import './assets/index.css';var NCe = Object.defineProperty;
var PCe = (i, e, t) => e in i ? NCe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var gn = (i, e, t) => PCe(i, typeof e != "symbol" ? e + "" : e, t);
import * as G from "react";
import it, { createElement as pr, useRef as Nt, useLayoutEffect as aA, useEffect as $e, useReducer as Ale, useState as Oe, isValidElement as e_, cloneElement as nd, forwardRef as tS, createContext as nf, useContext as x0, useMemo as Mn, Component as nS, Fragment as qh, useCallback as Wi, createRef as t1 } from "react";
import Ba, { components as zi } from "react-select";
import { Link as D0, useHistory as ip, NavLink as uo, useParams as eo, useLocation as E0, useRouteMatch as fd, generatePath as R2, Switch as OCe, Route as n1, Redirect as MCe } from "react-router-dom";
import Fm, { render as RCe, createPortal as kW } from "react-dom";
import hC from "yaml";
import lA from "dompurify";
import FCe from "react-draggable";
import BCe, { getDefaultRegistry as VCe } from "@rjsf/core";
import HCe from "@rjsf/validator-ajv8";
import { getUiOptions as kle, getTemplate as Tle, getSubmitButtonOptions as WCe, ADDITIONAL_PROPERTY_FLAG as Nle, errorId as jCe, titleId as zCe, canExpand as UCe, englishStringTranslator as GCe, TranslatableString as qCe } from "@rjsf/utils";
import { marked as r8 } from "marked";
import nK from "react-mde";
import cA from "react-ga4";
import { SliderButton as KCe } from "@typeform/embed-react";
import { BehaviorSubject as dA } from "rxjs";
const YCe = 6e4, CE = window?.__ORCHESTRATOR_ROOT__ ?? "/orchestrator", F2 = "https://docs.devtron.ai", _x = "/v/v0.7", TW = "https://discord.devtron.ai/", ey = {
  APP_TAGS: `${F2}${_x}/usage/applications/create-application#tags`,
  APP_OVERVIEW_TAGS: `${F2}${_x}/usage/applications/overview#manage-tags`,
  BLOB_STORAGE: `${F2}${_x}/getting-started/install/installation-configuration#configuration-of-blob-storage`,
  GLOBAL_CONFIG_BUILD_INFRA: `${F2}${_x}/global-configurations/build-infra`
}, yE = {
  KUBERNETES_KEY_PREFIX: /^[a-z0-9]([-a-z0-9]*[a-z0-9])?(\.[a-z0-9]([-a-z0-9]*[a-z0-9])?)*$/,
  KUBERNETES_KEY_NAME: /^(([A-Za-z0-9][-A-Za-z0-9_.]*)?[A-Za-z0-9])$/,
  START_END_ALPHANUMERIC: /^([Az09].*[A-Za-z0-9])$|[A-Za-z0-9]$/,
  ALPHANUMERIC_WITH_SPECIAL_CHAR: /^[A-Za-z0-9._-]+$/,
  // allow alphanumeric,(.) ,(-),(_)
  ESCAPED_CHARACTERS: /[.*+?^${}()|[\]\\]/g
}, sr = {
  LOGIN_SSO: "/login/sso",
  PERMISSION_GROUPS: "/global-config/auth/groups",
  APP: "/app",
  APP_LIST: "list",
  CHARTS_DISCOVER: "/chart-store/discover",
  JOB: "/job",
  CREATE_JOB: "create-job",
  GETTING_STARTED: "getting-started",
  STACK_MANAGER_ABOUT: "/stack-manager/about",
  APP_LIST_HELM: "h",
  APP_CI_DETAILS: "ci-details",
  LOGS: "Logs",
  CREATE: "/create",
  RELEASES: "/releases",
  DEVTRON_CHARTS: "dc",
  APP_DEPLOYMNENT_HISTORY: "deployments",
  APP_DETAILS: "details",
  APP_DETAILS_K8: "k8s-resources",
  // for V2
  DETAILS: "/details",
  CD_DETAILS: "cd-details",
  APP_TRIGGER: "trigger",
  GLOBAL_CONFIG_DOCKER: "/global-config/docker",
  DEPLOYMENT_HISTORY_CONFIGURATIONS: "/configuration",
  GLOBAL_CONFIG_SCOPED_VARIABLES: "/global-config/scoped-variables",
  GLOBAL_CONFIG_DEPLOYMENT_CHARTS_LIST: "/global-config/deployment-charts",
  NETWORK_STATUS_INTERFACE: "/network-status-interface"
}, hn = {
  APP: "app",
  APP_ARTIFACT_PROMOTE_MATERIAL: "app/artifact/promotion-request/material",
  PROJECT_LIST_MIN: "team/autocomplete",
  USER_CHECK_ROLE: "user/check/roles",
  IMAGE_TAGGING: "app/image-tagging",
  CI_CONFIG_GET: "app/ci-pipeline",
  CD_MATERIAL_GET: "app/cd-pipeline",
  DEPLOYMENT_TEMPLATE_LIST: "app/template/list",
  INFRA_CONFIG_PROFILE: "infra-config/profile",
  SECURITY_SCAN_EXECUTION_DETAILS: "security/scan/executionDetail",
  NOTIFIER: "notification",
  APP_LIST: "app/list",
  TELEMETRY_EVENT: "telemetry/event",
  SERVER_INFO_API: "server",
  ATTRIBUTES_USER: "attributes/user",
  UPDATE: "update",
  ENVIRONMENT_LIST_MIN: "env/autocomplete",
  CLUSTER: "cluster",
  API_RESOURCE: "k8s/api-resources",
  GVK: "gvk",
  NAMESPACE: "env/namespace",
  CLUSTER_NOTE: "cluster/note",
  APPLICATION_NOTE: "app/note",
  GIT_HOST_EVENT: "git/host/event",
  HELM_DEPLOYMENT_STATUS_TIMELINE_INSTALLED_APP: "app-store/deployment-status/timeline",
  DEPLOYMENT_STATUS: "app/deployment-status/timeline",
  MANUAL_SYNC: "app/deployment-status/manual-sync",
  CD_CONFIG: "app/cd-pipeline",
  CONFIG_CD_PIPELINE: "config/cd-pipeline",
  MODULE_CONFIGURED: "module/config",
  RESOURCE_HISTORY_DEPLOYMENT: "resource/history/deployment",
  ATTRIBUTES: "attributes",
  ATTRIBUTES_CREATE: "attributes/create",
  ATTRIBUTES_UPDATE: "attributes/update",
  APP_LIST_MIN: "app/min",
  CLUSTER_LIST_MIN: "cluster/autocomplete",
  PLUGIN_GLOBAL_LIST_DETAIL_V2: "plugin/global/list/detail/v2",
  PLUGIN_GLOBAL_LIST_V2: "plugin/global/list/v2",
  PLUGIN_GLOBAL_LIST_TAGS: "plugin/global/list/tags",
  PLUGIN_LIST_MIN: "plugin/global/list/v2/min",
  DEPLOYMENT_CHARTS_LIST: "deployment/template/fetch",
  USER_LIST_MIN: "user/list/min",
  CONFIG_DATA: "config/data"
};
var ah = /* @__PURE__ */ ((i) => (i.KEY = "key", i.VALUE = "value", i))(ah || {});
const XCe = {
  key: "",
  value: "",
  propagate: !1,
  isInvalidKey: !1,
  isInvalidValue: !1,
  isSuggested: !0
};
var ms = /* @__PURE__ */ ((i) => (i[i.BAD_REQUEST = 400] = "BAD_REQUEST", i[i.UNAUTHORIZED = 401] = "UNAUTHORIZED", i[i.PERMISSION_DENIED = 403] = "PERMISSION_DENIED", i[i.NOT_FOUND = 404] = "NOT_FOUND", i[i.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", i[i.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", i[i.BAD_GATEWAY = 502] = "BAD_GATEWAY", i[i.SERVICE_TEMPORARY_UNAVAILABLE = 503] = "SERVICE_TEMPORARY_UNAVAILABLE", i))(ms || {});
const iK = {
  TITLE: "Access denied",
  SUBTITLE: "You do not have required access to perform this action"
}, Jr = {
  PAGE_NOT_FOUND: "Not found",
  PAGE_NOT_EXIST: "Error 404: The requested resource could not be found. Please check the URL and try again.",
  TAKE_BACK_HOME: "Go back home",
  REPORT_ISSUE: "Report issue",
  ONLY_FOR_SUPERADMIN: "Information on this page is available only to superadmin users.",
  NOT_AUTHORIZED: "Not authorized",
  REQUIRED_MANAGER_ACCESS: "Looks like you don’t have access to information on this page. Please contact your manager to request access.",
  BAD_REQUEST: "Bad request",
  BAD_REQUEST_MESSAGE: "Error 400: The request could not be understood by the server due to malformed syntax. Please check your request and try again.",
  TRY_AGAIN: "Try again",
  UNAUTHORIZED: "Unauthorized",
  UNAUTHORIZED_MESSAGE: "Error 401: You are not authorized to access this resource. Please contact your administrator for assistance.",
  FORBIDDEN: "Forbidden",
  FORBIDDEN_MESSAGE: "Error 403: You are not authorized to access this resource. Please contact your administrator for assistance.",
  INTERNAL_SERVER_ERROR: "Internal server error",
  INTERNAL_SERVER_ERROR_MESSAGE: "Error 500: The server encountered an unexpected condition that prevented it from fulfilling the request. Please try again later.",
  BAD_GATEWAY: "Bad gateway",
  BAD_GATEWAY_MESSAGE: "Error 500: The server received an invalid response from an upstream server. Please try again later.",
  SERVICE_TEMPORARY_UNAVAILABLE: "Service temporary unavailable",
  SERVICE_TEMPORARY_UNAVAILABLE_MESSAGE: "Error 503: The server is currently unable to handle the request due to a temporary overload or maintenance. Please try again later."
}, T_t = "argocd.token", N_t = {
  automatic: "Auto",
  manual: "Manual"
}, P_t = {
  PreBuild: "preBuildStage",
  Build: "buildStage",
  PostBuild: "postBuildStage"
}, O_t = {
  ecr: {
    value: "ecr",
    label: "ECR",
    desiredFormat: "(desired format: repo-name)",
    placeholderText: "Eg. repo_name",
    gettingStartedLink: "https://docs.aws.amazon.com/AmazonECR/latest/userguide/get-set-up-for-amazon-ecr.html",
    defaultRegistryURL: "",
    registryURL: {
      label: "Registry URL",
      defaultValue: "",
      placeholder: "Eg. xxxxxxxxxxxx.dkr.ecr.region.amazonaws.com"
    },
    id: {
      label: "Access key ID",
      defaultValue: "",
      placeholder: ""
    },
    password: {
      label: "Secret access key",
      defaultValue: "",
      placeholder: ""
    }
  },
  "docker-hub": {
    value: "docker-hub",
    label: "Docker",
    desiredFormat: "(desired format: username/repo-name)",
    placeholderText: "Eg. username/repo_name",
    gettingStartedLink: "https://docs.docker.com/docker-hub/",
    defaultRegistryURL: "docker.io",
    registryURL: {
      label: "Registry URL",
      defaultValue: "",
      placeholder: ""
    },
    id: {
      label: "Username",
      defaultValue: "",
      placeholder: ""
    },
    password: {
      label: "Password/Token (Recommended: Token)",
      defaultValue: "",
      placeholder: ""
    }
  },
  acr: {
    value: "acr",
    label: "Azure",
    desiredFormat: "(desired format: repo-name)",
    placeholderText: "Eg. repo_name",
    gettingStartedLink: "https://docs.microsoft.com/en-us/azure/container-registry/container-registry-get-started-portal",
    defaultRegistryURL: "",
    registryURL: {
      label: "Registry URL/Login Server",
      defaultValue: "",
      placeholder: "Eg. xxx.azurecr.io"
    },
    id: {
      label: "Username/Registry Name",
      defaultValue: "",
      placeholder: ""
    },
    password: {
      label: "Password",
      defaultValue: "",
      placeholder: ""
    }
  },
  "artifact-registry": {
    value: "artifact-registry",
    label: "Artifact Registry (GCP)",
    desiredFormat: "(desired format: project-id/artifacts-repo/repo-name)",
    placeholderText: "Eg. project-id/artifacts-repo/repo-name",
    gettingStartedLink: "https://cloud.google.com/artifact-registry/docs/manage-repos?hl=en_US",
    defaultRegistryURL: "",
    registryURL: {
      label: "Registry URL",
      defaultValue: "",
      placeholder: "Eg. region-docker.pkg.dev"
    },
    id: {
      label: "Username",
      defaultValue: "_json_key",
      placeholder: ""
    },
    password: {
      label: "Service Account JSON File",
      defaultValue: "",
      placeholder: "Paste json file content here"
    }
  },
  gcr: {
    value: "gcr",
    label: "GCR",
    desiredFormat: "(desired format: project-id/repo-name)",
    placeholderText: "Eg. project-id/repo_name",
    gettingStartedLink: "https://cloud.google.com/container-registry/docs/quickstart",
    defaultRegistryURL: "gcr.io",
    registryURL: {
      label: "Registry URL",
      defaultValue: "gcr.io",
      placeholder: ""
    },
    id: {
      label: "Username",
      defaultValue: "_json_key",
      placeholder: ""
    },
    password: {
      label: "Service Account JSON File",
      defaultValue: "",
      placeholder: "Paste json file content here"
    }
  },
  quay: {
    value: "quay",
    label: "Quay",
    desiredFormat: "(desired format: username/repo-name)",
    placeholderText: "Eg. username/repo_name",
    gettingStartedLink: "",
    defaultRegistryURL: "quay.io",
    registryURL: {
      label: "Registry URL",
      defaultValue: "",
      placeholder: ""
    },
    id: {
      label: "Username",
      defaultValue: "",
      placeholder: ""
    },
    password: {
      label: "Token",
      defaultValue: "",
      placeholder: ""
    }
  },
  other: {
    value: "other",
    label: "Other",
    desiredFormat: "",
    placeholderText: "",
    gettingStartedLink: "",
    defaultRegistryURL: "",
    registryURL: {
      label: "Registry URL",
      defaultValue: "",
      placeholder: ""
    },
    id: {
      label: "Username",
      defaultValue: "",
      placeholder: ""
    },
    password: {
      label: "Password/Token",
      defaultValue: "",
      placeholder: ""
    }
  }
}, M_t = {
  CONTAINER: "CONTAINER",
  CHART_PULL: "CHART_PULL",
  CHART_PUSH: "CHART_PUSH"
};
var Bm = /* @__PURE__ */ ((i) => (i.YAML = "yaml", i.JSON = "json", i.SHELL = "shell", i.DOCKERFILE = "dockerfile", i.PLAINTEXT = "plaintext", i))(Bm || {}), ZCe = /* @__PURE__ */ ((i) => (i.CONFIG = "CONFIG", i.DEPLOYMENT = "DEPLOYMENT", i.IMAGE_PROMOTION = "IMAGE-PROMOTION", i))(ZCe || {});
const QCe = 2147483647, R_t = {
  APPROVAL: "approval",
  PENDING: "pending"
};
var Xi = /* @__PURE__ */ ((i) => (i.ASC = "ASC", i.DESC = "DESC", i))(Xi || {});
const s8 = 20;
var JCe = /* @__PURE__ */ ((i) => (i.HIBERNATE = "HIBERNATE", i.UNHIBERNATE = "UNHIBERNATE", i.RESTORE = "RESTORE", i.DEPLOY = "DEPLOY", i.RESOURCE = "RESOURCE", i.RESTART = "RESTART", i.PIPELINE = "PIPELINE", i.OVERVIEW = "OVERVIEW", i.APP_DETAILS_STATUS = "APP_DETAILS_STATUS", i))(JCe || {}), $Ce = /* @__PURE__ */ ((i) => (i.ALLOWED = "ALLOWED", i.PARTIAL = "PARTIAL", i.BLOCKED = "BLOCKED", i))($Ce || {}), eye = /* @__PURE__ */ ((i) => (i.MAINTENANCE = "MAINTENANCE", i.BLACKOUT = "BLACKOUT", i))(eye || {});
const F_t = "➝";
var tye = /* @__PURE__ */ ((i) => (i.SUNDAY = "SUNDAY", i.MONDAY = "MONDAY", i.TUESDAY = "TUESDAY", i.WEDNESDAY = "WEDNESDAY", i.THURSDAY = "THURSDAY", i.FRIDAY = "FRIDAY", i.SATURDAY = "SATURDAY", i))(tye || {}), nye = /* @__PURE__ */ ((i) => (i.FIXED = "FIXED", i.DAILY = "DAILY", i.WEEKLY = "WEEKLY", i.MONTHLY = "MONTHLY", i.YEARLY = "YEARLY", i.WEEKLY_RANGE = "WEEKLY_RANGE", i))(nye || {});
function B_t(i) {
  if (i % 100 >= 11 && i % 100 <= 13)
    return `${i}th`;
  switch (i % 10) {
    case 1:
      return `${i}st`;
    case 2:
      return `${i}nd`;
    case 3:
      return `${i}rd`;
    default:
      return `${i}th`;
  }
}
const bx = {
  AM: "AM",
  PM: "PM",
  MIDNIGHT: "midnight",
  NOON: "noon"
}, V_t = (i) => {
  const [e, t] = i.split(":"), n = parseInt(e, 10), r = parseInt(t, 10);
  return n === 12 && r === 0 ? bx.NOON : n === 0 && r === 0 ? bx.MIDNIGHT : n >= 12 ? bx.PM : bx.AM;
};
var o8 = /* @__PURE__ */ ((i) => (i.inputChange = "input-change", i.selectOption = "select-option", i.deselectOption = "deselect-option", i.removeValue = "remove-value", i))(o8 || {});
const iS = "0001-01-01T00:00:00Z", Ple = [void 0, null, "", NaN], rK = {
  OK: 200,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PERMISSION_DENIED: 403,
  NOT_FOUND: 404,
  EXPECTATION_FAILED: 417
};
var a8 = /* @__PURE__ */ ((i) => (i.EA_ONLY = "EA_ONLY", i.FULL = "FULL", i))(a8 || {});
const l8 = {
  PREVIEW: "Preview",
  DEPLOY_CUSTOM_APP_CI_CD: "Deploy custom app using CI/CD pipelines",
  INSTALL_CUSTOM_CI_CD: "Install CI/CD",
  VIEW_APPLICATION: "View helm application",
  BROWSE_HELM_CHART: "Browse helm chart",
  CONNECT_CLUSTER: "Connect cluster",
  CONNECT_CHART_REPOSITORY: "Connect chart repository",
  TOOLTIP_OKAY: "Tooltip okay",
  TOOLTIP_DONT_SHOW_AGAIN: "Tooltip Dont show again",
  HELP: "Clicked Help",
  SKIP_AND_EXPLORE_DEVTRON: "SkippedOnboarding"
}, Ole = 5, Mle = "login-count", H_t = "devtron-ci", id = {
  TWELVE_HOURS_FORMAT: "ddd, DD MMM YYYY, hh:mm A",
  TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY: "DD MMM YYYY, hh:mm A",
  TWELVE_HOURS_EXPORT_FORMAT: "DD-MMM-YYYY hh.mm A",
  DD_MMM_YYYY_HH_MM: "DD MMM YYYY, hh:mm",
  DD_MMM_YYYY: "DD MMM YYYY"
}, W_t = "https://semver.org/", wE = {
  critical: 1,
  high: 2,
  medium: 3,
  low: 4,
  unknown: 5
};
class iye {
  constructor(e) {
    gn(this, "code");
    gn(this, "internalMessage");
    gn(this, "userMessage");
    gn(this, "moreInfo");
    this.code = e.code || 0, this.userMessage = e.userMessage || "", this.internalMessage = e.internalMessage || "", this.moreInfo = e.moreInfo || "";
  }
}
class Kc extends Error {
  constructor(t) {
    super();
    gn(this, "code");
    gn(this, "errors");
    this.code = t.code;
    const n = t.errors.reduce((r, s) => (r += `${s.internalMessage || s.userMessage}`, r), "");
    this.name = `[${t.code.toString()}]`, this.message = n, this.errors = t.errors.map((r) => new iye(r)), Object.setPrototypeOf(this, Kc.prototype);
  }
}
var uA = /* @__PURE__ */ ((i) => (i.black = "black", i.white = "white", i))(uA || {}), Aa = /* @__PURE__ */ ((i) => (i.CHECKED = "CHECKED", i.INTERMEDIATE = "INTERMEDIATE", i.BULK_CHECKED = "BULK_CHECKED", i))(Aa || {}), Vl = /* @__PURE__ */ ((i) => (i.Large = "large", i.Medium = "medium", i.SMALL = "small", i))(Vl || {});
const B2 = {
  Security: "SECURITY",
  Changes: "CHANGES"
};
var c8 = /* @__PURE__ */ ((i) => (i.PRECD = "PRECD", i.CD = "CD", i.POSTCD = "POSTCD", i.APPROVAL = "APPROVAL", i))(c8 || {}), hA = /* @__PURE__ */ ((i) => (i.specific = "SPECIFIC", i.any = "ANY", i.notConfigured = "NOT_CONFIGURED", i))(hA || {}), fC = /* @__PURE__ */ ((i) => (i[i.ALLOWED = 0] = "ALLOWED", i[i.BLOCKED = 1] = "BLOCKED", i[i.ERROR = 2] = "ERROR", i))(fC || {}), rye = /* @__PURE__ */ ((i) => (i.EXTERNAL = "ext", i))(rye || {}), sye = /* @__PURE__ */ ((i) => (i.AWAITING = "AWAITING", i.PROMOTED = "PROMOTED", i.CANCELLED = "CANCELLED", i.STALE = "STALE", i))(sye || {}), d8 = /* @__PURE__ */ ((i) => (i.ROLLBACK = "rollback", i.CD_MATERIALS = "cd-materials", i.IMAGE_PROMOTION = "image-promotion", i))(d8 || {}), oye = /* @__PURE__ */ ((i) => (i.PENDING_APPROVAL = "PENDING_APPROVAL", i.PROMOTION_APPROVAL_PENDING_NODE = "PROMOTION_APPROVAL_PENDING_NODE", i.CI = "CI", i.ENVIRONMENT = "ENVIRONMENT", i.WEBHOOK = "WEBHOOK", i.LINKED_CI = "LINKED-CI", i.CI_JOB = "CI-JOB", i.LINKED_CD = "LINKED-CD", i))(oye || {}), Rle = /* @__PURE__ */ ((i) => (i.RESOURCE = "ELIGIBLE_RESOURCES", i.ALL = "ALL_RESOURCES", i))(Rle || {}), bv = /* @__PURE__ */ ((i) => (i.HELM = "helm", i.GITOPS = "argo_cd", i.MANIFEST_DOWNLOAD = "manifest_download", i.MANIFEST_PUSH = "manifest_push", i.FLUX = "flux", i))(bv || {}), aye = /* @__PURE__ */ ((i) => (i[i.PASS = 1] = "PASS", i[i.FAIL = 0] = "FAIL", i))(aye || {}), g3 = /* @__PURE__ */ ((i) => (i.CI_PIPELINE = "CI_PIPELINE", i.CD_PIPELINE = "CD_PIPELINE", i.WEBHOOK = "WEBHOOK", i.LINKED_CD = "LINKED_CD", i))(g3 || {}), u8 = /* @__PURE__ */ ((i) => (i.GIT = "GIT", i.CI = "CI", i.WEBHOOK = "WEBHOOK", i.PRE_CD = "PRECD", i.CD = "CD", i.POST_CD = "POSTCD", i))(u8 || {}), ty = /* @__PURE__ */ ((i) => (i.LEFT = "left", i.RIGHT = "right", i))(ty || {}), h8 = /* @__PURE__ */ ((i) => (i.SEQUENTIAL = "SEQUENTIAL", i.PARALLEL = "PARALLEL", i))(h8 || {});
const sK = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing(WebDAV)",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non - Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi - Status(WebDAV)",
  208: "Already Reported(WebDAV)",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  307: "Temporary Redirect",
  308: "Permanent Redirect(experimental)",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Request Entity Too Large",
  414: "Request - URI Too Long",
  415: "Unsupported Media Type",
  416: "Requested Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  420: "Enhance Your Calm(Twitter)",
  422: "Unprocessable Entity(WebDAV)",
  423: "Locked(WebDAV)",
  424: "Failed Dependency(WebDAV)",
  425: "Reserved for WebDAV",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  444: "No Response(Nginx)",
  449: "Retry With(Microsoft)",
  450: "Blocked by Windows Parental Controls(Microsoft)",
  451: "Unavailable For Legal Reasons",
  499: "Client Closed Request(Nginx)",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates(Experimental)",
  507: "Insufficient Storage(WebDAV)",
  508: "Loop Detected(WebDAV)",
  509: "Bandwidth Limit Exceeded(Apache)",
  510: "Not Extended",
  511: "Network Authentication Required",
  598: "Network read timeout error",
  599: "Network connect timeout error"
};
function lye() {
  const i = `${window.location.pathname.replace(window.__BASE_URL__, "")}${window.location.search}`;
  window.location.href = `${window.location.origin}${window.__BASE_URL__}${sr.LOGIN_SSO}?continue=${i}`;
}
async function cye(i, e) {
  const t = e.status;
  let n = e.statusText || sK[t];
  const r = new Kc({ code: t, errors: [] });
  if (i !== "application/json")
    n = `${sK[t]}. Please try again.`;
  else {
    const s = await e.json();
    s.errors && (r.errors = s.errors);
  }
  throw r.errors = r.errors.length > 0 ? r.errors : [{ code: t, internalMessage: n, userMessage: n }], r;
}
async function dye(i, e, t, n, r = !1, s) {
  const o = {
    method: e,
    signal: n,
    body: t ? JSON.stringify(t) : void 0
  };
  return o.credentials = "include", fetch(
    `${CE}/${i}`,
    s ? {
      method: e,
      body: t
    } : o
  ).then(
    async (a) => {
      const l = a.headers.get("Content-Type");
      if (a.status === 401) {
        if (r)
          throw new Kc({
            code: 401,
            errors: [
              { code: 401, internalMessage: "Please login again", userMessage: "Please login again" }
            ]
          });
        return lye(), { code: 401, status: "Unauthorized", result: [] };
      } else {
        if (a.status >= 300 && a.status <= 599)
          return await cye(l, a);
        if (l === "application/json")
          return a.json().then((c) => {
            if (c.code >= 300 && c.code <= 599)
              throw new Kc({ code: c.code, errors: c.errors });
            return c;
          });
        if (l === "octet-stream" || l === "application/octet-stream")
          return a;
      }
    },
    (a) => {
      const l = {
        code: 0,
        userMessage: a.message,
        internalMessage: a.message,
        moreInfo: a.message
      };
      throw new Kc({ code: 0, errors: [l] });
    }
  );
}
function rS(i, e, t, n, r) {
  const s = new AbortController(), { signal: o } = s, a = new Promise((l, c) => {
    const d = window?._env_?.GLOBAL_API_TIMEOUT || YCe, u = n?.timeout ? n.timeout : d;
    setTimeout(() => {
      s.abort(), c({
        code: 408,
        errors: [{ code: 408, internalMessage: "Request cancelled", userMessage: "Request Cancelled" }]
      });
    }, u);
  });
  return Promise.race([
    dye(i, e, t, n?.signal || o, n?.preventAutoLogout || !1, r),
    a
  ]).catch((l) => {
    throw l instanceof Kc ? l : new Kc({
      code: 408,
      errors: [
        {
          code: 408,
          internalMessage: "That took longer than expected.",
          userMessage: "That took longer than expected."
        }
      ]
    });
  });
}
const fA = (i, e, t, n) => rS(i, "POST", e, t, n), uye = (i, e, t) => rS(i, "PUT", e, t), j_t = (i, e, t) => rS(i, "PATCH", e, t), Qn = (i, e) => rS(i, "GET", null, e), Fle = (i, e, t) => rS(i, "DELETE", e, t), Ble = (i, e) => (e.current.abort(), e.current = new AbortController(), i()), SE = (i) => (
  // The 0 code is common for aborted and blocked requests
  i && i.code === 0 && i.message.search("abort|aborted")
);
var Zs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function eb(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
function L0(i) {
  if (i.__esModule) return i;
  var e = i.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(i).forEach(function(n) {
    var r = Object.getOwnPropertyDescriptor(i, n);
    Object.defineProperty(t, n, r.get ? r : {
      enumerable: !0,
      get: function() {
        return i[n];
      }
    });
  }), t;
}
var f8 = { exports: {} }, i1 = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Dk, oK;
function NW() {
  if (oK) return Dk;
  oK = 1;
  var i = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, a = 0; a < 10; a++)
        o["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Dk = r() ? Object.assign : function(s, o) {
    for (var a, l = n(s), c, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var u in a)
        e.call(a, u) && (l[u] = a[u]);
      if (i) {
        c = i(a);
        for (var h = 0; h < c.length; h++)
          t.call(a, c[h]) && (l[c[h]] = a[c[h]]);
      }
    }
    return l;
  }, Dk;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aK;
function hye() {
  if (aK) return i1;
  aK = 1, NW();
  var i = it, e = 60103;
  if (i1.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var t = Symbol.for;
    e = t("react.element"), i1.Fragment = t("react.fragment");
  }
  var n = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, r = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, l, c) {
    var d, u = {}, h = null, f = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (f = l.ref);
    for (d in l) r.call(l, d) && !s.hasOwnProperty(d) && (u[d] = l[d]);
    if (a && a.defaultProps) for (d in l = a.defaultProps, l) u[d] === void 0 && (u[d] = l[d]);
    return { $$typeof: e, type: a, key: h, ref: f, props: u, _owner: n.current };
  }
  return i1.jsx = o, i1.jsxs = o, i1;
}
var Ek = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lK;
function fye() {
  return lK || (lK = 1, function(i) {
    process.env.NODE_ENV !== "production" && function() {
      var e = it, t = NW(), n = 60103, r = 60106;
      i.Fragment = 60107;
      var s = 60108, o = 60114, a = 60109, l = 60110, c = 60112, d = 60113, u = 60120, h = 60115, f = 60116, g = 60121, p = 60122, m = 60117, _ = 60129, b = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var w = Symbol.for;
        n = w("react.element"), r = w("react.portal"), i.Fragment = w("react.fragment"), s = w("react.strict_mode"), o = w("react.profiler"), a = w("react.provider"), l = w("react.context"), c = w("react.forward_ref"), d = w("react.suspense"), u = w("react.suspense_list"), h = w("react.memo"), f = w("react.lazy"), g = w("react.block"), p = w("react.server.block"), m = w("react.fundamental"), w("react.scope"), w("react.opaque.id"), _ = w("react.debug_trace_mode"), w("react.offscreen"), b = w("react.legacy_hidden");
      }
      var y = typeof Symbol == "function" && Symbol.iterator, S = "@@iterator";
      function x(Ce) {
        if (Ce === null || typeof Ce != "object")
          return null;
        var Xe = y && Ce[y] || Ce[S];
        return typeof Xe == "function" ? Xe : null;
      }
      var D = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function E(Ce) {
        {
          for (var Xe = arguments.length, nt = new Array(Xe > 1 ? Xe - 1 : 0), At = 1; At < Xe; At++)
            nt[At - 1] = arguments[At];
          L("error", Ce, nt);
        }
      }
      function L(Ce, Xe, nt) {
        {
          var At = D.ReactDebugCurrentFrame, tn = At.getStackAddendum();
          tn !== "" && (Xe += "%s", nt = nt.concat([tn]));
          var qt = nt.map(function(Kt) {
            return "" + Kt;
          });
          qt.unshift("Warning: " + Xe), Function.prototype.apply.call(console[Ce], console, qt);
        }
      }
      var k = !1;
      function N(Ce) {
        return !!(typeof Ce == "string" || typeof Ce == "function" || Ce === i.Fragment || Ce === o || Ce === _ || Ce === s || Ce === d || Ce === u || Ce === b || k || typeof Ce == "object" && Ce !== null && (Ce.$$typeof === f || Ce.$$typeof === h || Ce.$$typeof === a || Ce.$$typeof === l || Ce.$$typeof === c || Ce.$$typeof === m || Ce.$$typeof === g || Ce[0] === p));
      }
      function I(Ce, Xe, nt) {
        var At = Xe.displayName || Xe.name || "";
        return Ce.displayName || (At !== "" ? nt + "(" + At + ")" : nt);
      }
      function A(Ce) {
        return Ce.displayName || "Context";
      }
      function P(Ce) {
        if (Ce == null)
          return null;
        if (typeof Ce.tag == "number" && E("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof Ce == "function")
          return Ce.displayName || Ce.name || null;
        if (typeof Ce == "string")
          return Ce;
        switch (Ce) {
          case i.Fragment:
            return "Fragment";
          case r:
            return "Portal";
          case o:
            return "Profiler";
          case s:
            return "StrictMode";
          case d:
            return "Suspense";
          case u:
            return "SuspenseList";
        }
        if (typeof Ce == "object")
          switch (Ce.$$typeof) {
            case l:
              var Xe = Ce;
              return A(Xe) + ".Consumer";
            case a:
              var nt = Ce;
              return A(nt._context) + ".Provider";
            case c:
              return I(Ce, Ce.render, "ForwardRef");
            case h:
              return P(Ce.type);
            case g:
              return P(Ce._render);
            case f: {
              var At = Ce, tn = At._payload, qt = At._init;
              try {
                return P(qt(tn));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var O = 0, K, W, F, q, R, T, z;
      function X() {
      }
      X.__reactDisabledLog = !0;
      function ae() {
        {
          if (O === 0) {
            K = console.log, W = console.info, F = console.warn, q = console.error, R = console.group, T = console.groupCollapsed, z = console.groupEnd;
            var Ce = {
              configurable: !0,
              enumerable: !0,
              value: X,
              writable: !0
            };
            Object.defineProperties(console, {
              info: Ce,
              log: Ce,
              warn: Ce,
              error: Ce,
              group: Ce,
              groupCollapsed: Ce,
              groupEnd: Ce
            });
          }
          O++;
        }
      }
      function ue() {
        {
          if (O--, O === 0) {
            var Ce = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: t({}, Ce, {
                value: K
              }),
              info: t({}, Ce, {
                value: W
              }),
              warn: t({}, Ce, {
                value: F
              }),
              error: t({}, Ce, {
                value: q
              }),
              group: t({}, Ce, {
                value: R
              }),
              groupCollapsed: t({}, Ce, {
                value: T
              }),
              groupEnd: t({}, Ce, {
                value: z
              })
            });
          }
          O < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var se = D.ReactCurrentDispatcher, le;
      function oe(Ce, Xe, nt) {
        {
          if (le === void 0)
            try {
              throw Error();
            } catch (tn) {
              var At = tn.stack.trim().match(/\n( *(at )?)/);
              le = At && At[1] || "";
            }
          return `
` + le + Ce;
        }
      }
      var re = !1, B;
      {
        var ee = typeof WeakMap == "function" ? WeakMap : Map;
        B = new ee();
      }
      function j(Ce, Xe) {
        if (!Ce || re)
          return "";
        {
          var nt = B.get(Ce);
          if (nt !== void 0)
            return nt;
        }
        var At;
        re = !0;
        var tn = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var qt;
        qt = se.current, se.current = null, ae();
        try {
          if (Xe) {
            var Kt = function() {
              throw Error();
            };
            if (Object.defineProperty(Kt.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Kt, []);
              } catch (ct) {
                At = ct;
              }
              Reflect.construct(Ce, [], Kt);
            } else {
              try {
                Kt.call();
              } catch (ct) {
                At = ct;
              }
              Ce.call(Kt.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (ct) {
              At = ct;
            }
            Ce();
          }
        } catch (ct) {
          if (ct && At && typeof ct.stack == "string") {
            for (var Pt = ct.stack.split(`
`), _i = At.stack.split(`
`), vn = Pt.length - 1, $n = _i.length - 1; vn >= 1 && $n >= 0 && Pt[vn] !== _i[$n]; )
              $n--;
            for (; vn >= 1 && $n >= 0; vn--, $n--)
              if (Pt[vn] !== _i[$n]) {
                if (vn !== 1 || $n !== 1)
                  do
                    if (vn--, $n--, $n < 0 || Pt[vn] !== _i[$n]) {
                      var mt = `
` + Pt[vn].replace(" at new ", " at ");
                      return typeof Ce == "function" && B.set(Ce, mt), mt;
                    }
                  while (vn >= 1 && $n >= 0);
                break;
              }
          }
        } finally {
          re = !1, se.current = qt, ue(), Error.prepareStackTrace = tn;
        }
        var De = Ce ? Ce.displayName || Ce.name : "", Qe = De ? oe(De) : "";
        return typeof Ce == "function" && B.set(Ce, Qe), Qe;
      }
      function he(Ce, Xe, nt) {
        return j(Ce, !1);
      }
      function Se(Ce) {
        var Xe = Ce.prototype;
        return !!(Xe && Xe.isReactComponent);
      }
      function ge(Ce, Xe, nt) {
        if (Ce == null)
          return "";
        if (typeof Ce == "function")
          return j(Ce, Se(Ce));
        if (typeof Ce == "string")
          return oe(Ce);
        switch (Ce) {
          case d:
            return oe("Suspense");
          case u:
            return oe("SuspenseList");
        }
        if (typeof Ce == "object")
          switch (Ce.$$typeof) {
            case c:
              return he(Ce.render);
            case h:
              return ge(Ce.type, Xe, nt);
            case g:
              return he(Ce._render);
            case f: {
              var At = Ce, tn = At._payload, qt = At._init;
              try {
                return ge(qt(tn), Xe, nt);
              } catch {
              }
            }
          }
        return "";
      }
      var te = {}, be = D.ReactDebugCurrentFrame;
      function Ae(Ce) {
        if (Ce) {
          var Xe = Ce._owner, nt = ge(Ce.type, Ce._source, Xe ? Xe.type : null);
          be.setExtraStackFrame(nt);
        } else
          be.setExtraStackFrame(null);
      }
      function He(Ce, Xe, nt, At, tn) {
        {
          var qt = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Kt in Ce)
            if (qt(Ce, Kt)) {
              var Pt = void 0;
              try {
                if (typeof Ce[Kt] != "function") {
                  var _i = Error((At || "React class") + ": " + nt + " type `" + Kt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ce[Kt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw _i.name = "Invariant Violation", _i;
                }
                Pt = Ce[Kt](Xe, Kt, At, nt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (vn) {
                Pt = vn;
              }
              Pt && !(Pt instanceof Error) && (Ae(tn), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", At || "React class", nt, Kt, typeof Pt), Ae(null)), Pt instanceof Error && !(Pt.message in te) && (te[Pt.message] = !0, Ae(tn), E("Failed %s type: %s", nt, Pt.message), Ae(null));
            }
        }
      }
      var de = D.ReactCurrentOwner, ce = Object.prototype.hasOwnProperty, ie = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, H, Y, Z;
      Z = {};
      function Q(Ce) {
        if (ce.call(Ce, "ref")) {
          var Xe = Object.getOwnPropertyDescriptor(Ce, "ref").get;
          if (Xe && Xe.isReactWarning)
            return !1;
        }
        return Ce.ref !== void 0;
      }
      function me(Ce) {
        if (ce.call(Ce, "key")) {
          var Xe = Object.getOwnPropertyDescriptor(Ce, "key").get;
          if (Xe && Xe.isReactWarning)
            return !1;
        }
        return Ce.key !== void 0;
      }
      function Le(Ce, Xe) {
        if (typeof Ce.ref == "string" && de.current && Xe && de.current.stateNode !== Xe) {
          var nt = P(de.current.type);
          Z[nt] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', P(de.current.type), Ce.ref), Z[nt] = !0);
        }
      }
      function xe(Ce, Xe) {
        {
          var nt = function() {
            H || (H = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Xe));
          };
          nt.isReactWarning = !0, Object.defineProperty(Ce, "key", {
            get: nt,
            configurable: !0
          });
        }
      }
      function Ue(Ce, Xe) {
        {
          var nt = function() {
            Y || (Y = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Xe));
          };
          nt.isReactWarning = !0, Object.defineProperty(Ce, "ref", {
            get: nt,
            configurable: !0
          });
        }
      }
      var je = function(Ce, Xe, nt, At, tn, qt, Kt) {
        var Pt = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: Ce,
          key: Xe,
          ref: nt,
          props: Kt,
          // Record the component responsible for creating this element.
          _owner: qt
        };
        return Pt._store = {}, Object.defineProperty(Pt._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Pt, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: At
        }), Object.defineProperty(Pt, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: tn
        }), Object.freeze && (Object.freeze(Pt.props), Object.freeze(Pt)), Pt;
      };
      function Ze(Ce, Xe, nt, At, tn) {
        {
          var qt, Kt = {}, Pt = null, _i = null;
          nt !== void 0 && (Pt = "" + nt), me(Xe) && (Pt = "" + Xe.key), Q(Xe) && (_i = Xe.ref, Le(Xe, tn));
          for (qt in Xe)
            ce.call(Xe, qt) && !ie.hasOwnProperty(qt) && (Kt[qt] = Xe[qt]);
          if (Ce && Ce.defaultProps) {
            var vn = Ce.defaultProps;
            for (qt in vn)
              Kt[qt] === void 0 && (Kt[qt] = vn[qt]);
          }
          if (Pt || _i) {
            var $n = typeof Ce == "function" ? Ce.displayName || Ce.name || "Unknown" : Ce;
            Pt && xe(Kt, $n), _i && Ue(Kt, $n);
          }
          return je(Ce, Pt, _i, tn, At, de.current, Kt);
        }
      }
      var _e = D.ReactCurrentOwner, U = D.ReactDebugCurrentFrame;
      function fe(Ce) {
        if (Ce) {
          var Xe = Ce._owner, nt = ge(Ce.type, Ce._source, Xe ? Xe.type : null);
          U.setExtraStackFrame(nt);
        } else
          U.setExtraStackFrame(null);
      }
      var Ee;
      Ee = !1;
      function Me(Ce) {
        return typeof Ce == "object" && Ce !== null && Ce.$$typeof === n;
      }
      function Pe() {
        {
          if (_e.current) {
            var Ce = P(_e.current.type);
            if (Ce)
              return `

Check the render method of \`` + Ce + "`.";
          }
          return "";
        }
      }
      function et(Ce) {
        return "";
      }
      var gt = {};
      function Vt(Ce) {
        {
          var Xe = Pe();
          if (!Xe) {
            var nt = typeof Ce == "string" ? Ce : Ce.displayName || Ce.name;
            nt && (Xe = `

Check the top-level render call using <` + nt + ">.");
          }
          return Xe;
        }
      }
      function Zt(Ce, Xe) {
        {
          if (!Ce._store || Ce._store.validated || Ce.key != null)
            return;
          Ce._store.validated = !0;
          var nt = Vt(Xe);
          if (gt[nt])
            return;
          gt[nt] = !0;
          var At = "";
          Ce && Ce._owner && Ce._owner !== _e.current && (At = " It was passed a child from " + P(Ce._owner.type) + "."), fe(Ce), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', nt, At), fe(null);
        }
      }
      function St(Ce, Xe) {
        {
          if (typeof Ce != "object")
            return;
          if (Array.isArray(Ce))
            for (var nt = 0; nt < Ce.length; nt++) {
              var At = Ce[nt];
              Me(At) && Zt(At, Xe);
            }
          else if (Me(Ce))
            Ce._store && (Ce._store.validated = !0);
          else if (Ce) {
            var tn = x(Ce);
            if (typeof tn == "function" && tn !== Ce.entries)
              for (var qt = tn.call(Ce), Kt; !(Kt = qt.next()).done; )
                Me(Kt.value) && Zt(Kt.value, Xe);
          }
        }
      }
      function Ht(Ce) {
        {
          var Xe = Ce.type;
          if (Xe == null || typeof Xe == "string")
            return;
          var nt;
          if (typeof Xe == "function")
            nt = Xe.propTypes;
          else if (typeof Xe == "object" && (Xe.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          Xe.$$typeof === h))
            nt = Xe.propTypes;
          else
            return;
          if (nt) {
            var At = P(Xe);
            He(nt, Ce.props, "prop", At, Ce);
          } else if (Xe.PropTypes !== void 0 && !Ee) {
            Ee = !0;
            var tn = P(Xe);
            E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", tn || "Unknown");
          }
          typeof Xe.getDefaultProps == "function" && !Xe.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(Ce) {
        {
          for (var Xe = Object.keys(Ce.props), nt = 0; nt < Xe.length; nt++) {
            var At = Xe[nt];
            if (At !== "children" && At !== "key") {
              fe(Ce), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", At), fe(null);
              break;
            }
          }
          Ce.ref !== null && (fe(Ce), E("Invalid attribute `ref` supplied to `React.Fragment`."), fe(null));
        }
      }
      function xn(Ce, Xe, nt, At, tn, qt) {
        {
          var Kt = N(Ce);
          if (!Kt) {
            var Pt = "";
            (Ce === void 0 || typeof Ce == "object" && Ce !== null && Object.keys(Ce).length === 0) && (Pt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var _i = et();
            _i ? Pt += _i : Pt += Pe();
            var vn;
            Ce === null ? vn = "null" : Array.isArray(Ce) ? vn = "array" : Ce !== void 0 && Ce.$$typeof === n ? (vn = "<" + (P(Ce.type) || "Unknown") + " />", Pt = " Did you accidentally export a JSX literal instead of a component?") : vn = typeof Ce, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", vn, Pt);
          }
          var $n = Ze(Ce, Xe, nt, tn, qt);
          if ($n == null)
            return $n;
          if (Kt) {
            var mt = Xe.children;
            if (mt !== void 0)
              if (At)
                if (Array.isArray(mt)) {
                  for (var De = 0; De < mt.length; De++)
                    St(mt[De], Ce);
                  Object.freeze && Object.freeze(mt);
                } else
                  E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                St(mt, Ce);
          }
          return Ce === i.Fragment ? fn($n) : Ht($n), $n;
        }
      }
      function rt(Ce, Xe, nt) {
        return xn(Ce, Xe, nt, !0);
      }
      function Ei(Ce, Xe, nt) {
        return xn(Ce, Xe, nt, !1);
      }
      var Nn = Ei, Gi = rt;
      i.jsx = Nn, i.jsxs = Gi;
    }();
  }(Ek)), Ek;
}
process.env.NODE_ENV === "production" ? f8.exports = hye() : f8.exports = fye();
var v = f8.exports;
function Vle(i) {
  var e, t, n = "";
  if (typeof i == "string" || typeof i == "number") n += i;
  else if (typeof i == "object") if (Array.isArray(i)) for (e = 0; e < i.length; e++) i[e] && (t = Vle(i[e])) && (n && (n += " "), n += t);
  else for (e in i) i[e] && (n && (n += " "), n += e);
  return n;
}
function zf() {
  for (var i, e, t = 0, n = ""; t < arguments.length; ) (i = arguments[t++]) && (e = Vle(i)) && (n && (n += " "), n += e);
  return n;
}
function al() {
  return al = Object.assign || function(i) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (i[n] = t[n]);
    }
    return i;
  }, al.apply(this, arguments);
}
function Hle(i, e) {
  if (i == null) return {};
  var t = {}, n = Object.keys(i), r, s;
  for (s = 0; s < n.length; s++)
    r = n[s], !(e.indexOf(r) >= 0) && (t[r] = i[r]);
  return t;
}
function gA(i) {
  return typeof i == "number" && !isNaN(i);
}
function zb(i) {
  return typeof i == "boolean";
}
function Vm(i) {
  return typeof i == "string";
}
function Po(i) {
  return typeof i == "function";
}
function p3(i) {
  return Vm(i) || Po(i) ? i : null;
}
function Lk(i) {
  return i === 0 || i;
}
function gye(i, e) {
  return i === !1 || gA(i) && i > 0 ? i : e;
}
var Wle = !!(typeof window < "u" && window.document && window.document.createElement);
function Ik(i) {
  return e_(i) || Vm(i) || Po(i) || gA(i);
}
var jle = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
}, rf = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
};
function pye(i, e, t) {
  t === void 0 && (t = 300);
  var n = i.scrollHeight, r = i.style;
  requestAnimationFrame(function() {
    r.minHeight = "initial", r.height = n + "px", r.transition = "all " + t + "ms", requestAnimationFrame(function() {
      r.height = "0", r.padding = "0", r.margin = "0", setTimeout(e, t);
    });
  });
}
function mye(i) {
  var e = i.enter, t = i.exit, n = i.appendPosition, r = n === void 0 ? !1 : n, s = i.collapse, o = s === void 0 ? !0 : s, a = i.collapseDuration, l = a === void 0 ? 300 : a;
  return function(d) {
    var u = d.children, h = d.position, f = d.preventExitTransition, g = d.done, p = d.nodeRef, m = d.isIn, _ = r ? e + "--" + h : e, b = r ? t + "--" + h : t, w = Nt(), y = Nt(
      0
      /* Enter */
    );
    aA(function() {
      S();
    }, []), $e(function() {
      m || (f ? E() : D());
    }, [m]);
    function S() {
      var L = p.current;
      w.current = L.className, L.className += " " + _, L.addEventListener("animationend", x), L.addEventListener("animationcancel", x);
    }
    function x(L) {
      if (L.target === p.current) {
        var k = p.current;
        k.dispatchEvent(new Event(
          "d"
          /* ENTRANCE_ANIMATION_END */
        )), k.removeEventListener("animationend", x), k.removeEventListener("animationcancel", x), y.current === 0 && (k.className = w.current);
      }
    }
    function D() {
      y.current = 1;
      var L = p.current;
      L.className += " " + b, L.addEventListener("animationend", E);
    }
    function E() {
      var L = p.current;
      L.removeEventListener("animationend", E), o ? pye(L, g, l) : g();
    }
    return it.createElement(it.Fragment, null, u);
  };
}
var Yc = {
  list: /* @__PURE__ */ new Map(),
  emitQueue: /* @__PURE__ */ new Map(),
  on: function(e, t) {
    return this.list.has(e) || this.list.set(e, []), this.list.get(e).push(t), this;
  },
  off: function(e, t) {
    if (t) {
      var n = this.list.get(e).filter(function(r) {
        return r !== t;
      });
      return this.list.set(e, n), this;
    }
    return this.list.delete(e), this;
  },
  cancelEmit: function(e) {
    var t = this.emitQueue.get(e);
    return t && (t.forEach(clearTimeout), this.emitQueue.delete(e)), this;
  },
  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function(e) {
    for (var t = this, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      r[s - 1] = arguments[s];
    this.list.has(e) && this.list.get(e).forEach(function(o) {
      var a = setTimeout(function() {
        o.apply(void 0, r);
      }, 0);
      t.emitQueue.has(e) || t.emitQueue.set(e, []), t.emitQueue.get(e).push(a);
    });
  }
}, vye = ["delay", "staleId"];
function _ye(i) {
  var e = Ale(function(_) {
    return _ + 1;
  }, 0), t = e[1], n = Oe([]), r = n[0], s = n[1], o = Nt(null), a = Nt(/* @__PURE__ */ new Map()).current, l = function(b) {
    return r.indexOf(b) !== -1;
  }, c = Nt({
    toastKey: 1,
    displayedToast: 0,
    count: 0,
    queue: [],
    props: i,
    containerId: null,
    isToastActive: l,
    getToast: function(b) {
      return a.get(b);
    }
  }).current;
  $e(function() {
    return c.containerId = i.containerId, Yc.cancelEmit(
      3
      /* WillUnmount */
    ).on(
      0,
      g
    ).on(
      1,
      function(_) {
        return o.current && u(_);
      }
    ).on(
      5,
      d
    ).emit(
      2,
      c
    ), function() {
      return Yc.emit(
        3,
        c
      );
    };
  }, []), $e(function() {
    c.isToastActive = l, c.displayedToast = r.length, Yc.emit(
      4,
      r.length,
      i.containerId
    );
  }, [r]), $e(function() {
    c.props = i;
  });
  function d(_) {
    var b = _.containerId, w = c.props.limit;
    w && (!b || c.containerId === b) && (c.count -= c.queue.length, c.queue = []);
  }
  function u(_) {
    s(function(b) {
      return Lk(_) ? b.filter(function(w) {
        return w !== _;
      }) : [];
    });
  }
  function h() {
    var _ = c.queue.shift(), b = _.toastContent, w = _.toastProps, y = _.staleId;
    p(b, w, y);
  }
  function f(_) {
    return !o.current || c.props.enableMultiContainer && _.containerId !== c.props.containerId || a.has(_.toastId) && _.updateId == null;
  }
  function g(_, b) {
    var w = b.delay, y = b.staleId, S = Hle(b, vye);
    if (!(!Ik(_) || f(S))) {
      var x = S.toastId, D = S.updateId, E = S.data, L = c.props, k = function() {
        return u(x);
      }, N = D == null;
      N && c.count++;
      var I = {
        toastId: x,
        updateId: D,
        isLoading: S.isLoading,
        theme: S.theme || L.theme,
        icon: S.icon != null ? S.icon : L.icon,
        isIn: !1,
        key: S.key || c.toastKey++,
        type: S.type,
        closeToast: k,
        closeButton: S.closeButton,
        rtl: L.rtl,
        position: S.position || L.position,
        transition: S.transition || L.transition,
        className: p3(S.className || L.toastClassName),
        bodyClassName: p3(S.bodyClassName || L.bodyClassName),
        style: S.style || L.toastStyle,
        bodyStyle: S.bodyStyle || L.bodyStyle,
        onClick: S.onClick || L.onClick,
        pauseOnHover: zb(S.pauseOnHover) ? S.pauseOnHover : L.pauseOnHover,
        pauseOnFocusLoss: zb(S.pauseOnFocusLoss) ? S.pauseOnFocusLoss : L.pauseOnFocusLoss,
        draggable: zb(S.draggable) ? S.draggable : L.draggable,
        draggablePercent: S.draggablePercent || L.draggablePercent,
        draggableDirection: S.draggableDirection || L.draggableDirection,
        closeOnClick: zb(S.closeOnClick) ? S.closeOnClick : L.closeOnClick,
        progressClassName: p3(S.progressClassName || L.progressClassName),
        progressStyle: S.progressStyle || L.progressStyle,
        autoClose: S.isLoading ? !1 : gye(S.autoClose, L.autoClose),
        hideProgressBar: zb(S.hideProgressBar) ? S.hideProgressBar : L.hideProgressBar,
        progress: S.progress,
        role: S.role || L.role,
        deleteToast: function() {
          a.delete(x);
          var O = c.queue.length;
          if (c.count = Lk(x) ? c.count - 1 : c.count - c.displayedToast, c.count < 0 && (c.count = 0), O > 0) {
            var K = Lk(x) ? 1 : c.props.limit;
            if (O === 1 || K === 1)
              c.displayedToast++, h();
            else {
              var W = K > O ? O : K;
              c.displayedToast = W;
              for (var F = 0; F < W; F++)
                h();
            }
          } else
            t();
        }
      };
      Po(S.onOpen) && (I.onOpen = S.onOpen), Po(S.onClose) && (I.onClose = S.onClose), I.closeButton = L.closeButton, S.closeButton === !1 || Ik(S.closeButton) ? I.closeButton = S.closeButton : S.closeButton === !0 && (I.closeButton = Ik(L.closeButton) ? L.closeButton : !0);
      var A = _;
      e_(_) && !Vm(_.type) ? A = nd(_, {
        closeToast: k,
        toastProps: I,
        data: E
      }) : Po(_) && (A = _({
        closeToast: k,
        toastProps: I,
        data: E
      })), L.limit && L.limit > 0 && c.count > L.limit && N ? c.queue.push({
        toastContent: A,
        toastProps: I,
        staleId: y
      }) : gA(w) && w > 0 ? setTimeout(function() {
        p(A, I, y);
      }, w) : p(A, I, y);
    }
  }
  function p(_, b, w) {
    var y = b.toastId;
    w && a.delete(w), a.set(y, {
      content: _,
      props: b
    }), s(function(S) {
      return [].concat(S, [y]).filter(function(x) {
        return x !== w;
      });
    });
  }
  function m(_) {
    var b = /* @__PURE__ */ new Map(), w = Array.from(a.values());
    return i.newestOnTop && w.reverse(), w.forEach(function(y) {
      var S = y.props.position;
      b.has(S) || b.set(S, []), b.get(S).push(y);
    }), Array.from(b, function(y) {
      return _(y[0], y[1]);
    });
  }
  return {
    getToastToRender: m,
    containerRef: o,
    isToastActive: l
  };
}
function cK(i) {
  return i.targetTouches && i.targetTouches.length >= 1 ? i.targetTouches[0].clientX : i.clientX;
}
function dK(i) {
  return i.targetTouches && i.targetTouches.length >= 1 ? i.targetTouches[0].clientY : i.clientY;
}
function bye(i) {
  var e = Oe(!1), t = e[0], n = e[1], r = Oe(!1), s = r[0], o = r[1], a = Nt(null), l = Nt({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: !0,
    canDrag: !1,
    boundingRect: null,
    didMove: !1
  }).current, c = Nt(i), d = i.autoClose, u = i.pauseOnHover, h = i.closeToast, f = i.onClick, g = i.closeOnClick;
  $e(function() {
    c.current = i;
  }), $e(function() {
    return a.current && a.current.addEventListener(
      "d",
      _,
      {
        once: !0
      }
    ), Po(i.onOpen) && i.onOpen(e_(i.children) && i.children.props), function() {
      var k = c.current;
      Po(k.onClose) && k.onClose(e_(k.children) && k.children.props);
    };
  }, []), $e(function() {
    return i.pauseOnFocusLoss && w(), function() {
      i.pauseOnFocusLoss && y();
    };
  }, [i.pauseOnFocusLoss]);
  function p(k) {
    if (i.draggable) {
      S();
      var N = a.current;
      l.canCloseOnClick = !0, l.canDrag = !0, l.boundingRect = N.getBoundingClientRect(), N.style.transition = "", l.x = cK(k.nativeEvent), l.y = dK(k.nativeEvent), i.draggableDirection === "x" ? (l.start = l.x, l.removalDistance = N.offsetWidth * (i.draggablePercent / 100)) : (l.start = l.y, l.removalDistance = N.offsetHeight * (i.draggablePercent === 80 ? i.draggablePercent * 1.5 : i.draggablePercent / 100));
    }
  }
  function m() {
    if (l.boundingRect) {
      var k = l.boundingRect, N = k.top, I = k.bottom, A = k.left, P = k.right;
      i.pauseOnHover && l.x >= A && l.x <= P && l.y >= N && l.y <= I ? b() : _();
    }
  }
  function _() {
    n(!0);
  }
  function b() {
    n(!1);
  }
  function w() {
    document.hasFocus() || b(), window.addEventListener("focus", _), window.addEventListener("blur", b);
  }
  function y() {
    window.removeEventListener("focus", _), window.removeEventListener("blur", b);
  }
  function S() {
    l.didMove = !1, document.addEventListener("mousemove", D), document.addEventListener("mouseup", E), document.addEventListener("touchmove", D), document.addEventListener("touchend", E);
  }
  function x() {
    document.removeEventListener("mousemove", D), document.removeEventListener("mouseup", E), document.removeEventListener("touchmove", D), document.removeEventListener("touchend", E);
  }
  function D(k) {
    var N = a.current;
    l.canDrag && N && (l.didMove = !0, t && b(), l.x = cK(k), l.y = dK(k), i.draggableDirection === "x" ? l.delta = l.x - l.start : l.delta = l.y - l.start, l.start !== l.x && (l.canCloseOnClick = !1), N.style.transform = "translate" + i.draggableDirection + "(" + l.delta + "px)", N.style.opacity = "" + (1 - Math.abs(l.delta / l.removalDistance)));
  }
  function E() {
    x();
    var k = a.current;
    if (l.canDrag && l.didMove && k) {
      if (l.canDrag = !1, Math.abs(l.delta) > l.removalDistance) {
        o(!0), i.closeToast();
        return;
      }
      k.style.transition = "transform 0.2s, opacity 0.2s", k.style.transform = "translate" + i.draggableDirection + "(0)", k.style.opacity = "1";
    }
  }
  var L = {
    onMouseDown: p,
    onTouchStart: p,
    onMouseUp: m,
    onTouchEnd: m
  };
  return d && u && (L.onMouseEnter = b, L.onMouseLeave = _), g && (L.onClick = function(k) {
    f && f(k), l.canCloseOnClick && h();
  }), {
    playToast: _,
    pauseToast: b,
    isRunning: t,
    preventExitTransition: s,
    toastRef: a,
    eventHandlers: L
  };
}
function zle(i) {
  var e = i.closeToast, t = i.theme, n = i.ariaLabel, r = n === void 0 ? "close" : n;
  return pr("button", {
    className: "Toastify__close-button Toastify__close-button--" + t,
    type: "button",
    onClick: function(o) {
      o.stopPropagation(), e(o);
    },
    "aria-label": r
  }, pr("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, pr("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}
function Ule(i) {
  var e, t, n = i.delay, r = i.isRunning, s = i.closeToast, o = i.type, a = i.hide, l = i.className, c = i.style, d = i.controlledProgress, u = i.progress, h = i.rtl, f = i.isIn, g = i.theme, p = al({}, c, {
    animationDuration: n + "ms",
    animationPlayState: r ? "running" : "paused",
    opacity: a ? 0 : 1
  });
  d && (p.transform = "scaleX(" + u + ")");
  var m = zf("Toastify__progress-bar", d ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--" + g, "Toastify__progress-bar--" + o, (e = {}, e["Toastify__progress-bar--rtl"] = h, e)), _ = Po(l) ? l({
    rtl: h,
    type: o,
    defaultClassName: m
  }) : zf(m, l), b = (t = {}, t[d && u >= 1 ? "onTransitionEnd" : "onAnimationEnd"] = d && u < 1 ? null : function() {
    f && s();
  }, t);
  return pr("div", Object.assign({
    role: "progressbar",
    "aria-hidden": a ? "true" : "false",
    "aria-label": "notification timer",
    className: _,
    style: p
  }, b));
}
Ule.defaultProps = {
  type: rf.DEFAULT,
  hide: !1
};
var Cye = ["theme", "type"], pA = function(e) {
  var t = e.theme, n = e.type, r = Hle(e, Cye);
  return pr("svg", Object.assign({
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: t === "colored" ? "currentColor" : "var(--toastify-icon-color-" + n + ")"
  }, r));
};
function yye(i) {
  return pr(pA, Object.assign({}, i), pr("path", {
    d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
  }));
}
function wye(i) {
  return pr(pA, Object.assign({}, i), pr("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
  }));
}
function Sye(i) {
  return pr(pA, Object.assign({}, i), pr("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }));
}
function xye(i) {
  return pr(pA, Object.assign({}, i), pr("path", {
    d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  }));
}
function Dye() {
  return pr("div", {
    className: "Toastify__spinner"
  });
}
var uK = {
  info: wye,
  warning: yye,
  success: Sye,
  error: xye,
  spinner: Dye
}, Eye = function(e) {
  var t, n, r = bye(e), s = r.isRunning, o = r.preventExitTransition, a = r.toastRef, l = r.eventHandlers, c = e.closeButton, d = e.children, u = e.autoClose, h = e.onClick, f = e.type, g = e.hideProgressBar, p = e.closeToast, m = e.transition, _ = e.position, b = e.className, w = e.style, y = e.bodyClassName, S = e.bodyStyle, x = e.progressClassName, D = e.progressStyle, E = e.updateId, L = e.role, k = e.progress, N = e.rtl, I = e.toastId, A = e.deleteToast, P = e.isIn, O = e.isLoading, K = e.icon, W = e.theme, F = zf("Toastify__toast", "Toastify__toast-theme--" + W, "Toastify__toast--" + f, (t = {}, t["Toastify__toast--rtl"] = N, t)), q = Po(b) ? b({
    rtl: N,
    position: _,
    type: f,
    defaultClassName: F
  }) : zf(F, b), R = !!k, T = uK[f], z = {
    theme: W,
    type: f
  }, X = T && T(z);
  K === !1 ? X = void 0 : Po(K) ? X = K(z) : e_(K) ? X = nd(K, z) : Vm(K) ? X = K : O && (X = uK.spinner());
  function ae(ue) {
    if (ue) {
      var se = {
        closeToast: p,
        type: f,
        theme: W
      };
      if (Po(ue)) return ue(se);
      if (e_(ue)) return nd(ue, se);
    }
  }
  return pr(m, {
    isIn: P,
    done: A,
    position: _,
    preventExitTransition: o,
    nodeRef: a
  }, pr("div", Object.assign({
    id: I,
    onClick: h,
    className: q
  }, l, {
    style: w,
    ref: a
  }), pr("div", Object.assign({}, P && {
    role: L
  }, {
    className: Po(y) ? y({
      type: f
    }) : zf("Toastify__toast-body", y),
    style: S
  }), X && pr("div", {
    className: zf("Toastify__toast-icon", (n = {}, n["Toastify--animate-icon Toastify__zoom-enter"] = !O, n))
  }, X), pr("div", null, d)), ae(c), (u || R) && pr(Ule, Object.assign({}, E && !R ? {
    key: "pb-" + E
  } : {}, {
    rtl: N,
    theme: W,
    delay: u,
    isRunning: s,
    isIn: P,
    closeToast: p,
    hide: g,
    type: f,
    style: D,
    className: x,
    controlledProgress: R,
    progress: k
  }))));
}, Lye = /* @__PURE__ */ mye({
  enter: "Toastify--animate Toastify__bounce-enter",
  exit: "Toastify--animate Toastify__bounce-exit",
  appendPosition: !0
}), Gle = function(e) {
  var t = _ye(e), n = t.getToastToRender, r = t.containerRef, s = t.isToastActive, o = e.className, a = e.style, l = e.rtl, c = e.containerId;
  function d(u) {
    var h, f = zf("Toastify__toast-container", "Toastify__toast-container--" + u, (h = {}, h["Toastify__toast-container--rtl"] = l, h));
    return Po(o) ? o({
      position: u,
      rtl: l,
      defaultClassName: f
    }) : zf(f, p3(o));
  }
  return pr("div", {
    ref: r,
    className: "Toastify",
    id: c
  }, n(function(u, h) {
    var f = h.length ? al({}, a) : al({}, a, {
      pointerEvents: "none"
    });
    return pr("div", {
      className: d(u),
      style: f,
      key: "container-" + u
    }, h.map(function(g) {
      var p = g.content, m = g.props;
      return pr(Eye, Object.assign({}, m, {
        isIn: s(m.toastId),
        key: "toast-" + m.key,
        closeButton: m.closeButton === !0 ? zle : m.closeButton
      }), p);
    }));
  }));
};
Gle.defaultProps = {
  position: jle.TOP_RIGHT,
  transition: Lye,
  rtl: !1,
  autoClose: 5e3,
  hideProgressBar: !1,
  closeButton: zle,
  pauseOnHover: !0,
  pauseOnFocusLoss: !0,
  closeOnClick: !0,
  newestOnTop: !1,
  draggable: !0,
  draggablePercent: 80,
  draggableDirection: "x",
  role: "alert",
  theme: "light"
};
var Cv = /* @__PURE__ */ new Map(), g8, gC, qle, p8 = [], m8 = !1;
function Iye(i, e) {
  var t = e.containerId, n = Cv.get(t || g8);
  return n ? n.getToast(i) : null;
}
function Kle() {
  return Math.random().toString(36).substring(2, 9);
}
function Aye(i) {
  return i && (Vm(i.toastId) || gA(i.toastId)) ? i.toastId : Kle();
}
function sS(i, e) {
  return Cv.size > 0 ? Yc.emit(
    0,
    i,
    e
  ) : (p8.push({
    content: i,
    options: e
  }), m8 && Wle && (m8 = !1, gC = document.createElement("div"), document.body.appendChild(gC), RCe(pr(Gle, Object.assign({}, qle)), gC))), e.toastId;
}
function mA(i, e) {
  return al({}, e, {
    type: e && e.type || i,
    toastId: Aye(e)
  });
}
function vA(i) {
  return function(e, t) {
    return sS(e, mA(i, t));
  };
}
function In(i, e) {
  return sS(i, mA(rf.DEFAULT, e));
}
In.loading = function(i, e) {
  return sS(i, mA(rf.DEFAULT, al({
    isLoading: !0,
    autoClose: !1,
    closeOnClick: !1,
    closeButton: !1,
    draggable: !1
  }, e)));
};
function kye(i, e, t) {
  var n = e.pending, r = e.error, s = e.success, o;
  n && (o = Vm(n) ? In.loading(n, t) : In.loading(n.render, al({}, t, n)));
  var a = {
    isLoading: null,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null
  }, l = function(u, h, f) {
    if (h == null) {
      In.dismiss(o);
      return;
    }
    var g = al({
      type: u
    }, a, t, {
      data: f
    }), p = Vm(h) ? {
      render: h
    } : h;
    return o ? In.update(o, al({}, g, p)) : In(p.render, al({}, g, p)), f;
  }, c = Po(i) ? i() : i;
  return c.then(function(d) {
    return l("success", s, d);
  }).catch(function(d) {
    return l("error", r, d);
  }), c;
}
In.promise = kye;
In.success = /* @__PURE__ */ vA(rf.SUCCESS);
In.info = /* @__PURE__ */ vA(rf.INFO);
In.error = /* @__PURE__ */ vA(rf.ERROR);
In.warning = /* @__PURE__ */ vA(rf.WARNING);
In.warn = In.warning;
In.dark = function(i, e) {
  return sS(i, mA(rf.DEFAULT, al({
    theme: "dark"
  }, e)));
};
In.dismiss = function(i) {
  return Yc.emit(
    1,
    i
  );
};
In.clearWaitingQueue = function(i) {
  return i === void 0 && (i = {}), Yc.emit(
    5,
    i
  );
};
In.isActive = function(i) {
  var e = !1;
  return Cv.forEach(function(t) {
    t.isToastActive && t.isToastActive(i) && (e = !0);
  }), e;
};
In.update = function(i, e) {
  e === void 0 && (e = {}), setTimeout(function() {
    var t = Iye(i, e);
    if (t) {
      var n = t.props, r = t.content, s = al({}, n, e, {
        toastId: e.toastId || i,
        updateId: Kle()
      });
      s.toastId !== i && (s.staleId = i);
      var o = s.render || r;
      delete s.render, sS(o, s);
    }
  }, 0);
};
In.done = function(i) {
  In.update(i, {
    progress: 1
  });
};
In.onChange = function(i) {
  return Po(i) && Yc.on(
    4,
    i
  ), function() {
    Po(i) && Yc.off(
      4,
      i
    );
  };
};
In.configure = function(i) {
  i === void 0 && (i = {}), m8 = !0, qle = i;
};
In.POSITION = jle;
In.TYPE = rf;
Yc.on(
  2,
  function(i) {
    g8 = i.containerId || i, Cv.set(g8, i), p8.forEach(function(e) {
      Yc.emit(
        0,
        e.content,
        e.options
      );
    }), p8 = [];
  }
).on(
  3,
  function(i) {
    Cv.delete(i.containerId || i), Cv.size === 0 && Yc.off(
      0
      /* Show */
    ).off(
      1
      /* Clear */
    ).off(
      5
      /* ClearWaitingQueue */
    ), Wle && gC && document.body.removeChild(gC);
  }
);
class Yle extends it.Component {
  render() {
    return /* @__PURE__ */ v.jsxs("div", { className: "toast", children: [
      /* @__PURE__ */ v.jsx("div", { className: "toast__title", children: this.props.title }),
      this.props.subtitle && /* @__PURE__ */ v.jsx("div", { className: "toast__subtitle", children: this.props.subtitle })
    ] });
  }
}
class z_t extends it.Component {
  render() {
    return /* @__PURE__ */ v.jsxs("div", { className: "flex left column dc__app-update-toast", children: [
      /* @__PURE__ */ v.jsx("span", { className: "info", children: this.props.text }),
      /* @__PURE__ */ v.jsx("button", { type: "button", onClick: this.props.onClick, children: this.props.buttonText })
    ] });
  }
}
class U_t extends it.Component {
  render() {
    return /* @__PURE__ */ v.jsxs("div", { className: "toast dc__app-update-toast", children: [
      /* @__PURE__ */ v.jsx("div", { className: "toast__title", children: this.props.title }),
      this.props.subtitle && /* @__PURE__ */ v.jsx("div", { className: "toast__subtitle", children: this.props.subtitle }),
      /* @__PURE__ */ v.jsx("button", { type: "button", onClick: this.props.onClick, style: { float: "right" }, children: this.props.buttonText })
    ] });
  }
}
const Tye = (i, e) => In.info(
  /* @__PURE__ */ v.jsx(Yle, { title: i || iK.TITLE, subtitle: e || iK.SUBTITLE }),
  {
    className: "devtron-toast unauthorized"
  }
), Nye = "data:image/png;base64,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";
function Pye(i, e, t) {
  return e = ny(e), Hye(i, PW() ? Reflect.construct(e, t || [], ny(i).constructor) : e.apply(i, t));
}
function Xle(i, e, t) {
  if (PW()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, e);
  var r = new (i.bind.apply(i, n))();
  return t && iy(r, t.prototype), r;
}
function PW() {
  try {
    var i = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (PW = function() {
    return !!i;
  })();
}
function hK(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(i);
    e && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(i, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Oye(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hK(Object(t), !0).forEach(function(n) {
      Rye(i, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : hK(Object(t)).forEach(function(n) {
      Object.defineProperty(i, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return i;
}
function Mye(i, e) {
  if (typeof i != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(i, e || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(i);
}
function Zle(i) {
  var e = Mye(i, "string");
  return typeof e == "symbol" ? e : e + "";
}
function jl(i) {
  "@babel/helpers - typeof";
  return jl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jl(i);
}
function tb(i, e) {
  if (!(i instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function fK(i, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(i, Zle(n.key), n);
  }
}
function nb(i, e, t) {
  return e && fK(i.prototype, e), t && fK(i, t), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
function Rye(i, e, t) {
  return e = Zle(e), e in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
function Fye(i, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  i.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: i,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(i, "prototype", {
    writable: !1
  }), e && iy(i, e);
}
function ny(i) {
  return ny = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ny(i);
}
function iy(i, e) {
  return iy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, iy(i, e);
}
function Bye(i) {
  try {
    return Function.toString.call(i).indexOf("[native code]") !== -1;
  } catch {
    return typeof i == "function";
  }
}
function v8(i) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return v8 = function(n) {
    if (n === null || !Bye(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(n)) return e.get(n);
      e.set(n, r);
    }
    function r() {
      return Xle(n, arguments, ny(this).constructor);
    }
    return r.prototype = Object.create(n.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), iy(r, n);
  }, v8(i);
}
function Vye(i) {
  if (i === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return i;
}
function Hye(i, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Vye(i);
}
function OW(i) {
  return Wye(i) || jye(i) || Qle(i) || zye();
}
function Wye(i) {
  if (Array.isArray(i)) return _8(i);
}
function jye(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
}
function Qle(i, e) {
  if (i) {
    if (typeof i == "string") return _8(i, e);
    var t = Object.prototype.toString.call(i).slice(8, -1);
    if (t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set") return Array.from(i);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return _8(i, e);
  }
}
function _8(i, e) {
  (e == null || e > i.length) && (e = i.length);
  for (var t = 0, n = new Array(e); t < e; t++) n[t] = i[t];
  return n;
}
function zye() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Uye(i, e) {
  var t = typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (!t) {
    if (Array.isArray(i) || (t = Qle(i)) || e) {
      t && (i = t);
      var n = 0, r = function() {
      };
      return {
        s: r,
        n: function() {
          return n >= i.length ? {
            done: !0
          } : {
            done: !1,
            value: i[n++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: r
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var s = !0, o = !1, a;
  return {
    s: function() {
      t = t.call(i);
    },
    n: function() {
      var l = t.next();
      return s = l.done, l;
    },
    e: function(l) {
      o = !0, a = l;
    },
    f: function() {
      try {
        !s && t.return != null && t.return();
      } finally {
        if (o) throw a;
      }
    }
  };
}
var Gye = /* @__PURE__ */ function() {
  function i() {
    tb(this, i);
  }
  return nb(i, [{
    key: "add",
    value: (
      /**
       * @callback HookCallback
       * @this {*|Jsep} this
       * @param {Jsep} env
       * @returns: void
       */
      /**
       * Adds the given callback to the list of callbacks for the given hook.
       *
       * The callback will be invoked when the hook it is registered for is run.
       *
       * One callback function can be registered to multiple hooks and the same hook multiple times.
       *
       * @param {string|object} name The name of the hook, or an object of callbacks keyed by name
       * @param {HookCallback|boolean} callback The callback function which is given environment variables.
       * @param {?boolean} [first=false] Will add the hook to the top of the list (defaults to the bottom)
       * @public
       */
      function(t, n, r) {
        if (typeof arguments[0] != "string")
          for (var s in arguments[0])
            this.add(s, arguments[0][s], arguments[1]);
        else
          (Array.isArray(t) ? t : [t]).forEach(function(o) {
            this[o] = this[o] || [], n && this[o][r ? "unshift" : "push"](n);
          }, this);
      }
    )
    /**
     * Runs a hook invoking all registered callbacks with the given environment variables.
     *
     * Callbacks will be invoked synchronously and in the order in which they were registered.
     *
     * @param {string} name The name of the hook.
     * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
     * @public
     */
  }, {
    key: "run",
    value: function(t, n) {
      this[t] = this[t] || [], this[t].forEach(function(r) {
        r.call(n && n.context ? n.context : n, n);
      });
    }
  }]);
}(), qye = /* @__PURE__ */ function() {
  function i(e) {
    tb(this, i), this.jsep = e, this.registered = {};
  }
  return nb(i, [{
    key: "register",
    value: function() {
      for (var t = this, n = arguments.length, r = new Array(n), s = 0; s < n; s++)
        r[s] = arguments[s];
      r.forEach(function(o) {
        if (jl(o) !== "object" || !o.name || !o.init)
          throw new Error("Invalid JSEP plugin format");
        t.registered[o.name] || (o.init(t.jsep), t.registered[o.name] = o);
      });
    }
  }]);
}(), Yl = /* @__PURE__ */ function() {
  function i(e) {
    tb(this, i), this.expr = e, this.index = 0;
  }
  return nb(i, [{
    key: "char",
    get: (
      // ==================== END CONFIG ============================
      /**
       * @returns {string}
       */
      function() {
        return this.expr.charAt(this.index);
      }
    )
    /**
     * @returns {number}
     */
  }, {
    key: "code",
    get: function() {
      return this.expr.charCodeAt(this.index);
    }
  }, {
    key: "throwError",
    value: (
      /**
       * throw error at index of the expression
       * @param {string} message
       * @throws
       */
      function(t) {
        var n = new Error(t + " at character " + this.index);
        throw n.index = this.index, n.description = t, n;
      }
    )
    /**
     * Run a given hook
     * @param {string} name
     * @param {jsep.Expression|false} [node]
     * @returns {?jsep.Expression}
     */
  }, {
    key: "runHook",
    value: function(t, n) {
      if (i.hooks[t]) {
        var r = {
          context: this,
          node: n
        };
        return i.hooks.run(t, r), r.node;
      }
      return n;
    }
    /**
     * Runs a given hook until one returns a node
     * @param {string} name
     * @returns {?jsep.Expression}
     */
  }, {
    key: "searchHook",
    value: function(t) {
      if (i.hooks[t]) {
        var n = {
          context: this
        };
        return i.hooks[t].find(function(r) {
          return r.call(n.context, n), n.node;
        }), n.node;
      }
    }
    /**
     * Push `index` up to the next non-space character
     */
  }, {
    key: "gobbleSpaces",
    value: function() {
      for (var t = this.code; t === i.SPACE_CODE || t === i.TAB_CODE || t === i.LF_CODE || t === i.CR_CODE; )
        t = this.expr.charCodeAt(++this.index);
      this.runHook("gobble-spaces");
    }
    /**
     * Top-level method to parse all expressions and returns compound or single node
     * @returns {jsep.Expression}
     */
  }, {
    key: "parse",
    value: function() {
      this.runHook("before-all");
      var t = this.gobbleExpressions(), n = t.length === 1 ? t[0] : {
        type: i.COMPOUND,
        body: t
      };
      return this.runHook("after-all", n);
    }
    /**
     * top-level parser (but can be reused within as well)
     * @param {number} [untilICode]
     * @returns {jsep.Expression[]}
     */
  }, {
    key: "gobbleExpressions",
    value: function(t) {
      for (var n = [], r, s; this.index < this.expr.length; )
        if (r = this.code, r === i.SEMCOL_CODE || r === i.COMMA_CODE)
          this.index++;
        else if (s = this.gobbleExpression())
          n.push(s);
        else if (this.index < this.expr.length) {
          if (r === t)
            break;
          this.throwError('Unexpected "' + this.char + '"');
        }
      return n;
    }
    /**
     * The main parsing function.
     * @returns {?jsep.Expression}
     */
  }, {
    key: "gobbleExpression",
    value: function() {
      var t = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
      return this.gobbleSpaces(), this.runHook("after-expression", t);
    }
    /**
     * Search for the operation portion of the string (e.g. `+`, `===`)
     * Start by taking the longest possible binary operations (3 characters: `===`, `!==`, `>>>`)
     * and move down from 3 to 2 to 1 character until a matching binary operation is found
     * then, return that binary operation
     * @returns {string|boolean}
     */
  }, {
    key: "gobbleBinaryOp",
    value: function() {
      this.gobbleSpaces();
      for (var t = this.expr.substr(this.index, i.max_binop_len), n = t.length; n > 0; ) {
        if (i.binary_ops.hasOwnProperty(t) && (!i.isIdentifierStart(this.code) || this.index + t.length < this.expr.length && !i.isIdentifierPart(this.expr.charCodeAt(this.index + t.length))))
          return this.index += n, t;
        t = t.substr(0, --n);
      }
      return !1;
    }
    /**
     * This function is responsible for gobbling an individual expression,
     * e.g. `1`, `1+2`, `a+(b*2)-Math.sqrt(2)`
     * @returns {?jsep.BinaryExpression}
     */
  }, {
    key: "gobbleBinaryExpression",
    value: function() {
      var t, n, r, s, o, a, l, c, d;
      if (a = this.gobbleToken(), !a || (n = this.gobbleBinaryOp(), !n))
        return a;
      for (o = {
        value: n,
        prec: i.binaryPrecedence(n),
        right_a: i.right_associative.has(n)
      }, l = this.gobbleToken(), l || this.throwError("Expected expression after " + n), s = [a, o, l]; n = this.gobbleBinaryOp(); ) {
        if (r = i.binaryPrecedence(n), r === 0) {
          this.index -= n.length;
          break;
        }
        o = {
          value: n,
          prec: r,
          right_a: i.right_associative.has(n)
        }, d = n;
        for (var u = function(f) {
          return o.right_a && f.right_a ? r > f.prec : r <= f.prec;
        }; s.length > 2 && u(s[s.length - 2]); )
          l = s.pop(), n = s.pop().value, a = s.pop(), t = {
            type: i.BINARY_EXP,
            operator: n,
            left: a,
            right: l
          }, s.push(t);
        t = this.gobbleToken(), t || this.throwError("Expected expression after " + d), s.push(o, t);
      }
      for (c = s.length - 1, t = s[c]; c > 1; )
        t = {
          type: i.BINARY_EXP,
          operator: s[c - 1].value,
          left: s[c - 2],
          right: t
        }, c -= 2;
      return t;
    }
    /**
     * An individual part of a binary expression:
     * e.g. `foo.bar(baz)`, `1`, `"abc"`, `(a % 2)` (because it's in parenthesis)
     * @returns {boolean|jsep.Expression}
     */
  }, {
    key: "gobbleToken",
    value: function() {
      var t, n, r, s;
      if (this.gobbleSpaces(), s = this.searchHook("gobble-token"), s)
        return this.runHook("after-token", s);
      if (t = this.code, i.isDecimalDigit(t) || t === i.PERIOD_CODE)
        return this.gobbleNumericLiteral();
      if (t === i.SQUOTE_CODE || t === i.DQUOTE_CODE)
        s = this.gobbleStringLiteral();
      else if (t === i.OBRACK_CODE)
        s = this.gobbleArray();
      else {
        for (n = this.expr.substr(this.index, i.max_unop_len), r = n.length; r > 0; ) {
          if (i.unary_ops.hasOwnProperty(n) && (!i.isIdentifierStart(this.code) || this.index + n.length < this.expr.length && !i.isIdentifierPart(this.expr.charCodeAt(this.index + n.length)))) {
            this.index += r;
            var o = this.gobbleToken();
            return o || this.throwError("missing unaryOp argument"), this.runHook("after-token", {
              type: i.UNARY_EXP,
              operator: n,
              argument: o,
              prefix: !0
            });
          }
          n = n.substr(0, --r);
        }
        i.isIdentifierStart(t) ? (s = this.gobbleIdentifier(), i.literals.hasOwnProperty(s.name) ? s = {
          type: i.LITERAL,
          value: i.literals[s.name],
          raw: s.name
        } : s.name === i.this_str && (s = {
          type: i.THIS_EXP
        })) : t === i.OPAREN_CODE && (s = this.gobbleGroup());
      }
      return s ? (s = this.gobbleTokenProperty(s), this.runHook("after-token", s)) : this.runHook("after-token", !1);
    }
    /**
     * Gobble properties of of identifiers/strings/arrays/groups.
     * e.g. `foo`, `bar.baz`, `foo['bar'].baz`
     * It also gobbles function calls:
     * e.g. `Math.acos(obj.angle)`
     * @param {jsep.Expression} node
     * @returns {jsep.Expression}
     */
  }, {
    key: "gobbleTokenProperty",
    value: function(t) {
      this.gobbleSpaces();
      for (var n = this.code; n === i.PERIOD_CODE || n === i.OBRACK_CODE || n === i.OPAREN_CODE || n === i.QUMARK_CODE; ) {
        var r = void 0;
        if (n === i.QUMARK_CODE) {
          if (this.expr.charCodeAt(this.index + 1) !== i.PERIOD_CODE)
            break;
          r = !0, this.index += 2, this.gobbleSpaces(), n = this.code;
        }
        this.index++, n === i.OBRACK_CODE ? (t = {
          type: i.MEMBER_EXP,
          computed: !0,
          object: t,
          property: this.gobbleExpression()
        }, this.gobbleSpaces(), n = this.code, n !== i.CBRACK_CODE && this.throwError("Unclosed ["), this.index++) : n === i.OPAREN_CODE ? t = {
          type: i.CALL_EXP,
          arguments: this.gobbleArguments(i.CPAREN_CODE),
          callee: t
        } : (n === i.PERIOD_CODE || r) && (r && this.index--, this.gobbleSpaces(), t = {
          type: i.MEMBER_EXP,
          computed: !1,
          object: t,
          property: this.gobbleIdentifier()
        }), r && (t.optional = !0), this.gobbleSpaces(), n = this.code;
      }
      return t;
    }
    /**
     * Parse simple numeric literals: `12`, `3.4`, `.5`. Do this by using a string to
     * keep track of everything in the numeric literal and then calling `parseFloat` on that string
     * @returns {jsep.Literal}
     */
  }, {
    key: "gobbleNumericLiteral",
    value: function() {
      for (var t = "", n, r; i.isDecimalDigit(this.code); )
        t += this.expr.charAt(this.index++);
      if (this.code === i.PERIOD_CODE)
        for (t += this.expr.charAt(this.index++); i.isDecimalDigit(this.code); )
          t += this.expr.charAt(this.index++);
      if (n = this.char, n === "e" || n === "E") {
        for (t += this.expr.charAt(this.index++), n = this.char, (n === "+" || n === "-") && (t += this.expr.charAt(this.index++)); i.isDecimalDigit(this.code); )
          t += this.expr.charAt(this.index++);
        i.isDecimalDigit(this.expr.charCodeAt(this.index - 1)) || this.throwError("Expected exponent (" + t + this.char + ")");
      }
      return r = this.code, i.isIdentifierStart(r) ? this.throwError("Variable names cannot start with a number (" + t + this.char + ")") : (r === i.PERIOD_CODE || t.length === 1 && t.charCodeAt(0) === i.PERIOD_CODE) && this.throwError("Unexpected period"), {
        type: i.LITERAL,
        value: parseFloat(t),
        raw: t
      };
    }
    /**
     * Parses a string literal, staring with single or double quotes with basic support for escape codes
     * e.g. `"hello world"`, `'this is\nJSEP'`
     * @returns {jsep.Literal}
     */
  }, {
    key: "gobbleStringLiteral",
    value: function() {
      for (var t = "", n = this.index, r = this.expr.charAt(this.index++), s = !1; this.index < this.expr.length; ) {
        var o = this.expr.charAt(this.index++);
        if (o === r) {
          s = !0;
          break;
        } else if (o === "\\")
          switch (o = this.expr.charAt(this.index++), o) {
            case "n":
              t += `
`;
              break;
            case "r":
              t += "\r";
              break;
            case "t":
              t += "	";
              break;
            case "b":
              t += "\b";
              break;
            case "f":
              t += "\f";
              break;
            case "v":
              t += "\v";
              break;
            default:
              t += o;
          }
        else
          t += o;
      }
      return s || this.throwError('Unclosed quote after "' + t + '"'), {
        type: i.LITERAL,
        value: t,
        raw: this.expr.substring(n, this.index)
      };
    }
    /**
     * Gobbles only identifiers
     * e.g.: `foo`, `_value`, `$x1`
     * Also, this function checks if that identifier is a literal:
     * (e.g. `true`, `false`, `null`) or `this`
     * @returns {jsep.Identifier}
     */
  }, {
    key: "gobbleIdentifier",
    value: function() {
      var t = this.code, n = this.index;
      for (i.isIdentifierStart(t) ? this.index++ : this.throwError("Unexpected " + this.char); this.index < this.expr.length && (t = this.code, i.isIdentifierPart(t)); )
        this.index++;
      return {
        type: i.IDENTIFIER,
        name: this.expr.slice(n, this.index)
      };
    }
    /**
     * Gobbles a list of arguments within the context of a function call
     * or array literal. This function also assumes that the opening character
     * `(` or `[` has already been gobbled, and gobbles expressions and commas
     * until the terminator character `)` or `]` is encountered.
     * e.g. `foo(bar, baz)`, `my_func()`, or `[bar, baz]`
     * @param {number} termination
     * @returns {jsep.Expression[]}
     */
  }, {
    key: "gobbleArguments",
    value: function(t) {
      for (var n = [], r = !1, s = 0; this.index < this.expr.length; ) {
        this.gobbleSpaces();
        var o = this.code;
        if (o === t) {
          r = !0, this.index++, t === i.CPAREN_CODE && s && s >= n.length && this.throwError("Unexpected token " + String.fromCharCode(t));
          break;
        } else if (o === i.COMMA_CODE) {
          if (this.index++, s++, s !== n.length) {
            if (t === i.CPAREN_CODE)
              this.throwError("Unexpected token ,");
            else if (t === i.CBRACK_CODE)
              for (var a = n.length; a < s; a++)
                n.push(null);
          }
        } else if (n.length !== s && s !== 0)
          this.throwError("Expected comma");
        else {
          var l = this.gobbleExpression();
          (!l || l.type === i.COMPOUND) && this.throwError("Expected comma"), n.push(l);
        }
      }
      return r || this.throwError("Expected " + String.fromCharCode(t)), n;
    }
    /**
     * Responsible for parsing a group of things within parentheses `()`
     * that have no identifier in front (so not a function call)
     * This function assumes that it needs to gobble the opening parenthesis
     * and then tries to gobble everything within that parenthesis, assuming
     * that the next thing it should see is the close parenthesis. If not,
     * then the expression probably doesn't have a `)`
     * @returns {boolean|jsep.Expression}
     */
  }, {
    key: "gobbleGroup",
    value: function() {
      this.index++;
      var t = this.gobbleExpressions(i.CPAREN_CODE);
      if (this.code === i.CPAREN_CODE)
        return this.index++, t.length === 1 ? t[0] : t.length ? {
          type: i.SEQUENCE_EXP,
          expressions: t
        } : !1;
      this.throwError("Unclosed (");
    }
    /**
     * Responsible for parsing Array literals `[1, 2, 3]`
     * This function assumes that it needs to gobble the opening bracket
     * and then tries to gobble the expressions as arguments.
     * @returns {jsep.ArrayExpression}
     */
  }, {
    key: "gobbleArray",
    value: function() {
      return this.index++, {
        type: i.ARRAY_EXP,
        elements: this.gobbleArguments(i.CBRACK_CODE)
      };
    }
  }], [{
    key: "version",
    get: (
      /**
       * @returns {string}
       */
      function() {
        return "1.3.8";
      }
    )
    /**
     * @returns {string}
     */
  }, {
    key: "toString",
    value: function() {
      return "JavaScript Expression Parser (JSEP) v" + i.version;
    }
  }, {
    key: "addUnaryOp",
    value: (
      // ==================== CONFIG ================================
      /**
       * @method addUnaryOp
       * @param {string} op_name The name of the unary op to add
       * @returns {Jsep}
       */
      function(t) {
        return i.max_unop_len = Math.max(t.length, i.max_unop_len), i.unary_ops[t] = 1, i;
      }
    )
    /**
     * @method jsep.addBinaryOp
     * @param {string} op_name The name of the binary op to add
     * @param {number} precedence The precedence of the binary op (can be a float). Higher number = higher precedence
     * @param {boolean} [isRightAssociative=false] whether operator is right-associative
     * @returns {Jsep}
     */
  }, {
    key: "addBinaryOp",
    value: function(t, n, r) {
      return i.max_binop_len = Math.max(t.length, i.max_binop_len), i.binary_ops[t] = n, r ? i.right_associative.add(t) : i.right_associative.delete(t), i;
    }
    /**
     * @method addIdentifierChar
     * @param {string} char The additional character to treat as a valid part of an identifier
     * @returns {Jsep}
     */
  }, {
    key: "addIdentifierChar",
    value: function(t) {
      return i.additional_identifier_chars.add(t), i;
    }
    /**
     * @method addLiteral
     * @param {string} literal_name The name of the literal to add
     * @param {*} literal_value The value of the literal
     * @returns {Jsep}
     */
  }, {
    key: "addLiteral",
    value: function(t, n) {
      return i.literals[t] = n, i;
    }
    /**
     * @method removeUnaryOp
     * @param {string} op_name The name of the unary op to remove
     * @returns {Jsep}
     */
  }, {
    key: "removeUnaryOp",
    value: function(t) {
      return delete i.unary_ops[t], t.length === i.max_unop_len && (i.max_unop_len = i.getMaxKeyLen(i.unary_ops)), i;
    }
    /**
     * @method removeAllUnaryOps
     * @returns {Jsep}
     */
  }, {
    key: "removeAllUnaryOps",
    value: function() {
      return i.unary_ops = {}, i.max_unop_len = 0, i;
    }
    /**
     * @method removeIdentifierChar
     * @param {string} char The additional character to stop treating as a valid part of an identifier
     * @returns {Jsep}
     */
  }, {
    key: "removeIdentifierChar",
    value: function(t) {
      return i.additional_identifier_chars.delete(t), i;
    }
    /**
     * @method removeBinaryOp
     * @param {string} op_name The name of the binary op to remove
     * @returns {Jsep}
     */
  }, {
    key: "removeBinaryOp",
    value: function(t) {
      return delete i.binary_ops[t], t.length === i.max_binop_len && (i.max_binop_len = i.getMaxKeyLen(i.binary_ops)), i.right_associative.delete(t), i;
    }
    /**
     * @method removeAllBinaryOps
     * @returns {Jsep}
     */
  }, {
    key: "removeAllBinaryOps",
    value: function() {
      return i.binary_ops = {}, i.max_binop_len = 0, i;
    }
    /**
     * @method removeLiteral
     * @param {string} literal_name The name of the literal to remove
     * @returns {Jsep}
     */
  }, {
    key: "removeLiteral",
    value: function(t) {
      return delete i.literals[t], i;
    }
    /**
     * @method removeAllLiterals
     * @returns {Jsep}
     */
  }, {
    key: "removeAllLiterals",
    value: function() {
      return i.literals = {}, i;
    }
  }, {
    key: "parse",
    value: function(t) {
      return new i(t).parse();
    }
    /**
     * Get the longest key length of any object
     * @param {object} obj
     * @returns {number}
     */
  }, {
    key: "getMaxKeyLen",
    value: function(t) {
      return Math.max.apply(Math, [0].concat(OW(Object.keys(t).map(function(n) {
        return n.length;
      }))));
    }
    /**
     * `ch` is a character code in the next three functions
     * @param {number} ch
     * @returns {boolean}
     */
  }, {
    key: "isDecimalDigit",
    value: function(t) {
      return t >= 48 && t <= 57;
    }
    /**
     * Returns the precedence of a binary operator or `0` if it isn't a binary operator. Can be float.
     * @param {string} op_val
     * @returns {number}
     */
  }, {
    key: "binaryPrecedence",
    value: function(t) {
      return i.binary_ops[t] || 0;
    }
    /**
     * Looks for start of identifier
     * @param {number} ch
     * @returns {boolean}
     */
  }, {
    key: "isIdentifierStart",
    value: function(t) {
      return t >= 65 && t <= 90 || // A...Z
      t >= 97 && t <= 122 || // a...z
      t >= 128 && !i.binary_ops[String.fromCharCode(t)] || // any non-ASCII that is not an operator
      i.additional_identifier_chars.has(String.fromCharCode(t));
    }
    /**
     * @param {number} ch
     * @returns {boolean}
     */
  }, {
    key: "isIdentifierPart",
    value: function(t) {
      return i.isIdentifierStart(t) || i.isDecimalDigit(t);
    }
  }]);
}(), Kye = new Gye();
Object.assign(Yl, {
  hooks: Kye,
  plugins: new qye(Yl),
  // Node Types
  // ----------
  // This is the full set of types that any JSEP node can be.
  // Store them here to save space when minified
  COMPOUND: "Compound",
  SEQUENCE_EXP: "SequenceExpression",
  IDENTIFIER: "Identifier",
  MEMBER_EXP: "MemberExpression",
  LITERAL: "Literal",
  THIS_EXP: "ThisExpression",
  CALL_EXP: "CallExpression",
  UNARY_EXP: "UnaryExpression",
  BINARY_EXP: "BinaryExpression",
  ARRAY_EXP: "ArrayExpression",
  TAB_CODE: 9,
  LF_CODE: 10,
  CR_CODE: 13,
  SPACE_CODE: 32,
  PERIOD_CODE: 46,
  // '.'
  COMMA_CODE: 44,
  // ','
  SQUOTE_CODE: 39,
  // single quote
  DQUOTE_CODE: 34,
  // double quotes
  OPAREN_CODE: 40,
  // (
  CPAREN_CODE: 41,
  // )
  OBRACK_CODE: 91,
  // [
  CBRACK_CODE: 93,
  // ]
  QUMARK_CODE: 63,
  // ?
  SEMCOL_CODE: 59,
  // ;
  COLON_CODE: 58,
  // :
  // Operations
  // ----------
  // Use a quickly-accessible map to store all of the unary operators
  // Values are set to `1` (it really doesn't matter)
  unary_ops: {
    "-": 1,
    "!": 1,
    "~": 1,
    "+": 1
  },
  // Also use a map for the binary operations but set their values to their
  // binary precedence for quick reference (higher number = higher precedence)
  // see [Order of operations](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_Precedence)
  binary_ops: {
    "||": 1,
    "&&": 2,
    "|": 3,
    "^": 4,
    "&": 5,
    "==": 6,
    "!=": 6,
    "===": 6,
    "!==": 6,
    "<": 7,
    ">": 7,
    "<=": 7,
    ">=": 7,
    "<<": 8,
    ">>": 8,
    ">>>": 8,
    "+": 9,
    "-": 9,
    "*": 10,
    "/": 10,
    "%": 10
  },
  // sets specific binary_ops as right-associative
  right_associative: /* @__PURE__ */ new Set(),
  // Additional valid identifier chars, apart from a-z, A-Z and 0-9 (except on the starting char)
  additional_identifier_chars: /* @__PURE__ */ new Set(["$", "_"]),
  // Literals
  // ----------
  // Store the values to return for the various literals we may encounter
  literals: {
    true: !0,
    false: !1,
    null: null
  },
  // Except for `this`, which is special. This could be changed to something like `'self'` as well
  this_str: "this"
});
Yl.max_unop_len = Yl.getMaxKeyLen(Yl.unary_ops);
Yl.max_binop_len = Yl.getMaxKeyLen(Yl.binary_ops);
var t_ = function(e) {
  return new Yl(e).parse();
}, Yye = Object.getOwnPropertyNames(Yl);
Yye.forEach(function(i) {
  t_[i] === void 0 && i !== "prototype" && (t_[i] = Yl[i]);
});
t_.Jsep = Yl;
var Xye = "ConditionalExpression", Zye = {
  name: "ternary",
  init: function(e) {
    e.hooks.add("after-expression", function(n) {
      if (n.node && this.code === e.QUMARK_CODE) {
        this.index++;
        var r = n.node, s = this.gobbleExpression();
        if (s || this.throwError("Expected expression"), this.gobbleSpaces(), this.code === e.COLON_CODE) {
          this.index++;
          var o = this.gobbleExpression();
          if (o || this.throwError("Expected expression"), n.node = {
            type: Xye,
            test: r,
            consequent: s,
            alternate: o
          }, r.operator && e.binary_ops[r.operator] <= 0.9) {
            for (var a = r; a.right.operator && e.binary_ops[a.right.operator] <= 0.9; )
              a = a.right;
            n.node.test = a.right, a.right = n.node, n.node = r;
          }
        } else
          this.throwError("Expected :");
      }
    });
  }
};
t_.plugins.register(Zye);
var gK = 47, Qye = 92, Jye = {
  name: "regex",
  init: function(e) {
    e.hooks.add("gobble-token", function(n) {
      if (this.code === gK) {
        for (var r = ++this.index, s = !1; this.index < this.expr.length; ) {
          if (this.code === gK && !s) {
            for (var o = this.expr.slice(r, this.index), a = ""; ++this.index < this.expr.length; ) {
              var l = this.code;
              if (l >= 97 && l <= 122 || l >= 65 && l <= 90 || l >= 48 && l <= 57)
                a += this.char;
              else
                break;
            }
            var c = void 0;
            try {
              c = new RegExp(o, a);
            } catch (d) {
              this.throwError(d.message);
            }
            return n.node = {
              type: e.LITERAL,
              value: c,
              raw: this.expr.slice(r - 1, this.index)
            }, n.node = this.gobbleTokenProperty(n.node), n.node;
          }
          this.code === e.OBRACK_CODE ? s = !0 : s && this.code === e.CBRACK_CODE && (s = !1), this.index += this.code === Qye ? 2 : 1;
        }
        this.throwError("Unclosed Regex");
      }
    });
  }
}, Ak = 43, $ye = 45, T1 = {
  name: "assignment",
  assignmentOperators: /* @__PURE__ */ new Set(["=", "*=", "**=", "/=", "%=", "+=", "-=", "<<=", ">>=", ">>>=", "&=", "^=", "|="]),
  updateOperators: [Ak, $ye],
  assignmentPrecedence: 0.9,
  init: function(e) {
    var t = [e.IDENTIFIER, e.MEMBER_EXP];
    T1.assignmentOperators.forEach(function(r) {
      return e.addBinaryOp(r, T1.assignmentPrecedence, !0);
    }), e.hooks.add("gobble-token", function(s) {
      var o = this, a = this.code;
      T1.updateOperators.some(function(l) {
        return l === a && l === o.expr.charCodeAt(o.index + 1);
      }) && (this.index += 2, s.node = {
        type: "UpdateExpression",
        operator: a === Ak ? "++" : "--",
        argument: this.gobbleTokenProperty(this.gobbleIdentifier()),
        prefix: !0
      }, (!s.node.argument || !t.includes(s.node.argument.type)) && this.throwError("Unexpected ".concat(s.node.operator)));
    }), e.hooks.add("after-token", function(s) {
      var o = this;
      if (s.node) {
        var a = this.code;
        T1.updateOperators.some(function(l) {
          return l === a && l === o.expr.charCodeAt(o.index + 1);
        }) && (t.includes(s.node.type) || this.throwError("Unexpected ".concat(s.node.operator)), this.index += 2, s.node = {
          type: "UpdateExpression",
          operator: a === Ak ? "++" : "--",
          argument: s.node,
          prefix: !1
        });
      }
    }), e.hooks.add("after-expression", function(s) {
      s.node && n(s.node);
    });
    function n(r) {
      T1.assignmentOperators.has(r.operator) ? (r.type = "AssignmentExpression", n(r.left), n(r.right)) : r.operator || Object.values(r).forEach(function(s) {
        s && jl(s) === "object" && n(s);
      });
    }
  }
}, Uo = Object.prototype.hasOwnProperty;
function mf(i, e) {
  return i = i.slice(), i.push(e), i;
}
function b8(i, e) {
  return e = e.slice(), e.unshift(i), e;
}
var ewe = /* @__PURE__ */ function(i) {
  function e(t) {
    var n;
    return tb(this, e), n = Pye(this, e, ['JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)']), n.avoidNew = !0, n.value = t, n.name = "NewError", n;
  }
  return Fye(e, i), nb(e);
}(/* @__PURE__ */ v8(Error));
function li(i, e, t, n, r) {
  if (!(this instanceof li))
    try {
      return new li(i, e, t, n, r);
    } catch (l) {
      if (!l.avoidNew)
        throw l;
      return l.value;
    }
  typeof i == "string" && (r = n, n = t, t = e, e = i, i = null);
  var s = i && jl(i) === "object";
  if (i = i || {}, this.json = i.json || t, this.path = i.path || e, this.resultType = i.resultType || "value", this.flatten = i.flatten || !1, this.wrap = Uo.call(i, "wrap") ? i.wrap : !0, this.sandbox = i.sandbox || {}, this.eval = i.eval === void 0 ? "safe" : i.eval, this.ignoreEvalErrors = typeof i.ignoreEvalErrors > "u" ? !1 : i.ignoreEvalErrors, this.parent = i.parent || null, this.parentProperty = i.parentProperty || null, this.callback = i.callback || n || null, this.otherTypeCallback = i.otherTypeCallback || r || function() {
    throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
  }, i.autostart !== !1) {
    var o = {
      path: s ? i.path : e
    };
    s ? "json" in i && (o.json = i.json) : o.json = t;
    var a = this.evaluate(o);
    if (!a || jl(a) !== "object")
      throw new ewe(a);
    return a;
  }
}
li.prototype.evaluate = function(i, e, t, n) {
  var r = this, s = this.parent, o = this.parentProperty, a = this.flatten, l = this.wrap;
  if (this.currResultType = this.resultType, this.currEval = this.eval, this.currSandbox = this.sandbox, t = t || this.callback, this.currOtherTypeCallback = n || this.otherTypeCallback, e = e || this.json, i = i || this.path, i && jl(i) === "object" && !Array.isArray(i)) {
    if (!i.path && i.path !== "")
      throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');
    if (!Uo.call(i, "json"))
      throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');
    var c = i;
    e = c.json, a = Uo.call(i, "flatten") ? i.flatten : a, this.currResultType = Uo.call(i, "resultType") ? i.resultType : this.currResultType, this.currSandbox = Uo.call(i, "sandbox") ? i.sandbox : this.currSandbox, l = Uo.call(i, "wrap") ? i.wrap : l, this.currEval = Uo.call(i, "eval") ? i.eval : this.currEval, t = Uo.call(i, "callback") ? i.callback : t, this.currOtherTypeCallback = Uo.call(i, "otherTypeCallback") ? i.otherTypeCallback : this.currOtherTypeCallback, s = Uo.call(i, "parent") ? i.parent : s, o = Uo.call(i, "parentProperty") ? i.parentProperty : o, i = i.path;
  }
  if (s = s || null, o = o || null, Array.isArray(i) && (i = li.toPathString(i)), !(!i && i !== "" || !e)) {
    var d = li.toPathArray(i);
    d[0] === "$" && d.length > 1 && d.shift(), this._hasParentSelector = null;
    var u = this._trace(d, e, ["$"], s, o, t).filter(function(h) {
      return h && !h.isParentSelector;
    });
    return u.length ? !l && u.length === 1 && !u[0].hasArrExpr ? this._getPreferredOutput(u[0]) : u.reduce(function(h, f) {
      var g = r._getPreferredOutput(f);
      return a && Array.isArray(g) ? h = h.concat(g) : h.push(g), h;
    }, []) : l ? [] : void 0;
  }
};
li.prototype._getPreferredOutput = function(i) {
  var e = this.currResultType;
  switch (e) {
    case "all": {
      var t = Array.isArray(i.path) ? i.path : li.toPathArray(i.path);
      return i.pointer = li.toPointer(t), i.path = typeof i.path == "string" ? i.path : li.toPathString(i.path), i;
    }
    case "value":
    case "parent":
    case "parentProperty":
      return i[e];
    case "path":
      return li.toPathString(i[e]);
    case "pointer":
      return li.toPointer(i.path);
    default:
      throw new TypeError("Unknown result type");
  }
};
li.prototype._handleCallback = function(i, e, t) {
  if (e) {
    var n = this._getPreferredOutput(i);
    i.path = typeof i.path == "string" ? i.path : li.toPathString(i.path), e(n, t, i);
  }
};
li.prototype._trace = function(i, e, t, n, r, s, o, a) {
  var l = this, c;
  if (!i.length)
    return c = {
      path: t,
      value: e,
      parent: n,
      parentProperty: r,
      hasArrExpr: o
    }, this._handleCallback(c, s, "value"), c;
  var d = i[0], u = i.slice(1), h = [];
  function f(I) {
    Array.isArray(I) ? I.forEach(function(A) {
      h.push(A);
    }) : h.push(I);
  }
  if ((typeof d != "string" || a) && e && Uo.call(e, d))
    f(this._trace(u, e[d], mf(t, d), e, d, s, o));
  else if (d === "*")
    this._walk(e, function(I) {
      f(l._trace(u, e[I], mf(t, I), e, I, s, !0, !0));
    });
  else if (d === "..")
    f(this._trace(u, e, t, n, r, s, o)), this._walk(e, function(I) {
      jl(e[I]) === "object" && f(l._trace(i.slice(), e[I], mf(t, I), e, I, s, !0));
    });
  else {
    if (d === "^")
      return this._hasParentSelector = !0, {
        path: t.slice(0, -1),
        expr: u,
        isParentSelector: !0
      };
    if (d === "~")
      return c = {
        path: mf(t, d),
        value: r,
        parent: n,
        parentProperty: null
      }, this._handleCallback(c, s, "property"), c;
    if (d === "$")
      f(this._trace(u, e, t, null, null, s, o));
    else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(d))
      f(this._slice(d, u, e, t, n, r, s));
    else if (d.indexOf("?(") === 0) {
      if (this.currEval === !1)
        throw new Error("Eval [?(expr)] prevented in JSONPath expression.");
      var g = d.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, "$1"), p = /@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])?((?:[\0->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))(?!(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])\)\])['\]]/g.exec(g);
      p ? this._walk(e, function(I) {
        var A = [p[2]], P = p[1] ? e[I][p[1]] : e[I], O = l._trace(A, P, t, n, r, s, !0);
        O.length > 0 && f(l._trace(u, e[I], mf(t, I), e, I, s, !0));
      }) : this._walk(e, function(I) {
        l._eval(g, e[I], I, t, n, r) && f(l._trace(u, e[I], mf(t, I), e, I, s, !0));
      });
    } else if (d[0] === "(") {
      if (this.currEval === !1)
        throw new Error("Eval [(expr)] prevented in JSONPath expression.");
      f(this._trace(b8(this._eval(d, e, t[t.length - 1], t.slice(0, -1), n, r), u), e, t, n, r, s, o));
    } else if (d[0] === "@") {
      var m = !1, _ = d.slice(1, -2);
      switch (_) {
        case "scalar":
          (!e || !["object", "function"].includes(jl(e))) && (m = !0);
          break;
        case "boolean":
        case "string":
        case "undefined":
        case "function":
          jl(e) === _ && (m = !0);
          break;
        case "integer":
          Number.isFinite(e) && !(e % 1) && (m = !0);
          break;
        case "number":
          Number.isFinite(e) && (m = !0);
          break;
        case "nonFinite":
          typeof e == "number" && !Number.isFinite(e) && (m = !0);
          break;
        case "object":
          e && jl(e) === _ && (m = !0);
          break;
        case "array":
          Array.isArray(e) && (m = !0);
          break;
        case "other":
          m = this.currOtherTypeCallback(e, t, n, r);
          break;
        case "null":
          e === null && (m = !0);
          break;
        default:
          throw new TypeError("Unknown value type " + _);
      }
      if (m)
        return c = {
          path: t,
          value: e,
          parent: n,
          parentProperty: r
        }, this._handleCallback(c, s, "value"), c;
    } else if (d[0] === "`" && e && Uo.call(e, d.slice(1))) {
      var b = d.slice(1);
      f(this._trace(u, e[b], mf(t, b), e, b, s, o, !0));
    } else if (d.includes(",")) {
      var w = d.split(","), y = Uye(w), S;
      try {
        for (y.s(); !(S = y.n()).done; ) {
          var x = S.value;
          f(this._trace(b8(x, u), e, t, n, r, s, !0));
        }
      } catch (I) {
        y.e(I);
      } finally {
        y.f();
      }
    } else !a && e && Uo.call(e, d) && f(this._trace(u, e[d], mf(t, d), e, d, s, o, !0));
  }
  if (this._hasParentSelector)
    for (var D = 0; D < h.length; D++) {
      var E = h[D];
      if (E && E.isParentSelector) {
        var L = this._trace(E.expr, e, E.path, n, r, s, o);
        if (Array.isArray(L)) {
          h[D] = L[0];
          for (var k = L.length, N = 1; N < k; N++)
            D++, h.splice(D, 0, L[N]);
        } else
          h[D] = L;
      }
    }
  return h;
};
li.prototype._walk = function(i, e) {
  if (Array.isArray(i))
    for (var t = i.length, n = 0; n < t; n++)
      e(n);
  else i && jl(i) === "object" && Object.keys(i).forEach(function(r) {
    e(r);
  });
};
li.prototype._slice = function(i, e, t, n, r, s, o) {
  if (Array.isArray(t)) {
    var a = t.length, l = i.split(":"), c = l[2] && Number.parseInt(l[2]) || 1, d = l[0] && Number.parseInt(l[0]) || 0, u = l[1] && Number.parseInt(l[1]) || a;
    d = d < 0 ? Math.max(0, d + a) : Math.min(a, d), u = u < 0 ? Math.max(0, u + a) : Math.min(a, u);
    for (var h = [], f = d; f < u; f += c) {
      var g = this._trace(b8(f, e), t, n, r, s, o, !0);
      g.forEach(function(p) {
        h.push(p);
      });
    }
    return h;
  }
};
li.prototype._eval = function(i, e, t, n, r, s) {
  var o = this;
  this.currSandbox._$_parentProperty = s, this.currSandbox._$_parent = r, this.currSandbox._$_property = t, this.currSandbox._$_root = this.json, this.currSandbox._$_v = e;
  var a = i.includes("@path");
  a && (this.currSandbox._$_path = li.toPathString(n.concat([t])));
  var l = this.currEval + "Script:" + i;
  if (!li.cache[l]) {
    var c = i.replace(/@parentProperty/g, "_$_parentProperty").replace(/@parent/g, "_$_parent").replace(/@property/g, "_$_property").replace(/@root/g, "_$_root").replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, "_$_v$1");
    if (a && (c = c.replace(/@path/g, "_$_path")), this.currEval === "safe" || this.currEval === !0 || this.currEval === void 0)
      li.cache[l] = new this.safeVm.Script(c);
    else if (this.currEval === "native")
      li.cache[l] = new this.vm.Script(c);
    else if (typeof this.currEval == "function" && this.currEval.prototype && Uo.call(this.currEval.prototype, "runInNewContext")) {
      var d = this.currEval;
      li.cache[l] = new d(c);
    } else if (typeof this.currEval == "function")
      li.cache[l] = {
        runInNewContext: function(h) {
          return o.currEval(c, h);
        }
      };
    else
      throw new TypeError('Unknown "eval" property "'.concat(this.currEval, '"'));
  }
  try {
    return li.cache[l].runInNewContext(this.currSandbox);
  } catch (u) {
    if (this.ignoreEvalErrors)
      return !1;
    throw new Error("jsonPath: " + u.message + ": " + i);
  }
};
li.cache = {};
li.toPathString = function(i) {
  for (var e = i, t = e.length, n = "$", r = 1; r < t; r++)
    /^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(e[r]) || (n += /^[\*0-9]+$/.test(e[r]) ? "[" + e[r] + "]" : "['" + e[r] + "']");
  return n;
};
li.toPointer = function(i) {
  for (var e = i, t = e.length, n = "", r = 1; r < t; r++)
    /^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(e[r]) || (n += "/" + e[r].toString().replace(/~/g, "~0").replace(/\//g, "~1"));
  return n;
};
li.toPathArray = function(i) {
  var e = li.cache;
  if (e[i])
    return e[i].concat();
  var t = [], n = i.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]](?!(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])\])/g, function(s, o) {
    return "[#" + (t.push(o) - 1) + "]";
  }).replace(/\[["']((?:[\0-&\(-\\\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)["']\]/g, function(s, o) {
    return "['" + o.replace(/\./g, "%@%").replace(/~/g, "%%@@%%") + "']";
  }).replace(/~/g, ";~;").replace(/["']?\.["']?(?!(?:[\0-Z\\-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\])|\[["']?/g, ";").replace(/%@%/g, ".").replace(/%%@@%%/g, "~").replace(/(?:;)?(\^+)(?:;)?/g, function(s, o) {
    return ";" + o.split("").join(";") + ";";
  }).replace(/;;;|;;/g, ";..;").replace(/;$|'?\]|'$/g, ""), r = n.split(";").map(function(s) {
    var o = s.match(/#([0-9]+)/);
    return !o || !o[1] ? s : t[o[1]];
  });
  return e[i] = r, e[i].concat();
};
var twe = function(e, t, n) {
  for (var r = e.length, s = 0; s < r; s++) {
    var o = e[s];
    n(o) && t.push(e.splice(s--, 1)[0]);
  }
};
t_.plugins.register(Jye, T1);
var nr = {
  /**
   * @param {jsep.Expression} ast
   * @param {Record<string, any>} subs
   */
  evalAst: function(e, t) {
    switch (e.type) {
      case "BinaryExpression":
      case "LogicalExpression":
        return nr.evalBinaryExpression(e, t);
      case "Compound":
        return nr.evalCompound(e, t);
      case "ConditionalExpression":
        return nr.evalConditionalExpression(e, t);
      case "Identifier":
        return nr.evalIdentifier(e, t);
      case "Literal":
        return nr.evalLiteral(e, t);
      case "MemberExpression":
        return nr.evalMemberExpression(e, t);
      case "UnaryExpression":
        return nr.evalUnaryExpression(e, t);
      case "ArrayExpression":
        return nr.evalArrayExpression(e, t);
      case "CallExpression":
        return nr.evalCallExpression(e, t);
      case "AssignmentExpression":
        return nr.evalAssignmentExpression(e, t);
      default:
        throw SyntaxError("Unexpected expression", e);
    }
  },
  evalBinaryExpression: function(e, t) {
    var n = {
      "||": function(s, o) {
        return s || o();
      },
      "&&": function(s, o) {
        return s && o();
      },
      "|": function(s, o) {
        return s | o();
      },
      "^": function(s, o) {
        return s ^ o();
      },
      "&": function(s, o) {
        return s & o();
      },
      // eslint-disable-next-line eqeqeq
      "==": function(s, o) {
        return s == o();
      },
      // eslint-disable-next-line eqeqeq
      "!=": function(s, o) {
        return s != o();
      },
      "===": function(s, o) {
        return s === o();
      },
      "!==": function(s, o) {
        return s !== o();
      },
      "<": function(s, o) {
        return s < o();
      },
      ">": function(s, o) {
        return s > o();
      },
      "<=": function(s, o) {
        return s <= o();
      },
      ">=": function(s, o) {
        return s >= o();
      },
      "<<": function(s, o) {
        return s << o();
      },
      ">>": function(s, o) {
        return s >> o();
      },
      ">>>": function(s, o) {
        return s >>> o();
      },
      "+": function(s, o) {
        return s + o();
      },
      "-": function(s, o) {
        return s - o();
      },
      "*": function(s, o) {
        return s * o();
      },
      "/": function(s, o) {
        return s / o();
      },
      "%": function(s, o) {
        return s % o();
      }
    }[e.operator](nr.evalAst(e.left, t), function() {
      return nr.evalAst(e.right, t);
    });
    return n;
  },
  evalCompound: function(e, t) {
    for (var n, r = 0; r < e.body.length; r++) {
      e.body[r].type === "Identifier" && ["var", "let", "const"].includes(e.body[r].name) && e.body[r + 1] && e.body[r + 1].type === "AssignmentExpression" && (r += 1);
      var s = e.body[r];
      n = nr.evalAst(s, t);
    }
    return n;
  },
  evalConditionalExpression: function(e, t) {
    return nr.evalAst(e.test, t) ? nr.evalAst(e.consequent, t) : nr.evalAst(e.alternate, t);
  },
  evalIdentifier: function(e, t) {
    if (e.name in t)
      return t[e.name];
    throw ReferenceError("".concat(e.name, " is not defined"));
  },
  evalLiteral: function(e) {
    return e.value;
  },
  evalMemberExpression: function(e, t) {
    var n = e.computed ? nr.evalAst(e.property) : e.property.name, r = nr.evalAst(e.object, t), s = r[n];
    return typeof s == "function" ? s.bind(r) : s;
  },
  evalUnaryExpression: function(e, t) {
    var n = {
      "-": function(s) {
        return -nr.evalAst(s, t);
      },
      "!": function(s) {
        return !nr.evalAst(s, t);
      },
      "~": function(s) {
        return ~nr.evalAst(s, t);
      },
      // eslint-disable-next-line no-implicit-coercion
      "+": function(s) {
        return +nr.evalAst(s, t);
      }
    }[e.operator](e.argument);
    return n;
  },
  evalArrayExpression: function(e, t) {
    return e.elements.map(function(n) {
      return nr.evalAst(n, t);
    });
  },
  evalCallExpression: function(e, t) {
    var n = e.arguments.map(function(s) {
      return nr.evalAst(s, t);
    }), r = nr.evalAst(e.callee, t);
    return r.apply(void 0, OW(n));
  },
  evalAssignmentExpression: function(e, t) {
    if (e.left.type !== "Identifier")
      throw SyntaxError("Invalid left-hand side in assignment");
    var n = e.left.name, r = nr.evalAst(e.right, t);
    return t[n] = r, t[n];
  }
}, nwe = /* @__PURE__ */ function() {
  function i(e) {
    tb(this, i), this.code = e, this.ast = t_(this.code);
  }
  return nb(i, [{
    key: "runInNewContext",
    value: function(t) {
      var n = Oye({}, t);
      return nr.evalAst(this.ast, n);
    }
  }]);
}(), iwe = /* @__PURE__ */ function() {
  function i(e) {
    tb(this, i), this.code = e;
  }
  return nb(i, [{
    key: "runInNewContext",
    value: function(t) {
      var n = this.code, r = Object.keys(t), s = [];
      twe(r, s, function(d) {
        return typeof t[d] == "function";
      });
      var o = r.map(function(d) {
        return t[d];
      }), a = s.reduce(function(d, u) {
        var h = t[u].toString();
        return /function/.test(h) || (h = "function " + h), "var " + u + "=" + h + ";" + d;
      }, "");
      n = a + n, !/(["'])use strict\1/.test(n) && !r.includes("arguments") && (n = "var arguments = undefined;" + n), n = n.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "");
      var l = n.lastIndexOf(";"), c = l > -1 ? n.slice(0, l + 1) + " return " + n.slice(l + 1) : " return " + n;
      return Xle(Function, r.concat([c])).apply(void 0, OW(o));
    }
  }]);
}();
li.prototype.vm = {
  Script: iwe
};
li.prototype.safeVm = {
  Script: nwe
};
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */
var rwe = /* @__PURE__ */ function() {
  var i = function(e, t) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
      n.__proto__ = r;
    } || function(n, r) {
      for (var s in r) r.hasOwnProperty(s) && (n[s] = r[s]);
    }, i(e, t);
  };
  return function(e, t) {
    i(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), swe = Object.prototype.hasOwnProperty;
function C8(i, e) {
  return swe.call(i, e);
}
function y8(i) {
  if (Array.isArray(i)) {
    for (var e = new Array(i.length), t = 0; t < e.length; t++)
      e[t] = "" + t;
    return e;
  }
  if (Object.keys)
    return Object.keys(i);
  var n = [];
  for (var r in i)
    C8(i, r) && n.push(r);
  return n;
}
function ll(i) {
  switch (typeof i) {
    case "object":
      return JSON.parse(JSON.stringify(i));
    case "undefined":
      return null;
    default:
      return i;
  }
}
function w8(i) {
  for (var e = 0, t = i.length, n; e < t; ) {
    if (n = i.charCodeAt(e), n >= 48 && n <= 57) {
      e++;
      continue;
    }
    return !1;
  }
  return !0;
}
function Pp(i) {
  return i.indexOf("/") === -1 && i.indexOf("~") === -1 ? i : i.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Jle(i) {
  return i.replace(/~1/g, "/").replace(/~0/g, "~");
}
function S8(i) {
  if (i === void 0)
    return !0;
  if (i) {
    if (Array.isArray(i)) {
      for (var e = 0, t = i.length; e < t; e++)
        if (S8(i[e]))
          return !0;
    } else if (typeof i == "object") {
      for (var n = y8(i), r = n.length, s = 0; s < r; s++)
        if (S8(i[n[s]]))
          return !0;
    }
  }
  return !1;
}
function pK(i, e) {
  var t = [i];
  for (var n in e) {
    var r = typeof e[n] == "object" ? JSON.stringify(e[n], null, 2) : e[n];
    typeof r < "u" && t.push(n + ": " + r);
  }
  return t.join(`
`);
}
var $le = (
  /** @class */
  function(i) {
    rwe(e, i);
    function e(t, n, r, s, o) {
      var a = this.constructor, l = i.call(this, pK(t, { name: n, index: r, operation: s, tree: o })) || this;
      return l.name = n, l.index = r, l.operation = s, l.tree = o, Object.setPrototypeOf(l, a.prototype), l.message = pK(t, { name: n, index: r, operation: s, tree: o }), l;
    }
    return e;
  }(Error)
), Hr = $le, owe = ll, z1 = {
  add: function(i, e, t) {
    return i[e] = this.value, { newDocument: t };
  },
  remove: function(i, e, t) {
    var n = i[e];
    return delete i[e], { newDocument: t, removed: n };
  },
  replace: function(i, e, t) {
    var n = i[e];
    return i[e] = this.value, { newDocument: t, removed: n };
  },
  move: function(i, e, t) {
    var n = xE(t, this.path);
    n && (n = ll(n));
    var r = _m(t, { op: "remove", path: this.from }).removed;
    return _m(t, { op: "add", path: this.path, value: r }), { newDocument: t, removed: n };
  },
  copy: function(i, e, t) {
    var n = xE(t, this.from);
    return _m(t, { op: "add", path: this.path, value: ll(n) }), { newDocument: t };
  },
  test: function(i, e, t) {
    return { newDocument: t, test: ry(i[e], this.value) };
  },
  _get: function(i, e, t) {
    return this.value = i[e], { newDocument: t };
  }
}, awe = {
  add: function(i, e, t) {
    return w8(e) ? i.splice(e, 0, this.value) : i[e] = this.value, { newDocument: t, index: e };
  },
  remove: function(i, e, t) {
    var n = i.splice(e, 1);
    return { newDocument: t, removed: n[0] };
  },
  replace: function(i, e, t) {
    var n = i[e];
    return i[e] = this.value, { newDocument: t, removed: n };
  },
  move: z1.move,
  copy: z1.copy,
  test: z1.test,
  _get: z1._get
};
function xE(i, e) {
  if (e == "")
    return i;
  var t = { op: "_get", path: e };
  return _m(i, t), t.value;
}
function _m(i, e, t, n, r, s) {
  if (t === void 0 && (t = !1), n === void 0 && (n = !0), r === void 0 && (r = !0), s === void 0 && (s = 0), t && (typeof t == "function" ? t(e, 0, i, e.path) : DE(e, 0)), e.path === "") {
    var o = { newDocument: i };
    if (e.op === "add")
      return o.newDocument = e.value, o;
    if (e.op === "replace")
      return o.newDocument = e.value, o.removed = i, o;
    if (e.op === "move" || e.op === "copy")
      return o.newDocument = xE(i, e.from), e.op === "move" && (o.removed = i), o;
    if (e.op === "test") {
      if (o.test = ry(i, e.value), o.test === !1)
        throw new Hr("Test operation failed", "TEST_OPERATION_FAILED", s, e, i);
      return o.newDocument = i, o;
    } else {
      if (e.op === "remove")
        return o.removed = i, o.newDocument = null, o;
      if (e.op === "_get")
        return e.value = i, o;
      if (t)
        throw new Hr("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", s, e, i);
      return o;
    }
  } else {
    n || (i = ll(i));
    var a = e.path || "", l = a.split("/"), c = i, d = 1, u = l.length, h = void 0, f = void 0, g = void 0;
    for (typeof t == "function" ? g = t : g = DE; ; ) {
      if (f = l[d], f && f.indexOf("~") != -1 && (f = Jle(f)), r && (f == "__proto__" || f == "prototype" && d > 0 && l[d - 1] == "constructor"))
        throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
      if (t && h === void 0 && (c[f] === void 0 ? h = l.slice(0, d).join("/") : d == u - 1 && (h = e.path), h !== void 0 && g(e, 0, i, h)), d++, Array.isArray(c)) {
        if (f === "-")
          f = c.length;
        else {
          if (t && !w8(f))
            throw new Hr("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", s, e, i);
          w8(f) && (f = ~~f);
        }
        if (d >= u) {
          if (t && e.op === "add" && f > c.length)
            throw new Hr("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", s, e, i);
          var o = awe[e.op].call(e, c, f, i);
          if (o.test === !1)
            throw new Hr("Test operation failed", "TEST_OPERATION_FAILED", s, e, i);
          return o;
        }
      } else if (d >= u) {
        var o = z1[e.op].call(e, c, f, i);
        if (o.test === !1)
          throw new Hr("Test operation failed", "TEST_OPERATION_FAILED", s, e, i);
        return o;
      }
      if (c = c[f], t && d < u && (!c || typeof c != "object"))
        throw new Hr("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", s, e, i);
    }
  }
}
function _A(i, e, t, n, r) {
  if (n === void 0 && (n = !0), r === void 0 && (r = !0), t && !Array.isArray(e))
    throw new Hr("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
  n || (i = ll(i));
  for (var s = new Array(e.length), o = 0, a = e.length; o < a; o++)
    s[o] = _m(i, e[o], t, !0, r, o), i = s[o].newDocument;
  return s.newDocument = i, s;
}
function lwe(i, e, t) {
  var n = _m(i, e);
  if (n.test === !1)
    throw new Hr("Test operation failed", "TEST_OPERATION_FAILED", t, e, i);
  return n.newDocument;
}
function DE(i, e, t, n) {
  if (typeof i != "object" || i === null || Array.isArray(i))
    throw new Hr("Operation is not an object", "OPERATION_NOT_AN_OBJECT", e, i, t);
  if (z1[i.op]) {
    if (typeof i.path != "string")
      throw new Hr("Operation `path` property is not a string", "OPERATION_PATH_INVALID", e, i, t);
    if (i.path.indexOf("/") !== 0 && i.path.length > 0)
      throw new Hr('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", e, i, t);
    if ((i.op === "move" || i.op === "copy") && typeof i.from != "string")
      throw new Hr("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", e, i, t);
    if ((i.op === "add" || i.op === "replace" || i.op === "test") && i.value === void 0)
      throw new Hr("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", e, i, t);
    if ((i.op === "add" || i.op === "replace" || i.op === "test") && S8(i.value))
      throw new Hr("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", e, i, t);
    if (t) {
      if (i.op == "add") {
        var r = i.path.split("/").length, s = n.split("/").length;
        if (r !== s + 1 && r !== s)
          throw new Hr("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", e, i, t);
      } else if (i.op === "replace" || i.op === "remove" || i.op === "_get") {
        if (i.path !== n)
          throw new Hr("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", e, i, t);
      } else if (i.op === "move" || i.op === "copy") {
        var o = { op: "_get", path: i.from, value: void 0 }, a = ece([o], t);
        if (a && a.name === "OPERATION_PATH_UNRESOLVABLE")
          throw new Hr("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", e, i, t);
      }
    }
  } else throw new Hr("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", e, i, t);
}
function ece(i, e, t) {
  try {
    if (!Array.isArray(i))
      throw new Hr("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    if (e)
      _A(ll(e), ll(i), t || !0);
    else {
      t = t || DE;
      for (var n = 0; n < i.length; n++)
        t(i[n], n, e, void 0);
    }
  } catch (r) {
    if (r instanceof Hr)
      return r;
    throw r;
  }
}
function ry(i, e) {
  if (i === e)
    return !0;
  if (i && e && typeof i == "object" && typeof e == "object") {
    var t = Array.isArray(i), n = Array.isArray(e), r, s, o;
    if (t && n) {
      if (s = i.length, s != e.length)
        return !1;
      for (r = s; r-- !== 0; )
        if (!ry(i[r], e[r]))
          return !1;
      return !0;
    }
    if (t != n)
      return !1;
    var a = Object.keys(i);
    if (s = a.length, s !== Object.keys(e).length)
      return !1;
    for (r = s; r-- !== 0; )
      if (!e.hasOwnProperty(a[r]))
        return !1;
    for (r = s; r-- !== 0; )
      if (o = a[r], !ry(i[o], e[o]))
        return !1;
    return !0;
  }
  return i !== i && e !== e;
}
const cwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  JsonPatchError: Hr,
  _areEquals: ry,
  applyOperation: _m,
  applyPatch: _A,
  applyReducer: lwe,
  deepClone: owe,
  getValueByPointer: xE,
  validate: ece,
  validator: DE
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2021 Joachim Wester
 * MIT license
 */
var MW = /* @__PURE__ */ new WeakMap(), dwe = (
  /** @class */
  /* @__PURE__ */ function() {
    function i(e) {
      this.observers = /* @__PURE__ */ new Map(), this.obj = e;
    }
    return i;
  }()
), uwe = (
  /** @class */
  /* @__PURE__ */ function() {
    function i(e, t) {
      this.callback = e, this.observer = t;
    }
    return i;
  }()
);
function hwe(i) {
  return MW.get(i);
}
function fwe(i, e) {
  return i.observers.get(e);
}
function gwe(i, e) {
  i.observers.delete(e.callback);
}
function pwe(i, e) {
  e.unobserve();
}
function mwe(i, e) {
  var t = [], n, r = hwe(i);
  if (!r)
    r = new dwe(i), MW.set(i, r);
  else {
    var s = fwe(r, e);
    n = s && s.observer;
  }
  if (n)
    return n;
  if (n = {}, r.value = ll(i), e) {
    n.callback = e, n.next = null;
    var o = function() {
      x8(n);
    }, a = function() {
      clearTimeout(n.next), n.next = setTimeout(o);
    };
    typeof window < "u" && (window.addEventListener("mouseup", a), window.addEventListener("keyup", a), window.addEventListener("mousedown", a), window.addEventListener("keydown", a), window.addEventListener("change", a));
  }
  return n.patches = t, n.object = i, n.unobserve = function() {
    x8(n), clearTimeout(n.next), gwe(r, n), typeof window < "u" && (window.removeEventListener("mouseup", a), window.removeEventListener("keyup", a), window.removeEventListener("mousedown", a), window.removeEventListener("keydown", a), window.removeEventListener("change", a));
  }, r.observers.set(e, new uwe(e, n)), n;
}
function x8(i, e) {
  e === void 0 && (e = !1);
  var t = MW.get(i.object);
  RW(t.value, i.object, i.patches, "", e), i.patches.length && _A(t.value, i.patches);
  var n = i.patches;
  return n.length > 0 && (i.patches = [], i.callback && i.callback(n)), n;
}
function RW(i, e, t, n, r) {
  if (e !== i) {
    typeof e.toJSON == "function" && (e = e.toJSON());
    for (var s = y8(e), o = y8(i), a = !1, l = o.length - 1; l >= 0; l--) {
      var c = o[l], d = i[c];
      if (C8(e, c) && !(e[c] === void 0 && d !== void 0 && Array.isArray(e) === !1)) {
        var u = e[c];
        typeof d == "object" && d != null && typeof u == "object" && u != null && Array.isArray(d) === Array.isArray(u) ? RW(d, u, t, n + "/" + Pp(c), r) : d !== u && (r && t.push({ op: "test", path: n + "/" + Pp(c), value: ll(d) }), t.push({ op: "replace", path: n + "/" + Pp(c), value: ll(u) }));
      } else Array.isArray(i) === Array.isArray(e) ? (r && t.push({ op: "test", path: n + "/" + Pp(c), value: ll(d) }), t.push({ op: "remove", path: n + "/" + Pp(c) }), a = !0) : (r && t.push({ op: "test", path: n, value: i }), t.push({ op: "replace", path: n, value: e }));
    }
    if (!(!a && s.length == o.length))
      for (var l = 0; l < s.length; l++) {
        var c = s[l];
        !C8(i, c) && e[c] !== void 0 && t.push({ op: "add", path: n + "/" + Pp(c), value: ll(e[c]) });
      }
  }
}
function tce(i, e, t) {
  t === void 0 && (t = !1);
  var n = [];
  return RW(i, e, n, "", t), n;
}
const vwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compare: tce,
  generate: x8,
  observe: mwe,
  unobserve: pwe
}, Symbol.toStringTag, { value: "Module" }));
Object.assign({}, cwe, vwe, {
  JsonPatchError: $le,
  deepClone: ll,
  escapePathComponent: Pp,
  unescapePathComponent: Jle
});
const _we = Object.prototype.toString;
function bwe(i, e) {
  return _we.call(i) === `[object ${e}]`;
}
function nce(i) {
  return bwe(i, "Object");
}
function FW(i) {
  return !!(i && i.then && typeof i.then == "function");
}
function Cx(i) {
  return i && i.Math == Math ? i : void 0;
}
const Xc = typeof globalThis == "object" && Cx(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && Cx(window) || typeof self == "object" && Cx(self) || typeof global == "object" && Cx(global) || /* @__PURE__ */ function() {
  return this;
}() || {};
function ice(i, e, t) {
  const n = t || Xc, r = n.__SENTRY__ = n.__SENTRY__ || {};
  return r[i] || (r[i] = e());
}
const Cwe = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, ywe = "Sentry Logger ", mK = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], vK = {};
function rce(i) {
  if (!("console" in Xc))
    return i();
  const e = Xc.console, t = {}, n = Object.keys(vK);
  n.forEach((r) => {
    const s = vK[r];
    t[r] = e[r], e[r] = s;
  });
  try {
    return i();
  } finally {
    n.forEach((r) => {
      e[r] = t[r];
    });
  }
}
function wwe() {
  let i = !1;
  const e = {
    enable: () => {
      i = !0;
    },
    disable: () => {
      i = !1;
    },
    isEnabled: () => i
  };
  return Cwe ? mK.forEach((t) => {
    e[t] = (...n) => {
      i && rce(() => {
        Xc.console[t](`${ywe}[${t}]:`, ...n);
      });
    };
  }) : mK.forEach((t) => {
    e[t] = () => {
    };
  }), e;
}
const Uf = wwe();
function sm(i) {
  return D8(i, /* @__PURE__ */ new Map());
}
function D8(i, e) {
  if (Swe(i)) {
    const t = e.get(i);
    if (t !== void 0)
      return t;
    const n = {};
    e.set(i, n);
    for (const r of Object.keys(i))
      typeof i[r] < "u" && (n[r] = D8(i[r], e));
    return n;
  }
  if (Array.isArray(i)) {
    const t = e.get(i);
    if (t !== void 0)
      return t;
    const n = [];
    return e.set(i, n), i.forEach((r) => {
      n.push(D8(r, e));
    }), n;
  }
  return i;
}
function Swe(i) {
  if (!nce(i))
    return !1;
  try {
    const e = Object.getPrototypeOf(i).constructor.name;
    return !e || e === "Object";
  } catch {
    return !0;
  }
}
function su() {
  const i = Xc, e = i.crypto || i.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (t = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (t() & 15) >> n / 4).toString(16)
    )
  );
}
function xwe(i) {
  return Array.isArray(i) ? i : [i];
}
var Ju;
(function(i) {
  i[i.PENDING = 0] = "PENDING";
  const t = 1;
  i[i.RESOLVED = t] = "RESOLVED";
  const n = 2;
  i[i.REJECTED = n] = "REJECTED";
})(Ju || (Ju = {}));
class Of {
  constructor(e) {
    Of.prototype.__init.call(this), Of.prototype.__init2.call(this), Of.prototype.__init3.call(this), Of.prototype.__init4.call(this), this._state = Ju.PENDING, this._handlers = [];
    try {
      e(this._resolve, this._reject);
    } catch (t) {
      this._reject(t);
    }
  }
  /** JSDoc */
  then(e, t) {
    return new Of((n, r) => {
      this._handlers.push([
        !1,
        (s) => {
          if (!e)
            n(s);
          else
            try {
              n(e(s));
            } catch (o) {
              r(o);
            }
        },
        (s) => {
          if (!t)
            r(s);
          else
            try {
              n(t(s));
            } catch (o) {
              r(o);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(e) {
    return this.then((t) => t, e);
  }
  /** JSDoc */
  finally(e) {
    return new Of((t, n) => {
      let r, s;
      return this.then(
        (o) => {
          s = !1, r = o, e && e();
        },
        (o) => {
          s = !0, r = o, e && e();
        }
      ).then(() => {
        if (s) {
          n(r);
          return;
        }
        t(r);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (e) => {
      this._setResult(Ju.RESOLVED, e);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (e) => {
      this._setResult(Ju.REJECTED, e);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (e, t) => {
      if (this._state === Ju.PENDING) {
        if (FW(t)) {
          t.then(this._resolve, this._reject);
          return;
        }
        this._state = e, this._value = t, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === Ju.PENDING)
        return;
      const e = this._handlers.slice();
      this._handlers = [], e.forEach((t) => {
        t[0] || (this._state === Ju.RESOLVED && t[1](this._value), this._state === Ju.REJECTED && t[2](this._value), t[0] = !0);
      });
    };
  }
}
const sce = 1e3;
function BW() {
  return Date.now() / sce;
}
function Dwe() {
  const { performance: i } = Xc;
  if (!i || !i.now)
    return BW;
  const e = Date.now() - i.now(), t = i.timeOrigin == null ? e : i.timeOrigin;
  return () => (t + i.now()) / sce;
}
const oce = Dwe();
(() => {
  const { performance: i } = Xc;
  if (!i || !i.now)
    return;
  const e = 3600 * 1e3, t = i.now(), n = Date.now(), r = i.timeOrigin ? Math.abs(i.timeOrigin + t - n) : e, s = r < e, o = i.timing && i.timing.navigationStart, l = typeof o == "number" ? Math.abs(o + t - n) : e, c = l < e;
  return s || c ? r <= l ? i.timeOrigin : o : n;
})();
const m3 = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, ace = "production";
function Ewe() {
  return ice("globalEventProcessors", () => []);
}
function E8(i, e, t, n = 0) {
  return new Of((r, s) => {
    const o = i[n];
    if (e === null || typeof o != "function")
      r(e);
    else {
      const a = o({ ...e }, t);
      m3 && o.id && a === null && Uf.log(`Event processor "${o.id}" dropped event`), FW(a) ? a.then((l) => E8(i, l, t, n + 1).then(r)).then(null, s) : E8(i, a, t, n + 1).then(r).then(null, s);
    }
  });
}
function Lwe(i) {
  const e = oce(), t = {
    sid: su(),
    init: !0,
    timestamp: e,
    started: e,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => Awe(t)
  };
  return i && bA(t, i), t;
}
function bA(i, e = {}) {
  if (e.user && (!i.ipAddress && e.user.ip_address && (i.ipAddress = e.user.ip_address), !i.did && !e.did && (i.did = e.user.id || e.user.email || e.user.username)), i.timestamp = e.timestamp || oce(), e.abnormal_mechanism && (i.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (i.ignoreDuration = e.ignoreDuration), e.sid && (i.sid = e.sid.length === 32 ? e.sid : su()), e.init !== void 0 && (i.init = e.init), !i.did && e.did && (i.did = `${e.did}`), typeof e.started == "number" && (i.started = e.started), i.ignoreDuration)
    i.duration = void 0;
  else if (typeof e.duration == "number")
    i.duration = e.duration;
  else {
    const t = i.timestamp - i.started;
    i.duration = t >= 0 ? t : 0;
  }
  e.release && (i.release = e.release), e.environment && (i.environment = e.environment), !i.ipAddress && e.ipAddress && (i.ipAddress = e.ipAddress), !i.userAgent && e.userAgent && (i.userAgent = e.userAgent), typeof e.errors == "number" && (i.errors = e.errors), e.status && (i.status = e.status);
}
function Iwe(i, e) {
  let t = {};
  i.status === "ok" && (t = { status: "exited" }), bA(i, t);
}
function Awe(i) {
  return sm({
    sid: `${i.sid}`,
    init: i.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(i.started * 1e3).toISOString(),
    timestamp: new Date(i.timestamp * 1e3).toISOString(),
    status: i.status,
    errors: i.errors,
    did: typeof i.did == "number" || typeof i.did == "string" ? `${i.did}` : void 0,
    duration: i.duration,
    abnormal_mechanism: i.abnormal_mechanism,
    attrs: {
      release: i.release,
      environment: i.environment,
      ip_address: i.ipAddress,
      user_agent: i.userAgent
    }
  });
}
const kwe = 1;
function Twe(i) {
  const { spanId: e, traceId: t } = i.spanContext(), { data: n, op: r, parent_span_id: s, status: o, tags: a, origin: l } = EE(i);
  return sm({
    data: n,
    op: r,
    parent_span_id: s,
    span_id: e,
    status: o,
    tags: a,
    trace_id: t,
    origin: l
  });
}
function EE(i) {
  return Nwe(i) ? i.getSpanJSON() : typeof i.toJSON == "function" ? i.toJSON() : {};
}
function Nwe(i) {
  return typeof i.getSpanJSON == "function";
}
function Pwe(i) {
  const { traceFlags: e } = i.spanContext();
  return !!(e & kwe);
}
function Owe(i) {
  if (i)
    return Mwe(i) ? { captureContext: i } : Fwe(i) ? {
      captureContext: i
    } : i;
}
function Mwe(i) {
  return i instanceof bm || typeof i == "function";
}
const Rwe = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Fwe(i) {
  return Object.keys(i).some((e) => Rwe.includes(e));
}
function lce(i, e) {
  return VW().captureException(i, Owe(e));
}
function Bwe() {
  return VW().getClient();
}
function Vwe() {
  return VW().getScope();
}
function cce(i) {
  return i.transaction;
}
function Hwe(i, e, t) {
  const n = e.getOptions(), { publicKey: r } = e.getDsn() || {}, { segment: s } = t && t.getUser() || {}, o = sm({
    environment: n.environment || ace,
    release: n.release,
    user_segment: s,
    public_key: r,
    trace_id: i
  });
  return e.emit && e.emit("createDsc", o), o;
}
function Wwe(i) {
  const e = Bwe();
  if (!e)
    return {};
  const t = Hwe(EE(i).trace_id || "", e, Vwe()), n = cce(i);
  if (!n)
    return t;
  const r = n && n._frozenDynamicSamplingContext;
  if (r)
    return r;
  const { sampleRate: s, source: o } = n.metadata;
  s != null && (t.sample_rate = `${s}`);
  const a = EE(n);
  return o && o !== "url" && (t.transaction = a.description), t.sampled = String(Pwe(n)), e.emit && e.emit("createDsc", t), t;
}
function jwe(i, e) {
  const { fingerprint: t, span: n, breadcrumbs: r, sdkProcessingMetadata: s } = e;
  zwe(i, e), n && qwe(i, n), Kwe(i, t), Uwe(i, r), Gwe(i, s);
}
function zwe(i, e) {
  const {
    extra: t,
    tags: n,
    user: r,
    contexts: s,
    level: o,
    // eslint-disable-next-line deprecation/deprecation
    transactionName: a
  } = e, l = sm(t);
  l && Object.keys(l).length && (i.extra = { ...l, ...i.extra });
  const c = sm(n);
  c && Object.keys(c).length && (i.tags = { ...c, ...i.tags });
  const d = sm(r);
  d && Object.keys(d).length && (i.user = { ...d, ...i.user });
  const u = sm(s);
  u && Object.keys(u).length && (i.contexts = { ...u, ...i.contexts }), o && (i.level = o), a && (i.transaction = a);
}
function Uwe(i, e) {
  const t = [...i.breadcrumbs || [], ...e];
  i.breadcrumbs = t.length ? t : void 0;
}
function Gwe(i, e) {
  i.sdkProcessingMetadata = {
    ...i.sdkProcessingMetadata,
    ...e
  };
}
function qwe(i, e) {
  i.contexts = { trace: Twe(e), ...i.contexts };
  const t = cce(e);
  if (t) {
    i.sdkProcessingMetadata = {
      dynamicSamplingContext: Wwe(e),
      ...i.sdkProcessingMetadata
    };
    const n = EE(t).description;
    n && (i.tags = { transaction: n, ...i.tags });
  }
}
function Kwe(i, e) {
  i.fingerprint = i.fingerprint ? xwe(i.fingerprint) : [], e && (i.fingerprint = i.fingerprint.concat(e)), i.fingerprint && !i.fingerprint.length && delete i.fingerprint;
}
const Ywe = 100;
class bm {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /**
   * Transaction Name
   */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = _K();
  }
  /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */
  static clone(e) {
    return e ? e.clone() : new bm();
  }
  /**
   * Clone this scope instance.
   */
  clone() {
    const e = new bm();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, e._user = this._user, e._level = this._level, e._span = this._span, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e;
  }
  /** Update the client on the scope. */
  setClient(e) {
    this._client = e;
  }
  /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */
  getClient() {
    return this._client;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      segment: void 0,
      username: void 0
    }, this._session && bA(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, t) {
    return this._tags = { ...this._tags, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, t) {
    return this._extra = { ...this._extra, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope for future events.
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, t) {
    return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */
  setSpan(e) {
    return this._span = e, this._notifyScopeListeners(), this;
  }
  /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */
  getSpan() {
    return this._span;
  }
  /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */
  getTransaction() {
    const e = this._span;
    return e && e.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const t = typeof e == "function" ? e(this) : e;
    if (t instanceof bm) {
      const n = t.getScopeData();
      this._tags = { ...this._tags, ...n.tags }, this._extra = { ...this._extra, ...n.extra }, this._contexts = { ...this._contexts, ...n.contexts }, n.user && Object.keys(n.user).length && (this._user = n.user), n.level && (this._level = n.level), n.fingerprint.length && (this._fingerprint = n.fingerprint), t.getRequestSession() && (this._requestSession = t.getRequestSession()), n.propagationContext && (this._propagationContext = n.propagationContext);
    } else if (nce(t)) {
      const n = e;
      this._tags = { ...this._tags, ...n.tags }, this._extra = { ...this._extra, ...n.extra }, this._contexts = { ...this._contexts, ...n.contexts }, n.user && (this._user = n.user), n.level && (this._level = n.level), n.fingerprint && (this._fingerprint = n.fingerprint), n.requestSession && (this._requestSession = n.requestSession), n.propagationContext && (this._propagationContext = n.propagationContext);
    }
    return this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this._propagationContext = _K(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, t) {
    const n = typeof t == "number" ? t : Ywe;
    if (n <= 0)
      return this;
    const r = {
      timestamp: BW(),
      ...e
    }, s = this._breadcrumbs;
    return s.push(r), this._breadcrumbs = s.length > n ? s.slice(-n) : s, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */
  getAttachments() {
    return this.getScopeData().attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    const {
      _breadcrumbs: e,
      _attachments: t,
      _contexts: n,
      _tags: r,
      _extra: s,
      _user: o,
      _level: a,
      _fingerprint: l,
      _eventProcessors: c,
      _propagationContext: d,
      _sdkProcessingMetadata: u,
      _transactionName: h,
      _span: f
    } = this;
    return {
      breadcrumbs: e,
      attachments: t,
      contexts: n,
      tags: r,
      extra: s,
      user: o,
      level: a,
      fingerprint: l || [],
      eventProcessors: c,
      propagationContext: d,
      sdkProcessingMetadata: u,
      transactionName: h,
      span: f
    };
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */
  applyToEvent(e, t = {}, n = []) {
    jwe(e, this.getScopeData());
    const r = [
      ...n,
      // eslint-disable-next-line deprecation/deprecation
      ...Ewe(),
      ...this._eventProcessors
    ];
    return E8(r, e, t);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = e, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */
  captureException(e, t) {
    const n = t && t.event_id ? t.event_id : su();
    if (!this._client)
      return Uf.warn("No client configured on scope - will not capture exception!"), n;
    const r = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: r,
        ...t,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */
  captureMessage(e, t, n) {
    const r = n && n.event_id ? n.event_id : su();
    if (!this._client)
      return Uf.warn("No client configured on scope - will not capture message!"), r;
    const s = new Error(e);
    return this._client.captureMessage(
      e,
      t,
      {
        originalException: e,
        syntheticException: s,
        ...n,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */
  captureEvent(e, t) {
    const n = t && t.event_id ? t.event_id : su();
    return this._client ? (this._client.captureEvent(e, { ...t, event_id: n }, this), n) : (Uf.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
function _K() {
  return {
    traceId: su(),
    spanId: su().substring(16)
  };
}
const Xwe = "7.118.0", dce = parseFloat(Xwe), Zwe = 100;
class uce {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */
  constructor(e, t, n, r = dce) {
    this._version = r;
    let s;
    t ? s = t : (s = new bm(), s.setClient(e));
    let o;
    n ? o = n : (o = new bm(), o.setClient(e)), this._stack = [{ scope: s }], e && this.bindClient(e), this._isolationScope = o;
  }
  /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */
  isOlderThan(e) {
    return this._version < e;
  }
  /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */
  bindClient(e) {
    const t = this.getStackTop();
    t.client = e, t.scope.setClient(e), e && e.setupIntegrations && e.setupIntegrations();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  pushScope() {
    const e = this.getScope().clone();
    return this.getStack().push({
      // eslint-disable-next-line deprecation/deprecation
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  popScope() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */
  withScope(e) {
    const t = this.pushScope();
    let n;
    try {
      n = e(t);
    } catch (r) {
      throw this.popScope(), r;
    }
    return FW(n) ? n.then(
      (r) => (this.popScope(), r),
      (r) => {
        throw this.popScope(), r;
      }
    ) : (this.popScope(), n);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */
  getStack() {
    return this._stack;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */
  captureException(e, t) {
    const n = this._lastEventId = t && t.event_id ? t.event_id : su(), r = new Error("Sentry syntheticException");
    return this.getScope().captureException(e, {
      originalException: e,
      syntheticException: r,
      ...t,
      event_id: n
    }), n;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */
  captureMessage(e, t, n) {
    const r = this._lastEventId = n && n.event_id ? n.event_id : su(), s = new Error(e);
    return this.getScope().captureMessage(e, t, {
      originalException: e,
      syntheticException: s,
      ...n,
      event_id: r
    }), r;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */
  captureEvent(e, t) {
    const n = t && t.event_id ? t.event_id : su();
    return e.type || (this._lastEventId = n), this.getScope().captureEvent(e, { ...t, event_id: n }), n;
  }
  /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */
  addBreadcrumb(e, t) {
    const { scope: n, client: r } = this.getStackTop();
    if (!r) return;
    const { beforeBreadcrumb: s = null, maxBreadcrumbs: o = Zwe } = r.getOptions && r.getOptions() || {};
    if (o <= 0) return;
    const l = { timestamp: BW(), ...e }, c = s ? rce(() => s(l, t)) : l;
    c !== null && (r.emit && r.emit("beforeAddBreadcrumb", c, t), n.addBreadcrumb(c, o));
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */
  setUser(e) {
    this.getScope().setUser(e), this.getIsolationScope().setUser(e);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */
  setTags(e) {
    this.getScope().setTags(e), this.getIsolationScope().setTags(e);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */
  setExtras(e) {
    this.getScope().setExtras(e), this.getIsolationScope().setExtras(e);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */
  setTag(e, t) {
    this.getScope().setTag(e, t), this.getIsolationScope().setTag(e, t);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */
  setExtra(e, t) {
    this.getScope().setExtra(e, t), this.getIsolationScope().setExtra(e, t);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(e, t) {
    this.getScope().setContext(e, t), this.getIsolationScope().setContext(e, t);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */
  configureScope(e) {
    const { scope: t, client: n } = this.getStackTop();
    n && e(t);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  run(e) {
    const t = bK(this);
    try {
      e(this);
    } finally {
      bK(t);
    }
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */
  getIntegration(e) {
    const t = this.getClient();
    if (!t) return null;
    try {
      return t.getIntegration(e);
    } catch {
      return m3 && Uf.warn(`Cannot retrieve integration ${e.id} from the current Hub`), null;
    }
  }
  /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
  startTransaction(e, t) {
    const n = this._callExtensionMethod("startTransaction", e, t);
    return m3 && !n && (this.getClient() ? Uf.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`) : Uf.warn(
      "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'"
    )), n;
  }
  /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */
  captureSession(e = !1) {
    if (e)
      return this.endSession();
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */
  endSession() {
    const t = this.getStackTop().scope, n = t.getSession();
    n && Iwe(n), this._sendSessionUpdate(), t.setSession();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */
  startSession(e) {
    const { scope: t, client: n } = this.getStackTop(), { release: r, environment: s = ace } = n && n.getOptions() || {}, { userAgent: o } = Xc.navigator || {}, a = Lwe({
      release: r,
      environment: s,
      user: t.getUser(),
      ...o && { userAgent: o },
      ...e
    }), l = t.getSession && t.getSession();
    return l && l.status === "ok" && bA(l, { status: "exited" }), this.endSession(), t.setSession(a), a;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */
  shouldSendDefaultPii() {
    const e = this.getClient(), t = e && e.getOptions();
    return !!(t && t.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope: e, client: t } = this.getStackTop(), n = e.getSession();
    n && t && t.captureSession && t.captureSession(n);
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(e, ...t) {
    const r = CA().__SENTRY__;
    if (r && r.extensions && typeof r.extensions[e] == "function")
      return r.extensions[e].apply(this, t);
    m3 && Uf.warn(`Extension method ${e} couldn't be found, doing nothing.`);
  }
}
function CA() {
  return Xc.__SENTRY__ = Xc.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, Xc;
}
function bK(i) {
  const e = CA(), t = L8(e);
  return hce(e, i), t;
}
function VW() {
  const i = CA();
  if (i.__SENTRY__ && i.__SENTRY__.acs) {
    const e = i.__SENTRY__.acs.getCurrentHub();
    if (e)
      return e;
  }
  return Qwe(i);
}
function Qwe(i = CA()) {
  return (!Jwe(i) || // eslint-disable-next-line deprecation/deprecation
  L8(i).isOlderThan(dce)) && hce(i, new uce()), L8(i);
}
function Jwe(i) {
  return !!(i && i.__SENTRY__ && i.__SENTRY__.hub);
}
function L8(i) {
  return ice("hub", () => new uce(), i);
}
function hce(i, e) {
  if (!i) return !1;
  const t = i.__SENTRY__ = i.__SENTRY__ || {};
  return t.hub = e, !0;
}
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var fce;
function st() {
  return fce.apply(null, arguments);
}
function $we(i) {
  fce = i;
}
function rd(i) {
  return i instanceof Array || Object.prototype.toString.call(i) === "[object Array]";
}
function Cm(i) {
  return i != null && Object.prototype.toString.call(i) === "[object Object]";
}
function ui(i, e) {
  return Object.prototype.hasOwnProperty.call(i, e);
}
function HW(i) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(i).length === 0;
  var e;
  for (e in i)
    if (ui(i, e))
      return !1;
  return !0;
}
function ba(i) {
  return i === void 0;
}
function Kh(i) {
  return typeof i == "number" || Object.prototype.toString.call(i) === "[object Number]";
}
function oS(i) {
  return i instanceof Date || Object.prototype.toString.call(i) === "[object Date]";
}
function gce(i, e) {
  var t = [], n, r = i.length;
  for (n = 0; n < r; ++n)
    t.push(e(i[n], n));
  return t;
}
function Gf(i, e) {
  for (var t in e)
    ui(e, t) && (i[t] = e[t]);
  return ui(e, "toString") && (i.toString = e.toString), ui(e, "valueOf") && (i.valueOf = e.valueOf), i;
}
function Nu(i, e, t, n) {
  return Fce(i, e, t, n, !0).utc();
}
function eSe() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Tn(i) {
  return i._pf == null && (i._pf = eSe()), i._pf;
}
var I8;
Array.prototype.some ? I8 = Array.prototype.some : I8 = function(i) {
  var e = Object(this), t = e.length >>> 0, n;
  for (n = 0; n < t; n++)
    if (n in e && i.call(this, e[n], n, e))
      return !0;
  return !1;
};
function WW(i) {
  var e = null, t = !1, n = i._d && !isNaN(i._d.getTime());
  if (n && (e = Tn(i), t = I8.call(e.parsedDateParts, function(r) {
    return r != null;
  }), n = e.overflow < 0 && !e.empty && !e.invalidEra && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && t), i._strict && (n = n && e.charsLeftOver === 0 && e.unusedTokens.length === 0 && e.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(i))
    i._isValid = n;
  else
    return n;
  return i._isValid;
}
function yA(i) {
  var e = Nu(NaN);
  return i != null ? Gf(Tn(e), i) : Tn(e).userInvalidated = !0, e;
}
var CK = st.momentProperties = [], kk = !1;
function jW(i, e) {
  var t, n, r, s = CK.length;
  if (ba(e._isAMomentObject) || (i._isAMomentObject = e._isAMomentObject), ba(e._i) || (i._i = e._i), ba(e._f) || (i._f = e._f), ba(e._l) || (i._l = e._l), ba(e._strict) || (i._strict = e._strict), ba(e._tzm) || (i._tzm = e._tzm), ba(e._isUTC) || (i._isUTC = e._isUTC), ba(e._offset) || (i._offset = e._offset), ba(e._pf) || (i._pf = Tn(e)), ba(e._locale) || (i._locale = e._locale), s > 0)
    for (t = 0; t < s; t++)
      n = CK[t], r = e[n], ba(r) || (i[n] = r);
  return i;
}
function aS(i) {
  jW(this, i), this._d = new Date(i._d != null ? i._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), kk === !1 && (kk = !0, st.updateOffset(this), kk = !1);
}
function sd(i) {
  return i instanceof aS || i != null && i._isAMomentObject != null;
}
function pce(i) {
  st.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + i);
}
function cc(i, e) {
  var t = !0;
  return Gf(function() {
    if (st.deprecationHandler != null && st.deprecationHandler(null, i), t) {
      var n = [], r, s, o, a = arguments.length;
      for (s = 0; s < a; s++) {
        if (r = "", typeof arguments[s] == "object") {
          r += `
[` + s + "] ";
          for (o in arguments[0])
            ui(arguments[0], o) && (r += o + ": " + arguments[0][o] + ", ");
          r = r.slice(0, -2);
        } else
          r = arguments[s];
        n.push(r);
      }
      pce(
        i + `
Arguments: ` + Array.prototype.slice.call(n).join("") + `
` + new Error().stack
      ), t = !1;
    }
    return e.apply(this, arguments);
  }, e);
}
var yK = {};
function mce(i, e) {
  st.deprecationHandler != null && st.deprecationHandler(i, e), yK[i] || (pce(e), yK[i] = !0);
}
st.suppressDeprecationWarnings = !1;
st.deprecationHandler = null;
function Pu(i) {
  return typeof Function < "u" && i instanceof Function || Object.prototype.toString.call(i) === "[object Function]";
}
function tSe(i) {
  var e, t;
  for (t in i)
    ui(i, t) && (e = i[t], Pu(e) ? this[t] = e : this["_" + t] = e);
  this._config = i, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function A8(i, e) {
  var t = Gf({}, i), n;
  for (n in e)
    ui(e, n) && (Cm(i[n]) && Cm(e[n]) ? (t[n] = {}, Gf(t[n], i[n]), Gf(t[n], e[n])) : e[n] != null ? t[n] = e[n] : delete t[n]);
  for (n in i)
    ui(i, n) && !ui(e, n) && Cm(i[n]) && (t[n] = Gf({}, t[n]));
  return t;
}
function zW(i) {
  i != null && this.set(i);
}
var k8;
Object.keys ? k8 = Object.keys : k8 = function(i) {
  var e, t = [];
  for (e in i)
    ui(i, e) && t.push(e);
  return t;
};
var nSe = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function iSe(i, e, t) {
  var n = this._calendar[i] || this._calendar.sameElse;
  return Pu(n) ? n.call(e, t) : n;
}
function pu(i, e, t) {
  var n = "" + Math.abs(i), r = e - n.length, s = i >= 0;
  return (s ? t ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + n;
}
var UW = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, yx = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Tk = {}, yv = {};
function Ut(i, e, t, n) {
  var r = n;
  typeof n == "string" && (r = function() {
    return this[n]();
  }), i && (yv[i] = r), e && (yv[e[0]] = function() {
    return pu(r.apply(this, arguments), e[1], e[2]);
  }), t && (yv[t] = function() {
    return this.localeData().ordinal(
      r.apply(this, arguments),
      i
    );
  });
}
function rSe(i) {
  return i.match(/\[[\s\S]/) ? i.replace(/^\[|\]$/g, "") : i.replace(/\\/g, "");
}
function sSe(i) {
  var e = i.match(UW), t, n;
  for (t = 0, n = e.length; t < n; t++)
    yv[e[t]] ? e[t] = yv[e[t]] : e[t] = rSe(e[t]);
  return function(r) {
    var s = "", o;
    for (o = 0; o < n; o++)
      s += Pu(e[o]) ? e[o].call(r, i) : e[o];
    return s;
  };
}
function v3(i, e) {
  return i.isValid() ? (e = vce(e, i.localeData()), Tk[e] = Tk[e] || sSe(e), Tk[e](i)) : i.localeData().invalidDate();
}
function vce(i, e) {
  var t = 5;
  function n(r) {
    return e.longDateFormat(r) || r;
  }
  for (yx.lastIndex = 0; t >= 0 && yx.test(i); )
    i = i.replace(
      yx,
      n
    ), yx.lastIndex = 0, t -= 1;
  return i;
}
var oSe = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function aSe(i) {
  var e = this._longDateFormat[i], t = this._longDateFormat[i.toUpperCase()];
  return e || !t ? e : (this._longDateFormat[i] = t.match(UW).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), this._longDateFormat[i]);
}
var lSe = "Invalid date";
function cSe() {
  return this._invalidDate;
}
var dSe = "%d", uSe = /\d{1,2}/;
function hSe(i) {
  return this._ordinal.replace("%d", i);
}
var fSe = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function gSe(i, e, t, n) {
  var r = this._relativeTime[t];
  return Pu(r) ? r(i, e, t, n) : r.replace(/%d/i, i);
}
function pSe(i, e) {
  var t = this._relativeTime[i > 0 ? "future" : "past"];
  return Pu(t) ? t(e) : t.replace(/%s/i, e);
}
var wK = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function dc(i) {
  return typeof i == "string" ? wK[i] || wK[i.toLowerCase()] : void 0;
}
function GW(i) {
  var e = {}, t, n;
  for (n in i)
    ui(i, n) && (t = dc(n), t && (e[t] = i[n]));
  return e;
}
var mSe = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function vSe(i) {
  var e = [], t;
  for (t in i)
    ui(i, t) && e.push({ unit: t, priority: mSe[t] });
  return e.sort(function(n, r) {
    return n.priority - r.priority;
  }), e;
}
var _ce = /\d/, Ll = /\d\d/, bce = /\d{3}/, qW = /\d{4}/, wA = /[+-]?\d{6}/, Dr = /\d\d?/, Cce = /\d\d\d\d?/, yce = /\d\d\d\d\d\d?/, SA = /\d{1,3}/, KW = /\d{1,4}/, xA = /[+-]?\d{1,6}/, ib = /\d+/, DA = /[+-]?\d+/, _Se = /Z|[+-]\d\d:?\d\d/gi, EA = /Z|[+-]\d\d(?::?\d\d)?/gi, bSe = /[+-]?\d+(\.\d{1,3})?/, lS = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, rb = /^[1-9]\d?/, YW = /^([1-9]\d|\d)/, LE;
LE = {};
function Dt(i, e, t) {
  LE[i] = Pu(e) ? e : function(n, r) {
    return n && t ? t : e;
  };
}
function CSe(i, e) {
  return ui(LE, i) ? LE[i](e._strict, e._locale) : new RegExp(ySe(i));
}
function ySe(i) {
  return Oh(
    i.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(e, t, n, r, s) {
        return t || n || r || s;
      }
    )
  );
}
function Oh(i) {
  return i.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Hl(i) {
  return i < 0 ? Math.ceil(i) || 0 : Math.floor(i);
}
function jn(i) {
  var e = +i, t = 0;
  return e !== 0 && isFinite(e) && (t = Hl(e)), t;
}
var T8 = {};
function Ji(i, e) {
  var t, n = e, r;
  for (typeof i == "string" && (i = [i]), Kh(e) && (n = function(s, o) {
    o[e] = jn(s);
  }), r = i.length, t = 0; t < r; t++)
    T8[i[t]] = n;
}
function cS(i, e) {
  Ji(i, function(t, n, r, s) {
    r._w = r._w || {}, e(t, r._w, r, s);
  });
}
function wSe(i, e, t) {
  e != null && ui(T8, i) && T8[i](e, t._a, t, i);
}
function LA(i) {
  return i % 4 === 0 && i % 100 !== 0 || i % 400 === 0;
}
var Ro = 0, yh = 1, Vd = 2, Rs = 3, zc = 4, wh = 5, om = 6, SSe = 7, xSe = 8;
Ut("Y", 0, 0, function() {
  var i = this.year();
  return i <= 9999 ? pu(i, 4) : "+" + i;
});
Ut(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Ut(0, ["YYYY", 4], 0, "year");
Ut(0, ["YYYYY", 5], 0, "year");
Ut(0, ["YYYYYY", 6, !0], 0, "year");
Dt("Y", DA);
Dt("YY", Dr, Ll);
Dt("YYYY", KW, qW);
Dt("YYYYY", xA, wA);
Dt("YYYYYY", xA, wA);
Ji(["YYYYY", "YYYYYY"], Ro);
Ji("YYYY", function(i, e) {
  e[Ro] = i.length === 2 ? st.parseTwoDigitYear(i) : jn(i);
});
Ji("YY", function(i, e) {
  e[Ro] = st.parseTwoDigitYear(i);
});
Ji("Y", function(i, e) {
  e[Ro] = parseInt(i, 10);
});
function pC(i) {
  return LA(i) ? 366 : 365;
}
st.parseTwoDigitYear = function(i) {
  return jn(i) + (jn(i) > 68 ? 1900 : 2e3);
};
var wce = sb("FullYear", !0);
function DSe() {
  return LA(this.year());
}
function sb(i, e) {
  return function(t) {
    return t != null ? (Sce(this, i, t), st.updateOffset(this, e), this) : sy(this, i);
  };
}
function sy(i, e) {
  if (!i.isValid())
    return NaN;
  var t = i._d, n = i._isUTC;
  switch (e) {
    case "Milliseconds":
      return n ? t.getUTCMilliseconds() : t.getMilliseconds();
    case "Seconds":
      return n ? t.getUTCSeconds() : t.getSeconds();
    case "Minutes":
      return n ? t.getUTCMinutes() : t.getMinutes();
    case "Hours":
      return n ? t.getUTCHours() : t.getHours();
    case "Date":
      return n ? t.getUTCDate() : t.getDate();
    case "Day":
      return n ? t.getUTCDay() : t.getDay();
    case "Month":
      return n ? t.getUTCMonth() : t.getMonth();
    case "FullYear":
      return n ? t.getUTCFullYear() : t.getFullYear();
    default:
      return NaN;
  }
}
function Sce(i, e, t) {
  var n, r, s, o, a;
  if (!(!i.isValid() || isNaN(t))) {
    switch (n = i._d, r = i._isUTC, e) {
      case "Milliseconds":
        return void (r ? n.setUTCMilliseconds(t) : n.setMilliseconds(t));
      case "Seconds":
        return void (r ? n.setUTCSeconds(t) : n.setSeconds(t));
      case "Minutes":
        return void (r ? n.setUTCMinutes(t) : n.setMinutes(t));
      case "Hours":
        return void (r ? n.setUTCHours(t) : n.setHours(t));
      case "Date":
        return void (r ? n.setUTCDate(t) : n.setDate(t));
      case "FullYear":
        break;
      default:
        return;
    }
    s = t, o = i.month(), a = i.date(), a = a === 29 && o === 1 && !LA(s) ? 28 : a, r ? n.setUTCFullYear(s, o, a) : n.setFullYear(s, o, a);
  }
}
function ESe(i) {
  return i = dc(i), Pu(this[i]) ? this[i]() : this;
}
function LSe(i, e) {
  if (typeof i == "object") {
    i = GW(i);
    var t = vSe(i), n, r = t.length;
    for (n = 0; n < r; n++)
      this[t[n].unit](i[t[n].unit]);
  } else if (i = dc(i), Pu(this[i]))
    return this[i](e);
  return this;
}
function ISe(i, e) {
  return (i % e + e) % e;
}
var $r;
Array.prototype.indexOf ? $r = Array.prototype.indexOf : $r = function(i) {
  var e;
  for (e = 0; e < this.length; ++e)
    if (this[e] === i)
      return e;
  return -1;
};
function XW(i, e) {
  if (isNaN(i) || isNaN(e))
    return NaN;
  var t = ISe(e, 12);
  return i += (e - t) / 12, t === 1 ? LA(i) ? 29 : 28 : 31 - t % 7 % 2;
}
Ut("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Ut("MMM", 0, 0, function(i) {
  return this.localeData().monthsShort(this, i);
});
Ut("MMMM", 0, 0, function(i) {
  return this.localeData().months(this, i);
});
Dt("M", Dr, rb);
Dt("MM", Dr, Ll);
Dt("MMM", function(i, e) {
  return e.monthsShortRegex(i);
});
Dt("MMMM", function(i, e) {
  return e.monthsRegex(i);
});
Ji(["M", "MM"], function(i, e) {
  e[yh] = jn(i) - 1;
});
Ji(["MMM", "MMMM"], function(i, e, t, n) {
  var r = t._locale.monthsParse(i, n, t._strict);
  r != null ? e[yh] = r : Tn(t).invalidMonth = i;
});
var ASe = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), xce = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Dce = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, kSe = lS, TSe = lS;
function NSe(i, e) {
  return i ? rd(this._months) ? this._months[i.month()] : this._months[(this._months.isFormat || Dce).test(e) ? "format" : "standalone"][i.month()] : rd(this._months) ? this._months : this._months.standalone;
}
function PSe(i, e) {
  return i ? rd(this._monthsShort) ? this._monthsShort[i.month()] : this._monthsShort[Dce.test(e) ? "format" : "standalone"][i.month()] : rd(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function OSe(i, e, t) {
  var n, r, s, o = i.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
      s = Nu([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(
        s,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n] = this.months(s, "").toLocaleLowerCase();
  return t ? e === "MMM" ? (r = $r.call(this._shortMonthsParse, o), r !== -1 ? r : null) : (r = $r.call(this._longMonthsParse, o), r !== -1 ? r : null) : e === "MMM" ? (r = $r.call(this._shortMonthsParse, o), r !== -1 ? r : (r = $r.call(this._longMonthsParse, o), r !== -1 ? r : null)) : (r = $r.call(this._longMonthsParse, o), r !== -1 ? r : (r = $r.call(this._shortMonthsParse, o), r !== -1 ? r : null));
}
function MSe(i, e, t) {
  var n, r, s;
  if (this._monthsParseExact)
    return OSe.call(this, i, e, t);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
    if (r = Nu([2e3, n]), t && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp(
      "^" + this.months(r, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n] = new RegExp(
      "^" + this.monthsShort(r, "").replace(".", "") + "$",
      "i"
    )), !t && !this._monthsParse[n] && (s = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), this._monthsParse[n] = new RegExp(s.replace(".", ""), "i")), t && e === "MMMM" && this._longMonthsParse[n].test(i))
      return n;
    if (t && e === "MMM" && this._shortMonthsParse[n].test(i))
      return n;
    if (!t && this._monthsParse[n].test(i))
      return n;
  }
}
function Ece(i, e) {
  if (!i.isValid())
    return i;
  if (typeof e == "string") {
    if (/^\d+$/.test(e))
      e = jn(e);
    else if (e = i.localeData().monthsParse(e), !Kh(e))
      return i;
  }
  var t = e, n = i.date();
  return n = n < 29 ? n : Math.min(n, XW(i.year(), t)), i._isUTC ? i._d.setUTCMonth(t, n) : i._d.setMonth(t, n), i;
}
function Lce(i) {
  return i != null ? (Ece(this, i), st.updateOffset(this, !0), this) : sy(this, "Month");
}
function RSe() {
  return XW(this.year(), this.month());
}
function FSe(i) {
  return this._monthsParseExact ? (ui(this, "_monthsRegex") || Ice.call(this), i ? this._monthsShortStrictRegex : this._monthsShortRegex) : (ui(this, "_monthsShortRegex") || (this._monthsShortRegex = kSe), this._monthsShortStrictRegex && i ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function BSe(i) {
  return this._monthsParseExact ? (ui(this, "_monthsRegex") || Ice.call(this), i ? this._monthsStrictRegex : this._monthsRegex) : (ui(this, "_monthsRegex") || (this._monthsRegex = TSe), this._monthsStrictRegex && i ? this._monthsStrictRegex : this._monthsRegex);
}
function Ice() {
  function i(l, c) {
    return c.length - l.length;
  }
  var e = [], t = [], n = [], r, s, o, a;
  for (r = 0; r < 12; r++)
    s = Nu([2e3, r]), o = Oh(this.monthsShort(s, "")), a = Oh(this.months(s, "")), e.push(o), t.push(a), n.push(a), n.push(o);
  e.sort(i), t.sort(i), n.sort(i), this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
function VSe(i, e, t, n, r, s, o) {
  var a;
  return i < 100 && i >= 0 ? (a = new Date(i + 400, e, t, n, r, s, o), isFinite(a.getFullYear()) && a.setFullYear(i)) : a = new Date(i, e, t, n, r, s, o), a;
}
function oy(i) {
  var e, t;
  return i < 100 && i >= 0 ? (t = Array.prototype.slice.call(arguments), t[0] = i + 400, e = new Date(Date.UTC.apply(null, t)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(i)) : e = new Date(Date.UTC.apply(null, arguments)), e;
}
function IE(i, e, t) {
  var n = 7 + e - t, r = (7 + oy(i, 0, n).getUTCDay() - e) % 7;
  return -r + n - 1;
}
function Ace(i, e, t, n, r) {
  var s = (7 + t - n) % 7, o = IE(i, n, r), a = 1 + 7 * (e - 1) + s + o, l, c;
  return a <= 0 ? (l = i - 1, c = pC(l) + a) : a > pC(i) ? (l = i + 1, c = a - pC(i)) : (l = i, c = a), {
    year: l,
    dayOfYear: c
  };
}
function ay(i, e, t) {
  var n = IE(i.year(), e, t), r = Math.floor((i.dayOfYear() - n - 1) / 7) + 1, s, o;
  return r < 1 ? (o = i.year() - 1, s = r + Mh(o, e, t)) : r > Mh(i.year(), e, t) ? (s = r - Mh(i.year(), e, t), o = i.year() + 1) : (o = i.year(), s = r), {
    week: s,
    year: o
  };
}
function Mh(i, e, t) {
  var n = IE(i, e, t), r = IE(i + 1, e, t);
  return (pC(i) - n + r) / 7;
}
Ut("w", ["ww", 2], "wo", "week");
Ut("W", ["WW", 2], "Wo", "isoWeek");
Dt("w", Dr, rb);
Dt("ww", Dr, Ll);
Dt("W", Dr, rb);
Dt("WW", Dr, Ll);
cS(
  ["w", "ww", "W", "WW"],
  function(i, e, t, n) {
    e[n.substr(0, 1)] = jn(i);
  }
);
function HSe(i) {
  return ay(i, this._week.dow, this._week.doy).week;
}
var WSe = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function jSe() {
  return this._week.dow;
}
function zSe() {
  return this._week.doy;
}
function USe(i) {
  var e = this.localeData().week(this);
  return i == null ? e : this.add((i - e) * 7, "d");
}
function GSe(i) {
  var e = ay(this, 1, 4).week;
  return i == null ? e : this.add((i - e) * 7, "d");
}
Ut("d", 0, "do", "day");
Ut("dd", 0, 0, function(i) {
  return this.localeData().weekdaysMin(this, i);
});
Ut("ddd", 0, 0, function(i) {
  return this.localeData().weekdaysShort(this, i);
});
Ut("dddd", 0, 0, function(i) {
  return this.localeData().weekdays(this, i);
});
Ut("e", 0, 0, "weekday");
Ut("E", 0, 0, "isoWeekday");
Dt("d", Dr);
Dt("e", Dr);
Dt("E", Dr);
Dt("dd", function(i, e) {
  return e.weekdaysMinRegex(i);
});
Dt("ddd", function(i, e) {
  return e.weekdaysShortRegex(i);
});
Dt("dddd", function(i, e) {
  return e.weekdaysRegex(i);
});
cS(["dd", "ddd", "dddd"], function(i, e, t, n) {
  var r = t._locale.weekdaysParse(i, n, t._strict);
  r != null ? e.d = r : Tn(t).invalidWeekday = i;
});
cS(["d", "e", "E"], function(i, e, t, n) {
  e[n] = jn(i);
});
function qSe(i, e) {
  return typeof i != "string" ? i : isNaN(i) ? (i = e.weekdaysParse(i), typeof i == "number" ? i : null) : parseInt(i, 10);
}
function KSe(i, e) {
  return typeof i == "string" ? e.weekdaysParse(i) % 7 || 7 : isNaN(i) ? null : i;
}
function ZW(i, e) {
  return i.slice(e, 7).concat(i.slice(0, e));
}
var YSe = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), kce = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), XSe = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), ZSe = lS, QSe = lS, JSe = lS;
function $Se(i, e) {
  var t = rd(this._weekdays) ? this._weekdays : this._weekdays[i && i !== !0 && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
  return i === !0 ? ZW(t, this._week.dow) : i ? t[i.day()] : t;
}
function exe(i) {
  return i === !0 ? ZW(this._weekdaysShort, this._week.dow) : i ? this._weekdaysShort[i.day()] : this._weekdaysShort;
}
function txe(i) {
  return i === !0 ? ZW(this._weekdaysMin, this._week.dow) : i ? this._weekdaysMin[i.day()] : this._weekdaysMin;
}
function nxe(i, e, t) {
  var n, r, s, o = i.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
      s = Nu([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(
        s,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(
        s,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(s, "").toLocaleLowerCase();
  return t ? e === "dddd" ? (r = $r.call(this._weekdaysParse, o), r !== -1 ? r : null) : e === "ddd" ? (r = $r.call(this._shortWeekdaysParse, o), r !== -1 ? r : null) : (r = $r.call(this._minWeekdaysParse, o), r !== -1 ? r : null) : e === "dddd" ? (r = $r.call(this._weekdaysParse, o), r !== -1 || (r = $r.call(this._shortWeekdaysParse, o), r !== -1) ? r : (r = $r.call(this._minWeekdaysParse, o), r !== -1 ? r : null)) : e === "ddd" ? (r = $r.call(this._shortWeekdaysParse, o), r !== -1 || (r = $r.call(this._weekdaysParse, o), r !== -1) ? r : (r = $r.call(this._minWeekdaysParse, o), r !== -1 ? r : null)) : (r = $r.call(this._minWeekdaysParse, o), r !== -1 || (r = $r.call(this._weekdaysParse, o), r !== -1) ? r : (r = $r.call(this._shortWeekdaysParse, o), r !== -1 ? r : null));
}
function ixe(i, e, t) {
  var n, r, s;
  if (this._weekdaysParseExact)
    return nxe.call(this, i, e, t);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
    if (r = Nu([2e3, 1]).day(n), t && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp(
      "^" + this.weekdays(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n] || (s = "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, ""), this._weekdaysParse[n] = new RegExp(s.replace(".", ""), "i")), t && e === "dddd" && this._fullWeekdaysParse[n].test(i))
      return n;
    if (t && e === "ddd" && this._shortWeekdaysParse[n].test(i))
      return n;
    if (t && e === "dd" && this._minWeekdaysParse[n].test(i))
      return n;
    if (!t && this._weekdaysParse[n].test(i))
      return n;
  }
}
function rxe(i) {
  if (!this.isValid())
    return i != null ? this : NaN;
  var e = sy(this, "Day");
  return i != null ? (i = qSe(i, this.localeData()), this.add(i - e, "d")) : e;
}
function sxe(i) {
  if (!this.isValid())
    return i != null ? this : NaN;
  var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return i == null ? e : this.add(i - e, "d");
}
function oxe(i) {
  if (!this.isValid())
    return i != null ? this : NaN;
  if (i != null) {
    var e = KSe(i, this.localeData());
    return this.day(this.day() % 7 ? e : e - 7);
  } else
    return this.day() || 7;
}
function axe(i) {
  return this._weekdaysParseExact ? (ui(this, "_weekdaysRegex") || QW.call(this), i ? this._weekdaysStrictRegex : this._weekdaysRegex) : (ui(this, "_weekdaysRegex") || (this._weekdaysRegex = ZSe), this._weekdaysStrictRegex && i ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function lxe(i) {
  return this._weekdaysParseExact ? (ui(this, "_weekdaysRegex") || QW.call(this), i ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (ui(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = QSe), this._weekdaysShortStrictRegex && i ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function cxe(i) {
  return this._weekdaysParseExact ? (ui(this, "_weekdaysRegex") || QW.call(this), i ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (ui(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = JSe), this._weekdaysMinStrictRegex && i ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function QW() {
  function i(d, u) {
    return u.length - d.length;
  }
  var e = [], t = [], n = [], r = [], s, o, a, l, c;
  for (s = 0; s < 7; s++)
    o = Nu([2e3, 1]).day(s), a = Oh(this.weekdaysMin(o, "")), l = Oh(this.weekdaysShort(o, "")), c = Oh(this.weekdays(o, "")), e.push(a), t.push(l), n.push(c), r.push(a), r.push(l), r.push(c);
  e.sort(i), t.sort(i), n.sort(i), r.sort(i), this._weekdaysRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
function JW() {
  return this.hours() % 12 || 12;
}
function dxe() {
  return this.hours() || 24;
}
Ut("H", ["HH", 2], 0, "hour");
Ut("h", ["hh", 2], 0, JW);
Ut("k", ["kk", 2], 0, dxe);
Ut("hmm", 0, 0, function() {
  return "" + JW.apply(this) + pu(this.minutes(), 2);
});
Ut("hmmss", 0, 0, function() {
  return "" + JW.apply(this) + pu(this.minutes(), 2) + pu(this.seconds(), 2);
});
Ut("Hmm", 0, 0, function() {
  return "" + this.hours() + pu(this.minutes(), 2);
});
Ut("Hmmss", 0, 0, function() {
  return "" + this.hours() + pu(this.minutes(), 2) + pu(this.seconds(), 2);
});
function Tce(i, e) {
  Ut(i, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      e
    );
  });
}
Tce("a", !0);
Tce("A", !1);
function Nce(i, e) {
  return e._meridiemParse;
}
Dt("a", Nce);
Dt("A", Nce);
Dt("H", Dr, YW);
Dt("h", Dr, rb);
Dt("k", Dr, rb);
Dt("HH", Dr, Ll);
Dt("hh", Dr, Ll);
Dt("kk", Dr, Ll);
Dt("hmm", Cce);
Dt("hmmss", yce);
Dt("Hmm", Cce);
Dt("Hmmss", yce);
Ji(["H", "HH"], Rs);
Ji(["k", "kk"], function(i, e, t) {
  var n = jn(i);
  e[Rs] = n === 24 ? 0 : n;
});
Ji(["a", "A"], function(i, e, t) {
  t._isPm = t._locale.isPM(i), t._meridiem = i;
});
Ji(["h", "hh"], function(i, e, t) {
  e[Rs] = jn(i), Tn(t).bigHour = !0;
});
Ji("hmm", function(i, e, t) {
  var n = i.length - 2;
  e[Rs] = jn(i.substr(0, n)), e[zc] = jn(i.substr(n)), Tn(t).bigHour = !0;
});
Ji("hmmss", function(i, e, t) {
  var n = i.length - 4, r = i.length - 2;
  e[Rs] = jn(i.substr(0, n)), e[zc] = jn(i.substr(n, 2)), e[wh] = jn(i.substr(r)), Tn(t).bigHour = !0;
});
Ji("Hmm", function(i, e, t) {
  var n = i.length - 2;
  e[Rs] = jn(i.substr(0, n)), e[zc] = jn(i.substr(n));
});
Ji("Hmmss", function(i, e, t) {
  var n = i.length - 4, r = i.length - 2;
  e[Rs] = jn(i.substr(0, n)), e[zc] = jn(i.substr(n, 2)), e[wh] = jn(i.substr(r));
});
function uxe(i) {
  return (i + "").toLowerCase().charAt(0) === "p";
}
var hxe = /[ap]\.?m?\.?/i, fxe = sb("Hours", !0);
function gxe(i, e, t) {
  return i > 11 ? t ? "pm" : "PM" : t ? "am" : "AM";
}
var Pce = {
  calendar: nSe,
  longDateFormat: oSe,
  invalidDate: lSe,
  ordinal: dSe,
  dayOfMonthOrdinalParse: uSe,
  relativeTime: fSe,
  months: ASe,
  monthsShort: xce,
  week: WSe,
  weekdays: YSe,
  weekdaysMin: XSe,
  weekdaysShort: kce,
  meridiemParse: hxe
}, Er = {}, Ub = {}, ly;
function pxe(i, e) {
  var t, n = Math.min(i.length, e.length);
  for (t = 0; t < n; t += 1)
    if (i[t] !== e[t])
      return t;
  return n;
}
function SK(i) {
  return i && i.toLowerCase().replace("_", "-");
}
function mxe(i) {
  for (var e = 0, t, n, r, s; e < i.length; ) {
    for (s = SK(i[e]).split("-"), t = s.length, n = SK(i[e + 1]), n = n ? n.split("-") : null; t > 0; ) {
      if (r = IA(s.slice(0, t).join("-")), r)
        return r;
      if (n && n.length >= t && pxe(s, n) >= t - 1)
        break;
      t--;
    }
    e++;
  }
  return ly;
}
function vxe(i) {
  return !!(i && i.match("^[^/\\\\]*$"));
}
function IA(i) {
  var e = null, t;
  if (Er[i] === void 0 && typeof module < "u" && module && module.exports && vxe(i))
    try {
      e = ly._abbr, t = require, t("./locale/" + i), ug(e);
    } catch {
      Er[i] = null;
    }
  return Er[i];
}
function ug(i, e) {
  var t;
  return i && (ba(e) ? t = sf(i) : t = $W(i, e), t ? ly = t : typeof console < "u" && console.warn && console.warn(
    "Locale " + i + " not found. Did you forget to load it?"
  )), ly._abbr;
}
function $W(i, e) {
  if (e !== null) {
    var t, n = Pce;
    if (e.abbr = i, Er[i] != null)
      mce(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n = Er[i]._config;
    else if (e.parentLocale != null)
      if (Er[e.parentLocale] != null)
        n = Er[e.parentLocale]._config;
      else if (t = IA(e.parentLocale), t != null)
        n = t._config;
      else
        return Ub[e.parentLocale] || (Ub[e.parentLocale] = []), Ub[e.parentLocale].push({
          name: i,
          config: e
        }), null;
    return Er[i] = new zW(A8(n, e)), Ub[i] && Ub[i].forEach(function(r) {
      $W(r.name, r.config);
    }), ug(i), Er[i];
  } else
    return delete Er[i], null;
}
function _xe(i, e) {
  if (e != null) {
    var t, n, r = Pce;
    Er[i] != null && Er[i].parentLocale != null ? Er[i].set(A8(Er[i]._config, e)) : (n = IA(i), n != null && (r = n._config), e = A8(r, e), n == null && (e.abbr = i), t = new zW(e), t.parentLocale = Er[i], Er[i] = t), ug(i);
  } else
    Er[i] != null && (Er[i].parentLocale != null ? (Er[i] = Er[i].parentLocale, i === ug() && ug(i)) : Er[i] != null && delete Er[i]);
  return Er[i];
}
function sf(i) {
  var e;
  if (i && i._locale && i._locale._abbr && (i = i._locale._abbr), !i)
    return ly;
  if (!rd(i)) {
    if (e = IA(i), e)
      return e;
    i = [i];
  }
  return mxe(i);
}
function bxe() {
  return k8(Er);
}
function ej(i) {
  var e, t = i._a;
  return t && Tn(i).overflow === -2 && (e = t[yh] < 0 || t[yh] > 11 ? yh : t[Vd] < 1 || t[Vd] > XW(t[Ro], t[yh]) ? Vd : t[Rs] < 0 || t[Rs] > 24 || t[Rs] === 24 && (t[zc] !== 0 || t[wh] !== 0 || t[om] !== 0) ? Rs : t[zc] < 0 || t[zc] > 59 ? zc : t[wh] < 0 || t[wh] > 59 ? wh : t[om] < 0 || t[om] > 999 ? om : -1, Tn(i)._overflowDayOfYear && (e < Ro || e > Vd) && (e = Vd), Tn(i)._overflowWeeks && e === -1 && (e = SSe), Tn(i)._overflowWeekday && e === -1 && (e = xSe), Tn(i).overflow = e), i;
}
var Cxe = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, yxe = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, wxe = /Z|[+-]\d\d(?::?\d\d)?/, wx = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Nk = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], Sxe = /^\/?Date\((-?\d+)/i, xxe = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Dxe = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Oce(i) {
  var e, t, n = i._i, r = Cxe.exec(n) || yxe.exec(n), s, o, a, l, c = wx.length, d = Nk.length;
  if (r) {
    for (Tn(i).iso = !0, e = 0, t = c; e < t; e++)
      if (wx[e][1].exec(r[1])) {
        o = wx[e][0], s = wx[e][2] !== !1;
        break;
      }
    if (o == null) {
      i._isValid = !1;
      return;
    }
    if (r[3]) {
      for (e = 0, t = d; e < t; e++)
        if (Nk[e][1].exec(r[3])) {
          a = (r[2] || " ") + Nk[e][0];
          break;
        }
      if (a == null) {
        i._isValid = !1;
        return;
      }
    }
    if (!s && a != null) {
      i._isValid = !1;
      return;
    }
    if (r[4])
      if (wxe.exec(r[4]))
        l = "Z";
      else {
        i._isValid = !1;
        return;
      }
    i._f = o + (a || "") + (l || ""), nj(i);
  } else
    i._isValid = !1;
}
function Exe(i, e, t, n, r, s) {
  var o = [
    Lxe(i),
    xce.indexOf(e),
    parseInt(t, 10),
    parseInt(n, 10),
    parseInt(r, 10)
  ];
  return s && o.push(parseInt(s, 10)), o;
}
function Lxe(i) {
  var e = parseInt(i, 10);
  return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e;
}
function Ixe(i) {
  return i.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function Axe(i, e, t) {
  if (i) {
    var n = kce.indexOf(i), r = new Date(
      e[0],
      e[1],
      e[2]
    ).getDay();
    if (n !== r)
      return Tn(t).weekdayMismatch = !0, t._isValid = !1, !1;
  }
  return !0;
}
function kxe(i, e, t) {
  if (i)
    return Dxe[i];
  if (e)
    return 0;
  var n = parseInt(t, 10), r = n % 100, s = (n - r) / 100;
  return s * 60 + r;
}
function Mce(i) {
  var e = xxe.exec(Ixe(i._i)), t;
  if (e) {
    if (t = Exe(
      e[4],
      e[3],
      e[2],
      e[5],
      e[6],
      e[7]
    ), !Axe(e[1], t, i))
      return;
    i._a = t, i._tzm = kxe(e[8], e[9], e[10]), i._d = oy.apply(null, i._a), i._d.setUTCMinutes(i._d.getUTCMinutes() - i._tzm), Tn(i).rfc2822 = !0;
  } else
    i._isValid = !1;
}
function Txe(i) {
  var e = Sxe.exec(i._i);
  if (e !== null) {
    i._d = /* @__PURE__ */ new Date(+e[1]);
    return;
  }
  if (Oce(i), i._isValid === !1)
    delete i._isValid;
  else
    return;
  if (Mce(i), i._isValid === !1)
    delete i._isValid;
  else
    return;
  i._strict ? i._isValid = !1 : st.createFromInputFallback(i);
}
st.createFromInputFallback = cc(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(i) {
    i._d = /* @__PURE__ */ new Date(i._i + (i._useUTC ? " UTC" : ""));
  }
);
function N1(i, e, t) {
  return i ?? e ?? t;
}
function Nxe(i) {
  var e = new Date(st.now());
  return i._useUTC ? [
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate()
  ] : [e.getFullYear(), e.getMonth(), e.getDate()];
}
function tj(i) {
  var e, t, n = [], r, s, o;
  if (!i._d) {
    for (r = Nxe(i), i._w && i._a[Vd] == null && i._a[yh] == null && Pxe(i), i._dayOfYear != null && (o = N1(i._a[Ro], r[Ro]), (i._dayOfYear > pC(o) || i._dayOfYear === 0) && (Tn(i)._overflowDayOfYear = !0), t = oy(o, 0, i._dayOfYear), i._a[yh] = t.getUTCMonth(), i._a[Vd] = t.getUTCDate()), e = 0; e < 3 && i._a[e] == null; ++e)
      i._a[e] = n[e] = r[e];
    for (; e < 7; e++)
      i._a[e] = n[e] = i._a[e] == null ? e === 2 ? 1 : 0 : i._a[e];
    i._a[Rs] === 24 && i._a[zc] === 0 && i._a[wh] === 0 && i._a[om] === 0 && (i._nextDay = !0, i._a[Rs] = 0), i._d = (i._useUTC ? oy : VSe).apply(
      null,
      n
    ), s = i._useUTC ? i._d.getUTCDay() : i._d.getDay(), i._tzm != null && i._d.setUTCMinutes(i._d.getUTCMinutes() - i._tzm), i._nextDay && (i._a[Rs] = 24), i._w && typeof i._w.d < "u" && i._w.d !== s && (Tn(i).weekdayMismatch = !0);
  }
}
function Pxe(i) {
  var e, t, n, r, s, o, a, l, c;
  e = i._w, e.GG != null || e.W != null || e.E != null ? (s = 1, o = 4, t = N1(
    e.GG,
    i._a[Ro],
    ay(Sr(), 1, 4).year
  ), n = N1(e.W, 1), r = N1(e.E, 1), (r < 1 || r > 7) && (l = !0)) : (s = i._locale._week.dow, o = i._locale._week.doy, c = ay(Sr(), s, o), t = N1(e.gg, i._a[Ro], c.year), n = N1(e.w, c.week), e.d != null ? (r = e.d, (r < 0 || r > 6) && (l = !0)) : e.e != null ? (r = e.e + s, (e.e < 0 || e.e > 6) && (l = !0)) : r = s), n < 1 || n > Mh(t, s, o) ? Tn(i)._overflowWeeks = !0 : l != null ? Tn(i)._overflowWeekday = !0 : (a = Ace(t, n, r, s, o), i._a[Ro] = a.year, i._dayOfYear = a.dayOfYear);
}
st.ISO_8601 = function() {
};
st.RFC_2822 = function() {
};
function nj(i) {
  if (i._f === st.ISO_8601) {
    Oce(i);
    return;
  }
  if (i._f === st.RFC_2822) {
    Mce(i);
    return;
  }
  i._a = [], Tn(i).empty = !0;
  var e = "" + i._i, t, n, r, s, o, a = e.length, l = 0, c, d;
  for (r = vce(i._f, i._locale).match(UW) || [], d = r.length, t = 0; t < d; t++)
    s = r[t], n = (e.match(CSe(s, i)) || [])[0], n && (o = e.substr(0, e.indexOf(n)), o.length > 0 && Tn(i).unusedInput.push(o), e = e.slice(
      e.indexOf(n) + n.length
    ), l += n.length), yv[s] ? (n ? Tn(i).empty = !1 : Tn(i).unusedTokens.push(s), wSe(s, n, i)) : i._strict && !n && Tn(i).unusedTokens.push(s);
  Tn(i).charsLeftOver = a - l, e.length > 0 && Tn(i).unusedInput.push(e), i._a[Rs] <= 12 && Tn(i).bigHour === !0 && i._a[Rs] > 0 && (Tn(i).bigHour = void 0), Tn(i).parsedDateParts = i._a.slice(0), Tn(i).meridiem = i._meridiem, i._a[Rs] = Oxe(
    i._locale,
    i._a[Rs],
    i._meridiem
  ), c = Tn(i).era, c !== null && (i._a[Ro] = i._locale.erasConvertYear(c, i._a[Ro])), tj(i), ej(i);
}
function Oxe(i, e, t) {
  var n;
  return t == null ? e : i.meridiemHour != null ? i.meridiemHour(e, t) : (i.isPM != null && (n = i.isPM(t), n && e < 12 && (e += 12), !n && e === 12 && (e = 0)), e);
}
function Mxe(i) {
  var e, t, n, r, s, o, a = !1, l = i._f.length;
  if (l === 0) {
    Tn(i).invalidFormat = !0, i._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (r = 0; r < l; r++)
    s = 0, o = !1, e = jW({}, i), i._useUTC != null && (e._useUTC = i._useUTC), e._f = i._f[r], nj(e), WW(e) && (o = !0), s += Tn(e).charsLeftOver, s += Tn(e).unusedTokens.length * 10, Tn(e).score = s, a ? s < n && (n = s, t = e) : (n == null || s < n || o) && (n = s, t = e, o && (a = !0));
  Gf(i, t || e);
}
function Rxe(i) {
  if (!i._d) {
    var e = GW(i._i), t = e.day === void 0 ? e.date : e.day;
    i._a = gce(
      [e.year, e.month, t, e.hour, e.minute, e.second, e.millisecond],
      function(n) {
        return n && parseInt(n, 10);
      }
    ), tj(i);
  }
}
function Fxe(i) {
  var e = new aS(ej(Rce(i)));
  return e._nextDay && (e.add(1, "d"), e._nextDay = void 0), e;
}
function Rce(i) {
  var e = i._i, t = i._f;
  return i._locale = i._locale || sf(i._l), e === null || t === void 0 && e === "" ? yA({ nullInput: !0 }) : (typeof e == "string" && (i._i = e = i._locale.preparse(e)), sd(e) ? new aS(ej(e)) : (oS(e) ? i._d = e : rd(t) ? Mxe(i) : t ? nj(i) : Bxe(i), WW(i) || (i._d = null), i));
}
function Bxe(i) {
  var e = i._i;
  ba(e) ? i._d = new Date(st.now()) : oS(e) ? i._d = new Date(e.valueOf()) : typeof e == "string" ? Txe(i) : rd(e) ? (i._a = gce(e.slice(0), function(t) {
    return parseInt(t, 10);
  }), tj(i)) : Cm(e) ? Rxe(i) : Kh(e) ? i._d = new Date(e) : st.createFromInputFallback(i);
}
function Fce(i, e, t, n, r) {
  var s = {};
  return (e === !0 || e === !1) && (n = e, e = void 0), (t === !0 || t === !1) && (n = t, t = void 0), (Cm(i) && HW(i) || rd(i) && i.length === 0) && (i = void 0), s._isAMomentObject = !0, s._useUTC = s._isUTC = r, s._l = t, s._i = i, s._f = e, s._strict = n, Fxe(s);
}
function Sr(i, e, t, n) {
  return Fce(i, e, t, n, !1);
}
var Vxe = cc(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var i = Sr.apply(null, arguments);
    return this.isValid() && i.isValid() ? i < this ? this : i : yA();
  }
), Hxe = cc(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var i = Sr.apply(null, arguments);
    return this.isValid() && i.isValid() ? i > this ? this : i : yA();
  }
);
function Bce(i, e) {
  var t, n;
  if (e.length === 1 && rd(e[0]) && (e = e[0]), !e.length)
    return Sr();
  for (t = e[0], n = 1; n < e.length; ++n)
    (!e[n].isValid() || e[n][i](t)) && (t = e[n]);
  return t;
}
function Wxe() {
  var i = [].slice.call(arguments, 0);
  return Bce("isBefore", i);
}
function jxe() {
  var i = [].slice.call(arguments, 0);
  return Bce("isAfter", i);
}
var zxe = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Gb = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Uxe(i) {
  var e, t = !1, n, r = Gb.length;
  for (e in i)
    if (ui(i, e) && !($r.call(Gb, e) !== -1 && (i[e] == null || !isNaN(i[e]))))
      return !1;
  for (n = 0; n < r; ++n)
    if (i[Gb[n]]) {
      if (t)
        return !1;
      parseFloat(i[Gb[n]]) !== jn(i[Gb[n]]) && (t = !0);
    }
  return !0;
}
function Gxe() {
  return this._isValid;
}
function qxe() {
  return gd(NaN);
}
function AA(i) {
  var e = GW(i), t = e.year || 0, n = e.quarter || 0, r = e.month || 0, s = e.week || e.isoWeek || 0, o = e.day || 0, a = e.hour || 0, l = e.minute || 0, c = e.second || 0, d = e.millisecond || 0;
  this._isValid = Uxe(e), this._milliseconds = +d + c * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  a * 1e3 * 60 * 60, this._days = +o + s * 7, this._months = +r + n * 3 + t * 12, this._data = {}, this._locale = sf(), this._bubble();
}
function _3(i) {
  return i instanceof AA;
}
function N8(i) {
  return i < 0 ? Math.round(-1 * i) * -1 : Math.round(i);
}
function Kxe(i, e, t) {
  var n = Math.min(i.length, e.length), r = Math.abs(i.length - e.length), s = 0, o;
  for (o = 0; o < n; o++)
    jn(i[o]) !== jn(e[o]) && s++;
  return s + r;
}
function Vce(i, e) {
  Ut(i, 0, 0, function() {
    var t = this.utcOffset(), n = "+";
    return t < 0 && (t = -t, n = "-"), n + pu(~~(t / 60), 2) + e + pu(~~t % 60, 2);
  });
}
Vce("Z", ":");
Vce("ZZ", "");
Dt("Z", EA);
Dt("ZZ", EA);
Ji(["Z", "ZZ"], function(i, e, t) {
  t._useUTC = !0, t._tzm = ij(EA, i);
});
var Yxe = /([\+\-]|\d\d)/gi;
function ij(i, e) {
  var t = (e || "").match(i), n, r, s;
  return t === null ? null : (n = t[t.length - 1] || [], r = (n + "").match(Yxe) || ["-", 0, 0], s = +(r[1] * 60) + jn(r[2]), s === 0 ? 0 : r[0] === "+" ? s : -s);
}
function rj(i, e) {
  var t, n;
  return e._isUTC ? (t = e.clone(), n = (sd(i) || oS(i) ? i.valueOf() : Sr(i).valueOf()) - t.valueOf(), t._d.setTime(t._d.valueOf() + n), st.updateOffset(t, !1), t) : Sr(i).local();
}
function P8(i) {
  return -Math.round(i._d.getTimezoneOffset());
}
st.updateOffset = function() {
};
function Xxe(i, e, t) {
  var n = this._offset || 0, r;
  if (!this.isValid())
    return i != null ? this : NaN;
  if (i != null) {
    if (typeof i == "string") {
      if (i = ij(EA, i), i === null)
        return this;
    } else Math.abs(i) < 16 && !t && (i = i * 60);
    return !this._isUTC && e && (r = P8(this)), this._offset = i, this._isUTC = !0, r != null && this.add(r, "m"), n !== i && (!e || this._changeInProgress ? jce(
      this,
      gd(i - n, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, st.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n : P8(this);
}
function Zxe(i, e) {
  return i != null ? (typeof i != "string" && (i = -i), this.utcOffset(i, e), this) : -this.utcOffset();
}
function Qxe(i) {
  return this.utcOffset(0, i);
}
function Jxe(i) {
  return this._isUTC && (this.utcOffset(0, i), this._isUTC = !1, i && this.subtract(P8(this), "m")), this;
}
function $xe() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var i = ij(_Se, this._i);
    i != null ? this.utcOffset(i) : this.utcOffset(0, !0);
  }
  return this;
}
function eDe(i) {
  return this.isValid() ? (i = i ? Sr(i).utcOffset() : 0, (this.utcOffset() - i) % 60 === 0) : !1;
}
function tDe() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function nDe() {
  if (!ba(this._isDSTShifted))
    return this._isDSTShifted;
  var i = {}, e;
  return jW(i, this), i = Rce(i), i._a ? (e = i._isUTC ? Nu(i._a) : Sr(i._a), this._isDSTShifted = this.isValid() && Kxe(i._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function iDe() {
  return this.isValid() ? !this._isUTC : !1;
}
function rDe() {
  return this.isValid() ? this._isUTC : !1;
}
function Hce() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var sDe = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, oDe = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function gd(i, e) {
  var t = i, n = null, r, s, o;
  return _3(i) ? t = {
    ms: i._milliseconds,
    d: i._days,
    M: i._months
  } : Kh(i) || !isNaN(+i) ? (t = {}, e ? t[e] = +i : t.milliseconds = +i) : (n = sDe.exec(i)) ? (r = n[1] === "-" ? -1 : 1, t = {
    y: 0,
    d: jn(n[Vd]) * r,
    h: jn(n[Rs]) * r,
    m: jn(n[zc]) * r,
    s: jn(n[wh]) * r,
    ms: jn(N8(n[om] * 1e3)) * r
    // the millisecond decimal point is included in the match
  }) : (n = oDe.exec(i)) ? (r = n[1] === "-" ? -1 : 1, t = {
    y: yp(n[2], r),
    M: yp(n[3], r),
    w: yp(n[4], r),
    d: yp(n[5], r),
    h: yp(n[6], r),
    m: yp(n[7], r),
    s: yp(n[8], r)
  }) : t == null ? t = {} : typeof t == "object" && ("from" in t || "to" in t) && (o = aDe(
    Sr(t.from),
    Sr(t.to)
  ), t = {}, t.ms = o.milliseconds, t.M = o.months), s = new AA(t), _3(i) && ui(i, "_locale") && (s._locale = i._locale), _3(i) && ui(i, "_isValid") && (s._isValid = i._isValid), s;
}
gd.fn = AA.prototype;
gd.invalid = qxe;
function yp(i, e) {
  var t = i && parseFloat(i.replace(",", "."));
  return (isNaN(t) ? 0 : t) * e;
}
function xK(i, e) {
  var t = {};
  return t.months = e.month() - i.month() + (e.year() - i.year()) * 12, i.clone().add(t.months, "M").isAfter(e) && --t.months, t.milliseconds = +e - +i.clone().add(t.months, "M"), t;
}
function aDe(i, e) {
  var t;
  return i.isValid() && e.isValid() ? (e = rj(e, i), i.isBefore(e) ? t = xK(i, e) : (t = xK(e, i), t.milliseconds = -t.milliseconds, t.months = -t.months), t) : { milliseconds: 0, months: 0 };
}
function Wce(i, e) {
  return function(t, n) {
    var r, s;
    return n !== null && !isNaN(+n) && (mce(
      e,
      "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), s = t, t = n, n = s), r = gd(t, n), jce(this, r, i), this;
  };
}
function jce(i, e, t, n) {
  var r = e._milliseconds, s = N8(e._days), o = N8(e._months);
  i.isValid() && (n = n ?? !0, o && Ece(i, sy(i, "Month") + o * t), s && Sce(i, "Date", sy(i, "Date") + s * t), r && i._d.setTime(i._d.valueOf() + r * t), n && st.updateOffset(i, s || o));
}
var lDe = Wce(1, "add"), cDe = Wce(-1, "subtract");
function zce(i) {
  return typeof i == "string" || i instanceof String;
}
function dDe(i) {
  return sd(i) || oS(i) || zce(i) || Kh(i) || hDe(i) || uDe(i) || i === null || i === void 0;
}
function uDe(i) {
  var e = Cm(i) && !HW(i), t = !1, n = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], r, s, o = n.length;
  for (r = 0; r < o; r += 1)
    s = n[r], t = t || ui(i, s);
  return e && t;
}
function hDe(i) {
  var e = rd(i), t = !1;
  return e && (t = i.filter(function(n) {
    return !Kh(n) && zce(i);
  }).length === 0), e && t;
}
function fDe(i) {
  var e = Cm(i) && !HW(i), t = !1, n = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], r, s;
  for (r = 0; r < n.length; r += 1)
    s = n[r], t = t || ui(i, s);
  return e && t;
}
function gDe(i, e) {
  var t = i.diff(e, "days", !0);
  return t < -6 ? "sameElse" : t < -1 ? "lastWeek" : t < 0 ? "lastDay" : t < 1 ? "sameDay" : t < 2 ? "nextDay" : t < 7 ? "nextWeek" : "sameElse";
}
function pDe(i, e) {
  arguments.length === 1 && (arguments[0] ? dDe(arguments[0]) ? (i = arguments[0], e = void 0) : fDe(arguments[0]) && (e = arguments[0], i = void 0) : (i = void 0, e = void 0));
  var t = i || Sr(), n = rj(t, this).startOf("day"), r = st.calendarFormat(this, n) || "sameElse", s = e && (Pu(e[r]) ? e[r].call(this, t) : e[r]);
  return this.format(
    s || this.localeData().calendar(r, this, Sr(t))
  );
}
function mDe() {
  return new aS(this);
}
function vDe(i, e) {
  var t = sd(i) ? i : Sr(i);
  return this.isValid() && t.isValid() ? (e = dc(e) || "millisecond", e === "millisecond" ? this.valueOf() > t.valueOf() : t.valueOf() < this.clone().startOf(e).valueOf()) : !1;
}
function _De(i, e) {
  var t = sd(i) ? i : Sr(i);
  return this.isValid() && t.isValid() ? (e = dc(e) || "millisecond", e === "millisecond" ? this.valueOf() < t.valueOf() : this.clone().endOf(e).valueOf() < t.valueOf()) : !1;
}
function bDe(i, e, t, n) {
  var r = sd(i) ? i : Sr(i), s = sd(e) ? e : Sr(e);
  return this.isValid() && r.isValid() && s.isValid() ? (n = n || "()", (n[0] === "(" ? this.isAfter(r, t) : !this.isBefore(r, t)) && (n[1] === ")" ? this.isBefore(s, t) : !this.isAfter(s, t))) : !1;
}
function CDe(i, e) {
  var t = sd(i) ? i : Sr(i), n;
  return this.isValid() && t.isValid() ? (e = dc(e) || "millisecond", e === "millisecond" ? this.valueOf() === t.valueOf() : (n = t.valueOf(), this.clone().startOf(e).valueOf() <= n && n <= this.clone().endOf(e).valueOf())) : !1;
}
function yDe(i, e) {
  return this.isSame(i, e) || this.isAfter(i, e);
}
function wDe(i, e) {
  return this.isSame(i, e) || this.isBefore(i, e);
}
function SDe(i, e, t) {
  var n, r, s;
  if (!this.isValid())
    return NaN;
  if (n = rj(i, this), !n.isValid())
    return NaN;
  switch (r = (n.utcOffset() - this.utcOffset()) * 6e4, e = dc(e), e) {
    case "year":
      s = b3(this, n) / 12;
      break;
    case "month":
      s = b3(this, n);
      break;
    case "quarter":
      s = b3(this, n) / 3;
      break;
    case "second":
      s = (this - n) / 1e3;
      break;
    case "minute":
      s = (this - n) / 6e4;
      break;
    case "hour":
      s = (this - n) / 36e5;
      break;
    case "day":
      s = (this - n - r) / 864e5;
      break;
    case "week":
      s = (this - n - r) / 6048e5;
      break;
    default:
      s = this - n;
  }
  return t ? s : Hl(s);
}
function b3(i, e) {
  if (i.date() < e.date())
    return -b3(e, i);
  var t = (e.year() - i.year()) * 12 + (e.month() - i.month()), n = i.clone().add(t, "months"), r, s;
  return e - n < 0 ? (r = i.clone().add(t - 1, "months"), s = (e - n) / (n - r)) : (r = i.clone().add(t + 1, "months"), s = (e - n) / (r - n)), -(t + s) || 0;
}
st.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
st.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function xDe() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function DDe(i) {
  if (!this.isValid())
    return null;
  var e = i !== !0, t = e ? this.clone().utc() : this;
  return t.year() < 0 || t.year() > 9999 ? v3(
    t,
    e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Pu(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", v3(t, "Z")) : v3(
    t,
    e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function EDe() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var i = "moment", e = "", t, n, r, s;
  return this.isLocal() || (i = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", e = "Z"), t = "[" + i + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", r = "-MM-DD[T]HH:mm:ss.SSS", s = e + '[")]', this.format(t + n + r + s);
}
function LDe(i) {
  i || (i = this.isUtc() ? st.defaultFormatUtc : st.defaultFormat);
  var e = v3(this, i);
  return this.localeData().postformat(e);
}
function IDe(i, e) {
  return this.isValid() && (sd(i) && i.isValid() || Sr(i).isValid()) ? gd({ to: this, from: i }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function ADe(i) {
  return this.from(Sr(), i);
}
function kDe(i, e) {
  return this.isValid() && (sd(i) && i.isValid() || Sr(i).isValid()) ? gd({ from: this, to: i }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function TDe(i) {
  return this.to(Sr(), i);
}
function Uce(i) {
  var e;
  return i === void 0 ? this._locale._abbr : (e = sf(i), e != null && (this._locale = e), this);
}
var Gce = cc(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(i) {
    return i === void 0 ? this.localeData() : this.locale(i);
  }
);
function qce() {
  return this._locale;
}
var AE = 1e3, wv = 60 * AE, kE = 60 * wv, Kce = (365 * 400 + 97) * 24 * kE;
function Sv(i, e) {
  return (i % e + e) % e;
}
function Yce(i, e, t) {
  return i < 100 && i >= 0 ? new Date(i + 400, e, t) - Kce : new Date(i, e, t).valueOf();
}
function Xce(i, e, t) {
  return i < 100 && i >= 0 ? Date.UTC(i + 400, e, t) - Kce : Date.UTC(i, e, t);
}
function NDe(i) {
  var e, t;
  if (i = dc(i), i === void 0 || i === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? Xce : Yce, i) {
    case "year":
      e = t(this.year(), 0, 1);
      break;
    case "quarter":
      e = t(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      e = t(this.year(), this.month(), 1);
      break;
    case "week":
      e = t(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      e = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      e = t(this.year(), this.month(), this.date());
      break;
    case "hour":
      e = this._d.valueOf(), e -= Sv(
        e + (this._isUTC ? 0 : this.utcOffset() * wv),
        kE
      );
      break;
    case "minute":
      e = this._d.valueOf(), e -= Sv(e, wv);
      break;
    case "second":
      e = this._d.valueOf(), e -= Sv(e, AE);
      break;
  }
  return this._d.setTime(e), st.updateOffset(this, !0), this;
}
function PDe(i) {
  var e, t;
  if (i = dc(i), i === void 0 || i === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? Xce : Yce, i) {
    case "year":
      e = t(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      e = t(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      e = t(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      e = t(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      e = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      e = t(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      e = this._d.valueOf(), e += kE - Sv(
        e + (this._isUTC ? 0 : this.utcOffset() * wv),
        kE
      ) - 1;
      break;
    case "minute":
      e = this._d.valueOf(), e += wv - Sv(e, wv) - 1;
      break;
    case "second":
      e = this._d.valueOf(), e += AE - Sv(e, AE) - 1;
      break;
  }
  return this._d.setTime(e), st.updateOffset(this, !0), this;
}
function ODe() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function MDe() {
  return Math.floor(this.valueOf() / 1e3);
}
function RDe() {
  return new Date(this.valueOf());
}
function FDe() {
  var i = this;
  return [
    i.year(),
    i.month(),
    i.date(),
    i.hour(),
    i.minute(),
    i.second(),
    i.millisecond()
  ];
}
function BDe() {
  var i = this;
  return {
    years: i.year(),
    months: i.month(),
    date: i.date(),
    hours: i.hours(),
    minutes: i.minutes(),
    seconds: i.seconds(),
    milliseconds: i.milliseconds()
  };
}
function VDe() {
  return this.isValid() ? this.toISOString() : null;
}
function HDe() {
  return WW(this);
}
function WDe() {
  return Gf({}, Tn(this));
}
function jDe() {
  return Tn(this).overflow;
}
function zDe() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Ut("N", 0, 0, "eraAbbr");
Ut("NN", 0, 0, "eraAbbr");
Ut("NNN", 0, 0, "eraAbbr");
Ut("NNNN", 0, 0, "eraName");
Ut("NNNNN", 0, 0, "eraNarrow");
Ut("y", ["y", 1], "yo", "eraYear");
Ut("y", ["yy", 2], 0, "eraYear");
Ut("y", ["yyy", 3], 0, "eraYear");
Ut("y", ["yyyy", 4], 0, "eraYear");
Dt("N", sj);
Dt("NN", sj);
Dt("NNN", sj);
Dt("NNNN", e3e);
Dt("NNNNN", t3e);
Ji(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(i, e, t, n) {
    var r = t._locale.erasParse(i, n, t._strict);
    r ? Tn(t).era = r : Tn(t).invalidEra = i;
  }
);
Dt("y", ib);
Dt("yy", ib);
Dt("yyy", ib);
Dt("yyyy", ib);
Dt("yo", n3e);
Ji(["y", "yy", "yyy", "yyyy"], Ro);
Ji(["yo"], function(i, e, t, n) {
  var r;
  t._locale._eraYearOrdinalRegex && (r = i.match(t._locale._eraYearOrdinalRegex)), t._locale.eraYearOrdinalParse ? e[Ro] = t._locale.eraYearOrdinalParse(i, r) : e[Ro] = parseInt(i, 10);
});
function UDe(i, e) {
  var t, n, r, s = this._eras || sf("en")._eras;
  for (t = 0, n = s.length; t < n; ++t) {
    switch (typeof s[t].since) {
      case "string":
        r = st(s[t].since).startOf("day"), s[t].since = r.valueOf();
        break;
    }
    switch (typeof s[t].until) {
      case "undefined":
        s[t].until = 1 / 0;
        break;
      case "string":
        r = st(s[t].until).startOf("day").valueOf(), s[t].until = r.valueOf();
        break;
    }
  }
  return s;
}
function GDe(i, e, t) {
  var n, r, s = this.eras(), o, a, l;
  for (i = i.toUpperCase(), n = 0, r = s.length; n < r; ++n)
    if (o = s[n].name.toUpperCase(), a = s[n].abbr.toUpperCase(), l = s[n].narrow.toUpperCase(), t)
      switch (e) {
        case "N":
        case "NN":
        case "NNN":
          if (a === i)
            return s[n];
          break;
        case "NNNN":
          if (o === i)
            return s[n];
          break;
        case "NNNNN":
          if (l === i)
            return s[n];
          break;
      }
    else if ([o, a, l].indexOf(i) >= 0)
      return s[n];
}
function qDe(i, e) {
  var t = i.since <= i.until ? 1 : -1;
  return e === void 0 ? st(i.since).year() : st(i.since).year() + (e - i.offset) * t;
}
function KDe() {
  var i, e, t, n = this.localeData().eras();
  for (i = 0, e = n.length; i < e; ++i)
    if (t = this.clone().startOf("day").valueOf(), n[i].since <= t && t <= n[i].until || n[i].until <= t && t <= n[i].since)
      return n[i].name;
  return "";
}
function YDe() {
  var i, e, t, n = this.localeData().eras();
  for (i = 0, e = n.length; i < e; ++i)
    if (t = this.clone().startOf("day").valueOf(), n[i].since <= t && t <= n[i].until || n[i].until <= t && t <= n[i].since)
      return n[i].narrow;
  return "";
}
function XDe() {
  var i, e, t, n = this.localeData().eras();
  for (i = 0, e = n.length; i < e; ++i)
    if (t = this.clone().startOf("day").valueOf(), n[i].since <= t && t <= n[i].until || n[i].until <= t && t <= n[i].since)
      return n[i].abbr;
  return "";
}
function ZDe() {
  var i, e, t, n, r = this.localeData().eras();
  for (i = 0, e = r.length; i < e; ++i)
    if (t = r[i].since <= r[i].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), r[i].since <= n && n <= r[i].until || r[i].until <= n && n <= r[i].since)
      return (this.year() - st(r[i].since).year()) * t + r[i].offset;
  return this.year();
}
function QDe(i) {
  return ui(this, "_erasNameRegex") || oj.call(this), i ? this._erasNameRegex : this._erasRegex;
}
function JDe(i) {
  return ui(this, "_erasAbbrRegex") || oj.call(this), i ? this._erasAbbrRegex : this._erasRegex;
}
function $De(i) {
  return ui(this, "_erasNarrowRegex") || oj.call(this), i ? this._erasNarrowRegex : this._erasRegex;
}
function sj(i, e) {
  return e.erasAbbrRegex(i);
}
function e3e(i, e) {
  return e.erasNameRegex(i);
}
function t3e(i, e) {
  return e.erasNarrowRegex(i);
}
function n3e(i, e) {
  return e._eraYearOrdinalRegex || ib;
}
function oj() {
  var i = [], e = [], t = [], n = [], r, s, o, a, l, c = this.eras();
  for (r = 0, s = c.length; r < s; ++r)
    o = Oh(c[r].name), a = Oh(c[r].abbr), l = Oh(c[r].narrow), e.push(o), i.push(a), t.push(l), n.push(o), n.push(a), n.push(l);
  this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
Ut(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Ut(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function kA(i, e) {
  Ut(0, [i, i.length], 0, e);
}
kA("gggg", "weekYear");
kA("ggggg", "weekYear");
kA("GGGG", "isoWeekYear");
kA("GGGGG", "isoWeekYear");
Dt("G", DA);
Dt("g", DA);
Dt("GG", Dr, Ll);
Dt("gg", Dr, Ll);
Dt("GGGG", KW, qW);
Dt("gggg", KW, qW);
Dt("GGGGG", xA, wA);
Dt("ggggg", xA, wA);
cS(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(i, e, t, n) {
    e[n.substr(0, 2)] = jn(i);
  }
);
cS(["gg", "GG"], function(i, e, t, n) {
  e[n] = st.parseTwoDigitYear(i);
});
function i3e(i) {
  return Zce.call(
    this,
    i,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function r3e(i) {
  return Zce.call(
    this,
    i,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function s3e() {
  return Mh(this.year(), 1, 4);
}
function o3e() {
  return Mh(this.isoWeekYear(), 1, 4);
}
function a3e() {
  var i = this.localeData()._week;
  return Mh(this.year(), i.dow, i.doy);
}
function l3e() {
  var i = this.localeData()._week;
  return Mh(this.weekYear(), i.dow, i.doy);
}
function Zce(i, e, t, n, r) {
  var s;
  return i == null ? ay(this, n, r).year : (s = Mh(i, n, r), e > s && (e = s), c3e.call(this, i, e, t, n, r));
}
function c3e(i, e, t, n, r) {
  var s = Ace(i, e, t, n, r), o = oy(s.year, 0, s.dayOfYear);
  return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
}
Ut("Q", 0, "Qo", "quarter");
Dt("Q", _ce);
Ji("Q", function(i, e) {
  e[yh] = (jn(i) - 1) * 3;
});
function d3e(i) {
  return i == null ? Math.ceil((this.month() + 1) / 3) : this.month((i - 1) * 3 + this.month() % 3);
}
Ut("D", ["DD", 2], "Do", "date");
Dt("D", Dr, rb);
Dt("DD", Dr, Ll);
Dt("Do", function(i, e) {
  return i ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient;
});
Ji(["D", "DD"], Vd);
Ji("Do", function(i, e) {
  e[Vd] = jn(i.match(Dr)[0]);
});
var Qce = sb("Date", !0);
Ut("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Dt("DDD", SA);
Dt("DDDD", bce);
Ji(["DDD", "DDDD"], function(i, e, t) {
  t._dayOfYear = jn(i);
});
function u3e(i) {
  var e = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return i == null ? e : this.add(i - e, "d");
}
Ut("m", ["mm", 2], 0, "minute");
Dt("m", Dr, YW);
Dt("mm", Dr, Ll);
Ji(["m", "mm"], zc);
var h3e = sb("Minutes", !1);
Ut("s", ["ss", 2], 0, "second");
Dt("s", Dr, YW);
Dt("ss", Dr, Ll);
Ji(["s", "ss"], wh);
var f3e = sb("Seconds", !1);
Ut("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Ut(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Ut(0, ["SSS", 3], 0, "millisecond");
Ut(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Ut(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Ut(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Ut(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Ut(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Ut(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Dt("S", SA, _ce);
Dt("SS", SA, Ll);
Dt("SSS", SA, bce);
var qf, Jce;
for (qf = "SSSS"; qf.length <= 9; qf += "S")
  Dt(qf, ib);
function g3e(i, e) {
  e[om] = jn(("0." + i) * 1e3);
}
for (qf = "S"; qf.length <= 9; qf += "S")
  Ji(qf, g3e);
Jce = sb("Milliseconds", !1);
Ut("z", 0, 0, "zoneAbbr");
Ut("zz", 0, 0, "zoneName");
function p3e() {
  return this._isUTC ? "UTC" : "";
}
function m3e() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var lt = aS.prototype;
lt.add = lDe;
lt.calendar = pDe;
lt.clone = mDe;
lt.diff = SDe;
lt.endOf = PDe;
lt.format = LDe;
lt.from = IDe;
lt.fromNow = ADe;
lt.to = kDe;
lt.toNow = TDe;
lt.get = ESe;
lt.invalidAt = jDe;
lt.isAfter = vDe;
lt.isBefore = _De;
lt.isBetween = bDe;
lt.isSame = CDe;
lt.isSameOrAfter = yDe;
lt.isSameOrBefore = wDe;
lt.isValid = HDe;
lt.lang = Gce;
lt.locale = Uce;
lt.localeData = qce;
lt.max = Hxe;
lt.min = Vxe;
lt.parsingFlags = WDe;
lt.set = LSe;
lt.startOf = NDe;
lt.subtract = cDe;
lt.toArray = FDe;
lt.toObject = BDe;
lt.toDate = RDe;
lt.toISOString = DDe;
lt.inspect = EDe;
typeof Symbol < "u" && Symbol.for != null && (lt[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
lt.toJSON = VDe;
lt.toString = xDe;
lt.unix = MDe;
lt.valueOf = ODe;
lt.creationData = zDe;
lt.eraName = KDe;
lt.eraNarrow = YDe;
lt.eraAbbr = XDe;
lt.eraYear = ZDe;
lt.year = wce;
lt.isLeapYear = DSe;
lt.weekYear = i3e;
lt.isoWeekYear = r3e;
lt.quarter = lt.quarters = d3e;
lt.month = Lce;
lt.daysInMonth = RSe;
lt.week = lt.weeks = USe;
lt.isoWeek = lt.isoWeeks = GSe;
lt.weeksInYear = a3e;
lt.weeksInWeekYear = l3e;
lt.isoWeeksInYear = s3e;
lt.isoWeeksInISOWeekYear = o3e;
lt.date = Qce;
lt.day = lt.days = rxe;
lt.weekday = sxe;
lt.isoWeekday = oxe;
lt.dayOfYear = u3e;
lt.hour = lt.hours = fxe;
lt.minute = lt.minutes = h3e;
lt.second = lt.seconds = f3e;
lt.millisecond = lt.milliseconds = Jce;
lt.utcOffset = Xxe;
lt.utc = Qxe;
lt.local = Jxe;
lt.parseZone = $xe;
lt.hasAlignedHourOffset = eDe;
lt.isDST = tDe;
lt.isLocal = iDe;
lt.isUtcOffset = rDe;
lt.isUtc = Hce;
lt.isUTC = Hce;
lt.zoneAbbr = p3e;
lt.zoneName = m3e;
lt.dates = cc(
  "dates accessor is deprecated. Use date instead.",
  Qce
);
lt.months = cc(
  "months accessor is deprecated. Use month instead",
  Lce
);
lt.years = cc(
  "years accessor is deprecated. Use year instead",
  wce
);
lt.zone = cc(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Zxe
);
lt.isDSTShifted = cc(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  nDe
);
function v3e(i) {
  return Sr(i * 1e3);
}
function _3e() {
  return Sr.apply(null, arguments).parseZone();
}
function $ce(i) {
  return i;
}
var hi = zW.prototype;
hi.calendar = iSe;
hi.longDateFormat = aSe;
hi.invalidDate = cSe;
hi.ordinal = hSe;
hi.preparse = $ce;
hi.postformat = $ce;
hi.relativeTime = gSe;
hi.pastFuture = pSe;
hi.set = tSe;
hi.eras = UDe;
hi.erasParse = GDe;
hi.erasConvertYear = qDe;
hi.erasAbbrRegex = JDe;
hi.erasNameRegex = QDe;
hi.erasNarrowRegex = $De;
hi.months = NSe;
hi.monthsShort = PSe;
hi.monthsParse = MSe;
hi.monthsRegex = BSe;
hi.monthsShortRegex = FSe;
hi.week = HSe;
hi.firstDayOfYear = zSe;
hi.firstDayOfWeek = jSe;
hi.weekdays = $Se;
hi.weekdaysMin = txe;
hi.weekdaysShort = exe;
hi.weekdaysParse = ixe;
hi.weekdaysRegex = axe;
hi.weekdaysShortRegex = lxe;
hi.weekdaysMinRegex = cxe;
hi.isPM = uxe;
hi.meridiem = gxe;
function TE(i, e, t, n) {
  var r = sf(), s = Nu().set(n, e);
  return r[t](s, i);
}
function ede(i, e, t) {
  if (Kh(i) && (e = i, i = void 0), i = i || "", e != null)
    return TE(i, e, t, "month");
  var n, r = [];
  for (n = 0; n < 12; n++)
    r[n] = TE(i, n, t, "month");
  return r;
}
function aj(i, e, t, n) {
  typeof i == "boolean" ? (Kh(e) && (t = e, e = void 0), e = e || "") : (e = i, t = e, i = !1, Kh(e) && (t = e, e = void 0), e = e || "");
  var r = sf(), s = i ? r._week.dow : 0, o, a = [];
  if (t != null)
    return TE(e, (t + s) % 7, n, "day");
  for (o = 0; o < 7; o++)
    a[o] = TE(e, (o + s) % 7, n, "day");
  return a;
}
function b3e(i, e) {
  return ede(i, e, "months");
}
function C3e(i, e) {
  return ede(i, e, "monthsShort");
}
function y3e(i, e, t) {
  return aj(i, e, t, "weekdays");
}
function w3e(i, e, t) {
  return aj(i, e, t, "weekdaysShort");
}
function S3e(i, e, t) {
  return aj(i, e, t, "weekdaysMin");
}
ug("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(i) {
    var e = i % 10, t = jn(i % 100 / 10) === 1 ? "th" : e === 1 ? "st" : e === 2 ? "nd" : e === 3 ? "rd" : "th";
    return i + t;
  }
});
st.lang = cc(
  "moment.lang is deprecated. Use moment.locale instead.",
  ug
);
st.langData = cc(
  "moment.langData is deprecated. Use moment.localeData instead.",
  sf
);
var Hu = Math.abs;
function x3e() {
  var i = this._data;
  return this._milliseconds = Hu(this._milliseconds), this._days = Hu(this._days), this._months = Hu(this._months), i.milliseconds = Hu(i.milliseconds), i.seconds = Hu(i.seconds), i.minutes = Hu(i.minutes), i.hours = Hu(i.hours), i.months = Hu(i.months), i.years = Hu(i.years), this;
}
function tde(i, e, t, n) {
  var r = gd(e, t);
  return i._milliseconds += n * r._milliseconds, i._days += n * r._days, i._months += n * r._months, i._bubble();
}
function D3e(i, e) {
  return tde(this, i, e, 1);
}
function E3e(i, e) {
  return tde(this, i, e, -1);
}
function DK(i) {
  return i < 0 ? Math.floor(i) : Math.ceil(i);
}
function L3e() {
  var i = this._milliseconds, e = this._days, t = this._months, n = this._data, r, s, o, a, l;
  return i >= 0 && e >= 0 && t >= 0 || i <= 0 && e <= 0 && t <= 0 || (i += DK(O8(t) + e) * 864e5, e = 0, t = 0), n.milliseconds = i % 1e3, r = Hl(i / 1e3), n.seconds = r % 60, s = Hl(r / 60), n.minutes = s % 60, o = Hl(s / 60), n.hours = o % 24, e += Hl(o / 24), l = Hl(nde(e)), t += l, e -= DK(O8(l)), a = Hl(t / 12), t %= 12, n.days = e, n.months = t, n.years = a, this;
}
function nde(i) {
  return i * 4800 / 146097;
}
function O8(i) {
  return i * 146097 / 4800;
}
function I3e(i) {
  if (!this.isValid())
    return NaN;
  var e, t, n = this._milliseconds;
  if (i = dc(i), i === "month" || i === "quarter" || i === "year")
    switch (e = this._days + n / 864e5, t = this._months + nde(e), i) {
      case "month":
        return t;
      case "quarter":
        return t / 3;
      case "year":
        return t / 12;
    }
  else
    switch (e = this._days + Math.round(O8(this._months)), i) {
      case "week":
        return e / 7 + n / 6048e5;
      case "day":
        return e + n / 864e5;
      case "hour":
        return e * 24 + n / 36e5;
      case "minute":
        return e * 1440 + n / 6e4;
      case "second":
        return e * 86400 + n / 1e3;
      case "millisecond":
        return Math.floor(e * 864e5) + n;
      default:
        throw new Error("Unknown unit " + i);
    }
}
function of(i) {
  return function() {
    return this.as(i);
  };
}
var ide = of("ms"), A3e = of("s"), k3e = of("m"), T3e = of("h"), N3e = of("d"), P3e = of("w"), O3e = of("M"), M3e = of("Q"), R3e = of("y"), F3e = ide;
function B3e() {
  return gd(this);
}
function V3e(i) {
  return i = dc(i), this.isValid() ? this[i + "s"]() : NaN;
}
function I0(i) {
  return function() {
    return this.isValid() ? this._data[i] : NaN;
  };
}
var H3e = I0("milliseconds"), W3e = I0("seconds"), j3e = I0("minutes"), z3e = I0("hours"), U3e = I0("days"), G3e = I0("months"), q3e = I0("years");
function K3e() {
  return Hl(this.days() / 7);
}
var $u = Math.round, U1 = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Y3e(i, e, t, n, r) {
  return r.relativeTime(e || 1, !!t, i, n);
}
function X3e(i, e, t, n) {
  var r = gd(i).abs(), s = $u(r.as("s")), o = $u(r.as("m")), a = $u(r.as("h")), l = $u(r.as("d")), c = $u(r.as("M")), d = $u(r.as("w")), u = $u(r.as("y")), h = s <= t.ss && ["s", s] || s < t.s && ["ss", s] || o <= 1 && ["m"] || o < t.m && ["mm", o] || a <= 1 && ["h"] || a < t.h && ["hh", a] || l <= 1 && ["d"] || l < t.d && ["dd", l];
  return t.w != null && (h = h || d <= 1 && ["w"] || d < t.w && ["ww", d]), h = h || c <= 1 && ["M"] || c < t.M && ["MM", c] || u <= 1 && ["y"] || ["yy", u], h[2] = e, h[3] = +i > 0, h[4] = n, Y3e.apply(null, h);
}
function Z3e(i) {
  return i === void 0 ? $u : typeof i == "function" ? ($u = i, !0) : !1;
}
function Q3e(i, e) {
  return U1[i] === void 0 ? !1 : e === void 0 ? U1[i] : (U1[i] = e, i === "s" && (U1.ss = e - 1), !0);
}
function J3e(i, e) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = !1, n = U1, r, s;
  return typeof i == "object" && (e = i, i = !1), typeof i == "boolean" && (t = i), typeof e == "object" && (n = Object.assign({}, U1, e), e.s != null && e.ss == null && (n.ss = e.s - 1)), r = this.localeData(), s = X3e(this, !t, n, r), t && (s = r.pastFuture(+this, s)), r.postformat(s);
}
var Pk = Math.abs;
function r1(i) {
  return (i > 0) - (i < 0) || +i;
}
function TA() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var i = Pk(this._milliseconds) / 1e3, e = Pk(this._days), t = Pk(this._months), n, r, s, o, a = this.asSeconds(), l, c, d, u;
  return a ? (n = Hl(i / 60), r = Hl(n / 60), i %= 60, n %= 60, s = Hl(t / 12), t %= 12, o = i ? i.toFixed(3).replace(/\.?0+$/, "") : "", l = a < 0 ? "-" : "", c = r1(this._months) !== r1(a) ? "-" : "", d = r1(this._days) !== r1(a) ? "-" : "", u = r1(this._milliseconds) !== r1(a) ? "-" : "", l + "P" + (s ? c + s + "Y" : "") + (t ? c + t + "M" : "") + (e ? d + e + "D" : "") + (r || n || i ? "T" : "") + (r ? u + r + "H" : "") + (n ? u + n + "M" : "") + (i ? u + o + "S" : "")) : "P0D";
}
var si = AA.prototype;
si.isValid = Gxe;
si.abs = x3e;
si.add = D3e;
si.subtract = E3e;
si.as = I3e;
si.asMilliseconds = ide;
si.asSeconds = A3e;
si.asMinutes = k3e;
si.asHours = T3e;
si.asDays = N3e;
si.asWeeks = P3e;
si.asMonths = O3e;
si.asQuarters = M3e;
si.asYears = R3e;
si.valueOf = F3e;
si._bubble = L3e;
si.clone = B3e;
si.get = V3e;
si.milliseconds = H3e;
si.seconds = W3e;
si.minutes = j3e;
si.hours = z3e;
si.days = U3e;
si.weeks = K3e;
si.months = G3e;
si.years = q3e;
si.humanize = J3e;
si.toISOString = TA;
si.toString = TA;
si.toJSON = TA;
si.locale = Uce;
si.localeData = qce;
si.toIsoString = cc(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  TA
);
si.lang = Gce;
Ut("X", 0, 0, "unix");
Ut("x", 0, 0, "valueOf");
Dt("x", DA);
Dt("X", bSe);
Ji("X", function(i, e, t) {
  t._d = new Date(parseFloat(i) * 1e3);
});
Ji("x", function(i, e, t) {
  t._d = new Date(jn(i));
});
//! moment.js
st.version = "2.30.1";
$we(Sr);
st.fn = lt;
st.min = Wxe;
st.max = jxe;
st.now = zxe;
st.utc = Nu;
st.unix = v3e;
st.months = b3e;
st.isDate = oS;
st.locale = ug;
st.invalid = yA;
st.duration = gd;
st.isMoment = sd;
st.weekdays = y3e;
st.parseZone = _3e;
st.localeData = sf;
st.isDuration = _3;
st.monthsShort = C3e;
st.weekdaysMin = S3e;
st.defineLocale = $W;
st.updateLocale = _xe;
st.locales = bxe;
st.weekdaysShort = w3e;
st.normalizeUnits = dc;
st.relativeTimeRounding = Z3e;
st.relativeTimeThreshold = Q3e;
st.calendarFormat = gDe;
st.prototype = lt;
st.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const $3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: st
}, Symbol.toStringTag, { value: "Module" })), A0 = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { fill: "#FFF", d: "M5 5H15V15H5z" }), /* @__PURE__ */ G.createElement("path", { fill: "#F33E3E", d: "M10 18.333c-4.6 0-8.333-3.733-8.333-8.333S5.4 1.667 10 1.667 18.333 5.4 18.333 10 14.6 18.333 10 18.333zm0-12.5c-.46 0-.833.373-.833.834V10c0 .46.373.833.833.833.46 0 .833-.373.833-.833V6.667c0-.46-.373-.834-.833-.834zm0 6.667c-.46 0-.833.373-.833.833 0 .46.373.834.833.834.46 0 .833-.373.833-.834 0-.46-.373-.833-.833-.833z" }))), eEe = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#B1B7BC", className: "fill-color", fillRule: "evenodd", d: "M10 18.333c4.6 0 8.333-3.733 8.333-8.333S14.6 1.667 10 1.667 1.667 5.4 1.667 10 5.4 18.333 10 18.333zm0-1.666c-3.68 0-6.667-2.987-6.667-6.667 0-3.68 2.987-6.667 6.667-6.667 3.68 0 6.667 2.987 6.667 6.667 0 3.68-2.987 6.667-6.667 6.667zm0-5.834c.46 0 .833-.373.833-.833V6.667c0-.46-.373-.834-.833-.834-.46 0-.833.373-.833.834V10c0 .46.373.833.833.833zm0 3.334c.46 0 .833-.373.833-.834 0-.46-.373-.833-.833-.833-.46 0-.833.373-.833.833 0 .46.373.834.833.834z" })), tEe = ({
  reload: i,
  withBorder: e = !1,
  title: t = "Failed to load",
  subTitle: n = "We could not load the information on this page.",
  description: r = "Please reload or try again later",
  buttonText: s = "Reload",
  rootClassName: o,
  useInfoIcon: a = !1
}) => /* @__PURE__ */ v.jsxs("div", { className: `flex column dc__gap-8 p-16 ${e ? "dc__border br-4" : ""} ${o || ""}`, children: [
  a ? /* @__PURE__ */ v.jsx(eEe, { className: "icon-dim-24 fcn-6" }) : /* @__PURE__ */ v.jsx(A0, { className: "icon-dim-24 alert-icon-r5-imp" }),
  /* @__PURE__ */ v.jsxs("div", { className: "flex column dc__gap-4 dc__align-center", children: [
    /* @__PURE__ */ v.jsx("h3", { className: "fs-13 lh-20 fw-6 cn-9 m-0", children: t }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex column fs-13 lh-20 fw-4 cn-7", children: [
      n && /* @__PURE__ */ v.jsx("p", { className: "m-0", children: n }),
      r && /* @__PURE__ */ v.jsx("p", { className: "m-0", children: r })
    ] })
  ] }),
  i && /* @__PURE__ */ v.jsx(
    "button",
    {
      type: "button",
      className: "cta text h-20 fs-13 lh-20-imp",
      onClick: i,
      "data-testid": "generic-section-reload-button",
      children: s
    }
  )
] }), ob = tEe, EK = {
  title: "Resource not found",
  subTitle: "The resource you are looking for does not exist"
}, nEe = ({
  isLoading: i,
  progressingProps: e,
  customLoader: t,
  error: n,
  notAuthorized: r,
  notFoundText: s,
  reloadProps: o,
  genericSectionErrorProps: a,
  errorScreenManagerProps: l,
  children: c
}) => r ? /* @__PURE__ */ v.jsx(k1t, {}) : i ? t ? /* @__PURE__ */ v.jsx(v.Fragment, { children: t }) : /* @__PURE__ */ v.jsx(Yr, { ...e }) : n ? a ? /* @__PURE__ */ v.jsx(ob, { ...a }) : l ? /* @__PURE__ */ v.jsx(I1t, { ...l }) : n?.code === 404 ? /* @__PURE__ */ v.jsx(
  oa,
  {
    title: s?.title ?? EK.title,
    subTitle: s?.subTitle ?? EK.subTitle
  }
) : /* @__PURE__ */ v.jsx(sA, { ...o }) : /* @__PURE__ */ v.jsx(v.Fragment, { children: c }), rde = nEe;
var Oa = "top", nc = "bottom", ic = "right", Ma = "left", lj = "auto", dS = [Oa, nc, ic, Ma], n_ = "start", cy = "end", iEe = "clippingParents", sde = "viewport", qb = "popper", rEe = "reference", LK = /* @__PURE__ */ dS.reduce(function(i, e) {
  return i.concat([e + "-" + n_, e + "-" + cy]);
}, []), ode = /* @__PURE__ */ [].concat(dS, [lj]).reduce(function(i, e) {
  return i.concat([e, e + "-" + n_, e + "-" + cy]);
}, []), sEe = "beforeRead", oEe = "read", aEe = "afterRead", lEe = "beforeMain", cEe = "main", dEe = "afterMain", uEe = "beforeWrite", hEe = "write", fEe = "afterWrite", gEe = [sEe, oEe, aEe, lEe, cEe, dEe, uEe, hEe, fEe];
function mu(i) {
  return i ? (i.nodeName || "").toLowerCase() : null;
}
function _l(i) {
  if (i == null)
    return window;
  if (i.toString() !== "[object Window]") {
    var e = i.ownerDocument;
    return e && e.defaultView || window;
  }
  return i;
}
function Hm(i) {
  var e = _l(i).Element;
  return i instanceof e || i instanceof Element;
}
function Xl(i) {
  var e = _l(i).HTMLElement;
  return i instanceof e || i instanceof HTMLElement;
}
function cj(i) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = _l(i).ShadowRoot;
  return i instanceof e || i instanceof ShadowRoot;
}
function pEe(i) {
  var e = i.state;
  Object.keys(e.elements).forEach(function(t) {
    var n = e.styles[t] || {}, r = e.attributes[t] || {}, s = e.elements[t];
    !Xl(s) || !mu(s) || (Object.assign(s.style, n), Object.keys(r).forEach(function(o) {
      var a = r[o];
      a === !1 ? s.removeAttribute(o) : s.setAttribute(o, a === !0 ? "" : a);
    }));
  });
}
function mEe(i) {
  var e = i.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(n) {
      var r = e.elements[n], s = e.attributes[n] || {}, o = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : t[n]), a = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Xl(r) || !mu(r) || (Object.assign(r.style, a), Object.keys(s).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
const dj = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: pEe,
  effect: mEe,
  requires: ["computeStyles"]
};
function ou(i) {
  return i.split("-")[0];
}
var ym = Math.max, NE = Math.min, i_ = Math.round;
function M8() {
  var i = navigator.userAgentData;
  return i != null && i.brands && Array.isArray(i.brands) ? i.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function ade() {
  return !/^((?!chrome|android).)*safari/i.test(M8());
}
function r_(i, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var n = i.getBoundingClientRect(), r = 1, s = 1;
  e && Xl(i) && (r = i.offsetWidth > 0 && i_(n.width) / i.offsetWidth || 1, s = i.offsetHeight > 0 && i_(n.height) / i.offsetHeight || 1);
  var o = Hm(i) ? _l(i) : window, a = o.visualViewport, l = !ade() && t, c = (n.left + (l && a ? a.offsetLeft : 0)) / r, d = (n.top + (l && a ? a.offsetTop : 0)) / s, u = n.width / r, h = n.height / s;
  return {
    width: u,
    height: h,
    top: d,
    right: c + u,
    bottom: d + h,
    left: c,
    x: c,
    y: d
  };
}
function uj(i) {
  var e = r_(i), t = i.offsetWidth, n = i.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
    x: i.offsetLeft,
    y: i.offsetTop,
    width: t,
    height: n
  };
}
function lde(i, e) {
  var t = e.getRootNode && e.getRootNode();
  if (i.contains(e))
    return !0;
  if (t && cj(t)) {
    var n = e;
    do {
      if (n && i.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Yh(i) {
  return _l(i).getComputedStyle(i);
}
function vEe(i) {
  return ["table", "td", "th"].indexOf(mu(i)) >= 0;
}
function rp(i) {
  return ((Hm(i) ? i.ownerDocument : (
    // $FlowFixMe[prop-missing]
    i.document
  )) || window.document).documentElement;
}
function NA(i) {
  return mu(i) === "html" ? i : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    i.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    i.parentNode || // DOM Element detected
    (cj(i) ? i.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    rp(i)
  );
}
function IK(i) {
  return !Xl(i) || // https://github.com/popperjs/popper-core/issues/837
  Yh(i).position === "fixed" ? null : i.offsetParent;
}
function _Ee(i) {
  var e = /firefox/i.test(M8()), t = /Trident/i.test(M8());
  if (t && Xl(i)) {
    var n = Yh(i);
    if (n.position === "fixed")
      return null;
  }
  var r = NA(i);
  for (cj(r) && (r = r.host); Xl(r) && ["html", "body"].indexOf(mu(r)) < 0; ) {
    var s = Yh(r);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || e && s.willChange === "filter" || e && s.filter && s.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function uS(i) {
  for (var e = _l(i), t = IK(i); t && vEe(t) && Yh(t).position === "static"; )
    t = IK(t);
  return t && (mu(t) === "html" || mu(t) === "body" && Yh(t).position === "static") ? e : t || _Ee(i) || e;
}
function hj(i) {
  return ["top", "bottom"].indexOf(i) >= 0 ? "x" : "y";
}
function mC(i, e, t) {
  return ym(i, NE(e, t));
}
function bEe(i, e, t) {
  var n = mC(i, e, t);
  return n > t ? t : n;
}
function cde() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function dde(i) {
  return Object.assign({}, cde(), i);
}
function ude(i, e) {
  return e.reduce(function(t, n) {
    return t[n] = i, t;
  }, {});
}
var CEe = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, dde(typeof e != "number" ? e : ude(e, dS));
};
function yEe(i) {
  var e, t = i.state, n = i.name, r = i.options, s = t.elements.arrow, o = t.modifiersData.popperOffsets, a = ou(t.placement), l = hj(a), c = [Ma, ic].indexOf(a) >= 0, d = c ? "height" : "width";
  if (!(!s || !o)) {
    var u = CEe(r.padding, t), h = uj(s), f = l === "y" ? Oa : Ma, g = l === "y" ? nc : ic, p = t.rects.reference[d] + t.rects.reference[l] - o[l] - t.rects.popper[d], m = o[l] - t.rects.reference[l], _ = uS(s), b = _ ? l === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, w = p / 2 - m / 2, y = u[f], S = b - h[d] - u[g], x = b / 2 - h[d] / 2 + w, D = mC(y, x, S), E = l;
    t.modifiersData[n] = (e = {}, e[E] = D, e.centerOffset = D - x, e);
  }
}
function wEe(i) {
  var e = i.state, t = i.options, n = t.element, r = n === void 0 ? "[data-popper-arrow]" : n;
  r != null && (typeof r == "string" && (r = e.elements.popper.querySelector(r), !r) || lde(e.elements.popper, r) && (e.elements.arrow = r));
}
const SEe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: yEe,
  effect: wEe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function s_(i) {
  return i.split("-")[1];
}
var xEe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function DEe(i, e) {
  var t = i.x, n = i.y, r = e.devicePixelRatio || 1;
  return {
    x: i_(t * r) / r || 0,
    y: i_(n * r) / r || 0
  };
}
function AK(i) {
  var e, t = i.popper, n = i.popperRect, r = i.placement, s = i.variation, o = i.offsets, a = i.position, l = i.gpuAcceleration, c = i.adaptive, d = i.roundOffsets, u = i.isFixed, h = o.x, f = h === void 0 ? 0 : h, g = o.y, p = g === void 0 ? 0 : g, m = typeof d == "function" ? d({
    x: f,
    y: p
  }) : {
    x: f,
    y: p
  };
  f = m.x, p = m.y;
  var _ = o.hasOwnProperty("x"), b = o.hasOwnProperty("y"), w = Ma, y = Oa, S = window;
  if (c) {
    var x = uS(t), D = "clientHeight", E = "clientWidth";
    if (x === _l(t) && (x = rp(t), Yh(x).position !== "static" && a === "absolute" && (D = "scrollHeight", E = "scrollWidth")), x = x, r === Oa || (r === Ma || r === ic) && s === cy) {
      y = nc;
      var L = u && x === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        x[D]
      );
      p -= L - n.height, p *= l ? 1 : -1;
    }
    if (r === Ma || (r === Oa || r === nc) && s === cy) {
      w = ic;
      var k = u && x === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        x[E]
      );
      f -= k - n.width, f *= l ? 1 : -1;
    }
  }
  var N = Object.assign({
    position: a
  }, c && xEe), I = d === !0 ? DEe({
    x: f,
    y: p
  }, _l(t)) : {
    x: f,
    y: p
  };
  if (f = I.x, p = I.y, l) {
    var A;
    return Object.assign({}, N, (A = {}, A[y] = b ? "0" : "", A[w] = _ ? "0" : "", A.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + p + "px)" : "translate3d(" + f + "px, " + p + "px, 0)", A));
  }
  return Object.assign({}, N, (e = {}, e[y] = b ? p + "px" : "", e[w] = _ ? f + "px" : "", e.transform = "", e));
}
function EEe(i) {
  var e = i.state, t = i.options, n = t.gpuAcceleration, r = n === void 0 ? !0 : n, s = t.adaptive, o = s === void 0 ? !0 : s, a = t.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: ou(e.placement),
    variation: s_(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: r,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, AK(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, AK(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const LEe = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: EEe,
  data: {}
};
var Sx = {
  passive: !0
};
function IEe(i) {
  var e = i.state, t = i.instance, n = i.options, r = n.scroll, s = r === void 0 ? !0 : r, o = n.resize, a = o === void 0 ? !0 : o, l = _l(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return s && c.forEach(function(d) {
    d.addEventListener("scroll", t.update, Sx);
  }), a && l.addEventListener("resize", t.update, Sx), function() {
    s && c.forEach(function(d) {
      d.removeEventListener("scroll", t.update, Sx);
    }), a && l.removeEventListener("resize", t.update, Sx);
  };
}
const AEe = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: IEe,
  data: {}
};
var kEe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function C3(i) {
  return i.replace(/left|right|bottom|top/g, function(e) {
    return kEe[e];
  });
}
var TEe = {
  start: "end",
  end: "start"
};
function kK(i) {
  return i.replace(/start|end/g, function(e) {
    return TEe[e];
  });
}
function fj(i) {
  var e = _l(i), t = e.pageXOffset, n = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: n
  };
}
function gj(i) {
  return r_(rp(i)).left + fj(i).scrollLeft;
}
function NEe(i, e) {
  var t = _l(i), n = rp(i), r = t.visualViewport, s = n.clientWidth, o = n.clientHeight, a = 0, l = 0;
  if (r) {
    s = r.width, o = r.height;
    var c = ade();
    (c || !c && e === "fixed") && (a = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: a + gj(i),
    y: l
  };
}
function PEe(i) {
  var e, t = rp(i), n = fj(i), r = (e = i.ownerDocument) == null ? void 0 : e.body, s = ym(t.scrollWidth, t.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), o = ym(t.scrollHeight, t.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), a = -n.scrollLeft + gj(i), l = -n.scrollTop;
  return Yh(r || t).direction === "rtl" && (a += ym(t.clientWidth, r ? r.clientWidth : 0) - s), {
    width: s,
    height: o,
    x: a,
    y: l
  };
}
function pj(i) {
  var e = Yh(i), t = e.overflow, n = e.overflowX, r = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + r + n);
}
function hde(i) {
  return ["html", "body", "#document"].indexOf(mu(i)) >= 0 ? i.ownerDocument.body : Xl(i) && pj(i) ? i : hde(NA(i));
}
function vC(i, e) {
  var t;
  e === void 0 && (e = []);
  var n = hde(i), r = n === ((t = i.ownerDocument) == null ? void 0 : t.body), s = _l(n), o = r ? [s].concat(s.visualViewport || [], pj(n) ? n : []) : n, a = e.concat(o);
  return r ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(vC(NA(o)))
  );
}
function R8(i) {
  return Object.assign({}, i, {
    left: i.x,
    top: i.y,
    right: i.x + i.width,
    bottom: i.y + i.height
  });
}
function OEe(i, e) {
  var t = r_(i, !1, e === "fixed");
  return t.top = t.top + i.clientTop, t.left = t.left + i.clientLeft, t.bottom = t.top + i.clientHeight, t.right = t.left + i.clientWidth, t.width = i.clientWidth, t.height = i.clientHeight, t.x = t.left, t.y = t.top, t;
}
function TK(i, e, t) {
  return e === sde ? R8(NEe(i, t)) : Hm(e) ? OEe(e, t) : R8(PEe(rp(i)));
}
function MEe(i) {
  var e = vC(NA(i)), t = ["absolute", "fixed"].indexOf(Yh(i).position) >= 0, n = t && Xl(i) ? uS(i) : i;
  return Hm(n) ? e.filter(function(r) {
    return Hm(r) && lde(r, n) && mu(r) !== "body";
  }) : [];
}
function REe(i, e, t, n) {
  var r = e === "clippingParents" ? MEe(i) : [].concat(e), s = [].concat(r, [t]), o = s[0], a = s.reduce(function(l, c) {
    var d = TK(i, c, n);
    return l.top = ym(d.top, l.top), l.right = NE(d.right, l.right), l.bottom = NE(d.bottom, l.bottom), l.left = ym(d.left, l.left), l;
  }, TK(i, o, n));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function fde(i) {
  var e = i.reference, t = i.element, n = i.placement, r = n ? ou(n) : null, s = n ? s_(n) : null, o = e.x + e.width / 2 - t.width / 2, a = e.y + e.height / 2 - t.height / 2, l;
  switch (r) {
    case Oa:
      l = {
        x: o,
        y: e.y - t.height
      };
      break;
    case nc:
      l = {
        x: o,
        y: e.y + e.height
      };
      break;
    case ic:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case Ma:
      l = {
        x: e.x - t.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = r ? hj(r) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (s) {
      case n_:
        l[c] = l[c] - (e[d] / 2 - t[d] / 2);
        break;
      case cy:
        l[c] = l[c] + (e[d] / 2 - t[d] / 2);
        break;
    }
  }
  return l;
}
function dy(i, e) {
  e === void 0 && (e = {});
  var t = e, n = t.placement, r = n === void 0 ? i.placement : n, s = t.strategy, o = s === void 0 ? i.strategy : s, a = t.boundary, l = a === void 0 ? iEe : a, c = t.rootBoundary, d = c === void 0 ? sde : c, u = t.elementContext, h = u === void 0 ? qb : u, f = t.altBoundary, g = f === void 0 ? !1 : f, p = t.padding, m = p === void 0 ? 0 : p, _ = dde(typeof m != "number" ? m : ude(m, dS)), b = h === qb ? rEe : qb, w = i.rects.popper, y = i.elements[g ? b : h], S = REe(Hm(y) ? y : y.contextElement || rp(i.elements.popper), l, d, o), x = r_(i.elements.reference), D = fde({
    reference: x,
    element: w,
    strategy: "absolute",
    placement: r
  }), E = R8(Object.assign({}, w, D)), L = h === qb ? E : x, k = {
    top: S.top - L.top + _.top,
    bottom: L.bottom - S.bottom + _.bottom,
    left: S.left - L.left + _.left,
    right: L.right - S.right + _.right
  }, N = i.modifiersData.offset;
  if (h === qb && N) {
    var I = N[r];
    Object.keys(k).forEach(function(A) {
      var P = [ic, nc].indexOf(A) >= 0 ? 1 : -1, O = [Oa, nc].indexOf(A) >= 0 ? "y" : "x";
      k[A] += I[O] * P;
    });
  }
  return k;
}
function FEe(i, e) {
  e === void 0 && (e = {});
  var t = e, n = t.placement, r = t.boundary, s = t.rootBoundary, o = t.padding, a = t.flipVariations, l = t.allowedAutoPlacements, c = l === void 0 ? ode : l, d = s_(n), u = d ? a ? LK : LK.filter(function(g) {
    return s_(g) === d;
  }) : dS, h = u.filter(function(g) {
    return c.indexOf(g) >= 0;
  });
  h.length === 0 && (h = u);
  var f = h.reduce(function(g, p) {
    return g[p] = dy(i, {
      placement: p,
      boundary: r,
      rootBoundary: s,
      padding: o
    })[ou(p)], g;
  }, {});
  return Object.keys(f).sort(function(g, p) {
    return f[g] - f[p];
  });
}
function BEe(i) {
  if (ou(i) === lj)
    return [];
  var e = C3(i);
  return [kK(i), e, kK(e)];
}
function VEe(i) {
  var e = i.state, t = i.options, n = i.name;
  if (!e.modifiersData[n]._skip) {
    for (var r = t.mainAxis, s = r === void 0 ? !0 : r, o = t.altAxis, a = o === void 0 ? !0 : o, l = t.fallbackPlacements, c = t.padding, d = t.boundary, u = t.rootBoundary, h = t.altBoundary, f = t.flipVariations, g = f === void 0 ? !0 : f, p = t.allowedAutoPlacements, m = e.options.placement, _ = ou(m), b = _ === m, w = l || (b || !g ? [C3(m)] : BEe(m)), y = [m].concat(w).reduce(function(ae, ue) {
      return ae.concat(ou(ue) === lj ? FEe(e, {
        placement: ue,
        boundary: d,
        rootBoundary: u,
        padding: c,
        flipVariations: g,
        allowedAutoPlacements: p
      }) : ue);
    }, []), S = e.rects.reference, x = e.rects.popper, D = /* @__PURE__ */ new Map(), E = !0, L = y[0], k = 0; k < y.length; k++) {
      var N = y[k], I = ou(N), A = s_(N) === n_, P = [Oa, nc].indexOf(I) >= 0, O = P ? "width" : "height", K = dy(e, {
        placement: N,
        boundary: d,
        rootBoundary: u,
        altBoundary: h,
        padding: c
      }), W = P ? A ? ic : Ma : A ? nc : Oa;
      S[O] > x[O] && (W = C3(W));
      var F = C3(W), q = [];
      if (s && q.push(K[I] <= 0), a && q.push(K[W] <= 0, K[F] <= 0), q.every(function(ae) {
        return ae;
      })) {
        L = N, E = !1;
        break;
      }
      D.set(N, q);
    }
    if (E)
      for (var R = g ? 3 : 1, T = function(ue) {
        var se = y.find(function(le) {
          var oe = D.get(le);
          if (oe)
            return oe.slice(0, ue).every(function(re) {
              return re;
            });
        });
        if (se)
          return L = se, "break";
      }, z = R; z > 0; z--) {
        var X = T(z);
        if (X === "break") break;
      }
    e.placement !== L && (e.modifiersData[n]._skip = !0, e.placement = L, e.reset = !0);
  }
}
const HEe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: VEe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function NK(i, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: i.top - e.height - t.y,
    right: i.right - e.width + t.x,
    bottom: i.bottom - e.height + t.y,
    left: i.left - e.width - t.x
  };
}
function PK(i) {
  return [Oa, ic, nc, Ma].some(function(e) {
    return i[e] >= 0;
  });
}
function WEe(i) {
  var e = i.state, t = i.name, n = e.rects.reference, r = e.rects.popper, s = e.modifiersData.preventOverflow, o = dy(e, {
    elementContext: "reference"
  }), a = dy(e, {
    altBoundary: !0
  }), l = NK(o, n), c = NK(a, r, s), d = PK(l), u = PK(c);
  e.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: u
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": u
  });
}
const jEe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: WEe
};
function zEe(i, e, t) {
  var n = ou(i), r = [Ma, Oa].indexOf(n) >= 0 ? -1 : 1, s = typeof t == "function" ? t(Object.assign({}, e, {
    placement: i
  })) : t, o = s[0], a = s[1];
  return o = o || 0, a = (a || 0) * r, [Ma, ic].indexOf(n) >= 0 ? {
    x: a,
    y: o
  } : {
    x: o,
    y: a
  };
}
function UEe(i) {
  var e = i.state, t = i.options, n = i.name, r = t.offset, s = r === void 0 ? [0, 0] : r, o = ode.reduce(function(d, u) {
    return d[u] = zEe(u, e.rects, s), d;
  }, {}), a = o[e.placement], l = a.x, c = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[n] = o;
}
const GEe = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: UEe
};
function qEe(i) {
  var e = i.state, t = i.name;
  e.modifiersData[t] = fde({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const KEe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: qEe,
  data: {}
};
function YEe(i) {
  return i === "x" ? "y" : "x";
}
function XEe(i) {
  var e = i.state, t = i.options, n = i.name, r = t.mainAxis, s = r === void 0 ? !0 : r, o = t.altAxis, a = o === void 0 ? !1 : o, l = t.boundary, c = t.rootBoundary, d = t.altBoundary, u = t.padding, h = t.tether, f = h === void 0 ? !0 : h, g = t.tetherOffset, p = g === void 0 ? 0 : g, m = dy(e, {
    boundary: l,
    rootBoundary: c,
    padding: u,
    altBoundary: d
  }), _ = ou(e.placement), b = s_(e.placement), w = !b, y = hj(_), S = YEe(y), x = e.modifiersData.popperOffsets, D = e.rects.reference, E = e.rects.popper, L = typeof p == "function" ? p(Object.assign({}, e.rects, {
    placement: e.placement
  })) : p, k = typeof L == "number" ? {
    mainAxis: L,
    altAxis: L
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, L), N = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, I = {
    x: 0,
    y: 0
  };
  if (x) {
    if (s) {
      var A, P = y === "y" ? Oa : Ma, O = y === "y" ? nc : ic, K = y === "y" ? "height" : "width", W = x[y], F = W + m[P], q = W - m[O], R = f ? -E[K] / 2 : 0, T = b === n_ ? D[K] : E[K], z = b === n_ ? -E[K] : -D[K], X = e.elements.arrow, ae = f && X ? uj(X) : {
        width: 0,
        height: 0
      }, ue = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : cde(), se = ue[P], le = ue[O], oe = mC(0, D[K], ae[K]), re = w ? D[K] / 2 - R - oe - se - k.mainAxis : T - oe - se - k.mainAxis, B = w ? -D[K] / 2 + R + oe + le + k.mainAxis : z + oe + le + k.mainAxis, ee = e.elements.arrow && uS(e.elements.arrow), j = ee ? y === "y" ? ee.clientTop || 0 : ee.clientLeft || 0 : 0, he = (A = N?.[y]) != null ? A : 0, Se = W + re - he - j, ge = W + B - he, te = mC(f ? NE(F, Se) : F, W, f ? ym(q, ge) : q);
      x[y] = te, I[y] = te - W;
    }
    if (a) {
      var be, Ae = y === "x" ? Oa : Ma, He = y === "x" ? nc : ic, de = x[S], ce = S === "y" ? "height" : "width", ie = de + m[Ae], H = de - m[He], Y = [Oa, Ma].indexOf(_) !== -1, Z = (be = N?.[S]) != null ? be : 0, Q = Y ? ie : de - D[ce] - E[ce] - Z + k.altAxis, me = Y ? de + D[ce] + E[ce] - Z - k.altAxis : H, Le = f && Y ? bEe(Q, de, me) : mC(f ? Q : ie, de, f ? me : H);
      x[S] = Le, I[S] = Le - de;
    }
    e.modifiersData[n] = I;
  }
}
const ZEe = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: XEe,
  requiresIfExists: ["offset"]
};
function QEe(i) {
  return {
    scrollLeft: i.scrollLeft,
    scrollTop: i.scrollTop
  };
}
function JEe(i) {
  return i === _l(i) || !Xl(i) ? fj(i) : QEe(i);
}
function $Ee(i) {
  var e = i.getBoundingClientRect(), t = i_(e.width) / i.offsetWidth || 1, n = i_(e.height) / i.offsetHeight || 1;
  return t !== 1 || n !== 1;
}
function eLe(i, e, t) {
  t === void 0 && (t = !1);
  var n = Xl(e), r = Xl(e) && $Ee(e), s = rp(e), o = r_(i, r, t), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !t) && ((mu(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  pj(s)) && (a = JEe(e)), Xl(e) ? (l = r_(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : s && (l.x = gj(s))), {
    x: o.left + a.scrollLeft - l.x,
    y: o.top + a.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function tLe(i) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = [];
  i.forEach(function(s) {
    e.set(s.name, s);
  });
  function r(s) {
    t.add(s.name);
    var o = [].concat(s.requires || [], s.requiresIfExists || []);
    o.forEach(function(a) {
      if (!t.has(a)) {
        var l = e.get(a);
        l && r(l);
      }
    }), n.push(s);
  }
  return i.forEach(function(s) {
    t.has(s.name) || r(s);
  }), n;
}
function nLe(i) {
  var e = tLe(i);
  return gEe.reduce(function(t, n) {
    return t.concat(e.filter(function(r) {
      return r.phase === n;
    }));
  }, []);
}
function iLe(i) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(i());
      });
    })), e;
  };
}
function rLe(i) {
  var e = i.reduce(function(t, n) {
    var r = t[n.name];
    return t[n.name] = r ? Object.assign({}, r, n, {
      options: Object.assign({}, r.options, n.options),
      data: Object.assign({}, r.data, n.data)
    }) : n, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var OK = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function MK() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++)
    e[t] = arguments[t];
  return !e.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function sLe(i) {
  i === void 0 && (i = {});
  var e = i, t = e.defaultModifiers, n = t === void 0 ? [] : t, r = e.defaultOptions, s = r === void 0 ? OK : r;
  return function(a, l, c) {
    c === void 0 && (c = s);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, OK, s),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, u = [], h = !1, f = {
      state: d,
      setOptions: function(_) {
        var b = typeof _ == "function" ? _(d.options) : _;
        p(), d.options = Object.assign({}, s, d.options, b), d.scrollParents = {
          reference: Hm(a) ? vC(a) : a.contextElement ? vC(a.contextElement) : [],
          popper: vC(l)
        };
        var w = nLe(rLe([].concat(n, d.options.modifiers)));
        return d.orderedModifiers = w.filter(function(y) {
          return y.enabled;
        }), g(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var _ = d.elements, b = _.reference, w = _.popper;
          if (MK(b, w)) {
            d.rects = {
              reference: eLe(b, uS(w), d.options.strategy === "fixed"),
              popper: uj(w)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(k) {
              return d.modifiersData[k.name] = Object.assign({}, k.data);
            });
            for (var y = 0; y < d.orderedModifiers.length; y++) {
              if (d.reset === !0) {
                d.reset = !1, y = -1;
                continue;
              }
              var S = d.orderedModifiers[y], x = S.fn, D = S.options, E = D === void 0 ? {} : D, L = S.name;
              typeof x == "function" && (d = x({
                state: d,
                options: E,
                name: L,
                instance: f
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: iLe(function() {
        return new Promise(function(m) {
          f.forceUpdate(), m(d);
        });
      }),
      destroy: function() {
        p(), h = !0;
      }
    };
    if (!MK(a, l))
      return f;
    f.setOptions(c).then(function(m) {
      !h && c.onFirstUpdate && c.onFirstUpdate(m);
    });
    function g() {
      d.orderedModifiers.forEach(function(m) {
        var _ = m.name, b = m.options, w = b === void 0 ? {} : b, y = m.effect;
        if (typeof y == "function") {
          var S = y({
            state: d,
            name: _,
            instance: f,
            options: w
          }), x = function() {
          };
          u.push(S || x);
        }
      });
    }
    function p() {
      u.forEach(function(m) {
        return m();
      }), u = [];
    }
    return f;
  };
}
var oLe = [AEe, KEe, LEe, dj, GEe, HEe, ZEe, SEe, jEe], gde = /* @__PURE__ */ sLe({
  defaultModifiers: oLe
}), aLe = "tippy-box", pde = "tippy-content", lLe = "tippy-backdrop", mde = "tippy-arrow", vde = "tippy-svg-arrow", Op = {
  passive: !0,
  capture: !0
}, _de = function() {
  return document.body;
};
function cLe(i, e) {
  return {}.hasOwnProperty.call(i, e);
}
function Ok(i, e, t) {
  if (Array.isArray(i)) {
    var n = i[e];
    return n ?? (Array.isArray(t) ? t[e] : t);
  }
  return i;
}
function mj(i, e) {
  var t = {}.toString.call(i);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function bde(i, e) {
  return typeof i == "function" ? i.apply(void 0, e) : i;
}
function RK(i, e) {
  if (e === 0)
    return i;
  var t;
  return function(n) {
    clearTimeout(t), t = setTimeout(function() {
      i(n);
    }, e);
  };
}
function dLe(i, e) {
  var t = Object.assign({}, i);
  return e.forEach(function(n) {
    delete t[n];
  }), t;
}
function uLe(i) {
  return i.split(/\s+/).filter(Boolean);
}
function P1(i) {
  return [].concat(i);
}
function FK(i, e) {
  i.indexOf(e) === -1 && i.push(e);
}
function hLe(i) {
  return i.filter(function(e, t) {
    return i.indexOf(e) === t;
  });
}
function fLe(i) {
  return i.split("-")[0];
}
function PE(i) {
  return [].slice.call(i);
}
function BK(i) {
  return Object.keys(i).reduce(function(e, t) {
    return i[t] !== void 0 && (e[t] = i[t]), e;
  }, {});
}
function _C() {
  return document.createElement("div");
}
function uy(i) {
  return ["Element", "Fragment"].some(function(e) {
    return mj(i, e);
  });
}
function gLe(i) {
  return mj(i, "NodeList");
}
function Cde(i) {
  return mj(i, "MouseEvent");
}
function pLe(i) {
  return !!(i && i._tippy && i._tippy.reference === i);
}
function mLe(i) {
  return uy(i) ? [i] : gLe(i) ? PE(i) : Array.isArray(i) ? i : PE(document.querySelectorAll(i));
}
function Mk(i, e) {
  i.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function VK(i, e) {
  i.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function yde(i) {
  var e, t = P1(i), n = t[0];
  return n != null && (e = n.ownerDocument) != null && e.body ? n.ownerDocument : document;
}
function vLe(i, e) {
  var t = e.clientX, n = e.clientY;
  return i.every(function(r) {
    var s = r.popperRect, o = r.popperState, a = r.props, l = a.interactiveBorder, c = fLe(o.placement), d = o.modifiersData.offset;
    if (!d)
      return !0;
    var u = c === "bottom" ? d.top.y : 0, h = c === "top" ? d.bottom.y : 0, f = c === "right" ? d.left.x : 0, g = c === "left" ? d.right.x : 0, p = s.top - n + u > l, m = n - s.bottom - h > l, _ = s.left - t + f > l, b = t - s.right - g > l;
    return p || m || _ || b;
  });
}
function Rk(i, e, t) {
  var n = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(r) {
    i[n](r, t);
  });
}
function HK(i, e) {
  for (var t = e; t; ) {
    var n;
    if (i.contains(t))
      return !0;
    t = t.getRootNode == null || (n = t.getRootNode()) == null ? void 0 : n.host;
  }
  return !1;
}
var Nd = {
  isTouch: !1
}, WK = 0;
function _Le() {
  Nd.isTouch || (Nd.isTouch = !0, window.performance && document.addEventListener("mousemove", wde));
}
function wde() {
  var i = performance.now();
  i - WK < 20 && (Nd.isTouch = !1, document.removeEventListener("mousemove", wde)), WK = i;
}
function bLe() {
  var i = document.activeElement;
  if (pLe(i)) {
    var e = i._tippy;
    i.blur && !e.state.isVisible && i.blur();
  }
}
function CLe() {
  document.addEventListener("touchstart", _Le, Op), window.addEventListener("blur", bLe);
}
var yLe = typeof window < "u" && typeof document < "u", wLe = yLe ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function s1(i) {
  var e = i === "destroy" ? "n already-" : " ";
  return [i + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function jK(i) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return i.replace(e, " ").replace(t, "").trim();
}
function SLe(i) {
  return jK(`
  %ctippy.js

  %c` + jK(i) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function Sde(i) {
  return [
    SLe(i),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var hy;
process.env.NODE_ENV !== "production" && xLe();
function xLe() {
  hy = /* @__PURE__ */ new Set();
}
function eh(i, e) {
  if (i && !hy.has(e)) {
    var t;
    hy.add(e), (t = console).warn.apply(t, Sde(e));
  }
}
function F8(i, e) {
  if (i && !hy.has(e)) {
    var t;
    hy.add(e), (t = console).error.apply(t, Sde(e));
  }
}
function DLe(i) {
  var e = !i, t = Object.prototype.toString.call(i) === "[object Object]" && !i.addEventListener;
  F8(e, ["tippy() was passed", "`" + String(i) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), F8(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var xde = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, ELe = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, nl = Object.assign({
  appendTo: _de,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, xde, ELe), LLe = Object.keys(nl), ILe = function(e) {
  process.env.NODE_ENV !== "production" && Ede(e, []);
  var t = Object.keys(e);
  t.forEach(function(n) {
    nl[n] = e[n];
  });
};
function Dde(i) {
  var e = i.plugins || [], t = e.reduce(function(n, r) {
    var s = r.name, o = r.defaultValue;
    if (s) {
      var a;
      n[s] = i[s] !== void 0 ? i[s] : (a = nl[s]) != null ? a : o;
    }
    return n;
  }, {});
  return Object.assign({}, i, t);
}
function ALe(i, e) {
  var t = e ? Object.keys(Dde(Object.assign({}, nl, {
    plugins: e
  }))) : LLe, n = t.reduce(function(r, s) {
    var o = (i.getAttribute("data-tippy-" + s) || "").trim();
    if (!o)
      return r;
    if (s === "content")
      r[s] = o;
    else
      try {
        r[s] = JSON.parse(o);
      } catch {
        r[s] = o;
      }
    return r;
  }, {});
  return n;
}
function zK(i, e) {
  var t = Object.assign({}, e, {
    content: bde(e.content, [i])
  }, e.ignoreAttributes ? {} : ALe(i, e.plugins));
  return t.aria = Object.assign({}, nl.aria, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function Ede(i, e) {
  i === void 0 && (i = {}), e === void 0 && (e = []);
  var t = Object.keys(i);
  t.forEach(function(n) {
    var r = dLe(nl, Object.keys(xde)), s = !cLe(r, n);
    s && (s = e.filter(function(o) {
      return o.name === n;
    }).length === 0), eh(s, ["`" + n + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var kLe = function() {
  return "innerHTML";
};
function B8(i, e) {
  i[kLe()] = e;
}
function UK(i) {
  var e = _C();
  return i === !0 ? e.className = mde : (e.className = vde, uy(i) ? e.appendChild(i) : B8(e, i)), e;
}
function GK(i, e) {
  uy(e.content) ? (B8(i, ""), i.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? B8(i, e.content) : i.textContent = e.content);
}
function V8(i) {
  var e = i.firstElementChild, t = PE(e.children);
  return {
    box: e,
    content: t.find(function(n) {
      return n.classList.contains(pde);
    }),
    arrow: t.find(function(n) {
      return n.classList.contains(mde) || n.classList.contains(vde);
    }),
    backdrop: t.find(function(n) {
      return n.classList.contains(lLe);
    })
  };
}
function Lde(i) {
  var e = _C(), t = _C();
  t.className = aLe, t.setAttribute("data-state", "hidden"), t.setAttribute("tabindex", "-1");
  var n = _C();
  n.className = pde, n.setAttribute("data-state", "hidden"), GK(n, i.props), e.appendChild(t), t.appendChild(n), r(i.props, i.props);
  function r(s, o) {
    var a = V8(e), l = a.box, c = a.content, d = a.arrow;
    o.theme ? l.setAttribute("data-theme", o.theme) : l.removeAttribute("data-theme"), typeof o.animation == "string" ? l.setAttribute("data-animation", o.animation) : l.removeAttribute("data-animation"), o.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? l.setAttribute("role", o.role) : l.removeAttribute("role"), (s.content !== o.content || s.allowHTML !== o.allowHTML) && GK(c, i.props), o.arrow ? d ? s.arrow !== o.arrow && (l.removeChild(d), l.appendChild(UK(o.arrow))) : l.appendChild(UK(o.arrow)) : d && l.removeChild(d);
  }
  return {
    popper: e,
    onUpdate: r
  };
}
Lde.$$tippy = !0;
var TLe = 1, xx = [], Fk = [];
function NLe(i, e) {
  var t = zK(i, Object.assign({}, nl, Dde(BK(e)))), n, r, s, o = !1, a = !1, l = !1, c = !1, d, u, h, f = [], g = RK(Se, t.interactiveDebounce), p, m = TLe++, _ = null, b = hLe(t.plugins), w = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, y = {
    // properties
    id: m,
    reference: i,
    popper: _C(),
    popperInstance: _,
    props: t,
    state: w,
    plugins: b,
    // methods
    clearDelayTimeouts: Q,
    setProps: me,
    setContent: Le,
    show: xe,
    hide: Ue,
    hideWithInteractivity: je,
    enable: Y,
    disable: Z,
    unmount: Ze,
    destroy: _e
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && F8(!0, "render() function has not been supplied."), y;
  var S = t.render(y), x = S.popper, D = S.onUpdate;
  x.setAttribute("data-tippy-root", ""), x.id = "tippy-" + y.id, y.popper = x, i._tippy = y, x._tippy = y;
  var E = b.map(function(U) {
    return U.fn(y);
  }), L = i.hasAttribute("aria-expanded");
  return ee(), R(), W(), F("onCreate", [y]), t.showOnCreate && ie(), x.addEventListener("mouseenter", function() {
    y.props.interactive && y.state.isVisible && y.clearDelayTimeouts();
  }), x.addEventListener("mouseleave", function() {
    y.props.interactive && y.props.trigger.indexOf("mouseenter") >= 0 && P().addEventListener("mousemove", g);
  }), y;
  function k() {
    var U = y.props.touch;
    return Array.isArray(U) ? U : [U, 0];
  }
  function N() {
    return k()[0] === "hold";
  }
  function I() {
    var U;
    return !!((U = y.props.render) != null && U.$$tippy);
  }
  function A() {
    return p || i;
  }
  function P() {
    var U = A().parentNode;
    return U ? yde(U) : document;
  }
  function O() {
    return V8(x);
  }
  function K(U) {
    return y.state.isMounted && !y.state.isVisible || Nd.isTouch || d && d.type === "focus" ? 0 : Ok(y.props.delay, U ? 0 : 1, nl.delay);
  }
  function W(U) {
    U === void 0 && (U = !1), x.style.pointerEvents = y.props.interactive && !U ? "" : "none", x.style.zIndex = "" + y.props.zIndex;
  }
  function F(U, fe, Ee) {
    if (Ee === void 0 && (Ee = !0), E.forEach(function(Pe) {
      Pe[U] && Pe[U].apply(Pe, fe);
    }), Ee) {
      var Me;
      (Me = y.props)[U].apply(Me, fe);
    }
  }
  function q() {
    var U = y.props.aria;
    if (U.content) {
      var fe = "aria-" + U.content, Ee = x.id, Me = P1(y.props.triggerTarget || i);
      Me.forEach(function(Pe) {
        var et = Pe.getAttribute(fe);
        if (y.state.isVisible)
          Pe.setAttribute(fe, et ? et + " " + Ee : Ee);
        else {
          var gt = et && et.replace(Ee, "").trim();
          gt ? Pe.setAttribute(fe, gt) : Pe.removeAttribute(fe);
        }
      });
    }
  }
  function R() {
    if (!(L || !y.props.aria.expanded)) {
      var U = P1(y.props.triggerTarget || i);
      U.forEach(function(fe) {
        y.props.interactive ? fe.setAttribute("aria-expanded", y.state.isVisible && fe === A() ? "true" : "false") : fe.removeAttribute("aria-expanded");
      });
    }
  }
  function T() {
    P().removeEventListener("mousemove", g), xx = xx.filter(function(U) {
      return U !== g;
    });
  }
  function z(U) {
    if (!(Nd.isTouch && (l || U.type === "mousedown"))) {
      var fe = U.composedPath && U.composedPath()[0] || U.target;
      if (!(y.props.interactive && HK(x, fe))) {
        if (P1(y.props.triggerTarget || i).some(function(Ee) {
          return HK(Ee, fe);
        })) {
          if (Nd.isTouch || y.state.isVisible && y.props.trigger.indexOf("click") >= 0)
            return;
        } else
          F("onClickOutside", [y, U]);
        y.props.hideOnClick === !0 && (y.clearDelayTimeouts(), y.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), y.state.isMounted || se());
      }
    }
  }
  function X() {
    l = !0;
  }
  function ae() {
    l = !1;
  }
  function ue() {
    var U = P();
    U.addEventListener("mousedown", z, !0), U.addEventListener("touchend", z, Op), U.addEventListener("touchstart", ae, Op), U.addEventListener("touchmove", X, Op);
  }
  function se() {
    var U = P();
    U.removeEventListener("mousedown", z, !0), U.removeEventListener("touchend", z, Op), U.removeEventListener("touchstart", ae, Op), U.removeEventListener("touchmove", X, Op);
  }
  function le(U, fe) {
    re(U, function() {
      !y.state.isVisible && x.parentNode && x.parentNode.contains(x) && fe();
    });
  }
  function oe(U, fe) {
    re(U, fe);
  }
  function re(U, fe) {
    var Ee = O().box;
    function Me(Pe) {
      Pe.target === Ee && (Rk(Ee, "remove", Me), fe());
    }
    if (U === 0)
      return fe();
    Rk(Ee, "remove", u), Rk(Ee, "add", Me), u = Me;
  }
  function B(U, fe, Ee) {
    Ee === void 0 && (Ee = !1);
    var Me = P1(y.props.triggerTarget || i);
    Me.forEach(function(Pe) {
      Pe.addEventListener(U, fe, Ee), f.push({
        node: Pe,
        eventType: U,
        handler: fe,
        options: Ee
      });
    });
  }
  function ee() {
    N() && (B("touchstart", he, {
      passive: !0
    }), B("touchend", ge, {
      passive: !0
    })), uLe(y.props.trigger).forEach(function(U) {
      if (U !== "manual")
        switch (B(U, he), U) {
          case "mouseenter":
            B("mouseleave", ge);
            break;
          case "focus":
            B(wLe ? "focusout" : "blur", te);
            break;
          case "focusin":
            B("focusout", te);
            break;
        }
    });
  }
  function j() {
    f.forEach(function(U) {
      var fe = U.node, Ee = U.eventType, Me = U.handler, Pe = U.options;
      fe.removeEventListener(Ee, Me, Pe);
    }), f = [];
  }
  function he(U) {
    var fe, Ee = !1;
    if (!(!y.state.isEnabled || be(U) || a)) {
      var Me = ((fe = d) == null ? void 0 : fe.type) === "focus";
      d = U, p = U.currentTarget, R(), !y.state.isVisible && Cde(U) && xx.forEach(function(Pe) {
        return Pe(U);
      }), U.type === "click" && (y.props.trigger.indexOf("mouseenter") < 0 || o) && y.props.hideOnClick !== !1 && y.state.isVisible ? Ee = !0 : ie(U), U.type === "click" && (o = !Ee), Ee && !Me && H(U);
    }
  }
  function Se(U) {
    var fe = U.target, Ee = A().contains(fe) || x.contains(fe);
    if (!(U.type === "mousemove" && Ee)) {
      var Me = ce().concat(x).map(function(Pe) {
        var et, gt = Pe._tippy, Vt = (et = gt.popperInstance) == null ? void 0 : et.state;
        return Vt ? {
          popperRect: Pe.getBoundingClientRect(),
          popperState: Vt,
          props: t
        } : null;
      }).filter(Boolean);
      vLe(Me, U) && (T(), H(U));
    }
  }
  function ge(U) {
    var fe = be(U) || y.props.trigger.indexOf("click") >= 0 && o;
    if (!fe) {
      if (y.props.interactive) {
        y.hideWithInteractivity(U);
        return;
      }
      H(U);
    }
  }
  function te(U) {
    y.props.trigger.indexOf("focusin") < 0 && U.target !== A() || y.props.interactive && U.relatedTarget && x.contains(U.relatedTarget) || H(U);
  }
  function be(U) {
    return Nd.isTouch ? N() !== U.type.indexOf("touch") >= 0 : !1;
  }
  function Ae() {
    He();
    var U = y.props, fe = U.popperOptions, Ee = U.placement, Me = U.offset, Pe = U.getReferenceClientRect, et = U.moveTransition, gt = I() ? V8(x).arrow : null, Vt = Pe ? {
      getBoundingClientRect: Pe,
      contextElement: Pe.contextElement || A()
    } : i, Zt = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(fn) {
        var xn = fn.state;
        if (I()) {
          var rt = O(), Ei = rt.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Nn) {
            Nn === "placement" ? Ei.setAttribute("data-placement", xn.placement) : xn.attributes.popper["data-popper-" + Nn] ? Ei.setAttribute("data-" + Nn, "") : Ei.removeAttribute("data-" + Nn);
          }), xn.attributes.popper = {};
        }
      }
    }, St = [{
      name: "offset",
      options: {
        offset: Me
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !et
      }
    }, Zt];
    I() && gt && St.push({
      name: "arrow",
      options: {
        element: gt,
        padding: 3
      }
    }), St.push.apply(St, fe?.modifiers || []), y.popperInstance = gde(Vt, x, Object.assign({}, fe, {
      placement: Ee,
      onFirstUpdate: h,
      modifiers: St
    }));
  }
  function He() {
    y.popperInstance && (y.popperInstance.destroy(), y.popperInstance = null);
  }
  function de() {
    var U = y.props.appendTo, fe, Ee = A();
    y.props.interactive && U === _de || U === "parent" ? fe = Ee.parentNode : fe = bde(U, [Ee]), fe.contains(x) || fe.appendChild(x), y.state.isMounted = !0, Ae(), process.env.NODE_ENV !== "production" && eh(y.props.interactive && U === nl.appendTo && Ee.nextElementSibling !== x, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function ce() {
    return PE(x.querySelectorAll("[data-tippy-root]"));
  }
  function ie(U) {
    y.clearDelayTimeouts(), U && F("onTrigger", [y, U]), ue();
    var fe = K(!0), Ee = k(), Me = Ee[0], Pe = Ee[1];
    Nd.isTouch && Me === "hold" && Pe && (fe = Pe), fe ? n = setTimeout(function() {
      y.show();
    }, fe) : y.show();
  }
  function H(U) {
    if (y.clearDelayTimeouts(), F("onUntrigger", [y, U]), !y.state.isVisible) {
      se();
      return;
    }
    if (!(y.props.trigger.indexOf("mouseenter") >= 0 && y.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(U.type) >= 0 && o)) {
      var fe = K(!1);
      fe ? r = setTimeout(function() {
        y.state.isVisible && y.hide();
      }, fe) : s = requestAnimationFrame(function() {
        y.hide();
      });
    }
  }
  function Y() {
    y.state.isEnabled = !0;
  }
  function Z() {
    y.hide(), y.state.isEnabled = !1;
  }
  function Q() {
    clearTimeout(n), clearTimeout(r), cancelAnimationFrame(s);
  }
  function me(U) {
    if (process.env.NODE_ENV !== "production" && eh(y.state.isDestroyed, s1("setProps")), !y.state.isDestroyed) {
      F("onBeforeUpdate", [y, U]), j();
      var fe = y.props, Ee = zK(i, Object.assign({}, fe, BK(U), {
        ignoreAttributes: !0
      }));
      y.props = Ee, ee(), fe.interactiveDebounce !== Ee.interactiveDebounce && (T(), g = RK(Se, Ee.interactiveDebounce)), fe.triggerTarget && !Ee.triggerTarget ? P1(fe.triggerTarget).forEach(function(Me) {
        Me.removeAttribute("aria-expanded");
      }) : Ee.triggerTarget && i.removeAttribute("aria-expanded"), R(), W(), D && D(fe, Ee), y.popperInstance && (Ae(), ce().forEach(function(Me) {
        requestAnimationFrame(Me._tippy.popperInstance.forceUpdate);
      })), F("onAfterUpdate", [y, U]);
    }
  }
  function Le(U) {
    y.setProps({
      content: U
    });
  }
  function xe() {
    process.env.NODE_ENV !== "production" && eh(y.state.isDestroyed, s1("show"));
    var U = y.state.isVisible, fe = y.state.isDestroyed, Ee = !y.state.isEnabled, Me = Nd.isTouch && !y.props.touch, Pe = Ok(y.props.duration, 0, nl.duration);
    if (!(U || fe || Ee || Me) && !A().hasAttribute("disabled") && (F("onShow", [y], !1), y.props.onShow(y) !== !1)) {
      if (y.state.isVisible = !0, I() && (x.style.visibility = "visible"), W(), ue(), y.state.isMounted || (x.style.transition = "none"), I()) {
        var et = O(), gt = et.box, Vt = et.content;
        Mk([gt, Vt], 0);
      }
      h = function() {
        var St;
        if (!(!y.state.isVisible || c)) {
          if (c = !0, x.offsetHeight, x.style.transition = y.props.moveTransition, I() && y.props.animation) {
            var Ht = O(), fn = Ht.box, xn = Ht.content;
            Mk([fn, xn], Pe), VK([fn, xn], "visible");
          }
          q(), R(), FK(Fk, y), (St = y.popperInstance) == null || St.forceUpdate(), F("onMount", [y]), y.props.animation && I() && oe(Pe, function() {
            y.state.isShown = !0, F("onShown", [y]);
          });
        }
      }, de();
    }
  }
  function Ue() {
    process.env.NODE_ENV !== "production" && eh(y.state.isDestroyed, s1("hide"));
    var U = !y.state.isVisible, fe = y.state.isDestroyed, Ee = !y.state.isEnabled, Me = Ok(y.props.duration, 1, nl.duration);
    if (!(U || fe || Ee) && (F("onHide", [y], !1), y.props.onHide(y) !== !1)) {
      if (y.state.isVisible = !1, y.state.isShown = !1, c = !1, o = !1, I() && (x.style.visibility = "hidden"), T(), se(), W(!0), I()) {
        var Pe = O(), et = Pe.box, gt = Pe.content;
        y.props.animation && (Mk([et, gt], Me), VK([et, gt], "hidden"));
      }
      q(), R(), y.props.animation ? I() && le(Me, y.unmount) : y.unmount();
    }
  }
  function je(U) {
    process.env.NODE_ENV !== "production" && eh(y.state.isDestroyed, s1("hideWithInteractivity")), P().addEventListener("mousemove", g), FK(xx, g), g(U);
  }
  function Ze() {
    process.env.NODE_ENV !== "production" && eh(y.state.isDestroyed, s1("unmount")), y.state.isVisible && y.hide(), y.state.isMounted && (He(), ce().forEach(function(U) {
      U._tippy.unmount();
    }), x.parentNode && x.parentNode.removeChild(x), Fk = Fk.filter(function(U) {
      return U !== y;
    }), y.state.isMounted = !1, F("onHidden", [y]));
  }
  function _e() {
    process.env.NODE_ENV !== "production" && eh(y.state.isDestroyed, s1("destroy")), !y.state.isDestroyed && (y.clearDelayTimeouts(), y.unmount(), j(), delete i._tippy, y.state.isDestroyed = !0, F("onDestroy", [y]));
  }
}
function hS(i, e) {
  e === void 0 && (e = {});
  var t = nl.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (DLe(i), Ede(e, t)), CLe();
  var n = Object.assign({}, e, {
    plugins: t
  }), r = mLe(i);
  if (process.env.NODE_ENV !== "production") {
    var s = uy(n.content), o = r.length > 1;
    eh(s && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = r.reduce(function(l, c) {
    var d = c && NLe(c, n);
    return d && l.push(d), l;
  }, []);
  return uy(i) ? a[0] : a;
}
hS.defaultProps = nl;
hS.setDefaultProps = ILe;
hS.currentInput = Nd;
Object.assign({}, dj, {
  effect: function(e) {
    var t = e.state, n = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow);
  }
});
var H8 = {
  clientX: 0,
  clientY: 0
}, Dx = [];
function Ide(i) {
  var e = i.clientX, t = i.clientY;
  H8 = {
    clientX: e,
    clientY: t
  };
}
function PLe(i) {
  i.addEventListener("mousemove", Ide);
}
function OLe(i) {
  i.removeEventListener("mousemove", Ide);
}
var MLe = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(e) {
    var t = e.reference, n = yde(e.props.triggerTarget || t), r = !1, s = !1, o = !0, a = e.props;
    function l() {
      return e.props.followCursor === "initial" && e.state.isVisible;
    }
    function c() {
      n.addEventListener("mousemove", h);
    }
    function d() {
      n.removeEventListener("mousemove", h);
    }
    function u() {
      r = !0, e.setProps({
        getReferenceClientRect: null
      }), r = !1;
    }
    function h(p) {
      var m = p.target ? t.contains(p.target) : !0, _ = e.props.followCursor, b = p.clientX, w = p.clientY, y = t.getBoundingClientRect(), S = b - y.left, x = w - y.top;
      (m || !e.props.interactive) && e.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var E = t.getBoundingClientRect(), L = b, k = w;
          _ === "initial" && (L = E.left + S, k = E.top + x);
          var N = _ === "horizontal" ? E.top : k, I = _ === "vertical" ? E.right : L, A = _ === "horizontal" ? E.bottom : k, P = _ === "vertical" ? E.left : L;
          return {
            width: I - P,
            height: A - N,
            top: N,
            right: I,
            bottom: A,
            left: P
          };
        }
      });
    }
    function f() {
      e.props.followCursor && (Dx.push({
        instance: e,
        doc: n
      }), PLe(n));
    }
    function g() {
      Dx = Dx.filter(function(p) {
        return p.instance !== e;
      }), Dx.filter(function(p) {
        return p.doc === n;
      }).length === 0 && OLe(n);
    }
    return {
      onCreate: f,
      onDestroy: g,
      onBeforeUpdate: function() {
        a = e.props;
      },
      onAfterUpdate: function(m, _) {
        var b = _.followCursor;
        r || b !== void 0 && a.followCursor !== b && (g(), b ? (f(), e.state.isMounted && !s && !l() && c()) : (d(), u()));
      },
      onMount: function() {
        e.props.followCursor && !s && (o && (h(H8), o = !1), l() || c());
      },
      onTrigger: function(m, _) {
        Cde(_) && (H8 = {
          clientX: _.clientX,
          clientY: _.clientY
        }), s = _.type === "focus";
      },
      onHidden: function() {
        e.props.followCursor && (u(), d(), o = !0);
      }
    };
  }
};
hS.setDefaultProps({
  render: Lde
});
function Ade(i, e) {
  if (i == null) return {};
  var t = {}, n = Object.keys(i), r, s;
  for (s = 0; s < n.length; s++)
    r = n[s], !(e.indexOf(r) >= 0) && (t[r] = i[r]);
  return t;
}
var kde = typeof window < "u" && typeof document < "u";
function W8(i, e) {
  i && (typeof i == "function" && i(e), {}.hasOwnProperty.call(i, "current") && (i.current = e));
}
function qK() {
  return kde && document.createElement("div");
}
function RLe(i) {
  var e = {
    "data-placement": i.placement
  };
  return i.referenceHidden && (e["data-reference-hidden"] = ""), i.escaped && (e["data-escaped"] = ""), e;
}
function Tde(i, e) {
  if (i === e)
    return !0;
  if (typeof i == "object" && i != null && typeof e == "object" && e != null) {
    if (Object.keys(i).length !== Object.keys(e).length)
      return !1;
    for (var t in i)
      if (e.hasOwnProperty(t)) {
        if (!Tde(i[t], e[t]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function FLe(i) {
  var e = [];
  return i.forEach(function(t) {
    e.find(function(n) {
      return Tde(t, n);
    }) || e.push(t);
  }), e;
}
function BLe(i, e) {
  var t, n;
  return Object.assign({}, e, {
    popperOptions: Object.assign({}, i.popperOptions, e.popperOptions, {
      modifiers: FLe([].concat(((t = i.popperOptions) == null ? void 0 : t.modifiers) || [], ((n = e.popperOptions) == null ? void 0 : n.modifiers) || []))
    })
  });
}
var Bk = kde ? aA : $e;
function VLe(i) {
  var e = Nt();
  return e.current || (e.current = typeof i == "function" ? i() : i), e.current;
}
function KK(i, e, t) {
  t.split(/\s+/).forEach(function(n) {
    n && i.classList[e](n);
  });
}
var HLe = {
  name: "className",
  defaultValue: "",
  fn: function(e) {
    var t = e.popper.firstElementChild, n = function() {
      var a;
      return !!((a = e.props.render) != null && a.$$tippy);
    };
    function r() {
      if (e.props.className && !n()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      KK(t, "add", e.props.className);
    }
    function s() {
      n() && KK(t, "remove", e.props.className);
    }
    return {
      onCreate: r,
      onBeforeUpdate: s,
      onAfterUpdate: r
    };
  }
};
function WLe(i) {
  function e(t) {
    var n = t.children, r = t.content, s = t.visible, o = t.singleton, a = t.render, l = t.reference, c = t.disabled, d = c === void 0 ? !1 : c, u = t.ignoreAttributes, h = u === void 0 ? !0 : u;
    t.__source, t.__self;
    var f = Ade(t, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), g = s !== void 0, p = o !== void 0, m = Oe(!1), _ = m[0], b = m[1], w = Oe({}), y = w[0], S = w[1], x = Oe(), D = x[0], E = x[1], L = VLe(function() {
      return {
        container: qK(),
        renders: 1
      };
    }), k = Object.assign({
      ignoreAttributes: h
    }, f, {
      content: L.container
    });
    g && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(P) {
      k[P] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + P + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), k.trigger = "manual", k.hideOnClick = !1), p && (d = !0);
    var N = k, I = k.plugins || [];
    a && (N = Object.assign({}, k, {
      plugins: p && o.data != null ? [].concat(I, [{
        fn: function() {
          return {
            onTrigger: function(K, W) {
              var F = o.data.children.find(function(q) {
                var R = q.instance;
                return R.reference === W.currentTarget;
              });
              K.state.$$activeSingletonInstance = F.instance, E(F.content);
            }
          };
        }
      }]) : I,
      render: function() {
        return {
          popper: L.container
        };
      }
    }));
    var A = [l].concat(n ? [n.type] : []);
    return Bk(function() {
      var P = l;
      l && l.hasOwnProperty("current") && (P = l.current);
      var O = i(P || L.ref || qK(), Object.assign({}, N, {
        plugins: [HLe].concat(k.plugins || [])
      }));
      return L.instance = O, d && O.disable(), s && O.show(), p && o.hook({
        instance: O,
        content: r,
        props: N,
        setSingletonContent: E
      }), b(!0), function() {
        O.destroy(), o?.cleanup(O);
      };
    }, A), Bk(function() {
      var P;
      if (L.renders === 1) {
        L.renders++;
        return;
      }
      var O = L.instance;
      O.setProps(BLe(O.props, N)), (P = O.popperInstance) == null || P.forceUpdate(), d ? O.disable() : O.enable(), g && (s ? O.show() : O.hide()), p && o.hook({
        instance: O,
        content: r,
        props: N,
        setSingletonContent: E
      });
    }), Bk(function() {
      var P;
      if (a) {
        var O = L.instance;
        O.setProps({
          popperOptions: Object.assign({}, O.props.popperOptions, {
            modifiers: [].concat((((P = O.props.popperOptions) == null ? void 0 : P.modifiers) || []).filter(function(K) {
              var W = K.name;
              return W !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(W) {
                var F, q = W.state, R = (F = q.modifiersData) == null ? void 0 : F.hide;
                (y.placement !== q.placement || y.referenceHidden !== R?.isReferenceHidden || y.escaped !== R?.hasPopperEscaped) && S({
                  placement: q.placement,
                  referenceHidden: R?.isReferenceHidden,
                  escaped: R?.hasPopperEscaped
                }), q.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [y.placement, y.referenceHidden, y.escaped].concat(A)), /* @__PURE__ */ it.createElement(it.Fragment, null, n ? /* @__PURE__ */ nd(n, {
      ref: function(O) {
        L.ref = O, W8(n.ref, O);
      }
    }) : null, _ && /* @__PURE__ */ kW(a ? a(RLe(y), D, L.instance) : r, L.container));
  }
  return e;
}
var jLe = function(i, e) {
  return /* @__PURE__ */ tS(function(n, r) {
    var s = n.children, o = Ade(n, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ it.createElement(i, Object.assign({}, e, o), s ? /* @__PURE__ */ nd(s, {
        ref: function(l) {
          W8(r, l), W8(s.ref, l);
        }
      }) : null)
    );
  });
}, wn = /* @__PURE__ */ jLe(/* @__PURE__ */ WLe(hS));
const j8 = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ G.createElement("path", { fill: "#959BA1", d: "M10 2a8 8 0 0 1 6.32 12.905l5.044 5.045a1 1 0 1 1-1.414 1.414l-5.045-5.043A8 8 0 1 1 10 2zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12z" }))), Nde = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M6 12H18M2 7.5H21.5M9.75 16.5H14.25", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Pde = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M23 7C23 8.65685 21.6569 10 20 10C18.3431 10 17 8.65685 17 7C17 5.34315 18.3431 4 20 4C21.6569 4 23 5.34315 23 7Z", fill: "#F33E3E" }), /* @__PURE__ */ G.createElement("path", { d: "M6 12H16M2 7.5L14 7.5M9.75 16.5H14.25", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Ode = (i = {}) => ({
  container: (e, t) => ({
    ...e,
    ...t.isDisabled && {
      cursor: "not-allowed",
      pointerEvents: "auto"
    }
  }),
  menuList: (e) => ({
    ...e,
    padding: 0,
    paddingBlock: "4px",
    cursor: "pointer"
  }),
  control: (e, t) => ({
    ...e,
    minHeight: "32px",
    boxShadow: "none",
    backgroundColor: t.isDisabled ? "var(--N100)" : "var(--N50)",
    border: "1px solid var(--N200)",
    cursor: t.isDisabled ? "not-allowed" : "pointer",
    "&:hover": {
      borderColor: "var(--N300)"
    },
    "&:focus, &:focus-within": {
      borderColor: "var(--B500)",
      outline: "none"
    }
  }),
  option: (e, t) => ({
    ...e,
    color: "var(--N900)",
    // eslint-disable-next-line no-nested-ternary
    backgroundColor: t.isSelected ? "var(--B100)" : t.isFocused ? "var(--N100)" : "white",
    padding: "10px 12px",
    cursor: "pointer",
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 400,
    ":active": {
      backgroundColor: "var(--N100)"
    }
  }),
  dropdownIndicator: (e, t) => ({
    ...e,
    color: "var(--N600)",
    padding: "0 8px",
    transition: "all .2s ease",
    transform: t.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
  }),
  valueContainer: (e) => ({
    ...e,
    padding: "0 8px",
    fontWeight: "400"
  }),
  loadingMessage: (e) => ({
    ...e,
    color: "var(--N600)"
  }),
  noOptionsMessage: (e) => ({
    ...e,
    color: "var(--N600)"
  }),
  placeholder: (e) => ({
    ...e,
    color: "var(--N500)",
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 400,
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  group: (e) => ({
    ...e,
    paddingTop: "4px",
    paddingBottom: 0
  }),
  groupHeading: (e) => ({
    ...e,
    fontWeight: 600,
    fontSize: "12px",
    color: "var(--N900)",
    backgroundColor: "var(--N100)",
    marginBottom: 0,
    padding: "4px 8px",
    textTransform: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  ...i
}), zLe = (i, e) => i ? "var(--B100)" : e ? "var(--N50)" : "var(--white)", Mde = (i = {}) => (e, t) => ({
  ...e,
  backgroundColor: zLe(t.isSelected, t.isFocused),
  color: t.isSelected ? "var(--B500)" : "var(--N900)",
  textOverflow: "ellipsis",
  fontWeight: "500",
  overflow: "hidden",
  textAlign: "left",
  whiteSpace: "nowrap",
  cursor: "pointer",
  fontSize: "13px",
  ...i
}), G_t = (i) => {
  const { selectProps: e, data: t, showTippy: n, style: r, placement: s, tippyContent: o, tippyClass: a } = i;
  e.styles.option = Mde(r);
  const l = () => /* @__PURE__ */ v.jsx("div", { onClick: Cr, children: /* @__PURE__ */ v.jsx(zi.Option, { ...i }) });
  return n ? /* @__PURE__ */ v.jsx(
    wn,
    {
      className: a || "default-white",
      arrow: !1,
      placement: s || "right",
      content: o || t.label,
      children: l()
    }
  ) : l();
}, Rde = () => /* @__PURE__ */ v.jsx(Yr, {}), ULe = (i) => {
  const { data: e } = i;
  return e.label ? /* @__PURE__ */ v.jsx(zi.GroupHeading, { ...i, children: /* @__PURE__ */ v.jsx("div", { className: "flex dc__no-text-transform flex-justify dc__truncate-text h-100", children: /* @__PURE__ */ v.jsx("span", { className: "dc__truncate-text", children: e.label }) }) }) : null;
}, Fde = Ode(), GLe = ({
  handleApplyFilter: i,
  ...e
}) => {
  const t = () => {
    e.selectProps.onInputChange("", {
      action: "set-value",
      prevInputValue: e.selectProps.inputValue
    }), i();
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(zi.MenuList, { ...e }),
    e.selectProps.options.length > 0 && /* @__PURE__ */ v.jsx("div", { className: "p-8 dc__position-sticky dc__bottom-0 dc__border-top-n1 bcn-0 dc__bottom-radius-4", children: /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        className: "dc__unset-button-styles w-100 br-4 h-28 flex bcb-5 cn-0 fw-6 lh-28 fs-12 h-28 br-4 pt-5 pr-12 pb-5 pl-12",
        onClick: t,
        "aria-label": "Apply filters",
        children: "Apply"
      }
    ) })
  ] });
}, qLe = ({
  title: i,
  ...e
}) => {
  const { children: t, selectProps: n, getValue: r } = e, s = r() || [], o = () => n.menuIsOpen ? n.inputValue ? /* @__PURE__ */ v.jsx(j8, { className: "icon-dim-16 dc__no-shrink mr-4 mw-18" }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(j8, { className: "icon-dim-16 dc__no-shrink mr-4 mw-18" }),
    /* @__PURE__ */ v.jsx("span", { className: "dc__position-abs dc__left-35 cn-5 ml-2", children: n.placeholder })
  ] }) : s.length ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(Pde, { className: "icon-dim-16 dc__no-shrink mr-4 mw-18" }),
    /* @__PURE__ */ v.jsx("span", { className: "dc__position-abs dc__left-35 cn-9 fs-13 fw-4 lh-20", children: i })
  ] }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(Nde, { className: "icon-dim-16 dc__no-shrink mr-4 mw-18" }),
    /* @__PURE__ */ v.jsx("span", { className: "dc__position-abs dc__left-35 cn-5 fs-13 fw-4 lh-20", children: i })
  ] });
  return /* @__PURE__ */ v.jsx(zi.ValueContainer, { ...e, children: /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center", children: [
    o(),
    nd(t[1])
  ] }) });
}, YK = {
  container: (i, e) => ({
    ...i,
    ...e.isDisabled && {
      cursor: "not-allowed",
      pointerEvents: "auto"
    },
    minHeight: "36px",
    width: "100%"
  }),
  control: (i, e) => ({
    ...i,
    boxShadow: "none",
    minHeight: "36px",
    backgroundColor: "var(--N50)",
    cursor: e.isDisabled ? "not-allowed" : "pointer",
    opacity: e.isDisabled ? 0.5 : 1
  }),
  singleValue: (i) => ({
    ...i,
    fontWeight: 400,
    color: "var(--N900)",
    fontSize: "13px"
  }),
  option: (i, e) => ({
    ...i,
    padding: "6px 8px 6px 0",
    backgroundColor: e.isFocused ? "var(--N100)" : "white",
    color: "var(--N900)",
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "13px"
  }),
  valueContainer: (i) => ({
    ...i,
    padding: "4px 0px 4px 8px",
    display: "flex",
    minHeight: "36px",
    gap: "6px"
  }),
  dropdownIndicator: (i, e) => ({
    ...i,
    transition: "all .2s ease",
    transform: e.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
    ...e.isDisabled ? { opacity: e.isDisabled ? 0.7 : 1 } : {}
  }),
  group: (i) => ({
    ...i,
    paddingTop: "4px",
    paddingBottom: 0
  }),
  groupHeading: (i) => ({
    ...i,
    fontWeight: 600,
    fontSize: "12px",
    color: "var(--N900)",
    backgroundColor: "var(--N100)",
    marginBottom: 0,
    padding: "4px 8px",
    textTransform: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  menuList: (i) => ({
    ...i,
    padding: 0,
    marginBottom: "4px"
  }),
  multiValue: (i) => ({
    ...i,
    border: "1px solid var(--N200)",
    borderRadius: "4px",
    background: "white",
    height: "28px",
    margin: "0px",
    padding: "2px",
    fontSize: "13px"
  }),
  multiValueLabel: (i) => ({
    ...i,
    padding: "0px",
    fontSize: "13px"
  }),
  placeholder: (i) => ({
    ...i,
    position: "absolute"
  })
}, KLe = ({
  locator: i,
  label: e,
  isSelected: t,
  handleBulkSelection: n,
  icon: r,
  iconClass: s
}) => {
  const o = () => {
    n({
      action: i
    });
  };
  return /* @__PURE__ */ v.jsxs(
    "button",
    {
      "data-testid": `bulk-action-${i}`,
      onClick: o,
      className: `dc__no-border dc__outline-none-imp w-100 flexbox h-32 dc__align-items-center pt-6 pr-8 pb-6 pl-8 dc__gap-8 ${t ? "cb-5 bcb-1 icon-stroke-b5 fs-13 fw-6 lh-20" : "dc__no-background cn-9 fs-13 fw-4 lh-20 dc__hover-n50"}`,
      type: "button",
      children: [
        /* @__PURE__ */ v.jsx(r, { className: `icon-dim-16 ${s || ""}` }),
        e
      ]
    }
  );
};
var so = /* @__PURE__ */ ((i) => (i.CLEAR_ALL_SELECTIONS = "CLEAR_ALL_SELECTIONS", i.CLEAR_IDENTIFIERS = "CLEAR_IDENTIFIERS", i.SELECT_ALL_ACROSS_PAGES = "SELECT_ALL_ACROSS_PAGES", i.SELECT_ALL_ON_PAGE = "SELECT_ALL_ON_PAGE", i.SELECT_IDENTIFIER = "SELECT_IDENTIFIER", i.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION = "CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION", i.CLEAR_SELECTIONS_AND_SELECT_ALL_ACROSS_PAGES = "CLEAR_SELECTIONS_AND_SELECT_ALL_ACROSS_PAGES", i))(so || {}), Bde = /* @__PURE__ */ ((i) => (i.OPEN = "OPEN", i.CLOSED = "CLOSED", i))(Bde || {});
const YLe = "bulk-selection-pop-up-menu", Vk = {
  [so.SELECT_ALL_ON_PAGE]: "All on this page",
  [so.SELECT_ALL_ACROSS_PAGES]: "All across pages",
  [so.CLEAR_ALL_SELECTIONS]: "Clear selection(s)"
}, Kb = "*", XLe = (i) => `Invalid action ${i} passed to useBulkSelection`, ZLe = "useBulkSelection must be used within BulkSelectionContext", XK = "Selections on other pages are cleared", Vde = nf({
  selectedIdentifiers: {},
  handleBulkSelection: El,
  isChecked: !1,
  checkboxValue: Aa.CHECKED,
  isBulkSelectionApplied: !1,
  getSelectedIdentifiersCount: El
}), QLe = () => {
  const i = x0(Vde);
  if (!i)
    throw new Error(ZLe);
  return i;
}, q_t = ({
  children: i,
  identifiers: e,
  getSelectAllDialogStatus: t
}) => {
  const [n, r] = Oe({}), s = n[Kb], o = () => Object.keys(n).length, a = (g, p) => {
    const m = JSON.parse(JSON.stringify(g));
    p.forEach((_) => {
      delete m[_];
    }), r(m);
  }, l = (g) => {
    const p = JSON.parse(JSON.stringify(n));
    s && delete p[Kb], r({
      ...p,
      ...g
    });
  }, c = ({ action: g, data: p }) => {
    const m = p?.identifierIds ?? [], _ = p?.identifierObject ?? {};
    switch (g) {
      case so.CLEAR_ALL_SELECTIONS:
        r({});
        break;
      case so.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION: {
        In.info(XK), a(e, m);
        break;
      }
      case so.CLEAR_IDENTIFIERS: {
        a(n, m);
        break;
      }
      case so.SELECT_ALL_ACROSS_PAGES: {
        if (s || o() > 0 && t() === Bde.OPEN)
          return;
        r({
          [Kb]: !0
        });
        break;
      }
      case so.CLEAR_SELECTIONS_AND_SELECT_ALL_ACROSS_PAGES:
        r({
          [Kb]: !0
        });
        break;
      case so.SELECT_ALL_ON_PAGE: {
        n[Kb] && In.info(XK), l(e);
        break;
      }
      case so.SELECT_IDENTIFIER: {
        l(_);
        break;
      }
      default:
        throw new Error(XLe(g));
    }
  }, d = () => Object.keys(n).length === 0 ? {
    isChecked: !1,
    checkboxValue: Aa.CHECKED
  } : s ? {
    isChecked: !0,
    checkboxValue: Aa.BULK_CHECKED
  } : Object.keys(e).every(
    (m) => n[m]
  ) ? {
    isChecked: !0,
    checkboxValue: Aa.CHECKED
  } : {
    isChecked: !0,
    checkboxValue: Aa.INTERMEDIATE
  }, { isChecked: u, checkboxValue: h } = d(), f = Mn(
    () => ({
      selectedIdentifiers: n,
      handleBulkSelection: c,
      isChecked: u,
      checkboxValue: h,
      isBulkSelectionApplied: s,
      getSelectedIdentifiersCount: o
    }),
    [n, c, u, h, o]
  );
  return /* @__PURE__ */ v.jsx(Vde.Provider, { value: f, children: i });
}, vu = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { fill: "#999", className: "fill-color", fillRule: "nonzero", d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" }))), JLe = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cpath%20fill='%23999'%20class='fill-color'%20fill-rule='nonzero'%20d='M7.41%208.59L12%2013.17l4.59-4.58L18%2010l-6%206-6-6z'/%3e%3c/g%3e%3c/svg%3e", $Le = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("rect", { x: 2, y: 2, width: 12, height: 12, rx: 2, stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M11.2083 5.95801L7.12498 10.0412L5.08331 7.99967", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), eIe = (i) => /* @__PURE__ */ G.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("rect", { x: 2, y: 2, width: 11.2, height: 11.2, rx: 2, stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M15.4667 5.86621V11.4662C15.4667 13.6754 13.6758 15.4662 11.4667 15.4662H5.8667", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M10.35 5.84961L6.85004 9.34945L5.10004 7.59961", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Il = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 24, height: 24, viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("defs", null, /* @__PURE__ */ G.createElement("path", { id: "a", className: "stroke-color", d: "M18.295 5.705a.997.997 0 0 0-1.41 0L12 10.59 7.115 5.705a.997.997 0 1 0-1.41 1.41L10.59 12l-4.885 4.885a.997.997 0 1 0 1.41 1.41L12 13.41l4.885 4.885a.997.997 0 0 0 1.41-1.41L13.41 12l4.885-4.885a.997.997 0 0 0 0-1.41z" })), /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { d: "" }), /* @__PURE__ */ G.createElement("use", { fill: "#999", xlinkHref: "#a" }))), tIe = ({ showPagination: i, disabled: e = !1 }) => {
  const { handleBulkSelection: t, isChecked: n, checkboxValue: r, getSelectedIdentifiersCount: s } = QLe(), o = s() > 0, a = [
    {
      locator: so.SELECT_ALL_ON_PAGE,
      label: Vk[so.SELECT_ALL_ON_PAGE],
      isSelected: n && r === Aa.CHECKED,
      icon: $Le
    },
    ...i ? [
      {
        locator: so.SELECT_ALL_ACROSS_PAGES,
        label: Vk[so.SELECT_ALL_ACROSS_PAGES],
        isSelected: n && r === Aa.BULK_CHECKED,
        icon: eIe
      }
    ] : [],
    ...o ? [
      {
        locator: so.CLEAR_ALL_SELECTIONS,
        label: Vk[so.CLEAR_ALL_SELECTIONS],
        isSelected: !1,
        icon: Il,
        iconClass: "icon-use-fill-n6"
      }
    ] : []
  ];
  return /* @__PURE__ */ v.jsxs(tc, { autoClose: !0, children: [
    /* @__PURE__ */ v.jsxs(
      tc.Button,
      {
        isKebab: !0,
        rootClassName: "h-20 flexbox p-0 dc__no-background dc__no-border dc__outline-none-imp",
        dataTestId: YLe,
        disabled: e,
        children: [
          /* @__PURE__ */ v.jsx(
            cb,
            {
              isChecked: n,
              onChange: El,
              rootClassName: "icon-dim-20 m-0",
              value: r,
              disabled: e
            }
          ),
          /* @__PURE__ */ v.jsx(vu, { className: "icon-dim-20 fcn-6 dc__no-shrink" })
        ]
      }
    ),
    /* @__PURE__ */ v.jsx(tc.Body, { rootClassName: "dc__top-22 w-150 dc__right-0 pt-4 pb-4 pl-0 pr-0 bcn-0 flex column dc__content-start dc__align-start dc__position-abs bcn-0 dc__border dc__border-radius-4-imp", children: a.map((l) => /* @__PURE__ */ v.jsx(
      KLe,
      {
        locator: l.locator,
        label: l.label,
        isSelected: l.isSelected,
        icon: l.icon,
        handleBulkSelection: t,
        iconClass: l.iconClass
      },
      l.locator
    )) })
  ] });
}, K_t = tIe;
var nIe = /* @__PURE__ */ ((i) => (i.CHART = "helm_charts", i.APPLICATION = "apps", i))(nIe || {}), En = /* @__PURE__ */ ((i) => (i.Service = "Service", i.Alertmanager = "Alertmanager", i.PodSecurity = "PodSecurityPolicy", i.ConfigMap = "ConfigMap", i.ServiceAccount = "ServiceAccount", i.ClusterRoleBinding = "ClusterRoleBinding", i.RoleBinding = "RoleBinding", i.ClusterRole = "ClusterRole", i.Role = "Role", i.Prometheus = "Prometheus", i.ServiceMonitor = "ServiceMonitor", i.Deployment = "Deployment", i.MutatingWebhookConfiguration = "MutatingWebhookConfiguration", i.DaemonSet = "DaemonSet", i.Secret = "Secret", i.ValidatingWebhookConfiguration = "ValidatingWebhookConfiguration", i.Pod = "Pod", i.Ingress = "Ingress", i.ReplicaSet = "ReplicaSet", i.Endpoints = "Endpoints", i.Cluster = "ClusterRoleBinding", i.PodSecurityPolicy = "PodSecurityPolicy", i.CronJob = "CronJob", i.Job = "Job", i.ReplicationController = "ReplicationController", i.StatefulSet = "StatefulSet", i.Rollout = "Rollout", i.PersistentVolumeClaim = "PersistentVolumeClaim", i.PersistentVolume = "PersistentVolume", i.Containers = "Containers", i.InitContainers = "InitContainers", i.EndpointSlice = "EndpointSlice", i.NetworkPolicy = "NetworkPolicy", i.StorageClass = "StorageClass", i.VolumeSnapshot = "VolumeSnapshot", i.VolumeSnapshotContent = "VolumeSnapshotContent", i.VolumeSnapshotClass = "VolumeSnapshotClass", i.PodDisruptionBudget = "PodDisruptionBudget", i.Event = "Event", i.Namespace = "Namespace", i.Overview = "Overview", i))(En || {}), z8 = /* @__PURE__ */ ((i) => (i.DEVTRON_APP = "devtron_app", i.DEVTRON_HELM_CHART = "devtron_helm_chart", i.EXTERNAL_HELM_CHART = "external_helm_chart", i.EXTERNAL_ARGO_APP = "external_argo_app", i.EXTERNAL_FLUX_APP = "external_flux_app", i))(z8 || {}), iIe = /* @__PURE__ */ ((i) => (i.GIT = "git", i.GITHUB = "github", i.GITLAB = "gitlab", i.BITBUCKET = "bitbucket", i.DOCKER = "docker", i.DOCKER_HUB = "docker-hub", i.ACR = "acr", i.QUAY = "quay", i.ECR = "ecr", i.ARTIFACT_REGISTRY = "artifact-registry", i.GCR = "gcr", i.OTHER = "other", i))(iIe || {}), fy = /* @__PURE__ */ ((i) => (i.system = "system", i.admin = "admin", i))(fy || {}), rIe = /* @__PURE__ */ ((i) => (i.CRITICAL = "critical", i.HIGH = "high", i.MEDIUM = "medium", i.LOW = "low", i.UNKNOWN = "unknown", i))(rIe || {}), sIe = /* @__PURE__ */ ((i) => (i.REQUEST = "request", i.PENDING = "pending", i))(sIe || {}), oIe = /* @__PURE__ */ ((i) => (i.HEALTHY = "healthy", i.NONE = "none", i.UNKNOWN = "unknown", i.UPGRADING = "upgrading", i.UPGRADE_FAILED = "upgradeFailed", i.INSTALLED = "installed", i.INSTALLING = "installing", i.INSTALL_FAILED = "installFailed", i.NOT_INSTALLED = "notInstalled", i.TIMEOUT = "timeout", i))(oIe || {}), aIe = /* @__PURE__ */ ((i) => (i.CODE_SOURCE = "Code Source", i.PARAMETERS = "Parameters", i))(aIe || {}), Hde = /* @__PURE__ */ ((i) => (i.IMAGE = "Image", i.PARAMETERS = "Parameters", i))(Hde || {}), Io = /* @__PURE__ */ ((i) => (i.devtronApplication = "application/devtron-application", i.helmChart = "application/helm-application", i.job = "job", i.cluster = "cluster", i.release = "release", i.releaseTrack = "release-track", i.releaseChannel = "release-channel", i.tenant = "tenant", i.installation = "installation", i.environment = "environment", i.cdPipeline = "cd-pipeline", i.project = "project", i))(Io || {}), vj = /* @__PURE__ */ ((i) => (i.v1 = "v1", i.alpha1 = "alpha1", i))(vj || {}), lIe = /* @__PURE__ */ ((i) => (i.lockConfiguration = "lock-configuration", i))(lIe || {}), U8 = /* @__PURE__ */ ((i) => (i.PULL_REQUEST = "Pull Request", i.TAG_CREATION = "Tag Creation", i))(U8 || {}), wc = /* @__PURE__ */ ((i) => (i.Workloads = "Workloads", i.Networking = "Networking", i["Config & Storage"] = "Config & Storage", i.RBAC = "RBAC", i.Administration = "Administration", i["Custom Resource"] = "Custom Resource", i["Other Resources"] = "Other Resources", i.Events = "Events", i.Namespaces = "Namespaces", i))(wc || {}), cIe = /* @__PURE__ */ ((i) => (i.SSH = "SSH", i.PASSWORD = "PASSWORD", i.SSH_AND_PASSWORD = "PAT_AND_SSH", i))(cIe || {}), dIe = /* @__PURE__ */ ((i) => (i.UPSTREAM = "upstream", i.DOWNSTREAM = "downstream", i.LEVEL = "level", i))(dIe || {}), y3 = /* @__PURE__ */ ((i) => (i.FULFILLED = "fulfilled", i.REJECTED = "rejected", i))(y3 || {}), uIe = /* @__PURE__ */ ((i) => (i.HTTP = "http:", i.HTTPS = "https:", i.SSH = "ssh:", i.SMTP = "smtp:", i.S3 = "s3:", i))(uIe || {}), hIe = /* @__PURE__ */ ((i) => (i.KEY = "key", i.VALUE = "value", i))(hIe || {});
const fIe = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M7.34833 14.419C6.46444 17.0707 2.92891 17.0707 2.92891 17.0707C2.92891 17.0707 2.92891 13.5351 5.58056 12.6513M9.99998 13.5351L15.3033 8.23183C17.3114 6.2237 17.2918 4.21556 17.164 3.35914C17.1444 3.22728 17.0829 3.10522 16.9886 3.01095C16.8944 2.91668 16.7723 2.85518 16.6404 2.83553C15.784 2.70775 13.7759 2.68816 11.7677 4.6963L6.46444 9.9996M9.99998 13.5351L6.46444 9.9996M9.99998 13.5351L10.6548 16.8094C10.677 16.9203 10.7289 17.0232 10.8049 17.1069C10.881 17.1907 10.9783 17.2522 11.0866 17.285C11.1949 17.3178 11.31 17.3206 11.4197 17.2931C11.5294 17.2655 11.6296 17.2088 11.7096 17.1288L14.2363 14.6021C14.2944 14.544 14.3404 14.4751 14.3718 14.3993C14.4032 14.3235 14.4194 14.2422 14.4194 14.1601V9.11572M6.46444 9.9996L3.19017 9.34474C3.07924 9.32256 2.97642 9.27068 2.89266 9.19465C2.8089 9.11861 2.74734 9.02127 2.71456 8.913C2.68178 8.80473 2.679 8.68959 2.70651 8.57986C2.73403 8.47013 2.79081 8.36993 2.8708 8.28994L5.3975 5.76324C5.45554 5.7052 5.52444 5.65917 5.60027 5.62776C5.6761 5.59635 5.75737 5.58018 5.83944 5.58018H10.8839", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), gIe = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M8.29075 5.35813V2.63086M8.29075 5.35813H3.1778C2.89542 5.35813 2.6665 5.61862 2.6665 5.93995V14.0854C2.6665 14.4067 2.89542 14.6672 3.1778 14.6672H13.4037C13.6861 14.6672 13.915 14.4067 13.915 14.0854V5.93995C13.915 5.61862 13.6861 5.35813 13.4037 5.35813H8.29075Z", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("line", { x1: 6.71338, y1: 11.3945, x2: 9.86792, y2: 11.3945, stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M5.96355 9.33334C6.44554 9.33334 6.83628 8.94261 6.83628 8.46062C6.83628 7.97862 6.44554 7.58789 5.96355 7.58789C5.48155 7.58789 5.09082 7.97862 5.09082 8.46062C5.09082 8.94261 5.48155 9.33334 5.96355 9.33334Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M10.6178 9.33334C11.0998 9.33334 11.4906 8.94261 11.4906 8.46062C11.4906 7.97862 11.0998 7.58789 10.6178 7.58789C10.1359 7.58789 9.74512 7.97862 9.74512 8.46062C9.74512 8.94261 10.1359 9.33334 10.6178 9.33334Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M9.98769 2L6.59375 2", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), pIe = ({ imagePath: i, registryName: e }) => /* @__PURE__ */ v.jsxs("div", { children: [
  /* @__PURE__ */ v.jsx("div", { className: "fw-6", children: e }),
  /* @__PURE__ */ v.jsx("div", { children: i })
] }), mIe = ({
  imagePath: i,
  registryName: e,
  registryType: t,
  image: n,
  deployedTime: r,
  deployedBy: s,
  isRollbackTrigger: o,
  excludedImagePathNode: a,
  approvalChecksNode: l,
  approvalInfoTippy: c
}) => {
  const d = (f) => {
    const g = /* @__PURE__ */ v.jsx(pIe, { imagePath: i, registryName: e });
    return /* @__PURE__ */ v.jsx(wn, { className: "default-tt dc__mxw-500", arrow: !1, placement: "top-start", content: g, children: f });
  }, u = () => r ? /* @__PURE__ */ v.jsxs("div", { className: "material-history__info flex left fs-13", children: [
    /* @__PURE__ */ v.jsx(fIe, { className: "icon-dim-16 scn-6 mr-8" }),
    /* @__PURE__ */ v.jsx("span", { className: "fs-13 fw-4", children: r })
  ] }) : null, h = () => !s || !o ? null : s === fy.system ? /* @__PURE__ */ v.jsxs("div", { className: "material-history__deployed-by flex left", children: [
    /* @__PURE__ */ v.jsx(gIe, { className: "icon-dim-16 mr-6" }),
    /* @__PURE__ */ v.jsx("span", { className: "fs-13 fw-4", children: "Auto triggered" })
  ] }) : /* @__PURE__ */ v.jsxs("div", { className: "material-history__deployed-by flex left", children: [
    /* @__PURE__ */ v.jsx(
      "span",
      {
        className: "flex fs-13 fw-6 lh-18 icon-dim-20 mr-6 cn-0 m-auto dc__border-transparent dc__uppercase dc__border-radius-50-per",
        style: {
          backgroundColor: vx(s)
        },
        children: s[0]
      }
    ),
    /* @__PURE__ */ v.jsx("span", { className: "fs-13 fw-4", children: s })
  ] });
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex left column", children: a ?? /* @__PURE__ */ v.jsx(lc, { condition: !!i, wrap: d, children: /* @__PURE__ */ v.jsxs("div", { className: "commit-hash commit-hash--docker", "data-testid": "cd-trigger-modal-image-value", children: [
      /* @__PURE__ */ v.jsx("div", { className: `dc__registry-icon ${t} mr-8` }),
      n
    ] }) }) }),
    c,
    h(),
    l ?? u()
  ] });
}, vIe = mIe, Ex = {
  PROGRESSING: "Progressing",
  DEGRADED: "Degraded",
  FAILED: "Failed"
}, _Ie = {
  CD: "CD",
  CI: "CI",
  GIT: "GIT",
  PRECD: "PRECD",
  POSTCD: "POSTCD",
  ROLLBACK: "ROLLBACK"
}, bIe = 3, ZK = {
  Clair: "Clair",
  Trivy: "Trivy"
}, CIe = "This image is excluded for new deployment as it does not match the filter conditions configured for this environment.", Y_t = {
  ARGO_CD: "argo-cd",
  CICD: "cicd",
  SECURITY: "security",
  BLOB_STORAGE: "blob-storage",
  GRAFANA: "monitoring.grafana",
  NOTIFICATION: "notifier",
  SECURITY_TRIVY: "security.trivy",
  SECURITY_CLAIR: "security.clair"
}, Wde = "ddd DD MMM YYYY HH:mm:ss", gy = "API-TOKEN:", yIe = "••••••••";
var wIe = /* @__PURE__ */ ((i) => (i.add = "add", i.replace = "replace", i.remove = "remove", i))(wIe || {}), w3 = /* @__PURE__ */ ((i) => (i.PRE = "PRE", i.DEPLOY = "DEPLOY", i.POST = "POST", i))(w3 || {}), SIe = /* @__PURE__ */ ((i) => (i.LAST_SAVED_CONFIG = "LAST_SAVED_CONFIG", i.LATEST_TRIGGER_CONFIG = "LATEST_TRIGGER_CONFIG", i.SPECIFIC_TRIGGER_CONFIG = "SPECIFIC_TRIGGER_CONFIG", i))(SIe || {}), G8 = /* @__PURE__ */ ((i) => (i.production = "Production", i.nonProduction = "Non-Production", i))(G8 || {}), Ot = /* @__PURE__ */ ((i) => (i.DEPLOYMENT_INITIATED = "DEPLOYMENT_INITIATED", i.GIT_COMMIT = "GIT_COMMIT", i.GIT_COMMIT_FAILED = "GIT_COMMIT_FAILED", i.ARGOCD_SYNC = "ARGOCD_SYNC", i.ARGOCD_SYNC_FAILED = "ARGOCD_SYNC_FAILED", i.KUBECTL_APPLY = "KUBECTL_APPLY", i.KUBECTL_APPLY_STARTED = "KUBECTL_APPLY_STARTED", i.KUBECTL_APPLY_SYNCED = "KUBECTL_APPLY_SYNCED", i.HEALTHY = "HEALTHY", i.APP_HEALTH = "APP_HEALTH", i.DEPLOYMENT_FAILED = "FAILED", i.FETCH_TIMED_OUT = "TIMED_OUT", i.UNABLE_TO_FETCH_STATUS = "UNABLE_TO_FETCH_STATUS", i.DEGRADED = "DEGRADED", i.DEPLOYMENT_SUPERSEDED = "DEPLOYMENT_SUPERSEDED", i.ABORTED = "ABORTED", i.INPROGRESS = "INPROGRESS", i.HELM_PACKAGE_GENERATED = "HELM_PACKAGE_GENERATED", i.HELM_MANIFEST_PUSHED_TO_HELM_REPO = "HELM_MANIFEST_PUSHED_TO_HELM_REPO", i.HELM_MANIFEST_PUSHED_TO_HELM_REPO_FAILED = "HELM_MANIFEST_PUSHED_TO_HELM_REPO_FAILED", i))(Ot || {});
const jr = {
  DATA_NOT_AVAILABLE: "Data not available",
  API_TOKEN: {
    TITLE: "No matching results",
    SUBTITLE: "We couldn't find any matching token"
  },
  ARTIFACTS_EMPTY_STATE_TEXTS: {
    NoFilesFound: "No files found",
    BlobStorageNotConfigured: "Blob storage must be configured to store any files generated by the pipeline",
    StoreFiles: "Want to store files?",
    ConfigureBlobStorage: "Configure blob storage",
    NoFilesGenerated: "No files were generated by the job pipeline.",
    NoArtifactsGenerated: "No artifacts generated",
    NoArtifactsError: "Errr..!! We couldn’t build your code.",
    FailedToFetchArtifacts: "Fail to find artifacts",
    FailedToFetchArtifactsError: "Errr..!! The pipeline execution failed",
    NoArtifactsFound: "No new artifacts found",
    NoArtifactsFoundError: "No new artifacts were found"
  },
  CI_BUILD_HISTORY_PIPELINE_TRIGGER: {
    TITLE: "pipeline not triggered",
    SUBTITLE: "Pipeline trigger history, details and logs will be available here."
  },
  CI_BUILD_HISTORY_LINKED_PIPELINE: {
    TITLE: "This is a Linked CI Pipeline",
    SUBTITLE: "This is a Linked CI Pipeline"
  },
  CI_BUILD_HISTORY_NO_PIPELINE: {
    TITLE: "No pipeline selected",
    SUBTITLE: "Please select a pipeline"
  },
  CI_DEATILS_NO_VULNERABILITY_FOUND: {
    TITLE: "You’re secure!",
    SUBTITLE: "No security vulnerability found for this image."
  },
  CI_DETAILS_IMAGE_SCANNED_DISABLED: "Go to build pipeline configurations and enable ’Scan for vulnerabilities’",
  CI_DETAILS_IMAGE_NOT_SCANNED: {
    TITLE: "Image not scanned",
    SUBTITLE: "This build was executed before scanning was enabled for this pipeline."
  },
  CD_DETAILS_NO_ENVIRONMENT: {
    TITLE: "No environment selected",
    SUBTITLE: "Please select an environment to start seeing CD deployments."
  },
  CD_DETAILS_NO_DEPLOYMENT: {
    TITLE: "No deployments",
    SUBTITLE: "No deployment history available for the"
  },
  CHART: {
    NO_SOURCE_TITLE: "No chart source configured",
    NO_CHART_FOUND: "Could not find any matching chart source"
  },
  CHART_DEPLOYMENT_HISTORY: {
    SUBTITLE: "Data for previous deployments is not available. History for any new deployment will be available here."
  },
  CHART_GROUP_DEPLOYMENT: {
    TITLE: "No Deployments",
    SUBTITLE: "You haven't made any deployments"
  },
  DEPLOYMENT_DETAILS_SETPS_FAILED: {
    TITLE: "Deployment failed",
    SUBTITLE: "A new deployment was initiated before this deployment completed."
  },
  DEPLOYMENT_DETAILS_SETPS_PROGRESSING: {
    TITLE: "Deployment in progress",
    SUBTITLE: "This deployment is in progress. Click on Check status to know the live status."
  },
  DEVTRON_APP_DEPLOYMENT_HISTORY_SOURCE_CODE: {
    SUBTITLE: "Source code detail is not available"
  },
  DEPLOYMENT_HISTORY_CONFIG_LIST: {
    SUBTITLE: "Deployed configurations is not available for older deployments"
  },
  GENERATE_API_TOKEN: {
    TITLE: "Generate a token to access the Devtron API",
    SUBTITLE: "API tokens are like ordinary OAuth access tokens. They can be used instead of username and password for programmatic access to API."
  },
  TRIGGER_URL: {
    TITLE: "No URLs available",
    SUBTITLE: "No URLs found in ingress and service resources"
  },
  CD_EMPTY_STATE: {
    TITLE: "Data not available",
    SUBTITLE: "Deployed configurations is not available for older deployments"
  },
  CI_PROGRESS_VIEW: {
    TITLE: "Building artifacts",
    SUBTITLE: "Generated artifact(s) will be available here after the pipeline is executed."
  },
  RENDER_EMPTY_STATE: {
    TITILE: "No deployments found",
    SUBTITLE: "There are no deployments in this period on"
  },
  RENDER_NO_ENVIORNMENT_STATE: {
    TITLE: "Deployment Metrics",
    SUBTITLE: "This app is not deployed on any production environment. Deploy on prod to get an overview of your deployment practices."
  },
  RENDER_SELECT_ENVIRONMENT_VIEW: {
    TITLE: "Select an Environment",
    SUBTITLE: "Please select an Enviroment to view deployment metrics."
  },
  SAVED_VALUES_EMPTY_STATE: {
    TITLE: "No values saved for this chart",
    SUBTITLE: "Customize, Dry Run and Save values so they’re ready to be used later."
  },
  LOADING_CLUSTER: {
    TITLE: "Trying to connect to Cluster",
    SUBTITLE: "Please wait while the kubeconfig is verified and cluster details are fetched."
  },
  NO_MATCHING_RESULT: {
    TITLE: "No matching results",
    SUBTITLE: "We couldn't find any matching cluster"
  },
  CLUSTER_NODE_EMPTY_STATE: {
    TITLE: "No matching clusters",
    SUBTITLE: "We couldn’t find any matching results"
  },
  CHART_EMPTY_STATE: {
    TITLE: "No matching charts",
    SUBTITLE: "We couldn't find any matching results"
  },
  CHART_VALUES_GUIT_VIEW: {
    SUBTITLE: "GUI view is not available as values.schema.json file does not exist for the selected version and values."
  },
  DEVTRON_STACK_MANAGER: {
    TITLE: "No integrations installed",
    SUBTITLE: "Installed integrations will be available here."
  },
  NO_GROUPS: {
    TITLE: "No groups",
    SUBTITLE: "Groups allow you to combine permissions and easily assign them to users."
  },
  NO_USER: {
    TITLE: "No users",
    SUBTITLE: "Add users and assign group or direct permissions"
  },
  RENDER_LIST: {
    SUBTITLE: "No results found for the applied filters."
  },
  CUSTOM_CHART_LIST: {
    TITLE: "Use custom charts in applications"
  },
  BULK_ACTION_EDITS: {
    TITLE: "No Linked pipelines created",
    SUBTITLE: "Deployment groups can only be created for applications and environments using Linked CI Pipelines."
  },
  SECURITY_SCANS: {
    TITLE: "No Scans Performed",
    SUBTITLE: "No results found for the applied filters."
  },
  NOTIFICATION_TAB: {
    TITLE: "Notification",
    SUBTITL: "Receive alerts when a pipeline triggers, completes successfully or fails."
  },
  CONFIGURATION_TAB: {
    TITLE: "No Configurations"
  },
  EXTERNAL_LINK_COMPONENT: {
    TITLE: "Add external links",
    SUBTITLE: "We couldn't find any matching external link configuration"
  },
  CD_MATERIAL: {
    TITLE: "No Image Available"
  },
  CI_DETAILS_NOT_FOUND: {
    TITLE: "Not found",
    SUBTITLE: "you are looking for does not exist"
  },
  TRIGGER_NOT_FOUND: {
    TITLE: "Trigger not found",
    SUBTITLE: "The trigger you are looking for does not exist"
  },
  OVERVIEW: {
    DEPLOYMENT_TITLE: "Explore your application's deployment landscape",
    DEPLOYMENT_SUB_TITLE: "Although there are no deployments to display just yet, it's the perfect time to start configuring and deploying your app to various environments. Let's go!",
    APP_DESCRIPTION: "Write a short description for this application",
    JOB_DESCRIPTION: "Write a short description for this job"
  }
}, Xo = {
  DEPLOYMENT_TEMPLATE: {
    DISPLAY_NAME: "Deployment template",
    VALUE: "deployment-template"
  },
  PIPELINE_STRATEGY: {
    DISPLAY_NAME: "Pipeline configurations",
    VALUE: "pipeline-strategy"
  },
  CONFIGMAP: {
    DISPLAY_NAME: "ConfigMap",
    VALUE: "configmap"
  },
  SECRET: {
    DISPLAY_NAME: "Secret",
    VALUE: "secret"
  }
}, Lx = {
  [Xo.SECRET.DISPLAY_NAME]: {
    "": "Kubernetes Secret",
    KubernetesSecret: "Kubernetes External Secret",
    AWSSecretsManager: "AWS Secrets Manager",
    AWSSystemManager: "AWS System Manager",
    HashiCorpVault: "Hashi Corp Vault",
    ESO_HashiCorpVault: "Hashi Corp Vault",
    ESO_AWSSecretsManager: "AWS Secrets Manager",
    ESO_GoogleSecretsManager: "Google Secrets Manager",
    ESO_AzureSecretsManager: "Azure Secrets Manager"
  },
  [Xo.CONFIGMAP.DISPLAY_NAME]: {
    "": "Kubernetes ConfigMap",
    KubernetesConfigMap: "Kubernetes External ConfigMap"
  }
}, ei = {
  SUCCEEDED: "succeeded",
  HEALTHY: "healthy",
  FAILED: "failed",
  TIMED_OUT: "timed_out",
  UNABLE_TO_FETCH: "unable_to_fetch",
  INPROGRESS: "inprogress",
  PROGRESSING: "progressing",
  STARTING: "starting",
  INITIATING: "initiating",
  SUPERSEDED: "superseded",
  QUEUED: "queued",
  UNKNOWN: "unknown",
  CHECKING: "checking"
}, xIe = {
  failed: "failed",
  queued: "queued",
  suspended: "suspended",
  starting: "progressing",
  initiating: "progressing",
  unknown: "unknown",
  degraded: "degraded",
  healthy: "healthy",
  notdeployed: "not-deployed",
  missing: "missing",
  progressing: "progressing",
  deploymentinitiated: "progressing",
  hibernating: "hibernating",
  succeeded: "healthy",
  timedout: "timed-out",
  unabletofetch: "failed"
}, q8 = {
  suspended: "var(--Y500)",
  unknown: "var(--N700)",
  queued: "var(--N700)",
  degraded: "var(--R500)",
  healthy: "var(--G500)",
  notdeployed: "var(--N500)",
  missing: "var(--N700)",
  progressing: "var(--O500)",
  initiating: "var(--O500)",
  starting: "var(--O500)",
  succeeded: "var(--G500)",
  running: "var(--O500)",
  failed: "var(--R500)",
  error: "var(--R500)",
  cancelled: "var(--R500)",
  aborted: "var(--R500)",
  timedout: "var(--R500)",
  unabletofetch: "var(--R500)",
  hibernating: "var(--N700)"
}, DIe = {
  progressing: !0,
  initiating: !0,
  starting: !0,
  running: !0
}, EIe = ["KIND", "NAME", "STATUS", "MESSAGE"], LIe = "Not available for build as this commit contains changes in excluded files or folders", Hk = {
  SAMPLE_NODE_REPO_URL: "https://github.com/devtron-labs/getting-started-nodejs",
  CREATE_DEVTRON_APP_URL: "create-d-app",
  AppTabs: {
    DEVTRON_APPS: "Devtron Apps",
    HELM_APPS: "Helm Apps",
    ARGO_APPS: "ArgoCD Apps",
    FLUX_APPS: "FluxCD Apps"
  },
  AppType: {
    DEVTRON_APPS: "d",
    HELM_APPS: "h",
    ARGO_APPS: "a",
    FLUX_APPS: "f"
  },
  FilterType: {
    PROJECT: "team",
    CLUTSER: "cluster",
    NAMESPACE: "namespace",
    ENVIRONMENT: "environment",
    APP_STATUS: "appStatus",
    TEMPLATE_TYPE: "templateType"
  }
};
var IIe = /* @__PURE__ */ ((i) => (i[i.DEVTRON_APP = 0] = "DEVTRON_APP", i[i.HELM_APP = 1] = "HELM_APP", i[i.EXTERNAL_ARGO_APP = 2] = "EXTERNAL_ARGO_APP", i[i.EXTERNAL_FLUX_APP = 3] = "EXTERNAL_FLUX_APP", i))(IIe || {});
const QK = /\x1B\[.*?m/g;
var Mi = /* @__PURE__ */ ((i) => (i.xs = "xs", i.small = "small", i.medium = "medium", i.large = "large", i.xl = "xl", i))(Mi || {});
const jde = "popup";
var AIe = /* @__PURE__ */ ((i) => (i.allProjects = "-1", i.allExistingAndFutureNonProdEnvironments = "-1", i.allExistingAndFutureProdEnvironments = "-2", i.allExistingAndFutureEnvironments = "-3", i))(AIe || {});
const X_t = Object.values(
  Hde
).map((i) => ({
  value: i,
  label: i
})), Z_t = ["progressing", "initiating", "running", "starting"], Kf = {
  ACTIVE: "Active on",
  VIRTUAL_ENV: "Last deployed on",
  FAILED: "Last deployment failed on",
  DEPLOYING: "Deploying on"
}, kIe = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M3.09915 11.4621L3.82901 11.0215C3.90233 10.9773 3.96305 10.9149 4.00535 10.8405C4.04765 10.766 4.07012 10.6819 4.0706 10.5963L4.08328 8.33822C4.08381 8.24387 4.11102 8.15161 4.16177 8.07207L5.40193 6.12847C5.43858 6.07102 5.48659 6.02168 5.54301 5.98346C5.59943 5.94524 5.66307 5.91896 5.73002 5.90623C5.79696 5.89349 5.8658 5.89458 5.93231 5.90942C5.99882 5.92426 6.0616 5.95254 6.11678 5.99252L7.34527 6.88256C7.44932 6.95795 7.5784 6.99038 7.70572 6.97314L9.67325 6.70668C9.79394 6.69034 9.90451 6.6305 9.98421 6.53841L11.369 4.93836C11.4531 4.84123 11.4966 4.71546 11.4904 4.58715L11.4174 3.06818M11.6917 12.7302L11.021 12.0581C10.9582 11.9953 10.8799 11.9502 10.794 11.9277L9.45281 11.5757C9.33378 11.5445 9.23044 11.4705 9.16259 11.3678C9.09474 11.2651 9.06713 11.141 9.08506 11.0193L9.23411 10.007C9.24669 9.92158 9.28119 9.84085 9.33425 9.7727C9.38731 9.70455 9.45712 9.65131 9.53687 9.61816L11.44 8.82712C11.5279 8.79058 11.6245 8.7799 11.7182 8.79633C11.812 8.81276 11.8991 8.85561 11.9694 8.91986L13.5253 10.3429M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z", stroke: "#1DAD70", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), TIe = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M5.87886 11.5355C5.17175 13.6568 2.34332 13.6568 2.34332 13.6568C2.34332 13.6568 2.34332 10.8284 4.46464 10.1213M8.00018 10.8284L12.2428 6.58576C13.8493 4.97925 13.8337 3.37274 13.7314 2.68761C13.7157 2.58212 13.6665 2.48447 13.5911 2.40905C13.5157 2.33364 13.418 2.28444 13.3125 2.26871C12.6274 2.16649 11.0209 2.15082 9.41439 3.75733L5.17175 7.99997M8.00018 10.8284L5.17175 7.99997M8.00018 10.8284L8.52406 13.4478C8.54181 13.5366 8.58331 13.6188 8.64414 13.6858C8.70497 13.7528 8.78284 13.8021 8.86946 13.8283C8.95608 13.8545 9.04819 13.8568 9.13597 13.8347C9.22375 13.8127 9.30391 13.7673 9.3679 13.7033L11.3893 11.682C11.4357 11.6355 11.4725 11.5804 11.4977 11.5197C11.5228 11.4591 11.5357 11.3941 11.5357 11.3284V7.29287M5.17175 7.99997L2.55233 7.47609C2.46359 7.45834 2.38133 7.41684 2.31432 7.35601C2.24731 7.29518 2.19807 7.21731 2.17184 7.13069C2.14562 7.04407 2.14339 6.95196 2.16541 6.86418C2.18742 6.7764 2.23284 6.69624 2.29684 6.63224L4.3182 4.61088C4.36463 4.56445 4.41975 4.52763 4.48041 4.5025C4.54107 4.47737 4.60609 4.46444 4.67175 4.46444H8.70728", stroke: "#000A14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("circle", { cx: 11.2004, cy: 11.2, r: 4.05, fill: "#F33E3E", stroke: "#FDE7E7", strokeWidth: 1.5 })), NIe = (i) => {
  switch (i) {
    case Kf.VIRTUAL_ENV:
    case Kf.ACTIVE:
      return { Icon: /* @__PURE__ */ v.jsx(kIe, { className: "icon-dim-16 mr-4 scg-5" }), stateClassName: "bcg-1 eg-2" };
    case Kf.FAILED:
      return { Icon: /* @__PURE__ */ v.jsx(TIe, { className: "icon-dim-16 mr-4" }), stateClassName: "bcr-1 er-2" };
    case Kf.DEPLOYING:
      return {
        Icon: /* @__PURE__ */ v.jsx("div", { className: "dc__app-summary__icon icon-dim-16 mr-6 progressing progressing--node" }),
        stateClassName: "bcy-1 ey-2"
      };
    default:
      return {
        Icon: null,
        stateClassName: ""
      };
  }
}, Yb = ({ envStateText: i, title: e, tooltipContent: t }) => {
  const { Icon: n, stateClassName: r } = NIe(i), s = (o) => /* @__PURE__ */ v.jsx(wn, { content: t, className: "default-tt", placement: "top", arrow: !1, interactive: !0, children: o });
  return /* @__PURE__ */ v.jsx(lc, { condition: !!t, wrap: s, children: /* @__PURE__ */ v.jsx("div", { className: `${r} br-4 cn-9 pt-3 pb-3 pl-6 pr-6 bw-1 mr-6`, children: /* @__PURE__ */ v.jsxs("span", { className: "fw-4 fs-11 lh-16 flex", children: [
    n,
    i,
    /* @__PURE__ */ v.jsx("span", { className: "fw-6 ml-4", children: e })
  ] }) }) });
}, PIe = ({
  isLatest: i,
  isRunningOnParentCD: e,
  artifactStatus: t,
  environmentName: n,
  parentEnvironmentName: r,
  stageType: s,
  showLatestTag: o,
  isVirtualEnvironment: a,
  deployedOn: l,
  additionalInfo: c
}) => {
  const d = () => a ? Kf.VIRTUAL_ENV : Kf.ACTIVE, u = () => {
    if (l?.length) {
      const h = l.length === 1 ? l[0] : `${l.length} environments`;
      return /* @__PURE__ */ v.jsx(
        Yb,
        {
          envStateText: d(),
          title: h,
          tooltipContent: l.join(",")
        }
      );
    }
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      i && n && /* @__PURE__ */ v.jsx(Yb, { envStateText: d(), title: n }),
      e && r && /* @__PURE__ */ v.jsx(Yb, { envStateText: d(), title: r })
    ] });
  };
  return s !== _Ie.CD ? i || c ? /* @__PURE__ */ v.jsxs("div", { className: "bcn-0 pb-8 br-4 flex left dc__gap-8", children: [
    i && /* @__PURE__ */ v.jsx("span", { className: "last-deployed-status", children: "Last Run" }),
    c
  ] }) : null : i || e || Object.values(Ex).includes(t) || o || l?.length || c ? /* @__PURE__ */ v.jsxs("div", { className: "bcn-0 pb-8 br-4 flex left", children: [
    u(),
    t === Ex.PROGRESSING && /* @__PURE__ */ v.jsx(Yb, { envStateText: Kf.DEPLOYING, title: n }),
    (t === Ex.DEGRADED || t === Ex.FAILED) && /* @__PURE__ */ v.jsx(Yb, { envStateText: Kf.FAILED, title: n }),
    o && /* @__PURE__ */ v.jsx(
      AW,
      {
        text: "Latest",
        isSoftDeleted: !1,
        isEditing: !1,
        tagId: 0,
        softDeleteTags: [],
        isSuperAdmin: !0
      }
    ),
    c
  ] }) : null;
}, OIe = ({
  testIdLocator: i,
  cta: e,
  sequentialCDCardTitleProps: t,
  artifactInfoProps: n,
  imageTagContainerProps: r,
  children: s,
  rootClassName: o = "",
  materialInfoRootClassName: a = ""
}) => /* @__PURE__ */ v.jsxs("div", { className: `material-history material-history--cd image-tag-parent-card ${o || ""}`, children: [
  /* @__PURE__ */ v.jsxs("div", { className: "p-12 bcn-0 br-4", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "dc__content-space flexbox dc__align-start", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__content-start dc__align-start", children: [
        /* @__PURE__ */ v.jsx(PIe, { ...t }),
        /* @__PURE__ */ v.jsx(
          "div",
          {
            "data-testid": `cd-material-history-image-${i}`,
            className: `material-history__top cursor-default ${a || ""}`,
            children: /* @__PURE__ */ v.jsx(vIe, { ...n })
          }
        )
      ] }),
      /* @__PURE__ */ v.jsx("div", { className: "material-history__select-text fs-13 w-auto dc__no-text-transform flex right cursor-default", children: e })
    ] }),
    /* @__PURE__ */ v.jsx("div", { "data-testid": `image-tags-container-${i}`, children: /* @__PURE__ */ v.jsx(CCe, { ...r }) })
  ] }),
  s
] }), Q_t = OIe, MIe = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M9.98187 1.11126C5.0037 1.04139 0.898899 5.02392 0.82903 10.0021C0.759161 14.9803 4.74169 19.0851 9.73733 19.1549H17.2308C18.3312 19.1549 18.9076 18.596 18.9076 17.5654V10.1942C18.9251 5.25099 14.96 1.18113 9.98187 1.11126ZM9.73733 17.0589C5.92947 17.0065 2.89017 13.8798 2.94257 10.072C2.99497 6.2641 6.12161 3.22479 9.92947 3.2772C13.7373 3.3296 16.7766 6.45623 16.7242 10.2641C16.6718 14.072 13.5452 17.1113 9.73733 17.0589Z", fill: "#56A3D9" }), /* @__PURE__ */ G.createElement("path", { d: "M7.41389 9.00636C7.64096 8.51727 8.02524 8.09806 8.53179 7.81858C9.02088 7.55657 9.56236 7.45177 10.0689 7.50417L10.8025 4.81422C9.61476 4.60461 8.33965 4.76182 7.20428 5.4081C6.01651 6.07186 5.17808 7.10243 4.7414 8.27273L7.41389 9.00636ZM8.67153 12.6046C8.18245 12.3775 7.74577 11.9933 7.46629 11.4867C7.20428 10.9976 7.09948 10.4561 7.15188 9.94959L4.46193 9.21596C4.23485 10.4037 4.40952 11.6788 5.05581 12.8317C5.71957 14.002 6.7676 14.8404 7.93791 15.2771L8.67153 12.6046Z", fill: "#56A3D9" }), /* @__PURE__ */ G.createElement("path", { d: "M12.2529 11.3296C12.0258 11.8187 11.6416 12.2554 11.135 12.5348C10.6459 12.7968 10.1219 12.9016 9.61535 12.8492L8.86426 15.5392C10.052 15.7488 11.3271 15.5741 12.4625 14.9453C13.6503 14.2816 14.4887 13.251 14.9254 12.0632L12.2529 11.3296Z", fill: "#F1626E" })), RIe = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...i }, /* @__PURE__ */ G.createElement("rect", { x: 0.458008, width: 19.084, height: 20, fill: "url(#pattern-trivy)" }), /* @__PURE__ */ G.createElement("defs", null, /* @__PURE__ */ G.createElement("pattern", { id: "pattern-trivy", patternContentUnits: "objectBoundingBox", width: 1, height: 1 }, /* @__PURE__ */ G.createElement("use", { xlinkHref: "#image0_2837_14768", transform: "scale(0.002 0.0019084)" })), /* @__PURE__ */ G.createElement("image", { id: "image0_2837_14768", width: 500, height: 524, xlinkHref: "data:image/png;base64,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" }))), FIe = ({
  scanToolId: i,
  fontSize: e = 13,
  spacingBetweenTextAndIcon: t = 6
}) => {
  const n = i === bIe;
  return /* @__PURE__ */ v.jsxs("div", { className: "flexbox", style: { gap: `${t}px` }, children: [
    /* @__PURE__ */ v.jsxs("span", { className: `dc__italic-font-style fs-${e}`, children: [
      "Scanned by",
      /* @__PURE__ */ v.jsx("span", { className: "fw-6 ml-4", "data-testid": "scanned-by-tool", children: n ? ZK.Trivy : ZK.Clair })
    ] }),
    n ? /* @__PURE__ */ v.jsx(RIe, { className: "icon-dim-20 dc__no-shrink" }) : /* @__PURE__ */ v.jsx(MIe, { className: "icon-dim-20 dc__no-shrink" })
  ] });
}, JK = FIe, $K = {
  SECURED: "You’re secure!",
  NO_VULNERABILITY_FOUND: "No security vulnerability found for this image."
}, BIe = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M3 3.5C3.55228 3.5 4 3.05228 4 2.5C4 1.94772 3.55228 1.5 3 1.5C2.44772 1.5 2 1.94772 2 2.5C2 3.05228 2.44772 3.5 3 3.5ZM3 3.5V8.5M3 8.5C2.44772 8.5 2 8.94772 2 9.5C2 10.0523 2.44772 10.5 3 10.5C3.55228 10.5 4 10.0523 4 9.5C4 8.94772 3.55228 8.5 3 8.5ZM9 8.5C8.44772 8.5 8 8.94772 8 9.5C8 10.0523 8.44772 10.5 9 10.5C9.55228 10.5 10 10.0523 10 9.5C10 8.94772 9.55228 8.5 9 8.5ZM9 8.5V5.32843C9 4.79799 8.78929 4.28929 8.41421 3.91421L6 1.5M6 1.5H8M6 1.5V3.5", stroke: "#596168", strokeLinecap: "round", strokeLinejoin: "round" })), VIe = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M5.74991 1.21236L1.96923 1.9685L1.21309 5.74918C1.20099 5.80971 1.20401 5.8723 1.2219 5.93139C1.23979 5.99047 1.27199 6.04423 1.31565 6.08788L6.21187 10.9841C6.24669 11.0189 6.28803 11.0466 6.33353 11.0654C6.37903 11.0842 6.42779 11.0939 6.47703 11.0939C6.52628 11.0939 6.57504 11.0842 6.62054 11.0654C6.66604 11.0466 6.70738 11.0189 6.7422 10.9841L10.9848 6.74147C11.0197 6.70665 11.0473 6.66531 11.0661 6.61981C11.085 6.57431 11.0947 6.52555 11.0947 6.4763C11.0947 6.42706 11.085 6.37829 11.0661 6.3328C11.0473 6.2873 11.0197 6.24596 10.9848 6.21114L6.08862 1.31491C6.04496 1.27126 5.99121 1.23906 5.93212 1.22117C5.87303 1.20328 5.81044 1.20025 5.74991 1.21236V1.21236Z", stroke: "#596168", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M3.9375 4.5C4.24816 4.5 4.5 4.24816 4.5 3.9375C4.5 3.62684 4.24816 3.375 3.9375 3.375C3.62684 3.375 3.375 3.62684 3.375 3.9375C3.375 4.24816 3.62684 4.5 3.9375 4.5Z", fill: "#596168" })), HIe = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("g", { fill: "#000A14" }, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("path", { d: "M8 3.333c.736 0 1.333.597 1.333 1.334 0 .234-.06.455-.167.647L10.89 8.19l.043-.016c.283-.096.58-.153.885-.17L12 8c1.84 0 3.333 1.492 3.333 3.333 0 1.841-1.492 3.334-3.333 3.334-.852 0-1.655-.322-2.267-.89-.27-.25-.285-.672-.035-.942.25-.27.672-.285.942-.035.368.341.848.533 1.36.533 1.105 0 2-.895 2-2 0-1.104-.895-2-2-2-.37 0-.722.1-1.03.286-.294.177-.669.101-.873-.164l-.044-.064-2.032-3.393L8 6c-.693 0-1.263-.529-1.327-1.205l-.006-.128c0-.737.597-1.334 1.333-1.334zM3.719 8.598c.125.346-.054.729-.4.854C2.534 9.736 2 10.484 2 11.333c0 1.105.895 2 2 2 1.065 0 1.936-.832 1.997-1.882L6 11.333c0-.342.257-.623.589-.662l.078-.004h4.178c.23-.399.662-.667 1.155-.667.736 0 1.333.597 1.333 1.333 0 .737-.597 1.334-1.333 1.334-.493 0-.924-.268-1.155-.666l-3.58-.002-.007.04c-.314 1.457-1.58 2.56-3.113 2.625L4 14.667c-1.84 0-3.333-1.493-3.333-3.334 0-1.414.89-2.66 2.198-3.135.346-.125.728.054.854.4zM8 1.333c1.84 0 3.333 1.493 3.333 3.334 0 .368-.298.666-.666.666-.342 0-.624-.257-.663-.589L10 4.667c0-1.105-.895-2-2-2s-2 .895-2 2c0 .755.422 1.434 1.08 1.776.349.181.466.623.253.953l-2.147 3.328c.094.183.147.39.147.61 0 .736-.597 1.333-1.333 1.333s-1.333-.597-1.333-1.334C2.667 10.597 3.264 10 4 10c.022 0 .044 0 .066.002L5.859 7.22l-.024-.02c-.69-.589-1.121-1.443-1.165-2.378l-.003-.156c0-1.841 1.492-3.334 3.333-3.334z", transform: "translate(-832.000000, -156.000000) translate(566.000000, 0.000000) translate(254.000000, 142.000000) translate(12.000000, 12.000000) translate(0.000000, 2.000000)" })))))))), WIe = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cg%20fill='%23000A14'%3e%3cg%3e%3cg%3e%3cg%3e%3cg%3e%3cpath%20d='M8%203.333c.736%200%201.333.597%201.333%201.334%200%20.234-.06.455-.167.647L10.89%208.19l.043-.016c.283-.096.58-.153.885-.17L12%208c1.84%200%203.333%201.492%203.333%203.333%200%201.841-1.492%203.334-3.333%203.334-.852%200-1.655-.322-2.267-.89-.27-.25-.285-.672-.035-.942.25-.27.672-.285.942-.035.368.341.848.533%201.36.533%201.105%200%202-.895%202-2%200-1.104-.895-2-2-2-.37%200-.722.1-1.03.286-.294.177-.669.101-.873-.164l-.044-.064-2.032-3.393L8%206c-.693%200-1.263-.529-1.327-1.205l-.006-.128c0-.737.597-1.334%201.333-1.334zM3.719%208.598c.125.346-.054.729-.4.854C2.534%209.736%202%2010.484%202%2011.333c0%201.105.895%202%202%202%201.065%200%201.936-.832%201.997-1.882L6%2011.333c0-.342.257-.623.589-.662l.078-.004h4.178c.23-.399.662-.667%201.155-.667.736%200%201.333.597%201.333%201.333%200%20.737-.597%201.334-1.333%201.334-.493%200-.924-.268-1.155-.666l-3.58-.002-.007.04c-.314%201.457-1.58%202.56-3.113%202.625L4%2014.667c-1.84%200-3.333-1.493-3.333-3.334%200-1.414.89-2.66%202.198-3.135.346-.125.728.054.854.4zM8%201.333c1.84%200%203.333%201.493%203.333%203.334%200%20.368-.298.666-.666.666-.342%200-.624-.257-.663-.589L10%204.667c0-1.105-.895-2-2-2s-2%20.895-2%202c0%20.755.422%201.434%201.08%201.776.349.181.466.623.253.953l-2.147%203.328c.094.183.147.39.147.61%200%20.736-.597%201.333-1.333%201.333s-1.333-.597-1.333-1.334C2.667%2010.597%203.264%2010%204%2010c.022%200%20.044%200%20.066.002L5.859%207.22l-.024-.02c-.69-.589-1.121-1.443-1.165-2.378l-.003-.156c0-1.841%201.492-3.334%203.333-3.334z'%20transform='translate(-832.000000,%20-156.000000)%20translate(566.000000,%200.000000)%20translate(254.000000,%20142.000000)%20translate(12.000000,%2012.000000)%20translate(0.000000,%202.000000)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", jIe = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M12.5 5.625H7.5M12.5 8.125H7.5M15.625 3.125V16.875C15.625 17.2202 15.3452 17.5 15 17.5H5C4.65482 17.5 4.375 17.2202 4.375 16.875V3.125C4.375 2.77982 4.65482 2.5 5 2.5H15C15.3452 2.5 15.625 2.77982 15.625 3.125Z", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M10 15C10.5178 15 10.9375 14.5803 10.9375 14.0625C10.9375 13.5447 10.5178 13.125 10 13.125C9.48223 13.125 9.0625 13.5447 9.0625 14.0625C9.0625 14.5803 9.48223 15 10 15Z", fill: "#596168" })), zIe = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M16.25 8.125H18.125M16.25 11.875H18.125M1.875 8.125H3.75M1.875 11.875H3.75M11.875 16.25V18.125M8.125 16.25V18.125M11.875 1.875V3.75M8.125 1.875V3.75M7.8125 7.8125H12.1875V12.1875H7.8125V7.8125ZM4.375 3.75H15.625C15.9702 3.75 16.25 4.02982 16.25 4.375V15.625C16.25 15.9702 15.9702 16.25 15.625 16.25H4.375C4.02982 16.25 3.75 15.9702 3.75 15.625V4.375C3.75 4.02982 4.02982 3.75 4.375 3.75Z", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), zde = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M10 11.0415L13.0936 7.94791M8.125 1.6665H11.875M16.875 11.0415C16.875 14.8385 13.797 17.9165 10 17.9165C6.20304 17.9165 3.125 14.8385 3.125 11.0415C3.125 7.24455 6.20304 4.1665 10 4.1665C13.797 4.1665 16.875 7.24455 16.875 11.0415Z", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
var at = /* @__PURE__ */ ((i) => (i.CPU_LIMIT = "cpu_limit", i.CPU_REQUEST = "cpu_request", i.MEMORY_LIMIT = "memory_limit", i.MEMORY_REQUEST = "memory_request", i.BUILD_TIMEOUT = "timeout", i))(at || {}), Wm = /* @__PURE__ */ ((i) => (i.NAME = "name", i.DESCRIPTION = "description", i))(Wm || {}), S3 = /* @__PURE__ */ ((i) => (i.CPU = "cpu", i.MEMORY = "memory", i.BUILD_TIMEOUT = "timeout", i))(S3 || {}), Mp = /* @__PURE__ */ ((i) => (i.ACTIVATE_CPU = "activate_cpu", i.DE_ACTIVATE_CPU = "de_activate_cpu", i.ACTIVATE_MEMORY = "activate_memory", i.DE_ACTIVATE_MEMORY = "de_activate_memory", i.ACTIVATE_BUILD_TIMEOUT = "activate_timeout", i.DE_ACTIVATE_BUILD_TIMEOUT = "de_activate_timeout", i))(Mp || {});
const J_t = {
  timeout: "timeout",
  cpu_limit: "cpu",
  cpu_request: "cpu",
  memory_limit: "memory",
  memory_request: "memory"
  /* MEMORY */
};
var Ude = /* @__PURE__ */ ((i) => (i.DEFAULT = "DEFAULT", i.NORMAL = "NORMAL", i.CUSTOM = "CUSTOM", i))(Ude || {});
const o_ = {
  // Will not enforce any decimal specification on input field
  STEP: "any",
  MIN: 0,
  DECIMAL_PLACES: 2
}, Ss = {
  HEADING: "Build Infra Configuration",
  EDIT_SUBMIT: "Save changes",
  SAVE_SUBMIT: "Save",
  EDIT_CANCEL: "Cancel",
  EDIT_DEFAULT_TOOLTIP: "Efficiently control infrastructure settings such as CPU, Memory, and Build timeout for your build pipelines. Streamline resource management to optimise build time and cost effortlessly.",
  DESCRIPTION_LABEL: "Description",
  DESCRIPTION_PLACEHOLDER: "Enter a description here",
  PROFILE_LABEL: "Profile name",
  PROFILE_PLACEHOLDER: "Enter a name eg. java/node/small/medium/large",
  INHERITING_HEADING_DESCRIPTION: "Inheriting from default",
  SUBMIT_BUTTON_TIPPY: {
    INVALID_INPUT: "Valid input is required for all mandatory fields.",
    REQUEST_IN_PROGRESS: "Request in progress."
  },
  VALIDATE_REQUEST_LIMIT: {
    REQUEST_LESS_THAN_LIMIT: "Request should be less than or equal to limit.",
    CAN_NOT_COMPUTE: "Request and limit value diff are too high to validate.",
    REQUEST_DECIMAL_PLACES: `Request should be upto ${o_.DECIMAL_PLACES} decimal places.`,
    LIMIT_DECIMAL_PLACES: `Limit should be upto ${o_.DECIMAL_PLACES} decimal places.`
  },
  getInvalidActionMessage: (i) => `Invalid action type: ${i}`,
  getSubmitSuccessMessage: (i, e) => `${i} profile is ${e ? "updated" : "created"}`,
  PROFILE_NOT_FOUND: {
    title: "Profile not found",
    subTitle: "The profile you are looking for does not exist."
  },
  INVALID_FORM_MESSAGE: "Valid input is required for all mandatory fields."
}, $_t = {
  alias: {
    "global-config": null,
    "build-infra": {
      component: /* @__PURE__ */ v.jsx("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-32", children: Ss.HEADING }),
      linked: !1
    }
  }
}, eY = [
  {
    heading: /* @__PURE__ */ v.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20 w-240 dc__no-shrink", children: "CPU (Request - Limit)" }),
    marker: jIe,
    actions: [
      {
        actionType: at.CPU_REQUEST,
        label: "Request",
        placeholder: "Type CPU request"
      },
      {
        actionType: at.CPU_LIMIT,
        label: "Limit",
        placeholder: "Type CPU limit"
      }
    ],
    locator: S3.CPU
  },
  {
    heading: /* @__PURE__ */ v.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20 w-240 dc__no-shrink", children: "Memory (Request - Limit)" }),
    marker: zIe,
    actions: [
      {
        actionType: at.MEMORY_REQUEST,
        label: "Request",
        placeholder: "Type memory request"
      },
      {
        actionType: at.MEMORY_LIMIT,
        label: "Limit",
        placeholder: "Type memory limit"
      }
    ],
    locator: S3.MEMORY
  },
  {
    heading: /* @__PURE__ */ v.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20 w-240 dc__no-shrink", children: "Build timeout" }),
    marker: zde,
    actions: [
      {
        actionType: at.BUILD_TIMEOUT,
        label: "Timeout",
        placeholder: "Type build timeout"
      }
    ],
    locator: S3.BUILD_TIMEOUT
  }
], K8 = Object.fromEntries(
  Object.values({ ...at, ...Wm }).map((i) => [i, null])
), UIe = [Wm.NAME], GIe = "default", qIe = {
  name: "",
  description: "",
  type: Ude.NORMAL,
  appCount: 0
}, KIe = {
  [at.CPU_REQUEST]: !0,
  [at.CPU_LIMIT]: !0
}, tY = {
  SUBMIT_BUTTON: "build-infra-submit-button",
  CANCEL_BUTTON: "build-infra-cancel-button"
}, YIe = ({
  additionalContainerClasses: i,
  breadCrumbs: e,
  children: t,
  tippyInfoText: n,
  tippyAdditionalContent: r
}) => /* @__PURE__ */ v.jsxs("div", { className: `flexbox dc__content-space dc__align-items-center w-100 ${i ?? ""}`, children: [
  /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4", children: [
    /* @__PURE__ */ v.jsx(gCe, { breadcrumbs: e }),
    /* @__PURE__ */ v.jsx(
      OA,
      {
        infoText: n ?? Ss.EDIT_DEFAULT_TOOLTIP,
        additionalContent: r,
        heading: Ss.HEADING,
        documentationLink: ey.GLOBAL_CONFIG_BUILD_INFRA,
        documentationLinkText: "View Documentation",
        iconClassName: "icon-dim-20 fcn-6"
      }
    )
  ] }),
  t
] }), ebt = YIe, XIe = ({ disabled: i, handleCancel: e, editProfile: t, loading: n }) => {
  const r = i ? Ss.SUBMIT_BUTTON_TIPPY.INVALID_INPUT : Ss.SUBMIT_BUTTON_TIPPY.REQUEST_IN_PROGRESS, s = () => t ? Ss.EDIT_SUBMIT : Ss.SAVE_SUBMIT, o = (a) => /* @__PURE__ */ v.jsx(wn, { content: r, placement: "top", className: "default-tt", arrow: !1, children: a });
  return /* @__PURE__ */ v.jsxs("div", { className: "flex pl pr pb pt h-64 dc__gap-12 dc__border-top dc__content-start", children: [
    /* @__PURE__ */ v.jsx(lc, { condition: i || n, wrap: o, children: /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "submit",
        className: "cta submit h-32 flex",
        disabled: i || n,
        "data-testid": tY.SUBMIT_BUTTON,
        children: n ? /* @__PURE__ */ v.jsx(Yr, { size: 16 }) : s()
      }
    ) }) }),
    e && /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        className: "cta cancel h-32 flex",
        disabled: n,
        "data-testid": tY.CANCEL_BUTTON,
        onClick: e,
        children: Ss.EDIT_CANCEL
      }
    )
  ] });
}, tbt = XIe, ZIe = (i, e) => i ? qIe : {
  id: e.id,
  name: e.name,
  description: e.description,
  type: e.type,
  appCount: e.appCount
}, QIe = ({
  configurationUnits: i,
  defaultConfigurations: e,
  profile: t,
  fromCreateView: n
}) => {
  const r = e?.reduce((a, l) => (a[l.key] = l, a), {}) ?? {}, s = t?.configurations?.reduce((a, l) => (a[l.key] = l, a), {}) ?? {}, o = Object.keys(r).reduce((a, l) => {
    const c = r[l], d = s[l]?.profileName === t?.name ? s[l] : null, u = {
      value: c.value,
      unit: c.unit
    };
    return n ? (a[l] = {
      key: l,
      value: c.value,
      unit: c.unit,
      active: KIe[l] ?? !1,
      defaultValue: u
    }, a) : d ? (a[l] = {
      ...d,
      defaultValue: u
    }, a) : (a[l] = {
      key: l,
      value: c.value,
      // saving profile name as undefined and this would be a check, if we are deriving from default or not
      unit: c.unit,
      active: !1,
      defaultValue: u
    }, a);
  }, {});
  return {
    configurationUnits: i,
    profile: {
      ...t && ZIe(n, t),
      configurations: o
    }
  };
}, JIe = async ({
  name: i,
  fromCreateView: e
}) => {
  try {
    const t = await Qn(`${hn.INFRA_CONFIG_PROFILE}/${i}`), {
      result: { configurationUnits: n, defaultConfigurations: r, profile: s }
    } = t;
    return QIe({
      configurationUnits: n,
      defaultConfigurations: r,
      profile: s,
      fromCreateView: e
    });
  } catch (t) {
    throw Is(t), t;
  }
}, Gde = (i) => {
  const e = i.configurations, n = Object.keys(e).reduce((s, o) => {
    const a = e[o];
    return (a.id || a.active) && s.push({
      id: a.id,
      key: o,
      value: Number(a.value),
      unit: a.unit,
      active: a.active
    }), s;
  }, []);
  return {
    name: i.name,
    description: i.description,
    type: i.type,
    configurations: n
  };
}, $Ie = ({ name: i, profileInput: e }) => {
  const t = Gde(e);
  return uye(`${hn.INFRA_CONFIG_PROFILE}/${i}`, t);
}, eAe = async ({ profileInput: i }) => {
  const e = Gde(i);
  return fA(hn.INFRA_CONFIG_PROFILE, e);
}, Ix = ({
  request: i,
  limit: e,
  unitsMap: t
}) => {
  const n = Number(i.value), r = Number(e.value), s = Number(t[i.unit]?.conversionFactor), o = Number(t[e.unit]?.conversionFactor), a = {
    request: {
      isValid: !0
    },
    limit: {
      isValid: !0
    }
  }, l = dle(i.value).message, c = dle(e.value).message;
  if (l && (a.request = {
    message: l,
    isValid: !1
  }), c && (a.limit = {
    message: c,
    isValid: !1
  }), c || l)
    return a;
  const d = String(i.value).split(".")[1]?.length ?? 0, u = String(e.value).split(".")[1]?.length ?? 0;
  if (d > o_.DECIMAL_PLACES)
    return a.request = {
      message: Ss.VALIDATE_REQUEST_LIMIT.REQUEST_DECIMAL_PLACES,
      isValid: !1
    }, a;
  if (u > o_.DECIMAL_PLACES)
    return a.limit = {
      message: Ss.VALIDATE_REQUEST_LIMIT.LIMIT_DECIMAL_PLACES,
      isValid: !1
    }, a;
  const h = o / s, f = r / n;
  return h * f <= Number.MAX_SAFE_INTEGER ? (h * f < 1 && (a.request = {
    message: Ss.VALIDATE_REQUEST_LIMIT.REQUEST_LESS_THAN_LIMIT,
    isValid: !1
  }), a) : (a.request = {
    message: Ss.VALIDATE_REQUEST_LIMIT.CAN_NOT_COMPUTE,
    isValid: !1
  }, a);
}, tAe = (i) => {
  if (i) {
    const e = { ...K8 };
    return UIe.forEach((t) => {
      e[t] = "";
    }), e;
  }
  return {
    ...K8
  };
}, nbt = ({
  name: i,
  editProfile: e,
  handleSuccessRedirection: t
}) => {
  const n = !i, [r, s, o, a] = tf(
    () => JIe({
      name: i ?? GIe,
      fromCreateView: n
    }),
    [i]
  ), [l, c] = Oe(null), [d, u] = Oe({
    ...K8
  }), [h, f] = Oe(!1);
  return $e(() => {
    !r && s?.configurationUnits && s?.profile && (c({
      ...s.profile
    }), u(tAe(n)));
  }, [s, r]), {
    isLoading: r,
    profileResponse: s,
    responseError: o,
    reloadRequest: a,
    profileInput: l,
    profileInputErrors: d,
    handleProfileInputChange: ({ action: m, data: _ }) => {
      const b = { ...l }, w = { ...d }, y = s.profile.configurations, S = b.configurations, { value: x, unit: D } = _ ?? { value: null, unit: null };
      switch (m) {
        case Wm.DESCRIPTION:
          b.description = x, w.description = Y0t(x).message;
          break;
        case Wm.NAME:
          b.name = x, w.name = K0t(x).message;
          break;
        case at.CPU_LIMIT: {
          S[at.CPU_LIMIT] = {
            ...S[at.CPU_LIMIT],
            value: x,
            unit: D
          };
          const { request: E, limit: L } = Ix({
            request: {
              value: S[at.CPU_REQUEST].value,
              unit: S[at.CPU_REQUEST].unit
            },
            limit: {
              value: x,
              unit: D
            },
            unitsMap: s.configurationUnits[at.CPU_LIMIT]
          });
          w[at.CPU_LIMIT] = L.message, w[at.CPU_REQUEST] = E.message;
          break;
        }
        case at.CPU_REQUEST: {
          S[at.CPU_REQUEST] = {
            ...S[at.CPU_REQUEST],
            value: x,
            unit: D
          };
          const { request: E, limit: L } = Ix({
            request: {
              value: x,
              unit: D
            },
            limit: {
              value: S[at.CPU_LIMIT].value,
              unit: S[at.CPU_LIMIT].unit
            },
            unitsMap: s.configurationUnits[at.CPU_LIMIT]
          });
          w[at.CPU_LIMIT] = L.message, w[at.CPU_REQUEST] = E.message;
          break;
        }
        case at.MEMORY_LIMIT: {
          S[at.MEMORY_LIMIT] = {
            ...S[at.MEMORY_LIMIT],
            value: x,
            unit: D
          };
          const { request: E, limit: L } = Ix({
            request: {
              value: S[at.MEMORY_REQUEST].value,
              unit: S[at.MEMORY_REQUEST].unit
            },
            limit: {
              value: x,
              unit: D
            },
            unitsMap: s.configurationUnits[at.MEMORY_LIMIT]
          });
          w[at.MEMORY_LIMIT] = L.message, w[at.MEMORY_REQUEST] = E.message;
          break;
        }
        case at.MEMORY_REQUEST: {
          S[at.MEMORY_REQUEST] = {
            ...S[at.MEMORY_REQUEST],
            value: x,
            unit: D
          };
          const { request: E, limit: L } = Ix({
            request: {
              value: x,
              unit: D
            },
            limit: {
              value: S[at.MEMORY_LIMIT].value,
              unit: S[at.MEMORY_LIMIT].unit
            },
            unitsMap: s.configurationUnits[at.MEMORY_LIMIT]
          });
          w[at.MEMORY_LIMIT] = L.message, w[at.MEMORY_REQUEST] = E.message;
          break;
        }
        case at.BUILD_TIMEOUT: {
          S[at.BUILD_TIMEOUT] = {
            ...S[at.BUILD_TIMEOUT],
            value: x,
            unit: D
          }, w[at.BUILD_TIMEOUT] = Z0t(x).message;
          break;
        }
        case Mp.ACTIVATE_CPU:
          S[at.CPU_LIMIT] = {
            ...y[at.CPU_LIMIT],
            value: y[at.CPU_LIMIT].value,
            unit: y[at.CPU_LIMIT].unit,
            active: !0
          }, S[at.CPU_REQUEST] = {
            ...y[at.CPU_REQUEST],
            value: y[at.CPU_REQUEST].value,
            unit: y[at.CPU_REQUEST].unit,
            active: !0
          }, w[at.CPU_LIMIT] = null, w[at.CPU_REQUEST] = null;
          break;
        case Mp.ACTIVATE_MEMORY:
          S[at.MEMORY_LIMIT] = {
            ...y[at.MEMORY_LIMIT],
            value: y[at.MEMORY_LIMIT].value,
            unit: y[at.MEMORY_LIMIT].unit,
            active: !0
          }, S[at.MEMORY_REQUEST] = {
            ...y[at.MEMORY_REQUEST],
            value: y[at.MEMORY_REQUEST].value,
            unit: y[at.MEMORY_REQUEST].unit,
            active: !0
          }, w[at.MEMORY_LIMIT] = null, w[at.MEMORY_REQUEST] = null;
          break;
        case Mp.ACTIVATE_BUILD_TIMEOUT:
          S[at.BUILD_TIMEOUT] = {
            ...y[at.BUILD_TIMEOUT],
            value: y[at.BUILD_TIMEOUT].value,
            unit: y[at.BUILD_TIMEOUT].unit,
            active: !0
          }, w[at.BUILD_TIMEOUT] = null;
          break;
        case Mp.DE_ACTIVATE_BUILD_TIMEOUT:
          S[at.BUILD_TIMEOUT] = {
            ...S[at.BUILD_TIMEOUT],
            value: y[at.BUILD_TIMEOUT].defaultValue.value,
            unit: y[at.BUILD_TIMEOUT].defaultValue.unit,
            active: !1
          }, w[at.BUILD_TIMEOUT] = null;
          break;
        case Mp.DE_ACTIVATE_CPU:
          S[at.CPU_LIMIT] = {
            ...S[at.CPU_LIMIT],
            value: y[at.CPU_LIMIT].defaultValue.value,
            unit: y[at.CPU_LIMIT].defaultValue.unit,
            active: !1
          }, S[at.CPU_REQUEST] = {
            ...S[at.CPU_REQUEST],
            value: y[at.CPU_REQUEST].defaultValue.value,
            unit: y[at.CPU_REQUEST].defaultValue.unit,
            active: !1
          }, w[at.CPU_LIMIT] = null, w[at.CPU_REQUEST] = null;
          break;
        case Mp.DE_ACTIVATE_MEMORY:
          S[at.MEMORY_LIMIT] = {
            ...S[at.MEMORY_LIMIT],
            value: y[at.MEMORY_LIMIT].defaultValue.value,
            unit: y[at.MEMORY_LIMIT].defaultValue.unit,
            active: !1
          }, S[at.MEMORY_REQUEST] = {
            ...S[at.MEMORY_REQUEST],
            value: y[at.MEMORY_REQUEST].defaultValue.value,
            unit: y[at.MEMORY_REQUEST].defaultValue.unit,
            active: !1
          }, w[at.MEMORY_LIMIT] = null, w[at.MEMORY_REQUEST] = null;
          break;
        default:
          throw new Error(Ss.getInvalidActionMessage(m));
      }
      c(b), u(w);
    },
    loadingActionRequest: h,
    handleSubmit: async (m) => {
      if (m.preventDefault(), Object.keys(d).filter(
        (b) => d[b] !== null && d[b] !== void 0
      ).length > 0) {
        In.error(Ss.INVALID_FORM_MESSAGE);
        return;
      }
      f(!0);
      try {
        e ? await $Ie({ name: i, profileInput: l }) : await eAe({ profileInput: l }), f(!1), In.success(Ss.getSubmitSuccessMessage(l.name, e)), t ? t() : a();
      } catch (b) {
        Is(b), f(!1);
      }
    }
  };
}, nAe = () => Ode({
  control: (i, e) => ({
    ...i,
    borderRadius: 0,
    backgroundColor: "var(--N0)",
    border: e.isFocused ? "1px solid var(--B500) !important" : "1px solid var(--N200)",
    alignItems: "center",
    cursor: "pointer",
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    outline: "none",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid var(--N400)"
    }
  }),
  indicatorContainer: (i) => ({
    ...i,
    padding: "0px"
  }),
  dropdownIndicator: (i, e) => ({
    ...i,
    color: "var(--N600)",
    transition: "all .2s ease",
    transform: e.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
  }),
  option: (i, e) => ({
    ...i,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    cursor: "pointer",
    ...e.isFocused ? {
      backgroundColor: "var(--N50)"
    } : {},
    ...e.isSelected && {
      backgroundColor: "var(--B100)",
      fontWeight: 600,
      color: "var(--B500)"
    },
    "&:active": {
      backgroundColor: "var(--N50)"
    }
  }),
  valueContainer: (i) => ({
    ...i,
    color: "var(--N900)",
    fontSize: "13px",
    fontWeight: "400",
    lineHeight: "20px"
  }),
  menuList: (i) => ({
    ...i,
    maxHeight: "164px",
    height: "100%"
  })
}), rc = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { d: "M0 0h32v32H0z" }), /* @__PURE__ */ G.createElement("path", { fill: "#FFCB5D", d: "M18.315 5.052L29.72 25.01A2.667 2.667 0 0 1 27.405 29H4.595a2.667 2.667 0 0 1-2.315-3.99L13.685 5.052a2.667 2.667 0 0 1 4.63 0z" }), /* @__PURE__ */ G.createElement("path", { fill: "#FFF", d: "M16 22.667a1.333 1.333 0 1 1 0 2.666 1.333 1.333 0 0 1 0-2.666zM16 12c.736 0 1.333.597 1.333 1.333v6.334a1.333 1.333 0 1 1-2.666 0v-6.334c0-.736.597-1.333 1.333-1.333z" }))), nY = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cpath%20d='M0%200h32v32H0z'/%3e%3cpath%20fill='%23FFCB5D'%20d='M18.315%205.052L29.72%2025.01A2.667%202.667%200%200%201%2027.405%2029H4.595a2.667%202.667%200%200%201-2.315-3.99L13.685%205.052a2.667%202.667%200%200%201%204.63%200z'/%3e%3cpath%20fill='%23FFF'%20d='M16%2022.667a1.333%201.333%200%201%201%200%202.666%201.333%201.333%200%200%201%200-2.666zM16%2012c.736%200%201.333.597%201.333%201.333v6.334a1.333%201.333%200%201%201-2.666%200v-6.334c0-.736.597-1.333%201.333-1.333z'/%3e%3c/g%3e%3c/svg%3e", iAe = ({
  actionType: i,
  label: e,
  placeholder: t,
  error: n,
  isRequired: r,
  profileUnitsMap: s,
  handleProfileInputChange: o,
  currentUnitName: a,
  currentValue: l
}) => {
  const c = (f) => {
    const g = {
      unit: f.label,
      value: l
    };
    o({ action: i, data: g });
  }, d = (f) => {
    const g = {
      unit: a,
      value: f.currentTarget.value
    };
    o({ action: i, data: g });
  }, u = Mn(() => (Object.values(s)?.map((g) => ({
    label: g.name,
    value: String(g.conversionFactor)
  })) ?? []).sort((g, p) => Number(g.value) - Number(p.value)), [s]), h = Mn(
    () => u.find((f) => f.label === a),
    [u, a]
  );
  return /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-4 dc__mxw-420 w-100 dc__align-start", children: [
    /* @__PURE__ */ v.jsx(
      "label",
      {
        htmlFor: `${i}-input`,
        className: `fs-13 fw-4 lh-20 cn-7 ${r ? "dc__required-field" : ""}`,
        children: e
      }
    ),
    /* @__PURE__ */ v.jsxs("div", { className: "w-100 flexbox dc__align-items-center", children: [
      /* @__PURE__ */ v.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ v.jsx(
        "input",
        {
          "data-testid": `${i}-input-field`,
          name: i,
          type: "number",
          step: o_.STEP,
          min: o_.MIN,
          className: "form__input dc__no-right-border dc__no-right-radius",
          placeholder: t,
          value: l,
          onChange: d,
          required: r,
          autoComplete: "off",
          id: `${i}-input`
        }
      ) }),
      s && /* @__PURE__ */ v.jsx(
        Ba,
        {
          classNamePrefix: "unit-dropdown",
          name: `${i}-unit`,
          className: "bcn-0 dc__mxw-120",
          options: u,
          value: h,
          onChange: c,
          isSearchable: !1,
          components: {
            IndicatorSeparator: null,
            ClearIndicator: null
          },
          styles: nAe()
        }
      )
    ] }),
    n && /* @__PURE__ */ v.jsxs("div", { className: "form__error", children: [
      /* @__PURE__ */ v.jsx(rc, { className: "form__icon form__icon--error" }),
      n
    ] })
  ] });
}, rAe = ({
  heading: i,
  marker: e,
  children: t,
  isInheriting: n,
  showDivider: r,
  handleProfileInputChange: s,
  locator: o,
  isDefaultProfile: a
}) => {
  const l = (d) => {
    const { checked: u } = d.currentTarget, h = u ? `activate_${o}` : `de_activate_${o}`;
    s({ action: h });
  }, c = () => a ? /* @__PURE__ */ v.jsx(e, { className: "icon-dim-20 dc__no-shrink" }) : /* @__PURE__ */ v.jsx(
    cb,
    {
      onChange: l,
      isChecked: !n,
      value: Aa.CHECKED,
      dataTestId: `${o}_marker`
    }
  );
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("div", { className: "flexbox-col dc__gap-8 w-100", children: /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-12 dc__align-start w-100", children: [
      c(),
      /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-8 w-100", children: [
        i,
        !n && t
      ] })
    ] }) }),
    r && /* @__PURE__ */ v.jsx("div", { className: "w-100 dc__border-bottom-n1" })
  ] });
}, sAe = ({
  handleProfileInputChange: i,
  currentValue: e,
  error: t
}) => {
  const n = (r) => {
    i({
      action: Wm.DESCRIPTION,
      data: { value: r.currentTarget.value }
    });
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-4 w-100 dc__align-start", children: [
    /* @__PURE__ */ v.jsx("label", { htmlFor: "build-infra-profile-description", className: "m-0 fs-13 fw-4 lh-20 cn-7", children: Ss.DESCRIPTION_LABEL }),
    /* @__PURE__ */ v.jsx(
      "textarea",
      {
        "data-testid": "build-infra-profile-description",
        name: "profile-description",
        className: "form__textarea mxh-140 dc__hover-border-n300",
        id: "build-infra-profile-description",
        placeholder: Ss.DESCRIPTION_PLACEHOLDER,
        value: e,
        onChange: n
      }
    ),
    t && /* @__PURE__ */ v.jsxs("div", { className: "form__error", children: [
      /* @__PURE__ */ v.jsx(rc, { className: "form__icon form__icon--error" }),
      t
    ] })
  ] });
}, oAe = ({
  handleProfileInputChange: i,
  currentValue: e,
  error: t
}) => {
  const n = (r) => {
    i({ action: Wm.NAME, data: { value: r.currentTarget.value } });
  };
  return /* @__PURE__ */ v.jsx("div", { className: "flexbox-col dc__gap-4 w-100 dc__align-start", children: /* @__PURE__ */ v.jsx(
    Ck,
    {
      name: "profile-name",
      label: Ss.PROFILE_LABEL,
      labelClassName: "m-0 dc__required-field fs-13 fw-4 lh-20 cn-7",
      placeholder: Ss.PROFILE_PLACEHOLDER,
      value: e,
      onChange: n,
      error: t,
      required: !0,
      inputWrapClassName: "w-100"
    }
  ) });
}, aAe = ({
  defaultHeading: i,
  inheritingData: e,
  isInheriting: t,
  isDefaultProfile: n
}) => {
  const r = e.map((s) => `${s.value} ${s.unit ?? ""}`).join(" - ");
  return n || !t ? /* @__PURE__ */ v.jsx(v.Fragment, { children: i }) : /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space w-100", children: [
    i,
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__content-space w-100", children: [
      /* @__PURE__ */ v.jsx("span", { className: "m-0 pt-0 pb-0 pl-4 pr-4 fs-13 lh-20 fw-4 cn-9 dc__ellipsis-right dc__word-break-all flex-grow-1", children: r }),
      /* @__PURE__ */ v.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-20 dc__no-shrink", children: Ss.INHERITING_HEADING_DESCRIPTION })
    ] })
  ] });
}, lAe = ({
  profileInput: i,
  profileInputErrors: e,
  handleProfileInputChange: t,
  isDefaultProfile: n,
  unitsMap: r,
  configurationContainerLabel: s
}) => {
  const o = i?.configurations, a = (l) => l.some((c) => !o[c.actionType].active);
  return o ? /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__mxw-920 dc__gap-16", children: [
    !n && /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ v.jsx(
        oAe,
        {
          handleProfileInputChange: t,
          currentValue: i.name,
          error: e.name
        }
      ),
      /* @__PURE__ */ v.jsx(
        sAe,
        {
          handleProfileInputChange: t,
          currentValue: i.description,
          error: e.description
        }
      )
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      s,
      /* @__PURE__ */ v.jsx("div", { className: "w-100 flexbox-col dc__gap-16 br-4 dc__border-n1 p-16", children: eY.map((l, c) => /* @__PURE__ */ v.jsx(
        rAe,
        {
          marker: l.marker,
          heading: /* @__PURE__ */ v.jsx(
            aAe,
            {
              defaultHeading: l.heading,
              inheritingData: l.actions.map(
                (d) => o[d.actionType]
              ),
              isInheriting: a(l.actions),
              isDefaultProfile: n
            }
          ),
          showDivider: c !== eY.length - 1,
          isInheriting: a(l.actions),
          handleProfileInputChange: t,
          locator: l.locator,
          isDefaultProfile: n,
          children: /* @__PURE__ */ v.jsx("div", { className: "w-50 flexbox dc__gap-12 w-100 dc__align-start", children: l.actions.map((d) => /* @__PURE__ */ v.jsx(
            iAe,
            {
              actionType: d.actionType,
              label: d.label,
              placeholder: d.placeholder,
              error: e[d.actionType],
              isRequired: !0,
              profileUnitsMap: r[d.actionType],
              handleProfileInputChange: t,
              currentUnitName: o[d.actionType].unit,
              currentValue: o[d.actionType].value
            },
            d.actionType
          )) })
        },
        l.locator
      )) })
    ] })
  ] }) : /* @__PURE__ */ v.jsx(Yr, { pageLoader: !0 });
}, ibt = lAe;
var cAe = /* @__PURE__ */ ((i) => (i.email = "email_id", i.lastLogin = "last_login", i))(cAe || {}), dAe = /* @__PURE__ */ ((i) => (i.active = "active", i.inactive = "inactive", i))(dAe || {}), uAe = /* @__PURE__ */ ((i) => (i.active = "active", i.inactive = "inactive", i.temporary = "temporaryAccess", i))(uAe || {});
const hAe = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { className: "stroke-color", d: "M2.5 5.00001H4.16667M4.16667 5.00001H17.5M4.16667 5.00001L4.16667 16.6667C4.16667 17.5872 4.91286 18.3333 5.83333 18.3333H14.1667C15.0871 18.3333 15.8333 17.5872 15.8333 16.6667V5.00001M6.66667 5.00001V3.33334C6.66667 2.41286 7.41286 1.66667 8.33334 1.66667H11.6667C12.5871 1.66667 13.3333 2.41286 13.3333 3.33334V5.00001M8.33333 9.16667V14.1667M11.6667 9.16667V14.1667", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), fAe = ({
  id: i,
  name: e,
  description: t,
  status: n,
  timeToLive: r,
  modifierClassName: s,
  disableStatusComponent: o,
  handleStatusUpdate: a,
  handleDelete: l,
  statusComponent: c,
  showStatus: d,
  showDelete: u
}) => {
  const h = (g, p) => {
    a?.(i, g, p);
  }, f = () => {
    l(i);
  };
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `user-role-groups__table-row ${s} display-grid dc__align-items-center`,
      children: [
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "icon-dim-20 mw-20 flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0",
            style: { backgroundColor: vx(e) },
            children: e[0]
          }
        ),
        /* @__PURE__ */ v.jsx(D0, { to: `${sr.PERMISSION_GROUPS}/${i}`, className: "dc__ellipsis-right anchor cursor", children: e }),
        /* @__PURE__ */ v.jsx("div", { className: "dc__ellipsis-right", children: t || "-" }),
        d && /* @__PURE__ */ v.jsx(
          c,
          {
            userStatus: n,
            timeToLive: r,
            userEmail: "",
            handleChange: h,
            disabled: o,
            showDropdownBorder: !1,
            breakLinesForTemporaryAccess: !0,
            showTooltipWhenDisabled: !0
          }
        ),
        u && /* @__PURE__ */ v.jsx(wn, { className: "default-tt", arrow: !1, placement: "top", content: "Delete", children: /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            className: "dc__transparent flex p-4",
            "data-testid": "user-role-groups__delete-button icon-delete",
            onClick: f,
            "aria-label": "Delete row",
            children: /* @__PURE__ */ v.jsx(hAe, { className: "scn-6 icon-dim-16 icon-delete" })
          }
        ) })
      ]
    },
    `user-groups-group-${i}`
  );
}, gAe = (i, e) => i && e ? "user-role-groups__table-row--with-status-and-delete" : i ? "user-role-groups__table-row--with-status" : "user-role-groups__table-row--with-delete", pAe = ({
  roleGroups: i,
  showStatus: e,
  handleDelete: t,
  statusComponent: n,
  statusHeaderComponent: r,
  handleStatusUpdate: s,
  disableStatusComponent: o = !1
}) => {
  const a = !!t, l = gAe(e, a);
  return /* @__PURE__ */ v.jsxs("div", { children: [
    /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: `user-role-groups__table-header ${l} display-grid dc__align-items-center dc__uppercase fs-12 fw-6 cn-7 lh-20 pt-6 pb-6`,
        children: [
          /* @__PURE__ */ v.jsx("span", {}),
          /* @__PURE__ */ v.jsx("span", { children: "Group Name" }),
          /* @__PURE__ */ v.jsx("span", { children: "Description" }),
          e && /* @__PURE__ */ v.jsx(r, {}),
          a && /* @__PURE__ */ v.jsx("span", {})
        ]
      }
    ),
    /* @__PURE__ */ v.jsx("div", { className: "fs-13 fw-4 lh-20 cn-9", children: i.map((c) => /* @__PURE__ */ pr(
      fAe,
      {
        ...c,
        statusComponent: n,
        handleStatusUpdate: s,
        disableStatusComponent: o,
        handleDelete: t,
        showDelete: a,
        modifierClassName: l,
        showStatus: e,
        key: c.id
      }
    )) })
  ] });
}, rbt = pAe, iY = (i) => ({
  label: i.startsWith(gy) ? i.split(":")[1] : i,
  value: i
}), sbt = async () => {
  const { result: i } = await Qn(hn.USER_LIST_MIN);
  if (!i)
    return [];
  const e = i.map(({ emailId: t }) => t).sort(Qs);
  return [
    {
      label: "Users",
      options: e.filter((t) => t !== fy.system && !t.startsWith(gy)).map((t) => iY(t))
    },
    {
      label: "API Tokens",
      options: e.filter((t) => t.startsWith(gy)).map((t) => iY(t))
    }
  ];
};
var mAe = /* @__PURE__ */ ((i) => (i.YAML = "yaml", i.SAVED = "variables", i.ENVIRONMENT_LIST = "environments", i))(mAe || {}), V2 = /* @__PURE__ */ ((i) => (i.JOB_AND_CRONJOB_CHART_NAME = "Job & CronJob", i.ROLLOUT_DEPLOYMENT = "Rollout Deployment", i.DEPLOYMENT = "Deployment", i.STATEFUL_SET = "StatefulSet", i))(V2 || {});
const vAe = "object", _Ae = {
  ContainerPort: {
    type: "array",
    description: "Defines ports on which application services will be exposed to other services",
    items: {
      type: "object",
      properties: {
        port: {
          type: "integer",
          description: "Port at which your application will run"
        }
      }
    },
    title: "Container Port"
  },
  resources: {
    type: "object",
    title: "Resources (CPU & RAM)",
    description: "Minimum and maximum RAM and CPU available to the application",
    properties: {
      limits: {
        type: "object",
        description: "Maximum RAM and CPU available to the application",
        required: [
          "cpu",
          "memory"
        ],
        properties: {
          cpu: {
            type: "string",
            description: "Maximum allowed CPU limit"
          },
          memory: {
            type: "string",
            description: "Maximum allowed memory limit"
          }
        }
      },
      requests: {
        type: "object",
        description: "Minimum RAM and CPU available to the application",
        properties: {
          cpu: {
            type: "string",
            description: "Minimum CPU value"
          },
          memory: {
            type: "string",
            description: "Minimum memory value"
          }
        }
      }
    }
  },
  EnvVariables: {
    type: "array",
    description: "Contains environment variables needed by the containers",
    items: {
      type: "object",
      properties: {
        name: {
          type: "string",
          description: "Name of the environment variables"
        },
        value: {
          type: "string",
          description: "Value of the environment variables"
        }
      }
    },
    title: "Environment Variables"
  }
}, bAe = {
  type: vAe,
  properties: _Ae
}, obt = (i) => {
  if (!i)
    return [];
  const e = i.reduce(
    (n, { id: r, version: s, chartDescription: o = "", name: a, isUserUploaded: l = !0 }) => {
      if (!a || !r || !s)
        return n;
      const c = n[a];
      return c ? c.versions.push({
        id: r,
        version: s,
        description: o
      }) : n[a] = {
        name: a,
        isUserUploaded: l,
        versions: [{ id: r, version: s, description: o }]
      }, n;
    },
    {}
  );
  return Object.values(e).map((n) => (n.versions.sort((r, s) => DAe(r, s, "version", Xi.DESC)), n));
}, abt = (i) => {
  switch (i) {
    case V2.JOB_AND_CRONJOB_CHART_NAME:
    case V2.DEPLOYMENT:
    case V2.ROLLOUT_DEPLOYMENT:
    case V2.STATEFUL_SET:
      return bAe;
    default:
      return {};
  }
};
function CAe(i, e) {
  switch (i) {
    case En.DaemonSet:
    case En.Deployment:
    case En.Pod:
    case En.ReplicaSet:
    case En.Job:
    case En.CronJob:
    case En.ReplicationController:
    case En.StatefulSet:
      return wc.Workloads;
    case En.Ingress:
    case En.Service:
    case En.Endpoints:
    case En.EndpointSlice:
    case En.NetworkPolicy:
      return wc.Networking;
    case En.ConfigMap:
    case En.Secret:
    case En.PersistentVolume:
    case En.PersistentVolumeClaim:
    case En.StorageClass:
    case En.VolumeSnapshot:
    case En.VolumeSnapshotContent:
    case En.VolumeSnapshotClass:
    case En.PodDisruptionBudget:
      return wc["Config & Storage"];
    case En.ServiceAccount:
    case En.ClusterRoleBinding:
    case En.RoleBinding:
    case En.ClusterRole:
    case En.Role:
    case En.PodSecurityPolicy:
      return wc.RBAC;
    case En.MutatingWebhookConfiguration:
    case En.ValidatingWebhookConfiguration:
      return wc.Administration;
    case En.Alertmanager:
    case En.Prometheus:
    case En.ServiceMonitor:
      return wc["Custom Resource"];
    case En.Event:
      return wc.Events;
    case En.Namespace:
      return wc.Namespaces;
    default:
      return e ? wc["Other Resources"] : wc["Custom Resource"];
  }
}
var yAe = /* @__PURE__ */ ((i) => (i.NEW_DEPLOYMENT = "create", i.MIGRATE_HELM = "link", i))(yAe || {});
const wAe = (i) => {
  switch (i) {
    case w3.PRE:
      return "pre-deployment";
    case w3.POST:
      return "post-deployment";
    case w3.DEPLOY:
      return "deployment";
    default:
      return "-";
  }
}, SAe = (i) => i.replace(yE.ESCAPED_CHARACTERS, "\\$&"), lbt = ({ searchText: i, text: e, highlightClasses: t }) => {
  if (!i)
    return e;
  try {
    const n = new RegExp(i, "gi");
    return e.replace(n, (r) => `<span class="${t}">${r}</span>`);
  } catch {
    return e;
  }
}, a_ = (i) => {
  i ? (document.body.style.overflowY = "hidden", document.body.style.height = "100vh", document.documentElement.style.overflow = "initial") : (document.body.style.overflowY = null, document.body.style.height = null, document.documentElement.style.overflow = null);
}, xAe = (i) => !!(i.webhookData || i.author || i.message || i.modifiedTime || i.revision), cbt = (i) => !!i?.every(xAe), dbt = (i) => ({
  Commit: i.revision,
  Author: i.author,
  Date: i.modifiedTime,
  Message: i.message,
  WebhookData: JSON.parse(i.webhookData),
  Changes: [],
  GitRepoUrl: "",
  GitRepoName: "",
  CiConfigureSourceType: "",
  CiConfigureSourceValue: ""
}), Qs = (i, e, t = Xi.ASC, n = !0) => n ? t === Xi.ASC ? i.localeCompare(e) : e.localeCompare(i) : t === Xi.ASC ? i.toLowerCase().localeCompare(e.toLowerCase()) : e.toLowerCase().localeCompare(i.toLowerCase()), qde = (i, e, t = Xi.ASC) => t === Xi.ASC ? i - e : e - i;
function DAe(i, e, t, n) {
  return n === Xi.DESC ? e[t].localeCompare(i[t], void 0, { numeric: !0 }) : i[t].localeCompare(e[t], void 0, { numeric: !0 });
}
const ubt = (i) => {
  switch (i) {
    case U8.PULL_REQUEST:
      return /* @__PURE__ */ v.jsx(BIe, { className: "icon-dim-12" });
    case U8.TAG_CREATION:
      return /* @__PURE__ */ v.jsx(VIe, { className: "icon-dim-12" });
    default:
      return /* @__PURE__ */ v.jsx(HIe, { className: "icon-dim-12" });
  }
}, Y8 = (i, e, t = Xi.ASC) => {
  let n = 0;
  return t === Xi.DESC ? n = -1 : t === Xi.ASC && (n = 1), i.key < e.key ? -1 * n : i.key > e.key ? 1 * n : 0;
}, EAe = (i, e = {}, t) => {
  const { defaultIntersecting: n, once: r, ...s } = e, o = Nt(s), [a, l] = Oe(n === !0), c = Nt(!1);
  return $e(() => {
    w1t(o.current, s) || (o.current = s);
  }), $e(() => {
    if (i == null)
      return;
    const d = i instanceof Element ? i : i.current;
    if (d == null || r && c.current)
      return;
    const u = new IntersectionObserver(
      ([h]) => {
        l(h.isIntersecting), t?.(h), h.isIntersecting && (c.current = !0), r && h.isIntersecting && d != null && u.unobserve(d);
      },
      {
        ...o.current,
        root: o.current.root != null ? o.current.root.current : null
      }
    );
    return u.observe(d), () => {
      r && c.current || d != null && u.unobserve(d);
    };
  }, [o.current, i]), a;
}, LAe = (i) => i == null, hbt = (i) => {
  const e = i.target instanceof HTMLTextAreaElement;
  i.key === "Enter" && !e && i.preventDefault();
}, fbt = (i = []) => i.reduce(
  (e, t) => (e[t] = !0, e),
  {}
), gbt = (i) => /* @__PURE__ */ v.jsx(
  wn,
  {
    content: "Valid input is required for all mandatory fields.",
    placement: "top",
    className: "default-tt",
    arrow: !1,
    children: i
  }
), rY = (i) => {
  const e = {
    deploymentStatus: "inprogress",
    deploymentStatusText: "In progress",
    deploymentTriggerTime: i?.deploymentStartedOn || "",
    deploymentEndTime: i?.deploymentFinishedOn || "",
    deploymentError: "",
    triggeredBy: i?.triggeredBy || "",
    nonDeploymentError: "",
    deploymentStatusBreakdown: {
      DEPLOYMENT_INITIATED: {
        icon: "success",
        displayText: `Deployment initiated ${i?.triggeredBy ? `by ${i?.triggeredBy}` : ""}`,
        displaySubText: "",
        time: ""
      },
      GIT_COMMIT: {
        icon: "",
        displayText: "Push manifest to Git",
        displaySubText: "",
        timelineStatus: "",
        time: "",
        isCollapsed: !0
      },
      ARGOCD_SYNC: {
        icon: "",
        displayText: "Synced with Argo CD",
        displaySubText: "",
        timelineStatus: "",
        time: "",
        isCollapsed: !0
      },
      KUBECTL_APPLY: {
        icon: "",
        displayText: "Apply manifest to Kubernetes",
        timelineStatus: "",
        displaySubText: "",
        time: "",
        resourceDetails: [],
        isCollapsed: !0,
        kubeList: []
      },
      APP_HEALTH: {
        icon: "",
        displayText: "Propogate manifest to Kubernetes resources",
        timelineStatus: "",
        displaySubText: "",
        time: "",
        isCollapsed: !0
      }
    }
  }, t = nA(i?.statusLastFetchedAt, !0), n = ["PreSync", "Sync", "PostSync", "Skip", "SyncFail"], r = {
    currentPhase: "",
    currentTableData: [{ icon: "success", message: "Started by Argo CD" }]
  };
  if (i?.timelines?.length) {
    const s = i.timelines.some(
      (o) => o.status.includes(Ot.ARGOCD_SYNC)
    );
    for (let o = i.timelines.length - 1; o >= 0; o--) {
      const a = i.timelines[o];
      a.status === Ot.HEALTHY || a.status === Ot.DEGRADED ? (e.deploymentStatus = ei.SUCCEEDED, e.deploymentStatusText = "Succeeded", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = a.status === Ot.HEALTHY ? "" : "Degraded", e.deploymentStatusBreakdown.APP_HEALTH.time = a.statusTime, e.deploymentStatusBreakdown.APP_HEALTH.icon = "success", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "success", e.deploymentStatusBreakdown.KUBECTL_APPLY.isCollapsed = !0, e.deploymentStatusBreakdown.APP_HEALTH.isCollapsed = !0, e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "success", e.deploymentStatusBreakdown.GIT_COMMIT.icon = "success") : a.status === Ot.DEPLOYMENT_FAILED ? (e.deploymentStatus = ei.FAILED, e.deploymentStatusText = "Failed", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "   Failed", e.deploymentError = a.statusDetail) : a.status === Ot.DEPLOYMENT_SUPERSEDED ? e.deploymentStatus = ei.SUPERSEDED : o === i.timelines.length - 1 && (a.status === Ot.FETCH_TIMED_OUT || a.status === Ot.UNABLE_TO_FETCH_STATUS) ? (a.status === Ot.FETCH_TIMED_OUT ? (e.deploymentStatus = ei.TIMED_OUT, e.deploymentStatusText = "Timed out") : a.status === Ot.UNABLE_TO_FETCH_STATUS && (e.deploymentStatus = ei.UNABLE_TO_FETCH, e.deploymentStatusText = "Unable to fetch status"), e.deploymentError = `Below resources did not become healthy within 10 mins. Resource status shown below was last fetched ${t}. ${i.statusFetchCount} retries failed.`) : a.status.includes(Ot.KUBECTL_APPLY) ? (s || (e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "success", e.deploymentStatusBreakdown.ARGOCD_SYNC.displaySubText = "", e.deploymentStatusBreakdown.ARGOCD_SYNC.time = a.statusTime), a?.resourceDetails && n.forEach((l) => {
        for (const c of a.resourceDetails)
          if (l === c.resourcePhase) {
            r.currentPhase = l, c.resourceStatus, r.currentTableData.push({
              icon: "success",
              phase: l,
              message: `${l}: Create and update resources based on manifest`
            });
            return;
          }
      }), a.status === Ot.KUBECTL_APPLY_STARTED && e.deploymentStatusBreakdown.KUBECTL_APPLY.time === "" && e.deploymentStatus !== ei.SUCCEEDED ? (e.deploymentStatusBreakdown.KUBECTL_APPLY.resourceDetails = a.resourceDetails?.filter((l) => l.resourcePhase === r.currentPhase), e.deploymentStatus === ei.FAILED ? (e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unknown", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = ": Unknown", e.deploymentStatusBreakdown.APP_HEALTH.icon = "unknown", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = ": Unknown") : e.deploymentStatus === ei.SUCCEEDED ? (e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "success", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "") : e.deploymentStatus === ei.TIMED_OUT || e.deploymentStatus === ei.UNABLE_TO_FETCH ? (e.deploymentStatus === ei.TIMED_OUT ? (e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unknown", e.deploymentStatusBreakdown.KUBECTL_APPLY.isCollapsed = !1) : e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "disconnect", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "Unknown", e.deploymentStatusBreakdown.KUBECTL_APPLY.timelineStatus = e.deploymentError, e.deploymentStatusBreakdown.KUBECTL_APPLY.kubeList = r.currentTableData.map((l) => ({
        icon: l.phase === r.currentPhase ? "failed" : "success",
        message: l.message
      }))) : (e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "inprogress", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "In progress", e.deploymentStatusBreakdown.KUBECTL_APPLY.time = a.statusTime, e.deploymentStatusBreakdown.KUBECTL_APPLY.timelineStatus = a.statusDetail, e.deploymentStatusBreakdown.KUBECTL_APPLY.isCollapsed = !1, e.deploymentStatusBreakdown.KUBECTL_APPLY.kubeList = r.currentTableData.map((l) => ({
        icon: l.phase === r.currentPhase ? "loading" : "success",
        message: l.message
      })))) : a.status === Ot.KUBECTL_APPLY_SYNCED && (e.deploymentStatusBreakdown.KUBECTL_APPLY.resourceDetails = [], e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.time = a.statusTime, e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "success", e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "success", e.deploymentStatusBreakdown.GIT_COMMIT.icon = "success", e.deploymentStatusBreakdown.KUBECTL_APPLY.kubeList = r.currentTableData, e.deploymentStatus === ei.INPROGRESS ? (e.deploymentStatusBreakdown.APP_HEALTH.icon = "inprogress", e.deploymentStatusBreakdown.APP_HEALTH.isCollapsed = !1) : e.deploymentStatus === ei.FAILED ? (e.deploymentStatusBreakdown.APP_HEALTH.icon = "failed", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "Failed") : e.deploymentStatus === ei.TIMED_OUT ? (e.deploymentStatusBreakdown.APP_HEALTH.icon = "timed_out", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "Unknown", e.deploymentStatusBreakdown.APP_HEALTH.timelineStatus = e.deploymentError, e.deploymentStatusBreakdown.APP_HEALTH.isCollapsed = !1) : e.deploymentStatus === ei.UNABLE_TO_FETCH && (e.deploymentStatusBreakdown.APP_HEALTH.icon = "disconnect", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "Unknown", e.deploymentStatusBreakdown.APP_HEALTH.timelineStatus = e.deploymentError, e.deploymentStatusBreakdown.APP_HEALTH.isCollapsed = !1))) : a.status.includes(Ot.ARGOCD_SYNC) ? (e.deploymentStatusBreakdown.ARGOCD_SYNC.time = a.statusTime, a.status === Ot.ARGOCD_SYNC_FAILED ? (e.deploymentStatusBreakdown.ARGOCD_SYNC.displaySubText = "Failed", e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "failed", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unreachable", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "", e.deploymentStatusBreakdown.APP_HEALTH.icon = "unreachable", e.deploymentStatusBreakdown.ARGOCD_SYNC.isCollapsed = !1, e.deploymentStatus = ei.FAILED, e.deploymentStatusText = "Failed", e.deploymentStatusBreakdown.ARGOCD_SYNC.timelineStatus = a.statusDetail) : (e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "success", e.deploymentStatus === ei.FAILED ? (e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unreachable", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "", e.deploymentStatusBreakdown.APP_HEALTH.icon = "unreachable", e.nonDeploymentError === "" && (e.nonDeploymentError = Ot.KUBECTL_APPLY)) : e.deploymentStatusBreakdown.KUBECTL_APPLY.time === "" && e.deploymentStatus === ei.INPROGRESS && (e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "Waiting", e.deploymentStatusBreakdown.KUBECTL_APPLY.kubeList = [
        { icon: "", message: "Waiting to be started by Argo CD" },
        { icon: "", message: "Create and update resources based on manifest" }
      ], e.deploymentStatusBreakdown.KUBECTL_APPLY.isCollapsed = !1))) : a.status.includes(Ot.GIT_COMMIT) ? (e.deploymentStatusBreakdown.GIT_COMMIT.time = a.statusTime, a.status === Ot.GIT_COMMIT_FAILED ? (e.deploymentStatusBreakdown.GIT_COMMIT.displaySubText = "Failed", e.deploymentStatusBreakdown.GIT_COMMIT.icon = "failed", e.deploymentStatusBreakdown.ARGOCD_SYNC.displaySubText = "", e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "unreachable", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unreachable", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "", e.deploymentStatusBreakdown.APP_HEALTH.icon = "unreachable", e.deploymentStatusBreakdown.GIT_COMMIT.isCollapsed = !1, e.deploymentStatus = ei.FAILED, e.deploymentStatusText = "Failed", e.deploymentStatusBreakdown.GIT_COMMIT.timelineStatus = a.statusDetail) : (e.deploymentStatusBreakdown.GIT_COMMIT.icon = "success", e.deploymentStatus === ei.FAILED ? (e.deploymentStatusBreakdown.ARGOCD_SYNC.icon === "" && (e.deploymentStatusBreakdown.ARGOCD_SYNC.displaySubText = "", e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "unreachable"), e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unreachable", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "", e.deploymentStatusBreakdown.APP_HEALTH.icon = "unreachable", e.nonDeploymentError === "" && (e.nonDeploymentError = Ot.ARGOCD_SYNC)) : e.deploymentStatusBreakdown.ARGOCD_SYNC.time === "" && e.deploymentStatus === ei.INPROGRESS && (e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "Waiting", e.deploymentStatusBreakdown.KUBECTL_APPLY.kubeList = [
        { icon: "", message: "Waiting to be started by Argo CD" },
        { icon: "", message: "Create and update resources based on manifest" }
      ], e.deploymentStatusBreakdown.KUBECTL_APPLY.isCollapsed = !1, e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "inprogress", e.deploymentStatusBreakdown.ARGOCD_SYNC.displaySubText = "In progress"))) : a.status === Ot.DEPLOYMENT_INITIATED && (e.deploymentStatusBreakdown.DEPLOYMENT_INITIATED.time = a.statusTime, e.deploymentStatusBreakdown.GIT_COMMIT.time === "" && e.deploymentStatus === ei.INPROGRESS && (e.deploymentStatusBreakdown.GIT_COMMIT.icon = "inprogress", e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "", e.deploymentStatusBreakdown.ARGOCD_SYNC.displaySubText = "Waiting", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "Waiting", e.deploymentStatusBreakdown.KUBECTL_APPLY.kubeList = [
        { icon: "", message: "Waiting to be started by Argo CD" },
        { icon: "", message: "Create and update resources based on manifest" }
      ], e.deploymentStatusBreakdown.KUBECTL_APPLY.isCollapsed = !1), e.deploymentStatus === ei.FAILED && (e.deploymentStatusBreakdown.GIT_COMMIT.time === "" ? (e.deploymentStatusBreakdown.GIT_COMMIT.displaySubText = "", e.deploymentStatusBreakdown.GIT_COMMIT.icon = "unreachable", e.deploymentStatusBreakdown.ARGOCD_SYNC.displaySubText = "", e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "unreachable", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unreachable", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "", e.deploymentStatusBreakdown.APP_HEALTH.icon = "unreachable", e.nonDeploymentError = Ot.GIT_COMMIT) : e.deploymentStatusBreakdown.GIT_COMMIT.icon !== "failed" ? e.deploymentStatusBreakdown.ARGOCD_SYNC.time === "" ? (e.deploymentStatusBreakdown.ARGOCD_SYNC.displaySubText = "Unknown", e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "unknown", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "Unknown", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unknown", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = ": Unknown", e.deploymentStatusBreakdown.APP_HEALTH.icon = "unknown") : e.deploymentStatusBreakdown.ARGOCD_SYNC.icon !== "failed" && (e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "Unknown", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unknown", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = ": Unknown", e.deploymentStatusBreakdown.APP_HEALTH.icon = "unknown") : (e.deploymentStatusBreakdown.GIT_COMMIT.displaySubText = "", e.deploymentStatusBreakdown.GIT_COMMIT.icon = "unreachable", e.deploymentStatusBreakdown.ARGOCD_SYNC.displaySubText = "", e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "unreachable", e.deploymentStatusBreakdown.KUBECTL_APPLY.displaySubText = "", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "unreachable", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "", e.deploymentStatusBreakdown.APP_HEALTH.icon = "unreachable", e.nonDeploymentError = Ot.GIT_COMMIT)));
    }
  } else i?.timelines || (i?.wfrStatus === "Healthy" || i?.wfrStatus === "Succeeded" ? (e.deploymentStatus = ei.SUCCEEDED, e.deploymentStatusText = "Succeeded", e.deploymentStatusBreakdown.APP_HEALTH.icon = "success", e.deploymentStatusBreakdown.KUBECTL_APPLY.icon = "success", e.deploymentStatusBreakdown.KUBECTL_APPLY.isCollapsed = !0, e.deploymentStatusBreakdown.APP_HEALTH.isCollapsed = !0, e.deploymentStatusBreakdown.ARGOCD_SYNC.icon = "success", e.deploymentStatusBreakdown.GIT_COMMIT.icon = "success") : i?.wfrStatus === "Failed" || i?.wfrStatus === "Degraded" ? (e.deploymentStatus = ei.FAILED, e.deploymentStatusText = "Failed", e.deploymentStatusBreakdown.APP_HEALTH.displaySubText = "Failed") : i?.wfrStatus === "Progressing" ? (e.deploymentStatus = ei.INPROGRESS, e.deploymentStatusText = "In progress") : i?.wfrStatus === "TimedOut" && (e.deploymentStatus = ei.TIMED_OUT, e.deploymentStatusText = "Timed out"));
  return e;
};
function IAe(i, e) {
  const t = hCe(e, "name"), n = i.reduce((r, s) => {
    if (r[s.kind] = r[s.kind] || /* @__PURE__ */ new Map(), s.kind === En.Pod) {
      s.info?.forEach(({ name: a, value: l }) => {
        a === "Status Reason" ? s.status = l.toLowerCase() : a === "Containers" && (s.ready = l);
      });
      const o = t.has(s.name) ? t.get(s.name) : {};
      r[s.kind].set(s.name, { ...s, ...o });
    } else s.kind === En.Service && (s.url = `${s.name}.${s.namespace}: { portnumber }`), r[s.kind].set(s.name, s);
    return r;
  }, {});
  return i.reduce(
    (r, s) => {
      const o = s.kind, a = CAe(o);
      return r.aggregation[a] = r.aggregation[a] || {}, r.nodes[o] = n[o], s.health && s.health.status && (r.statusCount[s.health.status] = (r.statusCount[s.health.status] || 0) + 1, r.nodeStatusCount[s.kind] = r.nodeStatusCount[s.kind] || {}, r.nodeStatusCount[s.kind][s.health.status] = (r.nodeStatusCount[s.kind][s.health.status] || 0) + 1, r.aggregatorStatusCount[a] = r.aggregatorStatusCount[a] || {}, r.aggregatorStatusCount[a][s.health.status] = (r.aggregatorStatusCount[a][s.health.status] || 0) + 1), Array.isArray(s.parentRefs) && s.parentRefs.forEach(({ kind: l, name: c }) => {
        if (n[l] && n[l].has(c)) {
          const d = n[l].get(c), u = d.children || {};
          u[o] = u[o] || [], u[o] = [...u[o], s.name], r.nodes[l] || (r.nodes[l] = /* @__PURE__ */ new Map()), r.nodes[l].set(c, { ...d, children: u });
        }
      }), r.aggregation[a][o] = r.nodes[o], r;
    },
    { nodes: {}, aggregation: {}, statusCount: {}, nodeStatusCount: {}, aggregatorStatusCount: {} }
  );
}
const AAe = (i, e = !1) => e ? btoa(i) : atob(i), sY = (i, e = !1) => Object.keys(i).map((t) => ({ key: t, value: i[t] ? AAe(i[t], e) : i[t] })).reduce((t, n) => (t[n.key] = n.value, t), {}), oY = (i) => !!i && i !== iS, kAe = (i, e) => {
  if (!oY(i) || !oY(e))
    return "-";
  const t = st(e).diff(st(i), "seconds"), n = st(e).diff(st(i), "minutes"), r = st(e).diff(st(i), "hours");
  if (t < 60)
    return `${t}s`;
  if (n < 60)
    return `${n}m ${t % 60}s`;
  const s = n - r * 60, o = t - n * 60;
  return `${r}h ${s}m ${o}s`;
}, TAe = (i) => i?.get("content-disposition")?.split(";")?.find((e) => e.includes("filename="))?.replace("filename=", "").trim(), _j = (i) => ({
  requiredCount: i?.requiredCount ?? 0,
  type: i?.type ?? hA.notConfigured,
  specificUsers: {
    identifiers: i?.specificUsers?.identifiers ?? [],
    requiredCount: i?.specificUsers?.identifiers?.length ?? 0
  },
  userGroups: i?.userGroups ?? []
}), NAe = (i) => (
  // Added null check for backward compatibility
  !!i?.type && i.type !== hA.notConfigured
), PAe = (i) => NAe(i) && i.type === hA.specific, OAe = (i) => () => {
  window.open(i, "_blank", "noreferrer");
}, MAe = (i) => i.sort(
  (e, t) => qde(
    wE[e.severity],
    wE[t.severity],
    Xi.ASC
  )
), RAe = (i) => {
  const e = i?.vulnerabilities || [], t = MAe(e);
  return {
    ...i || {},
    lastExecution: i?.executionTime && i.executionTime !== iS ? st(i.executionTime).format(Wde) : "",
    severityCount: {
      critical: i?.severityCount?.critical ?? 0,
      high: i?.severityCount?.high ?? 0,
      medium: i?.severityCount?.medium ?? 0,
      low: i?.severityCount?.low ?? 0,
      unknown: i?.severityCount?.unknown ?? 0
    },
    vulnerabilities: t.map((n) => ({
      name: n.cveName,
      severity: n.severity,
      package: n.package,
      version: n.currentVersion,
      fixedVersion: n.fixedVersion,
      policy: n.permission
    }))
  };
}, FAe = (i) => ({
  ...i,
  result: RAe(i.result)
});
function BAe(i, e, t) {
  return Qn(
    vl(hn.SECURITY_SCAN_EXECUTION_DETAILS, {
      artifactId: i,
      appId: e,
      envId: t
    })
  ).then((n) => FAe(n));
}
const VAe = ({
  isScanned: i,
  isScanEnabled: e,
  artifactId: t,
  applicationId: n,
  environmentId: r,
  setVulnerabilityCount: s
}) => {
  const [o, a, l, c] = tf(
    () => BAe(t, n, r),
    [],
    i && e,
    {
      resetOnChange: !1
    }
  );
  return $e(() => {
    a && s(a.result.vulnerabilities?.length);
  }, [a]), i ? e ? o ? /* @__PURE__ */ v.jsx("div", { className: "security-tab-empty", children: /* @__PURE__ */ v.jsx(Yr, {}) }) : l ? /* @__PURE__ */ v.jsxs("div", { className: "security-tab-empty", children: [
    /* @__PURE__ */ v.jsx("p", { className: "security-tab-empty__title", children: "Failed to fetch vulnerabilities" }),
    /* @__PURE__ */ v.jsx("button", { className: "cta secondary", type: "button", onClick: c, children: "Reload" })
  ] }) : a.result.vulnerabilities.length === 0 ? /* @__PURE__ */ v.jsxs("div", { className: "security-tab-empty", children: [
    /* @__PURE__ */ v.jsx("p", { className: "security-tab-empty__title", children: $K.SECURED }),
    /* @__PURE__ */ v.jsx("p", { children: $K.NO_VULNERABILITY_FOUND }),
    /* @__PURE__ */ v.jsx("p", { className: "security-tab-empty__subtitle", children: a.result.lastExecution }),
    /* @__PURE__ */ v.jsx("p", { className: "pt-8 pb-8 pl-16 pr-16 flexbox dc__align-items-center", children: /* @__PURE__ */ v.jsx(JK, { scanToolId: a.result.scanToolId }) })
  ] }) : /* @__PURE__ */ v.jsxs("div", { className: "security-tab", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__content-space", children: [
      /* @__PURE__ */ v.jsxs("span", { className: "flex left security-tab__last-scanned ", children: [
        "Scanned on ",
        a.result.lastExecution,
        " "
      ] }),
      /* @__PURE__ */ v.jsx("span", { className: "flex right", children: /* @__PURE__ */ v.jsx(JK, { scanToolId: a.result.scanToolId }) })
    ] }),
    /* @__PURE__ */ v.jsx($1t, { vulnerabilities: a.result.vulnerabilities })
  ] }) : /* @__PURE__ */ v.jsx("div", { className: "security-tab-empty", children: /* @__PURE__ */ v.jsx("p", { className: "security-tab-empty__title", children: "Scan is Disabled" }) }) : /* @__PURE__ */ v.jsx("div", { className: "security-tab-empty", children: /* @__PURE__ */ v.jsx("p", { className: "security-tab-empty__title", children: "Image was not scanned" }) });
}, HAe = VAe, aY = ({ currentTab: i, activeTab: e, setActiveTab: t, buttonText: n }) => {
  const r = () => {
    t(i);
  };
  return /* @__PURE__ */ v.jsx("li", { className: "tab-list__tab", children: /* @__PURE__ */ v.jsx(
    "button",
    {
      type: "button",
      onClick: r,
      className: `dc__transparent tab-list__tab-link tab-list__tab-link--vulnerability ${i === e ? "active" : ""}`,
      children: n
    }
  ) });
}, WAe = ({
  isSecurityModuleInstalled: i,
  artifactId: e,
  applicationId: t,
  environmentId: n,
  changesCard: r,
  isScanned: s,
  isScanEnabled: o
}) => {
  const [a, l] = Oe(!1), [c, d] = Oe(B2.Changes), [u, h] = Oe(null), f = () => {
    l(!a);
  }, g = () => a ? c === B2.Changes ? r : /* @__PURE__ */ v.jsx(
    HAe,
    {
      isScanned: s,
      isScanEnabled: o,
      artifactId: e,
      applicationId: t,
      environmentId: n,
      setVulnerabilityCount: h
    }
  ) : null;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs("ul", { className: `tab-list tab-list--vulnerability ${a ? "" : "tab-bottom-radius"}`, children: [
      a && (i ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(
          aY,
          {
            currentTab: B2.Changes,
            activeTab: c,
            setActiveTab: d,
            buttonText: "Changes"
          }
        ),
        /* @__PURE__ */ v.jsx(
          aY,
          {
            currentTab: B2.Security,
            activeTab: c,
            setActiveTab: d,
            buttonText: `Security ${u ? `(${u})` : ""}`
          }
        )
      ] }) : /* @__PURE__ */ v.jsx("div", { className: "fs-13 fw-6 flex", children: "Changes" })),
      /* @__PURE__ */ v.jsx("li", { className: "flex dc__align-right", children: /* @__PURE__ */ v.jsxs(
        "button",
        {
          type: "button",
          className: "material-history__changes-btn",
          "data-testid": a ? "collapse-show-info" : "collapse-hide-info",
          onClick: f,
          children: [
            a ? "Hide info" : "Show more info",
            /* @__PURE__ */ v.jsx(
              vu,
              {
                className: "icon-dim-24 rotate",
                style: { "--rotateBy": a ? "-180deg" : "0deg" }
              }
            )
          ]
        }
      ) })
    ] }),
    g()
  ] });
}, pbt = WAe, Kde = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 16, height: 16, viewBox: "0 0 16 16", ...i }, /* @__PURE__ */ G.createElement("defs", null, /* @__PURE__ */ G.createElement("path", { id: "hrh6rt6fka", d: "M8 1.333c3.682 0 6.667 2.985 6.667 6.667S11.682 14.667 8 14.667 1.333 11.682 1.333 8 4.318 1.333 8 1.333zM3.787 4.73c-.702.903-1.12 2.038-1.12 3.27 0 2.946 2.387 5.333 5.333 5.333 1.232 0 2.367-.418 3.27-1.12zM8 2.667c-1.232 0-2.367.418-3.27 1.12l7.483 7.483c.702-.903 1.12-2.038 1.12-3.27 0-2.946-2.387-5.333-5.333-5.333z" })), /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", { transform: "translate(-120 -226) translate(64 186) translate(0 32) translate(20 6) translate(36 2)" }, /* @__PURE__ */ G.createElement("use", { fill: "#959BA1", xlinkHref: "#hrh6rt6fka" })))))))), jAe = ({ image: i }) => /* @__PURE__ */ v.jsx(wn, { className: "default-tt w-200", arrow: !1, placement: "top", content: CIe, children: /* @__PURE__ */ v.jsxs("div", { className: "flexbox pt-2 pb-2 pl-8 pr-8 br-4 bcr-1 dc__align-items-center dc__gap-4", children: [
  /* @__PURE__ */ v.jsx(Kde, { className: "icon-dim-20 fcr-5 dc__no-shrink" }),
  /* @__PURE__ */ v.jsx("p", { className: "m-0 fs-12 lh-16 fw-4 cr-5", children: i })
] }) }), mbt = jAe, lY = ({
  label: i,
  value: e,
  handleRemoveFilter: t,
  getFormattedLabel: n = El,
  getFormattedValue: r = El,
  showRemoveIcon: s,
  shouldHideLabel: o = !1
}) => {
  const a = () => {
    t(i, e);
  }, l = n(i) ?? i, c = r(i, e) ?? e;
  return (l || o) && c && /* @__PURE__ */ v.jsxs("div", { className: "flexbox flex-align-center br-4 dc__border dc__bg-n50 pl-6 pr-6 pt-2 pb-2 dc__user-select-none h-24 dc__gap-6 fs-12 lh-20 cn-9 fw-4 dc__ellipsis-right", children: [
    !o && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx("span", { className: "fw-6 dc__capitalize", children: l }),
      /* @__PURE__ */ v.jsx("span", { className: "dc__divider h-24" })
    ] }),
    /* @__PURE__ */ v.jsx("span", { className: "dc__ellipsis-right", children: c }),
    s && /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        className: "flex p-0 dc__transparent dc__hover-remove-btn",
        onClick: a,
        "aria-label": "Remove filter",
        children: /* @__PURE__ */ v.jsx(Il, { className: "icon-dim-12 icon-use-fill-n6" })
      }
    )
  ] });
}, zAe = ({
  filterConfig: i,
  clearFilters: e,
  onRemoveFilter: t,
  getFormattedLabel: n,
  getFormattedValue: r,
  className: s = "",
  clearButtonClassName: o = "",
  showClearAndRemove: a = !0,
  shouldHideLabel: l
}) => {
  const c = (u, h) => {
    const f = JSON.parse(JSON.stringify(i));
    if (Array.isArray(i[u])) {
      t({
        ...f,
        [u]: f[u].filter((g) => g !== h)
      });
      return;
    }
    u in f && (delete f[u], t(f));
  }, d = Object.entries(i).filter(([, u]) => Array.isArray(u) ? u.length : !!u);
  return d.length > 0 && /* @__PURE__ */ v.jsxs("div", { className: `flexbox pt-6 pb-6 flex-wrap dc__gap-8 ${s}`, children: [
    d.map(
      ([u, h]) => Array.isArray(h) ? h.map((f) => /* @__PURE__ */ v.jsx(
        lY,
        {
          label: u,
          value: f,
          handleRemoveFilter: c,
          getFormattedLabel: n,
          getFormattedValue: r,
          showRemoveIcon: a,
          shouldHideLabel: l
        },
        `${u}-${f}`
      )) : /* @__PURE__ */ v.jsx(
        lY,
        {
          label: u,
          value: h,
          handleRemoveFilter: c,
          getFormattedLabel: n,
          getFormattedValue: r,
          showRemoveIcon: a,
          shouldHideLabel: l
        },
        u
      )
    ),
    a && /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        className: `cta text fs-13-imp lh-20-imp h-20 p-0-imp ${o}`,
        onClick: e,
        children: "Clear All Filters"
      }
    ) })
  ] });
}, UAe = zAe, GAe = ({
  rootClassName: i = "",
  backgroundColorClass: e = "bcr-5",
  iconSizeClass: t = "icon-dim-6"
}) => /* @__PURE__ */ v.jsx("div", { className: `dc__border-radius-50-per ${e} ${t} ${i}` }), vbt = GAe, Wk = {
  ADD_BUTTON_TEXT: "Add parameter",
  DEFAULT_KEY_PLACEHOLDER: "Enter key",
  DEFAULT_VALUE_PLACEHOLDER: "Enter value"
};
var bC = /* @__PURE__ */ ((i) => (i.ADD = "ADD_KEY_VALUE", i.DELETE = "DELETE_KEY_VALUE", i.UPDATE_KEY = "UPDATE", i.UPDATE_VALUE = "UPDATE_VALUE", i))(bC || {});
const qAe = ({
  itemKey: i,
  itemValue: e,
  handleKeyValueChange: t,
  isDisabled: n,
  keyPlaceholder: r,
  valuePlaceholder: s,
  index: o,
  itemClassName: a
}) => {
  const l = (u) => {
    const h = {
      index: o,
      value: u.target.value
    };
    t({ action: bC.UPDATE_KEY, data: h });
  }, c = (u) => {
    const h = {
      index: o,
      value: u.target.value
    };
    t({ action: bC.UPDATE_VALUE, data: h });
  }, d = (u) => {
    u.stopPropagation();
    const h = {
      index: o
    };
    t({ action: bC.DELETE, data: h });
  };
  return /* @__PURE__ */ v.jsxs("div", { className: `flexbox justify-space ${a || ""}`, children: [
    /* @__PURE__ */ v.jsxs("div", { className: "pt-8 w-100", children: [
      /* @__PURE__ */ v.jsx(
        Ck,
        {
          name: "item-key",
          rootClassName: `w-100 dc__top-radius-4 pl-10 pr-10 pt-6 pb-6 en-2 bw-1 ${n ? "cursor-not-allowed" : ""}`,
          autoComplete: "off",
          placeholder: r,
          type: "text",
          value: i,
          disabled: n,
          onChange: l
        }
      ),
      /* @__PURE__ */ v.jsx(
        "textarea",
        {
          className: `w-100 dc__bottom-radius-4 dc__no-top-border pl-10 pr-10 pt-6 pb-6 en-2 bw-1 mxh-140 form__textarea ${n ? "cursor-not-allowed bcn-1" : "build__value"}`,
          value: e,
          placeholder: s,
          onChange: c,
          disabled: n
        }
      )
    ] }),
    !n && /* @__PURE__ */ v.jsx(
      "button",
      {
        className: "dc__no-background flexbox dc__align-start dc__no-border dc__outline-none-imp dc__tab-focus",
        onClick: d,
        type: "button",
        "aria-label": "remove-docker-args",
        children: /* @__PURE__ */ v.jsx(Il, { className: "icon-dim-24 mt-6 ml-6" })
      }
    )
  ] });
}, KAe = ({
  keyValueList: i,
  handleKeyValueChange: e,
  isDisabled: t,
  disabledInfo: n,
  itemClassName: r,
  addButtonText: s = Wk.ADD_BUTTON_TEXT,
  keyPlaceholder: o = Wk.DEFAULT_KEY_PLACEHOLDER,
  valuePlaceholder: a = Wk.DEFAULT_VALUE_PLACEHOLDER
}) => {
  const l = () => {
    e({ action: bC.ADD });
  }, c = (d) => /* @__PURE__ */ v.jsx(wn, { content: n, children: d });
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(lc, { condition: t, wrap: c, children: /* @__PURE__ */ v.jsxs(
      "button",
      {
        className: "p-0 cb-5 fw-6 fs-13 flex content-fit lh-32 dc__no-background dc__no-border dc__outline-none-imp dc__tab-focus",
        onClick: l,
        type: "button",
        children: [
          /* @__PURE__ */ v.jsx("span", { className: "fa fa-plus mr-8" }),
          s
        ]
      }
    ) }),
    i.length > 0 && i.map((d, u) => /* @__PURE__ */ v.jsx(
      qAe,
      {
        itemKey: d.key,
        itemValue: d.value,
        handleKeyValueChange: e,
        isDisabled: t,
        keyPlaceholder: o,
        valuePlaceholder: a,
        index: u,
        itemClassName: r
      },
      u
    ))
  ] });
}, _bt = KAe, ab = (i) => /* @__PURE__ */ G.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M19.2803 5.78033C19.5732 5.48744 19.5732 5.01256 19.2803 4.71967C18.9874 4.42678 18.5126 4.42678 18.2197 4.71967L19.2803 5.78033ZM4.71967 18.2197C4.42678 18.5126 4.42678 18.9874 4.71967 19.2803C5.01256 19.5732 5.48744 19.5732 5.78033 19.2803L4.71967 18.2197ZM18.2197 19.2803C18.5126 19.5732 18.9874 19.5732 19.2803 19.2803C19.5732 18.9874 19.5732 18.5126 19.2803 18.2197L18.2197 19.2803ZM5.78033 4.71967C5.48744 4.42678 5.01256 4.42678 4.71967 4.71967C4.42678 5.01256 4.42678 5.48744 4.71967 5.78033L5.78033 4.71967ZM18.2197 4.71967L11.4697 11.4697L12.5303 12.5303L19.2803 5.78033L18.2197 4.71967ZM11.4697 11.4697L4.71967 18.2197L5.78033 19.2803L12.5303 12.5303L11.4697 11.4697ZM19.2803 18.2197L12.5303 11.4697L11.4697 12.5303L18.2197 19.2803L19.2803 18.2197ZM12.5303 11.4697L5.78033 4.71967L4.71967 5.78033L11.4697 12.5303L12.5303 11.4697Z", fill: "#596168" })), YAe = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.2803%205.78033C19.5732%205.48744%2019.5732%205.01256%2019.2803%204.71967C18.9874%204.42678%2018.5126%204.42678%2018.2197%204.71967L19.2803%205.78033ZM4.71967%2018.2197C4.42678%2018.5126%204.42678%2018.9874%204.71967%2019.2803C5.01256%2019.5732%205.48744%2019.5732%205.78033%2019.2803L4.71967%2018.2197ZM18.2197%2019.2803C18.5126%2019.5732%2018.9874%2019.5732%2019.2803%2019.2803C19.5732%2018.9874%2019.5732%2018.5126%2019.2803%2018.2197L18.2197%2019.2803ZM5.78033%204.71967C5.48744%204.42678%205.01256%204.42678%204.71967%204.71967C4.42678%205.01256%204.42678%205.48744%204.71967%205.78033L5.78033%204.71967ZM18.2197%204.71967L11.4697%2011.4697L12.5303%2012.5303L19.2803%205.78033L18.2197%204.71967ZM11.4697%2011.4697L4.71967%2018.2197L5.78033%2019.2803L12.5303%2012.5303L11.4697%2011.4697ZM19.2803%2018.2197L12.5303%2011.4697L11.4697%2012.5303L18.2197%2019.2803L19.2803%2018.2197ZM12.5303%2011.4697L5.78033%204.71967L4.71967%205.78033L11.4697%2012.5303L12.5303%2011.4697Z'%20fill='%23596168'/%3e%3c/svg%3e", PA = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#767D84", fillRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-.205 12.868c-.615 0-1.12.505-1.12 1.12 0 .617.505 1.121 1.12 1.121.615 0 1.12-.504 1.12-1.12 0-.616-.506-1.12-1.12-1.12zM11.863 7c-1.667 0-3.197 1.187-3.196 2.527 0 .546.41.833.888.833 1.325 0 .642-1.803 2.39-1.803.82 0 1.311.438 1.311 1.175 0 1.34-2.39 1.708-2.39 3.334 0 .438.287.915.874.915.902 0 .792-.67 1.12-1.148.438-.642 2.473-1.325 2.473-3.101 0-1.927-1.721-2.732-3.47-2.732z" })), lb = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#1D2730", fillRule: "evenodd", d: "M9 1.333c3.682 0 6.667 2.985 6.667 6.667S12.682 14.667 9 14.667 2.333 11.682 2.333 8 5.318 1.333 9 1.333zm0 1.334C6.054 2.667 3.667 5.054 3.667 8S6.054 13.333 9 13.333 14.333 10.946 14.333 8 11.946 2.667 9 2.667zm-.137 7.245c.41 0 .747.337.747.747s-.337.747-.747.747-.747-.336-.747-.747c0-.41.338-.747.747-.747zm.046-5.245c1.166 0 2.313.537 2.313 1.82 0 1.185-1.357 1.64-1.648 2.068-.22.319-.146.766-.747.766-.392 0-.583-.319-.583-.61 0-1.085 1.593-1.33 1.593-2.223 0-.492-.327-.783-.873-.783-1.166 0-.711 1.202-1.594 1.202-.319 0-.592-.191-.592-.556 0-.893 1.02-1.684 2.13-1.684z" })), XAe = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M13.5 6.25L13.4995 2.5005L9.75 2.5M8.99821 7.00179L13.4982 2.50179M11.5 9V13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V5C2.5 4.86739 2.55268 4.74021 2.64645 4.64645C2.74021 4.55268 2.86739 4.5 3 4.5H7", stroke: "#0066CC", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Yde = (i) => {
  const e = Nt(null), [t, n] = Oe(!1), r = i.theme === uA.white, s = (w) => {
    e.current = w, document.addEventListener("keydown", a);
  }, o = (w) => {
    Cr(w), e.current?.hide && (e.current.hide(), e.current = null, i.onClose && i.onClose()), n(!1);
  }, a = (w) => {
    w.keyCode === 27 && o(w);
  }, l = (w) => {
    n(oCe);
  }, c = () => {
    const {
      Icon: w,
      iconPath: y,
      iconClass: S,
      iconSize: x,
      onImageLoadError: D,
      heading: E,
      headingInfo: L,
      infoTextHeading: k,
      hideHeading: N,
      infoText: I,
      showCloseButton: A,
      additionalContent: P,
      documentationLink: O,
      documentationLinkText: K
    } = i;
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      !N && /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: `dc__word-break dc__hyphens-auto flex dc__align-start left ${r ? `p-12 cn-9 ${i.noHeadingBorder ? "" : "dc__border-bottom-n1"}` : "pt-20 pb-12 pr-20 pl-20 cn-0 top"}`,
          children: [
            y ? /* @__PURE__ */ v.jsx(
              "img",
              {
                className: `icon-dim-${x || 20} mr-6 ${S || ""}`,
                src: y,
                alt: "Heading",
                onError: D
              }
            ) : w && /* @__PURE__ */ v.jsx("div", { className: `icon-dim-${x || 20} mr-6`, children: /* @__PURE__ */ v.jsx(w, { className: `icon-dim-${x || 20} ${S || ""}` }) }),
            E && /* @__PURE__ */ v.jsx("span", { className: `fs-14 fw-6 lh-20 ${A ? "mr-12" : ""}`, children: E }),
            L && /* @__PURE__ */ v.jsx("div", { className: "icon-dim-20 cursor", onClick: l, children: /* @__PURE__ */ v.jsx(lb, { className: "icon-dim-20" }) }),
            A && /* @__PURE__ */ v.jsx("div", { className: "icon-dim-16 ml-auto", children: /* @__PURE__ */ v.jsx(
              ab,
              {
                className: `icon-dim-16 cursor ${r ? "fcn-9" : "fcn-0"}`,
                onClick: o
              }
            ) })
          ]
        }
      ),
      t && /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: `flex left top bcv-1 fs-13 fw-4 lh-20 pt-8 pb-8 ${r ? "pl-12 pr-12" : "pl-20 pr-20"}`,
          children: [
            /* @__PURE__ */ v.jsx("div", { className: "icon-dim-20 mr-8", children: /* @__PURE__ */ v.jsx(PA, { className: "icon-dim-20 fcv-5" }) }),
            /* @__PURE__ */ v.jsx("div", { className: "dc__word-break dc__hyphens-auto", children: L })
          ]
        }
      ),
      k && /* @__PURE__ */ v.jsx(
        "div",
        {
          className: `dc__word-break dc__hyphens-auto fs-14 fw-6 lh-20 ${r ? "pl-12 pr-12" : "pl-20 pr-20"}`,
          children: k
        }
      ),
      I && /* @__PURE__ */ v.jsx(
        "div",
        {
          className: `dc__word-break dc__hyphens-auto fs-13 fw-4 lh-20 ${r ? "p-12" : `pl-20 pr-20 pt-4 ${P && O ? "pb-12" : "pb-20"}`}`,
          children: I
        }
      ),
      P,
      O && /* @__PURE__ */ v.jsx("div", { className: "pl-12 pb-12", children: /* @__PURE__ */ v.jsxs(
        "a",
        {
          href: O,
          target: "_blank",
          rel: "noreferrer noopener",
          className: "fs-13 cb-5 flex left",
          onClick: o,
          children: [
            K || "Learn more",
            /* @__PURE__ */ v.jsx(XAe, { className: "icon-dim-14 ml-4" })
          ]
        }
      ) })
    ] });
  }, { className: d, placement: u, arrow: h, interactive: f, showOnCreate: g, trigger: p, animation: m, duration: _, children: b } = i;
  return /* @__PURE__ */ v.jsx(
    wn,
    {
      className: `${r ? "tippy-white-container default-white" : "tippy-black-container default-black"} no-content-padding tippy-shadow ${d}`,
      arrow: h || !1,
      interactive: f || !1,
      placement: u || "top",
      content: c(),
      trigger: p || "mouseenter",
      onMount: s,
      onClickOutside: (w, y) => o(y),
      showOnCreate: g || !1,
      animation: m || "fade",
      duration: _ || 300,
      visible: i.visible,
      children: b
    }
  );
}, ZAe = ({
  heading: i,
  infoText: e,
  iconClass: t = "fcv-5",
  documentationLink: n,
  documentationLinkText: r,
  additionalContent: s,
  iconClassName: o = "icon-dim-16",
  placement: a = "bottom",
  dataTestid: l = "info-tippy-button",
  children: c
}) => /* @__PURE__ */ v.jsx(
  Yde,
  {
    theme: uA.white,
    className: "w-300 h-100 dc__no-text-transform",
    placement: a,
    Icon: PA,
    heading: i,
    infoText: e,
    iconClass: t,
    showCloseButton: !0,
    trigger: "click",
    interactive: !0,
    documentationLink: n,
    documentationLinkText: r,
    additionalContent: s,
    children: c || /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        className: "p-0 dc__no-background dc__no-border dc__outline-none-imp flex dc__tab-focus",
        "aria-label": "Info Icon",
        "data-testid": l,
        children: /* @__PURE__ */ v.jsx(lb, { className: o })
      }
    )
  }
), OA = ZAe, MA = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M10.625 4.99991L15 9.37491M7.5 16.8749H3.75C3.58424 16.8749 3.42527 16.8091 3.30806 16.6918C3.19085 16.5746 3.125 16.4157 3.125 16.2499V12.7588C3.125 12.6767 3.14117 12.5954 3.17258 12.5196C3.20398 12.4438 3.25002 12.3749 3.30806 12.3168L12.6831 2.94185C12.8003 2.82464 12.9592 2.75879 13.125 2.75879C13.2908 2.75879 13.4497 2.82464 13.5669 2.94185L17.0581 6.43296C17.1753 6.55017 17.2411 6.70915 17.2411 6.87491C17.2411 7.04067 17.1753 7.19964 17.0581 7.31685L7.5 16.8749Z", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
class RA extends nS {
  constructor(e) {
    super(e), this.clickHandler = this.clickHandler.bind(this);
  }
  clickHandler(e) {
    !this.props.isLoading && this.props.onClick && this.props.onClick(e);
  }
  render() {
    return /* @__PURE__ */ v.jsx(
      "button",
      {
        type: this.props.type ?? "button",
        "data-testid": this.props.dataTestId,
        disabled: !!this.props.disabled,
        className: `${this.props.rootClassName}`,
        onClick: this.clickHandler,
        children: this.props.isLoading ? /* @__PURE__ */ v.jsx(Yr, {}) : this.props.children
      }
    );
  }
}
const QAe = (i) => {
  const { rows: e, placeholder: t, initialText: n, setIsEditable: r, updateContent: s, validations: o } = i, [a, l] = Oe(n), [c, d] = Oe(!1), [u, h] = Oe({ isValid: !0, message: "" }), f = () => {
    l(n), r(!1);
  }, g = () => {
    d(!0), s(a.trim()).then(() => {
      r(!1), d(!1);
    }).catch(() => {
      d(!1);
    });
  }, p = (_) => {
    if (o) {
      const b = _.trim(), { maxLength: w } = o;
      if (w && b.length > w.value)
        return {
          isValid: !1,
          message: w.message
        };
    }
    return {
      isValid: !0,
      message: ""
    };
  }, m = (_) => {
    const b = _.target.value ?? "";
    l(b), h(p(b));
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col flex-grow-1 dc__gap-12", children: [
    /* @__PURE__ */ v.jsxs("div", { children: [
      /* @__PURE__ */ v.jsx(
        "textarea",
        {
          rows: e,
          placeholder: t,
          value: a,
          className: "form__textarea bcn-0 fs-13 lh-20 cn-9 dc__resizable-textarea--vertical",
          onChange: m
        }
      ),
      !u.isValid && /* @__PURE__ */ v.jsxs("span", { className: "form__error", children: [
        /* @__PURE__ */ v.jsx(rc, { className: "form__icon form__icon--error" }),
        u.message,
        " ",
        /* @__PURE__ */ v.jsx("br", {})
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex dc__gap-12 ml-auto", children: [
      /* @__PURE__ */ v.jsx(
        "button",
        {
          type: "button",
          className: "cta cancel lh-20-imp h-28",
          disabled: c,
          onClick: f,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ v.jsx(
        RA,
        {
          rootClassName: "cta lh-20-imp h-28",
          onClick: g,
          disabled: !u.isValid,
          isLoading: c,
          children: "Save"
        }
      )
    ] })
  ] });
}, JAe = (i) => {
  const { initialText: e = "", emptyState: t, ...n } = i, [r, s] = Oe(!1);
  return r ? /* @__PURE__ */ v.jsx(QAe, { ...n, initialText: e, setIsEditable: s }) : /* @__PURE__ */ v.jsxs("div", { className: "flexbox flex-justify dc__gap-10", children: [
    /* @__PURE__ */ v.jsx("div", { className: "fs-13 fw-4 lh-20 cn-9 dc__word-break", children: e || t }),
    /* @__PURE__ */ v.jsx(MA, { className: "icon-dim-16 cursor mw-16", onClick: () => s(!r) })
  ] });
}, bbt = JAe, $Ae = ({ className: i, userFirstLetter: e, setShowLogOutCard: t, showLogOutCard: n }) => {
  const r = ip(), s = () => {
    document.cookie = "argocd.token=; expires=Thu, 01-Jan-1970 00:00:01 GMT;path=/", r.push("/login");
  };
  return /* @__PURE__ */ v.jsx("div", { className: "dc__transparent-div", onClick: () => t(!n), children: /* @__PURE__ */ v.jsxs("div", { className: `logout-card ${i}`, children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox flex-justify p-16", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "logout-card-user ", children: [
        /* @__PURE__ */ v.jsx("p", { className: "logout-card__name dc__ellipsis-right", children: e }),
        /* @__PURE__ */ v.jsx("p", { className: "logout-card__email dc__ellipsis-right", children: e })
      ] }),
      /* @__PURE__ */ v.jsx(
        "p",
        {
          className: "logout-card__initial fs-16 icon-dim-32 mb-0",
          style: { backgroundColor: vx(e) },
          children: e[0]
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: "logout-card__logout cursor", "data-testid": "logout-button", onClick: s, children: "Logout" })
  ] }) });
}, e4e = (i) => fA(hn.TELEMETRY_EVENT, i);
let cY;
const t4e = async (i, e) => {
  const t = await Qn(`${hn.SERVER_INFO_API}?showServerStatus=false`);
  return cY = t, typeof Storage < "u" && (localStorage.serverInfo = JSON.stringify(cY)), Promise.resolve(t);
}, n4e = 864e5, H2 = (i) => 1 + (/* @__PURE__ */ new Date()).valueOf() + (i ?? 0) * n4e, X8 = async (i, e) => {
  const t = {
    eventType: e || i.target?.dataset.posthog,
    key: Mle,
    value: "",
    active: !0
  };
  await e4e(t);
}, OE = (i, e) => {
  localStorage.setItem(i, `${H2(e)}`);
};
var ME = /* @__PURE__ */ ((i) => (i.OSS_KUBECTL = "oss_kubectl", i.OSS_HELM = "oss_helm", i.ENTERPRISE = "enterprise", i))(ME || {});
const i4e = "data:image/png;base64,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", r4e = (i) => fA(`${hn.ATTRIBUTES_USER}/${hn.UPDATE}`, i), s4e = ({ className: i, hideGettingStartedCard: e }) => {
  const t = async (r) => {
    OE("clickedOkay", 1), e(), await X8(r);
  }, n = async (r) => {
    const s = {
      key: Mle,
      value: `${Ole}`
    };
    await r4e(s), e(s.value), await X8(r);
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "getting_tippy__position", children: [
    /* @__PURE__ */ v.jsx("div", { className: "arrow-up" }),
    /* @__PURE__ */ v.jsxs("div", { className: `getting-started-card cn-0 p-20 br-8 fs-13 ${i}`, children: [
      /* @__PURE__ */ v.jsx("img", { className: "mb-12 icon-dim-32", src: i4e, alt: "getting started icon" }),
      /* @__PURE__ */ v.jsx("div", { className: "flex column left fw-6", children: "Getting started" }),
      /* @__PURE__ */ v.jsx("div", { children: "You can always access the Getting Started guide from here." }),
      /* @__PURE__ */ v.jsxs("div", { className: "mt-12 lh-18", children: [
        /* @__PURE__ */ v.jsx(
          "button",
          {
            onClick: t,
            type: "button",
            className: "bw-0 cn-9 fw-6 br-4 mr-12 pt-4 pb-4 pl-8 pr-8 pl-8 pr-8",
            "data-posthog": l8.TOOLTIP_OKAY,
            children: "Okay"
          }
        ),
        /* @__PURE__ */ v.jsx(
          "button",
          {
            className: "br-4 token__dont-show en-0 bw-1 dc__transparent pl-8 pr-8 pt-3 pb-3",
            type: "button",
            "data-posthog": l8.TOOLTIP_DONT_SHOW_AGAIN,
            onClick: n,
            children: "Don't show again"
          }
        )
      ] })
    ] })
  ] });
}, Xde = (i) => /* @__PURE__ */ G.createElement("svg", { width: 19, height: 20, viewBox: "0 0 19 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M3.54912 13.828C2.6173 12.2572 2.29097 10.4002 2.6314 8.60583C2.97184 6.81142 3.95563 5.20301 5.39803 4.08261C6.84044 2.96222 8.64224 2.40692 10.4651 2.52099C12.2879 2.63506 14.0065 3.41065 15.2979 4.70212C16.5894 5.99359 17.365 7.71211 17.4791 9.53496C17.5932 11.3578 17.0379 13.1596 15.9175 14.602C14.7971 16.0444 13.1887 17.0282 11.3943 17.3687C9.59988 17.7091 7.74291 17.3828 6.17207 16.451L6.17209 16.4509L3.58173 17.191C3.47456 17.2216 3.36115 17.223 3.25325 17.1951C3.14536 17.1671 3.0469 17.1108 2.96809 17.032C2.88927 16.9532 2.83297 16.8547 2.80501 16.7468C2.77705 16.6389 2.77846 16.5255 2.80908 16.4184L3.54918 13.828L3.54912 13.828Z", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M10 10.9375C10.5178 10.9375 10.9375 10.5178 10.9375 10C10.9375 9.48223 10.5178 9.0625 10 9.0625C9.48223 9.0625 9.0625 9.48223 9.0625 10C9.0625 10.5178 9.48223 10.9375 10 10.9375Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M6.25 10.9375C6.76777 10.9375 7.1875 10.5178 7.1875 10C7.1875 9.48223 6.76777 9.0625 6.25 9.0625C5.73223 9.0625 5.3125 9.48223 5.3125 10C5.3125 10.5178 5.73223 10.9375 6.25 10.9375Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M13.75 10.9375C14.2678 10.9375 14.6875 10.5178 14.6875 10C14.6875 9.48223 14.2678 9.0625 13.75 9.0625C13.2322 9.0625 12.8125 9.48223 12.8125 10C12.8125 10.5178 13.2322 10.9375 13.75 10.9375Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("circle", { cx: 16, cy: 16, r: 5, fill: "#29CC7A", stroke: "white", strokeWidth: 2 })), bj = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20.5, height: 20, viewBox: "0 0 20.5 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M12.7507 3H3.75C3.55109 3 3.36032 3.07902 3.21967 3.21967C3.07902 3.36032 3 3.55109 3 3.75V20.25C3 20.4489 3.07902 20.6397 3.21967 20.7803C3.36032 20.921 3.55109 21 3.75 21H8.50037M12.7507 3L18.0007 8.25M12.7507 3V8.25H18.0007M18.0007 8.25V11.25", stroke: "#3B444C", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M15.7818 15.4289L18.5711 18.2182M13.7894 23H11.3985C11.2928 23 11.1914 22.958 11.1167 22.8833C11.042 22.8086 11 22.7072 11 22.6015V20.3757C11 20.3234 11.0103 20.2715 11.0303 20.2232C11.0504 20.1749 11.0797 20.1309 11.1167 20.0939L17.0939 14.1167C17.1687 14.042 17.27 14 17.3757 14C17.4814 14 17.5827 14.042 17.6575 14.1167L19.8833 16.3425C19.958 16.4173 20 16.5186 20 16.6243C20 16.73 19.958 16.8313 19.8833 16.9061L13.7894 23Z", stroke: "#3B444C", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), o4e = (i) => /* @__PURE__ */ G.createElement("svg", { width: 19.5, height: 18, viewBox: "0 0 19.5 18", style: {
  marginLeft: 2,
  height: 24
}, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M10.8573 3.53223H4.32641C4.18208 3.53223 4.04366 3.58956 3.9416 3.69162C3.83955 3.79367 3.78221 3.93209 3.78221 4.07642V16.0487C3.78221 16.1931 3.83955 16.3315 3.9416 16.4335C4.04366 16.5356 4.18208 16.5929 4.32641 16.5929H14.1225C14.1939 16.5929 14.2647 16.5789 14.3307 16.5515C14.3967 16.5242 14.4567 16.4841 14.5073 16.4335C14.5578 16.383 14.5979 16.323 14.6252 16.257C14.6526 16.191 14.6667 16.1202 14.6667 16.0487V7.3416M10.8573 3.53223L14.6667 7.3416M10.8573 3.53223V7.3416H14.6667M7.04792 10.6068H11.4015M7.04792 12.7836H11.4015M12.2178 4.89272L8.40841 1.08334H1.87752C1.73319 1.08334 1.59478 1.14068 1.49272 1.24273C1.39066 1.34479 1.33333 1.48321 1.33333 1.62754V13.5999C1.33333 13.7442 1.39066 13.8826 1.49272 13.9847C1.59478 14.0867 1.73319 14.1441 1.87752 14.1441H3.78221", stroke: "#3B444C", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), a4e = "https://enterprise.devtron.ai/portal/en/newticket", l4e = "https://enterprise.devtron.ai/portal/en/myarea", c4e = "https://github.com/devtron-labs/devtron/issues/new/choose", d4e = [
  {
    name: "Open new ticket",
    link: a4e,
    icon: bj
  },
  {
    name: "View all tickets",
    link: l4e,
    icon: o4e
  }
], u4e = [
  {
    name: "Chat with support",
    link: TW,
    icon: Xde,
    showSeparator: !0
  },
  {
    name: "Raise an issue/request",
    link: c4e,
    icon: bj
  }
], h4e = (i) => /* @__PURE__ */ G.createElement("svg", { width: 18, height: 16, viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M12.75 12.625C12.75 13.6605 13.5895 14.5 14.625 14.5C15.6605 14.5 16.5 13.6605 16.5 12.625C16.5 11.5895 15.6605 10.75 14.625 10.75C13.5895 10.75 12.75 11.5895 12.75 12.625ZM12.75 12.625H4.625C3.7962 12.625 3.00134 12.2958 2.41529 11.7097C1.82924 11.1237 1.5 10.3288 1.5 9.5C1.5 8.6712 1.82924 7.87634 2.41529 7.29029C3.00134 6.70424 3.7962 6.375 4.625 6.375H12.125C12.788 6.375 13.4239 6.11161 13.8928 5.64277C14.3616 5.17393 14.625 4.53804 14.625 3.875C14.625 3.21196 14.3616 2.57607 13.8928 2.10723C13.4239 1.63839 12.788 1.375 12.125 1.375H4.625", stroke: "#000A14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), f4e = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M8.125 6.25001V15.9155C8.125 16.0184 8.0996 16.1197 8.05105 16.2104C8.0025 16.3011 7.9323 16.3785 7.84669 16.4355L6.98793 17.0081C6.90459 17.0636 6.80913 17.0983 6.70957 17.1093C6.61001 17.1202 6.50928 17.1071 6.41587 17.071C6.32245 17.0349 6.23908 16.9768 6.17278 16.9018C6.10648 16.8267 6.05919 16.7368 6.0349 16.6396L5 12.5M8.125 6.25001H5C4.1712 6.25001 3.37634 6.57925 2.79029 7.1653C2.20424 7.75135 1.875 8.54621 1.875 9.37501C1.875 10.2038 2.20424 10.9987 2.79029 11.5847C3.37634 12.1708 4.1712 12.5 5 12.5M8.125 6.25001C8.125 6.25001 12.379 6.25001 16.4727 2.8166C16.5638 2.73997 16.6748 2.69093 16.7928 2.67525C16.9107 2.65957 17.0307 2.6779 17.1386 2.72808C17.2465 2.77826 17.3379 2.85821 17.4019 2.95853C17.4659 3.05884 17.4999 3.17535 17.5 3.29435V15.4557C17.4999 15.5747 17.4659 15.6912 17.4019 15.7915C17.3379 15.8918 17.2465 15.9718 17.1386 16.0219C17.0307 16.0721 16.9107 16.0904 16.7928 16.0748C16.6748 16.0591 16.5638 16.01 16.4727 15.9334C12.379 12.5 8.125 12.5 8.125 12.5L5 12.5", stroke: "#3B444C", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), g4e = (i) => /* @__PURE__ */ G.createElement("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M15.1981 5.11426C14.2421 4.67559 13.2169 4.35239 12.1449 4.16728C12.1254 4.16371 12.1059 4.17264 12.0959 4.19049C11.964 4.425 11.818 4.73094 11.7157 4.9714C10.5628 4.7988 9.41574 4.7988 8.28645 4.9714C8.18415 4.72559 8.0328 4.425 7.90036 4.19049C7.8903 4.17323 7.8708 4.1643 7.85128 4.16728C6.77994 4.3518 5.75473 4.67499 4.79808 5.11426C4.7898 5.11783 4.7827 5.12379 4.77799 5.13152C2.83337 8.03675 2.30066 10.8706 2.56199 13.6693C2.56317 13.6829 2.57086 13.696 2.5815 13.7044C3.86451 14.6466 5.10732 15.2186 6.32705 15.5977C6.34657 15.6037 6.36725 15.5965 6.37968 15.5805C6.6682 15.1864 6.9254 14.771 7.14592 14.3341C7.15894 14.3085 7.14651 14.2781 7.11992 14.268C6.71196 14.1133 6.3235 13.9246 5.94983 13.7103C5.92027 13.6931 5.91791 13.6508 5.9451 13.6305C6.02373 13.5716 6.10239 13.5103 6.17747 13.4484C6.19106 13.4371 6.20999 13.4347 6.22596 13.4419C8.6808 14.5627 11.3385 14.5627 13.7643 13.4419C13.7803 13.4341 13.7992 13.4365 13.8134 13.4478C13.8885 13.5097 13.9672 13.5716 14.0464 13.6305C14.0736 13.6508 14.0718 13.6931 14.0422 13.7103C13.6686 13.9288 13.2801 14.1133 12.8716 14.2674C12.845 14.2776 12.8331 14.3085 12.8462 14.3341C13.0714 14.7704 13.3286 15.1858 13.6118 15.5799C13.6236 15.5965 13.6449 15.6037 13.6644 15.5977C14.8901 15.2186 16.1329 14.6466 17.4159 13.7044C17.4271 13.696 17.4342 13.6835 17.4354 13.6698C17.7482 10.4343 16.9116 7.62368 15.2176 5.13211C15.2135 5.12379 15.2064 5.11783 15.1981 5.11426ZM7.51251 11.9651C6.77344 11.9651 6.16446 11.2866 6.16446 10.4533C6.16446 9.62001 6.76163 8.94148 7.51251 8.94148C8.2693 8.94148 8.87238 9.62597 8.86055 10.4533C8.86055 11.2866 8.26338 11.9651 7.51251 11.9651ZM12.4967 11.9651C11.7577 11.9651 11.1487 11.2866 11.1487 10.4533C11.1487 9.62001 11.7458 8.94148 12.4967 8.94148C13.2535 8.94148 13.8566 9.62597 13.8448 10.4533C13.8448 11.2866 13.2535 11.9651 12.4967 11.9651Z", fill: "#596168" })), p4e = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M11.875 2.5H4.37439C4.20863 2.5 4.04966 2.56585 3.93245 2.68306C3.81524 2.80027 3.74939 2.95924 3.74939 3.125V16.875C3.74939 17.0408 3.81524 17.1997 3.93245 17.3169C4.04966 17.4342 4.20863 17.5 4.37439 17.5H15.625C15.7071 17.5 15.7883 17.4838 15.8642 17.4524C15.94 17.421 16.0089 17.375 16.0669 17.3169C16.125 17.2589 16.171 17.19 16.2024 17.1142C16.2338 17.0384 16.25 16.9571 16.25 16.875V6.875M11.875 2.5L16.25 6.875M11.875 2.5V6.875H16.25M7.5 10.625H12.5M7.5 13.125H12.5", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Zde = nf(null), Cj = () => {
  const i = x0(Zde);
  if (!i)
    throw new Error("Please wrap with MainContextProvider");
  return i;
}, Cbt = ({ children: i, value: e }) => /* @__PURE__ */ v.jsx(Zde.Provider, { value: e, children: i }), Qde = nf(null), ybt = () => {
  const i = x0(Qde);
  if (!i)
    throw new Error("useImageSelectionUtilityContext must be used within ImageSelectionUtilityProvider");
  return i;
}, wbt = ({ children: i, value: e }) => {
  const t = Mn(() => e, [e]);
  return /* @__PURE__ */ v.jsx(Qde.Provider, { value: t, children: i });
}, Jde = nf(null), $de = () => x0(Jde), Sbt = ({ children: i }) => {
  const [e, t] = Oe(""), n = Mn(
    () => ({
      email: e,
      setEmail: t
    }),
    [e]
  );
  return /* @__PURE__ */ v.jsx(Jde.Provider, { value: n, children: i });
}, xbt = (i) => (e) => {
  const { email: t, setEmail: n } = $de();
  return /* @__PURE__ */ v.jsx(i, { ...e, email: t, setEmail: n });
}, m4e = ({
  className: i,
  setShowHelpCard: e,
  serverInfo: t,
  fetchingServerInfo: n,
  setGettingStartedClicked: r,
  showHelpCard: s
}) => {
  const { currentServerInfo: o } = Cj(), a = o?.serverInfo?.installationType === ME.ENTERPRISE, l = `UheGN3KJ#source=${window.location.hostname}`, c = [
    {
      name: "View documentation",
      link: F2,
      icon: p4e,
      showSeparator: !0
    },
    {
      name: "Join discord community",
      link: TW,
      icon: g4e,
      showSeparator: a
    },
    ...a ? d4e : u4e
  ], d = () => {
    r(!0);
  }, u = (m) => {
    cA.event({
      category: "Help Nav",
      action: `${m.name} Clicked`
    });
  }, h = () => {
    e(!s);
  }, f = () => /* @__PURE__ */ v.jsxs("div", { onClick: Cr, className: "help-card__option help-card__link flex left cn-9", children: [
    /* @__PURE__ */ v.jsx(f4e, {}),
    /* @__PURE__ */ v.jsx(
      KCe,
      {
        className: "dc__transparent help-card__option-name ml-12 cn-9 fs-14",
        id: l,
        onClose: h,
        autoClose: 2e3,
        children: "Give feedback"
      }
    )
  ] }), g = (m) => {
    const _ = c[m.currentTarget.dataset.index];
    u(_);
  }, p = () => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    " ",
    c.map((m, _) => /* @__PURE__ */ v.jsxs(qh, { children: [
      /* @__PURE__ */ v.jsxs(
        "a",
        {
          className: "dc__no-decor help-card__option help-card__link flex left cn-9",
          href: m.link,
          target: "_blank",
          rel: "noreferrer noopener",
          "data-index": _,
          onClick: g,
          children: [
            /* @__PURE__ */ v.jsx(m.icon, {}),
            /* @__PURE__ */ v.jsx("div", { className: "help-card__option-name ml-12 cn-9 fs-14", children: m.name })
          ]
        },
        m.name
      ),
      a && _ === 1 && /* @__PURE__ */ v.jsx("div", { className: "help__enterprise pl-8 pb-4-imp pt-4-imp dc__gap-12 flexbox dc__align-items-center h-28", children: "Enterprise Support" })
    ] }, m.name))
  ] });
  return /* @__PURE__ */ v.jsx("div", { className: "dc__transparent-div", onClick: h, children: /* @__PURE__ */ v.jsxs("div", { className: `help-card pt-4 pb-4 ${i} ${a ? "help-grid__feedback" : ""}`, children: [
    !window._env_.K8S_CLIENT && /* @__PURE__ */ v.jsxs(
      uo,
      {
        to: `/${sr.GETTING_STARTED}`,
        className: "help-card__option dc__no-decor help-card__link flex left cn-9",
        activeClassName: "active",
        onClick: d,
        children: [
          /* @__PURE__ */ v.jsx(h4e, {}),
          /* @__PURE__ */ v.jsx("div", { className: "help-card__option-name ml-12 cn-9 fs-14", "data-testid": "getting-started-link", children: "Getting started" })
        ]
      }
    ),
    p(),
    a && f(),
    t?.installationType === ME.OSS_HELM && /* @__PURE__ */ v.jsxs("div", { className: "help-card__update-option fs-11 fw-6 mt-4", children: [
      n ? /* @__PURE__ */ v.jsx("span", { className: "dc__loading-dots", children: "Checking current version" }) : /* @__PURE__ */ v.jsxs("span", { children: [
        "version ",
        t?.currentVersion || ""
      ] }),
      /* @__PURE__ */ v.jsx("br", {}),
      /* @__PURE__ */ v.jsx(uo, { to: sr.STACK_MANAGER_ABOUT, children: "Check for Updates" })
    ] })
  ] }) });
}, v4e = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M8.125 6.25001V15.9155C8.125 16.0184 8.0996 16.1197 8.05105 16.2104C8.0025 16.3011 7.9323 16.3785 7.84669 16.4355L6.98793 17.0081C6.90459 17.0636 6.80913 17.0983 6.70957 17.1093C6.61001 17.1202 6.50928 17.1071 6.41587 17.071C6.32245 17.0349 6.23908 16.9768 6.17278 16.9018C6.10648 16.8267 6.05919 16.7368 6.0349 16.6396L5 12.5M8.125 6.25001H5C4.1712 6.25001 3.37634 6.57925 2.79029 7.1653C2.20424 7.75135 1.875 8.54621 1.875 9.37501C1.875 10.2038 2.20424 10.9987 2.79029 11.5847C3.37634 12.1708 4.1712 12.5 5 12.5M8.125 6.25001C8.125 6.25001 12.379 6.25001 16.4727 2.8166C16.5638 2.73997 16.6748 2.69093 16.7928 2.67525C16.9107 2.65957 17.0307 2.6779 17.1386 2.72808C17.2465 2.77826 17.3379 2.85821 17.4019 2.95853C17.4659 3.05884 17.4999 3.17535 17.5 3.29435V15.4557C17.4999 15.5747 17.4659 15.6912 17.4019 15.7915C17.3379 15.8918 17.2465 15.9718 17.1386 16.0219C17.0307 16.0721 16.9107 16.0904 16.7928 16.0748C16.6748 16.0591 16.5638 16.01 16.4727 15.9334C12.379 12.5 8.125 12.5 8.125 12.5L5 12.5", stroke: "#000A14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), _4e = ({ parentClassName: i = "", isCDMaterial: e = !1 }) => {
  const t = window?._env_?.ANNOUNCEMENT_BANNER_MSG, n = () => {
    const l = typeof Storage < "u" && localStorage.getItem(
      // it will store date and time of next day i.e, it will hide banner until this date
      "expiryDateOfHidingAnnouncementBanner"
    );
    return typeof Storage < "u" && H2(localStorage.getItem("dashboardLoginTime")) > H2(l) && !l ? !0 : H2((/* @__PURE__ */ new Date()).valueOf()) > H2(l);
  }, [r, s] = Oe(t ? n() : !1);
  if (!t)
    return null;
  const o = () => {
    s(!1), typeof Storage < "u" && OE("expiryDateOfHidingAnnouncementBanner", 1);
  }, a = () => /* @__PURE__ */ v.jsxs("div", { className: "flex", children: [
    /* @__PURE__ */ v.jsx("div", { children: t }),
    e ? null : /* @__PURE__ */ v.jsx(Il, { className: "icon-dim-20 ml-8 fcn-9", onClick: o })
  ] });
  return r || e ? /* @__PURE__ */ v.jsx("div", { className: `announcement-banner-container ${i}`, children: /* @__PURE__ */ v.jsx(
    q1t,
    {
      message: a(),
      classname: "announcement-bar fw-6 lh-20",
      Icon: v4e,
      iconSize: 20
    }
  ) }) : null;
}, b4e = _4e, C4e = ({
  headerName: i,
  additionalHeaderInfo: e,
  showTabs: t = !1,
  renderHeaderTabs: n,
  isBreadcrumbs: r = !1,
  breadCrumbs: s,
  renderActionButtons: o,
  showCloseButton: a = !1,
  onClose: l,
  markAsBeta: c,
  showAnnouncementHeader: d,
  tippyProps: u
}) => {
  const { loginCount: h, setLoginCount: f, showGettingStartedCard: g, setShowGettingStartedCard: p, setGettingStartedClicked: m } = Cj(), { isTippyCustomized: _, tippyRedirectLink: b, TippyIcon: w, tippyMessage: y, onClickTippyButton: S, additionalContent: x } = u || {}, [D, E] = Oe(!1), [L, k] = Oe(!1), { email: N } = $de(), [I, A] = Oe(
    {
      serverInfo: void 0,
      fetchingServerInfo: !1
    }
  ), [P, O] = Oe(0), K = async () => {
    try {
      const { result: X } = await t4e(!0, !0);
      A({
        serverInfo: X,
        fetchingServerInfo: !1
      });
    } catch {
      A({
        serverInfo: I.serverInfo,
        fetchingServerInfo: !1
      }), console.error("Error in fetching server info");
    }
  };
  $e(() => {
    O(+localStorage.getItem("clickedOkay"));
  }, []);
  const W = (X) => {
    p(!1), X && f(+X);
  }, F = () => {
    k(!L), D && E(!1), OE("clickedOkay", 1), W();
  }, q = async (X) => {
    !window._env_.K8S_CLIENT && I.serverInfo?.installationType !== ME.ENTERPRISE && await K(), E(!D), L && k(!1), OE("clickedOkay", 1), W(), await X8(X, l8.HELP), cA.event({
      category: "Main Navigation",
      action: "Help Clicked"
    });
  }, R = () => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex left cursor mr-16", onClick: q, children: [
      /* @__PURE__ */ v.jsx("span", { className: "icon-dim-24 fcn-9 mr-4 ml-16", children: /* @__PURE__ */ v.jsx(lb, {}) }),
      /* @__PURE__ */ v.jsx("span", { className: "fs-13 cn-9", "data-testid": "go-to-get-started", children: "Help" }),
      /* @__PURE__ */ v.jsx(
        vu,
        {
          style: { "--rotateBy": `${180 * Number(D)}deg` },
          className: "fcn-9 icon-dim-20 rotate pointer"
        }
      )
    ] }),
    !window._env_.K8S_CLIENT && /* @__PURE__ */ v.jsx(
      "div",
      {
        className: "logout-card__initial cursor fs-13 icon-dim-24 flex logout-card__initial--nav",
        onClick: F,
        style: { backgroundColor: vx(N) },
        "data-testid": "profile-button",
        children: N[0]
      }
    )
  ] }), T = () => (/* @__PURE__ */ new Date()).valueOf() > P, z = () => /* @__PURE__ */ v.jsx("span", { className: "fs-12 fw-4 lh-18 pt-1 pb-1 pl-6 pr-6 ml-8 cn-9 bcy-5 br-4", children: "Beta" });
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `dc__page-header dc__content-space cn-9 bcn-0 pl-20 pr-20 ${t ? "dc__page-header-tabs__height" : "dc__page-header__height flex"}`,
      children: [
        /* @__PURE__ */ v.jsxs("h1", { className: "dc__page-header__title dc__content-space  flex fs-16 fw-6 lh-20 h-48", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
            a && /* @__PURE__ */ v.jsx(
              "button",
              {
                className: "dc__transparent flex mr-8",
                type: "button",
                "aria-label": "close-button",
                onClick: l,
                children: /* @__PURE__ */ v.jsx(Il, { className: "dc__page-header__close-icon icon-dim-24 cursor" })
              }
            ),
            /* @__PURE__ */ v.jsx("span", { className: "fw-6", "data-testid": "main-header", children: i }),
            e && e(),
            r && s(),
            u && (_ ? /* @__PURE__ */ v.jsx(
              OA,
              {
                infoText: y,
                heading: i,
                iconClassName: "icon-dim-20 ml-8 fcn-5",
                documentationLink: b,
                documentationLinkText: "Learn More",
                additionalContent: x,
                children: w && /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(w, { className: "icon-dim-20 ml- cursor fcn-5" }) })
              }
            ) : /* @__PURE__ */ v.jsx(
              "a",
              {
                "data-testid": "learn-more-symbol",
                className: "dc__link flex",
                target: "_blank",
                href: b,
                onClick: S,
                rel: "noreferrer",
                "aria-label": "tippy-icon",
                children: /* @__PURE__ */ v.jsx(
                  wn,
                  {
                    className: "default-tt ",
                    arrow: !1,
                    placement: "top",
                    content: /* @__PURE__ */ v.jsxs("span", { style: { display: "block", width: "66px" }, children: [
                      " ",
                      y,
                      " "
                    ] }),
                    children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(w, { className: "icon-dim-20 ml-8 cursor fcn-5" }) })
                  }
                )
              }
            )),
            c && z()
          ] }),
          t && /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
            typeof o == "function" && o(),
            R()
          ] })
        ] }),
        t && n(),
        D && /* @__PURE__ */ v.jsx(
          m4e,
          {
            className: `help-card__more-option ${window._env_.K8S_CLIENT ? "k8s-client-view" : ""}`,
            setShowHelpCard: E,
            serverInfo: I.serverInfo,
            fetchingServerInfo: I.fetchingServerInfo,
            setGettingStartedClicked: m,
            showHelpCard: D
          }
        ),
        !window._env_.K8S_CLIENT && g && h >= 0 && h < Ole && T() && /* @__PURE__ */ v.jsx(
          s4e,
          {
            className: "w-300",
            showHelpCard: !1,
            hideGettingStartedCard: W,
            loginCount: h
          }
        ),
        L && /* @__PURE__ */ v.jsx(
          $Ae,
          {
            className: "logout-card__more-option",
            userFirstLetter: N,
            setShowLogOutCard: k,
            showLogOutCard: L
          }
        ),
        !t && /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
          typeof o == "function" && o(),
          R()
        ] }),
        d && /* @__PURE__ */ v.jsx(b4e, { parentClassName: "page-header-banner" })
      ]
    }
  );
}, y4e = C4e, w4e = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#767D84", fillRule: "evenodd", d: "M8.085 10L4 6 12 6z" })), S4e = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M10 0c.46 0 .833.373.833.833V2.5l-.001.047a7.454 7.454 0 0 1 3.851 1.595l.031-.035 1.179-1.178a.833.833 0 1 1 1.178 1.178l-1.178 1.179a.847.847 0 0 1-.035.032 7.453 7.453 0 0 1 1.596 3.851l.046-.002h1.667a.833.833 0 1 1 0 1.666H17.5l-.047-.001a7.454 7.454 0 0 1-1.595 3.851l.035.031 1.178 1.179a.833.833 0 0 1-1.178 1.178l-1.179-1.178a.847.847 0 0 1-.032-.035 7.453 7.453 0 0 1-3.851 1.596l.002.046v1.667a.833.833 0 1 1-1.666 0V17.5l.001-.047a7.454 7.454 0 0 1-3.851-1.595l-.031.035-1.179 1.178a.833.833 0 0 1-1.178-1.178l1.178-1.179a.847.847 0 0 1 .035-.032 7.453 7.453 0 0 1-1.596-3.851l-.046.002H.833a.833.833 0 1 1 0-1.666H2.5l.047.001a7.454 7.454 0 0 1 1.595-3.851l-.035-.031L2.93 4.107A.833.833 0 1 1 4.107 2.93l1.179 1.178a.847.847 0 0 1 .032.035A7.453 7.453 0 0 1 9.17 2.546L9.167 2.5V.833C9.167.373 9.54 0 10 0zm0 4.167a5.833 5.833 0 1 0 0 11.666 5.833 5.833 0 0 0 0-11.666zm0 1.666a4.167 4.167 0 1 1 0 8.334 4.167 4.167 0 0 1 0-8.334zM10 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z", fill: "#3B444C", fillRule: "evenodd" })), fS = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("path", { className: "fill-color", fill: "#999", fillRule: "nonzero", d: "M18 13h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2z" })), x4e = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M12.5 12.5H17.5M12.5 12.5V17.5M12.5 12.5V7.5M12.5 12.5H7.5M17.5 12.5V17.5H12.5M17.5 12.5V7.5M12.5 17.5H7.5M12.5 7.5H17.5M12.5 7.5V2.5H17.5V7.5M12.5 7.5H7.5M7.5 12.5V17.5M7.5 12.5V7.5M7.5 12.5H2.5M7.5 17.5H2.5V12.5M7.5 7.5H2.5V12.5", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Dbt = ({ headerName: i }) => {
  const e = eo(), t = ip(), n = E0(), { serverMode: r } = Cj(), [s, o] = Oe(!1), a = () => {
    o((f) => !f);
  }, l = () => {
    t.push(sr.CHARTS_DISCOVER);
  }, c = () => {
    const g = (e.appType ? e.appType === Hk.AppType.DEVTRON_APPS : r === a8.FULL) ? Hk.AppType.DEVTRON_APPS : sr.APP_LIST_HELM, p = `${sr.APP}/${sr.APP_LIST}/${g}`;
    t.push(`${p}/${Hk.CREATE_DEVTRON_APP_URL}${n.search}`);
  }, d = () => {
    t.push(`${sr.JOB}/${sr.APP_LIST}/${sr.CREATE_JOB}`);
  }, u = () => r === a8.FULL ? /* @__PURE__ */ v.jsxs(
    "button",
    {
      type: "button",
      className: "flex cta h-32 lh-n",
      onClick: a,
      "data-testid": "create-app-button-on-header",
      children: [
        "Create",
        /* @__PURE__ */ v.jsx(w4e, { className: "icon-dim-20" })
      ]
    }
  ) : /* @__PURE__ */ v.jsx("button", { type: "button", className: "flex cta h-32 lh-n", onClick: l, children: "Deploy helm charts" }), h = () => /* @__PURE__ */ v.jsxs(zve, { rootClassName: "create-modal-wrapper", onClick: a, children: [
    /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: "create-modal-child cursor",
        onClick: c,
        "data-testid": "create-custom-app-button-in-dropdown",
        children: [
          /* @__PURE__ */ v.jsx(fS, { className: "icon-dim-20 fcn-9" }),
          /* @__PURE__ */ v.jsxs("div", { className: "ml-8", children: [
            /* @__PURE__ */ v.jsx("strong", { children: "Custom app" }),
            /* @__PURE__ */ v.jsxs("div", { children: [
              "Connect a git repository to deploy ",
              /* @__PURE__ */ v.jsx("br", {}),
              " a custom application"
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: "create-modal-child cursor",
        onClick: l,
        "data-testid": "create-from-chart-store-button",
        children: [
          /* @__PURE__ */ v.jsx(S4e, { className: "icon-dim-20" }),
          /* @__PURE__ */ v.jsxs("div", { className: "ml-8", children: [
            /* @__PURE__ */ v.jsx("strong", { children: "From Chart store" }),
            /* @__PURE__ */ v.jsxs("div", { children: [
              "Deploy apps using third party helm ",
              /* @__PURE__ */ v.jsx("br", {}),
              " charts (eg. prometheus, redis etc.)"
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: "create-modal-child cursor",
        onClick: d,
        "data-testid": "create-job-button-in-dropdown",
        children: [
          /* @__PURE__ */ v.jsx(x4e, { className: "icon-dim-20 scn-7" }),
          /* @__PURE__ */ v.jsxs("div", { className: "ml-8", children: [
            /* @__PURE__ */ v.jsx("strong", { children: "Job" }),
            /* @__PURE__ */ v.jsxs("div", { children: [
              "Jobs allow manual and automated ",
              /* @__PURE__ */ v.jsx("br", {}),
              " execution of developer actions."
            ] })
          ] })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ v.jsxs("div", { className: "create-button-container dc__position-sticky dc__top-0 bcn-0 dc__zi-4", children: [
    /* @__PURE__ */ v.jsx(y4e, { headerName: i, renderActionButtons: u }),
    s && h()
  ] });
}, D4e = ({
  content: i,
  onClick: e,
  children: t,
  className: n = "",
  popUpBodyClassName: r = "",
  showPopUp: s = !0,
  disabled: o = !1,
  isLoading: a = !1
}) => {
  const [l, c] = Oe(!1);
  return /* @__PURE__ */ v.jsxs("div", { className: "flexbox bcb-5 br-4", children: [
    /* @__PURE__ */ v.jsx(
      RA,
      {
        isLoading: a,
        rootClassName: `cta flex h-28 ${s ? "dc__no-right-radius" : ""} dc__no-border-imp fs-12 fw-6 lh-20-imp ${n}`,
        type: "button",
        onClick: e,
        disabled: a || o,
        children: i
      }
    ),
    s && /* @__PURE__ */ v.jsxs(tc, { autoClose: !0, autoPosition: !0, onToggleCallback: c, children: [
      /* @__PURE__ */ v.jsx(
        tc.Button,
        {
          disabled: o,
          rootClassName: "flex dc__transparent p-0 w-28 bcb-5 dc__right-radius-4 dc__no-left-radius dc__no-top-border dc__no-bottom-border dc__no-right-border button-with-selector",
          children: /* @__PURE__ */ v.jsx(
            vu,
            {
              className: "icon-dim-16 fcn-0 dc__no-shrink rotate",
              style: { "--rotateBy": l ? "180deg" : "0deg" }
            }
          )
        }
      ),
      /* @__PURE__ */ v.jsx(tc.Body, { rootClassName: `pt-4 pb-4 dc__border dc__overflow-hidden ${r}`, children: t })
    ] })
  ] });
}, Ebt = D4e, Z8 = {
  DEFAULT_PLACEHOLDER: "Select Environment",
  GROUP_HEADING_PREFIX: "Cluster:",
  NO_ENVIRONMENTS_AVAILABLE: "No environments available"
}, E4e = (i) => {
  const e = i.reduce(
    (t, n) => (t[n.cluster_name] || (t[n.cluster_name] = []), t[n.cluster_name].push(n), t),
    {}
  );
  return Object.entries(e).map(([t, n]) => ({
    label: `${Z8.GROUP_HEADING_PREFIX} ${t}`,
    options: n.map((r) => ({
      label: r.environment_name,
      value: String(r.id)
    })).sort((r, s) => Qs(r.label, s.label))
  })).sort((t, n) => Qs(t.label, n.label));
}, L4e = (i, e) => e?.length ? e.reduce((t, n) => {
  const r = n.options.filter((s) => i[s.label]);
  return [...t, ...r];
}, []) : [], I4e = async () => {
  try {
    const { result: i } = await Qn(hn.ENVIRONMENT_LIST_MIN);
    return i ? E4e(i) : [];
  } catch (i) {
    return Is(i), i;
  }
}, A4e = ({
  handleEnvironmentChange: i,
  selectedEnvironmentsMap: e,
  isMulti: t,
  placeholder: n = Z8.DEFAULT_PLACEHOLDER,
  processOptions: r,
  styles: s,
  isClearable: o,
  autoFocus: a
}) => {
  const [l, c, d, u] = tf(
    I4e
  ), h = Mn(() => c ? r?.(c) || c : [], [c, r]), f = Mn(() => {
    const p = L4e(e, h);
    return t ? p : p?.[0] || null;
  }, [e, h, t]), g = () => d ? /* @__PURE__ */ v.jsx(ob, { withBorder: !0, reload: u }) : /* @__PURE__ */ v.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-20 py-6 px-8", children: Z8.NO_ENVIRONMENTS_AVAILABLE });
  return /* @__PURE__ */ v.jsx(
    Ba,
    {
      isMulti: t,
      options: h,
      value: f,
      onChange: i,
      isSearchable: !0,
      isClearable: o,
      isLoading: l,
      placeholder: n,
      components: {
        IndicatorSeparator: null,
        LoadingIndicator: Rde,
        NoOptionsMessage: g,
        GroupHeading: ULe,
        ClearIndicator: C5e
      },
      styles: s ?? Fde,
      backspaceRemovesValue: !1,
      autoFocus: a
    }
  );
}, Lbt = A4e, eue = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M13.5 6.25L13.4995 2.5005L9.75 2.5M8.99821 7.00179L13.4982 2.50179M11.5 9V13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V5C2.5 4.86739 2.55268 4.74021 2.64645 4.64645C2.74021 4.55268 2.86739 4.5 3 4.5H7", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), k4e = ({
  rootClassName: i = "",
  heading: e,
  icon: t,
  children: n,
  documentationLink: r
}) => /* @__PURE__ */ v.jsxs("div", { className: `flexbox-col w-250 dc__gap-24 dc__modal-gradient ${i}`, children: [
  /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      t && t,
      /* @__PURE__ */ v.jsx("h3", { className: "fs-18 fw-6 cn-9 lh-1-5 m-0", children: e })
    ] }),
    n && /* @__PURE__ */ v.jsx("div", { className: "fs-13 fw-4 lh-1-5 cn-7", children: n })
  ] }),
  /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
    /* @__PURE__ */ v.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: "📙 Need help?" }),
    /* @__PURE__ */ v.jsxs(
      "a",
      {
        href: r,
        target: "_blank",
        className: "dc__no-decor flexbox dc__align-items-center dc__gap-4",
        rel: "noreferrer",
        children: [
          /* @__PURE__ */ v.jsx("span", { className: "fs-13 fw-6 lh-20 cb-5", children: "View documentation" }),
          /* @__PURE__ */ v.jsx(eue, { className: "scb-5 icon-dim-14" })
        ]
      }
    )
  ] })
] }), Ibt = k4e, T4e = ({ imageProps: i, fallbackImage: e }) => {
  const [t, n] = Oe(i.src);
  $e(() => {
    n(i.src);
  }, [i.src]);
  const r = (s) => {
    e && t && n(null), i.onError && i.onError(s);
  };
  return (
    // Added for type consistency
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ v.jsx(v.Fragment, { children: t || !t && typeof e == "string" ? /* @__PURE__ */ v.jsx("img", { alt: "", ...i, src: t || e, onError: r }) : e })
  );
}, tue = T4e;
var Q8 = /* @__PURE__ */ ((i) => (i.GOT_IT = "Got it", i.VIEW_DOCUMENTATION = "View Documentation", i))(Q8 || {});
const dY = (i) => {
  switch (i) {
    case Vl.SMALL:
      return { width: "100%", height: "200px" };
    default:
      return { width: "100%", height: "250px" };
  }
}, N4e = ({
  title: i,
  renderDescriptionContent: e,
  closeModalText: t = Q8.GOT_IT,
  docLink: n = "",
  closeModal: r,
  imageVariant: s,
  SVGImage: o,
  imageStyles: a = {}
}) => {
  const l = () => o ? /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__align-center dc__justify-center mt-16 mb-12", children: /* @__PURE__ */ v.jsx(
    o,
    {
      style: {
        ...a,
        width: `${dY(s).width}`,
        height: `${dY(s).height}`
      }
    }
  ) }) : null, c = () => /* @__PURE__ */ v.jsxs("div", { className: "pl-20 pr-20 pt-16 pb-16 dc__gap-16", children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex left w-100 fs-16 fw-6", children: i }),
    l(),
    typeof e == "function" && e()
  ] }), d = () => /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `flex right w-100 dc__align-right dc__border-top-n1 px-20 py-16 ${n ? "dc__content-space" : "right"}`,
      children: [
        n.length > 0 && /* @__PURE__ */ v.jsxs(
          "a",
          {
            className: "flex dc__link en-2 bw-1 dc__gap-6 br-4 fw-6 lh-20 px-8 py-6 h-32 anchor dc__hover-n50",
            href: n,
            target: "_blank",
            rel: "noreferrer",
            children: [
              Q8.VIEW_DOCUMENTATION,
              /* @__PURE__ */ v.jsx(eue, { className: "icon-dim-16 scb-5" })
            ]
          }
        ),
        /* @__PURE__ */ v.jsx("button", { className: "cta flex small", type: "submit", onClick: r, children: t })
      ]
    }
  );
  return /* @__PURE__ */ v.jsx(yk, { className: "", close: r, children: /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: "feature-description modal__body w-600 mt-40 flex column p-0 fs-13 dc__overflow-hidden",
      onClick: Cr,
      children: [
        c(),
        d()
      ]
    }
  ) });
}, P4e = ({
  additionalContainerClasses: i,
  breadCrumbs: e = [],
  children: t,
  iconClassName: n = "icon-dim-20 fcn-6",
  title: r,
  renderDescriptionContent: s,
  closeModalText: o,
  docLink: a,
  SVGImage: l,
  showInfoIconTippy: c,
  docLinkText: d = "View Documentation",
  dataTestId: u = "feature-title-with-info",
  additionalContent: h
}) => {
  const [f, g] = Oe(!1), p = () => {
    g(!0);
  }, m = () => {
    g(!1);
  }, _ = () => c ? /* @__PURE__ */ v.jsxs("div", { className: "flex left fs-16 cn-9 fw-6 dc__gap-4", children: [
    /* @__PURE__ */ v.jsx("span", { "data-testid": u, className: "lh-32", children: r }),
    /* @__PURE__ */ v.jsx(
      OA,
      {
        heading: r,
        infoText: s(),
        additionalContent: h,
        iconClassName: n,
        documentationLink: a,
        documentationLinkText: d,
        dataTestid: "info-tippy-button"
      }
    )
  ] }) : e?.length > 0 ? /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4", children: [
    /* @__PURE__ */ v.jsx(gCe, { breadcrumbs: e }),
    /* @__PURE__ */ v.jsx(lb, { className: `${n} icon-dim-20 cursor fcn-6`, onClick: p })
  ] }) : /* @__PURE__ */ v.jsx("span", { className: "fs-16 fw-6 cn-9 lh-32", children: r });
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: `feature-description flexbox dc__content-space dc__align-items-center ${i ?? ""}`,
        children: [
          _(),
          t
        ]
      }
    ),
    f && /* @__PURE__ */ v.jsx(
      N4e,
      {
        title: r,
        renderDescriptionContent: s,
        closeModalText: o,
        docLink: a,
        closeModal: m,
        SVGImage: l
      }
    )
  ] });
}, Abt = P4e;
var O4e = "tippy-content", M4e = "tippy-backdrop", R4e = "tippy-arrow", F4e = "tippy-svg-arrow", Rp = {
  passive: !0,
  capture: !0
}, nue = function() {
  return document.body;
};
function B4e(i, e) {
  return {}.hasOwnProperty.call(i, e);
}
function jk(i, e, t) {
  if (Array.isArray(i)) {
    var n = i[e];
    return n ?? (Array.isArray(t) ? t[e] : t);
  }
  return i;
}
function yj(i, e) {
  var t = {}.toString.call(i);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function iue(i, e) {
  return typeof i == "function" ? i.apply(void 0, e) : i;
}
function uY(i, e) {
  if (e === 0)
    return i;
  var t;
  return function(n) {
    clearTimeout(t), t = setTimeout(function() {
      i(n);
    }, e);
  };
}
function V4e(i, e) {
  var t = Object.assign({}, i);
  return e.forEach(function(n) {
    delete t[n];
  }), t;
}
function H4e(i) {
  return i.split(/\s+/).filter(Boolean);
}
function O1(i) {
  return [].concat(i);
}
function hY(i, e) {
  i.indexOf(e) === -1 && i.push(e);
}
function W4e(i) {
  return i.filter(function(e, t) {
    return i.indexOf(e) === t;
  });
}
function j4e(i) {
  return i.split("-")[0];
}
function RE(i) {
  return [].slice.call(i);
}
function fY(i) {
  return Object.keys(i).reduce(function(e, t) {
    return i[t] !== void 0 && (e[t] = i[t]), e;
  }, {});
}
function z4e() {
  return document.createElement("div");
}
function J8(i) {
  return ["Element", "Fragment"].some(function(e) {
    return yj(i, e);
  });
}
function U4e(i) {
  return yj(i, "NodeList");
}
function G4e(i) {
  return yj(i, "MouseEvent");
}
function q4e(i) {
  return !!(i && i._tippy && i._tippy.reference === i);
}
function K4e(i) {
  return J8(i) ? [i] : U4e(i) ? RE(i) : Array.isArray(i) ? i : RE(document.querySelectorAll(i));
}
function zk(i, e) {
  i.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function gY(i, e) {
  i.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function Y4e(i) {
  var e, t = O1(i), n = t[0];
  return n != null && (e = n.ownerDocument) != null && e.body ? n.ownerDocument : document;
}
function X4e(i, e) {
  var t = e.clientX, n = e.clientY;
  return i.every(function(r) {
    var s = r.popperRect, o = r.popperState, a = r.props, l = a.interactiveBorder, c = j4e(o.placement), d = o.modifiersData.offset;
    if (!d)
      return !0;
    var u = c === "bottom" ? d.top.y : 0, h = c === "top" ? d.bottom.y : 0, f = c === "right" ? d.left.x : 0, g = c === "left" ? d.right.x : 0, p = s.top - n + u > l, m = n - s.bottom - h > l, _ = s.left - t + f > l, b = t - s.right - g > l;
    return p || m || _ || b;
  });
}
function Uk(i, e, t) {
  var n = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(r) {
    i[n](r, t);
  });
}
function pY(i, e) {
  for (var t = e; t; ) {
    var n;
    if (i.contains(t))
      return !0;
    t = t.getRootNode == null || (n = t.getRootNode()) == null ? void 0 : n.host;
  }
  return !1;
}
var Pd = {
  isTouch: !1
}, mY = 0;
function Z4e() {
  Pd.isTouch || (Pd.isTouch = !0, window.performance && document.addEventListener("mousemove", rue));
}
function rue() {
  var i = performance.now();
  i - mY < 20 && (Pd.isTouch = !1, document.removeEventListener("mousemove", rue)), mY = i;
}
function Q4e() {
  var i = document.activeElement;
  if (q4e(i)) {
    var e = i._tippy;
    i.blur && !e.state.isVisible && i.blur();
  }
}
function J4e() {
  document.addEventListener("touchstart", Z4e, Rp), window.addEventListener("blur", Q4e);
}
var $4e = typeof window < "u" && typeof document < "u", e5e = $4e ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function o1(i) {
  var e = i === "destroy" ? "n already-" : " ";
  return [i + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function vY(i) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return i.replace(e, " ").replace(t, "").trim();
}
function t5e(i) {
  return vY(`
  %ctippy.js

  %c` + vY(i) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function sue(i) {
  return [
    t5e(i),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var py;
process.env.NODE_ENV !== "production" && n5e();
function n5e() {
  py = /* @__PURE__ */ new Set();
}
function th(i, e) {
  if (i && !py.has(e)) {
    var t;
    py.add(e), (t = console).warn.apply(t, sue(e));
  }
}
function $8(i, e) {
  if (i && !py.has(e)) {
    var t;
    py.add(e), (t = console).error.apply(t, sue(e));
  }
}
function i5e(i) {
  var e = !i, t = Object.prototype.toString.call(i) === "[object Object]" && !i.addEventListener;
  $8(e, ["tippy() was passed", "`" + String(i) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), $8(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var oue = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, r5e = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, il = Object.assign({
  appendTo: nue,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, oue, r5e), s5e = Object.keys(il), o5e = function(e) {
  process.env.NODE_ENV !== "production" && lue(e, []);
  var t = Object.keys(e);
  t.forEach(function(n) {
    il[n] = e[n];
  });
};
function aue(i) {
  var e = i.plugins || [], t = e.reduce(function(n, r) {
    var s = r.name, o = r.defaultValue;
    if (s) {
      var a;
      n[s] = i[s] !== void 0 ? i[s] : (a = il[s]) != null ? a : o;
    }
    return n;
  }, {});
  return Object.assign({}, i, t);
}
function a5e(i, e) {
  var t = e ? Object.keys(aue(Object.assign({}, il, {
    plugins: e
  }))) : s5e, n = t.reduce(function(r, s) {
    var o = (i.getAttribute("data-tippy-" + s) || "").trim();
    if (!o)
      return r;
    if (s === "content")
      r[s] = o;
    else
      try {
        r[s] = JSON.parse(o);
      } catch {
        r[s] = o;
      }
    return r;
  }, {});
  return n;
}
function _Y(i, e) {
  var t = Object.assign({}, e, {
    content: iue(e.content, [i])
  }, e.ignoreAttributes ? {} : a5e(i, e.plugins));
  return t.aria = Object.assign({}, il.aria, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function lue(i, e) {
  i === void 0 && (i = {}), e === void 0 && (e = []);
  var t = Object.keys(i);
  t.forEach(function(n) {
    var r = V4e(il, Object.keys(oue)), s = !B4e(r, n);
    s && (s = e.filter(function(o) {
      return o.name === n;
    }).length === 0), th(s, ["`" + n + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
function bY(i) {
  var e = i.firstElementChild, t = RE(e.children);
  return {
    box: e,
    content: t.find(function(n) {
      return n.classList.contains(O4e);
    }),
    arrow: t.find(function(n) {
      return n.classList.contains(R4e) || n.classList.contains(F4e);
    }),
    backdrop: t.find(function(n) {
      return n.classList.contains(M4e);
    })
  };
}
var l5e = 1, Ax = [], Gk = [];
function c5e(i, e) {
  var t = _Y(i, Object.assign({}, il, aue(fY(e)))), n, r, s, o = !1, a = !1, l = !1, c = !1, d, u, h, f = [], g = uY(Se, t.interactiveDebounce), p, m = l5e++, _ = null, b = W4e(t.plugins), w = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, y = {
    // properties
    id: m,
    reference: i,
    popper: z4e(),
    popperInstance: _,
    props: t,
    state: w,
    plugins: b,
    // methods
    clearDelayTimeouts: Q,
    setProps: me,
    setContent: Le,
    show: xe,
    hide: Ue,
    hideWithInteractivity: je,
    enable: Y,
    disable: Z,
    unmount: Ze,
    destroy: _e
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && $8(!0, "render() function has not been supplied."), y;
  var S = t.render(y), x = S.popper, D = S.onUpdate;
  x.setAttribute("data-tippy-root", ""), x.id = "tippy-" + y.id, y.popper = x, i._tippy = y, x._tippy = y;
  var E = b.map(function(U) {
    return U.fn(y);
  }), L = i.hasAttribute("aria-expanded");
  return ee(), R(), W(), F("onCreate", [y]), t.showOnCreate && ie(), x.addEventListener("mouseenter", function() {
    y.props.interactive && y.state.isVisible && y.clearDelayTimeouts();
  }), x.addEventListener("mouseleave", function() {
    y.props.interactive && y.props.trigger.indexOf("mouseenter") >= 0 && P().addEventListener("mousemove", g);
  }), y;
  function k() {
    var U = y.props.touch;
    return Array.isArray(U) ? U : [U, 0];
  }
  function N() {
    return k()[0] === "hold";
  }
  function I() {
    var U;
    return !!((U = y.props.render) != null && U.$$tippy);
  }
  function A() {
    return p || i;
  }
  function P() {
    var U = A().parentNode;
    return U ? Y4e(U) : document;
  }
  function O() {
    return bY(x);
  }
  function K(U) {
    return y.state.isMounted && !y.state.isVisible || Pd.isTouch || d && d.type === "focus" ? 0 : jk(y.props.delay, U ? 0 : 1, il.delay);
  }
  function W(U) {
    U === void 0 && (U = !1), x.style.pointerEvents = y.props.interactive && !U ? "" : "none", x.style.zIndex = "" + y.props.zIndex;
  }
  function F(U, fe, Ee) {
    if (Ee === void 0 && (Ee = !0), E.forEach(function(Pe) {
      Pe[U] && Pe[U].apply(Pe, fe);
    }), Ee) {
      var Me;
      (Me = y.props)[U].apply(Me, fe);
    }
  }
  function q() {
    var U = y.props.aria;
    if (U.content) {
      var fe = "aria-" + U.content, Ee = x.id, Me = O1(y.props.triggerTarget || i);
      Me.forEach(function(Pe) {
        var et = Pe.getAttribute(fe);
        if (y.state.isVisible)
          Pe.setAttribute(fe, et ? et + " " + Ee : Ee);
        else {
          var gt = et && et.replace(Ee, "").trim();
          gt ? Pe.setAttribute(fe, gt) : Pe.removeAttribute(fe);
        }
      });
    }
  }
  function R() {
    if (!(L || !y.props.aria.expanded)) {
      var U = O1(y.props.triggerTarget || i);
      U.forEach(function(fe) {
        y.props.interactive ? fe.setAttribute("aria-expanded", y.state.isVisible && fe === A() ? "true" : "false") : fe.removeAttribute("aria-expanded");
      });
    }
  }
  function T() {
    P().removeEventListener("mousemove", g), Ax = Ax.filter(function(U) {
      return U !== g;
    });
  }
  function z(U) {
    if (!(Pd.isTouch && (l || U.type === "mousedown"))) {
      var fe = U.composedPath && U.composedPath()[0] || U.target;
      if (!(y.props.interactive && pY(x, fe))) {
        if (O1(y.props.triggerTarget || i).some(function(Ee) {
          return pY(Ee, fe);
        })) {
          if (Pd.isTouch || y.state.isVisible && y.props.trigger.indexOf("click") >= 0)
            return;
        } else
          F("onClickOutside", [y, U]);
        y.props.hideOnClick === !0 && (y.clearDelayTimeouts(), y.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), y.state.isMounted || se());
      }
    }
  }
  function X() {
    l = !0;
  }
  function ae() {
    l = !1;
  }
  function ue() {
    var U = P();
    U.addEventListener("mousedown", z, !0), U.addEventListener("touchend", z, Rp), U.addEventListener("touchstart", ae, Rp), U.addEventListener("touchmove", X, Rp);
  }
  function se() {
    var U = P();
    U.removeEventListener("mousedown", z, !0), U.removeEventListener("touchend", z, Rp), U.removeEventListener("touchstart", ae, Rp), U.removeEventListener("touchmove", X, Rp);
  }
  function le(U, fe) {
    re(U, function() {
      !y.state.isVisible && x.parentNode && x.parentNode.contains(x) && fe();
    });
  }
  function oe(U, fe) {
    re(U, fe);
  }
  function re(U, fe) {
    var Ee = O().box;
    function Me(Pe) {
      Pe.target === Ee && (Uk(Ee, "remove", Me), fe());
    }
    if (U === 0)
      return fe();
    Uk(Ee, "remove", u), Uk(Ee, "add", Me), u = Me;
  }
  function B(U, fe, Ee) {
    Ee === void 0 && (Ee = !1);
    var Me = O1(y.props.triggerTarget || i);
    Me.forEach(function(Pe) {
      Pe.addEventListener(U, fe, Ee), f.push({
        node: Pe,
        eventType: U,
        handler: fe,
        options: Ee
      });
    });
  }
  function ee() {
    N() && (B("touchstart", he, {
      passive: !0
    }), B("touchend", ge, {
      passive: !0
    })), H4e(y.props.trigger).forEach(function(U) {
      if (U !== "manual")
        switch (B(U, he), U) {
          case "mouseenter":
            B("mouseleave", ge);
            break;
          case "focus":
            B(e5e ? "focusout" : "blur", te);
            break;
          case "focusin":
            B("focusout", te);
            break;
        }
    });
  }
  function j() {
    f.forEach(function(U) {
      var fe = U.node, Ee = U.eventType, Me = U.handler, Pe = U.options;
      fe.removeEventListener(Ee, Me, Pe);
    }), f = [];
  }
  function he(U) {
    var fe, Ee = !1;
    if (!(!y.state.isEnabled || be(U) || a)) {
      var Me = ((fe = d) == null ? void 0 : fe.type) === "focus";
      d = U, p = U.currentTarget, R(), !y.state.isVisible && G4e(U) && Ax.forEach(function(Pe) {
        return Pe(U);
      }), U.type === "click" && (y.props.trigger.indexOf("mouseenter") < 0 || o) && y.props.hideOnClick !== !1 && y.state.isVisible ? Ee = !0 : ie(U), U.type === "click" && (o = !Ee), Ee && !Me && H(U);
    }
  }
  function Se(U) {
    var fe = U.target, Ee = A().contains(fe) || x.contains(fe);
    if (!(U.type === "mousemove" && Ee)) {
      var Me = ce().concat(x).map(function(Pe) {
        var et, gt = Pe._tippy, Vt = (et = gt.popperInstance) == null ? void 0 : et.state;
        return Vt ? {
          popperRect: Pe.getBoundingClientRect(),
          popperState: Vt,
          props: t
        } : null;
      }).filter(Boolean);
      X4e(Me, U) && (T(), H(U));
    }
  }
  function ge(U) {
    var fe = be(U) || y.props.trigger.indexOf("click") >= 0 && o;
    if (!fe) {
      if (y.props.interactive) {
        y.hideWithInteractivity(U);
        return;
      }
      H(U);
    }
  }
  function te(U) {
    y.props.trigger.indexOf("focusin") < 0 && U.target !== A() || y.props.interactive && U.relatedTarget && x.contains(U.relatedTarget) || H(U);
  }
  function be(U) {
    return Pd.isTouch ? N() !== U.type.indexOf("touch") >= 0 : !1;
  }
  function Ae() {
    He();
    var U = y.props, fe = U.popperOptions, Ee = U.placement, Me = U.offset, Pe = U.getReferenceClientRect, et = U.moveTransition, gt = I() ? bY(x).arrow : null, Vt = Pe ? {
      getBoundingClientRect: Pe,
      contextElement: Pe.contextElement || A()
    } : i, Zt = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(fn) {
        var xn = fn.state;
        if (I()) {
          var rt = O(), Ei = rt.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Nn) {
            Nn === "placement" ? Ei.setAttribute("data-placement", xn.placement) : xn.attributes.popper["data-popper-" + Nn] ? Ei.setAttribute("data-" + Nn, "") : Ei.removeAttribute("data-" + Nn);
          }), xn.attributes.popper = {};
        }
      }
    }, St = [{
      name: "offset",
      options: {
        offset: Me
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !et
      }
    }, Zt];
    I() && gt && St.push({
      name: "arrow",
      options: {
        element: gt,
        padding: 3
      }
    }), St.push.apply(St, fe?.modifiers || []), y.popperInstance = gde(Vt, x, Object.assign({}, fe, {
      placement: Ee,
      onFirstUpdate: h,
      modifiers: St
    }));
  }
  function He() {
    y.popperInstance && (y.popperInstance.destroy(), y.popperInstance = null);
  }
  function de() {
    var U = y.props.appendTo, fe, Ee = A();
    y.props.interactive && U === nue || U === "parent" ? fe = Ee.parentNode : fe = iue(U, [Ee]), fe.contains(x) || fe.appendChild(x), y.state.isMounted = !0, Ae(), process.env.NODE_ENV !== "production" && th(y.props.interactive && U === il.appendTo && Ee.nextElementSibling !== x, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function ce() {
    return RE(x.querySelectorAll("[data-tippy-root]"));
  }
  function ie(U) {
    y.clearDelayTimeouts(), U && F("onTrigger", [y, U]), ue();
    var fe = K(!0), Ee = k(), Me = Ee[0], Pe = Ee[1];
    Pd.isTouch && Me === "hold" && Pe && (fe = Pe), fe ? n = setTimeout(function() {
      y.show();
    }, fe) : y.show();
  }
  function H(U) {
    if (y.clearDelayTimeouts(), F("onUntrigger", [y, U]), !y.state.isVisible) {
      se();
      return;
    }
    if (!(y.props.trigger.indexOf("mouseenter") >= 0 && y.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(U.type) >= 0 && o)) {
      var fe = K(!1);
      fe ? r = setTimeout(function() {
        y.state.isVisible && y.hide();
      }, fe) : s = requestAnimationFrame(function() {
        y.hide();
      });
    }
  }
  function Y() {
    y.state.isEnabled = !0;
  }
  function Z() {
    y.hide(), y.state.isEnabled = !1;
  }
  function Q() {
    clearTimeout(n), clearTimeout(r), cancelAnimationFrame(s);
  }
  function me(U) {
    if (process.env.NODE_ENV !== "production" && th(y.state.isDestroyed, o1("setProps")), !y.state.isDestroyed) {
      F("onBeforeUpdate", [y, U]), j();
      var fe = y.props, Ee = _Y(i, Object.assign({}, fe, fY(U), {
        ignoreAttributes: !0
      }));
      y.props = Ee, ee(), fe.interactiveDebounce !== Ee.interactiveDebounce && (T(), g = uY(Se, Ee.interactiveDebounce)), fe.triggerTarget && !Ee.triggerTarget ? O1(fe.triggerTarget).forEach(function(Me) {
        Me.removeAttribute("aria-expanded");
      }) : Ee.triggerTarget && i.removeAttribute("aria-expanded"), R(), W(), D && D(fe, Ee), y.popperInstance && (Ae(), ce().forEach(function(Me) {
        requestAnimationFrame(Me._tippy.popperInstance.forceUpdate);
      })), F("onAfterUpdate", [y, U]);
    }
  }
  function Le(U) {
    y.setProps({
      content: U
    });
  }
  function xe() {
    process.env.NODE_ENV !== "production" && th(y.state.isDestroyed, o1("show"));
    var U = y.state.isVisible, fe = y.state.isDestroyed, Ee = !y.state.isEnabled, Me = Pd.isTouch && !y.props.touch, Pe = jk(y.props.duration, 0, il.duration);
    if (!(U || fe || Ee || Me) && !A().hasAttribute("disabled") && (F("onShow", [y], !1), y.props.onShow(y) !== !1)) {
      if (y.state.isVisible = !0, I() && (x.style.visibility = "visible"), W(), ue(), y.state.isMounted || (x.style.transition = "none"), I()) {
        var et = O(), gt = et.box, Vt = et.content;
        zk([gt, Vt], 0);
      }
      h = function() {
        var St;
        if (!(!y.state.isVisible || c)) {
          if (c = !0, x.offsetHeight, x.style.transition = y.props.moveTransition, I() && y.props.animation) {
            var Ht = O(), fn = Ht.box, xn = Ht.content;
            zk([fn, xn], Pe), gY([fn, xn], "visible");
          }
          q(), R(), hY(Gk, y), (St = y.popperInstance) == null || St.forceUpdate(), F("onMount", [y]), y.props.animation && I() && oe(Pe, function() {
            y.state.isShown = !0, F("onShown", [y]);
          });
        }
      }, de();
    }
  }
  function Ue() {
    process.env.NODE_ENV !== "production" && th(y.state.isDestroyed, o1("hide"));
    var U = !y.state.isVisible, fe = y.state.isDestroyed, Ee = !y.state.isEnabled, Me = jk(y.props.duration, 1, il.duration);
    if (!(U || fe || Ee) && (F("onHide", [y], !1), y.props.onHide(y) !== !1)) {
      if (y.state.isVisible = !1, y.state.isShown = !1, c = !1, o = !1, I() && (x.style.visibility = "hidden"), T(), se(), W(!0), I()) {
        var Pe = O(), et = Pe.box, gt = Pe.content;
        y.props.animation && (zk([et, gt], Me), gY([et, gt], "hidden"));
      }
      q(), R(), y.props.animation ? I() && le(Me, y.unmount) : y.unmount();
    }
  }
  function je(U) {
    process.env.NODE_ENV !== "production" && th(y.state.isDestroyed, o1("hideWithInteractivity")), P().addEventListener("mousemove", g), hY(Ax, g), g(U);
  }
  function Ze() {
    process.env.NODE_ENV !== "production" && th(y.state.isDestroyed, o1("unmount")), y.state.isVisible && y.hide(), y.state.isMounted && (He(), ce().forEach(function(U) {
      U._tippy.unmount();
    }), x.parentNode && x.parentNode.removeChild(x), Gk = Gk.filter(function(U) {
      return U !== y;
    }), y.state.isMounted = !1, F("onHidden", [y]));
  }
  function _e() {
    process.env.NODE_ENV !== "production" && th(y.state.isDestroyed, o1("destroy")), !y.state.isDestroyed && (y.clearDelayTimeouts(), y.unmount(), j(), delete i._tippy, y.state.isDestroyed = !0, F("onDestroy", [y]));
  }
}
function gS(i, e) {
  e === void 0 && (e = {});
  var t = il.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (i5e(i), lue(e, t)), J4e();
  var n = Object.assign({}, e, {
    plugins: t
  }), r = K4e(i);
  if (process.env.NODE_ENV !== "production") {
    var s = J8(n.content), o = r.length > 1;
    th(s && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = r.reduce(function(l, c) {
    var d = c && c5e(c, n);
    return d && l.push(d), l;
  }, []);
  return J8(i) ? a[0] : a;
}
gS.defaultProps = il;
gS.setDefaultProps = o5e;
gS.currentInput = Pd;
Object.assign({}, dj, {
  effect: function(e) {
    var t = e.state, n = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow);
  }
});
gS.setDefaultProps({
  animation: !1
});
function cue(i, e) {
  if (i == null) return {};
  var t = {}, n = Object.keys(i), r, s;
  for (s = 0; s < n.length; s++)
    r = n[s], !(e.indexOf(r) >= 0) && (t[r] = i[r]);
  return t;
}
var due = typeof window < "u" && typeof document < "u";
function eR(i, e) {
  i && (typeof i == "function" && i(e), {}.hasOwnProperty.call(i, "current") && (i.current = e));
}
function CY() {
  return due && document.createElement("div");
}
function d5e(i) {
  var e = {
    "data-placement": i.placement
  };
  return i.referenceHidden && (e["data-reference-hidden"] = ""), i.escaped && (e["data-escaped"] = ""), e;
}
function uue(i, e) {
  if (i === e)
    return !0;
  if (typeof i == "object" && i != null && typeof e == "object" && e != null) {
    if (Object.keys(i).length !== Object.keys(e).length)
      return !1;
    for (var t in i)
      if (e.hasOwnProperty(t)) {
        if (!uue(i[t], e[t]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function u5e(i) {
  var e = [];
  return i.forEach(function(t) {
    e.find(function(n) {
      return uue(t, n);
    }) || e.push(t);
  }), e;
}
function h5e(i, e) {
  var t, n;
  return Object.assign({}, e, {
    popperOptions: Object.assign({}, i.popperOptions, e.popperOptions, {
      modifiers: u5e([].concat(((t = i.popperOptions) == null ? void 0 : t.modifiers) || [], ((n = e.popperOptions) == null ? void 0 : n.modifiers) || []))
    })
  });
}
var qk = due ? aA : $e;
function f5e(i) {
  var e = Nt();
  return e.current || (e.current = typeof i == "function" ? i() : i), e.current;
}
function yY(i, e, t) {
  t.split(/\s+/).forEach(function(n) {
    n && i.classList[e](n);
  });
}
var g5e = {
  name: "className",
  defaultValue: "",
  fn: function(e) {
    var t = e.popper.firstElementChild, n = function() {
      var a;
      return !!((a = e.props.render) != null && a.$$tippy);
    };
    function r() {
      if (e.props.className && !n()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      yY(t, "add", e.props.className);
    }
    function s() {
      n() && yY(t, "remove", e.props.className);
    }
    return {
      onCreate: r,
      onBeforeUpdate: s,
      onAfterUpdate: r
    };
  }
};
function p5e(i) {
  function e(t) {
    var n = t.children, r = t.content, s = t.visible, o = t.singleton, a = t.render, l = t.reference, c = t.disabled, d = c === void 0 ? !1 : c, u = t.ignoreAttributes, h = u === void 0 ? !0 : u;
    t.__source, t.__self;
    var f = cue(t, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), g = s !== void 0, p = o !== void 0, m = Oe(!1), _ = m[0], b = m[1], w = Oe({}), y = w[0], S = w[1], x = Oe(), D = x[0], E = x[1], L = f5e(function() {
      return {
        container: CY(),
        renders: 1
      };
    }), k = Object.assign({
      ignoreAttributes: h
    }, f, {
      content: L.container
    });
    g && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(P) {
      k[P] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + P + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), k.trigger = "manual", k.hideOnClick = !1), p && (d = !0);
    var N = k, I = k.plugins || [];
    a && (N = Object.assign({}, k, {
      plugins: p && o.data != null ? [].concat(I, [{
        fn: function() {
          return {
            onTrigger: function(K, W) {
              var F = o.data.children.find(function(q) {
                var R = q.instance;
                return R.reference === W.currentTarget;
              });
              K.state.$$activeSingletonInstance = F.instance, E(F.content);
            }
          };
        }
      }]) : I,
      render: function() {
        return {
          popper: L.container
        };
      }
    }));
    var A = [l].concat(n ? [n.type] : []);
    return qk(function() {
      var P = l;
      l && l.hasOwnProperty("current") && (P = l.current);
      var O = i(P || L.ref || CY(), Object.assign({}, N, {
        plugins: [g5e].concat(k.plugins || [])
      }));
      return L.instance = O, d && O.disable(), s && O.show(), p && o.hook({
        instance: O,
        content: r,
        props: N,
        setSingletonContent: E
      }), b(!0), function() {
        O.destroy(), o?.cleanup(O);
      };
    }, A), qk(function() {
      var P;
      if (L.renders === 1) {
        L.renders++;
        return;
      }
      var O = L.instance;
      O.setProps(h5e(O.props, N)), (P = O.popperInstance) == null || P.forceUpdate(), d ? O.disable() : O.enable(), g && (s ? O.show() : O.hide()), p && o.hook({
        instance: O,
        content: r,
        props: N,
        setSingletonContent: E
      });
    }), qk(function() {
      var P;
      if (a) {
        var O = L.instance;
        O.setProps({
          popperOptions: Object.assign({}, O.props.popperOptions, {
            modifiers: [].concat((((P = O.props.popperOptions) == null ? void 0 : P.modifiers) || []).filter(function(K) {
              var W = K.name;
              return W !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(W) {
                var F, q = W.state, R = (F = q.modifiersData) == null ? void 0 : F.hide;
                (y.placement !== q.placement || y.referenceHidden !== R?.isReferenceHidden || y.escaped !== R?.hasPopperEscaped) && S({
                  placement: q.placement,
                  referenceHidden: R?.isReferenceHidden,
                  escaped: R?.hasPopperEscaped
                }), q.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [y.placement, y.referenceHidden, y.escaped].concat(A)), /* @__PURE__ */ it.createElement(it.Fragment, null, n ? /* @__PURE__ */ nd(n, {
      ref: function(O) {
        L.ref = O, eR(n.ref, O);
      }
    }) : null, _ && /* @__PURE__ */ kW(a ? a(d5e(y), D, L.instance) : r, L.container));
  }
  return e;
}
var m5e = function(i, e) {
  return /* @__PURE__ */ tS(function(n, r) {
    var s = n.children, o = cue(n, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ it.createElement(i, Object.assign({}, e, o), s ? /* @__PURE__ */ nd(s, {
        ref: function(l) {
          eR(r, l), eR(s.ref, l);
        }
      }) : null)
    );
  });
}, v5e = /* @__PURE__ */ m5e(/* @__PURE__ */ p5e(gS), {
  render: function() {
    return "";
  }
});
const FA = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("g", { transform: "translate(2.667 2.667)" }, /* @__PURE__ */ G.createElement("rect", { width: 26.667, height: 26.667, className: "fill-color", fill: "#596168", rx: 13.333 }), /* @__PURE__ */ G.createElement("path", { fill: "#FFF", fillRule: "nonzero", d: "M8.62 8.62c.52-.521 1.364-.521 1.885 0l2.828 2.827 2.829-2.828a1.334 1.334 0 0 1 1.777-.097l.108.097c.521.521.521 1.365 0 1.886l-2.828 2.828 2.828 2.829c.486.486.519 1.254.098 1.777l-.098.108c-.52.521-1.365.521-1.885 0l-2.83-2.828-2.827 2.828a1.334 1.334 0 0 1-1.777.098l-.109-.098a1.333 1.333 0 0 1 0-1.885l2.828-2.83-2.828-2.827a1.334 1.334 0 0 1-.097-1.777z" })))), _5e = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28", width: 24, height: 24, ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(2 2)" }, /* @__PURE__ */ G.createElement("rect", { width: 20, height: 20, fill: "#B1B7BC", rx: 10 }), /* @__PURE__ */ G.createElement("path", { fill: "#FFF", fillRule: "nonzero", d: "M6.464 6.464a1 1 0 0 1 1.415 0l2.12 2.12 2.122-2.12a1 1 0 0 1 1.32-.083l.095.083a1 1 0 0 1 0 1.415l-2.122 2.12 2.122 2.122a1 1 0 0 1 .083 1.32l-.083.095a1 1 0 0 1-1.415 0L10 11.414l-2.121 2.122a1 1 0 0 1-1.32.083l-.095-.083a1 1 0 0 1 0-1.415L8.584 10l-2.12-2.121a1 1 0 0 1-.083-1.32z" }))), BA = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { stroke: "#06C", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M3.898 12.564l4.95 4.95L19.455 6.906" }))), b5e = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 21, viewBox: "0 0 20 21", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { fill: "#FDE7E7", stroke: "#F33E3E", strokeLinejoin: "round", strokeWidth: 2, d: "M10 1.667C5.4 1.667 1.667 5.4 1.667 10S5.4 18.333 10 18.333 18.333 14.6 18.333 10 14.6 1.667 10 1.667z" }), /* @__PURE__ */ G.createElement("path", { fill: "#F33E3E", d: "M10 10.833c.46 0 .833-.373.833-.833V6.667c0-.46-.373-.834-.833-.834-.46 0-.833.373-.833.834V10c0 .46.373.833.833.833zm0 3.334c.46 0 .833-.373.833-.834 0-.46-.373-.833-.833-.833-.46 0-.833.373-.833.833 0 .46.373.834.833.834z" })));
let cb = class extends nS {
  render() {
    const e = `${this.props.rootClassName ? this.props.rootClassName : ""}`;
    return /* @__PURE__ */ v.jsxs("label", { className: `dc__position-rel flex left cursor ${e}`, onClick: this.props?.onClick, children: [
      /* @__PURE__ */ v.jsx(
        "input",
        {
          ...this.props.name ? { name: this.props.name } : {},
          type: "checkbox",
          className: "form__checkbox",
          disabled: this.props.disabled,
          value: this.props.value,
          onChange: this.props.onChange,
          tabIndex: this.props.tabIndex,
          checked: this.props.isChecked,
          id: this.props.id,
          "data-testid": this.props.dataTestId
        }
      ),
      /* @__PURE__ */ v.jsx("span", { className: "form__checkbox-container", "data-testid": `${this.props.dataTestId}-chk-span` }),
      /* @__PURE__ */ v.jsx("span", { className: "form__checkbox-label", children: this.props.children })
    ] });
  }
};
const hue = (i) => {
  const { selectOption: e, data: t, isDisabled: n, showTippy: r, tippyPlacement: s } = i, o = (c) => {
    e(t);
  }, a = () => /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `flex left pl-12 cursor dc__gap-8 ${n ? "dc__disabled" : ""}`,
      style: { background: i.isFocused ? "var(--N100)" : "transparent" },
      children: [
        /* @__PURE__ */ v.jsx(
          cb,
          {
            isChecked: i.isSelected || !1,
            onChange: o,
            value: Aa.CHECKED,
            rootClassName: "mb-0 w-20",
            disabled: n || !1
          }
        ),
        /* @__PURE__ */ v.jsx(zi.Option, { ...i })
      ]
    }
  ), l = (c) => {
    const d = s === "left" || s === "right" ? s : "auto";
    return /* @__PURE__ */ v.jsx(
      wn,
      {
        content: t.label,
        className: "default-tt dc__mxw-200 dc__word-break",
        placement: d,
        arrow: !1,
        children: c
      }
    );
  };
  return /* @__PURE__ */ v.jsx(lc, { condition: r, wrap: l, children: a() });
}, Tbt = (i) => {
  const { selectOption: e, data: t } = i, n = { height: "16px", width: "16px", flex: "0 0 16px" }, r = (s) => e(t);
  return /* @__PURE__ */ v.jsxs("div", { className: "flex left pl-12", style: { background: i.isFocused ? "var(--N100)" : "transparent" }, children: [
    i.isSelected ? /* @__PURE__ */ v.jsx(BA, { onClick: r, className: "mr-8 icon-dim-16", style: n }) : /* @__PURE__ */ v.jsx("span", { onClick: r, className: "mr-8", style: n }),
    /* @__PURE__ */ v.jsx(zi.Option, { ...i })
  ] });
}, Nbt = (i) => {
  const { children: e, data: t, innerProps: n, selectProps: r } = i, { label: s, value: o } = t;
  return /* @__PURE__ */ v.jsxs(zi.MultiValueContainer, { data: t, innerProps: n, selectProps: r, children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex fs-12 ml-4 cn-9", children: s }),
    e[1]
  ] });
}, Pbt = (i) => {
  const { children: e, data: t, innerProps: n, selectProps: r } = i, s = r.value?.length ?? 0;
  return /* @__PURE__ */ v.jsxs(zi.MultiValueContainer, { data: t, innerProps: n, selectProps: r, children: [
    (!r.menuIsOpen || !r.inputValue) && /* @__PURE__ */ v.jsxs("span", { className: "cn-9 fs-13 lh-20", children: [
      r.placeholder,
      s > 0 && /* @__PURE__ */ v.jsx("span", { className: "bcb-5 cn-0 fw-6 fs-12 br-8 ml-4 pr-8 pl-8", children: s })
    ] }),
    e[1]
  ] });
}, C5e = (i) => {
  const {
    children: e = /* @__PURE__ */ v.jsx(_5e, { className: "icon-dim-24" }),
    getStyles: t,
    innerProps: { ref: n, ...r }
  } = i;
  return /* @__PURE__ */ v.jsx("div", { ...r, ref: n, style: t("clearIndicator", i), children: /* @__PURE__ */ v.jsx("div", { className: "flex pointer", children: e }) });
}, Obt = (i) => {
  const {
    data: e,
    innerProps: { onClick: t, onMouseDown: n }
  } = i;
  return /* @__PURE__ */ v.jsx(zi.MultiValueRemove, { ...i, children: /* @__PURE__ */ v.jsx(
    FA,
    {
      onClick: t,
      onMouseDown: n,
      onClick: (r) => t(e),
      className: "icon-n5",
      style: { height: "14px", width: "14px" }
    }
  ) });
}, Mbt = ({ validator: i, isAllSelected: e = !1, ...t }) => {
  const { children: n, data: r, innerProps: s, selectProps: o } = t, { label: a, value: l } = r, c = i ? i(l) : !0;
  return e && l !== "*" ? null : /* @__PURE__ */ v.jsxs(zi.MultiValueContainer, { data: r, innerProps: s, selectProps: o, children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex left fs-12 pl-4 pr-4 dc__ellipsis-right", children: [
      !c && /* @__PURE__ */ v.jsx(b5e, { className: "mr-4 icon-dim-16 dc__no-shrink" }),
      /* @__PURE__ */ v.jsx("div", { className: `dc__ellipsis-right ${c ? "cn-9" : "cr-5"}`, children: a })
    ] }),
    n[1]
  ] });
}, fue = {
  control: (i, e) => ({
    ...i,
    cursor: e.isDisabled ? "not-allowed" : "normal",
    border: e.isFocused ? "1px solid #06c" : "1px solid #d6dbdf",
    boxShadow: "none"
  }),
  menu: (i, e) => ({
    ...i
  }),
  option: (i, e) => ({
    ...i,
    backgroundColor: e.isFocused ? "var(--N100)" : "white",
    color: "var(--N900)",
    padding: "8px 12px"
  }),
  container: (i, e) => ({
    ...i,
    cursor: e.isDisabled ? "not-allowed" : "pointer"
  }),
  valueContainer: (i, e) => ({
    ...i,
    color: e.selectProps.menuIsOpen ? "var(--N500)" : i.color
  })
}, Rbt = (i) => /* @__PURE__ */ v.jsx(Ba, { ...i }), Kk = {
  APPLICATION: "Application",
  ENVIRONMENT: "Environment",
  PIPELINE: "Pipeline"
}, y5e = {
  ...fue,
  control: (i) => ({
    ...i,
    minHeight: "36px",
    fontWeight: "400",
    backgroundColor: "var(--N50)",
    cursor: "pointer"
  }),
  dropdownIndicator: (i) => ({
    ...i,
    padding: "0 8px"
  }),
  menuPortal: (i) => ({ ...i, zIndex: 9999 })
}, w5e = "Not Configured", S5e = "--", fr = {
  SUCCEEDED: "succeeded",
  HEALTHY: "healthy",
  RUNNING: "running",
  PROGRESSING: "progressing",
  STARTING: "starting",
  INITIATING: "initiating",
  QUEUED: "queued",
  FAILED: "failed",
  ERROR: "error",
  CANCELLED: "cancelled",
  UNABLE_TO_FETCH: "unabletofetch",
  TIMED_OUT: "timedout"
}, kx = {
  MESSAGE: "message",
  START_OF_STREAM: "START_OF_STREAM",
  END_OF_STREAM: "END_OF_STREAM",
  ERROR: "error"
}, Yk = {
  PENDING: "Pending"
}, x5e = "1", D5e = "/resource-browser/1/devtron-ci/pod/k8sEmptyGroup", E5e = "devtron-ci", Tx = 3, wY = "deployment-status", L5e = ["KIND", "NAME", "SYNC STATUS", "MESSAGE"], SY = "STAGE_INFO", I5e = "|";
var ir = /* @__PURE__ */ ((i) => (i.CI = "CI", i.CD = "CD", i.GROUP_CI = "GROUP_CI", i.GROUP_CD = "GROUP_CD", i))(ir || {}), Yf = /* @__PURE__ */ ((i) => (i.SUCCESS = "SUCCESS", i.FETCHING = "FETCHING", i.SUSPEND = "SUSPEND", i))(Yf || {});
const A5e = {
  [fr.SUCCEEDED]: "cg-5",
  [fr.HEALTHY]: "cg-5",
  [fr.FAILED]: "cr-5",
  [fr.CANCELLED]: "cr-5",
  [fr.ERROR]: "cr-5"
}, k5e = {
  [fr.RUNNING]: "running",
  [fr.PROGRESSING]: "progressing",
  [fr.STARTING]: "starting",
  [fr.INITIATING]: "initiating",
  [fr.QUEUED]: "queued"
};
var no = /* @__PURE__ */ ((i) => (i.Degraded = "degraded", i.Healthy = "healthy", i.Progressing = "progressing", i.Missing = "missing", i.Suspended = "suspended", i.Unknown = "unknown", i))(no || {});
const xY = {
  missing: 1,
  degraded: 2,
  progressing: 3,
  healthy: 4
};
var xv = /* @__PURE__ */ ((i) => (i.SUCCESS = "Success", i.FAILURE = "Failure", i.PROGRESSING = "Progressing", i))(xv || {});
const T5e = /* @__PURE__ */ new Set(["error", "healthy", "succeeded", "cancelled", "failed", "aborted"]), N5e = /* @__PURE__ */ new Set(["starting", "running", "pending"]), P5e = ({ callback: i, hasError: e }) => {
  const t = Nt(null), n = EAe(t, {
    rootMargin: "0px",
    once: !1
  });
  return $e(() => {
    n && i();
  }, [n]), e ? /* @__PURE__ */ v.jsx("div", { className: "p-24 flex", children: /* @__PURE__ */ v.jsx(ob, { reload: i }) }) : /* @__PURE__ */ v.jsx("span", { className: "pb-5", ref: t });
}, gue = P5e, pue = (i) => /* @__PURE__ */ G.createElement("svg", { width: 18, height: 16, viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M17.25 8H0.75M0.75 8L7.5 1.25M0.75 8L7.5 14.75", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), mue = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 16 16", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M15.2064 6.95138C15.1695 6.92099 14.8352 6.66706 14.1179 6.66706C13.9324 6.66706 13.7403 6.68551 13.5547 6.71698C13.4191 5.7707 12.6334 5.31275 12.6019 5.28888L12.4098 5.1771L12.2861 5.35616C12.132 5.59707 12.0138 5.86945 11.9465 6.14726C11.8162 6.68551 11.8966 7.19229 12.1689 7.62528C11.8412 7.81084 11.3095 7.85425 11.1977 7.86076H2.4153C2.18632 7.86076 2.00076 8.04633 2.00076 8.2753C1.98882 9.04253 2.11796 9.80867 2.38383 10.5325C2.68659 11.3236 3.13803 11.9118 3.71969 12.2699C4.37514 12.6714 5.44513 12.9004 6.65077 12.9004C7.19445 12.9004 7.73921 12.8504 8.27746 12.7517C9.02624 12.616 9.74355 12.3556 10.4044 11.979C10.9492 11.6632 11.4375 11.2617 11.8521 10.7918C12.5509 10.0062 12.9655 9.12826 13.2682 8.3491C13.3116 8.3491 13.3485 8.3491 13.3919 8.3491C14.1527 8.3491 14.6225 8.04633 14.8819 7.78589C15.0555 7.62528 15.1847 7.42669 15.278 7.20423L15.3333 7.04362L15.2064 6.95138ZM9.77068 7.60683H10.9459C11.0013 7.60683 11.0512 7.56342 11.0512 7.50157V6.45002C11.0512 6.39468 11.0078 6.34476 10.9459 6.34476H9.77068C9.71533 6.34476 9.66542 6.38817 9.66542 6.45002V7.50157C9.67193 7.56342 9.71533 7.60683 9.77068 7.60683ZM8.13205 4.59544H9.3073C9.36265 4.59544 9.41257 4.55204 9.41257 4.49018V3.43864C9.41257 3.38329 9.36265 3.33337 9.3073 3.33337H8.13205C8.07671 3.33337 8.02679 3.37678 8.02679 3.43864V4.49018C8.02679 4.54552 8.07562 4.59544 8.13205 4.59544ZM8.13205 6.10385H9.3073C9.36265 6.10385 9.41257 6.05393 9.41257 5.99859V4.94704C9.41257 4.8917 9.36265 4.84178 9.3073 4.84178H8.13205C8.07671 4.84178 8.02679 4.88519 8.02679 4.94704V5.99859C8.02679 6.05502 8.07562 6.10385 8.13205 6.10385ZM6.50536 6.10385H7.68061C7.73596 6.10385 7.78588 6.05393 7.78588 5.99859V4.94704C7.78588 4.8917 7.74247 4.84178 7.68061 4.84178H6.50536C6.45001 4.84178 6.40009 4.88519 6.40009 4.94704V5.99859C6.40009 6.05502 6.4435 6.10385 6.50536 6.10385ZM4.85371 6.10385H6.02896C6.08431 6.10385 6.13423 6.05393 6.13423 5.99859V4.94704C6.13423 4.8917 6.09082 4.84178 6.02896 4.84178H4.85371C4.79836 4.84178 4.74844 4.88519 4.74844 4.94704V5.99859C4.75496 6.05502 4.79836 6.10385 4.85371 6.10385ZM8.13205 7.60683H9.3073C9.36265 7.60683 9.41257 7.56342 9.41257 7.50157V6.45002C9.41257 6.39468 9.36916 6.34476 9.3073 6.34476H8.13205C8.07671 6.34476 8.02679 6.38817 8.02679 6.45002V7.50157C8.02679 7.56342 8.07562 7.60683 8.13205 7.60683ZM6.50536 7.60683H7.68061C7.73596 7.60683 7.78588 7.56342 7.78588 7.50157V6.45002C7.78588 6.39468 7.74247 6.34476 7.68061 6.34476H6.50536C6.45001 6.34476 6.40009 6.38817 6.40009 6.45002V7.50157C6.40009 7.56342 6.4435 7.60683 6.50536 7.60683ZM4.85371 7.60683H6.02896C6.08431 7.60683 6.13423 7.56342 6.13423 7.50157V6.45002C6.13423 6.39468 6.09082 6.34476 6.02896 6.34476H4.85371C4.79836 6.34476 4.74844 6.38817 4.74844 6.45002V7.50157C4.75496 7.56342 4.79836 7.60683 4.85371 7.60683ZM3.23353 7.60683H4.40878C4.46413 7.60683 4.51404 7.56342 4.51404 7.50157V6.45002C4.51404 6.39468 4.47064 6.34476 4.40878 6.34476H3.23353C3.17818 6.34476 3.12826 6.38817 3.12826 6.45002V7.50157C3.13478 7.56342 3.17818 7.60683 3.23353 7.60683Z", fill: "#0091E2" })), O5e = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2016%2016'%20fill='none'%3e%3cpath%20d='M15.2064%206.95138C15.1695%206.92099%2014.8352%206.66706%2014.1179%206.66706C13.9324%206.66706%2013.7403%206.68551%2013.5547%206.71698C13.4191%205.7707%2012.6334%205.31275%2012.6019%205.28888L12.4098%205.1771L12.2861%205.35616C12.132%205.59707%2012.0138%205.86945%2011.9465%206.14726C11.8162%206.68551%2011.8966%207.19229%2012.1689%207.62528C11.8412%207.81084%2011.3095%207.85425%2011.1977%207.86076H2.4153C2.18632%207.86076%202.00076%208.04633%202.00076%208.2753C1.98882%209.04253%202.11796%209.80867%202.38383%2010.5325C2.68659%2011.3236%203.13803%2011.9118%203.71969%2012.2699C4.37514%2012.6714%205.44513%2012.9004%206.65077%2012.9004C7.19445%2012.9004%207.73921%2012.8504%208.27746%2012.7517C9.02624%2012.616%209.74355%2012.3556%2010.4044%2011.979C10.9492%2011.6632%2011.4375%2011.2617%2011.8521%2010.7918C12.5509%2010.0062%2012.9655%209.12826%2013.2682%208.3491C13.3116%208.3491%2013.3485%208.3491%2013.3919%208.3491C14.1527%208.3491%2014.6225%208.04633%2014.8819%207.78589C15.0555%207.62528%2015.1847%207.42669%2015.278%207.20423L15.3333%207.04362L15.2064%206.95138ZM9.77068%207.60683H10.9459C11.0013%207.60683%2011.0512%207.56342%2011.0512%207.50157V6.45002C11.0512%206.39468%2011.0078%206.34476%2010.9459%206.34476H9.77068C9.71533%206.34476%209.66542%206.38817%209.66542%206.45002V7.50157C9.67193%207.56342%209.71533%207.60683%209.77068%207.60683ZM8.13205%204.59544H9.3073C9.36265%204.59544%209.41257%204.55204%209.41257%204.49018V3.43864C9.41257%203.38329%209.36265%203.33337%209.3073%203.33337H8.13205C8.07671%203.33337%208.02679%203.37678%208.02679%203.43864V4.49018C8.02679%204.54552%208.07562%204.59544%208.13205%204.59544ZM8.13205%206.10385H9.3073C9.36265%206.10385%209.41257%206.05393%209.41257%205.99859V4.94704C9.41257%204.8917%209.36265%204.84178%209.3073%204.84178H8.13205C8.07671%204.84178%208.02679%204.88519%208.02679%204.94704V5.99859C8.02679%206.05502%208.07562%206.10385%208.13205%206.10385ZM6.50536%206.10385H7.68061C7.73596%206.10385%207.78588%206.05393%207.78588%205.99859V4.94704C7.78588%204.8917%207.74247%204.84178%207.68061%204.84178H6.50536C6.45001%204.84178%206.40009%204.88519%206.40009%204.94704V5.99859C6.40009%206.05502%206.4435%206.10385%206.50536%206.10385ZM4.85371%206.10385H6.02896C6.08431%206.10385%206.13423%206.05393%206.13423%205.99859V4.94704C6.13423%204.8917%206.09082%204.84178%206.02896%204.84178H4.85371C4.79836%204.84178%204.74844%204.88519%204.74844%204.94704V5.99859C4.75496%206.05502%204.79836%206.10385%204.85371%206.10385ZM8.13205%207.60683H9.3073C9.36265%207.60683%209.41257%207.56342%209.41257%207.50157V6.45002C9.41257%206.39468%209.36916%206.34476%209.3073%206.34476H8.13205C8.07671%206.34476%208.02679%206.38817%208.02679%206.45002V7.50157C8.02679%207.56342%208.07562%207.60683%208.13205%207.60683ZM6.50536%207.60683H7.68061C7.73596%207.60683%207.78588%207.56342%207.78588%207.50157V6.45002C7.78588%206.39468%207.74247%206.34476%207.68061%206.34476H6.50536C6.45001%206.34476%206.40009%206.38817%206.40009%206.45002V7.50157C6.40009%207.56342%206.4435%207.60683%206.50536%207.60683ZM4.85371%207.60683H6.02896C6.08431%207.60683%206.13423%207.56342%206.13423%207.50157V6.45002C6.13423%206.39468%206.09082%206.34476%206.02896%206.34476H4.85371C4.79836%206.34476%204.74844%206.38817%204.74844%206.45002V7.50157C4.75496%207.56342%204.79836%207.60683%204.85371%207.60683ZM3.23353%207.60683H4.40878C4.46413%207.60683%204.51404%207.56342%204.51404%207.50157V6.45002C4.51404%206.39468%204.47064%206.34476%204.40878%206.34476H3.23353C3.17818%206.34476%203.12826%206.38817%203.12826%206.45002V7.50157C3.13478%207.56342%203.17818%207.60683%203.23353%207.60683Z'%20fill='%230091E2'/%3e%3c/svg%3e", DY = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M4.25 9.4999L3.5 9.49988V9.4999H4.25ZM5.74997 7.99995L5.74997 8.74995H5.74998L5.74997 7.99995ZM10.25 7.99986L10.25 7.24986H10.25L10.25 7.99986ZM11.75 6.49992L12.5 6.49993V6.49992H11.75ZM5.25 11.7499C5.25 12.3022 4.80228 12.7499 4.25 12.7499V14.2499C5.63071 14.2499 6.75 13.1306 6.75 11.7499H5.25ZM4.25 12.7499C3.69772 12.7499 3.25 12.3022 3.25 11.7499H1.75C1.75 13.1306 2.86929 14.2499 4.25 14.2499V12.7499ZM3.25 11.7499C3.25 11.1976 3.69772 10.7499 4.25 10.7499V9.24991C2.86929 9.24991 1.75 10.3692 1.75 11.7499H3.25ZM4.25 10.7499C4.80228 10.7499 5.25 11.1976 5.25 11.7499H6.75C6.75 10.3692 5.63071 9.24991 4.25 9.24991V10.7499ZM12.75 4.24976C12.75 4.80204 12.3023 5.24976 11.75 5.24976V6.74976C13.1307 6.74976 14.25 5.63047 14.25 4.24976H12.75ZM11.75 5.24976C11.1977 5.24976 10.75 4.80204 10.75 4.24976H9.25C9.25 5.63047 10.3693 6.74976 11.75 6.74976V5.24976ZM10.75 4.24976C10.75 3.69747 11.1977 3.24976 11.75 3.24976V1.74976C10.3693 1.74976 9.25 2.86904 9.25 4.24976H10.75ZM11.75 3.24976C12.3023 3.24976 12.75 3.69747 12.75 4.24976H14.25C14.25 2.86904 13.1307 1.74976 11.75 1.74976V3.24976ZM5.25 4.24976C5.25 4.80204 4.80228 5.24976 4.25 5.24976V6.74976C5.63071 6.74976 6.75 5.63047 6.75 4.24976H5.25ZM4.25 5.24976C3.69772 5.24976 3.25 4.80204 3.25 4.24976H1.75C1.75 5.63047 2.86929 6.74976 4.25 6.74976V5.24976ZM3.25 4.24976C3.25 3.69747 3.69772 3.24976 4.25 3.24976V1.74976C2.86929 1.74976 1.75 2.86904 1.75 4.24976H3.25ZM4.25 3.24976C4.80228 3.24976 5.25 3.69747 5.25 4.24976H6.75C6.75 2.86904 5.63071 1.74976 4.25 1.74976V3.24976ZM5 9.99991V9.4999H3.5V9.99991H5ZM5 9.49991C5 9.30101 5.07902 9.11026 5.21967 8.96961L4.15902 7.90894C3.73707 8.33088 3.50001 8.90316 3.5 9.49988L5 9.49991ZM5.21967 8.96961C5.36031 8.82897 5.55107 8.74995 5.74997 8.74995L5.74997 7.24995C5.15325 7.24996 4.58097 7.487 4.15902 7.90894L5.21967 8.96961ZM5.74998 8.74995L10.25 8.74986L10.25 7.24986L5.74995 7.24995L5.74998 8.74995ZM10.25 8.74986C10.8468 8.74986 11.419 8.51282 11.841 8.09087L10.7803 7.03021C10.6397 7.17085 10.4489 7.24986 10.25 7.24986L10.25 8.74986ZM11.841 8.09087C12.2629 7.66893 12.5 7.09666 12.5 6.49993L11 6.49991C11 6.69881 10.921 6.88956 10.7803 7.03021L11.841 8.09087ZM12.5 6.49992V5.99976H11V6.49992H12.5ZM3.5 5.99976V9.99991H5V5.99976H3.5Z", fill: "#000A14" })), M5e = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.25%209.4999L3.5%209.49988V9.4999H4.25ZM5.74997%207.99995L5.74997%208.74995H5.74998L5.74997%207.99995ZM10.25%207.99986L10.25%207.24986H10.25L10.25%207.99986ZM11.75%206.49992L12.5%206.49993V6.49992H11.75ZM5.25%2011.7499C5.25%2012.3022%204.80228%2012.7499%204.25%2012.7499V14.2499C5.63071%2014.2499%206.75%2013.1306%206.75%2011.7499H5.25ZM4.25%2012.7499C3.69772%2012.7499%203.25%2012.3022%203.25%2011.7499H1.75C1.75%2013.1306%202.86929%2014.2499%204.25%2014.2499V12.7499ZM3.25%2011.7499C3.25%2011.1976%203.69772%2010.7499%204.25%2010.7499V9.24991C2.86929%209.24991%201.75%2010.3692%201.75%2011.7499H3.25ZM4.25%2010.7499C4.80228%2010.7499%205.25%2011.1976%205.25%2011.7499H6.75C6.75%2010.3692%205.63071%209.24991%204.25%209.24991V10.7499ZM12.75%204.24976C12.75%204.80204%2012.3023%205.24976%2011.75%205.24976V6.74976C13.1307%206.74976%2014.25%205.63047%2014.25%204.24976H12.75ZM11.75%205.24976C11.1977%205.24976%2010.75%204.80204%2010.75%204.24976H9.25C9.25%205.63047%2010.3693%206.74976%2011.75%206.74976V5.24976ZM10.75%204.24976C10.75%203.69747%2011.1977%203.24976%2011.75%203.24976V1.74976C10.3693%201.74976%209.25%202.86904%209.25%204.24976H10.75ZM11.75%203.24976C12.3023%203.24976%2012.75%203.69747%2012.75%204.24976H14.25C14.25%202.86904%2013.1307%201.74976%2011.75%201.74976V3.24976ZM5.25%204.24976C5.25%204.80204%204.80228%205.24976%204.25%205.24976V6.74976C5.63071%206.74976%206.75%205.63047%206.75%204.24976H5.25ZM4.25%205.24976C3.69772%205.24976%203.25%204.80204%203.25%204.24976H1.75C1.75%205.63047%202.86929%206.74976%204.25%206.74976V5.24976ZM3.25%204.24976C3.25%203.69747%203.69772%203.24976%204.25%203.24976V1.74976C2.86929%201.74976%201.75%202.86904%201.75%204.24976H3.25ZM4.25%203.24976C4.80228%203.24976%205.25%203.69747%205.25%204.24976H6.75C6.75%202.86904%205.63071%201.74976%204.25%201.74976V3.24976ZM5%209.99991V9.4999H3.5V9.99991H5ZM5%209.49991C5%209.30101%205.07902%209.11026%205.21967%208.96961L4.15902%207.90894C3.73707%208.33088%203.50001%208.90316%203.5%209.49988L5%209.49991ZM5.21967%208.96961C5.36031%208.82897%205.55107%208.74995%205.74997%208.74995L5.74997%207.24995C5.15325%207.24996%204.58097%207.487%204.15902%207.90894L5.21967%208.96961ZM5.74998%208.74995L10.25%208.74986L10.25%207.24986L5.74995%207.24995L5.74998%208.74995ZM10.25%208.74986C10.8468%208.74986%2011.419%208.51282%2011.841%208.09087L10.7803%207.03021C10.6397%207.17085%2010.4489%207.24986%2010.25%207.24986L10.25%208.74986ZM11.841%208.09087C12.2629%207.66893%2012.5%207.09666%2012.5%206.49993L11%206.49991C11%206.69881%2010.921%206.88956%2010.7803%207.03021L11.841%208.09087ZM12.5%206.49992V5.99976H11V6.49992H12.5ZM3.5%205.99976V9.99991H5V5.99976H3.5Z'%20fill='%23000A14'/%3e%3c/svg%3e", VA = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("g", { fill: "#06C" }, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("path", { d: "M10 1.667c4.6 0 8.333 3.733 8.333 8.333S14.6 18.333 10 18.333 1.667 14.6 1.667 10 5.4 1.667 10 1.667zm0 1.666C6.32 3.333 3.333 6.32 3.333 10c0 3.68 2.987 6.667 6.667 6.667 3.68 0 6.667-2.987 6.667-6.667 0-3.68-2.987-6.667-6.667-6.667zm0 5.834c.46 0 .833.373.833.833v3.333c0 .46-.373.834-.833.834-.46 0-.833-.373-.833-.834V10c0-.46.373-.833.833-.833zm0-3.334c.46 0 .833.373.833.834 0 .46-.373.833-.833.833-.46 0-.833-.373-.833-.833 0-.46.373-.834.833-.834z", transform: "translate(-315.000000, -313.000000) translate(303.000000, 256.000000) translate(4.000000, 49.000000) translate(8.000000, 8.000000)" }))))))), R5e = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20width='12'%20height='12'%20viewBox='0%200%2012%2012'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.04838%207.80842V5.49799L5.14528%206.66418L4.47437%205.49544L6.46036%204.40865L4.47437%203.30572L5.14869%202.15829L7.04838%203.31934V1H8.40426V3.31934L10.3215%202.15829L11%203.30572L9.00508%204.40865L11%205.49544L10.3188%206.6695L8.40426%205.49799V7.80842H7.04838ZM3.83541%209.55818C3.83541%208.47087%202.65025%207.78762%201.70725%208.33127C0.764249%208.87492%200.76425%2010.2414%201.70725%2010.7851C2.65025%2011.3287%203.83541%2010.6455%203.83541%209.55818Z'%20fill='%23596168'/%3e%3c/svg%3e", F5e = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M13.125 9.375V5.3125C13.125 4.8981 13.2896 4.50067 13.5826 4.20765C13.8757 3.91462 14.2731 3.75 14.6875 3.75C15.1019 3.75 15.4993 3.91462 15.7923 4.20765C16.0854 4.50067 16.25 4.8981 16.25 5.3125V11.875C16.25 12.6958 16.0883 13.5085 15.7742 14.2668C15.4602 15.0251 14.9998 15.7141 14.4194 16.2944C13.839 16.8748 13.1501 17.3352 12.3918 17.6492C11.6335 17.9633 10.8208 18.125 10 18.125C6.54822 18.125 5 16.25 2.45558 10.8818C2.35278 10.704 2.28601 10.5078 2.25909 10.3043C2.23216 10.1008 2.24561 9.89393 2.29866 9.6956C2.35171 9.49728 2.44333 9.31135 2.56828 9.14845C2.69322 8.98555 2.84904 8.84886 3.02684 8.74621C3.20464 8.64356 3.40092 8.57696 3.60447 8.5502C3.80802 8.52345 4.01484 8.53707 4.21313 8.59029C4.41141 8.64351 4.59726 8.73528 4.76006 8.86036C4.92285 8.98544 5.05941 9.14138 5.16191 9.31926L6.875 12.2864V4.0625C6.875 3.6481 7.03962 3.25067 7.33264 2.95765C7.62567 2.66462 8.0231 2.5 8.4375 2.5C8.8519 2.5 9.24932 2.66462 9.54235 2.95765C9.83538 3.25067 10 3.6481 10 4.0625V9.375", fill: "#F33E3E", fillOpacity: 0.12 }), /* @__PURE__ */ G.createElement("path", { d: "M13.125 9.375V2.8125C13.125 2.3981 12.9604 2.00067 12.6674 1.70765C12.3743 1.41462 11.9769 1.25 11.5625 1.25C11.1481 1.25 10.7507 1.41462 10.4576 1.70765C10.1646 2.00067 10 2.3981 10 2.8125V9.375", fill: "#F33E3E", fillOpacity: 0.12 }), /* @__PURE__ */ G.createElement("path", { d: "M13.125 9.375V5.3125C13.125 4.8981 13.2896 4.50067 13.5826 4.20765C13.8757 3.91462 14.2731 3.75 14.6875 3.75C15.1019 3.75 15.4993 3.91462 15.7924 4.20765C16.0854 4.50067 16.25 4.8981 16.25 5.3125V11.875C16.25 12.6958 16.0883 13.5085 15.7742 14.2668C15.4602 15.0251 14.9998 15.7141 14.4194 16.2944C13.839 16.8748 13.1501 17.3352 12.3918 17.6492C11.6335 17.9633 10.8208 18.125 10 18.125C6.54822 18.125 5 16.25 2.45558 10.8818C2.35278 10.704 2.28601 10.5078 2.25909 10.3043C2.23216 10.1008 2.24561 9.89393 2.29866 9.6956C2.35171 9.49728 2.44333 9.31135 2.56828 9.14845C2.69322 8.98555 2.84904 8.84886 3.02684 8.74621C3.20464 8.64356 3.40092 8.57696 3.60447 8.5502C3.80802 8.52345 4.01484 8.53707 4.21313 8.59029C4.41141 8.64351 4.59726 8.73528 4.76006 8.86036C4.92285 8.98544 5.05941 9.14138 5.16191 9.31926L6.875 12.2864V4.0625C6.875 3.6481 7.03962 3.25067 7.33264 2.95765C7.62567 2.66462 8.0231 2.5 8.4375 2.5C8.8519 2.5 9.24932 2.66462 9.54235 2.95765C9.83538 3.25067 10 3.6481 10 4.0625V9.375V2.8125C10 2.3981 10.1646 2.00067 10.4576 1.70765C10.7507 1.41462 11.1481 1.25 11.5625 1.25C11.9769 1.25 12.3743 1.41462 12.6674 1.70765C12.9604 2.00067 13.125 2.3981 13.125 2.8125V9.375Z", stroke: "#F33E3E", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), B5e = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { stroke: "#B1B7BC", strokeLinecap: "round", className: "stroke-color", strokeLinejoin: "round", strokeWidth: 2, d: "M3.898 12.564l4.95 4.95L19.455 6.906" }))), V5e = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("g", { fill: "#F33E3E" }, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("path", { d: "M13.463 1.678c.776.104 1.173 1.03.71 1.648-.104.137-.808.867-1.563 1.623-.756.749-1.375 1.394-1.375 1.433 0 .085 2.163 2.248 2.248 2.248.032 0 .749-.684 1.596-1.525 1.31-1.31 1.564-1.53 1.779-1.57.847-.156 1.505.593 1.219 1.382-.04.097-.763.873-1.603 1.713l-1.525 1.532.462.456c.502.488.646.742.646 1.107 0 .352-.118.522-.906 1.304-.398.39-.723.742-.723.782 0 .032.794.86 1.765 1.837l1.773 1.772-.04.28c-.071.541-.605.802-1.055.515-.104-.067-1.82-1.765-4.064-4.005l-.526-.526-.27-.269-.549-.55-1.129-1.13-.574-.576-.288-.29-.577-.578c-3.65-3.666-7.18-7.237-7.205-7.317-.066-.234.02-.56.189-.723.189-.176.553-.241.755-.137.079.046.88.828 1.78 1.733L6.04 5.51l.821-.814c.678-.665.867-.815 1.069-.854.43-.085.736.059 1.29.6l.495.482 1.454-1.5c1.576-1.628 1.811-1.81 2.293-1.745zm-9.52 12.79l.723.724.724.723-.743.789c-.417.443-.821.814-.932.853-.254.085-.547.078-.788-.026-.274-.117-.541-.45-.593-.736-.085-.437.078-.723.873-1.557l.736-.77zm.495-6.457l3.728 3.714 3.727 3.715-.183.078c-.573.234-1.896.378-2.626.28-2.28-.287-4.098-1.799-4.789-3.975-.32-.997-.293-2.548.059-3.558l.084-.254z", transform: "translate(-84 -224) translate(64 186) translate(0 32) translate(20 6)" }))))))), H5e = (i) => /* @__PURE__ */ G.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M3 12C3 7.02944 7.02944 3 12 3", stroke: "#F33E3E", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeDasharray: "2 3" }), /* @__PURE__ */ G.createElement("path", { d: "M12 6.75V12L15 16", stroke: "#F33E3E", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3", stroke: "#F33E3E", strokeWidth: 1.5, strokeMiterlimit: 10 })), vue = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", ...i }, /* @__PURE__ */ G.createElement("g", { clipPath: "url(#clip0_2382_27793)" }, /* @__PURE__ */ G.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.00016 1.75016C4.10067 1.75016 1.75016 4.10067 1.75016 7.00016C1.75016 9.89966 4.10067 12.2502 7.00016 12.2502C9.89966 12.2502 12.2502 9.89966 12.2502 7.00016C12.2502 4.10067 9.89966 1.75016 7.00016 1.75016ZM0.583496 7.00016C0.583496 3.45634 3.45634 0.583496 7.00016 0.583496C10.544 0.583496 13.4168 3.45634 13.4168 7.00016C13.4168 10.544 10.544 13.4168 7.00016 13.4168C3.45634 13.4168 0.583496 10.544 0.583496 7.00016Z", fill: "#FFB549" }), /* @__PURE__ */ G.createElement("path", { d: "M4.94656 9.83432C5.39385 10.1584 5.91148 10.372 6.45713 10.4576C7.00278 10.5433 7.56096 10.4986 8.08603 10.3272C8.61111 10.1559 9.08816 9.86263 9.4782 9.47154C9.86823 9.08046 10.1602 8.60262 10.3301 8.07708C10.5001 7.55155 10.5433 6.99325 10.4562 6.44783C10.369 5.90241 10.154 5.38536 9.82879 4.93895C9.50354 4.49253 9.07724 4.12944 8.58477 3.87934C8.0923 3.62925 7.54763 3.49926 6.99529 3.5L7 7L4.94656 9.83432Z", fill: "#8C6324" }))), W5e = ({
  appId: i,
  envId: e,
  releaseId: t,
  showCurrentReleaseDeployments: n
}) => {
  const r = [
    `${Io.devtronApplication}|id|${i}`,
    `environment|id|${e}`
  ];
  return n && r.push(`${Io.release}|id|${t}`), r;
}, j5e = (i) => ({
  cdWorkflows: (i.cdWorkflows || []).map((t) => ({
    ...t,
    triggerId: t?.cd_workflow_id,
    podStatus: t?.pod_status,
    startedOn: t?.started_on,
    finishedOn: t?.finished_on,
    pipelineId: t?.pipeline_id,
    logLocation: t?.log_file_path,
    triggeredBy: t?.triggered_by,
    artifact: t?.image,
    triggeredByEmail: t?.email_id,
    stage: t?.workflow_type,
    image: t?.image,
    imageComment: t?.imageComment,
    imageReleaseTags: t?.imageReleaseTags,
    artifactId: t?.ci_artifact_id,
    runSource: t?.runSource
  })),
  appReleaseTagNames: i.appReleaseTagNames,
  tagsEditable: i.tagsEditable,
  hideImageTaggingHardDelete: i.hideImageTaggingHardDelete
}), EY = (i, e, t) => {
  const n = [];
  return Object.keys(e).forEach((r) => {
    const s = t.find((o) => o.id == r);
    n.push({ name: s ? s.name : "", value: e[r] });
  }), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs("span", { children: [
      " ",
      i,
      " Filters "
    ] }),
    /* @__PURE__ */ v.jsx("br", {}),
    /* @__PURE__ */ v.jsx("ul", { className: "m-0", children: n.map((r, s) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ v.jsxs("li", { children: [
        r.name,
        " : ",
        r.value
      ] }, s)
    )) })
  ] });
}, LY = (i) => {
  switch (i) {
    case "success":
      return /* @__PURE__ */ v.jsx(B5e, { className: "icon-dim-20 green-tick", "data-testid": "success-green-tick" });
    case "failed":
      return /* @__PURE__ */ v.jsx(A0, { className: "icon-dim-20" });
    case "unknown":
      return /* @__PURE__ */ v.jsx(lb, { className: "icon-dim-20" });
    case "inprogress":
      return /* @__PURE__ */ v.jsx("div", { className: "icon-dim-20", children: /* @__PURE__ */ v.jsx("div", { className: "pulse-highlight" }) });
    case "unreachable":
      return /* @__PURE__ */ v.jsx(Il, { className: "icon-dim-20" });
    case "loading":
      return /* @__PURE__ */ v.jsx("div", { className: "dc__app-summary__icon icon-dim-20 mr-6 progressing progressing--node" });
    case "disconnect":
      return /* @__PURE__ */ v.jsx(V5e, { className: "icon-dim-20" });
    case "time_out":
      return /* @__PURE__ */ v.jsx(H5e, { className: "icon-dim-20" });
    default:
      return /* @__PURE__ */ v.jsx(zde, { className: "icon-dim-20 timer-icon" });
  }
}, z5e = (i) => {
  switch (i) {
    case xv.SUCCESS:
      return /* @__PURE__ */ v.jsx(BA, { className: "dc__no-shrink icon-dim-16 scg-5" });
    case xv.FAILURE:
      return /* @__PURE__ */ v.jsx(Il, { className: "dc__no-shrink icon-dim-16 fcr-5" });
    default:
      return /* @__PURE__ */ v.jsx(vue, { className: "dc__no-shrink icon-dim-16 ic-in-progress-orange" });
  }
}, IY = () => /* @__PURE__ */ v.jsx(F5e, { className: "icon-dim-20 dc__no-shrink" }), AY = () => /* @__PURE__ */ v.jsx(FA, { className: "icon-dim-20 dc__no-shrink ic-error-cross-red" }), kY = () => /* @__PURE__ */ v.jsx(vue, { className: "dc__no-shrink icon-dim-20 ic-in-progress-orange" }), TY = () => /* @__PURE__ */ v.jsx("div", { className: "dc__app-summary__icon dc__no-shrink icon-dim-20 succeeded" }), U5e = (i) => {
  const e = i?.toUpperCase();
  switch (e) {
    case Ot.ABORTED:
      return IY();
    case Ot.DEGRADED:
      return AY();
    case Ot.INPROGRESS:
      return kY();
    case Ot.HEALTHY:
      return TY();
  }
  const t = e?.toLocaleLowerCase();
  switch (t) {
    case fr.CANCELLED:
      return IY();
    case fr.FAILED:
    case fr.ERROR:
      return AY();
    case fr.RUNNING:
    case fr.PROGRESSING:
    case fr.STARTING:
    case fr.INITIATING:
      return kY();
    case fr.SUCCEEDED:
      return TY();
    default:
      return /* @__PURE__ */ v.jsx(
        "div",
        {
          className: `dc__app-summary__icon dc__no-shrink icon-dim-20 ${t.replace(
            /\s+/g,
            ""
          )}`
        }
      );
  }
}, _ue = ({
  sourceType: i,
  sourceValue: e,
  showTooltip: t,
  showIcons: n = !0,
  baseText: r = void 0,
  regex: s,
  isRegex: o,
  primaryBranchAfterRegex: a
}) => {
  const l = i === Ag.WEBHOOK, c = i === Ag.BranchRegex || !!s || o, [d, u] = Oe(""), [h, f] = Oe(""), [g, p] = Oe(!!l), m = () => {
    if (l) {
      const S = JSON.parse(e);
      MY(S.eventId).then((x) => {
        const D = x.result;
        u(D.name), f(
          EY(
            D.name,
            S.condition,
            D.selectors
          )
        ), p(!1);
      }).catch((x) => {
        throw x;
      });
    } else
      u(e), f(e);
  };
  $e(() => {
    m();
  }, [e]);
  const _ = () => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx("div", { className: "fw-6", children: "Regex" }),
      /* @__PURE__ */ v.jsx("p", { children: s })
    ] }),
    window.location.href.includes("trigger") && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx("div", { className: "fw-6", children: "Primary Branch" }),
      /* @__PURE__ */ v.jsx("p", { children: a || "Not set" })
    ] })
  ] });
  function b() {
    if (!l)
      return;
    const S = JSON.parse(e), x = S.eventId, D = S.condition;
    MY(x).then((E) => {
      const L = E.result;
      u(L.name), f(EY(L.name, D, L.selectors)), p(!1);
    }).catch((E) => {
      throw E;
    });
  }
  function w() {
    c && f(_());
  }
  $e(() => {
    b(), w();
  }, []);
  const y = c ? R5e : M5e;
  return /* @__PURE__ */ v.jsxs("div", { className: `flex left ${t ? "branch-name" : ""}`, children: [
    g && n && /* @__PURE__ */ v.jsx("span", { className: "dc__loading-dots", children: "loading" }),
    !g && /* @__PURE__ */ v.jsxs("div", { className: "flex dc__gap-4", children: [
      n && /* @__PURE__ */ v.jsx(
        "img",
        {
          src: l ? WIe : y,
          alt: "branch",
          className: "icon-dim-12"
        }
      ),
      t && /* @__PURE__ */ v.jsx(
        wn,
        {
          className: "default-tt dc__word-break-all",
          arrow: !1,
          placement: "bottom",
          content: h,
          children: /* @__PURE__ */ v.jsxs(
            "div",
            {
              className: "flex left dc__gap-4",
              style: { maxWidth: r ? "auto" : "calc(100% - 15px)" },
              children: [
                !r && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                  /* @__PURE__ */ v.jsx(
                    "div",
                    {
                      className: `dc__ellipsis-right ${e === w5e ? "cr-5" : ""}`,
                      children: d
                    }
                  ),
                  e !== S5e && /* @__PURE__ */ v.jsx(VA, { className: "icon-dim-12 fcn-5" })
                ] }),
                r && /* @__PURE__ */ v.jsx("span", { className: "cursor", style: { borderBottom: "1px solid #3b444c" }, children: r })
              ]
            }
          )
        }
      ),
      !t && /* @__PURE__ */ v.jsx("span", { className: "dc__ellipsis-right", children: h })
    ] })
  ] });
}, G5e = it.memo(
  ({
    status: i,
    startedOn: e,
    triggeredBy: t,
    triggeredByEmail: n,
    ciMaterials: r,
    gitTriggers: s
  }) => /* @__PURE__ */ v.jsxs("div", { className: "build-card-popup p-16 br-4 w-400 bcn-0 mxh-300 dc__overflow-scroll", children: [
    /* @__PURE__ */ v.jsx("span", { className: "fw-6 fs-16 mb-4", style: { color: q8[i.toLowerCase()] }, children: i.toLowerCase() === "cancelled" ? "Aborted" : i }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex column left", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex left fs-12 cn-7", children: [
        /* @__PURE__ */ v.jsx("div", { children: st(e).format(id.TWELVE_HOURS_FORMAT) }),
        /* @__PURE__ */ v.jsx("div", { className: "dc__bullet ml-6 mr-6" }),
        /* @__PURE__ */ v.jsx("div", { children: t === 1 ? "auto trigger" : n })
      ] }),
      Object.keys(s ?? {}).length > 0 && r?.map((o) => {
        const a = s[o.id], l = a?.CiConfigureSourceType ? a.CiConfigureSourceType : o?.type, c = a?.CiConfigureSourceValue ? a.CiConfigureSourceValue : o?.value, d = a?.GitRepoUrl ? a.GitRepoUrl : o?.url;
        return l !== Ag.WEBHOOK && !a ? null : /* @__PURE__ */ v.jsx("div", { className: "mt-22 ci-material-detail", children: l === Ag.WEBHOOK ? /* @__PURE__ */ v.jsx("div", { className: "flex left column", children: /* @__PURE__ */ v.jsx(
          _ue,
          {
            sourceType: l,
            sourceValue: c,
            showTooltip: !1
          }
        ) }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          /* @__PURE__ */ v.jsx("div", { className: "dc__git-logo", children: " " }),
          /* @__PURE__ */ v.jsxs("div", { className: "flex left column", children: [
            /* @__PURE__ */ v.jsxs(
              "a",
              {
                href: wm(d, a.Commit),
                target: "_blank",
                rel: "noopener noreferrer",
                className: "fs-12 fw-6 cn-9 pointer",
                children: [
                  "/",
                  c
                ]
              }
            ),
            /* @__PURE__ */ v.jsx("p", { className: "fs-12 cn-7", children: a?.Message })
          ] })
        ] }) }, o.id);
      })
    ] })
  ] })
), q5e = it.memo(
  ({ handleViewAllHistory: i }) => /* @__PURE__ */ v.jsxs("div", { className: "flex pt-12 pb-12 pl-16 pr-16 dc__gap-16 dc__align-self-stretch", children: [
    /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        "aria-label": "all-history",
        className: "p-0 dc__no-background dc__no-border h-16",
        onClick: i,
        children: /* @__PURE__ */ v.jsx(pue, { width: 16, height: 16 })
      }
    ),
    /* @__PURE__ */ v.jsx("div", { style: { flex: "1 0 0" }, children: /* @__PURE__ */ v.jsx("p", { className: "ci-cd-details__sidebar-typography", children: "View all items in history" }) })
  ] })
), K5e = it.memo(
  ({
    id: i,
    status: e,
    startedOn: t,
    triggeredBy: n,
    triggeredByEmail: r,
    ciMaterials: s,
    gitTriggers: o,
    artifact: a,
    type: l,
    stage: c,
    dataTestId: d,
    renderRunSource: u,
    runSource: h,
    resourceId: f
  }) => {
    const { path: g, params: p } = fd(), { pathname: m } = E0(), _ = m.split("/").pop(), { envId: b, ...w } = eo(), y = l === ir.CD || l === ir.GROUP_CD, S = y ? "triggerId" : "buildId", x = f === h?.id, D = Nt(null), E = () => {
      const I = {
        ...w,
        envId: b,
        [S]: i
      };
      return `${R2(g, I)}/${_}`;
    }, L = () => {
      D?.current && D.current.scrollIntoView({ behavior: "smooth" });
    };
    $e(() => {
      L();
    }, [D]);
    const k = p[S], N = (I) => {
      +k == +i && (D.current = I);
    };
    return /* @__PURE__ */ v.jsx(
      lc,
      {
        condition: Array.isArray(s),
        wrap: (I) => /* @__PURE__ */ v.jsx(
          v5e,
          {
            placement: "right",
            interactive: !0,
            render: () => /* @__PURE__ */ v.jsx(
              G5e,
              {
                status: e,
                startedOn: t,
                triggeredBy: n,
                triggeredByEmail: r,
                ciMaterials: s,
                gitTriggers: o
              }
            ),
            children: I
          }
        ),
        children: /* @__PURE__ */ v.jsx(
          uo,
          {
            to: E,
            className: "w-100 deployment-history-card-container",
            "data-testid": d,
            activeClassName: "active",
            ref: N,
            children: /* @__PURE__ */ v.jsxs("div", { className: "w-100 deployment-history-card", children: [
              U5e(e),
              /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
                /* @__PURE__ */ v.jsxs("div", { className: "flex column left dc__ellipsis-right", children: [
                  /* @__PURE__ */ v.jsx("div", { className: "cn-9 fs-14", children: st(t).format(id.TWELVE_HOURS_FORMAT) }),
                  /* @__PURE__ */ v.jsxs("div", { className: "flex left cn-7 fs-12", children: [
                    y && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                      /* @__PURE__ */ v.jsx("div", { className: "dc__capitalize", children: ["pre", "post"].includes(c?.toLowerCase()) ? `${c}-deploy` : c }),
                      /* @__PURE__ */ v.jsx("span", { className: "dc__bullet dc__bullet--d2 ml-4 mr-4" }),
                      a && /* @__PURE__ */ v.jsxs("div", { className: "dc__app-commit__hash dc__app-commit__hash--no-bg", children: [
                        /* @__PURE__ */ v.jsx(mue, { className: "commit-hash__icon grayscale" }),
                        a.split(":")[1].slice(-12)
                      ] }),
                      /* @__PURE__ */ v.jsx("span", { className: "dc__bullet dc__bullet--d2 ml-4 mr-4" })
                    ] }),
                    /* @__PURE__ */ v.jsx("div", { className: "cn-7 fs-12", children: n === 1 ? "auto trigger" : r })
                  ] })
                ] }),
                h && u && u(h, x)
              ] })
            ] })
          }
        )
      }
    );
  }
), Y5e = it.memo(
  ({
    type: i,
    filterOptions: e,
    triggerHistory: t,
    hasMore: n,
    setPagination: r,
    fetchIdData: s,
    handleViewAllHistory: o,
    children: a,
    renderRunSource: l,
    resourceId: c
  }) => {
    const { pipelineId: d, appId: u, envId: h } = eo(), { push: f } = ip(), { path: g } = fd(), p = (x) => {
      i === ir.CI ? (r({ offset: 0, size: 20 }), f(R2(g, { appId: u, pipelineId: x.value }))) : i === ir.GROUP_CI ? (r({ offset: 0, size: 20 }), f(R2(g, { envId: h, pipelineId: x.pipelineId }))) : i === ir.GROUP_CD ? (r({ offset: 0, size: 20 }), f(R2(g, { envId: h, appId: x.value, pipelineId: x.pipelineId }))) : (r({ offset: 0, size: 20 }), f(R2(g, { appId: u, envId: x.value, pipelineId: x.pipelineId })));
    }, m = () => {
      cA.event({
        category: "pagination",
        action: "scroll",
        label: `${i.toLowerCase()}-history`,
        value: t.size
      }), r({ offset: t.size, size: 20 });
    }, _ = () => i === ir.CI || i === ir.GROUP_CI ? d : i === ir.GROUP_CD ? u : h, b = e?.find((x) => x.value === _()) ?? null;
    e?.sort((x, D) => x.label > D.label ? 1 : -1);
    const w = e?.filter((x) => !x.deploymentAppDeleteRequest), y = () => i === ir.GROUP_CI || i === ir.GROUP_CD ? Kk.APPLICATION : i === ir.CI ? Kk.PIPELINE : Kk.ENVIRONMENT, S = (x) => (x.selectProps.styles.option = Mde(), /* @__PURE__ */ v.jsx(zi.Option, { ...x, children: /* @__PURE__ */ v.jsxs("div", { style: { display: "flex" }, children: [
      (i === ir.CI || i === ir.GROUP_CI) && /* @__PURE__ */ v.jsx(
        "div",
        {
          className: `dc__ci-pipeline-type-icon mr-5 ${x.data.pipelineType?.toLowerCase()}` || ""
        }
      ),
      x.label
    ] }) }));
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      a || /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: "select-pipeline-wrapper w-100 pl-16 pr-16 dc__overflow-hidden",
          style: {
            borderBottom: "1px solid var(--n-100, #EDF1F5)"
          },
          children: [
            /* @__PURE__ */ v.jsxs(
              "label",
              {
                htmlFor: "history-pipeline-selector",
                className: "form__label",
                "data-testid": "select-history-heading",
                children: [
                  "Select ",
                  y()
                ]
              }
            ),
            /* @__PURE__ */ v.jsx(
              Ba,
              {
                classNamePrefix: "history-pipeline-dropdown",
                value: b,
                options: i === ir.CI || i === ir.GROUP_CI ? e : w,
                onChange: p,
                components: {
                  IndicatorSeparator: null,
                  Option: S,
                  DropdownIndicator: uCe
                },
                styles: y5e,
                menuPosition: "fixed",
                inputId: "history-pipeline-selector"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ v.jsxs("div", { className: "flex column top left flex-grow-1 dc__hide-hscroll", style: { overflowY: "auto" }, children: [
        s === Yf.SUCCESS && /* @__PURE__ */ v.jsx(q5e, { handleViewAllHistory: o }),
        Array.from(t).sort(([x], [D]) => D - x).map(([x, D], E) => /* @__PURE__ */ v.jsx(
          K5e,
          {
            dataTestId: `deployment-history-${E}`,
            id: x,
            status: D.status,
            startedOn: D.startedOn,
            triggeredBy: D.triggeredBy,
            triggeredByEmail: D.triggeredByEmail,
            ciMaterials: D.ciMaterials,
            gitTriggers: D.gitTriggers,
            artifact: D.artifact,
            stage: D.stage,
            type: i,
            runSource: D.runSource,
            renderRunSource: l,
            resourceId: c
          },
          x
        )),
        n && (s === Yf.SUSPEND || !s) && /* @__PURE__ */ v.jsx(gue, { callback: m })
      ] })
    ] });
  }
), Fbt = Y5e, X5e = ({ shouldPrompt: i }) => {
  const e = Wi(
    (t) => {
      i && t.preventDefault();
    },
    [i]
  );
  $e(() => (window.addEventListener("beforeunload", e), () => {
    window.removeEventListener("beforeunload", e);
  }), [e]);
}, Bbt = X5e, Z5e = () => {
  const i = `${hn.PROJECT_LIST_MIN}`;
  return Qn(i).then((e) => {
    let t = [];
    return e && e.result && Array.isArray(e.result) && (t = e.result), t = t.sort((n, r) => p1t("name", n, r)), {
      code: e.code,
      status: e.status,
      result: t
    };
  });
}, Q5e = {
  PRECD: "PRE",
  CD: "DEPLOY",
  POSTCD: "POST",
  APPROVAL: "APPROVAL"
}, Ag = {
  BranchFixed: "SOURCE_TYPE_BRANCH_FIXED",
  WEBHOOK: "WEBHOOK",
  BranchRegex: "SOURCE_TYPE_BRANCH_REGEX"
};
function J5e(i) {
  return Qn(`${hn.USER_CHECK_ROLE}${i ? `?appName=${i}` : ""}`);
}
function $5e(i, e, t) {
  return fA(`${hn.IMAGE_TAGGING}/${e}/${t}`, i);
}
const eke = (i, e) => {
  if (!i)
    return null;
  const t = i.approvedUsersData || [], n = i.approvalConfig || e;
  return {
    ...i,
    approvedUsersData: t.map((r) => ({
      ...r,
      userGroups: r.userGroups?.filter((s) => !!s?.identifier && !!s?.name) ?? []
    })),
    approvalConfig: _j(n)
  };
}, tke = ({
  artifacts: i,
  offset: e,
  artifactId: t,
  artifactStatus: n,
  disableDefaultSelection: r,
  userApprovalConfig: s
}) => {
  if (!i || !i.length) return [];
  const o = e === 0, a = e;
  let l = r;
  return i.map((d, u) => {
    let h = "";
    const f = d.filterState ?? fC.ALLOWED;
    t && n && d.id === t && (h = n);
    const g = !l && o && f === fC.ALLOWED ? !d.vulnerable : !1;
    return g && (l = !0), {
      index: a + u,
      id: d.id,
      deployedTime: d.deployed_time ? st(d.deployed_time).format("ddd, DD MMM YYYY, hh:mm A") : "Not Deployed",
      deployedBy: d.deployedBy,
      wfrId: d.wfrId,
      tab: B2.Changes,
      image: FE(d.image),
      showChanges: !1,
      vulnerabilities: [],
      buildTime: d.build_time || "",
      isSelected: g,
      showSourceInfo: !1,
      deployed: d.deployed || !1,
      latest: d.latest || !1,
      vulnerabilitiesLoading: !0,
      scanned: d.scanned,
      scanEnabled: d.scanEnabled,
      vulnerable: d.vulnerable,
      runningOnParentCd: d.runningOnParentCd,
      artifactStatus: h,
      userApprovalMetadata: eke(
        d.userApprovalMetadata,
        s
      ),
      triggeredBy: d.triggeredBy,
      isVirtualEnvironment: d.isVirtualEnvironment,
      imageComment: d.imageComment,
      imageReleaseTags: d.imageReleaseTags,
      // It is going to be null but required in type so can't remove
      lastExecution: d.lastExecution,
      materialInfo: d.material_info ? d.material_info.map((p) => ({
        modifiedTime: p.modifiedTime ? st(p.modifiedTime).format("ddd, DD MMM YYYY, hh:mm A") : "",
        commitLink: wm(p.url, p.revision),
        author: p.author || "",
        message: p.message || "",
        revision: p.revision || "",
        tag: p.tag || "",
        webhookData: p.webhookData || "",
        url: p.url || "",
        branch: (d.ciConfigureSourceType === Ag.WEBHOOK ? d.ciConfigureSourceValue : p.branch) || "",
        type: d.ciConfigureSourceType || ""
      })) : [],
      filterState: f,
      appliedFiltersTimestamp: d.appliedFiltersTimestamp ?? "",
      appliedFilters: d.appliedFilters ?? [],
      appliedFiltersState: d.appliedFiltersState ?? fC.ALLOWED,
      createdTime: d.createdTime ?? "",
      dataSource: d.data_source ?? "",
      registryType: d.registryType ?? "",
      imagePath: d.image ?? "",
      registryName: d.registryName ?? "",
      promotionApprovalMetadata: d.promotionApprovalMetadata,
      deployedOnEnvironments: d.deployedOnEnvironments ?? [],
      deploymentWindowArtifactMetadata: d.deploymentWindowArtifactMetadata ?? null,
      configuredInReleases: d.configuredInReleases ?? [],
      appWorkflowId: d.appWorkflowId ?? null
    };
  });
}, nke = (i) => {
  const e = i.approvalUsers || [], t = _j(i.userApprovalConfig), n = PAe(t), r = i.imageApprovalUsersInfo || {}, s = e.reduce(
    (h, f) => (h[f] = !0, h),
    {}
  ), o = t.specificUsers.identifiers.filter((h) => h.startsWith(gy)).sort(Qs), a = t.specificUsers.identifiers.filter((h) => !h.startsWith(gy) && h !== fy.system).sort(Qs), l = {
    dataStore: t.specificUsers.identifiers.reduce(
      (h, f) => (h[f] = {
        email: f,
        hasAccess: s[f] ?? !1
      }, h),
      {}
    ),
    requiredCount: t.specificUsers.requiredCount,
    emails: a.concat(o)
  }, c = t.userGroups.map((h) => h.identifier), u = e.filter((h) => h !== fy.system).reduce(
    (h, f) => ((r[f] || []).forEach((p) => {
      h[p.identifier] || (h[p.identifier] = {}), h[p.identifier][f] = !0;
    }), h),
    {}
  );
  return {
    isPolicyConfigured: n,
    specificUsersData: l,
    userGroupData: t.userGroups.reduce(
      (h, f) => {
        const g = f.identifier, p = Object.keys(u[g] || {}).sort(Qs);
        return h[g] = {
          dataStore: p.reduce(
            (m, _) => (m[_] = {
              email: _,
              // As of now it will always be true, but UI has handled it in a way that can support false as well
              hasAccess: s[_] ?? !1
            }, m),
            {}
          ),
          requiredCount: f.requiredCount,
          emails: p
        }, h;
      },
      {}
    ),
    // Not sorting since would change them in approval info modal to name
    validGroups: c
  };
}, NY = (i, e) => !i || !e ? {
  approvalUsers: [],
  userApprovalConfig: null,
  canApproverDeploy: e?.canApproverDeploy ?? !1,
  imageApprovalPolicyDetails: null
} : {
  approvalUsers: e.approvalUsers,
  userApprovalConfig: _j(e.userApprovalConfig),
  canApproverDeploy: e.canApproverDeploy ?? !1,
  imageApprovalPolicyDetails: nke(e)
}, ike = (i) => Object.entries(i?.envVariables || {}).map(([e, t], n) => ({ key: e, value: t, id: n })).sort((e, t) => Qs(e.key, t.key)), PY = (i) => i ? {
  appReleaseTagNames: i.appReleaseTagNames ?? [],
  tagsEditable: i.tagsEditable ?? !1,
  hideImageTaggingHardDelete: i.hideImageTaggingHardDelete,
  resourceFilters: i.resourceFilters ?? [],
  totalCount: i.totalCount ?? 0,
  requestedUserId: i.requestedUserId,
  runtimeParams: ike(i.runtimeParams)
} : {
  tagsEditable: !1,
  appReleaseTagNames: [],
  hideImageTaggingHardDelete: !1,
  resourceFilters: [],
  totalCount: 0,
  requestedUserId: 0,
  runtimeParams: []
}, OY = (i) => i ? {
  isApprovalPendingForPromotion: i.isApprovalPendingForPromotion,
  imagePromotionApproverEmails: i.imagePromotionApproverEmails ?? []
} : {
  isApprovalPendingForPromotion: !1,
  imagePromotionApproverEmails: []
}, rke = (i, e, t, n, r) => {
  if (!i)
    return {
      materials: [],
      ...PY(i),
      ...NY(!1, i),
      ...OY(i)
    };
  const s = tke({
    artifacts: i.ci_artifacts,
    offset: t ?? 0,
    artifactId: i.latest_wf_artifact_id,
    artifactStatus: i.latest_wf_artifact_status,
    disableDefaultSelection: r,
    userApprovalConfig: i.userApprovalConfig
  }), o = NY(
    e === c8.CD || e === c8.APPROVAL,
    i
  ), a = PY(i), l = OY(i);
  return {
    materials: n && n === Rle.RESOURCE ? s.filter((d) => d.filterState === fC.ALLOWED) : s,
    ...o,
    ...a,
    ...l
  };
}, ske = (i) => {
  const { filter: e, ...t } = i;
  return t;
}, Vbt = (i, e, t, n, r = {}) => {
  const s = ske(r);
  let o;
  switch (i) {
    case d8.ROLLBACK:
      o = vl(
        `${hn.CD_MATERIAL_GET}/${e}/material/rollback`,
        s
      );
      break;
    case d8.IMAGE_PROMOTION:
      o = vl(hn.APP_ARTIFACT_PROMOTE_MATERIAL, r);
      break;
    default:
      o = vl(`${hn.CD_MATERIAL_GET}/${e}/material`, {
        ...s,
        stage: Q5e[t]
      });
      break;
  }
  return Qn(o, { signal: n }).then(
    (a) => rke(a.result, t, r.offset, r.filter)
  );
};
function FE(i) {
  return i ? i.split(":").pop() : "";
}
function wm(i, e) {
  if (!i || !e)
    return "NA";
  if (i.indexOf("gitlab") > 0 || i.indexOf("github") > 0 || i.indexOf("azure") > 0) {
    const t = i.split("@");
    if (t.length > 1)
      return `https://${t[1].split(".git")[0]}/commit/${e}`;
    if (t.length == 1)
      return `${t[0].split(".git")[0]}/commit/${e}`;
  }
  if (i.indexOf("bitbucket") > 0) {
    const t = i.split("@");
    if (t.length > 1)
      return `https://${t[1].split(".git")[0]}/commits/${e}`;
    if (t.length == 1)
      return `${t[0].split(".git")[0]}/commits/${e}`;
  }
  return "NA";
}
function oke() {
  return Qn(`${hn.DEPLOYMENT_TEMPLATE_LIST}?appId=-1&envId=-1`);
}
const Hbt = () => Qn(`${hn.NOTIFIER}/channel/config`);
function Wbt(i) {
  return Qn(
    `${hn.ENVIRONMENT_LIST_MIN}?auth=false${i ? "&showDeploymentOptions=true" : ""}`
  );
}
function jbt() {
  const i = `${hn.CLUSTER}/autocomplete`;
  return Qn(i);
}
const zbt = (i) => Qn(`${hn.API_RESOURCE}/${hn.GVK}/${i}`);
function Ubt(i) {
  const e = `${hn.NAMESPACE}/autocomplete?ids=${i}`;
  return Qn(e);
}
function MY(i) {
  const e = `${hn.GIT_HOST_EVENT}/${i}`;
  return Qn(e);
}
const ake = async () => {
  const { result: i } = await Qn(hn.APP_LIST_MIN);
  return i ? i.map((e) => ({
    ...e,
    appList: e.appList.sort((t, n) => Qs(t.name, n.name))
  })).sort((e, t) => Qs(e.projectName, t.projectName)) : [];
}, lke = async () => {
  const { result: i } = await Z5e();
  return i ? i.map(({ id: e, name: t }) => ({
    id: e,
    name: t
  })).sort((e, t) => Qs(e.name, t.name)) : [];
}, cke = async () => {
  const { result: i } = await Qn(hn.CLUSTER_LIST_MIN);
  return i ? i.map(({ id: e, cluster_name: t, isVirtualCluster: n }) => ({
    id: e,
    name: t,
    isVirtual: n ?? !1
  })).sort((e, t) => Qs(e.name, t.name)) : [];
}, dke = async () => {
  const { result: i } = await Qn(hn.ENVIRONMENT_LIST_MIN);
  return i ? i.map(
    ({
      id: e,
      environment_name: t,
      isVirtualEnvironment: n,
      cluster_name: r,
      default: s,
      namespace: o
    }) => ({
      id: e,
      name: t,
      isVirtual: n ?? !1,
      cluster: r,
      environmentType: s ? G8.production : G8.nonProduction,
      namespace: o
    })
  ).sort((e, t) => Qs(e.name, t.name)) : [];
}, uke = (i) => i.reduce(
  (e, t) => (e[t] = !0, e),
  {
    [Io.devtronApplication]: !1,
    [Io.project]: !1,
    [Io.cluster]: !1,
    [Io.environment]: !1
  }
), hke = ({
  resourcesToFetch: i
}) => {
  const e = Mn(() => uke(i), [i]), [t, n, r, s] = tf(
    () => Promise.all([
      e[Io.devtronApplication] ? ake() : null,
      e[Io.project] ? lke() : null,
      e[Io.cluster] ? cke() : null,
      e[Io.environment] ? dke() : null
    ]),
    [e],
    i.length > 0
  );
  return {
    isResourcesOptionsLoading: t,
    resourcesOptionsMap: {
      [Io.devtronApplication]: n?.[0] ?? [],
      [Io.project]: n?.[1] ?? [],
      [Io.cluster]: n?.[2] ?? [],
      [Io.environment]: n?.[3] ?? []
    },
    resourcesOptionsError: r,
    refetchResourcesOptions: s
  };
}, Gbt = hke, fke = (i) => fetch(`${CE}/${i}`), gke = () => {
  const [i, e] = Oe(!1);
  return { handleDownload: async ({
    downloadUrl: n,
    showFilePreparingToast: r = !1,
    fileName: s,
    showSuccessfulToast: o = !0,
    downloadSuccessToastContent: a = "Downloaded Successfully"
  }) => {
    e(!0);
    try {
      const l = await fke(n);
      if (l.status === rK.OK) {
        r && In.info(
          /* @__PURE__ */ v.jsx(
            Yle,
            {
              title: "Preparing file for download",
              subtitle: "File will be downloaded when it is available."
            }
          )
        );
        const c = await l.blob(), d = URL.createObjectURL(c), u = document.createElement("a");
        u.href = d, u.download = s || TAe(l.headers) || "file.tgz", document.body.appendChild(u), u.click(), setTimeout(() => {
          URL.revokeObjectURL(d), document.body.removeChild(u);
        }, 0), o && In.success(a);
      } else {
        if (l.status === rK.NO_CONTENT)
          throw new Error("No content to download");
        {
          const c = await l?.json();
          throw new Kc(c);
        }
      }
    } catch (l) {
      return e(!1), Is(l), l;
    }
    return e(!1), null;
  }, isDownloading: i };
}, pke = gke, mke = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { fill: "#959BA1", d: "M20 13a1 1 0 0 1 1 1v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-4a1 1 0 0 1 2 0v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1zm-8-8.5a1 1 0 0 1 1 1v8.085l2.293-2.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L11 13.585V5.5a1 1 0 0 1 .883-.993z" }))), vke = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 250, height: 200, viewBox: "0 0 250 200", ...i }, /* @__PURE__ */ G.createElement("defs", null, /* @__PURE__ */ G.createElement("linearGradient", { id: "prefix__c", x1: "55.01%", x2: "40.976%", y1: "0%", y2: "100%" }, /* @__PURE__ */ G.createElement("stop", { offset: "0%", stopColor: "#2A318C" }), /* @__PURE__ */ G.createElement("stop", { offset: "100%", stopColor: "#1D225F" })), /* @__PURE__ */ G.createElement("linearGradient", { id: "prefix__d", x1: "50%", x2: "50%", y1: "0%", y2: "100%" }, /* @__PURE__ */ G.createElement("stop", { offset: "0%", stopColor: "#EEE" }), /* @__PURE__ */ G.createElement("stop", { offset: "100%", stopColor: "#D6D7D8" })), /* @__PURE__ */ G.createElement("path", { id: "prefix__a", d: "M0 0H250V200H0z" })), /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("mask", { id: "prefix__b", fill: "#fff" }, /* @__PURE__ */ G.createElement("use", { xlinkHref: "#prefix__a" })), /* @__PURE__ */ G.createElement("g", { fill: "#FFF", mask: "url(#prefix__b)" }, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("path", { fillRule: "nonzero", d: "M33.56 183.308c0-.116 1.153-3.288 2.538-7.095l2.538-6.922 6.46-.173 6.403-.173 2.768 2.307c2.308 1.962 12.796 7.547 14.132 8.307.891.506 2.067 1.794 3.526 3.864-25.577-.038-38.365-.077-38.365-.115z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { fillRule: "nonzero", d: "M0 183.308c0-.116 1.154-3.288 2.538-7.095l2.538-6.922 6.46-.173 6.403-.173 2.769 2.307c2.307 1.962 12.795 7.547 14.132 8.307.89.506 2.066 1.794 3.525 3.864C12.788 183.385 0 183.346 0 183.308zM43.655 101.836c1.09 3.158 1.826 5.898 2.208 8.22.38 2.321 2.518 22.155 6.411 59.5H34.296c-1.444-2.618-2.166-4.457-2.166-5.518 0-1.59.913-3.77.913-6.068 0-1.532-2.034-6.823-6.104-15.871l3.931-39.349 12.785-.914z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { d: "M18.554 169.555H1.76c-.4-1.385-.792-3.254-1.175-5.606-.75-4.788-.18-7.96 3.05-14.536 3.23-6.518 4.866-10.072 4.866-13.764.058-5.768 1.222-11.316 4.28-17.315 2.364-4.73 3.495-5.086 3.725-7.97l.42-6.202h21.078c.512 1.433.696 4.075.55 7.925-.145 3.85-6.812 23.006-20.001 57.468z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { fillRule: "nonzero", d: "M63.94 42.818L80.78 21.987 100.971 21.987 83.532 42.818z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { fillRule: "nonzero", d: "M86.14 19.384c1.378 0 2.506 1.07 2.597 2.425l.006.178h-.578c0-1.118-.907-2.025-2.025-2.025-1.119 0-2.026.907-2.026 2.025 0 1.063.819 1.934 1.86 2.019l.166.007v.578c-1.439 0-2.604-1.166-2.604-2.604 0-1.438 1.165-2.603 2.604-2.603zM93.083 19.384c1.378 0 2.506 1.07 2.598 2.425l.006.178h-.579c0-1.118-.907-2.025-2.025-2.025-1.119 0-2.025.907-2.025 2.025 0 1.063.818 1.934 1.859 2.019l.166.007v.578c-1.438 0-2.604-1.166-2.604-2.604 0-1.438 1.166-2.603 2.604-2.603zM62.472 46.829c2.807-.962 5.554-2.299 8.242-4.011h6.871c-2.375 2.17-3.972 3.706-4.791 4.61-.82.903-2.509 2.638-5.068 5.205-1.091 5.781-2.254 8.21-3.487 7.285-1.85-1.386-7.939-10.897-1.767-13.09z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { fillRule: "nonzero", d: "M66.254 52.654c4.363-1.668 7.179-2.857 8.447-3.567 1.5-.865 2.077-1.673 3.807-5.307.23-.461.692-2.365 1.096-4.153.923-4.557 2.423-4.326 2.538.346.058 1.27.346 2.423.692 2.538.288.116 1.961-1.5 3.634-3.576 1.673-2.077 3.288-3.75 3.576-3.75.692 0 .692 5.307-.057 7.153-.289.865-4.73 5.71-9.864 10.844-3.422 3.423-8.431 8.068-15.026 13.937l1.157-14.465zM46.581 27.774c.772-3.086 1.543-5.015 2.315-5.787-1.157-1.157-2.315-2.314-4.63-3.471-.77 1.543-2.314 3.086-4.628 4.629 0 2.314.771 3.857 2.314 4.629 1.543.771 3.086.771 4.63 0z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { fillRule: "nonzero", d: "M17.308 104.98c-2.365-.173-6.23-.98-8.48-1.73l-4.21-1.385-.115-4.326C4.214 85.6 5.08 76.89 7.79 65.757 11.482 50.47 22.096 34.84 34.959 25.668c4.96-3.576 5.075-3.576 6.518-1.153.634 1.153 1.96 2.307 2.884 2.653l2.16.594c-3.045 29.324-1.868 53.63 3.532 72.917-1.157 1.157-1.946 1.682-2.808 2.052-1.039.403-2.365.807-3.057.865-.693.057-3 .519-5.25 1.038-4.21.923-13.382 1.096-21.63.346z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { d: "M62.472 46.829l1.767 11.31-19.972 2.646 1.106-15.653c2.141 1.735 4.344 2.776 6.608 3.123 2.263.348 5.76-.128 10.49-1.426z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { fillRule: "nonzero", d: "M66.254 52.654L71.157 75.8c-.568 1.157-2.01 1.928-4.324 2.314-5.208.579-10.415-1.736-16.78-1.736-6.365 0-6.09 4.05-15.349.579-6.171-2.314-8.679-12.73-7.522-31.245l18.054-1.73c-.078 5.782.655 9.252 2.198 10.409 1.512 1.134 7.569.6 18.17-1.6l.65-.136zM58.305 7.444c1.07 1.52 1.487 3.536 1.252 6.049-.06.656-.375.883-.375 2.052 0 1.12.07 2.506.212 4.157l-2.317.161c-2.223 2.412-4.574 3.48-7.055 3.207-2.481-.275-4.251-1.343-5.311-3.207-2.18-4.023-1.62-7.444 1.676-10.262 3.296-2.818 7.269-3.537 11.918-2.157z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { d: "M47.646 0c2.598 0 5.717 1.017 7.994 2.74 2.276 1.722 3.845 3.02 4.55 5.097.47 1.384.248 3.314-.665 5.791.13-2.345-.047-3.647-.532-3.906-.67 1.653-1.595 1.987-2.703 2.787-.62.448-2.791.518-4.917.897-2.629 1.722-4.303 3.33-4.867 4.86-.448 1.218-.402 2.608.148 4.177l.126.339-.54.21c-.714-1.833-.81-3.478-.277-4.925.522-1.417 1.85-2.838 3.893-4.321-1.088.307-2.05.754-2.633 1.449-1.28 1.526-2.028 3.765-2.246 6.716-2.766-.5-5.305-1.433-7.617-2.8-2.312-1.366-4.445-3.194-6.399-5.483.397-.834.904-1.524 1.522-2.07.671-.592 1.935-1.108 3.169-1.822l-.065.021-1.204.401c-1.26.424-1.956.713-2.396 1.032-.829.601-1.259 1.275-1.312 2.032l-.005.191-.579.007c-.012-1.039.516-1.943 1.557-2.699.427-.31 1.013-.573 1.983-.916l1.755-.59.612-.213c.593-.213 1.063-.401 1.438-.584 1.296-1.399 2.17-3.971 4.089-5.678C43.642.855 45.048 0 47.646 0z", transform: "translate(29 8)" }), /* @__PURE__ */ G.createElement("path", { fillRule: "nonzero", d: "M52.36 13.575c.597-1.64 2.169-2.597 3.535-2.1 1.061.386 1.653 1.524 1.586 2.781.36-.091.688-.137.988-.136l.208.007c.254.02.466.056.636.114.511-1.271 1.708-2.023 2.75-1.644 1.07.39 1.498 1.803 1.012 3.14-.487 1.337-1.723 2.144-2.794 1.754-.953-.347-1.397-1.504-1.14-2.697-.103-.038-.274-.072-.508-.09-.334-.025-.737.029-1.209.165l-.03.01c-.036.159-.083.318-.14.477-.597 1.64-2.17 2.597-3.536 2.1-1.366-.497-1.955-2.241-1.358-3.881zm9.504-.434c-.73-.266-1.664.343-2.052 1.408-.387 1.066-.064 2.132.667 2.398.73.266 1.664-.343 2.052-1.408.388-1.065.064-2.132-.667-2.398zm-6.167-1.122c-1.036-.377-2.297.39-2.793 1.754-.496 1.363-.024 2.762 1.012 3.14 1.036.376 2.298-.392 2.794-1.755s.023-2.762-1.013-3.14z", transform: "translate(29 8)" }))), /* @__PURE__ */ G.createElement("g", { mask: "url(#prefix__b)" }, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("path", { fill: "#80AEF2", fillRule: "nonzero", d: "M33.56 183.308c0-.116 1.153-3.288 2.538-7.095l2.538-6.922 6.46-.173 6.403-.173 2.768 2.307c2.308 1.962 12.796 7.547 14.132 8.307.891.506 2.067 1.794 3.526 3.864-25.577-.038-38.365-.077-38.365-.115z", transform: "translate(32 8)" }), /* @__PURE__ */ G.createElement("path", { fill: "#94BBF8", fillRule: "nonzero", d: "M0 183.308c0-.116 1.154-3.288 2.538-7.095l2.538-6.922 6.46-.173 6.403-.173 2.769 2.307c2.307 1.962 12.795 7.547 14.132 8.307.89.506 2.066 1.794 3.525 3.864C12.788 183.385 0 183.346 0 183.308z", transform: "translate(32 8)" }), /* @__PURE__ */ G.createElement("path", { fill: "#1D225F", fillRule: "nonzero", d: "M43.655 101.836c1.09 3.158 1.826 5.898 2.208 8.22.38 2.321 2.518 22.155 6.411 59.5H34.296c-1.444-2.618-2.166-4.457-2.166-5.518 0-1.59.913-3.77.913-6.068 0-1.532-2.034-6.823-6.104-15.871l3.931-39.349 12.785-.914z", transform: "translate(32 8)" }), /* @__PURE__ */ G.createElement("path", { fill: "url(#prefix__c)", d: "M18.554 169.555H1.76c-.4-1.385-.792-3.254-1.175-5.606-.75-4.788-.18-7.96 3.05-14.536 3.23-6.518 4.866-10.072 4.866-13.764.058-5.768 1.222-11.316 4.28-17.315 2.364-4.73 3.495-5.086 3.725-7.97l.42-6.202h21.078c.512 1.433.696 4.075.55 7.925-.145 3.85-6.812 23.006-20.001 57.468z", transform: "translate(32 8)" }), /* @__PURE__ */ G.createElement("g", { fillRule: "nonzero" }, /* @__PURE__ */ G.createElement("path", { fill: "#98BDF9", d: "M0 24.302L16.84 3.472 37.031 3.472 19.592 24.302z", transform: "translate(32 8) translate(63.94 18.516)" }), /* @__PURE__ */ G.createElement("path", { fill: "#2174DB", d: "M22.2.868c1.378 0 2.506 1.07 2.597 2.425l.006.179h-.578c0-1.119-.907-2.025-2.025-2.025-1.119 0-2.025.906-2.025 2.025 0 1.062.818 1.934 1.859 2.018l.166.007v.578c-1.438 0-2.604-1.165-2.604-2.603 0-1.438 1.166-2.604 2.604-2.604zM29.143.868c1.378 0 2.506 1.07 2.598 2.425l.006.179h-.579c0-1.119-.906-2.025-2.025-2.025-1.118 0-2.025.906-2.025 2.025 0 1.062.818 1.934 1.859 2.018l.166.007v.578c-1.438 0-2.604-1.165-2.604-2.603 0-1.438 1.166-2.604 2.604-2.604z", transform: "translate(32 8) translate(63.94 18.516)" })), /* @__PURE__ */ G.createElement("path", { fill: "#F3A29D", fillRule: "nonzero", d: "M62.472 46.829c2.807-.962 5.554-2.299 8.242-4.011h6.871c-2.375 2.17-3.972 3.706-4.791 4.61-.82.903-2.509 2.638-5.068 5.205-1.091 5.781-2.254 8.21-3.487 7.285-1.85-1.386-7.939-10.897-1.767-13.09z", transform: "translate(32 8)" }), /* @__PURE__ */ G.createElement("path", { fill: "#FAB6AF", fillRule: "nonzero", d: "M66.254 52.654c4.363-1.668 7.179-2.857 8.447-3.567 1.5-.865 2.077-1.673 3.807-5.307.23-.461.692-2.365 1.096-4.153.923-4.557 2.423-4.326 2.538.346.058 1.27.346 2.423.692 2.538.288.116 1.961-1.5 3.634-3.576 1.673-2.077 3.288-3.75 3.576-3.75.692 0 .692 5.307-.057 7.153-.289.865-4.73 5.71-9.864 10.844-3.422 3.423-8.431 8.068-15.026 13.937l1.157-14.465z", transform: "translate(32 8)" }), /* @__PURE__ */ G.createElement("path", { fill: "#F3A29D", fillRule: "nonzero", d: "M46.581 27.774c.772-3.086 1.543-5.015 2.315-5.787-1.157-1.157-2.315-2.314-4.63-3.471-.77 1.543-2.314 3.086-4.628 4.629 0 2.314.771 3.857 2.314 4.629 1.543.771 3.086.771 4.63 0z", transform: "translate(32 8)" }), /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("path", { fill: "url(#prefix__d)", fillRule: "nonzero", d: "M12.858 82.16c-2.365-.174-6.23-.981-8.48-1.731l-4.21-1.385-.115-4.326c-.289-11.94.577-20.65 3.288-31.782C7.032 27.65 17.646 12.019 30.509 2.847c4.96-3.576 5.076-3.576 6.518-1.153.634 1.153 1.96 2.307 2.884 2.653l2.161.594c-3.046 29.324-1.87 53.63 3.531 72.917-1.157 1.158-1.946 1.682-2.808 2.052-1.039.403-2.365.807-3.057.865-.693.058-3 .519-5.25 1.038-4.21.923-13.382 1.096-21.63.346z", transform: "translate(32 8) translate(4.45 22.82)" }), /* @__PURE__ */ G.createElement("path", { fill: "#D6D7D8", d: "M58.022 24.008l1.767 11.311-19.972 2.645 1.106-15.653c2.141 1.735 4.344 2.776 6.608 3.123 2.263.348 5.76-.128 10.49-1.426z", transform: "translate(32 8) translate(4.45 22.82)" }), /* @__PURE__ */ G.createElement("path", { fill: "#E9E9E9", fillRule: "nonzero", d: "M61.804 29.833l4.903 23.145c-.568 1.157-2.01 1.929-4.324 2.314-5.208.579-10.415-1.736-16.78-1.736-6.365 0-6.09 4.05-15.348.58-6.172-2.315-8.68-12.73-7.523-31.246l18.054-1.73c-.078 5.782.655 9.252 2.198 10.409 1.512 1.134 7.569.601 18.17-1.6l.65-.136z", transform: "translate(32 8) translate(4.45 22.82)" })), /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("path", { fill: "#FAB6AF", fillRule: "nonzero", d: "M29.082 7.444c1.07 1.52 1.488 3.536 1.253 6.049-.062.656-.376.883-.376 2.052 0 1.12.07 2.506.212 4.157l-2.317.161c-2.222 2.412-4.574 3.48-7.055 3.207-2.48-.275-4.251-1.343-5.31-3.207-2.18-4.023-1.621-7.444 1.675-10.262 3.296-2.818 7.269-3.537 11.918-2.157z", transform: "translate(32 8) translate(29.223)" }), /* @__PURE__ */ G.createElement("path", { fill: "#E94A47", d: "M18.423 0c2.598 0 5.717 1.017 7.994 2.74 2.277 1.722 3.845 3.02 4.55 5.097.47 1.384.248 3.314-.664 5.791.13-2.345-.048-3.647-.533-3.906-.67 1.653-1.595 1.987-2.703 2.787-.62.448-2.791.518-4.917.897-2.628 1.722-4.303 3.33-4.867 4.86-.448 1.218-.402 2.608.148 4.177l.126.339-.54.21c-.714-1.833-.81-3.478-.277-4.925.522-1.417 1.85-2.838 3.894-4.321-1.09.307-2.051.754-2.634 1.449-1.279 1.526-2.028 3.765-2.246 6.716-2.766-.5-5.305-1.433-7.617-2.8-2.312-1.366-4.445-3.194-6.398-5.483.396-.834.904-1.524 1.521-2.07.671-.592 1.935-1.108 3.169-1.822l-.065.021-1.204.401c-1.26.424-1.956.713-2.395 1.032-.83.601-1.26 1.275-1.313 2.032l-.005.191-.579.007c-.012-1.039.516-1.943 1.557-2.699.427-.31 1.013-.573 1.983-.916l1.756-.59.61-.213c.594-.213 1.064-.401 1.439-.584 1.296-1.399 2.17-3.971 4.09-5.678C14.418.855 15.825 0 18.422 0z", transform: "translate(32 8) translate(29.223)" }), /* @__PURE__ */ G.createElement("path", { fill: "#222768", fillRule: "nonzero", d: "M23.137 13.575c.597-1.64 2.17-2.597 3.535-2.1 1.061.386 1.654 1.524 1.586 2.781.36-.091.689-.137.988-.136l.208.007c.255.02.466.056.636.114.512-1.271 1.708-2.023 2.75-1.644 1.07.39 1.498 1.803 1.012 3.14-.487 1.337-1.723 2.144-2.794 1.754-.953-.347-1.397-1.504-1.14-2.697-.103-.038-.274-.072-.508-.09-.334-.025-.737.029-1.208.165l-.031.01c-.036.159-.083.318-.14.477-.597 1.64-2.17 2.597-3.536 2.1-1.366-.497-1.955-2.241-1.358-3.881zm9.504-.434c-.73-.266-1.664.343-2.052 1.408-.387 1.066-.064 2.132.667 2.398.731.266 1.664-.343 2.052-1.408.388-1.065.064-2.132-.667-2.398zm-6.167-1.122c-1.036-.377-2.297.39-2.793 1.754-.496 1.363-.024 2.762 1.012 3.14 1.036.376 2.298-.392 2.794-1.755s.023-2.762-1.013-3.14z", transform: "translate(32 8) translate(29.223)" })))), /* @__PURE__ */ G.createElement("path", { fill: "#222768", fillRule: "nonzero", d: "M153.265 114.963c-.449-.4-.897-2.243-1.097-4.187-.399-3.938-.698-4.486-3.589-6.031l-2.093-1.147-3.788 1.545c-2.094.848-4.087 1.446-4.436 1.296-.947-.349-6.78-10.716-6.78-12.012 0-.698 1.048-1.894 3.24-3.589l3.24-2.542V82.813l-3.24-2.542c-2.043-1.595-3.24-2.89-3.24-3.539 0-1.047 5.085-10.417 6.331-11.663.598-.549 1.196-.499 4.037.598 4.736 1.844 5.085 1.894 7.627.249 2.243-1.446 2.292-1.545 2.641-4.636.648-5.931-.15-5.383 8.075-5.383 8.324 0 7.776-.349 8.424 5.533l.349 3.24 2.592 1.395 2.592 1.396 3.19-1.296c4.037-1.645 5.183-1.645 6.38.1 2.093 3.04 5.582 9.57 5.582 10.467 0 .648-1.196 1.894-3.24 3.39l-3.19 2.442v2.99l-.05 2.991 3.24 2.443c2.044 1.545 3.24 2.79 3.24 3.389 0 1.047-5.582 10.916-6.679 11.813-.548.449-1.645.2-4.586-.997l-3.937-1.545-2.542 1.396-2.542 1.395-.599 3.988c-.348 2.691-.847 4.237-1.395 4.685-1.296.947-12.81.848-13.757-.15zm11.414-19.639c6.58-2.99 8.374-11.265 3.639-16.698-6.28-7.128-17.844-3.29-18.792 6.23-.398 4.287 2.991 9.371 7.377 11.066 1.595.598 5.832.3 7.776-.598z", mask: "url(#prefix__b)" }, /* @__PURE__ */ G.createElement("animateTransform", { attributeName: "transform", attributeType: "XML", dur: "2s", from: "0 160 86", repeatCount: "indefinite", to: "360 160 86", type: "rotate" })), /* @__PURE__ */ G.createElement("path", { fill: "#E94A47", fillRule: "nonzero", d: "M175.745 146.115c-1.845-1.146-3.49-2.243-3.64-2.442-.149-.25.2-1.545.749-2.841.996-2.293.996-2.443.15-4.038-.699-1.345-1.197-1.644-3.141-1.894-3.639-.498-3.49-.249-3.49-5.433v-4.735l1.895-.299c3.589-.598 3.838-.698 4.785-2.243.897-1.545.847-1.595-.15-4.037-.598-1.346-.947-2.692-.797-2.891.299-.549 7.128-4.536 7.726-4.536.249 0 1.296.997 2.342 2.243 1.446 1.744 2.194 2.243 3.39 2.243 1.196 0 1.944-.499 3.39-2.243 1.046-1.246 2.093-2.243 2.342-2.243.598 0 7.427 3.987 7.726 4.536.15.2-.2 1.545-.748 2.89-.997 2.293-1.047 2.543-.299 3.988.798 1.496 1.196 1.695 4.935 2.293l1.844.3v4.734c0 5.184.15 4.935-3.49 5.433-1.893.25-2.442.549-3.14 1.894-.797 1.546-.797 1.695.15 4.187l.997 2.592-1.396.947c-2.542 1.745-6.03 3.589-6.729 3.589-.448 0-1.445-.947-2.292-2.044-1.247-1.744-1.795-2.093-3.29-2.143-1.495-.05-1.944.25-3.34 2.094-.847 1.146-1.944 2.093-2.342 2.093-.449 0-2.293-.897-4.137-1.994zm13.109-10.716c4.486-2.343 4.486-9.371-.1-11.813-5.832-3.14-12.212 3.19-9.171 9.121 1.595 3.09 6.03 4.337 9.27 2.692z", mask: "url(#prefix__b)" }, /* @__PURE__ */ G.createElement("animateTransform", { attributeName: "transform", attributeType: "XML", dur: "2s", from: "360 185 130", repeatCount: "indefinite", to: "0 185 130", type: "rotate" })))), _ke = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='250'%20height='200'%20viewBox='0%200%20250%20200'%3e%3cdefs%3e%3clinearGradient%20id='prefix__c'%20x1='55.01%25'%20x2='40.976%25'%20y1='0%25'%20y2='100%25'%3e%3cstop%20offset='0%25'%20stop-color='%232A318C'/%3e%3cstop%20offset='100%25'%20stop-color='%231D225F'/%3e%3c/linearGradient%3e%3clinearGradient%20id='prefix__d'%20x1='50%25'%20x2='50%25'%20y1='0%25'%20y2='100%25'%3e%3cstop%20offset='0%25'%20stop-color='%23EEE'/%3e%3cstop%20offset='100%25'%20stop-color='%23D6D7D8'/%3e%3c/linearGradient%3e%3cpath%20id='prefix__a'%20d='M0%200H250V200H0z'/%3e%3c/defs%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cmask%20id='prefix__b'%20fill='%23fff'%3e%3cuse%20xlink:href='%23prefix__a'/%3e%3c/mask%3e%3cg%20fill='%23FFF'%20mask='url(%23prefix__b)'%3e%3cg%3e%3cpath%20fill-rule='nonzero'%20d='M33.56%20183.308c0-.116%201.153-3.288%202.538-7.095l2.538-6.922%206.46-.173%206.403-.173%202.768%202.307c2.308%201.962%2012.796%207.547%2014.132%208.307.891.506%202.067%201.794%203.526%203.864-25.577-.038-38.365-.077-38.365-.115z'%20transform='translate(29%208)'/%3e%3cpath%20fill-rule='nonzero'%20d='M0%20183.308c0-.116%201.154-3.288%202.538-7.095l2.538-6.922%206.46-.173%206.403-.173%202.769%202.307c2.307%201.962%2012.795%207.547%2014.132%208.307.89.506%202.066%201.794%203.525%203.864C12.788%20183.385%200%20183.346%200%20183.308zM43.655%20101.836c1.09%203.158%201.826%205.898%202.208%208.22.38%202.321%202.518%2022.155%206.411%2059.5H34.296c-1.444-2.618-2.166-4.457-2.166-5.518%200-1.59.913-3.77.913-6.068%200-1.532-2.034-6.823-6.104-15.871l3.931-39.349%2012.785-.914z'%20transform='translate(29%208)'/%3e%3cpath%20d='M18.554%20169.555H1.76c-.4-1.385-.792-3.254-1.175-5.606-.75-4.788-.18-7.96%203.05-14.536%203.23-6.518%204.866-10.072%204.866-13.764.058-5.768%201.222-11.316%204.28-17.315%202.364-4.73%203.495-5.086%203.725-7.97l.42-6.202h21.078c.512%201.433.696%204.075.55%207.925-.145%203.85-6.812%2023.006-20.001%2057.468z'%20transform='translate(29%208)'/%3e%3cpath%20fill-rule='nonzero'%20d='M63.94%2042.818L80.78%2021.987%20100.971%2021.987%2083.532%2042.818z'%20transform='translate(29%208)'/%3e%3cpath%20fill-rule='nonzero'%20d='M86.14%2019.384c1.378%200%202.506%201.07%202.597%202.425l.006.178h-.578c0-1.118-.907-2.025-2.025-2.025-1.119%200-2.026.907-2.026%202.025%200%201.063.819%201.934%201.86%202.019l.166.007v.578c-1.439%200-2.604-1.166-2.604-2.604%200-1.438%201.165-2.603%202.604-2.603zM93.083%2019.384c1.378%200%202.506%201.07%202.598%202.425l.006.178h-.579c0-1.118-.907-2.025-2.025-2.025-1.119%200-2.025.907-2.025%202.025%200%201.063.818%201.934%201.859%202.019l.166.007v.578c-1.438%200-2.604-1.166-2.604-2.604%200-1.438%201.166-2.603%202.604-2.603zM62.472%2046.829c2.807-.962%205.554-2.299%208.242-4.011h6.871c-2.375%202.17-3.972%203.706-4.791%204.61-.82.903-2.509%202.638-5.068%205.205-1.091%205.781-2.254%208.21-3.487%207.285-1.85-1.386-7.939-10.897-1.767-13.09z'%20transform='translate(29%208)'/%3e%3cpath%20fill-rule='nonzero'%20d='M66.254%2052.654c4.363-1.668%207.179-2.857%208.447-3.567%201.5-.865%202.077-1.673%203.807-5.307.23-.461.692-2.365%201.096-4.153.923-4.557%202.423-4.326%202.538.346.058%201.27.346%202.423.692%202.538.288.116%201.961-1.5%203.634-3.576%201.673-2.077%203.288-3.75%203.576-3.75.692%200%20.692%205.307-.057%207.153-.289.865-4.73%205.71-9.864%2010.844-3.422%203.423-8.431%208.068-15.026%2013.937l1.157-14.465zM46.581%2027.774c.772-3.086%201.543-5.015%202.315-5.787-1.157-1.157-2.315-2.314-4.63-3.471-.77%201.543-2.314%203.086-4.628%204.629%200%202.314.771%203.857%202.314%204.629%201.543.771%203.086.771%204.63%200z'%20transform='translate(29%208)'/%3e%3cpath%20fill-rule='nonzero'%20d='M17.308%20104.98c-2.365-.173-6.23-.98-8.48-1.73l-4.21-1.385-.115-4.326C4.214%2085.6%205.08%2076.89%207.79%2065.757%2011.482%2050.47%2022.096%2034.84%2034.959%2025.668c4.96-3.576%205.075-3.576%206.518-1.153.634%201.153%201.96%202.307%202.884%202.653l2.16.594c-3.045%2029.324-1.868%2053.63%203.532%2072.917-1.157%201.157-1.946%201.682-2.808%202.052-1.039.403-2.365.807-3.057.865-.693.057-3%20.519-5.25%201.038-4.21.923-13.382%201.096-21.63.346z'%20transform='translate(29%208)'/%3e%3cpath%20d='M62.472%2046.829l1.767%2011.31-19.972%202.646%201.106-15.653c2.141%201.735%204.344%202.776%206.608%203.123%202.263.348%205.76-.128%2010.49-1.426z'%20transform='translate(29%208)'/%3e%3cpath%20fill-rule='nonzero'%20d='M66.254%2052.654L71.157%2075.8c-.568%201.157-2.01%201.928-4.324%202.314-5.208.579-10.415-1.736-16.78-1.736-6.365%200-6.09%204.05-15.349.579-6.171-2.314-8.679-12.73-7.522-31.245l18.054-1.73c-.078%205.782.655%209.252%202.198%2010.409%201.512%201.134%207.569.6%2018.17-1.6l.65-.136zM58.305%207.444c1.07%201.52%201.487%203.536%201.252%206.049-.06.656-.375.883-.375%202.052%200%201.12.07%202.506.212%204.157l-2.317.161c-2.223%202.412-4.574%203.48-7.055%203.207-2.481-.275-4.251-1.343-5.311-3.207-2.18-4.023-1.62-7.444%201.676-10.262%203.296-2.818%207.269-3.537%2011.918-2.157z'%20transform='translate(29%208)'/%3e%3cpath%20d='M47.646%200c2.598%200%205.717%201.017%207.994%202.74%202.276%201.722%203.845%203.02%204.55%205.097.47%201.384.248%203.314-.665%205.791.13-2.345-.047-3.647-.532-3.906-.67%201.653-1.595%201.987-2.703%202.787-.62.448-2.791.518-4.917.897-2.629%201.722-4.303%203.33-4.867%204.86-.448%201.218-.402%202.608.148%204.177l.126.339-.54.21c-.714-1.833-.81-3.478-.277-4.925.522-1.417%201.85-2.838%203.893-4.321-1.088.307-2.05.754-2.633%201.449-1.28%201.526-2.028%203.765-2.246%206.716-2.766-.5-5.305-1.433-7.617-2.8-2.312-1.366-4.445-3.194-6.399-5.483.397-.834.904-1.524%201.522-2.07.671-.592%201.935-1.108%203.169-1.822l-.065.021-1.204.401c-1.26.424-1.956.713-2.396%201.032-.829.601-1.259%201.275-1.312%202.032l-.005.191-.579.007c-.012-1.039.516-1.943%201.557-2.699.427-.31%201.013-.573%201.983-.916l1.755-.59.612-.213c.593-.213%201.063-.401%201.438-.584%201.296-1.399%202.17-3.971%204.089-5.678C43.642.855%2045.048%200%2047.646%200z'%20transform='translate(29%208)'/%3e%3cpath%20fill-rule='nonzero'%20d='M52.36%2013.575c.597-1.64%202.169-2.597%203.535-2.1%201.061.386%201.653%201.524%201.586%202.781.36-.091.688-.137.988-.136l.208.007c.254.02.466.056.636.114.511-1.271%201.708-2.023%202.75-1.644%201.07.39%201.498%201.803%201.012%203.14-.487%201.337-1.723%202.144-2.794%201.754-.953-.347-1.397-1.504-1.14-2.697-.103-.038-.274-.072-.508-.09-.334-.025-.737.029-1.209.165l-.03.01c-.036.159-.083.318-.14.477-.597%201.64-2.17%202.597-3.536%202.1-1.366-.497-1.955-2.241-1.358-3.881zm9.504-.434c-.73-.266-1.664.343-2.052%201.408-.387%201.066-.064%202.132.667%202.398.73.266%201.664-.343%202.052-1.408.388-1.065.064-2.132-.667-2.398zm-6.167-1.122c-1.036-.377-2.297.39-2.793%201.754-.496%201.363-.024%202.762%201.012%203.14%201.036.376%202.298-.392%202.794-1.755s.023-2.762-1.013-3.14z'%20transform='translate(29%208)'/%3e%3c/g%3e%3c/g%3e%3cg%20mask='url(%23prefix__b)'%3e%3cg%3e%3cpath%20fill='%2380AEF2'%20fill-rule='nonzero'%20d='M33.56%20183.308c0-.116%201.153-3.288%202.538-7.095l2.538-6.922%206.46-.173%206.403-.173%202.768%202.307c2.308%201.962%2012.796%207.547%2014.132%208.307.891.506%202.067%201.794%203.526%203.864-25.577-.038-38.365-.077-38.365-.115z'%20transform='translate(32%208)'/%3e%3cpath%20fill='%2394BBF8'%20fill-rule='nonzero'%20d='M0%20183.308c0-.116%201.154-3.288%202.538-7.095l2.538-6.922%206.46-.173%206.403-.173%202.769%202.307c2.307%201.962%2012.795%207.547%2014.132%208.307.89.506%202.066%201.794%203.525%203.864C12.788%20183.385%200%20183.346%200%20183.308z'%20transform='translate(32%208)'/%3e%3cpath%20fill='%231D225F'%20fill-rule='nonzero'%20d='M43.655%20101.836c1.09%203.158%201.826%205.898%202.208%208.22.38%202.321%202.518%2022.155%206.411%2059.5H34.296c-1.444-2.618-2.166-4.457-2.166-5.518%200-1.59.913-3.77.913-6.068%200-1.532-2.034-6.823-6.104-15.871l3.931-39.349%2012.785-.914z'%20transform='translate(32%208)'/%3e%3cpath%20fill='url(%23prefix__c)'%20d='M18.554%20169.555H1.76c-.4-1.385-.792-3.254-1.175-5.606-.75-4.788-.18-7.96%203.05-14.536%203.23-6.518%204.866-10.072%204.866-13.764.058-5.768%201.222-11.316%204.28-17.315%202.364-4.73%203.495-5.086%203.725-7.97l.42-6.202h21.078c.512%201.433.696%204.075.55%207.925-.145%203.85-6.812%2023.006-20.001%2057.468z'%20transform='translate(32%208)'/%3e%3cg%20fill-rule='nonzero'%3e%3cpath%20fill='%2398BDF9'%20d='M0%2024.302L16.84%203.472%2037.031%203.472%2019.592%2024.302z'%20transform='translate(32%208)%20translate(63.94%2018.516)'/%3e%3cpath%20fill='%232174DB'%20d='M22.2.868c1.378%200%202.506%201.07%202.597%202.425l.006.179h-.578c0-1.119-.907-2.025-2.025-2.025-1.119%200-2.025.906-2.025%202.025%200%201.062.818%201.934%201.859%202.018l.166.007v.578c-1.438%200-2.604-1.165-2.604-2.603%200-1.438%201.166-2.604%202.604-2.604zM29.143.868c1.378%200%202.506%201.07%202.598%202.425l.006.179h-.579c0-1.119-.906-2.025-2.025-2.025-1.118%200-2.025.906-2.025%202.025%200%201.062.818%201.934%201.859%202.018l.166.007v.578c-1.438%200-2.604-1.165-2.604-2.603%200-1.438%201.166-2.604%202.604-2.604z'%20transform='translate(32%208)%20translate(63.94%2018.516)'/%3e%3c/g%3e%3cpath%20fill='%23F3A29D'%20fill-rule='nonzero'%20d='M62.472%2046.829c2.807-.962%205.554-2.299%208.242-4.011h6.871c-2.375%202.17-3.972%203.706-4.791%204.61-.82.903-2.509%202.638-5.068%205.205-1.091%205.781-2.254%208.21-3.487%207.285-1.85-1.386-7.939-10.897-1.767-13.09z'%20transform='translate(32%208)'/%3e%3cpath%20fill='%23FAB6AF'%20fill-rule='nonzero'%20d='M66.254%2052.654c4.363-1.668%207.179-2.857%208.447-3.567%201.5-.865%202.077-1.673%203.807-5.307.23-.461.692-2.365%201.096-4.153.923-4.557%202.423-4.326%202.538.346.058%201.27.346%202.423.692%202.538.288.116%201.961-1.5%203.634-3.576%201.673-2.077%203.288-3.75%203.576-3.75.692%200%20.692%205.307-.057%207.153-.289.865-4.73%205.71-9.864%2010.844-3.422%203.423-8.431%208.068-15.026%2013.937l1.157-14.465z'%20transform='translate(32%208)'/%3e%3cpath%20fill='%23F3A29D'%20fill-rule='nonzero'%20d='M46.581%2027.774c.772-3.086%201.543-5.015%202.315-5.787-1.157-1.157-2.315-2.314-4.63-3.471-.77%201.543-2.314%203.086-4.628%204.629%200%202.314.771%203.857%202.314%204.629%201.543.771%203.086.771%204.63%200z'%20transform='translate(32%208)'/%3e%3cg%3e%3cpath%20fill='url(%23prefix__d)'%20fill-rule='nonzero'%20d='M12.858%2082.16c-2.365-.174-6.23-.981-8.48-1.731l-4.21-1.385-.115-4.326c-.289-11.94.577-20.65%203.288-31.782C7.032%2027.65%2017.646%2012.019%2030.509%202.847c4.96-3.576%205.076-3.576%206.518-1.153.634%201.153%201.96%202.307%202.884%202.653l2.161.594c-3.046%2029.324-1.87%2053.63%203.531%2072.917-1.157%201.158-1.946%201.682-2.808%202.052-1.039.403-2.365.807-3.057.865-.693.058-3%20.519-5.25%201.038-4.21.923-13.382%201.096-21.63.346z'%20transform='translate(32%208)%20translate(4.45%2022.82)'/%3e%3cpath%20fill='%23D6D7D8'%20d='M58.022%2024.008l1.767%2011.311-19.972%202.645%201.106-15.653c2.141%201.735%204.344%202.776%206.608%203.123%202.263.348%205.76-.128%2010.49-1.426z'%20transform='translate(32%208)%20translate(4.45%2022.82)'/%3e%3cpath%20fill='%23E9E9E9'%20fill-rule='nonzero'%20d='M61.804%2029.833l4.903%2023.145c-.568%201.157-2.01%201.929-4.324%202.314-5.208.579-10.415-1.736-16.78-1.736-6.365%200-6.09%204.05-15.348.58-6.172-2.315-8.68-12.73-7.523-31.246l18.054-1.73c-.078%205.782.655%209.252%202.198%2010.409%201.512%201.134%207.569.601%2018.17-1.6l.65-.136z'%20transform='translate(32%208)%20translate(4.45%2022.82)'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23FAB6AF'%20fill-rule='nonzero'%20d='M29.082%207.444c1.07%201.52%201.488%203.536%201.253%206.049-.062.656-.376.883-.376%202.052%200%201.12.07%202.506.212%204.157l-2.317.161c-2.222%202.412-4.574%203.48-7.055%203.207-2.48-.275-4.251-1.343-5.31-3.207-2.18-4.023-1.621-7.444%201.675-10.262%203.296-2.818%207.269-3.537%2011.918-2.157z'%20transform='translate(32%208)%20translate(29.223)'/%3e%3cpath%20fill='%23E94A47'%20d='M18.423%200c2.598%200%205.717%201.017%207.994%202.74%202.277%201.722%203.845%203.02%204.55%205.097.47%201.384.248%203.314-.664%205.791.13-2.345-.048-3.647-.533-3.906-.67%201.653-1.595%201.987-2.703%202.787-.62.448-2.791.518-4.917.897-2.628%201.722-4.303%203.33-4.867%204.86-.448%201.218-.402%202.608.148%204.177l.126.339-.54.21c-.714-1.833-.81-3.478-.277-4.925.522-1.417%201.85-2.838%203.894-4.321-1.09.307-2.051.754-2.634%201.449-1.279%201.526-2.028%203.765-2.246%206.716-2.766-.5-5.305-1.433-7.617-2.8-2.312-1.366-4.445-3.194-6.398-5.483.396-.834.904-1.524%201.521-2.07.671-.592%201.935-1.108%203.169-1.822l-.065.021-1.204.401c-1.26.424-1.956.713-2.395%201.032-.83.601-1.26%201.275-1.313%202.032l-.005.191-.579.007c-.012-1.039.516-1.943%201.557-2.699.427-.31%201.013-.573%201.983-.916l1.756-.59.61-.213c.594-.213%201.064-.401%201.439-.584%201.296-1.399%202.17-3.971%204.09-5.678C14.418.855%2015.825%200%2018.422%200z'%20transform='translate(32%208)%20translate(29.223)'/%3e%3cpath%20fill='%23222768'%20fill-rule='nonzero'%20d='M23.137%2013.575c.597-1.64%202.17-2.597%203.535-2.1%201.061.386%201.654%201.524%201.586%202.781.36-.091.689-.137.988-.136l.208.007c.255.02.466.056.636.114.512-1.271%201.708-2.023%202.75-1.644%201.07.39%201.498%201.803%201.012%203.14-.487%201.337-1.723%202.144-2.794%201.754-.953-.347-1.397-1.504-1.14-2.697-.103-.038-.274-.072-.508-.09-.334-.025-.737.029-1.208.165l-.031.01c-.036.159-.083.318-.14.477-.597%201.64-2.17%202.597-3.536%202.1-1.366-.497-1.955-2.241-1.358-3.881zm9.504-.434c-.73-.266-1.664.343-2.052%201.408-.387%201.066-.064%202.132.667%202.398.731.266%201.664-.343%202.052-1.408.388-1.065.064-2.132-.667-2.398zm-6.167-1.122c-1.036-.377-2.297.39-2.793%201.754-.496%201.363-.024%202.762%201.012%203.14%201.036.376%202.298-.392%202.794-1.755s.023-2.762-1.013-3.14z'%20transform='translate(32%208)%20translate(29.223)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cpath%20fill='%23222768'%20fill-rule='nonzero'%20d='M153.265%20114.963c-.449-.4-.897-2.243-1.097-4.187-.399-3.938-.698-4.486-3.589-6.031l-2.093-1.147-3.788%201.545c-2.094.848-4.087%201.446-4.436%201.296-.947-.349-6.78-10.716-6.78-12.012%200-.698%201.048-1.894%203.24-3.589l3.24-2.542V82.813l-3.24-2.542c-2.043-1.595-3.24-2.89-3.24-3.539%200-1.047%205.085-10.417%206.331-11.663.598-.549%201.196-.499%204.037.598%204.736%201.844%205.085%201.894%207.627.249%202.243-1.446%202.292-1.545%202.641-4.636.648-5.931-.15-5.383%208.075-5.383%208.324%200%207.776-.349%208.424%205.533l.349%203.24%202.592%201.395%202.592%201.396%203.19-1.296c4.037-1.645%205.183-1.645%206.38.1%202.093%203.04%205.582%209.57%205.582%2010.467%200%20.648-1.196%201.894-3.24%203.39l-3.19%202.442v2.99l-.05%202.991%203.24%202.443c2.044%201.545%203.24%202.79%203.24%203.389%200%201.047-5.582%2010.916-6.679%2011.813-.548.449-1.645.2-4.586-.997l-3.937-1.545-2.542%201.396-2.542%201.395-.599%203.988c-.348%202.691-.847%204.237-1.395%204.685-1.296.947-12.81.848-13.757-.15zm11.414-19.639c6.58-2.99%208.374-11.265%203.639-16.698-6.28-7.128-17.844-3.29-18.792%206.23-.398%204.287%202.991%209.371%207.377%2011.066%201.595.598%205.832.3%207.776-.598z'%20mask='url(%23prefix__b)'%3e%3canimateTransform%20attributeName='transform'%20attributeType='XML'%20dur='2s'%20from='0%20160%2086'%20repeatCount='indefinite'%20to='360%20160%2086'%20type='rotate'%20/%3e%3c/path%3e%3cpath%20fill='%23E94A47'%20fill-rule='nonzero'%20d='M175.745%20146.115c-1.845-1.146-3.49-2.243-3.64-2.442-.149-.25.2-1.545.749-2.841.996-2.293.996-2.443.15-4.038-.699-1.345-1.197-1.644-3.141-1.894-3.639-.498-3.49-.249-3.49-5.433v-4.735l1.895-.299c3.589-.598%203.838-.698%204.785-2.243.897-1.545.847-1.595-.15-4.037-.598-1.346-.947-2.692-.797-2.891.299-.549%207.128-4.536%207.726-4.536.249%200%201.296.997%202.342%202.243%201.446%201.744%202.194%202.243%203.39%202.243%201.196%200%201.944-.499%203.39-2.243%201.046-1.246%202.093-2.243%202.342-2.243.598%200%207.427%203.987%207.726%204.536.15.2-.2%201.545-.748%202.89-.997%202.293-1.047%202.543-.299%203.988.798%201.496%201.196%201.695%204.935%202.293l1.844.3v4.734c0%205.184.15%204.935-3.49%205.433-1.893.25-2.442.549-3.14%201.894-.797%201.546-.797%201.695.15%204.187l.997%202.592-1.396.947c-2.542%201.745-6.03%203.589-6.729%203.589-.448%200-1.445-.947-2.292-2.044-1.247-1.744-1.795-2.093-3.29-2.143-1.495-.05-1.944.25-3.34%202.094-.847%201.146-1.944%202.093-2.342%202.093-.449%200-2.293-.897-4.137-1.994zm13.109-10.716c4.486-2.343%204.486-9.371-.1-11.813-5.832-3.14-12.212%203.19-9.171%209.121%201.595%203.09%206.03%204.337%209.27%202.692z'%20mask='url(%23prefix__b)'%3e%3canimateTransform%20attributeName='transform'%20attributeType='XML'%20dur='2s'%20from='360%20185%20130'%20repeatCount='indefinite'%20to='0%20185%20130'%20type='rotate'%20/%3e%3c/path%3e%3c/g%3e%3c/svg%3e", bue = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M13.5 6.25L13.4995 2.5005L9.75 2.5M8.99821 7.00179L13.4982 2.50179M11.5 9V13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V5C2.5 4.86739 2.55268 4.74021 2.64645 4.64645C2.74021 4.55268 2.86739 4.5 3 4.5H7", stroke: "#0066CC", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Cue = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 20, height: 20, viewBox: "0 0 20 20", ...i }, /* @__PURE__ */ G.createElement("defs", null, /* @__PURE__ */ G.createElement("path", { id: "a", d: "M12.652 6.169H3.344L7.41 2.102a.84.84 0 0 0 0-1.183.83.83 0 0 0-1.175 0L.744 6.41a.83.83 0 0 0 0 1.175l5.491 5.492a.83.83 0 1 0 1.175-1.175L3.344 7.835h9.308a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.833z" })), /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(3 3)" }, /* @__PURE__ */ G.createElement("mask", { id: "b", fill: "#fff" }, /* @__PURE__ */ G.createElement("use", { xlinkHref: "#a" })), /* @__PURE__ */ G.createElement("use", { fill: "#959BA1", transform: "matrix(-1 0 0 1 13.985 0)", xlinkHref: "#a" }))), bke = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill='%2306C'%20fill-rule='nonzero'%20d='M9.465%203H5a3%203%200%200%200-3%203v12a3%203%200%200%200%203%203h14a3%203%200%200%200%203-3V9a3%203%200%200%200-3-3h-6.465L11.13%203.89A2%202%200%200%200%209.465%203zM5%205h4.465l1.406%202.11a2%202%200%200%200%201.664.89H19a1%201%200%200%201%201%201v9a1%201%200%200%201-1%201H5a1%201%200%200%201-1-1V6a1%201%200%200%201%201-1z'/%3e%3c/svg%3e", Cke = "data:image/png;base64,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", yke = () => /* @__PURE__ */ v.jsx(
  oa,
  {
    SvgImage: vke,
    title: jr.CI_PROGRESS_VIEW.TITLE,
    subTitle: jr.CI_PROGRESS_VIEW.SUBTITLE
  }
), tR = ({
  type: i,
  userApprovalMetadata: e,
  triggeredBy: t,
  children: n,
  ciPipelineId: r,
  artifactId: s,
  imageComment: o,
  imageReleaseTags: a,
  appReleaseTagNames: l,
  tagsEditable: c,
  hideImageTaggingHardDelete: d,
  appliedFilters: u,
  isSuperAdmin: h,
  promotionApprovalMetadata: f,
  appliedFiltersTimestamp: g,
  selectedEnvironmentName: p,
  renderCIListHeader: m
}) => {
  const _ = !!e || !!u?.length || !!f?.promotedFromType;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    i === "deployed-artifact" && /* @__PURE__ */ v.jsxs("div", { className: "flex dc__width-inherit pb-12", children: [
      /* @__PURE__ */ v.jsx("div", { className: "w-50 text-underline-dashed-300" }),
      /* @__PURE__ */ v.jsx(Cue, { className: "icon-dim-16 ml-8 mr-8", style: { transform: "rotate(90deg)" } }),
      /* @__PURE__ */ v.jsx("div", { className: "w-50 text-underline-dashed-300" })
    ] }),
    _ && m && m({
      userApprovalMetadata: e,
      triggeredBy: t,
      appliedFilters: u,
      appliedFiltersTimestamp: g,
      promotionApprovalMetadata: f,
      selectedEnvironmentName: p
    }),
    /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: `dc__h-fit-content ci-artifact image-tag-parent-card bcn-0 br-4 dc__border p-12 w-100 dc__mxw-800 ci-artifact--${i} ${_ && m ? "dc__no-top-radius dc__no-top-border" : ""}`,
        "data-testid": "hover-on-report-artifact",
        children: [
          /* @__PURE__ */ v.jsxs("div", { className: "ci-artifacts-grid flex left", children: [
            /* @__PURE__ */ v.jsx("div", { className: "bcn-1 flex br-4 icon-dim-40", children: /* @__PURE__ */ v.jsx("img", { src: i === "report" ? bke : O5e, className: "icon-dim-20", alt: "type" }) }),
            n
          ] }),
          i !== "report" && /* @__PURE__ */ v.jsx(
            CCe,
            {
              ciPipelineId: r,
              artifactId: s,
              imageComment: o,
              imageReleaseTags: a,
              appReleaseTagNames: l,
              tagsEditable: c,
              hideHardDelete: d,
              isSuperAdmin: h
            }
          )
        ]
      }
    )
  ] });
}, wke = ({
  status: i,
  artifact: e,
  blobStorageEnabled: t,
  isArtifactUploaded: n,
  downloadArtifactUrl: r,
  ciPipelineId: s,
  artifactId: o,
  isJobView: a,
  isJobCI: l,
  imageComment: c,
  imageReleaseTags: d,
  type: u,
  appReleaseTagNames: h,
  tagsEditable: f,
  hideImageTaggingHardDelete: g,
  rootClassName: p,
  renderCIListHeader: m
}) => {
  const { isSuperAdmin: _ } = Vve(), { handleDownload: b } = pke(), { triggerId: w, buildId: y } = eo();
  async function S() {
    await b({
      downloadUrl: r,
      fileName: `${y || w}.zip`
    });
  }
  return i.toLowerCase() === fr.RUNNING || i.toLowerCase() === fr.STARTING ? /* @__PURE__ */ v.jsx(yke, {}) : i.toLowerCase() === fr.FAILED || i.toLowerCase() === fr.CANCELLED || i.toLowerCase() === fr.ERROR ? l ? /* @__PURE__ */ v.jsx(
    oa,
    {
      title: jr.ARTIFACTS_EMPTY_STATE_TEXTS.FailedToFetchArtifacts,
      subTitle: jr.ARTIFACTS_EMPTY_STATE_TEXTS.FailedToFetchArtifactsError
    }
  ) : /* @__PURE__ */ v.jsx(
    oa,
    {
      title: jr.ARTIFACTS_EMPTY_STATE_TEXTS.NoArtifactsGenerated,
      subTitle: jr.ARTIFACTS_EMPTY_STATE_TEXTS.NoArtifactsError
    }
  ) : !o && i.toLowerCase() === fr.SUCCEEDED ? /* @__PURE__ */ v.jsx(
    oa,
    {
      title: jr.ARTIFACTS_EMPTY_STATE_TEXTS.NoArtifactsFound,
      subTitle: jr.ARTIFACTS_EMPTY_STATE_TEXTS.NoArtifactsFoundError,
      image: Cke
    }
  ) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs("div", { className: `flex left column dc__gap-12 dc__content-start ${p ?? ""}`, children: [
      /* @__PURE__ */ v.jsx(
        tR,
        {
          type: "artifact",
          ciPipelineId: s,
          artifactId: o,
          imageComment: c,
          imageReleaseTags: d,
          appReleaseTagNames: h,
          tagsEditable: f,
          hideImageTaggingHardDelete: g,
          isSuperAdmin: _,
          renderCIListHeader: m,
          children: /* @__PURE__ */ v.jsxs("div", { className: "flex column left hover-trigger", children: [
            /* @__PURE__ */ v.jsxs("div", { className: "cn-9 fs-14 flex left", "data-testid": "artifact-text-visibility", children: [
              FE(e),
              /* @__PURE__ */ v.jsx("div", { className: "pl-4", children: /* @__PURE__ */ v.jsx(J_, { content: FE(e) }) })
            ] }),
            /* @__PURE__ */ v.jsxs("div", { className: "cn-7 fs-12 flex left", "data-testid": "artifact-image-text", children: [
              e,
              /* @__PURE__ */ v.jsx("div", { className: "pl-4", children: /* @__PURE__ */ v.jsx(J_, { content: e }) })
            ] })
          ] })
        }
      ),
      t && r && (u === ir.CD || n || a) && /* @__PURE__ */ v.jsx(
        tR,
        {
          type: "report",
          hideImageTaggingHardDelete: g,
          isSuperAdmin: _,
          renderCIListHeader: m,
          children: /* @__PURE__ */ v.jsxs("div", { className: "flex column left", children: [
            /* @__PURE__ */ v.jsx("div", { className: "cn-9 fs-14", children: "Reports.zip" }),
            /* @__PURE__ */ v.jsxs(
              "button",
              {
                type: "button",
                onClick: S,
                className: "anchor p-0 cb-5 fs-12 flex left pointer",
                children: [
                  "Download",
                  /* @__PURE__ */ v.jsx(mke, { className: "ml-5 icon-dim-16" })
                ]
              }
            )
          ] })
        }
      )
    ] }),
    !t && /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__position-abs-b-20 dc__content-center w-100", children: /* @__PURE__ */ v.jsxs("div", { className: "flexbox pt-8 pr-12 pb-8 pl-12 bcv-1 ev-2 bw-1 br-4", children: [
      /* @__PURE__ */ v.jsx(PA, { className: "icon-dim-20 fcv-5" }),
      /* @__PURE__ */ v.jsx("span", { className: "fs-13 fw-4 mr-8 ml-8", children: jr.ARTIFACTS_EMPTY_STATE_TEXTS.StoreFiles }),
      /* @__PURE__ */ v.jsx(
        "a",
        {
          className: "fs-13 fw-6 cb-5 dc__no-decor",
          href: ey.BLOB_STORAGE,
          target: "_blank",
          rel: "noreferrer",
          children: jr.ARTIFACTS_EMPTY_STATE_TEXTS.ConfigureBlobStorage
        }
      ),
      /* @__PURE__ */ v.jsx(bue, { className: "icon-dim-20 ml-8" })
    ] }) })
  ] });
}, yue = wke, pS = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M13 6L8 11L3 6", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Ske = ({ text: i, textClass: e }) => {
  const t = Nt(null), [n, r] = Oe(!1), [s, o] = Oe(!1);
  $e(() => {
    t.current?.offsetHeight && t.current?.scrollHeight && (t.current.offsetHeight === t.current?.scrollHeight ? r(!1) : r(!0));
  }, [t.current?.scrollHeight]);
  const a = () => {
    o(!s);
  }, l = () => s ? e || "" : `${e || ""} dc__truncate`;
  return /* @__PURE__ */ v.jsxs("div", { className: "min-w-385 pr-20", children: [
    /* @__PURE__ */ v.jsx("span", { ref: t, className: l(), children: i }),
    n && /* @__PURE__ */ v.jsxs(
      "button",
      {
        type: "button",
        className: "dc__transparent p-0 flexbox dc__align-items-center dc__gap-4",
        onClick: a,
        children: [
          /* @__PURE__ */ v.jsx("span", { className: "cb-5 fs-12 fw-6 lh-20", children: s ? "Show less" : "Show more" }),
          /* @__PURE__ */ v.jsx(
            pS,
            {
              className: `dc__no-shrink icon-dim-16 flex scb-5 dc__transition--transform ${s ? "dc__flip-180" : ""}`
            }
          )
        ]
      }
    )
  ] });
}, wue = Ske, xke = ({
  imagePath: i,
  registryType: e,
  handleClick: t,
  isExpanded: n,
  placement: r = "auto"
}) => {
  const [s, o] = Oe(!1), a = () => {
    o((c) => !c);
  }, l = n ?? s;
  return /* @__PURE__ */ v.jsx("div", { className: "cn-7 fs-14 lh-20 flexbox", children: /* @__PURE__ */ v.jsx(wn, { content: i, className: "default-tt", placement: r, arrow: !1, children: /* @__PURE__ */ v.jsxs(
    "button",
    {
      type: "button",
      className: `display-grid dc__align-items-center dc__select-text image-chip-cell__container ${l ? "image-chip-cell__container--expanded" : ""} bcn-1 br-6 dc__transparent py-0 px-6 cursor max-w-100`,
      onClick: t || a,
      children: [
        e ? /* @__PURE__ */ v.jsx("div", { className: `h-14 w-14 dc__registry-icon ${e} br-8 dc__no-shrink` }) : /* @__PURE__ */ v.jsx(mue, { className: "icon-dim-14 mw-14" }),
        l ? /* @__PURE__ */ v.jsx("div", { className: "mono dc__ellipsis-left direction-left", children: i }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          /* @__PURE__ */ v.jsx("div", { children: "…" }),
          /* @__PURE__ */ v.jsx("div", { className: "mono dc__ellipsis-left direction-left text-overflow-clip", children: i.split(":").slice(-1)[0] ?? "" })
        ] })
      ]
    }
  ) }) });
}, Sue = xke, xue = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#3B444C", fillRule: "evenodd", d: "M8 5.333c1.243 0 2.287.85 2.583 2H14c.368 0 .667.299.667.667 0 .368-.299.667-.667.667h-3.417c-.296 1.15-1.34 2-2.583 2s-2.287-.85-2.583-2H2c-.368 0-.667-.299-.667-.667 0-.368.299-.667.667-.667h3.417c.296-1.15 1.34-2 2.583-2zm0 1.334c-.736 0-1.333.597-1.333 1.333S7.264 9.333 8 9.333 9.333 8.736 9.333 8 8.736 6.667 8 6.667z" })), Dke = ({ handleClick: i = El, commits: e }) => e?.length > 0 ? /* @__PURE__ */ v.jsx("div", { className: "flexbox", children: /* @__PURE__ */ v.jsxs(
  "button",
  {
    type: "button",
    className: "dc__transparent p-0 flexbox dc__gap-4 fs-14 lh-20 cb-5 dc__truncate mono cursor",
    onClick: i,
    children: [
      /* @__PURE__ */ v.jsxs("span", { className: "flex dc__gap-4 br-4 pl-6 pr-6 bcb-1", children: [
        /* @__PURE__ */ v.jsx(xue, { className: "icon-dim-14 dc__no-shrink fcb-5" }),
        /* @__PURE__ */ v.jsx("span", { children: e[0].substring(0, 7) })
      ] }),
      e.length > 1 && /* @__PURE__ */ v.jsx("span", { className: "flex br-4 pl-6 pr-6 bcb-1", children: "…" })
    ]
  }
) }) : /* @__PURE__ */ v.jsx("span", {}), RY = Dke, Eke = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M3.33334 5H17.0833M3.33334 8.33333H16.25M3.33334 11.6667H12.0833M3.33334 15H14.5833", stroke: "#3B444C", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Lke = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("style", null, `
        .pulsate__history-status {
            animation: pulsate__history-status-animation 2s infinite ease-in-out;
            opacity: 0.8;
            }
            
            @keyframes pulsate__history-status-animation {
                0% {
                    stroke-width: 0;
                    stroke-opacity: 0.5;
                }
                100% {
                    stroke-width: 10;
                    stroke-opacity: 0;
                }
            }
    `), /* @__PURE__ */ G.createElement("circle", { className: "pulsate__history-status", cx: 10, cy: 10, r: 5, fill: "#FF7E5B", stroke: "#FF7E5B", strokeOpacity: 0.3, strokeWidth: 10 }), /* @__PURE__ */ G.createElement("path", { d: "M10 0L10 5", stroke: "#3B444C" })), Ike = (i) => /* @__PURE__ */ G.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M1.875 6H10.125M10.125 6L6.75 2.625M10.125 6L6.75 9.375", stroke: "#B1B7BC", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), FY = (i) => i && i === Yf.FETCHING ? "?SHOW_APPLIED_FILTERS=true" : "";
function Ake({
  appId: i,
  envId: e,
  pipelineId: t,
  triggerId: n,
  fetchIdData: r
}) {
  return Qn(
    n ? `${hn.APP}/cd-pipeline/workflow/trigger-info/${i}/${e}/${t}/${n}${FY(r)}` : `${hn.APP}/cd-pipeline/workflow/trigger-info/${i}/${e}/${t}/last${FY(r)}`
  );
}
const kke = (i) => {
  const e = `${hn.IMAGE_TAGGING}/${i.pipelineId}/${i.artifactId}`;
  return Qn(e);
}, Tke = (i, e) => {
  const t = `${hn.CI_CONFIG_GET}/${i.pipelineId}/workflow/${i.workflowId}?forceAbort=${e}`;
  return Fle(t);
}, Nke = (i, e) => {
  const t = `${hn.CD_MATERIAL_GET}/${i}/workflowRunner/${e}`;
  return Fle(t);
};
function Pke(i, e, t, n, r, s) {
  let o;
  return r ? o = hn.HELM_DEPLOYMENT_STATUS_TIMELINE_INSTALLED_APP : o = hn.DEPLOYMENT_STATUS, Qn(
    `${o}/${i}/${e}${`?showTimeline=${t}`}${n ? `&wfrId=${n}` : ""}${s ? `&installedAppVersionHistoryId=${s}` : ""}`
  );
}
function Oke(i) {
  return Qn(`${hn.MANUAL_SYNC}/${i.appId}/${i.envId}`);
}
const Due = (i, e, t) => Qn(`app/history/deployed-configuration/${i}/${e}/${t}`), BY = (i, e, t, n, r) => Qn(
  `app/history/deployed-component/detail/${i}/${e}/${t}?historyComponent=${n.replace("-", "_").toUpperCase()}${r ? `&historyComponentName=${r}` : ""}`
), Mke = (i) => {
  const e = {};
  return i.templateVersion && (e.templateVersion = { displayName: "Chart Version", value: i.templateVersion }), (i.isAppMetricsEnabled || i.isAppMetricsEnabled === !1) && (e.isAppMetricsEnabled = {
    displayName: "Application metrics",
    value: i.isAppMetricsEnabled ? "Enabled" : "Disabled"
  }), e;
}, Rke = (i) => {
  const e = {};
  return i.pipelineTriggerType && (e.pipelineTriggerType = {
    displayName: "When do you want the pipeline to execute?",
    value: i.pipelineTriggerType
  }), i.strategy && (e.strategy = {
    displayName: "Deployment strategy",
    value: i.strategy
  }), e;
}, Fke = (i, e, t, n) => {
  const r = {};
  if (i.external !== void 0) {
    if (i.external)
      i.externalType ? r.external = {
        displayName: "Data type",
        value: Lx[e][i.externalType]
      } : r.external = {
        displayName: "Data type",
        value: e === "Secret" ? Lx[e].KubernetesSecret : Lx[e].KubernetesConfigMap
      };
    else if (r.external = { displayName: "Data type", value: Lx[e][""] }, e === "Secret" && t.codeEditorValue.value) {
      const s = JSON.parse(t.codeEditorValue.value);
      let o = {};
      t.codeEditorValue?.resolvedValue && (o = JSON.parse(t.codeEditorValue.resolvedValue));
      const a = n || Object.keys(s).some((l) => s[l] === "*****");
      t.codeEditorValue.value = a ? t.codeEditorValue.value : JSON.stringify(sY(s)), t.codeEditorValue.resolvedValue = a ? t.codeEditorValue.resolvedValue : JSON.stringify(sY(o));
    }
  }
  if (i.type) {
    let s = "Environment Variable";
    i.type === "volume" && (s = "Data Volume", i.mountPath && (r.mountPath = { displayName: "Volume mount path", value: i.mountPath }), i.subPath && (r.subPath = { displayName: "Set SubPath", value: "Yes" }), i.filePermission && (r.filePermission = {
      displayName: "Set file permission",
      value: i.filePermission
    })), r.type = {
      displayName: `How do you want to use this ${e}?`,
      value: s
    };
  }
  return e === "Secret" && i.roleARN && (r.roleARN = { displayName: "Role ARN", value: i.roleARN }), r;
}, my = (i, e, t) => {
  let n;
  const r = { codeEditorValue: i.codeEditorValue, values: {} };
  return delete i.codeEditorValue, e === Xo.DEPLOYMENT_TEMPLATE.VALUE ? n = Mke(i) : e === Xo.PIPELINE_STRATEGY.VALUE ? n = Rke(i) : n = Fke(
    i,
    e === Xo.CONFIGMAP.VALUE ? Xo.CONFIGMAP.DISPLAY_NAME : Xo.SECRET.DISPLAY_NAME,
    r,
    t
  ), r.values = n, r;
}, Bke = (i, e, t, n) => {
  const r = vl(
    `${hn.RESOURCE_HISTORY_DEPLOYMENT}/${hn.CONFIG_CD_PIPELINE}/${vj.v1}`,
    {
      baseConfigurationId: t,
      historyComponent: e.replace("-", "_").toUpperCase(),
      filterCriteria: `cd-pipeline|id|${i}`,
      historyComponentName: n
    }
  );
  return Qn(r);
}, qbt = async ({
  appId: i,
  envId: e,
  pagination: t,
  releaseId: n,
  showCurrentReleaseDeployments: r = !1
}) => {
  const s = vl(
    `${hn.RESOURCE_HISTORY_DEPLOYMENT}/${Io.cdPipeline}/${vj.v1}`,
    {
      filterCriteria: W5e({ appId: i, envId: e, releaseId: n, showCurrentReleaseDeployments: r }),
      offset: t.offset,
      limit: t.size
    }
  ), { result: o } = await Qn(s);
  return { result: j5e(o) };
}, Kbt = (i) => Qn(`${hn.MODULE_CONFIGURED}?name=${i}`);
var Eue = {};
(function(i) {
  (function(e, t) {
    if (typeof i.nodeName != "string")
      t(i);
    else {
      var n = {};
      t(n), e.AnsiUp = n.default;
    }
  })(Zs, function(e) {
    var t = this && this.__makeTemplateObject || function(a, l) {
      return Object.defineProperty ? Object.defineProperty(a, "raw", { value: l }) : a.raw = l, a;
    }, n;
    (function(a) {
      a[a.EOS = 0] = "EOS", a[a.Text = 1] = "Text", a[a.Incomplete = 2] = "Incomplete", a[a.ESC = 3] = "ESC", a[a.Unknown = 4] = "Unknown", a[a.SGR = 5] = "SGR", a[a.OSCURL = 6] = "OSCURL";
    })(n || (n = {}));
    var r = function() {
      function a() {
        this.VERSION = "5.2.1", this.setup_palettes(), this._use_classes = !1, this.bold = !1, this.italic = !1, this.underline = !1, this.fg = this.bg = null, this._buffer = "", this._url_whitelist = { http: 1, https: 1 }, this._escape_html = !0;
      }
      return Object.defineProperty(a.prototype, "use_classes", {
        get: function() {
          return this._use_classes;
        },
        set: function(l) {
          this._use_classes = l;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "url_whitelist", {
        get: function() {
          return this._url_whitelist;
        },
        set: function(l) {
          this._url_whitelist = l;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "escape_html", {
        get: function() {
          return this._escape_html;
        },
        set: function(l) {
          this._escape_html = l;
        },
        enumerable: !1,
        configurable: !0
      }), a.prototype.setup_palettes = function() {
        var l = this;
        this.ansi_colors = [
          [
            { rgb: [0, 0, 0], class_name: "ansi-black" },
            { rgb: [187, 0, 0], class_name: "ansi-red" },
            { rgb: [0, 187, 0], class_name: "ansi-green" },
            { rgb: [187, 187, 0], class_name: "ansi-yellow" },
            { rgb: [0, 0, 187], class_name: "ansi-blue" },
            { rgb: [187, 0, 187], class_name: "ansi-magenta" },
            { rgb: [0, 187, 187], class_name: "ansi-cyan" },
            { rgb: [255, 255, 255], class_name: "ansi-white" }
          ],
          [
            { rgb: [85, 85, 85], class_name: "ansi-bright-black" },
            { rgb: [255, 85, 85], class_name: "ansi-bright-red" },
            { rgb: [0, 255, 0], class_name: "ansi-bright-green" },
            { rgb: [255, 255, 85], class_name: "ansi-bright-yellow" },
            { rgb: [85, 85, 255], class_name: "ansi-bright-blue" },
            { rgb: [255, 85, 255], class_name: "ansi-bright-magenta" },
            { rgb: [85, 255, 255], class_name: "ansi-bright-cyan" },
            { rgb: [255, 255, 255], class_name: "ansi-bright-white" }
          ]
        ], this.palette_256 = [], this.ansi_colors.forEach(function(_) {
          _.forEach(function(b) {
            l.palette_256.push(b);
          });
        });
        for (var c = [0, 95, 135, 175, 215, 255], d = 0; d < 6; ++d)
          for (var u = 0; u < 6; ++u)
            for (var h = 0; h < 6; ++h) {
              var f = { rgb: [c[d], c[u], c[h]], class_name: "truecolor" };
              this.palette_256.push(f);
            }
        for (var g = 8, p = 0; p < 24; ++p, g += 10) {
          var m = { rgb: [g, g, g], class_name: "truecolor" };
          this.palette_256.push(m);
        }
      }, a.prototype.escape_txt_for_html = function(l) {
        return this._escape_html ? l.replace(/[&<>"']/gm, function(c) {
          if (c === "&")
            return "&amp;";
          if (c === "<")
            return "&lt;";
          if (c === ">")
            return "&gt;";
          if (c === '"')
            return "&quot;";
          if (c === "'")
            return "&#x27;";
        }) : l;
      }, a.prototype.append_buffer = function(l) {
        var c = this._buffer + l;
        this._buffer = c;
      }, a.prototype.get_next_packet = function() {
        var l = {
          kind: n.EOS,
          text: "",
          url: ""
        }, c = this._buffer.length;
        if (c == 0)
          return l;
        var d = this._buffer.indexOf("\x1B");
        if (d == -1)
          return l.kind = n.Text, l.text = this._buffer, this._buffer = "", l;
        if (d > 0)
          return l.kind = n.Text, l.text = this._buffer.slice(0, d), this._buffer = this._buffer.slice(d), l;
        if (d == 0) {
          if (c < 3)
            return l.kind = n.Incomplete, l;
          var u = this._buffer.charAt(1);
          if (u != "[" && u != "]" && u != "(")
            return l.kind = n.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
          if (u == "[") {
            this._csi_regex || (this._csi_regex = s(t([`
                        ^                           # beginning of line
                                                    #
                                                    # First attempt
                        (?:                         # legal sequence
                          \x1B[                      # CSI
                          ([<-?]?)              # private-mode char
                          ([d;]*)                    # any digits or semicolons
                          ([ -/]?               # an intermediate modifier
                          [@-~])                # the command
                        )
                        |                           # alternate (second attempt)
                        (?:                         # illegal sequence
                          \x1B[                      # CSI
                          [ -~]*                # anything legal
                          ([\0-:])              # anything illegal
                        )
                    `], [`
                        ^                           # beginning of line
                                                    #
                                                    # First attempt
                        (?:                         # legal sequence
                          \\x1b\\[                      # CSI
                          ([\\x3c-\\x3f]?)              # private-mode char
                          ([\\d;]*)                    # any digits or semicolons
                          ([\\x20-\\x2f]?               # an intermediate modifier
                          [\\x40-\\x7e])                # the command
                        )
                        |                           # alternate (second attempt)
                        (?:                         # illegal sequence
                          \\x1b\\[                      # CSI
                          [\\x20-\\x7e]*                # anything legal
                          ([\\x00-\\x1f:])              # anything illegal
                        )
                    `])));
            var h = this._buffer.match(this._csi_regex);
            if (h === null)
              return l.kind = n.Incomplete, l;
            if (h[4])
              return l.kind = n.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
            h[1] != "" || h[3] != "m" ? l.kind = n.Unknown : l.kind = n.SGR, l.text = h[2];
            var f = h[0].length;
            return this._buffer = this._buffer.slice(f), l;
          } else if (u == "]") {
            if (c < 4)
              return l.kind = n.Incomplete, l;
            if (this._buffer.charAt(2) != "8" || this._buffer.charAt(3) != ";")
              return l.kind = n.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
            this._osc_st || (this._osc_st = o(t([`
                        (?:                         # legal sequence
                          (\x1B\\)                    # ESC                           |                           # alternate
                          (\x07)                      # BEL (what xterm did)
                        )
                        |                           # alternate (second attempt)
                        (                           # illegal sequence
                          [\0-]                 # anything illegal
                          |                           # alternate
                          [\b-]                 # anything illegal
                          |                           # alternate
                          [-]                 # anything illegal
                        )
                    `], [`
                        (?:                         # legal sequence
                          (\\x1b\\\\)                    # ESC \\
                          |                           # alternate
                          (\\x07)                      # BEL (what xterm did)
                        )
                        |                           # alternate (second attempt)
                        (                           # illegal sequence
                          [\\x00-\\x06]                 # anything illegal
                          |                           # alternate
                          [\\x08-\\x1a]                 # anything illegal
                          |                           # alternate
                          [\\x1c-\\x1f]                 # anything illegal
                        )
                    `]))), this._osc_st.lastIndex = 0;
            {
              var g = this._osc_st.exec(this._buffer);
              if (g === null)
                return l.kind = n.Incomplete, l;
              if (g[3])
                return l.kind = n.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
            }
            {
              var p = this._osc_st.exec(this._buffer);
              if (p === null)
                return l.kind = n.Incomplete, l;
              if (p[3])
                return l.kind = n.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
            }
            this._osc_regex || (this._osc_regex = s(t([`
                        ^                           # beginning of line
                                                    #
                        \x1B]8;                    # OSC Hyperlink
                        [ -:<-~]*       # params (excluding ;)
                        ;                           # end of params
                        ([!-~]{0,512})        # URL capture
                        (?:                         # ST
                          (?:\x1B\\)                  # ESC                           |                           # alternate
                          (?:\x07)                    # BEL (what xterm did)
                        )
                        ([ -~]+)              # TEXT capture
                        \x1B]8;;                   # OSC Hyperlink End
                        (?:                         # ST
                          (?:\x1B\\)                  # ESC                           |                           # alternate
                          (?:\x07)                    # BEL (what xterm did)
                        )
                    `], [`
                        ^                           # beginning of line
                                                    #
                        \\x1b\\]8;                    # OSC Hyperlink
                        [\\x20-\\x3a\\x3c-\\x7e]*       # params (excluding ;)
                        ;                           # end of params
                        ([\\x21-\\x7e]{0,512})        # URL capture
                        (?:                         # ST
                          (?:\\x1b\\\\)                  # ESC \\
                          |                           # alternate
                          (?:\\x07)                    # BEL (what xterm did)
                        )
                        ([\\x20-\\x7e]+)              # TEXT capture
                        \\x1b\\]8;;                   # OSC Hyperlink End
                        (?:                         # ST
                          (?:\\x1b\\\\)                  # ESC \\
                          |                           # alternate
                          (?:\\x07)                    # BEL (what xterm did)
                        )
                    `])));
            var h = this._buffer.match(this._osc_regex);
            if (h === null)
              return l.kind = n.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
            l.kind = n.OSCURL, l.url = h[1], l.text = h[2];
            var f = h[0].length;
            return this._buffer = this._buffer.slice(f), l;
          } else if (u == "(")
            return l.kind = n.Unknown, this._buffer = this._buffer.slice(3), l;
        }
      }, a.prototype.ansi_to_html = function(l) {
        this.append_buffer(l);
        for (var c = []; ; ) {
          var d = this.get_next_packet();
          if (d.kind == n.EOS || d.kind == n.Incomplete)
            break;
          d.kind == n.ESC || d.kind == n.Unknown || (d.kind == n.Text ? c.push(this.transform_to_html(this.with_state(d))) : d.kind == n.SGR ? this.process_ansi(d) : d.kind == n.OSCURL && c.push(this.process_hyperlink(d)));
        }
        return c.join("");
      }, a.prototype.with_state = function(l) {
        return { bold: this.bold, italic: this.italic, underline: this.underline, fg: this.fg, bg: this.bg, text: l.text };
      }, a.prototype.process_ansi = function(l) {
        for (var c = l.text.split(";"); c.length > 0; ) {
          var d = c.shift(), u = parseInt(d, 10);
          if (isNaN(u) || u === 0)
            this.fg = this.bg = null, this.bold = !1, this.italic = !1, this.underline = !1;
          else if (u === 1)
            this.bold = !0;
          else if (u === 3)
            this.italic = !0;
          else if (u === 4)
            this.underline = !0;
          else if (u === 22)
            this.bold = !1;
          else if (u === 23)
            this.italic = !1;
          else if (u === 24)
            this.underline = !1;
          else if (u === 39)
            this.fg = null;
          else if (u === 49)
            this.bg = null;
          else if (u >= 30 && u < 38)
            this.fg = this.ansi_colors[0][u - 30];
          else if (u >= 40 && u < 48)
            this.bg = this.ansi_colors[0][u - 40];
          else if (u >= 90 && u < 98)
            this.fg = this.ansi_colors[1][u - 90];
          else if (u >= 100 && u < 108)
            this.bg = this.ansi_colors[1][u - 100];
          else if ((u === 38 || u === 48) && c.length > 0) {
            var h = u === 38, f = c.shift();
            if (f === "5" && c.length > 0) {
              var g = parseInt(c.shift(), 10);
              g >= 0 && g <= 255 && (h ? this.fg = this.palette_256[g] : this.bg = this.palette_256[g]);
            }
            if (f === "2" && c.length > 2) {
              var p = parseInt(c.shift(), 10), m = parseInt(c.shift(), 10), _ = parseInt(c.shift(), 10);
              if (p >= 0 && p <= 255 && m >= 0 && m <= 255 && _ >= 0 && _ <= 255) {
                var b = { rgb: [p, m, _], class_name: "truecolor" };
                h ? this.fg = b : this.bg = b;
              }
            }
          }
        }
      }, a.prototype.transform_to_html = function(l) {
        var c = l.text;
        if (c.length === 0 || (c = this.escape_txt_for_html(c), !l.bold && !l.italic && !l.underline && l.fg === null && l.bg === null))
          return c;
        var d = [], u = [], h = l.fg, f = l.bg;
        l.bold && d.push("font-weight:bold"), l.italic && d.push("font-style:italic"), l.underline && d.push("text-decoration:underline"), this._use_classes ? (h && (h.class_name !== "truecolor" ? u.push(h.class_name + "-fg") : d.push("color:rgb(" + h.rgb.join(",") + ")")), f && (f.class_name !== "truecolor" ? u.push(f.class_name + "-bg") : d.push("background-color:rgb(" + f.rgb.join(",") + ")"))) : (h && d.push("color:rgb(" + h.rgb.join(",") + ")"), f && d.push("background-color:rgb(" + f.rgb + ")"));
        var g = "", p = "";
        return u.length && (g = ' class="' + u.join(" ") + '"'), d.length && (p = ' style="' + d.join(";") + '"'), "<span" + p + g + ">" + c + "</span>";
      }, a.prototype.process_hyperlink = function(l) {
        var c = l.url.split(":");
        if (c.length < 1 || !this._url_whitelist[c[0]])
          return "";
        var d = '<a href="' + this.escape_txt_for_html(l.url) + '">' + this.escape_txt_for_html(l.text) + "</a>";
        return d;
      }, a;
    }();
    function s(a) {
      var l = a.raw[0], c = /^\s+|\s+\n|\s*#[\s\S]*?\n|\n/gm, d = l.replace(c, "");
      return new RegExp(d);
    }
    function o(a) {
      var l = a.raw[0], c = /^\s+|\s+\n|\s*#[\s\S]*?\n|\n/gm, d = l.replace(c, "");
      return new RegExp(d, "g");
    }
    Object.defineProperty(e, "__esModule", { value: !0 }), e.default = r;
  });
})(Eue);
const Vke = /* @__PURE__ */ eb(Eue), VY = ({ children: i }) => /* @__PURE__ */ v.jsx("div", { className: "display-grid dc__column-gap-10 dc__align-start logs-renderer__log-item", children: i }), Hke = ({
  stage: i,
  isOpen: e,
  logs: t,
  endTime: n,
  startTime: r,
  status: s,
  handleStageClose: o,
  handleStageOpen: a,
  stageIndex: l,
  isLoading: c,
  fullScreenView: d
}) => {
  const u = () => {
    e ? o(l) : a(l);
  }, h = () => {
    const f = kAe(r, n);
    return f === "0s" ? "< 1s" : f;
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    /* @__PURE__ */ v.jsxs(
      "button",
      {
        className: `flexbox dc__transparent dc__content-space py-6 px-8 br-4 dc__align-items-center dc__select-text logs-renderer__stage-accordion ${e ? "logs-renderer__stage-accordion--open-stage" : ""} dc__position-sticky dc__zi-1 ${d ? "dc__top-44" : "dc__top-80"}`,
        type: "button",
        role: "tab",
        onClick: u,
        children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-8 dc__transparent dc__align-items-center", children: [
            /* @__PURE__ */ v.jsx(
              pS,
              {
                className: `icon-dim-16 dc__no-shrink dc__transition--transform scn-0 ${e ? "" : "dc__flip-n90 dc__opacity-0_5"}`
              }
            ),
            /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-center", children: [
              z5e(s),
              /* @__PURE__ */ v.jsx("h3", { className: "m-0 cn-0 fs-13 fw-4 lh-20 dc__word-break", children: i })
            ] })
          ] }),
          !!n && /* @__PURE__ */ v.jsx("span", { className: "cn-0 fs-13 fw-4 lh-20", children: h() })
        ]
      }
    ),
    e && /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      t.map((f, g) => /* @__PURE__ */ v.jsxs(
        VY,
        {
          children: [
            /* @__PURE__ */ v.jsx("span", { className: "cn-4 col-2 lh-20 dc__text-align-end dc__word-break mono fs-14", children: g + 1 }),
            /* @__PURE__ */ v.jsx(
              "p",
              {
                className: "mono fs-14 mb-0-imp cn-0 dc__word-break lh-20",
                dangerouslySetInnerHTML: {
                  __html: lA.sanitize(f)
                }
              }
            )
          ]
        },
        `logs-${i}-${r}-${g}`
      )),
      c && /* @__PURE__ */ v.jsxs(VY, { children: [
        /* @__PURE__ */ v.jsx("span", {}),
        /* @__PURE__ */ v.jsx("div", { className: "dc__loading-dots cn-0" })
      ] })
    ] })
  ] });
}, mS = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 32 32", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { d: "M0 0h32v32H0z" }), /* @__PURE__ */ G.createElement("path", { fill: "#06C", d: "M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667z" }), /* @__PURE__ */ G.createElement("path", { fill: "#FFF", d: "M16 14.667c.736 0 1.333.597 1.333 1.333v5.333a1.333 1.333 0 1 1-2.666 0V16c0-.736.597-1.333 1.333-1.333zm0-5.334A1.333 1.333 0 1 1 16 12a1.333 1.333 0 0 1 0-2.667z" }))), Wke = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='20'%20height='20'%20viewBox='0%200%2032%2032'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cpath%20d='M0%200h32v32H0z'/%3e%3cpath%20fill='%2306C'%20d='M16%202.667C8.64%202.667%202.667%208.64%202.667%2016S8.64%2029.333%2016%2029.333%2029.333%2023.36%2029.333%2016%2023.36%202.667%2016%202.667z'/%3e%3cpath%20fill='%23FFF'%20d='M16%2014.667c.736%200%201.333.597%201.333%201.333v5.333a1.333%201.333%200%201%201-2.666%200V16c0-.736.597-1.333%201.333-1.333zm0-5.334A1.333%201.333%200%201%201%2016%2012a1.333%201.333%200%200%201%200-2.667z'/%3e%3c/g%3e%3c/svg%3e", Lue = (i) => /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__content-center flex-align-center dc__height-inherit", children: /* @__PURE__ */ v.jsxs("div", { children: [
  /* @__PURE__ */ v.jsx("div", { className: "text-center", children: /* @__PURE__ */ v.jsx(mS, { className: "icon-dim-20" }) }),
  /* @__PURE__ */ v.jsx("div", { className: "text-center cn-0 fs-14 fw-6", children: "Logs not available" }),
  /* @__PURE__ */ v.jsx("div", { className: "text-center cn-0 fs-13 fw-4", children: i || "Blob storage was not configured at pipeline run." })
] }) }), jke = () => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
  Lue("Logs are available only at runtime."),
  /* @__PURE__ */ v.jsxs("div", { className: "flexbox configure-blob-container pt-8 pr-12 pb-8 pl-12 bcv-1 br-4", children: [
    /* @__PURE__ */ v.jsx(PA, { className: "icon-dim-20 fcv-5" }),
    /* @__PURE__ */ v.jsx("span", { className: "fs-13 fw-4 mr-8 ml-8", children: "Want to store logs to view later?" }),
    /* @__PURE__ */ v.jsx(
      "a",
      {
        className: "fs-13 fw-6 cb-5 dc__no-decor",
        href: ey.BLOB_STORAGE,
        target: "_blank",
        rel: "noreferrer",
        children: "Configure blob storage"
      }
    ),
    /* @__PURE__ */ v.jsx(bue, { className: "icon-dim-20 ml-8" })
  ] })
] }), zke = (i) => /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__content-center flex-grow-1 flex-align-center dc__height-inherit dark-background", children: i ? Lue() : jke() }), Uke = (i, e) => {
  const [t, n] = Oe([]);
  let r = Tx;
  const [s, o] = Oe(!1), [a, l] = Oe(1e3), c = Nt([]), d = Nt(null);
  function u() {
    n((b) => [...b, ...c.current]), c.current = [];
  }
  dCe(u, a);
  function h() {
    d.current && d.current.close && d.current.close();
  }
  function f(b) {
    b.type === "message" && (r = Tx, c.current.push(b.data));
  }
  function g() {
    r = Tx, c.current = [], n([]);
  }
  function p() {
    r = Tx, n((b) => [...b, ...c.current]), c.current = [], d.current.close(), l(null);
  }
  function m() {
    c.current = [], d.current = new EventSource(i, { withCredentials: !0 }), d.current.addEventListener(kx.MESSAGE, f), d.current.addEventListener(kx.START_OF_STREAM, g), d.current.addEventListener(kx.END_OF_STREAM, p), d.current.addEventListener(kx.ERROR, _);
  }
  function _(b) {
    r -= 1, d.current && d.current.close(), r > 0 ? m() : (o(!0), l(null));
  }
  return $e(() => (i && m(), h), [i, e]), [t, d.current, s];
}, Gke = ({
  triggerDetails: i,
  isBlobStorageConfigured: e,
  parentType: t,
  fullScreenView: n
}) => {
  const { pipelineId: r, envId: s, appId: o } = eo(), a = t === ir.CI ? `${CE}/${hn.CI_CONFIG_GET}/${r}/workflow/${i.id}/logs` : `${CE}/${hn.CD_MATERIAL_GET}/workflow/logs/${o}/${s}/${r}/${i.id}`, [l, c, d] = Uke(
    i.podStatus && i.podStatus !== Yk.PENDING && a
  ), [u, h] = Oe([]), [f, g] = Oe([]), { searchKey: p, handleSearch: m } = _at(), _ = window._env_.FEATURE_STEP_WISE_LOGS_ENABLE && l[0]?.startsWith(SY) || !1;
  function b(k, N = p) {
    let I = !1;
    try {
      if (k = k.replace(/\[[.]*m/, (P) => `\x1B[${P}m`), N && _) {
        const P = k.split(QK), O = k.match(QK) || [], K = new RegExp(`(${SAe(N)})`, "g");
        k = P.reduce((F, q, R) => {
          try {
            I = I || K.test(q), F.push(
              q.replace(
                K,
                (T) => `\x1B[0m\x1B[48;2;197;141;54m${T}\x1B[0m${R > 0 ? O[R - 1] : ""}`
              )
            );
          } catch {
            F.push(q);
          }
          return R < P.length - 1 && F.push(O[R]), F;
        }, []).join("");
      }
      return { __html: new Vke().ansi_to_html(k), isSearchKeyPresent: I };
    } catch {
      return { __html: k, isSearchKeyPresent: I };
    }
  }
  const w = (k, N, I, A) => {
    const P = u.length === 0, O = N ?? !0;
    return A ? I || O : P ? k !== xv.SUCCESS || I : O;
  }, y = i.podStatus === Yk.PENDING || !!(c && c.readyState <= 1), S = (k) => {
    const N = u.reduce(
      (A, P) => (A[P.stage] || (A[P.stage] = {}), A[P.stage][P.startTime] = P, A),
      {}
    ), I = {};
    return l.reduce((A, P, O) => {
      if (P.startsWith(SY))
        try {
          const { stage: K, startTime: W, endTime: F, status: q } = JSON.parse(
            P.split(I5e)[1]
          ), R = A.find((z) => z.stage === K && z.startTime === W), T = N[K]?.[W] ?? {};
          if (R)
            R.endTime = F, R.status = q, R.isOpen = w(
              q,
              T.isOpen,
              !!I[K]?.[W],
              !!k
            );
          else {
            const z = y ? xv.PROGRESSING : xv.FAILURE;
            A.push({
              stage: K || `Untitled stage ${O + 1}`,
              startTime: W || "",
              endTime: F || "",
              // Would be defining the state when we receive the end status, otherwise it is loading and would be open
              isOpen: w(
                z,
                T.isOpen,
                // Wont be present in case of start stage since no logs are present yet
                !!I[K]?.[W],
                !!k
              ),
              status: z,
              logs: []
            });
          }
          return A;
        } catch {
          return A;
        }
      if (A.length > 0) {
        const { __html: K, isSearchKeyPresent: W } = b(P, k), F = A[A.length - 1];
        F.logs.push(K), W && (F.isOpen = w(
          F.status,
          N[F.stage]?.[F.startTime]?.isOpen,
          !0,
          !!k
        ), I[F.stage] || (I[F.stage] = {}), I[F.stage][F.startTime] = !0);
      }
      return A;
    }, []);
  };
  $e(() => {
    if (!l?.length)
      return;
    if (!_) {
      const N = l.map((I) => b(I).__html);
      g(N);
      return;
    }
    const k = S();
    h(k);
  }, [l, y]);
  const x = (k) => {
    m(k);
    const N = S(k);
    h(N);
  }, D = (k) => {
    const N = structuredClone(u);
    N[k].isOpen = !1, h(N);
  }, E = (k) => {
    const N = structuredClone(u);
    N[k].isOpen = !0, h(N);
  }, L = () => _ ? /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: "flexbox-col pb-20 logs-renderer-container flex-grow-1",
      "data-testid": "check-logs-detail",
      style: {
        backgroundColor: "#0C1021"
      },
      children: [
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: `flexbox-col pb-7 dc__position-sticky dc__zi-2 ${n ? "dc__top-0" : "dc__top-36"}`,
            style: {
              backgroundColor: "#0C1021"
            },
            children: /* @__PURE__ */ v.jsx(
              "div",
              {
                className: "flexbox logs-renderer__search-bar logs-renderer__filters-border-bottom pl-12",
                onKeyDown: Cr,
                children: /* @__PURE__ */ v.jsx(
                  _Ce,
                  {
                    noBackgroundAndBorder: !0,
                    containerClassName: "w-100",
                    inputProps: {
                      placeholder: "Search logs"
                    },
                    handleEnter: x,
                    initialSearchText: p,
                    size: Mi.large
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ v.jsx("div", { className: "flexbox-col px-12 dc__gap-4", children: u.map(({ stage: k, isOpen: N, logs: I, endTime: A, startTime: P, status: O }, K) => /* @__PURE__ */ v.jsx(
          Hke,
          {
            stage: k,
            isOpen: N,
            logs: I,
            endTime: A,
            startTime: P,
            status: O,
            handleStageClose: D,
            handleStageOpen: E,
            stageIndex: K,
            isLoading: K === u.length - 1 && y,
            fullScreenView: n
          },
          `${k}-${P}-log-stage-accordion`
        )) })
      ]
    }
  ) : /* @__PURE__ */ v.jsxs("div", { className: "logs__body dark-background flex-grow-1", "data-testid": "check-logs-detail", children: [
    f.map((k, N) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ v.jsxs("div", { className: "flex top left mb-10 lh-24", children: [
        /* @__PURE__ */ v.jsx("span", { className: "cn-4 col-2 pr-10", children: N + 1 }),
        /* @__PURE__ */ v.jsx(
          "p",
          {
            className: "mono fs-14 mb-0-imp",
            dangerouslySetInnerHTML: {
              __html: lA.sanitize(k)
            }
          }
        )
      ] }, `logs-${N}`)
    )),
    y && /* @__PURE__ */ v.jsx("div", { className: "flex left event-source-status", children: /* @__PURE__ */ v.jsx(Yr, {}) })
  ] });
  return i.podStatus !== Yk.PENDING && d && (!e || !i.blobStorageEnabled) ? zke(e) : L();
}, Iue = "data:image/png;base64,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", qke = ({
  imgSource: i,
  title: e,
  subtitle: t,
  ActionButtonIcon: n,
  actionButtonClass: r,
  actionButtonIconRight: s,
  actionButtonText: o,
  actionHandler: a,
  dataTestId: l
}) => {
  const c = () => o ? /* @__PURE__ */ v.jsxs(
    "button",
    {
      type: "button",
      className: `${r || ""} cta secondary flex h-32`,
      onClick: a,
      "data-testid": l,
      children: [
        n && !s && /* @__PURE__ */ v.jsx(n, { className: "add-icon" }),
        o,
        n && s && /* @__PURE__ */ v.jsx(n, { className: "icon-dim-16 ml-8" })
      ]
    }
  ) : null;
  return /* @__PURE__ */ v.jsx("div", { className: "dc__position-rel", style: { backgroundColor: "var(--window-bg)" }, children: /* @__PURE__ */ v.jsx(
    oa,
    {
      image: i || Iue,
      classname: "fs-16",
      title: e || jr.CD_EMPTY_STATE.TITLE,
      subTitle: t || jr.CD_EMPTY_STATE.SUBTITLE,
      isButtonAvailable: !0,
      imageType: Vl.Large,
      renderButton: c
    }
  ) });
}, Kke = qke, x3 = ({
  nonDeploymentError: i,
  type: e,
  errorMessage: t,
  hideVerticalConnector: n,
  hideErrorIcon: r
}) => i === e ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
  /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `bcr-1 ${e === Ot.HELM_MANIFEST_PUSHED_TO_HELM_REPO ? "fs-13" : "flex left"} ${r ? "" : "er-2 br-4 bw-1"} p-8`,
      children: [
        !r && /* @__PURE__ */ v.jsx(A0, { className: "icon-dim-20 mr-8" }),
        t,
        e === Ot.HELM_MANIFEST_PUSHED_TO_HELM_REPO && /* @__PURE__ */ v.jsxs("ol", { className: "m-0 pl-20", children: [
          /* @__PURE__ */ v.jsx("li", { children: "Ensure provided repository path is valid" }),
          /* @__PURE__ */ v.jsx("li", { children: "Check if credentials provided for OCI registry are valid and have PUSH permission" })
        ] })
      ]
    }
  ),
  !n && /* @__PURE__ */ v.jsx("div", { className: "vertical-connector" })
] }) : null, va = new dA({}), Zu = new dA([]), D3 = new dA([]), Xk = new dA({});
let gh = {
  filterType: "",
  searchString: ""
};
const HY = () => {
  const i = Zu.getValue().filter((e) => !gh.filterType && !gh.searchString || gh.filterType === "ALL" || gh.filterType.toLowerCase() === e.health?.status?.toLowerCase());
  D3.next([...i]);
};
function wj(i, e, t) {
  if (e.some((o) => o.childNodes))
    return e;
  let n = e;
  const r = /* @__PURE__ */ new Map();
  for (i.forEach((o) => {
    o.parentRefs?.forEach((a) => {
      const l = `${a.group}/${a.kind}/${a.name}`;
      r.has(l) ? r.get(l).push(o) : r.set(l, [o]);
    });
  }); n.length > 0; ) {
    const o = [];
    n.forEach((a) => {
      const l = `${a.group}/${a.kind}/${a.name}`;
      r.get(l) && (o.push(...r.get(l)), a.childNodes || (a.childNodes = []), a.childNodes.push(...r.get(l)));
    }), n = o;
  }
  let s = e;
  for (; s.length > 0; )
    s.forEach((o) => {
      (o.childNodes ?? []).sort((a, l) => a.name < l.name ? -1 : a.name > l.name ? 1 : 0);
    }), s.filter((o) => o.kind.toLowerCase() == En.Pod.toLowerCase()).map((o) => {
      o.childNodes = (t || va.getValue().resourceTree?.podMetadata)?.filter((a) => a.uid === o.uid)[0]?.containers?.map((a) => {
        const l = {};
        return l.kind = En.Containers, l.pNode = o, l.name = a, l;
      });
    }), s = s.flatMap((o) => o.childNodes ?? []);
  return e;
}
const Yke = (i, e) => i?.toLowerCase() == "degraded" || e?.toLowerCase() == "degraded" ? "degraded" : i?.toLowerCase() == "progressing" || e?.toLowerCase() == "progressing" ? "progressing" : "healthy";
function Xke(i, e) {
  const t = i.filter((n) => n.kind.toLowerCase() == e.toLowerCase()).map((n) => n);
  return wj(i, t);
}
function Zke(i) {
  const e = [...i.filter((s) => s.kind.toLowerCase() == En.Pod.toLowerCase())], t = /* @__PURE__ */ new Map();
  i.forEach((s) => {
    const o = `${s.group}/${s.kind}/${s.name}`;
    t.set(o, s);
  });
  let n = e.flatMap(
    (s) => (s.parentRefs ?? []).map((o) => [
      `${o.group}/${o.kind}/${o.name}`,
      s.health?.status ?? ""
    ])
  ).reduce((s, o) => (s.get(o[0]) ? s.set(o[0], Yke(s.get(o[0]), o[1])) : s.set(o[0], o[1]), s), /* @__PURE__ */ new Map());
  const r = /* @__PURE__ */ new Map();
  for (; n.size > 0; ) {
    const s = /* @__PURE__ */ new Map();
    n.forEach((o, a) => {
      if ((t.get(a)?.parentRefs ?? []).forEach(
        (l) => s.set(`${l.group}/${l.kind}/${l.name}`, o)
      ), (t.get(a)?.parentRefs ?? []).length == 0) {
        const l = t.get(a);
        l && r.set(`${l.group}/${l.kind}/${l.name}`, o);
      }
    }), n = s;
  }
  return Array.from(r, ([s, o]) => [s, o]).sort(
    (s, o) => s[0] > o[0] ? 1 : -1
  );
}
const Qke = (i, e) => {
  const t = e.filter((s) => s.name.toLowerCase() == i.toLowerCase() && !s.parentRefs).map((s) => s);
  let n = wj(e, t), r = [];
  for (; n?.length > 0; )
    r = r.concat(n.filter((s) => s.kind.toLowerCase() == En.Pod.toLowerCase())), n = n.flatMap((s) => s.childNodes ?? []);
  return r;
}, Sj = {
  setEnvDetails: (i, e, t) => {
    const n = {};
    n.envType = i, n.appId = e, n.envId = t, gh = {
      filterType: "",
      searchString: ""
    }, Xk.next({ ...n });
  },
  getEnvDetails: () => Xk.getValue(),
  getEnvDetailsObservable: () => Xk.asObservable(),
  publishAppDetails: (i, e) => {
    const t = i.resourceTree?.nodes || [], n = i.resourceTree?.podMetadata || [];
    wj(
      t,
      t.filter((r) => (r.parentRefs ?? []).length == 0).map((r) => r),
      n
    ), va.next({ ...i, appType: e }), Zu.next([...t]), D3.next([...t]);
  },
  getAppDetails: () => va.getValue(),
  getAppDetailsObservable: () => va.asObservable(),
  getAppDetailsNodes: () => Zu.getValue(),
  getAppDetailsNodesObservable: () => Zu.asObservable(),
  getAppDetailsFilteredNodes: () => D3.getValue(),
  getAppDetailsNodesFilteredObservable: () => D3.asObservable(),
  getiNodesByKind: (i) => {
    const e = Zu.getValue();
    return Xke(e, i);
  },
  getNodesByKind: (i) => Zu.getValue().filter((t) => t.kind.toLowerCase() === i.toLowerCase()),
  getMetaDataForPod: (i) => va.getValue().resourceTree?.podMetadata?.filter((e) => e.name === i)[0] || {},
  getPodMetaData: () => va.getValue().resourceTree.podMetadata,
  getPodsForRootNode: (i) => {
    const e = Zu.getValue();
    return Qke(i, e);
  },
  getAllPodNames: () => Zu.getValue().filter((i) => i.kind === En.Pod).map((i) => i.name),
  getPodsRootParentNameAndStatus: () => {
    const i = Zu.getValue();
    return Zke(i);
  },
  getAllContainersForPod: (i) => va.getValue().resourceTree?.podMetadata?.find((e) => e.name === i)?.containers,
  getAllContainers: () => {
    const i = [], e = va.getValue().resourceTree.podMetadata;
    return e.forEach((t) => {
      t.containers.forEach((n) => {
        i.push(n);
      });
    }), { containers: i, pods: e };
  },
  getAllNewContainers: () => {
    const i = [], e = va.getValue().resourceTree.podMetadata.filter((t) => t.isNew);
    return e.forEach((t) => {
      t.containers.forEach((n) => {
        i.push(n);
      });
    }), { containers: i, pods: e };
  },
  getAllOldContainers: () => {
    const i = [], e = va.getValue().resourceTree.podMetadata.filter((t) => !t.isNew);
    return e.forEach((t) => {
      t.containers.forEach((n) => {
        i.push(n);
      });
    }), { containers: i, pods: e };
  },
  getAllPods: () => va.getValue().resourceTree?.podMetadata || [],
  getAllNewPods: () => va.getValue().resourceTree.podMetadata.filter((e) => e.isNew),
  getAllOldPods: () => va.getValue().resourceTree.podMetadata.filter((e) => !e.isNew),
  getPodForAContainer: (i) => {
    let e;
    return va.getValue().resourceTree.podMetadata.forEach((t) => {
      t.containers.find((n) => {
        n === i && (e = t.name);
      });
    }), e;
  },
  updateFilterType: (i) => {
    gh = { ...gh, filterType: i }, HY();
  },
  updateFilterSearch: (i) => {
    i.length && i.length < 4 || (gh = { ...gh, searchString: i }, HY());
  }
}, Jke = ({ nodes: i, handleFilterClick: e }) => {
  const [t, n] = Oe("all");
  let r = 0, s = 0, o = 0, a = 0, l = 0;
  i?.forEach((u) => {
    const h = u.health?.status;
    h?.toLowerCase() === no.Healthy ? s += 1 : h?.toLowerCase() === no.Degraded ? a += 1 : h?.toLowerCase() === no.Progressing ? o += 1 : h?.toLowerCase() === no.Missing && (l += 1), r += 1;
  });
  const c = [
    { status: "all", count: r, isSelected: t == "all" },
    { status: no.Missing, count: l, isSelected: no.Missing == t },
    { status: no.Degraded, count: a, isSelected: no.Degraded == t },
    {
      status: no.Progressing,
      count: o,
      isSelected: no.Progressing == t
    },
    { status: no.Healthy, count: s, isSelected: no.Healthy == t }
  ];
  $e(() => {
    t === no.Healthy && s === 0 || t === no.Degraded && a === 0 || t === no.Progressing && o === 0 || t === no.Missing && l === 0 ? n("all") : e ? e(t) : Sj.updateFilterType(t.toUpperCase());
  }, [i, t]);
  const d = (u) => {
    n(u.target.value);
  };
  return /* @__PURE__ */ v.jsx(
    $C,
    {
      className: "gui-yaml-switch",
      name: "yaml-mode",
      initialTab: t,
      disabled: !1,
      onChange: d,
      children: c.length && c.map(
        (u, h) => u.count > 0 && /* @__PURE__ */ v.jsxs($C.Radio, { value: u.status, children: [
          h !== 0 && /* @__PURE__ */ v.jsx(
            "span",
            {
              className: `dc__app-summary__icon icon-dim-16 mr-6 ${u.status} ${u.status}--node`,
              style: { zIndex: "unset" }
            }
          ),
          /* @__PURE__ */ v.jsx("span", { className: "dc__first-letter-capitalize", children: u.status }),
          /* @__PURE__ */ v.jsxs("span", { className: "pl-4", children: [
            "(",
            u.count,
            ")"
          ] })
        ] })
      )
    }
  );
}, $ke = ({ filterRemoveHealth: i = !1, showFooter: e }) => {
  const t = Sj.getAppDetails(), [n, r] = Oe(""), s = Mn(
    () => IAe(t.resourceTree?.nodes || [], t.resourceTree?.podMetadata || []),
    [t]
  ), o = Object.keys(s?.nodes || {});
  let a = [];
  if (o.length > 0) {
    for (let d = 0; d < o.length; d++)
      s.nodes[o[d]].forEach((h) => {
        h.health && a.push(h);
      });
    a.sort(
      (d, u) => xY[d.health.status?.toLowerCase()] - xY[u.health.status?.toLowerCase()]
    ), i && (a = a.filter(
      (d) => d.health.status?.toLowerCase() !== ei.HEALTHY
    ));
  }
  function l(d, u) {
    return t.resourceTree?.resourcesSyncResult && // eslint-disable-next-line no-prototype-builtins
    t.resourceTree?.resourcesSyncResult.hasOwnProperty(`${d}/${u}`) ? t.resourceTree.resourcesSyncResult[`${d}/${u}`] : "";
  }
  const c = (d) => {
    n !== d.toLowerCase() && r(d.toLowerCase());
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "pb-12", children: [
    a.length > 0 && /* @__PURE__ */ v.jsx("div", { className: "pt-16 pl-20 pb-8", children: /* @__PURE__ */ v.jsx("div", { className: "flexbox pr-20 w-100", children: /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(Jke, { nodes: a, handleFilterClick: c }) }) }) }),
    /* @__PURE__ */ v.jsxs("div", { children: [
      /* @__PURE__ */ v.jsx("div", { className: "app-status-row dc__border-bottom pt-8 pr-20 pb-8 pl-20", children: EIe.map((d, u) => (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ v.jsx("div", { className: "fs-13 fw-6 cn-7", children: d }, `header_${u}`)
      )) }),
      /* @__PURE__ */ v.jsx("div", { className: `resource-list fs-13 ${e ? "with-footer" : ""}`, children: a.length > 0 ? a.filter(
        (d) => n === "all" || d.health.status?.toLowerCase() === n
      ).map((d) => /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: "app-status-row pt-8 pr-20 pb-8 pl-20",
          children: [
            /* @__PURE__ */ v.jsx(
              wn,
              {
                className: "default-tt",
                arrow: !1,
                placement: "right",
                content: d.kind,
                children: /* @__PURE__ */ v.jsx("div", { className: "dc__ellipsis-right", children: d.kind })
              }
            ),
            /* @__PURE__ */ v.jsx("div", { children: d.name }),
            /* @__PURE__ */ v.jsx(
              "div",
              {
                className: `app-summary__status-name f-${d.health.status ? d.health.status.toLowerCase() : ""}`,
                children: d.status ? d.status : d.health.status
              }
            ),
            /* @__PURE__ */ v.jsx("div", { children: l(d.kind, d.name) })
          ]
        },
        `${d.kind}/${d.name}`
      )) : /* @__PURE__ */ v.jsx("div", { className: "flex dc__height-inherit mh-300", children: /* @__PURE__ */ v.jsxs("div", { className: "dc__align-center", children: [
        /* @__PURE__ */ v.jsx(mS, { className: "icon-dim-20" }),
        /* @__PURE__ */ v.jsx("div", { children: "Checking resources status" })
      ] }) }) }),
      e && /* @__PURE__ */ v.jsxs("div", { className: "dc__position-fixed bcn-0 flexbox dc__content-space dc__border-top p-16 fs-13 fw-6 footer", children: [
        /* @__PURE__ */ v.jsx("span", { className: "fs-13 fw-6", children: "Facing issues in installing integration?" }),
        /* @__PURE__ */ v.jsxs(
          "a",
          {
            className: "help-chat cb-5 flex left",
            href: "https://discord.devtron.ai/",
            target: "_blank",
            rel: "noreferrer noopener",
            children: [
              /* @__PURE__ */ v.jsx(Xde, { className: "icon-dim-20 mr-8" }),
              " Chat with support"
            ]
          }
        )
      ] })
    ] })
  ] });
}, e6e = $ke, wp = ({
  type: i,
  hideVerticalConnector: e,
  deploymentDetailedData: t
}) => {
  const { appId: n, envId: r } = eo(), s = t.deploymentStatusBreakdown[i], [o, a] = Oe(s.isCollapsed), l = ["inprogress", "failed", "disconnect", "timed_out"], c = i === Ot.HELM_MANIFEST_PUSHED_TO_HELM_REPO && t.deploymentStatus === xIe.failed;
  $e(() => {
    a(s.isCollapsed);
  }, [s.isCollapsed]);
  async function d() {
    try {
      const p = await Oke({ appId: n, envId: r });
    } catch (p) {
      Is(p);
    }
  }
  const u = () => {
    a(!o);
  }, h = () => o ? null : /* @__PURE__ */ v.jsxs("div", { className: "bcn-0 en-2 detail-tab_border bw-1", children: [
    s.timelineStatus && /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: `flex left pt-8 pl-12 pb-8 lh-20 ${s.icon !== "inprogress" ? "bcr-1" : "bcy-2"}`,
        children: [
          t.deploymentStatusBreakdown[i].timelineStatus,
          (t.deploymentStatus === ei.TIMED_OUT || t.deploymentStatus === ei.UNABLE_TO_FETCH) && /* @__PURE__ */ v.jsx("span", { className: "cb-5 fw-6 ml-8 cursor", onClick: d, children: "Try now" })
        ]
      }
    ),
    i === Ot.KUBECTL_APPLY && /* @__PURE__ */ v.jsxs("div", { className: "pr-8 pl-8 pt-12 pb-12", children: [
      /* @__PURE__ */ v.jsx("div", { className: "", children: t.deploymentStatusBreakdown[Ot.KUBECTL_APPLY].kubeList?.map((p, m) => (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ v.jsxs("div", { className: "flex left lh-20 mb-8", children: [
          LY(p.icon),
          /* @__PURE__ */ v.jsx("span", { className: "ml-12", children: p.message })
        ] }, `item-${m}`)
      )) }),
      s.resourceDetails?.length ? /* @__PURE__ */ v.jsxs("div", { className: "pl-32", children: [
        /* @__PURE__ */ v.jsx("div", { className: "app-status-row dc__border-bottom pt-8 pb-8", children: L5e.map((p, m) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ v.jsx("div", { className: "fs-13 fw-6 cn-7", children: p }, `header_${m}`)
        )) }),
        /* @__PURE__ */ v.jsx("div", { className: "resource-list fs-13", children: s.resourceDetails.map((p) => /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: "app-status-row pt-8 pb-8",
            children: [
              /* @__PURE__ */ v.jsx("div", { className: "dc__break-word", children: p.resourceKind }),
              /* @__PURE__ */ v.jsx("div", { className: "dc__break-word", children: p.resourceName }),
              /* @__PURE__ */ v.jsx(
                "div",
                {
                  className: `app-summary__status-name f-${p.resourceStatus ? p.resourceStatus.toLowerCase() === fr.RUNNING ? fr.PROGRESSING : p.resourceStatus.toLowerCase() : ""}`,
                  children: p.resourceStatus
                }
              ),
              /* @__PURE__ */ v.jsx(wue, { text: p.statusMessage })
            ]
          },
          `${p.resourceKind}/${p.resourceName}`
        )) })
      ] }) : null
    ] })
  ] }), f = () => !o && /* @__PURE__ */ v.jsxs("div", { className: "bcn-0 en-2 detail-tab_border bw-1", children: [
    s.timelineStatus && /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: `flex left pt-8 pl-12 pb-8 lh-20 ${s.icon !== "inprogress" ? "bcr-1" : "bcy-2"}`,
        children: [
          s.timelineStatus,
          (t.deploymentStatus === ei.TIMED_OUT || t.deploymentStatus === ei.UNABLE_TO_FETCH) && /* @__PURE__ */ v.jsx("span", { className: "cb-5 fw-6 ml-8 cursor", onClick: d, children: "Try now" })
        ]
      }
    ),
    /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(e6e, { filterRemoveHealth: !0, showFooter: !1 }) })
  ] }), g = () => /* @__PURE__ */ v.jsx(
    x3,
    {
      type: Ot.HELM_MANIFEST_PUSHED_TO_HELM_REPO,
      nonDeploymentError: t.nonDeploymentError,
      errorMessage: t.deploymentError,
      hideVerticalConnector: !0,
      hideErrorIcon: !0
    }
  );
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs("div", { className: "bw-1 en-2", children: [
      /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: `deployment-status-breakdown-row pt-8 pb-8 pl-8 pr-8 bcn-0  ${o ? c ? "" : "br-4" : "border-collapse"}`,
          children: [
            LY(s.icon),
            /* @__PURE__ */ v.jsxs("span", { className: "ml-12 mr-12 fs-13", children: [
              /* @__PURE__ */ v.jsx("span", { "data-testid": "deployment-status-step-name", children: s.displayText }),
              s.displaySubText && /* @__PURE__ */ v.jsx("span", { className: `ml-12 f-${s.icon || "waiting"}`, children: s.displaySubText })
            ] }),
            s.time !== "" && s.icon !== "inprogress" && /* @__PURE__ */ v.jsx(
              "span",
              {
                "data-testid": "deployment-status-kubernetes-dropdown",
                className: `pl-8 pr-8 pt-4 pb-4 br-12 ${s.icon === "failed" ? "bcr-1 cr-5" : "bcg-1 cg-7"}`,
                children: st(s.time, "YYYY-MM-DDTHH:mm:ssZ").format(
                  id.TWELVE_HOURS_FORMAT
                )
              }
            ),
            (i === Ot.KUBECTL_APPLY && s.kubeList?.length || i === Ot.APP_HEALTH && l.includes(s.icon) || (i === Ot.GIT_COMMIT || i === Ot.ARGOCD_SYNC) && s.icon === "failed") && /* @__PURE__ */ v.jsx(
              vu,
              {
                style: { marginLeft: "auto", "--rotateBy": `${180 * +!o}deg` },
                className: "icon-dim-24 rotate pointer",
                onClick: u,
                "data-testid": "steps-deployment-history-dropdown"
              }
            )
          ]
        }
      ),
      c && g()
    ] }),
    i === Ot.GIT_COMMIT && h(),
    i === Ot.ARGOCD_SYNC && h(),
    i === Ot.KUBECTL_APPLY && h(),
    i === Ot.APP_HEALTH && f(),
    !e && /* @__PURE__ */ v.jsx("div", { className: "vertical-connector" })
  ] });
}, t6e = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { d: "M0 0h32v32H0z" }), /* @__PURE__ */ G.createElement("path", { fill: "#de350b", d: "M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667z" }), /* @__PURE__ */ G.createElement("path", { fill: "#FFF", d: "M16 14.667c.736 0 1.333.597 1.333 1.333v5.333a1.333 1.333 0 1 1-2.666 0V16c0-.736.597-1.333 1.333-1.333zm0-5.334A1.333 1.333 0 1 1 16 12a1.333 1.333 0 0 1 0-2.667z" })));
var nR = /* @__PURE__ */ ((i) => (i.ERRIMAGEPULL = "errimagepull", i.IMAGEPULLBACKOFF = "imagepullbackoff", i))(nR || {});
const n6e = (i, e, t) => /* @__PURE__ */ v.jsxs("div", { children: [
  "'",
  i.clusterName,
  "' cluster",
  i.ipsAccessProvided ? " could not" : " does not have permission to",
  " pull container image from ‘",
  i.dockerRegistryId,
  "’ registry.",
  e === "sync-error" && /* @__PURE__ */ v.jsx("span", { className: "cb-5 cursor fw-6 ml-8", onClick: t, children: i.ipsAccessProvided ? "Possible issues?" : "How to resolve?" })
] }), i6e = ({ appDetails: i }) => {
  const [e, t] = Oe(!1);
  return $e(() => {
    if (i.appType === z8.DEVTRON_APP && i.resourceTree?.nodes?.length)
      for (let n = 0; n < i.resourceTree.nodes.length; n++) {
        const r = i.resourceTree.nodes[n];
        let s = !1;
        if (r.info?.length) {
          for (let o = 0; o < r.info.length; o++) {
            const a = r.info[o];
            if (a.value && (a.value.toLowerCase() === nR.ERRIMAGEPULL || a.value.toLowerCase() === nR.IMAGEPULLBACKOFF)) {
              s = !0;
              break;
            }
          }
          if (s) {
            t(!0);
            break;
          }
        }
      }
  }, [i]), !i || i.appType !== z8.DEVTRON_APP || !i.resourceTree || !i.resourceTree.nodes || i.externalCi ? null : e && /* @__PURE__ */ v.jsxs("div", { className: "er-2 bw-1 br-4 m-20 fs-13", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "bcr-1 pl-12 pr-12 pt-8 pb-8 dc__border-bottom-r2 flex left", children: [
      /* @__PURE__ */ v.jsx(t6e, { className: "icon-dim-24 mr-8" }),
      " ",
      /* @__PURE__ */ v.jsx("span", { className: "mr-8", children: "IMAGEPULLBACKOFF:" }),
      n6e(i, "error-bar")
    ] }),
    i.ipsAccessProvided ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs("div", { className: "pl-12 pr-12 pt-8 pb-8", children: [
        /* @__PURE__ */ v.jsx("div", { className: "fw-6", children: "Possible issues? " }),
        "1. Provided credentials may not have permission to pull image from ‘",
        i.dockerRegistryId,
        "’ registry. ",
        /* @__PURE__ */ v.jsx("br", {}),
        "2. Provided credentials may be invalid."
      ] }),
      /* @__PURE__ */ v.jsxs("div", { className: "pl-12 pr-12 pt-8 pb-8", style: { background: "var(--N50)" }, children: [
        /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
          /* @__PURE__ */ v.jsx("span", { className: "mr-8 fw-6", children: "Already provided permission?" }),
          "Redeploy the application.",
          /* @__PURE__ */ v.jsx(
            uo,
            {
              to: `/app/${i.appId}/${sr.APP_TRIGGER}`,
              className: "cb-5 fs-13 anchor w-auto dc__no-decor flex",
              children: "  Go to Deploy"
            }
          )
        ] }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
          /* @__PURE__ */ v.jsx("span", { className: "mr-8 fw-6", children: "Facing issues?" }),
          /* @__PURE__ */ v.jsx(
            "a",
            {
              href: "https://discord.devtron.ai/",
              className: "cb-5 fs-13 anchor w-auto dc__no-decor flex",
              target: "_blank",
              rel: "noreferrer",
              children: "Chat with support"
            }
          )
        ] })
      ] })
    ] }) : /* @__PURE__ */ v.jsxs("div", { className: "pl-12 pr-12 pt-8 pb-8", children: [
      /* @__PURE__ */ v.jsx("div", { className: "fw-6", children: "How to resolve? " }),
      /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
        "1. Allow '",
        i.clusterName,
        "' cluster to access credentials for ‘",
        i.dockerRegistryId,
        "’ registry and deploy again.",
        /* @__PURE__ */ v.jsx("br", {}),
        /* @__PURE__ */ v.jsx(
          uo,
          {
            to: `${sr.GLOBAL_CONFIG_DOCKER}/${i.dockerRegistryId}`,
            className: "cb-5 fs-13 anchor w-auto dc__no-decor flex ml-8",
            children: "Manage access  "
          }
        )
      ] }),
      "2. Redeploy the application after allowing access",
      /* @__PURE__ */ v.jsx("span", { className: "flex left" })
    ] })
  ] });
}, r6e = i6e, s6e = ({
  deploymentStatusDetailsBreakdownData: i,
  isVirtualEnvironment: e
}) => {
  const t = Sj.getAppDetails(), { url: n } = fd(), r = i.deploymentStatusBreakdown[Ot.HELM_MANIFEST_PUSHED_TO_HELM_REPO]?.showHelmManifest;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    !n.includes(`/${sr.CD_DETAILS}`) && /* @__PURE__ */ v.jsx(r6e, { appDetails: t }),
    /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: "deployment-status-breakdown-container pl-20 pr-20 pt-20 pb-20",
        "data-testid": "deployment-history-steps-status",
        children: [
          /* @__PURE__ */ v.jsx(
            wp,
            {
              type: Ot.DEPLOYMENT_INITIATED,
              deploymentDetailedData: i
            }
          ),
          e && i.deploymentStatusBreakdown[Ot.HELM_PACKAGE_GENERATED] ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(
              wp,
              {
                type: Ot.HELM_PACKAGE_GENERATED,
                hideVerticalConnector: !r,
                deploymentDetailedData: i
              }
            ),
            r && /* @__PURE__ */ v.jsx(
              wp,
              {
                type: Ot.HELM_MANIFEST_PUSHED_TO_HELM_REPO,
                hideVerticalConnector: !0,
                deploymentDetailedData: i
              }
            )
          ] }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(
              x3,
              {
                type: Ot.GIT_COMMIT,
                nonDeploymentError: i.nonDeploymentError,
                errorMessage: i.deploymentError
              }
            ),
            /* @__PURE__ */ v.jsx(
              wp,
              {
                type: Ot.GIT_COMMIT,
                deploymentDetailedData: i
              }
            ),
            /* @__PURE__ */ v.jsx(
              x3,
              {
                type: Ot.ARGOCD_SYNC,
                nonDeploymentError: i.nonDeploymentError,
                errorMessage: i.deploymentError
              }
            ),
            /* @__PURE__ */ v.jsx(
              wp,
              {
                type: Ot.ARGOCD_SYNC,
                deploymentDetailedData: i
              }
            ),
            /* @__PURE__ */ v.jsx(
              x3,
              {
                type: Ot.KUBECTL_APPLY,
                nonDeploymentError: i.nonDeploymentError,
                errorMessage: i.deploymentError
              }
            ),
            /* @__PURE__ */ v.jsx(
              wp,
              {
                type: Ot.KUBECTL_APPLY,
                deploymentDetailedData: i
              }
            ),
            /* @__PURE__ */ v.jsx(
              wp,
              {
                type: Ot.APP_HEALTH,
                hideVerticalConnector: !0,
                deploymentDetailedData: i
              }
            )
          ] })
        ]
      }
    )
  ] });
}, o6e = s6e;
let Nx = null;
const a6e = ({
  deploymentStatus: i,
  deploymentAppType: e,
  isHelmApps: t = !1,
  installedAppVersionHistoryId: n,
  isGitops: r,
  userApprovalMetadata: s,
  isVirtualEnvironment: o,
  processVirtualEnvironmentDeploymentData: a,
  renderDeploymentApprovalInfo: l
}) => {
  const c = ip(), { url: d } = fd(), { appId: u, envId: h, triggerId: f } = eo(), [g, p] = Oe(
    i?.toUpperCase() !== Ot.ABORTED
  ), m = Nt(o), _ = m.current && a ? a() : rY(), [b, w] = Oe(_), y = () => {
    Nx && clearTimeout(Nx);
  }, S = () => {
    Pke(u, h, !0, f, t, n).then((L) => {
      i !== "Aborted" && x(L.result);
    }).catch(() => {
      p(!1);
    }).finally(() => {
      p(!1);
    });
  };
  $e(() => (e === bv.HELM && c.replace(`${d.replace("deployment-steps", "source-code")}`), r && S(), () => {
    y();
  }), [n]), $e(() => {
    m.current = o;
  }, [o]);
  const x = (L) => {
    const k = m.current && a ? a(L) : rY(L);
    y(), k.deploymentStatus === ei.INPROGRESS ? Nx = setTimeout(() => {
      S();
    }, 1e4) : Nx = setTimeout(() => {
      S();
    }, 3e4), w(k);
  }, D = () => {
    if (t) {
      c.push({
        pathname: `${sr.APP}/${sr.DEVTRON_CHARTS}/${sr.APP_DEPLOYMNENT_HISTORY}/${u}/env/${h}/${sr.DETAILS}/${sr.APP_DETAILS_K8}`,
        search: wY
      });
      return;
    }
    c.push({
      pathname: `${sr.APP}/${u}/${sr.APP_DETAILS}/${h}/${sr.APP_DETAILS_K8}`,
      search: wY
    });
  }, E = () => !m.current && !b?.deploymentStatusBreakdown?.APP_HEALTH?.isCollapsed ? /* @__PURE__ */ v.jsx("div", { className: "h-100 flex", children: /* @__PURE__ */ v.jsx(
    Kke,
    {
      title: jr.DEPLOYMENT_DETAILS_SETPS_PROGRESSING.TITLE,
      imgSource: _ke,
      actionButtonClass: "bcb-5 cn-0",
      ActionButtonIcon: Cue,
      actionHandler: D,
      subtitle: jr.DEPLOYMENT_DETAILS_SETPS_PROGRESSING.SUBTITLE,
      actionButtonText: "Check live status",
      actionButtonIconRight: !0,
      dataTestId: "deployment-progress"
    }
  ) }) : /* @__PURE__ */ v.jsxs("div", { className: "dc__mxw-1000 min-w-800", children: [
    l && s && l(s),
    /* @__PURE__ */ v.jsx(
      o6e,
      {
        deploymentStatusDetailsBreakdownData: b,
        isVirtualEnvironment: m.current
      }
    )
  ] });
  return i?.toUpperCase() === Ot.ABORTED || b.deploymentStatus === ei.SUPERSEDED ? /* @__PURE__ */ v.jsx("div", { className: "flexbox deployment-aborted", "data-testid": "deployment-history-steps-failed-message", children: /* @__PURE__ */ v.jsx(
    oa,
    {
      title: jr.DEPLOYMENT_DETAILS_SETPS_FAILED.TITLE,
      subTitle: jr.DEPLOYMENT_DETAILS_SETPS_FAILED.SUBTITLE
    }
  ) }) : g ? /* @__PURE__ */ v.jsx(Yr, { pageLoader: !0 }) : E();
}, l6e = a6e, c6e = {
  ...fue,
  menu: (i) => ({ ...i, zIndex: 9999, textAlign: "left", width: "150%" }),
  control: (i) => ({
    ...i,
    backgroundColor: "transparent",
    minHeight: "12px",
    cursor: "pointer",
    border: 0,
    outline: "none",
    boxShadow: "none",
    fontSize: "13px"
  }),
  singleValue: (i) => ({
    ...i,
    fontWeight: 600,
    color: "#06c",
    marginLeft: 0
  }),
  option: (i, e) => ({
    ...i,
    backgroundColor: e.isFocused ? "var(--N100)" : "white",
    color: "var(--N900)",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    cursor: "pointer",
    padding: "0 4px"
  }),
  valueContainer: (i) => ({
    ...i,
    height: "20px",
    padding: 0
  }),
  indicatorsContainer: (i) => ({
    ...i,
    padding: 0
  }),
  dropdownIndicator: (i) => ({ ...i, padding: 0 })
}, d6e = (i) => {
  const {
    isSelected: e,
    data: { status: t, author: n, runSource: r, renderRunSource: s, resourceId: o },
    label: a
  } = i;
  return /* @__PURE__ */ v.jsx(zi.Option, { ...i, children: /* @__PURE__ */ v.jsxs("div", { className: `flex dc__align-start left pt-8 pb-8 pl-8 pr-8 ${e ? "bcb-1" : ""}`, children: [
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: `flexbox dc__align-items-start dc__app-summary__icon icon-dim-22 ${t.toLocaleLowerCase().replace(/\s+/g, "")} mr-8`
      }
    ),
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
      /* @__PURE__ */ v.jsxs("div", { children: [
        /* @__PURE__ */ v.jsxs("div", { className: "cn-9 fs-13", children: [
          " ",
          a
        ] }),
        /* @__PURE__ */ v.jsxs("div", { className: "cn-7 flex left", children: [
          /* @__PURE__ */ v.jsx("span", { className: "dc__capitalize", children: "Deploy" }),
          " ",
          /* @__PURE__ */ v.jsx("div", { className: "dc__bullet ml-4 dc__bullet--d2 mr-4" }),
          " ",
          n === "system" ? "auto-triggered" : n
        ] })
      ] }),
      r && s && s(r, o === r.id)
    ] })
  ] }) });
}, u6e = ({
  selectedDeploymentTemplate: i,
  setSelectedDeploymentTemplate: e,
  setFullScreenView: t,
  setLoader: n,
  setPreviousConfigAvailable: r,
  renderRunSource: s,
  resourceId: o
}) => {
  const { url: a } = fd(), l = ip(), { pipelineId: c, historyComponent: d, baseConfigurationId: u, historyComponentName: h } = eo(), [f, g] = Oe(""), [p, m] = Oe([]), _ = (S) => {
    e(S);
  };
  $e(() => {
    if (c && d && u)
      try {
        n(!0), Bke(c, d, u, h).then(
          (S) => {
            const x = [];
            if (S.result) {
              const D = S.result.length;
              for (let E = 0; E < D; E++)
                S.result[E].id.toString() === u ? g(S.result[E].deployedOn) : x.push({
                  value: String(S.result[E].id),
                  label: st(S.result[E].deployedOn).format(
                    id.TWELVE_HOURS_FORMAT
                  ),
                  author: S.result[E].deployedBy,
                  status: S.result[E].deploymentStatus,
                  runSource: S.result[E].runSource,
                  renderRunSource: s,
                  resourceId: o
                });
            }
            r(x.length > 0), m(x), e(
              x[0] || {
                label: "NA",
                value: "NA",
                author: "NA",
                status: "NA",
                runSource: null
              }
            );
          }
        );
      } catch (S) {
        Is(S), n(!1);
      }
  }, [d, u, h]);
  const b = () => /* @__PURE__ */ v.jsx(
    uo,
    {
      "data-testid": "configuration-back-arrow",
      to: "",
      className: "flex",
      onClick: (S) => {
        S.preventDefault(), t(!1), l.push(
          `${a.split(sr.DEPLOYMENT_HISTORY_CONFIGURATIONS)[0]}${sr.DEPLOYMENT_HISTORY_CONFIGURATIONS}`
        );
      },
      children: /* @__PURE__ */ v.jsx(pue, { className: "rotate icon-dim-24 mr-16" })
    }
  ), w = () => /* @__PURE__ */ v.jsxs("div", { className: "pt-12 pb-12 pl-16 compare-history__border-left pr-16", children: [
    /* @__PURE__ */ v.jsx("div", { className: "cn-6 lh-1-43 ", "data-testid": "configuration-compare-with-heading", children: "Compare with" }),
    /* @__PURE__ */ v.jsx("div", { style: { minWidth: "200px" }, children: p.length > 0 ? /* @__PURE__ */ v.jsx(
      Ba,
      {
        placeholder: "Select Timestamp",
        classNamePrefix: "configuration-compare-with-dropdown",
        isSearchable: !1,
        styles: c6e,
        onChange: _,
        options: p,
        components: {
          IndicatorSeparator: null,
          Option: d6e
        },
        value: i || p[0]
      }
    ) : /* @__PURE__ */ v.jsx("div", { className: "cn-9 fs-13 fw-4", children: /* @__PURE__ */ v.jsx(
      wn,
      {
        className: "default-tt left-50",
        placement: "bottom",
        arrow: !1,
        content: /* @__PURE__ */ v.jsxs("span", { style: { display: "block", width: "180px" }, children: [
          Xo[d.replace("-", "_").toUpperCase()]?.DISPLAY_NAME,
          h ? ` “${h}”` : "",
          " was added in this deployment. There is no previous instance to compare with."
        ] }),
        children: /* @__PURE__ */ v.jsx("span", { "data-testid": "deployment-history-configuration-no-options", children: "No options" })
      }
    ) }) })
  ] }), y = () => /* @__PURE__ */ v.jsxs("div", { className: "compare-history__border-left pt-12 pb-12 pl-16 pr-16", children: [
    /* @__PURE__ */ v.jsx("span", { className: "cn-6", "data-testid": "configuration-base-configuration-heading", children: "Base configuration" }),
    /* @__PURE__ */ v.jsx("div", { className: "cn-9 fs-13", children: f && st(f).format(id.TWELVE_HOURS_FORMAT) })
  ] });
  return /* @__PURE__ */ v.jsxs("div", { className: "dc__border-bottom pl-20 pr-20 flex left bcn-0", children: [
    b(),
    w(),
    y()
  ] });
};
function Ja(i, e = 0) {
  return i[i.length - (1 + e)];
}
function h6e(i) {
  if (i.length === 0)
    throw new Error("Invalid tail call");
  return [i.slice(0, i.length - 1), i[i.length - 1]];
}
function Qi(i, e, t = (n, r) => n === r) {
  if (i === e)
    return !0;
  if (!i || !e || i.length !== e.length)
    return !1;
  for (let n = 0, r = i.length; n < r; n++)
    if (!t(i[n], e[n]))
      return !1;
  return !0;
}
function f6e(i, e) {
  const t = i.length - 1;
  e < t && (i[e] = i[t]), i.pop();
}
function vy(i, e, t) {
  return g6e(i.length, (n) => t(i[n], e));
}
function g6e(i, e) {
  let t = 0, n = i - 1;
  for (; t <= n; ) {
    const r = (t + n) / 2 | 0, s = e(r);
    if (s < 0)
      t = r + 1;
    else if (s > 0)
      n = r - 1;
    else
      return r;
  }
  return -(t + 1);
}
function iR(i, e, t) {
  if (i = i | 0, i >= e.length)
    throw new TypeError("invalid index");
  const n = e[Math.floor(e.length * Math.random())], r = [], s = [], o = [];
  for (const a of e) {
    const l = t(a, n);
    l < 0 ? r.push(a) : l > 0 ? s.push(a) : o.push(a);
  }
  return i < r.length ? iR(i, r, t) : i < r.length + o.length ? o[0] : iR(i - (r.length + o.length), s, t);
}
function WY(i, e) {
  const t = [];
  let n;
  for (const r of i.slice(0).sort(e))
    !n || e(n[0], r) !== 0 ? (n = [r], t.push(n)) : n.push(r);
  return t;
}
function* Aue(i, e) {
  let t, n;
  for (const r of i)
    n !== void 0 && e(n, r) ? t.push(r) : (t && (yield t), t = [r]), n = r;
  t && (yield t);
}
function kue(i, e) {
  for (let t = 0; t <= i.length; t++)
    e(t === 0 ? void 0 : i[t - 1], t === i.length ? void 0 : i[t]);
}
function p6e(i, e) {
  for (let t = 0; t < i.length; t++)
    e(t === 0 ? void 0 : i[t - 1], i[t], t + 1 === i.length ? void 0 : i[t + 1]);
}
function _u(i) {
  return i.filter((e) => !!e);
}
function jY(i) {
  let e = 0;
  for (let t = 0; t < i.length; t++)
    i[t] && (i[e] = i[t], e += 1);
  i.length = e;
}
function Tue(i) {
  return !Array.isArray(i) || i.length === 0;
}
function Bs(i) {
  return Array.isArray(i) && i.length > 0;
}
function kg(i, e = (t) => t) {
  const t = /* @__PURE__ */ new Set();
  return i.filter((n) => {
    const r = e(n);
    return t.has(r) ? !1 : (t.add(r), !0);
  });
}
function Nue(i, e) {
  return i.length > 0 ? i[0] : e;
}
function io(i, e) {
  let t = typeof e == "number" ? i : 0;
  typeof e == "number" ? t = i : (t = 0, e = i);
  const n = [];
  if (t <= e)
    for (let r = t; r < e; r++)
      n.push(r);
  else
    for (let r = t; r > e; r--)
      n.push(r);
  return n;
}
function HA(i, e, t) {
  const n = i.slice(0, e), r = i.slice(e);
  return n.concat(t, r);
}
function Zk(i, e) {
  const t = i.indexOf(e);
  t > -1 && (i.splice(t, 1), i.unshift(e));
}
function Px(i, e) {
  const t = i.indexOf(e);
  t > -1 && (i.splice(t, 1), i.push(e));
}
function rR(i, e) {
  for (const t of e)
    i.push(t);
}
function xj(i) {
  return Array.isArray(i) ? i : [i];
}
function m6e(i, e, t) {
  const n = Pue(i, e), r = i.length, s = t.length;
  i.length = r + s;
  for (let o = r - 1; o >= n; o--)
    i[o + s] = i[o];
  for (let o = 0; o < s; o++)
    i[o + n] = t[o];
}
function zY(i, e, t, n) {
  const r = Pue(i, e);
  let s = i.splice(r, t);
  return s === void 0 && (s = []), m6e(i, r, n), s;
}
function Pue(i, e) {
  return e < 0 ? Math.max(e + i.length, 0) : Math.min(e, i.length);
}
var _y;
(function(i) {
  function e(s) {
    return s < 0;
  }
  i.isLessThan = e;
  function t(s) {
    return s <= 0;
  }
  i.isLessThanOrEqual = t;
  function n(s) {
    return s > 0;
  }
  i.isGreaterThan = n;
  function r(s) {
    return s === 0;
  }
  i.isNeitherLessOrGreaterThan = r, i.greaterThan = 1, i.lessThan = -1, i.neitherLessOrGreaterThan = 0;
})(_y || (_y = {}));
function hl(i, e) {
  return (t, n) => e(i(t), i(n));
}
function v6e(...i) {
  return (e, t) => {
    for (const n of i) {
      const r = n(e, t);
      if (!_y.isNeitherLessOrGreaterThan(r))
        return r;
    }
    return _y.neitherLessOrGreaterThan;
  };
}
const Rh = (i, e) => i - e, _6e = (i, e) => Rh(i ? 1 : 0, e ? 1 : 0);
function Oue(i) {
  return (e, t) => -i(e, t);
}
class Xh {
  /**
   * Constructs a queue that is backed by the given array. Runtime is O(1).
  */
  constructor(e) {
    this.items = e, this.firstIdx = 0, this.lastIdx = this.items.length - 1;
  }
  get length() {
    return this.lastIdx - this.firstIdx + 1;
  }
  /**
   * Consumes elements from the beginning of the queue as long as the predicate returns true.
   * If no elements were consumed, `null` is returned. Has a runtime of O(result.length).
  */
  takeWhile(e) {
    let t = this.firstIdx;
    for (; t < this.items.length && e(this.items[t]); )
      t++;
    const n = t === this.firstIdx ? null : this.items.slice(this.firstIdx, t);
    return this.firstIdx = t, n;
  }
  /**
   * Consumes elements from the end of the queue as long as the predicate returns true.
   * If no elements were consumed, `null` is returned.
   * The result has the same order as the underlying array!
  */
  takeFromEndWhile(e) {
    let t = this.lastIdx;
    for (; t >= 0 && e(this.items[t]); )
      t--;
    const n = t === this.lastIdx ? null : this.items.slice(t + 1, this.lastIdx + 1);
    return this.lastIdx = t, n;
  }
  peek() {
    if (this.length !== 0)
      return this.items[this.firstIdx];
  }
  dequeue() {
    const e = this.items[this.firstIdx];
    return this.firstIdx++, e;
  }
  takeCount(e) {
    const t = this.items.slice(this.firstIdx, this.firstIdx + e);
    return this.firstIdx += e, t;
  }
}
class au {
  constructor(e) {
    this.iterate = e;
  }
  toArray() {
    const e = [];
    return this.iterate((t) => (e.push(t), !0)), e;
  }
  filter(e) {
    return new au((t) => this.iterate((n) => e(n) ? t(n) : !0));
  }
  map(e) {
    return new au((t) => this.iterate((n) => t(e(n))));
  }
  findLast(e) {
    let t;
    return this.iterate((n) => (e(n) && (t = n), !0)), t;
  }
  findLastMaxBy(e) {
    let t, n = !0;
    return this.iterate((r) => ((n || _y.isGreaterThan(e(r, t))) && (n = !1, t = r), !0)), t;
  }
}
au.empty = new au((i) => {
});
function mo(i) {
  return typeof i == "string";
}
function ho(i) {
  return typeof i == "object" && i !== null && !Array.isArray(i) && !(i instanceof RegExp) && !(i instanceof Date);
}
function b6e(i) {
  const e = Object.getPrototypeOf(Uint8Array);
  return typeof i == "object" && i instanceof e;
}
function Tg(i) {
  return typeof i == "number" && !isNaN(i);
}
function UY(i) {
  return !!i && typeof i[Symbol.iterator] == "function";
}
function Mue(i) {
  return i === !0 || i === !1;
}
function Jo(i) {
  return typeof i > "u";
}
function by(i) {
  return !xa(i);
}
function xa(i) {
  return Jo(i) || i === null;
}
function On(i, e) {
  if (!i)
    throw new Error("Unexpected type");
}
function am(i) {
  if (xa(i))
    throw new Error("Assertion Failed: argument is undefined or null");
  return i;
}
function Cy(i) {
  return typeof i == "function";
}
function C6e(i, e) {
  const t = Math.min(i.length, e.length);
  for (let n = 0; n < t; n++)
    y6e(i[n], e[n]);
}
function y6e(i, e) {
  if (mo(e)) {
    if (typeof i !== e)
      throw new Error(`argument does not match constraint: typeof ${e}`);
  } else if (Cy(e)) {
    try {
      if (i instanceof e)
        return;
    } catch {
    }
    if (!xa(i) && i.constructor === e || e.length === 1 && e.call(void 0, i) === !0)
      return;
    throw new Error("argument does not match one of these constraints: arg instanceof constraint, arg.constructor === constraint, nor constraint(arg) === true");
  }
}
function lh(i) {
  if (!i || typeof i != "object" || i instanceof RegExp)
    return i;
  const e = Array.isArray(i) ? [] : {};
  return Object.entries(i).forEach(([t, n]) => {
    e[t] = n && typeof n == "object" ? lh(n) : n;
  }), e;
}
function w6e(i) {
  if (!i || typeof i != "object")
    return i;
  const e = [i];
  for (; e.length > 0; ) {
    const t = e.shift();
    Object.freeze(t);
    for (const n in t)
      if (Rue.call(t, n)) {
        const r = t[n];
        typeof r == "object" && !Object.isFrozen(r) && !b6e(r) && e.push(r);
      }
  }
  return i;
}
const Rue = Object.prototype.hasOwnProperty;
function Fue(i, e) {
  return sR(i, e, /* @__PURE__ */ new Set());
}
function sR(i, e, t) {
  if (xa(i))
    return i;
  const n = e(i);
  if (typeof n < "u")
    return n;
  if (Array.isArray(i)) {
    const r = [];
    for (const s of i)
      r.push(sR(s, e, t));
    return r;
  }
  if (ho(i)) {
    if (t.has(i))
      throw new Error("Cannot clone recursive data-structure");
    t.add(i);
    const r = {};
    for (const s in i)
      Rue.call(i, s) && (r[s] = sR(i[s], e, t));
    return t.delete(i), r;
  }
  return i;
}
function WA(i, e, t = !0) {
  return ho(i) ? (ho(e) && Object.keys(e).forEach((n) => {
    n in i ? t && (ho(i[n]) && ho(e[n]) ? WA(i[n], e[n], t) : i[n] = e[n]) : i[n] = e[n];
  }), i) : e;
}
function Ra(i, e) {
  if (i === e)
    return !0;
  if (i == null || e === null || e === void 0 || typeof i != typeof e || typeof i != "object" || Array.isArray(i) !== Array.isArray(e))
    return !1;
  let t, n;
  if (Array.isArray(i)) {
    if (i.length !== e.length)
      return !1;
    for (t = 0; t < i.length; t++)
      if (!Ra(i[t], e[t]))
        return !1;
  } else {
    const r = [];
    for (n in i)
      r.push(n);
    r.sort();
    const s = [];
    for (n in e)
      s.push(n);
    if (s.sort(), !Ra(r, s))
      return !1;
    for (t = 0; t < r.length; t++)
      if (!Ra(i[r[t]], e[r[t]]))
        return !1;
  }
  return !0;
}
function S6e(i) {
  let e = [];
  for (; Object.prototype !== i; )
    e = e.concat(Object.getOwnPropertyNames(i)), i = Object.getPrototypeOf(i);
  return e;
}
function Dj(i) {
  const e = [];
  for (const t of S6e(i))
    typeof i[t] == "function" && e.push(t);
  return e;
}
function x6e(i, e) {
  const t = (r) => function() {
    const s = Array.prototype.slice.call(arguments, 0);
    return e(r, s);
  }, n = {};
  for (const r of i)
    n[r] = t(r);
  return n;
}
let D6e = typeof document < "u" && document.location && document.location.hash.indexOf("pseudo=true") >= 0;
function E6e(i, e) {
  let t;
  return e.length === 0 ? t = i : t = i.replace(/\{(\d+)\}/g, (n, r) => {
    const s = r[0], o = e[s];
    let a = n;
    return typeof o == "string" ? a = o : (typeof o == "number" || typeof o == "boolean" || o === void 0 || o === null) && (a = String(o)), a;
  }), D6e && (t = "［" + t.replace(/[aouei]/g, "$&$&") + "］"), t;
}
function C(i, e, ...t) {
  return E6e(e, t);
}
var Qk;
const G1 = "en";
let BE = !1, VE = !1, E3 = !1, Bue = !1, Ej = !1, Lj = !1, Vue = !1, Ox, L3 = G1, GY = G1, L6e, Sc;
const Zl = typeof self == "object" ? self : typeof global == "object" ? global : {};
let ro;
typeof Zl.vscode < "u" && typeof Zl.vscode.process < "u" ? ro = Zl.vscode.process : typeof process < "u" && (ro = process);
const I6e = typeof ((Qk = ro?.versions) === null || Qk === void 0 ? void 0 : Qk.electron) == "string", A6e = I6e && ro?.type === "renderer";
if (typeof navigator == "object" && !A6e)
  Sc = navigator.userAgent, BE = Sc.indexOf("Windows") >= 0, VE = Sc.indexOf("Macintosh") >= 0, Lj = (Sc.indexOf("Macintosh") >= 0 || Sc.indexOf("iPad") >= 0 || Sc.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0, E3 = Sc.indexOf("Linux") >= 0, Vue = Sc?.indexOf("Mobi") >= 0, Ej = !0, // This call _must_ be done in the file that calls `nls.getConfiguredDefaultLocale`
  // to ensure that the NLS AMD Loader plugin has been loaded and configured.
  // This is because the loader plugin decides what the default locale is based on
  // how it's able to resolve the strings.
  C({ key: "ensureLoaderPluginIsLoaded", comment: ["{Locked}"] }, "_"), Ox = G1, L3 = Ox, GY = navigator.language;
else if (typeof ro == "object") {
  BE = ro.platform === "win32", VE = ro.platform === "darwin", E3 = ro.platform === "linux", E3 && ro.env.SNAP && ro.env.SNAP_REVISION, ro.env.CI || ro.env.BUILD_ARTIFACTSTAGINGDIRECTORY, Ox = G1, L3 = G1;
  const i = ro.env.VSCODE_NLS_CONFIG;
  if (i)
    try {
      const e = JSON.parse(i), t = e.availableLanguages["*"];
      Ox = e.locale, GY = e.osLocale, L3 = t || G1, L6e = e._translationsConfigFile;
    } catch {
    }
  Bue = !0;
} else
  console.error("Unable to resolve platform.");
const Ls = BE, sn = VE, $s = E3, Zc = Bue, sp = Ej, k6e = Ej && typeof Zl.importScripts == "function", od = Lj, T6e = Vue, bu = Sc, N6e = L3, P6e = typeof Zl.postMessage == "function" && !Zl.importScripts, Hue = (() => {
  if (P6e) {
    const i = [];
    Zl.addEventListener("message", (t) => {
      if (t.data && t.data.vscodeScheduleAsyncWork)
        for (let n = 0, r = i.length; n < r; n++) {
          const s = i[n];
          if (s.id === t.data.vscodeScheduleAsyncWork) {
            i.splice(n, 1), s.callback();
            return;
          }
        }
    });
    let e = 0;
    return (t) => {
      const n = ++e;
      i.push({
        id: n,
        callback: t
      }), Zl.postMessage({ vscodeScheduleAsyncWork: n }, "*");
    };
  }
  return (i) => setTimeout(i);
})(), ka = VE || Lj ? 2 : BE ? 1 : 3;
let qY = !0, KY = !1;
function Wue() {
  if (!KY) {
    KY = !0;
    const i = new Uint8Array(2);
    i[0] = 1, i[1] = 2, qY = new Uint16Array(i.buffer)[0] === 513;
  }
  return qY;
}
const jue = !!(bu && bu.indexOf("Chrome") >= 0), O6e = !!(bu && bu.indexOf("Firefox") >= 0), M6e = !!(!jue && bu && bu.indexOf("Safari") >= 0), R6e = !!(bu && bu.indexOf("Edg/") >= 0);
bu && bu.indexOf("Android") >= 0;
const Os = {
  tabSize: 4,
  indentSize: 4,
  insertSpaces: !0,
  detectIndentation: !0,
  trimAutoWhitespace: !0,
  largeFileOptimizations: !0,
  bracketPairColorizationOptions: {
    enabled: !0,
    independentColorPoolPerBracketType: !1
  }
};
var Wt;
(function(i) {
  function e(b) {
    return b && typeof b == "object" && typeof b[Symbol.iterator] == "function";
  }
  i.is = e;
  const t = Object.freeze([]);
  function n() {
    return t;
  }
  i.empty = n;
  function* r(b) {
    yield b;
  }
  i.single = r;
  function s(b) {
    return e(b) ? b : r(b);
  }
  i.wrap = s;
  function o(b) {
    return b || t;
  }
  i.from = o;
  function* a(b) {
    for (let w = b.length - 1; w >= 0; w--)
      yield b[w];
  }
  i.reverse = a;
  function l(b) {
    return !b || b[Symbol.iterator]().next().done === !0;
  }
  i.isEmpty = l;
  function c(b) {
    return b[Symbol.iterator]().next().value;
  }
  i.first = c;
  function d(b, w) {
    for (const y of b)
      if (w(y))
        return !0;
    return !1;
  }
  i.some = d;
  function u(b, w) {
    for (const y of b)
      if (w(y))
        return y;
  }
  i.find = u;
  function* h(b, w) {
    for (const y of b)
      w(y) && (yield y);
  }
  i.filter = h;
  function* f(b, w) {
    let y = 0;
    for (const S of b)
      yield w(S, y++);
  }
  i.map = f;
  function* g(...b) {
    for (const w of b)
      for (const y of w)
        yield y;
  }
  i.concat = g;
  function p(b, w, y) {
    let S = y;
    for (const x of b)
      S = w(S, x);
    return S;
  }
  i.reduce = p;
  function* m(b, w, y = b.length) {
    for (w < 0 && (w += b.length), y < 0 ? y += b.length : y > b.length && (y = b.length); w < y; w++)
      yield b[w];
  }
  i.slice = m;
  function _(b, w = Number.POSITIVE_INFINITY) {
    const y = [];
    if (w === 0)
      return [y, b];
    const S = b[Symbol.iterator]();
    for (let x = 0; x < w; x++) {
      const D = S.next();
      if (D.done)
        return [y, i.empty()];
      y.push(D.value);
    }
    return [y, { [Symbol.iterator]() {
      return S;
    } }];
  }
  i.consume = _;
})(Wt || (Wt = {}));
let _r = class oR {
  constructor(e) {
    this.element = e, this.next = oR.Undefined, this.prev = oR.Undefined;
  }
};
_r.Undefined = new _r(void 0);
class fo {
  constructor() {
    this._first = _r.Undefined, this._last = _r.Undefined, this._size = 0;
  }
  get size() {
    return this._size;
  }
  isEmpty() {
    return this._first === _r.Undefined;
  }
  clear() {
    let e = this._first;
    for (; e !== _r.Undefined; ) {
      const t = e.next;
      e.prev = _r.Undefined, e.next = _r.Undefined, e = t;
    }
    this._first = _r.Undefined, this._last = _r.Undefined, this._size = 0;
  }
  unshift(e) {
    return this._insert(e, !1);
  }
  push(e) {
    return this._insert(e, !0);
  }
  _insert(e, t) {
    const n = new _r(e);
    if (this._first === _r.Undefined)
      this._first = n, this._last = n;
    else if (t) {
      const s = this._last;
      this._last = n, n.prev = s, s.next = n;
    } else {
      const s = this._first;
      this._first = n, n.next = s, s.prev = n;
    }
    this._size += 1;
    let r = !1;
    return () => {
      r || (r = !0, this._remove(n));
    };
  }
  shift() {
    if (this._first !== _r.Undefined) {
      const e = this._first.element;
      return this._remove(this._first), e;
    }
  }
  pop() {
    if (this._last !== _r.Undefined) {
      const e = this._last.element;
      return this._remove(this._last), e;
    }
  }
  _remove(e) {
    if (e.prev !== _r.Undefined && e.next !== _r.Undefined) {
      const t = e.prev;
      t.next = e.next, e.next.prev = t;
    } else e.prev === _r.Undefined && e.next === _r.Undefined ? (this._first = _r.Undefined, this._last = _r.Undefined) : e.next === _r.Undefined ? (this._last = this._last.prev, this._last.next = _r.Undefined) : e.prev === _r.Undefined && (this._first = this._first.next, this._first.prev = _r.Undefined);
    this._size -= 1;
  }
  *[Symbol.iterator]() {
    let e = this._first;
    for (; e !== _r.Undefined; )
      yield e.element, e = e.next;
  }
}
const zue = "`~!@#$%^&*()-=+[{]}\\|;:'\",.<>/?";
function F6e(i = "") {
  let e = "(-?\\d*\\.\\d\\w*)|([^";
  for (const t of zue)
    i.indexOf(t) >= 0 || (e += "\\" + t);
  return e += "\\s]+)", new RegExp(e, "g");
}
const Ij = F6e();
function Uue(i) {
  let e = Ij;
  if (i && i instanceof RegExp)
    if (i.global)
      e = i;
    else {
      let t = "g";
      i.ignoreCase && (t += "i"), i.multiline && (t += "m"), i.unicode && (t += "u"), e = new RegExp(i.source, t);
    }
  return e.lastIndex = 0, e;
}
const Gue = new fo();
Gue.unshift({
  maxLen: 1e3,
  windowSize: 15,
  timeBudget: 150
});
function yy(i, e, t, n, r) {
  if (r || (r = Wt.first(Gue)), t.length > r.maxLen) {
    let c = i - r.maxLen / 2;
    return c < 0 ? c = 0 : n += c, t = t.substring(c, i + r.maxLen / 2), yy(i, e, t, n, r);
  }
  const s = Date.now(), o = i - 1 - n;
  let a = -1, l = null;
  for (let c = 1; !(Date.now() - s >= r.timeBudget); c++) {
    const d = o - r.windowSize * c;
    e.lastIndex = Math.max(0, d);
    const u = B6e(e, t, o, a);
    if (!u && l || (l = u, d <= 0))
      break;
    a = d;
  }
  if (l) {
    const c = {
      word: l[0],
      startColumn: n + 1 + l.index,
      endColumn: n + 1 + l.index + l[0].length
    };
    return e.lastIndex = 0, c;
  }
  return null;
}
function B6e(i, e, t, n) {
  let r;
  for (; r = i.exec(e); ) {
    const s = r.index || 0;
    if (s <= t && i.lastIndex >= t)
      return r;
    if (n > 0 && s > n)
      return null;
  }
  return null;
}
const Ef = 8;
class que {
  /**
   * @internal
   */
  constructor(e) {
    this._values = e;
  }
  hasChanged(e) {
    return this._values[e];
  }
}
class Kue {
  constructor() {
    this.stableMinimapLayoutInput = null, this.stableFitMaxMinimapScale = 0, this.stableFitRemainingWidth = 0;
  }
}
class xi {
  constructor(e, t, n, r) {
    this.id = e, this.name = t, this.defaultValue = n, this.schema = r;
  }
  applyUpdate(e, t) {
    return jA(e, t);
  }
  compute(e, t, n) {
    return n;
  }
}
class CC {
  constructor(e, t) {
    this.newValue = e, this.didChange = t;
  }
}
function jA(i, e) {
  if (typeof i != "object" || typeof e != "object" || !i || !e)
    return new CC(e, i !== e);
  if (Array.isArray(i) || Array.isArray(e)) {
    const n = Array.isArray(i) && Array.isArray(e) && Qi(i, e);
    return new CC(e, !n);
  }
  let t = !1;
  for (const n in e)
    if (e.hasOwnProperty(n)) {
      const r = jA(i[n], e[n]);
      r.didChange && (i[n] = r.newValue, t = !0);
    }
  return new CC(i, t);
}
class vS {
  constructor(e) {
    this.schema = void 0, this.id = e, this.name = "_never_", this.defaultValue = void 0;
  }
  applyUpdate(e, t) {
    return jA(e, t);
  }
  validate(e) {
    return this.defaultValue;
  }
}
class db {
  constructor(e, t, n, r) {
    this.id = e, this.name = t, this.defaultValue = n, this.schema = r;
  }
  applyUpdate(e, t) {
    return jA(e, t);
  }
  validate(e) {
    return typeof e > "u" ? this.defaultValue : e;
  }
  compute(e, t, n) {
    return n;
  }
}
function ut(i, e) {
  return typeof i > "u" ? e : i === "false" ? !1 : !!i;
}
class ln extends db {
  constructor(e, t, n, r = void 0) {
    typeof r < "u" && (r.type = "boolean", r.default = n), super(e, t, n, r);
  }
  validate(e) {
    return ut(e, this.defaultValue);
  }
}
function Fp(i, e, t, n) {
  if (typeof i > "u")
    return e;
  let r = parseInt(i, 10);
  return isNaN(r) ? e : (r = Math.max(t, r), r = Math.min(n, r), r | 0);
}
class Fn extends db {
  static clampedInt(e, t, n, r) {
    return Fp(e, t, n, r);
  }
  constructor(e, t, n, r, s, o = void 0) {
    typeof o < "u" && (o.type = "integer", o.default = n, o.minimum = r, o.maximum = s), super(e, t, n, o), this.minimum = r, this.maximum = s;
  }
  validate(e) {
    return Fn.clampedInt(e, this.defaultValue, this.minimum, this.maximum);
  }
}
function V6e(i, e, t, n) {
  if (typeof i > "u")
    return e;
  const r = zl.float(i, e);
  return zl.clamp(r, t, n);
}
class zl extends db {
  static clamp(e, t, n) {
    return e < t ? t : e > n ? n : e;
  }
  static float(e, t) {
    if (typeof e == "number")
      return e;
    if (typeof e > "u")
      return t;
    const n = parseFloat(e);
    return isNaN(n) ? t : n;
  }
  constructor(e, t, n, r, s) {
    typeof s < "u" && (s.type = "number", s.default = n), super(e, t, n, s), this.validationFn = r;
  }
  validate(e) {
    return this.validationFn(zl.float(e, this.defaultValue));
  }
}
class Ko extends db {
  static string(e, t) {
    return typeof e != "string" ? t : e;
  }
  constructor(e, t, n, r = void 0) {
    typeof r < "u" && (r.type = "string", r.default = n), super(e, t, n, r);
  }
  validate(e) {
    return Ko.string(e, this.defaultValue);
  }
}
function or(i, e, t, n) {
  return typeof i != "string" ? e : n && i in n ? n[i] : t.indexOf(i) === -1 ? e : i;
}
class Bi extends db {
  constructor(e, t, n, r, s = void 0) {
    typeof s < "u" && (s.type = "string", s.enum = r, s.default = n), super(e, t, n, s), this._allowedValues = r;
  }
  validate(e) {
    return or(e, this.defaultValue, this._allowedValues);
  }
}
class Mx extends xi {
  constructor(e, t, n, r, s, o, a = void 0) {
    typeof a < "u" && (a.type = "string", a.enum = s, a.default = r), super(e, t, n, a), this._allowedValues = s, this._convert = o;
  }
  validate(e) {
    return typeof e != "string" ? this.defaultValue : this._allowedValues.indexOf(e) === -1 ? this.defaultValue : this._convert(e);
  }
}
function H6e(i) {
  switch (i) {
    case "none":
      return 0;
    case "keep":
      return 1;
    case "brackets":
      return 2;
    case "advanced":
      return 3;
    case "full":
      return 4;
  }
}
class W6e extends xi {
  constructor() {
    super(2, "accessibilitySupport", 0, {
      type: "string",
      enum: ["auto", "on", "off"],
      enumDescriptions: [
        C("accessibilitySupport.auto", "Use platform APIs to detect when a Screen Reader is attached"),
        C("accessibilitySupport.on", "Optimize for usage with a Screen Reader"),
        C("accessibilitySupport.off", "Assume a screen reader is not attached")
      ],
      default: "auto",
      tags: ["accessibility"],
      description: C("accessibilitySupport", "Controls if the UI should run in a mode where it is optimized for screen readers.")
    });
  }
  validate(e) {
    switch (e) {
      case "auto":
        return 0;
      case "off":
        return 1;
      case "on":
        return 2;
    }
    return this.defaultValue;
  }
  compute(e, t, n) {
    return n === 0 ? e.accessibilitySupport : n;
  }
}
class j6e extends xi {
  constructor() {
    const e = {
      insertSpace: !0,
      ignoreEmptyLines: !0
    };
    super(23, "comments", e, {
      "editor.comments.insertSpace": {
        type: "boolean",
        default: e.insertSpace,
        description: C("comments.insertSpace", "Controls whether a space character is inserted when commenting.")
      },
      "editor.comments.ignoreEmptyLines": {
        type: "boolean",
        default: e.ignoreEmptyLines,
        description: C("comments.ignoreEmptyLines", "Controls if empty lines should be ignored with toggle, add or remove actions for line comments.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      insertSpace: ut(t.insertSpace, this.defaultValue.insertSpace),
      ignoreEmptyLines: ut(t.ignoreEmptyLines, this.defaultValue.ignoreEmptyLines)
    };
  }
}
function z6e(i) {
  switch (i) {
    case "blink":
      return 1;
    case "smooth":
      return 2;
    case "phase":
      return 3;
    case "expand":
      return 4;
    case "solid":
      return 5;
  }
}
var rs;
(function(i) {
  i[i.Line = 1] = "Line", i[i.Block = 2] = "Block", i[i.Underline = 3] = "Underline", i[i.LineThin = 4] = "LineThin", i[i.BlockOutline = 5] = "BlockOutline", i[i.UnderlineThin = 6] = "UnderlineThin";
})(rs || (rs = {}));
function U6e(i) {
  switch (i) {
    case "line":
      return rs.Line;
    case "block":
      return rs.Block;
    case "underline":
      return rs.Underline;
    case "line-thin":
      return rs.LineThin;
    case "block-outline":
      return rs.BlockOutline;
    case "underline-thin":
      return rs.UnderlineThin;
  }
}
class G6e extends vS {
  constructor() {
    super(
      140
      /* EditorOption.editorClassName */
    );
  }
  compute(e, t, n) {
    const r = ["monaco-editor"];
    return t.get(
      39
      /* EditorOption.extraEditorClassName */
    ) && r.push(t.get(
      39
      /* EditorOption.extraEditorClassName */
    )), e.extraEditorClassName && r.push(e.extraEditorClassName), t.get(
      73
      /* EditorOption.mouseStyle */
    ) === "default" ? r.push("mouse-default") : t.get(
      73
      /* EditorOption.mouseStyle */
    ) === "copy" && r.push("mouse-copy"), t.get(
      110
      /* EditorOption.showUnused */
    ) && r.push("showUnused"), t.get(
      138
      /* EditorOption.showDeprecated */
    ) && r.push("showDeprecated"), r.join(" ");
  }
}
class q6e extends ln {
  constructor() {
    super(37, "emptySelectionClipboard", !0, { description: C("emptySelectionClipboard", "Controls whether copying without a selection copies the current line.") });
  }
  compute(e, t, n) {
    return n && e.emptySelectionClipboard;
  }
}
class K6e extends xi {
  constructor() {
    const e = {
      cursorMoveOnType: !0,
      seedSearchStringFromSelection: "always",
      autoFindInSelection: "never",
      globalFindClipboard: !1,
      addExtraSpaceOnTop: !0,
      loop: !0
    };
    super(41, "find", e, {
      "editor.find.cursorMoveOnType": {
        type: "boolean",
        default: e.cursorMoveOnType,
        description: C("find.cursorMoveOnType", "Controls whether the cursor should jump to find matches while typing.")
      },
      "editor.find.seedSearchStringFromSelection": {
        type: "string",
        enum: ["never", "always", "selection"],
        default: e.seedSearchStringFromSelection,
        enumDescriptions: [
          C("editor.find.seedSearchStringFromSelection.never", "Never seed search string from the editor selection."),
          C("editor.find.seedSearchStringFromSelection.always", "Always seed search string from the editor selection, including word at cursor position."),
          C("editor.find.seedSearchStringFromSelection.selection", "Only seed search string from the editor selection.")
        ],
        description: C("find.seedSearchStringFromSelection", "Controls whether the search string in the Find Widget is seeded from the editor selection.")
      },
      "editor.find.autoFindInSelection": {
        type: "string",
        enum: ["never", "always", "multiline"],
        default: e.autoFindInSelection,
        enumDescriptions: [
          C("editor.find.autoFindInSelection.never", "Never turn on Find in Selection automatically (default)."),
          C("editor.find.autoFindInSelection.always", "Always turn on Find in Selection automatically."),
          C("editor.find.autoFindInSelection.multiline", "Turn on Find in Selection automatically when multiple lines of content are selected.")
        ],
        description: C("find.autoFindInSelection", "Controls the condition for turning on Find in Selection automatically.")
      },
      "editor.find.globalFindClipboard": {
        type: "boolean",
        default: e.globalFindClipboard,
        description: C("find.globalFindClipboard", "Controls whether the Find Widget should read or modify the shared find clipboard on macOS."),
        included: sn
      },
      "editor.find.addExtraSpaceOnTop": {
        type: "boolean",
        default: e.addExtraSpaceOnTop,
        description: C("find.addExtraSpaceOnTop", "Controls whether the Find Widget should add extra lines on top of the editor. When true, you can scroll beyond the first line when the Find Widget is visible.")
      },
      "editor.find.loop": {
        type: "boolean",
        default: e.loop,
        description: C("find.loop", "Controls whether the search automatically restarts from the beginning (or the end) when no further matches can be found.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      cursorMoveOnType: ut(t.cursorMoveOnType, this.defaultValue.cursorMoveOnType),
      seedSearchStringFromSelection: typeof e.seedSearchStringFromSelection == "boolean" ? e.seedSearchStringFromSelection ? "always" : "never" : or(t.seedSearchStringFromSelection, this.defaultValue.seedSearchStringFromSelection, ["never", "always", "selection"]),
      autoFindInSelection: typeof e.autoFindInSelection == "boolean" ? e.autoFindInSelection ? "always" : "never" : or(t.autoFindInSelection, this.defaultValue.autoFindInSelection, ["never", "always", "multiline"]),
      globalFindClipboard: ut(t.globalFindClipboard, this.defaultValue.globalFindClipboard),
      addExtraSpaceOnTop: ut(t.addExtraSpaceOnTop, this.defaultValue.addExtraSpaceOnTop),
      loop: ut(t.loop, this.defaultValue.loop)
    };
  }
}
class Da extends xi {
  constructor() {
    super(51, "fontLigatures", Da.OFF, {
      anyOf: [
        {
          type: "boolean",
          description: C("fontLigatures", "Enables/Disables font ligatures ('calt' and 'liga' font features). Change this to a string for fine-grained control of the 'font-feature-settings' CSS property.")
        },
        {
          type: "string",
          description: C("fontFeatureSettings", "Explicit 'font-feature-settings' CSS property. A boolean can be passed instead if one only needs to turn on/off ligatures.")
        }
      ],
      description: C("fontLigaturesGeneral", "Configures font ligatures or font features. Can be either a boolean to enable/disable ligatures or a string for the value of the CSS 'font-feature-settings' property."),
      default: !1
    });
  }
  validate(e) {
    return typeof e > "u" ? this.defaultValue : typeof e == "string" ? e === "false" ? Da.OFF : e === "true" ? Da.ON : e : e ? Da.ON : Da.OFF;
  }
}
Da.OFF = '"liga" off, "calt" off';
Da.ON = '"liga" on, "calt" on';
class Hc extends xi {
  constructor() {
    super(54, "fontVariations", Hc.OFF, {
      anyOf: [
        {
          type: "boolean",
          description: C("fontVariations", "Enables/Disables the translation from font-weight to font-variation-settings. Change this to a string for fine-grained control of the 'font-variation-settings' CSS property.")
        },
        {
          type: "string",
          description: C("fontVariationSettings", "Explicit 'font-variation-settings' CSS property. A boolean can be passed instead if one only needs to translate font-weight to font-variation-settings.")
        }
      ],
      description: C("fontVariationsGeneral", "Configures font variations. Can be either a boolean to enable/disable the translation from font-weight to font-variation-settings or a string for the value of the CSS 'font-variation-settings' property."),
      default: !1
    });
  }
  validate(e) {
    return typeof e > "u" ? this.defaultValue : typeof e == "string" ? e === "false" ? Hc.OFF : e === "true" ? Hc.TRANSLATE : e : e ? Hc.TRANSLATE : Hc.OFF;
  }
  compute(e, t, n) {
    return e.fontInfo.fontVariationSettings;
  }
}
Hc.OFF = "normal";
Hc.TRANSLATE = "translate";
class Y6e extends vS {
  constructor() {
    super(
      50
      /* EditorOption.fontInfo */
    );
  }
  compute(e, t, n) {
    return e.fontInfo;
  }
}
class X6e extends db {
  constructor() {
    super(52, "fontSize", na.fontSize, {
      type: "number",
      minimum: 6,
      maximum: 100,
      default: na.fontSize,
      description: C("fontSize", "Controls the font size in pixels.")
    });
  }
  validate(e) {
    const t = zl.float(e, this.defaultValue);
    return t === 0 ? na.fontSize : zl.clamp(t, 6, 100);
  }
  compute(e, t, n) {
    return e.fontInfo.fontSize;
  }
}
class Hd extends xi {
  constructor() {
    super(53, "fontWeight", na.fontWeight, {
      anyOf: [
        {
          type: "number",
          minimum: Hd.MINIMUM_VALUE,
          maximum: Hd.MAXIMUM_VALUE,
          errorMessage: C("fontWeightErrorMessage", 'Only "normal" and "bold" keywords or numbers between 1 and 1000 are allowed.')
        },
        {
          type: "string",
          pattern: "^(normal|bold|1000|[1-9][0-9]{0,2})$"
        },
        {
          enum: Hd.SUGGESTION_VALUES
        }
      ],
      default: na.fontWeight,
      description: C("fontWeight", 'Controls the font weight. Accepts "normal" and "bold" keywords or numbers between 1 and 1000.')
    });
  }
  validate(e) {
    return e === "normal" || e === "bold" ? e : String(Fn.clampedInt(e, na.fontWeight, Hd.MINIMUM_VALUE, Hd.MAXIMUM_VALUE));
  }
}
Hd.SUGGESTION_VALUES = ["normal", "bold", "100", "200", "300", "400", "500", "600", "700", "800", "900"];
Hd.MINIMUM_VALUE = 1;
Hd.MAXIMUM_VALUE = 1e3;
class Z6e extends xi {
  constructor() {
    const e = {
      multiple: "peek",
      multipleDefinitions: "peek",
      multipleTypeDefinitions: "peek",
      multipleDeclarations: "peek",
      multipleImplementations: "peek",
      multipleReferences: "peek",
      alternativeDefinitionCommand: "editor.action.goToReferences",
      alternativeTypeDefinitionCommand: "editor.action.goToReferences",
      alternativeDeclarationCommand: "editor.action.goToReferences",
      alternativeImplementationCommand: "",
      alternativeReferenceCommand: ""
    }, t = {
      type: "string",
      enum: ["peek", "gotoAndPeek", "goto"],
      default: e.multiple,
      enumDescriptions: [
        C("editor.gotoLocation.multiple.peek", "Show Peek view of the results (default)"),
        C("editor.gotoLocation.multiple.gotoAndPeek", "Go to the primary result and show a Peek view"),
        C("editor.gotoLocation.multiple.goto", "Go to the primary result and enable Peek-less navigation to others")
      ]
    }, n = ["", "editor.action.referenceSearch.trigger", "editor.action.goToReferences", "editor.action.peekImplementation", "editor.action.goToImplementation", "editor.action.peekTypeDefinition", "editor.action.goToTypeDefinition", "editor.action.peekDeclaration", "editor.action.revealDeclaration", "editor.action.peekDefinition", "editor.action.revealDefinitionAside", "editor.action.revealDefinition"];
    super(58, "gotoLocation", e, {
      "editor.gotoLocation.multiple": {
        deprecationMessage: C("editor.gotoLocation.multiple.deprecated", "This setting is deprecated, please use separate settings like 'editor.editor.gotoLocation.multipleDefinitions' or 'editor.editor.gotoLocation.multipleImplementations' instead.")
      },
      "editor.gotoLocation.multipleDefinitions": Object.assign({ description: C("editor.editor.gotoLocation.multipleDefinitions", "Controls the behavior the 'Go to Definition'-command when multiple target locations exist.") }, t),
      "editor.gotoLocation.multipleTypeDefinitions": Object.assign({ description: C("editor.editor.gotoLocation.multipleTypeDefinitions", "Controls the behavior the 'Go to Type Definition'-command when multiple target locations exist.") }, t),
      "editor.gotoLocation.multipleDeclarations": Object.assign({ description: C("editor.editor.gotoLocation.multipleDeclarations", "Controls the behavior the 'Go to Declaration'-command when multiple target locations exist.") }, t),
      "editor.gotoLocation.multipleImplementations": Object.assign({ description: C("editor.editor.gotoLocation.multipleImplemenattions", "Controls the behavior the 'Go to Implementations'-command when multiple target locations exist.") }, t),
      "editor.gotoLocation.multipleReferences": Object.assign({ description: C("editor.editor.gotoLocation.multipleReferences", "Controls the behavior the 'Go to References'-command when multiple target locations exist.") }, t),
      "editor.gotoLocation.alternativeDefinitionCommand": {
        type: "string",
        default: e.alternativeDefinitionCommand,
        enum: n,
        description: C("alternativeDefinitionCommand", "Alternative command id that is being executed when the result of 'Go to Definition' is the current location.")
      },
      "editor.gotoLocation.alternativeTypeDefinitionCommand": {
        type: "string",
        default: e.alternativeTypeDefinitionCommand,
        enum: n,
        description: C("alternativeTypeDefinitionCommand", "Alternative command id that is being executed when the result of 'Go to Type Definition' is the current location.")
      },
      "editor.gotoLocation.alternativeDeclarationCommand": {
        type: "string",
        default: e.alternativeDeclarationCommand,
        enum: n,
        description: C("alternativeDeclarationCommand", "Alternative command id that is being executed when the result of 'Go to Declaration' is the current location.")
      },
      "editor.gotoLocation.alternativeImplementationCommand": {
        type: "string",
        default: e.alternativeImplementationCommand,
        enum: n,
        description: C("alternativeImplementationCommand", "Alternative command id that is being executed when the result of 'Go to Implementation' is the current location.")
      },
      "editor.gotoLocation.alternativeReferenceCommand": {
        type: "string",
        default: e.alternativeReferenceCommand,
        enum: n,
        description: C("alternativeReferenceCommand", "Alternative command id that is being executed when the result of 'Go to Reference' is the current location.")
      }
    });
  }
  validate(e) {
    var t, n, r, s, o;
    if (!e || typeof e != "object")
      return this.defaultValue;
    const a = e;
    return {
      multiple: or(a.multiple, this.defaultValue.multiple, ["peek", "gotoAndPeek", "goto"]),
      multipleDefinitions: (t = a.multipleDefinitions) !== null && t !== void 0 ? t : or(a.multipleDefinitions, "peek", ["peek", "gotoAndPeek", "goto"]),
      multipleTypeDefinitions: (n = a.multipleTypeDefinitions) !== null && n !== void 0 ? n : or(a.multipleTypeDefinitions, "peek", ["peek", "gotoAndPeek", "goto"]),
      multipleDeclarations: (r = a.multipleDeclarations) !== null && r !== void 0 ? r : or(a.multipleDeclarations, "peek", ["peek", "gotoAndPeek", "goto"]),
      multipleImplementations: (s = a.multipleImplementations) !== null && s !== void 0 ? s : or(a.multipleImplementations, "peek", ["peek", "gotoAndPeek", "goto"]),
      multipleReferences: (o = a.multipleReferences) !== null && o !== void 0 ? o : or(a.multipleReferences, "peek", ["peek", "gotoAndPeek", "goto"]),
      alternativeDefinitionCommand: Ko.string(a.alternativeDefinitionCommand, this.defaultValue.alternativeDefinitionCommand),
      alternativeTypeDefinitionCommand: Ko.string(a.alternativeTypeDefinitionCommand, this.defaultValue.alternativeTypeDefinitionCommand),
      alternativeDeclarationCommand: Ko.string(a.alternativeDeclarationCommand, this.defaultValue.alternativeDeclarationCommand),
      alternativeImplementationCommand: Ko.string(a.alternativeImplementationCommand, this.defaultValue.alternativeImplementationCommand),
      alternativeReferenceCommand: Ko.string(a.alternativeReferenceCommand, this.defaultValue.alternativeReferenceCommand)
    };
  }
}
class Q6e extends xi {
  constructor() {
    const e = {
      enabled: !0,
      delay: 300,
      hidingDelay: 300,
      sticky: !0,
      above: !0
    };
    super(60, "hover", e, {
      "editor.hover.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("hover.enabled", "Controls whether the hover is shown.")
      },
      "editor.hover.delay": {
        type: "number",
        default: e.delay,
        minimum: 0,
        maximum: 1e4,
        description: C("hover.delay", "Controls the delay in milliseconds after which the hover is shown.")
      },
      "editor.hover.sticky": {
        type: "boolean",
        default: e.sticky,
        description: C("hover.sticky", "Controls whether the hover should remain visible when mouse is moved over it.")
      },
      "editor.hover.hidingDelay": {
        type: "integer",
        minimum: 0,
        default: e.hidingDelay,
        description: C("hover.hidingDelay", "Controls the delay in milliseconds after thich the hover is hidden. Requires `editor.hover.sticky` to be enabled.")
      },
      "editor.hover.above": {
        type: "boolean",
        default: e.above,
        description: C("hover.above", "Prefer showing hovers above the line, if there's space.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: ut(t.enabled, this.defaultValue.enabled),
      delay: Fn.clampedInt(t.delay, this.defaultValue.delay, 0, 1e4),
      sticky: ut(t.sticky, this.defaultValue.sticky),
      hidingDelay: Fn.clampedInt(t.hidingDelay, this.defaultValue.hidingDelay, 0, 6e5),
      above: ut(t.above, this.defaultValue.above)
    };
  }
}
class Dv extends vS {
  constructor() {
    super(
      143
      /* EditorOption.layoutInfo */
    );
  }
  compute(e, t, n) {
    return Dv.computeLayout(t, {
      memory: e.memory,
      outerWidth: e.outerWidth,
      outerHeight: e.outerHeight,
      isDominatedByLongLines: e.isDominatedByLongLines,
      lineHeight: e.fontInfo.lineHeight,
      viewLineCount: e.viewLineCount,
      lineNumbersDigitCount: e.lineNumbersDigitCount,
      typicalHalfwidthCharacterWidth: e.fontInfo.typicalHalfwidthCharacterWidth,
      maxDigitWidth: e.fontInfo.maxDigitWidth,
      pixelRatio: e.pixelRatio,
      glyphMarginDecorationLaneCount: e.glyphMarginDecorationLaneCount
    });
  }
  static computeContainedMinimapLineCount(e) {
    const t = e.height / e.lineHeight, n = Math.floor(e.paddingTop / e.lineHeight);
    let r = Math.floor(e.paddingBottom / e.lineHeight);
    e.scrollBeyondLastLine && (r = Math.max(r, t - 1));
    const s = (n + e.viewLineCount + r) / (e.pixelRatio * e.height), o = Math.floor(e.viewLineCount / s);
    return { typicalViewportLineCount: t, extraLinesBeforeFirstLine: n, extraLinesBeyondLastLine: r, desiredRatio: s, minimapLineCount: o };
  }
  static _computeMinimapLayout(e, t) {
    const n = e.outerWidth, r = e.outerHeight, s = e.pixelRatio;
    if (!e.minimap.enabled)
      return {
        renderMinimap: 0,
        minimapLeft: 0,
        minimapWidth: 0,
        minimapHeightIsEditorHeight: !1,
        minimapIsSampling: !1,
        minimapScale: 1,
        minimapLineHeight: 1,
        minimapCanvasInnerWidth: 0,
        minimapCanvasInnerHeight: Math.floor(s * r),
        minimapCanvasOuterWidth: 0,
        minimapCanvasOuterHeight: r
      };
    const o = t.stableMinimapLayoutInput, a = o && e.outerHeight === o.outerHeight && e.lineHeight === o.lineHeight && e.typicalHalfwidthCharacterWidth === o.typicalHalfwidthCharacterWidth && e.pixelRatio === o.pixelRatio && e.scrollBeyondLastLine === o.scrollBeyondLastLine && e.paddingTop === o.paddingTop && e.paddingBottom === o.paddingBottom && e.minimap.enabled === o.minimap.enabled && e.minimap.side === o.minimap.side && e.minimap.size === o.minimap.size && e.minimap.showSlider === o.minimap.showSlider && e.minimap.renderCharacters === o.minimap.renderCharacters && e.minimap.maxColumn === o.minimap.maxColumn && e.minimap.scale === o.minimap.scale && e.verticalScrollbarWidth === o.verticalScrollbarWidth && e.isViewportWrapping === o.isViewportWrapping, l = e.lineHeight, c = e.typicalHalfwidthCharacterWidth, d = e.scrollBeyondLastLine, u = e.minimap.renderCharacters;
    let h = s >= 2 ? Math.round(e.minimap.scale * 2) : e.minimap.scale;
    const f = e.minimap.maxColumn, g = e.minimap.size, p = e.minimap.side, m = e.verticalScrollbarWidth, _ = e.viewLineCount, b = e.remainingWidth, w = e.isViewportWrapping, y = u ? 2 : 3;
    let S = Math.floor(s * r);
    const x = S / s;
    let D = !1, E = !1, L = y * h, k = h / s, N = 1;
    if (g === "fill" || g === "fit") {
      const { typicalViewportLineCount: F, extraLinesBeforeFirstLine: q, extraLinesBeyondLastLine: R, desiredRatio: T, minimapLineCount: z } = Dv.computeContainedMinimapLineCount({
        viewLineCount: _,
        scrollBeyondLastLine: d,
        paddingTop: e.paddingTop,
        paddingBottom: e.paddingBottom,
        height: r,
        lineHeight: l,
        pixelRatio: s
      });
      if (_ / z > 1)
        D = !0, E = !0, h = 1, L = 1, k = h / s;
      else {
        let ae = !1, ue = h + 1;
        if (g === "fit") {
          const se = Math.ceil((q + _ + R) * L);
          w && a && b <= t.stableFitRemainingWidth ? (ae = !0, ue = t.stableFitMaxMinimapScale) : ae = se > S;
        }
        if (g === "fill" || ae) {
          D = !0;
          const se = h;
          L = Math.min(l * s, Math.max(1, Math.floor(1 / T))), w && a && b <= t.stableFitRemainingWidth && (ue = t.stableFitMaxMinimapScale), h = Math.min(ue, Math.max(1, Math.floor(L / y))), h > se && (N = Math.min(2, h / se)), k = h / s / N, S = Math.ceil(Math.max(F, q + _ + R) * L), w ? (t.stableMinimapLayoutInput = e, t.stableFitRemainingWidth = b, t.stableFitMaxMinimapScale = h) : (t.stableMinimapLayoutInput = null, t.stableFitRemainingWidth = 0);
        }
      }
    }
    const I = Math.floor(f * k), A = Math.min(I, Math.max(0, Math.floor((b - m - 2) * k / (c + k))) + Ef);
    let P = Math.floor(s * A);
    const O = P / s;
    P = Math.floor(P * N);
    const K = u ? 1 : 2, W = p === "left" ? 0 : n - A - m;
    return {
      renderMinimap: K,
      minimapLeft: W,
      minimapWidth: A,
      minimapHeightIsEditorHeight: D,
      minimapIsSampling: E,
      minimapScale: h,
      minimapLineHeight: L,
      minimapCanvasInnerWidth: P,
      minimapCanvasInnerHeight: S,
      minimapCanvasOuterWidth: O,
      minimapCanvasOuterHeight: x
    };
  }
  static computeLayout(e, t) {
    const n = t.outerWidth | 0, r = t.outerHeight | 0, s = t.lineHeight | 0, o = t.lineNumbersDigitCount | 0, a = t.typicalHalfwidthCharacterWidth, l = t.maxDigitWidth, c = t.pixelRatio, d = t.viewLineCount, u = e.get(
      135
      /* EditorOption.wordWrapOverride2 */
    ), h = u === "inherit" ? e.get(
      134
      /* EditorOption.wordWrapOverride1 */
    ) : u, f = h === "inherit" ? e.get(
      130
      /* EditorOption.wordWrap */
    ) : h, g = e.get(
      133
      /* EditorOption.wordWrapColumn */
    ), p = t.isDominatedByLongLines, m = e.get(
      57
      /* EditorOption.glyphMargin */
    ), _ = e.get(
      67
      /* EditorOption.lineNumbers */
    ).renderType !== 0, b = e.get(
      68
      /* EditorOption.lineNumbersMinChars */
    ), w = e.get(
      104
      /* EditorOption.scrollBeyondLastLine */
    ), y = e.get(
      83
      /* EditorOption.padding */
    ), S = e.get(
      72
      /* EditorOption.minimap */
    ), x = e.get(
      102
      /* EditorOption.scrollbar */
    ), D = x.verticalScrollbarSize, E = x.verticalHasArrows, L = x.arrowSize, k = x.horizontalScrollbarSize, N = e.get(
      43
      /* EditorOption.folding */
    ), I = e.get(
      109
      /* EditorOption.showFoldingControls */
    ) !== "never";
    let A = e.get(
      65
      /* EditorOption.lineDecorationsWidth */
    );
    N && I && (A += 16);
    let P = 0;
    if (_) {
      const oe = Math.max(o, b);
      P = Math.round(oe * l);
    }
    let O = 0;
    m && (O = s * t.glyphMarginDecorationLaneCount);
    let K = 0, W = K + O, F = W + P, q = F + A;
    const R = n - O - P - A;
    let T = !1, z = !1, X = -1;
    h === "inherit" && p ? (T = !0, z = !0) : f === "on" || f === "bounded" ? z = !0 : f === "wordWrapColumn" && (X = g);
    const ae = Dv._computeMinimapLayout({
      outerWidth: n,
      outerHeight: r,
      lineHeight: s,
      typicalHalfwidthCharacterWidth: a,
      pixelRatio: c,
      scrollBeyondLastLine: w,
      paddingTop: y.top,
      paddingBottom: y.bottom,
      minimap: S,
      verticalScrollbarWidth: D,
      viewLineCount: d,
      remainingWidth: R,
      isViewportWrapping: z
    }, t.memory || new Kue());
    ae.renderMinimap !== 0 && ae.minimapLeft === 0 && (K += ae.minimapWidth, W += ae.minimapWidth, F += ae.minimapWidth, q += ae.minimapWidth);
    const ue = R - ae.minimapWidth, se = Math.max(1, Math.floor((ue - D - 2) / a)), le = E ? L : 0;
    return z && (X = Math.max(1, se), f === "bounded" && (X = Math.min(X, g))), {
      width: n,
      height: r,
      glyphMarginLeft: K,
      glyphMarginWidth: O,
      glyphMarginDecorationLaneCount: t.glyphMarginDecorationLaneCount,
      lineNumbersLeft: W,
      lineNumbersWidth: P,
      decorationsLeft: F,
      decorationsWidth: A,
      contentLeft: q,
      contentWidth: ue,
      minimap: ae,
      viewportColumn: se,
      isWordWrapMinified: T,
      isViewportWrapping: z,
      wrappingColumn: X,
      verticalScrollbarWidth: D,
      horizontalScrollbarHeight: k,
      overviewRuler: {
        top: le,
        width: D,
        height: r - 2 * le,
        right: 0
      }
    };
  }
}
class J6e extends xi {
  constructor() {
    super(137, "wrappingStrategy", "simple", {
      "editor.wrappingStrategy": {
        enumDescriptions: [
          C("wrappingStrategy.simple", "Assumes that all characters are of the same width. This is a fast algorithm that works correctly for monospace fonts and certain scripts (like Latin characters) where glyphs are of equal width."),
          C("wrappingStrategy.advanced", "Delegates wrapping points computation to the browser. This is a slow algorithm, that might cause freezes for large files, but it works correctly in all cases.")
        ],
        type: "string",
        enum: ["simple", "advanced"],
        default: "simple",
        description: C("wrappingStrategy", "Controls the algorithm that computes wrapping points. Note that when in accessibility mode, advanced will be used for the best experience.")
      }
    });
  }
  validate(e) {
    return or(e, "simple", ["simple", "advanced"]);
  }
  compute(e, t, n) {
    return t.get(
      2
      /* EditorOption.accessibilitySupport */
    ) === 2 ? "advanced" : n;
  }
}
class $6e extends xi {
  constructor() {
    const e = { enabled: !0 };
    super(64, "lightbulb", e, {
      "editor.lightbulb.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("codeActions", "Enables the Code Action lightbulb in the editor.")
      }
    });
  }
  validate(e) {
    return !e || typeof e != "object" ? this.defaultValue : {
      enabled: ut(e.enabled, this.defaultValue.enabled)
    };
  }
}
class eTe extends xi {
  constructor() {
    const e = { enabled: !1, maxLineCount: 5, defaultModel: "outlineModel", scrollWithEditor: !0 };
    super(114, "stickyScroll", e, {
      "editor.stickyScroll.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("editor.stickyScroll.enabled", "Shows the nested current scopes during the scroll at the top of the editor.")
      },
      "editor.stickyScroll.maxLineCount": {
        type: "number",
        default: e.maxLineCount,
        minimum: 1,
        maximum: 10,
        description: C("editor.stickyScroll.maxLineCount", "Defines the maximum number of sticky lines to show.")
      },
      "editor.stickyScroll.defaultModel": {
        type: "string",
        enum: ["outlineModel", "foldingProviderModel", "indentationModel"],
        default: e.defaultModel,
        description: C("editor.stickyScroll.defaultModel", "Defines the model to use for determining which lines to stick. If the outline model does not exist, it will fall back on the folding provider model which falls back on the indentation model. This order is respected in all three cases.")
      },
      "editor.stickyScroll.scrollWithEditor": {
        type: "boolean",
        default: e.scrollWithEditor,
        description: C("editor.stickyScroll.scrollWithEditor", "Enable scrolling of the sticky scroll widget with the editor's horizontal scrollbar.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: ut(t.enabled, this.defaultValue.enabled),
      maxLineCount: Fn.clampedInt(t.maxLineCount, this.defaultValue.maxLineCount, 1, 10),
      defaultModel: or(t.defaultModel, this.defaultValue.defaultModel, ["outlineModel", "foldingProviderModel", "indentationModel"]),
      scrollWithEditor: ut(t.scrollWithEditor, this.defaultValue.scrollWithEditor)
    };
  }
}
class tTe extends xi {
  constructor() {
    const e = { enabled: "on", fontSize: 0, fontFamily: "", padding: !1 };
    super(139, "inlayHints", e, {
      "editor.inlayHints.enabled": {
        type: "string",
        default: e.enabled,
        description: C("inlayHints.enable", "Enables the inlay hints in the editor."),
        enum: ["on", "onUnlessPressed", "offUnlessPressed", "off"],
        markdownEnumDescriptions: [
          C("editor.inlayHints.on", "Inlay hints are enabled"),
          C("editor.inlayHints.onUnlessPressed", "Inlay hints are showing by default and hide when holding {0}", sn ? "Ctrl+Option" : "Ctrl+Alt"),
          C("editor.inlayHints.offUnlessPressed", "Inlay hints are hidden by default and show when holding {0}", sn ? "Ctrl+Option" : "Ctrl+Alt"),
          C("editor.inlayHints.off", "Inlay hints are disabled")
        ]
      },
      "editor.inlayHints.fontSize": {
        type: "number",
        default: e.fontSize,
        markdownDescription: C("inlayHints.fontSize", "Controls font size of inlay hints in the editor. As default the {0} is used when the configured value is less than {1} or greater than the editor font size.", "`#editor.fontSize#`", "`5`")
      },
      "editor.inlayHints.fontFamily": {
        type: "string",
        default: e.fontFamily,
        markdownDescription: C("inlayHints.fontFamily", "Controls font family of inlay hints in the editor. When set to empty, the {0} is used.", "`#editor.fontFamily#`")
      },
      "editor.inlayHints.padding": {
        type: "boolean",
        default: e.padding,
        description: C("inlayHints.padding", "Enables the padding around the inlay hints in the editor.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return typeof t.enabled == "boolean" && (t.enabled = t.enabled ? "on" : "off"), {
      enabled: or(t.enabled, this.defaultValue.enabled, ["on", "off", "offUnlessPressed", "onUnlessPressed"]),
      fontSize: Fn.clampedInt(t.fontSize, this.defaultValue.fontSize, 0, 100),
      fontFamily: Ko.string(t.fontFamily, this.defaultValue.fontFamily),
      padding: ut(t.padding, this.defaultValue.padding)
    };
  }
}
class nTe extends xi {
  constructor() {
    super(65, "lineDecorationsWidth", 10);
  }
  validate(e) {
    return typeof e == "string" && /^\d+(\.\d+)?ch$/.test(e) ? -parseFloat(e.substring(0, e.length - 2)) : Fn.clampedInt(e, this.defaultValue, 0, 1e3);
  }
  compute(e, t, n) {
    return n < 0 ? Fn.clampedInt(-n * e.fontInfo.typicalHalfwidthCharacterWidth, this.defaultValue, 0, 1e3) : n;
  }
}
class iTe extends zl {
  constructor() {
    super(66, "lineHeight", na.lineHeight, (e) => zl.clamp(e, 0, 150), { markdownDescription: C("lineHeight", `Controls the line height. 
 - Use 0 to automatically compute the line height from the font size.
 - Values between 0 and 8 will be used as a multiplier with the font size.
 - Values greater than or equal to 8 will be used as effective values.`) });
  }
  compute(e, t, n) {
    return e.fontInfo.lineHeight;
  }
}
class rTe extends xi {
  constructor() {
    const e = {
      enabled: !0,
      size: "proportional",
      side: "right",
      showSlider: "mouseover",
      autohide: !1,
      renderCharacters: !0,
      maxColumn: 120,
      scale: 1
    };
    super(72, "minimap", e, {
      "editor.minimap.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("minimap.enabled", "Controls whether the minimap is shown.")
      },
      "editor.minimap.autohide": {
        type: "boolean",
        default: e.autohide,
        description: C("minimap.autohide", "Controls whether the minimap is hidden automatically.")
      },
      "editor.minimap.size": {
        type: "string",
        enum: ["proportional", "fill", "fit"],
        enumDescriptions: [
          C("minimap.size.proportional", "The minimap has the same size as the editor contents (and might scroll)."),
          C("minimap.size.fill", "The minimap will stretch or shrink as necessary to fill the height of the editor (no scrolling)."),
          C("minimap.size.fit", "The minimap will shrink as necessary to never be larger than the editor (no scrolling).")
        ],
        default: e.size,
        description: C("minimap.size", "Controls the size of the minimap.")
      },
      "editor.minimap.side": {
        type: "string",
        enum: ["left", "right"],
        default: e.side,
        description: C("minimap.side", "Controls the side where to render the minimap.")
      },
      "editor.minimap.showSlider": {
        type: "string",
        enum: ["always", "mouseover"],
        default: e.showSlider,
        description: C("minimap.showSlider", "Controls when the minimap slider is shown.")
      },
      "editor.minimap.scale": {
        type: "number",
        default: e.scale,
        minimum: 1,
        maximum: 3,
        enum: [1, 2, 3],
        description: C("minimap.scale", "Scale of content drawn in the minimap: 1, 2 or 3.")
      },
      "editor.minimap.renderCharacters": {
        type: "boolean",
        default: e.renderCharacters,
        description: C("minimap.renderCharacters", "Render the actual characters on a line as opposed to color blocks.")
      },
      "editor.minimap.maxColumn": {
        type: "number",
        default: e.maxColumn,
        description: C("minimap.maxColumn", "Limit the width of the minimap to render at most a certain number of columns.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: ut(t.enabled, this.defaultValue.enabled),
      autohide: ut(t.autohide, this.defaultValue.autohide),
      size: or(t.size, this.defaultValue.size, ["proportional", "fill", "fit"]),
      side: or(t.side, this.defaultValue.side, ["right", "left"]),
      showSlider: or(t.showSlider, this.defaultValue.showSlider, ["always", "mouseover"]),
      renderCharacters: ut(t.renderCharacters, this.defaultValue.renderCharacters),
      scale: Fn.clampedInt(t.scale, 1, 1, 3),
      maxColumn: Fn.clampedInt(t.maxColumn, this.defaultValue.maxColumn, 1, 1e4)
    };
  }
}
function sTe(i) {
  return i === "ctrlCmd" ? sn ? "metaKey" : "ctrlKey" : "altKey";
}
class oTe extends xi {
  constructor() {
    super(83, "padding", { top: 0, bottom: 0 }, {
      "editor.padding.top": {
        type: "number",
        default: 0,
        minimum: 0,
        maximum: 1e3,
        description: C("padding.top", "Controls the amount of space between the top edge of the editor and the first line.")
      },
      "editor.padding.bottom": {
        type: "number",
        default: 0,
        minimum: 0,
        maximum: 1e3,
        description: C("padding.bottom", "Controls the amount of space between the bottom edge of the editor and the last line.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      top: Fn.clampedInt(t.top, 0, 0, 1e3),
      bottom: Fn.clampedInt(t.bottom, 0, 0, 1e3)
    };
  }
}
class aTe extends xi {
  constructor() {
    const e = {
      enabled: !0,
      cycle: !0
    };
    super(85, "parameterHints", e, {
      "editor.parameterHints.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("parameterHints.enabled", "Enables a pop-up that shows parameter documentation and type information as you type.")
      },
      "editor.parameterHints.cycle": {
        type: "boolean",
        default: e.cycle,
        description: C("parameterHints.cycle", "Controls whether the parameter hints menu cycles or closes when reaching the end of the list.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: ut(t.enabled, this.defaultValue.enabled),
      cycle: ut(t.cycle, this.defaultValue.cycle)
    };
  }
}
class lTe extends vS {
  constructor() {
    super(
      141
      /* EditorOption.pixelRatio */
    );
  }
  compute(e, t, n) {
    return e.pixelRatio;
  }
}
class cTe extends xi {
  constructor() {
    const e = {
      other: "on",
      comments: "off",
      strings: "off"
    }, t = [
      { type: "boolean" },
      {
        type: "string",
        enum: ["on", "inline", "off"],
        enumDescriptions: [C("on", "Quick suggestions show inside the suggest widget"), C("inline", "Quick suggestions show as ghost text"), C("off", "Quick suggestions are disabled")]
      }
    ];
    super(88, "quickSuggestions", e, {
      type: "object",
      additionalProperties: !1,
      properties: {
        strings: {
          anyOf: t,
          default: e.strings,
          description: C("quickSuggestions.strings", "Enable quick suggestions inside strings.")
        },
        comments: {
          anyOf: t,
          default: e.comments,
          description: C("quickSuggestions.comments", "Enable quick suggestions inside comments.")
        },
        other: {
          anyOf: t,
          default: e.other,
          description: C("quickSuggestions.other", "Enable quick suggestions outside of strings and comments.")
        }
      },
      default: e,
      markdownDescription: C("quickSuggestions", "Controls whether suggestions should automatically show up while typing. This can be controlled for typing in comments, strings, and other code. Quick suggestion can be configured to show as ghost text or with the suggest widget. Also be aware of the '{0}'-setting which controls if suggestions are triggered by special characters.", "#editor.suggestOnTriggerCharacters#")
    }), this.defaultValue = e;
  }
  validate(e) {
    if (typeof e == "boolean") {
      const c = e ? "on" : "off";
      return { comments: c, strings: c, other: c };
    }
    if (!e || typeof e != "object")
      return this.defaultValue;
    const { other: t, comments: n, strings: r } = e, s = ["on", "inline", "off"];
    let o, a, l;
    return typeof t == "boolean" ? o = t ? "on" : "off" : o = or(t, this.defaultValue.other, s), typeof n == "boolean" ? a = n ? "on" : "off" : a = or(n, this.defaultValue.comments, s), typeof r == "boolean" ? l = r ? "on" : "off" : l = or(r, this.defaultValue.strings, s), {
      other: o,
      comments: a,
      strings: l
    };
  }
}
class dTe extends xi {
  constructor() {
    super(67, "lineNumbers", { renderType: 1, renderFn: null }, {
      type: "string",
      enum: ["off", "on", "relative", "interval"],
      enumDescriptions: [
        C("lineNumbers.off", "Line numbers are not rendered."),
        C("lineNumbers.on", "Line numbers are rendered as absolute number."),
        C("lineNumbers.relative", "Line numbers are rendered as distance in lines to cursor position."),
        C("lineNumbers.interval", "Line numbers are rendered every 10 lines.")
      ],
      default: "on",
      description: C("lineNumbers", "Controls the display of line numbers.")
    });
  }
  validate(e) {
    let t = this.defaultValue.renderType, n = this.defaultValue.renderFn;
    return typeof e < "u" && (typeof e == "function" ? (t = 4, n = e) : e === "interval" ? t = 3 : e === "relative" ? t = 2 : e === "on" ? t = 1 : t = 0), {
      renderType: t,
      renderFn: n
    };
  }
}
function HE(i) {
  const e = i.get(
    97
    /* EditorOption.renderValidationDecorations */
  );
  return e === "editable" ? i.get(
    90
    /* EditorOption.readOnly */
  ) : e !== "on";
}
class uTe extends xi {
  constructor() {
    const e = [], t = { type: "number", description: C("rulers.size", "Number of monospace characters at which this editor ruler will render.") };
    super(101, "rulers", e, {
      type: "array",
      items: {
        anyOf: [
          t,
          {
            type: [
              "object"
            ],
            properties: {
              column: t,
              color: {
                type: "string",
                description: C("rulers.color", "Color of this editor ruler."),
                format: "color-hex"
              }
            }
          }
        ]
      },
      default: e,
      description: C("rulers", "Render vertical rulers after a certain number of monospace characters. Use multiple values for multiple rulers. No rulers are drawn if array is empty.")
    });
  }
  validate(e) {
    if (Array.isArray(e)) {
      const t = [];
      for (const n of e)
        if (typeof n == "number")
          t.push({
            column: Fn.clampedInt(n, 0, 0, 1e4),
            color: null
          });
        else if (n && typeof n == "object") {
          const r = n;
          t.push({
            column: Fn.clampedInt(r.column, 0, 0, 1e4),
            color: r.color
          });
        }
      return t.sort((n, r) => n.column - r.column), t;
    }
    return this.defaultValue;
  }
}
class hTe extends xi {
  constructor() {
    super(91, "readOnlyMessage", void 0);
  }
  validate(e) {
    return !e || typeof e != "object" ? this.defaultValue : e;
  }
}
function YY(i, e) {
  if (typeof i != "string")
    return e;
  switch (i) {
    case "hidden":
      return 2;
    case "visible":
      return 3;
    default:
      return 1;
  }
}
let fTe = class extends xi {
  constructor() {
    const e = {
      vertical: 1,
      horizontal: 1,
      arrowSize: 11,
      useShadows: !0,
      verticalHasArrows: !1,
      horizontalHasArrows: !1,
      horizontalScrollbarSize: 12,
      horizontalSliderSize: 12,
      verticalScrollbarSize: 14,
      verticalSliderSize: 14,
      handleMouseWheel: !0,
      alwaysConsumeMouseWheel: !0,
      scrollByPage: !1
    };
    super(102, "scrollbar", e, {
      "editor.scrollbar.vertical": {
        type: "string",
        enum: ["auto", "visible", "hidden"],
        enumDescriptions: [
          C("scrollbar.vertical.auto", "The vertical scrollbar will be visible only when necessary."),
          C("scrollbar.vertical.visible", "The vertical scrollbar will always be visible."),
          C("scrollbar.vertical.fit", "The vertical scrollbar will always be hidden.")
        ],
        default: "auto",
        description: C("scrollbar.vertical", "Controls the visibility of the vertical scrollbar.")
      },
      "editor.scrollbar.horizontal": {
        type: "string",
        enum: ["auto", "visible", "hidden"],
        enumDescriptions: [
          C("scrollbar.horizontal.auto", "The horizontal scrollbar will be visible only when necessary."),
          C("scrollbar.horizontal.visible", "The horizontal scrollbar will always be visible."),
          C("scrollbar.horizontal.fit", "The horizontal scrollbar will always be hidden.")
        ],
        default: "auto",
        description: C("scrollbar.horizontal", "Controls the visibility of the horizontal scrollbar.")
      },
      "editor.scrollbar.verticalScrollbarSize": {
        type: "number",
        default: e.verticalScrollbarSize,
        description: C("scrollbar.verticalScrollbarSize", "The width of the vertical scrollbar.")
      },
      "editor.scrollbar.horizontalScrollbarSize": {
        type: "number",
        default: e.horizontalScrollbarSize,
        description: C("scrollbar.horizontalScrollbarSize", "The height of the horizontal scrollbar.")
      },
      "editor.scrollbar.scrollByPage": {
        type: "boolean",
        default: e.scrollByPage,
        description: C("scrollbar.scrollByPage", "Controls whether clicks scroll by page or jump to click position.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e, n = Fn.clampedInt(t.horizontalScrollbarSize, this.defaultValue.horizontalScrollbarSize, 0, 1e3), r = Fn.clampedInt(t.verticalScrollbarSize, this.defaultValue.verticalScrollbarSize, 0, 1e3);
    return {
      arrowSize: Fn.clampedInt(t.arrowSize, this.defaultValue.arrowSize, 0, 1e3),
      vertical: YY(t.vertical, this.defaultValue.vertical),
      horizontal: YY(t.horizontal, this.defaultValue.horizontal),
      useShadows: ut(t.useShadows, this.defaultValue.useShadows),
      verticalHasArrows: ut(t.verticalHasArrows, this.defaultValue.verticalHasArrows),
      horizontalHasArrows: ut(t.horizontalHasArrows, this.defaultValue.horizontalHasArrows),
      handleMouseWheel: ut(t.handleMouseWheel, this.defaultValue.handleMouseWheel),
      alwaysConsumeMouseWheel: ut(t.alwaysConsumeMouseWheel, this.defaultValue.alwaysConsumeMouseWheel),
      horizontalScrollbarSize: n,
      horizontalSliderSize: Fn.clampedInt(t.horizontalSliderSize, n, 0, 1e3),
      verticalScrollbarSize: r,
      verticalSliderSize: Fn.clampedInt(t.verticalSliderSize, r, 0, 1e3),
      scrollByPage: ut(t.scrollByPage, this.defaultValue.scrollByPage)
    };
  }
};
const Ca = "inUntrustedWorkspace", To = {
  allowedCharacters: "editor.unicodeHighlight.allowedCharacters",
  invisibleCharacters: "editor.unicodeHighlight.invisibleCharacters",
  nonBasicASCII: "editor.unicodeHighlight.nonBasicASCII",
  ambiguousCharacters: "editor.unicodeHighlight.ambiguousCharacters",
  includeComments: "editor.unicodeHighlight.includeComments",
  includeStrings: "editor.unicodeHighlight.includeStrings",
  allowedLocales: "editor.unicodeHighlight.allowedLocales"
};
class gTe extends xi {
  constructor() {
    const e = {
      nonBasicASCII: Ca,
      invisibleCharacters: !0,
      ambiguousCharacters: !0,
      includeComments: Ca,
      includeStrings: !0,
      allowedCharacters: {},
      allowedLocales: { _os: !0, _vscode: !0 }
    };
    super(124, "unicodeHighlight", e, {
      [To.nonBasicASCII]: {
        restricted: !0,
        type: ["boolean", "string"],
        enum: [!0, !1, Ca],
        default: e.nonBasicASCII,
        description: C("unicodeHighlight.nonBasicASCII", "Controls whether all non-basic ASCII characters are highlighted. Only characters between U+0020 and U+007E, tab, line-feed and carriage-return are considered basic ASCII.")
      },
      [To.invisibleCharacters]: {
        restricted: !0,
        type: "boolean",
        default: e.invisibleCharacters,
        description: C("unicodeHighlight.invisibleCharacters", "Controls whether characters that just reserve space or have no width at all are highlighted.")
      },
      [To.ambiguousCharacters]: {
        restricted: !0,
        type: "boolean",
        default: e.ambiguousCharacters,
        description: C("unicodeHighlight.ambiguousCharacters", "Controls whether characters are highlighted that can be confused with basic ASCII characters, except those that are common in the current user locale.")
      },
      [To.includeComments]: {
        restricted: !0,
        type: ["boolean", "string"],
        enum: [!0, !1, Ca],
        default: e.includeComments,
        description: C("unicodeHighlight.includeComments", "Controls whether characters in comments should also be subject to Unicode highlighting.")
      },
      [To.includeStrings]: {
        restricted: !0,
        type: ["boolean", "string"],
        enum: [!0, !1, Ca],
        default: e.includeStrings,
        description: C("unicodeHighlight.includeStrings", "Controls whether characters in strings should also be subject to Unicode highlighting.")
      },
      [To.allowedCharacters]: {
        restricted: !0,
        type: "object",
        default: e.allowedCharacters,
        description: C("unicodeHighlight.allowedCharacters", "Defines allowed characters that are not being highlighted."),
        additionalProperties: {
          type: "boolean"
        }
      },
      [To.allowedLocales]: {
        restricted: !0,
        type: "object",
        additionalProperties: {
          type: "boolean"
        },
        default: e.allowedLocales,
        description: C("unicodeHighlight.allowedLocales", "Unicode characters that are common in allowed locales are not being highlighted.")
      }
    });
  }
  applyUpdate(e, t) {
    let n = !1;
    t.allowedCharacters && e && (Ra(e.allowedCharacters, t.allowedCharacters) || (e = Object.assign(Object.assign({}, e), { allowedCharacters: t.allowedCharacters }), n = !0)), t.allowedLocales && e && (Ra(e.allowedLocales, t.allowedLocales) || (e = Object.assign(Object.assign({}, e), { allowedLocales: t.allowedLocales }), n = !0));
    const r = super.applyUpdate(e, t);
    return n ? new CC(r.newValue, !0) : r;
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      nonBasicASCII: Ev(t.nonBasicASCII, Ca, [!0, !1, Ca]),
      invisibleCharacters: ut(t.invisibleCharacters, this.defaultValue.invisibleCharacters),
      ambiguousCharacters: ut(t.ambiguousCharacters, this.defaultValue.ambiguousCharacters),
      includeComments: Ev(t.includeComments, Ca, [!0, !1, Ca]),
      includeStrings: Ev(t.includeStrings, Ca, [!0, !1, Ca]),
      allowedCharacters: this.validateBooleanMap(e.allowedCharacters, this.defaultValue.allowedCharacters),
      allowedLocales: this.validateBooleanMap(e.allowedLocales, this.defaultValue.allowedLocales)
    };
  }
  validateBooleanMap(e, t) {
    if (typeof e != "object" || !e)
      return t;
    const n = {};
    for (const [r, s] of Object.entries(e))
      s === !0 && (n[r] = !0);
    return n;
  }
}
class pTe extends xi {
  constructor() {
    const e = {
      enabled: !0,
      mode: "subwordSmart",
      showToolbar: "onHover",
      suppressSuggestions: !1,
      keepOnBlur: !1
    };
    super(62, "inlineSuggest", e, {
      "editor.inlineSuggest.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("inlineSuggest.enabled", "Controls whether to automatically show inline suggestions in the editor.")
      },
      "editor.inlineSuggest.showToolbar": {
        type: "string",
        default: e.showToolbar,
        enum: ["always", "onHover"],
        enumDescriptions: [
          C("inlineSuggest.showToolbar.always", "Show the inline suggestion toolbar whenever an inline suggestion is shown."),
          C("inlineSuggest.showToolbar.onHover", "Show the inline suggestion toolbar when hovering over an inline suggestion.")
        ],
        description: C("inlineSuggest.showToolbar", "Controls when to show the inline suggestion toolbar.")
      },
      "editor.inlineSuggest.suppressSuggestions": {
        type: "boolean",
        default: e.suppressSuggestions,
        description: C("inlineSuggest.suppressSuggestions", "Controls how inline suggestions interact with the suggest widget. If enabled, the suggest widget is not shown automatically when inline suggestions are available.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: ut(t.enabled, this.defaultValue.enabled),
      mode: or(t.mode, this.defaultValue.mode, ["prefix", "subword", "subwordSmart"]),
      showToolbar: or(t.showToolbar, this.defaultValue.showToolbar, ["always", "onHover"]),
      suppressSuggestions: ut(t.suppressSuggestions, this.defaultValue.suppressSuggestions),
      keepOnBlur: ut(t.keepOnBlur, this.defaultValue.keepOnBlur)
    };
  }
}
class mTe extends xi {
  constructor() {
    const e = {
      enabled: Os.bracketPairColorizationOptions.enabled,
      independentColorPoolPerBracketType: Os.bracketPairColorizationOptions.independentColorPoolPerBracketType
    };
    super(15, "bracketPairColorization", e, {
      "editor.bracketPairColorization.enabled": {
        type: "boolean",
        default: e.enabled,
        markdownDescription: C("bracketPairColorization.enabled", "Controls whether bracket pair colorization is enabled or not. Use {0} to override the bracket highlight colors.", "`#workbench.colorCustomizations#`")
      },
      "editor.bracketPairColorization.independentColorPoolPerBracketType": {
        type: "boolean",
        default: e.independentColorPoolPerBracketType,
        description: C("bracketPairColorization.independentColorPoolPerBracketType", "Controls whether each bracket type has its own independent color pool.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: ut(t.enabled, this.defaultValue.enabled),
      independentColorPoolPerBracketType: ut(t.independentColorPoolPerBracketType, this.defaultValue.independentColorPoolPerBracketType)
    };
  }
}
class vTe extends xi {
  constructor() {
    const e = {
      bracketPairs: !1,
      bracketPairsHorizontal: "active",
      highlightActiveBracketPair: !0,
      indentation: !0,
      highlightActiveIndentation: !0
    };
    super(16, "guides", e, {
      "editor.guides.bracketPairs": {
        type: ["boolean", "string"],
        enum: [!0, "active", !1],
        enumDescriptions: [
          C("editor.guides.bracketPairs.true", "Enables bracket pair guides."),
          C("editor.guides.bracketPairs.active", "Enables bracket pair guides only for the active bracket pair."),
          C("editor.guides.bracketPairs.false", "Disables bracket pair guides.")
        ],
        default: e.bracketPairs,
        description: C("editor.guides.bracketPairs", "Controls whether bracket pair guides are enabled or not.")
      },
      "editor.guides.bracketPairsHorizontal": {
        type: ["boolean", "string"],
        enum: [!0, "active", !1],
        enumDescriptions: [
          C("editor.guides.bracketPairsHorizontal.true", "Enables horizontal guides as addition to vertical bracket pair guides."),
          C("editor.guides.bracketPairsHorizontal.active", "Enables horizontal guides only for the active bracket pair."),
          C("editor.guides.bracketPairsHorizontal.false", "Disables horizontal bracket pair guides.")
        ],
        default: e.bracketPairsHorizontal,
        description: C("editor.guides.bracketPairsHorizontal", "Controls whether horizontal bracket pair guides are enabled or not.")
      },
      "editor.guides.highlightActiveBracketPair": {
        type: "boolean",
        default: e.highlightActiveBracketPair,
        description: C("editor.guides.highlightActiveBracketPair", "Controls whether the editor should highlight the active bracket pair.")
      },
      "editor.guides.indentation": {
        type: "boolean",
        default: e.indentation,
        description: C("editor.guides.indentation", "Controls whether the editor should render indent guides.")
      },
      "editor.guides.highlightActiveIndentation": {
        type: ["boolean", "string"],
        enum: [!0, "always", !1],
        enumDescriptions: [
          C("editor.guides.highlightActiveIndentation.true", "Highlights the active indent guide."),
          C("editor.guides.highlightActiveIndentation.always", "Highlights the active indent guide even if bracket guides are highlighted."),
          C("editor.guides.highlightActiveIndentation.false", "Do not highlight the active indent guide.")
        ],
        default: e.highlightActiveIndentation,
        description: C("editor.guides.highlightActiveIndentation", "Controls whether the editor should highlight the active indent guide.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      bracketPairs: Ev(t.bracketPairs, this.defaultValue.bracketPairs, [!0, !1, "active"]),
      bracketPairsHorizontal: Ev(t.bracketPairsHorizontal, this.defaultValue.bracketPairsHorizontal, [!0, !1, "active"]),
      highlightActiveBracketPair: ut(t.highlightActiveBracketPair, this.defaultValue.highlightActiveBracketPair),
      indentation: ut(t.indentation, this.defaultValue.indentation),
      highlightActiveIndentation: Ev(t.highlightActiveIndentation, this.defaultValue.highlightActiveIndentation, [!0, !1, "always"])
    };
  }
}
function Ev(i, e, t) {
  const n = t.indexOf(i);
  return n === -1 ? e : t[n];
}
class _Te extends xi {
  constructor() {
    const e = {
      insertMode: "insert",
      filterGraceful: !0,
      snippetsPreventQuickSuggestions: !1,
      localityBonus: !1,
      shareSuggestSelections: !1,
      selectionMode: "always",
      showIcons: !0,
      showStatusBar: !1,
      preview: !1,
      previewMode: "subwordSmart",
      showInlineDetails: !0,
      showMethods: !0,
      showFunctions: !0,
      showConstructors: !0,
      showDeprecated: !0,
      matchOnWordStartOnly: !0,
      showFields: !0,
      showVariables: !0,
      showClasses: !0,
      showStructs: !0,
      showInterfaces: !0,
      showModules: !0,
      showProperties: !0,
      showEvents: !0,
      showOperators: !0,
      showUnits: !0,
      showValues: !0,
      showConstants: !0,
      showEnums: !0,
      showEnumMembers: !0,
      showKeywords: !0,
      showWords: !0,
      showColors: !0,
      showFiles: !0,
      showReferences: !0,
      showFolders: !0,
      showTypeParameters: !0,
      showSnippets: !0,
      showUsers: !0,
      showIssues: !0
    };
    super(117, "suggest", e, {
      "editor.suggest.insertMode": {
        type: "string",
        enum: ["insert", "replace"],
        enumDescriptions: [
          C("suggest.insertMode.insert", "Insert suggestion without overwriting text right of the cursor."),
          C("suggest.insertMode.replace", "Insert suggestion and overwrite text right of the cursor.")
        ],
        default: e.insertMode,
        description: C("suggest.insertMode", "Controls whether words are overwritten when accepting completions. Note that this depends on extensions opting into this feature.")
      },
      "editor.suggest.filterGraceful": {
        type: "boolean",
        default: e.filterGraceful,
        description: C("suggest.filterGraceful", "Controls whether filtering and sorting suggestions accounts for small typos.")
      },
      "editor.suggest.localityBonus": {
        type: "boolean",
        default: e.localityBonus,
        description: C("suggest.localityBonus", "Controls whether sorting favors words that appear close to the cursor.")
      },
      "editor.suggest.shareSuggestSelections": {
        type: "boolean",
        default: e.shareSuggestSelections,
        markdownDescription: C("suggest.shareSuggestSelections", "Controls whether remembered suggestion selections are shared between multiple workspaces and windows (needs `#editor.suggestSelection#`).")
      },
      "editor.suggest.selectionMode": {
        type: "string",
        enum: ["always", "never", "whenTriggerCharacter", "whenQuickSuggestion"],
        enumDescriptions: [
          C("suggest.insertMode.always", "Always select a suggestion when automatically triggering IntelliSense."),
          C("suggest.insertMode.never", "Never select a suggestion when automatically triggering IntelliSense."),
          C("suggest.insertMode.whenTriggerCharacter", "Select a suggestion only when triggering IntelliSense from a trigger character."),
          C("suggest.insertMode.whenQuickSuggestion", "Select a suggestion only when triggering IntelliSense as you type.")
        ],
        default: e.selectionMode,
        markdownDescription: C("suggest.selectionMode", "Controls whether a suggestion is selected when the widget shows. Note that this only applies to automatically triggered suggestions (`#editor.quickSuggestions#` and `#editor.suggestOnTriggerCharacters#`) and that a suggestion is always selected when explicitly invoked, e.g via `Ctrl+Space`.")
      },
      "editor.suggest.snippetsPreventQuickSuggestions": {
        type: "boolean",
        default: e.snippetsPreventQuickSuggestions,
        description: C("suggest.snippetsPreventQuickSuggestions", "Controls whether an active snippet prevents quick suggestions.")
      },
      "editor.suggest.showIcons": {
        type: "boolean",
        default: e.showIcons,
        description: C("suggest.showIcons", "Controls whether to show or hide icons in suggestions.")
      },
      "editor.suggest.showStatusBar": {
        type: "boolean",
        default: e.showStatusBar,
        description: C("suggest.showStatusBar", "Controls the visibility of the status bar at the bottom of the suggest widget.")
      },
      "editor.suggest.preview": {
        type: "boolean",
        default: e.preview,
        description: C("suggest.preview", "Controls whether to preview the suggestion outcome in the editor.")
      },
      "editor.suggest.showInlineDetails": {
        type: "boolean",
        default: e.showInlineDetails,
        description: C("suggest.showInlineDetails", "Controls whether suggest details show inline with the label or only in the details widget.")
      },
      "editor.suggest.maxVisibleSuggestions": {
        type: "number",
        deprecationMessage: C("suggest.maxVisibleSuggestions.dep", "This setting is deprecated. The suggest widget can now be resized.")
      },
      "editor.suggest.filteredTypes": {
        type: "object",
        deprecationMessage: C("deprecated", "This setting is deprecated, please use separate settings like 'editor.suggest.showKeywords' or 'editor.suggest.showSnippets' instead.")
      },
      "editor.suggest.showMethods": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showMethods", "When enabled IntelliSense shows `method`-suggestions.")
      },
      "editor.suggest.showFunctions": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showFunctions", "When enabled IntelliSense shows `function`-suggestions.")
      },
      "editor.suggest.showConstructors": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showConstructors", "When enabled IntelliSense shows `constructor`-suggestions.")
      },
      "editor.suggest.showDeprecated": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showDeprecated", "When enabled IntelliSense shows `deprecated`-suggestions.")
      },
      "editor.suggest.matchOnWordStartOnly": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.matchOnWordStartOnly", "When enabled IntelliSense filtering requires that the first character matches on a word start. For example, `c` on `Console` or `WebContext` but _not_ on `description`. When disabled IntelliSense will show more results but still sorts them by match quality.")
      },
      "editor.suggest.showFields": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showFields", "When enabled IntelliSense shows `field`-suggestions.")
      },
      "editor.suggest.showVariables": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showVariables", "When enabled IntelliSense shows `variable`-suggestions.")
      },
      "editor.suggest.showClasses": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showClasss", "When enabled IntelliSense shows `class`-suggestions.")
      },
      "editor.suggest.showStructs": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showStructs", "When enabled IntelliSense shows `struct`-suggestions.")
      },
      "editor.suggest.showInterfaces": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showInterfaces", "When enabled IntelliSense shows `interface`-suggestions.")
      },
      "editor.suggest.showModules": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showModules", "When enabled IntelliSense shows `module`-suggestions.")
      },
      "editor.suggest.showProperties": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showPropertys", "When enabled IntelliSense shows `property`-suggestions.")
      },
      "editor.suggest.showEvents": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showEvents", "When enabled IntelliSense shows `event`-suggestions.")
      },
      "editor.suggest.showOperators": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showOperators", "When enabled IntelliSense shows `operator`-suggestions.")
      },
      "editor.suggest.showUnits": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showUnits", "When enabled IntelliSense shows `unit`-suggestions.")
      },
      "editor.suggest.showValues": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showValues", "When enabled IntelliSense shows `value`-suggestions.")
      },
      "editor.suggest.showConstants": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showConstants", "When enabled IntelliSense shows `constant`-suggestions.")
      },
      "editor.suggest.showEnums": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showEnums", "When enabled IntelliSense shows `enum`-suggestions.")
      },
      "editor.suggest.showEnumMembers": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showEnumMembers", "When enabled IntelliSense shows `enumMember`-suggestions.")
      },
      "editor.suggest.showKeywords": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showKeywords", "When enabled IntelliSense shows `keyword`-suggestions.")
      },
      "editor.suggest.showWords": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showTexts", "When enabled IntelliSense shows `text`-suggestions.")
      },
      "editor.suggest.showColors": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showColors", "When enabled IntelliSense shows `color`-suggestions.")
      },
      "editor.suggest.showFiles": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showFiles", "When enabled IntelliSense shows `file`-suggestions.")
      },
      "editor.suggest.showReferences": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showReferences", "When enabled IntelliSense shows `reference`-suggestions.")
      },
      "editor.suggest.showCustomcolors": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showCustomcolors", "When enabled IntelliSense shows `customcolor`-suggestions.")
      },
      "editor.suggest.showFolders": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showFolders", "When enabled IntelliSense shows `folder`-suggestions.")
      },
      "editor.suggest.showTypeParameters": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showTypeParameters", "When enabled IntelliSense shows `typeParameter`-suggestions.")
      },
      "editor.suggest.showSnippets": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showSnippets", "When enabled IntelliSense shows `snippet`-suggestions.")
      },
      "editor.suggest.showUsers": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showUsers", "When enabled IntelliSense shows `user`-suggestions.")
      },
      "editor.suggest.showIssues": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showIssues", "When enabled IntelliSense shows `issues`-suggestions.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      insertMode: or(t.insertMode, this.defaultValue.insertMode, ["insert", "replace"]),
      filterGraceful: ut(t.filterGraceful, this.defaultValue.filterGraceful),
      snippetsPreventQuickSuggestions: ut(t.snippetsPreventQuickSuggestions, this.defaultValue.filterGraceful),
      localityBonus: ut(t.localityBonus, this.defaultValue.localityBonus),
      shareSuggestSelections: ut(t.shareSuggestSelections, this.defaultValue.shareSuggestSelections),
      selectionMode: or(t.selectionMode, this.defaultValue.selectionMode, ["always", "never", "whenQuickSuggestion", "whenTriggerCharacter"]),
      showIcons: ut(t.showIcons, this.defaultValue.showIcons),
      showStatusBar: ut(t.showStatusBar, this.defaultValue.showStatusBar),
      preview: ut(t.preview, this.defaultValue.preview),
      previewMode: or(t.previewMode, this.defaultValue.previewMode, ["prefix", "subword", "subwordSmart"]),
      showInlineDetails: ut(t.showInlineDetails, this.defaultValue.showInlineDetails),
      showMethods: ut(t.showMethods, this.defaultValue.showMethods),
      showFunctions: ut(t.showFunctions, this.defaultValue.showFunctions),
      showConstructors: ut(t.showConstructors, this.defaultValue.showConstructors),
      showDeprecated: ut(t.showDeprecated, this.defaultValue.showDeprecated),
      matchOnWordStartOnly: ut(t.matchOnWordStartOnly, this.defaultValue.matchOnWordStartOnly),
      showFields: ut(t.showFields, this.defaultValue.showFields),
      showVariables: ut(t.showVariables, this.defaultValue.showVariables),
      showClasses: ut(t.showClasses, this.defaultValue.showClasses),
      showStructs: ut(t.showStructs, this.defaultValue.showStructs),
      showInterfaces: ut(t.showInterfaces, this.defaultValue.showInterfaces),
      showModules: ut(t.showModules, this.defaultValue.showModules),
      showProperties: ut(t.showProperties, this.defaultValue.showProperties),
      showEvents: ut(t.showEvents, this.defaultValue.showEvents),
      showOperators: ut(t.showOperators, this.defaultValue.showOperators),
      showUnits: ut(t.showUnits, this.defaultValue.showUnits),
      showValues: ut(t.showValues, this.defaultValue.showValues),
      showConstants: ut(t.showConstants, this.defaultValue.showConstants),
      showEnums: ut(t.showEnums, this.defaultValue.showEnums),
      showEnumMembers: ut(t.showEnumMembers, this.defaultValue.showEnumMembers),
      showKeywords: ut(t.showKeywords, this.defaultValue.showKeywords),
      showWords: ut(t.showWords, this.defaultValue.showWords),
      showColors: ut(t.showColors, this.defaultValue.showColors),
      showFiles: ut(t.showFiles, this.defaultValue.showFiles),
      showReferences: ut(t.showReferences, this.defaultValue.showReferences),
      showFolders: ut(t.showFolders, this.defaultValue.showFolders),
      showTypeParameters: ut(t.showTypeParameters, this.defaultValue.showTypeParameters),
      showSnippets: ut(t.showSnippets, this.defaultValue.showSnippets),
      showUsers: ut(t.showUsers, this.defaultValue.showUsers),
      showIssues: ut(t.showIssues, this.defaultValue.showIssues)
    };
  }
}
class bTe extends xi {
  constructor() {
    super(112, "smartSelect", {
      selectLeadingAndTrailingWhitespace: !0,
      selectSubwords: !0
    }, {
      "editor.smartSelect.selectLeadingAndTrailingWhitespace": {
        description: C("selectLeadingAndTrailingWhitespace", "Whether leading and trailing whitespace should always be selected."),
        default: !0,
        type: "boolean"
      },
      "editor.smartSelect.selectSubwords": {
        description: C("selectSubwords", "Whether subwords (like 'foo' in 'fooBar' or 'foo_bar') should be selected."),
        default: !0,
        type: "boolean"
      }
    });
  }
  validate(e) {
    return !e || typeof e != "object" ? this.defaultValue : {
      selectLeadingAndTrailingWhitespace: ut(e.selectLeadingAndTrailingWhitespace, this.defaultValue.selectLeadingAndTrailingWhitespace),
      selectSubwords: ut(e.selectSubwords, this.defaultValue.selectSubwords)
    };
  }
}
class CTe extends xi {
  constructor() {
    super(136, "wrappingIndent", 1, {
      "editor.wrappingIndent": {
        type: "string",
        enum: ["none", "same", "indent", "deepIndent"],
        enumDescriptions: [
          C("wrappingIndent.none", "No indentation. Wrapped lines begin at column 1."),
          C("wrappingIndent.same", "Wrapped lines get the same indentation as the parent."),
          C("wrappingIndent.indent", "Wrapped lines get +1 indentation toward the parent."),
          C("wrappingIndent.deepIndent", "Wrapped lines get +2 indentation toward the parent.")
        ],
        description: C("wrappingIndent", "Controls the indentation of wrapped lines."),
        default: "same"
      }
    });
  }
  validate(e) {
    switch (e) {
      case "none":
        return 0;
      case "same":
        return 1;
      case "indent":
        return 2;
      case "deepIndent":
        return 3;
    }
    return 1;
  }
  compute(e, t, n) {
    return t.get(
      2
      /* EditorOption.accessibilitySupport */
    ) === 2 ? 0 : n;
  }
}
class yTe extends vS {
  constructor() {
    super(
      144
      /* EditorOption.wrappingInfo */
    );
  }
  compute(e, t, n) {
    const r = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    return {
      isDominatedByLongLines: e.isDominatedByLongLines,
      isWordWrapMinified: r.isWordWrapMinified,
      isViewportWrapping: r.isViewportWrapping,
      wrappingColumn: r.wrappingColumn
    };
  }
}
class wTe extends xi {
  constructor() {
    const e = { enabled: !0, showDropSelector: "afterDrop" };
    super(36, "dropIntoEditor", e, {
      "editor.dropIntoEditor.enabled": {
        type: "boolean",
        default: e.enabled,
        markdownDescription: C("dropIntoEditor.enabled", "Controls whether you can drag and drop a file into a text editor by holding down `shift` (instead of opening the file in an editor).")
      },
      "editor.dropIntoEditor.showDropSelector": {
        type: "string",
        markdownDescription: C("dropIntoEditor.showDropSelector", "Controls if a widget is shown when dropping files into the editor. This widget lets you control how the file is dropped."),
        enum: [
          "afterDrop",
          "never"
        ],
        enumDescriptions: [
          C("dropIntoEditor.showDropSelector.afterDrop", "Show the drop selector widget after a file is dropped into the editor."),
          C("dropIntoEditor.showDropSelector.never", "Never show the drop selector widget. Instead the default drop provider is always used.")
        ],
        default: "afterDrop"
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: ut(t.enabled, this.defaultValue.enabled),
      showDropSelector: or(t.showDropSelector, this.defaultValue.showDropSelector, ["afterDrop", "never"])
    };
  }
}
class STe extends xi {
  constructor() {
    const e = { enabled: !0, showPasteSelector: "afterPaste" };
    super(84, "pasteAs", e, {
      "editor.pasteAs.enabled": {
        type: "boolean",
        default: e.enabled,
        markdownDescription: C("pasteAs.enabled", "Controls whether you can paste content in different ways.")
      },
      "editor.pasteAs.showPasteSelector": {
        type: "string",
        markdownDescription: C("pasteAs.showPasteSelector", "Controls if a widget is shown when pasting content in to the editor. This widget lets you control how the file is pasted."),
        enum: [
          "afterPaste",
          "never"
        ],
        enumDescriptions: [
          C("pasteAs.showPasteSelector.afterPaste", "Show the paste selector widget after content is pasted into the editor."),
          C("pasteAs.showPasteSelector.never", "Never show the paste selector widget. Instead the default pasting behavior is always used.")
        ],
        default: "afterPaste"
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: ut(t.enabled, this.defaultValue.enabled),
      showPasteSelector: or(t.showPasteSelector, this.defaultValue.showPasteSelector, ["afterPaste", "never"])
    };
  }
}
const xTe = "Consolas, 'Courier New', monospace", DTe = "Menlo, Monaco, 'Courier New', monospace", ETe = "'Droid Sans Mono', 'monospace', monospace", na = {
  fontFamily: sn ? DTe : $s ? ETe : xTe,
  fontWeight: "normal",
  fontSize: sn ? 12 : 14,
  lineHeight: 0,
  letterSpacing: 0
}, q1 = [];
function Fe(i) {
  return q1[i.id] = i, i;
}
const pd = {
  acceptSuggestionOnCommitCharacter: Fe(new ln(0, "acceptSuggestionOnCommitCharacter", !0, { markdownDescription: C("acceptSuggestionOnCommitCharacter", "Controls whether suggestions should be accepted on commit characters. For example, in JavaScript, the semi-colon (`;`) can be a commit character that accepts a suggestion and types that character.") })),
  acceptSuggestionOnEnter: Fe(new Bi(1, "acceptSuggestionOnEnter", "on", ["on", "smart", "off"], {
    markdownEnumDescriptions: [
      "",
      C("acceptSuggestionOnEnterSmart", "Only accept a suggestion with `Enter` when it makes a textual change."),
      ""
    ],
    markdownDescription: C("acceptSuggestionOnEnter", "Controls whether suggestions should be accepted on `Enter`, in addition to `Tab`. Helps to avoid ambiguity between inserting new lines or accepting suggestions.")
  })),
  accessibilitySupport: Fe(new W6e()),
  accessibilityPageSize: Fe(new Fn(3, "accessibilityPageSize", 10, 1, 1073741824, {
    description: C("accessibilityPageSize", "Controls the number of lines in the editor that can be read out by a screen reader at once. When we detect a screen reader we automatically set the default to be 500. Warning: this has a performance implication for numbers larger than the default."),
    tags: ["accessibility"]
  })),
  ariaLabel: Fe(new Ko(4, "ariaLabel", C("editorViewAccessibleLabel", "Editor content"))),
  ariaRequired: Fe(new ln(5, "ariaRequired", !1, void 0)),
  screenReaderAnnounceInlineSuggestion: Fe(new ln(8, "screenReaderAnnounceInlineSuggestion", !0, {
    description: C("screenReaderAnnounceInlineSuggestion", "Control whether inline suggestions are announced by a screen reader."),
    tags: ["accessibility"]
  })),
  autoClosingBrackets: Fe(new Bi(6, "autoClosingBrackets", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingBrackets.languageDefined", "Use language configurations to determine when to autoclose brackets."),
      C("editor.autoClosingBrackets.beforeWhitespace", "Autoclose brackets only when the cursor is to the left of whitespace."),
      ""
    ],
    description: C("autoClosingBrackets", "Controls whether the editor should automatically close brackets after the user adds an opening bracket.")
  })),
  autoClosingComments: Fe(new Bi(7, "autoClosingComments", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingComments.languageDefined", "Use language configurations to determine when to autoclose comments."),
      C("editor.autoClosingComments.beforeWhitespace", "Autoclose comments only when the cursor is to the left of whitespace."),
      ""
    ],
    description: C("autoClosingComments", "Controls whether the editor should automatically close comments after the user adds an opening comment.")
  })),
  autoClosingDelete: Fe(new Bi(9, "autoClosingDelete", "auto", ["always", "auto", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingDelete.auto", "Remove adjacent closing quotes or brackets only if they were automatically inserted."),
      ""
    ],
    description: C("autoClosingDelete", "Controls whether the editor should remove adjacent closing quotes or brackets when deleting.")
  })),
  autoClosingOvertype: Fe(new Bi(10, "autoClosingOvertype", "auto", ["always", "auto", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingOvertype.auto", "Type over closing quotes or brackets only if they were automatically inserted."),
      ""
    ],
    description: C("autoClosingOvertype", "Controls whether the editor should type over closing quotes or brackets.")
  })),
  autoClosingQuotes: Fe(new Bi(11, "autoClosingQuotes", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingQuotes.languageDefined", "Use language configurations to determine when to autoclose quotes."),
      C("editor.autoClosingQuotes.beforeWhitespace", "Autoclose quotes only when the cursor is to the left of whitespace."),
      ""
    ],
    description: C("autoClosingQuotes", "Controls whether the editor should automatically close quotes after the user adds an opening quote.")
  })),
  autoIndent: Fe(new Mx(12, "autoIndent", 4, "full", ["none", "keep", "brackets", "advanced", "full"], H6e, {
    enumDescriptions: [
      C("editor.autoIndent.none", "The editor will not insert indentation automatically."),
      C("editor.autoIndent.keep", "The editor will keep the current line's indentation."),
      C("editor.autoIndent.brackets", "The editor will keep the current line's indentation and honor language defined brackets."),
      C("editor.autoIndent.advanced", "The editor will keep the current line's indentation, honor language defined brackets and invoke special onEnterRules defined by languages."),
      C("editor.autoIndent.full", "The editor will keep the current line's indentation, honor language defined brackets, invoke special onEnterRules defined by languages, and honor indentationRules defined by languages.")
    ],
    description: C("autoIndent", "Controls whether the editor should automatically adjust the indentation when users type, paste, move or indent lines.")
  })),
  automaticLayout: Fe(new ln(13, "automaticLayout", !1)),
  autoSurround: Fe(new Bi(14, "autoSurround", "languageDefined", ["languageDefined", "quotes", "brackets", "never"], {
    enumDescriptions: [
      C("editor.autoSurround.languageDefined", "Use language configurations to determine when to automatically surround selections."),
      C("editor.autoSurround.quotes", "Surround with quotes but not brackets."),
      C("editor.autoSurround.brackets", "Surround with brackets but not quotes."),
      ""
    ],
    description: C("autoSurround", "Controls whether the editor should automatically surround selections when typing quotes or brackets.")
  })),
  bracketPairColorization: Fe(new mTe()),
  bracketPairGuides: Fe(new vTe()),
  stickyTabStops: Fe(new ln(115, "stickyTabStops", !1, { description: C("stickyTabStops", "Emulate selection behavior of tab characters when using spaces for indentation. Selection will stick to tab stops.") })),
  codeLens: Fe(new ln(17, "codeLens", !0, { description: C("codeLens", "Controls whether the editor shows CodeLens.") })),
  codeLensFontFamily: Fe(new Ko(18, "codeLensFontFamily", "", { description: C("codeLensFontFamily", "Controls the font family for CodeLens.") })),
  codeLensFontSize: Fe(new Fn(19, "codeLensFontSize", 0, 0, 100, {
    type: "number",
    default: 0,
    minimum: 0,
    maximum: 100,
    markdownDescription: C("codeLensFontSize", "Controls the font size in pixels for CodeLens. When set to 0, 90% of `#editor.fontSize#` is used.")
  })),
  colorDecorators: Fe(new ln(20, "colorDecorators", !0, { description: C("colorDecorators", "Controls whether the editor should render the inline color decorators and color picker.") })),
  colorDecoratorActivatedOn: Fe(new Bi(146, "colorDecoratorsActivatedOn", "clickAndHover", ["clickAndHover", "hover", "click"], {
    enumDescriptions: [
      C("editor.colorDecoratorActivatedOn.clickAndHover", "Make the color picker appear both on click and hover of the color decorator"),
      C("editor.colorDecoratorActivatedOn.hover", "Make the color picker appear on hover of the color decorator"),
      C("editor.colorDecoratorActivatedOn.click", "Make the color picker appear on click of the color decorator")
    ],
    description: C("colorDecoratorActivatedOn", "Controls the condition to make a color picker appear from a color decorator")
  })),
  colorDecoratorsLimit: Fe(new Fn(21, "colorDecoratorsLimit", 500, 1, 1e6, {
    markdownDescription: C("colorDecoratorsLimit", "Controls the max number of color decorators that can be rendered in an editor at once.")
  })),
  columnSelection: Fe(new ln(22, "columnSelection", !1, { description: C("columnSelection", "Enable that the selection with the mouse and keys is doing column selection.") })),
  comments: Fe(new j6e()),
  contextmenu: Fe(new ln(24, "contextmenu", !0)),
  copyWithSyntaxHighlighting: Fe(new ln(25, "copyWithSyntaxHighlighting", !0, { description: C("copyWithSyntaxHighlighting", "Controls whether syntax highlighting should be copied into the clipboard.") })),
  cursorBlinking: Fe(new Mx(26, "cursorBlinking", 1, "blink", ["blink", "smooth", "phase", "expand", "solid"], z6e, { description: C("cursorBlinking", "Control the cursor animation style.") })),
  cursorSmoothCaretAnimation: Fe(new Bi(27, "cursorSmoothCaretAnimation", "off", ["off", "explicit", "on"], {
    enumDescriptions: [
      C("cursorSmoothCaretAnimation.off", "Smooth caret animation is disabled."),
      C("cursorSmoothCaretAnimation.explicit", "Smooth caret animation is enabled only when the user moves the cursor with an explicit gesture."),
      C("cursorSmoothCaretAnimation.on", "Smooth caret animation is always enabled.")
    ],
    description: C("cursorSmoothCaretAnimation", "Controls whether the smooth caret animation should be enabled.")
  })),
  cursorStyle: Fe(new Mx(28, "cursorStyle", rs.Line, "line", ["line", "block", "underline", "line-thin", "block-outline", "underline-thin"], U6e, { description: C("cursorStyle", "Controls the cursor style.") })),
  cursorSurroundingLines: Fe(new Fn(29, "cursorSurroundingLines", 0, 0, 1073741824, { description: C("cursorSurroundingLines", "Controls the minimal number of visible leading lines (minimum 0) and trailing lines (minimum 1) surrounding the cursor. Known as 'scrollOff' or 'scrollOffset' in some other editors.") })),
  cursorSurroundingLinesStyle: Fe(new Bi(30, "cursorSurroundingLinesStyle", "default", ["default", "all"], {
    enumDescriptions: [
      C("cursorSurroundingLinesStyle.default", "`cursorSurroundingLines` is enforced only when triggered via the keyboard or API."),
      C("cursorSurroundingLinesStyle.all", "`cursorSurroundingLines` is enforced always.")
    ],
    markdownDescription: C("cursorSurroundingLinesStyle", "Controls when `#cursorSurroundingLines#` should be enforced.")
  })),
  cursorWidth: Fe(new Fn(31, "cursorWidth", 0, 0, 1073741824, { markdownDescription: C("cursorWidth", "Controls the width of the cursor when `#editor.cursorStyle#` is set to `line`.") })),
  disableLayerHinting: Fe(new ln(32, "disableLayerHinting", !1)),
  disableMonospaceOptimizations: Fe(new ln(33, "disableMonospaceOptimizations", !1)),
  domReadOnly: Fe(new ln(34, "domReadOnly", !1)),
  dragAndDrop: Fe(new ln(35, "dragAndDrop", !0, { description: C("dragAndDrop", "Controls whether the editor should allow moving selections via drag and drop.") })),
  emptySelectionClipboard: Fe(new q6e()),
  dropIntoEditor: Fe(new wTe()),
  stickyScroll: Fe(new eTe()),
  experimentalWhitespaceRendering: Fe(new Bi(38, "experimentalWhitespaceRendering", "svg", ["svg", "font", "off"], {
    enumDescriptions: [
      C("experimentalWhitespaceRendering.svg", "Use a new rendering method with svgs."),
      C("experimentalWhitespaceRendering.font", "Use a new rendering method with font characters."),
      C("experimentalWhitespaceRendering.off", "Use the stable rendering method.")
    ],
    description: C("experimentalWhitespaceRendering", "Controls whether whitespace is rendered with a new, experimental method.")
  })),
  extraEditorClassName: Fe(new Ko(39, "extraEditorClassName", "")),
  fastScrollSensitivity: Fe(new zl(40, "fastScrollSensitivity", 5, (i) => i <= 0 ? 5 : i, { markdownDescription: C("fastScrollSensitivity", "Scrolling speed multiplier when pressing `Alt`.") })),
  find: Fe(new K6e()),
  fixedOverflowWidgets: Fe(new ln(42, "fixedOverflowWidgets", !1)),
  folding: Fe(new ln(43, "folding", !0, { description: C("folding", "Controls whether the editor has code folding enabled.") })),
  foldingStrategy: Fe(new Bi(44, "foldingStrategy", "auto", ["auto", "indentation"], {
    enumDescriptions: [
      C("foldingStrategy.auto", "Use a language-specific folding strategy if available, else the indentation-based one."),
      C("foldingStrategy.indentation", "Use the indentation-based folding strategy.")
    ],
    description: C("foldingStrategy", "Controls the strategy for computing folding ranges.")
  })),
  foldingHighlight: Fe(new ln(45, "foldingHighlight", !0, { description: C("foldingHighlight", "Controls whether the editor should highlight folded ranges.") })),
  foldingImportsByDefault: Fe(new ln(46, "foldingImportsByDefault", !1, { description: C("foldingImportsByDefault", "Controls whether the editor automatically collapses import ranges.") })),
  foldingMaximumRegions: Fe(new Fn(
    47,
    "foldingMaximumRegions",
    5e3,
    10,
    65e3,
    // limit must be less than foldingRanges MAX_FOLDING_REGIONS
    { description: C("foldingMaximumRegions", "The maximum number of foldable regions. Increasing this value may result in the editor becoming less responsive when the current source has a large number of foldable regions.") }
  )),
  unfoldOnClickAfterEndOfLine: Fe(new ln(48, "unfoldOnClickAfterEndOfLine", !1, { description: C("unfoldOnClickAfterEndOfLine", "Controls whether clicking on the empty content after a folded line will unfold the line.") })),
  fontFamily: Fe(new Ko(49, "fontFamily", na.fontFamily, { description: C("fontFamily", "Controls the font family.") })),
  fontInfo: Fe(new Y6e()),
  fontLigatures2: Fe(new Da()),
  fontSize: Fe(new X6e()),
  fontWeight: Fe(new Hd()),
  fontVariations: Fe(new Hc()),
  formatOnPaste: Fe(new ln(55, "formatOnPaste", !1, { description: C("formatOnPaste", "Controls whether the editor should automatically format the pasted content. A formatter must be available and the formatter should be able to format a range in a document.") })),
  formatOnType: Fe(new ln(56, "formatOnType", !1, { description: C("formatOnType", "Controls whether the editor should automatically format the line after typing.") })),
  glyphMargin: Fe(new ln(57, "glyphMargin", !0, { description: C("glyphMargin", "Controls whether the editor should render the vertical glyph margin. Glyph margin is mostly used for debugging.") })),
  gotoLocation: Fe(new Z6e()),
  hideCursorInOverviewRuler: Fe(new ln(59, "hideCursorInOverviewRuler", !1, { description: C("hideCursorInOverviewRuler", "Controls whether the cursor should be hidden in the overview ruler.") })),
  hover: Fe(new Q6e()),
  inDiffEditor: Fe(new ln(61, "inDiffEditor", !1)),
  letterSpacing: Fe(new zl(63, "letterSpacing", na.letterSpacing, (i) => zl.clamp(i, -5, 20), { description: C("letterSpacing", "Controls the letter spacing in pixels.") })),
  lightbulb: Fe(new $6e()),
  lineDecorationsWidth: Fe(new nTe()),
  lineHeight: Fe(new iTe()),
  lineNumbers: Fe(new dTe()),
  lineNumbersMinChars: Fe(new Fn(68, "lineNumbersMinChars", 5, 1, 300)),
  linkedEditing: Fe(new ln(69, "linkedEditing", !1, { description: C("linkedEditing", "Controls whether the editor has linked editing enabled. Depending on the language, related symbols such as HTML tags, are updated while editing.") })),
  links: Fe(new ln(70, "links", !0, { description: C("links", "Controls whether the editor should detect links and make them clickable.") })),
  matchBrackets: Fe(new Bi(71, "matchBrackets", "always", ["always", "near", "never"], { description: C("matchBrackets", "Highlight matching brackets.") })),
  minimap: Fe(new rTe()),
  mouseStyle: Fe(new Bi(73, "mouseStyle", "text", ["text", "default", "copy"])),
  mouseWheelScrollSensitivity: Fe(new zl(74, "mouseWheelScrollSensitivity", 1, (i) => i === 0 ? 1 : i, { markdownDescription: C("mouseWheelScrollSensitivity", "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.") })),
  mouseWheelZoom: Fe(new ln(75, "mouseWheelZoom", !1, { markdownDescription: C("mouseWheelZoom", "Zoom the font of the editor when using mouse wheel and holding `Ctrl`.") })),
  multiCursorMergeOverlapping: Fe(new ln(76, "multiCursorMergeOverlapping", !0, { description: C("multiCursorMergeOverlapping", "Merge multiple cursors when they are overlapping.") })),
  multiCursorModifier: Fe(new Mx(77, "multiCursorModifier", "altKey", "alt", ["ctrlCmd", "alt"], sTe, {
    markdownEnumDescriptions: [
      C("multiCursorModifier.ctrlCmd", "Maps to `Control` on Windows and Linux and to `Command` on macOS."),
      C("multiCursorModifier.alt", "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")
    ],
    markdownDescription: C({
      key: "multiCursorModifier",
      comment: [
        "- `ctrlCmd` refers to a value the setting can take and should not be localized.",
        "- `Control` and `Command` refer to the modifier keys Ctrl or Cmd on the keyboard and can be localized."
      ]
    }, "The modifier to be used to add multiple cursors with the mouse. The Go to Definition and Open Link mouse gestures will adapt such that they do not conflict with the [multicursor modifier](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).")
  })),
  multiCursorPaste: Fe(new Bi(78, "multiCursorPaste", "spread", ["spread", "full"], {
    markdownEnumDescriptions: [
      C("multiCursorPaste.spread", "Each cursor pastes a single line of the text."),
      C("multiCursorPaste.full", "Each cursor pastes the full text.")
    ],
    markdownDescription: C("multiCursorPaste", "Controls pasting when the line count of the pasted text matches the cursor count.")
  })),
  multiCursorLimit: Fe(new Fn(79, "multiCursorLimit", 1e4, 1, 1e5, {
    markdownDescription: C("multiCursorLimit", "Controls the max number of cursors that can be in an active editor at once.")
  })),
  occurrencesHighlight: Fe(new ln(80, "occurrencesHighlight", !0, { description: C("occurrencesHighlight", "Controls whether the editor should highlight semantic symbol occurrences.") })),
  overviewRulerBorder: Fe(new ln(81, "overviewRulerBorder", !0, { description: C("overviewRulerBorder", "Controls whether a border should be drawn around the overview ruler.") })),
  overviewRulerLanes: Fe(new Fn(82, "overviewRulerLanes", 3, 0, 3)),
  padding: Fe(new oTe()),
  pasteAs: Fe(new STe()),
  parameterHints: Fe(new aTe()),
  peekWidgetDefaultFocus: Fe(new Bi(86, "peekWidgetDefaultFocus", "tree", ["tree", "editor"], {
    enumDescriptions: [
      C("peekWidgetDefaultFocus.tree", "Focus the tree when opening peek"),
      C("peekWidgetDefaultFocus.editor", "Focus the editor when opening peek")
    ],
    description: C("peekWidgetDefaultFocus", "Controls whether to focus the inline editor or the tree in the peek widget.")
  })),
  definitionLinkOpensInPeek: Fe(new ln(87, "definitionLinkOpensInPeek", !1, { description: C("definitionLinkOpensInPeek", "Controls whether the Go to Definition mouse gesture always opens the peek widget.") })),
  quickSuggestions: Fe(new cTe()),
  quickSuggestionsDelay: Fe(new Fn(89, "quickSuggestionsDelay", 10, 0, 1073741824, { description: C("quickSuggestionsDelay", "Controls the delay in milliseconds after which quick suggestions will show up.") })),
  readOnly: Fe(new ln(90, "readOnly", !1)),
  readOnlyMessage: Fe(new hTe()),
  renameOnType: Fe(new ln(92, "renameOnType", !1, { description: C("renameOnType", "Controls whether the editor auto renames on type."), markdownDeprecationMessage: C("renameOnTypeDeprecate", "Deprecated, use `editor.linkedEditing` instead.") })),
  renderControlCharacters: Fe(new ln(93, "renderControlCharacters", !0, { description: C("renderControlCharacters", "Controls whether the editor should render control characters."), restricted: !0 })),
  renderFinalNewline: Fe(new Bi(94, "renderFinalNewline", $s ? "dimmed" : "on", ["off", "on", "dimmed"], { description: C("renderFinalNewline", "Render last line number when the file ends with a newline.") })),
  renderLineHighlight: Fe(new Bi(95, "renderLineHighlight", "line", ["none", "gutter", "line", "all"], {
    enumDescriptions: [
      "",
      "",
      "",
      C("renderLineHighlight.all", "Highlights both the gutter and the current line.")
    ],
    description: C("renderLineHighlight", "Controls how the editor should render the current line highlight.")
  })),
  renderLineHighlightOnlyWhenFocus: Fe(new ln(96, "renderLineHighlightOnlyWhenFocus", !1, { description: C("renderLineHighlightOnlyWhenFocus", "Controls if the editor should render the current line highlight only when the editor is focused.") })),
  renderValidationDecorations: Fe(new Bi(97, "renderValidationDecorations", "editable", ["editable", "on", "off"])),
  renderWhitespace: Fe(new Bi(98, "renderWhitespace", "selection", ["none", "boundary", "selection", "trailing", "all"], {
    enumDescriptions: [
      "",
      C("renderWhitespace.boundary", "Render whitespace characters except for single spaces between words."),
      C("renderWhitespace.selection", "Render whitespace characters only on selected text."),
      C("renderWhitespace.trailing", "Render only trailing whitespace characters."),
      ""
    ],
    description: C("renderWhitespace", "Controls how the editor should render whitespace characters.")
  })),
  revealHorizontalRightPadding: Fe(new Fn(99, "revealHorizontalRightPadding", 15, 0, 1e3)),
  roundedSelection: Fe(new ln(100, "roundedSelection", !0, { description: C("roundedSelection", "Controls whether selections should have rounded corners.") })),
  rulers: Fe(new uTe()),
  scrollbar: Fe(new fTe()),
  scrollBeyondLastColumn: Fe(new Fn(103, "scrollBeyondLastColumn", 4, 0, 1073741824, { description: C("scrollBeyondLastColumn", "Controls the number of extra characters beyond which the editor will scroll horizontally.") })),
  scrollBeyondLastLine: Fe(new ln(104, "scrollBeyondLastLine", !0, { description: C("scrollBeyondLastLine", "Controls whether the editor will scroll beyond the last line.") })),
  scrollPredominantAxis: Fe(new ln(105, "scrollPredominantAxis", !0, { description: C("scrollPredominantAxis", "Scroll only along the predominant axis when scrolling both vertically and horizontally at the same time. Prevents horizontal drift when scrolling vertically on a trackpad.") })),
  selectionClipboard: Fe(new ln(106, "selectionClipboard", !0, {
    description: C("selectionClipboard", "Controls whether the Linux primary clipboard should be supported."),
    included: $s
  })),
  selectionHighlight: Fe(new ln(107, "selectionHighlight", !0, { description: C("selectionHighlight", "Controls whether the editor should highlight matches similar to the selection.") })),
  selectOnLineNumbers: Fe(new ln(108, "selectOnLineNumbers", !0)),
  showFoldingControls: Fe(new Bi(109, "showFoldingControls", "mouseover", ["always", "never", "mouseover"], {
    enumDescriptions: [
      C("showFoldingControls.always", "Always show the folding controls."),
      C("showFoldingControls.never", "Never show the folding controls and reduce the gutter size."),
      C("showFoldingControls.mouseover", "Only show the folding controls when the mouse is over the gutter.")
    ],
    description: C("showFoldingControls", "Controls when the folding controls on the gutter are shown.")
  })),
  showUnused: Fe(new ln(110, "showUnused", !0, { description: C("showUnused", "Controls fading out of unused code.") })),
  showDeprecated: Fe(new ln(138, "showDeprecated", !0, { description: C("showDeprecated", "Controls strikethrough deprecated variables.") })),
  inlayHints: Fe(new tTe()),
  snippetSuggestions: Fe(new Bi(111, "snippetSuggestions", "inline", ["top", "bottom", "inline", "none"], {
    enumDescriptions: [
      C("snippetSuggestions.top", "Show snippet suggestions on top of other suggestions."),
      C("snippetSuggestions.bottom", "Show snippet suggestions below other suggestions."),
      C("snippetSuggestions.inline", "Show snippets suggestions with other suggestions."),
      C("snippetSuggestions.none", "Do not show snippet suggestions.")
    ],
    description: C("snippetSuggestions", "Controls whether snippets are shown with other suggestions and how they are sorted.")
  })),
  smartSelect: Fe(new bTe()),
  smoothScrolling: Fe(new ln(113, "smoothScrolling", !1, { description: C("smoothScrolling", "Controls whether the editor will scroll using an animation.") })),
  stopRenderingLineAfter: Fe(new Fn(
    116,
    "stopRenderingLineAfter",
    1e4,
    -1,
    1073741824
    /* Constants.MAX_SAFE_SMALL_INTEGER */
  )),
  suggest: Fe(new _Te()),
  inlineSuggest: Fe(new pTe()),
  inlineCompletionsAccessibilityVerbose: Fe(new ln(147, "inlineCompletionsAccessibilityVerbose", !1, { description: C("inlineCompletionsAccessibilityVerbose", "Controls whether the accessibility hint should be provided to screen reader users when an inline completion is shown.") })),
  suggestFontSize: Fe(new Fn(118, "suggestFontSize", 0, 0, 1e3, { markdownDescription: C("suggestFontSize", "Font size for the suggest widget. When set to {0}, the value of {1} is used.", "`0`", "`#editor.fontSize#`") })),
  suggestLineHeight: Fe(new Fn(119, "suggestLineHeight", 0, 0, 1e3, { markdownDescription: C("suggestLineHeight", "Line height for the suggest widget. When set to {0}, the value of {1} is used. The minimum value is 8.", "`0`", "`#editor.lineHeight#`") })),
  suggestOnTriggerCharacters: Fe(new ln(120, "suggestOnTriggerCharacters", !0, { description: C("suggestOnTriggerCharacters", "Controls whether suggestions should automatically show up when typing trigger characters.") })),
  suggestSelection: Fe(new Bi(121, "suggestSelection", "first", ["first", "recentlyUsed", "recentlyUsedByPrefix"], {
    markdownEnumDescriptions: [
      C("suggestSelection.first", "Always select the first suggestion."),
      C("suggestSelection.recentlyUsed", "Select recent suggestions unless further typing selects one, e.g. `console.| -> console.log` because `log` has been completed recently."),
      C("suggestSelection.recentlyUsedByPrefix", "Select suggestions based on previous prefixes that have completed those suggestions, e.g. `co -> console` and `con -> const`.")
    ],
    description: C("suggestSelection", "Controls how suggestions are pre-selected when showing the suggest list.")
  })),
  tabCompletion: Fe(new Bi(122, "tabCompletion", "off", ["on", "off", "onlySnippets"], {
    enumDescriptions: [
      C("tabCompletion.on", "Tab complete will insert the best matching suggestion when pressing tab."),
      C("tabCompletion.off", "Disable tab completions."),
      C("tabCompletion.onlySnippets", "Tab complete snippets when their prefix match. Works best when 'quickSuggestions' aren't enabled.")
    ],
    description: C("tabCompletion", "Enables tab completions.")
  })),
  tabIndex: Fe(new Fn(
    123,
    "tabIndex",
    0,
    -1,
    1073741824
    /* Constants.MAX_SAFE_SMALL_INTEGER */
  )),
  unicodeHighlight: Fe(new gTe()),
  unusualLineTerminators: Fe(new Bi(125, "unusualLineTerminators", "prompt", ["auto", "off", "prompt"], {
    enumDescriptions: [
      C("unusualLineTerminators.auto", "Unusual line terminators are automatically removed."),
      C("unusualLineTerminators.off", "Unusual line terminators are ignored."),
      C("unusualLineTerminators.prompt", "Unusual line terminators prompt to be removed.")
    ],
    description: C("unusualLineTerminators", "Remove unusual line terminators that might cause problems.")
  })),
  useShadowDOM: Fe(new ln(126, "useShadowDOM", !0)),
  useTabStops: Fe(new ln(127, "useTabStops", !0, { description: C("useTabStops", "Inserting and deleting whitespace follows tab stops.") })),
  wordBreak: Fe(new Bi(128, "wordBreak", "normal", ["normal", "keepAll"], {
    markdownEnumDescriptions: [
      C("wordBreak.normal", "Use the default line break rule."),
      C("wordBreak.keepAll", "Word breaks should not be used for Chinese/Japanese/Korean (CJK) text. Non-CJK text behavior is the same as for normal.")
    ],
    description: C("wordBreak", "Controls the word break rules used for Chinese/Japanese/Korean (CJK) text.")
  })),
  wordSeparators: Fe(new Ko(129, "wordSeparators", zue, { description: C("wordSeparators", "Characters that will be used as word separators when doing word related navigations or operations.") })),
  wordWrap: Fe(new Bi(130, "wordWrap", "off", ["off", "on", "wordWrapColumn", "bounded"], {
    markdownEnumDescriptions: [
      C("wordWrap.off", "Lines will never wrap."),
      C("wordWrap.on", "Lines will wrap at the viewport width."),
      C({
        key: "wordWrap.wordWrapColumn",
        comment: [
          "- `editor.wordWrapColumn` refers to a different setting and should not be localized."
        ]
      }, "Lines will wrap at `#editor.wordWrapColumn#`."),
      C({
        key: "wordWrap.bounded",
        comment: [
          "- viewport means the edge of the visible window size.",
          "- `editor.wordWrapColumn` refers to a different setting and should not be localized."
        ]
      }, "Lines will wrap at the minimum of viewport and `#editor.wordWrapColumn#`.")
    ],
    description: C({
      key: "wordWrap",
      comment: [
        "- 'off', 'on', 'wordWrapColumn' and 'bounded' refer to values the setting can take and should not be localized.",
        "- `editor.wordWrapColumn` refers to a different setting and should not be localized."
      ]
    }, "Controls how lines should wrap.")
  })),
  wordWrapBreakAfterCharacters: Fe(new Ko(
    131,
    "wordWrapBreakAfterCharacters",
    // allow-any-unicode-next-line
    " 	})]?|/&.,;¢°′″‰℃、。｡､￠，．：；？！％・･ゝゞヽヾーァィゥェォッャュョヮヵヶぁぃぅぇぉっゃゅょゎゕゖㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ々〻ｧｨｩｪｫｬｭｮｯｰ”〉》」』】〕）］｝｣"
  )),
  wordWrapBreakBeforeCharacters: Fe(new Ko(
    132,
    "wordWrapBreakBeforeCharacters",
    // allow-any-unicode-next-line
    "([{‘“〈《「『【〔（［｛｢£¥＄￡￥+＋"
  )),
  wordWrapColumn: Fe(new Fn(133, "wordWrapColumn", 80, 1, 1073741824, {
    markdownDescription: C({
      key: "wordWrapColumn",
      comment: [
        "- `editor.wordWrap` refers to a different setting and should not be localized.",
        "- 'wordWrapColumn' and 'bounded' refer to values the different setting can take and should not be localized."
      ]
    }, "Controls the wrapping column of the editor when `#editor.wordWrap#` is `wordWrapColumn` or `bounded`.")
  })),
  wordWrapOverride1: Fe(new Bi(134, "wordWrapOverride1", "inherit", ["off", "on", "inherit"])),
  wordWrapOverride2: Fe(new Bi(135, "wordWrapOverride2", "inherit", ["off", "on", "inherit"])),
  // Leave these at the end (because they have dependencies!)
  editorClassName: Fe(new G6e()),
  defaultColorDecorators: Fe(new ln(145, "defaultColorDecorators", !1, { markdownDescription: C("defaultColorDecorators", "Controls whether inline color decorations should be shown using the default document color provider") })),
  pixelRatio: Fe(new lTe()),
  tabFocusMode: Fe(new ln(142, "tabFocusMode", !1, { markdownDescription: C("tabFocusMode", "Controls whether the editor receives tabs or defers them to the workbench for navigation.") })),
  layoutInfo: Fe(new Dv()),
  wrappingInfo: Fe(new yTe()),
  wrappingIndent: Fe(new CTe()),
  wrappingStrategy: Fe(new J6e())
};
class LTe {
  constructor() {
    this.listeners = [], this.unexpectedErrorHandler = function(e) {
      setTimeout(() => {
        throw e.stack ? l_.isErrorNoTelemetry(e) ? new l_(e.message + `

` + e.stack) : new Error(e.message + `

` + e.stack) : e;
      }, 0);
    };
  }
  emit(e) {
    this.listeners.forEach((t) => {
      t(e);
    });
  }
  onUnexpectedError(e) {
    this.unexpectedErrorHandler(e), this.emit(e);
  }
  // For external errors, we don't want the listeners to be called
  onUnexpectedExternalError(e) {
    this.unexpectedErrorHandler(e);
  }
}
const Yue = new LTe();
function It(i) {
  md(i) || Yue.onUnexpectedError(i);
}
function vr(i) {
  md(i) || Yue.onUnexpectedExternalError(i);
}
function XY(i) {
  if (i instanceof Error) {
    const { name: e, message: t } = i, n = i.stacktrace || i.stack;
    return {
      $isError: !0,
      name: e,
      message: t,
      stack: n,
      noTelemetry: l_.isErrorNoTelemetry(i)
    };
  }
  return i;
}
const WE = "Canceled";
function md(i) {
  return i instanceof op ? !0 : i instanceof Error && i.name === WE && i.message === WE;
}
class op extends Error {
  constructor() {
    super(WE), this.name = this.message;
  }
}
function ITe() {
  const i = new Error(WE);
  return i.name = i.message, i;
}
function fl(i) {
  return i ? new Error(`Illegal argument: ${i}`) : new Error("Illegal argument");
}
function Aj(i) {
  return i ? new Error(`Illegal state: ${i}`) : new Error("Illegal state");
}
class ATe extends Error {
  constructor(e) {
    super("NotSupported"), e && (this.message = e);
  }
}
class l_ extends Error {
  constructor(e) {
    super(e), this.name = "CodeExpectedError";
  }
  static fromError(e) {
    if (e instanceof l_)
      return e;
    const t = new l_();
    return t.message = e.message, t.stack = e.stack, t;
  }
  static isErrorNoTelemetry(e) {
    return e.name === "CodeExpectedError";
  }
}
class gr extends Error {
  constructor(e) {
    super(e || "An unexpected bug occurred."), Object.setPrototypeOf(this, gr.prototype);
  }
}
function Ng(i) {
  const e = this;
  let t = !1, n;
  return function() {
    return t || (t = !0, n = i.apply(e, arguments)), n;
  };
}
function kj(i) {
  return typeof i.dispose == "function" && i.dispose.length === 0;
}
function An(i) {
  if (Wt.is(i)) {
    const e = [];
    for (const t of i)
      if (t)
        try {
          t.dispose();
        } catch (n) {
          e.push(n);
        }
    if (e.length === 1)
      throw e[0];
    if (e.length > 1)
      throw new AggregateError(e, "Encountered errors while disposing of store");
    return Array.isArray(i) ? [] : i;
  } else if (i)
    return i.dispose(), i;
}
function Ql(...i) {
  return Ct(() => An(i));
}
function Ct(i) {
  return {
    dispose: Ng(() => {
      i();
    })
  };
}
class Ne {
  constructor() {
    this._toDispose = /* @__PURE__ */ new Set(), this._isDisposed = !1;
  }
  /**
   * Dispose of all registered disposables and mark this object as disposed.
   *
   * Any future disposables added to this object will be disposed of on `add`.
   */
  dispose() {
    this._isDisposed || (this._isDisposed = !0, this.clear());
  }
  /**
   * @return `true` if this object has been disposed of.
   */
  get isDisposed() {
    return this._isDisposed;
  }
  /**
   * Dispose of all registered disposables but do not mark this object as disposed.
   */
  clear() {
    if (this._toDispose.size !== 0)
      try {
        An(this._toDispose);
      } finally {
        this._toDispose.clear();
      }
  }
  /**
   * Add a new {@link IDisposable disposable} to the collection.
   */
  add(e) {
    if (!e)
      return e;
    if (e === this)
      throw new Error("Cannot register a disposable on itself!");
    return this._isDisposed ? Ne.DISABLE_DISPOSED_WARNING || console.warn(new Error("Trying to add a disposable to a DisposableStore that has already been disposed of. The added object will be leaked!").stack) : this._toDispose.add(e), e;
  }
  /**
   * Deletes the value from the store, but does not dispose it.
   */
  deleteAndLeak(e) {
    e && this._toDispose.has(e) && this._toDispose.delete(e);
  }
}
Ne.DISABLE_DISPOSED_WARNING = !1;
class we {
  constructor() {
    this._store = new Ne(), this._store;
  }
  dispose() {
    this._store.dispose();
  }
  /**
   * Adds `o` to the collection of disposables managed by this object.
   */
  _register(e) {
    if (e === this)
      throw new Error("Cannot register a disposable on itself!");
    return this._store.add(e);
  }
}
we.None = Object.freeze({ dispose() {
} });
class ds {
  constructor() {
    this._isDisposed = !1;
  }
  get value() {
    return this._isDisposed ? void 0 : this._value;
  }
  set value(e) {
    var t;
    this._isDisposed || e === this._value || ((t = this._value) === null || t === void 0 || t.dispose(), this._value = e);
  }
  /**
   * Resets the stored value and disposed of the previously stored value.
   */
  clear() {
    this.value = void 0;
  }
  dispose() {
    var e;
    this._isDisposed = !0, (e = this._value) === null || e === void 0 || e.dispose(), this._value = void 0;
  }
}
class kTe {
  constructor(e) {
    this._disposable = e, this._counter = 1;
  }
  acquire() {
    return this._counter++, this;
  }
  release() {
    return --this._counter === 0 && this._disposable.dispose(), this;
  }
}
class TTe {
  constructor(e) {
    this.object = e;
  }
  dispose() {
  }
}
class Tj {
  constructor() {
    this._store = /* @__PURE__ */ new Map(), this._isDisposed = !1;
  }
  /**
   * Disposes of all stored values and mark this object as disposed.
   *
   * Trying to use this object after it has been disposed of is an error.
   */
  dispose() {
    this._isDisposed = !0, this.clearAndDisposeAll();
  }
  /**
   * Disposes of all stored values and clear the map, but DO NOT mark this object as disposed.
   */
  clearAndDisposeAll() {
    if (this._store.size)
      try {
        An(this._store.values());
      } finally {
        this._store.clear();
      }
  }
  get(e) {
    return this._store.get(e);
  }
  set(e, t, n = !1) {
    var r;
    this._isDisposed && console.warn(new Error("Trying to add a disposable to a DisposableMap that has already been disposed of. The added object will be leaked!").stack), n || (r = this._store.get(e)) === null || r === void 0 || r.dispose(), this._store.set(e, t);
  }
  /**
   * Delete the value stored for `key` from this map and also dispose of it.
   */
  deleteAndDispose(e) {
    var t;
    (t = this._store.get(e)) === null || t === void 0 || t.dispose(), this._store.delete(e);
  }
  [Symbol.iterator]() {
    return this._store[Symbol.iterator]();
  }
}
const NTe = globalThis.performance && typeof globalThis.performance.now == "function";
class Vs {
  static create(e) {
    return new Vs(e);
  }
  constructor(e) {
    this._now = NTe && e === !1 ? Date.now : globalThis.performance.now.bind(globalThis.performance), this._startTime = this._now(), this._stopTime = -1;
  }
  stop() {
    this._stopTime = this._now();
  }
  elapsed() {
    return this._stopTime !== -1 ? this._stopTime - this._startTime : this._now() - this._startTime;
  }
}
var qe;
(function(i) {
  i.None = () => we.None;
  function e(I, A) {
    return u(I, () => {
    }, 0, void 0, !0, void 0, A);
  }
  i.defer = e;
  function t(I) {
    return (A, P = null, O) => {
      let K = !1, W;
      return W = I((F) => {
        if (!K)
          return W ? W.dispose() : K = !0, A.call(P, F);
      }, null, O), K && W.dispose(), W;
    };
  }
  i.once = t;
  function n(I, A, P) {
    return c((O, K = null, W) => I((F) => O.call(K, A(F)), null, W), P);
  }
  i.map = n;
  function r(I, A, P) {
    return c((O, K = null, W) => I((F) => {
      A(F), O.call(K, F);
    }, null, W), P);
  }
  i.forEach = r;
  function s(I, A, P) {
    return c((O, K = null, W) => I((F) => A(F) && O.call(K, F), null, W), P);
  }
  i.filter = s;
  function o(I) {
    return I;
  }
  i.signal = o;
  function a(...I) {
    return (A, P = null, O) => {
      const K = Ql(...I.map((W) => W((F) => A.call(P, F))));
      return d(K, O);
    };
  }
  i.any = a;
  function l(I, A, P, O) {
    let K = P;
    return n(I, (W) => (K = A(K, W), K), O);
  }
  i.reduce = l;
  function c(I, A) {
    let P;
    const O = {
      onWillAddFirstListener() {
        P = I(K.fire, K);
      },
      onDidRemoveLastListener() {
        P?.dispose();
      }
    }, K = new pe(O);
    return A?.add(K), K.event;
  }
  function d(I, A) {
    return A instanceof Array ? A.push(I) : A && A.add(I), I;
  }
  function u(I, A, P = 100, O = !1, K = !1, W, F) {
    let q, R, T, z = 0, X;
    const ae = {
      leakWarningThreshold: W,
      onWillAddFirstListener() {
        q = I((se) => {
          z++, R = A(R, se), O && !T && (ue.fire(R), R = void 0), X = () => {
            const le = R;
            R = void 0, T = void 0, (!O || z > 1) && ue.fire(le), z = 0;
          }, typeof P == "number" ? (clearTimeout(T), T = setTimeout(X, P)) : T === void 0 && (T = 0, queueMicrotask(X));
        });
      },
      onWillRemoveListener() {
        K && z > 0 && X?.();
      },
      onDidRemoveLastListener() {
        X = void 0, q.dispose();
      }
    }, ue = new pe(ae);
    return F?.add(ue), ue.event;
  }
  i.debounce = u;
  function h(I, A = 0, P) {
    return i.debounce(I, (O, K) => O ? (O.push(K), O) : [K], A, void 0, !0, void 0, P);
  }
  i.accumulate = h;
  function f(I, A = (O, K) => O === K, P) {
    let O = !0, K;
    return s(I, (W) => {
      const F = O || !A(W, K);
      return O = !1, K = W, F;
    }, P);
  }
  i.latch = f;
  function g(I, A, P) {
    return [
      i.filter(I, A, P),
      i.filter(I, (O) => !A(O), P)
    ];
  }
  i.split = g;
  function p(I, A = !1, P = [], O) {
    let K = P.slice(), W = I((R) => {
      K ? K.push(R) : q.fire(R);
    });
    O && O.add(W);
    const F = () => {
      K?.forEach((R) => q.fire(R)), K = null;
    }, q = new pe({
      onWillAddFirstListener() {
        W || (W = I((R) => q.fire(R)), O && O.add(W));
      },
      onDidAddFirstListener() {
        K && (A ? setTimeout(F) : F());
      },
      onDidRemoveLastListener() {
        W && W.dispose(), W = null;
      }
    });
    return O && O.add(q), q.event;
  }
  i.buffer = p;
  function m(I, A) {
    return (O, K, W) => {
      const F = A(new b());
      return I(function(q) {
        const R = F.evaluate(q);
        R !== _ && O.call(K, R);
      }, void 0, W);
    };
  }
  i.chain = m;
  const _ = Symbol("HaltChainable");
  class b {
    constructor() {
      this.steps = [];
    }
    map(A) {
      return this.steps.push(A), this;
    }
    forEach(A) {
      return this.steps.push((P) => (A(P), P)), this;
    }
    filter(A) {
      return this.steps.push((P) => A(P) ? P : _), this;
    }
    reduce(A, P) {
      let O = P;
      return this.steps.push((K) => (O = A(O, K), O)), this;
    }
    latch(A = (P, O) => P === O) {
      let P = !0, O;
      return this.steps.push((K) => {
        const W = P || !A(K, O);
        return P = !1, O = K, W ? K : _;
      }), this;
    }
    evaluate(A) {
      for (const P of this.steps)
        if (A = P(A), A === _)
          break;
      return A;
    }
  }
  function w(I, A, P = (O) => O) {
    const O = (...q) => F.fire(P(...q)), K = () => I.on(A, O), W = () => I.removeListener(A, O), F = new pe({ onWillAddFirstListener: K, onDidRemoveLastListener: W });
    return F.event;
  }
  i.fromNodeEventEmitter = w;
  function y(I, A, P = (O) => O) {
    const O = (...q) => F.fire(P(...q)), K = () => I.addEventListener(A, O), W = () => I.removeEventListener(A, O), F = new pe({ onWillAddFirstListener: K, onDidRemoveLastListener: W });
    return F.event;
  }
  i.fromDOMEventEmitter = y;
  function S(I) {
    return new Promise((A) => t(I)(A));
  }
  i.toPromise = S;
  function x(I) {
    const A = new pe();
    return I.then((P) => {
      A.fire(P);
    }, () => {
      A.fire(void 0);
    }).finally(() => {
      A.dispose();
    }), A.event;
  }
  i.fromPromise = x;
  function D(I, A) {
    return A(void 0), I((P) => A(P));
  }
  i.runAndSubscribe = D;
  function E(I, A) {
    let P = null;
    function O(W) {
      P?.dispose(), P = new Ne(), A(W, P);
    }
    O(void 0);
    const K = I((W) => O(W));
    return Ct(() => {
      K.dispose(), P?.dispose();
    });
  }
  i.runAndSubscribeWithStore = E;
  class L {
    constructor(A, P) {
      this._observable = A, this._counter = 0, this._hasChanged = !1;
      const O = {
        onWillAddFirstListener: () => {
          A.addObserver(this);
        },
        onDidRemoveLastListener: () => {
          A.removeObserver(this);
        }
      };
      this.emitter = new pe(O), P && P.add(this.emitter);
    }
    beginUpdate(A) {
      this._counter++;
    }
    handlePossibleChange(A) {
    }
    handleChange(A, P) {
      this._hasChanged = !0;
    }
    endUpdate(A) {
      this._counter--, this._counter === 0 && (this._observable.reportChanges(), this._hasChanged && (this._hasChanged = !1, this.emitter.fire(this._observable.get())));
    }
  }
  function k(I, A) {
    return new L(I, A).emitter.event;
  }
  i.fromObservable = k;
  function N(I) {
    return (A) => {
      let P = 0, O = !1;
      const K = {
        beginUpdate() {
          P++;
        },
        endUpdate() {
          P--, P === 0 && (I.reportChanges(), O && (O = !1, A()));
        },
        handlePossibleChange() {
        },
        handleChange() {
          O = !0;
        }
      };
      return I.addObserver(K), I.reportChanges(), {
        dispose() {
          I.removeObserver(K);
        }
      };
    };
  }
  i.fromObservableLight = N;
})(qe || (qe = {}));
class c_ {
  constructor(e) {
    this.listenerCount = 0, this.invocationCount = 0, this.elapsedOverall = 0, this.durations = [], this.name = `${e}_${c_._idPool++}`, c_.all.add(this);
  }
  start(e) {
    this._stopWatch = new Vs(), this.listenerCount = e;
  }
  stop() {
    if (this._stopWatch) {
      const e = this._stopWatch.elapsed();
      this.durations.push(e), this.elapsedOverall += e, this.invocationCount += 1, this._stopWatch = void 0;
    }
  }
}
c_.all = /* @__PURE__ */ new Set();
c_._idPool = 0;
let PTe = -1;
class OTe {
  constructor(e, t = Math.random().toString(18).slice(2, 5)) {
    this.threshold = e, this.name = t, this._warnCountdown = 0;
  }
  dispose() {
    var e;
    (e = this._stacks) === null || e === void 0 || e.clear();
  }
  check(e, t) {
    const n = this.threshold;
    if (n <= 0 || t < n)
      return;
    this._stacks || (this._stacks = /* @__PURE__ */ new Map());
    const r = this._stacks.get(e.value) || 0;
    if (this._stacks.set(e.value, r + 1), this._warnCountdown -= 1, this._warnCountdown <= 0) {
      this._warnCountdown = n * 0.5;
      let s, o = 0;
      for (const [a, l] of this._stacks)
        (!s || o < l) && (s = a, o = l);
      console.warn(`[${this.name}] potential listener LEAK detected, having ${t} listeners already. MOST frequent listener (${o}):`), console.warn(s);
    }
    return () => {
      const s = this._stacks.get(e.value) || 0;
      this._stacks.set(e.value, s - 1);
    };
  }
}
class Nj {
  static create() {
    var e;
    return new Nj((e = new Error().stack) !== null && e !== void 0 ? e : "");
  }
  constructor(e) {
    this.value = e;
  }
  print() {
    console.warn(this.value.split(`
`).slice(2).join(`
`));
  }
}
class Jk {
  constructor(e) {
    this.value = e;
  }
}
const MTe = 2;
let pe = class {
  constructor(e) {
    var t, n, r, s, o;
    this._size = 0, this._options = e, this._leakageMon = !((t = this._options) === null || t === void 0) && t.leakWarningThreshold ? new OTe((r = (n = this._options) === null || n === void 0 ? void 0 : n.leakWarningThreshold) !== null && r !== void 0 ? r : PTe) : void 0, this._perfMon = !((s = this._options) === null || s === void 0) && s._profName ? new c_(this._options._profName) : void 0, this._deliveryQueue = (o = this._options) === null || o === void 0 ? void 0 : o.deliveryQueue;
  }
  dispose() {
    var e, t, n, r;
    this._disposed || (this._disposed = !0, ((e = this._deliveryQueue) === null || e === void 0 ? void 0 : e.current) === this && this._deliveryQueue.reset(), this._listeners && (this._listeners = void 0, this._size = 0), (n = (t = this._options) === null || t === void 0 ? void 0 : t.onDidRemoveLastListener) === null || n === void 0 || n.call(t), (r = this._leakageMon) === null || r === void 0 || r.dispose());
  }
  /**
   * For the public to allow to subscribe
   * to events from this Emitter
   */
  get event() {
    var e;
    return (e = this._event) !== null && e !== void 0 || (this._event = (t, n, r) => {
      var s, o, a, l, c;
      if (this._leakageMon && this._size > this._leakageMon.threshold * 3)
        return console.warn(`[${this._leakageMon.name}] REFUSES to accept new listeners because it exceeded its threshold by far`), we.None;
      if (this._disposed)
        return we.None;
      n && (t = t.bind(n));
      const d = new Jk(t);
      let u;
      this._leakageMon && this._size >= Math.ceil(this._leakageMon.threshold * 0.2) && (d.stack = Nj.create(), u = this._leakageMon.check(d.stack, this._size + 1)), this._listeners ? this._listeners instanceof Jk ? ((c = this._deliveryQueue) !== null && c !== void 0 || (this._deliveryQueue = new Xue()), this._listeners = [this._listeners, d]) : this._listeners.push(d) : ((o = (s = this._options) === null || s === void 0 ? void 0 : s.onWillAddFirstListener) === null || o === void 0 || o.call(s, this), this._listeners = d, (l = (a = this._options) === null || a === void 0 ? void 0 : a.onDidAddFirstListener) === null || l === void 0 || l.call(a, this)), this._size++;
      const h = Ct(() => {
        u?.(), this._removeListener(d);
      });
      return r instanceof Ne ? r.add(h) : Array.isArray(r) && r.push(h), h;
    }), this._event;
  }
  _removeListener(e) {
    var t, n, r, s;
    if ((n = (t = this._options) === null || t === void 0 ? void 0 : t.onWillRemoveListener) === null || n === void 0 || n.call(t, this), !this._listeners)
      return;
    if (this._size === 1) {
      this._listeners = void 0, (s = (r = this._options) === null || r === void 0 ? void 0 : r.onDidRemoveLastListener) === null || s === void 0 || s.call(r, this), this._size = 0;
      return;
    }
    const o = this._listeners, a = o.indexOf(e);
    if (a === -1)
      throw console.log("disposed?", this._disposed), console.log("size?", this._size), console.log("arr?", JSON.stringify(this._listeners)), new Error("Attempted to dispose unknown listener");
    this._size--, o[a] = void 0;
    const l = this._deliveryQueue.current === this;
    if (this._size * MTe <= o.length) {
      let c = 0;
      for (let d = 0; d < o.length; d++)
        o[d] ? o[c++] = o[d] : l && (this._deliveryQueue.end--, c < this._deliveryQueue.i && this._deliveryQueue.i--);
      o.length = c;
    }
  }
  _deliver(e, t) {
    var n;
    if (!e)
      return;
    const r = ((n = this._options) === null || n === void 0 ? void 0 : n.onListenerError) || It;
    if (!r) {
      e.value(t);
      return;
    }
    try {
      e.value(t);
    } catch (s) {
      r(s);
    }
  }
  /** Delivers items in the queue. Assumes the queue is ready to go. */
  _deliverQueue(e) {
    const t = e.current._listeners;
    for (; e.i < e.end; )
      this._deliver(t[e.i++], e.value);
    e.reset();
  }
  /**
   * To be kept private to fire an event to
   * subscribers
   */
  fire(e) {
    var t, n, r, s;
    if (!((t = this._deliveryQueue) === null || t === void 0) && t.current && (this._deliverQueue(this._deliveryQueue), (n = this._perfMon) === null || n === void 0 || n.stop()), (r = this._perfMon) === null || r === void 0 || r.start(this._size), this._listeners) if (this._listeners instanceof Jk)
      this._deliver(this._listeners, e);
    else {
      const o = this._deliveryQueue;
      o.enqueue(this, e, this._listeners.length), this._deliverQueue(o);
    }
    (s = this._perfMon) === null || s === void 0 || s.stop();
  }
  hasListeners() {
    return this._size > 0;
  }
};
const RTe = () => new Xue();
class Xue {
  constructor() {
    this.i = -1, this.end = 0;
  }
  enqueue(e, t, n) {
    this.i = 0, this.end = n, this.current = e, this.value = t;
  }
  reset() {
    this.i = this.end, this.current = void 0, this.value = void 0;
  }
}
class jm extends pe {
  constructor(e) {
    super(e), this._isPaused = 0, this._eventQueue = new fo(), this._mergeFn = e?.merge;
  }
  pause() {
    this._isPaused++;
  }
  resume() {
    if (this._isPaused !== 0 && --this._isPaused === 0)
      if (this._mergeFn) {
        if (this._eventQueue.size > 0) {
          const e = Array.from(this._eventQueue);
          this._eventQueue.clear(), super.fire(this._mergeFn(e));
        }
      } else
        for (; !this._isPaused && this._eventQueue.size !== 0; )
          super.fire(this._eventQueue.shift());
  }
  fire(e) {
    this._size && (this._isPaused !== 0 ? this._eventQueue.push(e) : super.fire(e));
  }
}
class Zue extends jm {
  constructor(e) {
    var t;
    super(e), this._delay = (t = e.delay) !== null && t !== void 0 ? t : 100;
  }
  fire(e) {
    this._handle || (this.pause(), this._handle = setTimeout(() => {
      this._handle = void 0, this.resume();
    }, this._delay)), super.fire(e);
  }
}
class FTe extends pe {
  constructor(e) {
    super(e), this._queuedEvents = [], this._mergeFn = e?.merge;
  }
  fire(e) {
    this.hasListeners() && (this._queuedEvents.push(e), this._queuedEvents.length === 1 && queueMicrotask(() => {
      this._mergeFn ? super.fire(this._mergeFn(this._queuedEvents)) : this._queuedEvents.forEach((t) => super.fire(t)), this._queuedEvents = [];
    }));
  }
}
class BTe {
  constructor() {
    this.hasListeners = !1, this.events = [], this.emitter = new pe({
      onWillAddFirstListener: () => this.onFirstListenerAdd(),
      onDidRemoveLastListener: () => this.onLastListenerRemove()
    });
  }
  get event() {
    return this.emitter.event;
  }
  add(e) {
    const t = { event: e, listener: null };
    return this.events.push(t), this.hasListeners && this.hook(t), Ct(Ng(() => {
      this.hasListeners && this.unhook(t);
      const r = this.events.indexOf(t);
      this.events.splice(r, 1);
    }));
  }
  onFirstListenerAdd() {
    this.hasListeners = !0, this.events.forEach((e) => this.hook(e));
  }
  onLastListenerRemove() {
    this.hasListeners = !1, this.events.forEach((e) => this.unhook(e));
  }
  hook(e) {
    e.listener = e.event((t) => this.emitter.fire(t));
  }
  unhook(e) {
    e.listener && e.listener.dispose(), e.listener = null;
  }
  dispose() {
    this.emitter.dispose();
  }
}
class Pj {
  constructor() {
    this.buffers = [];
  }
  wrapEvent(e) {
    return (t, n, r) => e((s) => {
      const o = this.buffers[this.buffers.length - 1];
      o ? o.push(() => t.call(n, s)) : t.call(n, s);
    }, void 0, r);
  }
  bufferEvents(e) {
    const t = [];
    this.buffers.push(t);
    const n = e();
    return this.buffers.pop(), t.forEach((r) => r()), n;
  }
}
class ZY {
  constructor() {
    this.listening = !1, this.inputEvent = qe.None, this.inputEventListener = we.None, this.emitter = new pe({
      onDidAddFirstListener: () => {
        this.listening = !0, this.inputEventListener = this.inputEvent(this.emitter.fire, this.emitter);
      },
      onDidRemoveLastListener: () => {
        this.listening = !1, this.inputEventListener.dispose();
      }
    }), this.event = this.emitter.event;
  }
  set input(e) {
    this.inputEvent = e, this.listening && (this.inputEventListener.dispose(), this.inputEventListener = e(this.emitter.fire, this.emitter));
  }
  dispose() {
    this.inputEventListener.dispose(), this.emitter.dispose();
  }
}
const Que = Object.freeze(function(i, e) {
  const t = setTimeout(i.bind(e), 0);
  return { dispose() {
    clearTimeout(t);
  } };
});
var jt;
(function(i) {
  function e(t) {
    return t === i.None || t === i.Cancelled || t instanceof I3 ? !0 : !t || typeof t != "object" ? !1 : typeof t.isCancellationRequested == "boolean" && typeof t.onCancellationRequested == "function";
  }
  i.isCancellationToken = e, i.None = Object.freeze({
    isCancellationRequested: !1,
    onCancellationRequested: qe.None
  }), i.Cancelled = Object.freeze({
    isCancellationRequested: !0,
    onCancellationRequested: Que
  });
})(jt || (jt = {}));
class I3 {
  constructor() {
    this._isCancelled = !1, this._emitter = null;
  }
  cancel() {
    this._isCancelled || (this._isCancelled = !0, this._emitter && (this._emitter.fire(void 0), this.dispose()));
  }
  get isCancellationRequested() {
    return this._isCancelled;
  }
  get onCancellationRequested() {
    return this._isCancelled ? Que : (this._emitter || (this._emitter = new pe()), this._emitter.event);
  }
  dispose() {
    this._emitter && (this._emitter.dispose(), this._emitter = null);
  }
}
let lr = class {
  constructor(e) {
    this._token = void 0, this._parentListener = void 0, this._parentListener = e && e.onCancellationRequested(this.cancel, this);
  }
  get token() {
    return this._token || (this._token = new I3()), this._token;
  }
  cancel() {
    this._token ? this._token instanceof I3 && this._token.cancel() : this._token = jt.Cancelled;
  }
  dispose(e = !1) {
    var t;
    e && this.cancel(), (t = this._parentListener) === null || t === void 0 || t.dispose(), this._token ? this._token instanceof I3 && this._token.dispose() : this._token = jt.None;
  }
};
class Oj {
  constructor() {
    this._keyCodeToStr = [], this._strToKeyCode = /* @__PURE__ */ Object.create(null);
  }
  define(e, t) {
    this._keyCodeToStr[e] = t, this._strToKeyCode[t.toLowerCase()] = e;
  }
  keyCodeToStr(e) {
    return this._keyCodeToStr[e];
  }
  strToKeyCode(e) {
    return this._strToKeyCode[e.toLowerCase()] || 0;
  }
}
const A3 = new Oj(), aR = new Oj(), lR = new Oj(), Jue = new Array(230), VTe = /* @__PURE__ */ Object.create(null), HTe = /* @__PURE__ */ Object.create(null), Mj = [];
for (let i = 0; i <= 193; i++)
  Mj[i] = -1;
(function() {
  const i = "", e = [
    // immutable, scanCode, scanCodeStr, keyCode, keyCodeStr, eventKeyCode, vkey, usUserSettingsLabel, generalUserSettingsLabel
    [1, 0, "None", 0, "unknown", 0, "VK_UNKNOWN", i, i],
    [1, 1, "Hyper", 0, i, 0, i, i, i],
    [1, 2, "Super", 0, i, 0, i, i, i],
    [1, 3, "Fn", 0, i, 0, i, i, i],
    [1, 4, "FnLock", 0, i, 0, i, i, i],
    [1, 5, "Suspend", 0, i, 0, i, i, i],
    [1, 6, "Resume", 0, i, 0, i, i, i],
    [1, 7, "Turbo", 0, i, 0, i, i, i],
    [1, 8, "Sleep", 0, i, 0, "VK_SLEEP", i, i],
    [1, 9, "WakeUp", 0, i, 0, i, i, i],
    [0, 10, "KeyA", 31, "A", 65, "VK_A", i, i],
    [0, 11, "KeyB", 32, "B", 66, "VK_B", i, i],
    [0, 12, "KeyC", 33, "C", 67, "VK_C", i, i],
    [0, 13, "KeyD", 34, "D", 68, "VK_D", i, i],
    [0, 14, "KeyE", 35, "E", 69, "VK_E", i, i],
    [0, 15, "KeyF", 36, "F", 70, "VK_F", i, i],
    [0, 16, "KeyG", 37, "G", 71, "VK_G", i, i],
    [0, 17, "KeyH", 38, "H", 72, "VK_H", i, i],
    [0, 18, "KeyI", 39, "I", 73, "VK_I", i, i],
    [0, 19, "KeyJ", 40, "J", 74, "VK_J", i, i],
    [0, 20, "KeyK", 41, "K", 75, "VK_K", i, i],
    [0, 21, "KeyL", 42, "L", 76, "VK_L", i, i],
    [0, 22, "KeyM", 43, "M", 77, "VK_M", i, i],
    [0, 23, "KeyN", 44, "N", 78, "VK_N", i, i],
    [0, 24, "KeyO", 45, "O", 79, "VK_O", i, i],
    [0, 25, "KeyP", 46, "P", 80, "VK_P", i, i],
    [0, 26, "KeyQ", 47, "Q", 81, "VK_Q", i, i],
    [0, 27, "KeyR", 48, "R", 82, "VK_R", i, i],
    [0, 28, "KeyS", 49, "S", 83, "VK_S", i, i],
    [0, 29, "KeyT", 50, "T", 84, "VK_T", i, i],
    [0, 30, "KeyU", 51, "U", 85, "VK_U", i, i],
    [0, 31, "KeyV", 52, "V", 86, "VK_V", i, i],
    [0, 32, "KeyW", 53, "W", 87, "VK_W", i, i],
    [0, 33, "KeyX", 54, "X", 88, "VK_X", i, i],
    [0, 34, "KeyY", 55, "Y", 89, "VK_Y", i, i],
    [0, 35, "KeyZ", 56, "Z", 90, "VK_Z", i, i],
    [0, 36, "Digit1", 22, "1", 49, "VK_1", i, i],
    [0, 37, "Digit2", 23, "2", 50, "VK_2", i, i],
    [0, 38, "Digit3", 24, "3", 51, "VK_3", i, i],
    [0, 39, "Digit4", 25, "4", 52, "VK_4", i, i],
    [0, 40, "Digit5", 26, "5", 53, "VK_5", i, i],
    [0, 41, "Digit6", 27, "6", 54, "VK_6", i, i],
    [0, 42, "Digit7", 28, "7", 55, "VK_7", i, i],
    [0, 43, "Digit8", 29, "8", 56, "VK_8", i, i],
    [0, 44, "Digit9", 30, "9", 57, "VK_9", i, i],
    [0, 45, "Digit0", 21, "0", 48, "VK_0", i, i],
    [1, 46, "Enter", 3, "Enter", 13, "VK_RETURN", i, i],
    [1, 47, "Escape", 9, "Escape", 27, "VK_ESCAPE", i, i],
    [1, 48, "Backspace", 1, "Backspace", 8, "VK_BACK", i, i],
    [1, 49, "Tab", 2, "Tab", 9, "VK_TAB", i, i],
    [1, 50, "Space", 10, "Space", 32, "VK_SPACE", i, i],
    [0, 51, "Minus", 88, "-", 189, "VK_OEM_MINUS", "-", "OEM_MINUS"],
    [0, 52, "Equal", 86, "=", 187, "VK_OEM_PLUS", "=", "OEM_PLUS"],
    [0, 53, "BracketLeft", 92, "[", 219, "VK_OEM_4", "[", "OEM_4"],
    [0, 54, "BracketRight", 94, "]", 221, "VK_OEM_6", "]", "OEM_6"],
    [0, 55, "Backslash", 93, "\\", 220, "VK_OEM_5", "\\", "OEM_5"],
    [0, 56, "IntlHash", 0, i, 0, i, i, i],
    // has been dropped from the w3c spec
    [0, 57, "Semicolon", 85, ";", 186, "VK_OEM_1", ";", "OEM_1"],
    [0, 58, "Quote", 95, "'", 222, "VK_OEM_7", "'", "OEM_7"],
    [0, 59, "Backquote", 91, "`", 192, "VK_OEM_3", "`", "OEM_3"],
    [0, 60, "Comma", 87, ",", 188, "VK_OEM_COMMA", ",", "OEM_COMMA"],
    [0, 61, "Period", 89, ".", 190, "VK_OEM_PERIOD", ".", "OEM_PERIOD"],
    [0, 62, "Slash", 90, "/", 191, "VK_OEM_2", "/", "OEM_2"],
    [1, 63, "CapsLock", 8, "CapsLock", 20, "VK_CAPITAL", i, i],
    [1, 64, "F1", 59, "F1", 112, "VK_F1", i, i],
    [1, 65, "F2", 60, "F2", 113, "VK_F2", i, i],
    [1, 66, "F3", 61, "F3", 114, "VK_F3", i, i],
    [1, 67, "F4", 62, "F4", 115, "VK_F4", i, i],
    [1, 68, "F5", 63, "F5", 116, "VK_F5", i, i],
    [1, 69, "F6", 64, "F6", 117, "VK_F6", i, i],
    [1, 70, "F7", 65, "F7", 118, "VK_F7", i, i],
    [1, 71, "F8", 66, "F8", 119, "VK_F8", i, i],
    [1, 72, "F9", 67, "F9", 120, "VK_F9", i, i],
    [1, 73, "F10", 68, "F10", 121, "VK_F10", i, i],
    [1, 74, "F11", 69, "F11", 122, "VK_F11", i, i],
    [1, 75, "F12", 70, "F12", 123, "VK_F12", i, i],
    [1, 76, "PrintScreen", 0, i, 0, i, i, i],
    [1, 77, "ScrollLock", 84, "ScrollLock", 145, "VK_SCROLL", i, i],
    [1, 78, "Pause", 7, "PauseBreak", 19, "VK_PAUSE", i, i],
    [1, 79, "Insert", 19, "Insert", 45, "VK_INSERT", i, i],
    [1, 80, "Home", 14, "Home", 36, "VK_HOME", i, i],
    [1, 81, "PageUp", 11, "PageUp", 33, "VK_PRIOR", i, i],
    [1, 82, "Delete", 20, "Delete", 46, "VK_DELETE", i, i],
    [1, 83, "End", 13, "End", 35, "VK_END", i, i],
    [1, 84, "PageDown", 12, "PageDown", 34, "VK_NEXT", i, i],
    [1, 85, "ArrowRight", 17, "RightArrow", 39, "VK_RIGHT", "Right", i],
    [1, 86, "ArrowLeft", 15, "LeftArrow", 37, "VK_LEFT", "Left", i],
    [1, 87, "ArrowDown", 18, "DownArrow", 40, "VK_DOWN", "Down", i],
    [1, 88, "ArrowUp", 16, "UpArrow", 38, "VK_UP", "Up", i],
    [1, 89, "NumLock", 83, "NumLock", 144, "VK_NUMLOCK", i, i],
    [1, 90, "NumpadDivide", 113, "NumPad_Divide", 111, "VK_DIVIDE", i, i],
    [1, 91, "NumpadMultiply", 108, "NumPad_Multiply", 106, "VK_MULTIPLY", i, i],
    [1, 92, "NumpadSubtract", 111, "NumPad_Subtract", 109, "VK_SUBTRACT", i, i],
    [1, 93, "NumpadAdd", 109, "NumPad_Add", 107, "VK_ADD", i, i],
    [1, 94, "NumpadEnter", 3, i, 0, i, i, i],
    [1, 95, "Numpad1", 99, "NumPad1", 97, "VK_NUMPAD1", i, i],
    [1, 96, "Numpad2", 100, "NumPad2", 98, "VK_NUMPAD2", i, i],
    [1, 97, "Numpad3", 101, "NumPad3", 99, "VK_NUMPAD3", i, i],
    [1, 98, "Numpad4", 102, "NumPad4", 100, "VK_NUMPAD4", i, i],
    [1, 99, "Numpad5", 103, "NumPad5", 101, "VK_NUMPAD5", i, i],
    [1, 100, "Numpad6", 104, "NumPad6", 102, "VK_NUMPAD6", i, i],
    [1, 101, "Numpad7", 105, "NumPad7", 103, "VK_NUMPAD7", i, i],
    [1, 102, "Numpad8", 106, "NumPad8", 104, "VK_NUMPAD8", i, i],
    [1, 103, "Numpad9", 107, "NumPad9", 105, "VK_NUMPAD9", i, i],
    [1, 104, "Numpad0", 98, "NumPad0", 96, "VK_NUMPAD0", i, i],
    [1, 105, "NumpadDecimal", 112, "NumPad_Decimal", 110, "VK_DECIMAL", i, i],
    [0, 106, "IntlBackslash", 97, "OEM_102", 226, "VK_OEM_102", i, i],
    [1, 107, "ContextMenu", 58, "ContextMenu", 93, i, i, i],
    [1, 108, "Power", 0, i, 0, i, i, i],
    [1, 109, "NumpadEqual", 0, i, 0, i, i, i],
    [1, 110, "F13", 71, "F13", 124, "VK_F13", i, i],
    [1, 111, "F14", 72, "F14", 125, "VK_F14", i, i],
    [1, 112, "F15", 73, "F15", 126, "VK_F15", i, i],
    [1, 113, "F16", 74, "F16", 127, "VK_F16", i, i],
    [1, 114, "F17", 75, "F17", 128, "VK_F17", i, i],
    [1, 115, "F18", 76, "F18", 129, "VK_F18", i, i],
    [1, 116, "F19", 77, "F19", 130, "VK_F19", i, i],
    [1, 117, "F20", 78, "F20", 131, "VK_F20", i, i],
    [1, 118, "F21", 79, "F21", 132, "VK_F21", i, i],
    [1, 119, "F22", 80, "F22", 133, "VK_F22", i, i],
    [1, 120, "F23", 81, "F23", 134, "VK_F23", i, i],
    [1, 121, "F24", 82, "F24", 135, "VK_F24", i, i],
    [1, 122, "Open", 0, i, 0, i, i, i],
    [1, 123, "Help", 0, i, 0, i, i, i],
    [1, 124, "Select", 0, i, 0, i, i, i],
    [1, 125, "Again", 0, i, 0, i, i, i],
    [1, 126, "Undo", 0, i, 0, i, i, i],
    [1, 127, "Cut", 0, i, 0, i, i, i],
    [1, 128, "Copy", 0, i, 0, i, i, i],
    [1, 129, "Paste", 0, i, 0, i, i, i],
    [1, 130, "Find", 0, i, 0, i, i, i],
    [1, 131, "AudioVolumeMute", 117, "AudioVolumeMute", 173, "VK_VOLUME_MUTE", i, i],
    [1, 132, "AudioVolumeUp", 118, "AudioVolumeUp", 175, "VK_VOLUME_UP", i, i],
    [1, 133, "AudioVolumeDown", 119, "AudioVolumeDown", 174, "VK_VOLUME_DOWN", i, i],
    [1, 134, "NumpadComma", 110, "NumPad_Separator", 108, "VK_SEPARATOR", i, i],
    [0, 135, "IntlRo", 115, "ABNT_C1", 193, "VK_ABNT_C1", i, i],
    [1, 136, "KanaMode", 0, i, 0, i, i, i],
    [0, 137, "IntlYen", 0, i, 0, i, i, i],
    [1, 138, "Convert", 0, i, 0, i, i, i],
    [1, 139, "NonConvert", 0, i, 0, i, i, i],
    [1, 140, "Lang1", 0, i, 0, i, i, i],
    [1, 141, "Lang2", 0, i, 0, i, i, i],
    [1, 142, "Lang3", 0, i, 0, i, i, i],
    [1, 143, "Lang4", 0, i, 0, i, i, i],
    [1, 144, "Lang5", 0, i, 0, i, i, i],
    [1, 145, "Abort", 0, i, 0, i, i, i],
    [1, 146, "Props", 0, i, 0, i, i, i],
    [1, 147, "NumpadParenLeft", 0, i, 0, i, i, i],
    [1, 148, "NumpadParenRight", 0, i, 0, i, i, i],
    [1, 149, "NumpadBackspace", 0, i, 0, i, i, i],
    [1, 150, "NumpadMemoryStore", 0, i, 0, i, i, i],
    [1, 151, "NumpadMemoryRecall", 0, i, 0, i, i, i],
    [1, 152, "NumpadMemoryClear", 0, i, 0, i, i, i],
    [1, 153, "NumpadMemoryAdd", 0, i, 0, i, i, i],
    [1, 154, "NumpadMemorySubtract", 0, i, 0, i, i, i],
    [1, 155, "NumpadClear", 131, "Clear", 12, "VK_CLEAR", i, i],
    [1, 156, "NumpadClearEntry", 0, i, 0, i, i, i],
    [1, 0, i, 5, "Ctrl", 17, "VK_CONTROL", i, i],
    [1, 0, i, 4, "Shift", 16, "VK_SHIFT", i, i],
    [1, 0, i, 6, "Alt", 18, "VK_MENU", i, i],
    [1, 0, i, 57, "Meta", 91, "VK_COMMAND", i, i],
    [1, 157, "ControlLeft", 5, i, 0, "VK_LCONTROL", i, i],
    [1, 158, "ShiftLeft", 4, i, 0, "VK_LSHIFT", i, i],
    [1, 159, "AltLeft", 6, i, 0, "VK_LMENU", i, i],
    [1, 160, "MetaLeft", 57, i, 0, "VK_LWIN", i, i],
    [1, 161, "ControlRight", 5, i, 0, "VK_RCONTROL", i, i],
    [1, 162, "ShiftRight", 4, i, 0, "VK_RSHIFT", i, i],
    [1, 163, "AltRight", 6, i, 0, "VK_RMENU", i, i],
    [1, 164, "MetaRight", 57, i, 0, "VK_RWIN", i, i],
    [1, 165, "BrightnessUp", 0, i, 0, i, i, i],
    [1, 166, "BrightnessDown", 0, i, 0, i, i, i],
    [1, 167, "MediaPlay", 0, i, 0, i, i, i],
    [1, 168, "MediaRecord", 0, i, 0, i, i, i],
    [1, 169, "MediaFastForward", 0, i, 0, i, i, i],
    [1, 170, "MediaRewind", 0, i, 0, i, i, i],
    [1, 171, "MediaTrackNext", 124, "MediaTrackNext", 176, "VK_MEDIA_NEXT_TRACK", i, i],
    [1, 172, "MediaTrackPrevious", 125, "MediaTrackPrevious", 177, "VK_MEDIA_PREV_TRACK", i, i],
    [1, 173, "MediaStop", 126, "MediaStop", 178, "VK_MEDIA_STOP", i, i],
    [1, 174, "Eject", 0, i, 0, i, i, i],
    [1, 175, "MediaPlayPause", 127, "MediaPlayPause", 179, "VK_MEDIA_PLAY_PAUSE", i, i],
    [1, 176, "MediaSelect", 128, "LaunchMediaPlayer", 181, "VK_MEDIA_LAUNCH_MEDIA_SELECT", i, i],
    [1, 177, "LaunchMail", 129, "LaunchMail", 180, "VK_MEDIA_LAUNCH_MAIL", i, i],
    [1, 178, "LaunchApp2", 130, "LaunchApp2", 183, "VK_MEDIA_LAUNCH_APP2", i, i],
    [1, 179, "LaunchApp1", 0, i, 0, "VK_MEDIA_LAUNCH_APP1", i, i],
    [1, 180, "SelectTask", 0, i, 0, i, i, i],
    [1, 181, "LaunchScreenSaver", 0, i, 0, i, i, i],
    [1, 182, "BrowserSearch", 120, "BrowserSearch", 170, "VK_BROWSER_SEARCH", i, i],
    [1, 183, "BrowserHome", 121, "BrowserHome", 172, "VK_BROWSER_HOME", i, i],
    [1, 184, "BrowserBack", 122, "BrowserBack", 166, "VK_BROWSER_BACK", i, i],
    [1, 185, "BrowserForward", 123, "BrowserForward", 167, "VK_BROWSER_FORWARD", i, i],
    [1, 186, "BrowserStop", 0, i, 0, "VK_BROWSER_STOP", i, i],
    [1, 187, "BrowserRefresh", 0, i, 0, "VK_BROWSER_REFRESH", i, i],
    [1, 188, "BrowserFavorites", 0, i, 0, "VK_BROWSER_FAVORITES", i, i],
    [1, 189, "ZoomToggle", 0, i, 0, i, i, i],
    [1, 190, "MailReply", 0, i, 0, i, i, i],
    [1, 191, "MailForward", 0, i, 0, i, i, i],
    [1, 192, "MailSend", 0, i, 0, i, i, i],
    // See https://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
    // If an Input Method Editor is processing key input and the event is keydown, return 229.
    [1, 0, i, 114, "KeyInComposition", 229, i, i, i],
    [1, 0, i, 116, "ABNT_C2", 194, "VK_ABNT_C2", i, i],
    [1, 0, i, 96, "OEM_8", 223, "VK_OEM_8", i, i],
    [1, 0, i, 0, i, 0, "VK_KANA", i, i],
    [1, 0, i, 0, i, 0, "VK_HANGUL", i, i],
    [1, 0, i, 0, i, 0, "VK_JUNJA", i, i],
    [1, 0, i, 0, i, 0, "VK_FINAL", i, i],
    [1, 0, i, 0, i, 0, "VK_HANJA", i, i],
    [1, 0, i, 0, i, 0, "VK_KANJI", i, i],
    [1, 0, i, 0, i, 0, "VK_CONVERT", i, i],
    [1, 0, i, 0, i, 0, "VK_NONCONVERT", i, i],
    [1, 0, i, 0, i, 0, "VK_ACCEPT", i, i],
    [1, 0, i, 0, i, 0, "VK_MODECHANGE", i, i],
    [1, 0, i, 0, i, 0, "VK_SELECT", i, i],
    [1, 0, i, 0, i, 0, "VK_PRINT", i, i],
    [1, 0, i, 0, i, 0, "VK_EXECUTE", i, i],
    [1, 0, i, 0, i, 0, "VK_SNAPSHOT", i, i],
    [1, 0, i, 0, i, 0, "VK_HELP", i, i],
    [1, 0, i, 0, i, 0, "VK_APPS", i, i],
    [1, 0, i, 0, i, 0, "VK_PROCESSKEY", i, i],
    [1, 0, i, 0, i, 0, "VK_PACKET", i, i],
    [1, 0, i, 0, i, 0, "VK_DBE_SBCSCHAR", i, i],
    [1, 0, i, 0, i, 0, "VK_DBE_DBCSCHAR", i, i],
    [1, 0, i, 0, i, 0, "VK_ATTN", i, i],
    [1, 0, i, 0, i, 0, "VK_CRSEL", i, i],
    [1, 0, i, 0, i, 0, "VK_EXSEL", i, i],
    [1, 0, i, 0, i, 0, "VK_EREOF", i, i],
    [1, 0, i, 0, i, 0, "VK_PLAY", i, i],
    [1, 0, i, 0, i, 0, "VK_ZOOM", i, i],
    [1, 0, i, 0, i, 0, "VK_NONAME", i, i],
    [1, 0, i, 0, i, 0, "VK_PA1", i, i],
    [1, 0, i, 0, i, 0, "VK_OEM_CLEAR", i, i]
  ], t = [], n = [];
  for (const r of e) {
    const [s, o, a, l, c, d, u, h, f] = r;
    if (n[o] || (n[o] = !0, VTe[a] = o, HTe[a.toLowerCase()] = o, s && (Mj[o] = l)), !t[l]) {
      if (t[l] = !0, !c)
        throw new Error(`String representation missing for key code ${l} around scan code ${a}`);
      A3.define(l, c), aR.define(l, h || c), lR.define(l, f || h || c);
    }
    d && (Jue[d] = l);
  }
})();
var ph;
(function(i) {
  function e(a) {
    return A3.keyCodeToStr(a);
  }
  i.toString = e;
  function t(a) {
    return A3.strToKeyCode(a);
  }
  i.fromString = t;
  function n(a) {
    return aR.keyCodeToStr(a);
  }
  i.toUserSettingsUS = n;
  function r(a) {
    return lR.keyCodeToStr(a);
  }
  i.toUserSettingsGeneral = r;
  function s(a) {
    return aR.strToKeyCode(a) || lR.strToKeyCode(a);
  }
  i.fromUserSettings = s;
  function o(a) {
    if (a >= 98 && a <= 113)
      return null;
    switch (a) {
      case 16:
        return "Up";
      case 18:
        return "Down";
      case 15:
        return "Left";
      case 17:
        return "Right";
    }
    return A3.keyCodeToStr(a);
  }
  i.toElectronAccelerator = o;
})(ph || (ph = {}));
function xr(i, e) {
  const t = (e & 65535) << 16 >>> 0;
  return (i | t) >>> 0;
}
let Lv;
if (typeof Zl.vscode < "u" && typeof Zl.vscode.process < "u") {
  const i = Zl.vscode.process;
  Lv = {
    get platform() {
      return i.platform;
    },
    get arch() {
      return i.arch;
    },
    get env() {
      return i.env;
    },
    cwd() {
      return i.cwd();
    }
  };
} else typeof process < "u" ? Lv = {
  get platform() {
    return process.platform;
  },
  get arch() {
    return process.arch;
  },
  get env() {
    return process.env;
  },
  cwd() {
    return process.env.VSCODE_CWD || process.cwd();
  }
} : Lv = {
  // Supported
  get platform() {
    return Ls ? "win32" : sn ? "darwin" : "linux";
  },
  get arch() {
  },
  // Unsupported
  get env() {
    return {};
  },
  cwd() {
    return "/";
  }
};
const jE = Lv.cwd, $ue = Lv.env, WTe = Lv.platform, jTe = 65, zTe = 97, UTe = 90, GTe = 122, hg = 46, qs = 47, _a = 92, vf = 58, qTe = 63;
class ehe extends Error {
  constructor(e, t, n) {
    let r;
    typeof t == "string" && t.indexOf("not ") === 0 ? (r = "must not be", t = t.replace(/^not /, "")) : r = "must be";
    const s = e.indexOf(".") !== -1 ? "property" : "argument";
    let o = `The "${e}" ${s} ${r} of type ${t}`;
    o += `. Received type ${typeof n}`, super(o), this.code = "ERR_INVALID_ARG_TYPE";
  }
}
function KTe(i, e) {
  if (i === null || typeof i != "object")
    throw new ehe(e, "Object", i);
}
function Br(i, e) {
  if (typeof i != "string")
    throw new ehe(e, "string", i);
}
const ap = WTe === "win32";
function kn(i) {
  return i === qs || i === _a;
}
function cR(i) {
  return i === qs;
}
function _f(i) {
  return i >= jTe && i <= UTe || i >= zTe && i <= GTe;
}
function zE(i, e, t, n) {
  let r = "", s = 0, o = -1, a = 0, l = 0;
  for (let c = 0; c <= i.length; ++c) {
    if (c < i.length)
      l = i.charCodeAt(c);
    else {
      if (n(l))
        break;
      l = qs;
    }
    if (n(l)) {
      if (!(o === c - 1 || a === 1)) if (a === 2) {
        if (r.length < 2 || s !== 2 || r.charCodeAt(r.length - 1) !== hg || r.charCodeAt(r.length - 2) !== hg) {
          if (r.length > 2) {
            const d = r.lastIndexOf(t);
            d === -1 ? (r = "", s = 0) : (r = r.slice(0, d), s = r.length - 1 - r.lastIndexOf(t)), o = c, a = 0;
            continue;
          } else if (r.length !== 0) {
            r = "", s = 0, o = c, a = 0;
            continue;
          }
        }
        e && (r += r.length > 0 ? `${t}..` : "..", s = 2);
      } else
        r.length > 0 ? r += `${t}${i.slice(o + 1, c)}` : r = i.slice(o + 1, c), s = c - o - 1;
      o = c, a = 0;
    } else l === hg && a !== -1 ? ++a : a = -1;
  }
  return r;
}
function the(i, e) {
  KTe(e, "pathObject");
  const t = e.dir || e.root, n = e.base || `${e.name || ""}${e.ext || ""}`;
  return t ? t === e.root ? `${t}${n}` : `${t}${i}${n}` : n;
}
const $o = {
  // path.resolve([from ...], to)
  resolve(...i) {
    let e = "", t = "", n = !1;
    for (let r = i.length - 1; r >= -1; r--) {
      let s;
      if (r >= 0) {
        if (s = i[r], Br(s, "path"), s.length === 0)
          continue;
      } else e.length === 0 ? s = jE() : (s = $ue[`=${e}`] || jE(), (s === void 0 || s.slice(0, 2).toLowerCase() !== e.toLowerCase() && s.charCodeAt(2) === _a) && (s = `${e}\\`));
      const o = s.length;
      let a = 0, l = "", c = !1;
      const d = s.charCodeAt(0);
      if (o === 1)
        kn(d) && (a = 1, c = !0);
      else if (kn(d))
        if (c = !0, kn(s.charCodeAt(1))) {
          let u = 2, h = u;
          for (; u < o && !kn(s.charCodeAt(u)); )
            u++;
          if (u < o && u !== h) {
            const f = s.slice(h, u);
            for (h = u; u < o && kn(s.charCodeAt(u)); )
              u++;
            if (u < o && u !== h) {
              for (h = u; u < o && !kn(s.charCodeAt(u)); )
                u++;
              (u === o || u !== h) && (l = `\\\\${f}\\${s.slice(h, u)}`, a = u);
            }
          }
        } else
          a = 1;
      else _f(d) && s.charCodeAt(1) === vf && (l = s.slice(0, 2), a = 2, o > 2 && kn(s.charCodeAt(2)) && (c = !0, a = 3));
      if (l.length > 0)
        if (e.length > 0) {
          if (l.toLowerCase() !== e.toLowerCase())
            continue;
        } else
          e = l;
      if (n) {
        if (e.length > 0)
          break;
      } else if (t = `${s.slice(a)}\\${t}`, n = c, c && e.length > 0)
        break;
    }
    return t = zE(t, !n, "\\", kn), n ? `${e}\\${t}` : `${e}${t}` || ".";
  },
  normalize(i) {
    Br(i, "path");
    const e = i.length;
    if (e === 0)
      return ".";
    let t = 0, n, r = !1;
    const s = i.charCodeAt(0);
    if (e === 1)
      return cR(s) ? "\\" : i;
    if (kn(s))
      if (r = !0, kn(i.charCodeAt(1))) {
        let a = 2, l = a;
        for (; a < e && !kn(i.charCodeAt(a)); )
          a++;
        if (a < e && a !== l) {
          const c = i.slice(l, a);
          for (l = a; a < e && kn(i.charCodeAt(a)); )
            a++;
          if (a < e && a !== l) {
            for (l = a; a < e && !kn(i.charCodeAt(a)); )
              a++;
            if (a === e)
              return `\\\\${c}\\${i.slice(l)}\\`;
            a !== l && (n = `\\\\${c}\\${i.slice(l, a)}`, t = a);
          }
        }
      } else
        t = 1;
    else _f(s) && i.charCodeAt(1) === vf && (n = i.slice(0, 2), t = 2, e > 2 && kn(i.charCodeAt(2)) && (r = !0, t = 3));
    let o = t < e ? zE(i.slice(t), !r, "\\", kn) : "";
    return o.length === 0 && !r && (o = "."), o.length > 0 && kn(i.charCodeAt(e - 1)) && (o += "\\"), n === void 0 ? r ? `\\${o}` : o : r ? `${n}\\${o}` : `${n}${o}`;
  },
  isAbsolute(i) {
    Br(i, "path");
    const e = i.length;
    if (e === 0)
      return !1;
    const t = i.charCodeAt(0);
    return kn(t) || // Possible device root
    e > 2 && _f(t) && i.charCodeAt(1) === vf && kn(i.charCodeAt(2));
  },
  join(...i) {
    if (i.length === 0)
      return ".";
    let e, t;
    for (let s = 0; s < i.length; ++s) {
      const o = i[s];
      Br(o, "path"), o.length > 0 && (e === void 0 ? e = t = o : e += `\\${o}`);
    }
    if (e === void 0)
      return ".";
    let n = !0, r = 0;
    if (typeof t == "string" && kn(t.charCodeAt(0))) {
      ++r;
      const s = t.length;
      s > 1 && kn(t.charCodeAt(1)) && (++r, s > 2 && (kn(t.charCodeAt(2)) ? ++r : n = !1));
    }
    if (n) {
      for (; r < e.length && kn(e.charCodeAt(r)); )
        r++;
      r >= 2 && (e = `\\${e.slice(r)}`);
    }
    return $o.normalize(e);
  },
  // It will solve the relative path from `from` to `to`, for instance:
  //  from = 'C:\\orandea\\test\\aaa'
  //  to = 'C:\\orandea\\impl\\bbb'
  // The output of the function should be: '..\\..\\impl\\bbb'
  relative(i, e) {
    if (Br(i, "from"), Br(e, "to"), i === e)
      return "";
    const t = $o.resolve(i), n = $o.resolve(e);
    if (t === n || (i = t.toLowerCase(), e = n.toLowerCase(), i === e))
      return "";
    let r = 0;
    for (; r < i.length && i.charCodeAt(r) === _a; )
      r++;
    let s = i.length;
    for (; s - 1 > r && i.charCodeAt(s - 1) === _a; )
      s--;
    const o = s - r;
    let a = 0;
    for (; a < e.length && e.charCodeAt(a) === _a; )
      a++;
    let l = e.length;
    for (; l - 1 > a && e.charCodeAt(l - 1) === _a; )
      l--;
    const c = l - a, d = o < c ? o : c;
    let u = -1, h = 0;
    for (; h < d; h++) {
      const g = i.charCodeAt(r + h);
      if (g !== e.charCodeAt(a + h))
        break;
      g === _a && (u = h);
    }
    if (h !== d) {
      if (u === -1)
        return n;
    } else {
      if (c > d) {
        if (e.charCodeAt(a + h) === _a)
          return n.slice(a + h + 1);
        if (h === 2)
          return n.slice(a + h);
      }
      o > d && (i.charCodeAt(r + h) === _a ? u = h : h === 2 && (u = 3)), u === -1 && (u = 0);
    }
    let f = "";
    for (h = r + u + 1; h <= s; ++h)
      (h === s || i.charCodeAt(h) === _a) && (f += f.length === 0 ? ".." : "\\..");
    return a += u, f.length > 0 ? `${f}${n.slice(a, l)}` : (n.charCodeAt(a) === _a && ++a, n.slice(a, l));
  },
  toNamespacedPath(i) {
    if (typeof i != "string" || i.length === 0)
      return i;
    const e = $o.resolve(i);
    if (e.length <= 2)
      return i;
    if (e.charCodeAt(0) === _a) {
      if (e.charCodeAt(1) === _a) {
        const t = e.charCodeAt(2);
        if (t !== qTe && t !== hg)
          return `\\\\?\\UNC\\${e.slice(2)}`;
      }
    } else if (_f(e.charCodeAt(0)) && e.charCodeAt(1) === vf && e.charCodeAt(2) === _a)
      return `\\\\?\\${e}`;
    return i;
  },
  dirname(i) {
    Br(i, "path");
    const e = i.length;
    if (e === 0)
      return ".";
    let t = -1, n = 0;
    const r = i.charCodeAt(0);
    if (e === 1)
      return kn(r) ? i : ".";
    if (kn(r)) {
      if (t = n = 1, kn(i.charCodeAt(1))) {
        let a = 2, l = a;
        for (; a < e && !kn(i.charCodeAt(a)); )
          a++;
        if (a < e && a !== l) {
          for (l = a; a < e && kn(i.charCodeAt(a)); )
            a++;
          if (a < e && a !== l) {
            for (l = a; a < e && !kn(i.charCodeAt(a)); )
              a++;
            if (a === e)
              return i;
            a !== l && (t = n = a + 1);
          }
        }
      }
    } else _f(r) && i.charCodeAt(1) === vf && (t = e > 2 && kn(i.charCodeAt(2)) ? 3 : 2, n = t);
    let s = -1, o = !0;
    for (let a = e - 1; a >= n; --a)
      if (kn(i.charCodeAt(a))) {
        if (!o) {
          s = a;
          break;
        }
      } else
        o = !1;
    if (s === -1) {
      if (t === -1)
        return ".";
      s = t;
    }
    return i.slice(0, s);
  },
  basename(i, e) {
    e !== void 0 && Br(e, "ext"), Br(i, "path");
    let t = 0, n = -1, r = !0, s;
    if (i.length >= 2 && _f(i.charCodeAt(0)) && i.charCodeAt(1) === vf && (t = 2), e !== void 0 && e.length > 0 && e.length <= i.length) {
      if (e === i)
        return "";
      let o = e.length - 1, a = -1;
      for (s = i.length - 1; s >= t; --s) {
        const l = i.charCodeAt(s);
        if (kn(l)) {
          if (!r) {
            t = s + 1;
            break;
          }
        } else
          a === -1 && (r = !1, a = s + 1), o >= 0 && (l === e.charCodeAt(o) ? --o === -1 && (n = s) : (o = -1, n = a));
      }
      return t === n ? n = a : n === -1 && (n = i.length), i.slice(t, n);
    }
    for (s = i.length - 1; s >= t; --s)
      if (kn(i.charCodeAt(s))) {
        if (!r) {
          t = s + 1;
          break;
        }
      } else n === -1 && (r = !1, n = s + 1);
    return n === -1 ? "" : i.slice(t, n);
  },
  extname(i) {
    Br(i, "path");
    let e = 0, t = -1, n = 0, r = -1, s = !0, o = 0;
    i.length >= 2 && i.charCodeAt(1) === vf && _f(i.charCodeAt(0)) && (e = n = 2);
    for (let a = i.length - 1; a >= e; --a) {
      const l = i.charCodeAt(a);
      if (kn(l)) {
        if (!s) {
          n = a + 1;
          break;
        }
        continue;
      }
      r === -1 && (s = !1, r = a + 1), l === hg ? t === -1 ? t = a : o !== 1 && (o = 1) : t !== -1 && (o = -1);
    }
    return t === -1 || r === -1 || // We saw a non-dot character immediately before the dot
    o === 0 || // The (right-most) trimmed path component is exactly '..'
    o === 1 && t === r - 1 && t === n + 1 ? "" : i.slice(t, r);
  },
  format: the.bind(null, "\\"),
  parse(i) {
    Br(i, "path");
    const e = { root: "", dir: "", base: "", ext: "", name: "" };
    if (i.length === 0)
      return e;
    const t = i.length;
    let n = 0, r = i.charCodeAt(0);
    if (t === 1)
      return kn(r) ? (e.root = e.dir = i, e) : (e.base = e.name = i, e);
    if (kn(r)) {
      if (n = 1, kn(i.charCodeAt(1))) {
        let u = 2, h = u;
        for (; u < t && !kn(i.charCodeAt(u)); )
          u++;
        if (u < t && u !== h) {
          for (h = u; u < t && kn(i.charCodeAt(u)); )
            u++;
          if (u < t && u !== h) {
            for (h = u; u < t && !kn(i.charCodeAt(u)); )
              u++;
            u === t ? n = u : u !== h && (n = u + 1);
          }
        }
      }
    } else if (_f(r) && i.charCodeAt(1) === vf) {
      if (t <= 2)
        return e.root = e.dir = i, e;
      if (n = 2, kn(i.charCodeAt(2))) {
        if (t === 3)
          return e.root = e.dir = i, e;
        n = 3;
      }
    }
    n > 0 && (e.root = i.slice(0, n));
    let s = -1, o = n, a = -1, l = !0, c = i.length - 1, d = 0;
    for (; c >= n; --c) {
      if (r = i.charCodeAt(c), kn(r)) {
        if (!l) {
          o = c + 1;
          break;
        }
        continue;
      }
      a === -1 && (l = !1, a = c + 1), r === hg ? s === -1 ? s = c : d !== 1 && (d = 1) : s !== -1 && (d = -1);
    }
    return a !== -1 && (s === -1 || // We saw a non-dot character immediately before the dot
    d === 0 || // The (right-most) trimmed path component is exactly '..'
    d === 1 && s === a - 1 && s === o + 1 ? e.base = e.name = i.slice(o, a) : (e.name = i.slice(o, s), e.base = i.slice(o, a), e.ext = i.slice(s, a))), o > 0 && o !== n ? e.dir = i.slice(0, o - 1) : e.dir = e.root, e;
  },
  sep: "\\",
  delimiter: ";",
  win32: null,
  posix: null
}, YTe = (() => {
  if (ap) {
    const i = /\\/g;
    return () => {
      const e = jE().replace(i, "/");
      return e.slice(e.indexOf("/"));
    };
  }
  return () => jE();
})(), yr = {
  // path.resolve([from ...], to)
  resolve(...i) {
    let e = "", t = !1;
    for (let n = i.length - 1; n >= -1 && !t; n--) {
      const r = n >= 0 ? i[n] : YTe();
      Br(r, "path"), r.length !== 0 && (e = `${r}/${e}`, t = r.charCodeAt(0) === qs);
    }
    return e = zE(e, !t, "/", cR), t ? `/${e}` : e.length > 0 ? e : ".";
  },
  normalize(i) {
    if (Br(i, "path"), i.length === 0)
      return ".";
    const e = i.charCodeAt(0) === qs, t = i.charCodeAt(i.length - 1) === qs;
    return i = zE(i, !e, "/", cR), i.length === 0 ? e ? "/" : t ? "./" : "." : (t && (i += "/"), e ? `/${i}` : i);
  },
  isAbsolute(i) {
    return Br(i, "path"), i.length > 0 && i.charCodeAt(0) === qs;
  },
  join(...i) {
    if (i.length === 0)
      return ".";
    let e;
    for (let t = 0; t < i.length; ++t) {
      const n = i[t];
      Br(n, "path"), n.length > 0 && (e === void 0 ? e = n : e += `/${n}`);
    }
    return e === void 0 ? "." : yr.normalize(e);
  },
  relative(i, e) {
    if (Br(i, "from"), Br(e, "to"), i === e || (i = yr.resolve(i), e = yr.resolve(e), i === e))
      return "";
    const t = 1, n = i.length, r = n - t, s = 1, o = e.length - s, a = r < o ? r : o;
    let l = -1, c = 0;
    for (; c < a; c++) {
      const u = i.charCodeAt(t + c);
      if (u !== e.charCodeAt(s + c))
        break;
      u === qs && (l = c);
    }
    if (c === a)
      if (o > a) {
        if (e.charCodeAt(s + c) === qs)
          return e.slice(s + c + 1);
        if (c === 0)
          return e.slice(s + c);
      } else r > a && (i.charCodeAt(t + c) === qs ? l = c : c === 0 && (l = 0));
    let d = "";
    for (c = t + l + 1; c <= n; ++c)
      (c === n || i.charCodeAt(c) === qs) && (d += d.length === 0 ? ".." : "/..");
    return `${d}${e.slice(s + l)}`;
  },
  toNamespacedPath(i) {
    return i;
  },
  dirname(i) {
    if (Br(i, "path"), i.length === 0)
      return ".";
    const e = i.charCodeAt(0) === qs;
    let t = -1, n = !0;
    for (let r = i.length - 1; r >= 1; --r)
      if (i.charCodeAt(r) === qs) {
        if (!n) {
          t = r;
          break;
        }
      } else
        n = !1;
    return t === -1 ? e ? "/" : "." : e && t === 1 ? "//" : i.slice(0, t);
  },
  basename(i, e) {
    e !== void 0 && Br(e, "ext"), Br(i, "path");
    let t = 0, n = -1, r = !0, s;
    if (e !== void 0 && e.length > 0 && e.length <= i.length) {
      if (e === i)
        return "";
      let o = e.length - 1, a = -1;
      for (s = i.length - 1; s >= 0; --s) {
        const l = i.charCodeAt(s);
        if (l === qs) {
          if (!r) {
            t = s + 1;
            break;
          }
        } else
          a === -1 && (r = !1, a = s + 1), o >= 0 && (l === e.charCodeAt(o) ? --o === -1 && (n = s) : (o = -1, n = a));
      }
      return t === n ? n = a : n === -1 && (n = i.length), i.slice(t, n);
    }
    for (s = i.length - 1; s >= 0; --s)
      if (i.charCodeAt(s) === qs) {
        if (!r) {
          t = s + 1;
          break;
        }
      } else n === -1 && (r = !1, n = s + 1);
    return n === -1 ? "" : i.slice(t, n);
  },
  extname(i) {
    Br(i, "path");
    let e = -1, t = 0, n = -1, r = !0, s = 0;
    for (let o = i.length - 1; o >= 0; --o) {
      const a = i.charCodeAt(o);
      if (a === qs) {
        if (!r) {
          t = o + 1;
          break;
        }
        continue;
      }
      n === -1 && (r = !1, n = o + 1), a === hg ? e === -1 ? e = o : s !== 1 && (s = 1) : e !== -1 && (s = -1);
    }
    return e === -1 || n === -1 || // We saw a non-dot character immediately before the dot
    s === 0 || // The (right-most) trimmed path component is exactly '..'
    s === 1 && e === n - 1 && e === t + 1 ? "" : i.slice(e, n);
  },
  format: the.bind(null, "/"),
  parse(i) {
    Br(i, "path");
    const e = { root: "", dir: "", base: "", ext: "", name: "" };
    if (i.length === 0)
      return e;
    const t = i.charCodeAt(0) === qs;
    let n;
    t ? (e.root = "/", n = 1) : n = 0;
    let r = -1, s = 0, o = -1, a = !0, l = i.length - 1, c = 0;
    for (; l >= n; --l) {
      const d = i.charCodeAt(l);
      if (d === qs) {
        if (!a) {
          s = l + 1;
          break;
        }
        continue;
      }
      o === -1 && (a = !1, o = l + 1), d === hg ? r === -1 ? r = l : c !== 1 && (c = 1) : r !== -1 && (c = -1);
    }
    if (o !== -1) {
      const d = s === 0 && t ? 1 : s;
      r === -1 || // We saw a non-dot character immediately before the dot
      c === 0 || // The (right-most) trimmed path component is exactly '..'
      c === 1 && r === o - 1 && r === s + 1 ? e.base = e.name = i.slice(d, o) : (e.name = i.slice(d, r), e.base = i.slice(d, o), e.ext = i.slice(r, o));
    }
    return s > 0 ? e.dir = i.slice(0, s - 1) : t && (e.dir = "/"), e;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
yr.win32 = $o.win32 = $o;
yr.posix = $o.posix = yr;
const nhe = ap ? $o.normalize : yr.normalize, XTe = ap ? $o.resolve : yr.resolve, ZTe = ap ? $o.relative : yr.relative, ihe = ap ? $o.dirname : yr.dirname, fg = ap ? $o.basename : yr.basename, QTe = ap ? $o.extname : yr.extname, Qc = ap ? $o.sep : yr.sep, JTe = /^\w[\w\d+.-]*$/, $Te = /^\//, eNe = /^\/\//;
function tNe(i, e) {
  if (!i.scheme && e)
    throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${i.authority}", path: "${i.path}", query: "${i.query}", fragment: "${i.fragment}"}`);
  if (i.scheme && !JTe.test(i.scheme))
    throw new Error("[UriError]: Scheme contains illegal characters.");
  if (i.path) {
    if (i.authority) {
      if (!$Te.test(i.path))
        throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
    } else if (eNe.test(i.path))
      throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
  }
}
function nNe(i, e) {
  return !i && !e ? "file" : i;
}
function iNe(i, e) {
  switch (i) {
    case "https":
    case "http":
    case "file":
      e ? e[0] !== Oc && (e = Oc + e) : e = Oc;
      break;
  }
  return e;
}
const tr = "", Oc = "/", rNe = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
let pt = class k3 {
  static isUri(e) {
    return e instanceof k3 ? !0 : e ? typeof e.authority == "string" && typeof e.fragment == "string" && typeof e.path == "string" && typeof e.query == "string" && typeof e.scheme == "string" && typeof e.fsPath == "string" && typeof e.with == "function" && typeof e.toString == "function" : !1;
  }
  /**
   * @internal
   */
  constructor(e, t, n, r, s, o = !1) {
    typeof e == "object" ? (this.scheme = e.scheme || tr, this.authority = e.authority || tr, this.path = e.path || tr, this.query = e.query || tr, this.fragment = e.fragment || tr) : (this.scheme = nNe(e, o), this.authority = t || tr, this.path = iNe(this.scheme, n || tr), this.query = r || tr, this.fragment = s || tr, tNe(this, o));
  }
  // ---- filesystem path -----------------------
  /**
   * Returns a string representing the corresponding file system path of this URI.
   * Will handle UNC paths, normalizes windows drive letters to lower-case, and uses the
   * platform specific path separator.
   *
   * * Will *not* validate the path for invalid characters and semantics.
   * * Will *not* look at the scheme of this URI.
   * * The result shall *not* be used for display purposes but for accessing a file on disk.
   *
   *
   * The *difference* to `URI#path` is the use of the platform specific separator and the handling
   * of UNC paths. See the below sample of a file-uri with an authority (UNC path).
   *
   * ```ts
      const u = URI.parse('file://server/c$/folder/file.txt')
      u.authority === 'server'
      u.path === '/shares/c$/file.txt'
      u.fsPath === '\\server\c$\folder\file.txt'
  ```
   *
   * Using `URI#path` to read a file (using fs-apis) would not be enough because parts of the path,
   * namely the server name, would be missing. Therefore `URI#fsPath` exists - it's sugar to ease working
   * with URIs that represent files on disk (`file` scheme).
   */
  get fsPath() {
    return UE(this, !1);
  }
  // ---- modify to new -------------------------
  with(e) {
    if (!e)
      return this;
    let { scheme: t, authority: n, path: r, query: s, fragment: o } = e;
    return t === void 0 ? t = this.scheme : t === null && (t = tr), n === void 0 ? n = this.authority : n === null && (n = tr), r === void 0 ? r = this.path : r === null && (r = tr), s === void 0 ? s = this.query : s === null && (s = tr), o === void 0 ? o = this.fragment : o === null && (o = tr), t === this.scheme && n === this.authority && r === this.path && s === this.query && o === this.fragment ? this : new a1(t, n, r, s, o);
  }
  // ---- parse & validate ------------------------
  /**
   * Creates a new URI from a string, e.g. `http://www.example.com/some/path`,
   * `file:///usr/home`, or `scheme:with/path`.
   *
   * @param value A string which represents an URI (see `URI#toString`).
   */
  static parse(e, t = !1) {
    const n = rNe.exec(e);
    return n ? new a1(n[2] || tr, Rx(n[4] || tr), Rx(n[5] || tr), Rx(n[7] || tr), Rx(n[9] || tr), t) : new a1(tr, tr, tr, tr, tr);
  }
  /**
   * Creates a new URI from a file system path, e.g. `c:\my\files`,
   * `/usr/home`, or `\\server\share\some\path`.
   *
   * The *difference* between `URI#parse` and `URI#file` is that the latter treats the argument
   * as path, not as stringified-uri. E.g. `URI.file(path)` is **not the same as**
   * `URI.parse('file://' + path)` because the path might contain characters that are
   * interpreted (# and ?). See the following sample:
   * ```ts
  const good = URI.file('/coding/c#/project1');
  good.scheme === 'file';
  good.path === '/coding/c#/project1';
  good.fragment === '';
  const bad = URI.parse('file://' + '/coding/c#/project1');
  bad.scheme === 'file';
  bad.path === '/coding/c'; // path is now broken
  bad.fragment === '/project1';
  ```
   *
   * @param path A file system path (see `URI#fsPath`)
   */
  static file(e) {
    let t = tr;
    if (Ls && (e = e.replace(/\\/g, Oc)), e[0] === Oc && e[1] === Oc) {
      const n = e.indexOf(Oc, 2);
      n === -1 ? (t = e.substring(2), e = Oc) : (t = e.substring(2, n), e = e.substring(n) || Oc);
    }
    return new a1("file", t, e, tr, tr);
  }
  /**
   * Creates new URI from uri components.
   *
   * Unless `strict` is `true` the scheme is defaults to be `file`. This function performs
   * validation and should be used for untrusted uri components retrieved from storage,
   * user input, command arguments etc
   */
  static from(e, t) {
    return new a1(e.scheme, e.authority, e.path, e.query, e.fragment, t);
  }
  /**
   * Join a URI path with path fragments and normalizes the resulting path.
   *
   * @param uri The input URI.
   * @param pathFragment The path fragment to add to the URI path.
   * @returns The resulting URI.
   */
  static joinPath(e, ...t) {
    if (!e.path)
      throw new Error("[UriError]: cannot call joinPath on URI without path");
    let n;
    return Ls && e.scheme === "file" ? n = k3.file($o.join(UE(e, !0), ...t)).path : n = yr.join(e.path, ...t), e.with({ path: n });
  }
  // ---- printing/externalize ---------------------------
  /**
   * Creates a string representation for this URI. It's guaranteed that calling
   * `URI.parse` with the result of this function creates an URI which is equal
   * to this URI.
   *
   * * The result shall *not* be used for display purposes but for externalization or transport.
   * * The result will be encoded using the percentage encoding and encoding happens mostly
   * ignore the scheme-specific encoding rules.
   *
   * @param skipEncoding Do not encode the result, default is `false`
   */
  toString(e = !1) {
    return dR(this, e);
  }
  toJSON() {
    return this;
  }
  static revive(e) {
    var t, n;
    if (e) {
      if (e instanceof k3)
        return e;
      {
        const r = new a1(e);
        return r._formatted = (t = e.external) !== null && t !== void 0 ? t : null, r._fsPath = e._sep === rhe && (n = e.fsPath) !== null && n !== void 0 ? n : null, r;
      }
    } else return e;
  }
};
const rhe = Ls ? 1 : void 0;
let a1 = class extends pt {
  constructor() {
    super(...arguments), this._formatted = null, this._fsPath = null;
  }
  get fsPath() {
    return this._fsPath || (this._fsPath = UE(this, !1)), this._fsPath;
  }
  toString(e = !1) {
    return e ? dR(this, !0) : (this._formatted || (this._formatted = dR(this, !1)), this._formatted);
  }
  toJSON() {
    const e = {
      $mid: 1
      /* MarshalledId.Uri */
    };
    return this._fsPath && (e.fsPath = this._fsPath, e._sep = rhe), this._formatted && (e.external = this._formatted), this.path && (e.path = this.path), this.scheme && (e.scheme = this.scheme), this.authority && (e.authority = this.authority), this.query && (e.query = this.query), this.fragment && (e.fragment = this.fragment), e;
  }
};
const she = {
  58: "%3A",
  // gen-delims
  47: "%2F",
  63: "%3F",
  35: "%23",
  91: "%5B",
  93: "%5D",
  64: "%40",
  33: "%21",
  // sub-delims
  36: "%24",
  38: "%26",
  39: "%27",
  40: "%28",
  41: "%29",
  42: "%2A",
  43: "%2B",
  44: "%2C",
  59: "%3B",
  61: "%3D",
  32: "%20"
};
function QY(i, e, t) {
  let n, r = -1;
  for (let s = 0; s < i.length; s++) {
    const o = i.charCodeAt(s);
    if (o >= 97 && o <= 122 || o >= 65 && o <= 90 || o >= 48 && o <= 57 || o === 45 || o === 46 || o === 95 || o === 126 || e && o === 47 || t && o === 91 || t && o === 93 || t && o === 58)
      r !== -1 && (n += encodeURIComponent(i.substring(r, s)), r = -1), n !== void 0 && (n += i.charAt(s));
    else {
      n === void 0 && (n = i.substr(0, s));
      const a = she[o];
      a !== void 0 ? (r !== -1 && (n += encodeURIComponent(i.substring(r, s)), r = -1), n += a) : r === -1 && (r = s);
    }
  }
  return r !== -1 && (n += encodeURIComponent(i.substring(r))), n !== void 0 ? n : i;
}
function sNe(i) {
  let e;
  for (let t = 0; t < i.length; t++) {
    const n = i.charCodeAt(t);
    n === 35 || n === 63 ? (e === void 0 && (e = i.substr(0, t)), e += she[n]) : e !== void 0 && (e += i[t]);
  }
  return e !== void 0 ? e : i;
}
function UE(i, e) {
  let t;
  return i.authority && i.path.length > 1 && i.scheme === "file" ? t = `//${i.authority}${i.path}` : i.path.charCodeAt(0) === 47 && (i.path.charCodeAt(1) >= 65 && i.path.charCodeAt(1) <= 90 || i.path.charCodeAt(1) >= 97 && i.path.charCodeAt(1) <= 122) && i.path.charCodeAt(2) === 58 ? e ? t = i.path.substr(1) : t = i.path[1].toLowerCase() + i.path.substr(2) : t = i.path, Ls && (t = t.replace(/\//g, "\\")), t;
}
function dR(i, e) {
  const t = e ? sNe : QY;
  let n = "", { scheme: r, authority: s, path: o, query: a, fragment: l } = i;
  if (r && (n += r, n += ":"), (s || r === "file") && (n += Oc, n += Oc), s) {
    let c = s.indexOf("@");
    if (c !== -1) {
      const d = s.substr(0, c);
      s = s.substr(c + 1), c = d.lastIndexOf(":"), c === -1 ? n += t(d, !1, !1) : (n += t(d.substr(0, c), !1, !1), n += ":", n += t(d.substr(c + 1), !1, !0)), n += "@";
    }
    s = s.toLowerCase(), c = s.lastIndexOf(":"), c === -1 ? n += t(s, !1, !0) : (n += t(s.substr(0, c), !1, !0), n += s.substr(c));
  }
  if (o) {
    if (o.length >= 3 && o.charCodeAt(0) === 47 && o.charCodeAt(2) === 58) {
      const c = o.charCodeAt(1);
      c >= 65 && c <= 90 && (o = `/${String.fromCharCode(c + 32)}:${o.substr(3)}`);
    } else if (o.length >= 2 && o.charCodeAt(1) === 58) {
      const c = o.charCodeAt(0);
      c >= 65 && c <= 90 && (o = `${String.fromCharCode(c + 32)}:${o.substr(2)}`);
    }
    n += t(o, !0, !1);
  }
  return a && (n += "?", n += t(a, !1, !1)), l && (n += "#", n += e ? l : QY(l, !1, !1)), n;
}
function ohe(i) {
  try {
    return decodeURIComponent(i);
  } catch {
    return i.length > 3 ? i.substr(0, 3) + ohe(i.substr(3)) : i;
  }
}
const JY = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
function Rx(i) {
  return i.match(JY) ? i.replace(JY, (e) => ohe(e)) : i;
}
let ve = class Bp {
  constructor(e, t) {
    this.lineNumber = e, this.column = t;
  }
  /**
   * Create a new position from this position.
   *
   * @param newLineNumber new line number
   * @param newColumn new column
   */
  with(e = this.lineNumber, t = this.column) {
    return e === this.lineNumber && t === this.column ? this : new Bp(e, t);
  }
  /**
   * Derive a new position from this position.
   *
   * @param deltaLineNumber line number delta
   * @param deltaColumn column delta
   */
  delta(e = 0, t = 0) {
    return this.with(this.lineNumber + e, this.column + t);
  }
  /**
   * Test if this position equals other position
   */
  equals(e) {
    return Bp.equals(this, e);
  }
  /**
   * Test if position `a` equals position `b`
   */
  static equals(e, t) {
    return !e && !t ? !0 : !!e && !!t && e.lineNumber === t.lineNumber && e.column === t.column;
  }
  /**
   * Test if this position is before other position.
   * If the two positions are equal, the result will be false.
   */
  isBefore(e) {
    return Bp.isBefore(this, e);
  }
  /**
   * Test if position `a` is before position `b`.
   * If the two positions are equal, the result will be false.
   */
  static isBefore(e, t) {
    return e.lineNumber < t.lineNumber ? !0 : t.lineNumber < e.lineNumber ? !1 : e.column < t.column;
  }
  /**
   * Test if this position is before other position.
   * If the two positions are equal, the result will be true.
   */
  isBeforeOrEqual(e) {
    return Bp.isBeforeOrEqual(this, e);
  }
  /**
   * Test if position `a` is before position `b`.
   * If the two positions are equal, the result will be true.
   */
  static isBeforeOrEqual(e, t) {
    return e.lineNumber < t.lineNumber ? !0 : t.lineNumber < e.lineNumber ? !1 : e.column <= t.column;
  }
  /**
   * A function that compares positions, useful for sorting
   */
  static compare(e, t) {
    const n = e.lineNumber | 0, r = t.lineNumber | 0;
    if (n === r) {
      const s = e.column | 0, o = t.column | 0;
      return s - o;
    }
    return n - r;
  }
  /**
   * Clone this position.
   */
  clone() {
    return new Bp(this.lineNumber, this.column);
  }
  /**
   * Convert to a human-readable representation.
   */
  toString() {
    return "(" + this.lineNumber + "," + this.column + ")";
  }
  // ---
  /**
   * Create a `Position` from an `IPosition`.
   */
  static lift(e) {
    return new Bp(e.lineNumber, e.column);
  }
  /**
   * Test if `obj` is an `IPosition`.
   */
  static isIPosition(e) {
    return e && typeof e.lineNumber == "number" && typeof e.column == "number";
  }
}, V = class Zr {
  constructor(e, t, n, r) {
    e > n || e === n && t > r ? (this.startLineNumber = n, this.startColumn = r, this.endLineNumber = e, this.endColumn = t) : (this.startLineNumber = e, this.startColumn = t, this.endLineNumber = n, this.endColumn = r);
  }
  /**
   * Test if this range is empty.
   */
  isEmpty() {
    return Zr.isEmpty(this);
  }
  /**
   * Test if `range` is empty.
   */
  static isEmpty(e) {
    return e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn;
  }
  /**
   * Test if position is in this range. If the position is at the edges, will return true.
   */
  containsPosition(e) {
    return Zr.containsPosition(this, e);
  }
  /**
   * Test if `position` is in `range`. If the position is at the edges, will return true.
   */
  static containsPosition(e, t) {
    return !(t.lineNumber < e.startLineNumber || t.lineNumber > e.endLineNumber || t.lineNumber === e.startLineNumber && t.column < e.startColumn || t.lineNumber === e.endLineNumber && t.column > e.endColumn);
  }
  /**
   * Test if `position` is in `range`. If the position is at the edges, will return false.
   * @internal
   */
  static strictContainsPosition(e, t) {
    return !(t.lineNumber < e.startLineNumber || t.lineNumber > e.endLineNumber || t.lineNumber === e.startLineNumber && t.column <= e.startColumn || t.lineNumber === e.endLineNumber && t.column >= e.endColumn);
  }
  /**
   * Test if range is in this range. If the range is equal to this range, will return true.
   */
  containsRange(e) {
    return Zr.containsRange(this, e);
  }
  /**
   * Test if `otherRange` is in `range`. If the ranges are equal, will return true.
   */
  static containsRange(e, t) {
    return !(t.startLineNumber < e.startLineNumber || t.endLineNumber < e.startLineNumber || t.startLineNumber > e.endLineNumber || t.endLineNumber > e.endLineNumber || t.startLineNumber === e.startLineNumber && t.startColumn < e.startColumn || t.endLineNumber === e.endLineNumber && t.endColumn > e.endColumn);
  }
  /**
   * Test if `range` is strictly in this range. `range` must start after and end before this range for the result to be true.
   */
  strictContainsRange(e) {
    return Zr.strictContainsRange(this, e);
  }
  /**
   * Test if `otherRange` is strictly in `range` (must start after, and end before). If the ranges are equal, will return false.
   */
  static strictContainsRange(e, t) {
    return !(t.startLineNumber < e.startLineNumber || t.endLineNumber < e.startLineNumber || t.startLineNumber > e.endLineNumber || t.endLineNumber > e.endLineNumber || t.startLineNumber === e.startLineNumber && t.startColumn <= e.startColumn || t.endLineNumber === e.endLineNumber && t.endColumn >= e.endColumn);
  }
  /**
   * A reunion of the two ranges.
   * The smallest position will be used as the start point, and the largest one as the end point.
   */
  plusRange(e) {
    return Zr.plusRange(this, e);
  }
  /**
   * A reunion of the two ranges.
   * The smallest position will be used as the start point, and the largest one as the end point.
   */
  static plusRange(e, t) {
    let n, r, s, o;
    return t.startLineNumber < e.startLineNumber ? (n = t.startLineNumber, r = t.startColumn) : t.startLineNumber === e.startLineNumber ? (n = t.startLineNumber, r = Math.min(t.startColumn, e.startColumn)) : (n = e.startLineNumber, r = e.startColumn), t.endLineNumber > e.endLineNumber ? (s = t.endLineNumber, o = t.endColumn) : t.endLineNumber === e.endLineNumber ? (s = t.endLineNumber, o = Math.max(t.endColumn, e.endColumn)) : (s = e.endLineNumber, o = e.endColumn), new Zr(n, r, s, o);
  }
  /**
   * A intersection of the two ranges.
   */
  intersectRanges(e) {
    return Zr.intersectRanges(this, e);
  }
  /**
   * A intersection of the two ranges.
   */
  static intersectRanges(e, t) {
    let n = e.startLineNumber, r = e.startColumn, s = e.endLineNumber, o = e.endColumn;
    const a = t.startLineNumber, l = t.startColumn, c = t.endLineNumber, d = t.endColumn;
    return n < a ? (n = a, r = l) : n === a && (r = Math.max(r, l)), s > c ? (s = c, o = d) : s === c && (o = Math.min(o, d)), n > s || n === s && r > o ? null : new Zr(n, r, s, o);
  }
  /**
   * Test if this range equals other.
   */
  equalsRange(e) {
    return Zr.equalsRange(this, e);
  }
  /**
   * Test if range `a` equals `b`.
   */
  static equalsRange(e, t) {
    return !e && !t ? !0 : !!e && !!t && e.startLineNumber === t.startLineNumber && e.startColumn === t.startColumn && e.endLineNumber === t.endLineNumber && e.endColumn === t.endColumn;
  }
  /**
   * Return the end position (which will be after or equal to the start position)
   */
  getEndPosition() {
    return Zr.getEndPosition(this);
  }
  /**
   * Return the end position (which will be after or equal to the start position)
   */
  static getEndPosition(e) {
    return new ve(e.endLineNumber, e.endColumn);
  }
  /**
   * Return the start position (which will be before or equal to the end position)
   */
  getStartPosition() {
    return Zr.getStartPosition(this);
  }
  /**
   * Return the start position (which will be before or equal to the end position)
   */
  static getStartPosition(e) {
    return new ve(e.startLineNumber, e.startColumn);
  }
  /**
   * Transform to a user presentable string representation.
   */
  toString() {
    return "[" + this.startLineNumber + "," + this.startColumn + " -> " + this.endLineNumber + "," + this.endColumn + "]";
  }
  /**
   * Create a new range using this range's start position, and using endLineNumber and endColumn as the end position.
   */
  setEndPosition(e, t) {
    return new Zr(this.startLineNumber, this.startColumn, e, t);
  }
  /**
   * Create a new range using this range's end position, and using startLineNumber and startColumn as the start position.
   */
  setStartPosition(e, t) {
    return new Zr(e, t, this.endLineNumber, this.endColumn);
  }
  /**
   * Create a new empty range using this range's start position.
   */
  collapseToStart() {
    return Zr.collapseToStart(this);
  }
  /**
   * Create a new empty range using this range's start position.
   */
  static collapseToStart(e) {
    return new Zr(e.startLineNumber, e.startColumn, e.startLineNumber, e.startColumn);
  }
  /**
   * Create a new empty range using this range's end position.
   */
  collapseToEnd() {
    return Zr.collapseToEnd(this);
  }
  /**
   * Create a new empty range using this range's end position.
   */
  static collapseToEnd(e) {
    return new Zr(e.endLineNumber, e.endColumn, e.endLineNumber, e.endColumn);
  }
  /**
   * Moves the range by the given amount of lines.
   */
  delta(e) {
    return new Zr(this.startLineNumber + e, this.startColumn, this.endLineNumber + e, this.endColumn);
  }
  // ---
  static fromPositions(e, t = e) {
    return new Zr(e.lineNumber, e.column, t.lineNumber, t.column);
  }
  static lift(e) {
    return e ? new Zr(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn) : null;
  }
  /**
   * Test if `obj` is an `IRange`.
   */
  static isIRange(e) {
    return e && typeof e.startLineNumber == "number" && typeof e.startColumn == "number" && typeof e.endLineNumber == "number" && typeof e.endColumn == "number";
  }
  /**
   * Test if the two ranges are touching in any way.
   */
  static areIntersectingOrTouching(e, t) {
    return !(e.endLineNumber < t.startLineNumber || e.endLineNumber === t.startLineNumber && e.endColumn < t.startColumn || t.endLineNumber < e.startLineNumber || t.endLineNumber === e.startLineNumber && t.endColumn < e.startColumn);
  }
  /**
   * Test if the two ranges are intersecting. If the ranges are touching it returns true.
   */
  static areIntersecting(e, t) {
    return !(e.endLineNumber < t.startLineNumber || e.endLineNumber === t.startLineNumber && e.endColumn <= t.startColumn || t.endLineNumber < e.startLineNumber || t.endLineNumber === e.startLineNumber && t.endColumn <= e.startColumn);
  }
  /**
   * A function that compares ranges, useful for sorting ranges
   * It will first compare ranges on the startPosition and then on the endPosition
   */
  static compareRangesUsingStarts(e, t) {
    if (e && t) {
      const s = e.startLineNumber | 0, o = t.startLineNumber | 0;
      if (s === o) {
        const a = e.startColumn | 0, l = t.startColumn | 0;
        if (a === l) {
          const c = e.endLineNumber | 0, d = t.endLineNumber | 0;
          if (c === d) {
            const u = e.endColumn | 0, h = t.endColumn | 0;
            return u - h;
          }
          return c - d;
        }
        return a - l;
      }
      return s - o;
    }
    return (e ? 1 : 0) - (t ? 1 : 0);
  }
  /**
   * A function that compares ranges, useful for sorting ranges
   * It will first compare ranges on the endPosition and then on the startPosition
   */
  static compareRangesUsingEnds(e, t) {
    return e.endLineNumber === t.endLineNumber ? e.endColumn === t.endColumn ? e.startLineNumber === t.startLineNumber ? e.startColumn - t.startColumn : e.startLineNumber - t.startLineNumber : e.endColumn - t.endColumn : e.endLineNumber - t.endLineNumber;
  }
  /**
   * Test if the range spans multiple lines.
   */
  static spansMultipleLines(e) {
    return e.endLineNumber > e.startLineNumber;
  }
  toJSON() {
    return this;
  }
}, ot = class Ml extends V {
  constructor(e, t, n, r) {
    super(e, t, n, r), this.selectionStartLineNumber = e, this.selectionStartColumn = t, this.positionLineNumber = n, this.positionColumn = r;
  }
  /**
   * Transform to a human-readable representation.
   */
  toString() {
    return "[" + this.selectionStartLineNumber + "," + this.selectionStartColumn + " -> " + this.positionLineNumber + "," + this.positionColumn + "]";
  }
  /**
   * Test if equals other selection.
   */
  equalsSelection(e) {
    return Ml.selectionsEqual(this, e);
  }
  /**
   * Test if the two selections are equal.
   */
  static selectionsEqual(e, t) {
    return e.selectionStartLineNumber === t.selectionStartLineNumber && e.selectionStartColumn === t.selectionStartColumn && e.positionLineNumber === t.positionLineNumber && e.positionColumn === t.positionColumn;
  }
  /**
   * Get directions (LTR or RTL).
   */
  getDirection() {
    return this.selectionStartLineNumber === this.startLineNumber && this.selectionStartColumn === this.startColumn ? 0 : 1;
  }
  /**
   * Create a new selection with a different `positionLineNumber` and `positionColumn`.
   */
  setEndPosition(e, t) {
    return this.getDirection() === 0 ? new Ml(this.startLineNumber, this.startColumn, e, t) : new Ml(e, t, this.startLineNumber, this.startColumn);
  }
  /**
   * Get the position at `positionLineNumber` and `positionColumn`.
   */
  getPosition() {
    return new ve(this.positionLineNumber, this.positionColumn);
  }
  /**
   * Get the position at the start of the selection.
  */
  getSelectionStart() {
    return new ve(this.selectionStartLineNumber, this.selectionStartColumn);
  }
  /**
   * Create a new selection with a different `selectionStartLineNumber` and `selectionStartColumn`.
   */
  setStartPosition(e, t) {
    return this.getDirection() === 0 ? new Ml(e, t, this.endLineNumber, this.endColumn) : new Ml(this.endLineNumber, this.endColumn, e, t);
  }
  // ----
  /**
   * Create a `Selection` from one or two positions
   */
  static fromPositions(e, t = e) {
    return new Ml(e.lineNumber, e.column, t.lineNumber, t.column);
  }
  /**
   * Creates a `Selection` from a range, given a direction.
   */
  static fromRange(e, t) {
    return t === 0 ? new Ml(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn) : new Ml(e.endLineNumber, e.endColumn, e.startLineNumber, e.startColumn);
  }
  /**
   * Create a `Selection` from an `ISelection`.
   */
  static liftSelection(e) {
    return new Ml(e.selectionStartLineNumber, e.selectionStartColumn, e.positionLineNumber, e.positionColumn);
  }
  /**
   * `a` equals `b`.
   */
  static selectionsArrEqual(e, t) {
    if (e && !t || !e && t)
      return !1;
    if (!e && !t)
      return !0;
    if (e.length !== t.length)
      return !1;
    for (let n = 0, r = e.length; n < r; n++)
      if (!this.selectionsEqual(e[n], t[n]))
        return !1;
    return !0;
  }
  /**
   * Test if `obj` is an `ISelection`.
   */
  static isISelection(e) {
    return e && typeof e.selectionStartLineNumber == "number" && typeof e.selectionStartColumn == "number" && typeof e.positionLineNumber == "number" && typeof e.positionColumn == "number";
  }
  /**
   * Create with a direction.
   */
  static createWithDirection(e, t, n, r, s) {
    return s === 0 ? new Ml(e, t, n, r) : new Ml(n, r, e, t);
  }
};
const uR = /* @__PURE__ */ Object.create(null);
function M(i, e) {
  if (mo(e)) {
    const t = uR[e];
    if (t === void 0)
      throw new Error(`${i} references an unknown codicon: ${e}`);
    e = t;
  }
  return uR[i] = e, { id: i };
}
function ahe() {
  return uR;
}
const We = {
  // built-in icons, with image name
  add: M("add", 6e4),
  plus: M("plus", 6e4),
  gistNew: M("gist-new", 6e4),
  repoCreate: M("repo-create", 6e4),
  lightbulb: M("lightbulb", 60001),
  lightBulb: M("light-bulb", 60001),
  repo: M("repo", 60002),
  repoDelete: M("repo-delete", 60002),
  gistFork: M("gist-fork", 60003),
  repoForked: M("repo-forked", 60003),
  gitPullRequest: M("git-pull-request", 60004),
  gitPullRequestAbandoned: M("git-pull-request-abandoned", 60004),
  recordKeys: M("record-keys", 60005),
  keyboard: M("keyboard", 60005),
  tag: M("tag", 60006),
  tagAdd: M("tag-add", 60006),
  tagRemove: M("tag-remove", 60006),
  gitPullRequestLabel: M("git-pull-request-label", 60006),
  person: M("person", 60007),
  personFollow: M("person-follow", 60007),
  personOutline: M("person-outline", 60007),
  personFilled: M("person-filled", 60007),
  gitBranch: M("git-branch", 60008),
  gitBranchCreate: M("git-branch-create", 60008),
  gitBranchDelete: M("git-branch-delete", 60008),
  sourceControl: M("source-control", 60008),
  mirror: M("mirror", 60009),
  mirrorPublic: M("mirror-public", 60009),
  star: M("star", 60010),
  starAdd: M("star-add", 60010),
  starDelete: M("star-delete", 60010),
  starEmpty: M("star-empty", 60010),
  comment: M("comment", 60011),
  commentAdd: M("comment-add", 60011),
  alert: M("alert", 60012),
  warning: M("warning", 60012),
  search: M("search", 60013),
  searchSave: M("search-save", 60013),
  logOut: M("log-out", 60014),
  signOut: M("sign-out", 60014),
  logIn: M("log-in", 60015),
  signIn: M("sign-in", 60015),
  eye: M("eye", 60016),
  eyeUnwatch: M("eye-unwatch", 60016),
  eyeWatch: M("eye-watch", 60016),
  circleFilled: M("circle-filled", 60017),
  primitiveDot: M("primitive-dot", 60017),
  closeDirty: M("close-dirty", 60017),
  debugBreakpoint: M("debug-breakpoint", 60017),
  debugBreakpointDisabled: M("debug-breakpoint-disabled", 60017),
  debugHint: M("debug-hint", 60017),
  primitiveSquare: M("primitive-square", 60018),
  edit: M("edit", 60019),
  pencil: M("pencil", 60019),
  info: M("info", 60020),
  issueOpened: M("issue-opened", 60020),
  gistPrivate: M("gist-private", 60021),
  gitForkPrivate: M("git-fork-private", 60021),
  lock: M("lock", 60021),
  mirrorPrivate: M("mirror-private", 60021),
  close: M("close", 60022),
  removeClose: M("remove-close", 60022),
  x: M("x", 60022),
  repoSync: M("repo-sync", 60023),
  sync: M("sync", 60023),
  clone: M("clone", 60024),
  desktopDownload: M("desktop-download", 60024),
  beaker: M("beaker", 60025),
  microscope: M("microscope", 60025),
  vm: M("vm", 60026),
  deviceDesktop: M("device-desktop", 60026),
  file: M("file", 60027),
  fileText: M("file-text", 60027),
  more: M("more", 60028),
  ellipsis: M("ellipsis", 60028),
  kebabHorizontal: M("kebab-horizontal", 60028),
  mailReply: M("mail-reply", 60029),
  reply: M("reply", 60029),
  organization: M("organization", 60030),
  organizationFilled: M("organization-filled", 60030),
  organizationOutline: M("organization-outline", 60030),
  newFile: M("new-file", 60031),
  fileAdd: M("file-add", 60031),
  newFolder: M("new-folder", 60032),
  fileDirectoryCreate: M("file-directory-create", 60032),
  trash: M("trash", 60033),
  trashcan: M("trashcan", 60033),
  history: M("history", 60034),
  clock: M("clock", 60034),
  folder: M("folder", 60035),
  fileDirectory: M("file-directory", 60035),
  symbolFolder: M("symbol-folder", 60035),
  logoGithub: M("logo-github", 60036),
  markGithub: M("mark-github", 60036),
  github: M("github", 60036),
  terminal: M("terminal", 60037),
  console: M("console", 60037),
  repl: M("repl", 60037),
  zap: M("zap", 60038),
  symbolEvent: M("symbol-event", 60038),
  error: M("error", 60039),
  stop: M("stop", 60039),
  variable: M("variable", 60040),
  symbolVariable: M("symbol-variable", 60040),
  array: M("array", 60042),
  symbolArray: M("symbol-array", 60042),
  symbolModule: M("symbol-module", 60043),
  symbolPackage: M("symbol-package", 60043),
  symbolNamespace: M("symbol-namespace", 60043),
  symbolObject: M("symbol-object", 60043),
  symbolMethod: M("symbol-method", 60044),
  symbolFunction: M("symbol-function", 60044),
  symbolConstructor: M("symbol-constructor", 60044),
  symbolBoolean: M("symbol-boolean", 60047),
  symbolNull: M("symbol-null", 60047),
  symbolNumeric: M("symbol-numeric", 60048),
  symbolNumber: M("symbol-number", 60048),
  symbolStructure: M("symbol-structure", 60049),
  symbolStruct: M("symbol-struct", 60049),
  symbolParameter: M("symbol-parameter", 60050),
  symbolTypeParameter: M("symbol-type-parameter", 60050),
  symbolKey: M("symbol-key", 60051),
  symbolText: M("symbol-text", 60051),
  symbolReference: M("symbol-reference", 60052),
  goToFile: M("go-to-file", 60052),
  symbolEnum: M("symbol-enum", 60053),
  symbolValue: M("symbol-value", 60053),
  symbolRuler: M("symbol-ruler", 60054),
  symbolUnit: M("symbol-unit", 60054),
  activateBreakpoints: M("activate-breakpoints", 60055),
  archive: M("archive", 60056),
  arrowBoth: M("arrow-both", 60057),
  arrowDown: M("arrow-down", 60058),
  arrowLeft: M("arrow-left", 60059),
  arrowRight: M("arrow-right", 60060),
  arrowSmallDown: M("arrow-small-down", 60061),
  arrowSmallLeft: M("arrow-small-left", 60062),
  arrowSmallRight: M("arrow-small-right", 60063),
  arrowSmallUp: M("arrow-small-up", 60064),
  arrowUp: M("arrow-up", 60065),
  bell: M("bell", 60066),
  bold: M("bold", 60067),
  book: M("book", 60068),
  bookmark: M("bookmark", 60069),
  debugBreakpointConditionalUnverified: M("debug-breakpoint-conditional-unverified", 60070),
  debugBreakpointConditional: M("debug-breakpoint-conditional", 60071),
  debugBreakpointConditionalDisabled: M("debug-breakpoint-conditional-disabled", 60071),
  debugBreakpointDataUnverified: M("debug-breakpoint-data-unverified", 60072),
  debugBreakpointData: M("debug-breakpoint-data", 60073),
  debugBreakpointDataDisabled: M("debug-breakpoint-data-disabled", 60073),
  debugBreakpointLogUnverified: M("debug-breakpoint-log-unverified", 60074),
  debugBreakpointLog: M("debug-breakpoint-log", 60075),
  debugBreakpointLogDisabled: M("debug-breakpoint-log-disabled", 60075),
  briefcase: M("briefcase", 60076),
  broadcast: M("broadcast", 60077),
  browser: M("browser", 60078),
  bug: M("bug", 60079),
  calendar: M("calendar", 60080),
  caseSensitive: M("case-sensitive", 60081),
  check: M("check", 60082),
  checklist: M("checklist", 60083),
  chevronDown: M("chevron-down", 60084),
  dropDownButton: M("drop-down-button", 60084),
  chevronLeft: M("chevron-left", 60085),
  chevronRight: M("chevron-right", 60086),
  chevronUp: M("chevron-up", 60087),
  chromeClose: M("chrome-close", 60088),
  chromeMaximize: M("chrome-maximize", 60089),
  chromeMinimize: M("chrome-minimize", 60090),
  chromeRestore: M("chrome-restore", 60091),
  circle: M("circle", 60092),
  circleOutline: M("circle-outline", 60092),
  debugBreakpointUnverified: M("debug-breakpoint-unverified", 60092),
  circleSlash: M("circle-slash", 60093),
  circuitBoard: M("circuit-board", 60094),
  clearAll: M("clear-all", 60095),
  clippy: M("clippy", 60096),
  closeAll: M("close-all", 60097),
  cloudDownload: M("cloud-download", 60098),
  cloudUpload: M("cloud-upload", 60099),
  code: M("code", 60100),
  collapseAll: M("collapse-all", 60101),
  colorMode: M("color-mode", 60102),
  commentDiscussion: M("comment-discussion", 60103),
  compareChanges: M("compare-changes", 60157),
  creditCard: M("credit-card", 60105),
  dash: M("dash", 60108),
  dashboard: M("dashboard", 60109),
  database: M("database", 60110),
  debugContinue: M("debug-continue", 60111),
  debugDisconnect: M("debug-disconnect", 60112),
  debugPause: M("debug-pause", 60113),
  debugRestart: M("debug-restart", 60114),
  debugStart: M("debug-start", 60115),
  debugStepInto: M("debug-step-into", 60116),
  debugStepOut: M("debug-step-out", 60117),
  debugStepOver: M("debug-step-over", 60118),
  debugStop: M("debug-stop", 60119),
  debug: M("debug", 60120),
  deviceCameraVideo: M("device-camera-video", 60121),
  deviceCamera: M("device-camera", 60122),
  deviceMobile: M("device-mobile", 60123),
  diffAdded: M("diff-added", 60124),
  diffIgnored: M("diff-ignored", 60125),
  diffModified: M("diff-modified", 60126),
  diffRemoved: M("diff-removed", 60127),
  diffRenamed: M("diff-renamed", 60128),
  diff: M("diff", 60129),
  discard: M("discard", 60130),
  editorLayout: M("editor-layout", 60131),
  emptyWindow: M("empty-window", 60132),
  exclude: M("exclude", 60133),
  extensions: M("extensions", 60134),
  eyeClosed: M("eye-closed", 60135),
  fileBinary: M("file-binary", 60136),
  fileCode: M("file-code", 60137),
  fileMedia: M("file-media", 60138),
  filePdf: M("file-pdf", 60139),
  fileSubmodule: M("file-submodule", 60140),
  fileSymlinkDirectory: M("file-symlink-directory", 60141),
  fileSymlinkFile: M("file-symlink-file", 60142),
  fileZip: M("file-zip", 60143),
  files: M("files", 60144),
  filter: M("filter", 60145),
  flame: M("flame", 60146),
  foldDown: M("fold-down", 60147),
  foldUp: M("fold-up", 60148),
  fold: M("fold", 60149),
  folderActive: M("folder-active", 60150),
  folderOpened: M("folder-opened", 60151),
  gear: M("gear", 60152),
  gift: M("gift", 60153),
  gistSecret: M("gist-secret", 60154),
  gist: M("gist", 60155),
  gitCommit: M("git-commit", 60156),
  gitCompare: M("git-compare", 60157),
  gitMerge: M("git-merge", 60158),
  githubAction: M("github-action", 60159),
  githubAlt: M("github-alt", 60160),
  globe: M("globe", 60161),
  grabber: M("grabber", 60162),
  graph: M("graph", 60163),
  gripper: M("gripper", 60164),
  heart: M("heart", 60165),
  home: M("home", 60166),
  horizontalRule: M("horizontal-rule", 60167),
  hubot: M("hubot", 60168),
  inbox: M("inbox", 60169),
  issueClosed: M("issue-closed", 60324),
  issueReopened: M("issue-reopened", 60171),
  issues: M("issues", 60172),
  italic: M("italic", 60173),
  jersey: M("jersey", 60174),
  json: M("json", 60175),
  bracket: M("bracket", 60175),
  kebabVertical: M("kebab-vertical", 60176),
  key: M("key", 60177),
  law: M("law", 60178),
  lightbulbAutofix: M("lightbulb-autofix", 60179),
  linkExternal: M("link-external", 60180),
  link: M("link", 60181),
  listOrdered: M("list-ordered", 60182),
  listUnordered: M("list-unordered", 60183),
  liveShare: M("live-share", 60184),
  loading: M("loading", 60185),
  location: M("location", 60186),
  mailRead: M("mail-read", 60187),
  mail: M("mail", 60188),
  markdown: M("markdown", 60189),
  megaphone: M("megaphone", 60190),
  mention: M("mention", 60191),
  milestone: M("milestone", 60192),
  gitPullRequestMilestone: M("git-pull-request-milestone", 60192),
  mortarBoard: M("mortar-board", 60193),
  move: M("move", 60194),
  multipleWindows: M("multiple-windows", 60195),
  mute: M("mute", 60196),
  noNewline: M("no-newline", 60197),
  note: M("note", 60198),
  octoface: M("octoface", 60199),
  openPreview: M("open-preview", 60200),
  package: M("package", 60201),
  paintcan: M("paintcan", 60202),
  pin: M("pin", 60203),
  play: M("play", 60204),
  run: M("run", 60204),
  plug: M("plug", 60205),
  preserveCase: M("preserve-case", 60206),
  preview: M("preview", 60207),
  project: M("project", 60208),
  pulse: M("pulse", 60209),
  question: M("question", 60210),
  quote: M("quote", 60211),
  radioTower: M("radio-tower", 60212),
  reactions: M("reactions", 60213),
  references: M("references", 60214),
  refresh: M("refresh", 60215),
  regex: M("regex", 60216),
  remoteExplorer: M("remote-explorer", 60217),
  remote: M("remote", 60218),
  remove: M("remove", 60219),
  replaceAll: M("replace-all", 60220),
  replace: M("replace", 60221),
  repoClone: M("repo-clone", 60222),
  repoForcePush: M("repo-force-push", 60223),
  repoPull: M("repo-pull", 60224),
  repoPush: M("repo-push", 60225),
  report: M("report", 60226),
  requestChanges: M("request-changes", 60227),
  rocket: M("rocket", 60228),
  rootFolderOpened: M("root-folder-opened", 60229),
  rootFolder: M("root-folder", 60230),
  rss: M("rss", 60231),
  ruby: M("ruby", 60232),
  saveAll: M("save-all", 60233),
  saveAs: M("save-as", 60234),
  save: M("save", 60235),
  screenFull: M("screen-full", 60236),
  screenNormal: M("screen-normal", 60237),
  searchStop: M("search-stop", 60238),
  server: M("server", 60240),
  settingsGear: M("settings-gear", 60241),
  settings: M("settings", 60242),
  shield: M("shield", 60243),
  smiley: M("smiley", 60244),
  sortPrecedence: M("sort-precedence", 60245),
  splitHorizontal: M("split-horizontal", 60246),
  splitVertical: M("split-vertical", 60247),
  squirrel: M("squirrel", 60248),
  starFull: M("star-full", 60249),
  starHalf: M("star-half", 60250),
  symbolClass: M("symbol-class", 60251),
  symbolColor: M("symbol-color", 60252),
  symbolCustomColor: M("symbol-customcolor", 60252),
  symbolConstant: M("symbol-constant", 60253),
  symbolEnumMember: M("symbol-enum-member", 60254),
  symbolField: M("symbol-field", 60255),
  symbolFile: M("symbol-file", 60256),
  symbolInterface: M("symbol-interface", 60257),
  symbolKeyword: M("symbol-keyword", 60258),
  symbolMisc: M("symbol-misc", 60259),
  symbolOperator: M("symbol-operator", 60260),
  symbolProperty: M("symbol-property", 60261),
  wrench: M("wrench", 60261),
  wrenchSubaction: M("wrench-subaction", 60261),
  symbolSnippet: M("symbol-snippet", 60262),
  tasklist: M("tasklist", 60263),
  telescope: M("telescope", 60264),
  textSize: M("text-size", 60265),
  threeBars: M("three-bars", 60266),
  thumbsdown: M("thumbsdown", 60267),
  thumbsup: M("thumbsup", 60268),
  tools: M("tools", 60269),
  triangleDown: M("triangle-down", 60270),
  triangleLeft: M("triangle-left", 60271),
  triangleRight: M("triangle-right", 60272),
  triangleUp: M("triangle-up", 60273),
  twitter: M("twitter", 60274),
  unfold: M("unfold", 60275),
  unlock: M("unlock", 60276),
  unmute: M("unmute", 60277),
  unverified: M("unverified", 60278),
  verified: M("verified", 60279),
  versions: M("versions", 60280),
  vmActive: M("vm-active", 60281),
  vmOutline: M("vm-outline", 60282),
  vmRunning: M("vm-running", 60283),
  watch: M("watch", 60284),
  whitespace: M("whitespace", 60285),
  wholeWord: M("whole-word", 60286),
  window: M("window", 60287),
  wordWrap: M("word-wrap", 60288),
  zoomIn: M("zoom-in", 60289),
  zoomOut: M("zoom-out", 60290),
  listFilter: M("list-filter", 60291),
  listFlat: M("list-flat", 60292),
  listSelection: M("list-selection", 60293),
  selection: M("selection", 60293),
  listTree: M("list-tree", 60294),
  debugBreakpointFunctionUnverified: M("debug-breakpoint-function-unverified", 60295),
  debugBreakpointFunction: M("debug-breakpoint-function", 60296),
  debugBreakpointFunctionDisabled: M("debug-breakpoint-function-disabled", 60296),
  debugStackframeActive: M("debug-stackframe-active", 60297),
  circleSmallFilled: M("circle-small-filled", 60298),
  debugStackframeDot: M("debug-stackframe-dot", 60298),
  debugStackframe: M("debug-stackframe", 60299),
  debugStackframeFocused: M("debug-stackframe-focused", 60299),
  debugBreakpointUnsupported: M("debug-breakpoint-unsupported", 60300),
  symbolString: M("symbol-string", 60301),
  debugReverseContinue: M("debug-reverse-continue", 60302),
  debugStepBack: M("debug-step-back", 60303),
  debugRestartFrame: M("debug-restart-frame", 60304),
  callIncoming: M("call-incoming", 60306),
  callOutgoing: M("call-outgoing", 60307),
  menu: M("menu", 60308),
  expandAll: M("expand-all", 60309),
  feedback: M("feedback", 60310),
  gitPullRequestReviewer: M("git-pull-request-reviewer", 60310),
  groupByRefType: M("group-by-ref-type", 60311),
  ungroupByRefType: M("ungroup-by-ref-type", 60312),
  account: M("account", 60313),
  gitPullRequestAssignee: M("git-pull-request-assignee", 60313),
  bellDot: M("bell-dot", 60314),
  debugConsole: M("debug-console", 60315),
  library: M("library", 60316),
  output: M("output", 60317),
  runAll: M("run-all", 60318),
  syncIgnored: M("sync-ignored", 60319),
  pinned: M("pinned", 60320),
  githubInverted: M("github-inverted", 60321),
  debugAlt: M("debug-alt", 60305),
  serverProcess: M("server-process", 60322),
  serverEnvironment: M("server-environment", 60323),
  pass: M("pass", 60324),
  stopCircle: M("stop-circle", 60325),
  playCircle: M("play-circle", 60326),
  record: M("record", 60327),
  debugAltSmall: M("debug-alt-small", 60328),
  vmConnect: M("vm-connect", 60329),
  cloud: M("cloud", 60330),
  merge: M("merge", 60331),
  exportIcon: M("export", 60332),
  graphLeft: M("graph-left", 60333),
  magnet: M("magnet", 60334),
  notebook: M("notebook", 60335),
  redo: M("redo", 60336),
  checkAll: M("check-all", 60337),
  pinnedDirty: M("pinned-dirty", 60338),
  passFilled: M("pass-filled", 60339),
  circleLargeFilled: M("circle-large-filled", 60340),
  circleLarge: M("circle-large", 60341),
  circleLargeOutline: M("circle-large-outline", 60341),
  combine: M("combine", 60342),
  gather: M("gather", 60342),
  table: M("table", 60343),
  variableGroup: M("variable-group", 60344),
  typeHierarchy: M("type-hierarchy", 60345),
  typeHierarchySub: M("type-hierarchy-sub", 60346),
  typeHierarchySuper: M("type-hierarchy-super", 60347),
  gitPullRequestCreate: M("git-pull-request-create", 60348),
  runAbove: M("run-above", 60349),
  runBelow: M("run-below", 60350),
  notebookTemplate: M("notebook-template", 60351),
  debugRerun: M("debug-rerun", 60352),
  workspaceTrusted: M("workspace-trusted", 60353),
  workspaceUntrusted: M("workspace-untrusted", 60354),
  workspaceUnspecified: M("workspace-unspecified", 60355),
  terminalCmd: M("terminal-cmd", 60356),
  terminalDebian: M("terminal-debian", 60357),
  terminalLinux: M("terminal-linux", 60358),
  terminalPowershell: M("terminal-powershell", 60359),
  terminalTmux: M("terminal-tmux", 60360),
  terminalUbuntu: M("terminal-ubuntu", 60361),
  terminalBash: M("terminal-bash", 60362),
  arrowSwap: M("arrow-swap", 60363),
  copy: M("copy", 60364),
  personAdd: M("person-add", 60365),
  filterFilled: M("filter-filled", 60366),
  wand: M("wand", 60367),
  debugLineByLine: M("debug-line-by-line", 60368),
  inspect: M("inspect", 60369),
  layers: M("layers", 60370),
  layersDot: M("layers-dot", 60371),
  layersActive: M("layers-active", 60372),
  compass: M("compass", 60373),
  compassDot: M("compass-dot", 60374),
  compassActive: M("compass-active", 60375),
  azure: M("azure", 60376),
  issueDraft: M("issue-draft", 60377),
  gitPullRequestClosed: M("git-pull-request-closed", 60378),
  gitPullRequestDraft: M("git-pull-request-draft", 60379),
  debugAll: M("debug-all", 60380),
  debugCoverage: M("debug-coverage", 60381),
  runErrors: M("run-errors", 60382),
  folderLibrary: M("folder-library", 60383),
  debugContinueSmall: M("debug-continue-small", 60384),
  beakerStop: M("beaker-stop", 60385),
  graphLine: M("graph-line", 60386),
  graphScatter: M("graph-scatter", 60387),
  pieChart: M("pie-chart", 60388),
  bracketDot: M("bracket-dot", 60389),
  bracketError: M("bracket-error", 60390),
  lockSmall: M("lock-small", 60391),
  azureDevops: M("azure-devops", 60392),
  verifiedFilled: M("verified-filled", 60393),
  newLine: M("newline", 60394),
  layout: M("layout", 60395),
  layoutActivitybarLeft: M("layout-activitybar-left", 60396),
  layoutActivitybarRight: M("layout-activitybar-right", 60397),
  layoutPanelLeft: M("layout-panel-left", 60398),
  layoutPanelCenter: M("layout-panel-center", 60399),
  layoutPanelJustify: M("layout-panel-justify", 60400),
  layoutPanelRight: M("layout-panel-right", 60401),
  layoutPanel: M("layout-panel", 60402),
  layoutSidebarLeft: M("layout-sidebar-left", 60403),
  layoutSidebarRight: M("layout-sidebar-right", 60404),
  layoutStatusbar: M("layout-statusbar", 60405),
  layoutMenubar: M("layout-menubar", 60406),
  layoutCentered: M("layout-centered", 60407),
  layoutSidebarRightOff: M("layout-sidebar-right-off", 60416),
  layoutPanelOff: M("layout-panel-off", 60417),
  layoutSidebarLeftOff: M("layout-sidebar-left-off", 60418),
  target: M("target", 60408),
  indent: M("indent", 60409),
  recordSmall: M("record-small", 60410),
  errorSmall: M("error-small", 60411),
  arrowCircleDown: M("arrow-circle-down", 60412),
  arrowCircleLeft: M("arrow-circle-left", 60413),
  arrowCircleRight: M("arrow-circle-right", 60414),
  arrowCircleUp: M("arrow-circle-up", 60415),
  heartFilled: M("heart-filled", 60420),
  map: M("map", 60421),
  mapFilled: M("map-filled", 60422),
  circleSmall: M("circle-small", 60423),
  bellSlash: M("bell-slash", 60424),
  bellSlashDot: M("bell-slash-dot", 60425),
  commentUnresolved: M("comment-unresolved", 60426),
  gitPullRequestGoToChanges: M("git-pull-request-go-to-changes", 60427),
  gitPullRequestNewChanges: M("git-pull-request-new-changes", 60428),
  searchFuzzy: M("search-fuzzy", 60429),
  commentDraft: M("comment-draft", 60430),
  send: M("send", 60431),
  sparkle: M("sparkle", 60432),
  insert: M("insert", 60433),
  mic: M("mic", 60434),
  // derived icons, that could become separate icons
  dialogError: M("dialog-error", "error"),
  dialogWarning: M("dialog-warning", "warning"),
  dialogInfo: M("dialog-info", "info"),
  dialogClose: M("dialog-close", "close"),
  treeItemExpanded: M("tree-item-expanded", "chevron-down"),
  // collapsed is done with rotation
  treeFilterOnTypeOn: M("tree-filter-on-type-on", "list-filter"),
  treeFilterOnTypeOff: M("tree-filter-on-type-off", "list-selection"),
  treeFilterClear: M("tree-filter-clear", "close"),
  treeItemLoading: M("tree-item-loading", "loading"),
  menuSelection: M("menu-selection", "check"),
  menuSubmenu: M("menu-submenu", "chevron-right"),
  menuBarMore: M("menubar-more", "more"),
  scrollbarButtonLeft: M("scrollbar-button-left", "triangle-left"),
  scrollbarButtonRight: M("scrollbar-button-right", "triangle-right"),
  scrollbarButtonUp: M("scrollbar-button-up", "triangle-up"),
  scrollbarButtonDown: M("scrollbar-button-down", "triangle-down"),
  toolBarMore: M("toolbar-more", "more"),
  quickInputBack: M("quick-input-back", "arrow-left")
};
var hR = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let oNe = class {
  constructor() {
    this._tokenizationSupports = /* @__PURE__ */ new Map(), this._factories = /* @__PURE__ */ new Map(), this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event, this._colorMap = null;
  }
  handleChange(e) {
    this._onDidChange.fire({
      changedLanguages: e,
      changedColorMap: !1
    });
  }
  register(e, t) {
    return this._tokenizationSupports.set(e, t), this.handleChange([e]), Ct(() => {
      this._tokenizationSupports.get(e) === t && (this._tokenizationSupports.delete(e), this.handleChange([e]));
    });
  }
  get(e) {
    return this._tokenizationSupports.get(e) || null;
  }
  registerFactory(e, t) {
    var n;
    (n = this._factories.get(e)) === null || n === void 0 || n.dispose();
    const r = new aNe(this, e, t);
    return this._factories.set(e, r), Ct(() => {
      const s = this._factories.get(e);
      !s || s !== r || (this._factories.delete(e), s.dispose());
    });
  }
  getOrCreate(e) {
    return hR(this, void 0, void 0, function* () {
      const t = this.get(e);
      if (t)
        return t;
      const n = this._factories.get(e);
      return !n || n.isResolved ? null : (yield n.resolve(), this.get(e));
    });
  }
  isResolved(e) {
    if (this.get(e))
      return !0;
    const n = this._factories.get(e);
    return !!(!n || n.isResolved);
  }
  setColorMap(e) {
    this._colorMap = e, this._onDidChange.fire({
      changedLanguages: Array.from(this._tokenizationSupports.keys()),
      changedColorMap: !0
    });
  }
  getColorMap() {
    return this._colorMap;
  }
  getDefaultBackground() {
    return this._colorMap && this._colorMap.length > 2 ? this._colorMap[
      2
      /* ColorId.DefaultBackground */
    ] : null;
  }
};
class aNe extends we {
  get isResolved() {
    return this._isResolved;
  }
  constructor(e, t, n) {
    super(), this._registry = e, this._languageId = t, this._factory = n, this._isDisposed = !1, this._resolvePromise = null, this._isResolved = !1;
  }
  dispose() {
    this._isDisposed = !0, super.dispose();
  }
  resolve() {
    return hR(this, void 0, void 0, function* () {
      return this._resolvePromise || (this._resolvePromise = this._create()), this._resolvePromise;
    });
  }
  _create() {
    return hR(this, void 0, void 0, function* () {
      const e = yield this._factory.tokenizationSupport;
      this._isResolved = !0, e && !this._isDisposed && this._register(this._registry.register(this._languageId, e));
    });
  }
}
let wy = class {
  constructor(e, t, n) {
    this.offset = e, this.type = t, this.language = n, this._tokenBrand = void 0;
  }
  toString() {
    return "(" + this.offset + ", " + this.type + ")";
  }
};
class Rj {
  constructor(e, t) {
    this.tokens = e, this.endState = t, this._tokenizationResultBrand = void 0;
  }
}
class zA {
  constructor(e, t) {
    this.tokens = e, this.endState = t, this._encodedTokenizationResultBrand = void 0;
  }
}
var Sy;
(function(i) {
  const e = /* @__PURE__ */ new Map();
  e.set(0, We.symbolMethod), e.set(1, We.symbolFunction), e.set(2, We.symbolConstructor), e.set(3, We.symbolField), e.set(4, We.symbolVariable), e.set(5, We.symbolClass), e.set(6, We.symbolStruct), e.set(7, We.symbolInterface), e.set(8, We.symbolModule), e.set(9, We.symbolProperty), e.set(10, We.symbolEvent), e.set(11, We.symbolOperator), e.set(12, We.symbolUnit), e.set(13, We.symbolValue), e.set(15, We.symbolEnum), e.set(14, We.symbolConstant), e.set(15, We.symbolEnum), e.set(16, We.symbolEnumMember), e.set(17, We.symbolKeyword), e.set(27, We.symbolSnippet), e.set(18, We.symbolText), e.set(19, We.symbolColor), e.set(20, We.symbolFile), e.set(21, We.symbolReference), e.set(22, We.symbolCustomColor), e.set(23, We.symbolFolder), e.set(24, We.symbolTypeParameter), e.set(25, We.account), e.set(26, We.issues);
  function t(s) {
    let o = e.get(s);
    return o || (console.info("No codicon found for CompletionItemKind " + s), o = We.symbolProperty), o;
  }
  i.toIcon = t;
  const n = /* @__PURE__ */ new Map();
  n.set(
    "method",
    0
    /* CompletionItemKind.Method */
  ), n.set(
    "function",
    1
    /* CompletionItemKind.Function */
  ), n.set(
    "constructor",
    2
    /* CompletionItemKind.Constructor */
  ), n.set(
    "field",
    3
    /* CompletionItemKind.Field */
  ), n.set(
    "variable",
    4
    /* CompletionItemKind.Variable */
  ), n.set(
    "class",
    5
    /* CompletionItemKind.Class */
  ), n.set(
    "struct",
    6
    /* CompletionItemKind.Struct */
  ), n.set(
    "interface",
    7
    /* CompletionItemKind.Interface */
  ), n.set(
    "module",
    8
    /* CompletionItemKind.Module */
  ), n.set(
    "property",
    9
    /* CompletionItemKind.Property */
  ), n.set(
    "event",
    10
    /* CompletionItemKind.Event */
  ), n.set(
    "operator",
    11
    /* CompletionItemKind.Operator */
  ), n.set(
    "unit",
    12
    /* CompletionItemKind.Unit */
  ), n.set(
    "value",
    13
    /* CompletionItemKind.Value */
  ), n.set(
    "constant",
    14
    /* CompletionItemKind.Constant */
  ), n.set(
    "enum",
    15
    /* CompletionItemKind.Enum */
  ), n.set(
    "enum-member",
    16
    /* CompletionItemKind.EnumMember */
  ), n.set(
    "enumMember",
    16
    /* CompletionItemKind.EnumMember */
  ), n.set(
    "keyword",
    17
    /* CompletionItemKind.Keyword */
  ), n.set(
    "snippet",
    27
    /* CompletionItemKind.Snippet */
  ), n.set(
    "text",
    18
    /* CompletionItemKind.Text */
  ), n.set(
    "color",
    19
    /* CompletionItemKind.Color */
  ), n.set(
    "file",
    20
    /* CompletionItemKind.File */
  ), n.set(
    "reference",
    21
    /* CompletionItemKind.Reference */
  ), n.set(
    "customcolor",
    22
    /* CompletionItemKind.Customcolor */
  ), n.set(
    "folder",
    23
    /* CompletionItemKind.Folder */
  ), n.set(
    "type-parameter",
    24
    /* CompletionItemKind.TypeParameter */
  ), n.set(
    "typeParameter",
    24
    /* CompletionItemKind.TypeParameter */
  ), n.set(
    "account",
    25
    /* CompletionItemKind.User */
  ), n.set(
    "issue",
    26
    /* CompletionItemKind.Issue */
  );
  function r(s, o) {
    let a = n.get(s);
    return typeof a > "u" && !o && (a = 9), a;
  }
  i.fromString = r;
})(Sy || (Sy = {}));
var Fh;
(function(i) {
  i[i.Automatic = 0] = "Automatic", i[i.Explicit = 1] = "Explicit";
})(Fh || (Fh = {}));
class lhe {
  constructor(e, t, n, r) {
    this.range = e, this.text = t, this.completionKind = n, this.isSnippetText = r;
  }
  equals(e) {
    return V.lift(this.range).equalsRange(e.range) && this.text === e.text && this.completionKind === e.completionKind && this.isSnippetText === e.isSnippetText;
  }
}
var lu;
(function(i) {
  i[i.Invoke = 1] = "Invoke", i[i.TriggerCharacter = 2] = "TriggerCharacter", i[i.ContentChange = 3] = "ContentChange";
})(lu || (lu = {}));
var xy;
(function(i) {
  i[i.Text = 0] = "Text", i[i.Read = 1] = "Read", i[i.Write = 2] = "Write";
})(xy || (xy = {}));
function lNe(i) {
  return i && pt.isUri(i.uri) && V.isIRange(i.range) && (V.isIRange(i.originSelectionRange) || V.isIRange(i.targetSelectionRange));
}
const cNe = {
  17: C("Array", "array"),
  16: C("Boolean", "boolean"),
  4: C("Class", "class"),
  13: C("Constant", "constant"),
  8: C("Constructor", "constructor"),
  9: C("Enum", "enumeration"),
  21: C("EnumMember", "enumeration member"),
  23: C("Event", "event"),
  7: C("Field", "field"),
  0: C("File", "file"),
  11: C("Function", "function"),
  10: C("Interface", "interface"),
  19: C("Key", "key"),
  5: C("Method", "method"),
  1: C("Module", "module"),
  2: C("Namespace", "namespace"),
  20: C("Null", "null"),
  15: C("Number", "number"),
  18: C("Object", "object"),
  24: C("Operator", "operator"),
  3: C("Package", "package"),
  6: C("Property", "property"),
  14: C("String", "string"),
  22: C("Struct", "struct"),
  25: C("TypeParameter", "type parameter"),
  12: C("Variable", "variable")
};
function dNe(i, e) {
  return C("symbolAriaLabel", "{0} ({1})", i, cNe[e]);
}
var GE;
(function(i) {
  const e = /* @__PURE__ */ new Map();
  e.set(0, We.symbolFile), e.set(1, We.symbolModule), e.set(2, We.symbolNamespace), e.set(3, We.symbolPackage), e.set(4, We.symbolClass), e.set(5, We.symbolMethod), e.set(6, We.symbolProperty), e.set(7, We.symbolField), e.set(8, We.symbolConstructor), e.set(9, We.symbolEnum), e.set(10, We.symbolInterface), e.set(11, We.symbolFunction), e.set(12, We.symbolVariable), e.set(13, We.symbolConstant), e.set(14, We.symbolString), e.set(15, We.symbolNumber), e.set(16, We.symbolBoolean), e.set(17, We.symbolArray), e.set(18, We.symbolObject), e.set(19, We.symbolKey), e.set(20, We.symbolNull), e.set(21, We.symbolEnumMember), e.set(22, We.symbolStruct), e.set(23, We.symbolEvent), e.set(24, We.symbolOperator), e.set(25, We.symbolTypeParameter);
  function t(n) {
    let r = e.get(n);
    return r || (console.info("No codicon found for SymbolKind " + n), r = We.symbolProperty), r;
  }
  i.toIcon = t;
})(GE || (GE = {}));
class go {
  /**
   * Returns a {@link FoldingRangeKind} for the given value.
   *
   * @param value of the kind.
   */
  static fromValue(e) {
    switch (e) {
      case "comment":
        return go.Comment;
      case "imports":
        return go.Imports;
      case "region":
        return go.Region;
    }
    return new go(e);
  }
  /**
   * Creates a new {@link FoldingRangeKind}.
   *
   * @param value of the kind.
   */
  constructor(e) {
    this.value = e;
  }
}
go.Comment = new go("comment");
go.Imports = new go("imports");
go.Region = new go("region");
var fR;
(function(i) {
  function e(t) {
    return !t || typeof t != "object" ? !1 : typeof t.id == "string" && typeof t.title == "string";
  }
  i.is = e;
})(fR || (fR = {}));
var qE;
(function(i) {
  i[i.Type = 1] = "Type", i[i.Parameter = 2] = "Parameter";
})(qE || (qE = {}));
class uNe {
  constructor(e) {
    this.createSupport = e, this._tokenizationSupport = null;
  }
  dispose() {
    this._tokenizationSupport && this._tokenizationSupport.then((e) => {
      e && e.dispose();
    });
  }
  get tokenizationSupport() {
    return this._tokenizationSupport || (this._tokenizationSupport = this.createSupport()), this._tokenizationSupport;
  }
}
const Pi = new oNe();
var gR;
(function(i) {
  i[i.Unknown = 0] = "Unknown", i[i.Disabled = 1] = "Disabled", i[i.Enabled = 2] = "Enabled";
})(gR || (gR = {}));
var pR;
(function(i) {
  i[i.Invoke = 1] = "Invoke", i[i.Auto = 2] = "Auto";
})(pR || (pR = {}));
var mR;
(function(i) {
  i[i.None = 0] = "None", i[i.KeepWhitespace = 1] = "KeepWhitespace", i[i.InsertAsSnippet = 4] = "InsertAsSnippet";
})(mR || (mR = {}));
var vR;
(function(i) {
  i[i.Method = 0] = "Method", i[i.Function = 1] = "Function", i[i.Constructor = 2] = "Constructor", i[i.Field = 3] = "Field", i[i.Variable = 4] = "Variable", i[i.Class = 5] = "Class", i[i.Struct = 6] = "Struct", i[i.Interface = 7] = "Interface", i[i.Module = 8] = "Module", i[i.Property = 9] = "Property", i[i.Event = 10] = "Event", i[i.Operator = 11] = "Operator", i[i.Unit = 12] = "Unit", i[i.Value = 13] = "Value", i[i.Constant = 14] = "Constant", i[i.Enum = 15] = "Enum", i[i.EnumMember = 16] = "EnumMember", i[i.Keyword = 17] = "Keyword", i[i.Text = 18] = "Text", i[i.Color = 19] = "Color", i[i.File = 20] = "File", i[i.Reference = 21] = "Reference", i[i.Customcolor = 22] = "Customcolor", i[i.Folder = 23] = "Folder", i[i.TypeParameter = 24] = "TypeParameter", i[i.User = 25] = "User", i[i.Issue = 26] = "Issue", i[i.Snippet = 27] = "Snippet";
})(vR || (vR = {}));
var _R;
(function(i) {
  i[i.Deprecated = 1] = "Deprecated";
})(_R || (_R = {}));
var bR;
(function(i) {
  i[i.Invoke = 0] = "Invoke", i[i.TriggerCharacter = 1] = "TriggerCharacter", i[i.TriggerForIncompleteCompletions = 2] = "TriggerForIncompleteCompletions";
})(bR || (bR = {}));
var CR;
(function(i) {
  i[i.EXACT = 0] = "EXACT", i[i.ABOVE = 1] = "ABOVE", i[i.BELOW = 2] = "BELOW";
})(CR || (CR = {}));
var yR;
(function(i) {
  i[i.NotSet = 0] = "NotSet", i[i.ContentFlush = 1] = "ContentFlush", i[i.RecoverFromMarkers = 2] = "RecoverFromMarkers", i[i.Explicit = 3] = "Explicit", i[i.Paste = 4] = "Paste", i[i.Undo = 5] = "Undo", i[i.Redo = 6] = "Redo";
})(yR || (yR = {}));
var wR;
(function(i) {
  i[i.LF = 1] = "LF", i[i.CRLF = 2] = "CRLF";
})(wR || (wR = {}));
var SR;
(function(i) {
  i[i.Text = 0] = "Text", i[i.Read = 1] = "Read", i[i.Write = 2] = "Write";
})(SR || (SR = {}));
var xR;
(function(i) {
  i[i.None = 0] = "None", i[i.Keep = 1] = "Keep", i[i.Brackets = 2] = "Brackets", i[i.Advanced = 3] = "Advanced", i[i.Full = 4] = "Full";
})(xR || (xR = {}));
var DR;
(function(i) {
  i[i.acceptSuggestionOnCommitCharacter = 0] = "acceptSuggestionOnCommitCharacter", i[i.acceptSuggestionOnEnter = 1] = "acceptSuggestionOnEnter", i[i.accessibilitySupport = 2] = "accessibilitySupport", i[i.accessibilityPageSize = 3] = "accessibilityPageSize", i[i.ariaLabel = 4] = "ariaLabel", i[i.ariaRequired = 5] = "ariaRequired", i[i.autoClosingBrackets = 6] = "autoClosingBrackets", i[i.autoClosingComments = 7] = "autoClosingComments", i[i.screenReaderAnnounceInlineSuggestion = 8] = "screenReaderAnnounceInlineSuggestion", i[i.autoClosingDelete = 9] = "autoClosingDelete", i[i.autoClosingOvertype = 10] = "autoClosingOvertype", i[i.autoClosingQuotes = 11] = "autoClosingQuotes", i[i.autoIndent = 12] = "autoIndent", i[i.automaticLayout = 13] = "automaticLayout", i[i.autoSurround = 14] = "autoSurround", i[i.bracketPairColorization = 15] = "bracketPairColorization", i[i.guides = 16] = "guides", i[i.codeLens = 17] = "codeLens", i[i.codeLensFontFamily = 18] = "codeLensFontFamily", i[i.codeLensFontSize = 19] = "codeLensFontSize", i[i.colorDecorators = 20] = "colorDecorators", i[i.colorDecoratorsLimit = 21] = "colorDecoratorsLimit", i[i.columnSelection = 22] = "columnSelection", i[i.comments = 23] = "comments", i[i.contextmenu = 24] = "contextmenu", i[i.copyWithSyntaxHighlighting = 25] = "copyWithSyntaxHighlighting", i[i.cursorBlinking = 26] = "cursorBlinking", i[i.cursorSmoothCaretAnimation = 27] = "cursorSmoothCaretAnimation", i[i.cursorStyle = 28] = "cursorStyle", i[i.cursorSurroundingLines = 29] = "cursorSurroundingLines", i[i.cursorSurroundingLinesStyle = 30] = "cursorSurroundingLinesStyle", i[i.cursorWidth = 31] = "cursorWidth", i[i.disableLayerHinting = 32] = "disableLayerHinting", i[i.disableMonospaceOptimizations = 33] = "disableMonospaceOptimizations", i[i.domReadOnly = 34] = "domReadOnly", i[i.dragAndDrop = 35] = "dragAndDrop", i[i.dropIntoEditor = 36] = "dropIntoEditor", i[i.emptySelectionClipboard = 37] = "emptySelectionClipboard", i[i.experimentalWhitespaceRendering = 38] = "experimentalWhitespaceRendering", i[i.extraEditorClassName = 39] = "extraEditorClassName", i[i.fastScrollSensitivity = 40] = "fastScrollSensitivity", i[i.find = 41] = "find", i[i.fixedOverflowWidgets = 42] = "fixedOverflowWidgets", i[i.folding = 43] = "folding", i[i.foldingStrategy = 44] = "foldingStrategy", i[i.foldingHighlight = 45] = "foldingHighlight", i[i.foldingImportsByDefault = 46] = "foldingImportsByDefault", i[i.foldingMaximumRegions = 47] = "foldingMaximumRegions", i[i.unfoldOnClickAfterEndOfLine = 48] = "unfoldOnClickAfterEndOfLine", i[i.fontFamily = 49] = "fontFamily", i[i.fontInfo = 50] = "fontInfo", i[i.fontLigatures = 51] = "fontLigatures", i[i.fontSize = 52] = "fontSize", i[i.fontWeight = 53] = "fontWeight", i[i.fontVariations = 54] = "fontVariations", i[i.formatOnPaste = 55] = "formatOnPaste", i[i.formatOnType = 56] = "formatOnType", i[i.glyphMargin = 57] = "glyphMargin", i[i.gotoLocation = 58] = "gotoLocation", i[i.hideCursorInOverviewRuler = 59] = "hideCursorInOverviewRuler", i[i.hover = 60] = "hover", i[i.inDiffEditor = 61] = "inDiffEditor", i[i.inlineSuggest = 62] = "inlineSuggest", i[i.letterSpacing = 63] = "letterSpacing", i[i.lightbulb = 64] = "lightbulb", i[i.lineDecorationsWidth = 65] = "lineDecorationsWidth", i[i.lineHeight = 66] = "lineHeight", i[i.lineNumbers = 67] = "lineNumbers", i[i.lineNumbersMinChars = 68] = "lineNumbersMinChars", i[i.linkedEditing = 69] = "linkedEditing", i[i.links = 70] = "links", i[i.matchBrackets = 71] = "matchBrackets", i[i.minimap = 72] = "minimap", i[i.mouseStyle = 73] = "mouseStyle", i[i.mouseWheelScrollSensitivity = 74] = "mouseWheelScrollSensitivity", i[i.mouseWheelZoom = 75] = "mouseWheelZoom", i[i.multiCursorMergeOverlapping = 76] = "multiCursorMergeOverlapping", i[i.multiCursorModifier = 77] = "multiCursorModifier", i[i.multiCursorPaste = 78] = "multiCursorPaste", i[i.multiCursorLimit = 79] = "multiCursorLimit", i[i.occurrencesHighlight = 80] = "occurrencesHighlight", i[i.overviewRulerBorder = 81] = "overviewRulerBorder", i[i.overviewRulerLanes = 82] = "overviewRulerLanes", i[i.padding = 83] = "padding", i[i.pasteAs = 84] = "pasteAs", i[i.parameterHints = 85] = "parameterHints", i[i.peekWidgetDefaultFocus = 86] = "peekWidgetDefaultFocus", i[i.definitionLinkOpensInPeek = 87] = "definitionLinkOpensInPeek", i[i.quickSuggestions = 88] = "quickSuggestions", i[i.quickSuggestionsDelay = 89] = "quickSuggestionsDelay", i[i.readOnly = 90] = "readOnly", i[i.readOnlyMessage = 91] = "readOnlyMessage", i[i.renameOnType = 92] = "renameOnType", i[i.renderControlCharacters = 93] = "renderControlCharacters", i[i.renderFinalNewline = 94] = "renderFinalNewline", i[i.renderLineHighlight = 95] = "renderLineHighlight", i[i.renderLineHighlightOnlyWhenFocus = 96] = "renderLineHighlightOnlyWhenFocus", i[i.renderValidationDecorations = 97] = "renderValidationDecorations", i[i.renderWhitespace = 98] = "renderWhitespace", i[i.revealHorizontalRightPadding = 99] = "revealHorizontalRightPadding", i[i.roundedSelection = 100] = "roundedSelection", i[i.rulers = 101] = "rulers", i[i.scrollbar = 102] = "scrollbar", i[i.scrollBeyondLastColumn = 103] = "scrollBeyondLastColumn", i[i.scrollBeyondLastLine = 104] = "scrollBeyondLastLine", i[i.scrollPredominantAxis = 105] = "scrollPredominantAxis", i[i.selectionClipboard = 106] = "selectionClipboard", i[i.selectionHighlight = 107] = "selectionHighlight", i[i.selectOnLineNumbers = 108] = "selectOnLineNumbers", i[i.showFoldingControls = 109] = "showFoldingControls", i[i.showUnused = 110] = "showUnused", i[i.snippetSuggestions = 111] = "snippetSuggestions", i[i.smartSelect = 112] = "smartSelect", i[i.smoothScrolling = 113] = "smoothScrolling", i[i.stickyScroll = 114] = "stickyScroll", i[i.stickyTabStops = 115] = "stickyTabStops", i[i.stopRenderingLineAfter = 116] = "stopRenderingLineAfter", i[i.suggest = 117] = "suggest", i[i.suggestFontSize = 118] = "suggestFontSize", i[i.suggestLineHeight = 119] = "suggestLineHeight", i[i.suggestOnTriggerCharacters = 120] = "suggestOnTriggerCharacters", i[i.suggestSelection = 121] = "suggestSelection", i[i.tabCompletion = 122] = "tabCompletion", i[i.tabIndex = 123] = "tabIndex", i[i.unicodeHighlighting = 124] = "unicodeHighlighting", i[i.unusualLineTerminators = 125] = "unusualLineTerminators", i[i.useShadowDOM = 126] = "useShadowDOM", i[i.useTabStops = 127] = "useTabStops", i[i.wordBreak = 128] = "wordBreak", i[i.wordSeparators = 129] = "wordSeparators", i[i.wordWrap = 130] = "wordWrap", i[i.wordWrapBreakAfterCharacters = 131] = "wordWrapBreakAfterCharacters", i[i.wordWrapBreakBeforeCharacters = 132] = "wordWrapBreakBeforeCharacters", i[i.wordWrapColumn = 133] = "wordWrapColumn", i[i.wordWrapOverride1 = 134] = "wordWrapOverride1", i[i.wordWrapOverride2 = 135] = "wordWrapOverride2", i[i.wrappingIndent = 136] = "wrappingIndent", i[i.wrappingStrategy = 137] = "wrappingStrategy", i[i.showDeprecated = 138] = "showDeprecated", i[i.inlayHints = 139] = "inlayHints", i[i.editorClassName = 140] = "editorClassName", i[i.pixelRatio = 141] = "pixelRatio", i[i.tabFocusMode = 142] = "tabFocusMode", i[i.layoutInfo = 143] = "layoutInfo", i[i.wrappingInfo = 144] = "wrappingInfo", i[i.defaultColorDecorators = 145] = "defaultColorDecorators", i[i.colorDecoratorsActivatedOn = 146] = "colorDecoratorsActivatedOn", i[i.inlineCompletionsAccessibilityVerbose = 147] = "inlineCompletionsAccessibilityVerbose";
})(DR || (DR = {}));
var ER;
(function(i) {
  i[i.TextDefined = 0] = "TextDefined", i[i.LF = 1] = "LF", i[i.CRLF = 2] = "CRLF";
})(ER || (ER = {}));
var LR;
(function(i) {
  i[i.LF = 0] = "LF", i[i.CRLF = 1] = "CRLF";
})(LR || (LR = {}));
var IR;
(function(i) {
  i[i.Left = 1] = "Left", i[i.Right = 2] = "Right";
})(IR || (IR = {}));
var AR;
(function(i) {
  i[i.None = 0] = "None", i[i.Indent = 1] = "Indent", i[i.IndentOutdent = 2] = "IndentOutdent", i[i.Outdent = 3] = "Outdent";
})(AR || (AR = {}));
var kR;
(function(i) {
  i[i.Both = 0] = "Both", i[i.Right = 1] = "Right", i[i.Left = 2] = "Left", i[i.None = 3] = "None";
})(kR || (kR = {}));
var TR;
(function(i) {
  i[i.Type = 1] = "Type", i[i.Parameter = 2] = "Parameter";
})(TR || (TR = {}));
var NR;
(function(i) {
  i[i.Automatic = 0] = "Automatic", i[i.Explicit = 1] = "Explicit";
})(NR || (NR = {}));
var PR;
(function(i) {
  i[i.DependsOnKbLayout = -1] = "DependsOnKbLayout", i[i.Unknown = 0] = "Unknown", i[i.Backspace = 1] = "Backspace", i[i.Tab = 2] = "Tab", i[i.Enter = 3] = "Enter", i[i.Shift = 4] = "Shift", i[i.Ctrl = 5] = "Ctrl", i[i.Alt = 6] = "Alt", i[i.PauseBreak = 7] = "PauseBreak", i[i.CapsLock = 8] = "CapsLock", i[i.Escape = 9] = "Escape", i[i.Space = 10] = "Space", i[i.PageUp = 11] = "PageUp", i[i.PageDown = 12] = "PageDown", i[i.End = 13] = "End", i[i.Home = 14] = "Home", i[i.LeftArrow = 15] = "LeftArrow", i[i.UpArrow = 16] = "UpArrow", i[i.RightArrow = 17] = "RightArrow", i[i.DownArrow = 18] = "DownArrow", i[i.Insert = 19] = "Insert", i[i.Delete = 20] = "Delete", i[i.Digit0 = 21] = "Digit0", i[i.Digit1 = 22] = "Digit1", i[i.Digit2 = 23] = "Digit2", i[i.Digit3 = 24] = "Digit3", i[i.Digit4 = 25] = "Digit4", i[i.Digit5 = 26] = "Digit5", i[i.Digit6 = 27] = "Digit6", i[i.Digit7 = 28] = "Digit7", i[i.Digit8 = 29] = "Digit8", i[i.Digit9 = 30] = "Digit9", i[i.KeyA = 31] = "KeyA", i[i.KeyB = 32] = "KeyB", i[i.KeyC = 33] = "KeyC", i[i.KeyD = 34] = "KeyD", i[i.KeyE = 35] = "KeyE", i[i.KeyF = 36] = "KeyF", i[i.KeyG = 37] = "KeyG", i[i.KeyH = 38] = "KeyH", i[i.KeyI = 39] = "KeyI", i[i.KeyJ = 40] = "KeyJ", i[i.KeyK = 41] = "KeyK", i[i.KeyL = 42] = "KeyL", i[i.KeyM = 43] = "KeyM", i[i.KeyN = 44] = "KeyN", i[i.KeyO = 45] = "KeyO", i[i.KeyP = 46] = "KeyP", i[i.KeyQ = 47] = "KeyQ", i[i.KeyR = 48] = "KeyR", i[i.KeyS = 49] = "KeyS", i[i.KeyT = 50] = "KeyT", i[i.KeyU = 51] = "KeyU", i[i.KeyV = 52] = "KeyV", i[i.KeyW = 53] = "KeyW", i[i.KeyX = 54] = "KeyX", i[i.KeyY = 55] = "KeyY", i[i.KeyZ = 56] = "KeyZ", i[i.Meta = 57] = "Meta", i[i.ContextMenu = 58] = "ContextMenu", i[i.F1 = 59] = "F1", i[i.F2 = 60] = "F2", i[i.F3 = 61] = "F3", i[i.F4 = 62] = "F4", i[i.F5 = 63] = "F5", i[i.F6 = 64] = "F6", i[i.F7 = 65] = "F7", i[i.F8 = 66] = "F8", i[i.F9 = 67] = "F9", i[i.F10 = 68] = "F10", i[i.F11 = 69] = "F11", i[i.F12 = 70] = "F12", i[i.F13 = 71] = "F13", i[i.F14 = 72] = "F14", i[i.F15 = 73] = "F15", i[i.F16 = 74] = "F16", i[i.F17 = 75] = "F17", i[i.F18 = 76] = "F18", i[i.F19 = 77] = "F19", i[i.F20 = 78] = "F20", i[i.F21 = 79] = "F21", i[i.F22 = 80] = "F22", i[i.F23 = 81] = "F23", i[i.F24 = 82] = "F24", i[i.NumLock = 83] = "NumLock", i[i.ScrollLock = 84] = "ScrollLock", i[i.Semicolon = 85] = "Semicolon", i[i.Equal = 86] = "Equal", i[i.Comma = 87] = "Comma", i[i.Minus = 88] = "Minus", i[i.Period = 89] = "Period", i[i.Slash = 90] = "Slash", i[i.Backquote = 91] = "Backquote", i[i.BracketLeft = 92] = "BracketLeft", i[i.Backslash = 93] = "Backslash", i[i.BracketRight = 94] = "BracketRight", i[i.Quote = 95] = "Quote", i[i.OEM_8 = 96] = "OEM_8", i[i.IntlBackslash = 97] = "IntlBackslash", i[i.Numpad0 = 98] = "Numpad0", i[i.Numpad1 = 99] = "Numpad1", i[i.Numpad2 = 100] = "Numpad2", i[i.Numpad3 = 101] = "Numpad3", i[i.Numpad4 = 102] = "Numpad4", i[i.Numpad5 = 103] = "Numpad5", i[i.Numpad6 = 104] = "Numpad6", i[i.Numpad7 = 105] = "Numpad7", i[i.Numpad8 = 106] = "Numpad8", i[i.Numpad9 = 107] = "Numpad9", i[i.NumpadMultiply = 108] = "NumpadMultiply", i[i.NumpadAdd = 109] = "NumpadAdd", i[i.NUMPAD_SEPARATOR = 110] = "NUMPAD_SEPARATOR", i[i.NumpadSubtract = 111] = "NumpadSubtract", i[i.NumpadDecimal = 112] = "NumpadDecimal", i[i.NumpadDivide = 113] = "NumpadDivide", i[i.KEY_IN_COMPOSITION = 114] = "KEY_IN_COMPOSITION", i[i.ABNT_C1 = 115] = "ABNT_C1", i[i.ABNT_C2 = 116] = "ABNT_C2", i[i.AudioVolumeMute = 117] = "AudioVolumeMute", i[i.AudioVolumeUp = 118] = "AudioVolumeUp", i[i.AudioVolumeDown = 119] = "AudioVolumeDown", i[i.BrowserSearch = 120] = "BrowserSearch", i[i.BrowserHome = 121] = "BrowserHome", i[i.BrowserBack = 122] = "BrowserBack", i[i.BrowserForward = 123] = "BrowserForward", i[i.MediaTrackNext = 124] = "MediaTrackNext", i[i.MediaTrackPrevious = 125] = "MediaTrackPrevious", i[i.MediaStop = 126] = "MediaStop", i[i.MediaPlayPause = 127] = "MediaPlayPause", i[i.LaunchMediaPlayer = 128] = "LaunchMediaPlayer", i[i.LaunchMail = 129] = "LaunchMail", i[i.LaunchApp2 = 130] = "LaunchApp2", i[i.Clear = 131] = "Clear", i[i.MAX_VALUE = 132] = "MAX_VALUE";
})(PR || (PR = {}));
var OR;
(function(i) {
  i[i.Hint = 1] = "Hint", i[i.Info = 2] = "Info", i[i.Warning = 4] = "Warning", i[i.Error = 8] = "Error";
})(OR || (OR = {}));
var MR;
(function(i) {
  i[i.Unnecessary = 1] = "Unnecessary", i[i.Deprecated = 2] = "Deprecated";
})(MR || (MR = {}));
var RR;
(function(i) {
  i[i.Inline = 1] = "Inline", i[i.Gutter = 2] = "Gutter";
})(RR || (RR = {}));
var FR;
(function(i) {
  i[i.UNKNOWN = 0] = "UNKNOWN", i[i.TEXTAREA = 1] = "TEXTAREA", i[i.GUTTER_GLYPH_MARGIN = 2] = "GUTTER_GLYPH_MARGIN", i[i.GUTTER_LINE_NUMBERS = 3] = "GUTTER_LINE_NUMBERS", i[i.GUTTER_LINE_DECORATIONS = 4] = "GUTTER_LINE_DECORATIONS", i[i.GUTTER_VIEW_ZONE = 5] = "GUTTER_VIEW_ZONE", i[i.CONTENT_TEXT = 6] = "CONTENT_TEXT", i[i.CONTENT_EMPTY = 7] = "CONTENT_EMPTY", i[i.CONTENT_VIEW_ZONE = 8] = "CONTENT_VIEW_ZONE", i[i.CONTENT_WIDGET = 9] = "CONTENT_WIDGET", i[i.OVERVIEW_RULER = 10] = "OVERVIEW_RULER", i[i.SCROLLBAR = 11] = "SCROLLBAR", i[i.OVERLAY_WIDGET = 12] = "OVERLAY_WIDGET", i[i.OUTSIDE_EDITOR = 13] = "OUTSIDE_EDITOR";
})(FR || (FR = {}));
var BR;
(function(i) {
  i[i.TOP_RIGHT_CORNER = 0] = "TOP_RIGHT_CORNER", i[i.BOTTOM_RIGHT_CORNER = 1] = "BOTTOM_RIGHT_CORNER", i[i.TOP_CENTER = 2] = "TOP_CENTER";
})(BR || (BR = {}));
var VR;
(function(i) {
  i[i.Left = 1] = "Left", i[i.Center = 2] = "Center", i[i.Right = 4] = "Right", i[i.Full = 7] = "Full";
})(VR || (VR = {}));
var HR;
(function(i) {
  i[i.Left = 0] = "Left", i[i.Right = 1] = "Right", i[i.None = 2] = "None", i[i.LeftOfInjectedText = 3] = "LeftOfInjectedText", i[i.RightOfInjectedText = 4] = "RightOfInjectedText";
})(HR || (HR = {}));
var WR;
(function(i) {
  i[i.Off = 0] = "Off", i[i.On = 1] = "On", i[i.Relative = 2] = "Relative", i[i.Interval = 3] = "Interval", i[i.Custom = 4] = "Custom";
})(WR || (WR = {}));
var jR;
(function(i) {
  i[i.None = 0] = "None", i[i.Text = 1] = "Text", i[i.Blocks = 2] = "Blocks";
})(jR || (jR = {}));
var zR;
(function(i) {
  i[i.Smooth = 0] = "Smooth", i[i.Immediate = 1] = "Immediate";
})(zR || (zR = {}));
var UR;
(function(i) {
  i[i.Auto = 1] = "Auto", i[i.Hidden = 2] = "Hidden", i[i.Visible = 3] = "Visible";
})(UR || (UR = {}));
var GR;
(function(i) {
  i[i.LTR = 0] = "LTR", i[i.RTL = 1] = "RTL";
})(GR || (GR = {}));
var qR;
(function(i) {
  i[i.Invoke = 1] = "Invoke", i[i.TriggerCharacter = 2] = "TriggerCharacter", i[i.ContentChange = 3] = "ContentChange";
})(qR || (qR = {}));
var KR;
(function(i) {
  i[i.File = 0] = "File", i[i.Module = 1] = "Module", i[i.Namespace = 2] = "Namespace", i[i.Package = 3] = "Package", i[i.Class = 4] = "Class", i[i.Method = 5] = "Method", i[i.Property = 6] = "Property", i[i.Field = 7] = "Field", i[i.Constructor = 8] = "Constructor", i[i.Enum = 9] = "Enum", i[i.Interface = 10] = "Interface", i[i.Function = 11] = "Function", i[i.Variable = 12] = "Variable", i[i.Constant = 13] = "Constant", i[i.String = 14] = "String", i[i.Number = 15] = "Number", i[i.Boolean = 16] = "Boolean", i[i.Array = 17] = "Array", i[i.Object = 18] = "Object", i[i.Key = 19] = "Key", i[i.Null = 20] = "Null", i[i.EnumMember = 21] = "EnumMember", i[i.Struct = 22] = "Struct", i[i.Event = 23] = "Event", i[i.Operator = 24] = "Operator", i[i.TypeParameter = 25] = "TypeParameter";
})(KR || (KR = {}));
var YR;
(function(i) {
  i[i.Deprecated = 1] = "Deprecated";
})(YR || (YR = {}));
var XR;
(function(i) {
  i[i.Hidden = 0] = "Hidden", i[i.Blink = 1] = "Blink", i[i.Smooth = 2] = "Smooth", i[i.Phase = 3] = "Phase", i[i.Expand = 4] = "Expand", i[i.Solid = 5] = "Solid";
})(XR || (XR = {}));
var ZR;
(function(i) {
  i[i.Line = 1] = "Line", i[i.Block = 2] = "Block", i[i.Underline = 3] = "Underline", i[i.LineThin = 4] = "LineThin", i[i.BlockOutline = 5] = "BlockOutline", i[i.UnderlineThin = 6] = "UnderlineThin";
})(ZR || (ZR = {}));
var QR;
(function(i) {
  i[i.AlwaysGrowsWhenTypingAtEdges = 0] = "AlwaysGrowsWhenTypingAtEdges", i[i.NeverGrowsWhenTypingAtEdges = 1] = "NeverGrowsWhenTypingAtEdges", i[i.GrowsOnlyWhenTypingBefore = 2] = "GrowsOnlyWhenTypingBefore", i[i.GrowsOnlyWhenTypingAfter = 3] = "GrowsOnlyWhenTypingAfter";
})(QR || (QR = {}));
var JR;
(function(i) {
  i[i.None = 0] = "None", i[i.Same = 1] = "Same", i[i.Indent = 2] = "Indent", i[i.DeepIndent = 3] = "DeepIndent";
})(JR || (JR = {}));
let _S = class {
  static chord(e, t) {
    return xr(e, t);
  }
};
_S.CtrlCmd = 2048;
_S.Shift = 1024;
_S.Alt = 512;
_S.WinCtrl = 256;
function che() {
  return {
    editor: void 0,
    // undefined override expected here
    languages: void 0,
    // undefined override expected here
    CancellationTokenSource: lr,
    Emitter: pe,
    KeyCode: PR,
    KeyMod: _S,
    Position: ve,
    Range: V,
    Selection: ot,
    SelectionDirection: GR,
    MarkerSeverity: OR,
    MarkerTag: MR,
    Uri: pt,
    Token: wy
  };
}
class hNe {
  constructor(e) {
    this.fn = e, this.lastCache = void 0, this.lastArgKey = void 0;
  }
  get(e) {
    const t = JSON.stringify(e);
    return this.lastArgKey !== t && (this.lastArgKey = t, this.lastCache = this.fn(e)), this.lastCache;
  }
}
class $Y {
  get cachedValues() {
    return this._map;
  }
  constructor(e) {
    this.fn = e, this._map = /* @__PURE__ */ new Map();
  }
  get(e) {
    if (this._map.has(e))
      return this._map.get(e);
    const t = this.fn(e);
    return this._map.set(e, t), t;
  }
}
class lp {
  constructor(e) {
    this.executor = e, this._didRun = !1;
  }
  /**
   * Get the wrapped value.
   *
   * This will force evaluation of the lazy value if it has not been resolved yet. Lazy values are only
   * resolved once. `getValue` will re-throw exceptions that are hit while resolving the value
   */
  get value() {
    if (!this._didRun)
      try {
        this._value = this.executor();
      } catch (e) {
        this._error = e;
      } finally {
        this._didRun = !0;
      }
    if (this._error)
      throw this._error;
    return this._value;
  }
  /**
   * Get the wrapped value without forcing evaluation.
   */
  get rawValue() {
    return this._value;
  }
}
var d_;
function dhe(i) {
  return !i || typeof i != "string" ? !0 : i.trim().length === 0;
}
const fNe = /{(\d+)}/g;
function zm(i, ...e) {
  return e.length === 0 ? i : i.replace(fNe, function(t, n) {
    const r = parseInt(n, 10);
    return isNaN(r) || r < 0 || r >= e.length ? t : e[r];
  });
}
function KE(i) {
  return i.replace(/[<>&]/g, function(e) {
    switch (e) {
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case "&":
        return "&amp;";
      default:
        return e;
    }
  });
}
function Va(i) {
  return i.replace(/[\\\{\}\*\+\?\|\^\$\.\[\]\(\)]/g, "\\$&");
}
function gNe(i, e = " ") {
  const t = bS(i, e);
  return uhe(t, e);
}
function bS(i, e) {
  if (!i || !e)
    return i;
  const t = e.length;
  if (t === 0 || i.length === 0)
    return i;
  let n = 0;
  for (; i.indexOf(e, n) === n; )
    n = n + t;
  return i.substring(n);
}
function uhe(i, e) {
  if (!i || !e)
    return i;
  const t = e.length, n = i.length;
  if (t === 0 || n === 0)
    return i;
  let r = n, s = -1;
  for (; s = i.lastIndexOf(e, r - 1), !(s === -1 || s + t !== r); ) {
    if (s === 0)
      return "";
    r = s;
  }
  return i.substring(0, r);
}
function pNe(i) {
  return i.replace(/[\-\\\{\}\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&").replace(/[\*]/g, ".*");
}
function mNe(i) {
  return i.replace(/\*/g, "");
}
function hhe(i, e, t = {}) {
  if (!i)
    throw new Error("Cannot create regex from empty string");
  e || (i = Va(i)), t.wholeWord && (/\B/.test(i.charAt(0)) || (i = "\\b" + i), /\B/.test(i.charAt(i.length - 1)) || (i = i + "\\b"));
  let n = "";
  return t.global && (n += "g"), t.matchCase || (n += "i"), t.multiline && (n += "m"), t.unicode && (n += "u"), new RegExp(i, n);
}
function vNe(i) {
  return i.source === "^" || i.source === "^$" || i.source === "$" || i.source === "^\\s*$" ? !1 : !!(i.exec("") && i.lastIndex === 0);
}
function Cu(i) {
  return i.split(/\r\n|\r|\n/);
}
function Js(i) {
  for (let e = 0, t = i.length; e < t; e++) {
    const n = i.charCodeAt(e);
    if (n !== 32 && n !== 9)
      return e;
  }
  return -1;
}
function Hn(i, e = 0, t = i.length) {
  for (let n = e; n < t; n++) {
    const r = i.charCodeAt(n);
    if (r !== 32 && r !== 9)
      return i.substring(e, n);
  }
  return i.substring(e, t);
}
function Jc(i, e = i.length - 1) {
  for (let t = e; t >= 0; t--) {
    const n = i.charCodeAt(t);
    if (n !== 32 && n !== 9)
      return t;
  }
  return -1;
}
function Dy(i, e) {
  return i < e ? -1 : i > e ? 1 : 0;
}
function Fj(i, e, t = 0, n = i.length, r = 0, s = e.length) {
  for (; t < n && r < s; t++, r++) {
    const l = i.charCodeAt(t), c = e.charCodeAt(r);
    if (l < c)
      return -1;
    if (l > c)
      return 1;
  }
  const o = n - t, a = s - r;
  return o < a ? -1 : o > a ? 1 : 0;
}
function $R(i, e) {
  return CS(i, e, 0, i.length, 0, e.length);
}
function CS(i, e, t = 0, n = i.length, r = 0, s = e.length) {
  for (; t < n && r < s; t++, r++) {
    let l = i.charCodeAt(t), c = e.charCodeAt(r);
    if (l === c)
      continue;
    if (l >= 128 || c >= 128)
      return Fj(i.toLowerCase(), e.toLowerCase(), t, n, r, s);
    Xf(l) && (l -= 32), Xf(c) && (c -= 32);
    const d = l - c;
    if (d !== 0)
      return d;
  }
  const o = n - t, a = s - r;
  return o < a ? -1 : o > a ? 1 : 0;
}
function Fx(i) {
  return i >= 48 && i <= 57;
}
function Xf(i) {
  return i >= 97 && i <= 122;
}
function Od(i) {
  return i >= 65 && i <= 90;
}
function K1(i, e) {
  return i.length === e.length && CS(i, e) === 0;
}
function Bj(i, e) {
  const t = e.length;
  return e.length > i.length ? !1 : CS(i, e, 0, t) === 0;
}
function Um(i, e) {
  const t = Math.min(i.length, e.length);
  let n;
  for (n = 0; n < t; n++)
    if (i.charCodeAt(n) !== e.charCodeAt(n))
      return n;
  return t;
}
function YE(i, e) {
  const t = Math.min(i.length, e.length);
  let n;
  const r = i.length - 1, s = e.length - 1;
  for (n = 0; n < t; n++)
    if (i.charCodeAt(r - n) !== e.charCodeAt(s - n))
      return n;
  return t;
}
function kr(i) {
  return 55296 <= i && i <= 56319;
}
function Gm(i) {
  return 56320 <= i && i <= 57343;
}
function Vj(i, e) {
  return (i - 55296 << 10) + (e - 56320) + 65536;
}
function XE(i, e, t) {
  const n = i.charCodeAt(t);
  if (kr(n) && t + 1 < e) {
    const r = i.charCodeAt(t + 1);
    if (Gm(r))
      return Vj(n, r);
  }
  return n;
}
function _Ne(i, e) {
  const t = i.charCodeAt(e - 1);
  if (Gm(t) && e > 1) {
    const n = i.charCodeAt(e - 2);
    if (kr(n))
      return Vj(n, t);
  }
  return t;
}
class Hj {
  get offset() {
    return this._offset;
  }
  constructor(e, t = 0) {
    this._str = e, this._len = e.length, this._offset = t;
  }
  setOffset(e) {
    this._offset = e;
  }
  prevCodePoint() {
    const e = _Ne(this._str, this._offset);
    return this._offset -= e >= 65536 ? 2 : 1, e;
  }
  nextCodePoint() {
    const e = XE(this._str, this._len, this._offset);
    return this._offset += e >= 65536 ? 2 : 1, e;
  }
  eol() {
    return this._offset >= this._len;
  }
}
class ZE {
  get offset() {
    return this._iterator.offset;
  }
  constructor(e, t = 0) {
    this._iterator = new Hj(e, t);
  }
  nextGraphemeLength() {
    const e = Zf.getInstance(), t = this._iterator, n = t.offset;
    let r = e.getGraphemeBreakType(t.nextCodePoint());
    for (; !t.eol(); ) {
      const s = t.offset, o = e.getGraphemeBreakType(t.nextCodePoint());
      if (eX(r, o)) {
        t.setOffset(s);
        break;
      }
      r = o;
    }
    return t.offset - n;
  }
  prevGraphemeLength() {
    const e = Zf.getInstance(), t = this._iterator, n = t.offset;
    let r = e.getGraphemeBreakType(t.prevCodePoint());
    for (; t.offset > 0; ) {
      const s = t.offset, o = e.getGraphemeBreakType(t.prevCodePoint());
      if (eX(o, r)) {
        t.setOffset(s);
        break;
      }
      r = o;
    }
    return n - t.offset;
  }
  eol() {
    return this._iterator.eol();
  }
}
function Wj(i, e) {
  return new ZE(i, e).nextGraphemeLength();
}
function fhe(i, e) {
  return new ZE(i, e).prevGraphemeLength();
}
function bNe(i, e) {
  e > 0 && Gm(i.charCodeAt(e)) && e--;
  const t = e + Wj(i, e);
  return [t - fhe(i, t), t];
}
let $k;
function CNe() {
  return /(?:[\u05BE\u05C0\u05C3\u05C6\u05D0-\u05F4\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u0710\u0712-\u072F\u074D-\u07A5\u07B1-\u07EA\u07F4\u07F5\u07FA\u07FE-\u0815\u081A\u0824\u0828\u0830-\u0858\u085E-\u088E\u08A0-\u08C9\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFD3D\uFD50-\uFDC7\uFDF0-\uFDFC\uFE70-\uFEFC]|\uD802[\uDC00-\uDD1B\uDD20-\uDE00\uDE10-\uDE35\uDE40-\uDEE4\uDEEB-\uDF35\uDF40-\uDFFF]|\uD803[\uDC00-\uDD23\uDE80-\uDEA9\uDEAD-\uDF45\uDF51-\uDF81\uDF86-\uDFF6]|\uD83A[\uDC00-\uDCCF\uDD00-\uDD43\uDD4B-\uDFFF]|\uD83B[\uDC00-\uDEBB])/;
}
function u_(i) {
  return $k || ($k = CNe()), $k.test(i);
}
const yNe = /^[\t\n\r\x20-\x7E]*$/;
function yS(i) {
  return yNe.test(i);
}
const ghe = /[\u2028\u2029]/;
function phe(i) {
  return ghe.test(i);
}
function Pg(i) {
  return i >= 11904 && i <= 55215 || i >= 63744 && i <= 64255 || i >= 65281 && i <= 65374;
}
function jj(i) {
  return i >= 127462 && i <= 127487 || i === 8986 || i === 8987 || i === 9200 || i === 9203 || i >= 9728 && i <= 10175 || i === 11088 || i === 11093 || i >= 127744 && i <= 128591 || i >= 128640 && i <= 128764 || i >= 128992 && i <= 129008 || i >= 129280 && i <= 129535 || i >= 129648 && i <= 129782;
}
const wNe = "\uFEFF";
function zj(i) {
  return !!(i && i.length > 0 && i.charCodeAt(0) === 65279);
}
function SNe(i, e = !1) {
  return i ? (e && (i = i.replace(/\\./g, "")), i.toLowerCase() !== i) : !1;
}
function mhe(i) {
  return i = i % (2 * 26), i < 26 ? String.fromCharCode(97 + i) : String.fromCharCode(65 + i - 26);
}
function eX(i, e) {
  return i === 0 ? e !== 5 && e !== 7 : i === 2 && e === 3 ? !1 : i === 4 || i === 2 || i === 3 || e === 4 || e === 2 || e === 3 ? !0 : !(i === 8 && (e === 8 || e === 9 || e === 11 || e === 12) || (i === 11 || i === 9) && (e === 9 || e === 10) || (i === 12 || i === 10) && e === 10 || e === 5 || e === 13 || e === 7 || i === 1 || i === 13 && e === 14 || i === 6 && e === 6);
}
class Zf {
  static getInstance() {
    return Zf._INSTANCE || (Zf._INSTANCE = new Zf()), Zf._INSTANCE;
  }
  constructor() {
    this._data = xNe();
  }
  getGraphemeBreakType(e) {
    if (e < 32)
      return e === 10 ? 3 : e === 13 ? 2 : 4;
    if (e < 127)
      return 0;
    const t = this._data, n = t.length / 3;
    let r = 1;
    for (; r <= n; )
      if (e < t[3 * r])
        r = 2 * r;
      else if (e > t[3 * r + 1])
        r = 2 * r + 1;
      else
        return t[3 * r + 2];
    return 0;
  }
}
Zf._INSTANCE = null;
function xNe() {
  return JSON.parse("[0,0,0,51229,51255,12,44061,44087,12,127462,127487,6,7083,7085,5,47645,47671,12,54813,54839,12,128678,128678,14,3270,3270,5,9919,9923,14,45853,45879,12,49437,49463,12,53021,53047,12,71216,71218,7,128398,128399,14,129360,129374,14,2519,2519,5,4448,4519,9,9742,9742,14,12336,12336,14,44957,44983,12,46749,46775,12,48541,48567,12,50333,50359,12,52125,52151,12,53917,53943,12,69888,69890,5,73018,73018,5,127990,127990,14,128558,128559,14,128759,128760,14,129653,129655,14,2027,2035,5,2891,2892,7,3761,3761,5,6683,6683,5,8293,8293,4,9825,9826,14,9999,9999,14,43452,43453,5,44509,44535,12,45405,45431,12,46301,46327,12,47197,47223,12,48093,48119,12,48989,49015,12,49885,49911,12,50781,50807,12,51677,51703,12,52573,52599,12,53469,53495,12,54365,54391,12,65279,65279,4,70471,70472,7,72145,72147,7,119173,119179,5,127799,127818,14,128240,128244,14,128512,128512,14,128652,128652,14,128721,128722,14,129292,129292,14,129445,129450,14,129734,129743,14,1476,1477,5,2366,2368,7,2750,2752,7,3076,3076,5,3415,3415,5,4141,4144,5,6109,6109,5,6964,6964,5,7394,7400,5,9197,9198,14,9770,9770,14,9877,9877,14,9968,9969,14,10084,10084,14,43052,43052,5,43713,43713,5,44285,44311,12,44733,44759,12,45181,45207,12,45629,45655,12,46077,46103,12,46525,46551,12,46973,46999,12,47421,47447,12,47869,47895,12,48317,48343,12,48765,48791,12,49213,49239,12,49661,49687,12,50109,50135,12,50557,50583,12,51005,51031,12,51453,51479,12,51901,51927,12,52349,52375,12,52797,52823,12,53245,53271,12,53693,53719,12,54141,54167,12,54589,54615,12,55037,55063,12,69506,69509,5,70191,70193,5,70841,70841,7,71463,71467,5,72330,72342,5,94031,94031,5,123628,123631,5,127763,127765,14,127941,127941,14,128043,128062,14,128302,128317,14,128465,128467,14,128539,128539,14,128640,128640,14,128662,128662,14,128703,128703,14,128745,128745,14,129004,129007,14,129329,129330,14,129402,129402,14,129483,129483,14,129686,129704,14,130048,131069,14,173,173,4,1757,1757,1,2200,2207,5,2434,2435,7,2631,2632,5,2817,2817,5,3008,3008,5,3201,3201,5,3387,3388,5,3542,3542,5,3902,3903,7,4190,4192,5,6002,6003,5,6439,6440,5,6765,6770,7,7019,7027,5,7154,7155,7,8205,8205,13,8505,8505,14,9654,9654,14,9757,9757,14,9792,9792,14,9852,9853,14,9890,9894,14,9937,9937,14,9981,9981,14,10035,10036,14,11035,11036,14,42654,42655,5,43346,43347,7,43587,43587,5,44006,44007,7,44173,44199,12,44397,44423,12,44621,44647,12,44845,44871,12,45069,45095,12,45293,45319,12,45517,45543,12,45741,45767,12,45965,45991,12,46189,46215,12,46413,46439,12,46637,46663,12,46861,46887,12,47085,47111,12,47309,47335,12,47533,47559,12,47757,47783,12,47981,48007,12,48205,48231,12,48429,48455,12,48653,48679,12,48877,48903,12,49101,49127,12,49325,49351,12,49549,49575,12,49773,49799,12,49997,50023,12,50221,50247,12,50445,50471,12,50669,50695,12,50893,50919,12,51117,51143,12,51341,51367,12,51565,51591,12,51789,51815,12,52013,52039,12,52237,52263,12,52461,52487,12,52685,52711,12,52909,52935,12,53133,53159,12,53357,53383,12,53581,53607,12,53805,53831,12,54029,54055,12,54253,54279,12,54477,54503,12,54701,54727,12,54925,54951,12,55149,55175,12,68101,68102,5,69762,69762,7,70067,70069,7,70371,70378,5,70720,70721,7,71087,71087,5,71341,71341,5,71995,71996,5,72249,72249,7,72850,72871,5,73109,73109,5,118576,118598,5,121505,121519,5,127245,127247,14,127568,127569,14,127777,127777,14,127872,127891,14,127956,127967,14,128015,128016,14,128110,128172,14,128259,128259,14,128367,128368,14,128424,128424,14,128488,128488,14,128530,128532,14,128550,128551,14,128566,128566,14,128647,128647,14,128656,128656,14,128667,128673,14,128691,128693,14,128715,128715,14,128728,128732,14,128752,128752,14,128765,128767,14,129096,129103,14,129311,129311,14,129344,129349,14,129394,129394,14,129413,129425,14,129466,129471,14,129511,129535,14,129664,129666,14,129719,129722,14,129760,129767,14,917536,917631,5,13,13,2,1160,1161,5,1564,1564,4,1807,1807,1,2085,2087,5,2307,2307,7,2382,2383,7,2497,2500,5,2563,2563,7,2677,2677,5,2763,2764,7,2879,2879,5,2914,2915,5,3021,3021,5,3142,3144,5,3263,3263,5,3285,3286,5,3398,3400,7,3530,3530,5,3633,3633,5,3864,3865,5,3974,3975,5,4155,4156,7,4229,4230,5,5909,5909,7,6078,6085,7,6277,6278,5,6451,6456,7,6744,6750,5,6846,6846,5,6972,6972,5,7074,7077,5,7146,7148,7,7222,7223,5,7416,7417,5,8234,8238,4,8417,8417,5,9000,9000,14,9203,9203,14,9730,9731,14,9748,9749,14,9762,9763,14,9776,9783,14,9800,9811,14,9831,9831,14,9872,9873,14,9882,9882,14,9900,9903,14,9929,9933,14,9941,9960,14,9974,9974,14,9989,9989,14,10006,10006,14,10062,10062,14,10160,10160,14,11647,11647,5,12953,12953,14,43019,43019,5,43232,43249,5,43443,43443,5,43567,43568,7,43696,43696,5,43765,43765,7,44013,44013,5,44117,44143,12,44229,44255,12,44341,44367,12,44453,44479,12,44565,44591,12,44677,44703,12,44789,44815,12,44901,44927,12,45013,45039,12,45125,45151,12,45237,45263,12,45349,45375,12,45461,45487,12,45573,45599,12,45685,45711,12,45797,45823,12,45909,45935,12,46021,46047,12,46133,46159,12,46245,46271,12,46357,46383,12,46469,46495,12,46581,46607,12,46693,46719,12,46805,46831,12,46917,46943,12,47029,47055,12,47141,47167,12,47253,47279,12,47365,47391,12,47477,47503,12,47589,47615,12,47701,47727,12,47813,47839,12,47925,47951,12,48037,48063,12,48149,48175,12,48261,48287,12,48373,48399,12,48485,48511,12,48597,48623,12,48709,48735,12,48821,48847,12,48933,48959,12,49045,49071,12,49157,49183,12,49269,49295,12,49381,49407,12,49493,49519,12,49605,49631,12,49717,49743,12,49829,49855,12,49941,49967,12,50053,50079,12,50165,50191,12,50277,50303,12,50389,50415,12,50501,50527,12,50613,50639,12,50725,50751,12,50837,50863,12,50949,50975,12,51061,51087,12,51173,51199,12,51285,51311,12,51397,51423,12,51509,51535,12,51621,51647,12,51733,51759,12,51845,51871,12,51957,51983,12,52069,52095,12,52181,52207,12,52293,52319,12,52405,52431,12,52517,52543,12,52629,52655,12,52741,52767,12,52853,52879,12,52965,52991,12,53077,53103,12,53189,53215,12,53301,53327,12,53413,53439,12,53525,53551,12,53637,53663,12,53749,53775,12,53861,53887,12,53973,53999,12,54085,54111,12,54197,54223,12,54309,54335,12,54421,54447,12,54533,54559,12,54645,54671,12,54757,54783,12,54869,54895,12,54981,55007,12,55093,55119,12,55243,55291,10,66045,66045,5,68325,68326,5,69688,69702,5,69817,69818,5,69957,69958,7,70089,70092,5,70198,70199,5,70462,70462,5,70502,70508,5,70750,70750,5,70846,70846,7,71100,71101,5,71230,71230,7,71351,71351,5,71737,71738,5,72000,72000,7,72160,72160,5,72273,72278,5,72752,72758,5,72882,72883,5,73031,73031,5,73461,73462,7,94192,94193,7,119149,119149,7,121403,121452,5,122915,122916,5,126980,126980,14,127358,127359,14,127535,127535,14,127759,127759,14,127771,127771,14,127792,127793,14,127825,127867,14,127897,127899,14,127945,127945,14,127985,127986,14,128000,128007,14,128021,128021,14,128066,128100,14,128184,128235,14,128249,128252,14,128266,128276,14,128335,128335,14,128379,128390,14,128407,128419,14,128444,128444,14,128481,128481,14,128499,128499,14,128526,128526,14,128536,128536,14,128543,128543,14,128556,128556,14,128564,128564,14,128577,128580,14,128643,128645,14,128649,128649,14,128654,128654,14,128660,128660,14,128664,128664,14,128675,128675,14,128686,128689,14,128695,128696,14,128705,128709,14,128717,128719,14,128725,128725,14,128736,128741,14,128747,128748,14,128755,128755,14,128762,128762,14,128981,128991,14,129009,129023,14,129160,129167,14,129296,129304,14,129320,129327,14,129340,129342,14,129356,129356,14,129388,129392,14,129399,129400,14,129404,129407,14,129432,129442,14,129454,129455,14,129473,129474,14,129485,129487,14,129648,129651,14,129659,129660,14,129671,129679,14,129709,129711,14,129728,129730,14,129751,129753,14,129776,129782,14,917505,917505,4,917760,917999,5,10,10,3,127,159,4,768,879,5,1471,1471,5,1536,1541,1,1648,1648,5,1767,1768,5,1840,1866,5,2070,2073,5,2137,2139,5,2274,2274,1,2363,2363,7,2377,2380,7,2402,2403,5,2494,2494,5,2507,2508,7,2558,2558,5,2622,2624,7,2641,2641,5,2691,2691,7,2759,2760,5,2786,2787,5,2876,2876,5,2881,2884,5,2901,2902,5,3006,3006,5,3014,3016,7,3072,3072,5,3134,3136,5,3157,3158,5,3260,3260,5,3266,3266,5,3274,3275,7,3328,3329,5,3391,3392,7,3405,3405,5,3457,3457,5,3536,3537,7,3551,3551,5,3636,3642,5,3764,3772,5,3895,3895,5,3967,3967,7,3993,4028,5,4146,4151,5,4182,4183,7,4226,4226,5,4253,4253,5,4957,4959,5,5940,5940,7,6070,6070,7,6087,6088,7,6158,6158,4,6432,6434,5,6448,6449,7,6679,6680,5,6742,6742,5,6754,6754,5,6783,6783,5,6912,6915,5,6966,6970,5,6978,6978,5,7042,7042,7,7080,7081,5,7143,7143,7,7150,7150,7,7212,7219,5,7380,7392,5,7412,7412,5,8203,8203,4,8232,8232,4,8265,8265,14,8400,8412,5,8421,8432,5,8617,8618,14,9167,9167,14,9200,9200,14,9410,9410,14,9723,9726,14,9733,9733,14,9745,9745,14,9752,9752,14,9760,9760,14,9766,9766,14,9774,9774,14,9786,9786,14,9794,9794,14,9823,9823,14,9828,9828,14,9833,9850,14,9855,9855,14,9875,9875,14,9880,9880,14,9885,9887,14,9896,9897,14,9906,9916,14,9926,9927,14,9935,9935,14,9939,9939,14,9962,9962,14,9972,9972,14,9978,9978,14,9986,9986,14,9997,9997,14,10002,10002,14,10017,10017,14,10055,10055,14,10071,10071,14,10133,10135,14,10548,10549,14,11093,11093,14,12330,12333,5,12441,12442,5,42608,42610,5,43010,43010,5,43045,43046,5,43188,43203,7,43302,43309,5,43392,43394,5,43446,43449,5,43493,43493,5,43571,43572,7,43597,43597,7,43703,43704,5,43756,43757,5,44003,44004,7,44009,44010,7,44033,44059,12,44089,44115,12,44145,44171,12,44201,44227,12,44257,44283,12,44313,44339,12,44369,44395,12,44425,44451,12,44481,44507,12,44537,44563,12,44593,44619,12,44649,44675,12,44705,44731,12,44761,44787,12,44817,44843,12,44873,44899,12,44929,44955,12,44985,45011,12,45041,45067,12,45097,45123,12,45153,45179,12,45209,45235,12,45265,45291,12,45321,45347,12,45377,45403,12,45433,45459,12,45489,45515,12,45545,45571,12,45601,45627,12,45657,45683,12,45713,45739,12,45769,45795,12,45825,45851,12,45881,45907,12,45937,45963,12,45993,46019,12,46049,46075,12,46105,46131,12,46161,46187,12,46217,46243,12,46273,46299,12,46329,46355,12,46385,46411,12,46441,46467,12,46497,46523,12,46553,46579,12,46609,46635,12,46665,46691,12,46721,46747,12,46777,46803,12,46833,46859,12,46889,46915,12,46945,46971,12,47001,47027,12,47057,47083,12,47113,47139,12,47169,47195,12,47225,47251,12,47281,47307,12,47337,47363,12,47393,47419,12,47449,47475,12,47505,47531,12,47561,47587,12,47617,47643,12,47673,47699,12,47729,47755,12,47785,47811,12,47841,47867,12,47897,47923,12,47953,47979,12,48009,48035,12,48065,48091,12,48121,48147,12,48177,48203,12,48233,48259,12,48289,48315,12,48345,48371,12,48401,48427,12,48457,48483,12,48513,48539,12,48569,48595,12,48625,48651,12,48681,48707,12,48737,48763,12,48793,48819,12,48849,48875,12,48905,48931,12,48961,48987,12,49017,49043,12,49073,49099,12,49129,49155,12,49185,49211,12,49241,49267,12,49297,49323,12,49353,49379,12,49409,49435,12,49465,49491,12,49521,49547,12,49577,49603,12,49633,49659,12,49689,49715,12,49745,49771,12,49801,49827,12,49857,49883,12,49913,49939,12,49969,49995,12,50025,50051,12,50081,50107,12,50137,50163,12,50193,50219,12,50249,50275,12,50305,50331,12,50361,50387,12,50417,50443,12,50473,50499,12,50529,50555,12,50585,50611,12,50641,50667,12,50697,50723,12,50753,50779,12,50809,50835,12,50865,50891,12,50921,50947,12,50977,51003,12,51033,51059,12,51089,51115,12,51145,51171,12,51201,51227,12,51257,51283,12,51313,51339,12,51369,51395,12,51425,51451,12,51481,51507,12,51537,51563,12,51593,51619,12,51649,51675,12,51705,51731,12,51761,51787,12,51817,51843,12,51873,51899,12,51929,51955,12,51985,52011,12,52041,52067,12,52097,52123,12,52153,52179,12,52209,52235,12,52265,52291,12,52321,52347,12,52377,52403,12,52433,52459,12,52489,52515,12,52545,52571,12,52601,52627,12,52657,52683,12,52713,52739,12,52769,52795,12,52825,52851,12,52881,52907,12,52937,52963,12,52993,53019,12,53049,53075,12,53105,53131,12,53161,53187,12,53217,53243,12,53273,53299,12,53329,53355,12,53385,53411,12,53441,53467,12,53497,53523,12,53553,53579,12,53609,53635,12,53665,53691,12,53721,53747,12,53777,53803,12,53833,53859,12,53889,53915,12,53945,53971,12,54001,54027,12,54057,54083,12,54113,54139,12,54169,54195,12,54225,54251,12,54281,54307,12,54337,54363,12,54393,54419,12,54449,54475,12,54505,54531,12,54561,54587,12,54617,54643,12,54673,54699,12,54729,54755,12,54785,54811,12,54841,54867,12,54897,54923,12,54953,54979,12,55009,55035,12,55065,55091,12,55121,55147,12,55177,55203,12,65024,65039,5,65520,65528,4,66422,66426,5,68152,68154,5,69291,69292,5,69633,69633,5,69747,69748,5,69811,69814,5,69826,69826,5,69932,69932,7,70016,70017,5,70079,70080,7,70095,70095,5,70196,70196,5,70367,70367,5,70402,70403,7,70464,70464,5,70487,70487,5,70709,70711,7,70725,70725,7,70833,70834,7,70843,70844,7,70849,70849,7,71090,71093,5,71103,71104,5,71227,71228,7,71339,71339,5,71344,71349,5,71458,71461,5,71727,71735,5,71985,71989,7,71998,71998,5,72002,72002,7,72154,72155,5,72193,72202,5,72251,72254,5,72281,72283,5,72344,72345,5,72766,72766,7,72874,72880,5,72885,72886,5,73023,73029,5,73104,73105,5,73111,73111,5,92912,92916,5,94095,94098,5,113824,113827,4,119142,119142,7,119155,119162,4,119362,119364,5,121476,121476,5,122888,122904,5,123184,123190,5,125252,125258,5,127183,127183,14,127340,127343,14,127377,127386,14,127491,127503,14,127548,127551,14,127744,127756,14,127761,127761,14,127769,127769,14,127773,127774,14,127780,127788,14,127796,127797,14,127820,127823,14,127869,127869,14,127894,127895,14,127902,127903,14,127943,127943,14,127947,127950,14,127972,127972,14,127988,127988,14,127992,127994,14,128009,128011,14,128019,128019,14,128023,128041,14,128064,128064,14,128102,128107,14,128174,128181,14,128238,128238,14,128246,128247,14,128254,128254,14,128264,128264,14,128278,128299,14,128329,128330,14,128348,128359,14,128371,128377,14,128392,128393,14,128401,128404,14,128421,128421,14,128433,128434,14,128450,128452,14,128476,128478,14,128483,128483,14,128495,128495,14,128506,128506,14,128519,128520,14,128528,128528,14,128534,128534,14,128538,128538,14,128540,128542,14,128544,128549,14,128552,128555,14,128557,128557,14,128560,128563,14,128565,128565,14,128567,128576,14,128581,128591,14,128641,128642,14,128646,128646,14,128648,128648,14,128650,128651,14,128653,128653,14,128655,128655,14,128657,128659,14,128661,128661,14,128663,128663,14,128665,128666,14,128674,128674,14,128676,128677,14,128679,128685,14,128690,128690,14,128694,128694,14,128697,128702,14,128704,128704,14,128710,128714,14,128716,128716,14,128720,128720,14,128723,128724,14,128726,128727,14,128733,128735,14,128742,128744,14,128746,128746,14,128749,128751,14,128753,128754,14,128756,128758,14,128761,128761,14,128763,128764,14,128884,128895,14,128992,129003,14,129008,129008,14,129036,129039,14,129114,129119,14,129198,129279,14,129293,129295,14,129305,129310,14,129312,129319,14,129328,129328,14,129331,129338,14,129343,129343,14,129351,129355,14,129357,129359,14,129375,129387,14,129393,129393,14,129395,129398,14,129401,129401,14,129403,129403,14,129408,129412,14,129426,129431,14,129443,129444,14,129451,129453,14,129456,129465,14,129472,129472,14,129475,129482,14,129484,129484,14,129488,129510,14,129536,129647,14,129652,129652,14,129656,129658,14,129661,129663,14,129667,129670,14,129680,129685,14,129705,129708,14,129712,129718,14,129723,129727,14,129731,129733,14,129744,129750,14,129754,129759,14,129768,129775,14,129783,129791,14,917504,917504,4,917506,917535,4,917632,917759,4,918000,921599,4,0,9,4,11,12,4,14,31,4,169,169,14,174,174,14,1155,1159,5,1425,1469,5,1473,1474,5,1479,1479,5,1552,1562,5,1611,1631,5,1750,1756,5,1759,1764,5,1770,1773,5,1809,1809,5,1958,1968,5,2045,2045,5,2075,2083,5,2089,2093,5,2192,2193,1,2250,2273,5,2275,2306,5,2362,2362,5,2364,2364,5,2369,2376,5,2381,2381,5,2385,2391,5,2433,2433,5,2492,2492,5,2495,2496,7,2503,2504,7,2509,2509,5,2530,2531,5,2561,2562,5,2620,2620,5,2625,2626,5,2635,2637,5,2672,2673,5,2689,2690,5,2748,2748,5,2753,2757,5,2761,2761,7,2765,2765,5,2810,2815,5,2818,2819,7,2878,2878,5,2880,2880,7,2887,2888,7,2893,2893,5,2903,2903,5,2946,2946,5,3007,3007,7,3009,3010,7,3018,3020,7,3031,3031,5,3073,3075,7,3132,3132,5,3137,3140,7,3146,3149,5,3170,3171,5,3202,3203,7,3262,3262,7,3264,3265,7,3267,3268,7,3271,3272,7,3276,3277,5,3298,3299,5,3330,3331,7,3390,3390,5,3393,3396,5,3402,3404,7,3406,3406,1,3426,3427,5,3458,3459,7,3535,3535,5,3538,3540,5,3544,3550,7,3570,3571,7,3635,3635,7,3655,3662,5,3763,3763,7,3784,3789,5,3893,3893,5,3897,3897,5,3953,3966,5,3968,3972,5,3981,3991,5,4038,4038,5,4145,4145,7,4153,4154,5,4157,4158,5,4184,4185,5,4209,4212,5,4228,4228,7,4237,4237,5,4352,4447,8,4520,4607,10,5906,5908,5,5938,5939,5,5970,5971,5,6068,6069,5,6071,6077,5,6086,6086,5,6089,6099,5,6155,6157,5,6159,6159,5,6313,6313,5,6435,6438,7,6441,6443,7,6450,6450,5,6457,6459,5,6681,6682,7,6741,6741,7,6743,6743,7,6752,6752,5,6757,6764,5,6771,6780,5,6832,6845,5,6847,6862,5,6916,6916,7,6965,6965,5,6971,6971,7,6973,6977,7,6979,6980,7,7040,7041,5,7073,7073,7,7078,7079,7,7082,7082,7,7142,7142,5,7144,7145,5,7149,7149,5,7151,7153,5,7204,7211,7,7220,7221,7,7376,7378,5,7393,7393,7,7405,7405,5,7415,7415,7,7616,7679,5,8204,8204,5,8206,8207,4,8233,8233,4,8252,8252,14,8288,8292,4,8294,8303,4,8413,8416,5,8418,8420,5,8482,8482,14,8596,8601,14,8986,8987,14,9096,9096,14,9193,9196,14,9199,9199,14,9201,9202,14,9208,9210,14,9642,9643,14,9664,9664,14,9728,9729,14,9732,9732,14,9735,9741,14,9743,9744,14,9746,9746,14,9750,9751,14,9753,9756,14,9758,9759,14,9761,9761,14,9764,9765,14,9767,9769,14,9771,9773,14,9775,9775,14,9784,9785,14,9787,9791,14,9793,9793,14,9795,9799,14,9812,9822,14,9824,9824,14,9827,9827,14,9829,9830,14,9832,9832,14,9851,9851,14,9854,9854,14,9856,9861,14,9874,9874,14,9876,9876,14,9878,9879,14,9881,9881,14,9883,9884,14,9888,9889,14,9895,9895,14,9898,9899,14,9904,9905,14,9917,9918,14,9924,9925,14,9928,9928,14,9934,9934,14,9936,9936,14,9938,9938,14,9940,9940,14,9961,9961,14,9963,9967,14,9970,9971,14,9973,9973,14,9975,9977,14,9979,9980,14,9982,9985,14,9987,9988,14,9992,9996,14,9998,9998,14,10000,10001,14,10004,10004,14,10013,10013,14,10024,10024,14,10052,10052,14,10060,10060,14,10067,10069,14,10083,10083,14,10085,10087,14,10145,10145,14,10175,10175,14,11013,11015,14,11088,11088,14,11503,11505,5,11744,11775,5,12334,12335,5,12349,12349,14,12951,12951,14,42607,42607,5,42612,42621,5,42736,42737,5,43014,43014,5,43043,43044,7,43047,43047,7,43136,43137,7,43204,43205,5,43263,43263,5,43335,43345,5,43360,43388,8,43395,43395,7,43444,43445,7,43450,43451,7,43454,43456,7,43561,43566,5,43569,43570,5,43573,43574,5,43596,43596,5,43644,43644,5,43698,43700,5,43710,43711,5,43755,43755,7,43758,43759,7,43766,43766,5,44005,44005,5,44008,44008,5,44012,44012,7,44032,44032,11,44060,44060,11,44088,44088,11,44116,44116,11,44144,44144,11,44172,44172,11,44200,44200,11,44228,44228,11,44256,44256,11,44284,44284,11,44312,44312,11,44340,44340,11,44368,44368,11,44396,44396,11,44424,44424,11,44452,44452,11,44480,44480,11,44508,44508,11,44536,44536,11,44564,44564,11,44592,44592,11,44620,44620,11,44648,44648,11,44676,44676,11,44704,44704,11,44732,44732,11,44760,44760,11,44788,44788,11,44816,44816,11,44844,44844,11,44872,44872,11,44900,44900,11,44928,44928,11,44956,44956,11,44984,44984,11,45012,45012,11,45040,45040,11,45068,45068,11,45096,45096,11,45124,45124,11,45152,45152,11,45180,45180,11,45208,45208,11,45236,45236,11,45264,45264,11,45292,45292,11,45320,45320,11,45348,45348,11,45376,45376,11,45404,45404,11,45432,45432,11,45460,45460,11,45488,45488,11,45516,45516,11,45544,45544,11,45572,45572,11,45600,45600,11,45628,45628,11,45656,45656,11,45684,45684,11,45712,45712,11,45740,45740,11,45768,45768,11,45796,45796,11,45824,45824,11,45852,45852,11,45880,45880,11,45908,45908,11,45936,45936,11,45964,45964,11,45992,45992,11,46020,46020,11,46048,46048,11,46076,46076,11,46104,46104,11,46132,46132,11,46160,46160,11,46188,46188,11,46216,46216,11,46244,46244,11,46272,46272,11,46300,46300,11,46328,46328,11,46356,46356,11,46384,46384,11,46412,46412,11,46440,46440,11,46468,46468,11,46496,46496,11,46524,46524,11,46552,46552,11,46580,46580,11,46608,46608,11,46636,46636,11,46664,46664,11,46692,46692,11,46720,46720,11,46748,46748,11,46776,46776,11,46804,46804,11,46832,46832,11,46860,46860,11,46888,46888,11,46916,46916,11,46944,46944,11,46972,46972,11,47000,47000,11,47028,47028,11,47056,47056,11,47084,47084,11,47112,47112,11,47140,47140,11,47168,47168,11,47196,47196,11,47224,47224,11,47252,47252,11,47280,47280,11,47308,47308,11,47336,47336,11,47364,47364,11,47392,47392,11,47420,47420,11,47448,47448,11,47476,47476,11,47504,47504,11,47532,47532,11,47560,47560,11,47588,47588,11,47616,47616,11,47644,47644,11,47672,47672,11,47700,47700,11,47728,47728,11,47756,47756,11,47784,47784,11,47812,47812,11,47840,47840,11,47868,47868,11,47896,47896,11,47924,47924,11,47952,47952,11,47980,47980,11,48008,48008,11,48036,48036,11,48064,48064,11,48092,48092,11,48120,48120,11,48148,48148,11,48176,48176,11,48204,48204,11,48232,48232,11,48260,48260,11,48288,48288,11,48316,48316,11,48344,48344,11,48372,48372,11,48400,48400,11,48428,48428,11,48456,48456,11,48484,48484,11,48512,48512,11,48540,48540,11,48568,48568,11,48596,48596,11,48624,48624,11,48652,48652,11,48680,48680,11,48708,48708,11,48736,48736,11,48764,48764,11,48792,48792,11,48820,48820,11,48848,48848,11,48876,48876,11,48904,48904,11,48932,48932,11,48960,48960,11,48988,48988,11,49016,49016,11,49044,49044,11,49072,49072,11,49100,49100,11,49128,49128,11,49156,49156,11,49184,49184,11,49212,49212,11,49240,49240,11,49268,49268,11,49296,49296,11,49324,49324,11,49352,49352,11,49380,49380,11,49408,49408,11,49436,49436,11,49464,49464,11,49492,49492,11,49520,49520,11,49548,49548,11,49576,49576,11,49604,49604,11,49632,49632,11,49660,49660,11,49688,49688,11,49716,49716,11,49744,49744,11,49772,49772,11,49800,49800,11,49828,49828,11,49856,49856,11,49884,49884,11,49912,49912,11,49940,49940,11,49968,49968,11,49996,49996,11,50024,50024,11,50052,50052,11,50080,50080,11,50108,50108,11,50136,50136,11,50164,50164,11,50192,50192,11,50220,50220,11,50248,50248,11,50276,50276,11,50304,50304,11,50332,50332,11,50360,50360,11,50388,50388,11,50416,50416,11,50444,50444,11,50472,50472,11,50500,50500,11,50528,50528,11,50556,50556,11,50584,50584,11,50612,50612,11,50640,50640,11,50668,50668,11,50696,50696,11,50724,50724,11,50752,50752,11,50780,50780,11,50808,50808,11,50836,50836,11,50864,50864,11,50892,50892,11,50920,50920,11,50948,50948,11,50976,50976,11,51004,51004,11,51032,51032,11,51060,51060,11,51088,51088,11,51116,51116,11,51144,51144,11,51172,51172,11,51200,51200,11,51228,51228,11,51256,51256,11,51284,51284,11,51312,51312,11,51340,51340,11,51368,51368,11,51396,51396,11,51424,51424,11,51452,51452,11,51480,51480,11,51508,51508,11,51536,51536,11,51564,51564,11,51592,51592,11,51620,51620,11,51648,51648,11,51676,51676,11,51704,51704,11,51732,51732,11,51760,51760,11,51788,51788,11,51816,51816,11,51844,51844,11,51872,51872,11,51900,51900,11,51928,51928,11,51956,51956,11,51984,51984,11,52012,52012,11,52040,52040,11,52068,52068,11,52096,52096,11,52124,52124,11,52152,52152,11,52180,52180,11,52208,52208,11,52236,52236,11,52264,52264,11,52292,52292,11,52320,52320,11,52348,52348,11,52376,52376,11,52404,52404,11,52432,52432,11,52460,52460,11,52488,52488,11,52516,52516,11,52544,52544,11,52572,52572,11,52600,52600,11,52628,52628,11,52656,52656,11,52684,52684,11,52712,52712,11,52740,52740,11,52768,52768,11,52796,52796,11,52824,52824,11,52852,52852,11,52880,52880,11,52908,52908,11,52936,52936,11,52964,52964,11,52992,52992,11,53020,53020,11,53048,53048,11,53076,53076,11,53104,53104,11,53132,53132,11,53160,53160,11,53188,53188,11,53216,53216,11,53244,53244,11,53272,53272,11,53300,53300,11,53328,53328,11,53356,53356,11,53384,53384,11,53412,53412,11,53440,53440,11,53468,53468,11,53496,53496,11,53524,53524,11,53552,53552,11,53580,53580,11,53608,53608,11,53636,53636,11,53664,53664,11,53692,53692,11,53720,53720,11,53748,53748,11,53776,53776,11,53804,53804,11,53832,53832,11,53860,53860,11,53888,53888,11,53916,53916,11,53944,53944,11,53972,53972,11,54000,54000,11,54028,54028,11,54056,54056,11,54084,54084,11,54112,54112,11,54140,54140,11,54168,54168,11,54196,54196,11,54224,54224,11,54252,54252,11,54280,54280,11,54308,54308,11,54336,54336,11,54364,54364,11,54392,54392,11,54420,54420,11,54448,54448,11,54476,54476,11,54504,54504,11,54532,54532,11,54560,54560,11,54588,54588,11,54616,54616,11,54644,54644,11,54672,54672,11,54700,54700,11,54728,54728,11,54756,54756,11,54784,54784,11,54812,54812,11,54840,54840,11,54868,54868,11,54896,54896,11,54924,54924,11,54952,54952,11,54980,54980,11,55008,55008,11,55036,55036,11,55064,55064,11,55092,55092,11,55120,55120,11,55148,55148,11,55176,55176,11,55216,55238,9,64286,64286,5,65056,65071,5,65438,65439,5,65529,65531,4,66272,66272,5,68097,68099,5,68108,68111,5,68159,68159,5,68900,68903,5,69446,69456,5,69632,69632,7,69634,69634,7,69744,69744,5,69759,69761,5,69808,69810,7,69815,69816,7,69821,69821,1,69837,69837,1,69927,69931,5,69933,69940,5,70003,70003,5,70018,70018,7,70070,70078,5,70082,70083,1,70094,70094,7,70188,70190,7,70194,70195,7,70197,70197,7,70206,70206,5,70368,70370,7,70400,70401,5,70459,70460,5,70463,70463,7,70465,70468,7,70475,70477,7,70498,70499,7,70512,70516,5,70712,70719,5,70722,70724,5,70726,70726,5,70832,70832,5,70835,70840,5,70842,70842,5,70845,70845,5,70847,70848,5,70850,70851,5,71088,71089,7,71096,71099,7,71102,71102,7,71132,71133,5,71219,71226,5,71229,71229,5,71231,71232,5,71340,71340,7,71342,71343,7,71350,71350,7,71453,71455,5,71462,71462,7,71724,71726,7,71736,71736,7,71984,71984,5,71991,71992,7,71997,71997,7,71999,71999,1,72001,72001,1,72003,72003,5,72148,72151,5,72156,72159,7,72164,72164,7,72243,72248,5,72250,72250,1,72263,72263,5,72279,72280,7,72324,72329,1,72343,72343,7,72751,72751,7,72760,72765,5,72767,72767,5,72873,72873,7,72881,72881,7,72884,72884,7,73009,73014,5,73020,73021,5,73030,73030,1,73098,73102,7,73107,73108,7,73110,73110,7,73459,73460,5,78896,78904,4,92976,92982,5,94033,94087,7,94180,94180,5,113821,113822,5,118528,118573,5,119141,119141,5,119143,119145,5,119150,119154,5,119163,119170,5,119210,119213,5,121344,121398,5,121461,121461,5,121499,121503,5,122880,122886,5,122907,122913,5,122918,122922,5,123566,123566,5,125136,125142,5,126976,126979,14,126981,127182,14,127184,127231,14,127279,127279,14,127344,127345,14,127374,127374,14,127405,127461,14,127489,127490,14,127514,127514,14,127538,127546,14,127561,127567,14,127570,127743,14,127757,127758,14,127760,127760,14,127762,127762,14,127766,127768,14,127770,127770,14,127772,127772,14,127775,127776,14,127778,127779,14,127789,127791,14,127794,127795,14,127798,127798,14,127819,127819,14,127824,127824,14,127868,127868,14,127870,127871,14,127892,127893,14,127896,127896,14,127900,127901,14,127904,127940,14,127942,127942,14,127944,127944,14,127946,127946,14,127951,127955,14,127968,127971,14,127973,127984,14,127987,127987,14,127989,127989,14,127991,127991,14,127995,127999,5,128008,128008,14,128012,128014,14,128017,128018,14,128020,128020,14,128022,128022,14,128042,128042,14,128063,128063,14,128065,128065,14,128101,128101,14,128108,128109,14,128173,128173,14,128182,128183,14,128236,128237,14,128239,128239,14,128245,128245,14,128248,128248,14,128253,128253,14,128255,128258,14,128260,128263,14,128265,128265,14,128277,128277,14,128300,128301,14,128326,128328,14,128331,128334,14,128336,128347,14,128360,128366,14,128369,128370,14,128378,128378,14,128391,128391,14,128394,128397,14,128400,128400,14,128405,128406,14,128420,128420,14,128422,128423,14,128425,128432,14,128435,128443,14,128445,128449,14,128453,128464,14,128468,128475,14,128479,128480,14,128482,128482,14,128484,128487,14,128489,128494,14,128496,128498,14,128500,128505,14,128507,128511,14,128513,128518,14,128521,128525,14,128527,128527,14,128529,128529,14,128533,128533,14,128535,128535,14,128537,128537,14]");
}
function DNe(i, e) {
  if (i === 0)
    return 0;
  const t = ENe(i, e);
  if (t !== void 0)
    return t;
  const n = new Hj(e, i);
  return n.prevCodePoint(), n.offset;
}
function ENe(i, e) {
  const t = new Hj(e, i);
  let n = t.prevCodePoint();
  for (; LNe(n) || n === 65039 || n === 8419; ) {
    if (t.offset === 0)
      return;
    n = t.prevCodePoint();
  }
  if (!jj(n))
    return;
  let r = t.offset;
  return r > 0 && t.prevCodePoint() === 8205 && (r = t.offset), r;
}
function LNe(i) {
  return 127995 <= i && i <= 127999;
}
const vhe = " ";
class qm {
  static getInstance(e) {
    return d_.cache.get(Array.from(e));
  }
  static getLocales() {
    return d_._locales.value;
  }
  constructor(e) {
    this.confusableDictionary = e;
  }
  isAmbiguous(e) {
    return this.confusableDictionary.has(e);
  }
  /**
   * Returns the non basic ASCII code point that the given code point can be confused,
   * or undefined if such code point does note exist.
   */
  getPrimaryConfusable(e) {
    return this.confusableDictionary.get(e);
  }
  getConfusableCodePoints() {
    return new Set(this.confusableDictionary.keys());
  }
}
d_ = qm;
qm.ambiguousCharacterData = new lp(() => JSON.parse('{"_common":[8232,32,8233,32,5760,32,8192,32,8193,32,8194,32,8195,32,8196,32,8197,32,8198,32,8200,32,8201,32,8202,32,8287,32,8199,32,8239,32,2042,95,65101,95,65102,95,65103,95,8208,45,8209,45,8210,45,65112,45,1748,45,8259,45,727,45,8722,45,10134,45,11450,45,1549,44,1643,44,8218,44,184,44,42233,44,894,59,2307,58,2691,58,1417,58,1795,58,1796,58,5868,58,65072,58,6147,58,6153,58,8282,58,1475,58,760,58,42889,58,8758,58,720,58,42237,58,451,33,11601,33,660,63,577,63,2429,63,5038,63,42731,63,119149,46,8228,46,1793,46,1794,46,42510,46,68176,46,1632,46,1776,46,42232,46,1373,96,65287,96,8219,96,8242,96,1370,96,1523,96,8175,96,65344,96,900,96,8189,96,8125,96,8127,96,8190,96,697,96,884,96,712,96,714,96,715,96,756,96,699,96,701,96,700,96,702,96,42892,96,1497,96,2036,96,2037,96,5194,96,5836,96,94033,96,94034,96,65339,91,10088,40,10098,40,12308,40,64830,40,65341,93,10089,41,10099,41,12309,41,64831,41,10100,123,119060,123,10101,125,65342,94,8270,42,1645,42,8727,42,66335,42,5941,47,8257,47,8725,47,8260,47,9585,47,10187,47,10744,47,119354,47,12755,47,12339,47,11462,47,20031,47,12035,47,65340,92,65128,92,8726,92,10189,92,10741,92,10745,92,119311,92,119355,92,12756,92,20022,92,12034,92,42872,38,708,94,710,94,5869,43,10133,43,66203,43,8249,60,10094,60,706,60,119350,60,5176,60,5810,60,5120,61,11840,61,12448,61,42239,61,8250,62,10095,62,707,62,119351,62,5171,62,94015,62,8275,126,732,126,8128,126,8764,126,65372,124,65293,45,120784,50,120794,50,120804,50,120814,50,120824,50,130034,50,42842,50,423,50,1000,50,42564,50,5311,50,42735,50,119302,51,120785,51,120795,51,120805,51,120815,51,120825,51,130035,51,42923,51,540,51,439,51,42858,51,11468,51,1248,51,94011,51,71882,51,120786,52,120796,52,120806,52,120816,52,120826,52,130036,52,5070,52,71855,52,120787,53,120797,53,120807,53,120817,53,120827,53,130037,53,444,53,71867,53,120788,54,120798,54,120808,54,120818,54,120828,54,130038,54,11474,54,5102,54,71893,54,119314,55,120789,55,120799,55,120809,55,120819,55,120829,55,130039,55,66770,55,71878,55,2819,56,2538,56,2666,56,125131,56,120790,56,120800,56,120810,56,120820,56,120830,56,130040,56,547,56,546,56,66330,56,2663,57,2920,57,2541,57,3437,57,120791,57,120801,57,120811,57,120821,57,120831,57,130041,57,42862,57,11466,57,71884,57,71852,57,71894,57,9082,97,65345,97,119834,97,119886,97,119938,97,119990,97,120042,97,120094,97,120146,97,120198,97,120250,97,120302,97,120354,97,120406,97,120458,97,593,97,945,97,120514,97,120572,97,120630,97,120688,97,120746,97,65313,65,119808,65,119860,65,119912,65,119964,65,120016,65,120068,65,120120,65,120172,65,120224,65,120276,65,120328,65,120380,65,120432,65,913,65,120488,65,120546,65,120604,65,120662,65,120720,65,5034,65,5573,65,42222,65,94016,65,66208,65,119835,98,119887,98,119939,98,119991,98,120043,98,120095,98,120147,98,120199,98,120251,98,120303,98,120355,98,120407,98,120459,98,388,98,5071,98,5234,98,5551,98,65314,66,8492,66,119809,66,119861,66,119913,66,120017,66,120069,66,120121,66,120173,66,120225,66,120277,66,120329,66,120381,66,120433,66,42932,66,914,66,120489,66,120547,66,120605,66,120663,66,120721,66,5108,66,5623,66,42192,66,66178,66,66209,66,66305,66,65347,99,8573,99,119836,99,119888,99,119940,99,119992,99,120044,99,120096,99,120148,99,120200,99,120252,99,120304,99,120356,99,120408,99,120460,99,7428,99,1010,99,11429,99,43951,99,66621,99,128844,67,71922,67,71913,67,65315,67,8557,67,8450,67,8493,67,119810,67,119862,67,119914,67,119966,67,120018,67,120174,67,120226,67,120278,67,120330,67,120382,67,120434,67,1017,67,11428,67,5087,67,42202,67,66210,67,66306,67,66581,67,66844,67,8574,100,8518,100,119837,100,119889,100,119941,100,119993,100,120045,100,120097,100,120149,100,120201,100,120253,100,120305,100,120357,100,120409,100,120461,100,1281,100,5095,100,5231,100,42194,100,8558,68,8517,68,119811,68,119863,68,119915,68,119967,68,120019,68,120071,68,120123,68,120175,68,120227,68,120279,68,120331,68,120383,68,120435,68,5024,68,5598,68,5610,68,42195,68,8494,101,65349,101,8495,101,8519,101,119838,101,119890,101,119942,101,120046,101,120098,101,120150,101,120202,101,120254,101,120306,101,120358,101,120410,101,120462,101,43826,101,1213,101,8959,69,65317,69,8496,69,119812,69,119864,69,119916,69,120020,69,120072,69,120124,69,120176,69,120228,69,120280,69,120332,69,120384,69,120436,69,917,69,120492,69,120550,69,120608,69,120666,69,120724,69,11577,69,5036,69,42224,69,71846,69,71854,69,66182,69,119839,102,119891,102,119943,102,119995,102,120047,102,120099,102,120151,102,120203,102,120255,102,120307,102,120359,102,120411,102,120463,102,43829,102,42905,102,383,102,7837,102,1412,102,119315,70,8497,70,119813,70,119865,70,119917,70,120021,70,120073,70,120125,70,120177,70,120229,70,120281,70,120333,70,120385,70,120437,70,42904,70,988,70,120778,70,5556,70,42205,70,71874,70,71842,70,66183,70,66213,70,66853,70,65351,103,8458,103,119840,103,119892,103,119944,103,120048,103,120100,103,120152,103,120204,103,120256,103,120308,103,120360,103,120412,103,120464,103,609,103,7555,103,397,103,1409,103,119814,71,119866,71,119918,71,119970,71,120022,71,120074,71,120126,71,120178,71,120230,71,120282,71,120334,71,120386,71,120438,71,1292,71,5056,71,5107,71,42198,71,65352,104,8462,104,119841,104,119945,104,119997,104,120049,104,120101,104,120153,104,120205,104,120257,104,120309,104,120361,104,120413,104,120465,104,1211,104,1392,104,5058,104,65320,72,8459,72,8460,72,8461,72,119815,72,119867,72,119919,72,120023,72,120179,72,120231,72,120283,72,120335,72,120387,72,120439,72,919,72,120494,72,120552,72,120610,72,120668,72,120726,72,11406,72,5051,72,5500,72,42215,72,66255,72,731,105,9075,105,65353,105,8560,105,8505,105,8520,105,119842,105,119894,105,119946,105,119998,105,120050,105,120102,105,120154,105,120206,105,120258,105,120310,105,120362,105,120414,105,120466,105,120484,105,618,105,617,105,953,105,8126,105,890,105,120522,105,120580,105,120638,105,120696,105,120754,105,1110,105,42567,105,1231,105,43893,105,5029,105,71875,105,65354,106,8521,106,119843,106,119895,106,119947,106,119999,106,120051,106,120103,106,120155,106,120207,106,120259,106,120311,106,120363,106,120415,106,120467,106,1011,106,1112,106,65322,74,119817,74,119869,74,119921,74,119973,74,120025,74,120077,74,120129,74,120181,74,120233,74,120285,74,120337,74,120389,74,120441,74,42930,74,895,74,1032,74,5035,74,5261,74,42201,74,119844,107,119896,107,119948,107,120000,107,120052,107,120104,107,120156,107,120208,107,120260,107,120312,107,120364,107,120416,107,120468,107,8490,75,65323,75,119818,75,119870,75,119922,75,119974,75,120026,75,120078,75,120130,75,120182,75,120234,75,120286,75,120338,75,120390,75,120442,75,922,75,120497,75,120555,75,120613,75,120671,75,120729,75,11412,75,5094,75,5845,75,42199,75,66840,75,1472,108,8739,73,9213,73,65512,73,1633,108,1777,73,66336,108,125127,108,120783,73,120793,73,120803,73,120813,73,120823,73,130033,73,65321,73,8544,73,8464,73,8465,73,119816,73,119868,73,119920,73,120024,73,120128,73,120180,73,120232,73,120284,73,120336,73,120388,73,120440,73,65356,108,8572,73,8467,108,119845,108,119897,108,119949,108,120001,108,120053,108,120105,73,120157,73,120209,73,120261,73,120313,73,120365,73,120417,73,120469,73,448,73,120496,73,120554,73,120612,73,120670,73,120728,73,11410,73,1030,73,1216,73,1493,108,1503,108,1575,108,126464,108,126592,108,65166,108,65165,108,1994,108,11599,73,5825,73,42226,73,93992,73,66186,124,66313,124,119338,76,8556,76,8466,76,119819,76,119871,76,119923,76,120027,76,120079,76,120131,76,120183,76,120235,76,120287,76,120339,76,120391,76,120443,76,11472,76,5086,76,5290,76,42209,76,93974,76,71843,76,71858,76,66587,76,66854,76,65325,77,8559,77,8499,77,119820,77,119872,77,119924,77,120028,77,120080,77,120132,77,120184,77,120236,77,120288,77,120340,77,120392,77,120444,77,924,77,120499,77,120557,77,120615,77,120673,77,120731,77,1018,77,11416,77,5047,77,5616,77,5846,77,42207,77,66224,77,66321,77,119847,110,119899,110,119951,110,120003,110,120055,110,120107,110,120159,110,120211,110,120263,110,120315,110,120367,110,120419,110,120471,110,1400,110,1404,110,65326,78,8469,78,119821,78,119873,78,119925,78,119977,78,120029,78,120081,78,120185,78,120237,78,120289,78,120341,78,120393,78,120445,78,925,78,120500,78,120558,78,120616,78,120674,78,120732,78,11418,78,42208,78,66835,78,3074,111,3202,111,3330,111,3458,111,2406,111,2662,111,2790,111,3046,111,3174,111,3302,111,3430,111,3664,111,3792,111,4160,111,1637,111,1781,111,65359,111,8500,111,119848,111,119900,111,119952,111,120056,111,120108,111,120160,111,120212,111,120264,111,120316,111,120368,111,120420,111,120472,111,7439,111,7441,111,43837,111,959,111,120528,111,120586,111,120644,111,120702,111,120760,111,963,111,120532,111,120590,111,120648,111,120706,111,120764,111,11423,111,4351,111,1413,111,1505,111,1607,111,126500,111,126564,111,126596,111,65259,111,65260,111,65258,111,65257,111,1726,111,64428,111,64429,111,64427,111,64426,111,1729,111,64424,111,64425,111,64423,111,64422,111,1749,111,3360,111,4125,111,66794,111,71880,111,71895,111,66604,111,1984,79,2534,79,2918,79,12295,79,70864,79,71904,79,120782,79,120792,79,120802,79,120812,79,120822,79,130032,79,65327,79,119822,79,119874,79,119926,79,119978,79,120030,79,120082,79,120134,79,120186,79,120238,79,120290,79,120342,79,120394,79,120446,79,927,79,120502,79,120560,79,120618,79,120676,79,120734,79,11422,79,1365,79,11604,79,4816,79,2848,79,66754,79,42227,79,71861,79,66194,79,66219,79,66564,79,66838,79,9076,112,65360,112,119849,112,119901,112,119953,112,120005,112,120057,112,120109,112,120161,112,120213,112,120265,112,120317,112,120369,112,120421,112,120473,112,961,112,120530,112,120544,112,120588,112,120602,112,120646,112,120660,112,120704,112,120718,112,120762,112,120776,112,11427,112,65328,80,8473,80,119823,80,119875,80,119927,80,119979,80,120031,80,120083,80,120187,80,120239,80,120291,80,120343,80,120395,80,120447,80,929,80,120504,80,120562,80,120620,80,120678,80,120736,80,11426,80,5090,80,5229,80,42193,80,66197,80,119850,113,119902,113,119954,113,120006,113,120058,113,120110,113,120162,113,120214,113,120266,113,120318,113,120370,113,120422,113,120474,113,1307,113,1379,113,1382,113,8474,81,119824,81,119876,81,119928,81,119980,81,120032,81,120084,81,120188,81,120240,81,120292,81,120344,81,120396,81,120448,81,11605,81,119851,114,119903,114,119955,114,120007,114,120059,114,120111,114,120163,114,120215,114,120267,114,120319,114,120371,114,120423,114,120475,114,43847,114,43848,114,7462,114,11397,114,43905,114,119318,82,8475,82,8476,82,8477,82,119825,82,119877,82,119929,82,120033,82,120189,82,120241,82,120293,82,120345,82,120397,82,120449,82,422,82,5025,82,5074,82,66740,82,5511,82,42211,82,94005,82,65363,115,119852,115,119904,115,119956,115,120008,115,120060,115,120112,115,120164,115,120216,115,120268,115,120320,115,120372,115,120424,115,120476,115,42801,115,445,115,1109,115,43946,115,71873,115,66632,115,65331,83,119826,83,119878,83,119930,83,119982,83,120034,83,120086,83,120138,83,120190,83,120242,83,120294,83,120346,83,120398,83,120450,83,1029,83,1359,83,5077,83,5082,83,42210,83,94010,83,66198,83,66592,83,119853,116,119905,116,119957,116,120009,116,120061,116,120113,116,120165,116,120217,116,120269,116,120321,116,120373,116,120425,116,120477,116,8868,84,10201,84,128872,84,65332,84,119827,84,119879,84,119931,84,119983,84,120035,84,120087,84,120139,84,120191,84,120243,84,120295,84,120347,84,120399,84,120451,84,932,84,120507,84,120565,84,120623,84,120681,84,120739,84,11430,84,5026,84,42196,84,93962,84,71868,84,66199,84,66225,84,66325,84,119854,117,119906,117,119958,117,120010,117,120062,117,120114,117,120166,117,120218,117,120270,117,120322,117,120374,117,120426,117,120478,117,42911,117,7452,117,43854,117,43858,117,651,117,965,117,120534,117,120592,117,120650,117,120708,117,120766,117,1405,117,66806,117,71896,117,8746,85,8899,85,119828,85,119880,85,119932,85,119984,85,120036,85,120088,85,120140,85,120192,85,120244,85,120296,85,120348,85,120400,85,120452,85,1357,85,4608,85,66766,85,5196,85,42228,85,94018,85,71864,85,8744,118,8897,118,65366,118,8564,118,119855,118,119907,118,119959,118,120011,118,120063,118,120115,118,120167,118,120219,118,120271,118,120323,118,120375,118,120427,118,120479,118,7456,118,957,118,120526,118,120584,118,120642,118,120700,118,120758,118,1141,118,1496,118,71430,118,43945,118,71872,118,119309,86,1639,86,1783,86,8548,86,119829,86,119881,86,119933,86,119985,86,120037,86,120089,86,120141,86,120193,86,120245,86,120297,86,120349,86,120401,86,120453,86,1140,86,11576,86,5081,86,5167,86,42719,86,42214,86,93960,86,71840,86,66845,86,623,119,119856,119,119908,119,119960,119,120012,119,120064,119,120116,119,120168,119,120220,119,120272,119,120324,119,120376,119,120428,119,120480,119,7457,119,1121,119,1309,119,1377,119,71434,119,71438,119,71439,119,43907,119,71919,87,71910,87,119830,87,119882,87,119934,87,119986,87,120038,87,120090,87,120142,87,120194,87,120246,87,120298,87,120350,87,120402,87,120454,87,1308,87,5043,87,5076,87,42218,87,5742,120,10539,120,10540,120,10799,120,65368,120,8569,120,119857,120,119909,120,119961,120,120013,120,120065,120,120117,120,120169,120,120221,120,120273,120,120325,120,120377,120,120429,120,120481,120,5441,120,5501,120,5741,88,9587,88,66338,88,71916,88,65336,88,8553,88,119831,88,119883,88,119935,88,119987,88,120039,88,120091,88,120143,88,120195,88,120247,88,120299,88,120351,88,120403,88,120455,88,42931,88,935,88,120510,88,120568,88,120626,88,120684,88,120742,88,11436,88,11613,88,5815,88,42219,88,66192,88,66228,88,66327,88,66855,88,611,121,7564,121,65369,121,119858,121,119910,121,119962,121,120014,121,120066,121,120118,121,120170,121,120222,121,120274,121,120326,121,120378,121,120430,121,120482,121,655,121,7935,121,43866,121,947,121,8509,121,120516,121,120574,121,120632,121,120690,121,120748,121,1199,121,4327,121,71900,121,65337,89,119832,89,119884,89,119936,89,119988,89,120040,89,120092,89,120144,89,120196,89,120248,89,120300,89,120352,89,120404,89,120456,89,933,89,978,89,120508,89,120566,89,120624,89,120682,89,120740,89,11432,89,1198,89,5033,89,5053,89,42220,89,94019,89,71844,89,66226,89,119859,122,119911,122,119963,122,120015,122,120067,122,120119,122,120171,122,120223,122,120275,122,120327,122,120379,122,120431,122,120483,122,7458,122,43923,122,71876,122,66293,90,71909,90,65338,90,8484,90,8488,90,119833,90,119885,90,119937,90,119989,90,120041,90,120197,90,120249,90,120301,90,120353,90,120405,90,120457,90,918,90,120493,90,120551,90,120609,90,120667,90,120725,90,5059,90,42204,90,71849,90,65282,34,65284,36,65285,37,65286,38,65290,42,65291,43,65294,46,65295,47,65296,48,65297,49,65298,50,65299,51,65300,52,65301,53,65302,54,65303,55,65304,56,65305,57,65308,60,65309,61,65310,62,65312,64,65316,68,65318,70,65319,71,65324,76,65329,81,65330,82,65333,85,65334,86,65335,87,65343,95,65346,98,65348,100,65350,102,65355,107,65357,109,65358,110,65361,113,65362,114,65364,116,65365,117,65367,119,65370,122,65371,123,65373,125,119846,109],"_default":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"cs":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"de":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"es":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"fr":[65374,126,65306,58,65281,33,8216,96,8245,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"it":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ja":[8211,45,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65292,44,65307,59],"ko":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pl":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pt-BR":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"qps-ploc":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ru":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,305,105,921,73,1009,112,215,120,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"tr":[160,32,8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"zh-hans":[65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65288,40,65289,41],"zh-hant":[8211,45,65374,126,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65307,59]}'));
qm.cache = new hNe((i) => {
  function e(c) {
    const d = /* @__PURE__ */ new Map();
    for (let u = 0; u < c.length; u += 2)
      d.set(c[u], c[u + 1]);
    return d;
  }
  function t(c, d) {
    const u = new Map(c);
    for (const [h, f] of d)
      u.set(h, f);
    return u;
  }
  function n(c, d) {
    if (!c)
      return d;
    const u = /* @__PURE__ */ new Map();
    for (const [h, f] of c)
      d.has(h) && u.set(h, f);
    return u;
  }
  const r = d_.ambiguousCharacterData.value;
  let s = i.filter((c) => !c.startsWith("_") && c in r);
  s.length === 0 && (s = ["_default"]);
  let o;
  for (const c of s) {
    const d = e(r[c]);
    o = n(o, d);
  }
  const a = e(r._common), l = t(a, o);
  return new d_(l);
});
qm._locales = new lp(() => Object.keys(d_.ambiguousCharacterData.value).filter((i) => !i.startsWith("_")));
class cu {
  static getRawData() {
    return JSON.parse("[9,10,11,12,13,32,127,160,173,847,1564,4447,4448,6068,6069,6155,6156,6157,6158,7355,7356,8192,8193,8194,8195,8196,8197,8198,8199,8200,8201,8202,8203,8204,8205,8206,8207,8234,8235,8236,8237,8238,8239,8287,8288,8289,8290,8291,8292,8293,8294,8295,8296,8297,8298,8299,8300,8301,8302,8303,10240,12288,12644,65024,65025,65026,65027,65028,65029,65030,65031,65032,65033,65034,65035,65036,65037,65038,65039,65279,65440,65520,65521,65522,65523,65524,65525,65526,65527,65528,65532,78844,119155,119156,119157,119158,119159,119160,119161,119162,917504,917505,917506,917507,917508,917509,917510,917511,917512,917513,917514,917515,917516,917517,917518,917519,917520,917521,917522,917523,917524,917525,917526,917527,917528,917529,917530,917531,917532,917533,917534,917535,917536,917537,917538,917539,917540,917541,917542,917543,917544,917545,917546,917547,917548,917549,917550,917551,917552,917553,917554,917555,917556,917557,917558,917559,917560,917561,917562,917563,917564,917565,917566,917567,917568,917569,917570,917571,917572,917573,917574,917575,917576,917577,917578,917579,917580,917581,917582,917583,917584,917585,917586,917587,917588,917589,917590,917591,917592,917593,917594,917595,917596,917597,917598,917599,917600,917601,917602,917603,917604,917605,917606,917607,917608,917609,917610,917611,917612,917613,917614,917615,917616,917617,917618,917619,917620,917621,917622,917623,917624,917625,917626,917627,917628,917629,917630,917631,917760,917761,917762,917763,917764,917765,917766,917767,917768,917769,917770,917771,917772,917773,917774,917775,917776,917777,917778,917779,917780,917781,917782,917783,917784,917785,917786,917787,917788,917789,917790,917791,917792,917793,917794,917795,917796,917797,917798,917799,917800,917801,917802,917803,917804,917805,917806,917807,917808,917809,917810,917811,917812,917813,917814,917815,917816,917817,917818,917819,917820,917821,917822,917823,917824,917825,917826,917827,917828,917829,917830,917831,917832,917833,917834,917835,917836,917837,917838,917839,917840,917841,917842,917843,917844,917845,917846,917847,917848,917849,917850,917851,917852,917853,917854,917855,917856,917857,917858,917859,917860,917861,917862,917863,917864,917865,917866,917867,917868,917869,917870,917871,917872,917873,917874,917875,917876,917877,917878,917879,917880,917881,917882,917883,917884,917885,917886,917887,917888,917889,917890,917891,917892,917893,917894,917895,917896,917897,917898,917899,917900,917901,917902,917903,917904,917905,917906,917907,917908,917909,917910,917911,917912,917913,917914,917915,917916,917917,917918,917919,917920,917921,917922,917923,917924,917925,917926,917927,917928,917929,917930,917931,917932,917933,917934,917935,917936,917937,917938,917939,917940,917941,917942,917943,917944,917945,917946,917947,917948,917949,917950,917951,917952,917953,917954,917955,917956,917957,917958,917959,917960,917961,917962,917963,917964,917965,917966,917967,917968,917969,917970,917971,917972,917973,917974,917975,917976,917977,917978,917979,917980,917981,917982,917983,917984,917985,917986,917987,917988,917989,917990,917991,917992,917993,917994,917995,917996,917997,917998,917999]");
  }
  static getData() {
    return this._data || (this._data = new Set(cu.getRawData())), this._data;
  }
  static isInvisibleCharacter(e) {
    return cu.getData().has(e);
  }
  static get codePoints() {
    return cu.getData();
  }
}
cu._data = void 0;
class eF {
  constructor() {
    this._zoomFactor = 1;
  }
  getZoomFactor() {
    return this._zoomFactor;
  }
}
eF.INSTANCE = new eF();
class INe extends we {
  constructor() {
    super(), this._onDidChange = this._register(new pe()), this.onDidChange = this._onDidChange.event, this._listener = () => this._handleChange(!0), this._mediaQueryList = null, this._handleChange(!1);
  }
  _handleChange(e) {
    var t;
    (t = this._mediaQueryList) === null || t === void 0 || t.removeEventListener("change", this._listener), this._mediaQueryList = window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`), this._mediaQueryList.addEventListener("change", this._listener), e && this._onDidChange.fire();
  }
}
class ANe extends we {
  get value() {
    return this._value;
  }
  constructor() {
    super(), this._onDidChange = this._register(new pe()), this.onDidChange = this._onDidChange.event, this._value = this._getPixelRatio();
    const e = this._register(new INe());
    this._register(e.onDidChange(() => {
      this._value = this._getPixelRatio(), this._onDidChange.fire(this._value);
    }));
  }
  _getPixelRatio() {
    const e = document.createElement("canvas").getContext("2d"), t = window.devicePixelRatio || 1, n = e.webkitBackingStorePixelRatio || e.mozBackingStorePixelRatio || e.msBackingStorePixelRatio || e.oBackingStorePixelRatio || e.backingStorePixelRatio || 1;
    return t / n;
  }
}
class kNe {
  constructor() {
    this._pixelRatioMonitor = null;
  }
  _getOrCreatePixelRatioMonitor() {
    return this._pixelRatioMonitor || (this._pixelRatioMonitor = new ANe()), this._pixelRatioMonitor;
  }
  /**
   * Get the current value.
   */
  get value() {
    return this._getOrCreatePixelRatioMonitor().value;
  }
  /**
   * Listen for changes.
   */
  get onDidChange() {
    return this._getOrCreatePixelRatioMonitor().onDidChange;
  }
}
function _he(i, e) {
  typeof i == "string" && (i = window.matchMedia(i)), i.addEventListener("change", e);
}
const Ey = new kNe();
function TNe() {
  return eF.INSTANCE.getZoomFactor();
}
const ub = navigator.userAgent, bl = ub.indexOf("Firefox") >= 0, Sm = ub.indexOf("AppleWebKit") >= 0, Uj = ub.indexOf("Chrome") >= 0, Zh = !Uj && ub.indexOf("Safari") >= 0, bhe = !Uj && !Zh && Sm;
ub.indexOf("Electron/") >= 0;
const tX = ub.indexOf("Android") >= 0;
let T3 = !1;
if (window.matchMedia) {
  const i = window.matchMedia("(display-mode: standalone) or (display-mode: window-controls-overlay)"), e = window.matchMedia("(display-mode: fullscreen)");
  T3 = i.matches, _he(i, ({ matches: t }) => {
    T3 && e.matches || (T3 = t);
  });
}
function NNe() {
  return T3;
}
class Che {
  constructor(e) {
    this.domNode = e, this._maxWidth = "", this._width = "", this._height = "", this._top = "", this._left = "", this._bottom = "", this._right = "", this._paddingLeft = "", this._fontFamily = "", this._fontWeight = "", this._fontSize = "", this._fontStyle = "", this._fontFeatureSettings = "", this._fontVariationSettings = "", this._textDecoration = "", this._lineHeight = "", this._letterSpacing = "", this._className = "", this._display = "", this._position = "", this._visibility = "", this._color = "", this._backgroundColor = "", this._layerHint = !1, this._contain = "none", this._boxShadow = "";
  }
  setMaxWidth(e) {
    const t = bc(e);
    this._maxWidth !== t && (this._maxWidth = t, this.domNode.style.maxWidth = this._maxWidth);
  }
  setWidth(e) {
    const t = bc(e);
    this._width !== t && (this._width = t, this.domNode.style.width = this._width);
  }
  setHeight(e) {
    const t = bc(e);
    this._height !== t && (this._height = t, this.domNode.style.height = this._height);
  }
  setTop(e) {
    const t = bc(e);
    this._top !== t && (this._top = t, this.domNode.style.top = this._top);
  }
  setLeft(e) {
    const t = bc(e);
    this._left !== t && (this._left = t, this.domNode.style.left = this._left);
  }
  setBottom(e) {
    const t = bc(e);
    this._bottom !== t && (this._bottom = t, this.domNode.style.bottom = this._bottom);
  }
  setRight(e) {
    const t = bc(e);
    this._right !== t && (this._right = t, this.domNode.style.right = this._right);
  }
  setPaddingLeft(e) {
    const t = bc(e);
    this._paddingLeft !== t && (this._paddingLeft = t, this.domNode.style.paddingLeft = this._paddingLeft);
  }
  setFontFamily(e) {
    this._fontFamily !== e && (this._fontFamily = e, this.domNode.style.fontFamily = this._fontFamily);
  }
  setFontWeight(e) {
    this._fontWeight !== e && (this._fontWeight = e, this.domNode.style.fontWeight = this._fontWeight);
  }
  setFontSize(e) {
    const t = bc(e);
    this._fontSize !== t && (this._fontSize = t, this.domNode.style.fontSize = this._fontSize);
  }
  setFontStyle(e) {
    this._fontStyle !== e && (this._fontStyle = e, this.domNode.style.fontStyle = this._fontStyle);
  }
  setFontFeatureSettings(e) {
    this._fontFeatureSettings !== e && (this._fontFeatureSettings = e, this.domNode.style.fontFeatureSettings = this._fontFeatureSettings);
  }
  setFontVariationSettings(e) {
    this._fontVariationSettings !== e && (this._fontVariationSettings = e, this.domNode.style.fontVariationSettings = this._fontVariationSettings);
  }
  setTextDecoration(e) {
    this._textDecoration !== e && (this._textDecoration = e, this.domNode.style.textDecoration = this._textDecoration);
  }
  setLineHeight(e) {
    const t = bc(e);
    this._lineHeight !== t && (this._lineHeight = t, this.domNode.style.lineHeight = this._lineHeight);
  }
  setLetterSpacing(e) {
    const t = bc(e);
    this._letterSpacing !== t && (this._letterSpacing = t, this.domNode.style.letterSpacing = this._letterSpacing);
  }
  setClassName(e) {
    this._className !== e && (this._className = e, this.domNode.className = this._className);
  }
  toggleClassName(e, t) {
    this.domNode.classList.toggle(e, t), this._className = this.domNode.className;
  }
  setDisplay(e) {
    this._display !== e && (this._display = e, this.domNode.style.display = this._display);
  }
  setPosition(e) {
    this._position !== e && (this._position = e, this.domNode.style.position = this._position);
  }
  setVisibility(e) {
    this._visibility !== e && (this._visibility = e, this.domNode.style.visibility = this._visibility);
  }
  setColor(e) {
    this._color !== e && (this._color = e, this.domNode.style.color = this._color);
  }
  setBackgroundColor(e) {
    this._backgroundColor !== e && (this._backgroundColor = e, this.domNode.style.backgroundColor = this._backgroundColor);
  }
  setLayerHinting(e) {
    this._layerHint !== e && (this._layerHint = e, this.domNode.style.transform = this._layerHint ? "translate3d(0px, 0px, 0px)" : "");
  }
  setBoxShadow(e) {
    this._boxShadow !== e && (this._boxShadow = e, this.domNode.style.boxShadow = e);
  }
  setContain(e) {
    this._contain !== e && (this._contain = e, this.domNode.style.contain = this._contain);
  }
  setAttribute(e, t) {
    this.domNode.setAttribute(e, t);
  }
  removeAttribute(e) {
    this.domNode.removeAttribute(e);
  }
  appendChild(e) {
    this.domNode.appendChild(e.domNode);
  }
  removeChild(e) {
    this.domNode.removeChild(e.domNode);
  }
}
function bc(i) {
  return typeof i == "number" ? `${i}px` : i;
}
function Dn(i) {
  return new Che(i);
}
function Ds(i, e) {
  i instanceof Che ? (i.setFontFamily(e.getMassagedFontFamily()), i.setFontWeight(e.fontWeight), i.setFontSize(e.fontSize), i.setFontFeatureSettings(e.fontFeatureSettings), i.setFontVariationSettings(e.fontVariationSettings), i.setLineHeight(e.lineHeight), i.setLetterSpacing(e.letterSpacing)) : (i.style.fontFamily = e.getMassagedFontFamily(), i.style.fontWeight = e.fontWeight, i.style.fontSize = e.fontSize + "px", i.style.fontFeatureSettings = e.fontFeatureSettings, i.style.fontVariationSettings = e.fontVariationSettings, i.style.lineHeight = e.lineHeight + "px", i.style.letterSpacing = e.letterSpacing + "px");
}
class PNe {
  constructor(e, t) {
    this.chr = e, this.type = t, this.width = 0;
  }
  fulfill(e) {
    this.width = e;
  }
}
class Gj {
  constructor(e, t) {
    this._bareFontInfo = e, this._requests = t, this._container = null, this._testElements = null;
  }
  read() {
    this._createDomElements(), document.body.appendChild(this._container), this._readFromDomElements(), document.body.removeChild(this._container), this._container = null, this._testElements = null;
  }
  _createDomElements() {
    const e = document.createElement("div");
    e.style.position = "absolute", e.style.top = "-50000px", e.style.width = "50000px";
    const t = document.createElement("div");
    Ds(t, this._bareFontInfo), e.appendChild(t);
    const n = document.createElement("div");
    Ds(n, this._bareFontInfo), n.style.fontWeight = "bold", e.appendChild(n);
    const r = document.createElement("div");
    Ds(r, this._bareFontInfo), r.style.fontStyle = "italic", e.appendChild(r);
    const s = [];
    for (const o of this._requests) {
      let a;
      o.type === 0 && (a = t), o.type === 2 && (a = n), o.type === 1 && (a = r), a.appendChild(document.createElement("br"));
      const l = document.createElement("span");
      Gj._render(l, o), a.appendChild(l), s.push(l);
    }
    this._container = e, this._testElements = s;
  }
  static _render(e, t) {
    if (t.chr === " ") {
      let n = " ";
      for (let r = 0; r < 8; r++)
        n += n;
      e.innerText = n;
    } else {
      let n = t.chr;
      for (let r = 0; r < 8; r++)
        n += n;
      e.textContent = n;
    }
  }
  _readFromDomElements() {
    for (let e = 0, t = this._requests.length; e < t; e++) {
      const n = this._requests[e], r = this._testElements[e];
      n.fulfill(r.offsetWidth / 256);
    }
  }
}
function ONe(i, e) {
  new Gj(i, e).read();
}
const rl = new class {
  constructor() {
    this._zoomLevel = 0, this._onDidChangeZoomLevel = new pe(), this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
  }
  getZoomLevel() {
    return this._zoomLevel;
  }
  setZoomLevel(i) {
    i = Math.min(Math.max(-5, i), 20), this._zoomLevel !== i && (this._zoomLevel = i, this._onDidChangeZoomLevel.fire(this._zoomLevel));
  }
}(), MNe = sn ? 1.5 : 1.35, e6 = 8;
class xm {
  /**
   * @internal
   */
  static createFromValidatedSettings(e, t, n) {
    const r = e.get(
      49
      /* EditorOption.fontFamily */
    ), s = e.get(
      53
      /* EditorOption.fontWeight */
    ), o = e.get(
      52
      /* EditorOption.fontSize */
    ), a = e.get(
      51
      /* EditorOption.fontLigatures */
    ), l = e.get(
      54
      /* EditorOption.fontVariations */
    ), c = e.get(
      66
      /* EditorOption.lineHeight */
    ), d = e.get(
      63
      /* EditorOption.letterSpacing */
    );
    return xm._create(r, s, o, a, l, c, d, t, n);
  }
  /**
   * @internal
   */
  static _create(e, t, n, r, s, o, a, l, c) {
    o === 0 ? o = MNe * n : o < e6 && (o = o * n), o = Math.round(o), o < e6 && (o = e6);
    const d = 1 + (c ? 0 : rl.getZoomLevel() * 0.1);
    return n *= d, o *= d, s === Hc.TRANSLATE && (t === "normal" || t === "bold" ? s = Hc.OFF : (s = `'wght' ${parseInt(t, 10)}`, t = "normal")), new xm({
      pixelRatio: l,
      fontFamily: e,
      fontWeight: t,
      fontSize: n,
      fontFeatureSettings: r,
      fontVariationSettings: s,
      lineHeight: o,
      letterSpacing: a
    });
  }
  /**
   * @internal
   */
  constructor(e) {
    this._bareFontInfoBrand = void 0, this.pixelRatio = e.pixelRatio, this.fontFamily = String(e.fontFamily), this.fontWeight = String(e.fontWeight), this.fontSize = e.fontSize, this.fontFeatureSettings = e.fontFeatureSettings, this.fontVariationSettings = e.fontVariationSettings, this.lineHeight = e.lineHeight | 0, this.letterSpacing = e.letterSpacing;
  }
  /**
   * @internal
   */
  getId() {
    return `${this.pixelRatio}-${this.fontFamily}-${this.fontWeight}-${this.fontSize}-${this.fontFeatureSettings}-${this.fontVariationSettings}-${this.lineHeight}-${this.letterSpacing}`;
  }
  /**
   * @internal
   */
  getMassagedFontFamily() {
    const e = na.fontFamily, t = xm._wrapInQuotes(this.fontFamily);
    return e && this.fontFamily !== e ? `${t}, ${e}` : t;
  }
  static _wrapInQuotes(e) {
    return /[,"']/.test(e) ? e : /[+ ]/.test(e) ? `"${e}"` : e;
  }
}
const RNe = 2;
class tF extends xm {
  /**
   * @internal
   */
  constructor(e, t) {
    super(e), this._editorStylingBrand = void 0, this.version = RNe, this.isTrusted = t, this.isMonospace = e.isMonospace, this.typicalHalfwidthCharacterWidth = e.typicalHalfwidthCharacterWidth, this.typicalFullwidthCharacterWidth = e.typicalFullwidthCharacterWidth, this.canUseHalfwidthRightwardsArrow = e.canUseHalfwidthRightwardsArrow, this.spaceWidth = e.spaceWidth, this.middotWidth = e.middotWidth, this.wsmiddotWidth = e.wsmiddotWidth, this.maxDigitWidth = e.maxDigitWidth;
  }
  /**
   * @internal
   */
  equals(e) {
    return this.fontFamily === e.fontFamily && this.fontWeight === e.fontWeight && this.fontSize === e.fontSize && this.fontFeatureSettings === e.fontFeatureSettings && this.fontVariationSettings === e.fontVariationSettings && this.lineHeight === e.lineHeight && this.letterSpacing === e.letterSpacing && this.typicalHalfwidthCharacterWidth === e.typicalHalfwidthCharacterWidth && this.typicalFullwidthCharacterWidth === e.typicalFullwidthCharacterWidth && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.maxDigitWidth === e.maxDigitWidth;
  }
}
class FNe extends we {
  constructor() {
    super(), this._onDidChange = this._register(new pe()), this.onDidChange = this._onDidChange.event, this._cache = new nX(), this._evictUntrustedReadingsTimeout = -1;
  }
  dispose() {
    this._evictUntrustedReadingsTimeout !== -1 && (window.clearTimeout(this._evictUntrustedReadingsTimeout), this._evictUntrustedReadingsTimeout = -1), super.dispose();
  }
  /**
   * Clear all cached font information and trigger a change event.
   */
  clearAllFontInfos() {
    this._cache = new nX(), this._onDidChange.fire();
  }
  _writeToCache(e, t) {
    this._cache.put(e, t), !t.isTrusted && this._evictUntrustedReadingsTimeout === -1 && (this._evictUntrustedReadingsTimeout = window.setTimeout(() => {
      this._evictUntrustedReadingsTimeout = -1, this._evictUntrustedReadings();
    }, 5e3));
  }
  _evictUntrustedReadings() {
    const e = this._cache.getValues();
    let t = !1;
    for (const n of e)
      n.isTrusted || (t = !0, this._cache.remove(n));
    t && this._onDidChange.fire();
  }
  /**
   * Read font information.
   */
  readFontInfo(e) {
    if (!this._cache.has(e)) {
      let t = this._actualReadFontInfo(e);
      (t.typicalHalfwidthCharacterWidth <= 2 || t.typicalFullwidthCharacterWidth <= 2 || t.spaceWidth <= 2 || t.maxDigitWidth <= 2) && (t = new tF({
        pixelRatio: Ey.value,
        fontFamily: t.fontFamily,
        fontWeight: t.fontWeight,
        fontSize: t.fontSize,
        fontFeatureSettings: t.fontFeatureSettings,
        fontVariationSettings: t.fontVariationSettings,
        lineHeight: t.lineHeight,
        letterSpacing: t.letterSpacing,
        isMonospace: t.isMonospace,
        typicalHalfwidthCharacterWidth: Math.max(t.typicalHalfwidthCharacterWidth, 5),
        typicalFullwidthCharacterWidth: Math.max(t.typicalFullwidthCharacterWidth, 5),
        canUseHalfwidthRightwardsArrow: t.canUseHalfwidthRightwardsArrow,
        spaceWidth: Math.max(t.spaceWidth, 5),
        middotWidth: Math.max(t.middotWidth, 5),
        wsmiddotWidth: Math.max(t.wsmiddotWidth, 5),
        maxDigitWidth: Math.max(t.maxDigitWidth, 5)
      }, !1)), this._writeToCache(e, t);
    }
    return this._cache.get(e);
  }
  _createRequest(e, t, n, r) {
    const s = new PNe(e, t);
    return n.push(s), r?.push(s), s;
  }
  _actualReadFontInfo(e) {
    const t = [], n = [], r = this._createRequest("n", 0, t, n), s = this._createRequest("ｍ", 0, t, null), o = this._createRequest(" ", 0, t, n), a = this._createRequest("0", 0, t, n), l = this._createRequest("1", 0, t, n), c = this._createRequest("2", 0, t, n), d = this._createRequest("3", 0, t, n), u = this._createRequest("4", 0, t, n), h = this._createRequest("5", 0, t, n), f = this._createRequest("6", 0, t, n), g = this._createRequest("7", 0, t, n), p = this._createRequest("8", 0, t, n), m = this._createRequest("9", 0, t, n), _ = this._createRequest("→", 0, t, n), b = this._createRequest("￫", 0, t, null), w = this._createRequest("·", 0, t, n), y = this._createRequest("⸱", 0, t, null), S = "|/-_ilm%";
    for (let k = 0, N = S.length; k < N; k++)
      this._createRequest(S.charAt(k), 0, t, n), this._createRequest(S.charAt(k), 1, t, n), this._createRequest(S.charAt(k), 2, t, n);
    ONe(e, t);
    const x = Math.max(a.width, l.width, c.width, d.width, u.width, h.width, f.width, g.width, p.width, m.width);
    let D = e.fontFeatureSettings === Da.OFF;
    const E = n[0].width;
    for (let k = 1, N = n.length; D && k < N; k++) {
      const I = E - n[k].width;
      if (I < -1e-3 || I > 1e-3) {
        D = !1;
        break;
      }
    }
    let L = !0;
    return D && b.width !== E && (L = !1), b.width > _.width && (L = !1), new tF({
      pixelRatio: Ey.value,
      fontFamily: e.fontFamily,
      fontWeight: e.fontWeight,
      fontSize: e.fontSize,
      fontFeatureSettings: e.fontFeatureSettings,
      fontVariationSettings: e.fontVariationSettings,
      lineHeight: e.lineHeight,
      letterSpacing: e.letterSpacing,
      isMonospace: D,
      typicalHalfwidthCharacterWidth: r.width,
      typicalFullwidthCharacterWidth: s.width,
      canUseHalfwidthRightwardsArrow: L,
      spaceWidth: o.width,
      middotWidth: w.width,
      wsmiddotWidth: y.width,
      maxDigitWidth: x
    }, !0);
  }
}
class nX {
  constructor() {
    this._keys = /* @__PURE__ */ Object.create(null), this._values = /* @__PURE__ */ Object.create(null);
  }
  has(e) {
    const t = e.getId();
    return !!this._values[t];
  }
  get(e) {
    const t = e.getId();
    return this._values[t];
  }
  put(e, t) {
    const n = e.getId();
    this._keys[n] = e, this._values[n] = t;
  }
  remove(e) {
    const t = e.getId();
    delete this._keys[t], delete this._values[t];
  }
  getValues() {
    return Object.keys(this._keys).map((e) => this._values[e]);
  }
}
const nF = new FNe();
var Uc;
(function(i) {
  i.serviceIds = /* @__PURE__ */ new Map(), i.DI_TARGET = "$di$target", i.DI_DEPENDENCIES = "$di$dependencies";
  function e(t) {
    return t[i.DI_DEPENDENCIES] || [];
  }
  i.getServiceDependencies = e;
})(Uc || (Uc = {}));
const bt = Gt("instantiationService");
function BNe(i, e, t) {
  e[Uc.DI_TARGET] === e ? e[Uc.DI_DEPENDENCIES].push({ id: i, index: t }) : (e[Uc.DI_DEPENDENCIES] = [{ id: i, index: t }], e[Uc.DI_TARGET] = e);
}
function Gt(i) {
  if (Uc.serviceIds.has(i))
    return Uc.serviceIds.get(i);
  const e = function(t, n, r) {
    if (arguments.length !== 3)
      throw new Error("@IServiceName-decorator can only be used to decorate a parameter");
    BNe(e, t, r);
  };
  return e.toString = () => i, Uc.serviceIds.set(i, e), e;
}
const Sn = Gt("codeEditorService"), fi = Gt("modelService"), Wo = Gt("textModelService");
var h_ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class vo extends we {
  constructor(e, t = "", n = "", r = !0, s) {
    super(), this._onDidChange = this._register(new pe()), this.onDidChange = this._onDidChange.event, this._enabled = !0, this._id = e, this._label = t, this._cssClass = n, this._enabled = r, this._actionCallback = s;
  }
  get id() {
    return this._id;
  }
  get label() {
    return this._label;
  }
  set label(e) {
    this._setLabel(e);
  }
  _setLabel(e) {
    this._label !== e && (this._label = e, this._onDidChange.fire({ label: e }));
  }
  get tooltip() {
    return this._tooltip || "";
  }
  set tooltip(e) {
    this._setTooltip(e);
  }
  _setTooltip(e) {
    this._tooltip !== e && (this._tooltip = e, this._onDidChange.fire({ tooltip: e }));
  }
  get class() {
    return this._cssClass;
  }
  set class(e) {
    this._setClass(e);
  }
  _setClass(e) {
    this._cssClass !== e && (this._cssClass = e, this._onDidChange.fire({ class: e }));
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._setEnabled(e);
  }
  _setEnabled(e) {
    this._enabled !== e && (this._enabled = e, this._onDidChange.fire({ enabled: e }));
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    this._setChecked(e);
  }
  _setChecked(e) {
    this._checked !== e && (this._checked = e, this._onDidChange.fire({ checked: e }));
  }
  run(e, t) {
    return h_(this, void 0, void 0, function* () {
      this._actionCallback && (yield this._actionCallback(e));
    });
  }
}
class f_ extends we {
  constructor() {
    super(...arguments), this._onWillRun = this._register(new pe()), this.onWillRun = this._onWillRun.event, this._onDidRun = this._register(new pe()), this.onDidRun = this._onDidRun.event;
  }
  run(e, t) {
    return h_(this, void 0, void 0, function* () {
      if (!e.enabled)
        return;
      this._onWillRun.fire({ action: e });
      let n;
      try {
        yield this.runAction(e, t);
      } catch (r) {
        n = r;
      }
      this._onDidRun.fire({ action: e, error: n });
    });
  }
  runAction(e, t) {
    return h_(this, void 0, void 0, function* () {
      yield e.run(t);
    });
  }
}
class Gr {
  constructor() {
    this.id = Gr.ID, this.label = "", this.tooltip = "", this.class = "separator", this.enabled = !1, this.checked = !1;
  }
  /**
   * Joins all non-empty lists of actions with separators.
   */
  static join(...e) {
    let t = [];
    for (const n of e)
      n.length && (t.length ? t = [...t, new Gr(), ...n] : t = n);
    return t;
  }
  run() {
    return h_(this, void 0, void 0, function* () {
    });
  }
}
Gr.ID = "vs.actions.separator";
class g_ {
  get actions() {
    return this._actions;
  }
  constructor(e, t, n, r) {
    this.tooltip = "", this.enabled = !0, this.checked = void 0, this.id = e, this.label = t, this.class = r, this._actions = n;
  }
  run() {
    return h_(this, void 0, void 0, function* () {
    });
  }
}
class UA extends vo {
  constructor() {
    super(UA.ID, C("submenu.empty", "(empty)"), void 0, !1);
  }
}
UA.ID = "vs.actions.empty";
function Iv(i) {
  var e, t;
  return {
    id: i.id,
    label: i.label,
    class: void 0,
    enabled: (e = i.enabled) !== null && e !== void 0 ? e : !0,
    checked: (t = i.checked) !== null && t !== void 0 ? t : !1,
    run: (...n) => h_(this, void 0, void 0, function* () {
      return i.run(...n);
    }),
    tooltip: i.label
  };
}
var iF;
(function(i) {
  function e(t) {
    return t && typeof t == "object" && typeof t.id == "string";
  }
  i.isThemeColor = e;
})(iF || (iF = {}));
var ft;
(function(i) {
  i.iconNameSegment = "[A-Za-z0-9]+", i.iconNameExpression = "[A-Za-z0-9-]+", i.iconModifierExpression = "~[A-Za-z]+", i.iconNameCharacter = "[A-Za-z0-9~-]";
  const e = new RegExp(`^(${i.iconNameExpression})(${i.iconModifierExpression})?$`);
  function t(h) {
    const f = e.exec(h.id);
    if (!f)
      return t(We.error);
    const [, g, p] = f, m = ["codicon", "codicon-" + g];
    return p && m.push("codicon-modifier-" + p.substring(1)), m;
  }
  i.asClassNameArray = t;
  function n(h) {
    return t(h).join(" ");
  }
  i.asClassName = n;
  function r(h) {
    return "." + t(h).join(".");
  }
  i.asCSSSelector = r;
  function s(h) {
    return h && typeof h == "object" && typeof h.id == "string" && (typeof h.color > "u" || iF.isThemeColor(h.color));
  }
  i.isThemeIcon = s;
  const o = new RegExp(`^\\$\\((${i.iconNameExpression}(?:${i.iconModifierExpression})?)\\)$`);
  function a(h) {
    const f = o.exec(h);
    if (!f)
      return;
    const [, g] = f;
    return { id: g };
  }
  i.fromString = a;
  function l(h) {
    return { id: h };
  }
  i.fromId = l;
  function c(h, f) {
    let g = h.id;
    const p = g.lastIndexOf("~");
    return p !== -1 && (g = g.substring(0, p)), f && (g = `${g}~${f}`), { id: g };
  }
  i.modify = c;
  function d(h) {
    const f = h.id.lastIndexOf("~");
    if (f !== -1)
      return h.id.substring(f + 1);
  }
  i.getModifier = d;
  function u(h, f) {
    var g, p;
    return h.id === f.id && ((g = h.color) === null || g === void 0 ? void 0 : g.id) === ((p = f.color) === null || p === void 0 ? void 0 : p.id);
  }
  i.isEqual = u;
})(ft || (ft = {}));
const Ui = Gt("commandService"), on = new class {
  constructor() {
    this._commands = /* @__PURE__ */ new Map(), this._onDidRegisterCommand = new pe(), this.onDidRegisterCommand = this._onDidRegisterCommand.event;
  }
  registerCommand(i, e) {
    if (!i)
      throw new Error("invalid command");
    if (typeof i == "string") {
      if (!e)
        throw new Error("invalid command");
      return this.registerCommand({ id: i, handler: e });
    }
    if (i.description) {
      const o = [];
      for (const l of i.description.args)
        o.push(l.constraint);
      const a = i.handler;
      i.handler = function(l, ...c) {
        return C6e(c, o), a(l, ...c);
      };
    }
    const { id: t } = i;
    let n = this._commands.get(t);
    n || (n = new fo(), this._commands.set(t, n));
    const r = n.unshift(i), s = Ct(() => {
      r();
      const o = this._commands.get(t);
      o?.isEmpty() && this._commands.delete(t);
    });
    return this._onDidRegisterCommand.fire(t), s;
  }
  registerCommandAlias(i, e) {
    return on.registerCommand(i, (t, ...n) => t.get(Ui).executeCommand(e, ...n));
  }
  getCommand(i) {
    const e = this._commands.get(i);
    if (!(!e || e.isEmpty()))
      return Wt.first(e);
  }
  getCommands() {
    const i = /* @__PURE__ */ new Map();
    for (const e of this._commands.keys()) {
      const t = this.getCommand(e);
      t && i.set(e, t);
    }
    return i;
  }
}();
on.registerCommand("noop", () => {
});
function t6(...i) {
  switch (i.length) {
    case 1:
      return C("contextkey.scanner.hint.didYouMean1", "Did you mean {0}?", i[0]);
    case 2:
      return C("contextkey.scanner.hint.didYouMean2", "Did you mean {0} or {1}?", i[0], i[1]);
    case 3:
      return C("contextkey.scanner.hint.didYouMean3", "Did you mean {0}, {1} or {2}?", i[0], i[1], i[2]);
    default:
      return;
  }
}
const VNe = C("contextkey.scanner.hint.didYouForgetToOpenOrCloseQuote", "Did you forget to open or close the quote?"), HNe = C("contextkey.scanner.hint.didYouForgetToEscapeSlash", "Did you forget to escape the '/' (slash) character? Put two backslashes before it to escape, e.g., '\\\\/'.");
let Kp = class rF {
  constructor() {
    this._input = "", this._start = 0, this._current = 0, this._tokens = [], this._errors = [], this.stringRe = /[a-zA-Z0-9_<>\-\./\\:\*\?\+\[\]\^,#@;"%\$\p{L}-]+/uy;
  }
  static getLexeme(e) {
    switch (e.type) {
      case 0:
        return "(";
      case 1:
        return ")";
      case 2:
        return "!";
      case 3:
        return e.isTripleEq ? "===" : "==";
      case 4:
        return e.isTripleEq ? "!==" : "!=";
      case 5:
        return "<";
      case 6:
        return "<=";
      case 7:
        return ">=";
      case 8:
        return ">=";
      case 9:
        return "=~";
      case 10:
        return e.lexeme;
      case 11:
        return "true";
      case 12:
        return "false";
      case 13:
        return "in";
      case 14:
        return "not";
      case 15:
        return "&&";
      case 16:
        return "||";
      case 17:
        return e.lexeme;
      case 18:
        return e.lexeme;
      case 19:
        return e.lexeme;
      case 20:
        return "EOF";
      default:
        throw Aj(`unhandled token type: ${JSON.stringify(e)}; have you forgotten to add a case?`);
    }
  }
  reset(e) {
    return this._input = e, this._start = 0, this._current = 0, this._tokens = [], this._errors = [], this;
  }
  scan() {
    for (; !this._isAtEnd(); )
      switch (this._start = this._current, this._advance()) {
        case 40:
          this._addToken(
            0
            /* TokenType.LParen */
          );
          break;
        case 41:
          this._addToken(
            1
            /* TokenType.RParen */
          );
          break;
        case 33:
          if (this._match(
            61
            /* CharCode.Equals */
          )) {
            const t = this._match(
              61
              /* CharCode.Equals */
            );
            this._tokens.push({ type: 4, offset: this._start, isTripleEq: t });
          } else
            this._addToken(
              2
              /* TokenType.Neg */
            );
          break;
        case 39:
          this._quotedString();
          break;
        case 47:
          this._regex();
          break;
        case 61:
          if (this._match(
            61
            /* CharCode.Equals */
          )) {
            const t = this._match(
              61
              /* CharCode.Equals */
            );
            this._tokens.push({ type: 3, offset: this._start, isTripleEq: t });
          } else this._match(
            126
            /* CharCode.Tilde */
          ) ? this._addToken(
            9
            /* TokenType.RegexOp */
          ) : this._error(t6("==", "=~"));
          break;
        case 60:
          this._addToken(
            this._match(
              61
              /* CharCode.Equals */
            ) ? 6 : 5
            /* TokenType.Lt */
          );
          break;
        case 62:
          this._addToken(
            this._match(
              61
              /* CharCode.Equals */
            ) ? 8 : 7
            /* TokenType.Gt */
          );
          break;
        case 38:
          this._match(
            38
            /* CharCode.Ampersand */
          ) ? this._addToken(
            15
            /* TokenType.And */
          ) : this._error(t6("&&"));
          break;
        case 124:
          this._match(
            124
            /* CharCode.Pipe */
          ) ? this._addToken(
            16
            /* TokenType.Or */
          ) : this._error(t6("||"));
          break;
        case 32:
        case 13:
        case 9:
        case 10:
        case 160:
          break;
        default:
          this._string();
      }
    return this._start = this._current, this._addToken(
      20
      /* TokenType.EOF */
    ), Array.from(this._tokens);
  }
  _match(e) {
    return this._isAtEnd() || this._input.charCodeAt(this._current) !== e ? !1 : (this._current++, !0);
  }
  _advance() {
    return this._input.charCodeAt(this._current++);
  }
  _peek() {
    return this._isAtEnd() ? 0 : this._input.charCodeAt(this._current);
  }
  _addToken(e) {
    this._tokens.push({ type: e, offset: this._start });
  }
  _error(e) {
    const t = this._start, n = this._input.substring(this._start, this._current), r = { type: 19, offset: this._start, lexeme: n };
    this._errors.push({ offset: t, lexeme: n, additionalInfo: e }), this._tokens.push(r);
  }
  _string() {
    this.stringRe.lastIndex = this._start;
    const e = this.stringRe.exec(this._input);
    if (e) {
      this._current = this._start + e[0].length;
      const t = this._input.substring(this._start, this._current), n = rF._keywords.get(t);
      n ? this._addToken(n) : this._tokens.push({ type: 17, lexeme: t, offset: this._start });
    }
  }
  // captures the lexeme without the leading and trailing '
  _quotedString() {
    for (; this._peek() !== 39 && !this._isAtEnd(); )
      this._advance();
    if (this._isAtEnd()) {
      this._error(VNe);
      return;
    }
    this._advance(), this._tokens.push({ type: 18, lexeme: this._input.substring(this._start + 1, this._current - 1), offset: this._start + 1 });
  }
  /*
   * Lexing a regex expression: /.../[igsmyu]*
   * Based on https://github.com/microsoft/TypeScript/blob/9247ef115e617805983740ba795d7a8164babf89/src/compiler/scanner.ts#L2129-L2181
   *
   * Note that we want slashes within a regex to be escaped, e.g., /file:\\/\\/\\// should match `file:///`
   */
  _regex() {
    let e = this._current, t = !1, n = !1;
    for (; ; ) {
      if (e >= this._input.length) {
        this._current = e, this._error(HNe);
        return;
      }
      const s = this._input.charCodeAt(e);
      if (t)
        t = !1;
      else if (s === 47 && !n) {
        e++;
        break;
      } else s === 91 ? n = !0 : s === 92 ? t = !0 : s === 93 && (n = !1);
      e++;
    }
    for (; e < this._input.length && rF._regexFlags.has(this._input.charCodeAt(e)); )
      e++;
    this._current = e;
    const r = this._input.substring(this._start, this._current);
    this._tokens.push({ type: 10, lexeme: r, offset: this._start });
  }
  _isAtEnd() {
    return this._current >= this._input.length;
  }
};
Kp._regexFlags = new Set(["i", "g", "s", "m", "y", "u"].map((i) => i.charCodeAt(0)));
Kp._keywords = /* @__PURE__ */ new Map([
  [
    "not",
    14
    /* TokenType.Not */
  ],
  [
    "in",
    13
    /* TokenType.In */
  ],
  [
    "false",
    12
    /* TokenType.False */
  ],
  [
    "true",
    11
    /* TokenType.True */
  ]
]);
const Hs = /* @__PURE__ */ new Map();
Hs.set("false", !1);
Hs.set("true", !0);
Hs.set("isMac", sn);
Hs.set("isLinux", $s);
Hs.set("isWindows", Ls);
Hs.set("isWeb", sp);
Hs.set("isMacNative", sn && !sp);
Hs.set("isEdge", R6e);
Hs.set("isFirefox", O6e);
Hs.set("isChrome", jue);
Hs.set("isSafari", M6e);
const WNe = Object.prototype.hasOwnProperty, jNe = {
  regexParsingWithErrorRecovery: !0
}, zNe = C("contextkey.parser.error.emptyString", "Empty context key expression"), UNe = C("contextkey.parser.error.emptyString.hint", "Did you forget to write an expression? You can also put 'false' or 'true' to always evaluate to false or true, respectively."), GNe = C("contextkey.parser.error.noInAfterNot", "'in' after 'not'."), iX = C("contextkey.parser.error.closingParenthesis", "closing parenthesis ')'"), qNe = C("contextkey.parser.error.unexpectedToken", "Unexpected token"), KNe = C("contextkey.parser.error.unexpectedToken.hint", "Did you forget to put && or || before the token?"), YNe = C("contextkey.parser.error.unexpectedEOF", "Unexpected end of expression"), XNe = C("contextkey.parser.error.unexpectedEOF.hint", "Did you forget to put a context key?");
let yhe = class W2 {
  constructor(e = jNe) {
    this._config = e, this._scanner = new Kp(), this._tokens = [], this._current = 0, this._parsingErrors = [], this._flagsGYRe = /g|y/g;
  }
  /**
   * Parse a context key expression.
   *
   * @param input the expression to parse
   * @returns the parsed expression or `undefined` if there's an error - call `lexingErrors` and `parsingErrors` to see the errors
   */
  parse(e) {
    if (e === "") {
      this._parsingErrors.push({ message: zNe, offset: 0, lexeme: "", additionalInfo: UNe });
      return;
    }
    this._tokens = this._scanner.reset(e).scan(), this._current = 0, this._parsingErrors = [];
    try {
      const t = this._expr();
      if (!this._isAtEnd()) {
        const n = this._peek(), r = n.type === 17 ? KNe : void 0;
        throw this._parsingErrors.push({ message: qNe, offset: n.offset, lexeme: Kp.getLexeme(n), additionalInfo: r }), W2._parseError;
      }
      return t;
    } catch (t) {
      if (t !== W2._parseError)
        throw t;
      return;
    }
  }
  _expr() {
    return this._or();
  }
  _or() {
    const e = [this._and()];
    for (; this._matchOne(
      16
      /* TokenType.Or */
    ); ) {
      const t = this._and();
      e.push(t);
    }
    return e.length === 1 ? e[0] : ke.or(...e);
  }
  _and() {
    const e = [this._term()];
    for (; this._matchOne(
      15
      /* TokenType.And */
    ); ) {
      const t = this._term();
      e.push(t);
    }
    return e.length === 1 ? e[0] : ke.and(...e);
  }
  _term() {
    if (this._matchOne(
      2
      /* TokenType.Neg */
    )) {
      const e = this._peek();
      switch (e.type) {
        case 11:
          return this._advance(), _o.INSTANCE;
        case 12:
          return this._advance(), Fo.INSTANCE;
        case 0: {
          this._advance();
          const t = this._expr();
          return this._consume(1, iX), t?.negate();
        }
        case 17:
          return this._advance(), T0.create(e.lexeme);
        default:
          throw this._errExpectedButGot("KEY | true | false | '(' expression ')'", e);
      }
    }
    return this._primary();
  }
  _primary() {
    const e = this._peek();
    switch (e.type) {
      case 11:
        return this._advance(), ke.true();
      case 12:
        return this._advance(), ke.false();
      case 0: {
        this._advance();
        const t = this._expr();
        return this._consume(1, iX), t;
      }
      case 17: {
        const t = e.lexeme;
        if (this._advance(), this._matchOne(
          9
          /* TokenType.RegexOp */
        )) {
          const r = this._peek();
          if (!this._config.regexParsingWithErrorRecovery) {
            if (this._advance(), r.type !== 10)
              throw this._errExpectedButGot("REGEX", r);
            const s = r.lexeme, o = s.lastIndexOf("/"), a = o === s.length - 1 ? void 0 : this._removeFlagsGY(s.substring(o + 1));
            let l;
            try {
              l = new RegExp(s.substring(1, o), a);
            } catch {
              throw this._errExpectedButGot("REGEX", r);
            }
            return Ly.create(t, l);
          }
          switch (r.type) {
            case 10:
            case 19: {
              const s = [r.lexeme];
              this._advance();
              let o = this._peek(), a = 0;
              for (let h = 0; h < r.lexeme.length; h++)
                r.lexeme.charCodeAt(h) === 40 ? a++ : r.lexeme.charCodeAt(h) === 41 && a--;
              for (; !this._isAtEnd() && o.type !== 15 && o.type !== 16; ) {
                switch (o.type) {
                  case 0:
                    a++;
                    break;
                  case 1:
                    a--;
                    break;
                  case 10:
                  case 18:
                    for (let h = 0; h < o.lexeme.length; h++)
                      o.lexeme.charCodeAt(h) === 40 ? a++ : r.lexeme.charCodeAt(h) === 41 && a--;
                }
                if (a < 0)
                  break;
                s.push(Kp.getLexeme(o)), this._advance(), o = this._peek();
              }
              const l = s.join(""), c = l.lastIndexOf("/"), d = c === l.length - 1 ? void 0 : this._removeFlagsGY(l.substring(c + 1));
              let u;
              try {
                u = new RegExp(l.substring(1, c), d);
              } catch {
                throw this._errExpectedButGot("REGEX", r);
              }
              return ke.regex(t, u);
            }
            case 18: {
              const s = r.lexeme;
              this._advance();
              let o = null;
              if (!dhe(s)) {
                const a = s.indexOf("/"), l = s.lastIndexOf("/");
                if (a !== l && a >= 0) {
                  const c = s.slice(a + 1, l), d = s[l + 1] === "i" ? "i" : "";
                  try {
                    o = new RegExp(c, d);
                  } catch {
                    throw this._errExpectedButGot("REGEX", r);
                  }
                }
              }
              if (o === null)
                throw this._errExpectedButGot("REGEX", r);
              return Ly.create(t, o);
            }
            default:
              throw this._errExpectedButGot("REGEX", this._peek());
          }
        }
        if (this._matchOne(
          14
          /* TokenType.Not */
        )) {
          this._consume(13, GNe);
          const r = this._value();
          return ke.notIn(t, r);
        }
        switch (this._peek().type) {
          case 3: {
            this._advance();
            const r = this._value();
            if (this._previous().type === 18)
              return ke.equals(t, r);
            switch (r) {
              case "true":
                return ke.has(t);
              case "false":
                return ke.not(t);
              default:
                return ke.equals(t, r);
            }
          }
          case 4: {
            this._advance();
            const r = this._value();
            if (this._previous().type === 18)
              return ke.notEquals(t, r);
            switch (r) {
              case "true":
                return ke.not(t);
              case "false":
                return ke.has(t);
              default:
                return ke.notEquals(t, r);
            }
          }
          case 5:
            return this._advance(), QA.create(t, this._value());
          case 6:
            return this._advance(), JA.create(t, this._value());
          case 7:
            return this._advance(), XA.create(t, this._value());
          case 8:
            return this._advance(), ZA.create(t, this._value());
          case 13:
            return this._advance(), ke.in(t, this._value());
          default:
            return ke.has(t);
        }
      }
      case 20:
        throw this._parsingErrors.push({ message: YNe, offset: e.offset, lexeme: "", additionalInfo: XNe }), W2._parseError;
      default:
        throw this._errExpectedButGot(`true | false | KEY 
	| KEY '=~' REGEX 
	| KEY ('==' | '!=' | '<' | '<=' | '>' | '>=' | 'in' | 'not' 'in') value`, this._peek());
    }
  }
  _value() {
    const e = this._peek();
    switch (e.type) {
      case 17:
      case 18:
        return this._advance(), e.lexeme;
      case 11:
        return this._advance(), "true";
      case 12:
        return this._advance(), "false";
      case 13:
        return this._advance(), "in";
      default:
        return "";
    }
  }
  _removeFlagsGY(e) {
    return e.replaceAll(this._flagsGYRe, "");
  }
  // careful: this can throw if current token is the initial one (ie index = 0)
  _previous() {
    return this._tokens[this._current - 1];
  }
  _matchOne(e) {
    return this._check(e) ? (this._advance(), !0) : !1;
  }
  _advance() {
    return this._isAtEnd() || this._current++, this._previous();
  }
  _consume(e, t) {
    if (this._check(e))
      return this._advance();
    throw this._errExpectedButGot(t, this._peek());
  }
  _errExpectedButGot(e, t, n) {
    const r = C("contextkey.parser.error.expectedButGot", `Expected: {0}
Received: '{1}'.`, e, Kp.getLexeme(t)), s = t.offset, o = Kp.getLexeme(t);
    return this._parsingErrors.push({ message: r, offset: s, lexeme: o, additionalInfo: n }), W2._parseError;
  }
  _check(e) {
    return this._peek().type === e;
  }
  _peek() {
    return this._tokens[this._current];
  }
  _isAtEnd() {
    return this._peek().type === 20;
  }
};
yhe._parseError = new Error();
class ke {
  static false() {
    return _o.INSTANCE;
  }
  static true() {
    return Fo.INSTANCE;
  }
  static has(e) {
    return k0.create(e);
  }
  static equals(e, t) {
    return hb.create(e, t);
  }
  static notEquals(e, t) {
    return KA.create(e, t);
  }
  static regex(e, t) {
    return Ly.create(e, t);
  }
  static in(e, t) {
    return GA.create(e, t);
  }
  static notIn(e, t) {
    return qA.create(e, t);
  }
  static not(e) {
    return T0.create(e);
  }
  static and(...e) {
    return lm.create(e, null, !0);
  }
  static or(...e) {
    return mh.create(e, null, !0);
  }
  static deserialize(e) {
    return e == null ? void 0 : this._parser.parse(e);
  }
}
ke._parser = new yhe({ regexParsingWithErrorRecovery: !1 });
function ZNe(i, e) {
  const t = i ? i.substituteConstants() : void 0, n = e ? e.substituteConstants() : void 0;
  return !t && !n ? !0 : !t || !n ? !1 : t.equals(n);
}
function yC(i, e) {
  return i.cmp(e);
}
class _o {
  constructor() {
    this.type = 0;
  }
  cmp(e) {
    return this.type - e.type;
  }
  equals(e) {
    return e.type === this.type;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !1;
  }
  serialize() {
    return "false";
  }
  keys() {
    return [];
  }
  negate() {
    return Fo.INSTANCE;
  }
}
_o.INSTANCE = new _o();
class Fo {
  constructor() {
    this.type = 1;
  }
  cmp(e) {
    return this.type - e.type;
  }
  equals(e) {
    return e.type === this.type;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !0;
  }
  serialize() {
    return "true";
  }
  keys() {
    return [];
  }
  negate() {
    return _o.INSTANCE;
  }
}
Fo.INSTANCE = new Fo();
class k0 {
  static create(e, t = null) {
    const n = Hs.get(e);
    return typeof n == "boolean" ? n ? Fo.INSTANCE : _o.INSTANCE : new k0(e, t);
  }
  constructor(e, t) {
    this.key = e, this.negated = t, this.type = 2;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : She(this.key, e.key);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key : !1;
  }
  substituteConstants() {
    const e = Hs.get(this.key);
    return typeof e == "boolean" ? e ? Fo.INSTANCE : _o.INSTANCE : this;
  }
  evaluate(e) {
    return !!e.getValue(this.key);
  }
  serialize() {
    return this.key;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = T0.create(this.key, this)), this.negated;
  }
}
class hb {
  static create(e, t, n = null) {
    if (typeof t == "boolean")
      return t ? k0.create(e, n) : T0.create(e, n);
    const r = Hs.get(e);
    return typeof r == "boolean" ? t === (r ? "true" : "false") ? Fo.INSTANCE : _o.INSTANCE : new hb(e, t, n);
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 4;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : N0(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    const e = Hs.get(this.key);
    if (typeof e == "boolean") {
      const t = e ? "true" : "false";
      return this.value === t ? Fo.INSTANCE : _o.INSTANCE;
    }
    return this;
  }
  evaluate(e) {
    return e.getValue(this.key) == this.value;
  }
  serialize() {
    return `${this.key} == '${this.value}'`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = KA.create(this.key, this.value, this)), this.negated;
  }
}
class GA {
  static create(e, t) {
    return new GA(e, t);
  }
  constructor(e, t) {
    this.key = e, this.valueKey = t, this.type = 10, this.negated = null;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : N0(this.key, this.valueKey, e.key, e.valueKey);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.valueKey === e.valueKey : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    const t = e.getValue(this.valueKey), n = e.getValue(this.key);
    return Array.isArray(t) ? t.includes(n) : typeof n == "string" && typeof t == "object" && t !== null ? WNe.call(t, n) : !1;
  }
  serialize() {
    return `${this.key} in '${this.valueKey}'`;
  }
  keys() {
    return [this.key, this.valueKey];
  }
  negate() {
    return this.negated || (this.negated = qA.create(this.key, this.valueKey)), this.negated;
  }
}
class qA {
  static create(e, t) {
    return new qA(e, t);
  }
  constructor(e, t) {
    this.key = e, this.valueKey = t, this.type = 11, this._negated = GA.create(e, t);
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : this._negated.cmp(e._negated);
  }
  equals(e) {
    return e.type === this.type ? this._negated.equals(e._negated) : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !this._negated.evaluate(e);
  }
  serialize() {
    return `${this.key} not in '${this.valueKey}'`;
  }
  keys() {
    return this._negated.keys();
  }
  negate() {
    return this._negated;
  }
}
class KA {
  static create(e, t, n = null) {
    if (typeof t == "boolean")
      return t ? T0.create(e, n) : k0.create(e, n);
    const r = Hs.get(e);
    return typeof r == "boolean" ? t === (r ? "true" : "false") ? _o.INSTANCE : Fo.INSTANCE : new KA(e, t, n);
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 5;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : N0(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    const e = Hs.get(this.key);
    if (typeof e == "boolean") {
      const t = e ? "true" : "false";
      return this.value === t ? _o.INSTANCE : Fo.INSTANCE;
    }
    return this;
  }
  evaluate(e) {
    return e.getValue(this.key) != this.value;
  }
  serialize() {
    return `${this.key} != '${this.value}'`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = hb.create(this.key, this.value, this)), this.negated;
  }
}
class T0 {
  static create(e, t = null) {
    const n = Hs.get(e);
    return typeof n == "boolean" ? n ? _o.INSTANCE : Fo.INSTANCE : new T0(e, t);
  }
  constructor(e, t) {
    this.key = e, this.negated = t, this.type = 3;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : She(this.key, e.key);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key : !1;
  }
  substituteConstants() {
    const e = Hs.get(this.key);
    return typeof e == "boolean" ? e ? _o.INSTANCE : Fo.INSTANCE : this;
  }
  evaluate(e) {
    return !e.getValue(this.key);
  }
  serialize() {
    return `!${this.key}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = k0.create(this.key, this)), this.negated;
  }
}
function YA(i, e) {
  if (typeof i == "string") {
    const t = parseFloat(i);
    isNaN(t) || (i = t);
  }
  return typeof i == "string" || typeof i == "number" ? e(i) : _o.INSTANCE;
}
class XA {
  static create(e, t, n = null) {
    return YA(t, (r) => new XA(e, r, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 12;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : N0(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value == "string" ? !1 : parseFloat(e.getValue(this.key)) > this.value;
  }
  serialize() {
    return `${this.key} > ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = JA.create(this.key, this.value, this)), this.negated;
  }
}
class ZA {
  static create(e, t, n = null) {
    return YA(t, (r) => new ZA(e, r, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 13;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : N0(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value == "string" ? !1 : parseFloat(e.getValue(this.key)) >= this.value;
  }
  serialize() {
    return `${this.key} >= ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = QA.create(this.key, this.value, this)), this.negated;
  }
}
class QA {
  static create(e, t, n = null) {
    return YA(t, (r) => new QA(e, r, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 14;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : N0(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value == "string" ? !1 : parseFloat(e.getValue(this.key)) < this.value;
  }
  serialize() {
    return `${this.key} < ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = ZA.create(this.key, this.value, this)), this.negated;
  }
}
class JA {
  static create(e, t, n = null) {
    return YA(t, (r) => new JA(e, r, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 15;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : N0(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value == "string" ? !1 : parseFloat(e.getValue(this.key)) <= this.value;
  }
  serialize() {
    return `${this.key} <= ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = XA.create(this.key, this.value, this)), this.negated;
  }
}
class Ly {
  static create(e, t) {
    return new Ly(e, t);
  }
  constructor(e, t) {
    this.key = e, this.regexp = t, this.type = 7, this.negated = null;
  }
  cmp(e) {
    if (e.type !== this.type)
      return this.type - e.type;
    if (this.key < e.key)
      return -1;
    if (this.key > e.key)
      return 1;
    const t = this.regexp ? this.regexp.source : "", n = e.regexp ? e.regexp.source : "";
    return t < n ? -1 : t > n ? 1 : 0;
  }
  equals(e) {
    if (e.type === this.type) {
      const t = this.regexp ? this.regexp.source : "", n = e.regexp ? e.regexp.source : "";
      return this.key === e.key && t === n;
    }
    return !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    const t = e.getValue(this.key);
    return this.regexp ? this.regexp.test(t) : !1;
  }
  serialize() {
    const e = this.regexp ? `/${this.regexp.source}/${this.regexp.flags}` : "/invalid/";
    return `${this.key} =~ ${e}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = qj.create(this)), this.negated;
  }
}
class qj {
  static create(e) {
    return new qj(e);
  }
  constructor(e) {
    this._actual = e, this.type = 8;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : this._actual.cmp(e._actual);
  }
  equals(e) {
    return e.type === this.type ? this._actual.equals(e._actual) : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !this._actual.evaluate(e);
  }
  serialize() {
    return `!(${this._actual.serialize()})`;
  }
  keys() {
    return this._actual.keys();
  }
  negate() {
    return this._actual;
  }
}
function whe(i) {
  let e = null;
  for (let t = 0, n = i.length; t < n; t++) {
    const r = i[t].substituteConstants();
    if (i[t] !== r && e === null) {
      e = [];
      for (let s = 0; s < t; s++)
        e[s] = i[s];
    }
    e !== null && (e[t] = r);
  }
  return e === null ? i : e;
}
class lm {
  static create(e, t, n) {
    return lm._normalizeArr(e, t, n);
  }
  constructor(e, t) {
    this.expr = e, this.negated = t, this.type = 6;
  }
  cmp(e) {
    if (e.type !== this.type)
      return this.type - e.type;
    if (this.expr.length < e.expr.length)
      return -1;
    if (this.expr.length > e.expr.length)
      return 1;
    for (let t = 0, n = this.expr.length; t < n; t++) {
      const r = yC(this.expr[t], e.expr[t]);
      if (r !== 0)
        return r;
    }
    return 0;
  }
  equals(e) {
    if (e.type === this.type) {
      if (this.expr.length !== e.expr.length)
        return !1;
      for (let t = 0, n = this.expr.length; t < n; t++)
        if (!this.expr[t].equals(e.expr[t]))
          return !1;
      return !0;
    }
    return !1;
  }
  substituteConstants() {
    const e = whe(this.expr);
    return e === this.expr ? this : lm.create(e, this.negated, !1);
  }
  evaluate(e) {
    for (let t = 0, n = this.expr.length; t < n; t++)
      if (!this.expr[t].evaluate(e))
        return !1;
    return !0;
  }
  static _normalizeArr(e, t, n) {
    const r = [];
    let s = !1;
    for (const o of e)
      if (o) {
        if (o.type === 1) {
          s = !0;
          continue;
        }
        if (o.type === 0)
          return _o.INSTANCE;
        if (o.type === 6) {
          r.push(...o.expr);
          continue;
        }
        r.push(o);
      }
    if (r.length === 0 && s)
      return Fo.INSTANCE;
    if (r.length !== 0) {
      if (r.length === 1)
        return r[0];
      r.sort(yC);
      for (let o = 1; o < r.length; o++)
        r[o - 1].equals(r[o]) && (r.splice(o, 1), o--);
      if (r.length === 1)
        return r[0];
      for (; r.length > 1; ) {
        const o = r[r.length - 1];
        if (o.type !== 9)
          break;
        r.pop();
        const a = r.pop(), l = r.length === 0, c = mh.create(o.expr.map((d) => lm.create([d, a], null, n)), null, l);
        c && (r.push(c), r.sort(yC));
      }
      if (r.length === 1)
        return r[0];
      if (n) {
        for (let o = 0; o < r.length; o++)
          for (let a = o + 1; a < r.length; a++)
            if (r[o].negate().equals(r[a]))
              return _o.INSTANCE;
        if (r.length === 1)
          return r[0];
      }
      return new lm(r, t);
    }
  }
  serialize() {
    return this.expr.map((e) => e.serialize()).join(" && ");
  }
  keys() {
    const e = [];
    for (const t of this.expr)
      e.push(...t.keys());
    return e;
  }
  negate() {
    if (!this.negated) {
      const e = [];
      for (const t of this.expr)
        e.push(t.negate());
      this.negated = mh.create(e, this, !0);
    }
    return this.negated;
  }
}
class mh {
  static create(e, t, n) {
    return mh._normalizeArr(e, t, n);
  }
  constructor(e, t) {
    this.expr = e, this.negated = t, this.type = 9;
  }
  cmp(e) {
    if (e.type !== this.type)
      return this.type - e.type;
    if (this.expr.length < e.expr.length)
      return -1;
    if (this.expr.length > e.expr.length)
      return 1;
    for (let t = 0, n = this.expr.length; t < n; t++) {
      const r = yC(this.expr[t], e.expr[t]);
      if (r !== 0)
        return r;
    }
    return 0;
  }
  equals(e) {
    if (e.type === this.type) {
      if (this.expr.length !== e.expr.length)
        return !1;
      for (let t = 0, n = this.expr.length; t < n; t++)
        if (!this.expr[t].equals(e.expr[t]))
          return !1;
      return !0;
    }
    return !1;
  }
  substituteConstants() {
    const e = whe(this.expr);
    return e === this.expr ? this : mh.create(e, this.negated, !1);
  }
  evaluate(e) {
    for (let t = 0, n = this.expr.length; t < n; t++)
      if (this.expr[t].evaluate(e))
        return !0;
    return !1;
  }
  static _normalizeArr(e, t, n) {
    let r = [], s = !1;
    if (e) {
      for (let o = 0, a = e.length; o < a; o++) {
        const l = e[o];
        if (l) {
          if (l.type === 0) {
            s = !0;
            continue;
          }
          if (l.type === 1)
            return Fo.INSTANCE;
          if (l.type === 9) {
            r = r.concat(l.expr);
            continue;
          }
          r.push(l);
        }
      }
      if (r.length === 0 && s)
        return _o.INSTANCE;
      r.sort(yC);
    }
    if (r.length !== 0) {
      if (r.length === 1)
        return r[0];
      for (let o = 1; o < r.length; o++)
        r[o - 1].equals(r[o]) && (r.splice(o, 1), o--);
      if (r.length === 1)
        return r[0];
      if (n) {
        for (let o = 0; o < r.length; o++)
          for (let a = o + 1; a < r.length; a++)
            if (r[o].negate().equals(r[a]))
              return Fo.INSTANCE;
        if (r.length === 1)
          return r[0];
      }
      return new mh(r, t);
    }
  }
  serialize() {
    return this.expr.map((e) => e.serialize()).join(" || ");
  }
  keys() {
    const e = [];
    for (const t of this.expr)
      e.push(...t.keys());
    return e;
  }
  negate() {
    if (!this.negated) {
      const e = [];
      for (const t of this.expr)
        e.push(t.negate());
      for (; e.length > 1; ) {
        const t = e.shift(), n = e.shift(), r = [];
        for (const s of sX(t))
          for (const o of sX(n))
            r.push(lm.create([s, o], null, !1));
        e.unshift(mh.create(r, null, !1));
      }
      this.negated = mh.create(e, this, !0);
    }
    return this.negated;
  }
}
class Ke extends k0 {
  static all() {
    return Ke._info.values();
  }
  constructor(e, t, n) {
    super(e, null), this._defaultValue = t, typeof n == "object" ? Ke._info.push(Object.assign(Object.assign({}, n), { key: e })) : n !== !0 && Ke._info.push({ key: e, description: n, type: t != null ? typeof t : void 0 });
  }
  bindTo(e) {
    return e.createKey(this.key, this._defaultValue);
  }
  getValue(e) {
    return e.getContextKeyValue(this.key);
  }
  toNegated() {
    return this.negate();
  }
  isEqualTo(e) {
    return hb.create(this.key, e);
  }
}
Ke._info = [];
const yt = Gt("contextKeyService");
function She(i, e) {
  return i < e ? -1 : i > e ? 1 : 0;
}
function N0(i, e, t, n) {
  return i < t ? -1 : i > t ? 1 : e < n ? -1 : e > n ? 1 : 0;
}
function sF(i, e) {
  if (i.type === 0 || e.type === 1)
    return !0;
  if (i.type === 9)
    return e.type === 9 ? rX(i.expr, e.expr) : !1;
  if (e.type === 9) {
    for (const t of e.expr)
      if (sF(i, t))
        return !0;
    return !1;
  }
  if (i.type === 6) {
    if (e.type === 6)
      return rX(e.expr, i.expr);
    for (const t of i.expr)
      if (sF(t, e))
        return !0;
    return !1;
  }
  return i.equals(e);
}
function rX(i, e) {
  let t = 0, n = 0;
  for (; t < i.length && n < e.length; ) {
    const r = i[t].cmp(e[n]);
    if (r < 0)
      return !1;
    r === 0 && t++, n++;
  }
  return t === i.length;
}
function sX(i) {
  return i.type === 9 ? i.expr : [i];
}
function oF(i, e) {
  if (typeof i == "number") {
    if (i === 0)
      return null;
    const t = (i & 65535) >>> 0, n = (i & 4294901760) >>> 16;
    return n !== 0 ? new n6([
      Bx(t, e),
      Bx(n, e)
    ]) : new n6([Bx(t, e)]);
  } else {
    const t = [];
    for (let n = 0; n < i.length; n++)
      t.push(Bx(i[n], e));
    return new n6(t);
  }
}
function Bx(i, e) {
  const t = !!(i & 2048), n = !!(i & 256), r = e === 2 ? n : t, s = !!(i & 1024), o = !!(i & 512), a = e === 2 ? t : n, l = i & 255;
  return new Qh(r, s, o, a, l);
}
class Qh {
  constructor(e, t, n, r, s) {
    this.ctrlKey = e, this.shiftKey = t, this.altKey = n, this.metaKey = r, this.keyCode = s;
  }
  equals(e) {
    return e instanceof Qh && this.ctrlKey === e.ctrlKey && this.shiftKey === e.shiftKey && this.altKey === e.altKey && this.metaKey === e.metaKey && this.keyCode === e.keyCode;
  }
  isModifierKey() {
    return this.keyCode === 0 || this.keyCode === 5 || this.keyCode === 57 || this.keyCode === 6 || this.keyCode === 4;
  }
  /**
   * Does this keybinding refer to the key code of a modifier and it also has the modifier flag?
   */
  isDuplicateModifierCase() {
    return this.ctrlKey && this.keyCode === 5 || this.shiftKey && this.keyCode === 4 || this.altKey && this.keyCode === 6 || this.metaKey && this.keyCode === 57;
  }
}
class n6 {
  constructor(e) {
    if (e.length === 0)
      throw fl("chords");
    this.chords = e;
  }
}
class QNe {
  constructor(e, t, n, r, s, o) {
    this.ctrlKey = e, this.shiftKey = t, this.altKey = n, this.metaKey = r, this.keyLabel = s, this.keyAriaLabel = o;
  }
}
class JNe {
}
function i6(i, e) {
  if (!i)
    throw new Error(e ? `Assertion failed (${e})` : "Assertion Failed");
}
function $A(i, e = "Unreachable") {
  throw new Error(e);
}
function Iy(i) {
  if (!i()) {
    debugger;
    i(), It(new gr("Assertion Failed"));
  }
}
function xhe(i, e) {
  let t = 0;
  for (; t < i.length - 1; ) {
    const n = i[t], r = i[t + 1];
    if (!e(n, r))
      return !1;
    t++;
  }
  return !0;
}
class $Ne {
  constructor() {
    this.data = /* @__PURE__ */ new Map();
  }
  add(e, t) {
    i6(mo(e)), i6(ho(t)), i6(!this.data.has(e), "There is already an extension with this id"), this.data.set(e, t);
  }
  as(e) {
    return this.data.get(e) || null;
  }
}
const Di = new $Ne();
class Kj {
  constructor() {
    this._coreKeybindings = new fo(), this._extensionKeybindings = [], this._cachedMergedKeybindings = null;
  }
  /**
   * Take current platform into account and reduce to primary & secondary.
   */
  static bindToCurrentPlatform(e) {
    if (ka === 1) {
      if (e && e.win)
        return e.win;
    } else if (ka === 2) {
      if (e && e.mac)
        return e.mac;
    } else if (e && e.linux)
      return e.linux;
    return e;
  }
  registerKeybindingRule(e) {
    const t = Kj.bindToCurrentPlatform(e), n = new Ne();
    if (t && t.primary) {
      const r = oF(t.primary, ka);
      r && n.add(this._registerDefaultKeybinding(r, e.id, e.args, e.weight, 0, e.when));
    }
    if (t && Array.isArray(t.secondary))
      for (let r = 0, s = t.secondary.length; r < s; r++) {
        const o = t.secondary[r], a = oF(o, ka);
        a && n.add(this._registerDefaultKeybinding(a, e.id, e.args, e.weight, -r - 1, e.when));
      }
    return n;
  }
  registerCommandAndKeybindingRule(e) {
    return Ql(this.registerKeybindingRule(e), on.registerCommand(e));
  }
  _registerDefaultKeybinding(e, t, n, r, s, o) {
    const a = this._coreKeybindings.push({
      keybinding: e,
      command: t,
      commandArgs: n,
      when: o,
      weight1: r,
      weight2: s,
      extensionId: null,
      isBuiltinExtension: !1
    });
    return this._cachedMergedKeybindings = null, Ct(() => {
      a(), this._cachedMergedKeybindings = null;
    });
  }
  getDefaultKeybindings() {
    return this._cachedMergedKeybindings || (this._cachedMergedKeybindings = Array.from(this._coreKeybindings).concat(this._extensionKeybindings), this._cachedMergedKeybindings.sort(t9e)), this._cachedMergedKeybindings.slice(0);
  }
}
const Bo = new Kj(), e9e = {
  EditorModes: "platform.keybindingsRegistry"
};
Di.add(e9e.EditorModes, Bo);
function t9e(i, e) {
  if (i.weight1 !== e.weight1)
    return i.weight1 - e.weight1;
  if (i.command && e.command) {
    if (i.command < e.command)
      return -1;
    if (i.command > e.command)
      return 1;
  }
  return i.weight2 - e.weight2;
}
var n9e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, oX = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, i9e = function(i, e) {
  var t = {};
  for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && e.indexOf(n) < 0 && (t[n] = i[n]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(i); r < n.length; r++)
      e.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(i, n[r]) && (t[n[r]] = i[n[r]]);
  return t;
}, N3;
function Y1(i) {
  return i.command !== void 0;
}
function r9e(i) {
  return i.submenu !== void 0;
}
class J {
  /**
   * Create a new `MenuId` with the unique identifier. Will throw if a menu
   * with the identifier already exists, use `MenuId.for(ident)` or a unique
   * identifier
   */
  constructor(e) {
    if (J._instances.has(e))
      throw new TypeError(`MenuId with identifier '${e}' already exists. Use MenuId.for(ident) or a unique identifier`);
    J._instances.set(e, this), this.id = e;
  }
}
J._instances = /* @__PURE__ */ new Map();
J.CommandPalette = new J("CommandPalette");
J.DebugBreakpointsContext = new J("DebugBreakpointsContext");
J.DebugCallStackContext = new J("DebugCallStackContext");
J.DebugConsoleContext = new J("DebugConsoleContext");
J.DebugVariablesContext = new J("DebugVariablesContext");
J.DebugWatchContext = new J("DebugWatchContext");
J.DebugToolBar = new J("DebugToolBar");
J.DebugToolBarStop = new J("DebugToolBarStop");
J.EditorContext = new J("EditorContext");
J.SimpleEditorContext = new J("SimpleEditorContext");
J.EditorContent = new J("EditorContent");
J.EditorLineNumberContext = new J("EditorLineNumberContext");
J.EditorContextCopy = new J("EditorContextCopy");
J.EditorContextPeek = new J("EditorContextPeek");
J.EditorContextShare = new J("EditorContextShare");
J.EditorTitle = new J("EditorTitle");
J.EditorTitleRun = new J("EditorTitleRun");
J.EditorTitleContext = new J("EditorTitleContext");
J.EditorTitleContextShare = new J("EditorTitleContextShare");
J.EmptyEditorGroup = new J("EmptyEditorGroup");
J.EmptyEditorGroupContext = new J("EmptyEditorGroupContext");
J.EditorTabsBarContext = new J("EditorTabsBarContext");
J.ExplorerContext = new J("ExplorerContext");
J.ExplorerContextShare = new J("ExplorerContextShare");
J.ExtensionContext = new J("ExtensionContext");
J.GlobalActivity = new J("GlobalActivity");
J.CommandCenter = new J("CommandCenter");
J.CommandCenterCenter = new J("CommandCenterCenter");
J.LayoutControlMenuSubmenu = new J("LayoutControlMenuSubmenu");
J.LayoutControlMenu = new J("LayoutControlMenu");
J.MenubarMainMenu = new J("MenubarMainMenu");
J.MenubarAppearanceMenu = new J("MenubarAppearanceMenu");
J.MenubarDebugMenu = new J("MenubarDebugMenu");
J.MenubarEditMenu = new J("MenubarEditMenu");
J.MenubarCopy = new J("MenubarCopy");
J.MenubarFileMenu = new J("MenubarFileMenu");
J.MenubarGoMenu = new J("MenubarGoMenu");
J.MenubarHelpMenu = new J("MenubarHelpMenu");
J.MenubarLayoutMenu = new J("MenubarLayoutMenu");
J.MenubarNewBreakpointMenu = new J("MenubarNewBreakpointMenu");
J.PanelAlignmentMenu = new J("PanelAlignmentMenu");
J.PanelPositionMenu = new J("PanelPositionMenu");
J.MenubarPreferencesMenu = new J("MenubarPreferencesMenu");
J.MenubarRecentMenu = new J("MenubarRecentMenu");
J.MenubarSelectionMenu = new J("MenubarSelectionMenu");
J.MenubarShare = new J("MenubarShare");
J.MenubarSwitchEditorMenu = new J("MenubarSwitchEditorMenu");
J.MenubarSwitchGroupMenu = new J("MenubarSwitchGroupMenu");
J.MenubarTerminalMenu = new J("MenubarTerminalMenu");
J.MenubarViewMenu = new J("MenubarViewMenu");
J.MenubarHomeMenu = new J("MenubarHomeMenu");
J.OpenEditorsContext = new J("OpenEditorsContext");
J.OpenEditorsContextShare = new J("OpenEditorsContextShare");
J.ProblemsPanelContext = new J("ProblemsPanelContext");
J.SCMChangeContext = new J("SCMChangeContext");
J.SCMResourceContext = new J("SCMResourceContext");
J.SCMResourceContextShare = new J("SCMResourceContextShare");
J.SCMResourceFolderContext = new J("SCMResourceFolderContext");
J.SCMResourceGroupContext = new J("SCMResourceGroupContext");
J.SCMSourceControl = new J("SCMSourceControl");
J.SCMTitle = new J("SCMTitle");
J.SearchContext = new J("SearchContext");
J.SearchActionMenu = new J("SearchActionContext");
J.StatusBarWindowIndicatorMenu = new J("StatusBarWindowIndicatorMenu");
J.StatusBarRemoteIndicatorMenu = new J("StatusBarRemoteIndicatorMenu");
J.StickyScrollContext = new J("StickyScrollContext");
J.TestItem = new J("TestItem");
J.TestItemGutter = new J("TestItemGutter");
J.TestMessageContext = new J("TestMessageContext");
J.TestMessageContent = new J("TestMessageContent");
J.TestPeekElement = new J("TestPeekElement");
J.TestPeekTitle = new J("TestPeekTitle");
J.TouchBarContext = new J("TouchBarContext");
J.TitleBarContext = new J("TitleBarContext");
J.TitleBarTitleContext = new J("TitleBarTitleContext");
J.TunnelContext = new J("TunnelContext");
J.TunnelPrivacy = new J("TunnelPrivacy");
J.TunnelProtocol = new J("TunnelProtocol");
J.TunnelPortInline = new J("TunnelInline");
J.TunnelTitle = new J("TunnelTitle");
J.TunnelLocalAddressInline = new J("TunnelLocalAddressInline");
J.TunnelOriginInline = new J("TunnelOriginInline");
J.ViewItemContext = new J("ViewItemContext");
J.ViewContainerTitle = new J("ViewContainerTitle");
J.ViewContainerTitleContext = new J("ViewContainerTitleContext");
J.ViewTitle = new J("ViewTitle");
J.ViewTitleContext = new J("ViewTitleContext");
J.CommentEditorActions = new J("CommentEditorActions");
J.CommentThreadTitle = new J("CommentThreadTitle");
J.CommentThreadActions = new J("CommentThreadActions");
J.CommentThreadAdditionalActions = new J("CommentThreadAdditionalActions");
J.CommentThreadTitleContext = new J("CommentThreadTitleContext");
J.CommentThreadCommentContext = new J("CommentThreadCommentContext");
J.CommentTitle = new J("CommentTitle");
J.CommentActions = new J("CommentActions");
J.InteractiveToolbar = new J("InteractiveToolbar");
J.InteractiveCellTitle = new J("InteractiveCellTitle");
J.InteractiveCellDelete = new J("InteractiveCellDelete");
J.InteractiveCellExecute = new J("InteractiveCellExecute");
J.InteractiveInputExecute = new J("InteractiveInputExecute");
J.NotebookToolbar = new J("NotebookToolbar");
J.NotebookStickyScrollContext = new J("NotebookStickyScrollContext");
J.NotebookCellTitle = new J("NotebookCellTitle");
J.NotebookCellDelete = new J("NotebookCellDelete");
J.NotebookCellInsert = new J("NotebookCellInsert");
J.NotebookCellBetween = new J("NotebookCellBetween");
J.NotebookCellListTop = new J("NotebookCellTop");
J.NotebookCellExecute = new J("NotebookCellExecute");
J.NotebookCellExecutePrimary = new J("NotebookCellExecutePrimary");
J.NotebookDiffCellInputTitle = new J("NotebookDiffCellInputTitle");
J.NotebookDiffCellMetadataTitle = new J("NotebookDiffCellMetadataTitle");
J.NotebookDiffCellOutputsTitle = new J("NotebookDiffCellOutputsTitle");
J.NotebookOutputToolbar = new J("NotebookOutputToolbar");
J.NotebookEditorLayoutConfigure = new J("NotebookEditorLayoutConfigure");
J.NotebookKernelSource = new J("NotebookKernelSource");
J.BulkEditTitle = new J("BulkEditTitle");
J.BulkEditContext = new J("BulkEditContext");
J.TimelineItemContext = new J("TimelineItemContext");
J.TimelineTitle = new J("TimelineTitle");
J.TimelineTitleContext = new J("TimelineTitleContext");
J.TimelineFilterSubMenu = new J("TimelineFilterSubMenu");
J.AccountsContext = new J("AccountsContext");
J.PanelTitle = new J("PanelTitle");
J.AuxiliaryBarTitle = new J("AuxiliaryBarTitle");
J.TerminalInstanceContext = new J("TerminalInstanceContext");
J.TerminalEditorInstanceContext = new J("TerminalEditorInstanceContext");
J.TerminalNewDropdownContext = new J("TerminalNewDropdownContext");
J.TerminalTabContext = new J("TerminalTabContext");
J.TerminalTabEmptyAreaContext = new J("TerminalTabEmptyAreaContext");
J.WebviewContext = new J("WebviewContext");
J.InlineCompletionsActions = new J("InlineCompletionsActions");
J.NewFile = new J("NewFile");
J.MergeInput1Toolbar = new J("MergeToolbar1Toolbar");
J.MergeInput2Toolbar = new J("MergeToolbar2Toolbar");
J.MergeBaseToolbar = new J("MergeBaseToolbar");
J.MergeInputResultToolbar = new J("MergeToolbarResultToolbar");
J.InlineSuggestionToolbar = new J("InlineSuggestionToolbar");
J.ChatContext = new J("ChatContext");
J.ChatCodeBlock = new J("ChatCodeblock");
J.ChatMessageTitle = new J("ChatMessageTitle");
J.ChatExecute = new J("ChatExecute");
J.ChatInputSide = new J("ChatInputSide");
J.AccessibleView = new J("AccessibleView");
const Ou = Gt("menuService");
class vh {
  static for(e) {
    let t = this._all.get(e);
    return t || (t = new vh(e), this._all.set(e, t)), t;
  }
  static merge(e) {
    const t = /* @__PURE__ */ new Set();
    for (const n of e)
      n instanceof vh && t.add(n.id);
    return t;
  }
  constructor(e) {
    this.id = e, this.has = (t) => t === e;
  }
}
vh._all = /* @__PURE__ */ new Map();
const os = new class {
  constructor() {
    this._commands = /* @__PURE__ */ new Map(), this._menuItems = /* @__PURE__ */ new Map(), this._onDidChangeMenu = new FTe({
      merge: vh.merge
    }), this.onDidChangeMenu = this._onDidChangeMenu.event;
  }
  addCommand(i) {
    return this._commands.set(i.id, i), this._onDidChangeMenu.fire(vh.for(J.CommandPalette)), Ct(() => {
      this._commands.delete(i.id) && this._onDidChangeMenu.fire(vh.for(J.CommandPalette));
    });
  }
  getCommand(i) {
    return this._commands.get(i);
  }
  getCommands() {
    const i = /* @__PURE__ */ new Map();
    return this._commands.forEach((e, t) => i.set(t, e)), i;
  }
  appendMenuItem(i, e) {
    let t = this._menuItems.get(i);
    t || (t = new fo(), this._menuItems.set(i, t));
    const n = t.push(e);
    return this._onDidChangeMenu.fire(vh.for(i)), Ct(() => {
      n(), this._onDidChangeMenu.fire(vh.for(i));
    });
  }
  appendMenuItems(i) {
    const e = new Ne();
    for (const { id: t, item: n } of i)
      e.add(this.appendMenuItem(t, n));
    return e;
  }
  getMenuItems(i) {
    let e;
    return this._menuItems.has(i) ? e = [...this._menuItems.get(i)] : e = [], i === J.CommandPalette && this._appendImplicitItems(e), e;
  }
  _appendImplicitItems(i) {
    const e = /* @__PURE__ */ new Set();
    for (const t of i)
      Y1(t) && (e.add(t.command.id), t.alt && e.add(t.alt.id));
    this._commands.forEach((t, n) => {
      e.has(n) || i.push({ command: t });
    });
  }
}();
class Ay extends g_ {
  constructor(e, t, n) {
    super(`submenuitem.${e.submenu.id}`, typeof e.title == "string" ? e.title : e.title.value, n, "submenu"), this.item = e, this.hideActions = t;
  }
}
let sc = N3 = class {
  static label(e, t) {
    return t?.renderShortTitle && e.shortTitle ? typeof e.shortTitle == "string" ? e.shortTitle : e.shortTitle.value : typeof e.title == "string" ? e.title : e.title.value;
  }
  constructor(e, t, n, r, s, o) {
    var a, l;
    this.hideActions = r, this._commandService = o, this.id = e.id, this.label = N3.label(e, n), this.tooltip = (l = typeof e.tooltip == "string" ? e.tooltip : (a = e.tooltip) === null || a === void 0 ? void 0 : a.value) !== null && l !== void 0 ? l : "", this.enabled = !e.precondition || s.contextMatchesRules(e.precondition), this.checked = void 0;
    let c;
    if (e.toggled) {
      const d = e.toggled.condition ? e.toggled : { condition: e.toggled };
      this.checked = s.contextMatchesRules(d.condition), this.checked && d.tooltip && (this.tooltip = typeof d.tooltip == "string" ? d.tooltip : d.tooltip.value), this.checked && ft.isThemeIcon(d.icon) && (c = d.icon), this.checked && d.title && (this.label = typeof d.title == "string" ? d.title : d.title.value);
    }
    c || (c = ft.isThemeIcon(e.icon) ? e.icon : void 0), this.item = e, this.alt = t ? new N3(t, void 0, n, r, s, o) : void 0, this._options = n, this.class = c && ft.asClassName(c);
  }
  run(...e) {
    var t, n;
    let r = [];
    return !((t = this._options) === null || t === void 0) && t.arg && (r = [...r, this._options.arg]), !((n = this._options) === null || n === void 0) && n.shouldForwardArgs && (r = [...r, ...e]), this._commandService.executeCommand(this.id, ...r);
  }
};
sc = N3 = n9e([
  oX(4, yt),
  oX(5, Ui)
], sc);
class Ga {
  constructor(e) {
    this.desc = e;
  }
}
function oi(i) {
  const e = new Ne(), t = new i(), n = t.desc, { f1: r, menu: s, keybinding: o, description: a } = n, l = i9e(n, ["f1", "menu", "keybinding", "description"]);
  if (e.add(on.registerCommand({
    id: l.id,
    handler: (c, ...d) => t.run(c, ...d),
    description: a
  })), Array.isArray(s))
    for (const c of s)
      e.add(os.appendMenuItem(c.id, Object.assign({ command: Object.assign(Object.assign({}, l), { precondition: c.precondition === null ? void 0 : l.precondition }) }, c)));
  else s && e.add(os.appendMenuItem(s.id, Object.assign({ command: Object.assign(Object.assign({}, l), { precondition: s.precondition === null ? void 0 : l.precondition }) }, s)));
  if (r && (e.add(os.appendMenuItem(J.CommandPalette, { command: l, when: l.precondition })), e.add(os.addCommand(l))), Array.isArray(o))
    for (const c of o)
      e.add(Bo.registerKeybindingRule(Object.assign(Object.assign({}, c), { id: l.id, when: l.precondition ? ke.and(l.precondition, c.when) : c.when })));
  else o && e.add(Bo.registerKeybindingRule(Object.assign(Object.assign({}, o), { id: l.id, when: l.precondition ? ke.and(l.precondition, o.when) : o.when })));
  return e;
}
const qa = Gt("telemetryService"), Ka = Gt("logService");
var bs;
(function(i) {
  i[i.Off = 0] = "Off", i[i.Trace = 1] = "Trace", i[i.Debug = 2] = "Debug", i[i.Info = 3] = "Info", i[i.Warning = 4] = "Warning", i[i.Error = 5] = "Error";
})(bs || (bs = {}));
const Dhe = bs.Info;
class Ehe extends we {
  constructor() {
    super(...arguments), this.level = Dhe, this._onDidChangeLogLevel = this._register(new pe()), this.onDidChangeLogLevel = this._onDidChangeLogLevel.event;
  }
  setLevel(e) {
    this.level !== e && (this.level = e, this._onDidChangeLogLevel.fire(this.level));
  }
  getLevel() {
    return this.level;
  }
  checkLogLevel(e) {
    return this.level !== bs.Off && this.level <= e;
  }
}
class s9e extends Ehe {
  constructor(e = Dhe, t = !0) {
    super(), this.useColors = t, this.setLevel(e);
  }
  trace(e, ...t) {
    this.checkLogLevel(bs.Trace) && (this.useColors ? console.log("%cTRACE", "color: #888", e, ...t) : console.log(e, ...t));
  }
  debug(e, ...t) {
    this.checkLogLevel(bs.Debug) && (this.useColors ? console.log("%cDEBUG", "background: #eee; color: #888", e, ...t) : console.log(e, ...t));
  }
  info(e, ...t) {
    this.checkLogLevel(bs.Info) && (this.useColors ? console.log("%c INFO", "color: #33f", e, ...t) : console.log(e, ...t));
  }
  warn(e, ...t) {
    this.checkLogLevel(bs.Warning) && (this.useColors ? console.log("%c WARN", "color: #993", e, ...t) : console.log(e, ...t));
  }
  error(e, ...t) {
    this.checkLogLevel(bs.Error) && (this.useColors ? console.log("%c  ERR", "color: #f33", e, ...t) : console.error(e, ...t));
  }
  dispose() {
  }
}
class o9e extends Ehe {
  constructor(e) {
    super(), this.loggers = e, e.length && this.setLevel(e[0].getLevel());
  }
  setLevel(e) {
    for (const t of this.loggers)
      t.setLevel(e);
    super.setLevel(e);
  }
  trace(e, ...t) {
    for (const n of this.loggers)
      n.trace(e, ...t);
  }
  debug(e, ...t) {
    for (const n of this.loggers)
      n.debug(e, ...t);
  }
  info(e, ...t) {
    for (const n of this.loggers)
      n.info(e, ...t);
  }
  warn(e, ...t) {
    for (const n of this.loggers)
      n.warn(e, ...t);
  }
  error(e, ...t) {
    for (const n of this.loggers)
      n.error(e, ...t);
  }
  dispose() {
    for (const e of this.loggers)
      e.dispose();
  }
}
function a9e(i) {
  switch (i) {
    case bs.Trace:
      return "trace";
    case bs.Debug:
      return "debug";
    case bs.Info:
      return "info";
    case bs.Warning:
      return "warn";
    case bs.Error:
      return "error";
    case bs.Off:
      return "off";
  }
}
new Ke("logLevel", a9e(bs.Info));
const Yj = {
  clipboard: {
    writeText: Zc || document.queryCommandSupported && document.queryCommandSupported("copy") || !!(navigator && navigator.clipboard && navigator.clipboard.writeText),
    readText: Zc || !!(navigator && navigator.clipboard && navigator.clipboard.readText)
  },
  keyboard: Zc || NNe() ? 0 : navigator.keyboard || Zh ? 1 : 2,
  // 'ontouchstart' in window always evaluates to true with typescript's modern typings. This causes `window` to be
  // `never` later in `window.navigator`. That's why we need the explicit `window as Window` cast
  touch: "ontouchstart" in window || navigator.maxTouchPoints > 0,
  pointerEvents: window.PointerEvent && ("ontouchstart" in window || window.navigator.maxTouchPoints > 0 || navigator.maxTouchPoints > 0)
};
function l9e(i) {
  if (i.charCode) {
    const t = String.fromCharCode(i.charCode).toUpperCase();
    return ph.fromString(t);
  }
  const e = i.keyCode;
  if (e === 3)
    return 7;
  if (bl)
    switch (e) {
      case 59:
        return 85;
      case 60:
        if ($s)
          return 97;
        break;
      case 61:
        return 86;
      case 107:
        return 109;
      case 109:
        return 111;
      case 173:
        return 88;
      case 224:
        if (sn)
          return 57;
        break;
    }
  else if (Sm) {
    if (sn && e === 93)
      return 57;
    if (!sn && e === 92)
      return 57;
  }
  return Jue[e] || 0;
}
const c9e = sn ? 256 : 2048, d9e = 512, u9e = 1024, h9e = sn ? 2048 : 256;
class Xn {
  constructor(e) {
    this._standardKeyboardEventBrand = !0;
    const t = e;
    this.browserEvent = t, this.target = t.target, this.ctrlKey = t.ctrlKey, this.shiftKey = t.shiftKey, this.altKey = t.altKey, this.metaKey = t.metaKey, this.altGraphKey = t.getModifierState("AltGraph"), this.keyCode = l9e(t), this.code = t.code, this.ctrlKey = this.ctrlKey || this.keyCode === 5, this.altKey = this.altKey || this.keyCode === 6, this.shiftKey = this.shiftKey || this.keyCode === 4, this.metaKey = this.metaKey || this.keyCode === 57, this._asKeybinding = this._computeKeybinding(), this._asKeyCodeChord = this._computeKeyCodeChord();
  }
  preventDefault() {
    this.browserEvent && this.browserEvent.preventDefault && this.browserEvent.preventDefault();
  }
  stopPropagation() {
    this.browserEvent && this.browserEvent.stopPropagation && this.browserEvent.stopPropagation();
  }
  toKeyCodeChord() {
    return this._asKeyCodeChord;
  }
  equals(e) {
    return this._asKeybinding === e;
  }
  _computeKeybinding() {
    let e = 0;
    this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (e = this.keyCode);
    let t = 0;
    return this.ctrlKey && (t |= c9e), this.altKey && (t |= d9e), this.shiftKey && (t |= u9e), this.metaKey && (t |= h9e), t |= e, t;
  }
  _computeKeyCodeChord() {
    let e = 0;
    return this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (e = this.keyCode), new Qh(this.ctrlKey, this.shiftKey, this.altKey, this.metaKey, e);
  }
}
let aX = !1, Xb = null;
function f9e(i) {
  if (!i.parent || i.parent === i)
    return null;
  try {
    const e = i.location, t = i.parent.location;
    if (e.origin !== "null" && t.origin !== "null" && e.origin !== t.origin)
      return aX = !0, null;
  } catch {
    return aX = !0, null;
  }
  return i.parent;
}
class g9e {
  /**
   * Returns a chain of embedded windows with the same origin (which can be accessed programmatically).
   * Having a chain of length 1 might mean that the current execution environment is running outside of an iframe or inside an iframe embedded in a window with a different origin.
   * To distinguish if at one point the current execution environment is running inside a window with a different origin, see hasDifferentOriginAncestor()
   */
  static getSameOriginWindowChain() {
    if (!Xb) {
      Xb = [];
      let e = window, t;
      do
        t = f9e(e), t ? Xb.push({
          window: e,
          iframeElement: e.frameElement || null
        }) : Xb.push({
          window: e,
          iframeElement: null
        }), e = t;
      while (e);
    }
    return Xb.slice(0);
  }
  /**
   * Returns the position of `childWindow` relative to `ancestorWindow`
   */
  static getPositionOfChildWindowRelativeToAncestorWindow(e, t) {
    if (!t || e === t)
      return {
        top: 0,
        left: 0
      };
    let n = 0, r = 0;
    const s = this.getSameOriginWindowChain();
    for (const o of s) {
      if (n += o.window.scrollY, r += o.window.scrollX, o.window === t || !o.iframeElement)
        break;
      const a = o.iframeElement.getBoundingClientRect();
      n += a.top, r += a.left;
    }
    return {
      top: n,
      left: r
    };
  }
}
class cl {
  constructor(e) {
    this.timestamp = Date.now(), this.browserEvent = e, this.leftButton = e.button === 0, this.middleButton = e.button === 1, this.rightButton = e.button === 2, this.buttons = e.buttons, this.target = e.target, this.detail = e.detail || 1, e.type === "dblclick" && (this.detail = 2), this.ctrlKey = e.ctrlKey, this.shiftKey = e.shiftKey, this.altKey = e.altKey, this.metaKey = e.metaKey, typeof e.pageX == "number" ? (this.posx = e.pageX, this.posy = e.pageY) : (this.posx = e.clientX + this.target.ownerDocument.body.scrollLeft + this.target.ownerDocument.documentElement.scrollLeft, this.posy = e.clientY + this.target.ownerDocument.body.scrollTop + this.target.ownerDocument.documentElement.scrollTop);
    const t = g9e.getPositionOfChildWindowRelativeToAncestorWindow(window, e.view);
    this.posx -= t.left, this.posy -= t.top;
  }
  preventDefault() {
    this.browserEvent.preventDefault();
  }
  stopPropagation() {
    this.browserEvent.stopPropagation();
  }
}
class Km {
  constructor(e, t = 0, n = 0) {
    if (this.browserEvent = e || null, this.target = e ? e.target || e.targetNode || e.srcElement : null, this.deltaY = n, this.deltaX = t, e) {
      const r = e, s = e;
      if (typeof r.wheelDeltaY < "u")
        this.deltaY = r.wheelDeltaY / 120;
      else if (typeof s.VERTICAL_AXIS < "u" && s.axis === s.VERTICAL_AXIS)
        this.deltaY = -s.detail / 3;
      else if (e.type === "wheel") {
        const o = e;
        o.deltaMode === o.DOM_DELTA_LINE ? bl && !sn ? this.deltaY = -e.deltaY / 3 : this.deltaY = -e.deltaY : this.deltaY = -e.deltaY / 40;
      }
      if (typeof r.wheelDeltaX < "u")
        Zh && Ls ? this.deltaX = -(r.wheelDeltaX / 120) : this.deltaX = r.wheelDeltaX / 120;
      else if (typeof s.HORIZONTAL_AXIS < "u" && s.axis === s.HORIZONTAL_AXIS)
        this.deltaX = -e.detail / 3;
      else if (e.type === "wheel") {
        const o = e;
        o.deltaMode === o.DOM_DELTA_LINE ? bl && !sn ? this.deltaX = -e.deltaX / 3 : this.deltaX = -e.deltaX : this.deltaX = -e.deltaX / 40;
      }
      this.deltaY === 0 && this.deltaX === 0 && e.wheelDelta && (this.deltaY = e.wheelDelta / 120);
    }
  }
  preventDefault() {
    var e;
    (e = this.browserEvent) === null || e === void 0 || e.preventDefault();
  }
  stopPropagation() {
    var e;
    (e = this.browserEvent) === null || e === void 0 || e.stopPropagation();
  }
}
/*! @license DOMPurify 3.0.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.5/LICENSE */
const {
  entries: Lhe,
  setPrototypeOf: lX,
  isFrozen: p9e,
  getPrototypeOf: m9e,
  getOwnPropertyDescriptor: v9e
} = Object;
let {
  freeze: aa,
  seal: ad,
  create: _9e
} = Object, {
  apply: aF,
  construct: lF
} = typeof Reflect < "u" && Reflect;
aF || (aF = function(e, t, n) {
  return e.apply(t, n);
});
aa || (aa = function(e) {
  return e;
});
ad || (ad = function(e) {
  return e;
});
lF || (lF = function(e, t) {
  return new e(...t);
});
const b9e = oc(Array.prototype.forEach), cX = oc(Array.prototype.pop), Zb = oc(Array.prototype.push), P3 = oc(String.prototype.toLowerCase), r6 = oc(String.prototype.toString), C9e = oc(String.prototype.match), Cc = oc(String.prototype.replace), y9e = oc(String.prototype.indexOf), w9e = oc(String.prototype.trim), $a = oc(RegExp.prototype.test), Qb = S9e(TypeError);
function oc(i) {
  return function(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      n[r - 1] = arguments[r];
    return aF(i, e, n);
  };
}
function S9e(i) {
  return function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return lF(i, t);
  };
}
function Pn(i, e, t) {
  var n;
  t = (n = t) !== null && n !== void 0 ? n : P3, lX && lX(i, null);
  let r = e.length;
  for (; r--; ) {
    let s = e[r];
    if (typeof s == "string") {
      const o = t(s);
      o !== s && (p9e(e) || (e[r] = o), s = o);
    }
    i[s] = !0;
  }
  return i;
}
function l1(i) {
  const e = _9e(null);
  for (const [t, n] of Lhe(i))
    e[t] = n;
  return e;
}
function Vx(i, e) {
  for (; i !== null; ) {
    const n = v9e(i, e);
    if (n) {
      if (n.get)
        return oc(n.get);
      if (typeof n.value == "function")
        return oc(n.value);
    }
    i = m9e(i);
  }
  function t(n) {
    return console.warn("fallback value for", n), null;
  }
  return t;
}
const dX = aa(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), s6 = aa(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), o6 = aa(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), x9e = aa(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), a6 = aa(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), D9e = aa(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), uX = aa(["#text"]), hX = aa(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), l6 = aa(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), fX = aa(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Hx = aa(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), E9e = ad(/\{\{[\w\W]*|[\w\W]*\}\}/gm), L9e = ad(/<%[\w\W]*|[\w\W]*%>/gm), I9e = ad(/\${[\w\W]*}/gm), A9e = ad(/^data-[\-\w.\u00B7-\uFFFF]/), k9e = ad(/^aria-[\-\w]+$/), Ihe = ad(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), T9e = ad(/^(?:\w+script|data):/i), N9e = ad(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Ahe = ad(/^html$/i);
var gX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: E9e,
  ERB_EXPR: L9e,
  TMPLIT_EXPR: I9e,
  DATA_ATTR: A9e,
  ARIA_ATTR: k9e,
  IS_ALLOWED_URI: Ihe,
  IS_SCRIPT_OR_DATA: T9e,
  ATTR_WHITESPACE: N9e,
  DOCTYPE_NAME: Ahe
});
const P9e = () => typeof window > "u" ? null : window, O9e = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let n = null;
  const r = "data-tt-policy-suffix";
  t && t.hasAttribute(r) && (n = t.getAttribute(r));
  const s = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(s, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
};
function khe() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : P9e();
  const e = (mt) => khe(mt);
  if (e.version = "3.0.5", e.removed = [], !i || !i.document || i.document.nodeType !== 9)
    return e.isSupported = !1, e;
  const t = i.document, n = t.currentScript;
  let {
    document: r
  } = i;
  const {
    DocumentFragment: s,
    HTMLTemplateElement: o,
    Node: a,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: d = i.NamedNodeMap || i.MozNamedAttrMap,
    HTMLFormElement: u,
    DOMParser: h,
    trustedTypes: f
  } = i, g = l.prototype, p = Vx(g, "cloneNode"), m = Vx(g, "nextSibling"), _ = Vx(g, "childNodes"), b = Vx(g, "parentNode");
  if (typeof o == "function") {
    const mt = r.createElement("template");
    mt.content && mt.content.ownerDocument && (r = mt.content.ownerDocument);
  }
  let w, y = "";
  const {
    implementation: S,
    createNodeIterator: x,
    createDocumentFragment: D,
    getElementsByTagName: E
  } = r, {
    importNode: L
  } = t;
  let k = {};
  e.isSupported = typeof Lhe == "function" && typeof b == "function" && S && S.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: N,
    ERB_EXPR: I,
    TMPLIT_EXPR: A,
    DATA_ATTR: P,
    ARIA_ATTR: O,
    IS_SCRIPT_OR_DATA: K,
    ATTR_WHITESPACE: W
  } = gX;
  let {
    IS_ALLOWED_URI: F
  } = gX, q = null;
  const R = Pn({}, [...dX, ...s6, ...o6, ...a6, ...uX]);
  let T = null;
  const z = Pn({}, [...hX, ...l6, ...fX, ...Hx]);
  let X = Object.seal(Object.create(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ae = null, ue = null, se = !0, le = !0, oe = !1, re = !0, B = !1, ee = !1, j = !1, he = !1, Se = !1, ge = !1, te = !1, be = !0, Ae = !1;
  const He = "user-content-";
  let de = !0, ce = !1, ie = {}, H = null;
  const Y = Pn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Z = null;
  const Q = Pn({}, ["audio", "video", "img", "source", "image", "track"]);
  let me = null;
  const Le = Pn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), xe = "http://www.w3.org/1998/Math/MathML", Ue = "http://www.w3.org/2000/svg", je = "http://www.w3.org/1999/xhtml";
  let Ze = je, _e = !1, U = null;
  const fe = Pn({}, [xe, Ue, je], r6);
  let Ee;
  const Me = ["application/xhtml+xml", "text/html"], Pe = "text/html";
  let et, gt = null;
  const Vt = r.createElement("form"), Zt = function(De) {
    return De instanceof RegExp || De instanceof Function;
  }, St = function(De) {
    if (!(gt && gt === De)) {
      if ((!De || typeof De != "object") && (De = {}), De = l1(De), Ee = // eslint-disable-next-line unicorn/prefer-includes
      Me.indexOf(De.PARSER_MEDIA_TYPE) === -1 ? Ee = Pe : Ee = De.PARSER_MEDIA_TYPE, et = Ee === "application/xhtml+xml" ? r6 : P3, q = "ALLOWED_TAGS" in De ? Pn({}, De.ALLOWED_TAGS, et) : R, T = "ALLOWED_ATTR" in De ? Pn({}, De.ALLOWED_ATTR, et) : z, U = "ALLOWED_NAMESPACES" in De ? Pn({}, De.ALLOWED_NAMESPACES, r6) : fe, me = "ADD_URI_SAFE_ATTR" in De ? Pn(
        l1(Le),
        // eslint-disable-line indent
        De.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        et
        // eslint-disable-line indent
      ) : Le, Z = "ADD_DATA_URI_TAGS" in De ? Pn(
        l1(Q),
        // eslint-disable-line indent
        De.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        et
        // eslint-disable-line indent
      ) : Q, H = "FORBID_CONTENTS" in De ? Pn({}, De.FORBID_CONTENTS, et) : Y, ae = "FORBID_TAGS" in De ? Pn({}, De.FORBID_TAGS, et) : {}, ue = "FORBID_ATTR" in De ? Pn({}, De.FORBID_ATTR, et) : {}, ie = "USE_PROFILES" in De ? De.USE_PROFILES : !1, se = De.ALLOW_ARIA_ATTR !== !1, le = De.ALLOW_DATA_ATTR !== !1, oe = De.ALLOW_UNKNOWN_PROTOCOLS || !1, re = De.ALLOW_SELF_CLOSE_IN_ATTR !== !1, B = De.SAFE_FOR_TEMPLATES || !1, ee = De.WHOLE_DOCUMENT || !1, Se = De.RETURN_DOM || !1, ge = De.RETURN_DOM_FRAGMENT || !1, te = De.RETURN_TRUSTED_TYPE || !1, he = De.FORCE_BODY || !1, be = De.SANITIZE_DOM !== !1, Ae = De.SANITIZE_NAMED_PROPS || !1, de = De.KEEP_CONTENT !== !1, ce = De.IN_PLACE || !1, F = De.ALLOWED_URI_REGEXP || Ihe, Ze = De.NAMESPACE || je, X = De.CUSTOM_ELEMENT_HANDLING || {}, De.CUSTOM_ELEMENT_HANDLING && Zt(De.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (X.tagNameCheck = De.CUSTOM_ELEMENT_HANDLING.tagNameCheck), De.CUSTOM_ELEMENT_HANDLING && Zt(De.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (X.attributeNameCheck = De.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), De.CUSTOM_ELEMENT_HANDLING && typeof De.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (X.allowCustomizedBuiltInElements = De.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), B && (le = !1), ge && (Se = !0), ie && (q = Pn({}, [...uX]), T = [], ie.html === !0 && (Pn(q, dX), Pn(T, hX)), ie.svg === !0 && (Pn(q, s6), Pn(T, l6), Pn(T, Hx)), ie.svgFilters === !0 && (Pn(q, o6), Pn(T, l6), Pn(T, Hx)), ie.mathMl === !0 && (Pn(q, a6), Pn(T, fX), Pn(T, Hx))), De.ADD_TAGS && (q === R && (q = l1(q)), Pn(q, De.ADD_TAGS, et)), De.ADD_ATTR && (T === z && (T = l1(T)), Pn(T, De.ADD_ATTR, et)), De.ADD_URI_SAFE_ATTR && Pn(me, De.ADD_URI_SAFE_ATTR, et), De.FORBID_CONTENTS && (H === Y && (H = l1(H)), Pn(H, De.FORBID_CONTENTS, et)), de && (q["#text"] = !0), ee && Pn(q, ["html", "head", "body"]), q.table && (Pn(q, ["tbody"]), delete ae.tbody), De.TRUSTED_TYPES_POLICY) {
        if (typeof De.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Qb('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof De.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Qb('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        w = De.TRUSTED_TYPES_POLICY, y = w.createHTML("");
      } else
        w === void 0 && (w = O9e(f, n)), w !== null && typeof y == "string" && (y = w.createHTML(""));
      aa && aa(De), gt = De;
    }
  }, Ht = Pn({}, ["mi", "mo", "mn", "ms", "mtext"]), fn = Pn({}, ["foreignobject", "desc", "title", "annotation-xml"]), xn = Pn({}, ["title", "style", "font", "a", "script"]), rt = Pn({}, s6);
  Pn(rt, o6), Pn(rt, x9e);
  const Ei = Pn({}, a6);
  Pn(Ei, D9e);
  const Nn = function(De) {
    let Qe = b(De);
    (!Qe || !Qe.tagName) && (Qe = {
      namespaceURI: Ze,
      tagName: "template"
    });
    const ct = P3(De.tagName), bi = P3(Qe.tagName);
    return U[De.namespaceURI] ? De.namespaceURI === Ue ? Qe.namespaceURI === je ? ct === "svg" : Qe.namespaceURI === xe ? ct === "svg" && (bi === "annotation-xml" || Ht[bi]) : !!rt[ct] : De.namespaceURI === xe ? Qe.namespaceURI === je ? ct === "math" : Qe.namespaceURI === Ue ? ct === "math" && fn[bi] : !!Ei[ct] : De.namespaceURI === je ? Qe.namespaceURI === Ue && !fn[bi] || Qe.namespaceURI === xe && !Ht[bi] ? !1 : !Ei[ct] && (xn[ct] || !rt[ct]) : !!(Ee === "application/xhtml+xml" && U[De.namespaceURI]) : !1;
  }, Gi = function(De) {
    Zb(e.removed, {
      element: De
    });
    try {
      De.parentNode.removeChild(De);
    } catch {
      De.remove();
    }
  }, Ce = function(De, Qe) {
    try {
      Zb(e.removed, {
        attribute: Qe.getAttributeNode(De),
        from: Qe
      });
    } catch {
      Zb(e.removed, {
        attribute: null,
        from: Qe
      });
    }
    if (Qe.removeAttribute(De), De === "is" && !T[De])
      if (Se || ge)
        try {
          Gi(Qe);
        } catch {
        }
      else
        try {
          Qe.setAttribute(De, "");
        } catch {
        }
  }, Xe = function(De) {
    let Qe, ct;
    if (he)
      De = "<remove></remove>" + De;
    else {
      const fs = C9e(De, /^[\r\n\t ]+/);
      ct = fs && fs[0];
    }
    Ee === "application/xhtml+xml" && Ze === je && (De = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + De + "</body></html>");
    const bi = w ? w.createHTML(De) : De;
    if (Ze === je)
      try {
        Qe = new h().parseFromString(bi, Ee);
      } catch {
      }
    if (!Qe || !Qe.documentElement) {
      Qe = S.createDocument(Ze, "template", null);
      try {
        Qe.documentElement.innerHTML = _e ? y : bi;
      } catch {
      }
    }
    const Mr = Qe.body || Qe.documentElement;
    return De && ct && Mr.insertBefore(r.createTextNode(ct), Mr.childNodes[0] || null), Ze === je ? E.call(Qe, ee ? "html" : "body")[0] : ee ? Qe.documentElement : Mr;
  }, nt = function(De) {
    return x.call(
      De.ownerDocument || De,
      De,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT,
      null,
      !1
    );
  }, At = function(De) {
    return De instanceof u && (typeof De.nodeName != "string" || typeof De.textContent != "string" || typeof De.removeChild != "function" || !(De.attributes instanceof d) || typeof De.removeAttribute != "function" || typeof De.setAttribute != "function" || typeof De.namespaceURI != "string" || typeof De.insertBefore != "function" || typeof De.hasChildNodes != "function");
  }, tn = function(De) {
    return typeof a == "object" ? De instanceof a : De && typeof De == "object" && typeof De.nodeType == "number" && typeof De.nodeName == "string";
  }, qt = function(De, Qe, ct) {
    k[De] && b9e(k[De], (bi) => {
      bi.call(e, Qe, ct, gt);
    });
  }, Kt = function(De) {
    let Qe;
    if (qt("beforeSanitizeElements", De, null), At(De))
      return Gi(De), !0;
    const ct = et(De.nodeName);
    if (qt("uponSanitizeElement", De, {
      tagName: ct,
      allowedTags: q
    }), De.hasChildNodes() && !tn(De.firstElementChild) && (!tn(De.content) || !tn(De.content.firstElementChild)) && $a(/<[/\w]/g, De.innerHTML) && $a(/<[/\w]/g, De.textContent))
      return Gi(De), !0;
    if (!q[ct] || ae[ct]) {
      if (!ae[ct] && _i(ct) && (X.tagNameCheck instanceof RegExp && $a(X.tagNameCheck, ct) || X.tagNameCheck instanceof Function && X.tagNameCheck(ct)))
        return !1;
      if (de && !H[ct]) {
        const bi = b(De) || De.parentNode, Mr = _(De) || De.childNodes;
        if (Mr && bi) {
          const fs = Mr.length;
          for (let er = fs - 1; er >= 0; --er)
            bi.insertBefore(p(Mr[er], !0), m(De));
        }
      }
      return Gi(De), !0;
    }
    return De instanceof l && !Nn(De) || (ct === "noscript" || ct === "noembed" || ct === "noframes") && $a(/<\/no(script|embed|frames)/i, De.innerHTML) ? (Gi(De), !0) : (B && De.nodeType === 3 && (Qe = De.textContent, Qe = Cc(Qe, N, " "), Qe = Cc(Qe, I, " "), Qe = Cc(Qe, A, " "), De.textContent !== Qe && (Zb(e.removed, {
      element: De.cloneNode()
    }), De.textContent = Qe)), qt("afterSanitizeElements", De, null), !1);
  }, Pt = function(De, Qe, ct) {
    if (be && (Qe === "id" || Qe === "name") && (ct in r || ct in Vt))
      return !1;
    if (!(le && !ue[Qe] && $a(P, Qe))) {
      if (!(se && $a(O, Qe))) {
        if (!T[Qe] || ue[Qe]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(_i(De) && (X.tagNameCheck instanceof RegExp && $a(X.tagNameCheck, De) || X.tagNameCheck instanceof Function && X.tagNameCheck(De)) && (X.attributeNameCheck instanceof RegExp && $a(X.attributeNameCheck, Qe) || X.attributeNameCheck instanceof Function && X.attributeNameCheck(Qe)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Qe === "is" && X.allowCustomizedBuiltInElements && (X.tagNameCheck instanceof RegExp && $a(X.tagNameCheck, ct) || X.tagNameCheck instanceof Function && X.tagNameCheck(ct)))
          ) return !1;
        } else if (!me[Qe]) {
          if (!$a(F, Cc(ct, W, ""))) {
            if (!((Qe === "src" || Qe === "xlink:href" || Qe === "href") && De !== "script" && y9e(ct, "data:") === 0 && Z[De])) {
              if (!(oe && !$a(K, Cc(ct, W, "")))) {
                if (ct)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, _i = function(De) {
    return De.indexOf("-") > 0;
  }, vn = function(De) {
    let Qe, ct, bi, Mr;
    qt("beforeSanitizeAttributes", De, null);
    const {
      attributes: fs
    } = De;
    if (!fs)
      return;
    const er = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: T
    };
    for (Mr = fs.length; Mr--; ) {
      Qe = fs[Mr];
      const {
        name: Qa,
        namespaceURI: Wb
      } = Qe;
      if (ct = Qa === "value" ? Qe.value : w9e(Qe.value), bi = et(Qa), er.attrName = bi, er.attrValue = ct, er.keepAttr = !0, er.forceKeepAttr = void 0, qt("uponSanitizeAttribute", De, er), ct = er.attrValue, er.forceKeepAttr || (Ce(Qa, De), !er.keepAttr))
        continue;
      if (!re && $a(/\/>/i, ct)) {
        Ce(Qa, De);
        continue;
      }
      B && (ct = Cc(ct, N, " "), ct = Cc(ct, I, " "), ct = Cc(ct, A, " "));
      const jb = et(De.nodeName);
      if (Pt(jb, bi, ct)) {
        if (Ae && (bi === "id" || bi === "name") && (Ce(Qa, De), ct = He + ct), w && typeof f == "object" && typeof f.getAttributeType == "function" && !Wb)
          switch (f.getAttributeType(jb, bi)) {
            case "TrustedHTML": {
              ct = w.createHTML(ct);
              break;
            }
            case "TrustedScriptURL": {
              ct = w.createScriptURL(ct);
              break;
            }
          }
        try {
          Wb ? De.setAttributeNS(Wb, Qa, ct) : De.setAttribute(Qa, ct), cX(e.removed);
        } catch {
        }
      }
    }
    qt("afterSanitizeAttributes", De, null);
  }, $n = function mt(De) {
    let Qe;
    const ct = nt(De);
    for (qt("beforeSanitizeShadowDOM", De, null); Qe = ct.nextNode(); )
      qt("uponSanitizeShadowNode", Qe, null), !Kt(Qe) && (Qe.content instanceof s && mt(Qe.content), vn(Qe));
    qt("afterSanitizeShadowDOM", De, null);
  };
  return e.sanitize = function(mt) {
    let De = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Qe, ct, bi, Mr;
    if (_e = !mt, _e && (mt = "<!-->"), typeof mt != "string" && !tn(mt))
      if (typeof mt.toString == "function") {
        if (mt = mt.toString(), typeof mt != "string")
          throw Qb("dirty is not a string, aborting");
      } else
        throw Qb("toString is not a function");
    if (!e.isSupported)
      return mt;
    if (j || St(De), e.removed = [], typeof mt == "string" && (ce = !1), ce) {
      if (mt.nodeName) {
        const Qa = et(mt.nodeName);
        if (!q[Qa] || ae[Qa])
          throw Qb("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (mt instanceof a)
      Qe = Xe("<!---->"), ct = Qe.ownerDocument.importNode(mt, !0), ct.nodeType === 1 && ct.nodeName === "BODY" || ct.nodeName === "HTML" ? Qe = ct : Qe.appendChild(ct);
    else {
      if (!Se && !B && !ee && // eslint-disable-next-line unicorn/prefer-includes
      mt.indexOf("<") === -1)
        return w && te ? w.createHTML(mt) : mt;
      if (Qe = Xe(mt), !Qe)
        return Se ? null : te ? y : "";
    }
    Qe && he && Gi(Qe.firstChild);
    const fs = nt(ce ? mt : Qe);
    for (; bi = fs.nextNode(); )
      Kt(bi) || (bi.content instanceof s && $n(bi.content), vn(bi));
    if (ce)
      return mt;
    if (Se) {
      if (ge)
        for (Mr = D.call(Qe.ownerDocument); Qe.firstChild; )
          Mr.appendChild(Qe.firstChild);
      else
        Mr = Qe;
      return (T.shadowroot || T.shadowrootmode) && (Mr = L.call(t, Mr, !0)), Mr;
    }
    let er = ee ? Qe.outerHTML : Qe.innerHTML;
    return ee && q["!doctype"] && Qe.ownerDocument && Qe.ownerDocument.doctype && Qe.ownerDocument.doctype.name && $a(Ahe, Qe.ownerDocument.doctype.name) && (er = "<!DOCTYPE " + Qe.ownerDocument.doctype.name + `>
` + er), B && (er = Cc(er, N, " "), er = Cc(er, I, " "), er = Cc(er, A, " ")), w && te ? w.createHTML(er) : er;
  }, e.setConfig = function(mt) {
    St(mt), j = !0;
  }, e.clearConfig = function() {
    gt = null, j = !1;
  }, e.isValidAttribute = function(mt, De, Qe) {
    gt || St({});
    const ct = et(mt), bi = et(De);
    return Pt(ct, bi, Qe);
  }, e.addHook = function(mt, De) {
    typeof De == "function" && (k[mt] = k[mt] || [], Zb(k[mt], De));
  }, e.removeHook = function(mt) {
    if (k[mt])
      return cX(k[mt]);
  }, e.removeHooks = function(mt) {
    k[mt] && (k[mt] = []);
  }, e.removeAllHooks = function() {
    k = {};
  }, e;
}
var Mu = khe();
Mu.version;
Mu.isSupported;
const The = Mu.sanitize;
Mu.setConfig;
Mu.clearConfig;
Mu.isValidAttribute;
const Nhe = Mu.addHook, Phe = Mu.removeHook;
Mu.removeHooks;
Mu.removeAllHooks;
var Mt;
(function(i) {
  i.inMemory = "inmemory", i.vscode = "vscode", i.internal = "private", i.walkThrough = "walkThrough", i.walkThroughSnippet = "walkThroughSnippet", i.http = "http", i.https = "https", i.file = "file", i.mailto = "mailto", i.untitled = "untitled", i.data = "data", i.command = "command", i.vscodeRemote = "vscode-remote", i.vscodeRemoteResource = "vscode-remote-resource", i.vscodeManagedRemoteResource = "vscode-managed-remote-resource", i.vscodeUserData = "vscode-userdata", i.vscodeCustomEditor = "vscode-custom-editor", i.vscodeNotebookCell = "vscode-notebook-cell", i.vscodeNotebookCellMetadata = "vscode-notebook-cell-metadata", i.vscodeNotebookCellOutput = "vscode-notebook-cell-output", i.vscodeInteractiveInput = "vscode-interactive-input", i.vscodeSettings = "vscode-settings", i.vscodeWorkspaceTrust = "vscode-workspace-trust", i.vscodeTerminal = "vscode-terminal", i.vscodeChatSesssion = "vscode-chat-editor", i.webviewPanel = "webview-panel", i.vscodeWebview = "vscode-webview", i.extension = "extension", i.vscodeFileResource = "vscode-file", i.tmp = "tmp", i.vsls = "vsls", i.vscodeSourceControl = "vscode-scm";
})(Mt || (Mt = {}));
const M9e = "tkn";
class R9e {
  constructor() {
    this._hosts = /* @__PURE__ */ Object.create(null), this._ports = /* @__PURE__ */ Object.create(null), this._connectionTokens = /* @__PURE__ */ Object.create(null), this._preferredWebSchema = "http", this._delegate = null, this._remoteResourcesPath = `/${Mt.vscodeRemoteResource}`;
  }
  setPreferredWebSchema(e) {
    this._preferredWebSchema = e;
  }
  rewrite(e) {
    if (this._delegate)
      try {
        return this._delegate(e);
      } catch (a) {
        return It(a), e;
      }
    const t = e.authority;
    let n = this._hosts[t];
    n && n.indexOf(":") !== -1 && n.indexOf("[") === -1 && (n = `[${n}]`);
    const r = this._ports[t], s = this._connectionTokens[t];
    let o = `path=${encodeURIComponent(e.path)}`;
    return typeof s == "string" && (o += `&${M9e}=${encodeURIComponent(s)}`), pt.from({
      scheme: sp ? this._preferredWebSchema : Mt.vscodeRemoteResource,
      authority: `${n}:${r}`,
      path: this._remoteResourcesPath,
      query: o
    });
  }
}
const Ohe = new R9e();
class ky {
  /**
   * Returns a URI to use in contexts where the browser is responsible
   * for loading (e.g. fetch()) or when used within the DOM.
   *
   * **Note:** use `dom.ts#asCSSUrl` whenever the URL is to be used in CSS context.
   */
  uriToBrowserUri(e) {
    return e.scheme === Mt.vscodeRemote ? Ohe.rewrite(e) : (
      // ...only ever for `file` resources
      e.scheme === Mt.file && // ...and we run in native environments
      (Zc || // ...or web worker extensions on desktop
      k6e && Zl.origin === `${Mt.vscodeFileResource}://${ky.FALLBACK_AUTHORITY}`) ? e.with({
        scheme: Mt.vscodeFileResource,
        // We need to provide an authority here so that it can serve
        // as origin for network and loading matters in chromium.
        // If the URI is not coming with an authority already, we
        // add our own
        authority: e.authority || ky.FALLBACK_AUTHORITY,
        query: null,
        fragment: null
      }) : e
    );
  }
}
ky.FALLBACK_AUTHORITY = "vscode-app";
const Mhe = new ky();
var pX;
(function(i) {
  const e = /* @__PURE__ */ new Map([
    ["1", { "Cross-Origin-Opener-Policy": "same-origin" }],
    ["2", { "Cross-Origin-Embedder-Policy": "require-corp" }],
    ["3", { "Cross-Origin-Opener-Policy": "same-origin", "Cross-Origin-Embedder-Policy": "require-corp" }]
  ]);
  i.CoopAndCoep = Object.freeze(e.get("3"));
  const t = "vscode-coi";
  function n(s) {
    let o;
    typeof s == "string" ? o = new URL(s).searchParams : s instanceof URL ? o = s.searchParams : pt.isUri(s) && (o = new URL(s.toString(!0)).searchParams);
    const a = o?.get(t);
    if (a)
      return e.get(a);
  }
  i.getHeadersFromQuery = n;
  function r(s, o, a) {
    if (!globalThis.crossOriginIsolated)
      return;
    const l = o && a ? "3" : a ? "2" : "1";
    s instanceof URLSearchParams ? s.set(t, l) : s[t] = l;
  }
  i.addSearchParam = r;
})(pX || (pX = {}));
const { registerWindow: n2t, getWindows: F9e, onDidCreateWindow: i2t } = function() {
  const i = [], e = new pe();
  return {
    onDidCreateWindow: e.event,
    registerWindow(t) {
      i.push(t);
      const n = new Ne();
      return n.add(Ct(() => {
        const r = i.indexOf(t);
        r !== -1 && i.splice(r, 1);
      })), e.fire({ window: t, disposableStore: n }), n;
    },
    getWindows() {
      return i;
    }
  };
}();
function ls(i) {
  for (; i.firstChild; )
    i.firstChild.remove();
}
function Xj(i) {
  var e;
  return (e = i?.isConnected) !== null && e !== void 0 ? e : !1;
}
class B9e {
  constructor(e, t, n, r) {
    this._node = e, this._type = t, this._handler = n, this._options = r || !1, this._node.addEventListener(this._type, this._handler, this._options);
  }
  dispose() {
    this._handler && (this._node.removeEventListener(this._type, this._handler, this._options), this._node = null, this._handler = null);
  }
}
function Ie(i, e, t, n) {
  return new B9e(i, e, t, n);
}
function Rhe(i) {
  return function(e) {
    return i(new cl(e));
  };
}
function V9e(i) {
  return function(e) {
    return i(new Xn(e));
  };
}
const ar = function(e, t, n, r) {
  let s = n;
  return t === "click" || t === "mousedown" ? s = Rhe(n) : (t === "keydown" || t === "keypress" || t === "keyup") && (s = V9e(n)), Ie(e, t, s, r);
}, H9e = function(e, t, n) {
  const r = Rhe(t);
  return W9e(e, r, n);
};
function W9e(i, e, t) {
  return Ie(i, od && Yj.pointerEvents ? Ge.POINTER_DOWN : Ge.MOUSE_DOWN, e, t);
}
let QE, Cl;
class c6 {
  constructor(e, t = 0) {
    this._runner = e, this.priority = t, this._canceled = !1;
  }
  dispose() {
    this._canceled = !0;
  }
  execute() {
    if (!this._canceled)
      try {
        this._runner();
      } catch (e) {
        It(e);
      }
  }
  // Sort by priority (largest to lowest)
  static sort(e, t) {
    return t.priority - e.priority;
  }
}
(function() {
  let i = [], e = null, t = !1, n = !1;
  const r = () => {
    for (t = !1, e = i, i = [], n = !0; e.length > 0; )
      e.sort(c6.sort), e.shift().execute();
    n = !1;
  };
  Cl = (s, o = 0) => {
    const a = new c6(s, o);
    return i.push(a), t || (t = !0, requestAnimationFrame(r)), a;
  }, QE = (s, o) => {
    if (n) {
      const a = new c6(s, o);
      return e.push(a), a;
    } else
      return Cl(s, o);
  };
})();
function e4(i) {
  return i.ownerDocument.defaultView.getComputedStyle(i, null);
}
function fb(i) {
  var e;
  const t = i.ownerDocument, n = (e = t.defaultView) === null || e === void 0 ? void 0 : e.window;
  if (i !== t.body)
    return new _n(i.clientWidth, i.clientHeight);
  if (od && n?.visualViewport)
    return new _n(n.visualViewport.width, n.visualViewport.height);
  if (n?.innerWidth && n.innerHeight)
    return new _n(n.innerWidth, n.innerHeight);
  if (t.body && t.body.clientWidth && t.body.clientHeight)
    return new _n(t.body.clientWidth, t.body.clientHeight);
  if (t.documentElement && t.documentElement.clientWidth && t.documentElement.clientHeight)
    return new _n(t.documentElement.clientWidth, t.documentElement.clientHeight);
  throw new Error("Unable to figure out browser width and height");
}
class Ki {
  // Adapted from WinJS
  // Converts a CSS positioning string for the specified element to pixels.
  static convertToPixels(e, t) {
    return parseFloat(t) || 0;
  }
  static getDimension(e, t, n) {
    const r = e4(e), s = r ? r.getPropertyValue(t) : "0";
    return Ki.convertToPixels(e, s);
  }
  static getBorderLeftWidth(e) {
    return Ki.getDimension(e, "border-left-width", "borderLeftWidth");
  }
  static getBorderRightWidth(e) {
    return Ki.getDimension(e, "border-right-width", "borderRightWidth");
  }
  static getBorderTopWidth(e) {
    return Ki.getDimension(e, "border-top-width", "borderTopWidth");
  }
  static getBorderBottomWidth(e) {
    return Ki.getDimension(e, "border-bottom-width", "borderBottomWidth");
  }
  static getPaddingLeft(e) {
    return Ki.getDimension(e, "padding-left", "paddingLeft");
  }
  static getPaddingRight(e) {
    return Ki.getDimension(e, "padding-right", "paddingRight");
  }
  static getPaddingTop(e) {
    return Ki.getDimension(e, "padding-top", "paddingTop");
  }
  static getPaddingBottom(e) {
    return Ki.getDimension(e, "padding-bottom", "paddingBottom");
  }
  static getMarginLeft(e) {
    return Ki.getDimension(e, "margin-left", "marginLeft");
  }
  static getMarginTop(e) {
    return Ki.getDimension(e, "margin-top", "marginTop");
  }
  static getMarginRight(e) {
    return Ki.getDimension(e, "margin-right", "marginRight");
  }
  static getMarginBottom(e) {
    return Ki.getDimension(e, "margin-bottom", "marginBottom");
  }
}
class _n {
  constructor(e, t) {
    this.width = e, this.height = t;
  }
  with(e = this.width, t = this.height) {
    return e !== this.width || t !== this.height ? new _n(e, t) : this;
  }
  static is(e) {
    return typeof e == "object" && typeof e.height == "number" && typeof e.width == "number";
  }
  static lift(e) {
    return e instanceof _n ? e : new _n(e.width, e.height);
  }
  static equals(e, t) {
    return e === t ? !0 : !e || !t ? !1 : e.width === t.width && e.height === t.height;
  }
}
_n.None = new _n(0, 0);
function Fhe(i) {
  let e = i.offsetParent, t = i.offsetTop, n = i.offsetLeft;
  for (; (i = i.parentNode) !== null && i !== i.ownerDocument.body && i !== i.ownerDocument.documentElement; ) {
    t -= i.scrollTop;
    const r = Bhe(i) ? null : e4(i);
    r && (n -= r.direction !== "rtl" ? i.scrollLeft : -i.scrollLeft), i === e && (n += Ki.getBorderLeftWidth(i), t += Ki.getBorderTopWidth(i), t += i.offsetTop, n += i.offsetLeft, e = i.offsetParent);
  }
  return {
    left: n,
    top: t
  };
}
function j9e(i, e, t) {
  typeof e == "number" && (i.style.width = `${e}px`), typeof t == "number" && (i.style.height = `${t}px`);
}
function wr(i) {
  var e, t, n, r;
  const s = i.getBoundingClientRect();
  return {
    left: s.left + ((t = (e = i.ownerDocument.defaultView) === null || e === void 0 ? void 0 : e.scrollX) !== null && t !== void 0 ? t : 0),
    top: s.top + ((r = (n = i.ownerDocument.defaultView) === null || n === void 0 ? void 0 : n.scrollY) !== null && r !== void 0 ? r : 0),
    width: s.width,
    height: s.height
  };
}
function z9e(i) {
  let e = i, t = 1;
  do {
    const n = e4(e).zoom;
    n != null && n !== "1" && (t *= n), e = e.parentElement;
  } while (e !== null && e !== e.ownerDocument.documentElement);
  return t;
}
function Lo(i) {
  const e = Ki.getMarginLeft(i) + Ki.getMarginRight(i);
  return i.offsetWidth + e;
}
function d6(i) {
  const e = Ki.getBorderLeftWidth(i) + Ki.getBorderRightWidth(i), t = Ki.getPaddingLeft(i) + Ki.getPaddingRight(i);
  return i.offsetWidth - e - t;
}
function U9e(i) {
  const e = Ki.getBorderTopWidth(i) + Ki.getBorderBottomWidth(i), t = Ki.getPaddingTop(i) + Ki.getPaddingBottom(i);
  return i.offsetHeight - e - t;
}
function cm(i) {
  const e = Ki.getMarginTop(i) + Ki.getMarginBottom(i);
  return i.offsetHeight + e;
}
function xs(i, e) {
  for (; i; ) {
    if (i === e)
      return !0;
    i = i.parentNode;
  }
  return !1;
}
function G9e(i, e, t) {
  for (; i && i.nodeType === i.ELEMENT_NODE; ) {
    if (i.classList.contains(e))
      return i;
    if (t) {
      if (typeof t == "string") {
        if (i.classList.contains(t))
          return null;
      } else if (i === t)
        return null;
    }
    i = i.parentNode;
  }
  return null;
}
function u6(i, e, t) {
  return !!G9e(i, e, t);
}
function Bhe(i) {
  return i && !!i.host && !!i.mode;
}
function JE(i) {
  return !!Ym(i);
}
function Ym(i) {
  for (var e; i.parentNode; ) {
    if (i === ((e = i.ownerDocument) === null || e === void 0 ? void 0 : e.body))
      return null;
    i = i.parentNode;
  }
  return Bhe(i) ? i : null;
}
function Jl() {
  let i = t4().activeElement;
  for (; i?.shadowRoot; )
    i = i.shadowRoot.activeElement;
  return i;
}
function t4() {
  var i;
  return (i = [document, ...F9e().map((t) => t.document)].find((t) => t.hasFocus())) !== null && i !== void 0 ? i : document;
}
function yl(i = document.getElementsByTagName("head")[0], e) {
  const t = document.createElement("style");
  return t.type = "text/css", t.media = "screen", e?.(t), i.appendChild(t), t;
}
let h6 = null;
function Vhe() {
  return h6 || (h6 = yl()), h6;
}
function q9e(i) {
  var e, t;
  return !((e = i?.sheet) === null || e === void 0) && e.rules ? i.sheet.rules : !((t = i?.sheet) === null || t === void 0) && t.cssRules ? i.sheet.cssRules : [];
}
function cF(i, e, t = Vhe()) {
  !t || !e || t.sheet.insertRule(i + "{" + e + "}", 0);
}
function mX(i, e = Vhe()) {
  if (!e)
    return;
  const t = q9e(e), n = [];
  for (let r = 0; r < t.length; r++)
    t[r].selectorText.indexOf(i) !== -1 && n.push(r);
  for (let r = n.length - 1; r >= 0; r--)
    e.sheet.deleteRule(n[r]);
}
function Zj(i) {
  return typeof HTMLElement == "object" ? i instanceof HTMLElement : i && typeof i == "object" && i.nodeType === 1 && typeof i.nodeName == "string";
}
const Ge = {
  // Mouse
  CLICK: "click",
  AUXCLICK: "auxclick",
  DBLCLICK: "dblclick",
  MOUSE_UP: "mouseup",
  MOUSE_DOWN: "mousedown",
  MOUSE_OVER: "mouseover",
  MOUSE_MOVE: "mousemove",
  MOUSE_OUT: "mouseout",
  MOUSE_ENTER: "mouseenter",
  MOUSE_LEAVE: "mouseleave",
  MOUSE_WHEEL: "wheel",
  POINTER_UP: "pointerup",
  POINTER_DOWN: "pointerdown",
  POINTER_MOVE: "pointermove",
  POINTER_LEAVE: "pointerleave",
  CONTEXT_MENU: "contextmenu",
  WHEEL: "wheel",
  // Keyboard
  KEY_DOWN: "keydown",
  KEY_PRESS: "keypress",
  KEY_UP: "keyup",
  // HTML Document
  LOAD: "load",
  BEFORE_UNLOAD: "beforeunload",
  UNLOAD: "unload",
  PAGE_SHOW: "pageshow",
  PAGE_HIDE: "pagehide",
  ABORT: "abort",
  ERROR: "error",
  RESIZE: "resize",
  SCROLL: "scroll",
  FULLSCREEN_CHANGE: "fullscreenchange",
  WK_FULLSCREEN_CHANGE: "webkitfullscreenchange",
  // Form
  SELECT: "select",
  CHANGE: "change",
  SUBMIT: "submit",
  RESET: "reset",
  FOCUS: "focus",
  FOCUS_IN: "focusin",
  FOCUS_OUT: "focusout",
  BLUR: "blur",
  INPUT: "input",
  // Local Storage
  STORAGE: "storage",
  // Drag
  DRAG_START: "dragstart",
  DRAG: "drag",
  DRAG_ENTER: "dragenter",
  DRAG_LEAVE: "dragleave",
  DRAG_OVER: "dragover",
  DROP: "drop",
  DRAG_END: "dragend",
  // Animation
  ANIMATION_START: Sm ? "webkitAnimationStart" : "animationstart",
  ANIMATION_END: Sm ? "webkitAnimationEnd" : "animationend",
  ANIMATION_ITERATION: Sm ? "webkitAnimationIteration" : "animationiteration"
};
function K9e(i) {
  const e = i;
  return !!(e && typeof e.preventDefault == "function" && typeof e.stopPropagation == "function");
}
const Tt = {
  stop: (i, e) => (i.preventDefault(), e && i.stopPropagation(), i)
};
function Y9e(i) {
  const e = [];
  for (let t = 0; i && i.nodeType === i.ELEMENT_NODE; t++)
    e[t] = i.scrollTop, i = i.parentNode;
  return e;
}
function X9e(i, e) {
  for (let t = 0; i && i.nodeType === i.ELEMENT_NODE; t++)
    i.scrollTop !== e[t] && (i.scrollTop = e[t]), i = i.parentNode;
}
class $E extends we {
  static hasFocusWithin(e) {
    if (Zj(e)) {
      const t = Ym(e), n = t ? t.activeElement : e.ownerDocument.activeElement;
      return xs(n, e);
    } else
      return xs(window.document.activeElement, window.document);
  }
  constructor(e) {
    super(), this._onDidFocus = this._register(new pe()), this.onDidFocus = this._onDidFocus.event, this._onDidBlur = this._register(new pe()), this.onDidBlur = this._onDidBlur.event;
    let t = $E.hasFocusWithin(e), n = !1;
    const r = () => {
      n = !1, t || (t = !0, this._onDidFocus.fire());
    }, s = () => {
      t && (n = !0, window.setTimeout(() => {
        n && (n = !1, t = !1, this._onDidBlur.fire());
      }, 0));
    };
    this._refreshStateHandler = () => {
      $E.hasFocusWithin(e) !== t && (t ? s() : r());
    }, this._register(Ie(e, Ge.FOCUS, r, !0)), this._register(Ie(e, Ge.BLUR, s, !0)), e instanceof HTMLElement && (this._register(Ie(e, Ge.FOCUS_IN, () => this._refreshStateHandler())), this._register(Ie(e, Ge.FOCUS_OUT, () => this._refreshStateHandler())));
  }
}
function yu(i) {
  return new $E(i);
}
function Te(i, ...e) {
  if (i.append(...e), e.length === 1 && typeof e[0] != "string")
    return e[0];
}
function Hhe(i, e) {
  return i.insertBefore(e, i.firstChild), e;
}
function cs(i, ...e) {
  i.innerText = "", Te(i, ...e);
}
const Z9e = /([\w\-]+)?(#([\w\-]+))?((\.([\w\-]+))*)/;
var Ty;
(function(i) {
  i.HTML = "http://www.w3.org/1999/xhtml", i.SVG = "http://www.w3.org/2000/svg";
})(Ty || (Ty = {}));
function Whe(i, e, t, ...n) {
  const r = Z9e.exec(e);
  if (!r)
    throw new Error("Bad use of emmet");
  const s = r[1] || "div";
  let o;
  return i !== Ty.HTML ? o = document.createElementNS(i, s) : o = document.createElement(s), r[3] && (o.id = r[3]), r[4] && (o.className = r[4].replace(/\./g, " ").trim()), t && Object.entries(t).forEach(([a, l]) => {
    typeof l > "u" || (/^on\w+$/.test(a) ? o[a] = l : a === "selected" ? l && o.setAttribute(a, "true") : o.setAttribute(a, l));
  }), o.append(...n), o;
}
function Re(i, e, ...t) {
  return Whe(Ty.HTML, i, e, ...t);
}
Re.SVG = function(i, e, ...t) {
  return Whe(Ty.SVG, i, e, ...t);
};
function Q9e(i, ...e) {
  i ? Zo(...e) : ao(...e);
}
function Zo(...i) {
  for (const e of i)
    e.style.display = "", e.removeAttribute("aria-hidden");
}
function ao(...i) {
  for (const e of i)
    e.style.display = "none", e.setAttribute("aria-hidden", "true");
}
function vX(i) {
  const e = window.devicePixelRatio * i;
  return Math.max(1, Math.floor(e)) / window.devicePixelRatio;
}
function jhe(i) {
  window.open(i, "_blank", "noopener");
}
function J9e(i) {
  const e = () => {
    i(), t = Cl(e);
  };
  let t = Cl(e);
  return Ct(() => t.dispose());
}
Ohe.setPreferredWebSchema(/^https:/.test(window.location.href) ? "https" : "http");
function Og(i) {
  return i ? `url('${Mhe.uriToBrowserUri(i).toString(!0).replace(/'/g, "%27")}')` : "url('')";
}
function _X(i) {
  return `'${i.replace(/'/g, "%27")}'`;
}
function Dm(i, e) {
  if (i !== void 0) {
    const t = i.match(/^\s*var\((.+)\)$/);
    if (t) {
      const n = t[1].split(",", 2);
      return n.length === 2 && (e = Dm(n[1].trim(), e)), `var(${n[0]}, ${e})`;
    }
    return i;
  }
  return e;
}
function $9e(i, e = !1) {
  const t = document.createElement("a");
  return Nhe("afterSanitizeAttributes", (n) => {
    for (const r of ["href", "src"])
      if (n.hasAttribute(r)) {
        const s = n.getAttribute(r);
        if (r === "href" && s.startsWith("#"))
          continue;
        if (t.href = s, !i.includes(t.protocol.replace(/:$/, ""))) {
          if (e && r === "src" && t.href.startsWith("data:"))
            continue;
          n.removeAttribute(r);
        }
      }
  }), Ct(() => {
    Phe("afterSanitizeAttributes");
  });
}
const e7e = Object.freeze([
  "a",
  "abbr",
  "b",
  "bdo",
  "blockquote",
  "br",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "ins",
  "kbd",
  "label",
  "li",
  "mark",
  "ol",
  "p",
  "pre",
  "q",
  "rp",
  "rt",
  "ruby",
  "samp",
  "small",
  "small",
  "source",
  "span",
  "strike",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "tt",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
]);
class Sh extends pe {
  constructor() {
    super(), this._subscriptions = new Ne(), this._keyStatus = {
      altKey: !1,
      shiftKey: !1,
      ctrlKey: !1,
      metaKey: !1
    }, this._subscriptions.add(Ie(window, "keydown", (e) => {
      if (e.defaultPrevented)
        return;
      const t = new Xn(e);
      if (!(t.keyCode === 6 && e.repeat)) {
        if (e.altKey && !this._keyStatus.altKey)
          this._keyStatus.lastKeyPressed = "alt";
        else if (e.ctrlKey && !this._keyStatus.ctrlKey)
          this._keyStatus.lastKeyPressed = "ctrl";
        else if (e.metaKey && !this._keyStatus.metaKey)
          this._keyStatus.lastKeyPressed = "meta";
        else if (e.shiftKey && !this._keyStatus.shiftKey)
          this._keyStatus.lastKeyPressed = "shift";
        else if (t.keyCode !== 6)
          this._keyStatus.lastKeyPressed = void 0;
        else
          return;
        this._keyStatus.altKey = e.altKey, this._keyStatus.ctrlKey = e.ctrlKey, this._keyStatus.metaKey = e.metaKey, this._keyStatus.shiftKey = e.shiftKey, this._keyStatus.lastKeyPressed && (this._keyStatus.event = e, this.fire(this._keyStatus));
      }
    }, !0)), this._subscriptions.add(Ie(window, "keyup", (e) => {
      e.defaultPrevented || (!e.altKey && this._keyStatus.altKey ? this._keyStatus.lastKeyReleased = "alt" : !e.ctrlKey && this._keyStatus.ctrlKey ? this._keyStatus.lastKeyReleased = "ctrl" : !e.metaKey && this._keyStatus.metaKey ? this._keyStatus.lastKeyReleased = "meta" : !e.shiftKey && this._keyStatus.shiftKey ? this._keyStatus.lastKeyReleased = "shift" : this._keyStatus.lastKeyReleased = void 0, this._keyStatus.lastKeyPressed !== this._keyStatus.lastKeyReleased && (this._keyStatus.lastKeyPressed = void 0), this._keyStatus.altKey = e.altKey, this._keyStatus.ctrlKey = e.ctrlKey, this._keyStatus.metaKey = e.metaKey, this._keyStatus.shiftKey = e.shiftKey, this._keyStatus.lastKeyReleased && (this._keyStatus.event = e, this.fire(this._keyStatus)));
    }, !0)), this._subscriptions.add(Ie(document.body, "mousedown", () => {
      this._keyStatus.lastKeyPressed = void 0;
    }, !0)), this._subscriptions.add(Ie(document.body, "mouseup", () => {
      this._keyStatus.lastKeyPressed = void 0;
    }, !0)), this._subscriptions.add(Ie(document.body, "mousemove", (e) => {
      e.buttons && (this._keyStatus.lastKeyPressed = void 0);
    }, !0)), this._subscriptions.add(Ie(window, "blur", () => {
      this.resetKeyStatus();
    }));
  }
  get keyStatus() {
    return this._keyStatus;
  }
  /**
   * Allows to explicitly reset the key status based on more knowledge (#109062)
   */
  resetKeyStatus() {
    this.doResetKeyStatus(), this.fire(this._keyStatus);
  }
  doResetKeyStatus() {
    this._keyStatus = {
      altKey: !1,
      shiftKey: !1,
      ctrlKey: !1,
      metaKey: !1
    };
  }
  static getInstance() {
    return Sh.instance || (Sh.instance = new Sh()), Sh.instance;
  }
  dispose() {
    super.dispose(), this._subscriptions.dispose();
  }
}
class t7e extends we {
  constructor(e, t) {
    super(), this.element = e, this.callbacks = t, this.counter = 0, this.dragStartTime = 0, this.registerListeners();
  }
  registerListeners() {
    this._register(Ie(this.element, Ge.DRAG_ENTER, (e) => {
      this.counter++, this.dragStartTime = e.timeStamp, this.callbacks.onDragEnter(e);
    })), this._register(Ie(this.element, Ge.DRAG_OVER, (e) => {
      var t, n;
      e.preventDefault(), (n = (t = this.callbacks).onDragOver) === null || n === void 0 || n.call(t, e, e.timeStamp - this.dragStartTime);
    })), this._register(Ie(this.element, Ge.DRAG_LEAVE, (e) => {
      this.counter--, this.counter === 0 && (this.dragStartTime = 0, this.callbacks.onDragLeave(e));
    })), this._register(Ie(this.element, Ge.DRAG_END, (e) => {
      this.counter = 0, this.dragStartTime = 0, this.callbacks.onDragEnd(e);
    })), this._register(Ie(this.element, Ge.DROP, (e) => {
      this.counter = 0, this.dragStartTime = 0, this.callbacks.onDrop(e);
    }));
  }
}
const n7e = /(?<tag>[\w\-]+)?(?:#(?<id>[\w\-]+))?(?<class>(?:\.(?:[\w\-]+))*)(?:@(?<name>(?:[\w\_])+))?/;
function ts(i, ...e) {
  let t, n;
  Array.isArray(e[0]) ? (t = {}, n = e[0]) : (t = e[0] || {}, n = e[1]);
  const r = n7e.exec(i);
  if (!r || !r.groups)
    throw new Error("Bad use of h");
  const s = r.groups.tag || "div", o = document.createElement(s);
  r.groups.id && (o.id = r.groups.id);
  const a = [];
  if (r.groups.class)
    for (const c of r.groups.class.split("."))
      c !== "" && a.push(c);
  if (t.className !== void 0)
    for (const c of t.className.split("."))
      c !== "" && a.push(c);
  a.length > 0 && (o.className = a.join(" "));
  const l = {};
  if (r.groups.name && (l[r.groups.name] = o), n)
    for (const c of n)
      c instanceof HTMLElement ? o.appendChild(c) : typeof c == "string" ? o.append(c) : "root" in c && (Object.assign(l, c), o.appendChild(c.root));
  for (const [c, d] of Object.entries(t))
    if (c !== "className")
      if (c === "style")
        for (const [u, h] of Object.entries(d))
          o.style.setProperty(bX(u), typeof h == "number" ? h + "px" : "" + h);
      else c === "tabIndex" ? o.tabIndex = d : o.setAttribute(bX(c), d.toString());
  return l.root = o, l;
}
function bX(i) {
  return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
class n4 {
  constructor(e) {
    this.id = e.id, this.precondition = e.precondition, this._kbOpts = e.kbOpts, this._menuOpts = e.menuOpts, this._description = e.description;
  }
  register() {
    if (Array.isArray(this._menuOpts) ? this._menuOpts.forEach(this._registerMenuItem, this) : this._menuOpts && this._registerMenuItem(this._menuOpts), this._kbOpts) {
      const e = Array.isArray(this._kbOpts) ? this._kbOpts : [this._kbOpts];
      for (const t of e) {
        let n = t.kbExpr;
        this.precondition && (n ? n = ke.and(n, this.precondition) : n = this.precondition);
        const r = {
          id: this.id,
          weight: t.weight,
          args: t.args,
          when: n,
          primary: t.primary,
          secondary: t.secondary,
          win: t.win,
          linux: t.linux,
          mac: t.mac
        };
        Bo.registerKeybindingRule(r);
      }
    }
    on.registerCommand({
      id: this.id,
      handler: (e, t) => this.runCommand(e, t),
      description: this._description
    });
  }
  _registerMenuItem(e) {
    os.appendMenuItem(e.menuId, {
      group: e.group,
      command: {
        id: this.id,
        title: e.title,
        icon: e.icon,
        precondition: this.precondition
      },
      when: e.when,
      order: e.order
    });
  }
}
class gb extends n4 {
  constructor() {
    super(...arguments), this._implementations = [];
  }
  /**
   * A higher priority gets to be looked at first
   */
  addImplementation(e, t, n, r) {
    return this._implementations.push({ priority: e, name: t, implementation: n, when: r }), this._implementations.sort((s, o) => o.priority - s.priority), {
      dispose: () => {
        for (let s = 0; s < this._implementations.length; s++)
          if (this._implementations[s].implementation === n) {
            this._implementations.splice(s, 1);
            return;
          }
      }
    };
  }
  runCommand(e, t) {
    const n = e.get(Ka), r = e.get(yt);
    n.trace(`Executing Command '${this.id}' which has ${this._implementations.length} bound.`);
    for (const s of this._implementations) {
      if (s.when) {
        const a = r.getContext(Jl());
        if (!s.when.evaluate(a))
          continue;
      }
      const o = s.implementation(e, t);
      if (o)
        return n.trace(`Command '${this.id}' was handled by '${s.name}'.`), typeof o == "boolean" ? void 0 : o;
    }
    n.trace(`The Command '${this.id}' was not handled by any implementation.`);
  }
}
class zhe extends n4 {
  constructor(e, t) {
    super(t), this.command = e;
  }
  runCommand(e, t) {
    return this.command.runCommand(e, t);
  }
}
class Kr extends n4 {
  /**
   * Create a command class that is bound to a certain editor contribution.
   */
  static bindToContribution(e) {
    return class extends Kr {
      constructor(n) {
        super(n), this._callback = n.handler;
      }
      runEditorCommand(n, r, s) {
        const o = e(r);
        o && this._callback(o, s);
      }
    };
  }
  static runEditorCommand(e, t, n, r) {
    const s = e.get(Sn), o = s.getFocusedCodeEditor() || s.getActiveCodeEditor();
    if (o)
      return o.invokeWithinContext((a) => {
        if (a.get(yt).contextMatchesRules(n ?? void 0))
          return r(a, o, t);
      });
  }
  runCommand(e, t) {
    return Kr.runEditorCommand(e, t, this.precondition, (n, r, s) => this.runEditorCommand(n, r, s));
  }
}
class Je extends Kr {
  static convertOptions(e) {
    let t;
    Array.isArray(e.menuOpts) ? t = e.menuOpts : e.menuOpts ? t = [e.menuOpts] : t = [];
    function n(r) {
      return r.menuId || (r.menuId = J.EditorContext), r.title || (r.title = e.label), r.when = ke.and(e.precondition, r.when), r;
    }
    return Array.isArray(e.contextMenuOpts) ? t.push(...e.contextMenuOpts.map(n)) : e.contextMenuOpts && t.push(n(e.contextMenuOpts)), e.menuOpts = t, e;
  }
  constructor(e) {
    super(Je.convertOptions(e)), this.label = e.label, this.alias = e.alias;
  }
  runEditorCommand(e, t, n) {
    return this.reportTelemetry(e, t), this.run(e, t, n || {});
  }
  reportTelemetry(e, t) {
    e.get(qa).publicLog2("editorActionInvoked", { name: this.label, id: this.id });
  }
}
class Uhe extends Je {
  constructor() {
    super(...arguments), this._implementations = [];
  }
  /**
   * A higher priority gets to be looked at first
   */
  addImplementation(e, t) {
    return this._implementations.push([e, t]), this._implementations.sort((n, r) => r[0] - n[0]), {
      dispose: () => {
        for (let n = 0; n < this._implementations.length; n++)
          if (this._implementations[n][1] === t) {
            this._implementations.splice(n, 1);
            return;
          }
      }
    };
  }
  run(e, t, n) {
    for (const r of this._implementations) {
      const s = r[1](e, t, n);
      if (s)
        return typeof s == "boolean" ? void 0 : s;
    }
  }
}
class vd extends Ga {
  run(e, ...t) {
    const n = e.get(Sn), r = n.getFocusedCodeEditor() || n.getActiveCodeEditor();
    if (r)
      return r.invokeWithinContext((s) => {
        var o, a;
        const l = s.get(yt), c = s.get(Ka);
        if (!l.contextMatchesRules((o = this.desc.precondition) !== null && o !== void 0 ? o : void 0)) {
          c.debug("[EditorAction2] NOT running command because its precondition is FALSE", this.desc.id, (a = this.desc.precondition) === null || a === void 0 ? void 0 : a.serialize());
          return;
        }
        return this.runEditorCommand(s, r, ...t);
      });
  }
}
function Ru(i, e) {
  on.registerCommand(i, function(t, ...n) {
    const r = t.get(bt), [s, o] = n;
    On(pt.isUri(s)), On(ve.isIPosition(o));
    const a = t.get(fi).getModel(s);
    if (a) {
      const l = ve.lift(o);
      return r.invokeFunction(e, a, l, ...n.slice(2));
    }
    return t.get(Wo).createModelReference(s).then((l) => new Promise((c, d) => {
      try {
        const u = r.invokeFunction(e, l.object.textEditorModel, ve.lift(o), n.slice(2));
        c(u);
      } catch (u) {
        d(u);
      }
    }).finally(() => {
      l.dispose();
    }));
  });
}
function ze(i) {
  return sl.INSTANCE.registerEditorCommand(i), i;
}
function Be(i) {
  const e = new i();
  return sl.INSTANCE.registerEditorAction(e), e;
}
function Ghe(i) {
  return sl.INSTANCE.registerEditorAction(i), i;
}
function i7e(i) {
  sl.INSTANCE.registerEditorAction(i);
}
function pn(i, e, t) {
  sl.INSTANCE.registerEditorContribution(i, e, t);
}
var Av;
(function(i) {
  function e(o) {
    return sl.INSTANCE.getEditorCommand(o);
  }
  i.getEditorCommand = e;
  function t() {
    return sl.INSTANCE.getEditorActions();
  }
  i.getEditorActions = t;
  function n() {
    return sl.INSTANCE.getEditorContributions();
  }
  i.getEditorContributions = n;
  function r(o) {
    return sl.INSTANCE.getEditorContributions().filter((a) => o.indexOf(a.id) >= 0);
  }
  i.getSomeEditorContributions = r;
  function s() {
    return sl.INSTANCE.getDiffEditorContributions();
  }
  i.getDiffEditorContributions = s;
})(Av || (Av = {}));
const r7e = {
  EditorCommonContributions: "editor.contributions"
};
class sl {
  constructor() {
    this.editorContributions = [], this.diffEditorContributions = [], this.editorActions = [], this.editorCommands = /* @__PURE__ */ Object.create(null);
  }
  registerEditorContribution(e, t, n) {
    this.editorContributions.push({ id: e, ctor: t, instantiation: n });
  }
  getEditorContributions() {
    return this.editorContributions.slice(0);
  }
  getDiffEditorContributions() {
    return this.diffEditorContributions.slice(0);
  }
  registerEditorAction(e) {
    e.register(), this.editorActions.push(e);
  }
  getEditorActions() {
    return this.editorActions;
  }
  registerEditorCommand(e) {
    e.register(), this.editorCommands[e.id] = e;
  }
  getEditorCommand(e) {
    return this.editorCommands[e] || null;
  }
}
sl.INSTANCE = new sl();
Di.add(r7e.EditorCommonContributions, sl.INSTANCE);
function wS(i) {
  return i.register(), i;
}
const qhe = wS(new gb({
  id: "undo",
  precondition: void 0,
  kbOpts: {
    weight: 0,
    primary: 2104
    /* KeyCode.KeyZ */
  },
  menuOpts: [{
    menuId: J.MenubarEditMenu,
    group: "1_do",
    title: C({ key: "miUndo", comment: ["&& denotes a mnemonic"] }, "&&Undo"),
    order: 1
  }, {
    menuId: J.CommandPalette,
    group: "",
    title: C("undo", "Undo"),
    order: 1
  }]
}));
wS(new zhe(qhe, { id: "default:undo", precondition: void 0 }));
const Khe = wS(new gb({
  id: "redo",
  precondition: void 0,
  kbOpts: {
    weight: 0,
    primary: 2103,
    secondary: [
      3128
      /* KeyCode.KeyZ */
    ],
    mac: {
      primary: 3128
      /* KeyCode.KeyZ */
    }
  },
  menuOpts: [{
    menuId: J.MenubarEditMenu,
    group: "1_do",
    title: C({ key: "miRedo", comment: ["&& denotes a mnemonic"] }, "&&Redo"),
    order: 2
  }, {
    menuId: J.CommandPalette,
    group: "",
    title: C("redo", "Redo"),
    order: 1
  }]
}));
wS(new zhe(Khe, { id: "default:redo", precondition: void 0 }));
const s7e = wS(new gb({
  id: "editor.action.selectAll",
  precondition: void 0,
  kbOpts: {
    weight: 0,
    kbExpr: null,
    primary: 2079
    /* KeyCode.KeyA */
  },
  menuOpts: [{
    menuId: J.MenubarSelectionMenu,
    group: "1_basic",
    title: C({ key: "miSelectAll", comment: ["&& denotes a mnemonic"] }, "&&Select All"),
    order: 1
  }, {
    menuId: J.CommandPalette,
    group: "",
    title: C("selectAll", "Select All"),
    order: 1
  }]
})), Yhe = Symbol("MicrotaskDelay");
var el = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, j2 = function(i) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = i[Symbol.asyncIterator], t;
  return e ? e.call(i) : (i = typeof __values == "function" ? __values(i) : i[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function n(s) {
    t[s] = i[s] && function(o) {
      return new Promise(function(a, l) {
        o = i[s](o), r(a, l, o.done, o.value);
      });
    };
  }
  function r(s, o, a, l) {
    Promise.resolve(l).then(function(c) {
      s({ value: c, done: a });
    }, o);
  }
};
function dF(i) {
  return !!i && typeof i.then == "function";
}
function Ir(i) {
  const e = new lr(), t = i(e.token), n = new Promise((r, s) => {
    const o = e.token.onCancellationRequested(() => {
      o.dispose(), e.dispose(), s(new op());
    });
    Promise.resolve(t).then((a) => {
      o.dispose(), e.dispose(), r(a);
    }, (a) => {
      o.dispose(), e.dispose(), s(a);
    });
  });
  return new class {
    cancel() {
      e.cancel();
    }
    then(r, s) {
      return n.then(r, s);
    }
    catch(r) {
      return this.then(void 0, r);
    }
    finally(r) {
      return n.finally(r);
    }
  }();
}
function i4(i, e, t) {
  return new Promise((n, r) => {
    const s = e.onCancellationRequested(() => {
      s.dispose(), n(t);
    });
    i.then(n, r).finally(() => s.dispose());
  });
}
class o7e {
  constructor() {
    this.isDisposed = !1, this.activePromise = null, this.queuedPromise = null, this.queuedPromiseFactory = null;
  }
  queue(e) {
    if (this.isDisposed)
      return Promise.reject(new Error("Throttler is disposed"));
    if (this.activePromise) {
      if (this.queuedPromiseFactory = e, !this.queuedPromise) {
        const t = () => {
          if (this.queuedPromise = null, this.isDisposed)
            return;
          const n = this.queue(this.queuedPromiseFactory);
          return this.queuedPromiseFactory = null, n;
        };
        this.queuedPromise = new Promise((n) => {
          this.activePromise.then(t, t).then(n);
        });
      }
      return new Promise((t, n) => {
        this.queuedPromise.then(t, n);
      });
    }
    return this.activePromise = e(), new Promise((t, n) => {
      this.activePromise.then((r) => {
        this.activePromise = null, t(r);
      }, (r) => {
        this.activePromise = null, n(r);
      });
    });
  }
  dispose() {
    this.isDisposed = !0;
  }
}
const a7e = (i, e) => {
  let t = !0;
  const n = setTimeout(() => {
    t = !1, e();
  }, i);
  return {
    isTriggered: () => t,
    dispose: () => {
      clearTimeout(n), t = !1;
    }
  };
}, l7e = (i) => {
  let e = !0;
  return queueMicrotask(() => {
    e && (e = !1, i());
  }), {
    isTriggered: () => e,
    dispose: () => {
      e = !1;
    }
  };
};
class ac {
  constructor(e) {
    this.defaultDelay = e, this.deferred = null, this.completionPromise = null, this.doResolve = null, this.doReject = null, this.task = null;
  }
  trigger(e, t = this.defaultDelay) {
    this.task = e, this.cancelTimeout(), this.completionPromise || (this.completionPromise = new Promise((r, s) => {
      this.doResolve = r, this.doReject = s;
    }).then(() => {
      if (this.completionPromise = null, this.doResolve = null, this.task) {
        const r = this.task;
        return this.task = null, r();
      }
    }));
    const n = () => {
      var r;
      this.deferred = null, (r = this.doResolve) === null || r === void 0 || r.call(this, null);
    };
    return this.deferred = t === Yhe ? l7e(n) : a7e(t, n), this.completionPromise;
  }
  isTriggered() {
    var e;
    return !!(!((e = this.deferred) === null || e === void 0) && e.isTriggered());
  }
  cancel() {
    var e;
    this.cancelTimeout(), this.completionPromise && ((e = this.doReject) === null || e === void 0 || e.call(this, new op()), this.completionPromise = null);
  }
  cancelTimeout() {
    var e;
    (e = this.deferred) === null || e === void 0 || e.dispose(), this.deferred = null;
  }
  dispose() {
    this.cancel();
  }
}
class Xhe {
  constructor(e) {
    this.delayer = new ac(e), this.throttler = new o7e();
  }
  trigger(e, t) {
    return this.delayer.trigger(() => this.throttler.queue(e), t);
  }
  cancel() {
    this.delayer.cancel();
  }
  dispose() {
    this.delayer.dispose(), this.throttler.dispose();
  }
}
function Mg(i, e) {
  return e ? new Promise((t, n) => {
    const r = setTimeout(() => {
      s.dispose(), t();
    }, i), s = e.onCancellationRequested(() => {
      clearTimeout(r), s.dispose(), n(new op());
    });
  }) : Ir((t) => Mg(i, t));
}
function Rg(i, e = 0, t) {
  const n = setTimeout(() => {
    i(), t && r.dispose();
  }, e), r = Ct(() => {
    clearTimeout(n), t?.deleteAndLeak(r);
  });
  return t?.add(r), r;
}
function Zhe(i, e = (n) => !!n, t = null) {
  let n = 0;
  const r = i.length, s = () => {
    if (n >= r)
      return Promise.resolve(t);
    const o = i[n++];
    return Promise.resolve(o()).then((l) => e(l) ? Promise.resolve(l) : s());
  };
  return s();
}
class uc {
  constructor(e, t) {
    this._token = -1, typeof e == "function" && typeof t == "number" && this.setIfNotSet(e, t);
  }
  dispose() {
    this.cancel();
  }
  cancel() {
    this._token !== -1 && (clearTimeout(this._token), this._token = -1);
  }
  cancelAndSet(e, t) {
    this.cancel(), this._token = setTimeout(() => {
      this._token = -1, e();
    }, t);
  }
  setIfNotSet(e, t) {
    this._token === -1 && (this._token = setTimeout(() => {
      this._token = -1, e();
    }, t));
  }
}
class SS {
  constructor() {
    this._token = -1;
  }
  dispose() {
    this.cancel();
  }
  cancel() {
    this._token !== -1 && (clearInterval(this._token), this._token = -1);
  }
  cancelAndSet(e, t) {
    this.cancel(), this._token = setInterval(() => {
      e();
    }, t);
  }
}
class Rn {
  constructor(e, t) {
    this.timeoutToken = -1, this.runner = e, this.timeout = t, this.timeoutHandler = this.onTimeout.bind(this);
  }
  /**
   * Dispose RunOnceScheduler
   */
  dispose() {
    this.cancel(), this.runner = null;
  }
  /**
   * Cancel current scheduled runner (if any).
   */
  cancel() {
    this.isScheduled() && (clearTimeout(this.timeoutToken), this.timeoutToken = -1);
  }
  /**
   * Cancel previous runner (if any) & schedule a new runner.
   */
  schedule(e = this.timeout) {
    this.cancel(), this.timeoutToken = setTimeout(this.timeoutHandler, e);
  }
  get delay() {
    return this.timeout;
  }
  set delay(e) {
    this.timeout = e;
  }
  /**
   * Returns true if scheduled.
   */
  isScheduled() {
    return this.timeoutToken !== -1;
  }
  onTimeout() {
    this.timeoutToken = -1, this.runner && this.doRun();
  }
  doRun() {
    var e;
    (e = this.runner) === null || e === void 0 || e.call(this);
  }
}
let xh;
(function() {
  typeof requestIdleCallback != "function" || typeof cancelIdleCallback != "function" ? xh = (i) => {
    Hue(() => {
      if (e)
        return;
      const t = Date.now() + 15;
      i(Object.freeze({
        didTimeout: !0,
        timeRemaining() {
          return Math.max(0, t - Date.now());
        }
      }));
    });
    let e = !1;
    return {
      dispose() {
        e || (e = !0);
      }
    };
  } : xh = (i, e) => {
    const t = requestIdleCallback(i, typeof e == "number" ? { timeout: e } : void 0);
    let n = !1;
    return {
      dispose() {
        n || (n = !0, cancelIdleCallback(t));
      }
    };
  };
})();
class O3 {
  constructor(e) {
    this._didRun = !1, this._executor = () => {
      try {
        this._value = e();
      } catch (t) {
        this._error = t;
      } finally {
        this._didRun = !0;
      }
    }, this._handle = xh(() => this._executor());
  }
  dispose() {
    this._handle.dispose();
  }
  get value() {
    if (this._didRun || (this._handle.dispose(), this._executor()), this._error)
      throw this._error;
    return this._value;
  }
  get isInitialized() {
    return this._didRun;
  }
}
class r4 {
  get isRejected() {
    var e;
    return ((e = this.outcome) === null || e === void 0 ? void 0 : e.outcome) === 1;
  }
  get isSettled() {
    return !!this.outcome;
  }
  constructor() {
    this.p = new Promise((e, t) => {
      this.completeCallback = e, this.errorCallback = t;
    });
  }
  complete(e) {
    return new Promise((t) => {
      this.completeCallback(e), this.outcome = { outcome: 0, value: e }, t();
    });
  }
  error(e) {
    return new Promise((t) => {
      this.errorCallback(e), this.outcome = { outcome: 1, value: e }, t();
    });
  }
  cancel() {
    return this.error(new op());
  }
}
var uF;
(function(i) {
  function e(n) {
    return el(this, void 0, void 0, function* () {
      let r;
      const s = yield Promise.all(n.map((o) => o.then((a) => a, (a) => {
        r || (r = a);
      })));
      if (typeof r < "u")
        throw r;
      return s;
    });
  }
  i.settled = e;
  function t(n) {
    return new Promise((r, s) => el(this, void 0, void 0, function* () {
      try {
        yield n(r, s);
      } catch (o) {
        s(o);
      }
    }));
  }
  i.withAsyncBody = t;
})(uF || (uF = {}));
class hr {
  static fromArray(e) {
    return new hr((t) => {
      t.emitMany(e);
    });
  }
  static fromPromise(e) {
    return new hr((t) => el(this, void 0, void 0, function* () {
      t.emitMany(yield e);
    }));
  }
  static fromPromises(e) {
    return new hr((t) => el(this, void 0, void 0, function* () {
      yield Promise.all(e.map((n) => el(this, void 0, void 0, function* () {
        return t.emitOne(yield n);
      })));
    }));
  }
  static merge(e) {
    return new hr((t) => el(this, void 0, void 0, function* () {
      yield Promise.all(e.map((n) => {
        var r, s, o;
        return el(this, void 0, void 0, function* () {
          var a, l, c, d;
          try {
            for (r = !0, s = j2(n); o = yield s.next(), a = o.done, !a; r = !0) {
              d = o.value, r = !1;
              const u = d;
              t.emitOne(u);
            }
          } catch (u) {
            l = { error: u };
          } finally {
            try {
              !r && !a && (c = s.return) && (yield c.call(s));
            } finally {
              if (l) throw l.error;
            }
          }
        });
      }));
    }));
  }
  constructor(e) {
    this._state = 0, this._results = [], this._error = null, this._onStateChanged = new pe(), queueMicrotask(() => el(this, void 0, void 0, function* () {
      const t = {
        emitOne: (n) => this.emitOne(n),
        emitMany: (n) => this.emitMany(n),
        reject: (n) => this.reject(n)
      };
      try {
        yield Promise.resolve(e(t)), this.resolve();
      } catch (n) {
        this.reject(n);
      } finally {
        t.emitOne = void 0, t.emitMany = void 0, t.reject = void 0;
      }
    }));
  }
  [Symbol.asyncIterator]() {
    let e = 0;
    return {
      next: () => el(this, void 0, void 0, function* () {
        do {
          if (this._state === 2)
            throw this._error;
          if (e < this._results.length)
            return { done: !1, value: this._results[e++] };
          if (this._state === 1)
            return { done: !0, value: void 0 };
          yield qe.toPromise(this._onStateChanged.event);
        } while (!0);
      })
    };
  }
  static map(e, t) {
    return new hr((n) => el(this, void 0, void 0, function* () {
      var r, s, o, a;
      try {
        for (var l = !0, c = j2(e), d; d = yield c.next(), r = d.done, !r; l = !0) {
          a = d.value, l = !1;
          const u = a;
          n.emitOne(t(u));
        }
      } catch (u) {
        s = { error: u };
      } finally {
        try {
          !l && !r && (o = c.return) && (yield o.call(c));
        } finally {
          if (s) throw s.error;
        }
      }
    }));
  }
  map(e) {
    return hr.map(this, e);
  }
  static filter(e, t) {
    return new hr((n) => el(this, void 0, void 0, function* () {
      var r, s, o, a;
      try {
        for (var l = !0, c = j2(e), d; d = yield c.next(), r = d.done, !r; l = !0) {
          a = d.value, l = !1;
          const u = a;
          t(u) && n.emitOne(u);
        }
      } catch (u) {
        s = { error: u };
      } finally {
        try {
          !l && !r && (o = c.return) && (yield o.call(c));
        } finally {
          if (s) throw s.error;
        }
      }
    }));
  }
  filter(e) {
    return hr.filter(this, e);
  }
  static coalesce(e) {
    return hr.filter(e, (t) => !!t);
  }
  coalesce() {
    return hr.coalesce(this);
  }
  static toPromise(e) {
    var t, n, r, s, o, a, l;
    return el(this, void 0, void 0, function* () {
      const c = [];
      try {
        for (t = !0, n = j2(e); r = yield n.next(), s = r.done, !s; t = !0) {
          l = r.value, t = !1;
          const d = l;
          c.push(d);
        }
      } catch (d) {
        o = { error: d };
      } finally {
        try {
          !t && !s && (a = n.return) && (yield a.call(n));
        } finally {
          if (o) throw o.error;
        }
      }
      return c;
    });
  }
  toPromise() {
    return hr.toPromise(this);
  }
  /**
   * The value will be appended at the end.
   *
   * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
   */
  emitOne(e) {
    this._state === 0 && (this._results.push(e), this._onStateChanged.fire());
  }
  /**
   * The values will be appended at the end.
   *
   * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
   */
  emitMany(e) {
    this._state === 0 && (this._results = this._results.concat(e), this._onStateChanged.fire());
  }
  /**
   * Calling `resolve()` will mark the result array as complete.
   *
   * **NOTE** `resolve()` must be called, otherwise all consumers of this iterable will hang indefinitely, similar to a non-resolved promise.
   * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
   */
  resolve() {
    this._state === 0 && (this._state = 1, this._onStateChanged.fire());
  }
  /**
   * Writing an error will permanently invalidate this iterable.
   * The current users will receive an error thrown, as will all future users.
   *
   * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
   */
  reject(e) {
    this._state === 0 && (this._state = 2, this._error = e, this._onStateChanged.fire());
  }
}
hr.EMPTY = hr.fromArray([]);
class c7e extends hr {
  constructor(e, t) {
    super(t), this._source = e;
  }
  cancel() {
    this._source.cancel();
  }
}
function d7e(i) {
  const e = new lr(), t = i(e.token);
  return new c7e(e, (n) => el(this, void 0, void 0, function* () {
    var r, s, o, a;
    const l = e.token.onCancellationRequested(() => {
      l.dispose(), e.dispose(), n.reject(new op());
    });
    try {
      try {
        for (var c = !0, d = j2(t), u; u = yield d.next(), r = u.done, !r; c = !0) {
          a = u.value, c = !1;
          const h = a;
          if (e.token.isCancellationRequested)
            return;
          n.emitOne(h);
        }
      } catch (h) {
        s = { error: h };
      } finally {
        try {
          !c && !r && (o = d.return) && (yield o.call(d));
        } finally {
          if (s) throw s.error;
        }
      }
      l.dispose(), e.dispose();
    } catch (h) {
      l.dispose(), e.dispose(), n.reject(h);
    }
  }));
}
const u7e = "$initialize";
let CX = !1;
function hF(i) {
  sp && (CX || (CX = !0, console.warn("Could not create web worker(s). Falling back to loading web worker code in main thread, which might cause UI freezes. Please see https://github.com/microsoft/monaco-editor#faq")), console.warn(i.message));
}
class h7e {
  constructor(e, t, n, r) {
    this.vsWorker = e, this.req = t, this.method = n, this.args = r, this.type = 0;
  }
}
class yX {
  constructor(e, t, n, r) {
    this.vsWorker = e, this.seq = t, this.res = n, this.err = r, this.type = 1;
  }
}
class f7e {
  constructor(e, t, n, r) {
    this.vsWorker = e, this.req = t, this.eventName = n, this.arg = r, this.type = 2;
  }
}
class g7e {
  constructor(e, t, n) {
    this.vsWorker = e, this.req = t, this.event = n, this.type = 3;
  }
}
class p7e {
  constructor(e, t) {
    this.vsWorker = e, this.req = t, this.type = 4;
  }
}
class m7e {
  constructor(e) {
    this._workerId = -1, this._handler = e, this._lastSentReq = 0, this._pendingReplies = /* @__PURE__ */ Object.create(null), this._pendingEmitters = /* @__PURE__ */ new Map(), this._pendingEvents = /* @__PURE__ */ new Map();
  }
  setWorkerId(e) {
    this._workerId = e;
  }
  sendMessage(e, t) {
    const n = String(++this._lastSentReq);
    return new Promise((r, s) => {
      this._pendingReplies[n] = {
        resolve: r,
        reject: s
      }, this._send(new h7e(this._workerId, n, e, t));
    });
  }
  listen(e, t) {
    let n = null;
    const r = new pe({
      onWillAddFirstListener: () => {
        n = String(++this._lastSentReq), this._pendingEmitters.set(n, r), this._send(new f7e(this._workerId, n, e, t));
      },
      onDidRemoveLastListener: () => {
        this._pendingEmitters.delete(n), this._send(new p7e(this._workerId, n)), n = null;
      }
    });
    return r.event;
  }
  handleMessage(e) {
    !e || !e.vsWorker || this._workerId !== -1 && e.vsWorker !== this._workerId || this._handleMessage(e);
  }
  _handleMessage(e) {
    switch (e.type) {
      case 1:
        return this._handleReplyMessage(e);
      case 0:
        return this._handleRequestMessage(e);
      case 2:
        return this._handleSubscribeEventMessage(e);
      case 3:
        return this._handleEventMessage(e);
      case 4:
        return this._handleUnsubscribeEventMessage(e);
    }
  }
  _handleReplyMessage(e) {
    if (!this._pendingReplies[e.seq]) {
      console.warn("Got reply to unknown seq");
      return;
    }
    const t = this._pendingReplies[e.seq];
    if (delete this._pendingReplies[e.seq], e.err) {
      let n = e.err;
      e.err.$isError && (n = new Error(), n.name = e.err.name, n.message = e.err.message, n.stack = e.err.stack), t.reject(n);
      return;
    }
    t.resolve(e.res);
  }
  _handleRequestMessage(e) {
    const t = e.req;
    this._handler.handleMessage(e.method, e.args).then((r) => {
      this._send(new yX(this._workerId, t, r, void 0));
    }, (r) => {
      r.detail instanceof Error && (r.detail = XY(r.detail)), this._send(new yX(this._workerId, t, void 0, XY(r)));
    });
  }
  _handleSubscribeEventMessage(e) {
    const t = e.req, n = this._handler.handleEvent(e.eventName, e.arg)((r) => {
      this._send(new g7e(this._workerId, t, r));
    });
    this._pendingEvents.set(t, n);
  }
  _handleEventMessage(e) {
    if (!this._pendingEmitters.has(e.req)) {
      console.warn("Got event for unknown req");
      return;
    }
    this._pendingEmitters.get(e.req).fire(e.event);
  }
  _handleUnsubscribeEventMessage(e) {
    if (!this._pendingEvents.has(e.req)) {
      console.warn("Got unsubscribe for unknown req");
      return;
    }
    this._pendingEvents.get(e.req).dispose(), this._pendingEvents.delete(e.req);
  }
  _send(e) {
    const t = [];
    if (e.type === 0)
      for (let n = 0; n < e.args.length; n++)
        e.args[n] instanceof ArrayBuffer && t.push(e.args[n]);
    else e.type === 1 && e.res instanceof ArrayBuffer && t.push(e.res);
    this._handler.sendMessage(e, t);
  }
}
class v7e extends we {
  constructor(e, t, n) {
    super();
    let r = null;
    this._worker = this._register(e.create("vs/base/common/worker/simpleWorker", (d) => {
      this._protocol.handleMessage(d);
    }, (d) => {
      r?.(d);
    })), this._protocol = new m7e({
      sendMessage: (d, u) => {
        this._worker.postMessage(d, u);
      },
      handleMessage: (d, u) => {
        if (typeof n[d] != "function")
          return Promise.reject(new Error("Missing method " + d + " on main thread host."));
        try {
          return Promise.resolve(n[d].apply(n, u));
        } catch (h) {
          return Promise.reject(h);
        }
      },
      handleEvent: (d, u) => {
        if (Jhe(d)) {
          const h = n[d].call(n, u);
          if (typeof h != "function")
            throw new Error(`Missing dynamic event ${d} on main thread host.`);
          return h;
        }
        if (Qhe(d)) {
          const h = n[d];
          if (typeof h != "function")
            throw new Error(`Missing event ${d} on main thread host.`);
          return h;
        }
        throw new Error(`Malformed event name ${d}`);
      }
    }), this._protocol.setWorkerId(this._worker.getId());
    let s = null;
    const o = globalThis.require;
    typeof o < "u" && typeof o.getConfig == "function" ? s = o.getConfig() : typeof globalThis.requirejs < "u" && (s = globalThis.requirejs.s.contexts._.config);
    const a = Dj(n);
    this._onModuleLoaded = this._protocol.sendMessage(u7e, [
      this._worker.getId(),
      JSON.parse(JSON.stringify(s)),
      t,
      a
    ]);
    const l = (d, u) => this._request(d, u), c = (d, u) => this._protocol.listen(d, u);
    this._lazyProxy = new Promise((d, u) => {
      r = u, this._onModuleLoaded.then((h) => {
        d(_7e(h, l, c));
      }, (h) => {
        u(h), this._onError("Worker failed to load " + t, h);
      });
    });
  }
  getProxyObject() {
    return this._lazyProxy;
  }
  _request(e, t) {
    return new Promise((n, r) => {
      this._onModuleLoaded.then(() => {
        this._protocol.sendMessage(e, t).then(n, r);
      }, r);
    });
  }
  _onError(e, t) {
    console.error(e), console.info(t);
  }
}
function Qhe(i) {
  return i[0] === "o" && i[1] === "n" && Od(i.charCodeAt(2));
}
function Jhe(i) {
  return /^onDynamic/.test(i) && Od(i.charCodeAt(9));
}
function _7e(i, e, t) {
  const n = (o) => function() {
    const a = Array.prototype.slice.call(arguments, 0);
    return e(o, a);
  }, r = (o) => function(a) {
    return t(o, a);
  }, s = {};
  for (const o of i) {
    if (Jhe(o)) {
      s[o] = r(o);
      continue;
    }
    if (Qhe(o)) {
      s[o] = t(o, void 0);
      continue;
    }
    s[o] = n(o);
  }
  return s;
}
function af(i, e) {
  var t;
  const n = globalThis.MonacoEnvironment;
  if (n?.createTrustedTypesPolicy)
    try {
      return n.createTrustedTypesPolicy(i, e);
    } catch (r) {
      It(r);
      return;
    }
  try {
    return (t = window.trustedTypes) === null || t === void 0 ? void 0 : t.createPolicy(i, e);
  } catch (r) {
    It(r);
    return;
  }
}
const wX = af("defaultWorkerFactory", { createScriptURL: (i) => i });
function b7e(i) {
  const e = globalThis.MonacoEnvironment;
  if (e) {
    if (typeof e.getWorker == "function")
      return e.getWorker("workerMain.js", i);
    if (typeof e.getWorkerUrl == "function") {
      const t = e.getWorkerUrl("workerMain.js", i);
      return new Worker(wX ? wX.createScriptURL(t) : t, { name: i });
    }
  }
  throw new Error("You must define a function MonacoEnvironment.getWorkerUrl or MonacoEnvironment.getWorker");
}
function C7e(i) {
  return typeof i.then == "function";
}
class y7e {
  constructor(e, t, n, r, s) {
    this.id = t, this.label = n;
    const o = b7e(n);
    C7e(o) ? this.worker = o : this.worker = Promise.resolve(o), this.postMessage(e, []), this.worker.then((a) => {
      a.onmessage = function(l) {
        r(l.data);
      }, a.onmessageerror = s, typeof a.addEventListener == "function" && a.addEventListener("error", s);
    });
  }
  getId() {
    return this.id;
  }
  postMessage(e, t) {
    var n;
    (n = this.worker) === null || n === void 0 || n.then((r) => {
      try {
        r.postMessage(e, t);
      } catch (s) {
        It(s), It(new Error(`FAILED to post message to '${this.label}'-worker`, { cause: s }));
      }
    });
  }
  dispose() {
    var e;
    (e = this.worker) === null || e === void 0 || e.then((t) => t.terminate()), this.worker = null;
  }
}
class s4 {
  constructor(e) {
    this._label = e, this._webWorkerFailedBeforeError = !1;
  }
  create(e, t, n) {
    const r = ++s4.LAST_WORKER_ID;
    if (this._webWorkerFailedBeforeError)
      throw this._webWorkerFailedBeforeError;
    return new y7e(e, r, this._label || "anonymous" + r, t, (s) => {
      hF(s), this._webWorkerFailedBeforeError = s, n(s);
    });
  }
}
s4.LAST_WORKER_ID = 0;
var mr;
(function(i) {
  i[i.None = 0] = "None", i[i.Indent = 1] = "Indent", i[i.IndentOutdent = 2] = "IndentOutdent", i[i.Outdent = 3] = "Outdent";
})(mr || (mr = {}));
class f6 {
  constructor(e) {
    if (this._neutralCharacter = null, this._neutralCharacterSearched = !1, this.open = e.open, this.close = e.close, this._inString = !0, this._inComment = !0, this._inRegEx = !0, Array.isArray(e.notIn))
      for (let t = 0, n = e.notIn.length; t < n; t++)
        switch (e.notIn[t]) {
          case "string":
            this._inString = !1;
            break;
          case "comment":
            this._inComment = !1;
            break;
          case "regex":
            this._inRegEx = !1;
            break;
        }
  }
  isOK(e) {
    switch (e) {
      case 0:
        return !0;
      case 1:
        return this._inComment;
      case 2:
        return this._inString;
      case 3:
        return this._inRegEx;
    }
  }
  shouldAutoClose(e, t) {
    if (e.getTokenCount() === 0)
      return !0;
    const n = e.findTokenIndexAtOffset(t - 2), r = e.getStandardTokenType(n);
    return this.isOK(r);
  }
  _findNeutralCharacterInRange(e, t) {
    for (let n = e; n <= t; n++) {
      const r = String.fromCharCode(n);
      if (!this.open.includes(r) && !this.close.includes(r))
        return r;
    }
    return null;
  }
  /**
   * Find a character in the range [0-9a-zA-Z] that does not appear in the open or close
   */
  findNeutralCharacter() {
    return this._neutralCharacterSearched || (this._neutralCharacterSearched = !0, this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(
      48,
      57
      /* CharCode.Digit9 */
    )), this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(
      97,
      122
      /* CharCode.z */
    )), this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(
      65,
      90
      /* CharCode.Z */
    ))), this._neutralCharacter;
  }
}
class w7e {
  constructor(e) {
    this.autoClosingPairsOpenByStart = /* @__PURE__ */ new Map(), this.autoClosingPairsOpenByEnd = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseByStart = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseByEnd = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseSingleChar = /* @__PURE__ */ new Map();
    for (const t of e)
      Jb(this.autoClosingPairsOpenByStart, t.open.charAt(0), t), Jb(this.autoClosingPairsOpenByEnd, t.open.charAt(t.open.length - 1), t), Jb(this.autoClosingPairsCloseByStart, t.close.charAt(0), t), Jb(this.autoClosingPairsCloseByEnd, t.close.charAt(t.close.length - 1), t), t.close.length === 1 && t.open.length === 1 && Jb(this.autoClosingPairsCloseSingleChar, t.close, t);
  }
}
function Jb(i, e, t) {
  i.has(e) ? i.get(e).push(t) : i.set(e, [t]);
}
function o4(i, e) {
  const t = i.getCount(), n = i.findTokenIndexAtOffset(e), r = i.getLanguageId(n);
  let s = n;
  for (; s + 1 < t && i.getLanguageId(s + 1) === r; )
    s++;
  let o = n;
  for (; o > 0 && i.getLanguageId(o - 1) === r; )
    o--;
  return new S7e(i, r, o, s + 1, i.getStartOffset(o), i.getEndOffset(s));
}
class S7e {
  constructor(e, t, n, r, s, o) {
    this._scopedLineTokensBrand = void 0, this._actual = e, this.languageId = t, this._firstTokenIndex = n, this._lastTokenIndex = r, this.firstCharOffset = s, this._lastCharOffset = o;
  }
  getLineContent() {
    return this._actual.getLineContent().substring(this.firstCharOffset, this._lastCharOffset);
  }
  getActualLineContentBefore(e) {
    return this._actual.getLineContent().substring(0, this.firstCharOffset + e);
  }
  getTokenCount() {
    return this._lastTokenIndex - this._firstTokenIndex;
  }
  findTokenIndexAtOffset(e) {
    return this._actual.findTokenIndexAtOffset(e + this.firstCharOffset) - this._firstTokenIndex;
  }
  getStandardTokenType(e) {
    return this._actual.getStandardTokenType(e + this._firstTokenIndex);
  }
}
function Ed(i) {
  return (i & 3) !== 0;
}
class p_ {
  constructor(e) {
    if (e.autoClosingPairs ? this._autoClosingPairs = e.autoClosingPairs.map((t) => new f6(t)) : e.brackets ? this._autoClosingPairs = e.brackets.map((t) => new f6({ open: t[0], close: t[1] })) : this._autoClosingPairs = [], e.__electricCharacterSupport && e.__electricCharacterSupport.docComment) {
      const t = e.__electricCharacterSupport.docComment;
      this._autoClosingPairs.push(new f6({ open: t.open, close: t.close || "" }));
    }
    this._autoCloseBeforeForQuotes = typeof e.autoCloseBefore == "string" ? e.autoCloseBefore : p_.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES, this._autoCloseBeforeForBrackets = typeof e.autoCloseBefore == "string" ? e.autoCloseBefore : p_.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS, this._surroundingPairs = e.surroundingPairs || this._autoClosingPairs;
  }
  getAutoClosingPairs() {
    return this._autoClosingPairs;
  }
  getAutoCloseBeforeSet(e) {
    return e ? this._autoCloseBeforeForQuotes : this._autoCloseBeforeForBrackets;
  }
  getSurroundingPairs() {
    return this._surroundingPairs;
  }
}
p_.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES = `;:.,=}])> 
	`;
p_.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS = `'"\`;:.,=}])> 
	`;
const SX = typeof Buffer < "u";
let g6;
class a4 {
  /**
   * When running in a nodejs context, if `actual` is not a nodejs Buffer, the backing store for
   * the returned `VSBuffer` instance might use a nodejs Buffer allocated from node's Buffer pool,
   * which is not transferrable.
   */
  static wrap(e) {
    return SX && !Buffer.isBuffer(e) && (e = Buffer.from(e.buffer, e.byteOffset, e.byteLength)), new a4(e);
  }
  constructor(e) {
    this.buffer = e, this.byteLength = this.buffer.byteLength;
  }
  toString() {
    return SX ? this.buffer.toString() : (g6 || (g6 = new TextDecoder()), g6.decode(this.buffer));
  }
}
function x7e(i, e) {
  return i[e + 0] << 0 >>> 0 | i[e + 1] << 8 >>> 0;
}
function D7e(i, e, t) {
  i[t + 0] = e & 255, e = e >>> 8, i[t + 1] = e & 255;
}
function Ic(i, e) {
  return i[e] * Math.pow(2, 24) + i[e + 1] * Math.pow(2, 16) + i[e + 2] * Math.pow(2, 8) + i[e + 3];
}
function Ac(i, e, t) {
  i[t + 3] = e, e = e >>> 8, i[t + 2] = e, e = e >>> 8, i[t + 1] = e, e = e >>> 8, i[t] = e;
}
function xX(i, e) {
  return i[e];
}
function DX(i, e, t) {
  i[t] = e;
}
let p6;
function $he() {
  return p6 || (p6 = new TextDecoder("UTF-16LE")), p6;
}
let m6;
function E7e() {
  return m6 || (m6 = new TextDecoder("UTF-16BE")), m6;
}
let v6;
function efe() {
  return v6 || (v6 = Wue() ? $he() : E7e()), v6;
}
function L7e(i, e, t) {
  const n = new Uint16Array(i.buffer, e, t);
  return t > 0 && (n[0] === 65279 || n[0] === 65534) ? I7e(i, e, t) : $he().decode(n);
}
function I7e(i, e, t) {
  const n = [];
  let r = 0;
  for (let s = 0; s < t; s++) {
    const o = x7e(i, e);
    e += 2, n[r++] = String.fromCharCode(o);
  }
  return n.join("");
}
class pb {
  constructor(e) {
    this._capacity = e | 0, this._buffer = new Uint16Array(this._capacity), this._completedStrings = null, this._bufferLength = 0;
  }
  reset() {
    this._completedStrings = null, this._bufferLength = 0;
  }
  build() {
    return this._completedStrings !== null ? (this._flushBuffer(), this._completedStrings.join("")) : this._buildBuffer();
  }
  _buildBuffer() {
    if (this._bufferLength === 0)
      return "";
    const e = new Uint16Array(this._buffer.buffer, 0, this._bufferLength);
    return efe().decode(e);
  }
  _flushBuffer() {
    const e = this._buildBuffer();
    this._bufferLength = 0, this._completedStrings === null ? this._completedStrings = [e] : this._completedStrings[this._completedStrings.length] = e;
  }
  /**
   * Append a char code (<2^16)
   */
  appendCharCode(e) {
    const t = this._capacity - this._bufferLength;
    t <= 1 && (t === 0 || kr(e)) && this._flushBuffer(), this._buffer[this._bufferLength++] = e;
  }
  /**
   * Append an ASCII char code (<2^8)
   */
  appendASCIICharCode(e) {
    this._bufferLength === this._capacity && this._flushBuffer(), this._buffer[this._bufferLength++] = e;
  }
  appendString(e) {
    const t = e.length;
    if (this._bufferLength + t >= this._capacity) {
      this._flushBuffer(), this._completedStrings[this._completedStrings.length] = e;
      return;
    }
    for (let n = 0; n < t; n++)
      this._buffer[this._bufferLength++] = e.charCodeAt(n);
  }
}
class eL {
  constructor(e, t, n, r, s, o) {
    this._richEditBracketBrand = void 0, this.languageId = e, this.index = t, this.open = n, this.close = r, this.forwardRegex = s, this.reversedRegex = o, this._openSet = eL._toSet(this.open), this._closeSet = eL._toSet(this.close);
  }
  /**
   * Check if the provided `text` is an open bracket in this group.
   */
  isOpen(e) {
    return this._openSet.has(e);
  }
  /**
   * Check if the provided `text` is a close bracket in this group.
   */
  isClose(e) {
    return this._closeSet.has(e);
  }
  static _toSet(e) {
    const t = /* @__PURE__ */ new Set();
    for (const n of e)
      t.add(n);
    return t;
  }
}
function A7e(i) {
  const e = i.length;
  i = i.map((o) => [o[0].toLowerCase(), o[1].toLowerCase()]);
  const t = [];
  for (let o = 0; o < e; o++)
    t[o] = o;
  const n = (o, a) => {
    const [l, c] = o, [d, u] = a;
    return l === d || l === u || c === d || c === u;
  }, r = (o, a) => {
    const l = Math.min(o, a), c = Math.max(o, a);
    for (let d = 0; d < e; d++)
      t[d] === c && (t[d] = l);
  };
  for (let o = 0; o < e; o++) {
    const a = i[o];
    for (let l = o + 1; l < e; l++) {
      const c = i[l];
      n(a, c) && r(t[o], t[l]);
    }
  }
  const s = [];
  for (let o = 0; o < e; o++) {
    const a = [], l = [];
    for (let c = 0; c < e; c++)
      if (t[c] === o) {
        const [d, u] = i[c];
        a.push(d), l.push(u);
      }
    a.length > 0 && s.push({
      open: a,
      close: l
    });
  }
  return s;
}
class k7e {
  constructor(e, t) {
    this._richEditBracketsBrand = void 0;
    const n = A7e(t);
    this.brackets = n.map((r, s) => new eL(e, s, r.open, r.close, T7e(r.open, r.close, n, s), N7e(r.open, r.close, n, s))), this.forwardRegex = P7e(this.brackets), this.reversedRegex = O7e(this.brackets), this.textIsBracket = {}, this.textIsOpenBracket = {}, this.maxBracketLength = 0;
    for (const r of this.brackets) {
      for (const s of r.open)
        this.textIsBracket[s] = r, this.textIsOpenBracket[s] = !0, this.maxBracketLength = Math.max(this.maxBracketLength, s.length);
      for (const s of r.close)
        this.textIsBracket[s] = r, this.textIsOpenBracket[s] = !1, this.maxBracketLength = Math.max(this.maxBracketLength, s.length);
    }
  }
}
function tfe(i, e, t, n) {
  for (let r = 0, s = e.length; r < s; r++) {
    if (r === t)
      continue;
    const o = e[r];
    for (const a of o.open)
      a.indexOf(i) >= 0 && n.push(a);
    for (const a of o.close)
      a.indexOf(i) >= 0 && n.push(a);
  }
}
function nfe(i, e) {
  return i.length - e.length;
}
function l4(i) {
  if (i.length <= 1)
    return i;
  const e = [], t = /* @__PURE__ */ new Set();
  for (const n of i)
    t.has(n) || (e.push(n), t.add(n));
  return e;
}
function T7e(i, e, t, n) {
  let r = [];
  r = r.concat(i), r = r.concat(e);
  for (let s = 0, o = r.length; s < o; s++)
    tfe(r[s], t, n, r);
  return r = l4(r), r.sort(nfe), r.reverse(), c4(r);
}
function N7e(i, e, t, n) {
  let r = [];
  r = r.concat(i), r = r.concat(e);
  for (let s = 0, o = r.length; s < o; s++)
    tfe(r[s], t, n, r);
  return r = l4(r), r.sort(nfe), r.reverse(), c4(r.map(Qj));
}
function P7e(i) {
  let e = [];
  for (const t of i) {
    for (const n of t.open)
      e.push(n);
    for (const n of t.close)
      e.push(n);
  }
  return e = l4(e), c4(e);
}
function O7e(i) {
  let e = [];
  for (const t of i) {
    for (const n of t.open)
      e.push(n);
    for (const n of t.close)
      e.push(n);
  }
  return e = l4(e), c4(e.map(Qj));
}
function M7e(i) {
  const e = /^[\w ]+$/.test(i);
  return i = Va(i), e ? `\\b${i}\\b` : i;
}
function c4(i) {
  const e = `(${i.map(M7e).join(")|(")})`;
  return hhe(e, !0);
}
const Qj = /* @__PURE__ */ function() {
  function i(n) {
    const r = new Uint16Array(n.length);
    let s = 0;
    for (let o = n.length - 1; o >= 0; o--)
      r[s++] = n.charCodeAt(o);
    return efe().decode(r);
  }
  let e = null, t = null;
  return function(r) {
    return e !== r && (e = r, t = i(e)), t;
  };
}();
class Rl {
  static _findPrevBracketInText(e, t, n, r) {
    const s = n.match(e);
    if (!s)
      return null;
    const o = n.length - (s.index || 0), a = s[0].length, l = r + o;
    return new V(t, l - a + 1, t, l + 1);
  }
  static findPrevBracketInRange(e, t, n, r, s) {
    const a = Qj(n).substring(n.length - s, n.length - r);
    return this._findPrevBracketInText(e, t, a, r);
  }
  static findNextBracketInText(e, t, n, r) {
    const s = n.match(e);
    if (!s)
      return null;
    const o = s.index || 0, a = s[0].length;
    if (a === 0)
      return null;
    const l = r + o;
    return new V(t, l + 1, t, l + 1 + a);
  }
  static findNextBracketInRange(e, t, n, r, s) {
    const o = n.substring(r, s);
    return this.findNextBracketInText(e, t, o, r);
  }
}
class R7e {
  constructor(e) {
    this._richEditBrackets = e;
  }
  getElectricCharacters() {
    const e = [];
    if (this._richEditBrackets)
      for (const t of this._richEditBrackets.brackets)
        for (const n of t.close) {
          const r = n.charAt(n.length - 1);
          e.push(r);
        }
    return kg(e);
  }
  onElectricCharacter(e, t, n) {
    if (!this._richEditBrackets || this._richEditBrackets.brackets.length === 0)
      return null;
    const r = t.findTokenIndexAtOffset(n - 1);
    if (Ed(t.getStandardTokenType(r)))
      return null;
    const s = this._richEditBrackets.reversedRegex, o = t.getLineContent().substring(0, n - 1) + e, a = Rl.findPrevBracketInRange(s, 1, o, 0, o.length);
    if (!a)
      return null;
    const l = o.substring(a.startColumn - 1, a.endColumn - 1).toLowerCase();
    if (this._richEditBrackets.textIsOpenBracket[l])
      return null;
    const d = t.getActualLineContentBefore(a.startColumn - 1);
    return /^\s*$/.test(d) ? {
      matchOpenBracket: l
    } : null;
  }
}
function Wx(i) {
  return i.global && (i.lastIndex = 0), !0;
}
class F7e {
  constructor(e) {
    this._indentationRules = e;
  }
  shouldIncrease(e) {
    return !!(this._indentationRules && this._indentationRules.increaseIndentPattern && Wx(this._indentationRules.increaseIndentPattern) && this._indentationRules.increaseIndentPattern.test(e));
  }
  shouldDecrease(e) {
    return !!(this._indentationRules && this._indentationRules.decreaseIndentPattern && Wx(this._indentationRules.decreaseIndentPattern) && this._indentationRules.decreaseIndentPattern.test(e));
  }
  shouldIndentNextLine(e) {
    return !!(this._indentationRules && this._indentationRules.indentNextLinePattern && Wx(this._indentationRules.indentNextLinePattern) && this._indentationRules.indentNextLinePattern.test(e));
  }
  shouldIgnore(e) {
    return !!(this._indentationRules && this._indentationRules.unIndentedLinePattern && Wx(this._indentationRules.unIndentedLinePattern) && this._indentationRules.unIndentedLinePattern.test(e));
  }
  getIndentMetadata(e) {
    let t = 0;
    return this.shouldIncrease(e) && (t += 1), this.shouldDecrease(e) && (t += 2), this.shouldIndentNextLine(e) && (t += 4), this.shouldIgnore(e) && (t += 8), t;
  }
}
class X1 {
  constructor(e) {
    e = e || {}, e.brackets = e.brackets || [
      ["(", ")"],
      ["{", "}"],
      ["[", "]"]
    ], this._brackets = [], e.brackets.forEach((t) => {
      const n = X1._createOpenBracketRegExp(t[0]), r = X1._createCloseBracketRegExp(t[1]);
      n && r && this._brackets.push({
        open: t[0],
        openRegExp: n,
        close: t[1],
        closeRegExp: r
      });
    }), this._regExpRules = e.onEnterRules || [];
  }
  onEnter(e, t, n, r) {
    if (e >= 3)
      for (let s = 0, o = this._regExpRules.length; s < o; s++) {
        const a = this._regExpRules[s];
        if ([{
          reg: a.beforeText,
          text: n
        }, {
          reg: a.afterText,
          text: r
        }, {
          reg: a.previousLineText,
          text: t
        }].every((c) => c.reg ? (c.reg.lastIndex = 0, c.reg.test(c.text)) : !0))
          return a.action;
      }
    if (e >= 2 && n.length > 0 && r.length > 0)
      for (let s = 0, o = this._brackets.length; s < o; s++) {
        const a = this._brackets[s];
        if (a.openRegExp.test(n) && a.closeRegExp.test(r))
          return { indentAction: mr.IndentOutdent };
      }
    if (e >= 2 && n.length > 0) {
      for (let s = 0, o = this._brackets.length; s < o; s++)
        if (this._brackets[s].openRegExp.test(n))
          return { indentAction: mr.Indent };
    }
    return null;
  }
  static _createOpenBracketRegExp(e) {
    let t = Va(e);
    return /\B/.test(t.charAt(0)) || (t = "\\b" + t), t += "\\s*$", X1._safeRegExp(t);
  }
  static _createCloseBracketRegExp(e) {
    let t = Va(e);
    return /\B/.test(t.charAt(t.length - 1)) || (t = t + "\\b"), t = "^\\s*" + t, X1._safeRegExp(t);
  }
  static _safeRegExp(e) {
    try {
      return new RegExp(e);
    } catch (t) {
      return It(t), null;
    }
  }
}
const en = Gt("configurationService");
function fF(i, e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n in i)
    ife(t, n, i[n], e);
  return t;
}
function ife(i, e, t, n) {
  const r = e.split("."), s = r.pop();
  let o = i;
  for (let a = 0; a < r.length; a++) {
    const l = r[a];
    let c = o[l];
    switch (typeof c) {
      case "undefined":
        c = o[l] = /* @__PURE__ */ Object.create(null);
        break;
      case "object":
        break;
      default:
        n(`Ignoring ${e} as ${r.slice(0, a + 1).join(".")} is ${JSON.stringify(c)}`);
        return;
    }
    o = c;
  }
  if (typeof o == "object" && o !== null)
    try {
      o[s] = t;
    } catch {
      n(`Ignoring ${e} as ${r.join(".")} is ${JSON.stringify(o)}`);
    }
  else
    n(`Ignoring ${e} as ${r.join(".")} is ${JSON.stringify(o)}`);
}
function B7e(i, e) {
  const t = e.split(".");
  rfe(i, t);
}
function rfe(i, e) {
  const t = e.shift();
  if (e.length === 0) {
    delete i[t];
    return;
  }
  if (Object.keys(i).indexOf(t) !== -1) {
    const n = i[t];
    typeof n == "object" && !Array.isArray(n) && (rfe(n, e), Object.keys(n).length === 0 && delete i[t]);
  }
}
function EX(i, e, t) {
  function n(o, a) {
    let l = o;
    for (const c of a) {
      if (typeof l != "object" || l === null)
        return;
      l = l[c];
    }
    return l;
  }
  const r = e.split("."), s = n(i, r);
  return typeof s > "u" ? t : s;
}
function V7e(i) {
  return i.replace(/[\[\]]/g, "");
}
const ci = Gt("languageService");
class Md {
  constructor(e, t = [], n = !1) {
    this.ctor = e, this.staticArguments = t, this.supportsDelayedInstantiation = n;
  }
}
const sfe = [];
function an(i, e, t) {
  e instanceof Md || (e = new Md(e, [], !!t)), sfe.push([i, e]);
}
function LX() {
  return sfe;
}
const Zi = Object.freeze({
  text: "text/plain",
  binary: "application/octet-stream",
  unknown: "application/unknown",
  markdown: "text/markdown",
  latex: "text/latex",
  uriList: "text/uri-list"
}), d4 = {
  JSONContribution: "base.contributions.json"
};
function H7e(i) {
  return i.length > 0 && i.charAt(i.length - 1) === "#" ? i.substring(0, i.length - 1) : i;
}
class W7e {
  constructor() {
    this._onDidChangeSchema = new pe(), this.schemasById = {};
  }
  registerSchema(e, t) {
    this.schemasById[H7e(e)] = t, this._onDidChangeSchema.fire(e);
  }
  notifySchemaChanged(e) {
    this._onDidChangeSchema.fire(e);
  }
}
const j7e = new W7e();
Di.add(d4.JSONContribution, j7e);
const _d = {
  Configuration: "base.contributions.configuration"
}, $b = "vscode://schemas/settings/resourceLanguage", IX = Di.as(d4.JSONContribution);
class z7e {
  constructor() {
    this.overrideIdentifiers = /* @__PURE__ */ new Set(), this._onDidSchemaChange = new pe(), this._onDidUpdateConfiguration = new pe(), this.configurationDefaultsOverrides = /* @__PURE__ */ new Map(), this.defaultLanguageConfigurationOverridesNode = {
      id: "defaultOverrides",
      title: C("defaultLanguageConfigurationOverrides.title", "Default Language Configuration Overrides"),
      properties: {}
    }, this.configurationContributors = [this.defaultLanguageConfigurationOverridesNode], this.resourceLanguageSettingsSchema = {
      properties: {},
      patternProperties: {},
      additionalProperties: !0,
      allowTrailingCommas: !0,
      allowComments: !0
    }, this.configurationProperties = {}, this.policyConfigurations = /* @__PURE__ */ new Map(), this.excludedConfigurationProperties = {}, IX.registerSchema($b, this.resourceLanguageSettingsSchema), this.registerOverridePropertyPatternKey();
  }
  registerConfiguration(e, t = !0) {
    this.registerConfigurations([e], t);
  }
  registerConfigurations(e, t = !0) {
    const n = /* @__PURE__ */ new Set();
    this.doRegisterConfigurations(e, t, n), IX.registerSchema($b, this.resourceLanguageSettingsSchema), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire({ properties: n });
  }
  registerDefaultConfigurations(e) {
    const t = /* @__PURE__ */ new Set();
    this.doRegisterDefaultConfigurations(e, t), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire({ properties: t, defaultsOverrides: !0 });
  }
  doRegisterDefaultConfigurations(e, t) {
    var n;
    const r = [];
    for (const { overrides: s, source: o } of e)
      for (const a in s)
        if (t.add(a), Fg.test(a)) {
          const l = this.configurationDefaultsOverrides.get(a), c = (n = l?.valuesSources) !== null && n !== void 0 ? n : /* @__PURE__ */ new Map();
          if (o)
            for (const f of Object.keys(s[a]))
              c.set(f, o);
          const d = Object.assign(Object.assign({}, l?.value || {}), s[a]);
          this.configurationDefaultsOverrides.set(a, { source: o, value: d, valuesSources: c });
          const u = V7e(a), h = {
            type: "object",
            default: d,
            description: C("defaultLanguageConfiguration.description", "Configure settings to be overridden for the {0} language.", u),
            $ref: $b,
            defaultDefaultValue: d,
            source: mo(o) ? void 0 : o,
            defaultValueSource: o
          };
          r.push(...tL(a)), this.configurationProperties[a] = h, this.defaultLanguageConfigurationOverridesNode.properties[a] = h;
        } else {
          this.configurationDefaultsOverrides.set(a, { value: s[a], source: o });
          const l = this.configurationProperties[a];
          l && (this.updatePropertyDefaultValue(a, l), this.updateSchema(a, l));
        }
    this.doRegisterOverrideIdentifiers(r);
  }
  registerOverrideIdentifiers(e) {
    this.doRegisterOverrideIdentifiers(e), this._onDidSchemaChange.fire();
  }
  doRegisterOverrideIdentifiers(e) {
    for (const t of e)
      this.overrideIdentifiers.add(t);
    this.updateOverridePropertyPatternKey();
  }
  doRegisterConfigurations(e, t, n) {
    e.forEach((r) => {
      this.validateAndRegisterProperties(r, t, r.extensionInfo, r.restrictedProperties, void 0, n), this.configurationContributors.push(r), this.registerJSONConfiguration(r);
    });
  }
  validateAndRegisterProperties(e, t = !0, n, r, s = 3, o) {
    var a;
    s = xa(e.scope) ? s : e.scope;
    const l = e.properties;
    if (l)
      for (const d in l) {
        const u = l[d];
        if (t && q7e(d, u)) {
          delete l[d];
          continue;
        }
        if (u.source = n, u.defaultDefaultValue = l[d].default, this.updatePropertyDefaultValue(d, u), Fg.test(d) ? u.scope = void 0 : (u.scope = xa(u.scope) ? s : u.scope, u.restricted = xa(u.restricted) ? !!r?.includes(d) : u.restricted), l[d].hasOwnProperty("included") && !l[d].included) {
          this.excludedConfigurationProperties[d] = l[d], delete l[d];
          continue;
        } else
          this.configurationProperties[d] = l[d], !((a = l[d].policy) === null || a === void 0) && a.name && this.policyConfigurations.set(l[d].policy.name, d);
        !l[d].deprecationMessage && l[d].markdownDeprecationMessage && (l[d].deprecationMessage = l[d].markdownDeprecationMessage), o.add(d);
      }
    const c = e.allOf;
    if (c)
      for (const d of c)
        this.validateAndRegisterProperties(d, t, n, r, s, o);
  }
  getConfigurationProperties() {
    return this.configurationProperties;
  }
  getPolicyConfigurations() {
    return this.policyConfigurations;
  }
  registerJSONConfiguration(e) {
    const t = (n) => {
      const r = n.properties;
      if (r)
        for (const o in r)
          this.updateSchema(o, r[o]);
      const s = n.allOf;
      s?.forEach(t);
    };
    t(e);
  }
  updateSchema(e, t) {
    switch (t.scope) {
      case 1:
        break;
      case 2:
        break;
      case 6:
        break;
      case 3:
        break;
      case 4:
        break;
      case 5:
        this.resourceLanguageSettingsSchema.properties[e] = t;
        break;
    }
  }
  updateOverridePropertyPatternKey() {
    for (const e of this.overrideIdentifiers.values()) {
      const t = `[${e}]`, n = {
        type: "object",
        description: C("overrideSettings.defaultDescription", "Configure editor settings to be overridden for a language."),
        errorMessage: C("overrideSettings.errorMessage", "This setting does not support per-language configuration."),
        $ref: $b
      };
      this.updatePropertyDefaultValue(t, n);
    }
  }
  registerOverridePropertyPatternKey() {
    C("overrideSettings.defaultDescription", "Configure editor settings to be overridden for a language."), C("overrideSettings.errorMessage", "This setting does not support per-language configuration."), this._onDidSchemaChange.fire();
  }
  updatePropertyDefaultValue(e, t) {
    const n = this.configurationDefaultsOverrides.get(e);
    let r = n?.value, s = n?.source;
    Jo(r) && (r = t.defaultDefaultValue, s = void 0), Jo(r) && (r = G7e(t.type)), t.default = r, t.defaultValueSource = s;
  }
}
const ofe = "\\[([^\\]]+)\\]", AX = new RegExp(ofe, "g"), U7e = `^(${ofe})+$`, Fg = new RegExp(U7e);
function tL(i) {
  const e = [];
  if (Fg.test(i)) {
    let t = AX.exec(i);
    for (; t?.length; ) {
      const n = t[1].trim();
      n && e.push(n), t = AX.exec(i);
    }
  }
  return kg(e);
}
function G7e(i) {
  switch (Array.isArray(i) ? i[0] : i) {
    case "boolean":
      return !1;
    case "integer":
    case "number":
      return 0;
    case "string":
      return "";
    case "array":
      return [];
    case "object":
      return {};
    default:
      return null;
  }
}
const M3 = new z7e();
Di.add(_d.Configuration, M3);
function q7e(i, e) {
  var t, n, r, s;
  return i.trim() ? Fg.test(i) ? C("config.property.languageDefault", "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.", i) : M3.getConfigurationProperties()[i] !== void 0 ? C("config.property.duplicate", "Cannot register '{0}'. This property is already registered.", i) : !((t = e.policy) === null || t === void 0) && t.name && M3.getPolicyConfigurations().get((n = e.policy) === null || n === void 0 ? void 0 : n.name) !== void 0 ? C("config.policy.duplicate", "Cannot register '{0}'. The associated policy {1} is already registered with {2}.", i, (r = e.policy) === null || r === void 0 ? void 0 : r.name, M3.getPolicyConfigurations().get((s = e.policy) === null || s === void 0 ? void 0 : s.name)) : null : C("config.property.empty", "Cannot register an empty property");
}
const K7e = {
  ModesRegistry: "editor.modesRegistry"
};
class Y7e {
  constructor() {
    this._onDidChangeLanguages = new pe(), this.onDidChangeLanguages = this._onDidChangeLanguages.event, this._languages = [];
  }
  registerLanguage(e) {
    return this._languages.push(e), this._onDidChangeLanguages.fire(void 0), {
      dispose: () => {
        for (let t = 0, n = this._languages.length; t < n; t++)
          if (this._languages[t] === e) {
            this._languages.splice(t, 1);
            return;
          }
      }
    };
  }
  getLanguages() {
    return this._languages;
  }
}
const m_ = new Y7e();
Di.add(K7e.ModesRegistry, m_);
const Fa = "plaintext", X7e = ".txt";
m_.registerLanguage({
  id: Fa,
  extensions: [X7e],
  aliases: [C("plainText.alias", "Plain Text"), "text"],
  mimetypes: [Zi.text]
});
Di.as(_d.Configuration).registerDefaultConfigurations([{
  overrides: {
    "[plaintext]": {
      "editor.unicodeHighlight.ambiguousCharacters": !1,
      "editor.unicodeHighlight.invisibleCharacters": !1
    }
  }
}]);
class Z7e {
  constructor(e, t) {
    this.languageId = e;
    const n = t.brackets ? kX(t.brackets) : [], r = new $Y((a) => {
      const l = /* @__PURE__ */ new Set();
      return {
        info: new Q7e(this, a, l),
        closing: l
      };
    }), s = new $Y((a) => {
      const l = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
      return {
        info: new J7e(this, a, l, c),
        opening: l,
        openingColorized: c
      };
    });
    for (const [a, l] of n) {
      const c = r.get(a), d = s.get(l);
      c.closing.add(d.info), d.opening.add(c.info);
    }
    const o = t.colorizedBracketPairs ? kX(t.colorizedBracketPairs) : n.filter((a) => !(a[0] === "<" && a[1] === ">"));
    for (const [a, l] of o) {
      const c = r.get(a), d = s.get(l);
      c.closing.add(d.info), d.openingColorized.add(c.info), d.opening.add(c.info);
    }
    this._openingBrackets = new Map([...r.cachedValues].map(([a, l]) => [a, l.info])), this._closingBrackets = new Map([...s.cachedValues].map(([a, l]) => [a, l.info]));
  }
  /**
   * No two brackets have the same bracket text.
  */
  get openingBrackets() {
    return [...this._openingBrackets.values()];
  }
  /**
   * No two brackets have the same bracket text.
  */
  get closingBrackets() {
    return [...this._closingBrackets.values()];
  }
  getOpeningBracketInfo(e) {
    return this._openingBrackets.get(e);
  }
  getClosingBracketInfo(e) {
    return this._closingBrackets.get(e);
  }
  getBracketInfo(e) {
    return this.getOpeningBracketInfo(e) || this.getClosingBracketInfo(e);
  }
}
function kX(i) {
  return i.filter(([e, t]) => e !== "" && t !== "");
}
class afe {
  constructor(e, t) {
    this.config = e, this.bracketText = t;
  }
  get languageId() {
    return this.config.languageId;
  }
}
class Q7e extends afe {
  constructor(e, t, n) {
    super(e, t), this.openedBrackets = n, this.isOpeningBracket = !0;
  }
}
class J7e extends afe {
  constructor(e, t, n, r) {
    super(e, t), this.openingBrackets = n, this.openingColorizedBrackets = r, this.isOpeningBracket = !1;
  }
  /**
   * Checks if this bracket closes the given other bracket.
   * If the bracket infos come from different configurations, this method will return false.
  */
  closes(e) {
    return e.config !== this.config ? !1 : this.openingBrackets.has(e);
  }
  closesColorized(e) {
    return e.config !== this.config ? !1 : this.openingColorizedBrackets.has(e);
  }
  getOpeningBrackets() {
    return [...this.openingBrackets];
  }
}
var $7e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, TX = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class _6 {
  constructor(e) {
    this.languageId = e;
  }
  affects(e) {
    return this.languageId ? this.languageId === e : !0;
  }
}
const Un = Gt("languageConfigurationService");
let gF = class extends we {
  constructor(e, t) {
    super(), this.configurationService = e, this.languageService = t, this._registry = this._register(new iPe()), this.onDidChangeEmitter = this._register(new pe()), this.onDidChange = this.onDidChangeEmitter.event, this.configurations = /* @__PURE__ */ new Map();
    const n = new Set(Object.values(pF));
    this._register(this.configurationService.onDidChangeConfiguration((r) => {
      const s = r.change.keys.some((a) => n.has(a)), o = r.change.overrides.filter(([a, l]) => l.some((c) => n.has(c))).map(([a]) => a);
      if (s)
        this.configurations.clear(), this.onDidChangeEmitter.fire(new _6(void 0));
      else
        for (const a of o)
          this.languageService.isRegisteredLanguageId(a) && (this.configurations.delete(a), this.onDidChangeEmitter.fire(new _6(a)));
    })), this._register(this._registry.onDidChange((r) => {
      this.configurations.delete(r.languageId), this.onDidChangeEmitter.fire(new _6(r.languageId));
    }));
  }
  register(e, t, n) {
    return this._registry.register(e, t, n);
  }
  getLanguageConfiguration(e) {
    let t = this.configurations.get(e);
    return t || (t = ePe(e, this._registry, this.configurationService, this.languageService), this.configurations.set(e, t)), t;
  }
};
gF = $7e([
  TX(0, en),
  TX(1, ci)
], gF);
function ePe(i, e, t, n) {
  let r = e.getLanguageConfiguration(i);
  if (!r) {
    if (!n.isRegisteredLanguageId(i))
      return new Tv(i, {});
    r = new Tv(i, {});
  }
  const s = tPe(r.languageId, t), o = cfe([r.underlyingConfig, s]);
  return new Tv(r.languageId, o);
}
const pF = {
  brackets: "editor.language.brackets",
  colorizedBracketPairs: "editor.language.colorizedBracketPairs"
};
function tPe(i, e) {
  const t = e.getValue(pF.brackets, {
    overrideIdentifier: i
  }), n = e.getValue(pF.colorizedBracketPairs, {
    overrideIdentifier: i
  });
  return {
    brackets: NX(t),
    colorizedBracketPairs: NX(n)
  };
}
function NX(i) {
  if (Array.isArray(i))
    return i.map((e) => {
      if (!(!Array.isArray(e) || e.length !== 2))
        return [e[0], e[1]];
    }).filter((e) => !!e);
}
function lfe(i, e, t) {
  const n = i.getLineContent(e);
  let r = Hn(n);
  return r.length > t - 1 && (r = r.substring(0, t - 1)), r;
}
function kv(i, e, t) {
  i.tokenization.forceTokenization(e);
  const n = i.tokenization.getLineTokens(e), r = typeof t > "u" ? i.getLineMaxColumn(e) - 1 : t - 1;
  return o4(n, r);
}
class nPe {
  constructor(e) {
    this.languageId = e, this._resolved = null, this._entries = [], this._order = 0, this._resolved = null;
  }
  register(e, t) {
    const n = new PX(e, t, ++this._order);
    return this._entries.push(n), this._resolved = null, Ct(() => {
      for (let r = 0; r < this._entries.length; r++)
        if (this._entries[r] === n) {
          this._entries.splice(r, 1), this._resolved = null;
          break;
        }
    });
  }
  getResolvedConfiguration() {
    if (!this._resolved) {
      const e = this._resolve();
      e && (this._resolved = new Tv(this.languageId, e));
    }
    return this._resolved;
  }
  _resolve() {
    return this._entries.length === 0 ? null : (this._entries.sort(PX.cmp), cfe(this._entries.map((e) => e.configuration)));
  }
}
function cfe(i) {
  let e = {
    comments: void 0,
    brackets: void 0,
    wordPattern: void 0,
    indentationRules: void 0,
    onEnterRules: void 0,
    autoClosingPairs: void 0,
    surroundingPairs: void 0,
    autoCloseBefore: void 0,
    folding: void 0,
    colorizedBracketPairs: void 0,
    __electricCharacterSupport: void 0
  };
  for (const t of i)
    e = {
      comments: t.comments || e.comments,
      brackets: t.brackets || e.brackets,
      wordPattern: t.wordPattern || e.wordPattern,
      indentationRules: t.indentationRules || e.indentationRules,
      onEnterRules: t.onEnterRules || e.onEnterRules,
      autoClosingPairs: t.autoClosingPairs || e.autoClosingPairs,
      surroundingPairs: t.surroundingPairs || e.surroundingPairs,
      autoCloseBefore: t.autoCloseBefore || e.autoCloseBefore,
      folding: t.folding || e.folding,
      colorizedBracketPairs: t.colorizedBracketPairs || e.colorizedBracketPairs,
      __electricCharacterSupport: t.__electricCharacterSupport || e.__electricCharacterSupport
    };
  return e;
}
class PX {
  constructor(e, t, n) {
    this.configuration = e, this.priority = t, this.order = n;
  }
  static cmp(e, t) {
    return e.priority === t.priority ? e.order - t.order : e.priority - t.priority;
  }
}
class OX {
  constructor(e) {
    this.languageId = e;
  }
}
class iPe extends we {
  constructor() {
    super(), this._entries = /* @__PURE__ */ new Map(), this._onDidChange = this._register(new pe()), this.onDidChange = this._onDidChange.event, this._register(this.register(Fa, {
      brackets: [
        ["(", ")"],
        ["[", "]"],
        ["{", "}"]
      ],
      surroundingPairs: [
        { open: "{", close: "}" },
        { open: "[", close: "]" },
        { open: "(", close: ")" },
        { open: "<", close: ">" },
        { open: '"', close: '"' },
        { open: "'", close: "'" },
        { open: "`", close: "`" }
      ],
      colorizedBracketPairs: [],
      folding: {
        offSide: !0
      }
    }, 0));
  }
  /**
   * @param priority Use a higher number for higher priority
   */
  register(e, t, n = 0) {
    let r = this._entries.get(e);
    r || (r = new nPe(e), this._entries.set(e, r));
    const s = r.register(t, n);
    return this._onDidChange.fire(new OX(e)), Ct(() => {
      s.dispose(), this._onDidChange.fire(new OX(e));
    });
  }
  getLanguageConfiguration(e) {
    const t = this._entries.get(e);
    return t?.getResolvedConfiguration() || null;
  }
}
class Tv {
  constructor(e, t) {
    this.languageId = e, this.underlyingConfig = t, this._brackets = null, this._electricCharacter = null, this._onEnterSupport = this.underlyingConfig.brackets || this.underlyingConfig.indentationRules || this.underlyingConfig.onEnterRules ? new X1(this.underlyingConfig) : null, this.comments = Tv._handleComments(this.underlyingConfig), this.characterPair = new p_(this.underlyingConfig), this.wordDefinition = this.underlyingConfig.wordPattern || Ij, this.indentationRules = this.underlyingConfig.indentationRules, this.underlyingConfig.indentationRules ? this.indentRulesSupport = new F7e(this.underlyingConfig.indentationRules) : this.indentRulesSupport = null, this.foldingRules = this.underlyingConfig.folding || {}, this.bracketsNew = new Z7e(e, this.underlyingConfig);
  }
  getWordDefinition() {
    return Uue(this.wordDefinition);
  }
  get brackets() {
    return !this._brackets && this.underlyingConfig.brackets && (this._brackets = new k7e(this.languageId, this.underlyingConfig.brackets)), this._brackets;
  }
  get electricCharacter() {
    return this._electricCharacter || (this._electricCharacter = new R7e(this.brackets)), this._electricCharacter;
  }
  onEnter(e, t, n, r) {
    return this._onEnterSupport ? this._onEnterSupport.onEnter(e, t, n, r) : null;
  }
  getAutoClosingPairs() {
    return new w7e(this.characterPair.getAutoClosingPairs());
  }
  getAutoCloseBeforeSet(e) {
    return this.characterPair.getAutoCloseBeforeSet(e);
  }
  getSurroundingPairs() {
    return this.characterPair.getSurroundingPairs();
  }
  static _handleComments(e) {
    const t = e.comments;
    if (!t)
      return null;
    const n = {};
    if (t.lineComment && (n.lineCommentToken = t.lineComment), t.blockComment) {
      const [r, s] = t.blockComment;
      n.blockCommentStartToken = r, n.blockCommentEndToken = s;
    }
    return n;
  }
}
an(
  Un,
  gF,
  1
  /* InstantiationType.Delayed */
);
class Lf {
  /**
   * Constructs a new DiffChange with the given sequence information
   * and content.
   */
  constructor(e, t, n, r) {
    this.originalStart = e, this.originalLength = t, this.modifiedStart = n, this.modifiedLength = r;
  }
  /**
   * The end point (exclusive) of the change in the original sequence.
   */
  getOriginalEnd() {
    return this.originalStart + this.originalLength;
  }
  /**
   * The end point (exclusive) of the change in the modified sequence.
   */
  getModifiedEnd() {
    return this.modifiedStart + this.modifiedLength;
  }
}
function dfe(i) {
  return u4(i, 0);
}
function u4(i, e) {
  switch (typeof i) {
    case "object":
      return i === null ? Dh(349, e) : Array.isArray(i) ? sPe(i, e) : oPe(i, e);
    case "string":
      return Jj(i, e);
    case "boolean":
      return rPe(i, e);
    case "number":
      return Dh(i, e);
    case "undefined":
      return Dh(937, e);
    default:
      return Dh(617, e);
  }
}
function Dh(i, e) {
  return (e << 5) - e + i | 0;
}
function rPe(i, e) {
  return Dh(i ? 433 : 863, e);
}
function Jj(i, e) {
  e = Dh(149417, e);
  for (let t = 0, n = i.length; t < n; t++)
    e = Dh(i.charCodeAt(t), e);
  return e;
}
function sPe(i, e) {
  return e = Dh(104579, e), i.reduce((t, n) => u4(n, t), e);
}
function oPe(i, e) {
  return e = Dh(181387, e), Object.keys(i).sort().reduce((t, n) => (t = Jj(n, t), u4(i[n], t)), e);
}
function b6(i, e, t = 32) {
  const n = t - e, r = ~((1 << n) - 1);
  return (i << e | (r & i) >>> n) >>> 0;
}
function MX(i, e = 0, t = i.byteLength, n = 0) {
  for (let r = 0; r < t; r++)
    i[e + r] = n;
}
function aPe(i, e, t = "0") {
  for (; i.length < e; )
    i = t + i;
  return i;
}
function e2(i, e = 32) {
  return i instanceof ArrayBuffer ? Array.from(new Uint8Array(i)).map((t) => t.toString(16).padStart(2, "0")).join("") : aPe((i >>> 0).toString(16), e / 4);
}
class h4 {
  constructor() {
    this._h0 = 1732584193, this._h1 = 4023233417, this._h2 = 2562383102, this._h3 = 271733878, this._h4 = 3285377520, this._buff = new Uint8Array(
      67
      /* to fit any utf-8 */
    ), this._buffDV = new DataView(this._buff.buffer), this._buffLen = 0, this._totalLen = 0, this._leftoverHighSurrogate = 0, this._finished = !1;
  }
  update(e) {
    const t = e.length;
    if (t === 0)
      return;
    const n = this._buff;
    let r = this._buffLen, s = this._leftoverHighSurrogate, o, a;
    for (s !== 0 ? (o = s, a = -1, s = 0) : (o = e.charCodeAt(0), a = 0); ; ) {
      let l = o;
      if (kr(o))
        if (a + 1 < t) {
          const c = e.charCodeAt(a + 1);
          Gm(c) ? (a++, l = Vj(o, c)) : l = 65533;
        } else {
          s = o;
          break;
        }
      else Gm(o) && (l = 65533);
      if (r = this._push(n, r, l), a++, a < t)
        o = e.charCodeAt(a);
      else
        break;
    }
    this._buffLen = r, this._leftoverHighSurrogate = s;
  }
  _push(e, t, n) {
    return n < 128 ? e[t++] = n : n < 2048 ? (e[t++] = 192 | (n & 1984) >>> 6, e[t++] = 128 | (n & 63) >>> 0) : n < 65536 ? (e[t++] = 224 | (n & 61440) >>> 12, e[t++] = 128 | (n & 4032) >>> 6, e[t++] = 128 | (n & 63) >>> 0) : (e[t++] = 240 | (n & 1835008) >>> 18, e[t++] = 128 | (n & 258048) >>> 12, e[t++] = 128 | (n & 4032) >>> 6, e[t++] = 128 | (n & 63) >>> 0), t >= 64 && (this._step(), t -= 64, this._totalLen += 64, e[0] = e[64], e[1] = e[65], e[2] = e[66]), t;
  }
  digest() {
    return this._finished || (this._finished = !0, this._leftoverHighSurrogate && (this._leftoverHighSurrogate = 0, this._buffLen = this._push(
      this._buff,
      this._buffLen,
      65533
      /* SHA1Constant.UNICODE_REPLACEMENT */
    )), this._totalLen += this._buffLen, this._wrapUp()), e2(this._h0) + e2(this._h1) + e2(this._h2) + e2(this._h3) + e2(this._h4);
  }
  _wrapUp() {
    this._buff[this._buffLen++] = 128, MX(this._buff, this._buffLen), this._buffLen > 56 && (this._step(), MX(this._buff));
    const e = 8 * this._totalLen;
    this._buffDV.setUint32(56, Math.floor(e / 4294967296), !1), this._buffDV.setUint32(60, e % 4294967296, !1), this._step();
  }
  _step() {
    const e = h4._bigBlock32, t = this._buffDV;
    for (let u = 0; u < 64; u += 4)
      e.setUint32(u, t.getUint32(u, !1), !1);
    for (let u = 64; u < 320; u += 4)
      e.setUint32(u, b6(e.getUint32(u - 12, !1) ^ e.getUint32(u - 32, !1) ^ e.getUint32(u - 56, !1) ^ e.getUint32(u - 64, !1), 1), !1);
    let n = this._h0, r = this._h1, s = this._h2, o = this._h3, a = this._h4, l, c, d;
    for (let u = 0; u < 80; u++)
      u < 20 ? (l = r & s | ~r & o, c = 1518500249) : u < 40 ? (l = r ^ s ^ o, c = 1859775393) : u < 60 ? (l = r & s | r & o | s & o, c = 2400959708) : (l = r ^ s ^ o, c = 3395469782), d = b6(n, 5) + l + a + c + e.getUint32(u * 4, !1) & 4294967295, a = o, o = s, s = b6(r, 30), r = n, n = d;
    this._h0 = this._h0 + n & 4294967295, this._h1 = this._h1 + r & 4294967295, this._h2 = this._h2 + s & 4294967295, this._h3 = this._h3 + o & 4294967295, this._h4 = this._h4 + a & 4294967295;
  }
}
h4._bigBlock32 = new DataView(new ArrayBuffer(320));
class RX {
  constructor(e) {
    this.source = e;
  }
  getElements() {
    const e = this.source, t = new Int32Array(e.length);
    for (let n = 0, r = e.length; n < r; n++)
      t[n] = e.charCodeAt(n);
    return t;
  }
}
function lPe(i, e, t) {
  return new Wd(new RX(i), new RX(e)).ComputeDiff(t).changes;
}
class c1 {
  static Assert(e, t) {
    if (!e)
      throw new Error(t);
  }
}
class d1 {
  /**
   * Copies a range of elements from an Array starting at the specified source index and pastes
   * them to another Array starting at the specified destination index. The length and the indexes
   * are specified as 64-bit integers.
   * sourceArray:
   *		The Array that contains the data to copy.
   * sourceIndex:
   *		A 64-bit integer that represents the index in the sourceArray at which copying begins.
   * destinationArray:
   *		The Array that receives the data.
   * destinationIndex:
   *		A 64-bit integer that represents the index in the destinationArray at which storing begins.
   * length:
   *		A 64-bit integer that represents the number of elements to copy.
   */
  static Copy(e, t, n, r, s) {
    for (let o = 0; o < s; o++)
      n[r + o] = e[t + o];
  }
  static Copy2(e, t, n, r, s) {
    for (let o = 0; o < s; o++)
      n[r + o] = e[t + o];
  }
}
class FX {
  /**
   * Constructs a new DiffChangeHelper for the given DiffSequences.
   */
  constructor() {
    this.m_changes = [], this.m_originalStart = 1073741824, this.m_modifiedStart = 1073741824, this.m_originalCount = 0, this.m_modifiedCount = 0;
  }
  /**
   * Marks the beginning of the next change in the set of differences.
   */
  MarkNextChange() {
    (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.m_changes.push(new Lf(this.m_originalStart, this.m_originalCount, this.m_modifiedStart, this.m_modifiedCount)), this.m_originalCount = 0, this.m_modifiedCount = 0, this.m_originalStart = 1073741824, this.m_modifiedStart = 1073741824;
  }
  /**
   * Adds the original element at the given position to the elements
   * affected by the current change. The modified index gives context
   * to the change position with respect to the original sequence.
   * @param originalIndex The index of the original element to add.
   * @param modifiedIndex The index of the modified element that provides corresponding position in the modified sequence.
   */
  AddOriginalElement(e, t) {
    this.m_originalStart = Math.min(this.m_originalStart, e), this.m_modifiedStart = Math.min(this.m_modifiedStart, t), this.m_originalCount++;
  }
  /**
   * Adds the modified element at the given position to the elements
   * affected by the current change. The original index gives context
   * to the change position with respect to the modified sequence.
   * @param originalIndex The index of the original element that provides corresponding position in the original sequence.
   * @param modifiedIndex The index of the modified element to add.
   */
  AddModifiedElement(e, t) {
    this.m_originalStart = Math.min(this.m_originalStart, e), this.m_modifiedStart = Math.min(this.m_modifiedStart, t), this.m_modifiedCount++;
  }
  /**
   * Retrieves all of the changes marked by the class.
   */
  getChanges() {
    return (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.MarkNextChange(), this.m_changes;
  }
  /**
   * Retrieves all of the changes marked by the class in the reverse order
   */
  getReverseChanges() {
    return (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.MarkNextChange(), this.m_changes.reverse(), this.m_changes;
  }
}
class Wd {
  /**
   * Constructs the DiffFinder
   */
  constructor(e, t, n = null) {
    this.ContinueProcessingPredicate = n, this._originalSequence = e, this._modifiedSequence = t;
    const [r, s, o] = Wd._getElements(e), [a, l, c] = Wd._getElements(t);
    this._hasStrings = o && c, this._originalStringElements = r, this._originalElementsOrHash = s, this._modifiedStringElements = a, this._modifiedElementsOrHash = l, this.m_forwardHistory = [], this.m_reverseHistory = [];
  }
  static _isStringArray(e) {
    return e.length > 0 && typeof e[0] == "string";
  }
  static _getElements(e) {
    const t = e.getElements();
    if (Wd._isStringArray(t)) {
      const n = new Int32Array(t.length);
      for (let r = 0, s = t.length; r < s; r++)
        n[r] = Jj(t[r], 0);
      return [t, n, !0];
    }
    return t instanceof Int32Array ? [[], t, !1] : [[], new Int32Array(t), !1];
  }
  ElementsAreEqual(e, t) {
    return this._originalElementsOrHash[e] !== this._modifiedElementsOrHash[t] ? !1 : this._hasStrings ? this._originalStringElements[e] === this._modifiedStringElements[t] : !0;
  }
  ElementsAreStrictEqual(e, t) {
    if (!this.ElementsAreEqual(e, t))
      return !1;
    const n = Wd._getStrictElement(this._originalSequence, e), r = Wd._getStrictElement(this._modifiedSequence, t);
    return n === r;
  }
  static _getStrictElement(e, t) {
    return typeof e.getStrictElement == "function" ? e.getStrictElement(t) : null;
  }
  OriginalElementsAreEqual(e, t) {
    return this._originalElementsOrHash[e] !== this._originalElementsOrHash[t] ? !1 : this._hasStrings ? this._originalStringElements[e] === this._originalStringElements[t] : !0;
  }
  ModifiedElementsAreEqual(e, t) {
    return this._modifiedElementsOrHash[e] !== this._modifiedElementsOrHash[t] ? !1 : this._hasStrings ? this._modifiedStringElements[e] === this._modifiedStringElements[t] : !0;
  }
  ComputeDiff(e) {
    return this._ComputeDiff(0, this._originalElementsOrHash.length - 1, 0, this._modifiedElementsOrHash.length - 1, e);
  }
  /**
   * Computes the differences between the original and modified input
   * sequences on the bounded range.
   * @returns An array of the differences between the two input sequences.
   */
  _ComputeDiff(e, t, n, r, s) {
    const o = [!1];
    let a = this.ComputeDiffRecursive(e, t, n, r, o);
    return s && (a = this.PrettifyChanges(a)), {
      quitEarly: o[0],
      changes: a
    };
  }
  /**
   * Private helper method which computes the differences on the bounded range
   * recursively.
   * @returns An array of the differences between the two input sequences.
   */
  ComputeDiffRecursive(e, t, n, r, s) {
    for (s[0] = !1; e <= t && n <= r && this.ElementsAreEqual(e, n); )
      e++, n++;
    for (; t >= e && r >= n && this.ElementsAreEqual(t, r); )
      t--, r--;
    if (e > t || n > r) {
      let u;
      return n <= r ? (c1.Assert(e === t + 1, "originalStart should only be one more than originalEnd"), u = [
        new Lf(e, 0, n, r - n + 1)
      ]) : e <= t ? (c1.Assert(n === r + 1, "modifiedStart should only be one more than modifiedEnd"), u = [
        new Lf(e, t - e + 1, n, 0)
      ]) : (c1.Assert(e === t + 1, "originalStart should only be one more than originalEnd"), c1.Assert(n === r + 1, "modifiedStart should only be one more than modifiedEnd"), u = []), u;
    }
    const o = [0], a = [0], l = this.ComputeRecursionPoint(e, t, n, r, o, a, s), c = o[0], d = a[0];
    if (l !== null)
      return l;
    if (!s[0]) {
      const u = this.ComputeDiffRecursive(e, c, n, d, s);
      let h = [];
      return s[0] ? h = [
        new Lf(c + 1, t - (c + 1) + 1, d + 1, r - (d + 1) + 1)
      ] : h = this.ComputeDiffRecursive(c + 1, t, d + 1, r, s), this.ConcatenateChanges(u, h);
    }
    return [
      new Lf(e, t - e + 1, n, r - n + 1)
    ];
  }
  WALKTRACE(e, t, n, r, s, o, a, l, c, d, u, h, f, g, p, m, _, b) {
    let w = null, y = null, S = new FX(), x = t, D = n, E = f[0] - m[0] - r, L = -1073741824, k = this.m_forwardHistory.length - 1;
    do {
      const N = E + e;
      N === x || N < D && c[N - 1] < c[N + 1] ? (u = c[N + 1], g = u - E - r, u < L && S.MarkNextChange(), L = u, S.AddModifiedElement(u + 1, g), E = N + 1 - e) : (u = c[N - 1] + 1, g = u - E - r, u < L && S.MarkNextChange(), L = u - 1, S.AddOriginalElement(u, g + 1), E = N - 1 - e), k >= 0 && (c = this.m_forwardHistory[k], e = c[0], x = 1, D = c.length - 1);
    } while (--k >= -1);
    if (w = S.getReverseChanges(), b[0]) {
      let N = f[0] + 1, I = m[0] + 1;
      if (w !== null && w.length > 0) {
        const A = w[w.length - 1];
        N = Math.max(N, A.getOriginalEnd()), I = Math.max(I, A.getModifiedEnd());
      }
      y = [
        new Lf(N, h - N + 1, I, p - I + 1)
      ];
    } else {
      S = new FX(), x = o, D = a, E = f[0] - m[0] - l, L = 1073741824, k = _ ? this.m_reverseHistory.length - 1 : this.m_reverseHistory.length - 2;
      do {
        const N = E + s;
        N === x || N < D && d[N - 1] >= d[N + 1] ? (u = d[N + 1] - 1, g = u - E - l, u > L && S.MarkNextChange(), L = u + 1, S.AddOriginalElement(u + 1, g + 1), E = N + 1 - s) : (u = d[N - 1], g = u - E - l, u > L && S.MarkNextChange(), L = u, S.AddModifiedElement(u + 1, g + 1), E = N - 1 - s), k >= 0 && (d = this.m_reverseHistory[k], s = d[0], x = 1, D = d.length - 1);
      } while (--k >= -1);
      y = S.getChanges();
    }
    return this.ConcatenateChanges(w, y);
  }
  /**
   * Given the range to compute the diff on, this method finds the point:
   * (midOriginal, midModified)
   * that exists in the middle of the LCS of the two sequences and
   * is the point at which the LCS problem may be broken down recursively.
   * This method will try to keep the LCS trace in memory. If the LCS recursion
   * point is calculated and the full trace is available in memory, then this method
   * will return the change list.
   * @param originalStart The start bound of the original sequence range
   * @param originalEnd The end bound of the original sequence range
   * @param modifiedStart The start bound of the modified sequence range
   * @param modifiedEnd The end bound of the modified sequence range
   * @param midOriginal The middle point of the original sequence range
   * @param midModified The middle point of the modified sequence range
   * @returns The diff changes, if available, otherwise null
   */
  ComputeRecursionPoint(e, t, n, r, s, o, a) {
    let l = 0, c = 0, d = 0, u = 0, h = 0, f = 0;
    e--, n--, s[0] = 0, o[0] = 0, this.m_forwardHistory = [], this.m_reverseHistory = [];
    const g = t - e + (r - n), p = g + 1, m = new Int32Array(p), _ = new Int32Array(p), b = r - n, w = t - e, y = e - n, S = t - r, D = (w - b) % 2 === 0;
    m[b] = e, _[w] = t, a[0] = !1;
    for (let E = 1; E <= g / 2 + 1; E++) {
      let L = 0, k = 0;
      d = this.ClipDiagonalBound(b - E, E, b, p), u = this.ClipDiagonalBound(b + E, E, b, p);
      for (let I = d; I <= u; I += 2) {
        I === d || I < u && m[I - 1] < m[I + 1] ? l = m[I + 1] : l = m[I - 1] + 1, c = l - (I - b) - y;
        const A = l;
        for (; l < t && c < r && this.ElementsAreEqual(l + 1, c + 1); )
          l++, c++;
        if (m[I] = l, l + c > L + k && (L = l, k = c), !D && Math.abs(I - w) <= E - 1 && l >= _[I])
          return s[0] = l, o[0] = c, A <= _[I] && E <= 1448 ? this.WALKTRACE(b, d, u, y, w, h, f, S, m, _, l, t, s, c, r, o, D, a) : null;
      }
      const N = (L - e + (k - n) - E) / 2;
      if (this.ContinueProcessingPredicate !== null && !this.ContinueProcessingPredicate(L, N))
        return a[0] = !0, s[0] = L, o[0] = k, N > 0 && E <= 1448 ? this.WALKTRACE(b, d, u, y, w, h, f, S, m, _, l, t, s, c, r, o, D, a) : (e++, n++, [
          new Lf(e, t - e + 1, n, r - n + 1)
        ]);
      h = this.ClipDiagonalBound(w - E, E, w, p), f = this.ClipDiagonalBound(w + E, E, w, p);
      for (let I = h; I <= f; I += 2) {
        I === h || I < f && _[I - 1] >= _[I + 1] ? l = _[I + 1] - 1 : l = _[I - 1], c = l - (I - w) - S;
        const A = l;
        for (; l > e && c > n && this.ElementsAreEqual(l, c); )
          l--, c--;
        if (_[I] = l, D && Math.abs(I - b) <= E && l <= m[I])
          return s[0] = l, o[0] = c, A >= m[I] && E <= 1448 ? this.WALKTRACE(b, d, u, y, w, h, f, S, m, _, l, t, s, c, r, o, D, a) : null;
      }
      if (E <= 1447) {
        let I = new Int32Array(u - d + 2);
        I[0] = b - d + 1, d1.Copy2(m, d, I, 1, u - d + 1), this.m_forwardHistory.push(I), I = new Int32Array(f - h + 2), I[0] = w - h + 1, d1.Copy2(_, h, I, 1, f - h + 1), this.m_reverseHistory.push(I);
      }
    }
    return this.WALKTRACE(b, d, u, y, w, h, f, S, m, _, l, t, s, c, r, o, D, a);
  }
  /**
   * Shifts the given changes to provide a more intuitive diff.
   * While the first element in a diff matches the first element after the diff,
   * we shift the diff down.
   *
   * @param changes The list of changes to shift
   * @returns The shifted changes
   */
  PrettifyChanges(e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t], r = t < e.length - 1 ? e[t + 1].originalStart : this._originalElementsOrHash.length, s = t < e.length - 1 ? e[t + 1].modifiedStart : this._modifiedElementsOrHash.length, o = n.originalLength > 0, a = n.modifiedLength > 0;
      for (; n.originalStart + n.originalLength < r && n.modifiedStart + n.modifiedLength < s && (!o || this.OriginalElementsAreEqual(n.originalStart, n.originalStart + n.originalLength)) && (!a || this.ModifiedElementsAreEqual(n.modifiedStart, n.modifiedStart + n.modifiedLength)); ) {
        const c = this.ElementsAreStrictEqual(n.originalStart, n.modifiedStart);
        if (this.ElementsAreStrictEqual(n.originalStart + n.originalLength, n.modifiedStart + n.modifiedLength) && !c)
          break;
        n.originalStart++, n.modifiedStart++;
      }
      const l = [null];
      if (t < e.length - 1 && this.ChangesOverlap(e[t], e[t + 1], l)) {
        e[t] = l[0], e.splice(t + 1, 1), t--;
        continue;
      }
    }
    for (let t = e.length - 1; t >= 0; t--) {
      const n = e[t];
      let r = 0, s = 0;
      if (t > 0) {
        const u = e[t - 1];
        r = u.originalStart + u.originalLength, s = u.modifiedStart + u.modifiedLength;
      }
      const o = n.originalLength > 0, a = n.modifiedLength > 0;
      let l = 0, c = this._boundaryScore(n.originalStart, n.originalLength, n.modifiedStart, n.modifiedLength);
      for (let u = 1; ; u++) {
        const h = n.originalStart - u, f = n.modifiedStart - u;
        if (h < r || f < s || o && !this.OriginalElementsAreEqual(h, h + n.originalLength) || a && !this.ModifiedElementsAreEqual(f, f + n.modifiedLength))
          break;
        const p = (h === r && f === s ? 5 : 0) + this._boundaryScore(h, n.originalLength, f, n.modifiedLength);
        p > c && (c = p, l = u);
      }
      n.originalStart -= l, n.modifiedStart -= l;
      const d = [null];
      if (t > 0 && this.ChangesOverlap(e[t - 1], e[t], d)) {
        e[t - 1] = d[0], e.splice(t, 1), t++;
        continue;
      }
    }
    if (this._hasStrings)
      for (let t = 1, n = e.length; t < n; t++) {
        const r = e[t - 1], s = e[t], o = s.originalStart - r.originalStart - r.originalLength, a = r.originalStart, l = s.originalStart + s.originalLength, c = l - a, d = r.modifiedStart, u = s.modifiedStart + s.modifiedLength, h = u - d;
        if (o < 5 && c < 20 && h < 20) {
          const f = this._findBetterContiguousSequence(a, c, d, h, o);
          if (f) {
            const [g, p] = f;
            (g !== r.originalStart + r.originalLength || p !== r.modifiedStart + r.modifiedLength) && (r.originalLength = g - r.originalStart, r.modifiedLength = p - r.modifiedStart, s.originalStart = g + o, s.modifiedStart = p + o, s.originalLength = l - s.originalStart, s.modifiedLength = u - s.modifiedStart);
          }
        }
      }
    return e;
  }
  _findBetterContiguousSequence(e, t, n, r, s) {
    if (t < s || r < s)
      return null;
    const o = e + t - s + 1, a = n + r - s + 1;
    let l = 0, c = 0, d = 0;
    for (let u = e; u < o; u++)
      for (let h = n; h < a; h++) {
        const f = this._contiguousSequenceScore(u, h, s);
        f > 0 && f > l && (l = f, c = u, d = h);
      }
    return l > 0 ? [c, d] : null;
  }
  _contiguousSequenceScore(e, t, n) {
    let r = 0;
    for (let s = 0; s < n; s++) {
      if (!this.ElementsAreEqual(e + s, t + s))
        return 0;
      r += this._originalStringElements[e + s].length;
    }
    return r;
  }
  _OriginalIsBoundary(e) {
    return e <= 0 || e >= this._originalElementsOrHash.length - 1 ? !0 : this._hasStrings && /^\s*$/.test(this._originalStringElements[e]);
  }
  _OriginalRegionIsBoundary(e, t) {
    if (this._OriginalIsBoundary(e) || this._OriginalIsBoundary(e - 1))
      return !0;
    if (t > 0) {
      const n = e + t;
      if (this._OriginalIsBoundary(n - 1) || this._OriginalIsBoundary(n))
        return !0;
    }
    return !1;
  }
  _ModifiedIsBoundary(e) {
    return e <= 0 || e >= this._modifiedElementsOrHash.length - 1 ? !0 : this._hasStrings && /^\s*$/.test(this._modifiedStringElements[e]);
  }
  _ModifiedRegionIsBoundary(e, t) {
    if (this._ModifiedIsBoundary(e) || this._ModifiedIsBoundary(e - 1))
      return !0;
    if (t > 0) {
      const n = e + t;
      if (this._ModifiedIsBoundary(n - 1) || this._ModifiedIsBoundary(n))
        return !0;
    }
    return !1;
  }
  _boundaryScore(e, t, n, r) {
    const s = this._OriginalRegionIsBoundary(e, t) ? 1 : 0, o = this._ModifiedRegionIsBoundary(n, r) ? 1 : 0;
    return s + o;
  }
  /**
   * Concatenates the two input DiffChange lists and returns the resulting
   * list.
   * @param The left changes
   * @param The right changes
   * @returns The concatenated list
   */
  ConcatenateChanges(e, t) {
    const n = [];
    if (e.length === 0 || t.length === 0)
      return t.length > 0 ? t : e;
    if (this.ChangesOverlap(e[e.length - 1], t[0], n)) {
      const r = new Array(e.length + t.length - 1);
      return d1.Copy(e, 0, r, 0, e.length - 1), r[e.length - 1] = n[0], d1.Copy(t, 1, r, e.length, t.length - 1), r;
    } else {
      const r = new Array(e.length + t.length);
      return d1.Copy(e, 0, r, 0, e.length), d1.Copy(t, 0, r, e.length, t.length), r;
    }
  }
  /**
   * Returns true if the two changes overlap and can be merged into a single
   * change
   * @param left The left change
   * @param right The right change
   * @param mergedChange The merged change if the two overlap, null otherwise
   * @returns True if the two changes overlap
   */
  ChangesOverlap(e, t, n) {
    if (c1.Assert(e.originalStart <= t.originalStart, "Left change is not less than or equal to right change"), c1.Assert(e.modifiedStart <= t.modifiedStart, "Left change is not less than or equal to right change"), e.originalStart + e.originalLength >= t.originalStart || e.modifiedStart + e.modifiedLength >= t.modifiedStart) {
      const r = e.originalStart;
      let s = e.originalLength;
      const o = e.modifiedStart;
      let a = e.modifiedLength;
      return e.originalStart + e.originalLength >= t.originalStart && (s = t.originalStart + t.originalLength - e.originalStart), e.modifiedStart + e.modifiedLength >= t.modifiedStart && (a = t.modifiedStart + t.modifiedLength - e.modifiedStart), n[0] = new Lf(r, s, o, a), !0;
    } else
      return n[0] = null, !1;
  }
  /**
   * Helper method used to clip a diagonal index to the range of valid
   * diagonals. This also decides whether or not the diagonal index,
   * if it exceeds the boundary, should be clipped to the boundary or clipped
   * one inside the boundary depending on the Even/Odd status of the boundary
   * and numDifferences.
   * @param diagonal The index of the diagonal to clip.
   * @param numDifferences The current number of differences being iterated upon.
   * @param diagonalBaseIndex The base reference diagonal.
   * @param numDiagonals The total number of diagonals.
   * @returns The clipped diagonal index.
   */
  ClipDiagonalBound(e, t, n, r) {
    if (e >= 0 && e < r)
      return e;
    const s = n, o = r - n - 1, a = t % 2 === 0;
    if (e < 0) {
      const l = s % 2 === 0;
      return a === l ? 0 : 1;
    } else {
      const l = o % 2 === 0;
      return a === l ? r - 1 : r - 2;
    }
  }
}
function nL(i) {
  return i < 0 ? 0 : i > 255 ? 255 : i | 0;
}
function u1(i) {
  return i < 0 ? 0 : i > 4294967295 ? 4294967295 : i | 0;
}
class cPe {
  constructor(e) {
    this.values = e, this.prefixSum = new Uint32Array(e.length), this.prefixSumValidIndex = new Int32Array(1), this.prefixSumValidIndex[0] = -1;
  }
  insertValues(e, t) {
    e = u1(e);
    const n = this.values, r = this.prefixSum, s = t.length;
    return s === 0 ? !1 : (this.values = new Uint32Array(n.length + s), this.values.set(n.subarray(0, e), 0), this.values.set(n.subarray(e), e + s), this.values.set(t, e), e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), this.prefixSum = new Uint32Array(this.values.length), this.prefixSumValidIndex[0] >= 0 && this.prefixSum.set(r.subarray(0, this.prefixSumValidIndex[0] + 1)), !0);
  }
  setValue(e, t) {
    return e = u1(e), t = u1(t), this.values[e] === t ? !1 : (this.values[e] = t, e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), !0);
  }
  removeValues(e, t) {
    e = u1(e), t = u1(t);
    const n = this.values, r = this.prefixSum;
    if (e >= n.length)
      return !1;
    const s = n.length - e;
    return t >= s && (t = s), t === 0 ? !1 : (this.values = new Uint32Array(n.length - t), this.values.set(n.subarray(0, e), 0), this.values.set(n.subarray(e + t), e), this.prefixSum = new Uint32Array(this.values.length), e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), this.prefixSumValidIndex[0] >= 0 && this.prefixSum.set(r.subarray(0, this.prefixSumValidIndex[0] + 1)), !0);
  }
  getTotalSum() {
    return this.values.length === 0 ? 0 : this._getPrefixSum(this.values.length - 1);
  }
  /**
   * Returns the sum of the first `index + 1` many items.
   * @returns `SUM(0 <= j <= index, values[j])`.
   */
  getPrefixSum(e) {
    return e < 0 ? 0 : (e = u1(e), this._getPrefixSum(e));
  }
  _getPrefixSum(e) {
    if (e <= this.prefixSumValidIndex[0])
      return this.prefixSum[e];
    let t = this.prefixSumValidIndex[0] + 1;
    t === 0 && (this.prefixSum[0] = this.values[0], t++), e >= this.values.length && (e = this.values.length - 1);
    for (let n = t; n <= e; n++)
      this.prefixSum[n] = this.prefixSum[n - 1] + this.values[n];
    return this.prefixSumValidIndex[0] = Math.max(this.prefixSumValidIndex[0], e), this.prefixSum[e];
  }
  getIndexOf(e) {
    e = Math.floor(e), this.getTotalSum();
    let t = 0, n = this.values.length - 1, r = 0, s = 0, o = 0;
    for (; t <= n; )
      if (r = t + (n - t) / 2 | 0, s = this.prefixSum[r], o = s - this.values[r], e < o)
        n = r - 1;
      else if (e >= s)
        t = r + 1;
      else
        break;
    return new ufe(r, e - o);
  }
}
class dPe {
  constructor(e) {
    this._values = e, this._isValid = !1, this._validEndIndex = -1, this._prefixSum = [], this._indexBySum = [];
  }
  /**
   * @returns SUM(0 <= j < values.length, values[j])
   */
  getTotalSum() {
    return this._ensureValid(), this._indexBySum.length;
  }
  /**
   * Returns the sum of the first `count` many items.
   * @returns `SUM(0 <= j < count, values[j])`.
   */
  getPrefixSum(e) {
    return this._ensureValid(), e === 0 ? 0 : this._prefixSum[e - 1];
  }
  /**
   * @returns `result`, such that `getPrefixSum(result.index) + result.remainder = sum`
   */
  getIndexOf(e) {
    this._ensureValid();
    const t = this._indexBySum[e], n = t > 0 ? this._prefixSum[t - 1] : 0;
    return new ufe(t, e - n);
  }
  removeValues(e, t) {
    this._values.splice(e, t), this._invalidate(e);
  }
  insertValues(e, t) {
    this._values = HA(this._values, e, t), this._invalidate(e);
  }
  _invalidate(e) {
    this._isValid = !1, this._validEndIndex = Math.min(this._validEndIndex, e - 1);
  }
  _ensureValid() {
    if (!this._isValid) {
      for (let e = this._validEndIndex + 1, t = this._values.length; e < t; e++) {
        const n = this._values[e], r = e > 0 ? this._prefixSum[e - 1] : 0;
        this._prefixSum[e] = r + n;
        for (let s = 0; s < n; s++)
          this._indexBySum[r + s] = e;
      }
      this._prefixSum.length = this._values.length, this._indexBySum.length = this._prefixSum[this._prefixSum.length - 1], this._isValid = !0, this._validEndIndex = this._values.length - 1;
    }
  }
  setValue(e, t) {
    this._values[e] !== t && (this._values[e] = t, this._invalidate(e));
  }
}
class ufe {
  constructor(e, t) {
    this.index = e, this.remainder = t, this._prefixSumIndexOfResultBrand = void 0, this.index = e, this.remainder = t;
  }
}
class uPe {
  constructor(e, t, n, r) {
    this._uri = e, this._lines = t, this._eol = n, this._versionId = r, this._lineStarts = null, this._cachedTextValue = null;
  }
  dispose() {
    this._lines.length = 0;
  }
  get version() {
    return this._versionId;
  }
  getText() {
    return this._cachedTextValue === null && (this._cachedTextValue = this._lines.join(this._eol)), this._cachedTextValue;
  }
  onEvents(e) {
    e.eol && e.eol !== this._eol && (this._eol = e.eol, this._lineStarts = null);
    const t = e.changes;
    for (const n of t)
      this._acceptDeleteRange(n.range), this._acceptInsertText(new ve(n.range.startLineNumber, n.range.startColumn), n.text);
    this._versionId = e.versionId, this._cachedTextValue = null;
  }
  _ensureLineStarts() {
    if (!this._lineStarts) {
      const e = this._eol.length, t = this._lines.length, n = new Uint32Array(t);
      for (let r = 0; r < t; r++)
        n[r] = this._lines[r].length + e;
      this._lineStarts = new cPe(n);
    }
  }
  /**
   * All changes to a line's text go through this method
   */
  _setLineText(e, t) {
    this._lines[e] = t, this._lineStarts && this._lineStarts.setValue(e, this._lines[e].length + this._eol.length);
  }
  _acceptDeleteRange(e) {
    if (e.startLineNumber === e.endLineNumber) {
      if (e.startColumn === e.endColumn)
        return;
      this._setLineText(e.startLineNumber - 1, this._lines[e.startLineNumber - 1].substring(0, e.startColumn - 1) + this._lines[e.startLineNumber - 1].substring(e.endColumn - 1));
      return;
    }
    this._setLineText(e.startLineNumber - 1, this._lines[e.startLineNumber - 1].substring(0, e.startColumn - 1) + this._lines[e.endLineNumber - 1].substring(e.endColumn - 1)), this._lines.splice(e.startLineNumber, e.endLineNumber - e.startLineNumber), this._lineStarts && this._lineStarts.removeValues(e.startLineNumber, e.endLineNumber - e.startLineNumber);
  }
  _acceptInsertText(e, t) {
    if (t.length === 0)
      return;
    const n = Cu(t);
    if (n.length === 1) {
      this._setLineText(e.lineNumber - 1, this._lines[e.lineNumber - 1].substring(0, e.column - 1) + n[0] + this._lines[e.lineNumber - 1].substring(e.column - 1));
      return;
    }
    n[n.length - 1] += this._lines[e.lineNumber - 1].substring(e.column - 1), this._setLineText(e.lineNumber - 1, this._lines[e.lineNumber - 1].substring(0, e.column - 1) + n[0]);
    const r = new Uint32Array(n.length - 1);
    for (let s = 1; s < n.length; s++)
      this._lines.splice(e.lineNumber + s - 1, 0, n[s]), r[s - 1] = n[s].length + this._eol.length;
    this._lineStarts && this._lineStarts.insertValues(e.lineNumber, r);
  }
}
class mb {
  constructor(e) {
    const t = nL(e);
    this._defaultValue = t, this._asciiMap = mb._createAsciiMap(t), this._map = /* @__PURE__ */ new Map();
  }
  static _createAsciiMap(e) {
    const t = new Uint8Array(256);
    return t.fill(e), t;
  }
  set(e, t) {
    const n = nL(t);
    e >= 0 && e < 256 ? this._asciiMap[e] = n : this._map.set(e, n);
  }
  get(e) {
    return e >= 0 && e < 256 ? this._asciiMap[e] : this._map.get(e) || this._defaultValue;
  }
  clear() {
    this._asciiMap.fill(this._defaultValue), this._map.clear();
  }
}
class iL {
  constructor() {
    this._actual = new mb(
      0
      /* Boolean.False */
    );
  }
  add(e) {
    this._actual.set(
      e,
      1
      /* Boolean.True */
    );
  }
  has(e) {
    return this._actual.get(e) === 1;
  }
  clear() {
    return this._actual.clear();
  }
}
class hPe {
  constructor(e, t, n) {
    const r = new Uint8Array(e * t);
    for (let s = 0, o = e * t; s < o; s++)
      r[s] = n;
    this._data = r, this.rows = e, this.cols = t;
  }
  get(e, t) {
    return this._data[e * this.cols + t];
  }
  set(e, t, n) {
    this._data[e * this.cols + t] = n;
  }
}
class fPe {
  constructor(e) {
    let t = 0, n = 0;
    for (let s = 0, o = e.length; s < o; s++) {
      const [a, l, c] = e[s];
      l > t && (t = l), a > n && (n = a), c > n && (n = c);
    }
    t++, n++;
    const r = new hPe(
      n,
      t,
      0
      /* State.Invalid */
    );
    for (let s = 0, o = e.length; s < o; s++) {
      const [a, l, c] = e[s];
      r.set(a, l, c);
    }
    this._states = r, this._maxCharCode = t;
  }
  nextState(e, t) {
    return t < 0 || t >= this._maxCharCode ? 0 : this._states.get(e, t);
  }
}
let C6 = null;
function gPe() {
  return C6 === null && (C6 = new fPe([
    [
      1,
      104,
      2
      /* State.H */
    ],
    [
      1,
      72,
      2
      /* State.H */
    ],
    [
      1,
      102,
      6
      /* State.F */
    ],
    [
      1,
      70,
      6
      /* State.F */
    ],
    [
      2,
      116,
      3
      /* State.HT */
    ],
    [
      2,
      84,
      3
      /* State.HT */
    ],
    [
      3,
      116,
      4
      /* State.HTT */
    ],
    [
      3,
      84,
      4
      /* State.HTT */
    ],
    [
      4,
      112,
      5
      /* State.HTTP */
    ],
    [
      4,
      80,
      5
      /* State.HTTP */
    ],
    [
      5,
      115,
      9
      /* State.BeforeColon */
    ],
    [
      5,
      83,
      9
      /* State.BeforeColon */
    ],
    [
      5,
      58,
      10
      /* State.AfterColon */
    ],
    [
      6,
      105,
      7
      /* State.FI */
    ],
    [
      6,
      73,
      7
      /* State.FI */
    ],
    [
      7,
      108,
      8
      /* State.FIL */
    ],
    [
      7,
      76,
      8
      /* State.FIL */
    ],
    [
      8,
      101,
      9
      /* State.BeforeColon */
    ],
    [
      8,
      69,
      9
      /* State.BeforeColon */
    ],
    [
      9,
      58,
      10
      /* State.AfterColon */
    ],
    [
      10,
      47,
      11
      /* State.AlmostThere */
    ],
    [
      11,
      47,
      12
      /* State.End */
    ]
  ])), C6;
}
let t2 = null;
function pPe() {
  if (t2 === null) {
    t2 = new mb(
      0
      /* CharacterClass.None */
    );
    const i = ` 	<>'"、。｡､，．：；‘〈「『〔（［｛｢｣｝］）〕』」〉’｀～…`;
    for (let t = 0; t < i.length; t++)
      t2.set(
        i.charCodeAt(t),
        1
        /* CharacterClass.ForceTermination */
      );
    const e = ".,;:";
    for (let t = 0; t < e.length; t++)
      t2.set(
        e.charCodeAt(t),
        2
        /* CharacterClass.CannotEndIn */
      );
  }
  return t2;
}
class rL {
  static _createLink(e, t, n, r, s) {
    let o = s - 1;
    do {
      const a = t.charCodeAt(o);
      if (e.get(a) !== 2)
        break;
      o--;
    } while (o > r);
    if (r > 0) {
      const a = t.charCodeAt(r - 1), l = t.charCodeAt(o);
      (a === 40 && l === 41 || a === 91 && l === 93 || a === 123 && l === 125) && o--;
    }
    return {
      range: {
        startLineNumber: n,
        startColumn: r + 1,
        endLineNumber: n,
        endColumn: o + 2
      },
      url: t.substring(r, o + 1)
    };
  }
  static computeLinks(e, t = gPe()) {
    const n = pPe(), r = [];
    for (let s = 1, o = e.getLineCount(); s <= o; s++) {
      const a = e.getLineContent(s), l = a.length;
      let c = 0, d = 0, u = 0, h = 1, f = !1, g = !1, p = !1, m = !1;
      for (; c < l; ) {
        let _ = !1;
        const b = a.charCodeAt(c);
        if (h === 13) {
          let w;
          switch (b) {
            case 40:
              f = !0, w = 0;
              break;
            case 41:
              w = f ? 0 : 1;
              break;
            case 91:
              p = !0, g = !0, w = 0;
              break;
            case 93:
              p = !1, w = g ? 0 : 1;
              break;
            case 123:
              m = !0, w = 0;
              break;
            case 125:
              w = m ? 0 : 1;
              break;
            case 39:
            case 34:
            case 96:
              u === b ? w = 1 : u === 39 || u === 34 || u === 96 ? w = 0 : w = 1;
              break;
            case 42:
              w = u === 42 ? 1 : 0;
              break;
            case 124:
              w = u === 124 ? 1 : 0;
              break;
            case 32:
              w = p ? 0 : 1;
              break;
            default:
              w = n.get(b);
          }
          w === 1 && (r.push(rL._createLink(n, a, s, d, c)), _ = !0);
        } else if (h === 12) {
          let w;
          b === 91 ? (g = !0, w = 0) : w = n.get(b), w === 1 ? _ = !0 : h = 13;
        } else
          h = t.nextState(h, b), h === 0 && (_ = !0);
        _ && (h = 1, f = !1, g = !1, m = !1, d = c + 1, u = b), c++;
      }
      h === 13 && r.push(rL._createLink(n, a, s, d, l));
    }
    return r;
  }
}
function mPe(i) {
  return !i || typeof i.getLineCount != "function" || typeof i.getLineContent != "function" ? [] : rL.computeLinks(i);
}
class mF {
  constructor() {
    this._defaultValueSet = [
      ["true", "false"],
      ["True", "False"],
      ["Private", "Public", "Friend", "ReadOnly", "Partial", "Protected", "WriteOnly"],
      ["public", "protected", "private"]
    ];
  }
  navigateValueSet(e, t, n, r, s) {
    if (e && t) {
      const o = this.doNavigateValueSet(t, s);
      if (o)
        return {
          range: e,
          value: o
        };
    }
    if (n && r) {
      const o = this.doNavigateValueSet(r, s);
      if (o)
        return {
          range: n,
          value: o
        };
    }
    return null;
  }
  doNavigateValueSet(e, t) {
    const n = this.numberReplace(e, t);
    return n !== null ? n : this.textReplace(e, t);
  }
  numberReplace(e, t) {
    const n = Math.pow(10, e.length - (e.lastIndexOf(".") + 1));
    let r = Number(e);
    const s = parseFloat(e);
    return !isNaN(r) && !isNaN(s) && r === s ? r === 0 && !t ? null : (r = Math.floor(r * n), r += t ? n : -n, String(r / n)) : null;
  }
  textReplace(e, t) {
    return this.valueSetsReplace(this._defaultValueSet, e, t);
  }
  valueSetsReplace(e, t, n) {
    let r = null;
    for (let s = 0, o = e.length; r === null && s < o; s++)
      r = this.valueSetReplace(e[s], t, n);
    return r;
  }
  valueSetReplace(e, t, n) {
    let r = e.indexOf(t);
    return r >= 0 ? (r += n ? 1 : -1, r < 0 ? r = e.length - 1 : r %= e.length, e[r]) : null;
  }
}
mF.INSTANCE = new mF();
class vPe extends mb {
  constructor(e) {
    super(
      0
      /* WordCharacterClass.Regular */
    );
    for (let t = 0, n = e.length; t < n; t++)
      this.set(
        e.charCodeAt(t),
        2
        /* WordCharacterClass.WordSeparator */
      );
    this.set(
      32,
      1
      /* WordCharacterClass.Whitespace */
    ), this.set(
      9,
      1
      /* WordCharacterClass.Whitespace */
    );
  }
}
function _Pe(i) {
  const e = {};
  return (t) => (e.hasOwnProperty(t) || (e[t] = i(t)), e[t]);
}
const wl = _Pe((i) => new vPe(i));
var Ha;
(function(i) {
  i[i.Left = 1] = "Left", i[i.Center = 2] = "Center", i[i.Right = 4] = "Right", i[i.Full = 7] = "Full";
})(Ha || (Ha = {}));
var Nv;
(function(i) {
  i[i.Left = 1] = "Left", i[i.Right = 2] = "Right";
})(Nv || (Nv = {}));
var ia;
(function(i) {
  i[i.Inline = 1] = "Inline", i[i.Gutter = 2] = "Gutter";
})(ia || (ia = {}));
var Gc;
(function(i) {
  i[i.Both = 0] = "Both", i[i.Right = 1] = "Right", i[i.Left = 2] = "Left", i[i.None = 3] = "None";
})(Gc || (Gc = {}));
class R3 {
  get originalIndentSize() {
    return this._indentSizeIsTabSize ? "tabSize" : this.indentSize;
  }
  /**
   * @internal
   */
  constructor(e) {
    this._textModelResolvedOptionsBrand = void 0, this.tabSize = Math.max(1, e.tabSize | 0), e.indentSize === "tabSize" ? (this.indentSize = this.tabSize, this._indentSizeIsTabSize = !0) : (this.indentSize = Math.max(1, e.indentSize | 0), this._indentSizeIsTabSize = !1), this.insertSpaces = !!e.insertSpaces, this.defaultEOL = e.defaultEOL | 0, this.trimAutoWhitespace = !!e.trimAutoWhitespace, this.bracketPairColorizationOptions = e.bracketPairColorizationOptions;
  }
  /**
   * @internal
   */
  equals(e) {
    return this.tabSize === e.tabSize && this._indentSizeIsTabSize === e._indentSizeIsTabSize && this.indentSize === e.indentSize && this.insertSpaces === e.insertSpaces && this.defaultEOL === e.defaultEOL && this.trimAutoWhitespace === e.trimAutoWhitespace && Ra(this.bracketPairColorizationOptions, e.bracketPairColorizationOptions);
  }
  /**
   * @internal
   */
  createChangeEvent(e) {
    return {
      tabSize: this.tabSize !== e.tabSize,
      indentSize: this.indentSize !== e.indentSize,
      insertSpaces: this.insertSpaces !== e.insertSpaces,
      trimAutoWhitespace: this.trimAutoWhitespace !== e.trimAutoWhitespace
    };
  }
}
class Ny {
  /**
   * @internal
   */
  constructor(e, t) {
    this._findMatchBrand = void 0, this.range = e, this.matches = t;
  }
}
function bPe(i) {
  return i && typeof i.read == "function";
}
class y6 {
  constructor(e, t, n, r, s, o) {
    this.identifier = e, this.range = t, this.text = n, this.forceMoveMarkers = r, this.isAutoWhitespaceEdit = s, this._isTracked = o;
  }
}
class CPe {
  constructor(e, t, n) {
    this.regex = e, this.wordSeparators = t, this.simpleSearch = n;
  }
}
class yPe {
  constructor(e, t, n) {
    this.reverseEdits = e, this.changes = t, this.trimAutoWhitespaceLineNumbers = n;
  }
}
function wPe(i) {
  return !i.isTooLargeForSyncing() && !i.isForSimpleWidget;
}
const SPe = 999;
class Vp {
  constructor(e, t, n, r) {
    this.searchString = e, this.isRegex = t, this.matchCase = n, this.wordSeparators = r;
  }
  parseSearchRequest() {
    if (this.searchString === "")
      return null;
    let e;
    this.isRegex ? e = xPe(this.searchString) : e = this.searchString.indexOf(`
`) >= 0;
    let t = null;
    try {
      t = hhe(this.searchString, this.isRegex, {
        matchCase: this.matchCase,
        wholeWord: !1,
        multiline: e,
        global: !0,
        unicode: !0
      });
    } catch {
      return null;
    }
    if (!t)
      return null;
    let n = !this.isRegex && !e;
    return n && this.searchString.toLowerCase() !== this.searchString.toUpperCase() && (n = this.matchCase), new CPe(t, this.wordSeparators ? wl(this.wordSeparators) : null, n ? this.searchString : null);
  }
}
function xPe(i) {
  if (!i || i.length === 0)
    return !1;
  for (let e = 0, t = i.length; e < t; e++) {
    const n = i.charCodeAt(e);
    if (n === 10)
      return !0;
    if (n === 92) {
      if (e++, e >= t)
        break;
      const r = i.charCodeAt(e);
      if (r === 110 || r === 114 || r === 87)
        return !0;
    }
  }
  return !1;
}
function Yp(i, e, t) {
  if (!t)
    return new Ny(i, null);
  const n = [];
  for (let r = 0, s = e.length; r < s; r++)
    n[r] = e[r];
  return new Ny(i, n);
}
class BX {
  constructor(e) {
    const t = [];
    let n = 0;
    for (let r = 0, s = e.length; r < s; r++)
      e.charCodeAt(r) === 10 && (t[n++] = r);
    this._lineFeedsOffsets = t;
  }
  findLineFeedCountBeforeOffset(e) {
    const t = this._lineFeedsOffsets;
    let n = 0, r = t.length - 1;
    if (r === -1 || e <= t[0])
      return 0;
    for (; n < r; ) {
      const s = n + ((r - n) / 2 >> 0);
      t[s] >= e ? r = s - 1 : t[s + 1] >= e ? (n = s, r = s) : n = s + 1;
    }
    return n + 1;
  }
}
class jx {
  static findMatches(e, t, n, r, s) {
    const o = t.parseSearchRequest();
    return o ? o.regex.multiline ? this._doFindMatchesMultiline(e, n, new Z1(o.wordSeparators, o.regex), r, s) : this._doFindMatchesLineByLine(e, n, o, r, s) : [];
  }
  /**
   * Multiline search always executes on the lines concatenated with \n.
   * We must therefore compensate for the count of \n in case the model is CRLF
   */
  static _getMultilineMatchRange(e, t, n, r, s, o) {
    let a, l = 0;
    r ? (l = r.findLineFeedCountBeforeOffset(s), a = t + s + l) : a = t + s;
    let c;
    if (r) {
      const f = r.findLineFeedCountBeforeOffset(s + o.length) - l;
      c = a + o.length + f;
    } else
      c = a + o.length;
    const d = e.getPositionAt(a), u = e.getPositionAt(c);
    return new V(d.lineNumber, d.column, u.lineNumber, u.column);
  }
  static _doFindMatchesMultiline(e, t, n, r, s) {
    const o = e.getOffsetAt(t.getStartPosition()), a = e.getValueInRange(
      t,
      1
      /* EndOfLinePreference.LF */
    ), l = e.getEOL() === `\r
` ? new BX(a) : null, c = [];
    let d = 0, u;
    for (n.reset(0); u = n.next(a); )
      if (c[d++] = Yp(this._getMultilineMatchRange(e, o, a, l, u.index, u[0]), u, r), d >= s)
        return c;
    return c;
  }
  static _doFindMatchesLineByLine(e, t, n, r, s) {
    const o = [];
    let a = 0;
    if (t.startLineNumber === t.endLineNumber) {
      const c = e.getLineContent(t.startLineNumber).substring(t.startColumn - 1, t.endColumn - 1);
      return a = this._findMatchesInLine(n, c, t.startLineNumber, t.startColumn - 1, a, o, r, s), o;
    }
    const l = e.getLineContent(t.startLineNumber).substring(t.startColumn - 1);
    a = this._findMatchesInLine(n, l, t.startLineNumber, t.startColumn - 1, a, o, r, s);
    for (let c = t.startLineNumber + 1; c < t.endLineNumber && a < s; c++)
      a = this._findMatchesInLine(n, e.getLineContent(c), c, 0, a, o, r, s);
    if (a < s) {
      const c = e.getLineContent(t.endLineNumber).substring(0, t.endColumn - 1);
      a = this._findMatchesInLine(n, c, t.endLineNumber, 0, a, o, r, s);
    }
    return o;
  }
  static _findMatchesInLine(e, t, n, r, s, o, a, l) {
    const c = e.wordSeparators;
    if (!a && e.simpleSearch) {
      const h = e.simpleSearch, f = h.length, g = t.length;
      let p = -f;
      for (; (p = t.indexOf(h, p + f)) !== -1; )
        if ((!c || $j(c, t, g, p, f)) && (o[s++] = new Ny(new V(n, p + 1 + r, n, p + 1 + f + r), null), s >= l))
          return s;
      return s;
    }
    const d = new Z1(e.wordSeparators, e.regex);
    let u;
    d.reset(0);
    do
      if (u = d.next(t), u && (o[s++] = Yp(new V(n, u.index + 1 + r, n, u.index + 1 + u[0].length + r), u, a), s >= l))
        return s;
    while (u);
    return s;
  }
  static findNextMatch(e, t, n, r) {
    const s = t.parseSearchRequest();
    if (!s)
      return null;
    const o = new Z1(s.wordSeparators, s.regex);
    return s.regex.multiline ? this._doFindNextMatchMultiline(e, n, o, r) : this._doFindNextMatchLineByLine(e, n, o, r);
  }
  static _doFindNextMatchMultiline(e, t, n, r) {
    const s = new ve(t.lineNumber, 1), o = e.getOffsetAt(s), a = e.getLineCount(), l = e.getValueInRange(
      new V(s.lineNumber, s.column, a, e.getLineMaxColumn(a)),
      1
      /* EndOfLinePreference.LF */
    ), c = e.getEOL() === `\r
` ? new BX(l) : null;
    n.reset(t.column - 1);
    const d = n.next(l);
    return d ? Yp(this._getMultilineMatchRange(e, o, l, c, d.index, d[0]), d, r) : t.lineNumber !== 1 || t.column !== 1 ? this._doFindNextMatchMultiline(e, new ve(1, 1), n, r) : null;
  }
  static _doFindNextMatchLineByLine(e, t, n, r) {
    const s = e.getLineCount(), o = t.lineNumber, a = e.getLineContent(o), l = this._findFirstMatchInLine(n, a, o, t.column, r);
    if (l)
      return l;
    for (let c = 1; c <= s; c++) {
      const d = (o + c - 1) % s, u = e.getLineContent(d + 1), h = this._findFirstMatchInLine(n, u, d + 1, 1, r);
      if (h)
        return h;
    }
    return null;
  }
  static _findFirstMatchInLine(e, t, n, r, s) {
    e.reset(r - 1);
    const o = e.next(t);
    return o ? Yp(new V(n, o.index + 1, n, o.index + 1 + o[0].length), o, s) : null;
  }
  static findPreviousMatch(e, t, n, r) {
    const s = t.parseSearchRequest();
    if (!s)
      return null;
    const o = new Z1(s.wordSeparators, s.regex);
    return s.regex.multiline ? this._doFindPreviousMatchMultiline(e, n, o, r) : this._doFindPreviousMatchLineByLine(e, n, o, r);
  }
  static _doFindPreviousMatchMultiline(e, t, n, r) {
    const s = this._doFindMatchesMultiline(e, new V(1, 1, t.lineNumber, t.column), n, r, 10 * SPe);
    if (s.length > 0)
      return s[s.length - 1];
    const o = e.getLineCount();
    return t.lineNumber !== o || t.column !== e.getLineMaxColumn(o) ? this._doFindPreviousMatchMultiline(e, new ve(o, e.getLineMaxColumn(o)), n, r) : null;
  }
  static _doFindPreviousMatchLineByLine(e, t, n, r) {
    const s = e.getLineCount(), o = t.lineNumber, a = e.getLineContent(o).substring(0, t.column - 1), l = this._findLastMatchInLine(n, a, o, r);
    if (l)
      return l;
    for (let c = 1; c <= s; c++) {
      const d = (s + o - c - 1) % s, u = e.getLineContent(d + 1), h = this._findLastMatchInLine(n, u, d + 1, r);
      if (h)
        return h;
    }
    return null;
  }
  static _findLastMatchInLine(e, t, n, r) {
    let s = null, o;
    for (e.reset(0); o = e.next(t); )
      s = Yp(new V(n, o.index + 1, n, o.index + 1 + o[0].length), o, r);
    return s;
  }
}
function DPe(i, e, t, n, r) {
  if (n === 0)
    return !0;
  const s = e.charCodeAt(n - 1);
  if (i.get(s) !== 0 || s === 13 || s === 10)
    return !0;
  if (r > 0) {
    const o = e.charCodeAt(n);
    if (i.get(o) !== 0)
      return !0;
  }
  return !1;
}
function EPe(i, e, t, n, r) {
  if (n + r === t)
    return !0;
  const s = e.charCodeAt(n + r);
  if (i.get(s) !== 0 || s === 13 || s === 10)
    return !0;
  if (r > 0) {
    const o = e.charCodeAt(n + r - 1);
    if (i.get(o) !== 0)
      return !0;
  }
  return !1;
}
function $j(i, e, t, n, r) {
  return DPe(i, e, t, n, r) && EPe(i, e, t, n, r);
}
class Z1 {
  constructor(e, t) {
    this._wordSeparators = e, this._searchRegex = t, this._prevMatchStartIndex = -1, this._prevMatchLength = 0;
  }
  reset(e) {
    this._searchRegex.lastIndex = e, this._prevMatchStartIndex = -1, this._prevMatchLength = 0;
  }
  next(e) {
    const t = e.length;
    let n;
    do {
      if (this._prevMatchStartIndex + this._prevMatchLength === t || (n = this._searchRegex.exec(e), !n))
        return null;
      const r = n.index, s = n[0].length;
      if (r === this._prevMatchStartIndex && s === this._prevMatchLength) {
        if (s === 0) {
          XE(e, t, this._searchRegex.lastIndex) > 65535 ? this._searchRegex.lastIndex += 2 : this._searchRegex.lastIndex += 1;
          continue;
        }
        return null;
      }
      if (this._prevMatchStartIndex = r, this._prevMatchLength = s, !this._wordSeparators || $j(this._wordSeparators, e, t, r, s))
        return n;
    } while (n);
    return null;
  }
}
class ez {
  static computeUnicodeHighlights(e, t, n) {
    const r = n ? n.startLineNumber : 1, s = n ? n.endLineNumber : e.getLineCount(), o = new VX(t), a = o.getCandidateCodePoints();
    let l;
    a === "allNonBasicAscii" ? l = new RegExp("[^\\t\\n\\r\\x20-\\x7E]", "g") : l = new RegExp(`${LPe(Array.from(a))}`, "g");
    const c = new Z1(null, l), d = [];
    let u = !1, h, f = 0, g = 0, p = 0;
    e: for (let m = r, _ = s; m <= _; m++) {
      const b = e.getLineContent(m), w = b.length;
      c.reset(0);
      do
        if (h = c.next(b), h) {
          let y = h.index, S = h.index + h[0].length;
          if (y > 0) {
            const L = b.charCodeAt(y - 1);
            kr(L) && y--;
          }
          if (S + 1 < w) {
            const L = b.charCodeAt(S - 1);
            kr(L) && S++;
          }
          const x = b.substring(y, S);
          let D = yy(y + 1, Ij, b, 0);
          D && D.endColumn <= y + 1 && (D = null);
          const E = o.shouldHighlightNonBasicASCII(x, D ? D.word : null);
          if (E !== 0) {
            if (E === 3 ? f++ : E === 2 ? g++ : E === 1 ? p++ : $A(), d.length >= 1e3) {
              u = !0;
              break e;
            }
            d.push(new V(m, y + 1, m, S + 1));
          }
        }
      while (h);
    }
    return {
      ranges: d,
      hasMore: u,
      ambiguousCharacterCount: f,
      invisibleCharacterCount: g,
      nonBasicAsciiCharacterCount: p
    };
  }
  static computeUnicodeHighlightReason(e, t) {
    const n = new VX(t);
    switch (n.shouldHighlightNonBasicASCII(e, null)) {
      case 0:
        return null;
      case 2:
        return {
          kind: 1
          /* UnicodeHighlighterReasonKind.Invisible */
        };
      case 3: {
        const s = e.codePointAt(0), o = n.ambiguousCharacters.getPrimaryConfusable(s), a = qm.getLocales().filter((l) => !qm.getInstance(/* @__PURE__ */ new Set([...t.allowedLocales, l])).isAmbiguous(s));
        return { kind: 0, confusableWith: String.fromCodePoint(o), notAmbiguousInLocales: a };
      }
      case 1:
        return {
          kind: 2
          /* UnicodeHighlighterReasonKind.NonBasicAscii */
        };
    }
  }
}
function LPe(i, e) {
  return `[${Va(i.map((n) => String.fromCodePoint(n)).join(""))}]`;
}
class VX {
  constructor(e) {
    this.options = e, this.allowedCodePoints = new Set(e.allowedCodePoints), this.ambiguousCharacters = qm.getInstance(new Set(e.allowedLocales));
  }
  getCandidateCodePoints() {
    if (this.options.nonBasicASCII)
      return "allNonBasicAscii";
    const e = /* @__PURE__ */ new Set();
    if (this.options.invisibleCharacters)
      for (const t of cu.codePoints)
        HX(String.fromCodePoint(t)) || e.add(t);
    if (this.options.ambiguousCharacters)
      for (const t of this.ambiguousCharacters.getConfusableCodePoints())
        e.add(t);
    for (const t of this.allowedCodePoints)
      e.delete(t);
    return e;
  }
  shouldHighlightNonBasicASCII(e, t) {
    const n = e.codePointAt(0);
    if (this.allowedCodePoints.has(n))
      return 0;
    if (this.options.nonBasicASCII)
      return 1;
    let r = !1, s = !1;
    if (t)
      for (const o of t) {
        const a = o.codePointAt(0), l = yS(o);
        r = r || l, !l && !this.ambiguousCharacters.isAmbiguous(a) && !cu.isInvisibleCharacter(a) && (s = !0);
      }
    return (
      /* Don't allow mixing weird looking characters with ASCII */
      !r && /* Is there an obviously weird looking character? */
      s ? 0 : this.options.invisibleCharacters && !HX(e) && cu.isInvisibleCharacter(n) ? 2 : this.options.ambiguousCharacters && this.ambiguousCharacters.isAmbiguous(n) ? 3 : 0
    );
  }
}
function HX(i) {
  return i === " " || i === `
` || i === "	";
}
class F3 {
  constructor(e, t, n) {
    this.changes = e, this.moves = t, this.hitTimeout = n;
  }
}
class hfe {
  constructor(e, t) {
    this.lineRangeMapping = e, this.changes = t;
  }
}
class zt {
  static addRange(e, t) {
    let n = 0;
    for (; n < t.length && t[n].endExclusive < e.start; )
      n++;
    let r = n;
    for (; r < t.length && t[r].start <= e.endExclusive; )
      r++;
    if (n === r)
      t.splice(n, 0, e);
    else {
      const s = Math.min(e.start, t[n].start), o = Math.max(e.endExclusive, t[r - 1].endExclusive);
      t.splice(n, r - n, new zt(s, o));
    }
  }
  static tryCreate(e, t) {
    if (!(e > t))
      return new zt(e, t);
  }
  static ofLength(e) {
    return new zt(0, e);
  }
  constructor(e, t) {
    if (this.start = e, this.endExclusive = t, e > t)
      throw new gr(`Invalid range: ${this.toString()}`);
  }
  get isEmpty() {
    return this.start === this.endExclusive;
  }
  delta(e) {
    return new zt(this.start + e, this.endExclusive + e);
  }
  deltaStart(e) {
    return new zt(this.start + e, this.endExclusive);
  }
  deltaEnd(e) {
    return new zt(this.start, this.endExclusive + e);
  }
  get length() {
    return this.endExclusive - this.start;
  }
  toString() {
    return `[${this.start}, ${this.endExclusive})`;
  }
  equals(e) {
    return this.start === e.start && this.endExclusive === e.endExclusive;
  }
  containsRange(e) {
    return this.start <= e.start && e.endExclusive <= this.endExclusive;
  }
  contains(e) {
    return this.start <= e && e < this.endExclusive;
  }
  /**
   * for all numbers n: range1.contains(n) or range2.contains(n) => range1.join(range2).contains(n)
   * The joined range is the smallest range that contains both ranges.
   */
  join(e) {
    return new zt(Math.min(this.start, e.start), Math.max(this.endExclusive, e.endExclusive));
  }
  /**
   * for all numbers n: range1.contains(n) and range2.contains(n) <=> range1.intersect(range2).contains(n)
   *
   * The resulting range is empty if the ranges do not intersect, but touch.
   * If the ranges don't even touch, the result is undefined.
   */
  intersect(e) {
    const t = Math.max(this.start, e.start), n = Math.min(this.endExclusive, e.endExclusive);
    if (t <= n)
      return new zt(t, n);
  }
  slice(e) {
    return e.slice(this.start, this.endExclusive);
  }
  /**
   * Returns the given value if it is contained in this instance, otherwise the closest value that is contained.
   * The range must not be empty.
   */
  clip(e) {
    if (this.isEmpty)
      throw new gr(`Invalid clipping range: ${this.toString()}`);
    return Math.max(this.start, Math.min(this.endExclusive - 1, e));
  }
  /**
   * Returns `r := value + k * length` such that `r` is contained in this range.
   * The range must not be empty.
   *
   * E.g. `[5, 10).clipCyclic(10) === 5`, `[5, 10).clipCyclic(11) === 6` and `[5, 10).clipCyclic(4) === 9`.
   */
  clipCyclic(e) {
    if (this.isEmpty)
      throw new gr(`Invalid clipping range: ${this.toString()}`);
    return e < this.start ? this.endExclusive - (this.start - e) % this.length : e >= this.endExclusive ? this.start + (e - this.start) % this.length : e;
  }
  forEach(e) {
    for (let t = this.start; t < this.endExclusive; t++)
      e(t);
  }
}
class tz {
  constructor() {
    this._sortedRanges = [];
  }
  addRange(e) {
    let t = 0;
    for (; t < this._sortedRanges.length && this._sortedRanges[t].endExclusive < e.start; )
      t++;
    let n = t;
    for (; n < this._sortedRanges.length && this._sortedRanges[n].start <= e.endExclusive; )
      n++;
    if (t === n)
      this._sortedRanges.splice(t, 0, e);
    else {
      const r = Math.min(e.start, this._sortedRanges[t].start), s = Math.max(e.endExclusive, this._sortedRanges[n - 1].endExclusive);
      this._sortedRanges.splice(t, n - t, new zt(r, s));
    }
  }
  toString() {
    return this._sortedRanges.map((e) => e.toString()).join(", ");
  }
  /**
   * Returns of there is a value that is contained in this instance and the given range.
   */
  intersectsStrict(e) {
    let t = 0;
    for (; t < this._sortedRanges.length && this._sortedRanges[t].endExclusive <= e.start; )
      t++;
    return t < this._sortedRanges.length && this._sortedRanges[t].start < e.endExclusive;
  }
  intersectWithRange(e) {
    const t = new tz();
    for (const n of this._sortedRanges) {
      const r = n.intersect(e);
      r && t.addRange(r);
    }
    return t;
  }
  intersectWithRangeLength(e) {
    return this.intersectWithRange(e).length;
  }
  get length() {
    return this._sortedRanges.reduce((e, t) => e + t.length, 0);
  }
}
function sL(i, e, t) {
  const n = IPe(i, e);
  if (n !== -1)
    return i[n];
}
function IPe(i, e, t = i.length - 1) {
  for (let n = t; n >= 0; n--) {
    const r = i[n];
    if (e(r))
      return n;
  }
  return -1;
}
function Py(i, e) {
  const t = Oy(i, e);
  return t === -1 ? void 0 : i[t];
}
function Oy(i, e, t = 0, n = i.length) {
  let r = t, s = n;
  for (; r < s; ) {
    const o = Math.floor((r + s) / 2);
    e(i[o]) ? r = o + 1 : s = o;
  }
  return r - 1;
}
function APe(i, e) {
  const t = My(i, e);
  return t === i.length ? void 0 : i[t];
}
function My(i, e, t = 0, n = i.length) {
  let r = t, s = n;
  for (; r < s; ) {
    const o = Math.floor((r + s) / 2);
    e(i[o]) ? s = o : r = o + 1;
  }
  return r;
}
class xS {
  constructor(e) {
    this._array = e, this._findLastMonotonousLastIdx = 0;
  }
  /**
   * The predicate must be monotonous, i.e. `arr.map(predicate)` must be like `[true, ..., true, false, ..., false]`!
   * For subsequent calls, current predicate must be weaker than (or equal to) the previous predicate, i.e. more entries must be `true`.
   */
  findLastMonotonous(e) {
    if (xS.assertInvariants) {
      if (this._prevFindLastPredicate) {
        for (const n of this._array)
          if (this._prevFindLastPredicate(n) && !e(n))
            throw new Error("MonotonousArray: current predicate must be weaker than (or equal to) the previous predicate.");
      }
      this._prevFindLastPredicate = e;
    }
    const t = Oy(this._array, e, this._findLastMonotonousLastIdx);
    return this._findLastMonotonousLastIdx = t + 1, t === -1 ? void 0 : this._array[t];
  }
}
xS.assertInvariants = !1;
function ffe(i, e) {
  if (i.length === 0)
    return;
  let t = i[0];
  for (let n = 1; n < i.length; n++) {
    const r = i[n];
    e(r, t) > 0 && (t = r);
  }
  return t;
}
function kPe(i, e) {
  if (i.length === 0)
    return;
  let t = i[0];
  for (let n = 1; n < i.length; n++) {
    const r = i[n];
    e(r, t) >= 0 && (t = r);
  }
  return t;
}
function TPe(i, e) {
  return ffe(i, (t, n) => -e(t, n));
}
function NPe(i, e) {
  if (i.length === 0)
    return -1;
  let t = 0;
  for (let n = 1; n < i.length; n++) {
    const r = i[n];
    e(r, i[t]) > 0 && (t = n);
  }
  return t;
}
function PPe(i, e) {
  for (const t of i) {
    const n = e(t);
    if (n !== void 0)
      return n;
  }
}
let Qt = class If {
  static fromRange(e) {
    return new If(e.startLineNumber, e.endLineNumber);
  }
  /**
   * @param lineRanges An array of sorted line ranges.
   */
  static joinMany(e) {
    if (e.length === 0)
      return [];
    let t = new jd(e[0].slice());
    for (let n = 1; n < e.length; n++)
      t = t.getUnion(new jd(e[n].slice()));
    return t.ranges;
  }
  static ofLength(e, t) {
    return new If(e, e + t);
  }
  /**
   * @internal
   */
  static deserialize(e) {
    return new If(e[0], e[1]);
  }
  constructor(e, t) {
    if (e > t)
      throw new gr(`startLineNumber ${e} cannot be after endLineNumberExclusive ${t}`);
    this.startLineNumber = e, this.endLineNumberExclusive = t;
  }
  /**
   * Indicates if this line range contains the given line number.
   */
  contains(e) {
    return this.startLineNumber <= e && e < this.endLineNumberExclusive;
  }
  /**
   * Indicates if this line range is empty.
   */
  get isEmpty() {
    return this.startLineNumber === this.endLineNumberExclusive;
  }
  /**
   * Moves this line range by the given offset of line numbers.
   */
  delta(e) {
    return new If(this.startLineNumber + e, this.endLineNumberExclusive + e);
  }
  deltaLength(e) {
    return new If(this.startLineNumber, this.endLineNumberExclusive + e);
  }
  /**
   * The number of lines this line range spans.
   */
  get length() {
    return this.endLineNumberExclusive - this.startLineNumber;
  }
  /**
   * Creates a line range that combines this and the given line range.
   */
  join(e) {
    return new If(Math.min(this.startLineNumber, e.startLineNumber), Math.max(this.endLineNumberExclusive, e.endLineNumberExclusive));
  }
  toString() {
    return `[${this.startLineNumber},${this.endLineNumberExclusive})`;
  }
  /**
   * The resulting range is empty if the ranges do not intersect, but touch.
   * If the ranges don't even touch, the result is undefined.
   */
  intersect(e) {
    const t = Math.max(this.startLineNumber, e.startLineNumber), n = Math.min(this.endLineNumberExclusive, e.endLineNumberExclusive);
    if (t <= n)
      return new If(t, n);
  }
  intersectsStrict(e) {
    return this.startLineNumber < e.endLineNumberExclusive && e.startLineNumber < this.endLineNumberExclusive;
  }
  overlapOrTouch(e) {
    return this.startLineNumber <= e.endLineNumberExclusive && e.startLineNumber <= this.endLineNumberExclusive;
  }
  equals(e) {
    return this.startLineNumber === e.startLineNumber && this.endLineNumberExclusive === e.endLineNumberExclusive;
  }
  toInclusiveRange() {
    return this.isEmpty ? null : new V(this.startLineNumber, 1, this.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER);
  }
  toExclusiveRange() {
    return new V(this.startLineNumber, 1, this.endLineNumberExclusive, 1);
  }
  mapToLineArray(e) {
    const t = [];
    for (let n = this.startLineNumber; n < this.endLineNumberExclusive; n++)
      t.push(e(n));
    return t;
  }
  forEach(e) {
    for (let t = this.startLineNumber; t < this.endLineNumberExclusive; t++)
      e(t);
  }
  /**
   * @internal
   */
  serialize() {
    return [this.startLineNumber, this.endLineNumberExclusive];
  }
  includes(e) {
    return this.startLineNumber <= e && e < this.endLineNumberExclusive;
  }
  /**
   * Converts this 1-based line range to a 0-based offset range (subtracts 1!).
   * @internal
   */
  toOffsetRange() {
    return new zt(this.startLineNumber - 1, this.endLineNumberExclusive - 1);
  }
};
class jd {
  constructor(e = []) {
    this._normalizedRanges = e;
  }
  get ranges() {
    return this._normalizedRanges;
  }
  addRange(e) {
    if (e.length === 0)
      return;
    const t = My(this._normalizedRanges, (r) => r.endLineNumberExclusive >= e.startLineNumber), n = Oy(this._normalizedRanges, (r) => r.startLineNumber <= e.endLineNumberExclusive) + 1;
    if (t === n)
      this._normalizedRanges.splice(t, 0, e);
    else if (t === n - 1) {
      const r = this._normalizedRanges[t];
      this._normalizedRanges[t] = r.join(e);
    } else {
      const r = this._normalizedRanges[t].join(this._normalizedRanges[n - 1]).join(e);
      this._normalizedRanges.splice(t, n - t, r);
    }
  }
  contains(e) {
    const t = Py(this._normalizedRanges, (n) => n.startLineNumber <= e);
    return !!t && t.endLineNumberExclusive > e;
  }
  getUnion(e) {
    if (this._normalizedRanges.length === 0)
      return e;
    if (e._normalizedRanges.length === 0)
      return this;
    const t = [];
    let n = 0, r = 0, s = null;
    for (; n < this._normalizedRanges.length || r < e._normalizedRanges.length; ) {
      let o = null;
      if (n < this._normalizedRanges.length && r < e._normalizedRanges.length) {
        const a = this._normalizedRanges[n], l = e._normalizedRanges[r];
        a.startLineNumber < l.startLineNumber ? (o = a, n++) : (o = l, r++);
      } else n < this._normalizedRanges.length ? (o = this._normalizedRanges[n], n++) : (o = e._normalizedRanges[r], r++);
      s === null ? s = o : s.endLineNumberExclusive >= o.startLineNumber ? s = new Qt(s.startLineNumber, Math.max(s.endLineNumberExclusive, o.endLineNumberExclusive)) : (t.push(s), s = o);
    }
    return s !== null && t.push(s), new jd(t);
  }
  /**
   * Subtracts all ranges in this set from `range` and returns the result.
   */
  subtractFrom(e) {
    const t = My(this._normalizedRanges, (o) => o.endLineNumberExclusive >= e.startLineNumber), n = Oy(this._normalizedRanges, (o) => o.startLineNumber <= e.endLineNumberExclusive) + 1;
    if (t === n)
      return new jd([e]);
    const r = [];
    let s = e.startLineNumber;
    for (let o = t; o < n; o++) {
      const a = this._normalizedRanges[o];
      a.startLineNumber > s && r.push(new Qt(s, a.startLineNumber)), s = a.endLineNumberExclusive;
    }
    return s < e.endLineNumberExclusive && r.push(new Qt(s, e.endLineNumberExclusive)), new jd(r);
  }
  toString() {
    return this._normalizedRanges.map((e) => e.toString()).join(", ");
  }
  getIntersection(e) {
    const t = [];
    let n = 0, r = 0;
    for (; n < this._normalizedRanges.length && r < e._normalizedRanges.length; ) {
      const s = this._normalizedRanges[n], o = e._normalizedRanges[r], a = s.intersect(o);
      a && !a.isEmpty && t.push(a), s.endLineNumberExclusive < o.endLineNumberExclusive ? n++ : r++;
    }
    return new jd(t);
  }
  getWithDelta(e) {
    return new jd(this._normalizedRanges.map((t) => t.delta(e)));
  }
}
class wu {
  static inverse(e, t, n) {
    const r = [];
    let s = 1, o = 1;
    for (const l of e) {
      const c = new Sl(new Qt(s, l.original.startLineNumber), new Qt(o, l.modified.startLineNumber), void 0);
      c.modified.isEmpty || r.push(c), s = l.original.endLineNumberExclusive, o = l.modified.endLineNumberExclusive;
    }
    const a = new Sl(new Qt(s, t + 1), new Qt(o, n + 1), void 0);
    return a.modified.isEmpty || r.push(a), r;
  }
  constructor(e, t) {
    this.original = e, this.modified = t;
  }
  toString() {
    return `{${this.original.toString()}->${this.modified.toString()}}`;
  }
  flip() {
    return new wu(this.modified, this.original);
  }
  join(e) {
    return new wu(this.original.join(e.original), this.modified.join(e.modified));
  }
}
class Sl extends wu {
  constructor(e, t, n) {
    super(e, t), this.innerChanges = n;
  }
  flip() {
    var e;
    return new Sl(this.modified, this.original, (e = this.innerChanges) === null || e === void 0 ? void 0 : e.map((t) => t.flip()));
  }
}
class Bg {
  constructor(e, t) {
    this.originalRange = e, this.modifiedRange = t;
  }
  toString() {
    return `{${this.originalRange.toString()}->${this.modifiedRange.toString()}}`;
  }
  flip() {
    return new Bg(this.modifiedRange, this.originalRange);
  }
}
const OPe = 3;
class MPe {
  computeDiff(e, t, n) {
    var r;
    const o = new BPe(e, t, {
      maxComputationTime: n.maxComputationTimeMs,
      shouldIgnoreTrimWhitespace: n.ignoreTrimWhitespace,
      shouldComputeCharChanges: !0,
      shouldMakePrettyDiff: !0,
      shouldPostProcessCharChanges: !0
    }).computeDiff(), a = [];
    let l = null;
    for (const c of o.changes) {
      let d;
      c.originalEndLineNumber === 0 ? d = new Qt(c.originalStartLineNumber + 1, c.originalStartLineNumber + 1) : d = new Qt(c.originalStartLineNumber, c.originalEndLineNumber + 1);
      let u;
      c.modifiedEndLineNumber === 0 ? u = new Qt(c.modifiedStartLineNumber + 1, c.modifiedStartLineNumber + 1) : u = new Qt(c.modifiedStartLineNumber, c.modifiedEndLineNumber + 1);
      let h = new Sl(d, u, (r = c.charChanges) === null || r === void 0 ? void 0 : r.map((f) => new Bg(new V(f.originalStartLineNumber, f.originalStartColumn, f.originalEndLineNumber, f.originalEndColumn), new V(f.modifiedStartLineNumber, f.modifiedStartColumn, f.modifiedEndLineNumber, f.modifiedEndColumn))));
      l && (l.modified.endLineNumberExclusive === h.modified.startLineNumber || l.original.endLineNumberExclusive === h.original.startLineNumber) && (h = new Sl(l.original.join(h.original), l.modified.join(h.modified), l.innerChanges && h.innerChanges ? l.innerChanges.concat(h.innerChanges) : void 0), a.pop()), a.push(h), l = h;
    }
    return Iy(() => xhe(a, (c, d) => d.original.startLineNumber - c.original.endLineNumberExclusive === d.modified.startLineNumber - c.modified.endLineNumberExclusive && // There has to be an unchanged line in between (otherwise both diffs should have been joined)
    c.original.endLineNumberExclusive < d.original.startLineNumber && c.modified.endLineNumberExclusive < d.modified.startLineNumber)), new F3(a, [], o.quitEarly);
  }
}
function gfe(i, e, t, n) {
  return new Wd(i, e, t).ComputeDiff(n);
}
let WX = class {
  constructor(e) {
    const t = [], n = [];
    for (let r = 0, s = e.length; r < s; r++)
      t[r] = vF(e[r], 1), n[r] = _F(e[r], 1);
    this.lines = e, this._startColumns = t, this._endColumns = n;
  }
  getElements() {
    const e = [];
    for (let t = 0, n = this.lines.length; t < n; t++)
      e[t] = this.lines[t].substring(this._startColumns[t] - 1, this._endColumns[t] - 1);
    return e;
  }
  getStrictElement(e) {
    return this.lines[e];
  }
  getStartLineNumber(e) {
    return e + 1;
  }
  getEndLineNumber(e) {
    return e + 1;
  }
  createCharSequence(e, t, n) {
    const r = [], s = [], o = [];
    let a = 0;
    for (let l = t; l <= n; l++) {
      const c = this.lines[l], d = e ? this._startColumns[l] : 1, u = e ? this._endColumns[l] : c.length + 1;
      for (let h = d; h < u; h++)
        r[a] = c.charCodeAt(h - 1), s[a] = l + 1, o[a] = h, a++;
      !e && l < n && (r[a] = 10, s[a] = l + 1, o[a] = c.length + 1, a++);
    }
    return new RPe(r, s, o);
  }
};
class RPe {
  constructor(e, t, n) {
    this._charCodes = e, this._lineNumbers = t, this._columns = n;
  }
  toString() {
    return "[" + this._charCodes.map((e, t) => (e === 10 ? "\\n" : String.fromCharCode(e)) + `-(${this._lineNumbers[t]},${this._columns[t]})`).join(", ") + "]";
  }
  _assertIndex(e, t) {
    if (e < 0 || e >= t.length)
      throw new Error("Illegal index");
  }
  getElements() {
    return this._charCodes;
  }
  getStartLineNumber(e) {
    return e > 0 && e === this._lineNumbers.length ? this.getEndLineNumber(e - 1) : (this._assertIndex(e, this._lineNumbers), this._lineNumbers[e]);
  }
  getEndLineNumber(e) {
    return e === -1 ? this.getStartLineNumber(e + 1) : (this._assertIndex(e, this._lineNumbers), this._charCodes[e] === 10 ? this._lineNumbers[e] + 1 : this._lineNumbers[e]);
  }
  getStartColumn(e) {
    return e > 0 && e === this._columns.length ? this.getEndColumn(e - 1) : (this._assertIndex(e, this._columns), this._columns[e]);
  }
  getEndColumn(e) {
    return e === -1 ? this.getStartColumn(e + 1) : (this._assertIndex(e, this._columns), this._charCodes[e] === 10 ? 1 : this._columns[e] + 1);
  }
}
class Pv {
  constructor(e, t, n, r, s, o, a, l) {
    this.originalStartLineNumber = e, this.originalStartColumn = t, this.originalEndLineNumber = n, this.originalEndColumn = r, this.modifiedStartLineNumber = s, this.modifiedStartColumn = o, this.modifiedEndLineNumber = a, this.modifiedEndColumn = l;
  }
  static createFromDiffChange(e, t, n) {
    const r = t.getStartLineNumber(e.originalStart), s = t.getStartColumn(e.originalStart), o = t.getEndLineNumber(e.originalStart + e.originalLength - 1), a = t.getEndColumn(e.originalStart + e.originalLength - 1), l = n.getStartLineNumber(e.modifiedStart), c = n.getStartColumn(e.modifiedStart), d = n.getEndLineNumber(e.modifiedStart + e.modifiedLength - 1), u = n.getEndColumn(e.modifiedStart + e.modifiedLength - 1);
    return new Pv(r, s, o, a, l, c, d, u);
  }
}
function FPe(i) {
  if (i.length <= 1)
    return i;
  const e = [i[0]];
  let t = e[0];
  for (let n = 1, r = i.length; n < r; n++) {
    const s = i[n], o = s.originalStart - (t.originalStart + t.originalLength), a = s.modifiedStart - (t.modifiedStart + t.modifiedLength);
    Math.min(o, a) < OPe ? (t.originalLength = s.originalStart + s.originalLength - t.originalStart, t.modifiedLength = s.modifiedStart + s.modifiedLength - t.modifiedStart) : (e.push(s), t = s);
  }
  return e;
}
class wC {
  constructor(e, t, n, r, s) {
    this.originalStartLineNumber = e, this.originalEndLineNumber = t, this.modifiedStartLineNumber = n, this.modifiedEndLineNumber = r, this.charChanges = s;
  }
  static createFromDiffResult(e, t, n, r, s, o, a) {
    let l, c, d, u, h;
    if (t.originalLength === 0 ? (l = n.getStartLineNumber(t.originalStart) - 1, c = 0) : (l = n.getStartLineNumber(t.originalStart), c = n.getEndLineNumber(t.originalStart + t.originalLength - 1)), t.modifiedLength === 0 ? (d = r.getStartLineNumber(t.modifiedStart) - 1, u = 0) : (d = r.getStartLineNumber(t.modifiedStart), u = r.getEndLineNumber(t.modifiedStart + t.modifiedLength - 1)), o && t.originalLength > 0 && t.originalLength < 20 && t.modifiedLength > 0 && t.modifiedLength < 20 && s()) {
      const f = n.createCharSequence(e, t.originalStart, t.originalStart + t.originalLength - 1), g = r.createCharSequence(e, t.modifiedStart, t.modifiedStart + t.modifiedLength - 1);
      if (f.getElements().length > 0 && g.getElements().length > 0) {
        let p = gfe(f, g, s, !0).changes;
        a && (p = FPe(p)), h = [];
        for (let m = 0, _ = p.length; m < _; m++)
          h.push(Pv.createFromDiffChange(p[m], f, g));
      }
    }
    return new wC(l, c, d, u, h);
  }
}
class BPe {
  constructor(e, t, n) {
    this.shouldComputeCharChanges = n.shouldComputeCharChanges, this.shouldPostProcessCharChanges = n.shouldPostProcessCharChanges, this.shouldIgnoreTrimWhitespace = n.shouldIgnoreTrimWhitespace, this.shouldMakePrettyDiff = n.shouldMakePrettyDiff, this.originalLines = e, this.modifiedLines = t, this.original = new WX(e), this.modified = new WX(t), this.continueLineDiff = jX(n.maxComputationTime), this.continueCharDiff = jX(n.maxComputationTime === 0 ? 0 : Math.min(n.maxComputationTime, 5e3));
  }
  computeDiff() {
    if (this.original.lines.length === 1 && this.original.lines[0].length === 0)
      return this.modified.lines.length === 1 && this.modified.lines[0].length === 0 ? {
        quitEarly: !1,
        changes: []
      } : {
        quitEarly: !1,
        changes: [{
          originalStartLineNumber: 1,
          originalEndLineNumber: 1,
          modifiedStartLineNumber: 1,
          modifiedEndLineNumber: this.modified.lines.length,
          charChanges: void 0
        }]
      };
    if (this.modified.lines.length === 1 && this.modified.lines[0].length === 0)
      return {
        quitEarly: !1,
        changes: [{
          originalStartLineNumber: 1,
          originalEndLineNumber: this.original.lines.length,
          modifiedStartLineNumber: 1,
          modifiedEndLineNumber: 1,
          charChanges: void 0
        }]
      };
    const e = gfe(this.original, this.modified, this.continueLineDiff, this.shouldMakePrettyDiff), t = e.changes, n = e.quitEarly;
    if (this.shouldIgnoreTrimWhitespace) {
      const a = [];
      for (let l = 0, c = t.length; l < c; l++)
        a.push(wC.createFromDiffResult(this.shouldIgnoreTrimWhitespace, t[l], this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges));
      return {
        quitEarly: n,
        changes: a
      };
    }
    const r = [];
    let s = 0, o = 0;
    for (let a = -1, l = t.length; a < l; a++) {
      const c = a + 1 < l ? t[a + 1] : null, d = c ? c.originalStart : this.originalLines.length, u = c ? c.modifiedStart : this.modifiedLines.length;
      for (; s < d && o < u; ) {
        const h = this.originalLines[s], f = this.modifiedLines[o];
        if (h !== f) {
          {
            let g = vF(h, 1), p = vF(f, 1);
            for (; g > 1 && p > 1; ) {
              const m = h.charCodeAt(g - 2), _ = f.charCodeAt(p - 2);
              if (m !== _)
                break;
              g--, p--;
            }
            (g > 1 || p > 1) && this._pushTrimWhitespaceCharChange(r, s + 1, 1, g, o + 1, 1, p);
          }
          {
            let g = _F(h, 1), p = _F(f, 1);
            const m = h.length + 1, _ = f.length + 1;
            for (; g < m && p < _; ) {
              const b = h.charCodeAt(g - 1), w = h.charCodeAt(p - 1);
              if (b !== w)
                break;
              g++, p++;
            }
            (g < m || p < _) && this._pushTrimWhitespaceCharChange(r, s + 1, g, m, o + 1, p, _);
          }
        }
        s++, o++;
      }
      c && (r.push(wC.createFromDiffResult(this.shouldIgnoreTrimWhitespace, c, this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges)), s += c.originalLength, o += c.modifiedLength);
    }
    return {
      quitEarly: n,
      changes: r
    };
  }
  _pushTrimWhitespaceCharChange(e, t, n, r, s, o, a) {
    if (this._mergeTrimWhitespaceCharChange(e, t, n, r, s, o, a))
      return;
    let l;
    this.shouldComputeCharChanges && (l = [new Pv(t, n, t, r, s, o, s, a)]), e.push(new wC(t, t, s, s, l));
  }
  _mergeTrimWhitespaceCharChange(e, t, n, r, s, o, a) {
    const l = e.length;
    if (l === 0)
      return !1;
    const c = e[l - 1];
    return c.originalEndLineNumber === 0 || c.modifiedEndLineNumber === 0 ? !1 : c.originalEndLineNumber === t && c.modifiedEndLineNumber === s ? (this.shouldComputeCharChanges && c.charChanges && c.charChanges.push(new Pv(t, n, t, r, s, o, s, a)), !0) : c.originalEndLineNumber + 1 === t && c.modifiedEndLineNumber + 1 === s ? (c.originalEndLineNumber = t, c.modifiedEndLineNumber = s, this.shouldComputeCharChanges && c.charChanges && c.charChanges.push(new Pv(t, n, t, r, s, o, s, a)), !0) : !1;
  }
}
function vF(i, e) {
  const t = Js(i);
  return t === -1 ? e : t + 1;
}
function _F(i, e) {
  const t = Jc(i);
  return t === -1 ? e : t + 2;
}
function jX(i) {
  if (i === 0)
    return () => !0;
  const e = Date.now();
  return () => Date.now() - e < i;
}
class Bh {
  static trivial(e, t) {
    return new Bh([new ns(zt.ofLength(e.length), zt.ofLength(t.length))], !1);
  }
  static trivialTimedOut(e, t) {
    return new Bh([new ns(zt.ofLength(e.length), zt.ofLength(t.length))], !0);
  }
  constructor(e, t) {
    this.diffs = e, this.hitTimeout = t;
  }
}
class ns {
  static invert(e, t) {
    const n = [];
    return kue(e, (r, s) => {
      n.push(ns.fromOffsetPairs(r ? r.getEndExclusives() : Xd.zero, s ? s.getStarts() : new Xd(t, (r ? r.seq2Range.endExclusive - r.seq1Range.endExclusive : 0) + t)));
    }), n;
  }
  static fromOffsetPairs(e, t) {
    return new ns(new zt(e.offset1, t.offset1), new zt(e.offset2, t.offset2));
  }
  constructor(e, t) {
    this.seq1Range = e, this.seq2Range = t;
  }
  swap() {
    return new ns(this.seq2Range, this.seq1Range);
  }
  toString() {
    return `${this.seq1Range} <-> ${this.seq2Range}`;
  }
  join(e) {
    return new ns(this.seq1Range.join(e.seq1Range), this.seq2Range.join(e.seq2Range));
  }
  delta(e) {
    return e === 0 ? this : new ns(this.seq1Range.delta(e), this.seq2Range.delta(e));
  }
  deltaStart(e) {
    return e === 0 ? this : new ns(this.seq1Range.deltaStart(e), this.seq2Range.deltaStart(e));
  }
  deltaEnd(e) {
    return e === 0 ? this : new ns(this.seq1Range.deltaEnd(e), this.seq2Range.deltaEnd(e));
  }
  intersect(e) {
    const t = this.seq1Range.intersect(e.seq1Range), n = this.seq2Range.intersect(e.seq2Range);
    if (!(!t || !n))
      return new ns(t, n);
  }
  getStarts() {
    return new Xd(this.seq1Range.start, this.seq2Range.start);
  }
  getEndExclusives() {
    return new Xd(this.seq1Range.endExclusive, this.seq2Range.endExclusive);
  }
}
class Xd {
  constructor(e, t) {
    this.offset1 = e, this.offset2 = t;
  }
  toString() {
    return `${this.offset1} <-> ${this.offset2}`;
  }
}
Xd.zero = new Xd(0, 0);
Xd.max = new Xd(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
class Ry {
  isValid() {
    return !0;
  }
}
Ry.instance = new Ry();
class VPe {
  constructor(e) {
    if (this.timeout = e, this.startTime = Date.now(), this.valid = !0, e <= 0)
      throw new gr("timeout must be positive");
  }
  // Recommendation: Set a log-point `{this.disable()}` in the body
  isValid() {
    if (!(Date.now() - this.startTime < this.timeout) && this.valid) {
      this.valid = !1;
      debugger;
    }
    return this.valid;
  }
}
class w6 {
  constructor(e, t) {
    this.width = e, this.height = t, this.array = [], this.array = new Array(e * t);
  }
  get(e, t) {
    return this.array[e + t * this.width];
  }
  set(e, t, n) {
    this.array[e + t * this.width] = n;
  }
}
function bF(i) {
  return i === 32 || i === 9;
}
class v_ {
  static getKey(e) {
    let t = this.chrKeys.get(e);
    return t === void 0 && (t = this.chrKeys.size, this.chrKeys.set(e, t)), t;
  }
  constructor(e, t, n) {
    this.range = e, this.lines = t, this.source = n, this.histogram = [];
    let r = 0;
    for (let s = e.startLineNumber - 1; s < e.endLineNumberExclusive - 1; s++) {
      const o = t[s];
      for (let l = 0; l < o.length; l++) {
        r++;
        const c = o[l], d = v_.getKey(c);
        this.histogram[d] = (this.histogram[d] || 0) + 1;
      }
      r++;
      const a = v_.getKey(`
`);
      this.histogram[a] = (this.histogram[a] || 0) + 1;
    }
    this.totalCount = r;
  }
  computeSimilarity(e) {
    var t, n;
    let r = 0;
    const s = Math.max(this.histogram.length, e.histogram.length);
    for (let o = 0; o < s; o++)
      r += Math.abs(((t = this.histogram[o]) !== null && t !== void 0 ? t : 0) - ((n = e.histogram[o]) !== null && n !== void 0 ? n : 0));
    return 1 - r / (this.totalCount + e.totalCount);
  }
}
v_.chrKeys = /* @__PURE__ */ new Map();
class HPe {
  compute(e, t, n = Ry.instance, r) {
    if (e.length === 0 || t.length === 0)
      return Bh.trivial(e, t);
    const s = new w6(e.length, t.length), o = new w6(e.length, t.length), a = new w6(e.length, t.length);
    for (let g = 0; g < e.length; g++)
      for (let p = 0; p < t.length; p++) {
        if (!n.isValid())
          return Bh.trivialTimedOut(e, t);
        const m = g === 0 ? 0 : s.get(g - 1, p), _ = p === 0 ? 0 : s.get(g, p - 1);
        let b;
        e.getElement(g) === t.getElement(p) ? (g === 0 || p === 0 ? b = 0 : b = s.get(g - 1, p - 1), g > 0 && p > 0 && o.get(g - 1, p - 1) === 3 && (b += a.get(g - 1, p - 1)), b += r ? r(g, p) : 1) : b = -1;
        const w = Math.max(m, _, b);
        if (w === b) {
          const y = g > 0 && p > 0 ? a.get(g - 1, p - 1) : 0;
          a.set(g, p, y + 1), o.set(g, p, 3);
        } else w === m ? (a.set(g, p, 0), o.set(g, p, 1)) : w === _ && (a.set(g, p, 0), o.set(g, p, 2));
        s.set(g, p, w);
      }
    const l = [];
    let c = e.length, d = t.length;
    function u(g, p) {
      (g + 1 !== c || p + 1 !== d) && l.push(new ns(new zt(g + 1, c), new zt(p + 1, d))), c = g, d = p;
    }
    let h = e.length - 1, f = t.length - 1;
    for (; h >= 0 && f >= 0; )
      o.get(h, f) === 3 ? (u(h, f), h--, f--) : o.get(h, f) === 1 ? h-- : f--;
    return u(-1, -1), l.reverse(), new Bh(l, !1);
  }
}
class pfe {
  compute(e, t, n = Ry.instance) {
    if (e.length === 0 || t.length === 0)
      return Bh.trivial(e, t);
    const r = e, s = t;
    function o(p, m) {
      for (; p < r.length && m < s.length && r.getElement(p) === s.getElement(m); )
        p++, m++;
      return p;
    }
    let a = 0;
    const l = new WPe();
    l.set(0, o(0, 0));
    const c = new jPe();
    c.set(0, l.get(0) === 0 ? null : new zX(null, 0, 0, l.get(0)));
    let d = 0;
    e: for (; ; ) {
      if (a++, !n.isValid())
        return Bh.trivialTimedOut(r, s);
      const p = -Math.min(a, s.length + a % 2), m = Math.min(a, r.length + a % 2);
      for (d = p; d <= m; d += 2) {
        const _ = d === m ? -1 : l.get(d + 1), b = d === p ? -1 : l.get(d - 1) + 1, w = Math.min(Math.max(_, b), r.length), y = w - d;
        if (w > r.length || y > s.length)
          continue;
        const S = o(w, y);
        l.set(d, S);
        const x = w === _ ? c.get(d + 1) : c.get(d - 1);
        if (c.set(d, S !== w ? new zX(x, w, y, S - w) : x), l.get(d) === r.length && l.get(d) - d === s.length)
          break e;
      }
    }
    let u = c.get(d);
    const h = [];
    let f = r.length, g = s.length;
    for (; ; ) {
      const p = u ? u.x + u.length : 0, m = u ? u.y + u.length : 0;
      if ((p !== f || m !== g) && h.push(new ns(new zt(p, f), new zt(m, g))), !u)
        break;
      f = u.x, g = u.y, u = u.prev;
    }
    return h.reverse(), new Bh(h, !1);
  }
}
class zX {
  constructor(e, t, n, r) {
    this.prev = e, this.x = t, this.y = n, this.length = r;
  }
}
class WPe {
  constructor() {
    this.positiveArr = new Int32Array(10), this.negativeArr = new Int32Array(10);
  }
  get(e) {
    return e < 0 ? (e = -e - 1, this.negativeArr[e]) : this.positiveArr[e];
  }
  set(e, t) {
    if (e < 0) {
      if (e = -e - 1, e >= this.negativeArr.length) {
        const n = this.negativeArr;
        this.negativeArr = new Int32Array(n.length * 2), this.negativeArr.set(n);
      }
      this.negativeArr[e] = t;
    } else {
      if (e >= this.positiveArr.length) {
        const n = this.positiveArr;
        this.positiveArr = new Int32Array(n.length * 2), this.positiveArr.set(n);
      }
      this.positiveArr[e] = t;
    }
  }
}
class jPe {
  constructor() {
    this.positiveArr = [], this.negativeArr = [];
  }
  get(e) {
    return e < 0 ? (e = -e - 1, this.negativeArr[e]) : this.positiveArr[e];
  }
  set(e, t) {
    e < 0 ? (e = -e - 1, this.negativeArr[e] = t) : this.positiveArr[e] = t;
  }
}
var UX, GX;
class zPe {
  constructor(e, t) {
    this.uri = e, this.value = t;
  }
}
function UPe(i) {
  return Array.isArray(i);
}
class Ms {
  constructor(e, t) {
    if (this[UX] = "ResourceMap", e instanceof Ms)
      this.map = new Map(e.map), this.toKey = t ?? Ms.defaultToKey;
    else if (UPe(e)) {
      this.map = /* @__PURE__ */ new Map(), this.toKey = t ?? Ms.defaultToKey;
      for (const [n, r] of e)
        this.set(n, r);
    } else
      this.map = /* @__PURE__ */ new Map(), this.toKey = e ?? Ms.defaultToKey;
  }
  set(e, t) {
    return this.map.set(this.toKey(e), new zPe(e, t)), this;
  }
  get(e) {
    var t;
    return (t = this.map.get(this.toKey(e))) === null || t === void 0 ? void 0 : t.value;
  }
  has(e) {
    return this.map.has(this.toKey(e));
  }
  get size() {
    return this.map.size;
  }
  clear() {
    this.map.clear();
  }
  delete(e) {
    return this.map.delete(this.toKey(e));
  }
  forEach(e, t) {
    typeof t < "u" && (e = e.bind(t));
    for (const [n, r] of this.map)
      e(r.value, r.uri, this);
  }
  *values() {
    for (const e of this.map.values())
      yield e.value;
  }
  *keys() {
    for (const e of this.map.values())
      yield e.uri;
  }
  *entries() {
    for (const e of this.map.values())
      yield [e.uri, e.value];
  }
  *[(UX = Symbol.toStringTag, Symbol.iterator)]() {
    for (const [, e] of this.map)
      yield [e.uri, e.value];
  }
}
Ms.defaultToKey = (i) => i.toString();
class GPe {
  constructor() {
    this[GX] = "LinkedMap", this._map = /* @__PURE__ */ new Map(), this._head = void 0, this._tail = void 0, this._size = 0, this._state = 0;
  }
  clear() {
    this._map.clear(), this._head = void 0, this._tail = void 0, this._size = 0, this._state++;
  }
  isEmpty() {
    return !this._head && !this._tail;
  }
  get size() {
    return this._size;
  }
  get first() {
    var e;
    return (e = this._head) === null || e === void 0 ? void 0 : e.value;
  }
  get last() {
    var e;
    return (e = this._tail) === null || e === void 0 ? void 0 : e.value;
  }
  has(e) {
    return this._map.has(e);
  }
  get(e, t = 0) {
    const n = this._map.get(e);
    if (n)
      return t !== 0 && this.touch(n, t), n.value;
  }
  set(e, t, n = 0) {
    let r = this._map.get(e);
    if (r)
      r.value = t, n !== 0 && this.touch(r, n);
    else {
      switch (r = { key: e, value: t, next: void 0, previous: void 0 }, n) {
        case 0:
          this.addItemLast(r);
          break;
        case 1:
          this.addItemFirst(r);
          break;
        case 2:
          this.addItemLast(r);
          break;
        default:
          this.addItemLast(r);
          break;
      }
      this._map.set(e, r), this._size++;
    }
    return this;
  }
  delete(e) {
    return !!this.remove(e);
  }
  remove(e) {
    const t = this._map.get(e);
    if (t)
      return this._map.delete(e), this.removeItem(t), this._size--, t.value;
  }
  shift() {
    if (!this._head && !this._tail)
      return;
    if (!this._head || !this._tail)
      throw new Error("Invalid list");
    const e = this._head;
    return this._map.delete(e.key), this.removeItem(e), this._size--, e.value;
  }
  forEach(e, t) {
    const n = this._state;
    let r = this._head;
    for (; r; ) {
      if (t ? e.bind(t)(r.value, r.key, this) : e(r.value, r.key, this), this._state !== n)
        throw new Error("LinkedMap got modified during iteration.");
      r = r.next;
    }
  }
  keys() {
    const e = this, t = this._state;
    let n = this._head;
    const r = {
      [Symbol.iterator]() {
        return r;
      },
      next() {
        if (e._state !== t)
          throw new Error("LinkedMap got modified during iteration.");
        if (n) {
          const s = { value: n.key, done: !1 };
          return n = n.next, s;
        } else
          return { value: void 0, done: !0 };
      }
    };
    return r;
  }
  values() {
    const e = this, t = this._state;
    let n = this._head;
    const r = {
      [Symbol.iterator]() {
        return r;
      },
      next() {
        if (e._state !== t)
          throw new Error("LinkedMap got modified during iteration.");
        if (n) {
          const s = { value: n.value, done: !1 };
          return n = n.next, s;
        } else
          return { value: void 0, done: !0 };
      }
    };
    return r;
  }
  entries() {
    const e = this, t = this._state;
    let n = this._head;
    const r = {
      [Symbol.iterator]() {
        return r;
      },
      next() {
        if (e._state !== t)
          throw new Error("LinkedMap got modified during iteration.");
        if (n) {
          const s = { value: [n.key, n.value], done: !1 };
          return n = n.next, s;
        } else
          return { value: void 0, done: !0 };
      }
    };
    return r;
  }
  [(GX = Symbol.toStringTag, Symbol.iterator)]() {
    return this.entries();
  }
  trimOld(e) {
    if (e >= this.size)
      return;
    if (e === 0) {
      this.clear();
      return;
    }
    let t = this._head, n = this.size;
    for (; t && n > e; )
      this._map.delete(t.key), t = t.next, n--;
    this._head = t, this._size = n, t && (t.previous = void 0), this._state++;
  }
  addItemFirst(e) {
    if (!this._head && !this._tail)
      this._tail = e;
    else if (this._head)
      e.next = this._head, this._head.previous = e;
    else
      throw new Error("Invalid list");
    this._head = e, this._state++;
  }
  addItemLast(e) {
    if (!this._head && !this._tail)
      this._head = e;
    else if (this._tail)
      e.previous = this._tail, this._tail.next = e;
    else
      throw new Error("Invalid list");
    this._tail = e, this._state++;
  }
  removeItem(e) {
    if (e === this._head && e === this._tail)
      this._head = void 0, this._tail = void 0;
    else if (e === this._head) {
      if (!e.next)
        throw new Error("Invalid list");
      e.next.previous = void 0, this._head = e.next;
    } else if (e === this._tail) {
      if (!e.previous)
        throw new Error("Invalid list");
      e.previous.next = void 0, this._tail = e.previous;
    } else {
      const t = e.next, n = e.previous;
      if (!t || !n)
        throw new Error("Invalid list");
      t.previous = n, n.next = t;
    }
    e.next = void 0, e.previous = void 0, this._state++;
  }
  touch(e, t) {
    if (!this._head || !this._tail)
      throw new Error("Invalid list");
    if (!(t !== 1 && t !== 2)) {
      if (t === 1) {
        if (e === this._head)
          return;
        const n = e.next, r = e.previous;
        e === this._tail ? (r.next = void 0, this._tail = r) : (n.previous = r, r.next = n), e.previous = void 0, e.next = this._head, this._head.previous = e, this._head = e, this._state++;
      } else if (t === 2) {
        if (e === this._tail)
          return;
        const n = e.next, r = e.previous;
        e === this._head ? (n.previous = void 0, this._head = n) : (n.previous = r, r.next = n), e.next = void 0, e.previous = this._tail, this._tail.next = e, this._tail = e, this._state++;
      }
    }
  }
  toJSON() {
    const e = [];
    return this.forEach((t, n) => {
      e.push([n, t]);
    }), e;
  }
  fromJSON(e) {
    this.clear();
    for (const [t, n] of e)
      this.set(t, n);
  }
}
class cp extends GPe {
  constructor(e, t = 1) {
    super(), this._limit = e, this._ratio = Math.min(Math.max(0, t), 1);
  }
  get limit() {
    return this._limit;
  }
  set limit(e) {
    this._limit = e, this.checkTrim();
  }
  get(e, t = 2) {
    return super.get(e, t);
  }
  peek(e) {
    return super.get(
      e,
      0
      /* Touch.None */
    );
  }
  set(e, t) {
    return super.set(
      e,
      t,
      2
      /* Touch.AsNew */
    ), this.checkTrim(), this;
  }
  checkTrim() {
    this.size > this._limit && this.trimOld(Math.round(this._limit * this._ratio));
  }
}
class qPe {
  constructor(e) {
    if (this._m1 = /* @__PURE__ */ new Map(), this._m2 = /* @__PURE__ */ new Map(), e)
      for (const [t, n] of e)
        this.set(t, n);
  }
  clear() {
    this._m1.clear(), this._m2.clear();
  }
  set(e, t) {
    this._m1.set(e, t), this._m2.set(t, e);
  }
  get(e) {
    return this._m1.get(e);
  }
  getKey(e) {
    return this._m2.get(e);
  }
  delete(e) {
    const t = this._m1.get(e);
    return t === void 0 ? !1 : (this._m1.delete(e), this._m2.delete(t), !0);
  }
  keys() {
    return this._m1.keys();
  }
  values() {
    return this._m1.values();
  }
}
class nz {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  add(e, t) {
    let n = this.map.get(e);
    n || (n = /* @__PURE__ */ new Set(), this.map.set(e, n)), n.add(t);
  }
  delete(e, t) {
    const n = this.map.get(e);
    n && (n.delete(t), n.size === 0 && this.map.delete(e));
  }
  forEach(e, t) {
    const n = this.map.get(e);
    n && n.forEach(t);
  }
  get(e) {
    const t = this.map.get(e);
    return t || /* @__PURE__ */ new Set();
  }
}
class oL {
  constructor(e, t, n) {
    this.lines = e, this.considerWhitespaceChanges = n, this.elements = [], this.firstCharOffsetByLine = [], this.additionalOffsetByLine = [];
    let r = !1;
    t.start > 0 && t.endExclusive >= e.length && (t = new zt(t.start - 1, t.endExclusive), r = !0), this.lineRange = t, this.firstCharOffsetByLine[0] = 0;
    for (let s = this.lineRange.start; s < this.lineRange.endExclusive; s++) {
      let o = e[s], a = 0;
      if (r)
        a = o.length, o = "", r = !1;
      else if (!n) {
        const l = o.trimStart();
        a = o.length - l.length, o = l.trimEnd();
      }
      this.additionalOffsetByLine.push(a);
      for (let l = 0; l < o.length; l++)
        this.elements.push(o.charCodeAt(l));
      s < e.length - 1 && (this.elements.push(10), this.firstCharOffsetByLine[s - this.lineRange.start + 1] = this.elements.length);
    }
    this.additionalOffsetByLine.push(0);
  }
  toString() {
    return `Slice: "${this.text}"`;
  }
  get text() {
    return this.getText(new zt(0, this.length));
  }
  getText(e) {
    return this.elements.slice(e.start, e.endExclusive).map((t) => String.fromCharCode(t)).join("");
  }
  getElement(e) {
    return this.elements[e];
  }
  get length() {
    return this.elements.length;
  }
  getBoundaryScore(e) {
    const t = KX(e > 0 ? this.elements[e - 1] : -1), n = KX(e < this.elements.length ? this.elements[e] : -1);
    if (t === 6 && n === 7)
      return 0;
    let r = 0;
    return t !== n && (r += 10, t === 0 && n === 1 && (r += 1)), r += qX(t), r += qX(n), r;
  }
  translateOffset(e) {
    if (this.lineRange.isEmpty)
      return new ve(this.lineRange.start + 1, 1);
    const t = Oy(this.firstCharOffsetByLine, (n) => n <= e);
    return new ve(this.lineRange.start + t + 1, e - this.firstCharOffsetByLine[t] + this.additionalOffsetByLine[t] + 1);
  }
  translateRange(e) {
    return V.fromPositions(this.translateOffset(e.start), this.translateOffset(e.endExclusive));
  }
  /**
   * Finds the word that contains the character at the given offset
   */
  findWordContaining(e) {
    if (e < 0 || e >= this.elements.length || !S6(this.elements[e]))
      return;
    let t = e;
    for (; t > 0 && S6(this.elements[t - 1]); )
      t--;
    let n = e;
    for (; n < this.elements.length && S6(this.elements[n]); )
      n++;
    return new zt(t, n);
  }
  countLinesIn(e) {
    return this.translateOffset(e.endExclusive).lineNumber - this.translateOffset(e.start).lineNumber;
  }
  isStronglyEqual(e, t) {
    return this.elements[e] === this.elements[t];
  }
  extendToFullLines(e) {
    var t, n;
    const r = (t = Py(this.firstCharOffsetByLine, (o) => o <= e.start)) !== null && t !== void 0 ? t : 0, s = (n = APe(this.firstCharOffsetByLine, (o) => e.endExclusive <= o)) !== null && n !== void 0 ? n : this.elements.length;
    return new zt(r, s);
  }
}
function S6(i) {
  return i >= 97 && i <= 122 || i >= 65 && i <= 90 || i >= 48 && i <= 57;
}
const KPe = {
  0: 0,
  1: 0,
  2: 0,
  3: 10,
  4: 2,
  5: 3,
  6: 10,
  7: 10
};
function qX(i) {
  return KPe[i];
}
function KX(i) {
  return i === 10 ? 7 : i === 13 ? 6 : bF(i) ? 5 : i >= 97 && i <= 122 ? 0 : i >= 65 && i <= 90 ? 1 : i >= 48 && i <= 57 ? 2 : i === -1 ? 3 : 4;
}
function YPe(i, e, t, n, r, s) {
  let { moves: o, excludedChanges: a } = XPe(i, e, t, s);
  if (!s.isValid())
    return [];
  const l = i.filter((d) => !a.has(d)), c = ZPe(l, n, r, e, t, s);
  return rR(o, c), o = QPe(o), o = o.filter((d) => d.original.toOffsetRange().slice(e).map((h) => h.trim()).join(`
`).length >= 10), o = JPe(i, o), o;
}
function XPe(i, e, t, n) {
  const r = [], s = i.filter((l) => l.modified.isEmpty && l.original.length >= 3).map((l) => new v_(l.original, e, l)), o = new Set(i.filter((l) => l.original.isEmpty && l.modified.length >= 3).map((l) => new v_(l.modified, t, l))), a = /* @__PURE__ */ new Set();
  for (const l of s) {
    let c = -1, d;
    for (const u of o) {
      const h = l.computeSimilarity(u);
      h > c && (c = h, d = u);
    }
    if (c > 0.9 && d && (o.delete(d), r.push(new wu(l.range, d.range)), a.add(l.source), a.add(d.source)), !n.isValid())
      return { moves: r, excludedChanges: a };
  }
  return { moves: r, excludedChanges: a };
}
function ZPe(i, e, t, n, r, s) {
  const o = [], a = new nz();
  for (const h of i)
    for (let f = h.original.startLineNumber; f < h.original.endLineNumberExclusive - 2; f++) {
      const g = `${e[f - 1]}:${e[f + 1 - 1]}:${e[f + 2 - 1]}`;
      a.add(g, { range: new Qt(f, f + 3) });
    }
  const l = [];
  i.sort(hl((h) => h.modified.startLineNumber, Rh));
  for (const h of i) {
    let f = [];
    for (let g = h.modified.startLineNumber; g < h.modified.endLineNumberExclusive - 2; g++) {
      const p = `${t[g - 1]}:${t[g + 1 - 1]}:${t[g + 2 - 1]}`, m = new Qt(g, g + 3), _ = [];
      a.forEach(p, ({ range: b }) => {
        for (const y of f)
          if (y.originalLineRange.endLineNumberExclusive + 1 === b.endLineNumberExclusive && y.modifiedLineRange.endLineNumberExclusive + 1 === m.endLineNumberExclusive) {
            y.originalLineRange = new Qt(y.originalLineRange.startLineNumber, b.endLineNumberExclusive), y.modifiedLineRange = new Qt(y.modifiedLineRange.startLineNumber, m.endLineNumberExclusive), _.push(y);
            return;
          }
        const w = {
          modifiedLineRange: m,
          originalLineRange: b
        };
        l.push(w), _.push(w);
      }), f = _;
    }
    if (!s.isValid())
      return [];
  }
  l.sort(Oue(hl((h) => h.modifiedLineRange.length, Rh)));
  const c = new jd(), d = new jd();
  for (const h of l) {
    const f = h.modifiedLineRange.startLineNumber - h.originalLineRange.startLineNumber, g = c.subtractFrom(h.modifiedLineRange), p = d.subtractFrom(h.originalLineRange).getWithDelta(f), m = g.getIntersection(p);
    for (const _ of m.ranges) {
      if (_.length < 3)
        continue;
      const b = _, w = _.delta(-f);
      o.push(new wu(w, b)), c.addRange(b), d.addRange(w);
    }
  }
  o.sort(hl((h) => h.original.startLineNumber, Rh));
  const u = new xS(i);
  for (let h = 0; h < o.length; h++) {
    const f = o[h], g = u.findLastMonotonous((x) => x.original.startLineNumber <= f.original.startLineNumber), p = Py(i, (x) => x.modified.startLineNumber <= f.modified.startLineNumber), m = Math.max(f.original.startLineNumber - g.original.startLineNumber, f.modified.startLineNumber - p.modified.startLineNumber), _ = u.findLastMonotonous((x) => x.original.startLineNumber < f.original.endLineNumberExclusive), b = Py(i, (x) => x.modified.startLineNumber < f.modified.endLineNumberExclusive), w = Math.max(_.original.endLineNumberExclusive - f.original.endLineNumberExclusive, b.modified.endLineNumberExclusive - f.modified.endLineNumberExclusive);
    let y;
    for (y = 0; y < m; y++) {
      const x = f.original.startLineNumber - y - 1, D = f.modified.startLineNumber - y - 1;
      if (x > n.length || D > r.length || c.contains(D) || d.contains(x) || !YX(n[x - 1], r[D - 1], s))
        break;
    }
    y > 0 && (d.addRange(new Qt(f.original.startLineNumber - y, f.original.startLineNumber)), c.addRange(new Qt(f.modified.startLineNumber - y, f.modified.startLineNumber)));
    let S;
    for (S = 0; S < w; S++) {
      const x = f.original.endLineNumberExclusive + S, D = f.modified.endLineNumberExclusive + S;
      if (x > n.length || D > r.length || c.contains(D) || d.contains(x) || !YX(n[x - 1], r[D - 1], s))
        break;
    }
    S > 0 && (d.addRange(new Qt(f.original.endLineNumberExclusive, f.original.endLineNumberExclusive + S)), c.addRange(new Qt(f.modified.endLineNumberExclusive, f.modified.endLineNumberExclusive + S))), (y > 0 || S > 0) && (o[h] = new wu(new Qt(f.original.startLineNumber - y, f.original.endLineNumberExclusive + S), new Qt(f.modified.startLineNumber - y, f.modified.endLineNumberExclusive + S)));
  }
  return o;
}
function YX(i, e, t) {
  if (i.trim() === e.trim())
    return !0;
  if (i.length > 300 && e.length > 300)
    return !1;
  const r = new pfe().compute(new oL([i], new zt(0, 1), !1), new oL([e], new zt(0, 1), !1), t);
  let s = 0;
  const o = ns.invert(r.diffs, i.length);
  for (const d of o)
    d.seq1Range.forEach((u) => {
      bF(i.charCodeAt(u)) || s++;
    });
  function a(d) {
    let u = 0;
    for (let h = 0; h < i.length; h++)
      bF(d.charCodeAt(h)) || u++;
    return u;
  }
  const l = a(i.length > e.length ? i : e);
  return s / l > 0.6 && l > 10;
}
function QPe(i) {
  if (i.length === 0)
    return i;
  i.sort(hl((t) => t.original.startLineNumber, Rh));
  const e = [i[0]];
  for (let t = 1; t < i.length; t++) {
    const n = e[e.length - 1], r = i[t], s = r.original.startLineNumber - n.original.endLineNumberExclusive, o = r.modified.startLineNumber - n.modified.endLineNumberExclusive;
    if (s >= 0 && o >= 0 && s + o <= 2) {
      e[e.length - 1] = n.join(r);
      continue;
    }
    e.push(r);
  }
  return e;
}
function JPe(i, e) {
  const t = new xS(i);
  return e = e.filter((n) => {
    const r = t.findLastMonotonous((a) => a.original.endLineNumberExclusive < n.original.endLineNumberExclusive) || new wu(new Qt(1, 1), new Qt(1, 1)), s = Py(i, (a) => a.modified.endLineNumberExclusive < n.modified.endLineNumberExclusive);
    return r !== s;
  }), e;
}
function CF(i, e, t) {
  let n = t;
  return n = $Pe(i, e, n), n = eOe(i, e, n), n;
}
function $Pe(i, e, t) {
  if (t.length === 0)
    return t;
  const n = [];
  n.push(t[0]);
  for (let s = 1; s < t.length; s++) {
    const o = n[n.length - 1];
    let a = t[s];
    if (a.seq1Range.isEmpty || a.seq2Range.isEmpty) {
      const l = a.seq1Range.start - o.seq1Range.endExclusive;
      let c;
      for (c = 1; c <= l && !(i.getElement(a.seq1Range.start - c) !== i.getElement(a.seq1Range.endExclusive - c) || e.getElement(a.seq2Range.start - c) !== e.getElement(a.seq2Range.endExclusive - c)); c++)
        ;
      if (c--, c === l) {
        n[n.length - 1] = new ns(new zt(o.seq1Range.start, a.seq1Range.endExclusive - l), new zt(o.seq2Range.start, a.seq2Range.endExclusive - l));
        continue;
      }
      a = a.delta(-c);
    }
    n.push(a);
  }
  const r = [];
  for (let s = 0; s < n.length - 1; s++) {
    const o = n[s + 1];
    let a = n[s];
    if (a.seq1Range.isEmpty || a.seq2Range.isEmpty) {
      const l = o.seq1Range.start - a.seq1Range.endExclusive;
      let c;
      for (c = 0; c < l && !(!i.isStronglyEqual(a.seq1Range.start + c, a.seq1Range.endExclusive + c) || !e.isStronglyEqual(a.seq2Range.start + c, a.seq2Range.endExclusive + c)); c++)
        ;
      if (c === l) {
        n[s + 1] = new ns(new zt(a.seq1Range.start + l, o.seq1Range.endExclusive), new zt(a.seq2Range.start + l, o.seq2Range.endExclusive));
        continue;
      }
      c > 0 && (a = a.delta(c));
    }
    r.push(a);
  }
  return n.length > 0 && r.push(n[n.length - 1]), r;
}
function eOe(i, e, t) {
  if (!i.getBoundaryScore || !e.getBoundaryScore)
    return t;
  for (let n = 0; n < t.length; n++) {
    const r = n > 0 ? t[n - 1] : void 0, s = t[n], o = n + 1 < t.length ? t[n + 1] : void 0, a = new zt(r ? r.seq1Range.start + 1 : 0, o ? o.seq1Range.endExclusive - 1 : i.length), l = new zt(r ? r.seq2Range.start + 1 : 0, o ? o.seq2Range.endExclusive - 1 : e.length);
    s.seq1Range.isEmpty ? t[n] = XX(s, i, e, a, l) : s.seq2Range.isEmpty && (t[n] = XX(s.swap(), e, i, l, a).swap());
  }
  return t;
}
function XX(i, e, t, n, r) {
  let o = 1;
  for (; i.seq1Range.start - o >= n.start && i.seq2Range.start - o >= r.start && t.isStronglyEqual(i.seq2Range.start - o, i.seq2Range.endExclusive - o) && o < 100; )
    o++;
  o--;
  let a = 0;
  for (; i.seq1Range.start + a < n.endExclusive && i.seq2Range.endExclusive + a < r.endExclusive && t.isStronglyEqual(i.seq2Range.start + a, i.seq2Range.endExclusive + a) && a < 100; )
    a++;
  if (o === 0 && a === 0)
    return i;
  let l = 0, c = -1;
  for (let d = -o; d <= a; d++) {
    const u = i.seq2Range.start + d, h = i.seq2Range.endExclusive + d, f = i.seq1Range.start + d, g = e.getBoundaryScore(f) + t.getBoundaryScore(u) + t.getBoundaryScore(h);
    g > c && (c = g, l = d);
  }
  return i.delta(l);
}
function tOe(i, e, t) {
  const n = [];
  for (const r of t) {
    const s = n[n.length - 1];
    if (!s) {
      n.push(r);
      continue;
    }
    r.seq1Range.start - s.seq1Range.endExclusive <= 2 || r.seq2Range.start - s.seq2Range.endExclusive <= 2 ? n[n.length - 1] = new ns(s.seq1Range.join(r.seq1Range), s.seq2Range.join(r.seq2Range)) : n.push(r);
  }
  return n;
}
function nOe(i, e, t) {
  const n = [];
  let r;
  function s() {
    if (!r)
      return;
    const a = r.s1Range.length - r.deleted;
    r.s2Range.length - r.added, Math.max(r.deleted, r.added) + (r.count - 1) > a && n.push(new ns(r.s1Range, r.s2Range)), r = void 0;
  }
  for (const a of t) {
    let l = function(f, g) {
      var p, m, _, b;
      if (!r || !r.s1Range.containsRange(f) || !r.s2Range.containsRange(g))
        if (r && !(r.s1Range.endExclusive < f.start && r.s2Range.endExclusive < g.start)) {
          const S = zt.tryCreate(r.s1Range.endExclusive, f.start), x = zt.tryCreate(r.s2Range.endExclusive, g.start);
          r.deleted += (p = S?.length) !== null && p !== void 0 ? p : 0, r.added += (m = x?.length) !== null && m !== void 0 ? m : 0, r.s1Range = r.s1Range.join(f), r.s2Range = r.s2Range.join(g);
        } else
          s(), r = { added: 0, deleted: 0, count: 0, s1Range: f, s2Range: g };
      const w = f.intersect(a.seq1Range), y = g.intersect(a.seq2Range);
      r.count++, r.deleted += (_ = w?.length) !== null && _ !== void 0 ? _ : 0, r.added += (b = y?.length) !== null && b !== void 0 ? b : 0;
    };
    const c = i.findWordContaining(a.seq1Range.start - 1), d = e.findWordContaining(a.seq2Range.start - 1), u = i.findWordContaining(a.seq1Range.endExclusive), h = e.findWordContaining(a.seq2Range.endExclusive);
    c && u && d && h && c.equals(u) && d.equals(h) ? l(c, d) : (c && d && l(c, d), u && h && l(u, h));
  }
  return s(), iOe(t, n);
}
function iOe(i, e) {
  const t = [];
  for (; i.length > 0 || e.length > 0; ) {
    const n = i[0], r = e[0];
    let s;
    n && (!r || n.seq1Range.start < r.seq1Range.start) ? s = i.shift() : s = e.shift(), t.length > 0 && t[t.length - 1].seq1Range.endExclusive >= s.seq1Range.start ? t[t.length - 1] = t[t.length - 1].join(s) : t.push(s);
  }
  return t;
}
function rOe(i, e, t) {
  let n = t;
  if (n.length === 0)
    return n;
  let r = 0, s;
  do {
    s = !1;
    const o = [
      n[0]
    ];
    for (let a = 1; a < n.length; a++) {
      let d = function(h, f) {
        const g = new zt(c.seq1Range.endExclusive, l.seq1Range.start);
        return i.getText(g).replace(/\s/g, "").length <= 4 && (h.seq1Range.length + h.seq2Range.length > 5 || f.seq1Range.length + f.seq2Range.length > 5);
      };
      const l = n[a], c = o[o.length - 1];
      d(c, l) ? (s = !0, o[o.length - 1] = o[o.length - 1].join(l)) : o.push(l);
    }
    n = o;
  } while (r++ < 10 && s);
  return n;
}
function sOe(i, e, t) {
  let n = t;
  if (n.length === 0)
    return n;
  let r = 0, s;
  do {
    s = !1;
    const a = [
      n[0]
    ];
    for (let l = 1; l < n.length; l++) {
      let u = function(f, g) {
        const p = new zt(d.seq1Range.endExclusive, c.seq1Range.start);
        if (i.countLinesIn(p) > 5 || p.length > 500)
          return !1;
        const _ = i.getText(p).trim();
        if (_.length > 20 || _.split(/\r\n|\r|\n/).length > 1)
          return !1;
        const b = i.countLinesIn(f.seq1Range), w = f.seq1Range.length, y = e.countLinesIn(f.seq2Range), S = f.seq2Range.length, x = i.countLinesIn(g.seq1Range), D = g.seq1Range.length, E = e.countLinesIn(g.seq2Range), L = g.seq2Range.length, k = 2 * 40 + 50;
        function N(I) {
          return Math.min(I, k);
        }
        return Math.pow(Math.pow(N(b * 40 + w), 1.5) + Math.pow(N(y * 40 + S), 1.5), 1.5) + Math.pow(Math.pow(N(x * 40 + D), 1.5) + Math.pow(N(E * 40 + L), 1.5), 1.5) > Math.pow(Math.pow(k, 1.5), 1.5) * 1.3;
      };
      const c = n[l], d = a[a.length - 1];
      u(d, c) ? (s = !0, a[a.length - 1] = a[a.length - 1].join(c)) : a.push(c);
    }
    n = a;
  } while (r++ < 10 && s);
  const o = [];
  return p6e(n, (a, l, c) => {
    let d = l;
    function u(_) {
      return _.length > 0 && _.trim().length <= 3 && l.seq1Range.length + l.seq2Range.length > 100;
    }
    const h = i.extendToFullLines(l.seq1Range), f = i.getText(new zt(h.start, l.seq1Range.start));
    u(f) && (d = d.deltaStart(-f.length));
    const g = i.getText(new zt(l.seq1Range.endExclusive, h.endExclusive));
    u(g) && (d = d.deltaEnd(g.length));
    const p = ns.fromOffsetPairs(a ? a.getEndExclusives() : Xd.zero, c ? c.getStarts() : Xd.max), m = d.intersect(p);
    o.push(m);
  }), o;
}
class ZX {
  constructor(e, t) {
    this.trimmedHash = e, this.lines = t;
  }
  getElement(e) {
    return this.trimmedHash[e];
  }
  get length() {
    return this.trimmedHash.length;
  }
  getBoundaryScore(e) {
    const t = e === 0 ? 0 : QX(this.lines[e - 1]), n = e === this.lines.length ? 0 : QX(this.lines[e]);
    return 1e3 - (t + n);
  }
  getText(e) {
    return this.lines.slice(e.start, e.endExclusive).join(`
`);
  }
  isStronglyEqual(e, t) {
    return this.lines[e] === this.lines[t];
  }
}
function QX(i) {
  let e = 0;
  for (; e < i.length && (i.charCodeAt(e) === 32 || i.charCodeAt(e) === 9); )
    e++;
  return e;
}
class mfe {
  constructor() {
    this.dynamicProgrammingDiffing = new HPe(), this.myersDiffingAlgorithm = new pfe();
  }
  computeDiff(e, t, n) {
    if (e.length <= 1 && Qi(e, t, (S, x) => S === x))
      return new F3([], [], !1);
    if (e.length === 1 && e[0].length === 0 || t.length === 1 && t[0].length === 0)
      return new F3([
        new Sl(new Qt(1, e.length + 1), new Qt(1, t.length + 1), [
          new Bg(new V(1, 1, e.length, e[0].length + 1), new V(1, 1, t.length, t[0].length + 1))
        ])
      ], [], !1);
    const r = n.maxComputationTimeMs === 0 ? Ry.instance : new VPe(n.maxComputationTimeMs), s = !n.ignoreTrimWhitespace, o = /* @__PURE__ */ new Map();
    function a(S) {
      let x = o.get(S);
      return x === void 0 && (x = o.size, o.set(S, x)), x;
    }
    const l = e.map((S) => a(S.trim())), c = t.map((S) => a(S.trim())), d = new ZX(l, e), u = new ZX(c, t), h = d.length + u.length < 1700 ? this.dynamicProgrammingDiffing.compute(d, u, r, (S, x) => e[S] === t[x] ? t[x].length === 0 ? 0.1 : 1 + Math.log(1 + t[x].length) : 0.99) : this.myersDiffingAlgorithm.compute(d, u);
    let f = h.diffs, g = h.hitTimeout;
    f = CF(d, u, f), f = rOe(d, u, f);
    const p = [], m = (S) => {
      if (s)
        for (let x = 0; x < S; x++) {
          const D = _ + x, E = b + x;
          if (e[D] !== t[E]) {
            const L = this.refineDiff(e, t, new ns(new zt(D, D + 1), new zt(E, E + 1)), r, s);
            for (const k of L.mappings)
              p.push(k);
            L.hitTimeout && (g = !0);
          }
        }
    };
    let _ = 0, b = 0;
    for (const S of f) {
      Iy(() => S.seq1Range.start - _ === S.seq2Range.start - b);
      const x = S.seq1Range.start - _;
      m(x), _ = S.seq1Range.endExclusive, b = S.seq2Range.endExclusive;
      const D = this.refineDiff(e, t, S, r, s);
      D.hitTimeout && (g = !0);
      for (const E of D.mappings)
        p.push(E);
    }
    m(e.length - _);
    const w = JX(p, e, t);
    let y = [];
    return n.computeMoves && (y = this.computeMoves(w, e, t, l, c, r, s)), Iy(() => {
      function S(D, E) {
        if (D.lineNumber < 1 || D.lineNumber > E.length)
          return !1;
        const L = E[D.lineNumber - 1];
        return !(D.column < 1 || D.column > L.length + 1);
      }
      function x(D, E) {
        return !(D.startLineNumber < 1 || D.startLineNumber > E.length + 1 || D.endLineNumberExclusive < 1 || D.endLineNumberExclusive > E.length + 1);
      }
      for (const D of w) {
        if (!D.innerChanges)
          return !1;
        for (const E of D.innerChanges)
          if (!(S(E.modifiedRange.getStartPosition(), t) && S(E.modifiedRange.getEndPosition(), t) && S(E.originalRange.getStartPosition(), e) && S(E.originalRange.getEndPosition(), e)))
            return !1;
        if (!x(D.modified, t) || !x(D.original, e))
          return !1;
      }
      return !0;
    }), new F3(w, y, g);
  }
  computeMoves(e, t, n, r, s, o, a) {
    return YPe(e, t, n, r, s, o).map((d) => {
      const u = this.refineDiff(t, n, new ns(d.original.toOffsetRange(), d.modified.toOffsetRange()), o, a), h = JX(u.mappings, t, n, !0);
      return new hfe(d, h);
    });
  }
  refineDiff(e, t, n, r, s) {
    const o = new oL(e, n.seq1Range, s), a = new oL(t, n.seq2Range, s), l = o.length + a.length < 500 ? this.dynamicProgrammingDiffing.compute(o, a, r) : this.myersDiffingAlgorithm.compute(o, a, r);
    let c = l.diffs;
    return c = CF(o, a, c), c = nOe(o, a, c), c = tOe(o, a, c), c = sOe(o, a, c), {
      mappings: c.map((u) => new Bg(o.translateRange(u.seq1Range), a.translateRange(u.seq2Range))),
      hitTimeout: l.hitTimeout
    };
  }
}
function JX(i, e, t, n = !1) {
  const r = [];
  for (const s of Aue(i.map((o) => oOe(o, e, t)), (o, a) => o.original.overlapOrTouch(a.original) || o.modified.overlapOrTouch(a.modified))) {
    const o = s[0], a = s[s.length - 1];
    r.push(new Sl(o.original.join(a.original), o.modified.join(a.modified), s.map((l) => l.innerChanges[0])));
  }
  return Iy(() => !n && r.length > 0 && r[0].original.startLineNumber !== r[0].modified.startLineNumber ? !1 : xhe(r, (s, o) => o.original.startLineNumber - s.original.endLineNumberExclusive === o.modified.startLineNumber - s.modified.endLineNumberExclusive && // There has to be an unchanged line in between (otherwise both diffs should have been joined)
  s.original.endLineNumberExclusive < o.original.startLineNumber && s.modified.endLineNumberExclusive < o.modified.startLineNumber)), r;
}
function oOe(i, e, t) {
  let n = 0, r = 0;
  i.modifiedRange.endColumn === 1 && i.originalRange.endColumn === 1 && i.originalRange.startLineNumber + n <= i.originalRange.endLineNumber && i.modifiedRange.startLineNumber + n <= i.modifiedRange.endLineNumber && (r = -1), i.modifiedRange.startColumn - 1 >= t[i.modifiedRange.startLineNumber - 1].length && i.originalRange.startColumn - 1 >= e[i.originalRange.startLineNumber - 1].length && i.originalRange.startLineNumber <= i.originalRange.endLineNumber + r && i.modifiedRange.startLineNumber <= i.modifiedRange.endLineNumber + r && (n = 1);
  const s = new Qt(i.originalRange.startLineNumber + n, i.originalRange.endLineNumber + 1 + r), o = new Qt(i.modifiedRange.startLineNumber + n, i.modifiedRange.endLineNumber + 1 + r);
  return new Sl(s, o, [i]);
}
const $X = {
  getLegacy: () => new MPe(),
  getDefault: () => new mfe()
};
function gg(i, e) {
  const t = Math.pow(10, e);
  return Math.round(i * t) / t;
}
class rn {
  constructor(e, t, n, r = 1) {
    this._rgbaBrand = void 0, this.r = Math.min(255, Math.max(0, e)) | 0, this.g = Math.min(255, Math.max(0, t)) | 0, this.b = Math.min(255, Math.max(0, n)) | 0, this.a = gg(Math.max(Math.min(1, r), 0), 3);
  }
  static equals(e, t) {
    return e.r === t.r && e.g === t.g && e.b === t.b && e.a === t.a;
  }
}
class Wl {
  constructor(e, t, n, r) {
    this._hslaBrand = void 0, this.h = Math.max(Math.min(360, e), 0) | 0, this.s = gg(Math.max(Math.min(1, t), 0), 3), this.l = gg(Math.max(Math.min(1, n), 0), 3), this.a = gg(Math.max(Math.min(1, r), 0), 3);
  }
  static equals(e, t) {
    return e.h === t.h && e.s === t.s && e.l === t.l && e.a === t.a;
  }
  /**
   * Converts an RGB color value to HSL. Conversion formula
   * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
   * Assumes r, g, and b are contained in the set [0, 255] and
   * returns h in the set [0, 360], s, and l in the set [0, 1].
   */
  static fromRGBA(e) {
    const t = e.r / 255, n = e.g / 255, r = e.b / 255, s = e.a, o = Math.max(t, n, r), a = Math.min(t, n, r);
    let l = 0, c = 0;
    const d = (a + o) / 2, u = o - a;
    if (u > 0) {
      switch (c = Math.min(d <= 0.5 ? u / (2 * d) : u / (2 - 2 * d), 1), o) {
        case t:
          l = (n - r) / u + (n < r ? 6 : 0);
          break;
        case n:
          l = (r - t) / u + 2;
          break;
        case r:
          l = (t - n) / u + 4;
          break;
      }
      l *= 60, l = Math.round(l);
    }
    return new Wl(l, c, d, s);
  }
  static _hue2rgb(e, t, n) {
    return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
  }
  /**
   * Converts an HSL color value to RGB. Conversion formula
   * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
   * Assumes h in the set [0, 360] s, and l are contained in the set [0, 1] and
   * returns r, g, and b in the set [0, 255].
   */
  static toRGBA(e) {
    const t = e.h / 360, { s: n, l: r, a: s } = e;
    let o, a, l;
    if (n === 0)
      o = a = l = r;
    else {
      const c = r < 0.5 ? r * (1 + n) : r + n - r * n, d = 2 * r - c;
      o = Wl._hue2rgb(d, c, t + 1 / 3), a = Wl._hue2rgb(d, c, t), l = Wl._hue2rgb(d, c, t - 1 / 3);
    }
    return new rn(Math.round(o * 255), Math.round(a * 255), Math.round(l * 255), s);
  }
}
class Zd {
  constructor(e, t, n, r) {
    this._hsvaBrand = void 0, this.h = Math.max(Math.min(360, e), 0) | 0, this.s = gg(Math.max(Math.min(1, t), 0), 3), this.v = gg(Math.max(Math.min(1, n), 0), 3), this.a = gg(Math.max(Math.min(1, r), 0), 3);
  }
  static equals(e, t) {
    return e.h === t.h && e.s === t.s && e.v === t.v && e.a === t.a;
  }
  // from http://www.rapidtables.com/convert/color/rgb-to-hsv.htm
  static fromRGBA(e) {
    const t = e.r / 255, n = e.g / 255, r = e.b / 255, s = Math.max(t, n, r), o = Math.min(t, n, r), a = s - o, l = s === 0 ? 0 : a / s;
    let c;
    return a === 0 ? c = 0 : s === t ? c = ((n - r) / a % 6 + 6) % 6 : s === n ? c = (r - t) / a + 2 : c = (t - n) / a + 4, new Zd(Math.round(c * 60), l, s, e.a);
  }
  // from http://www.rapidtables.com/convert/color/hsv-to-rgb.htm
  static toRGBA(e) {
    const { h: t, s: n, v: r, a: s } = e, o = r * n, a = o * (1 - Math.abs(t / 60 % 2 - 1)), l = r - o;
    let [c, d, u] = [0, 0, 0];
    return t < 60 ? (c = o, d = a) : t < 120 ? (c = a, d = o) : t < 180 ? (d = o, u = a) : t < 240 ? (d = a, u = o) : t < 300 ? (c = a, u = o) : t <= 360 && (c = o, u = a), c = Math.round((c + l) * 255), d = Math.round((d + l) * 255), u = Math.round((u + l) * 255), new rn(c, d, u, s);
  }
}
class ye {
  static fromHex(e) {
    return ye.Format.CSS.parseHex(e) || ye.red;
  }
  static equals(e, t) {
    return !e && !t ? !0 : !e || !t ? !1 : e.equals(t);
  }
  get hsla() {
    return this._hsla ? this._hsla : Wl.fromRGBA(this.rgba);
  }
  get hsva() {
    return this._hsva ? this._hsva : Zd.fromRGBA(this.rgba);
  }
  constructor(e) {
    if (e)
      if (e instanceof rn)
        this.rgba = e;
      else if (e instanceof Wl)
        this._hsla = e, this.rgba = Wl.toRGBA(e);
      else if (e instanceof Zd)
        this._hsva = e, this.rgba = Zd.toRGBA(e);
      else
        throw new Error("Invalid color ctor argument");
    else throw new Error("Color needs a value");
  }
  equals(e) {
    return !!e && rn.equals(this.rgba, e.rgba) && Wl.equals(this.hsla, e.hsla) && Zd.equals(this.hsva, e.hsva);
  }
  /**
   * http://www.w3.org/TR/WCAG20/#relativeluminancedef
   * Returns the number in the set [0, 1]. O => Darkest Black. 1 => Lightest white.
   */
  getRelativeLuminance() {
    const e = ye._relativeLuminanceForComponent(this.rgba.r), t = ye._relativeLuminanceForComponent(this.rgba.g), n = ye._relativeLuminanceForComponent(this.rgba.b), r = 0.2126 * e + 0.7152 * t + 0.0722 * n;
    return gg(r, 4);
  }
  static _relativeLuminanceForComponent(e) {
    const t = e / 255;
    return t <= 0.03928 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
  }
  /**
   *	http://24ways.org/2010/calculating-color-contrast
   *  Return 'true' if lighter color otherwise 'false'
   */
  isLighter() {
    return (this.rgba.r * 299 + this.rgba.g * 587 + this.rgba.b * 114) / 1e3 >= 128;
  }
  isLighterThan(e) {
    const t = this.getRelativeLuminance(), n = e.getRelativeLuminance();
    return t > n;
  }
  isDarkerThan(e) {
    const t = this.getRelativeLuminance(), n = e.getRelativeLuminance();
    return t < n;
  }
  lighten(e) {
    return new ye(new Wl(this.hsla.h, this.hsla.s, this.hsla.l + this.hsla.l * e, this.hsla.a));
  }
  darken(e) {
    return new ye(new Wl(this.hsla.h, this.hsla.s, this.hsla.l - this.hsla.l * e, this.hsla.a));
  }
  transparent(e) {
    const { r: t, g: n, b: r, a: s } = this.rgba;
    return new ye(new rn(t, n, r, s * e));
  }
  isTransparent() {
    return this.rgba.a === 0;
  }
  isOpaque() {
    return this.rgba.a === 1;
  }
  opposite() {
    return new ye(new rn(255 - this.rgba.r, 255 - this.rgba.g, 255 - this.rgba.b, this.rgba.a));
  }
  makeOpaque(e) {
    if (this.isOpaque() || e.rgba.a !== 1)
      return this;
    const { r: t, g: n, b: r, a: s } = this.rgba;
    return new ye(new rn(e.rgba.r - s * (e.rgba.r - t), e.rgba.g - s * (e.rgba.g - n), e.rgba.b - s * (e.rgba.b - r), 1));
  }
  toString() {
    return this._toString || (this._toString = ye.Format.CSS.format(this)), this._toString;
  }
  static getLighterColor(e, t, n) {
    if (e.isLighterThan(t))
      return e;
    n = n || 0.5;
    const r = e.getRelativeLuminance(), s = t.getRelativeLuminance();
    return n = n * (s - r) / s, e.lighten(n);
  }
  static getDarkerColor(e, t, n) {
    if (e.isDarkerThan(t))
      return e;
    n = n || 0.5;
    const r = e.getRelativeLuminance(), s = t.getRelativeLuminance();
    return n = n * (r - s) / r, e.darken(n);
  }
}
ye.white = new ye(new rn(255, 255, 255, 1));
ye.black = new ye(new rn(0, 0, 0, 1));
ye.red = new ye(new rn(255, 0, 0, 1));
ye.blue = new ye(new rn(0, 0, 255, 1));
ye.green = new ye(new rn(0, 255, 0, 1));
ye.cyan = new ye(new rn(0, 255, 255, 1));
ye.lightgrey = new ye(new rn(211, 211, 211, 1));
ye.transparent = new ye(new rn(0, 0, 0, 0));
(function(i) {
  (function(e) {
    (function(t) {
      function n(f) {
        return f.rgba.a === 1 ? `rgb(${f.rgba.r}, ${f.rgba.g}, ${f.rgba.b})` : i.Format.CSS.formatRGBA(f);
      }
      t.formatRGB = n;
      function r(f) {
        return `rgba(${f.rgba.r}, ${f.rgba.g}, ${f.rgba.b}, ${+f.rgba.a.toFixed(2)})`;
      }
      t.formatRGBA = r;
      function s(f) {
        return f.hsla.a === 1 ? `hsl(${f.hsla.h}, ${(f.hsla.s * 100).toFixed(2)}%, ${(f.hsla.l * 100).toFixed(2)}%)` : i.Format.CSS.formatHSLA(f);
      }
      t.formatHSL = s;
      function o(f) {
        return `hsla(${f.hsla.h}, ${(f.hsla.s * 100).toFixed(2)}%, ${(f.hsla.l * 100).toFixed(2)}%, ${f.hsla.a.toFixed(2)})`;
      }
      t.formatHSLA = o;
      function a(f) {
        const g = f.toString(16);
        return g.length !== 2 ? "0" + g : g;
      }
      function l(f) {
        return `#${a(f.rgba.r)}${a(f.rgba.g)}${a(f.rgba.b)}`;
      }
      t.formatHex = l;
      function c(f, g = !1) {
        return g && f.rgba.a === 1 ? i.Format.CSS.formatHex(f) : `#${a(f.rgba.r)}${a(f.rgba.g)}${a(f.rgba.b)}${a(Math.round(f.rgba.a * 255))}`;
      }
      t.formatHexA = c;
      function d(f) {
        return f.isOpaque() ? i.Format.CSS.formatHex(f) : i.Format.CSS.formatRGBA(f);
      }
      t.format = d;
      function u(f) {
        const g = f.length;
        if (g === 0 || f.charCodeAt(0) !== 35)
          return null;
        if (g === 7) {
          const p = 16 * h(f.charCodeAt(1)) + h(f.charCodeAt(2)), m = 16 * h(f.charCodeAt(3)) + h(f.charCodeAt(4)), _ = 16 * h(f.charCodeAt(5)) + h(f.charCodeAt(6));
          return new i(new rn(p, m, _, 1));
        }
        if (g === 9) {
          const p = 16 * h(f.charCodeAt(1)) + h(f.charCodeAt(2)), m = 16 * h(f.charCodeAt(3)) + h(f.charCodeAt(4)), _ = 16 * h(f.charCodeAt(5)) + h(f.charCodeAt(6)), b = 16 * h(f.charCodeAt(7)) + h(f.charCodeAt(8));
          return new i(new rn(p, m, _, b / 255));
        }
        if (g === 4) {
          const p = h(f.charCodeAt(1)), m = h(f.charCodeAt(2)), _ = h(f.charCodeAt(3));
          return new i(new rn(16 * p + p, 16 * m + m, 16 * _ + _));
        }
        if (g === 5) {
          const p = h(f.charCodeAt(1)), m = h(f.charCodeAt(2)), _ = h(f.charCodeAt(3)), b = h(f.charCodeAt(4));
          return new i(new rn(16 * p + p, 16 * m + m, 16 * _ + _, (16 * b + b) / 255));
        }
        return null;
      }
      t.parseHex = u;
      function h(f) {
        switch (f) {
          case 48:
            return 0;
          case 49:
            return 1;
          case 50:
            return 2;
          case 51:
            return 3;
          case 52:
            return 4;
          case 53:
            return 5;
          case 54:
            return 6;
          case 55:
            return 7;
          case 56:
            return 8;
          case 57:
            return 9;
          case 97:
            return 10;
          case 65:
            return 10;
          case 98:
            return 11;
          case 66:
            return 11;
          case 99:
            return 12;
          case 67:
            return 12;
          case 100:
            return 13;
          case 68:
            return 13;
          case 101:
            return 14;
          case 69:
            return 14;
          case 102:
            return 15;
          case 70:
            return 15;
        }
        return 0;
      }
    })(e.CSS || (e.CSS = {}));
  })(i.Format || (i.Format = {}));
})(ye || (ye = {}));
function vfe(i) {
  const e = [];
  for (const t of i) {
    const n = Number(t);
    (n || n === 0 && t.replace(/\s/g, "") !== "") && e.push(n);
  }
  return e;
}
function iz(i, e, t, n) {
  return {
    red: i / 255,
    blue: t / 255,
    green: e / 255,
    alpha: n
  };
}
function n2(i, e) {
  const t = e.index, n = e[0].length;
  if (!t)
    return;
  const r = i.positionAt(t);
  return {
    startLineNumber: r.lineNumber,
    startColumn: r.column,
    endLineNumber: r.lineNumber,
    endColumn: r.column + n
  };
}
function aOe(i, e) {
  if (!i)
    return;
  const t = ye.Format.CSS.parseHex(e);
  if (t)
    return {
      range: i,
      color: iz(t.rgba.r, t.rgba.g, t.rgba.b, t.rgba.a)
    };
}
function eZ(i, e, t) {
  if (!i || e.length !== 1)
    return;
  const r = e[0].values(), s = vfe(r);
  return {
    range: i,
    color: iz(s[0], s[1], s[2], t ? s[3] : 1)
  };
}
function tZ(i, e, t) {
  if (!i || e.length !== 1)
    return;
  const r = e[0].values(), s = vfe(r), o = new ye(new Wl(s[0], s[1] / 100, s[2] / 100, t ? s[3] : 1));
  return {
    range: i,
    color: iz(o.rgba.r, o.rgba.g, o.rgba.b, o.rgba.a)
  };
}
function i2(i, e) {
  return typeof i == "string" ? [...i.matchAll(e)] : i.findMatches(e);
}
function lOe(i) {
  const e = [], n = i2(i, /\b(rgb|rgba|hsl|hsla)(\([0-9\s,.\%]*\))|(#)([A-Fa-f0-9]{3})\b|(#)([A-Fa-f0-9]{4})\b|(#)([A-Fa-f0-9]{6})\b|(#)([A-Fa-f0-9]{8})\b/gm);
  if (n.length > 0)
    for (const r of n) {
      const s = r.filter((c) => c !== void 0), o = s[1], a = s[2];
      if (!a)
        continue;
      let l;
      if (o === "rgb") {
        const c = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*\)$/gm;
        l = eZ(n2(i, r), i2(a, c), !1);
      } else if (o === "rgba") {
        const c = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
        l = eZ(n2(i, r), i2(a, c), !0);
      } else if (o === "hsl") {
        const c = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*\)$/gm;
        l = tZ(n2(i, r), i2(a, c), !1);
      } else if (o === "hsla") {
        const c = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
        l = tZ(n2(i, r), i2(a, c), !0);
      } else o === "#" && (l = aOe(n2(i, r), o + a));
      l && e.push(l);
    }
  return e;
}
function cOe(i) {
  return !i || typeof i.getValue != "function" || typeof i.positionAt != "function" ? [] : lOe(i);
}
var bf = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class dOe extends uPe {
  get uri() {
    return this._uri;
  }
  get eol() {
    return this._eol;
  }
  getValue() {
    return this.getText();
  }
  findMatches(e) {
    const t = [];
    for (let n = 0; n < this._lines.length; n++) {
      const r = this._lines[n], s = this.offsetAt(new ve(n + 1, 1)), o = r.matchAll(e);
      for (const a of o)
        (a.index || a.index === 0) && (a.index = a.index + s), t.push(a);
    }
    return t;
  }
  getLinesContent() {
    return this._lines.slice(0);
  }
  getLineCount() {
    return this._lines.length;
  }
  getLineContent(e) {
    return this._lines[e - 1];
  }
  getWordAtPosition(e, t) {
    const n = yy(e.column, Uue(t), this._lines[e.lineNumber - 1], 0);
    return n ? new V(e.lineNumber, n.startColumn, e.lineNumber, n.endColumn) : null;
  }
  words(e) {
    const t = this._lines, n = this._wordenize.bind(this);
    let r = 0, s = "", o = 0, a = [];
    return {
      *[Symbol.iterator]() {
        for (; ; )
          if (o < a.length) {
            const l = s.substring(a[o].start, a[o].end);
            o += 1, yield l;
          } else if (r < t.length)
            s = t[r], a = n(s, e), o = 0, r += 1;
          else
            break;
      }
    };
  }
  getLineWords(e, t) {
    const n = this._lines[e - 1], r = this._wordenize(n, t), s = [];
    for (const o of r)
      s.push({
        word: n.substring(o.start, o.end),
        startColumn: o.start + 1,
        endColumn: o.end + 1
      });
    return s;
  }
  _wordenize(e, t) {
    const n = [];
    let r;
    for (t.lastIndex = 0; (r = t.exec(e)) && r[0].length !== 0; )
      n.push({ start: r.index, end: r.index + r[0].length });
    return n;
  }
  getValueInRange(e) {
    if (e = this._validateRange(e), e.startLineNumber === e.endLineNumber)
      return this._lines[e.startLineNumber - 1].substring(e.startColumn - 1, e.endColumn - 1);
    const t = this._eol, n = e.startLineNumber - 1, r = e.endLineNumber - 1, s = [];
    s.push(this._lines[n].substring(e.startColumn - 1));
    for (let o = n + 1; o < r; o++)
      s.push(this._lines[o]);
    return s.push(this._lines[r].substring(0, e.endColumn - 1)), s.join(t);
  }
  offsetAt(e) {
    return e = this._validatePosition(e), this._ensureLineStarts(), this._lineStarts.getPrefixSum(e.lineNumber - 2) + (e.column - 1);
  }
  positionAt(e) {
    e = Math.floor(e), e = Math.max(0, e), this._ensureLineStarts();
    const t = this._lineStarts.getIndexOf(e), n = this._lines[t.index].length;
    return {
      lineNumber: 1 + t.index,
      column: 1 + Math.min(t.remainder, n)
    };
  }
  _validateRange(e) {
    const t = this._validatePosition({ lineNumber: e.startLineNumber, column: e.startColumn }), n = this._validatePosition({ lineNumber: e.endLineNumber, column: e.endColumn });
    return t.lineNumber !== e.startLineNumber || t.column !== e.startColumn || n.lineNumber !== e.endLineNumber || n.column !== e.endColumn ? {
      startLineNumber: t.lineNumber,
      startColumn: t.column,
      endLineNumber: n.lineNumber,
      endColumn: n.column
    } : e;
  }
  _validatePosition(e) {
    if (!ve.isIPosition(e))
      throw new Error("bad position");
    let { lineNumber: t, column: n } = e, r = !1;
    if (t < 1)
      t = 1, n = 1, r = !0;
    else if (t > this._lines.length)
      t = this._lines.length, n = this._lines[t - 1].length + 1, r = !0;
    else {
      const s = this._lines[t - 1].length + 1;
      n < 1 ? (n = 1, r = !0) : n > s && (n = s, r = !0);
    }
    return r ? { lineNumber: t, column: n } : e;
  }
}
class pg {
  constructor(e, t) {
    this._host = e, this._models = /* @__PURE__ */ Object.create(null), this._foreignModuleFactory = t, this._foreignModule = null;
  }
  dispose() {
    this._models = /* @__PURE__ */ Object.create(null);
  }
  _getModel(e) {
    return this._models[e];
  }
  _getModels() {
    const e = [];
    return Object.keys(this._models).forEach((t) => e.push(this._models[t])), e;
  }
  acceptNewModel(e) {
    this._models[e.url] = new dOe(pt.parse(e.url), e.lines, e.EOL, e.versionId);
  }
  acceptModelChanged(e, t) {
    if (!this._models[e])
      return;
    this._models[e].onEvents(t);
  }
  acceptRemovedModel(e) {
    this._models[e] && delete this._models[e];
  }
  computeUnicodeHighlights(e, t, n) {
    return bf(this, void 0, void 0, function* () {
      const r = this._getModel(e);
      return r ? ez.computeUnicodeHighlights(r, t, n) : { ranges: [], hasMore: !1, ambiguousCharacterCount: 0, invisibleCharacterCount: 0, nonBasicAsciiCharacterCount: 0 };
    });
  }
  // ---- BEGIN diff --------------------------------------------------------------------------
  computeDiff(e, t, n, r) {
    return bf(this, void 0, void 0, function* () {
      const s = this._getModel(e), o = this._getModel(t);
      return !s || !o ? null : pg.computeDiff(s, o, n, r);
    });
  }
  static computeDiff(e, t, n, r) {
    const s = r === "advanced" ? $X.getDefault() : $X.getLegacy(), o = e.getLinesContent(), a = t.getLinesContent(), l = s.computeDiff(o, a, n), c = l.changes.length > 0 ? !1 : this._modelsAreIdentical(e, t);
    function d(u) {
      return u.map((h) => {
        var f;
        return [h.original.startLineNumber, h.original.endLineNumberExclusive, h.modified.startLineNumber, h.modified.endLineNumberExclusive, (f = h.innerChanges) === null || f === void 0 ? void 0 : f.map((g) => [
          g.originalRange.startLineNumber,
          g.originalRange.startColumn,
          g.originalRange.endLineNumber,
          g.originalRange.endColumn,
          g.modifiedRange.startLineNumber,
          g.modifiedRange.startColumn,
          g.modifiedRange.endLineNumber,
          g.modifiedRange.endColumn
        ])];
      });
    }
    return {
      identical: c,
      quitEarly: l.hitTimeout,
      changes: d(l.changes),
      moves: l.moves.map((u) => [
        u.lineRangeMapping.original.startLineNumber,
        u.lineRangeMapping.original.endLineNumberExclusive,
        u.lineRangeMapping.modified.startLineNumber,
        u.lineRangeMapping.modified.endLineNumberExclusive,
        d(u.changes)
      ])
    };
  }
  static _modelsAreIdentical(e, t) {
    const n = e.getLineCount(), r = t.getLineCount();
    if (n !== r)
      return !1;
    for (let s = 1; s <= n; s++) {
      const o = e.getLineContent(s), a = t.getLineContent(s);
      if (o !== a)
        return !1;
    }
    return !0;
  }
  computeMoreMinimalEdits(e, t, n) {
    return bf(this, void 0, void 0, function* () {
      const r = this._getModel(e);
      if (!r)
        return t;
      const s = [];
      let o;
      t = t.slice(0).sort((l, c) => {
        if (l.range && c.range)
          return V.compareRangesUsingStarts(l.range, c.range);
        const d = l.range ? 0 : 1, u = c.range ? 0 : 1;
        return d - u;
      });
      let a = 0;
      for (let l = 1; l < t.length; l++)
        V.getEndPosition(t[a].range).equals(V.getStartPosition(t[l].range)) ? (t[a].range = V.fromPositions(V.getStartPosition(t[a].range), V.getEndPosition(t[l].range)), t[a].text += t[l].text) : (a++, t[a] = t[l]);
      t.length = a + 1;
      for (let { range: l, text: c, eol: d } of t) {
        if (typeof d == "number" && (o = d), V.isEmpty(l) && !c)
          continue;
        const u = r.getValueInRange(l);
        if (c = c.replace(/\r\n|\n|\r/g, r.eol), u === c)
          continue;
        if (Math.max(c.length, u.length) > pg._diffLimit) {
          s.push({ range: l, text: c });
          continue;
        }
        const h = lPe(u, c, n), f = r.offsetAt(V.lift(l).getStartPosition());
        for (const g of h) {
          const p = r.positionAt(f + g.originalStart), m = r.positionAt(f + g.originalStart + g.originalLength), _ = {
            text: c.substr(g.modifiedStart, g.modifiedLength),
            range: { startLineNumber: p.lineNumber, startColumn: p.column, endLineNumber: m.lineNumber, endColumn: m.column }
          };
          r.getValueInRange(_.range) !== _.text && s.push(_);
        }
      }
      return typeof o == "number" && s.push({ eol: o, text: "", range: { startLineNumber: 0, startColumn: 0, endLineNumber: 0, endColumn: 0 } }), s;
    });
  }
  // ---- END minimal edits ---------------------------------------------------------------
  computeLinks(e) {
    return bf(this, void 0, void 0, function* () {
      const t = this._getModel(e);
      return t ? mPe(t) : null;
    });
  }
  // --- BEGIN default document colors -----------------------------------------------------------
  computeDefaultDocumentColors(e) {
    return bf(this, void 0, void 0, function* () {
      const t = this._getModel(e);
      return t ? cOe(t) : null;
    });
  }
  textualSuggest(e, t, n, r) {
    return bf(this, void 0, void 0, function* () {
      const s = new Vs(), o = new RegExp(n, r), a = /* @__PURE__ */ new Set();
      e: for (const l of e) {
        const c = this._getModel(l);
        if (c) {
          for (const d of c.words(o))
            if (!(d === t || !isNaN(Number(d))) && (a.add(d), a.size > pg._suggestionsLimit))
              break e;
        }
      }
      return { words: Array.from(a), duration: s.elapsed() };
    });
  }
  // ---- END suggest --------------------------------------------------------------------------
  //#region -- word ranges --
  computeWordRanges(e, t, n, r) {
    return bf(this, void 0, void 0, function* () {
      const s = this._getModel(e);
      if (!s)
        return /* @__PURE__ */ Object.create(null);
      const o = new RegExp(n, r), a = /* @__PURE__ */ Object.create(null);
      for (let l = t.startLineNumber; l < t.endLineNumber; l++) {
        const c = s.getLineWords(l, o);
        for (const d of c) {
          if (!isNaN(Number(d.word)))
            continue;
          let u = a[d.word];
          u || (u = [], a[d.word] = u), u.push({
            startLineNumber: l,
            startColumn: d.startColumn,
            endLineNumber: l,
            endColumn: d.endColumn
          });
        }
      }
      return a;
    });
  }
  //#endregion
  navigateValueSet(e, t, n, r, s) {
    return bf(this, void 0, void 0, function* () {
      const o = this._getModel(e);
      if (!o)
        return null;
      const a = new RegExp(r, s);
      t.startColumn === t.endColumn && (t = {
        startLineNumber: t.startLineNumber,
        startColumn: t.startColumn,
        endLineNumber: t.endLineNumber,
        endColumn: t.endColumn + 1
      });
      const l = o.getValueInRange(t), c = o.getWordAtPosition({ lineNumber: t.startLineNumber, column: t.startColumn }, a);
      if (!c)
        return null;
      const d = o.getValueInRange(c);
      return mF.INSTANCE.navigateValueSet(t, l, c, d, n);
    });
  }
  // ---- BEGIN foreign module support --------------------------------------------------------------------------
  loadForeignModule(e, t, n) {
    const o = {
      host: x6e(n, (a, l) => this._host.fhr(a, l)),
      getMirrorModels: () => this._getModels()
    };
    return this._foreignModuleFactory ? (this._foreignModule = this._foreignModuleFactory(o, t), Promise.resolve(Dj(this._foreignModule))) : Promise.reject(new Error("Unexpected usage"));
  }
  // foreign method request
  fmr(e, t) {
    if (!this._foreignModule || typeof this._foreignModule[e] != "function")
      return Promise.reject(new Error("Missing requestHandler or method: " + e));
    try {
      return Promise.resolve(this._foreignModule[e].apply(this._foreignModule, t));
    } catch (n) {
      return Promise.reject(n);
    }
  }
}
pg._diffLimit = 1e5;
pg._suggestionsLimit = 1e4;
typeof importScripts == "function" && (globalThis.monaco = che());
const rz = Gt("textResourceConfigurationService"), _fe = Gt("textResourcePropertiesService"), tt = Gt("ILanguageFeaturesService");
var uOe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, r2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, aL = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const nZ = 60 * 1e3, iZ = 5 * 60 * 1e3;
function Xp(i, e) {
  const t = i.getModel(e);
  return !(!t || t.isTooLargeForSyncing());
}
let yF = class extends we {
  constructor(e, t, n, r, s) {
    super(), this._modelService = e, this._workerManager = this._register(new fOe(this._modelService, r)), this._logService = n, this._register(s.linkProvider.register({ language: "*", hasAccessToAllModels: !0 }, {
      provideLinks: (o, a) => Xp(this._modelService, o.uri) ? this._workerManager.withWorker().then((l) => l.computeLinks(o.uri)).then((l) => l && { links: l }) : Promise.resolve({ links: [] })
    })), this._register(s.completionProvider.register("*", new hOe(this._workerManager, t, this._modelService, r)));
  }
  dispose() {
    super.dispose();
  }
  canComputeUnicodeHighlights(e) {
    return Xp(this._modelService, e);
  }
  computedUnicodeHighlights(e, t, n) {
    return this._workerManager.withWorker().then((r) => r.computedUnicodeHighlights(e, t, n));
  }
  computeDiff(e, t, n, r) {
    return aL(this, void 0, void 0, function* () {
      const s = yield this._workerManager.withWorker().then((l) => l.computeDiff(e, t, n, r));
      if (!s)
        return null;
      return {
        identical: s.identical,
        quitEarly: s.quitEarly,
        changes: a(s.changes),
        moves: s.moves.map((l) => new hfe(new wu(new Qt(l[0], l[1]), new Qt(l[2], l[3])), a(l[4])))
      };
      function a(l) {
        return l.map((c) => {
          var d;
          return new Sl(new Qt(c[0], c[1]), new Qt(c[2], c[3]), (d = c[4]) === null || d === void 0 ? void 0 : d.map((u) => new Bg(new V(u[0], u[1], u[2], u[3]), new V(u[4], u[5], u[6], u[7]))));
        });
      }
    });
  }
  computeMoreMinimalEdits(e, t, n = !1) {
    if (Bs(t)) {
      if (!Xp(this._modelService, e))
        return Promise.resolve(t);
      const r = Vs.create(), s = this._workerManager.withWorker().then((o) => o.computeMoreMinimalEdits(e, t, n));
      return s.finally(() => this._logService.trace("FORMAT#computeMoreMinimalEdits", e.toString(!0), r.elapsed())), Promise.race([s, Mg(1e3).then(() => t)]);
    } else
      return Promise.resolve(void 0);
  }
  canNavigateValueSet(e) {
    return Xp(this._modelService, e);
  }
  navigateValueSet(e, t, n) {
    return this._workerManager.withWorker().then((r) => r.navigateValueSet(e, t, n));
  }
  canComputeWordRanges(e) {
    return Xp(this._modelService, e);
  }
  computeWordRanges(e, t) {
    return this._workerManager.withWorker().then((n) => n.computeWordRanges(e, t));
  }
};
yF = uOe([
  r2(0, fi),
  r2(1, rz),
  r2(2, Ka),
  r2(3, Un),
  r2(4, tt)
], yF);
class hOe {
  constructor(e, t, n, r) {
    this.languageConfigurationService = r, this._debugDisplayName = "wordbasedCompletions", this._workerManager = e, this._configurationService = t, this._modelService = n;
  }
  provideCompletionItems(e, t) {
    return aL(this, void 0, void 0, function* () {
      const n = this._configurationService.getValue(e.uri, t, "editor");
      if (!n.wordBasedSuggestions)
        return;
      const r = [];
      if (n.wordBasedSuggestionsMode === "currentDocument")
        Xp(this._modelService, e.uri) && r.push(e.uri);
      else
        for (const u of this._modelService.getModels())
          Xp(this._modelService, u.uri) && (u === e ? r.unshift(u.uri) : (n.wordBasedSuggestionsMode === "allDocuments" || u.getLanguageId() === e.getLanguageId()) && r.push(u.uri));
      if (r.length === 0)
        return;
      const s = this.languageConfigurationService.getLanguageConfiguration(e.getLanguageId()).getWordDefinition(), o = e.getWordAtPosition(t), a = o ? new V(t.lineNumber, o.startColumn, t.lineNumber, o.endColumn) : V.fromPositions(t), l = a.setEndPosition(t.lineNumber, t.column), d = yield (yield this._workerManager.withWorker()).textualSuggest(r, o?.word, s);
      if (d)
        return {
          duration: d.duration,
          suggestions: d.words.map((u) => ({
            kind: 18,
            label: u,
            insertText: u,
            range: { insert: l, replace: a }
          }))
        };
    });
  }
}
class fOe extends we {
  constructor(e, t) {
    super(), this.languageConfigurationService = t, this._modelService = e, this._editorWorkerClient = null, this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime(), this._register(new SS()).cancelAndSet(() => this._checkStopIdleWorker(), Math.round(iZ / 2)), this._register(this._modelService.onModelRemoved((r) => this._checkStopEmptyWorker()));
  }
  dispose() {
    this._editorWorkerClient && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null), super.dispose();
  }
  /**
   * Check if the model service has no more models and stop the worker if that is the case.
   */
  _checkStopEmptyWorker() {
    if (!this._editorWorkerClient)
      return;
    this._modelService.getModels().length === 0 && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null);
  }
  /**
   * Check if the worker has been idle for a while and then stop it.
   */
  _checkStopIdleWorker() {
    if (!this._editorWorkerClient)
      return;
    (/* @__PURE__ */ new Date()).getTime() - this._lastWorkerUsedTime > iZ && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null);
  }
  withWorker() {
    return this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime(), this._editorWorkerClient || (this._editorWorkerClient = new sz(this._modelService, !1, "editorWorkerService", this.languageConfigurationService)), Promise.resolve(this._editorWorkerClient);
  }
}
class gOe extends we {
  constructor(e, t, n) {
    if (super(), this._syncedModels = /* @__PURE__ */ Object.create(null), this._syncedModelsLastUsedTime = /* @__PURE__ */ Object.create(null), this._proxy = e, this._modelService = t, !n) {
      const r = new SS();
      r.cancelAndSet(() => this._checkStopModelSync(), Math.round(nZ / 2)), this._register(r);
    }
  }
  dispose() {
    for (const e in this._syncedModels)
      An(this._syncedModels[e]);
    this._syncedModels = /* @__PURE__ */ Object.create(null), this._syncedModelsLastUsedTime = /* @__PURE__ */ Object.create(null), super.dispose();
  }
  ensureSyncedResources(e, t) {
    for (const n of e) {
      const r = n.toString();
      this._syncedModels[r] || this._beginModelSync(n, t), this._syncedModels[r] && (this._syncedModelsLastUsedTime[r] = (/* @__PURE__ */ new Date()).getTime());
    }
  }
  _checkStopModelSync() {
    const e = (/* @__PURE__ */ new Date()).getTime(), t = [];
    for (const n in this._syncedModelsLastUsedTime)
      e - this._syncedModelsLastUsedTime[n] > nZ && t.push(n);
    for (const n of t)
      this._stopModelSync(n);
  }
  _beginModelSync(e, t) {
    const n = this._modelService.getModel(e);
    if (!n || !t && n.isTooLargeForSyncing())
      return;
    const r = e.toString();
    this._proxy.acceptNewModel({
      url: n.uri.toString(),
      lines: n.getLinesContent(),
      EOL: n.getEOL(),
      versionId: n.getVersionId()
    });
    const s = new Ne();
    s.add(n.onDidChangeContent((o) => {
      this._proxy.acceptModelChanged(r.toString(), o);
    })), s.add(n.onWillDispose(() => {
      this._stopModelSync(r);
    })), s.add(Ct(() => {
      this._proxy.acceptRemovedModel(r);
    })), this._syncedModels[r] = s;
  }
  _stopModelSync(e) {
    const t = this._syncedModels[e];
    delete this._syncedModels[e], delete this._syncedModelsLastUsedTime[e], An(t);
  }
}
class rZ {
  constructor(e) {
    this._instance = e, this._proxyObj = Promise.resolve(this._instance);
  }
  dispose() {
    this._instance.dispose();
  }
  getProxyObject() {
    return this._proxyObj;
  }
}
class x6 {
  constructor(e) {
    this._workerClient = e;
  }
  // foreign host request
  fhr(e, t) {
    return this._workerClient.fhr(e, t);
  }
}
class sz extends we {
  constructor(e, t, n, r) {
    super(), this.languageConfigurationService = r, this._disposed = !1, this._modelService = e, this._keepIdleModels = t, this._workerFactory = new s4(n), this._worker = null, this._modelManager = null;
  }
  // foreign host request
  fhr(e, t) {
    throw new Error("Not implemented!");
  }
  _getOrCreateWorker() {
    if (!this._worker)
      try {
        this._worker = this._register(new v7e(this._workerFactory, "vs/editor/common/services/editorSimpleWorker", new x6(this)));
      } catch (e) {
        hF(e), this._worker = new rZ(new pg(new x6(this), null));
      }
    return this._worker;
  }
  _getProxy() {
    return this._getOrCreateWorker().getProxyObject().then(void 0, (e) => (hF(e), this._worker = new rZ(new pg(new x6(this), null)), this._getOrCreateWorker().getProxyObject()));
  }
  _getOrCreateModelManager(e) {
    return this._modelManager || (this._modelManager = this._register(new gOe(e, this._modelService, this._keepIdleModels))), this._modelManager;
  }
  _withSyncedResources(e, t = !1) {
    return aL(this, void 0, void 0, function* () {
      return this._disposed ? Promise.reject(ITe()) : this._getProxy().then((n) => (this._getOrCreateModelManager(n).ensureSyncedResources(e, t), n));
    });
  }
  computedUnicodeHighlights(e, t, n) {
    return this._withSyncedResources([e]).then((r) => r.computeUnicodeHighlights(e.toString(), t, n));
  }
  computeDiff(e, t, n, r) {
    return this._withSyncedResources(
      [e, t],
      /* forceLargeModels */
      !0
    ).then((s) => s.computeDiff(e.toString(), t.toString(), n, r));
  }
  computeMoreMinimalEdits(e, t, n) {
    return this._withSyncedResources([e]).then((r) => r.computeMoreMinimalEdits(e.toString(), t, n));
  }
  computeLinks(e) {
    return this._withSyncedResources([e]).then((t) => t.computeLinks(e.toString()));
  }
  computeDefaultDocumentColors(e) {
    return this._withSyncedResources([e]).then((t) => t.computeDefaultDocumentColors(e.toString()));
  }
  textualSuggest(e, t, n) {
    return aL(this, void 0, void 0, function* () {
      const r = yield this._withSyncedResources(e), s = n.source, o = n.flags;
      return r.textualSuggest(e.map((a) => a.toString()), t, s, o);
    });
  }
  computeWordRanges(e, t) {
    return this._withSyncedResources([e]).then((n) => {
      const r = this._modelService.getModel(e);
      if (!r)
        return Promise.resolve(null);
      const s = this.languageConfigurationService.getLanguageConfiguration(r.getLanguageId()).getWordDefinition(), o = s.source, a = s.flags;
      return n.computeWordRanges(e.toString(), t, o, a);
    });
  }
  navigateValueSet(e, t, n) {
    return this._withSyncedResources([e]).then((r) => {
      const s = this._modelService.getModel(e);
      if (!s)
        return null;
      const o = this.languageConfigurationService.getLanguageConfiguration(s.getLanguageId()).getWordDefinition(), a = o.source, l = o.flags;
      return r.navigateValueSet(e.toString(), t, n, a, l);
    });
  }
  dispose() {
    super.dispose(), this._disposed = !0;
  }
}
function pOe(i, e, t) {
  return new mOe(i, e, t);
}
class mOe extends sz {
  constructor(e, t, n) {
    super(e, n.keepIdleModels || !1, n.label, t), this._foreignModuleId = n.moduleId, this._foreignModuleCreateData = n.createData || null, this._foreignModuleHost = n.host || null, this._foreignProxy = null;
  }
  // foreign host request
  fhr(e, t) {
    if (!this._foreignModuleHost || typeof this._foreignModuleHost[e] != "function")
      return Promise.reject(new Error("Missing method " + e + " or missing main thread foreign host."));
    try {
      return Promise.resolve(this._foreignModuleHost[e].apply(this._foreignModuleHost, t));
    } catch (n) {
      return Promise.reject(n);
    }
  }
  _getForeignProxy() {
    return this._foreignProxy || (this._foreignProxy = this._getProxy().then((e) => {
      const t = this._foreignModuleHost ? Dj(this._foreignModuleHost) : [];
      return e.loadForeignModule(this._foreignModuleId, this._foreignModuleCreateData, t).then((n) => {
        this._foreignModuleCreateData = null;
        const r = (a, l) => e.fmr(a, l), s = (a, l) => function() {
          const c = Array.prototype.slice.call(arguments, 0);
          return l(a, c);
        }, o = {};
        for (const a of n)
          o[a] = s(a, r);
        return o;
      });
    })), this._foreignProxy;
  }
  getProxy() {
    return this._getForeignProxy();
  }
  withSyncedResources(e) {
    return this._withSyncedResources(e).then((t) => this.getProxy());
  }
}
const DS = {
  ICodeEditor: "vs.editor.ICodeEditor",
  IDiffEditor: "vs.editor.IDiffEditor"
}, __ = new class {
  clone() {
    return this;
  }
  equals(i) {
    return this === i;
  }
}();
function oz(i, e) {
  return new Rj([new wy(0, "", i)], e);
}
function f4(i, e) {
  const t = new Uint32Array(2);
  return t[0] = 0, t[1] = (i << 0 | 0 | 0 | 32768 | 2 << 24) >>> 0, new zA(t, e === null ? __ : e);
}
class Cs {
  static getLanguageId(e) {
    return (e & 255) >>> 0;
  }
  static getTokenType(e) {
    return (e & 768) >>> 8;
  }
  static containsBalancedBrackets(e) {
    return (e & 1024) !== 0;
  }
  static getFontStyle(e) {
    return (e & 30720) >>> 11;
  }
  static getForeground(e) {
    return (e & 16744448) >>> 15;
  }
  static getBackground(e) {
    return (e & 4278190080) >>> 24;
  }
  static getClassNameFromMetadata(e) {
    let n = "mtk" + this.getForeground(e);
    const r = this.getFontStyle(e);
    return r & 1 && (n += " mtki"), r & 2 && (n += " mtkb"), r & 4 && (n += " mtku"), r & 8 && (n += " mtks"), n;
  }
  static getInlineStyleFromMetadata(e, t) {
    const n = this.getForeground(e), r = this.getFontStyle(e);
    let s = `color: ${t[n]};`;
    r & 1 && (s += "font-style: italic;"), r & 2 && (s += "font-weight: bold;");
    let o = "";
    return r & 4 && (o += " underline"), r & 8 && (o += " line-through"), o && (s += `text-decoration:${o};`), s;
  }
  static getPresentationFromMetadata(e) {
    const t = this.getForeground(e), n = this.getFontStyle(e);
    return {
      foreground: t,
      italic: !!(n & 1),
      bold: !!(n & 2),
      underline: !!(n & 4),
      strikethrough: !!(n & 8)
    };
  }
}
class Tr {
  static createEmpty(e, t) {
    const n = Tr.defaultTokenMetadata, r = new Uint32Array(2);
    return r[0] = e.length, r[1] = n, new Tr(r, e, t);
  }
  constructor(e, t, n) {
    this._lineTokensBrand = void 0, this._tokens = e, this._tokensCount = this._tokens.length >>> 1, this._text = t, this._languageIdCodec = n;
  }
  equals(e) {
    return e instanceof Tr ? this.slicedEquals(e, 0, this._tokensCount) : !1;
  }
  slicedEquals(e, t, n) {
    if (this._text !== e._text || this._tokensCount !== e._tokensCount)
      return !1;
    const r = t << 1, s = r + (n << 1);
    for (let o = r; o < s; o++)
      if (this._tokens[o] !== e._tokens[o])
        return !1;
    return !0;
  }
  getLineContent() {
    return this._text;
  }
  getCount() {
    return this._tokensCount;
  }
  getStartOffset(e) {
    return e > 0 ? this._tokens[e - 1 << 1] : 0;
  }
  getMetadata(e) {
    return this._tokens[(e << 1) + 1];
  }
  getLanguageId(e) {
    const t = this._tokens[(e << 1) + 1], n = Cs.getLanguageId(t);
    return this._languageIdCodec.decodeLanguageId(n);
  }
  getStandardTokenType(e) {
    const t = this._tokens[(e << 1) + 1];
    return Cs.getTokenType(t);
  }
  getForeground(e) {
    const t = this._tokens[(e << 1) + 1];
    return Cs.getForeground(t);
  }
  getClassName(e) {
    const t = this._tokens[(e << 1) + 1];
    return Cs.getClassNameFromMetadata(t);
  }
  getInlineStyle(e, t) {
    const n = this._tokens[(e << 1) + 1];
    return Cs.getInlineStyleFromMetadata(n, t);
  }
  getPresentation(e) {
    const t = this._tokens[(e << 1) + 1];
    return Cs.getPresentationFromMetadata(t);
  }
  getEndOffset(e) {
    return this._tokens[e << 1];
  }
  /**
   * Find the token containing offset `offset`.
   * @param offset The search offset
   * @return The index of the token containing the offset.
   */
  findTokenIndexAtOffset(e) {
    return Tr.findIndexInTokensArray(this._tokens, e);
  }
  inflate() {
    return this;
  }
  sliceAndInflate(e, t, n) {
    return new az(this, e, t, n);
  }
  static convertToEndOffset(e, t) {
    const r = (e.length >>> 1) - 1;
    for (let s = 0; s < r; s++)
      e[s << 1] = e[s + 1 << 1];
    e[r << 1] = t;
  }
  static findIndexInTokensArray(e, t) {
    if (e.length <= 2)
      return 0;
    let n = 0, r = (e.length >>> 1) - 1;
    for (; n < r; ) {
      const s = n + Math.floor((r - n) / 2), o = e[s << 1];
      if (o === t)
        return s + 1;
      o < t ? n = s + 1 : o > t && (r = s);
    }
    return n;
  }
  /**
   * @pure
   * @param insertTokens Must be sorted by offset.
  */
  withInserted(e) {
    if (e.length === 0)
      return this;
    let t = 0, n = 0, r = "";
    const s = new Array();
    let o = 0;
    for (; ; ) {
      const a = t < this._tokensCount ? this._tokens[t << 1] : -1, l = n < e.length ? e[n] : null;
      if (a !== -1 && (l === null || a <= l.offset)) {
        r += this._text.substring(o, a);
        const c = this._tokens[(t << 1) + 1];
        s.push(r.length, c), t++, o = a;
      } else if (l) {
        if (l.offset > o) {
          r += this._text.substring(o, l.offset);
          const c = this._tokens[(t << 1) + 1];
          s.push(r.length, c), o = l.offset;
        }
        r += l.text, s.push(r.length, l.tokenMetadata), n++;
      } else
        break;
    }
    return new Tr(new Uint32Array(s), r, this._languageIdCodec);
  }
}
Tr.defaultTokenMetadata = (32768 | 2 << 24) >>> 0;
class az {
  constructor(e, t, n, r) {
    this._source = e, this._startOffset = t, this._endOffset = n, this._deltaOffset = r, this._firstTokenIndex = e.findTokenIndexAtOffset(t), this._tokensCount = 0;
    for (let s = this._firstTokenIndex, o = e.getCount(); s < o && !(e.getStartOffset(s) >= n); s++)
      this._tokensCount++;
  }
  getMetadata(e) {
    return this._source.getMetadata(this._firstTokenIndex + e);
  }
  getLanguageId(e) {
    return this._source.getLanguageId(this._firstTokenIndex + e);
  }
  getLineContent() {
    return this._source.getLineContent().substring(this._startOffset, this._endOffset);
  }
  equals(e) {
    return e instanceof az ? this._startOffset === e._startOffset && this._endOffset === e._endOffset && this._deltaOffset === e._deltaOffset && this._source.slicedEquals(e._source, this._firstTokenIndex, this._tokensCount) : !1;
  }
  getCount() {
    return this._tokensCount;
  }
  getForeground(e) {
    return this._source.getForeground(this._firstTokenIndex + e);
  }
  getEndOffset(e) {
    const t = this._source.getEndOffset(this._firstTokenIndex + e);
    return Math.min(this._endOffset, t) - this._startOffset + this._deltaOffset;
  }
  getClassName(e) {
    return this._source.getClassName(this._firstTokenIndex + e);
  }
  getInlineStyle(e, t) {
    return this._source.getInlineStyle(this._firstTokenIndex + e, t);
  }
  getPresentation(e) {
    return this._source.getPresentation(this._firstTokenIndex + e);
  }
  findTokenIndexAtOffset(e) {
    return this._source.findTokenIndexAtOffset(e + this._startOffset - this._deltaOffset) - this._firstTokenIndex;
  }
}
class ea {
  constructor(e, t, n, r) {
    this.startColumn = e, this.endColumn = t, this.className = n, this.type = r, this._lineDecorationBrand = void 0;
  }
  static _equals(e, t) {
    return e.startColumn === t.startColumn && e.endColumn === t.endColumn && e.className === t.className && e.type === t.type;
  }
  static equalsArr(e, t) {
    const n = e.length, r = t.length;
    if (n !== r)
      return !1;
    for (let s = 0; s < n; s++)
      if (!ea._equals(e[s], t[s]))
        return !1;
    return !0;
  }
  static extractWrapped(e, t, n) {
    if (e.length === 0)
      return e;
    const r = t + 1, s = n + 1, o = n - t, a = [];
    let l = 0;
    for (const c of e)
      c.endColumn <= r || c.startColumn >= s || (a[l++] = new ea(Math.max(1, c.startColumn - r + 1), Math.min(o + 1, c.endColumn - r + 1), c.className, c.type));
    return a;
  }
  static filter(e, t, n, r) {
    if (e.length === 0)
      return [];
    const s = [];
    let o = 0;
    for (let a = 0, l = e.length; a < l; a++) {
      const c = e[a], d = c.range;
      if (d.endLineNumber < t || d.startLineNumber > t || d.isEmpty() && (c.type === 0 || c.type === 3))
        continue;
      const u = d.startLineNumber === t ? d.startColumn : n, h = d.endLineNumber === t ? d.endColumn : r;
      s[o++] = new ea(u, h, c.inlineClassName, c.type);
    }
    return s;
  }
  static _typeCompare(e, t) {
    const n = [2, 0, 1, 3];
    return n[e] - n[t];
  }
  static compare(e, t) {
    if (e.startColumn !== t.startColumn)
      return e.startColumn - t.startColumn;
    if (e.endColumn !== t.endColumn)
      return e.endColumn - t.endColumn;
    const n = ea._typeCompare(e.type, t.type);
    return n !== 0 ? n : e.className !== t.className ? e.className < t.className ? -1 : 1 : 0;
  }
}
class sZ {
  constructor(e, t, n, r) {
    this.startOffset = e, this.endOffset = t, this.className = n, this.metadata = r;
  }
}
class lL {
  constructor() {
    this.stopOffsets = [], this.classNames = [], this.metadata = [], this.count = 0;
  }
  static _metadata(e) {
    let t = 0;
    for (let n = 0, r = e.length; n < r; n++)
      t |= e[n];
    return t;
  }
  consumeLowerThan(e, t, n) {
    for (; this.count > 0 && this.stopOffsets[0] < e; ) {
      let r = 0;
      for (; r + 1 < this.count && this.stopOffsets[r] === this.stopOffsets[r + 1]; )
        r++;
      n.push(new sZ(t, this.stopOffsets[r], this.classNames.join(" "), lL._metadata(this.metadata))), t = this.stopOffsets[r] + 1, this.stopOffsets.splice(0, r + 1), this.classNames.splice(0, r + 1), this.metadata.splice(0, r + 1), this.count -= r + 1;
    }
    return this.count > 0 && t < e && (n.push(new sZ(t, e - 1, this.classNames.join(" "), lL._metadata(this.metadata))), t = e), t;
  }
  insert(e, t, n) {
    if (this.count === 0 || this.stopOffsets[this.count - 1] <= e)
      this.stopOffsets.push(e), this.classNames.push(t), this.metadata.push(n);
    else
      for (let r = 0; r < this.count; r++)
        if (this.stopOffsets[r] >= e) {
          this.stopOffsets.splice(r, 0, e), this.classNames.splice(r, 0, t), this.metadata.splice(r, 0, n);
          break;
        }
    this.count++;
  }
}
class vOe {
  /**
   * Normalize line decorations. Overlapping decorations will generate multiple segments
   */
  static normalize(e, t) {
    if (t.length === 0)
      return [];
    const n = [], r = new lL();
    let s = 0;
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      let c = l.startColumn, d = l.endColumn;
      const u = l.className, h = l.type === 1 ? 2 : l.type === 2 ? 4 : 0;
      if (c > 1) {
        const p = e.charCodeAt(c - 2);
        kr(p) && c--;
      }
      if (d > 1) {
        const p = e.charCodeAt(d - 2);
        kr(p) && d--;
      }
      const f = c - 1, g = d - 2;
      s = r.consumeLowerThan(f, s, n), r.count === 0 && (s = f), r.insert(g, u, h);
    }
    return r.consumeLowerThan(1073741824, s, n), n;
  }
}
class zr {
  constructor(e, t, n, r) {
    this.endIndex = e, this.type = t, this.metadata = n, this.containsRTL = r, this._linePartBrand = void 0;
  }
  isWhitespace() {
    return !!(this.metadata & 1);
  }
  isPseudoAfter() {
    return !!(this.metadata & 4);
  }
}
class bfe {
  constructor(e, t) {
    this.startOffset = e, this.endOffset = t;
  }
  equals(e) {
    return this.startOffset === e.startOffset && this.endOffset === e.endOffset;
  }
}
class dp {
  constructor(e, t, n, r, s, o, a, l, c, d, u, h, f, g, p, m, _, b, w) {
    this.useMonospaceOptimizations = e, this.canUseHalfwidthRightwardsArrow = t, this.lineContent = n, this.continuesWithWrappedLine = r, this.isBasicASCII = s, this.containsRTL = o, this.fauxIndentLength = a, this.lineTokens = l, this.lineDecorations = c.sort(ea.compare), this.tabSize = d, this.startVisibleColumn = u, this.spaceWidth = h, this.stopRenderingLineAfter = p, this.renderWhitespace = m === "all" ? 4 : m === "boundary" ? 1 : m === "selection" ? 2 : m === "trailing" ? 3 : 0, this.renderControlCharacters = _, this.fontLigatures = b, this.selectionsOnLine = w && w.sort((x, D) => x.startOffset < D.startOffset ? -1 : 1);
    const y = Math.abs(g - h), S = Math.abs(f - h);
    y < S ? (this.renderSpaceWidth = g, this.renderSpaceCharCode = 11825) : (this.renderSpaceWidth = f, this.renderSpaceCharCode = 183);
  }
  sameSelection(e) {
    if (this.selectionsOnLine === null)
      return e === null;
    if (e === null || e.length !== this.selectionsOnLine.length)
      return !1;
    for (let t = 0; t < this.selectionsOnLine.length; t++)
      if (!this.selectionsOnLine[t].equals(e[t]))
        return !1;
    return !0;
  }
  equals(e) {
    return this.useMonospaceOptimizations === e.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineContent === e.lineContent && this.continuesWithWrappedLine === e.continuesWithWrappedLine && this.isBasicASCII === e.isBasicASCII && this.containsRTL === e.containsRTL && this.fauxIndentLength === e.fauxIndentLength && this.tabSize === e.tabSize && this.startVisibleColumn === e.startVisibleColumn && this.spaceWidth === e.spaceWidth && this.renderSpaceWidth === e.renderSpaceWidth && this.renderSpaceCharCode === e.renderSpaceCharCode && this.stopRenderingLineAfter === e.stopRenderingLineAfter && this.renderWhitespace === e.renderWhitespace && this.renderControlCharacters === e.renderControlCharacters && this.fontLigatures === e.fontLigatures && ea.equalsArr(this.lineDecorations, e.lineDecorations) && this.lineTokens.equals(e.lineTokens) && this.sameSelection(e.selectionsOnLine);
  }
}
class Cfe {
  constructor(e, t) {
    this.partIndex = e, this.charIndex = t;
  }
}
class Rd {
  static getPartIndex(e) {
    return (e & 4294901760) >>> 16;
  }
  static getCharIndex(e) {
    return (e & 65535) >>> 0;
  }
  constructor(e, t) {
    this.length = e, this._data = new Uint32Array(this.length), this._horizontalOffset = new Uint32Array(this.length);
  }
  setColumnInfo(e, t, n, r) {
    const s = (t << 16 | n << 0) >>> 0;
    this._data[e - 1] = s, this._horizontalOffset[e - 1] = r;
  }
  getHorizontalOffset(e) {
    return this._horizontalOffset.length === 0 ? 0 : this._horizontalOffset[e - 1];
  }
  charOffsetToPartData(e) {
    return this.length === 0 ? 0 : e < 0 ? this._data[0] : e >= this.length ? this._data[this.length - 1] : this._data[e];
  }
  getDomPosition(e) {
    const t = this.charOffsetToPartData(e - 1), n = Rd.getPartIndex(t), r = Rd.getCharIndex(t);
    return new Cfe(n, r);
  }
  getColumn(e, t) {
    return this.partDataToCharOffset(e.partIndex, t, e.charIndex) + 1;
  }
  partDataToCharOffset(e, t, n) {
    if (this.length === 0)
      return 0;
    const r = (e << 16 | n << 0) >>> 0;
    let s = 0, o = this.length - 1;
    for (; s + 1 < o; ) {
      const p = s + o >>> 1, m = this._data[p];
      if (m === r)
        return p;
      m > r ? o = p : s = p;
    }
    if (s === o)
      return s;
    const a = this._data[s], l = this._data[o];
    if (a === r)
      return s;
    if (l === r)
      return o;
    const c = Rd.getPartIndex(a), d = Rd.getCharIndex(a), u = Rd.getPartIndex(l);
    let h;
    c !== u ? h = t : h = Rd.getCharIndex(l);
    const f = n - d, g = h - n;
    return f <= g ? s : o;
  }
}
class wF {
  constructor(e, t, n) {
    this._renderLineOutputBrand = void 0, this.characterMapping = e, this.containsRTL = t, this.containsForeignElements = n;
  }
}
function ES(i, e) {
  if (i.lineContent.length === 0) {
    if (i.lineDecorations.length > 0) {
      e.appendString("<span>");
      let t = 0, n = 0, r = 0;
      for (const o of i.lineDecorations)
        (o.type === 1 || o.type === 2) && (e.appendString('<span class="'), e.appendString(o.className), e.appendString('"></span>'), o.type === 1 && (r |= 1, t++), o.type === 2 && (r |= 2, n++));
      e.appendString("</span>");
      const s = new Rd(1, t + n);
      return s.setColumnInfo(1, t, 0, 0), new wF(s, !1, r);
    }
    return e.appendString("<span><span></span></span>"), new wF(
      new Rd(0, 0),
      !1,
      0
      /* ForeignElementType.None */
    );
  }
  return EOe(COe(i), e);
}
class _Oe {
  constructor(e, t, n, r) {
    this.characterMapping = e, this.html = t, this.containsRTL = n, this.containsForeignElements = r;
  }
}
function g4(i) {
  const e = new pb(1e4), t = ES(i, e);
  return new _Oe(t.characterMapping, e.build(), t.containsRTL, t.containsForeignElements);
}
class bOe {
  constructor(e, t, n, r, s, o, a, l, c, d, u, h, f, g, p, m) {
    this.fontIsMonospace = e, this.canUseHalfwidthRightwardsArrow = t, this.lineContent = n, this.len = r, this.isOverflowing = s, this.overflowingCharCount = o, this.parts = a, this.containsForeignElements = l, this.fauxIndentLength = c, this.tabSize = d, this.startVisibleColumn = u, this.containsRTL = h, this.spaceWidth = f, this.renderSpaceCharCode = g, this.renderWhitespace = p, this.renderControlCharacters = m;
  }
}
function COe(i) {
  const e = i.lineContent;
  let t, n, r;
  i.stopRenderingLineAfter !== -1 && i.stopRenderingLineAfter < e.length ? (t = !0, n = e.length - i.stopRenderingLineAfter, r = i.stopRenderingLineAfter) : (t = !1, n = 0, r = e.length);
  let s = yOe(e, i.containsRTL, i.lineTokens, i.fauxIndentLength, r);
  i.renderControlCharacters && !i.isBasicASCII && (s = SOe(e, s)), (i.renderWhitespace === 4 || i.renderWhitespace === 1 || i.renderWhitespace === 2 && i.selectionsOnLine || i.renderWhitespace === 3 && !i.continuesWithWrappedLine) && (s = xOe(i, e, r, s));
  let o = 0;
  if (i.lineDecorations.length > 0) {
    for (let a = 0, l = i.lineDecorations.length; a < l; a++) {
      const c = i.lineDecorations[a];
      c.type === 3 || c.type === 1 ? o |= 1 : c.type === 2 && (o |= 2);
    }
    s = DOe(e, r, s, i.lineDecorations);
  }
  return i.containsRTL || (s = wOe(e, s, !i.isBasicASCII || i.fontLigatures)), new bOe(i.useMonospaceOptimizations, i.canUseHalfwidthRightwardsArrow, e, r, t, n, s, o, i.fauxIndentLength, i.tabSize, i.startVisibleColumn, i.containsRTL, i.spaceWidth, i.renderSpaceCharCode, i.renderWhitespace, i.renderControlCharacters);
}
function yOe(i, e, t, n, r) {
  const s = [];
  let o = 0;
  n > 0 && (s[o++] = new zr(n, "", 0, !1));
  let a = n;
  for (let l = 0, c = t.getCount(); l < c; l++) {
    const d = t.getEndOffset(l);
    if (d <= n)
      continue;
    const u = t.getClassName(l);
    if (d >= r) {
      const f = e ? u_(i.substring(a, r)) : !1;
      s[o++] = new zr(r, u, 0, f);
      break;
    }
    const h = e ? u_(i.substring(a, d)) : !1;
    s[o++] = new zr(d, u, 0, h), a = d;
  }
  return s;
}
function wOe(i, e, t) {
  let n = 0;
  const r = [];
  let s = 0;
  if (t)
    for (let o = 0, a = e.length; o < a; o++) {
      const l = e[o], c = l.endIndex;
      if (n + 50 < c) {
        const d = l.type, u = l.metadata, h = l.containsRTL;
        let f = -1, g = n;
        for (let p = n; p < c; p++)
          i.charCodeAt(p) === 32 && (f = p), f !== -1 && p - g >= 50 && (r[s++] = new zr(f + 1, d, u, h), g = f + 1, f = -1);
        g !== c && (r[s++] = new zr(c, d, u, h));
      } else
        r[s++] = l;
      n = c;
    }
  else
    for (let o = 0, a = e.length; o < a; o++) {
      const l = e[o], c = l.endIndex, d = c - n;
      if (d > 50) {
        const u = l.type, h = l.metadata, f = l.containsRTL, g = Math.ceil(
          d / 50
          /* Constants.LongToken */
        );
        for (let p = 1; p < g; p++) {
          const m = n + p * 50;
          r[s++] = new zr(m, u, h, f);
        }
        r[s++] = new zr(c, u, h, f);
      } else
        r[s++] = l;
      n = c;
    }
  return r;
}
function yfe(i) {
  return i < 32 ? i !== 9 : i === 127 || i >= 8234 && i <= 8238 || i >= 8294 && i <= 8297 || i >= 8206 && i <= 8207 || i === 1564;
}
function SOe(i, e) {
  const t = [];
  let n = new zr(0, "", 0, !1), r = 0;
  for (const s of e) {
    const o = s.endIndex;
    for (; r < o; r++) {
      const a = i.charCodeAt(r);
      yfe(a) && (r > n.endIndex && (n = new zr(r, s.type, s.metadata, s.containsRTL), t.push(n)), n = new zr(r + 1, "mtkcontrol", s.metadata, !1), t.push(n));
    }
    r > n.endIndex && (n = new zr(o, s.type, s.metadata, s.containsRTL), t.push(n));
  }
  return t;
}
function xOe(i, e, t, n) {
  const r = i.continuesWithWrappedLine, s = i.fauxIndentLength, o = i.tabSize, a = i.startVisibleColumn, l = i.useMonospaceOptimizations, c = i.selectionsOnLine, d = i.renderWhitespace === 1, u = i.renderWhitespace === 3, h = i.renderSpaceWidth !== i.spaceWidth, f = [];
  let g = 0, p = 0, m = n[p].type, _ = n[p].containsRTL, b = n[p].endIndex;
  const w = n.length;
  let y = !1, S = Js(e), x;
  S === -1 ? (y = !0, S = t, x = t) : x = Jc(e);
  let D = !1, E = 0, L = c && c[E], k = a % o;
  for (let I = s; I < t; I++) {
    const A = e.charCodeAt(I);
    L && I >= L.endOffset && (E++, L = c && c[E]);
    let P;
    if (I < S || I > x)
      P = !0;
    else if (A === 9)
      P = !0;
    else if (A === 32)
      if (d)
        if (D)
          P = !0;
        else {
          const O = I + 1 < t ? e.charCodeAt(I + 1) : 0;
          P = O === 32 || O === 9;
        }
      else
        P = !0;
    else
      P = !1;
    if (P && c && (P = !!L && L.startOffset <= I && L.endOffset > I), P && u && (P = y || I > x), P && _ && I >= S && I <= x && (P = !1), D) {
      if (!P || !l && k >= o) {
        if (h) {
          const O = g > 0 ? f[g - 1].endIndex : s;
          for (let K = O + 1; K <= I; K++)
            f[g++] = new zr(K, "mtkw", 1, !1);
        } else
          f[g++] = new zr(I, "mtkw", 1, !1);
        k = k % o;
      }
    } else
      (I === b || P && I > s) && (f[g++] = new zr(I, m, 0, _), k = k % o);
    for (A === 9 ? k = o : Pg(A) ? k += 2 : k++, D = P; I === b && (p++, p < w); )
      m = n[p].type, _ = n[p].containsRTL, b = n[p].endIndex;
  }
  let N = !1;
  if (D)
    if (r && d) {
      const I = t > 0 ? e.charCodeAt(t - 1) : 0, A = t > 1 ? e.charCodeAt(t - 2) : 0;
      I === 32 && A !== 32 && A !== 9 || (N = !0);
    } else
      N = !0;
  if (N)
    if (h) {
      const I = g > 0 ? f[g - 1].endIndex : s;
      for (let A = I + 1; A <= t; A++)
        f[g++] = new zr(A, "mtkw", 1, !1);
    } else
      f[g++] = new zr(t, "mtkw", 1, !1);
  else
    f[g++] = new zr(t, m, 0, _);
  return f;
}
function DOe(i, e, t, n) {
  n.sort(ea.compare);
  const r = vOe.normalize(i, n), s = r.length;
  let o = 0;
  const a = [];
  let l = 0, c = 0;
  for (let u = 0, h = t.length; u < h; u++) {
    const f = t[u], g = f.endIndex, p = f.type, m = f.metadata, _ = f.containsRTL;
    for (; o < s && r[o].startOffset < g; ) {
      const b = r[o];
      if (b.startOffset > c && (c = b.startOffset, a[l++] = new zr(c, p, m, _)), b.endOffset + 1 <= g)
        c = b.endOffset + 1, a[l++] = new zr(c, p + " " + b.className, m | b.metadata, _), o++;
      else {
        c = g, a[l++] = new zr(c, p + " " + b.className, m | b.metadata, _);
        break;
      }
    }
    g > c && (c = g, a[l++] = new zr(c, p, m, _));
  }
  const d = t[t.length - 1].endIndex;
  if (o < s && r[o].startOffset === d)
    for (; o < s && r[o].startOffset === d; ) {
      const u = r[o];
      a[l++] = new zr(c, u.className, u.metadata, !1), o++;
    }
  return a;
}
function EOe(i, e) {
  const t = i.fontIsMonospace, n = i.canUseHalfwidthRightwardsArrow, r = i.containsForeignElements, s = i.lineContent, o = i.len, a = i.isOverflowing, l = i.overflowingCharCount, c = i.parts, d = i.fauxIndentLength, u = i.tabSize, h = i.startVisibleColumn, f = i.containsRTL, g = i.spaceWidth, p = i.renderSpaceCharCode, m = i.renderWhitespace, _ = i.renderControlCharacters, b = new Rd(o + 1, c.length);
  let w = !1, y = 0, S = h, x = 0, D = 0, E = 0;
  f ? e.appendString('<span dir="ltr">') : e.appendString("<span>");
  for (let L = 0, k = c.length; L < k; L++) {
    const N = c[L], I = N.endIndex, A = N.type, P = N.containsRTL, O = m !== 0 && N.isWhitespace(), K = O && !t && (A === "mtkw" || !r), W = y === I && N.isPseudoAfter();
    if (x = 0, e.appendString("<span "), P && e.appendString('style="unicode-bidi:isolate" '), e.appendString('class="'), e.appendString(K ? "mtkz" : A), e.appendASCIICharCode(
      34
      /* CharCode.DoubleQuote */
    ), O) {
      let F = 0;
      {
        let q = y, R = S;
        for (; q < I; q++) {
          const z = (s.charCodeAt(q) === 9 ? u - R % u : 1) | 0;
          F += z, q >= d && (R += z);
        }
      }
      for (K && (e.appendString(' style="width:'), e.appendString(String(g * F)), e.appendString('px"')), e.appendASCIICharCode(
        62
        /* CharCode.GreaterThan */
      ); y < I; y++) {
        b.setColumnInfo(y + 1, L - E, x, D), E = 0;
        const q = s.charCodeAt(y);
        let R, T;
        if (q === 9) {
          R = u - S % u | 0, T = R, !n || T > 1 ? e.appendCharCode(8594) : e.appendCharCode(65515);
          for (let z = 2; z <= T; z++)
            e.appendCharCode(160);
        } else
          R = 2, T = 1, e.appendCharCode(p), e.appendCharCode(8204);
        x += R, D += T, y >= d && (S += T);
      }
    } else
      for (e.appendASCIICharCode(
        62
        /* CharCode.GreaterThan */
      ); y < I; y++) {
        b.setColumnInfo(y + 1, L - E, x, D), E = 0;
        const F = s.charCodeAt(y);
        let q = 1, R = 1;
        switch (F) {
          case 9:
            q = u - S % u, R = q;
            for (let T = 1; T <= q; T++)
              e.appendCharCode(160);
            break;
          case 32:
            e.appendCharCode(160);
            break;
          case 60:
            e.appendString("&lt;");
            break;
          case 62:
            e.appendString("&gt;");
            break;
          case 38:
            e.appendString("&amp;");
            break;
          case 0:
            _ ? e.appendCharCode(9216) : e.appendString("&#00;");
            break;
          case 65279:
          case 8232:
          case 8233:
          case 133:
            e.appendCharCode(65533);
            break;
          default:
            Pg(F) && R++, _ && F < 32 ? e.appendCharCode(9216 + F) : _ && F === 127 ? e.appendCharCode(9249) : _ && yfe(F) ? (e.appendString("[U+"), e.appendString(LOe(F)), e.appendString("]"), q = 8, R = q) : e.appendCharCode(F);
        }
        x += q, D += R, y >= d && (S += R);
      }
    W ? E++ : E = 0, y >= o && !w && N.isPseudoAfter() && (w = !0, b.setColumnInfo(y + 1, L, x, D)), e.appendString("</span>");
  }
  return w || b.setColumnInfo(o + 1, c.length - 1, x, D), a && (e.appendString('<span class="mtkoverflow">'), e.appendString(C("showMore", "Show more ({0})", IOe(l))), e.appendString("</span>")), e.appendString("</span>"), new wF(b, f, r);
}
function LOe(i) {
  return i.toString(16).toUpperCase().padStart(4, "0");
}
function IOe(i) {
  return i < 1024 ? C("overflow.chars", "{0} chars", i) : i < 1024 * 1024 ? `${(i / 1024).toFixed(1)} KB` : `${(i / 1024 / 1024).toFixed(1)} MB`;
}
class oZ {
  constructor(e, t, n, r) {
    this._viewportBrand = void 0, this.top = e | 0, this.left = t | 0, this.width = n | 0, this.height = r | 0;
  }
}
class AOe {
  constructor(e, t) {
    this.tabSize = e, this.data = t;
  }
}
class lz {
  constructor(e, t, n, r, s, o, a) {
    this._viewLineDataBrand = void 0, this.content = e, this.continuesWithWrappedLine = t, this.minColumn = n, this.maxColumn = r, this.startVisibleColumn = s, this.tokens = o, this.inlineDecorations = a;
  }
}
class Wa {
  constructor(e, t, n, r, s, o, a, l, c, d) {
    this.minColumn = e, this.maxColumn = t, this.content = n, this.continuesWithWrappedLine = r, this.isBasicASCII = Wa.isBasicASCII(n, o), this.containsRTL = Wa.containsRTL(n, this.isBasicASCII, s), this.tokens = a, this.inlineDecorations = l, this.tabSize = c, this.startVisibleColumn = d;
  }
  static isBasicASCII(e, t) {
    return t ? yS(e) : !0;
  }
  static containsRTL(e, t, n) {
    return !t && n ? u_(e) : !1;
  }
}
class SC {
  constructor(e, t, n) {
    this.range = e, this.inlineClassName = t, this.type = n;
  }
}
class kOe {
  constructor(e, t, n, r) {
    this.startOffset = e, this.endOffset = t, this.inlineClassName = n, this.inlineClassNameAffectsLetterSpacing = r;
  }
  toInlineDecoration(e) {
    return new SC(
      new V(e, this.startOffset + 1, e, this.endOffset + 1),
      this.inlineClassName,
      this.inlineClassNameAffectsLetterSpacing ? 3 : 0
      /* InlineDecorationType.Regular */
    );
  }
}
class wfe {
  constructor(e, t) {
    this._viewModelDecorationBrand = void 0, this.range = e, this.options = t;
  }
}
class Fy {
  constructor(e, t, n) {
    this.color = e, this.zIndex = t, this.data = n;
  }
  static compareByRenderingProps(e, t) {
    return e.zIndex === t.zIndex ? e.color < t.color ? -1 : e.color > t.color ? 1 : 0 : e.zIndex - t.zIndex;
  }
  static equals(e, t) {
    return e.color === t.color && e.zIndex === t.zIndex && Qi(e.data, t.data);
  }
  static equalsArr(e, t) {
    return Qi(e, t, Fy.equals);
  }
}
function TOe(i) {
  return Array.isArray(i);
}
function NOe(i) {
  return !TOe(i);
}
function Sfe(i) {
  return typeof i == "string";
}
function aZ(i) {
  return !Sfe(i);
}
function M1(i) {
  return !i;
}
function mg(i, e) {
  return i.ignoreCase && e ? e.toLowerCase() : e;
}
function lZ(i) {
  return i.replace(/[&<>'"_]/g, "-");
}
function POe(i, e) {
  console.log(`${i.languageId}: ${e}`);
}
function ni(i, e) {
  return new Error(`${i.languageId}: ${e}`);
}
function Bf(i, e, t, n, r) {
  const s = /\$((\$)|(#)|(\d\d?)|[sS](\d\d?)|@(\w+))/g;
  let o = null;
  return e.replace(s, function(a, l, c, d, u, h, f, g, p) {
    return M1(c) ? M1(d) ? !M1(u) && u < n.length ? mg(i, n[u]) : !M1(f) && i && typeof i[f] == "string" ? i[f] : (o === null && (o = r.split("."), o.unshift(r)), !M1(h) && h < o.length ? mg(i, o[h]) : "") : mg(i, t) : "$";
  });
}
function zx(i, e) {
  let t = e;
  for (; t && t.length > 0; ) {
    const n = i.tokenizer[t];
    if (n)
      return n;
    const r = t.lastIndexOf(".");
    r < 0 ? t = null : t = t.substr(0, r);
  }
  return null;
}
function OOe(i, e) {
  let t = e;
  for (; t && t.length > 0; ) {
    if (i.stateNames[t])
      return !0;
    const r = t.lastIndexOf(".");
    r < 0 ? t = null : t = t.substr(0, r);
  }
  return !1;
}
var MOe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, ROe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, SF;
const xfe = 5;
class By {
  static create(e, t) {
    return this._INSTANCE.create(e, t);
  }
  constructor(e) {
    this._maxCacheDepth = e, this._entries = /* @__PURE__ */ Object.create(null);
  }
  create(e, t) {
    if (e !== null && e.depth >= this._maxCacheDepth)
      return new Ov(e, t);
    let n = Ov.getStackElementId(e);
    n.length > 0 && (n += "|"), n += t;
    let r = this._entries[n];
    return r || (r = new Ov(e, t), this._entries[n] = r, r);
  }
}
By._INSTANCE = new By(xfe);
class Ov {
  constructor(e, t) {
    this.parent = e, this.state = t, this.depth = (this.parent ? this.parent.depth : 0) + 1;
  }
  static getStackElementId(e) {
    let t = "";
    for (; e !== null; )
      t.length > 0 && (t += "|"), t += e.state, e = e.parent;
    return t;
  }
  static _equals(e, t) {
    for (; e !== null && t !== null; ) {
      if (e === t)
        return !0;
      if (e.state !== t.state)
        return !1;
      e = e.parent, t = t.parent;
    }
    return e === null && t === null;
  }
  equals(e) {
    return Ov._equals(this, e);
  }
  push(e) {
    return By.create(this, e);
  }
  pop() {
    return this.parent;
  }
  popall() {
    let e = this;
    for (; e.parent; )
      e = e.parent;
    return e;
  }
  switchTo(e) {
    return By.create(this.parent, e);
  }
}
class Q1 {
  constructor(e, t) {
    this.languageId = e, this.state = t;
  }
  equals(e) {
    return this.languageId === e.languageId && this.state.equals(e.state);
  }
  clone() {
    return this.state.clone() === this.state ? this : new Q1(this.languageId, this.state);
  }
}
class Vf {
  static create(e, t) {
    return this._INSTANCE.create(e, t);
  }
  constructor(e) {
    this._maxCacheDepth = e, this._entries = /* @__PURE__ */ Object.create(null);
  }
  create(e, t) {
    if (t !== null)
      return new xC(e, t);
    if (e !== null && e.depth >= this._maxCacheDepth)
      return new xC(e, t);
    const n = Ov.getStackElementId(e);
    let r = this._entries[n];
    return r || (r = new xC(e, null), this._entries[n] = r, r);
  }
}
Vf._INSTANCE = new Vf(xfe);
class xC {
  constructor(e, t) {
    this.stack = e, this.embeddedLanguageData = t;
  }
  clone() {
    return (this.embeddedLanguageData ? this.embeddedLanguageData.clone() : null) === this.embeddedLanguageData ? this : Vf.create(this.stack, this.embeddedLanguageData);
  }
  equals(e) {
    return !(e instanceof xC) || !this.stack.equals(e.stack) ? !1 : this.embeddedLanguageData === null && e.embeddedLanguageData === null ? !0 : this.embeddedLanguageData === null || e.embeddedLanguageData === null ? !1 : this.embeddedLanguageData.equals(e.embeddedLanguageData);
  }
}
class FOe {
  constructor() {
    this._tokens = [], this._languageId = null, this._lastTokenType = null, this._lastTokenLanguage = null;
  }
  enterLanguage(e) {
    this._languageId = e;
  }
  emit(e, t) {
    this._lastTokenType === t && this._lastTokenLanguage === this._languageId || (this._lastTokenType = t, this._lastTokenLanguage = this._languageId, this._tokens.push(new wy(e, t, this._languageId)));
  }
  nestedLanguageTokenize(e, t, n, r) {
    const s = n.languageId, o = n.state, a = Pi.get(s);
    if (!a)
      return this.enterLanguage(s), this.emit(r, ""), o;
    const l = a.tokenize(e, t, o);
    if (r !== 0)
      for (const c of l.tokens)
        this._tokens.push(new wy(c.offset + r, c.type, c.language));
    else
      this._tokens = this._tokens.concat(l.tokens);
    return this._lastTokenType = null, this._lastTokenLanguage = null, this._languageId = null, l.endState;
  }
  finalize(e) {
    return new Rj(this._tokens, e);
  }
}
class cL {
  constructor(e, t) {
    this._languageService = e, this._theme = t, this._prependTokens = null, this._tokens = [], this._currentLanguageId = 0, this._lastTokenMetadata = 0;
  }
  enterLanguage(e) {
    this._currentLanguageId = this._languageService.languageIdCodec.encodeLanguageId(e);
  }
  emit(e, t) {
    const n = this._theme.match(this._currentLanguageId, t) | 1024;
    this._lastTokenMetadata !== n && (this._lastTokenMetadata = n, this._tokens.push(e), this._tokens.push(n));
  }
  static _merge(e, t, n) {
    const r = e !== null ? e.length : 0, s = t.length, o = n !== null ? n.length : 0;
    if (r === 0 && s === 0 && o === 0)
      return new Uint32Array(0);
    if (r === 0 && s === 0)
      return n;
    if (s === 0 && o === 0)
      return e;
    const a = new Uint32Array(r + s + o);
    e !== null && a.set(e);
    for (let l = 0; l < s; l++)
      a[r + l] = t[l];
    return n !== null && a.set(n, r + s), a;
  }
  nestedLanguageTokenize(e, t, n, r) {
    const s = n.languageId, o = n.state, a = Pi.get(s);
    if (!a)
      return this.enterLanguage(s), this.emit(r, ""), o;
    const l = a.tokenizeEncoded(e, t, o);
    if (r !== 0)
      for (let c = 0, d = l.tokens.length; c < d; c += 2)
        l.tokens[c] += r;
    return this._prependTokens = cL._merge(this._prependTokens, this._tokens, l.tokens), this._tokens = [], this._currentLanguageId = 0, this._lastTokenMetadata = 0, l.endState;
  }
  finalize(e) {
    return new zA(cL._merge(this._prependTokens, this._tokens, null), e);
  }
}
let Vy = SF = class extends we {
  constructor(e, t, n, r, s) {
    super(), this._configurationService = s, this._languageService = e, this._standaloneThemeService = t, this._languageId = n, this._lexer = r, this._embeddedLanguages = /* @__PURE__ */ Object.create(null), this.embeddedLoaded = Promise.resolve(void 0);
    let o = !1;
    this._register(Pi.onDidChange((a) => {
      if (o)
        return;
      let l = !1;
      for (let c = 0, d = a.changedLanguages.length; c < d; c++) {
        const u = a.changedLanguages[c];
        if (this._embeddedLanguages[u]) {
          l = !0;
          break;
        }
      }
      l && (o = !0, Pi.handleChange([this._languageId]), o = !1);
    })), this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", {
      overrideIdentifier: this._languageId
    }), this._register(this._configurationService.onDidChangeConfiguration((a) => {
      a.affectsConfiguration("editor.maxTokenizationLineLength") && (this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", {
        overrideIdentifier: this._languageId
      }));
    }));
  }
  getLoadStatus() {
    const e = [];
    for (const t in this._embeddedLanguages) {
      const n = Pi.get(t);
      if (n) {
        if (n instanceof SF) {
          const r = n.getLoadStatus();
          r.loaded === !1 && e.push(r.promise);
        }
        continue;
      }
      Pi.isResolved(t) || e.push(Pi.getOrCreate(t));
    }
    return e.length === 0 ? {
      loaded: !0
    } : {
      loaded: !1,
      promise: Promise.all(e).then((t) => {
      })
    };
  }
  getInitialState() {
    const e = By.create(null, this._lexer.start);
    return Vf.create(e, null);
  }
  tokenize(e, t, n) {
    if (e.length >= this._maxTokenizationLineLength)
      return oz(this._languageId, n);
    const r = new FOe(), s = this._tokenize(e, t, n, r);
    return r.finalize(s);
  }
  tokenizeEncoded(e, t, n) {
    if (e.length >= this._maxTokenizationLineLength)
      return f4(this._languageService.languageIdCodec.encodeLanguageId(this._languageId), n);
    const r = new cL(this._languageService, this._standaloneThemeService.getColorTheme().tokenTheme), s = this._tokenize(e, t, n, r);
    return r.finalize(s);
  }
  _tokenize(e, t, n, r) {
    return n.embeddedLanguageData ? this._nestedTokenize(e, t, n, 0, r) : this._myTokenize(e, t, n, 0, r);
  }
  _findLeavingNestedLanguageOffset(e, t) {
    let n = this._lexer.tokenizer[t.stack.state];
    if (!n && (n = zx(this._lexer, t.stack.state), !n))
      throw ni(this._lexer, "tokenizer state is not defined: " + t.stack.state);
    let r = -1, s = !1;
    for (const o of n) {
      if (!aZ(o.action) || o.action.nextEmbedded !== "@pop")
        continue;
      s = !0;
      let a = o.regex;
      const l = o.regex.source;
      if (l.substr(0, 4) === "^(?:" && l.substr(l.length - 1, 1) === ")") {
        const d = (a.ignoreCase ? "i" : "") + (a.unicode ? "u" : "");
        a = new RegExp(l.substr(4, l.length - 5), d);
      }
      const c = e.search(a);
      c === -1 || c !== 0 && o.matchOnlyAtLineStart || (r === -1 || c < r) && (r = c);
    }
    if (!s)
      throw ni(this._lexer, 'no rule containing nextEmbedded: "@pop" in tokenizer embedded state: ' + t.stack.state);
    return r;
  }
  _nestedTokenize(e, t, n, r, s) {
    const o = this._findLeavingNestedLanguageOffset(e, n);
    if (o === -1) {
      const c = s.nestedLanguageTokenize(e, t, n.embeddedLanguageData, r);
      return Vf.create(n.stack, new Q1(n.embeddedLanguageData.languageId, c));
    }
    const a = e.substring(0, o);
    a.length > 0 && s.nestedLanguageTokenize(a, !1, n.embeddedLanguageData, r);
    const l = e.substring(o);
    return this._myTokenize(l, t, n, r + o, s);
  }
  _safeRuleName(e) {
    return e ? e.name : "(unknown)";
  }
  _myTokenize(e, t, n, r, s) {
    s.enterLanguage(this._languageId);
    const o = e.length, a = t && this._lexer.includeLF ? e + `
` : e, l = a.length;
    let c = n.embeddedLanguageData, d = n.stack, u = 0, h = null, f = !0;
    for (; f || u < l; ) {
      const g = u, p = d.depth, m = h ? h.groups.length : 0, _ = d.state;
      let b = null, w = null, y = null, S = null, x = null;
      if (h) {
        b = h.matches;
        const L = h.groups.shift();
        w = L.matched, y = L.action, S = h.rule, h.groups.length === 0 && (h = null);
      } else {
        if (!f && u >= l)
          break;
        f = !1;
        let L = this._lexer.tokenizer[_];
        if (!L && (L = zx(this._lexer, _), !L))
          throw ni(this._lexer, "tokenizer state is not defined: " + _);
        const k = a.substr(u);
        for (const N of L)
          if ((u === 0 || !N.matchOnlyAtLineStart) && (b = k.match(N.regex), b)) {
            w = b[0], y = N.action;
            break;
          }
      }
      if (b || (b = [""], w = ""), y || (u < l && (b = [a.charAt(u)], w = b[0]), y = this._lexer.defaultToken), w === null)
        break;
      for (u += w.length; NOe(y) && aZ(y) && y.test; )
        y = y.test(w, b, _, u === l);
      let D = null;
      if (typeof y == "string" || Array.isArray(y))
        D = y;
      else if (y.group)
        D = y.group;
      else if (y.token !== null && y.token !== void 0) {
        if (y.tokenSubst ? D = Bf(this._lexer, y.token, w, b, _) : D = y.token, y.nextEmbedded)
          if (y.nextEmbedded === "@pop") {
            if (!c)
              throw ni(this._lexer, "cannot pop embedded language if not inside one");
            c = null;
          } else {
            if (c)
              throw ni(this._lexer, "cannot enter embedded language from within an embedded language");
            x = Bf(this._lexer, y.nextEmbedded, w, b, _);
          }
        if (y.goBack && (u = Math.max(0, u - y.goBack)), y.switchTo && typeof y.switchTo == "string") {
          let L = Bf(this._lexer, y.switchTo, w, b, _);
          if (L[0] === "@" && (L = L.substr(1)), zx(this._lexer, L))
            d = d.switchTo(L);
          else
            throw ni(this._lexer, "trying to switch to a state '" + L + "' that is undefined in rule: " + this._safeRuleName(S));
        } else {
          if (y.transform && typeof y.transform == "function")
            throw ni(this._lexer, "action.transform not supported");
          if (y.next)
            if (y.next === "@push") {
              if (d.depth >= this._lexer.maxStack)
                throw ni(this._lexer, "maximum tokenizer stack size reached: [" + d.state + "," + d.parent.state + ",...]");
              d = d.push(_);
            } else if (y.next === "@pop") {
              if (d.depth <= 1)
                throw ni(this._lexer, "trying to pop an empty stack in rule: " + this._safeRuleName(S));
              d = d.pop();
            } else if (y.next === "@popall")
              d = d.popall();
            else {
              let L = Bf(this._lexer, y.next, w, b, _);
              if (L[0] === "@" && (L = L.substr(1)), zx(this._lexer, L))
                d = d.push(L);
              else
                throw ni(this._lexer, "trying to set a next state '" + L + "' that is undefined in rule: " + this._safeRuleName(S));
            }
        }
        y.log && typeof y.log == "string" && POe(this._lexer, this._lexer.languageId + ": " + Bf(this._lexer, y.log, w, b, _));
      }
      if (D === null)
        throw ni(this._lexer, "lexer rule has no well-defined action in rule: " + this._safeRuleName(S));
      const E = (L) => {
        const k = this._languageService.getLanguageIdByLanguageName(L) || this._languageService.getLanguageIdByMimeType(L) || L, N = this._getNestedEmbeddedLanguageData(k);
        if (u < l) {
          const I = e.substr(u);
          return this._nestedTokenize(I, t, Vf.create(d, N), r + u, s);
        } else
          return Vf.create(d, N);
      };
      if (Array.isArray(D)) {
        if (h && h.groups.length > 0)
          throw ni(this._lexer, "groups cannot be nested: " + this._safeRuleName(S));
        if (b.length !== D.length + 1)
          throw ni(this._lexer, "matched number of groups does not match the number of actions in rule: " + this._safeRuleName(S));
        let L = 0;
        for (let k = 1; k < b.length; k++)
          L += b[k].length;
        if (L !== w.length)
          throw ni(this._lexer, "with groups, all characters should be matched in consecutive groups in rule: " + this._safeRuleName(S));
        h = {
          rule: S,
          matches: b,
          groups: []
        };
        for (let k = 0; k < D.length; k++)
          h.groups[k] = {
            action: D[k],
            matched: b[k + 1]
          };
        u -= w.length;
        continue;
      } else {
        if (D === "@rematch" && (u -= w.length, w = "", b = null, D = "", x !== null))
          return E(x);
        if (w.length === 0) {
          if (l === 0 || p !== d.depth || _ !== d.state || (h ? h.groups.length : 0) !== m)
            continue;
          throw ni(this._lexer, "no progress in tokenizer in rule: " + this._safeRuleName(S));
        }
        let L = null;
        if (Sfe(D) && D.indexOf("@brackets") === 0) {
          const k = D.substr(9), N = BOe(this._lexer, w);
          if (!N)
            throw ni(this._lexer, "@brackets token returned but no bracket defined as: " + w);
          L = lZ(N.token + k);
        } else {
          const k = D === "" ? "" : D + this._lexer.tokenPostfix;
          L = lZ(k);
        }
        g < o && s.emit(g + r, L);
      }
      if (x !== null)
        return E(x);
    }
    return Vf.create(d, c);
  }
  _getNestedEmbeddedLanguageData(e) {
    if (!this._languageService.isRegisteredLanguageId(e))
      return new Q1(e, __);
    e !== this._languageId && (this._languageService.requestBasicLanguageFeatures(e), Pi.getOrCreate(e), this._embeddedLanguages[e] = !0);
    const t = Pi.get(e);
    return t ? new Q1(e, t.getInitialState()) : new Q1(e, __);
  }
};
Vy = SF = MOe([
  ROe(4, en)
], Vy);
function BOe(i, e) {
  if (!e)
    return null;
  e = mg(i, e);
  const t = i.brackets;
  for (const n of t) {
    if (n.open === e)
      return {
        token: n.token,
        bracketType: 1
        /* monarchCommon.MonarchBracket.Open */
      };
    if (n.close === e)
      return {
        token: n.token,
        bracketType: -1
        /* monarchCommon.MonarchBracket.Close */
      };
  }
  return null;
}
var VOe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const D6 = af("standaloneColorizer", { createHTML: (i) => i });
class cz {
  static colorizeElement(e, t, n, r) {
    r = r || {};
    const s = r.theme || "vs", o = r.mimeType || n.getAttribute("lang") || n.getAttribute("data-lang");
    if (!o)
      return console.error("Mode not detected"), Promise.resolve();
    const a = t.getLanguageIdByMimeType(o) || o;
    e.setTheme(s);
    const l = n.firstChild ? n.firstChild.nodeValue : "";
    n.className += " " + s;
    const c = (d) => {
      var u;
      const h = (u = D6?.createHTML(d)) !== null && u !== void 0 ? u : d;
      n.innerHTML = h;
    };
    return this.colorize(t, l || "", a, r).then(c, (d) => console.error(d));
  }
  static colorize(e, t, n, r) {
    return VOe(this, void 0, void 0, function* () {
      const s = e.languageIdCodec;
      let o = 4;
      r && typeof r.tabSize == "number" && (o = r.tabSize), zj(t) && (t = t.substr(1));
      const a = Cu(t);
      if (!e.isRegisteredLanguageId(n))
        return cZ(a, o, s);
      const l = yield Pi.getOrCreate(n);
      return l ? HOe(a, o, l, s) : cZ(a, o, s);
    });
  }
  static colorizeLine(e, t, n, r, s = 4) {
    const o = Wa.isBasicASCII(e, t), a = Wa.containsRTL(e, o, n);
    return g4(new dp(!1, !0, e, !1, o, a, 0, r, [], s, 0, 0, 0, 0, -1, "none", !1, !1, null)).html;
  }
  static colorizeModelLine(e, t, n = 4) {
    const r = e.getLineContent(t);
    e.tokenization.forceTokenization(t);
    const o = e.tokenization.getLineTokens(t).inflate();
    return this.colorizeLine(r, e.mightContainNonBasicASCII(), e.mightContainRTL(), o, n);
  }
}
function HOe(i, e, t, n) {
  return new Promise((r, s) => {
    const o = () => {
      const a = WOe(i, e, t, n);
      if (t instanceof Vy) {
        const l = t.getLoadStatus();
        if (l.loaded === !1) {
          l.promise.then(o, s);
          return;
        }
      }
      r(a);
    };
    o();
  });
}
function cZ(i, e, t) {
  let n = [];
  const s = new Uint32Array(2);
  s[0] = 0, s[1] = 33587200;
  for (let o = 0, a = i.length; o < a; o++) {
    const l = i[o];
    s[0] = l.length;
    const c = new Tr(s, l, t), d = Wa.isBasicASCII(
      l,
      /* check for basic ASCII */
      !0
    ), u = Wa.containsRTL(
      l,
      d,
      /* check for RTL */
      !0
    ), h = g4(new dp(!1, !0, l, !1, d, u, 0, c, [], e, 0, 0, 0, 0, -1, "none", !1, !1, null));
    n = n.concat(h.html), n.push("<br/>");
  }
  return n.join("");
}
function WOe(i, e, t, n) {
  let r = [], s = t.getInitialState();
  for (let o = 0, a = i.length; o < a; o++) {
    const l = i[o], c = t.tokenizeEncoded(l, !0, s);
    Tr.convertToEndOffset(c.tokens, l.length);
    const d = new Tr(c.tokens, l, n), u = Wa.isBasicASCII(
      l,
      /* check for basic ASCII */
      !0
    ), h = Wa.containsRTL(
      l,
      u,
      /* check for RTL */
      !0
    ), f = g4(new dp(!1, !0, l, !1, u, h, 0, d.inflate(), [], e, 0, 0, 0, 0, -1, "none", !1, !1, null));
    r = r.concat(f.html), r.push("<br/>"), s = c.endState;
  }
  return r.join("");
}
const dZ = 2e4;
let Zp, B3, xF, V3, DF;
function jOe(i) {
  Zp = document.createElement("div"), Zp.className = "monaco-aria-container";
  const e = () => {
    const n = document.createElement("div");
    return n.className = "monaco-alert", n.setAttribute("role", "alert"), n.setAttribute("aria-atomic", "true"), Zp.appendChild(n), n;
  };
  B3 = e(), xF = e();
  const t = () => {
    const n = document.createElement("div");
    return n.className = "monaco-status", n.setAttribute("aria-live", "polite"), n.setAttribute("aria-atomic", "true"), Zp.appendChild(n), n;
  };
  V3 = t(), DF = t(), i.appendChild(Zp);
}
function Fs(i) {
  Zp && (B3.textContent !== i ? (ls(xF), dL(B3, i)) : (ls(B3), dL(xF, i)));
}
function Vg(i) {
  Zp && (V3.textContent !== i ? (ls(DF), dL(V3, i)) : (ls(V3), dL(DF, i)));
}
function dL(i, e) {
  ls(i), e.length > dZ && (e = e.substr(0, dZ)), i.textContent = e, i.style.visibility = "hidden", i.style.visibility = "visible";
}
const dz = Gt("markerDecorationsService");
var zOe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, UOe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Hy = class {
  constructor(e, t) {
  }
  dispose() {
  }
};
Hy.ID = "editor.contrib.markerDecorations";
Hy = zOe([
  UOe(1, dz)
], Hy);
pn(
  Hy.ID,
  Hy,
  0
  /* EditorContributionInstantiation.Eager */
);
class Dfe extends we {
  constructor(e, t) {
    super(), this._onDidChange = this._register(new pe()), this.onDidChange = this._onDidChange.event, this._referenceDomElement = e, this._width = -1, this._height = -1, this._resizeObserver = null, this.measureReferenceDomElement(!1, t);
  }
  dispose() {
    this.stopObserving(), super.dispose();
  }
  getWidth() {
    return this._width;
  }
  getHeight() {
    return this._height;
  }
  startObserving() {
    if (!this._resizeObserver && this._referenceDomElement) {
      let e = null;
      const t = () => {
        e ? this.observe({ width: e.width, height: e.height }) : this.observe();
      };
      let n = !1, r = !1;
      const s = () => {
        if (n && !r)
          try {
            n = !1, r = !0, t();
          } finally {
            requestAnimationFrame(() => {
              r = !1, s();
            });
          }
      };
      this._resizeObserver = new ResizeObserver((o) => {
        e = o && o[0] && o[0].contentRect ? o[0].contentRect : null, n = !0, s();
      }), this._resizeObserver.observe(this._referenceDomElement);
    }
  }
  stopObserving() {
    this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null);
  }
  observe(e) {
    this.measureReferenceDomElement(!0, e);
  }
  measureReferenceDomElement(e, t) {
    let n = 0, r = 0;
    t ? (n = t.width, r = t.height) : this._referenceDomElement && (n = this._referenceDomElement.clientWidth, r = this._referenceDomElement.clientHeight), n = Math.max(5, n), r = Math.max(5, r), (this._width !== n || this._height !== r) && (this._width = n, this._height = r, e && this._onDidChange.fire());
  }
}
class vg {
  constructor(e, t) {
    this.key = e, this.migrate = t;
  }
  apply(e) {
    const t = vg._read(e, this.key), n = (s) => vg._read(e, s), r = (s, o) => vg._write(e, s, o);
    this.migrate(t, n, r);
  }
  static _read(e, t) {
    if (typeof e > "u")
      return;
    const n = t.indexOf(".");
    if (n >= 0) {
      const r = t.substring(0, n);
      return this._read(e[r], t.substring(n + 1));
    }
    return e[t];
  }
  static _write(e, t, n) {
    const r = t.indexOf(".");
    if (r >= 0) {
      const s = t.substring(0, r);
      e[s] = e[s] || {}, this._write(e[s], t.substring(r + 1), n);
      return;
    }
    e[t] = n;
  }
}
vg.items = [];
function up(i, e) {
  vg.items.push(new vg(i, e));
}
function Al(i, e) {
  up(i, (t, n, r) => {
    if (typeof t < "u") {
      for (const [s, o] of e)
        if (t === s) {
          r(i, o);
          return;
        }
    }
  });
}
function GOe(i) {
  vg.items.forEach((e) => e.apply(i));
}
Al("wordWrap", [[!0, "on"], [!1, "off"]]);
Al("lineNumbers", [[!0, "on"], [!1, "off"]]);
Al("cursorBlinking", [["visible", "solid"]]);
Al("renderWhitespace", [[!0, "boundary"], [!1, "none"]]);
Al("renderLineHighlight", [[!0, "line"], [!1, "none"]]);
Al("acceptSuggestionOnEnter", [[!0, "on"], [!1, "off"]]);
Al("tabCompletion", [[!1, "off"], [!0, "onlySnippets"]]);
Al("hover", [[!0, { enabled: !0 }], [!1, { enabled: !1 }]]);
Al("parameterHints", [[!0, { enabled: !0 }], [!1, { enabled: !1 }]]);
Al("autoIndent", [[!1, "advanced"], [!0, "full"]]);
Al("matchBrackets", [[!0, "always"], [!1, "never"]]);
Al("renderFinalNewline", [[!0, "on"], [!1, "off"]]);
Al("cursorSmoothCaretAnimation", [[!0, "on"], [!1, "off"]]);
up("autoClosingBrackets", (i, e, t) => {
  i === !1 && (t("autoClosingBrackets", "never"), typeof e("autoClosingQuotes") > "u" && t("autoClosingQuotes", "never"), typeof e("autoSurround") > "u" && t("autoSurround", "never"));
});
up("renderIndentGuides", (i, e, t) => {
  typeof i < "u" && (t("renderIndentGuides", void 0), typeof e("guides.indentation") > "u" && t("guides.indentation", !!i));
});
up("highlightActiveIndentGuide", (i, e, t) => {
  typeof i < "u" && (t("highlightActiveIndentGuide", void 0), typeof e("guides.highlightActiveIndentation") > "u" && t("guides.highlightActiveIndentation", !!i));
});
const qOe = {
  method: "showMethods",
  function: "showFunctions",
  constructor: "showConstructors",
  deprecated: "showDeprecated",
  field: "showFields",
  variable: "showVariables",
  class: "showClasses",
  struct: "showStructs",
  interface: "showInterfaces",
  module: "showModules",
  property: "showProperties",
  event: "showEvents",
  operator: "showOperators",
  unit: "showUnits",
  value: "showValues",
  constant: "showConstants",
  enum: "showEnums",
  enumMember: "showEnumMembers",
  keyword: "showKeywords",
  text: "showWords",
  color: "showColors",
  file: "showFiles",
  reference: "showReferences",
  folder: "showFolders",
  typeParameter: "showTypeParameters",
  snippet: "showSnippets"
};
up("suggest.filteredTypes", (i, e, t) => {
  if (i && typeof i == "object") {
    for (const n of Object.entries(qOe))
      i[n[0]] === !1 && typeof e(`suggest.${n[1]}`) > "u" && t(`suggest.${n[1]}`, !1);
    t("suggest.filteredTypes", void 0);
  }
});
up("quickSuggestions", (i, e, t) => {
  if (typeof i == "boolean") {
    const n = i ? "on" : "off";
    t("quickSuggestions", { comments: n, strings: n, other: n });
  }
});
up("experimental.stickyScroll.enabled", (i, e, t) => {
  typeof i == "boolean" && (t("experimental.stickyScroll.enabled", void 0), typeof e("stickyScroll.enabled") > "u" && t("stickyScroll.enabled", i));
});
up("experimental.stickyScroll.maxLineCount", (i, e, t) => {
  typeof i == "number" && (t("experimental.stickyScroll.maxLineCount", void 0), typeof e("stickyScroll.maxLineCount") > "u" && t("stickyScroll.maxLineCount", i));
});
class KOe {
  constructor() {
    this._tabFocus = !1, this._onDidChangeTabFocus = new pe(), this.onDidChangeTabFocus = this._onDidChangeTabFocus.event;
  }
  getTabFocusMode() {
    return this._tabFocus;
  }
  setTabFocusMode(e) {
    this._tabFocus = e, this._onDidChangeTabFocus.fire(this._tabFocus);
  }
}
const b_ = new KOe(), lf = Gt("accessibilityService"), LS = new Ke("accessibilityModeEnabled", !1);
var YOe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, XOe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let EF = class extends we {
  constructor(e, t, n, r) {
    super(), this._accessibilityService = r, this._onDidChange = this._register(new pe()), this.onDidChange = this._onDidChange.event, this._onDidChangeFast = this._register(new pe()), this.onDidChangeFast = this._onDidChangeFast.event, this._isDominatedByLongLines = !1, this._viewLineCount = 1, this._lineNumbersDigitCount = 1, this._reservedHeight = 0, this._glyphMarginDecorationLaneCount = 1, this._computeOptionsMemory = new Kue(), this.isSimpleWidget = e, this._containerObserver = this._register(new Dfe(n, t.dimension)), this._rawOptions = uZ(t), this._validatedOptions = Hf.validateOptions(this._rawOptions), this.options = this._computeOptions(), this.options.get(
      13
      /* EditorOption.automaticLayout */
    ) && this._containerObserver.startObserving(), this._register(rl.onDidChangeZoomLevel(() => this._recomputeOptions())), this._register(b_.onDidChangeTabFocus(() => this._recomputeOptions())), this._register(this._containerObserver.onDidChange(() => this._recomputeOptions())), this._register(nF.onDidChange(() => this._recomputeOptions())), this._register(Ey.onDidChange(() => this._recomputeOptions())), this._register(this._accessibilityService.onDidChangeScreenReaderOptimized(() => this._recomputeOptions()));
  }
  _recomputeOptions() {
    const e = this._computeOptions(), t = Hf.checkEquals(this.options, e);
    t !== null && (this.options = e, this._onDidChangeFast.fire(t), this._onDidChange.fire(t));
  }
  _computeOptions() {
    const e = this._readEnvConfiguration(), t = xm.createFromValidatedSettings(this._validatedOptions, e.pixelRatio, this.isSimpleWidget), n = this._readFontInfo(t), r = {
      memory: this._computeOptionsMemory,
      outerWidth: e.outerWidth,
      outerHeight: e.outerHeight - this._reservedHeight,
      fontInfo: n,
      extraEditorClassName: e.extraEditorClassName,
      isDominatedByLongLines: this._isDominatedByLongLines,
      viewLineCount: this._viewLineCount,
      lineNumbersDigitCount: this._lineNumbersDigitCount,
      emptySelectionClipboard: e.emptySelectionClipboard,
      pixelRatio: e.pixelRatio,
      tabFocusMode: b_.getTabFocusMode(),
      accessibilitySupport: e.accessibilitySupport,
      glyphMarginDecorationLaneCount: this._glyphMarginDecorationLaneCount
    };
    return Hf.computeOptions(this._validatedOptions, r);
  }
  _readEnvConfiguration() {
    return {
      extraEditorClassName: QOe(),
      outerWidth: this._containerObserver.getWidth(),
      outerHeight: this._containerObserver.getHeight(),
      emptySelectionClipboard: Sm || bl,
      pixelRatio: Ey.value,
      accessibilitySupport: this._accessibilityService.isScreenReaderOptimized() ? 2 : this._accessibilityService.getAccessibilitySupport()
    };
  }
  _readFontInfo(e) {
    return nF.readFontInfo(e);
  }
  getRawOptions() {
    return this._rawOptions;
  }
  updateOptions(e) {
    const t = uZ(e);
    Hf.applyUpdate(this._rawOptions, t) && (this._validatedOptions = Hf.validateOptions(this._rawOptions), this._recomputeOptions());
  }
  observeContainer(e) {
    this._containerObserver.observe(e);
  }
  setIsDominatedByLongLines(e) {
    this._isDominatedByLongLines !== e && (this._isDominatedByLongLines = e, this._recomputeOptions());
  }
  setModelLineCount(e) {
    const t = ZOe(e);
    this._lineNumbersDigitCount !== t && (this._lineNumbersDigitCount = t, this._recomputeOptions());
  }
  setViewLineCount(e) {
    this._viewLineCount !== e && (this._viewLineCount = e, this._recomputeOptions());
  }
  setReservedHeight(e) {
    this._reservedHeight !== e && (this._reservedHeight = e, this._recomputeOptions());
  }
  setGlyphMarginDecorationLaneCount(e) {
    this._glyphMarginDecorationLaneCount !== e && (this._glyphMarginDecorationLaneCount = e, this._recomputeOptions());
  }
};
EF = YOe([
  XOe(3, lf)
], EF);
function ZOe(i) {
  let e = 0;
  for (; i; )
    i = Math.floor(i / 10), e++;
  return e || 1;
}
function QOe() {
  let i = "";
  return !Zh && !bhe && (i += "no-user-select "), Zh && (i += "no-minimap-shadow ", i += "enable-user-select "), sn && (i += "mac "), i;
}
class JOe {
  constructor() {
    this._values = [];
  }
  _read(e) {
    return this._values[e];
  }
  get(e) {
    return this._values[e];
  }
  _write(e, t) {
    this._values[e] = t;
  }
}
class $Oe {
  constructor() {
    this._values = [];
  }
  _read(e) {
    if (e >= this._values.length)
      throw new Error("Cannot read uninitialized value");
    return this._values[e];
  }
  get(e) {
    return this._read(e);
  }
  _write(e, t) {
    this._values[e] = t;
  }
}
class Hf {
  static validateOptions(e) {
    const t = new JOe();
    for (const n of q1) {
      const r = n.name === "_never_" ? void 0 : e[n.name];
      t._write(n.id, n.validate(r));
    }
    return t;
  }
  static computeOptions(e, t) {
    const n = new $Oe();
    for (const r of q1)
      n._write(r.id, r.compute(t, n, e._read(r.id)));
    return n;
  }
  static _deepEquals(e, t) {
    if (typeof e != "object" || typeof t != "object" || !e || !t)
      return e === t;
    if (Array.isArray(e) || Array.isArray(t))
      return Array.isArray(e) && Array.isArray(t) ? Qi(e, t) : !1;
    if (Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const n in e)
      if (!Hf._deepEquals(e[n], t[n]))
        return !1;
    return !0;
  }
  static checkEquals(e, t) {
    const n = [];
    let r = !1;
    for (const s of q1) {
      const o = !Hf._deepEquals(e._read(s.id), t._read(s.id));
      n[s.id] = o, o && (r = !0);
    }
    return r ? new que(n) : null;
  }
  /**
   * Returns true if something changed.
   * Modifies `options`.
  */
  static applyUpdate(e, t) {
    let n = !1;
    for (const r of q1)
      if (t.hasOwnProperty(r.name)) {
        const s = r.applyUpdate(e[r.name], t[r.name]);
        e[r.name] = s.newValue, n = n || s.didChange;
      }
    return n;
  }
}
function uZ(i) {
  const e = lh(i);
  return GOe(e), e;
}
function cr(i, e, t) {
  let n = null, r = null;
  if (typeof t.value == "function" ? (n = "value", r = t.value, r.length !== 0 && console.warn("Memoize should only be used in functions with zero parameters")) : typeof t.get == "function" && (n = "get", r = t.get), !r)
    throw new Error("not supported");
  const s = `$memoize$${e}`;
  t[n] = function(...o) {
    return this.hasOwnProperty(s) || Object.defineProperty(this, s, {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: r.apply(this, o)
    }), this[s];
  };
}
var eMe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Wn;
(function(i) {
  i.Tap = "-monaco-gesturetap", i.Change = "-monaco-gesturechange", i.Start = "-monaco-gesturestart", i.End = "-monaco-gesturesend", i.Contextmenu = "-monaco-gesturecontextmenu";
})(Wn || (Wn = {}));
class Vn extends we {
  constructor() {
    super(), this.dispatched = !1, this.targets = new fo(), this.ignoreTargets = new fo(), this.activeTouches = {}, this.handle = null, this._lastSetTapCountTime = 0, this._register(Ie(document, "touchstart", (e) => this.onTouchStart(e), { passive: !1 })), this._register(Ie(document, "touchend", (e) => this.onTouchEnd(e))), this._register(Ie(document, "touchmove", (e) => this.onTouchMove(e), { passive: !1 }));
  }
  static addTarget(e) {
    if (!Vn.isTouchDevice())
      return we.None;
    Vn.INSTANCE || (Vn.INSTANCE = new Vn());
    const t = Vn.INSTANCE.targets.push(e);
    return Ct(t);
  }
  static ignoreTarget(e) {
    if (!Vn.isTouchDevice())
      return we.None;
    Vn.INSTANCE || (Vn.INSTANCE = new Vn());
    const t = Vn.INSTANCE.ignoreTargets.push(e);
    return Ct(t);
  }
  static isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
  }
  dispose() {
    this.handle && (this.handle.dispose(), this.handle = null), super.dispose();
  }
  onTouchStart(e) {
    const t = Date.now();
    this.handle && (this.handle.dispose(), this.handle = null);
    for (let n = 0, r = e.targetTouches.length; n < r; n++) {
      const s = e.targetTouches.item(n);
      this.activeTouches[s.identifier] = {
        id: s.identifier,
        initialTarget: s.target,
        initialTimeStamp: t,
        initialPageX: s.pageX,
        initialPageY: s.pageY,
        rollingTimestamps: [t],
        rollingPageX: [s.pageX],
        rollingPageY: [s.pageY]
      };
      const o = this.newGestureEvent(Wn.Start, s.target);
      o.pageX = s.pageX, o.pageY = s.pageY, this.dispatchEvent(o);
    }
    this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
  }
  onTouchEnd(e) {
    const t = Date.now(), n = Object.keys(this.activeTouches).length;
    for (let r = 0, s = e.changedTouches.length; r < s; r++) {
      const o = e.changedTouches.item(r);
      if (!this.activeTouches.hasOwnProperty(String(o.identifier))) {
        console.warn("move of an UNKNOWN touch", o);
        continue;
      }
      const a = this.activeTouches[o.identifier], l = Date.now() - a.initialTimeStamp;
      if (l < Vn.HOLD_DELAY && Math.abs(a.initialPageX - Ja(a.rollingPageX)) < 30 && Math.abs(a.initialPageY - Ja(a.rollingPageY)) < 30) {
        const c = this.newGestureEvent(Wn.Tap, a.initialTarget);
        c.pageX = Ja(a.rollingPageX), c.pageY = Ja(a.rollingPageY), this.dispatchEvent(c);
      } else if (l >= Vn.HOLD_DELAY && Math.abs(a.initialPageX - Ja(a.rollingPageX)) < 30 && Math.abs(a.initialPageY - Ja(a.rollingPageY)) < 30) {
        const c = this.newGestureEvent(Wn.Contextmenu, a.initialTarget);
        c.pageX = Ja(a.rollingPageX), c.pageY = Ja(a.rollingPageY), this.dispatchEvent(c);
      } else if (n === 1) {
        const c = Ja(a.rollingPageX), d = Ja(a.rollingPageY), u = Ja(a.rollingTimestamps) - a.rollingTimestamps[0], h = c - a.rollingPageX[0], f = d - a.rollingPageY[0], g = [...this.targets].filter((p) => a.initialTarget instanceof Node && p.contains(a.initialTarget));
        this.inertia(
          g,
          t,
          // time now
          Math.abs(h) / u,
          // speed
          h > 0 ? 1 : -1,
          // x direction
          c,
          // x now
          Math.abs(f) / u,
          // y speed
          f > 0 ? 1 : -1,
          // y direction
          d
          // y now
        );
      }
      this.dispatchEvent(this.newGestureEvent(Wn.End, a.initialTarget)), delete this.activeTouches[o.identifier];
    }
    this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
  }
  newGestureEvent(e, t) {
    const n = document.createEvent("CustomEvent");
    return n.initEvent(e, !1, !0), n.initialTarget = t, n.tapCount = 0, n;
  }
  dispatchEvent(e) {
    if (e.type === Wn.Tap) {
      const t = (/* @__PURE__ */ new Date()).getTime();
      let n = 0;
      t - this._lastSetTapCountTime > Vn.CLEAR_TAP_COUNT_TIME ? n = 1 : n = 2, this._lastSetTapCountTime = t, e.tapCount = n;
    } else (e.type === Wn.Change || e.type === Wn.Contextmenu) && (this._lastSetTapCountTime = 0);
    if (e.initialTarget instanceof Node) {
      for (const t of this.ignoreTargets)
        if (t.contains(e.initialTarget))
          return;
      for (const t of this.targets)
        t.contains(e.initialTarget) && (t.dispatchEvent(e), this.dispatched = !0);
    }
  }
  inertia(e, t, n, r, s, o, a, l) {
    this.handle = Cl(() => {
      const c = Date.now(), d = c - t;
      let u = 0, h = 0, f = !0;
      n += Vn.SCROLL_FRICTION * d, o += Vn.SCROLL_FRICTION * d, n > 0 && (f = !1, u = r * n * d), o > 0 && (f = !1, h = a * o * d);
      const g = this.newGestureEvent(Wn.Change);
      g.translationX = u, g.translationY = h, e.forEach((p) => p.dispatchEvent(g)), f || this.inertia(e, c, n, r, s + u, o, a, l + h);
    });
  }
  onTouchMove(e) {
    const t = Date.now();
    for (let n = 0, r = e.changedTouches.length; n < r; n++) {
      const s = e.changedTouches.item(n);
      if (!this.activeTouches.hasOwnProperty(String(s.identifier))) {
        console.warn("end of an UNKNOWN touch", s);
        continue;
      }
      const o = this.activeTouches[s.identifier], a = this.newGestureEvent(Wn.Change, o.initialTarget);
      a.translationX = s.pageX - Ja(o.rollingPageX), a.translationY = s.pageY - Ja(o.rollingPageY), a.pageX = s.pageX, a.pageY = s.pageY, this.dispatchEvent(a), o.rollingPageX.length > 3 && (o.rollingPageX.shift(), o.rollingPageY.shift(), o.rollingTimestamps.shift()), o.rollingPageX.push(s.pageX), o.rollingPageY.push(s.pageY), o.rollingTimestamps.push(t);
    }
    this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
  }
}
Vn.SCROLL_FRICTION = -5e-3;
Vn.HOLD_DELAY = 700;
Vn.CLEAR_TAP_COUNT_TIME = 400;
eMe([
  cr
], Vn, "isTouchDevice", null);
class vb {
  constructor() {
    this._hooks = new Ne(), this._pointerMoveCallback = null, this._onStopCallback = null;
  }
  dispose() {
    this.stopMonitoring(!1), this._hooks.dispose();
  }
  stopMonitoring(e, t) {
    if (!this.isMonitoring())
      return;
    this._hooks.clear(), this._pointerMoveCallback = null;
    const n = this._onStopCallback;
    this._onStopCallback = null, e && n && n(t);
  }
  isMonitoring() {
    return !!this._pointerMoveCallback;
  }
  startMonitoring(e, t, n, r, s) {
    this.isMonitoring() && this.stopMonitoring(!1), this._pointerMoveCallback = r, this._onStopCallback = s;
    let o = e;
    try {
      e.setPointerCapture(t), this._hooks.add(Ct(() => {
        try {
          e.releasePointerCapture(t);
        } catch {
        }
      }));
    } catch {
      o = window;
    }
    this._hooks.add(Ie(o, Ge.POINTER_MOVE, (a) => {
      if (a.buttons !== n) {
        this.stopMonitoring(!0);
        return;
      }
      a.preventDefault(), this._pointerMoveCallback(a);
    })), this._hooks.add(Ie(o, Ge.POINTER_UP, (a) => this.stopMonitoring(!0)));
  }
}
function uz(i) {
  return `--vscode-${i.replace(/\./g, "-")}`;
}
function Ye(i) {
  return `var(${uz(i)})`;
}
function tMe(i, e) {
  return `var(${uz(i)}, ${e})`;
}
const Efe = {
  ColorContribution: "base.contributions.colors"
};
class nMe {
  constructor() {
    this._onDidChangeSchema = new pe(), this.onDidChangeSchema = this._onDidChangeSchema.event, this.colorSchema = { type: "object", properties: {} }, this.colorReferenceSchema = { type: "string", enum: [], enumDescriptions: [] }, this.colorsById = {};
  }
  registerColor(e, t, n, r = !1, s) {
    const o = { id: e, description: n, defaults: t, needsTransparency: r, deprecationMessage: s };
    this.colorsById[e] = o;
    const a = { type: "string", description: n, format: "color-hex", defaultSnippets: [{ body: "${1:#ff0000}" }] };
    return s && (a.deprecationMessage = s), this.colorSchema.properties[e] = a, this.colorReferenceSchema.enum.push(e), this.colorReferenceSchema.enumDescriptions.push(n), this._onDidChangeSchema.fire(), e;
  }
  getColors() {
    return Object.keys(this.colorsById).map((e) => this.colorsById[e]);
  }
  resolveDefaultColor(e, t) {
    const n = this.colorsById[e];
    if (n && n.defaults) {
      const r = n.defaults[t.type];
      return xc(r, t);
    }
  }
  getColorSchema() {
    return this.colorSchema;
  }
  toString() {
    const e = (t, n) => {
      const r = t.indexOf(".") === -1 ? 0 : 1, s = n.indexOf(".") === -1 ? 0 : 1;
      return r !== s ? r - s : t.localeCompare(n);
    };
    return Object.keys(this.colorsById).sort(e).map((t) => `- \`${t}\`: ${this.colorsById[t].description}`).join(`
`);
  }
}
const p4 = new nMe();
Di.add(Efe.ColorContribution, p4);
function ne(i, e, t, n, r) {
  return p4.registerColor(i, e, t, n, r);
}
const Ve = ne("foreground", { dark: "#CCCCCC", light: "#616161", hcDark: "#FFFFFF", hcLight: "#292929" }, C("foreground", "Overall foreground color. This color is only used if not overridden by a component."));
ne("disabledForeground", { dark: "#CCCCCC80", light: "#61616180", hcDark: "#A5A5A5", hcLight: "#7F7F7F" }, C("disabledForeground", "Overall foreground for disabled elements. This color is only used if not overridden by a component."));
const iMe = ne("errorForeground", { dark: "#F48771", light: "#A1260D", hcDark: "#F48771", hcLight: "#B5200D" }, C("errorForeground", "Overall foreground color for error messages. This color is only used if not overridden by a component."));
ne("descriptionForeground", { light: "#717171", dark: dt(Ve, 0.7), hcDark: dt(Ve, 0.7), hcLight: dt(Ve, 0.7) }, C("descriptionForeground", "Foreground color for description text providing additional information, for example for a label."));
const Qf = ne("icon.foreground", { dark: "#C5C5C5", light: "#424242", hcDark: "#FFFFFF", hcLight: "#292929" }, C("iconForeground", "The default color for icons in the workbench.")), Ta = ne("focusBorder", { dark: "#007FD4", light: "#0090F1", hcDark: "#F38518", hcLight: "#006BBD" }, C("focusBorder", "Overall border color for focused elements. This color is only used if not overridden by a component.")), $t = ne("contrastBorder", { light: null, dark: null, hcDark: "#6FC3DF", hcLight: "#0F4A85" }, C("contrastBorder", "An extra border around elements to separate them from others for greater contrast.")), ii = ne("contrastActiveBorder", { light: null, dark: null, hcDark: Ta, hcLight: Ta }, C("activeContrastBorder", "An extra border around active elements to separate them from others for greater contrast."));
ne("selection.background", { light: null, dark: null, hcDark: null, hcLight: null }, C("selectionBackground", "The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor."));
ne("textSeparator.foreground", { light: "#0000002e", dark: "#ffffff2e", hcDark: ye.black, hcLight: "#292929" }, C("textSeparatorForeground", "Color for text separators."));
const rMe = ne("textLink.foreground", { light: "#006AB1", dark: "#3794FF", hcDark: "#3794FF", hcLight: "#0F4A85" }, C("textLinkForeground", "Foreground color for links in text."));
ne("textLink.activeForeground", { light: "#006AB1", dark: "#3794FF", hcDark: "#3794FF", hcLight: "#0F4A85" }, C("textLinkActiveForeground", "Foreground color for links in text when clicked on and on mouse hover."));
ne("textPreformat.foreground", { light: "#A31515", dark: "#D7BA7D", hcDark: "#D7BA7D", hcLight: "#292929" }, C("textPreformatForeground", "Foreground color for preformatted text segments."));
ne("textBlockQuote.background", { light: "#7f7f7f1a", dark: "#7f7f7f1a", hcDark: null, hcLight: "#F2F2F2" }, C("textBlockQuoteBackground", "Background color for block quotes in text."));
ne("textBlockQuote.border", { light: "#007acc80", dark: "#007acc80", hcDark: ye.white, hcLight: "#292929" }, C("textBlockQuoteBorder", "Border color for block quotes in text."));
ne("textCodeBlock.background", { light: "#dcdcdc66", dark: "#0a0a0a66", hcDark: ye.black, hcLight: "#F2F2F2" }, C("textCodeBlockBackground", "Background color for code blocks in text."));
const Qd = ne("widget.shadow", { dark: dt(ye.black, 0.36), light: dt(ye.black, 0.16), hcDark: null, hcLight: null }, C("widgetShadow", "Shadow color of widgets such as find/replace inside the editor.")), hz = ne("widget.border", { dark: null, light: null, hcDark: $t, hcLight: $t }, C("widgetBorder", "Border color of widgets such as find/replace inside the editor.")), Lfe = ne("input.background", { dark: "#3C3C3C", light: ye.white, hcDark: ye.black, hcLight: ye.white }, C("inputBoxBackground", "Input box background.")), Ife = ne("input.foreground", { dark: Ve, light: Ve, hcDark: Ve, hcLight: Ve }, C("inputBoxForeground", "Input box foreground.")), Afe = ne("input.border", { dark: null, light: null, hcDark: $t, hcLight: $t }, C("inputBoxBorder", "Input box border.")), fz = ne("inputOption.activeBorder", { dark: "#007ACC", light: "#007ACC", hcDark: $t, hcLight: $t }, C("inputBoxActiveOptionBorder", "Border color of activated options in input fields."));
ne("inputOption.hoverBackground", { dark: "#5a5d5e80", light: "#b8b8b850", hcDark: null, hcLight: null }, C("inputOption.hoverBackground", "Background color of activated options in input fields."));
const dm = ne("inputOption.activeBackground", { dark: dt(Ta, 0.4), light: dt(Ta, 0.2), hcDark: ye.transparent, hcLight: ye.transparent }, C("inputOption.activeBackground", "Background hover color of options in input fields.")), gz = ne("inputOption.activeForeground", { dark: ye.white, light: ye.black, hcDark: Ve, hcLight: Ve }, C("inputOption.activeForeground", "Foreground color of activated options in input fields."));
ne("input.placeholderForeground", { light: dt(Ve, 0.5), dark: dt(Ve, 0.5), hcDark: dt(Ve, 0.7), hcLight: dt(Ve, 0.7) }, C("inputPlaceholderForeground", "Input box foreground color for placeholder text."));
const sMe = ne("inputValidation.infoBackground", { dark: "#063B49", light: "#D6ECF2", hcDark: ye.black, hcLight: ye.white }, C("inputValidationInfoBackground", "Input validation background color for information severity.")), oMe = ne("inputValidation.infoForeground", { dark: null, light: null, hcDark: null, hcLight: Ve }, C("inputValidationInfoForeground", "Input validation foreground color for information severity.")), aMe = ne("inputValidation.infoBorder", { dark: "#007acc", light: "#007acc", hcDark: $t, hcLight: $t }, C("inputValidationInfoBorder", "Input validation border color for information severity.")), lMe = ne("inputValidation.warningBackground", { dark: "#352A05", light: "#F6F5D2", hcDark: ye.black, hcLight: ye.white }, C("inputValidationWarningBackground", "Input validation background color for warning severity.")), cMe = ne("inputValidation.warningForeground", { dark: null, light: null, hcDark: null, hcLight: Ve }, C("inputValidationWarningForeground", "Input validation foreground color for warning severity.")), dMe = ne("inputValidation.warningBorder", { dark: "#B89500", light: "#B89500", hcDark: $t, hcLight: $t }, C("inputValidationWarningBorder", "Input validation border color for warning severity.")), uMe = ne("inputValidation.errorBackground", { dark: "#5A1D1D", light: "#F2DEDE", hcDark: ye.black, hcLight: ye.white }, C("inputValidationErrorBackground", "Input validation background color for error severity.")), hMe = ne("inputValidation.errorForeground", { dark: null, light: null, hcDark: null, hcLight: Ve }, C("inputValidationErrorForeground", "Input validation foreground color for error severity.")), fMe = ne("inputValidation.errorBorder", { dark: "#BE1100", light: "#BE1100", hcDark: $t, hcLight: $t }, C("inputValidationErrorBorder", "Input validation border color for error severity.")), Jd = ne("dropdown.background", { dark: "#3C3C3C", light: ye.white, hcDark: ye.black, hcLight: ye.white }, C("dropdownBackground", "Dropdown background.")), gMe = ne("dropdown.listBackground", { dark: null, light: null, hcDark: ye.black, hcLight: ye.white }, C("dropdownListBackground", "Dropdown list background.")), Eh = ne("dropdown.foreground", { dark: "#F0F0F0", light: Ve, hcDark: ye.white, hcLight: Ve }, C("dropdownForeground", "Dropdown foreground.")), J1 = ne("dropdown.border", { dark: Jd, light: "#CECECE", hcDark: $t, hcLight: $t }, C("dropdownBorder", "Dropdown border.")), z2 = ne("button.foreground", { dark: ye.white, light: ye.white, hcDark: ye.white, hcLight: ye.white }, C("buttonForeground", "Button foreground color.")), pMe = ne("button.separator", { dark: dt(z2, 0.4), light: dt(z2, 0.4), hcDark: dt(z2, 0.4), hcLight: dt(z2, 0.4) }, C("buttonSeparator", "Button separator color.")), U2 = ne("button.background", { dark: "#0E639C", light: "#007ACC", hcDark: null, hcLight: "#0F4A85" }, C("buttonBackground", "Button background color.")), mMe = ne("button.hoverBackground", { dark: $c(U2, 0.2), light: P0(U2, 0.2), hcDark: U2, hcLight: U2 }, C("buttonHoverBackground", "Button background color when hovering.")), vMe = ne("button.border", { dark: $t, light: $t, hcDark: $t, hcLight: $t }, C("buttonBorder", "Button border color.")), _Me = ne("button.secondaryForeground", { dark: ye.white, light: ye.white, hcDark: ye.white, hcLight: Ve }, C("buttonSecondaryForeground", "Secondary button foreground color.")), LF = ne("button.secondaryBackground", { dark: "#3A3D41", light: "#5F6A79", hcDark: null, hcLight: ye.white }, C("buttonSecondaryBackground", "Secondary button background color.")), bMe = ne("button.secondaryHoverBackground", { dark: $c(LF, 0.2), light: P0(LF, 0.2), hcDark: null, hcLight: null }, C("buttonSecondaryHoverBackground", "Secondary button background color when hovering.")), H3 = ne("badge.background", { dark: "#4D4D4D", light: "#C4C4C4", hcDark: ye.black, hcLight: "#0F4A85" }, C("badgeBackground", "Badge background color. Badges are small information labels, e.g. for search results count.")), CMe = ne("badge.foreground", { dark: ye.white, light: "#333", hcDark: ye.white, hcLight: ye.white }, C("badgeForeground", "Badge foreground color. Badges are small information labels, e.g. for search results count.")), yMe = ne("scrollbar.shadow", { dark: "#000000", light: "#DDDDDD", hcDark: null, hcLight: null }, C("scrollbarShadow", "Scrollbar shadow to indicate that the view is scrolled.")), G2 = ne("scrollbarSlider.background", { dark: ye.fromHex("#797979").transparent(0.4), light: ye.fromHex("#646464").transparent(0.4), hcDark: dt($t, 0.6), hcLight: dt($t, 0.4) }, C("scrollbarSliderBackground", "Scrollbar slider background color.")), q2 = ne("scrollbarSlider.hoverBackground", { dark: ye.fromHex("#646464").transparent(0.7), light: ye.fromHex("#646464").transparent(0.7), hcDark: dt($t, 0.8), hcLight: dt($t, 0.8) }, C("scrollbarSliderHoverBackground", "Scrollbar slider background color when hovering.")), K2 = ne("scrollbarSlider.activeBackground", { dark: ye.fromHex("#BFBFBF").transparent(0.4), light: ye.fromHex("#000000").transparent(0.6), hcDark: $t, hcLight: $t }, C("scrollbarSliderActiveBackground", "Scrollbar slider background color when clicked on.")), wMe = ne("progressBar.background", { dark: ye.fromHex("#0E70C0"), light: ye.fromHex("#0E70C0"), hcDark: $t, hcLight: $t }, C("progressBarBackground", "Background color of the progress bar that can show for long running operations."));
ne("editorError.background", { dark: null, light: null, hcDark: null, hcLight: null }, C("editorError.background", "Background color of error text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0);
const $d = ne("editorError.foreground", { dark: "#F14C4C", light: "#E51400", hcDark: "#F48771", hcLight: "#B5200D" }, C("editorError.foreground", "Foreground color of error squigglies in the editor.")), SMe = ne("editorError.border", { dark: null, light: null, hcDark: ye.fromHex("#E47777").transparent(0.8), hcLight: "#B5200D" }, C("errorBorder", "If set, color of double underlines for errors in the editor."));
ne("editorWarning.background", { dark: null, light: null, hcDark: null, hcLight: null }, C("editorWarning.background", "Background color of warning text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0);
const Na = ne("editorWarning.foreground", { dark: "#CCA700", light: "#BF8803", hcDark: "#FFD370", hcLight: "#895503" }, C("editorWarning.foreground", "Foreground color of warning squigglies in the editor.")), Wy = ne("editorWarning.border", { dark: null, light: null, hcDark: ye.fromHex("#FFCC00").transparent(0.8), hcLight: ye.fromHex("#FFCC00").transparent(0.8) }, C("warningBorder", "If set, color of double underlines for warnings in the editor."));
ne("editorInfo.background", { dark: null, light: null, hcDark: null, hcLight: null }, C("editorInfo.background", "Background color of info text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0);
const Oo = ne("editorInfo.foreground", { dark: "#3794FF", light: "#1a85ff", hcDark: "#3794FF", hcLight: "#1a85ff" }, C("editorInfo.foreground", "Foreground color of info squigglies in the editor.")), jy = ne("editorInfo.border", { dark: null, light: null, hcDark: ye.fromHex("#3794FF").transparent(0.8), hcLight: "#292929" }, C("infoBorder", "If set, color of double underlines for infos in the editor.")), xMe = ne("editorHint.foreground", { dark: ye.fromHex("#eeeeee").transparent(0.7), light: "#6c6c6c", hcDark: null, hcLight: null }, C("editorHint.foreground", "Foreground color of hint squigglies in the editor."));
ne("editorHint.border", { dark: null, light: null, hcDark: ye.fromHex("#eeeeee").transparent(0.8), hcLight: "#292929" }, C("hintBorder", "If set, color of double underlines for hints in the editor."));
ne("sash.hoverBorder", { dark: Ta, light: Ta, hcDark: Ta, hcLight: Ta }, C("sashActiveBorder", "Border color of active sashes."));
const Nr = ne("editor.background", { light: "#ffffff", dark: "#1E1E1E", hcDark: ye.black, hcLight: ye.white }, C("editorBackground", "Editor background color.")), Ul = ne("editor.foreground", { light: "#333333", dark: "#BBBBBB", hcDark: ye.white, hcLight: Ve }, C("editorForeground", "Editor default foreground color."));
ne("editorStickyScroll.background", { light: Nr, dark: Nr, hcDark: Nr, hcLight: Nr }, C("editorStickyScrollBackground", "Sticky scroll background color for the editor"));
ne("editorStickyScrollHover.background", { dark: "#2A2D2E", light: "#F0F0F0", hcDark: null, hcLight: ye.fromHex("#0F4A85").transparent(0.1) }, C("editorStickyScrollHoverBackground", "Sticky scroll on hover background color for the editor"));
const ji = ne("editorWidget.background", { dark: "#252526", light: "#F3F3F3", hcDark: "#0C141F", hcLight: ye.white }, C("editorWidgetBackground", "Background color of editor widgets, such as find/replace.")), eu = ne("editorWidget.foreground", { dark: Ve, light: Ve, hcDark: Ve, hcLight: Ve }, C("editorWidgetForeground", "Foreground color of editor widgets, such as find/replace.")), tu = ne("editorWidget.border", { dark: "#454545", light: "#C8C8C8", hcDark: $t, hcLight: $t }, C("editorWidgetBorder", "Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget.")), DMe = ne("editorWidget.resizeBorder", { light: null, dark: null, hcDark: null, hcLight: null }, C("editorWidgetResizeBorder", "Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget.")), hZ = ne("quickInput.background", { dark: ji, light: ji, hcDark: ji, hcLight: ji }, C("pickerBackground", "Quick picker background color. The quick picker widget is the container for pickers like the command palette.")), EMe = ne("quickInput.foreground", { dark: eu, light: eu, hcDark: eu, hcLight: eu }, C("pickerForeground", "Quick picker foreground color. The quick picker widget is the container for pickers like the command palette.")), LMe = ne("quickInputTitle.background", { dark: new ye(new rn(255, 255, 255, 0.105)), light: new ye(new rn(0, 0, 0, 0.06)), hcDark: "#000000", hcLight: ye.white }, C("pickerTitleBackground", "Quick picker title background color. The quick picker widget is the container for pickers like the command palette.")), kfe = ne("pickerGroup.foreground", { dark: "#3794FF", light: "#0066BF", hcDark: ye.white, hcLight: "#0F4A85" }, C("pickerGroupForeground", "Quick picker color for grouping labels.")), IMe = ne("pickerGroup.border", { dark: "#3F3F46", light: "#CCCEDB", hcDark: ye.white, hcLight: "#0F4A85" }, C("pickerGroupBorder", "Quick picker color for grouping borders.")), AMe = ne("keybindingLabel.background", { dark: new ye(new rn(128, 128, 128, 0.17)), light: new ye(new rn(221, 221, 221, 0.4)), hcDark: ye.transparent, hcLight: ye.transparent }, C("keybindingLabelBackground", "Keybinding label background color. The keybinding label is used to represent a keyboard shortcut.")), kMe = ne("keybindingLabel.foreground", { dark: ye.fromHex("#CCCCCC"), light: ye.fromHex("#555555"), hcDark: ye.white, hcLight: Ve }, C("keybindingLabelForeground", "Keybinding label foreground color. The keybinding label is used to represent a keyboard shortcut.")), TMe = ne("keybindingLabel.border", { dark: new ye(new rn(51, 51, 51, 0.6)), light: new ye(new rn(204, 204, 204, 0.4)), hcDark: new ye(new rn(111, 195, 223)), hcLight: $t }, C("keybindingLabelBorder", "Keybinding label border color. The keybinding label is used to represent a keyboard shortcut.")), NMe = ne("keybindingLabel.bottomBorder", { dark: new ye(new rn(68, 68, 68, 0.6)), light: new ye(new rn(187, 187, 187, 0.4)), hcDark: new ye(new rn(111, 195, 223)), hcLight: Ve }, C("keybindingLabelBottomBorder", "Keybinding label border bottom color. The keybinding label is used to represent a keyboard shortcut.")), Jf = ne("editor.selectionBackground", { light: "#ADD6FF", dark: "#264F78", hcDark: "#f3f518", hcLight: "#0F4A85" }, C("editorSelectionBackground", "Color of the editor selection.")), PMe = ne("editor.selectionForeground", { light: null, dark: null, hcDark: "#000000", hcLight: ye.white }, C("editorSelectionForeground", "Color of the selected text for high contrast.")), Tfe = ne("editor.inactiveSelectionBackground", { light: dt(Jf, 0.5), dark: dt(Jf, 0.5), hcDark: dt(Jf, 0.7), hcLight: dt(Jf, 0.5) }, C("editorInactiveSelection", "Color of the selection in an inactive editor. The color must not be opaque so as not to hide underlying decorations."), !0), pz = ne("editor.selectionHighlightBackground", { light: bZ(Jf, Nr, 0.3, 0.6), dark: bZ(Jf, Nr, 0.3, 0.6), hcDark: null, hcLight: null }, C("editorSelectionHighlight", "Color for regions with the same content as the selection. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("editor.selectionHighlightBorder", { light: null, dark: null, hcDark: ii, hcLight: ii }, C("editorSelectionHighlightBorder", "Border color for regions with the same content as the selection."));
const OMe = ne("editor.findMatchBackground", { light: "#A8AC94", dark: "#515C6A", hcDark: null, hcLight: null }, C("editorFindMatch", "Color of the current search match.")), nu = ne("editor.findMatchHighlightBackground", { light: "#EA5C0055", dark: "#EA5C0055", hcDark: null, hcLight: null }, C("findMatchHighlight", "Color of the other search matches. The color must not be opaque so as not to hide underlying decorations."), !0), MMe = ne("editor.findRangeHighlightBackground", { dark: "#3a3d4166", light: "#b4b4b44d", hcDark: null, hcLight: null }, C("findRangeHighlight", "Color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), !0), RMe = ne("editor.findMatchBorder", { light: null, dark: null, hcDark: ii, hcLight: ii }, C("editorFindMatchBorder", "Border color of the current search match.")), $f = ne("editor.findMatchHighlightBorder", { light: null, dark: null, hcDark: ii, hcLight: ii }, C("findMatchHighlightBorder", "Border color of the other search matches.")), FMe = ne("editor.findRangeHighlightBorder", { dark: null, light: null, hcDark: dt(ii, 0.4), hcLight: dt(ii, 0.4) }, C("findRangeHighlightBorder", "Border color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("searchEditor.findMatchBackground", { light: dt(nu, 0.66), dark: dt(nu, 0.66), hcDark: nu, hcLight: nu }, C("searchEditor.queryMatch", "Color of the Search Editor query matches."));
ne("searchEditor.findMatchBorder", { light: dt($f, 0.66), dark: dt($f, 0.66), hcDark: $f, hcLight: $f }, C("searchEditor.editorFindMatchBorder", "Border color of the Search Editor query matches."));
ne("search.resultsInfoForeground", { light: Ve, dark: dt(Ve, 0.65), hcDark: Ve, hcLight: Ve }, C("search.resultsInfoForeground", "Color of the text in the search viewlet's completion message."));
ne("editor.hoverHighlightBackground", { light: "#ADD6FF26", dark: "#264f7840", hcDark: "#ADD6FF26", hcLight: null }, C("hoverHighlight", "Highlight below the word for which a hover is shown. The color must not be opaque so as not to hide underlying decorations."), !0);
const uL = ne("editorHoverWidget.background", { light: ji, dark: ji, hcDark: ji, hcLight: ji }, C("hoverBackground", "Background color of the editor hover."));
ne("editorHoverWidget.foreground", { light: eu, dark: eu, hcDark: eu, hcLight: eu }, C("hoverForeground", "Foreground color of the editor hover."));
const BMe = ne("editorHoverWidget.border", { light: tu, dark: tu, hcDark: tu, hcLight: tu }, C("hoverBorder", "Border color of the editor hover."));
ne("editorHoverWidget.statusBarBackground", { dark: $c(uL, 0.2), light: P0(uL, 0.05), hcDark: ji, hcLight: ji }, C("statusBarBackground", "Background color of the editor hover status bar."));
const VMe = ne("editorLink.activeForeground", { dark: "#4E94CE", light: ye.blue, hcDark: ye.cyan, hcLight: "#292929" }, C("activeLinkForeground", "Color of active links.")), Lh = ne("editorInlayHint.foreground", { dark: "#969696", light: "#969696", hcDark: ye.white, hcLight: ye.black }, C("editorInlayHintForeground", "Foreground color of inline hints")), Ih = ne("editorInlayHint.background", { dark: dt(H3, 0.1), light: dt(H3, 0.1), hcDark: dt(ye.white, 0.1), hcLight: dt(H3, 0.1) }, C("editorInlayHintBackground", "Background color of inline hints")), HMe = ne("editorInlayHint.typeForeground", { dark: Lh, light: Lh, hcDark: Lh, hcLight: Lh }, C("editorInlayHintForegroundTypes", "Foreground color of inline hints for types")), WMe = ne("editorInlayHint.typeBackground", { dark: Ih, light: Ih, hcDark: Ih, hcLight: Ih }, C("editorInlayHintBackgroundTypes", "Background color of inline hints for types")), jMe = ne("editorInlayHint.parameterForeground", { dark: Lh, light: Lh, hcDark: Lh, hcLight: Lh }, C("editorInlayHintForegroundParameter", "Foreground color of inline hints for parameters")), zMe = ne("editorInlayHint.parameterBackground", { dark: Ih, light: Ih, hcDark: Ih, hcLight: Ih }, C("editorInlayHintBackgroundParameter", "Background color of inline hints for parameters"));
ne("editorLightBulb.foreground", { dark: "#FFCC00", light: "#DDB100", hcDark: "#FFCC00", hcLight: "#007ACC" }, C("editorLightBulbForeground", "The color used for the lightbulb actions icon."));
ne("editorLightBulbAutoFix.foreground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, C("editorLightBulbAutoFixForeground", "The color used for the lightbulb auto fix actions icon."));
const IF = new ye(new rn(155, 185, 85, 0.2)), AF = new ye(new rn(255, 0, 0, 0.2)), UMe = ne("diffEditor.insertedTextBackground", { dark: "#9ccc2c33", light: "#9ccc2c40", hcDark: null, hcLight: null }, C("diffEditorInserted", "Background color for text that got inserted. The color must not be opaque so as not to hide underlying decorations."), !0), GMe = ne("diffEditor.removedTextBackground", { dark: "#ff000033", light: "#ff000033", hcDark: null, hcLight: null }, C("diffEditorRemoved", "Background color for text that got removed. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("diffEditor.insertedLineBackground", { dark: IF, light: IF, hcDark: null, hcLight: null }, C("diffEditorInsertedLines", "Background color for lines that got inserted. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("diffEditor.removedLineBackground", { dark: AF, light: AF, hcDark: null, hcLight: null }, C("diffEditorRemovedLines", "Background color for lines that got removed. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("diffEditorGutter.insertedLineBackground", { dark: null, light: null, hcDark: null, hcLight: null }, C("diffEditorInsertedLineGutter", "Background color for the margin where lines got inserted."));
ne("diffEditorGutter.removedLineBackground", { dark: null, light: null, hcDark: null, hcLight: null }, C("diffEditorRemovedLineGutter", "Background color for the margin where lines got removed."));
const qMe = ne("diffEditorOverview.insertedForeground", { dark: null, light: null, hcDark: null, hcLight: null }, C("diffEditorOverviewInserted", "Diff overview ruler foreground for inserted content.")), KMe = ne("diffEditorOverview.removedForeground", { dark: null, light: null, hcDark: null, hcLight: null }, C("diffEditorOverviewRemoved", "Diff overview ruler foreground for removed content."));
ne("diffEditor.insertedTextBorder", { dark: null, light: null, hcDark: "#33ff2eff", hcLight: "#374E06" }, C("diffEditorInsertedOutline", "Outline color for the text that got inserted."));
ne("diffEditor.removedTextBorder", { dark: null, light: null, hcDark: "#FF008F", hcLight: "#AD0707" }, C("diffEditorRemovedOutline", "Outline color for text that got removed."));
ne("diffEditor.border", { dark: null, light: null, hcDark: $t, hcLight: $t }, C("diffEditorBorder", "Border color between the two text editors."));
ne("diffEditor.diagonalFill", { dark: "#cccccc33", light: "#22222233", hcDark: null, hcLight: null }, C("diffDiagonalFill", "Color of the diff editor's diagonal fill. The diagonal fill is used in side-by-side diff views."));
ne("diffEditor.unchangedRegionBackground", { dark: "#3e3e3e", light: "#e4e4e4", hcDark: null, hcLight: null }, C("diffEditor.unchangedRegionBackground", "The background color of unchanged blocks in the diff editor."));
ne("diffEditor.unchangedRegionForeground", { dark: "#a3a2a2", light: "#4d4c4c", hcDark: null, hcLight: null }, C("diffEditor.unchangedRegionForeground", "The foreground color of unchanged blocks in the diff editor."));
ne("diffEditor.unchangedCodeBackground", { dark: "#74747429", light: "#b8b8b829", hcDark: null, hcLight: null }, C("diffEditor.unchangedCodeBackground", "The background color of unchanged code in the diff editor."));
const YMe = ne("list.focusBackground", { dark: null, light: null, hcDark: null, hcLight: null }, C("listFocusBackground", "List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), XMe = ne("list.focusForeground", { dark: null, light: null, hcDark: null, hcLight: null }, C("listFocusForeground", "List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), ZMe = ne("list.focusOutline", { dark: Ta, light: Ta, hcDark: ii, hcLight: ii }, C("listFocusOutline", "List/Tree outline color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), QMe = ne("list.focusAndSelectionOutline", { dark: null, light: null, hcDark: null, hcLight: null }, C("listFocusAndSelectionOutline", "List/Tree outline color for the focused item when the list/tree is active and selected. An active list/tree has keyboard focus, an inactive does not.")), Ah = ne("list.activeSelectionBackground", { dark: "#04395E", light: "#0060C0", hcDark: null, hcLight: ye.fromHex("#0F4A85").transparent(0.1) }, C("listActiveSelectionBackground", "List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), iu = ne("list.activeSelectionForeground", { dark: ye.white, light: ye.white, hcDark: null, hcLight: null }, C("listActiveSelectionForeground", "List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), Y2 = ne("list.activeSelectionIconForeground", { dark: null, light: null, hcDark: null, hcLight: null }, C("listActiveSelectionIconForeground", "List/Tree icon foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), JMe = ne("list.inactiveSelectionBackground", { dark: "#37373D", light: "#E4E6F1", hcDark: null, hcLight: ye.fromHex("#0F4A85").transparent(0.1) }, C("listInactiveSelectionBackground", "List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), $Me = ne("list.inactiveSelectionForeground", { dark: null, light: null, hcDark: null, hcLight: null }, C("listInactiveSelectionForeground", "List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), e8e = ne("list.inactiveSelectionIconForeground", { dark: null, light: null, hcDark: null, hcLight: null }, C("listInactiveSelectionIconForeground", "List/Tree icon foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), t8e = ne("list.inactiveFocusBackground", { dark: null, light: null, hcDark: null, hcLight: null }, C("listInactiveFocusBackground", "List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), n8e = ne("list.inactiveFocusOutline", { dark: null, light: null, hcDark: null, hcLight: null }, C("listInactiveFocusOutline", "List/Tree outline color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), Nfe = ne("list.hoverBackground", { dark: "#2A2D2E", light: "#F0F0F0", hcDark: ye.white.transparent(0.1), hcLight: ye.fromHex("#0F4A85").transparent(0.1) }, C("listHoverBackground", "List/Tree background when hovering over items using the mouse.")), Pfe = ne("list.hoverForeground", { dark: null, light: null, hcDark: null, hcLight: null }, C("listHoverForeground", "List/Tree foreground when hovering over items using the mouse.")), i8e = ne("list.dropBackground", { dark: "#062F4A", light: "#D6EBFF", hcDark: null, hcLight: null }, C("listDropBackground", "List/Tree drag and drop background when moving items around using the mouse.")), Gl = ne("list.highlightForeground", { dark: "#2AAAFF", light: "#0066BF", hcDark: Ta, hcLight: Ta }, C("highlight", "List/Tree foreground color of the match highlights when searching inside the list/tree.")), Ux = ne("list.focusHighlightForeground", { dark: Gl, light: P8e(Ah, Gl, "#BBE7FF"), hcDark: Gl, hcLight: Gl }, C("listFocusHighlightForeground", "List/Tree foreground color of the match highlights on actively focused items when searching inside the list/tree."));
ne("list.invalidItemForeground", { dark: "#B89500", light: "#B89500", hcDark: "#B89500", hcLight: "#B5200D" }, C("invalidItemForeground", "List/Tree foreground color for invalid items, for example an unresolved root in explorer."));
ne("list.errorForeground", { dark: "#F88070", light: "#B01011", hcDark: null, hcLight: null }, C("listErrorForeground", "Foreground color of list items containing errors."));
ne("list.warningForeground", { dark: "#CCA700", light: "#855F00", hcDark: null, hcLight: null }, C("listWarningForeground", "Foreground color of list items containing warnings."));
const r8e = ne("listFilterWidget.background", { light: P0(ji, 0), dark: $c(ji, 0), hcDark: ji, hcLight: ji }, C("listFilterWidgetBackground", "Background color of the type filter widget in lists and trees.")), s8e = ne("listFilterWidget.outline", { dark: ye.transparent, light: ye.transparent, hcDark: "#f38518", hcLight: "#007ACC" }, C("listFilterWidgetOutline", "Outline color of the type filter widget in lists and trees.")), o8e = ne("listFilterWidget.noMatchesOutline", { dark: "#BE1100", light: "#BE1100", hcDark: $t, hcLight: $t }, C("listFilterWidgetNoMatchesOutline", "Outline color of the type filter widget in lists and trees, when there are no matches.")), a8e = ne("listFilterWidget.shadow", { dark: Qd, light: Qd, hcDark: Qd, hcLight: Qd }, C("listFilterWidgetShadow", "Shadow color of the type filter widget in lists and trees."));
ne("list.filterMatchBackground", { dark: nu, light: nu, hcDark: null, hcLight: null }, C("listFilterMatchHighlight", "Background color of the filtered match."));
ne("list.filterMatchBorder", { dark: $f, light: $f, hcDark: $t, hcLight: ii }, C("listFilterMatchHighlightBorder", "Border color of the filtered match."));
const X2 = ne("tree.indentGuidesStroke", { dark: "#585858", light: "#a9a9a9", hcDark: "#a9a9a9", hcLight: "#a5a5a5" }, C("treeIndentGuidesStroke", "Tree stroke color for the indentation guides.")), l8e = ne("tree.inactiveIndentGuidesStroke", { dark: dt(X2, 0.4), light: dt(X2, 0.4), hcDark: dt(X2, 0.4), hcLight: dt(X2, 0.4) }, C("treeInactiveIndentGuidesStroke", "Tree stroke color for the indentation guides that are not active.")), c8e = ne("tree.tableColumnsBorder", { dark: "#CCCCCC20", light: "#61616120", hcDark: null, hcLight: null }, C("tableColumnsBorder", "Table border color between columns.")), d8e = ne("tree.tableOddRowsBackground", { dark: dt(Ve, 0.04), light: dt(Ve, 0.04), hcDark: null, hcLight: null }, C("tableOddRowsBackgroundColor", "Background color for odd table rows."));
ne("list.deemphasizedForeground", { dark: "#8C8C8C", light: "#8E8E90", hcDark: "#A7A8A9", hcLight: "#666666" }, C("listDeemphasizedForeground", "List/Tree foreground color for items that are deemphasized. "));
const u8e = ne("checkbox.background", { dark: Jd, light: Jd, hcDark: Jd, hcLight: Jd }, C("checkbox.background", "Background color of checkbox widget."));
ne("checkbox.selectBackground", { dark: ji, light: ji, hcDark: ji, hcLight: ji }, C("checkbox.select.background", "Background color of checkbox widget when the element it's in is selected."));
const h8e = ne("checkbox.foreground", { dark: Eh, light: Eh, hcDark: Eh, hcLight: Eh }, C("checkbox.foreground", "Foreground color of checkbox widget.")), f8e = ne("checkbox.border", { dark: J1, light: J1, hcDark: J1, hcLight: J1 }, C("checkbox.border", "Border color of checkbox widget."));
ne("checkbox.selectBorder", { dark: Qf, light: Qf, hcDark: Qf, hcLight: Qf }, C("checkbox.select.border", "Border color of checkbox widget when the element it's in is selected."));
const fZ = ne("quickInput.list.focusBackground", { dark: null, light: null, hcDark: null, hcLight: null }, "", void 0, C("quickInput.list.focusBackground deprecation", "Please use quickInputList.focusBackground instead")), um = ne("quickInputList.focusForeground", { dark: iu, light: iu, hcDark: iu, hcLight: iu }, C("quickInput.listFocusForeground", "Quick picker foreground color for the focused item.")), $1 = ne("quickInputList.focusIconForeground", { dark: Y2, light: Y2, hcDark: Y2, hcLight: Y2 }, C("quickInput.listFocusIconForeground", "Quick picker icon foreground color for the focused item.")), hm = ne("quickInputList.focusBackground", { dark: zy(fZ, Ah), light: zy(fZ, Ah), hcDark: null, hcLight: null }, C("quickInput.listFocusBackground", "Quick picker background color for the focused item.")), g8e = ne("menu.border", { dark: null, light: null, hcDark: $t, hcLight: $t }, C("menuBorder", "Border color of menus.")), p8e = ne("menu.foreground", { dark: Eh, light: Eh, hcDark: Eh, hcLight: Eh }, C("menuForeground", "Foreground color of menu items.")), m8e = ne("menu.background", { dark: Jd, light: Jd, hcDark: Jd, hcLight: Jd }, C("menuBackground", "Background color of menu items.")), v8e = ne("menu.selectionForeground", { dark: iu, light: iu, hcDark: iu, hcLight: iu }, C("menuSelectionForeground", "Foreground color of the selected menu item in menus.")), _8e = ne("menu.selectionBackground", { dark: Ah, light: Ah, hcDark: Ah, hcLight: Ah }, C("menuSelectionBackground", "Background color of the selected menu item in menus.")), b8e = ne("menu.selectionBorder", { dark: null, light: null, hcDark: ii, hcLight: ii }, C("menuSelectionBorder", "Border color of the selected menu item in menus.")), C8e = ne("menu.separatorBackground", { dark: "#606060", light: "#D4D4D4", hcDark: $t, hcLight: $t }, C("menuSeparatorBackground", "Color of a separator menu item in menus.")), kF = ne("toolbar.hoverBackground", { dark: "#5a5d5e50", light: "#b8b8b850", hcDark: null, hcLight: null }, C("toolbarHoverBackground", "Toolbar background when hovering over actions using the mouse"));
ne("toolbar.hoverOutline", { dark: null, light: null, hcDark: ii, hcLight: ii }, C("toolbarHoverOutline", "Toolbar outline when hovering over actions using the mouse"));
ne("toolbar.activeBackground", { dark: $c(kF, 0.1), light: P0(kF, 0.1), hcDark: null, hcLight: null }, C("toolbarActiveBackground", "Toolbar background when holding the mouse over actions"));
ne("editor.snippetTabstopHighlightBackground", { dark: new ye(new rn(124, 124, 124, 0.3)), light: new ye(new rn(10, 50, 100, 0.2)), hcDark: new ye(new rn(124, 124, 124, 0.3)), hcLight: new ye(new rn(10, 50, 100, 0.2)) }, C("snippetTabstopHighlightBackground", "Highlight background color of a snippet tabstop."));
ne("editor.snippetTabstopHighlightBorder", { dark: null, light: null, hcDark: null, hcLight: null }, C("snippetTabstopHighlightBorder", "Highlight border color of a snippet tabstop."));
ne("editor.snippetFinalTabstopHighlightBackground", { dark: null, light: null, hcDark: null, hcLight: null }, C("snippetFinalTabstopHighlightBackground", "Highlight background color of the final tabstop of a snippet."));
ne("editor.snippetFinalTabstopHighlightBorder", { dark: "#525252", light: new ye(new rn(10, 50, 100, 0.5)), hcDark: "#525252", hcLight: "#292929" }, C("snippetFinalTabstopHighlightBorder", "Highlight border color of the final tabstop of a snippet."));
const y8e = ne("breadcrumb.foreground", { light: dt(Ve, 0.8), dark: dt(Ve, 0.8), hcDark: dt(Ve, 0.8), hcLight: dt(Ve, 0.8) }, C("breadcrumbsFocusForeground", "Color of focused breadcrumb items.")), w8e = ne("breadcrumb.background", { light: Nr, dark: Nr, hcDark: Nr, hcLight: Nr }, C("breadcrumbsBackground", "Background color of breadcrumb items.")), gZ = ne("breadcrumb.focusForeground", { light: P0(Ve, 0.2), dark: $c(Ve, 0.1), hcDark: $c(Ve, 0.1), hcLight: $c(Ve, 0.1) }, C("breadcrumbsFocusForeground", "Color of focused breadcrumb items.")), S8e = ne("breadcrumb.activeSelectionForeground", { light: P0(Ve, 0.2), dark: $c(Ve, 0.1), hcDark: $c(Ve, 0.1), hcLight: $c(Ve, 0.1) }, C("breadcrumbsSelectedForeground", "Color of selected breadcrumb items."));
ne("breadcrumbPicker.background", { light: ji, dark: ji, hcDark: ji, hcLight: ji }, C("breadcrumbsSelectedBackground", "Background color of breadcrumb item picker."));
const Ofe = 0.5, pZ = ye.fromHex("#40C8AE").transparent(Ofe), mZ = ye.fromHex("#40A6FF").transparent(Ofe), vZ = ye.fromHex("#606060").transparent(0.4), ql = 0.4, C_ = 1, ev = ne("merge.currentHeaderBackground", { dark: pZ, light: pZ, hcDark: null, hcLight: null }, C("mergeCurrentHeaderBackground", "Current header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("merge.currentContentBackground", { dark: dt(ev, ql), light: dt(ev, ql), hcDark: dt(ev, ql), hcLight: dt(ev, ql) }, C("mergeCurrentContentBackground", "Current content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const tv = ne("merge.incomingHeaderBackground", { dark: mZ, light: mZ, hcDark: null, hcLight: null }, C("mergeIncomingHeaderBackground", "Incoming header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("merge.incomingContentBackground", { dark: dt(tv, ql), light: dt(tv, ql), hcDark: dt(tv, ql), hcLight: dt(tv, ql) }, C("mergeIncomingContentBackground", "Incoming content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const nv = ne("merge.commonHeaderBackground", { dark: vZ, light: vZ, hcDark: null, hcLight: null }, C("mergeCommonHeaderBackground", "Common ancestor header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("merge.commonContentBackground", { dark: dt(nv, ql), light: dt(nv, ql), hcDark: dt(nv, ql), hcLight: dt(nv, ql) }, C("mergeCommonContentBackground", "Common ancestor content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const y_ = ne("merge.border", { dark: null, light: null, hcDark: "#C3DF6F", hcLight: "#007ACC" }, C("mergeBorder", "Border color on headers and the splitter in inline merge-conflicts."));
ne("editorOverviewRuler.currentContentForeground", { dark: dt(ev, C_), light: dt(ev, C_), hcDark: y_, hcLight: y_ }, C("overviewRulerCurrentContentForeground", "Current overview ruler foreground for inline merge-conflicts."));
ne("editorOverviewRuler.incomingContentForeground", { dark: dt(tv, C_), light: dt(tv, C_), hcDark: y_, hcLight: y_ }, C("overviewRulerIncomingContentForeground", "Incoming overview ruler foreground for inline merge-conflicts."));
ne("editorOverviewRuler.commonContentForeground", { dark: dt(nv, C_), light: dt(nv, C_), hcDark: y_, hcLight: y_ }, C("overviewRulerCommonContentForeground", "Common ancestor overview ruler foreground for inline merge-conflicts."));
const mz = ne("editorOverviewRuler.findMatchForeground", { dark: "#d186167e", light: "#d186167e", hcDark: "#AB5A00", hcLight: "" }, C("overviewRulerFindMatchForeground", "Overview ruler marker color for find matches. The color must not be opaque so as not to hide underlying decorations."), !0), Z2 = ne("editorOverviewRuler.selectionHighlightForeground", { dark: "#A0A0A0CC", light: "#A0A0A0CC", hcDark: "#A0A0A0CC", hcLight: "#A0A0A0CC" }, C("overviewRulerSelectionHighlightForeground", "Overview ruler marker color for selection highlights. The color must not be opaque so as not to hide underlying decorations."), !0), iv = ne("minimap.findMatchHighlight", { light: "#d18616", dark: "#d18616", hcDark: "#AB5A00", hcLight: "#0F4A85" }, C("minimapFindMatchHighlight", "Minimap marker color for find matches."), !0), m4 = ne("minimap.selectionOccurrenceHighlight", { light: "#c9c9c9", dark: "#676767", hcDark: "#ffffff", hcLight: "#0F4A85" }, C("minimapSelectionOccurrenceHighlight", "Minimap marker color for repeating editor selections."), !0), _Z = ne("minimap.selectionHighlight", { light: "#ADD6FF", dark: "#264F78", hcDark: "#ffffff", hcLight: "#0F4A85" }, C("minimapSelectionHighlight", "Minimap marker color for the editor selection."), !0), x8e = ne("minimap.infoHighlight", { dark: Oo, light: Oo, hcDark: jy, hcLight: jy }, C("minimapInfo", "Minimap marker color for infos.")), D8e = ne("minimap.warningHighlight", { dark: Na, light: Na, hcDark: Wy, hcLight: Wy }, C("overviewRuleWarning", "Minimap marker color for warnings.")), E8e = ne("minimap.errorHighlight", { dark: new ye(new rn(255, 18, 18, 0.7)), light: new ye(new rn(255, 18, 18, 0.7)), hcDark: new ye(new rn(255, 50, 50, 1)), hcLight: "#B5200D" }, C("minimapError", "Minimap marker color for errors.")), L8e = ne("minimap.background", { dark: null, light: null, hcDark: null, hcLight: null }, C("minimapBackground", "Minimap background color.")), I8e = ne("minimap.foregroundOpacity", { dark: ye.fromHex("#000f"), light: ye.fromHex("#000f"), hcDark: ye.fromHex("#000f"), hcLight: ye.fromHex("#000f") }, C("minimapForegroundOpacity", 'Opacity of foreground elements rendered in the minimap. For example, "#000000c0" will render the elements with 75% opacity.'));
ne("minimapSlider.background", { light: dt(G2, 0.5), dark: dt(G2, 0.5), hcDark: dt(G2, 0.5), hcLight: dt(G2, 0.5) }, C("minimapSliderBackground", "Minimap slider background color."));
ne("minimapSlider.hoverBackground", { light: dt(q2, 0.5), dark: dt(q2, 0.5), hcDark: dt(q2, 0.5), hcLight: dt(q2, 0.5) }, C("minimapSliderHoverBackground", "Minimap slider background color when hovering."));
ne("minimapSlider.activeBackground", { light: dt(K2, 0.5), dark: dt(K2, 0.5), hcDark: dt(K2, 0.5), hcLight: dt(K2, 0.5) }, C("minimapSliderActiveBackground", "Minimap slider background color when clicked on."));
const A8e = ne("problemsErrorIcon.foreground", { dark: $d, light: $d, hcDark: $d, hcLight: $d }, C("problemsErrorIconForeground", "The color used for the problems error icon.")), k8e = ne("problemsWarningIcon.foreground", { dark: Na, light: Na, hcDark: Na, hcLight: Na }, C("problemsWarningIconForeground", "The color used for the problems warning icon.")), T8e = ne("problemsInfoIcon.foreground", { dark: Oo, light: Oo, hcDark: Oo, hcLight: Oo }, C("problemsInfoIconForeground", "The color used for the problems info icon."));
ne("charts.foreground", { dark: Ve, light: Ve, hcDark: Ve, hcLight: Ve }, C("chartsForeground", "The foreground color used in charts."));
ne("charts.lines", { dark: dt(Ve, 0.5), light: dt(Ve, 0.5), hcDark: dt(Ve, 0.5), hcLight: dt(Ve, 0.5) }, C("chartsLines", "The color used for horizontal lines in charts."));
ne("charts.red", { dark: $d, light: $d, hcDark: $d, hcLight: $d }, C("chartsRed", "The red color used in chart visualizations."));
ne("charts.blue", { dark: Oo, light: Oo, hcDark: Oo, hcLight: Oo }, C("chartsBlue", "The blue color used in chart visualizations."));
ne("charts.yellow", { dark: Na, light: Na, hcDark: Na, hcLight: Na }, C("chartsYellow", "The yellow color used in chart visualizations."));
ne("charts.orange", { dark: iv, light: iv, hcDark: iv, hcLight: iv }, C("chartsOrange", "The orange color used in chart visualizations."));
ne("charts.green", { dark: "#89D185", light: "#388A34", hcDark: "#89D185", hcLight: "#374e06" }, C("chartsGreen", "The green color used in chart visualizations."));
ne("charts.purple", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, C("chartsPurple", "The purple color used in chart visualizations."));
function N8e(i, e) {
  var t, n, r, s;
  switch (i.op) {
    case 0:
      return (t = xc(i.value, e)) === null || t === void 0 ? void 0 : t.darken(i.factor);
    case 1:
      return (n = xc(i.value, e)) === null || n === void 0 ? void 0 : n.lighten(i.factor);
    case 2:
      return (r = xc(i.value, e)) === null || r === void 0 ? void 0 : r.transparent(i.factor);
    case 3: {
      const o = xc(i.background, e);
      return o ? (s = xc(i.value, e)) === null || s === void 0 ? void 0 : s.makeOpaque(o) : xc(i.value, e);
    }
    case 4:
      for (const o of i.values) {
        const a = xc(o, e);
        if (a)
          return a;
      }
      return;
    case 6:
      return xc(e.defines(i.if) ? i.then : i.else, e);
    case 5: {
      const o = xc(i.value, e);
      if (!o)
        return;
      const a = xc(i.background, e);
      return a ? o.isDarkerThan(a) ? ye.getLighterColor(o, a, i.factor).transparent(i.transparency) : ye.getDarkerColor(o, a, i.factor).transparent(i.transparency) : o.transparent(i.factor * i.transparency);
    }
    default:
      throw $A();
  }
}
function P0(i, e) {
  return { op: 0, value: i, factor: e };
}
function $c(i, e) {
  return { op: 1, value: i, factor: e };
}
function dt(i, e) {
  return { op: 2, value: i, factor: e };
}
function zy(...i) {
  return { op: 4, values: i };
}
function P8e(i, e, t) {
  return { op: 6, if: i, then: e, else: t };
}
function bZ(i, e, t, n) {
  return { op: 5, value: i, background: e, factor: t, transparency: n };
}
function xc(i, e) {
  if (i !== null) {
    if (typeof i == "string")
      return i[0] === "#" ? ye.fromHex(i) : e.getColor(i);
    if (i instanceof ye)
      return i;
    if (typeof i == "object")
      return N8e(i, e);
  }
}
const Mfe = "vscode://schemas/workbench-colors", Rfe = Di.as(d4.JSONContribution);
Rfe.registerSchema(Mfe, p4.getColorSchema());
const CZ = new Rn(() => Rfe.notifySchemaChanged(Mfe), 200);
p4.onDidChangeSchema(() => {
  CZ.isScheduled() || CZ.schedule();
});
class v4 {
  constructor(e, t) {
    this.x = e, this.y = t, this._pageCoordinatesBrand = void 0;
  }
  toClientCoordinates() {
    return new Ffe(this.x - window.scrollX, this.y - window.scrollY);
  }
}
class Ffe {
  constructor(e, t) {
    this.clientX = e, this.clientY = t, this._clientCoordinatesBrand = void 0;
  }
  toPageCoordinates() {
    return new v4(this.clientX + window.scrollX, this.clientY + window.scrollY);
  }
}
class O8e {
  constructor(e, t, n, r) {
    this.x = e, this.y = t, this.width = n, this.height = r, this._editorPagePositionBrand = void 0;
  }
}
class M8e {
  constructor(e, t) {
    this.x = e, this.y = t, this._positionRelativeToEditorBrand = void 0;
  }
}
function vz(i) {
  const e = wr(i);
  return new O8e(e.left, e.top, e.width, e.height);
}
function _z(i, e, t) {
  const n = e.width / i.offsetWidth, r = e.height / i.offsetHeight, s = (t.x - e.x) / n, o = (t.y - e.y) / r;
  return new M8e(s, o);
}
class Hg extends cl {
  constructor(e, t, n) {
    super(e), this._editorMouseEventBrand = void 0, this.isFromPointerCapture = t, this.pos = new v4(this.posx, this.posy), this.editorPos = vz(n), this.relativePos = _z(n, this.editorPos, this.pos);
  }
}
class R8e {
  constructor(e) {
    this._editorViewDomNode = e;
  }
  _create(e) {
    return new Hg(e, !1, this._editorViewDomNode);
  }
  onContextMenu(e, t) {
    return Ie(e, "contextmenu", (n) => {
      t(this._create(n));
    });
  }
  onMouseUp(e, t) {
    return Ie(e, "mouseup", (n) => {
      t(this._create(n));
    });
  }
  onMouseDown(e, t) {
    return Ie(e, Ge.MOUSE_DOWN, (n) => {
      t(this._create(n));
    });
  }
  onPointerDown(e, t) {
    return Ie(e, Ge.POINTER_DOWN, (n) => {
      t(this._create(n), n.pointerId);
    });
  }
  onMouseLeave(e, t) {
    return Ie(e, Ge.MOUSE_LEAVE, (n) => {
      t(this._create(n));
    });
  }
  onMouseMove(e, t) {
    return Ie(e, "mousemove", (n) => t(this._create(n)));
  }
}
class F8e {
  constructor(e) {
    this._editorViewDomNode = e;
  }
  _create(e) {
    return new Hg(e, !1, this._editorViewDomNode);
  }
  onPointerUp(e, t) {
    return Ie(e, "pointerup", (n) => {
      t(this._create(n));
    });
  }
  onPointerDown(e, t) {
    return Ie(e, Ge.POINTER_DOWN, (n) => {
      t(this._create(n), n.pointerId);
    });
  }
  onPointerLeave(e, t) {
    return Ie(e, Ge.POINTER_LEAVE, (n) => {
      t(this._create(n));
    });
  }
  onPointerMove(e, t) {
    return Ie(e, "pointermove", (n) => t(this._create(n)));
  }
}
class B8e extends we {
  constructor(e) {
    super(), this._editorViewDomNode = e, this._globalPointerMoveMonitor = this._register(new vb()), this._keydownListener = null;
  }
  startMonitoring(e, t, n, r, s) {
    this._keydownListener = ar(e.ownerDocument, "keydown", (o) => {
      o.toKeyCodeChord().isModifierKey() || this._globalPointerMoveMonitor.stopMonitoring(!0, o.browserEvent);
    }, !0), this._globalPointerMoveMonitor.startMonitoring(e, t, n, (o) => {
      r(new Hg(o, !0, this._editorViewDomNode));
    }, (o) => {
      this._keydownListener.dispose(), s(o);
    });
  }
  stopMonitoring() {
    this._globalPointerMoveMonitor.stopMonitoring(!0);
  }
}
class IS {
  constructor(e) {
    this._editor = e, this._instanceId = ++IS._idPool, this._counter = 0, this._rules = /* @__PURE__ */ new Map(), this._garbageCollectionScheduler = new Rn(() => this.garbageCollect(), 1e3);
  }
  createClassNameRef(e) {
    const t = this.getOrCreateRule(e);
    return t.increaseRefCount(), {
      className: t.className,
      dispose: () => {
        t.decreaseRefCount(), this._garbageCollectionScheduler.schedule();
      }
    };
  }
  getOrCreateRule(e) {
    const t = this.computeUniqueKey(e);
    let n = this._rules.get(t);
    if (!n) {
      const r = this._counter++;
      n = new V8e(t, `dyn-rule-${this._instanceId}-${r}`, JE(this._editor.getContainerDomNode()) ? this._editor.getContainerDomNode() : void 0, e), this._rules.set(t, n);
    }
    return n;
  }
  computeUniqueKey(e) {
    return JSON.stringify(e);
  }
  garbageCollect() {
    for (const e of this._rules.values())
      e.hasReferences() || (this._rules.delete(e.key), e.dispose());
  }
}
IS._idPool = 0;
class V8e {
  constructor(e, t, n, r) {
    this.key = e, this.className = t, this.properties = r, this._referenceCount = 0, this._styleElement = yl(n), this._styleElement.textContent = this.getCssText(this.className, this.properties);
  }
  getCssText(e, t) {
    let n = `.${e} {`;
    for (const r in t) {
      const s = t[r];
      let o;
      typeof s == "object" ? o = Ye(s.id) : o = s;
      const a = H8e(r);
      n += `
	${a}: ${o};`;
    }
    return n += `
}`, n;
  }
  dispose() {
    this._styleElement.remove();
  }
  increaseRefCount() {
    this._referenceCount++;
  }
  decreaseRefCount() {
    this._referenceCount--;
  }
  hasReferences() {
    return this._referenceCount > 0;
  }
}
function H8e(i) {
  return i.replace(/(^[A-Z])/, ([e]) => e.toLowerCase()).replace(/([A-Z])/g, ([e]) => `-${e.toLowerCase()}`);
}
class AS extends we {
  constructor() {
    super(), this._shouldRender = !0;
  }
  shouldRender() {
    return this._shouldRender;
  }
  forceShouldRender() {
    this._shouldRender = !0;
  }
  setShouldRender() {
    this._shouldRender = !0;
  }
  onDidRender() {
    this._shouldRender = !1;
  }
  // --- begin event handlers
  onCompositionStart(e) {
    return !1;
  }
  onCompositionEnd(e) {
    return !1;
  }
  onConfigurationChanged(e) {
    return !1;
  }
  onCursorStateChanged(e) {
    return !1;
  }
  onDecorationsChanged(e) {
    return !1;
  }
  onFlushed(e) {
    return !1;
  }
  onFocusChanged(e) {
    return !1;
  }
  onLanguageConfigurationChanged(e) {
    return !1;
  }
  onLineMappingChanged(e) {
    return !1;
  }
  onLinesChanged(e) {
    return !1;
  }
  onLinesDeleted(e) {
    return !1;
  }
  onLinesInserted(e) {
    return !1;
  }
  onRevealRangeRequest(e) {
    return !1;
  }
  onScrollChanged(e) {
    return !1;
  }
  onThemeChanged(e) {
    return !1;
  }
  onTokensChanged(e) {
    return !1;
  }
  onTokensColorsChanged(e) {
    return !1;
  }
  onZonesChanged(e) {
    return !1;
  }
  // --- end event handlers
  handleEvents(e) {
    let t = !1;
    for (let n = 0, r = e.length; n < r; n++) {
      const s = e[n];
      switch (s.type) {
        case 0:
          this.onCompositionStart(s) && (t = !0);
          break;
        case 1:
          this.onCompositionEnd(s) && (t = !0);
          break;
        case 2:
          this.onConfigurationChanged(s) && (t = !0);
          break;
        case 3:
          this.onCursorStateChanged(s) && (t = !0);
          break;
        case 4:
          this.onDecorationsChanged(s) && (t = !0);
          break;
        case 5:
          this.onFlushed(s) && (t = !0);
          break;
        case 6:
          this.onFocusChanged(s) && (t = !0);
          break;
        case 7:
          this.onLanguageConfigurationChanged(s) && (t = !0);
          break;
        case 8:
          this.onLineMappingChanged(s) && (t = !0);
          break;
        case 9:
          this.onLinesChanged(s) && (t = !0);
          break;
        case 10:
          this.onLinesDeleted(s) && (t = !0);
          break;
        case 11:
          this.onLinesInserted(s) && (t = !0);
          break;
        case 12:
          this.onRevealRangeRequest(s) && (t = !0);
          break;
        case 13:
          this.onScrollChanged(s) && (t = !0);
          break;
        case 15:
          this.onTokensChanged(s) && (t = !0);
          break;
        case 14:
          this.onThemeChanged(s) && (t = !0);
          break;
        case 16:
          this.onTokensColorsChanged(s) && (t = !0);
          break;
        case 17:
          this.onZonesChanged(s) && (t = !0);
          break;
        default:
          console.info("View received unknown event: "), console.info(s);
      }
    }
    t && (this._shouldRender = !0);
  }
}
class ca extends AS {
  constructor(e) {
    super(), this._context = e, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
}
class Su {
  static write(e, t) {
    e.setAttribute("data-mprt", String(t));
  }
  static read(e) {
    const t = e.getAttribute("data-mprt");
    return t === null ? 0 : parseInt(t, 10);
  }
  static collect(e, t) {
    const n = [];
    let r = 0;
    for (; e && e !== e.ownerDocument.body && e !== t; )
      e.nodeType === e.ELEMENT_NODE && (n[r++] = this.read(e)), e = e.parentElement;
    const s = new Uint8Array(r);
    for (let o = 0; o < r; o++)
      s[o] = n[r - o - 1];
    return s;
  }
}
class W8e {
  constructor(e, t) {
    this._restrictedRenderingContextBrand = void 0, this._viewLayout = e, this.viewportData = t, this.scrollWidth = this._viewLayout.getScrollWidth(), this.scrollHeight = this._viewLayout.getScrollHeight(), this.visibleRange = this.viewportData.visibleRange, this.bigNumbersDelta = this.viewportData.bigNumbersDelta;
    const n = this._viewLayout.getCurrentViewport();
    this.scrollTop = n.top, this.scrollLeft = n.left, this.viewportWidth = n.width, this.viewportHeight = n.height;
  }
  getScrolledTopFromAbsoluteTop(e) {
    return e - this.scrollTop;
  }
  getVerticalOffsetForLineNumber(e, t) {
    return this._viewLayout.getVerticalOffsetForLineNumber(e, t);
  }
  getVerticalOffsetAfterLineNumber(e, t) {
    return this._viewLayout.getVerticalOffsetAfterLineNumber(e, t);
  }
  getDecorationsInViewport() {
    return this.viewportData.getDecorationsInViewport();
  }
}
class j8e extends W8e {
  constructor(e, t, n) {
    super(e, t), this._renderingContextBrand = void 0, this._viewLines = n;
  }
  linesVisibleRangesForRange(e, t) {
    return this._viewLines.linesVisibleRangesForRange(e, t);
  }
  visibleRangeForPosition(e) {
    return this._viewLines.visibleRangeForPosition(e);
  }
}
class z8e {
  constructor(e, t, n, r) {
    this.outsideRenderedLine = e, this.lineNumber = t, this.ranges = n, this.continuesOnNextLine = r;
  }
}
class _4 {
  static from(e) {
    const t = new Array(e.length);
    for (let n = 0, r = e.length; n < r; n++) {
      const s = e[n];
      t[n] = new _4(s.left, s.width);
    }
    return t;
  }
  constructor(e, t) {
    this._horizontalRangeBrand = void 0, this.left = Math.round(e), this.width = Math.round(t);
  }
  toString() {
    return `[${this.left},${this.width}]`;
  }
}
class Em {
  constructor(e, t) {
    this._floatHorizontalRangeBrand = void 0, this.left = e, this.width = t;
  }
  toString() {
    return `[${this.left},${this.width}]`;
  }
  static compare(e, t) {
    return e.left - t.left;
  }
}
class U8e {
  constructor(e, t) {
    this.outsideRenderedLine = e, this.originalLeft = t, this.left = Math.round(this.originalLeft);
  }
}
class yZ {
  constructor(e, t) {
    this.outsideRenderedLine = e, this.ranges = t;
  }
}
class W3 {
  static _createRange() {
    return this._handyReadyRange || (this._handyReadyRange = document.createRange()), this._handyReadyRange;
  }
  static _detachRange(e, t) {
    e.selectNodeContents(t);
  }
  static _readClientRects(e, t, n, r, s) {
    const o = this._createRange();
    try {
      return o.setStart(e, t), o.setEnd(n, r), o.getClientRects();
    } catch {
      return null;
    } finally {
      this._detachRange(o, s);
    }
  }
  static _mergeAdjacentRanges(e) {
    if (e.length === 1)
      return e;
    e.sort(Em.compare);
    const t = [];
    let n = 0, r = e[0];
    for (let s = 1, o = e.length; s < o; s++) {
      const a = e[s];
      r.left + r.width + 0.9 >= a.left ? r.width = Math.max(r.width, a.left + a.width - r.left) : (t[n++] = r, r = a);
    }
    return t[n++] = r, t;
  }
  static _createHorizontalRangesFromClientRects(e, t, n) {
    if (!e || e.length === 0)
      return null;
    const r = [];
    for (let s = 0, o = e.length; s < o; s++) {
      const a = e[s];
      r[s] = new Em(Math.max(0, (a.left - t) / n), a.width / n);
    }
    return this._mergeAdjacentRanges(r);
  }
  static readHorizontalRanges(e, t, n, r, s, o) {
    const l = e.children.length - 1;
    if (0 > l)
      return null;
    if (t = Math.min(l, Math.max(0, t)), r = Math.min(l, Math.max(0, r)), t === r && n === s && n === 0 && !e.children[t].firstChild) {
      const h = e.children[t].getClientRects();
      return o.markDidDomLayout(), this._createHorizontalRangesFromClientRects(h, o.clientRectDeltaLeft, o.clientRectScale);
    }
    t !== r && r > 0 && s === 0 && (r--, s = 1073741824);
    let c = e.children[t].firstChild, d = e.children[r].firstChild;
    if ((!c || !d) && (!c && n === 0 && t > 0 && (c = e.children[t - 1].firstChild, n = 1073741824), !d && s === 0 && r > 0 && (d = e.children[r - 1].firstChild, s = 1073741824)), !c || !d)
      return null;
    n = Math.min(c.textContent.length, Math.max(0, n)), s = Math.min(d.textContent.length, Math.max(0, s));
    const u = this._readClientRects(c, n, d, s, o.endNode);
    return o.markDidDomLayout(), this._createHorizontalRangesFromClientRects(u, o.clientRectDeltaLeft, o.clientRectScale);
  }
}
var dl;
(function(i) {
  i.DARK = "dark", i.LIGHT = "light", i.HIGH_CONTRAST_DARK = "hcDark", i.HIGH_CONTRAST_LIGHT = "hcLight";
})(dl || (dl = {}));
function ed(i) {
  return i === dl.HIGH_CONTRAST_DARK || i === dl.HIGH_CONTRAST_LIGHT;
}
function w_(i) {
  return i === dl.DARK || i === dl.HIGH_CONTRAST_DARK;
}
const G8e = /* @__PURE__ */ function() {
  return Zc ? !0 : !($s || bl || Zh);
}();
let Mv = !0;
class wZ {
  constructor(e, t) {
    this.themeType = t;
    const n = e.options, r = n.get(
      50
      /* EditorOption.fontInfo */
    );
    n.get(
      38
      /* EditorOption.experimentalWhitespaceRendering */
    ) === "off" ? this.renderWhitespace = n.get(
      98
      /* EditorOption.renderWhitespace */
    ) : this.renderWhitespace = "none", this.renderControlCharacters = n.get(
      93
      /* EditorOption.renderControlCharacters */
    ), this.spaceWidth = r.spaceWidth, this.middotWidth = r.middotWidth, this.wsmiddotWidth = r.wsmiddotWidth, this.useMonospaceOptimizations = r.isMonospace && !n.get(
      33
      /* EditorOption.disableMonospaceOptimizations */
    ), this.canUseHalfwidthRightwardsArrow = r.canUseHalfwidthRightwardsArrow, this.lineHeight = n.get(
      66
      /* EditorOption.lineHeight */
    ), this.stopRenderingLineAfter = n.get(
      116
      /* EditorOption.stopRenderingLineAfter */
    ), this.fontLigatures = n.get(
      51
      /* EditorOption.fontLigatures */
    );
  }
  equals(e) {
    return this.themeType === e.themeType && this.renderWhitespace === e.renderWhitespace && this.renderControlCharacters === e.renderControlCharacters && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.useMonospaceOptimizations === e.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineHeight === e.lineHeight && this.stopRenderingLineAfter === e.stopRenderingLineAfter && this.fontLigatures === e.fontLigatures;
  }
}
class zd {
  constructor(e) {
    this._options = e, this._isMaybeInvalid = !0, this._renderedViewLine = null;
  }
  // --- begin IVisibleLineData
  getDomNode() {
    return this._renderedViewLine && this._renderedViewLine.domNode ? this._renderedViewLine.domNode.domNode : null;
  }
  setDomNode(e) {
    if (this._renderedViewLine)
      this._renderedViewLine.domNode = Dn(e);
    else
      throw new Error("I have no rendered view line to set the dom node to...");
  }
  onContentChanged() {
    this._isMaybeInvalid = !0;
  }
  onTokensChanged() {
    this._isMaybeInvalid = !0;
  }
  onDecorationsChanged() {
    this._isMaybeInvalid = !0;
  }
  onOptionsChanged(e) {
    this._isMaybeInvalid = !0, this._options = e;
  }
  onSelectionChanged() {
    return ed(this._options.themeType) || this._options.renderWhitespace === "selection" ? (this._isMaybeInvalid = !0, !0) : !1;
  }
  renderLine(e, t, n, r) {
    if (this._isMaybeInvalid === !1)
      return !1;
    this._isMaybeInvalid = !1;
    const s = n.getViewLineRenderingData(e), o = this._options, a = ea.filter(s.inlineDecorations, e, s.minColumn, s.maxColumn);
    let l = null;
    if (ed(o.themeType) || this._options.renderWhitespace === "selection") {
      const h = n.selections;
      for (const f of h) {
        if (f.endLineNumber < e || f.startLineNumber > e)
          continue;
        const g = f.startLineNumber === e ? f.startColumn : s.minColumn, p = f.endLineNumber === e ? f.endColumn : s.maxColumn;
        g < p && (ed(o.themeType) && a.push(new ea(
          g,
          p,
          "inline-selected-text",
          0
          /* InlineDecorationType.Regular */
        )), this._options.renderWhitespace === "selection" && (l || (l = []), l.push(new bfe(g - 1, p - 1))));
      }
    }
    const c = new dp(o.useMonospaceOptimizations, o.canUseHalfwidthRightwardsArrow, s.content, s.continuesWithWrappedLine, s.isBasicASCII, s.containsRTL, s.minColumn - 1, s.tokens, a, s.tabSize, s.startVisibleColumn, o.spaceWidth, o.middotWidth, o.wsmiddotWidth, o.stopRenderingLineAfter, o.renderWhitespace, o.renderControlCharacters, o.fontLigatures !== Da.OFF, l);
    if (this._renderedViewLine && this._renderedViewLine.input.equals(c))
      return !1;
    r.appendString('<div style="top:'), r.appendString(String(t)), r.appendString("px;height:"), r.appendString(String(this._options.lineHeight)), r.appendString('px;" class="'), r.appendString(zd.CLASS_NAME), r.appendString('">');
    const d = ES(c, r);
    r.appendString("</div>");
    let u = null;
    return Mv && G8e && s.isBasicASCII && o.useMonospaceOptimizations && d.containsForeignElements === 0 && (u = new Gx(this._renderedViewLine ? this._renderedViewLine.domNode : null, c, d.characterMapping)), u || (u = Vfe(this._renderedViewLine ? this._renderedViewLine.domNode : null, c, d.characterMapping, d.containsRTL, d.containsForeignElements)), this._renderedViewLine = u, !0;
  }
  layoutLine(e, t) {
    this._renderedViewLine && this._renderedViewLine.domNode && (this._renderedViewLine.domNode.setTop(t), this._renderedViewLine.domNode.setHeight(this._options.lineHeight));
  }
  // --- end IVisibleLineData
  getWidth(e) {
    return this._renderedViewLine ? this._renderedViewLine.getWidth(e) : 0;
  }
  getWidthIsFast() {
    return this._renderedViewLine ? this._renderedViewLine.getWidthIsFast() : !0;
  }
  needsMonospaceFontCheck() {
    return this._renderedViewLine ? this._renderedViewLine instanceof Gx : !1;
  }
  monospaceAssumptionsAreValid() {
    return this._renderedViewLine && this._renderedViewLine instanceof Gx ? this._renderedViewLine.monospaceAssumptionsAreValid() : Mv;
  }
  onMonospaceAssumptionsInvalidated() {
    this._renderedViewLine && this._renderedViewLine instanceof Gx && (this._renderedViewLine = this._renderedViewLine.toSlowRenderedLine());
  }
  getVisibleRangesForRange(e, t, n, r) {
    if (!this._renderedViewLine)
      return null;
    t = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, t)), n = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, n));
    const s = this._renderedViewLine.input.stopRenderingLineAfter;
    if (s !== -1 && t > s + 1 && n > s + 1)
      return new yZ(!0, [new Em(this.getWidth(r), 0)]);
    s !== -1 && t > s + 1 && (t = s + 1), s !== -1 && n > s + 1 && (n = s + 1);
    const o = this._renderedViewLine.getVisibleRangesForRange(e, t, n, r);
    return o && o.length > 0 ? new yZ(!1, o) : null;
  }
  getColumnOfNodeOffset(e, t) {
    return this._renderedViewLine ? this._renderedViewLine.getColumnOfNodeOffset(e, t) : 1;
  }
}
zd.CLASS_NAME = "view-line";
class Gx {
  constructor(e, t, n) {
    this._cachedWidth = -1, this.domNode = e, this.input = t;
    const r = Math.floor(
      t.lineContent.length / 300
      /* Constants.MaxMonospaceDistance */
    );
    if (r > 0) {
      this._keyColumnPixelOffsetCache = new Float32Array(r);
      for (let s = 0; s < r; s++)
        this._keyColumnPixelOffsetCache[s] = -1;
    } else
      this._keyColumnPixelOffsetCache = null;
    this._characterMapping = n, this._charWidth = t.spaceWidth;
  }
  getWidth(e) {
    if (!this.domNode || this.input.lineContent.length < 300) {
      const t = this._characterMapping.getHorizontalOffset(this._characterMapping.length);
      return Math.round(this._charWidth * t);
    }
    return this._cachedWidth === -1 && (this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth, e?.markDidDomLayout()), this._cachedWidth;
  }
  getWidthIsFast() {
    return this.input.lineContent.length < 300 || this._cachedWidth !== -1;
  }
  monospaceAssumptionsAreValid() {
    if (!this.domNode)
      return Mv;
    if (this.input.lineContent.length < 300) {
      const e = this.getWidth(null), t = this.domNode.domNode.firstChild.offsetWidth;
      Math.abs(e - t) >= 2 && (console.warn("monospace assumptions have been violated, therefore disabling monospace optimizations!"), Mv = !1);
    }
    return Mv;
  }
  toSlowRenderedLine() {
    return Vfe(
      this.domNode,
      this.input,
      this._characterMapping,
      !1,
      0
      /* ForeignElementType.None */
    );
  }
  getVisibleRangesForRange(e, t, n, r) {
    const s = this._getColumnPixelOffset(e, t, r), o = this._getColumnPixelOffset(e, n, r);
    return [new Em(s, o - s)];
  }
  _getColumnPixelOffset(e, t, n) {
    if (t <= 300) {
      const c = this._characterMapping.getHorizontalOffset(t);
      return this._charWidth * c;
    }
    const r = Math.floor(
      (t - 1) / 300
      /* Constants.MaxMonospaceDistance */
    ) - 1, s = (r + 1) * 300 + 1;
    let o = -1;
    if (this._keyColumnPixelOffsetCache && (o = this._keyColumnPixelOffsetCache[r], o === -1 && (o = this._actualReadPixelOffset(e, s, n), this._keyColumnPixelOffsetCache[r] = o)), o === -1) {
      const c = this._characterMapping.getHorizontalOffset(t);
      return this._charWidth * c;
    }
    const a = this._characterMapping.getHorizontalOffset(s), l = this._characterMapping.getHorizontalOffset(t);
    return o + this._charWidth * (l - a);
  }
  _getReadingTarget(e) {
    return e.domNode.firstChild;
  }
  _actualReadPixelOffset(e, t, n) {
    if (!this.domNode)
      return -1;
    const r = this._characterMapping.getDomPosition(t), s = W3.readHorizontalRanges(this._getReadingTarget(this.domNode), r.partIndex, r.charIndex, r.partIndex, r.charIndex, n);
    return !s || s.length === 0 ? -1 : s[0].left;
  }
  getColumnOfNodeOffset(e, t) {
    return bz(this._characterMapping, e, t);
  }
}
class Bfe {
  constructor(e, t, n, r, s) {
    if (this.domNode = e, this.input = t, this._characterMapping = n, this._isWhitespaceOnly = /^\s*$/.test(t.lineContent), this._containsForeignElements = s, this._cachedWidth = -1, this._pixelOffsetCache = null, !r || this._characterMapping.length === 0) {
      this._pixelOffsetCache = new Float32Array(Math.max(2, this._characterMapping.length + 1));
      for (let o = 0, a = this._characterMapping.length; o <= a; o++)
        this._pixelOffsetCache[o] = -1;
    }
  }
  // --- Reading from the DOM methods
  _getReadingTarget(e) {
    return e.domNode.firstChild;
  }
  /**
   * Width of the line in pixels
   */
  getWidth(e) {
    return this.domNode ? (this._cachedWidth === -1 && (this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth, e?.markDidDomLayout()), this._cachedWidth) : 0;
  }
  getWidthIsFast() {
    return this._cachedWidth !== -1;
  }
  /**
   * Visible ranges for a model range
   */
  getVisibleRangesForRange(e, t, n, r) {
    if (!this.domNode)
      return null;
    if (this._pixelOffsetCache !== null) {
      const s = this._readPixelOffset(this.domNode, e, t, r);
      if (s === -1)
        return null;
      const o = this._readPixelOffset(this.domNode, e, n, r);
      return o === -1 ? null : [new Em(s, o - s)];
    }
    return this._readVisibleRangesForRange(this.domNode, e, t, n, r);
  }
  _readVisibleRangesForRange(e, t, n, r, s) {
    if (n === r) {
      const o = this._readPixelOffset(e, t, n, s);
      return o === -1 ? null : [new Em(o, 0)];
    } else
      return this._readRawVisibleRangesForRange(e, n, r, s);
  }
  _readPixelOffset(e, t, n, r) {
    if (this._characterMapping.length === 0) {
      if (this._containsForeignElements === 0 || this._containsForeignElements === 2)
        return 0;
      if (this._containsForeignElements === 1)
        return this.getWidth(r);
      const s = this._getReadingTarget(e);
      return s.firstChild ? (r.markDidDomLayout(), s.firstChild.offsetWidth) : 0;
    }
    if (this._pixelOffsetCache !== null) {
      const s = this._pixelOffsetCache[n];
      if (s !== -1)
        return s;
      const o = this._actualReadPixelOffset(e, t, n, r);
      return this._pixelOffsetCache[n] = o, o;
    }
    return this._actualReadPixelOffset(e, t, n, r);
  }
  _actualReadPixelOffset(e, t, n, r) {
    if (this._characterMapping.length === 0) {
      const l = W3.readHorizontalRanges(this._getReadingTarget(e), 0, 0, 0, 0, r);
      return !l || l.length === 0 ? -1 : l[0].left;
    }
    if (n === this._characterMapping.length && this._isWhitespaceOnly && this._containsForeignElements === 0)
      return this.getWidth(r);
    const s = this._characterMapping.getDomPosition(n), o = W3.readHorizontalRanges(this._getReadingTarget(e), s.partIndex, s.charIndex, s.partIndex, s.charIndex, r);
    if (!o || o.length === 0)
      return -1;
    const a = o[0].left;
    if (this.input.isBasicASCII) {
      const l = this._characterMapping.getHorizontalOffset(n), c = Math.round(this.input.spaceWidth * l);
      if (Math.abs(c - a) <= 1)
        return c;
    }
    return a;
  }
  _readRawVisibleRangesForRange(e, t, n, r) {
    if (t === 1 && n === this._characterMapping.length)
      return [new Em(0, this.getWidth(r))];
    const s = this._characterMapping.getDomPosition(t), o = this._characterMapping.getDomPosition(n);
    return W3.readHorizontalRanges(this._getReadingTarget(e), s.partIndex, s.charIndex, o.partIndex, o.charIndex, r);
  }
  /**
   * Returns the column for the text found at a specific offset inside a rendered dom node
   */
  getColumnOfNodeOffset(e, t) {
    return bz(this._characterMapping, e, t);
  }
}
class q8e extends Bfe {
  _readVisibleRangesForRange(e, t, n, r, s) {
    const o = super._readVisibleRangesForRange(e, t, n, r, s);
    if (!o || o.length === 0 || n === r || n === 1 && r === this._characterMapping.length)
      return o;
    if (!this.input.containsRTL) {
      const a = this._readPixelOffset(e, t, r, s);
      if (a !== -1) {
        const l = o[o.length - 1];
        l.left < a && (l.width = a - l.left);
      }
    }
    return o;
  }
}
const Vfe = /* @__PURE__ */ function() {
  return Sm ? K8e : Y8e;
}();
function K8e(i, e, t, n, r) {
  return new q8e(i, e, t, n, r);
}
function Y8e(i, e, t, n, r) {
  return new Bfe(i, e, t, n, r);
}
function bz(i, e, t) {
  const n = e.textContent.length;
  let r = -1;
  for (; e; )
    e = e.previousSibling, r++;
  return i.getColumn(new Cfe(r, t), n);
}
class Lr {
  static _nextVisibleColumn(e, t, n) {
    return e === 9 ? Lr.nextRenderTabStop(t, n) : Pg(e) || jj(e) ? t + 2 : t + 1;
  }
  /**
   * Returns a visible column from a column.
   * @see {@link CursorColumns}
   */
  static visibleColumnFromColumn(e, t, n) {
    const r = Math.min(t - 1, e.length), s = e.substring(0, r), o = new ZE(s);
    let a = 0;
    for (; !o.eol(); ) {
      const l = XE(s, r, o.offset);
      o.nextGraphemeLength(), a = this._nextVisibleColumn(l, a, n);
    }
    return a;
  }
  /**
   * Returns a column from a visible column.
   * @see {@link CursorColumns}
   */
  static columnFromVisibleColumn(e, t, n) {
    if (t <= 0)
      return 1;
    const r = e.length, s = new ZE(e);
    let o = 0, a = 1;
    for (; !s.eol(); ) {
      const l = XE(e, r, s.offset);
      s.nextGraphemeLength();
      const c = this._nextVisibleColumn(l, o, n), d = s.offset + 1;
      if (c >= t) {
        const u = t - o;
        return c - t < u ? d : a;
      }
      o = c, a = d;
    }
    return r + 1;
  }
  /**
   * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
   * @see {@link CursorColumns}
   */
  static nextRenderTabStop(e, t) {
    return e + t - e % t;
  }
  /**
   * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
   * @see {@link CursorColumns}
   */
  static nextIndentTabStop(e, t) {
    return e + t - e % t;
  }
  /**
   * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
   * @see {@link CursorColumns}
   */
  static prevRenderTabStop(e, t) {
    return Math.max(0, e - 1 - (e - 1) % t);
  }
  /**
   * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
   * @see {@link CursorColumns}
   */
  static prevIndentTabStop(e, t) {
    return Math.max(0, e - 1 - (e - 1) % t);
  }
}
class Uy {
  /**
   * Get the visible column at the position. If we get to a non-whitespace character first
   * or past the end of string then return -1.
   *
   * **Note** `position` and the return value are 0-based.
   */
  static whitespaceVisibleColumn(e, t, n) {
    const r = e.length;
    let s = 0, o = -1, a = -1;
    for (let l = 0; l < r; l++) {
      if (l === t)
        return [o, a, s];
      switch (s % n === 0 && (o = l, a = s), e.charCodeAt(l)) {
        case 32:
          s += 1;
          break;
        case 9:
          s = Lr.nextRenderTabStop(s, n);
          break;
        default:
          return [-1, -1, -1];
      }
    }
    return t === r ? [o, a, s] : [-1, -1, -1];
  }
  /**
   * Return the position that should result from a move left, right or to the
   * nearest tab, if atomic tabs are enabled. Left and right are used for the
   * arrow key movements, nearest is used for mouse selection. It returns
   * -1 if atomic tabs are not relevant and you should fall back to normal
   * behaviour.
   *
   * **Note**: `position` and the return value are 0-based.
   */
  static atomicPosition(e, t, n, r) {
    const s = e.length, [o, a, l] = Uy.whitespaceVisibleColumn(e, t, n);
    if (l === -1)
      return -1;
    let c;
    switch (r) {
      case 0:
        c = !0;
        break;
      case 1:
        c = !1;
        break;
      case 2:
        if (l % n === 0)
          return t;
        c = l % n <= n / 2;
        break;
    }
    if (c) {
      if (o === -1)
        return -1;
      let h = a;
      for (let f = o; f < s; ++f) {
        if (h === a + n)
          return o;
        switch (e.charCodeAt(f)) {
          case 32:
            h += 1;
            break;
          case 9:
            h = Lr.nextRenderTabStop(h, n);
            break;
          default:
            return -1;
        }
      }
      return h === a + n ? o : -1;
    }
    const d = Lr.nextRenderTabStop(l, n);
    let u = l;
    for (let h = t; h < s; h++) {
      if (u === d)
        return h;
      switch (e.charCodeAt(h)) {
        case 32:
          u += 1;
          break;
        case 9:
          u = Lr.nextRenderTabStop(u, n);
          break;
        default:
          return -1;
      }
    }
    return u === d ? s : -1;
  }
}
class Af {
  constructor(e = null) {
    this.hitTarget = e, this.type = 0;
  }
}
class Hfe {
  constructor(e, t, n) {
    this.position = e, this.spanNode = t, this.injectedText = n, this.type = 1;
  }
}
var Qp;
(function(i) {
  function e(t, n, r) {
    const s = t.getPositionFromDOMInfo(n, r);
    return s ? new Hfe(s, n, null) : new Af(n);
  }
  i.createFromDOMInfo = e;
})(Qp || (Qp = {}));
class X8e {
  constructor(e, t) {
    this.lastViewCursorsRenderData = e, this.lastTextareaPosition = t;
  }
}
class Ys {
  static _deduceRage(e, t = null) {
    return !t && e ? new V(e.lineNumber, e.column, e.lineNumber, e.column) : t ?? null;
  }
  static createUnknown(e, t, n) {
    return { type: 0, element: e, mouseColumn: t, position: n, range: this._deduceRage(n) };
  }
  static createTextarea(e, t) {
    return { type: 1, element: e, mouseColumn: t, position: null, range: null };
  }
  static createMargin(e, t, n, r, s, o) {
    return { type: e, element: t, mouseColumn: n, position: r, range: s, detail: o };
  }
  static createViewZone(e, t, n, r, s) {
    return { type: e, element: t, mouseColumn: n, position: r, range: this._deduceRage(r), detail: s };
  }
  static createContentText(e, t, n, r, s) {
    return { type: 6, element: e, mouseColumn: t, position: n, range: this._deduceRage(n, r), detail: s };
  }
  static createContentEmpty(e, t, n, r) {
    return { type: 7, element: e, mouseColumn: t, position: n, range: this._deduceRage(n), detail: r };
  }
  static createContentWidget(e, t, n) {
    return { type: 9, element: e, mouseColumn: t, position: null, range: null, detail: n };
  }
  static createScrollbar(e, t, n) {
    return { type: 11, element: e, mouseColumn: t, position: n, range: this._deduceRage(n) };
  }
  static createOverlayWidget(e, t, n) {
    return { type: 12, element: e, mouseColumn: t, position: null, range: null, detail: n };
  }
  static createOutsideEditor(e, t, n, r) {
    return { type: 13, element: null, mouseColumn: e, position: t, range: this._deduceRage(t), outsidePosition: n, outsideDistance: r };
  }
  static _typeToString(e) {
    return e === 1 ? "TEXTAREA" : e === 2 ? "GUTTER_GLYPH_MARGIN" : e === 3 ? "GUTTER_LINE_NUMBERS" : e === 4 ? "GUTTER_LINE_DECORATIONS" : e === 5 ? "GUTTER_VIEW_ZONE" : e === 6 ? "CONTENT_TEXT" : e === 7 ? "CONTENT_EMPTY" : e === 8 ? "CONTENT_VIEW_ZONE" : e === 9 ? "CONTENT_WIDGET" : e === 10 ? "OVERVIEW_RULER" : e === 11 ? "SCROLLBAR" : e === 12 ? "OVERLAY_WIDGET" : "UNKNOWN";
  }
  static toString(e) {
    return this._typeToString(e.type) + ": " + e.position + " - " + e.range + " - " + JSON.stringify(e.detail);
  }
}
class pa {
  static isTextArea(e) {
    return e.length === 2 && e[0] === 3 && e[1] === 6;
  }
  static isChildOfViewLines(e) {
    return e.length >= 4 && e[0] === 3 && e[3] === 7;
  }
  static isStrictChildOfViewLines(e) {
    return e.length > 4 && e[0] === 3 && e[3] === 7;
  }
  static isChildOfScrollableElement(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 5;
  }
  static isChildOfMinimap(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 8;
  }
  static isChildOfContentWidgets(e) {
    return e.length >= 4 && e[0] === 3 && e[3] === 1;
  }
  static isChildOfOverflowGuard(e) {
    return e.length >= 1 && e[0] === 3;
  }
  static isChildOfOverflowingContentWidgets(e) {
    return e.length >= 1 && e[0] === 2;
  }
  static isChildOfOverlayWidgets(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 4;
  }
}
class S_ {
  constructor(e, t, n) {
    this.viewModel = e.viewModel;
    const r = e.configuration.options;
    this.layoutInfo = r.get(
      143
      /* EditorOption.layoutInfo */
    ), this.viewDomNode = t.viewDomNode, this.lineHeight = r.get(
      66
      /* EditorOption.lineHeight */
    ), this.stickyTabStops = r.get(
      115
      /* EditorOption.stickyTabStops */
    ), this.typicalHalfwidthCharacterWidth = r.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, this.lastRenderData = n, this._context = e, this._viewHelper = t;
  }
  getZoneAtCoord(e) {
    return S_.getZoneAtCoord(this._context, e);
  }
  static getZoneAtCoord(e, t) {
    const n = e.viewLayout.getWhitespaceAtVerticalOffset(t);
    if (n) {
      const r = n.verticalOffset + n.height / 2, s = e.viewModel.getLineCount();
      let o = null, a, l = null;
      return n.afterLineNumber !== s && (l = new ve(n.afterLineNumber + 1, 1)), n.afterLineNumber > 0 && (o = new ve(n.afterLineNumber, e.viewModel.getLineMaxColumn(n.afterLineNumber))), l === null ? a = o : o === null ? a = l : t < r ? a = o : a = l, {
        viewZoneId: n.id,
        afterLineNumber: n.afterLineNumber,
        positionBefore: o,
        positionAfter: l,
        position: a
      };
    }
    return null;
  }
  getFullLineRangeAtCoord(e) {
    if (this._context.viewLayout.isAfterLines(e)) {
      const r = this._context.viewModel.getLineCount(), s = this._context.viewModel.getLineMaxColumn(r);
      return {
        range: new V(r, s, r, s),
        isAfterLines: !0
      };
    }
    const t = this._context.viewLayout.getLineNumberAtVerticalOffset(e), n = this._context.viewModel.getLineMaxColumn(t);
    return {
      range: new V(t, 1, t, n),
      isAfterLines: !1
    };
  }
  getLineNumberAtVerticalOffset(e) {
    return this._context.viewLayout.getLineNumberAtVerticalOffset(e);
  }
  isAfterLines(e) {
    return this._context.viewLayout.isAfterLines(e);
  }
  isInTopPadding(e) {
    return this._context.viewLayout.isInTopPadding(e);
  }
  isInBottomPadding(e) {
    return this._context.viewLayout.isInBottomPadding(e);
  }
  getVerticalOffsetForLineNumber(e) {
    return this._context.viewLayout.getVerticalOffsetForLineNumber(e);
  }
  findAttribute(e, t) {
    return S_._findAttribute(e, t, this._viewHelper.viewDomNode);
  }
  static _findAttribute(e, t, n) {
    for (; e && e !== e.ownerDocument.body; ) {
      if (e.hasAttribute && e.hasAttribute(t))
        return e.getAttribute(t);
      if (e === n)
        return null;
      e = e.parentNode;
    }
    return null;
  }
  getLineWidth(e) {
    return this._viewHelper.getLineWidth(e);
  }
  visibleRangeForPosition(e, t) {
    return this._viewHelper.visibleRangeForPosition(e, t);
  }
  getPositionFromDOMInfo(e, t) {
    return this._viewHelper.getPositionFromDOMInfo(e, t);
  }
  getCurrentScrollTop() {
    return this._context.viewLayout.getCurrentScrollTop();
  }
  getCurrentScrollLeft() {
    return this._context.viewLayout.getCurrentScrollLeft();
  }
}
class Z8e {
  constructor(e, t, n, r) {
    this.editorPos = t, this.pos = n, this.relativePos = r, this.mouseVerticalOffset = Math.max(0, e.getCurrentScrollTop() + this.relativePos.y), this.mouseContentHorizontalOffset = e.getCurrentScrollLeft() + this.relativePos.x - e.layoutInfo.contentLeft, this.isInMarginArea = this.relativePos.x < e.layoutInfo.contentLeft && this.relativePos.x >= e.layoutInfo.glyphMarginLeft, this.isInContentArea = !this.isInMarginArea, this.mouseColumn = Math.max(0, ps._getMouseColumn(this.mouseContentHorizontalOffset, e.typicalHalfwidthCharacterWidth));
  }
}
class Cz extends Z8e {
  constructor(e, t, n, r, s) {
    super(e, t, n, r), this._ctx = e, s ? (this.target = s, this.targetPath = Su.collect(s, e.viewDomNode)) : (this.target = null, this.targetPath = new Uint8Array(0));
  }
  toString() {
    return `pos(${this.pos.x},${this.pos.y}), editorPos(${this.editorPos.x},${this.editorPos.y}), relativePos(${this.relativePos.x},${this.relativePos.y}), mouseVerticalOffset: ${this.mouseVerticalOffset}, mouseContentHorizontalOffset: ${this.mouseContentHorizontalOffset}
	target: ${this.target ? this.target.outerHTML : null}`;
  }
  _getMouseColumn(e = null) {
    return e && e.column < this._ctx.viewModel.getLineMaxColumn(e.lineNumber) ? Lr.visibleColumnFromColumn(this._ctx.viewModel.getLineContent(e.lineNumber), e.column, this._ctx.viewModel.model.getOptions().tabSize) + 1 : this.mouseColumn;
  }
  fulfillUnknown(e = null) {
    return Ys.createUnknown(this.target, this._getMouseColumn(e), e);
  }
  fulfillTextarea() {
    return Ys.createTextarea(this.target, this._getMouseColumn());
  }
  fulfillMargin(e, t, n, r) {
    return Ys.createMargin(e, this.target, this._getMouseColumn(t), t, n, r);
  }
  fulfillViewZone(e, t, n) {
    return Ys.createViewZone(e, this.target, this._getMouseColumn(t), t, n);
  }
  fulfillContentText(e, t, n) {
    return Ys.createContentText(this.target, this._getMouseColumn(e), e, t, n);
  }
  fulfillContentEmpty(e, t) {
    return Ys.createContentEmpty(this.target, this._getMouseColumn(e), e, t);
  }
  fulfillContentWidget(e) {
    return Ys.createContentWidget(this.target, this._getMouseColumn(), e);
  }
  fulfillScrollbar(e) {
    return Ys.createScrollbar(this.target, this._getMouseColumn(e), e);
  }
  fulfillOverlayWidget(e) {
    return Ys.createOverlayWidget(this.target, this._getMouseColumn(), e);
  }
  withTarget(e) {
    return new Cz(this._ctx, this.editorPos, this.pos, this.relativePos, e);
  }
}
const SZ = { isAfterLines: !0 };
function E6(i) {
  return {
    isAfterLines: !1,
    horizontalDistanceToText: i
  };
}
class ps {
  constructor(e, t) {
    this._context = e, this._viewHelper = t;
  }
  mouseTargetIsWidget(e) {
    const t = e.target, n = Su.collect(t, this._viewHelper.viewDomNode);
    return !!(pa.isChildOfContentWidgets(n) || pa.isChildOfOverflowingContentWidgets(n) || pa.isChildOfOverlayWidgets(n));
  }
  createMouseTarget(e, t, n, r, s) {
    const o = new S_(this._context, this._viewHelper, e), a = new Cz(o, t, n, r, s);
    try {
      const l = ps._createMouseTarget(o, a, !1);
      if (l.type === 6 && o.stickyTabStops && l.position !== null) {
        const c = ps._snapToSoftTabBoundary(l.position, o.viewModel), d = V.fromPositions(c, c).plusRange(l.range);
        return a.fulfillContentText(c, d, l.detail);
      }
      return l;
    } catch {
      return a.fulfillUnknown();
    }
  }
  static _createMouseTarget(e, t, n) {
    if (t.target === null) {
      if (n)
        return t.fulfillUnknown();
      const o = ps._doHitTest(e, t);
      return o.type === 1 ? ps.createMouseTargetFromHitTestPosition(e, t, o.spanNode, o.position, o.injectedText) : this._createMouseTarget(e, t.withTarget(o.hitTarget), !0);
    }
    const r = t;
    let s = null;
    return !pa.isChildOfOverflowGuard(t.targetPath) && !pa.isChildOfOverflowingContentWidgets(t.targetPath) && (s = s || t.fulfillUnknown()), s = s || ps._hitTestContentWidget(e, r), s = s || ps._hitTestOverlayWidget(e, r), s = s || ps._hitTestMinimap(e, r), s = s || ps._hitTestScrollbarSlider(e, r), s = s || ps._hitTestViewZone(e, r), s = s || ps._hitTestMargin(e, r), s = s || ps._hitTestViewCursor(e, r), s = s || ps._hitTestTextArea(e, r), s = s || ps._hitTestViewLines(e, r, n), s = s || ps._hitTestScrollbar(e, r), s || t.fulfillUnknown();
  }
  static _hitTestContentWidget(e, t) {
    if (pa.isChildOfContentWidgets(t.targetPath) || pa.isChildOfOverflowingContentWidgets(t.targetPath)) {
      const n = e.findAttribute(t.target, "widgetId");
      return n ? t.fulfillContentWidget(n) : t.fulfillUnknown();
    }
    return null;
  }
  static _hitTestOverlayWidget(e, t) {
    if (pa.isChildOfOverlayWidgets(t.targetPath)) {
      const n = e.findAttribute(t.target, "widgetId");
      return n ? t.fulfillOverlayWidget(n) : t.fulfillUnknown();
    }
    return null;
  }
  static _hitTestViewCursor(e, t) {
    if (t.target) {
      const n = e.lastRenderData.lastViewCursorsRenderData;
      for (const r of n)
        if (t.target === r.domNode)
          return t.fulfillContentText(r.position, null, { mightBeForeignElement: !1, injectedText: null });
    }
    if (t.isInContentArea) {
      const n = e.lastRenderData.lastViewCursorsRenderData, r = t.mouseContentHorizontalOffset, s = t.mouseVerticalOffset;
      for (const o of n) {
        if (r < o.contentLeft || r > o.contentLeft + o.width)
          continue;
        const a = e.getVerticalOffsetForLineNumber(o.position.lineNumber);
        if (a <= s && s <= a + o.height)
          return t.fulfillContentText(o.position, null, { mightBeForeignElement: !1, injectedText: null });
      }
    }
    return null;
  }
  static _hitTestViewZone(e, t) {
    const n = e.getZoneAtCoord(t.mouseVerticalOffset);
    if (n) {
      const r = t.isInContentArea ? 8 : 5;
      return t.fulfillViewZone(r, n.position, n);
    }
    return null;
  }
  static _hitTestTextArea(e, t) {
    return pa.isTextArea(t.targetPath) ? e.lastRenderData.lastTextareaPosition ? t.fulfillContentText(e.lastRenderData.lastTextareaPosition, null, { mightBeForeignElement: !1, injectedText: null }) : t.fulfillTextarea() : null;
  }
  static _hitTestMargin(e, t) {
    if (t.isInMarginArea) {
      const n = e.getFullLineRangeAtCoord(t.mouseVerticalOffset), r = n.range.getStartPosition();
      let s = Math.abs(t.relativePos.x);
      const o = {
        isAfterLines: n.isAfterLines,
        glyphMarginLeft: e.layoutInfo.glyphMarginLeft,
        glyphMarginWidth: e.layoutInfo.glyphMarginWidth,
        lineNumbersWidth: e.layoutInfo.lineNumbersWidth,
        offsetX: s
      };
      return s -= e.layoutInfo.glyphMarginLeft, s <= e.layoutInfo.glyphMarginWidth ? t.fulfillMargin(2, r, n.range, o) : (s -= e.layoutInfo.glyphMarginWidth, s <= e.layoutInfo.lineNumbersWidth ? t.fulfillMargin(3, r, n.range, o) : (s -= e.layoutInfo.lineNumbersWidth, t.fulfillMargin(4, r, n.range, o)));
    }
    return null;
  }
  static _hitTestViewLines(e, t, n) {
    if (!pa.isChildOfViewLines(t.targetPath))
      return null;
    if (e.isInTopPadding(t.mouseVerticalOffset))
      return t.fulfillContentEmpty(new ve(1, 1), SZ);
    if (e.isAfterLines(t.mouseVerticalOffset) || e.isInBottomPadding(t.mouseVerticalOffset)) {
      const s = e.viewModel.getLineCount(), o = e.viewModel.getLineMaxColumn(s);
      return t.fulfillContentEmpty(new ve(s, o), SZ);
    }
    if (n) {
      if (pa.isStrictChildOfViewLines(t.targetPath)) {
        const s = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset);
        if (e.viewModel.getLineLength(s) === 0) {
          const a = e.getLineWidth(s), l = E6(t.mouseContentHorizontalOffset - a);
          return t.fulfillContentEmpty(new ve(s, 1), l);
        }
        const o = e.getLineWidth(s);
        if (t.mouseContentHorizontalOffset >= o) {
          const a = E6(t.mouseContentHorizontalOffset - o), l = new ve(s, e.viewModel.getLineMaxColumn(s));
          return t.fulfillContentEmpty(l, a);
        }
      }
      return t.fulfillUnknown();
    }
    const r = ps._doHitTest(e, t);
    return r.type === 1 ? ps.createMouseTargetFromHitTestPosition(e, t, r.spanNode, r.position, r.injectedText) : this._createMouseTarget(e, t.withTarget(r.hitTarget), !0);
  }
  static _hitTestMinimap(e, t) {
    if (pa.isChildOfMinimap(t.targetPath)) {
      const n = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), r = e.viewModel.getLineMaxColumn(n);
      return t.fulfillScrollbar(new ve(n, r));
    }
    return null;
  }
  static _hitTestScrollbarSlider(e, t) {
    if (pa.isChildOfScrollableElement(t.targetPath) && t.target && t.target.nodeType === 1) {
      const n = t.target.className;
      if (n && /\b(slider|scrollbar)\b/.test(n)) {
        const r = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), s = e.viewModel.getLineMaxColumn(r);
        return t.fulfillScrollbar(new ve(r, s));
      }
    }
    return null;
  }
  static _hitTestScrollbar(e, t) {
    if (pa.isChildOfScrollableElement(t.targetPath)) {
      const n = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), r = e.viewModel.getLineMaxColumn(n);
      return t.fulfillScrollbar(new ve(n, r));
    }
    return null;
  }
  getMouseColumn(e) {
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    ), r = this._context.viewLayout.getCurrentScrollLeft() + e.x - n.contentLeft;
    return ps._getMouseColumn(r, t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth);
  }
  static _getMouseColumn(e, t) {
    return e < 0 ? 1 : Math.round(e / t) + 1;
  }
  static createMouseTargetFromHitTestPosition(e, t, n, r, s) {
    const o = r.lineNumber, a = r.column, l = e.getLineWidth(o);
    if (t.mouseContentHorizontalOffset > l) {
      const _ = E6(t.mouseContentHorizontalOffset - l);
      return t.fulfillContentEmpty(r, _);
    }
    const c = e.visibleRangeForPosition(o, a);
    if (!c)
      return t.fulfillUnknown(r);
    const d = c.left;
    if (Math.abs(t.mouseContentHorizontalOffset - d) < 1)
      return t.fulfillContentText(r, null, { mightBeForeignElement: !!s, injectedText: s });
    const u = [];
    if (u.push({ offset: c.left, column: a }), a > 1) {
      const _ = e.visibleRangeForPosition(o, a - 1);
      _ && u.push({ offset: _.left, column: a - 1 });
    }
    const h = e.viewModel.getLineMaxColumn(o);
    if (a < h) {
      const _ = e.visibleRangeForPosition(o, a + 1);
      _ && u.push({ offset: _.left, column: a + 1 });
    }
    u.sort((_, b) => _.offset - b.offset);
    const f = t.pos.toClientCoordinates(), g = n.getBoundingClientRect(), p = g.left <= f.clientX && f.clientX <= g.right;
    let m = null;
    for (let _ = 1; _ < u.length; _++) {
      const b = u[_ - 1], w = u[_];
      if (b.offset <= t.mouseContentHorizontalOffset && t.mouseContentHorizontalOffset <= w.offset) {
        m = new V(o, b.column, o, w.column);
        const y = Math.abs(b.offset - t.mouseContentHorizontalOffset), S = Math.abs(w.offset - t.mouseContentHorizontalOffset);
        r = y < S ? new ve(o, b.column) : new ve(o, w.column);
        break;
      }
    }
    return t.fulfillContentText(r, m, { mightBeForeignElement: !p || !!s, injectedText: s });
  }
  /**
   * Most probably WebKit browsers and Edge
   */
  static _doHitTestWithCaretRangeFromPoint(e, t) {
    const n = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), r = e.getVerticalOffsetForLineNumber(n), s = r + e.lineHeight;
    if (!(n === e.viewModel.getLineCount() && t.mouseVerticalOffset > s)) {
      const a = Math.floor((r + s) / 2);
      let l = t.pos.y + (a - t.mouseVerticalOffset);
      l <= t.editorPos.y && (l = t.editorPos.y + 1), l >= t.editorPos.y + t.editorPos.height && (l = t.editorPos.y + t.editorPos.height - 1);
      const c = new v4(t.pos.x, l), d = this._actualDoHitTestWithCaretRangeFromPoint(e, c.toClientCoordinates());
      if (d.type === 1)
        return d;
    }
    return this._actualDoHitTestWithCaretRangeFromPoint(e, t.pos.toClientCoordinates());
  }
  static _actualDoHitTestWithCaretRangeFromPoint(e, t) {
    const n = Ym(e.viewDomNode);
    let r;
    if (n ? typeof n.caretRangeFromPoint > "u" ? r = Q8e(n, t.clientX, t.clientY) : r = n.caretRangeFromPoint(t.clientX, t.clientY) : r = e.viewDomNode.ownerDocument.caretRangeFromPoint(t.clientX, t.clientY), !r || !r.startContainer)
      return new Af();
    const s = r.startContainer;
    if (s.nodeType === s.TEXT_NODE) {
      const o = s.parentNode, a = o ? o.parentNode : null, l = a ? a.parentNode : null;
      return (l && l.nodeType === l.ELEMENT_NODE ? l.className : null) === zd.CLASS_NAME ? Qp.createFromDOMInfo(e, o, r.startOffset) : new Af(s.parentNode);
    } else if (s.nodeType === s.ELEMENT_NODE) {
      const o = s.parentNode, a = o ? o.parentNode : null;
      return (a && a.nodeType === a.ELEMENT_NODE ? a.className : null) === zd.CLASS_NAME ? Qp.createFromDOMInfo(e, s, s.textContent.length) : new Af(s);
    }
    return new Af();
  }
  /**
   * Most probably Gecko
   */
  static _doHitTestWithCaretPositionFromPoint(e, t) {
    const n = e.viewDomNode.ownerDocument.caretPositionFromPoint(t.clientX, t.clientY);
    if (n.offsetNode.nodeType === n.offsetNode.TEXT_NODE) {
      const r = n.offsetNode.parentNode, s = r ? r.parentNode : null, o = s ? s.parentNode : null;
      return (o && o.nodeType === o.ELEMENT_NODE ? o.className : null) === zd.CLASS_NAME ? Qp.createFromDOMInfo(e, n.offsetNode.parentNode, n.offset) : new Af(n.offsetNode.parentNode);
    }
    if (n.offsetNode.nodeType === n.offsetNode.ELEMENT_NODE) {
      const r = n.offsetNode.parentNode, s = r && r.nodeType === r.ELEMENT_NODE ? r.className : null, o = r ? r.parentNode : null, a = o && o.nodeType === o.ELEMENT_NODE ? o.className : null;
      if (s === zd.CLASS_NAME) {
        const l = n.offsetNode.childNodes[Math.min(n.offset, n.offsetNode.childNodes.length - 1)];
        if (l)
          return Qp.createFromDOMInfo(e, l, 0);
      } else if (a === zd.CLASS_NAME)
        return Qp.createFromDOMInfo(e, n.offsetNode, 0);
    }
    return new Af(n.offsetNode);
  }
  static _snapToSoftTabBoundary(e, t) {
    const n = t.getLineContent(e.lineNumber), { tabSize: r } = t.model.getOptions(), s = Uy.atomicPosition(
      n,
      e.column - 1,
      r,
      2
      /* Direction.Nearest */
    );
    return s !== -1 ? new ve(e.lineNumber, s + 1) : e;
  }
  static _doHitTest(e, t) {
    let n = new Af();
    if (typeof e.viewDomNode.ownerDocument.caretRangeFromPoint == "function" ? n = this._doHitTestWithCaretRangeFromPoint(e, t) : e.viewDomNode.ownerDocument.caretPositionFromPoint && (n = this._doHitTestWithCaretPositionFromPoint(e, t.pos.toClientCoordinates())), n.type === 1) {
      const r = e.viewModel.getInjectedTextAt(n.position), s = e.viewModel.normalizePosition(
        n.position,
        2
        /* PositionAffinity.None */
      );
      (r || !s.equals(n.position)) && (n = new Hfe(s, n.spanNode, r));
    }
    return n;
  }
}
function Q8e(i, e, t) {
  const n = document.createRange();
  let r = i.elementFromPoint(e, t);
  if (r !== null) {
    for (; r && r.firstChild && r.firstChild.nodeType !== r.firstChild.TEXT_NODE && r.lastChild && r.lastChild.firstChild; )
      r = r.lastChild;
    const s = r.getBoundingClientRect(), o = window.getComputedStyle(r, null).getPropertyValue("font-style"), a = window.getComputedStyle(r, null).getPropertyValue("font-variant"), l = window.getComputedStyle(r, null).getPropertyValue("font-weight"), c = window.getComputedStyle(r, null).getPropertyValue("font-size"), d = window.getComputedStyle(r, null).getPropertyValue("line-height"), u = window.getComputedStyle(r, null).getPropertyValue("font-family"), h = `${o} ${a} ${l} ${c}/${d} ${u}`, f = r.innerText;
    let g = s.left, p = 0, m;
    if (e > s.left + s.width)
      p = f.length;
    else {
      const _ = fm.getInstance();
      for (let b = 0; b < f.length + 1; b++) {
        if (m = _.getCharWidth(f.charAt(b), h) / 2, g += m, e < g) {
          p = b;
          break;
        }
        g += m;
      }
    }
    n.setStart(r.firstChild, p), n.setEnd(r.firstChild, p);
  }
  return n;
}
class fm {
  static getInstance() {
    return fm._INSTANCE || (fm._INSTANCE = new fm()), fm._INSTANCE;
  }
  constructor() {
    this._cache = {}, this._canvas = document.createElement("canvas");
  }
  getCharWidth(e, t) {
    const n = e + t;
    if (this._cache[n])
      return this._cache[n];
    const r = this._canvas.getContext("2d");
    r.font = t;
    const o = r.measureText(e).width;
    return this._cache[n] = o, o;
  }
}
fm._INSTANCE = null;
let hc = class extends we {
  onclick(e, t) {
    this._register(Ie(e, Ge.CLICK, (n) => t(new cl(n))));
  }
  onmousedown(e, t) {
    this._register(Ie(e, Ge.MOUSE_DOWN, (n) => t(new cl(n))));
  }
  onmouseover(e, t) {
    this._register(Ie(e, Ge.MOUSE_OVER, (n) => t(new cl(n))));
  }
  onmouseleave(e, t) {
    this._register(Ie(e, Ge.MOUSE_LEAVE, (n) => t(new cl(n))));
  }
  onkeydown(e, t) {
    this._register(Ie(e, Ge.KEY_DOWN, (n) => t(new Xn(n))));
  }
  onkeyup(e, t) {
    this._register(Ie(e, Ge.KEY_UP, (n) => t(new Xn(n))));
  }
  oninput(e, t) {
    this._register(Ie(e, Ge.INPUT, t));
  }
  onblur(e, t) {
    this._register(Ie(e, Ge.BLUR, t));
  }
  onfocus(e, t) {
    this._register(Ie(e, Ge.FOCUS, t));
  }
  ignoreGesture(e) {
    return Vn.ignoreTarget(e);
  }
};
const x_ = 11;
class J8e extends hc {
  constructor(e) {
    super(), this._onActivate = e.onActivate, this.bgDomNode = document.createElement("div"), this.bgDomNode.className = "arrow-background", this.bgDomNode.style.position = "absolute", this.bgDomNode.style.width = e.bgWidth + "px", this.bgDomNode.style.height = e.bgHeight + "px", typeof e.top < "u" && (this.bgDomNode.style.top = "0px"), typeof e.left < "u" && (this.bgDomNode.style.left = "0px"), typeof e.bottom < "u" && (this.bgDomNode.style.bottom = "0px"), typeof e.right < "u" && (this.bgDomNode.style.right = "0px"), this.domNode = document.createElement("div"), this.domNode.className = e.className, this.domNode.classList.add(...ft.asClassNameArray(e.icon)), this.domNode.style.position = "absolute", this.domNode.style.width = x_ + "px", this.domNode.style.height = x_ + "px", typeof e.top < "u" && (this.domNode.style.top = e.top + "px"), typeof e.left < "u" && (this.domNode.style.left = e.left + "px"), typeof e.bottom < "u" && (this.domNode.style.bottom = e.bottom + "px"), typeof e.right < "u" && (this.domNode.style.right = e.right + "px"), this._pointerMoveMonitor = this._register(new vb()), this._register(ar(this.bgDomNode, Ge.POINTER_DOWN, (t) => this._arrowPointerDown(t))), this._register(ar(this.domNode, Ge.POINTER_DOWN, (t) => this._arrowPointerDown(t))), this._pointerdownRepeatTimer = this._register(new SS()), this._pointerdownScheduleRepeatTimer = this._register(new uc());
  }
  _arrowPointerDown(e) {
    if (!e.target || !(e.target instanceof Element))
      return;
    const t = () => {
      this._pointerdownRepeatTimer.cancelAndSet(() => this._onActivate(), 1e3 / 24);
    };
    this._onActivate(), this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancelAndSet(t, 200), this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (n) => {
    }, () => {
      this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancel();
    }), e.preventDefault();
  }
}
class $8e extends we {
  constructor(e, t, n) {
    super(), this._visibility = e, this._visibleClassName = t, this._invisibleClassName = n, this._domNode = null, this._isVisible = !1, this._isNeeded = !1, this._rawShouldBeVisible = !1, this._shouldBeVisible = !1, this._revealTimer = this._register(new uc());
  }
  setVisibility(e) {
    this._visibility !== e && (this._visibility = e, this._updateShouldBeVisible());
  }
  // ----------------- Hide / Reveal
  setShouldBeVisible(e) {
    this._rawShouldBeVisible = e, this._updateShouldBeVisible();
  }
  _applyVisibilitySetting() {
    return this._visibility === 2 ? !1 : this._visibility === 3 ? !0 : this._rawShouldBeVisible;
  }
  _updateShouldBeVisible() {
    const e = this._applyVisibilitySetting();
    this._shouldBeVisible !== e && (this._shouldBeVisible = e, this.ensureVisibility());
  }
  setIsNeeded(e) {
    this._isNeeded !== e && (this._isNeeded = e, this.ensureVisibility());
  }
  setDomNode(e) {
    this._domNode = e, this._domNode.setClassName(this._invisibleClassName), this.setShouldBeVisible(!1);
  }
  ensureVisibility() {
    if (!this._isNeeded) {
      this._hide(!1);
      return;
    }
    this._shouldBeVisible ? this._reveal() : this._hide(!0);
  }
  _reveal() {
    this._isVisible || (this._isVisible = !0, this._revealTimer.setIfNotSet(() => {
      var e;
      (e = this._domNode) === null || e === void 0 || e.setClassName(this._visibleClassName);
    }, 0));
  }
  _hide(e) {
    var t;
    this._revealTimer.cancel(), this._isVisible && (this._isVisible = !1, (t = this._domNode) === null || t === void 0 || t.setClassName(this._invisibleClassName + (e ? " fade" : "")));
  }
}
const eRe = 140;
class Wfe extends hc {
  constructor(e) {
    super(), this._lazyRender = e.lazyRender, this._host = e.host, this._scrollable = e.scrollable, this._scrollByPage = e.scrollByPage, this._scrollbarState = e.scrollbarState, this._visibilityController = this._register(new $8e(e.visibility, "visible scrollbar " + e.extraScrollbarClassName, "invisible scrollbar " + e.extraScrollbarClassName)), this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._pointerMoveMonitor = this._register(new vb()), this._shouldRender = !0, this.domNode = Dn(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this._visibilityController.setDomNode(this.domNode), this.domNode.setPosition("absolute"), this._register(Ie(this.domNode.domNode, Ge.POINTER_DOWN, (t) => this._domNodePointerDown(t)));
  }
  // ----------------- creation
  /**
   * Creates the dom node for an arrow & adds it to the container
   */
  _createArrow(e) {
    const t = this._register(new J8e(e));
    this.domNode.domNode.appendChild(t.bgDomNode), this.domNode.domNode.appendChild(t.domNode);
  }
  /**
   * Creates the slider dom node, adds it to the container & hooks up the events
   */
  _createSlider(e, t, n, r) {
    this.slider = Dn(document.createElement("div")), this.slider.setClassName("slider"), this.slider.setPosition("absolute"), this.slider.setTop(e), this.slider.setLeft(t), typeof n == "number" && this.slider.setWidth(n), typeof r == "number" && this.slider.setHeight(r), this.slider.setLayerHinting(!0), this.slider.setContain("strict"), this.domNode.domNode.appendChild(this.slider.domNode), this._register(Ie(this.slider.domNode, Ge.POINTER_DOWN, (s) => {
      s.button === 0 && (s.preventDefault(), this._sliderPointerDown(s));
    })), this.onclick(this.slider.domNode, (s) => {
      s.leftButton && s.stopPropagation();
    });
  }
  // ----------------- Update state
  _onElementSize(e) {
    return this._scrollbarState.setVisibleSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  _onElementScrollSize(e) {
    return this._scrollbarState.setScrollSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  _onElementScrollPosition(e) {
    return this._scrollbarState.setScrollPosition(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  // ----------------- rendering
  beginReveal() {
    this._visibilityController.setShouldBeVisible(!0);
  }
  beginHide() {
    this._visibilityController.setShouldBeVisible(!1);
  }
  render() {
    this._shouldRender && (this._shouldRender = !1, this._renderDomNode(this._scrollbarState.getRectangleLargeSize(), this._scrollbarState.getRectangleSmallSize()), this._updateSlider(this._scrollbarState.getSliderSize(), this._scrollbarState.getArrowSize() + this._scrollbarState.getSliderPosition()));
  }
  // ----------------- DOM events
  _domNodePointerDown(e) {
    e.target === this.domNode.domNode && this._onPointerDown(e);
  }
  delegatePointerDown(e) {
    const t = this.domNode.domNode.getClientRects()[0].top, n = t + this._scrollbarState.getSliderPosition(), r = t + this._scrollbarState.getSliderPosition() + this._scrollbarState.getSliderSize(), s = this._sliderPointerPosition(e);
    n <= s && s <= r ? e.button === 0 && (e.preventDefault(), this._sliderPointerDown(e)) : this._onPointerDown(e);
  }
  _onPointerDown(e) {
    let t, n;
    if (e.target === this.domNode.domNode && typeof e.offsetX == "number" && typeof e.offsetY == "number")
      t = e.offsetX, n = e.offsetY;
    else {
      const s = wr(this.domNode.domNode);
      t = e.pageX - s.left, n = e.pageY - s.top;
    }
    const r = this._pointerDownRelativePosition(t, n);
    this._setDesiredScrollPositionNow(this._scrollByPage ? this._scrollbarState.getDesiredScrollPositionFromOffsetPaged(r) : this._scrollbarState.getDesiredScrollPositionFromOffset(r)), e.button === 0 && (e.preventDefault(), this._sliderPointerDown(e));
  }
  _sliderPointerDown(e) {
    if (!e.target || !(e.target instanceof Element))
      return;
    const t = this._sliderPointerPosition(e), n = this._sliderOrthogonalPointerPosition(e), r = this._scrollbarState.clone();
    this.slider.toggleClassName("active", !0), this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (s) => {
      const o = this._sliderOrthogonalPointerPosition(s), a = Math.abs(o - n);
      if (Ls && a > eRe) {
        this._setDesiredScrollPositionNow(r.getScrollPosition());
        return;
      }
      const c = this._sliderPointerPosition(s) - t;
      this._setDesiredScrollPositionNow(r.getDesiredScrollPositionFromDelta(c));
    }, () => {
      this.slider.toggleClassName("active", !1), this._host.onDragEnd();
    }), this._host.onDragStart();
  }
  _setDesiredScrollPositionNow(e) {
    const t = {};
    this.writeScrollPosition(t, e), this._scrollable.setScrollPositionNow(t);
  }
  updateScrollbarSize(e) {
    this._updateScrollbarSize(e), this._scrollbarState.setScrollbarSize(e), this._shouldRender = !0, this._lazyRender || this.render();
  }
  isNeeded() {
    return this._scrollbarState.isNeeded();
  }
}
const tRe = 20;
class D_ {
  constructor(e, t, n, r, s, o) {
    this._scrollbarSize = Math.round(t), this._oppositeScrollbarSize = Math.round(n), this._arrowSize = Math.round(e), this._visibleSize = r, this._scrollSize = s, this._scrollPosition = o, this._computedAvailableSize = 0, this._computedIsNeeded = !1, this._computedSliderSize = 0, this._computedSliderRatio = 0, this._computedSliderPosition = 0, this._refreshComputedValues();
  }
  clone() {
    return new D_(this._arrowSize, this._scrollbarSize, this._oppositeScrollbarSize, this._visibleSize, this._scrollSize, this._scrollPosition);
  }
  setVisibleSize(e) {
    const t = Math.round(e);
    return this._visibleSize !== t ? (this._visibleSize = t, this._refreshComputedValues(), !0) : !1;
  }
  setScrollSize(e) {
    const t = Math.round(e);
    return this._scrollSize !== t ? (this._scrollSize = t, this._refreshComputedValues(), !0) : !1;
  }
  setScrollPosition(e) {
    const t = Math.round(e);
    return this._scrollPosition !== t ? (this._scrollPosition = t, this._refreshComputedValues(), !0) : !1;
  }
  setScrollbarSize(e) {
    this._scrollbarSize = Math.round(e);
  }
  setOppositeScrollbarSize(e) {
    this._oppositeScrollbarSize = Math.round(e);
  }
  static _computeValues(e, t, n, r, s) {
    const o = Math.max(0, n - e), a = Math.max(0, o - 2 * t), l = r > 0 && r > n;
    if (!l)
      return {
        computedAvailableSize: Math.round(o),
        computedIsNeeded: l,
        computedSliderSize: Math.round(a),
        computedSliderRatio: 0,
        computedSliderPosition: 0
      };
    const c = Math.round(Math.max(tRe, Math.floor(n * a / r))), d = (a - c) / (r - n), u = s * d;
    return {
      computedAvailableSize: Math.round(o),
      computedIsNeeded: l,
      computedSliderSize: Math.round(c),
      computedSliderRatio: d,
      computedSliderPosition: Math.round(u)
    };
  }
  _refreshComputedValues() {
    const e = D_._computeValues(this._oppositeScrollbarSize, this._arrowSize, this._visibleSize, this._scrollSize, this._scrollPosition);
    this._computedAvailableSize = e.computedAvailableSize, this._computedIsNeeded = e.computedIsNeeded, this._computedSliderSize = e.computedSliderSize, this._computedSliderRatio = e.computedSliderRatio, this._computedSliderPosition = e.computedSliderPosition;
  }
  getArrowSize() {
    return this._arrowSize;
  }
  getScrollPosition() {
    return this._scrollPosition;
  }
  getRectangleLargeSize() {
    return this._computedAvailableSize;
  }
  getRectangleSmallSize() {
    return this._scrollbarSize;
  }
  isNeeded() {
    return this._computedIsNeeded;
  }
  getSliderSize() {
    return this._computedSliderSize;
  }
  getSliderPosition() {
    return this._computedSliderPosition;
  }
  /**
   * Compute a desired `scrollPosition` such that `offset` ends up in the center of the slider.
   * `offset` is based on the same coordinate system as the `sliderPosition`.
   */
  getDesiredScrollPositionFromOffset(e) {
    if (!this._computedIsNeeded)
      return 0;
    const t = e - this._arrowSize - this._computedSliderSize / 2;
    return Math.round(t / this._computedSliderRatio);
  }
  /**
   * Compute a desired `scrollPosition` from if offset is before or after the slider position.
   * If offset is before slider, treat as a page up (or left).  If after, page down (or right).
   * `offset` and `_computedSliderPosition` are based on the same coordinate system.
   * `_visibleSize` corresponds to a "page" of lines in the returned coordinate system.
   */
  getDesiredScrollPositionFromOffsetPaged(e) {
    if (!this._computedIsNeeded)
      return 0;
    const t = e - this._arrowSize;
    let n = this._scrollPosition;
    return t < this._computedSliderPosition ? n -= this._visibleSize : n += this._visibleSize, n;
  }
  /**
   * Compute a desired `scrollPosition` such that the slider moves by `delta`.
   */
  getDesiredScrollPositionFromDelta(e) {
    if (!this._computedIsNeeded)
      return 0;
    const t = this._computedSliderPosition + e;
    return Math.round(t / this._computedSliderRatio);
  }
}
class nRe extends Wfe {
  constructor(e, t, n) {
    const r = e.getScrollDimensions(), s = e.getCurrentScrollPosition();
    if (super({
      lazyRender: t.lazyRender,
      host: n,
      scrollbarState: new D_(t.horizontalHasArrows ? t.arrowSize : 0, t.horizontal === 2 ? 0 : t.horizontalScrollbarSize, t.vertical === 2 ? 0 : t.verticalScrollbarSize, r.width, r.scrollWidth, s.scrollLeft),
      visibility: t.horizontal,
      extraScrollbarClassName: "horizontal",
      scrollable: e,
      scrollByPage: t.scrollByPage
    }), t.horizontalHasArrows) {
      const o = (t.arrowSize - x_) / 2, a = (t.horizontalScrollbarSize - x_) / 2;
      this._createArrow({
        className: "scra",
        icon: We.scrollbarButtonLeft,
        top: a,
        left: o,
        bottom: void 0,
        right: void 0,
        bgWidth: t.arrowSize,
        bgHeight: t.horizontalScrollbarSize,
        onActivate: () => this._host.onMouseWheel(new Km(null, 1, 0))
      }), this._createArrow({
        className: "scra",
        icon: We.scrollbarButtonRight,
        top: a,
        left: void 0,
        bottom: void 0,
        right: o,
        bgWidth: t.arrowSize,
        bgHeight: t.horizontalScrollbarSize,
        onActivate: () => this._host.onMouseWheel(new Km(null, -1, 0))
      });
    }
    this._createSlider(Math.floor((t.horizontalScrollbarSize - t.horizontalSliderSize) / 2), 0, void 0, t.horizontalSliderSize);
  }
  _updateSlider(e, t) {
    this.slider.setWidth(e), this.slider.setLeft(t);
  }
  _renderDomNode(e, t) {
    this.domNode.setWidth(e), this.domNode.setHeight(t), this.domNode.setLeft(0), this.domNode.setBottom(0);
  }
  onDidScroll(e) {
    return this._shouldRender = this._onElementScrollSize(e.scrollWidth) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollLeft) || this._shouldRender, this._shouldRender = this._onElementSize(e.width) || this._shouldRender, this._shouldRender;
  }
  _pointerDownRelativePosition(e, t) {
    return e;
  }
  _sliderPointerPosition(e) {
    return e.pageX;
  }
  _sliderOrthogonalPointerPosition(e) {
    return e.pageY;
  }
  _updateScrollbarSize(e) {
    this.slider.setHeight(e);
  }
  writeScrollPosition(e, t) {
    e.scrollLeft = t;
  }
  updateOptions(e) {
    this.updateScrollbarSize(e.horizontal === 2 ? 0 : e.horizontalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(e.vertical === 2 ? 0 : e.verticalScrollbarSize), this._visibilityController.setVisibility(e.horizontal), this._scrollByPage = e.scrollByPage;
  }
}
class iRe extends Wfe {
  constructor(e, t, n) {
    const r = e.getScrollDimensions(), s = e.getCurrentScrollPosition();
    if (super({
      lazyRender: t.lazyRender,
      host: n,
      scrollbarState: new D_(
        t.verticalHasArrows ? t.arrowSize : 0,
        t.vertical === 2 ? 0 : t.verticalScrollbarSize,
        // give priority to vertical scroll bar over horizontal and let it scroll all the way to the bottom
        0,
        r.height,
        r.scrollHeight,
        s.scrollTop
      ),
      visibility: t.vertical,
      extraScrollbarClassName: "vertical",
      scrollable: e,
      scrollByPage: t.scrollByPage
    }), t.verticalHasArrows) {
      const o = (t.arrowSize - x_) / 2, a = (t.verticalScrollbarSize - x_) / 2;
      this._createArrow({
        className: "scra",
        icon: We.scrollbarButtonUp,
        top: o,
        left: a,
        bottom: void 0,
        right: void 0,
        bgWidth: t.verticalScrollbarSize,
        bgHeight: t.arrowSize,
        onActivate: () => this._host.onMouseWheel(new Km(null, 0, 1))
      }), this._createArrow({
        className: "scra",
        icon: We.scrollbarButtonDown,
        top: void 0,
        left: a,
        bottom: o,
        right: void 0,
        bgWidth: t.verticalScrollbarSize,
        bgHeight: t.arrowSize,
        onActivate: () => this._host.onMouseWheel(new Km(null, 0, -1))
      });
    }
    this._createSlider(0, Math.floor((t.verticalScrollbarSize - t.verticalSliderSize) / 2), t.verticalSliderSize, void 0);
  }
  _updateSlider(e, t) {
    this.slider.setHeight(e), this.slider.setTop(t);
  }
  _renderDomNode(e, t) {
    this.domNode.setWidth(t), this.domNode.setHeight(e), this.domNode.setRight(0), this.domNode.setTop(0);
  }
  onDidScroll(e) {
    return this._shouldRender = this._onElementScrollSize(e.scrollHeight) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollTop) || this._shouldRender, this._shouldRender = this._onElementSize(e.height) || this._shouldRender, this._shouldRender;
  }
  _pointerDownRelativePosition(e, t) {
    return t;
  }
  _sliderPointerPosition(e) {
    return e.pageY;
  }
  _sliderOrthogonalPointerPosition(e) {
    return e.pageX;
  }
  _updateScrollbarSize(e) {
    this.slider.setWidth(e);
  }
  writeScrollPosition(e, t) {
    e.scrollTop = t;
  }
  updateOptions(e) {
    this.updateScrollbarSize(e.vertical === 2 ? 0 : e.verticalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(0), this._visibilityController.setVisibility(e.vertical), this._scrollByPage = e.scrollByPage;
  }
}
class hL {
  constructor(e, t, n, r, s, o, a) {
    this._forceIntegerValues = e, this._scrollStateBrand = void 0, this._forceIntegerValues && (t = t | 0, n = n | 0, r = r | 0, s = s | 0, o = o | 0, a = a | 0), this.rawScrollLeft = r, this.rawScrollTop = a, t < 0 && (t = 0), r + t > n && (r = n - t), r < 0 && (r = 0), s < 0 && (s = 0), a + s > o && (a = o - s), a < 0 && (a = 0), this.width = t, this.scrollWidth = n, this.scrollLeft = r, this.height = s, this.scrollHeight = o, this.scrollTop = a;
  }
  equals(e) {
    return this.rawScrollLeft === e.rawScrollLeft && this.rawScrollTop === e.rawScrollTop && this.width === e.width && this.scrollWidth === e.scrollWidth && this.scrollLeft === e.scrollLeft && this.height === e.height && this.scrollHeight === e.scrollHeight && this.scrollTop === e.scrollTop;
  }
  withScrollDimensions(e, t) {
    return new hL(this._forceIntegerValues, typeof e.width < "u" ? e.width : this.width, typeof e.scrollWidth < "u" ? e.scrollWidth : this.scrollWidth, t ? this.rawScrollLeft : this.scrollLeft, typeof e.height < "u" ? e.height : this.height, typeof e.scrollHeight < "u" ? e.scrollHeight : this.scrollHeight, t ? this.rawScrollTop : this.scrollTop);
  }
  withScrollPosition(e) {
    return new hL(this._forceIntegerValues, this.width, this.scrollWidth, typeof e.scrollLeft < "u" ? e.scrollLeft : this.rawScrollLeft, this.height, this.scrollHeight, typeof e.scrollTop < "u" ? e.scrollTop : this.rawScrollTop);
  }
  createScrollEvent(e, t) {
    const n = this.width !== e.width, r = this.scrollWidth !== e.scrollWidth, s = this.scrollLeft !== e.scrollLeft, o = this.height !== e.height, a = this.scrollHeight !== e.scrollHeight, l = this.scrollTop !== e.scrollTop;
    return {
      inSmoothScrolling: t,
      oldWidth: e.width,
      oldScrollWidth: e.scrollWidth,
      oldScrollLeft: e.scrollLeft,
      width: this.width,
      scrollWidth: this.scrollWidth,
      scrollLeft: this.scrollLeft,
      oldHeight: e.height,
      oldScrollHeight: e.scrollHeight,
      oldScrollTop: e.scrollTop,
      height: this.height,
      scrollHeight: this.scrollHeight,
      scrollTop: this.scrollTop,
      widthChanged: n,
      scrollWidthChanged: r,
      scrollLeftChanged: s,
      heightChanged: o,
      scrollHeightChanged: a,
      scrollTopChanged: l
    };
  }
}
class kS extends we {
  constructor(e) {
    super(), this._scrollableBrand = void 0, this._onScroll = this._register(new pe()), this.onScroll = this._onScroll.event, this._smoothScrollDuration = e.smoothScrollDuration, this._scheduleAtNextAnimationFrame = e.scheduleAtNextAnimationFrame, this._state = new hL(e.forceIntegerValues, 0, 0, 0, 0, 0, 0), this._smoothScrolling = null;
  }
  dispose() {
    this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), super.dispose();
  }
  setSmoothScrollDuration(e) {
    this._smoothScrollDuration = e;
  }
  validateScrollPosition(e) {
    return this._state.withScrollPosition(e);
  }
  getScrollDimensions() {
    return this._state;
  }
  setScrollDimensions(e, t) {
    var n;
    const r = this._state.withScrollDimensions(e, t);
    this._setState(r, !!this._smoothScrolling), (n = this._smoothScrolling) === null || n === void 0 || n.acceptScrollDimensions(this._state);
  }
  /**
   * Returns the final scroll position that the instance will have once the smooth scroll animation concludes.
   * If no scroll animation is occurring, it will return the current scroll position instead.
   */
  getFutureScrollPosition() {
    return this._smoothScrolling ? this._smoothScrolling.to : this._state;
  }
  /**
   * Returns the current scroll position.
   * Note: This result might be an intermediate scroll position, as there might be an ongoing smooth scroll animation.
   */
  getCurrentScrollPosition() {
    return this._state;
  }
  setScrollPositionNow(e) {
    const t = this._state.withScrollPosition(e);
    this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), this._setState(t, !1);
  }
  setScrollPositionSmooth(e, t) {
    if (this._smoothScrollDuration === 0)
      return this.setScrollPositionNow(e);
    if (this._smoothScrolling) {
      e = {
        scrollLeft: typeof e.scrollLeft > "u" ? this._smoothScrolling.to.scrollLeft : e.scrollLeft,
        scrollTop: typeof e.scrollTop > "u" ? this._smoothScrolling.to.scrollTop : e.scrollTop
      };
      const n = this._state.withScrollPosition(e);
      if (this._smoothScrolling.to.scrollLeft === n.scrollLeft && this._smoothScrolling.to.scrollTop === n.scrollTop)
        return;
      let r;
      t ? r = new Gy(this._smoothScrolling.from, n, this._smoothScrolling.startTime, this._smoothScrolling.duration) : r = this._smoothScrolling.combine(this._state, n, this._smoothScrollDuration), this._smoothScrolling.dispose(), this._smoothScrolling = r;
    } else {
      const n = this._state.withScrollPosition(e);
      this._smoothScrolling = Gy.start(this._state, n, this._smoothScrollDuration);
    }
    this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(() => {
      this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
    });
  }
  hasPendingScrollAnimation() {
    return !!this._smoothScrolling;
  }
  _performSmoothScrolling() {
    if (!this._smoothScrolling)
      return;
    const e = this._smoothScrolling.tick(), t = this._state.withScrollPosition(e);
    if (this._setState(t, !0), !!this._smoothScrolling) {
      if (e.isDone) {
        this._smoothScrolling.dispose(), this._smoothScrolling = null;
        return;
      }
      this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(() => {
        this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
      });
    }
  }
  _setState(e, t) {
    const n = this._state;
    n.equals(e) || (this._state = e, this._onScroll.fire(this._state.createScrollEvent(n, t)));
  }
}
class xZ {
  constructor(e, t, n) {
    this.scrollLeft = e, this.scrollTop = t, this.isDone = n;
  }
}
function L6(i, e) {
  const t = e - i;
  return function(n) {
    return i + t * oRe(n);
  };
}
function rRe(i, e, t) {
  return function(n) {
    return n < t ? i(n / t) : e((n - t) / (1 - t));
  };
}
class Gy {
  constructor(e, t, n, r) {
    this.from = e, this.to = t, this.duration = r, this.startTime = n, this.animationFrameDisposable = null, this._initAnimations();
  }
  _initAnimations() {
    this.scrollLeft = this._initAnimation(this.from.scrollLeft, this.to.scrollLeft, this.to.width), this.scrollTop = this._initAnimation(this.from.scrollTop, this.to.scrollTop, this.to.height);
  }
  _initAnimation(e, t, n) {
    if (Math.abs(e - t) > 2.5 * n) {
      let s, o;
      return e < t ? (s = e + 0.75 * n, o = t - 0.75 * n) : (s = e - 0.75 * n, o = t + 0.75 * n), rRe(L6(e, s), L6(o, t), 0.33);
    }
    return L6(e, t);
  }
  dispose() {
    this.animationFrameDisposable !== null && (this.animationFrameDisposable.dispose(), this.animationFrameDisposable = null);
  }
  acceptScrollDimensions(e) {
    this.to = e.withScrollPosition(this.to), this._initAnimations();
  }
  tick() {
    return this._tick(Date.now());
  }
  _tick(e) {
    const t = (e - this.startTime) / this.duration;
    if (t < 1) {
      const n = this.scrollLeft(t), r = this.scrollTop(t);
      return new xZ(n, r, !1);
    }
    return new xZ(this.to.scrollLeft, this.to.scrollTop, !0);
  }
  combine(e, t, n) {
    return Gy.start(e, t, n);
  }
  static start(e, t, n) {
    n = n + 10;
    const r = Date.now() - 10;
    return new Gy(e, t, r, n);
  }
}
function sRe(i) {
  return Math.pow(i, 3);
}
function oRe(i) {
  return 1 - sRe(1 - i);
}
const aRe = 500, DZ = 50;
class lRe {
  constructor(e, t, n) {
    this.timestamp = e, this.deltaX = t, this.deltaY = n, this.score = 0;
  }
}
class fL {
  constructor() {
    this._capacity = 5, this._memory = [], this._front = -1, this._rear = -1;
  }
  isPhysicalMouseWheel() {
    if (this._front === -1 && this._rear === -1)
      return !1;
    let e = 1, t = 0, n = 1, r = this._rear;
    do {
      const s = r === this._front ? e : Math.pow(2, -n);
      if (e -= s, t += this._memory[r].score * s, r === this._front)
        break;
      r = (this._capacity + r - 1) % this._capacity, n++;
    } while (!0);
    return t <= 0.5;
  }
  acceptStandardWheelEvent(e) {
    const t = window.devicePixelRatio / TNe();
    Ls || $s ? this.accept(Date.now(), e.deltaX / t, e.deltaY / t) : this.accept(Date.now(), e.deltaX, e.deltaY);
  }
  accept(e, t, n) {
    const r = new lRe(e, t, n);
    r.score = this._computeScore(r), this._front === -1 && this._rear === -1 ? (this._memory[0] = r, this._front = 0, this._rear = 0) : (this._rear = (this._rear + 1) % this._capacity, this._rear === this._front && (this._front = (this._front + 1) % this._capacity), this._memory[this._rear] = r);
  }
  /**
   * A score between 0 and 1 for `item`.
   *  - a score towards 0 indicates that the source appears to be a physical mouse wheel
   *  - a score towards 1 indicates that the source appears to be a touchpad or magic mouse, etc.
   */
  _computeScore(e) {
    if (Math.abs(e.deltaX) > 0 && Math.abs(e.deltaY) > 0)
      return 1;
    let t = 0.5;
    return this._front === -1 && this._rear === -1 || this._memory[this._rear], (!this._isAlmostInt(e.deltaX) || !this._isAlmostInt(e.deltaY)) && (t += 0.25), Math.min(Math.max(t, 0), 1);
  }
  _isAlmostInt(e) {
    return Math.abs(Math.round(e) - e) < 0.01;
  }
}
fL.INSTANCE = new fL();
class yz extends hc {
  get options() {
    return this._options;
  }
  constructor(e, t, n) {
    super(), this._onScroll = this._register(new pe()), this.onScroll = this._onScroll.event, this._onWillScroll = this._register(new pe()), e.style.overflow = "hidden", this._options = cRe(t), this._scrollable = n, this._register(this._scrollable.onScroll((s) => {
      this._onWillScroll.fire(s), this._onDidScroll(s), this._onScroll.fire(s);
    }));
    const r = {
      onMouseWheel: (s) => this._onMouseWheel(s),
      onDragStart: () => this._onDragStart(),
      onDragEnd: () => this._onDragEnd()
    };
    this._verticalScrollbar = this._register(new iRe(this._scrollable, this._options, r)), this._horizontalScrollbar = this._register(new nRe(this._scrollable, this._options, r)), this._domNode = document.createElement("div"), this._domNode.className = "monaco-scrollable-element " + this._options.className, this._domNode.setAttribute("role", "presentation"), this._domNode.style.position = "relative", this._domNode.style.overflow = "hidden", this._domNode.appendChild(e), this._domNode.appendChild(this._horizontalScrollbar.domNode.domNode), this._domNode.appendChild(this._verticalScrollbar.domNode.domNode), this._options.useShadows ? (this._leftShadowDomNode = Dn(document.createElement("div")), this._leftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._leftShadowDomNode.domNode), this._topShadowDomNode = Dn(document.createElement("div")), this._topShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topShadowDomNode.domNode), this._topLeftShadowDomNode = Dn(document.createElement("div")), this._topLeftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topLeftShadowDomNode.domNode)) : (this._leftShadowDomNode = null, this._topShadowDomNode = null, this._topLeftShadowDomNode = null), this._listenOnDomNode = this._options.listenOnDomNode || this._domNode, this._mouseWheelToDispose = [], this._setListeningToMouseWheel(this._options.handleMouseWheel), this.onmouseover(this._listenOnDomNode, (s) => this._onMouseOver(s)), this.onmouseleave(this._listenOnDomNode, (s) => this._onMouseLeave(s)), this._hideTimeout = this._register(new uc()), this._isDragging = !1, this._mouseIsOver = !1, this._shouldRender = !0, this._revealOnScroll = !0;
  }
  dispose() {
    this._mouseWheelToDispose = An(this._mouseWheelToDispose), super.dispose();
  }
  /**
   * Get the generated 'scrollable' dom node
   */
  getDomNode() {
    return this._domNode;
  }
  getOverviewRulerLayoutInfo() {
    return {
      parent: this._domNode,
      insertBefore: this._verticalScrollbar.domNode.domNode
    };
  }
  /**
   * Delegate a pointer down event to the vertical scrollbar.
   * This is to help with clicking somewhere else and having the scrollbar react.
   */
  delegateVerticalScrollbarPointerDown(e) {
    this._verticalScrollbar.delegatePointerDown(e);
  }
  getScrollDimensions() {
    return this._scrollable.getScrollDimensions();
  }
  setScrollDimensions(e) {
    this._scrollable.setScrollDimensions(e, !1);
  }
  /**
   * Update the class name of the scrollable element.
   */
  updateClassName(e) {
    this._options.className = e, sn && (this._options.className += " mac"), this._domNode.className = "monaco-scrollable-element " + this._options.className;
  }
  /**
   * Update configuration options for the scrollbar.
   */
  updateOptions(e) {
    typeof e.handleMouseWheel < "u" && (this._options.handleMouseWheel = e.handleMouseWheel, this._setListeningToMouseWheel(this._options.handleMouseWheel)), typeof e.mouseWheelScrollSensitivity < "u" && (this._options.mouseWheelScrollSensitivity = e.mouseWheelScrollSensitivity), typeof e.fastScrollSensitivity < "u" && (this._options.fastScrollSensitivity = e.fastScrollSensitivity), typeof e.scrollPredominantAxis < "u" && (this._options.scrollPredominantAxis = e.scrollPredominantAxis), typeof e.horizontal < "u" && (this._options.horizontal = e.horizontal), typeof e.vertical < "u" && (this._options.vertical = e.vertical), typeof e.horizontalScrollbarSize < "u" && (this._options.horizontalScrollbarSize = e.horizontalScrollbarSize), typeof e.verticalScrollbarSize < "u" && (this._options.verticalScrollbarSize = e.verticalScrollbarSize), typeof e.scrollByPage < "u" && (this._options.scrollByPage = e.scrollByPage), this._horizontalScrollbar.updateOptions(this._options), this._verticalScrollbar.updateOptions(this._options), this._options.lazyRender || this._render();
  }
  delegateScrollFromMouseWheelEvent(e) {
    this._onMouseWheel(new Km(e));
  }
  // -------------------- mouse wheel scrolling --------------------
  _setListeningToMouseWheel(e) {
    if (this._mouseWheelToDispose.length > 0 !== e && (this._mouseWheelToDispose = An(this._mouseWheelToDispose), e)) {
      const n = (r) => {
        this._onMouseWheel(new Km(r));
      };
      this._mouseWheelToDispose.push(Ie(this._listenOnDomNode, Ge.MOUSE_WHEEL, n, { passive: !1 }));
    }
  }
  _onMouseWheel(e) {
    var t;
    if (!((t = e.browserEvent) === null || t === void 0) && t.defaultPrevented)
      return;
    const n = fL.INSTANCE;
    n.acceptStandardWheelEvent(e);
    let r = !1;
    if (e.deltaY || e.deltaX) {
      let o = e.deltaY * this._options.mouseWheelScrollSensitivity, a = e.deltaX * this._options.mouseWheelScrollSensitivity;
      this._options.scrollPredominantAxis && (this._options.scrollYToX && a + o === 0 ? a = o = 0 : Math.abs(o) >= Math.abs(a) ? a = 0 : o = 0), this._options.flipAxes && ([o, a] = [a, o]);
      const l = !sn && e.browserEvent && e.browserEvent.shiftKey;
      (this._options.scrollYToX || l) && !a && (a = o, o = 0), e.browserEvent && e.browserEvent.altKey && (a = a * this._options.fastScrollSensitivity, o = o * this._options.fastScrollSensitivity);
      const c = this._scrollable.getFutureScrollPosition();
      let d = {};
      if (o) {
        const u = DZ * o, h = c.scrollTop - (u < 0 ? Math.floor(u) : Math.ceil(u));
        this._verticalScrollbar.writeScrollPosition(d, h);
      }
      if (a) {
        const u = DZ * a, h = c.scrollLeft - (u < 0 ? Math.floor(u) : Math.ceil(u));
        this._horizontalScrollbar.writeScrollPosition(d, h);
      }
      d = this._scrollable.validateScrollPosition(d), (c.scrollLeft !== d.scrollLeft || c.scrollTop !== d.scrollTop) && (this._options.mouseWheelSmoothScroll && n.isPhysicalMouseWheel() ? this._scrollable.setScrollPositionSmooth(d) : this._scrollable.setScrollPositionNow(d), r = !0);
    }
    let s = r;
    !s && this._options.alwaysConsumeMouseWheel && (s = !0), !s && this._options.consumeMouseWheelIfScrollbarIsNeeded && (this._verticalScrollbar.isNeeded() || this._horizontalScrollbar.isNeeded()) && (s = !0), s && (e.preventDefault(), e.stopPropagation());
  }
  _onDidScroll(e) {
    this._shouldRender = this._horizontalScrollbar.onDidScroll(e) || this._shouldRender, this._shouldRender = this._verticalScrollbar.onDidScroll(e) || this._shouldRender, this._options.useShadows && (this._shouldRender = !0), this._revealOnScroll && this._reveal(), this._options.lazyRender || this._render();
  }
  /**
   * Render / mutate the DOM now.
   * Should be used together with the ctor option `lazyRender`.
   */
  renderNow() {
    if (!this._options.lazyRender)
      throw new Error("Please use `lazyRender` together with `renderNow`!");
    this._render();
  }
  _render() {
    if (this._shouldRender && (this._shouldRender = !1, this._horizontalScrollbar.render(), this._verticalScrollbar.render(), this._options.useShadows)) {
      const e = this._scrollable.getCurrentScrollPosition(), t = e.scrollTop > 0, n = e.scrollLeft > 0, r = n ? " left" : "", s = t ? " top" : "", o = n || t ? " top-left-corner" : "";
      this._leftShadowDomNode.setClassName(`shadow${r}`), this._topShadowDomNode.setClassName(`shadow${s}`), this._topLeftShadowDomNode.setClassName(`shadow${o}${s}${r}`);
    }
  }
  // -------------------- fade in / fade out --------------------
  _onDragStart() {
    this._isDragging = !0, this._reveal();
  }
  _onDragEnd() {
    this._isDragging = !1, this._hide();
  }
  _onMouseLeave(e) {
    this._mouseIsOver = !1, this._hide();
  }
  _onMouseOver(e) {
    this._mouseIsOver = !0, this._reveal();
  }
  _reveal() {
    this._verticalScrollbar.beginReveal(), this._horizontalScrollbar.beginReveal(), this._scheduleHide();
  }
  _hide() {
    !this._mouseIsOver && !this._isDragging && (this._verticalScrollbar.beginHide(), this._horizontalScrollbar.beginHide());
  }
  _scheduleHide() {
    !this._mouseIsOver && !this._isDragging && this._hideTimeout.cancelAndSet(() => this._hide(), aRe);
  }
}
class jfe extends yz {
  constructor(e, t) {
    t = t || {}, t.mouseWheelSmoothScroll = !1;
    const n = new kS({
      forceIntegerValues: !0,
      smoothScrollDuration: 0,
      scheduleAtNextAnimationFrame: (r) => Cl(r)
    });
    super(e, t, n), this._register(n);
  }
  setScrollPosition(e) {
    this._scrollable.setScrollPositionNow(e);
  }
}
class wz extends yz {
  constructor(e, t, n) {
    super(e, t, n);
  }
  setScrollPosition(e) {
    e.reuseAnimation ? this._scrollable.setScrollPositionSmooth(e, e.reuseAnimation) : this._scrollable.setScrollPositionNow(e);
  }
  getScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
}
class TS extends yz {
  constructor(e, t) {
    t = t || {}, t.mouseWheelSmoothScroll = !1;
    const n = new kS({
      forceIntegerValues: !1,
      // See https://github.com/microsoft/vscode/issues/139877
      smoothScrollDuration: 0,
      scheduleAtNextAnimationFrame: (r) => Cl(r)
    });
    super(e, t, n), this._register(n), this._element = e, this._register(this.onScroll((r) => {
      r.scrollTopChanged && (this._element.scrollTop = r.scrollTop), r.scrollLeftChanged && (this._element.scrollLeft = r.scrollLeft);
    })), this.scanDomNode();
  }
  setScrollPosition(e) {
    this._scrollable.setScrollPositionNow(e);
  }
  getScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
  scanDomNode() {
    this.setScrollDimensions({
      width: this._element.clientWidth,
      scrollWidth: this._element.scrollWidth,
      height: this._element.clientHeight,
      scrollHeight: this._element.scrollHeight
    }), this.setScrollPosition({
      scrollLeft: this._element.scrollLeft,
      scrollTop: this._element.scrollTop
    });
  }
}
function cRe(i) {
  const e = {
    lazyRender: typeof i.lazyRender < "u" ? i.lazyRender : !1,
    className: typeof i.className < "u" ? i.className : "",
    useShadows: typeof i.useShadows < "u" ? i.useShadows : !0,
    handleMouseWheel: typeof i.handleMouseWheel < "u" ? i.handleMouseWheel : !0,
    flipAxes: typeof i.flipAxes < "u" ? i.flipAxes : !1,
    consumeMouseWheelIfScrollbarIsNeeded: typeof i.consumeMouseWheelIfScrollbarIsNeeded < "u" ? i.consumeMouseWheelIfScrollbarIsNeeded : !1,
    alwaysConsumeMouseWheel: typeof i.alwaysConsumeMouseWheel < "u" ? i.alwaysConsumeMouseWheel : !1,
    scrollYToX: typeof i.scrollYToX < "u" ? i.scrollYToX : !1,
    mouseWheelScrollSensitivity: typeof i.mouseWheelScrollSensitivity < "u" ? i.mouseWheelScrollSensitivity : 1,
    fastScrollSensitivity: typeof i.fastScrollSensitivity < "u" ? i.fastScrollSensitivity : 5,
    scrollPredominantAxis: typeof i.scrollPredominantAxis < "u" ? i.scrollPredominantAxis : !0,
    mouseWheelSmoothScroll: typeof i.mouseWheelSmoothScroll < "u" ? i.mouseWheelSmoothScroll : !0,
    arrowSize: typeof i.arrowSize < "u" ? i.arrowSize : 11,
    listenOnDomNode: typeof i.listenOnDomNode < "u" ? i.listenOnDomNode : null,
    horizontal: typeof i.horizontal < "u" ? i.horizontal : 1,
    horizontalScrollbarSize: typeof i.horizontalScrollbarSize < "u" ? i.horizontalScrollbarSize : 10,
    horizontalSliderSize: typeof i.horizontalSliderSize < "u" ? i.horizontalSliderSize : 0,
    horizontalHasArrows: typeof i.horizontalHasArrows < "u" ? i.horizontalHasArrows : !1,
    vertical: typeof i.vertical < "u" ? i.vertical : 1,
    verticalScrollbarSize: typeof i.verticalScrollbarSize < "u" ? i.verticalScrollbarSize : 10,
    verticalHasArrows: typeof i.verticalHasArrows < "u" ? i.verticalHasArrows : !1,
    verticalSliderSize: typeof i.verticalSliderSize < "u" ? i.verticalSliderSize : 0,
    scrollByPage: typeof i.scrollByPage < "u" ? i.scrollByPage : !1
  };
  return e.horizontalSliderSize = typeof i.horizontalSliderSize < "u" ? i.horizontalSliderSize : e.horizontalScrollbarSize, e.verticalSliderSize = typeof i.verticalSliderSize < "u" ? i.verticalSliderSize : e.verticalScrollbarSize, sn && (e.className += " mac"), e;
}
class Sz extends AS {
  constructor(e, t, n) {
    super(), this._mouseLeaveMonitor = null, this._context = e, this.viewController = t, this.viewHelper = n, this.mouseTargetFactory = new ps(this._context, n), this._mouseDownOperation = this._register(new dRe(this._context, this.viewController, this.viewHelper, this.mouseTargetFactory, (o, a) => this._createMouseTarget(o, a), (o) => this._getMouseColumn(o))), this.lastMouseLeaveTime = -1, this._height = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    ).height;
    const r = new R8e(this.viewHelper.viewDomNode);
    this._register(r.onContextMenu(this.viewHelper.viewDomNode, (o) => this._onContextMenu(o, !0))), this._register(r.onMouseMove(this.viewHelper.viewDomNode, (o) => {
      this._onMouseMove(o), this._mouseLeaveMonitor || (this._mouseLeaveMonitor = Ie(this.viewHelper.viewDomNode.ownerDocument, "mousemove", (a) => {
        this.viewHelper.viewDomNode.contains(a.target) || this._onMouseLeave(new Hg(a, !1, this.viewHelper.viewDomNode));
      }));
    })), this._register(r.onMouseUp(this.viewHelper.viewDomNode, (o) => this._onMouseUp(o))), this._register(r.onMouseLeave(this.viewHelper.viewDomNode, (o) => this._onMouseLeave(o)));
    let s = 0;
    this._register(r.onPointerDown(this.viewHelper.viewDomNode, (o, a) => {
      s = a;
    })), this._register(Ie(this.viewHelper.viewDomNode, Ge.POINTER_UP, (o) => {
      this._mouseDownOperation.onPointerUp();
    })), this._register(r.onMouseDown(this.viewHelper.viewDomNode, (o) => this._onMouseDown(o, s))), this._setupMouseWheelZoomListener(), this._context.addEventHandler(this);
  }
  _setupMouseWheelZoomListener() {
    const e = fL.INSTANCE;
    let t = 0, n = rl.getZoomLevel(), r = !1, s = 0;
    const o = (l) => {
      if (this.viewController.emitMouseWheel(l), !this._context.configuration.options.get(
        75
        /* EditorOption.mouseWheelZoom */
      ))
        return;
      const c = new Km(l);
      if (e.acceptStandardWheelEvent(c), e.isPhysicalMouseWheel()) {
        if (a(l)) {
          const d = rl.getZoomLevel(), u = c.deltaY > 0 ? 1 : -1;
          rl.setZoomLevel(d + u), c.preventDefault(), c.stopPropagation();
        }
      } else
        Date.now() - t > 50 && (n = rl.getZoomLevel(), r = a(l), s = 0), t = Date.now(), s += c.deltaY, r && (rl.setZoomLevel(n + s / 5), c.preventDefault(), c.stopPropagation());
    };
    this._register(Ie(this.viewHelper.viewDomNode, Ge.MOUSE_WHEEL, o, { capture: !0, passive: !1 }));
    function a(l) {
      return sn ? (l.metaKey || l.ctrlKey) && !l.shiftKey && !l.altKey : l.ctrlKey && !l.metaKey && !l.shiftKey && !l.altKey;
    }
  }
  dispose() {
    this._context.removeEventHandler(this), this._mouseLeaveMonitor && (this._mouseLeaveMonitor.dispose(), this._mouseLeaveMonitor = null), super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    if (e.hasChanged(
      143
      /* EditorOption.layoutInfo */
    )) {
      const t = this._context.configuration.options.get(
        143
        /* EditorOption.layoutInfo */
      ).height;
      this._height !== t && (this._height = t, this._mouseDownOperation.onHeightChanged());
    }
    return !1;
  }
  onCursorStateChanged(e) {
    return this._mouseDownOperation.onCursorStateChanged(e), !1;
  }
  onFocusChanged(e) {
    return !1;
  }
  // --- end event handlers
  getTargetAtClientPoint(e, t) {
    const r = new Ffe(e, t).toPageCoordinates(), s = vz(this.viewHelper.viewDomNode);
    if (r.y < s.y || r.y > s.y + s.height || r.x < s.x || r.x > s.x + s.width)
      return null;
    const o = _z(this.viewHelper.viewDomNode, s, r);
    return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), s, r, o, null);
  }
  _createMouseTarget(e, t) {
    let n = e.target;
    if (!this.viewHelper.viewDomNode.contains(n)) {
      const r = Ym(this.viewHelper.viewDomNode);
      r && (n = r.elementsFromPoint(e.posx, e.posy).find((s) => this.viewHelper.viewDomNode.contains(s)));
    }
    return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), e.editorPos, e.pos, e.relativePos, t ? n : null);
  }
  _getMouseColumn(e) {
    return this.mouseTargetFactory.getMouseColumn(e.relativePos);
  }
  _onContextMenu(e, t) {
    this.viewController.emitContextMenu({
      event: e,
      target: this._createMouseTarget(e, t)
    });
  }
  _onMouseMove(e) {
    this.mouseTargetFactory.mouseTargetIsWidget(e) || e.preventDefault(), !(this._mouseDownOperation.isActive() || e.timestamp < this.lastMouseLeaveTime) && this.viewController.emitMouseMove({
      event: e,
      target: this._createMouseTarget(e, !0)
    });
  }
  _onMouseLeave(e) {
    this._mouseLeaveMonitor && (this._mouseLeaveMonitor.dispose(), this._mouseLeaveMonitor = null), this.lastMouseLeaveTime = (/* @__PURE__ */ new Date()).getTime(), this.viewController.emitMouseLeave({
      event: e,
      target: null
    });
  }
  _onMouseUp(e) {
    this.viewController.emitMouseUp({
      event: e,
      target: this._createMouseTarget(e, !0)
    });
  }
  _onMouseDown(e, t) {
    const n = this._createMouseTarget(e, !0), r = n.type === 6 || n.type === 7, s = n.type === 2 || n.type === 3 || n.type === 4, o = n.type === 3, a = this._context.configuration.options.get(
      108
      /* EditorOption.selectOnLineNumbers */
    ), l = n.type === 8 || n.type === 5, c = n.type === 9;
    let d = e.leftButton || e.middleButton;
    sn && e.leftButton && e.ctrlKey && (d = !1);
    const u = () => {
      e.preventDefault(), this.viewHelper.focusTextArea();
    };
    if (d && (r || o && a))
      u(), this._mouseDownOperation.start(n.type, e, t);
    else if (s)
      e.preventDefault();
    else if (l) {
      const h = n.detail;
      d && this.viewHelper.shouldSuppressMouseDownOnViewZone(h.viewZoneId) && (u(), this._mouseDownOperation.start(n.type, e, t), e.preventDefault());
    } else c && this.viewHelper.shouldSuppressMouseDownOnWidget(n.detail) && (u(), e.preventDefault());
    this.viewController.emitMouseDown({
      event: e,
      target: n
    });
  }
}
class dRe extends we {
  constructor(e, t, n, r, s, o) {
    super(), this._context = e, this._viewController = t, this._viewHelper = n, this._mouseTargetFactory = r, this._createMouseTarget = s, this._getMouseColumn = o, this._mouseMoveMonitor = this._register(new B8e(this._viewHelper.viewDomNode)), this._topBottomDragScrolling = this._register(new uRe(this._context, this._viewHelper, this._mouseTargetFactory, (a, l, c) => this._dispatchMouse(a, l, c))), this._mouseState = new b4(), this._currentSelection = new ot(1, 1, 1, 1), this._isActive = !1, this._lastMouseEvent = null;
  }
  dispose() {
    super.dispose();
  }
  isActive() {
    return this._isActive;
  }
  _onMouseDownThenMove(e) {
    this._lastMouseEvent = e, this._mouseState.setModifiers(e);
    const t = this._findMousePosition(e, !1);
    t && (this._mouseState.isDragAndDrop ? this._viewController.emitMouseDrag({
      event: e,
      target: t
    }) : t.type === 13 && (t.outsidePosition === "above" || t.outsidePosition === "below") ? this._topBottomDragScrolling.start(t, e) : (this._topBottomDragScrolling.stop(), this._dispatchMouse(
      t,
      !0,
      1
      /* NavigationCommandRevealType.Minimal */
    )));
  }
  start(e, t, n) {
    this._lastMouseEvent = t, this._mouseState.setStartedOnLineNumbers(
      e === 3
      /* MouseTargetType.GUTTER_LINE_NUMBERS */
    ), this._mouseState.setStartButtons(t), this._mouseState.setModifiers(t);
    const r = this._findMousePosition(t, !0);
    if (!r || !r.position)
      return;
    this._mouseState.trySetCount(t.detail, r.position), t.detail = this._mouseState.count;
    const s = this._context.configuration.options;
    if (!s.get(
      90
      /* EditorOption.readOnly */
    ) && s.get(
      35
      /* EditorOption.dragAndDrop */
    ) && !s.get(
      22
      /* EditorOption.columnSelection */
    ) && !this._mouseState.altKey && t.detail < 2 && !this._isActive && !this._currentSelection.isEmpty() && r.type === 6 && r.position && this._currentSelection.containsPosition(r.position)) {
      this._mouseState.isDragAndDrop = !0, this._isActive = !0, this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, n, t.buttons, (o) => this._onMouseDownThenMove(o), (o) => {
        const a = this._findMousePosition(this._lastMouseEvent, !1);
        o && o instanceof KeyboardEvent ? this._viewController.emitMouseDropCanceled() : this._viewController.emitMouseDrop({
          event: this._lastMouseEvent,
          target: a ? this._createMouseTarget(this._lastMouseEvent, !0) : null
          // Ignoring because position is unknown, e.g., Content View Zone
        }), this._stop();
      });
      return;
    }
    this._mouseState.isDragAndDrop = !1, this._dispatchMouse(
      r,
      t.shiftKey,
      1
      /* NavigationCommandRevealType.Minimal */
    ), this._isActive || (this._isActive = !0, this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, n, t.buttons, (o) => this._onMouseDownThenMove(o), () => this._stop()));
  }
  _stop() {
    this._isActive = !1, this._topBottomDragScrolling.stop();
  }
  onHeightChanged() {
    this._mouseMoveMonitor.stopMonitoring();
  }
  onPointerUp() {
    this._mouseMoveMonitor.stopMonitoring();
  }
  onCursorStateChanged(e) {
    this._currentSelection = e.selections[0];
  }
  _getPositionOutsideEditor(e) {
    const t = e.editorPos, n = this._context.viewModel, r = this._context.viewLayout, s = this._getMouseColumn(e);
    if (e.posy < t.y) {
      const a = t.y - e.posy, l = Math.max(r.getCurrentScrollTop() - a, 0), c = S_.getZoneAtCoord(this._context, l);
      if (c) {
        const u = this._helpPositionJumpOverViewZone(c);
        if (u)
          return Ys.createOutsideEditor(s, u, "above", a);
      }
      const d = r.getLineNumberAtVerticalOffset(l);
      return Ys.createOutsideEditor(s, new ve(d, 1), "above", a);
    }
    if (e.posy > t.y + t.height) {
      const a = e.posy - t.y - t.height, l = r.getCurrentScrollTop() + e.relativePos.y, c = S_.getZoneAtCoord(this._context, l);
      if (c) {
        const u = this._helpPositionJumpOverViewZone(c);
        if (u)
          return Ys.createOutsideEditor(s, u, "below", a);
      }
      const d = r.getLineNumberAtVerticalOffset(l);
      return Ys.createOutsideEditor(s, new ve(d, n.getLineMaxColumn(d)), "below", a);
    }
    const o = r.getLineNumberAtVerticalOffset(r.getCurrentScrollTop() + e.relativePos.y);
    if (e.posx < t.x) {
      const a = t.x - e.posx;
      return Ys.createOutsideEditor(s, new ve(o, 1), "left", a);
    }
    if (e.posx > t.x + t.width) {
      const a = e.posx - t.x - t.width;
      return Ys.createOutsideEditor(s, new ve(o, n.getLineMaxColumn(o)), "right", a);
    }
    return null;
  }
  _findMousePosition(e, t) {
    const n = this._getPositionOutsideEditor(e);
    if (n)
      return n;
    const r = this._createMouseTarget(e, t);
    if (!r.position)
      return null;
    if (r.type === 8 || r.type === 5) {
      const o = this._helpPositionJumpOverViewZone(r.detail);
      if (o)
        return Ys.createViewZone(r.type, r.element, r.mouseColumn, o, r.detail);
    }
    return r;
  }
  _helpPositionJumpOverViewZone(e) {
    const t = new ve(this._currentSelection.selectionStartLineNumber, this._currentSelection.selectionStartColumn), n = e.positionBefore, r = e.positionAfter;
    return n && r ? n.isBefore(t) ? n : r : null;
  }
  _dispatchMouse(e, t, n) {
    e.position && this._viewController.dispatchMouse({
      position: e.position,
      mouseColumn: e.mouseColumn,
      startedOnLineNumbers: this._mouseState.startedOnLineNumbers,
      revealType: n,
      inSelectionMode: t,
      mouseDownCount: this._mouseState.count,
      altKey: this._mouseState.altKey,
      ctrlKey: this._mouseState.ctrlKey,
      metaKey: this._mouseState.metaKey,
      shiftKey: this._mouseState.shiftKey,
      leftButton: this._mouseState.leftButton,
      middleButton: this._mouseState.middleButton,
      onInjectedText: e.type === 6 && e.detail.injectedText !== null
    });
  }
}
class uRe extends we {
  constructor(e, t, n, r) {
    super(), this._context = e, this._viewHelper = t, this._mouseTargetFactory = n, this._dispatchMouse = r, this._operation = null;
  }
  dispose() {
    super.dispose(), this.stop();
  }
  start(e, t) {
    this._operation ? this._operation.setPosition(e, t) : this._operation = new hRe(this._context, this._viewHelper, this._mouseTargetFactory, this._dispatchMouse, e, t);
  }
  stop() {
    this._operation && (this._operation.dispose(), this._operation = null);
  }
}
class hRe extends we {
  constructor(e, t, n, r, s, o) {
    super(), this._context = e, this._viewHelper = t, this._mouseTargetFactory = n, this._dispatchMouse = r, this._position = s, this._mouseEvent = o, this._lastTime = Date.now(), this._animationFrameDisposable = Cl(() => this._execute());
  }
  dispose() {
    this._animationFrameDisposable.dispose();
  }
  setPosition(e, t) {
    this._position = e, this._mouseEvent = t;
  }
  /**
   * update internal state and return elapsed ms since last time
   */
  _tick() {
    const e = Date.now(), t = e - this._lastTime;
    return this._lastTime = e, t;
  }
  /**
   * get the number of lines per second to auto-scroll
   */
  _getScrollSpeed() {
    const e = this._context.configuration.options.get(
      66
      /* EditorOption.lineHeight */
    ), t = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    ).height / e, n = this._position.outsideDistance / e;
    return n <= 1.5 ? Math.max(30, t * (1 + n)) : n <= 3 ? Math.max(60, t * (2 + n)) : Math.max(200, t * (7 + n));
  }
  _execute() {
    const e = this._context.configuration.options.get(
      66
      /* EditorOption.lineHeight */
    ), t = this._getScrollSpeed(), n = this._tick(), r = t * (n / 1e3) * e, s = this._position.outsidePosition === "above" ? -r : r;
    this._context.viewModel.viewLayout.deltaScrollNow(0, s), this._viewHelper.renderNow();
    const o = this._context.viewLayout.getLinesViewportData(), a = this._position.outsidePosition === "above" ? o.startLineNumber : o.endLineNumber;
    let l;
    {
      const c = vz(this._viewHelper.viewDomNode), d = this._context.configuration.options.get(
        143
        /* EditorOption.layoutInfo */
      ).horizontalScrollbarHeight, u = new v4(this._mouseEvent.pos.x, c.y + c.height - d - 0.1), h = _z(this._viewHelper.viewDomNode, c, u);
      l = this._mouseTargetFactory.createMouseTarget(this._viewHelper.getLastRenderData(), c, u, h, null);
    }
    (!l.position || l.position.lineNumber !== a) && (this._position.outsidePosition === "above" ? l = Ys.createOutsideEditor(this._position.mouseColumn, new ve(a, 1), "above", this._position.outsideDistance) : l = Ys.createOutsideEditor(this._position.mouseColumn, new ve(a, this._context.viewModel.getLineMaxColumn(a)), "below", this._position.outsideDistance)), this._dispatchMouse(
      l,
      !0,
      2
      /* NavigationCommandRevealType.None */
    ), this._animationFrameDisposable = Cl(() => this._execute());
  }
}
class b4 {
  get altKey() {
    return this._altKey;
  }
  get ctrlKey() {
    return this._ctrlKey;
  }
  get metaKey() {
    return this._metaKey;
  }
  get shiftKey() {
    return this._shiftKey;
  }
  get leftButton() {
    return this._leftButton;
  }
  get middleButton() {
    return this._middleButton;
  }
  get startedOnLineNumbers() {
    return this._startedOnLineNumbers;
  }
  constructor() {
    this._altKey = !1, this._ctrlKey = !1, this._metaKey = !1, this._shiftKey = !1, this._leftButton = !1, this._middleButton = !1, this._startedOnLineNumbers = !1, this._lastMouseDownPosition = null, this._lastMouseDownPositionEqualCount = 0, this._lastMouseDownCount = 0, this._lastSetMouseDownCountTime = 0, this.isDragAndDrop = !1;
  }
  get count() {
    return this._lastMouseDownCount;
  }
  setModifiers(e) {
    this._altKey = e.altKey, this._ctrlKey = e.ctrlKey, this._metaKey = e.metaKey, this._shiftKey = e.shiftKey;
  }
  setStartButtons(e) {
    this._leftButton = e.leftButton, this._middleButton = e.middleButton;
  }
  setStartedOnLineNumbers(e) {
    this._startedOnLineNumbers = e;
  }
  trySetCount(e, t) {
    const n = (/* @__PURE__ */ new Date()).getTime();
    n - this._lastSetMouseDownCountTime > b4.CLEAR_MOUSE_DOWN_COUNT_TIME && (e = 1), this._lastSetMouseDownCountTime = n, e > this._lastMouseDownCount + 1 && (e = this._lastMouseDownCount + 1), this._lastMouseDownPosition && this._lastMouseDownPosition.equals(t) ? this._lastMouseDownPositionEqualCount++ : this._lastMouseDownPositionEqualCount = 1, this._lastMouseDownPosition = t, this._lastMouseDownCount = Math.min(e, this._lastMouseDownPositionEqualCount);
  }
}
b4.CLEAR_MOUSE_DOWN_COUNT_TIME = 400;
class Yt {
  get event() {
    return this.emitter.event;
  }
  constructor(e, t, n) {
    const r = (s) => this.emitter.fire(s);
    this.emitter = new pe({
      onWillAddFirstListener: () => e.addEventListener(t, r, n),
      onDidRemoveLastListener: () => e.removeEventListener(t, r, n)
    });
  }
  dispose() {
    this.emitter.dispose();
  }
}
var eg;
(function(i) {
  const e = { total: 0, min: Number.MAX_VALUE, max: 0 }, t = Object.assign({}, e), n = Object.assign({}, e), r = Object.assign({}, e);
  let s = 0;
  const o = {
    keydown: 0,
    input: 0,
    render: 0
  };
  function a() {
    _(), performance.mark("inputlatency/start"), performance.mark("keydown/start"), o.keydown = 1, queueMicrotask(l);
  }
  i.onKeyDown = a;
  function l() {
    o.keydown === 1 && (performance.mark("keydown/end"), o.keydown = 2);
  }
  function c() {
    performance.mark("input/start"), o.input = 1, m();
  }
  i.onBeforeInput = c;
  function d() {
    o.input === 0 && c(), queueMicrotask(u);
  }
  i.onInput = d;
  function u() {
    o.input === 1 && (performance.mark("input/end"), o.input = 2);
  }
  function h() {
    _();
  }
  i.onKeyUp = h;
  function f() {
    _();
  }
  i.onSelectionChange = f;
  function g() {
    o.keydown === 2 && o.input === 2 && o.render === 0 && (performance.mark("render/start"), o.render = 1, queueMicrotask(p), m());
  }
  i.onRenderStart = g;
  function p() {
    o.render === 1 && (performance.mark("render/end"), o.render = 2);
  }
  function m() {
    setTimeout(_);
  }
  function _() {
    o.keydown === 2 && o.input === 2 && o.render === 2 && (performance.mark("inputlatency/end"), performance.measure("keydown", "keydown/start", "keydown/end"), performance.measure("input", "input/start", "input/end"), performance.measure("render", "render/start", "render/end"), performance.measure("inputlatency", "inputlatency/start", "inputlatency/end"), b("keydown", e), b("input", t), b("render", n), b("inputlatency", r), s++, w());
  }
  function b(D, E) {
    const L = performance.getEntriesByName(D)[0].duration;
    E.total += L, E.min = Math.min(E.min, L), E.max = Math.max(E.max, L);
  }
  function w() {
    performance.clearMarks("keydown/start"), performance.clearMarks("keydown/end"), performance.clearMarks("input/start"), performance.clearMarks("input/end"), performance.clearMarks("render/start"), performance.clearMarks("render/end"), performance.clearMarks("inputlatency/start"), performance.clearMarks("inputlatency/end"), performance.clearMeasures("keydown"), performance.clearMeasures("input"), performance.clearMeasures("render"), performance.clearMeasures("inputlatency"), o.keydown = 0, o.input = 0, o.render = 0;
  }
  function y() {
    if (s === 0)
      return;
    const D = {
      keydown: S(e),
      input: S(t),
      render: S(n),
      total: S(r),
      sampleCount: s
    };
    return x(e), x(t), x(n), x(r), s = 0, D;
  }
  i.getAndClearMeasurements = y;
  function S(D) {
    return {
      average: D.total / s,
      max: D.max,
      min: D.min
    };
  }
  function x(D) {
    D.total = 0, D.min = Number.MAX_VALUE, D.max = 0;
  }
})(eg || (eg = {}));
class es {
  constructor(e, t, n, r, s) {
    this.value = e, this.selectionStart = t, this.selectionEnd = n, this.selection = r, this.newlineCountBeforeSelection = s;
  }
  toString() {
    return `[ <${this.value}>, selectionStart: ${this.selectionStart}, selectionEnd: ${this.selectionEnd}]`;
  }
  static readFromTextArea(e, t) {
    const n = e.getValue(), r = e.getSelectionStart(), s = e.getSelectionEnd();
    let o;
    if (t) {
      const a = n.substring(0, r), l = t.value.substring(0, t.selectionStart);
      a === l && (o = t.newlineCountBeforeSelection);
    }
    return new es(n, r, s, null, o);
  }
  collapseSelection() {
    return this.selectionStart === this.value.length ? this : new es(this.value, this.value.length, this.value.length, null, void 0);
  }
  writeToTextArea(e, t, n) {
    t.setValue(e, this.value), n && t.setSelectionRange(e, this.selectionStart, this.selectionEnd);
  }
  deduceEditorPosition(e) {
    var t, n, r, s, o, a, l, c;
    if (e <= this.selectionStart) {
      const h = this.value.substring(e, this.selectionStart);
      return this._finishDeduceEditorPosition((n = (t = this.selection) === null || t === void 0 ? void 0 : t.getStartPosition()) !== null && n !== void 0 ? n : null, h, -1);
    }
    if (e >= this.selectionEnd) {
      const h = this.value.substring(this.selectionEnd, e);
      return this._finishDeduceEditorPosition((s = (r = this.selection) === null || r === void 0 ? void 0 : r.getEndPosition()) !== null && s !== void 0 ? s : null, h, 1);
    }
    const d = this.value.substring(this.selectionStart, e);
    if (d.indexOf("…") === -1)
      return this._finishDeduceEditorPosition((a = (o = this.selection) === null || o === void 0 ? void 0 : o.getStartPosition()) !== null && a !== void 0 ? a : null, d, 1);
    const u = this.value.substring(e, this.selectionEnd);
    return this._finishDeduceEditorPosition((c = (l = this.selection) === null || l === void 0 ? void 0 : l.getEndPosition()) !== null && c !== void 0 ? c : null, u, -1);
  }
  _finishDeduceEditorPosition(e, t, n) {
    let r = 0, s = -1;
    for (; (s = t.indexOf(`
`, s + 1)) !== -1; )
      r++;
    return [e, n * t.length, r];
  }
  static deduceInput(e, t, n) {
    if (!e)
      return {
        text: "",
        replacePrevCharCnt: 0,
        replaceNextCharCnt: 0,
        positionDelta: 0
      };
    const r = Math.min(Um(e.value, t.value), e.selectionStart, t.selectionStart), s = Math.min(YE(e.value, t.value), e.value.length - e.selectionEnd, t.value.length - t.selectionEnd);
    e.value.substring(r, e.value.length - s);
    const o = t.value.substring(r, t.value.length - s), a = e.selectionStart - r, l = e.selectionEnd - r, c = t.selectionStart - r, d = t.selectionEnd - r;
    if (c === d) {
      const h = e.selectionStart - r;
      return {
        text: o,
        replacePrevCharCnt: h,
        replaceNextCharCnt: 0,
        positionDelta: 0
      };
    }
    const u = l - a;
    return {
      text: o,
      replacePrevCharCnt: u,
      replaceNextCharCnt: 0,
      positionDelta: 0
    };
  }
  static deduceAndroidCompositionInput(e, t) {
    if (!e)
      return {
        text: "",
        replacePrevCharCnt: 0,
        replaceNextCharCnt: 0,
        positionDelta: 0
      };
    if (e.value === t.value)
      return {
        text: "",
        replacePrevCharCnt: 0,
        replaceNextCharCnt: 0,
        positionDelta: t.selectionEnd - e.selectionEnd
      };
    const n = Math.min(Um(e.value, t.value), e.selectionEnd), r = Math.min(YE(e.value, t.value), e.value.length - e.selectionEnd), s = e.value.substring(n, e.value.length - r), o = t.value.substring(n, t.value.length - r);
    e.selectionStart - n;
    const a = e.selectionEnd - n;
    t.selectionStart - n;
    const l = t.selectionEnd - n;
    return {
      text: o,
      replacePrevCharCnt: a,
      replaceNextCharCnt: s.length - a,
      positionDelta: l - o.length
    };
  }
}
es.EMPTY = new es("", 0, 0, null, void 0);
class rv {
  static _getPageOfLine(e, t) {
    return Math.floor((e - 1) / t);
  }
  static _getRangeForPage(e, t) {
    const n = e * t, r = n + 1, s = n + t;
    return new V(r, 1, s + 1, 1);
  }
  static fromEditorSelection(e, t, n, r) {
    const o = rv._getPageOfLine(t.startLineNumber, n), a = rv._getRangeForPage(o, n), l = rv._getPageOfLine(t.endLineNumber, n), c = rv._getRangeForPage(l, n);
    let d = a.intersectRanges(new V(1, 1, t.startLineNumber, t.startColumn));
    if (r && e.getValueLengthInRange(
      d,
      1
      /* EndOfLinePreference.LF */
    ) > 500) {
      const _ = e.modifyPosition(d.getEndPosition(), -500);
      d = V.fromPositions(_, d.getEndPosition());
    }
    const u = e.getValueInRange(
      d,
      1
      /* EndOfLinePreference.LF */
    ), h = e.getLineCount(), f = e.getLineMaxColumn(h);
    let g = c.intersectRanges(new V(t.endLineNumber, t.endColumn, h, f));
    if (r && e.getValueLengthInRange(
      g,
      1
      /* EndOfLinePreference.LF */
    ) > 500) {
      const _ = e.modifyPosition(g.getStartPosition(), 500);
      g = V.fromPositions(g.getStartPosition(), _);
    }
    const p = e.getValueInRange(
      g,
      1
      /* EndOfLinePreference.LF */
    );
    let m;
    if (o === l || o + 1 === l)
      m = e.getValueInRange(
        t,
        1
        /* EndOfLinePreference.LF */
      );
    else {
      const _ = a.intersectRanges(t), b = c.intersectRanges(t);
      m = e.getValueInRange(
        _,
        1
        /* EndOfLinePreference.LF */
      ) + "…" + e.getValueInRange(
        b,
        1
        /* EndOfLinePreference.LF */
      );
    }
    return r && m.length > 2 * 500 && (m = m.substring(0, 500) + "…" + m.substring(m.length - 500, m.length)), new es(u + m + p, u.length, u.length + m.length, t, d.endLineNumber - d.startLineNumber);
  }
}
var gL;
(function(i) {
  i.Tap = "-monaco-textarea-synthetic-tap";
})(gL || (gL = {}));
const TF = {
  forceCopyWithSyntaxHighlighting: !1
};
class qy {
  constructor() {
    this._lastState = null;
  }
  set(e, t) {
    this._lastState = { lastCopiedValue: e, data: t };
  }
  get(e) {
    return this._lastState && this._lastState.lastCopiedValue === e ? this._lastState.data : (this._lastState = null, null);
  }
}
qy.INSTANCE = new qy();
class fRe {
  constructor() {
    this._lastTypeTextLength = 0;
  }
  handleCompositionUpdate(e) {
    e = e || "";
    const t = {
      text: e,
      replacePrevCharCnt: this._lastTypeTextLength,
      replaceNextCharCnt: 0,
      positionDelta: 0
    };
    return this._lastTypeTextLength = e.length, t;
  }
}
class gRe extends we {
  get textAreaState() {
    return this._textAreaState;
  }
  constructor(e, t, n, r) {
    super(), this._host = e, this._textArea = t, this._OS = n, this._browser = r, this._onFocus = this._register(new pe()), this.onFocus = this._onFocus.event, this._onBlur = this._register(new pe()), this.onBlur = this._onBlur.event, this._onKeyDown = this._register(new pe()), this.onKeyDown = this._onKeyDown.event, this._onKeyUp = this._register(new pe()), this.onKeyUp = this._onKeyUp.event, this._onCut = this._register(new pe()), this.onCut = this._onCut.event, this._onPaste = this._register(new pe()), this.onPaste = this._onPaste.event, this._onType = this._register(new pe()), this.onType = this._onType.event, this._onCompositionStart = this._register(new pe()), this.onCompositionStart = this._onCompositionStart.event, this._onCompositionUpdate = this._register(new pe()), this.onCompositionUpdate = this._onCompositionUpdate.event, this._onCompositionEnd = this._register(new pe()), this.onCompositionEnd = this._onCompositionEnd.event, this._onSelectionChangeRequest = this._register(new pe()), this.onSelectionChangeRequest = this._onSelectionChangeRequest.event, this._asyncTriggerCut = this._register(new Rn(() => this._onCut.fire(), 0)), this._asyncFocusGainWriteScreenReaderContent = this._register(new Rn(() => this.writeScreenReaderContent("asyncFocusGain"), 0)), this._textAreaState = es.EMPTY, this._selectionChangeListener = null, this.writeScreenReaderContent("ctor"), this._hasFocus = !1, this._currentComposition = null;
    let s = null;
    this._register(this._textArea.onKeyDown((o) => {
      const a = new Xn(o);
      (a.keyCode === 114 || this._currentComposition && a.keyCode === 1) && a.stopPropagation(), a.equals(
        9
        /* KeyCode.Escape */
      ) && a.preventDefault(), s = a, this._onKeyDown.fire(a);
    })), this._register(this._textArea.onKeyUp((o) => {
      const a = new Xn(o);
      this._onKeyUp.fire(a);
    })), this._register(this._textArea.onCompositionStart((o) => {
      const a = new fRe();
      if (this._currentComposition) {
        this._currentComposition = a;
        return;
      }
      if (this._currentComposition = a, this._OS === 2 && s && s.equals(
        114
        /* KeyCode.KEY_IN_COMPOSITION */
      ) && this._textAreaState.selectionStart === this._textAreaState.selectionEnd && this._textAreaState.selectionStart > 0 && this._textAreaState.value.substr(this._textAreaState.selectionStart - 1, 1) === o.data && (s.code === "ArrowRight" || s.code === "ArrowLeft")) {
        a.handleCompositionUpdate("x"), this._onCompositionStart.fire({ data: o.data });
        return;
      }
      if (this._browser.isAndroid) {
        this._onCompositionStart.fire({ data: o.data });
        return;
      }
      this._onCompositionStart.fire({ data: o.data });
    })), this._register(this._textArea.onCompositionUpdate((o) => {
      const a = this._currentComposition;
      if (!a)
        return;
      if (this._browser.isAndroid) {
        const c = es.readFromTextArea(this._textArea, this._textAreaState), d = es.deduceAndroidCompositionInput(this._textAreaState, c);
        this._textAreaState = c, this._onType.fire(d), this._onCompositionUpdate.fire(o);
        return;
      }
      const l = a.handleCompositionUpdate(o.data);
      this._textAreaState = es.readFromTextArea(this._textArea, this._textAreaState), this._onType.fire(l), this._onCompositionUpdate.fire(o);
    })), this._register(this._textArea.onCompositionEnd((o) => {
      const a = this._currentComposition;
      if (!a)
        return;
      if (this._currentComposition = null, this._browser.isAndroid) {
        const c = es.readFromTextArea(this._textArea, this._textAreaState), d = es.deduceAndroidCompositionInput(this._textAreaState, c);
        this._textAreaState = c, this._onType.fire(d), this._onCompositionEnd.fire();
        return;
      }
      const l = a.handleCompositionUpdate(o.data);
      this._textAreaState = es.readFromTextArea(this._textArea, this._textAreaState), this._onType.fire(l), this._onCompositionEnd.fire();
    })), this._register(this._textArea.onInput((o) => {
      if (this._textArea.setIgnoreSelectionChangeTime("received input event"), this._currentComposition)
        return;
      const a = es.readFromTextArea(this._textArea, this._textAreaState), l = es.deduceInput(
        this._textAreaState,
        a,
        /*couldBeEmojiInput*/
        this._OS === 2
        /* OperatingSystem.Macintosh */
      );
      l.replacePrevCharCnt === 0 && l.text.length === 1 && (kr(l.text.charCodeAt(0)) || l.text.charCodeAt(0) === 127) || (this._textAreaState = a, (l.text !== "" || l.replacePrevCharCnt !== 0 || l.replaceNextCharCnt !== 0 || l.positionDelta !== 0) && this._onType.fire(l));
    })), this._register(this._textArea.onCut((o) => {
      this._textArea.setIgnoreSelectionChangeTime("received cut event"), this._ensureClipboardGetsEditorSelection(o), this._asyncTriggerCut.schedule();
    })), this._register(this._textArea.onCopy((o) => {
      this._ensureClipboardGetsEditorSelection(o);
    })), this._register(this._textArea.onPaste((o) => {
      if (this._textArea.setIgnoreSelectionChangeTime("received paste event"), o.preventDefault(), !o.clipboardData)
        return;
      let [a, l] = NF.getTextData(o.clipboardData);
      a && (l = l || qy.INSTANCE.get(a), this._onPaste.fire({
        text: a,
        metadata: l
      }));
    })), this._register(this._textArea.onFocus(() => {
      const o = this._hasFocus;
      this._setHasFocus(!0), this._browser.isSafari && !o && this._hasFocus && this._asyncFocusGainWriteScreenReaderContent.schedule();
    })), this._register(this._textArea.onBlur(() => {
      this._currentComposition && (this._currentComposition = null, this.writeScreenReaderContent("blurWithoutCompositionEnd"), this._onCompositionEnd.fire()), this._setHasFocus(!1);
    })), this._register(this._textArea.onSyntheticTap(() => {
      this._browser.isAndroid && this._currentComposition && (this._currentComposition = null, this.writeScreenReaderContent("tapWithoutCompositionEnd"), this._onCompositionEnd.fire());
    }));
  }
  _installSelectionChangeListener() {
    let e = 0;
    return Ie(this._textArea.ownerDocument, "selectionchange", (t) => {
      if (eg.onSelectionChange(), !this._hasFocus || this._currentComposition || !this._browser.isChrome)
        return;
      const n = Date.now(), r = n - e;
      if (e = n, r < 5)
        return;
      const s = n - this._textArea.getIgnoreSelectionChangeTime();
      if (this._textArea.resetSelectionChangeTime(), s < 100 || !this._textAreaState.selection)
        return;
      const o = this._textArea.getValue();
      if (this._textAreaState.value !== o)
        return;
      const a = this._textArea.getSelectionStart(), l = this._textArea.getSelectionEnd();
      if (this._textAreaState.selectionStart === a && this._textAreaState.selectionEnd === l)
        return;
      const c = this._textAreaState.deduceEditorPosition(a), d = this._host.deduceModelPosition(c[0], c[1], c[2]), u = this._textAreaState.deduceEditorPosition(l), h = this._host.deduceModelPosition(u[0], u[1], u[2]), f = new ot(d.lineNumber, d.column, h.lineNumber, h.column);
      this._onSelectionChangeRequest.fire(f);
    });
  }
  dispose() {
    super.dispose(), this._selectionChangeListener && (this._selectionChangeListener.dispose(), this._selectionChangeListener = null);
  }
  focusTextArea() {
    this._setHasFocus(!0), this.refreshFocusState();
  }
  isFocused() {
    return this._hasFocus;
  }
  refreshFocusState() {
    this._setHasFocus(this._textArea.hasFocus());
  }
  _setHasFocus(e) {
    this._hasFocus !== e && (this._hasFocus = e, this._selectionChangeListener && (this._selectionChangeListener.dispose(), this._selectionChangeListener = null), this._hasFocus && (this._selectionChangeListener = this._installSelectionChangeListener()), this._hasFocus && this.writeScreenReaderContent("focusgain"), this._hasFocus ? this._onFocus.fire() : this._onBlur.fire());
  }
  _setAndWriteTextAreaState(e, t) {
    this._hasFocus || (t = t.collapseSelection()), t.writeToTextArea(e, this._textArea, this._hasFocus), this._textAreaState = t;
  }
  writeScreenReaderContent(e) {
    this._currentComposition || this._setAndWriteTextAreaState(e, this._host.getScreenReaderContent());
  }
  _ensureClipboardGetsEditorSelection(e) {
    const t = this._host.getDataToCopy(), n = {
      version: 1,
      isFromEmptySelection: t.isFromEmptySelection,
      multicursorText: t.multicursorText,
      mode: t.mode
    };
    qy.INSTANCE.set(
      // When writing "LINE\r\n" to the clipboard and then pasting,
      // Firefox pastes "LINE\n", so let's work around this quirk
      this._browser.isFirefox ? t.text.replace(/\r\n/g, `
`) : t.text,
      n
    ), e.preventDefault(), e.clipboardData && NF.setTextData(e.clipboardData, t.text, t.html, n);
  }
}
const NF = {
  getTextData(i) {
    const e = i.getData(Zi.text);
    let t = null;
    const n = i.getData("vscode-editor-data");
    if (typeof n == "string")
      try {
        t = JSON.parse(n), t.version !== 1 && (t = null);
      } catch {
      }
    return e.length === 0 && t === null && i.files.length > 0 ? [Array.prototype.slice.call(i.files, 0).map((s) => s.name).join(`
`), null] : [e, t];
  },
  setTextData(i, e, t, n) {
    i.setData(Zi.text, e), typeof t == "string" && i.setData("text/html", t), i.setData("vscode-editor-data", JSON.stringify(n));
  }
};
class pRe extends we {
  get ownerDocument() {
    return this._actual.ownerDocument;
  }
  constructor(e) {
    super(), this._actual = e, this.onKeyDown = this._register(new Yt(this._actual, "keydown")).event, this.onKeyUp = this._register(new Yt(this._actual, "keyup")).event, this.onCompositionStart = this._register(new Yt(this._actual, "compositionstart")).event, this.onCompositionUpdate = this._register(new Yt(this._actual, "compositionupdate")).event, this.onCompositionEnd = this._register(new Yt(this._actual, "compositionend")).event, this.onBeforeInput = this._register(new Yt(this._actual, "beforeinput")).event, this.onInput = this._register(new Yt(this._actual, "input")).event, this.onCut = this._register(new Yt(this._actual, "cut")).event, this.onCopy = this._register(new Yt(this._actual, "copy")).event, this.onPaste = this._register(new Yt(this._actual, "paste")).event, this.onFocus = this._register(new Yt(this._actual, "focus")).event, this.onBlur = this._register(new Yt(this._actual, "blur")).event, this._onSyntheticTap = this._register(new pe()), this.onSyntheticTap = this._onSyntheticTap.event, this._ignoreSelectionChangeTime = 0, this._register(this.onKeyDown(() => eg.onKeyDown())), this._register(this.onBeforeInput(() => eg.onBeforeInput())), this._register(this.onInput(() => eg.onInput())), this._register(this.onKeyUp(() => eg.onKeyUp())), this._register(Ie(this._actual, gL.Tap, () => this._onSyntheticTap.fire()));
  }
  hasFocus() {
    const e = Ym(this._actual);
    return e ? e.activeElement === this._actual : Xj(this._actual) ? this._actual.ownerDocument.activeElement === this._actual : !1;
  }
  setIgnoreSelectionChangeTime(e) {
    this._ignoreSelectionChangeTime = Date.now();
  }
  getIgnoreSelectionChangeTime() {
    return this._ignoreSelectionChangeTime;
  }
  resetSelectionChangeTime() {
    this._ignoreSelectionChangeTime = 0;
  }
  getValue() {
    return this._actual.value;
  }
  setValue(e, t) {
    const n = this._actual;
    n.value !== t && (this.setIgnoreSelectionChangeTime("setValue"), n.value = t);
  }
  getSelectionStart() {
    return this._actual.selectionDirection === "backward" ? this._actual.selectionEnd : this._actual.selectionStart;
  }
  getSelectionEnd() {
    return this._actual.selectionDirection === "backward" ? this._actual.selectionStart : this._actual.selectionEnd;
  }
  setSelectionRange(e, t, n) {
    const r = this._actual;
    let s = null;
    const o = Ym(r);
    o ? s = o.activeElement : s = r.ownerDocument.activeElement;
    const a = s === r, l = r.selectionStart, c = r.selectionEnd;
    if (a && l === t && c === n) {
      bl && window.parent !== window && r.focus();
      return;
    }
    if (a) {
      this.setIgnoreSelectionChangeTime("setSelectionRange"), r.setSelectionRange(t, n), bl && window.parent !== window && r.focus();
      return;
    }
    try {
      const d = Y9e(r);
      this.setIgnoreSelectionChangeTime("setSelectionRange"), r.focus(), r.setSelectionRange(t, n), X9e(r, d);
    } catch {
    }
  }
}
class mRe extends Sz {
  constructor(e, t, n) {
    super(e, t, n), this._register(Vn.addTarget(this.viewHelper.linesContentDomNode)), this._register(Ie(this.viewHelper.linesContentDomNode, Wn.Tap, (s) => this.onTap(s))), this._register(Ie(this.viewHelper.linesContentDomNode, Wn.Change, (s) => this.onChange(s))), this._register(Ie(this.viewHelper.linesContentDomNode, Wn.Contextmenu, (s) => this._onContextMenu(new Hg(s, !1, this.viewHelper.viewDomNode), !1))), this._lastPointerType = "mouse", this._register(Ie(this.viewHelper.linesContentDomNode, "pointerdown", (s) => {
      const o = s.pointerType;
      if (o === "mouse") {
        this._lastPointerType = "mouse";
        return;
      } else o === "touch" ? this._lastPointerType = "touch" : this._lastPointerType = "pen";
    }));
    const r = new F8e(this.viewHelper.viewDomNode);
    this._register(r.onPointerMove(this.viewHelper.viewDomNode, (s) => this._onMouseMove(s))), this._register(r.onPointerUp(this.viewHelper.viewDomNode, (s) => this._onMouseUp(s))), this._register(r.onPointerLeave(this.viewHelper.viewDomNode, (s) => this._onMouseLeave(s))), this._register(r.onPointerDown(this.viewHelper.viewDomNode, (s, o) => this._onMouseDown(s, o)));
  }
  onTap(e) {
    if (!e.initialTarget || !this.viewHelper.linesContentDomNode.contains(e.initialTarget))
      return;
    e.preventDefault(), this.viewHelper.focusTextArea();
    const t = this._createMouseTarget(new Hg(e, !1, this.viewHelper.viewDomNode), !1);
    t.position && this.viewController.dispatchMouse({
      position: t.position,
      mouseColumn: t.position.column,
      startedOnLineNumbers: !1,
      revealType: 1,
      mouseDownCount: e.tapCount,
      inSelectionMode: !1,
      altKey: !1,
      ctrlKey: !1,
      metaKey: !1,
      shiftKey: !1,
      leftButton: !1,
      middleButton: !1,
      onInjectedText: t.type === 6 && t.detail.injectedText !== null
    });
  }
  onChange(e) {
    this._lastPointerType === "touch" && this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
  }
  _onMouseDown(e, t) {
    e.browserEvent.pointerType !== "touch" && super._onMouseDown(e, t);
  }
}
class vRe extends Sz {
  constructor(e, t, n) {
    super(e, t, n), this._register(Vn.addTarget(this.viewHelper.linesContentDomNode)), this._register(Ie(this.viewHelper.linesContentDomNode, Wn.Tap, (r) => this.onTap(r))), this._register(Ie(this.viewHelper.linesContentDomNode, Wn.Change, (r) => this.onChange(r))), this._register(Ie(this.viewHelper.linesContentDomNode, Wn.Contextmenu, (r) => this._onContextMenu(new Hg(r, !1, this.viewHelper.viewDomNode), !1)));
  }
  onTap(e) {
    e.preventDefault(), this.viewHelper.focusTextArea();
    const t = this._createMouseTarget(new Hg(e, !1, this.viewHelper.viewDomNode), !1);
    if (t.position) {
      const n = document.createEvent("CustomEvent");
      n.initEvent(gL.Tap, !1, !0), this.viewHelper.dispatchTextAreaEvent(n), this.viewController.moveTo(
        t.position,
        1
        /* NavigationCommandRevealType.Minimal */
      );
    }
  }
  onChange(e) {
    this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
  }
}
class _Re extends we {
  constructor(e, t, n) {
    super(), od && Yj.pointerEvents ? this.handler = this._register(new mRe(e, t, n)) : window.TouchEvent ? this.handler = this._register(new vRe(e, t, n)) : this.handler = this._register(new Sz(e, t, n));
  }
  getTargetAtClientPoint(e, t) {
    return this.handler.getTargetAtClientPoint(e, t);
  }
}
class O0 extends AS {
}
const Pr = Gt("themeService");
function Oi(i) {
  return { id: i };
}
function PF(i) {
  switch (i) {
    case dl.DARK:
      return "vs-dark";
    case dl.HIGH_CONTRAST_DARK:
      return "hc-black";
    case dl.HIGH_CONTRAST_LIGHT:
      return "hc-light";
    default:
      return "vs";
  }
}
const zfe = {
  ThemingContribution: "base.contributions.theming"
};
class bRe {
  constructor() {
    this.themingParticipants = [], this.themingParticipants = [], this.onThemingParticipantAddedEmitter = new pe();
  }
  onColorThemeChange(e) {
    return this.themingParticipants.push(e), this.onThemingParticipantAddedEmitter.fire(e), Ct(() => {
      const t = this.themingParticipants.indexOf(e);
      this.themingParticipants.splice(t, 1);
    });
  }
  getThemingParticipants() {
    return this.themingParticipants;
  }
}
const Ufe = new bRe();
Di.add(zfe.ThemingContribution, Ufe);
function fc(i) {
  return Ufe.onColorThemeChange(i);
}
class CRe extends we {
  constructor(e) {
    super(), this.themeService = e, this.theme = e.getColorTheme(), this._register(this.themeService.onDidColorThemeChange((t) => this.onThemeChange(t)));
  }
  onThemeChange(e) {
    this.theme = e, this.updateStyles();
  }
  updateStyles() {
  }
}
const Gfe = ne("editor.lineHighlightBackground", { dark: null, light: null, hcDark: null, hcLight: null }, C("lineHighlight", "Background color for the highlight of line at the cursor position.")), EZ = ne("editor.lineHighlightBorder", { dark: "#282828", light: "#eeeeee", hcDark: "#f38518", hcLight: $t }, C("lineHighlightBorderBox", "Background color for the border around the line at the cursor position."));
ne("editor.rangeHighlightBackground", { dark: "#ffffff0b", light: "#fdff0033", hcDark: null, hcLight: null }, C("rangeHighlight", "Background color of highlighted ranges, like by quick open and find features. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("editor.rangeHighlightBorder", { dark: null, light: null, hcDark: ii, hcLight: ii }, C("rangeHighlightBorder", "Background color of the border around highlighted ranges."), !0);
ne("editor.symbolHighlightBackground", { dark: nu, light: nu, hcDark: null, hcLight: null }, C("symbolHighlight", "Background color of highlighted symbol, like for go to definition or go next/previous symbol. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("editor.symbolHighlightBorder", { dark: null, light: null, hcDark: ii, hcLight: ii }, C("symbolHighlightBorder", "Background color of the border around highlighted symbols."), !0);
const qfe = ne("editorCursor.foreground", { dark: "#AEAFAD", light: ye.black, hcDark: ye.white, hcLight: "#0F4A85" }, C("caret", "Color of the editor cursor.")), yRe = ne("editorCursor.background", null, C("editorCursorBackground", "The background color of the editor cursor. Allows customizing the color of a character overlapped by a block cursor.")), kh = ne("editorWhitespace.foreground", { dark: "#e3e4e229", light: "#33333333", hcDark: "#e3e4e229", hcLight: "#CCCCCC" }, C("editorWhitespaces", "Color of whitespace characters in the editor.")), wRe = ne("editorLineNumber.foreground", { dark: "#858585", light: "#237893", hcDark: ye.white, hcLight: "#292929" }, C("editorLineNumbers", "Color of editor line numbers.")), qx = ne("editorIndentGuide.background", { dark: kh, light: kh, hcDark: kh, hcLight: kh }, C("editorIndentGuides", "Color of the editor indentation guides."), !1, C("deprecatedEditorIndentGuides", "'editorIndentGuide.background' is deprecated. Use 'editorIndentGuide.background1' instead.")), Kx = ne("editorIndentGuide.activeBackground", { dark: kh, light: kh, hcDark: kh, hcLight: kh }, C("editorActiveIndentGuide", "Color of the active editor indentation guides."), !1, C("deprecatedEditorActiveIndentGuide", "'editorIndentGuide.activeBackground' is deprecated. Use 'editorIndentGuide.activeBackground1' instead.")), NS = ne("editorIndentGuide.background1", { dark: qx, light: qx, hcDark: qx, hcLight: qx }, C("editorIndentGuides1", "Color of the editor indentation guides (1).")), SRe = ne("editorIndentGuide.background2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorIndentGuides2", "Color of the editor indentation guides (2).")), xRe = ne("editorIndentGuide.background3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorIndentGuides3", "Color of the editor indentation guides (3).")), DRe = ne("editorIndentGuide.background4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorIndentGuides4", "Color of the editor indentation guides (4).")), ERe = ne("editorIndentGuide.background5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorIndentGuides5", "Color of the editor indentation guides (5).")), LRe = ne("editorIndentGuide.background6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorIndentGuides6", "Color of the editor indentation guides (6).")), PS = ne("editorIndentGuide.activeBackground1", { dark: Kx, light: Kx, hcDark: Kx, hcLight: Kx }, C("editorActiveIndentGuide1", "Color of the active editor indentation guides (1).")), IRe = ne("editorIndentGuide.activeBackground2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorActiveIndentGuide2", "Color of the active editor indentation guides (2).")), ARe = ne("editorIndentGuide.activeBackground3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorActiveIndentGuide3", "Color of the active editor indentation guides (3).")), kRe = ne("editorIndentGuide.activeBackground4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorActiveIndentGuide4", "Color of the active editor indentation guides (4).")), TRe = ne("editorIndentGuide.activeBackground5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorActiveIndentGuide5", "Color of the active editor indentation guides (5).")), NRe = ne("editorIndentGuide.activeBackground6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorActiveIndentGuide6", "Color of the active editor indentation guides (6).")), Yx = ne("editorActiveLineNumber.foreground", { dark: "#c6c6c6", light: "#0B216F", hcDark: ii, hcLight: ii }, C("editorActiveLineNumber", "Color of editor active line number"), !1, C("deprecatedEditorActiveLineNumber", "Id is deprecated. Use 'editorLineNumber.activeForeground' instead."));
ne("editorLineNumber.activeForeground", { dark: Yx, light: Yx, hcDark: Yx, hcLight: Yx }, C("editorActiveLineNumber", "Color of editor active line number"));
const PRe = ne("editorLineNumber.dimmedForeground", { dark: null, light: null, hcDark: null, hcLight: null }, C("editorDimmedLineNumber", "Color of the final editor line when editor.renderFinalNewline is set to dimmed."));
ne("editorRuler.foreground", { dark: "#5A5A5A", light: ye.lightgrey, hcDark: ye.white, hcLight: "#292929" }, C("editorRuler", "Color of the editor rulers."));
ne("editorCodeLens.foreground", { dark: "#999999", light: "#919191", hcDark: "#999999", hcLight: "#292929" }, C("editorCodeLensForeground", "Foreground color of editor CodeLens"));
ne("editorBracketMatch.background", { dark: "#0064001a", light: "#0064001a", hcDark: "#0064001a", hcLight: "#0000" }, C("editorBracketMatchBackground", "Background color behind matching brackets"));
ne("editorBracketMatch.border", { dark: "#888", light: "#B9B9B9", hcDark: $t, hcLight: $t }, C("editorBracketMatchBorder", "Color for matching brackets boxes"));
const ORe = ne("editorOverviewRuler.border", { dark: "#7f7f7f4d", light: "#7f7f7f4d", hcDark: "#7f7f7f4d", hcLight: "#666666" }, C("editorOverviewRulerBorder", "Color of the overview ruler border.")), MRe = ne("editorOverviewRuler.background", null, C("editorOverviewRulerBackground", "Background color of the editor overview ruler."));
ne("editorGutter.background", { dark: Nr, light: Nr, hcDark: Nr, hcLight: Nr }, C("editorGutter", "Background color of the editor gutter. The gutter contains the glyph margins and the line numbers."));
ne("editorUnnecessaryCode.border", { dark: null, light: null, hcDark: ye.fromHex("#fff").transparent(0.8), hcLight: $t }, C("unnecessaryCodeBorder", "Border color of unnecessary (unused) source code in the editor."));
const RRe = ne("editorUnnecessaryCode.opacity", { dark: ye.fromHex("#000a"), light: ye.fromHex("#0007"), hcDark: null, hcLight: null }, C("unnecessaryCodeOpacity", `Opacity of unnecessary (unused) source code in the editor. For example, "#000000c0" will render the code with 75% opacity. For high contrast themes, use the  'editorUnnecessaryCode.border' theme color to underline unnecessary code instead of fading it out.`));
ne("editorGhostText.border", { dark: null, light: null, hcDark: ye.fromHex("#fff").transparent(0.8), hcLight: ye.fromHex("#292929").transparent(0.8) }, C("editorGhostTextBorder", "Border color of ghost text in the editor."));
ne("editorGhostText.foreground", { dark: ye.fromHex("#ffffff56"), light: ye.fromHex("#0007"), hcDark: null, hcLight: null }, C("editorGhostTextForeground", "Foreground color of the ghost text in the editor."));
ne("editorGhostText.background", { dark: null, light: null, hcDark: null, hcLight: null }, C("editorGhostTextBackground", "Background color of the ghost text in the editor."));
const Xx = new ye(new rn(0, 122, 204, 0.6)), Kfe = ne("editorOverviewRuler.rangeHighlightForeground", { dark: Xx, light: Xx, hcDark: Xx, hcLight: Xx }, C("overviewRulerRangeHighlight", "Overview ruler marker color for range highlights. The color must not be opaque so as not to hide underlying decorations."), !0), FRe = ne("editorOverviewRuler.errorForeground", { dark: new ye(new rn(255, 18, 18, 0.7)), light: new ye(new rn(255, 18, 18, 0.7)), hcDark: new ye(new rn(255, 50, 50, 1)), hcLight: "#B5200D" }, C("overviewRuleError", "Overview ruler marker color for errors.")), BRe = ne("editorOverviewRuler.warningForeground", { dark: Na, light: Na, hcDark: Wy, hcLight: Wy }, C("overviewRuleWarning", "Overview ruler marker color for warnings.")), VRe = ne("editorOverviewRuler.infoForeground", { dark: Oo, light: Oo, hcDark: jy, hcLight: jy }, C("overviewRuleInfo", "Overview ruler marker color for infos.")), Yfe = ne("editorBracketHighlight.foreground1", { dark: "#FFD700", light: "#0431FAFF", hcDark: "#FFD700", hcLight: "#0431FAFF" }, C("editorBracketHighlightForeground1", "Foreground color of brackets (1). Requires enabling bracket pair colorization.")), Xfe = ne("editorBracketHighlight.foreground2", { dark: "#DA70D6", light: "#319331FF", hcDark: "#DA70D6", hcLight: "#319331FF" }, C("editorBracketHighlightForeground2", "Foreground color of brackets (2). Requires enabling bracket pair colorization.")), Zfe = ne("editorBracketHighlight.foreground3", { dark: "#179FFF", light: "#7B3814FF", hcDark: "#87CEFA", hcLight: "#7B3814FF" }, C("editorBracketHighlightForeground3", "Foreground color of brackets (3). Requires enabling bracket pair colorization.")), Qfe = ne("editorBracketHighlight.foreground4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketHighlightForeground4", "Foreground color of brackets (4). Requires enabling bracket pair colorization.")), Jfe = ne("editorBracketHighlight.foreground5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketHighlightForeground5", "Foreground color of brackets (5). Requires enabling bracket pair colorization.")), $fe = ne("editorBracketHighlight.foreground6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketHighlightForeground6", "Foreground color of brackets (6). Requires enabling bracket pair colorization.")), HRe = ne("editorBracketHighlight.unexpectedBracket.foreground", { dark: new ye(new rn(255, 18, 18, 0.8)), light: new ye(new rn(255, 18, 18, 0.8)), hcDark: new ye(new rn(255, 50, 50, 1)), hcLight: "" }, C("editorBracketHighlightUnexpectedBracketForeground", "Foreground color of unexpected brackets.")), WRe = ne("editorBracketPairGuide.background1", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.background1", "Background color of inactive bracket pair guides (1). Requires enabling bracket pair guides.")), jRe = ne("editorBracketPairGuide.background2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.background2", "Background color of inactive bracket pair guides (2). Requires enabling bracket pair guides.")), zRe = ne("editorBracketPairGuide.background3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.background3", "Background color of inactive bracket pair guides (3). Requires enabling bracket pair guides.")), URe = ne("editorBracketPairGuide.background4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.background4", "Background color of inactive bracket pair guides (4). Requires enabling bracket pair guides.")), GRe = ne("editorBracketPairGuide.background5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.background5", "Background color of inactive bracket pair guides (5). Requires enabling bracket pair guides.")), qRe = ne("editorBracketPairGuide.background6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.background6", "Background color of inactive bracket pair guides (6). Requires enabling bracket pair guides.")), KRe = ne("editorBracketPairGuide.activeBackground1", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.activeBackground1", "Background color of active bracket pair guides (1). Requires enabling bracket pair guides.")), YRe = ne("editorBracketPairGuide.activeBackground2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.activeBackground2", "Background color of active bracket pair guides (2). Requires enabling bracket pair guides.")), XRe = ne("editorBracketPairGuide.activeBackground3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.activeBackground3", "Background color of active bracket pair guides (3). Requires enabling bracket pair guides.")), ZRe = ne("editorBracketPairGuide.activeBackground4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.activeBackground4", "Background color of active bracket pair guides (4). Requires enabling bracket pair guides.")), QRe = ne("editorBracketPairGuide.activeBackground5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.activeBackground5", "Background color of active bracket pair guides (5). Requires enabling bracket pair guides.")), JRe = ne("editorBracketPairGuide.activeBackground6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, C("editorBracketPairGuide.activeBackground6", "Background color of active bracket pair guides (6). Requires enabling bracket pair guides."));
ne("editorUnicodeHighlight.border", { dark: "#BD9B03", light: "#CEA33D", hcDark: "#ff0000", hcLight: "#CEA33D" }, C("editorUnicodeHighlight.border", "Border color used to highlight unicode characters."));
ne("editorUnicodeHighlight.background", { dark: "#bd9b0326", light: "#cea33d14", hcDark: "#00000000", hcLight: "#cea33d14" }, C("editorUnicodeHighlight.background", "Background color used to highlight unicode characters."));
fc((i, e) => {
  const t = i.getColor(Nr), n = i.getColor(Gfe), r = n && !n.isTransparent() ? n : t;
  r && e.addRule(`.monaco-editor .inputarea.ime-input { background-color: ${r}; }`);
});
class OS extends O0 {
  constructor(e) {
    super(), this._context = e, this._readConfig(), this._lastCursorModelPosition = new ve(1, 1), this._renderResult = null, this._activeLineNumber = 1, this._context.addEventHandler(this);
  }
  _readConfig() {
    const e = this._context.configuration.options;
    this._lineHeight = e.get(
      66
      /* EditorOption.lineHeight */
    );
    const t = e.get(
      67
      /* EditorOption.lineNumbers */
    );
    this._renderLineNumbers = t.renderType, this._renderCustomLineNumbers = t.renderFn, this._renderFinalNewline = e.get(
      94
      /* EditorOption.renderFinalNewline */
    );
    const n = e.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._lineNumbersLeft = n.lineNumbersLeft, this._lineNumbersWidth = n.lineNumbersWidth;
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    return this._readConfig(), !0;
  }
  onCursorStateChanged(e) {
    const t = e.selections[0].getPosition();
    this._lastCursorModelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(t);
    let n = !1;
    return this._activeLineNumber !== t.lineNumber && (this._activeLineNumber = t.lineNumber, n = !0), (this._renderLineNumbers === 2 || this._renderLineNumbers === 3) && (n = !0), n;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  _getLineRenderLineNumber(e) {
    const t = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new ve(e, 1));
    if (t.column !== 1)
      return "";
    const n = t.lineNumber;
    if (this._renderCustomLineNumbers)
      return this._renderCustomLineNumbers(n);
    if (this._renderLineNumbers === 2) {
      const r = Math.abs(this._lastCursorModelPosition.lineNumber - n);
      return r === 0 ? '<span class="relative-current-line-number">' + n + "</span>" : String(r);
    }
    return this._renderLineNumbers === 3 ? this._lastCursorModelPosition.lineNumber === n || n % 10 === 0 ? String(n) : "" : String(n);
  }
  prepareRender(e) {
    if (this._renderLineNumbers === 0) {
      this._renderResult = null;
      return;
    }
    const t = $s ? this._lineHeight % 2 === 0 ? " lh-even" : " lh-odd" : "", n = e.visibleRange.startLineNumber, r = e.visibleRange.endLineNumber, s = this._context.viewModel.getLineCount(), o = [];
    for (let a = n; a <= r; a++) {
      const l = a - n, c = this._getLineRenderLineNumber(a);
      if (!c) {
        o[l] = "";
        continue;
      }
      let d = "";
      if (a === s && this._context.viewModel.getLineLength(a) === 0) {
        if (this._renderFinalNewline === "off") {
          o[l] = "";
          continue;
        }
        this._renderFinalNewline === "dimmed" && (d = " dimmed-line-number");
      }
      a === this._activeLineNumber && (d = " active-line-number"), o[l] = `<div class="${OS.CLASS_NAME}${t}${d}" style="left:${this._lineNumbersLeft}px;width:${this._lineNumbersWidth}px;">${c}</div>`;
    }
    this._renderResult = o;
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
OS.CLASS_NAME = "line-numbers";
fc((i, e) => {
  const t = i.getColor(wRe), n = i.getColor(PRe);
  n ? e.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${n}; }`) : t && e.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${t.transparent(0.4)}; }`);
});
class Xm extends ca {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._canUseLayerHinting = !t.get(
      32
      /* EditorOption.disableLayerHinting */
    ), this._contentLeft = n.contentLeft, this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, this._domNode = Dn(document.createElement("div")), this._domNode.setClassName(Xm.OUTER_CLASS_NAME), this._domNode.setPosition("absolute"), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._glyphMarginBackgroundDomNode = Dn(document.createElement("div")), this._glyphMarginBackgroundDomNode.setClassName(Xm.CLASS_NAME), this._domNode.appendChild(this._glyphMarginBackgroundDomNode);
  }
  dispose() {
    super.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    return this._canUseLayerHinting = !t.get(
      32
      /* EditorOption.disableLayerHinting */
    ), this._contentLeft = n.contentLeft, this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollTopChanged;
  }
  // --- end event handlers
  prepareRender(e) {
  }
  render(e) {
    this._domNode.setLayerHinting(this._canUseLayerHinting), this._domNode.setContain("strict");
    const t = e.scrollTop - e.bigNumbersDelta;
    this._domNode.setTop(-t);
    const n = Math.min(e.scrollHeight, 1e6);
    this._domNode.setHeight(n), this._domNode.setWidth(this._contentLeft), this._glyphMarginBackgroundDomNode.setLeft(this._glyphMarginLeft), this._glyphMarginBackgroundDomNode.setWidth(this._glyphMarginWidth), this._glyphMarginBackgroundDomNode.setHeight(n);
  }
}
Xm.CLASS_NAME = "glyph-margin";
Xm.OUTER_CLASS_NAME = "margin";
const Rv = "monaco-mouse-cursor-text";
class $Re {
  constructor() {
    this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event, this._enabled = !0;
  }
  get enabled() {
    return this._enabled;
  }
  /**
   * Enable IME
   */
  enable() {
    this._enabled = !0, this._onDidChange.fire();
  }
  /**
   * Disable IME
   */
  disable() {
    this._enabled = !1, this._onDidChange.fire();
  }
}
const DC = new $Re(), Bn = Gt("keybindingService");
var eFe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, tFe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class nFe {
  constructor(e, t, n, r, s) {
    this._context = e, this.modelLineNumber = t, this.distanceToModelLineStart = n, this.widthOfHiddenLineTextBefore = r, this.distanceToModelLineEnd = s, this._visibleTextAreaBrand = void 0, this.startPosition = null, this.endPosition = null, this.visibleTextareaStart = null, this.visibleTextareaEnd = null, this._previousPresentation = null;
  }
  prepareRender(e) {
    const t = new ve(this.modelLineNumber, this.distanceToModelLineStart + 1), n = new ve(this.modelLineNumber, this._context.viewModel.model.getLineMaxColumn(this.modelLineNumber) - this.distanceToModelLineEnd);
    this.startPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t), this.endPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(n), this.startPosition.lineNumber === this.endPosition.lineNumber ? (this.visibleTextareaStart = e.visibleRangeForPosition(this.startPosition), this.visibleTextareaEnd = e.visibleRangeForPosition(this.endPosition)) : (this.visibleTextareaStart = null, this.visibleTextareaEnd = null);
  }
  definePresentation(e) {
    return this._previousPresentation || (e ? this._previousPresentation = e : this._previousPresentation = {
      foreground: 1,
      italic: !1,
      bold: !1,
      underline: !1,
      strikethrough: !1
    }), this._previousPresentation;
  }
}
const I6 = bl;
let OF = class extends ca {
  constructor(e, t, n, r) {
    super(e), this._keybindingService = r, this._primaryCursorPosition = new ve(1, 1), this._primaryCursorVisibleRange = null, this._viewController = t, this._visibleRangeProvider = n, this._scrollLeft = 0, this._scrollTop = 0;
    const s = this._context.configuration.options, o = s.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._setAccessibilityOptions(s), this._contentLeft = o.contentLeft, this._contentWidth = o.contentWidth, this._contentHeight = o.height, this._fontInfo = s.get(
      50
      /* EditorOption.fontInfo */
    ), this._lineHeight = s.get(
      66
      /* EditorOption.lineHeight */
    ), this._emptySelectionClipboard = s.get(
      37
      /* EditorOption.emptySelectionClipboard */
    ), this._copyWithSyntaxHighlighting = s.get(
      25
      /* EditorOption.copyWithSyntaxHighlighting */
    ), this._visibleTextArea = null, this._selections = [new ot(1, 1, 1, 1)], this._modelSelections = [new ot(1, 1, 1, 1)], this._lastRenderPosition = null, this.textArea = Dn(document.createElement("textarea")), Su.write(
      this.textArea,
      6
      /* PartFingerprint.TextArea */
    ), this.textArea.setClassName(`inputarea ${Rv}`), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
    const { tabSize: a } = this._context.viewModel.model.getOptions();
    this.textArea.domNode.style.tabSize = `${a * this._fontInfo.spaceWidth}px`, this.textArea.setAttribute("autocorrect", "off"), this.textArea.setAttribute("autocapitalize", "off"), this.textArea.setAttribute("autocomplete", "off"), this.textArea.setAttribute("spellcheck", "false"), this.textArea.setAttribute("aria-label", this._getAriaLabel(s)), this.textArea.setAttribute("aria-required", s.get(
      5
      /* EditorOption.ariaRequired */
    ) ? "true" : "false"), this.textArea.setAttribute("tabindex", String(s.get(
      123
      /* EditorOption.tabIndex */
    ))), this.textArea.setAttribute("role", "textbox"), this.textArea.setAttribute("aria-roledescription", C("editor", "editor")), this.textArea.setAttribute("aria-multiline", "true"), this.textArea.setAttribute("aria-autocomplete", s.get(
      90
      /* EditorOption.readOnly */
    ) ? "none" : "both"), this._ensureReadOnlyAttribute(), this.textAreaCover = Dn(document.createElement("div")), this.textAreaCover.setPosition("absolute");
    const l = {
      getLineCount: () => this._context.viewModel.getLineCount(),
      getLineMaxColumn: (u) => this._context.viewModel.getLineMaxColumn(u),
      getValueInRange: (u, h) => this._context.viewModel.getValueInRange(u, h),
      getValueLengthInRange: (u, h) => this._context.viewModel.getValueLengthInRange(u, h),
      modifyPosition: (u, h) => this._context.viewModel.modifyPosition(u, h)
    }, c = {
      getDataToCopy: () => {
        const u = this._context.viewModel.getPlainTextToCopy(this._modelSelections, this._emptySelectionClipboard, Ls), h = this._context.viewModel.model.getEOL(), f = this._emptySelectionClipboard && this._modelSelections.length === 1 && this._modelSelections[0].isEmpty(), g = Array.isArray(u) ? u : null, p = Array.isArray(u) ? u.join(h) : u;
        let m, _ = null;
        if (TF.forceCopyWithSyntaxHighlighting || this._copyWithSyntaxHighlighting && p.length < 65536) {
          const b = this._context.viewModel.getRichTextToCopy(this._modelSelections, this._emptySelectionClipboard);
          b && (m = b.html, _ = b.mode);
        }
        return {
          isFromEmptySelection: f,
          multicursorText: g,
          text: p,
          html: m,
          mode: _
        };
      },
      getScreenReaderContent: () => {
        if (this._accessibilitySupport === 1) {
          const u = this._selections[0];
          if (sn && u.isEmpty()) {
            const f = u.getStartPosition();
            let g = this._getWordBeforePosition(f);
            if (g.length === 0 && (g = this._getCharacterBeforePosition(f)), g.length > 0)
              return new es(g, g.length, g.length, V.fromPositions(f), 0);
          }
          if (sn && !u.isEmpty() && l.getValueLengthInRange(
            u,
            0
            /* EndOfLinePreference.TextDefined */
          ) < 500) {
            const f = l.getValueInRange(
              u,
              0
              /* EndOfLinePreference.TextDefined */
            );
            return new es(f, 0, f.length, u, 0);
          }
          if (Zh && !u.isEmpty()) {
            const f = "vscode-placeholder";
            return new es(f, 0, f.length, null, void 0);
          }
          return es.EMPTY;
        }
        if (tX) {
          const u = this._selections[0];
          if (u.isEmpty()) {
            const h = u.getStartPosition(), [f, g] = this._getAndroidWordAtPosition(h);
            if (f.length > 0)
              return new es(f, g, g, V.fromPositions(h), 0);
          }
          return es.EMPTY;
        }
        return rv.fromEditorSelection(
          l,
          this._selections[0],
          this._accessibilityPageSize,
          this._accessibilitySupport === 0
          /* AccessibilitySupport.Unknown */
        );
      },
      deduceModelPosition: (u, h, f) => this._context.viewModel.deduceModelPositionRelativeToViewPosition(u, h, f)
    }, d = this._register(new pRe(this.textArea.domNode));
    this._textAreaInput = this._register(new gRe(c, d, ka, {
      isAndroid: tX,
      isChrome: Uj,
      isFirefox: bl,
      isSafari: Zh
    })), this._register(this._textAreaInput.onKeyDown((u) => {
      this._viewController.emitKeyDown(u);
    })), this._register(this._textAreaInput.onKeyUp((u) => {
      this._viewController.emitKeyUp(u);
    })), this._register(this._textAreaInput.onPaste((u) => {
      let h = !1, f = null, g = null;
      u.metadata && (h = this._emptySelectionClipboard && !!u.metadata.isFromEmptySelection, f = typeof u.metadata.multicursorText < "u" ? u.metadata.multicursorText : null, g = u.metadata.mode), this._viewController.paste(u.text, h, f, g);
    })), this._register(this._textAreaInput.onCut(() => {
      this._viewController.cut();
    })), this._register(this._textAreaInput.onType((u) => {
      u.replacePrevCharCnt || u.replaceNextCharCnt || u.positionDelta ? this._viewController.compositionType(u.text, u.replacePrevCharCnt, u.replaceNextCharCnt, u.positionDelta) : this._viewController.type(u.text);
    })), this._register(this._textAreaInput.onSelectionChangeRequest((u) => {
      this._viewController.setSelection(u);
    })), this._register(this._textAreaInput.onCompositionStart((u) => {
      const h = this.textArea.domNode, f = this._modelSelections[0], { distanceToModelLineStart: g, widthOfHiddenTextBefore: p } = (() => {
        const _ = h.value.substring(0, Math.min(h.selectionStart, h.selectionEnd)), b = _.lastIndexOf(`
`), w = _.substring(b + 1), y = w.lastIndexOf("	"), S = w.length - y - 1, x = f.getStartPosition(), D = Math.min(x.column - 1, S), E = x.column - 1 - D, L = w.substring(0, w.length - D), { tabSize: k } = this._context.viewModel.model.getOptions(), N = iFe(this.textArea.domNode.ownerDocument, L, this._fontInfo, k);
        return { distanceToModelLineStart: E, widthOfHiddenTextBefore: N };
      })(), { distanceToModelLineEnd: m } = (() => {
        const _ = h.value.substring(Math.max(h.selectionStart, h.selectionEnd)), b = _.indexOf(`
`), w = b === -1 ? _ : _.substring(0, b), y = w.indexOf("	"), S = y === -1 ? w.length : w.length - y - 1, x = f.getEndPosition(), D = Math.min(this._context.viewModel.model.getLineMaxColumn(x.lineNumber) - x.column, S);
        return { distanceToModelLineEnd: this._context.viewModel.model.getLineMaxColumn(x.lineNumber) - x.column - D };
      })();
      this._context.viewModel.revealRange(
        "keyboard",
        !0,
        V.fromPositions(this._selections[0].getStartPosition()),
        0,
        1
        /* ScrollType.Immediate */
      ), this._visibleTextArea = new nFe(this._context, f.startLineNumber, g, p, m), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off"), this._visibleTextArea.prepareRender(this._visibleRangeProvider), this._render(), this.textArea.setClassName(`inputarea ${Rv} ime-input`), this._viewController.compositionStart(), this._context.viewModel.onCompositionStart();
    })), this._register(this._textAreaInput.onCompositionUpdate((u) => {
      this._visibleTextArea && (this._visibleTextArea.prepareRender(this._visibleRangeProvider), this._render());
    })), this._register(this._textAreaInput.onCompositionEnd(() => {
      this._visibleTextArea = null, this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off"), this._render(), this.textArea.setClassName(`inputarea ${Rv}`), this._viewController.compositionEnd(), this._context.viewModel.onCompositionEnd();
    })), this._register(this._textAreaInput.onFocus(() => {
      this._context.viewModel.setHasFocus(!0);
    })), this._register(this._textAreaInput.onBlur(() => {
      this._context.viewModel.setHasFocus(!1);
    })), this._register(DC.onDidChange(() => {
      this._ensureReadOnlyAttribute();
    }));
  }
  writeScreenReaderContent(e) {
    this._textAreaInput.writeScreenReaderContent(e);
  }
  dispose() {
    super.dispose();
  }
  _getAndroidWordAtPosition(e) {
    const t = '`~!@#$%^&*()-=+[{]}\\|;:",.<>/?', n = this._context.viewModel.getLineContent(e.lineNumber), r = wl(t);
    let s = !0, o = e.column, a = !0, l = e.column, c = 0;
    for (; c < 50 && (s || a); ) {
      if (s && o <= 1 && (s = !1), s) {
        const d = n.charCodeAt(o - 2);
        r.get(d) !== 0 ? s = !1 : o--;
      }
      if (a && l > n.length && (a = !1), a) {
        const d = n.charCodeAt(l - 1);
        r.get(d) !== 0 ? a = !1 : l++;
      }
      c++;
    }
    return [n.substring(o - 1, l - 1), e.column - o];
  }
  _getWordBeforePosition(e) {
    const t = this._context.viewModel.getLineContent(e.lineNumber), n = wl(this._context.configuration.options.get(
      129
      /* EditorOption.wordSeparators */
    ));
    let r = e.column, s = 0;
    for (; r > 1; ) {
      const o = t.charCodeAt(r - 2);
      if (n.get(o) !== 0 || s > 50)
        return t.substring(r - 1, e.column - 1);
      s++, r--;
    }
    return t.substring(0, e.column - 1);
  }
  _getCharacterBeforePosition(e) {
    if (e.column > 1) {
      const n = this._context.viewModel.getLineContent(e.lineNumber).charAt(e.column - 2);
      if (!kr(n.charCodeAt(0)))
        return n;
    }
    return "";
  }
  _getAriaLabel(e) {
    var t, n, r;
    if (e.get(
      2
      /* EditorOption.accessibilitySupport */
    ) === 1) {
      const o = (t = this._keybindingService.lookupKeybinding("editor.action.toggleScreenReaderAccessibilityMode")) === null || t === void 0 ? void 0 : t.getAriaLabel(), a = (n = this._keybindingService.lookupKeybinding("workbench.action.showCommands")) === null || n === void 0 ? void 0 : n.getAriaLabel(), l = (r = this._keybindingService.lookupKeybinding("workbench.action.openGlobalKeybindings")) === null || r === void 0 ? void 0 : r.getAriaLabel(), c = C("accessibilityModeOff", "The editor is not accessible at this time.");
      return o ? C("accessibilityOffAriaLabel", "{0} To enable screen reader optimized mode, use {1}", c, o) : a ? C("accessibilityOffAriaLabelNoKb", "{0} To enable screen reader optimized mode, open the quick pick with {1} and run the command Toggle Screen Reader Accessibility Mode, which is currently not triggerable via keyboard.", c, a) : l ? C("accessibilityOffAriaLabelNoKbs", "{0} Please assign a keybinding for the command Toggle Screen Reader Accessibility Mode by accessing the keybindings editor with {1} and run it.", c, l) : c;
    }
    return e.get(
      4
      /* EditorOption.ariaLabel */
    );
  }
  _setAccessibilityOptions(e) {
    this._accessibilitySupport = e.get(
      2
      /* EditorOption.accessibilitySupport */
    );
    const t = e.get(
      3
      /* EditorOption.accessibilityPageSize */
    );
    this._accessibilitySupport === 2 && t === pd.accessibilityPageSize.defaultValue ? this._accessibilityPageSize = 500 : this._accessibilityPageSize = t;
    const r = e.get(
      143
      /* EditorOption.layoutInfo */
    ).wrappingColumn;
    if (r !== -1 && this._accessibilitySupport !== 1) {
      const s = e.get(
        50
        /* EditorOption.fontInfo */
      );
      this._textAreaWrapping = !0, this._textAreaWidth = Math.round(r * s.typicalHalfwidthCharacterWidth);
    } else
      this._textAreaWrapping = !1, this._textAreaWidth = I6 ? 0 : 1;
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._setAccessibilityOptions(t), this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, this._contentHeight = n.height, this._fontInfo = t.get(
      50
      /* EditorOption.fontInfo */
    ), this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._emptySelectionClipboard = t.get(
      37
      /* EditorOption.emptySelectionClipboard */
    ), this._copyWithSyntaxHighlighting = t.get(
      25
      /* EditorOption.copyWithSyntaxHighlighting */
    ), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
    const { tabSize: r } = this._context.viewModel.model.getOptions();
    return this.textArea.domNode.style.tabSize = `${r * this._fontInfo.spaceWidth}px`, this.textArea.setAttribute("aria-label", this._getAriaLabel(t)), this.textArea.setAttribute("aria-required", t.get(
      5
      /* EditorOption.ariaRequired */
    ) ? "true" : "false"), this.textArea.setAttribute("tabindex", String(t.get(
      123
      /* EditorOption.tabIndex */
    ))), (e.hasChanged(
      34
      /* EditorOption.domReadOnly */
    ) || e.hasChanged(
      90
      /* EditorOption.readOnly */
    )) && this._ensureReadOnlyAttribute(), e.hasChanged(
      2
      /* EditorOption.accessibilitySupport */
    ) && this._textAreaInput.writeScreenReaderContent("strategy changed"), !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections.slice(0), this._modelSelections = e.modelSelections.slice(0), this._textAreaInput.writeScreenReaderContent("selection changed"), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return this._scrollLeft = e.scrollLeft, this._scrollTop = e.scrollTop, !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  // --- begin view API
  isFocused() {
    return this._textAreaInput.isFocused();
  }
  focusTextArea() {
    this._textAreaInput.focusTextArea();
  }
  getLastRenderData() {
    return this._lastRenderPosition;
  }
  setAriaOptions(e) {
    e.activeDescendant ? (this.textArea.setAttribute("aria-haspopup", "true"), this.textArea.setAttribute("aria-autocomplete", "list"), this.textArea.setAttribute("aria-activedescendant", e.activeDescendant)) : (this.textArea.setAttribute("aria-haspopup", "false"), this.textArea.setAttribute("aria-autocomplete", "both"), this.textArea.removeAttribute("aria-activedescendant")), e.role && this.textArea.setAttribute("role", e.role);
  }
  // --- end view API
  _ensureReadOnlyAttribute() {
    const e = this._context.configuration.options;
    !DC.enabled || e.get(
      34
      /* EditorOption.domReadOnly */
    ) && e.get(
      90
      /* EditorOption.readOnly */
    ) ? this.textArea.setAttribute("readonly", "true") : this.textArea.removeAttribute("readonly");
  }
  prepareRender(e) {
    var t;
    this._primaryCursorPosition = new ve(this._selections[0].positionLineNumber, this._selections[0].positionColumn), this._primaryCursorVisibleRange = e.visibleRangeForPosition(this._primaryCursorPosition), (t = this._visibleTextArea) === null || t === void 0 || t.prepareRender(e);
  }
  render(e) {
    this._textAreaInput.writeScreenReaderContent("render"), this._render();
  }
  _render() {
    var e;
    if (this._visibleTextArea) {
      const r = this._visibleTextArea.visibleTextareaStart, s = this._visibleTextArea.visibleTextareaEnd, o = this._visibleTextArea.startPosition, a = this._visibleTextArea.endPosition;
      if (o && a && r && s && s.left >= this._scrollLeft && r.left <= this._scrollLeft + this._contentWidth) {
        const l = this._context.viewLayout.getVerticalOffsetForLineNumber(this._primaryCursorPosition.lineNumber) - this._scrollTop, c = this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
        let d = this._visibleTextArea.widthOfHiddenLineTextBefore, u = this._contentLeft + r.left - this._scrollLeft, h = s.left - r.left + 1;
        if (u < this._contentLeft) {
          const b = this._contentLeft - u;
          u += b, d += b, h -= b;
        }
        h > this._contentWidth && (h = this._contentWidth);
        const f = this._context.viewModel.getViewLineData(o.lineNumber), g = f.tokens.findTokenIndexAtOffset(o.column - 1), p = f.tokens.findTokenIndexAtOffset(a.column - 1), m = g === p, _ = this._visibleTextArea.definePresentation(m ? f.tokens.getPresentation(g) : null);
        this.textArea.domNode.scrollTop = c * this._lineHeight, this.textArea.domNode.scrollLeft = d, this._doRender({
          lastRenderPosition: null,
          top: l,
          left: u,
          width: h,
          height: this._lineHeight,
          useCover: !1,
          color: (Pi.getColorMap() || [])[_.foreground],
          italic: _.italic,
          bold: _.bold,
          underline: _.underline,
          strikethrough: _.strikethrough
        });
      }
      return;
    }
    if (!this._primaryCursorVisibleRange) {
      this._renderAtTopLeft();
      return;
    }
    const t = this._contentLeft + this._primaryCursorVisibleRange.left - this._scrollLeft;
    if (t < this._contentLeft || t > this._contentLeft + this._contentWidth) {
      this._renderAtTopLeft();
      return;
    }
    const n = this._context.viewLayout.getVerticalOffsetForLineNumber(this._selections[0].positionLineNumber) - this._scrollTop;
    if (n < 0 || n > this._contentHeight) {
      this._renderAtTopLeft();
      return;
    }
    if (sn) {
      this._doRender({
        lastRenderPosition: this._primaryCursorPosition,
        top: n,
        left: this._textAreaWrapping ? this._contentLeft : t,
        width: this._textAreaWidth,
        height: this._lineHeight,
        useCover: !1
      }), this.textArea.domNode.scrollLeft = this._primaryCursorVisibleRange.left;
      const r = (e = this._textAreaInput.textAreaState.newlineCountBeforeSelection) !== null && e !== void 0 ? e : this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
      this.textArea.domNode.scrollTop = r * this._lineHeight;
      return;
    }
    this._doRender({
      lastRenderPosition: this._primaryCursorPosition,
      top: n,
      left: this._textAreaWrapping ? this._contentLeft : t,
      width: this._textAreaWidth,
      height: I6 ? 0 : 1,
      useCover: !1
    });
  }
  _newlinecount(e) {
    let t = 0, n = -1;
    do {
      if (n = e.indexOf(`
`, n + 1), n === -1)
        break;
      t++;
    } while (!0);
    return t;
  }
  _renderAtTopLeft() {
    this._doRender({
      lastRenderPosition: null,
      top: 0,
      left: 0,
      width: this._textAreaWidth,
      height: I6 ? 0 : 1,
      useCover: !0
    });
  }
  _doRender(e) {
    this._lastRenderPosition = e.lastRenderPosition;
    const t = this.textArea, n = this.textAreaCover;
    Ds(t, this._fontInfo), t.setTop(e.top), t.setLeft(e.left), t.setWidth(e.width), t.setHeight(e.height), t.setColor(e.color ? ye.Format.CSS.formatHex(e.color) : ""), t.setFontStyle(e.italic ? "italic" : ""), e.bold && t.setFontWeight("bold"), t.setTextDecoration(`${e.underline ? " underline" : ""}${e.strikethrough ? " line-through" : ""}`), n.setTop(e.useCover ? e.top : 0), n.setLeft(e.useCover ? e.left : 0), n.setWidth(e.useCover ? e.width : 0), n.setHeight(e.useCover ? e.height : 0);
    const r = this._context.configuration.options;
    r.get(
      57
      /* EditorOption.glyphMargin */
    ) ? n.setClassName("monaco-editor-background textAreaCover " + Xm.OUTER_CLASS_NAME) : r.get(
      67
      /* EditorOption.lineNumbers */
    ).renderType !== 0 ? n.setClassName("monaco-editor-background textAreaCover " + OS.CLASS_NAME) : n.setClassName("monaco-editor-background textAreaCover");
  }
};
OF = eFe([
  tFe(3, Bn)
], OF);
function iFe(i, e, t, n) {
  if (e.length === 0)
    return 0;
  const r = i.createElement("div");
  r.style.position = "absolute", r.style.top = "-50000px", r.style.width = "50000px";
  const s = i.createElement("span");
  Ds(s, t), s.style.whiteSpace = "pre", s.style.tabSize = `${n * t.spaceWidth}px`, s.append(e), r.appendChild(s), i.body.appendChild(r);
  const o = s.offsetWidth;
  return i.body.removeChild(r), o;
}
function rFe(i, e, t) {
  let n = 0;
  for (let s = 0; s < i.length; s++)
    i.charAt(s) === "	" ? n = Lr.nextIndentTabStop(n, e) : n++;
  let r = "";
  if (!t) {
    const s = Math.floor(n / e);
    n = n % e;
    for (let o = 0; o < s; o++)
      r += "	";
  }
  for (let s = 0; s < n; s++)
    r += " ";
  return r;
}
function xz(i, e, t) {
  let n = Js(i);
  return n === -1 && (n = i.length), rFe(i.substring(0, n), e, t) + i.substring(n);
}
const sFe = () => !0, oFe = () => !1, aFe = (i) => i === " " || i === "	";
class h1 {
  static shouldRecreate(e) {
    return e.hasChanged(
      143
      /* EditorOption.layoutInfo */
    ) || e.hasChanged(
      129
      /* EditorOption.wordSeparators */
    ) || e.hasChanged(
      37
      /* EditorOption.emptySelectionClipboard */
    ) || e.hasChanged(
      76
      /* EditorOption.multiCursorMergeOverlapping */
    ) || e.hasChanged(
      78
      /* EditorOption.multiCursorPaste */
    ) || e.hasChanged(
      79
      /* EditorOption.multiCursorLimit */
    ) || e.hasChanged(
      6
      /* EditorOption.autoClosingBrackets */
    ) || e.hasChanged(
      7
      /* EditorOption.autoClosingComments */
    ) || e.hasChanged(
      11
      /* EditorOption.autoClosingQuotes */
    ) || e.hasChanged(
      9
      /* EditorOption.autoClosingDelete */
    ) || e.hasChanged(
      10
      /* EditorOption.autoClosingOvertype */
    ) || e.hasChanged(
      14
      /* EditorOption.autoSurround */
    ) || e.hasChanged(
      127
      /* EditorOption.useTabStops */
    ) || e.hasChanged(
      50
      /* EditorOption.fontInfo */
    ) || e.hasChanged(
      90
      /* EditorOption.readOnly */
    );
  }
  constructor(e, t, n, r) {
    var s;
    this.languageConfigurationService = r, this._cursorMoveConfigurationBrand = void 0, this._languageId = e;
    const o = n.options, a = o.get(
      143
      /* EditorOption.layoutInfo */
    ), l = o.get(
      50
      /* EditorOption.fontInfo */
    );
    this.readOnly = o.get(
      90
      /* EditorOption.readOnly */
    ), this.tabSize = t.tabSize, this.indentSize = t.indentSize, this.insertSpaces = t.insertSpaces, this.stickyTabStops = o.get(
      115
      /* EditorOption.stickyTabStops */
    ), this.lineHeight = l.lineHeight, this.typicalHalfwidthCharacterWidth = l.typicalHalfwidthCharacterWidth, this.pageSize = Math.max(1, Math.floor(a.height / this.lineHeight) - 2), this.useTabStops = o.get(
      127
      /* EditorOption.useTabStops */
    ), this.wordSeparators = o.get(
      129
      /* EditorOption.wordSeparators */
    ), this.emptySelectionClipboard = o.get(
      37
      /* EditorOption.emptySelectionClipboard */
    ), this.copyWithSyntaxHighlighting = o.get(
      25
      /* EditorOption.copyWithSyntaxHighlighting */
    ), this.multiCursorMergeOverlapping = o.get(
      76
      /* EditorOption.multiCursorMergeOverlapping */
    ), this.multiCursorPaste = o.get(
      78
      /* EditorOption.multiCursorPaste */
    ), this.multiCursorLimit = o.get(
      79
      /* EditorOption.multiCursorLimit */
    ), this.autoClosingBrackets = o.get(
      6
      /* EditorOption.autoClosingBrackets */
    ), this.autoClosingComments = o.get(
      7
      /* EditorOption.autoClosingComments */
    ), this.autoClosingQuotes = o.get(
      11
      /* EditorOption.autoClosingQuotes */
    ), this.autoClosingDelete = o.get(
      9
      /* EditorOption.autoClosingDelete */
    ), this.autoClosingOvertype = o.get(
      10
      /* EditorOption.autoClosingOvertype */
    ), this.autoSurround = o.get(
      14
      /* EditorOption.autoSurround */
    ), this.autoIndent = o.get(
      12
      /* EditorOption.autoIndent */
    ), this.surroundingPairs = {}, this._electricChars = null, this.shouldAutoCloseBefore = {
      quote: this._getShouldAutoClose(e, this.autoClosingQuotes, !0),
      comment: this._getShouldAutoClose(e, this.autoClosingComments, !1),
      bracket: this._getShouldAutoClose(e, this.autoClosingBrackets, !1)
    }, this.autoClosingPairs = this.languageConfigurationService.getLanguageConfiguration(e).getAutoClosingPairs();
    const c = this.languageConfigurationService.getLanguageConfiguration(e).getSurroundingPairs();
    if (c)
      for (const u of c)
        this.surroundingPairs[u.open] = u.close;
    const d = this.languageConfigurationService.getLanguageConfiguration(e).comments;
    this.blockCommentStartToken = (s = d?.blockCommentStartToken) !== null && s !== void 0 ? s : null;
  }
  get electricChars() {
    var e;
    if (!this._electricChars) {
      this._electricChars = {};
      const t = (e = this.languageConfigurationService.getLanguageConfiguration(this._languageId).electricCharacter) === null || e === void 0 ? void 0 : e.getElectricCharacters();
      if (t)
        for (const n of t)
          this._electricChars[n] = !0;
    }
    return this._electricChars;
  }
  /**
   * Should return opening bracket type to match indentation with
   */
  onElectricCharacter(e, t, n) {
    const r = o4(t, n - 1), s = this.languageConfigurationService.getLanguageConfiguration(r.languageId).electricCharacter;
    return s ? s.onElectricCharacter(e, r, n - r.firstCharOffset) : null;
  }
  normalizeIndentation(e) {
    return xz(e, this.indentSize, this.insertSpaces);
  }
  _getShouldAutoClose(e, t, n) {
    switch (t) {
      case "beforeWhitespace":
        return aFe;
      case "languageDefined":
        return this._getLanguageDefinedShouldAutoClose(e, n);
      case "always":
        return sFe;
      case "never":
        return oFe;
    }
  }
  _getLanguageDefinedShouldAutoClose(e, t) {
    const n = this.languageConfigurationService.getLanguageConfiguration(e).getAutoCloseBeforeSet(t);
    return (r) => n.indexOf(r) !== -1;
  }
  /**
   * Returns a visible column from a column.
   * @see {@link CursorColumns}
   */
  visibleColumnFromColumn(e, t) {
    return Lr.visibleColumnFromColumn(e.getLineContent(t.lineNumber), t.column, this.tabSize);
  }
  /**
   * Returns a visible column from a column.
   * @see {@link CursorColumns}
   */
  columnFromVisibleColumn(e, t, n) {
    const r = Lr.columnFromVisibleColumn(e.getLineContent(t), n, this.tabSize), s = e.getLineMinColumn(t);
    if (r < s)
      return s;
    const o = e.getLineMaxColumn(t);
    return r > o ? o : r;
  }
}
let dn = class ege {
  static fromModelState(e) {
    return new lFe(e);
  }
  static fromViewState(e) {
    return new cFe(e);
  }
  static fromModelSelection(e) {
    const t = ot.liftSelection(e), n = new is(V.fromPositions(t.getSelectionStart()), 0, 0, t.getPosition(), 0);
    return ege.fromModelState(n);
  }
  static fromModelSelections(e) {
    const t = [];
    for (let n = 0, r = e.length; n < r; n++)
      t[n] = this.fromModelSelection(e[n]);
    return t;
  }
  constructor(e, t) {
    this._cursorStateBrand = void 0, this.modelState = e, this.viewState = t;
  }
  equals(e) {
    return this.viewState.equals(e.viewState) && this.modelState.equals(e.modelState);
  }
};
class lFe {
  constructor(e) {
    this.modelState = e, this.viewState = null;
  }
}
class cFe {
  constructor(e) {
    this.modelState = null, this.viewState = e;
  }
}
class is {
  constructor(e, t, n, r, s) {
    this.selectionStart = e, this.selectionStartKind = t, this.selectionStartLeftoverVisibleColumns = n, this.position = r, this.leftoverVisibleColumns = s, this._singleCursorStateBrand = void 0, this.selection = is._computeSelection(this.selectionStart, this.position);
  }
  equals(e) {
    return this.selectionStartLeftoverVisibleColumns === e.selectionStartLeftoverVisibleColumns && this.leftoverVisibleColumns === e.leftoverVisibleColumns && this.selectionStartKind === e.selectionStartKind && this.position.equals(e.position) && this.selectionStart.equalsRange(e.selectionStart);
  }
  hasSelection() {
    return !this.selection.isEmpty() || !this.selectionStart.isEmpty();
  }
  move(e, t, n, r) {
    return e ? new is(this.selectionStart, this.selectionStartKind, this.selectionStartLeftoverVisibleColumns, new ve(t, n), r) : new is(new V(t, n, t, n), 0, r, new ve(t, n), r);
  }
  static _computeSelection(e, t) {
    return e.isEmpty() || !t.isBeforeOrEqual(e.getStartPosition()) ? ot.fromPositions(e.getStartPosition(), t) : ot.fromPositions(e.getEndPosition(), t);
  }
}
class Do {
  constructor(e, t, n) {
    this._editOperationResultBrand = void 0, this.type = e, this.commands = t, this.shouldPushStackElementBefore = n.shouldPushStackElementBefore, this.shouldPushStackElementAfter = n.shouldPushStackElementAfter;
  }
}
function kf(i) {
  return i === "'" || i === '"' || i === "`";
}
class Jp {
  static columnSelect(e, t, n, r, s, o) {
    const a = Math.abs(s - n) + 1, l = n > s, c = r > o, d = r < o, u = [];
    for (let h = 0; h < a; h++) {
      const f = n + (l ? -h : h), g = e.columnFromVisibleColumn(t, f, r), p = e.columnFromVisibleColumn(t, f, o), m = e.visibleColumnFromColumn(t, new ve(f, g)), _ = e.visibleColumnFromColumn(t, new ve(f, p));
      d && (m > o || _ < r) || c && (_ > r || m < o) || u.push(new is(new V(f, g, f, g), 0, 0, new ve(f, p), 0));
    }
    if (u.length === 0)
      for (let h = 0; h < a; h++) {
        const f = n + (l ? -h : h), g = t.getLineMaxColumn(f);
        u.push(new is(new V(f, g, f, g), 0, 0, new ve(f, g), 0));
      }
    return {
      viewStates: u,
      reversed: l,
      fromLineNumber: n,
      fromVisualColumn: r,
      toLineNumber: s,
      toVisualColumn: o
    };
  }
  static columnSelectLeft(e, t, n) {
    let r = n.toViewVisualColumn;
    return r > 0 && r--, Jp.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, n.toViewLineNumber, r);
  }
  static columnSelectRight(e, t, n) {
    let r = 0;
    const s = Math.min(n.fromViewLineNumber, n.toViewLineNumber), o = Math.max(n.fromViewLineNumber, n.toViewLineNumber);
    for (let l = s; l <= o; l++) {
      const c = t.getLineMaxColumn(l), d = e.visibleColumnFromColumn(t, new ve(l, c));
      r = Math.max(r, d);
    }
    let a = n.toViewVisualColumn;
    return a < r && a++, this.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, n.toViewLineNumber, a);
  }
  static columnSelectUp(e, t, n, r) {
    const s = r ? e.pageSize : 1, o = Math.max(1, n.toViewLineNumber - s);
    return this.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, o, n.toViewVisualColumn);
  }
  static columnSelectDown(e, t, n, r) {
    const s = r ? e.pageSize : 1, o = Math.min(t.getLineCount(), n.toViewLineNumber + s);
    return this.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, o, n.toViewVisualColumn);
  }
}
class vs {
  constructor(e, t, n = !1) {
    this._range = e, this._text = t, this.insertsAutoWhitespace = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const r = t.getInverseEditOperations()[0].range;
    return ot.fromPositions(r.getEndPosition());
  }
}
class dFe {
  constructor(e, t) {
    this._range = e, this._text = t;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const r = t.getInverseEditOperations()[0].range;
    return ot.fromRange(
      r,
      0
      /* SelectionDirection.LTR */
    );
  }
}
class Zx {
  constructor(e, t, n = !1) {
    this._range = e, this._text = t, this.insertsAutoWhitespace = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const r = t.getInverseEditOperations()[0].range;
    return ot.fromPositions(r.getStartPosition());
  }
}
class j3 {
  constructor(e, t, n, r, s = !1) {
    this._range = e, this._text = t, this._columnDeltaOffset = r, this._lineNumberDeltaOffset = n, this.insertsAutoWhitespace = s;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const r = t.getInverseEditOperations()[0].range;
    return ot.fromPositions(r.getEndPosition().delta(this._lineNumberDeltaOffset, this._columnDeltaOffset));
  }
}
class Dz {
  constructor(e, t, n, r = !1) {
    this._range = e, this._text = t, this._initialSelection = n, this._forceMoveMarkers = r, this._selectionId = null;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text, this._forceMoveMarkers), this._selectionId = t.trackSelection(this._initialSelection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
class A6 {
  constructor(e, t, n) {
    this._cursorPositionBrand = void 0, this.lineNumber = e, this.column = t, this.leftoverVisibleColumns = n;
  }
}
class Ln {
  static leftPosition(e, t) {
    if (t.column > e.getLineMinColumn(t.lineNumber))
      return t.delta(void 0, -fhe(e.getLineContent(t.lineNumber), t.column - 1));
    if (t.lineNumber > 1) {
      const n = t.lineNumber - 1;
      return new ve(n, e.getLineMaxColumn(n));
    } else
      return t;
  }
  static leftPositionAtomicSoftTabs(e, t, n) {
    if (t.column <= e.getLineIndentColumn(t.lineNumber)) {
      const r = e.getLineMinColumn(t.lineNumber), s = e.getLineContent(t.lineNumber), o = Uy.atomicPosition(
        s,
        t.column - 1,
        n,
        0
        /* Direction.Left */
      );
      if (o !== -1 && o + 1 >= r)
        return new ve(t.lineNumber, o + 1);
    }
    return this.leftPosition(e, t);
  }
  static left(e, t, n) {
    const r = e.stickyTabStops ? Ln.leftPositionAtomicSoftTabs(t, n, e.tabSize) : Ln.leftPosition(t, n);
    return new A6(r.lineNumber, r.column, 0);
  }
  /**
   * @param noOfColumns Must be either `1`
   * or `Math.round(viewModel.getLineContent(viewLineNumber).length / 2)` (for half lines).
  */
  static moveLeft(e, t, n, r, s) {
    let o, a;
    if (n.hasSelection() && !r)
      o = n.selection.startLineNumber, a = n.selection.startColumn;
    else {
      const l = n.position.delta(void 0, -(s - 1)), c = t.normalizePosition(
        Ln.clipPositionColumn(l, t),
        0
        /* PositionAffinity.Left */
      ), d = Ln.left(e, t, c);
      o = d.lineNumber, a = d.column;
    }
    return n.move(r, o, a, 0);
  }
  /**
   * Adjusts the column so that it is within min/max of the line.
  */
  static clipPositionColumn(e, t) {
    return new ve(e.lineNumber, Ln.clipRange(e.column, t.getLineMinColumn(e.lineNumber), t.getLineMaxColumn(e.lineNumber)));
  }
  static clipRange(e, t, n) {
    return e < t ? t : e > n ? n : e;
  }
  static rightPosition(e, t, n) {
    return n < e.getLineMaxColumn(t) ? n = n + Wj(e.getLineContent(t), n - 1) : t < e.getLineCount() && (t = t + 1, n = e.getLineMinColumn(t)), new ve(t, n);
  }
  static rightPositionAtomicSoftTabs(e, t, n, r, s) {
    if (n < e.getLineIndentColumn(t)) {
      const o = e.getLineContent(t), a = Uy.atomicPosition(
        o,
        n - 1,
        r,
        1
        /* Direction.Right */
      );
      if (a !== -1)
        return new ve(t, a + 1);
    }
    return this.rightPosition(e, t, n);
  }
  static right(e, t, n) {
    const r = e.stickyTabStops ? Ln.rightPositionAtomicSoftTabs(t, n.lineNumber, n.column, e.tabSize, e.indentSize) : Ln.rightPosition(t, n.lineNumber, n.column);
    return new A6(r.lineNumber, r.column, 0);
  }
  static moveRight(e, t, n, r, s) {
    let o, a;
    if (n.hasSelection() && !r)
      o = n.selection.endLineNumber, a = n.selection.endColumn;
    else {
      const l = n.position.delta(void 0, s - 1), c = t.normalizePosition(
        Ln.clipPositionColumn(l, t),
        1
        /* PositionAffinity.Right */
      ), d = Ln.right(e, t, c);
      o = d.lineNumber, a = d.column;
    }
    return n.move(r, o, a, 0);
  }
  static vertical(e, t, n, r, s, o, a, l) {
    const c = Lr.visibleColumnFromColumn(t.getLineContent(n), r, e.tabSize) + s, d = t.getLineCount(), u = n === 1 && r === 1, h = n === d && r === t.getLineMaxColumn(n), f = o < n ? u : h;
    if (n = o, n < 1 ? (n = 1, a ? r = t.getLineMinColumn(n) : r = Math.min(t.getLineMaxColumn(n), r)) : n > d ? (n = d, a ? r = t.getLineMaxColumn(n) : r = Math.min(t.getLineMaxColumn(n), r)) : r = e.columnFromVisibleColumn(t, n, c), f ? s = 0 : s = c - Lr.visibleColumnFromColumn(t.getLineContent(n), r, e.tabSize), l !== void 0) {
      const g = new ve(n, r), p = t.normalizePosition(g, l);
      s = s + (r - p.column), n = p.lineNumber, r = p.column;
    }
    return new A6(n, r, s);
  }
  static down(e, t, n, r, s, o, a) {
    return this.vertical(
      e,
      t,
      n,
      r,
      s,
      n + o,
      a,
      4
      /* PositionAffinity.RightOfInjectedText */
    );
  }
  static moveDown(e, t, n, r, s) {
    let o, a;
    n.hasSelection() && !r ? (o = n.selection.endLineNumber, a = n.selection.endColumn) : (o = n.position.lineNumber, a = n.position.column);
    let l = 0, c;
    do
      if (c = Ln.down(e, t, o + l, a, n.leftoverVisibleColumns, s, !0), t.normalizePosition(
        new ve(c.lineNumber, c.column),
        2
        /* PositionAffinity.None */
      ).lineNumber > o)
        break;
    while (l++ < 10 && o + l < t.getLineCount());
    return n.move(r, c.lineNumber, c.column, c.leftoverVisibleColumns);
  }
  static translateDown(e, t, n) {
    const r = n.selection, s = Ln.down(e, t, r.selectionStartLineNumber, r.selectionStartColumn, n.selectionStartLeftoverVisibleColumns, 1, !1), o = Ln.down(e, t, r.positionLineNumber, r.positionColumn, n.leftoverVisibleColumns, 1, !1);
    return new is(new V(s.lineNumber, s.column, s.lineNumber, s.column), 0, s.leftoverVisibleColumns, new ve(o.lineNumber, o.column), o.leftoverVisibleColumns);
  }
  static up(e, t, n, r, s, o, a) {
    return this.vertical(
      e,
      t,
      n,
      r,
      s,
      n - o,
      a,
      3
      /* PositionAffinity.LeftOfInjectedText */
    );
  }
  static moveUp(e, t, n, r, s) {
    let o, a;
    n.hasSelection() && !r ? (o = n.selection.startLineNumber, a = n.selection.startColumn) : (o = n.position.lineNumber, a = n.position.column);
    const l = Ln.up(e, t, o, a, n.leftoverVisibleColumns, s, !0);
    return n.move(r, l.lineNumber, l.column, l.leftoverVisibleColumns);
  }
  static translateUp(e, t, n) {
    const r = n.selection, s = Ln.up(e, t, r.selectionStartLineNumber, r.selectionStartColumn, n.selectionStartLeftoverVisibleColumns, 1, !1), o = Ln.up(e, t, r.positionLineNumber, r.positionColumn, n.leftoverVisibleColumns, 1, !1);
    return new is(new V(s.lineNumber, s.column, s.lineNumber, s.column), 0, s.leftoverVisibleColumns, new ve(o.lineNumber, o.column), o.leftoverVisibleColumns);
  }
  static _isBlankLine(e, t) {
    return e.getLineFirstNonWhitespaceColumn(t) === 0;
  }
  static moveToPrevBlankLine(e, t, n, r) {
    let s = n.position.lineNumber;
    for (; s > 1 && this._isBlankLine(t, s); )
      s--;
    for (; s > 1 && !this._isBlankLine(t, s); )
      s--;
    return n.move(r, s, t.getLineMinColumn(s), 0);
  }
  static moveToNextBlankLine(e, t, n, r) {
    const s = t.getLineCount();
    let o = n.position.lineNumber;
    for (; o < s && this._isBlankLine(t, o); )
      o++;
    for (; o < s && !this._isBlankLine(t, o); )
      o++;
    return n.move(r, o, t.getLineMinColumn(o), 0);
  }
  static moveToBeginningOfLine(e, t, n, r) {
    const s = n.position.lineNumber, o = t.getLineMinColumn(s), a = t.getLineFirstNonWhitespaceColumn(s) || o;
    let l;
    return n.position.column === a ? l = o : l = a, n.move(r, s, l, 0);
  }
  static moveToEndOfLine(e, t, n, r, s) {
    const o = n.position.lineNumber, a = t.getLineMaxColumn(o);
    return n.move(r, o, a, s ? 1073741824 - a : 0);
  }
  static moveToBeginningOfBuffer(e, t, n, r) {
    return n.move(r, 1, 1, 0);
  }
  static moveToEndOfBuffer(e, t, n, r) {
    const s = t.getLineCount(), o = t.getLineMaxColumn(s);
    return n.move(r, s, o, 0);
  }
}
class Zm {
  static deleteRight(e, t, n, r) {
    const s = [];
    let o = e !== 3;
    for (let a = 0, l = r.length; a < l; a++) {
      const c = r[a];
      let d = c;
      if (d.isEmpty()) {
        const u = c.getPosition(), h = Ln.right(t, n, u);
        d = new V(h.lineNumber, h.column, u.lineNumber, u.column);
      }
      if (d.isEmpty()) {
        s[a] = null;
        continue;
      }
      d.startLineNumber !== d.endLineNumber && (o = !0), s[a] = new vs(d, "");
    }
    return [o, s];
  }
  static isAutoClosingPairDelete(e, t, n, r, s, o, a) {
    if (t === "never" && n === "never" || e === "never")
      return !1;
    for (let l = 0, c = o.length; l < c; l++) {
      const d = o[l], u = d.getPosition();
      if (!d.isEmpty())
        return !1;
      const h = s.getLineContent(u.lineNumber);
      if (u.column < 2 || u.column >= h.length + 1)
        return !1;
      const f = h.charAt(u.column - 2), g = r.get(f);
      if (!g)
        return !1;
      if (kf(f)) {
        if (n === "never")
          return !1;
      } else if (t === "never")
        return !1;
      const p = h.charAt(u.column - 1);
      let m = !1;
      for (const _ of g)
        _.open === f && _.close === p && (m = !0);
      if (!m)
        return !1;
      if (e === "auto") {
        let _ = !1;
        for (let b = 0, w = a.length; b < w; b++) {
          const y = a[b];
          if (u.lineNumber === y.startLineNumber && u.column === y.startColumn) {
            _ = !0;
            break;
          }
        }
        if (!_)
          return !1;
      }
    }
    return !0;
  }
  static _runAutoClosingPairDelete(e, t, n) {
    const r = [];
    for (let s = 0, o = n.length; s < o; s++) {
      const a = n[s].getPosition(), l = new V(a.lineNumber, a.column - 1, a.lineNumber, a.column + 1);
      r[s] = new vs(l, "");
    }
    return [!0, r];
  }
  static deleteLeft(e, t, n, r, s) {
    if (this.isAutoClosingPairDelete(t.autoClosingDelete, t.autoClosingBrackets, t.autoClosingQuotes, t.autoClosingPairs.autoClosingPairsOpenByEnd, n, r, s))
      return this._runAutoClosingPairDelete(t, n, r);
    const o = [];
    let a = e !== 2;
    for (let l = 0, c = r.length; l < c; l++) {
      const d = Zm.getDeleteRange(r[l], n, t);
      if (d.isEmpty()) {
        o[l] = null;
        continue;
      }
      d.startLineNumber !== d.endLineNumber && (a = !0), o[l] = new vs(d, "");
    }
    return [a, o];
  }
  static getDeleteRange(e, t, n) {
    if (!e.isEmpty())
      return e;
    const r = e.getPosition();
    if (n.useTabStops && r.column > 1) {
      const s = t.getLineContent(r.lineNumber), o = Js(s), a = o === -1 ? (
        /* entire string is whitespace */
        s.length + 1
      ) : o + 1;
      if (r.column <= a) {
        const l = n.visibleColumnFromColumn(t, r), c = Lr.prevIndentTabStop(l, n.indentSize), d = n.columnFromVisibleColumn(t, r.lineNumber, c);
        return new V(r.lineNumber, d, r.lineNumber, r.column);
      }
    }
    return V.fromPositions(Zm.getPositionAfterDeleteLeft(r, t), r);
  }
  static getPositionAfterDeleteLeft(e, t) {
    if (e.column > 1) {
      const n = DNe(e.column - 1, t.getLineContent(e.lineNumber));
      return e.with(void 0, n + 1);
    } else if (e.lineNumber > 1) {
      const n = e.lineNumber - 1;
      return new ve(n, t.getLineMaxColumn(n));
    } else
      return e;
  }
  static cut(e, t, n) {
    const r = [];
    let s = null;
    n.sort((o, a) => ve.compare(o.getStartPosition(), a.getEndPosition()));
    for (let o = 0, a = n.length; o < a; o++) {
      const l = n[o];
      if (l.isEmpty())
        if (e.emptySelectionClipboard) {
          const c = l.getPosition();
          let d, u, h, f;
          c.lineNumber < t.getLineCount() ? (d = c.lineNumber, u = 1, h = c.lineNumber + 1, f = 1) : c.lineNumber > 1 && s?.endLineNumber !== c.lineNumber ? (d = c.lineNumber - 1, u = t.getLineMaxColumn(c.lineNumber - 1), h = c.lineNumber, f = t.getLineMaxColumn(c.lineNumber)) : (d = c.lineNumber, u = 1, h = c.lineNumber, f = t.getLineMaxColumn(c.lineNumber));
          const g = new V(d, u, h, f);
          s = g, g.isEmpty() ? r[o] = null : r[o] = new vs(g, "");
        } else
          r[o] = null;
      else
        r[o] = new vs(l, "");
    }
    return new Do(0, r, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !0
    });
  }
}
class yn {
  static _createWord(e, t, n, r, s) {
    return { start: r, end: s, wordType: t, nextCharClass: n };
  }
  static _findPreviousWordOnLine(e, t, n) {
    const r = t.getLineContent(n.lineNumber);
    return this._doFindPreviousWordOnLine(r, e, n);
  }
  static _doFindPreviousWordOnLine(e, t, n) {
    let r = 0;
    for (let s = n.column - 2; s >= 0; s--) {
      const o = e.charCodeAt(s), a = t.get(o);
      if (a === 0) {
        if (r === 2)
          return this._createWord(e, r, a, s + 1, this._findEndOfWord(e, t, r, s + 1));
        r = 1;
      } else if (a === 2) {
        if (r === 1)
          return this._createWord(e, r, a, s + 1, this._findEndOfWord(e, t, r, s + 1));
        r = 2;
      } else if (a === 1 && r !== 0)
        return this._createWord(e, r, a, s + 1, this._findEndOfWord(e, t, r, s + 1));
    }
    return r !== 0 ? this._createWord(e, r, 1, 0, this._findEndOfWord(e, t, r, 0)) : null;
  }
  static _findEndOfWord(e, t, n, r) {
    const s = e.length;
    for (let o = r; o < s; o++) {
      const a = e.charCodeAt(o), l = t.get(a);
      if (l === 1 || n === 1 && l === 2 || n === 2 && l === 0)
        return o;
    }
    return s;
  }
  static _findNextWordOnLine(e, t, n) {
    const r = t.getLineContent(n.lineNumber);
    return this._doFindNextWordOnLine(r, e, n);
  }
  static _doFindNextWordOnLine(e, t, n) {
    let r = 0;
    const s = e.length;
    for (let o = n.column - 1; o < s; o++) {
      const a = e.charCodeAt(o), l = t.get(a);
      if (l === 0) {
        if (r === 2)
          return this._createWord(e, r, l, this._findStartOfWord(e, t, r, o - 1), o);
        r = 1;
      } else if (l === 2) {
        if (r === 1)
          return this._createWord(e, r, l, this._findStartOfWord(e, t, r, o - 1), o);
        r = 2;
      } else if (l === 1 && r !== 0)
        return this._createWord(e, r, l, this._findStartOfWord(e, t, r, o - 1), o);
    }
    return r !== 0 ? this._createWord(e, r, 1, this._findStartOfWord(e, t, r, s - 1), s) : null;
  }
  static _findStartOfWord(e, t, n, r) {
    for (let s = r; s >= 0; s--) {
      const o = e.charCodeAt(s), a = t.get(o);
      if (a === 1 || n === 1 && a === 2 || n === 2 && a === 0)
        return s + 1;
    }
    return 0;
  }
  static moveWordLeft(e, t, n, r) {
    let s = n.lineNumber, o = n.column;
    o === 1 && s > 1 && (s = s - 1, o = t.getLineMaxColumn(s));
    let a = yn._findPreviousWordOnLine(e, t, new ve(s, o));
    if (r === 0)
      return new ve(s, a ? a.start + 1 : 1);
    if (r === 1)
      return a && a.wordType === 2 && a.end - a.start === 1 && a.nextCharClass === 0 && (a = yn._findPreviousWordOnLine(e, t, new ve(s, a.start + 1))), new ve(s, a ? a.start + 1 : 1);
    if (r === 3) {
      for (; a && a.wordType === 2; )
        a = yn._findPreviousWordOnLine(e, t, new ve(s, a.start + 1));
      return new ve(s, a ? a.start + 1 : 1);
    }
    return a && o <= a.end + 1 && (a = yn._findPreviousWordOnLine(e, t, new ve(s, a.start + 1))), new ve(s, a ? a.end + 1 : 1);
  }
  static _moveWordPartLeft(e, t) {
    const n = t.lineNumber, r = e.getLineMaxColumn(n);
    if (t.column === 1)
      return n > 1 ? new ve(n - 1, e.getLineMaxColumn(n - 1)) : t;
    const s = e.getLineContent(n);
    for (let o = t.column - 1; o > 1; o--) {
      const a = s.charCodeAt(o - 2), l = s.charCodeAt(o - 1);
      if (a === 95 && l !== 95)
        return new ve(n, o);
      if (a === 45 && l !== 45)
        return new ve(n, o);
      if ((Xf(a) || Fx(a)) && Od(l))
        return new ve(n, o);
      if (Od(a) && Od(l) && o + 1 < r) {
        const c = s.charCodeAt(o);
        if (Xf(c) || Fx(c))
          return new ve(n, o);
      }
    }
    return new ve(n, 1);
  }
  static moveWordRight(e, t, n, r) {
    let s = n.lineNumber, o = n.column, a = !1;
    o === t.getLineMaxColumn(s) && s < t.getLineCount() && (a = !0, s = s + 1, o = 1);
    let l = yn._findNextWordOnLine(e, t, new ve(s, o));
    if (r === 2)
      l && l.wordType === 2 && l.end - l.start === 1 && l.nextCharClass === 0 && (l = yn._findNextWordOnLine(e, t, new ve(s, l.end + 1))), l ? o = l.end + 1 : o = t.getLineMaxColumn(s);
    else if (r === 3) {
      for (a && (o = 0); l && (l.wordType === 2 || l.start + 1 <= o); )
        l = yn._findNextWordOnLine(e, t, new ve(s, l.end + 1));
      l ? o = l.start + 1 : o = t.getLineMaxColumn(s);
    } else
      l && !a && o >= l.start + 1 && (l = yn._findNextWordOnLine(e, t, new ve(s, l.end + 1))), l ? o = l.start + 1 : o = t.getLineMaxColumn(s);
    return new ve(s, o);
  }
  static _moveWordPartRight(e, t) {
    const n = t.lineNumber, r = e.getLineMaxColumn(n);
    if (t.column === r)
      return n < e.getLineCount() ? new ve(n + 1, 1) : t;
    const s = e.getLineContent(n);
    for (let o = t.column + 1; o < r; o++) {
      const a = s.charCodeAt(o - 2), l = s.charCodeAt(o - 1);
      if (a !== 95 && l === 95)
        return new ve(n, o);
      if (a !== 45 && l === 45)
        return new ve(n, o);
      if ((Xf(a) || Fx(a)) && Od(l))
        return new ve(n, o);
      if (Od(a) && Od(l) && o + 1 < r) {
        const c = s.charCodeAt(o);
        if (Xf(c) || Fx(c))
          return new ve(n, o);
      }
    }
    return new ve(n, r);
  }
  static _deleteWordLeftWhitespace(e, t) {
    const n = e.getLineContent(t.lineNumber), r = t.column - 2, s = Jc(n, r);
    return s + 1 < r ? new V(t.lineNumber, s + 2, t.lineNumber, t.column) : null;
  }
  static deleteWordLeft(e, t) {
    const n = e.wordSeparators, r = e.model, s = e.selection, o = e.whitespaceHeuristics;
    if (!s.isEmpty())
      return s;
    if (Zm.isAutoClosingPairDelete(e.autoClosingDelete, e.autoClosingBrackets, e.autoClosingQuotes, e.autoClosingPairs.autoClosingPairsOpenByEnd, e.model, [e.selection], e.autoClosedCharacters)) {
      const u = e.selection.getPosition();
      return new V(u.lineNumber, u.column - 1, u.lineNumber, u.column + 1);
    }
    const a = new ve(s.positionLineNumber, s.positionColumn);
    let l = a.lineNumber, c = a.column;
    if (l === 1 && c === 1)
      return null;
    if (o) {
      const u = this._deleteWordLeftWhitespace(r, a);
      if (u)
        return u;
    }
    let d = yn._findPreviousWordOnLine(n, r, a);
    return t === 0 ? d ? c = d.start + 1 : c > 1 ? c = 1 : (l--, c = r.getLineMaxColumn(l)) : (d && c <= d.end + 1 && (d = yn._findPreviousWordOnLine(n, r, new ve(l, d.start + 1))), d ? c = d.end + 1 : c > 1 ? c = 1 : (l--, c = r.getLineMaxColumn(l))), new V(l, c, a.lineNumber, a.column);
  }
  static deleteInsideWord(e, t, n) {
    if (!n.isEmpty())
      return n;
    const r = new ve(n.positionLineNumber, n.positionColumn), s = this._deleteInsideWordWhitespace(t, r);
    return s || this._deleteInsideWordDetermineDeleteRange(e, t, r);
  }
  static _charAtIsWhitespace(e, t) {
    const n = e.charCodeAt(t);
    return n === 32 || n === 9;
  }
  static _deleteInsideWordWhitespace(e, t) {
    const n = e.getLineContent(t.lineNumber), r = n.length;
    if (r === 0)
      return null;
    let s = Math.max(t.column - 2, 0);
    if (!this._charAtIsWhitespace(n, s))
      return null;
    let o = Math.min(t.column - 1, r - 1);
    if (!this._charAtIsWhitespace(n, o))
      return null;
    for (; s > 0 && this._charAtIsWhitespace(n, s - 1); )
      s--;
    for (; o + 1 < r && this._charAtIsWhitespace(n, o + 1); )
      o++;
    return new V(t.lineNumber, s + 1, t.lineNumber, o + 2);
  }
  static _deleteInsideWordDetermineDeleteRange(e, t, n) {
    const r = t.getLineContent(n.lineNumber), s = r.length;
    if (s === 0)
      return n.lineNumber > 1 ? new V(n.lineNumber - 1, t.getLineMaxColumn(n.lineNumber - 1), n.lineNumber, 1) : n.lineNumber < t.getLineCount() ? new V(n.lineNumber, 1, n.lineNumber + 1, 1) : new V(n.lineNumber, 1, n.lineNumber, 1);
    const o = (u) => u.start + 1 <= n.column && n.column <= u.end + 1, a = (u, h) => (u = Math.min(u, n.column), h = Math.max(h, n.column), new V(n.lineNumber, u, n.lineNumber, h)), l = (u) => {
      let h = u.start + 1, f = u.end + 1, g = !1;
      for (; f - 1 < s && this._charAtIsWhitespace(r, f - 1); )
        g = !0, f++;
      if (!g)
        for (; h > 1 && this._charAtIsWhitespace(r, h - 2); )
          h--;
      return a(h, f);
    }, c = yn._findPreviousWordOnLine(e, t, n);
    if (c && o(c))
      return l(c);
    const d = yn._findNextWordOnLine(e, t, n);
    return d && o(d) ? l(d) : c && d ? a(c.end + 1, d.start + 1) : c ? a(c.start + 1, c.end + 1) : d ? a(d.start + 1, d.end + 1) : a(1, s + 1);
  }
  static _deleteWordPartLeft(e, t) {
    if (!t.isEmpty())
      return t;
    const n = t.getPosition(), r = yn._moveWordPartLeft(e, n);
    return new V(n.lineNumber, n.column, r.lineNumber, r.column);
  }
  static _findFirstNonWhitespaceChar(e, t) {
    const n = e.length;
    for (let r = t; r < n; r++) {
      const s = e.charAt(r);
      if (s !== " " && s !== "	")
        return r;
    }
    return n;
  }
  static _deleteWordRightWhitespace(e, t) {
    const n = e.getLineContent(t.lineNumber), r = t.column - 1, s = this._findFirstNonWhitespaceChar(n, r);
    return r + 1 < s ? new V(t.lineNumber, t.column, t.lineNumber, s + 1) : null;
  }
  static deleteWordRight(e, t) {
    const n = e.wordSeparators, r = e.model, s = e.selection, o = e.whitespaceHeuristics;
    if (!s.isEmpty())
      return s;
    const a = new ve(s.positionLineNumber, s.positionColumn);
    let l = a.lineNumber, c = a.column;
    const d = r.getLineCount(), u = r.getLineMaxColumn(l);
    if (l === d && c === u)
      return null;
    if (o) {
      const f = this._deleteWordRightWhitespace(r, a);
      if (f)
        return f;
    }
    let h = yn._findNextWordOnLine(n, r, a);
    return t === 2 ? h ? c = h.end + 1 : c < u || l === d ? c = u : (l++, h = yn._findNextWordOnLine(n, r, new ve(l, 1)), h ? c = h.start + 1 : c = r.getLineMaxColumn(l)) : (h && c >= h.start + 1 && (h = yn._findNextWordOnLine(n, r, new ve(l, h.end + 1))), h ? c = h.start + 1 : c < u || l === d ? c = u : (l++, h = yn._findNextWordOnLine(n, r, new ve(l, 1)), h ? c = h.start + 1 : c = r.getLineMaxColumn(l))), new V(l, c, a.lineNumber, a.column);
  }
  static _deleteWordPartRight(e, t) {
    if (!t.isEmpty())
      return t;
    const n = t.getPosition(), r = yn._moveWordPartRight(e, n);
    return new V(n.lineNumber, n.column, r.lineNumber, r.column);
  }
  static _createWordAtPosition(e, t, n) {
    const r = new V(t, n.start + 1, t, n.end + 1);
    return {
      word: e.getValueInRange(r),
      startColumn: r.startColumn,
      endColumn: r.endColumn
    };
  }
  static getWordAtPosition(e, t, n) {
    const r = wl(t), s = yn._findPreviousWordOnLine(r, e, n);
    if (s && s.wordType === 1 && s.start <= n.column - 1 && n.column - 1 <= s.end)
      return yn._createWordAtPosition(e, n.lineNumber, s);
    const o = yn._findNextWordOnLine(r, e, n);
    return o && o.wordType === 1 && o.start <= n.column - 1 && n.column - 1 <= o.end ? yn._createWordAtPosition(e, n.lineNumber, o) : null;
  }
  static word(e, t, n, r, s) {
    const o = wl(e.wordSeparators), a = yn._findPreviousWordOnLine(o, t, s), l = yn._findNextWordOnLine(o, t, s);
    if (!r) {
      let f, g;
      return a && a.wordType === 1 && a.start <= s.column - 1 && s.column - 1 <= a.end ? (f = a.start + 1, g = a.end + 1) : l && l.wordType === 1 && l.start <= s.column - 1 && s.column - 1 <= l.end ? (f = l.start + 1, g = l.end + 1) : (a ? f = a.end + 1 : f = 1, l ? g = l.start + 1 : g = t.getLineMaxColumn(s.lineNumber)), new is(new V(s.lineNumber, f, s.lineNumber, g), 1, 0, new ve(s.lineNumber, g), 0);
    }
    let c, d;
    a && a.wordType === 1 && a.start < s.column - 1 && s.column - 1 < a.end ? (c = a.start + 1, d = a.end + 1) : l && l.wordType === 1 && l.start < s.column - 1 && s.column - 1 < l.end ? (c = l.start + 1, d = l.end + 1) : (c = s.column, d = s.column);
    const u = s.lineNumber;
    let h;
    if (n.selectionStart.containsPosition(s))
      h = n.selectionStart.endColumn;
    else if (s.isBeforeOrEqual(n.selectionStart.getStartPosition())) {
      h = c;
      const f = new ve(u, h);
      n.selectionStart.containsPosition(f) && (h = n.selectionStart.endColumn);
    } else {
      h = d;
      const f = new ve(u, h);
      n.selectionStart.containsPosition(f) && (h = n.selectionStart.startColumn);
    }
    return n.move(!0, u, h, 0);
  }
}
class C4 extends yn {
  static deleteWordPartLeft(e) {
    const t = Qx([
      yn.deleteWordLeft(
        e,
        0
        /* WordNavigationType.WordStart */
      ),
      yn.deleteWordLeft(
        e,
        2
        /* WordNavigationType.WordEnd */
      ),
      yn._deleteWordPartLeft(e.model, e.selection)
    ]);
    return t.sort(V.compareRangesUsingEnds), t[2];
  }
  static deleteWordPartRight(e) {
    const t = Qx([
      yn.deleteWordRight(
        e,
        0
        /* WordNavigationType.WordStart */
      ),
      yn.deleteWordRight(
        e,
        2
        /* WordNavigationType.WordEnd */
      ),
      yn._deleteWordPartRight(e.model, e.selection)
    ]);
    return t.sort(V.compareRangesUsingStarts), t[0];
  }
  static moveWordPartLeft(e, t, n) {
    const r = Qx([
      yn.moveWordLeft(
        e,
        t,
        n,
        0
        /* WordNavigationType.WordStart */
      ),
      yn.moveWordLeft(
        e,
        t,
        n,
        2
        /* WordNavigationType.WordEnd */
      ),
      yn._moveWordPartLeft(t, n)
    ]);
    return r.sort(ve.compare), r[2];
  }
  static moveWordPartRight(e, t, n) {
    const r = Qx([
      yn.moveWordRight(
        e,
        t,
        n,
        0
        /* WordNavigationType.WordStart */
      ),
      yn.moveWordRight(
        e,
        t,
        n,
        2
        /* WordNavigationType.WordEnd */
      ),
      yn._moveWordPartRight(t, n)
    ]);
    return r.sort(ve.compare), r[0];
  }
}
function Qx(i) {
  return i.filter((e) => !!e);
}
class Qr {
  static addCursorDown(e, t, n) {
    const r = [];
    let s = 0;
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      r[s++] = new dn(l.modelState, l.viewState), n ? r[s++] = dn.fromModelState(Ln.translateDown(e.cursorConfig, e.model, l.modelState)) : r[s++] = dn.fromViewState(Ln.translateDown(e.cursorConfig, e, l.viewState));
    }
    return r;
  }
  static addCursorUp(e, t, n) {
    const r = [];
    let s = 0;
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      r[s++] = new dn(l.modelState, l.viewState), n ? r[s++] = dn.fromModelState(Ln.translateUp(e.cursorConfig, e.model, l.modelState)) : r[s++] = dn.fromViewState(Ln.translateUp(e.cursorConfig, e, l.viewState));
    }
    return r;
  }
  static moveToBeginningOfLine(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s];
      r[s] = this._moveToLineStart(e, a, n);
    }
    return r;
  }
  static _moveToLineStart(e, t, n) {
    const r = t.viewState.position.column, s = t.modelState.position.column, o = r === s, a = t.viewState.position.lineNumber, l = e.getLineFirstNonWhitespaceColumn(a);
    return !o && !(r === l) ? this._moveToLineStartByView(e, t, n) : this._moveToLineStartByModel(e, t, n);
  }
  static _moveToLineStartByView(e, t, n) {
    return dn.fromViewState(Ln.moveToBeginningOfLine(e.cursorConfig, e, t.viewState, n));
  }
  static _moveToLineStartByModel(e, t, n) {
    return dn.fromModelState(Ln.moveToBeginningOfLine(e.cursorConfig, e.model, t.modelState, n));
  }
  static moveToEndOfLine(e, t, n, r) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = this._moveToLineEnd(e, l, n, r);
    }
    return s;
  }
  static _moveToLineEnd(e, t, n, r) {
    const s = t.viewState.position, o = e.getLineMaxColumn(s.lineNumber), a = s.column === o, l = t.modelState.position, c = e.model.getLineMaxColumn(l.lineNumber), d = o - s.column === c - l.column;
    return a || d ? this._moveToLineEndByModel(e, t, n, r) : this._moveToLineEndByView(e, t, n, r);
  }
  static _moveToLineEndByView(e, t, n, r) {
    return dn.fromViewState(Ln.moveToEndOfLine(e.cursorConfig, e, t.viewState, n, r));
  }
  static _moveToLineEndByModel(e, t, n, r) {
    return dn.fromModelState(Ln.moveToEndOfLine(e.cursorConfig, e.model, t.modelState, n, r));
  }
  static expandLineSelection(e, t) {
    const n = [];
    for (let r = 0, s = t.length; r < s; r++) {
      const o = t[r], a = o.modelState.selection.startLineNumber, l = e.model.getLineCount();
      let c = o.modelState.selection.endLineNumber, d;
      c === l ? d = e.model.getLineMaxColumn(l) : (c++, d = 1), n[r] = dn.fromModelState(new is(new V(a, 1, a, 1), 0, 0, new ve(c, d), 0));
    }
    return n;
  }
  static moveToBeginningOfBuffer(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s];
      r[s] = dn.fromModelState(Ln.moveToBeginningOfBuffer(e.cursorConfig, e.model, a.modelState, n));
    }
    return r;
  }
  static moveToEndOfBuffer(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s];
      r[s] = dn.fromModelState(Ln.moveToEndOfBuffer(e.cursorConfig, e.model, a.modelState, n));
    }
    return r;
  }
  static selectAll(e, t) {
    const n = e.model.getLineCount(), r = e.model.getLineMaxColumn(n);
    return dn.fromModelState(new is(new V(1, 1, 1, 1), 0, 0, new ve(n, r), 0));
  }
  static line(e, t, n, r, s) {
    const o = e.model.validatePosition(r), a = s ? e.coordinatesConverter.validateViewPosition(new ve(s.lineNumber, s.column), o) : e.coordinatesConverter.convertModelPositionToViewPosition(o);
    if (!n) {
      const c = e.model.getLineCount();
      let d = o.lineNumber + 1, u = 1;
      return d > c && (d = c, u = e.model.getLineMaxColumn(d)), dn.fromModelState(new is(new V(o.lineNumber, 1, d, u), 2, 0, new ve(d, u), 0));
    }
    const l = t.modelState.selectionStart.getStartPosition().lineNumber;
    if (o.lineNumber < l)
      return dn.fromViewState(t.viewState.move(!0, a.lineNumber, 1, 0));
    if (o.lineNumber > l) {
      const c = e.getLineCount();
      let d = a.lineNumber + 1, u = 1;
      return d > c && (d = c, u = e.getLineMaxColumn(d)), dn.fromViewState(t.viewState.move(!0, d, u, 0));
    } else {
      const c = t.modelState.selectionStart.getEndPosition();
      return dn.fromModelState(t.modelState.move(!0, c.lineNumber, c.column, 0));
    }
  }
  static word(e, t, n, r) {
    const s = e.model.validatePosition(r);
    return dn.fromModelState(yn.word(e.cursorConfig, e.model, t.modelState, n, s));
  }
  static cancelSelection(e, t) {
    if (!t.modelState.hasSelection())
      return new dn(t.modelState, t.viewState);
    const n = t.viewState.position.lineNumber, r = t.viewState.position.column;
    return dn.fromViewState(new is(new V(n, r, n, r), 0, 0, new ve(n, r), 0));
  }
  static moveTo(e, t, n, r, s) {
    if (n) {
      if (t.modelState.selectionStartKind === 1)
        return this.word(e, t, n, r);
      if (t.modelState.selectionStartKind === 2)
        return this.line(e, t, n, r, s);
    }
    const o = e.model.validatePosition(r), a = s ? e.coordinatesConverter.validateViewPosition(new ve(s.lineNumber, s.column), o) : e.coordinatesConverter.convertModelPositionToViewPosition(o);
    return dn.fromViewState(t.viewState.move(n, a.lineNumber, a.column, 0));
  }
  static simpleMove(e, t, n, r, s, o) {
    switch (n) {
      case 0:
        return o === 4 ? this._moveHalfLineLeft(e, t, r) : this._moveLeft(e, t, r, s);
      case 1:
        return o === 4 ? this._moveHalfLineRight(e, t, r) : this._moveRight(e, t, r, s);
      case 2:
        return o === 2 ? this._moveUpByViewLines(e, t, r, s) : this._moveUpByModelLines(e, t, r, s);
      case 3:
        return o === 2 ? this._moveDownByViewLines(e, t, r, s) : this._moveDownByModelLines(e, t, r, s);
      case 4:
        return o === 2 ? t.map((a) => dn.fromViewState(Ln.moveToPrevBlankLine(e.cursorConfig, e, a.viewState, r))) : t.map((a) => dn.fromModelState(Ln.moveToPrevBlankLine(e.cursorConfig, e.model, a.modelState, r)));
      case 5:
        return o === 2 ? t.map((a) => dn.fromViewState(Ln.moveToNextBlankLine(e.cursorConfig, e, a.viewState, r))) : t.map((a) => dn.fromModelState(Ln.moveToNextBlankLine(e.cursorConfig, e.model, a.modelState, r)));
      case 6:
        return this._moveToViewMinColumn(e, t, r);
      case 7:
        return this._moveToViewFirstNonWhitespaceColumn(e, t, r);
      case 8:
        return this._moveToViewCenterColumn(e, t, r);
      case 9:
        return this._moveToViewMaxColumn(e, t, r);
      case 10:
        return this._moveToViewLastNonWhitespaceColumn(e, t, r);
      default:
        return null;
    }
  }
  static viewportMove(e, t, n, r, s) {
    const o = e.getCompletelyVisibleViewRange(), a = e.coordinatesConverter.convertViewRangeToModelRange(o);
    switch (n) {
      case 11: {
        const l = this._firstLineNumberInRange(e.model, a, s), c = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], r, l, c)];
      }
      case 13: {
        const l = this._lastLineNumberInRange(e.model, a, s), c = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], r, l, c)];
      }
      case 12: {
        const l = Math.round((a.startLineNumber + a.endLineNumber) / 2), c = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], r, l, c)];
      }
      case 14: {
        const l = [];
        for (let c = 0, d = t.length; c < d; c++) {
          const u = t[c];
          l[c] = this.findPositionInViewportIfOutside(e, u, o, r);
        }
        return l;
      }
      default:
        return null;
    }
  }
  static findPositionInViewportIfOutside(e, t, n, r) {
    const s = t.viewState.position.lineNumber;
    if (n.startLineNumber <= s && s <= n.endLineNumber - 1)
      return new dn(t.modelState, t.viewState);
    {
      let o;
      s > n.endLineNumber - 1 ? o = n.endLineNumber - 1 : s < n.startLineNumber ? o = n.startLineNumber : o = s;
      const a = Ln.vertical(e.cursorConfig, e, s, t.viewState.position.column, t.viewState.leftoverVisibleColumns, o, !1);
      return dn.fromViewState(t.viewState.move(r, a.lineNumber, a.column, a.leftoverVisibleColumns));
    }
  }
  /**
   * Find the nth line start included in the range (from the start).
   */
  static _firstLineNumberInRange(e, t, n) {
    let r = t.startLineNumber;
    return t.startColumn !== e.getLineMinColumn(r) && r++, Math.min(t.endLineNumber, r + n - 1);
  }
  /**
   * Find the nth line start included in the range (from the end).
   */
  static _lastLineNumberInRange(e, t, n) {
    let r = t.startLineNumber;
    return t.startColumn !== e.getLineMinColumn(r) && r++, Math.max(r, t.endLineNumber - n + 1);
  }
  static _moveLeft(e, t, n, r) {
    return t.map((s) => dn.fromViewState(Ln.moveLeft(e.cursorConfig, e, s.viewState, n, r)));
  }
  static _moveHalfLineLeft(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = Math.round(e.getLineContent(l).length / 2);
      r[s] = dn.fromViewState(Ln.moveLeft(e.cursorConfig, e, a.viewState, n, c));
    }
    return r;
  }
  static _moveRight(e, t, n, r) {
    return t.map((s) => dn.fromViewState(Ln.moveRight(e.cursorConfig, e, s.viewState, n, r)));
  }
  static _moveHalfLineRight(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = Math.round(e.getLineContent(l).length / 2);
      r[s] = dn.fromViewState(Ln.moveRight(e.cursorConfig, e, a.viewState, n, c));
    }
    return r;
  }
  static _moveDownByViewLines(e, t, n, r) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = dn.fromViewState(Ln.moveDown(e.cursorConfig, e, l.viewState, n, r));
    }
    return s;
  }
  static _moveDownByModelLines(e, t, n, r) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = dn.fromModelState(Ln.moveDown(e.cursorConfig, e.model, l.modelState, n, r));
    }
    return s;
  }
  static _moveUpByViewLines(e, t, n, r) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = dn.fromViewState(Ln.moveUp(e.cursorConfig, e, l.viewState, n, r));
    }
    return s;
  }
  static _moveUpByModelLines(e, t, n, r) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = dn.fromModelState(Ln.moveUp(e.cursorConfig, e.model, l.modelState, n, r));
    }
    return s;
  }
  static _moveToViewPosition(e, t, n, r, s) {
    return dn.fromViewState(t.viewState.move(n, r, s, 0));
  }
  static _moveToModelPosition(e, t, n, r, s) {
    return dn.fromModelState(t.modelState.move(n, r, s, 0));
  }
  static _moveToViewMinColumn(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = e.getLineMinColumn(l);
      r[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return r;
  }
  static _moveToViewFirstNonWhitespaceColumn(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = e.getLineFirstNonWhitespaceColumn(l);
      r[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return r;
  }
  static _moveToViewCenterColumn(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = Math.round((e.getLineMaxColumn(l) + e.getLineMinColumn(l)) / 2);
      r[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return r;
  }
  static _moveToViewMaxColumn(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = e.getLineMaxColumn(l);
      r[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return r;
  }
  static _moveToViewLastNonWhitespaceColumn(e, t, n) {
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = e.getLineLastNonWhitespaceColumn(l);
      r[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return r;
  }
}
var pL;
(function(i) {
  const e = function(n) {
    if (!ho(n))
      return !1;
    const r = n;
    return !(!mo(r.to) || !Jo(r.select) && !Mue(r.select) || !Jo(r.by) && !mo(r.by) || !Jo(r.value) && !Tg(r.value));
  };
  i.description = {
    description: "Move cursor to a logical position in the view",
    args: [
      {
        name: "Cursor move argument object",
        description: `Property-value pairs that can be passed through this argument:
					* 'to': A mandatory logical position value providing where to move the cursor.
						\`\`\`
						'left', 'right', 'up', 'down', 'prevBlankLine', 'nextBlankLine',
						'wrappedLineStart', 'wrappedLineEnd', 'wrappedLineColumnCenter'
						'wrappedLineFirstNonWhitespaceCharacter', 'wrappedLineLastNonWhitespaceCharacter'
						'viewPortTop', 'viewPortCenter', 'viewPortBottom', 'viewPortIfOutside'
						\`\`\`
					* 'by': Unit to move. Default is computed based on 'to' value.
						\`\`\`
						'line', 'wrappedLine', 'character', 'halfLine'
						\`\`\`
					* 'value': Number of units to move. Default is '1'.
					* 'select': If 'true' makes the selection. Default is 'false'.
				`,
        constraint: e,
        schema: {
          type: "object",
          required: ["to"],
          properties: {
            to: {
              type: "string",
              enum: ["left", "right", "up", "down", "prevBlankLine", "nextBlankLine", "wrappedLineStart", "wrappedLineEnd", "wrappedLineColumnCenter", "wrappedLineFirstNonWhitespaceCharacter", "wrappedLineLastNonWhitespaceCharacter", "viewPortTop", "viewPortCenter", "viewPortBottom", "viewPortIfOutside"]
            },
            by: {
              type: "string",
              enum: ["line", "wrappedLine", "character", "halfLine"]
            },
            value: {
              type: "number",
              default: 1
            },
            select: {
              type: "boolean",
              default: !1
            }
          }
        }
      }
    ]
  }, i.RawDirection = {
    Left: "left",
    Right: "right",
    Up: "up",
    Down: "down",
    PrevBlankLine: "prevBlankLine",
    NextBlankLine: "nextBlankLine",
    WrappedLineStart: "wrappedLineStart",
    WrappedLineFirstNonWhitespaceCharacter: "wrappedLineFirstNonWhitespaceCharacter",
    WrappedLineColumnCenter: "wrappedLineColumnCenter",
    WrappedLineEnd: "wrappedLineEnd",
    WrappedLineLastNonWhitespaceCharacter: "wrappedLineLastNonWhitespaceCharacter",
    ViewPortTop: "viewPortTop",
    ViewPortCenter: "viewPortCenter",
    ViewPortBottom: "viewPortBottom",
    ViewPortIfOutside: "viewPortIfOutside"
  }, i.RawUnit = {
    Line: "line",
    WrappedLine: "wrappedLine",
    Character: "character",
    HalfLine: "halfLine"
  };
  function t(n) {
    if (!n.to)
      return null;
    let r;
    switch (n.to) {
      case i.RawDirection.Left:
        r = 0;
        break;
      case i.RawDirection.Right:
        r = 1;
        break;
      case i.RawDirection.Up:
        r = 2;
        break;
      case i.RawDirection.Down:
        r = 3;
        break;
      case i.RawDirection.PrevBlankLine:
        r = 4;
        break;
      case i.RawDirection.NextBlankLine:
        r = 5;
        break;
      case i.RawDirection.WrappedLineStart:
        r = 6;
        break;
      case i.RawDirection.WrappedLineFirstNonWhitespaceCharacter:
        r = 7;
        break;
      case i.RawDirection.WrappedLineColumnCenter:
        r = 8;
        break;
      case i.RawDirection.WrappedLineEnd:
        r = 9;
        break;
      case i.RawDirection.WrappedLineLastNonWhitespaceCharacter:
        r = 10;
        break;
      case i.RawDirection.ViewPortTop:
        r = 11;
        break;
      case i.RawDirection.ViewPortBottom:
        r = 13;
        break;
      case i.RawDirection.ViewPortCenter:
        r = 12;
        break;
      case i.RawDirection.ViewPortIfOutside:
        r = 14;
        break;
      default:
        return null;
    }
    let s = 0;
    switch (n.by) {
      case i.RawUnit.Line:
        s = 1;
        break;
      case i.RawUnit.WrappedLine:
        s = 2;
        break;
      case i.RawUnit.Character:
        s = 3;
        break;
      case i.RawUnit.HalfLine:
        s = 4;
        break;
    }
    return {
      direction: r,
      unit: s,
      select: !!n.select,
      value: n.value || 1
    };
  }
  i.parse = t;
})(pL || (pL = {}));
function Fv(i, e, t, n) {
  const r = kv(e, t.startLineNumber, t.startColumn), s = n.getLanguageConfiguration(r.languageId);
  if (!s)
    return null;
  const o = r.getLineContent(), a = o.substr(0, t.startColumn - 1 - r.firstCharOffset);
  let l;
  t.isEmpty() ? l = o.substr(t.startColumn - 1 - r.firstCharOffset) : l = kv(e, t.endLineNumber, t.endColumn).getLineContent().substr(t.endColumn - 1 - r.firstCharOffset);
  let c = "";
  if (t.startLineNumber > 1 && r.firstCharOffset === 0) {
    const p = kv(e, t.startLineNumber - 1);
    p.languageId === r.languageId && (c = p.getLineContent());
  }
  const d = s.onEnter(i, c, a, l);
  if (!d)
    return null;
  const u = d.indentAction;
  let h = d.appendText;
  const f = d.removeText || 0;
  h ? u === mr.Indent && (h = "	" + h) : u === mr.Indent || u === mr.IndentOutdent ? h = "	" : h = "";
  let g = lfe(e, t.startLineNumber, t.startColumn);
  return f && (g = g.substring(0, g.length - f)), {
    indentAction: u,
    appendText: h,
    removeText: f,
    indentation: g
  };
}
var uFe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, hFe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, z3;
const k6 = /* @__PURE__ */ Object.create(null);
function Sp(i, e) {
  if (e <= 0)
    return "";
  k6[i] || (k6[i] = ["", i]);
  const t = k6[i];
  for (let n = t.length; n <= e; n++)
    t[n] = t[n - 1] + i;
  return t[e];
}
let ol = z3 = class {
  static unshiftIndent(e, t, n, r, s) {
    const o = Lr.visibleColumnFromColumn(e, t, n);
    if (s) {
      const a = Sp(" ", r), c = Lr.prevIndentTabStop(o, r) / r;
      return Sp(a, c);
    } else {
      const a = "	", c = Lr.prevRenderTabStop(o, n) / n;
      return Sp(a, c);
    }
  }
  static shiftIndent(e, t, n, r, s) {
    const o = Lr.visibleColumnFromColumn(e, t, n);
    if (s) {
      const a = Sp(" ", r), c = Lr.nextIndentTabStop(o, r) / r;
      return Sp(a, c);
    } else {
      const a = "	", c = Lr.nextRenderTabStop(o, n) / n;
      return Sp(a, c);
    }
  }
  constructor(e, t, n) {
    this._languageConfigurationService = n, this._opts = t, this._selection = e, this._selectionId = null, this._useLastEditRangeForCursorEndPosition = !1, this._selectionStartColumnStaysPut = !1;
  }
  _addEditOperation(e, t, n) {
    this._useLastEditRangeForCursorEndPosition ? e.addTrackedEditOperation(t, n) : e.addEditOperation(t, n);
  }
  getEditOperations(e, t) {
    const n = this._selection.startLineNumber;
    let r = this._selection.endLineNumber;
    this._selection.endColumn === 1 && n !== r && (r = r - 1);
    const { tabSize: s, indentSize: o, insertSpaces: a } = this._opts, l = n === r;
    if (this._opts.useTabStops) {
      this._selection.isEmpty() && /^\s*$/.test(e.getLineContent(n)) && (this._useLastEditRangeForCursorEndPosition = !0);
      let c = 0, d = 0;
      for (let u = n; u <= r; u++, c = d) {
        d = 0;
        const h = e.getLineContent(u);
        let f = Js(h);
        if (this._opts.isUnshift && (h.length === 0 || f === 0) || !l && !this._opts.isUnshift && h.length === 0)
          continue;
        if (f === -1 && (f = h.length), u > 1 && Lr.visibleColumnFromColumn(h, f + 1, s) % o !== 0 && e.tokenization.isCheapToTokenize(u - 1)) {
          const m = Fv(this._opts.autoIndent, e, new V(u - 1, e.getLineMaxColumn(u - 1), u - 1, e.getLineMaxColumn(u - 1)), this._languageConfigurationService);
          if (m) {
            if (d = c, m.appendText)
              for (let _ = 0, b = m.appendText.length; _ < b && d < o && m.appendText.charCodeAt(_) === 32; _++)
                d++;
            m.removeText && (d = Math.max(0, d - m.removeText));
            for (let _ = 0; _ < d && !(f === 0 || h.charCodeAt(f - 1) !== 32); _++)
              f--;
          }
        }
        if (this._opts.isUnshift && f === 0)
          continue;
        let g;
        this._opts.isUnshift ? g = z3.unshiftIndent(h, f + 1, s, o, a) : g = z3.shiftIndent(h, f + 1, s, o, a), this._addEditOperation(t, new V(u, 1, u, f + 1), g), u === n && !this._selection.isEmpty() && (this._selectionStartColumnStaysPut = this._selection.startColumn <= f + 1);
      }
    } else {
      !this._opts.isUnshift && this._selection.isEmpty() && e.getLineLength(n) === 0 && (this._useLastEditRangeForCursorEndPosition = !0);
      const c = a ? Sp(" ", o) : "	";
      for (let d = n; d <= r; d++) {
        const u = e.getLineContent(d);
        let h = Js(u);
        if (!(this._opts.isUnshift && (u.length === 0 || h === 0)) && !(!l && !this._opts.isUnshift && u.length === 0) && (h === -1 && (h = u.length), !(this._opts.isUnshift && h === 0)))
          if (this._opts.isUnshift) {
            h = Math.min(h, o);
            for (let f = 0; f < h; f++)
              if (u.charCodeAt(f) === 9) {
                h = f + 1;
                break;
              }
            this._addEditOperation(t, new V(d, 1, d, h + 1), "");
          } else
            this._addEditOperation(t, new V(d, 1, d, 1), c), d === n && !this._selection.isEmpty() && (this._selectionStartColumnStaysPut = this._selection.startColumn === 1);
      }
    }
    this._selectionId = t.trackSelection(this._selection);
  }
  computeCursorState(e, t) {
    if (this._useLastEditRangeForCursorEndPosition) {
      const r = t.getInverseEditOperations()[0];
      return new ot(r.range.endLineNumber, r.range.endColumn, r.range.endLineNumber, r.range.endColumn);
    }
    const n = t.getTrackedSelection(this._selectionId);
    if (this._selectionStartColumnStaysPut) {
      const r = this._selection.startColumn;
      return n.startColumn <= r ? n : n.getDirection() === 0 ? new ot(n.startLineNumber, r, n.endLineNumber, n.endColumn) : new ot(n.endLineNumber, n.endColumn, n.startLineNumber, r);
    }
    return n;
  }
};
ol = z3 = uFe([
  hFe(2, Un)
], ol);
class fFe {
  constructor(e, t, n) {
    this._range = e, this._charBeforeSelection = t, this._charAfterSelection = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(new V(this._range.startLineNumber, this._range.startColumn, this._range.startLineNumber, this._range.startColumn), this._charBeforeSelection), t.addTrackedEditOperation(new V(this._range.endLineNumber, this._range.endColumn, this._range.endLineNumber, this._range.endColumn), this._charAfterSelection);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations(), r = n[0].range, s = n[1].range;
    return new ot(r.endLineNumber, r.endColumn, s.endLineNumber, s.endColumn - this._charAfterSelection.length);
  }
}
class gFe {
  constructor(e, t, n) {
    this._position = e, this._text = t, this._charAfter = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(new V(this._position.lineNumber, this._position.column, this._position.lineNumber, this._position.column), this._text + this._charAfter);
  }
  computeCursorState(e, t) {
    const r = t.getInverseEditOperations()[0].range;
    return new ot(r.endLineNumber, r.startColumn, r.endLineNumber, r.endColumn - this._charAfter.length);
  }
}
function pFe(i, e, t) {
  const n = i.tokenization.getLanguageIdAtPosition(e, 0);
  if (e > 1) {
    let r, s = -1;
    for (r = e - 1; r >= 1; r--) {
      if (i.tokenization.getLanguageIdAtPosition(r, 0) !== n)
        return s;
      const o = i.getLineContent(r);
      if (t.shouldIgnore(o) || /^\s+$/.test(o) || o === "") {
        s = r;
        continue;
      }
      return r;
    }
  }
  return -1;
}
function y4(i, e, t, n = !0, r) {
  if (i < 4)
    return null;
  const s = r.getLanguageConfiguration(e.tokenization.getLanguageId()).indentRulesSupport;
  if (!s)
    return null;
  if (t <= 1)
    return {
      indentation: "",
      action: null
    };
  for (let l = t - 1; l > 0 && e.getLineContent(l) === ""; l--)
    if (l === 1)
      return {
        indentation: "",
        action: null
      };
  const o = pFe(e, t, s);
  if (o < 0)
    return null;
  if (o < 1)
    return {
      indentation: "",
      action: null
    };
  const a = e.getLineContent(o);
  if (s.shouldIncrease(a) || s.shouldIndentNextLine(a))
    return {
      indentation: Hn(a),
      action: mr.Indent,
      line: o
    };
  if (s.shouldDecrease(a))
    return {
      indentation: Hn(a),
      action: null,
      line: o
    };
  {
    if (o === 1)
      return {
        indentation: Hn(e.getLineContent(o)),
        action: null,
        line: o
      };
    const l = o - 1, c = s.getIndentMetadata(e.getLineContent(l));
    if (!(c & 3) && c & 4) {
      let d = 0;
      for (let u = l - 1; u > 0; u--)
        if (!s.shouldIndentNextLine(e.getLineContent(u))) {
          d = u;
          break;
        }
      return {
        indentation: Hn(e.getLineContent(d + 1)),
        action: null,
        line: d + 1
      };
    }
    if (n)
      return {
        indentation: Hn(e.getLineContent(o)),
        action: null,
        line: o
      };
    for (let d = o; d > 0; d--) {
      const u = e.getLineContent(d);
      if (s.shouldIncrease(u))
        return {
          indentation: Hn(u),
          action: mr.Indent,
          line: d
        };
      if (s.shouldIndentNextLine(u)) {
        let h = 0;
        for (let f = d - 1; f > 0; f--)
          if (!s.shouldIndentNextLine(e.getLineContent(d))) {
            h = f;
            break;
          }
        return {
          indentation: Hn(e.getLineContent(h + 1)),
          action: null,
          line: h + 1
        };
      } else if (s.shouldDecrease(u))
        return {
          indentation: Hn(u),
          action: null,
          line: d
        };
    }
    return {
      indentation: Hn(e.getLineContent(1)),
      action: null,
      line: 1
    };
  }
}
function EC(i, e, t, n, r, s) {
  if (i < 4)
    return null;
  const o = s.getLanguageConfiguration(t);
  if (!o)
    return null;
  const a = s.getLanguageConfiguration(t).indentRulesSupport;
  if (!a)
    return null;
  const l = y4(i, e, n, void 0, s), c = e.getLineContent(n);
  if (l) {
    const d = l.line;
    if (d !== void 0) {
      let u = !0;
      for (let h = d; h < n - 1; h++)
        if (!/^\s*$/.test(e.getLineContent(h))) {
          u = !1;
          break;
        }
      if (u) {
        const h = o.onEnter(i, "", e.getLineContent(d), "");
        if (h) {
          let f = Hn(e.getLineContent(d));
          return h.removeText && (f = f.substring(0, f.length - h.removeText)), h.indentAction === mr.Indent || h.indentAction === mr.IndentOutdent ? f = r.shiftIndent(f) : h.indentAction === mr.Outdent && (f = r.unshiftIndent(f)), a.shouldDecrease(c) && (f = r.unshiftIndent(f)), h.appendText && (f += h.appendText), Hn(f);
        }
      }
    }
    return a.shouldDecrease(c) ? l.action === mr.Indent ? l.indentation : r.unshiftIndent(l.indentation) : l.action === mr.Indent ? r.shiftIndent(l.indentation) : l.indentation;
  }
  return null;
}
function mFe(i, e, t, n, r) {
  if (i < 4)
    return null;
  e.tokenization.forceTokenization(t.startLineNumber);
  const s = e.tokenization.getLineTokens(t.startLineNumber), o = o4(s, t.startColumn - 1), a = o.getLineContent();
  let l = !1, c;
  o.firstCharOffset > 0 && s.getLanguageId(0) !== o.languageId ? (l = !0, c = a.substr(0, t.startColumn - 1 - o.firstCharOffset)) : c = s.getLineContent().substring(0, t.startColumn - 1);
  let d;
  t.isEmpty() ? d = a.substr(t.startColumn - 1 - o.firstCharOffset) : d = kv(e, t.endLineNumber, t.endColumn).getLineContent().substr(t.endColumn - 1 - o.firstCharOffset);
  const u = r.getLanguageConfiguration(o.languageId).indentRulesSupport;
  if (!u)
    return null;
  const h = c, f = Hn(c), g = {
    tokenization: {
      getLineTokens: (b) => e.tokenization.getLineTokens(b),
      getLanguageId: () => e.getLanguageId(),
      getLanguageIdAtPosition: (b, w) => e.getLanguageIdAtPosition(b, w)
    },
    getLineContent: (b) => b === t.startLineNumber ? h : e.getLineContent(b)
  }, p = Hn(s.getLineContent()), m = y4(i, g, t.startLineNumber + 1, void 0, r);
  if (!m) {
    const b = l ? p : f;
    return {
      beforeEnter: b,
      afterEnter: b
    };
  }
  let _ = l ? p : m.indentation;
  return m.action === mr.Indent && (_ = n.shiftIndent(_)), u.shouldDecrease(d) && (_ = n.unshiftIndent(_)), {
    beforeEnter: l ? p : f,
    afterEnter: _
  };
}
function vFe(i, e, t, n, r, s) {
  if (i < 4)
    return null;
  const o = kv(e, t.startLineNumber, t.startColumn);
  if (o.firstCharOffset)
    return null;
  const a = s.getLanguageConfiguration(o.languageId).indentRulesSupport;
  if (!a)
    return null;
  const l = o.getLineContent(), c = l.substr(0, t.startColumn - 1 - o.firstCharOffset);
  let d;
  if (t.isEmpty() ? d = l.substr(t.startColumn - 1 - o.firstCharOffset) : d = kv(e, t.endLineNumber, t.endColumn).getLineContent().substr(t.endColumn - 1 - o.firstCharOffset), !a.shouldDecrease(c + d) && a.shouldDecrease(c + n + d)) {
    const u = y4(i, e, t.startLineNumber, !1, s);
    if (!u)
      return null;
    let h = u.indentation;
    return u.action !== mr.Indent && (h = r.unshiftIndent(h)), h;
  }
  return null;
}
function tge(i, e, t) {
  const n = t.getLanguageConfiguration(i.getLanguageId()).indentRulesSupport;
  return !n || e < 1 || e > i.getLineCount() ? null : n.getIndentMetadata(i.getLineContent(e));
}
class wi {
  static indent(e, t, n) {
    if (t === null || n === null)
      return [];
    const r = [];
    for (let s = 0, o = n.length; s < o; s++)
      r[s] = new ol(n[s], {
        isUnshift: !1,
        tabSize: e.tabSize,
        indentSize: e.indentSize,
        insertSpaces: e.insertSpaces,
        useTabStops: e.useTabStops,
        autoIndent: e.autoIndent
      }, e.languageConfigurationService);
    return r;
  }
  static outdent(e, t, n) {
    const r = [];
    for (let s = 0, o = n.length; s < o; s++)
      r[s] = new ol(n[s], {
        isUnshift: !0,
        tabSize: e.tabSize,
        indentSize: e.indentSize,
        insertSpaces: e.insertSpaces,
        useTabStops: e.useTabStops,
        autoIndent: e.autoIndent
      }, e.languageConfigurationService);
    return r;
  }
  static shiftIndent(e, t, n) {
    return n = n || 1, ol.shiftIndent(t, t.length + n, e.tabSize, e.indentSize, e.insertSpaces);
  }
  static unshiftIndent(e, t, n) {
    return n = n || 1, ol.unshiftIndent(t, t.length + n, e.tabSize, e.indentSize, e.insertSpaces);
  }
  static _distributedPaste(e, t, n, r) {
    const s = [];
    for (let o = 0, a = n.length; o < a; o++)
      s[o] = new vs(n[o], r[o]);
    return new Do(0, s, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !0
    });
  }
  static _simplePaste(e, t, n, r, s) {
    const o = [];
    for (let a = 0, l = n.length; a < l; a++) {
      const c = n[a], d = c.getPosition();
      if (s && !c.isEmpty() && (s = !1), s && r.indexOf(`
`) !== r.length - 1 && (s = !1), s) {
        const u = new V(d.lineNumber, 1, d.lineNumber, 1);
        o[a] = new Dz(u, r, c, !0);
      } else
        o[a] = new vs(c, r);
    }
    return new Do(0, o, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !0
    });
  }
  static _distributePasteToCursors(e, t, n, r, s) {
    if (r || t.length === 1)
      return null;
    if (s && s.length === t.length)
      return s;
    if (e.multiCursorPaste === "spread") {
      n.charCodeAt(n.length - 1) === 10 && (n = n.substr(0, n.length - 1)), n.charCodeAt(n.length - 1) === 13 && (n = n.substr(0, n.length - 1));
      const o = Cu(n);
      if (o.length === t.length)
        return o;
    }
    return null;
  }
  static paste(e, t, n, r, s, o) {
    const a = this._distributePasteToCursors(e, n, r, s, o);
    return a ? (n = n.sort(V.compareRangesUsingStarts), this._distributedPaste(e, t, n, a)) : this._simplePaste(e, t, n, r, s);
  }
  static _goodIndentForLine(e, t, n) {
    let r = null, s = "";
    const o = y4(e.autoIndent, t, n, !1, e.languageConfigurationService);
    if (o)
      r = o.action, s = o.indentation;
    else if (n > 1) {
      let a;
      for (a = n - 1; a >= 1; a--) {
        const d = t.getLineContent(a);
        if (Jc(d) >= 0)
          break;
      }
      if (a < 1)
        return null;
      const l = t.getLineMaxColumn(a), c = Fv(e.autoIndent, t, new V(a, l, a, l), e.languageConfigurationService);
      c && (s = c.indentation + c.appendText);
    }
    return r && (r === mr.Indent && (s = wi.shiftIndent(e, s)), r === mr.Outdent && (s = wi.unshiftIndent(e, s)), s = e.normalizeIndentation(s)), s || null;
  }
  static _replaceJumpToNextIndent(e, t, n, r) {
    let s = "";
    const o = n.getStartPosition();
    if (e.insertSpaces) {
      const a = e.visibleColumnFromColumn(t, o), l = e.indentSize, c = l - a % l;
      for (let d = 0; d < c; d++)
        s += " ";
    } else
      s = "	";
    return new vs(n, s, r);
  }
  static tab(e, t, n) {
    const r = [];
    for (let s = 0, o = n.length; s < o; s++) {
      const a = n[s];
      if (a.isEmpty()) {
        const l = t.getLineContent(a.startLineNumber);
        if (/^\s*$/.test(l) && t.tokenization.isCheapToTokenize(a.startLineNumber)) {
          let c = this._goodIndentForLine(e, t, a.startLineNumber);
          c = c || "	";
          const d = e.normalizeIndentation(c);
          if (!l.startsWith(d)) {
            r[s] = new vs(new V(a.startLineNumber, 1, a.startLineNumber, l.length + 1), d, !0);
            continue;
          }
        }
        r[s] = this._replaceJumpToNextIndent(e, t, a, !0);
      } else {
        if (a.startLineNumber === a.endLineNumber) {
          const l = t.getLineMaxColumn(a.startLineNumber);
          if (a.startColumn !== 1 || a.endColumn !== l) {
            r[s] = this._replaceJumpToNextIndent(e, t, a, !1);
            continue;
          }
        }
        r[s] = new ol(a, {
          isUnshift: !1,
          tabSize: e.tabSize,
          indentSize: e.indentSize,
          insertSpaces: e.insertSpaces,
          useTabStops: e.useTabStops,
          autoIndent: e.autoIndent
        }, e.languageConfigurationService);
      }
    }
    return r;
  }
  static compositionType(e, t, n, r, s, o, a, l) {
    const c = r.map((d) => this._compositionType(n, d, s, o, a, l));
    return new Do(4, c, {
      shouldPushStackElementBefore: Jx(
        e,
        4
        /* EditOperationType.TypingOther */
      ),
      shouldPushStackElementAfter: !1
    });
  }
  static _compositionType(e, t, n, r, s, o) {
    if (!t.isEmpty())
      return null;
    const a = t.getPosition(), l = Math.max(1, a.column - r), c = Math.min(e.getLineMaxColumn(a.lineNumber), a.column + s), d = new V(a.lineNumber, l, a.lineNumber, c);
    return e.getValueInRange(d) === n && o === 0 ? null : new j3(d, n, 0, o);
  }
  static _typeCommand(e, t, n) {
    return n ? new Zx(e, t, !0) : new vs(e, t, !0);
  }
  static _enter(e, t, n, r) {
    if (e.autoIndent === 0)
      return wi._typeCommand(r, `
`, n);
    if (!t.tokenization.isCheapToTokenize(r.getStartPosition().lineNumber) || e.autoIndent === 1) {
      const l = t.getLineContent(r.startLineNumber), c = Hn(l).substring(0, r.startColumn - 1);
      return wi._typeCommand(r, `
` + e.normalizeIndentation(c), n);
    }
    const s = Fv(e.autoIndent, t, r, e.languageConfigurationService);
    if (s) {
      if (s.indentAction === mr.None)
        return wi._typeCommand(r, `
` + e.normalizeIndentation(s.indentation + s.appendText), n);
      if (s.indentAction === mr.Indent)
        return wi._typeCommand(r, `
` + e.normalizeIndentation(s.indentation + s.appendText), n);
      if (s.indentAction === mr.IndentOutdent) {
        const l = e.normalizeIndentation(s.indentation), c = e.normalizeIndentation(s.indentation + s.appendText), d = `
` + c + `
` + l;
        return n ? new Zx(r, d, !0) : new j3(r, d, -1, c.length - l.length, !0);
      } else if (s.indentAction === mr.Outdent) {
        const l = wi.unshiftIndent(e, s.indentation);
        return wi._typeCommand(r, `
` + e.normalizeIndentation(l + s.appendText), n);
      }
    }
    const o = t.getLineContent(r.startLineNumber), a = Hn(o).substring(0, r.startColumn - 1);
    if (e.autoIndent >= 4) {
      const l = mFe(e.autoIndent, t, r, {
        unshiftIndent: (c) => wi.unshiftIndent(e, c),
        shiftIndent: (c) => wi.shiftIndent(e, c),
        normalizeIndentation: (c) => e.normalizeIndentation(c)
      }, e.languageConfigurationService);
      if (l) {
        let c = e.visibleColumnFromColumn(t, r.getEndPosition());
        const d = r.endColumn, u = t.getLineContent(r.endLineNumber), h = Js(u);
        if (h >= 0 ? r = r.setEndPosition(r.endLineNumber, Math.max(r.endColumn, h + 1)) : r = r.setEndPosition(r.endLineNumber, t.getLineMaxColumn(r.endLineNumber)), n)
          return new Zx(r, `
` + e.normalizeIndentation(l.afterEnter), !0);
        {
          let f = 0;
          return d <= h + 1 && (e.insertSpaces || (c = Math.ceil(c / e.indentSize)), f = Math.min(c + 1 - e.normalizeIndentation(l.afterEnter).length - 1, 0)), new j3(r, `
` + e.normalizeIndentation(l.afterEnter), 0, f, !0);
        }
      }
    }
    return wi._typeCommand(r, `
` + e.normalizeIndentation(a), n);
  }
  static _isAutoIndentType(e, t, n) {
    if (e.autoIndent < 4)
      return !1;
    for (let r = 0, s = n.length; r < s; r++)
      if (!t.tokenization.isCheapToTokenize(n[r].getEndPosition().lineNumber))
        return !1;
    return !0;
  }
  static _runAutoIndentType(e, t, n, r) {
    const s = lfe(t, n.startLineNumber, n.startColumn), o = vFe(e.autoIndent, t, n, r, {
      shiftIndent: (a) => wi.shiftIndent(e, a),
      unshiftIndent: (a) => wi.unshiftIndent(e, a)
    }, e.languageConfigurationService);
    if (o === null)
      return null;
    if (o !== e.normalizeIndentation(s)) {
      const a = t.getLineFirstNonWhitespaceColumn(n.startLineNumber);
      return a === 0 ? wi._typeCommand(new V(n.startLineNumber, 1, n.endLineNumber, n.endColumn), e.normalizeIndentation(o) + r, !1) : wi._typeCommand(new V(n.startLineNumber, 1, n.endLineNumber, n.endColumn), e.normalizeIndentation(o) + t.getLineContent(n.startLineNumber).substring(a - 1, n.startColumn - 1) + r, !1);
    }
    return null;
  }
  static _isAutoClosingOvertype(e, t, n, r, s) {
    if (e.autoClosingOvertype === "never" || !e.autoClosingPairs.autoClosingPairsCloseSingleChar.has(s))
      return !1;
    for (let o = 0, a = n.length; o < a; o++) {
      const l = n[o];
      if (!l.isEmpty())
        return !1;
      const c = l.getPosition(), d = t.getLineContent(c.lineNumber);
      if (d.charAt(c.column - 1) !== s)
        return !1;
      const h = kf(s);
      if ((c.column > 2 ? d.charCodeAt(c.column - 2) : 0) === 92 && h)
        return !1;
      if (e.autoClosingOvertype === "auto") {
        let g = !1;
        for (let p = 0, m = r.length; p < m; p++) {
          const _ = r[p];
          if (c.lineNumber === _.startLineNumber && c.column === _.startColumn) {
            g = !0;
            break;
          }
        }
        if (!g)
          return !1;
      }
    }
    return !0;
  }
  static _runAutoClosingOvertype(e, t, n, r, s) {
    const o = [];
    for (let a = 0, l = r.length; a < l; a++) {
      const d = r[a].getPosition(), u = new V(d.lineNumber, d.column, d.lineNumber, d.column + 1);
      o[a] = new vs(u, s);
    }
    return new Do(4, o, {
      shouldPushStackElementBefore: Jx(
        e,
        4
        /* EditOperationType.TypingOther */
      ),
      shouldPushStackElementAfter: !1
    });
  }
  static _isBeforeClosingBrace(e, t) {
    const n = t.charAt(0), r = e.autoClosingPairs.autoClosingPairsOpenByStart.get(n) || [], s = e.autoClosingPairs.autoClosingPairsCloseByStart.get(n) || [], o = r.some((l) => t.startsWith(l.open)), a = s.some((l) => t.startsWith(l.close));
    return !o && a;
  }
  /**
   * Determine if typing `ch` at all `positions` in the `model` results in an
   * auto closing open sequence being typed.
   *
   * Auto closing open sequences can consist of multiple characters, which
   * can lead to ambiguities. In such a case, the longest auto-closing open
   * sequence is returned.
   */
  static _findAutoClosingPairOpen(e, t, n, r) {
    const s = e.autoClosingPairs.autoClosingPairsOpenByEnd.get(r);
    if (!s)
      return null;
    let o = null;
    for (const a of s)
      if (o === null || a.open.length > o.open.length) {
        let l = !0;
        for (const c of n)
          if (t.getValueInRange(new V(c.lineNumber, c.column - a.open.length + 1, c.lineNumber, c.column)) + r !== a.open) {
            l = !1;
            break;
          }
        l && (o = a);
      }
    return o;
  }
  /**
   * Find another auto-closing pair that is contained by the one passed in.
   *
   * e.g. when having [(,)] and [(*,*)] as auto-closing pairs
   * this method will find [(,)] as a containment pair for [(*,*)]
   */
  static _findContainedAutoClosingPair(e, t) {
    if (t.open.length <= 1)
      return null;
    const n = t.close.charAt(t.close.length - 1), r = e.autoClosingPairs.autoClosingPairsCloseByEnd.get(n) || [];
    let s = null;
    for (const o of r)
      o.open !== t.open && t.open.includes(o.open) && t.close.endsWith(o.close) && (!s || o.open.length > s.open.length) && (s = o);
    return s;
  }
  static _getAutoClosingPairClose(e, t, n, r, s) {
    for (const g of n)
      if (!g.isEmpty())
        return null;
    const o = n.map((g) => {
      const p = g.getPosition();
      return s ? { lineNumber: p.lineNumber, beforeColumn: p.column - r.length, afterColumn: p.column } : { lineNumber: p.lineNumber, beforeColumn: p.column, afterColumn: p.column };
    }), a = this._findAutoClosingPairOpen(e, t, o.map((g) => new ve(g.lineNumber, g.beforeColumn)), r);
    if (!a)
      return null;
    let l, c;
    if (kf(r) ? (l = e.autoClosingQuotes, c = e.shouldAutoCloseBefore.quote) : (e.blockCommentStartToken ? a.open.includes(e.blockCommentStartToken) : !1) ? (l = e.autoClosingComments, c = e.shouldAutoCloseBefore.comment) : (l = e.autoClosingBrackets, c = e.shouldAutoCloseBefore.bracket), l === "never")
      return null;
    const u = this._findContainedAutoClosingPair(e, a), h = u ? u.close : "";
    let f = !0;
    for (const g of o) {
      const { lineNumber: p, beforeColumn: m, afterColumn: _ } = g, b = t.getLineContent(p), w = b.substring(0, m - 1), y = b.substring(_ - 1);
      if (y.startsWith(h) || (f = !1), y.length > 0) {
        const E = y.charAt(0);
        if (!wi._isBeforeClosingBrace(e, y) && !c(E))
          return null;
      }
      if (a.open.length === 1 && (r === "'" || r === '"') && l !== "always") {
        const E = wl(e.wordSeparators);
        if (w.length > 0) {
          const L = w.charCodeAt(w.length - 1);
          if (E.get(L) === 0)
            return null;
        }
      }
      if (!t.tokenization.isCheapToTokenize(p))
        return null;
      t.tokenization.forceTokenization(p);
      const S = t.tokenization.getLineTokens(p), x = o4(S, m - 1);
      if (!a.shouldAutoClose(x, m - x.firstCharOffset))
        return null;
      const D = a.findNeutralCharacter();
      if (D) {
        const E = t.tokenization.getTokenTypeIfInsertingCharacter(p, m, D);
        if (!a.isOK(E))
          return null;
      }
    }
    return f ? a.close.substring(0, a.close.length - h.length) : a.close;
  }
  static _runAutoClosingOpenCharType(e, t, n, r, s, o, a) {
    const l = [];
    for (let c = 0, d = r.length; c < d; c++) {
      const u = r[c];
      l[c] = new nge(u, s, !o, a);
    }
    return new Do(4, l, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !1
    });
  }
  static _shouldSurroundChar(e, t) {
    return kf(t) ? e.autoSurround === "quotes" || e.autoSurround === "languageDefined" : e.autoSurround === "brackets" || e.autoSurround === "languageDefined";
  }
  static _isSurroundSelectionType(e, t, n, r) {
    if (!wi._shouldSurroundChar(e, r) || !e.surroundingPairs.hasOwnProperty(r))
      return !1;
    const s = kf(r);
    for (const o of n) {
      if (o.isEmpty())
        return !1;
      let a = !0;
      for (let l = o.startLineNumber; l <= o.endLineNumber; l++) {
        const c = t.getLineContent(l), d = l === o.startLineNumber ? o.startColumn - 1 : 0, u = l === o.endLineNumber ? o.endColumn - 1 : c.length, h = c.substring(d, u);
        if (/[^ \t]/.test(h)) {
          a = !1;
          break;
        }
      }
      if (a)
        return !1;
      if (s && o.startLineNumber === o.endLineNumber && o.startColumn + 1 === o.endColumn) {
        const l = t.getValueInRange(o);
        if (kf(l))
          return !1;
      }
    }
    return !0;
  }
  static _runSurroundSelectionType(e, t, n, r, s) {
    const o = [];
    for (let a = 0, l = r.length; a < l; a++) {
      const c = r[a], d = t.surroundingPairs[s];
      o[a] = new fFe(c, s, d);
    }
    return new Do(0, o, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !0
    });
  }
  static _isTypeInterceptorElectricChar(e, t, n) {
    return !!(n.length === 1 && t.tokenization.isCheapToTokenize(n[0].getEndPosition().lineNumber));
  }
  static _typeInterceptorElectricChar(e, t, n, r, s) {
    if (!t.electricChars.hasOwnProperty(s) || !r.isEmpty())
      return null;
    const o = r.getPosition();
    n.tokenization.forceTokenization(o.lineNumber);
    const a = n.tokenization.getLineTokens(o.lineNumber);
    let l;
    try {
      l = t.onElectricCharacter(s, a, o.column);
    } catch (c) {
      return It(c), null;
    }
    if (!l)
      return null;
    if (l.matchOpenBracket) {
      const c = (a.getLineContent() + s).lastIndexOf(l.matchOpenBracket) + 1, d = n.bracketPairs.findMatchingBracketUp(
        l.matchOpenBracket,
        {
          lineNumber: o.lineNumber,
          column: c
        },
        500
        /* give at most 500ms to compute */
      );
      if (d) {
        if (d.startLineNumber === o.lineNumber)
          return null;
        const u = n.getLineContent(d.startLineNumber), h = Hn(u), f = t.normalizeIndentation(h), g = n.getLineContent(o.lineNumber), p = n.getLineFirstNonWhitespaceColumn(o.lineNumber) || o.column, m = g.substring(p - 1, o.column - 1), _ = f + m + s, b = new V(o.lineNumber, 1, o.lineNumber, o.column), w = new vs(b, _);
        return new Do(T6(_, e), [w], {
          shouldPushStackElementBefore: !1,
          shouldPushStackElementAfter: !0
        });
      }
    }
    return null;
  }
  /**
   * This is very similar with typing, but the character is already in the text buffer!
   */
  static compositionEndWithInterceptors(e, t, n, r, s, o) {
    if (!r)
      return null;
    let a = null;
    for (const u of r)
      if (a === null)
        a = u.insertedText;
      else if (a !== u.insertedText)
        return null;
    if (!a || a.length !== 1)
      return null;
    const l = a;
    let c = !1;
    for (const u of r)
      if (u.deletedText.length !== 0) {
        c = !0;
        break;
      }
    if (c) {
      if (!wi._shouldSurroundChar(t, l) || !t.surroundingPairs.hasOwnProperty(l))
        return null;
      const u = kf(l);
      for (const g of r)
        if (g.deletedSelectionStart !== 0 || g.deletedSelectionEnd !== g.deletedText.length || /^[ \t]+$/.test(g.deletedText) || u && kf(g.deletedText))
          return null;
      const h = [];
      for (const g of s) {
        if (!g.isEmpty())
          return null;
        h.push(g.getPosition());
      }
      if (h.length !== r.length)
        return null;
      const f = [];
      for (let g = 0, p = h.length; g < p; g++)
        f.push(new gFe(h[g], r[g].deletedText, t.surroundingPairs[l]));
      return new Do(4, f, {
        shouldPushStackElementBefore: !0,
        shouldPushStackElementAfter: !1
      });
    }
    if (this._isAutoClosingOvertype(t, n, s, o, l)) {
      const u = s.map((h) => new vs(new V(h.positionLineNumber, h.positionColumn, h.positionLineNumber, h.positionColumn + 1), "", !1));
      return new Do(4, u, {
        shouldPushStackElementBefore: !0,
        shouldPushStackElementAfter: !1
      });
    }
    const d = this._getAutoClosingPairClose(t, n, s, l, !0);
    return d !== null ? this._runAutoClosingOpenCharType(e, t, n, s, l, !0, d) : null;
  }
  static typeWithInterceptors(e, t, n, r, s, o, a) {
    if (!e && a === `
`) {
      const d = [];
      for (let u = 0, h = s.length; u < h; u++)
        d[u] = wi._enter(n, r, !1, s[u]);
      return new Do(4, d, {
        shouldPushStackElementBefore: !0,
        shouldPushStackElementAfter: !1
      });
    }
    if (!e && this._isAutoIndentType(n, r, s)) {
      const d = [];
      let u = !1;
      for (let h = 0, f = s.length; h < f; h++)
        if (d[h] = this._runAutoIndentType(n, r, s[h], a), !d[h]) {
          u = !0;
          break;
        }
      if (!u)
        return new Do(4, d, {
          shouldPushStackElementBefore: !0,
          shouldPushStackElementAfter: !1
        });
    }
    if (this._isAutoClosingOvertype(n, r, s, o, a))
      return this._runAutoClosingOvertype(t, n, r, s, a);
    if (!e) {
      const d = this._getAutoClosingPairClose(n, r, s, a, !1);
      if (d)
        return this._runAutoClosingOpenCharType(t, n, r, s, a, !1, d);
    }
    if (!e && this._isSurroundSelectionType(n, r, s, a))
      return this._runSurroundSelectionType(t, n, r, s, a);
    if (!e && this._isTypeInterceptorElectricChar(n, r, s)) {
      const d = this._typeInterceptorElectricChar(t, n, r, s[0], a);
      if (d)
        return d;
    }
    const l = [];
    for (let d = 0, u = s.length; d < u; d++)
      l[d] = new vs(s[d], a);
    const c = T6(a, t);
    return new Do(c, l, {
      shouldPushStackElementBefore: Jx(t, c),
      shouldPushStackElementAfter: !1
    });
  }
  static typeWithoutInterceptors(e, t, n, r, s) {
    const o = [];
    for (let l = 0, c = r.length; l < c; l++)
      o[l] = new vs(r[l], s);
    const a = T6(s, e);
    return new Do(a, o, {
      shouldPushStackElementBefore: Jx(e, a),
      shouldPushStackElementAfter: !1
    });
  }
  static lineInsertBefore(e, t, n) {
    if (t === null || n === null)
      return [];
    const r = [];
    for (let s = 0, o = n.length; s < o; s++) {
      let a = n[s].positionLineNumber;
      if (a === 1)
        r[s] = new Zx(new V(1, 1, 1, 1), `
`);
      else {
        a--;
        const l = t.getLineMaxColumn(a);
        r[s] = this._enter(e, t, !1, new V(a, l, a, l));
      }
    }
    return r;
  }
  static lineInsertAfter(e, t, n) {
    if (t === null || n === null)
      return [];
    const r = [];
    for (let s = 0, o = n.length; s < o; s++) {
      const a = n[s].positionLineNumber, l = t.getLineMaxColumn(a);
      r[s] = this._enter(e, t, !1, new V(a, l, a, l));
    }
    return r;
  }
  static lineBreakInsert(e, t, n) {
    const r = [];
    for (let s = 0, o = n.length; s < o; s++)
      r[s] = this._enter(e, t, !0, n[s]);
    return r;
  }
}
class nge extends j3 {
  constructor(e, t, n, r) {
    super(e, (n ? t : "") + r, 0, -r.length), this._openCharacter = t, this._closeCharacter = r, this.closeCharacterRange = null, this.enclosingRange = null;
  }
  computeCursorState(e, t) {
    const r = t.getInverseEditOperations()[0].range;
    return this.closeCharacterRange = new V(r.startLineNumber, r.endColumn - this._closeCharacter.length, r.endLineNumber, r.endColumn), this.enclosingRange = new V(r.startLineNumber, r.endColumn - this._openCharacter.length - this._closeCharacter.length, r.endLineNumber, r.endColumn), super.computeCursorState(e, t);
  }
}
class _Fe {
  constructor(e, t, n, r, s, o) {
    this.deletedText = e, this.deletedSelectionStart = t, this.deletedSelectionEnd = n, this.insertedText = r, this.insertedSelectionStart = s, this.insertedSelectionEnd = o;
  }
}
function T6(i, e) {
  return i === " " ? e === 5 || e === 6 ? 6 : 5 : 4;
}
function Jx(i, e) {
  return IZ(i) && !IZ(e) ? !0 : i === 5 ? !1 : LZ(i) !== LZ(e);
}
function LZ(i) {
  return i === 6 || i === 5 ? "space" : i;
}
function IZ(i) {
  return i === 4 || i === 5 || i === 6;
}
var $;
(function(i) {
  i.editorSimpleInput = new Ke("editorSimpleInput", !1, !0), i.editorTextFocus = new Ke("editorTextFocus", !1, C("editorTextFocus", "Whether the editor text has focus (cursor is blinking)")), i.focus = new Ke("editorFocus", !1, C("editorFocus", "Whether the editor or an editor widget has focus (e.g. focus is in the find widget)")), i.textInputFocus = new Ke("textInputFocus", !1, C("textInputFocus", "Whether an editor or a rich text input has focus (cursor is blinking)")), i.readOnly = new Ke("editorReadonly", !1, C("editorReadonly", "Whether the editor is read-only")), i.inDiffEditor = new Ke("inDiffEditor", !1, C("inDiffEditor", "Whether the context is a diff editor")), i.isEmbeddedDiffEditor = new Ke("isEmbeddedDiffEditor", !1, C("isEmbeddedDiffEditor", "Whether the context is an embedded diff editor")), i.comparingMovedCode = new Ke("comparingMovedCode", !1, C("comparingMovedCode", "Whether a moved code block is selected for comparison")), i.accessibleDiffViewerVisible = new Ke("accessibleDiffViewerVisible", !1, C("accessibleDiffViewerVisible", "Whether the accessible diff viewer is visible")), i.diffEditorRenderSideBySideInlineBreakpointReached = new Ke("diffEditorRenderSideBySideInlineBreakpointReached", !1, C("diffEditorRenderSideBySideInlineBreakpointReached", "Whether the diff editor render side by side inline breakpoint is reached")), i.columnSelection = new Ke("editorColumnSelection", !1, C("editorColumnSelection", "Whether `editor.columnSelection` is enabled")), i.writable = i.readOnly.toNegated(), i.hasNonEmptySelection = new Ke("editorHasSelection", !1, C("editorHasSelection", "Whether the editor has text selected")), i.hasOnlyEmptySelection = i.hasNonEmptySelection.toNegated(), i.hasMultipleSelections = new Ke("editorHasMultipleSelections", !1, C("editorHasMultipleSelections", "Whether the editor has multiple selections")), i.hasSingleSelection = i.hasMultipleSelections.toNegated(), i.tabMovesFocus = new Ke("editorTabMovesFocus", !1, C("editorTabMovesFocus", "Whether `Tab` will move focus out of the editor")), i.tabDoesNotMoveFocus = i.tabMovesFocus.toNegated(), i.isInWalkThroughSnippet = new Ke("isInEmbeddedEditor", !1, !0), i.canUndo = new Ke("canUndo", !1, !0), i.canRedo = new Ke("canRedo", !1, !0), i.hoverVisible = new Ke("editorHoverVisible", !1, C("editorHoverVisible", "Whether the editor hover is visible")), i.hoverFocused = new Ke("editorHoverFocused", !1, C("editorHoverFocused", "Whether the editor hover is focused")), i.stickyScrollFocused = new Ke("stickyScrollFocused", !1, C("stickyScrollFocused", "Whether the sticky scroll is focused")), i.stickyScrollVisible = new Ke("stickyScrollVisible", !1, C("stickyScrollVisible", "Whether the sticky scroll is visible")), i.standaloneColorPickerVisible = new Ke("standaloneColorPickerVisible", !1, C("standaloneColorPickerVisible", "Whether the standalone color picker is visible")), i.standaloneColorPickerFocused = new Ke("standaloneColorPickerFocused", !1, C("standaloneColorPickerFocused", "Whether the standalone color picker is focused")), i.inCompositeEditor = new Ke("inCompositeEditor", void 0, C("inCompositeEditor", "Whether the editor is part of a larger editor (e.g. notebooks)")), i.notInCompositeEditor = i.inCompositeEditor.toNegated(), i.languageId = new Ke("editorLangId", "", C("editorLangId", "The language identifier of the editor")), i.hasCompletionItemProvider = new Ke("editorHasCompletionItemProvider", !1, C("editorHasCompletionItemProvider", "Whether the editor has a completion item provider")), i.hasCodeActionsProvider = new Ke("editorHasCodeActionsProvider", !1, C("editorHasCodeActionsProvider", "Whether the editor has a code actions provider")), i.hasCodeLensProvider = new Ke("editorHasCodeLensProvider", !1, C("editorHasCodeLensProvider", "Whether the editor has a code lens provider")), i.hasDefinitionProvider = new Ke("editorHasDefinitionProvider", !1, C("editorHasDefinitionProvider", "Whether the editor has a definition provider")), i.hasDeclarationProvider = new Ke("editorHasDeclarationProvider", !1, C("editorHasDeclarationProvider", "Whether the editor has a declaration provider")), i.hasImplementationProvider = new Ke("editorHasImplementationProvider", !1, C("editorHasImplementationProvider", "Whether the editor has an implementation provider")), i.hasTypeDefinitionProvider = new Ke("editorHasTypeDefinitionProvider", !1, C("editorHasTypeDefinitionProvider", "Whether the editor has a type definition provider")), i.hasHoverProvider = new Ke("editorHasHoverProvider", !1, C("editorHasHoverProvider", "Whether the editor has a hover provider")), i.hasDocumentHighlightProvider = new Ke("editorHasDocumentHighlightProvider", !1, C("editorHasDocumentHighlightProvider", "Whether the editor has a document highlight provider")), i.hasDocumentSymbolProvider = new Ke("editorHasDocumentSymbolProvider", !1, C("editorHasDocumentSymbolProvider", "Whether the editor has a document symbol provider")), i.hasReferenceProvider = new Ke("editorHasReferenceProvider", !1, C("editorHasReferenceProvider", "Whether the editor has a reference provider")), i.hasRenameProvider = new Ke("editorHasRenameProvider", !1, C("editorHasRenameProvider", "Whether the editor has a rename provider")), i.hasSignatureHelpProvider = new Ke("editorHasSignatureHelpProvider", !1, C("editorHasSignatureHelpProvider", "Whether the editor has a signature help provider")), i.hasInlayHintsProvider = new Ke("editorHasInlayHintsProvider", !1, C("editorHasInlayHintsProvider", "Whether the editor has an inline hints provider")), i.hasDocumentFormattingProvider = new Ke("editorHasDocumentFormattingProvider", !1, C("editorHasDocumentFormattingProvider", "Whether the editor has a document formatting provider")), i.hasDocumentSelectionFormattingProvider = new Ke("editorHasDocumentSelectionFormattingProvider", !1, C("editorHasDocumentSelectionFormattingProvider", "Whether the editor has a document selection formatting provider")), i.hasMultipleDocumentFormattingProvider = new Ke("editorHasMultipleDocumentFormattingProvider", !1, C("editorHasMultipleDocumentFormattingProvider", "Whether the editor has multiple document formatting providers")), i.hasMultipleDocumentSelectionFormattingProvider = new Ke("editorHasMultipleDocumentSelectionFormattingProvider", !1, C("editorHasMultipleDocumentSelectionFormattingProvider", "Whether the editor has multiple document selection formatting providers"));
})($ || ($ = {}));
const bn = 0;
class Vi extends Kr {
  runEditorCommand(e, t, n) {
    const r = t._getViewModel();
    r && this.runCoreEditorCommand(r, n || {});
  }
}
var gs;
(function(i) {
  const e = function(n) {
    if (!ho(n))
      return !1;
    const r = n;
    return !(!mo(r.to) || !Jo(r.by) && !mo(r.by) || !Jo(r.value) && !Tg(r.value) || !Jo(r.revealCursor) && !Mue(r.revealCursor));
  };
  i.description = {
    description: "Scroll editor in the given direction",
    args: [
      {
        name: "Editor scroll argument object",
        description: "Property-value pairs that can be passed through this argument:\n					* 'to': A mandatory direction value.\n						```\n						'up', 'down'\n						```\n					* 'by': Unit to move. Default is computed based on 'to' value.\n						```\n						'line', 'wrappedLine', 'page', 'halfPage', 'editor'\n						```\n					* 'value': Number of units to move. Default is '1'.\n					* 'revealCursor': If 'true' reveals the cursor if it is outside view port.\n				",
        constraint: e,
        schema: {
          type: "object",
          required: ["to"],
          properties: {
            to: {
              type: "string",
              enum: ["up", "down"]
            },
            by: {
              type: "string",
              enum: ["line", "wrappedLine", "page", "halfPage", "editor"]
            },
            value: {
              type: "number",
              default: 1
            },
            revealCursor: {
              type: "boolean"
            }
          }
        }
      }
    ]
  }, i.RawDirection = {
    Up: "up",
    Right: "right",
    Down: "down",
    Left: "left"
  }, i.RawUnit = {
    Line: "line",
    WrappedLine: "wrappedLine",
    Page: "page",
    HalfPage: "halfPage",
    Editor: "editor",
    Column: "column"
  };
  function t(n) {
    let r;
    switch (n.to) {
      case i.RawDirection.Up:
        r = 1;
        break;
      case i.RawDirection.Right:
        r = 2;
        break;
      case i.RawDirection.Down:
        r = 3;
        break;
      case i.RawDirection.Left:
        r = 4;
        break;
      default:
        return null;
    }
    let s;
    switch (n.by) {
      case i.RawUnit.Line:
        s = 1;
        break;
      case i.RawUnit.WrappedLine:
        s = 2;
        break;
      case i.RawUnit.Page:
        s = 3;
        break;
      case i.RawUnit.HalfPage:
        s = 4;
        break;
      case i.RawUnit.Editor:
        s = 5;
        break;
      case i.RawUnit.Column:
        s = 6;
        break;
      default:
        s = 2;
    }
    const o = Math.floor(n.value || 1), a = !!n.revealCursor;
    return {
      direction: r,
      unit: s,
      value: o,
      revealCursor: a,
      select: !!n.select
    };
  }
  i.parse = t;
})(gs || (gs = {}));
var sv;
(function(i) {
  const e = function(t) {
    if (!ho(t))
      return !1;
    const n = t;
    return !(!Tg(n.lineNumber) && !mo(n.lineNumber) || !Jo(n.at) && !mo(n.at));
  };
  i.description = {
    description: "Reveal the given line at the given logical position",
    args: [
      {
        name: "Reveal line argument object",
        description: "Property-value pairs that can be passed through this argument:\n					* 'lineNumber': A mandatory line number value.\n					* 'at': Logical position at which line has to be revealed.\n						```\n						'top', 'center', 'bottom'\n						```\n				",
        constraint: e,
        schema: {
          type: "object",
          required: ["lineNumber"],
          properties: {
            lineNumber: {
              type: ["number", "string"]
            },
            at: {
              type: "string",
              enum: ["top", "center", "bottom"]
            }
          }
        }
      }
    ]
  }, i.RawAtArgument = {
    Top: "top",
    Center: "center",
    Bottom: "bottom"
  };
})(sv || (sv = {}));
class MF {
  constructor(e) {
    e.addImplementation(1e4, "code-editor", (t, n) => {
      const r = t.get(Sn).getFocusedCodeEditor();
      return r && r.hasTextFocus() ? this._runEditorCommand(t, r, n) : !1;
    }), e.addImplementation(1e3, "generic-dom-input-textarea", (t, n) => {
      const r = Jl();
      return r && ["input", "textarea"].indexOf(r.tagName.toLowerCase()) >= 0 ? (this.runDOMCommand(r), !0) : !1;
    }), e.addImplementation(0, "generic-dom", (t, n) => {
      const r = t.get(Sn).getActiveCodeEditor();
      return r ? (r.focus(), this._runEditorCommand(t, r, n)) : !1;
    });
  }
  _runEditorCommand(e, t, n) {
    const r = this.runEditorCommand(e, t, n);
    return r || !0;
  }
}
var Rr;
(function(i) {
  class e extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      if (!w.position)
        return;
      b.model.pushStackElement(), b.setCursorStates(w.source, 3, [
        Qr.moveTo(b, b.getPrimaryCursorState(), this._inSelectionMode, w.position, w.viewPosition)
      ]) && w.revealType !== 2 && b.revealPrimaryCursor(w.source, !0, !0);
    }
  }
  i.MoveTo = ze(new e({
    id: "_moveTo",
    inSelectionMode: !1,
    precondition: void 0
  })), i.MoveToSelect = ze(new e({
    id: "_moveToSelect",
    inSelectionMode: !0,
    precondition: void 0
  }));
  class t extends Vi {
    runCoreEditorCommand(b, w) {
      b.model.pushStackElement();
      const y = this._getColumnSelectResult(b, b.getPrimaryCursorState(), b.getCursorColumnSelectData(), w);
      y !== null && (b.setCursorStates(w.source, 3, y.viewStates.map((S) => dn.fromViewState(S))), b.setCursorColumnSelectData({
        isReal: !0,
        fromViewLineNumber: y.fromLineNumber,
        fromViewVisualColumn: y.fromVisualColumn,
        toViewLineNumber: y.toLineNumber,
        toViewVisualColumn: y.toVisualColumn
      }), y.reversed ? b.revealTopMostCursor(w.source) : b.revealBottomMostCursor(w.source));
    }
  }
  i.ColumnSelect = ze(new class extends t {
    constructor() {
      super({
        id: "columnSelect",
        precondition: void 0
      });
    }
    _getColumnSelectResult(_, b, w, y) {
      if (typeof y.position > "u" || typeof y.viewPosition > "u" || typeof y.mouseColumn > "u")
        return null;
      const S = _.model.validatePosition(y.position), x = _.coordinatesConverter.validateViewPosition(new ve(y.viewPosition.lineNumber, y.viewPosition.column), S), D = y.doColumnSelect ? w.fromViewLineNumber : x.lineNumber, E = y.doColumnSelect ? w.fromViewVisualColumn : y.mouseColumn - 1;
      return Jp.columnSelect(_.cursorConfig, _, D, E, x.lineNumber, y.mouseColumn - 1);
    }
  }()), i.CursorColumnSelectLeft = ze(new class extends t {
    constructor() {
      super({
        id: "cursorColumnSelectLeft",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 3599,
          linux: { primary: 0 }
        }
      });
    }
    _getColumnSelectResult(_, b, w, y) {
      return Jp.columnSelectLeft(_.cursorConfig, _, w);
    }
  }()), i.CursorColumnSelectRight = ze(new class extends t {
    constructor() {
      super({
        id: "cursorColumnSelectRight",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 3601,
          linux: { primary: 0 }
        }
      });
    }
    _getColumnSelectResult(_, b, w, y) {
      return Jp.columnSelectRight(_.cursorConfig, _, w);
    }
  }());
  class n extends t {
    constructor(b) {
      super(b), this._isPaged = b.isPaged;
    }
    _getColumnSelectResult(b, w, y, S) {
      return Jp.columnSelectUp(b.cursorConfig, b, y, this._isPaged);
    }
  }
  i.CursorColumnSelectUp = ze(new n({
    isPaged: !1,
    id: "cursorColumnSelectUp",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 3600,
      linux: { primary: 0 }
    }
  })), i.CursorColumnSelectPageUp = ze(new n({
    isPaged: !0,
    id: "cursorColumnSelectPageUp",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 3595,
      linux: { primary: 0 }
    }
  }));
  class r extends t {
    constructor(b) {
      super(b), this._isPaged = b.isPaged;
    }
    _getColumnSelectResult(b, w, y, S) {
      return Jp.columnSelectDown(b.cursorConfig, b, y, this._isPaged);
    }
  }
  i.CursorColumnSelectDown = ze(new r({
    isPaged: !1,
    id: "cursorColumnSelectDown",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 3602,
      linux: { primary: 0 }
    }
  })), i.CursorColumnSelectPageDown = ze(new r({
    isPaged: !0,
    id: "cursorColumnSelectPageDown",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 3596,
      linux: { primary: 0 }
    }
  }));
  class s extends Vi {
    constructor() {
      super({
        id: "cursorMove",
        precondition: void 0,
        description: pL.description
      });
    }
    runCoreEditorCommand(b, w) {
      const y = pL.parse(w);
      y && this._runCursorMove(b, w.source, y);
    }
    _runCursorMove(b, w, y) {
      b.model.pushStackElement(), b.setCursorStates(w, 3, s._move(b, b.getCursorStates(), y)), b.revealPrimaryCursor(w, !0);
    }
    static _move(b, w, y) {
      const S = y.select, x = y.value;
      switch (y.direction) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          return Qr.simpleMove(b, w, y.direction, S, x, y.unit);
        case 11:
        case 13:
        case 12:
        case 14:
          return Qr.viewportMove(b, w, y.direction, S, x);
        default:
          return null;
      }
    }
  }
  i.CursorMoveImpl = s, i.CursorMove = ze(new s());
  class o extends Vi {
    constructor(b) {
      super(b), this._staticArgs = b.args;
    }
    runCoreEditorCommand(b, w) {
      let y = this._staticArgs;
      this._staticArgs.value === -1 && (y = {
        direction: this._staticArgs.direction,
        unit: this._staticArgs.unit,
        select: this._staticArgs.select,
        value: w.pageSize || b.cursorConfig.pageSize
      }), b.model.pushStackElement(), b.setCursorStates(w.source, 3, Qr.simpleMove(b, b.getCursorStates(), y.direction, y.select, y.value, y.unit)), b.revealPrimaryCursor(w.source, !0);
    }
  }
  i.CursorLeft = ze(new o({
    args: {
      direction: 0,
      unit: 0,
      select: !1,
      value: 1
    },
    id: "cursorLeft",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 15,
      mac: { primary: 15, secondary: [
        288
        /* KeyCode.KeyB */
      ] }
    }
  })), i.CursorLeftSelect = ze(new o({
    args: {
      direction: 0,
      unit: 0,
      select: !0,
      value: 1
    },
    id: "cursorLeftSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 1039
      /* KeyCode.LeftArrow */
    }
  })), i.CursorRight = ze(new o({
    args: {
      direction: 1,
      unit: 0,
      select: !1,
      value: 1
    },
    id: "cursorRight",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 17,
      mac: { primary: 17, secondary: [
        292
        /* KeyCode.KeyF */
      ] }
    }
  })), i.CursorRightSelect = ze(new o({
    args: {
      direction: 1,
      unit: 0,
      select: !0,
      value: 1
    },
    id: "cursorRightSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 1041
      /* KeyCode.RightArrow */
    }
  })), i.CursorUp = ze(new o({
    args: {
      direction: 2,
      unit: 2,
      select: !1,
      value: 1
    },
    id: "cursorUp",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 16,
      mac: { primary: 16, secondary: [
        302
        /* KeyCode.KeyP */
      ] }
    }
  })), i.CursorUpSelect = ze(new o({
    args: {
      direction: 2,
      unit: 2,
      select: !0,
      value: 1
    },
    id: "cursorUpSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 1040,
      secondary: [
        3088
        /* KeyCode.UpArrow */
      ],
      mac: {
        primary: 1040
        /* KeyCode.UpArrow */
      },
      linux: {
        primary: 1040
        /* KeyCode.UpArrow */
      }
    }
  })), i.CursorPageUp = ze(new o({
    args: {
      direction: 2,
      unit: 2,
      select: !1,
      value: -1
      /* Constants.PAGE_SIZE_MARKER */
    },
    id: "cursorPageUp",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 11
      /* KeyCode.PageUp */
    }
  })), i.CursorPageUpSelect = ze(new o({
    args: {
      direction: 2,
      unit: 2,
      select: !0,
      value: -1
      /* Constants.PAGE_SIZE_MARKER */
    },
    id: "cursorPageUpSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 1035
      /* KeyCode.PageUp */
    }
  })), i.CursorDown = ze(new o({
    args: {
      direction: 3,
      unit: 2,
      select: !1,
      value: 1
    },
    id: "cursorDown",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 18,
      mac: { primary: 18, secondary: [
        300
        /* KeyCode.KeyN */
      ] }
    }
  })), i.CursorDownSelect = ze(new o({
    args: {
      direction: 3,
      unit: 2,
      select: !0,
      value: 1
    },
    id: "cursorDownSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 1042,
      secondary: [
        3090
        /* KeyCode.DownArrow */
      ],
      mac: {
        primary: 1042
        /* KeyCode.DownArrow */
      },
      linux: {
        primary: 1042
        /* KeyCode.DownArrow */
      }
    }
  })), i.CursorPageDown = ze(new o({
    args: {
      direction: 3,
      unit: 2,
      select: !1,
      value: -1
      /* Constants.PAGE_SIZE_MARKER */
    },
    id: "cursorPageDown",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 12
      /* KeyCode.PageDown */
    }
  })), i.CursorPageDownSelect = ze(new o({
    args: {
      direction: 3,
      unit: 2,
      select: !0,
      value: -1
      /* Constants.PAGE_SIZE_MARKER */
    },
    id: "cursorPageDownSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 1036
      /* KeyCode.PageDown */
    }
  })), i.CreateCursor = ze(new class extends Vi {
    constructor() {
      super({
        id: "createCursor",
        precondition: void 0
      });
    }
    runCoreEditorCommand(_, b) {
      if (!b.position)
        return;
      let w;
      b.wholeLine ? w = Qr.line(_, _.getPrimaryCursorState(), !1, b.position, b.viewPosition) : w = Qr.moveTo(_, _.getPrimaryCursorState(), !1, b.position, b.viewPosition);
      const y = _.getCursorStates();
      if (y.length > 1) {
        const S = w.modelState ? w.modelState.position : null, x = w.viewState ? w.viewState.position : null;
        for (let D = 0, E = y.length; D < E; D++) {
          const L = y[D];
          if (!(S && !L.modelState.selection.containsPosition(S)) && !(x && !L.viewState.selection.containsPosition(x))) {
            y.splice(D, 1), _.model.pushStackElement(), _.setCursorStates(b.source, 3, y);
            return;
          }
        }
      }
      y.push(w), _.model.pushStackElement(), _.setCursorStates(b.source, 3, y);
    }
  }()), i.LastCursorMoveToSelect = ze(new class extends Vi {
    constructor() {
      super({
        id: "_lastCursorMoveToSelect",
        precondition: void 0
      });
    }
    runCoreEditorCommand(_, b) {
      if (!b.position)
        return;
      const w = _.getLastAddedCursorIndex(), y = _.getCursorStates(), S = y.slice(0);
      S[w] = Qr.moveTo(_, y[w], !0, b.position, b.viewPosition), _.model.pushStackElement(), _.setCursorStates(b.source, 3, S);
    }
  }());
  class a extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      b.model.pushStackElement(), b.setCursorStates(w.source, 3, Qr.moveToBeginningOfLine(b, b.getCursorStates(), this._inSelectionMode)), b.revealPrimaryCursor(w.source, !0);
    }
  }
  i.CursorHome = ze(new a({
    inSelectionMode: !1,
    id: "cursorHome",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 14,
      mac: { primary: 14, secondary: [
        2063
        /* KeyCode.LeftArrow */
      ] }
    }
  })), i.CursorHomeSelect = ze(new a({
    inSelectionMode: !0,
    id: "cursorHomeSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 1038,
      mac: { primary: 1038, secondary: [
        3087
        /* KeyCode.LeftArrow */
      ] }
    }
  }));
  class l extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      b.model.pushStackElement(), b.setCursorStates(w.source, 3, this._exec(b.getCursorStates())), b.revealPrimaryCursor(w.source, !0);
    }
    _exec(b) {
      const w = [];
      for (let y = 0, S = b.length; y < S; y++) {
        const x = b[y], D = x.modelState.position.lineNumber;
        w[y] = dn.fromModelState(x.modelState.move(this._inSelectionMode, D, 1, 0));
      }
      return w;
    }
  }
  i.CursorLineStart = ze(new l({
    inSelectionMode: !1,
    id: "cursorLineStart",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 0,
      mac: {
        primary: 287
        /* KeyCode.KeyA */
      }
    }
  })), i.CursorLineStartSelect = ze(new l({
    inSelectionMode: !0,
    id: "cursorLineStartSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 0,
      mac: {
        primary: 1311
        /* KeyCode.KeyA */
      }
    }
  }));
  class c extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      b.model.pushStackElement(), b.setCursorStates(w.source, 3, Qr.moveToEndOfLine(b, b.getCursorStates(), this._inSelectionMode, w.sticky || !1)), b.revealPrimaryCursor(w.source, !0);
    }
  }
  i.CursorEnd = ze(new c({
    inSelectionMode: !1,
    id: "cursorEnd",
    precondition: void 0,
    kbOpts: {
      args: { sticky: !1 },
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 13,
      mac: { primary: 13, secondary: [
        2065
        /* KeyCode.RightArrow */
      ] }
    },
    description: {
      description: "Go to End",
      args: [{
        name: "args",
        schema: {
          type: "object",
          properties: {
            sticky: {
              description: C("stickydesc", "Stick to the end even when going to longer lines"),
              type: "boolean",
              default: !1
            }
          }
        }
      }]
    }
  })), i.CursorEndSelect = ze(new c({
    inSelectionMode: !0,
    id: "cursorEndSelect",
    precondition: void 0,
    kbOpts: {
      args: { sticky: !1 },
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 1037,
      mac: { primary: 1037, secondary: [
        3089
        /* KeyCode.RightArrow */
      ] }
    },
    description: {
      description: "Select to End",
      args: [{
        name: "args",
        schema: {
          type: "object",
          properties: {
            sticky: {
              description: C("stickydesc", "Stick to the end even when going to longer lines"),
              type: "boolean",
              default: !1
            }
          }
        }
      }]
    }
  }));
  class d extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      b.model.pushStackElement(), b.setCursorStates(w.source, 3, this._exec(b, b.getCursorStates())), b.revealPrimaryCursor(w.source, !0);
    }
    _exec(b, w) {
      const y = [];
      for (let S = 0, x = w.length; S < x; S++) {
        const D = w[S], E = D.modelState.position.lineNumber, L = b.model.getLineMaxColumn(E);
        y[S] = dn.fromModelState(D.modelState.move(this._inSelectionMode, E, L, 0));
      }
      return y;
    }
  }
  i.CursorLineEnd = ze(new d({
    inSelectionMode: !1,
    id: "cursorLineEnd",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 0,
      mac: {
        primary: 291
        /* KeyCode.KeyE */
      }
    }
  })), i.CursorLineEndSelect = ze(new d({
    inSelectionMode: !0,
    id: "cursorLineEndSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 0,
      mac: {
        primary: 1315
        /* KeyCode.KeyE */
      }
    }
  }));
  class u extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      b.model.pushStackElement(), b.setCursorStates(w.source, 3, Qr.moveToBeginningOfBuffer(b, b.getCursorStates(), this._inSelectionMode)), b.revealPrimaryCursor(w.source, !0);
    }
  }
  i.CursorTop = ze(new u({
    inSelectionMode: !1,
    id: "cursorTop",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 2062,
      mac: {
        primary: 2064
        /* KeyCode.UpArrow */
      }
    }
  })), i.CursorTopSelect = ze(new u({
    inSelectionMode: !0,
    id: "cursorTopSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 3086,
      mac: {
        primary: 3088
        /* KeyCode.UpArrow */
      }
    }
  }));
  class h extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      b.model.pushStackElement(), b.setCursorStates(w.source, 3, Qr.moveToEndOfBuffer(b, b.getCursorStates(), this._inSelectionMode)), b.revealPrimaryCursor(w.source, !0);
    }
  }
  i.CursorBottom = ze(new h({
    inSelectionMode: !1,
    id: "cursorBottom",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 2061,
      mac: {
        primary: 2066
        /* KeyCode.DownArrow */
      }
    }
  })), i.CursorBottomSelect = ze(new h({
    inSelectionMode: !0,
    id: "cursorBottomSelect",
    precondition: void 0,
    kbOpts: {
      weight: bn,
      kbExpr: $.textInputFocus,
      primary: 3085,
      mac: {
        primary: 3090
        /* KeyCode.DownArrow */
      }
    }
  }));
  class f extends Vi {
    constructor() {
      super({
        id: "editorScroll",
        precondition: void 0,
        description: gs.description
      });
    }
    determineScrollMethod(b) {
      const w = [
        6
        /* EditorScroll_.Unit.Column */
      ], y = [
        1,
        2,
        3,
        4,
        5,
        6
        /* EditorScroll_.Unit.Column */
      ], S = [
        4,
        2
        /* EditorScroll_.Direction.Right */
      ], x = [
        1,
        3
        /* EditorScroll_.Direction.Down */
      ];
      return w.includes(b.unit) && S.includes(b.direction) ? this._runHorizontalEditorScroll.bind(this) : y.includes(b.unit) && x.includes(b.direction) ? this._runVerticalEditorScroll.bind(this) : null;
    }
    runCoreEditorCommand(b, w) {
      const y = gs.parse(w);
      if (!y)
        return;
      const S = this.determineScrollMethod(y);
      S && S(b, w.source, y);
    }
    _runVerticalEditorScroll(b, w, y) {
      const S = this._computeDesiredScrollTop(b, y);
      if (y.revealCursor) {
        const x = b.getCompletelyVisibleViewRangeAtScrollTop(S);
        b.setCursorStates(w, 3, [
          Qr.findPositionInViewportIfOutside(b, b.getPrimaryCursorState(), x, y.select)
        ]);
      }
      b.viewLayout.setScrollPosition(
        { scrollTop: S },
        0
        /* ScrollType.Smooth */
      );
    }
    _computeDesiredScrollTop(b, w) {
      if (w.unit === 1) {
        const x = b.viewLayout.getFutureViewport(), D = b.getCompletelyVisibleViewRangeAtScrollTop(x.top), E = b.coordinatesConverter.convertViewRangeToModelRange(D);
        let L;
        w.direction === 1 ? L = Math.max(1, E.startLineNumber - w.value) : L = Math.min(b.model.getLineCount(), E.startLineNumber + w.value);
        const k = b.coordinatesConverter.convertModelPositionToViewPosition(new ve(L, 1));
        return b.viewLayout.getVerticalOffsetForLineNumber(k.lineNumber);
      }
      if (w.unit === 5) {
        let x = 0;
        return w.direction === 3 && (x = b.model.getLineCount() - b.cursorConfig.pageSize), b.viewLayout.getVerticalOffsetForLineNumber(x);
      }
      let y;
      w.unit === 3 ? y = b.cursorConfig.pageSize * w.value : w.unit === 4 ? y = Math.round(b.cursorConfig.pageSize / 2) * w.value : y = w.value;
      const S = (w.direction === 1 ? -1 : 1) * y;
      return b.viewLayout.getCurrentScrollTop() + S * b.cursorConfig.lineHeight;
    }
    _runHorizontalEditorScroll(b, w, y) {
      const S = this._computeDesiredScrollLeft(b, y);
      b.viewLayout.setScrollPosition(
        { scrollLeft: S },
        0
        /* ScrollType.Smooth */
      );
    }
    _computeDesiredScrollLeft(b, w) {
      const y = (w.direction === 4 ? -1 : 1) * w.value;
      return b.viewLayout.getCurrentScrollLeft() + y * b.cursorConfig.typicalHalfwidthCharacterWidth;
    }
  }
  i.EditorScrollImpl = f, i.EditorScroll = ze(new f()), i.ScrollLineUp = ze(new class extends Vi {
    constructor() {
      super({
        id: "scrollLineUp",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 2064,
          mac: {
            primary: 267
            /* KeyCode.PageUp */
          }
        }
      });
    }
    runCoreEditorCommand(_, b) {
      i.EditorScroll.runCoreEditorCommand(_, {
        to: gs.RawDirection.Up,
        by: gs.RawUnit.WrappedLine,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: b.source
      });
    }
  }()), i.ScrollPageUp = ze(new class extends Vi {
    constructor() {
      super({
        id: "scrollPageUp",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 2059,
          win: {
            primary: 523
            /* KeyCode.PageUp */
          },
          linux: {
            primary: 523
            /* KeyCode.PageUp */
          }
        }
      });
    }
    runCoreEditorCommand(_, b) {
      i.EditorScroll.runCoreEditorCommand(_, {
        to: gs.RawDirection.Up,
        by: gs.RawUnit.Page,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: b.source
      });
    }
  }()), i.ScrollEditorTop = ze(new class extends Vi {
    constructor() {
      super({
        id: "scrollEditorTop",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus
        }
      });
    }
    runCoreEditorCommand(_, b) {
      i.EditorScroll.runCoreEditorCommand(_, {
        to: gs.RawDirection.Up,
        by: gs.RawUnit.Editor,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: b.source
      });
    }
  }()), i.ScrollLineDown = ze(new class extends Vi {
    constructor() {
      super({
        id: "scrollLineDown",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 2066,
          mac: {
            primary: 268
            /* KeyCode.PageDown */
          }
        }
      });
    }
    runCoreEditorCommand(_, b) {
      i.EditorScroll.runCoreEditorCommand(_, {
        to: gs.RawDirection.Down,
        by: gs.RawUnit.WrappedLine,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: b.source
      });
    }
  }()), i.ScrollPageDown = ze(new class extends Vi {
    constructor() {
      super({
        id: "scrollPageDown",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 2060,
          win: {
            primary: 524
            /* KeyCode.PageDown */
          },
          linux: {
            primary: 524
            /* KeyCode.PageDown */
          }
        }
      });
    }
    runCoreEditorCommand(_, b) {
      i.EditorScroll.runCoreEditorCommand(_, {
        to: gs.RawDirection.Down,
        by: gs.RawUnit.Page,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: b.source
      });
    }
  }()), i.ScrollEditorBottom = ze(new class extends Vi {
    constructor() {
      super({
        id: "scrollEditorBottom",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus
        }
      });
    }
    runCoreEditorCommand(_, b) {
      i.EditorScroll.runCoreEditorCommand(_, {
        to: gs.RawDirection.Down,
        by: gs.RawUnit.Editor,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: b.source
      });
    }
  }()), i.ScrollLeft = ze(new class extends Vi {
    constructor() {
      super({
        id: "scrollLeft",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus
        }
      });
    }
    runCoreEditorCommand(_, b) {
      i.EditorScroll.runCoreEditorCommand(_, {
        to: gs.RawDirection.Left,
        by: gs.RawUnit.Column,
        value: 2,
        revealCursor: !1,
        select: !1,
        source: b.source
      });
    }
  }()), i.ScrollRight = ze(new class extends Vi {
    constructor() {
      super({
        id: "scrollRight",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus
        }
      });
    }
    runCoreEditorCommand(_, b) {
      i.EditorScroll.runCoreEditorCommand(_, {
        to: gs.RawDirection.Right,
        by: gs.RawUnit.Column,
        value: 2,
        revealCursor: !1,
        select: !1,
        source: b.source
      });
    }
  }());
  class g extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      w.position && (b.model.pushStackElement(), b.setCursorStates(w.source, 3, [
        Qr.word(b, b.getPrimaryCursorState(), this._inSelectionMode, w.position)
      ]), w.revealType !== 2 && b.revealPrimaryCursor(w.source, !0, !0));
    }
  }
  i.WordSelect = ze(new g({
    inSelectionMode: !1,
    id: "_wordSelect",
    precondition: void 0
  })), i.WordSelectDrag = ze(new g({
    inSelectionMode: !0,
    id: "_wordSelectDrag",
    precondition: void 0
  })), i.LastCursorWordSelect = ze(new class extends Vi {
    constructor() {
      super({
        id: "lastCursorWordSelect",
        precondition: void 0
      });
    }
    runCoreEditorCommand(_, b) {
      if (!b.position)
        return;
      const w = _.getLastAddedCursorIndex(), y = _.getCursorStates(), S = y.slice(0), x = y[w];
      S[w] = Qr.word(_, x, x.modelState.hasSelection(), b.position), _.model.pushStackElement(), _.setCursorStates(b.source, 3, S);
    }
  }());
  class p extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      w.position && (b.model.pushStackElement(), b.setCursorStates(w.source, 3, [
        Qr.line(b, b.getPrimaryCursorState(), this._inSelectionMode, w.position, w.viewPosition)
      ]), w.revealType !== 2 && b.revealPrimaryCursor(w.source, !1, !0));
    }
  }
  i.LineSelect = ze(new p({
    inSelectionMode: !1,
    id: "_lineSelect",
    precondition: void 0
  })), i.LineSelectDrag = ze(new p({
    inSelectionMode: !0,
    id: "_lineSelectDrag",
    precondition: void 0
  }));
  class m extends Vi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, w) {
      if (!w.position)
        return;
      const y = b.getLastAddedCursorIndex(), S = b.getCursorStates(), x = S.slice(0);
      x[y] = Qr.line(b, S[y], this._inSelectionMode, w.position, w.viewPosition), b.model.pushStackElement(), b.setCursorStates(w.source, 3, x);
    }
  }
  i.LastCursorLineSelect = ze(new m({
    inSelectionMode: !1,
    id: "lastCursorLineSelect",
    precondition: void 0
  })), i.LastCursorLineSelectDrag = ze(new m({
    inSelectionMode: !0,
    id: "lastCursorLineSelectDrag",
    precondition: void 0
  })), i.CancelSelection = ze(new class extends Vi {
    constructor() {
      super({
        id: "cancelSelection",
        precondition: $.hasNonEmptySelection,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 9,
          secondary: [
            1033
            /* KeyCode.Escape */
          ]
        }
      });
    }
    runCoreEditorCommand(_, b) {
      _.model.pushStackElement(), _.setCursorStates(b.source, 3, [
        Qr.cancelSelection(_, _.getPrimaryCursorState())
      ]), _.revealPrimaryCursor(b.source, !0);
    }
  }()), i.RemoveSecondaryCursors = ze(new class extends Vi {
    constructor() {
      super({
        id: "removeSecondaryCursors",
        precondition: $.hasMultipleSelections,
        kbOpts: {
          weight: bn + 1,
          kbExpr: $.textInputFocus,
          primary: 9,
          secondary: [
            1033
            /* KeyCode.Escape */
          ]
        }
      });
    }
    runCoreEditorCommand(_, b) {
      _.model.pushStackElement(), _.setCursorStates(b.source, 3, [
        _.getPrimaryCursorState()
      ]), _.revealPrimaryCursor(b.source, !0), Vg(C("removedCursor", "Removed secondary cursors"));
    }
  }()), i.RevealLine = ze(new class extends Vi {
    constructor() {
      super({
        id: "revealLine",
        precondition: void 0,
        description: sv.description
      });
    }
    runCoreEditorCommand(_, b) {
      const w = b, y = w.lineNumber || 0;
      let S = typeof y == "number" ? y + 1 : parseInt(y) + 1;
      S < 1 && (S = 1);
      const x = _.model.getLineCount();
      S > x && (S = x);
      const D = new V(S, 1, S, _.model.getLineMaxColumn(S));
      let E = 0;
      if (w.at)
        switch (w.at) {
          case sv.RawAtArgument.Top:
            E = 3;
            break;
          case sv.RawAtArgument.Center:
            E = 1;
            break;
          case sv.RawAtArgument.Bottom:
            E = 4;
            break;
        }
      const L = _.coordinatesConverter.convertModelRangeToViewRange(D);
      _.revealRange(
        b.source,
        !1,
        L,
        E,
        0
        /* ScrollType.Smooth */
      );
    }
  }()), i.SelectAll = new class extends MF {
    constructor() {
      super(s7e);
    }
    runDOMCommand(_) {
      bl && (_.focus(), _.select()), _.ownerDocument.execCommand("selectAll");
    }
    runEditorCommand(_, b, w) {
      const y = b._getViewModel();
      y && this.runCoreEditorCommand(y, w);
    }
    runCoreEditorCommand(_, b) {
      _.model.pushStackElement(), _.setCursorStates("keyboard", 3, [
        Qr.selectAll(_, _.getPrimaryCursorState())
      ]);
    }
  }(), i.SetSelection = ze(new class extends Vi {
    constructor() {
      super({
        id: "setSelection",
        precondition: void 0
      });
    }
    runCoreEditorCommand(_, b) {
      b.selection && (_.model.pushStackElement(), _.setCursorStates(b.source, 3, [
        dn.fromModelSelection(b.selection)
      ]));
    }
  }());
})(Rr || (Rr = {}));
const bFe = ke.and($.textInputFocus, $.columnSelection);
function _b(i, e) {
  Bo.registerKeybindingRule({
    id: i,
    primary: e,
    when: bFe,
    weight: bn + 1
  });
}
_b(
  Rr.CursorColumnSelectLeft.id,
  1039
  /* KeyCode.LeftArrow */
);
_b(
  Rr.CursorColumnSelectRight.id,
  1041
  /* KeyCode.RightArrow */
);
_b(
  Rr.CursorColumnSelectUp.id,
  1040
  /* KeyCode.UpArrow */
);
_b(
  Rr.CursorColumnSelectPageUp.id,
  1035
  /* KeyCode.PageUp */
);
_b(
  Rr.CursorColumnSelectDown.id,
  1042
  /* KeyCode.DownArrow */
);
_b(
  Rr.CursorColumnSelectPageDown.id,
  1036
  /* KeyCode.PageDown */
);
function AZ(i) {
  return i.register(), i;
}
var Bv;
(function(i) {
  class e extends Kr {
    runEditorCommand(n, r, s) {
      const o = r._getViewModel();
      o && this.runCoreEditingCommand(r, o, s || {});
    }
  }
  i.CoreEditingCommand = e, i.LineBreakInsert = ze(new class extends e {
    constructor() {
      super({
        id: "lineBreakInsert",
        precondition: $.writable,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 0,
          mac: {
            primary: 301
            /* KeyCode.KeyO */
          }
        }
      });
    }
    runCoreEditingCommand(t, n, r) {
      t.pushUndoStop(), t.executeCommands(this.id, wi.lineBreakInsert(n.cursorConfig, n.model, n.getCursorStates().map((s) => s.modelState.selection)));
    }
  }()), i.Outdent = ze(new class extends e {
    constructor() {
      super({
        id: "outdent",
        precondition: $.writable,
        kbOpts: {
          weight: bn,
          kbExpr: ke.and($.editorTextFocus, $.tabDoesNotMoveFocus),
          primary: 1026
          /* KeyCode.Tab */
        }
      });
    }
    runCoreEditingCommand(t, n, r) {
      t.pushUndoStop(), t.executeCommands(this.id, wi.outdent(n.cursorConfig, n.model, n.getCursorStates().map((s) => s.modelState.selection))), t.pushUndoStop();
    }
  }()), i.Tab = ze(new class extends e {
    constructor() {
      super({
        id: "tab",
        precondition: $.writable,
        kbOpts: {
          weight: bn,
          kbExpr: ke.and($.editorTextFocus, $.tabDoesNotMoveFocus),
          primary: 2
          /* KeyCode.Tab */
        }
      });
    }
    runCoreEditingCommand(t, n, r) {
      t.pushUndoStop(), t.executeCommands(this.id, wi.tab(n.cursorConfig, n.model, n.getCursorStates().map((s) => s.modelState.selection))), t.pushUndoStop();
    }
  }()), i.DeleteLeft = ze(new class extends e {
    constructor() {
      super({
        id: "deleteLeft",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 1,
          secondary: [
            1025
            /* KeyCode.Backspace */
          ],
          mac: { primary: 1, secondary: [
            1025,
            294,
            257
            /* KeyCode.Backspace */
          ] }
        }
      });
    }
    runCoreEditingCommand(t, n, r) {
      const [s, o] = Zm.deleteLeft(n.getPrevEditOperationType(), n.cursorConfig, n.model, n.getCursorStates().map((a) => a.modelState.selection), n.getCursorAutoClosedCharacters());
      s && t.pushUndoStop(), t.executeCommands(this.id, o), n.setPrevEditOperationType(
        2
        /* EditOperationType.DeletingLeft */
      );
    }
  }()), i.DeleteRight = ze(new class extends e {
    constructor() {
      super({
        id: "deleteRight",
        precondition: void 0,
        kbOpts: {
          weight: bn,
          kbExpr: $.textInputFocus,
          primary: 20,
          mac: { primary: 20, secondary: [
            290,
            276
            /* KeyCode.Delete */
          ] }
        }
      });
    }
    runCoreEditingCommand(t, n, r) {
      const [s, o] = Zm.deleteRight(n.getPrevEditOperationType(), n.cursorConfig, n.model, n.getCursorStates().map((a) => a.modelState.selection));
      s && t.pushUndoStop(), t.executeCommands(this.id, o), n.setPrevEditOperationType(
        3
        /* EditOperationType.DeletingRight */
      );
    }
  }()), i.Undo = new class extends MF {
    constructor() {
      super(qhe);
    }
    runDOMCommand(t) {
      t.ownerDocument.execCommand("undo");
    }
    runEditorCommand(t, n, r) {
      if (!(!n.hasModel() || n.getOption(
        90
        /* EditorOption.readOnly */
      ) === !0))
        return n.getModel().undo();
    }
  }(), i.Redo = new class extends MF {
    constructor() {
      super(Khe);
    }
    runDOMCommand(t) {
      t.ownerDocument.execCommand("redo");
    }
    runEditorCommand(t, n, r) {
      if (!(!n.hasModel() || n.getOption(
        90
        /* EditorOption.readOnly */
      ) === !0))
        return n.getModel().redo();
    }
  }();
})(Bv || (Bv = {}));
class kZ extends n4 {
  constructor(e, t, n) {
    super({
      id: e,
      precondition: void 0,
      description: n
    }), this._handlerId = t;
  }
  runCommand(e, t) {
    const n = e.get(Sn).getFocusedCodeEditor();
    n && n.trigger("keyboard", this._handlerId, t);
  }
}
function M0(i, e) {
  AZ(new kZ("default:" + i, i)), AZ(new kZ(i, i, e));
}
M0("type", {
  description: "Type",
  args: [{
    name: "args",
    schema: {
      type: "object",
      required: ["text"],
      properties: {
        text: {
          type: "string"
        }
      }
    }
  }]
});
M0(
  "replacePreviousChar"
  /* Handler.ReplacePreviousChar */
);
M0(
  "compositionType"
  /* Handler.CompositionType */
);
M0(
  "compositionStart"
  /* Handler.CompositionStart */
);
M0(
  "compositionEnd"
  /* Handler.CompositionEnd */
);
M0(
  "paste"
  /* Handler.Paste */
);
M0(
  "cut"
  /* Handler.Cut */
);
class CFe {
  constructor(e, t, n, r) {
    this.configuration = e, this.viewModel = t, this.userInputEvents = n, this.commandDelegate = r;
  }
  paste(e, t, n, r) {
    this.commandDelegate.paste(e, t, n, r);
  }
  type(e) {
    this.commandDelegate.type(e);
  }
  compositionType(e, t, n, r) {
    this.commandDelegate.compositionType(e, t, n, r);
  }
  compositionStart() {
    this.commandDelegate.startComposition();
  }
  compositionEnd() {
    this.commandDelegate.endComposition();
  }
  cut() {
    this.commandDelegate.cut();
  }
  setSelection(e) {
    Rr.SetSelection.runCoreEditorCommand(this.viewModel, {
      source: "keyboard",
      selection: e
    });
  }
  _validateViewColumn(e) {
    const t = this.viewModel.getLineMinColumn(e.lineNumber);
    return e.column < t ? new ve(e.lineNumber, t) : e;
  }
  _hasMulticursorModifier(e) {
    switch (this.configuration.options.get(
      77
      /* EditorOption.multiCursorModifier */
    )) {
      case "altKey":
        return e.altKey;
      case "ctrlKey":
        return e.ctrlKey;
      case "metaKey":
        return e.metaKey;
      default:
        return !1;
    }
  }
  _hasNonMulticursorModifier(e) {
    switch (this.configuration.options.get(
      77
      /* EditorOption.multiCursorModifier */
    )) {
      case "altKey":
        return e.ctrlKey || e.metaKey;
      case "ctrlKey":
        return e.altKey || e.metaKey;
      case "metaKey":
        return e.ctrlKey || e.altKey;
      default:
        return !1;
    }
  }
  dispatchMouse(e) {
    const t = this.configuration.options, n = $s && t.get(
      106
      /* EditorOption.selectionClipboard */
    ), r = t.get(
      22
      /* EditorOption.columnSelection */
    );
    e.middleButton && !n ? this._columnSelect(e.position, e.mouseColumn, e.inSelectionMode) : e.startedOnLineNumbers ? this._hasMulticursorModifier(e) ? e.inSelectionMode ? this._lastCursorLineSelect(e.position, e.revealType) : this._createCursor(e.position, !0) : e.inSelectionMode ? this._lineSelectDrag(e.position, e.revealType) : this._lineSelect(e.position, e.revealType) : e.mouseDownCount >= 4 ? this._selectAll() : e.mouseDownCount === 3 ? this._hasMulticursorModifier(e) ? e.inSelectionMode ? this._lastCursorLineSelectDrag(e.position, e.revealType) : this._lastCursorLineSelect(e.position, e.revealType) : e.inSelectionMode ? this._lineSelectDrag(e.position, e.revealType) : this._lineSelect(e.position, e.revealType) : e.mouseDownCount === 2 ? e.onInjectedText || (this._hasMulticursorModifier(e) ? this._lastCursorWordSelect(e.position, e.revealType) : e.inSelectionMode ? this._wordSelectDrag(e.position, e.revealType) : this._wordSelect(e.position, e.revealType)) : this._hasMulticursorModifier(e) ? this._hasNonMulticursorModifier(e) || (e.shiftKey ? this._columnSelect(e.position, e.mouseColumn, !0) : e.inSelectionMode ? this._lastCursorMoveToSelect(e.position, e.revealType) : this._createCursor(e.position, !1)) : e.inSelectionMode ? e.altKey ? this._columnSelect(e.position, e.mouseColumn, !0) : r ? this._columnSelect(e.position, e.mouseColumn, !0) : this._moveToSelect(e.position, e.revealType) : this.moveTo(e.position, e.revealType);
  }
  _usualArgs(e, t) {
    return e = this._validateViewColumn(e), {
      source: "mouse",
      position: this._convertViewToModelPosition(e),
      viewPosition: e,
      revealType: t
    };
  }
  moveTo(e, t) {
    Rr.MoveTo.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _moveToSelect(e, t) {
    Rr.MoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _columnSelect(e, t, n) {
    e = this._validateViewColumn(e), Rr.ColumnSelect.runCoreEditorCommand(this.viewModel, {
      source: "mouse",
      position: this._convertViewToModelPosition(e),
      viewPosition: e,
      mouseColumn: t,
      doColumnSelect: n
    });
  }
  _createCursor(e, t) {
    e = this._validateViewColumn(e), Rr.CreateCursor.runCoreEditorCommand(this.viewModel, {
      source: "mouse",
      position: this._convertViewToModelPosition(e),
      viewPosition: e,
      wholeLine: t
    });
  }
  _lastCursorMoveToSelect(e, t) {
    Rr.LastCursorMoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _wordSelect(e, t) {
    Rr.WordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _wordSelectDrag(e, t) {
    Rr.WordSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorWordSelect(e, t) {
    Rr.LastCursorWordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lineSelect(e, t) {
    Rr.LineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lineSelectDrag(e, t) {
    Rr.LineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorLineSelect(e, t) {
    Rr.LastCursorLineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorLineSelectDrag(e, t) {
    Rr.LastCursorLineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _selectAll() {
    Rr.SelectAll.runCoreEditorCommand(this.viewModel, { source: "mouse" });
  }
  // ----------------------
  _convertViewToModelPosition(e) {
    return this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(e);
  }
  emitKeyDown(e) {
    this.userInputEvents.emitKeyDown(e);
  }
  emitKeyUp(e) {
    this.userInputEvents.emitKeyUp(e);
  }
  emitContextMenu(e) {
    this.userInputEvents.emitContextMenu(e);
  }
  emitMouseMove(e) {
    this.userInputEvents.emitMouseMove(e);
  }
  emitMouseLeave(e) {
    this.userInputEvents.emitMouseLeave(e);
  }
  emitMouseUp(e) {
    this.userInputEvents.emitMouseUp(e);
  }
  emitMouseDown(e) {
    this.userInputEvents.emitMouseDown(e);
  }
  emitMouseDrag(e) {
    this.userInputEvents.emitMouseDrag(e);
  }
  emitMouseDrop(e) {
    this.userInputEvents.emitMouseDrop(e);
  }
  emitMouseDropCanceled() {
    this.userInputEvents.emitMouseDropCanceled();
  }
  emitMouseWheel(e) {
    this.userInputEvents.emitMouseWheel(e);
  }
}
class w4 {
  constructor(e) {
    this.onKeyDown = null, this.onKeyUp = null, this.onContextMenu = null, this.onMouseMove = null, this.onMouseLeave = null, this.onMouseDown = null, this.onMouseUp = null, this.onMouseDrag = null, this.onMouseDrop = null, this.onMouseDropCanceled = null, this.onMouseWheel = null, this._coordinatesConverter = e;
  }
  emitKeyDown(e) {
    var t;
    (t = this.onKeyDown) === null || t === void 0 || t.call(this, e);
  }
  emitKeyUp(e) {
    var t;
    (t = this.onKeyUp) === null || t === void 0 || t.call(this, e);
  }
  emitContextMenu(e) {
    var t;
    (t = this.onContextMenu) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseMove(e) {
    var t;
    (t = this.onMouseMove) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseLeave(e) {
    var t;
    (t = this.onMouseLeave) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDown(e) {
    var t;
    (t = this.onMouseDown) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseUp(e) {
    var t;
    (t = this.onMouseUp) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDrag(e) {
    var t;
    (t = this.onMouseDrag) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDrop(e) {
    var t;
    (t = this.onMouseDrop) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDropCanceled() {
    var e;
    (e = this.onMouseDropCanceled) === null || e === void 0 || e.call(this);
  }
  emitMouseWheel(e) {
    var t;
    (t = this.onMouseWheel) === null || t === void 0 || t.call(this, e);
  }
  _convertViewToModelMouseEvent(e) {
    return e.target ? {
      event: e.event,
      target: this._convertViewToModelMouseTarget(e.target)
    } : e;
  }
  _convertViewToModelMouseTarget(e) {
    return w4.convertViewToModelMouseTarget(e, this._coordinatesConverter);
  }
  static convertViewToModelMouseTarget(e, t) {
    const n = Object.assign({}, e);
    return n.position && (n.position = t.convertViewPositionToModelPosition(n.position)), n.range && (n.range = t.convertViewRangeToModelRange(n.range)), (n.type === 5 || n.type === 8) && (n.detail = this.convertViewToModelViewZoneData(n.detail, t)), n;
  }
  static convertViewToModelViewZoneData(e, t) {
    return {
      viewZoneId: e.viewZoneId,
      positionBefore: e.positionBefore ? t.convertViewPositionToModelPosition(e.positionBefore) : e.positionBefore,
      positionAfter: e.positionAfter ? t.convertViewPositionToModelPosition(e.positionAfter) : e.positionAfter,
      position: t.convertViewPositionToModelPosition(e.position),
      afterLineNumber: t.convertViewPositionToModelPosition(new ve(e.afterLineNumber, 1)).lineNumber
    };
  }
}
class ige {
  constructor(e) {
    this._createLine = e, this._set(1, []);
  }
  flush() {
    this._set(1, []);
  }
  _set(e, t) {
    this._lines = t, this._rendLineNumberStart = e;
  }
  _get() {
    return {
      rendLineNumberStart: this._rendLineNumberStart,
      lines: this._lines
    };
  }
  /**
   * @returns Inclusive line number that is inside this collection
   */
  getStartLineNumber() {
    return this._rendLineNumberStart;
  }
  /**
   * @returns Inclusive line number that is inside this collection
   */
  getEndLineNumber() {
    return this._rendLineNumberStart + this._lines.length - 1;
  }
  getCount() {
    return this._lines.length;
  }
  getLine(e) {
    const t = e - this._rendLineNumberStart;
    if (t < 0 || t >= this._lines.length)
      throw new gr("Illegal value for lineNumber");
    return this._lines[t];
  }
  /**
   * @returns Lines that were removed from this collection
   */
  onLinesDeleted(e, t) {
    if (this.getCount() === 0)
      return null;
    const n = this.getStartLineNumber(), r = this.getEndLineNumber();
    if (t < n) {
      const l = t - e + 1;
      return this._rendLineNumberStart -= l, null;
    }
    if (e > r)
      return null;
    let s = 0, o = 0;
    for (let l = n; l <= r; l++) {
      const c = l - this._rendLineNumberStart;
      e <= l && l <= t && (o === 0 ? (s = c, o = 1) : o++);
    }
    if (e < n) {
      let l = 0;
      t < n ? l = t - e + 1 : l = n - e, this._rendLineNumberStart -= l;
    }
    return this._lines.splice(s, o);
  }
  onLinesChanged(e, t) {
    const n = e + t - 1;
    if (this.getCount() === 0)
      return !1;
    const r = this.getStartLineNumber(), s = this.getEndLineNumber();
    let o = !1;
    for (let a = e; a <= n; a++)
      a >= r && a <= s && (this._lines[a - this._rendLineNumberStart].onContentChanged(), o = !0);
    return o;
  }
  onLinesInserted(e, t) {
    if (this.getCount() === 0)
      return null;
    const n = t - e + 1, r = this.getStartLineNumber(), s = this.getEndLineNumber();
    if (e <= r)
      return this._rendLineNumberStart += n, null;
    if (e > s)
      return null;
    if (n + e > s)
      return this._lines.splice(e - this._rendLineNumberStart, s - e + 1);
    const o = [];
    for (let u = 0; u < n; u++)
      o[u] = this._createLine();
    const a = e - this._rendLineNumberStart, l = this._lines.slice(0, a), c = this._lines.slice(a, this._lines.length - n), d = this._lines.slice(this._lines.length - n, this._lines.length);
    return this._lines = l.concat(o).concat(c), d;
  }
  onTokensChanged(e) {
    if (this.getCount() === 0)
      return !1;
    const t = this.getStartLineNumber(), n = this.getEndLineNumber();
    let r = !1;
    for (let s = 0, o = e.length; s < o; s++) {
      const a = e[s];
      if (a.toLineNumber < t || a.fromLineNumber > n)
        continue;
      const l = Math.max(t, a.fromLineNumber), c = Math.min(n, a.toLineNumber);
      for (let d = l; d <= c; d++) {
        const u = d - this._rendLineNumberStart;
        this._lines[u].onTokensChanged(), r = !0;
      }
    }
    return r;
  }
}
class rge {
  constructor(e) {
    this._host = e, this.domNode = this._createDomNode(), this._linesCollection = new ige(() => this._host.createVisibleLine());
  }
  _createDomNode() {
    const e = Dn(document.createElement("div"));
    return e.setClassName("view-layer"), e.setPosition("absolute"), e.domNode.setAttribute("role", "presentation"), e.domNode.setAttribute("aria-hidden", "true"), e;
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    return !!e.hasChanged(
      143
      /* EditorOption.layoutInfo */
    );
  }
  onFlushed(e) {
    return this._linesCollection.flush(), !0;
  }
  onLinesChanged(e) {
    return this._linesCollection.onLinesChanged(e.fromLineNumber, e.count);
  }
  onLinesDeleted(e) {
    const t = this._linesCollection.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
    if (t)
      for (let n = 0, r = t.length; n < r; n++) {
        const s = t[n].getDomNode();
        s && this.domNode.domNode.removeChild(s);
      }
    return !0;
  }
  onLinesInserted(e) {
    const t = this._linesCollection.onLinesInserted(e.fromLineNumber, e.toLineNumber);
    if (t)
      for (let n = 0, r = t.length; n < r; n++) {
        const s = t[n].getDomNode();
        s && this.domNode.domNode.removeChild(s);
      }
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onTokensChanged(e) {
    return this._linesCollection.onTokensChanged(e.ranges);
  }
  onZonesChanged(e) {
    return !0;
  }
  // ---- end view event handlers
  getStartLineNumber() {
    return this._linesCollection.getStartLineNumber();
  }
  getEndLineNumber() {
    return this._linesCollection.getEndLineNumber();
  }
  getVisibleLine(e) {
    return this._linesCollection.getLine(e);
  }
  renderLines(e) {
    const t = this._linesCollection._get(), n = new _h(this.domNode.domNode, this._host, e), r = {
      rendLineNumberStart: t.rendLineNumberStart,
      lines: t.lines,
      linesLength: t.lines.length
    }, s = n.render(r, e.startLineNumber, e.endLineNumber, e.relativeVerticalOffset);
    this._linesCollection._set(s.rendLineNumberStart, s.lines);
  }
}
class _h {
  constructor(e, t, n) {
    this.domNode = e, this.host = t, this.viewportData = n;
  }
  render(e, t, n, r) {
    const s = {
      rendLineNumberStart: e.rendLineNumberStart,
      lines: e.lines.slice(0),
      linesLength: e.linesLength
    };
    if (s.rendLineNumberStart + s.linesLength - 1 < t || n < s.rendLineNumberStart) {
      s.rendLineNumberStart = t, s.linesLength = n - t + 1, s.lines = [];
      for (let o = t; o <= n; o++)
        s.lines[o - t] = this.host.createVisibleLine();
      return this._finishRendering(s, !0, r), s;
    }
    if (this._renderUntouchedLines(s, Math.max(t - s.rendLineNumberStart, 0), Math.min(n - s.rendLineNumberStart, s.linesLength - 1), r, t), s.rendLineNumberStart > t) {
      const o = t, a = Math.min(n, s.rendLineNumberStart - 1);
      o <= a && (this._insertLinesBefore(s, o, a, r, t), s.linesLength += a - o + 1);
    } else if (s.rendLineNumberStart < t) {
      const o = Math.min(s.linesLength, t - s.rendLineNumberStart);
      o > 0 && (this._removeLinesBefore(s, o), s.linesLength -= o);
    }
    if (s.rendLineNumberStart = t, s.rendLineNumberStart + s.linesLength - 1 < n) {
      const o = s.rendLineNumberStart + s.linesLength, a = n;
      o <= a && (this._insertLinesAfter(s, o, a, r, t), s.linesLength += a - o + 1);
    } else if (s.rendLineNumberStart + s.linesLength - 1 > n) {
      const o = Math.max(0, n - s.rendLineNumberStart + 1), l = s.linesLength - 1 - o + 1;
      l > 0 && (this._removeLinesAfter(s, l), s.linesLength -= l);
    }
    return this._finishRendering(s, !1, r), s;
  }
  _renderUntouchedLines(e, t, n, r, s) {
    const o = e.rendLineNumberStart, a = e.lines;
    for (let l = t; l <= n; l++) {
      const c = o + l;
      a[l].layoutLine(c, r[c - s]);
    }
  }
  _insertLinesBefore(e, t, n, r, s) {
    const o = [];
    let a = 0;
    for (let l = t; l <= n; l++)
      o[a++] = this.host.createVisibleLine();
    e.lines = o.concat(e.lines);
  }
  _removeLinesBefore(e, t) {
    for (let n = 0; n < t; n++) {
      const r = e.lines[n].getDomNode();
      r && this.domNode.removeChild(r);
    }
    e.lines.splice(0, t);
  }
  _insertLinesAfter(e, t, n, r, s) {
    const o = [];
    let a = 0;
    for (let l = t; l <= n; l++)
      o[a++] = this.host.createVisibleLine();
    e.lines = e.lines.concat(o);
  }
  _removeLinesAfter(e, t) {
    const n = e.linesLength - t;
    for (let r = 0; r < t; r++) {
      const s = e.lines[n + r].getDomNode();
      s && this.domNode.removeChild(s);
    }
    e.lines.splice(n, t);
  }
  _finishRenderingNewLines(e, t, n, r) {
    _h._ttPolicy && (n = _h._ttPolicy.createHTML(n));
    const s = this.domNode.lastChild;
    t || !s ? this.domNode.innerHTML = n : s.insertAdjacentHTML("afterend", n);
    let o = this.domNode.lastChild;
    for (let a = e.linesLength - 1; a >= 0; a--) {
      const l = e.lines[a];
      r[a] && (l.setDomNode(o), o = o.previousSibling);
    }
  }
  _finishRenderingInvalidLines(e, t, n) {
    const r = document.createElement("div");
    _h._ttPolicy && (t = _h._ttPolicy.createHTML(t)), r.innerHTML = t;
    for (let s = 0; s < e.linesLength; s++) {
      const o = e.lines[s];
      if (n[s]) {
        const a = r.firstChild, l = o.getDomNode();
        l.parentNode.replaceChild(a, l), o.setDomNode(a);
      }
    }
  }
  _finishRendering(e, t, n) {
    const r = _h._sb, s = e.linesLength, o = e.lines, a = e.rendLineNumberStart, l = [];
    {
      r.reset();
      let c = !1;
      for (let d = 0; d < s; d++) {
        const u = o[d];
        l[d] = !1, !(u.getDomNode() || !u.renderLine(d + a, n[d], this.viewportData, r)) && (l[d] = !0, c = !0);
      }
      c && this._finishRenderingNewLines(e, t, r.build(), l);
    }
    {
      r.reset();
      let c = !1;
      const d = [];
      for (let u = 0; u < s; u++) {
        const h = o[u];
        d[u] = !1, !(l[u] || !h.renderLine(u + a, n[u], this.viewportData, r)) && (d[u] = !0, c = !0);
      }
      c && this._finishRenderingInvalidLines(e, r.build(), d);
    }
  }
}
_h._ttPolicy = af("editorViewLayer", { createHTML: (i) => i });
_h._sb = new pb(1e5);
class sge extends ca {
  constructor(e) {
    super(e), this._visibleLines = new rge(this), this.domNode = this._visibleLines.domNode;
    const n = this._context.configuration.options.get(
      50
      /* EditorOption.fontInfo */
    );
    Ds(this.domNode, n), this._dynamicOverlays = [], this._isFocused = !1, this.domNode.setClassName("view-overlays");
  }
  shouldRender() {
    if (super.shouldRender())
      return !0;
    for (let e = 0, t = this._dynamicOverlays.length; e < t; e++)
      if (this._dynamicOverlays[e].shouldRender())
        return !0;
    return !1;
  }
  dispose() {
    super.dispose();
    for (let e = 0, t = this._dynamicOverlays.length; e < t; e++)
      this._dynamicOverlays[e].dispose();
    this._dynamicOverlays = [];
  }
  getDomNode() {
    return this.domNode;
  }
  // ---- begin IVisibleLinesHost
  createVisibleLine() {
    return new yFe(this._context.configuration, this._dynamicOverlays);
  }
  // ---- end IVisibleLinesHost
  addDynamicOverlay(e) {
    this._dynamicOverlays.push(e);
  }
  // ----- event handlers
  onConfigurationChanged(e) {
    this._visibleLines.onConfigurationChanged(e);
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    for (let o = t; o <= n; o++)
      this._visibleLines.getVisibleLine(o).onConfigurationChanged(e);
    const s = this._context.configuration.options.get(
      50
      /* EditorOption.fontInfo */
    );
    return Ds(this.domNode, s), !0;
  }
  onFlushed(e) {
    return this._visibleLines.onFlushed(e);
  }
  onFocusChanged(e) {
    return this._isFocused = e.isFocused, !0;
  }
  onLinesChanged(e) {
    return this._visibleLines.onLinesChanged(e);
  }
  onLinesDeleted(e) {
    return this._visibleLines.onLinesDeleted(e);
  }
  onLinesInserted(e) {
    return this._visibleLines.onLinesInserted(e);
  }
  onScrollChanged(e) {
    return this._visibleLines.onScrollChanged(e) || !0;
  }
  onTokensChanged(e) {
    return this._visibleLines.onTokensChanged(e);
  }
  onZonesChanged(e) {
    return this._visibleLines.onZonesChanged(e);
  }
  // ----- end event handlers
  prepareRender(e) {
    const t = this._dynamicOverlays.filter((n) => n.shouldRender());
    for (let n = 0, r = t.length; n < r; n++) {
      const s = t[n];
      s.prepareRender(e), s.onDidRender();
    }
  }
  render(e) {
    this._viewOverlaysRender(e), this.domNode.toggleClassName("focused", this._isFocused);
  }
  _viewOverlaysRender(e) {
    this._visibleLines.renderLines(e.viewportData);
  }
}
class yFe {
  constructor(e, t) {
    this._configuration = e, this._lineHeight = this._configuration.options.get(
      66
      /* EditorOption.lineHeight */
    ), this._dynamicOverlays = t, this._domNode = null, this._renderedContent = null;
  }
  getDomNode() {
    return this._domNode ? this._domNode.domNode : null;
  }
  setDomNode(e) {
    this._domNode = Dn(e);
  }
  onContentChanged() {
  }
  onTokensChanged() {
  }
  onConfigurationChanged(e) {
    this._lineHeight = this._configuration.options.get(
      66
      /* EditorOption.lineHeight */
    );
  }
  renderLine(e, t, n, r) {
    let s = "";
    for (let o = 0, a = this._dynamicOverlays.length; o < a; o++) {
      const l = this._dynamicOverlays[o];
      s += l.render(n.startLineNumber, e);
    }
    return this._renderedContent === s ? !1 : (this._renderedContent = s, r.appendString('<div style="position:absolute;top:'), r.appendString(String(t)), r.appendString("px;width:100%;height:"), r.appendString(String(this._lineHeight)), r.appendString('px;">'), r.appendString(s), r.appendString("</div>"), !0);
  }
  layoutLine(e, t) {
    this._domNode && (this._domNode.setTop(t), this._domNode.setHeight(this._lineHeight));
  }
}
class wFe extends sge {
  constructor(e) {
    super(e);
    const n = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._contentWidth = n.contentWidth, this.domNode.setHeight(0);
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const n = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    );
    return this._contentWidth = n.contentWidth, super.onConfigurationChanged(e) || !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollWidthChanged;
  }
  // --- end event handlers
  _viewOverlaysRender(e) {
    super._viewOverlaysRender(e), this.domNode.setWidth(Math.max(e.scrollWidth, this._contentWidth));
  }
}
class SFe extends sge {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._contentLeft = n.contentLeft, this.domNode.setClassName("margin-view-overlays"), this.domNode.setWidth(1), Ds(this.domNode, t.get(
      50
      /* EditorOption.fontInfo */
    ));
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    Ds(this.domNode, t.get(
      50
      /* EditorOption.fontInfo */
    ));
    const n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    return this._contentLeft = n.contentLeft, super.onConfigurationChanged(e) || !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollHeightChanged;
  }
  _viewOverlaysRender(e) {
    super._viewOverlaysRender(e);
    const t = Math.min(e.scrollHeight, 1e6);
    this.domNode.setHeight(t), this.domNode.setWidth(this._contentLeft);
  }
}
class xFe extends ca {
  constructor(e, t) {
    super(e), this._viewDomNode = t, this._widgets = {}, this.domNode = Dn(document.createElement("div")), Su.write(
      this.domNode,
      1
      /* PartFingerprint.ContentWidgets */
    ), this.domNode.setClassName("contentWidgets"), this.domNode.setPosition("absolute"), this.domNode.setTop(0), this.overflowingContentWidgetsDomNode = Dn(document.createElement("div")), Su.write(
      this.overflowingContentWidgetsDomNode,
      2
      /* PartFingerprint.OverflowingContentWidgets */
    ), this.overflowingContentWidgetsDomNode.setClassName("overflowingContentWidgets");
  }
  dispose() {
    super.dispose(), this._widgets = {};
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = Object.keys(this._widgets);
    for (const n of t)
      this._widgets[n].onConfigurationChanged(e);
    return !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLineMappingChanged(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesChanged(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesDeleted(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesInserted(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  // ---- end view event handlers
  _updateAnchorsViewPositions() {
    const e = Object.keys(this._widgets);
    for (const t of e)
      this._widgets[t].updateAnchorViewPosition();
  }
  addWidget(e) {
    const t = new DFe(this._context, this._viewDomNode, e);
    this._widgets[t.id] = t, t.allowEditorOverflow ? this.overflowingContentWidgetsDomNode.appendChild(t.domNode) : this.domNode.appendChild(t.domNode), this.setShouldRender();
  }
  setWidgetPosition(e, t, n, r, s) {
    this._widgets[e.getId()].setPosition(t, n, r, s), this.setShouldRender();
  }
  removeWidget(e) {
    const t = e.getId();
    if (this._widgets.hasOwnProperty(t)) {
      const n = this._widgets[t];
      delete this._widgets[t];
      const r = n.domNode.domNode;
      r.parentNode.removeChild(r), r.removeAttribute("monaco-visible-content-widget"), this.setShouldRender();
    }
  }
  shouldSuppressMouseDownOnWidget(e) {
    return this._widgets.hasOwnProperty(e) ? this._widgets[e].suppressMouseDown : !1;
  }
  onBeforeRender(e) {
    const t = Object.keys(this._widgets);
    for (const n of t)
      this._widgets[n].onBeforeRender(e);
  }
  prepareRender(e) {
    const t = Object.keys(this._widgets);
    for (const n of t)
      this._widgets[n].prepareRender(e);
  }
  render(e) {
    const t = Object.keys(this._widgets);
    for (const n of t)
      this._widgets[n].render(e);
  }
}
class DFe {
  constructor(e, t, n) {
    this._primaryAnchor = new s2(null, null), this._secondaryAnchor = new s2(null, null), this._context = e, this._viewDomNode = t, this._actual = n, this.domNode = Dn(this._actual.getDomNode()), this.id = this._actual.getId(), this.allowEditorOverflow = this._actual.allowEditorOverflow || !1, this.suppressMouseDown = this._actual.suppressMouseDown || !1;
    const r = this._context.configuration.options, s = r.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._fixedOverflowWidgets = r.get(
      42
      /* EditorOption.fixedOverflowWidgets */
    ), this._contentWidth = s.contentWidth, this._contentLeft = s.contentLeft, this._lineHeight = r.get(
      66
      /* EditorOption.lineHeight */
    ), this._affinity = null, this._preference = [], this._cachedDomNodeOffsetWidth = -1, this._cachedDomNodeOffsetHeight = -1, this._maxWidth = this._getMaxWidth(), this._isVisible = !1, this._renderData = null, this.domNode.setPosition(this._fixedOverflowWidgets && this.allowEditorOverflow ? "fixed" : "absolute"), this.domNode.setDisplay("none"), this.domNode.setVisibility("hidden"), this.domNode.setAttribute("widgetId", this.id), this.domNode.setMaxWidth(this._maxWidth);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    if (this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), e.hasChanged(
      143
      /* EditorOption.layoutInfo */
    )) {
      const n = t.get(
        143
        /* EditorOption.layoutInfo */
      );
      this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, this._maxWidth = this._getMaxWidth();
    }
  }
  updateAnchorViewPosition() {
    this._setPosition(this._affinity, this._primaryAnchor.modelPosition, this._secondaryAnchor.modelPosition);
  }
  _setPosition(e, t, n) {
    this._affinity = e, this._primaryAnchor = r(t, this._context.viewModel, this._affinity), this._secondaryAnchor = r(n, this._context.viewModel, this._affinity);
    function r(s, o, a) {
      if (!s)
        return new s2(null, null);
      const l = o.model.validatePosition(s);
      if (o.coordinatesConverter.modelPositionIsVisible(l)) {
        const c = o.coordinatesConverter.convertModelPositionToViewPosition(l, a ?? void 0);
        return new s2(s, c);
      }
      return new s2(s, null);
    }
  }
  _getMaxWidth() {
    const e = this.domNode.domNode.ownerDocument, t = e.defaultView;
    return this.allowEditorOverflow ? t?.innerWidth || e.documentElement.offsetWidth || e.body.offsetWidth : this._contentWidth;
  }
  setPosition(e, t, n, r) {
    this._setPosition(r, e, t), this._preference = n, this._primaryAnchor.viewPosition && this._preference && this._preference.length > 0 ? this.domNode.setDisplay("block") : this.domNode.setDisplay("none"), this._cachedDomNodeOffsetWidth = -1, this._cachedDomNodeOffsetHeight = -1;
  }
  _layoutBoxInViewport(e, t, n, r) {
    const s = e.top, o = s, a = e.top + e.height, l = r.viewportHeight - a, c = s - n, d = o >= n, u = a, h = l >= n;
    let f = e.left;
    return f + t > r.scrollLeft + r.viewportWidth && (f = r.scrollLeft + r.viewportWidth - t), f < r.scrollLeft && (f = r.scrollLeft), { fitsAbove: d, aboveTop: c, fitsBelow: h, belowTop: u, left: f };
  }
  _layoutHorizontalSegmentInPage(e, t, n, r) {
    var s;
    const l = Math.max(15, t.left - r), c = Math.min(t.left + t.width + r, e.width - 15), u = this._viewDomNode.domNode.ownerDocument.defaultView;
    let h = t.left + n - ((s = u?.scrollX) !== null && s !== void 0 ? s : 0);
    if (h + r > c) {
      const f = h - (c - r);
      h -= f, n -= f;
    }
    if (h < l) {
      const f = h - l;
      h -= f, n -= f;
    }
    return [n, h];
  }
  _layoutBoxInPage(e, t, n, r) {
    var s, o;
    const a = e.top - n, l = e.top + e.height, c = wr(this._viewDomNode.domNode), d = this._viewDomNode.domNode.ownerDocument, u = d.defaultView, h = c.top + a - ((s = u?.scrollY) !== null && s !== void 0 ? s : 0), f = c.top + l - ((o = u?.scrollY) !== null && o !== void 0 ? o : 0), g = fb(d.body), [p, m] = this._layoutHorizontalSegmentInPage(g, c, e.left - r.scrollLeft + this._contentLeft, t), _ = 22, b = 22, w = h >= _, y = f + n <= g.height - b;
    return this._fixedOverflowWidgets ? {
      fitsAbove: w,
      aboveTop: Math.max(h, _),
      fitsBelow: y,
      belowTop: f,
      left: m
    } : { fitsAbove: w, aboveTop: a, fitsBelow: y, belowTop: l, left: p };
  }
  _prepareRenderWidgetAtExactPositionOverflowing(e) {
    return new o2(e.top, e.left + this._contentLeft);
  }
  /**
   * Compute the coordinates above and below the primary and secondary anchors.
   * The content widget *must* touch the primary anchor.
   * The content widget should touch if possible the secondary anchor.
   */
  _getAnchorsCoordinates(e) {
    var t, n;
    const r = a(this._primaryAnchor.viewPosition, this._affinity, this._lineHeight), s = ((t = this._secondaryAnchor.viewPosition) === null || t === void 0 ? void 0 : t.lineNumber) === ((n = this._primaryAnchor.viewPosition) === null || n === void 0 ? void 0 : n.lineNumber) ? this._secondaryAnchor.viewPosition : null, o = a(s, this._affinity, this._lineHeight);
    return { primary: r, secondary: o };
    function a(l, c, d) {
      if (!l)
        return null;
      const u = e.visibleRangeForPosition(l);
      if (!u)
        return null;
      const h = l.column === 1 && c === 3 ? 0 : u.left, f = e.getVerticalOffsetForLineNumber(l.lineNumber) - e.scrollTop;
      return new TZ(f, h, d);
    }
  }
  _reduceAnchorCoordinates(e, t, n) {
    if (!t)
      return e;
    const r = this._context.configuration.options.get(
      50
      /* EditorOption.fontInfo */
    );
    let s = t.left;
    return s < e.left ? s = Math.max(s, e.left - n + r.typicalFullwidthCharacterWidth) : s = Math.min(s, e.left + n - r.typicalFullwidthCharacterWidth), new TZ(e.top, s, e.height);
  }
  _prepareRenderWidget(e) {
    if (!this._preference || this._preference.length === 0)
      return null;
    const { primary: t, secondary: n } = this._getAnchorsCoordinates(e);
    if (!t)
      return null;
    if (this._cachedDomNodeOffsetWidth === -1 || this._cachedDomNodeOffsetHeight === -1) {
      let o = null;
      if (typeof this._actual.beforeRender == "function" && (o = N6(this._actual.beforeRender, this._actual)), o)
        this._cachedDomNodeOffsetWidth = o.width, this._cachedDomNodeOffsetHeight = o.height;
      else {
        const l = this.domNode.domNode.getBoundingClientRect();
        this._cachedDomNodeOffsetWidth = Math.round(l.width), this._cachedDomNodeOffsetHeight = Math.round(l.height);
      }
    }
    const r = this._reduceAnchorCoordinates(t, n, this._cachedDomNodeOffsetWidth);
    let s;
    this.allowEditorOverflow ? s = this._layoutBoxInPage(r, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, e) : s = this._layoutBoxInViewport(r, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, e);
    for (let o = 1; o <= 2; o++)
      for (const a of this._preference)
        if (a === 1) {
          if (!s)
            return null;
          if (o === 2 || s.fitsAbove)
            return {
              coordinate: new o2(s.aboveTop, s.left),
              position: 1
              /* ContentWidgetPositionPreference.ABOVE */
            };
        } else if (a === 2) {
          if (!s)
            return null;
          if (o === 2 || s.fitsBelow)
            return {
              coordinate: new o2(s.belowTop, s.left),
              position: 2
              /* ContentWidgetPositionPreference.BELOW */
            };
        } else
          return this.allowEditorOverflow ? {
            coordinate: this._prepareRenderWidgetAtExactPositionOverflowing(new o2(r.top, r.left)),
            position: 0
            /* ContentWidgetPositionPreference.EXACT */
          } : {
            coordinate: new o2(r.top, r.left),
            position: 0
            /* ContentWidgetPositionPreference.EXACT */
          };
    return null;
  }
  /**
   * On this first pass, we ensure that the content widget (if it is in the viewport) has the max width set correctly.
   */
  onBeforeRender(e) {
    !this._primaryAnchor.viewPosition || !this._preference || this._primaryAnchor.viewPosition.lineNumber < e.startLineNumber || this._primaryAnchor.viewPosition.lineNumber > e.endLineNumber || this.domNode.setMaxWidth(this._maxWidth);
  }
  prepareRender(e) {
    this._renderData = this._prepareRenderWidget(e);
  }
  render(e) {
    if (!this._renderData) {
      this._isVisible && (this.domNode.removeAttribute("monaco-visible-content-widget"), this._isVisible = !1, this.domNode.setVisibility("hidden")), typeof this._actual.afterRender == "function" && N6(this._actual.afterRender, this._actual, null);
      return;
    }
    this.allowEditorOverflow ? (this.domNode.setTop(this._renderData.coordinate.top), this.domNode.setLeft(this._renderData.coordinate.left)) : (this.domNode.setTop(this._renderData.coordinate.top + e.scrollTop - e.bigNumbersDelta), this.domNode.setLeft(this._renderData.coordinate.left)), this._isVisible || (this.domNode.setVisibility("inherit"), this.domNode.setAttribute("monaco-visible-content-widget", "true"), this._isVisible = !0), typeof this._actual.afterRender == "function" && N6(this._actual.afterRender, this._actual, this._renderData.position);
  }
}
class s2 {
  constructor(e, t) {
    this.modelPosition = e, this.viewPosition = t;
  }
}
class o2 {
  constructor(e, t) {
    this.top = e, this.left = t, this._coordinateBrand = void 0;
  }
}
class TZ {
  constructor(e, t, n) {
    this.top = e, this.left = t, this.height = n, this._anchorCoordinateBrand = void 0;
  }
}
function N6(i, e, ...t) {
  try {
    return i.call(e, ...t);
  } catch {
    return null;
  }
}
class oge extends O0 {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._renderLineHighlight = t.get(
      95
      /* EditorOption.renderLineHighlight */
    ), this._renderLineHighlightOnlyWhenFocus = t.get(
      96
      /* EditorOption.renderLineHighlightOnlyWhenFocus */
    ), this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, this._selectionIsEmpty = !0, this._focused = !1, this._cursorLineNumbers = [1], this._selections = [new ot(1, 1, 1, 1)], this._renderData = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
  _readFromSelections() {
    let e = !1;
    const t = this._selections.map((r) => r.positionLineNumber);
    t.sort((r, s) => r - s), Qi(this._cursorLineNumbers, t) || (this._cursorLineNumbers = t, e = !0);
    const n = this._selections.every((r) => r.isEmpty());
    return this._selectionIsEmpty !== n && (this._selectionIsEmpty = n, e = !0), e;
  }
  // --- begin event handlers
  onThemeChanged(e) {
    return this._readFromSelections();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    return this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._renderLineHighlight = t.get(
      95
      /* EditorOption.renderLineHighlight */
    ), this._renderLineHighlightOnlyWhenFocus = t.get(
      96
      /* EditorOption.renderLineHighlightOnlyWhenFocus */
    ), this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, this._readFromSelections();
  }
  onFlushed(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollWidthChanged || e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onFocusChanged(e) {
    return this._renderLineHighlightOnlyWhenFocus ? (this._focused = e.isFocused, !0) : !1;
  }
  // --- end event handlers
  prepareRender(e) {
    if (!this._shouldRenderThis()) {
      this._renderData = null;
      return;
    }
    const t = this._renderOne(e), n = e.visibleRange.startLineNumber, r = e.visibleRange.endLineNumber, s = this._cursorLineNumbers.length;
    let o = 0;
    const a = [];
    for (let l = n; l <= r; l++) {
      const c = l - n;
      for (; o < s && this._cursorLineNumbers[o] < l; )
        o++;
      o < s && this._cursorLineNumbers[o] === l ? a[c] = t : a[c] = "";
    }
    this._renderData = a;
  }
  render(e, t) {
    if (!this._renderData)
      return "";
    const n = t - e;
    return n >= this._renderData.length ? "" : this._renderData[n];
  }
  _shouldRenderInMargin() {
    return (this._renderLineHighlight === "gutter" || this._renderLineHighlight === "all") && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
  }
  _shouldRenderInContent() {
    return (this._renderLineHighlight === "line" || this._renderLineHighlight === "all") && this._selectionIsEmpty && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
  }
}
class EFe extends oge {
  _renderOne(e) {
    return `<div class="${"current-line" + (this._shouldRenderOther() ? " current-line-both" : "")}" style="width:${Math.max(e.scrollWidth, this._contentWidth)}px; height:${this._lineHeight}px;"></div>`;
  }
  _shouldRenderThis() {
    return this._shouldRenderInContent();
  }
  _shouldRenderOther() {
    return this._shouldRenderInMargin();
  }
}
class LFe extends oge {
  _renderOne(e) {
    return `<div class="${"current-line" + (this._shouldRenderInMargin() ? " current-line-margin" : "") + (this._shouldRenderOther() ? " current-line-margin-both" : "")}" style="width:${this._contentLeft}px; height:${this._lineHeight}px;"></div>`;
  }
  _shouldRenderThis() {
    return !0;
  }
  _shouldRenderOther() {
    return this._shouldRenderInContent();
  }
}
fc((i, e) => {
  const t = i.getColor(Gfe);
  if (t && (e.addRule(`.monaco-editor .view-overlays .current-line { background-color: ${t}; }`), e.addRule(`.monaco-editor .margin-view-overlays .current-line-margin { background-color: ${t}; border: none; }`)), !t || t.isTransparent() || i.defines(EZ)) {
    const n = i.getColor(EZ);
    n && (e.addRule(`.monaco-editor .view-overlays .current-line { border: 2px solid ${n}; }`), e.addRule(`.monaco-editor .margin-view-overlays .current-line-margin { border: 2px solid ${n}; }`), ed(i.type) && (e.addRule(".monaco-editor .view-overlays .current-line { border-width: 1px; }"), e.addRule(".monaco-editor .margin-view-overlays .current-line-margin { border-width: 1px; }")));
  }
});
class IFe extends O0 {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options;
    this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollWidthChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  prepareRender(e) {
    const t = e.getDecorationsInViewport();
    let n = [], r = 0;
    for (let l = 0, c = t.length; l < c; l++) {
      const d = t[l];
      d.options.className && (n[r++] = d);
    }
    n = n.sort((l, c) => {
      if (l.options.zIndex < c.options.zIndex)
        return -1;
      if (l.options.zIndex > c.options.zIndex)
        return 1;
      const d = l.options.className, u = c.options.className;
      return d < u ? -1 : d > u ? 1 : V.compareRangesUsingStarts(l.range, c.range);
    });
    const s = e.visibleRange.startLineNumber, o = e.visibleRange.endLineNumber, a = [];
    for (let l = s; l <= o; l++) {
      const c = l - s;
      a[c] = "";
    }
    this._renderWholeLineDecorations(e, n, a), this._renderNormalDecorations(e, n, a), this._renderResult = a;
  }
  _renderWholeLineDecorations(e, t, n) {
    const r = String(this._lineHeight), s = e.visibleRange.startLineNumber, o = e.visibleRange.endLineNumber;
    for (let a = 0, l = t.length; a < l; a++) {
      const c = t[a];
      if (!c.options.isWholeLine)
        continue;
      const d = '<div class="cdr ' + c.options.className + '" style="left:0;width:100%;height:' + r + 'px;"></div>', u = Math.max(c.range.startLineNumber, s), h = Math.min(c.range.endLineNumber, o);
      for (let f = u; f <= h; f++) {
        const g = f - s;
        n[g] += d;
      }
    }
  }
  _renderNormalDecorations(e, t, n) {
    var r;
    const s = String(this._lineHeight), o = e.visibleRange.startLineNumber;
    let a = null, l = !1, c = null, d = !1;
    for (let u = 0, h = t.length; u < h; u++) {
      const f = t[u];
      if (f.options.isWholeLine)
        continue;
      const g = f.options.className, p = !!f.options.showIfCollapsed;
      let m = f.range;
      if (p && m.endColumn === 1 && m.endLineNumber !== m.startLineNumber && (m = new V(m.startLineNumber, m.startColumn, m.endLineNumber - 1, this._context.viewModel.getLineMaxColumn(m.endLineNumber - 1))), a === g && l === p && V.areIntersectingOrTouching(c, m)) {
        c = V.plusRange(c, m);
        continue;
      }
      a !== null && this._renderNormalDecoration(e, c, a, d, l, s, o, n), a = g, l = p, c = m, d = (r = f.options.shouldFillLineOnLineBreak) !== null && r !== void 0 ? r : !1;
    }
    a !== null && this._renderNormalDecoration(e, c, a, d, l, s, o, n);
  }
  _renderNormalDecoration(e, t, n, r, s, o, a, l) {
    const c = e.linesVisibleRangesForRange(
      t,
      /*TODO@Alex*/
      n === "findMatch"
    );
    if (c)
      for (let d = 0, u = c.length; d < u; d++) {
        const h = c[d];
        if (h.outsideRenderedLine)
          continue;
        const f = h.lineNumber - a;
        if (s && h.ranges.length === 1) {
          const g = h.ranges[0];
          if (g.width < this._typicalHalfwidthCharacterWidth) {
            const p = Math.round(g.left + g.width / 2), m = Math.max(0, Math.round(p - this._typicalHalfwidthCharacterWidth / 2));
            h.ranges[0] = new _4(m, this._typicalHalfwidthCharacterWidth);
          }
        }
        for (let g = 0, p = h.ranges.length; g < p; g++) {
          const m = r && h.continuesOnNextLine && p === 1, _ = h.ranges[g], b = '<div class="cdr ' + n + '" style="left:' + String(_.left) + (m ? "px;width:100%;height:" : "px;width:" + String(_.width) + "px;height:") + o + 'px;"></div>';
          l[f] += b;
        }
      }
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
class AFe extends ca {
  constructor(e, t, n, r) {
    super(e);
    const s = this._context.configuration.options, o = s.get(
      102
      /* EditorOption.scrollbar */
    ), a = s.get(
      74
      /* EditorOption.mouseWheelScrollSensitivity */
    ), l = s.get(
      40
      /* EditorOption.fastScrollSensitivity */
    ), c = s.get(
      105
      /* EditorOption.scrollPredominantAxis */
    ), d = {
      listenOnDomNode: n.domNode,
      className: "editor-scrollable " + PF(e.theme.type),
      useShadows: !1,
      lazyRender: !0,
      vertical: o.vertical,
      horizontal: o.horizontal,
      verticalHasArrows: o.verticalHasArrows,
      horizontalHasArrows: o.horizontalHasArrows,
      verticalScrollbarSize: o.verticalScrollbarSize,
      verticalSliderSize: o.verticalSliderSize,
      horizontalScrollbarSize: o.horizontalScrollbarSize,
      horizontalSliderSize: o.horizontalSliderSize,
      handleMouseWheel: o.handleMouseWheel,
      alwaysConsumeMouseWheel: o.alwaysConsumeMouseWheel,
      arrowSize: o.arrowSize,
      mouseWheelScrollSensitivity: a,
      fastScrollSensitivity: l,
      scrollPredominantAxis: c,
      scrollByPage: o.scrollByPage
    };
    this.scrollbar = this._register(new wz(t.domNode, d, this._context.viewLayout.getScrollable())), Su.write(
      this.scrollbar.getDomNode(),
      5
      /* PartFingerprint.ScrollableElement */
    ), this.scrollbarDomNode = Dn(this.scrollbar.getDomNode()), this.scrollbarDomNode.setPosition("absolute"), this._setLayout();
    const u = (h, f, g) => {
      const p = {};
      {
        const m = h.scrollTop;
        m && (p.scrollTop = this._context.viewLayout.getCurrentScrollTop() + m, h.scrollTop = 0);
      }
      if (g) {
        const m = h.scrollLeft;
        m && (p.scrollLeft = this._context.viewLayout.getCurrentScrollLeft() + m, h.scrollLeft = 0);
      }
      this._context.viewModel.viewLayout.setScrollPosition(
        p,
        1
        /* ScrollType.Immediate */
      );
    };
    this._register(Ie(n.domNode, "scroll", (h) => u(n.domNode, !0, !0))), this._register(Ie(t.domNode, "scroll", (h) => u(t.domNode, !0, !1))), this._register(Ie(r.domNode, "scroll", (h) => u(r.domNode, !0, !1))), this._register(Ie(this.scrollbarDomNode.domNode, "scroll", (h) => u(this.scrollbarDomNode.domNode, !0, !1)));
  }
  dispose() {
    super.dispose();
  }
  _setLayout() {
    const e = this._context.configuration.options, t = e.get(
      143
      /* EditorOption.layoutInfo */
    );
    this.scrollbarDomNode.setLeft(t.contentLeft), e.get(
      72
      /* EditorOption.minimap */
    ).side === "right" ? this.scrollbarDomNode.setWidth(t.contentWidth + t.minimap.minimapWidth) : this.scrollbarDomNode.setWidth(t.contentWidth), this.scrollbarDomNode.setHeight(t.height);
  }
  getOverviewRulerLayoutInfo() {
    return this.scrollbar.getOverviewRulerLayoutInfo();
  }
  getDomNode() {
    return this.scrollbarDomNode;
  }
  delegateVerticalScrollbarPointerDown(e) {
    this.scrollbar.delegateVerticalScrollbarPointerDown(e);
  }
  delegateScrollFromMouseWheelEvent(e) {
    this.scrollbar.delegateScrollFromMouseWheelEvent(e);
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    if (e.hasChanged(
      102
      /* EditorOption.scrollbar */
    ) || e.hasChanged(
      74
      /* EditorOption.mouseWheelScrollSensitivity */
    ) || e.hasChanged(
      40
      /* EditorOption.fastScrollSensitivity */
    )) {
      const t = this._context.configuration.options, n = t.get(
        102
        /* EditorOption.scrollbar */
      ), r = t.get(
        74
        /* EditorOption.mouseWheelScrollSensitivity */
      ), s = t.get(
        40
        /* EditorOption.fastScrollSensitivity */
      ), o = t.get(
        105
        /* EditorOption.scrollPredominantAxis */
      ), a = {
        vertical: n.vertical,
        horizontal: n.horizontal,
        verticalScrollbarSize: n.verticalScrollbarSize,
        horizontalScrollbarSize: n.horizontalScrollbarSize,
        scrollByPage: n.scrollByPage,
        handleMouseWheel: n.handleMouseWheel,
        mouseWheelScrollSensitivity: r,
        fastScrollSensitivity: s,
        scrollPredominantAxis: o
      };
      this.scrollbar.updateOptions(a);
    }
    return e.hasChanged(
      143
      /* EditorOption.layoutInfo */
    ) && this._setLayout(), !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onThemeChanged(e) {
    return this.scrollbar.updateClassName("editor-scrollable " + PF(this._context.theme.type)), !0;
  }
  // --- end event handlers
  prepareRender(e) {
  }
  render(e) {
    this.scrollbar.renderNow();
  }
}
class age extends we {
  constructor() {
    super(...arguments), this._isDisposed = !1;
  }
  dispose() {
    super.dispose(), this._isDisposed = !0;
  }
  assertNotDisposed() {
    if (this._isDisposed)
      throw new Error("TextModelPart is disposed!");
  }
}
function S4(i, e) {
  let t = 0, n = 0;
  const r = i.length;
  for (; n < r; ) {
    const s = i.charCodeAt(n);
    if (s === 32)
      t++;
    else if (s === 9)
      t = t - t % e + e;
    else
      break;
    n++;
  }
  return n === r ? -1 : t;
}
var Lm;
(function(i) {
  i[i.Disabled = 0] = "Disabled", i[i.EnabledForActive = 1] = "EnabledForActive", i[i.Enabled = 2] = "Enabled";
})(Lm || (Lm = {}));
class gm {
  constructor(e, t, n, r, s, o) {
    if (this.visibleColumn = e, this.column = t, this.className = n, this.horizontalLine = r, this.forWrappedLinesAfterColumn = s, this.forWrappedLinesBeforeOrAtColumn = o, e !== -1 == (t !== -1))
      throw new Error();
  }
}
class LC {
  constructor(e, t) {
    this.top = e, this.endColumn = t;
  }
}
class kFe extends age {
  constructor(e, t) {
    super(), this.textModel = e, this.languageConfigurationService = t;
  }
  getLanguageConfiguration(e) {
    return this.languageConfigurationService.getLanguageConfiguration(e);
  }
  _computeIndentLevel(e) {
    return S4(this.textModel.getLineContent(e + 1), this.textModel.getOptions().tabSize);
  }
  getActiveIndentGuide(e, t, n) {
    this.assertNotDisposed();
    const r = this.textModel.getLineCount();
    if (e < 1 || e > r)
      throw new gr("Illegal value for lineNumber");
    const s = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules, o = !!(s && s.offSide);
    let a = -2, l = -1, c = -2, d = -1;
    const u = (D) => {
      if (a !== -1 && (a === -2 || a > D - 1)) {
        a = -1, l = -1;
        for (let E = D - 2; E >= 0; E--) {
          const L = this._computeIndentLevel(E);
          if (L >= 0) {
            a = E, l = L;
            break;
          }
        }
      }
      if (c === -2) {
        c = -1, d = -1;
        for (let E = D; E < r; E++) {
          const L = this._computeIndentLevel(E);
          if (L >= 0) {
            c = E, d = L;
            break;
          }
        }
      }
    };
    let h = -2, f = -1, g = -2, p = -1;
    const m = (D) => {
      if (h === -2) {
        h = -1, f = -1;
        for (let E = D - 2; E >= 0; E--) {
          const L = this._computeIndentLevel(E);
          if (L >= 0) {
            h = E, f = L;
            break;
          }
        }
      }
      if (g !== -1 && (g === -2 || g < D - 1)) {
        g = -1, p = -1;
        for (let E = D; E < r; E++) {
          const L = this._computeIndentLevel(E);
          if (L >= 0) {
            g = E, p = L;
            break;
          }
        }
      }
    };
    let _ = 0, b = !0, w = 0, y = !0, S = 0, x = 0;
    for (let D = 0; b || y; D++) {
      const E = e - D, L = e + D;
      D > 1 && (E < 1 || E < t) && (b = !1), D > 1 && (L > r || L > n) && (y = !1), D > 5e4 && (b = !1, y = !1);
      let k = -1;
      if (b && E >= 1) {
        const I = this._computeIndentLevel(E - 1);
        I >= 0 ? (c = E - 1, d = I, k = Math.ceil(I / this.textModel.getOptions().indentSize)) : (u(E), k = this._getIndentLevelForWhitespaceLine(o, l, d));
      }
      let N = -1;
      if (y && L <= r) {
        const I = this._computeIndentLevel(L - 1);
        I >= 0 ? (h = L - 1, f = I, N = Math.ceil(I / this.textModel.getOptions().indentSize)) : (m(L), N = this._getIndentLevelForWhitespaceLine(o, f, p));
      }
      if (D === 0) {
        x = k;
        continue;
      }
      if (D === 1) {
        if (L <= r && N >= 0 && x + 1 === N) {
          b = !1, _ = L, w = L, S = N;
          continue;
        }
        if (E >= 1 && k >= 0 && k - 1 === x) {
          y = !1, _ = E, w = E, S = k;
          continue;
        }
        if (_ = e, w = e, S = x, S === 0)
          return { startLineNumber: _, endLineNumber: w, indent: S };
      }
      b && (k >= S ? _ = E : b = !1), y && (N >= S ? w = L : y = !1);
    }
    return { startLineNumber: _, endLineNumber: w, indent: S };
  }
  getLinesBracketGuides(e, t, n, r) {
    var s;
    const o = [];
    for (let h = e; h <= t; h++)
      o.push([]);
    const a = !0, l = this.textModel.bracketPairs.getBracketPairsInRangeWithMinIndentation(new V(e, 1, t, this.textModel.getLineMaxColumn(t))).toArray();
    let c;
    if (n && l.length > 0) {
      const h = (e <= n.lineNumber && n.lineNumber <= t ? l : this.textModel.bracketPairs.getBracketPairsInRange(V.fromPositions(n)).toArray()).filter((f) => V.strictContainsPosition(f.range, n));
      c = (s = sL(h, (f) => a)) === null || s === void 0 ? void 0 : s.range;
    }
    const d = this.textModel.getOptions().bracketPairColorizationOptions.independentColorPoolPerBracketType, u = new lge();
    for (const h of l) {
      if (!h.closingBracketRange)
        continue;
      const f = c && h.range.equalsRange(c);
      if (!f && !r.includeInactive)
        continue;
      const g = u.getInlineClassName(h.nestingLevel, h.nestingLevelOfEqualBracketType, d) + (r.highlightActive && f ? " " + u.activeClassName : ""), p = h.openingBracketRange.getStartPosition(), m = h.closingBracketRange.getStartPosition(), _ = r.horizontalGuides === Lm.Enabled || r.horizontalGuides === Lm.EnabledForActive && f;
      if (h.range.startLineNumber === h.range.endLineNumber) {
        _ && o[h.range.startLineNumber - e].push(new gm(-1, h.openingBracketRange.getEndPosition().column, g, new LC(!1, m.column), -1, -1));
        continue;
      }
      const b = this.getVisibleColumnFromPosition(m), w = this.getVisibleColumnFromPosition(h.openingBracketRange.getStartPosition()), y = Math.min(w, b, h.minVisibleColumnIndentation + 1);
      let S = !1;
      Js(this.textModel.getLineContent(h.closingBracketRange.startLineNumber)) < h.closingBracketRange.startColumn - 1 && (S = !0);
      const E = Math.max(p.lineNumber, e), L = Math.min(m.lineNumber, t), k = S ? 1 : 0;
      for (let N = E; N < L + k; N++)
        o[N - e].push(new gm(y, -1, g, null, N === p.lineNumber ? p.column : -1, N === m.lineNumber ? m.column : -1));
      _ && (p.lineNumber >= e && w > y && o[p.lineNumber - e].push(new gm(y, -1, g, new LC(!1, p.column), -1, -1)), m.lineNumber <= t && b > y && o[m.lineNumber - e].push(new gm(y, -1, g, new LC(!S, m.column), -1, -1)));
    }
    for (const h of o)
      h.sort((f, g) => f.visibleColumn - g.visibleColumn);
    return o;
  }
  getVisibleColumnFromPosition(e) {
    return Lr.visibleColumnFromColumn(this.textModel.getLineContent(e.lineNumber), e.column, this.textModel.getOptions().tabSize) + 1;
  }
  getLinesIndentGuides(e, t) {
    this.assertNotDisposed();
    const n = this.textModel.getLineCount();
    if (e < 1 || e > n)
      throw new Error("Illegal value for startLineNumber");
    if (t < 1 || t > n)
      throw new Error("Illegal value for endLineNumber");
    const r = this.textModel.getOptions(), s = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules, o = !!(s && s.offSide), a = new Array(t - e + 1);
    let l = -2, c = -1, d = -2, u = -1;
    for (let h = e; h <= t; h++) {
      const f = h - e, g = this._computeIndentLevel(h - 1);
      if (g >= 0) {
        l = h - 1, c = g, a[f] = Math.ceil(g / r.indentSize);
        continue;
      }
      if (l === -2) {
        l = -1, c = -1;
        for (let p = h - 2; p >= 0; p--) {
          const m = this._computeIndentLevel(p);
          if (m >= 0) {
            l = p, c = m;
            break;
          }
        }
      }
      if (d !== -1 && (d === -2 || d < h - 1)) {
        d = -1, u = -1;
        for (let p = h; p < n; p++) {
          const m = this._computeIndentLevel(p);
          if (m >= 0) {
            d = p, u = m;
            break;
          }
        }
      }
      a[f] = this._getIndentLevelForWhitespaceLine(o, c, u);
    }
    return a;
  }
  _getIndentLevelForWhitespaceLine(e, t, n) {
    const r = this.textModel.getOptions();
    return t === -1 || n === -1 ? 0 : t < n ? 1 + Math.floor(t / r.indentSize) : t === n || e ? Math.ceil(n / r.indentSize) : 1 + Math.floor(n / r.indentSize);
  }
}
class lge {
  constructor() {
    this.activeClassName = "indent-active";
  }
  getInlineClassName(e, t, n) {
    return this.getInlineClassNameOfLevel(n ? t : e);
  }
  getInlineClassNameOfLevel(e) {
    return `bracket-indent-guide lvl-${e % 30}`;
  }
}
class TFe extends O0 {
  constructor(e) {
    super(), this._context = e, this._primaryPosition = null;
    const t = this._context.configuration.options, n = t.get(
      144
      /* EditorOption.wrappingInfo */
    ), r = t.get(
      50
      /* EditorOption.fontInfo */
    );
    this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._spaceWidth = r.spaceWidth, this._maxIndentLeft = n.wrappingColumn === -1 ? -1 : n.wrappingColumn * r.typicalHalfwidthCharacterWidth, this._bracketPairGuideOptions = t.get(
      16
      /* EditorOption.guides */
    ), this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      144
      /* EditorOption.wrappingInfo */
    ), r = t.get(
      50
      /* EditorOption.fontInfo */
    );
    return this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._spaceWidth = r.spaceWidth, this._maxIndentLeft = n.wrappingColumn === -1 ? -1 : n.wrappingColumn * r.typicalHalfwidthCharacterWidth, this._bracketPairGuideOptions = t.get(
      16
      /* EditorOption.guides */
    ), !0;
  }
  onCursorStateChanged(e) {
    var t;
    const r = e.selections[0].getPosition();
    return !((t = this._primaryPosition) === null || t === void 0) && t.equals(r) ? !1 : (this._primaryPosition = r, !0);
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onLanguageConfigurationChanged(e) {
    return !0;
  }
  // --- end event handlers
  prepareRender(e) {
    var t, n, r, s;
    if (!this._bracketPairGuideOptions.indentation && this._bracketPairGuideOptions.bracketPairs === !1) {
      this._renderResult = null;
      return;
    }
    const o = e.visibleRange.startLineNumber, a = e.visibleRange.endLineNumber, l = e.scrollWidth, c = this._lineHeight, d = this._primaryPosition, u = this.getGuidesByLine(o, Math.min(a + 1, this._context.viewModel.getLineCount()), d), h = [];
    for (let f = o; f <= a; f++) {
      const g = f - o, p = u[g];
      let m = "";
      const _ = (n = (t = e.visibleRangeForPosition(new ve(f, 1))) === null || t === void 0 ? void 0 : t.left) !== null && n !== void 0 ? n : 0;
      for (const b of p) {
        const w = b.column === -1 ? _ + (b.visibleColumn - 1) * this._spaceWidth : e.visibleRangeForPosition(new ve(f, b.column)).left;
        if (w > l || this._maxIndentLeft > 0 && w > this._maxIndentLeft)
          break;
        const y = b.horizontalLine ? b.horizontalLine.top ? "horizontal-top" : "horizontal-bottom" : "vertical", S = b.horizontalLine ? ((s = (r = e.visibleRangeForPosition(new ve(f, b.horizontalLine.endColumn))) === null || r === void 0 ? void 0 : r.left) !== null && s !== void 0 ? s : w + this._spaceWidth) - w : this._spaceWidth;
        m += `<div class="core-guide ${b.className} ${y}" style="left:${w}px;height:${c}px;width:${S}px"></div>`;
      }
      h[g] = m;
    }
    this._renderResult = h;
  }
  getGuidesByLine(e, t, n) {
    const r = this._bracketPairGuideOptions.bracketPairs !== !1 ? this._context.viewModel.getBracketGuidesInRangeByLine(e, t, n, {
      highlightActive: this._bracketPairGuideOptions.highlightActiveBracketPair,
      horizontalGuides: this._bracketPairGuideOptions.bracketPairsHorizontal === !0 ? Lm.Enabled : this._bracketPairGuideOptions.bracketPairsHorizontal === "active" ? Lm.EnabledForActive : Lm.Disabled,
      includeInactive: this._bracketPairGuideOptions.bracketPairs === !0
    }) : null, s = this._bracketPairGuideOptions.indentation ? this._context.viewModel.getLinesIndentGuides(e, t) : null;
    let o = 0, a = 0, l = 0;
    if (this._bracketPairGuideOptions.highlightActiveIndentation !== !1 && n) {
      const u = this._context.viewModel.getActiveIndentGuide(n.lineNumber, e, t);
      o = u.startLineNumber, a = u.endLineNumber, l = u.indent;
    }
    const { indentSize: c } = this._context.viewModel.model.getOptions(), d = [];
    for (let u = e; u <= t; u++) {
      const h = new Array();
      d.push(h);
      const f = r ? r[u - e] : [], g = new Xh(f), p = s ? s[u - e] : 0;
      for (let m = 1; m <= p; m++) {
        const _ = (m - 1) * c + 1, b = (
          // Disable active indent guide if there are bracket guides.
          (this._bracketPairGuideOptions.highlightActiveIndentation === "always" || f.length === 0) && o <= u && u <= a && m === l
        );
        h.push(...g.takeWhile((y) => y.visibleColumn < _) || []);
        const w = g.peek();
        (!w || w.visibleColumn !== _ || w.horizontalLine) && h.push(new gm(_, -1, `core-guide-indent lvl-${(m - 1) % 30}` + (b ? " indent-active" : ""), null, -1, -1));
      }
      h.push(...g.takeWhile((m) => !0) || []);
    }
    return d;
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
function f1(i) {
  if (!(i && i.isTransparent()))
    return i;
}
fc((i, e) => {
  const t = [
    { bracketColor: Yfe, guideColor: WRe, guideColorActive: KRe },
    { bracketColor: Xfe, guideColor: jRe, guideColorActive: YRe },
    { bracketColor: Zfe, guideColor: zRe, guideColorActive: XRe },
    { bracketColor: Qfe, guideColor: URe, guideColorActive: ZRe },
    { bracketColor: Jfe, guideColor: GRe, guideColorActive: QRe },
    { bracketColor: $fe, guideColor: qRe, guideColorActive: JRe }
  ], n = new lge(), r = [
    { indentColor: NS, indentColorActive: PS },
    { indentColor: SRe, indentColorActive: IRe },
    { indentColor: xRe, indentColorActive: ARe },
    { indentColor: DRe, indentColorActive: kRe },
    { indentColor: ERe, indentColorActive: TRe },
    { indentColor: LRe, indentColorActive: NRe }
  ], s = t.map((a) => {
    var l, c;
    const d = i.getColor(a.bracketColor), u = i.getColor(a.guideColor), h = i.getColor(a.guideColorActive), f = f1((l = f1(u)) !== null && l !== void 0 ? l : d?.transparent(0.3)), g = f1((c = f1(h)) !== null && c !== void 0 ? c : d);
    if (!(!f || !g))
      return {
        guideColor: f,
        guideColorActive: g
      };
  }).filter(by), o = r.map((a) => {
    const l = i.getColor(a.indentColor), c = i.getColor(a.indentColorActive), d = f1(l), u = f1(c);
    if (!(!d || !u))
      return {
        indentColor: d,
        indentColorActive: u
      };
  }).filter(by);
  if (s.length > 0) {
    for (let a = 0; a < 30; a++) {
      const l = s[a % s.length];
      e.addRule(`.monaco-editor .${n.getInlineClassNameOfLevel(a).replace(/ /g, ".")} { --guide-color: ${l.guideColor}; --guide-color-active: ${l.guideColorActive}; }`);
    }
    e.addRule(".monaco-editor .vertical { box-shadow: 1px 0 0 0 var(--guide-color) inset; }"), e.addRule(".monaco-editor .horizontal-top { border-top: 1px solid var(--guide-color); }"), e.addRule(".monaco-editor .horizontal-bottom { border-bottom: 1px solid var(--guide-color); }"), e.addRule(`.monaco-editor .vertical.${n.activeClassName} { box-shadow: 1px 0 0 0 var(--guide-color-active) inset; }`), e.addRule(`.monaco-editor .horizontal-top.${n.activeClassName} { border-top: 1px solid var(--guide-color-active); }`), e.addRule(`.monaco-editor .horizontal-bottom.${n.activeClassName} { border-bottom: 1px solid var(--guide-color-active); }`);
  }
  if (o.length > 0) {
    for (let a = 0; a < 30; a++) {
      const l = o[a % o.length];
      e.addRule(`.monaco-editor .lines-content .core-guide-indent.lvl-${a} { --indent-color: ${l.indentColor}; --indent-color-active: ${l.indentColorActive}; }`);
    }
    e.addRule(".monaco-editor .lines-content .core-guide-indent { box-shadow: 1px 0 0 0 var(--indent-color) inset; }"), e.addRule(".monaco-editor .lines-content .core-guide-indent.indent-active { box-shadow: 1px 0 0 0 var(--indent-color-active) inset; }");
  }
});
class P6 {
  get didDomLayout() {
    return this._didDomLayout;
  }
  readClientRect() {
    if (!this._clientRectRead) {
      this._clientRectRead = !0;
      const e = this._domNode.getBoundingClientRect();
      this.markDidDomLayout(), this._clientRectDeltaLeft = e.left, this._clientRectScale = e.width / this._domNode.offsetWidth;
    }
  }
  get clientRectDeltaLeft() {
    return this._clientRectRead || this.readClientRect(), this._clientRectDeltaLeft;
  }
  get clientRectScale() {
    return this._clientRectRead || this.readClientRect(), this._clientRectScale;
  }
  constructor(e, t) {
    this._domNode = e, this.endNode = t, this._didDomLayout = !1, this._clientRectDeltaLeft = 0, this._clientRectScale = 1, this._clientRectRead = !1;
  }
  markDidDomLayout() {
    this._didDomLayout = !0;
  }
}
class NFe {
  constructor() {
    this._currentVisibleRange = new V(1, 1, 1, 1);
  }
  getCurrentVisibleRange() {
    return this._currentVisibleRange;
  }
  setCurrentVisibleRange(e) {
    this._currentVisibleRange = e;
  }
}
class PFe {
  constructor(e, t, n, r, s, o, a) {
    this.minimalReveal = e, this.lineNumber = t, this.startColumn = n, this.endColumn = r, this.startScrollTop = s, this.stopScrollTop = o, this.scrollType = a, this.type = "range", this.minLineNumber = t, this.maxLineNumber = t;
  }
}
class OFe {
  constructor(e, t, n, r, s) {
    this.minimalReveal = e, this.selections = t, this.startScrollTop = n, this.stopScrollTop = r, this.scrollType = s, this.type = "selections";
    let o = t[0].startLineNumber, a = t[0].endLineNumber;
    for (let l = 1, c = t.length; l < c; l++) {
      const d = t[l];
      o = Math.min(o, d.startLineNumber), a = Math.max(a, d.endLineNumber);
    }
    this.minLineNumber = o, this.maxLineNumber = a;
  }
}
class x4 extends ca {
  constructor(e, t) {
    super(e), this._linesContent = t, this._textRangeRestingSpot = document.createElement("div"), this._visibleLines = new rge(this), this.domNode = this._visibleLines.domNode;
    const n = this._context.configuration, r = this._context.configuration.options, s = r.get(
      50
      /* EditorOption.fontInfo */
    ), o = r.get(
      144
      /* EditorOption.wrappingInfo */
    );
    this._lineHeight = r.get(
      66
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = s.typicalHalfwidthCharacterWidth, this._isViewportWrapping = o.isViewportWrapping, this._revealHorizontalRightPadding = r.get(
      99
      /* EditorOption.revealHorizontalRightPadding */
    ), this._cursorSurroundingLines = r.get(
      29
      /* EditorOption.cursorSurroundingLines */
    ), this._cursorSurroundingLinesStyle = r.get(
      30
      /* EditorOption.cursorSurroundingLinesStyle */
    ), this._canUseLayerHinting = !r.get(
      32
      /* EditorOption.disableLayerHinting */
    ), this._viewLineOptions = new wZ(n, this._context.theme.type), Su.write(
      this.domNode,
      7
      /* PartFingerprint.ViewLines */
    ), this.domNode.setClassName(`view-lines ${Rv}`), Ds(this.domNode, s), this._maxLineWidth = 0, this._asyncUpdateLineWidths = new Rn(() => {
      this._updateLineWidthsSlow();
    }, 200), this._asyncCheckMonospaceFontAssumptions = new Rn(() => {
      this._checkMonospaceFontAssumptions();
    }, 2e3), this._lastRenderedData = new NFe(), this._horizontalRevealRequest = null, this._stickyScrollEnabled = r.get(
      114
      /* EditorOption.stickyScroll */
    ).enabled, this._maxNumberStickyLines = r.get(
      114
      /* EditorOption.stickyScroll */
    ).maxLineCount;
  }
  dispose() {
    this._asyncUpdateLineWidths.dispose(), this._asyncCheckMonospaceFontAssumptions.dispose(), super.dispose();
  }
  getDomNode() {
    return this.domNode;
  }
  // ---- begin IVisibleLinesHost
  createVisibleLine() {
    return new zd(this._viewLineOptions);
  }
  // ---- end IVisibleLinesHost
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    this._visibleLines.onConfigurationChanged(e), e.hasChanged(
      144
      /* EditorOption.wrappingInfo */
    ) && (this._maxLineWidth = 0);
    const t = this._context.configuration.options, n = t.get(
      50
      /* EditorOption.fontInfo */
    ), r = t.get(
      144
      /* EditorOption.wrappingInfo */
    );
    return this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = n.typicalHalfwidthCharacterWidth, this._isViewportWrapping = r.isViewportWrapping, this._revealHorizontalRightPadding = t.get(
      99
      /* EditorOption.revealHorizontalRightPadding */
    ), this._cursorSurroundingLines = t.get(
      29
      /* EditorOption.cursorSurroundingLines */
    ), this._cursorSurroundingLinesStyle = t.get(
      30
      /* EditorOption.cursorSurroundingLinesStyle */
    ), this._canUseLayerHinting = !t.get(
      32
      /* EditorOption.disableLayerHinting */
    ), this._stickyScrollEnabled = t.get(
      114
      /* EditorOption.stickyScroll */
    ).enabled, this._maxNumberStickyLines = t.get(
      114
      /* EditorOption.stickyScroll */
    ).maxLineCount, Ds(this.domNode, n), this._onOptionsMaybeChanged(), e.hasChanged(
      143
      /* EditorOption.layoutInfo */
    ) && (this._maxLineWidth = 0), !0;
  }
  _onOptionsMaybeChanged() {
    const e = this._context.configuration, t = new wZ(e, this._context.theme.type);
    if (!this._viewLineOptions.equals(t)) {
      this._viewLineOptions = t;
      const n = this._visibleLines.getStartLineNumber(), r = this._visibleLines.getEndLineNumber();
      for (let s = n; s <= r; s++)
        this._visibleLines.getVisibleLine(s).onOptionsChanged(this._viewLineOptions);
      return !0;
    }
    return !1;
  }
  onCursorStateChanged(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    let r = !1;
    for (let s = t; s <= n; s++)
      r = this._visibleLines.getVisibleLine(s).onSelectionChanged() || r;
    return r;
  }
  onDecorationsChanged(e) {
    {
      const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
      for (let r = t; r <= n; r++)
        this._visibleLines.getVisibleLine(r).onDecorationsChanged();
    }
    return !0;
  }
  onFlushed(e) {
    const t = this._visibleLines.onFlushed(e);
    return this._maxLineWidth = 0, t;
  }
  onLinesChanged(e) {
    return this._visibleLines.onLinesChanged(e);
  }
  onLinesDeleted(e) {
    return this._visibleLines.onLinesDeleted(e);
  }
  onLinesInserted(e) {
    return this._visibleLines.onLinesInserted(e);
  }
  onRevealRangeRequest(e) {
    const t = this._computeScrollTopToRevealRange(this._context.viewLayout.getFutureViewport(), e.source, e.minimalReveal, e.range, e.selections, e.verticalType);
    if (t === -1)
      return !1;
    let n = this._context.viewLayout.validateScrollPosition({ scrollTop: t });
    e.revealHorizontal ? e.range && e.range.startLineNumber !== e.range.endLineNumber ? n = {
      scrollTop: n.scrollTop,
      scrollLeft: 0
    } : e.range ? this._horizontalRevealRequest = new PFe(e.minimalReveal, e.range.startLineNumber, e.range.startColumn, e.range.endColumn, this._context.viewLayout.getCurrentScrollTop(), n.scrollTop, e.scrollType) : e.selections && e.selections.length > 0 && (this._horizontalRevealRequest = new OFe(e.minimalReveal, e.selections, this._context.viewLayout.getCurrentScrollTop(), n.scrollTop, e.scrollType)) : this._horizontalRevealRequest = null;
    const s = Math.abs(this._context.viewLayout.getCurrentScrollTop() - n.scrollTop) <= this._lineHeight ? 1 : e.scrollType;
    return this._context.viewModel.viewLayout.setScrollPosition(n, s), !0;
  }
  onScrollChanged(e) {
    if (this._horizontalRevealRequest && e.scrollLeftChanged && (this._horizontalRevealRequest = null), this._horizontalRevealRequest && e.scrollTopChanged) {
      const t = Math.min(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop), n = Math.max(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
      (e.scrollTop < t || e.scrollTop > n) && (this._horizontalRevealRequest = null);
    }
    return this.domNode.setWidth(e.scrollWidth), this._visibleLines.onScrollChanged(e) || !0;
  }
  onTokensChanged(e) {
    return this._visibleLines.onTokensChanged(e);
  }
  onZonesChanged(e) {
    return this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth), this._visibleLines.onZonesChanged(e);
  }
  onThemeChanged(e) {
    return this._onOptionsMaybeChanged();
  }
  // ---- end view event handlers
  // ----------- HELPERS FOR OTHERS
  getPositionFromDOMInfo(e, t) {
    const n = this._getViewLineDomNode(e);
    if (n === null)
      return null;
    const r = this._getLineNumberFor(n);
    if (r === -1 || r < 1 || r > this._context.viewModel.getLineCount())
      return null;
    if (this._context.viewModel.getLineMaxColumn(r) === 1)
      return new ve(r, 1);
    const s = this._visibleLines.getStartLineNumber(), o = this._visibleLines.getEndLineNumber();
    if (r < s || r > o)
      return null;
    let a = this._visibleLines.getVisibleLine(r).getColumnOfNodeOffset(e, t);
    const l = this._context.viewModel.getLineMinColumn(r);
    return a < l && (a = l), new ve(r, a);
  }
  _getViewLineDomNode(e) {
    for (; e && e.nodeType === 1; ) {
      if (e.className === zd.CLASS_NAME)
        return e;
      e = e.parentElement;
    }
    return null;
  }
  /**
   * @returns the line number of this view line dom node.
   */
  _getLineNumberFor(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    for (let r = t; r <= n; r++) {
      const s = this._visibleLines.getVisibleLine(r);
      if (e === s.getDomNode())
        return r;
    }
    return -1;
  }
  getLineWidth(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    if (e < t || e > n)
      return -1;
    const r = new P6(this.domNode.domNode, this._textRangeRestingSpot), s = this._visibleLines.getVisibleLine(e).getWidth(r);
    return this._updateLineWidthsSlowIfDomDidLayout(r), s;
  }
  linesVisibleRangesForRange(e, t) {
    if (this.shouldRender())
      return null;
    const n = e.endLineNumber, r = V.intersectRanges(e, this._lastRenderedData.getCurrentVisibleRange());
    if (!r)
      return null;
    const s = [];
    let o = 0;
    const a = new P6(this.domNode.domNode, this._textRangeRestingSpot);
    let l = 0;
    t && (l = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new ve(r.startLineNumber, 1)).lineNumber);
    const c = this._visibleLines.getStartLineNumber(), d = this._visibleLines.getEndLineNumber();
    for (let u = r.startLineNumber; u <= r.endLineNumber; u++) {
      if (u < c || u > d)
        continue;
      const h = u === r.startLineNumber ? r.startColumn : 1, f = u !== r.endLineNumber, g = f ? this._context.viewModel.getLineMaxColumn(u) : r.endColumn, p = this._visibleLines.getVisibleLine(u).getVisibleRangesForRange(u, h, g, a);
      if (p) {
        if (t && u < n) {
          const m = l;
          l = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new ve(u + 1, 1)).lineNumber, m !== l && (p.ranges[p.ranges.length - 1].width += this._typicalHalfwidthCharacterWidth);
        }
        s[o++] = new z8e(p.outsideRenderedLine, u, _4.from(p.ranges), f);
      }
    }
    return this._updateLineWidthsSlowIfDomDidLayout(a), o === 0 ? null : s;
  }
  _visibleRangesForLineRange(e, t, n) {
    if (this.shouldRender() || e < this._visibleLines.getStartLineNumber() || e > this._visibleLines.getEndLineNumber())
      return null;
    const r = new P6(this.domNode.domNode, this._textRangeRestingSpot), s = this._visibleLines.getVisibleLine(e).getVisibleRangesForRange(e, t, n, r);
    return this._updateLineWidthsSlowIfDomDidLayout(r), s;
  }
  visibleRangeForPosition(e) {
    const t = this._visibleRangesForLineRange(e.lineNumber, e.column, e.column);
    return t ? new U8e(t.outsideRenderedLine, t.ranges[0].left) : null;
  }
  /**
   * Updates the max line width if it is fast to compute.
   * Returns true if all lines were taken into account.
   * Returns false if some lines need to be reevaluated (in a slow fashion).
   */
  _updateLineWidthsFast() {
    return this._updateLineWidths(!0);
  }
  _updateLineWidthsSlow() {
    this._updateLineWidths(!1);
  }
  /**
   * Update the line widths using DOM layout information after someone else
   * has caused a synchronous layout.
   */
  _updateLineWidthsSlowIfDomDidLayout(e) {
    e.didDomLayout && (this._asyncUpdateLineWidths.isScheduled() || (this._asyncUpdateLineWidths.cancel(), this._updateLineWidthsSlow()));
  }
  _updateLineWidths(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    let r = 1, s = !0;
    for (let o = t; o <= n; o++) {
      const a = this._visibleLines.getVisibleLine(o);
      if (e && !a.getWidthIsFast()) {
        s = !1;
        continue;
      }
      r = Math.max(r, a.getWidth(null));
    }
    return s && t === 1 && n === this._context.viewModel.getLineCount() && (this._maxLineWidth = 0), this._ensureMaxLineWidth(r), s;
  }
  _checkMonospaceFontAssumptions() {
    let e = -1, t = -1;
    const n = this._visibleLines.getStartLineNumber(), r = this._visibleLines.getEndLineNumber();
    for (let s = n; s <= r; s++) {
      const o = this._visibleLines.getVisibleLine(s);
      if (o.needsMonospaceFontCheck()) {
        const a = o.getWidth(null);
        a > t && (t = a, e = s);
      }
    }
    if (e !== -1 && !this._visibleLines.getVisibleLine(e).monospaceAssumptionsAreValid())
      for (let s = n; s <= r; s++)
        this._visibleLines.getVisibleLine(s).onMonospaceAssumptionsInvalidated();
  }
  prepareRender() {
    throw new Error("Not supported");
  }
  render() {
    throw new Error("Not supported");
  }
  renderText(e) {
    if (this._visibleLines.renderLines(e), this._lastRenderedData.setCurrentVisibleRange(e.visibleRange), this.domNode.setWidth(this._context.viewLayout.getScrollWidth()), this.domNode.setHeight(Math.min(this._context.viewLayout.getScrollHeight(), 1e6)), this._horizontalRevealRequest) {
      const n = this._horizontalRevealRequest;
      if (e.startLineNumber <= n.minLineNumber && n.maxLineNumber <= e.endLineNumber) {
        this._horizontalRevealRequest = null, this.onDidRender();
        const r = this._computeScrollLeftToReveal(n);
        r && (this._isViewportWrapping || this._ensureMaxLineWidth(r.maxHorizontalOffset), this._context.viewModel.viewLayout.setScrollPosition({
          scrollLeft: r.scrollLeft
        }, n.scrollType));
      }
    }
    if (this._updateLineWidthsFast() ? this._asyncUpdateLineWidths.cancel() : this._asyncUpdateLineWidths.schedule(), $s && !this._asyncCheckMonospaceFontAssumptions.isScheduled()) {
      const n = this._visibleLines.getStartLineNumber(), r = this._visibleLines.getEndLineNumber();
      for (let s = n; s <= r; s++)
        if (this._visibleLines.getVisibleLine(s).needsMonospaceFontCheck()) {
          this._asyncCheckMonospaceFontAssumptions.schedule();
          break;
        }
    }
    this._linesContent.setLayerHinting(this._canUseLayerHinting), this._linesContent.setContain("strict");
    const t = this._context.viewLayout.getCurrentScrollTop() - e.bigNumbersDelta;
    this._linesContent.setTop(-t), this._linesContent.setLeft(-this._context.viewLayout.getCurrentScrollLeft());
  }
  // --- width
  _ensureMaxLineWidth(e) {
    const t = Math.ceil(e);
    this._maxLineWidth < t && (this._maxLineWidth = t, this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth));
  }
  _computeScrollTopToRevealRange(e, t, n, r, s, o) {
    const a = e.top, l = e.height, c = a + l;
    let d, u, h;
    if (s && s.length > 0) {
      let _ = s[0].startLineNumber, b = s[0].endLineNumber;
      for (let w = 1, y = s.length; w < y; w++) {
        const S = s[w];
        _ = Math.min(_, S.startLineNumber), b = Math.max(b, S.endLineNumber);
      }
      d = !1, u = this._context.viewLayout.getVerticalOffsetForLineNumber(_), h = this._context.viewLayout.getVerticalOffsetForLineNumber(b) + this._lineHeight;
    } else if (r)
      d = !0, u = this._context.viewLayout.getVerticalOffsetForLineNumber(r.startLineNumber), h = this._context.viewLayout.getVerticalOffsetForLineNumber(r.endLineNumber) + this._lineHeight;
    else
      return -1;
    const f = (t === "mouse" || n) && this._cursorSurroundingLinesStyle === "default";
    let g = 0, p = 0;
    if (f)
      n || (g = this._lineHeight);
    else {
      const _ = Math.min(l / this._lineHeight / 2, this._cursorSurroundingLines);
      this._stickyScrollEnabled ? g = Math.max(_, this._maxNumberStickyLines) * this._lineHeight : g = _ * this._lineHeight, p = Math.max(0, _ - 1) * this._lineHeight;
    }
    n || (o === 0 || o === 4) && (p += this._lineHeight), u -= g, h += p;
    let m;
    if (h - u > l) {
      if (!d)
        return -1;
      m = u;
    } else if (o === 5 || o === 6)
      if (o === 6 && a <= u && h <= c)
        m = a;
      else {
        const _ = Math.max(5 * this._lineHeight, l * 0.2), b = u - _, w = h - l;
        m = Math.max(w, b);
      }
    else if (o === 1 || o === 2)
      if (o === 2 && a <= u && h <= c)
        m = a;
      else {
        const _ = (u + h) / 2;
        m = Math.max(0, _ - l / 2);
      }
    else
      m = this._computeMinimumScrolling(
        a,
        c,
        u,
        h,
        o === 3,
        o === 4
        /* viewEvents.VerticalRevealType.Bottom */
      );
    return m;
  }
  _computeScrollLeftToReveal(e) {
    const t = this._context.viewLayout.getCurrentViewport(), n = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    ), r = t.left, s = r + t.width - n.verticalScrollbarWidth;
    let o = 1073741824, a = 0;
    if (e.type === "range") {
      const c = this._visibleRangesForLineRange(e.lineNumber, e.startColumn, e.endColumn);
      if (!c)
        return null;
      for (const d of c.ranges)
        o = Math.min(o, Math.round(d.left)), a = Math.max(a, Math.round(d.left + d.width));
    } else
      for (const c of e.selections) {
        if (c.startLineNumber !== c.endLineNumber)
          return null;
        const d = this._visibleRangesForLineRange(c.startLineNumber, c.startColumn, c.endColumn);
        if (!d)
          return null;
        for (const u of d.ranges)
          o = Math.min(o, Math.round(u.left)), a = Math.max(a, Math.round(u.left + u.width));
      }
    return e.minimalReveal || (o = Math.max(0, o - x4.HORIZONTAL_EXTRA_PX), a += this._revealHorizontalRightPadding), e.type === "selections" && a - o > t.width ? null : {
      scrollLeft: this._computeMinimumScrolling(r, s, o, a),
      maxHorizontalOffset: a
    };
  }
  _computeMinimumScrolling(e, t, n, r, s, o) {
    e = e | 0, t = t | 0, n = n | 0, r = r | 0, s = !!s, o = !!o;
    const a = t - e;
    if (r - n < a) {
      if (s)
        return n;
      if (o)
        return Math.max(0, r - a);
      if (n < e)
        return n;
      if (r > t)
        return Math.max(0, r - a);
    } else
      return n;
    return e;
  }
}
x4.HORIZONTAL_EXTRA_PX = 30;
class RF {
  constructor(e, t, n, r) {
    this._decorationToRenderBrand = void 0, this.startLineNumber = +e, this.endLineNumber = +t, this.className = String(n), this.zIndex = r ?? 0;
  }
}
class MFe {
  constructor(e, t) {
    this.className = e, this.zIndex = t;
  }
}
class RFe {
  constructor() {
    this.decorations = [];
  }
  add(e) {
    this.decorations.push(e);
  }
  getDecorations() {
    return this.decorations;
  }
}
class cge extends O0 {
  /**
   * Returns an array with an element for each visible line number.
   */
  _render(e, t, n) {
    const r = [];
    for (let a = e; a <= t; a++) {
      const l = a - e;
      r[l] = new RFe();
    }
    if (n.length === 0)
      return r;
    n.sort((a, l) => a.className === l.className ? a.startLineNumber === l.startLineNumber ? a.endLineNumber - l.endLineNumber : a.startLineNumber - l.startLineNumber : a.className < l.className ? -1 : 1);
    let s = null, o = 0;
    for (let a = 0, l = n.length; a < l; a++) {
      const c = n[a], d = c.className, u = c.zIndex;
      let h = Math.max(c.startLineNumber, e) - e;
      const f = Math.min(c.endLineNumber, t) - e;
      s === d ? (h = Math.max(o + 1, h), o = Math.max(o, f)) : (s = d, o = f);
      for (let g = h; g <= o; g++)
        r[g].add(new MFe(d, u));
    }
    return r;
  }
}
class FFe extends ca {
  constructor(e) {
    super(e), this._widgets = {}, this._context = e;
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    this.domNode = Dn(document.createElement("div")), this.domNode.setClassName("glyph-margin-widgets"), this.domNode.setPosition("absolute"), this.domNode.setTop(0), this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._glyphMargin = t.get(
      57
      /* EditorOption.glyphMargin */
    ), this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, this._glyphMarginDecorationLaneCount = n.glyphMarginDecorationLaneCount, this._managedDomNodes = [], this._decorationGlyphsToRender = [];
  }
  dispose() {
    this._managedDomNodes = [], this._decorationGlyphsToRender = [], this._widgets = {}, super.dispose();
  }
  getWidgets() {
    return Object.values(this._widgets);
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    return this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._glyphMargin = t.get(
      57
      /* EditorOption.glyphMargin */
    ), this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, this._glyphMarginDecorationLaneCount = n.glyphMarginDecorationLaneCount, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  // --- begin widget management
  addWidget(e) {
    const t = Dn(e.getDomNode());
    this._widgets[e.getId()] = {
      widget: e,
      preference: e.getPosition(),
      domNode: t,
      renderInfo: null
    }, t.setPosition("absolute"), t.setDisplay("none"), t.setAttribute("widgetId", e.getId()), this.domNode.appendChild(t), this.setShouldRender();
  }
  setWidgetPosition(e, t) {
    const n = this._widgets[e.getId()];
    return n.preference.lane === t.lane && n.preference.zIndex === t.zIndex && V.equalsRange(n.preference.range, t.range) ? !1 : (n.preference = t, this.setShouldRender(), !0);
  }
  removeWidget(e) {
    var t;
    const n = e.getId();
    if (this._widgets[n]) {
      const s = this._widgets[n].domNode.domNode;
      delete this._widgets[n], (t = s.parentNode) === null || t === void 0 || t.removeChild(s), this.setShouldRender();
    }
  }
  // --- end widget management
  _collectDecorationBasedGlyphRenderRequest(e, t) {
    var n, r, s;
    const o = e.visibleRange.startLineNumber, a = e.visibleRange.endLineNumber, l = e.getDecorationsInViewport();
    for (const c of l) {
      const d = c.options.glyphMarginClassName;
      if (!d)
        continue;
      const u = Math.max(c.range.startLineNumber, o), h = Math.min(c.range.endLineNumber, a), f = Math.min((r = (n = c.options.glyphMargin) === null || n === void 0 ? void 0 : n.position) !== null && r !== void 0 ? r : 1, this._glyphMarginDecorationLaneCount), g = (s = c.options.zIndex) !== null && s !== void 0 ? s : 0;
      for (let p = u; p <= h; p++)
        t.push(new BFe(p, f, g, d));
    }
  }
  _collectWidgetBasedGlyphRenderRequest(e, t) {
    const n = e.visibleRange.startLineNumber, r = e.visibleRange.endLineNumber;
    for (const s of Object.values(this._widgets)) {
      const o = s.preference.range;
      if (o.endLineNumber < n || o.startLineNumber > r)
        continue;
      const a = Math.max(o.startLineNumber, n), l = Math.min(s.preference.lane, this._glyphMarginDecorationLaneCount);
      t.push(new VFe(a, l, s.preference.zIndex, s));
    }
  }
  _collectSortedGlyphRenderRequests(e) {
    const t = [];
    return this._collectDecorationBasedGlyphRenderRequest(e, t), this._collectWidgetBasedGlyphRenderRequest(e, t), t.sort((n, r) => n.lineNumber === r.lineNumber ? n.lane === r.lane ? n.zIndex === r.zIndex ? r.type === n.type ? n.type === 0 && r.type === 0 ? n.className < r.className ? -1 : 1 : 0 : r.type - n.type : r.zIndex - n.zIndex : n.lane - r.lane : n.lineNumber - r.lineNumber), t;
  }
  /**
   * Will store render information in each widget's renderInfo and in `_decorationGlyphsToRender`.
   */
  prepareRender(e) {
    if (!this._glyphMargin) {
      this._decorationGlyphsToRender = [];
      return;
    }
    for (const r of Object.values(this._widgets))
      r.renderInfo = null;
    const t = new Xh(this._collectSortedGlyphRenderRequests(e)), n = [];
    for (; t.length > 0; ) {
      const r = t.peek();
      if (!r)
        break;
      const s = t.takeWhile((a) => a.lineNumber === r.lineNumber && a.lane === r.lane);
      if (!s || s.length === 0)
        break;
      const o = s[0];
      if (o.type === 0) {
        const a = [];
        for (const l of s) {
          if (l.zIndex !== o.zIndex || l.type !== o.type)
            break;
          (a.length === 0 || a[a.length - 1] !== l.className) && a.push(l.className);
        }
        n.push(o.accept(a.join(" ")));
      } else
        o.widget.renderInfo = {
          lineNumber: o.lineNumber,
          lane: o.lane
        };
    }
    this._decorationGlyphsToRender = n;
  }
  render(e) {
    if (!this._glyphMargin) {
      for (const n of Object.values(this._widgets))
        n.domNode.setDisplay("none");
      for (; this._managedDomNodes.length > 0; ) {
        const n = this._managedDomNodes.pop();
        n?.domNode.remove();
      }
      return;
    }
    const t = Math.round(this._glyphMarginWidth / this._glyphMarginDecorationLaneCount);
    for (const n of Object.values(this._widgets))
      if (!n.renderInfo)
        n.domNode.setDisplay("none");
      else {
        const r = e.viewportData.relativeVerticalOffset[n.renderInfo.lineNumber - e.viewportData.startLineNumber], s = this._glyphMarginLeft + (n.renderInfo.lane - 1) * this._lineHeight;
        n.domNode.setDisplay("block"), n.domNode.setTop(r), n.domNode.setLeft(s), n.domNode.setWidth(t), n.domNode.setHeight(this._lineHeight);
      }
    for (let n = 0; n < this._decorationGlyphsToRender.length; n++) {
      const r = this._decorationGlyphsToRender[n], s = e.viewportData.relativeVerticalOffset[r.lineNumber - e.viewportData.startLineNumber], o = this._glyphMarginLeft + (r.lane - 1) * this._lineHeight;
      let a;
      n < this._managedDomNodes.length ? a = this._managedDomNodes[n] : (a = Dn(document.createElement("div")), this._managedDomNodes.push(a), this.domNode.appendChild(a)), a.setClassName("cgmr codicon " + r.combinedClassName), a.setPosition("absolute"), a.setTop(s), a.setLeft(o), a.setWidth(t), a.setHeight(this._lineHeight);
    }
    for (; this._managedDomNodes.length > this._decorationGlyphsToRender.length; ) {
      const n = this._managedDomNodes.pop();
      n?.domNode.remove();
    }
  }
}
class BFe {
  constructor(e, t, n, r) {
    this.lineNumber = e, this.lane = t, this.zIndex = n, this.className = r, this.type = 0;
  }
  accept(e) {
    return new HFe(this.lineNumber, this.lane, e);
  }
}
class VFe {
  constructor(e, t, n, r) {
    this.lineNumber = e, this.lane = t, this.zIndex = n, this.widget = r, this.type = 1;
  }
}
class HFe {
  constructor(e, t, n) {
    this.lineNumber = e, this.lane = t, this.combinedClassName = n;
  }
}
class WFe extends cge {
  constructor(e) {
    super(), this._context = e;
    const n = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._decorationsLeft = n.decorationsLeft, this._decorationsWidth = n.decorationsWidth, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const n = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    );
    return this._decorationsLeft = n.decorationsLeft, this._decorationsWidth = n.decorationsWidth, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  _getDecorations(e) {
    const t = e.getDecorationsInViewport(), n = [];
    let r = 0;
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.options.linesDecorationsClassName, c = a.options.zIndex;
      l && (n[r++] = new RF(a.range.startLineNumber, a.range.endLineNumber, l, c));
      const d = a.options.firstLineDecorationClassName;
      d && (n[r++] = new RF(a.range.startLineNumber, a.range.startLineNumber, d, c));
    }
    return n;
  }
  prepareRender(e) {
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber, r = this._render(t, n, this._getDecorations(e)), s = this._decorationsLeft.toString(), o = this._decorationsWidth.toString(), a = '" style="left:' + s + "px;width:" + o + 'px;"></div>', l = [];
    for (let c = t; c <= n; c++) {
      const d = c - t, u = r[d].getDecorations();
      let h = "";
      for (const f of u)
        h += '<div class="cldr ' + f.className + a;
      l[d] = h;
    }
    this._renderResult = l;
  }
  render(e, t) {
    return this._renderResult ? this._renderResult[t - e] : "";
  }
}
class jFe extends cge {
  constructor(e) {
    super(), this._context = e, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    return !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  _getDecorations(e) {
    const t = e.getDecorationsInViewport(), n = [];
    let r = 0;
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.options.marginClassName, c = a.options.zIndex;
      l && (n[r++] = new RF(a.range.startLineNumber, a.range.endLineNumber, l, c));
    }
    return n;
  }
  prepareRender(e) {
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber, r = this._render(t, n, this._getDecorations(e)), s = [];
    for (let o = t; o <= n; o++) {
      const a = o - t, l = r[a].getDecorations();
      let c = "";
      for (const d of l)
        c += '<div class="cmdr ' + d.className + '" style=""></div>';
      s[a] = c;
    }
    this._renderResult = s;
  }
  render(e, t) {
    return this._renderResult ? this._renderResult[t - e] : "";
  }
}
class ul {
  constructor(e, t, n, r) {
    this._rgba8Brand = void 0, this.r = ul._clamp(e), this.g = ul._clamp(t), this.b = ul._clamp(n), this.a = ul._clamp(r);
  }
  equals(e) {
    return this.r === e.r && this.g === e.g && this.b === e.b && this.a === e.a;
  }
  static _clamp(e) {
    return e < 0 ? 0 : e > 255 ? 255 : e | 0;
  }
}
ul.Empty = new ul(0, 0, 0, 0);
class MS extends we {
  static getInstance() {
    return this._INSTANCE || (this._INSTANCE = new MS()), this._INSTANCE;
  }
  constructor() {
    super(), this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event, this._updateColorMap(), this._register(Pi.onDidChange((e) => {
      e.changedColorMap && this._updateColorMap();
    }));
  }
  _updateColorMap() {
    const e = Pi.getColorMap();
    if (!e) {
      this._colors = [ul.Empty], this._backgroundIsLight = !0;
      return;
    }
    this._colors = [ul.Empty];
    for (let n = 1; n < e.length; n++) {
      const r = e[n].rgba;
      this._colors[n] = new ul(r.r, r.g, r.b, Math.round(r.a * 255));
    }
    const t = e[
      2
      /* ColorId.DefaultBackground */
    ].getRelativeLuminance();
    this._backgroundIsLight = t >= 0.5, this._onDidChange.fire(void 0);
  }
  getColor(e) {
    return (e < 1 || e >= this._colors.length) && (e = 2), this._colors[e];
  }
  backgroundIsLight() {
    return this._backgroundIsLight;
  }
}
MS._INSTANCE = null;
const zFe = (() => {
  const i = [];
  for (let e = 32; e <= 126; e++)
    i.push(e);
  return i.push(
    65533
    /* Constants.UNKNOWN_CODE */
  ), i;
})(), UFe = (i, e) => (i -= 32, i < 0 || i > 96 ? e <= 2 ? (i + 96) % 96 : 95 : i);
class Ky {
  constructor(e, t) {
    this.scale = t, this._minimapCharRendererBrand = void 0, this.charDataNormal = Ky.soften(e, 12 / 15), this.charDataLight = Ky.soften(e, 50 / 60);
  }
  static soften(e, t) {
    const n = new Uint8ClampedArray(e.length);
    for (let r = 0, s = e.length; r < s; r++)
      n[r] = nL(e[r] * t);
    return n;
  }
  renderChar(e, t, n, r, s, o, a, l, c, d, u) {
    const h = 1 * this.scale, f = 2 * this.scale, g = u ? 1 : f;
    if (t + h > e.width || n + g > e.height) {
      console.warn("bad render request outside image data");
      return;
    }
    const p = d ? this.charDataLight : this.charDataNormal, m = UFe(r, c), _ = e.width * 4, b = a.r, w = a.g, y = a.b, S = s.r - b, x = s.g - w, D = s.b - y, E = Math.max(o, l), L = e.data;
    let k = m * h * f, N = n * _ + t * 4;
    for (let I = 0; I < g; I++) {
      let A = N;
      for (let P = 0; P < h; P++) {
        const O = p[k++] / 255 * (o / 255);
        L[A++] = b + S * O, L[A++] = w + x * O, L[A++] = y + D * O, L[A++] = E;
      }
      N += _;
    }
  }
  blockRenderChar(e, t, n, r, s, o, a, l) {
    const c = 1 * this.scale, d = 2 * this.scale, u = l ? 1 : d;
    if (t + c > e.width || n + u > e.height) {
      console.warn("bad render request outside image data");
      return;
    }
    const h = e.width * 4, f = 0.5 * (s / 255), g = o.r, p = o.g, m = o.b, _ = r.r - g, b = r.g - p, w = r.b - m, y = g + _ * f, S = p + b * f, x = m + w * f, D = Math.max(s, a), E = e.data;
    let L = n * h + t * 4;
    for (let k = 0; k < u; k++) {
      let N = L;
      for (let I = 0; I < c; I++)
        E[N++] = y, E[N++] = S, E[N++] = x, E[N++] = D;
      L += h;
    }
  }
}
const NZ = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15
}, PZ = (i) => {
  const e = new Uint8ClampedArray(i.length / 2);
  for (let t = 0; t < i.length; t += 2)
    e[t >> 1] = NZ[i[t]] << 4 | NZ[i[t + 1]] & 15;
  return e;
}, OZ = {
  1: Ng(() => PZ("0000511D6300CF609C709645A78432005642574171487021003C451900274D35D762755E8B629C5BA856AF57BA649530C167D1512A272A3F6038604460398526BCA2A968DB6F8957C768BE5FBE2FB467CF5D8D5B795DC7625B5DFF50DE64C466DB2FC47CD860A65E9A2EB96CB54CE06DA763AB2EA26860524D3763536601005116008177A8705E53AB738E6A982F88BAA35B5F5B626D9C636B449B737E5B7B678598869A662F6B5B8542706C704C80736A607578685B70594A49715A4522E792")),
  2: Ng(() => PZ("000000000000000055394F383D2800008B8B1F210002000081B1CBCBCC820000847AAF6B9AAF2119BE08B8881AD60000A44FD07DCCF107015338130C00000000385972265F390B406E2437634B4B48031B12B8A0847000001E15B29A402F0000000000004B33460B00007A752C2A0000000000004D3900000084394B82013400ABA5CFC7AD9C0302A45A3E5A98AB000089A43382D97900008BA54AA087A70A0248A6A7AE6DBE0000BF6F94987EA40A01A06DCFA7A7A9030496C32F77891D0000A99FB1A0AFA80603B29AB9CA75930D010C0948354D3900000C0948354F37460D0028BE673D8400000000AF9D7B6E00002B007AA8933400007AA642675C2700007984CFB9C3985B768772A8A6B7B20000CAAECAAFC4B700009F94A6009F840009D09F9BA4CA9C0000CC8FC76DC87F0000C991C472A2000000A894A48CA7B501079BA2C9C69BA20000B19A5D3FA89000005CA6009DA2960901B0A7F0669FB200009D009E00B7890000DAD0F5D092820000D294D4C48BD10000B5A7A4A3B1A50402CAB6CBA6A2000000B5A7A4A3B1A8044FCDADD19D9CB00000B7778F7B8AAE0803C9AB5D3F5D3F00009EA09EA0BAB006039EA0989A8C7900009B9EF4D6B7C00000A9A7816CACA80000ABAC84705D3F000096DA635CDC8C00006F486F266F263D4784006124097B00374F6D2D6D2D6D4A3A95872322000000030000000000008D8939130000000000002E22A5C9CBC70600AB25C0B5C9B400061A2DB04CA67001082AA6BEBEBFC606002321DACBC19E03087AA08B6768380000282FBAC0B8CA7A88AD25BBA5A29900004C396C5894A6000040485A6E356E9442A32CD17EADA70000B4237923628600003E2DE9C1D7B500002F25BBA5A2990000231DB6AFB4A804023025C0B5CAB588062B2CBDBEC0C706882435A75CA20000002326BD6A82A908048B4B9A5A668000002423A09CB4BB060025259C9D8A7900001C1FCAB2C7C700002A2A9387ABA200002626A4A47D6E9D14333163A0C87500004B6F9C2D643A257049364936493647358A34438355497F1A0000A24C1D590000D38DFFBDD4CD3126"))
};
class IC {
  /**
   * Creates a new character renderer factory with the given scale.
   */
  static create(e, t) {
    if (this.lastCreated && e === this.lastCreated.scale && t === this.lastFontFamily)
      return this.lastCreated;
    let n;
    return OZ[e] ? n = new Ky(OZ[e](), e) : n = IC.createFromSampleData(IC.createSampleData(t).data, e), this.lastFontFamily = t, this.lastCreated = n, n;
  }
  /**
   * Creates the font sample data, writing to a canvas.
   */
  static createSampleData(e) {
    const t = document.createElement("canvas"), n = t.getContext("2d");
    t.style.height = "16px", t.height = 16, t.width = 96 * 10, t.style.width = 96 * 10 + "px", n.fillStyle = "#ffffff", n.font = `bold 16px ${e}`, n.textBaseline = "middle";
    let r = 0;
    for (const s of zFe)
      n.fillText(String.fromCharCode(s), r, 16 / 2), r += 10;
    return n.getImageData(
      0,
      0,
      96 * 10,
      16
      /* Constants.SAMPLED_CHAR_HEIGHT */
    );
  }
  /**
   * Creates a character renderer from the canvas sample data.
   */
  static createFromSampleData(e, t) {
    if (e.length !== 61440)
      throw new Error("Unexpected source in MinimapCharRenderer");
    const r = IC._downsample(e, t);
    return new Ky(r, t);
  }
  static _downsampleChar(e, t, n, r, s) {
    const o = 1 * s, a = 2 * s;
    let l = r, c = 0;
    for (let d = 0; d < a; d++) {
      const u = d / a * 16, h = (d + 1) / a * 16;
      for (let f = 0; f < o; f++) {
        const g = f / o * 10, p = (f + 1) / o * 10;
        let m = 0, _ = 0;
        for (let w = u; w < h; w++) {
          const y = t + Math.floor(w) * 3840, S = 1 - (w - Math.floor(w));
          for (let x = g; x < p; x++) {
            const D = 1 - (x - Math.floor(x)), E = y + Math.floor(x) * 4, L = D * S;
            _ += L, m += e[E] * e[E + 3] / 255 * L;
          }
        }
        const b = m / _;
        c = Math.max(c, b), n[l++] = nL(b);
      }
    }
    return c;
  }
  static _downsample(e, t) {
    const n = 2 * t * 1 * t, r = n * 96, s = new Uint8ClampedArray(r);
    let o = 0, a = 0, l = 0;
    for (let c = 0; c < 96; c++)
      l = Math.max(l, this._downsampleChar(e, a, s, o, t)), o += n, a += 10 * 4;
    if (l > 0) {
      const c = 255 / l;
      for (let d = 0; d < r; d++)
        s[d] *= c;
    }
    return s;
  }
}
const GFe = 140, qFe = 2;
class Yy {
  constructor(e, t, n) {
    const r = e.options, s = r.get(
      141
      /* EditorOption.pixelRatio */
    ), o = r.get(
      143
      /* EditorOption.layoutInfo */
    ), a = o.minimap, l = r.get(
      50
      /* EditorOption.fontInfo */
    ), c = r.get(
      72
      /* EditorOption.minimap */
    );
    this.renderMinimap = a.renderMinimap, this.size = c.size, this.minimapHeightIsEditorHeight = a.minimapHeightIsEditorHeight, this.scrollBeyondLastLine = r.get(
      104
      /* EditorOption.scrollBeyondLastLine */
    ), this.paddingTop = r.get(
      83
      /* EditorOption.padding */
    ).top, this.paddingBottom = r.get(
      83
      /* EditorOption.padding */
    ).bottom, this.showSlider = c.showSlider, this.autohide = c.autohide, this.pixelRatio = s, this.typicalHalfwidthCharacterWidth = l.typicalHalfwidthCharacterWidth, this.lineHeight = r.get(
      66
      /* EditorOption.lineHeight */
    ), this.minimapLeft = a.minimapLeft, this.minimapWidth = a.minimapWidth, this.minimapHeight = o.height, this.canvasInnerWidth = a.minimapCanvasInnerWidth, this.canvasInnerHeight = a.minimapCanvasInnerHeight, this.canvasOuterWidth = a.minimapCanvasOuterWidth, this.canvasOuterHeight = a.minimapCanvasOuterHeight, this.isSampling = a.minimapIsSampling, this.editorHeight = o.height, this.fontScale = a.minimapScale, this.minimapLineHeight = a.minimapLineHeight, this.minimapCharWidth = 1 * this.fontScale, this.charRenderer = Ng(() => IC.create(this.fontScale, l.fontFamily)), this.defaultBackgroundColor = n.getColor(
      2
      /* ColorId.DefaultBackground */
    ), this.backgroundColor = Yy._getMinimapBackground(t, this.defaultBackgroundColor), this.foregroundAlpha = Yy._getMinimapForegroundOpacity(t);
  }
  static _getMinimapBackground(e, t) {
    const n = e.getColor(L8e);
    return n ? new ul(n.rgba.r, n.rgba.g, n.rgba.b, Math.round(255 * n.rgba.a)) : t;
  }
  static _getMinimapForegroundOpacity(e) {
    const t = e.getColor(I8e);
    return t ? ul._clamp(Math.round(255 * t.rgba.a)) : 255;
  }
  equals(e) {
    return this.renderMinimap === e.renderMinimap && this.size === e.size && this.minimapHeightIsEditorHeight === e.minimapHeightIsEditorHeight && this.scrollBeyondLastLine === e.scrollBeyondLastLine && this.paddingTop === e.paddingTop && this.paddingBottom === e.paddingBottom && this.showSlider === e.showSlider && this.autohide === e.autohide && this.pixelRatio === e.pixelRatio && this.typicalHalfwidthCharacterWidth === e.typicalHalfwidthCharacterWidth && this.lineHeight === e.lineHeight && this.minimapLeft === e.minimapLeft && this.minimapWidth === e.minimapWidth && this.minimapHeight === e.minimapHeight && this.canvasInnerWidth === e.canvasInnerWidth && this.canvasInnerHeight === e.canvasInnerHeight && this.canvasOuterWidth === e.canvasOuterWidth && this.canvasOuterHeight === e.canvasOuterHeight && this.isSampling === e.isSampling && this.editorHeight === e.editorHeight && this.fontScale === e.fontScale && this.minimapLineHeight === e.minimapLineHeight && this.minimapCharWidth === e.minimapCharWidth && this.defaultBackgroundColor && this.defaultBackgroundColor.equals(e.defaultBackgroundColor) && this.backgroundColor && this.backgroundColor.equals(e.backgroundColor) && this.foregroundAlpha === e.foregroundAlpha;
  }
}
class AC {
  constructor(e, t, n, r, s, o, a, l, c) {
    this.scrollTop = e, this.scrollHeight = t, this.sliderNeeded = n, this._computedSliderRatio = r, this.sliderTop = s, this.sliderHeight = o, this.topPaddingLineCount = a, this.startLineNumber = l, this.endLineNumber = c;
  }
  /**
   * Compute a desired `scrollPosition` such that the slider moves by `delta`.
   */
  getDesiredScrollTopFromDelta(e) {
    return Math.round(this.scrollTop + e / this._computedSliderRatio);
  }
  getDesiredScrollTopFromTouchLocation(e) {
    return Math.round((e - this.sliderHeight / 2) / this._computedSliderRatio);
  }
  /**
   * Intersect a line range with `this.startLineNumber` and `this.endLineNumber`.
   */
  intersectWithViewport(e) {
    const t = Math.max(this.startLineNumber, e.startLineNumber), n = Math.min(this.endLineNumber, e.endLineNumber);
    return t > n ? null : [t, n];
  }
  /**
   * Get the inner minimap y coordinate for a line number.
   */
  getYForLineNumber(e, t) {
    return +(e - this.startLineNumber + this.topPaddingLineCount) * t;
  }
  static create(e, t, n, r, s, o, a, l, c, d, u) {
    const h = e.pixelRatio, f = e.minimapLineHeight, g = Math.floor(e.canvasInnerHeight / f), p = e.lineHeight;
    if (e.minimapHeightIsEditorHeight) {
      let x = l * e.lineHeight + e.paddingTop + e.paddingBottom;
      e.scrollBeyondLastLine && (x += Math.max(0, s - e.lineHeight - e.paddingBottom));
      const D = Math.max(1, Math.floor(s * s / x)), E = Math.max(0, e.minimapHeight - D), L = E / (d - s), k = c * L, N = E > 0, I = Math.floor(e.canvasInnerHeight / e.minimapLineHeight), A = Math.floor(e.paddingTop / e.lineHeight);
      return new AC(c, d, N, L, k, D, A, 1, Math.min(a, I));
    }
    let m;
    if (o && n !== a) {
      const x = n - t + 1;
      m = Math.floor(x * f / h);
    } else {
      const x = s / p;
      m = Math.floor(x * f / h);
    }
    const _ = Math.floor(e.paddingTop / p);
    let b = Math.floor(e.paddingBottom / p);
    if (e.scrollBeyondLastLine) {
      const x = s / p;
      b = Math.max(b, x - 1);
    }
    let w;
    if (b > 0) {
      const x = s / p;
      w = (_ + a + b - x - 1) * f / h;
    } else
      w = Math.max(0, (_ + a) * f / h - m);
    w = Math.min(e.minimapHeight - m, w);
    const y = w / (d - s), S = c * y;
    if (g >= _ + a + b) {
      const x = w > 0;
      return new AC(c, d, x, y, S, m, _, 1, a);
    } else {
      let x;
      t > 1 ? x = t + _ : x = Math.max(1, c / p);
      let D, E = Math.max(1, Math.floor(x - S * h / f));
      E < _ ? (D = _ - E + 1, E = 1) : (D = 0, E = Math.max(1, E - _)), u && u.scrollHeight === d && (u.scrollTop > c && (E = Math.min(E, u.startLineNumber), D = Math.max(D, u.topPaddingLineCount)), u.scrollTop < c && (E = Math.max(E, u.startLineNumber), D = Math.min(D, u.topPaddingLineCount)));
      const L = Math.min(a, E - D + g - 1), k = (c - r) / p;
      let N;
      return c >= e.paddingTop ? N = (t - E + D + k) * f / h : N = c / e.paddingTop * (D + k) * f / h, new AC(c, d, !0, y, N, m, D, E, L);
    }
  }
}
class mL {
  constructor(e) {
    this.dy = e;
  }
  onContentChanged() {
    this.dy = -1;
  }
  onTokensChanged() {
    this.dy = -1;
  }
}
mL.INVALID = new mL(-1);
class MZ {
  constructor(e, t, n) {
    this.renderedLayout = e, this._imageData = t, this._renderedLines = new ige(() => mL.INVALID), this._renderedLines._set(e.startLineNumber, n);
  }
  /**
   * Check if the current RenderData matches accurately the new desired layout and no painting is needed.
   */
  linesEquals(e) {
    if (!this.scrollEquals(e))
      return !1;
    const n = this._renderedLines._get().lines;
    for (let r = 0, s = n.length; r < s; r++)
      if (n[r].dy === -1)
        return !1;
    return !0;
  }
  /**
   * Check if the current RenderData matches the new layout's scroll position
   */
  scrollEquals(e) {
    return this.renderedLayout.startLineNumber === e.startLineNumber && this.renderedLayout.endLineNumber === e.endLineNumber;
  }
  _get() {
    const e = this._renderedLines._get();
    return {
      imageData: this._imageData,
      rendLineNumberStart: e.rendLineNumberStart,
      lines: e.lines
    };
  }
  onLinesChanged(e, t) {
    return this._renderedLines.onLinesChanged(e, t);
  }
  onLinesDeleted(e, t) {
    this._renderedLines.onLinesDeleted(e, t);
  }
  onLinesInserted(e, t) {
    this._renderedLines.onLinesInserted(e, t);
  }
  onTokensChanged(e) {
    return this._renderedLines.onTokensChanged(e);
  }
}
class Ez {
  constructor(e, t, n, r) {
    this._backgroundFillData = Ez._createBackgroundFillData(t, n, r), this._buffers = [
      e.createImageData(t, n),
      e.createImageData(t, n)
    ], this._lastUsedBuffer = 0;
  }
  getBuffer() {
    this._lastUsedBuffer = 1 - this._lastUsedBuffer;
    const e = this._buffers[this._lastUsedBuffer];
    return e.data.set(this._backgroundFillData), e;
  }
  static _createBackgroundFillData(e, t, n) {
    const r = n.r, s = n.g, o = n.b, a = n.a, l = new Uint8ClampedArray(e * t * 4);
    let c = 0;
    for (let d = 0; d < t; d++)
      for (let u = 0; u < e; u++)
        l[c] = r, l[c + 1] = s, l[c + 2] = o, l[c + 3] = a, c += 4;
    return l;
  }
}
class Xy {
  static compute(e, t, n) {
    if (e.renderMinimap === 0 || !e.isSampling)
      return [null, []];
    const { minimapLineCount: r } = Dv.computeContainedMinimapLineCount({
      viewLineCount: t,
      scrollBeyondLastLine: e.scrollBeyondLastLine,
      paddingTop: e.paddingTop,
      paddingBottom: e.paddingBottom,
      height: e.editorHeight,
      lineHeight: e.lineHeight,
      pixelRatio: e.pixelRatio
    }), s = t / r, o = s / 2;
    if (!n || n.minimapLines.length === 0) {
      const m = [];
      if (m[0] = 1, r > 1) {
        for (let _ = 0, b = r - 1; _ < b; _++)
          m[_] = Math.round(_ * s + o);
        m[r - 1] = t;
      }
      return [new Xy(s, m), []];
    }
    const a = n.minimapLines, l = a.length, c = [];
    let d = 0, u = 0, h = 1;
    const f = 10;
    let g = [], p = null;
    for (let m = 0; m < r; m++) {
      const _ = Math.max(h, Math.round(m * s)), b = Math.max(_, Math.round((m + 1) * s));
      for (; d < l && a[d] < _; ) {
        if (g.length < f) {
          const y = d + 1 + u;
          p && p.type === "deleted" && p._oldIndex === d - 1 ? p.deleteToLineNumber++ : (p = { type: "deleted", _oldIndex: d, deleteFromLineNumber: y, deleteToLineNumber: y }, g.push(p)), u--;
        }
        d++;
      }
      let w;
      if (d < l && a[d] <= b)
        w = a[d], d++;
      else if (m === 0 ? w = 1 : m + 1 === r ? w = t : w = Math.round(m * s + o), g.length < f) {
        const y = d + 1 + u;
        p && p.type === "inserted" && p._i === m - 1 ? p.insertToLineNumber++ : (p = { type: "inserted", _i: m, insertFromLineNumber: y, insertToLineNumber: y }, g.push(p)), u++;
      }
      c[m] = w, h = w;
    }
    if (g.length < f)
      for (; d < l; ) {
        const m = d + 1 + u;
        p && p.type === "deleted" && p._oldIndex === d - 1 ? p.deleteToLineNumber++ : (p = { type: "deleted", _oldIndex: d, deleteFromLineNumber: m, deleteToLineNumber: m }, g.push(p)), u--, d++;
      }
    else
      g = [{ type: "flush" }];
    return [new Xy(s, c), g];
  }
  constructor(e, t) {
    this.samplingRatio = e, this.minimapLines = t;
  }
  modelLineToMinimapLine(e) {
    return Math.min(this.minimapLines.length, Math.max(1, Math.round(e / this.samplingRatio)));
  }
  /**
   * Will return null if the model line ranges are not intersecting with a sampled model line.
   */
  modelLineRangeToMinimapLineRange(e, t) {
    let n = this.modelLineToMinimapLine(e) - 1;
    for (; n > 0 && this.minimapLines[n - 1] >= e; )
      n--;
    let r = this.modelLineToMinimapLine(t) - 1;
    for (; r + 1 < this.minimapLines.length && this.minimapLines[r + 1] <= t; )
      r++;
    if (n === r) {
      const s = this.minimapLines[n];
      if (s < e || s > t)
        return null;
    }
    return [n + 1, r + 1];
  }
  /**
   * Will always return a range, even if it is not intersecting with a sampled model line.
   */
  decorationLineRangeToMinimapLineRange(e, t) {
    let n = this.modelLineToMinimapLine(e), r = this.modelLineToMinimapLine(t);
    return e !== t && r === n && (r === this.minimapLines.length ? n > 1 && n-- : r++), [n, r];
  }
  onLinesDeleted(e) {
    const t = e.toLineNumber - e.fromLineNumber + 1;
    let n = this.minimapLines.length, r = 0;
    for (let s = this.minimapLines.length - 1; s >= 0 && !(this.minimapLines[s] < e.fromLineNumber); s--)
      this.minimapLines[s] <= e.toLineNumber ? (this.minimapLines[s] = Math.max(1, e.fromLineNumber - 1), n = Math.min(n, s), r = Math.max(r, s)) : this.minimapLines[s] -= t;
    return [n, r];
  }
  onLinesInserted(e) {
    const t = e.toLineNumber - e.fromLineNumber + 1;
    for (let n = this.minimapLines.length - 1; n >= 0 && !(this.minimapLines[n] < e.fromLineNumber); n--)
      this.minimapLines[n] += t;
  }
}
class KFe extends ca {
  constructor(e) {
    super(e), this.tokensColorTracker = MS.getInstance(), this._selections = [], this._minimapSelections = null, this.options = new Yy(this._context.configuration, this._context.theme, this.tokensColorTracker);
    const [t] = Xy.compute(this.options, this._context.viewModel.getLineCount(), null);
    this._samplingState = t, this._shouldCheckSampling = !1, this._actual = new vL(e.theme, this);
  }
  dispose() {
    this._actual.dispose(), super.dispose();
  }
  getDomNode() {
    return this._actual.getDomNode();
  }
  _onOptionsMaybeChanged() {
    const e = new Yy(this._context.configuration, this._context.theme, this.tokensColorTracker);
    return this.options.equals(e) ? !1 : (this.options = e, this._recreateLineSampling(), this._actual.onDidChangeOptions(), !0);
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    return this._onOptionsMaybeChanged();
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, this._minimapSelections = null, this._actual.onSelectionChanged();
  }
  onDecorationsChanged(e) {
    return e.affectsMinimap ? this._actual.onDecorationsChanged() : !1;
  }
  onFlushed(e) {
    return this._samplingState && (this._shouldCheckSampling = !0), this._actual.onFlushed();
  }
  onLinesChanged(e) {
    if (this._samplingState) {
      const t = this._samplingState.modelLineRangeToMinimapLineRange(e.fromLineNumber, e.fromLineNumber + e.count - 1);
      return t ? this._actual.onLinesChanged(t[0], t[1] - t[0] + 1) : !1;
    } else
      return this._actual.onLinesChanged(e.fromLineNumber, e.count);
  }
  onLinesDeleted(e) {
    if (this._samplingState) {
      const [t, n] = this._samplingState.onLinesDeleted(e);
      return t <= n && this._actual.onLinesChanged(t + 1, n - t + 1), this._shouldCheckSampling = !0, !0;
    } else
      return this._actual.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
  }
  onLinesInserted(e) {
    return this._samplingState ? (this._samplingState.onLinesInserted(e), this._shouldCheckSampling = !0, !0) : this._actual.onLinesInserted(e.fromLineNumber, e.toLineNumber);
  }
  onScrollChanged(e) {
    return this._actual.onScrollChanged();
  }
  onThemeChanged(e) {
    return this._actual.onThemeChanged(), this._onOptionsMaybeChanged(), !0;
  }
  onTokensChanged(e) {
    if (this._samplingState) {
      const t = [];
      for (const n of e.ranges) {
        const r = this._samplingState.modelLineRangeToMinimapLineRange(n.fromLineNumber, n.toLineNumber);
        r && t.push({ fromLineNumber: r[0], toLineNumber: r[1] });
      }
      return t.length ? this._actual.onTokensChanged(t) : !1;
    } else
      return this._actual.onTokensChanged(e.ranges);
  }
  onTokensColorsChanged(e) {
    return this._onOptionsMaybeChanged(), this._actual.onTokensColorsChanged();
  }
  onZonesChanged(e) {
    return this._actual.onZonesChanged();
  }
  // --- end event handlers
  prepareRender(e) {
    this._shouldCheckSampling && (this._shouldCheckSampling = !1, this._recreateLineSampling());
  }
  render(e) {
    let t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber;
    this._samplingState && (t = this._samplingState.modelLineToMinimapLine(t), n = this._samplingState.modelLineToMinimapLine(n));
    const r = {
      viewportContainsWhitespaceGaps: e.viewportData.whitespaceViewportData.length > 0,
      scrollWidth: e.scrollWidth,
      scrollHeight: e.scrollHeight,
      viewportStartLineNumber: t,
      viewportEndLineNumber: n,
      viewportStartLineNumberVerticalOffset: e.getVerticalOffsetForLineNumber(t),
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft,
      viewportWidth: e.viewportWidth,
      viewportHeight: e.viewportHeight
    };
    this._actual.render(r);
  }
  //#region IMinimapModel
  _recreateLineSampling() {
    this._minimapSelections = null;
    const e = !!this._samplingState, [t, n] = Xy.compute(this.options, this._context.viewModel.getLineCount(), this._samplingState);
    if (this._samplingState = t, e && this._samplingState)
      for (const r of n)
        switch (r.type) {
          case "deleted":
            this._actual.onLinesDeleted(r.deleteFromLineNumber, r.deleteToLineNumber);
            break;
          case "inserted":
            this._actual.onLinesInserted(r.insertFromLineNumber, r.insertToLineNumber);
            break;
          case "flush":
            this._actual.onFlushed();
            break;
        }
  }
  getLineCount() {
    return this._samplingState ? this._samplingState.minimapLines.length : this._context.viewModel.getLineCount();
  }
  getRealLineCount() {
    return this._context.viewModel.getLineCount();
  }
  getLineContent(e) {
    return this._samplingState ? this._context.viewModel.getLineContent(this._samplingState.minimapLines[e - 1]) : this._context.viewModel.getLineContent(e);
  }
  getLineMaxColumn(e) {
    return this._samplingState ? this._context.viewModel.getLineMaxColumn(this._samplingState.minimapLines[e - 1]) : this._context.viewModel.getLineMaxColumn(e);
  }
  getMinimapLinesRenderingData(e, t, n) {
    if (this._samplingState) {
      const r = [];
      for (let s = 0, o = t - e + 1; s < o; s++)
        n[s] ? r[s] = this._context.viewModel.getViewLineData(this._samplingState.minimapLines[e + s - 1]) : r[s] = null;
      return r;
    }
    return this._context.viewModel.getMinimapLinesRenderingData(e, t, n).data;
  }
  getSelections() {
    if (this._minimapSelections === null)
      if (this._samplingState) {
        this._minimapSelections = [];
        for (const e of this._selections) {
          const [t, n] = this._samplingState.decorationLineRangeToMinimapLineRange(e.startLineNumber, e.endLineNumber);
          this._minimapSelections.push(new ot(t, e.startColumn, n, e.endColumn));
        }
      } else
        this._minimapSelections = this._selections;
    return this._minimapSelections;
  }
  getMinimapDecorationsInViewport(e, t) {
    let n;
    if (this._samplingState) {
      const s = this._samplingState.minimapLines[e - 1], o = this._samplingState.minimapLines[t - 1];
      n = new V(s, 1, o, this._context.viewModel.getLineMaxColumn(o));
    } else
      n = new V(e, 1, t, this._context.viewModel.getLineMaxColumn(t));
    const r = this._context.viewModel.getMinimapDecorationsInRange(n);
    if (this._samplingState) {
      const s = [];
      for (const o of r) {
        if (!o.options.minimap)
          continue;
        const a = o.range, l = this._samplingState.modelLineToMinimapLine(a.startLineNumber), c = this._samplingState.modelLineToMinimapLine(a.endLineNumber);
        s.push(new wfe(new V(l, a.startColumn, c, a.endColumn), o.options));
      }
      return s;
    }
    return r;
  }
  getOptions() {
    return this._context.viewModel.model.getOptions();
  }
  revealLineNumber(e) {
    this._samplingState && (e = this._samplingState.minimapLines[e - 1]), this._context.viewModel.revealRange(
      "mouse",
      !1,
      new V(e, 1, e, 1),
      1,
      0
      /* ScrollType.Smooth */
    );
  }
  setScrollTop(e) {
    this._context.viewModel.viewLayout.setScrollPosition(
      {
        scrollTop: e
      },
      1
      /* ScrollType.Immediate */
    );
  }
}
class vL extends we {
  constructor(e, t) {
    super(), this._renderDecorations = !1, this._gestureInProgress = !1, this._theme = e, this._model = t, this._lastRenderData = null, this._buffers = null, this._selectionColor = this._theme.getColor(_Z), this._domNode = Dn(document.createElement("div")), Su.write(
      this._domNode,
      8
      /* PartFingerprint.Minimap */
    ), this._domNode.setClassName(this._getMinimapDomNodeClassName()), this._domNode.setPosition("absolute"), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._shadow = Dn(document.createElement("div")), this._shadow.setClassName("minimap-shadow-hidden"), this._domNode.appendChild(this._shadow), this._canvas = Dn(document.createElement("canvas")), this._canvas.setPosition("absolute"), this._canvas.setLeft(0), this._domNode.appendChild(this._canvas), this._decorationsCanvas = Dn(document.createElement("canvas")), this._decorationsCanvas.setPosition("absolute"), this._decorationsCanvas.setClassName("minimap-decorations-layer"), this._decorationsCanvas.setLeft(0), this._domNode.appendChild(this._decorationsCanvas), this._slider = Dn(document.createElement("div")), this._slider.setPosition("absolute"), this._slider.setClassName("minimap-slider"), this._slider.setLayerHinting(!0), this._slider.setContain("strict"), this._domNode.appendChild(this._slider), this._sliderHorizontal = Dn(document.createElement("div")), this._sliderHorizontal.setPosition("absolute"), this._sliderHorizontal.setClassName("minimap-slider-horizontal"), this._slider.appendChild(this._sliderHorizontal), this._applyLayout(), this._pointerDownListener = ar(this._domNode.domNode, Ge.POINTER_DOWN, (n) => {
      if (n.preventDefault(), this._model.options.renderMinimap === 0 || !this._lastRenderData)
        return;
      if (this._model.options.size !== "proportional") {
        if (n.button === 0 && this._lastRenderData) {
          const c = wr(this._slider.domNode), d = c.top + c.height / 2;
          this._startSliderDragging(n, d, this._lastRenderData.renderedLayout);
        }
        return;
      }
      const s = this._model.options.minimapLineHeight, o = this._model.options.canvasInnerHeight / this._model.options.canvasOuterHeight * n.offsetY;
      let l = Math.floor(o / s) + this._lastRenderData.renderedLayout.startLineNumber - this._lastRenderData.renderedLayout.topPaddingLineCount;
      l = Math.min(l, this._model.getLineCount()), this._model.revealLineNumber(l);
    }), this._sliderPointerMoveMonitor = new vb(), this._sliderPointerDownListener = ar(this._slider.domNode, Ge.POINTER_DOWN, (n) => {
      n.preventDefault(), n.stopPropagation(), n.button === 0 && this._lastRenderData && this._startSliderDragging(n, n.pageY, this._lastRenderData.renderedLayout);
    }), this._gestureDisposable = Vn.addTarget(this._domNode.domNode), this._sliderTouchStartListener = Ie(this._domNode.domNode, Wn.Start, (n) => {
      n.preventDefault(), n.stopPropagation(), this._lastRenderData && (this._slider.toggleClassName("active", !0), this._gestureInProgress = !0, this.scrollDueToTouchEvent(n));
    }, { passive: !1 }), this._sliderTouchMoveListener = Ie(this._domNode.domNode, Wn.Change, (n) => {
      n.preventDefault(), n.stopPropagation(), this._lastRenderData && this._gestureInProgress && this.scrollDueToTouchEvent(n);
    }, { passive: !1 }), this._sliderTouchEndListener = ar(this._domNode.domNode, Wn.End, (n) => {
      n.preventDefault(), n.stopPropagation(), this._gestureInProgress = !1, this._slider.toggleClassName("active", !1);
    });
  }
  _startSliderDragging(e, t, n) {
    if (!e.target || !(e.target instanceof Element))
      return;
    const r = e.pageX;
    this._slider.toggleClassName("active", !0);
    const s = (o, a) => {
      const l = wr(this._domNode.domNode), c = Math.min(Math.abs(a - r), Math.abs(a - l.left), Math.abs(a - l.left - l.width));
      if (Ls && c > GFe) {
        this._model.setScrollTop(n.scrollTop);
        return;
      }
      const d = o - t;
      this._model.setScrollTop(n.getDesiredScrollTopFromDelta(d));
    };
    e.pageY !== t && s(e.pageY, r), this._sliderPointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (o) => s(o.pageY, o.pageX), () => {
      this._slider.toggleClassName("active", !1);
    });
  }
  scrollDueToTouchEvent(e) {
    const t = this._domNode.domNode.getBoundingClientRect().top, n = this._lastRenderData.renderedLayout.getDesiredScrollTopFromTouchLocation(e.pageY - t);
    this._model.setScrollTop(n);
  }
  dispose() {
    this._pointerDownListener.dispose(), this._sliderPointerMoveMonitor.dispose(), this._sliderPointerDownListener.dispose(), this._gestureDisposable.dispose(), this._sliderTouchStartListener.dispose(), this._sliderTouchMoveListener.dispose(), this._sliderTouchEndListener.dispose(), super.dispose();
  }
  _getMinimapDomNodeClassName() {
    const e = ["minimap"];
    return this._model.options.showSlider === "always" ? e.push("slider-always") : e.push("slider-mouseover"), this._model.options.autohide && e.push("autohide"), e.join(" ");
  }
  getDomNode() {
    return this._domNode;
  }
  _applyLayout() {
    this._domNode.setLeft(this._model.options.minimapLeft), this._domNode.setWidth(this._model.options.minimapWidth), this._domNode.setHeight(this._model.options.minimapHeight), this._shadow.setHeight(this._model.options.minimapHeight), this._canvas.setWidth(this._model.options.canvasOuterWidth), this._canvas.setHeight(this._model.options.canvasOuterHeight), this._canvas.domNode.width = this._model.options.canvasInnerWidth, this._canvas.domNode.height = this._model.options.canvasInnerHeight, this._decorationsCanvas.setWidth(this._model.options.canvasOuterWidth), this._decorationsCanvas.setHeight(this._model.options.canvasOuterHeight), this._decorationsCanvas.domNode.width = this._model.options.canvasInnerWidth, this._decorationsCanvas.domNode.height = this._model.options.canvasInnerHeight, this._slider.setWidth(this._model.options.minimapWidth);
  }
  _getBuffer() {
    return this._buffers || this._model.options.canvasInnerWidth > 0 && this._model.options.canvasInnerHeight > 0 && (this._buffers = new Ez(this._canvas.domNode.getContext("2d"), this._model.options.canvasInnerWidth, this._model.options.canvasInnerHeight, this._model.options.backgroundColor)), this._buffers ? this._buffers.getBuffer() : null;
  }
  // ---- begin view event handlers
  onDidChangeOptions() {
    this._lastRenderData = null, this._buffers = null, this._applyLayout(), this._domNode.setClassName(this._getMinimapDomNodeClassName());
  }
  onSelectionChanged() {
    return this._renderDecorations = !0, !0;
  }
  onDecorationsChanged() {
    return this._renderDecorations = !0, !0;
  }
  onFlushed() {
    return this._lastRenderData = null, !0;
  }
  onLinesChanged(e, t) {
    return this._lastRenderData ? this._lastRenderData.onLinesChanged(e, t) : !1;
  }
  onLinesDeleted(e, t) {
    var n;
    return (n = this._lastRenderData) === null || n === void 0 || n.onLinesDeleted(e, t), !0;
  }
  onLinesInserted(e, t) {
    var n;
    return (n = this._lastRenderData) === null || n === void 0 || n.onLinesInserted(e, t), !0;
  }
  onScrollChanged() {
    return this._renderDecorations = !0, !0;
  }
  onThemeChanged() {
    return this._selectionColor = this._theme.getColor(_Z), this._renderDecorations = !0, !0;
  }
  onTokensChanged(e) {
    return this._lastRenderData ? this._lastRenderData.onTokensChanged(e) : !1;
  }
  onTokensColorsChanged() {
    return this._lastRenderData = null, this._buffers = null, !0;
  }
  onZonesChanged() {
    return this._lastRenderData = null, !0;
  }
  // --- end event handlers
  render(e) {
    if (this._model.options.renderMinimap === 0) {
      this._shadow.setClassName("minimap-shadow-hidden"), this._sliderHorizontal.setWidth(0), this._sliderHorizontal.setHeight(0);
      return;
    }
    e.scrollLeft + e.viewportWidth >= e.scrollWidth ? this._shadow.setClassName("minimap-shadow-hidden") : this._shadow.setClassName("minimap-shadow-visible");
    const n = AC.create(this._model.options, e.viewportStartLineNumber, e.viewportEndLineNumber, e.viewportStartLineNumberVerticalOffset, e.viewportHeight, e.viewportContainsWhitespaceGaps, this._model.getLineCount(), this._model.getRealLineCount(), e.scrollTop, e.scrollHeight, this._lastRenderData ? this._lastRenderData.renderedLayout : null);
    this._slider.setDisplay(n.sliderNeeded ? "block" : "none"), this._slider.setTop(n.sliderTop), this._slider.setHeight(n.sliderHeight), this._sliderHorizontal.setLeft(0), this._sliderHorizontal.setWidth(this._model.options.minimapWidth), this._sliderHorizontal.setTop(0), this._sliderHorizontal.setHeight(n.sliderHeight), this.renderDecorations(n), this._lastRenderData = this.renderLines(n);
  }
  renderDecorations(e) {
    if (this._renderDecorations) {
      this._renderDecorations = !1;
      const t = this._model.getSelections();
      t.sort(V.compareRangesUsingStarts);
      const n = this._model.getMinimapDecorationsInViewport(e.startLineNumber, e.endLineNumber);
      n.sort((h, f) => (h.options.zIndex || 0) - (f.options.zIndex || 0));
      const { canvasInnerWidth: r, canvasInnerHeight: s } = this._model.options, o = this._model.options.minimapLineHeight, a = this._model.options.minimapCharWidth, l = this._model.getOptions().tabSize, c = this._decorationsCanvas.domNode.getContext("2d");
      c.clearRect(0, 0, r, s);
      const d = new RZ(e.startLineNumber, e.endLineNumber, !1);
      this._renderSelectionLineHighlights(c, t, d, e, o), this._renderDecorationsLineHighlights(c, n, d, e, o);
      const u = new RZ(e.startLineNumber, e.endLineNumber, null);
      this._renderSelectionsHighlights(c, t, u, e, o, l, a, r), this._renderDecorationsHighlights(c, n, u, e, o, l, a, r);
    }
  }
  _renderSelectionLineHighlights(e, t, n, r, s) {
    if (!this._selectionColor || this._selectionColor.isTransparent())
      return;
    e.fillStyle = this._selectionColor.transparent(0.5).toString();
    let o = 0, a = 0;
    for (const l of t) {
      const c = r.intersectWithViewport(l);
      if (!c)
        continue;
      const [d, u] = c;
      for (let g = d; g <= u; g++)
        n.set(g, !0);
      const h = r.getYForLineNumber(d, s), f = r.getYForLineNumber(u, s);
      a >= h || (a > o && e.fillRect(Ef, o, e.canvas.width, a - o), o = h), a = f;
    }
    a > o && e.fillRect(Ef, o, e.canvas.width, a - o);
  }
  _renderDecorationsLineHighlights(e, t, n, r, s) {
    const o = /* @__PURE__ */ new Map();
    for (let a = t.length - 1; a >= 0; a--) {
      const l = t[a], c = l.options.minimap;
      if (!c || c.position !== ia.Inline)
        continue;
      const d = r.intersectWithViewport(l.range);
      if (!d)
        continue;
      const [u, h] = d, f = c.getColor(this._theme.value);
      if (!f || f.isTransparent())
        continue;
      let g = o.get(f.toString());
      g || (g = f.transparent(0.5).toString(), o.set(f.toString(), g)), e.fillStyle = g;
      for (let p = u; p <= h; p++) {
        if (n.has(p))
          continue;
        n.set(p, !0);
        const m = r.getYForLineNumber(u, s);
        e.fillRect(Ef, m, e.canvas.width, s);
      }
    }
  }
  _renderSelectionsHighlights(e, t, n, r, s, o, a, l) {
    if (!(!this._selectionColor || this._selectionColor.isTransparent()))
      for (const c of t) {
        const d = r.intersectWithViewport(c);
        if (!d)
          continue;
        const [u, h] = d;
        for (let f = u; f <= h; f++)
          this.renderDecorationOnLine(e, n, c, this._selectionColor, r, f, s, s, o, a, l);
      }
  }
  _renderDecorationsHighlights(e, t, n, r, s, o, a, l) {
    for (const c of t) {
      const d = c.options.minimap;
      if (!d)
        continue;
      const u = r.intersectWithViewport(c.range);
      if (!u)
        continue;
      const [h, f] = u, g = d.getColor(this._theme.value);
      if (!(!g || g.isTransparent()))
        for (let p = h; p <= f; p++)
          switch (d.position) {
            case ia.Inline:
              this.renderDecorationOnLine(e, n, c.range, g, r, p, s, s, o, a, l);
              continue;
            case ia.Gutter: {
              const m = r.getYForLineNumber(p, s);
              this.renderDecoration(e, g, 2, m, qFe, s);
              continue;
            }
          }
    }
  }
  renderDecorationOnLine(e, t, n, r, s, o, a, l, c, d, u) {
    const h = s.getYForLineNumber(o, l);
    if (h + a < 0 || h > this._model.options.canvasInnerHeight)
      return;
    const { startLineNumber: f, endLineNumber: g } = n, p = f === o ? n.startColumn : 1, m = g === o ? n.endColumn : this._model.getLineMaxColumn(o), _ = this.getXOffsetForPosition(t, o, p, c, d, u), b = this.getXOffsetForPosition(t, o, m, c, d, u);
    this.renderDecoration(e, r, _, h, b - _, a);
  }
  getXOffsetForPosition(e, t, n, r, s, o) {
    if (n === 1)
      return Ef;
    if ((n - 1) * s >= o)
      return o;
    let l = e.get(t);
    if (!l) {
      const c = this._model.getLineContent(t);
      l = [Ef];
      let d = Ef;
      for (let u = 1; u < c.length + 1; u++) {
        const h = c.charCodeAt(u - 1), f = h === 9 ? r * s : Pg(h) ? 2 * s : s, g = d + f;
        if (g >= o) {
          l[u] = o;
          break;
        }
        l[u] = g, d = g;
      }
      e.set(t, l);
    }
    return n - 1 < l.length ? l[n - 1] : o;
  }
  renderDecoration(e, t, n, r, s, o) {
    e.fillStyle = t && t.toString() || "", e.fillRect(n, r, s, o);
  }
  renderLines(e) {
    const t = e.startLineNumber, n = e.endLineNumber, r = this._model.options.minimapLineHeight;
    if (this._lastRenderData && this._lastRenderData.linesEquals(e)) {
      const O = this._lastRenderData._get();
      return new MZ(e, O.imageData, O.lines);
    }
    const s = this._getBuffer();
    if (!s)
      return null;
    const [o, a, l] = vL._renderUntouchedLines(s, e.topPaddingLineCount, t, n, r, this._lastRenderData), c = this._model.getMinimapLinesRenderingData(t, n, l), d = this._model.getOptions().tabSize, u = this._model.options.defaultBackgroundColor, h = this._model.options.backgroundColor, f = this._model.options.foregroundAlpha, g = this._model.tokensColorTracker, p = g.backgroundIsLight(), m = this._model.options.renderMinimap, _ = this._model.options.charRenderer(), b = this._model.options.fontScale, w = this._model.options.minimapCharWidth, S = (m === 1 ? 2 : 3) * b, x = r > S ? Math.floor((r - S) / 2) : 0, D = h.a / 255, E = new ul(Math.round((h.r - u.r) * D + u.r), Math.round((h.g - u.g) * D + u.g), Math.round((h.b - u.b) * D + u.b), 255);
    let L = e.topPaddingLineCount * r;
    const k = [];
    for (let O = 0, K = n - t + 1; O < K; O++)
      l[O] && vL._renderLine(s, E, h.a, p, m, w, g, f, _, L, x, d, c[O], b, r), k[O] = new mL(L), L += r;
    const N = o === -1 ? 0 : o, A = (a === -1 ? s.height : a) - N;
    return this._canvas.domNode.getContext("2d").putImageData(s, 0, 0, 0, N, s.width, A), new MZ(e, s, k);
  }
  static _renderUntouchedLines(e, t, n, r, s, o) {
    const a = [];
    if (!o) {
      for (let L = 0, k = r - n + 1; L < k; L++)
        a[L] = !0;
      return [-1, -1, a];
    }
    const l = o._get(), c = l.imageData.data, d = l.rendLineNumberStart, u = l.lines, h = u.length, f = e.width, g = e.data, p = (r - n + 1) * s * f * 4;
    let m = -1, _ = -1, b = -1, w = -1, y = -1, S = -1, x = t * s;
    for (let L = n; L <= r; L++) {
      const k = L - n, N = L - d, I = N >= 0 && N < h ? u[N].dy : -1;
      if (I === -1) {
        a[k] = !0, x += s;
        continue;
      }
      const A = I * f * 4, P = (I + s) * f * 4, O = x * f * 4, K = (x + s) * f * 4;
      w === A && S === O ? (w = P, S = K) : (b !== -1 && (g.set(c.subarray(b, w), y), m === -1 && b === 0 && b === y && (m = w), _ === -1 && w === p && b === y && (_ = b)), b = A, w = P, y = O, S = K), a[k] = !1, x += s;
    }
    b !== -1 && (g.set(c.subarray(b, w), y), m === -1 && b === 0 && b === y && (m = w), _ === -1 && w === p && b === y && (_ = b));
    const D = m === -1 ? -1 : m / (f * 4), E = _ === -1 ? -1 : _ / (f * 4);
    return [D, E, a];
  }
  static _renderLine(e, t, n, r, s, o, a, l, c, d, u, h, f, g, p) {
    const m = f.content, _ = f.tokens, b = e.width - o, w = p === 1;
    let y = Ef, S = 0, x = 0;
    for (let D = 0, E = _.getCount(); D < E; D++) {
      const L = _.getEndOffset(D), k = _.getForeground(D), N = a.getColor(k);
      for (; S < L; S++) {
        if (y > b)
          return;
        const I = m.charCodeAt(S);
        if (I === 9) {
          const A = h - (S + x) % h;
          x += A - 1, y += A * o;
        } else if (I === 32)
          y += o;
        else {
          const A = Pg(I) ? 2 : 1;
          for (let P = 0; P < A; P++)
            if (s === 2 ? c.blockRenderChar(e, y, d + u, N, l, t, n, w) : c.renderChar(e, y, d + u, I, N, l, t, n, g, r, w), y += o, y > b)
              return;
        }
      }
    }
  }
}
class RZ {
  constructor(e, t, n) {
    this._startLineNumber = e, this._endLineNumber = t, this._defaultValue = n, this._values = [];
    for (let r = 0, s = this._endLineNumber - this._startLineNumber + 1; r < s; r++)
      this._values[r] = n;
  }
  has(e) {
    return this.get(e) !== this._defaultValue;
  }
  set(e, t) {
    e < this._startLineNumber || e > this._endLineNumber || (this._values[e - this._startLineNumber] = t);
  }
  get(e) {
    return e < this._startLineNumber || e > this._endLineNumber ? this._defaultValue : this._values[e - this._startLineNumber];
  }
}
class YFe extends ca {
  constructor(e) {
    super(e);
    const n = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._widgets = {}, this._verticalScrollbarWidth = n.verticalScrollbarWidth, this._minimapWidth = n.minimap.minimapWidth, this._horizontalScrollbarHeight = n.horizontalScrollbarHeight, this._editorHeight = n.height, this._editorWidth = n.width, this._domNode = Dn(document.createElement("div")), Su.write(
      this._domNode,
      4
      /* PartFingerprint.OverlayWidgets */
    ), this._domNode.setClassName("overlayWidgets");
  }
  dispose() {
    super.dispose(), this._widgets = {};
  }
  getDomNode() {
    return this._domNode;
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    const n = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    );
    return this._verticalScrollbarWidth = n.verticalScrollbarWidth, this._minimapWidth = n.minimap.minimapWidth, this._horizontalScrollbarHeight = n.horizontalScrollbarHeight, this._editorHeight = n.height, this._editorWidth = n.width, !0;
  }
  // ---- end view event handlers
  addWidget(e) {
    const t = Dn(e.getDomNode());
    this._widgets[e.getId()] = {
      widget: e,
      preference: null,
      domNode: t
    }, t.setPosition("absolute"), t.setAttribute("widgetId", e.getId()), this._domNode.appendChild(t), this.setShouldRender(), this._updateMaxMinWidth();
  }
  setWidgetPosition(e, t) {
    const n = this._widgets[e.getId()];
    return n.preference === t ? (this._updateMaxMinWidth(), !1) : (n.preference = t, this.setShouldRender(), this._updateMaxMinWidth(), !0);
  }
  removeWidget(e) {
    const t = e.getId();
    if (this._widgets.hasOwnProperty(t)) {
      const r = this._widgets[t].domNode.domNode;
      delete this._widgets[t], r.parentNode.removeChild(r), this.setShouldRender(), this._updateMaxMinWidth();
    }
  }
  _updateMaxMinWidth() {
    var e, t;
    let n = 0;
    const r = Object.keys(this._widgets);
    for (let s = 0, o = r.length; s < o; s++) {
      const a = r[s], c = (t = (e = this._widgets[a].widget).getMinContentWidthInPx) === null || t === void 0 ? void 0 : t.call(e);
      typeof c < "u" && (n = Math.max(n, c));
    }
    this._context.viewLayout.setOverlayWidgetsMinWidth(n);
  }
  _renderWidget(e) {
    const t = e.domNode;
    if (e.preference === null) {
      t.setTop("");
      return;
    }
    if (e.preference === 0)
      t.setTop(0), t.setRight(2 * this._verticalScrollbarWidth + this._minimapWidth);
    else if (e.preference === 1) {
      const n = t.domNode.clientHeight;
      t.setTop(this._editorHeight - n - 2 * this._horizontalScrollbarHeight), t.setRight(2 * this._verticalScrollbarWidth + this._minimapWidth);
    } else e.preference === 2 && (t.setTop(0), t.domNode.style.right = "50%");
  }
  prepareRender(e) {
  }
  render(e) {
    this._domNode.setWidth(this._editorWidth);
    const t = Object.keys(this._widgets);
    for (let n = 0, r = t.length; n < r; n++) {
      const s = t[n];
      this._renderWidget(this._widgets[s]);
    }
  }
}
class XFe {
  constructor(e, t) {
    const n = e.options;
    this.lineHeight = n.get(
      66
      /* EditorOption.lineHeight */
    ), this.pixelRatio = n.get(
      141
      /* EditorOption.pixelRatio */
    ), this.overviewRulerLanes = n.get(
      82
      /* EditorOption.overviewRulerLanes */
    ), this.renderBorder = n.get(
      81
      /* EditorOption.overviewRulerBorder */
    );
    const r = t.getColor(ORe);
    this.borderColor = r ? r.toString() : null, this.hideCursor = n.get(
      59
      /* EditorOption.hideCursorInOverviewRuler */
    );
    const s = t.getColor(qfe);
    this.cursorColor = s ? s.transparent(0.7).toString() : null, this.themeType = t.type;
    const o = n.get(
      72
      /* EditorOption.minimap */
    ), a = o.enabled, l = o.side, c = t.getColor(MRe), d = Pi.getDefaultBackground();
    c ? this.backgroundColor = c : a && l === "right" ? this.backgroundColor = d : this.backgroundColor = null;
    const h = n.get(
      143
      /* EditorOption.layoutInfo */
    ).overviewRuler;
    this.top = h.top, this.right = h.right, this.domWidth = h.width, this.domHeight = h.height, this.overviewRulerLanes === 0 ? (this.canvasWidth = 0, this.canvasHeight = 0) : (this.canvasWidth = this.domWidth * this.pixelRatio | 0, this.canvasHeight = this.domHeight * this.pixelRatio | 0);
    const [f, g] = this._initLanes(1, this.canvasWidth, this.overviewRulerLanes);
    this.x = f, this.w = g;
  }
  _initLanes(e, t, n) {
    const r = t - e;
    if (n >= 3) {
      const s = Math.floor(r / 3), o = Math.floor(r / 3), a = r - s - o, l = e, c = l + s, d = l + s + a;
      return [
        [
          0,
          l,
          // Left
          c,
          // Center
          l,
          // Left | Center
          d,
          // Right
          l,
          // Left | Right
          c,
          // Center | Right
          l
          // Left | Center | Right
        ],
        [
          0,
          s,
          // Left
          a,
          // Center
          s + a,
          // Left | Center
          o,
          // Right
          s + a + o,
          // Left | Right
          a + o,
          // Center | Right
          s + a + o
          // Left | Center | Right
        ]
      ];
    } else if (n === 2) {
      const s = Math.floor(r / 2), o = r - s, a = e, l = a + s;
      return [
        [
          0,
          a,
          // Left
          a,
          // Center
          a,
          // Left | Center
          l,
          // Right
          a,
          // Left | Right
          a,
          // Center | Right
          a
          // Left | Center | Right
        ],
        [
          0,
          s,
          // Left
          s,
          // Center
          s,
          // Left | Center
          o,
          // Right
          s + o,
          // Left | Right
          s + o,
          // Center | Right
          s + o
          // Left | Center | Right
        ]
      ];
    } else {
      const s = e, o = r;
      return [
        [
          0,
          s,
          // Left
          s,
          // Center
          s,
          // Left | Center
          s,
          // Right
          s,
          // Left | Right
          s,
          // Center | Right
          s
          // Left | Center | Right
        ],
        [
          0,
          o,
          // Left
          o,
          // Center
          o,
          // Left | Center
          o,
          // Right
          o,
          // Left | Right
          o,
          // Center | Right
          o
          // Left | Center | Right
        ]
      ];
    }
  }
  equals(e) {
    return this.lineHeight === e.lineHeight && this.pixelRatio === e.pixelRatio && this.overviewRulerLanes === e.overviewRulerLanes && this.renderBorder === e.renderBorder && this.borderColor === e.borderColor && this.hideCursor === e.hideCursor && this.cursorColor === e.cursorColor && this.themeType === e.themeType && ye.equals(this.backgroundColor, e.backgroundColor) && this.top === e.top && this.right === e.right && this.domWidth === e.domWidth && this.domHeight === e.domHeight && this.canvasWidth === e.canvasWidth && this.canvasHeight === e.canvasHeight;
  }
}
class ZFe extends ca {
  constructor(e) {
    super(e), this._actualShouldRender = 0, this._renderedDecorations = [], this._renderedCursorPositions = [], this._domNode = Dn(document.createElement("canvas")), this._domNode.setClassName("decorationsOverviewRuler"), this._domNode.setPosition("absolute"), this._domNode.setLayerHinting(!0), this._domNode.setContain("strict"), this._domNode.setAttribute("aria-hidden", "true"), this._updateSettings(!1), this._tokensColorTrackerListener = Pi.onDidChange((t) => {
      t.changedColorMap && this._updateSettings(!0);
    }), this._cursorPositions = [];
  }
  dispose() {
    super.dispose(), this._tokensColorTrackerListener.dispose();
  }
  _updateSettings(e) {
    const t = new XFe(this._context.configuration, this._context.theme);
    return this._settings && this._settings.equals(t) ? !1 : (this._settings = t, this._domNode.setTop(this._settings.top), this._domNode.setRight(this._settings.right), this._domNode.setWidth(this._settings.domWidth), this._domNode.setHeight(this._settings.domHeight), this._domNode.domNode.width = this._settings.canvasWidth, this._domNode.domNode.height = this._settings.canvasHeight, e && this._render(), !0);
  }
  // ---- begin view event handlers
  _markRenderingIsNeeded() {
    return this._actualShouldRender = 2, !0;
  }
  _markRenderingIsMaybeNeeded() {
    return this._actualShouldRender = 1, !0;
  }
  onConfigurationChanged(e) {
    return this._updateSettings(!1) ? this._markRenderingIsNeeded() : !1;
  }
  onCursorStateChanged(e) {
    this._cursorPositions = [];
    for (let t = 0, n = e.selections.length; t < n; t++)
      this._cursorPositions[t] = e.selections[t].getPosition();
    return this._cursorPositions.sort(ve.compare), this._markRenderingIsMaybeNeeded();
  }
  onDecorationsChanged(e) {
    return e.affectsOverviewRuler ? this._markRenderingIsMaybeNeeded() : !1;
  }
  onFlushed(e) {
    return this._markRenderingIsNeeded();
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged ? this._markRenderingIsNeeded() : !1;
  }
  onZonesChanged(e) {
    return this._markRenderingIsNeeded();
  }
  onThemeChanged(e) {
    return this._updateSettings(!1) ? this._markRenderingIsNeeded() : !1;
  }
  // ---- end view event handlers
  getDomNode() {
    return this._domNode.domNode;
  }
  prepareRender(e) {
  }
  render(e) {
    this._render(), this._actualShouldRender = 0;
  }
  _render() {
    const e = this._settings.backgroundColor;
    if (this._settings.overviewRulerLanes === 0) {
      this._domNode.setBackgroundColor(e ? ye.Format.CSS.formatHexA(e) : ""), this._domNode.setDisplay("none");
      return;
    }
    const t = this._context.viewModel.getAllOverviewRulerDecorations(this._context.theme);
    if (t.sort(Fy.compareByRenderingProps), this._actualShouldRender === 1 && !Fy.equalsArr(this._renderedDecorations, t) && (this._actualShouldRender = 2), this._actualShouldRender === 1 && !Qi(this._renderedCursorPositions, this._cursorPositions, (g, p) => g.lineNumber === p.lineNumber) && (this._actualShouldRender = 2), this._actualShouldRender === 1)
      return;
    this._renderedDecorations = t, this._renderedCursorPositions = this._cursorPositions, this._domNode.setDisplay("block");
    const n = this._settings.canvasWidth, r = this._settings.canvasHeight, s = this._settings.lineHeight, o = this._context.viewLayout, a = this._context.viewLayout.getScrollHeight(), l = r / a, c = 6 * this._settings.pixelRatio | 0, d = c / 2 | 0, u = this._domNode.domNode.getContext("2d");
    e ? e.isOpaque() ? (u.fillStyle = ye.Format.CSS.formatHexA(e), u.fillRect(0, 0, n, r)) : (u.clearRect(0, 0, n, r), u.fillStyle = ye.Format.CSS.formatHexA(e), u.fillRect(0, 0, n, r)) : u.clearRect(0, 0, n, r);
    const h = this._settings.x, f = this._settings.w;
    for (const g of t) {
      const p = g.color, m = g.data;
      u.fillStyle = p;
      let _ = 0, b = 0, w = 0;
      for (let y = 0, S = m.length / 3; y < S; y++) {
        const x = m[3 * y], D = m[3 * y + 1], E = m[3 * y + 2];
        let L = o.getVerticalOffsetForLineNumber(D) * l | 0, k = (o.getVerticalOffsetForLineNumber(E) + s) * l | 0;
        if (k - L < c) {
          let I = (L + k) / 2 | 0;
          I < d ? I = d : I + d > r && (I = r - d), L = I - d, k = I + d;
        }
        L > w + 1 || x !== _ ? (y !== 0 && u.fillRect(h[_], b, f[_], w - b), _ = x, b = L, w = k) : k > w && (w = k);
      }
      u.fillRect(h[_], b, f[_], w - b);
    }
    if (!this._settings.hideCursor && this._settings.cursorColor) {
      const g = 2 * this._settings.pixelRatio | 0, p = g / 2 | 0, m = this._settings.x[
        7
        /* OverviewRulerLane.Full */
      ], _ = this._settings.w[
        7
        /* OverviewRulerLane.Full */
      ];
      u.fillStyle = this._settings.cursorColor;
      let b = -100, w = -100;
      for (let y = 0, S = this._cursorPositions.length; y < S; y++) {
        const x = this._cursorPositions[y];
        let D = o.getVerticalOffsetForLineNumber(x.lineNumber) * l | 0;
        D < p ? D = p : D + p > r && (D = r - p);
        const E = D - p, L = E + g;
        E > w + 1 ? (y !== 0 && u.fillRect(m, b, _, w - b), b = E, w = L) : L > w && (w = L);
      }
      u.fillRect(m, b, _, w - b);
    }
    this._settings.renderBorder && this._settings.borderColor && this._settings.overviewRulerLanes > 0 && (u.beginPath(), u.lineWidth = 1, u.strokeStyle = this._settings.borderColor, u.moveTo(0, 0), u.lineTo(0, r), u.stroke(), u.moveTo(0, 0), u.lineTo(n, 0), u.stroke());
  }
}
class FZ {
  constructor(e, t, n) {
    this._colorZoneBrand = void 0, this.from = e | 0, this.to = t | 0, this.colorId = n | 0;
  }
  static compare(e, t) {
    return e.colorId === t.colorId ? e.from === t.from ? e.to - t.to : e.from - t.from : e.colorId - t.colorId;
  }
}
class dge {
  constructor(e, t, n, r) {
    this._overviewRulerZoneBrand = void 0, this.startLineNumber = e, this.endLineNumber = t, this.heightInLines = n, this.color = r, this._colorZone = null;
  }
  static compare(e, t) {
    return e.color === t.color ? e.startLineNumber === t.startLineNumber ? e.heightInLines === t.heightInLines ? e.endLineNumber - t.endLineNumber : e.heightInLines - t.heightInLines : e.startLineNumber - t.startLineNumber : e.color < t.color ? -1 : 1;
  }
  setColorZone(e) {
    this._colorZone = e;
  }
  getColorZones() {
    return this._colorZone;
  }
}
class QFe {
  constructor(e) {
    this._getVerticalOffsetForLine = e, this._zones = [], this._colorZonesInvalid = !1, this._lineHeight = 0, this._domWidth = 0, this._domHeight = 0, this._outerHeight = 0, this._pixelRatio = 1, this._lastAssignedId = 0, this._color2Id = /* @__PURE__ */ Object.create(null), this._id2Color = [];
  }
  getId2Color() {
    return this._id2Color;
  }
  setZones(e) {
    this._zones = e, this._zones.sort(dge.compare);
  }
  setLineHeight(e) {
    return this._lineHeight === e ? !1 : (this._lineHeight = e, this._colorZonesInvalid = !0, !0);
  }
  setPixelRatio(e) {
    this._pixelRatio = e, this._colorZonesInvalid = !0;
  }
  getDOMWidth() {
    return this._domWidth;
  }
  getCanvasWidth() {
    return this._domWidth * this._pixelRatio;
  }
  setDOMWidth(e) {
    return this._domWidth === e ? !1 : (this._domWidth = e, this._colorZonesInvalid = !0, !0);
  }
  getDOMHeight() {
    return this._domHeight;
  }
  getCanvasHeight() {
    return this._domHeight * this._pixelRatio;
  }
  setDOMHeight(e) {
    return this._domHeight === e ? !1 : (this._domHeight = e, this._colorZonesInvalid = !0, !0);
  }
  getOuterHeight() {
    return this._outerHeight;
  }
  setOuterHeight(e) {
    return this._outerHeight === e ? !1 : (this._outerHeight = e, this._colorZonesInvalid = !0, !0);
  }
  resolveColorZones() {
    const e = this._colorZonesInvalid, t = Math.floor(this._lineHeight), n = Math.floor(this.getCanvasHeight()), r = Math.floor(this._outerHeight), s = n / r, o = Math.floor(4 * this._pixelRatio / 2), a = [];
    for (let l = 0, c = this._zones.length; l < c; l++) {
      const d = this._zones[l];
      if (!e) {
        const y = d.getColorZones();
        if (y) {
          a.push(y);
          continue;
        }
      }
      const u = this._getVerticalOffsetForLine(d.startLineNumber), h = d.heightInLines === 0 ? this._getVerticalOffsetForLine(d.endLineNumber) + t : u + d.heightInLines * t, f = Math.floor(s * u), g = Math.floor(s * h);
      let p = Math.floor((f + g) / 2), m = g - p;
      m < o && (m = o), p - m < 0 && (p = m), p + m > n && (p = n - m);
      const _ = d.color;
      let b = this._color2Id[_];
      b || (b = ++this._lastAssignedId, this._color2Id[_] = b, this._id2Color[b] = _);
      const w = new FZ(p - m, p + m, b);
      d.setColorZone(w), a.push(w);
    }
    return this._colorZonesInvalid = !1, a.sort(FZ.compare), a;
  }
}
class JFe extends AS {
  constructor(e, t) {
    super(), this._context = e;
    const n = this._context.configuration.options;
    this._domNode = Dn(document.createElement("canvas")), this._domNode.setClassName(t), this._domNode.setPosition("absolute"), this._domNode.setLayerHinting(!0), this._domNode.setContain("strict"), this._zoneManager = new QFe((r) => this._context.viewLayout.getVerticalOffsetForLineNumber(r)), this._zoneManager.setDOMWidth(0), this._zoneManager.setDOMHeight(0), this._zoneManager.setOuterHeight(this._context.viewLayout.getScrollHeight()), this._zoneManager.setLineHeight(n.get(
      66
      /* EditorOption.lineHeight */
    )), this._zoneManager.setPixelRatio(n.get(
      141
      /* EditorOption.pixelRatio */
    )), this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return e.hasChanged(
      66
      /* EditorOption.lineHeight */
    ) && (this._zoneManager.setLineHeight(t.get(
      66
      /* EditorOption.lineHeight */
    )), this._render()), e.hasChanged(
      141
      /* EditorOption.pixelRatio */
    ) && (this._zoneManager.setPixelRatio(t.get(
      141
      /* EditorOption.pixelRatio */
    )), this._domNode.setWidth(this._zoneManager.getDOMWidth()), this._domNode.setHeight(this._zoneManager.getDOMHeight()), this._domNode.domNode.width = this._zoneManager.getCanvasWidth(), this._domNode.domNode.height = this._zoneManager.getCanvasHeight(), this._render()), !0;
  }
  onFlushed(e) {
    return this._render(), !0;
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged && (this._zoneManager.setOuterHeight(e.scrollHeight), this._render()), !0;
  }
  onZonesChanged(e) {
    return this._render(), !0;
  }
  // ---- end view event handlers
  getDomNode() {
    return this._domNode.domNode;
  }
  setLayout(e) {
    this._domNode.setTop(e.top), this._domNode.setRight(e.right);
    let t = !1;
    t = this._zoneManager.setDOMWidth(e.width) || t, t = this._zoneManager.setDOMHeight(e.height) || t, t && (this._domNode.setWidth(this._zoneManager.getDOMWidth()), this._domNode.setHeight(this._zoneManager.getDOMHeight()), this._domNode.domNode.width = this._zoneManager.getCanvasWidth(), this._domNode.domNode.height = this._zoneManager.getCanvasHeight(), this._render());
  }
  setZones(e) {
    this._zoneManager.setZones(e), this._render();
  }
  _render() {
    if (this._zoneManager.getOuterHeight() === 0)
      return !1;
    const e = this._zoneManager.getCanvasWidth(), t = this._zoneManager.getCanvasHeight(), n = this._zoneManager.resolveColorZones(), r = this._zoneManager.getId2Color(), s = this._domNode.domNode.getContext("2d");
    return s.clearRect(0, 0, e, t), n.length > 0 && this._renderOneLane(s, n, r, e), !0;
  }
  _renderOneLane(e, t, n, r) {
    let s = 0, o = 0, a = 0;
    for (const l of t) {
      const c = l.colorId, d = l.from, u = l.to;
      c !== s ? (e.fillRect(0, o, r, a - o), s = c, e.fillStyle = n[s], o = d, a = u) : a >= d ? a = Math.max(a, u) : (e.fillRect(0, o, r, a - o), o = d, a = u);
    }
    e.fillRect(0, o, r, a - o);
  }
}
class $Fe extends ca {
  constructor(e) {
    super(e), this.domNode = Dn(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setClassName("view-rulers"), this._renderedRulers = [];
    const t = this._context.configuration.options;
    this._rulers = t.get(
      101
      /* EditorOption.rulers */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth;
  }
  dispose() {
    super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._rulers = t.get(
      101
      /* EditorOption.rulers */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, !0;
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged;
  }
  // --- end event handlers
  prepareRender(e) {
  }
  _ensureRulersCount() {
    const e = this._renderedRulers.length, t = this._rulers.length;
    if (e === t)
      return;
    if (e < t) {
      const { tabSize: r } = this._context.viewModel.model.getOptions(), s = r;
      let o = t - e;
      for (; o > 0; ) {
        const a = Dn(document.createElement("div"));
        a.setClassName("view-ruler"), a.setWidth(s), this.domNode.appendChild(a), this._renderedRulers.push(a), o--;
      }
      return;
    }
    let n = e - t;
    for (; n > 0; ) {
      const r = this._renderedRulers.pop();
      this.domNode.removeChild(r), n--;
    }
  }
  render(e) {
    this._ensureRulersCount();
    for (let t = 0, n = this._rulers.length; t < n; t++) {
      const r = this._renderedRulers[t], s = this._rulers[t];
      r.setBoxShadow(s.color ? `1px 0 0 0 ${s.color} inset` : ""), r.setHeight(Math.min(e.scrollHeight, 1e6)), r.setLeft(s.column * this._typicalHalfwidthCharacterWidth);
    }
  }
}
class eBe extends ca {
  constructor(e) {
    super(e), this._scrollTop = 0, this._width = 0, this._updateWidth(), this._shouldShow = !1;
    const n = this._context.configuration.options.get(
      102
      /* EditorOption.scrollbar */
    );
    this._useShadows = n.useShadows, this._domNode = Dn(document.createElement("div")), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true");
  }
  dispose() {
    super.dispose();
  }
  _updateShouldShow() {
    const e = this._useShadows && this._scrollTop > 0;
    return this._shouldShow !== e ? (this._shouldShow = e, !0) : !1;
  }
  getDomNode() {
    return this._domNode;
  }
  _updateWidth() {
    const t = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    );
    t.minimap.renderMinimap === 0 || t.minimap.minimapWidth > 0 && t.minimap.minimapLeft === 0 ? this._width = t.width : this._width = t.width - t.verticalScrollbarWidth;
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const n = this._context.configuration.options.get(
      102
      /* EditorOption.scrollbar */
    );
    return this._useShadows = n.useShadows, this._updateWidth(), this._updateShouldShow(), !0;
  }
  onScrollChanged(e) {
    return this._scrollTop = e.scrollTop, this._updateShouldShow();
  }
  // --- end event handlers
  prepareRender(e) {
  }
  render(e) {
    this._domNode.setWidth(this._width), this._domNode.setClassName(this._shouldShow ? "scroll-decoration" : "");
  }
}
class tBe {
  constructor(e) {
    this.left = e.left, this.width = e.width, this.startStyle = null, this.endStyle = null;
  }
}
class nBe {
  constructor(e, t) {
    this.lineNumber = e, this.ranges = t;
  }
}
function iBe(i) {
  return new tBe(i);
}
function rBe(i) {
  return new nBe(i.lineNumber, i.ranges.map(iBe));
}
class qi extends O0 {
  constructor(e) {
    super(), this._previousFrameVisibleRangesWithStyle = [], this._context = e;
    const t = this._context.configuration.options;
    this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._roundedSelection = t.get(
      100
      /* EditorOption.roundedSelection */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, this._selections = [], this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._roundedSelection = t.get(
      100
      /* EditorOption.roundedSelection */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections.slice(0), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  _visibleRangesHaveGaps(e) {
    for (let t = 0, n = e.length; t < n; t++)
      if (e[t].ranges.length > 1)
        return !0;
    return !1;
  }
  _enrichVisibleRangesWithStyle(e, t, n) {
    const r = this._typicalHalfwidthCharacterWidth / 4;
    let s = null, o = null;
    if (n && n.length > 0 && t.length > 0) {
      const a = t[0].lineNumber;
      if (a === e.startLineNumber)
        for (let c = 0; !s && c < n.length; c++)
          n[c].lineNumber === a && (s = n[c].ranges[0]);
      const l = t[t.length - 1].lineNumber;
      if (l === e.endLineNumber)
        for (let c = n.length - 1; !o && c >= 0; c--)
          n[c].lineNumber === l && (o = n[c].ranges[0]);
      s && !s.startStyle && (s = null), o && !o.startStyle && (o = null);
    }
    for (let a = 0, l = t.length; a < l; a++) {
      const c = t[a].ranges[0], d = c.left, u = c.left + c.width, h = {
        top: 0,
        bottom: 0
        /* CornerStyle.EXTERN */
      }, f = {
        top: 0,
        bottom: 0
        /* CornerStyle.EXTERN */
      };
      if (a > 0) {
        const g = t[a - 1].ranges[0].left, p = t[a - 1].ranges[0].left + t[a - 1].ranges[0].width;
        $x(d - g) < r ? h.top = 2 : d > g && (h.top = 1), $x(u - p) < r ? f.top = 2 : g < u && u < p && (f.top = 1);
      } else s && (h.top = s.startStyle.top, f.top = s.endStyle.top);
      if (a + 1 < l) {
        const g = t[a + 1].ranges[0].left, p = t[a + 1].ranges[0].left + t[a + 1].ranges[0].width;
        $x(d - g) < r ? h.bottom = 2 : g < d && d < p && (h.bottom = 1), $x(u - p) < r ? f.bottom = 2 : u < p && (f.bottom = 1);
      } else o && (h.bottom = o.startStyle.bottom, f.bottom = o.endStyle.bottom);
      c.startStyle = h, c.endStyle = f;
    }
  }
  _getVisibleRangesWithStyle(e, t, n) {
    const s = (t.linesVisibleRangesForRange(e, !0) || []).map(rBe);
    return !this._visibleRangesHaveGaps(s) && this._roundedSelection && this._enrichVisibleRangesWithStyle(t.visibleRange, s, n), s;
  }
  _createSelectionPiece(e, t, n, r, s) {
    return '<div class="cslr ' + n + '" style="top:' + e.toString() + "px;left:" + r.toString() + "px;width:" + s.toString() + "px;height:" + t + 'px;"></div>';
  }
  _actualRenderOneSelection(e, t, n, r) {
    if (r.length === 0)
      return;
    const s = !!r[0].ranges[0].startStyle, o = this._lineHeight.toString(), a = (this._lineHeight - 1).toString(), l = r[0].lineNumber, c = r[r.length - 1].lineNumber;
    for (let d = 0, u = r.length; d < u; d++) {
      const h = r[d], f = h.lineNumber, g = f - t, p = n && (f === c || f === l) ? a : o, m = n && f === l ? 1 : 0;
      let _ = "", b = "";
      for (let w = 0, y = h.ranges.length; w < y; w++) {
        const S = h.ranges[w];
        if (s) {
          const D = S.startStyle, E = S.endStyle;
          if (D.top === 1 || D.bottom === 1) {
            _ += this._createSelectionPiece(m, p, qi.SELECTION_CLASS_NAME, S.left - qi.ROUNDED_PIECE_WIDTH, qi.ROUNDED_PIECE_WIDTH);
            let L = qi.EDITOR_BACKGROUND_CLASS_NAME;
            D.top === 1 && (L += " " + qi.SELECTION_TOP_RIGHT), D.bottom === 1 && (L += " " + qi.SELECTION_BOTTOM_RIGHT), _ += this._createSelectionPiece(m, p, L, S.left - qi.ROUNDED_PIECE_WIDTH, qi.ROUNDED_PIECE_WIDTH);
          }
          if (E.top === 1 || E.bottom === 1) {
            _ += this._createSelectionPiece(m, p, qi.SELECTION_CLASS_NAME, S.left + S.width, qi.ROUNDED_PIECE_WIDTH);
            let L = qi.EDITOR_BACKGROUND_CLASS_NAME;
            E.top === 1 && (L += " " + qi.SELECTION_TOP_LEFT), E.bottom === 1 && (L += " " + qi.SELECTION_BOTTOM_LEFT), _ += this._createSelectionPiece(m, p, L, S.left + S.width, qi.ROUNDED_PIECE_WIDTH);
          }
        }
        let x = qi.SELECTION_CLASS_NAME;
        if (s) {
          const D = S.startStyle, E = S.endStyle;
          D.top === 0 && (x += " " + qi.SELECTION_TOP_LEFT), D.bottom === 0 && (x += " " + qi.SELECTION_BOTTOM_LEFT), E.top === 0 && (x += " " + qi.SELECTION_TOP_RIGHT), E.bottom === 0 && (x += " " + qi.SELECTION_BOTTOM_RIGHT);
        }
        b += this._createSelectionPiece(m, p, x, S.left, S.width);
      }
      e[g][0] += _, e[g][1] += b;
    }
  }
  prepareRender(e) {
    const t = [], n = e.visibleRange.startLineNumber, r = e.visibleRange.endLineNumber;
    for (let o = n; o <= r; o++) {
      const a = o - n;
      t[a] = ["", ""];
    }
    const s = [];
    for (let o = 0, a = this._selections.length; o < a; o++) {
      const l = this._selections[o];
      if (l.isEmpty()) {
        s[o] = null;
        continue;
      }
      const c = this._getVisibleRangesWithStyle(l, e, this._previousFrameVisibleRangesWithStyle[o]);
      s[o] = c, this._actualRenderOneSelection(t, n, this._selections.length > 1, c);
    }
    this._previousFrameVisibleRangesWithStyle = s, this._renderResult = t.map(([o, a]) => o + a);
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
qi.SELECTION_CLASS_NAME = "selected-text";
qi.SELECTION_TOP_LEFT = "top-left-radius";
qi.SELECTION_BOTTOM_LEFT = "bottom-left-radius";
qi.SELECTION_TOP_RIGHT = "top-right-radius";
qi.SELECTION_BOTTOM_RIGHT = "bottom-right-radius";
qi.EDITOR_BACKGROUND_CLASS_NAME = "monaco-editor-background";
qi.ROUNDED_PIECE_WIDTH = 10;
fc((i, e) => {
  const t = i.getColor(PMe);
  t && !t.isTransparent() && e.addRule(`.monaco-editor .view-line span.inline-selected-text { color: ${t}; }`);
});
function $x(i) {
  return i < 0 ? -i : i;
}
class BZ {
  constructor(e, t, n, r, s, o, a) {
    this.top = e, this.left = t, this.paddingLeft = n, this.width = r, this.height = s, this.textContent = o, this.textContentClassName = a;
  }
}
class VZ {
  constructor(e) {
    this._context = e;
    const t = this._context.configuration.options, n = t.get(
      50
      /* EditorOption.fontInfo */
    );
    this._cursorStyle = t.get(
      28
      /* EditorOption.cursorStyle */
    ), this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = n.typicalHalfwidthCharacterWidth, this._lineCursorWidth = Math.min(t.get(
      31
      /* EditorOption.cursorWidth */
    ), this._typicalHalfwidthCharacterWidth), this._isVisible = !0, this._domNode = Dn(document.createElement("div")), this._domNode.setClassName(`cursor ${Rv}`), this._domNode.setHeight(this._lineHeight), this._domNode.setTop(0), this._domNode.setLeft(0), Ds(this._domNode, n), this._domNode.setDisplay("none"), this._position = new ve(1, 1), this._lastRenderedContent = "", this._renderData = null;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._position;
  }
  show() {
    this._isVisible || (this._domNode.setVisibility("inherit"), this._isVisible = !0);
  }
  hide() {
    this._isVisible && (this._domNode.setVisibility("hidden"), this._isVisible = !1);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      50
      /* EditorOption.fontInfo */
    );
    return this._cursorStyle = t.get(
      28
      /* EditorOption.cursorStyle */
    ), this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = n.typicalHalfwidthCharacterWidth, this._lineCursorWidth = Math.min(t.get(
      31
      /* EditorOption.cursorWidth */
    ), this._typicalHalfwidthCharacterWidth), Ds(this._domNode, n), !0;
  }
  onCursorPositionChanged(e, t) {
    return t ? this._domNode.domNode.style.transitionProperty = "none" : this._domNode.domNode.style.transitionProperty = "", this._position = e, !0;
  }
  /**
   * If `this._position` is inside a grapheme, returns the position where the grapheme starts.
   * Also returns the next grapheme.
   */
  _getGraphemeAwarePosition() {
    const { lineNumber: e, column: t } = this._position, n = this._context.viewModel.getLineContent(e), [r, s] = bNe(n, t - 1);
    return [new ve(e, r + 1), n.substring(r, s)];
  }
  _prepareRender(e) {
    let t = "", n = "";
    const [r, s] = this._getGraphemeAwarePosition();
    if (this._cursorStyle === rs.Line || this._cursorStyle === rs.LineThin) {
      const h = e.visibleRangeForPosition(r);
      if (!h || h.outsideRenderedLine)
        return null;
      let f;
      this._cursorStyle === rs.Line ? (f = vX(this._lineCursorWidth > 0 ? this._lineCursorWidth : 2), f > 2 && (t = s, n = this._getTokenClassName(r))) : f = vX(1);
      let g = h.left, p = 0;
      f >= 2 && g >= 1 && (p = 1, g -= p);
      const m = e.getVerticalOffsetForLineNumber(r.lineNumber) - e.bigNumbersDelta;
      return new BZ(m, g, p, f, this._lineHeight, t, n);
    }
    const o = e.linesVisibleRangesForRange(new V(r.lineNumber, r.column, r.lineNumber, r.column + s.length), !1);
    if (!o || o.length === 0)
      return null;
    const a = o[0];
    if (a.outsideRenderedLine || a.ranges.length === 0)
      return null;
    const l = a.ranges[0], c = s === "	" ? this._typicalHalfwidthCharacterWidth : l.width < 1 ? this._typicalHalfwidthCharacterWidth : l.width;
    this._cursorStyle === rs.Block && (t = s, n = this._getTokenClassName(r));
    let d = e.getVerticalOffsetForLineNumber(r.lineNumber) - e.bigNumbersDelta, u = this._lineHeight;
    return (this._cursorStyle === rs.Underline || this._cursorStyle === rs.UnderlineThin) && (d += this._lineHeight - 2, u = 2), new BZ(d, l.left, 0, c, u, t, n);
  }
  _getTokenClassName(e) {
    const t = this._context.viewModel.getViewLineData(e.lineNumber), n = t.tokens.findTokenIndexAtOffset(e.column - 1);
    return t.tokens.getClassName(n);
  }
  prepareRender(e) {
    this._renderData = this._prepareRender(e);
  }
  render(e) {
    return this._renderData ? (this._lastRenderedContent !== this._renderData.textContent && (this._lastRenderedContent = this._renderData.textContent, this._domNode.domNode.textContent = this._lastRenderedContent), this._domNode.setClassName(`cursor ${Rv} ${this._renderData.textContentClassName}`), this._domNode.setDisplay("block"), this._domNode.setTop(this._renderData.top), this._domNode.setLeft(this._renderData.left), this._domNode.setPaddingLeft(this._renderData.paddingLeft), this._domNode.setWidth(this._renderData.width), this._domNode.setLineHeight(this._renderData.height), this._domNode.setHeight(this._renderData.height), {
      domNode: this._domNode.domNode,
      position: this._position,
      contentLeft: this._renderData.left,
      height: this._renderData.height,
      width: 2
    }) : (this._domNode.setDisplay("none"), null);
  }
}
class Zy extends ca {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options;
    this._readOnly = t.get(
      90
      /* EditorOption.readOnly */
    ), this._cursorBlinking = t.get(
      26
      /* EditorOption.cursorBlinking */
    ), this._cursorStyle = t.get(
      28
      /* EditorOption.cursorStyle */
    ), this._cursorSmoothCaretAnimation = t.get(
      27
      /* EditorOption.cursorSmoothCaretAnimation */
    ), this._selectionIsEmpty = !0, this._isComposingInput = !1, this._isVisible = !1, this._primaryCursor = new VZ(this._context), this._secondaryCursors = [], this._renderData = [], this._domNode = Dn(document.createElement("div")), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._updateDomClassName(), this._domNode.appendChild(this._primaryCursor.getDomNode()), this._startCursorBlinkAnimation = new uc(), this._cursorFlatBlinkInterval = new SS(), this._blinkingEnabled = !1, this._editorHasFocus = !1, this._updateBlinking();
  }
  dispose() {
    super.dispose(), this._startCursorBlinkAnimation.dispose(), this._cursorFlatBlinkInterval.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  // --- begin event handlers
  onCompositionStart(e) {
    return this._isComposingInput = !0, this._updateBlinking(), !0;
  }
  onCompositionEnd(e) {
    return this._isComposingInput = !1, this._updateBlinking(), !0;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    this._readOnly = t.get(
      90
      /* EditorOption.readOnly */
    ), this._cursorBlinking = t.get(
      26
      /* EditorOption.cursorBlinking */
    ), this._cursorStyle = t.get(
      28
      /* EditorOption.cursorStyle */
    ), this._cursorSmoothCaretAnimation = t.get(
      27
      /* EditorOption.cursorSmoothCaretAnimation */
    ), this._updateBlinking(), this._updateDomClassName(), this._primaryCursor.onConfigurationChanged(e);
    for (let n = 0, r = this._secondaryCursors.length; n < r; n++)
      this._secondaryCursors[n].onConfigurationChanged(e);
    return !0;
  }
  _onCursorPositionChanged(e, t, n) {
    const r = this._secondaryCursors.length !== t.length || this._cursorSmoothCaretAnimation === "explicit" && n !== 3;
    if (this._primaryCursor.onCursorPositionChanged(e, r), this._updateBlinking(), this._secondaryCursors.length < t.length) {
      const s = t.length - this._secondaryCursors.length;
      for (let o = 0; o < s; o++) {
        const a = new VZ(this._context);
        this._domNode.domNode.insertBefore(a.getDomNode().domNode, this._primaryCursor.getDomNode().domNode.nextSibling), this._secondaryCursors.push(a);
      }
    } else if (this._secondaryCursors.length > t.length) {
      const s = this._secondaryCursors.length - t.length;
      for (let o = 0; o < s; o++)
        this._domNode.removeChild(this._secondaryCursors[0].getDomNode()), this._secondaryCursors.splice(0, 1);
    }
    for (let s = 0; s < t.length; s++)
      this._secondaryCursors[s].onCursorPositionChanged(t[s], r);
  }
  onCursorStateChanged(e) {
    const t = [];
    for (let r = 0, s = e.selections.length; r < s; r++)
      t[r] = e.selections[r].getPosition();
    this._onCursorPositionChanged(t[0], t.slice(1), e.reason);
    const n = e.selections[0].isEmpty();
    return this._selectionIsEmpty !== n && (this._selectionIsEmpty = n, this._updateDomClassName()), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onFocusChanged(e) {
    return this._editorHasFocus = e.isFocused, this._updateBlinking(), !1;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onTokensChanged(e) {
    const t = (n) => {
      for (let r = 0, s = e.ranges.length; r < s; r++)
        if (e.ranges[r].fromLineNumber <= n.lineNumber && n.lineNumber <= e.ranges[r].toLineNumber)
          return !0;
      return !1;
    };
    if (t(this._primaryCursor.getPosition()))
      return !0;
    for (const n of this._secondaryCursors)
      if (t(n.getPosition()))
        return !0;
    return !1;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  // ---- blinking logic
  _getCursorBlinking() {
    return this._isComposingInput || !this._editorHasFocus ? 0 : this._readOnly ? 5 : this._cursorBlinking;
  }
  _updateBlinking() {
    this._startCursorBlinkAnimation.cancel(), this._cursorFlatBlinkInterval.cancel();
    const e = this._getCursorBlinking(), t = e === 0, n = e === 5;
    t ? this._hide() : this._show(), this._blinkingEnabled = !1, this._updateDomClassName(), !t && !n && (e === 1 ? this._cursorFlatBlinkInterval.cancelAndSet(() => {
      this._isVisible ? this._hide() : this._show();
    }, Zy.BLINK_INTERVAL) : this._startCursorBlinkAnimation.setIfNotSet(() => {
      this._blinkingEnabled = !0, this._updateDomClassName();
    }, Zy.BLINK_INTERVAL));
  }
  // --- end blinking logic
  _updateDomClassName() {
    this._domNode.setClassName(this._getClassName());
  }
  _getClassName() {
    let e = "cursors-layer";
    switch (this._selectionIsEmpty || (e += " has-selection"), this._cursorStyle) {
      case rs.Line:
        e += " cursor-line-style";
        break;
      case rs.Block:
        e += " cursor-block-style";
        break;
      case rs.Underline:
        e += " cursor-underline-style";
        break;
      case rs.LineThin:
        e += " cursor-line-thin-style";
        break;
      case rs.BlockOutline:
        e += " cursor-block-outline-style";
        break;
      case rs.UnderlineThin:
        e += " cursor-underline-thin-style";
        break;
      default:
        e += " cursor-line-style";
    }
    if (this._blinkingEnabled)
      switch (this._getCursorBlinking()) {
        case 1:
          e += " cursor-blink";
          break;
        case 2:
          e += " cursor-smooth";
          break;
        case 3:
          e += " cursor-phase";
          break;
        case 4:
          e += " cursor-expand";
          break;
        case 5:
          e += " cursor-solid";
          break;
        default:
          e += " cursor-solid";
      }
    else
      e += " cursor-solid";
    return (this._cursorSmoothCaretAnimation === "on" || this._cursorSmoothCaretAnimation === "explicit") && (e += " cursor-smooth-caret-animation"), e;
  }
  _show() {
    this._primaryCursor.show();
    for (let e = 0, t = this._secondaryCursors.length; e < t; e++)
      this._secondaryCursors[e].show();
    this._isVisible = !0;
  }
  _hide() {
    this._primaryCursor.hide();
    for (let e = 0, t = this._secondaryCursors.length; e < t; e++)
      this._secondaryCursors[e].hide();
    this._isVisible = !1;
  }
  // ---- IViewPart implementation
  prepareRender(e) {
    this._primaryCursor.prepareRender(e);
    for (let t = 0, n = this._secondaryCursors.length; t < n; t++)
      this._secondaryCursors[t].prepareRender(e);
  }
  render(e) {
    const t = [];
    let n = 0;
    const r = this._primaryCursor.render(e);
    r && (t[n++] = r);
    for (let s = 0, o = this._secondaryCursors.length; s < o; s++) {
      const a = this._secondaryCursors[s].render(e);
      a && (t[n++] = a);
    }
    this._renderData = t;
  }
  getLastRenderData() {
    return this._renderData;
  }
}
Zy.BLINK_INTERVAL = 500;
fc((i, e) => {
  const t = i.getColor(qfe);
  if (t) {
    let n = i.getColor(yRe);
    n || (n = t.opposite()), e.addRule(`.monaco-editor .cursors-layer .cursor { background-color: ${t}; border-color: ${t}; color: ${n}; }`), ed(i.type) && e.addRule(`.monaco-editor .cursors-layer.has-selection .cursor { border-left: 1px solid ${n}; border-right: 1px solid ${n}; }`);
  }
});
const O6 = () => {
  throw new Error("Invalid change accessor");
};
class sBe extends ca {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._contentWidth = n.contentWidth, this._contentLeft = n.contentLeft, this.domNode = Dn(document.createElement("div")), this.domNode.setClassName("view-zones"), this.domNode.setPosition("absolute"), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.marginDomNode = Dn(document.createElement("div")), this.marginDomNode.setClassName("margin-view-zones"), this.marginDomNode.setPosition("absolute"), this.marginDomNode.setAttribute("role", "presentation"), this.marginDomNode.setAttribute("aria-hidden", "true"), this._zones = {};
  }
  dispose() {
    super.dispose(), this._zones = {};
  }
  // ---- begin view event handlers
  _recomputeWhitespacesProps() {
    const e = this._context.viewLayout.getWhitespaces(), t = /* @__PURE__ */ new Map();
    for (const r of e)
      t.set(r.id, r);
    let n = !1;
    return this._context.viewModel.changeWhitespace((r) => {
      const s = Object.keys(this._zones);
      for (let o = 0, a = s.length; o < a; o++) {
        const l = s[o], c = this._zones[l], d = this._computeWhitespaceProps(c.delegate);
        c.isInHiddenArea = d.isInHiddenArea;
        const u = t.get(l);
        u && (u.afterLineNumber !== d.afterViewLineNumber || u.height !== d.heightInPx) && (r.changeOneWhitespace(l, d.afterViewLineNumber, d.heightInPx), this._safeCallOnComputedHeight(c.delegate, d.heightInPx), n = !0);
      }
    }), n;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      143
      /* EditorOption.layoutInfo */
    );
    return this._lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this._contentWidth = n.contentWidth, this._contentLeft = n.contentLeft, e.hasChanged(
      66
      /* EditorOption.lineHeight */
    ) && this._recomputeWhitespacesProps(), !0;
  }
  onLineMappingChanged(e) {
    return this._recomputeWhitespacesProps();
  }
  onLinesDeleted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollWidthChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  // ---- end view event handlers
  _getZoneOrdinal(e) {
    var t, n;
    return (n = (t = e.ordinal) !== null && t !== void 0 ? t : e.afterColumn) !== null && n !== void 0 ? n : 1e4;
  }
  _computeWhitespaceProps(e) {
    if (e.afterLineNumber === 0)
      return {
        isInHiddenArea: !1,
        afterViewLineNumber: 0,
        heightInPx: this._heightInPixels(e),
        minWidthInPx: this._minWidthInPixels(e)
      };
    let t;
    if (typeof e.afterColumn < "u")
      t = this._context.viewModel.model.validatePosition({
        lineNumber: e.afterLineNumber,
        column: e.afterColumn
      });
    else {
      const o = this._context.viewModel.model.validatePosition({
        lineNumber: e.afterLineNumber,
        column: 1
      }).lineNumber;
      t = new ve(o, this._context.viewModel.model.getLineMaxColumn(o));
    }
    let n;
    t.column === this._context.viewModel.model.getLineMaxColumn(t.lineNumber) ? n = this._context.viewModel.model.validatePosition({
      lineNumber: t.lineNumber + 1,
      column: 1
    }) : n = this._context.viewModel.model.validatePosition({
      lineNumber: t.lineNumber,
      column: t.column + 1
    });
    const r = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t, e.afterColumnAffinity, !0), s = e.showInHiddenAreas || this._context.viewModel.coordinatesConverter.modelPositionIsVisible(n);
    return {
      isInHiddenArea: !s,
      afterViewLineNumber: r.lineNumber,
      heightInPx: s ? this._heightInPixels(e) : 0,
      minWidthInPx: this._minWidthInPixels(e)
    };
  }
  changeViewZones(e) {
    let t = !1;
    return this._context.viewModel.changeWhitespace((n) => {
      const r = {
        addZone: (s) => (t = !0, this._addZone(n, s)),
        removeZone: (s) => {
          s && (t = this._removeZone(n, s) || t);
        },
        layoutZone: (s) => {
          s && (t = this._layoutZone(n, s) || t);
        }
      };
      oBe(e, r), r.addZone = O6, r.removeZone = O6, r.layoutZone = O6;
    }), t;
  }
  _addZone(e, t) {
    const n = this._computeWhitespaceProps(t), s = {
      whitespaceId: e.insertWhitespace(n.afterViewLineNumber, this._getZoneOrdinal(t), n.heightInPx, n.minWidthInPx),
      delegate: t,
      isInHiddenArea: n.isInHiddenArea,
      isVisible: !1,
      domNode: Dn(t.domNode),
      marginDomNode: t.marginDomNode ? Dn(t.marginDomNode) : null
    };
    return this._safeCallOnComputedHeight(s.delegate, n.heightInPx), s.domNode.setPosition("absolute"), s.domNode.domNode.style.width = "100%", s.domNode.setDisplay("none"), s.domNode.setAttribute("monaco-view-zone", s.whitespaceId), this.domNode.appendChild(s.domNode), s.marginDomNode && (s.marginDomNode.setPosition("absolute"), s.marginDomNode.domNode.style.width = "100%", s.marginDomNode.setDisplay("none"), s.marginDomNode.setAttribute("monaco-view-zone", s.whitespaceId), this.marginDomNode.appendChild(s.marginDomNode)), this._zones[s.whitespaceId] = s, this.setShouldRender(), s.whitespaceId;
  }
  _removeZone(e, t) {
    if (this._zones.hasOwnProperty(t)) {
      const n = this._zones[t];
      return delete this._zones[t], e.removeWhitespace(n.whitespaceId), n.domNode.removeAttribute("monaco-visible-view-zone"), n.domNode.removeAttribute("monaco-view-zone"), n.domNode.domNode.parentNode.removeChild(n.domNode.domNode), n.marginDomNode && (n.marginDomNode.removeAttribute("monaco-visible-view-zone"), n.marginDomNode.removeAttribute("monaco-view-zone"), n.marginDomNode.domNode.parentNode.removeChild(n.marginDomNode.domNode)), this.setShouldRender(), !0;
    }
    return !1;
  }
  _layoutZone(e, t) {
    if (this._zones.hasOwnProperty(t)) {
      const n = this._zones[t], r = this._computeWhitespaceProps(n.delegate);
      return n.isInHiddenArea = r.isInHiddenArea, e.changeOneWhitespace(n.whitespaceId, r.afterViewLineNumber, r.heightInPx), this._safeCallOnComputedHeight(n.delegate, r.heightInPx), this.setShouldRender(), !0;
    }
    return !1;
  }
  shouldSuppressMouseDownOnViewZone(e) {
    return this._zones.hasOwnProperty(e) ? !!this._zones[e].delegate.suppressMouseDown : !1;
  }
  _heightInPixels(e) {
    return typeof e.heightInPx == "number" ? e.heightInPx : typeof e.heightInLines == "number" ? this._lineHeight * e.heightInLines : this._lineHeight;
  }
  _minWidthInPixels(e) {
    return typeof e.minWidthInPx == "number" ? e.minWidthInPx : 0;
  }
  _safeCallOnComputedHeight(e, t) {
    if (typeof e.onComputedHeight == "function")
      try {
        e.onComputedHeight(t);
      } catch (n) {
        It(n);
      }
  }
  _safeCallOnDomNodeTop(e, t) {
    if (typeof e.onDomNodeTop == "function")
      try {
        e.onDomNodeTop(t);
      } catch (n) {
        It(n);
      }
  }
  prepareRender(e) {
  }
  render(e) {
    const t = e.viewportData.whitespaceViewportData, n = {};
    let r = !1;
    for (const o of t)
      this._zones[o.id].isInHiddenArea || (n[o.id] = o, r = !0);
    const s = Object.keys(this._zones);
    for (let o = 0, a = s.length; o < a; o++) {
      const l = s[o], c = this._zones[l];
      let d = 0, u = 0, h = "none";
      n.hasOwnProperty(l) ? (d = n[l].verticalOffset - e.bigNumbersDelta, u = n[l].height, h = "block", c.isVisible || (c.domNode.setAttribute("monaco-visible-view-zone", "true"), c.isVisible = !0), this._safeCallOnDomNodeTop(c.delegate, e.getScrolledTopFromAbsoluteTop(n[l].verticalOffset))) : (c.isVisible && (c.domNode.removeAttribute("monaco-visible-view-zone"), c.isVisible = !1), this._safeCallOnDomNodeTop(c.delegate, e.getScrolledTopFromAbsoluteTop(-1e6))), c.domNode.setTop(d), c.domNode.setHeight(u), c.domNode.setDisplay(h), c.marginDomNode && (c.marginDomNode.setTop(d), c.marginDomNode.setHeight(u), c.marginDomNode.setDisplay(h));
    }
    r && (this.domNode.setWidth(Math.max(e.scrollWidth, this._contentWidth)), this.marginDomNode.setWidth(this._contentLeft));
  }
}
function oBe(i, e) {
  try {
    return i(e);
  } catch (t) {
    It(t);
  }
}
class aBe {
  get type() {
    return this._theme.type;
  }
  get value() {
    return this._theme;
  }
  constructor(e) {
    this._theme = e;
  }
  update(e) {
    this._theme = e;
  }
  getColor(e) {
    return this._theme.getColor(e);
  }
}
class lBe {
  constructor(e, t, n) {
    this.configuration = e, this.theme = new aBe(t), this.viewModel = n, this.viewLayout = n.viewLayout;
  }
  addEventHandler(e) {
    this.viewModel.addViewEventHandler(e);
  }
  removeEventHandler(e) {
    this.viewModel.removeViewEventHandler(e);
  }
}
class cBe {
  constructor(e, t, n, r) {
    this.selections = e, this.startLineNumber = t.startLineNumber | 0, this.endLineNumber = t.endLineNumber | 0, this.relativeVerticalOffset = t.relativeVerticalOffset, this.bigNumbersDelta = t.bigNumbersDelta | 0, this.whitespaceViewportData = n, this._model = r, this.visibleRange = new V(t.startLineNumber, this._model.getLineMinColumn(t.startLineNumber), t.endLineNumber, this._model.getLineMaxColumn(t.endLineNumber));
  }
  getViewLineRenderingData(e) {
    return this._model.getViewportViewLineRenderingData(this.visibleRange, e);
  }
  getDecorationsInViewport() {
    return this._model.getDecorationsInViewport(this.visibleRange);
  }
}
class dBe extends ca {
  constructor(e) {
    super(e), this.blocks = [], this.contentWidth = -1, this.contentLeft = 0, this.domNode = Dn(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setClassName("blockDecorations-container"), this.update();
  }
  update() {
    let e = !1;
    const n = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    ), r = n.contentWidth - n.verticalScrollbarWidth;
    this.contentWidth !== r && (this.contentWidth = r, e = !0);
    const s = n.contentLeft;
    return this.contentLeft !== s && (this.contentLeft = s, e = !0), e;
  }
  dispose() {
    super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    return this.update();
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollLeftChanged;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  prepareRender(e) {
  }
  render(e) {
    var t;
    let n = 0;
    const r = e.getDecorationsInViewport();
    for (const s of r) {
      if (!s.options.blockClassName)
        continue;
      let o = this.blocks[n];
      o || (o = this.blocks[n] = Dn(document.createElement("div")), this.domNode.appendChild(o));
      let a, l;
      s.options.blockIsAfterEnd ? (a = e.getVerticalOffsetAfterLineNumber(s.range.endLineNumber, !1), l = e.getVerticalOffsetAfterLineNumber(s.range.endLineNumber, !0)) : (a = e.getVerticalOffsetForLineNumber(s.range.startLineNumber, !0), l = s.range.isEmpty() && !s.options.blockDoesNotCollapse ? e.getVerticalOffsetForLineNumber(s.range.startLineNumber, !1) : e.getVerticalOffsetAfterLineNumber(s.range.endLineNumber, !0));
      const [c, d, u, h] = (t = s.options.blockPadding) !== null && t !== void 0 ? t : [0, 0, 0, 0];
      o.setClassName("blockDecorations-block " + s.options.blockClassName), o.setLeft(this.contentLeft - h), o.setWidth(this.contentWidth + h + d), o.setTop(a - e.scrollTop - c), o.setHeight(l - a + c + u), n++;
    }
    for (let s = n; s < this.blocks.length; s++)
      this.blocks[s].domNode.remove();
    this.blocks.length = n;
  }
}
class uBe extends O0 {
  constructor(e) {
    super(), this._context = e, this._options = new HZ(this._context.configuration), this._selection = [], this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = new HZ(this._context.configuration);
    return this._options.equals(t) ? e.hasChanged(
      143
      /* EditorOption.layoutInfo */
    ) : (this._options = t, !0);
  }
  onCursorStateChanged(e) {
    return this._selection = e.selections, this._options.renderWhitespace === "selection";
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  prepareRender(e) {
    if (this._options.renderWhitespace === "none") {
      this._renderResult = null;
      return;
    }
    const t = e.visibleRange.startLineNumber, r = e.visibleRange.endLineNumber - t + 1, s = new Array(r);
    for (let a = 0; a < r; a++)
      s[a] = !0;
    const o = this._context.viewModel.getMinimapLinesRenderingData(e.viewportData.startLineNumber, e.viewportData.endLineNumber, s);
    this._renderResult = [];
    for (let a = e.viewportData.startLineNumber; a <= e.viewportData.endLineNumber; a++) {
      const l = a - e.viewportData.startLineNumber, c = o.data[l];
      let d = null;
      if (this._options.renderWhitespace === "selection") {
        const u = this._selection;
        for (const h of u) {
          if (h.endLineNumber < a || h.startLineNumber > a)
            continue;
          const f = h.startLineNumber === a ? h.startColumn : c.minColumn, g = h.endLineNumber === a ? h.endColumn : c.maxColumn;
          f < g && (d || (d = []), d.push(new bfe(f - 1, g - 1)));
        }
      }
      this._renderResult[l] = this._applyRenderWhitespace(e, a, d, c);
    }
  }
  _applyRenderWhitespace(e, t, n, r) {
    if (this._options.renderWhitespace === "selection" && !n || this._options.renderWhitespace === "trailing" && r.continuesWithWrappedLine)
      return "";
    const s = this._context.theme.getColor(kh), o = this._options.renderWithSVG, a = r.content, l = this._options.stopRenderingLineAfter === -1 ? a.length : Math.min(this._options.stopRenderingLineAfter, a.length), c = r.continuesWithWrappedLine, d = r.minColumn - 1, u = this._options.renderWhitespace === "boundary", h = this._options.renderWhitespace === "trailing", f = this._options.lineHeight, g = this._options.middotWidth, p = this._options.wsmiddotWidth, m = this._options.spaceWidth, _ = Math.abs(p - m), b = Math.abs(g - m), w = _ < b ? 11825 : 183, y = this._options.canUseHalfwidthRightwardsArrow;
    let S = "", x = !1, D = Js(a), E;
    D === -1 ? (x = !0, D = l, E = l) : E = Jc(a);
    let L = 0, k = n && n[L], N = 0;
    for (let I = d; I < l; I++) {
      const A = a.charCodeAt(I);
      if (k && I >= k.endOffset && (L++, k = n && n[L]), A !== 9 && A !== 32 || h && !x && I <= E)
        continue;
      if (u && I >= D && I <= E && A === 32) {
        const O = I - 1 >= 0 ? a.charCodeAt(I - 1) : 0, K = I + 1 < l ? a.charCodeAt(I + 1) : 0;
        if (O !== 32 && K !== 32)
          continue;
      }
      if (u && c && I === l - 1) {
        const O = I - 1 >= 0 ? a.charCodeAt(I - 1) : 0;
        if (A === 32 && O !== 32 && O !== 9)
          continue;
      }
      if (n && (!k || k.startOffset > I || k.endOffset <= I))
        continue;
      const P = e.visibleRangeForPosition(new ve(t, I + 1));
      P && (o ? (N = Math.max(N, P.left), A === 9 ? S += this._renderArrow(f, m, P.left) : S += `<circle cx="${(P.left + m / 2).toFixed(2)}" cy="${(f / 2).toFixed(2)}" r="${(m / 7).toFixed(2)}" />`) : A === 9 ? S += `<div class="mwh" style="left:${P.left}px;height:${f}px;">${y ? "￫" : "→"}</div>` : S += `<div class="mwh" style="left:${P.left}px;height:${f}px;">${String.fromCharCode(w)}</div>`);
    }
    return o ? (N = Math.round(N + m), `<svg style="position:absolute;width:${N}px;height:${f}px" viewBox="0 0 ${N} ${f}" xmlns="http://www.w3.org/2000/svg" fill="${s}">` + S + "</svg>") : S;
  }
  _renderArrow(e, t, n) {
    const r = t / 7, s = t, o = e / 2, a = n, l = { x: 0, y: r / 2 }, c = { x: 100 / 125 * s, y: l.y }, d = { x: c.x - 0.2 * c.x, y: c.y + 0.2 * c.x }, u = { x: d.x + 0.1 * c.x, y: d.y + 0.1 * c.x }, h = { x: u.x + 0.35 * c.x, y: u.y - 0.35 * c.x }, f = { x: h.x, y: -h.y }, g = { x: u.x, y: -u.y }, p = { x: d.x, y: -d.y }, m = { x: c.x, y: -c.y }, _ = { x: l.x, y: -l.y };
    return `<path d="M ${[l, c, d, u, h, f, g, p, m, _].map((y) => `${(a + y.x).toFixed(2)} ${(o + y.y).toFixed(2)}`).join(" L ")}" />`;
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
class HZ {
  constructor(e) {
    const t = e.options, n = t.get(
      50
      /* EditorOption.fontInfo */
    ), r = t.get(
      38
      /* EditorOption.experimentalWhitespaceRendering */
    );
    r === "off" ? (this.renderWhitespace = "none", this.renderWithSVG = !1) : r === "svg" ? (this.renderWhitespace = t.get(
      98
      /* EditorOption.renderWhitespace */
    ), this.renderWithSVG = !0) : (this.renderWhitespace = t.get(
      98
      /* EditorOption.renderWhitespace */
    ), this.renderWithSVG = !1), this.spaceWidth = n.spaceWidth, this.middotWidth = n.middotWidth, this.wsmiddotWidth = n.wsmiddotWidth, this.canUseHalfwidthRightwardsArrow = n.canUseHalfwidthRightwardsArrow, this.lineHeight = t.get(
      66
      /* EditorOption.lineHeight */
    ), this.stopRenderingLineAfter = t.get(
      116
      /* EditorOption.stopRenderingLineAfter */
    );
  }
  equals(e) {
    return this.renderWhitespace === e.renderWhitespace && this.renderWithSVG === e.renderWithSVG && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineHeight === e.lineHeight && this.stopRenderingLineAfter === e.stopRenderingLineAfter;
  }
}
var hBe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, fBe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let FF = class extends AS {
  constructor(e, t, n, r, s, o, a) {
    super(), this._instantiationService = a, this._shouldRecomputeGlyphMarginLanes = !1, this._selections = [new ot(1, 1, 1, 1)], this._renderAnimationFrame = null;
    const l = new CFe(t, r, s, e);
    this._context = new lBe(t, n, r), this._context.addEventHandler(this), this._viewParts = [], this._textAreaHandler = this._instantiationService.createInstance(OF, this._context, l, this._createTextAreaHandlerHelper()), this._viewParts.push(this._textAreaHandler), this._linesContent = Dn(document.createElement("div")), this._linesContent.setClassName("lines-content monaco-editor-background"), this._linesContent.setPosition("absolute"), this.domNode = Dn(document.createElement("div")), this.domNode.setClassName(this._getEditorClassName()), this.domNode.setAttribute("role", "code"), this._overflowGuardContainer = Dn(document.createElement("div")), Su.write(
      this._overflowGuardContainer,
      3
      /* PartFingerprint.OverflowGuard */
    ), this._overflowGuardContainer.setClassName("overflow-guard"), this._scrollbar = new AFe(this._context, this._linesContent, this.domNode, this._overflowGuardContainer), this._viewParts.push(this._scrollbar), this._viewLines = new x4(this._context, this._linesContent), this._viewZones = new sBe(this._context), this._viewParts.push(this._viewZones);
    const c = new ZFe(this._context);
    this._viewParts.push(c);
    const d = new eBe(this._context);
    this._viewParts.push(d);
    const u = new wFe(this._context);
    this._viewParts.push(u), u.addDynamicOverlay(new EFe(this._context)), u.addDynamicOverlay(new qi(this._context)), u.addDynamicOverlay(new TFe(this._context)), u.addDynamicOverlay(new IFe(this._context)), u.addDynamicOverlay(new uBe(this._context));
    const h = new SFe(this._context);
    this._viewParts.push(h), h.addDynamicOverlay(new LFe(this._context)), h.addDynamicOverlay(new jFe(this._context)), h.addDynamicOverlay(new WFe(this._context)), h.addDynamicOverlay(new OS(this._context)), this._glyphMarginWidgets = new FFe(this._context), this._viewParts.push(this._glyphMarginWidgets);
    const f = new Xm(this._context);
    f.getDomNode().appendChild(this._viewZones.marginDomNode), f.getDomNode().appendChild(h.getDomNode()), f.getDomNode().appendChild(this._glyphMarginWidgets.domNode), this._viewParts.push(f), this._contentWidgets = new xFe(this._context, this.domNode), this._viewParts.push(this._contentWidgets), this._viewCursors = new Zy(this._context), this._viewParts.push(this._viewCursors), this._overlayWidgets = new YFe(this._context), this._viewParts.push(this._overlayWidgets);
    const g = new $Fe(this._context);
    this._viewParts.push(g);
    const p = new dBe(this._context);
    this._viewParts.push(p);
    const m = new KFe(this._context);
    if (this._viewParts.push(m), c) {
      const _ = this._scrollbar.getOverviewRulerLayoutInfo();
      _.parent.insertBefore(c.getDomNode(), _.insertBefore);
    }
    this._linesContent.appendChild(u.getDomNode()), this._linesContent.appendChild(g.domNode), this._linesContent.appendChild(this._viewZones.domNode), this._linesContent.appendChild(this._viewLines.getDomNode()), this._linesContent.appendChild(this._contentWidgets.domNode), this._linesContent.appendChild(this._viewCursors.getDomNode()), this._overflowGuardContainer.appendChild(f.getDomNode()), this._overflowGuardContainer.appendChild(this._scrollbar.getDomNode()), this._overflowGuardContainer.appendChild(d.getDomNode()), this._overflowGuardContainer.appendChild(this._textAreaHandler.textArea), this._overflowGuardContainer.appendChild(this._textAreaHandler.textAreaCover), this._overflowGuardContainer.appendChild(this._overlayWidgets.getDomNode()), this._overflowGuardContainer.appendChild(m.getDomNode()), this._overflowGuardContainer.appendChild(p.domNode), this.domNode.appendChild(this._overflowGuardContainer), o ? o.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode.domNode) : this.domNode.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode), this._applyLayout(), this._pointerHandler = this._register(new _Re(this._context, l, this._createPointerHandlerHelper()));
  }
  _flushAccumulatedAndRenderNow() {
    this._shouldRecomputeGlyphMarginLanes && (this._shouldRecomputeGlyphMarginLanes = !1, this._context.configuration.setGlyphMarginDecorationLaneCount(this._computeGlyphMarginLaneCount())), eg.onRenderStart(), this._renderNow();
  }
  _computeGlyphMarginLaneCount() {
    const e = this._context.viewModel.model;
    let t = [];
    t = t.concat(e.getAllMarginDecorations().map((s) => {
      var o, a;
      const l = (a = (o = s.options.glyphMargin) === null || o === void 0 ? void 0 : o.position) !== null && a !== void 0 ? a : Nv.Left;
      return { range: s.range, lane: l };
    })), t = t.concat(this._glyphMarginWidgets.getWidgets().map((s) => ({ range: e.validateRange(s.preference.range), lane: s.preference.lane }))), t.sort((s, o) => V.compareRangesUsingStarts(s.range, o.range));
    let n = null, r = null;
    for (const s of t)
      if (s.lane === Nv.Left && (!n || V.compareRangesUsingEnds(n, s.range) < 0) && (n = s.range), s.lane === Nv.Right && (!r || V.compareRangesUsingEnds(r, s.range) < 0) && (r = s.range), n && r) {
        if (n.endLineNumber < r.startLineNumber) {
          n = null;
          continue;
        }
        if (r.endLineNumber < n.startLineNumber) {
          r = null;
          continue;
        }
        return 2;
      }
    return 1;
  }
  _createPointerHandlerHelper() {
    return {
      viewDomNode: this.domNode.domNode,
      linesContentDomNode: this._linesContent.domNode,
      viewLinesDomNode: this._viewLines.getDomNode().domNode,
      focusTextArea: () => {
        this.focus();
      },
      dispatchTextAreaEvent: (e) => {
        this._textAreaHandler.textArea.domNode.dispatchEvent(e);
      },
      getLastRenderData: () => {
        const e = this._viewCursors.getLastRenderData() || [], t = this._textAreaHandler.getLastRenderData();
        return new X8e(e, t);
      },
      renderNow: () => {
        this.render(!0, !1);
      },
      shouldSuppressMouseDownOnViewZone: (e) => this._viewZones.shouldSuppressMouseDownOnViewZone(e),
      shouldSuppressMouseDownOnWidget: (e) => this._contentWidgets.shouldSuppressMouseDownOnWidget(e),
      getPositionFromDOMInfo: (e, t) => (this._flushAccumulatedAndRenderNow(), this._viewLines.getPositionFromDOMInfo(e, t)),
      visibleRangeForPosition: (e, t) => (this._flushAccumulatedAndRenderNow(), this._viewLines.visibleRangeForPosition(new ve(e, t))),
      getLineWidth: (e) => (this._flushAccumulatedAndRenderNow(), this._viewLines.getLineWidth(e))
    };
  }
  _createTextAreaHandlerHelper() {
    return {
      visibleRangeForPosition: (e) => (this._flushAccumulatedAndRenderNow(), this._viewLines.visibleRangeForPosition(e))
    };
  }
  _applyLayout() {
    const t = this._context.configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    );
    this.domNode.setWidth(t.width), this.domNode.setHeight(t.height), this._overflowGuardContainer.setWidth(t.width), this._overflowGuardContainer.setHeight(t.height), this._linesContent.setWidth(1e6), this._linesContent.setHeight(1e6);
  }
  _getEditorClassName() {
    const e = this._textAreaHandler.isFocused() ? " focused" : "";
    return this._context.configuration.options.get(
      140
      /* EditorOption.editorClassName */
    ) + " " + PF(this._context.theme.type) + e;
  }
  // --- begin event handlers
  handleEvents(e) {
    super.handleEvents(e), this._scheduleRender();
  }
  onConfigurationChanged(e) {
    return this.domNode.setClassName(this._getEditorClassName()), this._applyLayout(), !1;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, !1;
  }
  onDecorationsChanged(e) {
    return e.affectsGlyphMargin && (this._shouldRecomputeGlyphMarginLanes = !0), !1;
  }
  onFocusChanged(e) {
    return this.domNode.setClassName(this._getEditorClassName()), !1;
  }
  onThemeChanged(e) {
    return this._context.theme.update(e.theme), this.domNode.setClassName(this._getEditorClassName()), !1;
  }
  // --- end event handlers
  dispose() {
    this._renderAnimationFrame !== null && (this._renderAnimationFrame.dispose(), this._renderAnimationFrame = null), this._contentWidgets.overflowingContentWidgetsDomNode.domNode.remove(), this._context.removeEventHandler(this), this._viewLines.dispose();
    for (const e of this._viewParts)
      e.dispose();
    super.dispose();
  }
  _scheduleRender() {
    this._renderAnimationFrame === null && (this._renderAnimationFrame = QE(this._onRenderScheduled.bind(this), 100));
  }
  _onRenderScheduled() {
    this._renderAnimationFrame = null, this._flushAccumulatedAndRenderNow();
  }
  _renderNow() {
    gBe(() => this._actualRender());
  }
  _getViewPartsToRender() {
    const e = [];
    let t = 0;
    for (const n of this._viewParts)
      n.shouldRender() && (e[t++] = n);
    return e;
  }
  _actualRender() {
    if (!Xj(this.domNode.domNode))
      return;
    let e = this._getViewPartsToRender();
    if (!this._viewLines.shouldRender() && e.length === 0)
      return;
    const t = this._context.viewLayout.getLinesViewportData();
    this._context.viewModel.setViewport(t.startLineNumber, t.endLineNumber, t.centeredLineNumber);
    const n = new cBe(this._selections, t, this._context.viewLayout.getWhitespaceViewportData(), this._context.viewModel);
    this._contentWidgets.shouldRender() && this._contentWidgets.onBeforeRender(n), this._viewLines.shouldRender() && (this._viewLines.renderText(n), this._viewLines.onDidRender(), e = this._getViewPartsToRender());
    const r = new j8e(this._context.viewLayout, n, this._viewLines);
    for (const s of e)
      s.prepareRender(r);
    for (const s of e)
      s.render(r), s.onDidRender();
  }
  // --- BEGIN CodeEditor helpers
  delegateVerticalScrollbarPointerDown(e) {
    this._scrollbar.delegateVerticalScrollbarPointerDown(e);
  }
  delegateScrollFromMouseWheelEvent(e) {
    this._scrollbar.delegateScrollFromMouseWheelEvent(e);
  }
  restoreState(e) {
    this._context.viewModel.viewLayout.setScrollPosition(
      {
        scrollTop: e.scrollTop,
        scrollLeft: e.scrollLeft
      },
      1
      /* ScrollType.Immediate */
    ), this._context.viewModel.visibleLinesStabilized();
  }
  getOffsetForColumn(e, t) {
    const n = this._context.viewModel.model.validatePosition({
      lineNumber: e,
      column: t
    }), r = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(n);
    this._flushAccumulatedAndRenderNow();
    const s = this._viewLines.visibleRangeForPosition(new ve(r.lineNumber, r.column));
    return s ? s.left : -1;
  }
  getTargetAtClientPoint(e, t) {
    const n = this._pointerHandler.getTargetAtClientPoint(e, t);
    return n ? w4.convertViewToModelMouseTarget(n, this._context.viewModel.coordinatesConverter) : null;
  }
  createOverviewRuler(e) {
    return new JFe(this._context, e);
  }
  change(e) {
    this._viewZones.changeViewZones(e), this._scheduleRender();
  }
  render(e, t) {
    if (t) {
      this._viewLines.forceShouldRender();
      for (const n of this._viewParts)
        n.forceShouldRender();
    }
    e ? this._flushAccumulatedAndRenderNow() : this._scheduleRender();
  }
  writeScreenReaderContent(e) {
    this._textAreaHandler.writeScreenReaderContent(e);
  }
  focus() {
    this._textAreaHandler.focusTextArea();
  }
  isFocused() {
    return this._textAreaHandler.isFocused();
  }
  setAriaOptions(e) {
    this._textAreaHandler.setAriaOptions(e);
  }
  addContentWidget(e) {
    this._contentWidgets.addWidget(e.widget), this.layoutContentWidget(e), this._scheduleRender();
  }
  layoutContentWidget(e) {
    var t, n, r, s, o, a, l, c;
    this._contentWidgets.setWidgetPosition(e.widget, (n = (t = e.position) === null || t === void 0 ? void 0 : t.position) !== null && n !== void 0 ? n : null, (s = (r = e.position) === null || r === void 0 ? void 0 : r.secondaryPosition) !== null && s !== void 0 ? s : null, (a = (o = e.position) === null || o === void 0 ? void 0 : o.preference) !== null && a !== void 0 ? a : null, (c = (l = e.position) === null || l === void 0 ? void 0 : l.positionAffinity) !== null && c !== void 0 ? c : null), this._scheduleRender();
  }
  removeContentWidget(e) {
    this._contentWidgets.removeWidget(e.widget), this._scheduleRender();
  }
  addOverlayWidget(e) {
    this._overlayWidgets.addWidget(e.widget), this.layoutOverlayWidget(e), this._scheduleRender();
  }
  layoutOverlayWidget(e) {
    const t = e.position ? e.position.preference : null;
    this._overlayWidgets.setWidgetPosition(e.widget, t) && this._scheduleRender();
  }
  removeOverlayWidget(e) {
    this._overlayWidgets.removeWidget(e.widget), this._scheduleRender();
  }
  addGlyphMarginWidget(e) {
    this._glyphMarginWidgets.addWidget(e.widget), this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender();
  }
  layoutGlyphMarginWidget(e) {
    const t = e.position;
    this._glyphMarginWidgets.setWidgetPosition(e.widget, t) && (this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender());
  }
  removeGlyphMarginWidget(e) {
    this._glyphMarginWidgets.removeWidget(e.widget), this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender();
  }
};
FF = hBe([
  fBe(6, bt)
], FF);
function gBe(i) {
  try {
    return i();
  } catch (e) {
    It(e);
  }
}
class uge {
  constructor(e, t, n, r, s, o) {
    this.id = e, this.label = t, this.alias = n, this._precondition = r, this._run = s, this._contextKeyService = o;
  }
  isSupported() {
    return this._contextKeyService.contextMatchesRules(this._precondition);
  }
  run(e) {
    return this.isSupported() ? this._run(e) : Promise.resolve(void 0);
  }
}
function Wg(i) {
  let e = 0, t = 0, n = 0, r = 0;
  for (let s = 0, o = i.length; s < o; s++) {
    const a = i.charCodeAt(s);
    a === 13 ? (e === 0 && (t = s), e++, s + 1 < o && i.charCodeAt(s + 1) === 10 ? (r |= 2, s++) : r |= 3, n = s + 1) : a === 10 && (r |= 1, e === 0 && (t = s), e++, n = s + 1);
  }
  return e === 0 && (t = i.length), [e, t, i.length - n, r];
}
class WZ {
  constructor(e, t, n, r) {
    this.range = e, this.nestingLevel = t, this.nestingLevelOfEqualBracketType = n, this.isInvalid = r;
  }
}
class pBe {
  constructor(e, t, n, r, s, o) {
    this.range = e, this.openingBracketRange = t, this.closingBracketRange = n, this.nestingLevel = r, this.nestingLevelOfEqualBracketType = s, this.bracketPairNode = o;
  }
  get openingBracketInfo() {
    return this.bracketPairNode.openingBracket.bracketInfo;
  }
}
class mBe extends pBe {
  constructor(e, t, n, r, s, o, a) {
    super(e, t, n, r, s, o), this.minVisibleColumnIndentation = a;
  }
}
class Qy {
  constructor(e, t) {
    this.lineCount = e, this.columnCount = t;
  }
  toString() {
    return `${this.lineCount},${this.columnCount}`;
  }
}
Qy.zero = new Qy(0, 0);
function vBe(i, e, t, n) {
  return i !== t ? rr(t - i, n) : rr(0, n - e);
}
const po = 0;
function _L(i) {
  return i === 0;
}
const Pa = Math.pow(2, 26);
function rr(i, e) {
  return i * Pa + e;
}
function gl(i) {
  const e = i, t = Math.floor(e / Pa), n = e - t * Pa;
  return new Qy(t, n);
}
function _Be(i) {
  return Math.floor(i / Pa);
}
function Ri(i, e) {
  let t = i + e;
  return e >= Pa && (t = t - i % Pa), t;
}
function bBe(i, e) {
  return i.reduce((t, n) => Ri(t, e(n)), po);
}
function hge(i, e) {
  return i === e;
}
function Jy(i, e) {
  const t = i, n = e;
  if (n - t <= 0)
    return po;
  const s = Math.floor(t / Pa), o = Math.floor(n / Pa), a = n - o * Pa;
  if (s === o) {
    const l = t - s * Pa;
    return rr(0, a - l);
  } else
    return rr(o - s, a);
}
function Vv(i, e) {
  return i < e;
}
function Hv(i, e) {
  return i <= e;
}
function Q2(i, e) {
  return i >= e;
}
function ov(i) {
  return rr(i.lineNumber - 1, i.column - 1);
}
function Im(i, e) {
  const t = i, n = Math.floor(t / Pa), r = t - n * Pa, s = e, o = Math.floor(s / Pa), a = s - o * Pa;
  return new V(n + 1, r + 1, o + 1, a + 1);
}
function CBe(i) {
  const e = Cu(i);
  return rr(e.length - 1, e[e.length - 1].length);
}
class Th {
  static fromModelContentChanges(e) {
    return e.map((n) => {
      const r = V.lift(n.range);
      return new Th(ov(r.getStartPosition()), ov(r.getEndPosition()), CBe(n.text));
    }).reverse();
  }
  constructor(e, t, n) {
    this.startOffset = e, this.endOffset = t, this.newLength = n;
  }
  toString() {
    return `[${gl(this.startOffset)}...${gl(this.endOffset)}) -> ${gl(this.newLength)}`;
  }
}
class yBe {
  /**
   * @param edits Must be sorted by offset in ascending order.
  */
  constructor(e) {
    this.nextEditIdx = 0, this.deltaOldToNewLineCount = 0, this.deltaOldToNewColumnCount = 0, this.deltaLineIdxInOld = -1, this.edits = e.map((t) => Lz.from(t));
  }
  /**
   * @param offset Must be equal to or greater than the last offset this method has been called with.
  */
  getOffsetBeforeChange(e) {
    return this.adjustNextEdit(e), this.translateCurToOld(e);
  }
  /**
   * @param offset Must be equal to or greater than the last offset this method has been called with.
   * Returns null if there is no edit anymore.
  */
  getDistanceToNextChange(e) {
    this.adjustNextEdit(e);
    const t = this.edits[this.nextEditIdx], n = t ? this.translateOldToCur(t.offsetObj) : null;
    return n === null ? null : Jy(e, n);
  }
  translateOldToCur(e) {
    return e.lineCount === this.deltaLineIdxInOld ? rr(e.lineCount + this.deltaOldToNewLineCount, e.columnCount + this.deltaOldToNewColumnCount) : rr(e.lineCount + this.deltaOldToNewLineCount, e.columnCount);
  }
  translateCurToOld(e) {
    const t = gl(e);
    return t.lineCount - this.deltaOldToNewLineCount === this.deltaLineIdxInOld ? rr(t.lineCount - this.deltaOldToNewLineCount, t.columnCount - this.deltaOldToNewColumnCount) : rr(t.lineCount - this.deltaOldToNewLineCount, t.columnCount);
  }
  adjustNextEdit(e) {
    for (; this.nextEditIdx < this.edits.length; ) {
      const t = this.edits[this.nextEditIdx], n = this.translateOldToCur(t.endOffsetAfterObj);
      if (Hv(n, e)) {
        this.nextEditIdx++;
        const r = gl(n), s = gl(this.translateOldToCur(t.endOffsetBeforeObj)), o = r.lineCount - s.lineCount;
        this.deltaOldToNewLineCount += o;
        const a = this.deltaLineIdxInOld === t.endOffsetBeforeObj.lineCount ? this.deltaOldToNewColumnCount : 0, l = r.columnCount - s.columnCount;
        this.deltaOldToNewColumnCount = a + l, this.deltaLineIdxInOld = t.endOffsetBeforeObj.lineCount;
      } else
        break;
    }
  }
}
class Lz {
  static from(e) {
    return new Lz(e.startOffset, e.endOffset, e.newLength);
  }
  constructor(e, t, n) {
    this.endOffsetBeforeObj = gl(t), this.endOffsetAfterObj = gl(Ri(e, n)), this.offsetObj = gl(e);
  }
}
const U3 = [];
class br {
  static create(e, t) {
    if (e <= 128 && t.length === 0) {
      let n = br.cache[e];
      return n || (n = new br(e, t), br.cache[e] = n), n;
    }
    return new br(e, t);
  }
  static getEmpty() {
    return this.empty;
  }
  constructor(e, t) {
    this.items = e, this.additionalItems = t;
  }
  add(e, t) {
    const n = t.getKey(e);
    let r = n >> 5;
    if (r === 0) {
      const o = 1 << n | this.items;
      return o === this.items ? this : br.create(o, this.additionalItems);
    }
    r--;
    const s = this.additionalItems.slice(0);
    for (; s.length < r; )
      s.push(0);
    return s[r] |= 1 << (n & 31), br.create(this.items, s);
  }
  merge(e) {
    const t = this.items | e.items;
    if (this.additionalItems === U3 && e.additionalItems === U3)
      return t === this.items ? this : t === e.items ? e : br.create(t, U3);
    const n = [];
    for (let r = 0; r < Math.max(this.additionalItems.length, e.additionalItems.length); r++) {
      const s = this.additionalItems[r] || 0, o = e.additionalItems[r] || 0;
      n.push(s | o);
    }
    return br.create(t, n);
  }
  intersects(e) {
    if (this.items & e.items)
      return !0;
    for (let t = 0; t < Math.min(this.additionalItems.length, e.additionalItems.length); t++)
      if (this.additionalItems[t] & e.additionalItems[t])
        return !0;
    return !1;
  }
}
br.cache = new Array(129);
br.empty = br.create(0, U3);
const jZ = {
  getKey(i) {
    return i;
  }
};
class fge {
  constructor() {
    this.items = /* @__PURE__ */ new Map();
  }
  getKey(e) {
    let t = this.items.get(e);
    return t === void 0 && (t = this.items.size, this.items.set(e, t)), t;
  }
}
class Iz {
  /**
   * The length of the entire node, which should equal the sum of lengths of all children.
  */
  get length() {
    return this._length;
  }
  constructor(e) {
    this._length = e;
  }
}
class $y extends Iz {
  static create(e, t, n) {
    let r = e.length;
    return t && (r = Ri(r, t.length)), n && (r = Ri(r, n.length)), new $y(r, e, t, n, t ? t.missingOpeningBracketIds : br.getEmpty());
  }
  get kind() {
    return 2;
  }
  get listHeight() {
    return 0;
  }
  get childrenLength() {
    return 3;
  }
  getChild(e) {
    switch (e) {
      case 0:
        return this.openingBracket;
      case 1:
        return this.child;
      case 2:
        return this.closingBracket;
    }
    throw new Error("Invalid child index");
  }
  /**
   * Avoid using this property, it allocates an array!
  */
  get children() {
    const e = [];
    return e.push(this.openingBracket), this.child && e.push(this.child), this.closingBracket && e.push(this.closingBracket), e;
  }
  constructor(e, t, n, r, s) {
    super(e), this.openingBracket = t, this.child = n, this.closingBracket = r, this.missingOpeningBracketIds = s;
  }
  canBeReused(e) {
    return !(this.closingBracket === null || e.intersects(this.missingOpeningBracketIds));
  }
  deepClone() {
    return new $y(this.length, this.openingBracket.deepClone(), this.child && this.child.deepClone(), this.closingBracket && this.closingBracket.deepClone(), this.missingOpeningBracketIds);
  }
  computeMinIndentation(e, t) {
    return this.child ? this.child.computeMinIndentation(Ri(e, this.openingBracket.length), t) : Number.MAX_SAFE_INTEGER;
  }
}
class xu extends Iz {
  /**
   * This method uses more memory-efficient list nodes that can only store 2 or 3 children.
  */
  static create23(e, t, n, r = !1) {
    let s = e.length, o = e.missingOpeningBracketIds;
    if (e.listHeight !== t.listHeight)
      throw new Error("Invalid list heights");
    if (s = Ri(s, t.length), o = o.merge(t.missingOpeningBracketIds), n) {
      if (e.listHeight !== n.listHeight)
        throw new Error("Invalid list heights");
      s = Ri(s, n.length), o = o.merge(n.missingOpeningBracketIds);
    }
    return r ? new wBe(s, e.listHeight + 1, e, t, n, o) : new ew(s, e.listHeight + 1, e, t, n, o);
  }
  static getEmpty() {
    return new SBe(po, 0, [], br.getEmpty());
  }
  get kind() {
    return 4;
  }
  get missingOpeningBracketIds() {
    return this._missingOpeningBracketIds;
  }
  /**
   * Use ListAstNode.create.
  */
  constructor(e, t, n) {
    super(e), this.listHeight = t, this._missingOpeningBracketIds = n, this.cachedMinIndentation = -1;
  }
  throwIfImmutable() {
  }
  makeLastElementMutable() {
    this.throwIfImmutable();
    const e = this.childrenLength;
    if (e === 0)
      return;
    const t = this.getChild(e - 1), n = t.kind === 4 ? t.toMutable() : t;
    return t !== n && this.setChild(e - 1, n), n;
  }
  makeFirstElementMutable() {
    if (this.throwIfImmutable(), this.childrenLength === 0)
      return;
    const t = this.getChild(0), n = t.kind === 4 ? t.toMutable() : t;
    return t !== n && this.setChild(0, n), n;
  }
  canBeReused(e) {
    if (e.intersects(this.missingOpeningBracketIds) || this.childrenLength === 0)
      return !1;
    let t = this;
    for (; t.kind === 4; ) {
      const n = t.childrenLength;
      if (n === 0)
        throw new gr();
      t = t.getChild(n - 1);
    }
    return t.canBeReused(e);
  }
  handleChildrenChanged() {
    this.throwIfImmutable();
    const e = this.childrenLength;
    let t = this.getChild(0).length, n = this.getChild(0).missingOpeningBracketIds;
    for (let r = 1; r < e; r++) {
      const s = this.getChild(r);
      t = Ri(t, s.length), n = n.merge(s.missingOpeningBracketIds);
    }
    this._length = t, this._missingOpeningBracketIds = n, this.cachedMinIndentation = -1;
  }
  computeMinIndentation(e, t) {
    if (this.cachedMinIndentation !== -1)
      return this.cachedMinIndentation;
    let n = Number.MAX_SAFE_INTEGER, r = e;
    for (let s = 0; s < this.childrenLength; s++) {
      const o = this.getChild(s);
      o && (n = Math.min(n, o.computeMinIndentation(r, t)), r = Ri(r, o.length));
    }
    return this.cachedMinIndentation = n, n;
  }
}
class ew extends xu {
  get childrenLength() {
    return this._item3 !== null ? 3 : 2;
  }
  getChild(e) {
    switch (e) {
      case 0:
        return this._item1;
      case 1:
        return this._item2;
      case 2:
        return this._item3;
    }
    throw new Error("Invalid child index");
  }
  setChild(e, t) {
    switch (e) {
      case 0:
        this._item1 = t;
        return;
      case 1:
        this._item2 = t;
        return;
      case 2:
        this._item3 = t;
        return;
    }
    throw new Error("Invalid child index");
  }
  get children() {
    return this._item3 ? [this._item1, this._item2, this._item3] : [this._item1, this._item2];
  }
  get item1() {
    return this._item1;
  }
  get item2() {
    return this._item2;
  }
  get item3() {
    return this._item3;
  }
  constructor(e, t, n, r, s, o) {
    super(e, t, o), this._item1 = n, this._item2 = r, this._item3 = s;
  }
  deepClone() {
    return new ew(this.length, this.listHeight, this._item1.deepClone(), this._item2.deepClone(), this._item3 ? this._item3.deepClone() : null, this.missingOpeningBracketIds);
  }
  appendChildOfSameHeight(e) {
    if (this._item3)
      throw new Error("Cannot append to a full (2,3) tree node");
    this.throwIfImmutable(), this._item3 = e, this.handleChildrenChanged();
  }
  unappendChild() {
    if (!this._item3)
      throw new Error("Cannot remove from a non-full (2,3) tree node");
    this.throwIfImmutable();
    const e = this._item3;
    return this._item3 = null, this.handleChildrenChanged(), e;
  }
  prependChildOfSameHeight(e) {
    if (this._item3)
      throw new Error("Cannot prepend to a full (2,3) tree node");
    this.throwIfImmutable(), this._item3 = this._item2, this._item2 = this._item1, this._item1 = e, this.handleChildrenChanged();
  }
  unprependChild() {
    if (!this._item3)
      throw new Error("Cannot remove from a non-full (2,3) tree node");
    this.throwIfImmutable();
    const e = this._item1;
    return this._item1 = this._item2, this._item2 = this._item3, this._item3 = null, this.handleChildrenChanged(), e;
  }
  toMutable() {
    return this;
  }
}
class wBe extends ew {
  toMutable() {
    return new ew(this.length, this.listHeight, this.item1, this.item2, this.item3, this.missingOpeningBracketIds);
  }
  throwIfImmutable() {
    throw new Error("this instance is immutable");
  }
}
class bL extends xu {
  get childrenLength() {
    return this._children.length;
  }
  getChild(e) {
    return this._children[e];
  }
  setChild(e, t) {
    this._children[e] = t;
  }
  get children() {
    return this._children;
  }
  constructor(e, t, n, r) {
    super(e, t, r), this._children = n;
  }
  deepClone() {
    const e = new Array(this._children.length);
    for (let t = 0; t < this._children.length; t++)
      e[t] = this._children[t].deepClone();
    return new bL(this.length, this.listHeight, e, this.missingOpeningBracketIds);
  }
  appendChildOfSameHeight(e) {
    this.throwIfImmutable(), this._children.push(e), this.handleChildrenChanged();
  }
  unappendChild() {
    this.throwIfImmutable();
    const e = this._children.pop();
    return this.handleChildrenChanged(), e;
  }
  prependChildOfSameHeight(e) {
    this.throwIfImmutable(), this._children.unshift(e), this.handleChildrenChanged();
  }
  unprependChild() {
    this.throwIfImmutable();
    const e = this._children.shift();
    return this.handleChildrenChanged(), e;
  }
  toMutable() {
    return this;
  }
}
class SBe extends bL {
  toMutable() {
    return new bL(this.length, this.listHeight, [...this.children], this.missingOpeningBracketIds);
  }
  throwIfImmutable() {
    throw new Error("this instance is immutable");
  }
}
const xBe = [];
class Az extends Iz {
  get listHeight() {
    return 0;
  }
  get childrenLength() {
    return 0;
  }
  getChild(e) {
    return null;
  }
  get children() {
    return xBe;
  }
  deepClone() {
    return this;
  }
}
class $p extends Az {
  get kind() {
    return 0;
  }
  get missingOpeningBracketIds() {
    return br.getEmpty();
  }
  canBeReused(e) {
    return !0;
  }
  computeMinIndentation(e, t) {
    const n = gl(e), r = (n.columnCount === 0 ? n.lineCount : n.lineCount + 1) + 1, s = _Be(Ri(e, this.length)) + 1;
    let o = Number.MAX_SAFE_INTEGER;
    for (let a = r; a <= s; a++) {
      const l = t.getLineFirstNonWhitespaceColumn(a), c = t.getLineContent(a);
      if (l === 0)
        continue;
      const d = Lr.visibleColumnFromColumn(c, l, t.getOptions().tabSize);
      o = Math.min(o, d);
    }
    return o;
  }
}
class CL extends Az {
  static create(e, t, n) {
    return new CL(e, t, n);
  }
  get kind() {
    return 1;
  }
  get missingOpeningBracketIds() {
    return br.getEmpty();
  }
  constructor(e, t, n) {
    super(e), this.bracketInfo = t, this.bracketIds = n;
  }
  get text() {
    return this.bracketInfo.bracketText;
  }
  get languageId() {
    return this.bracketInfo.languageId;
  }
  canBeReused(e) {
    return !1;
  }
  computeMinIndentation(e, t) {
    return Number.MAX_SAFE_INTEGER;
  }
}
class DBe extends Az {
  get kind() {
    return 3;
  }
  constructor(e, t) {
    super(t), this.missingOpeningBracketIds = e;
  }
  canBeReused(e) {
    return !e.intersects(this.missingOpeningBracketIds);
  }
  computeMinIndentation(e, t) {
    return Number.MAX_SAFE_INTEGER;
  }
}
let Wf = class {
  constructor(e, t, n, r, s) {
    this.length = e, this.kind = t, this.bracketId = n, this.bracketIds = r, this.astNode = s;
  }
};
class gge {
  constructor(e, t) {
    this.textModel = e, this.bracketTokens = t, this.reader = new EBe(this.textModel, this.bracketTokens), this._offset = po, this.didPeek = !1, this.peeked = null, this.textBufferLineCount = e.getLineCount(), this.textBufferLastLineLength = e.getLineLength(this.textBufferLineCount);
  }
  get offset() {
    return this._offset;
  }
  get length() {
    return rr(this.textBufferLineCount - 1, this.textBufferLastLineLength);
  }
  skip(e) {
    this.didPeek = !1, this._offset = Ri(this._offset, e);
    const t = gl(this._offset);
    this.reader.setPosition(t.lineCount, t.columnCount);
  }
  read() {
    let e;
    return this.peeked ? (this.didPeek = !1, e = this.peeked) : e = this.reader.read(), e && (this._offset = Ri(this._offset, e.length)), e;
  }
  peek() {
    return this.didPeek || (this.peeked = this.reader.read(), this.didPeek = !0), this.peeked;
  }
}
class EBe {
  constructor(e, t) {
    this.textModel = e, this.bracketTokens = t, this.lineIdx = 0, this.line = null, this.lineCharOffset = 0, this.lineTokens = null, this.lineTokenOffset = 0, this.peekedToken = null, this.textBufferLineCount = e.getLineCount(), this.textBufferLastLineLength = e.getLineLength(this.textBufferLineCount);
  }
  setPosition(e, t) {
    e === this.lineIdx ? (this.lineCharOffset = t, this.line !== null && (this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset))) : (this.lineIdx = e, this.lineCharOffset = t, this.line = null), this.peekedToken = null;
  }
  read() {
    if (this.peekedToken) {
      const s = this.peekedToken;
      return this.peekedToken = null, this.lineCharOffset += s.length, s;
    }
    if (this.lineIdx > this.textBufferLineCount - 1 || this.lineIdx === this.textBufferLineCount - 1 && this.lineCharOffset >= this.textBufferLastLineLength)
      return null;
    this.line === null && (this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1), this.line = this.lineTokens.getLineContent(), this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset));
    const e = this.lineIdx, t = this.lineCharOffset;
    let n = 0;
    for (; ; ) {
      const s = this.lineTokens, o = s.getCount();
      let a = null;
      if (this.lineTokenOffset < o) {
        const l = s.getMetadata(this.lineTokenOffset);
        for (; this.lineTokenOffset + 1 < o && l === s.getMetadata(this.lineTokenOffset + 1); )
          this.lineTokenOffset++;
        const c = Cs.getTokenType(l) === 0, d = Cs.containsBalancedBrackets(l), u = s.getEndOffset(this.lineTokenOffset);
        if (d && c && this.lineCharOffset < u) {
          const h = s.getLanguageId(this.lineTokenOffset), f = this.line.substring(this.lineCharOffset, u), g = this.bracketTokens.getSingleLanguageBracketTokens(h), p = g.regExpGlobal;
          if (p) {
            p.lastIndex = 0;
            const m = p.exec(f);
            m && (a = g.getToken(m[0]), a && (this.lineCharOffset += m.index));
          }
        }
        if (n += u - this.lineCharOffset, a)
          if (e !== this.lineIdx || t !== this.lineCharOffset) {
            this.peekedToken = a;
            break;
          } else
            return this.lineCharOffset += a.length, a;
        else
          this.lineTokenOffset++, this.lineCharOffset = u;
      } else if (this.lineIdx === this.textBufferLineCount - 1 || (this.lineIdx++, this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1), this.lineTokenOffset = 0, this.line = this.lineTokens.getLineContent(), this.lineCharOffset = 0, n += 33, n > 1e3))
        break;
      if (n > 1500)
        break;
    }
    const r = vBe(e, t, this.lineIdx, this.lineCharOffset);
    return new Wf(r, 0, -1, br.getEmpty(), new $p(r));
  }
}
class LBe {
  constructor(e, t) {
    this.text = e, this._offset = po, this.idx = 0;
    const n = t.getRegExpStr(), r = n ? new RegExp(n + `|
`, "gi") : null, s = [];
    let o, a = 0, l = 0, c = 0, d = 0;
    const u = [];
    for (let g = 0; g < 60; g++)
      u.push(new Wf(rr(0, g), 0, -1, br.getEmpty(), new $p(rr(0, g))));
    const h = [];
    for (let g = 0; g < 60; g++)
      h.push(new Wf(rr(1, g), 0, -1, br.getEmpty(), new $p(rr(1, g))));
    if (r)
      for (r.lastIndex = 0; (o = r.exec(e)) !== null; ) {
        const g = o.index, p = o[0];
        if (p === `
`)
          a++, l = g + 1;
        else {
          if (c !== g) {
            let m;
            if (d === a) {
              const _ = g - c;
              if (_ < u.length)
                m = u[_];
              else {
                const b = rr(0, _);
                m = new Wf(b, 0, -1, br.getEmpty(), new $p(b));
              }
            } else {
              const _ = a - d, b = g - l;
              if (_ === 1 && b < h.length)
                m = h[b];
              else {
                const w = rr(_, b);
                m = new Wf(w, 0, -1, br.getEmpty(), new $p(w));
              }
            }
            s.push(m);
          }
          s.push(t.getToken(p)), c = g + p.length, d = a;
        }
      }
    const f = e.length;
    if (c !== f) {
      const g = d === a ? rr(0, f - c) : rr(a - d, f - l);
      s.push(new Wf(g, 0, -1, br.getEmpty(), new $p(g)));
    }
    this.length = rr(a, f - l), this.tokens = s;
  }
  get offset() {
    return this._offset;
  }
  read() {
    return this.tokens[this.idx++] || null;
  }
  peek() {
    return this.tokens[this.idx] || null;
  }
  skip(e) {
    throw new ATe();
  }
}
class kz {
  static createFromLanguage(e, t) {
    function n(s) {
      return t.getKey(`${s.languageId}:::${s.bracketText}`);
    }
    const r = /* @__PURE__ */ new Map();
    for (const s of e.bracketsNew.openingBrackets) {
      const o = rr(0, s.bracketText.length), a = n(s), l = br.getEmpty().add(a, jZ);
      r.set(s.bracketText, new Wf(o, 1, a, l, CL.create(o, s, l)));
    }
    for (const s of e.bracketsNew.closingBrackets) {
      const o = rr(0, s.bracketText.length);
      let a = br.getEmpty();
      const l = s.getOpeningBrackets();
      for (const c of l)
        a = a.add(n(c), jZ);
      r.set(s.bracketText, new Wf(o, 2, n(l[0]), a, CL.create(o, s, a)));
    }
    return new kz(r);
  }
  constructor(e) {
    this.map = e, this.hasRegExp = !1, this._regExpGlobal = null;
  }
  getRegExpStr() {
    if (this.isEmpty)
      return null;
    {
      const e = [...this.map.keys()];
      return e.sort(), e.reverse(), e.map((t) => IBe(t)).join("|");
    }
  }
  /**
   * Returns null if there is no such regexp (because there are no brackets).
  */
  get regExpGlobal() {
    if (!this.hasRegExp) {
      const e = this.getRegExpStr();
      this._regExpGlobal = e ? new RegExp(e, "gi") : null, this.hasRegExp = !0;
    }
    return this._regExpGlobal;
  }
  getToken(e) {
    return this.map.get(e.toLowerCase());
  }
  findClosingTokenText(e) {
    for (const [t, n] of this.map)
      if (n.kind === 2 && n.bracketIds.intersects(e))
        return t;
  }
  get isEmpty() {
    return this.map.size === 0;
  }
}
function IBe(i) {
  let e = Va(i);
  return /^[\w ]+/.test(i) && (e = `\\b${e}`), /[\w ]+$/.test(i) && (e = `${e}\\b`), e;
}
class pge {
  constructor(e, t) {
    this.denseKeyProvider = e, this.getLanguageConfiguration = t, this.languageIdToBracketTokens = /* @__PURE__ */ new Map();
  }
  didLanguageChange(e) {
    return this.languageIdToBracketTokens.has(e);
  }
  getSingleLanguageBracketTokens(e) {
    let t = this.languageIdToBracketTokens.get(e);
    return t || (t = kz.createFromLanguage(this.getLanguageConfiguration(e), this.denseKeyProvider), this.languageIdToBracketTokens.set(e, t)), t;
  }
}
function ABe(i) {
  if (i.length === 0)
    return null;
  if (i.length === 1)
    return i[0];
  let e = 0;
  function t() {
    if (e >= i.length)
      return null;
    const o = e, a = i[o].listHeight;
    for (e++; e < i.length && i[e].listHeight === a; )
      e++;
    return e - o >= 2 ? mge(o === 0 && e === i.length ? i : i.slice(o, e), !1) : i[o];
  }
  let n = t(), r = t();
  if (!r)
    return n;
  for (let o = t(); o; o = t())
    zZ(n, r) <= zZ(r, o) ? (n = M6(n, r), r = o) : r = M6(r, o);
  return M6(n, r);
}
function mge(i, e = !1) {
  if (i.length === 0)
    return null;
  if (i.length === 1)
    return i[0];
  let t = i.length;
  for (; t > 3; ) {
    const n = t >> 1;
    for (let r = 0; r < n; r++) {
      const s = r << 1;
      i[r] = xu.create23(i[s], i[s + 1], s + 3 === t ? i[s + 2] : null, e);
    }
    t = n;
  }
  return xu.create23(i[0], i[1], t >= 3 ? i[2] : null, e);
}
function zZ(i, e) {
  return Math.abs(i.listHeight - e.listHeight);
}
function M6(i, e) {
  return i.listHeight === e.listHeight ? xu.create23(i, e, null, !1) : i.listHeight > e.listHeight ? kBe(i, e) : TBe(e, i);
}
function kBe(i, e) {
  i = i.toMutable();
  let t = i;
  const n = [];
  let r;
  for (; ; ) {
    if (e.listHeight === t.listHeight) {
      r = e;
      break;
    }
    if (t.kind !== 4)
      throw new Error("unexpected");
    n.push(t), t = t.makeLastElementMutable();
  }
  for (let s = n.length - 1; s >= 0; s--) {
    const o = n[s];
    r ? o.childrenLength >= 3 ? r = xu.create23(o.unappendChild(), r, null, !1) : (o.appendChildOfSameHeight(r), r = void 0) : o.handleChildrenChanged();
  }
  return r ? xu.create23(i, r, null, !1) : i;
}
function TBe(i, e) {
  i = i.toMutable();
  let t = i;
  const n = [];
  for (; e.listHeight !== t.listHeight; ) {
    if (t.kind !== 4)
      throw new Error("unexpected");
    n.push(t), t = t.makeFirstElementMutable();
  }
  let r = e;
  for (let s = n.length - 1; s >= 0; s--) {
    const o = n[s];
    r ? o.childrenLength >= 3 ? r = xu.create23(r, o.unprependChild(), null, !1) : (o.prependChildOfSameHeight(r), r = void 0) : o.handleChildrenChanged();
  }
  return r ? xu.create23(r, i, null, !1) : i;
}
class NBe {
  constructor(e) {
    this.lastOffset = po, this.nextNodes = [e], this.offsets = [po], this.idxs = [];
  }
  /**
   * Returns the longest node at `offset` that satisfies the predicate.
   * @param offset must be greater than or equal to the last offset this method has been called with!
  */
  readLongestNodeAt(e, t) {
    if (Vv(e, this.lastOffset))
      throw new Error("Invalid offset");
    for (this.lastOffset = e; ; ) {
      const n = a2(this.nextNodes);
      if (!n)
        return;
      const r = a2(this.offsets);
      if (Vv(e, r))
        return;
      if (Vv(r, e))
        if (Ri(r, n.length) <= e)
          this.nextNodeAfterCurrent();
        else {
          const s = R6(n);
          s !== -1 ? (this.nextNodes.push(n.getChild(s)), this.offsets.push(r), this.idxs.push(s)) : this.nextNodeAfterCurrent();
        }
      else {
        if (t(n))
          return this.nextNodeAfterCurrent(), n;
        {
          const s = R6(n);
          if (s === -1) {
            this.nextNodeAfterCurrent();
            return;
          } else
            this.nextNodes.push(n.getChild(s)), this.offsets.push(r), this.idxs.push(s);
        }
      }
    }
  }
  // Navigates to the longest node that continues after the current node.
  nextNodeAfterCurrent() {
    for (; ; ) {
      const e = a2(this.offsets), t = a2(this.nextNodes);
      if (this.nextNodes.pop(), this.offsets.pop(), this.idxs.length === 0)
        break;
      const n = a2(this.nextNodes), r = R6(n, this.idxs[this.idxs.length - 1]);
      if (r !== -1) {
        this.nextNodes.push(n.getChild(r)), this.offsets.push(Ri(e, t.length)), this.idxs[this.idxs.length - 1] = r;
        break;
      } else
        this.idxs.pop();
    }
  }
}
function R6(i, e = -1) {
  for (; ; ) {
    if (e++, e >= i.childrenLength)
      return -1;
    if (i.getChild(e))
      return e;
  }
}
function a2(i) {
  return i.length > 0 ? i[i.length - 1] : void 0;
}
function BF(i, e, t, n) {
  return new PBe(i, e, t, n).parseDocument();
}
class PBe {
  constructor(e, t, n, r) {
    if (this.tokenizer = e, this.createImmutableLists = r, this._itemsConstructed = 0, this._itemsFromCache = 0, n && r)
      throw new Error("Not supported");
    this.oldNodeReader = n ? new NBe(n) : void 0, this.positionMapper = new yBe(t);
  }
  parseDocument() {
    this._itemsConstructed = 0, this._itemsFromCache = 0;
    let e = this.parseList(br.getEmpty(), 0);
    return e || (e = xu.getEmpty()), e;
  }
  parseList(e, t) {
    const n = [];
    for (; ; ) {
      let s = this.tryReadChildFromCache(e);
      if (!s) {
        const o = this.tokenizer.peek();
        if (!o || o.kind === 2 && o.bracketIds.intersects(e))
          break;
        s = this.parseChild(e, t + 1);
      }
      s.kind === 4 && s.childrenLength === 0 || n.push(s);
    }
    return this.oldNodeReader ? ABe(n) : mge(n, this.createImmutableLists);
  }
  tryReadChildFromCache(e) {
    if (this.oldNodeReader) {
      const t = this.positionMapper.getDistanceToNextChange(this.tokenizer.offset);
      if (t === null || !_L(t)) {
        const n = this.oldNodeReader.readLongestNodeAt(this.positionMapper.getOffsetBeforeChange(this.tokenizer.offset), (r) => t !== null && !Vv(r.length, t) ? !1 : r.canBeReused(e));
        if (n)
          return this._itemsFromCache++, this.tokenizer.skip(n.length), n;
      }
    }
  }
  parseChild(e, t) {
    this._itemsConstructed++;
    const n = this.tokenizer.read();
    switch (n.kind) {
      case 2:
        return new DBe(n.bracketIds, n.length);
      case 0:
        return n.astNode;
      case 1: {
        if (t > 300)
          return new $p(n.length);
        const r = e.merge(n.bracketIds), s = this.parseList(r, t + 1), o = this.tokenizer.peek();
        return o && o.kind === 2 && (o.bracketId === n.bracketId || o.bracketIds.intersects(n.bracketIds)) ? (this.tokenizer.read(), $y.create(n.astNode, s, o.astNode)) : $y.create(n.astNode, s, null);
      }
      default:
        throw new Error("unexpected");
    }
  }
}
function yL(i, e) {
  if (i.length === 0)
    return e;
  if (e.length === 0)
    return i;
  const t = new Xh(UZ(i)), n = UZ(e);
  n.push({ modified: !1, lengthBefore: void 0, lengthAfter: void 0 });
  let r = t.dequeue();
  function s(c) {
    if (c === void 0) {
      const u = t.takeWhile((h) => !0) || [];
      return r && u.unshift(r), u;
    }
    const d = [];
    for (; r && !_L(c); ) {
      const [u, h] = r.splitAt(c);
      d.push(u), c = Jy(u.lengthAfter, c), r = h ?? t.dequeue();
    }
    return _L(c) || d.push(new tg(!1, c, c)), d;
  }
  const o = [];
  function a(c, d, u) {
    if (o.length > 0 && hge(o[o.length - 1].endOffset, c)) {
      const h = o[o.length - 1];
      o[o.length - 1] = new Th(h.startOffset, d, Ri(h.newLength, u));
    } else
      o.push({ startOffset: c, endOffset: d, newLength: u });
  }
  let l = po;
  for (const c of n) {
    const d = s(c.lengthBefore);
    if (c.modified) {
      const u = bBe(d, (f) => f.lengthBefore), h = Ri(l, u);
      a(l, h, c.lengthAfter), l = h;
    } else
      for (const u of d) {
        const h = l;
        l = Ri(l, u.lengthBefore), u.modified && a(h, l, u.lengthAfter);
      }
  }
  return o;
}
class tg {
  constructor(e, t, n) {
    this.modified = e, this.lengthBefore = t, this.lengthAfter = n;
  }
  splitAt(e) {
    const t = Jy(e, this.lengthAfter);
    return hge(t, po) ? [this, void 0] : this.modified ? [
      new tg(this.modified, this.lengthBefore, e),
      new tg(this.modified, po, t)
    ] : [
      new tg(this.modified, e, e),
      new tg(this.modified, t, t)
    ];
  }
  toString() {
    return `${this.modified ? "M" : "U"}:${gl(this.lengthBefore)} -> ${gl(this.lengthAfter)}`;
  }
}
function UZ(i) {
  const e = [];
  let t = po;
  for (const n of i) {
    const r = Jy(t, n.startOffset);
    _L(r) || e.push(new tg(!1, r, r));
    const s = Jy(n.startOffset, n.endOffset);
    e.push(new tg(!0, s, n.newLength)), t = n.endOffset;
  }
  return e;
}
class OBe extends we {
  didLanguageChange(e) {
    return this.brackets.didLanguageChange(e);
  }
  constructor(e, t) {
    if (super(), this.textModel = e, this.getLanguageConfiguration = t, this.didChangeEmitter = new pe(), this.denseKeyProvider = new fge(), this.brackets = new pge(this.denseKeyProvider, this.getLanguageConfiguration), this.onDidChange = this.didChangeEmitter.event, this.queuedTextEditsForInitialAstWithoutTokens = [], this.queuedTextEdits = [], e.tokenization.hasTokens)
      e.tokenization.backgroundTokenizationState === 2 ? (this.initialAstWithoutTokens = void 0, this.astWithTokens = this.parseDocumentFromTextBuffer([], void 0, !1)) : (this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer([], void 0, !0), this.astWithTokens = this.initialAstWithoutTokens);
    else {
      const n = this.brackets.getSingleLanguageBracketTokens(this.textModel.getLanguageId()), r = new LBe(this.textModel.getValue(), n);
      this.initialAstWithoutTokens = BF(r, [], void 0, !0), this.astWithTokens = this.initialAstWithoutTokens;
    }
  }
  //#region TextModel events
  handleDidChangeBackgroundTokenizationState() {
    if (this.textModel.tokenization.backgroundTokenizationState === 2) {
      const e = this.initialAstWithoutTokens === void 0;
      this.initialAstWithoutTokens = void 0, e || this.didChangeEmitter.fire();
    }
  }
  handleDidChangeTokens({ ranges: e }) {
    const t = e.map((n) => new Th(rr(n.fromLineNumber - 1, 0), rr(n.toLineNumber, 0), rr(n.toLineNumber - n.fromLineNumber + 1, 0)));
    this.handleEdits(t, !0), this.initialAstWithoutTokens || this.didChangeEmitter.fire();
  }
  handleContentChanged(e) {
    const t = Th.fromModelContentChanges(e.changes);
    this.handleEdits(t, !1);
  }
  handleEdits(e, t) {
    const n = yL(this.queuedTextEdits, e);
    this.queuedTextEdits = n, this.initialAstWithoutTokens && !t && (this.queuedTextEditsForInitialAstWithoutTokens = yL(this.queuedTextEditsForInitialAstWithoutTokens, e));
  }
  //#endregion
  flushQueue() {
    this.queuedTextEdits.length > 0 && (this.astWithTokens = this.parseDocumentFromTextBuffer(this.queuedTextEdits, this.astWithTokens, !1), this.queuedTextEdits = []), this.queuedTextEditsForInitialAstWithoutTokens.length > 0 && (this.initialAstWithoutTokens && (this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer(this.queuedTextEditsForInitialAstWithoutTokens, this.initialAstWithoutTokens, !1)), this.queuedTextEditsForInitialAstWithoutTokens = []);
  }
  /**
   * @pure (only if isPure = true)
  */
  parseDocumentFromTextBuffer(e, t, n) {
    const r = t, s = new gge(this.textModel, this.brackets);
    return BF(s, e, r, n);
  }
  getBracketsInRange(e, t) {
    this.flushQueue();
    const n = rr(e.startLineNumber - 1, e.startColumn - 1), r = rr(e.endLineNumber - 1, e.endColumn - 1);
    return new au((s) => {
      const o = this.initialAstWithoutTokens || this.astWithTokens;
      VF(o, po, o.length, n, r, s, 0, 0, /* @__PURE__ */ new Map(), t);
    });
  }
  getBracketPairsInRange(e, t) {
    this.flushQueue();
    const n = ov(e.getStartPosition()), r = ov(e.getEndPosition());
    return new au((s) => {
      const o = this.initialAstWithoutTokens || this.astWithTokens, a = new MBe(s, t, this.textModel);
      HF(o, po, o.length, n, r, a, 0, /* @__PURE__ */ new Map());
    });
  }
  getFirstBracketAfter(e) {
    this.flushQueue();
    const t = this.initialAstWithoutTokens || this.astWithTokens;
    return _ge(t, po, t.length, ov(e));
  }
  getFirstBracketBefore(e) {
    this.flushQueue();
    const t = this.initialAstWithoutTokens || this.astWithTokens;
    return vge(t, po, t.length, ov(e));
  }
}
function vge(i, e, t, n) {
  if (i.kind === 4 || i.kind === 2) {
    const r = [];
    for (const s of i.children)
      t = Ri(e, s.length), r.push({ nodeOffsetStart: e, nodeOffsetEnd: t }), e = t;
    for (let s = r.length - 1; s >= 0; s--) {
      const { nodeOffsetStart: o, nodeOffsetEnd: a } = r[s];
      if (Vv(o, n)) {
        const l = vge(i.children[s], o, a, n);
        if (l)
          return l;
      }
    }
    return null;
  } else {
    if (i.kind === 3)
      return null;
    if (i.kind === 1) {
      const r = Im(e, t);
      return {
        bracketInfo: i.bracketInfo,
        range: r
      };
    }
  }
  return null;
}
function _ge(i, e, t, n) {
  if (i.kind === 4 || i.kind === 2) {
    for (const r of i.children) {
      if (t = Ri(e, r.length), Vv(n, t)) {
        const s = _ge(r, e, t, n);
        if (s)
          return s;
      }
      e = t;
    }
    return null;
  } else {
    if (i.kind === 3)
      return null;
    if (i.kind === 1) {
      const r = Im(e, t);
      return {
        bracketInfo: i.bracketInfo,
        range: r
      };
    }
  }
  return null;
}
function VF(i, e, t, n, r, s, o, a, l, c, d = !1) {
  if (o > 200)
    return !0;
  e: for (; ; )
    switch (i.kind) {
      case 4: {
        const u = i.childrenLength;
        for (let h = 0; h < u; h++) {
          const f = i.getChild(h);
          if (f) {
            if (t = Ri(e, f.length), Hv(e, r) && Q2(t, n)) {
              if (Q2(t, r)) {
                i = f;
                continue e;
              }
              if (!VF(f, e, t, n, r, s, o, 0, l, c))
                return !1;
            }
            e = t;
          }
        }
        return !0;
      }
      case 2: {
        const u = !c || !i.closingBracket || i.closingBracket.bracketInfo.closesColorized(i.openingBracket.bracketInfo);
        let h = 0;
        if (l) {
          let g = l.get(i.openingBracket.text);
          g === void 0 && (g = 0), h = g, u && (g++, l.set(i.openingBracket.text, g));
        }
        const f = i.childrenLength;
        for (let g = 0; g < f; g++) {
          const p = i.getChild(g);
          if (p) {
            if (t = Ri(e, p.length), Hv(e, r) && Q2(t, n)) {
              if (Q2(t, r) && p.kind !== 1) {
                i = p, u ? (o++, a = h + 1) : a = h;
                continue e;
              }
              if ((u || p.kind !== 1 || !i.closingBracket) && !VF(p, e, t, n, r, s, u ? o + 1 : o, u ? h + 1 : h, l, c, !i.closingBracket))
                return !1;
            }
            e = t;
          }
        }
        return l?.set(i.openingBracket.text, h), !0;
      }
      case 3: {
        const u = Im(e, t);
        return s(new WZ(u, o - 1, 0, !0));
      }
      case 1: {
        const u = Im(e, t);
        return s(new WZ(u, o - 1, a - 1, d));
      }
      case 0:
        return !0;
    }
}
class MBe {
  constructor(e, t, n) {
    this.push = e, this.includeMinIndentation = t, this.textModel = n;
  }
}
function HF(i, e, t, n, r, s, o, a) {
  var l;
  if (o > 200)
    return !0;
  let c = !0;
  if (i.kind === 2) {
    let d = 0;
    if (a) {
      let f = a.get(i.openingBracket.text);
      f === void 0 && (f = 0), d = f, f++, a.set(i.openingBracket.text, f);
    }
    const u = Ri(e, i.openingBracket.length);
    let h = -1;
    if (s.includeMinIndentation && (h = i.computeMinIndentation(e, s.textModel)), c = s.push(new mBe(Im(e, t), Im(e, u), i.closingBracket ? Im(Ri(u, ((l = i.child) === null || l === void 0 ? void 0 : l.length) || po), t) : void 0, o, d, i, h)), e = u, c && i.child) {
      const f = i.child;
      if (t = Ri(e, f.length), Hv(e, r) && Q2(t, n) && (c = HF(f, e, t, n, r, s, o + 1, a), !c))
        return !1;
    }
    a?.set(i.openingBracket.text, d);
  } else {
    let d = e;
    for (const u of i.children) {
      const h = d;
      if (d = Ri(d, u.length), Hv(h, r) && Hv(n, d) && (c = HF(u, h, d, n, r, s, o, a), !c))
        return !1;
    }
  }
  return c;
}
class RBe extends we {
  get canBuildAST() {
    return this.textModel.getValueLength() <= 5e6;
  }
  constructor(e, t) {
    super(), this.textModel = e, this.languageConfigurationService = t, this.bracketPairsTree = this._register(new ds()), this.onDidChangeEmitter = new pe(), this.onDidChange = this.onDidChangeEmitter.event, this.bracketsRequested = !1, this._register(this.languageConfigurationService.onDidChange((n) => {
      var r;
      (!n.languageId || !((r = this.bracketPairsTree.value) === null || r === void 0) && r.object.didLanguageChange(n.languageId)) && (this.bracketPairsTree.clear(), this.updateBracketPairsTree());
    }));
  }
  //#region TextModel events
  handleDidChangeOptions(e) {
    this.bracketPairsTree.clear(), this.updateBracketPairsTree();
  }
  handleDidChangeLanguage(e) {
    this.bracketPairsTree.clear(), this.updateBracketPairsTree();
  }
  handleDidChangeContent(e) {
    var t;
    (t = this.bracketPairsTree.value) === null || t === void 0 || t.object.handleContentChanged(e);
  }
  handleDidChangeBackgroundTokenizationState() {
    var e;
    (e = this.bracketPairsTree.value) === null || e === void 0 || e.object.handleDidChangeBackgroundTokenizationState();
  }
  handleDidChangeTokens(e) {
    var t;
    (t = this.bracketPairsTree.value) === null || t === void 0 || t.object.handleDidChangeTokens(e);
  }
  //#endregion
  updateBracketPairsTree() {
    if (this.bracketsRequested && this.canBuildAST) {
      if (!this.bracketPairsTree.value) {
        const e = new Ne();
        this.bracketPairsTree.value = FBe(e.add(new OBe(this.textModel, (t) => this.languageConfigurationService.getLanguageConfiguration(t))), e), e.add(this.bracketPairsTree.value.object.onDidChange((t) => this.onDidChangeEmitter.fire(t))), this.onDidChangeEmitter.fire();
      }
    } else
      this.bracketPairsTree.value && (this.bracketPairsTree.clear(), this.onDidChangeEmitter.fire());
  }
  /**
   * Returns all bracket pairs that intersect the given range.
   * The result is sorted by the start position.
  */
  getBracketPairsInRange(e) {
    var t;
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getBracketPairsInRange(e, !1)) || au.empty;
  }
  getBracketPairsInRangeWithMinIndentation(e) {
    var t;
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getBracketPairsInRange(e, !0)) || au.empty;
  }
  getBracketsInRange(e, t = !1) {
    var n;
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((n = this.bracketPairsTree.value) === null || n === void 0 ? void 0 : n.object.getBracketsInRange(e, t)) || au.empty;
  }
  findMatchingBracketUp(e, t, n) {
    const r = this.textModel.validatePosition(t), s = this.textModel.getLanguageIdAtPosition(r.lineNumber, r.column);
    if (this.canBuildAST) {
      const o = this.languageConfigurationService.getLanguageConfiguration(s).bracketsNew.getClosingBracketInfo(e);
      if (!o)
        return null;
      const a = this.getBracketPairsInRange(V.fromPositions(t, t)).findLast((l) => o.closes(l.openingBracketInfo));
      return a ? a.openingBracketRange : null;
    } else {
      const o = e.toLowerCase(), a = this.languageConfigurationService.getLanguageConfiguration(s).brackets;
      if (!a)
        return null;
      const l = a.textIsBracket[o];
      return l ? eD(this._findMatchingBracketUp(l, r, F6(n))) : null;
    }
  }
  matchBracket(e, t) {
    if (this.canBuildAST) {
      const n = this.getBracketPairsInRange(V.fromPositions(e, e)).filter((r) => r.closingBracketRange !== void 0 && (r.openingBracketRange.containsPosition(e) || r.closingBracketRange.containsPosition(e))).findLastMaxBy(hl((r) => r.openingBracketRange.containsPosition(e) ? r.openingBracketRange : r.closingBracketRange, V.compareRangesUsingStarts));
      return n ? [n.openingBracketRange, n.closingBracketRange] : null;
    } else {
      const n = F6(t);
      return this._matchBracket(this.textModel.validatePosition(e), n);
    }
  }
  _establishBracketSearchOffsets(e, t, n, r) {
    const s = t.getCount(), o = t.getLanguageId(r);
    let a = Math.max(0, e.column - 1 - n.maxBracketLength);
    for (let c = r - 1; c >= 0; c--) {
      const d = t.getEndOffset(c);
      if (d <= a)
        break;
      if (Ed(t.getStandardTokenType(c)) || t.getLanguageId(c) !== o) {
        a = d;
        break;
      }
    }
    let l = Math.min(t.getLineContent().length, e.column - 1 + n.maxBracketLength);
    for (let c = r + 1; c < s; c++) {
      const d = t.getStartOffset(c);
      if (d >= l)
        break;
      if (Ed(t.getStandardTokenType(c)) || t.getLanguageId(c) !== o) {
        l = d;
        break;
      }
    }
    return { searchStartOffset: a, searchEndOffset: l };
  }
  _matchBracket(e, t) {
    const n = e.lineNumber, r = this.textModel.tokenization.getLineTokens(n), s = this.textModel.getLineContent(n), o = r.findTokenIndexAtOffset(e.column - 1);
    if (o < 0)
      return null;
    const a = this.languageConfigurationService.getLanguageConfiguration(r.getLanguageId(o)).brackets;
    if (a && !Ed(r.getStandardTokenType(o))) {
      let { searchStartOffset: l, searchEndOffset: c } = this._establishBracketSearchOffsets(e, r, a, o), d = null;
      for (; ; ) {
        const u = Rl.findNextBracketInRange(a.forwardRegex, n, s, l, c);
        if (!u)
          break;
        if (u.startColumn <= e.column && e.column <= u.endColumn) {
          const h = s.substring(u.startColumn - 1, u.endColumn - 1).toLowerCase(), f = this._matchFoundBracket(u, a.textIsBracket[h], a.textIsOpenBracket[h], t);
          if (f) {
            if (f instanceof ch)
              return null;
            d = f;
          }
        }
        l = u.endColumn - 1;
      }
      if (d)
        return d;
    }
    if (o > 0 && r.getStartOffset(o) === e.column - 1) {
      const l = o - 1, c = this.languageConfigurationService.getLanguageConfiguration(r.getLanguageId(l)).brackets;
      if (c && !Ed(r.getStandardTokenType(l))) {
        const { searchStartOffset: d, searchEndOffset: u } = this._establishBracketSearchOffsets(e, r, c, l), h = Rl.findPrevBracketInRange(c.reversedRegex, n, s, d, u);
        if (h && h.startColumn <= e.column && e.column <= h.endColumn) {
          const f = s.substring(h.startColumn - 1, h.endColumn - 1).toLowerCase(), g = this._matchFoundBracket(h, c.textIsBracket[f], c.textIsOpenBracket[f], t);
          if (g)
            return g instanceof ch ? null : g;
        }
      }
    }
    return null;
  }
  _matchFoundBracket(e, t, n, r) {
    if (!t)
      return null;
    const s = n ? this._findMatchingBracketDown(t, e.getEndPosition(), r) : this._findMatchingBracketUp(t, e.getStartPosition(), r);
    return s ? s instanceof ch ? s : [e, s] : null;
  }
  _findMatchingBracketUp(e, t, n) {
    const r = e.languageId, s = e.reversedRegex;
    let o = -1, a = 0;
    const l = (c, d, u, h) => {
      for (; ; ) {
        if (n && ++a % 100 === 0 && !n())
          return ch.INSTANCE;
        const f = Rl.findPrevBracketInRange(s, c, d, u, h);
        if (!f)
          break;
        const g = d.substring(f.startColumn - 1, f.endColumn - 1).toLowerCase();
        if (e.isOpen(g) ? o++ : e.isClose(g) && o--, o === 0)
          return f;
        h = f.startColumn - 1;
      }
      return null;
    };
    for (let c = t.lineNumber; c >= 1; c--) {
      const d = this.textModel.tokenization.getLineTokens(c), u = d.getCount(), h = this.textModel.getLineContent(c);
      let f = u - 1, g = h.length, p = h.length;
      c === t.lineNumber && (f = d.findTokenIndexAtOffset(t.column - 1), g = t.column - 1, p = t.column - 1);
      let m = !0;
      for (; f >= 0; f--) {
        const _ = d.getLanguageId(f) === r && !Ed(d.getStandardTokenType(f));
        if (_)
          m ? g = d.getStartOffset(f) : (g = d.getStartOffset(f), p = d.getEndOffset(f));
        else if (m && g !== p) {
          const b = l(c, h, g, p);
          if (b)
            return b;
        }
        m = _;
      }
      if (m && g !== p) {
        const _ = l(c, h, g, p);
        if (_)
          return _;
      }
    }
    return null;
  }
  _findMatchingBracketDown(e, t, n) {
    const r = e.languageId, s = e.forwardRegex;
    let o = 1, a = 0;
    const l = (d, u, h, f) => {
      for (; ; ) {
        if (n && ++a % 100 === 0 && !n())
          return ch.INSTANCE;
        const g = Rl.findNextBracketInRange(s, d, u, h, f);
        if (!g)
          break;
        const p = u.substring(g.startColumn - 1, g.endColumn - 1).toLowerCase();
        if (e.isOpen(p) ? o++ : e.isClose(p) && o--, o === 0)
          return g;
        h = g.endColumn - 1;
      }
      return null;
    }, c = this.textModel.getLineCount();
    for (let d = t.lineNumber; d <= c; d++) {
      const u = this.textModel.tokenization.getLineTokens(d), h = u.getCount(), f = this.textModel.getLineContent(d);
      let g = 0, p = 0, m = 0;
      d === t.lineNumber && (g = u.findTokenIndexAtOffset(t.column - 1), p = t.column - 1, m = t.column - 1);
      let _ = !0;
      for (; g < h; g++) {
        const b = u.getLanguageId(g) === r && !Ed(u.getStandardTokenType(g));
        if (b)
          _ || (p = u.getStartOffset(g)), m = u.getEndOffset(g);
        else if (_ && p !== m) {
          const w = l(d, f, p, m);
          if (w)
            return w;
        }
        _ = b;
      }
      if (_ && p !== m) {
        const b = l(d, f, p, m);
        if (b)
          return b;
      }
    }
    return null;
  }
  findPrevBracket(e) {
    var t;
    const n = this.textModel.validatePosition(e);
    if (this.canBuildAST)
      return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getFirstBracketBefore(n)) || null;
    let r = null, s = null, o = null;
    for (let a = n.lineNumber; a >= 1; a--) {
      const l = this.textModel.tokenization.getLineTokens(a), c = l.getCount(), d = this.textModel.getLineContent(a);
      let u = c - 1, h = d.length, f = d.length;
      if (a === n.lineNumber) {
        u = l.findTokenIndexAtOffset(n.column - 1), h = n.column - 1, f = n.column - 1;
        const p = l.getLanguageId(u);
        r !== p && (r = p, s = this.languageConfigurationService.getLanguageConfiguration(r).brackets, o = this.languageConfigurationService.getLanguageConfiguration(r).bracketsNew);
      }
      let g = !0;
      for (; u >= 0; u--) {
        const p = l.getLanguageId(u);
        if (r !== p) {
          if (s && o && g && h !== f) {
            const _ = Rl.findPrevBracketInRange(s.reversedRegex, a, d, h, f);
            if (_)
              return this._toFoundBracket(o, _);
            g = !1;
          }
          r = p, s = this.languageConfigurationService.getLanguageConfiguration(r).brackets, o = this.languageConfigurationService.getLanguageConfiguration(r).bracketsNew;
        }
        const m = !!s && !Ed(l.getStandardTokenType(u));
        if (m)
          g ? h = l.getStartOffset(u) : (h = l.getStartOffset(u), f = l.getEndOffset(u));
        else if (o && s && g && h !== f) {
          const _ = Rl.findPrevBracketInRange(s.reversedRegex, a, d, h, f);
          if (_)
            return this._toFoundBracket(o, _);
        }
        g = m;
      }
      if (o && s && g && h !== f) {
        const p = Rl.findPrevBracketInRange(s.reversedRegex, a, d, h, f);
        if (p)
          return this._toFoundBracket(o, p);
      }
    }
    return null;
  }
  findNextBracket(e) {
    var t;
    const n = this.textModel.validatePosition(e);
    if (this.canBuildAST)
      return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getFirstBracketAfter(n)) || null;
    const r = this.textModel.getLineCount();
    let s = null, o = null, a = null;
    for (let l = n.lineNumber; l <= r; l++) {
      const c = this.textModel.tokenization.getLineTokens(l), d = c.getCount(), u = this.textModel.getLineContent(l);
      let h = 0, f = 0, g = 0;
      if (l === n.lineNumber) {
        h = c.findTokenIndexAtOffset(n.column - 1), f = n.column - 1, g = n.column - 1;
        const m = c.getLanguageId(h);
        s !== m && (s = m, o = this.languageConfigurationService.getLanguageConfiguration(s).brackets, a = this.languageConfigurationService.getLanguageConfiguration(s).bracketsNew);
      }
      let p = !0;
      for (; h < d; h++) {
        const m = c.getLanguageId(h);
        if (s !== m) {
          if (a && o && p && f !== g) {
            const b = Rl.findNextBracketInRange(o.forwardRegex, l, u, f, g);
            if (b)
              return this._toFoundBracket(a, b);
            p = !1;
          }
          s = m, o = this.languageConfigurationService.getLanguageConfiguration(s).brackets, a = this.languageConfigurationService.getLanguageConfiguration(s).bracketsNew;
        }
        const _ = !!o && !Ed(c.getStandardTokenType(h));
        if (_)
          p || (f = c.getStartOffset(h)), g = c.getEndOffset(h);
        else if (a && o && p && f !== g) {
          const b = Rl.findNextBracketInRange(o.forwardRegex, l, u, f, g);
          if (b)
            return this._toFoundBracket(a, b);
        }
        p = _;
      }
      if (a && o && p && f !== g) {
        const m = Rl.findNextBracketInRange(o.forwardRegex, l, u, f, g);
        if (m)
          return this._toFoundBracket(a, m);
      }
    }
    return null;
  }
  findEnclosingBrackets(e, t) {
    const n = this.textModel.validatePosition(e);
    if (this.canBuildAST) {
      const f = V.fromPositions(n), g = this.getBracketPairsInRange(V.fromPositions(n, n)).findLast((p) => p.closingBracketRange !== void 0 && p.range.strictContainsRange(f));
      return g ? [g.openingBracketRange, g.closingBracketRange] : null;
    }
    const r = F6(t), s = this.textModel.getLineCount(), o = /* @__PURE__ */ new Map();
    let a = [];
    const l = (f, g) => {
      if (!o.has(f)) {
        const p = [];
        for (let m = 0, _ = g ? g.brackets.length : 0; m < _; m++)
          p[m] = 0;
        o.set(f, p);
      }
      a = o.get(f);
    };
    let c = 0;
    const d = (f, g, p, m, _) => {
      for (; ; ) {
        if (r && ++c % 100 === 0 && !r())
          return ch.INSTANCE;
        const b = Rl.findNextBracketInRange(f.forwardRegex, g, p, m, _);
        if (!b)
          break;
        const w = p.substring(b.startColumn - 1, b.endColumn - 1).toLowerCase(), y = f.textIsBracket[w];
        if (y && (y.isOpen(w) ? a[y.index]++ : y.isClose(w) && a[y.index]--, a[y.index] === -1))
          return this._matchFoundBracket(b, y, !1, r);
        m = b.endColumn - 1;
      }
      return null;
    };
    let u = null, h = null;
    for (let f = n.lineNumber; f <= s; f++) {
      const g = this.textModel.tokenization.getLineTokens(f), p = g.getCount(), m = this.textModel.getLineContent(f);
      let _ = 0, b = 0, w = 0;
      if (f === n.lineNumber) {
        _ = g.findTokenIndexAtOffset(n.column - 1), b = n.column - 1, w = n.column - 1;
        const S = g.getLanguageId(_);
        u !== S && (u = S, h = this.languageConfigurationService.getLanguageConfiguration(u).brackets, l(u, h));
      }
      let y = !0;
      for (; _ < p; _++) {
        const S = g.getLanguageId(_);
        if (u !== S) {
          if (h && y && b !== w) {
            const D = d(h, f, m, b, w);
            if (D)
              return eD(D);
            y = !1;
          }
          u = S, h = this.languageConfigurationService.getLanguageConfiguration(u).brackets, l(u, h);
        }
        const x = !!h && !Ed(g.getStandardTokenType(_));
        if (x)
          y || (b = g.getStartOffset(_)), w = g.getEndOffset(_);
        else if (h && y && b !== w) {
          const D = d(h, f, m, b, w);
          if (D)
            return eD(D);
        }
        y = x;
      }
      if (h && y && b !== w) {
        const S = d(h, f, m, b, w);
        if (S)
          return eD(S);
      }
    }
    return null;
  }
  _toFoundBracket(e, t) {
    if (!t)
      return null;
    let n = this.textModel.getValueInRange(t);
    n = n.toLowerCase();
    const r = e.getBracketInfo(n);
    return r ? {
      range: t,
      bracketInfo: r
    } : null;
  }
}
function FBe(i, e) {
  return {
    object: i,
    dispose: () => e?.dispose()
  };
}
function F6(i) {
  if (typeof i > "u")
    return () => !0;
  {
    const e = Date.now();
    return () => Date.now() - e <= i;
  }
}
class ch {
  constructor() {
    this._searchCanceledBrand = void 0;
  }
}
ch.INSTANCE = new ch();
function eD(i) {
  return i instanceof ch ? null : i;
}
class BBe extends we {
  constructor(e) {
    super(), this.textModel = e, this.colorProvider = new bge(), this.onDidChangeEmitter = new pe(), this.onDidChange = this.onDidChangeEmitter.event, this.colorizationOptions = e.getOptions().bracketPairColorizationOptions, this._register(e.bracketPairs.onDidChange((t) => {
      this.onDidChangeEmitter.fire();
    }));
  }
  //#region TextModel events
  handleDidChangeOptions(e) {
    this.colorizationOptions = this.textModel.getOptions().bracketPairColorizationOptions;
  }
  //#endregion
  getDecorationsInRange(e, t, n, r) {
    return r ? [] : t === void 0 ? [] : this.colorizationOptions.enabled ? this.textModel.bracketPairs.getBracketsInRange(e, !0).map((o) => ({
      id: `bracket${o.range.toString()}-${o.nestingLevel}`,
      options: {
        description: "BracketPairColorization",
        inlineClassName: this.colorProvider.getInlineClassName(o, this.colorizationOptions.independentColorPoolPerBracketType)
      },
      ownerId: 0,
      range: o.range
    })).toArray() : [];
  }
  getAllDecorations(e, t) {
    return e === void 0 ? [] : this.colorizationOptions.enabled ? this.getDecorationsInRange(new V(1, 1, this.textModel.getLineCount(), 1), e, t) : [];
  }
}
class bge {
  constructor() {
    this.unexpectedClosingBracketClassName = "unexpected-closing-bracket";
  }
  getInlineClassName(e, t) {
    return e.isInvalid ? this.unexpectedClosingBracketClassName : this.getInlineClassNameOfLevel(t ? e.nestingLevelOfEqualBracketType : e.nestingLevel);
  }
  getInlineClassNameOfLevel(e) {
    return `bracket-highlighting-${e % 30}`;
  }
}
fc((i, e) => {
  const t = [
    Yfe,
    Xfe,
    Zfe,
    Qfe,
    Jfe,
    $fe
  ], n = new bge();
  e.addRule(`.monaco-editor .${n.unexpectedClosingBracketClassName} { color: ${i.getColor(HRe)}; }`);
  const r = t.map((s) => i.getColor(s)).filter((s) => !!s).filter((s) => !s.isTransparent());
  for (let s = 0; s < 30; s++) {
    const o = r[s % r.length];
    e.addRule(`.monaco-editor .${n.getInlineClassNameOfLevel(s)} { color: ${o}; }`);
  }
});
function tD(i) {
  return i.replace(/\n/g, "\\n").replace(/\r/g, "\\r");
}
class _s {
  get oldLength() {
    return this.oldText.length;
  }
  get oldEnd() {
    return this.oldPosition + this.oldText.length;
  }
  get newLength() {
    return this.newText.length;
  }
  get newEnd() {
    return this.newPosition + this.newText.length;
  }
  constructor(e, t, n, r) {
    this.oldPosition = e, this.oldText = t, this.newPosition = n, this.newText = r;
  }
  toString() {
    return this.oldText.length === 0 ? `(insert@${this.oldPosition} "${tD(this.newText)}")` : this.newText.length === 0 ? `(delete@${this.oldPosition} "${tD(this.oldText)}")` : `(replace@${this.oldPosition} "${tD(this.oldText)}" with "${tD(this.newText)}")`;
  }
  static _writeStringSize(e) {
    return 4 + 2 * e.length;
  }
  static _writeString(e, t, n) {
    const r = t.length;
    Ac(e, r, n), n += 4;
    for (let s = 0; s < r; s++)
      D7e(e, t.charCodeAt(s), n), n += 2;
    return n;
  }
  static _readString(e, t) {
    const n = Ic(e, t);
    return t += 4, L7e(e, t, n);
  }
  writeSize() {
    return 8 + _s._writeStringSize(this.oldText) + _s._writeStringSize(this.newText);
  }
  write(e, t) {
    return Ac(e, this.oldPosition, t), t += 4, Ac(e, this.newPosition, t), t += 4, t = _s._writeString(e, this.oldText, t), t = _s._writeString(e, this.newText, t), t;
  }
  static read(e, t, n) {
    const r = Ic(e, t);
    t += 4;
    const s = Ic(e, t);
    t += 4;
    const o = _s._readString(e, t);
    t += _s._writeStringSize(o);
    const a = _s._readString(e, t);
    return t += _s._writeStringSize(a), n.push(new _s(r, o, s, a)), t;
  }
}
function VBe(i, e) {
  return i === null || i.length === 0 ? e : new Ad(i, e).compress();
}
class Ad {
  constructor(e, t) {
    this._prevEdits = e, this._currEdits = t, this._result = [], this._resultLen = 0, this._prevLen = this._prevEdits.length, this._prevDeltaOffset = 0, this._currLen = this._currEdits.length, this._currDeltaOffset = 0;
  }
  compress() {
    let e = 0, t = 0, n = this._getPrev(e), r = this._getCurr(t);
    for (; e < this._prevLen || t < this._currLen; ) {
      if (n === null) {
        this._acceptCurr(r), r = this._getCurr(++t);
        continue;
      }
      if (r === null) {
        this._acceptPrev(n), n = this._getPrev(++e);
        continue;
      }
      if (r.oldEnd <= n.newPosition) {
        this._acceptCurr(r), r = this._getCurr(++t);
        continue;
      }
      if (n.newEnd <= r.oldPosition) {
        this._acceptPrev(n), n = this._getPrev(++e);
        continue;
      }
      if (r.oldPosition < n.newPosition) {
        const [c, d] = Ad._splitCurr(r, n.newPosition - r.oldPosition);
        this._acceptCurr(c), r = d;
        continue;
      }
      if (n.newPosition < r.oldPosition) {
        const [c, d] = Ad._splitPrev(n, r.oldPosition - n.newPosition);
        this._acceptPrev(c), n = d;
        continue;
      }
      let a, l;
      if (r.oldEnd === n.newEnd)
        a = n, l = r, n = this._getPrev(++e), r = this._getCurr(++t);
      else if (r.oldEnd < n.newEnd) {
        const [c, d] = Ad._splitPrev(n, r.oldLength);
        a = c, l = r, n = d, r = this._getCurr(++t);
      } else {
        const [c, d] = Ad._splitCurr(r, n.newLength);
        a = n, l = c, n = this._getPrev(++e), r = d;
      }
      this._result[this._resultLen++] = new _s(a.oldPosition, a.oldText, l.newPosition, l.newText), this._prevDeltaOffset += a.newLength - a.oldLength, this._currDeltaOffset += l.newLength - l.oldLength;
    }
    const s = Ad._merge(this._result);
    return Ad._removeNoOps(s);
  }
  _acceptCurr(e) {
    this._result[this._resultLen++] = Ad._rebaseCurr(this._prevDeltaOffset, e), this._currDeltaOffset += e.newLength - e.oldLength;
  }
  _getCurr(e) {
    return e < this._currLen ? this._currEdits[e] : null;
  }
  _acceptPrev(e) {
    this._result[this._resultLen++] = Ad._rebasePrev(this._currDeltaOffset, e), this._prevDeltaOffset += e.newLength - e.oldLength;
  }
  _getPrev(e) {
    return e < this._prevLen ? this._prevEdits[e] : null;
  }
  static _rebaseCurr(e, t) {
    return new _s(t.oldPosition - e, t.oldText, t.newPosition, t.newText);
  }
  static _rebasePrev(e, t) {
    return new _s(t.oldPosition, t.oldText, t.newPosition + e, t.newText);
  }
  static _splitPrev(e, t) {
    const n = e.newText.substr(0, t), r = e.newText.substr(t);
    return [
      new _s(e.oldPosition, e.oldText, e.newPosition, n),
      new _s(e.oldEnd, "", e.newPosition + t, r)
    ];
  }
  static _splitCurr(e, t) {
    const n = e.oldText.substr(0, t), r = e.oldText.substr(t);
    return [
      new _s(e.oldPosition, n, e.newPosition, e.newText),
      new _s(e.oldPosition + t, r, e.newEnd, "")
    ];
  }
  static _merge(e) {
    if (e.length === 0)
      return e;
    const t = [];
    let n = 0, r = e[0];
    for (let s = 1; s < e.length; s++) {
      const o = e[s];
      r.oldEnd === o.oldPosition ? r = new _s(r.oldPosition, r.oldText + o.oldText, r.newPosition, r.newText + o.newText) : (t[n++] = r, r = o);
    }
    return t[n++] = r, t;
  }
  static _removeNoOps(e) {
    if (e.length === 0)
      return e;
    const t = [];
    let n = 0;
    for (let r = 0; r < e.length; r++) {
      const s = e[r];
      s.oldText !== s.newText && (t[n++] = s);
    }
    return t;
  }
}
function Cf(i) {
  return i === 47 || i === 92;
}
function Cge(i) {
  return i.replace(/[\\/]/g, yr.sep);
}
function HBe(i) {
  return i.indexOf("/") === -1 && (i = Cge(i)), /^[a-zA-Z]:(\/|$)/.test(i) && (i = "/" + i), i;
}
function GZ(i, e = yr.sep) {
  if (!i)
    return "";
  const t = i.length, n = i.charCodeAt(0);
  if (Cf(n)) {
    if (Cf(i.charCodeAt(1)) && !Cf(i.charCodeAt(2))) {
      let s = 3;
      const o = s;
      for (; s < t && !Cf(i.charCodeAt(s)); s++)
        ;
      if (o !== s && !Cf(i.charCodeAt(s + 1))) {
        for (s += 1; s < t; s++)
          if (Cf(i.charCodeAt(s)))
            return i.slice(0, s + 1).replace(/[\\/]/g, e);
      }
    }
    return e;
  } else if (yge(n) && i.charCodeAt(1) === 58)
    return Cf(i.charCodeAt(2)) ? i.slice(0, 2) + e : i.slice(0, 2);
  let r = i.indexOf("://");
  if (r !== -1) {
    for (r += 3; r < t; r++)
      if (Cf(i.charCodeAt(r)))
        return i.slice(0, r + 1);
  }
  return "";
}
function WF(i, e, t, n = Qc) {
  if (i === e)
    return !0;
  if (!i || !e || e.length > i.length)
    return !1;
  if (t) {
    if (!Bj(i, e))
      return !1;
    if (e.length === i.length)
      return !0;
    let s = e.length;
    return e.charAt(e.length - 1) === n && s--, i.charAt(s) === n;
  }
  return e.charAt(e.length - 1) !== n && (e += n), i.indexOf(e) === 0;
}
function yge(i) {
  return i >= 65 && i <= 90 || i >= 97 && i <= 122;
}
function WBe(i, e = Ls) {
  return e ? yge(i.charCodeAt(0)) && i.charCodeAt(1) === 58 : !1;
}
function Ld(i) {
  return UE(i, !0);
}
class jBe {
  constructor(e) {
    this._ignorePathCasing = e;
  }
  compare(e, t, n = !1) {
    return e === t ? 0 : Dy(this.getComparisonKey(e, n), this.getComparisonKey(t, n));
  }
  isEqual(e, t, n = !1) {
    return e === t ? !0 : !e || !t ? !1 : this.getComparisonKey(e, n) === this.getComparisonKey(t, n);
  }
  getComparisonKey(e, t = !1) {
    return e.with({
      path: this._ignorePathCasing(e) ? e.path.toLowerCase() : void 0,
      fragment: t ? null : void 0
    }).toString();
  }
  isEqualOrParent(e, t, n = !1) {
    if (e.scheme === t.scheme) {
      if (e.scheme === Mt.file)
        return WF(Ld(e), Ld(t), this._ignorePathCasing(e)) && e.query === t.query && (n || e.fragment === t.fragment);
      if (KZ(e.authority, t.authority))
        return WF(e.path, t.path, this._ignorePathCasing(e), "/") && e.query === t.query && (n || e.fragment === t.fragment);
    }
    return !1;
  }
  // --- path math
  joinPath(e, ...t) {
    return pt.joinPath(e, ...t);
  }
  basenameOrAuthority(e) {
    return xl(e) || e.authority;
  }
  basename(e) {
    return yr.basename(e.path);
  }
  extname(e) {
    return yr.extname(e.path);
  }
  dirname(e) {
    if (e.path.length === 0)
      return e;
    let t;
    return e.scheme === Mt.file ? t = pt.file(ihe(Ld(e))).path : (t = yr.dirname(e.path), e.authority && t.length && t.charCodeAt(0) !== 47 && (console.error(`dirname("${e.toString})) resulted in a relative path`), t = "/")), e.with({
      path: t
    });
  }
  normalizePath(e) {
    if (!e.path.length)
      return e;
    let t;
    return e.scheme === Mt.file ? t = pt.file(nhe(Ld(e))).path : t = yr.normalize(e.path), e.with({
      path: t
    });
  }
  relativePath(e, t) {
    if (e.scheme !== t.scheme || !KZ(e.authority, t.authority))
      return;
    if (e.scheme === Mt.file) {
      const s = ZTe(Ld(e), Ld(t));
      return Ls ? Cge(s) : s;
    }
    let n = e.path || "/";
    const r = t.path || "/";
    if (this._ignorePathCasing(e)) {
      let s = 0;
      for (const o = Math.min(n.length, r.length); s < o && !(n.charCodeAt(s) !== r.charCodeAt(s) && n.charAt(s).toLowerCase() !== r.charAt(s).toLowerCase()); s++)
        ;
      n = r.substr(0, s) + n.substr(s);
    }
    return yr.relative(n, r);
  }
  resolvePath(e, t) {
    if (e.scheme === Mt.file) {
      const n = pt.file(XTe(Ld(e), t));
      return e.with({
        authority: n.authority,
        path: n.path
      });
    }
    return t = HBe(t), e.with({
      path: yr.resolve(e.path, t)
    });
  }
  // --- misc
  isAbsolutePath(e) {
    return !!e.path && e.path[0] === "/";
  }
  isEqualAuthority(e, t) {
    return e === t || e !== void 0 && t !== void 0 && K1(e, t);
  }
  hasTrailingPathSeparator(e, t = Qc) {
    if (e.scheme === Mt.file) {
      const n = Ld(e);
      return n.length > GZ(n).length && n[n.length - 1] === t;
    } else {
      const n = e.path;
      return n.length > 1 && n.charCodeAt(n.length - 1) === 47 && !/^[a-zA-Z]:(\/$|\\$)/.test(e.fsPath);
    }
  }
  removeTrailingPathSeparator(e, t = Qc) {
    return YZ(e, t) ? e.with({ path: e.path.substr(0, e.path.length - 1) }) : e;
  }
  addTrailingPathSeparator(e, t = Qc) {
    let n = !1;
    if (e.scheme === Mt.file) {
      const r = Ld(e);
      n = r !== void 0 && r.length === GZ(r).length && r[r.length - 1] === t;
    } else {
      t = "/";
      const r = e.path;
      n = r.length === 1 && r.charCodeAt(r.length - 1) === 47;
    }
    return !n && !YZ(e, t) ? e.with({ path: e.path + "/" }) : e;
  }
}
const ri = new jBe(() => !1), Tz = ri.isEqual.bind(ri);
ri.isEqualOrParent.bind(ri);
ri.getComparisonKey.bind(ri);
const zBe = ri.basenameOrAuthority.bind(ri), xl = ri.basename.bind(ri), UBe = ri.extname.bind(ri), D4 = ri.dirname.bind(ri), GBe = ri.joinPath.bind(ri), qBe = ri.normalizePath.bind(ri), KBe = ri.relativePath.bind(ri), qZ = ri.resolvePath.bind(ri);
ri.isAbsolutePath.bind(ri);
const KZ = ri.isEqualAuthority.bind(ri), YZ = ri.hasTrailingPathSeparator.bind(ri);
ri.removeTrailingPathSeparator.bind(ri);
ri.addTrailingPathSeparator.bind(ri);
var jg;
(function(i) {
  i.META_DATA_LABEL = "label", i.META_DATA_DESCRIPTION = "description", i.META_DATA_SIZE = "size", i.META_DATA_MIME = "mime";
  function e(t) {
    const n = /* @__PURE__ */ new Map();
    t.path.substring(t.path.indexOf(";") + 1, t.path.lastIndexOf(";")).split(";").forEach((o) => {
      const [a, l] = o.split(":");
      a && l && n.set(a, l);
    });
    const s = t.path.substring(0, t.path.indexOf(";"));
    return s && n.set(i.META_DATA_MIME, s), n;
  }
  i.parseMetaData = e;
})(jg || (jg = {}));
function g1(i) {
  return i.toString();
}
class Fr {
  static create(e, t) {
    const n = e.getAlternativeVersionId(), r = jF(e);
    return new Fr(n, n, r, r, t, t, []);
  }
  constructor(e, t, n, r, s, o, a) {
    this.beforeVersionId = e, this.afterVersionId = t, this.beforeEOL = n, this.afterEOL = r, this.beforeCursorState = s, this.afterCursorState = o, this.changes = a;
  }
  append(e, t, n, r, s) {
    t.length > 0 && (this.changes = VBe(this.changes, t)), this.afterEOL = n, this.afterVersionId = r, this.afterCursorState = s;
  }
  static _writeSelectionsSize(e) {
    return 4 + 4 * 4 * (e ? e.length : 0);
  }
  static _writeSelections(e, t, n) {
    if (Ac(e, t ? t.length : 0, n), n += 4, t)
      for (const r of t)
        Ac(e, r.selectionStartLineNumber, n), n += 4, Ac(e, r.selectionStartColumn, n), n += 4, Ac(e, r.positionLineNumber, n), n += 4, Ac(e, r.positionColumn, n), n += 4;
    return n;
  }
  static _readSelections(e, t, n) {
    const r = Ic(e, t);
    t += 4;
    for (let s = 0; s < r; s++) {
      const o = Ic(e, t);
      t += 4;
      const a = Ic(e, t);
      t += 4;
      const l = Ic(e, t);
      t += 4;
      const c = Ic(e, t);
      t += 4, n.push(new ot(o, a, l, c));
    }
    return t;
  }
  serialize() {
    let e = 10 + Fr._writeSelectionsSize(this.beforeCursorState) + Fr._writeSelectionsSize(this.afterCursorState) + 4;
    for (const r of this.changes)
      e += r.writeSize();
    const t = new Uint8Array(e);
    let n = 0;
    Ac(t, this.beforeVersionId, n), n += 4, Ac(t, this.afterVersionId, n), n += 4, DX(t, this.beforeEOL, n), n += 1, DX(t, this.afterEOL, n), n += 1, n = Fr._writeSelections(t, this.beforeCursorState, n), n = Fr._writeSelections(t, this.afterCursorState, n), Ac(t, this.changes.length, n), n += 4;
    for (const r of this.changes)
      n = r.write(t, n);
    return t.buffer;
  }
  static deserialize(e) {
    const t = new Uint8Array(e);
    let n = 0;
    const r = Ic(t, n);
    n += 4;
    const s = Ic(t, n);
    n += 4;
    const o = xX(t, n);
    n += 1;
    const a = xX(t, n);
    n += 1;
    const l = [];
    n = Fr._readSelections(t, n, l);
    const c = [];
    n = Fr._readSelections(t, n, c);
    const d = Ic(t, n);
    n += 4;
    const u = [];
    for (let h = 0; h < d; h++)
      n = _s.read(t, n, u);
    return new Fr(r, s, o, a, l, c, u);
  }
}
class wge {
  get type() {
    return 0;
  }
  get resource() {
    return pt.isUri(this.model) ? this.model : this.model.uri;
  }
  constructor(e, t, n, r) {
    this.label = e, this.code = t, this.model = n, this._data = Fr.create(n, r);
  }
  toString() {
    return (this._data instanceof Fr ? this._data : Fr.deserialize(this._data)).changes.map((t) => t.toString()).join(", ");
  }
  matchesResource(e) {
    return (pt.isUri(this.model) ? this.model : this.model.uri).toString() === e.toString();
  }
  setModel(e) {
    this.model = e;
  }
  canAppend(e) {
    return this.model === e && this._data instanceof Fr;
  }
  append(e, t, n, r, s) {
    this._data instanceof Fr && this._data.append(e, t, n, r, s);
  }
  close() {
    this._data instanceof Fr && (this._data = this._data.serialize());
  }
  open() {
    this._data instanceof Fr || (this._data = Fr.deserialize(this._data));
  }
  undo() {
    if (pt.isUri(this.model))
      throw new Error("Invalid SingleModelEditStackElement");
    this._data instanceof Fr && (this._data = this._data.serialize());
    const e = Fr.deserialize(this._data);
    this.model._applyUndo(e.changes, e.beforeEOL, e.beforeVersionId, e.beforeCursorState);
  }
  redo() {
    if (pt.isUri(this.model))
      throw new Error("Invalid SingleModelEditStackElement");
    this._data instanceof Fr && (this._data = this._data.serialize());
    const e = Fr.deserialize(this._data);
    this.model._applyRedo(e.changes, e.afterEOL, e.afterVersionId, e.afterCursorState);
  }
  heapSize() {
    return this._data instanceof Fr && (this._data = this._data.serialize()), this._data.byteLength + 168;
  }
}
class YBe {
  get resources() {
    return this._editStackElementsArr.map((e) => e.resource);
  }
  constructor(e, t, n) {
    this.label = e, this.code = t, this.type = 1, this._isOpen = !0, this._editStackElementsArr = n.slice(0), this._editStackElementsMap = /* @__PURE__ */ new Map();
    for (const r of this._editStackElementsArr) {
      const s = g1(r.resource);
      this._editStackElementsMap.set(s, r);
    }
    this._delegate = null;
  }
  prepareUndoRedo() {
    if (this._delegate)
      return this._delegate.prepareUndoRedo(this);
  }
  matchesResource(e) {
    const t = g1(e);
    return this._editStackElementsMap.has(t);
  }
  setModel(e) {
    const t = g1(pt.isUri(e) ? e : e.uri);
    this._editStackElementsMap.has(t) && this._editStackElementsMap.get(t).setModel(e);
  }
  canAppend(e) {
    if (!this._isOpen)
      return !1;
    const t = g1(e.uri);
    return this._editStackElementsMap.has(t) ? this._editStackElementsMap.get(t).canAppend(e) : !1;
  }
  append(e, t, n, r, s) {
    const o = g1(e.uri);
    this._editStackElementsMap.get(o).append(e, t, n, r, s);
  }
  close() {
    this._isOpen = !1;
  }
  open() {
  }
  undo() {
    this._isOpen = !1;
    for (const e of this._editStackElementsArr)
      e.undo();
  }
  redo() {
    for (const e of this._editStackElementsArr)
      e.redo();
  }
  heapSize(e) {
    const t = g1(e);
    return this._editStackElementsMap.has(t) ? this._editStackElementsMap.get(t).heapSize() : 0;
  }
  split() {
    return this._editStackElementsArr;
  }
  toString() {
    const e = [];
    for (const t of this._editStackElementsArr)
      e.push(`${xl(t.resource)}: ${t}`);
    return `{${e.join(", ")}}`;
  }
}
function jF(i) {
  return i.getEOL() === `
` ? 0 : 1;
}
function dh(i) {
  return i ? i instanceof wge || i instanceof YBe : !1;
}
class Nz {
  constructor(e, t) {
    this._model = e, this._undoRedoService = t;
  }
  pushStackElement() {
    const e = this._undoRedoService.getLastElement(this._model.uri);
    dh(e) && e.close();
  }
  popStackElement() {
    const e = this._undoRedoService.getLastElement(this._model.uri);
    dh(e) && e.open();
  }
  clear() {
    this._undoRedoService.removeElements(this._model.uri);
  }
  _getOrCreateEditStackElement(e, t) {
    const n = this._undoRedoService.getLastElement(this._model.uri);
    if (dh(n) && n.canAppend(this._model))
      return n;
    const r = new wge(C("edit", "Typing"), "undoredo.textBufferEdit", this._model, e);
    return this._undoRedoService.pushElement(r, t), r;
  }
  pushEOL(e) {
    const t = this._getOrCreateEditStackElement(null, void 0);
    this._model.setEOL(e), t.append(this._model, [], jF(this._model), this._model.getAlternativeVersionId(), null);
  }
  pushEditOperation(e, t, n, r) {
    const s = this._getOrCreateEditStackElement(e, r), o = this._model.applyEdits(t, !0), a = Nz._computeCursorState(n, o), l = o.map((c, d) => ({ index: d, textChange: c.textChange }));
    return l.sort((c, d) => c.textChange.oldPosition === d.textChange.oldPosition ? c.index - d.index : c.textChange.oldPosition - d.textChange.oldPosition), s.append(this._model, l.map((c) => c.textChange), jF(this._model), this._model.getAlternativeVersionId(), a), a;
  }
  static _computeCursorState(e, t) {
    try {
      return e ? e(t) : null;
    } catch (n) {
      return It(n), null;
    }
  }
}
class XBe {
  constructor() {
    this.spacesDiff = 0, this.looksLikeAlignment = !1;
  }
}
function ZBe(i, e, t, n, r) {
  r.spacesDiff = 0, r.looksLikeAlignment = !1;
  let s;
  for (s = 0; s < e && s < n; s++) {
    const h = i.charCodeAt(s), f = t.charCodeAt(s);
    if (h !== f)
      break;
  }
  let o = 0, a = 0;
  for (let h = s; h < e; h++)
    i.charCodeAt(h) === 32 ? o++ : a++;
  let l = 0, c = 0;
  for (let h = s; h < n; h++)
    t.charCodeAt(h) === 32 ? l++ : c++;
  if (o > 0 && a > 0 || l > 0 && c > 0)
    return;
  const d = Math.abs(a - c), u = Math.abs(o - l);
  if (d === 0) {
    r.spacesDiff = u, u > 0 && 0 <= l - 1 && l - 1 < i.length && l < t.length && t.charCodeAt(l) !== 32 && i.charCodeAt(l - 1) === 32 && i.charCodeAt(i.length - 1) === 44 && (r.looksLikeAlignment = !0);
    return;
  }
  if (u % d === 0) {
    r.spacesDiff = u / d;
    return;
  }
}
function XZ(i, e, t) {
  const n = Math.min(i.getLineCount(), 1e4);
  let r = 0, s = 0, o = "", a = 0;
  const l = [2, 4, 6, 8, 3, 5, 7], c = 8, d = [0, 0, 0, 0, 0, 0, 0, 0, 0], u = new XBe();
  for (let g = 1; g <= n; g++) {
    const p = i.getLineLength(g), m = i.getLineContent(g), _ = p <= 65536;
    let b = !1, w = 0, y = 0, S = 0;
    for (let D = 0, E = p; D < E; D++) {
      const L = _ ? m.charCodeAt(D) : i.getLineCharCode(g, D);
      if (L === 9)
        S++;
      else if (L === 32)
        y++;
      else {
        b = !0, w = D;
        break;
      }
    }
    if (!b || (S > 0 ? r++ : y > 1 && s++, ZBe(o, a, m, w, u), u.looksLikeAlignment && !(t && e === u.spacesDiff)))
      continue;
    const x = u.spacesDiff;
    x <= c && d[x]++, o = m, a = w;
  }
  let h = t;
  r !== s && (h = r < s);
  let f = e;
  if (h) {
    let g = h ? 0 : 0.1 * n;
    l.forEach((p) => {
      const m = d[p];
      m > g && (g = m, f = p);
    }), f === 4 && d[4] > 0 && d[2] > 0 && d[2] >= d[4] / 2 && (f = 2);
  }
  return {
    insertSpaces: h,
    tabSize: f
  };
}
function Eo(i) {
  return (i.metadata & 1) >>> 0;
}
function ti(i, e) {
  i.metadata = i.metadata & 254 | e << 0;
}
function Es(i) {
  return (i.metadata & 2) >>> 1 === 1;
}
function Kn(i, e) {
  i.metadata = i.metadata & 253 | (e ? 1 : 0) << 1;
}
function Sge(i) {
  return (i.metadata & 4) >>> 2 === 1;
}
function ZZ(i, e) {
  i.metadata = i.metadata & 251 | (e ? 1 : 0) << 2;
}
function xge(i) {
  return (i.metadata & 64) >>> 6 === 1;
}
function QZ(i, e) {
  i.metadata = i.metadata & 191 | (e ? 1 : 0) << 6;
}
function QBe(i) {
  return (i.metadata & 24) >>> 3;
}
function JZ(i, e) {
  i.metadata = i.metadata & 231 | e << 3;
}
function JBe(i) {
  return (i.metadata & 32) >>> 5 === 1;
}
function $Z(i, e) {
  i.metadata = i.metadata & 223 | (e ? 1 : 0) << 5;
}
class Dge {
  constructor(e, t, n) {
    this.metadata = 0, this.parent = this, this.left = this, this.right = this, ti(
      this,
      1
      /* NodeColor.Red */
    ), this.start = t, this.end = n, this.delta = 0, this.maxEnd = n, this.id = e, this.ownerId = 0, this.options = null, ZZ(this, !1), QZ(this, !1), JZ(
      this,
      1
      /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
    ), $Z(this, !1), this.cachedVersionId = 0, this.cachedAbsoluteStart = t, this.cachedAbsoluteEnd = n, this.range = null, Kn(this, !1);
  }
  reset(e, t, n, r) {
    this.start = t, this.end = n, this.maxEnd = n, this.cachedVersionId = e, this.cachedAbsoluteStart = t, this.cachedAbsoluteEnd = n, this.range = r;
  }
  setOptions(e) {
    this.options = e;
    const t = this.options.className;
    ZZ(this, t === "squiggly-error" || t === "squiggly-warning" || t === "squiggly-info"), QZ(this, this.options.glyphMarginClassName !== null), JZ(this, this.options.stickiness), $Z(this, this.options.collapseOnReplaceEdit);
  }
  setCachedOffsets(e, t, n) {
    this.cachedVersionId !== n && (this.range = null), this.cachedVersionId = n, this.cachedAbsoluteStart = e, this.cachedAbsoluteEnd = t;
  }
  detach() {
    this.parent = null, this.left = null, this.right = null;
  }
}
const Bt = new Dge(null, 0, 0);
Bt.parent = Bt;
Bt.left = Bt;
Bt.right = Bt;
ti(
  Bt,
  0
  /* NodeColor.Black */
);
class B6 {
  constructor() {
    this.root = Bt, this.requestNormalizeDelta = !1;
  }
  intervalSearch(e, t, n, r, s, o) {
    return this.root === Bt ? [] : oVe(this, e, t, n, r, s, o);
  }
  search(e, t, n, r) {
    return this.root === Bt ? [] : sVe(this, e, t, n, r);
  }
  /**
   * Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
   */
  collectNodesFromOwner(e) {
    return iVe(this, e);
  }
  /**
   * Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
   */
  collectNodesPostOrder() {
    return rVe(this);
  }
  insert(e) {
    eQ(this, e), this._normalizeDeltaIfNecessary();
  }
  delete(e) {
    tQ(this, e), this._normalizeDeltaIfNecessary();
  }
  resolveNode(e, t) {
    const n = e;
    let r = 0;
    for (; e !== this.root; )
      e === e.parent.right && (r += e.parent.delta), e = e.parent;
    const s = n.start + r, o = n.end + r;
    n.setCachedOffsets(s, o, t);
  }
  acceptReplace(e, t, n, r) {
    const s = tVe(this, e, e + t);
    for (let o = 0, a = s.length; o < a; o++) {
      const l = s[o];
      tQ(this, l);
    }
    this._normalizeDeltaIfNecessary(), nVe(this, e, e + t, n), this._normalizeDeltaIfNecessary();
    for (let o = 0, a = s.length; o < a; o++) {
      const l = s[o];
      l.start = l.cachedAbsoluteStart, l.end = l.cachedAbsoluteEnd, eVe(l, e, e + t, n, r), l.maxEnd = l.end, eQ(this, l);
    }
    this._normalizeDeltaIfNecessary();
  }
  _normalizeDeltaIfNecessary() {
    this.requestNormalizeDelta && (this.requestNormalizeDelta = !1, $Be(this));
  }
}
function $Be(i) {
  let e = i.root, t = 0;
  for (; e !== Bt; ) {
    if (e.left !== Bt && !Es(e.left)) {
      e = e.left;
      continue;
    }
    if (e.right !== Bt && !Es(e.right)) {
      t += e.delta, e = e.right;
      continue;
    }
    e.start = t + e.start, e.end = t + e.end, e.delta = 0, zg(e), Kn(e, !0), Kn(e.left, !1), Kn(e.right, !1), e === e.parent.right && (t -= e.parent.delta), e = e.parent;
  }
  Kn(i.root, !1);
}
function p1(i, e, t, n) {
  return i < t ? !0 : i > t || n === 1 ? !1 : n === 2 ? !0 : e;
}
function eVe(i, e, t, n, r) {
  const s = QBe(i), o = s === 0 || s === 2, a = s === 1 || s === 2, l = t - e, c = n, d = Math.min(l, c), u = i.start;
  let h = !1;
  const f = i.end;
  let g = !1;
  e <= u && f <= t && JBe(i) && (i.start = e, h = !0, i.end = e, g = !0);
  {
    const m = r ? 1 : l > 0 ? 2 : 0;
    !h && p1(u, o, e, m) && (h = !0), !g && p1(f, a, e, m) && (g = !0);
  }
  if (d > 0 && !r) {
    const m = l > c ? 2 : 0;
    !h && p1(u, o, e + d, m) && (h = !0), !g && p1(f, a, e + d, m) && (g = !0);
  }
  {
    const m = r ? 1 : 0;
    !h && p1(u, o, t, m) && (i.start = e + c, h = !0), !g && p1(f, a, t, m) && (i.end = e + c, g = !0);
  }
  const p = c - l;
  h || (i.start = Math.max(0, u + p)), g || (i.end = Math.max(0, f + p)), i.start > i.end && (i.end = i.start);
}
function tVe(i, e, t) {
  let n = i.root, r = 0, s = 0, o = 0, a = 0;
  const l = [];
  let c = 0;
  for (; n !== Bt; ) {
    if (Es(n)) {
      Kn(n.left, !1), Kn(n.right, !1), n === n.parent.right && (r -= n.parent.delta), n = n.parent;
      continue;
    }
    if (!Es(n.left)) {
      if (s = r + n.maxEnd, s < e) {
        Kn(n, !0);
        continue;
      }
      if (n.left !== Bt) {
        n = n.left;
        continue;
      }
    }
    if (o = r + n.start, o > t) {
      Kn(n, !0);
      continue;
    }
    if (a = r + n.end, a >= e && (n.setCachedOffsets(o, a, 0), l[c++] = n), Kn(n, !0), n.right !== Bt && !Es(n.right)) {
      r += n.delta, n = n.right;
      continue;
    }
  }
  return Kn(i.root, !1), l;
}
function nVe(i, e, t, n) {
  let r = i.root, s = 0, o = 0, a = 0;
  const l = n - (t - e);
  for (; r !== Bt; ) {
    if (Es(r)) {
      Kn(r.left, !1), Kn(r.right, !1), r === r.parent.right && (s -= r.parent.delta), zg(r), r = r.parent;
      continue;
    }
    if (!Es(r.left)) {
      if (o = s + r.maxEnd, o < e) {
        Kn(r, !0);
        continue;
      }
      if (r.left !== Bt) {
        r = r.left;
        continue;
      }
    }
    if (a = s + r.start, a > t) {
      r.start += l, r.end += l, r.delta += l, (r.delta < -1073741824 || r.delta > 1073741824) && (i.requestNormalizeDelta = !0), Kn(r, !0);
      continue;
    }
    if (Kn(r, !0), r.right !== Bt && !Es(r.right)) {
      s += r.delta, r = r.right;
      continue;
    }
  }
  Kn(i.root, !1);
}
function iVe(i, e) {
  let t = i.root;
  const n = [];
  let r = 0;
  for (; t !== Bt; ) {
    if (Es(t)) {
      Kn(t.left, !1), Kn(t.right, !1), t = t.parent;
      continue;
    }
    if (t.left !== Bt && !Es(t.left)) {
      t = t.left;
      continue;
    }
    if (t.ownerId === e && (n[r++] = t), Kn(t, !0), t.right !== Bt && !Es(t.right)) {
      t = t.right;
      continue;
    }
  }
  return Kn(i.root, !1), n;
}
function rVe(i) {
  let e = i.root;
  const t = [];
  let n = 0;
  for (; e !== Bt; ) {
    if (Es(e)) {
      Kn(e.left, !1), Kn(e.right, !1), e = e.parent;
      continue;
    }
    if (e.left !== Bt && !Es(e.left)) {
      e = e.left;
      continue;
    }
    if (e.right !== Bt && !Es(e.right)) {
      e = e.right;
      continue;
    }
    t[n++] = e, Kn(e, !0);
  }
  return Kn(i.root, !1), t;
}
function sVe(i, e, t, n, r) {
  let s = i.root, o = 0, a = 0, l = 0;
  const c = [];
  let d = 0;
  for (; s !== Bt; ) {
    if (Es(s)) {
      Kn(s.left, !1), Kn(s.right, !1), s === s.parent.right && (o -= s.parent.delta), s = s.parent;
      continue;
    }
    if (s.left !== Bt && !Es(s.left)) {
      s = s.left;
      continue;
    }
    a = o + s.start, l = o + s.end, s.setCachedOffsets(a, l, n);
    let u = !0;
    if (e && s.ownerId && s.ownerId !== e && (u = !1), t && Sge(s) && (u = !1), r && !xge(s) && (u = !1), u && (c[d++] = s), Kn(s, !0), s.right !== Bt && !Es(s.right)) {
      o += s.delta, s = s.right;
      continue;
    }
  }
  return Kn(i.root, !1), c;
}
function oVe(i, e, t, n, r, s, o) {
  let a = i.root, l = 0, c = 0, d = 0, u = 0;
  const h = [];
  let f = 0;
  for (; a !== Bt; ) {
    if (Es(a)) {
      Kn(a.left, !1), Kn(a.right, !1), a === a.parent.right && (l -= a.parent.delta), a = a.parent;
      continue;
    }
    if (!Es(a.left)) {
      if (c = l + a.maxEnd, c < e) {
        Kn(a, !0);
        continue;
      }
      if (a.left !== Bt) {
        a = a.left;
        continue;
      }
    }
    if (d = l + a.start, d > t) {
      Kn(a, !0);
      continue;
    }
    if (u = l + a.end, u >= e) {
      a.setCachedOffsets(d, u, s);
      let g = !0;
      n && a.ownerId && a.ownerId !== n && (g = !1), r && Sge(a) && (g = !1), o && !xge(a) && (g = !1), g && (h[f++] = a);
    }
    if (Kn(a, !0), a.right !== Bt && !Es(a.right)) {
      l += a.delta, a = a.right;
      continue;
    }
  }
  return Kn(i.root, !1), h;
}
function eQ(i, e) {
  if (i.root === Bt)
    return e.parent = Bt, e.left = Bt, e.right = Bt, ti(
      e,
      0
      /* NodeColor.Black */
    ), i.root = e, i.root;
  aVe(i, e), Tf(e.parent);
  let t = e;
  for (; t !== i.root && Eo(t.parent) === 1; )
    if (t.parent === t.parent.parent.left) {
      const n = t.parent.parent.right;
      Eo(n) === 1 ? (ti(
        t.parent,
        0
        /* NodeColor.Black */
      ), ti(
        n,
        0
        /* NodeColor.Black */
      ), ti(
        t.parent.parent,
        1
        /* NodeColor.Red */
      ), t = t.parent.parent) : (t === t.parent.right && (t = t.parent, kC(i, t)), ti(
        t.parent,
        0
        /* NodeColor.Black */
      ), ti(
        t.parent.parent,
        1
        /* NodeColor.Red */
      ), TC(i, t.parent.parent));
    } else {
      const n = t.parent.parent.left;
      Eo(n) === 1 ? (ti(
        t.parent,
        0
        /* NodeColor.Black */
      ), ti(
        n,
        0
        /* NodeColor.Black */
      ), ti(
        t.parent.parent,
        1
        /* NodeColor.Red */
      ), t = t.parent.parent) : (t === t.parent.left && (t = t.parent, TC(i, t)), ti(
        t.parent,
        0
        /* NodeColor.Black */
      ), ti(
        t.parent.parent,
        1
        /* NodeColor.Red */
      ), kC(i, t.parent.parent));
    }
  return ti(
    i.root,
    0
    /* NodeColor.Black */
  ), e;
}
function aVe(i, e) {
  let t = 0, n = i.root;
  const r = e.start, s = e.end;
  for (; ; )
    if (cVe(r, s, n.start + t, n.end + t) < 0)
      if (n.left === Bt) {
        e.start -= t, e.end -= t, e.maxEnd -= t, n.left = e;
        break;
      } else
        n = n.left;
    else if (n.right === Bt) {
      e.start -= t + n.delta, e.end -= t + n.delta, e.maxEnd -= t + n.delta, n.right = e;
      break;
    } else
      t += n.delta, n = n.right;
  e.parent = n, e.left = Bt, e.right = Bt, ti(
    e,
    1
    /* NodeColor.Red */
  );
}
function tQ(i, e) {
  let t, n;
  if (e.left === Bt ? (t = e.right, n = e, t.delta += e.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (i.requestNormalizeDelta = !0), t.start += e.delta, t.end += e.delta) : e.right === Bt ? (t = e.left, n = e) : (n = lVe(e.right), t = n.right, t.start += n.delta, t.end += n.delta, t.delta += n.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (i.requestNormalizeDelta = !0), n.start += e.delta, n.end += e.delta, n.delta = e.delta, (n.delta < -1073741824 || n.delta > 1073741824) && (i.requestNormalizeDelta = !0)), n === i.root) {
    i.root = t, ti(
      t,
      0
      /* NodeColor.Black */
    ), e.detach(), V6(), zg(t), i.root.parent = Bt;
    return;
  }
  const r = Eo(n) === 1;
  if (n === n.parent.left ? n.parent.left = t : n.parent.right = t, n === e ? t.parent = n.parent : (n.parent === e ? t.parent = n : t.parent = n.parent, n.left = e.left, n.right = e.right, n.parent = e.parent, ti(n, Eo(e)), e === i.root ? i.root = n : e === e.parent.left ? e.parent.left = n : e.parent.right = n, n.left !== Bt && (n.left.parent = n), n.right !== Bt && (n.right.parent = n)), e.detach(), r) {
    Tf(t.parent), n !== e && (Tf(n), Tf(n.parent)), V6();
    return;
  }
  Tf(t), Tf(t.parent), n !== e && (Tf(n), Tf(n.parent));
  let s;
  for (; t !== i.root && Eo(t) === 0; )
    t === t.parent.left ? (s = t.parent.right, Eo(s) === 1 && (ti(
      s,
      0
      /* NodeColor.Black */
    ), ti(
      t.parent,
      1
      /* NodeColor.Red */
    ), kC(i, t.parent), s = t.parent.right), Eo(s.left) === 0 && Eo(s.right) === 0 ? (ti(
      s,
      1
      /* NodeColor.Red */
    ), t = t.parent) : (Eo(s.right) === 0 && (ti(
      s.left,
      0
      /* NodeColor.Black */
    ), ti(
      s,
      1
      /* NodeColor.Red */
    ), TC(i, s), s = t.parent.right), ti(s, Eo(t.parent)), ti(
      t.parent,
      0
      /* NodeColor.Black */
    ), ti(
      s.right,
      0
      /* NodeColor.Black */
    ), kC(i, t.parent), t = i.root)) : (s = t.parent.left, Eo(s) === 1 && (ti(
      s,
      0
      /* NodeColor.Black */
    ), ti(
      t.parent,
      1
      /* NodeColor.Red */
    ), TC(i, t.parent), s = t.parent.left), Eo(s.left) === 0 && Eo(s.right) === 0 ? (ti(
      s,
      1
      /* NodeColor.Red */
    ), t = t.parent) : (Eo(s.left) === 0 && (ti(
      s.right,
      0
      /* NodeColor.Black */
    ), ti(
      s,
      1
      /* NodeColor.Red */
    ), kC(i, s), s = t.parent.left), ti(s, Eo(t.parent)), ti(
      t.parent,
      0
      /* NodeColor.Black */
    ), ti(
      s.left,
      0
      /* NodeColor.Black */
    ), TC(i, t.parent), t = i.root));
  ti(
    t,
    0
    /* NodeColor.Black */
  ), V6();
}
function lVe(i) {
  for (; i.left !== Bt; )
    i = i.left;
  return i;
}
function V6() {
  Bt.parent = Bt, Bt.delta = 0, Bt.start = 0, Bt.end = 0;
}
function kC(i, e) {
  const t = e.right;
  t.delta += e.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (i.requestNormalizeDelta = !0), t.start += e.delta, t.end += e.delta, e.right = t.left, t.left !== Bt && (t.left.parent = e), t.parent = e.parent, e.parent === Bt ? i.root = t : e === e.parent.left ? e.parent.left = t : e.parent.right = t, t.left = e, e.parent = t, zg(e), zg(t);
}
function TC(i, e) {
  const t = e.left;
  e.delta -= t.delta, (e.delta < -1073741824 || e.delta > 1073741824) && (i.requestNormalizeDelta = !0), e.start -= t.delta, e.end -= t.delta, e.left = t.right, t.right !== Bt && (t.right.parent = e), t.parent = e.parent, e.parent === Bt ? i.root = t : e === e.parent.right ? e.parent.right = t : e.parent.left = t, t.right = e, e.parent = t, zg(e), zg(t);
}
function Ege(i) {
  let e = i.end;
  if (i.left !== Bt) {
    const t = i.left.maxEnd;
    t > e && (e = t);
  }
  if (i.right !== Bt) {
    const t = i.right.maxEnd + i.delta;
    t > e && (e = t);
  }
  return e;
}
function zg(i) {
  i.maxEnd = Ege(i);
}
function Tf(i) {
  for (; i !== Bt; ) {
    const e = Ege(i);
    if (i.maxEnd === e)
      return;
    i.maxEnd = e, i = i.parent;
  }
}
function cVe(i, e, t, n) {
  return i === t ? e - n : i - t;
}
class zF {
  constructor(e, t) {
    this.piece = e, this.color = t, this.size_left = 0, this.lf_left = 0, this.parent = this, this.left = this, this.right = this;
  }
  next() {
    if (this.right !== Et)
      return Pz(this.right);
    let e = this;
    for (; e.parent !== Et && e.parent.left !== e; )
      e = e.parent;
    return e.parent === Et ? Et : e.parent;
  }
  prev() {
    if (this.left !== Et)
      return Lge(this.left);
    let e = this;
    for (; e.parent !== Et && e.parent.right !== e; )
      e = e.parent;
    return e.parent === Et ? Et : e.parent;
  }
  detach() {
    this.parent = null, this.left = null, this.right = null;
  }
}
const Et = new zF(
  null,
  0
  /* NodeColor.Black */
);
Et.parent = Et;
Et.left = Et;
Et.right = Et;
Et.color = 0;
function Pz(i) {
  for (; i.left !== Et; )
    i = i.left;
  return i;
}
function Lge(i) {
  for (; i.right !== Et; )
    i = i.right;
  return i;
}
function Oz(i) {
  return i === Et ? 0 : i.size_left + i.piece.length + Oz(i.right);
}
function Mz(i) {
  return i === Et ? 0 : i.lf_left + i.piece.lineFeedCnt + Mz(i.right);
}
function H6() {
  Et.parent = Et;
}
function NC(i, e) {
  const t = e.right;
  t.size_left += e.size_left + (e.piece ? e.piece.length : 0), t.lf_left += e.lf_left + (e.piece ? e.piece.lineFeedCnt : 0), e.right = t.left, t.left !== Et && (t.left.parent = e), t.parent = e.parent, e.parent === Et ? i.root = t : e.parent.left === e ? e.parent.left = t : e.parent.right = t, t.left = e, e.parent = t;
}
function PC(i, e) {
  const t = e.left;
  e.left = t.right, t.right !== Et && (t.right.parent = e), t.parent = e.parent, e.size_left -= t.size_left + (t.piece ? t.piece.length : 0), e.lf_left -= t.lf_left + (t.piece ? t.piece.lineFeedCnt : 0), e.parent === Et ? i.root = t : e === e.parent.right ? e.parent.right = t : e.parent.left = t, t.right = e, e.parent = t;
}
function nD(i, e) {
  let t, n;
  if (e.left === Et ? (n = e, t = n.right) : e.right === Et ? (n = e, t = n.left) : (n = Pz(e.right), t = n.right), n === i.root) {
    i.root = t, t.color = 0, e.detach(), H6(), i.root.parent = Et;
    return;
  }
  const r = n.color === 1;
  if (n === n.parent.left ? n.parent.left = t : n.parent.right = t, n === e ? (t.parent = n.parent, J2(i, t)) : (n.parent === e ? t.parent = n : t.parent = n.parent, J2(i, t), n.left = e.left, n.right = e.right, n.parent = e.parent, n.color = e.color, e === i.root ? i.root = n : e === e.parent.left ? e.parent.left = n : e.parent.right = n, n.left !== Et && (n.left.parent = n), n.right !== Et && (n.right.parent = n), n.size_left = e.size_left, n.lf_left = e.lf_left, J2(i, n)), e.detach(), t.parent.left === t) {
    const o = Oz(t), a = Mz(t);
    if (o !== t.parent.size_left || a !== t.parent.lf_left) {
      const l = o - t.parent.size_left, c = a - t.parent.lf_left;
      t.parent.size_left = o, t.parent.lf_left = a, Qu(i, t.parent, l, c);
    }
  }
  if (J2(i, t.parent), r) {
    H6();
    return;
  }
  let s;
  for (; t !== i.root && t.color === 0; )
    t === t.parent.left ? (s = t.parent.right, s.color === 1 && (s.color = 0, t.parent.color = 1, NC(i, t.parent), s = t.parent.right), s.left.color === 0 && s.right.color === 0 ? (s.color = 1, t = t.parent) : (s.right.color === 0 && (s.left.color = 0, s.color = 1, PC(i, s), s = t.parent.right), s.color = t.parent.color, t.parent.color = 0, s.right.color = 0, NC(i, t.parent), t = i.root)) : (s = t.parent.left, s.color === 1 && (s.color = 0, t.parent.color = 1, PC(i, t.parent), s = t.parent.left), s.left.color === 0 && s.right.color === 0 ? (s.color = 1, t = t.parent) : (s.left.color === 0 && (s.right.color = 0, s.color = 1, NC(i, s), s = t.parent.left), s.color = t.parent.color, t.parent.color = 0, s.left.color = 0, PC(i, t.parent), t = i.root));
  t.color = 0, H6();
}
function nQ(i, e) {
  for (J2(i, e); e !== i.root && e.parent.color === 1; )
    if (e.parent === e.parent.parent.left) {
      const t = e.parent.parent.right;
      t.color === 1 ? (e.parent.color = 0, t.color = 0, e.parent.parent.color = 1, e = e.parent.parent) : (e === e.parent.right && (e = e.parent, NC(i, e)), e.parent.color = 0, e.parent.parent.color = 1, PC(i, e.parent.parent));
    } else {
      const t = e.parent.parent.left;
      t.color === 1 ? (e.parent.color = 0, t.color = 0, e.parent.parent.color = 1, e = e.parent.parent) : (e === e.parent.left && (e = e.parent, PC(i, e)), e.parent.color = 0, e.parent.parent.color = 1, NC(i, e.parent.parent));
    }
  i.root.color = 0;
}
function Qu(i, e, t, n) {
  for (; e !== i.root && e !== Et; )
    e.parent.left === e && (e.parent.size_left += t, e.parent.lf_left += n), e = e.parent;
}
function J2(i, e) {
  let t = 0, n = 0;
  if (e !== i.root) {
    for (; e !== i.root && e === e.parent.right; )
      e = e.parent;
    if (e !== i.root)
      for (e = e.parent, t = Oz(e.left) - e.size_left, n = Mz(e.left) - e.lf_left, e.size_left += t, e.lf_left += n; e !== i.root && (t !== 0 || n !== 0); )
        e.parent.left === e && (e.parent.size_left += t, e.parent.lf_left += n), e = e.parent;
  }
}
const Wu = 65535;
function Ige(i) {
  let e;
  return i[i.length - 1] < 65536 ? e = new Uint16Array(i.length) : e = new Uint32Array(i.length), e.set(i, 0), e;
}
class dVe {
  constructor(e, t, n, r, s) {
    this.lineStarts = e, this.cr = t, this.lf = n, this.crlf = r, this.isBasicASCII = s;
  }
}
function nh(i, e = !0) {
  const t = [0];
  let n = 1;
  for (let r = 0, s = i.length; r < s; r++) {
    const o = i.charCodeAt(r);
    o === 13 ? r + 1 < s && i.charCodeAt(r + 1) === 10 ? (t[n++] = r + 2, r++) : t[n++] = r + 1 : o === 10 && (t[n++] = r + 1);
  }
  return e ? Ige(t) : t;
}
function uVe(i, e) {
  i.length = 0, i[0] = 0;
  let t = 1, n = 0, r = 0, s = 0, o = !0;
  for (let l = 0, c = e.length; l < c; l++) {
    const d = e.charCodeAt(l);
    d === 13 ? l + 1 < c && e.charCodeAt(l + 1) === 10 ? (s++, i[t++] = l + 2, l++) : (n++, i[t++] = l + 1) : d === 10 ? (r++, i[t++] = l + 1) : o && d !== 9 && (d < 32 || d > 126) && (o = !1);
  }
  const a = new dVe(Ige(i), n, r, s, o);
  return i.length = 0, a;
}
class jo {
  constructor(e, t, n, r, s) {
    this.bufferIndex = e, this.start = t, this.end = n, this.lineFeedCnt = r, this.length = s;
  }
}
class em {
  constructor(e, t) {
    this.buffer = e, this.lineStarts = t;
  }
}
class hVe {
  constructor(e, t) {
    this._pieces = [], this._tree = e, this._BOM = t, this._index = 0, e.root !== Et && e.iterate(e.root, (n) => (n !== Et && this._pieces.push(n.piece), !0));
  }
  read() {
    return this._pieces.length === 0 ? this._index === 0 ? (this._index++, this._BOM) : null : this._index > this._pieces.length - 1 ? null : this._index === 0 ? this._BOM + this._tree.getPieceContent(this._pieces[this._index++]) : this._tree.getPieceContent(this._pieces[this._index++]);
  }
}
class fVe {
  constructor(e) {
    this._limit = e, this._cache = [];
  }
  get(e) {
    for (let t = this._cache.length - 1; t >= 0; t--) {
      const n = this._cache[t];
      if (n.nodeStartOffset <= e && n.nodeStartOffset + n.node.piece.length >= e)
        return n;
    }
    return null;
  }
  get2(e) {
    for (let t = this._cache.length - 1; t >= 0; t--) {
      const n = this._cache[t];
      if (n.nodeStartLineNumber && n.nodeStartLineNumber < e && n.nodeStartLineNumber + n.node.piece.lineFeedCnt >= e)
        return n;
    }
    return null;
  }
  set(e) {
    this._cache.length >= this._limit && this._cache.shift(), this._cache.push(e);
  }
  validate(e) {
    let t = !1;
    const n = this._cache;
    for (let r = 0; r < n.length; r++) {
      const s = n[r];
      if (s.node.parent === null || s.nodeStartOffset >= e) {
        n[r] = null, t = !0;
        continue;
      }
    }
    if (t) {
      const r = [];
      for (const s of n)
        s !== null && r.push(s);
      this._cache = r;
    }
  }
}
class gVe {
  constructor(e, t, n) {
    this.create(e, t, n);
  }
  create(e, t, n) {
    this._buffers = [
      new em("", [0])
    ], this._lastChangeBufferPos = { line: 0, column: 0 }, this.root = Et, this._lineCnt = 1, this._length = 0, this._EOL = t, this._EOLLength = t.length, this._EOLNormalized = n;
    let r = null;
    for (let s = 0, o = e.length; s < o; s++)
      if (e[s].buffer.length > 0) {
        e[s].lineStarts || (e[s].lineStarts = nh(e[s].buffer));
        const a = new jo(s + 1, { line: 0, column: 0 }, { line: e[s].lineStarts.length - 1, column: e[s].buffer.length - e[s].lineStarts[e[s].lineStarts.length - 1] }, e[s].lineStarts.length - 1, e[s].buffer.length);
        this._buffers.push(e[s]), r = this.rbInsertRight(r, a);
      }
    this._searchCache = new fVe(1), this._lastVisitedLine = { lineNumber: 0, value: "" }, this.computeBufferMetadata();
  }
  normalizeEOL(e) {
    const t = Wu, n = t - Math.floor(t / 3), r = n * 2;
    let s = "", o = 0;
    const a = [];
    if (this.iterate(this.root, (l) => {
      const c = this.getNodeContent(l), d = c.length;
      if (o <= n || o + d < r)
        return s += c, o += d, !0;
      const u = s.replace(/\r\n|\r|\n/g, e);
      return a.push(new em(u, nh(u))), s = c, o = d, !0;
    }), o > 0) {
      const l = s.replace(/\r\n|\r|\n/g, e);
      a.push(new em(l, nh(l)));
    }
    this.create(a, e, !0);
  }
  // #region Buffer API
  getEOL() {
    return this._EOL;
  }
  setEOL(e) {
    this._EOL = e, this._EOLLength = this._EOL.length, this.normalizeEOL(e);
  }
  createSnapshot(e) {
    return new hVe(this, e);
  }
  getOffsetAt(e, t) {
    let n = 0, r = this.root;
    for (; r !== Et; )
      if (r.left !== Et && r.lf_left + 1 >= e)
        r = r.left;
      else if (r.lf_left + r.piece.lineFeedCnt + 1 >= e) {
        n += r.size_left;
        const s = this.getAccumulatedValue(r, e - r.lf_left - 2);
        return n += s + t - 1;
      } else
        e -= r.lf_left + r.piece.lineFeedCnt, n += r.size_left + r.piece.length, r = r.right;
    return n;
  }
  getPositionAt(e) {
    e = Math.floor(e), e = Math.max(0, e);
    let t = this.root, n = 0;
    const r = e;
    for (; t !== Et; )
      if (t.size_left !== 0 && t.size_left >= e)
        t = t.left;
      else if (t.size_left + t.piece.length >= e) {
        const s = this.getIndexOf(t, e - t.size_left);
        if (n += t.lf_left + s.index, s.index === 0) {
          const o = this.getOffsetAt(n + 1, 1), a = r - o;
          return new ve(n + 1, a + 1);
        }
        return new ve(n + 1, s.remainder + 1);
      } else if (e -= t.size_left + t.piece.length, n += t.lf_left + t.piece.lineFeedCnt, t.right === Et) {
        const s = this.getOffsetAt(n + 1, 1), o = r - e - s;
        return new ve(n + 1, o + 1);
      } else
        t = t.right;
    return new ve(1, 1);
  }
  getValueInRange(e, t) {
    if (e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn)
      return "";
    const n = this.nodeAt2(e.startLineNumber, e.startColumn), r = this.nodeAt2(e.endLineNumber, e.endColumn), s = this.getValueInRange2(n, r);
    return t ? t !== this._EOL || !this._EOLNormalized ? s.replace(/\r\n|\r|\n/g, t) : t === this.getEOL() && this._EOLNormalized ? s : s.replace(/\r\n|\r|\n/g, t) : s;
  }
  getValueInRange2(e, t) {
    if (e.node === t.node) {
      const a = e.node, l = this._buffers[a.piece.bufferIndex].buffer, c = this.offsetInBuffer(a.piece.bufferIndex, a.piece.start);
      return l.substring(c + e.remainder, c + t.remainder);
    }
    let n = e.node;
    const r = this._buffers[n.piece.bufferIndex].buffer, s = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
    let o = r.substring(s + e.remainder, s + n.piece.length);
    for (n = n.next(); n !== Et; ) {
      const a = this._buffers[n.piece.bufferIndex].buffer, l = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
      if (n === t.node) {
        o += a.substring(l, l + t.remainder);
        break;
      } else
        o += a.substr(l, n.piece.length);
      n = n.next();
    }
    return o;
  }
  getLinesContent() {
    const e = [];
    let t = 0, n = "", r = !1;
    return this.iterate(this.root, (s) => {
      if (s === Et)
        return !0;
      const o = s.piece;
      let a = o.length;
      if (a === 0)
        return !0;
      const l = this._buffers[o.bufferIndex].buffer, c = this._buffers[o.bufferIndex].lineStarts, d = o.start.line, u = o.end.line;
      let h = c[d] + o.start.column;
      if (r && (l.charCodeAt(h) === 10 && (h++, a--), e[t++] = n, n = "", r = !1, a === 0))
        return !0;
      if (d === u)
        return !this._EOLNormalized && l.charCodeAt(h + a - 1) === 13 ? (r = !0, n += l.substr(h, a - 1)) : n += l.substr(h, a), !0;
      n += this._EOLNormalized ? l.substring(h, Math.max(h, c[d + 1] - this._EOLLength)) : l.substring(h, c[d + 1]).replace(/(\r\n|\r|\n)$/, ""), e[t++] = n;
      for (let f = d + 1; f < u; f++)
        n = this._EOLNormalized ? l.substring(c[f], c[f + 1] - this._EOLLength) : l.substring(c[f], c[f + 1]).replace(/(\r\n|\r|\n)$/, ""), e[t++] = n;
      return !this._EOLNormalized && l.charCodeAt(c[u] + o.end.column - 1) === 13 ? (r = !0, o.end.column === 0 ? t-- : n = l.substr(c[u], o.end.column - 1)) : n = l.substr(c[u], o.end.column), !0;
    }), r && (e[t++] = n, n = ""), e[t++] = n, e;
  }
  getLength() {
    return this._length;
  }
  getLineCount() {
    return this._lineCnt;
  }
  getLineContent(e) {
    return this._lastVisitedLine.lineNumber === e ? this._lastVisitedLine.value : (this._lastVisitedLine.lineNumber = e, e === this._lineCnt ? this._lastVisitedLine.value = this.getLineRawContent(e) : this._EOLNormalized ? this._lastVisitedLine.value = this.getLineRawContent(e, this._EOLLength) : this._lastVisitedLine.value = this.getLineRawContent(e).replace(/(\r\n|\r|\n)$/, ""), this._lastVisitedLine.value);
  }
  _getCharCode(e) {
    if (e.remainder === e.node.piece.length) {
      const t = e.node.next();
      if (!t)
        return 0;
      const n = this._buffers[t.piece.bufferIndex], r = this.offsetInBuffer(t.piece.bufferIndex, t.piece.start);
      return n.buffer.charCodeAt(r);
    } else {
      const t = this._buffers[e.node.piece.bufferIndex], r = this.offsetInBuffer(e.node.piece.bufferIndex, e.node.piece.start) + e.remainder;
      return t.buffer.charCodeAt(r);
    }
  }
  getLineCharCode(e, t) {
    const n = this.nodeAt2(e, t + 1);
    return this._getCharCode(n);
  }
  getLineLength(e) {
    if (e === this.getLineCount()) {
      const t = this.getOffsetAt(e, 1);
      return this.getLength() - t;
    }
    return this.getOffsetAt(e + 1, 1) - this.getOffsetAt(e, 1) - this._EOLLength;
  }
  findMatchesInNode(e, t, n, r, s, o, a, l, c, d, u) {
    const h = this._buffers[e.piece.bufferIndex], f = this.offsetInBuffer(e.piece.bufferIndex, e.piece.start), g = this.offsetInBuffer(e.piece.bufferIndex, s), p = this.offsetInBuffer(e.piece.bufferIndex, o);
    let m;
    const _ = { line: 0, column: 0 };
    let b, w;
    t._wordSeparators ? (b = h.buffer.substring(g, p), w = (y) => y + g, t.reset(0)) : (b = h.buffer, w = (y) => y, t.reset(g));
    do
      if (m = t.next(b), m) {
        if (w(m.index) >= p)
          return d;
        this.positionInBuffer(e, w(m.index) - f, _);
        const y = this.getLineFeedCnt(e.piece.bufferIndex, s, _), S = _.line === s.line ? _.column - s.column + r : _.column + 1, x = S + m[0].length;
        if (u[d++] = Yp(new V(n + y, S, n + y, x), m, l), w(m.index) + m[0].length >= p || d >= c)
          return d;
      }
    while (m);
    return d;
  }
  findMatchesLineByLine(e, t, n, r) {
    const s = [];
    let o = 0;
    const a = new Z1(t.wordSeparators, t.regex);
    let l = this.nodeAt2(e.startLineNumber, e.startColumn);
    if (l === null)
      return [];
    const c = this.nodeAt2(e.endLineNumber, e.endColumn);
    if (c === null)
      return [];
    let d = this.positionInBuffer(l.node, l.remainder);
    const u = this.positionInBuffer(c.node, c.remainder);
    if (l.node === c.node)
      return this.findMatchesInNode(l.node, a, e.startLineNumber, e.startColumn, d, u, t, n, r, o, s), s;
    let h = e.startLineNumber, f = l.node;
    for (; f !== c.node; ) {
      const p = this.getLineFeedCnt(f.piece.bufferIndex, d, f.piece.end);
      if (p >= 1) {
        const _ = this._buffers[f.piece.bufferIndex].lineStarts, b = this.offsetInBuffer(f.piece.bufferIndex, f.piece.start), w = _[d.line + p], y = h === e.startLineNumber ? e.startColumn : 1;
        if (o = this.findMatchesInNode(f, a, h, y, d, this.positionInBuffer(f, w - b), t, n, r, o, s), o >= r)
          return s;
        h += p;
      }
      const m = h === e.startLineNumber ? e.startColumn - 1 : 0;
      if (h === e.endLineNumber) {
        const _ = this.getLineContent(h).substring(m, e.endColumn - 1);
        return o = this._findMatchesInLine(t, a, _, e.endLineNumber, m, o, s, n, r), s;
      }
      if (o = this._findMatchesInLine(t, a, this.getLineContent(h).substr(m), h, m, o, s, n, r), o >= r)
        return s;
      h++, l = this.nodeAt2(h, 1), f = l.node, d = this.positionInBuffer(l.node, l.remainder);
    }
    if (h === e.endLineNumber) {
      const p = h === e.startLineNumber ? e.startColumn - 1 : 0, m = this.getLineContent(h).substring(p, e.endColumn - 1);
      return o = this._findMatchesInLine(t, a, m, e.endLineNumber, p, o, s, n, r), s;
    }
    const g = h === e.startLineNumber ? e.startColumn : 1;
    return o = this.findMatchesInNode(c.node, a, h, g, d, u, t, n, r, o, s), s;
  }
  _findMatchesInLine(e, t, n, r, s, o, a, l, c) {
    const d = e.wordSeparators;
    if (!l && e.simpleSearch) {
      const h = e.simpleSearch, f = h.length, g = n.length;
      let p = -f;
      for (; (p = n.indexOf(h, p + f)) !== -1; )
        if ((!d || $j(d, n, g, p, f)) && (a[o++] = new Ny(new V(r, p + 1 + s, r, p + 1 + f + s), null), o >= c))
          return o;
      return o;
    }
    let u;
    t.reset(0);
    do
      if (u = t.next(n), u && (a[o++] = Yp(new V(r, u.index + 1 + s, r, u.index + 1 + u[0].length + s), u, l), o >= c))
        return o;
    while (u);
    return o;
  }
  // #endregion
  // #region Piece Table
  insert(e, t, n = !1) {
    if (this._EOLNormalized = this._EOLNormalized && n, this._lastVisitedLine.lineNumber = 0, this._lastVisitedLine.value = "", this.root !== Et) {
      const { node: r, remainder: s, nodeStartOffset: o } = this.nodeAt(e), a = r.piece, l = a.bufferIndex, c = this.positionInBuffer(r, s);
      if (r.piece.bufferIndex === 0 && a.end.line === this._lastChangeBufferPos.line && a.end.column === this._lastChangeBufferPos.column && o + a.length === e && t.length < Wu) {
        this.appendToNode(r, t), this.computeBufferMetadata();
        return;
      }
      if (o === e)
        this.insertContentToNodeLeft(t, r), this._searchCache.validate(e);
      else if (o + r.piece.length > e) {
        const d = [];
        let u = new jo(a.bufferIndex, c, a.end, this.getLineFeedCnt(a.bufferIndex, c, a.end), this.offsetInBuffer(l, a.end) - this.offsetInBuffer(l, c));
        if (this.shouldCheckCRLF() && this.endWithCR(t) && this.nodeCharCodeAt(r, s) === 10) {
          const p = { line: u.start.line + 1, column: 0 };
          u = new jo(u.bufferIndex, p, u.end, this.getLineFeedCnt(u.bufferIndex, p, u.end), u.length - 1), t += `
`;
        }
        if (this.shouldCheckCRLF() && this.startWithLF(t))
          if (this.nodeCharCodeAt(r, s - 1) === 13) {
            const p = this.positionInBuffer(r, s - 1);
            this.deleteNodeTail(r, p), t = "\r" + t, r.piece.length === 0 && d.push(r);
          } else
            this.deleteNodeTail(r, c);
        else
          this.deleteNodeTail(r, c);
        const h = this.createNewPieces(t);
        u.length > 0 && this.rbInsertRight(r, u);
        let f = r;
        for (let g = 0; g < h.length; g++)
          f = this.rbInsertRight(f, h[g]);
        this.deleteNodes(d);
      } else
        this.insertContentToNodeRight(t, r);
    } else {
      const r = this.createNewPieces(t);
      let s = this.rbInsertLeft(null, r[0]);
      for (let o = 1; o < r.length; o++)
        s = this.rbInsertRight(s, r[o]);
    }
    this.computeBufferMetadata();
  }
  delete(e, t) {
    if (this._lastVisitedLine.lineNumber = 0, this._lastVisitedLine.value = "", t <= 0 || this.root === Et)
      return;
    const n = this.nodeAt(e), r = this.nodeAt(e + t), s = n.node, o = r.node;
    if (s === o) {
      const h = this.positionInBuffer(s, n.remainder), f = this.positionInBuffer(s, r.remainder);
      if (n.nodeStartOffset === e) {
        if (t === s.piece.length) {
          const g = s.next();
          nD(this, s), this.validateCRLFWithPrevNode(g), this.computeBufferMetadata();
          return;
        }
        this.deleteNodeHead(s, f), this._searchCache.validate(e), this.validateCRLFWithPrevNode(s), this.computeBufferMetadata();
        return;
      }
      if (n.nodeStartOffset + s.piece.length === e + t) {
        this.deleteNodeTail(s, h), this.validateCRLFWithNextNode(s), this.computeBufferMetadata();
        return;
      }
      this.shrinkNode(s, h, f), this.computeBufferMetadata();
      return;
    }
    const a = [], l = this.positionInBuffer(s, n.remainder);
    this.deleteNodeTail(s, l), this._searchCache.validate(e), s.piece.length === 0 && a.push(s);
    const c = this.positionInBuffer(o, r.remainder);
    this.deleteNodeHead(o, c), o.piece.length === 0 && a.push(o);
    const d = s.next();
    for (let h = d; h !== Et && h !== o; h = h.next())
      a.push(h);
    const u = s.piece.length === 0 ? s.prev() : s;
    this.deleteNodes(a), this.validateCRLFWithNextNode(u), this.computeBufferMetadata();
  }
  insertContentToNodeLeft(e, t) {
    const n = [];
    if (this.shouldCheckCRLF() && this.endWithCR(e) && this.startWithLF(t)) {
      const o = t.piece, a = { line: o.start.line + 1, column: 0 }, l = new jo(o.bufferIndex, a, o.end, this.getLineFeedCnt(o.bufferIndex, a, o.end), o.length - 1);
      t.piece = l, e += `
`, Qu(this, t, -1, -1), t.piece.length === 0 && n.push(t);
    }
    const r = this.createNewPieces(e);
    let s = this.rbInsertLeft(t, r[r.length - 1]);
    for (let o = r.length - 2; o >= 0; o--)
      s = this.rbInsertLeft(s, r[o]);
    this.validateCRLFWithPrevNode(s), this.deleteNodes(n);
  }
  insertContentToNodeRight(e, t) {
    this.adjustCarriageReturnFromNext(e, t) && (e += `
`);
    const n = this.createNewPieces(e), r = this.rbInsertRight(t, n[0]);
    let s = r;
    for (let o = 1; o < n.length; o++)
      s = this.rbInsertRight(s, n[o]);
    this.validateCRLFWithPrevNode(r);
  }
  positionInBuffer(e, t, n) {
    const r = e.piece, s = e.piece.bufferIndex, o = this._buffers[s].lineStarts, l = o[r.start.line] + r.start.column + t;
    let c = r.start.line, d = r.end.line, u = 0, h = 0, f = 0;
    for (; c <= d && (u = c + (d - c) / 2 | 0, f = o[u], u !== d); )
      if (h = o[u + 1], l < f)
        d = u - 1;
      else if (l >= h)
        c = u + 1;
      else
        break;
    return n ? (n.line = u, n.column = l - f, null) : {
      line: u,
      column: l - f
    };
  }
  getLineFeedCnt(e, t, n) {
    if (n.column === 0)
      return n.line - t.line;
    const r = this._buffers[e].lineStarts;
    if (n.line === r.length - 1)
      return n.line - t.line;
    const s = r[n.line + 1], o = r[n.line] + n.column;
    if (s > o + 1)
      return n.line - t.line;
    const a = o - 1;
    return this._buffers[e].buffer.charCodeAt(a) === 13 ? n.line - t.line + 1 : n.line - t.line;
  }
  offsetInBuffer(e, t) {
    return this._buffers[e].lineStarts[t.line] + t.column;
  }
  deleteNodes(e) {
    for (let t = 0; t < e.length; t++)
      nD(this, e[t]);
  }
  createNewPieces(e) {
    if (e.length > Wu) {
      const d = [];
      for (; e.length > Wu; ) {
        const h = e.charCodeAt(Wu - 1);
        let f;
        h === 13 || h >= 55296 && h <= 56319 ? (f = e.substring(0, Wu - 1), e = e.substring(Wu - 1)) : (f = e.substring(0, Wu), e = e.substring(Wu));
        const g = nh(f);
        d.push(new jo(
          this._buffers.length,
          /* buffer index */
          { line: 0, column: 0 },
          { line: g.length - 1, column: f.length - g[g.length - 1] },
          g.length - 1,
          f.length
        )), this._buffers.push(new em(f, g));
      }
      const u = nh(e);
      return d.push(new jo(
        this._buffers.length,
        /* buffer index */
        { line: 0, column: 0 },
        { line: u.length - 1, column: e.length - u[u.length - 1] },
        u.length - 1,
        e.length
      )), this._buffers.push(new em(e, u)), d;
    }
    let t = this._buffers[0].buffer.length;
    const n = nh(e, !1);
    let r = this._lastChangeBufferPos;
    if (this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 1] === t && t !== 0 && this.startWithLF(e) && this.endWithCR(this._buffers[0].buffer)) {
      this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line, column: this._lastChangeBufferPos.column + 1 }, r = this._lastChangeBufferPos;
      for (let d = 0; d < n.length; d++)
        n[d] += t + 1;
      this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(n.slice(1)), this._buffers[0].buffer += "_" + e, t += 1;
    } else {
      if (t !== 0)
        for (let d = 0; d < n.length; d++)
          n[d] += t;
      this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(n.slice(1)), this._buffers[0].buffer += e;
    }
    const s = this._buffers[0].buffer.length, o = this._buffers[0].lineStarts.length - 1, a = s - this._buffers[0].lineStarts[o], l = { line: o, column: a }, c = new jo(
      0,
      /** todo@peng */
      r,
      l,
      this.getLineFeedCnt(0, r, l),
      s - t
    );
    return this._lastChangeBufferPos = l, [c];
  }
  getLineRawContent(e, t = 0) {
    let n = this.root, r = "";
    const s = this._searchCache.get2(e);
    if (s) {
      n = s.node;
      const o = this.getAccumulatedValue(n, e - s.nodeStartLineNumber - 1), a = this._buffers[n.piece.bufferIndex].buffer, l = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
      if (s.nodeStartLineNumber + n.piece.lineFeedCnt === e)
        r = a.substring(l + o, l + n.piece.length);
      else {
        const c = this.getAccumulatedValue(n, e - s.nodeStartLineNumber);
        return a.substring(l + o, l + c - t);
      }
    } else {
      let o = 0;
      const a = e;
      for (; n !== Et; )
        if (n.left !== Et && n.lf_left >= e - 1)
          n = n.left;
        else if (n.lf_left + n.piece.lineFeedCnt > e - 1) {
          const l = this.getAccumulatedValue(n, e - n.lf_left - 2), c = this.getAccumulatedValue(n, e - n.lf_left - 1), d = this._buffers[n.piece.bufferIndex].buffer, u = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
          return o += n.size_left, this._searchCache.set({
            node: n,
            nodeStartOffset: o,
            nodeStartLineNumber: a - (e - 1 - n.lf_left)
          }), d.substring(u + l, u + c - t);
        } else if (n.lf_left + n.piece.lineFeedCnt === e - 1) {
          const l = this.getAccumulatedValue(n, e - n.lf_left - 2), c = this._buffers[n.piece.bufferIndex].buffer, d = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
          r = c.substring(d + l, d + n.piece.length);
          break;
        } else
          e -= n.lf_left + n.piece.lineFeedCnt, o += n.size_left + n.piece.length, n = n.right;
    }
    for (n = n.next(); n !== Et; ) {
      const o = this._buffers[n.piece.bufferIndex].buffer;
      if (n.piece.lineFeedCnt > 0) {
        const a = this.getAccumulatedValue(n, 0), l = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
        return r += o.substring(l, l + a - t), r;
      } else {
        const a = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
        r += o.substr(a, n.piece.length);
      }
      n = n.next();
    }
    return r;
  }
  computeBufferMetadata() {
    let e = this.root, t = 1, n = 0;
    for (; e !== Et; )
      t += e.lf_left + e.piece.lineFeedCnt, n += e.size_left + e.piece.length, e = e.right;
    this._lineCnt = t, this._length = n, this._searchCache.validate(this._length);
  }
  // #region node operations
  getIndexOf(e, t) {
    const n = e.piece, r = this.positionInBuffer(e, t), s = r.line - n.start.line;
    if (this.offsetInBuffer(n.bufferIndex, n.end) - this.offsetInBuffer(n.bufferIndex, n.start) === t) {
      const o = this.getLineFeedCnt(e.piece.bufferIndex, n.start, r);
      if (o !== s)
        return { index: o, remainder: 0 };
    }
    return { index: s, remainder: r.column };
  }
  getAccumulatedValue(e, t) {
    if (t < 0)
      return 0;
    const n = e.piece, r = this._buffers[n.bufferIndex].lineStarts, s = n.start.line + t + 1;
    return s > n.end.line ? r[n.end.line] + n.end.column - r[n.start.line] - n.start.column : r[s] - r[n.start.line] - n.start.column;
  }
  deleteNodeTail(e, t) {
    const n = e.piece, r = n.lineFeedCnt, s = this.offsetInBuffer(n.bufferIndex, n.end), o = t, a = this.offsetInBuffer(n.bufferIndex, o), l = this.getLineFeedCnt(n.bufferIndex, n.start, o), c = l - r, d = a - s, u = n.length + d;
    e.piece = new jo(n.bufferIndex, n.start, o, l, u), Qu(this, e, d, c);
  }
  deleteNodeHead(e, t) {
    const n = e.piece, r = n.lineFeedCnt, s = this.offsetInBuffer(n.bufferIndex, n.start), o = t, a = this.getLineFeedCnt(n.bufferIndex, o, n.end), l = this.offsetInBuffer(n.bufferIndex, o), c = a - r, d = s - l, u = n.length + d;
    e.piece = new jo(n.bufferIndex, o, n.end, a, u), Qu(this, e, d, c);
  }
  shrinkNode(e, t, n) {
    const r = e.piece, s = r.start, o = r.end, a = r.length, l = r.lineFeedCnt, c = t, d = this.getLineFeedCnt(r.bufferIndex, r.start, c), u = this.offsetInBuffer(r.bufferIndex, t) - this.offsetInBuffer(r.bufferIndex, s);
    e.piece = new jo(r.bufferIndex, r.start, c, d, u), Qu(this, e, u - a, d - l);
    const h = new jo(r.bufferIndex, n, o, this.getLineFeedCnt(r.bufferIndex, n, o), this.offsetInBuffer(r.bufferIndex, o) - this.offsetInBuffer(r.bufferIndex, n)), f = this.rbInsertRight(e, h);
    this.validateCRLFWithPrevNode(f);
  }
  appendToNode(e, t) {
    this.adjustCarriageReturnFromNext(t, e) && (t += `
`);
    const n = this.shouldCheckCRLF() && this.startWithLF(t) && this.endWithCR(e), r = this._buffers[0].buffer.length;
    this._buffers[0].buffer += t;
    const s = nh(t, !1);
    for (let f = 0; f < s.length; f++)
      s[f] += r;
    if (n) {
      const f = this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 2];
      this._buffers[0].lineStarts.pop(), this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line - 1, column: r - f };
    }
    this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(s.slice(1));
    const o = this._buffers[0].lineStarts.length - 1, a = this._buffers[0].buffer.length - this._buffers[0].lineStarts[o], l = { line: o, column: a }, c = e.piece.length + t.length, d = e.piece.lineFeedCnt, u = this.getLineFeedCnt(0, e.piece.start, l), h = u - d;
    e.piece = new jo(e.piece.bufferIndex, e.piece.start, l, u, c), this._lastChangeBufferPos = l, Qu(this, e, t.length, h);
  }
  nodeAt(e) {
    let t = this.root;
    const n = this._searchCache.get(e);
    if (n)
      return {
        node: n.node,
        nodeStartOffset: n.nodeStartOffset,
        remainder: e - n.nodeStartOffset
      };
    let r = 0;
    for (; t !== Et; )
      if (t.size_left > e)
        t = t.left;
      else if (t.size_left + t.piece.length >= e) {
        r += t.size_left;
        const s = {
          node: t,
          remainder: e - t.size_left,
          nodeStartOffset: r
        };
        return this._searchCache.set(s), s;
      } else
        e -= t.size_left + t.piece.length, r += t.size_left + t.piece.length, t = t.right;
    return null;
  }
  nodeAt2(e, t) {
    let n = this.root, r = 0;
    for (; n !== Et; )
      if (n.left !== Et && n.lf_left >= e - 1)
        n = n.left;
      else if (n.lf_left + n.piece.lineFeedCnt > e - 1) {
        const s = this.getAccumulatedValue(n, e - n.lf_left - 2), o = this.getAccumulatedValue(n, e - n.lf_left - 1);
        return r += n.size_left, {
          node: n,
          remainder: Math.min(s + t - 1, o),
          nodeStartOffset: r
        };
      } else if (n.lf_left + n.piece.lineFeedCnt === e - 1) {
        const s = this.getAccumulatedValue(n, e - n.lf_left - 2);
        if (s + t - 1 <= n.piece.length)
          return {
            node: n,
            remainder: s + t - 1,
            nodeStartOffset: r
          };
        t -= n.piece.length - s;
        break;
      } else
        e -= n.lf_left + n.piece.lineFeedCnt, r += n.size_left + n.piece.length, n = n.right;
    for (n = n.next(); n !== Et; ) {
      if (n.piece.lineFeedCnt > 0) {
        const s = this.getAccumulatedValue(n, 0), o = this.offsetOfNode(n);
        return {
          node: n,
          remainder: Math.min(t - 1, s),
          nodeStartOffset: o
        };
      } else if (n.piece.length >= t - 1) {
        const s = this.offsetOfNode(n);
        return {
          node: n,
          remainder: t - 1,
          nodeStartOffset: s
        };
      } else
        t -= n.piece.length;
      n = n.next();
    }
    return null;
  }
  nodeCharCodeAt(e, t) {
    if (e.piece.lineFeedCnt < 1)
      return -1;
    const n = this._buffers[e.piece.bufferIndex], r = this.offsetInBuffer(e.piece.bufferIndex, e.piece.start) + t;
    return n.buffer.charCodeAt(r);
  }
  offsetOfNode(e) {
    if (!e)
      return 0;
    let t = e.size_left;
    for (; e !== this.root; )
      e.parent.right === e && (t += e.parent.size_left + e.parent.piece.length), e = e.parent;
    return t;
  }
  // #endregion
  // #region CRLF
  shouldCheckCRLF() {
    return !(this._EOLNormalized && this._EOL === `
`);
  }
  startWithLF(e) {
    if (typeof e == "string")
      return e.charCodeAt(0) === 10;
    if (e === Et || e.piece.lineFeedCnt === 0)
      return !1;
    const t = e.piece, n = this._buffers[t.bufferIndex].lineStarts, r = t.start.line, s = n[r] + t.start.column;
    return r === n.length - 1 || n[r + 1] > s + 1 ? !1 : this._buffers[t.bufferIndex].buffer.charCodeAt(s) === 10;
  }
  endWithCR(e) {
    return typeof e == "string" ? e.charCodeAt(e.length - 1) === 13 : e === Et || e.piece.lineFeedCnt === 0 ? !1 : this.nodeCharCodeAt(e, e.piece.length - 1) === 13;
  }
  validateCRLFWithPrevNode(e) {
    if (this.shouldCheckCRLF() && this.startWithLF(e)) {
      const t = e.prev();
      this.endWithCR(t) && this.fixCRLF(t, e);
    }
  }
  validateCRLFWithNextNode(e) {
    if (this.shouldCheckCRLF() && this.endWithCR(e)) {
      const t = e.next();
      this.startWithLF(t) && this.fixCRLF(e, t);
    }
  }
  fixCRLF(e, t) {
    const n = [], r = this._buffers[e.piece.bufferIndex].lineStarts;
    let s;
    e.piece.end.column === 0 ? s = { line: e.piece.end.line - 1, column: r[e.piece.end.line] - r[e.piece.end.line - 1] - 1 } : s = { line: e.piece.end.line, column: e.piece.end.column - 1 };
    const o = e.piece.length - 1, a = e.piece.lineFeedCnt - 1;
    e.piece = new jo(e.piece.bufferIndex, e.piece.start, s, a, o), Qu(this, e, -1, -1), e.piece.length === 0 && n.push(e);
    const l = { line: t.piece.start.line + 1, column: 0 }, c = t.piece.length - 1, d = this.getLineFeedCnt(t.piece.bufferIndex, l, t.piece.end);
    t.piece = new jo(t.piece.bufferIndex, l, t.piece.end, d, c), Qu(this, t, -1, -1), t.piece.length === 0 && n.push(t);
    const u = this.createNewPieces(`\r
`);
    this.rbInsertRight(e, u[0]);
    for (let h = 0; h < n.length; h++)
      nD(this, n[h]);
  }
  adjustCarriageReturnFromNext(e, t) {
    if (this.shouldCheckCRLF() && this.endWithCR(e)) {
      const n = t.next();
      if (this.startWithLF(n)) {
        if (e += `
`, n.piece.length === 1)
          nD(this, n);
        else {
          const r = n.piece, s = { line: r.start.line + 1, column: 0 }, o = r.length - 1, a = this.getLineFeedCnt(r.bufferIndex, s, r.end);
          n.piece = new jo(r.bufferIndex, s, r.end, a, o), Qu(this, n, -1, -1);
        }
        return !0;
      }
    }
    return !1;
  }
  // #endregion
  // #endregion
  // #region Tree operations
  iterate(e, t) {
    if (e === Et)
      return t(Et);
    const n = this.iterate(e.left, t);
    return n && t(e) && this.iterate(e.right, t);
  }
  getNodeContent(e) {
    if (e === Et)
      return "";
    const t = this._buffers[e.piece.bufferIndex], n = e.piece, r = this.offsetInBuffer(n.bufferIndex, n.start), s = this.offsetInBuffer(n.bufferIndex, n.end);
    return t.buffer.substring(r, s);
  }
  getPieceContent(e) {
    const t = this._buffers[e.bufferIndex], n = this.offsetInBuffer(e.bufferIndex, e.start), r = this.offsetInBuffer(e.bufferIndex, e.end);
    return t.buffer.substring(n, r);
  }
  /**
   *      node              node
   *     /  \              /  \
   *    a   b    <----   a    b
   *                         /
   *                        z
   */
  rbInsertRight(e, t) {
    const n = new zF(
      t,
      1
      /* NodeColor.Red */
    );
    if (n.left = Et, n.right = Et, n.parent = Et, n.size_left = 0, n.lf_left = 0, this.root === Et)
      this.root = n, n.color = 0;
    else if (e.right === Et)
      e.right = n, n.parent = e;
    else {
      const s = Pz(e.right);
      s.left = n, n.parent = s;
    }
    return nQ(this, n), n;
  }
  /**
   *      node              node
   *     /  \              /  \
   *    a   b     ---->   a    b
   *                       \
   *                        z
   */
  rbInsertLeft(e, t) {
    const n = new zF(
      t,
      1
      /* NodeColor.Red */
    );
    if (n.left = Et, n.right = Et, n.parent = Et, n.size_left = 0, n.lf_left = 0, this.root === Et)
      this.root = n, n.color = 0;
    else if (e.left === Et)
      e.left = n, n.parent = e;
    else {
      const r = Lge(e.left);
      r.right = n, n.parent = r;
    }
    return nQ(this, n), n;
  }
}
class Wv extends we {
  constructor(e, t, n, r, s, o, a) {
    super(), this._onDidChangeContent = this._register(new pe()), this._BOM = t, this._mightContainNonBasicASCII = !o, this._mightContainRTL = r, this._mightContainUnusualLineTerminators = s, this._pieceTree = new gVe(e, n, a);
  }
  mightContainRTL() {
    return this._mightContainRTL;
  }
  mightContainUnusualLineTerminators() {
    return this._mightContainUnusualLineTerminators;
  }
  resetMightContainUnusualLineTerminators() {
    this._mightContainUnusualLineTerminators = !1;
  }
  mightContainNonBasicASCII() {
    return this._mightContainNonBasicASCII;
  }
  getBOM() {
    return this._BOM;
  }
  getEOL() {
    return this._pieceTree.getEOL();
  }
  createSnapshot(e) {
    return this._pieceTree.createSnapshot(e ? this._BOM : "");
  }
  getOffsetAt(e, t) {
    return this._pieceTree.getOffsetAt(e, t);
  }
  getPositionAt(e) {
    return this._pieceTree.getPositionAt(e);
  }
  getRangeAt(e, t) {
    const n = e + t, r = this.getPositionAt(e), s = this.getPositionAt(n);
    return new V(r.lineNumber, r.column, s.lineNumber, s.column);
  }
  getValueInRange(e, t = 0) {
    if (e.isEmpty())
      return "";
    const n = this._getEndOfLine(t);
    return this._pieceTree.getValueInRange(e, n);
  }
  getValueLengthInRange(e, t = 0) {
    if (e.isEmpty())
      return 0;
    if (e.startLineNumber === e.endLineNumber)
      return e.endColumn - e.startColumn;
    const n = this.getOffsetAt(e.startLineNumber, e.startColumn), r = this.getOffsetAt(e.endLineNumber, e.endColumn);
    let s = 0;
    const o = this._getEndOfLine(t), a = this.getEOL();
    if (o.length !== a.length) {
      const l = o.length - a.length, c = e.endLineNumber - e.startLineNumber;
      s = l * c;
    }
    return r - n + s;
  }
  getCharacterCountInRange(e, t = 0) {
    if (this._mightContainNonBasicASCII) {
      let n = 0;
      const r = e.startLineNumber, s = e.endLineNumber;
      for (let o = r; o <= s; o++) {
        const a = this.getLineContent(o), l = o === r ? e.startColumn - 1 : 0, c = o === s ? e.endColumn - 1 : a.length;
        for (let d = l; d < c; d++)
          kr(a.charCodeAt(d)) ? (n = n + 1, d = d + 1) : n = n + 1;
      }
      return n += this._getEndOfLine(t).length * (s - r), n;
    }
    return this.getValueLengthInRange(e, t);
  }
  getLength() {
    return this._pieceTree.getLength();
  }
  getLineCount() {
    return this._pieceTree.getLineCount();
  }
  getLinesContent() {
    return this._pieceTree.getLinesContent();
  }
  getLineContent(e) {
    return this._pieceTree.getLineContent(e);
  }
  getLineCharCode(e, t) {
    return this._pieceTree.getLineCharCode(e, t);
  }
  getLineLength(e) {
    return this._pieceTree.getLineLength(e);
  }
  getLineFirstNonWhitespaceColumn(e) {
    const t = Js(this.getLineContent(e));
    return t === -1 ? 0 : t + 1;
  }
  getLineLastNonWhitespaceColumn(e) {
    const t = Jc(this.getLineContent(e));
    return t === -1 ? 0 : t + 2;
  }
  _getEndOfLine(e) {
    switch (e) {
      case 1:
        return `
`;
      case 2:
        return `\r
`;
      case 0:
        return this.getEOL();
      default:
        throw new Error("Unknown EOL preference");
    }
  }
  setEOL(e) {
    this._pieceTree.setEOL(e);
  }
  applyEdits(e, t, n) {
    let r = this._mightContainRTL, s = this._mightContainUnusualLineTerminators, o = this._mightContainNonBasicASCII, a = !0, l = [];
    for (let p = 0; p < e.length; p++) {
      const m = e[p];
      a && m._isTracked && (a = !1);
      const _ = m.range;
      if (m.text) {
        let x = !0;
        o || (x = !yS(m.text), o = x), !r && x && (r = u_(m.text)), !s && x && (s = phe(m.text));
      }
      let b = "", w = 0, y = 0, S = 0;
      if (m.text) {
        let x;
        [w, y, S, x] = Wg(m.text);
        const D = this.getEOL();
        x === 0 || x === (D === `\r
` ? 2 : 1) ? b = m.text : b = m.text.replace(/\r\n|\r|\n/g, D);
      }
      l[p] = {
        sortIndex: p,
        identifier: m.identifier || null,
        range: _,
        rangeOffset: this.getOffsetAt(_.startLineNumber, _.startColumn),
        rangeLength: this.getValueLengthInRange(_),
        text: b,
        eolCount: w,
        firstLineLength: y,
        lastLineLength: S,
        forceMoveMarkers: !!m.forceMoveMarkers,
        isAutoWhitespaceEdit: m.isAutoWhitespaceEdit || !1
      };
    }
    l.sort(Wv._sortOpsAscending);
    let c = !1;
    for (let p = 0, m = l.length - 1; p < m; p++) {
      const _ = l[p].range.getEndPosition(), b = l[p + 1].range.getStartPosition();
      if (b.isBeforeOrEqual(_)) {
        if (b.isBefore(_))
          throw new Error("Overlapping ranges are not allowed!");
        c = !0;
      }
    }
    a && (l = this._reduceOperations(l));
    const d = n || t ? Wv._getInverseEditRanges(l) : [], u = [];
    if (t)
      for (let p = 0; p < l.length; p++) {
        const m = l[p], _ = d[p];
        if (m.isAutoWhitespaceEdit && m.range.isEmpty())
          for (let b = _.startLineNumber; b <= _.endLineNumber; b++) {
            let w = "";
            b === _.startLineNumber && (w = this.getLineContent(m.range.startLineNumber), Js(w) !== -1) || u.push({ lineNumber: b, oldContent: w });
          }
      }
    let h = null;
    if (n) {
      let p = 0;
      h = [];
      for (let m = 0; m < l.length; m++) {
        const _ = l[m], b = d[m], w = this.getValueInRange(_.range), y = _.rangeOffset + p;
        p += _.text.length - w.length, h[m] = {
          sortIndex: _.sortIndex,
          identifier: _.identifier,
          range: b,
          text: w,
          textChange: new _s(_.rangeOffset, w, y, _.text)
        };
      }
      c || h.sort((m, _) => m.sortIndex - _.sortIndex);
    }
    this._mightContainRTL = r, this._mightContainUnusualLineTerminators = s, this._mightContainNonBasicASCII = o;
    const f = this._doApplyEdits(l);
    let g = null;
    if (t && u.length > 0) {
      u.sort((p, m) => m.lineNumber - p.lineNumber), g = [];
      for (let p = 0, m = u.length; p < m; p++) {
        const _ = u[p].lineNumber;
        if (p > 0 && u[p - 1].lineNumber === _)
          continue;
        const b = u[p].oldContent, w = this.getLineContent(_);
        w.length === 0 || w === b || Js(w) !== -1 || g.push(_);
      }
    }
    return this._onDidChangeContent.fire(), new yPe(h, f, g);
  }
  /**
   * Transform operations such that they represent the same logic edit,
   * but that they also do not cause OOM crashes.
   */
  _reduceOperations(e) {
    return e.length < 1e3 ? e : [this._toSingleEditOperation(e)];
  }
  _toSingleEditOperation(e) {
    let t = !1;
    const n = e[0].range, r = e[e.length - 1].range, s = new V(n.startLineNumber, n.startColumn, r.endLineNumber, r.endColumn);
    let o = n.startLineNumber, a = n.startColumn;
    const l = [];
    for (let f = 0, g = e.length; f < g; f++) {
      const p = e[f], m = p.range;
      t = t || p.forceMoveMarkers, l.push(this.getValueInRange(new V(o, a, m.startLineNumber, m.startColumn))), p.text.length > 0 && l.push(p.text), o = m.endLineNumber, a = m.endColumn;
    }
    const c = l.join(""), [d, u, h] = Wg(c);
    return {
      sortIndex: 0,
      identifier: e[0].identifier,
      range: s,
      rangeOffset: this.getOffsetAt(s.startLineNumber, s.startColumn),
      rangeLength: this.getValueLengthInRange(
        s,
        0
        /* EndOfLinePreference.TextDefined */
      ),
      text: c,
      eolCount: d,
      firstLineLength: u,
      lastLineLength: h,
      forceMoveMarkers: t,
      isAutoWhitespaceEdit: !1
    };
  }
  _doApplyEdits(e) {
    e.sort(Wv._sortOpsDescending);
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const r = e[n], s = r.range.startLineNumber, o = r.range.startColumn, a = r.range.endLineNumber, l = r.range.endColumn;
      if (s === a && o === l && r.text.length === 0)
        continue;
      r.text ? (this._pieceTree.delete(r.rangeOffset, r.rangeLength), this._pieceTree.insert(r.rangeOffset, r.text, !0)) : this._pieceTree.delete(r.rangeOffset, r.rangeLength);
      const c = new V(s, o, a, l);
      t.push({
        range: c,
        rangeLength: r.rangeLength,
        text: r.text,
        rangeOffset: r.rangeOffset,
        forceMoveMarkers: r.forceMoveMarkers
      });
    }
    return t;
  }
  findMatchesLineByLine(e, t, n, r) {
    return this._pieceTree.findMatchesLineByLine(e, t, n, r);
  }
  /**
   * Assumes `operations` are validated and sorted ascending
   */
  static _getInverseEditRanges(e) {
    const t = [];
    let n = 0, r = 0, s = null;
    for (let o = 0, a = e.length; o < a; o++) {
      const l = e[o];
      let c, d;
      s ? s.range.endLineNumber === l.range.startLineNumber ? (c = n, d = r + (l.range.startColumn - s.range.endColumn)) : (c = n + (l.range.startLineNumber - s.range.endLineNumber), d = l.range.startColumn) : (c = l.range.startLineNumber, d = l.range.startColumn);
      let u;
      if (l.text.length > 0) {
        const h = l.eolCount + 1;
        h === 1 ? u = new V(c, d, c, d + l.firstLineLength) : u = new V(c, d, c + h - 1, l.lastLineLength + 1);
      } else
        u = new V(c, d, c, d);
      n = u.endLineNumber, r = u.endColumn, t.push(u), s = l;
    }
    return t;
  }
  static _sortOpsAscending(e, t) {
    const n = V.compareRangesUsingEnds(e.range, t.range);
    return n === 0 ? e.sortIndex - t.sortIndex : n;
  }
  static _sortOpsDescending(e, t) {
    const n = V.compareRangesUsingEnds(e.range, t.range);
    return n === 0 ? t.sortIndex - e.sortIndex : -n;
  }
}
class pVe {
  constructor(e, t, n, r, s, o, a, l, c) {
    this._chunks = e, this._bom = t, this._cr = n, this._lf = r, this._crlf = s, this._containsRTL = o, this._containsUnusualLineTerminators = a, this._isBasicASCII = l, this._normalizeEOL = c;
  }
  _getEOL(e) {
    const t = this._cr + this._lf + this._crlf, n = this._cr + this._crlf;
    return t === 0 ? e === 1 ? `
` : `\r
` : n > t / 2 ? `\r
` : `
`;
  }
  create(e) {
    const t = this._getEOL(e), n = this._chunks;
    if (this._normalizeEOL && (t === `\r
` && (this._cr > 0 || this._lf > 0) || t === `
` && (this._cr > 0 || this._crlf > 0)))
      for (let s = 0, o = n.length; s < o; s++) {
        const a = n[s].buffer.replace(/\r\n|\r|\n/g, t), l = nh(a);
        n[s] = new em(a, l);
      }
    const r = new Wv(n, this._bom, t, this._containsRTL, this._containsUnusualLineTerminators, this._isBasicASCII, this._normalizeEOL);
    return { textBuffer: r, disposable: r };
  }
}
class Age {
  constructor() {
    this.chunks = [], this.BOM = "", this._hasPreviousChar = !1, this._previousChar = 0, this._tmpLineStarts = [], this.cr = 0, this.lf = 0, this.crlf = 0, this.containsRTL = !1, this.containsUnusualLineTerminators = !1, this.isBasicASCII = !0;
  }
  acceptChunk(e) {
    if (e.length === 0)
      return;
    this.chunks.length === 0 && zj(e) && (this.BOM = wNe, e = e.substr(1));
    const t = e.charCodeAt(e.length - 1);
    t === 13 || t >= 55296 && t <= 56319 ? (this._acceptChunk1(e.substr(0, e.length - 1), !1), this._hasPreviousChar = !0, this._previousChar = t) : (this._acceptChunk1(e, !1), this._hasPreviousChar = !1, this._previousChar = t);
  }
  _acceptChunk1(e, t) {
    !t && e.length === 0 || (this._hasPreviousChar ? this._acceptChunk2(String.fromCharCode(this._previousChar) + e) : this._acceptChunk2(e));
  }
  _acceptChunk2(e) {
    const t = uVe(this._tmpLineStarts, e);
    this.chunks.push(new em(e, t.lineStarts)), this.cr += t.cr, this.lf += t.lf, this.crlf += t.crlf, t.isBasicASCII || (this.isBasicASCII = !1, this.containsRTL || (this.containsRTL = u_(e)), this.containsUnusualLineTerminators || (this.containsUnusualLineTerminators = phe(e)));
  }
  finish(e = !0) {
    return this._finish(), new pVe(this.chunks, this.BOM, this.cr, this.lf, this.crlf, this.containsRTL, this.containsUnusualLineTerminators, this.isBasicASCII, e);
  }
  _finish() {
    if (this.chunks.length === 0 && this._acceptChunk1("", !0), this._hasPreviousChar) {
      this._hasPreviousChar = !1;
      const e = this.chunks[this.chunks.length - 1];
      e.buffer += String.fromCharCode(this._previousChar);
      const t = nh(e.buffer);
      e.lineStarts = t, this._previousChar === 13 && this.cr++;
    }
  }
}
class mVe {
  constructor(e) {
    this._default = e, this._store = [];
  }
  get(e) {
    return e < this._store.length ? this._store[e] : this._default;
  }
  set(e, t) {
    for (; e >= this._store.length; )
      this._store[this._store.length] = this._default;
    this._store[e] = t;
  }
  replace(e, t, n) {
    if (e >= this._store.length)
      return;
    if (t === 0) {
      this.insert(e, n);
      return;
    } else if (n === 0) {
      this.delete(e, t);
      return;
    }
    const r = this._store.slice(0, e), s = this._store.slice(e + t), o = vVe(n, this._default);
    this._store = r.concat(o, s);
  }
  delete(e, t) {
    t === 0 || e >= this._store.length || this._store.splice(e, t);
  }
  insert(e, t) {
    if (t === 0 || e >= this._store.length)
      return;
    const n = [];
    for (let r = 0; r < t; r++)
      n[r] = this._default;
    this._store = HA(this._store, e, n);
  }
}
function vVe(i, e) {
  const t = [];
  for (let n = 0; n < i; n++)
    t[n] = e;
  return t;
}
class _Ve {
  /**
   * (Inclusive) start line number for these tokens.
   */
  get startLineNumber() {
    return this._startLineNumber;
  }
  /**
   * (Inclusive) end line number for these tokens.
   */
  get endLineNumber() {
    return this._startLineNumber + this._tokens.length - 1;
  }
  constructor(e, t) {
    this._startLineNumber = e, this._tokens = t;
  }
  /**
   * @see {@link _tokens}
   */
  getLineTokens(e) {
    return this._tokens[e - this._startLineNumber];
  }
  appendLineTokens(e) {
    this._tokens.push(e);
  }
}
class UF {
  constructor() {
    this._tokens = [];
  }
  add(e, t) {
    if (this._tokens.length > 0) {
      const n = this._tokens[this._tokens.length - 1];
      if (n.endLineNumber + 1 === e) {
        n.appendLineTokens(t);
        return;
      }
    }
    this._tokens.push(new _Ve(e, [t]));
  }
  finalize() {
    return this._tokens;
  }
}
class bVe {
  constructor(e, t) {
    this.tokenizationSupport = t, this.initialState = this.tokenizationSupport.getInitialState(), this.store = new GF(e);
  }
  getStartState(e) {
    return this.store.getStartState(e, this.initialState);
  }
  getFirstInvalidLine() {
    return this.store.getFirstInvalidLine(this.initialState);
  }
}
class CVe extends bVe {
  constructor(e, t, n, r) {
    super(e, t), this._textModel = n, this._languageIdCodec = r;
  }
  updateTokensUntilLine(e, t) {
    const n = this._textModel.getLanguageId();
    for (; ; ) {
      const r = this.getFirstInvalidLine();
      if (!r || r.lineNumber > t)
        break;
      const s = this._textModel.getLineContent(r.lineNumber), o = l2(this._languageIdCodec, n, this.tokenizationSupport, s, !0, r.startState);
      e.add(r.lineNumber, o.tokens), this.store.setEndState(r.lineNumber, o.endState);
    }
  }
  /** assumes state is up to date */
  getTokenTypeIfInsertingCharacter(e, t) {
    const n = this.getStartState(e.lineNumber);
    if (!n)
      return 0;
    const r = this._textModel.getLanguageId(), s = this._textModel.getLineContent(e.lineNumber), o = s.substring(0, e.column - 1) + t + s.substring(e.column - 1), a = l2(this._languageIdCodec, r, this.tokenizationSupport, o, !0, n), l = new Tr(a.tokens, o, this._languageIdCodec);
    if (l.getCount() === 0)
      return 0;
    const c = l.findTokenIndexAtOffset(e.column - 1);
    return l.getStandardTokenType(c);
  }
  /** assumes state is up to date */
  tokenizeLineWithEdit(e, t, n) {
    const r = e.lineNumber, s = e.column, o = this.getStartState(r);
    if (!o)
      return null;
    const a = this._textModel.getLineContent(r), l = a.substring(0, s - 1) + n + a.substring(s - 1 + t), c = this._textModel.getLanguageIdAtPosition(r, 0), d = l2(this._languageIdCodec, c, this.tokenizationSupport, l, !0, o);
    return new Tr(d.tokens, l, this._languageIdCodec);
  }
  isCheapToTokenize(e) {
    const t = this.store.getFirstInvalidEndStateLineNumberOrMax();
    return e < t || e === t && this._textModel.getLineLength(e) < 2048;
  }
  /**
   * The result is not cached.
   */
  tokenizeHeuristically(e, t, n) {
    if (n <= this.store.getFirstInvalidEndStateLineNumberOrMax())
      return { heuristicTokens: !1 };
    if (t <= this.store.getFirstInvalidEndStateLineNumberOrMax())
      return this.updateTokensUntilLine(e, n), { heuristicTokens: !1 };
    let r = this.guessStartState(t);
    const s = this._textModel.getLanguageId();
    for (let o = t; o <= n; o++) {
      const a = this._textModel.getLineContent(o), l = l2(this._languageIdCodec, s, this.tokenizationSupport, a, !0, r);
      e.add(o, l.tokens), r = l.endState;
    }
    return { heuristicTokens: !0 };
  }
  guessStartState(e) {
    let t = this._textModel.getLineFirstNonWhitespaceColumn(e);
    const n = [];
    let r = null;
    for (let a = e - 1; t > 1 && a >= 1; a--) {
      const l = this._textModel.getLineFirstNonWhitespaceColumn(a);
      if (l !== 0 && l < t && (n.push(this._textModel.getLineContent(a)), t = l, r = this.getStartState(a), r))
        break;
    }
    r || (r = this.tokenizationSupport.getInitialState()), n.reverse();
    const s = this._textModel.getLanguageId();
    let o = r;
    for (const a of n)
      o = l2(this._languageIdCodec, s, this.tokenizationSupport, a, !1, o).endState;
    return o;
  }
}
class GF {
  constructor(e) {
    this.lineCount = e, this._tokenizationStateStore = new yVe(), this._invalidEndStatesLineNumbers = new wVe(), this._invalidEndStatesLineNumbers.addRange(new zt(1, e + 1));
  }
  getEndState(e) {
    return this._tokenizationStateStore.getEndState(e);
  }
  /**
   * @returns if the end state has changed.
   */
  setEndState(e, t) {
    if (!t)
      throw new gr("Cannot set null/undefined state");
    this._invalidEndStatesLineNumbers.delete(e);
    const n = this._tokenizationStateStore.setEndState(e, t);
    return n && e < this.lineCount && this._invalidEndStatesLineNumbers.addRange(new zt(e + 1, e + 2)), n;
  }
  acceptChange(e, t) {
    this.lineCount += t - e.length, this._tokenizationStateStore.acceptChange(e, t), this._invalidEndStatesLineNumbers.addRangeAndResize(new zt(e.startLineNumber, e.endLineNumberExclusive), t);
  }
  acceptChanges(e) {
    for (const t of e) {
      const [n] = Wg(t.text);
      this.acceptChange(new Qt(t.range.startLineNumber, t.range.endLineNumber + 1), n + 1);
    }
  }
  invalidateEndStateRange(e) {
    this._invalidEndStatesLineNumbers.addRange(new zt(e.startLineNumber, e.endLineNumberExclusive));
  }
  getFirstInvalidEndStateLineNumber() {
    return this._invalidEndStatesLineNumbers.min;
  }
  getFirstInvalidEndStateLineNumberOrMax() {
    return this.getFirstInvalidEndStateLineNumber() || Number.MAX_SAFE_INTEGER;
  }
  allStatesValid() {
    return this._invalidEndStatesLineNumbers.min === null;
  }
  getStartState(e, t) {
    return e === 1 ? t : this.getEndState(e - 1);
  }
  getFirstInvalidLine(e) {
    const t = this.getFirstInvalidEndStateLineNumber();
    if (t === null)
      return null;
    const n = this.getStartState(t, e);
    if (!n)
      throw new gr("Start state must be defined");
    return { lineNumber: t, startState: n };
  }
}
class yVe {
  constructor() {
    this._lineEndStates = new mVe(null);
  }
  getEndState(e) {
    return this._lineEndStates.get(e);
  }
  setEndState(e, t) {
    const n = this._lineEndStates.get(e);
    return n && n.equals(t) ? !1 : (this._lineEndStates.set(e, t), !0);
  }
  acceptChange(e, t) {
    let n = e.length;
    t > 0 && n > 0 && (n--, t--), this._lineEndStates.replace(e.startLineNumber, n, t);
  }
}
class wVe {
  constructor() {
    this._ranges = [];
  }
  get min() {
    return this._ranges.length === 0 ? null : this._ranges[0].start;
  }
  delete(e) {
    const t = this._ranges.findIndex((n) => n.contains(e));
    if (t !== -1) {
      const n = this._ranges[t];
      n.start === e ? n.endExclusive === e + 1 ? this._ranges.splice(t, 1) : this._ranges[t] = new zt(e + 1, n.endExclusive) : n.endExclusive === e + 1 ? this._ranges[t] = new zt(n.start, e) : this._ranges.splice(t, 1, new zt(n.start, e), new zt(e + 1, n.endExclusive));
    }
  }
  addRange(e) {
    zt.addRange(e, this._ranges);
  }
  addRangeAndResize(e, t) {
    let n = 0;
    for (; !(n >= this._ranges.length || e.start <= this._ranges[n].endExclusive); )
      n++;
    let r = n;
    for (; !(r >= this._ranges.length || e.endExclusive < this._ranges[r].start); )
      r++;
    const s = t - e.length;
    for (let o = r; o < this._ranges.length; o++)
      this._ranges[o] = this._ranges[o].delta(s);
    if (n === r) {
      const o = new zt(e.start, e.start + t);
      o.isEmpty || this._ranges.splice(n, 0, o);
    } else {
      const o = Math.min(e.start, this._ranges[n].start), a = Math.max(e.endExclusive, this._ranges[r - 1].endExclusive), l = new zt(o, a + s);
      l.isEmpty ? this._ranges.splice(n, r - n) : this._ranges.splice(n, r - n, l);
    }
  }
  toString() {
    return this._ranges.map((e) => e.toString()).join(" + ");
  }
}
function l2(i, e, t, n, r, s) {
  let o = null;
  if (t)
    try {
      o = t.tokenizeEncoded(n, r, s.clone());
    } catch (a) {
      It(a);
    }
  return o || (o = f4(i.encodeLanguageId(e), s)), Tr.convertToEndOffset(o.tokens, n.length), o;
}
class SVe {
  constructor(e, t) {
    this._tokenizerWithStateStore = e, this._backgroundTokenStore = t, this._isDisposed = !1, this._isScheduled = !1;
  }
  dispose() {
    this._isDisposed = !0;
  }
  handleChanges() {
    this._beginBackgroundTokenization();
  }
  _beginBackgroundTokenization() {
    this._isScheduled || !this._tokenizerWithStateStore._textModel.isAttachedToEditor() || !this._hasLinesToTokenize() || (this._isScheduled = !0, xh((e) => {
      this._isScheduled = !1, this._backgroundTokenizeWithDeadline(e);
    }));
  }
  /**
   * Tokenize until the deadline occurs, but try to yield every 1-2ms.
   */
  _backgroundTokenizeWithDeadline(e) {
    const t = Date.now() + e.timeRemaining(), n = () => {
      this._isDisposed || !this._tokenizerWithStateStore._textModel.isAttachedToEditor() || !this._hasLinesToTokenize() || (this._backgroundTokenizeForAtLeast1ms(), Date.now() < t ? Hue(n) : this._beginBackgroundTokenization());
    };
    n();
  }
  /**
   * Tokenize for at least 1ms.
   */
  _backgroundTokenizeForAtLeast1ms() {
    const e = this._tokenizerWithStateStore._textModel.getLineCount(), t = new UF(), n = Vs.create(!1);
    do
      if (n.elapsed() > 1 || this._tokenizeOneInvalidLine(t) >= e)
        break;
    while (this._hasLinesToTokenize());
    this._backgroundTokenStore.setTokens(t.finalize()), this.checkFinished();
  }
  _hasLinesToTokenize() {
    return this._tokenizerWithStateStore ? !this._tokenizerWithStateStore.store.allStatesValid() : !1;
  }
  _tokenizeOneInvalidLine(e) {
    var t;
    const n = (t = this._tokenizerWithStateStore) === null || t === void 0 ? void 0 : t.getFirstInvalidLine();
    return n ? (this._tokenizerWithStateStore.updateTokensUntilLine(e, n.lineNumber), n.lineNumber) : this._tokenizerWithStateStore._textModel.getLineCount() + 1;
  }
  checkFinished() {
    this._isDisposed || this._tokenizerWithStateStore.store.allStatesValid() && this._backgroundTokenStore.backgroundTokenizationFinished();
  }
  requestTokens(e, t) {
    this._tokenizerWithStateStore.store.invalidateEndStateRange(new Qt(e, t));
  }
}
const ih = new Uint32Array(0).buffer;
class Td {
  static deleteBeginning(e, t) {
    return e === null || e === ih ? e : Td.delete(e, 0, t);
  }
  static deleteEnding(e, t) {
    if (e === null || e === ih)
      return e;
    const n = bh(e), r = n[n.length - 2];
    return Td.delete(e, t, r);
  }
  static delete(e, t, n) {
    if (e === null || e === ih || t === n)
      return e;
    const r = bh(e), s = r.length >>> 1;
    if (t === 0 && r[r.length - 2] === n)
      return ih;
    const o = Tr.findIndexInTokensArray(r, t), a = o > 0 ? r[o - 1 << 1] : 0, l = r[o << 1];
    if (n < l) {
      const f = n - t;
      for (let g = o; g < s; g++)
        r[g << 1] -= f;
      return e;
    }
    let c, d;
    a !== t ? (r[o << 1] = t, c = o + 1 << 1, d = t) : (c = o << 1, d = a);
    const u = n - t;
    for (let f = o + 1; f < s; f++) {
      const g = r[f << 1] - u;
      g > d && (r[c++] = g, r[c++] = r[(f << 1) + 1], d = g);
    }
    if (c === r.length)
      return e;
    const h = new Uint32Array(c);
    return h.set(r.subarray(0, c), 0), h.buffer;
  }
  static append(e, t) {
    if (t === ih)
      return e;
    if (e === ih)
      return t;
    if (e === null)
      return e;
    if (t === null)
      return null;
    const n = bh(e), r = bh(t), s = r.length >>> 1, o = new Uint32Array(n.length + r.length);
    o.set(n, 0);
    let a = n.length;
    const l = n[n.length - 2];
    for (let c = 0; c < s; c++)
      o[a++] = r[c << 1] + l, o[a++] = r[(c << 1) + 1];
    return o.buffer;
  }
  static insert(e, t, n) {
    if (e === null || e === ih)
      return e;
    const r = bh(e), s = r.length >>> 1;
    let o = Tr.findIndexInTokensArray(r, t);
    o > 0 && r[o - 1 << 1] === t && o--;
    for (let a = o; a < s; a++)
      r[a << 1] += n;
    return e;
  }
}
function bh(i) {
  return i instanceof Uint32Array ? i : new Uint32Array(i);
}
class tw {
  constructor(e) {
    this._lineTokens = [], this._len = 0, this._languageIdCodec = e;
  }
  flush() {
    this._lineTokens = [], this._len = 0;
  }
  get hasTokens() {
    return this._lineTokens.length > 0;
  }
  getTokens(e, t, n) {
    let r = null;
    if (t < this._len && (r = this._lineTokens[t]), r !== null && r !== ih)
      return new Tr(bh(r), n, this._languageIdCodec);
    const s = new Uint32Array(2);
    return s[0] = n.length, s[1] = iQ(this._languageIdCodec.encodeLanguageId(e)), new Tr(s, n, this._languageIdCodec);
  }
  static _massageTokens(e, t, n) {
    const r = n ? bh(n) : null;
    if (t === 0) {
      let s = !1;
      if (r && r.length > 1 && (s = Cs.getLanguageId(r[1]) !== e), !s)
        return ih;
    }
    if (!r || r.length === 0) {
      const s = new Uint32Array(2);
      return s[0] = t, s[1] = iQ(e), s.buffer;
    }
    return r[r.length - 2] = t, r.byteOffset === 0 && r.byteLength === r.buffer.byteLength ? r.buffer : r;
  }
  _ensureLine(e) {
    for (; e >= this._len; )
      this._lineTokens[this._len] = null, this._len++;
  }
  _deleteLines(e, t) {
    t !== 0 && (e + t > this._len && (t = this._len - e), this._lineTokens.splice(e, t), this._len -= t);
  }
  _insertLines(e, t) {
    if (t === 0)
      return;
    const n = [];
    for (let r = 0; r < t; r++)
      n[r] = null;
    this._lineTokens = HA(this._lineTokens, e, n), this._len += t;
  }
  setTokens(e, t, n, r, s) {
    const o = tw._massageTokens(this._languageIdCodec.encodeLanguageId(e), n, r);
    this._ensureLine(t);
    const a = this._lineTokens[t];
    return this._lineTokens[t] = o, s ? !tw._equals(a, o) : !1;
  }
  static _equals(e, t) {
    if (!e || !t)
      return !e && !t;
    const n = bh(e), r = bh(t);
    if (n.length !== r.length)
      return !1;
    for (let s = 0, o = n.length; s < o; s++)
      if (n[s] !== r[s])
        return !1;
    return !0;
  }
  //#region Editing
  acceptEdit(e, t, n) {
    this._acceptDeleteRange(e), this._acceptInsertText(new ve(e.startLineNumber, e.startColumn), t, n);
  }
  _acceptDeleteRange(e) {
    const t = e.startLineNumber - 1;
    if (t >= this._len)
      return;
    if (e.startLineNumber === e.endLineNumber) {
      if (e.startColumn === e.endColumn)
        return;
      this._lineTokens[t] = Td.delete(this._lineTokens[t], e.startColumn - 1, e.endColumn - 1);
      return;
    }
    this._lineTokens[t] = Td.deleteEnding(this._lineTokens[t], e.startColumn - 1);
    const n = e.endLineNumber - 1;
    let r = null;
    n < this._len && (r = Td.deleteBeginning(this._lineTokens[n], e.endColumn - 1)), this._lineTokens[t] = Td.append(this._lineTokens[t], r), this._deleteLines(e.startLineNumber, e.endLineNumber - e.startLineNumber);
  }
  _acceptInsertText(e, t, n) {
    if (t === 0 && n === 0)
      return;
    const r = e.lineNumber - 1;
    if (!(r >= this._len)) {
      if (t === 0) {
        this._lineTokens[r] = Td.insert(this._lineTokens[r], e.column - 1, n);
        return;
      }
      this._lineTokens[r] = Td.deleteEnding(this._lineTokens[r], e.column - 1), this._lineTokens[r] = Td.insert(this._lineTokens[r], e.column - 1, n), this._insertLines(e.lineNumber, t);
    }
  }
  //#endregion
  setMultilineTokens(e, t) {
    if (e.length === 0)
      return { changes: [] };
    const n = [];
    for (let r = 0, s = e.length; r < s; r++) {
      const o = e[r];
      let a = 0, l = 0, c = !1;
      for (let d = o.startLineNumber; d <= o.endLineNumber; d++)
        c ? (this.setTokens(t.getLanguageId(), d - 1, t.getLineLength(d), o.getLineTokens(d), !1), l = d) : this.setTokens(t.getLanguageId(), d - 1, t.getLineLength(d), o.getLineTokens(d), !0) && (c = !0, a = d, l = d);
      c && n.push({ fromLineNumber: a, toLineNumber: l });
    }
    return { changes: n };
  }
}
function iQ(i) {
  return (i << 0 | 0 | 0 | 32768 | 2 << 24 | 1024) >>> 0;
}
class Rz {
  constructor(e) {
    this._pieces = [], this._isComplete = !1, this._languageIdCodec = e;
  }
  flush() {
    this._pieces = [], this._isComplete = !1;
  }
  isEmpty() {
    return this._pieces.length === 0;
  }
  set(e, t) {
    this._pieces = e || [], this._isComplete = t;
  }
  setPartial(e, t) {
    let n = e;
    if (t.length > 0) {
      const s = t[0].getRange(), o = t[t.length - 1].getRange();
      if (!s || !o)
        return e;
      n = e.plusRange(s).plusRange(o);
    }
    let r = null;
    for (let s = 0, o = this._pieces.length; s < o; s++) {
      const a = this._pieces[s];
      if (a.endLineNumber < n.startLineNumber)
        continue;
      if (a.startLineNumber > n.endLineNumber) {
        r = r || { index: s };
        break;
      }
      if (a.removeTokens(n), a.isEmpty()) {
        this._pieces.splice(s, 1), s--, o--;
        continue;
      }
      if (a.endLineNumber < n.startLineNumber)
        continue;
      if (a.startLineNumber > n.endLineNumber) {
        r = r || { index: s };
        continue;
      }
      const [l, c] = a.split(n);
      if (l.isEmpty()) {
        r = r || { index: s };
        continue;
      }
      c.isEmpty() || (this._pieces.splice(s, 1, l, c), s++, o++, r = r || { index: s });
    }
    return r = r || { index: this._pieces.length }, t.length > 0 && (this._pieces = HA(this._pieces, r.index, t)), n;
  }
  isComplete() {
    return this._isComplete;
  }
  addSparseTokens(e, t) {
    if (t.getLineContent().length === 0)
      return t;
    const n = this._pieces;
    if (n.length === 0)
      return t;
    const r = Rz._findFirstPieceWithLine(n, e), s = n[r].getLineTokens(e);
    if (!s)
      return t;
    const o = t.getCount(), a = s.getCount();
    let l = 0;
    const c = [];
    let d = 0, u = 0;
    const h = (f, g) => {
      f !== u && (u = f, c[d++] = f, c[d++] = g);
    };
    for (let f = 0; f < a; f++) {
      const g = s.getStartCharacter(f), p = s.getEndCharacter(f), m = s.getMetadata(f), _ = ((m & 1 ? 2048 : 0) | (m & 2 ? 4096 : 0) | (m & 4 ? 8192 : 0) | (m & 8 ? 16384 : 0) | (m & 16 ? 16744448 : 0) | (m & 32 ? 4278190080 : 0)) >>> 0, b = ~_ >>> 0;
      for (; l < o && t.getEndOffset(l) <= g; )
        h(t.getEndOffset(l), t.getMetadata(l)), l++;
      for (l < o && t.getStartOffset(l) < g && h(g, t.getMetadata(l)); l < o && t.getEndOffset(l) < p; )
        h(t.getEndOffset(l), t.getMetadata(l) & b | m & _), l++;
      if (l < o)
        h(p, t.getMetadata(l) & b | m & _), t.getEndOffset(l) === p && l++;
      else {
        const w = Math.min(Math.max(0, l - 1), o - 1);
        h(p, t.getMetadata(w) & b | m & _);
      }
    }
    for (; l < o; )
      h(t.getEndOffset(l), t.getMetadata(l)), l++;
    return new Tr(new Uint32Array(c), t.getLineContent(), this._languageIdCodec);
  }
  static _findFirstPieceWithLine(e, t) {
    let n = 0, r = e.length - 1;
    for (; n < r; ) {
      let s = n + Math.floor((r - n) / 2);
      if (e[s].endLineNumber < t)
        n = s + 1;
      else if (e[s].startLineNumber > t)
        r = s - 1;
      else {
        for (; s > n && e[s - 1].startLineNumber <= t && t <= e[s - 1].endLineNumber; )
          s--;
        return s;
      }
    }
    return n;
  }
  acceptEdit(e, t, n, r, s) {
    for (const o of this._pieces)
      o.acceptEdit(e, t, n, r, s);
  }
}
class wL extends age {
  constructor(e, t, n, r, s, o) {
    super(), this._languageService = e, this._languageConfigurationService = t, this._textModel = n, this._bracketPairsTextModelPart = r, this._languageId = s, this._attachedViews = o, this._semanticTokens = new Rz(this._languageService.languageIdCodec), this._onDidChangeLanguage = this._register(new pe()), this.onDidChangeLanguage = this._onDidChangeLanguage.event, this._onDidChangeLanguageConfiguration = this._register(new pe()), this.onDidChangeLanguageConfiguration = this._onDidChangeLanguageConfiguration.event, this._onDidChangeTokens = this._register(new pe()), this.onDidChangeTokens = this._onDidChangeTokens.event, this.grammarTokens = this._register(new xVe(this._languageService.languageIdCodec, this._textModel, () => this._languageId, this._attachedViews)), this._register(this._languageConfigurationService.onDidChange((a) => {
      a.affects(this._languageId) && this._onDidChangeLanguageConfiguration.fire({});
    })), this._register(this.grammarTokens.onDidChangeTokens((a) => {
      this._emitModelTokensChangedEvent(a);
    })), this._register(this.grammarTokens.onDidChangeBackgroundTokenizationState((a) => {
      this._bracketPairsTextModelPart.handleDidChangeBackgroundTokenizationState();
    }));
  }
  handleDidChangeContent(e) {
    if (e.isFlush)
      this._semanticTokens.flush();
    else if (!e.isEolChange)
      for (const t of e.changes) {
        const [n, r, s] = Wg(t.text);
        this._semanticTokens.acceptEdit(
          t.range,
          n,
          r,
          s,
          t.text.length > 0 ? t.text.charCodeAt(0) : 0
          /* CharCode.Null */
        );
      }
    this.grammarTokens.handleDidChangeContent(e);
  }
  handleDidChangeAttached() {
    this.grammarTokens.handleDidChangeAttached();
  }
  /**
   * Includes grammar and semantic tokens.
   */
  getLineTokens(e) {
    this.validateLineNumber(e);
    const t = this.grammarTokens.getLineTokens(e);
    return this._semanticTokens.addSparseTokens(e, t);
  }
  _emitModelTokensChangedEvent(e) {
    this._textModel._isDisposing() || (this._bracketPairsTextModelPart.handleDidChangeTokens(e), this._onDidChangeTokens.fire(e));
  }
  // #region Grammar Tokens
  validateLineNumber(e) {
    if (e < 1 || e > this._textModel.getLineCount())
      throw new gr("Illegal value for lineNumber");
  }
  get hasTokens() {
    return this.grammarTokens.hasTokens;
  }
  resetTokenization() {
    this.grammarTokens.resetTokenization();
  }
  get backgroundTokenizationState() {
    return this.grammarTokens.backgroundTokenizationState;
  }
  forceTokenization(e) {
    this.validateLineNumber(e), this.grammarTokens.forceTokenization(e);
  }
  isCheapToTokenize(e) {
    return this.validateLineNumber(e), this.grammarTokens.isCheapToTokenize(e);
  }
  tokenizeIfCheap(e) {
    this.validateLineNumber(e), this.grammarTokens.tokenizeIfCheap(e);
  }
  getTokenTypeIfInsertingCharacter(e, t, n) {
    return this.grammarTokens.getTokenTypeIfInsertingCharacter(e, t, n);
  }
  tokenizeLineWithEdit(e, t, n) {
    return this.grammarTokens.tokenizeLineWithEdit(e, t, n);
  }
  // #endregion
  // #region Semantic Tokens
  setSemanticTokens(e, t) {
    this._semanticTokens.set(e, t), this._emitModelTokensChangedEvent({
      semanticTokensApplied: e !== null,
      ranges: [{ fromLineNumber: 1, toLineNumber: this._textModel.getLineCount() }]
    });
  }
  hasCompleteSemanticTokens() {
    return this._semanticTokens.isComplete();
  }
  hasSomeSemanticTokens() {
    return !this._semanticTokens.isEmpty();
  }
  setPartialSemanticTokens(e, t) {
    if (this.hasCompleteSemanticTokens())
      return;
    const n = this._textModel.validateRange(this._semanticTokens.setPartial(e, t));
    this._emitModelTokensChangedEvent({
      semanticTokensApplied: !0,
      ranges: [
        {
          fromLineNumber: n.startLineNumber,
          toLineNumber: n.endLineNumber
        }
      ]
    });
  }
  // #endregion
  // #region Utility Methods
  getWordAtPosition(e) {
    this.assertNotDisposed();
    const t = this._textModel.validatePosition(e), n = this._textModel.getLineContent(t.lineNumber), r = this.getLineTokens(t.lineNumber), s = r.findTokenIndexAtOffset(t.column - 1), [o, a] = wL._findLanguageBoundaries(r, s), l = yy(t.column, this.getLanguageConfiguration(r.getLanguageId(s)).getWordDefinition(), n.substring(o, a), o);
    if (l && l.startColumn <= e.column && e.column <= l.endColumn)
      return l;
    if (s > 0 && o === t.column - 1) {
      const [c, d] = wL._findLanguageBoundaries(r, s - 1), u = yy(t.column, this.getLanguageConfiguration(r.getLanguageId(s - 1)).getWordDefinition(), n.substring(c, d), c);
      if (u && u.startColumn <= e.column && e.column <= u.endColumn)
        return u;
    }
    return null;
  }
  getLanguageConfiguration(e) {
    return this._languageConfigurationService.getLanguageConfiguration(e);
  }
  static _findLanguageBoundaries(e, t) {
    const n = e.getLanguageId(t);
    let r = 0;
    for (let o = t; o >= 0 && e.getLanguageId(o) === n; o--)
      r = e.getStartOffset(o);
    let s = e.getLineContent().length;
    for (let o = t, a = e.getCount(); o < a && e.getLanguageId(o) === n; o++)
      s = e.getEndOffset(o);
    return [r, s];
  }
  getWordUntilPosition(e) {
    const t = this.getWordAtPosition(e);
    return t ? {
      word: t.word.substr(0, e.column - t.startColumn),
      startColumn: t.startColumn,
      endColumn: e.column
    } : { word: "", startColumn: e.column, endColumn: e.column };
  }
  // #endregion
  // #region Language Id handling
  getLanguageId() {
    return this._languageId;
  }
  getLanguageIdAtPosition(e, t) {
    const n = this._textModel.validatePosition(new ve(e, t)), r = this.getLineTokens(n.lineNumber);
    return r.getLanguageId(r.findTokenIndexAtOffset(n.column - 1));
  }
  setLanguageId(e, t = "api") {
    if (this._languageId === e)
      return;
    const n = {
      oldLanguage: this._languageId,
      newLanguage: e,
      source: t
    };
    this._languageId = e, this._bracketPairsTextModelPart.handleDidChangeLanguage(n), this.grammarTokens.resetTokenization(), this._onDidChangeLanguage.fire(n), this._onDidChangeLanguageConfiguration.fire({});
  }
}
class xVe extends we {
  get backgroundTokenizationState() {
    return this._backgroundTokenizationState;
  }
  constructor(e, t, n, r) {
    super(), this._languageIdCodec = e, this._textModel = t, this.getLanguageId = n, this._tokenizer = null, this._defaultBackgroundTokenizer = null, this._backgroundTokenizer = this._register(new ds()), this._tokens = new tw(this._languageIdCodec), this._debugBackgroundTokenizer = this._register(new ds()), this._backgroundTokenizationState = 1, this._onDidChangeBackgroundTokenizationState = this._register(new pe()), this.onDidChangeBackgroundTokenizationState = this._onDidChangeBackgroundTokenizationState.event, this._onDidChangeTokens = this._register(new pe()), this.onDidChangeTokens = this._onDidChangeTokens.event, this._attachedViewStates = this._register(new Tj()), this._register(Pi.onDidChange((s) => {
      const o = this.getLanguageId();
      s.changedLanguages.indexOf(o) !== -1 && this.resetTokenization();
    })), this.resetTokenization(), this._register(r.onDidChangeVisibleRanges(({ view: s, state: o }) => {
      if (o) {
        let a = this._attachedViewStates.get(s);
        a || (a = new DVe(() => this.refreshRanges(a.lineRanges)), this._attachedViewStates.set(s, a)), a.handleStateChange(o);
      } else
        this._attachedViewStates.deleteAndDispose(s);
    }));
  }
  resetTokenization(e = !0) {
    var t;
    this._tokens.flush(), (t = this._debugBackgroundTokens) === null || t === void 0 || t.flush(), this._debugBackgroundStates && (this._debugBackgroundStates = new GF(this._textModel.getLineCount())), e && this._onDidChangeTokens.fire({
      semanticTokensApplied: !1,
      ranges: [
        {
          fromLineNumber: 1,
          toLineNumber: this._textModel.getLineCount()
        }
      ]
    });
    const n = () => {
      if (this._textModel.isTooLargeForTokenization())
        return [null, null];
      const o = Pi.get(this.getLanguageId());
      if (!o)
        return [null, null];
      let a;
      try {
        a = o.getInitialState();
      } catch (l) {
        return It(l), [null, null];
      }
      return [o, a];
    }, [r, s] = n();
    if (r && s ? this._tokenizer = new CVe(this._textModel.getLineCount(), r, this._textModel, this._languageIdCodec) : this._tokenizer = null, this._backgroundTokenizer.clear(), this._defaultBackgroundTokenizer = null, this._tokenizer) {
      const o = {
        setTokens: (a) => {
          this.setTokens(a);
        },
        backgroundTokenizationFinished: () => {
          if (this._backgroundTokenizationState === 2)
            return;
          const a = 2;
          this._backgroundTokenizationState = a, this._onDidChangeBackgroundTokenizationState.fire();
        },
        setEndState: (a, l) => {
          var c;
          if (!this._tokenizer)
            return;
          const d = this._tokenizer.store.getFirstInvalidEndStateLineNumber();
          d !== null && a >= d && ((c = this._tokenizer) === null || c === void 0 || c.store.setEndState(a, l));
        }
      };
      r && r.createBackgroundTokenizer && !r.backgroundTokenizerShouldOnlyVerifyTokens && (this._backgroundTokenizer.value = r.createBackgroundTokenizer(this._textModel, o)), this._backgroundTokenizer.value || (this._backgroundTokenizer.value = this._defaultBackgroundTokenizer = new SVe(this._tokenizer, o), this._defaultBackgroundTokenizer.handleChanges()), r?.backgroundTokenizerShouldOnlyVerifyTokens && r.createBackgroundTokenizer ? (this._debugBackgroundTokens = new tw(this._languageIdCodec), this._debugBackgroundStates = new GF(this._textModel.getLineCount()), this._debugBackgroundTokenizer.clear(), this._debugBackgroundTokenizer.value = r.createBackgroundTokenizer(this._textModel, {
        setTokens: (a) => {
          var l;
          (l = this._debugBackgroundTokens) === null || l === void 0 || l.setMultilineTokens(a, this._textModel);
        },
        backgroundTokenizationFinished() {
        },
        setEndState: (a, l) => {
          var c;
          (c = this._debugBackgroundStates) === null || c === void 0 || c.setEndState(a, l);
        }
      })) : (this._debugBackgroundTokens = void 0, this._debugBackgroundStates = void 0, this._debugBackgroundTokenizer.value = void 0);
    }
    this.refreshAllVisibleLineTokens();
  }
  handleDidChangeAttached() {
    var e;
    (e = this._defaultBackgroundTokenizer) === null || e === void 0 || e.handleChanges();
  }
  handleDidChangeContent(e) {
    var t, n, r;
    if (e.isFlush)
      this.resetTokenization(!1);
    else if (!e.isEolChange) {
      for (const s of e.changes) {
        const [o, a] = Wg(s.text);
        this._tokens.acceptEdit(s.range, o, a), (t = this._debugBackgroundTokens) === null || t === void 0 || t.acceptEdit(s.range, o, a);
      }
      (n = this._debugBackgroundStates) === null || n === void 0 || n.acceptChanges(e.changes), this._tokenizer && this._tokenizer.store.acceptChanges(e.changes), (r = this._defaultBackgroundTokenizer) === null || r === void 0 || r.handleChanges();
    }
  }
  setTokens(e) {
    const { changes: t } = this._tokens.setMultilineTokens(e, this._textModel);
    return t.length > 0 && this._onDidChangeTokens.fire({ semanticTokensApplied: !1, ranges: t }), { changes: t };
  }
  refreshAllVisibleLineTokens() {
    const e = Qt.joinMany([...this._attachedViewStates].map(([t, n]) => n.lineRanges));
    this.refreshRanges(e);
  }
  refreshRanges(e) {
    for (const t of e)
      this.refreshRange(t.startLineNumber, t.endLineNumberExclusive - 1);
  }
  refreshRange(e, t) {
    var n, r;
    if (!this._tokenizer)
      return;
    e = Math.max(1, Math.min(this._textModel.getLineCount(), e)), t = Math.min(this._textModel.getLineCount(), t);
    const s = new UF(), { heuristicTokens: o } = this._tokenizer.tokenizeHeuristically(s, e, t), a = this.setTokens(s.finalize());
    if (o)
      for (const l of a.changes)
        (n = this._backgroundTokenizer.value) === null || n === void 0 || n.requestTokens(l.fromLineNumber, l.toLineNumber + 1);
    (r = this._defaultBackgroundTokenizer) === null || r === void 0 || r.checkFinished();
  }
  forceTokenization(e) {
    var t, n;
    const r = new UF();
    (t = this._tokenizer) === null || t === void 0 || t.updateTokensUntilLine(r, e), this.setTokens(r.finalize()), (n = this._defaultBackgroundTokenizer) === null || n === void 0 || n.checkFinished();
  }
  isCheapToTokenize(e) {
    return this._tokenizer ? this._tokenizer.isCheapToTokenize(e) : !0;
  }
  tokenizeIfCheap(e) {
    this.isCheapToTokenize(e) && this.forceTokenization(e);
  }
  getLineTokens(e) {
    var t;
    const n = this._textModel.getLineContent(e), r = this._tokens.getTokens(this._textModel.getLanguageId(), e - 1, n);
    if (this._debugBackgroundTokens && this._debugBackgroundStates && this._tokenizer && this._debugBackgroundStates.getFirstInvalidEndStateLineNumberOrMax() > e && this._tokenizer.store.getFirstInvalidEndStateLineNumberOrMax() > e) {
      const s = this._debugBackgroundTokens.getTokens(this._textModel.getLanguageId(), e - 1, n);
      !r.equals(s) && (!((t = this._debugBackgroundTokenizer.value) === null || t === void 0) && t.reportMismatchingTokens) && this._debugBackgroundTokenizer.value.reportMismatchingTokens(e);
    }
    return r;
  }
  getTokenTypeIfInsertingCharacter(e, t, n) {
    if (!this._tokenizer)
      return 0;
    const r = this._textModel.validatePosition(new ve(e, t));
    return this.forceTokenization(r.lineNumber), this._tokenizer.getTokenTypeIfInsertingCharacter(r, n);
  }
  tokenizeLineWithEdit(e, t, n) {
    if (!this._tokenizer)
      return null;
    const r = this._textModel.validatePosition(e);
    return this.forceTokenization(r.lineNumber), this._tokenizer.tokenizeLineWithEdit(r, t, n);
  }
  get hasTokens() {
    return this._tokens.hasTokens;
  }
}
class DVe extends we {
  get lineRanges() {
    return this._lineRanges;
  }
  constructor(e) {
    super(), this._refreshTokens = e, this.runner = this._register(new Rn(() => this.update(), 50)), this._computedLineRanges = [], this._lineRanges = [];
  }
  update() {
    Qi(this._computedLineRanges, this._lineRanges, (e, t) => e.equals(t)) || (this._computedLineRanges = this._lineRanges, this._refreshTokens());
  }
  handleStateChange(e) {
    this._lineRanges = e.visibleLineRanges, e.stabilized ? (this.runner.cancel(), this.update()) : this.runner.schedule();
  }
}
class EVe {
  constructor() {
    this.changeType = 1;
  }
}
class ld {
  static applyInjectedText(e, t) {
    if (!t || t.length === 0)
      return e;
    let n = "", r = 0;
    for (const s of t)
      n += e.substring(r, s.column - 1), r = s.column - 1, n += s.options.content;
    return n += e.substring(r), n;
  }
  static fromDecorations(e) {
    const t = [];
    for (const n of e)
      n.options.before && n.options.before.content.length > 0 && t.push(new ld(n.ownerId, n.range.startLineNumber, n.range.startColumn, n.options.before, 0)), n.options.after && n.options.after.content.length > 0 && t.push(new ld(n.ownerId, n.range.endLineNumber, n.range.endColumn, n.options.after, 1));
    return t.sort((n, r) => n.lineNumber === r.lineNumber ? n.column === r.column ? n.order - r.order : n.column - r.column : n.lineNumber - r.lineNumber), t;
  }
  constructor(e, t, n, r, s) {
    this.ownerId = e, this.lineNumber = t, this.column = n, this.options = r, this.order = s;
  }
}
class rQ {
  constructor(e, t, n) {
    this.changeType = 2, this.lineNumber = e, this.detail = t, this.injectedText = n;
  }
}
class LVe {
  constructor(e, t) {
    this.changeType = 3, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class IVe {
  constructor(e, t, n, r) {
    this.changeType = 4, this.injectedTexts = r, this.fromLineNumber = e, this.toLineNumber = t, this.detail = n;
  }
}
class AVe {
  constructor() {
    this.changeType = 5;
  }
}
class jv {
  constructor(e, t, n, r) {
    this.changes = e, this.versionId = t, this.isUndoing = n, this.isRedoing = r, this.resultingSelection = null;
  }
  containsEvent(e) {
    for (let t = 0, n = this.changes.length; t < n; t++)
      if (this.changes[t].changeType === e)
        return !0;
    return !1;
  }
  static merge(e, t) {
    const n = [].concat(e.changes).concat(t.changes), r = t.versionId, s = e.isUndoing || t.isUndoing, o = e.isRedoing || t.isRedoing;
    return new jv(n, r, s, o);
  }
}
class kge {
  constructor(e) {
    this.changes = e;
  }
}
class Am {
  constructor(e, t) {
    this.rawContentChangedEvent = e, this.contentChangedEvent = t;
  }
  merge(e) {
    const t = jv.merge(this.rawContentChangedEvent, e.rawContentChangedEvent), n = Am._mergeChangeEvents(this.contentChangedEvent, e.contentChangedEvent);
    return new Am(t, n);
  }
  static _mergeChangeEvents(e, t) {
    const n = [].concat(e.changes).concat(t.changes), r = t.eol, s = t.versionId, o = e.isUndoing || t.isUndoing, a = e.isRedoing || t.isRedoing, l = e.isFlush || t.isFlush, c = e.isEolChange && t.isEolChange;
    return {
      changes: n,
      eol: r,
      isEolChange: c,
      versionId: s,
      isUndoing: o,
      isRedoing: a,
      isFlush: l
    };
  }
}
const E4 = Gt("undoRedoService");
class Tge {
  constructor(e, t) {
    this.resource = e, this.elements = t;
  }
}
class E_ {
  constructor() {
    this.id = E_._ID++, this.order = 1;
  }
  nextOrder() {
    return this.id === 0 ? 0 : this.order++;
  }
}
E_._ID = 0;
E_.None = new E_();
class Ud {
  constructor() {
    this.id = Ud._ID++, this.order = 1;
  }
  nextOrder() {
    return this.id === 0 ? 0 : this.order++;
  }
}
Ud._ID = 0;
Ud.None = new Ud();
var kVe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, W6 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Hp;
function TVe(i) {
  const e = new Age();
  return e.acceptChunk(i), e.finish();
}
function NVe(i) {
  const e = new Age();
  let t;
  for (; typeof (t = i.read()) == "string"; )
    e.acceptChunk(t);
  return e.finish();
}
function sQ(i, e) {
  let t;
  return typeof i == "string" ? t = TVe(i) : bPe(i) ? t = NVe(i) : t = i, t.create(e);
}
let iD = 0;
const PVe = 999, OVe = 1e4;
class MVe {
  constructor(e) {
    this._source = e, this._eos = !1;
  }
  read() {
    if (this._eos)
      return null;
    const e = [];
    let t = 0, n = 0;
    do {
      const r = this._source.read();
      if (r === null)
        return this._eos = !0, t === 0 ? null : e.join("");
      if (r.length > 0 && (e[t++] = r, n += r.length), n >= 64 * 1024)
        return e.join("");
    } while (!0);
  }
}
const c2 = () => {
  throw new Error("Invalid change accessor");
};
let Du = Hp = class extends we {
  static resolveOptions(e, t) {
    if (t.detectIndentation) {
      const n = XZ(e, t.tabSize, t.insertSpaces);
      return new R3({
        tabSize: n.tabSize,
        indentSize: "tabSize",
        // TODO@Alex: guess indentSize independent of tabSize
        insertSpaces: n.insertSpaces,
        trimAutoWhitespace: t.trimAutoWhitespace,
        defaultEOL: t.defaultEOL,
        bracketPairColorizationOptions: t.bracketPairColorizationOptions
      });
    }
    return new R3(t);
  }
  get onDidChangeLanguage() {
    return this._tokenizationTextModelPart.onDidChangeLanguage;
  }
  get onDidChangeLanguageConfiguration() {
    return this._tokenizationTextModelPart.onDidChangeLanguageConfiguration;
  }
  get onDidChangeTokens() {
    return this._tokenizationTextModelPart.onDidChangeTokens;
  }
  onDidChangeContent(e) {
    return this._eventEmitter.slowEvent((t) => e(t.contentChangedEvent));
  }
  onDidChangeContentOrInjectedText(e) {
    return Ql(this._eventEmitter.fastEvent((t) => e(t)), this._onDidChangeInjectedText.event((t) => e(t)));
  }
  _isDisposing() {
    return this.__isDisposing;
  }
  get tokenization() {
    return this._tokenizationTextModelPart;
  }
  get bracketPairs() {
    return this._bracketPairs;
  }
  get guides() {
    return this._guidesTextModelPart;
  }
  constructor(e, t, n, r = null, s, o, a) {
    super(), this._undoRedoService = s, this._languageService = o, this._languageConfigurationService = a, this._onWillDispose = this._register(new pe()), this.onWillDispose = this._onWillDispose.event, this._onDidChangeDecorations = this._register(new HVe((f) => this.handleBeforeFireDecorationsChangedEvent(f))), this.onDidChangeDecorations = this._onDidChangeDecorations.event, this._onDidChangeOptions = this._register(new pe()), this.onDidChangeOptions = this._onDidChangeOptions.event, this._onDidChangeAttached = this._register(new pe()), this.onDidChangeAttached = this._onDidChangeAttached.event, this._onDidChangeInjectedText = this._register(new pe()), this._eventEmitter = this._register(new WVe()), this._languageSelectionListener = this._register(new ds()), this._deltaDecorationCallCnt = 0, this._attachedViews = new jVe(), iD++, this.id = "$model" + iD, this.isForSimpleWidget = n.isForSimpleWidget, typeof r > "u" || r === null ? this._associatedResource = pt.parse("inmemory://model/" + iD) : this._associatedResource = r, this._attachedEditorCount = 0;
    const { textBuffer: l, disposable: c } = sQ(e, n.defaultEOL);
    this._buffer = l, this._bufferDisposable = c, this._options = Hp.resolveOptions(this._buffer, n);
    const d = typeof t == "string" ? t : t.languageId;
    typeof t != "string" && (this._languageSelectionListener.value = t.onDidChange(() => this._setLanguage(t.languageId))), this._bracketPairs = this._register(new RBe(this, this._languageConfigurationService)), this._guidesTextModelPart = this._register(new kFe(this, this._languageConfigurationService)), this._decorationProvider = this._register(new BBe(this)), this._tokenizationTextModelPart = new wL(this._languageService, this._languageConfigurationService, this, this._bracketPairs, d, this._attachedViews);
    const u = this._buffer.getLineCount(), h = this._buffer.getValueLengthInRange(
      new V(1, 1, u, this._buffer.getLineLength(u) + 1),
      0
      /* model.EndOfLinePreference.TextDefined */
    );
    n.largeFileOptimizations ? (this._isTooLargeForTokenization = h > Hp.LARGE_FILE_SIZE_THRESHOLD || u > Hp.LARGE_FILE_LINE_COUNT_THRESHOLD, this._isTooLargeForHeapOperation = h > Hp.LARGE_FILE_HEAP_OPERATION_THRESHOLD) : (this._isTooLargeForTokenization = !1, this._isTooLargeForHeapOperation = !1), this._isTooLargeForSyncing = h > Hp._MODEL_SYNC_LIMIT, this._versionId = 1, this._alternativeVersionId = 1, this._initialUndoRedoSnapshot = null, this._isDisposed = !1, this.__isDisposing = !1, this._instanceId = mhe(iD), this._lastDecorationId = 0, this._decorations = /* @__PURE__ */ Object.create(null), this._decorationsTree = new oQ(), this._commandManager = new Nz(this, this._undoRedoService), this._isUndoing = !1, this._isRedoing = !1, this._trimAutoWhitespaceLines = null, this._register(this._decorationProvider.onDidChange(() => {
      this._onDidChangeDecorations.beginDeferredEmit(), this._onDidChangeDecorations.fire(), this._onDidChangeDecorations.endDeferredEmit();
    })), this._languageService.requestRichLanguageFeatures(d);
  }
  dispose() {
    this.__isDisposing = !0, this._onWillDispose.fire(), this._tokenizationTextModelPart.dispose(), this._isDisposed = !0, super.dispose(), this._bufferDisposable.dispose(), this.__isDisposing = !1;
    const e = new Wv([], "", `
`, !1, !1, !0, !0);
    e.dispose(), this._buffer = e, this._bufferDisposable = we.None;
  }
  _assertNotDisposed() {
    if (this._isDisposed)
      throw new Error("Model is disposed!");
  }
  _emitContentChangedEvent(e, t) {
    this.__isDisposing || (this._tokenizationTextModelPart.handleDidChangeContent(t), this._bracketPairs.handleDidChangeContent(t), this._eventEmitter.fire(new Am(e, t)));
  }
  setValue(e) {
    if (this._assertNotDisposed(), e == null)
      throw fl();
    const { textBuffer: t, disposable: n } = sQ(e, this._options.defaultEOL);
    this._setValueFromTextBuffer(t, n);
  }
  _createContentChanged2(e, t, n, r, s, o, a, l) {
    return {
      changes: [{
        range: e,
        rangeOffset: t,
        rangeLength: n,
        text: r
      }],
      eol: this._buffer.getEOL(),
      isEolChange: l,
      versionId: this.getVersionId(),
      isUndoing: s,
      isRedoing: o,
      isFlush: a
    };
  }
  _setValueFromTextBuffer(e, t) {
    this._assertNotDisposed();
    const n = this.getFullModelRange(), r = this.getValueLengthInRange(n), s = this.getLineCount(), o = this.getLineMaxColumn(s);
    this._buffer = e, this._bufferDisposable.dispose(), this._bufferDisposable = t, this._increaseVersionId(), this._decorations = /* @__PURE__ */ Object.create(null), this._decorationsTree = new oQ(), this._commandManager.clear(), this._trimAutoWhitespaceLines = null, this._emitContentChangedEvent(new jv([
      new EVe()
    ], this._versionId, !1, !1), this._createContentChanged2(new V(1, 1, s, o), 0, r, this.getValue(), !1, !1, !0, !1));
  }
  setEOL(e) {
    this._assertNotDisposed();
    const t = e === 1 ? `\r
` : `
`;
    if (this._buffer.getEOL() === t)
      return;
    const n = this.getFullModelRange(), r = this.getValueLengthInRange(n), s = this.getLineCount(), o = this.getLineMaxColumn(s);
    this._onBeforeEOLChange(), this._buffer.setEOL(t), this._increaseVersionId(), this._onAfterEOLChange(), this._emitContentChangedEvent(new jv([
      new AVe()
    ], this._versionId, !1, !1), this._createContentChanged2(new V(1, 1, s, o), 0, r, this.getValue(), !1, !1, !1, !0));
  }
  _onBeforeEOLChange() {
    this._decorationsTree.ensureAllNodesHaveRanges(this);
  }
  _onAfterEOLChange() {
    const e = this.getVersionId(), t = this._decorationsTree.collectNodesPostOrder();
    for (let n = 0, r = t.length; n < r; n++) {
      const s = t[n], o = s.range, a = s.cachedAbsoluteStart - s.start, l = this._buffer.getOffsetAt(o.startLineNumber, o.startColumn), c = this._buffer.getOffsetAt(o.endLineNumber, o.endColumn);
      s.cachedAbsoluteStart = l, s.cachedAbsoluteEnd = c, s.cachedVersionId = e, s.start = l - a, s.end = c - a, zg(s);
    }
  }
  onBeforeAttached() {
    return this._attachedEditorCount++, this._attachedEditorCount === 1 && (this._tokenizationTextModelPart.handleDidChangeAttached(), this._onDidChangeAttached.fire(void 0)), this._attachedViews.attachView();
  }
  onBeforeDetached(e) {
    this._attachedEditorCount--, this._attachedEditorCount === 0 && (this._tokenizationTextModelPart.handleDidChangeAttached(), this._onDidChangeAttached.fire(void 0)), this._attachedViews.detachView(e);
  }
  isAttachedToEditor() {
    return this._attachedEditorCount > 0;
  }
  getAttachedEditorCount() {
    return this._attachedEditorCount;
  }
  isTooLargeForSyncing() {
    return this._isTooLargeForSyncing;
  }
  isTooLargeForTokenization() {
    return this._isTooLargeForTokenization;
  }
  isTooLargeForHeapOperation() {
    return this._isTooLargeForHeapOperation;
  }
  isDisposed() {
    return this._isDisposed;
  }
  isDominatedByLongLines() {
    if (this._assertNotDisposed(), this.isTooLargeForTokenization())
      return !1;
    let e = 0, t = 0;
    const n = this._buffer.getLineCount();
    for (let r = 1; r <= n; r++) {
      const s = this._buffer.getLineLength(r);
      s >= OVe ? t += s : e += s;
    }
    return t > e;
  }
  get uri() {
    return this._associatedResource;
  }
  //#region Options
  getOptions() {
    return this._assertNotDisposed(), this._options;
  }
  getFormattingOptions() {
    return {
      tabSize: this._options.indentSize,
      insertSpaces: this._options.insertSpaces
    };
  }
  updateOptions(e) {
    this._assertNotDisposed();
    const t = typeof e.tabSize < "u" ? e.tabSize : this._options.tabSize, n = typeof e.indentSize < "u" ? e.indentSize : this._options.originalIndentSize, r = typeof e.insertSpaces < "u" ? e.insertSpaces : this._options.insertSpaces, s = typeof e.trimAutoWhitespace < "u" ? e.trimAutoWhitespace : this._options.trimAutoWhitespace, o = typeof e.bracketColorizationOptions < "u" ? e.bracketColorizationOptions : this._options.bracketPairColorizationOptions, a = new R3({
      tabSize: t,
      indentSize: n,
      insertSpaces: r,
      defaultEOL: this._options.defaultEOL,
      trimAutoWhitespace: s,
      bracketPairColorizationOptions: o
    });
    if (this._options.equals(a))
      return;
    const l = this._options.createChangeEvent(a);
    this._options = a, this._bracketPairs.handleDidChangeOptions(l), this._decorationProvider.handleDidChangeOptions(l), this._onDidChangeOptions.fire(l);
  }
  detectIndentation(e, t) {
    this._assertNotDisposed();
    const n = XZ(this._buffer, t, e);
    this.updateOptions({
      insertSpaces: n.insertSpaces,
      tabSize: n.tabSize,
      indentSize: n.tabSize
      // TODO@Alex: guess indentSize independent of tabSize
    });
  }
  normalizeIndentation(e) {
    return this._assertNotDisposed(), xz(e, this._options.indentSize, this._options.insertSpaces);
  }
  //#endregion
  //#region Reading
  getVersionId() {
    return this._assertNotDisposed(), this._versionId;
  }
  mightContainRTL() {
    return this._buffer.mightContainRTL();
  }
  mightContainUnusualLineTerminators() {
    return this._buffer.mightContainUnusualLineTerminators();
  }
  removeUnusualLineTerminators(e = null) {
    const t = this.findMatches(
      ghe.source,
      !1,
      !0,
      !1,
      null,
      !1,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    );
    this._buffer.resetMightContainUnusualLineTerminators(), this.pushEditOperations(e, t.map((n) => ({ range: n.range, text: null })), () => null);
  }
  mightContainNonBasicASCII() {
    return this._buffer.mightContainNonBasicASCII();
  }
  getAlternativeVersionId() {
    return this._assertNotDisposed(), this._alternativeVersionId;
  }
  getInitialUndoRedoSnapshot() {
    return this._assertNotDisposed(), this._initialUndoRedoSnapshot;
  }
  getOffsetAt(e) {
    this._assertNotDisposed();
    const t = this._validatePosition(
      e.lineNumber,
      e.column,
      0
      /* StringOffsetValidationType.Relaxed */
    );
    return this._buffer.getOffsetAt(t.lineNumber, t.column);
  }
  getPositionAt(e) {
    this._assertNotDisposed();
    const t = Math.min(this._buffer.getLength(), Math.max(0, e));
    return this._buffer.getPositionAt(t);
  }
  _increaseVersionId() {
    this._versionId = this._versionId + 1, this._alternativeVersionId = this._versionId;
  }
  _overwriteVersionId(e) {
    this._versionId = e;
  }
  _overwriteAlternativeVersionId(e) {
    this._alternativeVersionId = e;
  }
  _overwriteInitialUndoRedoSnapshot(e) {
    this._initialUndoRedoSnapshot = e;
  }
  getValue(e, t = !1) {
    if (this._assertNotDisposed(), this.isTooLargeForHeapOperation())
      throw new gr("Operation would exceed heap memory limits");
    const n = this.getFullModelRange(), r = this.getValueInRange(n, e);
    return t ? this._buffer.getBOM() + r : r;
  }
  createSnapshot(e = !1) {
    return new MVe(this._buffer.createSnapshot(e));
  }
  getValueLength(e, t = !1) {
    this._assertNotDisposed();
    const n = this.getFullModelRange(), r = this.getValueLengthInRange(n, e);
    return t ? this._buffer.getBOM().length + r : r;
  }
  getValueInRange(e, t = 0) {
    return this._assertNotDisposed(), this._buffer.getValueInRange(this.validateRange(e), t);
  }
  getValueLengthInRange(e, t = 0) {
    return this._assertNotDisposed(), this._buffer.getValueLengthInRange(this.validateRange(e), t);
  }
  getCharacterCountInRange(e, t = 0) {
    return this._assertNotDisposed(), this._buffer.getCharacterCountInRange(this.validateRange(e), t);
  }
  getLineCount() {
    return this._assertNotDisposed(), this._buffer.getLineCount();
  }
  getLineContent(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new gr("Illegal value for lineNumber");
    return this._buffer.getLineContent(e);
  }
  getLineLength(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new gr("Illegal value for lineNumber");
    return this._buffer.getLineLength(e);
  }
  getLinesContent() {
    if (this._assertNotDisposed(), this.isTooLargeForHeapOperation())
      throw new gr("Operation would exceed heap memory limits");
    return this._buffer.getLinesContent();
  }
  getEOL() {
    return this._assertNotDisposed(), this._buffer.getEOL();
  }
  getEndOfLineSequence() {
    return this._assertNotDisposed(), this._buffer.getEOL() === `
` ? 0 : 1;
  }
  getLineMinColumn(e) {
    return this._assertNotDisposed(), 1;
  }
  getLineMaxColumn(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new gr("Illegal value for lineNumber");
    return this._buffer.getLineLength(e) + 1;
  }
  getLineFirstNonWhitespaceColumn(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new gr("Illegal value for lineNumber");
    return this._buffer.getLineFirstNonWhitespaceColumn(e);
  }
  getLineLastNonWhitespaceColumn(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new gr("Illegal value for lineNumber");
    return this._buffer.getLineLastNonWhitespaceColumn(e);
  }
  /**
   * Validates `range` is within buffer bounds, but allows it to sit in between surrogate pairs, etc.
   * Will try to not allocate if possible.
   */
  _validateRangeRelaxedNoAllocations(e) {
    const t = this._buffer.getLineCount(), n = e.startLineNumber, r = e.startColumn;
    let s = Math.floor(typeof n == "number" && !isNaN(n) ? n : 1), o = Math.floor(typeof r == "number" && !isNaN(r) ? r : 1);
    if (s < 1)
      s = 1, o = 1;
    else if (s > t)
      s = t, o = this.getLineMaxColumn(s);
    else if (o <= 1)
      o = 1;
    else {
      const u = this.getLineMaxColumn(s);
      o >= u && (o = u);
    }
    const a = e.endLineNumber, l = e.endColumn;
    let c = Math.floor(typeof a == "number" && !isNaN(a) ? a : 1), d = Math.floor(typeof l == "number" && !isNaN(l) ? l : 1);
    if (c < 1)
      c = 1, d = 1;
    else if (c > t)
      c = t, d = this.getLineMaxColumn(c);
    else if (d <= 1)
      d = 1;
    else {
      const u = this.getLineMaxColumn(c);
      d >= u && (d = u);
    }
    return n === s && r === o && a === c && l === d && e instanceof V && !(e instanceof ot) ? e : new V(s, o, c, d);
  }
  _isValidPosition(e, t, n) {
    if (typeof e != "number" || typeof t != "number" || isNaN(e) || isNaN(t) || e < 1 || t < 1 || (e | 0) !== e || (t | 0) !== t)
      return !1;
    const r = this._buffer.getLineCount();
    if (e > r)
      return !1;
    if (t === 1)
      return !0;
    const s = this.getLineMaxColumn(e);
    if (t > s)
      return !1;
    if (n === 1) {
      const o = this._buffer.getLineCharCode(e, t - 2);
      if (kr(o))
        return !1;
    }
    return !0;
  }
  _validatePosition(e, t, n) {
    const r = Math.floor(typeof e == "number" && !isNaN(e) ? e : 1), s = Math.floor(typeof t == "number" && !isNaN(t) ? t : 1), o = this._buffer.getLineCount();
    if (r < 1)
      return new ve(1, 1);
    if (r > o)
      return new ve(o, this.getLineMaxColumn(o));
    if (s <= 1)
      return new ve(r, 1);
    const a = this.getLineMaxColumn(r);
    if (s >= a)
      return new ve(r, a);
    if (n === 1) {
      const l = this._buffer.getLineCharCode(r, s - 2);
      if (kr(l))
        return new ve(r, s - 1);
    }
    return new ve(r, s);
  }
  validatePosition(e) {
    return this._assertNotDisposed(), e instanceof ve && this._isValidPosition(e.lineNumber, e.column, 1) ? e : this._validatePosition(e.lineNumber, e.column, 1);
  }
  _isValidRange(e, t) {
    const n = e.startLineNumber, r = e.startColumn, s = e.endLineNumber, o = e.endColumn;
    if (!this._isValidPosition(
      n,
      r,
      0
      /* StringOffsetValidationType.Relaxed */
    ) || !this._isValidPosition(
      s,
      o,
      0
      /* StringOffsetValidationType.Relaxed */
    ))
      return !1;
    if (t === 1) {
      const a = r > 1 ? this._buffer.getLineCharCode(n, r - 2) : 0, l = o > 1 && o <= this._buffer.getLineLength(s) ? this._buffer.getLineCharCode(s, o - 2) : 0, c = kr(a), d = kr(l);
      return !c && !d;
    }
    return !0;
  }
  validateRange(e) {
    if (this._assertNotDisposed(), e instanceof V && !(e instanceof ot) && this._isValidRange(e, 1))
      return e;
    const n = this._validatePosition(
      e.startLineNumber,
      e.startColumn,
      0
      /* StringOffsetValidationType.Relaxed */
    ), r = this._validatePosition(
      e.endLineNumber,
      e.endColumn,
      0
      /* StringOffsetValidationType.Relaxed */
    ), s = n.lineNumber, o = n.column, a = r.lineNumber, l = r.column;
    {
      const c = o > 1 ? this._buffer.getLineCharCode(s, o - 2) : 0, d = l > 1 && l <= this._buffer.getLineLength(a) ? this._buffer.getLineCharCode(a, l - 2) : 0, u = kr(c), h = kr(d);
      return !u && !h ? new V(s, o, a, l) : s === a && o === l ? new V(s, o - 1, a, l - 1) : u && h ? new V(s, o - 1, a, l + 1) : u ? new V(s, o - 1, a, l) : new V(s, o, a, l + 1);
    }
  }
  modifyPosition(e, t) {
    this._assertNotDisposed();
    const n = this.getOffsetAt(e) + t;
    return this.getPositionAt(Math.min(this._buffer.getLength(), Math.max(0, n)));
  }
  getFullModelRange() {
    this._assertNotDisposed();
    const e = this.getLineCount();
    return new V(1, 1, e, this.getLineMaxColumn(e));
  }
  findMatchesLineByLine(e, t, n, r) {
    return this._buffer.findMatchesLineByLine(e, t, n, r);
  }
  findMatches(e, t, n, r, s, o, a = PVe) {
    this._assertNotDisposed();
    let l = null;
    t !== null && (Array.isArray(t) || (t = [t]), t.every((u) => V.isIRange(u)) && (l = t.map((u) => this.validateRange(u)))), l === null && (l = [this.getFullModelRange()]), l = l.sort((u, h) => u.startLineNumber - h.startLineNumber || u.startColumn - h.startColumn);
    const c = [];
    c.push(l.reduce((u, h) => V.areIntersecting(u, h) ? u.plusRange(h) : (c.push(u), h)));
    let d;
    if (!n && e.indexOf(`
`) < 0) {
      const h = new Vp(e, n, r, s).parseSearchRequest();
      if (!h)
        return [];
      d = (f) => this.findMatchesLineByLine(f, h, o, a);
    } else
      d = (u) => jx.findMatches(this, new Vp(e, n, r, s), u, o, a);
    return c.map(d).reduce((u, h) => u.concat(h), []);
  }
  findNextMatch(e, t, n, r, s, o) {
    this._assertNotDisposed();
    const a = this.validatePosition(t);
    if (!n && e.indexOf(`
`) < 0) {
      const c = new Vp(e, n, r, s).parseSearchRequest();
      if (!c)
        return null;
      const d = this.getLineCount();
      let u = new V(a.lineNumber, a.column, d, this.getLineMaxColumn(d)), h = this.findMatchesLineByLine(u, c, o, 1);
      return jx.findNextMatch(this, new Vp(e, n, r, s), a, o), h.length > 0 || (u = new V(1, 1, a.lineNumber, this.getLineMaxColumn(a.lineNumber)), h = this.findMatchesLineByLine(u, c, o, 1), h.length > 0) ? h[0] : null;
    }
    return jx.findNextMatch(this, new Vp(e, n, r, s), a, o);
  }
  findPreviousMatch(e, t, n, r, s, o) {
    this._assertNotDisposed();
    const a = this.validatePosition(t);
    return jx.findPreviousMatch(this, new Vp(e, n, r, s), a, o);
  }
  //#endregion
  //#region Editing
  pushStackElement() {
    this._commandManager.pushStackElement();
  }
  popStackElement() {
    this._commandManager.popStackElement();
  }
  pushEOL(e) {
    if ((this.getEOL() === `
` ? 0 : 1) !== e)
      try {
        this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._initialUndoRedoSnapshot === null && (this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri)), this._commandManager.pushEOL(e);
      } finally {
        this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
      }
  }
  _validateEditOperation(e) {
    return e instanceof y6 ? e : new y6(e.identifier || null, this.validateRange(e.range), e.text, e.forceMoveMarkers || !1, e.isAutoWhitespaceEdit || !1, e._isTracked || !1);
  }
  _validateEditOperations(e) {
    const t = [];
    for (let n = 0, r = e.length; n < r; n++)
      t[n] = this._validateEditOperation(e[n]);
    return t;
  }
  pushEditOperations(e, t, n, r) {
    try {
      return this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._pushEditOperations(e, this._validateEditOperations(t), n, r);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _pushEditOperations(e, t, n, r) {
    if (this._options.trimAutoWhitespace && this._trimAutoWhitespaceLines) {
      const s = t.map((a) => ({
        range: this.validateRange(a.range),
        text: a.text
      }));
      let o = !0;
      if (e)
        for (let a = 0, l = e.length; a < l; a++) {
          const c = e[a];
          let d = !1;
          for (let u = 0, h = s.length; u < h; u++) {
            const f = s[u].range, g = f.startLineNumber > c.endLineNumber, p = c.startLineNumber > f.endLineNumber;
            if (!g && !p) {
              d = !0;
              break;
            }
          }
          if (!d) {
            o = !1;
            break;
          }
        }
      if (o)
        for (let a = 0, l = this._trimAutoWhitespaceLines.length; a < l; a++) {
          const c = this._trimAutoWhitespaceLines[a], d = this.getLineMaxColumn(c);
          let u = !0;
          for (let h = 0, f = s.length; h < f; h++) {
            const g = s[h].range, p = s[h].text;
            if (!(c < g.startLineNumber || c > g.endLineNumber) && !(c === g.startLineNumber && g.startColumn === d && g.isEmpty() && p && p.length > 0 && p.charAt(0) === `
`) && !(c === g.startLineNumber && g.startColumn === 1 && g.isEmpty() && p && p.length > 0 && p.charAt(p.length - 1) === `
`)) {
              u = !1;
              break;
            }
          }
          if (u) {
            const h = new V(c, 1, c, d);
            t.push(new y6(null, h, null, !1, !1, !1));
          }
        }
      this._trimAutoWhitespaceLines = null;
    }
    return this._initialUndoRedoSnapshot === null && (this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri)), this._commandManager.pushEditOperation(e, t, n, r);
  }
  _applyUndo(e, t, n, r) {
    const s = e.map((o) => {
      const a = this.getPositionAt(o.newPosition), l = this.getPositionAt(o.newEnd);
      return {
        range: new V(a.lineNumber, a.column, l.lineNumber, l.column),
        text: o.oldText
      };
    });
    this._applyUndoRedoEdits(s, t, !0, !1, n, r);
  }
  _applyRedo(e, t, n, r) {
    const s = e.map((o) => {
      const a = this.getPositionAt(o.oldPosition), l = this.getPositionAt(o.oldEnd);
      return {
        range: new V(a.lineNumber, a.column, l.lineNumber, l.column),
        text: o.newText
      };
    });
    this._applyUndoRedoEdits(s, t, !1, !0, n, r);
  }
  _applyUndoRedoEdits(e, t, n, r, s, o) {
    try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._isUndoing = n, this._isRedoing = r, this.applyEdits(e, !1), this.setEOL(t), this._overwriteAlternativeVersionId(s);
    } finally {
      this._isUndoing = !1, this._isRedoing = !1, this._eventEmitter.endDeferredEmit(o), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  applyEdits(e, t = !1) {
    try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit();
      const n = this._validateEditOperations(e);
      return this._doApplyEdits(n, t);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _doApplyEdits(e, t) {
    const n = this._buffer.getLineCount(), r = this._buffer.applyEdits(e, this._options.trimAutoWhitespace, t), s = this._buffer.getLineCount(), o = r.changes;
    if (this._trimAutoWhitespaceLines = r.trimAutoWhitespaceLineNumbers, o.length !== 0) {
      for (let c = 0, d = o.length; c < d; c++) {
        const u = o[c];
        this._decorationsTree.acceptReplace(u.rangeOffset, u.rangeLength, u.text.length, u.forceMoveMarkers);
      }
      const a = [];
      this._increaseVersionId();
      let l = n;
      for (let c = 0, d = o.length; c < d; c++) {
        const u = o[c], [h] = Wg(u.text);
        this._onDidChangeDecorations.fire();
        const f = u.range.startLineNumber, g = u.range.endLineNumber, p = g - f, m = h, _ = Math.min(p, m), b = m - p, w = s - l - b + f, y = w, S = w + m, x = this._decorationsTree.getInjectedTextInInterval(this, this.getOffsetAt(new ve(y, 1)), this.getOffsetAt(new ve(S, this.getLineMaxColumn(S))), 0), D = ld.fromDecorations(x), E = new Xh(D);
        for (let L = _; L >= 0; L--) {
          const k = f + L, N = w + L;
          E.takeFromEndWhile((A) => A.lineNumber > N);
          const I = E.takeFromEndWhile((A) => A.lineNumber === N);
          a.push(new rQ(k, this.getLineContent(N), I));
        }
        if (_ < p) {
          const L = f + _;
          a.push(new LVe(L + 1, g));
        }
        if (_ < m) {
          const L = new Xh(D), k = f + _, N = m - _, I = s - l - N + k + 1, A = [], P = [];
          for (let O = 0; O < N; O++) {
            const K = I + O;
            P[O] = this.getLineContent(K), L.takeWhile((W) => W.lineNumber < K), A[O] = L.takeWhile((W) => W.lineNumber === K);
          }
          a.push(new IVe(k + 1, f + m, P, A));
        }
        l += b;
      }
      this._emitContentChangedEvent(new jv(a, this.getVersionId(), this._isUndoing, this._isRedoing), {
        changes: o,
        eol: this._buffer.getEOL(),
        isEolChange: !1,
        versionId: this.getVersionId(),
        isUndoing: this._isUndoing,
        isRedoing: this._isRedoing,
        isFlush: !1
      });
    }
    return r.reverseEdits === null ? void 0 : r.reverseEdits;
  }
  undo() {
    return this._undoRedoService.undo(this.uri);
  }
  canUndo() {
    return this._undoRedoService.canUndo(this.uri);
  }
  redo() {
    return this._undoRedoService.redo(this.uri);
  }
  canRedo() {
    return this._undoRedoService.canRedo(this.uri);
  }
  //#endregion
  //#region Decorations
  handleBeforeFireDecorationsChangedEvent(e) {
    if (e === null || e.size === 0)
      return;
    const n = Array.from(e).map((r) => new rQ(r, this.getLineContent(r), this._getInjectedTextInLine(r)));
    this._onDidChangeInjectedText.fire(new kge(n));
  }
  changeDecorations(e, t = 0) {
    this._assertNotDisposed();
    try {
      return this._onDidChangeDecorations.beginDeferredEmit(), this._changeDecorations(t, e);
    } finally {
      this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _changeDecorations(e, t) {
    const n = {
      addDecoration: (s, o) => this._deltaDecorationsImpl(e, [], [{ range: s, options: o }])[0],
      changeDecoration: (s, o) => {
        this._changeDecorationImpl(s, o);
      },
      changeDecorationOptions: (s, o) => {
        this._changeDecorationOptionsImpl(s, lQ(o));
      },
      removeDecoration: (s) => {
        this._deltaDecorationsImpl(e, [s], []);
      },
      deltaDecorations: (s, o) => s.length === 0 && o.length === 0 ? [] : this._deltaDecorationsImpl(e, s, o)
    };
    let r = null;
    try {
      r = t(n);
    } catch (s) {
      It(s);
    }
    return n.addDecoration = c2, n.changeDecoration = c2, n.changeDecorationOptions = c2, n.removeDecoration = c2, n.deltaDecorations = c2, r;
  }
  deltaDecorations(e, t, n = 0) {
    if (this._assertNotDisposed(), e || (e = []), e.length === 0 && t.length === 0)
      return [];
    try {
      return this._deltaDecorationCallCnt++, this._deltaDecorationCallCnt > 1 && (console.warn("Invoking deltaDecorations recursively could lead to leaking decorations."), It(new Error("Invoking deltaDecorations recursively could lead to leaking decorations."))), this._onDidChangeDecorations.beginDeferredEmit(), this._deltaDecorationsImpl(n, e, t);
    } finally {
      this._onDidChangeDecorations.endDeferredEmit(), this._deltaDecorationCallCnt--;
    }
  }
  _getTrackedRange(e) {
    return this.getDecorationRange(e);
  }
  _setTrackedRange(e, t, n) {
    const r = e ? this._decorations[e] : null;
    if (!r)
      return t ? this._deltaDecorationsImpl(0, [], [{ range: t, options: aQ[n] }], !0)[0] : null;
    if (!t)
      return this._decorationsTree.delete(r), delete this._decorations[r.id], null;
    const s = this._validateRangeRelaxedNoAllocations(t), o = this._buffer.getOffsetAt(s.startLineNumber, s.startColumn), a = this._buffer.getOffsetAt(s.endLineNumber, s.endColumn);
    return this._decorationsTree.delete(r), r.reset(this.getVersionId(), o, a, s), r.setOptions(aQ[n]), this._decorationsTree.insert(r), r.id;
  }
  removeAllDecorationsWithOwnerId(e) {
    if (this._isDisposed)
      return;
    const t = this._decorationsTree.collectNodesFromOwner(e);
    for (let n = 0, r = t.length; n < r; n++) {
      const s = t[n];
      this._decorationsTree.delete(s), delete this._decorations[s.id];
    }
  }
  getDecorationOptions(e) {
    const t = this._decorations[e];
    return t ? t.options : null;
  }
  getDecorationRange(e) {
    const t = this._decorations[e];
    return t ? this._decorationsTree.getNodeRange(this, t) : null;
  }
  getLineDecorations(e, t = 0, n = !1) {
    return e < 1 || e > this.getLineCount() ? [] : this.getLinesDecorations(e, e, t, n);
  }
  getLinesDecorations(e, t, n = 0, r = !1, s = !1) {
    const o = this.getLineCount(), a = Math.min(o, Math.max(1, e)), l = Math.min(o, Math.max(1, t)), c = this.getLineMaxColumn(l), d = new V(a, 1, l, c), u = this._getDecorationsInRange(d, n, r, s);
    return rR(u, this._decorationProvider.getDecorationsInRange(d, n, r)), u;
  }
  getDecorationsInRange(e, t = 0, n = !1, r = !1, s = !1) {
    const o = this.validateRange(e), a = this._getDecorationsInRange(o, t, n, s);
    return rR(a, this._decorationProvider.getDecorationsInRange(o, t, n, r)), a;
  }
  getOverviewRulerDecorations(e = 0, t = !1) {
    return this._decorationsTree.getAll(this, e, t, !0, !1);
  }
  getInjectedTextDecorations(e = 0) {
    return this._decorationsTree.getAllInjectedText(this, e);
  }
  _getInjectedTextInLine(e) {
    const t = this._buffer.getOffsetAt(e, 1), n = t + this._buffer.getLineLength(e), r = this._decorationsTree.getInjectedTextInInterval(this, t, n, 0);
    return ld.fromDecorations(r).filter((s) => s.lineNumber === e);
  }
  getAllDecorations(e = 0, t = !1) {
    let n = this._decorationsTree.getAll(this, e, t, !1, !1);
    return n = n.concat(this._decorationProvider.getAllDecorations(e, t)), n;
  }
  getAllMarginDecorations(e = 0) {
    return this._decorationsTree.getAll(this, e, !1, !1, !0);
  }
  _getDecorationsInRange(e, t, n, r) {
    const s = this._buffer.getOffsetAt(e.startLineNumber, e.startColumn), o = this._buffer.getOffsetAt(e.endLineNumber, e.endColumn);
    return this._decorationsTree.getAllInInterval(this, s, o, t, n, r);
  }
  getRangeAt(e, t) {
    return this._buffer.getRangeAt(e, t - e);
  }
  _changeDecorationImpl(e, t) {
    const n = this._decorations[e];
    if (!n)
      return;
    if (n.options.after) {
      const a = this.getDecorationRange(e);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(a.endLineNumber);
    }
    if (n.options.before) {
      const a = this.getDecorationRange(e);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(a.startLineNumber);
    }
    const r = this._validateRangeRelaxedNoAllocations(t), s = this._buffer.getOffsetAt(r.startLineNumber, r.startColumn), o = this._buffer.getOffsetAt(r.endLineNumber, r.endColumn);
    this._decorationsTree.delete(n), n.reset(this.getVersionId(), s, o, r), this._decorationsTree.insert(n), this._onDidChangeDecorations.checkAffectedAndFire(n.options), n.options.after && this._onDidChangeDecorations.recordLineAffectedByInjectedText(r.endLineNumber), n.options.before && this._onDidChangeDecorations.recordLineAffectedByInjectedText(r.startLineNumber);
  }
  _changeDecorationOptionsImpl(e, t) {
    const n = this._decorations[e];
    if (!n)
      return;
    const r = !!(n.options.overviewRuler && n.options.overviewRuler.color), s = !!(t.overviewRuler && t.overviewRuler.color);
    if (this._onDidChangeDecorations.checkAffectedAndFire(n.options), this._onDidChangeDecorations.checkAffectedAndFire(t), n.options.after || t.after) {
      const o = this._decorationsTree.getNodeRange(this, n);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(o.endLineNumber);
    }
    if (n.options.before || t.before) {
      const o = this._decorationsTree.getNodeRange(this, n);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(o.startLineNumber);
    }
    r !== s ? (this._decorationsTree.delete(n), n.setOptions(t), this._decorationsTree.insert(n)) : n.setOptions(t);
  }
  _deltaDecorationsImpl(e, t, n, r = !1) {
    const s = this.getVersionId(), o = t.length;
    let a = 0;
    const l = n.length;
    let c = 0;
    this._onDidChangeDecorations.beginDeferredEmit();
    try {
      const d = new Array(l);
      for (; a < o || c < l; ) {
        let u = null;
        if (a < o) {
          do
            u = this._decorations[t[a++]];
          while (!u && a < o);
          if (u) {
            if (u.options.after) {
              const h = this._decorationsTree.getNodeRange(this, u);
              this._onDidChangeDecorations.recordLineAffectedByInjectedText(h.endLineNumber);
            }
            if (u.options.before) {
              const h = this._decorationsTree.getNodeRange(this, u);
              this._onDidChangeDecorations.recordLineAffectedByInjectedText(h.startLineNumber);
            }
            this._decorationsTree.delete(u), r || this._onDidChangeDecorations.checkAffectedAndFire(u.options);
          }
        }
        if (c < l) {
          if (!u) {
            const _ = ++this._lastDecorationId, b = `${this._instanceId};${_}`;
            u = new Dge(b, 0, 0), this._decorations[b] = u;
          }
          const h = n[c], f = this._validateRangeRelaxedNoAllocations(h.range), g = lQ(h.options), p = this._buffer.getOffsetAt(f.startLineNumber, f.startColumn), m = this._buffer.getOffsetAt(f.endLineNumber, f.endColumn);
          u.ownerId = e, u.reset(s, p, m, f), u.setOptions(g), u.options.after && this._onDidChangeDecorations.recordLineAffectedByInjectedText(f.endLineNumber), u.options.before && this._onDidChangeDecorations.recordLineAffectedByInjectedText(f.startLineNumber), r || this._onDidChangeDecorations.checkAffectedAndFire(g), this._decorationsTree.insert(u), d[c] = u.id, c++;
        } else
          u && delete this._decorations[u.id];
      }
      return d;
    } finally {
      this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  //#endregion
  //#region Tokenization
  // TODO move them to the tokenization part.
  getLanguageId() {
    return this.tokenization.getLanguageId();
  }
  setLanguage(e, t) {
    typeof e == "string" ? (this._languageSelectionListener.clear(), this._setLanguage(e, t)) : (this._languageSelectionListener.value = e.onDidChange(() => this._setLanguage(e.languageId, t)), this._setLanguage(e.languageId, t));
  }
  _setLanguage(e, t) {
    this.tokenization.setLanguageId(e, t), this._languageService.requestRichLanguageFeatures(e);
  }
  getLanguageIdAtPosition(e, t) {
    return this.tokenization.getLanguageIdAtPosition(e, t);
  }
  getWordAtPosition(e) {
    return this._tokenizationTextModelPart.getWordAtPosition(e);
  }
  getWordUntilPosition(e) {
    return this._tokenizationTextModelPart.getWordUntilPosition(e);
  }
  //#endregion
  normalizePosition(e, t) {
    return e;
  }
  /**
   * Gets the column at which indentation stops at a given line.
   * @internal
  */
  getLineIndentColumn(e) {
    return RVe(this.getLineContent(e)) + 1;
  }
};
Du._MODEL_SYNC_LIMIT = 50 * 1024 * 1024;
Du.LARGE_FILE_SIZE_THRESHOLD = 20 * 1024 * 1024;
Du.LARGE_FILE_LINE_COUNT_THRESHOLD = 300 * 1e3;
Du.LARGE_FILE_HEAP_OPERATION_THRESHOLD = 256 * 1024 * 1024;
Du.DEFAULT_CREATION_OPTIONS = {
  isForSimpleWidget: !1,
  tabSize: Os.tabSize,
  indentSize: Os.indentSize,
  insertSpaces: Os.insertSpaces,
  detectIndentation: !1,
  defaultEOL: 1,
  trimAutoWhitespace: Os.trimAutoWhitespace,
  largeFileOptimizations: Os.largeFileOptimizations,
  bracketPairColorizationOptions: Os.bracketPairColorizationOptions
};
Du = Hp = kVe([
  W6(4, E4),
  W6(5, ci),
  W6(6, Un)
], Du);
function RVe(i) {
  let e = 0;
  for (const t of i)
    if (t === " " || t === "	")
      e++;
    else
      break;
  return e;
}
function j6(i) {
  return !!(i.options.overviewRuler && i.options.overviewRuler.color);
}
function z6(i) {
  return !!i.options.after || !!i.options.before;
}
class oQ {
  constructor() {
    this._decorationsTree0 = new B6(), this._decorationsTree1 = new B6(), this._injectedTextDecorationsTree = new B6();
  }
  ensureAllNodesHaveRanges(e) {
    this.getAll(e, 0, !1, !1, !1);
  }
  _ensureNodesHaveRanges(e, t) {
    for (const n of t)
      n.range === null && (n.range = e.getRangeAt(n.cachedAbsoluteStart, n.cachedAbsoluteEnd));
    return t;
  }
  getAllInInterval(e, t, n, r, s, o) {
    const a = e.getVersionId(), l = this._intervalSearch(t, n, r, s, a, o);
    return this._ensureNodesHaveRanges(e, l);
  }
  _intervalSearch(e, t, n, r, s, o) {
    const a = this._decorationsTree0.intervalSearch(e, t, n, r, s, o), l = this._decorationsTree1.intervalSearch(e, t, n, r, s, o), c = this._injectedTextDecorationsTree.intervalSearch(e, t, n, r, s, o);
    return a.concat(l).concat(c);
  }
  getInjectedTextInInterval(e, t, n, r) {
    const s = e.getVersionId(), o = this._injectedTextDecorationsTree.intervalSearch(t, n, r, !1, s, !1);
    return this._ensureNodesHaveRanges(e, o).filter((a) => a.options.showIfCollapsed || !a.range.isEmpty());
  }
  getAllInjectedText(e, t) {
    const n = e.getVersionId(), r = this._injectedTextDecorationsTree.search(t, !1, n, !1);
    return this._ensureNodesHaveRanges(e, r).filter((s) => s.options.showIfCollapsed || !s.range.isEmpty());
  }
  getAll(e, t, n, r, s) {
    const o = e.getVersionId(), a = this._search(t, n, r, o, s);
    return this._ensureNodesHaveRanges(e, a);
  }
  _search(e, t, n, r, s) {
    if (n)
      return this._decorationsTree1.search(e, t, r, s);
    {
      const o = this._decorationsTree0.search(e, t, r, s), a = this._decorationsTree1.search(e, t, r, s), l = this._injectedTextDecorationsTree.search(e, t, r, s);
      return o.concat(a).concat(l);
    }
  }
  collectNodesFromOwner(e) {
    const t = this._decorationsTree0.collectNodesFromOwner(e), n = this._decorationsTree1.collectNodesFromOwner(e), r = this._injectedTextDecorationsTree.collectNodesFromOwner(e);
    return t.concat(n).concat(r);
  }
  collectNodesPostOrder() {
    const e = this._decorationsTree0.collectNodesPostOrder(), t = this._decorationsTree1.collectNodesPostOrder(), n = this._injectedTextDecorationsTree.collectNodesPostOrder();
    return e.concat(t).concat(n);
  }
  insert(e) {
    z6(e) ? this._injectedTextDecorationsTree.insert(e) : j6(e) ? this._decorationsTree1.insert(e) : this._decorationsTree0.insert(e);
  }
  delete(e) {
    z6(e) ? this._injectedTextDecorationsTree.delete(e) : j6(e) ? this._decorationsTree1.delete(e) : this._decorationsTree0.delete(e);
  }
  getNodeRange(e, t) {
    const n = e.getVersionId();
    return t.cachedVersionId !== n && this._resolveNode(t, n), t.range === null && (t.range = e.getRangeAt(t.cachedAbsoluteStart, t.cachedAbsoluteEnd)), t.range;
  }
  _resolveNode(e, t) {
    z6(e) ? this._injectedTextDecorationsTree.resolveNode(e, t) : j6(e) ? this._decorationsTree1.resolveNode(e, t) : this._decorationsTree0.resolveNode(e, t);
  }
  acceptReplace(e, t, n, r) {
    this._decorationsTree0.acceptReplace(e, t, n, r), this._decorationsTree1.acceptReplace(e, t, n, r), this._injectedTextDecorationsTree.acceptReplace(e, t, n, r);
  }
}
function ju(i) {
  return i.replace(/[^a-z0-9\-_]/gi, " ");
}
class Nge {
  constructor(e) {
    this.color = e.color || "", this.darkColor = e.darkColor || "";
  }
}
class FVe extends Nge {
  constructor(e) {
    super(e), this._resolvedColor = null, this.position = typeof e.position == "number" ? e.position : Ha.Center;
  }
  getColor(e) {
    return this._resolvedColor || (e.type !== "light" && this.darkColor ? this._resolvedColor = this._resolveColor(this.darkColor, e) : this._resolvedColor = this._resolveColor(this.color, e)), this._resolvedColor;
  }
  invalidateCachedColor() {
    this._resolvedColor = null;
  }
  _resolveColor(e, t) {
    if (typeof e == "string")
      return e;
    const n = e ? t.getColor(e.id) : null;
    return n ? n.toString() : "";
  }
}
class BVe {
  constructor(e) {
    var t;
    this.position = (t = e?.position) !== null && t !== void 0 ? t : Nv.Left;
  }
}
class VVe extends Nge {
  constructor(e) {
    super(e), this.position = e.position;
  }
  getColor(e) {
    return this._resolvedColor || (e.type !== "light" && this.darkColor ? this._resolvedColor = this._resolveColor(this.darkColor, e) : this._resolvedColor = this._resolveColor(this.color, e)), this._resolvedColor;
  }
  invalidateCachedColor() {
    this._resolvedColor = void 0;
  }
  _resolveColor(e, t) {
    return typeof e == "string" ? ye.fromHex(e) : t.getColor(e.id);
  }
}
class Ug {
  static from(e) {
    return e instanceof Ug ? e : new Ug(e);
  }
  constructor(e) {
    this.content = e.content || "", this.inlineClassName = e.inlineClassName || null, this.inlineClassNameAffectsLetterSpacing = e.inlineClassNameAffectsLetterSpacing || !1, this.attachedData = e.attachedData || null, this.cursorStops = e.cursorStops || null;
  }
}
class Lt {
  static register(e) {
    return new Lt(e);
  }
  static createDynamic(e) {
    return new Lt(e);
  }
  constructor(e) {
    var t, n, r, s, o, a;
    this.description = e.description, this.blockClassName = e.blockClassName ? ju(e.blockClassName) : null, this.blockDoesNotCollapse = (t = e.blockDoesNotCollapse) !== null && t !== void 0 ? t : null, this.blockIsAfterEnd = (n = e.blockIsAfterEnd) !== null && n !== void 0 ? n : null, this.blockPadding = (r = e.blockPadding) !== null && r !== void 0 ? r : null, this.stickiness = e.stickiness || 0, this.zIndex = e.zIndex || 0, this.className = e.className ? ju(e.className) : null, this.shouldFillLineOnLineBreak = (s = e.shouldFillLineOnLineBreak) !== null && s !== void 0 ? s : null, this.hoverMessage = e.hoverMessage || null, this.glyphMarginHoverMessage = e.glyphMarginHoverMessage || null, this.isWholeLine = e.isWholeLine || !1, this.showIfCollapsed = e.showIfCollapsed || !1, this.collapseOnReplaceEdit = e.collapseOnReplaceEdit || !1, this.overviewRuler = e.overviewRuler ? new FVe(e.overviewRuler) : null, this.minimap = e.minimap ? new VVe(e.minimap) : null, this.glyphMargin = e.glyphMarginClassName ? new BVe(e.glyphMargin) : null, this.glyphMarginClassName = e.glyphMarginClassName ? ju(e.glyphMarginClassName) : null, this.linesDecorationsClassName = e.linesDecorationsClassName ? ju(e.linesDecorationsClassName) : null, this.firstLineDecorationClassName = e.firstLineDecorationClassName ? ju(e.firstLineDecorationClassName) : null, this.marginClassName = e.marginClassName ? ju(e.marginClassName) : null, this.inlineClassName = e.inlineClassName ? ju(e.inlineClassName) : null, this.inlineClassNameAffectsLetterSpacing = e.inlineClassNameAffectsLetterSpacing || !1, this.beforeContentClassName = e.beforeContentClassName ? ju(e.beforeContentClassName) : null, this.afterContentClassName = e.afterContentClassName ? ju(e.afterContentClassName) : null, this.after = e.after ? Ug.from(e.after) : null, this.before = e.before ? Ug.from(e.before) : null, this.hideInCommentTokens = (o = e.hideInCommentTokens) !== null && o !== void 0 ? o : !1, this.hideInStringTokens = (a = e.hideInStringTokens) !== null && a !== void 0 ? a : !1;
  }
}
Lt.EMPTY = Lt.register({ description: "empty" });
const aQ = [
  Lt.register({
    description: "tracked-range-always-grows-when-typing-at-edges",
    stickiness: 0
    /* model.TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */
  }),
  Lt.register({
    description: "tracked-range-never-grows-when-typing-at-edges",
    stickiness: 1
    /* model.TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
  }),
  Lt.register({
    description: "tracked-range-grows-only-when-typing-before",
    stickiness: 2
    /* model.TrackedRangeStickiness.GrowsOnlyWhenTypingBefore */
  }),
  Lt.register({
    description: "tracked-range-grows-only-when-typing-after",
    stickiness: 3
    /* model.TrackedRangeStickiness.GrowsOnlyWhenTypingAfter */
  })
];
function lQ(i) {
  return i instanceof Lt ? i : Lt.createDynamic(i);
}
class HVe extends we {
  constructor(e) {
    super(), this.handleBeforeFire = e, this._actual = this._register(new pe()), this.event = this._actual.event, this._affectedInjectedTextLines = null, this._deferredCnt = 0, this._shouldFireDeferred = !1, this._affectsMinimap = !1, this._affectsOverviewRuler = !1, this._affectsGlyphMargin = !1;
  }
  beginDeferredEmit() {
    this._deferredCnt++;
  }
  endDeferredEmit() {
    var e;
    this._deferredCnt--, this._deferredCnt === 0 && (this._shouldFireDeferred && this.doFire(), (e = this._affectedInjectedTextLines) === null || e === void 0 || e.clear(), this._affectedInjectedTextLines = null);
  }
  recordLineAffectedByInjectedText(e) {
    this._affectedInjectedTextLines || (this._affectedInjectedTextLines = /* @__PURE__ */ new Set()), this._affectedInjectedTextLines.add(e);
  }
  checkAffectedAndFire(e) {
    this._affectsMinimap || (this._affectsMinimap = !!(e.minimap && e.minimap.position)), this._affectsOverviewRuler || (this._affectsOverviewRuler = !!(e.overviewRuler && e.overviewRuler.color)), this._affectsGlyphMargin || (this._affectsGlyphMargin = !!e.glyphMarginClassName), this.tryFire();
  }
  fire() {
    this._affectsMinimap = !0, this._affectsOverviewRuler = !0, this._affectsGlyphMargin = !0, this.tryFire();
  }
  tryFire() {
    this._deferredCnt === 0 ? this.doFire() : this._shouldFireDeferred = !0;
  }
  doFire() {
    this.handleBeforeFire(this._affectedInjectedTextLines);
    const e = {
      affectsMinimap: this._affectsMinimap,
      affectsOverviewRuler: this._affectsOverviewRuler,
      affectsGlyphMargin: this._affectsGlyphMargin
    };
    this._shouldFireDeferred = !1, this._affectsMinimap = !1, this._affectsOverviewRuler = !1, this._affectsGlyphMargin = !1, this._actual.fire(e);
  }
}
class WVe extends we {
  constructor() {
    super(), this._fastEmitter = this._register(new pe()), this.fastEvent = this._fastEmitter.event, this._slowEmitter = this._register(new pe()), this.slowEvent = this._slowEmitter.event, this._deferredCnt = 0, this._deferredEvent = null;
  }
  beginDeferredEmit() {
    this._deferredCnt++;
  }
  endDeferredEmit(e = null) {
    if (this._deferredCnt--, this._deferredCnt === 0 && this._deferredEvent !== null) {
      this._deferredEvent.rawContentChangedEvent.resultingSelection = e;
      const t = this._deferredEvent;
      this._deferredEvent = null, this._fastEmitter.fire(t), this._slowEmitter.fire(t);
    }
  }
  fire(e) {
    if (this._deferredCnt > 0) {
      this._deferredEvent ? this._deferredEvent = this._deferredEvent.merge(e) : this._deferredEvent = e;
      return;
    }
    this._fastEmitter.fire(e), this._slowEmitter.fire(e);
  }
}
class jVe {
  constructor() {
    this._onDidChangeVisibleRanges = new pe(), this.onDidChangeVisibleRanges = this._onDidChangeVisibleRanges.event, this._views = /* @__PURE__ */ new Set();
  }
  attachView() {
    const e = new zVe((t) => {
      this._onDidChangeVisibleRanges.fire({ view: e, state: t });
    });
    return this._views.add(e), e;
  }
  detachView(e) {
    this._views.delete(e), this._onDidChangeVisibleRanges.fire({ view: e, state: void 0 });
  }
}
class zVe {
  constructor(e) {
    this.handleStateChange = e;
  }
  setVisibleLines(e, t) {
    const n = e.map((r) => new Qt(r.startLineNumber, r.endLineNumber + 1));
    this.handleStateChange({ visibleLineRanges: n, stabilized: t });
  }
}
class SL {
  constructor(e) {
    this._selTrackedRange = null, this._trackSelection = !0, this._setState(e, new is(new V(1, 1, 1, 1), 0, 0, new ve(1, 1), 0), new is(new V(1, 1, 1, 1), 0, 0, new ve(1, 1), 0));
  }
  dispose(e) {
    this._removeTrackedRange(e);
  }
  startTrackingSelection(e) {
    this._trackSelection = !0, this._updateTrackedRange(e);
  }
  stopTrackingSelection(e) {
    this._trackSelection = !1, this._removeTrackedRange(e);
  }
  _updateTrackedRange(e) {
    this._trackSelection && (this._selTrackedRange = e.model._setTrackedRange(
      this._selTrackedRange,
      this.modelState.selection,
      0
      /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */
    ));
  }
  _removeTrackedRange(e) {
    this._selTrackedRange = e.model._setTrackedRange(
      this._selTrackedRange,
      null,
      0
      /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */
    );
  }
  asCursorState() {
    return new dn(this.modelState, this.viewState);
  }
  readSelectionFromMarkers(e) {
    const t = e.model._getTrackedRange(this._selTrackedRange);
    return this.modelState.selection.isEmpty() && !t.isEmpty() ? ot.fromRange(t.collapseToEnd(), this.modelState.selection.getDirection()) : ot.fromRange(t, this.modelState.selection.getDirection());
  }
  ensureValidState(e) {
    this._setState(e, this.modelState, this.viewState);
  }
  setState(e, t, n) {
    this._setState(e, t, n);
  }
  static _validatePositionWithCache(e, t, n, r) {
    return t.equals(n) ? r : e.normalizePosition(
      t,
      2
      /* PositionAffinity.None */
    );
  }
  static _validateViewState(e, t) {
    const n = t.position, r = t.selectionStart.getStartPosition(), s = t.selectionStart.getEndPosition(), o = e.normalizePosition(
      n,
      2
      /* PositionAffinity.None */
    ), a = this._validatePositionWithCache(e, r, n, o), l = this._validatePositionWithCache(e, s, r, a);
    return n.equals(o) && r.equals(a) && s.equals(l) ? t : new is(V.fromPositions(a, l), t.selectionStartKind, t.selectionStartLeftoverVisibleColumns + r.column - a.column, o, t.leftoverVisibleColumns + n.column - o.column);
  }
  _setState(e, t, n) {
    if (n && (n = SL._validateViewState(e.viewModel, n)), t) {
      const r = e.model.validateRange(t.selectionStart), s = t.selectionStart.equalsRange(r) ? t.selectionStartLeftoverVisibleColumns : 0, o = e.model.validatePosition(t.position), a = t.position.equals(o) ? t.leftoverVisibleColumns : 0;
      t = new is(r, t.selectionStartKind, s, o, a);
    } else {
      if (!n)
        return;
      const r = e.model.validateRange(e.coordinatesConverter.convertViewRangeToModelRange(n.selectionStart)), s = e.model.validatePosition(e.coordinatesConverter.convertViewPositionToModelPosition(n.position));
      t = new is(r, n.selectionStartKind, n.selectionStartLeftoverVisibleColumns, s, n.leftoverVisibleColumns);
    }
    if (n) {
      const r = e.coordinatesConverter.validateViewRange(n.selectionStart, t.selectionStart), s = e.coordinatesConverter.validateViewPosition(n.position, t.position);
      n = new is(r, t.selectionStartKind, t.selectionStartLeftoverVisibleColumns, s, t.leftoverVisibleColumns);
    } else {
      const r = e.coordinatesConverter.convertModelPositionToViewPosition(new ve(t.selectionStart.startLineNumber, t.selectionStart.startColumn)), s = e.coordinatesConverter.convertModelPositionToViewPosition(new ve(t.selectionStart.endLineNumber, t.selectionStart.endColumn)), o = new V(r.lineNumber, r.column, s.lineNumber, s.column), a = e.coordinatesConverter.convertModelPositionToViewPosition(t.position);
      n = new is(o, t.selectionStartKind, t.selectionStartLeftoverVisibleColumns, a, t.leftoverVisibleColumns);
    }
    this.modelState = t, this.viewState = n, this._updateTrackedRange(e);
  }
}
class cQ {
  constructor(e) {
    this.context = e, this.cursors = [new SL(e)], this.lastAddedCursorIndex = 0;
  }
  dispose() {
    for (const e of this.cursors)
      e.dispose(this.context);
  }
  startTrackingSelections() {
    for (const e of this.cursors)
      e.startTrackingSelection(this.context);
  }
  stopTrackingSelections() {
    for (const e of this.cursors)
      e.stopTrackingSelection(this.context);
  }
  updateContext(e) {
    this.context = e;
  }
  ensureValidState() {
    for (const e of this.cursors)
      e.ensureValidState(this.context);
  }
  readSelectionFromMarkers() {
    return this.cursors.map((e) => e.readSelectionFromMarkers(this.context));
  }
  getAll() {
    return this.cursors.map((e) => e.asCursorState());
  }
  getViewPositions() {
    return this.cursors.map((e) => e.viewState.position);
  }
  getTopMostViewPosition() {
    return TPe(this.cursors, hl((e) => e.viewState.position, ve.compare)).viewState.position;
  }
  getBottomMostViewPosition() {
    return kPe(this.cursors, hl((e) => e.viewState.position, ve.compare)).viewState.position;
  }
  getSelections() {
    return this.cursors.map((e) => e.modelState.selection);
  }
  getViewSelections() {
    return this.cursors.map((e) => e.viewState.selection);
  }
  setSelections(e) {
    this.setStates(dn.fromModelSelections(e));
  }
  getPrimaryCursor() {
    return this.cursors[0].asCursorState();
  }
  setStates(e) {
    e !== null && (this.cursors[0].setState(this.context, e[0].modelState, e[0].viewState), this._setSecondaryStates(e.slice(1)));
  }
  /**
   * Creates or disposes secondary cursors as necessary to match the number of `secondarySelections`.
   */
  _setSecondaryStates(e) {
    const t = this.cursors.length - 1, n = e.length;
    if (t < n) {
      const r = n - t;
      for (let s = 0; s < r; s++)
        this._addSecondaryCursor();
    } else if (t > n) {
      const r = t - n;
      for (let s = 0; s < r; s++)
        this._removeSecondaryCursor(this.cursors.length - 2);
    }
    for (let r = 0; r < n; r++)
      this.cursors[r + 1].setState(this.context, e[r].modelState, e[r].viewState);
  }
  killSecondaryCursors() {
    this._setSecondaryStates([]);
  }
  _addSecondaryCursor() {
    this.cursors.push(new SL(this.context)), this.lastAddedCursorIndex = this.cursors.length - 1;
  }
  getLastAddedCursorIndex() {
    return this.cursors.length === 1 || this.lastAddedCursorIndex === 0 ? 0 : this.lastAddedCursorIndex;
  }
  _removeSecondaryCursor(e) {
    this.lastAddedCursorIndex >= e + 1 && this.lastAddedCursorIndex--, this.cursors[e + 1].dispose(this.context), this.cursors.splice(e + 1, 1);
  }
  normalize() {
    if (this.cursors.length === 1)
      return;
    const e = this.cursors.slice(0), t = [];
    for (let n = 0, r = e.length; n < r; n++)
      t.push({
        index: n,
        selection: e[n].modelState.selection
      });
    t.sort(hl((n) => n.selection, V.compareRangesUsingStarts));
    for (let n = 0; n < t.length - 1; n++) {
      const r = t[n], s = t[n + 1], o = r.selection, a = s.selection;
      if (!this.context.cursorConfig.multiCursorMergeOverlapping)
        continue;
      let l;
      if (a.isEmpty() || o.isEmpty() ? l = a.getStartPosition().isBeforeOrEqual(o.getEndPosition()) : l = a.getStartPosition().isBefore(o.getEndPosition()), l) {
        const c = r.index < s.index ? n : n + 1, d = r.index < s.index ? n + 1 : n, u = t[d].index, h = t[c].index, f = t[d].selection, g = t[c].selection;
        if (!f.equalsSelection(g)) {
          const p = f.plusRange(g), m = f.selectionStartLineNumber === f.startLineNumber && f.selectionStartColumn === f.startColumn, _ = g.selectionStartLineNumber === g.startLineNumber && g.selectionStartColumn === g.startColumn;
          let b;
          u === this.lastAddedCursorIndex ? (b = m, this.lastAddedCursorIndex = h) : b = _;
          let w;
          b ? w = new ot(p.startLineNumber, p.startColumn, p.endLineNumber, p.endColumn) : w = new ot(p.endLineNumber, p.endColumn, p.startLineNumber, p.startColumn), t[c].selection = w;
          const y = dn.fromModelSelection(w);
          e[h].setState(this.context, y.modelState, y.viewState);
        }
        for (const p of t)
          p.index > u && p.index--;
        e.splice(u, 1), t.splice(d, 1), this._removeSecondaryCursor(u - 1), n--;
      }
    }
  }
}
class dQ {
  constructor(e, t, n, r) {
    this._cursorContextBrand = void 0, this.model = e, this.viewModel = t, this.coordinatesConverter = n, this.cursorConfig = r;
  }
}
class UVe {
  constructor() {
    this.type = 0;
  }
}
class GVe {
  constructor() {
    this.type = 1;
  }
}
class qVe {
  constructor(e) {
    this.type = 2, this._source = e;
  }
  hasChanged(e) {
    return this._source.hasChanged(e);
  }
}
class KVe {
  constructor(e, t, n) {
    this.selections = e, this.modelSelections = t, this.reason = n, this.type = 3;
  }
}
class m1 {
  constructor(e) {
    this.type = 4, e ? (this.affectsMinimap = e.affectsMinimap, this.affectsOverviewRuler = e.affectsOverviewRuler, this.affectsGlyphMargin = e.affectsGlyphMargin) : (this.affectsMinimap = !0, this.affectsOverviewRuler = !0, this.affectsGlyphMargin = !0);
  }
}
class rD {
  constructor() {
    this.type = 5;
  }
}
class YVe {
  constructor(e) {
    this.type = 6, this.isFocused = e;
  }
}
class XVe {
  constructor() {
    this.type = 7;
  }
}
class sD {
  constructor() {
    this.type = 8;
  }
}
class Pge {
  constructor(e, t) {
    this.fromLineNumber = e, this.count = t, this.type = 9;
  }
}
class qF {
  constructor(e, t) {
    this.type = 10, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class KF {
  constructor(e, t) {
    this.type = 11, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class G3 {
  constructor(e, t, n, r, s, o, a) {
    this.source = e, this.minimalReveal = t, this.range = n, this.selections = r, this.verticalType = s, this.revealHorizontal = o, this.scrollType = a, this.type = 12;
  }
}
class ZVe {
  constructor(e) {
    this.type = 13, this.scrollWidth = e.scrollWidth, this.scrollLeft = e.scrollLeft, this.scrollHeight = e.scrollHeight, this.scrollTop = e.scrollTop, this.scrollWidthChanged = e.scrollWidthChanged, this.scrollLeftChanged = e.scrollLeftChanged, this.scrollHeightChanged = e.scrollHeightChanged, this.scrollTopChanged = e.scrollTopChanged;
  }
}
class QVe {
  constructor(e) {
    this.theme = e, this.type = 14;
  }
}
class JVe {
  constructor(e) {
    this.type = 15, this.ranges = e;
  }
}
class $Ve {
  constructor() {
    this.type = 16;
  }
}
let eHe = class {
  constructor() {
    this.type = 17;
  }
};
class tHe extends we {
  constructor() {
    super(), this._onEvent = this._register(new pe()), this.onEvent = this._onEvent.event, this._eventHandlers = [], this._viewEventQueue = null, this._isConsumingViewEventQueue = !1, this._collector = null, this._collectorCnt = 0, this._outgoingEvents = [];
  }
  emitOutgoingEvent(e) {
    this._addOutgoingEvent(e), this._emitOutgoingEvents();
  }
  _addOutgoingEvent(e) {
    for (let t = 0, n = this._outgoingEvents.length; t < n; t++) {
      const r = this._outgoingEvents[t].kind === e.kind ? this._outgoingEvents[t].attemptToMerge(e) : null;
      if (r) {
        this._outgoingEvents[t] = r;
        return;
      }
    }
    this._outgoingEvents.push(e);
  }
  _emitOutgoingEvents() {
    for (; this._outgoingEvents.length > 0; ) {
      if (this._collector || this._isConsumingViewEventQueue)
        return;
      const e = this._outgoingEvents.shift();
      e.isNoOp() || this._onEvent.fire(e);
    }
  }
  addViewEventHandler(e) {
    for (let t = 0, n = this._eventHandlers.length; t < n; t++)
      this._eventHandlers[t] === e && console.warn("Detected duplicate listener in ViewEventDispatcher", e);
    this._eventHandlers.push(e);
  }
  removeViewEventHandler(e) {
    for (let t = 0; t < this._eventHandlers.length; t++)
      if (this._eventHandlers[t] === e) {
        this._eventHandlers.splice(t, 1);
        break;
      }
  }
  beginEmitViewEvents() {
    return this._collectorCnt++, this._collectorCnt === 1 && (this._collector = new nHe()), this._collector;
  }
  endEmitViewEvents() {
    if (this._collectorCnt--, this._collectorCnt === 0) {
      const e = this._collector.outgoingEvents, t = this._collector.viewEvents;
      this._collector = null;
      for (const n of e)
        this._addOutgoingEvent(n);
      t.length > 0 && this._emitMany(t);
    }
    this._emitOutgoingEvents();
  }
  emitSingleViewEvent(e) {
    try {
      this.beginEmitViewEvents().emitViewEvent(e);
    } finally {
      this.endEmitViewEvents();
    }
  }
  _emitMany(e) {
    this._viewEventQueue ? this._viewEventQueue = this._viewEventQueue.concat(e) : this._viewEventQueue = e, this._isConsumingViewEventQueue || this._consumeViewEventQueue();
  }
  _consumeViewEventQueue() {
    try {
      this._isConsumingViewEventQueue = !0, this._doConsumeQueue();
    } finally {
      this._isConsumingViewEventQueue = !1;
    }
  }
  _doConsumeQueue() {
    for (; this._viewEventQueue; ) {
      const e = this._viewEventQueue;
      this._viewEventQueue = null;
      const t = this._eventHandlers.slice(0);
      for (const n of t)
        n.handleEvents(e);
    }
  }
}
class nHe {
  constructor() {
    this.viewEvents = [], this.outgoingEvents = [];
  }
  emitViewEvent(e) {
    this.viewEvents.push(e);
  }
  emitOutgoingEvent(e) {
    this.outgoingEvents.push(e);
  }
}
class Fz {
  constructor(e, t, n, r) {
    this.kind = 0, this._oldContentWidth = e, this._oldContentHeight = t, this.contentWidth = n, this.contentHeight = r, this.contentWidthChanged = this._oldContentWidth !== this.contentWidth, this.contentHeightChanged = this._oldContentHeight !== this.contentHeight;
  }
  isNoOp() {
    return !this.contentWidthChanged && !this.contentHeightChanged;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new Fz(this._oldContentWidth, this._oldContentHeight, e.contentWidth, e.contentHeight);
  }
}
class Bz {
  constructor(e, t) {
    this.kind = 1, this.oldHasFocus = e, this.hasFocus = t;
  }
  isNoOp() {
    return this.oldHasFocus === this.hasFocus;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new Bz(this.oldHasFocus, e.hasFocus);
  }
}
class Vz {
  constructor(e, t, n, r, s, o, a, l) {
    this.kind = 2, this._oldScrollWidth = e, this._oldScrollLeft = t, this._oldScrollHeight = n, this._oldScrollTop = r, this.scrollWidth = s, this.scrollLeft = o, this.scrollHeight = a, this.scrollTop = l, this.scrollWidthChanged = this._oldScrollWidth !== this.scrollWidth, this.scrollLeftChanged = this._oldScrollLeft !== this.scrollLeft, this.scrollHeightChanged = this._oldScrollHeight !== this.scrollHeight, this.scrollTopChanged = this._oldScrollTop !== this.scrollTop;
  }
  isNoOp() {
    return !this.scrollWidthChanged && !this.scrollLeftChanged && !this.scrollHeightChanged && !this.scrollTopChanged;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new Vz(this._oldScrollWidth, this._oldScrollLeft, this._oldScrollHeight, this._oldScrollTop, e.scrollWidth, e.scrollLeft, e.scrollHeight, e.scrollTop);
  }
}
class iHe {
  constructor() {
    this.kind = 3;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class rHe {
  constructor() {
    this.kind = 4;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class xL {
  constructor(e, t, n, r, s, o, a) {
    this.kind = 6, this.oldSelections = e, this.selections = t, this.oldModelVersionId = n, this.modelVersionId = r, this.source = s, this.reason = o, this.reachedMaxCursorCount = a;
  }
  static _selectionsAreEqual(e, t) {
    if (!e && !t)
      return !0;
    if (!e || !t)
      return !1;
    const n = e.length, r = t.length;
    if (n !== r)
      return !1;
    for (let s = 0; s < n; s++)
      if (!e[s].equalsSelection(t[s]))
        return !1;
    return !0;
  }
  isNoOp() {
    return xL._selectionsAreEqual(this.oldSelections, this.selections) && this.oldModelVersionId === this.modelVersionId;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new xL(this.oldSelections, e.selections, this.oldModelVersionId, e.modelVersionId, e.source, e.reason, this.reachedMaxCursorCount || e.reachedMaxCursorCount);
  }
}
class sHe {
  constructor() {
    this.kind = 5;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class oHe {
  constructor(e) {
    this.event = e, this.kind = 7;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class aHe {
  constructor(e) {
    this.event = e, this.kind = 8;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class lHe {
  constructor(e) {
    this.event = e, this.kind = 9;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class cHe {
  constructor(e) {
    this.event = e, this.kind = 10;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class dHe {
  constructor(e) {
    this.event = e, this.kind = 11;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class uHe {
  constructor(e) {
    this.event = e, this.kind = 12;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class hHe extends we {
  constructor(e, t, n, r) {
    super(), this._model = e, this._knownModelVersionId = this._model.getVersionId(), this._viewModel = t, this._coordinatesConverter = n, this.context = new dQ(this._model, this._viewModel, this._coordinatesConverter, r), this._cursors = new cQ(this.context), this._hasFocus = !1, this._isHandling = !1, this._compositionState = null, this._columnSelectData = null, this._autoClosedActions = [], this._prevEditOperationType = 0;
  }
  dispose() {
    this._cursors.dispose(), this._autoClosedActions = An(this._autoClosedActions), super.dispose();
  }
  updateConfiguration(e) {
    this.context = new dQ(this._model, this._viewModel, this._coordinatesConverter, e), this._cursors.updateContext(this.context);
  }
  onLineMappingChanged(e) {
    this._knownModelVersionId === this._model.getVersionId() && this.setStates(e, "viewModel", 0, this.getCursorStates());
  }
  setHasFocus(e) {
    this._hasFocus = e;
  }
  _validateAutoClosedActions() {
    if (this._autoClosedActions.length > 0) {
      const e = this._cursors.getSelections();
      for (let t = 0; t < this._autoClosedActions.length; t++) {
        const n = this._autoClosedActions[t];
        n.isValid(e) || (n.dispose(), this._autoClosedActions.splice(t, 1), t--);
      }
    }
  }
  // ------ some getters/setters
  getPrimaryCursorState() {
    return this._cursors.getPrimaryCursor();
  }
  getLastAddedCursorIndex() {
    return this._cursors.getLastAddedCursorIndex();
  }
  getCursorStates() {
    return this._cursors.getAll();
  }
  setStates(e, t, n, r) {
    let s = !1;
    const o = this.context.cursorConfig.multiCursorLimit;
    r !== null && r.length > o && (r = r.slice(0, o), s = !0);
    const a = OC.from(this._model, this);
    return this._cursors.setStates(r), this._cursors.normalize(), this._columnSelectData = null, this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(e, t, n, a, s);
  }
  setCursorColumnSelectData(e) {
    this._columnSelectData = e;
  }
  revealPrimary(e, t, n, r, s, o) {
    const a = this._cursors.getViewPositions();
    let l = null, c = null;
    a.length > 1 ? c = this._cursors.getViewSelections() : l = V.fromPositions(a[0], a[0]), e.emitViewEvent(new G3(t, n, l, c, r, s, o));
  }
  saveState() {
    const e = [], t = this._cursors.getSelections();
    for (let n = 0, r = t.length; n < r; n++) {
      const s = t[n];
      e.push({
        inSelectionMode: !s.isEmpty(),
        selectionStart: {
          lineNumber: s.selectionStartLineNumber,
          column: s.selectionStartColumn
        },
        position: {
          lineNumber: s.positionLineNumber,
          column: s.positionColumn
        }
      });
    }
    return e;
  }
  restoreState(e, t) {
    const n = [];
    for (let r = 0, s = t.length; r < s; r++) {
      const o = t[r];
      let a = 1, l = 1;
      o.position && o.position.lineNumber && (a = o.position.lineNumber), o.position && o.position.column && (l = o.position.column);
      let c = a, d = l;
      o.selectionStart && o.selectionStart.lineNumber && (c = o.selectionStart.lineNumber), o.selectionStart && o.selectionStart.column && (d = o.selectionStart.column), n.push({
        selectionStartLineNumber: c,
        selectionStartColumn: d,
        positionLineNumber: a,
        positionColumn: l
      });
    }
    this.setStates(e, "restoreState", 0, dn.fromModelSelections(n)), this.revealPrimary(
      e,
      "restoreState",
      !1,
      0,
      !0,
      1
      /* editorCommon.ScrollType.Immediate */
    );
  }
  onModelContentChanged(e, t) {
    if (t instanceof kge) {
      if (this._isHandling)
        return;
      this._isHandling = !0;
      try {
        this.setStates(e, "modelChange", 0, this.getCursorStates());
      } finally {
        this._isHandling = !1;
      }
    } else {
      const n = t.rawContentChangedEvent;
      if (this._knownModelVersionId = n.versionId, this._isHandling)
        return;
      const r = n.containsEvent(
        1
        /* RawContentChangedType.Flush */
      );
      if (this._prevEditOperationType = 0, r)
        this._cursors.dispose(), this._cursors = new cQ(this.context), this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(e, "model", 1, null, !1);
      else if (this._hasFocus && n.resultingSelection && n.resultingSelection.length > 0) {
        const s = dn.fromModelSelections(n.resultingSelection);
        this.setStates(e, "modelChange", n.isUndoing ? 5 : n.isRedoing ? 6 : 2, s) && this.revealPrimary(
          e,
          "modelChange",
          !1,
          0,
          !0,
          0
          /* editorCommon.ScrollType.Smooth */
        );
      } else {
        const s = this._cursors.readSelectionFromMarkers();
        this.setStates(e, "modelChange", 2, dn.fromModelSelections(s));
      }
    }
  }
  getSelection() {
    return this._cursors.getPrimaryCursor().modelState.selection;
  }
  getTopMostViewPosition() {
    return this._cursors.getTopMostViewPosition();
  }
  getBottomMostViewPosition() {
    return this._cursors.getBottomMostViewPosition();
  }
  getCursorColumnSelectData() {
    if (this._columnSelectData)
      return this._columnSelectData;
    const e = this._cursors.getPrimaryCursor(), t = e.viewState.selectionStart.getStartPosition(), n = e.viewState.position;
    return {
      isReal: !1,
      fromViewLineNumber: t.lineNumber,
      fromViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, t),
      toViewLineNumber: n.lineNumber,
      toViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, n)
    };
  }
  getSelections() {
    return this._cursors.getSelections();
  }
  setSelections(e, t, n, r) {
    this.setStates(e, t, r, dn.fromModelSelections(n));
  }
  getPrevEditOperationType() {
    return this._prevEditOperationType;
  }
  setPrevEditOperationType(e) {
    this._prevEditOperationType = e;
  }
  // ------ auxiliary handling logic
  _pushAutoClosedAction(e, t) {
    const n = [], r = [];
    for (let a = 0, l = e.length; a < l; a++)
      n.push({
        range: e[a],
        options: {
          description: "auto-closed-character",
          inlineClassName: "auto-closed-character",
          stickiness: 1
          /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
        }
      }), r.push({
        range: t[a],
        options: {
          description: "auto-closed-enclosing",
          stickiness: 1
          /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
        }
      });
    const s = this._model.deltaDecorations([], n), o = this._model.deltaDecorations([], r);
    this._autoClosedActions.push(new uQ(this._model, s, o));
  }
  _executeEditOperation(e) {
    if (!e)
      return;
    e.shouldPushStackElementBefore && this._model.pushStackElement();
    const t = fHe.executeCommands(this._model, this._cursors.getSelections(), e.commands);
    if (t) {
      this._interpretCommandResult(t);
      const n = [], r = [];
      for (let s = 0; s < e.commands.length; s++) {
        const o = e.commands[s];
        o instanceof nge && o.enclosingRange && o.closeCharacterRange && (n.push(o.closeCharacterRange), r.push(o.enclosingRange));
      }
      n.length > 0 && this._pushAutoClosedAction(n, r), this._prevEditOperationType = e.type;
    }
    e.shouldPushStackElementAfter && this._model.pushStackElement();
  }
  _interpretCommandResult(e) {
    (!e || e.length === 0) && (e = this._cursors.readSelectionFromMarkers()), this._columnSelectData = null, this._cursors.setSelections(e), this._cursors.normalize();
  }
  // -----------------------------------------------------------------------------------------------------------
  // ----- emitting events
  _emitStateChangedIfNecessary(e, t, n, r, s) {
    const o = OC.from(this._model, this);
    if (o.equals(r))
      return !1;
    const a = this._cursors.getSelections(), l = this._cursors.getViewSelections();
    if (e.emitViewEvent(new KVe(l, a, n)), !r || r.cursorState.length !== o.cursorState.length || o.cursorState.some((c, d) => !c.modelState.equals(r.cursorState[d].modelState))) {
      const c = r ? r.cursorState.map((u) => u.modelState.selection) : null, d = r ? r.modelVersionId : 0;
      e.emitOutgoingEvent(new xL(c, a, d, o.modelVersionId, t || "keyboard", n, s));
    }
    return !0;
  }
  // -----------------------------------------------------------------------------------------------------------
  // ----- handlers beyond this point
  _findAutoClosingPairs(e) {
    if (!e.length)
      return null;
    const t = [];
    for (let n = 0, r = e.length; n < r; n++) {
      const s = e[n];
      if (!s.text || s.text.indexOf(`
`) >= 0)
        return null;
      const o = s.text.match(/([)\]}>'"`])([^)\]}>'"`]*)$/);
      if (!o)
        return null;
      const a = o[1], l = this.context.cursorConfig.autoClosingPairs.autoClosingPairsCloseSingleChar.get(a);
      if (!l || l.length !== 1)
        return null;
      const c = l[0].open, d = s.text.length - o[2].length - 1, u = s.text.lastIndexOf(c, d - 1);
      if (u === -1)
        return null;
      t.push([u, d]);
    }
    return t;
  }
  executeEdits(e, t, n, r) {
    let s = null;
    t === "snippet" && (s = this._findAutoClosingPairs(n)), s && (n[0]._isTracked = !0);
    const o = [], a = [], l = this._model.pushEditOperations(this.getSelections(), n, (c) => {
      if (s)
        for (let u = 0, h = s.length; u < h; u++) {
          const [f, g] = s[u], p = c[u], m = p.range.startLineNumber, _ = p.range.startColumn - 1 + f, b = p.range.startColumn - 1 + g;
          o.push(new V(m, b + 1, m, b + 2)), a.push(new V(m, _ + 1, m, b + 2));
        }
      const d = r(c);
      return d && (this._isHandling = !0), d;
    });
    l && (this._isHandling = !1, this.setSelections(
      e,
      t,
      l,
      0
      /* CursorChangeReason.NotSet */
    )), o.length > 0 && this._pushAutoClosedAction(o, a);
  }
  _executeEdit(e, t, n, r = 0) {
    if (this.context.cursorConfig.readOnly)
      return;
    const s = OC.from(this._model, this);
    this._cursors.stopTrackingSelections(), this._isHandling = !0;
    try {
      this._cursors.ensureValidState(), e();
    } catch (o) {
      It(o);
    }
    this._isHandling = !1, this._cursors.startTrackingSelections(), this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(t, n, r, s, !1) && this.revealPrimary(
      t,
      n,
      !1,
      0,
      !0,
      0
      /* editorCommon.ScrollType.Smooth */
    );
  }
  getAutoClosedCharacters() {
    return uQ.getAllAutoClosedCharacters(this._autoClosedActions);
  }
  startComposition(e) {
    this._compositionState = new MC(this._model, this.getSelections());
  }
  endComposition(e, t) {
    const n = this._compositionState ? this._compositionState.deduceOutcome(this._model, this.getSelections()) : null;
    this._compositionState = null, this._executeEdit(() => {
      t === "keyboard" && this._executeEditOperation(wi.compositionEndWithInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, n, this.getSelections(), this.getAutoClosedCharacters()));
    }, e, t);
  }
  type(e, t, n) {
    this._executeEdit(() => {
      if (n === "keyboard") {
        const r = t.length;
        let s = 0;
        for (; s < r; ) {
          const o = Wj(t, s), a = t.substr(s, o);
          this._executeEditOperation(wi.typeWithInterceptors(!!this._compositionState, this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), this.getAutoClosedCharacters(), a)), s += o;
        }
      } else
        this._executeEditOperation(wi.typeWithoutInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), t));
    }, e, n);
  }
  compositionType(e, t, n, r, s, o) {
    if (t.length === 0 && n === 0 && r === 0) {
      if (s !== 0) {
        const a = this.getSelections().map((l) => {
          const c = l.getPosition();
          return new ot(c.lineNumber, c.column + s, c.lineNumber, c.column + s);
        });
        this.setSelections(
          e,
          o,
          a,
          0
          /* CursorChangeReason.NotSet */
        );
      }
      return;
    }
    this._executeEdit(() => {
      this._executeEditOperation(wi.compositionType(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), t, n, r, s));
    }, e, o);
  }
  paste(e, t, n, r, s) {
    this._executeEdit(
      () => {
        this._executeEditOperation(wi.paste(this.context.cursorConfig, this._model, this.getSelections(), t, n, r || []));
      },
      e,
      s,
      4
      /* CursorChangeReason.Paste */
    );
  }
  cut(e, t) {
    this._executeEdit(() => {
      this._executeEditOperation(Zm.cut(this.context.cursorConfig, this._model, this.getSelections()));
    }, e, t);
  }
  executeCommand(e, t, n) {
    this._executeEdit(() => {
      this._cursors.killSecondaryCursors(), this._executeEditOperation(new Do(0, [t], {
        shouldPushStackElementBefore: !1,
        shouldPushStackElementAfter: !1
      }));
    }, e, n);
  }
  executeCommands(e, t, n) {
    this._executeEdit(() => {
      this._executeEditOperation(new Do(0, t, {
        shouldPushStackElementBefore: !1,
        shouldPushStackElementAfter: !1
      }));
    }, e, n);
  }
}
class OC {
  static from(e, t) {
    return new OC(e.getVersionId(), t.getCursorStates());
  }
  constructor(e, t) {
    this.modelVersionId = e, this.cursorState = t;
  }
  equals(e) {
    if (!e || this.modelVersionId !== e.modelVersionId || this.cursorState.length !== e.cursorState.length)
      return !1;
    for (let t = 0, n = this.cursorState.length; t < n; t++)
      if (!this.cursorState[t].equals(e.cursorState[t]))
        return !1;
    return !0;
  }
}
class uQ {
  static getAllAutoClosedCharacters(e) {
    let t = [];
    for (const n of e)
      t = t.concat(n.getAutoClosedCharactersRanges());
    return t;
  }
  constructor(e, t, n) {
    this._model = e, this._autoClosedCharactersDecorations = t, this._autoClosedEnclosingDecorations = n;
  }
  dispose() {
    this._autoClosedCharactersDecorations = this._model.deltaDecorations(this._autoClosedCharactersDecorations, []), this._autoClosedEnclosingDecorations = this._model.deltaDecorations(this._autoClosedEnclosingDecorations, []);
  }
  getAutoClosedCharactersRanges() {
    const e = [];
    for (let t = 0; t < this._autoClosedCharactersDecorations.length; t++) {
      const n = this._model.getDecorationRange(this._autoClosedCharactersDecorations[t]);
      n && e.push(n);
    }
    return e;
  }
  isValid(e) {
    const t = [];
    for (let n = 0; n < this._autoClosedEnclosingDecorations.length; n++) {
      const r = this._model.getDecorationRange(this._autoClosedEnclosingDecorations[n]);
      if (r && (t.push(r), r.startLineNumber !== r.endLineNumber))
        return !1;
    }
    t.sort(V.compareRangesUsingStarts), e.sort(V.compareRangesUsingStarts);
    for (let n = 0; n < e.length; n++)
      if (n >= t.length || !t[n].strictContainsRange(e[n]))
        return !1;
    return !0;
  }
}
class fHe {
  static executeCommands(e, t, n) {
    const r = {
      model: e,
      selectionsBefore: t,
      trackedRanges: [],
      trackedRangesDirection: []
    }, s = this._innerExecuteCommands(r, n);
    for (let o = 0, a = r.trackedRanges.length; o < a; o++)
      r.model._setTrackedRange(
        r.trackedRanges[o],
        null,
        0
        /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */
      );
    return s;
  }
  static _innerExecuteCommands(e, t) {
    if (this._arrayIsEmpty(t))
      return null;
    const n = this._getEditOperations(e, t);
    if (n.operations.length === 0)
      return null;
    const r = n.operations, s = this._getLoserCursorMap(r);
    if (s.hasOwnProperty("0"))
      return console.warn("Ignoring commands"), null;
    const o = [];
    for (let c = 0, d = r.length; c < d; c++)
      s.hasOwnProperty(r[c].identifier.major.toString()) || o.push(r[c]);
    n.hadTrackedEditOperation && o.length > 0 && (o[0]._isTracked = !0);
    let a = e.model.pushEditOperations(e.selectionsBefore, o, (c) => {
      const d = [];
      for (let f = 0; f < e.selectionsBefore.length; f++)
        d[f] = [];
      for (const f of c)
        f.identifier && d[f.identifier.major].push(f);
      const u = (f, g) => f.identifier.minor - g.identifier.minor, h = [];
      for (let f = 0; f < e.selectionsBefore.length; f++)
        d[f].length > 0 ? (d[f].sort(u), h[f] = t[f].computeCursorState(e.model, {
          getInverseEditOperations: () => d[f],
          getTrackedSelection: (g) => {
            const p = parseInt(g, 10), m = e.model._getTrackedRange(e.trackedRanges[p]);
            return e.trackedRangesDirection[p] === 0 ? new ot(m.startLineNumber, m.startColumn, m.endLineNumber, m.endColumn) : new ot(m.endLineNumber, m.endColumn, m.startLineNumber, m.startColumn);
          }
        })) : h[f] = e.selectionsBefore[f];
      return h;
    });
    a || (a = e.selectionsBefore);
    const l = [];
    for (const c in s)
      s.hasOwnProperty(c) && l.push(parseInt(c, 10));
    l.sort((c, d) => d - c);
    for (const c of l)
      a.splice(c, 1);
    return a;
  }
  static _arrayIsEmpty(e) {
    for (let t = 0, n = e.length; t < n; t++)
      if (e[t])
        return !1;
    return !0;
  }
  static _getEditOperations(e, t) {
    let n = [], r = !1;
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s];
      if (a) {
        const l = this._getEditOperationsFromCommand(e, s, a);
        n = n.concat(l.operations), r = r || l.hadTrackedEditOperation;
      }
    }
    return {
      operations: n,
      hadTrackedEditOperation: r
    };
  }
  static _getEditOperationsFromCommand(e, t, n) {
    const r = [];
    let s = 0;
    const o = (u, h, f = !1) => {
      V.isEmpty(u) && h === "" || r.push({
        identifier: {
          major: t,
          minor: s++
        },
        range: u,
        text: h,
        forceMoveMarkers: f,
        isAutoWhitespaceEdit: n.insertsAutoWhitespace
      });
    };
    let a = !1;
    const d = {
      addEditOperation: o,
      addTrackedEditOperation: (u, h, f) => {
        a = !0, o(u, h, f);
      },
      trackSelection: (u, h) => {
        const f = ot.liftSelection(u);
        let g;
        if (f.isEmpty())
          if (typeof h == "boolean")
            h ? g = 2 : g = 3;
          else {
            const _ = e.model.getLineMaxColumn(f.startLineNumber);
            f.startColumn === _ ? g = 2 : g = 3;
          }
        else
          g = 1;
        const p = e.trackedRanges.length, m = e.model._setTrackedRange(null, f, g);
        return e.trackedRanges[p] = m, e.trackedRangesDirection[p] = f.getDirection(), p.toString();
      }
    };
    try {
      n.getEditOperations(e.model, d);
    } catch (u) {
      return It(u), {
        operations: [],
        hadTrackedEditOperation: !1
      };
    }
    return {
      operations: r,
      hadTrackedEditOperation: a
    };
  }
  static _getLoserCursorMap(e) {
    e = e.slice(0), e.sort((n, r) => -V.compareRangesUsingEnds(n.range, r.range));
    const t = {};
    for (let n = 1; n < e.length; n++) {
      const r = e[n - 1], s = e[n];
      if (V.getStartPosition(r.range).isBefore(V.getEndPosition(s.range))) {
        let o;
        r.identifier.major > s.identifier.major ? o = r.identifier.major : o = s.identifier.major, t[o.toString()] = !0;
        for (let a = 0; a < e.length; a++)
          e[a].identifier.major === o && (e.splice(a, 1), a < n && n--, a--);
        n > 0 && n--;
      }
    }
    return t;
  }
}
class gHe {
  constructor(e, t, n) {
    this.text = e, this.startSelection = t, this.endSelection = n;
  }
}
class MC {
  static _capture(e, t) {
    const n = [];
    for (const r of t) {
      if (r.startLineNumber !== r.endLineNumber)
        return null;
      n.push(new gHe(e.getLineContent(r.startLineNumber), r.startColumn - 1, r.endColumn - 1));
    }
    return n;
  }
  constructor(e, t) {
    this._original = MC._capture(e, t);
  }
  /**
   * Returns the inserted text during this composition.
   * If the composition resulted in existing text being changed (i.e. not a pure insertion) it returns null.
   */
  deduceOutcome(e, t) {
    if (!this._original)
      return null;
    const n = MC._capture(e, t);
    if (!n || this._original.length !== n.length)
      return null;
    const r = [];
    for (let s = 0, o = this._original.length; s < o; s++)
      r.push(MC._deduceOutcome(this._original[s], n[s]));
    return r;
  }
  static _deduceOutcome(e, t) {
    const n = Math.min(e.startSelection, t.startSelection, Um(e.text, t.text)), r = Math.min(e.text.length - e.endSelection, t.text.length - t.endSelection, YE(e.text, t.text)), s = e.text.substring(n, e.text.length - r), o = t.text.substring(n, t.text.length - r);
    return new _Fe(s, e.startSelection - n, e.endSelection - n, o, t.startSelection - n, t.endSelection - n);
  }
}
var pHe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const hQ = {
  getInitialState: () => __,
  tokenizeEncoded: (i, e, t) => f4(0, t)
};
function mHe(i, e, t) {
  return pHe(this, void 0, void 0, function* () {
    if (!t)
      return fQ(e, i.languageIdCodec, hQ);
    const n = yield Pi.getOrCreate(t);
    return fQ(e, i.languageIdCodec, n || hQ);
  });
}
function vHe(i, e, t, n, r, s, o) {
  let a = "<div>", l = n, c = 0, d = !0;
  for (let u = 0, h = e.getCount(); u < h; u++) {
    const f = e.getEndOffset(u);
    if (f <= n)
      continue;
    let g = "";
    for (; l < f && l < r; l++) {
      const p = i.charCodeAt(l);
      switch (p) {
        case 9: {
          let m = s - (l + c) % s;
          for (c += m - 1; m > 0; )
            o && d ? (g += "&#160;", d = !1) : (g += " ", d = !0), m--;
          break;
        }
        case 60:
          g += "&lt;", d = !1;
          break;
        case 62:
          g += "&gt;", d = !1;
          break;
        case 38:
          g += "&amp;", d = !1;
          break;
        case 0:
          g += "&#00;", d = !1;
          break;
        case 65279:
        case 8232:
        case 8233:
        case 133:
          g += "�", d = !1;
          break;
        case 13:
          g += "&#8203", d = !1;
          break;
        case 32:
          o && d ? (g += "&#160;", d = !1) : (g += " ", d = !0);
          break;
        default:
          g += String.fromCharCode(p), d = !1;
      }
    }
    if (a += `<span style="${e.getInlineStyle(u, t)}">${g}</span>`, f > r || l >= r)
      break;
  }
  return a += "</div>", a;
}
function fQ(i, e, t) {
  let n = '<div class="monaco-tokenized-source">';
  const r = Cu(i);
  let s = t.getInitialState();
  for (let o = 0, a = r.length; o < a; o++) {
    const l = r[o];
    o > 0 && (n += "<br/>");
    const c = t.tokenizeEncoded(l, !0, s);
    Tr.convertToEndOffset(c.tokens, l.length);
    const u = new Tr(c.tokens, l, e).inflate();
    let h = 0;
    for (let f = 0, g = u.getCount(); f < g; f++) {
      const p = u.getClassName(f), m = u.getEndOffset(f);
      n += `<span class="${p}">${KE(l.substring(h, m))}</span>`, h = m;
    }
    s = c.endState;
  }
  return n += "</div>", n;
}
class _He {
  constructor() {
    this._hasPending = !1, this._inserts = [], this._changes = [], this._removes = [];
  }
  insert(e) {
    this._hasPending = !0, this._inserts.push(e);
  }
  change(e) {
    this._hasPending = !0, this._changes.push(e);
  }
  remove(e) {
    this._hasPending = !0, this._removes.push(e);
  }
  mustCommit() {
    return this._hasPending;
  }
  commit(e) {
    if (!this._hasPending)
      return;
    const t = this._inserts, n = this._changes, r = this._removes;
    this._hasPending = !1, this._inserts = [], this._changes = [], this._removes = [], e._commitPendingChanges(t, n, r);
  }
}
class bHe {
  constructor(e, t, n, r, s) {
    this.id = e, this.afterLineNumber = t, this.ordinal = n, this.height = r, this.minWidth = s, this.prefixSum = 0;
  }
}
let Oge = class YF {
  constructor(e, t, n, r) {
    this._instanceId = mhe(++YF.INSTANCE_COUNT), this._pendingChanges = new _He(), this._lastWhitespaceId = 0, this._arr = [], this._prefixSumValidIndex = -1, this._minWidth = -1, this._lineCount = e, this._lineHeight = t, this._paddingTop = n, this._paddingBottom = r;
  }
  /**
   * Find the insertion index for a new value inside a sorted array of values.
   * If the value is already present in the sorted array, the insertion index will be after the already existing value.
   */
  static findInsertionIndex(e, t, n) {
    let r = 0, s = e.length;
    for (; r < s; ) {
      const o = r + s >>> 1;
      t === e[o].afterLineNumber ? n < e[o].ordinal ? s = o : r = o + 1 : t < e[o].afterLineNumber ? s = o : r = o + 1;
    }
    return r;
  }
  /**
   * Change the height of a line in pixels.
   */
  setLineHeight(e) {
    this._checkPendingChanges(), this._lineHeight = e;
  }
  /**
   * Changes the padding used to calculate vertical offsets.
   */
  setPadding(e, t) {
    this._paddingTop = e, this._paddingBottom = t;
  }
  /**
   * Set the number of lines.
   *
   * @param lineCount New number of lines.
   */
  onFlushed(e) {
    this._checkPendingChanges(), this._lineCount = e;
  }
  changeWhitespace(e) {
    let t = !1;
    try {
      e({
        insertWhitespace: (r, s, o, a) => {
          t = !0, r = r | 0, s = s | 0, o = o | 0, a = a | 0;
          const l = this._instanceId + ++this._lastWhitespaceId;
          return this._pendingChanges.insert(new bHe(l, r, s, o, a)), l;
        },
        changeOneWhitespace: (r, s, o) => {
          t = !0, s = s | 0, o = o | 0, this._pendingChanges.change({ id: r, newAfterLineNumber: s, newHeight: o });
        },
        removeWhitespace: (r) => {
          t = !0, this._pendingChanges.remove({ id: r });
        }
      });
    } finally {
      this._pendingChanges.commit(this);
    }
    return t;
  }
  _commitPendingChanges(e, t, n) {
    if ((e.length > 0 || n.length > 0) && (this._minWidth = -1), e.length + t.length + n.length <= 1) {
      for (const l of e)
        this._insertWhitespace(l);
      for (const l of t)
        this._changeOneWhitespace(l.id, l.newAfterLineNumber, l.newHeight);
      for (const l of n) {
        const c = this._findWhitespaceIndex(l.id);
        c !== -1 && this._removeWhitespace(c);
      }
      return;
    }
    const r = /* @__PURE__ */ new Set();
    for (const l of n)
      r.add(l.id);
    const s = /* @__PURE__ */ new Map();
    for (const l of t)
      s.set(l.id, l);
    const o = (l) => {
      const c = [];
      for (const d of l)
        if (!r.has(d.id)) {
          if (s.has(d.id)) {
            const u = s.get(d.id);
            d.afterLineNumber = u.newAfterLineNumber, d.height = u.newHeight;
          }
          c.push(d);
        }
      return c;
    }, a = o(this._arr).concat(o(e));
    a.sort((l, c) => l.afterLineNumber === c.afterLineNumber ? l.ordinal - c.ordinal : l.afterLineNumber - c.afterLineNumber), this._arr = a, this._prefixSumValidIndex = -1;
  }
  _checkPendingChanges() {
    this._pendingChanges.mustCommit() && this._pendingChanges.commit(this);
  }
  _insertWhitespace(e) {
    const t = YF.findInsertionIndex(this._arr, e.afterLineNumber, e.ordinal);
    this._arr.splice(t, 0, e), this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, t - 1);
  }
  _findWhitespaceIndex(e) {
    const t = this._arr;
    for (let n = 0, r = t.length; n < r; n++)
      if (t[n].id === e)
        return n;
    return -1;
  }
  _changeOneWhitespace(e, t, n) {
    const r = this._findWhitespaceIndex(e);
    if (r !== -1 && (this._arr[r].height !== n && (this._arr[r].height = n, this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, r - 1)), this._arr[r].afterLineNumber !== t)) {
      const s = this._arr[r];
      this._removeWhitespace(r), s.afterLineNumber = t, this._insertWhitespace(s);
    }
  }
  _removeWhitespace(e) {
    this._arr.splice(e, 1), this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, e - 1);
  }
  /**
   * Notify the layouter that lines have been deleted (a continuous zone of lines).
   *
   * @param fromLineNumber The line number at which the deletion started, inclusive
   * @param toLineNumber The line number at which the deletion ended, inclusive
   */
  onLinesDeleted(e, t) {
    this._checkPendingChanges(), e = e | 0, t = t | 0, this._lineCount -= t - e + 1;
    for (let n = 0, r = this._arr.length; n < r; n++) {
      const s = this._arr[n].afterLineNumber;
      e <= s && s <= t ? this._arr[n].afterLineNumber = e - 1 : s > t && (this._arr[n].afterLineNumber -= t - e + 1);
    }
  }
  /**
   * Notify the layouter that lines have been inserted (a continuous zone of lines).
   *
   * @param fromLineNumber The line number at which the insertion started, inclusive
   * @param toLineNumber The line number at which the insertion ended, inclusive.
   */
  onLinesInserted(e, t) {
    this._checkPendingChanges(), e = e | 0, t = t | 0, this._lineCount += t - e + 1;
    for (let n = 0, r = this._arr.length; n < r; n++) {
      const s = this._arr[n].afterLineNumber;
      e <= s && (this._arr[n].afterLineNumber += t - e + 1);
    }
  }
  /**
   * Get the sum of all the whitespaces.
   */
  getWhitespacesTotalHeight() {
    return this._checkPendingChanges(), this._arr.length === 0 ? 0 : this.getWhitespacesAccumulatedHeight(this._arr.length - 1);
  }
  /**
   * Return the sum of the heights of the whitespaces at [0..index].
   * This includes the whitespace at `index`.
   *
   * @param index The index of the whitespace.
   * @return The sum of the heights of all whitespaces before the one at `index`, including the one at `index`.
   */
  getWhitespacesAccumulatedHeight(e) {
    this._checkPendingChanges(), e = e | 0;
    let t = Math.max(0, this._prefixSumValidIndex + 1);
    t === 0 && (this._arr[0].prefixSum = this._arr[0].height, t++);
    for (let n = t; n <= e; n++)
      this._arr[n].prefixSum = this._arr[n - 1].prefixSum + this._arr[n].height;
    return this._prefixSumValidIndex = Math.max(this._prefixSumValidIndex, e), this._arr[e].prefixSum;
  }
  /**
   * Get the sum of heights for all objects.
   *
   * @return The sum of heights for all objects.
   */
  getLinesTotalHeight() {
    this._checkPendingChanges();
    const e = this._lineHeight * this._lineCount, t = this.getWhitespacesTotalHeight();
    return e + t + this._paddingTop + this._paddingBottom;
  }
  /**
   * Returns the accumulated height of whitespaces before the given line number.
   *
   * @param lineNumber The line number
   */
  getWhitespaceAccumulatedHeightBeforeLineNumber(e) {
    this._checkPendingChanges(), e = e | 0;
    const t = this._findLastWhitespaceBeforeLineNumber(e);
    return t === -1 ? 0 : this.getWhitespacesAccumulatedHeight(t);
  }
  _findLastWhitespaceBeforeLineNumber(e) {
    e = e | 0;
    const t = this._arr;
    let n = 0, r = t.length - 1;
    for (; n <= r; ) {
      const o = (r - n | 0) / 2 | 0, a = n + o | 0;
      if (t[a].afterLineNumber < e) {
        if (a + 1 >= t.length || t[a + 1].afterLineNumber >= e)
          return a;
        n = a + 1 | 0;
      } else
        r = a - 1 | 0;
    }
    return -1;
  }
  _findFirstWhitespaceAfterLineNumber(e) {
    e = e | 0;
    const n = this._findLastWhitespaceBeforeLineNumber(e) + 1;
    return n < this._arr.length ? n : -1;
  }
  /**
   * Find the index of the first whitespace which has `afterLineNumber` >= `lineNumber`.
   * @return The index of the first whitespace with `afterLineNumber` >= `lineNumber` or -1 if no whitespace is found.
   */
  getFirstWhitespaceIndexAfterLineNumber(e) {
    return this._checkPendingChanges(), e = e | 0, this._findFirstWhitespaceAfterLineNumber(e);
  }
  /**
   * Get the vertical offset (the sum of heights for all objects above) a certain line number.
   *
   * @param lineNumber The line number
   * @return The sum of heights for all objects above `lineNumber`.
   */
  getVerticalOffsetForLineNumber(e, t = !1) {
    this._checkPendingChanges(), e = e | 0;
    let n;
    e > 1 ? n = this._lineHeight * (e - 1) : n = 0;
    const r = this.getWhitespaceAccumulatedHeightBeforeLineNumber(e - (t ? 1 : 0));
    return n + r + this._paddingTop;
  }
  /**
   * Get the vertical offset (the sum of heights for all objects above) a certain line number.
   *
   * @param lineNumber The line number
   * @return The sum of heights for all objects above `lineNumber`.
   */
  getVerticalOffsetAfterLineNumber(e, t = !1) {
    this._checkPendingChanges(), e = e | 0;
    const n = this._lineHeight * e, r = this.getWhitespaceAccumulatedHeightBeforeLineNumber(e + (t ? 1 : 0));
    return n + r + this._paddingTop;
  }
  /**
   * The maximum min width for all whitespaces.
   */
  getWhitespaceMinWidth() {
    if (this._checkPendingChanges(), this._minWidth === -1) {
      let e = 0;
      for (let t = 0, n = this._arr.length; t < n; t++)
        e = Math.max(e, this._arr[t].minWidth);
      this._minWidth = e;
    }
    return this._minWidth;
  }
  /**
   * Check if `verticalOffset` is below all lines.
   */
  isAfterLines(e) {
    this._checkPendingChanges();
    const t = this.getLinesTotalHeight();
    return e > t;
  }
  isInTopPadding(e) {
    return this._paddingTop === 0 ? !1 : (this._checkPendingChanges(), e < this._paddingTop);
  }
  isInBottomPadding(e) {
    if (this._paddingBottom === 0)
      return !1;
    this._checkPendingChanges();
    const t = this.getLinesTotalHeight();
    return e >= t - this._paddingBottom;
  }
  /**
   * Find the first line number that is at or after vertical offset `verticalOffset`.
   * i.e. if getVerticalOffsetForLine(line) is x and getVerticalOffsetForLine(line + 1) is y, then
   * getLineNumberAtOrAfterVerticalOffset(i) = line, x <= i < y.
   *
   * @param verticalOffset The vertical offset to search at.
   * @return The line number at or after vertical offset `verticalOffset`.
   */
  getLineNumberAtOrAfterVerticalOffset(e) {
    if (this._checkPendingChanges(), e = e | 0, e < 0)
      return 1;
    const t = this._lineCount | 0, n = this._lineHeight;
    let r = 1, s = t;
    for (; r < s; ) {
      const o = (r + s) / 2 | 0, a = this.getVerticalOffsetForLineNumber(o) | 0;
      if (e >= a + n)
        r = o + 1;
      else {
        if (e >= a)
          return o;
        s = o;
      }
    }
    return r > t ? t : r;
  }
  /**
   * Get all the lines and their relative vertical offsets that are positioned between `verticalOffset1` and `verticalOffset2`.
   *
   * @param verticalOffset1 The beginning of the viewport.
   * @param verticalOffset2 The end of the viewport.
   * @return A structure describing the lines positioned between `verticalOffset1` and `verticalOffset2`.
   */
  getLinesViewportData(e, t) {
    this._checkPendingChanges(), e = e | 0, t = t | 0;
    const n = this._lineHeight, r = this.getLineNumberAtOrAfterVerticalOffset(e) | 0, s = this.getVerticalOffsetForLineNumber(r) | 0;
    let o = this._lineCount | 0, a = this.getFirstWhitespaceIndexAfterLineNumber(r) | 0;
    const l = this.getWhitespacesCount() | 0;
    let c, d;
    a === -1 ? (a = l, d = o + 1, c = 0) : (d = this.getAfterLineNumberForWhitespaceIndex(a) | 0, c = this.getHeightForWhitespaceIndex(a) | 0);
    let u = s, h = u;
    const f = 5e5;
    let g = 0;
    s >= f && (g = Math.floor(s / f) * f, g = Math.floor(g / n) * n, h -= g);
    const p = [], m = e + (t - e) / 2;
    let _ = -1;
    for (let S = r; S <= o; S++) {
      if (_ === -1) {
        const x = u, D = u + n;
        (x <= m && m < D || x > m) && (_ = S);
      }
      for (u += n, p[S - r] = h, h += n; d === S; )
        h += c, u += c, a++, a >= l ? d = o + 1 : (d = this.getAfterLineNumberForWhitespaceIndex(a) | 0, c = this.getHeightForWhitespaceIndex(a) | 0);
      if (u >= t) {
        o = S;
        break;
      }
    }
    _ === -1 && (_ = o);
    const b = this.getVerticalOffsetForLineNumber(o) | 0;
    let w = r, y = o;
    return w < y && s < e && w++, w < y && b + n > t && y--, {
      bigNumbersDelta: g,
      startLineNumber: r,
      endLineNumber: o,
      relativeVerticalOffset: p,
      centeredLineNumber: _,
      completelyVisibleStartLineNumber: w,
      completelyVisibleEndLineNumber: y
    };
  }
  getVerticalOffsetForWhitespaceIndex(e) {
    this._checkPendingChanges(), e = e | 0;
    const t = this.getAfterLineNumberForWhitespaceIndex(e);
    let n;
    t >= 1 ? n = this._lineHeight * t : n = 0;
    let r;
    return e > 0 ? r = this.getWhitespacesAccumulatedHeight(e - 1) : r = 0, n + r + this._paddingTop;
  }
  getWhitespaceIndexAtOrAfterVerticallOffset(e) {
    this._checkPendingChanges(), e = e | 0;
    let t = 0, n = this.getWhitespacesCount() - 1;
    if (n < 0)
      return -1;
    const r = this.getVerticalOffsetForWhitespaceIndex(n), s = this.getHeightForWhitespaceIndex(n);
    if (e >= r + s)
      return -1;
    for (; t < n; ) {
      const o = Math.floor((t + n) / 2), a = this.getVerticalOffsetForWhitespaceIndex(o), l = this.getHeightForWhitespaceIndex(o);
      if (e >= a + l)
        t = o + 1;
      else {
        if (e >= a)
          return o;
        n = o;
      }
    }
    return t;
  }
  /**
   * Get exactly the whitespace that is layouted at `verticalOffset`.
   *
   * @param verticalOffset The vertical offset.
   * @return Precisely the whitespace that is layouted at `verticaloffset` or null.
   */
  getWhitespaceAtVerticalOffset(e) {
    this._checkPendingChanges(), e = e | 0;
    const t = this.getWhitespaceIndexAtOrAfterVerticallOffset(e);
    if (t < 0 || t >= this.getWhitespacesCount())
      return null;
    const n = this.getVerticalOffsetForWhitespaceIndex(t);
    if (n > e)
      return null;
    const r = this.getHeightForWhitespaceIndex(t), s = this.getIdForWhitespaceIndex(t), o = this.getAfterLineNumberForWhitespaceIndex(t);
    return {
      id: s,
      afterLineNumber: o,
      verticalOffset: n,
      height: r
    };
  }
  /**
   * Get a list of whitespaces that are positioned between `verticalOffset1` and `verticalOffset2`.
   *
   * @param verticalOffset1 The beginning of the viewport.
   * @param verticalOffset2 The end of the viewport.
   * @return An array with all the whitespaces in the viewport. If no whitespace is in viewport, the array is empty.
   */
  getWhitespaceViewportData(e, t) {
    this._checkPendingChanges(), e = e | 0, t = t | 0;
    const n = this.getWhitespaceIndexAtOrAfterVerticallOffset(e), r = this.getWhitespacesCount() - 1;
    if (n < 0)
      return [];
    const s = [];
    for (let o = n; o <= r; o++) {
      const a = this.getVerticalOffsetForWhitespaceIndex(o), l = this.getHeightForWhitespaceIndex(o);
      if (a >= t)
        break;
      s.push({
        id: this.getIdForWhitespaceIndex(o),
        afterLineNumber: this.getAfterLineNumberForWhitespaceIndex(o),
        verticalOffset: a,
        height: l
      });
    }
    return s;
  }
  /**
   * Get all whitespaces.
   */
  getWhitespaces() {
    return this._checkPendingChanges(), this._arr.slice(0);
  }
  /**
   * The number of whitespaces.
   */
  getWhitespacesCount() {
    return this._checkPendingChanges(), this._arr.length;
  }
  /**
   * Get the `id` for whitespace at index `index`.
   *
   * @param index The index of the whitespace.
   * @return `id` of whitespace at `index`.
   */
  getIdForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e = e | 0, this._arr[e].id;
  }
  /**
   * Get the `afterLineNumber` for whitespace at index `index`.
   *
   * @param index The index of the whitespace.
   * @return `afterLineNumber` of whitespace at `index`.
   */
  getAfterLineNumberForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e = e | 0, this._arr[e].afterLineNumber;
  }
  /**
   * Get the `height` for whitespace at index `index`.
   *
   * @param index The index of the whitespace.
   * @return `height` of whitespace at `index`.
   */
  getHeightForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e = e | 0, this._arr[e].height;
  }
};
Oge.INSTANCE_COUNT = 0;
const CHe = 125;
class $2 {
  constructor(e, t, n, r) {
    e = e | 0, t = t | 0, n = n | 0, r = r | 0, e < 0 && (e = 0), t < 0 && (t = 0), n < 0 && (n = 0), r < 0 && (r = 0), this.width = e, this.contentWidth = t, this.scrollWidth = Math.max(e, t), this.height = n, this.contentHeight = r, this.scrollHeight = Math.max(n, r);
  }
  equals(e) {
    return this.width === e.width && this.contentWidth === e.contentWidth && this.height === e.height && this.contentHeight === e.contentHeight;
  }
}
class yHe extends we {
  constructor(e, t) {
    super(), this._onDidContentSizeChange = this._register(new pe()), this.onDidContentSizeChange = this._onDidContentSizeChange.event, this._dimensions = new $2(0, 0, 0, 0), this._scrollable = this._register(new kS({
      forceIntegerValues: !0,
      smoothScrollDuration: e,
      scheduleAtNextAnimationFrame: t
    })), this.onDidScroll = this._scrollable.onScroll;
  }
  getScrollable() {
    return this._scrollable;
  }
  setSmoothScrollDuration(e) {
    this._scrollable.setSmoothScrollDuration(e);
  }
  validateScrollPosition(e) {
    return this._scrollable.validateScrollPosition(e);
  }
  getScrollDimensions() {
    return this._dimensions;
  }
  setScrollDimensions(e) {
    if (this._dimensions.equals(e))
      return;
    const t = this._dimensions;
    this._dimensions = e, this._scrollable.setScrollDimensions({
      width: e.width,
      scrollWidth: e.scrollWidth,
      height: e.height,
      scrollHeight: e.scrollHeight
    }, !0);
    const n = t.contentWidth !== e.contentWidth, r = t.contentHeight !== e.contentHeight;
    (n || r) && this._onDidContentSizeChange.fire(new Fz(t.contentWidth, t.contentHeight, e.contentWidth, e.contentHeight));
  }
  getFutureScrollPosition() {
    return this._scrollable.getFutureScrollPosition();
  }
  getCurrentScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
  setScrollPositionNow(e) {
    this._scrollable.setScrollPositionNow(e);
  }
  setScrollPositionSmooth(e) {
    this._scrollable.setScrollPositionSmooth(e);
  }
  hasPendingScrollAnimation() {
    return this._scrollable.hasPendingScrollAnimation();
  }
}
class wHe extends we {
  constructor(e, t, n) {
    super(), this._configuration = e;
    const r = this._configuration.options, s = r.get(
      143
      /* EditorOption.layoutInfo */
    ), o = r.get(
      83
      /* EditorOption.padding */
    );
    this._linesLayout = new Oge(t, r.get(
      66
      /* EditorOption.lineHeight */
    ), o.top, o.bottom), this._maxLineWidth = 0, this._overlayWidgetsMinWidth = 0, this._scrollable = this._register(new yHe(0, n)), this._configureSmoothScrollDuration(), this._scrollable.setScrollDimensions(new $2(s.contentWidth, 0, s.height, 0)), this.onDidScroll = this._scrollable.onDidScroll, this.onDidContentSizeChange = this._scrollable.onDidContentSizeChange, this._updateHeight();
  }
  dispose() {
    super.dispose();
  }
  getScrollable() {
    return this._scrollable.getScrollable();
  }
  onHeightMaybeChanged() {
    this._updateHeight();
  }
  _configureSmoothScrollDuration() {
    this._scrollable.setSmoothScrollDuration(this._configuration.options.get(
      113
      /* EditorOption.smoothScrolling */
    ) ? CHe : 0);
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    const t = this._configuration.options;
    if (e.hasChanged(
      66
      /* EditorOption.lineHeight */
    ) && this._linesLayout.setLineHeight(t.get(
      66
      /* EditorOption.lineHeight */
    )), e.hasChanged(
      83
      /* EditorOption.padding */
    )) {
      const n = t.get(
        83
        /* EditorOption.padding */
      );
      this._linesLayout.setPadding(n.top, n.bottom);
    }
    if (e.hasChanged(
      143
      /* EditorOption.layoutInfo */
    )) {
      const n = t.get(
        143
        /* EditorOption.layoutInfo */
      ), r = n.contentWidth, s = n.height, o = this._scrollable.getScrollDimensions(), a = o.contentWidth;
      this._scrollable.setScrollDimensions(new $2(r, o.contentWidth, s, this._getContentHeight(r, s, a)));
    } else
      this._updateHeight();
    e.hasChanged(
      113
      /* EditorOption.smoothScrolling */
    ) && this._configureSmoothScrollDuration();
  }
  onFlushed(e) {
    this._linesLayout.onFlushed(e);
  }
  onLinesDeleted(e, t) {
    this._linesLayout.onLinesDeleted(e, t);
  }
  onLinesInserted(e, t) {
    this._linesLayout.onLinesInserted(e, t);
  }
  // ---- end view event handlers
  _getHorizontalScrollbarHeight(e, t) {
    const r = this._configuration.options.get(
      102
      /* EditorOption.scrollbar */
    );
    return r.horizontal === 2 || e >= t ? 0 : r.horizontalScrollbarSize;
  }
  _getContentHeight(e, t, n) {
    const r = this._configuration.options;
    let s = this._linesLayout.getLinesTotalHeight();
    return r.get(
      104
      /* EditorOption.scrollBeyondLastLine */
    ) ? s += Math.max(0, t - r.get(
      66
      /* EditorOption.lineHeight */
    ) - r.get(
      83
      /* EditorOption.padding */
    ).bottom) : s += this._getHorizontalScrollbarHeight(e, n), s;
  }
  _updateHeight() {
    const e = this._scrollable.getScrollDimensions(), t = e.width, n = e.height, r = e.contentWidth;
    this._scrollable.setScrollDimensions(new $2(t, e.contentWidth, n, this._getContentHeight(t, n, r)));
  }
  // ---- Layouting logic
  getCurrentViewport() {
    const e = this._scrollable.getScrollDimensions(), t = this._scrollable.getCurrentScrollPosition();
    return new oZ(t.scrollTop, t.scrollLeft, e.width, e.height);
  }
  getFutureViewport() {
    const e = this._scrollable.getScrollDimensions(), t = this._scrollable.getFutureScrollPosition();
    return new oZ(t.scrollTop, t.scrollLeft, e.width, e.height);
  }
  _computeContentWidth() {
    const e = this._configuration.options, t = this._maxLineWidth, n = e.get(
      144
      /* EditorOption.wrappingInfo */
    ), r = e.get(
      50
      /* EditorOption.fontInfo */
    ), s = e.get(
      143
      /* EditorOption.layoutInfo */
    );
    if (n.isViewportWrapping) {
      const o = e.get(
        72
        /* EditorOption.minimap */
      );
      return t > s.contentWidth + r.typicalHalfwidthCharacterWidth && o.enabled && o.side === "right" ? t + s.verticalScrollbarWidth : t;
    } else {
      const o = e.get(
        103
        /* EditorOption.scrollBeyondLastColumn */
      ) * r.typicalHalfwidthCharacterWidth, a = this._linesLayout.getWhitespaceMinWidth();
      return Math.max(t + o + s.verticalScrollbarWidth, a, this._overlayWidgetsMinWidth);
    }
  }
  setMaxLineWidth(e) {
    this._maxLineWidth = e, this._updateContentWidth();
  }
  setOverlayWidgetsMinWidth(e) {
    this._overlayWidgetsMinWidth = e, this._updateContentWidth();
  }
  _updateContentWidth() {
    const e = this._scrollable.getScrollDimensions();
    this._scrollable.setScrollDimensions(new $2(e.width, this._computeContentWidth(), e.height, e.contentHeight)), this._updateHeight();
  }
  // ---- view state
  saveState() {
    const e = this._scrollable.getFutureScrollPosition(), t = e.scrollTop, n = this._linesLayout.getLineNumberAtOrAfterVerticalOffset(t), r = this._linesLayout.getWhitespaceAccumulatedHeightBeforeLineNumber(n);
    return {
      scrollTop: t,
      scrollTopWithoutViewZones: t - r,
      scrollLeft: e.scrollLeft
    };
  }
  // ----
  changeWhitespace(e) {
    const t = this._linesLayout.changeWhitespace(e);
    return t && this.onHeightMaybeChanged(), t;
  }
  getVerticalOffsetForLineNumber(e, t = !1) {
    return this._linesLayout.getVerticalOffsetForLineNumber(e, t);
  }
  getVerticalOffsetAfterLineNumber(e, t = !1) {
    return this._linesLayout.getVerticalOffsetAfterLineNumber(e, t);
  }
  isAfterLines(e) {
    return this._linesLayout.isAfterLines(e);
  }
  isInTopPadding(e) {
    return this._linesLayout.isInTopPadding(e);
  }
  isInBottomPadding(e) {
    return this._linesLayout.isInBottomPadding(e);
  }
  getLineNumberAtVerticalOffset(e) {
    return this._linesLayout.getLineNumberAtOrAfterVerticalOffset(e);
  }
  getWhitespaceAtVerticalOffset(e) {
    return this._linesLayout.getWhitespaceAtVerticalOffset(e);
  }
  getLinesViewportData() {
    const e = this.getCurrentViewport();
    return this._linesLayout.getLinesViewportData(e.top, e.top + e.height);
  }
  getLinesViewportDataAtScrollTop(e) {
    const t = this._scrollable.getScrollDimensions();
    return e + t.height > t.scrollHeight && (e = t.scrollHeight - t.height), e < 0 && (e = 0), this._linesLayout.getLinesViewportData(e, e + t.height);
  }
  getWhitespaceViewportData() {
    const e = this.getCurrentViewport();
    return this._linesLayout.getWhitespaceViewportData(e.top, e.top + e.height);
  }
  getWhitespaces() {
    return this._linesLayout.getWhitespaces();
  }
  // ----
  getContentWidth() {
    return this._scrollable.getScrollDimensions().contentWidth;
  }
  getScrollWidth() {
    return this._scrollable.getScrollDimensions().scrollWidth;
  }
  getContentHeight() {
    return this._scrollable.getScrollDimensions().contentHeight;
  }
  getScrollHeight() {
    return this._scrollable.getScrollDimensions().scrollHeight;
  }
  getCurrentScrollLeft() {
    return this._scrollable.getCurrentScrollPosition().scrollLeft;
  }
  getCurrentScrollTop() {
    return this._scrollable.getCurrentScrollPosition().scrollTop;
  }
  validateScrollPosition(e) {
    return this._scrollable.validateScrollPosition(e);
  }
  setScrollPosition(e, t) {
    t === 1 ? this._scrollable.setScrollPositionNow(e) : this._scrollable.setScrollPositionSmooth(e);
  }
  hasPendingScrollAnimation() {
    return this._scrollable.hasPendingScrollAnimation();
  }
  deltaScrollNow(e, t) {
    const n = this._scrollable.getCurrentScrollPosition();
    this._scrollable.setScrollPositionNow({
      scrollLeft: n.scrollLeft + e,
      scrollTop: n.scrollTop + t
    });
  }
}
class SHe {
  constructor(e, t, n, r, s) {
    this.editorId = e, this.model = t, this.configuration = n, this._linesCollection = r, this._coordinatesConverter = s, this._decorationsCache = /* @__PURE__ */ Object.create(null), this._cachedModelDecorationsResolver = null, this._cachedModelDecorationsResolverViewRange = null;
  }
  _clearCachedModelDecorationsResolver() {
    this._cachedModelDecorationsResolver = null, this._cachedModelDecorationsResolverViewRange = null;
  }
  dispose() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  reset() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  onModelDecorationsChanged() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  onLineMappingChanged() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  _getOrCreateViewModelDecoration(e) {
    const t = e.id;
    let n = this._decorationsCache[t];
    if (!n) {
      const r = e.range, s = e.options;
      let o;
      if (s.isWholeLine) {
        const a = this._coordinatesConverter.convertModelPositionToViewPosition(new ve(r.startLineNumber, 1), 0, !1, !0), l = this._coordinatesConverter.convertModelPositionToViewPosition(
          new ve(r.endLineNumber, this.model.getLineMaxColumn(r.endLineNumber)),
          1
          /* PositionAffinity.Right */
        );
        o = new V(a.lineNumber, a.column, l.lineNumber, l.column);
      } else
        o = this._coordinatesConverter.convertModelRangeToViewRange(
          r,
          1
          /* PositionAffinity.Right */
        );
      n = new wfe(o, s), this._decorationsCache[t] = n;
    }
    return n;
  }
  getMinimapDecorationsInRange(e) {
    return this._getDecorationsInRange(e, !0, !1).decorations;
  }
  getDecorationsViewportData(e) {
    let t = this._cachedModelDecorationsResolver !== null;
    return t = t && e.equalsRange(this._cachedModelDecorationsResolverViewRange), t || (this._cachedModelDecorationsResolver = this._getDecorationsInRange(e, !1, !1), this._cachedModelDecorationsResolverViewRange = e), this._cachedModelDecorationsResolver;
  }
  getInlineDecorationsOnLine(e, t = !1, n = !1) {
    const r = new V(e, this._linesCollection.getViewLineMinColumn(e), e, this._linesCollection.getViewLineMaxColumn(e));
    return this._getDecorationsInRange(r, t, n).inlineDecorations[0];
  }
  _getDecorationsInRange(e, t, n) {
    const r = this._linesCollection.getDecorationsInRange(e, this.editorId, HE(this.configuration.options), t, n), s = e.startLineNumber, o = e.endLineNumber, a = [];
    let l = 0;
    const c = [];
    for (let d = s; d <= o; d++)
      c[d - s] = [];
    for (let d = 0, u = r.length; d < u; d++) {
      const h = r[d], f = h.options;
      if (!Hz(this.model, h))
        continue;
      const g = this._getOrCreateViewModelDecoration(h), p = g.range;
      if (a[l++] = g, f.inlineClassName) {
        const m = new SC(
          p,
          f.inlineClassName,
          f.inlineClassNameAffectsLetterSpacing ? 3 : 0
          /* InlineDecorationType.Regular */
        ), _ = Math.max(s, p.startLineNumber), b = Math.min(o, p.endLineNumber);
        for (let w = _; w <= b; w++)
          c[w - s].push(m);
      }
      if (f.beforeContentClassName && s <= p.startLineNumber && p.startLineNumber <= o) {
        const m = new SC(
          new V(p.startLineNumber, p.startColumn, p.startLineNumber, p.startColumn),
          f.beforeContentClassName,
          1
          /* InlineDecorationType.Before */
        );
        c[p.startLineNumber - s].push(m);
      }
      if (f.afterContentClassName && s <= p.endLineNumber && p.endLineNumber <= o) {
        const m = new SC(
          new V(p.endLineNumber, p.endColumn, p.endLineNumber, p.endColumn),
          f.afterContentClassName,
          2
          /* InlineDecorationType.After */
        );
        c[p.endLineNumber - s].push(m);
      }
    }
    return {
      decorations: a,
      inlineDecorations: c
    };
  }
}
function Hz(i, e) {
  return !(e.options.hideInCommentTokens && Wz(i, e) || e.options.hideInStringTokens && jz(i, e));
}
function Wz(i, e) {
  return Mge(
    i,
    e.range,
    (t) => t === 1
    /* StandardTokenType.Comment */
  );
}
function jz(i, e) {
  return Mge(
    i,
    e.range,
    (t) => t === 2
    /* StandardTokenType.String */
  );
}
function Mge(i, e, t) {
  for (let n = e.startLineNumber; n <= e.endLineNumber; n++) {
    const r = i.tokenization.getLineTokens(n), s = n === e.startLineNumber, o = n === e.endLineNumber;
    let a = s ? r.findTokenIndexAtOffset(e.startColumn - 1) : 0;
    for (; a < r.getCount() && !(o && r.getStartOffset(a) > e.endColumn - 1); ) {
      if (!t(r.getStandardTokenType(a)))
        return !1;
      a++;
    }
  }
  return !0;
}
function U6(i, e) {
  return i === null ? e ? DL.INSTANCE : EL.INSTANCE : new xHe(i, e);
}
class xHe {
  constructor(e, t) {
    this._projectionData = e, this._isVisible = t;
  }
  isVisible() {
    return this._isVisible;
  }
  setVisible(e) {
    return this._isVisible = e, this;
  }
  getProjectionData() {
    return this._projectionData;
  }
  getViewLineCount() {
    return this._isVisible ? this._projectionData.getOutputLineCount() : 0;
  }
  getViewLineContent(e, t, n) {
    this._assertVisible();
    const r = n > 0 ? this._projectionData.breakOffsets[n - 1] : 0, s = this._projectionData.breakOffsets[n];
    let o;
    if (this._projectionData.injectionOffsets !== null) {
      const a = this._projectionData.injectionOffsets.map((c, d) => new ld(0, 0, c + 1, this._projectionData.injectionOptions[d], 0));
      o = ld.applyInjectedText(e.getLineContent(t), a).substring(r, s);
    } else
      o = e.getValueInRange({
        startLineNumber: t,
        startColumn: r + 1,
        endLineNumber: t,
        endColumn: s + 1
      });
    return n > 0 && (o = gQ(this._projectionData.wrappedTextIndentLength) + o), o;
  }
  getViewLineLength(e, t, n) {
    return this._assertVisible(), this._projectionData.getLineLength(n);
  }
  getViewLineMinColumn(e, t, n) {
    return this._assertVisible(), this._projectionData.getMinOutputOffset(n) + 1;
  }
  getViewLineMaxColumn(e, t, n) {
    return this._assertVisible(), this._projectionData.getMaxOutputOffset(n) + 1;
  }
  /**
   * Try using {@link getViewLinesData} instead.
  */
  getViewLineData(e, t, n) {
    const r = new Array();
    return this.getViewLinesData(e, t, n, 1, 0, [!0], r), r[0];
  }
  getViewLinesData(e, t, n, r, s, o, a) {
    this._assertVisible();
    const l = this._projectionData, c = l.injectionOffsets, d = l.injectionOptions;
    let u = null;
    if (c) {
      u = [];
      let f = 0, g = 0;
      for (let p = 0; p < l.getOutputLineCount(); p++) {
        const m = new Array();
        u[p] = m;
        const _ = p > 0 ? l.breakOffsets[p - 1] : 0, b = l.breakOffsets[p];
        for (; g < c.length; ) {
          const w = d[g].content.length, y = c[g] + f, S = y + w;
          if (y > b)
            break;
          if (_ < S) {
            const x = d[g];
            if (x.inlineClassName) {
              const D = p > 0 ? l.wrappedTextIndentLength : 0, E = D + Math.max(y - _, 0), L = D + Math.min(S - _, b - _);
              E !== L && m.push(new kOe(E, L, x.inlineClassName, x.inlineClassNameAffectsLetterSpacing));
            }
          }
          if (S <= b)
            f += w, g++;
          else
            break;
        }
      }
    }
    let h;
    c ? h = e.tokenization.getLineTokens(t).withInserted(c.map((f, g) => ({
      offset: f,
      text: d[g].content,
      tokenMetadata: Tr.defaultTokenMetadata
    }))) : h = e.tokenization.getLineTokens(t);
    for (let f = n; f < n + r; f++) {
      const g = s + f - n;
      if (!o[g]) {
        a[g] = null;
        continue;
      }
      a[g] = this._getViewLineData(h, u ? u[f] : null, f);
    }
  }
  _getViewLineData(e, t, n) {
    this._assertVisible();
    const r = this._projectionData, s = n > 0 ? r.wrappedTextIndentLength : 0, o = n > 0 ? r.breakOffsets[n - 1] : 0, a = r.breakOffsets[n], l = e.sliceAndInflate(o, a, s);
    let c = l.getLineContent();
    n > 0 && (c = gQ(r.wrappedTextIndentLength) + c);
    const d = this._projectionData.getMinOutputOffset(n) + 1, u = c.length + 1, h = n + 1 < this.getViewLineCount(), f = n === 0 ? 0 : r.breakOffsetsVisibleColumn[n - 1];
    return new lz(c, h, d, u, f, l, t);
  }
  getModelColumnOfViewPosition(e, t) {
    return this._assertVisible(), this._projectionData.translateToInputOffset(e, t - 1) + 1;
  }
  getViewPositionOfModelPosition(e, t, n = 2) {
    return this._assertVisible(), this._projectionData.translateToOutputPosition(t - 1, n).toPosition(e);
  }
  getViewLineNumberOfModelPosition(e, t) {
    this._assertVisible();
    const n = this._projectionData.translateToOutputPosition(t - 1);
    return e + n.outputLineIndex;
  }
  normalizePosition(e, t, n) {
    const r = t.lineNumber - e;
    return this._projectionData.normalizeOutputPosition(e, t.column - 1, n).toPosition(r);
  }
  getInjectedTextAt(e, t) {
    return this._projectionData.getInjectedText(e, t - 1);
  }
  _assertVisible() {
    if (!this._isVisible)
      throw new Error("Not supported");
  }
}
class DL {
  constructor() {
  }
  isVisible() {
    return !0;
  }
  setVisible(e) {
    return e ? this : EL.INSTANCE;
  }
  getProjectionData() {
    return null;
  }
  getViewLineCount() {
    return 1;
  }
  getViewLineContent(e, t, n) {
    return e.getLineContent(t);
  }
  getViewLineLength(e, t, n) {
    return e.getLineLength(t);
  }
  getViewLineMinColumn(e, t, n) {
    return e.getLineMinColumn(t);
  }
  getViewLineMaxColumn(e, t, n) {
    return e.getLineMaxColumn(t);
  }
  getViewLineData(e, t, n) {
    const r = e.tokenization.getLineTokens(t), s = r.getLineContent();
    return new lz(s, !1, 1, s.length + 1, 0, r.inflate(), null);
  }
  getViewLinesData(e, t, n, r, s, o, a) {
    if (!o[s]) {
      a[s] = null;
      return;
    }
    a[s] = this.getViewLineData(e, t, 0);
  }
  getModelColumnOfViewPosition(e, t) {
    return t;
  }
  getViewPositionOfModelPosition(e, t) {
    return new ve(e, t);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return e;
  }
  normalizePosition(e, t, n) {
    return t;
  }
  getInjectedTextAt(e, t) {
    return null;
  }
}
DL.INSTANCE = new DL();
class EL {
  constructor() {
  }
  isVisible() {
    return !1;
  }
  setVisible(e) {
    return e ? DL.INSTANCE : this;
  }
  getProjectionData() {
    return null;
  }
  getViewLineCount() {
    return 0;
  }
  getViewLineContent(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineLength(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineMinColumn(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineMaxColumn(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineData(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLinesData(e, t, n, r, s, o, a) {
    throw new Error("Not supported");
  }
  getModelColumnOfViewPosition(e, t) {
    throw new Error("Not supported");
  }
  getViewPositionOfModelPosition(e, t) {
    throw new Error("Not supported");
  }
  getViewLineNumberOfModelPosition(e, t) {
    throw new Error("Not supported");
  }
  normalizePosition(e, t, n) {
    throw new Error("Not supported");
  }
  getInjectedTextAt(e, t) {
    throw new Error("Not supported");
  }
}
EL.INSTANCE = new EL();
const G6 = [""];
function gQ(i) {
  if (i >= G6.length)
    for (let e = 1; e <= i; e++)
      G6[e] = DHe(e);
  return G6[i];
}
function DHe(i) {
  return new Array(i + 1).join(" ");
}
class EHe {
  constructor(e, t, n, r, s, o, a, l, c, d) {
    this._editorId = e, this.model = t, this._validModelVersionId = -1, this._domLineBreaksComputerFactory = n, this._monospaceLineBreaksComputerFactory = r, this.fontInfo = s, this.tabSize = o, this.wrappingStrategy = a, this.wrappingColumn = l, this.wrappingIndent = c, this.wordBreak = d, this._constructLines(
      /*resetHiddenAreas*/
      !0,
      null
    );
  }
  dispose() {
    this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []);
  }
  createCoordinatesConverter() {
    return new IHe(this);
  }
  _constructLines(e, t) {
    this.modelLineProjections = [], e && (this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []));
    const n = this.model.getLinesContent(), r = this.model.getInjectedTextDecorations(this._editorId), s = n.length, o = this.createLineBreaksComputer(), a = new Xh(ld.fromDecorations(r));
    for (let p = 0; p < s; p++) {
      const m = a.takeWhile((_) => _.lineNumber === p + 1);
      o.addRequest(n[p], m, t ? t[p] : null);
    }
    const l = o.finalize(), c = [], d = this.hiddenAreasDecorationIds.map((p) => this.model.getDecorationRange(p)).sort(V.compareRangesUsingStarts);
    let u = 1, h = 0, f = -1, g = f + 1 < d.length ? h + 1 : s + 2;
    for (let p = 0; p < s; p++) {
      const m = p + 1;
      m === g && (f++, u = d[f].startLineNumber, h = d[f].endLineNumber, g = f + 1 < d.length ? h + 1 : s + 2);
      const _ = m >= u && m <= h, b = U6(l[p], !_);
      c[p] = b.getViewLineCount(), this.modelLineProjections[p] = b;
    }
    this._validModelVersionId = this.model.getVersionId(), this.projectedModelLineLineCounts = new dPe(c);
  }
  getHiddenAreas() {
    return this.hiddenAreasDecorationIds.map((e) => this.model.getDecorationRange(e));
  }
  setHiddenAreas(e) {
    const t = e.map((h) => this.model.validateRange(h)), n = LHe(t), r = this.hiddenAreasDecorationIds.map((h) => this.model.getDecorationRange(h)).sort(V.compareRangesUsingStarts);
    if (n.length === r.length) {
      let h = !1;
      for (let f = 0; f < n.length; f++)
        if (!n[f].equalsRange(r[f])) {
          h = !0;
          break;
        }
      if (!h)
        return !1;
    }
    const s = n.map((h) => ({
      range: h,
      options: Lt.EMPTY
    }));
    this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, s);
    const o = n;
    let a = 1, l = 0, c = -1, d = c + 1 < o.length ? l + 1 : this.modelLineProjections.length + 2, u = !1;
    for (let h = 0; h < this.modelLineProjections.length; h++) {
      const f = h + 1;
      f === d && (c++, a = o[c].startLineNumber, l = o[c].endLineNumber, d = c + 1 < o.length ? l + 1 : this.modelLineProjections.length + 2);
      let g = !1;
      if (f >= a && f <= l ? this.modelLineProjections[h].isVisible() && (this.modelLineProjections[h] = this.modelLineProjections[h].setVisible(!1), g = !0) : (u = !0, this.modelLineProjections[h].isVisible() || (this.modelLineProjections[h] = this.modelLineProjections[h].setVisible(!0), g = !0)), g) {
        const p = this.modelLineProjections[h].getViewLineCount();
        this.projectedModelLineLineCounts.setValue(h, p);
      }
    }
    return u || this.setHiddenAreas([]), !0;
  }
  modelPositionIsVisible(e, t) {
    return e < 1 || e > this.modelLineProjections.length ? !1 : this.modelLineProjections[e - 1].isVisible();
  }
  getModelLineViewLineCount(e) {
    return e < 1 || e > this.modelLineProjections.length ? 1 : this.modelLineProjections[e - 1].getViewLineCount();
  }
  setTabSize(e) {
    return this.tabSize === e ? !1 : (this.tabSize = e, this._constructLines(
      /*resetHiddenAreas*/
      !1,
      null
    ), !0);
  }
  setWrappingSettings(e, t, n, r, s) {
    const o = this.fontInfo.equals(e), a = this.wrappingStrategy === t, l = this.wrappingColumn === n, c = this.wrappingIndent === r, d = this.wordBreak === s;
    if (o && a && l && c && d)
      return !1;
    const u = o && a && !l && c && d;
    this.fontInfo = e, this.wrappingStrategy = t, this.wrappingColumn = n, this.wrappingIndent = r, this.wordBreak = s;
    let h = null;
    if (u) {
      h = [];
      for (let f = 0, g = this.modelLineProjections.length; f < g; f++)
        h[f] = this.modelLineProjections[f].getProjectionData();
    }
    return this._constructLines(
      /*resetHiddenAreas*/
      !1,
      h
    ), !0;
  }
  createLineBreaksComputer() {
    return (this.wrappingStrategy === "advanced" ? this._domLineBreaksComputerFactory : this._monospaceLineBreaksComputerFactory).createLineBreaksComputer(this.fontInfo, this.tabSize, this.wrappingColumn, this.wrappingIndent, this.wordBreak);
  }
  onModelFlushed() {
    this._constructLines(
      /*resetHiddenAreas*/
      !0,
      null
    );
  }
  onModelLinesDeleted(e, t, n) {
    if (!e || e <= this._validModelVersionId)
      return null;
    const r = t === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, s = this.projectedModelLineLineCounts.getPrefixSum(n);
    return this.modelLineProjections.splice(t - 1, n - t + 1), this.projectedModelLineLineCounts.removeValues(t - 1, n - t + 1), new qF(r, s);
  }
  onModelLinesInserted(e, t, n, r) {
    if (!e || e <= this._validModelVersionId)
      return null;
    const s = t > 2 && !this.modelLineProjections[t - 2].isVisible(), o = t === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1;
    let a = 0;
    const l = [], c = [];
    for (let d = 0, u = r.length; d < u; d++) {
      const h = U6(r[d], !s);
      l.push(h);
      const f = h.getViewLineCount();
      a += f, c[d] = f;
    }
    return this.modelLineProjections = this.modelLineProjections.slice(0, t - 1).concat(l).concat(this.modelLineProjections.slice(t - 1)), this.projectedModelLineLineCounts.insertValues(t - 1, c), new KF(o, o + a - 1);
  }
  onModelLineChanged(e, t, n) {
    if (e !== null && e <= this._validModelVersionId)
      return [!1, null, null, null];
    const r = t - 1, s = this.modelLineProjections[r].getViewLineCount(), o = this.modelLineProjections[r].isVisible(), a = U6(n, o);
    this.modelLineProjections[r] = a;
    const l = this.modelLineProjections[r].getViewLineCount();
    let c = !1, d = 0, u = -1, h = 0, f = -1, g = 0, p = -1;
    s > l ? (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, u = d + l - 1, g = u + 1, p = g + (s - l) - 1, c = !0) : s < l ? (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, u = d + s - 1, h = u + 1, f = h + (l - s) - 1, c = !0) : (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, u = d + l - 1), this.projectedModelLineLineCounts.setValue(r, l);
    const m = d <= u ? new Pge(d, u - d + 1) : null, _ = h <= f ? new KF(h, f) : null, b = g <= p ? new qF(g, p) : null;
    return [c, m, _, b];
  }
  acceptVersionId(e) {
    this._validModelVersionId = e, this.modelLineProjections.length === 1 && !this.modelLineProjections[0].isVisible() && this.setHiddenAreas([]);
  }
  getViewLineCount() {
    return this.projectedModelLineLineCounts.getTotalSum();
  }
  _toValidViewLineNumber(e) {
    if (e < 1)
      return 1;
    const t = this.getViewLineCount();
    return e > t ? t : e | 0;
  }
  getActiveIndentGuide(e, t, n) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t), n = this._toValidViewLineNumber(n);
    const r = this.convertViewPositionToModelPosition(e, this.getViewLineMinColumn(e)), s = this.convertViewPositionToModelPosition(t, this.getViewLineMinColumn(t)), o = this.convertViewPositionToModelPosition(n, this.getViewLineMinColumn(n)), a = this.model.guides.getActiveIndentGuide(r.lineNumber, s.lineNumber, o.lineNumber), l = this.convertModelPositionToViewPosition(a.startLineNumber, 1), c = this.convertModelPositionToViewPosition(a.endLineNumber, this.model.getLineMaxColumn(a.endLineNumber));
    return {
      startLineNumber: l.lineNumber,
      endLineNumber: c.lineNumber,
      indent: a.indent
    };
  }
  // #region ViewLineInfo
  getViewLineInfo(e) {
    e = this._toValidViewLineNumber(e);
    const t = this.projectedModelLineLineCounts.getIndexOf(e - 1), n = t.index, r = t.remainder;
    return new pQ(n + 1, r);
  }
  getMinColumnOfViewLine(e) {
    return this.modelLineProjections[e.modelLineNumber - 1].getViewLineMinColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx);
  }
  getMaxColumnOfViewLine(e) {
    return this.modelLineProjections[e.modelLineNumber - 1].getViewLineMaxColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx);
  }
  getModelStartPositionOfViewLine(e) {
    const t = this.modelLineProjections[e.modelLineNumber - 1], n = t.getViewLineMinColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx), r = t.getModelColumnOfViewPosition(e.modelLineWrappedLineIdx, n);
    return new ve(e.modelLineNumber, r);
  }
  getModelEndPositionOfViewLine(e) {
    const t = this.modelLineProjections[e.modelLineNumber - 1], n = t.getViewLineMaxColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx), r = t.getModelColumnOfViewPosition(e.modelLineWrappedLineIdx, n);
    return new ve(e.modelLineNumber, r);
  }
  getViewLineInfosGroupedByModelRanges(e, t) {
    const n = this.getViewLineInfo(e), r = this.getViewLineInfo(t), s = new Array();
    let o = this.getModelStartPositionOfViewLine(n), a = new Array();
    for (let l = n.modelLineNumber; l <= r.modelLineNumber; l++) {
      const c = this.modelLineProjections[l - 1];
      if (c.isVisible()) {
        const d = l === n.modelLineNumber ? n.modelLineWrappedLineIdx : 0, u = l === r.modelLineNumber ? r.modelLineWrappedLineIdx + 1 : c.getViewLineCount();
        for (let h = d; h < u; h++)
          a.push(new pQ(l, h));
      }
      if (!c.isVisible() && o) {
        const d = new ve(l - 1, this.model.getLineMaxColumn(l - 1) + 1), u = V.fromPositions(o, d);
        s.push(new mQ(u, a)), a = [], o = null;
      } else c.isVisible() && !o && (o = new ve(l, 1));
    }
    if (o) {
      const l = V.fromPositions(o, this.getModelEndPositionOfViewLine(r));
      s.push(new mQ(l, a));
    }
    return s;
  }
  // #endregion
  getViewLinesBracketGuides(e, t, n, r) {
    const s = n ? this.convertViewPositionToModelPosition(n.lineNumber, n.column) : null, o = [];
    for (const a of this.getViewLineInfosGroupedByModelRanges(e, t)) {
      const l = a.modelRange.startLineNumber, c = this.model.guides.getLinesBracketGuides(l, a.modelRange.endLineNumber, s, r);
      for (const d of a.viewLines) {
        const h = c[d.modelLineNumber - l].map((f) => {
          if (f.forWrappedLinesAfterColumn !== -1 && this.modelLineProjections[d.modelLineNumber - 1].getViewPositionOfModelPosition(0, f.forWrappedLinesAfterColumn).lineNumber >= d.modelLineWrappedLineIdx || f.forWrappedLinesBeforeOrAtColumn !== -1 && this.modelLineProjections[d.modelLineNumber - 1].getViewPositionOfModelPosition(0, f.forWrappedLinesBeforeOrAtColumn).lineNumber < d.modelLineWrappedLineIdx)
            return;
          if (!f.horizontalLine)
            return f;
          let g = -1;
          if (f.column !== -1) {
            const _ = this.modelLineProjections[d.modelLineNumber - 1].getViewPositionOfModelPosition(0, f.column);
            if (_.lineNumber === d.modelLineWrappedLineIdx)
              g = _.column;
            else if (_.lineNumber < d.modelLineWrappedLineIdx)
              g = this.getMinColumnOfViewLine(d);
            else if (_.lineNumber > d.modelLineWrappedLineIdx)
              return;
          }
          const p = this.convertModelPositionToViewPosition(d.modelLineNumber, f.horizontalLine.endColumn), m = this.modelLineProjections[d.modelLineNumber - 1].getViewPositionOfModelPosition(0, f.horizontalLine.endColumn);
          return m.lineNumber === d.modelLineWrappedLineIdx ? new gm(f.visibleColumn, g, f.className, new LC(f.horizontalLine.top, p.column), -1, -1) : m.lineNumber < d.modelLineWrappedLineIdx || f.visibleColumn !== -1 ? void 0 : new gm(f.visibleColumn, g, f.className, new LC(f.horizontalLine.top, this.getMaxColumnOfViewLine(d)), -1, -1);
        });
        o.push(h.filter((f) => !!f));
      }
    }
    return o;
  }
  getViewLinesIndentGuides(e, t) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t);
    const n = this.convertViewPositionToModelPosition(e, this.getViewLineMinColumn(e)), r = this.convertViewPositionToModelPosition(t, this.getViewLineMaxColumn(t));
    let s = [];
    const o = [], a = [], l = n.lineNumber - 1, c = r.lineNumber - 1;
    let d = null;
    for (let g = l; g <= c; g++) {
      const p = this.modelLineProjections[g];
      if (p.isVisible()) {
        const m = p.getViewLineNumberOfModelPosition(0, g === l ? n.column : 1), _ = p.getViewLineNumberOfModelPosition(0, this.model.getLineMaxColumn(g + 1)), b = _ - m + 1;
        let w = 0;
        b > 1 && p.getViewLineMinColumn(this.model, g + 1, _) === 1 && (w = m === 0 ? 1 : 2), o.push(b), a.push(w), d === null && (d = new ve(g + 1, 0));
      } else
        d !== null && (s = s.concat(this.model.guides.getLinesIndentGuides(d.lineNumber, g)), d = null);
    }
    d !== null && (s = s.concat(this.model.guides.getLinesIndentGuides(d.lineNumber, r.lineNumber)), d = null);
    const u = t - e + 1, h = new Array(u);
    let f = 0;
    for (let g = 0, p = s.length; g < p; g++) {
      let m = s[g];
      const _ = Math.min(u - f, o[g]), b = a[g];
      let w;
      b === 2 ? w = 0 : b === 1 ? w = 1 : w = _;
      for (let y = 0; y < _; y++)
        y === w && (m = 0), h[f++] = m;
    }
    return h;
  }
  getViewLineContent(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineContent(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineLength(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineLength(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineMinColumn(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineMinColumn(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineMaxColumn(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineMaxColumn(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineData(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineData(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLinesData(e, t, n) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t);
    const r = this.projectedModelLineLineCounts.getIndexOf(e - 1);
    let s = e;
    const o = r.index, a = r.remainder, l = [];
    for (let c = o, d = this.model.getLineCount(); c < d; c++) {
      const u = this.modelLineProjections[c];
      if (!u.isVisible())
        continue;
      const h = c === o ? a : 0;
      let f = u.getViewLineCount() - h, g = !1;
      if (s + f > t && (g = !0, f = t - s + 1), u.getViewLinesData(this.model, c + 1, h, f, s - e, n, l), s += f, g)
        break;
    }
    return l;
  }
  validateViewPosition(e, t, n) {
    e = this._toValidViewLineNumber(e);
    const r = this.projectedModelLineLineCounts.getIndexOf(e - 1), s = r.index, o = r.remainder, a = this.modelLineProjections[s], l = a.getViewLineMinColumn(this.model, s + 1, o), c = a.getViewLineMaxColumn(this.model, s + 1, o);
    t < l && (t = l), t > c && (t = c);
    const d = a.getModelColumnOfViewPosition(o, t);
    return this.model.validatePosition(new ve(s + 1, d)).equals(n) ? new ve(e, t) : this.convertModelPositionToViewPosition(n.lineNumber, n.column);
  }
  validateViewRange(e, t) {
    const n = this.validateViewPosition(e.startLineNumber, e.startColumn, t.getStartPosition()), r = this.validateViewPosition(e.endLineNumber, e.endColumn, t.getEndPosition());
    return new V(n.lineNumber, n.column, r.lineNumber, r.column);
  }
  convertViewPositionToModelPosition(e, t) {
    const n = this.getViewLineInfo(e), r = this.modelLineProjections[n.modelLineNumber - 1].getModelColumnOfViewPosition(n.modelLineWrappedLineIdx, t);
    return this.model.validatePosition(new ve(n.modelLineNumber, r));
  }
  convertViewRangeToModelRange(e) {
    const t = this.convertViewPositionToModelPosition(e.startLineNumber, e.startColumn), n = this.convertViewPositionToModelPosition(e.endLineNumber, e.endColumn);
    return new V(t.lineNumber, t.column, n.lineNumber, n.column);
  }
  convertModelPositionToViewPosition(e, t, n = 2, r = !1, s = !1) {
    const o = this.model.validatePosition(new ve(e, t)), a = o.lineNumber, l = o.column;
    let c = a - 1, d = !1;
    if (s)
      for (; c < this.modelLineProjections.length && !this.modelLineProjections[c].isVisible(); )
        c++, d = !0;
    else
      for (; c > 0 && !this.modelLineProjections[c].isVisible(); )
        c--, d = !0;
    if (c === 0 && !this.modelLineProjections[c].isVisible())
      return new ve(r ? 0 : 1, 1);
    const u = 1 + this.projectedModelLineLineCounts.getPrefixSum(c);
    let h;
    return d ? s ? h = this.modelLineProjections[c].getViewPositionOfModelPosition(u, 1, n) : h = this.modelLineProjections[c].getViewPositionOfModelPosition(u, this.model.getLineMaxColumn(c + 1), n) : h = this.modelLineProjections[a - 1].getViewPositionOfModelPosition(u, l, n), h;
  }
  /**
   * @param affinity The affinity in case of an empty range. Has no effect for non-empty ranges.
  */
  convertModelRangeToViewRange(e, t = 0) {
    if (e.isEmpty()) {
      const n = this.convertModelPositionToViewPosition(e.startLineNumber, e.startColumn, t);
      return V.fromPositions(n);
    } else {
      const n = this.convertModelPositionToViewPosition(
        e.startLineNumber,
        e.startColumn,
        1
        /* PositionAffinity.Right */
      ), r = this.convertModelPositionToViewPosition(
        e.endLineNumber,
        e.endColumn,
        0
        /* PositionAffinity.Left */
      );
      return new V(n.lineNumber, n.column, r.lineNumber, r.column);
    }
  }
  getViewLineNumberOfModelPosition(e, t) {
    let n = e - 1;
    if (this.modelLineProjections[n].isVisible()) {
      const s = 1 + this.projectedModelLineLineCounts.getPrefixSum(n);
      return this.modelLineProjections[n].getViewLineNumberOfModelPosition(s, t);
    }
    for (; n > 0 && !this.modelLineProjections[n].isVisible(); )
      n--;
    if (n === 0 && !this.modelLineProjections[n].isVisible())
      return 1;
    const r = 1 + this.projectedModelLineLineCounts.getPrefixSum(n);
    return this.modelLineProjections[n].getViewLineNumberOfModelPosition(r, this.model.getLineMaxColumn(n + 1));
  }
  getDecorationsInRange(e, t, n, r, s) {
    const o = this.convertViewPositionToModelPosition(e.startLineNumber, e.startColumn), a = this.convertViewPositionToModelPosition(e.endLineNumber, e.endColumn);
    if (a.lineNumber - o.lineNumber <= e.endLineNumber - e.startLineNumber)
      return this.model.getDecorationsInRange(new V(o.lineNumber, 1, a.lineNumber, a.column), t, n, r, s);
    let l = [];
    const c = o.lineNumber - 1, d = a.lineNumber - 1;
    let u = null;
    for (let p = c; p <= d; p++)
      if (this.modelLineProjections[p].isVisible())
        u === null && (u = new ve(p + 1, p === c ? o.column : 1));
      else if (u !== null) {
        const _ = this.model.getLineMaxColumn(p);
        l = l.concat(this.model.getDecorationsInRange(new V(u.lineNumber, u.column, p, _), t, n, r)), u = null;
      }
    u !== null && (l = l.concat(this.model.getDecorationsInRange(new V(u.lineNumber, u.column, a.lineNumber, a.column), t, n, r)), u = null), l.sort((p, m) => {
      const _ = V.compareRangesUsingStarts(p.range, m.range);
      return _ === 0 ? p.id < m.id ? -1 : p.id > m.id ? 1 : 0 : _;
    });
    const h = [];
    let f = 0, g = null;
    for (const p of l) {
      const m = p.id;
      g !== m && (g = m, h[f++] = p);
    }
    return h;
  }
  getInjectedTextAt(e) {
    const t = this.getViewLineInfo(e.lineNumber);
    return this.modelLineProjections[t.modelLineNumber - 1].getInjectedTextAt(t.modelLineWrappedLineIdx, e.column);
  }
  normalizePosition(e, t) {
    const n = this.getViewLineInfo(e.lineNumber);
    return this.modelLineProjections[n.modelLineNumber - 1].normalizePosition(n.modelLineWrappedLineIdx, e, t);
  }
  getLineIndentColumn(e) {
    const t = this.getViewLineInfo(e);
    return t.modelLineWrappedLineIdx === 0 ? this.model.getLineIndentColumn(t.modelLineNumber) : 0;
  }
}
function LHe(i) {
  if (i.length === 0)
    return [];
  const e = i.slice();
  e.sort(V.compareRangesUsingStarts);
  const t = [];
  let n = e[0].startLineNumber, r = e[0].endLineNumber;
  for (let s = 1, o = e.length; s < o; s++) {
    const a = e[s];
    a.startLineNumber > r + 1 ? (t.push(new V(n, 1, r, 1)), n = a.startLineNumber, r = a.endLineNumber) : a.endLineNumber > r && (r = a.endLineNumber);
  }
  return t.push(new V(n, 1, r, 1)), t;
}
class pQ {
  constructor(e, t) {
    this.modelLineNumber = e, this.modelLineWrappedLineIdx = t;
  }
}
class mQ {
  constructor(e, t) {
    this.modelRange = e, this.viewLines = t;
  }
}
class IHe {
  constructor(e) {
    this._lines = e;
  }
  // View -> Model conversion and related methods
  convertViewPositionToModelPosition(e) {
    return this._lines.convertViewPositionToModelPosition(e.lineNumber, e.column);
  }
  convertViewRangeToModelRange(e) {
    return this._lines.convertViewRangeToModelRange(e);
  }
  validateViewPosition(e, t) {
    return this._lines.validateViewPosition(e.lineNumber, e.column, t);
  }
  validateViewRange(e, t) {
    return this._lines.validateViewRange(e, t);
  }
  // Model -> View conversion and related methods
  convertModelPositionToViewPosition(e, t, n, r) {
    return this._lines.convertModelPositionToViewPosition(e.lineNumber, e.column, t, n, r);
  }
  convertModelRangeToViewRange(e, t) {
    return this._lines.convertModelRangeToViewRange(e, t);
  }
  modelPositionIsVisible(e) {
    return this._lines.modelPositionIsVisible(e.lineNumber, e.column);
  }
  getModelLineViewLineCount(e) {
    return this._lines.getModelLineViewLineCount(e);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return this._lines.getViewLineNumberOfModelPosition(e, t);
  }
}
class AHe {
  constructor(e) {
    this.model = e;
  }
  dispose() {
  }
  createCoordinatesConverter() {
    return new kHe(this);
  }
  getHiddenAreas() {
    return [];
  }
  setHiddenAreas(e) {
    return !1;
  }
  setTabSize(e) {
    return !1;
  }
  setWrappingSettings(e, t, n, r) {
    return !1;
  }
  createLineBreaksComputer() {
    const e = [];
    return {
      addRequest: (t, n, r) => {
        e.push(null);
      },
      finalize: () => e
    };
  }
  onModelFlushed() {
  }
  onModelLinesDeleted(e, t, n) {
    return new qF(t, n);
  }
  onModelLinesInserted(e, t, n, r) {
    return new KF(t, n);
  }
  onModelLineChanged(e, t, n) {
    return [!1, new Pge(t, 1), null, null];
  }
  acceptVersionId(e) {
  }
  getViewLineCount() {
    return this.model.getLineCount();
  }
  getActiveIndentGuide(e, t, n) {
    return {
      startLineNumber: e,
      endLineNumber: e,
      indent: 0
    };
  }
  getViewLinesBracketGuides(e, t, n) {
    return new Array(t - e + 1).fill([]);
  }
  getViewLinesIndentGuides(e, t) {
    const n = t - e + 1, r = new Array(n);
    for (let s = 0; s < n; s++)
      r[s] = 0;
    return r;
  }
  getViewLineContent(e) {
    return this.model.getLineContent(e);
  }
  getViewLineLength(e) {
    return this.model.getLineLength(e);
  }
  getViewLineMinColumn(e) {
    return this.model.getLineMinColumn(e);
  }
  getViewLineMaxColumn(e) {
    return this.model.getLineMaxColumn(e);
  }
  getViewLineData(e) {
    const t = this.model.tokenization.getLineTokens(e), n = t.getLineContent();
    return new lz(n, !1, 1, n.length + 1, 0, t.inflate(), null);
  }
  getViewLinesData(e, t, n) {
    const r = this.model.getLineCount();
    e = Math.min(Math.max(1, e), r), t = Math.min(Math.max(1, t), r);
    const s = [];
    for (let o = e; o <= t; o++) {
      const a = o - e;
      s[a] = n[a] ? this.getViewLineData(o) : null;
    }
    return s;
  }
  getDecorationsInRange(e, t, n, r, s) {
    return this.model.getDecorationsInRange(e, t, n, r, s);
  }
  normalizePosition(e, t) {
    return this.model.normalizePosition(e, t);
  }
  getLineIndentColumn(e) {
    return this.model.getLineIndentColumn(e);
  }
  getInjectedTextAt(e) {
    return null;
  }
}
class kHe {
  constructor(e) {
    this._lines = e;
  }
  _validPosition(e) {
    return this._lines.model.validatePosition(e);
  }
  _validRange(e) {
    return this._lines.model.validateRange(e);
  }
  // View -> Model conversion and related methods
  convertViewPositionToModelPosition(e) {
    return this._validPosition(e);
  }
  convertViewRangeToModelRange(e) {
    return this._validRange(e);
  }
  validateViewPosition(e, t) {
    return this._validPosition(t);
  }
  validateViewRange(e, t) {
    return this._validRange(t);
  }
  // Model -> View conversion and related methods
  convertModelPositionToViewPosition(e) {
    return this._validPosition(e);
  }
  convertModelRangeToViewRange(e) {
    return this._validRange(e);
  }
  modelPositionIsVisible(e) {
    const t = this._lines.model.getLineCount();
    return !(e.lineNumber < 1 || e.lineNumber > t);
  }
  getModelLineViewLineCount(e) {
    return 1;
  }
  getViewLineNumberOfModelPosition(e, t) {
    return e;
  }
}
let THe = class extends we {
  constructor(e, t, n, r, s, o, a, l, c) {
    if (super(), this.languageConfigurationService = a, this._themeService = l, this._attachedView = c, this.hiddenAreasModel = new PHe(), this.previousHiddenAreas = [], this._editorId = e, this._configuration = t, this.model = n, this._eventDispatcher = new tHe(), this.onEvent = this._eventDispatcher.onEvent, this.cursorConfig = new h1(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._updateConfigurationViewLineCount = this._register(new Rn(() => this._updateConfigurationViewLineCountNow(), 0)), this._hasFocus = !1, this._viewportStart = zz.create(this.model), this.model.isTooLargeForTokenization())
      this._lines = new AHe(this.model);
    else {
      const d = this._configuration.options, u = d.get(
        50
        /* EditorOption.fontInfo */
      ), h = d.get(
        137
        /* EditorOption.wrappingStrategy */
      ), f = d.get(
        144
        /* EditorOption.wrappingInfo */
      ), g = d.get(
        136
        /* EditorOption.wrappingIndent */
      ), p = d.get(
        128
        /* EditorOption.wordBreak */
      );
      this._lines = new EHe(this._editorId, this.model, r, s, u, this.model.getOptions().tabSize, h, f.wrappingColumn, g, p);
    }
    this.coordinatesConverter = this._lines.createCoordinatesConverter(), this._cursor = this._register(new hHe(n, this, this.coordinatesConverter, this.cursorConfig)), this.viewLayout = this._register(new wHe(this._configuration, this.getLineCount(), o)), this._register(this.viewLayout.onDidScroll((d) => {
      d.scrollTopChanged && this._handleVisibleLinesChanged(), d.scrollTopChanged && this._viewportStart.invalidate(), this._eventDispatcher.emitSingleViewEvent(new ZVe(d)), this._eventDispatcher.emitOutgoingEvent(new Vz(d.oldScrollWidth, d.oldScrollLeft, d.oldScrollHeight, d.oldScrollTop, d.scrollWidth, d.scrollLeft, d.scrollHeight, d.scrollTop));
    })), this._register(this.viewLayout.onDidContentSizeChange((d) => {
      this._eventDispatcher.emitOutgoingEvent(d);
    })), this._decorations = new SHe(this._editorId, this.model, this._configuration, this._lines, this.coordinatesConverter), this._registerModelEvents(), this._register(this._configuration.onDidChangeFast((d) => {
      try {
        const u = this._eventDispatcher.beginEmitViewEvents();
        this._onConfigurationChanged(u, d);
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
    })), this._register(MS.getInstance().onDidChange(() => {
      this._eventDispatcher.emitSingleViewEvent(new $Ve());
    })), this._register(this._themeService.onDidColorThemeChange((d) => {
      this._invalidateDecorationsColorCache(), this._eventDispatcher.emitSingleViewEvent(new QVe(d));
    })), this._updateConfigurationViewLineCountNow();
  }
  dispose() {
    super.dispose(), this._decorations.dispose(), this._lines.dispose(), this._viewportStart.dispose(), this._eventDispatcher.dispose();
  }
  createLineBreaksComputer() {
    return this._lines.createLineBreaksComputer();
  }
  addViewEventHandler(e) {
    this._eventDispatcher.addViewEventHandler(e);
  }
  removeViewEventHandler(e) {
    this._eventDispatcher.removeViewEventHandler(e);
  }
  _updateConfigurationViewLineCountNow() {
    this._configuration.setViewLineCount(this._lines.getViewLineCount());
  }
  getModelVisibleRanges() {
    const e = this.viewLayout.getLinesViewportData(), t = new V(e.startLineNumber, this.getLineMinColumn(e.startLineNumber), e.endLineNumber, this.getLineMaxColumn(e.endLineNumber));
    return this._toModelVisibleRanges(t);
  }
  visibleLinesStabilized() {
    const e = this.getModelVisibleRanges();
    this._attachedView.setVisibleLines(e, !0);
  }
  _handleVisibleLinesChanged() {
    const e = this.getModelVisibleRanges();
    this._attachedView.setVisibleLines(e, !1);
  }
  setHasFocus(e) {
    this._hasFocus = e, this._cursor.setHasFocus(e), this._eventDispatcher.emitSingleViewEvent(new YVe(e)), this._eventDispatcher.emitOutgoingEvent(new Bz(!e, e));
  }
  onCompositionStart() {
    this._eventDispatcher.emitSingleViewEvent(new UVe());
  }
  onCompositionEnd() {
    this._eventDispatcher.emitSingleViewEvent(new GVe());
  }
  _captureStableViewport() {
    if (this._viewportStart.isValid && this.viewLayout.getCurrentScrollTop() > 0) {
      const e = new ve(this._viewportStart.viewLineNumber, this.getLineMinColumn(this._viewportStart.viewLineNumber)), t = this.coordinatesConverter.convertViewPositionToModelPosition(e);
      return new _Q(t, this._viewportStart.startLineDelta);
    }
    return new _Q(null, 0);
  }
  _onConfigurationChanged(e, t) {
    const n = this._captureStableViewport(), r = this._configuration.options, s = r.get(
      50
      /* EditorOption.fontInfo */
    ), o = r.get(
      137
      /* EditorOption.wrappingStrategy */
    ), a = r.get(
      144
      /* EditorOption.wrappingInfo */
    ), l = r.get(
      136
      /* EditorOption.wrappingIndent */
    ), c = r.get(
      128
      /* EditorOption.wordBreak */
    );
    this._lines.setWrappingSettings(s, o, a.wrappingColumn, l, c) && (e.emitViewEvent(new rD()), e.emitViewEvent(new sD()), e.emitViewEvent(new m1(null)), this._cursor.onLineMappingChanged(e), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount()), this._updateConfigurationViewLineCount.schedule()), t.hasChanged(
      90
      /* EditorOption.readOnly */
    ) && (this._decorations.reset(), e.emitViewEvent(new m1(null))), e.emitViewEvent(new qVe(t)), this.viewLayout.onConfigurationChanged(t), n.recoverViewportStart(this.coordinatesConverter, this.viewLayout), h1.shouldRecreate(t) && (this.cursorConfig = new h1(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig));
  }
  _registerModelEvents() {
    this._register(this.model.onDidChangeContentOrInjectedText((e) => {
      try {
        const n = this._eventDispatcher.beginEmitViewEvents();
        let r = !1, s = !1;
        const o = e instanceof Am ? e.rawContentChangedEvent.changes : e.changes, a = e instanceof Am ? e.rawContentChangedEvent.versionId : null, l = this._lines.createLineBreaksComputer();
        for (const u of o)
          switch (u.changeType) {
            case 4: {
              for (let h = 0; h < u.detail.length; h++) {
                const f = u.detail[h];
                let g = u.injectedTexts[h];
                g && (g = g.filter((p) => !p.ownerId || p.ownerId === this._editorId)), l.addRequest(f, g, null);
              }
              break;
            }
            case 2: {
              let h = null;
              u.injectedText && (h = u.injectedText.filter((f) => !f.ownerId || f.ownerId === this._editorId)), l.addRequest(u.detail, h, null);
              break;
            }
          }
        const c = l.finalize(), d = new Xh(c);
        for (const u of o)
          switch (u.changeType) {
            case 1: {
              this._lines.onModelFlushed(), n.emitViewEvent(new rD()), this._decorations.reset(), this.viewLayout.onFlushed(this.getLineCount()), r = !0;
              break;
            }
            case 3: {
              const h = this._lines.onModelLinesDeleted(a, u.fromLineNumber, u.toLineNumber);
              h !== null && (n.emitViewEvent(h), this.viewLayout.onLinesDeleted(h.fromLineNumber, h.toLineNumber)), r = !0;
              break;
            }
            case 4: {
              const h = d.takeCount(u.detail.length), f = this._lines.onModelLinesInserted(a, u.fromLineNumber, u.toLineNumber, h);
              f !== null && (n.emitViewEvent(f), this.viewLayout.onLinesInserted(f.fromLineNumber, f.toLineNumber)), r = !0;
              break;
            }
            case 2: {
              const h = d.dequeue(), [f, g, p, m] = this._lines.onModelLineChanged(a, u.lineNumber, h);
              s = f, g && n.emitViewEvent(g), p && (n.emitViewEvent(p), this.viewLayout.onLinesInserted(p.fromLineNumber, p.toLineNumber)), m && (n.emitViewEvent(m), this.viewLayout.onLinesDeleted(m.fromLineNumber, m.toLineNumber));
              break;
            }
            case 5:
              break;
          }
        a !== null && this._lines.acceptVersionId(a), this.viewLayout.onHeightMaybeChanged(), !r && s && (n.emitViewEvent(new sD()), n.emitViewEvent(new m1(null)), this._cursor.onLineMappingChanged(n), this._decorations.onLineMappingChanged());
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
      const t = this._viewportStart.isValid;
      if (this._viewportStart.invalidate(), this._configuration.setModelLineCount(this.model.getLineCount()), this._updateConfigurationViewLineCountNow(), !this._hasFocus && this.model.getAttachedEditorCount() >= 2 && t) {
        const n = this.model._getTrackedRange(this._viewportStart.modelTrackedRange);
        if (n) {
          const r = this.coordinatesConverter.convertModelPositionToViewPosition(n.getStartPosition()), s = this.viewLayout.getVerticalOffsetForLineNumber(r.lineNumber);
          this.viewLayout.setScrollPosition(
            { scrollTop: s + this._viewportStart.startLineDelta },
            1
            /* ScrollType.Immediate */
          );
        }
      }
      try {
        const n = this._eventDispatcher.beginEmitViewEvents();
        e instanceof Am && n.emitOutgoingEvent(new cHe(e.contentChangedEvent)), this._cursor.onModelContentChanged(n, e);
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
      this._handleVisibleLinesChanged();
    })), this._register(this.model.onDidChangeTokens((e) => {
      const t = [];
      for (let n = 0, r = e.ranges.length; n < r; n++) {
        const s = e.ranges[n], o = this.coordinatesConverter.convertModelPositionToViewPosition(new ve(s.fromLineNumber, 1)).lineNumber, a = this.coordinatesConverter.convertModelPositionToViewPosition(new ve(s.toLineNumber, this.model.getLineMaxColumn(s.toLineNumber))).lineNumber;
        t[n] = {
          fromLineNumber: o,
          toLineNumber: a
        };
      }
      this._eventDispatcher.emitSingleViewEvent(new JVe(t)), this._eventDispatcher.emitOutgoingEvent(new uHe(e));
    })), this._register(this.model.onDidChangeLanguageConfiguration((e) => {
      this._eventDispatcher.emitSingleViewEvent(new XVe()), this.cursorConfig = new h1(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new lHe(e));
    })), this._register(this.model.onDidChangeLanguage((e) => {
      this.cursorConfig = new h1(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new aHe(e));
    })), this._register(this.model.onDidChangeOptions((e) => {
      if (this._lines.setTabSize(this.model.getOptions().tabSize)) {
        try {
          const t = this._eventDispatcher.beginEmitViewEvents();
          t.emitViewEvent(new rD()), t.emitViewEvent(new sD()), t.emitViewEvent(new m1(null)), this._cursor.onLineMappingChanged(t), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount());
        } finally {
          this._eventDispatcher.endEmitViewEvents();
        }
        this._updateConfigurationViewLineCount.schedule();
      }
      this.cursorConfig = new h1(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new dHe(e));
    })), this._register(this.model.onDidChangeDecorations((e) => {
      this._decorations.onModelDecorationsChanged(), this._eventDispatcher.emitSingleViewEvent(new m1(e)), this._eventDispatcher.emitOutgoingEvent(new oHe(e));
    }));
  }
  setHiddenAreas(e, t) {
    this.hiddenAreasModel.setHiddenAreas(t, e);
    const n = this.hiddenAreasModel.getMergedRanges();
    if (n === this.previousHiddenAreas)
      return;
    this.previousHiddenAreas = n;
    const r = this._captureStableViewport();
    let s = !1;
    try {
      const o = this._eventDispatcher.beginEmitViewEvents();
      s = this._lines.setHiddenAreas(n), s && (o.emitViewEvent(new rD()), o.emitViewEvent(new sD()), o.emitViewEvent(new m1(null)), this._cursor.onLineMappingChanged(o), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount()), this.viewLayout.onHeightMaybeChanged()), r.recoverViewportStart(this.coordinatesConverter, this.viewLayout);
    } finally {
      this._eventDispatcher.endEmitViewEvents();
    }
    this._updateConfigurationViewLineCount.schedule(), s && this._eventDispatcher.emitOutgoingEvent(new rHe());
  }
  getVisibleRangesPlusViewportAboveBelow() {
    const e = this._configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    ), t = this._configuration.options.get(
      66
      /* EditorOption.lineHeight */
    ), n = Math.max(20, Math.round(e.height / t)), r = this.viewLayout.getLinesViewportData(), s = Math.max(1, r.completelyVisibleStartLineNumber - n), o = Math.min(this.getLineCount(), r.completelyVisibleEndLineNumber + n);
    return this._toModelVisibleRanges(new V(s, this.getLineMinColumn(s), o, this.getLineMaxColumn(o)));
  }
  getVisibleRanges() {
    const e = this.getCompletelyVisibleViewRange();
    return this._toModelVisibleRanges(e);
  }
  getHiddenAreas() {
    return this._lines.getHiddenAreas();
  }
  _toModelVisibleRanges(e) {
    const t = this.coordinatesConverter.convertViewRangeToModelRange(e), n = this._lines.getHiddenAreas();
    if (n.length === 0)
      return [t];
    const r = [];
    let s = 0, o = t.startLineNumber, a = t.startColumn;
    const l = t.endLineNumber, c = t.endColumn;
    for (let d = 0, u = n.length; d < u; d++) {
      const h = n[d].startLineNumber, f = n[d].endLineNumber;
      f < o || h > l || (o < h && (r[s++] = new V(o, a, h - 1, this.model.getLineMaxColumn(h - 1))), o = f + 1, a = 1);
    }
    return (o < l || o === l && a < c) && (r[s++] = new V(o, a, l, c)), r;
  }
  getCompletelyVisibleViewRange() {
    const e = this.viewLayout.getLinesViewportData(), t = e.completelyVisibleStartLineNumber, n = e.completelyVisibleEndLineNumber;
    return new V(t, this.getLineMinColumn(t), n, this.getLineMaxColumn(n));
  }
  getCompletelyVisibleViewRangeAtScrollTop(e) {
    const t = this.viewLayout.getLinesViewportDataAtScrollTop(e), n = t.completelyVisibleStartLineNumber, r = t.completelyVisibleEndLineNumber;
    return new V(n, this.getLineMinColumn(n), r, this.getLineMaxColumn(r));
  }
  saveState() {
    const e = this.viewLayout.saveState(), t = e.scrollTop, n = this.viewLayout.getLineNumberAtVerticalOffset(t), r = this.coordinatesConverter.convertViewPositionToModelPosition(new ve(n, this.getLineMinColumn(n))), s = this.viewLayout.getVerticalOffsetForLineNumber(n) - t;
    return {
      scrollLeft: e.scrollLeft,
      firstPosition: r,
      firstPositionDeltaTop: s
    };
  }
  reduceRestoreState(e) {
    if (typeof e.firstPosition > "u")
      return this._reduceRestoreStateCompatibility(e);
    const t = this.model.validatePosition(e.firstPosition), n = this.coordinatesConverter.convertModelPositionToViewPosition(t), r = this.viewLayout.getVerticalOffsetForLineNumber(n.lineNumber) - e.firstPositionDeltaTop;
    return {
      scrollLeft: e.scrollLeft,
      scrollTop: r
    };
  }
  _reduceRestoreStateCompatibility(e) {
    return {
      scrollLeft: e.scrollLeft,
      scrollTop: e.scrollTopWithoutViewZones
    };
  }
  getTabSize() {
    return this.model.getOptions().tabSize;
  }
  getLineCount() {
    return this._lines.getViewLineCount();
  }
  /**
   * Gives a hint that a lot of requests are about to come in for these line numbers.
   */
  setViewport(e, t, n) {
    this._viewportStart.update(this, e);
  }
  getActiveIndentGuide(e, t, n) {
    return this._lines.getActiveIndentGuide(e, t, n);
  }
  getLinesIndentGuides(e, t) {
    return this._lines.getViewLinesIndentGuides(e, t);
  }
  getBracketGuidesInRangeByLine(e, t, n, r) {
    return this._lines.getViewLinesBracketGuides(e, t, n, r);
  }
  getLineContent(e) {
    return this._lines.getViewLineContent(e);
  }
  getLineLength(e) {
    return this._lines.getViewLineLength(e);
  }
  getLineMinColumn(e) {
    return this._lines.getViewLineMinColumn(e);
  }
  getLineMaxColumn(e) {
    return this._lines.getViewLineMaxColumn(e);
  }
  getLineFirstNonWhitespaceColumn(e) {
    const t = Js(this.getLineContent(e));
    return t === -1 ? 0 : t + 1;
  }
  getLineLastNonWhitespaceColumn(e) {
    const t = Jc(this.getLineContent(e));
    return t === -1 ? 0 : t + 2;
  }
  getMinimapDecorationsInRange(e) {
    return this._decorations.getMinimapDecorationsInRange(e);
  }
  getDecorationsInViewport(e) {
    return this._decorations.getDecorationsViewportData(e).decorations;
  }
  getInjectedTextAt(e) {
    return this._lines.getInjectedTextAt(e);
  }
  getViewportViewLineRenderingData(e, t) {
    const r = this._decorations.getDecorationsViewportData(e).inlineDecorations[t - e.startLineNumber];
    return this._getViewLineRenderingData(t, r);
  }
  getViewLineRenderingData(e) {
    const t = this._decorations.getInlineDecorationsOnLine(e);
    return this._getViewLineRenderingData(e, t);
  }
  _getViewLineRenderingData(e, t) {
    const n = this.model.mightContainRTL(), r = this.model.mightContainNonBasicASCII(), s = this.getTabSize(), o = this._lines.getViewLineData(e);
    return o.inlineDecorations && (t = [
      ...t,
      ...o.inlineDecorations.map((a) => a.toInlineDecoration(e))
    ]), new Wa(o.minColumn, o.maxColumn, o.content, o.continuesWithWrappedLine, n, r, o.tokens, t, s, o.startVisibleColumn);
  }
  getViewLineData(e) {
    return this._lines.getViewLineData(e);
  }
  getMinimapLinesRenderingData(e, t, n) {
    const r = this._lines.getViewLinesData(e, t, n);
    return new AOe(this.getTabSize(), r);
  }
  getAllOverviewRulerDecorations(e) {
    const t = this.model.getOverviewRulerDecorations(this._editorId, HE(this._configuration.options)), n = new NHe();
    for (const r of t) {
      const s = r.options, o = s.overviewRuler;
      if (!o)
        continue;
      const a = o.position;
      if (a === 0)
        continue;
      const l = o.getColor(e.value), c = this.coordinatesConverter.getViewLineNumberOfModelPosition(r.range.startLineNumber, r.range.startColumn), d = this.coordinatesConverter.getViewLineNumberOfModelPosition(r.range.endLineNumber, r.range.endColumn);
      n.accept(l, s.zIndex, c, d, a);
    }
    return n.asArray;
  }
  _invalidateDecorationsColorCache() {
    const e = this.model.getOverviewRulerDecorations();
    for (const t of e) {
      const n = t.options.overviewRuler;
      n?.invalidateCachedColor();
      const r = t.options.minimap;
      r?.invalidateCachedColor();
    }
  }
  getValueInRange(e, t) {
    const n = this.coordinatesConverter.convertViewRangeToModelRange(e);
    return this.model.getValueInRange(n, t);
  }
  getValueLengthInRange(e, t) {
    const n = this.coordinatesConverter.convertViewRangeToModelRange(e);
    return this.model.getValueLengthInRange(n, t);
  }
  modifyPosition(e, t) {
    const n = this.coordinatesConverter.convertViewPositionToModelPosition(e);
    return this.model.modifyPosition(n, t);
  }
  deduceModelPositionRelativeToViewPosition(e, t, n) {
    const r = this.coordinatesConverter.convertViewPositionToModelPosition(e);
    this.model.getEOL().length === 2 && (t < 0 ? t -= n : t += n);
    const o = this.model.getOffsetAt(r) + t;
    return this.model.getPositionAt(o);
  }
  getPlainTextToCopy(e, t, n) {
    const r = n ? `\r
` : this.model.getEOL();
    e = e.slice(0), e.sort(V.compareRangesUsingStarts);
    let s = !1, o = !1;
    for (const l of e)
      l.isEmpty() ? s = !0 : o = !0;
    if (!o) {
      if (!t)
        return "";
      const l = e.map((d) => d.startLineNumber);
      let c = "";
      for (let d = 0; d < l.length; d++)
        d > 0 && l[d - 1] === l[d] || (c += this.model.getLineContent(l[d]) + r);
      return c;
    }
    if (s && t) {
      const l = [];
      let c = 0;
      for (const d of e) {
        const u = d.startLineNumber;
        d.isEmpty() ? u !== c && l.push(this.model.getLineContent(u)) : l.push(this.model.getValueInRange(
          d,
          n ? 2 : 0
          /* EndOfLinePreference.TextDefined */
        )), c = u;
      }
      return l.length === 1 ? l[0] : l;
    }
    const a = [];
    for (const l of e)
      l.isEmpty() || a.push(this.model.getValueInRange(
        l,
        n ? 2 : 0
        /* EndOfLinePreference.TextDefined */
      ));
    return a.length === 1 ? a[0] : a;
  }
  getRichTextToCopy(e, t) {
    const n = this.model.getLanguageId();
    if (n === Fa || e.length !== 1)
      return null;
    let r = e[0];
    if (r.isEmpty()) {
      if (!t)
        return null;
      const d = r.startLineNumber;
      r = new V(d, this.model.getLineMinColumn(d), d, this.model.getLineMaxColumn(d));
    }
    const s = this._configuration.options.get(
      50
      /* EditorOption.fontInfo */
    ), o = this._getColorMap(), l = /[:;\\\/<>]/.test(s.fontFamily) || s.fontFamily === na.fontFamily;
    let c;
    return l ? c = na.fontFamily : (c = s.fontFamily, c = c.replace(/"/g, "'"), /[,']/.test(c) || /[+ ]/.test(c) && (c = `'${c}'`), c = `${c}, ${na.fontFamily}`), {
      mode: n,
      html: `<div style="color: ${o[
        1
        /* ColorId.DefaultForeground */
      ]};background-color: ${o[
        2
        /* ColorId.DefaultBackground */
      ]};font-family: ${c};font-weight: ${s.fontWeight};font-size: ${s.fontSize}px;line-height: ${s.lineHeight}px;white-space: pre;">` + this._getHTMLToCopy(r, o) + "</div>"
    };
  }
  _getHTMLToCopy(e, t) {
    const n = e.startLineNumber, r = e.startColumn, s = e.endLineNumber, o = e.endColumn, a = this.getTabSize();
    let l = "";
    for (let c = n; c <= s; c++) {
      const d = this.model.tokenization.getLineTokens(c), u = d.getLineContent(), h = c === n ? r - 1 : 0, f = c === s ? o - 1 : u.length;
      u === "" ? l += "<br>" : l += vHe(u, d.inflate(), t, h, f, a, Ls);
    }
    return l;
  }
  _getColorMap() {
    const e = Pi.getColorMap(), t = ["#000000"];
    if (e)
      for (let n = 1, r = e.length; n < r; n++)
        t[n] = ye.Format.CSS.formatHex(e[n]);
    return t;
  }
  //#region cursor operations
  getPrimaryCursorState() {
    return this._cursor.getPrimaryCursorState();
  }
  getLastAddedCursorIndex() {
    return this._cursor.getLastAddedCursorIndex();
  }
  getCursorStates() {
    return this._cursor.getCursorStates();
  }
  setCursorStates(e, t, n) {
    return this._withViewEventsCollector((r) => this._cursor.setStates(r, e, t, n));
  }
  getCursorColumnSelectData() {
    return this._cursor.getCursorColumnSelectData();
  }
  getCursorAutoClosedCharacters() {
    return this._cursor.getAutoClosedCharacters();
  }
  setCursorColumnSelectData(e) {
    this._cursor.setCursorColumnSelectData(e);
  }
  getPrevEditOperationType() {
    return this._cursor.getPrevEditOperationType();
  }
  setPrevEditOperationType(e) {
    this._cursor.setPrevEditOperationType(e);
  }
  getSelection() {
    return this._cursor.getSelection();
  }
  getSelections() {
    return this._cursor.getSelections();
  }
  getPosition() {
    return this._cursor.getPrimaryCursorState().modelState.position;
  }
  setSelections(e, t, n = 0) {
    this._withViewEventsCollector((r) => this._cursor.setSelections(r, e, t, n));
  }
  saveCursorState() {
    return this._cursor.saveState();
  }
  restoreCursorState(e) {
    this._withViewEventsCollector((t) => this._cursor.restoreState(t, e));
  }
  _executeCursorEdit(e) {
    if (this._cursor.context.cursorConfig.readOnly) {
      this._eventDispatcher.emitOutgoingEvent(new sHe());
      return;
    }
    this._withViewEventsCollector(e);
  }
  executeEdits(e, t, n) {
    this._executeCursorEdit((r) => this._cursor.executeEdits(r, e, t, n));
  }
  startComposition() {
    this._executeCursorEdit((e) => this._cursor.startComposition(e));
  }
  endComposition(e) {
    this._executeCursorEdit((t) => this._cursor.endComposition(t, e));
  }
  type(e, t) {
    this._executeCursorEdit((n) => this._cursor.type(n, e, t));
  }
  compositionType(e, t, n, r, s) {
    this._executeCursorEdit((o) => this._cursor.compositionType(o, e, t, n, r, s));
  }
  paste(e, t, n, r) {
    this._executeCursorEdit((s) => this._cursor.paste(s, e, t, n, r));
  }
  cut(e) {
    this._executeCursorEdit((t) => this._cursor.cut(t, e));
  }
  executeCommand(e, t) {
    this._executeCursorEdit((n) => this._cursor.executeCommand(n, e, t));
  }
  executeCommands(e, t) {
    this._executeCursorEdit((n) => this._cursor.executeCommands(n, e, t));
  }
  revealPrimaryCursor(e, t, n = !1) {
    this._withViewEventsCollector((r) => this._cursor.revealPrimary(
      r,
      e,
      n,
      0,
      t,
      0
      /* ScrollType.Smooth */
    ));
  }
  revealTopMostCursor(e) {
    const t = this._cursor.getTopMostViewPosition(), n = new V(t.lineNumber, t.column, t.lineNumber, t.column);
    this._withViewEventsCollector((r) => r.emitViewEvent(new G3(
      e,
      !1,
      n,
      null,
      0,
      !0,
      0
      /* ScrollType.Smooth */
    )));
  }
  revealBottomMostCursor(e) {
    const t = this._cursor.getBottomMostViewPosition(), n = new V(t.lineNumber, t.column, t.lineNumber, t.column);
    this._withViewEventsCollector((r) => r.emitViewEvent(new G3(
      e,
      !1,
      n,
      null,
      0,
      !0,
      0
      /* ScrollType.Smooth */
    )));
  }
  revealRange(e, t, n, r, s) {
    this._withViewEventsCollector((o) => o.emitViewEvent(new G3(e, !1, n, null, r, t, s)));
  }
  //#endregion
  //#region viewLayout
  changeWhitespace(e) {
    this.viewLayout.changeWhitespace(e) && (this._eventDispatcher.emitSingleViewEvent(new eHe()), this._eventDispatcher.emitOutgoingEvent(new iHe()));
  }
  //#endregion
  _withViewEventsCollector(e) {
    try {
      const t = this._eventDispatcher.beginEmitViewEvents();
      return e(t);
    } finally {
      this._eventDispatcher.endEmitViewEvents();
    }
  }
  normalizePosition(e, t) {
    return this._lines.normalizePosition(e, t);
  }
  /**
   * Gets the column at which indentation stops at a given line.
   * @internal
  */
  getLineIndentColumn(e) {
    return this._lines.getLineIndentColumn(e);
  }
};
class zz {
  static create(e) {
    const t = e._setTrackedRange(
      null,
      new V(1, 1, 1, 1),
      1
      /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
    );
    return new zz(e, 1, !1, t, 0);
  }
  get viewLineNumber() {
    return this._viewLineNumber;
  }
  get isValid() {
    return this._isValid;
  }
  get modelTrackedRange() {
    return this._modelTrackedRange;
  }
  get startLineDelta() {
    return this._startLineDelta;
  }
  constructor(e, t, n, r, s) {
    this._model = e, this._viewLineNumber = t, this._isValid = n, this._modelTrackedRange = r, this._startLineDelta = s;
  }
  dispose() {
    this._model._setTrackedRange(
      this._modelTrackedRange,
      null,
      1
      /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
    );
  }
  update(e, t) {
    const n = e.coordinatesConverter.convertViewPositionToModelPosition(new ve(t, e.getLineMinColumn(t))), r = e.model._setTrackedRange(
      this._modelTrackedRange,
      new V(n.lineNumber, n.column, n.lineNumber, n.column),
      1
      /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
    ), s = e.viewLayout.getVerticalOffsetForLineNumber(t), o = e.viewLayout.getCurrentScrollTop();
    this._viewLineNumber = t, this._isValid = !0, this._modelTrackedRange = r, this._startLineDelta = o - s;
  }
  invalidate() {
    this._isValid = !1;
  }
}
class NHe {
  constructor() {
    this._asMap = /* @__PURE__ */ Object.create(null), this.asArray = [];
  }
  accept(e, t, n, r, s) {
    const o = this._asMap[e];
    if (o) {
      const a = o.data, l = a[a.length - 3], c = a[a.length - 1];
      if (l === s && c + 1 >= n) {
        r > c && (a[a.length - 1] = r);
        return;
      }
      a.push(s, n, r);
    } else {
      const a = new Fy(e, t, [s, n, r]);
      this._asMap[e] = a, this.asArray.push(a);
    }
  }
}
class PHe {
  constructor() {
    this.hiddenAreas = /* @__PURE__ */ new Map(), this.shouldRecompute = !1, this.ranges = [];
  }
  setHiddenAreas(e, t) {
    const n = this.hiddenAreas.get(e);
    n && vQ(n, t) || (this.hiddenAreas.set(e, t), this.shouldRecompute = !0);
  }
  /**
   * The returned array is immutable.
  */
  getMergedRanges() {
    if (!this.shouldRecompute)
      return this.ranges;
    this.shouldRecompute = !1;
    const e = Array.from(this.hiddenAreas.values()).reduce((t, n) => OHe(t, n), []);
    return vQ(this.ranges, e) ? this.ranges : (this.ranges = e, this.ranges);
  }
}
function OHe(i, e) {
  const t = [];
  let n = 0, r = 0;
  for (; n < i.length && r < e.length; ) {
    const s = i[n], o = e[r];
    if (s.endLineNumber < o.startLineNumber - 1)
      t.push(i[n++]);
    else if (o.endLineNumber < s.startLineNumber - 1)
      t.push(e[r++]);
    else {
      const a = Math.min(s.startLineNumber, o.startLineNumber), l = Math.max(s.endLineNumber, o.endLineNumber);
      t.push(new V(a, 1, l, 1)), n++, r++;
    }
  }
  for (; n < i.length; )
    t.push(i[n++]);
  for (; r < e.length; )
    t.push(e[r++]);
  return t;
}
function vQ(i, e) {
  if (i.length !== e.length)
    return !1;
  for (let t = 0; t < i.length; t++)
    if (!i[t].equalsRange(e[t]))
      return !1;
  return !0;
}
class _Q {
  constructor(e, t) {
    this.viewportStartModelPosition = e, this.startLineDelta = t;
  }
  recoverViewportStart(e, t) {
    if (!this.viewportStartModelPosition)
      return;
    const n = e.convertModelPositionToViewPosition(this.viewportStartModelPosition), r = t.getVerticalOffsetForLineNumber(n.lineNumber);
    t.setScrollPosition(
      { scrollTop: r + this.startLineDelta },
      1
      /* ScrollType.Immediate */
    );
  }
}
class L4 {
  constructor(...e) {
    this._entries = /* @__PURE__ */ new Map();
    for (const [t, n] of e)
      this.set(t, n);
  }
  set(e, t) {
    const n = this._entries.get(e);
    return this._entries.set(e, t), n;
  }
  get(e) {
    return this._entries.get(e);
  }
}
var nw;
(function(i) {
  i[i.Ignore = 0] = "Ignore", i[i.Info = 1] = "Info", i[i.Warning = 2] = "Warning", i[i.Error = 3] = "Error";
})(nw || (nw = {}));
(function(i) {
  const e = "error", t = "warning", n = "warn", r = "info", s = "ignore";
  function o(l) {
    return l ? K1(e, l) ? i.Error : K1(t, l) || K1(n, l) ? i.Warning : K1(r, l) ? i.Info : i.Ignore : i.Ignore;
  }
  i.fromValue = o;
  function a(l) {
    switch (l) {
      case i.Error:
        return e;
      case i.Warning:
        return t;
      case i.Info:
        return r;
      default:
        return s;
    }
  }
  i.toString = a;
})(nw || (nw = {}));
const Yi = nw;
var I4 = Yi;
const dr = Gt("notificationService");
class MHe {
}
class RC {
  constructor(e, t, n, r, s) {
    this.injectionOffsets = e, this.injectionOptions = t, this.breakOffsets = n, this.breakOffsetsVisibleColumn = r, this.wrappedTextIndentLength = s;
  }
  getOutputLineCount() {
    return this.breakOffsets.length;
  }
  getMinOutputOffset(e) {
    return e > 0 ? this.wrappedTextIndentLength : 0;
  }
  getLineLength(e) {
    const t = e > 0 ? this.breakOffsets[e - 1] : 0;
    let r = this.breakOffsets[e] - t;
    return e > 0 && (r += this.wrappedTextIndentLength), r;
  }
  getMaxOutputOffset(e) {
    return this.getLineLength(e);
  }
  translateToInputOffset(e, t) {
    e > 0 && (t = Math.max(0, t - this.wrappedTextIndentLength));
    let r = e === 0 ? t : this.breakOffsets[e - 1] + t;
    if (this.injectionOffsets !== null)
      for (let s = 0; s < this.injectionOffsets.length && r > this.injectionOffsets[s]; s++)
        r < this.injectionOffsets[s] + this.injectionOptions[s].content.length ? r = this.injectionOffsets[s] : r -= this.injectionOptions[s].content.length;
    return r;
  }
  translateToOutputPosition(e, t = 2) {
    let n = e;
    if (this.injectionOffsets !== null)
      for (let r = 0; r < this.injectionOffsets.length && !(e < this.injectionOffsets[r] || t !== 1 && e === this.injectionOffsets[r]); r++)
        n += this.injectionOptions[r].content.length;
    return this.offsetInInputWithInjectionsToOutputPosition(n, t);
  }
  offsetInInputWithInjectionsToOutputPosition(e, t = 2) {
    let n = 0, r = this.breakOffsets.length - 1, s = 0, o = 0;
    for (; n <= r; ) {
      s = n + (r - n) / 2 | 0;
      const l = this.breakOffsets[s];
      if (o = s > 0 ? this.breakOffsets[s - 1] : 0, t === 0)
        if (e <= o)
          r = s - 1;
        else if (e > l)
          n = s + 1;
        else
          break;
      else if (e < o)
        r = s - 1;
      else if (e >= l)
        n = s + 1;
      else
        break;
    }
    let a = e - o;
    return s > 0 && (a += this.wrappedTextIndentLength), new oD(s, a);
  }
  normalizeOutputPosition(e, t, n) {
    if (this.injectionOffsets !== null) {
      const r = this.outputPositionToOffsetInInputWithInjections(e, t), s = this.normalizeOffsetInInputWithInjectionsAroundInjections(r, n);
      if (s !== r)
        return this.offsetInInputWithInjectionsToOutputPosition(s, n);
    }
    if (n === 0) {
      if (e > 0 && t === this.getMinOutputOffset(e))
        return new oD(e - 1, this.getMaxOutputOffset(e - 1));
    } else if (n === 1) {
      const r = this.getOutputLineCount() - 1;
      if (e < r && t === this.getMaxOutputOffset(e))
        return new oD(e + 1, this.getMinOutputOffset(e + 1));
    }
    return new oD(e, t);
  }
  outputPositionToOffsetInInputWithInjections(e, t) {
    return e > 0 && (t = Math.max(0, t - this.wrappedTextIndentLength)), (e > 0 ? this.breakOffsets[e - 1] : 0) + t;
  }
  normalizeOffsetInInputWithInjectionsAroundInjections(e, t) {
    const n = this.getInjectedTextAtOffset(e);
    if (!n)
      return e;
    if (t === 2) {
      if (e === n.offsetInInputWithInjections + n.length && bQ(this.injectionOptions[n.injectedTextIndex].cursorStops))
        return n.offsetInInputWithInjections + n.length;
      {
        let r = n.offsetInInputWithInjections;
        if (CQ(this.injectionOptions[n.injectedTextIndex].cursorStops))
          return r;
        let s = n.injectedTextIndex - 1;
        for (; s >= 0 && this.injectionOffsets[s] === this.injectionOffsets[n.injectedTextIndex] && !(bQ(this.injectionOptions[s].cursorStops) || (r -= this.injectionOptions[s].content.length, CQ(this.injectionOptions[s].cursorStops))); )
          s--;
        return r;
      }
    } else if (t === 1 || t === 4) {
      let r = n.offsetInInputWithInjections + n.length, s = n.injectedTextIndex;
      for (; s + 1 < this.injectionOffsets.length && this.injectionOffsets[s + 1] === this.injectionOffsets[s]; )
        r += this.injectionOptions[s + 1].content.length, s++;
      return r;
    } else if (t === 0 || t === 3) {
      let r = n.offsetInInputWithInjections, s = n.injectedTextIndex;
      for (; s - 1 >= 0 && this.injectionOffsets[s - 1] === this.injectionOffsets[s]; )
        r -= this.injectionOptions[s - 1].content.length, s--;
      return r;
    }
    $A();
  }
  getInjectedText(e, t) {
    const n = this.outputPositionToOffsetInInputWithInjections(e, t), r = this.getInjectedTextAtOffset(n);
    return r ? {
      options: this.injectionOptions[r.injectedTextIndex]
    } : null;
  }
  getInjectedTextAtOffset(e) {
    const t = this.injectionOffsets, n = this.injectionOptions;
    if (t !== null) {
      let r = 0;
      for (let s = 0; s < t.length; s++) {
        const o = n[s].content.length, a = t[s] + r, l = t[s] + r + o;
        if (a > e)
          break;
        if (e <= l)
          return {
            injectedTextIndex: s,
            offsetInInputWithInjections: a,
            length: o
          };
        r += o;
      }
    }
  }
}
function bQ(i) {
  return i == null ? !0 : i === Gc.Right || i === Gc.Both;
}
function CQ(i) {
  return i == null ? !0 : i === Gc.Left || i === Gc.Both;
}
class oD {
  constructor(e, t) {
    this.outputLineIndex = e, this.outputOffset = t;
  }
  toString() {
    return `${this.outputLineIndex}:${this.outputOffset}`;
  }
  toPosition(e) {
    return new ve(e + this.outputLineIndex, this.outputOffset + 1);
  }
}
class Uz {
  static create(e) {
    return new Uz(e.get(
      132
      /* EditorOption.wordWrapBreakBeforeCharacters */
    ), e.get(
      131
      /* EditorOption.wordWrapBreakAfterCharacters */
    ));
  }
  constructor(e, t) {
    this.classifier = new RHe(e, t);
  }
  createLineBreaksComputer(e, t, n, r, s) {
    const o = [], a = [], l = [];
    return {
      addRequest: (c, d, u) => {
        o.push(c), a.push(d), l.push(u);
      },
      finalize: () => {
        const c = e.typicalFullwidthCharacterWidth / e.typicalHalfwidthCharacterWidth, d = [];
        for (let u = 0, h = o.length; u < h; u++) {
          const f = a[u], g = l[u];
          g && !g.injectionOptions && !f ? d[u] = FHe(this.classifier, g, o[u], t, n, c, r, s) : d[u] = BHe(this.classifier, o[u], f, t, n, c, r, s);
        }
        return XF.length = 0, ZF.length = 0, d;
      }
    };
  }
}
class RHe extends mb {
  constructor(e, t) {
    super(
      0
      /* CharacterClass.NONE */
    );
    for (let n = 0; n < e.length; n++)
      this.set(
        e.charCodeAt(n),
        1
        /* CharacterClass.BREAK_BEFORE */
      );
    for (let n = 0; n < t.length; n++)
      this.set(
        t.charCodeAt(n),
        2
        /* CharacterClass.BREAK_AFTER */
      );
  }
  get(e) {
    return e >= 0 && e < 256 ? this._asciiMap[e] : e >= 12352 && e <= 12543 || e >= 13312 && e <= 19903 || e >= 19968 && e <= 40959 ? 3 : this._map.get(e) || this._defaultValue;
  }
}
let XF = [], ZF = [];
function FHe(i, e, t, n, r, s, o, a) {
  if (r === -1)
    return null;
  const l = t.length;
  if (l <= 1)
    return null;
  const c = a === "keepAll", d = e.breakOffsets, u = e.breakOffsetsVisibleColumn, h = Rge(t, n, r, s, o), f = r - h, g = XF, p = ZF;
  let m = 0, _ = 0, b = 0, w = r;
  const y = d.length;
  let S = 0;
  if (S >= 0) {
    let x = Math.abs(u[S] - w);
    for (; S + 1 < y; ) {
      const D = Math.abs(u[S + 1] - w);
      if (D >= x)
        break;
      x = D, S++;
    }
  }
  for (; S < y; ) {
    let x = S < 0 ? 0 : d[S], D = S < 0 ? 0 : u[S];
    _ > x && (x = _, D = b);
    let E = 0, L = 0, k = 0, N = 0;
    if (D <= w) {
      let A = D, P = x === 0 ? 0 : t.charCodeAt(x - 1), O = x === 0 ? 0 : i.get(P), K = !0;
      for (let W = x; W < l; W++) {
        const F = W, q = t.charCodeAt(W);
        let R, T;
        if (kr(q) ? (W++, R = 0, T = 2) : (R = i.get(q), T = FC(q, A, n, s)), F > _ && QF(P, O, q, R, c) && (E = F, L = A), A += T, A > w) {
          F > _ ? (k = F, N = A - T) : (k = W + 1, N = A), A - L > f && (E = 0), K = !1;
          break;
        }
        P = q, O = R;
      }
      if (K) {
        m > 0 && (g[m] = d[d.length - 1], p[m] = u[d.length - 1], m++);
        break;
      }
    }
    if (E === 0) {
      let A = D, P = t.charCodeAt(x), O = i.get(P), K = !1;
      for (let W = x - 1; W >= _; W--) {
        const F = W + 1, q = t.charCodeAt(W);
        if (q === 9) {
          K = !0;
          break;
        }
        let R, T;
        if (Gm(q) ? (W--, R = 0, T = 2) : (R = i.get(q), T = Pg(q) ? s : 1), A <= w) {
          if (k === 0 && (k = F, N = A), A <= w - f)
            break;
          if (QF(q, R, P, O, c)) {
            E = F, L = A;
            break;
          }
        }
        A -= T, P = q, O = R;
      }
      if (E !== 0) {
        const W = f - (N - L);
        if (W <= n) {
          const F = t.charCodeAt(k);
          let q;
          kr(F) ? q = 2 : q = FC(F, N, n, s), W - q < 0 && (E = 0);
        }
      }
      if (K) {
        S--;
        continue;
      }
    }
    if (E === 0 && (E = k, L = N), E <= _) {
      const A = t.charCodeAt(_);
      kr(A) ? (E = _ + 2, L = b + 2) : (E = _ + 1, L = b + FC(A, b, n, s));
    }
    for (_ = E, g[m] = E, b = L, p[m] = L, m++, w = L + f; S < 0 || S < y && u[S] < L; )
      S++;
    let I = Math.abs(u[S] - w);
    for (; S + 1 < y; ) {
      const A = Math.abs(u[S + 1] - w);
      if (A >= I)
        break;
      I = A, S++;
    }
  }
  return m === 0 ? null : (g.length = m, p.length = m, XF = e.breakOffsets, ZF = e.breakOffsetsVisibleColumn, e.breakOffsets = g, e.breakOffsetsVisibleColumn = p, e.wrappedTextIndentLength = h, e);
}
function BHe(i, e, t, n, r, s, o, a) {
  const l = ld.applyInjectedText(e, t);
  let c, d;
  if (t && t.length > 0 ? (c = t.map((L) => L.options), d = t.map((L) => L.column - 1)) : (c = null, d = null), r === -1)
    return c ? new RC(d, c, [l.length], [], 0) : null;
  const u = l.length;
  if (u <= 1)
    return c ? new RC(d, c, [l.length], [], 0) : null;
  const h = a === "keepAll", f = Rge(l, n, r, s, o), g = r - f, p = [], m = [];
  let _ = 0, b = 0, w = 0, y = r, S = l.charCodeAt(0), x = i.get(S), D = FC(S, 0, n, s), E = 1;
  kr(S) && (D += 1, S = l.charCodeAt(1), x = i.get(S), E++);
  for (let L = E; L < u; L++) {
    const k = L, N = l.charCodeAt(L);
    let I, A;
    kr(N) ? (L++, I = 0, A = 2) : (I = i.get(N), A = FC(N, D, n, s)), QF(S, x, N, I, h) && (b = k, w = D), D += A, D > y && ((b === 0 || D - w > g) && (b = k, w = D - A), p[_] = b, m[_] = w, _++, y = w + g, b = 0), S = N, x = I;
  }
  return _ === 0 && (!t || t.length === 0) ? null : (p[_] = u, m[_] = D, new RC(d, c, p, m, f));
}
function FC(i, e, t, n) {
  return i === 9 ? t - e % t : Pg(i) || i < 32 ? n : 1;
}
function yQ(i, e) {
  return e - i % e;
}
function QF(i, e, t, n, r) {
  return t !== 32 && (e === 2 && n !== 2 || e !== 1 && n === 1 || !r && e === 3 && n !== 2 || !r && n === 3 && e !== 1);
}
function Rge(i, e, t, n, r) {
  let s = 0;
  if (r !== 0) {
    const o = Js(i);
    if (o !== -1) {
      for (let l = 0; l < o; l++) {
        const c = i.charCodeAt(l) === 9 ? yQ(s, e) : 1;
        s += c;
      }
      const a = r === 3 ? 2 : r === 2 ? 1 : 0;
      for (let l = 0; l < a; l++) {
        const c = yQ(s, e);
        s += c;
      }
      s + n > t && (s = 0);
    }
  }
  return s;
}
const q6 = af("domLineBreaksComputer", { createHTML: (i) => i });
class Gz {
  static create() {
    return new Gz();
  }
  constructor() {
  }
  createLineBreaksComputer(e, t, n, r, s) {
    const o = [], a = [];
    return {
      addRequest: (l, c, d) => {
        o.push(l), a.push(c);
      },
      finalize: () => VHe(o, e, t, n, r, s, a)
    };
  }
}
function VHe(i, e, t, n, r, s, o) {
  var a;
  function l(L) {
    const k = o[L];
    if (k) {
      const N = ld.applyInjectedText(i[L], k), I = k.map((P) => P.options), A = k.map((P) => P.column - 1);
      return new RC(A, I, [N.length], [], 0);
    } else
      return null;
  }
  if (n === -1) {
    const L = [];
    for (let k = 0, N = i.length; k < N; k++)
      L[k] = l(k);
    return L;
  }
  const c = Math.round(n * e.typicalHalfwidthCharacterWidth), u = Math.round(t * (r === 3 ? 2 : r === 2 ? 1 : 0)), h = Math.ceil(e.spaceWidth * u), f = document.createElement("div");
  Ds(f, e);
  const g = new pb(1e4), p = [], m = [], _ = [], b = [], w = [];
  for (let L = 0; L < i.length; L++) {
    const k = ld.applyInjectedText(i[L], o[L]);
    let N = 0, I = 0, A = c;
    if (r !== 0)
      if (N = Js(k), N === -1)
        N = 0;
      else {
        for (let W = 0; W < N; W++) {
          const F = k.charCodeAt(W) === 9 ? t - I % t : 1;
          I += F;
        }
        const K = Math.ceil(e.spaceWidth * I);
        K + e.typicalFullwidthCharacterWidth > c ? (N = 0, I = 0) : A = c - K;
      }
    const P = k.substr(N), O = HHe(P, I, t, A, g, h);
    p[L] = N, m[L] = I, _[L] = P, b[L] = O[0], w[L] = O[1];
  }
  const y = g.build(), S = (a = q6?.createHTML(y)) !== null && a !== void 0 ? a : y;
  f.innerHTML = S, f.style.position = "absolute", f.style.top = "10000", s === "keepAll" ? (f.style.wordBreak = "keep-all", f.style.overflowWrap = "anywhere") : (f.style.wordBreak = "inherit", f.style.overflowWrap = "break-word"), document.body.appendChild(f);
  const x = document.createRange(), D = Array.prototype.slice.call(f.children, 0), E = [];
  for (let L = 0; L < i.length; L++) {
    const k = D[L], N = WHe(x, k, _[L], b[L]);
    if (N === null) {
      E[L] = l(L);
      continue;
    }
    const I = p[L], A = m[L] + u, P = w[L], O = [];
    for (let q = 0, R = N.length; q < R; q++)
      O[q] = P[N[q]];
    if (I !== 0)
      for (let q = 0, R = N.length; q < R; q++)
        N[q] += I;
    let K, W;
    const F = o[L];
    F ? (K = F.map((q) => q.options), W = F.map((q) => q.column - 1)) : (K = null, W = null), E[L] = new RC(W, K, N, O, A);
  }
  return document.body.removeChild(f), E;
}
function HHe(i, e, t, n, r, s) {
  if (s !== 0) {
    const h = String(s);
    r.appendString('<div style="text-indent: -'), r.appendString(h), r.appendString("px; padding-left: "), r.appendString(h), r.appendString("px; box-sizing: border-box; width:");
  } else
    r.appendString('<div style="width:');
  r.appendString(String(n)), r.appendString('px;">');
  const o = i.length;
  let a = e, l = 0;
  const c = [], d = [];
  let u = 0 < o ? i.charCodeAt(0) : 0;
  r.appendString("<span>");
  for (let h = 0; h < o; h++) {
    h !== 0 && h % 16384 === 0 && r.appendString("</span><span>"), c[h] = l, d[h] = a;
    const f = u;
    u = h + 1 < o ? i.charCodeAt(h + 1) : 0;
    let g = 1, p = 1;
    switch (f) {
      case 9:
        g = t - a % t, p = g;
        for (let m = 1; m <= g; m++)
          m < g ? r.appendCharCode(160) : r.appendASCIICharCode(
            32
            /* CharCode.Space */
          );
        break;
      case 32:
        u === 32 ? r.appendCharCode(160) : r.appendASCIICharCode(
          32
          /* CharCode.Space */
        );
        break;
      case 60:
        r.appendString("&lt;");
        break;
      case 62:
        r.appendString("&gt;");
        break;
      case 38:
        r.appendString("&amp;");
        break;
      case 0:
        r.appendString("&#00;");
        break;
      case 65279:
      case 8232:
      case 8233:
      case 133:
        r.appendCharCode(65533);
        break;
      default:
        Pg(f) && p++, f < 32 ? r.appendCharCode(9216 + f) : r.appendCharCode(f);
    }
    l += g, a += p;
  }
  return r.appendString("</span>"), c[i.length] = l, d[i.length] = a, r.appendString("</div>"), [c, d];
}
function WHe(i, e, t, n) {
  if (t.length <= 1)
    return null;
  const r = Array.prototype.slice.call(e.children, 0), s = [];
  try {
    JF(i, r, n, 0, null, t.length - 1, null, s);
  } catch (o) {
    return console.log(o), null;
  }
  return s.length === 0 ? null : (s.push(t.length), s);
}
function JF(i, e, t, n, r, s, o, a) {
  if (n === s || (r = r || K6(i, e, t[n], t[n + 1]), o = o || K6(i, e, t[s], t[s + 1]), Math.abs(r[0].top - o[0].top) <= 0.1))
    return;
  if (n + 1 === s) {
    a.push(s);
    return;
  }
  const l = n + (s - n) / 2 | 0, c = K6(i, e, t[l], t[l + 1]);
  JF(i, e, t, n, r, l, c, a), JF(i, e, t, l, c, s, o, a);
}
function K6(i, e, t, n) {
  return i.setStart(
    e[t / 16384 | 0].firstChild,
    t % 16384
    /* Constants.SPAN_MODULO_LIMIT */
  ), i.setEnd(
    e[n / 16384 | 0].firstChild,
    n % 16384
    /* Constants.SPAN_MODULO_LIMIT */
  ), i.getClientRects();
}
class jHe extends we {
  constructor() {
    super(), this._editor = null, this._instantiationService = null, this._instances = this._register(new Tj()), this._pending = /* @__PURE__ */ new Map(), this._finishedInstantiation = [], this._finishedInstantiation[
      0
      /* EditorContributionInstantiation.Eager */
    ] = !1, this._finishedInstantiation[
      1
      /* EditorContributionInstantiation.AfterFirstRender */
    ] = !1, this._finishedInstantiation[
      2
      /* EditorContributionInstantiation.BeforeFirstInteraction */
    ] = !1, this._finishedInstantiation[
      3
      /* EditorContributionInstantiation.Eventually */
    ] = !1;
  }
  initialize(e, t, n) {
    this._editor = e, this._instantiationService = n;
    for (const r of t) {
      if (this._pending.has(r.id)) {
        It(new Error(`Cannot have two contributions with the same id ${r.id}`));
        continue;
      }
      this._pending.set(r.id, r);
    }
    this._instantiateSome(
      0
      /* EditorContributionInstantiation.Eager */
    ), this._register(xh(() => {
      this._instantiateSome(
        1
        /* EditorContributionInstantiation.AfterFirstRender */
      );
    })), this._register(xh(() => {
      this._instantiateSome(
        2
        /* EditorContributionInstantiation.BeforeFirstInteraction */
      );
    })), this._register(xh(() => {
      this._instantiateSome(
        3
        /* EditorContributionInstantiation.Eventually */
      );
    }, 5e3));
  }
  saveViewState() {
    const e = {};
    for (const [t, n] of this._instances)
      typeof n.saveViewState == "function" && (e[t] = n.saveViewState());
    return e;
  }
  restoreViewState(e) {
    for (const [t, n] of this._instances)
      typeof n.restoreViewState == "function" && n.restoreViewState(e[t]);
  }
  get(e) {
    return this._instantiateById(e), this._instances.get(e) || null;
  }
  onBeforeInteractionEvent() {
    this._instantiateSome(
      2
      /* EditorContributionInstantiation.BeforeFirstInteraction */
    );
  }
  onAfterModelAttached() {
    this._register(xh(() => {
      this._instantiateSome(
        1
        /* EditorContributionInstantiation.AfterFirstRender */
      );
    }, 50));
  }
  _instantiateSome(e) {
    if (this._finishedInstantiation[e])
      return;
    this._finishedInstantiation[e] = !0;
    const t = this._findPendingContributionsByInstantiation(e);
    for (const n of t)
      this._instantiateById(n.id);
  }
  _findPendingContributionsByInstantiation(e) {
    const t = [];
    for (const [, n] of this._pending)
      n.instantiation === e && t.push(n);
    return t;
  }
  _instantiateById(e) {
    const t = this._pending.get(e);
    if (t) {
      if (this._pending.delete(e), !this._instantiationService || !this._editor)
        throw new Error("Cannot instantiate contributions before being initialized!");
      try {
        const n = this._instantiationService.createInstance(t.ctor, this._editor);
        this._instances.set(t.id, n), typeof n.restoreViewState == "function" && t.instantiation !== 0 && console.warn(`Editor contribution '${t.id}' should be eager instantiated because it uses saveViewState / restoreViewState.`);
      } catch (n) {
        It(n);
      }
    }
  }
}
var zHe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, zu = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, UHe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, Wp;
let GHe = 0, qHe = class {
  constructor(e, t, n, r, s, o) {
    this.model = e, this.viewModel = t, this.view = n, this.hasRealView = r, this.listenersToRemove = s, this.attachedView = o;
  }
  dispose() {
    An(this.listenersToRemove), this.model.onBeforeDetached(this.attachedView), this.hasRealView && this.view.dispose(), this.viewModel.dispose();
  }
}, L_ = Wp = class extends we {
  //#endregion
  get isSimpleWidget() {
    return this._configuration.isSimpleWidget;
  }
  constructor(e, t, n, r, s, o, a, l, c, d, u, h) {
    var f;
    super(), this.languageConfigurationService = u, this._deliveryQueue = RTe(), this._contributions = this._register(new jHe()), this._onDidDispose = this._register(new pe()), this.onDidDispose = this._onDidDispose.event, this._onDidChangeModelContent = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelContent = this._onDidChangeModelContent.event, this._onDidChangeModelLanguage = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelLanguage = this._onDidChangeModelLanguage.event, this._onDidChangeModelLanguageConfiguration = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelLanguageConfiguration = this._onDidChangeModelLanguageConfiguration.event, this._onDidChangeModelOptions = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelOptions = this._onDidChangeModelOptions.event, this._onDidChangeModelDecorations = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelDecorations = this._onDidChangeModelDecorations.event, this._onDidChangeModelTokens = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelTokens = this._onDidChangeModelTokens.event, this._onDidChangeConfiguration = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeConfiguration = this._onDidChangeConfiguration.event, this._onDidChangeModel = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModel = this._onDidChangeModel.event, this._onDidChangeCursorPosition = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeCursorPosition = this._onDidChangeCursorPosition.event, this._onDidChangeCursorSelection = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeCursorSelection = this._onDidChangeCursorSelection.event, this._onDidAttemptReadOnlyEdit = this._register(new js(this._contributions, this._deliveryQueue)), this.onDidAttemptReadOnlyEdit = this._onDidAttemptReadOnlyEdit.event, this._onDidLayoutChange = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidLayoutChange = this._onDidLayoutChange.event, this._editorTextFocus = this._register(new wQ({ deliveryQueue: this._deliveryQueue })), this.onDidFocusEditorText = this._editorTextFocus.onDidChangeToTrue, this.onDidBlurEditorText = this._editorTextFocus.onDidChangeToFalse, this._editorWidgetFocus = this._register(new wQ({ deliveryQueue: this._deliveryQueue })), this.onDidFocusEditorWidget = this._editorWidgetFocus.onDidChangeToTrue, this.onDidBlurEditorWidget = this._editorWidgetFocus.onDidChangeToFalse, this._onWillType = this._register(new js(this._contributions, this._deliveryQueue)), this.onWillType = this._onWillType.event, this._onDidType = this._register(new js(this._contributions, this._deliveryQueue)), this.onDidType = this._onDidType.event, this._onDidCompositionStart = this._register(new js(this._contributions, this._deliveryQueue)), this.onDidCompositionStart = this._onDidCompositionStart.event, this._onDidCompositionEnd = this._register(new js(this._contributions, this._deliveryQueue)), this.onDidCompositionEnd = this._onDidCompositionEnd.event, this._onDidPaste = this._register(new js(this._contributions, this._deliveryQueue)), this.onDidPaste = this._onDidPaste.event, this._onMouseUp = this._register(new js(this._contributions, this._deliveryQueue)), this.onMouseUp = this._onMouseUp.event, this._onMouseDown = this._register(new js(this._contributions, this._deliveryQueue)), this.onMouseDown = this._onMouseDown.event, this._onMouseDrag = this._register(new js(this._contributions, this._deliveryQueue)), this.onMouseDrag = this._onMouseDrag.event, this._onMouseDrop = this._register(new js(this._contributions, this._deliveryQueue)), this.onMouseDrop = this._onMouseDrop.event, this._onMouseDropCanceled = this._register(new js(this._contributions, this._deliveryQueue)), this.onMouseDropCanceled = this._onMouseDropCanceled.event, this._onDropIntoEditor = this._register(new js(this._contributions, this._deliveryQueue)), this.onDropIntoEditor = this._onDropIntoEditor.event, this._onContextMenu = this._register(new js(this._contributions, this._deliveryQueue)), this.onContextMenu = this._onContextMenu.event, this._onMouseMove = this._register(new js(this._contributions, this._deliveryQueue)), this.onMouseMove = this._onMouseMove.event, this._onMouseLeave = this._register(new js(this._contributions, this._deliveryQueue)), this.onMouseLeave = this._onMouseLeave.event, this._onMouseWheel = this._register(new js(this._contributions, this._deliveryQueue)), this.onMouseWheel = this._onMouseWheel.event, this._onKeyUp = this._register(new js(this._contributions, this._deliveryQueue)), this.onKeyUp = this._onKeyUp.event, this._onKeyDown = this._register(new js(this._contributions, this._deliveryQueue)), this.onKeyDown = this._onKeyDown.event, this._onDidContentSizeChange = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidContentSizeChange = this._onDidContentSizeChange.event, this._onDidScrollChange = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidScrollChange = this._onDidScrollChange.event, this._onDidChangeViewZones = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeViewZones = this._onDidChangeViewZones.event, this._onDidChangeHiddenAreas = this._register(new pe({ deliveryQueue: this._deliveryQueue })), this.onDidChangeHiddenAreas = this._onDidChangeHiddenAreas.event, this._actions = /* @__PURE__ */ new Map(), this._bannerDomNode = null, this._dropIntoEditorDecorations = this.createDecorationsCollection(), s.willCreateCodeEditor();
    const g = Object.assign({}, t);
    this._domElement = e, this._overflowWidgetsDomNode = g.overflowWidgetsDomNode, delete g.overflowWidgetsDomNode, this._id = ++GHe, this._decorationTypeKeysToIds = {}, this._decorationTypeSubtypes = {}, this._telemetryData = n.telemetryData, this._configuration = this._register(this._createConfiguration(n.isSimpleWidget || !1, g, d)), this._register(this._configuration.onDidChange((_) => {
      this._onDidChangeConfiguration.fire(_);
      const b = this._configuration.options;
      if (_.hasChanged(
        143
        /* EditorOption.layoutInfo */
      )) {
        const w = b.get(
          143
          /* EditorOption.layoutInfo */
        );
        this._onDidLayoutChange.fire(w);
      }
    })), this._contextKeyService = this._register(a.createScoped(this._domElement)), this._notificationService = c, this._codeEditorService = s, this._commandService = o, this._themeService = l, this._register(new KHe(this, this._contextKeyService)), this._register(new YHe(this, this._contextKeyService, h)), this._instantiationService = r.createChild(new L4([yt, this._contextKeyService])), this._modelData = null, this._focusTracker = new XHe(e), this._register(this._focusTracker.onChange(() => {
      this._editorWidgetFocus.setValue(this._focusTracker.hasFocus());
    })), this._contentWidgets = {}, this._overlayWidgets = {}, this._glyphMarginWidgets = {};
    let p;
    Array.isArray(n.contributions) ? p = n.contributions : p = Av.getEditorContributions(), this._contributions.initialize(this, p, this._instantiationService);
    for (const _ of Av.getEditorActions()) {
      if (this._actions.has(_.id)) {
        It(new Error(`Cannot have two actions with the same id ${_.id}`));
        continue;
      }
      const b = new uge(_.id, _.label, _.alias, (f = _.precondition) !== null && f !== void 0 ? f : void 0, () => this._instantiationService.invokeFunction((w) => Promise.resolve(_.runEditorCommand(w, this, null))), this._contextKeyService);
      this._actions.set(b.id, b);
    }
    const m = () => !this._configuration.options.get(
      90
      /* EditorOption.readOnly */
    ) && this._configuration.options.get(
      36
      /* EditorOption.dropIntoEditor */
    ).enabled;
    this._register(new t7e(this._domElement, {
      onDragEnter: () => {
      },
      onDragOver: (_) => {
        if (!m())
          return;
        const b = this.getTargetAtClientPoint(_.clientX, _.clientY);
        b?.position && this.showDropIndicatorAt(b.position);
      },
      onDrop: (_) => UHe(this, void 0, void 0, function* () {
        if (!m() || (this.removeDropIndicator(), !_.dataTransfer))
          return;
        const b = this.getTargetAtClientPoint(_.clientX, _.clientY);
        b?.position && this._onDropIntoEditor.fire({ position: b.position, event: _ });
      }),
      onDragLeave: () => {
        this.removeDropIndicator();
      },
      onDragEnd: () => {
        this.removeDropIndicator();
      }
    })), this._codeEditorService.addCodeEditor(this);
  }
  writeScreenReaderContent(e) {
    var t;
    (t = this._modelData) === null || t === void 0 || t.view.writeScreenReaderContent(e);
  }
  _createConfiguration(e, t, n) {
    return new EF(e, t, this._domElement, n);
  }
  getId() {
    return this.getEditorType() + ":" + this._id;
  }
  getEditorType() {
    return DS.ICodeEditor;
  }
  dispose() {
    this._codeEditorService.removeCodeEditor(this), this._focusTracker.dispose(), this._actions.clear(), this._contentWidgets = {}, this._overlayWidgets = {}, this._removeDecorationTypes(), this._postDetachModelCleanup(this._detachModel()), this._onDidDispose.fire(), super.dispose();
  }
  invokeWithinContext(e) {
    return this._instantiationService.invokeFunction(e);
  }
  updateOptions(e) {
    this._configuration.updateOptions(e || {});
  }
  getOptions() {
    return this._configuration.options;
  }
  getOption(e) {
    return this._configuration.options.get(e);
  }
  getRawOptions() {
    return this._configuration.getRawOptions();
  }
  getOverflowWidgetsDomNode() {
    return this._overflowWidgetsDomNode;
  }
  getConfiguredWordAtPosition(e) {
    return this._modelData ? yn.getWordAtPosition(this._modelData.model, this._configuration.options.get(
      129
      /* EditorOption.wordSeparators */
    ), e) : null;
  }
  getValue(e = null) {
    if (!this._modelData)
      return "";
    const t = !!(e && e.preserveBOM);
    let n = 0;
    return e && e.lineEnding && e.lineEnding === `
` ? n = 1 : e && e.lineEnding && e.lineEnding === `\r
` && (n = 2), this._modelData.model.getValue(n, t);
  }
  setValue(e) {
    this._modelData && this._modelData.model.setValue(e);
  }
  getModel() {
    return this._modelData ? this._modelData.model : null;
  }
  setModel(e = null) {
    const t = e;
    if (this._modelData === null && t === null || this._modelData && this._modelData.model === t)
      return;
    const n = this.hasTextFocus(), r = this._detachModel();
    this._attachModel(t), n && this.hasModel() && this.focus();
    const s = {
      oldModelUrl: r ? r.uri : null,
      newModelUrl: t ? t.uri : null
    };
    this._removeDecorationTypes(), this._onDidChangeModel.fire(s), this._postDetachModelCleanup(r), this._contributions.onAfterModelAttached();
  }
  _removeDecorationTypes() {
    if (this._decorationTypeKeysToIds = {}, this._decorationTypeSubtypes) {
      for (const e in this._decorationTypeSubtypes) {
        const t = this._decorationTypeSubtypes[e];
        for (const n in t)
          this._removeDecorationType(e + "-" + n);
      }
      this._decorationTypeSubtypes = {};
    }
  }
  getVisibleRanges() {
    return this._modelData ? this._modelData.viewModel.getVisibleRanges() : [];
  }
  getVisibleRangesPlusViewportAboveBelow() {
    return this._modelData ? this._modelData.viewModel.getVisibleRangesPlusViewportAboveBelow() : [];
  }
  getWhitespaces() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getWhitespaces() : [];
  }
  static _getVerticalOffsetAfterPosition(e, t, n, r) {
    const s = e.model.validatePosition({
      lineNumber: t,
      column: n
    }), o = e.viewModel.coordinatesConverter.convertModelPositionToViewPosition(s);
    return e.viewModel.viewLayout.getVerticalOffsetAfterLineNumber(o.lineNumber, r);
  }
  getTopForLineNumber(e, t = !1) {
    return this._modelData ? Wp._getVerticalOffsetForPosition(this._modelData, e, 1, t) : -1;
  }
  getTopForPosition(e, t) {
    return this._modelData ? Wp._getVerticalOffsetForPosition(this._modelData, e, t, !1) : -1;
  }
  static _getVerticalOffsetForPosition(e, t, n, r = !1) {
    const s = e.model.validatePosition({
      lineNumber: t,
      column: n
    }), o = e.viewModel.coordinatesConverter.convertModelPositionToViewPosition(s);
    return e.viewModel.viewLayout.getVerticalOffsetForLineNumber(o.lineNumber, r);
  }
  getBottomForLineNumber(e, t = !1) {
    return this._modelData ? Wp._getVerticalOffsetAfterPosition(this._modelData, e, 1, t) : -1;
  }
  setHiddenAreas(e, t) {
    var n;
    (n = this._modelData) === null || n === void 0 || n.viewModel.setHiddenAreas(e.map((r) => V.lift(r)), t);
  }
  getVisibleColumnFromPosition(e) {
    if (!this._modelData)
      return e.column;
    const t = this._modelData.model.validatePosition(e), n = this._modelData.model.getOptions().tabSize;
    return Lr.visibleColumnFromColumn(this._modelData.model.getLineContent(t.lineNumber), t.column, n) + 1;
  }
  getPosition() {
    return this._modelData ? this._modelData.viewModel.getPosition() : null;
  }
  setPosition(e, t = "api") {
    if (this._modelData) {
      if (!ve.isIPosition(e))
        throw new Error("Invalid arguments");
      this._modelData.viewModel.setSelections(t, [{
        selectionStartLineNumber: e.lineNumber,
        selectionStartColumn: e.column,
        positionLineNumber: e.lineNumber,
        positionColumn: e.column
      }]);
    }
  }
  _sendRevealRange(e, t, n, r) {
    if (!this._modelData)
      return;
    if (!V.isIRange(e))
      throw new Error("Invalid arguments");
    const s = this._modelData.model.validateRange(e), o = this._modelData.viewModel.coordinatesConverter.convertModelRangeToViewRange(s);
    this._modelData.viewModel.revealRange("api", n, o, t, r);
  }
  revealLine(e, t = 0) {
    this._revealLine(e, 0, t);
  }
  revealLineInCenter(e, t = 0) {
    this._revealLine(e, 1, t);
  }
  revealLineInCenterIfOutsideViewport(e, t = 0) {
    this._revealLine(e, 2, t);
  }
  revealLineNearTop(e, t = 0) {
    this._revealLine(e, 5, t);
  }
  _revealLine(e, t, n) {
    if (typeof e != "number")
      throw new Error("Invalid arguments");
    this._sendRevealRange(new V(e, 1, e, 1), t, !1, n);
  }
  revealPosition(e, t = 0) {
    this._revealPosition(e, 0, !0, t);
  }
  revealPositionInCenter(e, t = 0) {
    this._revealPosition(e, 1, !0, t);
  }
  revealPositionInCenterIfOutsideViewport(e, t = 0) {
    this._revealPosition(e, 2, !0, t);
  }
  revealPositionNearTop(e, t = 0) {
    this._revealPosition(e, 5, !0, t);
  }
  _revealPosition(e, t, n, r) {
    if (!ve.isIPosition(e))
      throw new Error("Invalid arguments");
    this._sendRevealRange(new V(e.lineNumber, e.column, e.lineNumber, e.column), t, n, r);
  }
  getSelection() {
    return this._modelData ? this._modelData.viewModel.getSelection() : null;
  }
  getSelections() {
    return this._modelData ? this._modelData.viewModel.getSelections() : null;
  }
  setSelection(e, t = "api") {
    const n = ot.isISelection(e), r = V.isIRange(e);
    if (!n && !r)
      throw new Error("Invalid arguments");
    if (n)
      this._setSelectionImpl(e, t);
    else if (r) {
      const s = {
        selectionStartLineNumber: e.startLineNumber,
        selectionStartColumn: e.startColumn,
        positionLineNumber: e.endLineNumber,
        positionColumn: e.endColumn
      };
      this._setSelectionImpl(s, t);
    }
  }
  _setSelectionImpl(e, t) {
    if (!this._modelData)
      return;
    const n = new ot(e.selectionStartLineNumber, e.selectionStartColumn, e.positionLineNumber, e.positionColumn);
    this._modelData.viewModel.setSelections(t, [n]);
  }
  revealLines(e, t, n = 0) {
    this._revealLines(e, t, 0, n);
  }
  revealLinesInCenter(e, t, n = 0) {
    this._revealLines(e, t, 1, n);
  }
  revealLinesInCenterIfOutsideViewport(e, t, n = 0) {
    this._revealLines(e, t, 2, n);
  }
  revealLinesNearTop(e, t, n = 0) {
    this._revealLines(e, t, 5, n);
  }
  _revealLines(e, t, n, r) {
    if (typeof e != "number" || typeof t != "number")
      throw new Error("Invalid arguments");
    this._sendRevealRange(new V(e, 1, t, 1), n, !1, r);
  }
  revealRange(e, t = 0, n = !1, r = !0) {
    this._revealRange(e, n ? 1 : 0, r, t);
  }
  revealRangeInCenter(e, t = 0) {
    this._revealRange(e, 1, !0, t);
  }
  revealRangeInCenterIfOutsideViewport(e, t = 0) {
    this._revealRange(e, 2, !0, t);
  }
  revealRangeNearTop(e, t = 0) {
    this._revealRange(e, 5, !0, t);
  }
  revealRangeNearTopIfOutsideViewport(e, t = 0) {
    this._revealRange(e, 6, !0, t);
  }
  revealRangeAtTop(e, t = 0) {
    this._revealRange(e, 3, !0, t);
  }
  _revealRange(e, t, n, r) {
    if (!V.isIRange(e))
      throw new Error("Invalid arguments");
    this._sendRevealRange(V.lift(e), t, n, r);
  }
  setSelections(e, t = "api", n = 0) {
    if (this._modelData) {
      if (!e || e.length === 0)
        throw new Error("Invalid arguments");
      for (let r = 0, s = e.length; r < s; r++)
        if (!ot.isISelection(e[r]))
          throw new Error("Invalid arguments");
      this._modelData.viewModel.setSelections(t, e, n);
    }
  }
  getContentWidth() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getContentWidth() : -1;
  }
  getScrollWidth() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getScrollWidth() : -1;
  }
  getScrollLeft() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getCurrentScrollLeft() : -1;
  }
  getContentHeight() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getContentHeight() : -1;
  }
  getScrollHeight() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getScrollHeight() : -1;
  }
  getScrollTop() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getCurrentScrollTop() : -1;
  }
  setScrollLeft(e, t = 1) {
    if (this._modelData) {
      if (typeof e != "number")
        throw new Error("Invalid arguments");
      this._modelData.viewModel.viewLayout.setScrollPosition({
        scrollLeft: e
      }, t);
    }
  }
  setScrollTop(e, t = 1) {
    if (this._modelData) {
      if (typeof e != "number")
        throw new Error("Invalid arguments");
      this._modelData.viewModel.viewLayout.setScrollPosition({
        scrollTop: e
      }, t);
    }
  }
  setScrollPosition(e, t = 1) {
    this._modelData && this._modelData.viewModel.viewLayout.setScrollPosition(e, t);
  }
  hasPendingScrollAnimation() {
    return this._modelData ? this._modelData.viewModel.viewLayout.hasPendingScrollAnimation() : !1;
  }
  saveViewState() {
    if (!this._modelData)
      return null;
    const e = this._contributions.saveViewState(), t = this._modelData.viewModel.saveCursorState(), n = this._modelData.viewModel.saveState();
    return {
      cursorState: t,
      viewState: n,
      contributionsState: e
    };
  }
  restoreViewState(e) {
    if (!this._modelData || !this._modelData.hasRealView)
      return;
    const t = e;
    if (t && t.cursorState && t.viewState) {
      const n = t.cursorState;
      Array.isArray(n) ? n.length > 0 && this._modelData.viewModel.restoreCursorState(n) : this._modelData.viewModel.restoreCursorState([n]), this._contributions.restoreViewState(t.contributionsState || {});
      const r = this._modelData.viewModel.reduceRestoreState(t.viewState);
      this._modelData.view.restoreState(r);
    }
  }
  handleInitialized() {
    var e;
    (e = this._getViewModel()) === null || e === void 0 || e.visibleLinesStabilized();
  }
  getContribution(e) {
    return this._contributions.get(e);
  }
  getActions() {
    return Array.from(this._actions.values());
  }
  getSupportedActions() {
    let e = this.getActions();
    return e = e.filter((t) => t.isSupported()), e;
  }
  getAction(e) {
    return this._actions.get(e) || null;
  }
  trigger(e, t, n) {
    switch (n = n || {}, t) {
      case "compositionStart":
        this._startComposition();
        return;
      case "compositionEnd":
        this._endComposition(e);
        return;
      case "type": {
        const s = n;
        this._type(e, s.text || "");
        return;
      }
      case "replacePreviousChar": {
        const s = n;
        this._compositionType(e, s.text || "", s.replaceCharCnt || 0, 0, 0);
        return;
      }
      case "compositionType": {
        const s = n;
        this._compositionType(e, s.text || "", s.replacePrevCharCnt || 0, s.replaceNextCharCnt || 0, s.positionDelta || 0);
        return;
      }
      case "paste": {
        const s = n;
        this._paste(e, s.text || "", s.pasteOnNewLine || !1, s.multicursorText || null, s.mode || null);
        return;
      }
      case "cut":
        this._cut(e);
        return;
    }
    const r = this.getAction(t);
    if (r) {
      Promise.resolve(r.run(n)).then(void 0, It);
      return;
    }
    this._modelData && (this._triggerEditorCommand(e, t, n) || this._triggerCommand(t, n));
  }
  _triggerCommand(e, t) {
    this._commandService.executeCommand(e, t);
  }
  _startComposition() {
    this._modelData && (this._modelData.viewModel.startComposition(), this._onDidCompositionStart.fire());
  }
  _endComposition(e) {
    this._modelData && (this._modelData.viewModel.endComposition(e), this._onDidCompositionEnd.fire());
  }
  _type(e, t) {
    !this._modelData || t.length === 0 || (e === "keyboard" && this._onWillType.fire(t), this._modelData.viewModel.type(t, e), e === "keyboard" && this._onDidType.fire(t));
  }
  _compositionType(e, t, n, r, s) {
    this._modelData && this._modelData.viewModel.compositionType(t, n, r, s, e);
  }
  _paste(e, t, n, r, s) {
    if (!this._modelData || t.length === 0)
      return;
    const o = this._modelData.viewModel, a = o.getSelection().getStartPosition();
    o.paste(t, n, r, e);
    const l = o.getSelection().getStartPosition();
    e === "keyboard" && this._onDidPaste.fire({
      range: new V(a.lineNumber, a.column, l.lineNumber, l.column),
      languageId: s
    });
  }
  _cut(e) {
    this._modelData && this._modelData.viewModel.cut(e);
  }
  _triggerEditorCommand(e, t, n) {
    const r = Av.getEditorCommand(t);
    return r ? (n = n || {}, n.source = e, this._instantiationService.invokeFunction((s) => {
      Promise.resolve(r.runEditorCommand(s, this, n)).then(void 0, It);
    }), !0) : !1;
  }
  _getViewModel() {
    return this._modelData ? this._modelData.viewModel : null;
  }
  pushUndoStop() {
    return !this._modelData || this._configuration.options.get(
      90
      /* EditorOption.readOnly */
    ) ? !1 : (this._modelData.model.pushStackElement(), !0);
  }
  popUndoStop() {
    return !this._modelData || this._configuration.options.get(
      90
      /* EditorOption.readOnly */
    ) ? !1 : (this._modelData.model.popStackElement(), !0);
  }
  executeEdits(e, t, n) {
    if (!this._modelData || this._configuration.options.get(
      90
      /* EditorOption.readOnly */
    ))
      return !1;
    let r;
    return n ? Array.isArray(n) ? r = () => n : r = n : r = () => null, this._modelData.viewModel.executeEdits(e, t, r), !0;
  }
  executeCommand(e, t) {
    this._modelData && this._modelData.viewModel.executeCommand(t, e);
  }
  executeCommands(e, t) {
    this._modelData && this._modelData.viewModel.executeCommands(t, e);
  }
  createDecorationsCollection(e) {
    return new ZHe(this, e);
  }
  changeDecorations(e) {
    return this._modelData ? this._modelData.model.changeDecorations(e, this._id) : null;
  }
  getLineDecorations(e) {
    return this._modelData ? this._modelData.model.getLineDecorations(e, this._id, HE(this._configuration.options)) : null;
  }
  getDecorationsInRange(e) {
    return this._modelData ? this._modelData.model.getDecorationsInRange(e, this._id, HE(this._configuration.options)) : null;
  }
  /**
   * @deprecated
   */
  deltaDecorations(e, t) {
    return this._modelData ? e.length === 0 && t.length === 0 ? e : this._modelData.model.deltaDecorations(e, t, this._id) : [];
  }
  removeDecorations(e) {
    !this._modelData || e.length === 0 || this._modelData.model.changeDecorations((t) => {
      t.deltaDecorations(e, []);
    });
  }
  removeDecorationsByType(e) {
    const t = this._decorationTypeKeysToIds[e];
    t && this.deltaDecorations(t, []), this._decorationTypeKeysToIds.hasOwnProperty(e) && delete this._decorationTypeKeysToIds[e], this._decorationTypeSubtypes.hasOwnProperty(e) && delete this._decorationTypeSubtypes[e];
  }
  getLayoutInfo() {
    return this._configuration.options.get(
      143
      /* EditorOption.layoutInfo */
    );
  }
  createOverviewRuler(e) {
    return !this._modelData || !this._modelData.hasRealView ? null : this._modelData.view.createOverviewRuler(e);
  }
  getContainerDomNode() {
    return this._domElement;
  }
  getDomNode() {
    return !this._modelData || !this._modelData.hasRealView ? null : this._modelData.view.domNode.domNode;
  }
  delegateVerticalScrollbarPointerDown(e) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.delegateVerticalScrollbarPointerDown(e);
  }
  delegateScrollFromMouseWheelEvent(e) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.delegateScrollFromMouseWheelEvent(e);
  }
  layout(e) {
    this._configuration.observeContainer(e), this.render();
  }
  focus() {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.focus();
  }
  hasTextFocus() {
    return !this._modelData || !this._modelData.hasRealView ? !1 : this._modelData.view.isFocused();
  }
  hasWidgetFocus() {
    return this._focusTracker && this._focusTracker.hasFocus();
  }
  addContentWidget(e) {
    const t = {
      widget: e,
      position: e.getPosition()
    };
    this._contentWidgets.hasOwnProperty(e.getId()) && console.warn("Overwriting a content widget with the same id."), this._contentWidgets[e.getId()] = t, this._modelData && this._modelData.hasRealView && this._modelData.view.addContentWidget(t);
  }
  layoutContentWidget(e) {
    const t = e.getId();
    if (this._contentWidgets.hasOwnProperty(t)) {
      const n = this._contentWidgets[t];
      n.position = e.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutContentWidget(n);
    }
  }
  removeContentWidget(e) {
    const t = e.getId();
    if (this._contentWidgets.hasOwnProperty(t)) {
      const n = this._contentWidgets[t];
      delete this._contentWidgets[t], this._modelData && this._modelData.hasRealView && this._modelData.view.removeContentWidget(n);
    }
  }
  addOverlayWidget(e) {
    const t = {
      widget: e,
      position: e.getPosition()
    };
    this._overlayWidgets.hasOwnProperty(e.getId()) && console.warn("Overwriting an overlay widget with the same id."), this._overlayWidgets[e.getId()] = t, this._modelData && this._modelData.hasRealView && this._modelData.view.addOverlayWidget(t);
  }
  layoutOverlayWidget(e) {
    const t = e.getId();
    if (this._overlayWidgets.hasOwnProperty(t)) {
      const n = this._overlayWidgets[t];
      n.position = e.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutOverlayWidget(n);
    }
  }
  removeOverlayWidget(e) {
    const t = e.getId();
    if (this._overlayWidgets.hasOwnProperty(t)) {
      const n = this._overlayWidgets[t];
      delete this._overlayWidgets[t], this._modelData && this._modelData.hasRealView && this._modelData.view.removeOverlayWidget(n);
    }
  }
  addGlyphMarginWidget(e) {
    const t = {
      widget: e,
      position: e.getPosition()
    };
    this._glyphMarginWidgets.hasOwnProperty(e.getId()) && console.warn("Overwriting a glyph margin widget with the same id."), this._glyphMarginWidgets[e.getId()] = t, this._modelData && this._modelData.hasRealView && this._modelData.view.addGlyphMarginWidget(t);
  }
  layoutGlyphMarginWidget(e) {
    const t = e.getId();
    if (this._glyphMarginWidgets.hasOwnProperty(t)) {
      const n = this._glyphMarginWidgets[t];
      n.position = e.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutGlyphMarginWidget(n);
    }
  }
  removeGlyphMarginWidget(e) {
    const t = e.getId();
    if (this._glyphMarginWidgets.hasOwnProperty(t)) {
      const n = this._glyphMarginWidgets[t];
      delete this._glyphMarginWidgets[t], this._modelData && this._modelData.hasRealView && this._modelData.view.removeGlyphMarginWidget(n);
    }
  }
  changeViewZones(e) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.change(e);
  }
  getTargetAtClientPoint(e, t) {
    return !this._modelData || !this._modelData.hasRealView ? null : this._modelData.view.getTargetAtClientPoint(e, t);
  }
  getScrolledVisiblePosition(e) {
    if (!this._modelData || !this._modelData.hasRealView)
      return null;
    const t = this._modelData.model.validatePosition(e), n = this._configuration.options, r = n.get(
      143
      /* EditorOption.layoutInfo */
    ), s = Wp._getVerticalOffsetForPosition(this._modelData, t.lineNumber, t.column) - this.getScrollTop(), o = this._modelData.view.getOffsetForColumn(t.lineNumber, t.column) + r.glyphMarginWidth + r.lineNumbersWidth + r.decorationsWidth - this.getScrollLeft();
    return {
      top: s,
      left: o,
      height: n.get(
        66
        /* EditorOption.lineHeight */
      )
    };
  }
  getOffsetForColumn(e, t) {
    return !this._modelData || !this._modelData.hasRealView ? -1 : this._modelData.view.getOffsetForColumn(e, t);
  }
  render(e = !1) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.render(!0, e);
  }
  setAriaOptions(e) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.setAriaOptions(e);
  }
  applyFontInfo(e) {
    Ds(e, this._configuration.options.get(
      50
      /* EditorOption.fontInfo */
    ));
  }
  setBanner(e, t) {
    this._bannerDomNode && this._domElement.contains(this._bannerDomNode) && this._domElement.removeChild(this._bannerDomNode), this._bannerDomNode = e, this._configuration.setReservedHeight(e ? t : 0), this._bannerDomNode && this._domElement.prepend(this._bannerDomNode);
  }
  _attachModel(e) {
    if (!e) {
      this._modelData = null;
      return;
    }
    const t = [];
    this._domElement.setAttribute("data-mode-id", e.getLanguageId()), this._configuration.setIsDominatedByLongLines(e.isDominatedByLongLines()), this._configuration.setModelLineCount(e.getLineCount());
    const n = e.onBeforeAttached(), r = new THe(this._id, this._configuration, e, Gz.create(), Uz.create(this._configuration.options), (a) => Cl(a), this.languageConfigurationService, this._themeService, n);
    t.push(e.onWillDispose(() => this.setModel(null))), t.push(r.onEvent((a) => {
      switch (a.kind) {
        case 0:
          this._onDidContentSizeChange.fire(a);
          break;
        case 1:
          this._editorTextFocus.setValue(a.hasFocus);
          break;
        case 2:
          this._onDidScrollChange.fire(a);
          break;
        case 3:
          this._onDidChangeViewZones.fire();
          break;
        case 4:
          this._onDidChangeHiddenAreas.fire();
          break;
        case 5:
          this._onDidAttemptReadOnlyEdit.fire();
          break;
        case 6: {
          if (a.reachedMaxCursorCount) {
            const u = this.getOption(
              79
              /* EditorOption.multiCursorLimit */
            ), h = C("cursors.maximum", "The number of cursors has been limited to {0}. Consider using [find and replace](https://code.visualstudio.com/docs/editor/codebasics#_find-and-replace) for larger changes or increase the editor multi cursor limit setting.", u);
            this._notificationService.prompt(I4.Warning, h, [
              {
                label: "Find and Replace",
                run: () => {
                  this._commandService.executeCommand("editor.action.startFindReplaceAction");
                }
              },
              {
                label: C("goToSetting", "Increase Multi Cursor Limit"),
                run: () => {
                  this._commandService.executeCommand("workbench.action.openSettings2", {
                    query: "editor.multiCursorLimit"
                  });
                }
              }
            ]);
          }
          const l = [];
          for (let u = 0, h = a.selections.length; u < h; u++)
            l[u] = a.selections[u].getPosition();
          const c = {
            position: l[0],
            secondaryPositions: l.slice(1),
            reason: a.reason,
            source: a.source
          };
          this._onDidChangeCursorPosition.fire(c);
          const d = {
            selection: a.selections[0],
            secondarySelections: a.selections.slice(1),
            modelVersionId: a.modelVersionId,
            oldSelections: a.oldSelections,
            oldModelVersionId: a.oldModelVersionId,
            source: a.source,
            reason: a.reason
          };
          this._onDidChangeCursorSelection.fire(d);
          break;
        }
        case 7:
          this._onDidChangeModelDecorations.fire(a.event);
          break;
        case 8:
          this._domElement.setAttribute("data-mode-id", e.getLanguageId()), this._onDidChangeModelLanguage.fire(a.event);
          break;
        case 9:
          this._onDidChangeModelLanguageConfiguration.fire(a.event);
          break;
        case 10:
          this._onDidChangeModelContent.fire(a.event);
          break;
        case 11:
          this._onDidChangeModelOptions.fire(a.event);
          break;
        case 12:
          this._onDidChangeModelTokens.fire(a.event);
          break;
      }
    }));
    const [s, o] = this._createView(r);
    if (o) {
      this._domElement.appendChild(s.domNode.domNode);
      let a = Object.keys(this._contentWidgets);
      for (let l = 0, c = a.length; l < c; l++) {
        const d = a[l];
        s.addContentWidget(this._contentWidgets[d]);
      }
      a = Object.keys(this._overlayWidgets);
      for (let l = 0, c = a.length; l < c; l++) {
        const d = a[l];
        s.addOverlayWidget(this._overlayWidgets[d]);
      }
      a = Object.keys(this._glyphMarginWidgets);
      for (let l = 0, c = a.length; l < c; l++) {
        const d = a[l];
        s.addGlyphMarginWidget(this._glyphMarginWidgets[d]);
      }
      s.render(!1, !0), s.domNode.domNode.setAttribute("data-uri", e.uri.toString());
    }
    this._modelData = new qHe(e, r, s, o, t, n);
  }
  _createView(e) {
    let t;
    this.isSimpleWidget ? t = {
      paste: (s, o, a, l) => {
        this._paste("keyboard", s, o, a, l);
      },
      type: (s) => {
        this._type("keyboard", s);
      },
      compositionType: (s, o, a, l) => {
        this._compositionType("keyboard", s, o, a, l);
      },
      startComposition: () => {
        this._startComposition();
      },
      endComposition: () => {
        this._endComposition("keyboard");
      },
      cut: () => {
        this._cut("keyboard");
      }
    } : t = {
      paste: (s, o, a, l) => {
        const c = { text: s, pasteOnNewLine: o, multicursorText: a, mode: l };
        this._commandService.executeCommand("paste", c);
      },
      type: (s) => {
        const o = { text: s };
        this._commandService.executeCommand("type", o);
      },
      compositionType: (s, o, a, l) => {
        if (a || l) {
          const c = { text: s, replacePrevCharCnt: o, replaceNextCharCnt: a, positionDelta: l };
          this._commandService.executeCommand("compositionType", c);
        } else {
          const c = { text: s, replaceCharCnt: o };
          this._commandService.executeCommand("replacePreviousChar", c);
        }
      },
      startComposition: () => {
        this._commandService.executeCommand("compositionStart", {});
      },
      endComposition: () => {
        this._commandService.executeCommand("compositionEnd", {});
      },
      cut: () => {
        this._commandService.executeCommand("cut", {});
      }
    };
    const n = new w4(e.coordinatesConverter);
    return n.onKeyDown = (s) => this._onKeyDown.fire(s), n.onKeyUp = (s) => this._onKeyUp.fire(s), n.onContextMenu = (s) => this._onContextMenu.fire(s), n.onMouseMove = (s) => this._onMouseMove.fire(s), n.onMouseLeave = (s) => this._onMouseLeave.fire(s), n.onMouseDown = (s) => this._onMouseDown.fire(s), n.onMouseUp = (s) => this._onMouseUp.fire(s), n.onMouseDrag = (s) => this._onMouseDrag.fire(s), n.onMouseDrop = (s) => this._onMouseDrop.fire(s), n.onMouseDropCanceled = (s) => this._onMouseDropCanceled.fire(s), n.onMouseWheel = (s) => this._onMouseWheel.fire(s), [new FF(t, this._configuration, this._themeService.getColorTheme(), e, n, this._overflowWidgetsDomNode, this._instantiationService), !0];
  }
  _postDetachModelCleanup(e) {
    e?.removeAllDecorationsWithOwnerId(this._id);
  }
  _detachModel() {
    if (!this._modelData)
      return null;
    const e = this._modelData.model, t = this._modelData.hasRealView ? this._modelData.view.domNode.domNode : null;
    return this._modelData.dispose(), this._modelData = null, this._domElement.removeAttribute("data-mode-id"), t && this._domElement.contains(t) && this._domElement.removeChild(t), this._bannerDomNode && this._domElement.contains(this._bannerDomNode) && this._domElement.removeChild(this._bannerDomNode), e;
  }
  _removeDecorationType(e) {
    this._codeEditorService.removeDecorationType(e);
  }
  hasModel() {
    return this._modelData !== null;
  }
  showDropIndicatorAt(e) {
    const t = [{
      range: new V(e.lineNumber, e.column, e.lineNumber, e.column),
      options: Wp.dropIntoEditorDecorationOptions
    }];
    this._dropIntoEditorDecorations.set(t), this.revealPosition(
      e,
      1
      /* editorCommon.ScrollType.Immediate */
    );
  }
  removeDropIndicator() {
    this._dropIntoEditorDecorations.clear();
  }
  setContextValue(e, t) {
    this._contextKeyService.createKey(e, t);
  }
};
L_.dropIntoEditorDecorationOptions = Lt.register({
  description: "workbench-dnd-target",
  className: "dnd-target"
});
L_ = Wp = zHe([
  zu(3, bt),
  zu(4, Sn),
  zu(5, Ui),
  zu(6, yt),
  zu(7, Pr),
  zu(8, dr),
  zu(9, lf),
  zu(10, Un),
  zu(11, tt)
], L_);
class wQ extends we {
  constructor(e) {
    super(), this._emitterOptions = e, this._onDidChangeToTrue = this._register(new pe(this._emitterOptions)), this.onDidChangeToTrue = this._onDidChangeToTrue.event, this._onDidChangeToFalse = this._register(new pe(this._emitterOptions)), this.onDidChangeToFalse = this._onDidChangeToFalse.event, this._value = 0;
  }
  setValue(e) {
    const t = e ? 2 : 1;
    this._value !== t && (this._value = t, this._value === 2 ? this._onDidChangeToTrue.fire() : this._value === 1 && this._onDidChangeToFalse.fire());
  }
}
class js extends pe {
  constructor(e, t) {
    super({ deliveryQueue: t }), this._contributions = e;
  }
  fire(e) {
    this._contributions.onBeforeInteractionEvent(), super.fire(e);
  }
}
class KHe extends we {
  constructor(e, t) {
    super(), this._editor = e, t.createKey("editorId", e.getId()), this._editorSimpleInput = $.editorSimpleInput.bindTo(t), this._editorFocus = $.focus.bindTo(t), this._textInputFocus = $.textInputFocus.bindTo(t), this._editorTextFocus = $.editorTextFocus.bindTo(t), this._tabMovesFocus = $.tabMovesFocus.bindTo(t), this._editorReadonly = $.readOnly.bindTo(t), this._inDiffEditor = $.inDiffEditor.bindTo(t), this._editorColumnSelection = $.columnSelection.bindTo(t), this._hasMultipleSelections = $.hasMultipleSelections.bindTo(t), this._hasNonEmptySelection = $.hasNonEmptySelection.bindTo(t), this._canUndo = $.canUndo.bindTo(t), this._canRedo = $.canRedo.bindTo(t), this._register(this._editor.onDidChangeConfiguration(() => this._updateFromConfig())), this._register(this._editor.onDidChangeCursorSelection(() => this._updateFromSelection())), this._register(this._editor.onDidFocusEditorWidget(() => this._updateFromFocus())), this._register(this._editor.onDidBlurEditorWidget(() => this._updateFromFocus())), this._register(this._editor.onDidFocusEditorText(() => this._updateFromFocus())), this._register(this._editor.onDidBlurEditorText(() => this._updateFromFocus())), this._register(this._editor.onDidChangeModel(() => this._updateFromModel())), this._register(this._editor.onDidChangeConfiguration(() => this._updateFromModel())), this._register(b_.onDidChangeTabFocus((n) => this._tabMovesFocus.set(n))), this._updateFromConfig(), this._updateFromSelection(), this._updateFromFocus(), this._updateFromModel(), this._editorSimpleInput.set(this._editor.isSimpleWidget);
  }
  _updateFromConfig() {
    const e = this._editor.getOptions();
    this._tabMovesFocus.set(b_.getTabFocusMode()), this._editorReadonly.set(e.get(
      90
      /* EditorOption.readOnly */
    )), this._inDiffEditor.set(e.get(
      61
      /* EditorOption.inDiffEditor */
    )), this._editorColumnSelection.set(e.get(
      22
      /* EditorOption.columnSelection */
    ));
  }
  _updateFromSelection() {
    const e = this._editor.getSelections();
    e ? (this._hasMultipleSelections.set(e.length > 1), this._hasNonEmptySelection.set(e.some((t) => !t.isEmpty()))) : (this._hasMultipleSelections.reset(), this._hasNonEmptySelection.reset());
  }
  _updateFromFocus() {
    this._editorFocus.set(this._editor.hasWidgetFocus() && !this._editor.isSimpleWidget), this._editorTextFocus.set(this._editor.hasTextFocus() && !this._editor.isSimpleWidget), this._textInputFocus.set(this._editor.hasTextFocus());
  }
  _updateFromModel() {
    const e = this._editor.getModel();
    this._canUndo.set(!!(e && e.canUndo())), this._canRedo.set(!!(e && e.canRedo()));
  }
}
class YHe extends we {
  constructor(e, t, n) {
    super(), this._editor = e, this._contextKeyService = t, this._languageFeaturesService = n, this._langId = $.languageId.bindTo(t), this._hasCompletionItemProvider = $.hasCompletionItemProvider.bindTo(t), this._hasCodeActionsProvider = $.hasCodeActionsProvider.bindTo(t), this._hasCodeLensProvider = $.hasCodeLensProvider.bindTo(t), this._hasDefinitionProvider = $.hasDefinitionProvider.bindTo(t), this._hasDeclarationProvider = $.hasDeclarationProvider.bindTo(t), this._hasImplementationProvider = $.hasImplementationProvider.bindTo(t), this._hasTypeDefinitionProvider = $.hasTypeDefinitionProvider.bindTo(t), this._hasHoverProvider = $.hasHoverProvider.bindTo(t), this._hasDocumentHighlightProvider = $.hasDocumentHighlightProvider.bindTo(t), this._hasDocumentSymbolProvider = $.hasDocumentSymbolProvider.bindTo(t), this._hasReferenceProvider = $.hasReferenceProvider.bindTo(t), this._hasRenameProvider = $.hasRenameProvider.bindTo(t), this._hasSignatureHelpProvider = $.hasSignatureHelpProvider.bindTo(t), this._hasInlayHintsProvider = $.hasInlayHintsProvider.bindTo(t), this._hasDocumentFormattingProvider = $.hasDocumentFormattingProvider.bindTo(t), this._hasDocumentSelectionFormattingProvider = $.hasDocumentSelectionFormattingProvider.bindTo(t), this._hasMultipleDocumentFormattingProvider = $.hasMultipleDocumentFormattingProvider.bindTo(t), this._hasMultipleDocumentSelectionFormattingProvider = $.hasMultipleDocumentSelectionFormattingProvider.bindTo(t), this._isInWalkThrough = $.isInWalkThroughSnippet.bindTo(t);
    const r = () => this._update();
    this._register(e.onDidChangeModel(r)), this._register(e.onDidChangeModelLanguage(r)), this._register(n.completionProvider.onDidChange(r)), this._register(n.codeActionProvider.onDidChange(r)), this._register(n.codeLensProvider.onDidChange(r)), this._register(n.definitionProvider.onDidChange(r)), this._register(n.declarationProvider.onDidChange(r)), this._register(n.implementationProvider.onDidChange(r)), this._register(n.typeDefinitionProvider.onDidChange(r)), this._register(n.hoverProvider.onDidChange(r)), this._register(n.documentHighlightProvider.onDidChange(r)), this._register(n.documentSymbolProvider.onDidChange(r)), this._register(n.referenceProvider.onDidChange(r)), this._register(n.renameProvider.onDidChange(r)), this._register(n.documentFormattingEditProvider.onDidChange(r)), this._register(n.documentRangeFormattingEditProvider.onDidChange(r)), this._register(n.signatureHelpProvider.onDidChange(r)), this._register(n.inlayHintsProvider.onDidChange(r)), r();
  }
  dispose() {
    super.dispose();
  }
  reset() {
    this._contextKeyService.bufferChangeEvents(() => {
      this._langId.reset(), this._hasCompletionItemProvider.reset(), this._hasCodeActionsProvider.reset(), this._hasCodeLensProvider.reset(), this._hasDefinitionProvider.reset(), this._hasDeclarationProvider.reset(), this._hasImplementationProvider.reset(), this._hasTypeDefinitionProvider.reset(), this._hasHoverProvider.reset(), this._hasDocumentHighlightProvider.reset(), this._hasDocumentSymbolProvider.reset(), this._hasReferenceProvider.reset(), this._hasRenameProvider.reset(), this._hasDocumentFormattingProvider.reset(), this._hasDocumentSelectionFormattingProvider.reset(), this._hasSignatureHelpProvider.reset(), this._isInWalkThrough.reset();
    });
  }
  _update() {
    const e = this._editor.getModel();
    if (!e) {
      this.reset();
      return;
    }
    this._contextKeyService.bufferChangeEvents(() => {
      this._langId.set(e.getLanguageId()), this._hasCompletionItemProvider.set(this._languageFeaturesService.completionProvider.has(e)), this._hasCodeActionsProvider.set(this._languageFeaturesService.codeActionProvider.has(e)), this._hasCodeLensProvider.set(this._languageFeaturesService.codeLensProvider.has(e)), this._hasDefinitionProvider.set(this._languageFeaturesService.definitionProvider.has(e)), this._hasDeclarationProvider.set(this._languageFeaturesService.declarationProvider.has(e)), this._hasImplementationProvider.set(this._languageFeaturesService.implementationProvider.has(e)), this._hasTypeDefinitionProvider.set(this._languageFeaturesService.typeDefinitionProvider.has(e)), this._hasHoverProvider.set(this._languageFeaturesService.hoverProvider.has(e)), this._hasDocumentHighlightProvider.set(this._languageFeaturesService.documentHighlightProvider.has(e)), this._hasDocumentSymbolProvider.set(this._languageFeaturesService.documentSymbolProvider.has(e)), this._hasReferenceProvider.set(this._languageFeaturesService.referenceProvider.has(e)), this._hasRenameProvider.set(this._languageFeaturesService.renameProvider.has(e)), this._hasSignatureHelpProvider.set(this._languageFeaturesService.signatureHelpProvider.has(e)), this._hasInlayHintsProvider.set(this._languageFeaturesService.inlayHintsProvider.has(e)), this._hasDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.has(e) || this._languageFeaturesService.documentRangeFormattingEditProvider.has(e)), this._hasDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.has(e)), this._hasMultipleDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.all(e).length + this._languageFeaturesService.documentRangeFormattingEditProvider.all(e).length > 1), this._hasMultipleDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.all(e).length > 1), this._isInWalkThrough.set(e.uri.scheme === Mt.walkThroughSnippet);
    });
  }
}
class XHe extends we {
  constructor(e) {
    super(), this._onChange = this._register(new pe()), this.onChange = this._onChange.event, this._hasFocus = !1, this._domFocusTracker = this._register(yu(e)), this._register(this._domFocusTracker.onDidFocus(() => {
      this._hasFocus = !0, this._onChange.fire(void 0);
    })), this._register(this._domFocusTracker.onDidBlur(() => {
      this._hasFocus = !1, this._onChange.fire(void 0);
    }));
  }
  hasFocus() {
    return this._hasFocus;
  }
}
class ZHe {
  get length() {
    return this._decorationIds.length;
  }
  constructor(e, t) {
    this._editor = e, this._decorationIds = [], this._isChangingDecorations = !1, Array.isArray(t) && t.length > 0 && this.set(t);
  }
  onDidChange(e, t, n) {
    return this._editor.onDidChangeModelDecorations((r) => {
      this._isChangingDecorations || e.call(t, r);
    }, n);
  }
  getRange(e) {
    return !this._editor.hasModel() || e >= this._decorationIds.length ? null : this._editor.getModel().getDecorationRange(this._decorationIds[e]);
  }
  getRanges() {
    if (!this._editor.hasModel())
      return [];
    const e = this._editor.getModel(), t = [];
    for (const n of this._decorationIds) {
      const r = e.getDecorationRange(n);
      r && t.push(r);
    }
    return t;
  }
  has(e) {
    return this._decorationIds.includes(e.id);
  }
  clear() {
    this._decorationIds.length !== 0 && this.set([]);
  }
  set(e) {
    try {
      this._isChangingDecorations = !0, this._editor.changeDecorations((t) => {
        this._decorationIds = t.deltaDecorations(this._decorationIds, e);
      });
    } finally {
      this._isChangingDecorations = !1;
    }
    return this._decorationIds;
  }
}
const QHe = encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3' enable-background='new 0 0 6 3' height='3' width='6'><g fill='"), JHe = encodeURIComponent("'><polygon points='5.5,0 2.5,3 1.1,3 4.1,0'/><polygon points='4,0 6,2 6,0.6 5.4,0'/><polygon points='0,2 1,3 2.4,3 0,0.6'/></g></svg>");
function Y6(i) {
  return QHe + encodeURIComponent(i.toString()) + JHe;
}
const $He = encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" height="3" width="12"><g fill="'), eWe = encodeURIComponent('"><circle cx="1" cy="1" r="1"/><circle cx="5" cy="1" r="1"/><circle cx="9" cy="1" r="1"/></g></svg>');
function tWe(i) {
  return $He + encodeURIComponent(i.toString()) + eWe;
}
fc((i, e) => {
  const t = i.getColor($d);
  t && e.addRule(`.monaco-editor .squiggly-error { background: url("data:image/svg+xml,${Y6(t)}") repeat-x bottom left; }`);
  const n = i.getColor(Na);
  n && e.addRule(`.monaco-editor .squiggly-warning { background: url("data:image/svg+xml,${Y6(n)}") repeat-x bottom left; }`);
  const r = i.getColor(Oo);
  r && e.addRule(`.monaco-editor .squiggly-info { background: url("data:image/svg+xml,${Y6(r)}") repeat-x bottom left; }`);
  const s = i.getColor(xMe);
  s && e.addRule(`.monaco-editor .squiggly-hint { background: url("data:image/svg+xml,${tWe(s)}") no-repeat bottom left; }`);
  const o = i.getColor(RRe);
  o && e.addRule(`.monaco-editor.showUnused .squiggly-inline-unnecessary { opacity: ${o.rgba.a}; }`);
});
var nWe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, iWe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, rWe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let $F = class extends we {
  constructor(e) {
    super(), this._themeService = e, this._onWillCreateCodeEditor = this._register(new pe()), this._onCodeEditorAdd = this._register(new pe()), this.onCodeEditorAdd = this._onCodeEditorAdd.event, this._onCodeEditorRemove = this._register(new pe()), this.onCodeEditorRemove = this._onCodeEditorRemove.event, this._onWillCreateDiffEditor = this._register(new pe()), this._onDiffEditorAdd = this._register(new pe()), this.onDiffEditorAdd = this._onDiffEditorAdd.event, this._onDiffEditorRemove = this._register(new pe()), this.onDiffEditorRemove = this._onDiffEditorRemove.event, this._decorationOptionProviders = /* @__PURE__ */ new Map(), this._codeEditorOpenHandlers = new fo(), this._modelProperties = /* @__PURE__ */ new Map(), this._codeEditors = /* @__PURE__ */ Object.create(null), this._diffEditors = /* @__PURE__ */ Object.create(null), this._globalStyleSheet = null;
  }
  willCreateCodeEditor() {
    this._onWillCreateCodeEditor.fire();
  }
  addCodeEditor(e) {
    this._codeEditors[e.getId()] = e, this._onCodeEditorAdd.fire(e);
  }
  removeCodeEditor(e) {
    delete this._codeEditors[e.getId()] && this._onCodeEditorRemove.fire(e);
  }
  listCodeEditors() {
    return Object.keys(this._codeEditors).map((e) => this._codeEditors[e]);
  }
  willCreateDiffEditor() {
    this._onWillCreateDiffEditor.fire();
  }
  addDiffEditor(e) {
    this._diffEditors[e.getId()] = e, this._onDiffEditorAdd.fire(e);
  }
  listDiffEditors() {
    return Object.keys(this._diffEditors).map((e) => this._diffEditors[e]);
  }
  getFocusedCodeEditor() {
    let e = null;
    const t = this.listCodeEditors();
    for (const n of t) {
      if (n.hasTextFocus())
        return n;
      n.hasWidgetFocus() && (e = n);
    }
    return e;
  }
  removeDecorationType(e) {
    const t = this._decorationOptionProviders.get(e);
    t && (t.refCount--, t.refCount <= 0 && (this._decorationOptionProviders.delete(e), t.dispose(), this.listCodeEditors().forEach((n) => n.removeDecorationsByType(e))));
  }
  setModelProperty(e, t, n) {
    const r = e.toString();
    let s;
    this._modelProperties.has(r) ? s = this._modelProperties.get(r) : (s = /* @__PURE__ */ new Map(), this._modelProperties.set(r, s)), s.set(t, n);
  }
  getModelProperty(e, t) {
    const n = e.toString();
    if (this._modelProperties.has(n))
      return this._modelProperties.get(n).get(t);
  }
  openCodeEditor(e, t, n) {
    return rWe(this, void 0, void 0, function* () {
      for (const r of this._codeEditorOpenHandlers) {
        const s = yield r(e, t, n);
        if (s !== null)
          return s;
      }
      return null;
    });
  }
  registerCodeEditorOpenHandler(e) {
    const t = this._codeEditorOpenHandlers.unshift(e);
    return Ct(t);
  }
};
$F = nWe([
  iWe(0, Pr)
], $F);
var sWe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, SQ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, oWe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let LL = class extends $F {
  constructor(e, t) {
    super(t), this._register(this.onCodeEditorAdd(() => this._checkContextKey())), this._register(this.onCodeEditorRemove(() => this._checkContextKey())), this._editorIsOpen = e.createKey("editorIsOpen", !1), this._activeCodeEditor = null, this._register(this.registerCodeEditorOpenHandler((n, r, s) => oWe(this, void 0, void 0, function* () {
      return r ? this.doOpenEditor(r, n) : null;
    })));
  }
  _checkContextKey() {
    let e = !1;
    for (const t of this.listCodeEditors())
      if (!t.isSimpleWidget) {
        e = !0;
        break;
      }
    this._editorIsOpen.set(e);
  }
  setActiveCodeEditor(e) {
    this._activeCodeEditor = e;
  }
  getActiveCodeEditor() {
    return this._activeCodeEditor;
  }
  doOpenEditor(e, t) {
    if (!this.findModel(e, t.resource)) {
      if (t.resource) {
        const s = t.resource.scheme;
        if (s === Mt.http || s === Mt.https)
          return jhe(t.resource.toString()), e;
      }
      return null;
    }
    const r = t.options ? t.options.selection : null;
    if (r)
      if (typeof r.endLineNumber == "number" && typeof r.endColumn == "number")
        e.setSelection(r), e.revealRangeInCenter(
          r,
          1
          /* ScrollType.Immediate */
        );
      else {
        const s = {
          lineNumber: r.startLineNumber,
          column: r.startColumn
        };
        e.setPosition(s), e.revealPositionInCenter(
          s,
          1
          /* ScrollType.Immediate */
        );
      }
    return e;
  }
  findModel(e, t) {
    const n = e.getModel();
    return n && n.uri.toString() !== t.toString() ? null : n;
  }
};
LL = sWe([
  SQ(0, yt),
  SQ(1, Pr)
], LL);
an(
  Sn,
  LL,
  0
  /* InstantiationType.Eager */
);
const bb = Gt("layoutService");
var Fge = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Bge = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let IL = class {
  get dimension() {
    return this._dimension || (this._dimension = fb(window.document.body)), this._dimension;
  }
  get hasContainer() {
    return !1;
  }
  get container() {
    throw new Error("ILayoutService.container is not available in the standalone editor!");
  }
  focus() {
    var e;
    (e = this._codeEditorService.getFocusedCodeEditor()) === null || e === void 0 || e.focus();
  }
  constructor(e) {
    this._codeEditorService = e, this.onDidLayout = qe.None, this.offset = { top: 0, quickPickTop: 0 };
  }
};
IL = Fge([
  Bge(0, Sn)
], IL);
let eB = class extends IL {
  get hasContainer() {
    return !1;
  }
  get container() {
    return this._container;
  }
  constructor(e, t) {
    super(t), this._container = e;
  }
};
eB = Fge([
  Bge(1, Sn)
], eB);
an(
  bb,
  IL,
  1
  /* InstantiationType.Delayed */
);
const RS = Gt("dialogService");
var aWe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, xQ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, aD = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function lD(i) {
  return i.scheme === Mt.file ? i.fsPath : i.path;
}
let Vge = 0;
class cD {
  constructor(e, t, n, r, s, o, a) {
    this.id = ++Vge, this.type = 0, this.actual = e, this.label = e.label, this.confirmBeforeUndo = e.confirmBeforeUndo || !1, this.resourceLabel = t, this.strResource = n, this.resourceLabels = [this.resourceLabel], this.strResources = [this.strResource], this.groupId = r, this.groupOrder = s, this.sourceId = o, this.sourceOrder = a, this.isValid = !0;
  }
  setValid(e) {
    this.isValid = e;
  }
  toString() {
    return `[id:${this.id}] [group:${this.groupId}] [${this.isValid ? "  VALID" : "INVALID"}] ${this.actual.constructor.name} - ${this.actual}`;
  }
}
class DQ {
  constructor(e, t) {
    this.resourceLabel = e, this.reason = t;
  }
}
class EQ {
  constructor() {
    this.elements = /* @__PURE__ */ new Map();
  }
  createMessage() {
    const e = [], t = [];
    for (const [, r] of this.elements)
      (r.reason === 0 ? e : t).push(r.resourceLabel);
    const n = [];
    return e.length > 0 && n.push(C({ key: "externalRemoval", comment: ["{0} is a list of filenames"] }, "The following files have been closed and modified on disk: {0}.", e.join(", "))), t.length > 0 && n.push(C({ key: "noParallelUniverses", comment: ["{0} is a list of filenames"] }, "The following files have been modified in an incompatible way: {0}.", t.join(", "))), n.join(`
`);
  }
  get size() {
    return this.elements.size;
  }
  has(e) {
    return this.elements.has(e);
  }
  set(e, t) {
    this.elements.set(e, t);
  }
  delete(e) {
    return this.elements.delete(e);
  }
}
class lWe {
  constructor(e, t, n, r, s, o, a) {
    this.id = ++Vge, this.type = 1, this.actual = e, this.label = e.label, this.confirmBeforeUndo = e.confirmBeforeUndo || !1, this.resourceLabels = t, this.strResources = n, this.groupId = r, this.groupOrder = s, this.sourceId = o, this.sourceOrder = a, this.removedResources = null, this.invalidatedResources = null;
  }
  canSplit() {
    return typeof this.actual.split == "function";
  }
  removeResource(e, t, n) {
    this.removedResources || (this.removedResources = new EQ()), this.removedResources.has(t) || this.removedResources.set(t, new DQ(e, n));
  }
  setValid(e, t, n) {
    n ? this.invalidatedResources && (this.invalidatedResources.delete(t), this.invalidatedResources.size === 0 && (this.invalidatedResources = null)) : (this.invalidatedResources || (this.invalidatedResources = new EQ()), this.invalidatedResources.has(t) || this.invalidatedResources.set(t, new DQ(
      e,
      0
      /* RemovedResourceReason.ExternalRemoval */
    )));
  }
  toString() {
    return `[id:${this.id}] [group:${this.groupId}] [${this.invalidatedResources ? "INVALID" : "  VALID"}] ${this.actual.constructor.name} - ${this.actual}`;
  }
}
class Hge {
  constructor(e, t) {
    this.resourceLabel = e, this.strResource = t, this._past = [], this._future = [], this.locked = !1, this.versionId = 1;
  }
  dispose() {
    for (const e of this._past)
      e.type === 1 && e.removeResource(
        this.resourceLabel,
        this.strResource,
        0
        /* RemovedResourceReason.ExternalRemoval */
      );
    for (const e of this._future)
      e.type === 1 && e.removeResource(
        this.resourceLabel,
        this.strResource,
        0
        /* RemovedResourceReason.ExternalRemoval */
      );
    this.versionId++;
  }
  toString() {
    const e = [];
    e.push(`* ${this.strResource}:`);
    for (let t = 0; t < this._past.length; t++)
      e.push(`   * [UNDO] ${this._past[t]}`);
    for (let t = this._future.length - 1; t >= 0; t--)
      e.push(`   * [REDO] ${this._future[t]}`);
    return e.join(`
`);
  }
  flushAllElements() {
    this._past = [], this._future = [], this.versionId++;
  }
  _setElementValidFlag(e, t) {
    e.type === 1 ? e.setValid(this.resourceLabel, this.strResource, t) : e.setValid(t);
  }
  setElementsValidFlag(e, t) {
    for (const n of this._past)
      t(n.actual) && this._setElementValidFlag(n, e);
    for (const n of this._future)
      t(n.actual) && this._setElementValidFlag(n, e);
  }
  pushElement(e) {
    for (const t of this._future)
      t.type === 1 && t.removeResource(
        this.resourceLabel,
        this.strResource,
        1
        /* RemovedResourceReason.NoParallelUniverses */
      );
    this._future = [], this._past.push(e), this.versionId++;
  }
  createSnapshot(e) {
    const t = [];
    for (let n = 0, r = this._past.length; n < r; n++)
      t.push(this._past[n].id);
    for (let n = this._future.length - 1; n >= 0; n--)
      t.push(this._future[n].id);
    return new Tge(e, t);
  }
  restoreSnapshot(e) {
    const t = e.elements.length;
    let n = !0, r = 0, s = -1;
    for (let a = 0, l = this._past.length; a < l; a++, r++) {
      const c = this._past[a];
      n && (r >= t || c.id !== e.elements[r]) && (n = !1, s = 0), !n && c.type === 1 && c.removeResource(
        this.resourceLabel,
        this.strResource,
        0
        /* RemovedResourceReason.ExternalRemoval */
      );
    }
    let o = -1;
    for (let a = this._future.length - 1; a >= 0; a--, r++) {
      const l = this._future[a];
      n && (r >= t || l.id !== e.elements[r]) && (n = !1, o = a), !n && l.type === 1 && l.removeResource(
        this.resourceLabel,
        this.strResource,
        0
        /* RemovedResourceReason.ExternalRemoval */
      );
    }
    s !== -1 && (this._past = this._past.slice(0, s)), o !== -1 && (this._future = this._future.slice(o + 1)), this.versionId++;
  }
  getElements() {
    const e = [], t = [];
    for (const n of this._past)
      e.push(n.actual);
    for (const n of this._future)
      t.push(n.actual);
    return { past: e, future: t };
  }
  getClosestPastElement() {
    return this._past.length === 0 ? null : this._past[this._past.length - 1];
  }
  getSecondClosestPastElement() {
    return this._past.length < 2 ? null : this._past[this._past.length - 2];
  }
  getClosestFutureElement() {
    return this._future.length === 0 ? null : this._future[this._future.length - 1];
  }
  hasPastElements() {
    return this._past.length > 0;
  }
  hasFutureElements() {
    return this._future.length > 0;
  }
  splitPastWorkspaceElement(e, t) {
    for (let n = this._past.length - 1; n >= 0; n--)
      if (this._past[n] === e) {
        t.has(this.strResource) ? this._past[n] = t.get(this.strResource) : this._past.splice(n, 1);
        break;
      }
    this.versionId++;
  }
  splitFutureWorkspaceElement(e, t) {
    for (let n = this._future.length - 1; n >= 0; n--)
      if (this._future[n] === e) {
        t.has(this.strResource) ? this._future[n] = t.get(this.strResource) : this._future.splice(n, 1);
        break;
      }
    this.versionId++;
  }
  moveBackward(e) {
    this._past.pop(), this._future.push(e), this.versionId++;
  }
  moveForward(e) {
    this._future.pop(), this._past.push(e), this.versionId++;
  }
}
class X6 {
  constructor(e) {
    this.editStacks = e, this._versionIds = [];
    for (let t = 0, n = this.editStacks.length; t < n; t++)
      this._versionIds[t] = this.editStacks[t].versionId;
  }
  isValid() {
    for (let e = 0, t = this.editStacks.length; e < t; e++)
      if (this._versionIds[e] !== this.editStacks[e].versionId)
        return !1;
    return !0;
  }
}
const Wge = new Hge("", "");
Wge.locked = !0;
let tB = class {
  constructor(e, t) {
    this._dialogService = e, this._notificationService = t, this._editStacks = /* @__PURE__ */ new Map(), this._uriComparisonKeyComputers = [];
  }
  getUriComparisonKey(e) {
    for (const t of this._uriComparisonKeyComputers)
      if (t[0] === e.scheme)
        return t[1].getComparisonKey(e);
    return e.toString();
  }
  _print(e) {
    console.log("------------------------------------"), console.log(`AFTER ${e}: `);
    const t = [];
    for (const n of this._editStacks)
      t.push(n[1].toString());
    console.log(t.join(`
`));
  }
  pushElement(e, t = E_.None, n = Ud.None) {
    if (e.type === 0) {
      const r = lD(e.resource), s = this.getUriComparisonKey(e.resource);
      this._pushElement(new cD(e, r, s, t.id, t.nextOrder(), n.id, n.nextOrder()));
    } else {
      const r = /* @__PURE__ */ new Set(), s = [], o = [];
      for (const a of e.resources) {
        const l = lD(a), c = this.getUriComparisonKey(a);
        r.has(c) || (r.add(c), s.push(l), o.push(c));
      }
      s.length === 1 ? this._pushElement(new cD(e, s[0], o[0], t.id, t.nextOrder(), n.id, n.nextOrder())) : this._pushElement(new lWe(e, s, o, t.id, t.nextOrder(), n.id, n.nextOrder()));
    }
  }
  _pushElement(e) {
    for (let t = 0, n = e.strResources.length; t < n; t++) {
      const r = e.resourceLabels[t], s = e.strResources[t];
      let o;
      this._editStacks.has(s) ? o = this._editStacks.get(s) : (o = new Hge(r, s), this._editStacks.set(s, o)), o.pushElement(e);
    }
  }
  getLastElement(e) {
    const t = this.getUriComparisonKey(e);
    if (this._editStacks.has(t)) {
      const n = this._editStacks.get(t);
      if (n.hasFutureElements())
        return null;
      const r = n.getClosestPastElement();
      return r ? r.actual : null;
    }
    return null;
  }
  _splitPastWorkspaceElement(e, t) {
    const n = e.actual.split(), r = /* @__PURE__ */ new Map();
    for (const s of n) {
      const o = lD(s.resource), a = this.getUriComparisonKey(s.resource), l = new cD(s, o, a, 0, 0, 0, 0);
      r.set(l.strResource, l);
    }
    for (const s of e.strResources) {
      if (t && t.has(s))
        continue;
      this._editStacks.get(s).splitPastWorkspaceElement(e, r);
    }
  }
  _splitFutureWorkspaceElement(e, t) {
    const n = e.actual.split(), r = /* @__PURE__ */ new Map();
    for (const s of n) {
      const o = lD(s.resource), a = this.getUriComparisonKey(s.resource), l = new cD(s, o, a, 0, 0, 0, 0);
      r.set(l.strResource, l);
    }
    for (const s of e.strResources) {
      if (t && t.has(s))
        continue;
      this._editStacks.get(s).splitFutureWorkspaceElement(e, r);
    }
  }
  removeElements(e) {
    const t = typeof e == "string" ? e : this.getUriComparisonKey(e);
    this._editStacks.has(t) && (this._editStacks.get(t).dispose(), this._editStacks.delete(t));
  }
  setElementsValidFlag(e, t, n) {
    const r = this.getUriComparisonKey(e);
    this._editStacks.has(r) && this._editStacks.get(r).setElementsValidFlag(t, n);
  }
  createSnapshot(e) {
    const t = this.getUriComparisonKey(e);
    return this._editStacks.has(t) ? this._editStacks.get(t).createSnapshot(e) : new Tge(e, []);
  }
  restoreSnapshot(e) {
    const t = this.getUriComparisonKey(e.resource);
    if (this._editStacks.has(t)) {
      const n = this._editStacks.get(t);
      n.restoreSnapshot(e), !n.hasPastElements() && !n.hasFutureElements() && (n.dispose(), this._editStacks.delete(t));
    }
  }
  getElements(e) {
    const t = this.getUriComparisonKey(e);
    return this._editStacks.has(t) ? this._editStacks.get(t).getElements() : { past: [], future: [] };
  }
  _findClosestUndoElementWithSource(e) {
    if (!e)
      return [null, null];
    let t = null, n = null;
    for (const [r, s] of this._editStacks) {
      const o = s.getClosestPastElement();
      o && o.sourceId === e && (!t || o.sourceOrder > t.sourceOrder) && (t = o, n = r);
    }
    return [t, n];
  }
  canUndo(e) {
    if (e instanceof Ud) {
      const [, n] = this._findClosestUndoElementWithSource(e.id);
      return !!n;
    }
    const t = this.getUriComparisonKey(e);
    return this._editStacks.has(t) ? this._editStacks.get(t).hasPastElements() : !1;
  }
  _onError(e, t) {
    It(e);
    for (const n of t.strResources)
      this.removeElements(n);
    this._notificationService.error(e);
  }
  _acquireLocks(e) {
    for (const t of e.editStacks)
      if (t.locked)
        throw new Error("Cannot acquire edit stack lock");
    for (const t of e.editStacks)
      t.locked = !0;
    return () => {
      for (const t of e.editStacks)
        t.locked = !1;
    };
  }
  _safeInvokeWithLocks(e, t, n, r, s) {
    const o = this._acquireLocks(n);
    let a;
    try {
      a = t();
    } catch (l) {
      return o(), r.dispose(), this._onError(l, e);
    }
    return a ? a.then(() => (o(), r.dispose(), s()), (l) => (o(), r.dispose(), this._onError(l, e))) : (o(), r.dispose(), s());
  }
  _invokeWorkspacePrepare(e) {
    return aD(this, void 0, void 0, function* () {
      if (typeof e.actual.prepareUndoRedo > "u")
        return we.None;
      const t = e.actual.prepareUndoRedo();
      return typeof t > "u" ? we.None : t;
    });
  }
  _invokeResourcePrepare(e, t) {
    if (e.actual.type !== 1 || typeof e.actual.prepareUndoRedo > "u")
      return t(we.None);
    const n = e.actual.prepareUndoRedo();
    return n ? kj(n) ? t(n) : n.then((r) => t(r)) : t(we.None);
  }
  _getAffectedEditStacks(e) {
    const t = [];
    for (const n of e.strResources)
      t.push(this._editStacks.get(n) || Wge);
    return new X6(t);
  }
  _tryToSplitAndUndo(e, t, n, r) {
    if (t.canSplit())
      return this._splitPastWorkspaceElement(t, n), this._notificationService.warn(r), new dD(this._undo(e, 0, !0));
    for (const s of t.strResources)
      this.removeElements(s);
    return this._notificationService.warn(r), new dD();
  }
  _checkWorkspaceUndo(e, t, n, r) {
    if (t.removedResources)
      return this._tryToSplitAndUndo(e, t, t.removedResources, C({ key: "cannotWorkspaceUndo", comment: ["{0} is a label for an operation. {1} is another message."] }, "Could not undo '{0}' across all files. {1}", t.label, t.removedResources.createMessage()));
    if (r && t.invalidatedResources)
      return this._tryToSplitAndUndo(e, t, t.invalidatedResources, C({ key: "cannotWorkspaceUndo", comment: ["{0} is a label for an operation. {1} is another message."] }, "Could not undo '{0}' across all files. {1}", t.label, t.invalidatedResources.createMessage()));
    const s = [];
    for (const a of n.editStacks)
      a.getClosestPastElement() !== t && s.push(a.resourceLabel);
    if (s.length > 0)
      return this._tryToSplitAndUndo(e, t, null, C({ key: "cannotWorkspaceUndoDueToChanges", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not undo '{0}' across all files because changes were made to {1}", t.label, s.join(", ")));
    const o = [];
    for (const a of n.editStacks)
      a.locked && o.push(a.resourceLabel);
    return o.length > 0 ? this._tryToSplitAndUndo(e, t, null, C({ key: "cannotWorkspaceUndoDueToInProgressUndoRedo", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not undo '{0}' across all files because there is already an undo or redo operation running on {1}", t.label, o.join(", "))) : n.isValid() ? null : this._tryToSplitAndUndo(e, t, null, C({ key: "cannotWorkspaceUndoDueToInMeantimeUndoRedo", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not undo '{0}' across all files because an undo or redo operation occurred in the meantime", t.label));
  }
  _workspaceUndo(e, t, n) {
    const r = this._getAffectedEditStacks(t), s = this._checkWorkspaceUndo(
      e,
      t,
      r,
      /*invalidated resources will be checked after the prepare call*/
      !1
    );
    return s ? s.returnValue : this._confirmAndExecuteWorkspaceUndo(e, t, r, n);
  }
  _isPartOfUndoGroup(e) {
    if (!e.groupId)
      return !1;
    for (const [, t] of this._editStacks) {
      const n = t.getClosestPastElement();
      if (n) {
        if (n === e) {
          const r = t.getSecondClosestPastElement();
          if (r && r.groupId === e.groupId)
            return !0;
        }
        if (n.groupId === e.groupId)
          return !0;
      }
    }
    return !1;
  }
  _confirmAndExecuteWorkspaceUndo(e, t, n, r) {
    return aD(this, void 0, void 0, function* () {
      if (t.canSplit() && !this._isPartOfUndoGroup(t)) {
        let a;
        (function(d) {
          d[d.All = 0] = "All", d[d.This = 1] = "This", d[d.Cancel = 2] = "Cancel";
        })(a || (a = {}));
        const { result: l } = yield this._dialogService.prompt({
          type: Yi.Info,
          message: C("confirmWorkspace", "Would you like to undo '{0}' across all files?", t.label),
          buttons: [
            {
              label: C({ key: "ok", comment: ["{0} denotes a number that is > 1, && denotes a mnemonic"] }, "&&Undo in {0} Files", n.editStacks.length),
              run: () => a.All
            },
            {
              label: C({ key: "nok", comment: ["&& denotes a mnemonic"] }, "Undo this &&File"),
              run: () => a.This
            }
          ],
          cancelButton: {
            run: () => a.Cancel
          }
        });
        if (l === a.Cancel)
          return;
        if (l === a.This)
          return this._splitPastWorkspaceElement(t, null), this._undo(e, 0, !0);
        const c = this._checkWorkspaceUndo(
          e,
          t,
          n,
          /*invalidated resources will be checked after the prepare call*/
          !1
        );
        if (c)
          return c.returnValue;
        r = !0;
      }
      let s;
      try {
        s = yield this._invokeWorkspacePrepare(t);
      } catch (a) {
        return this._onError(a, t);
      }
      const o = this._checkWorkspaceUndo(
        e,
        t,
        n,
        /*now also check that there are no more invalidated resources*/
        !0
      );
      if (o)
        return s.dispose(), o.returnValue;
      for (const a of n.editStacks)
        a.moveBackward(t);
      return this._safeInvokeWithLocks(t, () => t.actual.undo(), n, s, () => this._continueUndoInGroup(t.groupId, r));
    });
  }
  _resourceUndo(e, t, n) {
    if (!t.isValid) {
      e.flushAllElements();
      return;
    }
    if (e.locked) {
      const r = C({ key: "cannotResourceUndoDueToInProgressUndoRedo", comment: ["{0} is a label for an operation."] }, "Could not undo '{0}' because there is already an undo or redo operation running.", t.label);
      this._notificationService.warn(r);
      return;
    }
    return this._invokeResourcePrepare(t, (r) => (e.moveBackward(t), this._safeInvokeWithLocks(t, () => t.actual.undo(), new X6([e]), r, () => this._continueUndoInGroup(t.groupId, n))));
  }
  _findClosestUndoElementInGroup(e) {
    if (!e)
      return [null, null];
    let t = null, n = null;
    for (const [r, s] of this._editStacks) {
      const o = s.getClosestPastElement();
      o && o.groupId === e && (!t || o.groupOrder > t.groupOrder) && (t = o, n = r);
    }
    return [t, n];
  }
  _continueUndoInGroup(e, t) {
    if (!e)
      return;
    const [, n] = this._findClosestUndoElementInGroup(e);
    if (n)
      return this._undo(n, 0, t);
  }
  undo(e) {
    if (e instanceof Ud) {
      const [, t] = this._findClosestUndoElementWithSource(e.id);
      return t ? this._undo(t, e.id, !1) : void 0;
    }
    return typeof e == "string" ? this._undo(e, 0, !1) : this._undo(this.getUriComparisonKey(e), 0, !1);
  }
  _undo(e, t = 0, n) {
    if (!this._editStacks.has(e))
      return;
    const r = this._editStacks.get(e), s = r.getClosestPastElement();
    if (!s)
      return;
    if (s.groupId) {
      const [a, l] = this._findClosestUndoElementInGroup(s.groupId);
      if (s !== a && l)
        return this._undo(l, t, n);
    }
    if ((s.sourceId !== t || s.confirmBeforeUndo) && !n)
      return this._confirmAndContinueUndo(e, t, s);
    try {
      return s.type === 1 ? this._workspaceUndo(e, s, n) : this._resourceUndo(r, s, n);
    } finally {
    }
  }
  _confirmAndContinueUndo(e, t, n) {
    return aD(this, void 0, void 0, function* () {
      if ((yield this._dialogService.confirm({
        message: C("confirmDifferentSource", "Would you like to undo '{0}'?", n.label),
        primaryButton: C({ key: "confirmDifferentSource.yes", comment: ["&& denotes a mnemonic"] }, "&&Yes"),
        cancelButton: C("confirmDifferentSource.no", "No")
      })).confirmed)
        return this._undo(e, t, !0);
    });
  }
  _findClosestRedoElementWithSource(e) {
    if (!e)
      return [null, null];
    let t = null, n = null;
    for (const [r, s] of this._editStacks) {
      const o = s.getClosestFutureElement();
      o && o.sourceId === e && (!t || o.sourceOrder < t.sourceOrder) && (t = o, n = r);
    }
    return [t, n];
  }
  canRedo(e) {
    if (e instanceof Ud) {
      const [, n] = this._findClosestRedoElementWithSource(e.id);
      return !!n;
    }
    const t = this.getUriComparisonKey(e);
    return this._editStacks.has(t) ? this._editStacks.get(t).hasFutureElements() : !1;
  }
  _tryToSplitAndRedo(e, t, n, r) {
    if (t.canSplit())
      return this._splitFutureWorkspaceElement(t, n), this._notificationService.warn(r), new dD(this._redo(e));
    for (const s of t.strResources)
      this.removeElements(s);
    return this._notificationService.warn(r), new dD();
  }
  _checkWorkspaceRedo(e, t, n, r) {
    if (t.removedResources)
      return this._tryToSplitAndRedo(e, t, t.removedResources, C({ key: "cannotWorkspaceRedo", comment: ["{0} is a label for an operation. {1} is another message."] }, "Could not redo '{0}' across all files. {1}", t.label, t.removedResources.createMessage()));
    if (r && t.invalidatedResources)
      return this._tryToSplitAndRedo(e, t, t.invalidatedResources, C({ key: "cannotWorkspaceRedo", comment: ["{0} is a label for an operation. {1} is another message."] }, "Could not redo '{0}' across all files. {1}", t.label, t.invalidatedResources.createMessage()));
    const s = [];
    for (const a of n.editStacks)
      a.getClosestFutureElement() !== t && s.push(a.resourceLabel);
    if (s.length > 0)
      return this._tryToSplitAndRedo(e, t, null, C({ key: "cannotWorkspaceRedoDueToChanges", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not redo '{0}' across all files because changes were made to {1}", t.label, s.join(", ")));
    const o = [];
    for (const a of n.editStacks)
      a.locked && o.push(a.resourceLabel);
    return o.length > 0 ? this._tryToSplitAndRedo(e, t, null, C({ key: "cannotWorkspaceRedoDueToInProgressUndoRedo", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not redo '{0}' across all files because there is already an undo or redo operation running on {1}", t.label, o.join(", "))) : n.isValid() ? null : this._tryToSplitAndRedo(e, t, null, C({ key: "cannotWorkspaceRedoDueToInMeantimeUndoRedo", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not redo '{0}' across all files because an undo or redo operation occurred in the meantime", t.label));
  }
  _workspaceRedo(e, t) {
    const n = this._getAffectedEditStacks(t), r = this._checkWorkspaceRedo(
      e,
      t,
      n,
      /*invalidated resources will be checked after the prepare call*/
      !1
    );
    return r ? r.returnValue : this._executeWorkspaceRedo(e, t, n);
  }
  _executeWorkspaceRedo(e, t, n) {
    return aD(this, void 0, void 0, function* () {
      let r;
      try {
        r = yield this._invokeWorkspacePrepare(t);
      } catch (o) {
        return this._onError(o, t);
      }
      const s = this._checkWorkspaceRedo(
        e,
        t,
        n,
        /*now also check that there are no more invalidated resources*/
        !0
      );
      if (s)
        return r.dispose(), s.returnValue;
      for (const o of n.editStacks)
        o.moveForward(t);
      return this._safeInvokeWithLocks(t, () => t.actual.redo(), n, r, () => this._continueRedoInGroup(t.groupId));
    });
  }
  _resourceRedo(e, t) {
    if (!t.isValid) {
      e.flushAllElements();
      return;
    }
    if (e.locked) {
      const n = C({ key: "cannotResourceRedoDueToInProgressUndoRedo", comment: ["{0} is a label for an operation."] }, "Could not redo '{0}' because there is already an undo or redo operation running.", t.label);
      this._notificationService.warn(n);
      return;
    }
    return this._invokeResourcePrepare(t, (n) => (e.moveForward(t), this._safeInvokeWithLocks(t, () => t.actual.redo(), new X6([e]), n, () => this._continueRedoInGroup(t.groupId))));
  }
  _findClosestRedoElementInGroup(e) {
    if (!e)
      return [null, null];
    let t = null, n = null;
    for (const [r, s] of this._editStacks) {
      const o = s.getClosestFutureElement();
      o && o.groupId === e && (!t || o.groupOrder < t.groupOrder) && (t = o, n = r);
    }
    return [t, n];
  }
  _continueRedoInGroup(e) {
    if (!e)
      return;
    const [, t] = this._findClosestRedoElementInGroup(e);
    if (t)
      return this._redo(t);
  }
  redo(e) {
    if (e instanceof Ud) {
      const [, t] = this._findClosestRedoElementWithSource(e.id);
      return t ? this._redo(t) : void 0;
    }
    return typeof e == "string" ? this._redo(e) : this._redo(this.getUriComparisonKey(e));
  }
  _redo(e) {
    if (!this._editStacks.has(e))
      return;
    const t = this._editStacks.get(e), n = t.getClosestFutureElement();
    if (n) {
      if (n.groupId) {
        const [r, s] = this._findClosestRedoElementInGroup(n.groupId);
        if (n !== r && s)
          return this._redo(s);
      }
      try {
        return n.type === 1 ? this._workspaceRedo(e, n) : this._resourceRedo(t, n);
      } finally {
      }
    }
  }
};
tB = aWe([
  xQ(0, RS),
  xQ(1, dr)
], tB);
class dD {
  constructor(e) {
    this.returnValue = e;
  }
}
an(
  E4,
  tB,
  1
  /* InstantiationType.Delayed */
);
function qo(i, e, t) {
  return Math.min(Math.max(i, e), t);
}
class jge {
  constructor() {
    this._n = 1, this._val = 0;
  }
  update(e) {
    return this._val = this._val + (e - this._val) / this._n, this._n += 1, this._val;
  }
  get value() {
    return this._val;
  }
}
class cWe {
  constructor(e) {
    this._n = 0, this._val = 0, this._values = [], this._index = 0, this._sum = 0, this._values = new Array(e), this._values.fill(0, 0, e);
  }
  update(e) {
    const t = this._values[this._index];
    return this._values[this._index] = e, this._index = (this._index + 1) % this._values.length, this._sum -= t, this._sum += e, this._n < this._values.length && (this._n += 1), this._val = this._sum / this._n, this._val;
  }
  get value() {
    return this._val;
  }
}
const qz = Gt("environmentService"), da = Gt("openerService");
function Kz(i, e) {
  return pt.isUri(i) ? K1(i.scheme, e) : Bj(i, e + ":");
}
function LQ(i, ...e) {
  return e.some((t) => Kz(i, t));
}
function dWe(i) {
  let e;
  const t = /^L?(\d+)(?:,(\d+))?(-L?(\d+)(?:,(\d+))?)?/.exec(i.fragment);
  return t && (e = {
    startLineNumber: parseInt(t[1]),
    startColumn: t[2] ? parseInt(t[2]) : 1,
    endLineNumber: t[4] ? parseInt(t[4]) : void 0,
    endColumn: t[4] ? t[5] ? parseInt(t[5]) : 1 : void 0
  }, i = i.with({ fragment: "" })), { selection: e, uri: i };
}
var uWe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, IQ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const kl = Gt("ILanguageFeatureDebounceService");
var AL;
(function(i) {
  const e = /* @__PURE__ */ new WeakMap();
  let t = 0;
  function n(r) {
    let s = e.get(r);
    return s === void 0 && (s = ++t, e.set(r, s)), s;
  }
  i.of = n;
})(AL || (AL = {}));
class hWe {
  constructor(e) {
    this._default = e;
  }
  get(e) {
    return this._default;
  }
  update(e, t) {
    return this._default;
  }
  default() {
    return this._default;
  }
}
class fWe {
  constructor(e, t, n, r, s, o) {
    this._logService = e, this._name = t, this._registry = n, this._default = r, this._min = s, this._max = o, this._cache = new cp(50, 0.7);
  }
  _key(e) {
    return e.id + this._registry.all(e).reduce((t, n) => u4(AL.of(n), t), 0);
  }
  get(e) {
    const t = this._key(e), n = this._cache.get(t);
    return n ? qo(n.value, this._min, this._max) : this.default();
  }
  update(e, t) {
    const n = this._key(e);
    let r = this._cache.get(n);
    r || (r = new cWe(6), this._cache.set(n, r));
    const s = qo(r.update(t), this._min, this._max);
    return Kz(e.uri, "output") || this._logService.trace(`[DEBOUNCE: ${this._name}] for ${e.uri.toString()} is ${s}ms`), s;
  }
  _overall() {
    const e = new jge();
    for (const [, t] of this._cache)
      e.update(t.value);
    return e.value;
  }
  default() {
    const e = this._overall() | 0 || this._default;
    return qo(e, this._min, this._max);
  }
}
let nB = class {
  constructor(e, t) {
    this._logService = e, this._data = /* @__PURE__ */ new Map(), this._isDev = t.isExtensionDevelopment || !t.isBuilt;
  }
  for(e, t, n) {
    var r, s, o;
    const a = (r = n?.min) !== null && r !== void 0 ? r : 50, l = (s = n?.max) !== null && s !== void 0 ? s : Math.pow(a, 2), c = (o = n?.key) !== null && o !== void 0 ? o : void 0, d = `${AL.of(e)},${a}${c ? "," + c : ""}`;
    let u = this._data.get(d);
    return u || (this._isDev ? u = new fWe(
      this._logService,
      t,
      e,
      this._overallAverage() | 0 || a * 1.5,
      // default is overall default or derived from min-value
      a,
      l
    ) : (this._logService.debug(`[DEBOUNCE: ${t}] is disabled in developed mode`), u = new hWe(a * 1.5)), this._data.set(d, u)), u;
  }
  _overallAverage() {
    const e = new jge();
    for (const t of this._data.values())
      e.update(t.default());
    return e.value;
  }
};
nB = uWe([
  IQ(0, Ka),
  IQ(1, qz)
], nB);
an(
  kl,
  nB,
  1
  /* InstantiationType.Delayed */
);
class BC {
  static create(e, t) {
    return new BC(e, new kL(t));
  }
  /**
   * (Inclusive) start line number for these tokens.
   */
  get startLineNumber() {
    return this._startLineNumber;
  }
  /**
   * (Inclusive) end line number for these tokens.
   */
  get endLineNumber() {
    return this._endLineNumber;
  }
  constructor(e, t) {
    this._startLineNumber = e, this._tokens = t, this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
  }
  toString() {
    return this._tokens.toString(this._startLineNumber);
  }
  _updateEndLineNumber() {
    this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
  }
  isEmpty() {
    return this._tokens.isEmpty();
  }
  getLineTokens(e) {
    return this._startLineNumber <= e && e <= this._endLineNumber ? this._tokens.getLineTokens(e - this._startLineNumber) : null;
  }
  getRange() {
    const e = this._tokens.getRange();
    return e && new V(this._startLineNumber + e.startLineNumber, e.startColumn, this._startLineNumber + e.endLineNumber, e.endColumn);
  }
  removeTokens(e) {
    const t = e.startLineNumber - this._startLineNumber, n = e.endLineNumber - this._startLineNumber;
    this._startLineNumber += this._tokens.removeTokens(t, e.startColumn - 1, n, e.endColumn - 1), this._updateEndLineNumber();
  }
  split(e) {
    const t = e.startLineNumber - this._startLineNumber, n = e.endLineNumber - this._startLineNumber, [r, s, o] = this._tokens.split(t, e.startColumn - 1, n, e.endColumn - 1);
    return [new BC(this._startLineNumber, r), new BC(this._startLineNumber + o, s)];
  }
  applyEdit(e, t) {
    const [n, r, s] = Wg(t);
    this.acceptEdit(
      e,
      n,
      r,
      s,
      t.length > 0 ? t.charCodeAt(0) : 0
      /* CharCode.Null */
    );
  }
  acceptEdit(e, t, n, r, s) {
    this._acceptDeleteRange(e), this._acceptInsertText(new ve(e.startLineNumber, e.startColumn), t, n, r, s), this._updateEndLineNumber();
  }
  _acceptDeleteRange(e) {
    if (e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn)
      return;
    const t = e.startLineNumber - this._startLineNumber, n = e.endLineNumber - this._startLineNumber;
    if (n < 0) {
      const s = n - t;
      this._startLineNumber -= s;
      return;
    }
    const r = this._tokens.getMaxDeltaLine();
    if (!(t >= r + 1)) {
      if (t < 0 && n >= r + 1) {
        this._startLineNumber = 0, this._tokens.clear();
        return;
      }
      if (t < 0) {
        const s = -t;
        this._startLineNumber -= s, this._tokens.acceptDeleteRange(e.startColumn - 1, 0, 0, n, e.endColumn - 1);
      } else
        this._tokens.acceptDeleteRange(0, t, e.startColumn - 1, n, e.endColumn - 1);
    }
  }
  _acceptInsertText(e, t, n, r, s) {
    if (t === 0 && n === 0)
      return;
    const o = e.lineNumber - this._startLineNumber;
    if (o < 0) {
      this._startLineNumber += t;
      return;
    }
    const a = this._tokens.getMaxDeltaLine();
    o >= a + 1 || this._tokens.acceptInsertText(o, e.column - 1, t, n, r, s);
  }
}
class kL {
  constructor(e) {
    this._tokens = e, this._tokenCount = e.length / 4;
  }
  toString(e) {
    const t = [];
    for (let n = 0; n < this._tokenCount; n++)
      t.push(`(${this._getDeltaLine(n) + e},${this._getStartCharacter(n)}-${this._getEndCharacter(n)})`);
    return `[${t.join(",")}]`;
  }
  getMaxDeltaLine() {
    const e = this._getTokenCount();
    return e === 0 ? -1 : this._getDeltaLine(e - 1);
  }
  getRange() {
    const e = this._getTokenCount();
    if (e === 0)
      return null;
    const t = this._getStartCharacter(0), n = this._getDeltaLine(e - 1), r = this._getEndCharacter(e - 1);
    return new V(0, t + 1, n, r + 1);
  }
  _getTokenCount() {
    return this._tokenCount;
  }
  _getDeltaLine(e) {
    return this._tokens[4 * e];
  }
  _getStartCharacter(e) {
    return this._tokens[4 * e + 1];
  }
  _getEndCharacter(e) {
    return this._tokens[4 * e + 2];
  }
  isEmpty() {
    return this._getTokenCount() === 0;
  }
  getLineTokens(e) {
    let t = 0, n = this._getTokenCount() - 1;
    for (; t < n; ) {
      const r = t + Math.floor((n - t) / 2), s = this._getDeltaLine(r);
      if (s < e)
        t = r + 1;
      else if (s > e)
        n = r - 1;
      else {
        let o = r;
        for (; o > t && this._getDeltaLine(o - 1) === e; )
          o--;
        let a = r;
        for (; a < n && this._getDeltaLine(a + 1) === e; )
          a++;
        return new AQ(this._tokens.subarray(4 * o, 4 * a + 4));
      }
    }
    return this._getDeltaLine(t) === e ? new AQ(this._tokens.subarray(4 * t, 4 * t + 4)) : null;
  }
  clear() {
    this._tokenCount = 0;
  }
  removeTokens(e, t, n, r) {
    const s = this._tokens, o = this._tokenCount;
    let a = 0, l = !1, c = 0;
    for (let d = 0; d < o; d++) {
      const u = 4 * d, h = s[u], f = s[u + 1], g = s[u + 2], p = s[u + 3];
      if ((h > e || h === e && g >= t) && (h < n || h === n && f <= r))
        l = !0;
      else {
        if (a === 0 && (c = h), l) {
          const m = 4 * a;
          s[m] = h - c, s[m + 1] = f, s[m + 2] = g, s[m + 3] = p;
        }
        a++;
      }
    }
    return this._tokenCount = a, c;
  }
  split(e, t, n, r) {
    const s = this._tokens, o = this._tokenCount, a = [], l = [];
    let c = a, d = 0, u = 0;
    for (let h = 0; h < o; h++) {
      const f = 4 * h, g = s[f], p = s[f + 1], m = s[f + 2], _ = s[f + 3];
      if (g > e || g === e && m >= t) {
        if (g < n || g === n && p <= r)
          continue;
        c !== l && (c = l, d = 0, u = g);
      }
      c[d++] = g - u, c[d++] = p, c[d++] = m, c[d++] = _;
    }
    return [new kL(new Uint32Array(a)), new kL(new Uint32Array(l)), u];
  }
  acceptDeleteRange(e, t, n, r, s) {
    const o = this._tokens, a = this._tokenCount, l = r - t;
    let c = 0, d = !1;
    for (let u = 0; u < a; u++) {
      const h = 4 * u;
      let f = o[h], g = o[h + 1], p = o[h + 2];
      const m = o[h + 3];
      if (f < t || f === t && p <= n) {
        c++;
        continue;
      } else if (f === t && g < n)
        f === r && p > s ? p -= s - n : p = n;
      else if (f === t && g === n)
        if (f === r && p > s)
          p -= s - n;
        else {
          d = !0;
          continue;
        }
      else if (f < r || f === r && g < s)
        if (f === r && p > s)
          f = t, g = n, p = g + (p - s);
        else {
          d = !0;
          continue;
        }
      else if (f > r) {
        if (l === 0 && !d) {
          c = a;
          break;
        }
        f -= l;
      } else if (f === r && g >= s)
        e && f === 0 && (g += e, p += e), f -= l, g -= s - n, p -= s - n;
      else
        throw new Error("Not possible!");
      const _ = 4 * c;
      o[_] = f, o[_ + 1] = g, o[_ + 2] = p, o[_ + 3] = m, c++;
    }
    this._tokenCount = c;
  }
  acceptInsertText(e, t, n, r, s, o) {
    const a = n === 0 && r === 1 && (o >= 48 && o <= 57 || o >= 65 && o <= 90 || o >= 97 && o <= 122), l = this._tokens, c = this._tokenCount;
    for (let d = 0; d < c; d++) {
      const u = 4 * d;
      let h = l[u], f = l[u + 1], g = l[u + 2];
      if (!(h < e || h === e && g < t)) {
        if (h === e && g === t)
          if (a)
            g += 1;
          else
            continue;
        else if (h === e && f < t && t < g)
          n === 0 ? g += r : g = t;
        else {
          if (h === e && f === t && a)
            continue;
          if (h === e)
            if (h += n, n === 0)
              f += r, g += r;
            else {
              const p = g - f;
              f = s + (f - t), g = f + p;
            }
          else
            h += n;
        }
        l[u] = h, l[u + 1] = f, l[u + 2] = g;
      }
    }
  }
}
class AQ {
  constructor(e) {
    this._tokens = e;
  }
  getCount() {
    return this._tokens.length / 4;
  }
  getStartCharacter(e) {
    return this._tokens[4 * e + 1];
  }
  getEndCharacter(e) {
    return this._tokens[4 * e + 2];
  }
  getMetadata(e) {
    return this._tokens[4 * e + 3];
  }
}
var gWe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Z6 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let iB = class {
  constructor(e, t, n, r) {
    this._legend = e, this._themeService = t, this._languageService = n, this._logService = r, this._hasWarnedOverlappingTokens = !1, this._hasWarnedInvalidLengthTokens = !1, this._hasWarnedInvalidEditStart = !1, this._hashTable = new uh();
  }
  getMetadata(e, t, n) {
    const r = this._languageService.languageIdCodec.encodeLanguageId(n), s = this._hashTable.get(e, t, r);
    let o;
    if (s)
      o = s.metadata, this._logService.getLevel() === bs.Trace && this._logService.trace(`SemanticTokensProviderStyling [CACHED] ${e} / ${t}: foreground ${Cs.getForeground(o)}, fontStyle ${Cs.getFontStyle(o).toString(2)}`);
    else {
      let a = this._legend.tokenTypes[e];
      const l = [];
      if (a) {
        let c = t;
        for (let u = 0; c > 0 && u < this._legend.tokenModifiers.length; u++)
          c & 1 && l.push(this._legend.tokenModifiers[u]), c = c >> 1;
        c > 0 && this._logService.getLevel() === bs.Trace && (this._logService.trace(`SemanticTokensProviderStyling: unknown token modifier index: ${t.toString(2)} for legend: ${JSON.stringify(this._legend.tokenModifiers)}`), l.push("not-in-legend"));
        const d = this._themeService.getColorTheme().getTokenStyleMetadata(a, l, n);
        if (typeof d > "u")
          o = 2147483647;
        else {
          if (o = 0, typeof d.italic < "u") {
            const u = (d.italic ? 1 : 0) << 11;
            o |= u | 1;
          }
          if (typeof d.bold < "u") {
            const u = (d.bold ? 2 : 0) << 11;
            o |= u | 2;
          }
          if (typeof d.underline < "u") {
            const u = (d.underline ? 4 : 0) << 11;
            o |= u | 4;
          }
          if (typeof d.strikethrough < "u") {
            const u = (d.strikethrough ? 8 : 0) << 11;
            o |= u | 8;
          }
          if (d.foreground) {
            const u = d.foreground << 15;
            o |= u | 16;
          }
          o === 0 && (o = 2147483647);
        }
      } else
        this._logService.getLevel() === bs.Trace && this._logService.trace(`SemanticTokensProviderStyling: unknown token type index: ${e} for legend: ${JSON.stringify(this._legend.tokenTypes)}`), o = 2147483647, a = "not-in-legend";
      this._hashTable.add(e, t, r, o), this._logService.getLevel() === bs.Trace && this._logService.trace(`SemanticTokensProviderStyling ${e} (${a}) / ${t} (${l.join(" ")}): foreground ${Cs.getForeground(o)}, fontStyle ${Cs.getFontStyle(o).toString(2)}`);
    }
    return o;
  }
  warnOverlappingSemanticTokens(e, t) {
    this._hasWarnedOverlappingTokens || (this._hasWarnedOverlappingTokens = !0, console.warn(`Overlapping semantic tokens detected at lineNumber ${e}, column ${t}`));
  }
  warnInvalidLengthSemanticTokens(e, t) {
    this._hasWarnedInvalidLengthTokens || (this._hasWarnedInvalidLengthTokens = !0, console.warn(`Semantic token with invalid length detected at lineNumber ${e}, column ${t}`));
  }
  warnInvalidEditStart(e, t, n, r, s) {
    this._hasWarnedInvalidEditStart || (this._hasWarnedInvalidEditStart = !0, console.warn(`Invalid semantic tokens edit detected (previousResultId: ${e}, resultId: ${t}) at edit #${n}: The provided start offset ${r} is outside the previous data (length ${s}).`));
  }
};
iB = gWe([
  Z6(1, Pr),
  Z6(2, ci),
  Z6(3, Ka)
], iB);
function zge(i, e, t) {
  const n = i.data, r = i.data.length / 5 | 0, s = Math.max(
    Math.ceil(
      r / 1024
      /* SemanticColoringConstants.DesiredMaxAreas */
    ),
    400
    /* SemanticColoringConstants.DesiredTokensPerArea */
  ), o = [];
  let a = 0, l = 1, c = 0;
  for (; a < r; ) {
    const d = a;
    let u = Math.min(d + s, r);
    if (u < r) {
      let b = u;
      for (; b - 1 > d && n[5 * b] === 0; )
        b--;
      if (b - 1 === d) {
        let w = u;
        for (; w + 1 < r && n[5 * w] === 0; )
          w++;
        u = w;
      } else
        u = b;
    }
    let h = new Uint32Array((u - d) * 4), f = 0, g = 0, p = 0, m = 0;
    for (; a < u; ) {
      const b = 5 * a, w = n[b], y = n[b + 1], S = l + w | 0, x = w === 0 ? c + y | 0 : y, D = n[b + 2], E = x + D | 0, L = n[b + 3], k = n[b + 4];
      if (E <= x)
        e.warnInvalidLengthSemanticTokens(S, x + 1);
      else if (p === S && m > x)
        e.warnOverlappingSemanticTokens(S, x + 1);
      else {
        const N = e.getMetadata(L, k, t);
        N !== 2147483647 && (g === 0 && (g = S), h[f] = S - g, h[f + 1] = x, h[f + 2] = E, h[f + 3] = N, f += 4, p = S, m = E);
      }
      l = S, c = x, a++;
    }
    f !== h.length && (h = h.subarray(0, f));
    const _ = BC.create(g, h);
    o.push(_);
  }
  return o;
}
class pWe {
  constructor(e, t, n, r) {
    this.tokenTypeIndex = e, this.tokenModifierSet = t, this.languageId = n, this.metadata = r, this.next = null;
  }
}
class uh {
  constructor() {
    this._elementsCount = 0, this._currentLengthIndex = 0, this._currentLength = uh._SIZES[this._currentLengthIndex], this._growCount = Math.round(this._currentLengthIndex + 1 < uh._SIZES.length ? 2 / 3 * this._currentLength : 0), this._elements = [], uh._nullOutEntries(this._elements, this._currentLength);
  }
  static _nullOutEntries(e, t) {
    for (let n = 0; n < t; n++)
      e[n] = null;
  }
  _hash2(e, t) {
    return (e << 5) - e + t | 0;
  }
  _hashFunc(e, t, n) {
    return this._hash2(this._hash2(e, t), n) % this._currentLength;
  }
  get(e, t, n) {
    const r = this._hashFunc(e, t, n);
    let s = this._elements[r];
    for (; s; ) {
      if (s.tokenTypeIndex === e && s.tokenModifierSet === t && s.languageId === n)
        return s;
      s = s.next;
    }
    return null;
  }
  add(e, t, n, r) {
    if (this._elementsCount++, this._growCount !== 0 && this._elementsCount >= this._growCount) {
      const s = this._elements;
      this._currentLengthIndex++, this._currentLength = uh._SIZES[this._currentLengthIndex], this._growCount = Math.round(this._currentLengthIndex + 1 < uh._SIZES.length ? 2 / 3 * this._currentLength : 0), this._elements = [], uh._nullOutEntries(this._elements, this._currentLength);
      for (const o of s) {
        let a = o;
        for (; a; ) {
          const l = a.next;
          a.next = null, this._add(a), a = l;
        }
      }
    }
    this._add(new pWe(e, t, n, r));
  }
  _add(e) {
    const t = this._hashFunc(e.tokenTypeIndex, e.tokenModifierSet, e.languageId);
    e.next = this._elements[t], this._elements[t] = e;
  }
}
uh._SIZES = [3, 7, 13, 31, 61, 127, 251, 509, 1021, 2039, 4093, 8191, 16381, 32749, 65521, 131071, 262139, 524287, 1048573, 2097143];
const A4 = Gt("semanticTokensStylingService");
var mWe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Q6 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let rB = class extends we {
  constructor(e, t, n) {
    super(), this._themeService = e, this._logService = t, this._languageService = n, this._caches = /* @__PURE__ */ new WeakMap(), this._register(this._themeService.onDidColorThemeChange(() => {
      this._caches = /* @__PURE__ */ new WeakMap();
    }));
  }
  getStyling(e) {
    return this._caches.has(e) || this._caches.set(e, new iB(e.getLegend(), this._themeService, this._languageService, this._logService)), this._caches.get(e);
  }
};
rB = mWe([
  Q6(0, Pr),
  Q6(1, Ka),
  Q6(2, ci)
], rB);
an(
  A4,
  rB,
  1
  /* InstantiationType.Delayed */
);
var kQ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const uD = "**", TQ = "/", q3 = "[/\\\\]", K3 = "[^/\\\\]", vWe = /\//g;
function NQ(i, e) {
  switch (i) {
    case 0:
      return "";
    case 1:
      return `${K3}*?`;
    default:
      return `(?:${q3}|${K3}+${q3}${e ? `|${q3}${K3}+` : ""})*?`;
  }
}
function PQ(i, e) {
  if (!i)
    return [];
  const t = [];
  let n = !1, r = !1, s = "";
  for (const o of i) {
    switch (o) {
      case e:
        if (!n && !r) {
          t.push(s), s = "";
          continue;
        }
        break;
      case "{":
        n = !0;
        break;
      case "}":
        n = !1;
        break;
      case "[":
        r = !0;
        break;
      case "]":
        r = !1;
        break;
    }
    s += o;
  }
  return s && t.push(s), t;
}
function Uge(i) {
  if (!i)
    return "";
  let e = "";
  const t = PQ(i, TQ);
  if (t.every((n) => n === uD))
    e = ".*";
  else {
    let n = !1;
    t.forEach((r, s) => {
      if (r === uD) {
        if (n)
          return;
        e += NQ(2, s === t.length - 1);
      } else {
        let o = !1, a = "", l = !1, c = "";
        for (const d of r) {
          if (d !== "}" && o) {
            a += d;
            continue;
          }
          if (l && (d !== "]" || !c)) {
            let u;
            d === "-" ? u = d : (d === "^" || d === "!") && !c ? u = "^" : d === TQ ? u = "" : u = Va(d), c += u;
            continue;
          }
          switch (d) {
            case "{":
              o = !0;
              continue;
            case "[":
              l = !0;
              continue;
            case "}": {
              const h = `(?:${PQ(a, ",").map((f) => Uge(f)).join("|")})`;
              e += h, o = !1, a = "";
              break;
            }
            case "]": {
              e += "[" + c + "]", l = !1, c = "";
              break;
            }
            case "?":
              e += K3;
              continue;
            case "*":
              e += NQ(1);
              continue;
            default:
              e += Va(d);
          }
        }
        s < t.length - 1 && // more segments to come after this
        (t[s + 1] !== uD || // next segment is not **, or...
        s + 2 < t.length) && (e += q3);
      }
      n = r === uD;
    });
  }
  return e;
}
const _We = /^\*\*\/\*\.[\w\.-]+$/, bWe = /^\*\*\/([\w\.-]+)\/?$/, CWe = /^{\*\*\/\*?[\w\.-]+\/?(,\*\*\/\*?[\w\.-]+\/?)*}$/, yWe = /^{\*\*\/\*?[\w\.-]+(\/(\*\*)?)?(,\*\*\/\*?[\w\.-]+(\/(\*\*)?)?)*}$/, wWe = /^\*\*((\/[\w\.-]+)+)\/?$/, SWe = /^([\w\.-]+(\/[\w\.-]+)*)\/?$/, OQ = new cp(1e4), MQ = function() {
  return !1;
}, du = function() {
  return null;
};
function Yz(i, e) {
  if (!i)
    return du;
  let t;
  typeof i != "string" ? t = i.pattern : t = i, t = t.trim();
  const n = `${t}_${!!e.trimForExclusions}`;
  let r = OQ.get(n);
  if (r)
    return RQ(r, i);
  let s;
  return _We.test(t) ? r = xWe(t.substr(4), t) : (s = bWe.exec(J6(t, e))) ? r = DWe(s[1], t) : (e.trimForExclusions ? yWe : CWe).test(t) ? r = EWe(t, e) : (s = wWe.exec(J6(t, e))) ? r = FQ(s[1].substr(1), t, !0) : (s = SWe.exec(J6(t, e))) ? r = FQ(s[1], t, !1) : r = LWe(t), OQ.set(n, r), RQ(r, i);
}
function RQ(i, e) {
  if (typeof e == "string")
    return i;
  const t = function(n, r) {
    return WF(n, e.base, !$s) ? i(bS(n.substr(e.base.length), Qc), r) : null;
  };
  return t.allBasenames = i.allBasenames, t.allPaths = i.allPaths, t.basenames = i.basenames, t.patterns = i.patterns, t;
}
function J6(i, e) {
  return e.trimForExclusions && i.endsWith("/**") ? i.substr(0, i.length - 2) : i;
}
function xWe(i, e) {
  return function(t, n) {
    return typeof t == "string" && t.endsWith(i) ? e : null;
  };
}
function DWe(i, e) {
  const t = `/${i}`, n = `\\${i}`, r = function(o, a) {
    return typeof o != "string" ? null : a ? a === i ? e : null : o === i || o.endsWith(t) || o.endsWith(n) ? e : null;
  }, s = [i];
  return r.basenames = s, r.patterns = [e], r.allBasenames = s, r;
}
function EWe(i, e) {
  const t = qge(i.slice(1, -1).split(",").map((a) => Yz(a, e)).filter((a) => a !== du), i), n = t.length;
  if (!n)
    return du;
  if (n === 1)
    return t[0];
  const r = function(a, l) {
    for (let c = 0, d = t.length; c < d; c++)
      if (t[c](a, l))
        return i;
    return null;
  }, s = t.find((a) => !!a.allBasenames);
  s && (r.allBasenames = s.allBasenames);
  const o = t.reduce((a, l) => l.allPaths ? a.concat(l.allPaths) : a, []);
  return o.length && (r.allPaths = o), r;
}
function FQ(i, e, t) {
  const n = Qc === yr.sep, r = n ? i : i.replace(vWe, Qc), s = Qc + r, o = yr.sep + i;
  let a;
  return t ? a = function(l, c) {
    return typeof l == "string" && (l === r || l.endsWith(s) || !n && (l === i || l.endsWith(o))) ? e : null;
  } : a = function(l, c) {
    return typeof l == "string" && (l === r || !n && l === i) ? e : null;
  }, a.allPaths = [(t ? "*/" : "./") + i], a;
}
function LWe(i) {
  try {
    const e = new RegExp(`^${Uge(i)}$`);
    return function(t) {
      return e.lastIndex = 0, typeof t == "string" && e.test(t) ? i : null;
    };
  } catch {
    return du;
  }
}
function IWe(i, e, t) {
  return !i || typeof e != "string" ? !1 : Gge(i)(e, void 0, t);
}
function Gge(i, e = {}) {
  if (!i)
    return MQ;
  if (typeof i == "string" || AWe(i)) {
    const t = Yz(i, e);
    if (t === du)
      return MQ;
    const n = function(r, s) {
      return !!t(r, s);
    };
    return t.allBasenames && (n.allBasenames = t.allBasenames), t.allPaths && (n.allPaths = t.allPaths), n;
  }
  return kWe(i, e);
}
function AWe(i) {
  const e = i;
  return e ? typeof e.base == "string" && typeof e.pattern == "string" : !1;
}
function kWe(i, e) {
  const t = qge(Object.getOwnPropertyNames(i).map((a) => TWe(a, i[a], e)).filter((a) => a !== du)), n = t.length;
  if (!n)
    return du;
  if (!t.some((a) => !!a.requiresSiblings)) {
    if (n === 1)
      return t[0];
    const a = function(d, u) {
      let h;
      for (let f = 0, g = t.length; f < g; f++) {
        const p = t[f](d, u);
        if (typeof p == "string")
          return p;
        dF(p) && (h || (h = []), h.push(p));
      }
      return h ? kQ(this, void 0, void 0, function* () {
        for (const f of h) {
          const g = yield f;
          if (typeof g == "string")
            return g;
        }
        return null;
      }) : null;
    }, l = t.find((d) => !!d.allBasenames);
    l && (a.allBasenames = l.allBasenames);
    const c = t.reduce((d, u) => u.allPaths ? d.concat(u.allPaths) : d, []);
    return c.length && (a.allPaths = c), a;
  }
  const r = function(a, l, c) {
    let d, u;
    for (let h = 0, f = t.length; h < f; h++) {
      const g = t[h];
      g.requiresSiblings && c && (l || (l = fg(a)), d || (d = l.substr(0, l.length - QTe(a).length)));
      const p = g(a, l, d, c);
      if (typeof p == "string")
        return p;
      dF(p) && (u || (u = []), u.push(p));
    }
    return u ? kQ(this, void 0, void 0, function* () {
      for (const h of u) {
        const f = yield h;
        if (typeof f == "string")
          return f;
      }
      return null;
    }) : null;
  }, s = t.find((a) => !!a.allBasenames);
  s && (r.allBasenames = s.allBasenames);
  const o = t.reduce((a, l) => l.allPaths ? a.concat(l.allPaths) : a, []);
  return o.length && (r.allPaths = o), r;
}
function TWe(i, e, t) {
  if (e === !1)
    return du;
  const n = Yz(i, t);
  if (n === du)
    return du;
  if (typeof e == "boolean")
    return n;
  if (e) {
    const r = e.when;
    if (typeof r == "string") {
      const s = (o, a, l, c) => {
        if (!c || !n(o, a))
          return null;
        const d = r.replace("$(basename)", () => l), u = c(d);
        return dF(u) ? u.then((h) => h ? i : null) : u ? i : null;
      };
      return s.requiresSiblings = !0, s;
    }
  }
  return n;
}
function qge(i, e) {
  const t = i.filter((a) => !!a.basenames);
  if (t.length < 2)
    return i;
  const n = t.reduce((a, l) => {
    const c = l.basenames;
    return c ? a.concat(c) : a;
  }, []);
  let r;
  if (e) {
    r = [];
    for (let a = 0, l = n.length; a < l; a++)
      r.push(e);
  } else
    r = t.reduce((a, l) => {
      const c = l.patterns;
      return c ? a.concat(c) : a;
    }, []);
  const s = function(a, l) {
    if (typeof a != "string")
      return null;
    if (!l) {
      let d;
      for (d = a.length; d > 0; d--) {
        const u = a.charCodeAt(d - 1);
        if (u === 47 || u === 92)
          break;
      }
      l = a.substr(d);
    }
    const c = n.indexOf(l);
    return c !== -1 ? r[c] : null;
  };
  s.basenames = n, s.patterns = r, s.allBasenames = n;
  const o = i.filter((a) => !a.basenames);
  return o.push(s), o;
}
function Kge(i, e, t, n, r, s) {
  if (Array.isArray(i)) {
    let o = 0;
    for (const a of i) {
      const l = Kge(a, e, t, n, r, s);
      if (l === 10)
        return l;
      l > o && (o = l);
    }
    return o;
  } else {
    if (typeof i == "string")
      return n ? i === "*" ? 5 : i === t ? 10 : 0 : 0;
    if (i) {
      const { language: o, pattern: a, scheme: l, hasAccessToAllModels: c, notebookType: d } = i;
      if (!n && !c)
        return 0;
      d && r && (e = r);
      let u = 0;
      if (l)
        if (l === e.scheme)
          u = 10;
        else if (l === "*")
          u = 5;
        else
          return 0;
      if (o)
        if (o === t)
          u = 10;
        else if (o === "*")
          u = Math.max(u, 5);
        else
          return 0;
      if (d)
        if (d === s)
          u = 10;
        else if (d === "*" && s !== void 0)
          u = Math.max(u, 5);
        else
          return 0;
      if (a) {
        let h;
        if (typeof a == "string" ? h = a : h = Object.assign(Object.assign({}, a), { base: nhe(a.base) }), h === e.fsPath || IWe(h, e.fsPath))
          u = 10;
        else
          return 0;
      }
      return u;
    } else
      return 0;
  }
}
function Yge(i) {
  return typeof i == "string" ? !1 : Array.isArray(i) ? i.every(Yge) : !!i.exclusive;
}
class BQ {
  constructor(e, t, n, r) {
    this.uri = e, this.languageId = t, this.notebookUri = n, this.notebookType = r;
  }
  equals(e) {
    var t, n;
    return this.notebookType === e.notebookType && this.languageId === e.languageId && this.uri.toString() === e.uri.toString() && ((t = this.notebookUri) === null || t === void 0 ? void 0 : t.toString()) === ((n = e.notebookUri) === null || n === void 0 ? void 0 : n.toString());
  }
}
class Hi {
  constructor(e) {
    this._notebookInfoResolver = e, this._clock = 0, this._entries = [], this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event;
  }
  register(e, t) {
    let n = {
      selector: e,
      provider: t,
      _score: -1,
      _time: this._clock++
    };
    return this._entries.push(n), this._lastCandidate = void 0, this._onDidChange.fire(this._entries.length), Ct(() => {
      if (n) {
        const r = this._entries.indexOf(n);
        r >= 0 && (this._entries.splice(r, 1), this._lastCandidate = void 0, this._onDidChange.fire(this._entries.length), n = void 0);
      }
    });
  }
  has(e) {
    return this.all(e).length > 0;
  }
  all(e) {
    if (!e)
      return [];
    this._updateScores(e);
    const t = [];
    for (const n of this._entries)
      n._score > 0 && t.push(n.provider);
    return t;
  }
  ordered(e) {
    const t = [];
    return this._orderedForEach(e, (n) => t.push(n.provider)), t;
  }
  orderedGroups(e) {
    const t = [];
    let n, r;
    return this._orderedForEach(e, (s) => {
      n && r === s._score ? n.push(s.provider) : (r = s._score, n = [s.provider], t.push(n));
    }), t;
  }
  _orderedForEach(e, t) {
    this._updateScores(e);
    for (const n of this._entries)
      n._score > 0 && t(n);
  }
  _updateScores(e) {
    var t, n;
    const r = (t = this._notebookInfoResolver) === null || t === void 0 ? void 0 : t.call(this, e.uri), s = r ? new BQ(e.uri, e.getLanguageId(), r.uri, r.type) : new BQ(e.uri, e.getLanguageId(), void 0, void 0);
    if (!(!((n = this._lastCandidate) === null || n === void 0) && n.equals(s))) {
      this._lastCandidate = s;
      for (const o of this._entries)
        if (o._score = Kge(o.selector, s.uri, s.languageId, wPe(e), s.notebookUri, s.notebookType), Yge(o.selector) && o._score > 0) {
          for (const a of this._entries)
            a._score = 0;
          o._score = 1e3;
          break;
        }
      this._entries.sort(Hi._compareByScoreAndTime);
    }
  }
  static _compareByScoreAndTime(e, t) {
    return e._score < t._score ? 1 : e._score > t._score ? -1 : eC(e.selector) && !eC(t.selector) ? 1 : !eC(e.selector) && eC(t.selector) ? -1 : e._time < t._time ? 1 : e._time > t._time ? -1 : 0;
  }
}
function eC(i) {
  return typeof i == "string" ? !1 : Array.isArray(i) ? i.some(eC) : !!i.isBuiltin;
}
class NWe {
  constructor() {
    this.referenceProvider = new Hi(this._score.bind(this)), this.renameProvider = new Hi(this._score.bind(this)), this.codeActionProvider = new Hi(this._score.bind(this)), this.definitionProvider = new Hi(this._score.bind(this)), this.typeDefinitionProvider = new Hi(this._score.bind(this)), this.declarationProvider = new Hi(this._score.bind(this)), this.implementationProvider = new Hi(this._score.bind(this)), this.documentSymbolProvider = new Hi(this._score.bind(this)), this.inlayHintsProvider = new Hi(this._score.bind(this)), this.colorProvider = new Hi(this._score.bind(this)), this.codeLensProvider = new Hi(this._score.bind(this)), this.documentFormattingEditProvider = new Hi(this._score.bind(this)), this.documentRangeFormattingEditProvider = new Hi(this._score.bind(this)), this.onTypeFormattingEditProvider = new Hi(this._score.bind(this)), this.signatureHelpProvider = new Hi(this._score.bind(this)), this.hoverProvider = new Hi(this._score.bind(this)), this.documentHighlightProvider = new Hi(this._score.bind(this)), this.selectionRangeProvider = new Hi(this._score.bind(this)), this.foldingRangeProvider = new Hi(this._score.bind(this)), this.linkProvider = new Hi(this._score.bind(this)), this.inlineCompletionsProvider = new Hi(this._score.bind(this)), this.completionProvider = new Hi(this._score.bind(this)), this.linkedEditingRangeProvider = new Hi(this._score.bind(this)), this.documentRangeSemanticTokensProvider = new Hi(this._score.bind(this)), this.documentSemanticTokensProvider = new Hi(this._score.bind(this)), this.documentOnDropEditProvider = new Hi(this._score.bind(this)), this.documentPasteEditProvider = new Hi(this._score.bind(this));
  }
  _score(e) {
    var t;
    return (t = this._notebookTypeResolver) === null || t === void 0 ? void 0 : t.call(this, e);
  }
}
an(
  tt,
  NWe,
  1
  /* InstantiationType.Delayed */
);
const FS = Gt("IWorkspaceEditService");
class Xz {
  constructor(e) {
    this.metadata = e;
  }
  static convert(e) {
    return e.edits.map((t) => {
      if (Vh.is(t))
        return Vh.lift(t);
      if (zv.is(t))
        return zv.lift(t);
      throw new Error("Unsupported edit");
    });
  }
}
class Vh extends Xz {
  static is(e) {
    return e instanceof Vh ? !0 : ho(e) && pt.isUri(e.resource) && ho(e.textEdit);
  }
  static lift(e) {
    return e instanceof Vh ? e : new Vh(e.resource, e.textEdit, e.versionId, e.metadata);
  }
  constructor(e, t, n = void 0, r) {
    super(r), this.resource = e, this.textEdit = t, this.versionId = n;
  }
}
class zv extends Xz {
  static is(e) {
    return e instanceof zv ? !0 : ho(e) && (!!e.newResource || !!e.oldResource);
  }
  static lift(e) {
    return e instanceof zv ? e : new zv(e.oldResource, e.newResource, e.options, e.metadata);
  }
  constructor(e, t, n = {}, r) {
    super(r), this.oldResource = e, this.newResource = t, this.options = n;
  }
}
const Gs = {
  enableSplitViewResizing: !0,
  splitViewDefaultRatio: 0.5,
  renderSideBySide: !0,
  renderMarginRevertIcon: !0,
  maxComputationTime: 5e3,
  maxFileSize: 50,
  ignoreTrimWhitespace: !0,
  renderIndicators: !0,
  originalEditable: !1,
  diffCodeLens: !1,
  renderOverviewRuler: !0,
  diffWordWrap: "inherit",
  diffAlgorithm: "advanced",
  accessibilityVerbose: !1,
  experimental: {
    showMoves: !1,
    showEmptyDecorations: !0
  },
  hideUnchangedRegions: {
    enabled: !1,
    contextLineCount: 3,
    minimumLineCount: 3,
    revealLineCount: 20
  },
  isInEmbeddedEditor: !1,
  onlyShowAccessibleDiffViewer: !1,
  renderSideBySideInlineBreakpoint: 900,
  useInlineViewWhenSpaceIsLimited: !0
}, k4 = Object.freeze({
  id: "editor",
  order: 5,
  type: "object",
  title: C("editorConfigurationTitle", "Editor"),
  scope: 5
}), TL = Object.assign(Object.assign({}, k4), { properties: {
  "editor.tabSize": {
    type: "number",
    default: Os.tabSize,
    minimum: 1,
    markdownDescription: C("tabSize", "The number of spaces a tab is equal to. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`")
  },
  "editor.indentSize": {
    anyOf: [
      {
        type: "string",
        enum: ["tabSize"]
      },
      {
        type: "number",
        minimum: 1
      }
    ],
    default: "tabSize",
    markdownDescription: C("indentSize", 'The number of spaces used for indentation or `"tabSize"` to use the value from `#editor.tabSize#`. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on.')
  },
  "editor.insertSpaces": {
    type: "boolean",
    default: Os.insertSpaces,
    markdownDescription: C("insertSpaces", "Insert spaces when pressing `Tab`. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`")
  },
  "editor.detectIndentation": {
    type: "boolean",
    default: Os.detectIndentation,
    markdownDescription: C("detectIndentation", "Controls whether {0} and {1} will be automatically detected when a file is opened based on the file contents.", "`#editor.tabSize#`", "`#editor.insertSpaces#`")
  },
  "editor.trimAutoWhitespace": {
    type: "boolean",
    default: Os.trimAutoWhitespace,
    description: C("trimAutoWhitespace", "Remove trailing auto inserted whitespace.")
  },
  "editor.largeFileOptimizations": {
    type: "boolean",
    default: Os.largeFileOptimizations,
    description: C("largeFileOptimizations", "Special handling for large files to disable certain memory intensive features.")
  },
  "editor.wordBasedSuggestions": {
    type: "boolean",
    default: !0,
    description: C("wordBasedSuggestions", "Controls whether completions should be computed based on words in the document.")
  },
  "editor.wordBasedSuggestionsMode": {
    enum: ["currentDocument", "matchingDocuments", "allDocuments"],
    default: "matchingDocuments",
    enumDescriptions: [
      C("wordBasedSuggestionsMode.currentDocument", "Only suggest words from the active document."),
      C("wordBasedSuggestionsMode.matchingDocuments", "Suggest words from all open documents of the same language."),
      C("wordBasedSuggestionsMode.allDocuments", "Suggest words from all open documents.")
    ],
    description: C("wordBasedSuggestionsMode", "Controls from which documents word based completions are computed.")
  },
  "editor.semanticHighlighting.enabled": {
    enum: [!0, !1, "configuredByTheme"],
    enumDescriptions: [
      C("semanticHighlighting.true", "Semantic highlighting enabled for all color themes."),
      C("semanticHighlighting.false", "Semantic highlighting disabled for all color themes."),
      C("semanticHighlighting.configuredByTheme", "Semantic highlighting is configured by the current color theme's `semanticHighlighting` setting.")
    ],
    default: "configuredByTheme",
    description: C("semanticHighlighting.enabled", "Controls whether the semanticHighlighting is shown for the languages that support it.")
  },
  "editor.stablePeek": {
    type: "boolean",
    default: !1,
    markdownDescription: C("stablePeek", "Keep peek editors open even when double-clicking their content or when hitting `Escape`.")
  },
  "editor.maxTokenizationLineLength": {
    type: "integer",
    default: 2e4,
    description: C("maxTokenizationLineLength", "Lines above this length will not be tokenized for performance reasons")
  },
  "editor.experimental.asyncTokenization": {
    type: "boolean",
    default: !1,
    description: C("editor.experimental.asyncTokenization", "Controls whether the tokenization should happen asynchronously on a web worker."),
    tags: ["experimental"]
  },
  "editor.experimental.asyncTokenizationLogging": {
    type: "boolean",
    default: !1,
    description: C("editor.experimental.asyncTokenizationLogging", "Controls whether async tokenization should be logged. For debugging only.")
  },
  "editor.experimental.asyncTokenizationVerification": {
    type: "boolean",
    default: !1,
    description: C("editor.experimental.asyncTokenizationVerification", "Controls whether async tokenization should be verified against legacy background tokenization. Might slow down tokenization. For debugging only."),
    tags: ["experimental"]
  },
  "editor.language.brackets": {
    type: ["array", "null"],
    default: null,
    // We want to distinguish the empty array from not configured.
    description: C("schema.brackets", "Defines the bracket symbols that increase or decrease the indentation."),
    items: {
      type: "array",
      items: [
        {
          type: "string",
          description: C("schema.openBracket", "The opening bracket character or string sequence.")
        },
        {
          type: "string",
          description: C("schema.closeBracket", "The closing bracket character or string sequence.")
        }
      ]
    }
  },
  "editor.language.colorizedBracketPairs": {
    type: ["array", "null"],
    default: null,
    // We want to distinguish the empty array from not configured.
    description: C("schema.colorizedBracketPairs", "Defines the bracket pairs that are colorized by their nesting level if bracket pair colorization is enabled."),
    items: {
      type: "array",
      items: [
        {
          type: "string",
          description: C("schema.openBracket", "The opening bracket character or string sequence.")
        },
        {
          type: "string",
          description: C("schema.closeBracket", "The closing bracket character or string sequence.")
        }
      ]
    }
  },
  "diffEditor.maxComputationTime": {
    type: "number",
    default: Gs.maxComputationTime,
    description: C("maxComputationTime", "Timeout in milliseconds after which diff computation is cancelled. Use 0 for no timeout.")
  },
  "diffEditor.maxFileSize": {
    type: "number",
    default: Gs.maxFileSize,
    description: C("maxFileSize", "Maximum file size in MB for which to compute diffs. Use 0 for no limit.")
  },
  "diffEditor.renderSideBySide": {
    type: "boolean",
    default: Gs.renderSideBySide,
    description: C("sideBySide", "Controls whether the diff editor shows the diff side by side or inline.")
  },
  "diffEditor.renderSideBySideInlineBreakpoint": {
    type: "number",
    default: Gs.renderSideBySideInlineBreakpoint,
    description: C("renderSideBySideInlineBreakpoint", "If the diff editor width is smaller than this value, the inline view is used.")
  },
  "diffEditor.useInlineViewWhenSpaceIsLimited": {
    type: "boolean",
    default: Gs.useInlineViewWhenSpaceIsLimited,
    description: C("useInlineViewWhenSpaceIsLimited", "If enabled and the editor width is too small, the inline view is used.")
  },
  "diffEditor.renderMarginRevertIcon": {
    type: "boolean",
    default: Gs.renderMarginRevertIcon,
    description: C("renderMarginRevertIcon", "When enabled, the diff editor shows arrows in its glyph margin to revert changes.")
  },
  "diffEditor.ignoreTrimWhitespace": {
    type: "boolean",
    default: Gs.ignoreTrimWhitespace,
    description: C("ignoreTrimWhitespace", "When enabled, the diff editor ignores changes in leading or trailing whitespace.")
  },
  "diffEditor.renderIndicators": {
    type: "boolean",
    default: Gs.renderIndicators,
    description: C("renderIndicators", "Controls whether the diff editor shows +/- indicators for added/removed changes.")
  },
  "diffEditor.codeLens": {
    type: "boolean",
    default: Gs.diffCodeLens,
    description: C("codeLens", "Controls whether the editor shows CodeLens.")
  },
  "diffEditor.wordWrap": {
    type: "string",
    enum: ["off", "on", "inherit"],
    default: Gs.diffWordWrap,
    markdownEnumDescriptions: [
      C("wordWrap.off", "Lines will never wrap."),
      C("wordWrap.on", "Lines will wrap at the viewport width."),
      C("wordWrap.inherit", "Lines will wrap according to the {0} setting.", "`#editor.wordWrap#`")
    ]
  },
  "diffEditor.diffAlgorithm": {
    type: "string",
    enum: ["legacy", "advanced"],
    default: Gs.diffAlgorithm,
    markdownEnumDescriptions: [
      C("diffAlgorithm.legacy", "Uses the legacy diffing algorithm."),
      C("diffAlgorithm.advanced", "Uses the advanced diffing algorithm.")
    ],
    tags: ["experimental"]
  },
  "diffEditor.hideUnchangedRegions.enabled": {
    type: "boolean",
    default: Gs.hideUnchangedRegions.enabled,
    markdownDescription: C("hideUnchangedRegions.enabled", "Controls whether the diff editor shows unchanged regions.")
  },
  "diffEditor.hideUnchangedRegions.revealLineCount": {
    type: "integer",
    default: Gs.hideUnchangedRegions.revealLineCount,
    markdownDescription: C("hideUnchangedRegions.revealLineCount", "Controls how many lines are used for unchanged regions."),
    minimum: 1
  },
  "diffEditor.hideUnchangedRegions.minimumLineCount": {
    type: "integer",
    default: Gs.hideUnchangedRegions.minimumLineCount,
    markdownDescription: C("hideUnchangedRegions.minimumLineCount", "Controls how many lines are used as a minimum for unchanged regions."),
    minimum: 1
  },
  "diffEditor.hideUnchangedRegions.contextLineCount": {
    type: "integer",
    default: Gs.hideUnchangedRegions.contextLineCount,
    markdownDescription: C("hideUnchangedRegions.contextLineCount", "Controls how many lines are used as context when comparing unchanged regions."),
    minimum: 1
  },
  "diffEditor.experimental.showMoves": {
    type: "boolean",
    default: Gs.experimental.showMoves,
    markdownDescription: C("showMoves", "Controls whether the diff editor should show detected code moves.")
  },
  "diffEditor.experimental.showEmptyDecorations": {
    type: "boolean",
    default: Gs.experimental.showEmptyDecorations,
    description: C("showEmptyDecorations", "Controls whether the diff editor shows empty decorations to see where characters got inserted or deleted.")
  }
} });
function PWe(i) {
  return typeof i.type < "u" || typeof i.anyOf < "u";
}
for (const i of q1) {
  const e = i.schema;
  if (typeof e < "u")
    if (PWe(e))
      TL.properties[`editor.${i.name}`] = e;
    else
      for (const t in e)
        Object.hasOwnProperty.call(e, t) && (TL.properties[t] = e[t]);
}
let hD = null;
function Xge() {
  return hD === null && (hD = /* @__PURE__ */ Object.create(null), Object.keys(TL.properties).forEach((i) => {
    hD[i] = !0;
  })), hD;
}
function OWe(i) {
  return Xge()[`editor.${i}`] || !1;
}
function MWe(i) {
  return Xge()[`diffEditor.${i}`] || !1;
}
const RWe = Di.as(_d.Configuration);
RWe.registerConfiguration(TL);
class Si {
  static insert(e, t) {
    return {
      range: new V(e.lineNumber, e.column, e.lineNumber, e.column),
      text: t,
      forceMoveMarkers: !0
    };
  }
  static delete(e) {
    return {
      range: e,
      text: null
    };
  }
  static replace(e, t) {
    return {
      range: e,
      text: t
    };
  }
  static replaceMove(e, t) {
    return {
      range: e,
      text: t,
      forceMoveMarkers: !0
    };
  }
}
function $6(i) {
  return Object.isFrozen(i) ? i : w6e(i);
}
class Ns {
  constructor(e = {}, t = [], n = [], r) {
    this._contents = e, this._keys = t, this._overrides = n, this.raw = r, this.overrideConfigurations = /* @__PURE__ */ new Map();
  }
  get rawConfiguration() {
    var e;
    if (!this._rawConfiguration)
      if (!((e = this.raw) === null || e === void 0) && e.length) {
        const t = this.raw.map((n) => {
          if (n instanceof Ns)
            return n;
          const r = new FWe("");
          return r.parseRaw(n), r.configurationModel;
        });
        this._rawConfiguration = t.reduce((n, r) => r === n ? r : n.merge(r), t[0]);
      } else
        this._rawConfiguration = this;
    return this._rawConfiguration;
  }
  get contents() {
    return this._contents;
  }
  get overrides() {
    return this._overrides;
  }
  get keys() {
    return this._keys;
  }
  isEmpty() {
    return this._keys.length === 0 && Object.keys(this._contents).length === 0 && this._overrides.length === 0;
  }
  getValue(e) {
    return e ? EX(this.contents, e) : this.contents;
  }
  inspect(e, t) {
    const n = this.rawConfiguration.getValue(e), r = t ? this.rawConfiguration.getOverrideValue(e, t) : void 0, s = t ? this.rawConfiguration.override(t).getValue(e) : n;
    return { value: n, override: r, merged: s };
  }
  getOverrideValue(e, t) {
    const n = this.getContentsForOverrideIdentifer(t);
    return n ? e ? EX(n, e) : n : void 0;
  }
  override(e) {
    let t = this.overrideConfigurations.get(e);
    return t || (t = this.createOverrideConfigurationModel(e), this.overrideConfigurations.set(e, t)), t;
  }
  merge(...e) {
    var t, n;
    const r = lh(this.contents), s = lh(this.overrides), o = [...this.keys], a = !((t = this.raw) === null || t === void 0) && t.length ? [...this.raw] : [this];
    for (const l of e)
      if (a.push(...!((n = l.raw) === null || n === void 0) && n.length ? l.raw : [l]), !l.isEmpty()) {
        this.mergeContents(r, l.contents);
        for (const c of l.overrides) {
          const [d] = s.filter((u) => Qi(u.identifiers, c.identifiers));
          d ? (this.mergeContents(d.contents, c.contents), d.keys.push(...c.keys), d.keys = kg(d.keys)) : s.push(lh(c));
        }
        for (const c of l.keys)
          o.indexOf(c) === -1 && o.push(c);
      }
    return new Ns(r, o, s, a.every((l) => l instanceof Ns) ? void 0 : a);
  }
  createOverrideConfigurationModel(e) {
    const t = this.getContentsForOverrideIdentifer(e);
    if (!t || typeof t != "object" || !Object.keys(t).length)
      return this;
    const n = {};
    for (const r of kg([...Object.keys(this.contents), ...Object.keys(t)])) {
      let s = this.contents[r];
      const o = t[r];
      o && (typeof s == "object" && typeof o == "object" ? (s = lh(s), this.mergeContents(s, o)) : s = o), n[r] = s;
    }
    return new Ns(n, this.keys, this.overrides);
  }
  mergeContents(e, t) {
    for (const n of Object.keys(t)) {
      if (n in e && ho(e[n]) && ho(t[n])) {
        this.mergeContents(e[n], t[n]);
        continue;
      }
      e[n] = lh(t[n]);
    }
  }
  getContentsForOverrideIdentifer(e) {
    let t = null, n = null;
    const r = (s) => {
      s && (n ? this.mergeContents(n, s) : n = lh(s));
    };
    for (const s of this.overrides)
      s.identifiers.length === 1 && s.identifiers[0] === e ? t = s.contents : s.identifiers.includes(e) && r(s.contents);
    return r(t), n;
  }
  toJSON() {
    return {
      contents: this.contents,
      overrides: this.overrides,
      keys: this.keys
    };
  }
  // Update methods
  addValue(e, t) {
    this.updateValue(e, t, !0);
  }
  setValue(e, t) {
    this.updateValue(e, t, !1);
  }
  removeValue(e) {
    const t = this.keys.indexOf(e);
    t !== -1 && (this.keys.splice(t, 1), B7e(this.contents, e), Fg.test(e) && this.overrides.splice(this.overrides.findIndex((n) => Qi(n.identifiers, tL(e))), 1));
  }
  updateValue(e, t, n) {
    ife(this.contents, e, t, (r) => console.error(r)), n = n || this.keys.indexOf(e) === -1, n && this.keys.push(e), Fg.test(e) && this.overrides.push({
      identifiers: tL(e),
      keys: Object.keys(this.contents[e]),
      contents: fF(this.contents[e], (r) => console.error(r))
    });
  }
}
class FWe {
  constructor(e) {
    this._name = e, this._raw = null, this._configurationModel = null, this._restrictedConfigurations = [];
  }
  get configurationModel() {
    return this._configurationModel || new Ns();
  }
  parseRaw(e, t) {
    this._raw = e;
    const { contents: n, keys: r, overrides: s, restricted: o, hasExcludedProperties: a } = this.doParseRaw(e, t);
    this._configurationModel = new Ns(
      n,
      r,
      s,
      a ? [e] : void 0
      /* raw has not changed */
    ), this._restrictedConfigurations = o || [];
  }
  doParseRaw(e, t) {
    const n = Di.as(_d.Configuration).getConfigurationProperties(), r = this.filter(e, n, !0, t);
    e = r.raw;
    const s = fF(e, (l) => console.error(`Conflict in settings file ${this._name}: ${l}`)), o = Object.keys(e), a = this.toOverrides(e, (l) => console.error(`Conflict in settings file ${this._name}: ${l}`));
    return { contents: s, keys: o, overrides: a, restricted: r.restricted, hasExcludedProperties: r.hasExcludedProperties };
  }
  filter(e, t, n, r) {
    var s, o, a;
    let l = !1;
    if (!r?.scopes && !r?.skipRestricted && !(!((s = r?.exclude) === null || s === void 0) && s.length))
      return { raw: e, restricted: [], hasExcludedProperties: l };
    const c = {}, d = [];
    for (const u in e)
      if (Fg.test(u) && n) {
        const h = this.filter(e[u], t, !1, r);
        c[u] = h.raw, l = l || h.hasExcludedProperties, d.push(...h.restricted);
      } else {
        const h = t[u], f = h ? typeof h.scope < "u" ? h.scope : 3 : void 0;
        h?.restricted && d.push(u), !(!((o = r.exclude) === null || o === void 0) && o.includes(u)) && (!((a = r.include) === null || a === void 0) && a.includes(u) || (f === void 0 || r.scopes === void 0 || r.scopes.includes(f)) && !(r.skipRestricted && h?.restricted)) ? c[u] = e[u] : l = !0;
      }
    return { raw: c, restricted: d, hasExcludedProperties: l };
  }
  toOverrides(e, t) {
    const n = [];
    for (const r of Object.keys(e))
      if (Fg.test(r)) {
        const s = {};
        for (const o in e[r])
          s[o] = e[r][o];
        n.push({
          identifiers: tL(r),
          keys: Object.keys(s),
          contents: fF(s, t)
        });
      }
    return n;
  }
}
class BWe {
  constructor(e, t, n, r, s, o, a, l, c, d, u, h, f) {
    this.key = e, this.overrides = t, this._value = n, this.overrideIdentifiers = r, this.defaultConfiguration = s, this.policyConfiguration = o, this.applicationConfiguration = a, this.userConfiguration = l, this.localUserConfiguration = c, this.remoteUserConfiguration = d, this.workspaceConfiguration = u, this.folderConfigurationModel = h, this.memoryConfigurationModel = f;
  }
  inspect(e, t, n) {
    const r = e.inspect(t, n);
    return {
      get value() {
        return $6(r.value);
      },
      get override() {
        return $6(r.override);
      },
      get merged() {
        return $6(r.merged);
      }
    };
  }
  get userInspectValue() {
    return this._userInspectValue || (this._userInspectValue = this.inspect(this.userConfiguration, this.key, this.overrides.overrideIdentifier)), this._userInspectValue;
  }
  get user() {
    return this.userInspectValue.value !== void 0 || this.userInspectValue.override !== void 0 ? { value: this.userInspectValue.value, override: this.userInspectValue.override } : void 0;
  }
}
class T4 {
  constructor(e, t, n, r, s = new Ns(), o = new Ns(), a = new Ms(), l = new Ns(), c = new Ms()) {
    this._defaultConfiguration = e, this._policyConfiguration = t, this._applicationConfiguration = n, this._localUserConfiguration = r, this._remoteUserConfiguration = s, this._workspaceConfiguration = o, this._folderConfigurations = a, this._memoryConfiguration = l, this._memoryConfigurationByResource = c, this._workspaceConsolidatedConfiguration = null, this._foldersConsolidatedConfigurations = new Ms(), this._userConfiguration = null;
  }
  getValue(e, t, n) {
    return this.getConsolidatedConfigurationModel(e, t, n).getValue(e);
  }
  updateValue(e, t, n = {}) {
    let r;
    n.resource ? (r = this._memoryConfigurationByResource.get(n.resource), r || (r = new Ns(), this._memoryConfigurationByResource.set(n.resource, r))) : r = this._memoryConfiguration, t === void 0 ? r.removeValue(e) : r.setValue(e, t), n.resource || (this._workspaceConsolidatedConfiguration = null);
  }
  inspect(e, t, n) {
    const r = this.getConsolidatedConfigurationModel(e, t, n), s = this.getFolderConfigurationModelForResource(t.resource, n), o = t.resource ? this._memoryConfigurationByResource.get(t.resource) || this._memoryConfiguration : this._memoryConfiguration, a = /* @__PURE__ */ new Set();
    for (const l of r.overrides)
      for (const c of l.identifiers)
        r.getOverrideValue(e, c) !== void 0 && a.add(c);
    return new BWe(e, t, r.getValue(e), a.size ? [...a] : void 0, this._defaultConfiguration, this._policyConfiguration.isEmpty() ? void 0 : this._policyConfiguration, this.applicationConfiguration.isEmpty() ? void 0 : this.applicationConfiguration, this.userConfiguration, this.localUserConfiguration, this.remoteUserConfiguration, n ? this._workspaceConfiguration : void 0, s || void 0, o);
  }
  get applicationConfiguration() {
    return this._applicationConfiguration;
  }
  get userConfiguration() {
    return this._userConfiguration || (this._userConfiguration = this._remoteUserConfiguration.isEmpty() ? this._localUserConfiguration : this._localUserConfiguration.merge(this._remoteUserConfiguration)), this._userConfiguration;
  }
  get localUserConfiguration() {
    return this._localUserConfiguration;
  }
  get remoteUserConfiguration() {
    return this._remoteUserConfiguration;
  }
  getConsolidatedConfigurationModel(e, t, n) {
    let r = this.getConsolidatedConfigurationModelForResource(t, n);
    return t.overrideIdentifier && (r = r.override(t.overrideIdentifier)), !this._policyConfiguration.isEmpty() && this._policyConfiguration.getValue(e) !== void 0 && (r = r.merge(this._policyConfiguration)), r;
  }
  getConsolidatedConfigurationModelForResource({ resource: e }, t) {
    let n = this.getWorkspaceConsolidatedConfiguration();
    if (t && e) {
      const r = t.getFolder(e);
      r && (n = this.getFolderConsolidatedConfiguration(r.uri) || n);
      const s = this._memoryConfigurationByResource.get(e);
      s && (n = n.merge(s));
    }
    return n;
  }
  getWorkspaceConsolidatedConfiguration() {
    return this._workspaceConsolidatedConfiguration || (this._workspaceConsolidatedConfiguration = this._defaultConfiguration.merge(this.applicationConfiguration, this.userConfiguration, this._workspaceConfiguration, this._memoryConfiguration)), this._workspaceConsolidatedConfiguration;
  }
  getFolderConsolidatedConfiguration(e) {
    let t = this._foldersConsolidatedConfigurations.get(e);
    if (!t) {
      const n = this.getWorkspaceConsolidatedConfiguration(), r = this._folderConfigurations.get(e);
      r ? (t = n.merge(r), this._foldersConsolidatedConfigurations.set(e, t)) : t = n;
    }
    return t;
  }
  getFolderConfigurationModelForResource(e, t) {
    if (t && e) {
      const n = t.getFolder(e);
      if (n)
        return this._folderConfigurations.get(n.uri);
    }
  }
  toData() {
    return {
      defaults: {
        contents: this._defaultConfiguration.contents,
        overrides: this._defaultConfiguration.overrides,
        keys: this._defaultConfiguration.keys
      },
      policy: {
        contents: this._policyConfiguration.contents,
        overrides: this._policyConfiguration.overrides,
        keys: this._policyConfiguration.keys
      },
      application: {
        contents: this.applicationConfiguration.contents,
        overrides: this.applicationConfiguration.overrides,
        keys: this.applicationConfiguration.keys
      },
      user: {
        contents: this.userConfiguration.contents,
        overrides: this.userConfiguration.overrides,
        keys: this.userConfiguration.keys
      },
      workspace: {
        contents: this._workspaceConfiguration.contents,
        overrides: this._workspaceConfiguration.overrides,
        keys: this._workspaceConfiguration.keys
      },
      folders: [...this._folderConfigurations.keys()].reduce((e, t) => {
        const { contents: n, overrides: r, keys: s } = this._folderConfigurations.get(t);
        return e.push([t, { contents: n, overrides: r, keys: s }]), e;
      }, [])
    };
  }
  static parse(e) {
    const t = this.parseConfigurationModel(e.defaults), n = this.parseConfigurationModel(e.policy), r = this.parseConfigurationModel(e.application), s = this.parseConfigurationModel(e.user), o = this.parseConfigurationModel(e.workspace), a = e.folders.reduce((l, c) => (l.set(pt.revive(c[0]), this.parseConfigurationModel(c[1])), l), new Ms());
    return new T4(t, n, r, s, new Ns(), o, a, new Ns(), new Ms());
  }
  static parseConfigurationModel(e) {
    return new Ns(e.contents, e.keys, e.overrides);
  }
}
class VWe {
  constructor(e, t, n, r) {
    this.change = e, this.previous = t, this.currentConfiguraiton = n, this.currentWorkspace = r, this._marker = `
`, this._markerCode1 = this._marker.charCodeAt(0), this._markerCode2 = 46, this.affectedKeys = /* @__PURE__ */ new Set(), this._previousConfiguration = void 0;
    for (const s of e.keys)
      this.affectedKeys.add(s);
    for (const [, s] of e.overrides)
      for (const o of s)
        this.affectedKeys.add(o);
    this._affectsConfigStr = this._marker;
    for (const s of this.affectedKeys)
      this._affectsConfigStr += s + this._marker;
  }
  get previousConfiguration() {
    return !this._previousConfiguration && this.previous && (this._previousConfiguration = T4.parse(this.previous.data)), this._previousConfiguration;
  }
  affectsConfiguration(e, t) {
    var n;
    const r = this._marker + e, s = this._affectsConfigStr.indexOf(r);
    if (s < 0)
      return !1;
    const o = s + r.length;
    if (o >= this._affectsConfigStr.length)
      return !1;
    const a = this._affectsConfigStr.charCodeAt(o);
    if (a !== this._markerCode1 && a !== this._markerCode2)
      return !1;
    if (t) {
      const l = this.previousConfiguration ? this.previousConfiguration.getValue(e, t, (n = this.previous) === null || n === void 0 ? void 0 : n.workspace) : void 0, c = this.currentConfiguraiton.getValue(e, t, this.currentWorkspace);
      return !Ra(l, c);
    }
    return !0;
  }
}
const NL = {
  kind: 0
  /* ResultKind.NoMatchingKb */
}, HWe = {
  kind: 1
  /* ResultKind.MoreChordsNeeded */
};
function WWe(i, e, t) {
  return { kind: 2, commandId: i, commandArgs: e, isBubble: t };
}
class VC {
  constructor(e, t, n) {
    var r;
    this._log = n, this._defaultKeybindings = e, this._defaultBoundCommands = /* @__PURE__ */ new Map();
    for (const s of e) {
      const o = s.command;
      o && o.charAt(0) !== "-" && this._defaultBoundCommands.set(o, !0);
    }
    this._map = /* @__PURE__ */ new Map(), this._lookupMap = /* @__PURE__ */ new Map(), this._keybindings = VC.handleRemovals([].concat(e).concat(t));
    for (let s = 0, o = this._keybindings.length; s < o; s++) {
      const a = this._keybindings[s];
      if (a.chords.length === 0)
        continue;
      const l = (r = a.when) === null || r === void 0 ? void 0 : r.substituteConstants();
      l && l.type === 0 || this._addKeyPress(a.chords[0], a);
    }
  }
  static _isTargetedForRemoval(e, t, n) {
    if (t) {
      for (let r = 0; r < t.length; r++)
        if (t[r] !== e.chords[r])
          return !1;
    }
    return !(n && n.type !== 1 && (!e.when || !ZNe(n, e.when)));
  }
  /**
   * Looks for rules containing "-commandId" and removes them.
   */
  static handleRemovals(e) {
    const t = /* @__PURE__ */ new Map();
    for (let r = 0, s = e.length; r < s; r++) {
      const o = e[r];
      if (o.command && o.command.charAt(0) === "-") {
        const a = o.command.substring(1);
        t.has(a) ? t.get(a).push(o) : t.set(a, [o]);
      }
    }
    if (t.size === 0)
      return e;
    const n = [];
    for (let r = 0, s = e.length; r < s; r++) {
      const o = e[r];
      if (!o.command || o.command.length === 0) {
        n.push(o);
        continue;
      }
      if (o.command.charAt(0) === "-")
        continue;
      const a = t.get(o.command);
      if (!a || !o.isDefault) {
        n.push(o);
        continue;
      }
      let l = !1;
      for (const c of a) {
        const d = c.when;
        if (this._isTargetedForRemoval(o, c.chords, d)) {
          l = !0;
          break;
        }
      }
      if (!l) {
        n.push(o);
        continue;
      }
    }
    return n;
  }
  _addKeyPress(e, t) {
    const n = this._map.get(e);
    if (typeof n > "u") {
      this._map.set(e, [t]), this._addToLookupMap(t);
      return;
    }
    for (let r = n.length - 1; r >= 0; r--) {
      const s = n[r];
      if (s.command === t.command)
        continue;
      let o = !0;
      for (let a = 1; a < s.chords.length && a < t.chords.length; a++)
        if (s.chords[a] !== t.chords[a]) {
          o = !1;
          break;
        }
      o && VC.whenIsEntirelyIncluded(s.when, t.when) && this._removeFromLookupMap(s);
    }
    n.push(t), this._addToLookupMap(t);
  }
  _addToLookupMap(e) {
    if (!e.command)
      return;
    let t = this._lookupMap.get(e.command);
    typeof t > "u" ? (t = [e], this._lookupMap.set(e.command, t)) : t.push(e);
  }
  _removeFromLookupMap(e) {
    if (!e.command)
      return;
    const t = this._lookupMap.get(e.command);
    if (!(typeof t > "u")) {
      for (let n = 0, r = t.length; n < r; n++)
        if (t[n] === e) {
          t.splice(n, 1);
          return;
        }
    }
  }
  /**
   * Returns true if it is provable `a` implies `b`.
   */
  static whenIsEntirelyIncluded(e, t) {
    return !t || t.type === 1 ? !0 : !e || e.type === 1 ? !1 : sF(e, t);
  }
  getKeybindings() {
    return this._keybindings;
  }
  lookupPrimaryKeybinding(e, t) {
    const n = this._lookupMap.get(e);
    if (typeof n > "u" || n.length === 0)
      return null;
    if (n.length === 1)
      return n[0];
    for (let r = n.length - 1; r >= 0; r--) {
      const s = n[r];
      if (t.contextMatchesRules(s.when))
        return s;
    }
    return n[n.length - 1];
  }
  /**
   * Looks up a keybinding trigged as a result of pressing a sequence of chords - `[...currentChords, keypress]`
   *
   * Example: resolving 3 chords pressed sequentially - `cmd+k cmd+p cmd+i`:
   * 	`currentChords = [ 'cmd+k' , 'cmd+p' ]` and `keypress = `cmd+i` - last pressed chord
   */
  resolve(e, t, n) {
    const r = [...t, n];
    this._log(`| Resolving ${r}`);
    const s = this._map.get(r[0]);
    if (s === void 0)
      return this._log("\\ No keybinding entries."), NL;
    let o = null;
    if (r.length < 2)
      o = s;
    else {
      o = [];
      for (let l = 0, c = s.length; l < c; l++) {
        const d = s[l];
        if (r.length > d.chords.length)
          continue;
        let u = !0;
        for (let h = 1; h < r.length; h++)
          if (d.chords[h] !== r[h]) {
            u = !1;
            break;
          }
        u && o.push(d);
      }
    }
    const a = this._findCommand(e, o);
    return a ? r.length < a.chords.length ? (this._log(`\\ From ${o.length} keybinding entries, awaiting ${a.chords.length - r.length} more chord(s), when: ${VQ(a.when)}, source: ${HQ(a)}.`), HWe) : (this._log(`\\ From ${o.length} keybinding entries, matched ${a.command}, when: ${VQ(a.when)}, source: ${HQ(a)}.`), WWe(a.command, a.commandArgs, a.bubble)) : (this._log(`\\ From ${o.length} keybinding entries, no when clauses matched the context.`), NL);
  }
  _findCommand(e, t) {
    for (let n = t.length - 1; n >= 0; n--) {
      const r = t[n];
      if (VC._contextMatchesRules(e, r.when))
        return r;
    }
    return null;
  }
  static _contextMatchesRules(e, t) {
    return t ? t.evaluate(e) : !0;
  }
}
function VQ(i) {
  return i ? `${i.serialize()}` : "no when condition";
}
function HQ(i) {
  return i.extensionId ? i.isBuiltinExtension ? `built-in extension ${i.extensionId}` : `user extension ${i.extensionId}` : i.isDefault ? "built-in" : "user";
}
const jWe = /^(cursor|delete|undo|redo|tab|editor\.action\.clipboard)/;
class zWe extends we {
  get onDidUpdateKeybindings() {
    return this._onDidUpdateKeybindings ? this._onDidUpdateKeybindings.event : qe.None;
  }
  get inChordMode() {
    return this._currentChords.length > 0;
  }
  constructor(e, t, n, r, s) {
    super(), this._contextKeyService = e, this._commandService = t, this._telemetryService = n, this._notificationService = r, this._logService = s, this._onDidUpdateKeybindings = this._register(new pe()), this._currentChords = [], this._currentChordChecker = new SS(), this._currentChordStatusMessage = null, this._ignoreSingleModifiers = av.EMPTY, this._currentSingleModifier = null, this._currentSingleModifierClearTimeout = new uc(), this._logging = !1;
  }
  dispose() {
    super.dispose();
  }
  _log(e) {
    this._logging && this._logService.info(`[KeybindingService]: ${e}`);
  }
  getKeybindings() {
    return this._getResolver().getKeybindings();
  }
  lookupKeybinding(e, t) {
    const n = this._getResolver().lookupPrimaryKeybinding(e, t || this._contextKeyService);
    if (n)
      return n.resolvedKeybinding;
  }
  dispatchEvent(e, t) {
    return this._dispatch(e, t);
  }
  // TODO@ulugbekna: update namings to align with `_doDispatch`
  // TODO@ulugbekna: this fn doesn't seem to take into account single-modifier keybindings, eg `shift shift`
  softDispatch(e, t) {
    this._log("/ Soft dispatching keyboard event");
    const n = this.resolveKeyboardEvent(e);
    if (n.hasMultipleChords())
      return console.warn("keyboard event should not be mapped to multiple chords"), NL;
    const [r] = n.getDispatchChords();
    if (r === null)
      return this._log("\\ Keyboard event cannot be dispatched"), NL;
    const s = this._contextKeyService.getContext(t), o = this._currentChords.map(({ keypress: a }) => a);
    return this._getResolver().resolve(s, o, r);
  }
  _scheduleLeaveChordMode() {
    const e = Date.now();
    this._currentChordChecker.cancelAndSet(() => {
      if (!this._documentHasFocus()) {
        this._leaveChordMode();
        return;
      }
      Date.now() - e > 5e3 && this._leaveChordMode();
    }, 500);
  }
  _expectAnotherChord(e, t) {
    switch (this._currentChords.push({ keypress: e, label: t }), this._currentChords.length) {
      case 0:
        throw Aj("impossible");
      case 1:
        this._currentChordStatusMessage = this._notificationService.status(C("first.chord", "({0}) was pressed. Waiting for second key of chord...", t));
        break;
      default: {
        const n = this._currentChords.map(({ label: r }) => r).join(", ");
        this._currentChordStatusMessage = this._notificationService.status(C("next.chord", "({0}) was pressed. Waiting for next key of chord...", n));
      }
    }
    this._scheduleLeaveChordMode(), DC.enabled && DC.disable();
  }
  _leaveChordMode() {
    this._currentChordStatusMessage && (this._currentChordStatusMessage.dispose(), this._currentChordStatusMessage = null), this._currentChordChecker.cancel(), this._currentChords = [], DC.enable();
  }
  _dispatch(e, t) {
    return this._doDispatch(
      this.resolveKeyboardEvent(e),
      t,
      /*isSingleModiferChord*/
      !1
    );
  }
  _singleModifierDispatch(e, t) {
    const n = this.resolveKeyboardEvent(e), [r] = n.getSingleModifierDispatchChords();
    if (r)
      return this._ignoreSingleModifiers.has(r) ? (this._log(`+ Ignoring single modifier ${r} due to it being pressed together with other keys.`), this._ignoreSingleModifiers = av.EMPTY, this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1) : (this._ignoreSingleModifiers = av.EMPTY, this._currentSingleModifier === null ? (this._log(`+ Storing single modifier for possible chord ${r}.`), this._currentSingleModifier = r, this._currentSingleModifierClearTimeout.cancelAndSet(() => {
        this._log("+ Clearing single modifier due to 300ms elapsed."), this._currentSingleModifier = null;
      }, 300), !1) : r === this._currentSingleModifier ? (this._log(`/ Dispatching single modifier chord ${r} ${r}`), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, this._doDispatch(
        n,
        t,
        /*isSingleModiferChord*/
        !0
      )) : (this._log(`+ Clearing single modifier due to modifier mismatch: ${this._currentSingleModifier} ${r}`), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1));
    const [s] = n.getChords();
    return this._ignoreSingleModifiers = new av(s), this._currentSingleModifier !== null && this._log("+ Clearing single modifier due to other key up."), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1;
  }
  _doDispatch(e, t, n = !1) {
    var r;
    let s = !1;
    if (e.hasMultipleChords())
      return console.warn("Unexpected keyboard event mapped to multiple chords"), !1;
    let o = null, a = null;
    if (n) {
      const [u] = e.getSingleModifierDispatchChords();
      o = u, a = u ? [u] : [];
    } else
      [o] = e.getDispatchChords(), a = this._currentChords.map(({ keypress: u }) => u);
    if (o === null)
      return this._log("\\ Keyboard event cannot be dispatched in keydown phase."), s;
    const l = this._contextKeyService.getContext(t), c = e.getLabel(), d = this._getResolver().resolve(l, a, o);
    switch (d.kind) {
      case 0: {
        if (this._logService.trace("KeybindingService#dispatch", c, "[ No matching keybinding ]"), this.inChordMode) {
          const u = this._currentChords.map(({ label: h }) => h).join(", ");
          this._log(`+ Leaving multi-chord mode: Nothing bound to "${u}, ${c}".`), this._notificationService.status(C("missing.chord", "The key combination ({0}, {1}) is not a command.", u, c), {
            hideAfter: 10 * 1e3
            /* 10s */
          }), this._leaveChordMode(), s = !0;
        }
        return s;
      }
      case 1:
        return this._logService.trace("KeybindingService#dispatch", c, "[ Several keybindings match - more chords needed ]"), s = !0, this._expectAnotherChord(o, c), this._log(this._currentChords.length === 1 ? "+ Entering multi-chord mode..." : "+ Continuing multi-chord mode..."), s;
      case 2: {
        if (this._logService.trace("KeybindingService#dispatch", c, `[ Will dispatch command ${d.commandId} ]`), d.commandId === null || d.commandId === "") {
          if (this.inChordMode) {
            const u = this._currentChords.map(({ label: h }) => h).join(", ");
            this._log(`+ Leaving chord mode: Nothing bound to "${u}, ${c}".`), this._notificationService.status(C("missing.chord", "The key combination ({0}, {1}) is not a command.", u, c), {
              hideAfter: 10 * 1e3
              /* 10s */
            }), this._leaveChordMode(), s = !0;
          }
        } else
          this.inChordMode && this._leaveChordMode(), d.isBubble || (s = !0), this._log(`+ Invoking command ${d.commandId}.`), typeof d.commandArgs > "u" ? this._commandService.executeCommand(d.commandId).then(void 0, (u) => this._notificationService.warn(u)) : this._commandService.executeCommand(d.commandId, d.commandArgs).then(void 0, (u) => this._notificationService.warn(u)), jWe.test(d.commandId) || this._telemetryService.publicLog2("workbenchActionExecuted", { id: d.commandId, from: "keybinding", detail: (r = e.getUserSettingsLabel()) !== null && r !== void 0 ? r : void 0 });
        return s;
      }
    }
  }
  mightProducePrintableCharacter(e) {
    return e.ctrlKey || e.metaKey ? !1 : e.keyCode >= 31 && e.keyCode <= 56 || e.keyCode >= 21 && e.keyCode <= 30;
  }
}
class av {
  constructor(e) {
    this._ctrlKey = e ? e.ctrlKey : !1, this._shiftKey = e ? e.shiftKey : !1, this._altKey = e ? e.altKey : !1, this._metaKey = e ? e.metaKey : !1;
  }
  has(e) {
    switch (e) {
      case "ctrl":
        return this._ctrlKey;
      case "shift":
        return this._shiftKey;
      case "alt":
        return this._altKey;
      case "meta":
        return this._metaKey;
    }
  }
}
av.EMPTY = new av(null);
class WQ {
  constructor(e, t, n, r, s, o, a) {
    this._resolvedKeybindingItemBrand = void 0, this.resolvedKeybinding = e, this.chords = e ? sB(e.getDispatchChords()) : [], e && this.chords.length === 0 && (this.chords = sB(e.getSingleModifierDispatchChords())), this.bubble = t ? t.charCodeAt(0) === 94 : !1, this.command = this.bubble ? t.substr(1) : t, this.commandArgs = n, this.when = r, this.isDefault = s, this.extensionId = o, this.isBuiltinExtension = a;
  }
}
function sB(i) {
  const e = [];
  for (let t = 0, n = i.length; t < n; t++) {
    const r = i[t];
    if (!r)
      return [];
    e.push(r);
  }
  return e;
}
class N4 {
  constructor(e, t, n = t) {
    this.modifierLabels = [null], this.modifierLabels[
      2
      /* OperatingSystem.Macintosh */
    ] = e, this.modifierLabels[
      1
      /* OperatingSystem.Windows */
    ] = t, this.modifierLabels[
      3
      /* OperatingSystem.Linux */
    ] = n;
  }
  toLabel(e, t, n) {
    if (t.length === 0)
      return null;
    const r = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = n(a);
      if (l === null)
        return null;
      r[s] = KWe(a, l, this.modifierLabels[e]);
    }
    return r.join(" ");
  }
}
const Zz = new N4({
  ctrlKey: "⌃",
  shiftKey: "⇧",
  altKey: "⌥",
  metaKey: "⌘",
  separator: ""
}, {
  ctrlKey: C({ key: "ctrlKey", comment: ["This is the short form for the Control key on the keyboard"] }, "Ctrl"),
  shiftKey: C({ key: "shiftKey", comment: ["This is the short form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "altKey", comment: ["This is the short form for the Alt key on the keyboard"] }, "Alt"),
  metaKey: C({ key: "windowsKey", comment: ["This is the short form for the Windows key on the keyboard"] }, "Windows"),
  separator: "+"
}, {
  ctrlKey: C({ key: "ctrlKey", comment: ["This is the short form for the Control key on the keyboard"] }, "Ctrl"),
  shiftKey: C({ key: "shiftKey", comment: ["This is the short form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "altKey", comment: ["This is the short form for the Alt key on the keyboard"] }, "Alt"),
  metaKey: C({ key: "superKey", comment: ["This is the short form for the Super key on the keyboard"] }, "Super"),
  separator: "+"
}), UWe = new N4({
  ctrlKey: C({ key: "ctrlKey.long", comment: ["This is the long form for the Control key on the keyboard"] }, "Control"),
  shiftKey: C({ key: "shiftKey.long", comment: ["This is the long form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "optKey.long", comment: ["This is the long form for the Alt/Option key on the keyboard"] }, "Option"),
  metaKey: C({ key: "cmdKey.long", comment: ["This is the long form for the Command key on the keyboard"] }, "Command"),
  separator: "+"
}, {
  ctrlKey: C({ key: "ctrlKey.long", comment: ["This is the long form for the Control key on the keyboard"] }, "Control"),
  shiftKey: C({ key: "shiftKey.long", comment: ["This is the long form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "altKey.long", comment: ["This is the long form for the Alt key on the keyboard"] }, "Alt"),
  metaKey: C({ key: "windowsKey.long", comment: ["This is the long form for the Windows key on the keyboard"] }, "Windows"),
  separator: "+"
}, {
  ctrlKey: C({ key: "ctrlKey.long", comment: ["This is the long form for the Control key on the keyboard"] }, "Control"),
  shiftKey: C({ key: "shiftKey.long", comment: ["This is the long form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "altKey.long", comment: ["This is the long form for the Alt key on the keyboard"] }, "Alt"),
  metaKey: C({ key: "superKey.long", comment: ["This is the long form for the Super key on the keyboard"] }, "Super"),
  separator: "+"
}), GWe = new N4({
  ctrlKey: "Ctrl",
  shiftKey: "Shift",
  altKey: "Alt",
  metaKey: "Cmd",
  separator: "+"
}, {
  ctrlKey: "Ctrl",
  shiftKey: "Shift",
  altKey: "Alt",
  metaKey: "Super",
  separator: "+"
}), qWe = new N4({
  ctrlKey: "ctrl",
  shiftKey: "shift",
  altKey: "alt",
  metaKey: "cmd",
  separator: "+"
}, {
  ctrlKey: "ctrl",
  shiftKey: "shift",
  altKey: "alt",
  metaKey: "win",
  separator: "+"
}, {
  ctrlKey: "ctrl",
  shiftKey: "shift",
  altKey: "alt",
  metaKey: "meta",
  separator: "+"
});
function KWe(i, e, t) {
  if (e === null)
    return "";
  const n = [];
  return i.ctrlKey && n.push(t.ctrlKey), i.shiftKey && n.push(t.shiftKey), i.altKey && n.push(t.altKey), i.metaKey && n.push(t.metaKey), e !== "" && n.push(e), n.join(t.separator);
}
class YWe extends JNe {
  constructor(e, t) {
    if (super(), t.length === 0)
      throw fl("chords");
    this._os = e, this._chords = t;
  }
  getLabel() {
    return Zz.toLabel(this._os, this._chords, (e) => this._getLabel(e));
  }
  getAriaLabel() {
    return UWe.toLabel(this._os, this._chords, (e) => this._getAriaLabel(e));
  }
  getElectronAccelerator() {
    return this._chords.length > 1 || this._chords[0].isDuplicateModifierCase() ? null : GWe.toLabel(this._os, this._chords, (e) => this._getElectronAccelerator(e));
  }
  getUserSettingsLabel() {
    return qWe.toLabel(this._os, this._chords, (e) => this._getUserSettingsLabel(e));
  }
  hasMultipleChords() {
    return this._chords.length > 1;
  }
  getChords() {
    return this._chords.map((e) => this._getChord(e));
  }
  _getChord(e) {
    return new QNe(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, this._getLabel(e), this._getAriaLabel(e));
  }
  getDispatchChords() {
    return this._chords.map((e) => this._getChordDispatch(e));
  }
  getSingleModifierDispatchChords() {
    return this._chords.map((e) => this._getSingleModifierChordDispatch(e));
  }
}
class iw extends YWe {
  constructor(e, t) {
    super(t, e);
  }
  _keyCodeToUILabel(e) {
    if (this._os === 2)
      switch (e) {
        case 15:
          return "←";
        case 16:
          return "↑";
        case 17:
          return "→";
        case 18:
          return "↓";
      }
    return ph.toString(e);
  }
  _getLabel(e) {
    return e.isDuplicateModifierCase() ? "" : this._keyCodeToUILabel(e.keyCode);
  }
  _getAriaLabel(e) {
    return e.isDuplicateModifierCase() ? "" : ph.toString(e.keyCode);
  }
  _getElectronAccelerator(e) {
    return ph.toElectronAccelerator(e.keyCode);
  }
  _getUserSettingsLabel(e) {
    if (e.isDuplicateModifierCase())
      return "";
    const t = ph.toUserSettingsUS(e.keyCode);
    return t && t.toLowerCase();
  }
  _getChordDispatch(e) {
    return iw.getDispatchStr(e);
  }
  static getDispatchStr(e) {
    if (e.isModifierKey())
      return null;
    let t = "";
    return e.ctrlKey && (t += "ctrl+"), e.shiftKey && (t += "shift+"), e.altKey && (t += "alt+"), e.metaKey && (t += "meta+"), t += ph.toString(e.keyCode), t;
  }
  _getSingleModifierChordDispatch(e) {
    return e.keyCode === 5 && !e.shiftKey && !e.altKey && !e.metaKey ? "ctrl" : e.keyCode === 4 && !e.ctrlKey && !e.altKey && !e.metaKey ? "shift" : e.keyCode === 6 && !e.ctrlKey && !e.shiftKey && !e.metaKey ? "alt" : e.keyCode === 57 && !e.ctrlKey && !e.shiftKey && !e.altKey ? "meta" : null;
  }
  /**
   * *NOTE*: Check return value for `KeyCode.Unknown`.
   */
  static _scanCodeToKeyCode(e) {
    const t = Mj[e];
    if (t !== -1)
      return t;
    switch (e) {
      case 10:
        return 31;
      case 11:
        return 32;
      case 12:
        return 33;
      case 13:
        return 34;
      case 14:
        return 35;
      case 15:
        return 36;
      case 16:
        return 37;
      case 17:
        return 38;
      case 18:
        return 39;
      case 19:
        return 40;
      case 20:
        return 41;
      case 21:
        return 42;
      case 22:
        return 43;
      case 23:
        return 44;
      case 24:
        return 45;
      case 25:
        return 46;
      case 26:
        return 47;
      case 27:
        return 48;
      case 28:
        return 49;
      case 29:
        return 50;
      case 30:
        return 51;
      case 31:
        return 52;
      case 32:
        return 53;
      case 33:
        return 54;
      case 34:
        return 55;
      case 35:
        return 56;
      case 36:
        return 22;
      case 37:
        return 23;
      case 38:
        return 24;
      case 39:
        return 25;
      case 40:
        return 26;
      case 41:
        return 27;
      case 42:
        return 28;
      case 43:
        return 29;
      case 44:
        return 30;
      case 45:
        return 21;
      case 51:
        return 88;
      case 52:
        return 86;
      case 53:
        return 92;
      case 54:
        return 94;
      case 55:
        return 93;
      case 56:
        return 0;
      case 57:
        return 85;
      case 58:
        return 95;
      case 59:
        return 91;
      case 60:
        return 87;
      case 61:
        return 89;
      case 62:
        return 90;
      case 106:
        return 97;
    }
    return 0;
  }
  static _toKeyCodeChord(e) {
    if (!e)
      return null;
    if (e instanceof Qh)
      return e;
    const t = this._scanCodeToKeyCode(e.scanCode);
    return t === 0 ? null : new Qh(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, t);
  }
  static resolveKeybinding(e, t) {
    const n = sB(e.chords.map((r) => this._toKeyCodeChord(r)));
    return n.length > 0 ? [new iw(n, t)] : [];
  }
}
const I_ = Gt("labelService"), Zge = Gt("progressService");
class Hh {
  constructor(e, t) {
    this.callback = e, this.report = t?.async ? this._reportAsync.bind(this) : this._reportSync.bind(this);
  }
  _reportSync(e) {
    this._value = e, this.callback(this._value);
  }
  _reportAsync(e) {
    Promise.resolve(this._lastTask).finally(() => {
      this._value = e;
      const t = this.callback(this._value);
      this._lastTask = Promise.resolve(t).finally(() => this._lastTask = void 0);
    });
  }
}
Hh.None = Object.freeze({ report() {
} });
const hp = Gt("editorProgressService");
class XWe {
  constructor() {
    this._value = "", this._pos = 0;
  }
  reset(e) {
    return this._value = e, this._pos = 0, this;
  }
  next() {
    return this._pos += 1, this;
  }
  hasNext() {
    return this._pos < this._value.length - 1;
  }
  cmp(e) {
    const t = e.charCodeAt(0), n = this._value.charCodeAt(this._pos);
    return t - n;
  }
  value() {
    return this._value[this._pos];
  }
}
class ZWe {
  constructor(e = !0) {
    this._caseSensitive = e;
  }
  reset(e) {
    return this._value = e, this._from = 0, this._to = 0, this.next();
  }
  hasNext() {
    return this._to < this._value.length;
  }
  next() {
    this._from = this._to;
    let e = !0;
    for (; this._to < this._value.length; this._to++)
      if (this._value.charCodeAt(this._to) === 46)
        if (e)
          this._from++;
        else
          break;
      else
        e = !1;
    return this;
  }
  cmp(e) {
    return this._caseSensitive ? Fj(e, this._value, 0, e.length, this._from, this._to) : CS(e, this._value, 0, e.length, this._from, this._to);
  }
  value() {
    return this._value.substring(this._from, this._to);
  }
}
class QWe {
  constructor(e = !0, t = !0) {
    this._splitOnBackslash = e, this._caseSensitive = t;
  }
  reset(e) {
    this._from = 0, this._to = 0, this._value = e, this._valueLen = e.length;
    for (let t = e.length - 1; t >= 0; t--, this._valueLen--) {
      const n = this._value.charCodeAt(t);
      if (!(n === 47 || this._splitOnBackslash && n === 92))
        break;
    }
    return this.next();
  }
  hasNext() {
    return this._to < this._valueLen;
  }
  next() {
    this._from = this._to;
    let e = !0;
    for (; this._to < this._valueLen; this._to++) {
      const t = this._value.charCodeAt(this._to);
      if (t === 47 || this._splitOnBackslash && t === 92)
        if (e)
          this._from++;
        else
          break;
      else
        e = !1;
    }
    return this;
  }
  cmp(e) {
    return this._caseSensitive ? Fj(e, this._value, 0, e.length, this._from, this._to) : CS(e, this._value, 0, e.length, this._from, this._to);
  }
  value() {
    return this._value.substring(this._from, this._to);
  }
}
class JWe {
  constructor(e, t) {
    this._ignorePathCasing = e, this._ignoreQueryAndFragment = t, this._states = [], this._stateIdx = 0;
  }
  reset(e) {
    return this._value = e, this._states = [], this._value.scheme && this._states.push(
      1
      /* UriIteratorState.Scheme */
    ), this._value.authority && this._states.push(
      2
      /* UriIteratorState.Authority */
    ), this._value.path && (this._pathIterator = new QWe(!1, !this._ignorePathCasing(e)), this._pathIterator.reset(e.path), this._pathIterator.value() && this._states.push(
      3
      /* UriIteratorState.Path */
    )), this._ignoreQueryAndFragment(e) || (this._value.query && this._states.push(
      4
      /* UriIteratorState.Query */
    ), this._value.fragment && this._states.push(
      5
      /* UriIteratorState.Fragment */
    )), this._stateIdx = 0, this;
  }
  next() {
    return this._states[this._stateIdx] === 3 && this._pathIterator.hasNext() ? this._pathIterator.next() : this._stateIdx += 1, this;
  }
  hasNext() {
    return this._states[this._stateIdx] === 3 && this._pathIterator.hasNext() || this._stateIdx < this._states.length - 1;
  }
  cmp(e) {
    if (this._states[this._stateIdx] === 1)
      return $R(e, this._value.scheme);
    if (this._states[this._stateIdx] === 2)
      return $R(e, this._value.authority);
    if (this._states[this._stateIdx] === 3)
      return this._pathIterator.cmp(e);
    if (this._states[this._stateIdx] === 4)
      return Dy(e, this._value.query);
    if (this._states[this._stateIdx] === 5)
      return Dy(e, this._value.fragment);
    throw new Error();
  }
  value() {
    if (this._states[this._stateIdx] === 1)
      return this._value.scheme;
    if (this._states[this._stateIdx] === 2)
      return this._value.authority;
    if (this._states[this._stateIdx] === 3)
      return this._pathIterator.value();
    if (this._states[this._stateIdx] === 4)
      return this._value.query;
    if (this._states[this._stateIdx] === 5)
      return this._value.fragment;
    throw new Error();
  }
}
class fD {
  constructor() {
    this.height = 1;
  }
  rotateLeft() {
    const e = this.right;
    return this.right = e.left, e.left = this, this.updateHeight(), e.updateHeight(), e;
  }
  rotateRight() {
    const e = this.left;
    return this.left = e.right, e.right = this, this.updateHeight(), e.updateHeight(), e;
  }
  updateHeight() {
    this.height = 1 + Math.max(this.heightLeft, this.heightRight);
  }
  balanceFactor() {
    return this.heightRight - this.heightLeft;
  }
  get heightLeft() {
    var e, t;
    return (t = (e = this.left) === null || e === void 0 ? void 0 : e.height) !== null && t !== void 0 ? t : 0;
  }
  get heightRight() {
    var e, t;
    return (t = (e = this.right) === null || e === void 0 ? void 0 : e.height) !== null && t !== void 0 ? t : 0;
  }
}
class Uv {
  static forUris(e = () => !1, t = () => !1) {
    return new Uv(new JWe(e, t));
  }
  static forStrings() {
    return new Uv(new XWe());
  }
  static forConfigKeys() {
    return new Uv(new ZWe());
  }
  constructor(e) {
    this._iter = e;
  }
  clear() {
    this._root = void 0;
  }
  set(e, t) {
    const n = this._iter.reset(e);
    let r;
    this._root || (this._root = new fD(), this._root.segment = n.value());
    const s = [];
    for (r = this._root; ; ) {
      const a = n.cmp(r.segment);
      if (a > 0)
        r.left || (r.left = new fD(), r.left.segment = n.value()), s.push([-1, r]), r = r.left;
      else if (a < 0)
        r.right || (r.right = new fD(), r.right.segment = n.value()), s.push([1, r]), r = r.right;
      else if (n.hasNext())
        n.next(), r.mid || (r.mid = new fD(), r.mid.segment = n.value()), s.push([0, r]), r = r.mid;
      else
        break;
    }
    const o = r.value;
    r.value = t, r.key = e;
    for (let a = s.length - 1; a >= 0; a--) {
      const l = s[a][1];
      l.updateHeight();
      const c = l.balanceFactor();
      if (c < -1 || c > 1) {
        const d = s[a][0], u = s[a + 1][0];
        if (d === 1 && u === 1)
          s[a][1] = l.rotateLeft();
        else if (d === -1 && u === -1)
          s[a][1] = l.rotateRight();
        else if (d === 1 && u === -1)
          l.right = s[a + 1][1] = s[a + 1][1].rotateRight(), s[a][1] = l.rotateLeft();
        else if (d === -1 && u === 1)
          l.left = s[a + 1][1] = s[a + 1][1].rotateLeft(), s[a][1] = l.rotateRight();
        else
          throw new Error();
        if (a > 0)
          switch (s[a - 1][0]) {
            case -1:
              s[a - 1][1].left = s[a][1];
              break;
            case 1:
              s[a - 1][1].right = s[a][1];
              break;
            case 0:
              s[a - 1][1].mid = s[a][1];
              break;
          }
        else
          this._root = s[0][1];
      }
    }
    return o;
  }
  get(e) {
    var t;
    return (t = this._getNode(e)) === null || t === void 0 ? void 0 : t.value;
  }
  _getNode(e) {
    const t = this._iter.reset(e);
    let n = this._root;
    for (; n; ) {
      const r = t.cmp(n.segment);
      if (r > 0)
        n = n.left;
      else if (r < 0)
        n = n.right;
      else if (t.hasNext())
        t.next(), n = n.mid;
      else
        break;
    }
    return n;
  }
  has(e) {
    const t = this._getNode(e);
    return !(t?.value === void 0 && t?.mid === void 0);
  }
  delete(e) {
    return this._delete(e, !1);
  }
  deleteSuperstr(e) {
    return this._delete(e, !0);
  }
  _delete(e, t) {
    var n;
    const r = this._iter.reset(e), s = [];
    let o = this._root;
    for (; o; ) {
      const a = r.cmp(o.segment);
      if (a > 0)
        s.push([-1, o]), o = o.left;
      else if (a < 0)
        s.push([1, o]), o = o.right;
      else if (r.hasNext())
        r.next(), s.push([0, o]), o = o.mid;
      else
        break;
    }
    if (o) {
      if (t ? (o.left = void 0, o.mid = void 0, o.right = void 0, o.height = 1) : (o.key = void 0, o.value = void 0), !o.mid && !o.value)
        if (o.left && o.right) {
          const a = this._min(o.right);
          if (a.key) {
            const { key: l, value: c, segment: d } = a;
            this._delete(a.key, !1), o.key = l, o.value = c, o.segment = d;
          }
        } else {
          const a = (n = o.left) !== null && n !== void 0 ? n : o.right;
          if (s.length > 0) {
            const [l, c] = s[s.length - 1];
            switch (l) {
              case -1:
                c.left = a;
                break;
              case 0:
                c.mid = a;
                break;
              case 1:
                c.right = a;
                break;
            }
          } else
            this._root = a;
        }
      for (let a = s.length - 1; a >= 0; a--) {
        const l = s[a][1];
        l.updateHeight();
        const c = l.balanceFactor();
        if (c > 1 ? (l.right.balanceFactor() >= 0 || (l.right = l.right.rotateRight()), s[a][1] = l.rotateLeft()) : c < -1 && (l.left.balanceFactor() <= 0 || (l.left = l.left.rotateLeft()), s[a][1] = l.rotateRight()), a > 0)
          switch (s[a - 1][0]) {
            case -1:
              s[a - 1][1].left = s[a][1];
              break;
            case 1:
              s[a - 1][1].right = s[a][1];
              break;
            case 0:
              s[a - 1][1].mid = s[a][1];
              break;
          }
        else
          this._root = s[0][1];
      }
    }
  }
  _min(e) {
    for (; e.left; )
      e = e.left;
    return e;
  }
  findSubstr(e) {
    const t = this._iter.reset(e);
    let n = this._root, r;
    for (; n; ) {
      const s = t.cmp(n.segment);
      if (s > 0)
        n = n.left;
      else if (s < 0)
        n = n.right;
      else if (t.hasNext())
        t.next(), r = n.value || r, n = n.mid;
      else
        break;
    }
    return n && n.value || r;
  }
  findSuperstr(e) {
    return this._findSuperstrOrElement(e, !1);
  }
  _findSuperstrOrElement(e, t) {
    const n = this._iter.reset(e);
    let r = this._root;
    for (; r; ) {
      const s = n.cmp(r.segment);
      if (s > 0)
        r = r.left;
      else if (s < 0)
        r = r.right;
      else if (n.hasNext())
        n.next(), r = r.mid;
      else
        return r.mid ? this._entries(r.mid) : t ? r.value : void 0;
    }
  }
  forEach(e) {
    for (const [t, n] of this)
      e(n, t);
  }
  *[Symbol.iterator]() {
    yield* this._entries(this._root);
  }
  _entries(e) {
    const t = [];
    return this._dfsEntries(e, t), t[Symbol.iterator]();
  }
  _dfsEntries(e, t) {
    e && (e.left && this._dfsEntries(e.left, t), e.value && t.push([e.key, e.value]), e.mid && this._dfsEntries(e.mid, t), e.right && this._dfsEntries(e.right, t));
  }
}
const Qm = Gt("contextService");
function oB(i) {
  const e = i;
  return typeof e?.id == "string" && pt.isUri(e.uri);
}
function $We(i) {
  const e = i;
  return typeof e?.id == "string" && !oB(i) && !nje(i);
}
const eje = { id: "empty-window" };
function tje(i, e) {
  if (typeof i == "string" || typeof i > "u")
    return typeof i == "string" ? {
      id: fg(i)
    } : eje;
  const t = i;
  return t.configuration ? {
    id: t.id,
    configPath: t.configuration
  } : t.folders.length === 1 ? {
    id: t.id,
    uri: t.folders[0].uri
  } : {
    id: t.id
  };
}
function nje(i) {
  const e = i;
  return typeof e?.id == "string" && pt.isUri(e.configPath);
}
class ije {
  constructor(e, t) {
    this.raw = t, this.uri = e.uri, this.index = e.index, this.name = e.name;
  }
  toJSON() {
    return { uri: this.uri, name: this.name, index: this.index };
  }
}
const aB = "code-workspace";
C("codeWorkspace", "Code Workspace");
const Qge = "4064f6ec-cb38-4ad0-af64-ee6467e63c82";
function rje(i) {
  return i.id === Qge;
}
var lB;
(function(i) {
  i.inspectTokensAction = C("inspectTokens", "Developer: Inspect Tokens");
})(lB || (lB = {}));
var PL;
(function(i) {
  i.gotoLineActionLabel = C("gotoLineActionLabel", "Go to Line/Column...");
})(PL || (PL = {}));
var cB;
(function(i) {
  i.helpQuickAccessActionLabel = C("helpQuickAccess", "Show all Quick Access Providers");
})(cB || (cB = {}));
var OL;
(function(i) {
  i.quickCommandActionLabel = C("quickCommandActionLabel", "Command Palette"), i.quickCommandHelp = C("quickCommandActionHelp", "Show And Run Commands");
})(OL || (OL = {}));
var rw;
(function(i) {
  i.quickOutlineActionLabel = C("quickOutlineActionLabel", "Go to Symbol..."), i.quickOutlineByCategoryActionLabel = C("quickOutlineByCategoryActionLabel", "Go to Symbol by Category...");
})(rw || (rw = {}));
var ML;
(function(i) {
  i.editorViewAccessibleLabel = C("editorViewAccessibleLabel", "Editor content"), i.accessibilityHelpMessage = C("accessibilityHelpMessage", "Press Alt+F1 for Accessibility Options.");
})(ML || (ML = {}));
var dB;
(function(i) {
  i.toggleHighContrast = C("toggleHighContrast", "Toggle High Contrast Theme");
})(dB || (dB = {}));
var uB;
(function(i) {
  i.bulkEditServiceSummary = C("bulkEditServiceSummary", "Made {0} edits in {1} files");
})(uB || (uB = {}));
const Jge = Gt("workspaceTrustManagementService"), cf = Gt("contextViewService"), gc = Gt("contextMenuService");
var ks;
(function(i) {
  function e(s, o) {
    if (s.start >= o.end || o.start >= s.end)
      return { start: 0, end: 0 };
    const a = Math.max(s.start, o.start), l = Math.min(s.end, o.end);
    return l - a <= 0 ? { start: 0, end: 0 } : { start: a, end: l };
  }
  i.intersect = e;
  function t(s) {
    return s.end - s.start <= 0;
  }
  i.isEmpty = t;
  function n(s, o) {
    return !t(e(s, o));
  }
  i.intersects = n;
  function r(s, o) {
    const a = [], l = { start: s.start, end: Math.min(o.start, s.end) }, c = { start: Math.max(o.end, s.start), end: s.end };
    return t(l) || a.push(l), t(c) || a.push(c), a;
  }
  i.relativeComplement = r;
})(ks || (ks = {}));
function sje(i) {
  const e = i;
  return !!e && typeof e.x == "number" && typeof e.y == "number";
}
var ng;
(function(i) {
  i[i.AVOID = 0] = "AVOID", i[i.ALIGN = 1] = "ALIGN";
})(ng || (ng = {}));
function lv(i, e, t) {
  const n = t.mode === ng.ALIGN ? t.offset : t.offset + t.size, r = t.mode === ng.ALIGN ? t.offset + t.size : t.offset;
  return t.position === 0 ? e <= i - n ? n : e <= r ? r - e : Math.max(i - e, 0) : e <= r ? r - e : e <= i - n ? n : 0;
}
class A_ extends we {
  constructor(e, t) {
    super(), this.container = null, this.delegate = null, this.toDisposeOnClean = we.None, this.toDisposeOnSetContainer = we.None, this.shadowRoot = null, this.shadowRootHostElement = null, this.view = Re(".context-view"), this.useFixedPosition = !1, this.useShadowDOM = !1, ao(this.view), this.setContainer(e, t), this._register(Ct(() => this.setContainer(
      null,
      1
      /* ContextViewDOMPosition.ABSOLUTE */
    )));
  }
  setContainer(e, t) {
    var n;
    if (this.container && (this.toDisposeOnSetContainer.dispose(), this.shadowRoot ? (this.shadowRoot.removeChild(this.view), this.shadowRoot = null, (n = this.shadowRootHostElement) === null || n === void 0 || n.remove(), this.shadowRootHostElement = null) : this.container.removeChild(this.view), this.container = null), e) {
      if (this.container = e, this.useFixedPosition = t !== 1, this.useShadowDOM = t === 3, this.useShadowDOM) {
        this.shadowRootHostElement = Re(".shadow-root-host"), this.container.appendChild(this.shadowRootHostElement), this.shadowRoot = this.shadowRootHostElement.attachShadow({ mode: "open" });
        const s = document.createElement("style");
        s.textContent = oje, this.shadowRoot.appendChild(s), this.shadowRoot.appendChild(this.view), this.shadowRoot.appendChild(Re("slot"));
      } else
        this.container.appendChild(this.view);
      const r = new Ne();
      A_.BUBBLE_UP_EVENTS.forEach((s) => {
        r.add(ar(this.container, s, (o) => {
          this.onDOMEvent(o, !1);
        }));
      }), A_.BUBBLE_DOWN_EVENTS.forEach((s) => {
        r.add(ar(this.container, s, (o) => {
          this.onDOMEvent(o, !0);
        }, !0));
      }), this.toDisposeOnSetContainer = r;
    }
  }
  show(e) {
    var t, n;
    this.isVisible() && this.hide(), ls(this.view), this.view.className = "context-view", this.view.style.top = "0px", this.view.style.left = "0px", this.view.style.zIndex = "2575", this.view.style.position = this.useFixedPosition ? "fixed" : "absolute", Zo(this.view), this.toDisposeOnClean = e.render(this.view) || we.None, this.delegate = e, this.doLayout(), (n = (t = this.delegate).focus) === null || n === void 0 || n.call(t);
  }
  getViewElement() {
    return this.view;
  }
  layout() {
    if (this.isVisible()) {
      if (this.delegate.canRelayout === !1 && !(od && Yj.pointerEvents)) {
        this.hide();
        return;
      }
      this.delegate.layout && this.delegate.layout(), this.doLayout();
    }
  }
  doLayout() {
    if (!this.isVisible())
      return;
    const e = this.delegate.getAnchor();
    let t;
    if (Zj(e)) {
      const u = wr(e), h = z9e(e);
      t = {
        top: u.top * h,
        left: u.left * h,
        width: u.width * h,
        height: u.height * h
      };
    } else sje(e) ? t = {
      top: e.y,
      left: e.x,
      width: e.width || 1,
      height: e.height || 2
    } : t = {
      top: e.posy,
      left: e.posx,
      // We are about to position the context view where the mouse
      // cursor is. To prevent the view being exactly under the mouse
      // when showing and thus potentially triggering an action within,
      // we treat the mouse location like a small sized block element.
      width: 2,
      height: 2
    };
    const n = Lo(this.view), r = cm(this.view), s = this.delegate.anchorPosition || 0, o = this.delegate.anchorAlignment || 0, a = this.delegate.anchorAxisAlignment || 0;
    let l, c;
    if (a === 0) {
      const u = {
        offset: t.top - window.pageYOffset,
        size: t.height,
        position: s === 0 ? 0 : 1
        /* LayoutAnchorPosition.After */
      }, h = { offset: t.left, size: t.width, position: o === 0 ? 0 : 1, mode: ng.ALIGN };
      l = lv(window.innerHeight, r, u) + window.pageYOffset, ks.intersects({ start: l, end: l + r }, { start: u.offset, end: u.offset + u.size }) && (h.mode = ng.AVOID), c = lv(window.innerWidth, n, h);
    } else {
      const u = {
        offset: t.left,
        size: t.width,
        position: o === 0 ? 0 : 1
        /* LayoutAnchorPosition.After */
      }, h = { offset: t.top, size: t.height, position: s === 0 ? 0 : 1, mode: ng.ALIGN };
      c = lv(window.innerWidth, n, u), ks.intersects({ start: c, end: c + n }, { start: u.offset, end: u.offset + u.size }) && (h.mode = ng.AVOID), l = lv(window.innerHeight, r, h) + window.pageYOffset;
    }
    this.view.classList.remove("top", "bottom", "left", "right"), this.view.classList.add(s === 0 ? "bottom" : "top"), this.view.classList.add(o === 0 ? "left" : "right"), this.view.classList.toggle("fixed", this.useFixedPosition);
    const d = wr(this.container);
    this.view.style.top = `${l - (this.useFixedPosition ? wr(this.view).top : d.top)}px`, this.view.style.left = `${c - (this.useFixedPosition ? wr(this.view).left : d.left)}px`, this.view.style.width = "initial";
  }
  hide(e) {
    const t = this.delegate;
    this.delegate = null, t?.onHide && t.onHide(e), this.toDisposeOnClean.dispose(), ao(this.view);
  }
  isVisible() {
    return !!this.delegate;
  }
  onDOMEvent(e, t) {
    this.delegate && (this.delegate.onDOMEvent ? this.delegate.onDOMEvent(e, document.activeElement) : t && !xs(e.target, this.container) && this.hide());
  }
  dispose() {
    this.hide(), super.dispose();
  }
}
A_.BUBBLE_UP_EVENTS = ["click", "keydown", "focus", "blur"];
A_.BUBBLE_DOWN_EVENTS = ["click"];
const oje = (
  /* css */
  `
	:host {
		all: initial; /* 1st rule so subsequent properties are reset. */
	}

	.codicon[class*='codicon-'] {
		font: normal normal normal 16px/1 codicon;
		display: inline-block;
		text-decoration: none;
		text-rendering: auto;
		text-align: center;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	:host {
		font-family: -apple-system, BlinkMacSystemFont, "Segoe WPC", "Segoe UI", "HelveticaNeue-Light", system-ui, "Ubuntu", "Droid Sans", sans-serif;
	}

	:host-context(.mac) { font-family: -apple-system, BlinkMacSystemFont, sans-serif; }
	:host-context(.mac:lang(zh-Hans)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", sans-serif; }
	:host-context(.mac:lang(zh-Hant)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang TC", sans-serif; }
	:host-context(.mac:lang(ja)) { font-family: -apple-system, BlinkMacSystemFont, "Hiragino Kaku Gothic Pro", sans-serif; }
	:host-context(.mac:lang(ko)) { font-family: -apple-system, BlinkMacSystemFont, "Nanum Gothic", "Apple SD Gothic Neo", "AppleGothic", sans-serif; }

	:host-context(.windows) { font-family: "Segoe WPC", "Segoe UI", sans-serif; }
	:host-context(.windows:lang(zh-Hans)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft YaHei", sans-serif; }
	:host-context(.windows:lang(zh-Hant)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft Jhenghei", sans-serif; }
	:host-context(.windows:lang(ja)) { font-family: "Segoe WPC", "Segoe UI", "Yu Gothic UI", "Meiryo UI", sans-serif; }
	:host-context(.windows:lang(ko)) { font-family: "Segoe WPC", "Segoe UI", "Malgun Gothic", "Dotom", sans-serif; }

	:host-context(.linux) { font-family: system-ui, "Ubuntu", "Droid Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hans)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans SC", "Source Han Sans CN", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hant)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans TC", "Source Han Sans TW", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ja)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans J", "Source Han Sans JP", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ko)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans K", "Source Han Sans JR", "Source Han Sans", "UnDotum", "FBaekmuk Gulim", sans-serif; }
`
);
var aje = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, lje = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let hB = class extends we {
  constructor(e) {
    super(), this.layoutService = e, this.currentViewDisposable = we.None, this.container = e.hasContainer ? e.container : null, this.contextView = this._register(new A_(
      this.container,
      1
      /* ContextViewDOMPosition.ABSOLUTE */
    )), this.layout(), this._register(e.onDidLayout(() => this.layout()));
  }
  // ContextView
  setContainer(e, t) {
    this.contextView.setContainer(
      e,
      t || 1
      /* ContextViewDOMPosition.ABSOLUTE */
    );
  }
  showContextView(e, t, n) {
    t ? (t !== this.container || this.shadowRoot !== n) && (this.container = t, this.setContainer(
      t,
      n ? 3 : 2
      /* ContextViewDOMPosition.FIXED */
    )) : this.layoutService.hasContainer && this.container !== this.layoutService.container && (this.container = this.layoutService.container, this.setContainer(
      this.container,
      1
      /* ContextViewDOMPosition.ABSOLUTE */
    )), this.shadowRoot = n, this.contextView.show(e);
    const r = Ct(() => {
      this.currentViewDisposable === r && this.hideContextView();
    });
    return this.currentViewDisposable = r, r;
  }
  getContextViewElement() {
    return this.contextView.getViewElement();
  }
  layout() {
    this.contextView.layout();
  }
  hideContextView(e) {
    this.contextView.hide(e);
  }
};
hB = aje([
  lje(0, bb)
], hB);
let k_ = [], Qz = [], $ge = [];
function gD(i, e = !1) {
  cje(i, !1, e);
}
function cje(i, e, t) {
  const n = dje(i, e);
  k_.push(n), n.userConfigured ? $ge.push(n) : Qz.push(n), t && !n.userConfigured && k_.forEach((r) => {
    r.mime === n.mime || r.userConfigured || (n.extension && r.extension === n.extension && console.warn(`Overwriting extension <<${n.extension}>> to now point to mime <<${n.mime}>>`), n.filename && r.filename === n.filename && console.warn(`Overwriting filename <<${n.filename}>> to now point to mime <<${n.mime}>>`), n.filepattern && r.filepattern === n.filepattern && console.warn(`Overwriting filepattern <<${n.filepattern}>> to now point to mime <<${n.mime}>>`), n.firstline && r.firstline === n.firstline && console.warn(`Overwriting firstline <<${n.firstline}>> to now point to mime <<${n.mime}>>`));
  });
}
function dje(i, e) {
  return {
    id: i.id,
    mime: i.mime,
    filename: i.filename,
    extension: i.extension,
    filepattern: i.filepattern,
    firstline: i.firstline,
    userConfigured: e,
    filenameLowercase: i.filename ? i.filename.toLowerCase() : void 0,
    extensionLowercase: i.extension ? i.extension.toLowerCase() : void 0,
    filepatternLowercase: i.filepattern ? Gge(i.filepattern.toLowerCase()) : void 0,
    filepatternOnPath: i.filepattern ? i.filepattern.indexOf(yr.sep) >= 0 : !1
  };
}
function uje() {
  k_ = k_.filter((i) => i.userConfigured), Qz = [];
}
function hje(i, e) {
  return fje(i, e).map((t) => t.id);
}
function fje(i, e) {
  let t;
  if (i)
    switch (i.scheme) {
      case Mt.file:
        t = i.fsPath;
        break;
      case Mt.data: {
        t = jg.parseMetaData(i).get(jg.META_DATA_LABEL);
        break;
      }
      case Mt.vscodeNotebookCell:
        t = void 0;
        break;
      default:
        t = i.path;
    }
  if (!t)
    return [{ id: "unknown", mime: Zi.unknown }];
  t = t.toLowerCase();
  const n = fg(t), r = jQ(t, n, $ge);
  if (r)
    return [r, { id: Fa, mime: Zi.text }];
  const s = jQ(t, n, Qz);
  if (s)
    return [s, { id: Fa, mime: Zi.text }];
  if (e) {
    const o = gje(e);
    if (o)
      return [o, { id: Fa, mime: Zi.text }];
  }
  return [{ id: "unknown", mime: Zi.unknown }];
}
function jQ(i, e, t) {
  var n;
  let r, s, o;
  for (let a = t.length - 1; a >= 0; a--) {
    const l = t[a];
    if (e === l.filenameLowercase) {
      r = l;
      break;
    }
    if (l.filepattern && (!s || l.filepattern.length > s.filepattern.length)) {
      const c = l.filepatternOnPath ? i : e;
      !((n = l.filepatternLowercase) === null || n === void 0) && n.call(l, c) && (s = l);
    }
    l.extension && (!o || l.extension.length > o.extension.length) && e.endsWith(l.extensionLowercase) && (o = l);
  }
  if (r)
    return r;
  if (s)
    return s;
  if (o)
    return o;
}
function gje(i) {
  if (zj(i) && (i = i.substr(1)), i.length > 0)
    for (let e = k_.length - 1; e >= 0; e--) {
      const t = k_[e];
      if (!t.firstline)
        continue;
      const n = i.match(t.firstline);
      if (n && n.length > 0)
        return t;
    }
}
const pD = Object.prototype.hasOwnProperty, zQ = "vs.editor.nullLanguage";
class pje {
  constructor() {
    this._languageIdToLanguage = [], this._languageToLanguageId = /* @__PURE__ */ new Map(), this._register(
      zQ,
      0
      /* LanguageId.Null */
    ), this._register(
      Fa,
      1
      /* LanguageId.PlainText */
    ), this._nextLanguageId = 2;
  }
  _register(e, t) {
    this._languageIdToLanguage[t] = e, this._languageToLanguageId.set(e, t);
  }
  register(e) {
    if (this._languageToLanguageId.has(e))
      return;
    const t = this._nextLanguageId++;
    this._register(e, t);
  }
  encodeLanguageId(e) {
    return this._languageToLanguageId.get(e) || 0;
  }
  decodeLanguageId(e) {
    return this._languageIdToLanguage[e] || zQ;
  }
}
class sw extends we {
  constructor(e = !0, t = !1) {
    super(), this._onDidChange = this._register(new pe()), this.onDidChange = this._onDidChange.event, sw.instanceCount++, this._warnOnOverwrite = t, this.languageIdCodec = new pje(), this._dynamicLanguages = [], this._languages = {}, this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, e && (this._initializeFromRegistry(), this._register(m_.onDidChangeLanguages((n) => {
      this._initializeFromRegistry();
    })));
  }
  dispose() {
    sw.instanceCount--, super.dispose();
  }
  _initializeFromRegistry() {
    this._languages = {}, this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, uje();
    const e = [].concat(m_.getLanguages()).concat(this._dynamicLanguages);
    this._registerLanguages(e);
  }
  _registerLanguages(e) {
    for (const t of e)
      this._registerLanguage(t);
    this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, Object.keys(this._languages).forEach((t) => {
      const n = this._languages[t];
      n.name && (this._nameMap[n.name] = n.identifier), n.aliases.forEach((r) => {
        this._lowercaseNameMap[r.toLowerCase()] = n.identifier;
      }), n.mimetypes.forEach((r) => {
        this._mimeTypesMap[r] = n.identifier;
      });
    }), Di.as(_d.Configuration).registerOverrideIdentifiers(this.getRegisteredLanguageIds()), this._onDidChange.fire();
  }
  _registerLanguage(e) {
    const t = e.id;
    let n;
    pD.call(this._languages, t) ? n = this._languages[t] : (this.languageIdCodec.register(t), n = {
      identifier: t,
      name: null,
      mimetypes: [],
      aliases: [],
      extensions: [],
      filenames: [],
      configurationFiles: [],
      icons: []
    }, this._languages[t] = n), this._mergeLanguage(n, e);
  }
  _mergeLanguage(e, t) {
    const n = t.id;
    let r = null;
    if (Array.isArray(t.mimetypes) && t.mimetypes.length > 0 && (e.mimetypes.push(...t.mimetypes), r = t.mimetypes[0]), r || (r = `text/x-${n}`, e.mimetypes.push(r)), Array.isArray(t.extensions)) {
      t.configuration ? e.extensions = t.extensions.concat(e.extensions) : e.extensions = e.extensions.concat(t.extensions);
      for (const a of t.extensions)
        gD({ id: n, mime: r, extension: a }, this._warnOnOverwrite);
    }
    if (Array.isArray(t.filenames))
      for (const a of t.filenames)
        gD({ id: n, mime: r, filename: a }, this._warnOnOverwrite), e.filenames.push(a);
    if (Array.isArray(t.filenamePatterns))
      for (const a of t.filenamePatterns)
        gD({ id: n, mime: r, filepattern: a }, this._warnOnOverwrite);
    if (typeof t.firstLine == "string" && t.firstLine.length > 0) {
      let a = t.firstLine;
      a.charAt(0) !== "^" && (a = "^" + a);
      try {
        const l = new RegExp(a);
        vNe(l) || gD({ id: n, mime: r, firstline: l }, this._warnOnOverwrite);
      } catch (l) {
        console.warn(`[${t.id}]: Invalid regular expression \`${a}\`: `, l);
      }
    }
    e.aliases.push(n);
    let s = null;
    if (typeof t.aliases < "u" && Array.isArray(t.aliases) && (t.aliases.length === 0 ? s = [null] : s = t.aliases), s !== null)
      for (const a of s)
        !a || a.length === 0 || e.aliases.push(a);
    const o = s !== null && s.length > 0;
    if (!(o && s[0] === null)) {
      const a = (o ? s[0] : null) || n;
      (o || !e.name) && (e.name = a);
    }
    t.configuration && e.configurationFiles.push(t.configuration), t.icon && e.icons.push(t.icon);
  }
  isRegisteredLanguageId(e) {
    return e ? pD.call(this._languages, e) : !1;
  }
  getRegisteredLanguageIds() {
    return Object.keys(this._languages);
  }
  getLanguageIdByLanguageName(e) {
    const t = e.toLowerCase();
    return pD.call(this._lowercaseNameMap, t) ? this._lowercaseNameMap[t] : null;
  }
  getLanguageIdByMimeType(e) {
    return e && pD.call(this._mimeTypesMap, e) ? this._mimeTypesMap[e] : null;
  }
  guessLanguageIdByFilepathOrFirstLine(e, t) {
    return !e && !t ? [] : hje(e, t);
  }
}
sw.instanceCount = 0;
class ow extends we {
  constructor(e = !1) {
    super(), this._onDidRequestBasicLanguageFeatures = this._register(new pe()), this.onDidRequestBasicLanguageFeatures = this._onDidRequestBasicLanguageFeatures.event, this._onDidRequestRichLanguageFeatures = this._register(new pe()), this.onDidRequestRichLanguageFeatures = this._onDidRequestRichLanguageFeatures.event, this._onDidChange = this._register(new pe({
      leakWarningThreshold: 200
      /* https://github.com/microsoft/vscode/issues/119968 */
    })), this.onDidChange = this._onDidChange.event, this._requestedBasicLanguages = /* @__PURE__ */ new Set(), this._requestedRichLanguages = /* @__PURE__ */ new Set(), ow.instanceCount++, this._registry = this._register(new sw(!0, e)), this.languageIdCodec = this._registry.languageIdCodec, this._register(this._registry.onDidChange(() => this._onDidChange.fire()));
  }
  dispose() {
    ow.instanceCount--, super.dispose();
  }
  isRegisteredLanguageId(e) {
    return this._registry.isRegisteredLanguageId(e);
  }
  getLanguageIdByLanguageName(e) {
    return this._registry.getLanguageIdByLanguageName(e);
  }
  getLanguageIdByMimeType(e) {
    return this._registry.getLanguageIdByMimeType(e);
  }
  guessLanguageIdByFilepathOrFirstLine(e, t) {
    const n = this._registry.guessLanguageIdByFilepathOrFirstLine(e, t);
    return Nue(n, null);
  }
  createById(e) {
    return new UQ(this.onDidChange, () => this._createAndGetLanguageIdentifier(e));
  }
  createByFilepathOrFirstLine(e, t) {
    return new UQ(this.onDidChange, () => {
      const n = this.guessLanguageIdByFilepathOrFirstLine(e, t);
      return this._createAndGetLanguageIdentifier(n);
    });
  }
  _createAndGetLanguageIdentifier(e) {
    return (!e || !this.isRegisteredLanguageId(e)) && (e = Fa), e;
  }
  requestBasicLanguageFeatures(e) {
    this._requestedBasicLanguages.has(e) || (this._requestedBasicLanguages.add(e), this._onDidRequestBasicLanguageFeatures.fire(e));
  }
  requestRichLanguageFeatures(e) {
    this._requestedRichLanguages.has(e) || (this._requestedRichLanguages.add(e), this.requestBasicLanguageFeatures(e), Pi.getOrCreate(e), this._onDidRequestRichLanguageFeatures.fire(e));
  }
}
ow.instanceCount = 0;
class UQ {
  constructor(e, t) {
    this._onDidChangeLanguages = e, this._selector = t, this._listener = null, this._emitter = null, this.languageId = this._selector();
  }
  _dispose() {
    this._listener && (this._listener.dispose(), this._listener = null), this._emitter && (this._emitter.dispose(), this._emitter = null);
  }
  get onDidChange() {
    return this._listener || (this._listener = this._onDidChangeLanguages(() => this._evaluate())), this._emitter || (this._emitter = new pe({
      onDidRemoveLastListener: () => {
        this._dispose();
      }
    })), this._emitter.event;
  }
  _evaluate() {
    var e;
    const t = this._selector();
    t !== this.languageId && (this.languageId = t, (e = this._emitter) === null || e === void 0 || e.fire(this.languageId));
  }
}
const aw = {
  /**
   * Application specific resource transfer type
   */
  RESOURCES: "ResourceURLs",
  /**
   * Browser specific transfer type to download
   */
  DOWNLOAD_URL: "DownloadURL",
  /**
   * Browser specific transfer type for files
   */
  FILES: "Files",
  /**
   * Typically transfer type for copy/paste transfers.
   */
  TEXT: Zi.text,
  /**
   * Internal type used to pass around text/uri-list data.
   *
   * This is needed to work around https://bugs.chromium.org/p/chromium/issues/detail?id=239745.
   */
  INTERNAL_URI_LIST: "application/vnd.code.uri-list"
};
function Jz(...i) {
  return function(e, t) {
    for (let n = 0, r = i.length; n < r; n++) {
      const s = i[n](e, t);
      if (s)
        return s;
    }
    return null;
  };
}
epe.bind(void 0, !1);
const lw = epe.bind(void 0, !0);
function epe(i, e, t) {
  if (!t || t.length < e.length)
    return null;
  let n;
  return i ? n = Bj(t, e) : n = t.indexOf(e) === 0, n ? e.length > 0 ? [{ start: 0, end: e.length }] : [] : null;
}
function tpe(i, e) {
  const t = e.toLowerCase().indexOf(i.toLowerCase());
  return t === -1 ? null : [{ start: t, end: t + i.length }];
}
function npe(i, e) {
  return fB(i.toLowerCase(), e.toLowerCase(), 0, 0);
}
function fB(i, e, t, n) {
  if (t === i.length)
    return [];
  if (n === e.length)
    return null;
  if (i[t] === e[n]) {
    let r = null;
    return (r = fB(i, e, t + 1, n + 1)) ? tU({ start: n, end: n + 1 }, r) : null;
  }
  return fB(i, e, t, n + 1);
}
function $z(i) {
  return 97 <= i && i <= 122;
}
function P4(i) {
  return 65 <= i && i <= 90;
}
function eU(i) {
  return 48 <= i && i <= 57;
}
function ipe(i) {
  return i === 32 || i === 9 || i === 10 || i === 13;
}
const rpe = /* @__PURE__ */ new Set();
"()[]{}<>`'\"-/;:,.?!".split("").forEach((i) => rpe.add(i.charCodeAt(0)));
function RL(i) {
  return ipe(i) || rpe.has(i);
}
function mje(i, e) {
  return i === e || RL(i) && RL(e);
}
function spe(i) {
  return $z(i) || P4(i) || eU(i);
}
function tU(i, e) {
  return e.length === 0 ? e = [i] : i.end === e[0].start ? e[0].start = i.start : e.unshift(i), e;
}
function ope(i, e) {
  for (let t = e; t < i.length; t++) {
    const n = i.charCodeAt(t);
    if (P4(n) || eU(n) || t > 0 && !spe(i.charCodeAt(t - 1)))
      return t;
  }
  return i.length;
}
function gB(i, e, t, n) {
  if (t === i.length)
    return [];
  if (n === e.length)
    return null;
  if (i[t] !== e[n].toLowerCase())
    return null;
  {
    let r = null, s = n + 1;
    for (r = gB(i, e, t + 1, n + 1); !r && (s = ope(e, s)) < e.length; )
      r = gB(i, e, t + 1, s), s++;
    return r === null ? null : tU({ start: n, end: n + 1 }, r);
  }
}
function vje(i) {
  let e = 0, t = 0, n = 0, r = 0, s = 0;
  for (let d = 0; d < i.length; d++)
    s = i.charCodeAt(d), P4(s) && e++, $z(s) && t++, spe(s) && n++, eU(s) && r++;
  const o = e / i.length, a = t / i.length, l = n / i.length, c = r / i.length;
  return { upperPercent: o, lowerPercent: a, alphaPercent: l, numericPercent: c };
}
function _je(i) {
  const { upperPercent: e, lowerPercent: t } = i;
  return t === 0 && e > 0.6;
}
function bje(i) {
  const { upperPercent: e, lowerPercent: t, alphaPercent: n, numericPercent: r } = i;
  return t > 0.2 && e < 0.8 && n > 0.6 && r < 0.2;
}
function Cje(i) {
  let e = 0, t = 0, n = 0, r = 0;
  for (let s = 0; s < i.length; s++)
    n = i.charCodeAt(s), P4(n) && e++, $z(n) && t++, ipe(n) && r++;
  return (e === 0 || t === 0) && r === 0 ? i.length <= 30 : e <= 5;
}
function ape(i, e) {
  if (!e || (e = e.trim(), e.length === 0) || !Cje(i) || e.length > 60)
    return null;
  const t = vje(e);
  if (!bje(t)) {
    if (!_je(t))
      return null;
    e = e.toLowerCase();
  }
  let n = null, r = 0;
  for (i = i.toLowerCase(); r < e.length && (n = gB(i, e, 0, r)) === null; )
    r = ope(e, r + 1);
  return n;
}
function yje(i, e, t = !1) {
  if (!e || e.length === 0)
    return null;
  let n = null, r = 0;
  for (i = i.toLowerCase(), e = e.toLowerCase(); r < e.length && (n = pB(i, e, 0, r, t)) === null; )
    r = lpe(e, r + 1);
  return n;
}
function pB(i, e, t, n, r) {
  if (t === i.length)
    return [];
  if (n === e.length)
    return null;
  if (mje(i.charCodeAt(t), e.charCodeAt(n))) {
    let s = null, o = n + 1;
    if (s = pB(i, e, t + 1, n + 1, r), !r)
      for (; !s && (o = lpe(e, o)) < e.length; )
        s = pB(i, e, t + 1, o, r), o++;
    return s ? i.charCodeAt(t) !== e.charCodeAt(n) ? s : tU({ start: n, end: n + 1 }, s) : null;
  } else
    return null;
}
function lpe(i, e) {
  for (let t = e; t < i.length; t++)
    if (RL(i.charCodeAt(t)) || t > 0 && RL(i.charCodeAt(t - 1)))
      return t;
  return i.length;
}
const wje = Jz(lw, ape, tpe), Sje = Jz(lw, ape, npe), GQ = new cp(1e4);
function qQ(i, e, t = !1) {
  if (typeof i != "string" || typeof e != "string")
    return null;
  let n = GQ.get(i);
  n || (n = new RegExp(pNe(i), "i"), GQ.set(i, n));
  const r = n.exec(e);
  return r ? [{ start: r.index, end: r.index + r[0].length }] : t ? Sje(i, e) : wje(i, e);
}
function xje(i, e) {
  const t = Jm(i, i.toLowerCase(), 0, e, e.toLowerCase(), 0, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
  return t ? BS(t) : null;
}
function Dje(i, e, t, n, r, s) {
  const o = Math.min(13, i.length);
  for (; t < o; t++) {
    const a = Jm(i, e, t, n, r, s, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
    if (a)
      return a;
  }
  return [0, s];
}
function BS(i) {
  if (typeof i > "u")
    return [];
  const e = [], t = i[1];
  for (let n = i.length - 1; n > 1; n--) {
    const r = i[n] + t, s = e[e.length - 1];
    s && s.end === r ? s.end = r + 1 : e.push({ start: r, end: r + 1 });
  }
  return e;
}
const ig = 128;
function nU() {
  const i = [], e = [];
  for (let t = 0; t <= ig; t++)
    e[t] = 0;
  for (let t = 0; t <= ig; t++)
    i.push(e.slice(0));
  return i;
}
function cpe(i) {
  const e = [];
  for (let t = 0; t <= i; t++)
    e[t] = 0;
  return e;
}
const dpe = cpe(2 * ig), mB = cpe(2 * ig), Uu = nU(), xp = nU(), mD = nU();
function vD(i, e) {
  if (e < 0 || e >= i.length)
    return !1;
  const t = i.codePointAt(e);
  switch (t) {
    case 95:
    case 45:
    case 46:
    case 32:
    case 47:
    case 92:
    case 39:
    case 34:
    case 58:
    case 36:
    case 60:
    case 62:
    case 40:
    case 41:
    case 91:
    case 93:
    case 123:
    case 125:
      return !0;
    case void 0:
      return !1;
    default:
      return !!jj(t);
  }
}
function KQ(i, e) {
  if (e < 0 || e >= i.length)
    return !1;
  switch (i.charCodeAt(e)) {
    case 32:
    case 9:
      return !0;
    default:
      return !1;
  }
}
function Y3(i, e, t) {
  return e[i] !== t[i];
}
function Eje(i, e, t, n, r, s, o = !1) {
  for (; e < t && r < s; )
    i[e] === n[r] && (o && (dpe[e] = r), e += 1), r += 1;
  return e === t;
}
var td;
(function(i) {
  i.Default = [-100, 0];
  function e(t) {
    return !t || t.length === 2 && t[0] === -100 && t[1] === 0;
  }
  i.isDefault = e;
})(td || (td = {}));
class O4 {
  constructor(e, t) {
    this.firstMatchCanBeWeak = e, this.boostFullMatch = t;
  }
}
O4.default = { boostFullMatch: !0, firstMatchCanBeWeak: !1 };
function Jm(i, e, t, n, r, s, o = O4.default) {
  const a = i.length > ig ? ig : i.length, l = n.length > ig ? ig : n.length;
  if (t >= a || s >= l || a - t > l - s || !Eje(e, t, a, r, s, l, !0))
    return;
  Lje(a, l, t, s, e, r);
  let c = 1, d = 1, u = t, h = s;
  const f = [!1];
  for (c = 1, u = t; u < a; c++, u++) {
    const b = dpe[u], w = mB[u], y = u + 1 < a ? mB[u + 1] : l;
    for (d = b - s + 1, h = b; h < y; d++, h++) {
      let S = Number.MIN_SAFE_INTEGER, x = !1;
      h <= w && (S = Ije(i, e, u, t, n, r, h, l, s, Uu[c - 1][d - 1] === 0, f));
      let D = 0;
      S !== Number.MAX_SAFE_INTEGER && (x = !0, D = S + xp[c - 1][d - 1]);
      const E = h > b, L = E ? xp[c][d - 1] + (Uu[c][d - 1] > 0 ? -5 : 0) : 0, k = h > b + 1 && Uu[c][d - 1] > 0, N = k ? xp[c][d - 2] + (Uu[c][d - 2] > 0 ? -5 : 0) : 0;
      if (k && (!E || N >= L) && (!x || N >= D))
        xp[c][d] = N, mD[c][d] = 3, Uu[c][d] = 0;
      else if (E && (!x || L >= D))
        xp[c][d] = L, mD[c][d] = 2, Uu[c][d] = 0;
      else if (x)
        xp[c][d] = D, mD[c][d] = 1, Uu[c][d] = Uu[c - 1][d - 1] + 1;
      else
        throw new Error("not possible");
    }
  }
  if (!f[0] && !o.firstMatchCanBeWeak)
    return;
  c--, d--;
  const g = [xp[c][d], s];
  let p = 0, m = 0;
  for (; c >= 1; ) {
    let b = d;
    do {
      const w = mD[c][b];
      if (w === 3)
        b = b - 2;
      else if (w === 2)
        b = b - 1;
      else
        break;
    } while (b >= 1);
    p > 1 && e[t + c - 1] === r[s + d - 1] && !Y3(b + s - 1, n, r) && p + 1 > Uu[c][b] && (b = d), b === d ? p++ : p = 1, m || (m = b), c--, d = b - 1, g.push(d);
  }
  l === a && o.boostFullMatch && (g[0] += 2);
  const _ = m - a;
  return g[0] -= _, g;
}
function Lje(i, e, t, n, r, s) {
  let o = i - 1, a = e - 1;
  for (; o >= t && a >= n; )
    r[o] === s[a] && (mB[o] = a, o--), a--;
}
function Ije(i, e, t, n, r, s, o, a, l, c, d) {
  if (e[t] !== s[o])
    return Number.MIN_SAFE_INTEGER;
  let u = 1, h = !1;
  return o === t - n ? u = i[t] === r[o] ? 7 : 5 : Y3(o, r, s) && (o === 0 || !Y3(o - 1, r, s)) ? (u = i[t] === r[o] ? 7 : 5, h = !0) : vD(s, o) && (o === 0 || !vD(s, o - 1)) ? u = 5 : (vD(s, o - 1) || KQ(s, o - 1)) && (u = 5, h = !0), u > 1 && t === n && (d[0] = !0), h || (h = Y3(o, r, s) || vD(s, o - 1) || KQ(s, o - 1)), t === n ? o > l && (u -= h ? 3 : 5) : c ? u += h ? 2 : 0 : u += h ? 0 : 1, o + 1 === a && (u -= h ? 3 : 5), u;
}
function Aje(i, e, t, n, r, s, o) {
  return kje(i, e, t, n, r, s, !0, o);
}
function kje(i, e, t, n, r, s, o, a) {
  let l = Jm(i, e, t, n, r, s, a);
  if (l && !o)
    return l;
  if (i.length >= 3) {
    const c = Math.min(7, i.length - 1);
    for (let d = t + 1; d < c; d++) {
      const u = Tje(i, d);
      if (u) {
        const h = Jm(u, u.toLowerCase(), t, n, r, s, a);
        h && (h[0] -= 3, (!l || h[0] > l[0]) && (l = h));
      }
    }
  }
  return l;
}
function Tje(i, e) {
  if (e + 1 >= i.length)
    return;
  const t = i[e], n = i[e + 1];
  if (t !== n)
    return i.slice(0, e) + n + t + i.slice(e + 2);
}
const Nje = "$(", iU = new RegExp(`\\$\\(${ft.iconNameExpression}(?:${ft.iconModifierExpression})?\\)`, "g"), Pje = new RegExp(`(\\\\)?${iU.source}`, "g");
function Oje(i) {
  return i.replace(Pje, (e, t) => t ? e : `\\${e}`);
}
const Mje = new RegExp(`\\\\${iU.source}`, "g");
function Rje(i) {
  return i.replace(Mje, (e) => `\\${e}`);
}
const Fje = new RegExp(`(\\s)?(\\\\)?${iU.source}(\\s)?`, "g");
function rU(i) {
  return i.indexOf(Nje) === -1 ? i : i.replace(Fje, (e, t, n, r) => n ? e : t || r || "");
}
function Bje(i) {
  return i ? i.replace(/\$\((.*?)\)/g, (e, t) => ` ${t} `).trim() : "";
}
const eT = new RegExp(`\\$\\(${ft.iconNameCharacter}+\\)`, "g");
function tC(i) {
  eT.lastIndex = 0;
  let e = "";
  const t = [];
  let n = 0;
  for (; ; ) {
    const r = eT.lastIndex, s = eT.exec(i), o = i.substring(r, s?.index);
    if (o.length > 0) {
      e += o;
      for (let a = 0; a < o.length; a++)
        t.push(n);
    }
    if (!s)
      break;
    n += s[0].length;
  }
  return { text: e, iconOffsets: t };
}
function tT(i, e, t = !1) {
  const { text: n, iconOffsets: r } = e;
  if (!r || r.length === 0)
    return qQ(i, n, t);
  const s = bS(n, " "), o = n.length - s.length, a = qQ(i, s, t);
  if (a)
    for (const l of a) {
      const c = r[l.start + o] + o;
      l.start += c, l.end += c;
    }
  return a;
}
class ys {
  constructor(e = "", t = !1) {
    var n, r, s;
    if (this.value = e, typeof this.value != "string")
      throw fl("value");
    typeof t == "boolean" ? (this.isTrusted = t, this.supportThemeIcons = !1, this.supportHtml = !1) : (this.isTrusted = (n = t.isTrusted) !== null && n !== void 0 ? n : void 0, this.supportThemeIcons = (r = t.supportThemeIcons) !== null && r !== void 0 ? r : !1, this.supportHtml = (s = t.supportHtml) !== null && s !== void 0 ? s : !1);
  }
  appendText(e, t = 0) {
    return this.value += Hje(this.supportThemeIcons ? Oje(e) : e).replace(/([ \t]+)/g, (n, r) => "&nbsp;".repeat(r.length)).replace(/\>/gm, "\\>").replace(/\n/g, t === 1 ? `\\
` : `

`), this;
  }
  appendMarkdown(e) {
    return this.value += e, this;
  }
  appendCodeblock(e, t) {
    return this.value += "\n```", this.value += e, this.value += `
`, this.value += t, this.value += "\n```\n", this;
  }
  appendLink(e, t, n) {
    return this.value += "[", this.value += this._escape(t, "]"), this.value += "](", this.value += this._escape(String(e), ")"), n && (this.value += ` "${this._escape(this._escape(n, '"'), ")")}"`), this.value += ")", this;
  }
  _escape(e, t) {
    const n = new RegExp(Va(t), "g");
    return e.replace(n, (r, s) => e.charAt(s - 1) !== "\\" ? `\\${r}` : r);
  }
}
function T_(i) {
  return _g(i) ? !i.value : Array.isArray(i) ? i.every(T_) : !0;
}
function _g(i) {
  return i instanceof ys ? !0 : i && typeof i == "object" ? typeof i.value == "string" && (typeof i.isTrusted == "boolean" || typeof i.isTrusted == "object" || i.isTrusted === void 0) && (typeof i.supportThemeIcons == "boolean" || i.supportThemeIcons === void 0) : !1;
}
function Vje(i, e) {
  return i === e ? !0 : !i || !e ? !1 : i.value === e.value && i.isTrusted === e.isTrusted && i.supportThemeIcons === e.supportThemeIcons && i.supportHtml === e.supportHtml && (i.baseUri === e.baseUri || !!i.baseUri && !!e.baseUri && Tz(pt.from(i.baseUri), pt.from(e.baseUri)));
}
function Hje(i) {
  return i.replace(/[\\`*_{}[\]()#+\-!~]/g, "\\$&");
}
function _D(i) {
  return i.replace(/"/g, "&quot;");
}
function nT(i) {
  return i && i.replace(/\\([\\`*_{}[\]()#+\-.!~])/g, "$1");
}
function Wje(i) {
  const e = [], t = i.split("|").map((r) => r.trim());
  i = t[0];
  const n = t[1];
  if (n) {
    const r = /height=(\d+)/.exec(n), s = /width=(\d+)/.exec(n), o = r ? r[1] : "", a = s ? s[1] : "", l = isFinite(parseInt(a)), c = isFinite(parseInt(o));
    l && e.push(`width="${a}"`), c && e.push(`height="${o}"`);
  }
  return { href: i, dimensions: e };
}
var vB = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function jje(i, e) {
  mo(e) ? i.title = rU(e) : e?.markdownNotSupportedFallback ? i.title = e.markdownNotSupportedFallback : i.removeAttribute("title");
}
class zje {
  constructor(e, t, n) {
    this.hoverDelegate = e, this.target = t, this.fadeInAnimation = n;
  }
  update(e, t, n) {
    var r;
    return vB(this, void 0, void 0, function* () {
      if (this._cancellationTokenSource && (this._cancellationTokenSource.dispose(!0), this._cancellationTokenSource = void 0), this.isDisposed)
        return;
      let s;
      if (e === void 0 || mo(e) || e instanceof HTMLElement)
        s = e;
      else if (!Cy(e.markdown))
        s = (r = e.markdown) !== null && r !== void 0 ? r : e.markdownNotSupportedFallback;
      else {
        this._hoverWidget || this.show(C("iconLabel.loading", "Loading..."), t), this._cancellationTokenSource = new lr();
        const o = this._cancellationTokenSource.token;
        if (s = yield e.markdown(o), s === void 0 && (s = e.markdownNotSupportedFallback), this.isDisposed || o.isCancellationRequested)
          return;
      }
      this.show(s, t, n);
    });
  }
  show(e, t, n) {
    const r = this._hoverWidget;
    if (this.hasContent(e)) {
      const s = Object.assign({ content: e, target: this.target, showPointer: this.hoverDelegate.placement === "element", hoverPosition: 2, skipFadeInAnimation: !this.fadeInAnimation || !!r }, n);
      this._hoverWidget = this.hoverDelegate.showHover(s, t);
    }
    r?.dispose();
  }
  hasContent(e) {
    return e ? _g(e) ? !!e.value : !0 : !1;
  }
  get isDisposed() {
    var e;
    return (e = this._hoverWidget) === null || e === void 0 ? void 0 : e.isDisposed;
  }
  dispose() {
    var e, t;
    (e = this._hoverWidget) === null || e === void 0 || e.dispose(), (t = this._cancellationTokenSource) === null || t === void 0 || t.dispose(!0), this._cancellationTokenSource = void 0;
  }
}
function upe(i, e, t, n) {
  let r, s;
  const o = (u, h) => {
    var f;
    const g = s !== void 0;
    u && (s?.dispose(), s = void 0), h && (r?.dispose(), r = void 0), g && ((f = i.onDidHideHover) === null || f === void 0 || f.call(i));
  }, a = (u, h, f) => new uc(() => vB(this, void 0, void 0, function* () {
    (!s || s.isDisposed) && (s = new zje(i, f || e, u > 0), yield s.update(t, h, n));
  }), u), l = () => {
    if (r)
      return;
    const u = new Ne(), h = (p) => o(!1, p.fromElement === e);
    u.add(Ie(e, Ge.MOUSE_LEAVE, h, !0));
    const f = () => o(!0, !0);
    u.add(Ie(e, Ge.MOUSE_DOWN, f, !0));
    const g = {
      targetElements: [e],
      dispose: () => {
      }
    };
    if (i.placement === void 0 || i.placement === "mouse") {
      const p = (m) => {
        g.x = m.x + 10, m.target instanceof HTMLElement && m.target.classList.contains("action-label") && o(!0, !0);
      };
      u.add(Ie(e, Ge.MOUSE_MOVE, p, !0));
    }
    u.add(a(i.delay, !1, g)), r = u;
  }, c = Ie(e, Ge.MOUSE_OVER, l, !0);
  return {
    show: (u) => {
      o(!1, !0), a(0, u);
    },
    hide: () => {
      o(!0, !0);
    },
    update: (u, h) => vB(this, void 0, void 0, function* () {
      t = u, yield s?.update(t, void 0, h);
    }),
    dispose: () => {
      c.dispose(), o(!0, !0);
    }
  };
}
function Uje(i, e = {}) {
  const t = sU(e);
  return t.textContent = i, t;
}
function Gje(i, e = {}) {
  const t = sU(e);
  return hpe(t, Kje(i, !!e.renderCodeSegments), e.actionHandler, e.renderCodeSegments), t;
}
function sU(i) {
  const e = i.inline ? "span" : "div", t = document.createElement(e);
  return i.className && (t.className = i.className), t;
}
class qje {
  constructor(e) {
    this.source = e, this.index = 0;
  }
  eos() {
    return this.index >= this.source.length;
  }
  next() {
    const e = this.peek();
    return this.advance(), e;
  }
  peek() {
    return this.source[this.index];
  }
  advance() {
    this.index++;
  }
}
function hpe(i, e, t, n) {
  let r;
  if (e.type === 2)
    r = document.createTextNode(e.content || "");
  else if (e.type === 3)
    r = document.createElement("b");
  else if (e.type === 4)
    r = document.createElement("i");
  else if (e.type === 7 && n)
    r = document.createElement("code");
  else if (e.type === 5 && t) {
    const s = document.createElement("a");
    t.disposables.add(ar(s, "click", (o) => {
      t.callback(String(e.index), o);
    })), r = s;
  } else e.type === 8 ? r = document.createElement("br") : e.type === 1 && (r = i);
  r && i !== r && i.appendChild(r), r && Array.isArray(e.children) && e.children.forEach((s) => {
    hpe(r, s, t, n);
  });
}
function Kje(i, e) {
  const t = {
    type: 1,
    children: []
  };
  let n = 0, r = t;
  const s = [], o = new qje(i);
  for (; !o.eos(); ) {
    let a = o.next();
    const l = a === "\\" && _B(o.peek(), e) !== 0;
    if (l && (a = o.next()), !l && Yje(a, e) && a === o.peek()) {
      o.advance(), r.type === 2 && (r = s.pop());
      const c = _B(a, e);
      if (r.type === c || r.type === 5 && c === 6)
        r = s.pop();
      else {
        const d = {
          type: c,
          children: []
        };
        c === 5 && (d.index = n, n++), r.children.push(d), s.push(r), r = d;
      }
    } else if (a === `
`)
      r.type === 2 && (r = s.pop()), r.children.push({
        type: 8
        /* FormatType.NewLine */
      });
    else if (r.type !== 2) {
      const c = {
        type: 2,
        content: a
      };
      r.children.push(c), s.push(r), r = c;
    } else
      r.content += a;
  }
  return r.type === 2 && (r = s.pop()), t;
}
function Yje(i, e) {
  return _B(i, e) !== 0;
}
function _B(i, e) {
  switch (i) {
    case "*":
      return 3;
    case "_":
      return 4;
    case "[":
      return 5;
    case "]":
      return 6;
    case "`":
      return e ? 7 : 0;
    default:
      return 0;
  }
}
const Xje = new RegExp(`(\\\\)?\\$\\((${ft.iconNameExpression}(?:${ft.iconModifierExpression})?)\\)`, "g");
function bg(i) {
  const e = new Array();
  let t, n = 0, r = 0;
  for (; (t = Xje.exec(i)) !== null; ) {
    r = t.index || 0, n < r && e.push(i.substring(n, r)), n = (t.index || 0) + t[0].length;
    const [, s, o] = t;
    e.push(s ? `$(${o})` : bB({ id: o }));
  }
  return n < i.length && e.push(i.substring(n)), e;
}
function bB(i) {
  const e = Re("span");
  return e.classList.add(...ft.asClassNameArray(i)), e;
}
class oU {
  constructor(e) {
    this._prefix = e, this._lastId = 0;
  }
  nextId() {
    return this._prefix + ++this._lastId;
  }
}
const CB = new oU("id#");
let Co = {};
(function() {
  function i(e, t) {
    t(Co);
  }
  i.amd = !0, function(e, t) {
    typeof i == "function" && i.amd ? i(["exports"], t) : typeof exports == "object" && typeof module < "u" ? t(exports) : (e = typeof globalThis < "u" ? globalThis : e || self, t(e.marked = {}));
  }(this, function(e) {
    function t(de, ce) {
      for (var ie = 0; ie < ce.length; ie++) {
        var H = ce[ie];
        H.enumerable = H.enumerable || !1, H.configurable = !0, "value" in H && (H.writable = !0), Object.defineProperty(de, H.key, H);
      }
    }
    function n(de, ce, ie) {
      return ie && t(de, ie), Object.defineProperty(de, "prototype", {
        writable: !1
      }), de;
    }
    function r(de, ce) {
      if (de) {
        if (typeof de == "string") return s(de, ce);
        var ie = Object.prototype.toString.call(de).slice(8, -1);
        if (ie === "Object" && de.constructor && (ie = de.constructor.name), ie === "Map" || ie === "Set") return Array.from(de);
        if (ie === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ie)) return s(de, ce);
      }
    }
    function s(de, ce) {
      (ce == null || ce > de.length) && (ce = de.length);
      for (var ie = 0, H = new Array(ce); ie < ce; ie++) H[ie] = de[ie];
      return H;
    }
    function o(de, ce) {
      var ie = typeof Symbol < "u" && de[Symbol.iterator] || de["@@iterator"];
      if (ie) return (ie = ie.call(de)).next.bind(ie);
      if (Array.isArray(de) || (ie = r(de)) || ce) {
        ie && (de = ie);
        var H = 0;
        return function() {
          return H >= de.length ? {
            done: !0
          } : {
            done: !1,
            value: de[H++]
          };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function a() {
      return {
        async: !1,
        baseUrl: null,
        breaks: !1,
        extensions: null,
        gfm: !0,
        headerIds: !0,
        headerPrefix: "",
        highlight: null,
        langPrefix: "language-",
        mangle: !0,
        pedantic: !1,
        renderer: null,
        sanitize: !1,
        sanitizer: null,
        silent: !1,
        smartLists: !1,
        smartypants: !1,
        tokenizer: null,
        walkTokens: null,
        xhtml: !1
      };
    }
    e.defaults = a();
    function l(de) {
      e.defaults = de;
    }
    var c = /[&<>"']/, d = /[&<>"']/g, u = /[<>"']|&(?!#?\w+;)/, h = /[<>"']|&(?!#?\w+;)/g, f = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, g = function(ce) {
      return f[ce];
    };
    function p(de, ce) {
      if (ce) {
        if (c.test(de))
          return de.replace(d, g);
      } else if (u.test(de))
        return de.replace(h, g);
      return de;
    }
    var m = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    function _(de) {
      return de.replace(m, function(ce, ie) {
        return ie = ie.toLowerCase(), ie === "colon" ? ":" : ie.charAt(0) === "#" ? ie.charAt(1) === "x" ? String.fromCharCode(parseInt(ie.substring(2), 16)) : String.fromCharCode(+ie.substring(1)) : "";
      });
    }
    var b = /(^|[^\[])\^/g;
    function w(de, ce) {
      de = typeof de == "string" ? de : de.source, ce = ce || "";
      var ie = {
        replace: function(Y, Z) {
          return Z = Z.source || Z, Z = Z.replace(b, "$1"), de = de.replace(Y, Z), ie;
        },
        getRegex: function() {
          return new RegExp(de, ce);
        }
      };
      return ie;
    }
    var y = /[^\w:]/g, S = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    function x(de, ce, ie) {
      if (de) {
        var H;
        try {
          H = decodeURIComponent(_(ie)).replace(y, "").toLowerCase();
        } catch {
          return null;
        }
        if (H.indexOf("javascript:") === 0 || H.indexOf("vbscript:") === 0 || H.indexOf("data:") === 0)
          return null;
      }
      ce && !S.test(ie) && (ie = N(ce, ie));
      try {
        ie = encodeURI(ie).replace(/%25/g, "%");
      } catch {
        return null;
      }
      return ie;
    }
    var D = {}, E = /^[^:]+:\/*[^/]*$/, L = /^([^:]+:)[\s\S]*$/, k = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    function N(de, ce) {
      D[" " + de] || (E.test(de) ? D[" " + de] = de + "/" : D[" " + de] = O(de, "/", !0)), de = D[" " + de];
      var ie = de.indexOf(":") === -1;
      return ce.substring(0, 2) === "//" ? ie ? ce : de.replace(L, "$1") + ce : ce.charAt(0) === "/" ? ie ? ce : de.replace(k, "$1") + ce : de + ce;
    }
    var I = {
      exec: function() {
      }
    };
    function A(de) {
      for (var ce = 1, ie, H; ce < arguments.length; ce++) {
        ie = arguments[ce];
        for (H in ie)
          Object.prototype.hasOwnProperty.call(ie, H) && (de[H] = ie[H]);
      }
      return de;
    }
    function P(de, ce) {
      var ie = de.replace(/\|/g, function(Z, Q, me) {
        for (var Le = !1, xe = Q; --xe >= 0 && me[xe] === "\\"; )
          Le = !Le;
        return Le ? "|" : " |";
      }), H = ie.split(/ \|/), Y = 0;
      if (H[0].trim() || H.shift(), H.length > 0 && !H[H.length - 1].trim() && H.pop(), H.length > ce)
        H.splice(ce);
      else
        for (; H.length < ce; )
          H.push("");
      for (; Y < H.length; Y++)
        H[Y] = H[Y].trim().replace(/\\\|/g, "|");
      return H;
    }
    function O(de, ce, ie) {
      var H = de.length;
      if (H === 0)
        return "";
      for (var Y = 0; Y < H; ) {
        var Z = de.charAt(H - Y - 1);
        if (Z === ce && !ie)
          Y++;
        else if (Z !== ce && ie)
          Y++;
        else
          break;
      }
      return de.slice(0, H - Y);
    }
    function K(de, ce) {
      if (de.indexOf(ce[1]) === -1)
        return -1;
      for (var ie = de.length, H = 0, Y = 0; Y < ie; Y++)
        if (de[Y] === "\\")
          Y++;
        else if (de[Y] === ce[0])
          H++;
        else if (de[Y] === ce[1] && (H--, H < 0))
          return Y;
      return -1;
    }
    function W(de) {
      de && de.sanitize && !de.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
    }
    function F(de, ce) {
      if (ce < 1)
        return "";
      for (var ie = ""; ce > 1; )
        ce & 1 && (ie += de), ce >>= 1, de += de;
      return ie + de;
    }
    function q(de, ce, ie, H) {
      var Y = ce.href, Z = ce.title ? p(ce.title) : null, Q = de[1].replace(/\\([\[\]])/g, "$1");
      if (de[0].charAt(0) !== "!") {
        H.state.inLink = !0;
        var me = {
          type: "link",
          raw: ie,
          href: Y,
          title: Z,
          text: Q,
          tokens: H.inlineTokens(Q)
        };
        return H.state.inLink = !1, me;
      }
      return {
        type: "image",
        raw: ie,
        href: Y,
        title: Z,
        text: p(Q)
      };
    }
    function R(de, ce) {
      var ie = de.match(/^(\s+)(?:```)/);
      if (ie === null)
        return ce;
      var H = ie[1];
      return ce.split(`
`).map(function(Y) {
        var Z = Y.match(/^\s+/);
        if (Z === null)
          return Y;
        var Q = Z[0];
        return Q.length >= H.length ? Y.slice(H.length) : Y;
      }).join(`
`);
    }
    var T = /* @__PURE__ */ function() {
      function de(ie) {
        this.options = ie || e.defaults;
      }
      var ce = de.prototype;
      return ce.space = function(H) {
        var Y = this.rules.block.newline.exec(H);
        if (Y && Y[0].length > 0)
          return {
            type: "space",
            raw: Y[0]
          };
      }, ce.code = function(H) {
        var Y = this.rules.block.code.exec(H);
        if (Y) {
          var Z = Y[0].replace(/^ {1,4}/gm, "");
          return {
            type: "code",
            raw: Y[0],
            codeBlockStyle: "indented",
            text: this.options.pedantic ? Z : O(Z, `
`)
          };
        }
      }, ce.fences = function(H) {
        var Y = this.rules.block.fences.exec(H);
        if (Y) {
          var Z = Y[0], Q = R(Z, Y[3] || "");
          return {
            type: "code",
            raw: Z,
            lang: Y[2] ? Y[2].trim() : Y[2],
            text: Q
          };
        }
      }, ce.heading = function(H) {
        var Y = this.rules.block.heading.exec(H);
        if (Y) {
          var Z = Y[2].trim();
          if (/#$/.test(Z)) {
            var Q = O(Z, "#");
            (this.options.pedantic || !Q || / $/.test(Q)) && (Z = Q.trim());
          }
          return {
            type: "heading",
            raw: Y[0],
            depth: Y[1].length,
            text: Z,
            tokens: this.lexer.inline(Z)
          };
        }
      }, ce.hr = function(H) {
        var Y = this.rules.block.hr.exec(H);
        if (Y)
          return {
            type: "hr",
            raw: Y[0]
          };
      }, ce.blockquote = function(H) {
        var Y = this.rules.block.blockquote.exec(H);
        if (Y) {
          var Z = Y[0].replace(/^ *>[ \t]?/gm, "");
          return {
            type: "blockquote",
            raw: Y[0],
            tokens: this.lexer.blockTokens(Z, []),
            text: Z
          };
        }
      }, ce.list = function(H) {
        var Y = this.rules.block.list.exec(H);
        if (Y) {
          var Z, Q, me, Le, xe, Ue, je, Ze, _e, U, fe, Ee, Me = Y[1].trim(), Pe = Me.length > 1, et = {
            type: "list",
            raw: "",
            ordered: Pe,
            start: Pe ? +Me.slice(0, -1) : "",
            loose: !1,
            items: []
          };
          Me = Pe ? "\\d{1,9}\\" + Me.slice(-1) : "\\" + Me, this.options.pedantic && (Me = Pe ? Me : "[*+-]");
          for (var gt = new RegExp("^( {0,3}" + Me + ")((?:[	 ][^\\n]*)?(?:\\n|$))"); H && (Ee = !1, !(!(Y = gt.exec(H)) || this.rules.block.hr.test(H))); ) {
            if (Z = Y[0], H = H.substring(Z.length), Ze = Y[2].split(`
`, 1)[0], _e = H.split(`
`, 1)[0], this.options.pedantic ? (Le = 2, fe = Ze.trimLeft()) : (Le = Y[2].search(/[^ ]/), Le = Le > 4 ? 1 : Le, fe = Ze.slice(Le), Le += Y[1].length), Ue = !1, !Ze && /^ *$/.test(_e) && (Z += _e + `
`, H = H.substring(_e.length + 1), Ee = !0), !Ee)
              for (var Vt = new RegExp("^ {0," + Math.min(3, Le - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))"), Zt = new RegExp("^ {0," + Math.min(3, Le - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)"), St = new RegExp("^ {0," + Math.min(3, Le - 1) + "}(?:```|~~~)"), Ht = new RegExp("^ {0," + Math.min(3, Le - 1) + "}#"); H && (U = H.split(`
`, 1)[0], Ze = U, this.options.pedantic && (Ze = Ze.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !(St.test(Ze) || Ht.test(Ze) || Vt.test(Ze) || Zt.test(H))); ) {
                if (Ze.search(/[^ ]/) >= Le || !Ze.trim())
                  fe += `
` + Ze.slice(Le);
                else if (!Ue)
                  fe += `
` + Ze;
                else
                  break;
                !Ue && !Ze.trim() && (Ue = !0), Z += U + `
`, H = H.substring(U.length + 1);
              }
            et.loose || (je ? et.loose = !0 : /\n *\n *$/.test(Z) && (je = !0)), this.options.gfm && (Q = /^\[[ xX]\] /.exec(fe), Q && (me = Q[0] !== "[ ] ", fe = fe.replace(/^\[[ xX]\] +/, ""))), et.items.push({
              type: "list_item",
              raw: Z,
              task: !!Q,
              checked: me,
              loose: !1,
              text: fe
            }), et.raw += Z;
          }
          et.items[et.items.length - 1].raw = Z.trimRight(), et.items[et.items.length - 1].text = fe.trimRight(), et.raw = et.raw.trimRight();
          var fn = et.items.length;
          for (xe = 0; xe < fn; xe++) {
            this.lexer.state.top = !1, et.items[xe].tokens = this.lexer.blockTokens(et.items[xe].text, []);
            var xn = et.items[xe].tokens.filter(function(Ei) {
              return Ei.type === "space";
            }), rt = xn.every(function(Ei) {
              for (var Nn = Ei.raw.split(""), Gi = 0, Ce = o(Nn), Xe; !(Xe = Ce()).done; ) {
                var nt = Xe.value;
                if (nt === `
` && (Gi += 1), Gi > 1)
                  return !0;
              }
              return !1;
            });
            !et.loose && xn.length && rt && (et.loose = !0, et.items[xe].loose = !0);
          }
          return et;
        }
      }, ce.html = function(H) {
        var Y = this.rules.block.html.exec(H);
        if (Y) {
          var Z = {
            type: "html",
            raw: Y[0],
            pre: !this.options.sanitizer && (Y[1] === "pre" || Y[1] === "script" || Y[1] === "style"),
            text: Y[0]
          };
          if (this.options.sanitize) {
            var Q = this.options.sanitizer ? this.options.sanitizer(Y[0]) : p(Y[0]);
            Z.type = "paragraph", Z.text = Q, Z.tokens = this.lexer.inline(Q);
          }
          return Z;
        }
      }, ce.def = function(H) {
        var Y = this.rules.block.def.exec(H);
        if (Y) {
          Y[3] && (Y[3] = Y[3].substring(1, Y[3].length - 1));
          var Z = Y[1].toLowerCase().replace(/\s+/g, " ");
          return {
            type: "def",
            tag: Z,
            raw: Y[0],
            href: Y[2],
            title: Y[3]
          };
        }
      }, ce.table = function(H) {
        var Y = this.rules.block.table.exec(H);
        if (Y) {
          var Z = {
            type: "table",
            header: P(Y[1]).map(function(je) {
              return {
                text: je
              };
            }),
            align: Y[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
            rows: Y[3] && Y[3].trim() ? Y[3].replace(/\n[ \t]*$/, "").split(`
`) : []
          };
          if (Z.header.length === Z.align.length) {
            Z.raw = Y[0];
            var Q = Z.align.length, me, Le, xe, Ue;
            for (me = 0; me < Q; me++)
              /^ *-+: *$/.test(Z.align[me]) ? Z.align[me] = "right" : /^ *:-+: *$/.test(Z.align[me]) ? Z.align[me] = "center" : /^ *:-+ *$/.test(Z.align[me]) ? Z.align[me] = "left" : Z.align[me] = null;
            for (Q = Z.rows.length, me = 0; me < Q; me++)
              Z.rows[me] = P(Z.rows[me], Z.header.length).map(function(je) {
                return {
                  text: je
                };
              });
            for (Q = Z.header.length, Le = 0; Le < Q; Le++)
              Z.header[Le].tokens = this.lexer.inline(Z.header[Le].text);
            for (Q = Z.rows.length, Le = 0; Le < Q; Le++)
              for (Ue = Z.rows[Le], xe = 0; xe < Ue.length; xe++)
                Ue[xe].tokens = this.lexer.inline(Ue[xe].text);
            return Z;
          }
        }
      }, ce.lheading = function(H) {
        var Y = this.rules.block.lheading.exec(H);
        if (Y)
          return {
            type: "heading",
            raw: Y[0],
            depth: Y[2].charAt(0) === "=" ? 1 : 2,
            text: Y[1],
            tokens: this.lexer.inline(Y[1])
          };
      }, ce.paragraph = function(H) {
        var Y = this.rules.block.paragraph.exec(H);
        if (Y) {
          var Z = Y[1].charAt(Y[1].length - 1) === `
` ? Y[1].slice(0, -1) : Y[1];
          return {
            type: "paragraph",
            raw: Y[0],
            text: Z,
            tokens: this.lexer.inline(Z)
          };
        }
      }, ce.text = function(H) {
        var Y = this.rules.block.text.exec(H);
        if (Y)
          return {
            type: "text",
            raw: Y[0],
            text: Y[0],
            tokens: this.lexer.inline(Y[0])
          };
      }, ce.escape = function(H) {
        var Y = this.rules.inline.escape.exec(H);
        if (Y)
          return {
            type: "escape",
            raw: Y[0],
            text: p(Y[1])
          };
      }, ce.tag = function(H) {
        var Y = this.rules.inline.tag.exec(H);
        if (Y)
          return !this.lexer.state.inLink && /^<a /i.test(Y[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(Y[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(Y[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(Y[0]) && (this.lexer.state.inRawBlock = !1), {
            type: this.options.sanitize ? "text" : "html",
            raw: Y[0],
            inLink: this.lexer.state.inLink,
            inRawBlock: this.lexer.state.inRawBlock,
            text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(Y[0]) : p(Y[0]) : Y[0]
          };
      }, ce.link = function(H) {
        var Y = this.rules.inline.link.exec(H);
        if (Y) {
          var Z = Y[2].trim();
          if (!this.options.pedantic && /^</.test(Z)) {
            if (!/>$/.test(Z))
              return;
            var Q = O(Z.slice(0, -1), "\\");
            if ((Z.length - Q.length) % 2 === 0)
              return;
          } else {
            var me = K(Y[2], "()");
            if (me > -1) {
              var Le = Y[0].indexOf("!") === 0 ? 5 : 4, xe = Le + Y[1].length + me;
              Y[2] = Y[2].substring(0, me), Y[0] = Y[0].substring(0, xe).trim(), Y[3] = "";
            }
          }
          var Ue = Y[2], je = "";
          if (this.options.pedantic) {
            var Ze = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(Ue);
            Ze && (Ue = Ze[1], je = Ze[3]);
          } else
            je = Y[3] ? Y[3].slice(1, -1) : "";
          return Ue = Ue.trim(), /^</.test(Ue) && (this.options.pedantic && !/>$/.test(Z) ? Ue = Ue.slice(1) : Ue = Ue.slice(1, -1)), q(Y, {
            href: Ue && Ue.replace(this.rules.inline._escapes, "$1"),
            title: je && je.replace(this.rules.inline._escapes, "$1")
          }, Y[0], this.lexer);
        }
      }, ce.reflink = function(H, Y) {
        var Z;
        if ((Z = this.rules.inline.reflink.exec(H)) || (Z = this.rules.inline.nolink.exec(H))) {
          var Q = (Z[2] || Z[1]).replace(/\s+/g, " ");
          if (Q = Y[Q.toLowerCase()], !Q || !Q.href) {
            var me = Z[0].charAt(0);
            return {
              type: "text",
              raw: me,
              text: me
            };
          }
          return q(Z, Q, Z[0], this.lexer);
        }
      }, ce.emStrong = function(H, Y, Z) {
        Z === void 0 && (Z = "");
        var Q = this.rules.inline.emStrong.lDelim.exec(H);
        if (Q && !(Q[3] && Z.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/))) {
          var me = Q[1] || Q[2] || "";
          if (!me || me && (Z === "" || this.rules.inline.punctuation.exec(Z))) {
            var Le = Q[0].length - 1, xe, Ue, je = Le, Ze = 0, _e = Q[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
            for (_e.lastIndex = 0, Y = Y.slice(-1 * H.length + Le); (Q = _e.exec(Y)) != null; )
              if (xe = Q[1] || Q[2] || Q[3] || Q[4] || Q[5] || Q[6], !!xe) {
                if (Ue = xe.length, Q[3] || Q[4]) {
                  je += Ue;
                  continue;
                } else if ((Q[5] || Q[6]) && Le % 3 && !((Le + Ue) % 3)) {
                  Ze += Ue;
                  continue;
                }
                if (je -= Ue, !(je > 0)) {
                  if (Ue = Math.min(Ue, Ue + je + Ze), Math.min(Le, Ue) % 2) {
                    var U = H.slice(1, Le + Q.index + Ue);
                    return {
                      type: "em",
                      raw: H.slice(0, Le + Q.index + Ue + 1),
                      text: U,
                      tokens: this.lexer.inlineTokens(U)
                    };
                  }
                  var fe = H.slice(2, Le + Q.index + Ue - 1);
                  return {
                    type: "strong",
                    raw: H.slice(0, Le + Q.index + Ue + 1),
                    text: fe,
                    tokens: this.lexer.inlineTokens(fe)
                  };
                }
              }
          }
        }
      }, ce.codespan = function(H) {
        var Y = this.rules.inline.code.exec(H);
        if (Y) {
          var Z = Y[2].replace(/\n/g, " "), Q = /[^ ]/.test(Z), me = /^ /.test(Z) && / $/.test(Z);
          return Q && me && (Z = Z.substring(1, Z.length - 1)), Z = p(Z, !0), {
            type: "codespan",
            raw: Y[0],
            text: Z
          };
        }
      }, ce.br = function(H) {
        var Y = this.rules.inline.br.exec(H);
        if (Y)
          return {
            type: "br",
            raw: Y[0]
          };
      }, ce.del = function(H) {
        var Y = this.rules.inline.del.exec(H);
        if (Y)
          return {
            type: "del",
            raw: Y[0],
            text: Y[2],
            tokens: this.lexer.inlineTokens(Y[2])
          };
      }, ce.autolink = function(H, Y) {
        var Z = this.rules.inline.autolink.exec(H);
        if (Z) {
          var Q, me;
          return Z[2] === "@" ? (Q = p(this.options.mangle ? Y(Z[1]) : Z[1]), me = "mailto:" + Q) : (Q = p(Z[1]), me = Q), {
            type: "link",
            raw: Z[0],
            text: Q,
            href: me,
            tokens: [{
              type: "text",
              raw: Q,
              text: Q
            }]
          };
        }
      }, ce.url = function(H, Y) {
        var Z;
        if (Z = this.rules.inline.url.exec(H)) {
          var Q, me;
          if (Z[2] === "@")
            Q = p(this.options.mangle ? Y(Z[0]) : Z[0]), me = "mailto:" + Q;
          else {
            var Le;
            do
              Le = Z[0], Z[0] = this.rules.inline._backpedal.exec(Z[0])[0];
            while (Le !== Z[0]);
            Q = p(Z[0]), Z[1] === "www." ? me = "http://" + Q : me = Q;
          }
          return {
            type: "link",
            raw: Z[0],
            text: Q,
            href: me,
            tokens: [{
              type: "text",
              raw: Q,
              text: Q
            }]
          };
        }
      }, ce.inlineText = function(H, Y) {
        var Z = this.rules.inline.text.exec(H);
        if (Z) {
          var Q;
          return this.lexer.state.inRawBlock ? Q = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(Z[0]) : p(Z[0]) : Z[0] : Q = p(this.options.smartypants ? Y(Z[0]) : Z[0]), {
            type: "text",
            raw: Z[0],
            text: Q
          };
        }
      }, de;
    }(), z = {
      newline: /^(?: *(?:\n|$))+/,
      code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
      fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
      hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
      heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
      blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
      list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
      html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
      def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
      table: I,
      lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
      // regex template, placeholders will be replaced according to different paragraph
      // interruption rules of commonmark and the original markdown spec:
      _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
      text: /^[^\n]+/
    };
    z._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/, z._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/, z.def = w(z.def).replace("label", z._label).replace("title", z._title).getRegex(), z.bullet = /(?:[*+-]|\d{1,9}[.)])/, z.listItemStart = w(/^( *)(bull) */).replace("bull", z.bullet).getRegex(), z.list = w(z.list).replace(/bull/g, z.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + z.def.source + ")").getRegex(), z._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", z._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/, z.html = w(z.html, "i").replace("comment", z._comment).replace("tag", z._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), z.paragraph = w(z._paragraph).replace("hr", z.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", z._tag).getRegex(), z.blockquote = w(z.blockquote).replace("paragraph", z.paragraph).getRegex(), z.normal = A({}, z), z.gfm = A({}, z.normal, {
      table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
      // Cells
    }), z.gfm.table = w(z.gfm.table).replace("hr", z.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", z._tag).getRegex(), z.gfm.paragraph = w(z._paragraph).replace("hr", z.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", z.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", z._tag).getRegex(), z.pedantic = A({}, z.normal, {
      html: w(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", z._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
      def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
      heading: /^(#{1,6})(.*)(?:\n+|$)/,
      fences: I,
      // fences not supported
      paragraph: w(z.normal._paragraph).replace("hr", z.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", z.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
    });
    var X = {
      escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
      autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
      url: I,
      tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
      // CDATA section
      link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
      reflink: /^!?\[(label)\]\[(ref)\]/,
      nolink: /^!?\[(ref)\](?:\[\])?/,
      reflinkSearch: "reflink|nolink(?!\\()",
      emStrong: {
        lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
        //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
        //          () Skip orphan inside strong  () Consume to delim (1) #***                (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
        rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
        rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
        // ^- Not allowed for _
      },
      code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
      br: /^( {2,}|\\)\n(?!\s*$)/,
      del: I,
      text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
      punctuation: /^([\spunctuation])/
    };
    X._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~", X.punctuation = w(X.punctuation).replace(/punctuation/g, X._punctuation).getRegex(), X.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g, X.escapedEmSt = /\\\*|\\_/g, X._comment = w(z._comment).replace("(?:-->|$)", "-->").getRegex(), X.emStrong.lDelim = w(X.emStrong.lDelim).replace(/punct/g, X._punctuation).getRegex(), X.emStrong.rDelimAst = w(X.emStrong.rDelimAst, "g").replace(/punct/g, X._punctuation).getRegex(), X.emStrong.rDelimUnd = w(X.emStrong.rDelimUnd, "g").replace(/punct/g, X._punctuation).getRegex(), X._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g, X._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, X._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, X.autolink = w(X.autolink).replace("scheme", X._scheme).replace("email", X._email).getRegex(), X._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, X.tag = w(X.tag).replace("comment", X._comment).replace("attribute", X._attribute).getRegex(), X._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, X._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/, X._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, X.link = w(X.link).replace("label", X._label).replace("href", X._href).replace("title", X._title).getRegex(), X.reflink = w(X.reflink).replace("label", X._label).replace("ref", z._label).getRegex(), X.nolink = w(X.nolink).replace("ref", z._label).getRegex(), X.reflinkSearch = w(X.reflinkSearch, "g").replace("reflink", X.reflink).replace("nolink", X.nolink).getRegex(), X.normal = A({}, X), X.pedantic = A({}, X.normal, {
      strong: {
        start: /^__|\*\*/,
        middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
        endAst: /\*\*(?!\*)/g,
        endUnd: /__(?!_)/g
      },
      em: {
        start: /^_|\*/,
        middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
        endAst: /\*(?!\*)/g,
        endUnd: /_(?!_)/g
      },
      link: w(/^!?\[(label)\]\((.*?)\)/).replace("label", X._label).getRegex(),
      reflink: w(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", X._label).getRegex()
    }), X.gfm = A({}, X.normal, {
      escape: w(X.escape).replace("])", "~|])").getRegex(),
      _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
      url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
      _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
      del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
      text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    }), X.gfm.url = w(X.gfm.url, "i").replace("email", X.gfm._extended_email).getRegex(), X.breaks = A({}, X.gfm, {
      br: w(X.br).replace("{2,}", "*").getRegex(),
      text: w(X.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    });
    function ae(de) {
      return de.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
    }
    function ue(de) {
      var ce = "", ie, H, Y = de.length;
      for (ie = 0; ie < Y; ie++)
        H = de.charCodeAt(ie), Math.random() > 0.5 && (H = "x" + H.toString(16)), ce += "&#" + H + ";";
      return ce;
    }
    var se = /* @__PURE__ */ function() {
      function de(ie) {
        this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = ie || e.defaults, this.options.tokenizer = this.options.tokenizer || new T(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
          inLink: !1,
          inRawBlock: !1,
          top: !0
        };
        var H = {
          block: z.normal,
          inline: X.normal
        };
        this.options.pedantic ? (H.block = z.pedantic, H.inline = X.pedantic) : this.options.gfm && (H.block = z.gfm, this.options.breaks ? H.inline = X.breaks : H.inline = X.gfm), this.tokenizer.rules = H;
      }
      de.lex = function(H, Y) {
        var Z = new de(Y);
        return Z.lex(H);
      }, de.lexInline = function(H, Y) {
        var Z = new de(Y);
        return Z.inlineTokens(H);
      };
      var ce = de.prototype;
      return ce.lex = function(H) {
        H = H.replace(/\r\n|\r/g, `
`), this.blockTokens(H, this.tokens);
        for (var Y; Y = this.inlineQueue.shift(); )
          this.inlineTokens(Y.src, Y.tokens);
        return this.tokens;
      }, ce.blockTokens = function(H, Y) {
        var Z = this;
        Y === void 0 && (Y = []), this.options.pedantic ? H = H.replace(/\t/g, "    ").replace(/^ +$/gm, "") : H = H.replace(/^( *)(\t+)/gm, function(je, Ze, _e) {
          return Ze + "    ".repeat(_e.length);
        });
        for (var Q, me, Le, xe; H; )
          if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(je) {
            return (Q = je.call({
              lexer: Z
            }, H, Y)) ? (H = H.substring(Q.raw.length), Y.push(Q), !0) : !1;
          }))) {
            if (Q = this.tokenizer.space(H)) {
              H = H.substring(Q.raw.length), Q.raw.length === 1 && Y.length > 0 ? Y[Y.length - 1].raw += `
` : Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.code(H)) {
              H = H.substring(Q.raw.length), me = Y[Y.length - 1], me && (me.type === "paragraph" || me.type === "text") ? (me.raw += `
` + Q.raw, me.text += `
` + Q.text, this.inlineQueue[this.inlineQueue.length - 1].src = me.text) : Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.fences(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.heading(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.hr(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.blockquote(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.list(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.html(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.def(H)) {
              H = H.substring(Q.raw.length), me = Y[Y.length - 1], me && (me.type === "paragraph" || me.type === "text") ? (me.raw += `
` + Q.raw, me.text += `
` + Q.raw, this.inlineQueue[this.inlineQueue.length - 1].src = me.text) : this.tokens.links[Q.tag] || (this.tokens.links[Q.tag] = {
                href: Q.href,
                title: Q.title
              });
              continue;
            }
            if (Q = this.tokenizer.table(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.lheading(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Le = H, this.options.extensions && this.options.extensions.startBlock && function() {
              var je = 1 / 0, Ze = H.slice(1), _e = void 0;
              Z.options.extensions.startBlock.forEach(function(U) {
                _e = U.call({
                  lexer: this
                }, Ze), typeof _e == "number" && _e >= 0 && (je = Math.min(je, _e));
              }), je < 1 / 0 && je >= 0 && (Le = H.substring(0, je + 1));
            }(), this.state.top && (Q = this.tokenizer.paragraph(Le))) {
              me = Y[Y.length - 1], xe && me.type === "paragraph" ? (me.raw += `
` + Q.raw, me.text += `
` + Q.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = me.text) : Y.push(Q), xe = Le.length !== H.length, H = H.substring(Q.raw.length);
              continue;
            }
            if (Q = this.tokenizer.text(H)) {
              H = H.substring(Q.raw.length), me = Y[Y.length - 1], me && me.type === "text" ? (me.raw += `
` + Q.raw, me.text += `
` + Q.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = me.text) : Y.push(Q);
              continue;
            }
            if (H) {
              var Ue = "Infinite loop on byte: " + H.charCodeAt(0);
              if (this.options.silent) {
                console.error(Ue);
                break;
              } else
                throw new Error(Ue);
            }
          }
        return this.state.top = !0, Y;
      }, ce.inline = function(H, Y) {
        return Y === void 0 && (Y = []), this.inlineQueue.push({
          src: H,
          tokens: Y
        }), Y;
      }, ce.inlineTokens = function(H, Y) {
        var Z = this;
        Y === void 0 && (Y = []);
        var Q, me, Le, xe = H, Ue, je, Ze;
        if (this.tokens.links) {
          var _e = Object.keys(this.tokens.links);
          if (_e.length > 0)
            for (; (Ue = this.tokenizer.rules.inline.reflinkSearch.exec(xe)) != null; )
              _e.includes(Ue[0].slice(Ue[0].lastIndexOf("[") + 1, -1)) && (xe = xe.slice(0, Ue.index) + "[" + F("a", Ue[0].length - 2) + "]" + xe.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
        }
        for (; (Ue = this.tokenizer.rules.inline.blockSkip.exec(xe)) != null; )
          xe = xe.slice(0, Ue.index) + "[" + F("a", Ue[0].length - 2) + "]" + xe.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        for (; (Ue = this.tokenizer.rules.inline.escapedEmSt.exec(xe)) != null; )
          xe = xe.slice(0, Ue.index) + "++" + xe.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        for (; H; )
          if (je || (Ze = ""), je = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(fe) {
            return (Q = fe.call({
              lexer: Z
            }, H, Y)) ? (H = H.substring(Q.raw.length), Y.push(Q), !0) : !1;
          }))) {
            if (Q = this.tokenizer.escape(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.tag(H)) {
              H = H.substring(Q.raw.length), me = Y[Y.length - 1], me && Q.type === "text" && me.type === "text" ? (me.raw += Q.raw, me.text += Q.text) : Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.link(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.reflink(H, this.tokens.links)) {
              H = H.substring(Q.raw.length), me = Y[Y.length - 1], me && Q.type === "text" && me.type === "text" ? (me.raw += Q.raw, me.text += Q.text) : Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.emStrong(H, xe, Ze)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.codespan(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.br(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.del(H)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Q = this.tokenizer.autolink(H, ue)) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (!this.state.inLink && (Q = this.tokenizer.url(H, ue))) {
              H = H.substring(Q.raw.length), Y.push(Q);
              continue;
            }
            if (Le = H, this.options.extensions && this.options.extensions.startInline && function() {
              var fe = 1 / 0, Ee = H.slice(1), Me = void 0;
              Z.options.extensions.startInline.forEach(function(Pe) {
                Me = Pe.call({
                  lexer: this
                }, Ee), typeof Me == "number" && Me >= 0 && (fe = Math.min(fe, Me));
              }), fe < 1 / 0 && fe >= 0 && (Le = H.substring(0, fe + 1));
            }(), Q = this.tokenizer.inlineText(Le, ae)) {
              H = H.substring(Q.raw.length), Q.raw.slice(-1) !== "_" && (Ze = Q.raw.slice(-1)), je = !0, me = Y[Y.length - 1], me && me.type === "text" ? (me.raw += Q.raw, me.text += Q.text) : Y.push(Q);
              continue;
            }
            if (H) {
              var U = "Infinite loop on byte: " + H.charCodeAt(0);
              if (this.options.silent) {
                console.error(U);
                break;
              } else
                throw new Error(U);
            }
          }
        return Y;
      }, n(de, null, [{
        key: "rules",
        get: function() {
          return {
            block: z,
            inline: X
          };
        }
      }]), de;
    }(), le = /* @__PURE__ */ function() {
      function de(ie) {
        this.options = ie || e.defaults;
      }
      var ce = de.prototype;
      return ce.code = function(H, Y, Z) {
        var Q = (Y || "").match(/\S*/)[0];
        if (this.options.highlight) {
          var me = this.options.highlight(H, Q);
          me != null && me !== H && (Z = !0, H = me);
        }
        return H = H.replace(/\n$/, "") + `
`, Q ? '<pre><code class="' + this.options.langPrefix + p(Q, !0) + '">' + (Z ? H : p(H, !0)) + `</code></pre>
` : "<pre><code>" + (Z ? H : p(H, !0)) + `</code></pre>
`;
      }, ce.blockquote = function(H) {
        return `<blockquote>
` + H + `</blockquote>
`;
      }, ce.html = function(H) {
        return H;
      }, ce.heading = function(H, Y, Z, Q) {
        if (this.options.headerIds) {
          var me = this.options.headerPrefix + Q.slug(Z);
          return "<h" + Y + ' id="' + me + '">' + H + "</h" + Y + `>
`;
        }
        return "<h" + Y + ">" + H + "</h" + Y + `>
`;
      }, ce.hr = function() {
        return this.options.xhtml ? `<hr/>
` : `<hr>
`;
      }, ce.list = function(H, Y, Z) {
        var Q = Y ? "ol" : "ul", me = Y && Z !== 1 ? ' start="' + Z + '"' : "";
        return "<" + Q + me + `>
` + H + "</" + Q + `>
`;
      }, ce.listitem = function(H) {
        return "<li>" + H + `</li>
`;
      }, ce.checkbox = function(H) {
        return "<input " + (H ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
      }, ce.paragraph = function(H) {
        return "<p>" + H + `</p>
`;
      }, ce.table = function(H, Y) {
        return Y && (Y = "<tbody>" + Y + "</tbody>"), `<table>
<thead>
` + H + `</thead>
` + Y + `</table>
`;
      }, ce.tablerow = function(H) {
        return `<tr>
` + H + `</tr>
`;
      }, ce.tablecell = function(H, Y) {
        var Z = Y.header ? "th" : "td", Q = Y.align ? "<" + Z + ' align="' + Y.align + '">' : "<" + Z + ">";
        return Q + H + ("</" + Z + `>
`);
      }, ce.strong = function(H) {
        return "<strong>" + H + "</strong>";
      }, ce.em = function(H) {
        return "<em>" + H + "</em>";
      }, ce.codespan = function(H) {
        return "<code>" + H + "</code>";
      }, ce.br = function() {
        return this.options.xhtml ? "<br/>" : "<br>";
      }, ce.del = function(H) {
        return "<del>" + H + "</del>";
      }, ce.link = function(H, Y, Z) {
        if (H = x(this.options.sanitize, this.options.baseUrl, H), H === null)
          return Z;
        var Q = '<a href="' + p(H) + '"';
        return Y && (Q += ' title="' + Y + '"'), Q += ">" + Z + "</a>", Q;
      }, ce.image = function(H, Y, Z) {
        if (H = x(this.options.sanitize, this.options.baseUrl, H), H === null)
          return Z;
        var Q = '<img src="' + H + '" alt="' + Z + '"';
        return Y && (Q += ' title="' + Y + '"'), Q += this.options.xhtml ? "/>" : ">", Q;
      }, ce.text = function(H) {
        return H;
      }, de;
    }(), oe = /* @__PURE__ */ function() {
      function de() {
      }
      var ce = de.prototype;
      return ce.strong = function(H) {
        return H;
      }, ce.em = function(H) {
        return H;
      }, ce.codespan = function(H) {
        return H;
      }, ce.del = function(H) {
        return H;
      }, ce.html = function(H) {
        return H;
      }, ce.text = function(H) {
        return H;
      }, ce.link = function(H, Y, Z) {
        return "" + Z;
      }, ce.image = function(H, Y, Z) {
        return "" + Z;
      }, ce.br = function() {
        return "";
      }, de;
    }(), re = /* @__PURE__ */ function() {
      function de() {
        this.seen = {};
      }
      var ce = de.prototype;
      return ce.serialize = function(H) {
        return H.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
      }, ce.getNextSafeSlug = function(H, Y) {
        var Z = H, Q = 0;
        if (this.seen.hasOwnProperty(Z)) {
          Q = this.seen[H];
          do
            Q++, Z = H + "-" + Q;
          while (this.seen.hasOwnProperty(Z));
        }
        return Y || (this.seen[H] = Q, this.seen[Z] = 0), Z;
      }, ce.slug = function(H, Y) {
        Y === void 0 && (Y = {});
        var Z = this.serialize(H);
        return this.getNextSafeSlug(Z, Y.dryrun);
      }, de;
    }(), B = /* @__PURE__ */ function() {
      function de(ie) {
        this.options = ie || e.defaults, this.options.renderer = this.options.renderer || new le(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new oe(), this.slugger = new re();
      }
      de.parse = function(H, Y) {
        var Z = new de(Y);
        return Z.parse(H);
      }, de.parseInline = function(H, Y) {
        var Z = new de(Y);
        return Z.parseInline(H);
      };
      var ce = de.prototype;
      return ce.parse = function(H, Y) {
        Y === void 0 && (Y = !0);
        var Z = "", Q, me, Le, xe, Ue, je, Ze, _e, U, fe, Ee, Me, Pe, et, gt, Vt, Zt, St, Ht, fn = H.length;
        for (Q = 0; Q < fn; Q++) {
          if (fe = H[Q], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[fe.type] && (Ht = this.options.extensions.renderers[fe.type].call({
            parser: this
          }, fe), Ht !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(fe.type))) {
            Z += Ht || "";
            continue;
          }
          switch (fe.type) {
            case "space":
              continue;
            case "hr": {
              Z += this.renderer.hr();
              continue;
            }
            case "heading": {
              Z += this.renderer.heading(this.parseInline(fe.tokens), fe.depth, _(this.parseInline(fe.tokens, this.textRenderer)), this.slugger);
              continue;
            }
            case "code": {
              Z += this.renderer.code(fe.text, fe.lang, fe.escaped);
              continue;
            }
            case "table": {
              for (_e = "", Ze = "", xe = fe.header.length, me = 0; me < xe; me++)
                Ze += this.renderer.tablecell(this.parseInline(fe.header[me].tokens), {
                  header: !0,
                  align: fe.align[me]
                });
              for (_e += this.renderer.tablerow(Ze), U = "", xe = fe.rows.length, me = 0; me < xe; me++) {
                for (je = fe.rows[me], Ze = "", Ue = je.length, Le = 0; Le < Ue; Le++)
                  Ze += this.renderer.tablecell(this.parseInline(je[Le].tokens), {
                    header: !1,
                    align: fe.align[Le]
                  });
                U += this.renderer.tablerow(Ze);
              }
              Z += this.renderer.table(_e, U);
              continue;
            }
            case "blockquote": {
              U = this.parse(fe.tokens), Z += this.renderer.blockquote(U);
              continue;
            }
            case "list": {
              for (Ee = fe.ordered, Me = fe.start, Pe = fe.loose, xe = fe.items.length, U = "", me = 0; me < xe; me++)
                gt = fe.items[me], Vt = gt.checked, Zt = gt.task, et = "", gt.task && (St = this.renderer.checkbox(Vt), Pe ? gt.tokens.length > 0 && gt.tokens[0].type === "paragraph" ? (gt.tokens[0].text = St + " " + gt.tokens[0].text, gt.tokens[0].tokens && gt.tokens[0].tokens.length > 0 && gt.tokens[0].tokens[0].type === "text" && (gt.tokens[0].tokens[0].text = St + " " + gt.tokens[0].tokens[0].text)) : gt.tokens.unshift({
                  type: "text",
                  text: St
                }) : et += St), et += this.parse(gt.tokens, Pe), U += this.renderer.listitem(et, Zt, Vt);
              Z += this.renderer.list(U, Ee, Me);
              continue;
            }
            case "html": {
              Z += this.renderer.html(fe.text);
              continue;
            }
            case "paragraph": {
              Z += this.renderer.paragraph(this.parseInline(fe.tokens));
              continue;
            }
            case "text": {
              for (U = fe.tokens ? this.parseInline(fe.tokens) : fe.text; Q + 1 < fn && H[Q + 1].type === "text"; )
                fe = H[++Q], U += `
` + (fe.tokens ? this.parseInline(fe.tokens) : fe.text);
              Z += Y ? this.renderer.paragraph(U) : U;
              continue;
            }
            default: {
              var xn = 'Token with "' + fe.type + '" type was not found.';
              if (this.options.silent) {
                console.error(xn);
                return;
              } else
                throw new Error(xn);
            }
          }
        }
        return Z;
      }, ce.parseInline = function(H, Y) {
        Y = Y || this.renderer;
        var Z = "", Q, me, Le, xe = H.length;
        for (Q = 0; Q < xe; Q++) {
          if (me = H[Q], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[me.type] && (Le = this.options.extensions.renderers[me.type].call({
            parser: this
          }, me), Le !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(me.type))) {
            Z += Le || "";
            continue;
          }
          switch (me.type) {
            case "escape": {
              Z += Y.text(me.text);
              break;
            }
            case "html": {
              Z += Y.html(me.text);
              break;
            }
            case "link": {
              Z += Y.link(me.href, me.title, this.parseInline(me.tokens, Y));
              break;
            }
            case "image": {
              Z += Y.image(me.href, me.title, me.text);
              break;
            }
            case "strong": {
              Z += Y.strong(this.parseInline(me.tokens, Y));
              break;
            }
            case "em": {
              Z += Y.em(this.parseInline(me.tokens, Y));
              break;
            }
            case "codespan": {
              Z += Y.codespan(me.text);
              break;
            }
            case "br": {
              Z += Y.br();
              break;
            }
            case "del": {
              Z += Y.del(this.parseInline(me.tokens, Y));
              break;
            }
            case "text": {
              Z += Y.text(me.text);
              break;
            }
            default: {
              var Ue = 'Token with "' + me.type + '" type was not found.';
              if (this.options.silent) {
                console.error(Ue);
                return;
              } else
                throw new Error(Ue);
            }
          }
        }
        return Z;
      }, de;
    }();
    function ee(de, ce, ie) {
      if (typeof de > "u" || de === null)
        throw new Error("marked(): input parameter is undefined or null");
      if (typeof de != "string")
        throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(de) + ", string expected");
      if (typeof ce == "function" && (ie = ce, ce = null), ce = A({}, ee.defaults, ce || {}), W(ce), ie) {
        var H = ce.highlight, Y;
        try {
          Y = se.lex(de, ce);
        } catch (xe) {
          return ie(xe);
        }
        var Z = function(Ue) {
          var je;
          if (!Ue)
            try {
              ce.walkTokens && ee.walkTokens(Y, ce.walkTokens), je = B.parse(Y, ce);
            } catch (Ze) {
              Ue = Ze;
            }
          return ce.highlight = H, Ue ? ie(Ue) : ie(null, je);
        };
        if (!H || H.length < 3 || (delete ce.highlight, !Y.length)) return Z();
        var Q = 0;
        ee.walkTokens(Y, function(xe) {
          xe.type === "code" && (Q++, setTimeout(function() {
            H(xe.text, xe.lang, function(Ue, je) {
              if (Ue)
                return Z(Ue);
              je != null && je !== xe.text && (xe.text = je, xe.escaped = !0), Q--, Q === 0 && Z();
            });
          }, 0));
        }), Q === 0 && Z();
        return;
      }
      function me(xe) {
        if (xe.message += `
Please report this to https://github.com/markedjs/marked.`, ce.silent)
          return "<p>An error occurred:</p><pre>" + p(xe.message + "", !0) + "</pre>";
        throw xe;
      }
      try {
        var Le = se.lex(de, ce);
        if (ce.walkTokens) {
          if (ce.async)
            return Promise.all(ee.walkTokens(Le, ce.walkTokens)).then(function() {
              return B.parse(Le, ce);
            }).catch(me);
          ee.walkTokens(Le, ce.walkTokens);
        }
        return B.parse(Le, ce);
      } catch (xe) {
        me(xe);
      }
    }
    ee.options = ee.setOptions = function(de) {
      return A(ee.defaults, de), l(ee.defaults), ee;
    }, ee.getDefaults = a, ee.defaults = e.defaults, ee.use = function() {
      for (var de = arguments.length, ce = new Array(de), ie = 0; ie < de; ie++)
        ce[ie] = arguments[ie];
      var H = A.apply(void 0, [{}].concat(ce)), Y = ee.defaults.extensions || {
        renderers: {},
        childTokens: {}
      }, Z;
      ce.forEach(function(Q) {
        if (Q.extensions && (Z = !0, Q.extensions.forEach(function(Le) {
          if (!Le.name)
            throw new Error("extension name required");
          if (Le.renderer) {
            var xe = Y.renderers ? Y.renderers[Le.name] : null;
            xe ? Y.renderers[Le.name] = function() {
              for (var Ue = arguments.length, je = new Array(Ue), Ze = 0; Ze < Ue; Ze++)
                je[Ze] = arguments[Ze];
              var _e = Le.renderer.apply(this, je);
              return _e === !1 && (_e = xe.apply(this, je)), _e;
            } : Y.renderers[Le.name] = Le.renderer;
          }
          if (Le.tokenizer) {
            if (!Le.level || Le.level !== "block" && Le.level !== "inline")
              throw new Error("extension level must be 'block' or 'inline'");
            Y[Le.level] ? Y[Le.level].unshift(Le.tokenizer) : Y[Le.level] = [Le.tokenizer], Le.start && (Le.level === "block" ? Y.startBlock ? Y.startBlock.push(Le.start) : Y.startBlock = [Le.start] : Le.level === "inline" && (Y.startInline ? Y.startInline.push(Le.start) : Y.startInline = [Le.start]));
          }
          Le.childTokens && (Y.childTokens[Le.name] = Le.childTokens);
        })), Q.renderer && function() {
          var Le = ee.defaults.renderer || new le(), xe = function(Ze) {
            var _e = Le[Ze];
            Le[Ze] = function() {
              for (var U = arguments.length, fe = new Array(U), Ee = 0; Ee < U; Ee++)
                fe[Ee] = arguments[Ee];
              var Me = Q.renderer[Ze].apply(Le, fe);
              return Me === !1 && (Me = _e.apply(Le, fe)), Me;
            };
          };
          for (var Ue in Q.renderer)
            xe(Ue);
          H.renderer = Le;
        }(), Q.tokenizer && function() {
          var Le = ee.defaults.tokenizer || new T(), xe = function(Ze) {
            var _e = Le[Ze];
            Le[Ze] = function() {
              for (var U = arguments.length, fe = new Array(U), Ee = 0; Ee < U; Ee++)
                fe[Ee] = arguments[Ee];
              var Me = Q.tokenizer[Ze].apply(Le, fe);
              return Me === !1 && (Me = _e.apply(Le, fe)), Me;
            };
          };
          for (var Ue in Q.tokenizer)
            xe(Ue);
          H.tokenizer = Le;
        }(), Q.walkTokens) {
          var me = ee.defaults.walkTokens;
          H.walkTokens = function(Le) {
            var xe = [];
            return xe.push(Q.walkTokens.call(this, Le)), me && (xe = xe.concat(me.call(this, Le))), xe;
          };
        }
        Z && (H.extensions = Y), ee.setOptions(H);
      });
    }, ee.walkTokens = function(de, ce) {
      for (var ie = [], H = function() {
        var me = Z.value;
        switch (ie = ie.concat(ce.call(ee, me)), me.type) {
          case "table": {
            for (var Le = o(me.header), xe; !(xe = Le()).done; ) {
              var Ue = xe.value;
              ie = ie.concat(ee.walkTokens(Ue.tokens, ce));
            }
            for (var je = o(me.rows), Ze; !(Ze = je()).done; )
              for (var _e = Ze.value, U = o(_e), fe; !(fe = U()).done; ) {
                var Ee = fe.value;
                ie = ie.concat(ee.walkTokens(Ee.tokens, ce));
              }
            break;
          }
          case "list": {
            ie = ie.concat(ee.walkTokens(me.items, ce));
            break;
          }
          default:
            ee.defaults.extensions && ee.defaults.extensions.childTokens && ee.defaults.extensions.childTokens[me.type] ? ee.defaults.extensions.childTokens[me.type].forEach(function(Me) {
              ie = ie.concat(ee.walkTokens(me[Me], ce));
            }) : me.tokens && (ie = ie.concat(ee.walkTokens(me.tokens, ce)));
        }
      }, Y = o(de), Z; !(Z = Y()).done; )
        H();
      return ie;
    }, ee.parseInline = function(de, ce) {
      if (typeof de > "u" || de === null)
        throw new Error("marked.parseInline(): input parameter is undefined or null");
      if (typeof de != "string")
        throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(de) + ", string expected");
      ce = A({}, ee.defaults, ce || {}), W(ce);
      try {
        var ie = se.lexInline(de, ce);
        return ce.walkTokens && ee.walkTokens(ie, ce.walkTokens), B.parseInline(ie, ce);
      } catch (H) {
        if (H.message += `
Please report this to https://github.com/markedjs/marked.`, ce.silent)
          return "<p>An error occurred:</p><pre>" + p(H.message + "", !0) + "</pre>";
        throw H;
      }
    }, ee.Parser = B, ee.parser = B.parse, ee.Renderer = le, ee.TextRenderer = oe, ee.Lexer = se, ee.lexer = se.lex, ee.Tokenizer = T, ee.Slugger = re, ee.parse = ee;
    var j = ee.options, he = ee.setOptions, Se = ee.use, ge = ee.walkTokens, te = ee.parseInline, be = ee, Ae = B.parse, He = se.lex;
    e.Lexer = se, e.Parser = B, e.Renderer = le, e.Slugger = re, e.TextRenderer = oe, e.Tokenizer = T, e.getDefaults = a, e.lexer = He, e.marked = ee, e.options = j, e.parse = be, e.parseInline = te, e.parser = Ae, e.setOptions = he, e.use = Se, e.walkTokens = ge, Object.defineProperty(e, "__esModule", { value: !0 });
  });
})();
Co.Lexer || exports.Lexer;
Co.Parser || exports.Parser;
Co.Renderer || exports.Renderer;
Co.Slugger || exports.Slugger;
Co.TextRenderer || exports.TextRenderer;
Co.Tokenizer || exports.Tokenizer;
Co.getDefaults || exports.getDefaults;
Co.lexer || exports.lexer;
var Gd = Co.marked || exports.marked;
Co.options || exports.options;
Co.parse || exports.parse;
Co.parseInline || exports.parseInline;
Co.parser || exports.parser;
Co.setOptions || exports.setOptions;
Co.use || exports.use;
Co.walkTokens || exports.walkTokens;
function Zje(i) {
  return JSON.stringify(i, Qje);
}
function yB(i) {
  let e = JSON.parse(i);
  return e = wB(e), e;
}
function Qje(i, e) {
  return e instanceof RegExp ? {
    $mid: 2,
    source: e.source,
    flags: e.flags
  } : e;
}
function wB(i, e = 0) {
  if (!i || e > 200)
    return i;
  if (typeof i == "object") {
    switch (i.$mid) {
      case 1:
        return pt.revive(i);
      case 2:
        return new RegExp(i.source, i.flags);
      case 17:
        return new Date(i.source);
    }
    if (i instanceof a4 || i instanceof Uint8Array)
      return i;
    if (Array.isArray(i))
      for (let t = 0; t < i.length; ++t)
        i[t] = wB(i[t], e + 1);
    else
      for (const t in i)
        Object.hasOwnProperty.call(i, t) && (i[t] = wB(i[t], e + 1));
  }
  return i;
}
const iT = Object.freeze({
  image: (i, e, t) => {
    let n = [], r = [];
    return i && ({ href: i, dimensions: n } = Wje(i), r.push(`src="${_D(i)}"`)), t && r.push(`alt="${_D(t)}"`), e && r.push(`title="${_D(e)}"`), n.length && (r = r.concat(n)), "<img " + r.join(" ") + ">";
  },
  paragraph: (i) => `<p>${i}</p>`,
  link: (i, e, t) => typeof i != "string" ? "" : (i === t && (t = nT(t)), e = typeof e == "string" ? _D(nT(e)) : "", i = nT(i), i = i.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"), `<a href="${i}" title="${e || i}">${t}</a>`)
});
function M4(i, e = {}, t = {}) {
  var n, r;
  const s = new Ne();
  let o = !1;
  const a = sU(e), l = function(_) {
    let b;
    try {
      b = yB(decodeURIComponent(_));
    } catch {
    }
    return b ? (b = Fue(b, (w) => {
      if (i.uris && i.uris[w])
        return pt.revive(i.uris[w]);
    }), encodeURIComponent(JSON.stringify(b))) : _;
  }, c = function(_, b) {
    const w = i.uris && i.uris[_];
    let y = pt.revive(w);
    return b ? _.startsWith(Mt.data + ":") ? _ : (y || (y = pt.parse(_)), Mhe.uriToBrowserUri(y).toString(!0)) : !y || pt.parse(_).toString() === y.toString() ? _ : (y.query && (y = y.with({ query: l(y.query) })), y.toString());
  }, d = new Gd.Renderer();
  d.image = iT.image, d.link = iT.link, d.paragraph = iT.paragraph;
  const u = [], h = [];
  if (e.codeBlockRendererSync ? d.code = (_, b) => {
    const w = CB.nextId(), y = e.codeBlockRendererSync(YQ(b), _);
    return h.push([w, y]), `<div class="code" data-code="${w}">${KE(_)}</div>`;
  } : e.codeBlockRenderer && (d.code = (_, b) => {
    const w = CB.nextId(), y = e.codeBlockRenderer(YQ(b), _);
    return u.push(y.then((S) => [w, S])), `<div class="code" data-code="${w}">${KE(_)}</div>`;
  }), e.actionHandler) {
    const _ = function(y) {
      let S = y.target;
      if (!(S.tagName !== "A" && (S = S.parentElement, !S || S.tagName !== "A")))
        try {
          let x = S.dataset.href;
          x && (i.baseUri && (x = rT(pt.from(i.baseUri), x)), e.actionHandler.callback(x, y));
        } catch (x) {
          It(x);
        } finally {
          y.preventDefault();
        }
    }, b = e.actionHandler.disposables.add(new Yt(a, "click")), w = e.actionHandler.disposables.add(new Yt(a, "auxclick"));
    e.actionHandler.disposables.add(qe.any(b.event, w.event)((y) => {
      const S = new cl(y);
      !S.leftButton && !S.middleButton || _(S);
    })), e.actionHandler.disposables.add(Ie(a, "keydown", (y) => {
      const S = new Xn(y);
      !S.equals(
        10
        /* KeyCode.Space */
      ) && !S.equals(
        3
        /* KeyCode.Enter */
      ) || _(S);
    }));
  }
  i.supportHtml || (t.sanitizer = (_) => (i.isTrusted ? _.match(/^(<span[^>]+>)|(<\/\s*span>)$/) : void 0) ? _ : "", t.sanitize = !0, t.silent = !0), t.renderer = d;
  let f = (n = i.value) !== null && n !== void 0 ? n : "";
  f.length > 1e5 && (f = `${f.substr(0, 1e5)}…`), i.supportThemeIcons && (f = Rje(f));
  let g;
  if (e.fillInIncompleteTokens) {
    const _ = Object.assign(Object.assign({}, Gd.defaults), t), b = Gd.lexer(f, _), w = sze(b);
    g = Gd.parser(w, _);
  } else
    g = Gd.parse(f, t);
  i.supportThemeIcons && (g = bg(g).map((b) => typeof b == "string" ? b : b.outerHTML).join(""));
  const m = new DOMParser().parseFromString(SB(i, g), "text/html");
  if (m.body.querySelectorAll("img").forEach((_) => {
    const b = _.getAttribute("src");
    if (b) {
      let w = b;
      try {
        i.baseUri && (w = rT(pt.from(i.baseUri), w));
      } catch {
      }
      _.src = c(w, !0);
    }
  }), m.body.querySelectorAll("a").forEach((_) => {
    const b = _.getAttribute("href");
    if (_.setAttribute("href", ""), !b || /^data:|javascript:/i.test(b) || /^command:/i.test(b) && !i.isTrusted || /^command:(\/\/\/)?_workbench\.downloadResource/i.test(b))
      _.replaceWith(..._.childNodes);
    else {
      let w = c(b, !1);
      i.baseUri && (w = rT(pt.from(i.baseUri), b)), _.dataset.href = w;
    }
  }), a.innerHTML = SB(i, m.body.innerHTML), u.length > 0)
    Promise.all(u).then((_) => {
      var b, w;
      if (o)
        return;
      const y = new Map(_), S = a.querySelectorAll("div[data-code]");
      for (const x of S) {
        const D = y.get((b = x.dataset.code) !== null && b !== void 0 ? b : "");
        D && cs(x, D);
      }
      (w = e.asyncRenderCallback) === null || w === void 0 || w.call(e);
    });
  else if (h.length > 0) {
    const _ = new Map(h), b = a.querySelectorAll("div[data-code]");
    for (const w of b) {
      const y = _.get((r = w.dataset.code) !== null && r !== void 0 ? r : "");
      y && cs(w, y);
    }
  }
  if (e.asyncRenderCallback)
    for (const _ of a.getElementsByTagName("img")) {
      const b = s.add(Ie(_, "load", () => {
        b.dispose(), e.asyncRenderCallback();
      }));
    }
  return {
    element: a,
    dispose: () => {
      o = !0, s.dispose();
    }
  };
}
function YQ(i) {
  if (!i)
    return "";
  const e = i.split(/[\s+|:|,|\{|\?]/, 1);
  return e.length ? e[0] : i;
}
function rT(i, e) {
  return /^\w[\w\d+.-]*:/.test(e) ? e : i.path.endsWith("/") ? qZ(i, e).toString() : qZ(D4(i), e).toString();
}
function SB(i, e) {
  const { config: t, allowedSchemes: n } = $je(i);
  Nhe("uponSanitizeAttribute", (s, o) => {
    if (o.attrName === "style" || o.attrName === "class") {
      if (s.tagName === "SPAN") {
        if (o.attrName === "style") {
          o.keepAttr = /^(color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?(background-color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?$/.test(o.attrValue);
          return;
        } else if (o.attrName === "class") {
          o.keepAttr = /^codicon codicon-[a-z\-]+( codicon-modifier-[a-z\-]+)?$/.test(o.attrValue);
          return;
        }
      }
      o.keepAttr = !1;
      return;
    }
  });
  const r = $9e(n);
  try {
    return The(e, Object.assign(Object.assign({}, t), { RETURN_TRUSTED_TYPE: !0 }));
  } finally {
    Phe("uponSanitizeAttribute"), r.dispose();
  }
}
const Jje = [
  "align",
  "autoplay",
  "alt",
  "class",
  "controls",
  "data-code",
  "data-href",
  "height",
  "href",
  "loop",
  "muted",
  "playsinline",
  "poster",
  "src",
  "style",
  "target",
  "title",
  "width",
  "start"
];
function $je(i) {
  const e = [
    Mt.http,
    Mt.https,
    Mt.mailto,
    Mt.data,
    Mt.file,
    Mt.vscodeFileResource,
    Mt.vscodeRemote,
    Mt.vscodeRemoteResource
  ];
  return i.isTrusted && e.push(Mt.command), {
    config: {
      // allowedTags should included everything that markdown renders to.
      // Since we have our own sanitize function for marked, it's possible we missed some tag so let dompurify make sure.
      // HTML tags that can result from markdown are from reading https://spec.commonmark.org/0.29/
      // HTML table tags that can result from markdown are from https://github.github.com/gfm/#tables-extension-
      ALLOWED_TAGS: [...e7e],
      ALLOWED_ATTR: Jje,
      ALLOW_UNKNOWN_PROTOCOLS: !0
    },
    allowedSchemes: e
  };
}
function eze(i) {
  return typeof i == "string" ? i : tze(i);
}
function tze(i) {
  var e;
  let t = (e = i.value) !== null && e !== void 0 ? e : "";
  t.length > 1e5 && (t = `${t.substr(0, 1e5)}…`);
  const n = Gd.parse(t, { renderer: ize.value }).replace(/&(#\d+|[a-zA-Z]+);/g, (r) => {
    var s;
    return (s = nze.get(r)) !== null && s !== void 0 ? s : r;
  });
  return SB({ isTrusted: !1 }, n).toString();
}
const nze = /* @__PURE__ */ new Map([
  ["&quot;", '"'],
  ["&nbsp;", " "],
  ["&amp;", "&"],
  ["&#39;", "'"],
  ["&lt;", "<"],
  ["&gt;", ">"]
]), ize = new lp(() => {
  const i = new Gd.Renderer();
  return i.code = (e) => e, i.blockquote = (e) => e, i.html = (e) => "", i.heading = (e, t, n) => e + `
`, i.hr = () => "", i.list = (e, t) => e, i.listitem = (e) => e + `
`, i.paragraph = (e) => e + `
`, i.table = (e, t) => e + t + `
`, i.tablerow = (e) => e, i.tablecell = (e, t) => e + " ", i.strong = (e) => e, i.em = (e) => e, i.codespan = (e) => e, i.br = () => `
`, i.del = (e) => e, i.image = (e, t, n) => "", i.text = (e) => e, i.link = (e, t, n) => n, i;
});
function aU(i) {
  let e = "";
  return i.forEach((t) => {
    e += t.raw;
  }), e;
}
function rze(i) {
  for (const e of i.tokens)
    if (e.type === "text") {
      const t = e.raw.split(`
`), n = t[t.length - 1];
      if (n.includes("`"))
        return aze(i);
      if (n.includes("**"))
        return hze(i);
      if (n.match(/\*\w/))
        return lze(i);
      if (n.match(/(^|\s)__\w/))
        return fze(i);
      if (n.match(/(^|\s)_\w/))
        return cze(i);
      if (n.match(/(^|\s)\[.*\]\(\w*/))
        return dze(i);
      if (n.match(/(^|\s)\[\w/))
        return uze(i);
    }
}
function sze(i) {
  let e, t;
  for (e = 0; e < i.length; e++) {
    const n = i[e];
    if (n.type === "paragraph" && n.raw.match(/(\n|^)```/)) {
      t = oze(i.slice(e));
      break;
    }
    if (n.type === "paragraph" && n.raw.match(/(\n|^)\|/)) {
      t = gze(i.slice(e));
      break;
    }
    if (e === i.length - 1 && n.type === "paragraph") {
      const r = rze(n);
      if (r) {
        t = [r];
        break;
      }
    }
  }
  if (t) {
    const n = [
      ...i.slice(0, e),
      ...t
    ];
    return n.links = i.links, n;
  }
  return i;
}
function oze(i) {
  const e = aU(i);
  return Gd.lexer(e + "\n```");
}
function aze(i) {
  return R0(i, "`");
}
function lze(i) {
  return R0(i, "*");
}
function cze(i) {
  return R0(i, "_");
}
function dze(i) {
  return R0(i, ")");
}
function uze(i) {
  return R0(i, "](about:blank)");
}
function hze(i) {
  return R0(i, "**");
}
function fze(i) {
  return R0(i, "__");
}
function R0(i, e) {
  const t = aU(Array.isArray(i) ? i : [i]);
  return Gd.lexer(t + e)[0];
}
function gze(i) {
  const e = aU(i), t = e.split(`
`);
  let n, r = !1;
  for (let s = 0; s < t.length; s++) {
    const o = t[s].trim();
    if (typeof n > "u" && o.match(/^\s*\|/)) {
      const a = o.match(/(\|[^\|]+)(?=\||$)/g);
      a && (n = a.length);
    } else if (typeof n == "number")
      if (o.match(/^\s*\|/)) {
        if (s !== t.length - 1)
          return;
        r = !0;
      } else
        return;
  }
  if (typeof n == "number" && n > 0) {
    const s = r ? t.slice(0, -1).join(`
`) : e, o = !!s.match(/\|\s*$/), a = s + (o ? "" : "|") + `
|${" --- |".repeat(n)}`;
    return Gd.lexer(a);
  }
}
class pze {
  constructor(e) {
    this.spliceables = e;
  }
  splice(e, t, n) {
    this.spliceables.forEach((r) => r.splice(e, t, n));
  }
}
class v1 extends Error {
  constructor(e, t) {
    super(`ListError [${e}] ${t}`);
  }
}
function XQ(i, e) {
  const t = [];
  for (const n of e) {
    if (i.start >= n.range.end)
      continue;
    if (i.end < n.range.start)
      break;
    const r = ks.intersect(i, n.range);
    ks.isEmpty(r) || t.push({
      range: r,
      size: n.size
    });
  }
  return t;
}
function xB({ start: i, end: e }, t) {
  return { start: i + t, end: e + t };
}
function mze(i) {
  const e = [];
  let t = null;
  for (const n of i) {
    const r = n.range.start, s = n.range.end, o = n.size;
    if (t && o === t.size) {
      t.range.end = s;
      continue;
    }
    t = { range: { start: r, end: s }, size: o }, e.push(t);
  }
  return e;
}
function vze(...i) {
  return mze(i.reduce((e, t) => e.concat(t), []));
}
class ZQ {
  get paddingTop() {
    return this._paddingTop;
  }
  set paddingTop(e) {
    this._size = this._size + e - this._paddingTop, this._paddingTop = e;
  }
  constructor(e) {
    this.groups = [], this._size = 0, this._paddingTop = 0, this._paddingTop = e ?? 0, this._size = this._paddingTop;
  }
  splice(e, t, n = []) {
    const r = n.length - t, s = XQ({ start: 0, end: e }, this.groups), o = XQ({ start: e + t, end: Number.POSITIVE_INFINITY }, this.groups).map((l) => ({ range: xB(l.range, r), size: l.size })), a = n.map((l, c) => ({
      range: { start: e + c, end: e + c + 1 },
      size: l.size
    }));
    this.groups = vze(s, a, o), this._size = this._paddingTop + this.groups.reduce((l, c) => l + c.size * (c.range.end - c.range.start), 0);
  }
  /**
   * Returns the number of items in the range map.
   */
  get count() {
    const e = this.groups.length;
    return e ? this.groups[e - 1].range.end : 0;
  }
  /**
   * Returns the sum of the sizes of all items in the range map.
   */
  get size() {
    return this._size;
  }
  /**
   * Returns the index of the item at the given position.
   */
  indexAt(e) {
    if (e < 0)
      return -1;
    if (e < this._paddingTop)
      return 0;
    let t = 0, n = this._paddingTop;
    for (const r of this.groups) {
      const s = r.range.end - r.range.start, o = n + s * r.size;
      if (e < o)
        return t + Math.floor((e - n) / r.size);
      t += s, n = o;
    }
    return t;
  }
  /**
   * Returns the index of the item right after the item at the
   * index of the given position.
   */
  indexAfter(e) {
    return Math.min(this.indexAt(e) + 1, this.count);
  }
  /**
   * Returns the start position of the item at the given index.
   */
  positionAt(e) {
    if (e < 0)
      return -1;
    let t = 0, n = 0;
    for (const r of this.groups) {
      const s = r.range.end - r.range.start, o = n + s;
      if (e < o)
        return this._paddingTop + t + (e - n) * r.size;
      t += s * r.size, n = o;
    }
    return -1;
  }
}
function _ze(i) {
  var e;
  try {
    (e = i.parentElement) === null || e === void 0 || e.removeChild(i);
  } catch {
  }
}
class bze {
  constructor(e) {
    this.renderers = e, this.cache = /* @__PURE__ */ new Map(), this.transactionNodesPendingRemoval = /* @__PURE__ */ new Set(), this.inTransaction = !1;
  }
  /**
   * Returns a row either by creating a new one or reusing
   * a previously released row which shares the same templateId.
   *
   * @returns A row and `isReusingConnectedDomNode` if the row's node is already in the dom in a stale position.
   */
  alloc(e) {
    let t = this.getTemplateCache(e).pop(), n = !1;
    if (t)
      n = this.transactionNodesPendingRemoval.has(t.domNode), n && this.transactionNodesPendingRemoval.delete(t.domNode);
    else {
      const r = Re(".monaco-list-row"), o = this.getRenderer(e).renderTemplate(r);
      t = { domNode: r, templateId: e, templateData: o };
    }
    return { row: t, isReusingConnectedDomNode: n };
  }
  /**
   * Releases the row for eventual reuse.
   */
  release(e) {
    e && this.releaseRow(e);
  }
  /**
   * Begin a set of changes that use the cache. This lets us skip work when a row is removed and then inserted again.
   */
  transact(e) {
    if (this.inTransaction)
      throw new Error("Already in transaction");
    this.inTransaction = !0;
    try {
      e();
    } finally {
      for (const t of this.transactionNodesPendingRemoval)
        this.doRemoveNode(t);
      this.transactionNodesPendingRemoval.clear(), this.inTransaction = !1;
    }
  }
  releaseRow(e) {
    const { domNode: t, templateId: n } = e;
    t && (this.inTransaction ? this.transactionNodesPendingRemoval.add(t) : this.doRemoveNode(t)), this.getTemplateCache(n).push(e);
  }
  doRemoveNode(e) {
    e.classList.remove("scrolling"), _ze(e);
  }
  getTemplateCache(e) {
    let t = this.cache.get(e);
    return t || (t = [], this.cache.set(e, t)), t;
  }
  dispose() {
    this.cache.forEach((e, t) => {
      for (const n of e)
        this.getRenderer(t).disposeTemplate(n.templateData), n.templateData = null;
    }), this.cache.clear(), this.transactionNodesPendingRemoval.clear();
  }
  getRenderer(e) {
    const t = this.renderers.get(e);
    if (!t)
      throw new Error(`No renderer found for ${e}`);
    return t;
  }
}
var df = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
};
const Dp = {
  CurrentDragAndDropData: void 0
}, Sd = {
  useShadows: !0,
  verticalScrollMode: 1,
  setRowLineHeight: !0,
  setRowHeight: !0,
  supportDynamicHeights: !1,
  dnd: {
    getDragElements(i) {
      return [i];
    },
    getDragURI() {
      return null;
    },
    onDragStart() {
    },
    onDragOver() {
      return !1;
    },
    drop() {
    },
    dispose() {
    }
  },
  horizontalScrolling: !1,
  transformOptimization: !0,
  alwaysConsumeMouseWheel: !0
};
class VS {
  constructor(e) {
    this.elements = e;
  }
  update() {
  }
  getData() {
    return this.elements;
  }
}
class Cze {
  constructor(e) {
    this.elements = e;
  }
  update() {
  }
  getData() {
    return this.elements;
  }
}
class yze {
  constructor() {
    this.types = [], this.files = [];
  }
  update(e) {
    if (e.types && this.types.splice(0, this.types.length, ...e.types), e.files) {
      this.files.splice(0, this.files.length);
      for (let t = 0; t < e.files.length; t++) {
        const n = e.files.item(t);
        n && (n.size || n.type) && this.files.push(n);
      }
    }
  }
  getData() {
    return {
      types: this.types,
      files: this.files
    };
  }
}
function wze(i, e) {
  return Array.isArray(i) && Array.isArray(e) ? Qi(i, e) : i === e;
}
class Sze {
  constructor(e) {
    e?.getSetSize ? this.getSetSize = e.getSetSize.bind(e) : this.getSetSize = (t, n, r) => r, e?.getPosInSet ? this.getPosInSet = e.getPosInSet.bind(e) : this.getPosInSet = (t, n) => n + 1, e?.getRole ? this.getRole = e.getRole.bind(e) : this.getRole = (t) => "listitem", e?.isChecked ? this.isChecked = e.isChecked.bind(e) : this.isChecked = (t) => {
    };
  }
}
class Tl {
  get contentHeight() {
    return this.rangeMap.size;
  }
  get onDidScroll() {
    return this.scrollableElement.onScroll;
  }
  get horizontalScrolling() {
    return this._horizontalScrolling;
  }
  set horizontalScrolling(e) {
    if (e !== this._horizontalScrolling) {
      if (e && this.supportDynamicHeights)
        throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
      if (this._horizontalScrolling = e, this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling), this._horizontalScrolling) {
        for (const t of this.items)
          this.measureItemWidth(t);
        this.updateScrollWidth(), this.scrollableElement.setScrollDimensions({ width: d6(this.domNode) }), this.rowsContainer.style.width = `${Math.max(this.scrollWidth || 0, this.renderWidth)}px`;
      } else
        this.scrollableElementWidthDelayer.cancel(), this.scrollableElement.setScrollDimensions({ width: this.renderWidth, scrollWidth: this.renderWidth }), this.rowsContainer.style.width = "";
    }
  }
  constructor(e, t, n, r = Sd) {
    var s, o, a, l, c, d, u, h, f, g, p, m, _;
    if (this.virtualDelegate = t, this.domId = `list_id_${++Tl.InstanceCount}`, this.renderers = /* @__PURE__ */ new Map(), this.renderWidth = 0, this._scrollHeight = 0, this.scrollableElementUpdateDisposable = null, this.scrollableElementWidthDelayer = new ac(50), this.splicing = !1, this.dragOverAnimationStopDisposable = we.None, this.dragOverMouseY = 0, this.canDrop = !1, this.currentDragFeedbackDisposable = we.None, this.onDragLeaveTimeout = we.None, this.disposables = new Ne(), this._onDidChangeContentHeight = new pe(), this._onDidChangeContentWidth = new pe(), this._horizontalScrolling = !1, r.horizontalScrolling && r.supportDynamicHeights)
      throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
    this.items = [], this.itemId = 0, this.rangeMap = new ZQ((s = r.paddingTop) !== null && s !== void 0 ? s : 0);
    for (const w of n)
      this.renderers.set(w.templateId, w);
    this.cache = this.disposables.add(new bze(this.renderers)), this.lastRenderTop = 0, this.lastRenderHeight = 0, this.domNode = document.createElement("div"), this.domNode.className = "monaco-list", this.domNode.classList.add(this.domId), this.domNode.tabIndex = 0, this.domNode.classList.toggle("mouse-support", typeof r.mouseSupport == "boolean" ? r.mouseSupport : !0), this._horizontalScrolling = (o = r.horizontalScrolling) !== null && o !== void 0 ? o : Sd.horizontalScrolling, this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling), this.paddingBottom = typeof r.paddingBottom > "u" ? 0 : r.paddingBottom, this.accessibilityProvider = new Sze(r.accessibilityProvider), this.rowsContainer = document.createElement("div"), this.rowsContainer.className = "monaco-list-rows", ((a = r.transformOptimization) !== null && a !== void 0 ? a : Sd.transformOptimization) && (this.rowsContainer.style.transform = "translate3d(0px, 0px, 0px)", this.rowsContainer.style.overflow = "hidden", this.rowsContainer.style.contain = "strict"), this.disposables.add(Vn.addTarget(this.rowsContainer)), this.scrollable = this.disposables.add(new kS({
      forceIntegerValues: !0,
      smoothScrollDuration: (l = r.smoothScrolling) !== null && l !== void 0 && l ? 125 : 0,
      scheduleAtNextAnimationFrame: (w) => Cl(w)
    })), this.scrollableElement = this.disposables.add(new wz(this.rowsContainer, {
      alwaysConsumeMouseWheel: (c = r.alwaysConsumeMouseWheel) !== null && c !== void 0 ? c : Sd.alwaysConsumeMouseWheel,
      horizontal: 1,
      vertical: (d = r.verticalScrollMode) !== null && d !== void 0 ? d : Sd.verticalScrollMode,
      useShadows: (u = r.useShadows) !== null && u !== void 0 ? u : Sd.useShadows,
      mouseWheelScrollSensitivity: r.mouseWheelScrollSensitivity,
      fastScrollSensitivity: r.fastScrollSensitivity,
      scrollByPage: r.scrollByPage
    }, this.scrollable)), this.domNode.appendChild(this.scrollableElement.getDomNode()), e.appendChild(this.domNode), this.scrollableElement.onScroll(this.onScroll, this, this.disposables), this.disposables.add(Ie(this.rowsContainer, Wn.Change, (w) => this.onTouchChange(w))), this.disposables.add(Ie(this.scrollableElement.getDomNode(), "scroll", (w) => w.target.scrollTop = 0)), this.disposables.add(Ie(this.domNode, "dragover", (w) => this.onDragOver(this.toDragEvent(w)))), this.disposables.add(Ie(this.domNode, "drop", (w) => this.onDrop(this.toDragEvent(w)))), this.disposables.add(Ie(this.domNode, "dragleave", (w) => this.onDragLeave(this.toDragEvent(w)))), this.disposables.add(Ie(this.domNode, "dragend", (w) => this.onDragEnd(w))), this.setRowLineHeight = (h = r.setRowLineHeight) !== null && h !== void 0 ? h : Sd.setRowLineHeight, this.setRowHeight = (f = r.setRowHeight) !== null && f !== void 0 ? f : Sd.setRowHeight, this.supportDynamicHeights = (g = r.supportDynamicHeights) !== null && g !== void 0 ? g : Sd.supportDynamicHeights, this.dnd = (p = r.dnd) !== null && p !== void 0 ? p : this.disposables.add(Sd.dnd), this.layout((m = r.initialSize) === null || m === void 0 ? void 0 : m.height, (_ = r.initialSize) === null || _ === void 0 ? void 0 : _.width);
  }
  updateOptions(e) {
    e.paddingBottom !== void 0 && (this.paddingBottom = e.paddingBottom, this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight })), e.smoothScrolling !== void 0 && this.scrollable.setSmoothScrollDuration(e.smoothScrolling ? 125 : 0), e.horizontalScrolling !== void 0 && (this.horizontalScrolling = e.horizontalScrolling);
    let t;
    if (e.scrollByPage !== void 0 && (t = Object.assign(Object.assign({}, t ?? {}), { scrollByPage: e.scrollByPage })), e.mouseWheelScrollSensitivity !== void 0 && (t = Object.assign(Object.assign({}, t ?? {}), { mouseWheelScrollSensitivity: e.mouseWheelScrollSensitivity })), e.fastScrollSensitivity !== void 0 && (t = Object.assign(Object.assign({}, t ?? {}), { fastScrollSensitivity: e.fastScrollSensitivity })), t && this.scrollableElement.updateOptions(t), e.paddingTop !== void 0 && e.paddingTop !== this.rangeMap.paddingTop) {
      const n = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), r = e.paddingTop - this.rangeMap.paddingTop;
      this.rangeMap.paddingTop = e.paddingTop, this.render(n, Math.max(0, this.lastRenderTop + r), this.lastRenderHeight, void 0, void 0, !0), this.setScrollTop(this.lastRenderTop), this.eventuallyUpdateScrollDimensions(), this.supportDynamicHeights && this._rerender(this.lastRenderTop, this.lastRenderHeight);
    }
  }
  splice(e, t, n = []) {
    if (this.splicing)
      throw new Error("Can't run recursive splices.");
    this.splicing = !0;
    try {
      return this._splice(e, t, n);
    } finally {
      this.splicing = !1, this._onDidChangeContentHeight.fire(this.contentHeight);
    }
  }
  _splice(e, t, n = []) {
    const r = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), s = { start: e, end: e + t }, o = ks.intersect(r, s), a = /* @__PURE__ */ new Map();
    for (let x = o.end - 1; x >= o.start; x--) {
      const D = this.items[x];
      if (D.dragStartDisposable.dispose(), D.checkedDisposable.dispose(), D.row) {
        let E = a.get(D.templateId);
        E || (E = [], a.set(D.templateId, E));
        const L = this.renderers.get(D.templateId);
        L && L.disposeElement && L.disposeElement(D.element, x, D.row.templateData, D.size), E.push(D.row);
      }
      D.row = null;
    }
    const l = { start: e + t, end: this.items.length }, c = ks.intersect(l, r), d = ks.relativeComplement(l, r), u = n.map((x) => ({
      id: String(this.itemId++),
      element: x,
      templateId: this.virtualDelegate.getTemplateId(x),
      size: this.virtualDelegate.getHeight(x),
      width: void 0,
      hasDynamicHeight: !!this.virtualDelegate.hasDynamicHeight && this.virtualDelegate.hasDynamicHeight(x),
      lastDynamicHeightWidth: void 0,
      row: null,
      uri: void 0,
      dropTarget: !1,
      dragStartDisposable: we.None,
      checkedDisposable: we.None
    }));
    let h;
    e === 0 && t >= this.items.length ? (this.rangeMap = new ZQ(this.rangeMap.paddingTop), this.rangeMap.splice(0, 0, u), h = this.items, this.items = u) : (this.rangeMap.splice(e, t, u), h = this.items.splice(e, t, ...u));
    const f = n.length - t, g = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), p = xB(c, f), m = ks.intersect(g, p);
    for (let x = m.start; x < m.end; x++)
      this.updateItemInDOM(this.items[x], x);
    const _ = ks.relativeComplement(p, g);
    for (const x of _)
      for (let D = x.start; D < x.end; D++)
        this.removeItemFromDOM(D);
    const b = d.map((x) => xB(x, f)), y = [{ start: e, end: e + n.length }, ...b].map((x) => ks.intersect(g, x)), S = this.getNextToLastElement(y);
    for (const x of y)
      for (let D = x.start; D < x.end; D++) {
        const E = this.items[D], L = a.get(E.templateId), k = L?.pop();
        this.insertItemInDOM(D, S, k);
      }
    for (const x of a.values())
      for (const D of x)
        this.cache.release(D);
    return this.eventuallyUpdateScrollDimensions(), this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight), h.map((x) => x.element);
  }
  eventuallyUpdateScrollDimensions() {
    this._scrollHeight = this.contentHeight, this.rowsContainer.style.height = `${this._scrollHeight}px`, this.scrollableElementUpdateDisposable || (this.scrollableElementUpdateDisposable = Cl(() => {
      this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight }), this.updateScrollWidth(), this.scrollableElementUpdateDisposable = null;
    }));
  }
  eventuallyUpdateScrollWidth() {
    if (!this.horizontalScrolling) {
      this.scrollableElementWidthDelayer.cancel();
      return;
    }
    this.scrollableElementWidthDelayer.trigger(() => this.updateScrollWidth());
  }
  updateScrollWidth() {
    if (!this.horizontalScrolling)
      return;
    let e = 0;
    for (const t of this.items)
      typeof t.width < "u" && (e = Math.max(e, t.width));
    this.scrollWidth = e, this.scrollableElement.setScrollDimensions({ scrollWidth: e === 0 ? 0 : e + 10 }), this._onDidChangeContentWidth.fire(this.scrollWidth);
  }
  rerender() {
    if (this.supportDynamicHeights) {
      for (const e of this.items)
        e.lastDynamicHeightWidth = void 0;
      this._rerender(this.lastRenderTop, this.lastRenderHeight);
    }
  }
  get length() {
    return this.items.length;
  }
  get renderHeight() {
    return this.scrollableElement.getScrollDimensions().height;
  }
  get firstVisibleIndex() {
    const e = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), t = this.rangeMap.positionAt(e.start), n = this.rangeMap.positionAt(e.start + 1);
    return n !== -1 && (n - t) / 2 + t < this.scrollTop ? e.start + 1 : e.start;
  }
  element(e) {
    return this.items[e].element;
  }
  domElement(e) {
    const t = this.items[e].row;
    return t && t.domNode;
  }
  elementHeight(e) {
    return this.items[e].size;
  }
  elementTop(e) {
    return this.rangeMap.positionAt(e);
  }
  indexAt(e) {
    return this.rangeMap.indexAt(e);
  }
  indexAfter(e) {
    return this.rangeMap.indexAfter(e);
  }
  layout(e, t) {
    const n = {
      height: typeof e == "number" ? e : U9e(this.domNode)
    };
    this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, n.scrollHeight = this.scrollHeight), this.scrollableElement.setScrollDimensions(n), typeof t < "u" && (this.renderWidth = t, this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight)), this.horizontalScrolling && this.scrollableElement.setScrollDimensions({
      width: typeof t == "number" ? t : d6(this.domNode)
    });
  }
  // Render
  render(e, t, n, r, s, o = !1) {
    const a = this.getRenderRange(t, n), l = ks.relativeComplement(a, e), c = ks.relativeComplement(e, a), d = this.getNextToLastElement(l);
    if (o) {
      const u = ks.intersect(e, a);
      for (let h = u.start; h < u.end; h++)
        this.updateItemInDOM(this.items[h], h);
    }
    this.cache.transact(() => {
      for (const u of c)
        for (let h = u.start; h < u.end; h++)
          this.removeItemFromDOM(h);
      for (const u of l)
        for (let h = u.start; h < u.end; h++)
          this.insertItemInDOM(h, d);
    }), r !== void 0 && (this.rowsContainer.style.left = `-${r}px`), this.rowsContainer.style.top = `-${t}px`, this.horizontalScrolling && s !== void 0 && (this.rowsContainer.style.width = `${Math.max(s, this.renderWidth)}px`), this.lastRenderTop = t, this.lastRenderHeight = n;
  }
  // DOM operations
  insertItemInDOM(e, t, n) {
    const r = this.items[e];
    let s = !1;
    if (!r.row)
      if (n)
        r.row = n;
      else {
        const d = this.cache.alloc(r.templateId);
        r.row = d.row, s = d.isReusingConnectedDomNode;
      }
    const o = this.accessibilityProvider.getRole(r.element) || "listitem";
    r.row.domNode.setAttribute("role", o);
    const a = this.accessibilityProvider.isChecked(r.element);
    if (typeof a == "boolean")
      r.row.domNode.setAttribute("aria-checked", String(!!a));
    else if (a) {
      const d = (u) => r.row.domNode.setAttribute("aria-checked", String(!!u));
      d(a.value), r.checkedDisposable = a.onDidChange(d);
    }
    (s || !r.row.domNode.parentElement) && (t ? this.rowsContainer.insertBefore(r.row.domNode, t) : this.rowsContainer.appendChild(r.row.domNode)), this.updateItemInDOM(r, e);
    const l = this.renderers.get(r.templateId);
    if (!l)
      throw new Error(`No renderer found for template id ${r.templateId}`);
    l?.renderElement(r.element, e, r.row.templateData, r.size);
    const c = this.dnd.getDragURI(r.element);
    r.dragStartDisposable.dispose(), r.row.domNode.draggable = !!c, c && (r.dragStartDisposable = Ie(r.row.domNode, "dragstart", (d) => this.onDragStart(r.element, c, d))), this.horizontalScrolling && (this.measureItemWidth(r), this.eventuallyUpdateScrollWidth());
  }
  measureItemWidth(e) {
    if (!e.row || !e.row.domNode)
      return;
    e.row.domNode.style.width = "fit-content", e.width = d6(e.row.domNode);
    const t = window.getComputedStyle(e.row.domNode);
    t.paddingLeft && (e.width += parseFloat(t.paddingLeft)), t.paddingRight && (e.width += parseFloat(t.paddingRight)), e.row.domNode.style.width = "";
  }
  updateItemInDOM(e, t) {
    e.row.domNode.style.top = `${this.elementTop(t)}px`, this.setRowHeight && (e.row.domNode.style.height = `${e.size}px`), this.setRowLineHeight && (e.row.domNode.style.lineHeight = `${e.size}px`), e.row.domNode.setAttribute("data-index", `${t}`), e.row.domNode.setAttribute("data-last-element", t === this.length - 1 ? "true" : "false"), e.row.domNode.setAttribute("data-parity", t % 2 === 0 ? "even" : "odd"), e.row.domNode.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(e.element, t, this.length))), e.row.domNode.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(e.element, t))), e.row.domNode.setAttribute("id", this.getElementDomId(t)), e.row.domNode.classList.toggle("drop-target", e.dropTarget);
  }
  removeItemFromDOM(e) {
    const t = this.items[e];
    if (t.dragStartDisposable.dispose(), t.checkedDisposable.dispose(), t.row) {
      const n = this.renderers.get(t.templateId);
      n && n.disposeElement && n.disposeElement(t.element, e, t.row.templateData, t.size), this.cache.release(t.row), t.row = null;
    }
    this.horizontalScrolling && this.eventuallyUpdateScrollWidth();
  }
  getScrollTop() {
    return this.scrollableElement.getScrollPosition().scrollTop;
  }
  setScrollTop(e, t) {
    this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight })), this.scrollableElement.setScrollPosition({ scrollTop: e, reuseAnimation: t });
  }
  get scrollTop() {
    return this.getScrollTop();
  }
  set scrollTop(e) {
    this.setScrollTop(e);
  }
  get scrollHeight() {
    return this._scrollHeight + (this.horizontalScrolling ? 10 : 0) + this.paddingBottom;
  }
  // Events
  get onMouseClick() {
    return qe.map(this.disposables.add(new Yt(this.domNode, "click")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseDblClick() {
    return qe.map(this.disposables.add(new Yt(this.domNode, "dblclick")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseMiddleClick() {
    return qe.filter(qe.map(this.disposables.add(new Yt(this.domNode, "auxclick")).event, (e) => this.toMouseEvent(e), this.disposables), (e) => e.browserEvent.button === 1, this.disposables);
  }
  get onMouseDown() {
    return qe.map(this.disposables.add(new Yt(this.domNode, "mousedown")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseOver() {
    return qe.map(this.disposables.add(new Yt(this.domNode, "mouseover")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseOut() {
    return qe.map(this.disposables.add(new Yt(this.domNode, "mouseout")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onContextMenu() {
    return qe.any(qe.map(this.disposables.add(new Yt(this.domNode, "contextmenu")).event, (e) => this.toMouseEvent(e), this.disposables), qe.map(this.disposables.add(new Yt(this.domNode, Wn.Contextmenu)).event, (e) => this.toGestureEvent(e), this.disposables));
  }
  get onTouchStart() {
    return qe.map(this.disposables.add(new Yt(this.domNode, "touchstart")).event, (e) => this.toTouchEvent(e), this.disposables);
  }
  get onTap() {
    return qe.map(this.disposables.add(new Yt(this.rowsContainer, Wn.Tap)).event, (e) => this.toGestureEvent(e), this.disposables);
  }
  toMouseEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), n = typeof t > "u" ? void 0 : this.items[t], r = n && n.element;
    return { browserEvent: e, index: t, element: r };
  }
  toTouchEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), n = typeof t > "u" ? void 0 : this.items[t], r = n && n.element;
    return { browserEvent: e, index: t, element: r };
  }
  toGestureEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.initialTarget || null), n = typeof t > "u" ? void 0 : this.items[t], r = n && n.element;
    return { browserEvent: e, index: t, element: r };
  }
  toDragEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), n = typeof t > "u" ? void 0 : this.items[t], r = n && n.element;
    return { browserEvent: e, index: t, element: r };
  }
  onScroll(e) {
    try {
      const t = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
      this.render(t, e.scrollTop, e.height, e.scrollLeft, e.scrollWidth), this.supportDynamicHeights && this._rerender(e.scrollTop, e.height, e.inSmoothScrolling);
    } catch (t) {
      throw console.error("Got bad scroll event:", e), t;
    }
  }
  onTouchChange(e) {
    e.preventDefault(), e.stopPropagation(), this.scrollTop -= e.translationY;
  }
  // DND
  onDragStart(e, t, n) {
    var r, s;
    if (!n.dataTransfer)
      return;
    const o = this.dnd.getDragElements(e);
    if (n.dataTransfer.effectAllowed = "copyMove", n.dataTransfer.setData(aw.TEXT, t), n.dataTransfer.setDragImage) {
      let a;
      this.dnd.getDragLabel && (a = this.dnd.getDragLabel(o, n)), typeof a > "u" && (a = String(o.length));
      const l = Re(".monaco-drag-image");
      l.textContent = a;
      const d = ((u) => {
        for (; u && !u.classList.contains("monaco-workbench"); )
          u = u.parentElement;
        return u || document.body;
      })(this.domNode);
      d.appendChild(l), n.dataTransfer.setDragImage(l, -10, -10), setTimeout(() => d.removeChild(l), 0);
    }
    this.domNode.classList.add("dragging"), this.currentDragData = new VS(o), Dp.CurrentDragAndDropData = new Cze(o), (s = (r = this.dnd).onDragStart) === null || s === void 0 || s.call(r, this.currentDragData, n);
  }
  onDragOver(e) {
    var t;
    if (e.browserEvent.preventDefault(), this.onDragLeaveTimeout.dispose(), Dp.CurrentDragAndDropData && Dp.CurrentDragAndDropData.getData() === "vscode-ui" || (this.setupDragAndDropScrollTopAnimation(e.browserEvent), !e.browserEvent.dataTransfer))
      return !1;
    if (!this.currentDragData)
      if (Dp.CurrentDragAndDropData)
        this.currentDragData = Dp.CurrentDragAndDropData;
      else {
        if (!e.browserEvent.dataTransfer.types)
          return !1;
        this.currentDragData = new yze();
      }
    const n = this.dnd.onDragOver(this.currentDragData, e.element, e.index, e.browserEvent);
    if (this.canDrop = typeof n == "boolean" ? n : n.accept, !this.canDrop)
      return this.currentDragFeedback = void 0, this.currentDragFeedbackDisposable.dispose(), !1;
    e.browserEvent.dataTransfer.dropEffect = typeof n != "boolean" && n.effect === 0 ? "copy" : "move";
    let r;
    if (typeof n != "boolean" && n.feedback ? r = n.feedback : typeof e.index > "u" ? r = [-1] : r = [e.index], r = kg(r).filter((s) => s >= -1 && s < this.length).sort((s, o) => s - o), r = r[0] === -1 ? [-1] : r, wze(this.currentDragFeedback, r))
      return !0;
    if (this.currentDragFeedback = r, this.currentDragFeedbackDisposable.dispose(), r[0] === -1)
      this.domNode.classList.add("drop-target"), this.rowsContainer.classList.add("drop-target"), this.currentDragFeedbackDisposable = Ct(() => {
        this.domNode.classList.remove("drop-target"), this.rowsContainer.classList.remove("drop-target");
      });
    else {
      for (const s of r) {
        const o = this.items[s];
        o.dropTarget = !0, (t = o.row) === null || t === void 0 || t.domNode.classList.add("drop-target");
      }
      this.currentDragFeedbackDisposable = Ct(() => {
        var s;
        for (const o of r) {
          const a = this.items[o];
          a.dropTarget = !1, (s = a.row) === null || s === void 0 || s.domNode.classList.remove("drop-target");
        }
      });
    }
    return !0;
  }
  onDragLeave(e) {
    var t, n;
    this.onDragLeaveTimeout.dispose(), this.onDragLeaveTimeout = Rg(() => this.clearDragOverFeedback(), 100, this.disposables), this.currentDragData && ((n = (t = this.dnd).onDragLeave) === null || n === void 0 || n.call(t, this.currentDragData, e.element, e.index, e.browserEvent));
  }
  onDrop(e) {
    if (!this.canDrop)
      return;
    const t = this.currentDragData;
    this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.domNode.classList.remove("dragging"), this.currentDragData = void 0, Dp.CurrentDragAndDropData = void 0, !(!t || !e.browserEvent.dataTransfer) && (e.browserEvent.preventDefault(), t.update(e.browserEvent.dataTransfer), this.dnd.drop(t, e.element, e.index, e.browserEvent));
  }
  onDragEnd(e) {
    var t, n;
    this.canDrop = !1, this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.domNode.classList.remove("dragging"), this.currentDragData = void 0, Dp.CurrentDragAndDropData = void 0, (n = (t = this.dnd).onDragEnd) === null || n === void 0 || n.call(t, e);
  }
  clearDragOverFeedback() {
    this.currentDragFeedback = void 0, this.currentDragFeedbackDisposable.dispose(), this.currentDragFeedbackDisposable = we.None;
  }
  // DND scroll top animation
  setupDragAndDropScrollTopAnimation(e) {
    if (!this.dragOverAnimationDisposable) {
      const t = Fhe(this.domNode).top;
      this.dragOverAnimationDisposable = J9e(this.animateDragAndDropScrollTop.bind(this, t));
    }
    this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationStopDisposable = Rg(() => {
      this.dragOverAnimationDisposable && (this.dragOverAnimationDisposable.dispose(), this.dragOverAnimationDisposable = void 0);
    }, 1e3, this.disposables), this.dragOverMouseY = e.pageY;
  }
  animateDragAndDropScrollTop(e) {
    if (this.dragOverMouseY === void 0)
      return;
    const t = this.dragOverMouseY - e, n = this.renderHeight - 35;
    t < 35 ? this.scrollTop += Math.max(-14, Math.floor(0.3 * (t - 35))) : t > n && (this.scrollTop += Math.min(14, Math.floor(0.3 * (t - n))));
  }
  teardownDragAndDropScrollTopAnimation() {
    this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationDisposable && (this.dragOverAnimationDisposable.dispose(), this.dragOverAnimationDisposable = void 0);
  }
  // Util
  getItemIndexFromEventTarget(e) {
    const t = this.scrollableElement.getDomNode();
    let n = e;
    for (; n instanceof HTMLElement && n !== this.rowsContainer && t.contains(n); ) {
      const r = n.getAttribute("data-index");
      if (r) {
        const s = Number(r);
        if (!isNaN(s))
          return s;
      }
      n = n.parentElement;
    }
  }
  getRenderRange(e, t) {
    return {
      start: this.rangeMap.indexAt(e),
      end: this.rangeMap.indexAfter(e + t - 1)
    };
  }
  /**
   * Given a stable rendered state, checks every rendered element whether it needs
   * to be probed for dynamic height. Adjusts scroll height and top if necessary.
   */
  _rerender(e, t, n) {
    const r = this.getRenderRange(e, t);
    let s, o;
    e === this.elementTop(r.start) ? (s = r.start, o = 0) : r.end - r.start > 1 && (s = r.start + 1, o = this.elementTop(s) - e);
    let a = 0;
    for (; ; ) {
      const l = this.getRenderRange(e, t);
      let c = !1;
      for (let d = l.start; d < l.end; d++) {
        const u = this.probeDynamicHeight(d);
        u !== 0 && this.rangeMap.splice(d, 1, [this.items[d]]), a += u, c = c || u !== 0;
      }
      if (!c) {
        a !== 0 && this.eventuallyUpdateScrollDimensions();
        const d = ks.relativeComplement(r, l);
        for (const h of d)
          for (let f = h.start; f < h.end; f++)
            this.items[f].row && this.removeItemFromDOM(f);
        const u = ks.relativeComplement(l, r);
        for (const h of u)
          for (let f = h.start; f < h.end; f++) {
            const g = f + 1, p = g < this.items.length ? this.items[g].row : null, m = p ? p.domNode : null;
            this.insertItemInDOM(f, m);
          }
        for (let h = l.start; h < l.end; h++)
          this.items[h].row && this.updateItemInDOM(this.items[h], h);
        if (typeof s == "number") {
          const h = this.scrollable.getFutureScrollPosition().scrollTop - e, f = this.elementTop(s) - o + h;
          this.setScrollTop(f, n);
        }
        this._onDidChangeContentHeight.fire(this.contentHeight);
        return;
      }
    }
  }
  probeDynamicHeight(e) {
    var t, n, r;
    const s = this.items[e];
    if (this.virtualDelegate.getDynamicHeight) {
      const c = this.virtualDelegate.getDynamicHeight(s.element);
      if (c !== null) {
        const d = s.size;
        return s.size = c, s.lastDynamicHeightWidth = this.renderWidth, c - d;
      }
    }
    if (!s.hasDynamicHeight || s.lastDynamicHeightWidth === this.renderWidth || this.virtualDelegate.hasDynamicHeight && !this.virtualDelegate.hasDynamicHeight(s.element))
      return 0;
    const o = s.size;
    if (s.row)
      return s.row.domNode.style.height = "", s.size = s.row.domNode.offsetHeight, s.lastDynamicHeightWidth = this.renderWidth, s.size - o;
    const { row: a } = this.cache.alloc(s.templateId);
    a.domNode.style.height = "", this.rowsContainer.appendChild(a.domNode);
    const l = this.renderers.get(s.templateId);
    if (!l)
      throw new gr("Missing renderer for templateId: " + s.templateId);
    return l.renderElement(s.element, e, a.templateData, void 0), s.size = a.domNode.offsetHeight, (t = l.disposeElement) === null || t === void 0 || t.call(l, s.element, e, a.templateData, void 0), (r = (n = this.virtualDelegate).setDynamicHeight) === null || r === void 0 || r.call(n, s.element, s.size), s.lastDynamicHeightWidth = this.renderWidth, this.rowsContainer.removeChild(a.domNode), this.cache.release(a), s.size - o;
  }
  getNextToLastElement(e) {
    const t = e[e.length - 1];
    if (!t)
      return null;
    const n = this.items[t.end];
    return !n || !n.row ? null : n.row.domNode;
  }
  getElementDomId(e) {
    return `${this.domId}_${e}`;
  }
  // Dispose
  dispose() {
    var e, t;
    for (const n of this.items)
      if (n.dragStartDisposable.dispose(), n.checkedDisposable.dispose(), n.row) {
        const r = this.renderers.get(n.row.templateId);
        r && ((e = r.disposeElement) === null || e === void 0 || e.call(r, n.element, -1, n.row.templateData, void 0), r.disposeTemplate(n.row.templateData));
      }
    this.items = [], this.domNode && this.domNode.parentNode && this.domNode.parentNode.removeChild(this.domNode), (t = this.dragOverAnimationDisposable) === null || t === void 0 || t.dispose(), this.disposables.dispose();
  }
}
Tl.InstanceCount = 0;
df([
  cr
], Tl.prototype, "onMouseClick", null);
df([
  cr
], Tl.prototype, "onMouseDblClick", null);
df([
  cr
], Tl.prototype, "onMouseMiddleClick", null);
df([
  cr
], Tl.prototype, "onMouseDown", null);
df([
  cr
], Tl.prototype, "onMouseOver", null);
df([
  cr
], Tl.prototype, "onMouseOut", null);
df([
  cr
], Tl.prototype, "onContextMenu", null);
df([
  cr
], Tl.prototype, "onTouchStart", null);
df([
  cr
], Tl.prototype, "onTap", null);
var F0 = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, QQ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class xze {
  constructor(e) {
    this.trait = e, this.renderedElements = [];
  }
  get templateId() {
    return `template:${this.trait.name}`;
  }
  renderTemplate(e) {
    return e;
  }
  renderElement(e, t, n) {
    const r = this.renderedElements.findIndex((s) => s.templateData === n);
    if (r >= 0) {
      const s = this.renderedElements[r];
      this.trait.unrender(n), s.index = t;
    } else {
      const s = { index: t, templateData: n };
      this.renderedElements.push(s);
    }
    this.trait.renderIndex(t, n);
  }
  splice(e, t, n) {
    const r = [];
    for (const s of this.renderedElements)
      s.index < e ? r.push(s) : s.index >= e + t && r.push({
        index: s.index + n - t,
        templateData: s.templateData
      });
    this.renderedElements = r;
  }
  renderIndexes(e) {
    for (const { index: t, templateData: n } of this.renderedElements)
      e.indexOf(t) > -1 && this.trait.renderIndex(t, n);
  }
  disposeTemplate(e) {
    const t = this.renderedElements.findIndex((n) => n.templateData === e);
    t < 0 || this.renderedElements.splice(t, 1);
  }
}
let FL = class {
  get name() {
    return this._trait;
  }
  get renderer() {
    return new xze(this);
  }
  constructor(e) {
    this._trait = e, this.length = 0, this.indexes = [], this.sortedIndexes = [], this._onChange = new pe(), this.onChange = this._onChange.event;
  }
  splice(e, t, n) {
    var r;
    t = Math.max(0, Math.min(t, this.length - e));
    const s = n.length - t, o = e + t, a = [];
    let l = 0;
    for (; l < this.sortedIndexes.length && this.sortedIndexes[l] < e; )
      a.push(this.sortedIndexes[l++]);
    for (let d = 0; d < n.length; d++)
      n[d] && a.push(d + e);
    for (; l < this.sortedIndexes.length && this.sortedIndexes[l] >= o; )
      a.push(this.sortedIndexes[l++] + s);
    const c = this.length + s;
    if (this.sortedIndexes.length > 0 && a.length === 0 && c > 0) {
      const d = (r = this.sortedIndexes.find((u) => u >= e)) !== null && r !== void 0 ? r : c - 1;
      a.push(Math.min(d, c - 1));
    }
    this.renderer.splice(e, t, n.length), this._set(a, a), this.length = c;
  }
  renderIndex(e, t) {
    t.classList.toggle(this._trait, this.contains(e));
  }
  unrender(e) {
    e.classList.remove(this._trait);
  }
  /**
   * Sets the indexes which should have this trait.
   *
   * @param indexes Indexes which should have this trait.
   * @return The old indexes which had this trait.
   */
  set(e, t) {
    return this._set(e, [...e].sort($Q), t);
  }
  _set(e, t, n) {
    const r = this.indexes, s = this.sortedIndexes;
    this.indexes = e, this.sortedIndexes = t;
    const o = DB(s, e);
    return this.renderer.renderIndexes(o), this._onChange.fire({ indexes: e, browserEvent: n }), r;
  }
  get() {
    return this.indexes;
  }
  contains(e) {
    return vy(this.sortedIndexes, e, $Q) >= 0;
  }
  dispose() {
    An(this._onChange);
  }
};
F0([
  cr
], FL.prototype, "renderer", null);
class Dze extends FL {
  constructor(e) {
    super("selected"), this.setAriaSelected = e;
  }
  renderIndex(e, t) {
    super.renderIndex(e, t), this.setAriaSelected && (this.contains(e) ? t.setAttribute("aria-selected", "true") : t.setAttribute("aria-selected", "false"));
  }
}
class sT {
  constructor(e, t, n) {
    this.trait = e, this.view = t, this.identityProvider = n;
  }
  splice(e, t, n) {
    if (!this.identityProvider)
      return this.trait.splice(e, t, new Array(n.length).fill(!1));
    const r = this.trait.get().map((a) => this.identityProvider.getId(this.view.element(a)).toString());
    if (r.length === 0)
      return this.trait.splice(e, t, new Array(n.length).fill(!1));
    const s = new Set(r), o = n.map((a) => s.has(this.identityProvider.getId(a).toString()));
    this.trait.splice(e, t, o);
  }
}
function Cg(i) {
  return i.tagName === "INPUT" || i.tagName === "TEXTAREA";
}
function cv(i) {
  return i.classList.contains("monaco-editor") ? !0 : i.classList.contains("monaco-list") || !i.parentElement ? !1 : cv(i.parentElement);
}
function fpe(i) {
  return i.tagName === "A" && i.classList.contains("monaco-button") || i.tagName === "DIV" && i.classList.contains("monaco-button-dropdown") ? !0 : i.classList.contains("monaco-list") || !i.parentElement ? !1 : fpe(i.parentElement);
}
class gpe {
  get onKeyDown() {
    return qe.chain(this.disposables.add(new Yt(this.view.domNode, "keydown")).event, (e) => e.filter((t) => !Cg(t.target)).map((t) => new Xn(t)));
  }
  constructor(e, t, n) {
    this.list = e, this.view = t, this.disposables = new Ne(), this.multipleSelectionDisposables = new Ne(), this.multipleSelectionSupport = n.multipleSelectionSupport, this.disposables.add(this.onKeyDown((r) => {
      switch (r.keyCode) {
        case 3:
          return this.onEnter(r);
        case 16:
          return this.onUpArrow(r);
        case 18:
          return this.onDownArrow(r);
        case 11:
          return this.onPageUpArrow(r);
        case 12:
          return this.onPageDownArrow(r);
        case 9:
          return this.onEscape(r);
        case 31:
          this.multipleSelectionSupport && (sn ? r.metaKey : r.ctrlKey) && this.onCtrlA(r);
      }
    }));
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && (this.multipleSelectionSupport = e.multipleSelectionSupport);
  }
  onEnter(e) {
    e.preventDefault(), e.stopPropagation(), this.list.setSelection(this.list.getFocus(), e.browserEvent);
  }
  onUpArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusPrevious(1, !1, e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onDownArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusNext(1, !1, e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onPageUpArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusPreviousPage(e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onPageDownArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusNextPage(e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onCtrlA(e) {
    e.preventDefault(), e.stopPropagation(), this.list.setSelection(io(this.list.length), e.browserEvent), this.list.setAnchor(void 0), this.view.domNode.focus();
  }
  onEscape(e) {
    this.list.getSelection().length && (e.preventDefault(), e.stopPropagation(), this.list.setSelection([], e.browserEvent), this.list.setAnchor(void 0), this.view.domNode.focus());
  }
  dispose() {
    this.disposables.dispose(), this.multipleSelectionDisposables.dispose();
  }
}
F0([
  cr
], gpe.prototype, "onKeyDown", null);
var qd;
(function(i) {
  i[i.Automatic = 0] = "Automatic", i[i.Trigger = 1] = "Trigger";
})(qd || (qd = {}));
var dv;
(function(i) {
  i[i.Idle = 0] = "Idle", i[i.Typing = 1] = "Typing";
})(dv || (dv = {}));
const Eze = new class {
  mightProducePrintableCharacter(i) {
    return i.ctrlKey || i.metaKey || i.altKey ? !1 : i.keyCode >= 31 && i.keyCode <= 56 || i.keyCode >= 21 && i.keyCode <= 30 || i.keyCode >= 98 && i.keyCode <= 107 || i.keyCode >= 85 && i.keyCode <= 95;
  }
}();
class Lze {
  constructor(e, t, n, r, s) {
    this.list = e, this.view = t, this.keyboardNavigationLabelProvider = n, this.keyboardNavigationEventFilter = r, this.delegate = s, this.enabled = !1, this.state = dv.Idle, this.mode = qd.Automatic, this.triggered = !1, this.previouslyFocused = -1, this.enabledDisposables = new Ne(), this.disposables = new Ne(), this.updateOptions(e.options);
  }
  updateOptions(e) {
    var t, n;
    !((t = e.typeNavigationEnabled) !== null && t !== void 0) || t ? this.enable() : this.disable(), this.mode = (n = e.typeNavigationMode) !== null && n !== void 0 ? n : qd.Automatic;
  }
  enable() {
    if (this.enabled)
      return;
    let e = !1;
    const t = qe.chain(this.enabledDisposables.add(new Yt(this.view.domNode, "keydown")).event, (s) => s.filter((o) => !Cg(o.target)).filter(() => this.mode === qd.Automatic || this.triggered).map((o) => new Xn(o)).filter((o) => e || this.keyboardNavigationEventFilter(o)).filter((o) => this.delegate.mightProducePrintableCharacter(o)).forEach((o) => Tt.stop(o, !0)).map((o) => o.browserEvent.key)), n = qe.debounce(t, () => null, 800, void 0, void 0, void 0, this.enabledDisposables);
    qe.reduce(qe.any(t, n), (s, o) => o === null ? null : (s || "") + o, void 0, this.enabledDisposables)(this.onInput, this, this.enabledDisposables), n(this.onClear, this, this.enabledDisposables), t(() => e = !0, void 0, this.enabledDisposables), n(() => e = !1, void 0, this.enabledDisposables), this.enabled = !0, this.triggered = !1;
  }
  disable() {
    this.enabled && (this.enabledDisposables.clear(), this.enabled = !1, this.triggered = !1);
  }
  onClear() {
    var e;
    const t = this.list.getFocus();
    if (t.length > 0 && t[0] === this.previouslyFocused) {
      const n = (e = this.list.options.accessibilityProvider) === null || e === void 0 ? void 0 : e.getAriaLabel(this.list.element(t[0]));
      n && Fs(n);
    }
    this.previouslyFocused = -1;
  }
  onInput(e) {
    if (!e) {
      this.state = dv.Idle, this.triggered = !1;
      return;
    }
    const t = this.list.getFocus(), n = t.length > 0 ? t[0] : 0, r = this.state === dv.Idle ? 1 : 0;
    this.state = dv.Typing;
    for (let s = 0; s < this.list.length; s++) {
      const o = (n + s + r) % this.list.length, a = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(this.view.element(o)), l = a && a.toString();
      if (this.list.options.typeNavigationEnabled) {
        if (typeof l < "u") {
          if (lw(e, l)) {
            this.previouslyFocused = n, this.list.setFocus([o]), this.list.reveal(o);
            return;
          }
          const c = xje(e, l);
          if (c && c[0].end - c[0].start > 1 && c.length === 1) {
            this.previouslyFocused = n, this.list.setFocus([o]), this.list.reveal(o);
            return;
          }
        }
      } else if (typeof l > "u" || lw(e, l)) {
        this.previouslyFocused = n, this.list.setFocus([o]), this.list.reveal(o);
        return;
      }
    }
  }
  dispose() {
    this.disable(), this.enabledDisposables.dispose(), this.disposables.dispose();
  }
}
class Ize {
  constructor(e, t) {
    this.list = e, this.view = t, this.disposables = new Ne();
    const n = qe.chain(this.disposables.add(new Yt(t.domNode, "keydown")).event, (s) => s.filter((o) => !Cg(o.target)).map((o) => new Xn(o)));
    qe.chain(n, (s) => s.filter((o) => o.keyCode === 2 && !o.ctrlKey && !o.metaKey && !o.shiftKey && !o.altKey))(this.onTab, this, this.disposables);
  }
  onTab(e) {
    if (e.target !== this.view.domNode)
      return;
    const t = this.list.getFocus();
    if (t.length === 0)
      return;
    const n = this.view.domElement(t[0]);
    if (!n)
      return;
    const r = n.querySelector("[tabIndex]");
    if (!r || !(r instanceof HTMLElement) || r.tabIndex === -1)
      return;
    const s = window.getComputedStyle(r);
    s.visibility === "hidden" || s.display === "none" || (e.preventDefault(), e.stopPropagation(), r.focus());
  }
  dispose() {
    this.disposables.dispose();
  }
}
function ppe(i) {
  return sn ? i.browserEvent.metaKey : i.browserEvent.ctrlKey;
}
function mpe(i) {
  return i.browserEvent.shiftKey;
}
function Aze(i) {
  return i instanceof MouseEvent && i.button === 2;
}
const JQ = {
  isSelectionSingleChangeEvent: ppe,
  isSelectionRangeChangeEvent: mpe
};
class vpe {
  constructor(e) {
    this.list = e, this.disposables = new Ne(), this._onPointer = new pe(), this.onPointer = this._onPointer.event, e.options.multipleSelectionSupport !== !1 && (this.multipleSelectionController = this.list.options.multipleSelectionController || JQ), this.mouseSupport = typeof e.options.mouseSupport > "u" || !!e.options.mouseSupport, this.mouseSupport && (e.onMouseDown(this.onMouseDown, this, this.disposables), e.onContextMenu(this.onContextMenu, this, this.disposables), e.onMouseDblClick(this.onDoubleClick, this, this.disposables), e.onTouchStart(this.onMouseDown, this, this.disposables), this.disposables.add(Vn.addTarget(e.getHTMLElement()))), qe.any(e.onMouseClick, e.onMouseMiddleClick, e.onTap)(this.onViewPointer, this, this.disposables);
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && (this.multipleSelectionController = void 0, e.multipleSelectionSupport && (this.multipleSelectionController = this.list.options.multipleSelectionController || JQ));
  }
  isSelectionSingleChangeEvent(e) {
    return this.multipleSelectionController ? this.multipleSelectionController.isSelectionSingleChangeEvent(e) : !1;
  }
  isSelectionRangeChangeEvent(e) {
    return this.multipleSelectionController ? this.multipleSelectionController.isSelectionRangeChangeEvent(e) : !1;
  }
  isSelectionChangeEvent(e) {
    return this.isSelectionSingleChangeEvent(e) || this.isSelectionRangeChangeEvent(e);
  }
  onMouseDown(e) {
    cv(e.browserEvent.target) || document.activeElement !== e.browserEvent.target && this.list.domFocus();
  }
  onContextMenu(e) {
    if (Cg(e.browserEvent.target) || cv(e.browserEvent.target))
      return;
    const t = typeof e.index > "u" ? [] : [e.index];
    this.list.setFocus(t, e.browserEvent);
  }
  onViewPointer(e) {
    if (!this.mouseSupport || Cg(e.browserEvent.target) || cv(e.browserEvent.target) || e.browserEvent.isHandledByList)
      return;
    e.browserEvent.isHandledByList = !0;
    const t = e.index;
    if (typeof t > "u") {
      this.list.setFocus([], e.browserEvent), this.list.setSelection([], e.browserEvent), this.list.setAnchor(void 0);
      return;
    }
    if (this.isSelectionChangeEvent(e))
      return this.changeSelection(e);
    this.list.setFocus([t], e.browserEvent), this.list.setAnchor(t), Aze(e.browserEvent) || this.list.setSelection([t], e.browserEvent), this._onPointer.fire(e);
  }
  onDoubleClick(e) {
    if (Cg(e.browserEvent.target) || cv(e.browserEvent.target) || this.isSelectionChangeEvent(e) || e.browserEvent.isHandledByList)
      return;
    e.browserEvent.isHandledByList = !0;
    const t = this.list.getFocus();
    this.list.setSelection(t, e.browserEvent);
  }
  changeSelection(e) {
    const t = e.index;
    let n = this.list.getAnchor();
    if (this.isSelectionRangeChangeEvent(e)) {
      if (typeof n > "u") {
        const d = this.list.getFocus()[0];
        n = d ?? t, this.list.setAnchor(n);
      }
      const r = Math.min(n, t), s = Math.max(n, t), o = io(r, s + 1), a = this.list.getSelection(), l = Nze(DB(a, [n]), n);
      if (l.length === 0)
        return;
      const c = DB(o, Pze(a, l));
      this.list.setSelection(c, e.browserEvent), this.list.setFocus([t], e.browserEvent);
    } else if (this.isSelectionSingleChangeEvent(e)) {
      const r = this.list.getSelection(), s = r.filter((o) => o !== t);
      this.list.setFocus([t]), this.list.setAnchor(t), r.length === s.length ? this.list.setSelection([...s, t], e.browserEvent) : this.list.setSelection(s, e.browserEvent);
    }
  }
  dispose() {
    this.disposables.dispose();
  }
}
class _pe {
  constructor(e, t) {
    this.styleElement = e, this.selectorSuffix = t;
  }
  style(e) {
    var t, n;
    const r = this.selectorSuffix && `.${this.selectorSuffix}`, s = [];
    e.listBackground && s.push(`.monaco-list${r} .monaco-list-rows { background: ${e.listBackground}; }`), e.listFocusBackground && (s.push(`.monaco-list${r}:focus .monaco-list-row.focused { background-color: ${e.listFocusBackground}; }`), s.push(`.monaco-list${r}:focus .monaco-list-row.focused:hover { background-color: ${e.listFocusBackground}; }`)), e.listFocusForeground && s.push(`.monaco-list${r}:focus .monaco-list-row.focused { color: ${e.listFocusForeground}; }`), e.listActiveSelectionBackground && (s.push(`.monaco-list${r}:focus .monaco-list-row.selected { background-color: ${e.listActiveSelectionBackground}; }`), s.push(`.monaco-list${r}:focus .monaco-list-row.selected:hover { background-color: ${e.listActiveSelectionBackground}; }`)), e.listActiveSelectionForeground && s.push(`.monaco-list${r}:focus .monaco-list-row.selected { color: ${e.listActiveSelectionForeground}; }`), e.listActiveSelectionIconForeground && s.push(`.monaco-list${r}:focus .monaco-list-row.selected .codicon { color: ${e.listActiveSelectionIconForeground}; }`), e.listFocusAndSelectionBackground && s.push(`
				.monaco-drag-image,
				.monaco-list${r}:focus .monaco-list-row.selected.focused { background-color: ${e.listFocusAndSelectionBackground}; }
			`), e.listFocusAndSelectionForeground && s.push(`
				.monaco-drag-image,
				.monaco-list${r}:focus .monaco-list-row.selected.focused { color: ${e.listFocusAndSelectionForeground}; }
			`), e.listInactiveFocusForeground && (s.push(`.monaco-list${r} .monaco-list-row.focused { color:  ${e.listInactiveFocusForeground}; }`), s.push(`.monaco-list${r} .monaco-list-row.focused:hover { color:  ${e.listInactiveFocusForeground}; }`)), e.listInactiveSelectionIconForeground && s.push(`.monaco-list${r} .monaco-list-row.focused .codicon { color:  ${e.listInactiveSelectionIconForeground}; }`), e.listInactiveFocusBackground && (s.push(`.monaco-list${r} .monaco-list-row.focused { background-color:  ${e.listInactiveFocusBackground}; }`), s.push(`.monaco-list${r} .monaco-list-row.focused:hover { background-color:  ${e.listInactiveFocusBackground}; }`)), e.listInactiveSelectionBackground && (s.push(`.monaco-list${r} .monaco-list-row.selected { background-color:  ${e.listInactiveSelectionBackground}; }`), s.push(`.monaco-list${r} .monaco-list-row.selected:hover { background-color:  ${e.listInactiveSelectionBackground}; }`)), e.listInactiveSelectionForeground && s.push(`.monaco-list${r} .monaco-list-row.selected { color: ${e.listInactiveSelectionForeground}; }`), e.listHoverBackground && s.push(`.monaco-list${r}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { background-color: ${e.listHoverBackground}; }`), e.listHoverForeground && s.push(`.monaco-list${r}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { color:  ${e.listHoverForeground}; }`);
    const o = Dm(e.listFocusAndSelectionOutline, Dm(e.listSelectionOutline, (t = e.listFocusOutline) !== null && t !== void 0 ? t : ""));
    o && s.push(`.monaco-list${r}:focus .monaco-list-row.focused.selected { outline: 1px solid ${o}; outline-offset: -1px;}`), e.listFocusOutline && s.push(`
				.monaco-drag-image,
				.monaco-list${r}:focus .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }
				.monaco-workbench.context-menu-visible .monaco-list${r}.last-focused .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }
			`);
    const a = Dm(e.listSelectionOutline, (n = e.listInactiveFocusOutline) !== null && n !== void 0 ? n : "");
    a && s.push(`.monaco-list${r} .monaco-list-row.focused.selected { outline: 1px dotted ${a}; outline-offset: -1px; }`), e.listSelectionOutline && s.push(`.monaco-list${r} .monaco-list-row.selected { outline: 1px dotted ${e.listSelectionOutline}; outline-offset: -1px; }`), e.listInactiveFocusOutline && s.push(`.monaco-list${r} .monaco-list-row.focused { outline: 1px dotted ${e.listInactiveFocusOutline}; outline-offset: -1px; }`), e.listHoverOutline && s.push(`.monaco-list${r} .monaco-list-row:hover { outline: 1px dashed ${e.listHoverOutline}; outline-offset: -1px; }`), e.listDropBackground && s.push(`
				.monaco-list${r}.drop-target,
				.monaco-list${r} .monaco-list-rows.drop-target,
				.monaco-list${r} .monaco-list-row.drop-target { background-color: ${e.listDropBackground} !important; color: inherit !important; }
			`), e.tableColumnsBorder && s.push(`
				.monaco-table > .monaco-split-view2,
				.monaco-table > .monaco-split-view2 .monaco-sash.vertical::before,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: ${e.tableColumnsBorder};
				}

				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: transparent;
				}
			`), e.tableOddRowsBackgroundColor && s.push(`
				.monaco-table .monaco-list-row[data-parity=odd]:not(.focused):not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(:focus) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(.focused) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr {
					background-color: ${e.tableOddRowsBackgroundColor};
				}
			`), this.styleElement.textContent = s.join(`
`);
  }
}
const kze = {
  listFocusBackground: "#7FB0D0",
  listActiveSelectionBackground: "#0E639C",
  listActiveSelectionForeground: "#FFFFFF",
  listActiveSelectionIconForeground: "#FFFFFF",
  listFocusAndSelectionOutline: "#90C2F9",
  listFocusAndSelectionBackground: "#094771",
  listFocusAndSelectionForeground: "#FFFFFF",
  listInactiveSelectionBackground: "#3F3F46",
  listInactiveSelectionIconForeground: "#FFFFFF",
  listHoverBackground: "#2A2D2E",
  listDropBackground: "#383B3D",
  treeIndentGuidesStroke: "#a9a9a9",
  treeInactiveIndentGuidesStroke: ye.fromHex("#a9a9a9").transparent(0.4).toString(),
  tableColumnsBorder: ye.fromHex("#cccccc").transparent(0.2).toString(),
  tableOddRowsBackgroundColor: ye.fromHex("#cccccc").transparent(0.04).toString(),
  listBackground: void 0,
  listFocusForeground: void 0,
  listInactiveSelectionForeground: void 0,
  listInactiveFocusForeground: void 0,
  listInactiveFocusBackground: void 0,
  listHoverForeground: void 0,
  listFocusOutline: void 0,
  listInactiveFocusOutline: void 0,
  listSelectionOutline: void 0,
  listHoverOutline: void 0
}, Tze = {
  keyboardSupport: !0,
  mouseSupport: !0,
  multipleSelectionSupport: !0,
  dnd: {
    getDragURI() {
      return null;
    },
    onDragStart() {
    },
    onDragOver() {
      return !1;
    },
    drop() {
    },
    dispose() {
    }
  }
};
function Nze(i, e) {
  const t = i.indexOf(e);
  if (t === -1)
    return [];
  const n = [];
  let r = t - 1;
  for (; r >= 0 && i[r] === e - (t - r); )
    n.push(i[r--]);
  for (n.reverse(), r = t; r < i.length && i[r] === e + (r - t); )
    n.push(i[r++]);
  return n;
}
function DB(i, e) {
  const t = [];
  let n = 0, r = 0;
  for (; n < i.length || r < e.length; )
    if (n >= i.length)
      t.push(e[r++]);
    else if (r >= e.length)
      t.push(i[n++]);
    else if (i[n] === e[r]) {
      t.push(i[n]), n++, r++;
      continue;
    } else i[n] < e[r] ? t.push(i[n++]) : t.push(e[r++]);
  return t;
}
function Pze(i, e) {
  const t = [];
  let n = 0, r = 0;
  for (; n < i.length || r < e.length; )
    if (n >= i.length)
      t.push(e[r++]);
    else if (r >= e.length)
      t.push(i[n++]);
    else if (i[n] === e[r]) {
      n++, r++;
      continue;
    } else i[n] < e[r] ? t.push(i[n++]) : r++;
  return t;
}
const $Q = (i, e) => i - e;
class Oze {
  constructor(e, t) {
    this._templateId = e, this.renderers = t;
  }
  get templateId() {
    return this._templateId;
  }
  renderTemplate(e) {
    return this.renderers.map((t) => t.renderTemplate(e));
  }
  renderElement(e, t, n, r) {
    let s = 0;
    for (const o of this.renderers)
      o.renderElement(e, t, n[s++], r);
  }
  disposeElement(e, t, n, r) {
    var s;
    let o = 0;
    for (const a of this.renderers)
      (s = a.disposeElement) === null || s === void 0 || s.call(a, e, t, n[o], r), o += 1;
  }
  disposeTemplate(e) {
    let t = 0;
    for (const n of this.renderers)
      n.disposeTemplate(e[t++]);
  }
}
class Mze {
  constructor(e) {
    this.accessibilityProvider = e, this.templateId = "a18n";
  }
  renderTemplate(e) {
    return e;
  }
  renderElement(e, t, n) {
    const r = this.accessibilityProvider.getAriaLabel(e);
    r ? n.setAttribute("aria-label", r) : n.removeAttribute("aria-label");
    const s = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(e);
    typeof s == "number" ? n.setAttribute("aria-level", `${s}`) : n.removeAttribute("aria-level");
  }
  disposeTemplate(e) {
  }
}
class Rze {
  constructor(e, t) {
    this.list = e, this.dnd = t;
  }
  getDragElements(e) {
    const t = this.list.getSelectedElements();
    return t.indexOf(e) > -1 ? t : [e];
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel)
      return this.dnd.getDragLabel(e, t);
  }
  onDragStart(e, t) {
    var n, r;
    (r = (n = this.dnd).onDragStart) === null || r === void 0 || r.call(n, e, t);
  }
  onDragOver(e, t, n, r) {
    return this.dnd.onDragOver(e, t, n, r);
  }
  onDragLeave(e, t, n, r) {
    var s, o;
    (o = (s = this.dnd).onDragLeave) === null || o === void 0 || o.call(s, e, t, n, r);
  }
  onDragEnd(e) {
    var t, n;
    (n = (t = this.dnd).onDragEnd) === null || n === void 0 || n.call(t, e);
  }
  drop(e, t, n, r) {
    this.dnd.drop(e, t, n, r);
  }
  dispose() {
    this.dnd.dispose();
  }
}
class pc {
  get onDidChangeFocus() {
    return qe.map(this.eventBufferer.wrapEvent(this.focus.onChange), (e) => this.toListEvent(e), this.disposables);
  }
  get onDidChangeSelection() {
    return qe.map(this.eventBufferer.wrapEvent(this.selection.onChange), (e) => this.toListEvent(e), this.disposables);
  }
  get domId() {
    return this.view.domId;
  }
  get onDidScroll() {
    return this.view.onDidScroll;
  }
  get onMouseClick() {
    return this.view.onMouseClick;
  }
  get onMouseDblClick() {
    return this.view.onMouseDblClick;
  }
  get onMouseMiddleClick() {
    return this.view.onMouseMiddleClick;
  }
  get onPointer() {
    return this.mouseController.onPointer;
  }
  get onMouseDown() {
    return this.view.onMouseDown;
  }
  get onMouseOver() {
    return this.view.onMouseOver;
  }
  get onMouseOut() {
    return this.view.onMouseOut;
  }
  get onTouchStart() {
    return this.view.onTouchStart;
  }
  get onTap() {
    return this.view.onTap;
  }
  /**
   * Possible context menu trigger events:
   * - ContextMenu key
   * - Shift F10
   * - Ctrl Option Shift M (macOS with VoiceOver)
   * - Mouse right click
   */
  get onContextMenu() {
    let e = !1;
    const t = qe.chain(this.disposables.add(new Yt(this.view.domNode, "keydown")).event, (s) => s.map((o) => new Xn(o)).filter((o) => e = o.keyCode === 58 || o.shiftKey && o.keyCode === 68).map((o) => Tt.stop(o, !0)).filter(() => !1)), n = qe.chain(this.disposables.add(new Yt(this.view.domNode, "keyup")).event, (s) => s.forEach(() => e = !1).map((o) => new Xn(o)).filter((o) => o.keyCode === 58 || o.shiftKey && o.keyCode === 68).map((o) => Tt.stop(o, !0)).map(({ browserEvent: o }) => {
      const a = this.getFocus(), l = a.length ? a[0] : void 0, c = typeof l < "u" ? this.view.element(l) : void 0, d = typeof l < "u" ? this.view.domElement(l) : this.view.domNode;
      return { index: l, element: c, anchor: d, browserEvent: o };
    })), r = qe.chain(this.view.onContextMenu, (s) => s.filter((o) => !e).map(({ element: o, index: a, browserEvent: l }) => ({ element: o, index: a, anchor: new cl(l), browserEvent: l })));
    return qe.any(t, n, r);
  }
  get onKeyDown() {
    return this.disposables.add(new Yt(this.view.domNode, "keydown")).event;
  }
  get onDidFocus() {
    return qe.signal(this.disposables.add(new Yt(this.view.domNode, "focus", !0)).event);
  }
  constructor(e, t, n, r, s = Tze) {
    var o, a, l, c;
    this.user = e, this._options = s, this.focus = new FL("focused"), this.anchor = new FL("anchor"), this.eventBufferer = new Pj(), this._ariaLabel = "", this.disposables = new Ne(), this._onDidDispose = new pe(), this.onDidDispose = this._onDidDispose.event;
    const d = this._options.accessibilityProvider && this._options.accessibilityProvider.getWidgetRole ? (o = this._options.accessibilityProvider) === null || o === void 0 ? void 0 : o.getWidgetRole() : "list";
    this.selection = new Dze(d !== "listbox");
    const u = [this.focus.renderer, this.selection.renderer];
    this.accessibilityProvider = s.accessibilityProvider, this.accessibilityProvider && (u.push(new Mze(this.accessibilityProvider)), (l = (a = this.accessibilityProvider).onDidChangeActiveDescendant) === null || l === void 0 || l.call(a, this.onDidChangeActiveDescendant, this, this.disposables)), r = r.map((f) => new Oze(f.templateId, [...u, f]));
    const h = Object.assign(Object.assign({}, s), { dnd: s.dnd && new Rze(this, s.dnd) });
    if (this.view = this.createListView(t, n, r, h), this.view.domNode.setAttribute("role", d), s.styleController)
      this.styleController = s.styleController(this.view.domId);
    else {
      const f = yl(this.view.domNode);
      this.styleController = new _pe(f, this.view.domId);
    }
    if (this.spliceable = new pze([
      new sT(this.focus, this.view, s.identityProvider),
      new sT(this.selection, this.view, s.identityProvider),
      new sT(this.anchor, this.view, s.identityProvider),
      this.view
    ]), this.disposables.add(this.focus), this.disposables.add(this.selection), this.disposables.add(this.anchor), this.disposables.add(this.view), this.disposables.add(this._onDidDispose), this.disposables.add(new Ize(this, this.view)), (typeof s.keyboardSupport != "boolean" || s.keyboardSupport) && (this.keyboardController = new gpe(this, this.view, s), this.disposables.add(this.keyboardController)), s.keyboardNavigationLabelProvider) {
      const f = s.keyboardNavigationDelegate || Eze;
      this.typeNavigationController = new Lze(this, this.view, s.keyboardNavigationLabelProvider, (c = s.keyboardNavigationEventFilter) !== null && c !== void 0 ? c : () => !0, f), this.disposables.add(this.typeNavigationController);
    }
    this.mouseController = this.createMouseController(s), this.disposables.add(this.mouseController), this.onDidChangeFocus(this._onFocusChange, this, this.disposables), this.onDidChangeSelection(this._onSelectionChange, this, this.disposables), this.accessibilityProvider && (this.ariaLabel = this.accessibilityProvider.getWidgetAriaLabel()), this._options.multipleSelectionSupport !== !1 && this.view.domNode.setAttribute("aria-multiselectable", "true");
  }
  createListView(e, t, n, r) {
    return new Tl(e, t, n, r);
  }
  createMouseController(e) {
    return new vpe(this);
  }
  updateOptions(e = {}) {
    var t, n;
    this._options = Object.assign(Object.assign({}, this._options), e), (t = this.typeNavigationController) === null || t === void 0 || t.updateOptions(this._options), this._options.multipleSelectionController !== void 0 && (this._options.multipleSelectionSupport ? this.view.domNode.setAttribute("aria-multiselectable", "true") : this.view.domNode.removeAttribute("aria-multiselectable")), this.mouseController.updateOptions(e), (n = this.keyboardController) === null || n === void 0 || n.updateOptions(e), this.view.updateOptions(e);
  }
  get options() {
    return this._options;
  }
  splice(e, t, n = []) {
    if (e < 0 || e > this.view.length)
      throw new v1(this.user, `Invalid start index: ${e}`);
    if (t < 0)
      throw new v1(this.user, `Invalid delete count: ${t}`);
    t === 0 && n.length === 0 || this.eventBufferer.bufferEvents(() => this.spliceable.splice(e, t, n));
  }
  rerender() {
    this.view.rerender();
  }
  element(e) {
    return this.view.element(e);
  }
  get length() {
    return this.view.length;
  }
  get contentHeight() {
    return this.view.contentHeight;
  }
  get scrollTop() {
    return this.view.getScrollTop();
  }
  set scrollTop(e) {
    this.view.setScrollTop(e);
  }
  get scrollHeight() {
    return this.view.scrollHeight;
  }
  get renderHeight() {
    return this.view.renderHeight;
  }
  get firstVisibleIndex() {
    return this.view.firstVisibleIndex;
  }
  get ariaLabel() {
    return this._ariaLabel;
  }
  set ariaLabel(e) {
    this._ariaLabel = e, this.view.domNode.setAttribute("aria-label", e);
  }
  domFocus() {
    this.view.domNode.focus({ preventScroll: !0 });
  }
  layout(e, t) {
    this.view.layout(e, t);
  }
  setSelection(e, t) {
    for (const n of e)
      if (n < 0 || n >= this.length)
        throw new v1(this.user, `Invalid index ${n}`);
    this.selection.set(e, t);
  }
  getSelection() {
    return this.selection.get();
  }
  getSelectedElements() {
    return this.getSelection().map((e) => this.view.element(e));
  }
  setAnchor(e) {
    if (typeof e > "u") {
      this.anchor.set([]);
      return;
    }
    if (e < 0 || e >= this.length)
      throw new v1(this.user, `Invalid index ${e}`);
    this.anchor.set([e]);
  }
  getAnchor() {
    return Nue(this.anchor.get(), void 0);
  }
  getAnchorElement() {
    const e = this.getAnchor();
    return typeof e > "u" ? void 0 : this.element(e);
  }
  setFocus(e, t) {
    for (const n of e)
      if (n < 0 || n >= this.length)
        throw new v1(this.user, `Invalid index ${n}`);
    this.focus.set(e, t);
  }
  focusNext(e = 1, t = !1, n, r) {
    if (this.length === 0)
      return;
    const s = this.focus.get(), o = this.findNextIndex(s.length > 0 ? s[0] + e : 0, t, r);
    o > -1 && this.setFocus([o], n);
  }
  focusPrevious(e = 1, t = !1, n, r) {
    if (this.length === 0)
      return;
    const s = this.focus.get(), o = this.findPreviousIndex(s.length > 0 ? s[0] - e : 0, t, r);
    o > -1 && this.setFocus([o], n);
  }
  focusNextPage(e, t) {
    return QQ(this, void 0, void 0, function* () {
      let n = this.view.indexAt(this.view.getScrollTop() + this.view.renderHeight);
      n = n === 0 ? 0 : n - 1;
      const r = this.getFocus()[0];
      if (r !== n && (r === void 0 || n > r)) {
        const s = this.findPreviousIndex(n, !1, t);
        s > -1 && r !== s ? this.setFocus([s], e) : this.setFocus([n], e);
      } else {
        const s = this.view.getScrollTop();
        let o = s + this.view.renderHeight;
        n > r && (o -= this.view.elementHeight(n)), this.view.setScrollTop(o), this.view.getScrollTop() !== s && (this.setFocus([]), yield Mg(0), yield this.focusNextPage(e, t));
      }
    });
  }
  focusPreviousPage(e, t) {
    return QQ(this, void 0, void 0, function* () {
      let n;
      const r = this.view.getScrollTop();
      r === 0 ? n = this.view.indexAt(r) : n = this.view.indexAfter(r - 1);
      const s = this.getFocus()[0];
      if (s !== n && (s === void 0 || s >= n)) {
        const o = this.findNextIndex(n, !1, t);
        o > -1 && s !== o ? this.setFocus([o], e) : this.setFocus([n], e);
      } else {
        const o = r;
        this.view.setScrollTop(r - this.view.renderHeight), this.view.getScrollTop() !== o && (this.setFocus([]), yield Mg(0), yield this.focusPreviousPage(e, t));
      }
    });
  }
  focusLast(e, t) {
    if (this.length === 0)
      return;
    const n = this.findPreviousIndex(this.length - 1, !1, t);
    n > -1 && this.setFocus([n], e);
  }
  focusFirst(e, t) {
    this.focusNth(0, e, t);
  }
  focusNth(e, t, n) {
    if (this.length === 0)
      return;
    const r = this.findNextIndex(e, !1, n);
    r > -1 && this.setFocus([r], t);
  }
  findNextIndex(e, t = !1, n) {
    for (let r = 0; r < this.length; r++) {
      if (e >= this.length && !t)
        return -1;
      if (e = e % this.length, !n || n(this.element(e)))
        return e;
      e++;
    }
    return -1;
  }
  findPreviousIndex(e, t = !1, n) {
    for (let r = 0; r < this.length; r++) {
      if (e < 0 && !t)
        return -1;
      if (e = (this.length + e % this.length) % this.length, !n || n(this.element(e)))
        return e;
      e--;
    }
    return -1;
  }
  getFocus() {
    return this.focus.get();
  }
  getFocusedElements() {
    return this.getFocus().map((e) => this.view.element(e));
  }
  reveal(e, t) {
    if (e < 0 || e >= this.length)
      throw new v1(this.user, `Invalid index ${e}`);
    const n = this.view.getScrollTop(), r = this.view.elementTop(e), s = this.view.elementHeight(e);
    if (Tg(t)) {
      const o = s - this.view.renderHeight;
      this.view.setScrollTop(o * qo(t, 0, 1) + r);
    } else {
      const o = r + s, a = n + this.view.renderHeight;
      r < n && o >= a || (r < n || o >= a && s >= this.view.renderHeight ? this.view.setScrollTop(r) : o >= a && this.view.setScrollTop(o - this.view.renderHeight));
    }
  }
  getHTMLElement() {
    return this.view.domNode;
  }
  getElementID(e) {
    return this.view.getElementDomId(e);
  }
  style(e) {
    this.styleController.style(e);
  }
  toListEvent({ indexes: e, browserEvent: t }) {
    return { indexes: e, elements: e.map((n) => this.view.element(n)), browserEvent: t };
  }
  _onFocusChange() {
    const e = this.focus.get();
    this.view.domNode.classList.toggle("element-focused", e.length > 0), this.onDidChangeActiveDescendant();
  }
  onDidChangeActiveDescendant() {
    var e;
    const t = this.focus.get();
    if (t.length > 0) {
      let n;
      !((e = this.accessibilityProvider) === null || e === void 0) && e.getActiveDescendantId && (n = this.accessibilityProvider.getActiveDescendantId(this.view.element(t[0]))), this.view.domNode.setAttribute("aria-activedescendant", n || this.view.getElementDomId(t[0]));
    } else
      this.view.domNode.removeAttribute("aria-activedescendant");
  }
  _onSelectionChange() {
    const e = this.selection.get();
    this.view.domNode.classList.toggle("selection-none", e.length === 0), this.view.domNode.classList.toggle("selection-single", e.length === 1), this.view.domNode.classList.toggle("selection-multiple", e.length > 1);
  }
  dispose() {
    this._onDidDispose.fire(), this.disposables.dispose(), this._onDidDispose.dispose();
  }
}
F0([
  cr
], pc.prototype, "onDidChangeFocus", null);
F0([
  cr
], pc.prototype, "onDidChangeSelection", null);
F0([
  cr
], pc.prototype, "onContextMenu", null);
F0([
  cr
], pc.prototype, "onKeyDown", null);
F0([
  cr
], pc.prototype, "onDidFocus", null);
const pm = Re, bpe = "selectOption.entry.template";
class Fze {
  get templateId() {
    return bpe;
  }
  renderTemplate(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return t.root = e, t.text = Te(e, pm(".option-text")), t.detail = Te(e, pm(".option-detail")), t.decoratorRight = Te(e, pm(".option-decorator-right")), t;
  }
  renderElement(e, t, n) {
    const r = n, s = e.text, o = e.detail, a = e.decoratorRight, l = e.isDisabled;
    r.text.textContent = s, r.detail.textContent = o || "", r.decoratorRight.innerText = a || "", l ? r.root.classList.add("option-disabled") : r.root.classList.remove("option-disabled");
  }
  disposeTemplate(e) {
  }
}
class Kd extends we {
  constructor(e, t, n, r, s) {
    super(), this.options = [], this._currentSelection = 0, this._hasDetails = !1, this._skipLayout = !1, this._sticky = !1, this._isVisible = !1, this.styles = r, this.selectBoxOptions = s || /* @__PURE__ */ Object.create(null), typeof this.selectBoxOptions.minBottomMargin != "number" ? this.selectBoxOptions.minBottomMargin = Kd.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN : this.selectBoxOptions.minBottomMargin < 0 && (this.selectBoxOptions.minBottomMargin = 0), this.selectElement = document.createElement("select"), this.selectElement.className = "monaco-select-box monaco-select-box-dropdown-padding", typeof this.selectBoxOptions.ariaLabel == "string" && this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel), typeof this.selectBoxOptions.ariaDescription == "string" && this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription), this._onDidSelect = new pe(), this._register(this._onDidSelect), this.registerListeners(), this.constructSelectDropDown(n), this.selected = t || 0, e && this.setOptions(e, t), this.initStyleSheet();
  }
  // IDelegate - List renderer
  getHeight() {
    return 22;
  }
  getTemplateId() {
    return bpe;
  }
  constructSelectDropDown(e) {
    this.contextViewProvider = e, this.selectDropDownContainer = Re(".monaco-select-box-dropdown-container"), this.selectDropDownContainer.classList.add("monaco-select-box-dropdown-padding"), this.selectionDetailsPane = Te(this.selectDropDownContainer, pm(".select-box-details-pane"));
    const t = Te(this.selectDropDownContainer, pm(".select-box-dropdown-container-width-control")), n = Te(t, pm(".width-control-div"));
    this.widthControlElement = document.createElement("span"), this.widthControlElement.className = "option-text-width-control", Te(n, this.widthControlElement), this._dropDownPosition = 0, this.styleElement = yl(this.selectDropDownContainer), this.selectDropDownContainer.setAttribute("draggable", "true"), this._register(Ie(this.selectDropDownContainer, Ge.DRAG_START, (r) => {
      Tt.stop(r, !0);
    }));
  }
  registerListeners() {
    this._register(ar(this.selectElement, "change", (t) => {
      this.selected = t.target.selectedIndex, this._onDidSelect.fire({
        index: t.target.selectedIndex,
        selected: t.target.value
      }), this.options[this.selected] && this.options[this.selected].text && (this.selectElement.title = this.options[this.selected].text);
    })), this._register(Ie(this.selectElement, Ge.CLICK, (t) => {
      Tt.stop(t), this._isVisible ? this.hideSelectDropDown(!0) : this.showSelectDropDown();
    })), this._register(Ie(this.selectElement, Ge.MOUSE_DOWN, (t) => {
      Tt.stop(t);
    }));
    let e;
    this._register(Ie(this.selectElement, "touchstart", (t) => {
      e = this._isVisible;
    })), this._register(Ie(this.selectElement, "touchend", (t) => {
      Tt.stop(t), e ? this.hideSelectDropDown(!0) : this.showSelectDropDown();
    })), this._register(Ie(this.selectElement, Ge.KEY_DOWN, (t) => {
      const n = new Xn(t);
      let r = !1;
      sn ? (n.keyCode === 18 || n.keyCode === 16 || n.keyCode === 10 || n.keyCode === 3) && (r = !0) : (n.keyCode === 18 && n.altKey || n.keyCode === 16 && n.altKey || n.keyCode === 10 || n.keyCode === 3) && (r = !0), r && (this.showSelectDropDown(), Tt.stop(t, !0));
    }));
  }
  get onDidSelect() {
    return this._onDidSelect.event;
  }
  setOptions(e, t) {
    Qi(this.options, e) || (this.options = e, this.selectElement.options.length = 0, this._hasDetails = !1, this._cachedMaxDetailsHeight = void 0, this.options.forEach((n, r) => {
      this.selectElement.add(this.createOption(n.text, r, n.isDisabled)), typeof n.description == "string" && (this._hasDetails = !0);
    })), t !== void 0 && (this.select(t), this._currentSelection = this.selected);
  }
  setOptionsList() {
    var e;
    (e = this.selectList) === null || e === void 0 || e.splice(0, this.selectList.length, this.options);
  }
  select(e) {
    e >= 0 && e < this.options.length ? this.selected = e : e > this.options.length - 1 ? this.select(this.options.length - 1) : this.selected < 0 && (this.selected = 0), this.selectElement.selectedIndex = this.selected, this.options[this.selected] && this.options[this.selected].text && (this.selectElement.title = this.options[this.selected].text);
  }
  focus() {
    this.selectElement && (this.selectElement.tabIndex = 0, this.selectElement.focus());
  }
  blur() {
    this.selectElement && (this.selectElement.tabIndex = -1, this.selectElement.blur());
  }
  setFocusable(e) {
    this.selectElement.tabIndex = e ? 0 : -1;
  }
  render(e) {
    this.container = e, e.classList.add("select-container"), e.appendChild(this.selectElement), this.styleSelectElement();
  }
  initStyleSheet() {
    const e = [];
    this.styles.listFocusBackground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { background-color: ${this.styles.listFocusBackground} !important; }`), this.styles.listFocusForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { color: ${this.styles.listFocusForeground} !important; }`), this.styles.decoratorRightForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.focused) .option-decorator-right { color: ${this.styles.decoratorRightForeground}; }`), this.styles.selectBackground && this.styles.selectBorder && this.styles.selectBorder !== this.styles.selectBackground ? (e.push(`.monaco-select-box-dropdown-container { border: 1px solid ${this.styles.selectBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectBorder} } `)) : this.styles.selectListBorder && (e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectListBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectListBorder} } `)), this.styles.listHoverForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { color: ${this.styles.listHoverForeground} !important; }`), this.styles.listHoverBackground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { background-color: ${this.styles.listHoverBackground} !important; }`), this.styles.listFocusOutline && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { outline: 1.6px dotted ${this.styles.listFocusOutline} !important; outline-offset: -1.6px !important; }`), this.styles.listHoverOutline && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { outline: 1.6px dashed ${this.styles.listHoverOutline} !important; outline-offset: -1.6px !important; }`), e.push(".monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled.focused { background-color: transparent !important; color: inherit !important; outline: none !important; }"), e.push(".monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled:hover { background-color: transparent !important; color: inherit !important; outline: none !important; }"), this.styleElement.textContent = e.join(`
`);
  }
  styleSelectElement() {
    var e, t, n;
    const r = (e = this.styles.selectBackground) !== null && e !== void 0 ? e : "", s = (t = this.styles.selectForeground) !== null && t !== void 0 ? t : "", o = (n = this.styles.selectBorder) !== null && n !== void 0 ? n : "";
    this.selectElement.style.backgroundColor = r, this.selectElement.style.color = s, this.selectElement.style.borderColor = o;
  }
  styleList() {
    var e, t;
    const n = (e = this.styles.selectBackground) !== null && e !== void 0 ? e : "", r = Dm(this.styles.selectListBackground, n);
    this.selectDropDownListContainer.style.backgroundColor = r, this.selectionDetailsPane.style.backgroundColor = r;
    const s = (t = this.styles.focusBorder) !== null && t !== void 0 ? t : "";
    this.selectDropDownContainer.style.outlineColor = s, this.selectDropDownContainer.style.outlineOffset = "-1px", this.selectList.style(this.styles);
  }
  createOption(e, t, n) {
    const r = document.createElement("option");
    return r.value = e, r.text = e, r.disabled = !!n, r;
  }
  // ContextView dropdown methods
  showSelectDropDown() {
    this.selectionDetailsPane.innerText = "", !(!this.contextViewProvider || this._isVisible) && (this.createSelectList(this.selectDropDownContainer), this.setOptionsList(), this.contextViewProvider.showContextView({
      getAnchor: () => this.selectElement,
      render: (e) => this.renderSelectDropDown(e, !0),
      layout: () => {
        this.layoutSelectDropDown();
      },
      onHide: () => {
        this.selectDropDownContainer.classList.remove("visible"), this.selectElement.classList.remove("synthetic-focus");
      },
      anchorPosition: this._dropDownPosition
    }, this.selectBoxOptions.optionsAsChildren ? this.container : void 0), this._isVisible = !0, this.hideSelectDropDown(!1), this.contextViewProvider.showContextView({
      getAnchor: () => this.selectElement,
      render: (e) => this.renderSelectDropDown(e),
      layout: () => this.layoutSelectDropDown(),
      onHide: () => {
        this.selectDropDownContainer.classList.remove("visible"), this.selectElement.classList.remove("synthetic-focus");
      },
      anchorPosition: this._dropDownPosition
    }, this.selectBoxOptions.optionsAsChildren ? this.container : void 0), this._currentSelection = this.selected, this._isVisible = !0, this.selectElement.setAttribute("aria-expanded", "true"));
  }
  hideSelectDropDown(e) {
    !this.contextViewProvider || !this._isVisible || (this._isVisible = !1, this.selectElement.setAttribute("aria-expanded", "false"), e && this.selectElement.focus(), this.contextViewProvider.hideContextView());
  }
  renderSelectDropDown(e, t) {
    return e.appendChild(this.selectDropDownContainer), this.layoutSelectDropDown(t), {
      dispose: () => {
        try {
          e.removeChild(this.selectDropDownContainer);
        } catch {
        }
      }
    };
  }
  // Iterate over detailed descriptions, find max height
  measureMaxDetailsHeight() {
    let e = 0;
    return this.options.forEach((t, n) => {
      this.updateDetail(n), this.selectionDetailsPane.offsetHeight > e && (e = this.selectionDetailsPane.offsetHeight);
    }), e;
  }
  layoutSelectDropDown(e) {
    if (this._skipLayout)
      return !1;
    if (this.selectList) {
      this.selectDropDownContainer.classList.add("visible");
      const t = wr(this.selectElement), n = getComputedStyle(this.selectElement), r = parseFloat(n.getPropertyValue("--dropdown-padding-top")) + parseFloat(n.getPropertyValue("--dropdown-padding-bottom")), s = window.innerHeight - t.top - t.height - (this.selectBoxOptions.minBottomMargin || 0), o = t.top - Kd.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN, a = this.selectElement.offsetWidth, l = this.setWidthControlElement(this.widthControlElement), c = Math.max(l, Math.round(a)).toString() + "px";
      this.selectDropDownContainer.style.width = c, this.selectList.getHTMLElement().style.height = "", this.selectList.layout();
      let d = this.selectList.contentHeight;
      this._hasDetails && this._cachedMaxDetailsHeight === void 0 && (this._cachedMaxDetailsHeight = this.measureMaxDetailsHeight());
      const u = this._hasDetails ? this._cachedMaxDetailsHeight : 0, h = d + r + u, f = Math.floor((s - r - u) / this.getHeight()), g = Math.floor((o - r - u) / this.getHeight());
      if (e)
        return t.top + t.height > window.innerHeight - 22 || t.top < Kd.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || f < 1 && g < 1 ? !1 : (f < Kd.DEFAULT_MINIMUM_VISIBLE_OPTIONS && g > f && this.options.length > f ? (this._dropDownPosition = 1, this.selectDropDownContainer.removeChild(this.selectDropDownListContainer), this.selectDropDownContainer.removeChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectDropDownListContainer), this.selectionDetailsPane.classList.remove("border-top"), this.selectionDetailsPane.classList.add("border-bottom")) : (this._dropDownPosition = 0, this.selectDropDownContainer.removeChild(this.selectDropDownListContainer), this.selectDropDownContainer.removeChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectDropDownListContainer), this.selectDropDownContainer.appendChild(this.selectionDetailsPane), this.selectionDetailsPane.classList.remove("border-bottom"), this.selectionDetailsPane.classList.add("border-top")), !0);
      if (t.top + t.height > window.innerHeight - 22 || t.top < Kd.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || this._dropDownPosition === 0 && f < 1 || this._dropDownPosition === 1 && g < 1)
        return this.hideSelectDropDown(!0), !1;
      if (this._dropDownPosition === 0) {
        if (this._isVisible && f + g < 1)
          return this.hideSelectDropDown(!0), !1;
        h > s && (d = f * this.getHeight());
      } else
        h > o && (d = g * this.getHeight());
      return this.selectList.layout(d), this.selectList.domFocus(), this.selectList.length > 0 && (this.selectList.setFocus([this.selected || 0]), this.selectList.reveal(this.selectList.getFocus()[0] || 0)), this._hasDetails ? (this.selectList.getHTMLElement().style.height = d + r + "px", this.selectDropDownContainer.style.height = "") : this.selectDropDownContainer.style.height = d + r + "px", this.updateDetail(this.selected), this.selectDropDownContainer.style.width = c, this.selectDropDownListContainer.setAttribute("tabindex", "0"), this.selectElement.classList.add("synthetic-focus"), this.selectDropDownContainer.classList.add("synthetic-focus"), !0;
    } else
      return !1;
  }
  setWidthControlElement(e) {
    let t = 0;
    if (e) {
      let n = 0, r = 0;
      this.options.forEach((s, o) => {
        const a = s.detail ? s.detail.length : 0, l = s.decoratorRight ? s.decoratorRight.length : 0, c = s.text.length + a + l;
        c > r && (n = o, r = c);
      }), e.textContent = this.options[n].text + (this.options[n].decoratorRight ? this.options[n].decoratorRight + " " : ""), t = Lo(e);
    }
    return t;
  }
  createSelectList(e) {
    if (this.selectList)
      return;
    this.selectDropDownListContainer = Te(e, pm(".select-box-dropdown-list-container")), this.listRenderer = new Fze(), this.selectList = new pc("SelectBoxCustom", this.selectDropDownListContainer, this, [this.listRenderer], {
      useShadows: !1,
      verticalScrollMode: 3,
      keyboardSupport: !1,
      mouseSupport: !1,
      accessibilityProvider: {
        getAriaLabel: (r) => {
          let s = r.text;
          return r.detail && (s += `. ${r.detail}`), r.decoratorRight && (s += `. ${r.decoratorRight}`), r.description && (s += `. ${r.description}`), s;
        },
        getWidgetAriaLabel: () => C({ key: "selectBox", comment: ["Behave like native select dropdown element."] }, "Select Box"),
        getRole: () => sn ? "" : "option",
        getWidgetRole: () => "listbox"
      }
    }), this.selectBoxOptions.ariaLabel && (this.selectList.ariaLabel = this.selectBoxOptions.ariaLabel);
    const t = this._register(new Yt(this.selectDropDownListContainer, "keydown")), n = qe.chain(t.event, (r) => r.filter(() => this.selectList.length > 0).map((s) => new Xn(s)));
    this._register(qe.chain(n, (r) => r.filter(
      (s) => s.keyCode === 3
      /* KeyCode.Enter */
    ))(this.onEnter, this)), this._register(qe.chain(n, (r) => r.filter(
      (s) => s.keyCode === 2
      /* KeyCode.Tab */
    ))(this.onEnter, this)), this._register(qe.chain(n, (r) => r.filter(
      (s) => s.keyCode === 9
      /* KeyCode.Escape */
    ))(this.onEscape, this)), this._register(qe.chain(n, (r) => r.filter(
      (s) => s.keyCode === 16
      /* KeyCode.UpArrow */
    ))(this.onUpArrow, this)), this._register(qe.chain(n, (r) => r.filter(
      (s) => s.keyCode === 18
      /* KeyCode.DownArrow */
    ))(this.onDownArrow, this)), this._register(qe.chain(n, (r) => r.filter(
      (s) => s.keyCode === 12
      /* KeyCode.PageDown */
    ))(this.onPageDown, this)), this._register(qe.chain(n, (r) => r.filter(
      (s) => s.keyCode === 11
      /* KeyCode.PageUp */
    ))(this.onPageUp, this)), this._register(qe.chain(n, (r) => r.filter(
      (s) => s.keyCode === 14
      /* KeyCode.Home */
    ))(this.onHome, this)), this._register(qe.chain(n, (r) => r.filter(
      (s) => s.keyCode === 13
      /* KeyCode.End */
    ))(this.onEnd, this)), this._register(qe.chain(n, (r) => r.filter((s) => s.keyCode >= 21 && s.keyCode <= 56 || s.keyCode >= 85 && s.keyCode <= 113))(this.onCharacter, this)), this._register(Ie(this.selectList.getHTMLElement(), Ge.POINTER_UP, (r) => this.onPointerUp(r))), this._register(this.selectList.onMouseOver((r) => typeof r.index < "u" && this.selectList.setFocus([r.index]))), this._register(this.selectList.onDidChangeFocus((r) => this.onListFocus(r))), this._register(Ie(this.selectDropDownContainer, Ge.FOCUS_OUT, (r) => {
      !this._isVisible || xs(r.relatedTarget, this.selectDropDownContainer) || this.onListBlur();
    })), this.selectList.getHTMLElement().setAttribute("aria-label", this.selectBoxOptions.ariaLabel || ""), this.selectList.getHTMLElement().setAttribute("aria-expanded", "true"), this.styleList();
  }
  // List methods
  // List mouse controller - active exit, select option, fire onDidSelect if change, return focus to parent select
  // Also takes in touchend events
  onPointerUp(e) {
    if (!this.selectList.length)
      return;
    Tt.stop(e);
    const t = e.target;
    if (!t || t.classList.contains("slider"))
      return;
    const n = t.closest(".monaco-list-row");
    if (!n)
      return;
    const r = Number(n.getAttribute("data-index")), s = n.classList.contains("option-disabled");
    r >= 0 && r < this.options.length && !s && (this.selected = r, this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]), this.selected !== this._currentSelection && (this._currentSelection = this.selected, this._onDidSelect.fire({
      index: this.selectElement.selectedIndex,
      selected: this.options[this.selected].text
    }), this.options[this.selected] && this.options[this.selected].text && (this.selectElement.title = this.options[this.selected].text)), this.hideSelectDropDown(!0));
  }
  // List Exit - passive - implicit no selection change, hide drop-down
  onListBlur() {
    this._sticky || (this.selected !== this._currentSelection && this.select(this._currentSelection), this.hideSelectDropDown(!1));
  }
  renderDescriptionMarkdown(e, t) {
    const n = (s) => {
      for (let o = 0; o < s.childNodes.length; o++) {
        const a = s.childNodes.item(o);
        (a.tagName && a.tagName.toLowerCase()) === "img" ? s.removeChild(a) : n(a);
      }
    }, r = M4({ value: e, supportThemeIcons: !0 }, { actionHandler: t });
    return r.element.classList.add("select-box-description-markdown"), n(r.element), r.element;
  }
  // List Focus Change - passive - update details pane with newly focused element's data
  onListFocus(e) {
    !this._isVisible || !this._hasDetails || this.updateDetail(e.indexes[0]);
  }
  updateDetail(e) {
    var t, n;
    this.selectionDetailsPane.innerText = "";
    const r = this.options[e], s = (t = r?.description) !== null && t !== void 0 ? t : "", o = (n = r?.descriptionIsMarkdown) !== null && n !== void 0 ? n : !1;
    if (s) {
      if (o) {
        const a = r.descriptionMarkdownActionHandler;
        this.selectionDetailsPane.appendChild(this.renderDescriptionMarkdown(s, a));
      } else
        this.selectionDetailsPane.innerText = s;
      this.selectionDetailsPane.style.display = "block";
    } else
      this.selectionDetailsPane.style.display = "none";
    this._skipLayout = !0, this.contextViewProvider.layout(), this._skipLayout = !1;
  }
  // List keyboard controller
  // List exit - active - hide ContextView dropdown, reset selection, return focus to parent select
  onEscape(e) {
    Tt.stop(e), this.select(this._currentSelection), this.hideSelectDropDown(!0);
  }
  // List exit - active - hide ContextView dropdown, return focus to parent select, fire onDidSelect if change
  onEnter(e) {
    Tt.stop(e), this.selected !== this._currentSelection && (this._currentSelection = this.selected, this._onDidSelect.fire({
      index: this.selectElement.selectedIndex,
      selected: this.options[this.selected].text
    }), this.options[this.selected] && this.options[this.selected].text && (this.selectElement.title = this.options[this.selected].text)), this.hideSelectDropDown(!0);
  }
  // List navigation - have to handle a disabled option (jump over)
  onDownArrow(e) {
    if (this.selected < this.options.length - 1) {
      Tt.stop(e, !0);
      const t = this.options[this.selected + 1].isDisabled;
      if (t && this.options.length > this.selected + 2)
        this.selected += 2;
      else {
        if (t)
          return;
        this.selected++;
      }
      this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]);
    }
  }
  onUpArrow(e) {
    this.selected > 0 && (Tt.stop(e, !0), this.options[this.selected - 1].isDisabled && this.selected > 1 ? this.selected -= 2 : this.selected--, this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]));
  }
  onPageUp(e) {
    Tt.stop(e), this.selectList.focusPreviousPage(), setTimeout(() => {
      this.selected = this.selectList.getFocus()[0], this.options[this.selected].isDisabled && this.selected < this.options.length - 1 && (this.selected++, this.selectList.setFocus([this.selected])), this.selectList.reveal(this.selected), this.select(this.selected);
    }, 1);
  }
  onPageDown(e) {
    Tt.stop(e), this.selectList.focusNextPage(), setTimeout(() => {
      this.selected = this.selectList.getFocus()[0], this.options[this.selected].isDisabled && this.selected > 0 && (this.selected--, this.selectList.setFocus([this.selected])), this.selectList.reveal(this.selected), this.select(this.selected);
    }, 1);
  }
  onHome(e) {
    Tt.stop(e), !(this.options.length < 2) && (this.selected = 0, this.options[this.selected].isDisabled && this.selected > 1 && this.selected++, this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selected), this.select(this.selected));
  }
  onEnd(e) {
    Tt.stop(e), !(this.options.length < 2) && (this.selected = this.options.length - 1, this.options[this.selected].isDisabled && this.selected > 1 && this.selected--, this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selected), this.select(this.selected));
  }
  // Mimic option first character navigation of native select
  onCharacter(e) {
    const t = ph.toString(e.keyCode);
    let n = -1;
    for (let r = 0; r < this.options.length - 1; r++)
      if (n = (r + this.selected + 1) % this.options.length, this.options[n].text.charAt(0).toUpperCase() === t && !this.options[n].isDisabled) {
        this.select(n), this.selectList.setFocus([n]), this.selectList.reveal(this.selectList.getFocus()[0]), Tt.stop(e);
        break;
      }
  }
  dispose() {
    this.hideSelectDropDown(!1), super.dispose();
  }
}
Kd.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN = 32;
Kd.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN = 2;
Kd.DEFAULT_MINIMUM_VISIBLE_OPTIONS = 3;
class Bze extends we {
  constructor(e, t, n, r) {
    super(), this.selected = 0, this.selectBoxOptions = r || /* @__PURE__ */ Object.create(null), this.options = [], this.selectElement = document.createElement("select"), this.selectElement.className = "monaco-select-box", typeof this.selectBoxOptions.ariaLabel == "string" && this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel), typeof this.selectBoxOptions.ariaDescription == "string" && this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription), this._onDidSelect = this._register(new pe()), this.styles = n, this.registerListeners(), this.setOptions(e, t);
  }
  registerListeners() {
    this._register(Vn.addTarget(this.selectElement)), [Wn.Tap].forEach((e) => {
      this._register(Ie(this.selectElement, e, (t) => {
        this.selectElement.focus();
      }));
    }), this._register(ar(this.selectElement, "click", (e) => {
      Tt.stop(e, !0);
    })), this._register(ar(this.selectElement, "change", (e) => {
      this.selectElement.title = e.target.value, this._onDidSelect.fire({
        index: e.target.selectedIndex,
        selected: e.target.value
      });
    })), this._register(ar(this.selectElement, "keydown", (e) => {
      let t = !1;
      sn ? (e.keyCode === 18 || e.keyCode === 16 || e.keyCode === 10) && (t = !0) : (e.keyCode === 18 && e.altKey || e.keyCode === 10 || e.keyCode === 3) && (t = !0), t && e.stopPropagation();
    }));
  }
  get onDidSelect() {
    return this._onDidSelect.event;
  }
  setOptions(e, t) {
    (!this.options || !Qi(this.options, e)) && (this.options = e, this.selectElement.options.length = 0, this.options.forEach((n, r) => {
      this.selectElement.add(this.createOption(n.text, r, n.isDisabled));
    })), t !== void 0 && this.select(t);
  }
  select(e) {
    this.options.length === 0 ? this.selected = 0 : e >= 0 && e < this.options.length ? this.selected = e : e > this.options.length - 1 ? this.select(this.options.length - 1) : this.selected < 0 && (this.selected = 0), this.selectElement.selectedIndex = this.selected, this.selected < this.options.length && typeof this.options[this.selected].text == "string" ? this.selectElement.title = this.options[this.selected].text : this.selectElement.title = "";
  }
  focus() {
    this.selectElement && (this.selectElement.tabIndex = 0, this.selectElement.focus());
  }
  blur() {
    this.selectElement && (this.selectElement.tabIndex = -1, this.selectElement.blur());
  }
  setFocusable(e) {
    this.selectElement.tabIndex = e ? 0 : -1;
  }
  render(e) {
    e.classList.add("select-container"), e.appendChild(this.selectElement), this.setOptions(this.options, this.selected), this.applyStyles();
  }
  applyStyles() {
    var e, t, n;
    this.selectElement && (this.selectElement.style.backgroundColor = (e = this.styles.selectBackground) !== null && e !== void 0 ? e : "", this.selectElement.style.color = (t = this.styles.selectForeground) !== null && t !== void 0 ? t : "", this.selectElement.style.borderColor = (n = this.styles.selectBorder) !== null && n !== void 0 ? n : "");
  }
  createOption(e, t, n) {
    const r = document.createElement("option");
    return r.value = e, r.text = e, r.disabled = !!n, r;
  }
}
class Vze extends hc {
  constructor(e, t, n, r, s) {
    super(), sn && !s?.useCustomDrawn ? this.selectBoxDelegate = new Bze(e, t, r, s) : this.selectBoxDelegate = new Kd(e, t, n, r, s), this._register(this.selectBoxDelegate);
  }
  // Public SelectBox Methods - routed through delegate interface
  get onDidSelect() {
    return this.selectBoxDelegate.onDidSelect;
  }
  setOptions(e, t) {
    this.selectBoxDelegate.setOptions(e, t);
  }
  select(e) {
    this.selectBoxDelegate.select(e);
  }
  focus() {
    this.selectBoxDelegate.focus();
  }
  blur() {
    this.selectBoxDelegate.blur();
  }
  setFocusable(e) {
    this.selectBoxDelegate.setFocusable(e);
  }
  render(e) {
    this.selectBoxDelegate.render(e);
  }
}
class Mc extends we {
  get action() {
    return this._action;
  }
  constructor(e, t, n = {}) {
    super(), this.options = n, this._context = e || this, this._action = t, t instanceof vo && this._register(t.onDidChange((r) => {
      this.element && this.handleActionChangeEvent(r);
    }));
  }
  handleActionChangeEvent(e) {
    e.enabled !== void 0 && this.updateEnabled(), e.checked !== void 0 && this.updateChecked(), e.class !== void 0 && this.updateClass(), e.label !== void 0 && (this.updateLabel(), this.updateTooltip()), e.tooltip !== void 0 && this.updateTooltip();
  }
  get actionRunner() {
    return this._actionRunner || (this._actionRunner = this._register(new f_())), this._actionRunner;
  }
  set actionRunner(e) {
    this._actionRunner = e;
  }
  isEnabled() {
    return this._action.enabled;
  }
  setActionContext(e) {
    this._context = e;
  }
  render(e) {
    const t = this.element = e;
    this._register(Vn.addTarget(e));
    const n = this.options && this.options.draggable;
    n && (e.draggable = !0, bl && this._register(Ie(e, Ge.DRAG_START, (r) => {
      var s;
      return (s = r.dataTransfer) === null || s === void 0 ? void 0 : s.setData(aw.TEXT, this._action.label);
    }))), this._register(Ie(t, Wn.Tap, (r) => this.onClick(r, !0))), this._register(Ie(t, Ge.MOUSE_DOWN, (r) => {
      n || Tt.stop(r, !0), this._action.enabled && r.button === 0 && t.classList.add("active");
    })), sn && this._register(Ie(t, Ge.CONTEXT_MENU, (r) => {
      r.button === 0 && r.ctrlKey === !0 && this.onClick(r);
    })), this._register(Ie(t, Ge.CLICK, (r) => {
      Tt.stop(r, !0), this.options && this.options.isMenu || this.onClick(r);
    })), this._register(Ie(t, Ge.DBLCLICK, (r) => {
      Tt.stop(r, !0);
    })), [Ge.MOUSE_UP, Ge.MOUSE_OUT].forEach((r) => {
      this._register(Ie(t, r, (s) => {
        Tt.stop(s), t.classList.remove("active");
      }));
    });
  }
  onClick(e, t = !1) {
    var n;
    Tt.stop(e, !0);
    const r = xa(this._context) ? !((n = this.options) === null || n === void 0) && n.useEventAsContext ? e : { preserveFocus: t } : this._context;
    this.actionRunner.run(this._action, r);
  }
  // Only set the tabIndex on the element once it is about to get focused
  // That way this element wont be a tab stop when it is not needed #106441
  focus() {
    this.element && (this.element.tabIndex = 0, this.element.focus(), this.element.classList.add("focused"));
  }
  blur() {
    this.element && (this.element.blur(), this.element.tabIndex = -1, this.element.classList.remove("focused"));
  }
  setFocusable(e) {
    this.element && (this.element.tabIndex = e ? 0 : -1);
  }
  get trapsArrowNavigation() {
    return !1;
  }
  updateEnabled() {
  }
  updateLabel() {
  }
  getTooltip() {
    return this.action.tooltip;
  }
  updateTooltip() {
    var e;
    if (!this.element)
      return;
    const t = (e = this.getTooltip()) !== null && e !== void 0 ? e : "";
    this.updateAriaLabel(), this.options.hoverDelegate ? (this.element.title = "", this.customHover ? this.customHover.update(t) : (this.customHover = upe(this.options.hoverDelegate, this.element, t), this._store.add(this.customHover))) : this.element.title = t;
  }
  updateAriaLabel() {
    var e;
    if (this.element) {
      const t = (e = this.getTooltip()) !== null && e !== void 0 ? e : "";
      this.element.setAttribute("aria-label", t);
    }
  }
  updateClass() {
  }
  updateChecked() {
  }
  dispose() {
    this.element && (this.element.remove(), this.element = void 0), this._context = void 0, super.dispose();
  }
}
class N_ extends Mc {
  constructor(e, t, n) {
    super(e, t, n), this.options = n, this.options.icon = n.icon !== void 0 ? n.icon : !1, this.options.label = n.label !== void 0 ? n.label : !0, this.cssClass = "";
  }
  render(e) {
    super.render(e), this.element && (this.label = Te(this.element, Re("a.action-label"))), this.label && this.label.setAttribute("role", this.getDefaultAriaRole()), this.options.label && this.options.keybinding && this.element && (Te(this.element, Re("span.keybinding")).textContent = this.options.keybinding), this.updateClass(), this.updateLabel(), this.updateTooltip(), this.updateEnabled(), this.updateChecked();
  }
  getDefaultAriaRole() {
    return this._action.id === Gr.ID ? "presentation" : this.options.isMenu ? "menuitem" : "button";
  }
  // Only set the tabIndex on the element once it is about to get focused
  // That way this element wont be a tab stop when it is not needed #106441
  focus() {
    this.label && (this.label.tabIndex = 0, this.label.focus());
  }
  blur() {
    this.label && (this.label.tabIndex = -1);
  }
  setFocusable(e) {
    this.label && (this.label.tabIndex = e ? 0 : -1);
  }
  updateLabel() {
    this.options.label && this.label && (this.label.textContent = this.action.label);
  }
  getTooltip() {
    let e = null;
    return this.action.tooltip ? e = this.action.tooltip : !this.options.label && this.action.label && this.options.icon && (e = this.action.label, this.options.keybinding && (e = C({ key: "titleLabel", comment: ["action title", "action keybinding"] }, "{0} ({1})", e, this.options.keybinding))), e ?? void 0;
  }
  updateClass() {
    var e;
    this.cssClass && this.label && this.label.classList.remove(...this.cssClass.split(" ")), this.options.icon ? (this.cssClass = this.action.class, this.label && (this.label.classList.add("codicon"), this.cssClass && this.label.classList.add(...this.cssClass.split(" "))), this.updateEnabled()) : (e = this.label) === null || e === void 0 || e.classList.remove("codicon");
  }
  updateEnabled() {
    var e, t;
    this.action.enabled ? (this.label && (this.label.removeAttribute("aria-disabled"), this.label.classList.remove("disabled")), (e = this.element) === null || e === void 0 || e.classList.remove("disabled")) : (this.label && (this.label.setAttribute("aria-disabled", "true"), this.label.classList.add("disabled")), (t = this.element) === null || t === void 0 || t.classList.add("disabled"));
  }
  updateAriaLabel() {
    var e;
    if (this.label) {
      const t = (e = this.getTooltip()) !== null && e !== void 0 ? e : "";
      this.label.setAttribute("aria-label", t);
    }
  }
  updateChecked() {
    this.label && (this.action.checked !== void 0 ? (this.label.classList.toggle("checked", this.action.checked), this.label.setAttribute("aria-checked", this.action.checked ? "true" : "false"), this.label.setAttribute("role", "checkbox")) : (this.label.classList.remove("checked"), this.label.setAttribute("aria-checked", ""), this.label.setAttribute("role", this.getDefaultAriaRole())));
  }
}
class Hze extends Mc {
  constructor(e, t, n, r, s, o, a) {
    super(e, t), this.selectBox = new Vze(n, r, s, o, a), this.selectBox.setFocusable(!1), this._register(this.selectBox), this.registerListeners();
  }
  select(e) {
    this.selectBox.select(e);
  }
  registerListeners() {
    this._register(this.selectBox.onDidSelect((e) => this.runAction(e.selected, e.index)));
  }
  runAction(e, t) {
    this.actionRunner.run(this._action, this.getActionContext(e, t));
  }
  getActionContext(e, t) {
    return e;
  }
  setFocusable(e) {
    this.selectBox.setFocusable(e);
  }
  focus() {
    var e;
    (e = this.selectBox) === null || e === void 0 || e.focus();
  }
  blur() {
    var e;
    (e = this.selectBox) === null || e === void 0 || e.blur();
  }
  render(e) {
    this.selectBox.render(e);
  }
}
class Wze extends f_ {
  constructor(e, t) {
    super(), this._onDidChangeVisibility = this._register(new pe()), this.onDidChangeVisibility = this._onDidChangeVisibility.event, this._element = Te(e, Re(".monaco-dropdown")), this._label = Te(this._element, Re(".dropdown-label"));
    let n = t.labelRenderer;
    n || (n = (s) => (s.textContent = t.label || "", null));
    for (const s of [Ge.CLICK, Ge.MOUSE_DOWN, Wn.Tap])
      this._register(Ie(this.element, s, (o) => Tt.stop(o, !0)));
    for (const s of [Ge.MOUSE_DOWN, Wn.Tap])
      this._register(Ie(this._label, s, (o) => {
        o instanceof MouseEvent && (o.detail > 1 || o.button !== 0) || (this.visible ? this.hide() : this.show());
      }));
    this._register(Ie(this._label, Ge.KEY_UP, (s) => {
      const o = new Xn(s);
      (o.equals(
        3
        /* KeyCode.Enter */
      ) || o.equals(
        10
        /* KeyCode.Space */
      )) && (Tt.stop(s, !0), this.visible ? this.hide() : this.show());
    }));
    const r = n(this._label);
    r && this._register(r), this._register(Vn.addTarget(this._label));
  }
  get element() {
    return this._element;
  }
  show() {
    this.visible || (this.visible = !0, this._onDidChangeVisibility.fire(!0));
  }
  hide() {
    this.visible && (this.visible = !1, this._onDidChangeVisibility.fire(!1));
  }
  dispose() {
    super.dispose(), this.hide(), this.boxContainer && (this.boxContainer.remove(), this.boxContainer = void 0), this.contents && (this.contents.remove(), this.contents = void 0), this._label && (this._label.remove(), this._label = void 0);
  }
}
class jze extends Wze {
  constructor(e, t) {
    super(e, t), this._options = t, this._actions = [], this.actions = t.actions || [];
  }
  set menuOptions(e) {
    this._menuOptions = e;
  }
  get menuOptions() {
    return this._menuOptions;
  }
  get actions() {
    return this._options.actionProvider ? this._options.actionProvider.getActions() : this._actions;
  }
  set actions(e) {
    this._actions = e;
  }
  show() {
    super.show(), this.element.classList.add("active"), this._options.contextMenuProvider.showContextMenu({
      getAnchor: () => this.element,
      getActions: () => this.actions,
      getActionsContext: () => this.menuOptions ? this.menuOptions.context : null,
      getActionViewItem: (e, t) => this.menuOptions && this.menuOptions.actionViewItemProvider ? this.menuOptions.actionViewItemProvider(e, t) : void 0,
      getKeyBinding: (e) => this.menuOptions && this.menuOptions.getKeyBinding ? this.menuOptions.getKeyBinding(e) : void 0,
      getMenuClassName: () => this._options.menuClassName || "",
      onHide: () => this.onHide(),
      actionRunner: this.menuOptions ? this.menuOptions.actionRunner : void 0,
      anchorAlignment: this.menuOptions ? this.menuOptions.anchorAlignment : 0,
      domForShadowRoot: this._options.menuAsChild ? this.element : void 0,
      skipTelemetry: this._options.skipTelemetry
    });
  }
  hide() {
    super.hide();
  }
  onHide() {
    this.hide(), this.element.classList.remove("active");
  }
}
class BL extends Mc {
  constructor(e, t, n, r = /* @__PURE__ */ Object.create(null)) {
    super(null, e, r), this.actionItem = null, this._onDidChangeVisibility = this._register(new pe()), this.onDidChangeVisibility = this._onDidChangeVisibility.event, this.menuActionsOrProvider = t, this.contextMenuProvider = n, this.options = r, this.options.actionRunner && (this.actionRunner = this.options.actionRunner);
  }
  render(e) {
    this.actionItem = e;
    const t = (s) => {
      this.element = Te(s, Re("a.action-label"));
      let o = [];
      return typeof this.options.classNames == "string" ? o = this.options.classNames.split(/\s+/g).filter((a) => !!a) : this.options.classNames && (o = this.options.classNames), o.find((a) => a === "icon") || o.push("codicon"), this.element.classList.add(...o), this.element.setAttribute("role", "button"), this.element.setAttribute("aria-haspopup", "true"), this.element.setAttribute("aria-expanded", "false"), this.element.title = this._action.label || "", this.element.ariaLabel = this._action.label || "", null;
    }, n = Array.isArray(this.menuActionsOrProvider), r = {
      contextMenuProvider: this.contextMenuProvider,
      labelRenderer: t,
      menuAsChild: this.options.menuAsChild,
      actions: n ? this.menuActionsOrProvider : void 0,
      actionProvider: n ? void 0 : this.menuActionsOrProvider,
      skipTelemetry: this.options.skipTelemetry
    };
    if (this.dropdownMenu = this._register(new jze(e, r)), this._register(this.dropdownMenu.onDidChangeVisibility((s) => {
      var o;
      (o = this.element) === null || o === void 0 || o.setAttribute("aria-expanded", `${s}`), this._onDidChangeVisibility.fire(s);
    })), this.dropdownMenu.menuOptions = {
      actionViewItemProvider: this.options.actionViewItemProvider,
      actionRunner: this.actionRunner,
      getKeyBinding: this.options.keybindingProvider,
      context: this._context
    }, this.options.anchorAlignmentProvider) {
      const s = this;
      this.dropdownMenu.menuOptions = Object.assign(Object.assign({}, this.dropdownMenu.menuOptions), { get anchorAlignment() {
        return s.options.anchorAlignmentProvider();
      } });
    }
    this.updateTooltip(), this.updateEnabled();
  }
  getTooltip() {
    let e = null;
    return this.action.tooltip ? e = this.action.tooltip : this.action.label && (e = this.action.label), e ?? void 0;
  }
  setActionContext(e) {
    super.setActionContext(e), this.dropdownMenu && (this.dropdownMenu.menuOptions ? this.dropdownMenu.menuOptions.context = e : this.dropdownMenu.menuOptions = { context: e });
  }
  show() {
    var e;
    (e = this.dropdownMenu) === null || e === void 0 || e.show();
  }
  updateEnabled() {
    var e, t;
    const n = !this.action.enabled;
    (e = this.actionItem) === null || e === void 0 || e.classList.toggle("disabled", n), (t = this.element) === null || t === void 0 || t.classList.toggle("disabled", n);
  }
}
function zze(i) {
  return i ? i.condition !== void 0 : !1;
}
var nC = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, Gv;
(function(i) {
  i[i.STORAGE_DOES_NOT_EXIST = 0] = "STORAGE_DOES_NOT_EXIST", i[i.STORAGE_IN_MEMORY = 1] = "STORAGE_IN_MEMORY";
})(Gv || (Gv = {}));
var uv;
(function(i) {
  i[i.None = 0] = "None", i[i.Initialized = 1] = "Initialized", i[i.Closed = 2] = "Closed";
})(uv || (uv = {}));
let X3 = class Cpe extends we {
  constructor(e, t = /* @__PURE__ */ Object.create(null)) {
    super(), this.database = e, this.options = t, this._onDidChangeStorage = this._register(new jm()), this.onDidChangeStorage = this._onDidChangeStorage.event, this.state = uv.None, this.cache = /* @__PURE__ */ new Map(), this.flushDelayer = this._register(new Xhe(Cpe.DEFAULT_FLUSH_DELAY)), this.pendingDeletes = /* @__PURE__ */ new Set(), this.pendingInserts = /* @__PURE__ */ new Map(), this.whenFlushedCallbacks = [], this.registerListeners();
  }
  registerListeners() {
    this._register(this.database.onDidChangeItemsExternal((e) => this.onDidChangeItemsExternal(e)));
  }
  onDidChangeItemsExternal(e) {
    var t, n;
    this._onDidChangeStorage.pause();
    try {
      (t = e.changed) === null || t === void 0 || t.forEach((r, s) => this.acceptExternal(s, r)), (n = e.deleted) === null || n === void 0 || n.forEach((r) => this.acceptExternal(r, void 0));
    } finally {
      this._onDidChangeStorage.resume();
    }
  }
  acceptExternal(e, t) {
    if (this.state === uv.Closed)
      return;
    let n = !1;
    xa(t) ? n = this.cache.delete(e) : this.cache.get(e) !== t && (this.cache.set(e, t), n = !0), n && this._onDidChangeStorage.fire({ key: e, external: !0 });
  }
  get(e, t) {
    const n = this.cache.get(e);
    return xa(n) ? t : n;
  }
  getBoolean(e, t) {
    const n = this.get(e);
    return xa(n) ? t : n === "true";
  }
  getNumber(e, t) {
    const n = this.get(e);
    return xa(n) ? t : parseInt(n, 10);
  }
  set(e, t, n = !1) {
    return nC(this, void 0, void 0, function* () {
      if (this.state === uv.Closed)
        return;
      if (xa(t))
        return this.delete(e, n);
      const r = ho(t) || Array.isArray(t) ? Zje(t) : String(t);
      if (this.cache.get(e) !== r)
        return this.cache.set(e, r), this.pendingInserts.set(e, r), this.pendingDeletes.delete(e), this._onDidChangeStorage.fire({ key: e, external: n }), this.doFlush();
    });
  }
  delete(e, t = !1) {
    return nC(this, void 0, void 0, function* () {
      if (!(this.state === uv.Closed || !this.cache.delete(e)))
        return this.pendingDeletes.has(e) || this.pendingDeletes.add(e), this.pendingInserts.delete(e), this._onDidChangeStorage.fire({ key: e, external: t }), this.doFlush();
    });
  }
  get hasPending() {
    return this.pendingInserts.size > 0 || this.pendingDeletes.size > 0;
  }
  flushPending() {
    return nC(this, void 0, void 0, function* () {
      if (!this.hasPending)
        return;
      const e = { insert: this.pendingInserts, delete: this.pendingDeletes };
      return this.pendingDeletes = /* @__PURE__ */ new Set(), this.pendingInserts = /* @__PURE__ */ new Map(), this.database.updateItems(e).finally(() => {
        var t;
        if (!this.hasPending)
          for (; this.whenFlushedCallbacks.length; )
            (t = this.whenFlushedCallbacks.pop()) === null || t === void 0 || t();
      });
    });
  }
  doFlush(e) {
    return nC(this, void 0, void 0, function* () {
      return this.options.hint === Gv.STORAGE_IN_MEMORY ? this.flushPending() : this.flushDelayer.trigger(() => this.flushPending(), e);
    });
  }
};
X3.DEFAULT_FLUSH_DELAY = 100;
class oT {
  constructor() {
    this.onDidChangeItemsExternal = qe.None, this.items = /* @__PURE__ */ new Map();
  }
  updateItems(e) {
    var t, n;
    return nC(this, void 0, void 0, function* () {
      (t = e.insert) === null || t === void 0 || t.forEach((r, s) => this.items.set(s, r)), (n = e.delete) === null || n === void 0 || n.forEach((r) => this.items.delete(r));
    });
  }
}
const Z3 = "__$__targetStorageMarker", mc = Gt("storageService");
var VL;
(function(i) {
  i[i.NONE = 0] = "NONE", i[i.SHUTDOWN = 1] = "SHUTDOWN";
})(VL || (VL = {}));
function Uze(i) {
  const e = i.get(Z3);
  if (e)
    try {
      return JSON.parse(e);
    } catch {
    }
  return /* @__PURE__ */ Object.create(null);
}
class R4 extends we {
  constructor(e = { flushInterval: R4.DEFAULT_FLUSH_INTERVAL }) {
    super(), this.options = e, this._onDidChangeValue = this._register(new jm()), this._onDidChangeTarget = this._register(new jm()), this._onWillSaveState = this._register(new pe()), this.onWillSaveState = this._onWillSaveState.event, this._workspaceKeyTargets = void 0, this._profileKeyTargets = void 0, this._applicationKeyTargets = void 0;
  }
  onDidChangeValue(e, t, n) {
    return qe.filter(this._onDidChangeValue.event, (r) => r.scope === e && (t === void 0 || r.key === t), n);
  }
  emitDidChangeValue(e, t) {
    const { key: n, external: r } = t;
    if (n === Z3) {
      switch (e) {
        case -1:
          this._applicationKeyTargets = void 0;
          break;
        case 0:
          this._profileKeyTargets = void 0;
          break;
        case 1:
          this._workspaceKeyTargets = void 0;
          break;
      }
      this._onDidChangeTarget.fire({ scope: e });
    } else
      this._onDidChangeValue.fire({ scope: e, key: n, target: this.getKeyTargets(e)[n], external: r });
  }
  get(e, t, n) {
    var r;
    return (r = this.getStorage(t)) === null || r === void 0 ? void 0 : r.get(e, n);
  }
  getBoolean(e, t, n) {
    var r;
    return (r = this.getStorage(t)) === null || r === void 0 ? void 0 : r.getBoolean(e, n);
  }
  getNumber(e, t, n) {
    var r;
    return (r = this.getStorage(t)) === null || r === void 0 ? void 0 : r.getNumber(e, n);
  }
  store(e, t, n, r, s = !1) {
    if (xa(t)) {
      this.remove(e, n, s);
      return;
    }
    this.withPausedEmitters(() => {
      var o;
      this.updateKeyTarget(e, n, r), (o = this.getStorage(n)) === null || o === void 0 || o.set(e, t, s);
    });
  }
  remove(e, t, n = !1) {
    this.withPausedEmitters(() => {
      var r;
      this.updateKeyTarget(e, t, void 0), (r = this.getStorage(t)) === null || r === void 0 || r.delete(e, n);
    });
  }
  withPausedEmitters(e) {
    this._onDidChangeValue.pause(), this._onDidChangeTarget.pause();
    try {
      e();
    } finally {
      this._onDidChangeValue.resume(), this._onDidChangeTarget.resume();
    }
  }
  updateKeyTarget(e, t, n, r = !1) {
    var s, o;
    const a = this.getKeyTargets(t);
    typeof n == "number" ? a[e] !== n && (a[e] = n, (s = this.getStorage(t)) === null || s === void 0 || s.set(Z3, JSON.stringify(a), r)) : typeof a[e] == "number" && (delete a[e], (o = this.getStorage(t)) === null || o === void 0 || o.set(Z3, JSON.stringify(a), r));
  }
  get workspaceKeyTargets() {
    return this._workspaceKeyTargets || (this._workspaceKeyTargets = this.loadKeyTargets(
      1
      /* StorageScope.WORKSPACE */
    )), this._workspaceKeyTargets;
  }
  get profileKeyTargets() {
    return this._profileKeyTargets || (this._profileKeyTargets = this.loadKeyTargets(
      0
      /* StorageScope.PROFILE */
    )), this._profileKeyTargets;
  }
  get applicationKeyTargets() {
    return this._applicationKeyTargets || (this._applicationKeyTargets = this.loadKeyTargets(
      -1
      /* StorageScope.APPLICATION */
    )), this._applicationKeyTargets;
  }
  getKeyTargets(e) {
    switch (e) {
      case -1:
        return this.applicationKeyTargets;
      case 0:
        return this.profileKeyTargets;
      default:
        return this.workspaceKeyTargets;
    }
  }
  loadKeyTargets(e) {
    const t = this.getStorage(e);
    return t ? Uze(t) : /* @__PURE__ */ Object.create(null);
  }
}
R4.DEFAULT_FLUSH_INTERVAL = 60 * 1e3;
class Gze extends R4 {
  constructor() {
    super(), this.applicationStorage = this._register(new X3(new oT(), { hint: Gv.STORAGE_IN_MEMORY })), this.profileStorage = this._register(new X3(new oT(), { hint: Gv.STORAGE_IN_MEMORY })), this.workspaceStorage = this._register(new X3(new oT(), { hint: Gv.STORAGE_IN_MEMORY })), this._register(this.workspaceStorage.onDidChangeStorage((e) => this.emitDidChangeValue(1, e))), this._register(this.profileStorage.onDidChangeStorage((e) => this.emitDidChangeValue(0, e))), this._register(this.applicationStorage.onDidChangeStorage((e) => this.emitDidChangeValue(-1, e)));
  }
  getStorage(e) {
    switch (e) {
      case -1:
        return this.applicationStorage;
      case 0:
        return this.profileStorage;
      default:
        return this.workspaceStorage;
    }
  }
}
function qze(i, e) {
  const t = Object.assign({}, e);
  for (const n in i) {
    const r = i[n];
    t[n] = r !== void 0 ? Ye(r) : void 0;
  }
  return t;
}
const Kze = {
  keybindingLabelBackground: Ye(AMe),
  keybindingLabelForeground: Ye(kMe),
  keybindingLabelBorder: Ye(TMe),
  keybindingLabelBottomBorder: Ye(NMe),
  keybindingLabelShadow: Ye(Qd)
}, Yze = {
  buttonForeground: Ye(z2),
  buttonSeparator: Ye(pMe),
  buttonBackground: Ye(U2),
  buttonHoverBackground: Ye(mMe),
  buttonSecondaryForeground: Ye(_Me),
  buttonSecondaryBackground: Ye(LF),
  buttonSecondaryHoverBackground: Ye(bMe),
  buttonBorder: Ye(vMe)
}, Xze = {
  progressBarBackground: Ye(wMe)
}, HL = {
  inputActiveOptionBorder: Ye(fz),
  inputActiveOptionForeground: Ye(gz),
  inputActiveOptionBackground: Ye(dm)
};
Ye(u8e), Ye(f8e), Ye(h8e);
Ye(ji), Ye(eu), Ye(Qd), Ye($t), Ye(A8e), Ye(k8e), Ye(T8e), Ye(rMe);
const WL = {
  inputBackground: Ye(Lfe),
  inputForeground: Ye(Ife),
  inputBorder: Ye(Afe),
  inputValidationInfoBorder: Ye(aMe),
  inputValidationInfoBackground: Ye(sMe),
  inputValidationInfoForeground: Ye(oMe),
  inputValidationWarningBorder: Ye(dMe),
  inputValidationWarningBackground: Ye(lMe),
  inputValidationWarningForeground: Ye(cMe),
  inputValidationErrorBorder: Ye(fMe),
  inputValidationErrorBackground: Ye(uMe),
  inputValidationErrorForeground: Ye(hMe)
}, Zze = {
  listFilterWidgetBackground: Ye(r8e),
  listFilterWidgetOutline: Ye(s8e),
  listFilterWidgetNoMatchesOutline: Ye(o8e),
  listFilterWidgetShadow: Ye(a8e),
  inputBoxStyles: WL,
  toggleStyles: HL
}, ype = {
  badgeBackground: Ye(H3),
  badgeForeground: Ye(CMe),
  badgeBorder: Ye($t)
};
Ye(w8e), Ye(y8e), Ye(gZ), Ye(gZ), Ye(S8e);
const B0 = {
  listBackground: void 0,
  listInactiveFocusForeground: void 0,
  listFocusBackground: Ye(YMe),
  listFocusForeground: Ye(XMe),
  listFocusOutline: Ye(ZMe),
  listActiveSelectionBackground: Ye(Ah),
  listActiveSelectionForeground: Ye(iu),
  listActiveSelectionIconForeground: Ye(Y2),
  listFocusAndSelectionOutline: Ye(QMe),
  listFocusAndSelectionBackground: Ye(Ah),
  listFocusAndSelectionForeground: Ye(iu),
  listInactiveSelectionBackground: Ye(JMe),
  listInactiveSelectionIconForeground: Ye(e8e),
  listInactiveSelectionForeground: Ye($Me),
  listInactiveFocusBackground: Ye(t8e),
  listInactiveFocusOutline: Ye(n8e),
  listHoverBackground: Ye(Nfe),
  listHoverForeground: Ye(Pfe),
  listDropBackground: Ye(i8e),
  listSelectionOutline: Ye(ii),
  listHoverOutline: Ye(ii),
  treeIndentGuidesStroke: Ye(X2),
  treeInactiveIndentGuidesStroke: Ye(l8e),
  tableColumnsBorder: Ye(c8e),
  tableOddRowsBackgroundColor: Ye(d8e)
};
function Cb(i) {
  return qze(i, B0);
}
const Qze = {
  selectBackground: Ye(Jd),
  selectListBackground: Ye(gMe),
  selectForeground: Ye(Eh),
  decoratorRightForeground: Ye(kfe),
  selectBorder: Ye(J1),
  focusBorder: Ye(Ta),
  listFocusBackground: Ye(hm),
  listInactiveSelectionIconForeground: Ye($1),
  listFocusForeground: Ye(um),
  listFocusOutline: tMe(ii, ye.transparent.toString()),
  listHoverBackground: Ye(Nfe),
  listHoverForeground: Ye(Pfe),
  listHoverOutline: Ye(ii),
  selectListBorder: Ye(tu),
  listBackground: void 0,
  listActiveSelectionBackground: void 0,
  listActiveSelectionForeground: void 0,
  listActiveSelectionIconForeground: void 0,
  listFocusAndSelectionBackground: void 0,
  listDropBackground: void 0,
  listInactiveSelectionBackground: void 0,
  listInactiveSelectionForeground: void 0,
  listInactiveFocusBackground: void 0,
  listInactiveFocusOutline: void 0,
  listSelectionOutline: void 0,
  listFocusAndSelectionForeground: void 0,
  listFocusAndSelectionOutline: void 0,
  listInactiveFocusForeground: void 0,
  tableColumnsBorder: void 0,
  tableOddRowsBackgroundColor: void 0,
  treeIndentGuidesStroke: void 0,
  treeInactiveIndentGuidesStroke: void 0
}, Jze = {
  shadowColor: Ye(Qd),
  borderColor: Ye(g8e),
  foregroundColor: Ye(p8e),
  backgroundColor: Ye(m8e),
  selectionForegroundColor: Ye(v8e),
  selectionBackgroundColor: Ye(_8e),
  selectionBorderColor: Ye(b8e),
  separatorColor: Ye(C8e),
  scrollbarShadow: Ye(yMe),
  scrollbarSliderBackground: Ye(G2),
  scrollbarSliderHoverBackground: Ye(q2),
  scrollbarSliderActiveBackground: Ye(K2)
};
var F4 = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, No = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, wpe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function $ze(i, e, t, n) {
  const r = i.getActions(e), s = Sh.getInstance(), o = s.keyStatus.altKey || (Ls || $s) && s.keyStatus.shiftKey;
  xpe(r, t, o, (a) => a === "navigation");
}
function Spe(i, e, t, n, r, s) {
  const o = i.getActions(e);
  xpe(o, t, !1, typeof n == "string" ? (l) => l === n : n, r, s);
}
function xpe(i, e, t, n = (o) => o === "navigation", r = () => !1, s = !1) {
  let o, a;
  Array.isArray(e) ? (o = e, a = e) : (o = e.primary, a = e.secondary);
  const l = /* @__PURE__ */ new Set();
  for (const [c, d] of i) {
    let u;
    n(c) ? (u = o, u.length > 0 && s && u.push(new Gr())) : (u = a, u.length > 0 && u.push(new Gr()));
    for (let h of d) {
      t && (h = h instanceof sc && h.alt ? h.alt : h);
      const f = u.push(h);
      h instanceof g_ && l.add({ group: c, action: h, index: f - 1 });
    }
  }
  for (const { group: c, action: d, index: u } of l) {
    const h = n(c) ? o : a, f = d.actions;
    r(d, c, h.length) && h.splice(u, 1, ...f);
  }
}
let $m = class extends N_ {
  constructor(e, t, n, r, s, o, a, l) {
    super(void 0, e, { icon: !!(e.class || e.item.icon), label: !e.class && !e.item.icon, draggable: t?.draggable, keybinding: t?.keybinding, hoverDelegate: t?.hoverDelegate }), this._keybindingService = n, this._notificationService = r, this._contextKeyService = s, this._themeService = o, this._contextMenuService = a, this._accessibilityService = l, this._wantsAltCommand = !1, this._itemClassDispose = this._register(new ds()), this._altKey = Sh.getInstance();
  }
  get _menuItemAction() {
    return this._action;
  }
  get _commandAction() {
    return this._wantsAltCommand && this._menuItemAction.alt || this._menuItemAction;
  }
  onClick(e) {
    return wpe(this, void 0, void 0, function* () {
      e.preventDefault(), e.stopPropagation();
      try {
        yield this.actionRunner.run(this._commandAction, this._context);
      } catch (t) {
        this._notificationService.error(t);
      }
    });
  }
  render(e) {
    if (super.render(e), e.classList.add("menu-entry"), this.options.icon && this._updateItemClass(this._menuItemAction.item), this._menuItemAction.alt) {
      let t = !1;
      const n = () => {
        var r;
        const s = !!(!((r = this._menuItemAction.alt) === null || r === void 0) && r.enabled) && (!this._accessibilityService.isMotionReduced() || t) && (this._altKey.keyStatus.altKey || this._altKey.keyStatus.shiftKey && t);
        s !== this._wantsAltCommand && (this._wantsAltCommand = s, this.updateLabel(), this.updateTooltip(), this.updateClass());
      };
      this._register(this._altKey.event(n)), this._register(Ie(e, "mouseleave", (r) => {
        t = !1, n();
      })), this._register(Ie(e, "mouseenter", (r) => {
        t = !0, n();
      })), n();
    }
  }
  updateLabel() {
    this.options.label && this.label && (this.label.textContent = this._commandAction.label);
  }
  getTooltip() {
    var e;
    const t = this._keybindingService.lookupKeybinding(this._commandAction.id, this._contextKeyService), n = t && t.getLabel(), r = this._commandAction.tooltip || this._commandAction.label;
    let s = n ? C("titleAndKb", "{0} ({1})", r, n) : r;
    if (!this._wantsAltCommand && (!((e = this._menuItemAction.alt) === null || e === void 0) && e.enabled)) {
      const o = this._menuItemAction.alt.tooltip || this._menuItemAction.alt.label, a = this._keybindingService.lookupKeybinding(this._menuItemAction.alt.id, this._contextKeyService), l = a && a.getLabel(), c = l ? C("titleAndKb", "{0} ({1})", o, l) : o;
      s = C("titleAndKbAndAlt", `{0}
[{1}] {2}`, s, Zz.modifierLabels[ka].altKey, c);
    }
    return s;
  }
  updateClass() {
    this.options.icon && (this._commandAction !== this._menuItemAction ? this._menuItemAction.alt && this._updateItemClass(this._menuItemAction.alt.item) : this._updateItemClass(this._menuItemAction.item));
  }
  _updateItemClass(e) {
    this._itemClassDispose.value = void 0;
    const { element: t, label: n } = this;
    if (!t || !n)
      return;
    const r = this._commandAction.checked && zze(e.toggled) && e.toggled.icon ? e.toggled.icon : e.icon;
    if (r)
      if (ft.isThemeIcon(r)) {
        const s = ft.asClassNameArray(r);
        n.classList.add(...s), this._itemClassDispose.value = Ct(() => {
          n.classList.remove(...s);
        });
      } else {
        const s = w_(this._themeService.getColorTheme().type) ? Og(r.dark) : Og(r.light), o = Re("span");
        o.style.webkitMask = o.style.mask = `${s} no-repeat 50% 50%`, o.style.background = "var(--vscode-icon-foreground)", o.style.display = "inline-block", o.style.width = "100%", o.style.height = "100%", n.appendChild(o), n.classList.add("icon"), this._itemClassDispose.value = Ql(Ct(() => {
          n.classList.remove("icon"), cs(n);
        }), this._themeService.onDidColorThemeChange(() => {
          this.updateClass();
        }));
      }
  }
};
$m = F4([
  No(2, Bn),
  No(3, dr),
  No(4, yt),
  No(5, Pr),
  No(6, gc),
  No(7, lf)
], $m);
let EB = class extends BL {
  constructor(e, t, n, r, s) {
    var o, a, l;
    const c = Object.assign(Object.assign({}, t), { menuAsChild: (o = t?.menuAsChild) !== null && o !== void 0 ? o : !1, classNames: (a = t?.classNames) !== null && a !== void 0 ? a : ft.isThemeIcon(e.item.icon) ? ft.asClassName(e.item.icon) : void 0, keybindingProvider: (l = t?.keybindingProvider) !== null && l !== void 0 ? l : (d) => n.lookupKeybinding(d.id) });
    super(e, { getActions: () => e.actions }, r, c), this._keybindingService = n, this._contextMenuService = r, this._themeService = s;
  }
  render(e) {
    super.render(e), On(this.element), e.classList.add("menu-entry");
    const t = this._action, { icon: n } = t.item;
    if (n && !ft.isThemeIcon(n)) {
      this.element.classList.add("icon");
      const r = () => {
        this.element && (this.element.style.backgroundImage = w_(this._themeService.getColorTheme().type) ? Og(n.dark) : Og(n.light));
      };
      r(), this._register(this._themeService.onDidColorThemeChange(() => {
        r();
      }));
    }
  }
};
EB = F4([
  No(2, Bn),
  No(3, gc),
  No(4, Pr)
], EB);
let LB = class extends Mc {
  constructor(e, t, n, r, s, o, a, l) {
    var c, d, u;
    super(null, e), this._keybindingService = n, this._notificationService = r, this._contextMenuService = s, this._menuService = o, this._instaService = a, this._storageService = l, this._container = null, this._options = t, this._storageKey = `${e.item.submenu.id}_lastActionId`;
    let h;
    const f = t?.persistLastActionId ? l.get(
      this._storageKey,
      1
      /* StorageScope.WORKSPACE */
    ) : void 0;
    f && (h = e.actions.find((p) => f === p.id)), h || (h = e.actions[0]), this._defaultAction = this._instaService.createInstance($m, h, { keybinding: this._getDefaultActionKeybindingLabel(h) });
    const g = Object.assign(Object.assign({ keybindingProvider: (p) => this._keybindingService.lookupKeybinding(p.id) }, t), { menuAsChild: (c = t?.menuAsChild) !== null && c !== void 0 ? c : !0, classNames: (d = t?.classNames) !== null && d !== void 0 ? d : ["codicon", "codicon-chevron-down"], actionRunner: (u = t?.actionRunner) !== null && u !== void 0 ? u : new f_() });
    this._dropdown = new BL(e, e.actions, this._contextMenuService, g), this._dropdown.actionRunner.onDidRun((p) => {
      p.action instanceof sc && this.update(p.action);
    });
  }
  update(e) {
    var t;
    !((t = this._options) === null || t === void 0) && t.persistLastActionId && this._storageService.store(
      this._storageKey,
      e.id,
      1,
      1
      /* StorageTarget.MACHINE */
    ), this._defaultAction.dispose(), this._defaultAction = this._instaService.createInstance($m, e, { keybinding: this._getDefaultActionKeybindingLabel(e) }), this._defaultAction.actionRunner = new class extends f_ {
      runAction(n, r) {
        return wpe(this, void 0, void 0, function* () {
          yield n.run(void 0);
        });
      }
    }(), this._container && this._defaultAction.render(Hhe(this._container, Re(".action-container")));
  }
  _getDefaultActionKeybindingLabel(e) {
    var t;
    let n;
    if (!((t = this._options) === null || t === void 0) && t.renderKeybindingWithDefaultActionLabel) {
      const r = this._keybindingService.lookupKeybinding(e.id);
      r && (n = `(${r.getLabel()})`);
    }
    return n;
  }
  setActionContext(e) {
    super.setActionContext(e), this._defaultAction.setActionContext(e), this._dropdown.setActionContext(e);
  }
  render(e) {
    this._container = e, super.render(this._container), this._container.classList.add("monaco-dropdown-with-default");
    const t = Re(".action-container");
    this._defaultAction.render(Te(this._container, t)), this._register(Ie(t, Ge.KEY_DOWN, (r) => {
      const s = new Xn(r);
      s.equals(
        17
        /* KeyCode.RightArrow */
      ) && (this._defaultAction.element.tabIndex = -1, this._dropdown.focus(), s.stopPropagation());
    }));
    const n = Re(".dropdown-action-container");
    this._dropdown.render(Te(this._container, n)), this._register(Ie(n, Ge.KEY_DOWN, (r) => {
      var s;
      const o = new Xn(r);
      o.equals(
        15
        /* KeyCode.LeftArrow */
      ) && (this._defaultAction.element.tabIndex = 0, this._dropdown.setFocusable(!1), (s = this._defaultAction.element) === null || s === void 0 || s.focus(), o.stopPropagation());
    }));
  }
  focus(e) {
    e ? this._dropdown.focus() : (this._defaultAction.element.tabIndex = 0, this._defaultAction.element.focus());
  }
  blur() {
    this._defaultAction.element.tabIndex = -1, this._dropdown.blur(), this._container.blur();
  }
  setFocusable(e) {
    e ? this._defaultAction.element.tabIndex = 0 : (this._defaultAction.element.tabIndex = -1, this._dropdown.setFocusable(!1));
  }
  dispose() {
    this._defaultAction.dispose(), this._dropdown.dispose(), super.dispose();
  }
};
LB = F4([
  No(2, Bn),
  No(3, dr),
  No(4, gc),
  No(5, Ou),
  No(6, bt),
  No(7, mc)
], LB);
let IB = class extends Hze {
  constructor(e, t) {
    super(null, e, e.actions.map((n) => ({
      text: n.id === Gr.ID ? "─────────" : n.label,
      isDisabled: !n.enabled
    })), 0, t, Qze, { ariaLabel: e.tooltip, optionsAsChildren: !0 }), this.select(Math.max(0, e.actions.findIndex((n) => n.checked)));
  }
  render(e) {
    super.render(e), e.style.borderColor = Ye(J1);
  }
  runAction(e, t) {
    const n = this.action.actions[t];
    n && this.actionRunner.run(n);
  }
};
IB = F4([
  No(1, cf)
], IB);
function eUe(i, e, t) {
  return e instanceof sc ? i.createInstance($m, e, t) : e instanceof Ay ? e.item.isSelection ? i.createInstance(IB, e) : e.item.rememberDefaultAction ? i.createInstance(LB, e, Object.assign(Object.assign({}, t), { persistLastActionId: !0 })) : i.createInstance(EB, e, t) : void 0;
}
var tUe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class Dl extends we {
  constructor(e, t = {}) {
    var n, r, s, o, a, l;
    super(), this._actionRunnerDisposables = this._register(new Ne()), this.viewItemDisposables = this._register(new Tj()), this.triggerKeyDown = !1, this.focusable = !0, this._onDidBlur = this._register(new pe()), this.onDidBlur = this._onDidBlur.event, this._onDidCancel = this._register(new pe({ onWillAddFirstListener: () => this.cancelHasListener = !0 })), this.onDidCancel = this._onDidCancel.event, this.cancelHasListener = !1, this._onDidRun = this._register(new pe()), this.onDidRun = this._onDidRun.event, this._onWillRun = this._register(new pe()), this.onWillRun = this._onWillRun.event, this.options = t, this._context = (n = t.context) !== null && n !== void 0 ? n : null, this._orientation = (r = this.options.orientation) !== null && r !== void 0 ? r : 0, this._triggerKeys = {
      keyDown: (o = (s = this.options.triggerKeys) === null || s === void 0 ? void 0 : s.keyDown) !== null && o !== void 0 ? o : !1,
      keys: (l = (a = this.options.triggerKeys) === null || a === void 0 ? void 0 : a.keys) !== null && l !== void 0 ? l : [
        3,
        10
        /* KeyCode.Space */
      ]
    }, this.options.actionRunner ? this._actionRunner = this.options.actionRunner : (this._actionRunner = new f_(), this._actionRunnerDisposables.add(this._actionRunner)), this._actionRunnerDisposables.add(this._actionRunner.onDidRun((u) => this._onDidRun.fire(u))), this._actionRunnerDisposables.add(this._actionRunner.onWillRun((u) => this._onWillRun.fire(u))), this.viewItems = [], this.focusedItem = void 0, this.domNode = document.createElement("div"), this.domNode.className = "monaco-action-bar", t.animated !== !1 && this.domNode.classList.add("animated");
    let c, d;
    switch (this._orientation) {
      case 0:
        c = [
          15
          /* KeyCode.LeftArrow */
        ], d = [
          17
          /* KeyCode.RightArrow */
        ];
        break;
      case 1:
        c = [
          16
          /* KeyCode.UpArrow */
        ], d = [
          18
          /* KeyCode.DownArrow */
        ], this.domNode.className += " vertical";
        break;
    }
    this._register(Ie(this.domNode, Ge.KEY_DOWN, (u) => {
      const h = new Xn(u);
      let f = !0;
      const g = typeof this.focusedItem == "number" ? this.viewItems[this.focusedItem] : void 0;
      c && (h.equals(c[0]) || h.equals(c[1])) ? f = this.focusPrevious() : d && (h.equals(d[0]) || h.equals(d[1])) ? f = this.focusNext() : h.equals(
        9
        /* KeyCode.Escape */
      ) && this.cancelHasListener ? this._onDidCancel.fire() : h.equals(
        14
        /* KeyCode.Home */
      ) ? f = this.focusFirst() : h.equals(
        13
        /* KeyCode.End */
      ) ? f = this.focusLast() : h.equals(
        2
        /* KeyCode.Tab */
      ) && g instanceof Mc && g.trapsArrowNavigation ? f = this.focusNext() : this.isTriggerKeyEvent(h) ? this._triggerKeys.keyDown ? this.doTrigger(h) : this.triggerKeyDown = !0 : f = !1, f && (h.preventDefault(), h.stopPropagation());
    })), this._register(Ie(this.domNode, Ge.KEY_UP, (u) => {
      const h = new Xn(u);
      this.isTriggerKeyEvent(h) ? (!this._triggerKeys.keyDown && this.triggerKeyDown && (this.triggerKeyDown = !1, this.doTrigger(h)), h.preventDefault(), h.stopPropagation()) : (h.equals(
        2
        /* KeyCode.Tab */
      ) || h.equals(
        1026
        /* KeyCode.Tab */
      )) && this.updateFocusedItem();
    })), this.focusTracker = this._register(yu(this.domNode)), this._register(this.focusTracker.onDidBlur(() => {
      (Jl() === this.domNode || !xs(Jl(), this.domNode)) && (this._onDidBlur.fire(), this.previouslyFocusedItem = this.focusedItem, this.focusedItem = void 0, this.triggerKeyDown = !1);
    })), this._register(this.focusTracker.onDidFocus(() => this.updateFocusedItem())), this.actionsList = document.createElement("ul"), this.actionsList.className = "actions-container", this.options.highlightToggledItems && this.actionsList.classList.add("highlight-toggled"), this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar"), this.options.ariaLabel && this.actionsList.setAttribute("aria-label", this.options.ariaLabel), this.domNode.appendChild(this.actionsList), e.appendChild(this.domNode);
  }
  refreshRole() {
    this.length() >= 2 ? this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar") : this.actionsList.setAttribute("role", "presentation");
  }
  // Some action bars should not be focusable at times
  // When an action bar is not focusable make sure to make all the elements inside it not focusable
  // When an action bar is focusable again, make sure the first item can be focused
  setFocusable(e) {
    if (this.focusable = e, this.focusable) {
      const t = this.viewItems.find((n) => n instanceof Mc && n.isEnabled());
      t instanceof Mc && t.setFocusable(!0);
    } else
      this.viewItems.forEach((t) => {
        t instanceof Mc && t.setFocusable(!1);
      });
  }
  isTriggerKeyEvent(e) {
    let t = !1;
    return this._triggerKeys.keys.forEach((n) => {
      t = t || e.equals(n);
    }), t;
  }
  updateFocusedItem() {
    for (let e = 0; e < this.actionsList.children.length; e++) {
      const t = this.actionsList.children[e];
      if (xs(Jl(), t)) {
        this.focusedItem = e;
        break;
      }
    }
  }
  get context() {
    return this._context;
  }
  set context(e) {
    this._context = e, this.viewItems.forEach((t) => t.setActionContext(e));
  }
  get actionRunner() {
    return this._actionRunner;
  }
  set actionRunner(e) {
    this._actionRunner = e, this._actionRunnerDisposables.clear(), this._actionRunnerDisposables.add(this._actionRunner.onDidRun((t) => this._onDidRun.fire(t))), this._actionRunnerDisposables.add(this._actionRunner.onWillRun((t) => this._onWillRun.fire(t))), this.viewItems.forEach((t) => t.actionRunner = e);
  }
  getContainer() {
    return this.domNode;
  }
  getAction(e) {
    var t;
    if (typeof e == "number")
      return (t = this.viewItems[e]) === null || t === void 0 ? void 0 : t.action;
    if (e instanceof HTMLElement) {
      for (; e.parentElement !== this.actionsList; ) {
        if (!e.parentElement)
          return;
        e = e.parentElement;
      }
      for (let n = 0; n < this.actionsList.childNodes.length; n++)
        if (this.actionsList.childNodes[n] === e)
          return this.viewItems[n].action;
    }
  }
  push(e, t = {}) {
    const n = Array.isArray(e) ? e : [e];
    let r = Tg(t.index) ? t.index : null;
    n.forEach((s) => {
      const o = document.createElement("li");
      o.className = "action-item", o.setAttribute("role", "presentation");
      let a;
      const l = Object.assign({ hoverDelegate: this.options.hoverDelegate }, t);
      this.options.actionViewItemProvider && (a = this.options.actionViewItemProvider(s, l)), a || (a = new N_(this.context, s, l)), this.options.allowContextMenu || this.viewItemDisposables.set(a, Ie(o, Ge.CONTEXT_MENU, (c) => {
        Tt.stop(c, !0);
      })), a.actionRunner = this._actionRunner, a.setActionContext(this.context), a.render(o), this.focusable && a instanceof Mc && this.viewItems.length === 0 && a.setFocusable(!0), r === null || r < 0 || r >= this.actionsList.children.length ? (this.actionsList.appendChild(o), this.viewItems.push(a)) : (this.actionsList.insertBefore(o, this.actionsList.children[r]), this.viewItems.splice(r, 0, a), r++);
    }), typeof this.focusedItem == "number" && this.focus(this.focusedItem), this.refreshRole();
  }
  clear() {
    this.isEmpty() || (this.viewItems = An(this.viewItems), this.viewItemDisposables.clearAndDisposeAll(), ls(this.actionsList), this.refreshRole());
  }
  length() {
    return this.viewItems.length;
  }
  isEmpty() {
    return this.viewItems.length === 0;
  }
  focus(e) {
    let t = !1, n;
    if (e === void 0 ? t = !0 : typeof e == "number" ? n = e : typeof e == "boolean" && (t = e), t && typeof this.focusedItem > "u") {
      const r = this.viewItems.findIndex((s) => s.isEnabled());
      this.focusedItem = r === -1 ? void 0 : r, this.updateFocus(void 0, void 0, !0);
    } else
      n !== void 0 && (this.focusedItem = n), this.updateFocus(void 0, void 0, !0);
  }
  focusFirst() {
    return this.focusedItem = this.length() - 1, this.focusNext(!0);
  }
  focusLast() {
    return this.focusedItem = 0, this.focusPrevious(!0);
  }
  focusNext(e) {
    if (typeof this.focusedItem > "u")
      this.focusedItem = this.viewItems.length - 1;
    else if (this.viewItems.length <= 1)
      return !1;
    const t = this.focusedItem;
    let n;
    do {
      if (!e && this.options.preventLoopNavigation && this.focusedItem + 1 >= this.viewItems.length)
        return this.focusedItem = t, !1;
      this.focusedItem = (this.focusedItem + 1) % this.viewItems.length, n = this.viewItems[this.focusedItem];
    } while (this.focusedItem !== t && (this.options.focusOnlyEnabledItems && !n.isEnabled() || n.action.id === Gr.ID));
    return this.updateFocus(), !0;
  }
  focusPrevious(e) {
    if (typeof this.focusedItem > "u")
      this.focusedItem = 0;
    else if (this.viewItems.length <= 1)
      return !1;
    const t = this.focusedItem;
    let n;
    do {
      if (this.focusedItem = this.focusedItem - 1, this.focusedItem < 0) {
        if (!e && this.options.preventLoopNavigation)
          return this.focusedItem = t, !1;
        this.focusedItem = this.viewItems.length - 1;
      }
      n = this.viewItems[this.focusedItem];
    } while (this.focusedItem !== t && (this.options.focusOnlyEnabledItems && !n.isEnabled() || n.action.id === Gr.ID));
    return this.updateFocus(!0), !0;
  }
  updateFocus(e, t, n = !1) {
    var r;
    typeof this.focusedItem > "u" && this.actionsList.focus({ preventScroll: t }), this.previouslyFocusedItem !== void 0 && this.previouslyFocusedItem !== this.focusedItem && ((r = this.viewItems[this.previouslyFocusedItem]) === null || r === void 0 || r.blur());
    const s = this.focusedItem !== void 0 && this.viewItems[this.focusedItem];
    if (s) {
      let o = !0;
      Cy(s.focus) || (o = !1), this.options.focusOnlyEnabledItems && Cy(s.isEnabled) && !s.isEnabled() && (o = !1), s.action.id === Gr.ID && (o = !1), o ? (n || this.previouslyFocusedItem !== this.focusedItem) && (s.focus(e), this.previouslyFocusedItem = this.focusedItem) : (this.actionsList.focus({ preventScroll: t }), this.previouslyFocusedItem = void 0);
    }
  }
  doTrigger(e) {
    if (typeof this.focusedItem > "u")
      return;
    const t = this.viewItems[this.focusedItem];
    if (t instanceof Mc) {
      const n = t._context === null || t._context === void 0 ? e : t._context;
      this.run(t._action, n);
    }
  }
  run(e, t) {
    return tUe(this, void 0, void 0, function* () {
      yield this._actionRunner.run(e, t);
    });
  }
  dispose() {
    this._context = void 0, this.viewItems = An(this.viewItems), this.getContainer().remove(), super.dispose();
  }
}
const AB = /\(&([^\s&])\)|(^|[^&])&([^\s&])/, aT = /(&amp;)?(&amp;)([^\s&])/g;
var jL;
(function(i) {
  i[i.Right = 0] = "Right", i[i.Left = 1] = "Left";
})(jL || (jL = {}));
let Dpe = class Q3 extends Dl {
  constructor(e, t, n, r) {
    e.classList.add("monaco-menu-container"), e.setAttribute("role", "presentation");
    const s = document.createElement("div");
    s.classList.add("monaco-menu"), s.setAttribute("role", "presentation"), super(s, {
      orientation: 1,
      actionViewItemProvider: (l) => this.doGetActionViewItem(l, n, o),
      context: n.context,
      actionRunner: n.actionRunner,
      ariaLabel: n.ariaLabel,
      ariaRole: "menu",
      focusOnlyEnabledItems: !0,
      triggerKeys: { keys: [3, ...sn || $s ? [
        10
        /* KeyCode.Space */
      ] : []], keyDown: !0 }
    }), this.menuStyles = r, this.menuElement = s, this.actionsList.tabIndex = 0, this.menuDisposables = this._register(new Ne()), this.initializeOrUpdateStyleSheet(e, r), this._register(Vn.addTarget(s)), Ie(s, Ge.KEY_DOWN, (l) => {
      new Xn(l).equals(
        2
        /* KeyCode.Tab */
      ) && l.preventDefault();
    }), n.enableMnemonics && this.menuDisposables.add(Ie(s, Ge.KEY_DOWN, (l) => {
      const c = l.key.toLocaleLowerCase();
      if (this.mnemonics.has(c)) {
        Tt.stop(l, !0);
        const d = this.mnemonics.get(c);
        if (d.length === 1 && (d[0] instanceof eJ && d[0].container && this.focusItemByElement(d[0].container), d[0].onClick(l)), d.length > 1) {
          const u = d.shift();
          u && u.container && (this.focusItemByElement(u.container), d.push(u)), this.mnemonics.set(c, d);
        }
      }
    })), $s && this._register(Ie(s, Ge.KEY_DOWN, (l) => {
      const c = new Xn(l);
      c.equals(
        14
        /* KeyCode.Home */
      ) || c.equals(
        11
        /* KeyCode.PageUp */
      ) ? (this.focusedItem = this.viewItems.length - 1, this.focusNext(), Tt.stop(l, !0)) : (c.equals(
        13
        /* KeyCode.End */
      ) || c.equals(
        12
        /* KeyCode.PageDown */
      )) && (this.focusedItem = 0, this.focusPrevious(), Tt.stop(l, !0));
    })), this._register(Ie(this.domNode, Ge.MOUSE_OUT, (l) => {
      const c = l.relatedTarget;
      xs(c, this.domNode) || (this.focusedItem = void 0, this.updateFocus(), l.stopPropagation());
    })), this._register(Ie(this.actionsList, Ge.MOUSE_OVER, (l) => {
      let c = l.target;
      if (!(!c || !xs(c, this.actionsList) || c === this.actionsList)) {
        for (; c.parentElement !== this.actionsList && c.parentElement !== null; )
          c = c.parentElement;
        if (c.classList.contains("action-item")) {
          const d = this.focusedItem;
          this.setFocusedItem(c), d !== this.focusedItem && this.updateFocus();
        }
      }
    })), this._register(Vn.addTarget(this.actionsList)), this._register(Ie(this.actionsList, Wn.Tap, (l) => {
      let c = l.initialTarget;
      if (!(!c || !xs(c, this.actionsList) || c === this.actionsList)) {
        for (; c.parentElement !== this.actionsList && c.parentElement !== null; )
          c = c.parentElement;
        if (c.classList.contains("action-item")) {
          const d = this.focusedItem;
          this.setFocusedItem(c), d !== this.focusedItem && this.updateFocus();
        }
      }
    }));
    const o = {
      parent: this
    };
    this.mnemonics = /* @__PURE__ */ new Map(), this.scrollableElement = this._register(new TS(s, {
      alwaysConsumeMouseWheel: !0,
      horizontal: 2,
      vertical: 3,
      verticalScrollbarSize: 7,
      handleMouseWheel: !0,
      useShadows: !0
    }));
    const a = this.scrollableElement.getDomNode();
    a.style.position = "", this.styleScrollElement(a, r), this._register(Ie(s, Wn.Change, (l) => {
      Tt.stop(l, !0);
      const c = this.scrollableElement.getScrollPosition().scrollTop;
      this.scrollableElement.setScrollPosition({ scrollTop: c - l.translationY });
    })), this._register(Ie(a, Ge.MOUSE_UP, (l) => {
      l.preventDefault();
    })), s.style.maxHeight = `${Math.max(10, window.innerHeight - e.getBoundingClientRect().top - 35)}px`, t = t.filter((l) => {
      var c;
      return !((c = n.submenuIds) === null || c === void 0) && c.has(l.id) ? (console.warn(`Found submenu cycle: ${l.id}`), !1) : !0;
    }), this.push(t, { icon: !0, label: !0, isMenu: !0 }), e.appendChild(this.scrollableElement.getDomNode()), this.scrollableElement.scanDomNode(), this.viewItems.filter((l) => !(l instanceof tJ)).forEach((l, c, d) => {
      l.updatePositionInSet(c + 1, d.length);
    });
  }
  initializeOrUpdateStyleSheet(e, t) {
    this.styleSheet || (JE(e) ? this.styleSheet = yl(e) : (Q3.globalStyleSheet || (Q3.globalStyleSheet = yl()), this.styleSheet = Q3.globalStyleSheet)), this.styleSheet.textContent = iUe(t, JE(e));
  }
  styleScrollElement(e, t) {
    var n, r;
    const s = (n = t.foregroundColor) !== null && n !== void 0 ? n : "", o = (r = t.backgroundColor) !== null && r !== void 0 ? r : "", a = t.borderColor ? `1px solid ${t.borderColor}` : "", l = "5px", c = t.shadowColor ? `0 2px 8px ${t.shadowColor}` : "";
    e.style.outline = a, e.style.borderRadius = l, e.style.color = s, e.style.backgroundColor = o, e.style.boxShadow = c;
  }
  getContainer() {
    return this.scrollableElement.getDomNode();
  }
  get onScroll() {
    return this.scrollableElement.onScroll;
  }
  focusItemByElement(e) {
    const t = this.focusedItem;
    this.setFocusedItem(e), t !== this.focusedItem && this.updateFocus();
  }
  setFocusedItem(e) {
    for (let t = 0; t < this.actionsList.children.length; t++) {
      const n = this.actionsList.children[t];
      if (e === n) {
        this.focusedItem = t;
        break;
      }
    }
  }
  updateFocus(e) {
    super.updateFocus(e, !0, !0), typeof this.focusedItem < "u" && this.scrollableElement.setScrollPosition({
      scrollTop: Math.round(this.menuElement.scrollTop)
    });
  }
  doGetActionViewItem(e, t, n) {
    if (e instanceof Gr)
      return new tJ(t.context, e, { icon: !0 }, this.menuStyles);
    if (e instanceof g_) {
      const r = new eJ(e, e.actions, n, Object.assign(Object.assign({}, t), { submenuIds: /* @__PURE__ */ new Set([...t.submenuIds || [], e.id]) }), this.menuStyles);
      if (t.enableMnemonics) {
        const s = r.getMnemonic();
        if (s && r.isEnabled()) {
          let o = [];
          this.mnemonics.has(s) && (o = this.mnemonics.get(s)), o.push(r), this.mnemonics.set(s, o);
        }
      }
      return r;
    } else {
      const r = { enableMnemonics: t.enableMnemonics, useEventAsContext: t.useEventAsContext };
      if (t.getKeyBinding) {
        const o = t.getKeyBinding(e);
        if (o) {
          const a = o.getLabel();
          a && (r.keybinding = a);
        }
      }
      const s = new Epe(t.context, e, r, this.menuStyles);
      if (t.enableMnemonics) {
        const o = s.getMnemonic();
        if (o && s.isEnabled()) {
          let a = [];
          this.mnemonics.has(o) && (a = this.mnemonics.get(o)), a.push(s), this.mnemonics.set(o, a);
        }
      }
      return s;
    }
  }
};
class Epe extends Mc {
  constructor(e, t, n, r) {
    if (n.isMenu = !0, super(t, t, n), this.menuStyle = r, this.options = n, this.options.icon = n.icon !== void 0 ? n.icon : !1, this.options.label = n.label !== void 0 ? n.label : !0, this.cssClass = "", this.options.label && n.enableMnemonics) {
      const s = this.action.label;
      if (s) {
        const o = AB.exec(s);
        o && (this.mnemonic = (o[1] ? o[1] : o[3]).toLocaleLowerCase());
      }
    }
    this.runOnceToEnableMouseUp = new Rn(() => {
      this.element && (this._register(Ie(this.element, Ge.MOUSE_UP, (s) => {
        if (Tt.stop(s, !0), bl) {
          if (new cl(s).rightButton)
            return;
          this.onClick(s);
        } else
          setTimeout(() => {
            this.onClick(s);
          }, 0);
      })), this._register(Ie(this.element, Ge.CONTEXT_MENU, (s) => {
        Tt.stop(s, !0);
      })));
    }, 100), this._register(this.runOnceToEnableMouseUp);
  }
  render(e) {
    super.render(e), this.element && (this.container = e, this.item = Te(this.element, Re("a.action-menu-item")), this._action.id === Gr.ID ? this.item.setAttribute("role", "presentation") : (this.item.setAttribute("role", "menuitem"), this.mnemonic && this.item.setAttribute("aria-keyshortcuts", `${this.mnemonic}`)), this.check = Te(this.item, Re("span.menu-item-check" + ft.asCSSSelector(We.menuSelection))), this.check.setAttribute("role", "none"), this.label = Te(this.item, Re("span.action-label")), this.options.label && this.options.keybinding && (Te(this.item, Re("span.keybinding")).textContent = this.options.keybinding), this.runOnceToEnableMouseUp.schedule(), this.updateClass(), this.updateLabel(), this.updateTooltip(), this.updateEnabled(), this.updateChecked(), this.applyStyle());
  }
  blur() {
    super.blur(), this.applyStyle();
  }
  focus() {
    var e;
    super.focus(), (e = this.item) === null || e === void 0 || e.focus(), this.applyStyle();
  }
  updatePositionInSet(e, t) {
    this.item && (this.item.setAttribute("aria-posinset", `${e}`), this.item.setAttribute("aria-setsize", `${t}`));
  }
  updateLabel() {
    var e;
    if (this.label && this.options.label) {
      ls(this.label);
      let t = rU(this.action.label);
      if (t) {
        const n = nUe(t);
        this.options.enableMnemonics || (t = n), this.label.setAttribute("aria-label", n.replace(/&&/g, "&"));
        const r = AB.exec(t);
        if (r) {
          t = KE(t), aT.lastIndex = 0;
          let s = aT.exec(t);
          for (; s && s[1]; )
            s = aT.exec(t);
          const o = (a) => a.replace(/&amp;&amp;/g, "&amp;");
          s ? this.label.append(bS(o(t.substr(0, s.index)), " "), Re("u", { "aria-hidden": "true" }, s[3]), uhe(o(t.substr(s.index + s[0].length)), " ")) : this.label.innerText = o(t).trim(), (e = this.item) === null || e === void 0 || e.setAttribute("aria-keyshortcuts", (r[1] ? r[1] : r[3]).toLocaleLowerCase());
        } else
          this.label.innerText = t.replace(/&&/g, "&").trim();
      }
    }
  }
  updateTooltip() {
  }
  updateClass() {
    this.cssClass && this.item && this.item.classList.remove(...this.cssClass.split(" ")), this.options.icon && this.label ? (this.cssClass = this.action.class || "", this.label.classList.add("icon"), this.cssClass && this.label.classList.add(...this.cssClass.split(" ")), this.updateEnabled()) : this.label && this.label.classList.remove("icon");
  }
  updateEnabled() {
    this.action.enabled ? (this.element && (this.element.classList.remove("disabled"), this.element.removeAttribute("aria-disabled")), this.item && (this.item.classList.remove("disabled"), this.item.removeAttribute("aria-disabled"), this.item.tabIndex = 0)) : (this.element && (this.element.classList.add("disabled"), this.element.setAttribute("aria-disabled", "true")), this.item && (this.item.classList.add("disabled"), this.item.setAttribute("aria-disabled", "true")));
  }
  updateChecked() {
    if (!this.item)
      return;
    const e = this.action.checked;
    this.item.classList.toggle("checked", !!e), e !== void 0 ? (this.item.setAttribute("role", "menuitemcheckbox"), this.item.setAttribute("aria-checked", e ? "true" : "false")) : (this.item.setAttribute("role", "menuitem"), this.item.setAttribute("aria-checked", ""));
  }
  getMnemonic() {
    return this.mnemonic;
  }
  applyStyle() {
    const e = this.element && this.element.classList.contains("focused"), t = e && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor, n = e && this.menuStyle.selectionBackgroundColor ? this.menuStyle.selectionBackgroundColor : void 0, r = e && this.menuStyle.selectionBorderColor ? `1px solid ${this.menuStyle.selectionBorderColor}` : "", s = e && this.menuStyle.selectionBorderColor ? "-1px" : "";
    this.item && (this.item.style.color = t ?? "", this.item.style.backgroundColor = n ?? "", this.item.style.outline = r, this.item.style.outlineOffset = s), this.check && (this.check.style.color = t ?? "");
  }
}
class eJ extends Epe {
  constructor(e, t, n, r, s) {
    super(e, e, r, s), this.submenuActions = t, this.parentData = n, this.submenuOptions = r, this.mysubmenu = null, this.submenuDisposables = this._register(new Ne()), this.mouseOver = !1, this.expandDirection = r && r.expandDirection !== void 0 ? r.expandDirection : jL.Right, this.showScheduler = new Rn(() => {
      this.mouseOver && (this.cleanupExistingSubmenu(!1), this.createSubmenu(!1));
    }, 250), this.hideScheduler = new Rn(() => {
      this.element && !xs(Jl(), this.element) && this.parentData.submenu === this.mysubmenu && (this.parentData.parent.focus(!1), this.cleanupExistingSubmenu(!0));
    }, 750);
  }
  render(e) {
    super.render(e), this.element && (this.item && (this.item.classList.add("monaco-submenu-item"), this.item.tabIndex = 0, this.item.setAttribute("aria-haspopup", "true"), this.updateAriaExpanded("false"), this.submenuIndicator = Te(this.item, Re("span.submenu-indicator" + ft.asCSSSelector(We.menuSubmenu))), this.submenuIndicator.setAttribute("aria-hidden", "true")), this._register(Ie(this.element, Ge.KEY_UP, (t) => {
      const n = new Xn(t);
      (n.equals(
        17
        /* KeyCode.RightArrow */
      ) || n.equals(
        3
        /* KeyCode.Enter */
      )) && (Tt.stop(t, !0), this.createSubmenu(!0));
    })), this._register(Ie(this.element, Ge.KEY_DOWN, (t) => {
      const n = new Xn(t);
      Jl() === this.item && (n.equals(
        17
        /* KeyCode.RightArrow */
      ) || n.equals(
        3
        /* KeyCode.Enter */
      )) && Tt.stop(t, !0);
    })), this._register(Ie(this.element, Ge.MOUSE_OVER, (t) => {
      this.mouseOver || (this.mouseOver = !0, this.showScheduler.schedule());
    })), this._register(Ie(this.element, Ge.MOUSE_LEAVE, (t) => {
      this.mouseOver = !1;
    })), this._register(Ie(this.element, Ge.FOCUS_OUT, (t) => {
      this.element && !xs(Jl(), this.element) && this.hideScheduler.schedule();
    })), this._register(this.parentData.parent.onScroll(() => {
      this.parentData.submenu === this.mysubmenu && (this.parentData.parent.focus(!1), this.cleanupExistingSubmenu(!0));
    })));
  }
  updateEnabled() {
  }
  onClick(e) {
    Tt.stop(e, !0), this.cleanupExistingSubmenu(!1), this.createSubmenu(!0);
  }
  cleanupExistingSubmenu(e) {
    if (this.parentData.submenu && (e || this.parentData.submenu !== this.mysubmenu)) {
      try {
        this.parentData.submenu.dispose();
      } catch {
      }
      this.parentData.submenu = void 0, this.updateAriaExpanded("false"), this.submenuContainer && (this.submenuDisposables.clear(), this.submenuContainer = void 0);
    }
  }
  calculateSubmenuMenuLayout(e, t, n, r) {
    const s = { top: 0, left: 0 };
    return s.left = lv(e.width, t.width, { position: r === jL.Right ? 0 : 1, offset: n.left, size: n.width }), s.left >= n.left && s.left < n.left + n.width && (n.left + 10 + t.width <= e.width && (s.left = n.left + 10), n.top += 10, n.height = 0), s.top = lv(e.height, t.height, { position: 0, offset: n.top, size: 0 }), s.top + t.height === n.top && s.top + n.height + t.height <= e.height && (s.top += n.height), s;
  }
  createSubmenu(e = !0) {
    if (this.element)
      if (this.parentData.submenu)
        this.parentData.submenu.focus(!1);
      else {
        this.updateAriaExpanded("true"), this.submenuContainer = Te(this.element, Re("div.monaco-submenu")), this.submenuContainer.classList.add("menubar-menu-items-holder", "context-view");
        const t = getComputedStyle(this.parentData.parent.domNode), n = parseFloat(t.paddingTop || "0") || 0;
        this.submenuContainer.style.zIndex = "1", this.submenuContainer.style.position = "fixed", this.submenuContainer.style.top = "0", this.submenuContainer.style.left = "0", this.parentData.submenu = new Dpe(this.submenuContainer, this.submenuActions.length ? this.submenuActions : [new UA()], this.submenuOptions, this.menuStyle);
        const r = this.element.getBoundingClientRect(), s = {
          top: r.top - n,
          left: r.left,
          height: r.height + 2 * n,
          width: r.width
        }, o = this.submenuContainer.getBoundingClientRect(), { top: a, left: l } = this.calculateSubmenuMenuLayout(new _n(window.innerWidth, window.innerHeight), _n.lift(o), s, this.expandDirection);
        this.submenuContainer.style.left = `${l - o.left}px`, this.submenuContainer.style.top = `${a - o.top}px`, this.submenuDisposables.add(Ie(this.submenuContainer, Ge.KEY_UP, (c) => {
          new Xn(c).equals(
            15
            /* KeyCode.LeftArrow */
          ) && (Tt.stop(c, !0), this.parentData.parent.focus(), this.cleanupExistingSubmenu(!0));
        })), this.submenuDisposables.add(Ie(this.submenuContainer, Ge.KEY_DOWN, (c) => {
          new Xn(c).equals(
            15
            /* KeyCode.LeftArrow */
          ) && Tt.stop(c, !0);
        })), this.submenuDisposables.add(this.parentData.submenu.onDidCancel(() => {
          this.parentData.parent.focus(), this.cleanupExistingSubmenu(!0);
        })), this.parentData.submenu.focus(e), this.mysubmenu = this.parentData.submenu;
      }
  }
  updateAriaExpanded(e) {
    var t;
    this.item && ((t = this.item) === null || t === void 0 || t.setAttribute("aria-expanded", e));
  }
  applyStyle() {
    super.applyStyle();
    const t = this.element && this.element.classList.contains("focused") && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor;
    this.submenuIndicator && (this.submenuIndicator.style.color = t ?? "");
  }
  dispose() {
    super.dispose(), this.hideScheduler.dispose(), this.mysubmenu && (this.mysubmenu.dispose(), this.mysubmenu = null), this.submenuContainer && (this.submenuContainer = void 0);
  }
}
class tJ extends N_ {
  constructor(e, t, n, r) {
    super(e, t, n), this.menuStyles = r;
  }
  render(e) {
    super.render(e), this.label && (this.label.style.borderBottomColor = this.menuStyles.separatorColor ? `${this.menuStyles.separatorColor}` : "");
  }
}
function nUe(i) {
  const e = AB, t = e.exec(i);
  if (!t)
    return i;
  const n = !t[1];
  return i.replace(e, n ? "$2$3" : "").trim();
}
function nJ(i) {
  const e = ahe()[i.id];
  return `.codicon-${i.id}:before { content: '\\${e.toString(16)}'; }`;
}
function iUe(i, e) {
  let t = (
    /* css */
    `
.monaco-menu {
	font-size: 13px;
	border-radius: 5px;
	min-width: 160px;
}

${nJ(We.menuSelection)}
${nJ(We.menuSubmenu)}

.monaco-menu .monaco-action-bar {
	text-align: right;
	overflow: hidden;
	white-space: nowrap;
}

.monaco-menu .monaco-action-bar .actions-container {
	display: flex;
	margin: 0 auto;
	padding: 0;
	width: 100%;
	justify-content: flex-end;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: inline-block;
}

.monaco-menu .monaco-action-bar.reverse .actions-container {
	flex-direction: row-reverse;
}

.monaco-menu .monaco-action-bar .action-item {
	cursor: pointer;
	display: inline-block;
	transition: transform 50ms ease;
	position: relative;  /* DO NOT REMOVE - this is the key to preventing the ghosting icon bug in Chrome 42 */
}

.monaco-menu .monaco-action-bar .action-item.disabled {
	cursor: default;
}

.monaco-menu .monaco-action-bar.animated .action-item.active {
	transform: scale(1.272019649, 1.272019649); /* 1.272019649 = √φ */
}

.monaco-menu .monaco-action-bar .action-item .icon,
.monaco-menu .monaco-action-bar .action-item .codicon {
	display: inline-block;
}

.monaco-menu .monaco-action-bar .action-item .codicon {
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar .action-label {
	font-size: 11px;
	margin-right: 4px;
}

.monaco-menu .monaco-action-bar .action-item.disabled .action-label,
.monaco-menu .monaco-action-bar .action-item.disabled .action-label:hover {
	color: var(--vscode-disabledForeground);
}

/* Vertical actions */

.monaco-menu .monaco-action-bar.vertical {
	text-align: left;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	display: block;
	border-bottom: 1px solid var(--vscode-menu-separatorBackground);
	padding-top: 1px;
	padding: 30px;
}

.monaco-menu .secondary-actions .monaco-action-bar .action-label {
	margin-left: 6px;
}

/* Action Items */
.monaco-menu .monaco-action-bar .action-item.select-container {
	overflow: hidden; /* somehow the dropdown overflows its container, we prevent it here to not push */
	flex: 1;
	max-width: 170px;
	min-width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
}

.monaco-menu .monaco-action-bar.vertical {
	margin-left: 0;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	padding: 0;
	transform: none;
	display: flex;
}

.monaco-menu .monaco-action-bar.vertical .action-item.active {
	transform: none;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	flex: 1 1 auto;
	display: flex;
	height: 2em;
	align-items: center;
	position: relative;
	margin: 0 4px;
	border-radius: 4px;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item:hover .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-menu-item:focus .keybinding {
	opacity: unset;
}

.monaco-menu .monaco-action-bar.vertical .action-label {
	flex: 1 1 auto;
	text-decoration: none;
	padding: 0 1em;
	background: none;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .keybinding,
.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	display: inline-block;
	flex: 2 1 auto;
	padding: 0 1em;
	text-align: right;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon {
	font-size: 16px !important;
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon::before {
	margin-left: auto;
	margin-right: -20px;
}

.monaco-menu .monaco-action-bar.vertical .action-item.disabled .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-item.disabled .submenu-indicator {
	opacity: 0.4;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator) {
	display: inline-block;
	box-sizing: border-box;
	margin: 0;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	position: static;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .action-item .monaco-submenu {
	position: absolute;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	width: 100%;
	height: 0px !important;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator.text {
	padding: 0.7em 1em 0.1em 1em;
	font-weight: bold;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label:hover {
	color: inherit;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	position: absolute;
	visibility: hidden;
	width: 1em;
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item.checked .menu-item-check {
	visibility: visible;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Context Menu */

.context-view.monaco-menu-container {
	outline: 0;
	border: none;
	animation: fadeIn 0.083s linear;
	-webkit-app-region: no-drag;
}

.context-view.monaco-menu-container :focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical:focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical :focus {
	outline: 0;
}

.hc-black .context-view.monaco-menu-container,
.hc-light .context-view.monaco-menu-container,
:host-context(.hc-black) .context-view.monaco-menu-container,
:host-context(.hc-light) .context-view.monaco-menu-container {
	box-shadow: none;
}

.hc-black .monaco-menu .monaco-action-bar.vertical .action-item.focused,
.hc-light .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-black) .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-light) .monaco-menu .monaco-action-bar.vertical .action-item.focused {
	background: none;
}

/* Vertical Action Bar Styles */

.monaco-menu .monaco-action-bar.vertical {
	padding: 4px 0;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	height: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator),
.monaco-menu .monaco-action-bar.vertical .keybinding {
	font-size: inherit;
	padding: 0 2em;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	font-size: inherit;
	width: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	font-size: inherit;
	margin: 5px 0 !important;
	padding: 0;
	border-radius: 0;
}

.linux .monaco-menu .monaco-action-bar.vertical .action-label.separator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .action-label.separator {
	margin-left: 0;
	margin-right: 0;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	font-size: 60%;
	padding: 0 1.8em;
}

.linux .monaco-menu .monaco-action-bar.vertical .submenu-indicator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
	mask-size: 10px 10px;
	-webkit-mask-size: 10px 10px;
}

.monaco-menu .action-item {
	cursor: default;
}`
  );
  if (e) {
    t += `
			/* Arrows */
			.monaco-scrollable-element > .scrollbar > .scra {
				cursor: pointer;
				font-size: 11px !important;
			}

			.monaco-scrollable-element > .visible {
				opacity: 1;

				/* Background rule added for IE9 - to allow clicks on dom node */
				background:rgba(0,0,0,0);

				transition: opacity 100ms linear;
			}
			.monaco-scrollable-element > .invisible {
				opacity: 0;
				pointer-events: none;
			}
			.monaco-scrollable-element > .invisible.fade {
				transition: opacity 800ms linear;
			}

			/* Scrollable Content Inset Shadow */
			.monaco-scrollable-element > .shadow {
				position: absolute;
				display: none;
			}
			.monaco-scrollable-element > .shadow.top {
				display: block;
				top: 0;
				left: 3px;
				height: 3px;
				width: 100%;
			}
			.monaco-scrollable-element > .shadow.left {
				display: block;
				top: 3px;
				left: 0;
				height: 100%;
				width: 3px;
			}
			.monaco-scrollable-element > .shadow.top-left-corner {
				display: block;
				top: 0;
				left: 0;
				height: 3px;
				width: 3px;
			}
		`;
    const n = i.scrollbarShadow;
    n && (t += `
				.monaco-scrollable-element > .shadow.top {
					box-shadow: ${n} 0 6px 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.left {
					box-shadow: ${n} 6px 0 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.top.left {
					box-shadow: ${n} 6px 6px 6px -6px inset;
				}
			`);
    const r = i.scrollbarSliderBackground;
    r && (t += `
				.monaco-scrollable-element > .scrollbar > .slider {
					background: ${r};
				}
			`);
    const s = i.scrollbarSliderHoverBackground;
    s && (t += `
				.monaco-scrollable-element > .scrollbar > .slider:hover {
					background: ${s};
				}
			`);
    const o = i.scrollbarSliderActiveBackground;
    o && (t += `
				.monaco-scrollable-element > .scrollbar > .slider.active {
					background: ${o};
				}
			`);
  }
  return t;
}
class rUe {
  constructor(e, t, n, r) {
    this.contextViewService = e, this.telemetryService = t, this.notificationService = n, this.keybindingService = r, this.focusToReturn = null, this.lastContainer = null, this.block = null, this.blockDisposable = null, this.options = { blockMouse: !0 };
  }
  configure(e) {
    this.options = e;
  }
  showContextMenu(e) {
    const t = e.getActions();
    if (!t.length)
      return;
    this.focusToReturn = document.activeElement;
    let n;
    const r = Zj(e.domForShadowRoot) ? e.domForShadowRoot : void 0;
    this.contextViewService.showContextView({
      getAnchor: () => e.getAnchor(),
      canRelayout: !1,
      anchorAlignment: e.anchorAlignment,
      anchorAxisAlignment: e.anchorAxisAlignment,
      render: (s) => {
        var o;
        this.lastContainer = s;
        const a = e.getMenuClassName ? e.getMenuClassName() : "";
        a && (s.className += " " + a), this.options.blockMouse && (this.block = s.appendChild(Re(".context-view-block")), this.block.style.position = "fixed", this.block.style.cursor = "initial", this.block.style.left = "0", this.block.style.top = "0", this.block.style.width = "100%", this.block.style.height = "100%", this.block.style.zIndex = "-1", (o = this.blockDisposable) === null || o === void 0 || o.dispose(), this.blockDisposable = Ie(this.block, Ge.MOUSE_DOWN, (d) => d.stopPropagation()));
        const l = new Ne(), c = e.actionRunner || new f_();
        return c.onWillRun((d) => this.onActionRun(d, !e.skipTelemetry), this, l), c.onDidRun(this.onDidActionRun, this, l), n = new Dpe(s, t, {
          actionViewItemProvider: e.getActionViewItem,
          context: e.getActionsContext ? e.getActionsContext() : null,
          actionRunner: c,
          getKeyBinding: e.getKeyBinding ? e.getKeyBinding : (d) => this.keybindingService.lookupKeybinding(d.id)
        }, Jze), n.onDidCancel(() => this.contextViewService.hideContextView(!0), null, l), n.onDidBlur(() => this.contextViewService.hideContextView(!0), null, l), l.add(Ie(window, Ge.BLUR, () => this.contextViewService.hideContextView(!0))), l.add(Ie(window, Ge.MOUSE_DOWN, (d) => {
          if (d.defaultPrevented)
            return;
          const u = new cl(d);
          let h = u.target;
          if (!u.rightButton) {
            for (; h; ) {
              if (h === s)
                return;
              h = h.parentElement;
            }
            this.contextViewService.hideContextView(!0);
          }
        })), Ql(l, n);
      },
      focus: () => {
        n?.focus(!!e.autoSelectFirstItem);
      },
      onHide: (s) => {
        var o, a, l;
        (o = e.onHide) === null || o === void 0 || o.call(e, !!s), this.block && (this.block.remove(), this.block = null), (a = this.blockDisposable) === null || a === void 0 || a.dispose(), this.blockDisposable = null, this.lastContainer && (Jl() === this.lastContainer || xs(Jl(), this.lastContainer)) && ((l = this.focusToReturn) === null || l === void 0 || l.focus()), this.lastContainer = null;
      }
    }, r, !!r);
  }
  onActionRun(e, t) {
    t && this.telemetryService.publicLog2("workbenchActionExecuted", { id: e.action.id, from: "contextMenu" }), this.contextViewService.hideContextView(!1);
  }
  onDidActionRun(e) {
    e.error && !md(e.error) && this.notificationService.error(e.error);
  }
}
var sUe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, _1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let kB = class extends we {
  get contextMenuHandler() {
    return this._contextMenuHandler || (this._contextMenuHandler = new rUe(this.contextViewService, this.telemetryService, this.notificationService, this.keybindingService)), this._contextMenuHandler;
  }
  constructor(e, t, n, r, s, o) {
    super(), this.telemetryService = e, this.notificationService = t, this.contextViewService = n, this.keybindingService = r, this.menuService = s, this.contextKeyService = o, this._contextMenuHandler = void 0, this._onDidShowContextMenu = this._store.add(new pe()), this._onDidHideContextMenu = this._store.add(new pe());
  }
  configure(e) {
    this.contextMenuHandler.configure(e);
  }
  // ContextMenu
  showContextMenu(e) {
    e = TB.transform(e, this.menuService, this.contextKeyService), this.contextMenuHandler.showContextMenu(Object.assign(Object.assign({}, e), { onHide: (t) => {
      var n;
      (n = e.onHide) === null || n === void 0 || n.call(e, t), this._onDidHideContextMenu.fire();
    } })), Sh.getInstance().resetKeyStatus(), this._onDidShowContextMenu.fire();
  }
};
kB = sUe([
  _1(0, qa),
  _1(1, dr),
  _1(2, cf),
  _1(3, Bn),
  _1(4, Ou),
  _1(5, yt)
], kB);
var TB;
(function(i) {
  function e(n) {
    return n && n.menuId instanceof J;
  }
  function t(n, r, s) {
    if (!e(n))
      return n;
    const { menuId: o, menuActionOptions: a, contextKeyService: l } = n;
    return Object.assign(Object.assign({}, n), { getActions: () => {
      const c = [];
      if (o) {
        const d = r.createMenu(o, l ?? s);
        $ze(d, a, c), d.dispose();
      }
      return n.getActions ? Gr.join(n.getActions(), c) : c;
    } });
  }
  i.transform = t;
})(TB || (TB = {}));
var zL;
(function(i) {
  i[i.API = 0] = "API", i[i.USER = 1] = "USER";
})(zL || (zL = {}));
var lU = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, UL = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, tm = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let NB = class {
  constructor(e) {
    this._commandService = e;
  }
  open(e, t) {
    return tm(this, void 0, void 0, function* () {
      if (!Kz(e, Mt.command))
        return !1;
      if (!t?.allowCommands || (typeof e == "string" && (e = pt.parse(e)), Array.isArray(t.allowCommands) && !t.allowCommands.includes(e.path)))
        return !0;
      let n = [];
      try {
        n = yB(decodeURIComponent(e.query));
      } catch {
        try {
          n = yB(e.query);
        } catch {
        }
      }
      return Array.isArray(n) || (n = [n]), yield this._commandService.executeCommand(e.path, ...n), !0;
    });
  }
};
NB = lU([
  UL(0, Ui)
], NB);
let PB = class {
  constructor(e) {
    this._editorService = e;
  }
  open(e, t) {
    return tm(this, void 0, void 0, function* () {
      typeof e == "string" && (e = pt.parse(e));
      const { selection: n, uri: r } = dWe(e);
      return e = r, e.scheme === Mt.file && (e = qBe(e)), yield this._editorService.openCodeEditor({
        resource: e,
        options: Object.assign({ selection: n, source: t?.fromUserGesture ? zL.USER : zL.API }, t?.editorOptions)
      }, this._editorService.getFocusedCodeEditor(), t?.openToSide), !0;
    });
  }
};
PB = lU([
  UL(0, Sn)
], PB);
let OB = class {
  constructor(e, t) {
    this._openers = new fo(), this._validators = new fo(), this._resolvers = new fo(), this._resolvedUriTargets = new Ms((n) => n.with({ path: null, fragment: null, query: null }).toString()), this._externalOpeners = new fo(), this._defaultExternalOpener = {
      openExternal: (n) => tm(this, void 0, void 0, function* () {
        return LQ(n, Mt.http, Mt.https) ? jhe(n) : window.location.href = n, !0;
      })
    }, this._openers.push({
      open: (n, r) => tm(this, void 0, void 0, function* () {
        return r?.openExternal || LQ(n, Mt.mailto, Mt.http, Mt.https, Mt.vsls) ? (yield this._doOpenExternal(n, r), !0) : !1;
      })
    }), this._openers.push(new NB(t)), this._openers.push(new PB(e));
  }
  registerOpener(e) {
    return { dispose: this._openers.unshift(e) };
  }
  open(e, t) {
    var n;
    return tm(this, void 0, void 0, function* () {
      const r = typeof e == "string" ? pt.parse(e) : e, s = (n = this._resolvedUriTargets.get(r)) !== null && n !== void 0 ? n : e;
      for (const o of this._validators)
        if (!(yield o.shouldOpen(s, t)))
          return !1;
      for (const o of this._openers)
        if (yield o.open(e, t))
          return !0;
      return !1;
    });
  }
  resolveExternalUri(e, t) {
    return tm(this, void 0, void 0, function* () {
      for (const n of this._resolvers)
        try {
          const r = yield n.resolveExternalUri(e, t);
          if (r)
            return this._resolvedUriTargets.has(r.resolved) || this._resolvedUriTargets.set(r.resolved, e), r;
        } catch {
        }
      throw new Error("Could not resolve external URI: " + e.toString());
    });
  }
  _doOpenExternal(e, t) {
    return tm(this, void 0, void 0, function* () {
      const n = typeof e == "string" ? pt.parse(e) : e;
      let r;
      try {
        r = (yield this.resolveExternalUri(n, t)).resolved;
      } catch {
        r = n;
      }
      let s;
      if (typeof e == "string" && n.toString() === r.toString() ? s = e : s = encodeURI(r.toString(!0)), t?.allowContributedOpeners) {
        const o = typeof t?.allowContributedOpeners == "string" ? t?.allowContributedOpeners : void 0;
        for (const a of this._externalOpeners)
          if (yield a.openExternal(s, {
            sourceUri: n,
            preferredOpenerId: o
          }, jt.None))
            return !0;
      }
      return this._defaultExternalOpener.openExternal(s, { sourceUri: n }, jt.None);
    });
  }
  dispose() {
    this._validators.clear();
  }
};
OB = lU([
  UL(0, Sn),
  UL(1, Ui)
], OB);
const vc = Gt("editorWorkerService");
var Fi;
(function(i) {
  i[i.Hint = 1] = "Hint", i[i.Info = 2] = "Info", i[i.Warning = 4] = "Warning", i[i.Error = 8] = "Error";
})(Fi || (Fi = {}));
(function(i) {
  function e(o, a) {
    return a - o;
  }
  i.compare = e;
  const t = /* @__PURE__ */ Object.create(null);
  t[i.Error] = C("sev.error", "Error"), t[i.Warning] = C("sev.warning", "Warning"), t[i.Info] = C("sev.info", "Info");
  function n(o) {
    return t[o] || "";
  }
  i.toString = n;
  function r(o) {
    switch (o) {
      case Yi.Error:
        return i.Error;
      case Yi.Warning:
        return i.Warning;
      case Yi.Info:
        return i.Info;
      case Yi.Ignore:
        return i.Hint;
    }
  }
  i.fromSeverity = r;
  function s(o) {
    switch (o) {
      case i.Error:
        return Yi.Error;
      case i.Warning:
        return Yi.Warning;
      case i.Info:
        return Yi.Info;
      case i.Hint:
        return Yi.Ignore;
    }
  }
  i.toSeverity = s;
})(Fi || (Fi = {}));
var GL;
(function(i) {
  const e = "";
  function t(r) {
    return n(r, !0);
  }
  i.makeKey = t;
  function n(r, s) {
    const o = [e];
    return r.source ? o.push(r.source.replace("¦", "\\¦")) : o.push(e), r.code ? typeof r.code == "string" ? o.push(r.code.replace("¦", "\\¦")) : o.push(r.code.value.replace("¦", "\\¦")) : o.push(e), r.severity !== void 0 && r.severity !== null ? o.push(Fi.toString(r.severity)) : o.push(e), r.message && s ? o.push(r.message.replace("¦", "\\¦")) : o.push(e), r.startLineNumber !== void 0 && r.startLineNumber !== null ? o.push(r.startLineNumber.toString()) : o.push(e), r.startColumn !== void 0 && r.startColumn !== null ? o.push(r.startColumn.toString()) : o.push(e), r.endLineNumber !== void 0 && r.endLineNumber !== null ? o.push(r.endLineNumber.toString()) : o.push(e), r.endColumn !== void 0 && r.endColumn !== null ? o.push(r.endColumn.toString()) : o.push(e), o.push(e), o.join("¦");
  }
  i.makeKeyOptionalMessage = n;
})(GL || (GL = {}));
const Fu = Gt("markerService");
function oUe(i, e) {
  const t = [], n = [];
  for (const r of i)
    e.has(r) || t.push(r);
  for (const r of e)
    i.has(r) || n.push(r);
  return { removed: t, added: n };
}
function aUe(i, e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    i.has(n) && t.add(n);
  return t;
}
var lUe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, iJ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let MB = class extends we {
  constructor(e, t) {
    super(), this._markerService = t, this._onDidChangeMarker = this._register(new pe()), this._markerDecorations = new Ms(), e.getModels().forEach((n) => this._onModelAdded(n)), this._register(e.onModelAdded(this._onModelAdded, this)), this._register(e.onModelRemoved(this._onModelRemoved, this)), this._register(this._markerService.onMarkerChanged(this._handleMarkerChange, this));
  }
  dispose() {
    super.dispose(), this._markerDecorations.forEach((e) => e.dispose()), this._markerDecorations.clear();
  }
  getMarker(e, t) {
    const n = this._markerDecorations.get(e);
    return n && n.getMarker(t) || null;
  }
  _handleMarkerChange(e) {
    e.forEach((t) => {
      const n = this._markerDecorations.get(t);
      n && this._updateDecorations(n);
    });
  }
  _onModelAdded(e) {
    const t = new cUe(e);
    this._markerDecorations.set(e.uri, t), this._updateDecorations(t);
  }
  _onModelRemoved(e) {
    var t;
    const n = this._markerDecorations.get(e.uri);
    n && (n.dispose(), this._markerDecorations.delete(e.uri)), (e.uri.scheme === Mt.inMemory || e.uri.scheme === Mt.internal || e.uri.scheme === Mt.vscode) && ((t = this._markerService) === null || t === void 0 || t.read({ resource: e.uri }).map((r) => r.owner).forEach((r) => this._markerService.remove(r, [e.uri])));
  }
  _updateDecorations(e) {
    const t = this._markerService.read({ resource: e.model.uri, take: 500 });
    e.update(t) && this._onDidChangeMarker.fire(e.model);
  }
};
MB = lUe([
  iJ(0, fi),
  iJ(1, Fu)
], MB);
class cUe extends we {
  constructor(e) {
    super(), this.model = e, this._map = new qPe(), this._register(Ct(() => {
      this.model.deltaDecorations([...this._map.values()], []), this._map.clear();
    }));
  }
  update(e) {
    const { added: t, removed: n } = oUe(new Set(this._map.keys()), new Set(e));
    if (t.length === 0 && n.length === 0)
      return !1;
    const r = n.map((a) => this._map.get(a)), s = t.map((a) => ({
      range: this._createDecorationRange(this.model, a),
      options: this._createDecorationOption(a)
    })), o = this.model.deltaDecorations(r, s);
    for (const a of n)
      this._map.delete(a);
    for (let a = 0; a < o.length; a++)
      this._map.set(t[a], o[a]);
    return !0;
  }
  getMarker(e) {
    return this._map.getKey(e.id);
  }
  _createDecorationRange(e, t) {
    let n = V.lift(t);
    if (t.severity === Fi.Hint && !this._hasMarkerTag(
      t,
      1
      /* MarkerTag.Unnecessary */
    ) && !this._hasMarkerTag(
      t,
      2
      /* MarkerTag.Deprecated */
    ) && (n = n.setEndPosition(n.startLineNumber, n.startColumn + 2)), n = e.validateRange(n), n.isEmpty()) {
      const r = e.getLineLastNonWhitespaceColumn(n.startLineNumber) || e.getLineMaxColumn(n.startLineNumber);
      if (r === 1 || n.endColumn >= r)
        return n;
      const s = e.getWordAtPosition(n.getStartPosition());
      s && (n = new V(n.startLineNumber, s.startColumn, n.endLineNumber, s.endColumn));
    } else if (t.endColumn === Number.MAX_VALUE && t.startColumn === 1 && n.startLineNumber === n.endLineNumber) {
      const r = e.getLineFirstNonWhitespaceColumn(t.startLineNumber);
      r < n.endColumn && (n = new V(n.startLineNumber, r, n.endLineNumber, n.endColumn), t.startColumn = r);
    }
    return n;
  }
  _createDecorationOption(e) {
    let t, n, r, s, o;
    switch (e.severity) {
      case Fi.Hint:
        this._hasMarkerTag(
          e,
          2
          /* MarkerTag.Deprecated */
        ) ? t = void 0 : this._hasMarkerTag(
          e,
          1
          /* MarkerTag.Unnecessary */
        ) ? t = "squiggly-unnecessary" : t = "squiggly-hint", r = 0;
        break;
      case Fi.Info:
        t = "squiggly-info", n = Oi(VRe), r = 10, o = {
          color: Oi(x8e),
          position: ia.Inline
        };
        break;
      case Fi.Warning:
        t = "squiggly-warning", n = Oi(BRe), r = 20, o = {
          color: Oi(D8e),
          position: ia.Inline
        };
        break;
      case Fi.Error:
      default:
        t = "squiggly-error", n = Oi(FRe), r = 30, o = {
          color: Oi(E8e),
          position: ia.Inline
        };
        break;
    }
    return e.tags && (e.tags.indexOf(
      1
      /* MarkerTag.Unnecessary */
    ) !== -1 && (s = "squiggly-inline-unnecessary"), e.tags.indexOf(
      2
      /* MarkerTag.Deprecated */
    ) !== -1 && (s = "squiggly-inline-deprecated")), {
      description: "marker-decoration",
      stickiness: 1,
      className: t,
      showIfCollapsed: !0,
      overviewRuler: {
        color: n,
        position: Ha.Right
      },
      minimap: o,
      zIndex: r,
      inlineClassName: s
    };
  }
  _hasMarkerTag(e, t) {
    return e.tags ? e.tags.indexOf(t) >= 0 : !1;
  }
}
var dUe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, d2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, R1;
function Ep(i) {
  return i.toString();
}
class uUe {
  constructor(e, t, n) {
    this.model = e, this._modelEventListeners = new Ne(), this.model = e, this._modelEventListeners.add(e.onWillDispose(() => t(e))), this._modelEventListeners.add(e.onDidChangeLanguage((r) => n(e, r)));
  }
  dispose() {
    this._modelEventListeners.dispose();
  }
}
const hUe = $s || sn ? 1 : 2;
class fUe {
  constructor(e, t, n, r, s, o, a, l) {
    this.uri = e, this.initialUndoRedoSnapshot = t, this.time = n, this.sharesUndoRedoStack = r, this.heapSize = s, this.sha1 = o, this.versionId = a, this.alternativeVersionId = l;
  }
}
let qL = R1 = class extends we {
  constructor(e, t, n, r, s) {
    super(), this._configurationService = e, this._resourcePropertiesService = t, this._undoRedoService = n, this._languageService = r, this._languageConfigurationService = s, this._onModelAdded = this._register(new pe()), this.onModelAdded = this._onModelAdded.event, this._onModelRemoved = this._register(new pe()), this.onModelRemoved = this._onModelRemoved.event, this._onModelModeChanged = this._register(new pe()), this.onModelLanguageChanged = this._onModelModeChanged.event, this._modelCreationOptionsByLanguageAndResource = /* @__PURE__ */ Object.create(null), this._models = {}, this._disposedModels = /* @__PURE__ */ new Map(), this._disposedModelsHeapSize = 0, this._register(this._configurationService.onDidChangeConfiguration((o) => this._updateModelOptions(o))), this._updateModelOptions(void 0);
  }
  static _readModelOptions(e, t) {
    var n;
    let r = Os.tabSize;
    if (e.editor && typeof e.editor.tabSize < "u") {
      const f = parseInt(e.editor.tabSize, 10);
      isNaN(f) || (r = f), r < 1 && (r = 1);
    }
    let s = "tabSize";
    if (e.editor && typeof e.editor.indentSize < "u" && e.editor.indentSize !== "tabSize") {
      const f = parseInt(e.editor.indentSize, 10);
      isNaN(f) || (s = Math.max(f, 1));
    }
    let o = Os.insertSpaces;
    e.editor && typeof e.editor.insertSpaces < "u" && (o = e.editor.insertSpaces === "false" ? !1 : !!e.editor.insertSpaces);
    let a = hUe;
    const l = e.eol;
    l === `\r
` ? a = 2 : l === `
` && (a = 1);
    let c = Os.trimAutoWhitespace;
    e.editor && typeof e.editor.trimAutoWhitespace < "u" && (c = e.editor.trimAutoWhitespace === "false" ? !1 : !!e.editor.trimAutoWhitespace);
    let d = Os.detectIndentation;
    e.editor && typeof e.editor.detectIndentation < "u" && (d = e.editor.detectIndentation === "false" ? !1 : !!e.editor.detectIndentation);
    let u = Os.largeFileOptimizations;
    e.editor && typeof e.editor.largeFileOptimizations < "u" && (u = e.editor.largeFileOptimizations === "false" ? !1 : !!e.editor.largeFileOptimizations);
    let h = Os.bracketPairColorizationOptions;
    return !((n = e.editor) === null || n === void 0) && n.bracketPairColorization && typeof e.editor.bracketPairColorization == "object" && (h = {
      enabled: !!e.editor.bracketPairColorization.enabled,
      independentColorPoolPerBracketType: !!e.editor.bracketPairColorization.independentColorPoolPerBracketType
    }), {
      isForSimpleWidget: t,
      tabSize: r,
      indentSize: s,
      insertSpaces: o,
      detectIndentation: d,
      defaultEOL: a,
      trimAutoWhitespace: c,
      largeFileOptimizations: u,
      bracketPairColorizationOptions: h
    };
  }
  _getEOL(e, t) {
    if (e)
      return this._resourcePropertiesService.getEOL(e, t);
    const n = this._configurationService.getValue("files.eol", { overrideIdentifier: t });
    return n && typeof n == "string" && n !== "auto" ? n : ka === 3 || ka === 2 ? `
` : `\r
`;
  }
  _shouldRestoreUndoStack() {
    const e = this._configurationService.getValue("files.restoreUndoStack");
    return typeof e == "boolean" ? e : !0;
  }
  getCreationOptions(e, t, n) {
    const r = typeof e == "string" ? e : e.languageId;
    let s = this._modelCreationOptionsByLanguageAndResource[r + t];
    if (!s) {
      const o = this._configurationService.getValue("editor", { overrideIdentifier: r, resource: t }), a = this._getEOL(t, r);
      s = R1._readModelOptions({ editor: o, eol: a }, n), this._modelCreationOptionsByLanguageAndResource[r + t] = s;
    }
    return s;
  }
  _updateModelOptions(e) {
    const t = this._modelCreationOptionsByLanguageAndResource;
    this._modelCreationOptionsByLanguageAndResource = /* @__PURE__ */ Object.create(null);
    const n = Object.keys(this._models);
    for (let r = 0, s = n.length; r < s; r++) {
      const o = n[r], a = this._models[o], l = a.model.getLanguageId(), c = a.model.uri;
      if (e && !e.affectsConfiguration("editor", { overrideIdentifier: l, resource: c }) && !e.affectsConfiguration("files.eol", { overrideIdentifier: l, resource: c }))
        continue;
      const d = t[l + c], u = this.getCreationOptions(l, c, a.model.isForSimpleWidget);
      R1._setModelOptionsForModel(a.model, u, d);
    }
  }
  static _setModelOptionsForModel(e, t, n) {
    n && n.defaultEOL !== t.defaultEOL && e.getLineCount() === 1 && e.setEOL(
      t.defaultEOL === 1 ? 0 : 1
      /* EndOfLineSequence.CRLF */
    ), !(n && n.detectIndentation === t.detectIndentation && n.insertSpaces === t.insertSpaces && n.tabSize === t.tabSize && n.indentSize === t.indentSize && n.trimAutoWhitespace === t.trimAutoWhitespace && Ra(n.bracketPairColorizationOptions, t.bracketPairColorizationOptions)) && (t.detectIndentation ? (e.detectIndentation(t.insertSpaces, t.tabSize), e.updateOptions({
      trimAutoWhitespace: t.trimAutoWhitespace,
      bracketColorizationOptions: t.bracketPairColorizationOptions
    })) : e.updateOptions({
      insertSpaces: t.insertSpaces,
      tabSize: t.tabSize,
      indentSize: t.indentSize,
      trimAutoWhitespace: t.trimAutoWhitespace,
      bracketColorizationOptions: t.bracketPairColorizationOptions
    }));
  }
  // --- begin IModelService
  _insertDisposedModel(e) {
    this._disposedModels.set(Ep(e.uri), e), this._disposedModelsHeapSize += e.heapSize;
  }
  _removeDisposedModel(e) {
    const t = this._disposedModels.get(Ep(e));
    return t && (this._disposedModelsHeapSize -= t.heapSize), this._disposedModels.delete(Ep(e)), t;
  }
  _ensureDisposedModelsHeapSize(e) {
    if (this._disposedModelsHeapSize > e) {
      const t = [];
      for (this._disposedModels.forEach((n) => {
        n.sharesUndoRedoStack || t.push(n);
      }), t.sort((n, r) => n.time - r.time); t.length > 0 && this._disposedModelsHeapSize > e; ) {
        const n = t.shift();
        this._removeDisposedModel(n.uri), n.initialUndoRedoSnapshot !== null && this._undoRedoService.restoreSnapshot(n.initialUndoRedoSnapshot);
      }
    }
  }
  _createModelData(e, t, n, r) {
    const s = this.getCreationOptions(t, n, r), o = new Du(e, t, s, n, this._undoRedoService, this._languageService, this._languageConfigurationService);
    if (n && this._disposedModels.has(Ep(n))) {
      const c = this._removeDisposedModel(n), d = this._undoRedoService.getElements(n), u = this._getSHA1Computer(), h = u.canComputeSHA1(o) ? u.computeSHA1(o) === c.sha1 : !1;
      if (h || c.sharesUndoRedoStack) {
        for (const f of d.past)
          dh(f) && f.matchesResource(n) && f.setModel(o);
        for (const f of d.future)
          dh(f) && f.matchesResource(n) && f.setModel(o);
        this._undoRedoService.setElementsValidFlag(n, !0, (f) => dh(f) && f.matchesResource(n)), h && (o._overwriteVersionId(c.versionId), o._overwriteAlternativeVersionId(c.alternativeVersionId), o._overwriteInitialUndoRedoSnapshot(c.initialUndoRedoSnapshot));
      } else
        c.initialUndoRedoSnapshot !== null && this._undoRedoService.restoreSnapshot(c.initialUndoRedoSnapshot);
    }
    const a = Ep(o.uri);
    if (this._models[a])
      throw new Error("ModelService: Cannot add model because it already exists!");
    const l = new uUe(o, (c) => this._onWillDispose(c), (c, d) => this._onDidChangeLanguage(c, d));
    return this._models[a] = l, l;
  }
  createModel(e, t, n, r = !1) {
    let s;
    return t ? s = this._createModelData(e, t, n, r) : s = this._createModelData(e, Fa, n, r), this._onModelAdded.fire(s.model), s.model;
  }
  getModels() {
    const e = [], t = Object.keys(this._models);
    for (let n = 0, r = t.length; n < r; n++) {
      const s = t[n];
      e.push(this._models[s].model);
    }
    return e;
  }
  getModel(e) {
    const t = Ep(e), n = this._models[t];
    return n ? n.model : null;
  }
  // --- end IModelService
  _schemaShouldMaintainUndoRedoElements(e) {
    return e.scheme === Mt.file || e.scheme === Mt.vscodeRemote || e.scheme === Mt.vscodeUserData || e.scheme === Mt.vscodeNotebookCell || e.scheme === "fake-fs";
  }
  _onWillDispose(e) {
    const t = Ep(e.uri), n = this._models[t], r = this._undoRedoService.getUriComparisonKey(e.uri) !== e.uri.toString();
    let s = !1, o = 0;
    if (r || this._shouldRestoreUndoStack() && this._schemaShouldMaintainUndoRedoElements(e.uri)) {
      const c = this._undoRedoService.getElements(e.uri);
      if (c.past.length > 0 || c.future.length > 0) {
        for (const d of c.past)
          dh(d) && d.matchesResource(e.uri) && (s = !0, o += d.heapSize(e.uri), d.setModel(e.uri));
        for (const d of c.future)
          dh(d) && d.matchesResource(e.uri) && (s = !0, o += d.heapSize(e.uri), d.setModel(e.uri));
      }
    }
    const a = R1.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK, l = this._getSHA1Computer();
    if (s)
      if (!r && (o > a || !l.canComputeSHA1(e))) {
        const c = n.model.getInitialUndoRedoSnapshot();
        c !== null && this._undoRedoService.restoreSnapshot(c);
      } else
        this._ensureDisposedModelsHeapSize(a - o), this._undoRedoService.setElementsValidFlag(e.uri, !1, (c) => dh(c) && c.matchesResource(e.uri)), this._insertDisposedModel(new fUe(e.uri, n.model.getInitialUndoRedoSnapshot(), Date.now(), r, o, l.computeSHA1(e), e.getVersionId(), e.getAlternativeVersionId()));
    else if (!r) {
      const c = n.model.getInitialUndoRedoSnapshot();
      c !== null && this._undoRedoService.restoreSnapshot(c);
    }
    delete this._models[t], n.dispose(), delete this._modelCreationOptionsByLanguageAndResource[e.getLanguageId() + e.uri], this._onModelRemoved.fire(e);
  }
  _onDidChangeLanguage(e, t) {
    const n = t.oldLanguage, r = e.getLanguageId(), s = this.getCreationOptions(n, e.uri, e.isForSimpleWidget), o = this.getCreationOptions(r, e.uri, e.isForSimpleWidget);
    R1._setModelOptionsForModel(e, o, s), this._onModelModeChanged.fire({ model: e, oldLanguageId: n });
  }
  _getSHA1Computer() {
    return new B4();
  }
};
qL.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK = 20 * 1024 * 1024;
qL = R1 = dUe([
  d2(0, en),
  d2(1, _fe),
  d2(2, E4),
  d2(3, ci),
  d2(4, Un)
], qL);
class B4 {
  canComputeSHA1(e) {
    return e.getValueLength() <= B4.MAX_MODEL_SIZE;
  }
  computeSHA1(e) {
    const t = new h4(), n = e.createSnapshot();
    let r;
    for (; r = n.read(); )
      t.update(r);
    return t.digest();
  }
}
B4.MAX_MODEL_SIZE = 10 * 1024 * 1024;
class gUe {
  get templateId() {
    return this.renderer.templateId;
  }
  constructor(e, t) {
    this.renderer = e, this.modelProvider = t;
  }
  renderTemplate(e) {
    return { data: this.renderer.renderTemplate(e), disposable: we.None };
  }
  renderElement(e, t, n, r) {
    var s;
    if ((s = n.disposable) === null || s === void 0 || s.dispose(), !n.data)
      return;
    const o = this.modelProvider();
    if (o.isResolved(e))
      return this.renderer.renderElement(o.get(e), e, n.data, r);
    const a = new lr(), l = o.resolve(e, a.token);
    n.disposable = { dispose: () => a.cancel() }, this.renderer.renderPlaceholder(e, n.data), l.then((c) => this.renderer.renderElement(c, e, n.data, r));
  }
  disposeTemplate(e) {
    e.disposable && (e.disposable.dispose(), e.disposable = void 0), e.data && (this.renderer.disposeTemplate(e.data), e.data = void 0);
  }
}
class pUe {
  constructor(e, t) {
    this.modelProvider = e, this.accessibilityProvider = t;
  }
  getWidgetAriaLabel() {
    return this.accessibilityProvider.getWidgetAriaLabel();
  }
  getAriaLabel(e) {
    const t = this.modelProvider();
    return t.isResolved(e) ? this.accessibilityProvider.getAriaLabel(t.get(e)) : null;
  }
}
function mUe(i, e) {
  return Object.assign(Object.assign({}, e), { accessibilityProvider: e.accessibilityProvider && new pUe(i, e.accessibilityProvider) });
}
class vUe {
  constructor(e, t, n, r, s = {}) {
    const o = () => this.model, a = r.map((l) => new gUe(l, o));
    this.list = new pc(e, t, n, a, mUe(o, s));
  }
  updateOptions(e) {
    this.list.updateOptions(e);
  }
  getHTMLElement() {
    return this.list.getHTMLElement();
  }
  get onDidFocus() {
    return this.list.onDidFocus;
  }
  get widget() {
    return this.list;
  }
  get onDidDispose() {
    return this.list.onDidDispose;
  }
  get onMouseDblClick() {
    return qe.map(this.list.onMouseDblClick, ({ element: e, index: t, browserEvent: n }) => ({ element: e === void 0 ? void 0 : this._model.get(e), index: t, browserEvent: n }));
  }
  get onPointer() {
    return qe.map(this.list.onPointer, ({ element: e, index: t, browserEvent: n }) => ({ element: e === void 0 ? void 0 : this._model.get(e), index: t, browserEvent: n }));
  }
  get onDidChangeSelection() {
    return qe.map(this.list.onDidChangeSelection, ({ elements: e, indexes: t, browserEvent: n }) => ({ elements: e.map((r) => this._model.get(r)), indexes: t, browserEvent: n }));
  }
  get model() {
    return this._model;
  }
  set model(e) {
    this._model = e, this.list.splice(0, this.list.length, io(e.length));
  }
  getFocus() {
    return this.list.getFocus();
  }
  getSelection() {
    return this.list.getSelection();
  }
  getSelectedElements() {
    return this.getSelection().map((e) => this.model.get(e));
  }
  style(e) {
    this.list.style(e);
  }
  dispose() {
    this.list.dispose();
  }
}
var yb = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
};
const _Ue = !1;
var KL;
(function(i) {
  i.North = "north", i.South = "south", i.East = "east", i.West = "west";
})(KL || (KL = {}));
let bUe = 4;
const CUe = new pe();
let yUe = 300;
const wUe = new pe();
class cU {
  constructor() {
    this.disposables = new Ne();
  }
  get onPointerMove() {
    return this.disposables.add(new Yt(window, "mousemove")).event;
  }
  get onPointerUp() {
    return this.disposables.add(new Yt(window, "mouseup")).event;
  }
  dispose() {
    this.disposables.dispose();
  }
}
yb([
  cr
], cU.prototype, "onPointerMove", null);
yb([
  cr
], cU.prototype, "onPointerUp", null);
class dU {
  get onPointerMove() {
    return this.disposables.add(new Yt(this.el, Wn.Change)).event;
  }
  get onPointerUp() {
    return this.disposables.add(new Yt(this.el, Wn.End)).event;
  }
  constructor(e) {
    this.el = e, this.disposables = new Ne();
  }
  dispose() {
    this.disposables.dispose();
  }
}
yb([
  cr
], dU.prototype, "onPointerMove", null);
yb([
  cr
], dU.prototype, "onPointerUp", null);
class YL {
  get onPointerMove() {
    return this.factory.onPointerMove;
  }
  get onPointerUp() {
    return this.factory.onPointerUp;
  }
  constructor(e) {
    this.factory = e;
  }
  dispose() {
  }
}
yb([
  cr
], YL.prototype, "onPointerMove", null);
yb([
  cr
], YL.prototype, "onPointerUp", null);
const rJ = "pointer-events-disabled";
class Ts extends we {
  get state() {
    return this._state;
  }
  get orthogonalStartSash() {
    return this._orthogonalStartSash;
  }
  get orthogonalEndSash() {
    return this._orthogonalEndSash;
  }
  /**
   * The state of a sash defines whether it can be interacted with by the user
   * as well as what mouse cursor to use, when hovered.
   */
  set state(e) {
    this._state !== e && (this.el.classList.toggle(
      "disabled",
      e === 0
      /* SashState.Disabled */
    ), this.el.classList.toggle(
      "minimum",
      e === 1
      /* SashState.AtMinimum */
    ), this.el.classList.toggle(
      "maximum",
      e === 2
      /* SashState.AtMaximum */
    ), this._state = e, this.onDidEnablementChange.fire(e));
  }
  /**
   * A reference to another sash, perpendicular to this one, which
   * aligns at the start of this one. A corner sash will be created
   * automatically at that location.
   *
   * The start of a horizontal sash is its left-most position.
   * The start of a vertical sash is its top-most position.
   */
  set orthogonalStartSash(e) {
    if (this._orthogonalStartSash !== e) {
      if (this.orthogonalStartDragHandleDisposables.clear(), this.orthogonalStartSashDisposables.clear(), e) {
        const t = (n) => {
          this.orthogonalStartDragHandleDisposables.clear(), n !== 0 && (this._orthogonalStartDragHandle = Te(this.el, Re(".orthogonal-drag-handle.start")), this.orthogonalStartDragHandleDisposables.add(Ct(() => this._orthogonalStartDragHandle.remove())), this.orthogonalStartDragHandleDisposables.add(new Yt(this._orthogonalStartDragHandle, "mouseenter")).event(() => Ts.onMouseEnter(e), void 0, this.orthogonalStartDragHandleDisposables), this.orthogonalStartDragHandleDisposables.add(new Yt(this._orthogonalStartDragHandle, "mouseleave")).event(() => Ts.onMouseLeave(e), void 0, this.orthogonalStartDragHandleDisposables));
        };
        this.orthogonalStartSashDisposables.add(e.onDidEnablementChange.event(t, this)), t(e.state);
      }
      this._orthogonalStartSash = e;
    }
  }
  /**
   * A reference to another sash, perpendicular to this one, which
   * aligns at the end of this one. A corner sash will be created
   * automatically at that location.
   *
   * The end of a horizontal sash is its right-most position.
   * The end of a vertical sash is its bottom-most position.
   */
  set orthogonalEndSash(e) {
    if (this._orthogonalEndSash !== e) {
      if (this.orthogonalEndDragHandleDisposables.clear(), this.orthogonalEndSashDisposables.clear(), e) {
        const t = (n) => {
          this.orthogonalEndDragHandleDisposables.clear(), n !== 0 && (this._orthogonalEndDragHandle = Te(this.el, Re(".orthogonal-drag-handle.end")), this.orthogonalEndDragHandleDisposables.add(Ct(() => this._orthogonalEndDragHandle.remove())), this.orthogonalEndDragHandleDisposables.add(new Yt(this._orthogonalEndDragHandle, "mouseenter")).event(() => Ts.onMouseEnter(e), void 0, this.orthogonalEndDragHandleDisposables), this.orthogonalEndDragHandleDisposables.add(new Yt(this._orthogonalEndDragHandle, "mouseleave")).event(() => Ts.onMouseLeave(e), void 0, this.orthogonalEndDragHandleDisposables));
        };
        this.orthogonalEndSashDisposables.add(e.onDidEnablementChange.event(t, this)), t(e.state);
      }
      this._orthogonalEndSash = e;
    }
  }
  constructor(e, t, n) {
    super(), this.hoverDelay = yUe, this.hoverDelayer = this._register(new ac(this.hoverDelay)), this._state = 3, this.onDidEnablementChange = this._register(new pe()), this._onDidStart = this._register(new pe()), this._onDidChange = this._register(new pe()), this._onDidReset = this._register(new pe()), this._onDidEnd = this._register(new pe()), this.orthogonalStartSashDisposables = this._register(new Ne()), this.orthogonalStartDragHandleDisposables = this._register(new Ne()), this.orthogonalEndSashDisposables = this._register(new Ne()), this.orthogonalEndDragHandleDisposables = this._register(new Ne()), this.onDidStart = this._onDidStart.event, this.onDidChange = this._onDidChange.event, this.onDidReset = this._onDidReset.event, this.onDidEnd = this._onDidEnd.event, this.linkedSash = void 0, this.el = Te(e, Re(".monaco-sash")), n.orthogonalEdge && this.el.classList.add(`orthogonal-edge-${n.orthogonalEdge}`), sn && this.el.classList.add("mac");
    const r = this._register(new Yt(this.el, "mousedown")).event;
    this._register(r((u) => this.onPointerStart(u, new cU()), this));
    const s = this._register(new Yt(this.el, "dblclick")).event;
    this._register(s(this.onPointerDoublePress, this));
    const o = this._register(new Yt(this.el, "mouseenter")).event;
    this._register(o(() => Ts.onMouseEnter(this)));
    const a = this._register(new Yt(this.el, "mouseleave")).event;
    this._register(a(() => Ts.onMouseLeave(this))), this._register(Vn.addTarget(this.el));
    const l = this._register(new Yt(this.el, Wn.Start)).event;
    this._register(l((u) => this.onPointerStart(u, new dU(this.el)), this));
    const c = this._register(new Yt(this.el, Wn.Tap)).event;
    let d;
    this._register(c((u) => {
      if (d) {
        clearTimeout(d), d = void 0, this.onPointerDoublePress(u);
        return;
      }
      clearTimeout(d), d = setTimeout(() => d = void 0, 250);
    }, this)), typeof n.size == "number" ? (this.size = n.size, n.orientation === 0 ? this.el.style.width = `${this.size}px` : this.el.style.height = `${this.size}px`) : (this.size = bUe, this._register(CUe.event((u) => {
      this.size = u, this.layout();
    }))), this._register(wUe.event((u) => this.hoverDelay = u)), this.layoutProvider = t, this.orthogonalStartSash = n.orthogonalStartSash, this.orthogonalEndSash = n.orthogonalEndSash, this.orientation = n.orientation || 0, this.orientation === 1 ? (this.el.classList.add("horizontal"), this.el.classList.remove("vertical")) : (this.el.classList.remove("horizontal"), this.el.classList.add("vertical")), this.el.classList.toggle("debug", _Ue), this.layout();
  }
  onPointerStart(e, t) {
    Tt.stop(e);
    let n = !1;
    if (!e.__orthogonalSashEvent) {
      const g = this.getOrthogonalSash(e);
      g && (n = !0, e.__orthogonalSashEvent = !0, g.onPointerStart(e, new YL(t)));
    }
    if (this.linkedSash && !e.__linkedSashEvent && (e.__linkedSashEvent = !0, this.linkedSash.onPointerStart(e, new YL(t))), !this.state)
      return;
    const r = document.getElementsByTagName("iframe");
    for (const g of r)
      g.classList.add(rJ);
    const s = e.pageX, o = e.pageY, a = e.altKey, l = { startX: s, currentX: s, startY: o, currentY: o, altKey: a };
    this.el.classList.add("active"), this._onDidStart.fire(l);
    const c = yl(this.el), d = () => {
      let g = "";
      n ? g = "all-scroll" : this.orientation === 1 ? this.state === 1 ? g = "s-resize" : this.state === 2 ? g = "n-resize" : g = sn ? "row-resize" : "ns-resize" : this.state === 1 ? g = "e-resize" : this.state === 2 ? g = "w-resize" : g = sn ? "col-resize" : "ew-resize", c.textContent = `* { cursor: ${g} !important; }`;
    }, u = new Ne();
    d(), n || this.onDidEnablementChange.event(d, null, u);
    const h = (g) => {
      Tt.stop(g, !1);
      const p = { startX: s, currentX: g.pageX, startY: o, currentY: g.pageY, altKey: a };
      this._onDidChange.fire(p);
    }, f = (g) => {
      Tt.stop(g, !1), this.el.removeChild(c), this.el.classList.remove("active"), this._onDidEnd.fire(), u.dispose();
      for (const p of r)
        p.classList.remove(rJ);
    };
    t.onPointerMove(h, null, u), t.onPointerUp(f, null, u), u.add(t);
  }
  onPointerDoublePress(e) {
    const t = this.getOrthogonalSash(e);
    t && t._onDidReset.fire(), this.linkedSash && this.linkedSash._onDidReset.fire(), this._onDidReset.fire();
  }
  static onMouseEnter(e, t = !1) {
    e.el.classList.contains("active") ? (e.hoverDelayer.cancel(), e.el.classList.add("hover")) : e.hoverDelayer.trigger(() => e.el.classList.add("hover"), e.hoverDelay).then(void 0, () => {
    }), !t && e.linkedSash && Ts.onMouseEnter(e.linkedSash, !0);
  }
  static onMouseLeave(e, t = !1) {
    e.hoverDelayer.cancel(), e.el.classList.remove("hover"), !t && e.linkedSash && Ts.onMouseLeave(e.linkedSash, !0);
  }
  /**
   * Forcefully stop any user interactions with this sash.
   * Useful when hiding a parent component, while the user is still
   * interacting with the sash.
   */
  clearSashHoverState() {
    Ts.onMouseLeave(this);
  }
  /**
   * Layout the sash. The sash will size and position itself
   * based on its provided {@link ISashLayoutProvider layout provider}.
   */
  layout() {
    if (this.orientation === 0) {
      const e = this.layoutProvider;
      this.el.style.left = e.getVerticalSashLeft(this) - this.size / 2 + "px", e.getVerticalSashTop && (this.el.style.top = e.getVerticalSashTop(this) + "px"), e.getVerticalSashHeight && (this.el.style.height = e.getVerticalSashHeight(this) + "px");
    } else {
      const e = this.layoutProvider;
      this.el.style.top = e.getHorizontalSashTop(this) - this.size / 2 + "px", e.getHorizontalSashLeft && (this.el.style.left = e.getHorizontalSashLeft(this) + "px"), e.getHorizontalSashWidth && (this.el.style.width = e.getHorizontalSashWidth(this) + "px");
    }
  }
  getOrthogonalSash(e) {
    var t;
    const n = (t = e.initialTarget) !== null && t !== void 0 ? t : e.target;
    if (!(!n || !(n instanceof HTMLElement)) && n.classList.contains("orthogonal-drag-handle"))
      return n.classList.contains("start") ? this.orthogonalStartSash : this.orthogonalEndSash;
  }
  dispose() {
    super.dispose(), this.el.remove();
  }
}
const SUe = {
  separatorBorder: ye.transparent
};
class Lpe {
  set size(e) {
    this._size = e;
  }
  get size() {
    return this._size;
  }
  get visible() {
    return typeof this._cachedVisibleSize > "u";
  }
  setVisible(e, t) {
    var n, r;
    e !== this.visible && (e ? (this.size = qo(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize), this._cachedVisibleSize = void 0) : (this._cachedVisibleSize = typeof t == "number" ? t : this.size, this.size = 0), this.container.classList.toggle("visible", e), (r = (n = this.view).setVisible) === null || r === void 0 || r.call(n, e));
  }
  get minimumSize() {
    return this.visible ? this.view.minimumSize : 0;
  }
  get viewMinimumSize() {
    return this.view.minimumSize;
  }
  get maximumSize() {
    return this.visible ? this.view.maximumSize : 0;
  }
  get viewMaximumSize() {
    return this.view.maximumSize;
  }
  get priority() {
    return this.view.priority;
  }
  get proportionalLayout() {
    var e;
    return (e = this.view.proportionalLayout) !== null && e !== void 0 ? e : !0;
  }
  get snap() {
    return !!this.view.snap;
  }
  set enabled(e) {
    this.container.style.pointerEvents = e ? "" : "none";
  }
  constructor(e, t, n, r) {
    this.container = e, this.view = t, this.disposable = r, this._cachedVisibleSize = void 0, typeof n == "number" ? (this._size = n, this._cachedVisibleSize = void 0, e.classList.add("visible")) : (this._size = 0, this._cachedVisibleSize = n.cachedVisibleSize);
  }
  layout(e, t) {
    this.layoutContainer(e), this.view.layout(this.size, e, t);
  }
  dispose() {
    this.disposable.dispose();
  }
}
class xUe extends Lpe {
  layoutContainer(e) {
    this.container.style.top = `${e}px`, this.container.style.height = `${this.size}px`;
  }
}
class DUe extends Lpe {
  layoutContainer(e) {
    this.container.style.left = `${e}px`, this.container.style.width = `${this.size}px`;
  }
}
var rh;
(function(i) {
  i[i.Idle = 0] = "Idle", i[i.Busy = 1] = "Busy";
})(rh || (rh = {}));
var XL;
(function(i) {
  i.Distribute = { type: "distribute" };
  function e(r) {
    return { type: "split", index: r };
  }
  i.Split = e;
  function t(r) {
    return { type: "auto", index: r };
  }
  i.Auto = t;
  function n(r) {
    return { type: "invisible", cachedVisibleSize: r };
  }
  i.Invisible = n;
})(XL || (XL = {}));
class Ipe extends we {
  get orthogonalStartSash() {
    return this._orthogonalStartSash;
  }
  get orthogonalEndSash() {
    return this._orthogonalEndSash;
  }
  get startSnappingEnabled() {
    return this._startSnappingEnabled;
  }
  get endSnappingEnabled() {
    return this._endSnappingEnabled;
  }
  /**
   * A reference to a sash, perpendicular to all sashes in this {@link SplitView},
   * located at the left- or top-most side of the SplitView.
   * Corner sashes will be created automatically at the intersections.
   */
  set orthogonalStartSash(e) {
    for (const t of this.sashItems)
      t.sash.orthogonalStartSash = e;
    this._orthogonalStartSash = e;
  }
  /**
   * A reference to a sash, perpendicular to all sashes in this {@link SplitView},
   * located at the right- or bottom-most side of the SplitView.
   * Corner sashes will be created automatically at the intersections.
   */
  set orthogonalEndSash(e) {
    for (const t of this.sashItems)
      t.sash.orthogonalEndSash = e;
    this._orthogonalEndSash = e;
  }
  /**
   * Enable/disable snapping at the beginning of this {@link SplitView}.
   */
  set startSnappingEnabled(e) {
    this._startSnappingEnabled !== e && (this._startSnappingEnabled = e, this.updateSashEnablement());
  }
  /**
   * Enable/disable snapping at the end of this {@link SplitView}.
   */
  set endSnappingEnabled(e) {
    this._endSnappingEnabled !== e && (this._endSnappingEnabled = e, this.updateSashEnablement());
  }
  /**
   * Create a new {@link SplitView} instance.
   */
  constructor(e, t = {}) {
    var n, r, s, o, a;
    super(), this.size = 0, this.contentSize = 0, this.proportions = void 0, this.viewItems = [], this.sashItems = [], this.state = rh.Idle, this._onDidSashChange = this._register(new pe()), this._onDidSashReset = this._register(new pe()), this._startSnappingEnabled = !0, this._endSnappingEnabled = !0, this.onDidSashChange = this._onDidSashChange.event, this.onDidSashReset = this._onDidSashReset.event, this.orientation = (n = t.orientation) !== null && n !== void 0 ? n : 0, this.inverseAltBehavior = (r = t.inverseAltBehavior) !== null && r !== void 0 ? r : !1, this.proportionalLayout = (s = t.proportionalLayout) !== null && s !== void 0 ? s : !0, this.getSashOrthogonalSize = t.getSashOrthogonalSize, this.el = document.createElement("div"), this.el.classList.add("monaco-split-view2"), this.el.classList.add(this.orientation === 0 ? "vertical" : "horizontal"), e.appendChild(this.el), this.sashContainer = Te(this.el, Re(".sash-container")), this.viewContainer = Re(".split-view-container"), this.scrollable = this._register(new kS({
      forceIntegerValues: !0,
      smoothScrollDuration: 125,
      scheduleAtNextAnimationFrame: Cl
    })), this.scrollableElement = this._register(new wz(this.viewContainer, {
      vertical: this.orientation === 0 ? (o = t.scrollbarVisibility) !== null && o !== void 0 ? o : 1 : 2,
      horizontal: this.orientation === 1 ? (a = t.scrollbarVisibility) !== null && a !== void 0 ? a : 1 : 2
      /* ScrollbarVisibility.Hidden */
    }, this.scrollable));
    const l = this._register(new Yt(this.viewContainer, "scroll")).event;
    this._register(l((c) => {
      const d = this.scrollableElement.getScrollPosition(), u = Math.abs(this.viewContainer.scrollLeft - d.scrollLeft) <= 1 ? void 0 : this.viewContainer.scrollLeft, h = Math.abs(this.viewContainer.scrollTop - d.scrollTop) <= 1 ? void 0 : this.viewContainer.scrollTop;
      (u !== void 0 || h !== void 0) && this.scrollableElement.setScrollPosition({ scrollLeft: u, scrollTop: h });
    })), this.onDidScroll = this.scrollableElement.onScroll, this._register(this.onDidScroll((c) => {
      c.scrollTopChanged && (this.viewContainer.scrollTop = c.scrollTop), c.scrollLeftChanged && (this.viewContainer.scrollLeft = c.scrollLeft);
    })), Te(this.el, this.scrollableElement.getDomNode()), this.style(t.styles || SUe), t.descriptor && (this.size = t.descriptor.size, t.descriptor.views.forEach((c, d) => {
      const u = Jo(c.visible) || c.visible ? c.size : { type: "invisible", cachedVisibleSize: c.size }, h = c.view;
      this.doAddView(h, u, d, !0);
    }), this.contentSize = this.viewItems.reduce((c, d) => c + d.size, 0), this.saveProportions());
  }
  style(e) {
    e.separatorBorder.isTransparent() ? (this.el.classList.remove("separator-border"), this.el.style.removeProperty("--separator-border")) : (this.el.classList.add("separator-border"), this.el.style.setProperty("--separator-border", e.separatorBorder.toString()));
  }
  /**
   * Add a {@link IView view} to this {@link SplitView}.
   *
   * @param view The view to add.
   * @param size Either a fixed size, or a dynamic {@link Sizing} strategy.
   * @param index The index to insert the view on.
   * @param skipLayout Whether layout should be skipped.
   */
  addView(e, t, n = this.viewItems.length, r) {
    this.doAddView(e, t, n, r);
  }
  /**
   * Layout the {@link SplitView}.
   *
   * @param size The entire size of the {@link SplitView}.
   * @param layoutContext An optional layout context to pass along to {@link IView views}.
   */
  layout(e, t) {
    const n = Math.max(this.size, this.contentSize);
    if (this.size = e, this.layoutContext = t, this.proportions) {
      let r = 0;
      for (let s = 0; s < this.viewItems.length; s++) {
        const o = this.viewItems[s], a = this.proportions[s];
        typeof a == "number" ? r += a : e -= o.size;
      }
      for (let s = 0; s < this.viewItems.length; s++) {
        const o = this.viewItems[s], a = this.proportions[s];
        typeof a == "number" && (o.size = qo(Math.round(a * e / r), o.minimumSize, o.maximumSize));
      }
    } else {
      const r = io(this.viewItems.length), s = r.filter(
        (a) => this.viewItems[a].priority === 1
        /* LayoutPriority.Low */
      ), o = r.filter(
        (a) => this.viewItems[a].priority === 2
        /* LayoutPriority.High */
      );
      this.resize(this.viewItems.length - 1, e - n, void 0, s, o);
    }
    this.distributeEmptySpace(), this.layoutViews();
  }
  saveProportions() {
    this.proportionalLayout && this.contentSize > 0 && (this.proportions = this.viewItems.map((e) => e.proportionalLayout ? e.size / this.contentSize : void 0));
  }
  onSashStart({ sash: e, start: t, alt: n }) {
    for (const a of this.viewItems)
      a.enabled = !1;
    const r = this.sashItems.findIndex((a) => a.sash === e), s = Ql(Ie(document.body, "keydown", (a) => o(this.sashDragState.current, a.altKey)), Ie(document.body, "keyup", () => o(this.sashDragState.current, !1))), o = (a, l) => {
      const c = this.viewItems.map((g) => g.size);
      let d = Number.NEGATIVE_INFINITY, u = Number.POSITIVE_INFINITY;
      if (this.inverseAltBehavior && (l = !l), l)
        if (r === this.sashItems.length - 1) {
          const p = this.viewItems[r];
          d = (p.minimumSize - p.size) / 2, u = (p.maximumSize - p.size) / 2;
        } else {
          const p = this.viewItems[r + 1];
          d = (p.size - p.maximumSize) / 2, u = (p.size - p.minimumSize) / 2;
        }
      let h, f;
      if (!l) {
        const g = io(r, -1), p = io(r + 1, this.viewItems.length), m = g.reduce((E, L) => E + (this.viewItems[L].minimumSize - c[L]), 0), _ = g.reduce((E, L) => E + (this.viewItems[L].viewMaximumSize - c[L]), 0), b = p.length === 0 ? Number.POSITIVE_INFINITY : p.reduce((E, L) => E + (c[L] - this.viewItems[L].minimumSize), 0), w = p.length === 0 ? Number.NEGATIVE_INFINITY : p.reduce((E, L) => E + (c[L] - this.viewItems[L].viewMaximumSize), 0), y = Math.max(m, w), S = Math.min(b, _), x = this.findFirstSnapIndex(g), D = this.findFirstSnapIndex(p);
        if (typeof x == "number") {
          const E = this.viewItems[x], L = Math.floor(E.viewMinimumSize / 2);
          h = {
            index: x,
            limitDelta: E.visible ? y - L : y + L,
            size: E.size
          };
        }
        if (typeof D == "number") {
          const E = this.viewItems[D], L = Math.floor(E.viewMinimumSize / 2);
          f = {
            index: D,
            limitDelta: E.visible ? S + L : S - L,
            size: E.size
          };
        }
      }
      this.sashDragState = { start: a, current: a, index: r, sizes: c, minDelta: d, maxDelta: u, alt: l, snapBefore: h, snapAfter: f, disposable: s };
    };
    o(t, n);
  }
  onSashChange({ current: e }) {
    const { index: t, start: n, sizes: r, alt: s, minDelta: o, maxDelta: a, snapBefore: l, snapAfter: c } = this.sashDragState;
    this.sashDragState.current = e;
    const d = e - n, u = this.resize(t, d, r, void 0, void 0, o, a, l, c);
    if (s) {
      const h = t === this.sashItems.length - 1, f = this.viewItems.map((w) => w.size), g = h ? t : t + 1, p = this.viewItems[g], m = p.size - p.maximumSize, _ = p.size - p.minimumSize, b = h ? t - 1 : t + 1;
      this.resize(b, -u, f, void 0, void 0, m, _);
    }
    this.distributeEmptySpace(), this.layoutViews();
  }
  onSashEnd(e) {
    this._onDidSashChange.fire(e), this.sashDragState.disposable.dispose(), this.saveProportions();
    for (const t of this.viewItems)
      t.enabled = !0;
  }
  onViewChange(e, t) {
    const n = this.viewItems.indexOf(e);
    n < 0 || n >= this.viewItems.length || (t = typeof t == "number" ? t : e.size, t = qo(t, e.minimumSize, e.maximumSize), this.inverseAltBehavior && n > 0 ? (this.resize(n - 1, Math.floor((e.size - t) / 2)), this.distributeEmptySpace(), this.layoutViews()) : (e.size = t, this.relayout([n], void 0)));
  }
  /**
   * Resize a {@link IView view} within the {@link SplitView}.
   *
   * @param index The {@link IView view} index.
   * @param size The {@link IView view} size.
   */
  resizeView(e, t) {
    if (this.state !== rh.Idle)
      throw new Error("Cant modify splitview");
    if (this.state = rh.Busy, e < 0 || e >= this.viewItems.length)
      return;
    const n = io(this.viewItems.length).filter((a) => a !== e), r = [...n.filter(
      (a) => this.viewItems[a].priority === 1
      /* LayoutPriority.Low */
    ), e], s = n.filter(
      (a) => this.viewItems[a].priority === 2
      /* LayoutPriority.High */
    ), o = this.viewItems[e];
    t = Math.round(t), t = qo(t, o.minimumSize, Math.min(o.maximumSize, this.size)), o.size = t, this.relayout(r, s), this.state = rh.Idle;
  }
  /**
   * Distribute the entire {@link SplitView} size among all {@link IView views}.
   */
  distributeViewSizes() {
    const e = [];
    let t = 0;
    for (const a of this.viewItems)
      a.maximumSize - a.minimumSize > 0 && (e.push(a), t += a.size);
    const n = Math.floor(t / e.length);
    for (const a of e)
      a.size = qo(n, a.minimumSize, a.maximumSize);
    const r = io(this.viewItems.length), s = r.filter(
      (a) => this.viewItems[a].priority === 1
      /* LayoutPriority.Low */
    ), o = r.filter(
      (a) => this.viewItems[a].priority === 2
      /* LayoutPriority.High */
    );
    this.relayout(s, o);
  }
  /**
   * Returns the size of a {@link IView view}.
   */
  getViewSize(e) {
    return e < 0 || e >= this.viewItems.length ? -1 : this.viewItems[e].size;
  }
  doAddView(e, t, n = this.viewItems.length, r) {
    if (this.state !== rh.Idle)
      throw new Error("Cant modify splitview");
    this.state = rh.Busy;
    const s = Re(".split-view-view");
    n === this.viewItems.length ? this.viewContainer.appendChild(s) : this.viewContainer.insertBefore(s, this.viewContainer.children.item(n));
    const o = e.onDidChange((h) => this.onViewChange(d, h)), a = Ct(() => this.viewContainer.removeChild(s)), l = Ql(o, a);
    let c;
    typeof t == "number" ? c = t : (t.type === "auto" && (this.areViewsDistributed() ? t = { type: "distribute" } : t = { type: "split", index: t.index }), t.type === "split" ? c = this.getViewSize(t.index) / 2 : t.type === "invisible" ? c = { cachedVisibleSize: t.cachedVisibleSize } : c = e.minimumSize);
    const d = this.orientation === 0 ? new xUe(s, e, c, l) : new DUe(s, e, c, l);
    if (this.viewItems.splice(n, 0, d), this.viewItems.length > 1) {
      const h = { orthogonalStartSash: this.orthogonalStartSash, orthogonalEndSash: this.orthogonalEndSash }, f = this.orientation === 0 ? new Ts(this.sashContainer, { getHorizontalSashTop: (E) => this.getSashPosition(E), getHorizontalSashWidth: this.getSashOrthogonalSize }, Object.assign(Object.assign({}, h), {
        orientation: 1
        /* Orientation.HORIZONTAL */
      })) : new Ts(this.sashContainer, { getVerticalSashLeft: (E) => this.getSashPosition(E), getVerticalSashHeight: this.getSashOrthogonalSize }, Object.assign(Object.assign({}, h), {
        orientation: 0
        /* Orientation.VERTICAL */
      })), g = this.orientation === 0 ? (E) => ({ sash: f, start: E.startY, current: E.currentY, alt: E.altKey }) : (E) => ({ sash: f, start: E.startX, current: E.currentX, alt: E.altKey }), m = qe.map(f.onDidStart, g)(this.onSashStart, this), b = qe.map(f.onDidChange, g)(this.onSashChange, this), y = qe.map(f.onDidEnd, () => this.sashItems.findIndex((E) => E.sash === f))(this.onSashEnd, this), S = f.onDidReset(() => {
        const E = this.sashItems.findIndex((A) => A.sash === f), L = io(E, -1), k = io(E + 1, this.viewItems.length), N = this.findFirstSnapIndex(L), I = this.findFirstSnapIndex(k);
        typeof N == "number" && !this.viewItems[N].visible || typeof I == "number" && !this.viewItems[I].visible || this._onDidSashReset.fire(E);
      }), x = Ql(m, b, y, S, f), D = { sash: f, disposable: x };
      this.sashItems.splice(n - 1, 0, D);
    }
    s.appendChild(e.element);
    let u;
    typeof t != "number" && t.type === "split" && (u = [t.index]), r || this.relayout([n], u), this.state = rh.Idle, !r && typeof t != "number" && t.type === "distribute" && this.distributeViewSizes();
  }
  relayout(e, t) {
    const n = this.viewItems.reduce((r, s) => r + s.size, 0);
    this.resize(this.viewItems.length - 1, this.size - n, void 0, e, t), this.distributeEmptySpace(), this.layoutViews(), this.saveProportions();
  }
  resize(e, t, n = this.viewItems.map((d) => d.size), r, s, o = Number.NEGATIVE_INFINITY, a = Number.POSITIVE_INFINITY, l, c) {
    if (e < 0 || e >= this.viewItems.length)
      return 0;
    const d = io(e, -1), u = io(e + 1, this.viewItems.length);
    if (s)
      for (const D of s)
        Zk(d, D), Zk(u, D);
    if (r)
      for (const D of r)
        Px(d, D), Px(u, D);
    const h = d.map((D) => this.viewItems[D]), f = d.map((D) => n[D]), g = u.map((D) => this.viewItems[D]), p = u.map((D) => n[D]), m = d.reduce((D, E) => D + (this.viewItems[E].minimumSize - n[E]), 0), _ = d.reduce((D, E) => D + (this.viewItems[E].maximumSize - n[E]), 0), b = u.length === 0 ? Number.POSITIVE_INFINITY : u.reduce((D, E) => D + (n[E] - this.viewItems[E].minimumSize), 0), w = u.length === 0 ? Number.NEGATIVE_INFINITY : u.reduce((D, E) => D + (n[E] - this.viewItems[E].maximumSize), 0), y = Math.max(m, w, o), S = Math.min(b, _, a);
    let x = !1;
    if (l) {
      const D = this.viewItems[l.index], E = t >= l.limitDelta;
      x = E !== D.visible, D.setVisible(E, l.size);
    }
    if (!x && c) {
      const D = this.viewItems[c.index], E = t < c.limitDelta;
      x = E !== D.visible, D.setVisible(E, c.size);
    }
    if (x)
      return this.resize(e, t, n, r, s, o, a);
    t = qo(t, y, S);
    for (let D = 0, E = t; D < h.length; D++) {
      const L = h[D], k = qo(f[D] + E, L.minimumSize, L.maximumSize), N = k - f[D];
      E -= N, L.size = k;
    }
    for (let D = 0, E = t; D < g.length; D++) {
      const L = g[D], k = qo(p[D] - E, L.minimumSize, L.maximumSize), N = k - p[D];
      E += N, L.size = k;
    }
    return t;
  }
  distributeEmptySpace(e) {
    const t = this.viewItems.reduce((a, l) => a + l.size, 0);
    let n = this.size - t;
    const r = io(this.viewItems.length - 1, -1), s = r.filter(
      (a) => this.viewItems[a].priority === 1
      /* LayoutPriority.Low */
    ), o = r.filter(
      (a) => this.viewItems[a].priority === 2
      /* LayoutPriority.High */
    );
    for (const a of o)
      Zk(r, a);
    for (const a of s)
      Px(r, a);
    typeof e == "number" && Px(r, e);
    for (let a = 0; n !== 0 && a < r.length; a++) {
      const l = this.viewItems[r[a]], c = qo(l.size + n, l.minimumSize, l.maximumSize), d = c - l.size;
      n -= d, l.size = c;
    }
  }
  layoutViews() {
    this.contentSize = this.viewItems.reduce((t, n) => t + n.size, 0);
    let e = 0;
    for (const t of this.viewItems)
      t.layout(e, this.layoutContext), e += t.size;
    this.sashItems.forEach((t) => t.sash.layout()), this.updateSashEnablement(), this.updateScrollableElement();
  }
  updateScrollableElement() {
    this.orientation === 0 ? this.scrollableElement.setScrollDimensions({
      height: this.size,
      scrollHeight: this.contentSize
    }) : this.scrollableElement.setScrollDimensions({
      width: this.size,
      scrollWidth: this.contentSize
    });
  }
  updateSashEnablement() {
    let e = !1;
    const t = this.viewItems.map((l) => e = l.size - l.minimumSize > 0 || e);
    e = !1;
    const n = this.viewItems.map((l) => e = l.maximumSize - l.size > 0 || e), r = [...this.viewItems].reverse();
    e = !1;
    const s = r.map((l) => e = l.size - l.minimumSize > 0 || e).reverse();
    e = !1;
    const o = r.map((l) => e = l.maximumSize - l.size > 0 || e).reverse();
    let a = 0;
    for (let l = 0; l < this.sashItems.length; l++) {
      const { sash: c } = this.sashItems[l], d = this.viewItems[l];
      a += d.size;
      const u = !(t[l] && o[l + 1]), h = !(n[l] && s[l + 1]);
      if (u && h) {
        const f = io(l, -1), g = io(l + 1, this.viewItems.length), p = this.findFirstSnapIndex(f), m = this.findFirstSnapIndex(g), _ = typeof p == "number" && !this.viewItems[p].visible, b = typeof m == "number" && !this.viewItems[m].visible;
        _ && s[l] && (a > 0 || this.startSnappingEnabled) ? c.state = 1 : b && t[l] && (a < this.contentSize || this.endSnappingEnabled) ? c.state = 2 : c.state = 0;
      } else u && !h ? c.state = 1 : !u && h ? c.state = 2 : c.state = 3;
    }
  }
  getSashPosition(e) {
    let t = 0;
    for (let n = 0; n < this.sashItems.length; n++)
      if (t += this.viewItems[n].size, this.sashItems[n].sash === e)
        return t;
    return 0;
  }
  findFirstSnapIndex(e) {
    for (const t of e) {
      const n = this.viewItems[t];
      if (n.visible && n.snap)
        return t;
    }
    for (const t of e) {
      const n = this.viewItems[t];
      if (n.visible && n.maximumSize - n.minimumSize > 0)
        return;
      if (!n.visible && n.snap)
        return t;
    }
  }
  areViewsDistributed() {
    let e, t;
    for (const n of this.viewItems)
      if (e = e === void 0 ? n.size : Math.min(e, n.size), t = t === void 0 ? n.size : Math.max(t, n.size), t - e > 2)
        return !1;
    return !0;
  }
  dispose() {
    var e;
    (e = this.sashDragState) === null || e === void 0 || e.disposable.dispose(), An(this.viewItems), this.viewItems = [], this.sashItems.forEach((t) => t.disposable.dispose()), this.sashItems = [], super.dispose();
  }
}
class HS {
  constructor(e, t, n) {
    this.columns = e, this.getColumnSize = n, this.templateId = HS.TemplateId, this.renderedTemplates = /* @__PURE__ */ new Set();
    const r = new Map(t.map((s) => [s.templateId, s]));
    this.renderers = [];
    for (const s of e) {
      const o = r.get(s.templateId);
      if (!o)
        throw new Error(`Table cell renderer for template id ${s.templateId} not found.`);
      this.renderers.push(o);
    }
  }
  renderTemplate(e) {
    const t = Te(e, Re(".monaco-table-tr")), n = [], r = [];
    for (let o = 0; o < this.columns.length; o++) {
      const a = this.renderers[o], l = Te(t, Re(".monaco-table-td", { "data-col-index": o }));
      l.style.width = `${this.getColumnSize(o)}px`, n.push(l), r.push(a.renderTemplate(l));
    }
    const s = { container: e, cellContainers: n, cellTemplateData: r };
    return this.renderedTemplates.add(s), s;
  }
  renderElement(e, t, n, r) {
    for (let s = 0; s < this.columns.length; s++) {
      const a = this.columns[s].project(e);
      this.renderers[s].renderElement(a, t, n.cellTemplateData[s], r);
    }
  }
  disposeElement(e, t, n, r) {
    for (let s = 0; s < this.columns.length; s++) {
      const o = this.renderers[s];
      if (o.disposeElement) {
        const l = this.columns[s].project(e);
        o.disposeElement(l, t, n.cellTemplateData[s], r);
      }
    }
  }
  disposeTemplate(e) {
    for (let t = 0; t < this.columns.length; t++)
      this.renderers[t].disposeTemplate(e.cellTemplateData[t]);
    ls(e.container), this.renderedTemplates.delete(e);
  }
  layoutColumn(e, t) {
    for (const { cellContainers: n } of this.renderedTemplates)
      n[e].style.width = `${t}px`;
  }
}
HS.TemplateId = "row";
function EUe(i) {
  return {
    getHeight(e) {
      return i.getHeight(e);
    },
    getTemplateId() {
      return HS.TemplateId;
    }
  };
}
class LUe {
  get minimumSize() {
    var e;
    return (e = this.column.minimumWidth) !== null && e !== void 0 ? e : 120;
  }
  get maximumSize() {
    var e;
    return (e = this.column.maximumWidth) !== null && e !== void 0 ? e : Number.POSITIVE_INFINITY;
  }
  get onDidChange() {
    var e;
    return (e = this.column.onDidChangeWidthConstraints) !== null && e !== void 0 ? e : qe.None;
  }
  constructor(e, t) {
    this.column = e, this.index = t, this._onDidLayout = new pe(), this.onDidLayout = this._onDidLayout.event, this.element = Re(".monaco-table-th", { "data-col-index": t, title: e.tooltip }, e.label);
  }
  layout(e) {
    this._onDidLayout.fire([this.index, e]);
  }
}
class V4 {
  get onDidChangeFocus() {
    return this.list.onDidChangeFocus;
  }
  get onDidChangeSelection() {
    return this.list.onDidChangeSelection;
  }
  get onDidScroll() {
    return this.list.onDidScroll;
  }
  get onMouseDblClick() {
    return this.list.onMouseDblClick;
  }
  get onPointer() {
    return this.list.onPointer;
  }
  get onDidFocus() {
    return this.list.onDidFocus;
  }
  get scrollTop() {
    return this.list.scrollTop;
  }
  set scrollTop(e) {
    this.list.scrollTop = e;
  }
  get scrollHeight() {
    return this.list.scrollHeight;
  }
  get renderHeight() {
    return this.list.renderHeight;
  }
  get onDidDispose() {
    return this.list.onDidDispose;
  }
  constructor(e, t, n, r, s, o) {
    this.virtualDelegate = n, this.domId = `table_id_${++V4.InstanceCount}`, this.disposables = new Ne(), this.cachedWidth = 0, this.cachedHeight = 0, this.domNode = Te(t, Re(`.monaco-table.${this.domId}`));
    const a = r.map((d, u) => new LUe(d, u)), l = {
      size: a.reduce((d, u) => d + u.column.weight, 0),
      views: a.map((d) => ({ size: d.column.weight, view: d }))
    };
    this.splitview = this.disposables.add(new Ipe(this.domNode, {
      orientation: 1,
      scrollbarVisibility: 2,
      getSashOrthogonalSize: () => this.cachedHeight,
      descriptor: l
    })), this.splitview.el.style.height = `${n.headerRowHeight}px`, this.splitview.el.style.lineHeight = `${n.headerRowHeight}px`;
    const c = new HS(r, s, (d) => this.splitview.getViewSize(d));
    this.list = this.disposables.add(new pc(e, this.domNode, EUe(n), [c], o)), qe.any(...a.map((d) => d.onDidLayout))(([d, u]) => c.layoutColumn(d, u), null, this.disposables), this.splitview.onDidSashReset((d) => {
      const u = r.reduce((f, g) => f + g.weight, 0), h = r[d].weight / u * this.cachedWidth;
      this.splitview.resizeView(d, h);
    }, null, this.disposables), this.styleElement = yl(this.domNode), this.style(kze);
  }
  updateOptions(e) {
    this.list.updateOptions(e);
  }
  splice(e, t, n = []) {
    this.list.splice(e, t, n);
  }
  getHTMLElement() {
    return this.domNode;
  }
  style(e) {
    const t = [];
    t.push(`.monaco-table.${this.domId} > .monaco-split-view2 .monaco-sash.vertical::before {
			top: ${this.virtualDelegate.headerRowHeight + 1}px;
			height: calc(100% - ${this.virtualDelegate.headerRowHeight}px);
		}`), this.styleElement.textContent = t.join(`
`), this.list.style(e);
  }
  getSelectedElements() {
    return this.list.getSelectedElements();
  }
  getSelection() {
    return this.list.getSelection();
  }
  getFocus() {
    return this.list.getFocus();
  }
  dispose() {
    this.disposables.dispose();
  }
}
V4.InstanceCount = 0;
let wb = class extends hc {
  constructor(e) {
    super(), this._onChange = this._register(new pe()), this.onChange = this._onChange.event, this._onKeyDown = this._register(new pe()), this.onKeyDown = this._onKeyDown.event, this._opts = e, this._checked = this._opts.isChecked;
    const t = ["monaco-custom-toggle"];
    this._opts.icon && (this._icon = this._opts.icon, t.push(...ft.asClassNameArray(this._icon))), this._opts.actionClassName && t.push(...this._opts.actionClassName.split(" ")), this._checked && t.push("checked"), this.domNode = document.createElement("div"), this.domNode.title = this._opts.title, this.domNode.classList.add(...t), this._opts.notFocusable || (this.domNode.tabIndex = 0), this.domNode.setAttribute("role", "checkbox"), this.domNode.setAttribute("aria-checked", String(this._checked)), this.domNode.setAttribute("aria-label", this._opts.title), this.applyStyles(), this.onclick(this.domNode, (n) => {
      this.enabled && (this.checked = !this._checked, this._onChange.fire(!1), n.preventDefault());
    }), this._register(this.ignoreGesture(this.domNode)), this.onkeydown(this.domNode, (n) => {
      if (n.keyCode === 10 || n.keyCode === 3) {
        this.checked = !this._checked, this._onChange.fire(!0), n.preventDefault(), n.stopPropagation();
        return;
      }
      this._onKeyDown.fire(n);
    });
  }
  get enabled() {
    return this.domNode.getAttribute("aria-disabled") !== "true";
  }
  focus() {
    this.domNode.focus();
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    this._checked = e, this.domNode.setAttribute("aria-checked", String(this._checked)), this.domNode.classList.toggle("checked", this._checked), this.applyStyles();
  }
  width() {
    return 22;
  }
  applyStyles() {
    this.domNode && (this.domNode.style.borderColor = this._checked && this._opts.inputActiveOptionBorder || "", this.domNode.style.color = this._checked && this._opts.inputActiveOptionForeground || "inherit", this.domNode.style.backgroundColor = this._checked && this._opts.inputActiveOptionBackground || "");
  }
  enable() {
    this.domNode.setAttribute("aria-disabled", String(!1));
  }
  disable() {
    this.domNode.setAttribute("aria-disabled", String(!0));
  }
};
const IUe = C("caseDescription", "Match Case"), AUe = C("wordsDescription", "Match Whole Word"), kUe = C("regexDescription", "Use Regular Expression");
class Ape extends wb {
  constructor(e) {
    super({
      icon: We.caseSensitive,
      title: IUe + e.appendTitle,
      isChecked: e.isChecked,
      inputActiveOptionBorder: e.inputActiveOptionBorder,
      inputActiveOptionForeground: e.inputActiveOptionForeground,
      inputActiveOptionBackground: e.inputActiveOptionBackground
    });
  }
}
class kpe extends wb {
  constructor(e) {
    super({
      icon: We.wholeWord,
      title: AUe + e.appendTitle,
      isChecked: e.isChecked,
      inputActiveOptionBorder: e.inputActiveOptionBorder,
      inputActiveOptionForeground: e.inputActiveOptionForeground,
      inputActiveOptionBackground: e.inputActiveOptionBackground
    });
  }
}
class Tpe extends wb {
  constructor(e) {
    super({
      icon: We.regex,
      title: kUe + e.appendTitle,
      isChecked: e.isChecked,
      inputActiveOptionBorder: e.inputActiveOptionBorder,
      inputActiveOptionForeground: e.inputActiveOptionForeground,
      inputActiveOptionBackground: e.inputActiveOptionBackground
    });
  }
}
class TUe {
  constructor(e, t = 0, n = e.length, r = t - 1) {
    this.items = e, this.start = t, this.end = n, this.index = r;
  }
  current() {
    return this.index === this.start - 1 || this.index === this.end ? null : this.items[this.index];
  }
  next() {
    return this.index = Math.min(this.index + 1, this.end), this.current();
  }
  previous() {
    return this.index = Math.max(this.index - 1, this.start - 1), this.current();
  }
  first() {
    return this.index = this.start, this.current();
  }
  last() {
    return this.index = this.end - 1, this.current();
  }
}
class NUe {
  constructor(e = [], t = 10) {
    this._initialize(e), this._limit = t, this._onChange();
  }
  getHistory() {
    return this._elements;
  }
  add(e) {
    this._history.delete(e), this._history.add(e), this._onChange();
  }
  next() {
    return this._navigator.next();
  }
  previous() {
    return this._currentPosition() !== 0 ? this._navigator.previous() : null;
  }
  current() {
    return this._navigator.current();
  }
  first() {
    return this._navigator.first();
  }
  last() {
    return this._navigator.last();
  }
  isLast() {
    return this._currentPosition() >= this._elements.length - 1;
  }
  isNowhere() {
    return this._navigator.current() === null;
  }
  has(e) {
    return this._history.has(e);
  }
  _onChange() {
    this._reduceToLimit();
    const e = this._elements;
    this._navigator = new TUe(e, 0, e.length, e.length);
  }
  _reduceToLimit() {
    const e = this._elements;
    e.length > this._limit && this._initialize(e.slice(e.length - this._limit));
  }
  _currentPosition() {
    const e = this._navigator.current();
    return e ? this._elements.indexOf(e) : -1;
  }
  _initialize(e) {
    this._history = /* @__PURE__ */ new Set();
    for (const t of e)
      this._history.add(t);
  }
  get _elements() {
    const e = [];
    return this._history.forEach((t) => e.push(t)), e;
  }
}
const u2 = Re;
let PUe = class extends hc {
  constructor(e, t, n) {
    var r;
    super(), this.state = "idle", this.maxHeight = Number.POSITIVE_INFINITY, this._onDidChange = this._register(new pe()), this.onDidChange = this._onDidChange.event, this._onDidHeightChange = this._register(new pe()), this.onDidHeightChange = this._onDidHeightChange.event, this.contextViewProvider = t, this.options = n, this.message = null, this.placeholder = this.options.placeholder || "", this.tooltip = (r = this.options.tooltip) !== null && r !== void 0 ? r : this.placeholder || "", this.ariaLabel = this.options.ariaLabel || "", this.options.validationOptions && (this.validation = this.options.validationOptions.validation), this.element = Te(e, u2(".monaco-inputbox.idle"));
    const s = this.options.flexibleHeight ? "textarea" : "input", o = Te(this.element, u2(".ibwrapper"));
    if (this.input = Te(o, u2(s + ".input.empty")), this.input.setAttribute("autocorrect", "off"), this.input.setAttribute("autocapitalize", "off"), this.input.setAttribute("spellcheck", "false"), this.onfocus(this.input, () => this.element.classList.add("synthetic-focus")), this.onblur(this.input, () => this.element.classList.remove("synthetic-focus")), this.options.flexibleHeight) {
      this.maxHeight = typeof this.options.flexibleMaxHeight == "number" ? this.options.flexibleMaxHeight : Number.POSITIVE_INFINITY, this.mirror = Te(o, u2("div.mirror")), this.mirror.innerText = " ", this.scrollableElement = new jfe(this.element, {
        vertical: 1
        /* ScrollbarVisibility.Auto */
      }), this.options.flexibleWidth && (this.input.setAttribute("wrap", "off"), this.mirror.style.whiteSpace = "pre", this.mirror.style.wordWrap = "initial"), Te(e, this.scrollableElement.getDomNode()), this._register(this.scrollableElement), this._register(this.scrollableElement.onScroll((c) => this.input.scrollTop = c.scrollTop));
      const a = this._register(new Yt(document, "selectionchange")), l = qe.filter(a.event, () => {
        const c = document.getSelection();
        return c?.anchorNode === o;
      });
      this._register(l(this.updateScrollDimensions, this)), this._register(this.onDidHeightChange(this.updateScrollDimensions, this));
    } else
      this.input.type = this.options.type || "text", this.input.setAttribute("wrap", "off");
    this.ariaLabel && this.input.setAttribute("aria-label", this.ariaLabel), this.placeholder && !this.options.showPlaceholderOnFocus && this.setPlaceHolder(this.placeholder), this.tooltip && this.setTooltip(this.tooltip), this.oninput(this.input, () => this.onValueChange()), this.onblur(this.input, () => this.onBlur()), this.onfocus(this.input, () => this.onFocus()), this._register(this.ignoreGesture(this.input)), setTimeout(() => this.updateMirror(), 0), this.options.actions && (this.actionbar = this._register(new Dl(this.element)), this.actionbar.push(this.options.actions, { icon: !0, label: !1 })), this.applyStyles();
  }
  onBlur() {
    this._hideMessage(), this.options.showPlaceholderOnFocus && this.input.setAttribute("placeholder", "");
  }
  onFocus() {
    this._showMessage(), this.options.showPlaceholderOnFocus && this.input.setAttribute("placeholder", this.placeholder || "");
  }
  setPlaceHolder(e) {
    this.placeholder = e, this.input.setAttribute("placeholder", e);
  }
  setTooltip(e) {
    this.tooltip = e, this.input.title = e;
  }
  get inputElement() {
    return this.input;
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value !== e && (this.input.value = e, this.onValueChange());
  }
  get height() {
    return typeof this.cachedHeight == "number" ? this.cachedHeight : cm(this.element);
  }
  focus() {
    this.input.focus();
  }
  blur() {
    this.input.blur();
  }
  hasFocus() {
    return document.activeElement === this.input;
  }
  select(e = null) {
    this.input.select(), e && (this.input.setSelectionRange(e.start, e.end), e.end === this.input.value.length && (this.input.scrollLeft = this.input.scrollWidth));
  }
  isSelectionAtEnd() {
    return this.input.selectionEnd === this.input.value.length && this.input.selectionStart === this.input.selectionEnd;
  }
  enable() {
    this.input.removeAttribute("disabled");
  }
  disable() {
    this.blur(), this.input.disabled = !0, this._hideMessage();
  }
  set paddingRight(e) {
    this.input.style.width = `calc(100% - ${e}px)`, this.mirror && (this.mirror.style.paddingRight = e + "px");
  }
  updateScrollDimensions() {
    if (typeof this.cachedContentHeight != "number" || typeof this.cachedHeight != "number" || !this.scrollableElement)
      return;
    const e = this.cachedContentHeight, t = this.cachedHeight, n = this.input.scrollTop;
    this.scrollableElement.setScrollDimensions({ scrollHeight: e, height: t }), this.scrollableElement.setScrollPosition({ scrollTop: n });
  }
  showMessage(e, t) {
    if (this.state === "open" && Ra(this.message, e))
      return;
    this.message = e, this.element.classList.remove("idle"), this.element.classList.remove("info"), this.element.classList.remove("warning"), this.element.classList.remove("error"), this.element.classList.add(this.classForType(e.type));
    const n = this.stylesForType(this.message.type);
    this.element.style.border = `1px solid ${Dm(n.border, "transparent")}`, this.message.content && (this.hasFocus() || t) && this._showMessage();
  }
  hideMessage() {
    this.message = null, this.element.classList.remove("info"), this.element.classList.remove("warning"), this.element.classList.remove("error"), this.element.classList.add("idle"), this._hideMessage(), this.applyStyles();
  }
  validate() {
    let e = null;
    return this.validation && (e = this.validation(this.value), e ? (this.inputElement.setAttribute("aria-invalid", "true"), this.showMessage(e)) : this.inputElement.hasAttribute("aria-invalid") && (this.inputElement.removeAttribute("aria-invalid"), this.hideMessage())), e?.type;
  }
  stylesForType(e) {
    const t = this.options.inputBoxStyles;
    switch (e) {
      case 1:
        return { border: t.inputValidationInfoBorder, background: t.inputValidationInfoBackground, foreground: t.inputValidationInfoForeground };
      case 2:
        return { border: t.inputValidationWarningBorder, background: t.inputValidationWarningBackground, foreground: t.inputValidationWarningForeground };
      default:
        return { border: t.inputValidationErrorBorder, background: t.inputValidationErrorBackground, foreground: t.inputValidationErrorForeground };
    }
  }
  classForType(e) {
    switch (e) {
      case 1:
        return "info";
      case 2:
        return "warning";
      default:
        return "error";
    }
  }
  _showMessage() {
    if (!this.contextViewProvider || !this.message)
      return;
    let e;
    const t = () => e.style.width = Lo(this.element) + "px";
    this.contextViewProvider.showContextView({
      getAnchor: () => this.element,
      anchorAlignment: 1,
      render: (r) => {
        var s, o;
        if (!this.message)
          return null;
        e = Te(r, u2(".monaco-inputbox-container")), t();
        const a = {
          inline: !0,
          className: "monaco-inputbox-message"
        }, l = this.message.formatContent ? Gje(this.message.content, a) : Uje(this.message.content, a);
        l.classList.add(this.classForType(this.message.type));
        const c = this.stylesForType(this.message.type);
        return l.style.backgroundColor = (s = c.background) !== null && s !== void 0 ? s : "", l.style.color = (o = c.foreground) !== null && o !== void 0 ? o : "", l.style.border = c.border ? `1px solid ${c.border}` : "", Te(e, l), null;
      },
      onHide: () => {
        this.state = "closed";
      },
      layout: t
    });
    let n;
    this.message.type === 3 ? n = C("alertErrorMessage", "Error: {0}", this.message.content) : this.message.type === 2 ? n = C("alertWarningMessage", "Warning: {0}", this.message.content) : n = C("alertInfoMessage", "Info: {0}", this.message.content), Fs(n), this.state = "open";
  }
  _hideMessage() {
    this.contextViewProvider && (this.state === "open" && this.contextViewProvider.hideContextView(), this.state = "idle");
  }
  onValueChange() {
    this._onDidChange.fire(this.value), this.validate(), this.updateMirror(), this.input.classList.toggle("empty", !this.value), this.state === "open" && this.contextViewProvider && this.contextViewProvider.layout();
  }
  updateMirror() {
    if (!this.mirror)
      return;
    const e = this.value, n = e.charCodeAt(e.length - 1) === 10 ? " " : "";
    (e + n).replace(/\u000c/g, "") ? this.mirror.textContent = e + n : this.mirror.innerText = " ", this.layout();
  }
  applyStyles() {
    var e, t, n;
    const r = this.options.inputBoxStyles, s = (e = r.inputBackground) !== null && e !== void 0 ? e : "", o = (t = r.inputForeground) !== null && t !== void 0 ? t : "", a = (n = r.inputBorder) !== null && n !== void 0 ? n : "";
    this.element.style.backgroundColor = s, this.element.style.color = o, this.input.style.backgroundColor = "inherit", this.input.style.color = o, this.element.style.border = `1px solid ${Dm(a, "transparent")}`;
  }
  layout() {
    if (!this.mirror)
      return;
    const e = this.cachedContentHeight;
    this.cachedContentHeight = cm(this.mirror), e !== this.cachedContentHeight && (this.cachedHeight = Math.min(this.cachedContentHeight, this.maxHeight), this.input.style.height = this.cachedHeight + "px", this._onDidHeightChange.fire(this.cachedContentHeight));
  }
  insertAtCursor(e) {
    const t = this.inputElement, n = t.selectionStart, r = t.selectionEnd, s = t.value;
    n !== null && r !== null && (this.value = s.substr(0, n) + e + s.substr(r), t.setSelectionRange(n + 1, n + 1), this.layout());
  }
  dispose() {
    var e;
    this._hideMessage(), this.message = null, (e = this.actionbar) === null || e === void 0 || e.dispose(), super.dispose();
  }
};
class Npe extends PUe {
  constructor(e, t, n) {
    const r = C({ key: "history.inputbox.hint", comment: ["Text will be prefixed with ⇅ plus a single space, then used as a hint where input field keeps history"] }, "for history"), s = ` or ⇅ ${r}`, o = ` (⇅ ${r})`;
    super(e, t, n), this._onDidFocus = this._register(new pe()), this.onDidFocus = this._onDidFocus.event, this._onDidBlur = this._register(new pe()), this.onDidBlur = this._onDidBlur.event, this.history = new NUe(n.history, 100);
    const a = () => {
      if (n.showHistoryHint && n.showHistoryHint() && !this.placeholder.endsWith(s) && !this.placeholder.endsWith(o) && this.history.getHistory().length) {
        const l = this.placeholder.endsWith(")") ? s : o, c = this.placeholder + l;
        n.showPlaceholderOnFocus && document.activeElement !== this.input ? this.placeholder = c : this.setPlaceHolder(c);
      }
    };
    this.observer = new MutationObserver((l, c) => {
      l.forEach((d) => {
        d.target.textContent || a();
      });
    }), this.observer.observe(this.input, { attributeFilter: ["class"] }), this.onfocus(this.input, () => a()), this.onblur(this.input, () => {
      const l = (c) => {
        if (this.placeholder.endsWith(c)) {
          const d = this.placeholder.slice(0, this.placeholder.length - c.length);
          return n.showPlaceholderOnFocus ? this.placeholder = d : this.setPlaceHolder(d), !0;
        } else
          return !1;
      };
      l(o) || l(s);
    });
  }
  dispose() {
    super.dispose(), this.observer && (this.observer.disconnect(), this.observer = void 0);
  }
  addToHistory(e) {
    this.value && (e || this.value !== this.getCurrentValue()) && this.history.add(this.value);
  }
  isAtLastInHistory() {
    return this.history.isLast();
  }
  isNowhereInHistory() {
    return this.history.isNowhere();
  }
  showNextValue() {
    this.history.has(this.value) || this.addToHistory();
    let e = this.getNextValue();
    e && (e = e === this.value ? this.getNextValue() : e), this.value = e ?? "", Vg(this.value ? this.value : C("clearedInput", "Cleared Input"));
  }
  showPreviousValue() {
    this.history.has(this.value) || this.addToHistory();
    let e = this.getPreviousValue();
    e && (e = e === this.value ? this.getPreviousValue() : e), e && (this.value = e, Vg(this.value));
  }
  onBlur() {
    super.onBlur(), this._onDidBlur.fire();
  }
  onFocus() {
    super.onFocus(), this._onDidFocus.fire();
  }
  getCurrentValue() {
    let e = this.history.current();
    return e || (e = this.history.last(), this.history.next()), e;
  }
  getPreviousValue() {
    return this.history.previous() || this.history.first();
  }
  getNextValue() {
    return this.history.next();
  }
}
const OUe = C("defaultLabel", "input");
class Ppe extends hc {
  constructor(e, t, n) {
    super(), this.fixFocusOnOptionClickEnabled = !0, this.imeSessionInProgress = !1, this.additionalTogglesDisposables = this._register(new ds()), this.additionalToggles = [], this._onDidOptionChange = this._register(new pe()), this.onDidOptionChange = this._onDidOptionChange.event, this._onKeyDown = this._register(new pe()), this.onKeyDown = this._onKeyDown.event, this._onMouseDown = this._register(new pe()), this.onMouseDown = this._onMouseDown.event, this._onInput = this._register(new pe()), this._onKeyUp = this._register(new pe()), this._onCaseSensitiveKeyDown = this._register(new pe()), this.onCaseSensitiveKeyDown = this._onCaseSensitiveKeyDown.event, this._onRegexKeyDown = this._register(new pe()), this.onRegexKeyDown = this._onRegexKeyDown.event, this._lastHighlightFindOptions = 0, this.placeholder = n.placeholder || "", this.validation = n.validation, this.label = n.label || OUe, this.showCommonFindToggles = !!n.showCommonFindToggles;
    const r = n.appendCaseSensitiveLabel || "", s = n.appendWholeWordsLabel || "", o = n.appendRegexLabel || "", a = n.history || [], l = !!n.flexibleHeight, c = !!n.flexibleWidth, d = n.flexibleMaxHeight;
    if (this.domNode = document.createElement("div"), this.domNode.classList.add("monaco-findInput"), this.inputBox = this._register(new Npe(this.domNode, t, {
      placeholder: this.placeholder || "",
      ariaLabel: this.label || "",
      validationOptions: {
        validation: this.validation
      },
      history: a,
      showHistoryHint: n.showHistoryHint,
      flexibleHeight: l,
      flexibleWidth: c,
      flexibleMaxHeight: d,
      inputBoxStyles: n.inputBoxStyles
    })), this.showCommonFindToggles) {
      this.regex = this._register(new Tpe(Object.assign({ appendTitle: o, isChecked: !1 }, n.toggleStyles))), this._register(this.regex.onChange((h) => {
        this._onDidOptionChange.fire(h), !h && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      })), this._register(this.regex.onKeyDown((h) => {
        this._onRegexKeyDown.fire(h);
      })), this.wholeWords = this._register(new kpe(Object.assign({ appendTitle: s, isChecked: !1 }, n.toggleStyles))), this._register(this.wholeWords.onChange((h) => {
        this._onDidOptionChange.fire(h), !h && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      })), this.caseSensitive = this._register(new Ape(Object.assign({ appendTitle: r, isChecked: !1 }, n.toggleStyles))), this._register(this.caseSensitive.onChange((h) => {
        this._onDidOptionChange.fire(h), !h && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      })), this._register(this.caseSensitive.onKeyDown((h) => {
        this._onCaseSensitiveKeyDown.fire(h);
      }));
      const u = [this.caseSensitive.domNode, this.wholeWords.domNode, this.regex.domNode];
      this.onkeydown(this.domNode, (h) => {
        if (h.equals(
          15
          /* KeyCode.LeftArrow */
        ) || h.equals(
          17
          /* KeyCode.RightArrow */
        ) || h.equals(
          9
          /* KeyCode.Escape */
        )) {
          const f = u.indexOf(document.activeElement);
          if (f >= 0) {
            let g = -1;
            h.equals(
              17
              /* KeyCode.RightArrow */
            ) ? g = (f + 1) % u.length : h.equals(
              15
              /* KeyCode.LeftArrow */
            ) && (f === 0 ? g = u.length - 1 : g = f - 1), h.equals(
              9
              /* KeyCode.Escape */
            ) ? (u[f].blur(), this.inputBox.focus()) : g >= 0 && u[g].focus(), Tt.stop(h, !0);
          }
        }
      });
    }
    this.controls = document.createElement("div"), this.controls.className = "controls", this.controls.style.display = this.showCommonFindToggles ? "" : "none", this.caseSensitive && this.controls.append(this.caseSensitive.domNode), this.wholeWords && this.controls.appendChild(this.wholeWords.domNode), this.regex && this.controls.appendChild(this.regex.domNode), this.setAdditionalToggles(n?.additionalToggles), this.controls && this.domNode.appendChild(this.controls), e?.appendChild(this.domNode), this._register(Ie(this.inputBox.inputElement, "compositionstart", (u) => {
      this.imeSessionInProgress = !0;
    })), this._register(Ie(this.inputBox.inputElement, "compositionend", (u) => {
      this.imeSessionInProgress = !1, this._onInput.fire();
    })), this.onkeydown(this.inputBox.inputElement, (u) => this._onKeyDown.fire(u)), this.onkeyup(this.inputBox.inputElement, (u) => this._onKeyUp.fire(u)), this.oninput(this.inputBox.inputElement, (u) => this._onInput.fire()), this.onmousedown(this.inputBox.inputElement, (u) => this._onMouseDown.fire(u));
  }
  get onDidChange() {
    return this.inputBox.onDidChange;
  }
  layout(e) {
    this.inputBox.layout(), this.updateInputBoxPadding(e.collapsedFindWidget);
  }
  enable() {
    var e, t, n;
    this.domNode.classList.remove("disabled"), this.inputBox.enable(), (e = this.regex) === null || e === void 0 || e.enable(), (t = this.wholeWords) === null || t === void 0 || t.enable(), (n = this.caseSensitive) === null || n === void 0 || n.enable();
    for (const r of this.additionalToggles)
      r.enable();
  }
  disable() {
    var e, t, n;
    this.domNode.classList.add("disabled"), this.inputBox.disable(), (e = this.regex) === null || e === void 0 || e.disable(), (t = this.wholeWords) === null || t === void 0 || t.disable(), (n = this.caseSensitive) === null || n === void 0 || n.disable();
    for (const r of this.additionalToggles)
      r.disable();
  }
  setFocusInputOnOptionClick(e) {
    this.fixFocusOnOptionClickEnabled = e;
  }
  setEnabled(e) {
    e ? this.enable() : this.disable();
  }
  setAdditionalToggles(e) {
    for (const t of this.additionalToggles)
      t.domNode.remove();
    this.additionalToggles = [], this.additionalTogglesDisposables.value = new Ne();
    for (const t of e ?? [])
      this.additionalTogglesDisposables.value.add(t), this.controls.appendChild(t.domNode), this.additionalTogglesDisposables.value.add(t.onChange((n) => {
        this._onDidOptionChange.fire(n), !n && this.fixFocusOnOptionClickEnabled && this.inputBox.focus();
      })), this.additionalToggles.push(t);
    this.additionalToggles.length > 0 && (this.controls.style.display = ""), this.updateInputBoxPadding();
  }
  updateInputBoxPadding(e = !1) {
    var t, n, r, s, o, a;
    e ? this.inputBox.paddingRight = 0 : this.inputBox.paddingRight = ((n = (t = this.caseSensitive) === null || t === void 0 ? void 0 : t.width()) !== null && n !== void 0 ? n : 0) + ((s = (r = this.wholeWords) === null || r === void 0 ? void 0 : r.width()) !== null && s !== void 0 ? s : 0) + ((a = (o = this.regex) === null || o === void 0 ? void 0 : o.width()) !== null && a !== void 0 ? a : 0) + this.additionalToggles.reduce((l, c) => l + c.width(), 0);
  }
  getValue() {
    return this.inputBox.value;
  }
  setValue(e) {
    this.inputBox.value !== e && (this.inputBox.value = e);
  }
  select() {
    this.inputBox.select();
  }
  focus() {
    this.inputBox.focus();
  }
  getCaseSensitive() {
    var e, t;
    return (t = (e = this.caseSensitive) === null || e === void 0 ? void 0 : e.checked) !== null && t !== void 0 ? t : !1;
  }
  setCaseSensitive(e) {
    this.caseSensitive && (this.caseSensitive.checked = e);
  }
  getWholeWords() {
    var e, t;
    return (t = (e = this.wholeWords) === null || e === void 0 ? void 0 : e.checked) !== null && t !== void 0 ? t : !1;
  }
  setWholeWords(e) {
    this.wholeWords && (this.wholeWords.checked = e);
  }
  getRegex() {
    var e, t;
    return (t = (e = this.regex) === null || e === void 0 ? void 0 : e.checked) !== null && t !== void 0 ? t : !1;
  }
  setRegex(e) {
    this.regex && (this.regex.checked = e, this.validate());
  }
  focusOnCaseSensitive() {
    var e;
    (e = this.caseSensitive) === null || e === void 0 || e.focus();
  }
  highlightFindOptions() {
    this.domNode.classList.remove("highlight-" + this._lastHighlightFindOptions), this._lastHighlightFindOptions = 1 - this._lastHighlightFindOptions, this.domNode.classList.add("highlight-" + this._lastHighlightFindOptions);
  }
  validate() {
    this.inputBox.validate();
  }
  showMessage(e) {
    this.inputBox.showMessage(e);
  }
  clearMessage() {
    this.inputBox.hideMessage();
  }
}
var kd;
(function(i) {
  i[i.Expanded = 0] = "Expanded", i[i.Collapsed = 1] = "Collapsed", i[i.PreserveOrExpanded = 2] = "PreserveOrExpanded", i[i.PreserveOrCollapsed = 3] = "PreserveOrCollapsed";
})(kd || (kd = {}));
var mm;
(function(i) {
  i[i.Unknown = 0] = "Unknown", i[i.Twistie = 1] = "Twistie", i[i.Element = 2] = "Element", i[i.Filter = 3] = "Filter";
})(mm || (mm = {}));
class Ea extends Error {
  constructor(e, t) {
    super(`TreeError [${e}] ${t}`);
  }
}
class uU {
  constructor(e) {
    this.fn = e, this._map = /* @__PURE__ */ new WeakMap();
  }
  map(e) {
    let t = this._map.get(e);
    return t || (t = this.fn(e), this._map.set(e, t)), t;
  }
}
function hU(i) {
  return typeof i == "object" && "visibility" in i && "data" in i;
}
function cw(i) {
  switch (i) {
    case !0:
      return 1;
    case !1:
      return 0;
    default:
      return i;
  }
}
function lT(i) {
  return typeof i.collapsible == "boolean";
}
class MUe {
  constructor(e, t, n, r = {}) {
    this.user = e, this.list = t, this.rootRef = [], this.eventBufferer = new Pj(), this._onDidChangeCollapseState = new pe(), this.onDidChangeCollapseState = this.eventBufferer.wrapEvent(this._onDidChangeCollapseState.event), this._onDidChangeRenderNodeCount = new pe(), this.onDidChangeRenderNodeCount = this.eventBufferer.wrapEvent(this._onDidChangeRenderNodeCount.event), this._onDidSplice = new pe(), this.onDidSplice = this._onDidSplice.event, this.refilterDelayer = new ac(Yhe), this.collapseByDefault = typeof r.collapseByDefault > "u" ? !1 : r.collapseByDefault, this.filter = r.filter, this.autoExpandSingleChildren = typeof r.autoExpandSingleChildren > "u" ? !1 : r.autoExpandSingleChildren, this.root = {
      parent: void 0,
      element: n,
      children: [],
      depth: 0,
      visibleChildrenCount: 0,
      visibleChildIndex: -1,
      collapsible: !1,
      collapsed: !1,
      renderNodeCount: 0,
      visibility: 1,
      visible: !0,
      filterData: void 0
    };
  }
  splice(e, t, n = Wt.empty(), r = {}) {
    if (e.length === 0)
      throw new Ea(this.user, "Invalid tree location");
    r.diffIdentityProvider ? this.spliceSmart(r.diffIdentityProvider, e, t, n, r) : this.spliceSimple(e, t, n, r);
  }
  spliceSmart(e, t, n, r, s, o) {
    var a;
    r === void 0 && (r = Wt.empty()), o === void 0 && (o = (a = s.diffDepth) !== null && a !== void 0 ? a : 0);
    const { parentNode: l } = this.getParentNodeWithListIndex(t);
    if (!l.lastDiffIds)
      return this.spliceSimple(t, n, r, s);
    const c = [...r], d = t[t.length - 1], u = new Wd({ getElements: () => l.lastDiffIds }, {
      getElements: () => [
        ...l.children.slice(0, d),
        ...c,
        ...l.children.slice(d + n)
      ].map((m) => e.getId(m.element).toString())
    }).ComputeDiff(!1);
    if (u.quitEarly)
      return l.lastDiffIds = void 0, this.spliceSimple(t, n, c, s);
    const h = t.slice(0, -1), f = (m, _, b) => {
      if (o > 0)
        for (let w = 0; w < b; w++)
          m--, _--, this.spliceSmart(e, [...h, m, 0], Number.MAX_SAFE_INTEGER, c[_].children, s, o - 1);
    };
    let g = Math.min(l.children.length, d + n), p = c.length;
    for (const m of u.changes.sort((_, b) => b.originalStart - _.originalStart))
      f(g, p, g - (m.originalStart + m.originalLength)), g = m.originalStart, p = m.modifiedStart - d, this.spliceSimple([...h, g], m.originalLength, Wt.slice(c, p, p + m.modifiedLength), s);
    f(g, p, g);
  }
  spliceSimple(e, t, n = Wt.empty(), { onDidCreateNode: r, onDidDeleteNode: s, diffIdentityProvider: o }) {
    const { parentNode: a, listIndex: l, revealed: c, visible: d } = this.getParentNodeWithListIndex(e), u = [], h = Wt.map(n, (D) => this.createTreeNode(D, a, a.visible ? 1 : 0, c, u, r)), f = e[e.length - 1], g = a.children.length > 0;
    let p = 0;
    for (let D = f; D >= 0 && D < a.children.length; D--) {
      const E = a.children[D];
      if (E.visible) {
        p = E.visibleChildIndex;
        break;
      }
    }
    const m = [];
    let _ = 0, b = 0;
    for (const D of h)
      m.push(D), b += D.renderNodeCount, D.visible && (D.visibleChildIndex = p + _++);
    const w = zY(a.children, f, t, m);
    o ? a.lastDiffIds ? zY(a.lastDiffIds, f, t, m.map((D) => o.getId(D.element).toString())) : a.lastDiffIds = a.children.map((D) => o.getId(D.element).toString()) : a.lastDiffIds = void 0;
    let y = 0;
    for (const D of w)
      D.visible && y++;
    if (y !== 0)
      for (let D = f + m.length; D < a.children.length; D++) {
        const E = a.children[D];
        E.visible && (E.visibleChildIndex -= y);
      }
    if (a.visibleChildrenCount += _ - y, c && d) {
      const D = w.reduce((E, L) => E + (L.visible ? L.renderNodeCount : 0), 0);
      this._updateAncestorsRenderNodeCount(a, b - D), this.list.splice(l, D, u);
    }
    if (w.length > 0 && s) {
      const D = (E) => {
        s(E), E.children.forEach(D);
      };
      w.forEach(D);
    }
    this._onDidSplice.fire({ insertedNodes: m, deletedNodes: w });
    const S = a.children.length > 0;
    g !== S && this.setCollapsible(e.slice(0, -1), S);
    let x = a;
    for (; x; ) {
      if (x.visibility === 2) {
        this.refilterDelayer.trigger(() => this.refilter());
        break;
      }
      x = x.parent;
    }
  }
  rerender(e) {
    if (e.length === 0)
      throw new Ea(this.user, "Invalid tree location");
    const { node: t, listIndex: n, revealed: r } = this.getTreeNodeWithListIndex(e);
    t.visible && r && this.list.splice(n, 1, [t]);
  }
  has(e) {
    return this.hasTreeNode(e);
  }
  getListIndex(e) {
    const { listIndex: t, visible: n, revealed: r } = this.getTreeNodeWithListIndex(e);
    return n && r ? t : -1;
  }
  getListRenderCount(e) {
    return this.getTreeNode(e).renderNodeCount;
  }
  isCollapsible(e) {
    return this.getTreeNode(e).collapsible;
  }
  setCollapsible(e, t) {
    const n = this.getTreeNode(e);
    typeof t > "u" && (t = !n.collapsible);
    const r = { collapsible: t };
    return this.eventBufferer.bufferEvents(() => this._setCollapseState(e, r));
  }
  isCollapsed(e) {
    return this.getTreeNode(e).collapsed;
  }
  setCollapsed(e, t, n) {
    const r = this.getTreeNode(e);
    typeof t > "u" && (t = !r.collapsed);
    const s = { collapsed: t, recursive: n || !1 };
    return this.eventBufferer.bufferEvents(() => this._setCollapseState(e, s));
  }
  _setCollapseState(e, t) {
    const { node: n, listIndex: r, revealed: s } = this.getTreeNodeWithListIndex(e), o = this._setListNodeCollapseState(n, r, s, t);
    if (n !== this.root && this.autoExpandSingleChildren && o && !lT(t) && n.collapsible && !n.collapsed && !t.recursive) {
      let a = -1;
      for (let l = 0; l < n.children.length; l++)
        if (n.children[l].visible)
          if (a > -1) {
            a = -1;
            break;
          } else
            a = l;
      a > -1 && this._setCollapseState([...e, a], t);
    }
    return o;
  }
  _setListNodeCollapseState(e, t, n, r) {
    const s = this._setNodeCollapseState(e, r, !1);
    if (!n || !e.visible || !s)
      return s;
    const o = e.renderNodeCount, a = this.updateNodeAfterCollapseChange(e), l = o - (t === -1 ? 0 : 1);
    return this.list.splice(t + 1, l, a.slice(1)), s;
  }
  _setNodeCollapseState(e, t, n) {
    let r;
    if (e === this.root ? r = !1 : (lT(t) ? (r = e.collapsible !== t.collapsible, e.collapsible = t.collapsible) : e.collapsible ? (r = e.collapsed !== t.collapsed, e.collapsed = t.collapsed) : r = !1, r && this._onDidChangeCollapseState.fire({ node: e, deep: n })), !lT(t) && t.recursive)
      for (const s of e.children)
        r = this._setNodeCollapseState(s, t, !0) || r;
    return r;
  }
  expandTo(e) {
    this.eventBufferer.bufferEvents(() => {
      let t = this.getTreeNode(e);
      for (; t.parent; )
        t = t.parent, e = e.slice(0, e.length - 1), t.collapsed && this._setCollapseState(e, { collapsed: !1, recursive: !1 });
    });
  }
  refilter() {
    const e = this.root.renderNodeCount, t = this.updateNodeAfterFilterChange(this.root);
    this.list.splice(0, e, t), this.refilterDelayer.cancel();
  }
  createTreeNode(e, t, n, r, s, o) {
    const a = {
      parent: t,
      element: e.element,
      children: [],
      depth: t.depth + 1,
      visibleChildrenCount: 0,
      visibleChildIndex: -1,
      collapsible: typeof e.collapsible == "boolean" ? e.collapsible : typeof e.collapsed < "u",
      collapsed: typeof e.collapsed > "u" ? this.collapseByDefault : e.collapsed,
      renderNodeCount: 1,
      visibility: 1,
      visible: !0,
      filterData: void 0
    }, l = this._filterNode(a, n);
    a.visibility = l, r && s.push(a);
    const c = e.children || Wt.empty(), d = r && l !== 0 && !a.collapsed;
    let u = 0, h = 1;
    for (const f of c) {
      const g = this.createTreeNode(f, a, l, d, s, o);
      a.children.push(g), h += g.renderNodeCount, g.visible && (g.visibleChildIndex = u++);
    }
    return a.collapsible = a.collapsible || a.children.length > 0, a.visibleChildrenCount = u, a.visible = l === 2 ? u > 0 : l === 1, a.visible ? a.collapsed || (a.renderNodeCount = h) : (a.renderNodeCount = 0, r && s.pop()), o?.(a), a;
  }
  updateNodeAfterCollapseChange(e) {
    const t = e.renderNodeCount, n = [];
    return this._updateNodeAfterCollapseChange(e, n), this._updateAncestorsRenderNodeCount(e.parent, n.length - t), n;
  }
  _updateNodeAfterCollapseChange(e, t) {
    if (e.visible === !1)
      return 0;
    if (t.push(e), e.renderNodeCount = 1, !e.collapsed)
      for (const n of e.children)
        e.renderNodeCount += this._updateNodeAfterCollapseChange(n, t);
    return this._onDidChangeRenderNodeCount.fire(e), e.renderNodeCount;
  }
  updateNodeAfterFilterChange(e) {
    const t = e.renderNodeCount, n = [];
    return this._updateNodeAfterFilterChange(e, e.visible ? 1 : 0, n), this._updateAncestorsRenderNodeCount(e.parent, n.length - t), n;
  }
  _updateNodeAfterFilterChange(e, t, n, r = !0) {
    let s;
    if (e !== this.root) {
      if (s = this._filterNode(e, t), s === 0)
        return e.visible = !1, e.renderNodeCount = 0, !1;
      r && n.push(e);
    }
    const o = n.length;
    e.renderNodeCount = e === this.root ? 0 : 1;
    let a = !1;
    if (!e.collapsed || s !== 0) {
      let l = 0;
      for (const c of e.children)
        a = this._updateNodeAfterFilterChange(c, s, n, r && !e.collapsed) || a, c.visible && (c.visibleChildIndex = l++);
      e.visibleChildrenCount = l;
    } else
      e.visibleChildrenCount = 0;
    return e !== this.root && (e.visible = s === 2 ? a : s === 1, e.visibility = s), e.visible ? e.collapsed || (e.renderNodeCount += n.length - o) : (e.renderNodeCount = 0, r && n.pop()), this._onDidChangeRenderNodeCount.fire(e), e.visible;
  }
  _updateAncestorsRenderNodeCount(e, t) {
    if (t !== 0)
      for (; e; )
        e.renderNodeCount += t, this._onDidChangeRenderNodeCount.fire(e), e = e.parent;
  }
  _filterNode(e, t) {
    const n = this.filter ? this.filter.filter(e.element, t) : 1;
    return typeof n == "boolean" ? (e.filterData = void 0, n ? 1 : 0) : hU(n) ? (e.filterData = n.data, cw(n.visibility)) : (e.filterData = void 0, cw(n));
  }
  // cheap
  hasTreeNode(e, t = this.root) {
    if (!e || e.length === 0)
      return !0;
    const [n, ...r] = e;
    return n < 0 || n > t.children.length ? !1 : this.hasTreeNode(r, t.children[n]);
  }
  // cheap
  getTreeNode(e, t = this.root) {
    if (!e || e.length === 0)
      return t;
    const [n, ...r] = e;
    if (n < 0 || n > t.children.length)
      throw new Ea(this.user, "Invalid tree location");
    return this.getTreeNode(r, t.children[n]);
  }
  // expensive
  getTreeNodeWithListIndex(e) {
    if (e.length === 0)
      return { node: this.root, listIndex: -1, revealed: !0, visible: !1 };
    const { parentNode: t, listIndex: n, revealed: r, visible: s } = this.getParentNodeWithListIndex(e), o = e[e.length - 1];
    if (o < 0 || o > t.children.length)
      throw new Ea(this.user, "Invalid tree location");
    const a = t.children[o];
    return { node: a, listIndex: n, revealed: r, visible: s && a.visible };
  }
  getParentNodeWithListIndex(e, t = this.root, n = 0, r = !0, s = !0) {
    const [o, ...a] = e;
    if (o < 0 || o > t.children.length)
      throw new Ea(this.user, "Invalid tree location");
    for (let l = 0; l < o; l++)
      n += t.children[l].renderNodeCount;
    return r = r && !t.collapsed, s = s && t.visible, a.length === 0 ? { parentNode: t, listIndex: n, revealed: r, visible: s } : this.getParentNodeWithListIndex(a, t.children[o], n + 1, r, s);
  }
  getNode(e = []) {
    return this.getTreeNode(e);
  }
  // TODO@joao perf!
  getNodeLocation(e) {
    const t = [];
    let n = e;
    for (; n.parent; )
      t.push(n.parent.children.indexOf(n)), n = n.parent;
    return t.reverse();
  }
  getParentNodeLocation(e) {
    if (e.length !== 0)
      return e.length === 1 ? [] : h6e(e)[0];
  }
  getFirstElementChild(e) {
    const t = this.getTreeNode(e);
    if (t.children.length !== 0)
      return t.children[0].element;
  }
}
class RUe extends VS {
  constructor(e) {
    super(e.elements.map((t) => t.element)), this.data = e;
  }
}
function cT(i) {
  return i instanceof VS ? new RUe(i) : i;
}
class FUe {
  constructor(e, t) {
    this.modelProvider = e, this.dnd = t, this.autoExpandDisposable = we.None, this.disposables = new Ne();
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e.element);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel)
      return this.dnd.getDragLabel(e.map((n) => n.element), t);
  }
  onDragStart(e, t) {
    var n, r;
    (r = (n = this.dnd).onDragStart) === null || r === void 0 || r.call(n, cT(e), t);
  }
  onDragOver(e, t, n, r, s = !0) {
    const o = this.dnd.onDragOver(cT(e), t && t.element, n, r), a = this.autoExpandNode !== t;
    if (a && (this.autoExpandDisposable.dispose(), this.autoExpandNode = t), typeof t > "u")
      return o;
    if (a && typeof o != "boolean" && o.autoExpand && (this.autoExpandDisposable = Rg(() => {
      const h = this.modelProvider(), f = h.getNodeLocation(t);
      h.isCollapsed(f) && h.setCollapsed(f, !1), this.autoExpandNode = void 0;
    }, 500, this.disposables)), typeof o == "boolean" || !o.accept || typeof o.bubble > "u" || o.feedback) {
      if (!s) {
        const h = typeof o == "boolean" ? o : o.accept, f = typeof o == "boolean" ? void 0 : o.effect;
        return { accept: h, effect: f, feedback: [n] };
      }
      return o;
    }
    if (o.bubble === 1) {
      const h = this.modelProvider(), f = h.getNodeLocation(t), g = h.getParentNodeLocation(f), p = h.getNode(g), m = g && h.getListIndex(g);
      return this.onDragOver(e, p, m, r, !1);
    }
    const l = this.modelProvider(), c = l.getNodeLocation(t), d = l.getListIndex(c), u = l.getListRenderCount(c);
    return Object.assign(Object.assign({}, o), { feedback: io(d, d + u) });
  }
  drop(e, t, n, r) {
    this.autoExpandDisposable.dispose(), this.autoExpandNode = void 0, this.dnd.drop(cT(e), t && t.element, n, r);
  }
  onDragEnd(e) {
    var t, n;
    (n = (t = this.dnd).onDragEnd) === null || n === void 0 || n.call(t, e);
  }
  dispose() {
    this.disposables.dispose(), this.dnd.dispose();
  }
}
function BUe(i, e) {
  return e && Object.assign(Object.assign({}, e), { identityProvider: e.identityProvider && {
    getId(t) {
      return e.identityProvider.getId(t.element);
    }
  }, dnd: e.dnd && new FUe(i, e.dnd), multipleSelectionController: e.multipleSelectionController && {
    isSelectionSingleChangeEvent(t) {
      return e.multipleSelectionController.isSelectionSingleChangeEvent(Object.assign(Object.assign({}, t), { element: t.element }));
    },
    isSelectionRangeChangeEvent(t) {
      return e.multipleSelectionController.isSelectionRangeChangeEvent(Object.assign(Object.assign({}, t), { element: t.element }));
    }
  }, accessibilityProvider: e.accessibilityProvider && Object.assign(Object.assign({}, e.accessibilityProvider), {
    getSetSize(t) {
      const n = i(), r = n.getNodeLocation(t), s = n.getParentNodeLocation(r);
      return n.getNode(s).visibleChildrenCount;
    },
    getPosInSet(t) {
      return t.visibleChildIndex + 1;
    },
    isChecked: e.accessibilityProvider && e.accessibilityProvider.isChecked ? (t) => e.accessibilityProvider.isChecked(t.element) : void 0,
    getRole: e.accessibilityProvider && e.accessibilityProvider.getRole ? (t) => e.accessibilityProvider.getRole(t.element) : () => "treeitem",
    getAriaLabel(t) {
      return e.accessibilityProvider.getAriaLabel(t.element);
    },
    getWidgetAriaLabel() {
      return e.accessibilityProvider.getWidgetAriaLabel();
    },
    getWidgetRole: e.accessibilityProvider && e.accessibilityProvider.getWidgetRole ? () => e.accessibilityProvider.getWidgetRole() : () => "tree",
    getAriaLevel: e.accessibilityProvider && e.accessibilityProvider.getAriaLevel ? (t) => e.accessibilityProvider.getAriaLevel(t.element) : (t) => t.depth,
    getActiveDescendantId: e.accessibilityProvider.getActiveDescendantId && ((t) => e.accessibilityProvider.getActiveDescendantId(t.element))
  }), keyboardNavigationLabelProvider: e.keyboardNavigationLabelProvider && Object.assign(Object.assign({}, e.keyboardNavigationLabelProvider), { getKeyboardNavigationLabel(t) {
    return e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t.element);
  } }) });
}
class fU {
  constructor(e) {
    this.delegate = e;
  }
  getHeight(e) {
    return this.delegate.getHeight(e.element);
  }
  getTemplateId(e) {
    return this.delegate.getTemplateId(e.element);
  }
  hasDynamicHeight(e) {
    return !!this.delegate.hasDynamicHeight && this.delegate.hasDynamicHeight(e.element);
  }
  setDynamicHeight(e, t) {
    var n, r;
    (r = (n = this.delegate).setDynamicHeight) === null || r === void 0 || r.call(n, e.element, t);
  }
}
var dw;
(function(i) {
  i.None = "none", i.OnHover = "onHover", i.Always = "always";
})(dw || (dw = {}));
class VUe {
  get elements() {
    return this._elements;
  }
  constructor(e, t = []) {
    this._elements = t, this.disposables = new Ne(), this.onDidChange = qe.forEach(e, (n) => this._elements = n, this.disposables);
  }
  dispose() {
    this.disposables.dispose();
  }
}
class uw {
  constructor(e, t, n, r, s, o = {}) {
    var a;
    this.renderer = e, this.modelProvider = t, this.activeNodes = r, this.renderedIndentGuides = s, this.renderedElements = /* @__PURE__ */ new Map(), this.renderedNodes = /* @__PURE__ */ new Map(), this.indent = uw.DefaultIndent, this.hideTwistiesOfChildlessElements = !1, this.shouldRenderIndentGuides = !1, this.activeIndentNodes = /* @__PURE__ */ new Set(), this.indentGuidesDisposable = we.None, this.disposables = new Ne(), this.templateId = e.templateId, this.updateOptions(o), qe.map(n, (l) => l.node)(this.onDidChangeNodeTwistieState, this, this.disposables), (a = e.onDidChangeTwistieState) === null || a === void 0 || a.call(e, this.onDidChangeTwistieState, this, this.disposables);
  }
  updateOptions(e = {}) {
    if (typeof e.indent < "u") {
      const t = qo(e.indent, 0, 40);
      if (t !== this.indent) {
        this.indent = t;
        for (const [n, r] of this.renderedNodes)
          this.renderTreeElement(n, r);
      }
    }
    if (typeof e.renderIndentGuides < "u") {
      const t = e.renderIndentGuides !== dw.None;
      if (t !== this.shouldRenderIndentGuides) {
        this.shouldRenderIndentGuides = t;
        for (const [n, r] of this.renderedNodes)
          this._renderIndentGuides(n, r);
        if (this.indentGuidesDisposable.dispose(), t) {
          const n = new Ne();
          this.activeNodes.onDidChange(this._onDidChangeActiveNodes, this, n), this.indentGuidesDisposable = n, this._onDidChangeActiveNodes(this.activeNodes.elements);
        }
      }
    }
    typeof e.hideTwistiesOfChildlessElements < "u" && (this.hideTwistiesOfChildlessElements = e.hideTwistiesOfChildlessElements);
  }
  renderTemplate(e) {
    const t = Te(e, Re(".monaco-tl-row")), n = Te(t, Re(".monaco-tl-indent")), r = Te(t, Re(".monaco-tl-twistie")), s = Te(t, Re(".monaco-tl-contents")), o = this.renderer.renderTemplate(s);
    return { container: e, indent: n, twistie: r, indentGuidesDisposable: we.None, templateData: o };
  }
  renderElement(e, t, n, r) {
    this.renderedNodes.set(e, n), this.renderedElements.set(e.element, e), this.renderTreeElement(e, n), this.renderer.renderElement(e, t, n.templateData, r);
  }
  disposeElement(e, t, n, r) {
    var s, o;
    n.indentGuidesDisposable.dispose(), (o = (s = this.renderer).disposeElement) === null || o === void 0 || o.call(s, e, t, n.templateData, r), typeof r == "number" && (this.renderedNodes.delete(e), this.renderedElements.delete(e.element));
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  onDidChangeTwistieState(e) {
    const t = this.renderedElements.get(e);
    t && this.onDidChangeNodeTwistieState(t);
  }
  onDidChangeNodeTwistieState(e) {
    const t = this.renderedNodes.get(e);
    t && (this._onDidChangeActiveNodes(this.activeNodes.elements), this.renderTreeElement(e, t));
  }
  renderTreeElement(e, t) {
    const n = uw.DefaultIndent + (e.depth - 1) * this.indent;
    t.twistie.style.paddingLeft = `${n}px`, t.indent.style.width = `${n + this.indent - 16}px`, e.collapsible ? t.container.setAttribute("aria-expanded", String(!e.collapsed)) : t.container.removeAttribute("aria-expanded"), t.twistie.classList.remove(...ft.asClassNameArray(We.treeItemExpanded));
    let r = !1;
    this.renderer.renderTwistie && (r = this.renderer.renderTwistie(e.element, t.twistie)), e.collapsible && (!this.hideTwistiesOfChildlessElements || e.visibleChildrenCount > 0) ? (r || t.twistie.classList.add(...ft.asClassNameArray(We.treeItemExpanded)), t.twistie.classList.add("collapsible"), t.twistie.classList.toggle("collapsed", e.collapsed)) : t.twistie.classList.remove("collapsible", "collapsed"), this._renderIndentGuides(e, t);
  }
  _renderIndentGuides(e, t) {
    if (ls(t.indent), t.indentGuidesDisposable.dispose(), !this.shouldRenderIndentGuides)
      return;
    const n = new Ne(), r = this.modelProvider();
    for (; ; ) {
      const s = r.getNodeLocation(e), o = r.getParentNodeLocation(s);
      if (!o)
        break;
      const a = r.getNode(o), l = Re(".indent-guide", { style: `width: ${this.indent}px` });
      this.activeIndentNodes.has(a) && l.classList.add("active"), t.indent.childElementCount === 0 ? t.indent.appendChild(l) : t.indent.insertBefore(l, t.indent.firstElementChild), this.renderedIndentGuides.add(a, l), n.add(Ct(() => this.renderedIndentGuides.delete(a, l))), e = a;
    }
    t.indentGuidesDisposable = n;
  }
  _onDidChangeActiveNodes(e) {
    if (!this.shouldRenderIndentGuides)
      return;
    const t = /* @__PURE__ */ new Set(), n = this.modelProvider();
    e.forEach((r) => {
      const s = n.getNodeLocation(r);
      try {
        const o = n.getParentNodeLocation(s);
        r.collapsible && r.children.length > 0 && !r.collapsed ? t.add(r) : o && t.add(n.getNode(o));
      } catch {
      }
    }), this.activeIndentNodes.forEach((r) => {
      t.has(r) || this.renderedIndentGuides.forEach(r, (s) => s.classList.remove("active"));
    }), t.forEach((r) => {
      this.activeIndentNodes.has(r) || this.renderedIndentGuides.forEach(r, (s) => s.classList.add("active"));
    }), this.activeIndentNodes = t;
  }
  dispose() {
    this.renderedNodes.clear(), this.renderedElements.clear(), this.indentGuidesDisposable.dispose(), An(this.disposables);
  }
}
uw.DefaultIndent = 8;
class HUe {
  get totalCount() {
    return this._totalCount;
  }
  get matchCount() {
    return this._matchCount;
  }
  constructor(e, t, n) {
    this.tree = e, this.keyboardNavigationLabelProvider = t, this._filter = n, this._totalCount = 0, this._matchCount = 0, this._pattern = "", this._lowercasePattern = "", this.disposables = new Ne(), e.onWillRefilter(this.reset, this, this.disposables);
  }
  filter(e, t) {
    let n = 1;
    if (this._filter) {
      const o = this._filter.filter(e, t);
      if (typeof o == "boolean" ? n = o ? 1 : 0 : hU(o) ? n = cw(o.visibility) : n = o, n === 0)
        return !1;
    }
    if (this._totalCount++, !this._pattern)
      return this._matchCount++, { data: td.Default, visibility: n };
    const r = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e), s = Array.isArray(r) ? r : [r];
    for (const o of s) {
      const a = o && o.toString();
      if (typeof a > "u")
        return { data: td.Default, visibility: n };
      let l;
      if (this.tree.findMatchType === e0.Contiguous) {
        const c = a.toLowerCase().indexOf(this._lowercasePattern);
        if (c > -1) {
          l = [Number.MAX_SAFE_INTEGER, 0];
          for (let d = this._lowercasePattern.length; d > 0; d--)
            l.push(c + d - 1);
        }
      } else
        l = Jm(this._pattern, this._lowercasePattern, 0, a, a.toLowerCase(), 0, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
      if (l)
        return this._matchCount++, s.length === 1 ? { data: l, visibility: n } : { data: { label: a, score: l }, visibility: n };
    }
    return this.tree.findMode === ru.Filter ? typeof this.tree.options.defaultFindVisibility == "number" ? this.tree.options.defaultFindVisibility : this.tree.options.defaultFindVisibility ? this.tree.options.defaultFindVisibility(e) : 2 : { data: td.Default, visibility: n };
  }
  reset() {
    this._totalCount = 0, this._matchCount = 0;
  }
  dispose() {
    An(this.disposables);
  }
}
var ru;
(function(i) {
  i[i.Highlight = 0] = "Highlight", i[i.Filter = 1] = "Filter";
})(ru || (ru = {}));
var e0;
(function(i) {
  i[i.Fuzzy = 0] = "Fuzzy", i[i.Contiguous = 1] = "Contiguous";
})(e0 || (e0 = {}));
let WUe = class {
  get pattern() {
    return this._pattern;
  }
  get mode() {
    return this._mode;
  }
  set mode(e) {
    e !== this._mode && (this._mode = e, this.widget && (this.widget.mode = this._mode), this.tree.refilter(), this.render(), this._onDidChangeMode.fire(e));
  }
  get matchType() {
    return this._matchType;
  }
  set matchType(e) {
    e !== this._matchType && (this._matchType = e, this.widget && (this.widget.matchType = this._matchType), this.tree.refilter(), this.render(), this._onDidChangeMatchType.fire(e));
  }
  constructor(e, t, n, r, s, o = {}) {
    var a, l;
    this.tree = e, this.view = n, this.filter = r, this.contextViewProvider = s, this.options = o, this._pattern = "", this.width = 0, this._onDidChangeMode = new pe(), this.onDidChangeMode = this._onDidChangeMode.event, this._onDidChangeMatchType = new pe(), this.onDidChangeMatchType = this._onDidChangeMatchType.event, this._onDidChangePattern = new pe(), this._onDidChangeOpenState = new pe(), this.onDidChangeOpenState = this._onDidChangeOpenState.event, this.enabledDisposables = new Ne(), this.disposables = new Ne(), this._mode = (a = e.options.defaultFindMode) !== null && a !== void 0 ? a : ru.Highlight, this._matchType = (l = e.options.defaultFindMatchType) !== null && l !== void 0 ? l : e0.Fuzzy, t.onDidSplice(this.onDidSpliceModel, this, this.disposables);
  }
  updateOptions(e = {}) {
    e.defaultFindMode !== void 0 && (this.mode = e.defaultFindMode), e.defaultFindMatchType !== void 0 && (this.matchType = e.defaultFindMatchType);
  }
  onDidSpliceModel() {
    !this.widget || this.pattern.length === 0 || (this.tree.refilter(), this.render());
  }
  render() {
    var e, t, n, r;
    const s = this.filter.totalCount > 0 && this.filter.matchCount === 0;
    this.pattern && s ? !((e = this.tree.options.showNotFoundMessage) !== null && e !== void 0) || e ? (t = this.widget) === null || t === void 0 || t.showMessage({ type: 2, content: C("not found", "No elements found.") }) : (n = this.widget) === null || n === void 0 || n.showMessage({
      type: 2
      /* MessageType.WARNING */
    }) : (r = this.widget) === null || r === void 0 || r.clearMessage();
  }
  shouldAllowFocus(e) {
    return !this.widget || !this.pattern || this._mode === ru.Filter || this.filter.totalCount > 0 && this.filter.matchCount <= 1 ? !0 : !td.isDefault(e.filterData);
  }
  layout(e) {
    var t;
    this.width = e, (t = this.widget) === null || t === void 0 || t.layout(e);
  }
  dispose() {
    this._history = void 0, this._onDidChangePattern.dispose(), this.enabledDisposables.dispose(), this.disposables.dispose();
  }
};
function sJ(i) {
  let e = mm.Unknown;
  return u6(i.browserEvent.target, "monaco-tl-twistie", "monaco-tl-row") ? e = mm.Twistie : u6(i.browserEvent.target, "monaco-tl-contents", "monaco-tl-row") ? e = mm.Element : u6(i.browserEvent.target, "monaco-tree-type-filter", "monaco-list") && (e = mm.Filter), {
    browserEvent: i.browserEvent,
    element: i.element ? i.element.element : null,
    target: e
  };
}
function J3(i, e) {
  e(i), i.children.forEach((t) => J3(t, e));
}
class dT {
  get nodeSet() {
    return this._nodeSet || (this._nodeSet = this.createNodeSet()), this._nodeSet;
  }
  constructor(e, t) {
    this.getFirstViewElementWithTrait = e, this.identityProvider = t, this.nodes = [], this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event;
  }
  set(e, t) {
    !t?.__forceEvent && Qi(this.nodes, e) || this._set(e, !1, t);
  }
  _set(e, t, n) {
    if (this.nodes = [...e], this.elements = void 0, this._nodeSet = void 0, !t) {
      const r = this;
      this._onDidChange.fire({ get elements() {
        return r.get();
      }, browserEvent: n });
    }
  }
  get() {
    return this.elements || (this.elements = this.nodes.map((e) => e.element)), [...this.elements];
  }
  getNodes() {
    return this.nodes;
  }
  has(e) {
    return this.nodeSet.has(e);
  }
  onDidModelSplice({ insertedNodes: e, deletedNodes: t }) {
    if (!this.identityProvider) {
      const l = this.createNodeSet(), c = (d) => l.delete(d);
      t.forEach((d) => J3(d, c)), this.set([...l.values()]);
      return;
    }
    const n = /* @__PURE__ */ new Set(), r = (l) => n.add(this.identityProvider.getId(l.element).toString());
    t.forEach((l) => J3(l, r));
    const s = /* @__PURE__ */ new Map(), o = (l) => s.set(this.identityProvider.getId(l.element).toString(), l);
    e.forEach((l) => J3(l, o));
    const a = [];
    for (const l of this.nodes) {
      const c = this.identityProvider.getId(l.element).toString();
      if (!n.has(c))
        a.push(l);
      else {
        const u = s.get(c);
        u && u.visible && a.push(u);
      }
    }
    if (this.nodes.length > 0 && a.length === 0) {
      const l = this.getFirstViewElementWithTrait();
      l && a.push(l);
    }
    this._set(a, !0);
  }
  createNodeSet() {
    const e = /* @__PURE__ */ new Set();
    for (const t of this.nodes)
      e.add(t);
    return e;
  }
}
class jUe extends vpe {
  constructor(e, t) {
    super(e), this.tree = t;
  }
  onViewPointer(e) {
    if (fpe(e.browserEvent.target) || Cg(e.browserEvent.target) || cv(e.browserEvent.target) || e.browserEvent.isHandledByList)
      return;
    const t = e.element;
    if (!t)
      return super.onViewPointer(e);
    if (this.isSelectionRangeChangeEvent(e) || this.isSelectionSingleChangeEvent(e))
      return super.onViewPointer(e);
    const n = e.browserEvent.target, r = n.classList.contains("monaco-tl-twistie") || n.classList.contains("monaco-icon-label") && n.classList.contains("folder-icon") && e.browserEvent.offsetX < 16;
    let s = !1;
    if (typeof this.tree.expandOnlyOnTwistieClick == "function" ? s = this.tree.expandOnlyOnTwistieClick(t.element) : s = !!this.tree.expandOnlyOnTwistieClick, s && !r && e.browserEvent.detail !== 2)
      return super.onViewPointer(e);
    if (!this.tree.expandOnDoubleClick && e.browserEvent.detail === 2)
      return super.onViewPointer(e);
    if (t.collapsible) {
      const o = this.tree.getNodeLocation(t), a = e.browserEvent.altKey;
      if (this.tree.setFocus([o]), this.tree.toggleCollapsed(o, a), s && r) {
        e.browserEvent.isHandledByList = !0;
        return;
      }
    }
    super.onViewPointer(e);
  }
  onDoubleClick(e) {
    e.browserEvent.target.classList.contains("monaco-tl-twistie") || !this.tree.expandOnDoubleClick || e.browserEvent.isHandledByList || super.onDoubleClick(e);
  }
}
class zUe extends pc {
  constructor(e, t, n, r, s, o, a, l) {
    super(e, t, n, r, l), this.focusTrait = s, this.selectionTrait = o, this.anchorTrait = a;
  }
  createMouseController(e) {
    return new jUe(this, e.tree);
  }
  splice(e, t, n = []) {
    if (super.splice(e, t, n), n.length === 0)
      return;
    const r = [], s = [];
    let o;
    n.forEach((a, l) => {
      this.focusTrait.has(a) && r.push(e + l), this.selectionTrait.has(a) && s.push(e + l), this.anchorTrait.has(a) && (o = e + l);
    }), r.length > 0 && super.setFocus(kg([...super.getFocus(), ...r])), s.length > 0 && super.setSelection(kg([...super.getSelection(), ...s])), typeof o == "number" && super.setAnchor(o);
  }
  setFocus(e, t, n = !1) {
    super.setFocus(e, t), n || this.focusTrait.set(e.map((r) => this.element(r)), t);
  }
  setSelection(e, t, n = !1) {
    super.setSelection(e, t), n || this.selectionTrait.set(e.map((r) => this.element(r)), t);
  }
  setAnchor(e, t = !1) {
    super.setAnchor(e), t || (typeof e > "u" ? this.anchorTrait.set([]) : this.anchorTrait.set([this.element(e)]));
  }
}
class Ope {
  get onDidScroll() {
    return this.view.onDidScroll;
  }
  get onDidChangeFocus() {
    return this.eventBufferer.wrapEvent(this.focus.onDidChange);
  }
  get onDidChangeSelection() {
    return this.eventBufferer.wrapEvent(this.selection.onDidChange);
  }
  get onMouseDblClick() {
    return qe.filter(qe.map(this.view.onMouseDblClick, sJ), (e) => e.target !== mm.Filter);
  }
  get onPointer() {
    return qe.map(this.view.onPointer, sJ);
  }
  get onDidFocus() {
    return this.view.onDidFocus;
  }
  get onDidChangeModel() {
    return qe.signal(this.model.onDidSplice);
  }
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  get findMode() {
    var e, t;
    return (t = (e = this.findController) === null || e === void 0 ? void 0 : e.mode) !== null && t !== void 0 ? t : ru.Highlight;
  }
  set findMode(e) {
    this.findController && (this.findController.mode = e);
  }
  get findMatchType() {
    var e, t;
    return (t = (e = this.findController) === null || e === void 0 ? void 0 : e.matchType) !== null && t !== void 0 ? t : e0.Fuzzy;
  }
  set findMatchType(e) {
    this.findController && (this.findController.matchType = e);
  }
  get expandOnDoubleClick() {
    return typeof this._options.expandOnDoubleClick > "u" ? !0 : this._options.expandOnDoubleClick;
  }
  get expandOnlyOnTwistieClick() {
    return typeof this._options.expandOnlyOnTwistieClick > "u" ? !0 : this._options.expandOnlyOnTwistieClick;
  }
  get onDidDispose() {
    return this.view.onDidDispose;
  }
  constructor(e, t, n, r, s = {}) {
    var o;
    this._user = e, this._options = s, this.eventBufferer = new Pj(), this.onDidChangeFindOpenState = qe.None, this.disposables = new Ne(), this._onWillRefilter = new pe(), this.onWillRefilter = this._onWillRefilter.event, this._onDidUpdateOptions = new pe();
    const a = new fU(n), l = new ZY(), c = new ZY(), d = this.disposables.add(new VUe(c.event)), u = new nz();
    this.renderers = r.map((m) => new uw(m, () => this.model, l.event, d, u, s));
    for (const m of this.renderers)
      this.disposables.add(m);
    let h;
    s.keyboardNavigationLabelProvider && (h = new HUe(this, s.keyboardNavigationLabelProvider, s.filter), s = Object.assign(Object.assign({}, s), { filter: h }), this.disposables.add(h)), this.focus = new dT(() => this.view.getFocusedElements()[0], s.identityProvider), this.selection = new dT(() => this.view.getSelectedElements()[0], s.identityProvider), this.anchor = new dT(() => this.view.getAnchorElement(), s.identityProvider), this.view = new zUe(e, t, a, this.renderers, this.focus, this.selection, this.anchor, Object.assign(Object.assign({}, BUe(() => this.model, s)), { tree: this })), this.model = this.createModel(e, this.view, s), l.input = this.model.onDidChangeCollapseState;
    const f = qe.forEach(this.model.onDidSplice, (m) => {
      this.eventBufferer.bufferEvents(() => {
        this.focus.onDidModelSplice(m), this.selection.onDidModelSplice(m);
      });
    }, this.disposables);
    f(() => null, null, this.disposables);
    const g = this.disposables.add(new pe()), p = this.disposables.add(new ac(0));
    if (this.disposables.add(qe.any(f, this.focus.onDidChange, this.selection.onDidChange)(() => {
      p.trigger(() => {
        const m = /* @__PURE__ */ new Set();
        for (const _ of this.focus.getNodes())
          m.add(_);
        for (const _ of this.selection.getNodes())
          m.add(_);
        g.fire([...m.values()]);
      });
    })), c.input = g.event, s.keyboardSupport !== !1) {
      const m = qe.chain(this.view.onKeyDown, (_) => _.filter((b) => !Cg(b.target)).map((b) => new Xn(b)));
      qe.chain(m, (_) => _.filter(
        (b) => b.keyCode === 15
        /* KeyCode.LeftArrow */
      ))(this.onLeftArrow, this, this.disposables), qe.chain(m, (_) => _.filter(
        (b) => b.keyCode === 17
        /* KeyCode.RightArrow */
      ))(this.onRightArrow, this, this.disposables), qe.chain(m, (_) => _.filter(
        (b) => b.keyCode === 10
        /* KeyCode.Space */
      ))(this.onSpace, this, this.disposables);
    }
    if ((!((o = s.findWidgetEnabled) !== null && o !== void 0) || o) && s.keyboardNavigationLabelProvider && s.contextViewProvider) {
      const m = this.options.findWidgetStyles ? { styles: this.options.findWidgetStyles } : void 0;
      this.findController = new WUe(this, this.model, this.view, h, s.contextViewProvider, m), this.focusNavigationFilter = (_) => this.findController.shouldAllowFocus(_), this.onDidChangeFindOpenState = this.findController.onDidChangeOpenState, this.disposables.add(this.findController), this.onDidChangeFindMode = this.findController.onDidChangeMode, this.onDidChangeFindMatchType = this.findController.onDidChangeMatchType;
    } else
      this.onDidChangeFindMode = qe.None, this.onDidChangeFindMatchType = qe.None;
    this.styleElement = yl(this.view.getHTMLElement()), this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === dw.Always);
  }
  updateOptions(e = {}) {
    var t;
    this._options = Object.assign(Object.assign({}, this._options), e);
    for (const n of this.renderers)
      n.updateOptions(e);
    this.view.updateOptions(this._options), (t = this.findController) === null || t === void 0 || t.updateOptions(e), this._onDidUpdateOptions.fire(this._options), this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === dw.Always);
  }
  get options() {
    return this._options;
  }
  // Widget
  getHTMLElement() {
    return this.view.getHTMLElement();
  }
  get scrollTop() {
    return this.view.scrollTop;
  }
  set scrollTop(e) {
    this.view.scrollTop = e;
  }
  get scrollHeight() {
    return this.view.scrollHeight;
  }
  get renderHeight() {
    return this.view.renderHeight;
  }
  domFocus() {
    this.view.domFocus();
  }
  layout(e, t) {
    var n;
    this.view.layout(e, t), Tg(t) && ((n = this.findController) === null || n === void 0 || n.layout(t));
  }
  style(e) {
    const t = `.${this.view.domId}`, n = [];
    e.treeIndentGuidesStroke && (n.push(`.monaco-list${t}:hover .monaco-tl-indent > .indent-guide, .monaco-list${t}.always .monaco-tl-indent > .indent-guide  { border-color: ${e.treeInactiveIndentGuidesStroke}; }`), n.push(`.monaco-list${t} .monaco-tl-indent > .indent-guide.active { border-color: ${e.treeIndentGuidesStroke}; }`)), this.styleElement.textContent = n.join(`
`), this.view.style(e);
  }
  // Tree navigation
  getParentElement(e) {
    const t = this.model.getParentNodeLocation(e);
    return this.model.getNode(t).element;
  }
  getFirstElementChild(e) {
    return this.model.getFirstElementChild(e);
  }
  // Tree
  getNode(e) {
    return this.model.getNode(e);
  }
  getNodeLocation(e) {
    return this.model.getNodeLocation(e);
  }
  collapse(e, t = !1) {
    return this.model.setCollapsed(e, !0, t);
  }
  expand(e, t = !1) {
    return this.model.setCollapsed(e, !1, t);
  }
  toggleCollapsed(e, t = !1) {
    return this.model.setCollapsed(e, void 0, t);
  }
  isCollapsible(e) {
    return this.model.isCollapsible(e);
  }
  setCollapsible(e, t) {
    return this.model.setCollapsible(e, t);
  }
  isCollapsed(e) {
    return this.model.isCollapsed(e);
  }
  refilter() {
    this._onWillRefilter.fire(void 0), this.model.refilter();
  }
  setSelection(e, t) {
    const n = e.map((s) => this.model.getNode(s));
    this.selection.set(n, t);
    const r = e.map((s) => this.model.getListIndex(s)).filter((s) => s > -1);
    this.view.setSelection(r, t, !0);
  }
  getSelection() {
    return this.selection.get();
  }
  setFocus(e, t) {
    const n = e.map((s) => this.model.getNode(s));
    this.focus.set(n, t);
    const r = e.map((s) => this.model.getListIndex(s)).filter((s) => s > -1);
    this.view.setFocus(r, t, !0);
  }
  getFocus() {
    return this.focus.get();
  }
  reveal(e, t) {
    this.model.expandTo(e);
    const n = this.model.getListIndex(e);
    n !== -1 && this.view.reveal(n, t);
  }
  // List
  onLeftArrow(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0)
      return;
    const n = t[0], r = this.model.getNodeLocation(n);
    if (!this.model.setCollapsed(r, !0)) {
      const o = this.model.getParentNodeLocation(r);
      if (!o)
        return;
      const a = this.model.getListIndex(o);
      this.view.reveal(a), this.view.setFocus([a]);
    }
  }
  onRightArrow(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0)
      return;
    const n = t[0], r = this.model.getNodeLocation(n);
    if (!this.model.setCollapsed(r, !1)) {
      if (!n.children.some((l) => l.visible))
        return;
      const [o] = this.view.getFocus(), a = o + 1;
      this.view.reveal(a), this.view.setFocus([a]);
    }
  }
  onSpace(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0)
      return;
    const n = t[0], r = this.model.getNodeLocation(n), s = e.browserEvent.altKey;
    this.model.setCollapsed(r, void 0, s);
  }
  dispose() {
    An(this.disposables), this.view.dispose();
  }
}
class gU {
  constructor(e, t, n = {}) {
    this.user = e, this.rootRef = null, this.nodes = /* @__PURE__ */ new Map(), this.nodesByIdentity = /* @__PURE__ */ new Map(), this.model = new MUe(e, t, null, n), this.onDidSplice = this.model.onDidSplice, this.onDidChangeCollapseState = this.model.onDidChangeCollapseState, this.onDidChangeRenderNodeCount = this.model.onDidChangeRenderNodeCount, n.sorter && (this.sorter = {
      compare(r, s) {
        return n.sorter.compare(r.element, s.element);
      }
    }), this.identityProvider = n.identityProvider;
  }
  setChildren(e, t = Wt.empty(), n = {}) {
    const r = this.getElementLocation(e);
    this._setChildren(r, this.preserveCollapseState(t), n);
  }
  _setChildren(e, t = Wt.empty(), n) {
    const r = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), o = (l) => {
      var c;
      if (l.element === null)
        return;
      const d = l;
      if (r.add(d.element), this.nodes.set(d.element, d), this.identityProvider) {
        const u = this.identityProvider.getId(d.element).toString();
        s.add(u), this.nodesByIdentity.set(u, d);
      }
      (c = n.onDidCreateNode) === null || c === void 0 || c.call(n, d);
    }, a = (l) => {
      var c;
      if (l.element === null)
        return;
      const d = l;
      if (r.has(d.element) || this.nodes.delete(d.element), this.identityProvider) {
        const u = this.identityProvider.getId(d.element).toString();
        s.has(u) || this.nodesByIdentity.delete(u);
      }
      (c = n.onDidDeleteNode) === null || c === void 0 || c.call(n, d);
    };
    this.model.splice([...e, 0], Number.MAX_VALUE, t, Object.assign(Object.assign({}, n), { onDidCreateNode: o, onDidDeleteNode: a }));
  }
  preserveCollapseState(e = Wt.empty()) {
    return this.sorter && (e = [...e].sort(this.sorter.compare.bind(this.sorter))), Wt.map(e, (t) => {
      let n = this.nodes.get(t.element);
      if (!n && this.identityProvider) {
        const o = this.identityProvider.getId(t.element).toString();
        n = this.nodesByIdentity.get(o);
      }
      if (!n) {
        let o;
        return typeof t.collapsed > "u" ? o = void 0 : t.collapsed === kd.Collapsed || t.collapsed === kd.PreserveOrCollapsed ? o = !0 : t.collapsed === kd.Expanded || t.collapsed === kd.PreserveOrExpanded ? o = !1 : o = !!t.collapsed, Object.assign(Object.assign({}, t), { children: this.preserveCollapseState(t.children), collapsed: o });
      }
      const r = typeof t.collapsible == "boolean" ? t.collapsible : n.collapsible;
      let s;
      return typeof t.collapsed > "u" || t.collapsed === kd.PreserveOrCollapsed || t.collapsed === kd.PreserveOrExpanded ? s = n.collapsed : t.collapsed === kd.Collapsed ? s = !0 : t.collapsed === kd.Expanded ? s = !1 : s = !!t.collapsed, Object.assign(Object.assign({}, t), {
        collapsible: r,
        collapsed: s,
        children: this.preserveCollapseState(t.children)
      });
    });
  }
  rerender(e) {
    const t = this.getElementLocation(e);
    this.model.rerender(t);
  }
  getFirstElementChild(e = null) {
    const t = this.getElementLocation(e);
    return this.model.getFirstElementChild(t);
  }
  has(e) {
    return this.nodes.has(e);
  }
  getListIndex(e) {
    const t = this.getElementLocation(e);
    return this.model.getListIndex(t);
  }
  getListRenderCount(e) {
    const t = this.getElementLocation(e);
    return this.model.getListRenderCount(t);
  }
  isCollapsible(e) {
    const t = this.getElementLocation(e);
    return this.model.isCollapsible(t);
  }
  setCollapsible(e, t) {
    const n = this.getElementLocation(e);
    return this.model.setCollapsible(n, t);
  }
  isCollapsed(e) {
    const t = this.getElementLocation(e);
    return this.model.isCollapsed(t);
  }
  setCollapsed(e, t, n) {
    const r = this.getElementLocation(e);
    return this.model.setCollapsed(r, t, n);
  }
  expandTo(e) {
    const t = this.getElementLocation(e);
    this.model.expandTo(t);
  }
  refilter() {
    this.model.refilter();
  }
  getNode(e = null) {
    if (e === null)
      return this.model.getNode(this.model.rootRef);
    const t = this.nodes.get(e);
    if (!t)
      throw new Ea(this.user, `Tree element not found: ${e}`);
    return t;
  }
  getNodeLocation(e) {
    return e.element;
  }
  getParentNodeLocation(e) {
    if (e === null)
      throw new Ea(this.user, "Invalid getParentNodeLocation call");
    const t = this.nodes.get(e);
    if (!t)
      throw new Ea(this.user, `Tree element not found: ${e}`);
    const n = this.model.getNodeLocation(t), r = this.model.getParentNodeLocation(n);
    return this.model.getNode(r).element;
  }
  getElementLocation(e) {
    if (e === null)
      return [];
    const t = this.nodes.get(e);
    if (!t)
      throw new Ea(this.user, `Tree element not found: ${e}`);
    return this.model.getNodeLocation(t);
  }
}
function $3(i) {
  const e = [i.element], t = i.incompressible || !1;
  return {
    element: { elements: e, incompressible: t },
    children: Wt.map(Wt.from(i.children), $3),
    collapsible: i.collapsible,
    collapsed: i.collapsed
  };
}
function eE(i) {
  const e = [i.element], t = i.incompressible || !1;
  let n, r;
  for (; [r, n] = Wt.consume(Wt.from(i.children), 2), !(r.length !== 1 || r[0].incompressible); )
    i = r[0], e.push(i.element);
  return {
    element: { elements: e, incompressible: t },
    children: Wt.map(Wt.concat(r, n), eE),
    collapsible: i.collapsible,
    collapsed: i.collapsed
  };
}
function RB(i, e = 0) {
  let t;
  return e < i.element.elements.length - 1 ? t = [RB(i, e + 1)] : t = Wt.map(Wt.from(i.children), (n) => RB(n, 0)), e === 0 && i.element.incompressible ? {
    element: i.element.elements[e],
    children: t,
    incompressible: !0,
    collapsible: i.collapsible,
    collapsed: i.collapsed
  } : {
    element: i.element.elements[e],
    children: t,
    collapsible: i.collapsible,
    collapsed: i.collapsed
  };
}
function oJ(i) {
  return RB(i, 0);
}
function Mpe(i, e, t) {
  return i.element === e ? Object.assign(Object.assign({}, i), { children: t }) : Object.assign(Object.assign({}, i), { children: Wt.map(Wt.from(i.children), (n) => Mpe(n, e, t)) });
}
const UUe = (i) => ({
  getId(e) {
    return e.elements.map((t) => i.getId(t).toString()).join("\0");
  }
});
class GUe {
  get onDidSplice() {
    return this.model.onDidSplice;
  }
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  get onDidChangeRenderNodeCount() {
    return this.model.onDidChangeRenderNodeCount;
  }
  constructor(e, t, n = {}) {
    this.user = e, this.rootRef = null, this.nodes = /* @__PURE__ */ new Map(), this.model = new gU(e, t, n), this.enabled = typeof n.compressionEnabled > "u" ? !0 : n.compressionEnabled, this.identityProvider = n.identityProvider;
  }
  setChildren(e, t = Wt.empty(), n) {
    const r = n.diffIdentityProvider && UUe(n.diffIdentityProvider);
    if (e === null) {
      const g = Wt.map(t, this.enabled ? eE : $3);
      this._setChildren(null, g, { diffIdentityProvider: r, diffDepth: 1 / 0 });
      return;
    }
    const s = this.nodes.get(e);
    if (!s)
      throw new Ea(this.user, "Unknown compressed tree node");
    const o = this.model.getNode(s), a = this.model.getParentNodeLocation(s), l = this.model.getNode(a), c = oJ(o), d = Mpe(c, e, t), u = (this.enabled ? eE : $3)(d), h = n.diffIdentityProvider ? (g, p) => n.diffIdentityProvider.getId(g) === n.diffIdentityProvider.getId(p) : void 0;
    if (Qi(u.element.elements, o.element.elements, h)) {
      this._setChildren(s, u.children || Wt.empty(), { diffIdentityProvider: r, diffDepth: 1 });
      return;
    }
    const f = l.children.map((g) => g === o ? u : g);
    this._setChildren(l.element, f, {
      diffIdentityProvider: r,
      diffDepth: o.depth - l.depth
    });
  }
  setCompressionEnabled(e) {
    if (e === this.enabled)
      return;
    this.enabled = e;
    const n = this.model.getNode().children, r = Wt.map(n, oJ), s = Wt.map(r, e ? eE : $3);
    this._setChildren(null, s, {
      diffIdentityProvider: this.identityProvider,
      diffDepth: 1 / 0
    });
  }
  _setChildren(e, t, n) {
    const r = /* @__PURE__ */ new Set(), s = (a) => {
      for (const l of a.element.elements)
        r.add(l), this.nodes.set(l, a.element);
    }, o = (a) => {
      for (const l of a.element.elements)
        r.has(l) || this.nodes.delete(l);
    };
    this.model.setChildren(e, t, Object.assign(Object.assign({}, n), { onDidCreateNode: s, onDidDeleteNode: o }));
  }
  has(e) {
    return this.nodes.has(e);
  }
  getListIndex(e) {
    const t = this.getCompressedNode(e);
    return this.model.getListIndex(t);
  }
  getListRenderCount(e) {
    const t = this.getCompressedNode(e);
    return this.model.getListRenderCount(t);
  }
  getNode(e) {
    if (typeof e > "u")
      return this.model.getNode();
    const t = this.getCompressedNode(e);
    return this.model.getNode(t);
  }
  // TODO: review this
  getNodeLocation(e) {
    const t = this.model.getNodeLocation(e);
    return t === null ? null : t.elements[t.elements.length - 1];
  }
  // TODO: review this
  getParentNodeLocation(e) {
    const t = this.getCompressedNode(e), n = this.model.getParentNodeLocation(t);
    return n === null ? null : n.elements[n.elements.length - 1];
  }
  getFirstElementChild(e) {
    const t = this.getCompressedNode(e);
    return this.model.getFirstElementChild(t);
  }
  isCollapsible(e) {
    const t = this.getCompressedNode(e);
    return this.model.isCollapsible(t);
  }
  setCollapsible(e, t) {
    const n = this.getCompressedNode(e);
    return this.model.setCollapsible(n, t);
  }
  isCollapsed(e) {
    const t = this.getCompressedNode(e);
    return this.model.isCollapsed(t);
  }
  setCollapsed(e, t, n) {
    const r = this.getCompressedNode(e);
    return this.model.setCollapsed(r, t, n);
  }
  expandTo(e) {
    const t = this.getCompressedNode(e);
    this.model.expandTo(t);
  }
  rerender(e) {
    const t = this.getCompressedNode(e);
    this.model.rerender(t);
  }
  refilter() {
    this.model.refilter();
  }
  getCompressedNode(e) {
    if (e === null)
      return null;
    const t = this.nodes.get(e);
    if (!t)
      throw new Ea(this.user, `Tree element not found: ${e}`);
    return t;
  }
}
const qUe = (i) => i[i.length - 1];
class pU {
  get element() {
    return this.node.element === null ? null : this.unwrapper(this.node.element);
  }
  get children() {
    return this.node.children.map((e) => new pU(this.unwrapper, e));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e, t) {
    this.unwrapper = e, this.node = t;
  }
}
function KUe(i, e) {
  return {
    splice(t, n, r) {
      e.splice(t, n, r.map((s) => i.map(s)));
    },
    updateElementHeight(t, n) {
      e.updateElementHeight(t, n);
    }
  };
}
function YUe(i, e) {
  return Object.assign(Object.assign({}, e), { identityProvider: e.identityProvider && {
    getId(t) {
      return e.identityProvider.getId(i(t));
    }
  }, sorter: e.sorter && {
    compare(t, n) {
      return e.sorter.compare(t.elements[0], n.elements[0]);
    }
  }, filter: e.filter && {
    filter(t, n) {
      return e.filter.filter(i(t), n);
    }
  } });
}
class XUe {
  get onDidSplice() {
    return qe.map(this.model.onDidSplice, ({ insertedNodes: e, deletedNodes: t }) => ({
      insertedNodes: e.map((n) => this.nodeMapper.map(n)),
      deletedNodes: t.map((n) => this.nodeMapper.map(n))
    }));
  }
  get onDidChangeCollapseState() {
    return qe.map(this.model.onDidChangeCollapseState, ({ node: e, deep: t }) => ({
      node: this.nodeMapper.map(e),
      deep: t
    }));
  }
  get onDidChangeRenderNodeCount() {
    return qe.map(this.model.onDidChangeRenderNodeCount, (e) => this.nodeMapper.map(e));
  }
  constructor(e, t, n = {}) {
    this.rootRef = null, this.elementMapper = n.elementMapper || qUe;
    const r = (s) => this.elementMapper(s.elements);
    this.nodeMapper = new uU((s) => new pU(r, s)), this.model = new GUe(e, KUe(this.nodeMapper, t), YUe(r, n));
  }
  setChildren(e, t = Wt.empty(), n = {}) {
    this.model.setChildren(e, t, n);
  }
  setCompressionEnabled(e) {
    this.model.setCompressionEnabled(e);
  }
  has(e) {
    return this.model.has(e);
  }
  getListIndex(e) {
    return this.model.getListIndex(e);
  }
  getListRenderCount(e) {
    return this.model.getListRenderCount(e);
  }
  getNode(e) {
    return this.nodeMapper.map(this.model.getNode(e));
  }
  getNodeLocation(e) {
    return e.element;
  }
  getParentNodeLocation(e) {
    return this.model.getParentNodeLocation(e);
  }
  getFirstElementChild(e) {
    const t = this.model.getFirstElementChild(e);
    return t === null || typeof t > "u" ? t : this.elementMapper(t.elements);
  }
  isCollapsible(e) {
    return this.model.isCollapsible(e);
  }
  setCollapsible(e, t) {
    return this.model.setCollapsible(e, t);
  }
  isCollapsed(e) {
    return this.model.isCollapsed(e);
  }
  setCollapsed(e, t, n) {
    return this.model.setCollapsed(e, t, n);
  }
  expandTo(e) {
    return this.model.expandTo(e);
  }
  rerender(e) {
    return this.model.rerender(e);
  }
  refilter() {
    return this.model.refilter();
  }
  getCompressedTreeNode(e = null) {
    return this.model.getNode(e);
  }
}
var ZUe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
};
class mU extends Ope {
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  constructor(e, t, n, r, s = {}) {
    super(e, t, n, r, s), this.user = e;
  }
  setChildren(e, t = Wt.empty(), n) {
    this.model.setChildren(e, t, n);
  }
  rerender(e) {
    if (e === void 0) {
      this.view.rerender();
      return;
    }
    this.model.rerender(e);
  }
  hasElement(e) {
    return this.model.has(e);
  }
  createModel(e, t, n) {
    return new gU(e, t, n);
  }
}
class Rpe {
  get compressedTreeNodeProvider() {
    return this._compressedTreeNodeProvider();
  }
  constructor(e, t) {
    this._compressedTreeNodeProvider = e, this.renderer = t, this.templateId = t.templateId, t.onDidChangeTwistieState && (this.onDidChangeTwistieState = t.onDidChangeTwistieState);
  }
  renderTemplate(e) {
    return { compressedTreeNode: void 0, data: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, n, r) {
    const s = this.compressedTreeNodeProvider.getCompressedTreeNode(e.element);
    s.element.elements.length === 1 ? (n.compressedTreeNode = void 0, this.renderer.renderElement(e, t, n.data, r)) : (n.compressedTreeNode = s, this.renderer.renderCompressedElements(s, t, n.data, r));
  }
  disposeElement(e, t, n, r) {
    var s, o, a, l;
    n.compressedTreeNode ? (o = (s = this.renderer).disposeCompressedElements) === null || o === void 0 || o.call(s, n.compressedTreeNode, t, n.data, r) : (l = (a = this.renderer).disposeElement) === null || l === void 0 || l.call(a, e, t, n.data, r);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.data);
  }
  renderTwistie(e, t) {
    return this.renderer.renderTwistie ? this.renderer.renderTwistie(e, t) : !1;
  }
}
ZUe([
  cr
], Rpe.prototype, "compressedTreeNodeProvider", null);
function QUe(i, e) {
  return e && Object.assign(Object.assign({}, e), { keyboardNavigationLabelProvider: e.keyboardNavigationLabelProvider && {
    getKeyboardNavigationLabel(t) {
      let n;
      try {
        n = i().getCompressedTreeNode(t);
      } catch {
        return e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t);
      }
      return n.element.elements.length === 1 ? e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t) : e.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(n.element.elements);
    }
  } });
}
class Fpe extends mU {
  constructor(e, t, n, r, s = {}) {
    const o = () => this, a = r.map((l) => new Rpe(o, l));
    super(e, t, n, a, QUe(o, s));
  }
  setChildren(e, t = Wt.empty(), n) {
    this.model.setChildren(e, t, n);
  }
  createModel(e, t, n) {
    return new XUe(e, t, n);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), typeof e.compressionEnabled < "u" && this.model.setCompressionEnabled(e.compressionEnabled);
  }
  getCompressedTreeNode(e = null) {
    return this.model.getCompressedTreeNode(e);
  }
}
var yf = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function uT(i) {
  return Object.assign(Object.assign({}, i), { children: [], refreshPromise: void 0, stale: !0, slow: !1, collapsedByDefault: void 0 });
}
function FB(i, e) {
  return e.parent ? e.parent === i ? !0 : FB(i, e.parent) : !1;
}
function JUe(i, e) {
  return i === e || FB(i, e) || FB(e, i);
}
class vU {
  get element() {
    return this.node.element.element;
  }
  get children() {
    return this.node.children.map((e) => new vU(e));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e) {
    this.node = e;
  }
}
class $Ue {
  constructor(e, t, n) {
    this.renderer = e, this.nodeMapper = t, this.onDidChangeTwistieState = n, this.renderedNodes = /* @__PURE__ */ new Map(), this.templateId = e.templateId;
  }
  renderTemplate(e) {
    return { templateData: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, n, r) {
    this.renderer.renderElement(this.nodeMapper.map(e), t, n.templateData, r);
  }
  renderTwistie(e, t) {
    return e.slow ? (t.classList.add(...ft.asClassNameArray(We.treeItemLoading)), !0) : (t.classList.remove(...ft.asClassNameArray(We.treeItemLoading)), !1);
  }
  disposeElement(e, t, n, r) {
    var s, o;
    (o = (s = this.renderer).disposeElement) === null || o === void 0 || o.call(s, this.nodeMapper.map(e), t, n.templateData, r);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  dispose() {
    this.renderedNodes.clear();
  }
}
function aJ(i) {
  return {
    browserEvent: i.browserEvent,
    elements: i.elements.map((e) => e.element)
  };
}
function lJ(i) {
  return {
    browserEvent: i.browserEvent,
    element: i.element && i.element.element,
    target: i.target
  };
}
class eGe extends VS {
  constructor(e) {
    super(e.elements.map((t) => t.element)), this.data = e;
  }
}
function hT(i) {
  return i instanceof VS ? new eGe(i) : i;
}
class tGe {
  constructor(e) {
    this.dnd = e;
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e.element);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel)
      return this.dnd.getDragLabel(e.map((n) => n.element), t);
  }
  onDragStart(e, t) {
    var n, r;
    (r = (n = this.dnd).onDragStart) === null || r === void 0 || r.call(n, hT(e), t);
  }
  onDragOver(e, t, n, r, s = !0) {
    return this.dnd.onDragOver(hT(e), t && t.element, n, r);
  }
  drop(e, t, n, r) {
    this.dnd.drop(hT(e), t && t.element, n, r);
  }
  onDragEnd(e) {
    var t, n;
    (n = (t = this.dnd).onDragEnd) === null || n === void 0 || n.call(t, e);
  }
  dispose() {
    this.dnd.dispose();
  }
}
function Bpe(i) {
  return i && Object.assign(Object.assign({}, i), { collapseByDefault: !0, identityProvider: i.identityProvider && {
    getId(e) {
      return i.identityProvider.getId(e.element);
    }
  }, dnd: i.dnd && new tGe(i.dnd), multipleSelectionController: i.multipleSelectionController && {
    isSelectionSingleChangeEvent(e) {
      return i.multipleSelectionController.isSelectionSingleChangeEvent(Object.assign(Object.assign({}, e), { element: e.element }));
    },
    isSelectionRangeChangeEvent(e) {
      return i.multipleSelectionController.isSelectionRangeChangeEvent(Object.assign(Object.assign({}, e), { element: e.element }));
    }
  }, accessibilityProvider: i.accessibilityProvider && Object.assign(Object.assign({}, i.accessibilityProvider), {
    getPosInSet: void 0,
    getSetSize: void 0,
    getRole: i.accessibilityProvider.getRole ? (e) => i.accessibilityProvider.getRole(e.element) : () => "treeitem",
    isChecked: i.accessibilityProvider.isChecked ? (e) => {
      var t;
      return !!(!((t = i.accessibilityProvider) === null || t === void 0) && t.isChecked(e.element));
    } : void 0,
    getAriaLabel(e) {
      return i.accessibilityProvider.getAriaLabel(e.element);
    },
    getWidgetAriaLabel() {
      return i.accessibilityProvider.getWidgetAriaLabel();
    },
    getWidgetRole: i.accessibilityProvider.getWidgetRole ? () => i.accessibilityProvider.getWidgetRole() : () => "tree",
    getAriaLevel: i.accessibilityProvider.getAriaLevel && ((e) => i.accessibilityProvider.getAriaLevel(e.element)),
    getActiveDescendantId: i.accessibilityProvider.getActiveDescendantId && ((e) => i.accessibilityProvider.getActiveDescendantId(e.element))
  }), filter: i.filter && {
    filter(e, t) {
      return i.filter.filter(e.element, t);
    }
  }, keyboardNavigationLabelProvider: i.keyboardNavigationLabelProvider && Object.assign(Object.assign({}, i.keyboardNavigationLabelProvider), { getKeyboardNavigationLabel(e) {
    return i.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e.element);
  } }), sorter: void 0, expandOnlyOnTwistieClick: typeof i.expandOnlyOnTwistieClick > "u" ? void 0 : typeof i.expandOnlyOnTwistieClick != "function" ? i.expandOnlyOnTwistieClick : (e) => i.expandOnlyOnTwistieClick(e.element), defaultFindVisibility: (e) => e.hasChildren && e.stale ? 1 : typeof i.defaultFindVisibility == "number" ? i.defaultFindVisibility : typeof i.defaultFindVisibility > "u" ? 2 : i.defaultFindVisibility(e.element) });
}
function BB(i, e) {
  e(i), i.children.forEach((t) => BB(t, e));
}
class Vpe {
  get onDidScroll() {
    return this.tree.onDidScroll;
  }
  get onDidChangeFocus() {
    return qe.map(this.tree.onDidChangeFocus, aJ);
  }
  get onDidChangeSelection() {
    return qe.map(this.tree.onDidChangeSelection, aJ);
  }
  get onMouseDblClick() {
    return qe.map(this.tree.onMouseDblClick, lJ);
  }
  get onPointer() {
    return qe.map(this.tree.onPointer, lJ);
  }
  get onDidFocus() {
    return this.tree.onDidFocus;
  }
  /**
   * To be used internally only!
   * @deprecated
   */
  get onDidChangeModel() {
    return this.tree.onDidChangeModel;
  }
  get onDidChangeCollapseState() {
    return this.tree.onDidChangeCollapseState;
  }
  get onDidChangeFindOpenState() {
    return this.tree.onDidChangeFindOpenState;
  }
  get onDidDispose() {
    return this.tree.onDidDispose;
  }
  constructor(e, t, n, r, s, o = {}) {
    this.user = e, this.dataSource = s, this.nodes = /* @__PURE__ */ new Map(), this.subTreeRefreshPromises = /* @__PURE__ */ new Map(), this.refreshPromises = /* @__PURE__ */ new Map(), this._onDidRender = new pe(), this._onDidChangeNodeSlowState = new pe(), this.nodeMapper = new uU((a) => new vU(a)), this.disposables = new Ne(), this.identityProvider = o.identityProvider, this.autoExpandSingleChildren = typeof o.autoExpandSingleChildren > "u" ? !1 : o.autoExpandSingleChildren, this.sorter = o.sorter, this.collapseByDefault = o.collapseByDefault, this.tree = this.createTree(e, t, n, r, o), this.onDidChangeFindMode = this.tree.onDidChangeFindMode, this.root = uT({
      element: void 0,
      parent: null,
      hasChildren: !0
    }), this.identityProvider && (this.root = Object.assign(Object.assign({}, this.root), { id: null })), this.nodes.set(null, this.root), this.tree.onDidChangeCollapseState(this._onDidChangeCollapseState, this, this.disposables);
  }
  createTree(e, t, n, r, s) {
    const o = new fU(n), a = r.map((c) => new $Ue(c, this.nodeMapper, this._onDidChangeNodeSlowState.event)), l = Bpe(s) || {};
    return new mU(e, t, o, a, l);
  }
  updateOptions(e = {}) {
    this.tree.updateOptions(e);
  }
  // Widget
  getHTMLElement() {
    return this.tree.getHTMLElement();
  }
  get scrollTop() {
    return this.tree.scrollTop;
  }
  set scrollTop(e) {
    this.tree.scrollTop = e;
  }
  get scrollHeight() {
    return this.tree.scrollHeight;
  }
  get renderHeight() {
    return this.tree.renderHeight;
  }
  domFocus() {
    this.tree.domFocus();
  }
  layout(e, t) {
    this.tree.layout(e, t);
  }
  style(e) {
    this.tree.style(e);
  }
  // Model
  getInput() {
    return this.root.element;
  }
  setInput(e, t) {
    return yf(this, void 0, void 0, function* () {
      this.refreshPromises.forEach((r) => r.cancel()), this.refreshPromises.clear(), this.root.element = e;
      const n = t && { viewState: t, focus: [], selection: [] };
      yield this._updateChildren(e, !0, !1, n), n && (this.tree.setFocus(n.focus), this.tree.setSelection(n.selection)), t && typeof t.scrollTop == "number" && (this.scrollTop = t.scrollTop);
    });
  }
  _updateChildren(e = this.root.element, t = !0, n = !1, r, s) {
    return yf(this, void 0, void 0, function* () {
      if (typeof this.root.element > "u")
        throw new Ea(this.user, "Tree input not set");
      this.root.refreshPromise && (yield this.root.refreshPromise, yield qe.toPromise(this._onDidRender.event));
      const o = this.getDataNode(e);
      if (yield this.refreshAndRenderNode(o, t, r, s), n)
        try {
          this.tree.rerender(o);
        } catch {
        }
    });
  }
  // View
  rerender(e) {
    if (e === void 0 || e === this.root.element) {
      this.tree.rerender();
      return;
    }
    const t = this.getDataNode(e);
    this.tree.rerender(t);
  }
  // Tree
  getNode(e = this.root.element) {
    const t = this.getDataNode(e), n = this.tree.getNode(t === this.root ? null : t);
    return this.nodeMapper.map(n);
  }
  collapse(e, t = !1) {
    const n = this.getDataNode(e);
    return this.tree.collapse(n === this.root ? null : n, t);
  }
  expand(e, t = !1) {
    return yf(this, void 0, void 0, function* () {
      if (typeof this.root.element > "u")
        throw new Ea(this.user, "Tree input not set");
      this.root.refreshPromise && (yield this.root.refreshPromise, yield qe.toPromise(this._onDidRender.event));
      const n = this.getDataNode(e);
      if (this.tree.hasElement(n) && !this.tree.isCollapsible(n) || (n.refreshPromise && (yield this.root.refreshPromise, yield qe.toPromise(this._onDidRender.event)), n !== this.root && !n.refreshPromise && !this.tree.isCollapsed(n)))
        return !1;
      const r = this.tree.expand(n === this.root ? null : n, t);
      return n.refreshPromise && (yield this.root.refreshPromise, yield qe.toPromise(this._onDidRender.event)), r;
    });
  }
  setSelection(e, t) {
    const n = e.map((r) => this.getDataNode(r));
    this.tree.setSelection(n, t);
  }
  getSelection() {
    return this.tree.getSelection().map((t) => t.element);
  }
  setFocus(e, t) {
    const n = e.map((r) => this.getDataNode(r));
    this.tree.setFocus(n, t);
  }
  getFocus() {
    return this.tree.getFocus().map((t) => t.element);
  }
  reveal(e, t) {
    this.tree.reveal(this.getDataNode(e), t);
  }
  // Tree navigation
  getParentElement(e) {
    const t = this.tree.getParentElement(this.getDataNode(e));
    return t && t.element;
  }
  getFirstElementChild(e = this.root.element) {
    const t = this.getDataNode(e), n = this.tree.getFirstElementChild(t === this.root ? null : t);
    return n && n.element;
  }
  // Implementation
  getDataNode(e) {
    const t = this.nodes.get(e === this.root.element ? null : e);
    if (!t)
      throw new Ea(this.user, `Data tree node not found: ${e}`);
    return t;
  }
  refreshAndRenderNode(e, t, n, r) {
    return yf(this, void 0, void 0, function* () {
      yield this.refreshNode(e, t, n), this.render(e, n, r);
    });
  }
  refreshNode(e, t, n) {
    return yf(this, void 0, void 0, function* () {
      let r;
      if (this.subTreeRefreshPromises.forEach((s, o) => {
        !r && JUe(o, e) && (r = s.then(() => this.refreshNode(e, t, n)));
      }), r)
        return r;
      if (e !== this.root && this.tree.getNode(e).collapsed) {
        e.hasChildren = !!this.dataSource.hasChildren(e.element), e.stale = !0;
        return;
      }
      return this.doRefreshSubTree(e, t, n);
    });
  }
  doRefreshSubTree(e, t, n) {
    return yf(this, void 0, void 0, function* () {
      let r;
      e.refreshPromise = new Promise((s) => r = s), this.subTreeRefreshPromises.set(e, e.refreshPromise), e.refreshPromise.finally(() => {
        e.refreshPromise = void 0, this.subTreeRefreshPromises.delete(e);
      });
      try {
        const s = yield this.doRefreshNode(e, t, n);
        e.stale = !1, yield uF.settled(s.map((o) => this.doRefreshSubTree(o, t, n)));
      } finally {
        r();
      }
    });
  }
  doRefreshNode(e, t, n) {
    return yf(this, void 0, void 0, function* () {
      e.hasChildren = !!this.dataSource.hasChildren(e.element);
      let r;
      if (!e.hasChildren)
        r = Promise.resolve(Wt.empty());
      else {
        const s = this.doGetChildren(e);
        if (UY(s))
          r = Promise.resolve(s);
        else {
          const o = Mg(800);
          o.then(() => {
            e.slow = !0, this._onDidChangeNodeSlowState.fire(e);
          }, (a) => null), r = s.finally(() => o.cancel());
        }
      }
      try {
        const s = yield r;
        return this.setChildren(e, s, t, n);
      } catch (s) {
        if (e !== this.root && this.tree.hasElement(e) && this.tree.collapse(e), md(s))
          return [];
        throw s;
      } finally {
        e.slow && (e.slow = !1, this._onDidChangeNodeSlowState.fire(e));
      }
    });
  }
  doGetChildren(e) {
    let t = this.refreshPromises.get(e);
    if (t)
      return t;
    const n = this.dataSource.getChildren(e.element);
    return UY(n) ? this.processChildren(n) : (t = Ir(() => yf(this, void 0, void 0, function* () {
      return this.processChildren(yield n);
    })), this.refreshPromises.set(e, t), t.finally(() => {
      this.refreshPromises.delete(e);
    }));
  }
  _onDidChangeCollapseState({ node: e, deep: t }) {
    e.element !== null && !e.collapsed && e.element.stale && (t ? this.collapse(e.element.element) : this.refreshAndRenderNode(e.element, !1).catch(It));
  }
  setChildren(e, t, n, r) {
    const s = [...t];
    if (e.children.length === 0 && s.length === 0)
      return [];
    const o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
    for (const d of e.children)
      if (o.set(d.element, d), this.identityProvider) {
        const u = this.tree.isCollapsed(d);
        a.set(d.id, { node: d, collapsed: u });
      }
    const l = [], c = s.map((d) => {
      const u = !!this.dataSource.hasChildren(d);
      if (!this.identityProvider) {
        const p = uT({ element: d, parent: e, hasChildren: u });
        return u && this.collapseByDefault && !this.collapseByDefault(d) && (p.collapsedByDefault = !1, l.push(p)), p;
      }
      const h = this.identityProvider.getId(d).toString(), f = a.get(h);
      if (f) {
        const p = f.node;
        return o.delete(p.element), this.nodes.delete(p.element), this.nodes.set(d, p), p.element = d, p.hasChildren = u, n ? f.collapsed ? (p.children.forEach((m) => BB(m, (_) => this.nodes.delete(_.element))), p.children.splice(0, p.children.length), p.stale = !0) : l.push(p) : u && this.collapseByDefault && !this.collapseByDefault(d) && (p.collapsedByDefault = !1, l.push(p)), p;
      }
      const g = uT({ element: d, parent: e, id: h, hasChildren: u });
      return r && r.viewState.focus && r.viewState.focus.indexOf(h) > -1 && r.focus.push(g), r && r.viewState.selection && r.viewState.selection.indexOf(h) > -1 && r.selection.push(g), r && r.viewState.expanded && r.viewState.expanded.indexOf(h) > -1 ? l.push(g) : u && this.collapseByDefault && !this.collapseByDefault(d) && (g.collapsedByDefault = !1, l.push(g)), g;
    });
    for (const d of o.values())
      BB(d, (u) => this.nodes.delete(u.element));
    for (const d of c)
      this.nodes.set(d.element, d);
    return e.children.splice(0, e.children.length, ...c), e !== this.root && this.autoExpandSingleChildren && c.length === 1 && l.length === 0 && (c[0].collapsedByDefault = !1, l.push(c[0])), l;
  }
  render(e, t, n) {
    const r = e.children.map((o) => this.asTreeElement(o, t)), s = n && Object.assign(Object.assign({}, n), { diffIdentityProvider: n.diffIdentityProvider && {
      getId(o) {
        return n.diffIdentityProvider.getId(o.element);
      }
    } });
    this.tree.setChildren(e === this.root ? null : e, r, s), e !== this.root && this.tree.setCollapsible(e, e.hasChildren), this._onDidRender.fire();
  }
  asTreeElement(e, t) {
    if (e.stale)
      return {
        element: e,
        collapsible: e.hasChildren,
        collapsed: !0
      };
    let n;
    return t && t.viewState.expanded && e.id && t.viewState.expanded.indexOf(e.id) > -1 ? n = !1 : n = e.collapsedByDefault, e.collapsedByDefault = void 0, {
      element: e,
      children: e.hasChildren ? Wt.map(e.children, (r) => this.asTreeElement(r, t)) : [],
      collapsible: e.hasChildren,
      collapsed: n
    };
  }
  processChildren(e) {
    return this.sorter && (e = [...e].sort(this.sorter.compare.bind(this.sorter))), e;
  }
  dispose() {
    this.disposables.dispose(), this.tree.dispose();
  }
}
class _U {
  get element() {
    return {
      elements: this.node.element.elements.map((e) => e.element),
      incompressible: this.node.element.incompressible
    };
  }
  get children() {
    return this.node.children.map((e) => new _U(e));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e) {
    this.node = e;
  }
}
class nGe {
  constructor(e, t, n, r) {
    this.renderer = e, this.nodeMapper = t, this.compressibleNodeMapperProvider = n, this.onDidChangeTwistieState = r, this.renderedNodes = /* @__PURE__ */ new Map(), this.disposables = [], this.templateId = e.templateId;
  }
  renderTemplate(e) {
    return { templateData: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, n, r) {
    this.renderer.renderElement(this.nodeMapper.map(e), t, n.templateData, r);
  }
  renderCompressedElements(e, t, n, r) {
    this.renderer.renderCompressedElements(this.compressibleNodeMapperProvider().map(e), t, n.templateData, r);
  }
  renderTwistie(e, t) {
    return e.slow ? (t.classList.add(...ft.asClassNameArray(We.treeItemLoading)), !0) : (t.classList.remove(...ft.asClassNameArray(We.treeItemLoading)), !1);
  }
  disposeElement(e, t, n, r) {
    var s, o;
    (o = (s = this.renderer).disposeElement) === null || o === void 0 || o.call(s, this.nodeMapper.map(e), t, n.templateData, r);
  }
  disposeCompressedElements(e, t, n, r) {
    var s, o;
    (o = (s = this.renderer).disposeCompressedElements) === null || o === void 0 || o.call(s, this.compressibleNodeMapperProvider().map(e), t, n.templateData, r);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  dispose() {
    this.renderedNodes.clear(), this.disposables = An(this.disposables);
  }
}
function iGe(i) {
  const e = i && Bpe(i);
  return e && Object.assign(Object.assign({}, e), { keyboardNavigationLabelProvider: e.keyboardNavigationLabelProvider && Object.assign(Object.assign({}, e.keyboardNavigationLabelProvider), { getCompressedNodeKeyboardNavigationLabel(t) {
    return i.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(t.map((n) => n.element));
  } }) });
}
class rGe extends Vpe {
  constructor(e, t, n, r, s, o, a = {}) {
    super(e, t, n, s, o, a), this.compressionDelegate = r, this.compressibleNodeMapper = new uU((l) => new _U(l)), this.filter = a.filter;
  }
  createTree(e, t, n, r, s) {
    const o = new fU(n), a = r.map((c) => new nGe(c, this.nodeMapper, () => this.compressibleNodeMapper, this._onDidChangeNodeSlowState.event)), l = iGe(s) || {};
    return new Fpe(e, t, o, a, l);
  }
  asTreeElement(e, t) {
    return Object.assign({ incompressible: this.compressionDelegate.isIncompressible(e.element) }, super.asTreeElement(e, t));
  }
  updateOptions(e = {}) {
    this.tree.updateOptions(e);
  }
  render(e, t) {
    if (!this.identityProvider)
      return super.render(e, t);
    const n = (h) => this.identityProvider.getId(h).toString(), r = (h) => {
      const f = /* @__PURE__ */ new Set();
      for (const g of h) {
        const p = this.tree.getCompressedTreeNode(g === this.root ? null : g);
        if (p.element)
          for (const m of p.element.elements)
            f.add(n(m.element));
      }
      return f;
    }, s = r(this.tree.getSelection()), o = r(this.tree.getFocus());
    super.render(e, t);
    const a = this.getSelection();
    let l = !1;
    const c = this.getFocus();
    let d = !1;
    const u = (h) => {
      const f = h.element;
      if (f)
        for (let g = 0; g < f.elements.length; g++) {
          const p = n(f.elements[g].element), m = f.elements[f.elements.length - 1].element;
          s.has(p) && a.indexOf(m) === -1 && (a.push(m), l = !0), o.has(p) && c.indexOf(m) === -1 && (c.push(m), d = !0);
        }
      h.children.forEach(u);
    };
    u(this.tree.getCompressedTreeNode(e === this.root ? null : e)), l && this.setSelection(a), d && this.setFocus(c);
  }
  // For compressed async data trees, `TreeVisibility.Recurse` doesn't currently work
  // and we have to filter everything beforehand
  // Related to #85193 and #85835
  processChildren(e) {
    return this.filter && (e = Wt.filter(e, (t) => {
      const n = this.filter.filter(
        t,
        1
        /* TreeVisibility.Visible */
      ), r = sGe(n);
      if (r === 2)
        throw new Error("Recursive tree visibility not supported in async data compressed trees");
      return r === 1;
    })), super.processChildren(e);
  }
}
function sGe(i) {
  return typeof i == "boolean" ? i ? 1 : 0 : hU(i) ? cw(i.visibility) : cw(i);
}
class oGe extends Ope {
  constructor(e, t, n, r, s, o = {}) {
    super(e, t, n, r, o), this.user = e, this.dataSource = s, this.identityProvider = o.identityProvider;
  }
  createModel(e, t, n) {
    return new gU(e, t, n);
  }
}
new Ke("isMac", sn, C("isMac", "Whether the operating system is macOS"));
new Ke("isLinux", $s, C("isLinux", "Whether the operating system is Linux"));
const H4 = new Ke("isWindows", Ls, C("isWindows", "Whether the operating system is Windows")), Hpe = new Ke("isWeb", sp, C("isWeb", "Whether the platform is a web browser"));
new Ke("isMacNative", sn && !sp, C("isMacNative", "Whether the operating system is macOS on a non-browser platform"));
new Ke("isIOS", od, C("isIOS", "Whether the operating system is iOS"));
new Ke("isMobile", T6e, C("isMobile", "Whether the platform is a mobile web browser"));
new Ke("isDevelopment", !1, !0);
new Ke("productQualityType", "", C("productQualityType", "Quality type of VS Code"));
const Wpe = "inputFocus";
new Ke(Wpe, !1, C("inputFocus", "Whether keyboard focus is inside an input box"));
var uf = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Zn = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Nl = Gt("listService");
class aGe {
  get lastFocusedList() {
    return this._lastFocusedWidget;
  }
  constructor() {
    this.disposables = new Ne(), this.lists = [], this._lastFocusedWidget = void 0, this._hasCreatedStyleController = !1;
  }
  setLastFocusedList(e) {
    var t, n;
    e !== this._lastFocusedWidget && ((t = this._lastFocusedWidget) === null || t === void 0 || t.getHTMLElement().classList.remove("last-focused"), this._lastFocusedWidget = e, (n = this._lastFocusedWidget) === null || n === void 0 || n.getHTMLElement().classList.add("last-focused"));
  }
  register(e, t) {
    if (this._hasCreatedStyleController || (this._hasCreatedStyleController = !0, new _pe(yl(), "").style(B0)), this.lists.some((r) => r.widget === e))
      throw new Error("Cannot register the same widget multiple times");
    const n = { widget: e, extraContextKeys: t };
    return this.lists.push(n), e.getHTMLElement() === document.activeElement && this.setLastFocusedList(e), Ql(e.onDidFocus(() => this.setLastFocusedList(e)), Ct(() => this.lists.splice(this.lists.indexOf(n), 1)), e.onDidDispose(() => {
      this.lists = this.lists.filter((r) => r !== n), this._lastFocusedWidget === e && this.setLastFocusedList(void 0);
    }));
  }
  dispose() {
    this.disposables.dispose();
  }
}
const hw = new Ke("listScrollAtBoundary", "none");
ke.or(hw.isEqualTo("top"), hw.isEqualTo("both"));
ke.or(hw.isEqualTo("bottom"), hw.isEqualTo("both"));
const jpe = new Ke("listFocus", !0), W4 = new Ke("listSupportsMultiselect", !0), zpe = ke.and(jpe, ke.not(Wpe)), bU = new Ke("listHasSelectionOrFocus", !1), CU = new Ke("listDoubleSelection", !1), yU = new Ke("listMultiSelection", !1), j4 = new Ke("listSelectionNavigation", !1), lGe = new Ke("listSupportsFind", !0), wU = new Ke("treeElementCanCollapse", !1), cGe = new Ke("treeElementHasParent", !1), SU = new Ke("treeElementCanExpand", !1), dGe = new Ke("treeElementHasChild", !1), uGe = new Ke("treeFindOpen", !1), Upe = "listTypeNavigationMode", Gpe = "listAutomaticKeyboardNavigation";
function z4(i, e) {
  const t = i.createScoped(e.getHTMLElement());
  return jpe.bindTo(t), t;
}
function U4(i, e) {
  const t = hw.bindTo(i), n = () => {
    const r = e.scrollTop === 0, s = e.scrollHeight - e.renderHeight - e.scrollTop < 1;
    r && s ? t.set("both") : r ? t.set("top") : s ? t.set("bottom") : t.set("none");
  };
  return n(), e.onDidScroll(n);
}
const V0 = "workbench.list.multiSelectModifier", tE = "workbench.list.openMode", pl = "workbench.list.horizontalScrolling", xU = "workbench.list.defaultFindMode", DU = "workbench.list.typeNavigationMode", ZL = "workbench.list.keyboardNavigation", cd = "workbench.list.scrollByPage", EU = "workbench.list.defaultFindMatchType", fw = "workbench.tree.indent", QL = "workbench.tree.renderIndentGuides", dd = "workbench.list.smoothScrolling", Eu = "workbench.list.mouseWheelScrollSensitivity", Lu = "workbench.list.fastScrollSensitivity", JL = "workbench.tree.expandMode";
function Iu(i) {
  return i.getValue(V0) === "alt";
}
class hGe extends we {
  constructor(e) {
    super(), this.configurationService = e, this.useAltAsMultipleSelectionModifier = Iu(e), this.registerListeners();
  }
  registerListeners() {
    this._register(this.configurationService.onDidChangeConfiguration((e) => {
      e.affectsConfiguration(V0) && (this.useAltAsMultipleSelectionModifier = Iu(this.configurationService));
    }));
  }
  isSelectionSingleChangeEvent(e) {
    return this.useAltAsMultipleSelectionModifier ? e.browserEvent.altKey : ppe(e);
  }
  isSelectionRangeChangeEvent(e) {
    return mpe(e);
  }
}
function G4(i, e) {
  var t;
  const n = i.get(en), r = i.get(Bn), s = new Ne();
  return [Object.assign(Object.assign({}, e), { keyboardNavigationDelegate: { mightProducePrintableCharacter(a) {
    return r.mightProducePrintableCharacter(a);
  } }, smoothScrolling: !!n.getValue(dd), mouseWheelScrollSensitivity: n.getValue(Eu), fastScrollSensitivity: n.getValue(Lu), multipleSelectionController: (t = e.multipleSelectionController) !== null && t !== void 0 ? t : s.add(new hGe(n)), keyboardNavigationEventFilter: pGe(r), scrollByPage: !!n.getValue(cd) }), s];
}
let VB = class extends pc {
  constructor(e, t, n, r, s, o, a, l, c) {
    const d = typeof s.horizontalScrolling < "u" ? s.horizontalScrolling : !!l.getValue(pl), [u, h] = c.invokeFunction(G4, s);
    super(e, t, n, r, Object.assign(Object.assign({ keyboardSupport: !1 }, u), { horizontalScrolling: d })), this.disposables.add(h), this.contextKeyService = z4(o, this), this.disposables.add(U4(this.contextKeyService, this)), this.listSupportsMultiSelect = W4.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(s.multipleSelectionSupport !== !1), j4.bindTo(this.contextKeyService).set(!!s.selectionNavigation), this.listHasSelectionOrFocus = bU.bindTo(this.contextKeyService), this.listDoubleSelection = CU.bindTo(this.contextKeyService), this.listMultiSelection = yU.bindTo(this.contextKeyService), this.horizontalScrolling = s.horizontalScrolling, this._useAltAsMultipleSelectionModifier = Iu(l), this.disposables.add(this.contextKeyService), this.disposables.add(a.register(this)), this.updateStyles(s.overrideStyles), this.disposables.add(this.onDidChangeSelection(() => {
      const g = this.getSelection(), p = this.getFocus();
      this.contextKeyService.bufferChangeEvents(() => {
        this.listHasSelectionOrFocus.set(g.length > 0 || p.length > 0), this.listMultiSelection.set(g.length > 1), this.listDoubleSelection.set(g.length === 2);
      });
    })), this.disposables.add(this.onDidChangeFocus(() => {
      const g = this.getSelection(), p = this.getFocus();
      this.listHasSelectionOrFocus.set(g.length > 0 || p.length > 0);
    })), this.disposables.add(l.onDidChangeConfiguration((g) => {
      g.affectsConfiguration(V0) && (this._useAltAsMultipleSelectionModifier = Iu(l));
      let p = {};
      if (g.affectsConfiguration(pl) && this.horizontalScrolling === void 0) {
        const m = !!l.getValue(pl);
        p = Object.assign(Object.assign({}, p), { horizontalScrolling: m });
      }
      if (g.affectsConfiguration(cd)) {
        const m = !!l.getValue(cd);
        p = Object.assign(Object.assign({}, p), { scrollByPage: m });
      }
      if (g.affectsConfiguration(dd)) {
        const m = !!l.getValue(dd);
        p = Object.assign(Object.assign({}, p), { smoothScrolling: m });
      }
      if (g.affectsConfiguration(Eu)) {
        const m = l.getValue(Eu);
        p = Object.assign(Object.assign({}, p), { mouseWheelScrollSensitivity: m });
      }
      if (g.affectsConfiguration(Lu)) {
        const m = l.getValue(Lu);
        p = Object.assign(Object.assign({}, p), { fastScrollSensitivity: m });
      }
      Object.keys(p).length > 0 && this.updateOptions(p);
    })), this.navigator = new qpe(this, Object.assign({ configurationService: l }, s)), this.disposables.add(this.navigator);
  }
  updateOptions(e) {
    super.updateOptions(e), e.overrideStyles !== void 0 && this.updateStyles(e.overrideStyles), e.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!e.multipleSelectionSupport);
  }
  updateStyles(e) {
    this.style(e ? Cb(e) : B0);
  }
};
VB = uf([
  Zn(5, yt),
  Zn(6, Nl),
  Zn(7, en),
  Zn(8, bt)
], VB);
let cJ = class extends vUe {
  constructor(e, t, n, r, s, o, a, l, c) {
    const d = typeof s.horizontalScrolling < "u" ? s.horizontalScrolling : !!l.getValue(pl), [u, h] = c.invokeFunction(G4, s);
    super(e, t, n, r, Object.assign(Object.assign({ keyboardSupport: !1 }, u), { horizontalScrolling: d })), this.disposables = new Ne(), this.disposables.add(h), this.contextKeyService = z4(o, this), this.disposables.add(U4(this.contextKeyService, this.widget)), this.horizontalScrolling = s.horizontalScrolling, this.listSupportsMultiSelect = W4.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(s.multipleSelectionSupport !== !1), j4.bindTo(this.contextKeyService).set(!!s.selectionNavigation), this._useAltAsMultipleSelectionModifier = Iu(l), this.disposables.add(this.contextKeyService), this.disposables.add(a.register(this)), this.updateStyles(s.overrideStyles), this.disposables.add(l.onDidChangeConfiguration((g) => {
      g.affectsConfiguration(V0) && (this._useAltAsMultipleSelectionModifier = Iu(l));
      let p = {};
      if (g.affectsConfiguration(pl) && this.horizontalScrolling === void 0) {
        const m = !!l.getValue(pl);
        p = Object.assign(Object.assign({}, p), { horizontalScrolling: m });
      }
      if (g.affectsConfiguration(cd)) {
        const m = !!l.getValue(cd);
        p = Object.assign(Object.assign({}, p), { scrollByPage: m });
      }
      if (g.affectsConfiguration(dd)) {
        const m = !!l.getValue(dd);
        p = Object.assign(Object.assign({}, p), { smoothScrolling: m });
      }
      if (g.affectsConfiguration(Eu)) {
        const m = l.getValue(Eu);
        p = Object.assign(Object.assign({}, p), { mouseWheelScrollSensitivity: m });
      }
      if (g.affectsConfiguration(Lu)) {
        const m = l.getValue(Lu);
        p = Object.assign(Object.assign({}, p), { fastScrollSensitivity: m });
      }
      Object.keys(p).length > 0 && this.updateOptions(p);
    })), this.navigator = new qpe(this, Object.assign({ configurationService: l }, s)), this.disposables.add(this.navigator);
  }
  updateOptions(e) {
    super.updateOptions(e), e.overrideStyles !== void 0 && this.updateStyles(e.overrideStyles), e.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!e.multipleSelectionSupport);
  }
  updateStyles(e) {
    this.style(e ? Cb(e) : B0);
  }
  dispose() {
    this.disposables.dispose(), super.dispose();
  }
};
cJ = uf([
  Zn(5, yt),
  Zn(6, Nl),
  Zn(7, en),
  Zn(8, bt)
], cJ);
let dJ = class extends V4 {
  constructor(e, t, n, r, s, o, a, l, c, d) {
    const u = typeof o.horizontalScrolling < "u" ? o.horizontalScrolling : !!c.getValue(pl), [h, f] = d.invokeFunction(G4, o);
    super(e, t, n, r, s, Object.assign(Object.assign({ keyboardSupport: !1 }, h), { horizontalScrolling: u })), this.disposables.add(f), this.contextKeyService = z4(a, this), this.disposables.add(U4(this.contextKeyService, this)), this.listSupportsMultiSelect = W4.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(o.multipleSelectionSupport !== !1), j4.bindTo(this.contextKeyService).set(!!o.selectionNavigation), this.listHasSelectionOrFocus = bU.bindTo(this.contextKeyService), this.listDoubleSelection = CU.bindTo(this.contextKeyService), this.listMultiSelection = yU.bindTo(this.contextKeyService), this.horizontalScrolling = o.horizontalScrolling, this._useAltAsMultipleSelectionModifier = Iu(c), this.disposables.add(this.contextKeyService), this.disposables.add(l.register(this)), this.updateStyles(o.overrideStyles), this.disposables.add(this.onDidChangeSelection(() => {
      const p = this.getSelection(), m = this.getFocus();
      this.contextKeyService.bufferChangeEvents(() => {
        this.listHasSelectionOrFocus.set(p.length > 0 || m.length > 0), this.listMultiSelection.set(p.length > 1), this.listDoubleSelection.set(p.length === 2);
      });
    })), this.disposables.add(this.onDidChangeFocus(() => {
      const p = this.getSelection(), m = this.getFocus();
      this.listHasSelectionOrFocus.set(p.length > 0 || m.length > 0);
    })), this.disposables.add(c.onDidChangeConfiguration((p) => {
      p.affectsConfiguration(V0) && (this._useAltAsMultipleSelectionModifier = Iu(c));
      let m = {};
      if (p.affectsConfiguration(pl) && this.horizontalScrolling === void 0) {
        const _ = !!c.getValue(pl);
        m = Object.assign(Object.assign({}, m), { horizontalScrolling: _ });
      }
      if (p.affectsConfiguration(cd)) {
        const _ = !!c.getValue(cd);
        m = Object.assign(Object.assign({}, m), { scrollByPage: _ });
      }
      if (p.affectsConfiguration(dd)) {
        const _ = !!c.getValue(dd);
        m = Object.assign(Object.assign({}, m), { smoothScrolling: _ });
      }
      if (p.affectsConfiguration(Eu)) {
        const _ = c.getValue(Eu);
        m = Object.assign(Object.assign({}, m), { mouseWheelScrollSensitivity: _ });
      }
      if (p.affectsConfiguration(Lu)) {
        const _ = c.getValue(Lu);
        m = Object.assign(Object.assign({}, m), { fastScrollSensitivity: _ });
      }
      Object.keys(m).length > 0 && this.updateOptions(m);
    })), this.navigator = new fGe(this, Object.assign({ configurationService: c }, o)), this.disposables.add(this.navigator);
  }
  updateOptions(e) {
    super.updateOptions(e), e.overrideStyles !== void 0 && this.updateStyles(e.overrideStyles), e.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!e.multipleSelectionSupport);
  }
  updateStyles(e) {
    this.style(e ? Cb(e) : B0);
  }
  dispose() {
    this.disposables.dispose(), super.dispose();
  }
};
dJ = uf([
  Zn(6, yt),
  Zn(7, Nl),
  Zn(8, en),
  Zn(9, bt)
], dJ);
class LU extends we {
  constructor(e, t) {
    var n;
    super(), this.widget = e, this._onDidOpen = this._register(new pe()), this.onDidOpen = this._onDidOpen.event, this._register(qe.filter(this.widget.onDidChangeSelection, (r) => r.browserEvent instanceof KeyboardEvent)((r) => this.onSelectionFromKeyboard(r))), this._register(this.widget.onPointer((r) => this.onPointer(r.element, r.browserEvent))), this._register(this.widget.onMouseDblClick((r) => this.onMouseDblClick(r.element, r.browserEvent))), typeof t?.openOnSingleClick != "boolean" && t?.configurationService ? (this.openOnSingleClick = t?.configurationService.getValue(tE) !== "doubleClick", this._register(t?.configurationService.onDidChangeConfiguration((r) => {
      r.affectsConfiguration(tE) && (this.openOnSingleClick = t?.configurationService.getValue(tE) !== "doubleClick");
    }))) : this.openOnSingleClick = (n = t?.openOnSingleClick) !== null && n !== void 0 ? n : !0;
  }
  onSelectionFromKeyboard(e) {
    if (e.elements.length !== 1)
      return;
    const t = e.browserEvent, n = typeof t.preserveFocus == "boolean" ? t.preserveFocus : !0, r = typeof t.pinned == "boolean" ? t.pinned : !n;
    this._open(this.getSelectedElement(), n, r, !1, e.browserEvent);
  }
  onPointer(e, t) {
    if (!this.openOnSingleClick || t.detail === 2)
      return;
    const r = t.button === 1, s = !0, o = r, a = t.ctrlKey || t.metaKey || t.altKey;
    this._open(e, s, o, a, t);
  }
  onMouseDblClick(e, t) {
    if (!t)
      return;
    const n = t.target;
    if (n.classList.contains("monaco-tl-twistie") || n.classList.contains("monaco-icon-label") && n.classList.contains("folder-icon") && t.offsetX < 16)
      return;
    const s = !1, o = !0, a = t.ctrlKey || t.metaKey || t.altKey;
    this._open(e, s, o, a, t);
  }
  _open(e, t, n, r, s) {
    e && this._onDidOpen.fire({
      editorOptions: {
        preserveFocus: t,
        pinned: n,
        revealIfVisible: !0
      },
      sideBySide: r,
      element: e,
      browserEvent: s
    });
  }
}
class qpe extends LU {
  constructor(e, t) {
    super(e, t), this.widget = e;
  }
  getSelectedElement() {
    return this.widget.getSelectedElements()[0];
  }
}
class fGe extends LU {
  constructor(e, t) {
    super(e, t);
  }
  getSelectedElement() {
    return this.widget.getSelectedElements()[0];
  }
}
class gGe extends LU {
  constructor(e, t) {
    super(e, t);
  }
  getSelectedElement() {
    var e;
    return (e = this.widget.getSelection()[0]) !== null && e !== void 0 ? e : void 0;
  }
}
function pGe(i) {
  let e = !1;
  return (t) => {
    if (t.toKeyCodeChord().isModifierKey())
      return !1;
    if (e)
      return e = !1, !1;
    const n = i.softDispatch(t, t.target);
    return n.kind === 1 ? (e = !0, !1) : (e = !1, n.kind === 0);
  };
}
let uJ = class extends mU {
  constructor(e, t, n, r, s, o, a, l, c) {
    const { options: d, getTypeNavigationMode: u, disposable: h } = o.invokeFunction(WS, s);
    super(e, t, n, r, d), this.disposables.add(h), this.internals = new t0(this, s, u, s.overrideStyles, a, l, c), this.disposables.add(this.internals);
  }
  updateOptions(e) {
    super.updateOptions(e), this.internals.updateOptions(e);
  }
};
uJ = uf([
  Zn(5, bt),
  Zn(6, yt),
  Zn(7, Nl),
  Zn(8, en)
], uJ);
let hJ = class extends Fpe {
  constructor(e, t, n, r, s, o, a, l, c) {
    const { options: d, getTypeNavigationMode: u, disposable: h } = o.invokeFunction(WS, s);
    super(e, t, n, r, d), this.disposables.add(h), this.internals = new t0(this, s, u, s.overrideStyles, a, l, c), this.disposables.add(this.internals);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), e.overrideStyles && this.internals.updateStyleOverrides(e.overrideStyles), this.internals.updateOptions(e);
  }
};
hJ = uf([
  Zn(5, bt),
  Zn(6, yt),
  Zn(7, Nl),
  Zn(8, en)
], hJ);
let fJ = class extends oGe {
  constructor(e, t, n, r, s, o, a, l, c, d) {
    const { options: u, getTypeNavigationMode: h, disposable: f } = a.invokeFunction(WS, o);
    super(e, t, n, r, s, u), this.disposables.add(f), this.internals = new t0(this, o, h, o.overrideStyles, l, c, d), this.disposables.add(this.internals);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), e.overrideStyles !== void 0 && this.internals.updateStyleOverrides(e.overrideStyles), this.internals.updateOptions(e);
  }
};
fJ = uf([
  Zn(6, bt),
  Zn(7, yt),
  Zn(8, Nl),
  Zn(9, en)
], fJ);
let HB = class extends Vpe {
  get onDidOpen() {
    return this.internals.onDidOpen;
  }
  constructor(e, t, n, r, s, o, a, l, c, d) {
    const { options: u, getTypeNavigationMode: h, disposable: f } = a.invokeFunction(WS, o);
    super(e, t, n, r, s, u), this.disposables.add(f), this.internals = new t0(this, o, h, o.overrideStyles, l, c, d), this.disposables.add(this.internals);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), e.overrideStyles && this.internals.updateStyleOverrides(e.overrideStyles), this.internals.updateOptions(e);
  }
};
HB = uf([
  Zn(6, bt),
  Zn(7, yt),
  Zn(8, Nl),
  Zn(9, en)
], HB);
let gJ = class extends rGe {
  constructor(e, t, n, r, s, o, a, l, c, d, u) {
    const { options: h, getTypeNavigationMode: f, disposable: g } = l.invokeFunction(WS, a);
    super(e, t, n, r, s, o, h), this.disposables.add(g), this.internals = new t0(this, a, f, a.overrideStyles, c, d, u), this.disposables.add(this.internals);
  }
  updateOptions(e) {
    super.updateOptions(e), this.internals.updateOptions(e);
  }
};
gJ = uf([
  Zn(7, bt),
  Zn(8, yt),
  Zn(9, Nl),
  Zn(10, en)
], gJ);
function Kpe(i) {
  const e = i.getValue(xU);
  if (e === "highlight")
    return ru.Highlight;
  if (e === "filter")
    return ru.Filter;
  const t = i.getValue(ZL);
  if (t === "simple" || t === "highlight")
    return ru.Highlight;
  if (t === "filter")
    return ru.Filter;
}
function Ype(i) {
  const e = i.getValue(EU);
  if (e === "fuzzy")
    return e0.Fuzzy;
  if (e === "contiguous")
    return e0.Contiguous;
}
function WS(i, e) {
  var t;
  const n = i.get(en), r = i.get(cf), s = i.get(yt), o = i.get(bt), a = () => {
    const f = s.getContextKeyValue(Upe);
    if (f === "automatic")
      return qd.Automatic;
    if (f === "trigger" || s.getContextKeyValue(Gpe) === !1)
      return qd.Trigger;
    const p = n.getValue(DU);
    if (p === "automatic")
      return qd.Automatic;
    if (p === "trigger")
      return qd.Trigger;
  }, l = e.horizontalScrolling !== void 0 ? e.horizontalScrolling : !!n.getValue(pl), [c, d] = o.invokeFunction(G4, e), u = e.paddingBottom, h = e.renderIndentGuides !== void 0 ? e.renderIndentGuides : n.getValue(QL);
  return {
    getTypeNavigationMode: a,
    disposable: d,
    options: Object.assign(Object.assign({
      // ...options, // TODO@Joao why is this not splatted here?
      keyboardSupport: !1
    }, c), { indent: typeof n.getValue(fw) == "number" ? n.getValue(fw) : void 0, renderIndentGuides: h, smoothScrolling: !!n.getValue(dd), defaultFindMode: Kpe(n), defaultFindMatchType: Ype(n), horizontalScrolling: l, scrollByPage: !!n.getValue(cd), paddingBottom: u, hideTwistiesOfChildlessElements: e.hideTwistiesOfChildlessElements, expandOnlyOnTwistieClick: (t = e.expandOnlyOnTwistieClick) !== null && t !== void 0 ? t : n.getValue(JL) === "doubleClick", contextViewProvider: r, findWidgetStyles: Zze })
  };
}
let t0 = class {
  get onDidOpen() {
    return this.navigator.onDidOpen;
  }
  constructor(e, t, n, r, s, o, a) {
    var l;
    this.tree = e, this.disposables = [], this.contextKeyService = z4(s, e), this.disposables.push(U4(this.contextKeyService, e)), this.listSupportsMultiSelect = W4.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(t.multipleSelectionSupport !== !1), j4.bindTo(this.contextKeyService).set(!!t.selectionNavigation), this.listSupportFindWidget = lGe.bindTo(this.contextKeyService), this.listSupportFindWidget.set((l = t.findWidgetEnabled) !== null && l !== void 0 ? l : !0), this.hasSelectionOrFocus = bU.bindTo(this.contextKeyService), this.hasDoubleSelection = CU.bindTo(this.contextKeyService), this.hasMultiSelection = yU.bindTo(this.contextKeyService), this.treeElementCanCollapse = wU.bindTo(this.contextKeyService), this.treeElementHasParent = cGe.bindTo(this.contextKeyService), this.treeElementCanExpand = SU.bindTo(this.contextKeyService), this.treeElementHasChild = dGe.bindTo(this.contextKeyService), this.treeFindOpen = uGe.bindTo(this.contextKeyService), this._useAltAsMultipleSelectionModifier = Iu(a), this.updateStyleOverrides(r);
    const d = () => {
      const h = e.getFocus()[0];
      if (!h)
        return;
      const f = e.getNode(h);
      this.treeElementCanCollapse.set(f.collapsible && !f.collapsed), this.treeElementHasParent.set(!!e.getParentElement(h)), this.treeElementCanExpand.set(f.collapsible && f.collapsed), this.treeElementHasChild.set(!!e.getFirstElementChild(h));
    }, u = /* @__PURE__ */ new Set();
    u.add(Upe), u.add(Gpe), this.disposables.push(this.contextKeyService, o.register(e), e.onDidChangeSelection(() => {
      const h = e.getSelection(), f = e.getFocus();
      this.contextKeyService.bufferChangeEvents(() => {
        this.hasSelectionOrFocus.set(h.length > 0 || f.length > 0), this.hasMultiSelection.set(h.length > 1), this.hasDoubleSelection.set(h.length === 2);
      });
    }), e.onDidChangeFocus(() => {
      const h = e.getSelection(), f = e.getFocus();
      this.hasSelectionOrFocus.set(h.length > 0 || f.length > 0), d();
    }), e.onDidChangeCollapseState(d), e.onDidChangeModel(d), e.onDidChangeFindOpenState((h) => this.treeFindOpen.set(h)), a.onDidChangeConfiguration((h) => {
      let f = {};
      if (h.affectsConfiguration(V0) && (this._useAltAsMultipleSelectionModifier = Iu(a)), h.affectsConfiguration(fw)) {
        const g = a.getValue(fw);
        f = Object.assign(Object.assign({}, f), { indent: g });
      }
      if (h.affectsConfiguration(QL) && t.renderIndentGuides === void 0) {
        const g = a.getValue(QL);
        f = Object.assign(Object.assign({}, f), { renderIndentGuides: g });
      }
      if (h.affectsConfiguration(dd)) {
        const g = !!a.getValue(dd);
        f = Object.assign(Object.assign({}, f), { smoothScrolling: g });
      }
      if (h.affectsConfiguration(xU) || h.affectsConfiguration(ZL)) {
        const g = Kpe(a);
        f = Object.assign(Object.assign({}, f), { defaultFindMode: g });
      }
      if (h.affectsConfiguration(DU) || h.affectsConfiguration(ZL)) {
        const g = n();
        f = Object.assign(Object.assign({}, f), { typeNavigationMode: g });
      }
      if (h.affectsConfiguration(EU)) {
        const g = Ype(a);
        f = Object.assign(Object.assign({}, f), { defaultFindMatchType: g });
      }
      if (h.affectsConfiguration(pl) && t.horizontalScrolling === void 0) {
        const g = !!a.getValue(pl);
        f = Object.assign(Object.assign({}, f), { horizontalScrolling: g });
      }
      if (h.affectsConfiguration(cd)) {
        const g = !!a.getValue(cd);
        f = Object.assign(Object.assign({}, f), { scrollByPage: g });
      }
      if (h.affectsConfiguration(JL) && t.expandOnlyOnTwistieClick === void 0 && (f = Object.assign(Object.assign({}, f), { expandOnlyOnTwistieClick: a.getValue(JL) === "doubleClick" })), h.affectsConfiguration(Eu)) {
        const g = a.getValue(Eu);
        f = Object.assign(Object.assign({}, f), { mouseWheelScrollSensitivity: g });
      }
      if (h.affectsConfiguration(Lu)) {
        const g = a.getValue(Lu);
        f = Object.assign(Object.assign({}, f), { fastScrollSensitivity: g });
      }
      Object.keys(f).length > 0 && e.updateOptions(f);
    }), this.contextKeyService.onDidChangeContext((h) => {
      h.affectsSome(u) && e.updateOptions({ typeNavigationMode: n() });
    })), this.navigator = new gGe(e, Object.assign({ configurationService: a }, t)), this.disposables.push(this.navigator);
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!e.multipleSelectionSupport);
  }
  updateStyleOverrides(e) {
    this.tree.style(e ? Cb(e) : B0);
  }
  dispose() {
    this.disposables = An(this.disposables);
  }
};
t0 = uf([
  Zn(4, yt),
  Zn(5, Nl),
  Zn(6, en)
], t0);
const mGe = Di.as(_d.Configuration);
mGe.registerConfiguration({
  id: "workbench",
  order: 7,
  title: C("workbenchConfigurationTitle", "Workbench"),
  type: "object",
  properties: {
    [V0]: {
      type: "string",
      enum: ["ctrlCmd", "alt"],
      markdownEnumDescriptions: [
        C("multiSelectModifier.ctrlCmd", "Maps to `Control` on Windows and Linux and to `Command` on macOS."),
        C("multiSelectModifier.alt", "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")
      ],
      default: "ctrlCmd",
      description: C({
        key: "multiSelectModifier",
        comment: [
          "- `ctrlCmd` refers to a value the setting can take and should not be localized.",
          "- `Control` and `Command` refer to the modifier keys Ctrl or Cmd on the keyboard and can be localized."
        ]
      }, "The modifier to be used to add an item in trees and lists to a multi-selection with the mouse (for example in the explorer, open editors and scm view). The 'Open to Side' mouse gestures - if supported - will adapt such that they do not conflict with the multiselect modifier.")
    },
    [tE]: {
      type: "string",
      enum: ["singleClick", "doubleClick"],
      default: "singleClick",
      description: C({
        key: "openModeModifier",
        comment: ["`singleClick` and `doubleClick` refers to a value the setting can take and should not be localized."]
      }, "Controls how to open items in trees and lists using the mouse (if supported). Note that some trees and lists might choose to ignore this setting if it is not applicable.")
    },
    [pl]: {
      type: "boolean",
      default: !1,
      description: C("horizontalScrolling setting", "Controls whether lists and trees support horizontal scrolling in the workbench. Warning: turning on this setting has a performance implication.")
    },
    [cd]: {
      type: "boolean",
      default: !1,
      description: C("list.scrollByPage", "Controls whether clicks in the scrollbar scroll page by page.")
    },
    [fw]: {
      type: "number",
      default: 8,
      minimum: 4,
      maximum: 40,
      description: C("tree indent setting", "Controls tree indentation in pixels.")
    },
    [QL]: {
      type: "string",
      enum: ["none", "onHover", "always"],
      default: "onHover",
      description: C("render tree indent guides", "Controls whether the tree should render indent guides.")
    },
    [dd]: {
      type: "boolean",
      default: !1,
      description: C("list smoothScrolling setting", "Controls whether lists and trees have smooth scrolling.")
    },
    [Eu]: {
      type: "number",
      default: 1,
      markdownDescription: C("Mouse Wheel Scroll Sensitivity", "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.")
    },
    [Lu]: {
      type: "number",
      default: 5,
      markdownDescription: C("Fast Scroll Sensitivity", "Scrolling speed multiplier when pressing `Alt`.")
    },
    [xU]: {
      type: "string",
      enum: ["highlight", "filter"],
      enumDescriptions: [
        C("defaultFindModeSettingKey.highlight", "Highlight elements when searching. Further up and down navigation will traverse only the highlighted elements."),
        C("defaultFindModeSettingKey.filter", "Filter elements when searching.")
      ],
      default: "highlight",
      description: C("defaultFindModeSettingKey", "Controls the default find mode for lists and trees in the workbench.")
    },
    [ZL]: {
      type: "string",
      enum: ["simple", "highlight", "filter"],
      enumDescriptions: [
        C("keyboardNavigationSettingKey.simple", "Simple keyboard navigation focuses elements which match the keyboard input. Matching is done only on prefixes."),
        C("keyboardNavigationSettingKey.highlight", "Highlight keyboard navigation highlights elements which match the keyboard input. Further up and down navigation will traverse only the highlighted elements."),
        C("keyboardNavigationSettingKey.filter", "Filter keyboard navigation will filter out and hide all the elements which do not match the keyboard input.")
      ],
      default: "highlight",
      description: C("keyboardNavigationSettingKey", "Controls the keyboard navigation style for lists and trees in the workbench. Can be simple, highlight and filter."),
      deprecated: !0,
      deprecationMessage: C("keyboardNavigationSettingKeyDeprecated", "Please use 'workbench.list.defaultFindMode' and	'workbench.list.typeNavigationMode' instead.")
    },
    [EU]: {
      type: "string",
      enum: ["fuzzy", "contiguous"],
      enumDescriptions: [
        C("defaultFindMatchTypeSettingKey.fuzzy", "Use fuzzy matching when searching."),
        C("defaultFindMatchTypeSettingKey.contiguous", "Use contiguous matching when searching.")
      ],
      default: "fuzzy",
      description: C("defaultFindMatchTypeSettingKey", "Controls the type of matching used when searching lists and trees in the workbench.")
    },
    [JL]: {
      type: "string",
      enum: ["singleClick", "doubleClick"],
      default: "singleClick",
      description: C("expand mode", "Controls how tree folders are expanded when clicking the folder names. Note that some trees and lists might choose to ignore this setting if it is not applicable.")
    },
    [DU]: {
      type: "string",
      enum: ["automatic", "trigger"],
      default: "automatic",
      markdownDescription: C("typeNavigationMode2", "Controls how type navigation works in lists and trees in the workbench. When set to `trigger`, type navigation begins once the `list.triggerTypeNavigation` command is run.")
    }
  }
});
var WB;
(function(i) {
  i[i.PRESERVE = 0] = "PRESERVE", i[i.LAST = 1] = "LAST";
})(WB || (WB = {}));
const H0 = {
  Quickaccess: "workbench.contributions.quickaccess"
};
class vGe {
  constructor() {
    this.providers = [], this.defaultProvider = void 0;
  }
  registerQuickAccessProvider(e) {
    return e.prefix.length === 0 ? this.defaultProvider = e : this.providers.push(e), this.providers.sort((t, n) => n.prefix.length - t.prefix.length), Ct(() => {
      this.providers.splice(this.providers.indexOf(e), 1), this.defaultProvider === e && (this.defaultProvider = void 0);
    });
  }
  getQuickAccessProviders() {
    return _u([this.defaultProvider, ...this.providers]);
  }
  getQuickAccessProvider(e) {
    return e && this.providers.find((n) => e.startsWith(n.prefix)) || void 0 || this.defaultProvider;
  }
}
Di.add(H0.Quickaccess, new vGe());
const _Ge = { ctrlCmd: !1, alt: !1 };
var gw;
(function(i) {
  i[i.Blur = 1] = "Blur", i[i.Gesture = 2] = "Gesture", i[i.Other = 3] = "Other";
})(gw || (gw = {}));
var kc;
(function(i) {
  i[i.NONE = 0] = "NONE", i[i.FIRST = 1] = "FIRST", i[i.SECOND = 2] = "SECOND", i[i.LAST = 3] = "LAST";
})(kc || (kc = {}));
const bd = Gt("quickInputService");
var bGe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, pJ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let jB = class extends we {
  constructor(e, t) {
    super(), this.quickInputService = e, this.instantiationService = t, this.registry = Di.as(H0.Quickaccess), this.mapProviderToDescriptor = /* @__PURE__ */ new Map(), this.lastAcceptedPickerValues = /* @__PURE__ */ new Map(), this.visibleQuickAccess = void 0;
  }
  show(e = "", t) {
    this.doShowOrPick(e, !1, t);
  }
  doShowOrPick(e, t, n) {
    var r;
    const [s, o] = this.getOrInstantiateProvider(e), a = this.visibleQuickAccess, l = a?.descriptor;
    if (a && o && l === o) {
      e !== o.prefix && !n?.preserveValue && (a.picker.value = e), this.adjustValueSelection(a.picker, o, n);
      return;
    }
    if (o && !n?.preserveValue) {
      let f;
      if (a && l && l !== o) {
        const g = a.value.substr(l.prefix.length);
        g && (f = `${o.prefix}${g}`);
      }
      if (!f) {
        const g = s?.defaultFilterValue;
        g === WB.LAST ? f = this.lastAcceptedPickerValues.get(o) : typeof g == "string" && (f = `${o.prefix}${g}`);
      }
      typeof f == "string" && (e = f);
    }
    const c = new Ne(), d = c.add(this.quickInputService.createQuickPick());
    d.value = e, this.adjustValueSelection(d, o, n), d.placeholder = o?.placeholder, d.quickNavigate = n?.quickNavigateConfiguration, d.hideInput = !!d.quickNavigate && !a, (typeof n?.itemActivation == "number" || n?.quickNavigateConfiguration) && (d.itemActivation = (r = n?.itemActivation) !== null && r !== void 0 ? r : kc.SECOND), d.contextKey = o?.contextKey, d.filterValue = (f) => f.substring(o ? o.prefix.length : 0);
    let u;
    t && (u = new r4(), c.add(qe.once(d.onWillAccept)((f) => {
      f.veto(), d.hide();
    }))), c.add(this.registerPickerListeners(d, s, o, e, n?.providerOptions));
    const h = c.add(new lr());
    if (s && c.add(s.provide(d, h.token, n?.providerOptions)), qe.once(d.onDidHide)(() => {
      d.selectedItems.length === 0 && h.cancel(), c.dispose(), u?.complete(d.selectedItems.slice(0));
    }), d.show(), t)
      return u?.p;
  }
  adjustValueSelection(e, t, n) {
    var r;
    let s;
    n?.preserveValue ? s = [e.value.length, e.value.length] : s = [(r = t?.prefix.length) !== null && r !== void 0 ? r : 0, e.value.length], e.valueSelection = s;
  }
  registerPickerListeners(e, t, n, r, s) {
    const o = new Ne(), a = this.visibleQuickAccess = { picker: e, descriptor: n, value: r };
    return o.add(Ct(() => {
      a === this.visibleQuickAccess && (this.visibleQuickAccess = void 0);
    })), o.add(e.onDidChangeValue((l) => {
      const [c] = this.getOrInstantiateProvider(l);
      c !== t ? this.show(l, {
        // do not rewrite value from user typing!
        preserveValue: !0,
        // persist the value of the providerOptions from the original showing
        providerOptions: s
      }) : a.value = l;
    })), n && o.add(e.onDidAccept(() => {
      this.lastAcceptedPickerValues.set(n, e.value);
    })), o;
  }
  getOrInstantiateProvider(e) {
    const t = this.registry.getQuickAccessProvider(e);
    if (!t)
      return [void 0, void 0];
    let n = this.mapProviderToDescriptor.get(t);
    return n || (n = this.instantiationService.createInstance(t.ctor), this.mapProviderToDescriptor.set(t, n)), [n, t];
  }
};
jB = bGe([
  pJ(0, bd),
  pJ(1, bt)
], jB);
ye.white.toString(), ye.white.toString();
let zB = class extends we {
  get onDidClick() {
    return this._onDidClick.event;
  }
  constructor(e, t) {
    super(), this._label = "", this._onDidClick = this._register(new pe()), this.options = t, this._element = document.createElement("a"), this._element.classList.add("monaco-button"), this._element.tabIndex = 0, this._element.setAttribute("role", "button"), this._element.classList.toggle("secondary", !!t.secondary);
    const n = t.secondary ? t.buttonSecondaryBackground : t.buttonBackground, r = t.secondary ? t.buttonSecondaryForeground : t.buttonForeground;
    this._element.style.color = r || "", this._element.style.backgroundColor = n || "", t.supportShortLabel && (this._labelShortElement = document.createElement("div"), this._labelShortElement.classList.add("monaco-button-label-short"), this._element.appendChild(this._labelShortElement), this._labelElement = document.createElement("div"), this._labelElement.classList.add("monaco-button-label"), this._element.appendChild(this._labelElement), this._element.classList.add("monaco-text-button-with-short-label")), e.appendChild(this._element), this._register(Vn.addTarget(this._element)), [Ge.CLICK, Wn.Tap].forEach((s) => {
      this._register(Ie(this._element, s, (o) => {
        if (!this.enabled) {
          Tt.stop(o);
          return;
        }
        this._onDidClick.fire(o);
      }));
    }), this._register(Ie(this._element, Ge.KEY_DOWN, (s) => {
      const o = new Xn(s);
      let a = !1;
      this.enabled && (o.equals(
        3
        /* KeyCode.Enter */
      ) || o.equals(
        10
        /* KeyCode.Space */
      )) ? (this._onDidClick.fire(s), a = !0) : o.equals(
        9
        /* KeyCode.Escape */
      ) && (this._element.blur(), a = !0), a && Tt.stop(o, !0);
    })), this._register(Ie(this._element, Ge.MOUSE_OVER, (s) => {
      this._element.classList.contains("disabled") || this.updateBackground(!0);
    })), this._register(Ie(this._element, Ge.MOUSE_OUT, (s) => {
      this.updateBackground(!1);
    })), this.focusTracker = this._register(yu(this._element)), this._register(this.focusTracker.onDidFocus(() => {
      this.enabled && this.updateBackground(!0);
    })), this._register(this.focusTracker.onDidBlur(() => {
      this.enabled && this.updateBackground(!1);
    }));
  }
  dispose() {
    super.dispose(), this._element.remove();
  }
  getContentElements(e) {
    const t = [];
    for (let n of bg(e))
      if (typeof n == "string") {
        if (n = n.trim(), n === "")
          continue;
        const r = document.createElement("span");
        r.textContent = n, t.push(r);
      } else
        t.push(n);
    return t;
  }
  updateBackground(e) {
    let t;
    this.options.secondary ? t = e ? this.options.buttonSecondaryHoverBackground : this.options.buttonSecondaryBackground : t = e ? this.options.buttonHoverBackground : this.options.buttonBackground, t && (this._element.style.backgroundColor = t);
  }
  get element() {
    return this._element;
  }
  set label(e) {
    var t;
    if (this._label === e || _g(this._label) && _g(e) && Vje(this._label, e))
      return;
    this._element.classList.add("monaco-text-button");
    const n = this.options.supportShortLabel ? this._labelElement : this._element;
    if (_g(e)) {
      const r = M4(e, { inline: !0 });
      r.dispose();
      const s = (t = r.element.querySelector("p")) === null || t === void 0 ? void 0 : t.innerHTML;
      if (s) {
        const o = The(s, { ADD_TAGS: ["b", "i", "u", "code", "span"], ALLOWED_ATTR: ["class"], RETURN_TRUSTED_TYPE: !0 });
        n.innerHTML = o;
      } else
        cs(n);
    } else
      this.options.supportIcons ? cs(n, ...this.getContentElements(e)) : n.textContent = e;
    typeof this.options.title == "string" ? this._element.title = this.options.title : this.options.title && (this._element.title = eze(e)), this._label = e;
  }
  get label() {
    return this._label;
  }
  set enabled(e) {
    e ? (this._element.classList.remove("disabled"), this._element.setAttribute("aria-disabled", String(!1)), this._element.tabIndex = 0) : (this._element.classList.add("disabled"), this._element.setAttribute("aria-disabled", String(!0)));
  }
  get enabled() {
    return !this._element.classList.contains("disabled");
  }
};
class UB {
  constructor(e, t, n) {
    this.options = t, this.styles = n, this.count = 0, this.element = Te(e, Re(".monaco-count-badge")), this.countFormat = this.options.countFormat || "{0}", this.titleFormat = this.options.titleFormat || "", this.setCount(this.options.count || 0);
  }
  setCount(e) {
    this.count = e, this.render();
  }
  setTitleFormat(e) {
    this.titleFormat = e, this.render();
  }
  render() {
    var e, t;
    this.element.textContent = zm(this.countFormat, this.count), this.element.title = zm(this.titleFormat, this.count), this.element.style.backgroundColor = (e = this.styles.badgeBackground) !== null && e !== void 0 ? e : "", this.element.style.color = (t = this.styles.badgeForeground) !== null && t !== void 0 ? t : "", this.styles.badgeBorder && (this.element.style.border = `1px solid ${this.styles.badgeBorder}`);
  }
}
const mJ = "done", vJ = "active", fT = "infinite", gT = "infinite-long-running", _J = "discrete";
class q4 extends we {
  constructor(e, t) {
    super(), this.workedVal = 0, this.showDelayedScheduler = this._register(new Rn(() => Zo(this.element), 0)), this.longRunningScheduler = this._register(new Rn(() => this.infiniteLongRunning(), q4.LONG_RUNNING_INFINITE_THRESHOLD)), this.create(e, t);
  }
  create(e, t) {
    this.element = document.createElement("div"), this.element.classList.add("monaco-progress-container"), this.element.setAttribute("role", "progressbar"), this.element.setAttribute("aria-valuemin", "0"), e.appendChild(this.element), this.bit = document.createElement("div"), this.bit.classList.add("progress-bit"), this.bit.style.backgroundColor = t?.progressBarBackground || "#0E70C0", this.element.appendChild(this.bit);
  }
  off() {
    this.bit.style.width = "inherit", this.bit.style.opacity = "1", this.element.classList.remove(vJ, fT, gT, _J), this.workedVal = 0, this.totalWork = void 0, this.longRunningScheduler.cancel();
  }
  /**
   * Stops the progressbar from showing any progress instantly without fading out.
   */
  stop() {
    return this.doDone(!1);
  }
  doDone(e) {
    return this.element.classList.add(mJ), this.element.classList.contains(fT) ? (this.bit.style.opacity = "0", e ? setTimeout(() => this.off(), 200) : this.off()) : (this.bit.style.width = "inherit", e ? setTimeout(() => this.off(), 200) : this.off()), this;
  }
  /**
   * Use this mode to indicate progress that has no total number of work units.
   */
  infinite() {
    return this.bit.style.width = "2%", this.bit.style.opacity = "1", this.element.classList.remove(_J, mJ, gT), this.element.classList.add(vJ, fT), this.longRunningScheduler.schedule(), this;
  }
  infiniteLongRunning() {
    this.element.classList.add(gT);
  }
  getContainer() {
    return this.element;
  }
}
q4.LONG_RUNNING_INFINITE_THRESHOLD = 1e4;
const CGe = Re;
class yGe extends we {
  constructor(e, t, n) {
    super(), this.parent = e, this.onKeyDown = (s) => Ie(this.findInput.inputBox.inputElement, Ge.KEY_DOWN, (o) => {
      s(new Xn(o));
    }), this.onMouseDown = (s) => Ie(this.findInput.inputBox.inputElement, Ge.MOUSE_DOWN, (o) => {
      s(new cl(o));
    }), this.onDidChange = (s) => this.findInput.onDidChange(s), this.container = Te(this.parent, CGe(".quick-input-box")), this.findInput = this._register(new Ppe(this.container, void 0, { label: "", inputBoxStyles: t, toggleStyles: n }));
    const r = this.findInput.inputBox.inputElement;
    r.role = "combobox", r.ariaHasPopup = "menu", r.ariaAutoComplete = "list", r.ariaExpanded = "true";
  }
  get value() {
    return this.findInput.getValue();
  }
  set value(e) {
    this.findInput.setValue(e);
  }
  select(e = null) {
    this.findInput.inputBox.select(e);
  }
  isSelectionAtEnd() {
    return this.findInput.inputBox.isSelectionAtEnd();
  }
  get placeholder() {
    return this.findInput.inputBox.inputElement.getAttribute("placeholder") || "";
  }
  set placeholder(e) {
    this.findInput.inputBox.setPlaceHolder(e);
  }
  get password() {
    return this.findInput.inputBox.inputElement.type === "password";
  }
  set password(e) {
    this.findInput.inputBox.inputElement.type = e ? "password" : "text";
  }
  set enabled(e) {
    this.findInput.inputBox.inputElement.toggleAttribute("readonly", !e);
  }
  set toggles(e) {
    this.findInput.setAdditionalToggles(e);
  }
  setAttribute(e, t) {
    this.findInput.inputBox.inputElement.setAttribute(e, t);
  }
  showDecoration(e) {
    e === Yi.Ignore ? this.findInput.clearMessage() : this.findInput.showMessage({ type: e === Yi.Info ? 1 : e === Yi.Warning ? 2 : 3, content: "" });
  }
  stylesForType(e) {
    return this.findInput.inputBox.stylesForType(
      e === Yi.Info ? 1 : e === Yi.Warning ? 2 : 3
      /* MessageType.ERROR */
    );
  }
  setFocus() {
    this.findInput.focus();
  }
  layout() {
    this.findInput.inputBox.layout();
  }
}
class yg {
  /**
   * Create a new {@link HighlightedLabel}.
   *
   * @param container The parent container to append to.
   */
  constructor(e, t) {
    var n;
    this.text = "", this.title = "", this.highlights = [], this.didEverRender = !1, this.supportIcons = (n = t?.supportIcons) !== null && n !== void 0 ? n : !1, this.domNode = Te(e, Re("span.monaco-highlighted-label"));
  }
  /**
   * The label's DOM node.
   */
  get element() {
    return this.domNode;
  }
  /**
   * Set the label and highlights.
   *
   * @param text The label to display.
   * @param highlights The ranges to highlight.
   * @param title An optional title for the hover tooltip.
   * @param escapeNewLines Whether to escape new lines.
   * @returns
   */
  set(e, t = [], n = "", r) {
    e || (e = ""), r && (e = yg.escapeNewLines(e, t)), !(this.didEverRender && this.text === e && this.title === n && Ra(this.highlights, t)) && (this.text = e, this.title = n, this.highlights = t, this.render());
  }
  render() {
    const e = [];
    let t = 0;
    for (const n of this.highlights) {
      if (n.end === n.start)
        continue;
      if (t < n.start) {
        const o = this.text.substring(t, n.start);
        this.supportIcons ? e.push(...bg(o)) : e.push(o), t = n.start;
      }
      const r = this.text.substring(t, n.end), s = Re("span.highlight", void 0, ...this.supportIcons ? bg(r) : [r]);
      n.extraClasses && s.classList.add(...n.extraClasses), e.push(s), t = n.end;
    }
    if (t < this.text.length) {
      const n = this.text.substring(t);
      this.supportIcons ? e.push(...bg(n)) : e.push(n);
    }
    cs(this.domNode, ...e), this.title ? this.domNode.title = this.title : this.domNode.removeAttribute("title"), this.didEverRender = !0;
  }
  static escapeNewLines(e, t) {
    let n = 0, r = 0;
    return e.replace(/\r\n|\r|\n/g, (s, o) => {
      r = s === `\r
` ? -1 : 0, o += n;
      for (const a of t)
        a.end <= o || (a.start >= o && (a.start += r), a.end >= o && (a.end += r));
      return n += r, "⏎";
    });
  }
}
class pT {
  constructor(e) {
    this._element = e;
  }
  get element() {
    return this._element;
  }
  set textContent(e) {
    this.disposed || e === this._textContent || (this._textContent = e, this._element.textContent = e);
  }
  set className(e) {
    this.disposed || e === this._className || (this._className = e, this._element.className = e);
  }
  set empty(e) {
    this.disposed || e === this._empty || (this._empty = e, this._element.style.marginLeft = e ? "0" : "");
  }
  dispose() {
    this.disposed = !0;
  }
}
class $L extends we {
  constructor(e, t) {
    super(), this.customHovers = /* @__PURE__ */ new Map(), this.creationOptions = t, this.domNode = this._register(new pT(Te(e, Re(".monaco-icon-label")))), this.labelContainer = Te(this.domNode.element, Re(".monaco-icon-label-container"));
    const n = Te(this.labelContainer, Re("span.monaco-icon-name-container"));
    t?.supportHighlights || t?.supportIcons ? this.nameNode = new xGe(n, !!t.supportIcons) : this.nameNode = new wGe(n), this.hoverDelegate = t?.hoverDelegate;
  }
  get element() {
    return this.domNode.element;
  }
  setLabel(e, t, n) {
    const r = ["monaco-icon-label"], s = ["monaco-icon-label-container"];
    let o = "";
    if (n && (n.extraClasses && r.push(...n.extraClasses), n.italic && r.push("italic"), n.strikethrough && r.push("strikethrough"), n.disabledCommand && s.push("disabled"), n.title && (o += n.title)), this.domNode.className = r.join(" "), this.domNode.element.setAttribute("aria-label", o), this.labelContainer.className = s.join(" "), this.setupHover(n?.descriptionTitle ? this.labelContainer : this.element, n?.title), this.nameNode.setLabel(e, n), t || this.descriptionNode) {
      const a = this.getOrCreateDescriptionNode();
      a instanceof yg ? (a.set(t || "", n ? n.descriptionMatches : void 0, void 0, n?.labelEscapeNewLines), this.setupHover(a.element, n?.descriptionTitle)) : (a.textContent = t && n?.labelEscapeNewLines ? yg.escapeNewLines(t, []) : t || "", this.setupHover(a.element, n?.descriptionTitle || ""), a.empty = !t);
    }
  }
  setupHover(e, t) {
    const n = this.customHovers.get(e);
    if (n && (n.dispose(), this.customHovers.delete(e)), !t) {
      e.removeAttribute("title");
      return;
    }
    if (!this.hoverDelegate)
      jje(e, t);
    else {
      const r = upe(this.hoverDelegate, e, t);
      r && this.customHovers.set(e, r);
    }
  }
  dispose() {
    super.dispose();
    for (const e of this.customHovers.values())
      e.dispose();
    this.customHovers.clear();
  }
  getOrCreateDescriptionNode() {
    var e;
    if (!this.descriptionNode) {
      const t = this._register(new pT(Te(this.labelContainer, Re("span.monaco-icon-description-container"))));
      !((e = this.creationOptions) === null || e === void 0) && e.supportDescriptionHighlights ? this.descriptionNode = new yg(Te(t.element, Re("span.label-description")), { supportIcons: !!this.creationOptions.supportIcons }) : this.descriptionNode = this._register(new pT(Te(t.element, Re("span.label-description"))));
    }
    return this.descriptionNode;
  }
}
class wGe {
  constructor(e) {
    this.container = e, this.label = void 0, this.singleLabel = void 0;
  }
  setLabel(e, t) {
    if (!(this.label === e && Ra(this.options, t)))
      if (this.label = e, this.options = t, typeof e == "string")
        this.singleLabel || (this.container.innerText = "", this.container.classList.remove("multiple"), this.singleLabel = Te(this.container, Re("a.label-name", { id: t?.domId }))), this.singleLabel.textContent = e;
      else {
        this.container.innerText = "", this.container.classList.add("multiple"), this.singleLabel = void 0;
        for (let n = 0; n < e.length; n++) {
          const r = e[n], s = t?.domId && `${t?.domId}_${n}`;
          Te(this.container, Re("a.label-name", { id: s, "data-icon-label-count": e.length, "data-icon-label-index": n, role: "treeitem" }, r)), n < e.length - 1 && Te(this.container, Re("span.label-separator", void 0, t?.separator || "/"));
        }
      }
  }
}
function SGe(i, e, t) {
  if (!t)
    return;
  let n = 0;
  return i.map((r) => {
    const s = { start: n, end: n + r.length }, o = t.map((a) => ks.intersect(s, a)).filter((a) => !ks.isEmpty(a)).map(({ start: a, end: l }) => ({ start: a - n, end: l - n }));
    return n = s.end + e.length, o;
  });
}
class xGe {
  constructor(e, t) {
    this.container = e, this.supportIcons = t, this.label = void 0, this.singleLabel = void 0;
  }
  setLabel(e, t) {
    if (!(this.label === e && Ra(this.options, t)))
      if (this.label = e, this.options = t, typeof e == "string")
        this.singleLabel || (this.container.innerText = "", this.container.classList.remove("multiple"), this.singleLabel = new yg(Te(this.container, Re("a.label-name", { id: t?.domId })), { supportIcons: this.supportIcons })), this.singleLabel.set(e, t?.matches, void 0, t?.labelEscapeNewLines);
      else {
        this.container.innerText = "", this.container.classList.add("multiple"), this.singleLabel = void 0;
        const n = t?.separator || "/", r = SGe(e, n, t?.matches);
        for (let s = 0; s < e.length; s++) {
          const o = e[s], a = r ? r[s] : void 0, l = t?.domId && `${t?.domId}_${s}`, c = Re("a.label-name", { id: l, "data-icon-label-count": e.length, "data-icon-label-index": s, role: "treeitem" });
          new yg(Te(this.container, c), { supportIcons: this.supportIcons }).set(o, a, void 0, t?.labelEscapeNewLines), s < e.length - 1 && Te(c, Re("span.label-separator", void 0, n));
        }
      }
  }
}
const bD = Re, DGe = {
  keybindingLabelBackground: void 0,
  keybindingLabelForeground: void 0,
  keybindingLabelBorder: void 0,
  keybindingLabelBottomBorder: void 0,
  keybindingLabelShadow: void 0
};
class jS {
  constructor(e, t, n) {
    this.os = t, this.keyElements = /* @__PURE__ */ new Set(), this.options = n || /* @__PURE__ */ Object.create(null);
    const r = this.options.keybindingLabelForeground;
    this.domNode = Te(e, bD(".monaco-keybinding")), r && (this.domNode.style.color = r), this.didEverRender = !1, e.appendChild(this.domNode);
  }
  get element() {
    return this.domNode;
  }
  set(e, t) {
    this.didEverRender && this.keybinding === e && jS.areSame(this.matches, t) || (this.keybinding = e, this.matches = t, this.render());
  }
  render() {
    var e;
    if (this.clear(), this.keybinding) {
      const t = this.keybinding.getChords();
      t[0] && this.renderChord(this.domNode, t[0], this.matches ? this.matches.firstPart : null);
      for (let r = 1; r < t.length; r++)
        Te(this.domNode, bD("span.monaco-keybinding-key-chord-separator", void 0, " ")), this.renderChord(this.domNode, t[r], this.matches ? this.matches.chordPart : null);
      const n = (e = this.options.disableTitle) !== null && e !== void 0 && e ? void 0 : this.keybinding.getAriaLabel() || void 0;
      n !== void 0 ? this.domNode.title = n : this.domNode.removeAttribute("title");
    } else this.options && this.options.renderUnboundKeybindings && this.renderUnbound(this.domNode);
    this.didEverRender = !0;
  }
  clear() {
    ls(this.domNode), this.keyElements.clear();
  }
  renderChord(e, t, n) {
    const r = Zz.modifierLabels[this.os];
    t.ctrlKey && this.renderKey(e, r.ctrlKey, !!n?.ctrlKey, r.separator), t.shiftKey && this.renderKey(e, r.shiftKey, !!n?.shiftKey, r.separator), t.altKey && this.renderKey(e, r.altKey, !!n?.altKey, r.separator), t.metaKey && this.renderKey(e, r.metaKey, !!n?.metaKey, r.separator);
    const s = t.keyLabel;
    s && this.renderKey(e, s, !!n?.keyCode, "");
  }
  renderKey(e, t, n, r) {
    Te(e, this.createKeyElement(t, n ? ".highlight" : "")), r && Te(e, bD("span.monaco-keybinding-key-separator", void 0, r));
  }
  renderUnbound(e) {
    Te(e, this.createKeyElement(C("unbound", "Unbound")));
  }
  createKeyElement(e, t = "") {
    const n = bD("span.monaco-keybinding-key" + t, void 0, e);
    return this.keyElements.add(n), this.options.keybindingLabelBackground && (n.style.backgroundColor = this.options.keybindingLabelBackground), this.options.keybindingLabelBorder && (n.style.borderColor = this.options.keybindingLabelBorder), this.options.keybindingLabelBottomBorder && (n.style.borderBottomColor = this.options.keybindingLabelBottomBorder), this.options.keybindingLabelShadow && (n.style.boxShadow = `inset 0 -1px 0 ${this.options.keybindingLabelShadow}`), n;
  }
  static areSame(e, t) {
    return e === t || !e && !t ? !0 : !!e && !!t && Ra(e.firstPart, t.firstPart) && Ra(e.chordPart, t.chordPart);
  }
}
const bJ = new lp(() => {
  const i = new Intl.Collator(void 0, { numeric: !0, sensitivity: "base" });
  return {
    collator: i,
    collatorIsNumeric: i.resolvedOptions().numeric
  };
});
function EGe(i, e, t = !1) {
  const n = i || "", r = e || "", s = bJ.value.collator.compare(n, r);
  return bJ.value.collatorIsNumeric && s === 0 && n !== r ? n < r ? -1 : 1 : s;
}
function LGe(i, e, t) {
  const n = i.toLowerCase(), r = e.toLowerCase(), s = IGe(i, e, t);
  if (s)
    return s;
  const o = n.endsWith(t), a = r.endsWith(t);
  if (o !== a)
    return o ? -1 : 1;
  const l = EGe(n, r);
  return l !== 0 ? l : n.localeCompare(r);
}
function IGe(i, e, t) {
  const n = i.toLowerCase(), r = e.toLowerCase(), s = n.startsWith(t), o = r.startsWith(t);
  if (s !== o)
    return s ? -1 : 1;
  if (s && o) {
    if (n.length < r.length)
      return -1;
    if (n.length > r.length)
      return 1;
  }
  return 0;
}
var AGe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
};
class Xpe {
  constructor(e) {
    this.nodes = e;
  }
  toString() {
    return this.nodes.map((e) => typeof e == "string" ? e : e.label).join("");
  }
}
AGe([
  cr
], Xpe.prototype, "toString", null);
const kGe = /\[([^\]]+)\]\(((?:https?:\/\/|command:|file:)[^\)\s]+)(?: (["'])(.+?)(\3))?\)/gi;
function TGe(i) {
  const e = [];
  let t = 0, n;
  for (; n = kGe.exec(i); ) {
    n.index - t > 0 && e.push(i.substring(t, n.index));
    const [, r, s, , o] = n;
    o ? e.push({ label: r, href: s, title: o }) : e.push({ label: r, href: s }), t = n.index + n[0].length;
  }
  return t < i.length && e.push(i.substring(t)), new Xpe(e);
}
const mT = {}, NGe = new oU("quick-input-button-icon-");
function GB(i) {
  if (!i)
    return;
  let e;
  const t = i.dark.toString();
  return mT[t] ? e = mT[t] : (e = NGe.nextId(), cF(`.${e}, .hc-light .${e}`, `background-image: ${Og(i.light || i.dark)}`), cF(`.vs-dark .${e}, .hc-black .${e}`, `background-image: ${Og(i.dark)}`), mT[t] = e), e;
}
function PGe(i, e, t) {
  cs(e);
  const n = TGe(i);
  let r = 0;
  for (const s of n.nodes)
    if (typeof s == "string")
      e.append(...bg(s));
    else {
      let o = s.title;
      !o && s.href.startsWith("command:") ? o = C("executeCommand", "Click to execute command '{0}'", s.href.substring(8)) : o || (o = s.href);
      const a = Re("a", { href: s.href, title: o, tabIndex: r++ }, s.label);
      a.style.textDecoration = "underline";
      const l = (f) => {
        K9e(f) && Tt.stop(f, !0), t.callback(s.href);
      }, c = t.disposables.add(new Yt(a, Ge.CLICK)).event, d = t.disposables.add(new Yt(a, Ge.KEY_DOWN)).event, u = qe.chain(d, (f) => f.filter((g) => {
        const p = new Xn(g);
        return p.equals(
          10
          /* KeyCode.Space */
        ) || p.equals(
          3
          /* KeyCode.Enter */
        );
      }));
      t.disposables.add(Vn.addTarget(a));
      const h = t.disposables.add(new Yt(a, Wn.Tap)).event;
      qe.any(c, h, u)(l, null, t.disposables), e.appendChild(a);
    }
}
var Zpe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, CJ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const Dc = Re;
class OGe {
  constructor(e, t, n, r, s, o, a) {
    var l, c, d;
    this._checked = !1, this._hidden = !1, this.hasCheckbox = r, this.index = n, this.fireButtonTriggered = s, this.fireSeparatorButtonTriggered = o, this._onChecked = a, this.onChecked = r ? qe.map(qe.filter(this._onChecked.event, (u) => u.listElement === this), (u) => u.checked) : qe.None, e.type === "separator" ? this._separator = e : (this.item = e, t && t.type === "separator" && !t.buttons && (this._separator = t), this.saneDescription = this.item.description, this.saneDetail = this.item.detail, this._labelHighlights = (l = this.item.highlights) === null || l === void 0 ? void 0 : l.label, this._descriptionHighlights = (c = this.item.highlights) === null || c === void 0 ? void 0 : c.description, this._detailHighlights = (d = this.item.highlights) === null || d === void 0 ? void 0 : d.detail, this.saneTooltip = this.item.tooltip), this._init = new lp(() => {
      var u;
      const h = (u = e.label) !== null && u !== void 0 ? u : "", f = tC(h).text.trim(), g = e.ariaLabel || [h, this.saneDescription, this.saneDetail].map((p) => Bje(p)).filter((p) => !!p).join(", ");
      return {
        saneLabel: h,
        saneSortLabel: f,
        saneAriaLabel: g
      };
    });
  }
  // #region Lazy Getters
  get saneLabel() {
    return this._init.value.saneLabel;
  }
  get saneSortLabel() {
    return this._init.value.saneSortLabel;
  }
  get saneAriaLabel() {
    return this._init.value.saneAriaLabel;
  }
  // #endregion
  // #region Getters and Setters
  get element() {
    return this._element;
  }
  set element(e) {
    this._element = e;
  }
  get hidden() {
    return this._hidden;
  }
  set hidden(e) {
    this._hidden = e;
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    e !== this._checked && (this._checked = e, this._onChecked.fire({ listElement: this, checked: e }));
  }
  get separator() {
    return this._separator;
  }
  set separator(e) {
    this._separator = e;
  }
  get labelHighlights() {
    return this._labelHighlights;
  }
  set labelHighlights(e) {
    this._labelHighlights = e;
  }
  get descriptionHighlights() {
    return this._descriptionHighlights;
  }
  set descriptionHighlights(e) {
    this._descriptionHighlights = e;
  }
  get detailHighlights() {
    return this._detailHighlights;
  }
  set detailHighlights(e) {
    this._detailHighlights = e;
  }
}
class zS {
  constructor(e) {
    this.themeService = e;
  }
  get templateId() {
    return zS.ID;
  }
  renderTemplate(e) {
    const t = /* @__PURE__ */ Object.create(null);
    t.toDisposeElement = [], t.toDisposeTemplate = [], t.entry = Te(e, Dc(".quick-input-list-entry"));
    const n = Te(t.entry, Dc("label.quick-input-list-label"));
    t.toDisposeTemplate.push(ar(n, Ge.CLICK, (c) => {
      t.checkbox.offsetParent || c.preventDefault();
    })), t.checkbox = Te(n, Dc("input.quick-input-list-checkbox")), t.checkbox.type = "checkbox", t.toDisposeTemplate.push(ar(t.checkbox, Ge.CHANGE, (c) => {
      t.element.checked = t.checkbox.checked;
    }));
    const r = Te(n, Dc(".quick-input-list-rows")), s = Te(r, Dc(".quick-input-list-row")), o = Te(r, Dc(".quick-input-list-row"));
    t.label = new $L(s, { supportHighlights: !0, supportDescriptionHighlights: !0, supportIcons: !0 }), t.toDisposeTemplate.push(t.label), t.icon = Hhe(t.label.element, Dc(".quick-input-list-icon"));
    const a = Te(s, Dc(".quick-input-list-entry-keybinding"));
    t.keybinding = new jS(a, ka);
    const l = Te(o, Dc(".quick-input-list-label-meta"));
    return t.detail = new $L(l, { supportHighlights: !0, supportIcons: !0 }), t.toDisposeTemplate.push(t.detail), t.separator = Te(t.entry, Dc(".quick-input-list-separator")), t.actionBar = new Dl(t.entry), t.actionBar.domNode.classList.add("quick-input-list-entry-action-bar"), t.toDisposeTemplate.push(t.actionBar), t;
  }
  renderElement(e, t, n) {
    var r, s, o, a;
    n.element = e, e.element = (r = n.entry) !== null && r !== void 0 ? r : void 0;
    const l = e.item ? e.item : e.separator;
    n.checkbox.checked = e.checked, n.toDisposeElement.push(e.onChecked((g) => n.checkbox.checked = g));
    const { labelHighlights: c, descriptionHighlights: d, detailHighlights: u } = e;
    if (!((s = e.item) === null || s === void 0) && s.iconPath) {
      const g = w_(this.themeService.getColorTheme().type) ? e.item.iconPath.dark : (o = e.item.iconPath.light) !== null && o !== void 0 ? o : e.item.iconPath.dark, p = pt.revive(g);
      n.icon.className = "quick-input-list-icon", n.icon.style.backgroundImage = Og(p);
    } else
      n.icon.style.backgroundImage = "", n.icon.className = !((a = e.item) === null || a === void 0) && a.iconClass ? `quick-input-list-icon ${e.item.iconClass}` : "";
    const h = {
      matches: c || [],
      descriptionTitle: e.saneDescription,
      descriptionMatches: d || [],
      labelEscapeNewLines: !0
    };
    l.type !== "separator" ? (h.extraClasses = l.iconClasses, h.italic = l.italic, h.strikethrough = l.strikethrough, n.entry.classList.remove("quick-input-list-separator-as-item")) : n.entry.classList.add("quick-input-list-separator-as-item"), n.label.setLabel(e.saneLabel, e.saneDescription, h), n.keybinding.set(l.type === "separator" ? void 0 : l.keybinding), e.saneDetail ? (n.detail.element.style.display = "", n.detail.setLabel(e.saneDetail, void 0, {
      matches: u,
      title: e.saneDetail,
      labelEscapeNewLines: !0
    })) : n.detail.element.style.display = "none", e.item && e.separator && e.separator.label ? (n.separator.textContent = e.separator.label, n.separator.style.display = "") : n.separator.style.display = "none", n.entry.classList.toggle("quick-input-list-separator-border", !!e.separator);
    const f = l.buttons;
    f && f.length ? (n.actionBar.push(f.map((g, p) => {
      let m = g.iconClass || (g.iconPath ? GB(g.iconPath) : void 0);
      return g.alwaysVisible && (m = m ? `${m} always-visible` : "always-visible"), {
        id: `id-${p}`,
        class: m,
        enabled: !0,
        label: "",
        tooltip: g.tooltip || "",
        run: () => {
          l.type !== "separator" ? e.fireButtonTriggered({
            button: g,
            item: l
          }) : e.fireSeparatorButtonTriggered({
            button: g,
            separator: l
          });
        }
      };
    }), { icon: !0, label: !1 }), n.entry.classList.add("has-actions")) : n.entry.classList.remove("has-actions");
  }
  disposeElement(e, t, n) {
    n.toDisposeElement = An(n.toDisposeElement), n.actionBar.clear();
  }
  disposeTemplate(e) {
    e.toDisposeElement = An(e.toDisposeElement), e.toDisposeTemplate = An(e.toDisposeTemplate);
  }
}
zS.ID = "listelement";
class MGe {
  getHeight(e) {
    return e.item ? e.saneDetail ? 44 : 22 : 24;
  }
  getTemplateId(e) {
    return zS.ID;
  }
}
var Vr;
(function(i) {
  i[i.First = 1] = "First", i[i.Second = 2] = "Second", i[i.Last = 3] = "Last", i[i.Next = 4] = "Next", i[i.Previous = 5] = "Previous", i[i.NextPage = 6] = "NextPage", i[i.PreviousPage = 7] = "PreviousPage";
})(Vr || (Vr = {}));
class IU {
  constructor(e, t, n, r) {
    this.parent = e, this.options = n, this.inputElements = [], this.elements = [], this.elementsToIndexes = /* @__PURE__ */ new Map(), this.matchOnDescription = !1, this.matchOnDetail = !1, this.matchOnLabel = !0, this.matchOnLabelMode = "fuzzy", this.sortByLabel = !0, this._onChangedAllVisibleChecked = new pe(), this.onChangedAllVisibleChecked = this._onChangedAllVisibleChecked.event, this._onChangedCheckedCount = new pe(), this.onChangedCheckedCount = this._onChangedCheckedCount.event, this._onChangedVisibleCount = new pe(), this.onChangedVisibleCount = this._onChangedVisibleCount.event, this._onChangedCheckedElements = new pe(), this.onChangedCheckedElements = this._onChangedCheckedElements.event, this._onButtonTriggered = new pe(), this.onButtonTriggered = this._onButtonTriggered.event, this._onSeparatorButtonTriggered = new pe(), this.onSeparatorButtonTriggered = this._onSeparatorButtonTriggered.event, this._onKeyDown = new pe(), this.onKeyDown = this._onKeyDown.event, this._onLeave = new pe(), this.onLeave = this._onLeave.event, this._listElementChecked = new pe(), this._fireCheckedEvents = !0, this.elementDisposables = [], this.disposables = [], this.id = t, this.container = Te(this.parent, Dc(".quick-input-list"));
    const s = new MGe(), o = new BGe();
    if (this.list = n.createList("QuickInput", this.container, s, [new zS(r)], {
      identityProvider: {
        getId: (a) => {
          var l, c, d, u, h, f, g, p;
          return (p = (f = (u = (c = (l = a.item) === null || l === void 0 ? void 0 : l.id) !== null && c !== void 0 ? c : (d = a.item) === null || d === void 0 ? void 0 : d.label) !== null && u !== void 0 ? u : (h = a.separator) === null || h === void 0 ? void 0 : h.id) !== null && f !== void 0 ? f : (g = a.separator) === null || g === void 0 ? void 0 : g.label) !== null && p !== void 0 ? p : "";
        }
      },
      setRowLineHeight: !1,
      multipleSelectionSupport: !1,
      horizontalScrolling: !1,
      accessibilityProvider: o
    }), this.list.getHTMLElement().id = t, this.disposables.push(this.list), this.disposables.push(this.list.onKeyDown((a) => {
      const l = new Xn(a);
      switch (l.keyCode) {
        case 10:
          this.toggleCheckbox();
          break;
        case 31:
          (sn ? a.metaKey : a.ctrlKey) && this.list.setFocus(io(this.list.length));
          break;
        case 16: {
          const c = this.list.getFocus();
          c.length === 1 && c[0] === 0 && this._onLeave.fire();
          break;
        }
        case 18: {
          const c = this.list.getFocus();
          c.length === 1 && c[0] === this.list.length - 1 && this._onLeave.fire();
          break;
        }
      }
      this._onKeyDown.fire(l);
    })), this.disposables.push(this.list.onMouseDown((a) => {
      a.browserEvent.button !== 2 && a.browserEvent.preventDefault();
    })), this.disposables.push(Ie(this.container, Ge.CLICK, (a) => {
      (a.x || a.y) && this._onLeave.fire();
    })), this.disposables.push(this.list.onMouseMiddleClick((a) => {
      this._onLeave.fire();
    })), this.disposables.push(this.list.onContextMenu((a) => {
      typeof a.index == "number" && (a.browserEvent.preventDefault(), this.list.setSelection([a.index]));
    })), n.hoverDelegate) {
      const a = new Xhe(n.hoverDelegate.delay);
      this.disposables.push(this.list.onMouseOver((l) => CJ(this, void 0, void 0, function* () {
        var c;
        if (l.browserEvent.target instanceof HTMLAnchorElement) {
          a.cancel();
          return;
        }
        if (
          // anchors are an exception as called out above so we skip them here
          !(!(l.browserEvent.relatedTarget instanceof HTMLAnchorElement) && // check if the mouse is still over the same element
          xs(l.browserEvent.relatedTarget, (c = l.element) === null || c === void 0 ? void 0 : c.element))
        )
          try {
            yield a.trigger(() => CJ(this, void 0, void 0, function* () {
              l.element && this.showHover(l.element);
            }));
          } catch (d) {
            if (!md(d))
              throw d;
          }
      }))), this.disposables.push(this.list.onMouseOut((l) => {
        var c;
        xs(l.browserEvent.relatedTarget, (c = l.element) === null || c === void 0 ? void 0 : c.element) || a.cancel();
      })), this.disposables.push(a);
    }
    this.disposables.push(this._listElementChecked.event((a) => this.fireCheckedEvents())), this.disposables.push(this._onChangedAllVisibleChecked, this._onChangedCheckedCount, this._onChangedVisibleCount, this._onChangedCheckedElements, this._onButtonTriggered, this._onSeparatorButtonTriggered, this._onLeave, this._onKeyDown);
  }
  get onDidChangeFocus() {
    return qe.map(this.list.onDidChangeFocus, (e) => e.elements.map((t) => t.item));
  }
  get onDidChangeSelection() {
    return qe.map(this.list.onDidChangeSelection, (e) => ({ items: e.elements.map((t) => t.item), event: e.browserEvent }));
  }
  get scrollTop() {
    return this.list.scrollTop;
  }
  set scrollTop(e) {
    this.list.scrollTop = e;
  }
  get ariaLabel() {
    return this.list.getHTMLElement().ariaLabel;
  }
  set ariaLabel(e) {
    this.list.getHTMLElement().ariaLabel = e;
  }
  getAllVisibleChecked() {
    return this.allVisibleChecked(this.elements, !1);
  }
  allVisibleChecked(e, t = !0) {
    for (let n = 0, r = e.length; n < r; n++) {
      const s = e[n];
      if (!s.hidden)
        if (s.checked)
          t = !0;
        else
          return !1;
    }
    return t;
  }
  getCheckedCount() {
    let e = 0;
    const t = this.elements;
    for (let n = 0, r = t.length; n < r; n++)
      t[n].checked && e++;
    return e;
  }
  getVisibleCount() {
    let e = 0;
    const t = this.elements;
    for (let n = 0, r = t.length; n < r; n++)
      t[n].hidden || e++;
    return e;
  }
  setAllVisibleChecked(e) {
    try {
      this._fireCheckedEvents = !1, this.elements.forEach((t) => {
        t.hidden || (t.checked = e);
      });
    } finally {
      this._fireCheckedEvents = !0, this.fireCheckedEvents();
    }
  }
  setElements(e) {
    this.elementDisposables = An(this.elementDisposables);
    const t = (o) => this.fireButtonTriggered(o), n = (o) => this.fireSeparatorButtonTriggered(o);
    this.inputElements = e;
    const r = /* @__PURE__ */ new Map(), s = this.parent.classList.contains("show-checkboxes");
    this.elements = e.reduce((o, a, l) => {
      var c;
      const d = l > 0 ? e[l - 1] : void 0;
      if (a.type === "separator" && !a.buttons)
        return o;
      const u = new OGe(a, d, l, s, t, n, this._listElementChecked), h = o.length;
      return o.push(u), r.set((c = u.item) !== null && c !== void 0 ? c : u.separator, h), o;
    }, []), this.elementsToIndexes = r, this.list.splice(0, this.list.length), this.list.splice(0, this.list.length, this.elements), this._onChangedVisibleCount.fire(this.elements.length);
  }
  getFocusedElements() {
    return this.list.getFocusedElements().map((e) => e.item);
  }
  setFocusedElements(e) {
    if (this.list.setFocus(e.filter((t) => this.elementsToIndexes.has(t)).map((t) => this.elementsToIndexes.get(t))), e.length > 0) {
      const t = this.list.getFocus()[0];
      typeof t == "number" && this.list.reveal(t);
    }
  }
  getActiveDescendant() {
    return this.list.getHTMLElement().getAttribute("aria-activedescendant");
  }
  setSelectedElements(e) {
    this.list.setSelection(e.filter((t) => this.elementsToIndexes.has(t)).map((t) => this.elementsToIndexes.get(t)));
  }
  getCheckedElements() {
    return this.elements.filter((e) => e.checked).map((e) => e.item).filter((e) => !!e);
  }
  setCheckedElements(e) {
    try {
      this._fireCheckedEvents = !1;
      const t = /* @__PURE__ */ new Set();
      for (const n of e)
        t.add(n);
      for (const n of this.elements)
        n.checked = t.has(n.item);
    } finally {
      this._fireCheckedEvents = !0, this.fireCheckedEvents();
    }
  }
  set enabled(e) {
    this.list.getHTMLElement().style.pointerEvents = e ? "" : "none";
  }
  focus(e) {
    if (!this.list.length)
      return;
    switch (e === Vr.Second && this.list.length < 2 && (e = Vr.First), e) {
      case Vr.First:
        this.list.scrollTop = 0, this.list.focusFirst(void 0, (n) => !!n.item);
        break;
      case Vr.Second:
        this.list.scrollTop = 0, this.list.focusNth(1, void 0, (n) => !!n.item);
        break;
      case Vr.Last:
        this.list.scrollTop = this.list.scrollHeight, this.list.focusLast(void 0, (n) => !!n.item);
        break;
      case Vr.Next: {
        this.list.focusNext(void 0, !0, void 0, (r) => !!r.item);
        const n = this.list.getFocus()[0];
        n !== 0 && !this.elements[n - 1].item && this.list.firstVisibleIndex > n - 1 && this.list.reveal(n - 1);
        break;
      }
      case Vr.Previous: {
        this.list.focusPrevious(void 0, !0, void 0, (r) => !!r.item);
        const n = this.list.getFocus()[0];
        n !== 0 && !this.elements[n - 1].item && this.list.firstVisibleIndex > n - 1 && this.list.reveal(n - 1);
        break;
      }
      case Vr.NextPage:
        this.list.focusNextPage(void 0, (n) => !!n.item);
        break;
      case Vr.PreviousPage:
        this.list.focusPreviousPage(void 0, (n) => !!n.item);
        break;
    }
    const t = this.list.getFocus()[0];
    typeof t == "number" && this.list.reveal(t);
  }
  clearFocus() {
    this.list.setFocus([]);
  }
  domFocus() {
    this.list.domFocus();
  }
  /**
   * Disposes of the hover and shows a new one for the given index if it has a tooltip.
   * @param element The element to show the hover for
   */
  showHover(e) {
    var t, n, r;
    this.options.hoverDelegate !== void 0 && (this._lastHover && !this._lastHover.isDisposed && ((n = (t = this.options.hoverDelegate).onDidHideHover) === null || n === void 0 || n.call(t), (r = this._lastHover) === null || r === void 0 || r.dispose()), !(!e.element || !e.saneTooltip) && (this._lastHover = this.options.hoverDelegate.showHover({
      content: e.saneTooltip,
      target: e.element,
      linkHandler: (s) => {
        this.options.linkOpenerDelegate(s);
      },
      showPointer: !0,
      container: this.container,
      hoverPosition: 1
      /* HoverPosition.RIGHT */
    }, !1)));
  }
  layout(e) {
    this.list.getHTMLElement().style.maxHeight = e ? `${// Make sure height aligns with list item heights
    Math.floor(e / 44) * 44 + 6}px` : "", this.list.layout();
  }
  filter(e) {
    if (!(this.sortByLabel || this.matchOnLabel || this.matchOnDescription || this.matchOnDetail))
      return this.list.layout(), !1;
    const t = e;
    if (e = e.trim(), !e || !(this.matchOnLabel || this.matchOnDescription || this.matchOnDetail))
      this.elements.forEach((r) => {
        r.labelHighlights = void 0, r.descriptionHighlights = void 0, r.detailHighlights = void 0, r.hidden = !1;
        const s = r.index && this.inputElements[r.index - 1];
        r.item && (r.separator = s && s.type === "separator" && !s.buttons ? s : void 0);
      });
    else {
      let r;
      this.elements.forEach((s) => {
        var o, a, l, c;
        let d;
        this.matchOnLabelMode === "fuzzy" ? d = this.matchOnLabel && (o = tT(e, tC(s.saneLabel))) !== null && o !== void 0 ? o : void 0 : d = this.matchOnLabel && (a = RGe(t, tC(s.saneLabel))) !== null && a !== void 0 ? a : void 0;
        const u = this.matchOnDescription && (l = tT(e, tC(s.saneDescription || ""))) !== null && l !== void 0 ? l : void 0, h = this.matchOnDetail && (c = tT(e, tC(s.saneDetail || ""))) !== null && c !== void 0 ? c : void 0;
        if (d || u || h ? (s.labelHighlights = d, s.descriptionHighlights = u, s.detailHighlights = h, s.hidden = !1) : (s.labelHighlights = void 0, s.descriptionHighlights = void 0, s.detailHighlights = void 0, s.hidden = s.item ? !s.item.alwaysShow : !0), s.item ? s.separator = void 0 : s.separator && (s.hidden = !0), !this.sortByLabel) {
          const f = s.index && this.inputElements[s.index - 1];
          r = f && f.type === "separator" ? f : r, r && !s.hidden && (s.separator = r, r = void 0);
        }
      });
    }
    const n = this.elements.filter((r) => !r.hidden);
    if (this.sortByLabel && e) {
      const r = e.toLowerCase();
      n.sort((s, o) => FGe(s, o, r));
    }
    return this.elementsToIndexes = n.reduce((r, s, o) => {
      var a;
      return r.set((a = s.item) !== null && a !== void 0 ? a : s.separator, o), r;
    }, /* @__PURE__ */ new Map()), this.list.splice(0, this.list.length, n), this.list.setFocus([]), this.list.layout(), this._onChangedAllVisibleChecked.fire(this.getAllVisibleChecked()), this._onChangedVisibleCount.fire(n.length), !0;
  }
  toggleCheckbox() {
    try {
      this._fireCheckedEvents = !1;
      const e = this.list.getFocusedElements(), t = this.allVisibleChecked(e);
      for (const n of e)
        n.checked = !t;
    } finally {
      this._fireCheckedEvents = !0, this.fireCheckedEvents();
    }
  }
  display(e) {
    this.container.style.display = e ? "" : "none";
  }
  isDisplayed() {
    return this.container.style.display !== "none";
  }
  dispose() {
    this.elementDisposables = An(this.elementDisposables), this.disposables = An(this.disposables);
  }
  fireCheckedEvents() {
    this._fireCheckedEvents && (this._onChangedAllVisibleChecked.fire(this.getAllVisibleChecked()), this._onChangedCheckedCount.fire(this.getCheckedCount()), this._onChangedCheckedElements.fire(this.getCheckedElements()));
  }
  fireButtonTriggered(e) {
    this._onButtonTriggered.fire(e);
  }
  fireSeparatorButtonTriggered(e) {
    this._onSeparatorButtonTriggered.fire(e);
  }
  style(e) {
    this.list.style(e);
  }
  toggleHover() {
    const e = this.list.getFocusedElements()[0];
    if (!e?.saneTooltip)
      return;
    if (this._lastHover && !this._lastHover.isDisposed) {
      this._lastHover.dispose();
      return;
    }
    const t = this.list.getFocusedElements()[0];
    if (!t)
      return;
    this.showHover(t);
    const n = new Ne();
    n.add(this.list.onDidChangeFocus((r) => {
      r.indexes.length && this.showHover(r.elements[0]);
    })), this._lastHover && n.add(this._lastHover), this._toggleHover = n, this.elementDisposables.push(this._toggleHover);
  }
}
Zpe([
  cr
], IU.prototype, "onDidChangeFocus", null);
Zpe([
  cr
], IU.prototype, "onDidChangeSelection", null);
function RGe(i, e) {
  const { text: t, iconOffsets: n } = e;
  if (!n || n.length === 0)
    return yJ(i, t);
  const r = bS(t, " "), s = t.length - r.length, o = yJ(i, r);
  if (o)
    for (const a of o) {
      const l = n[a.start + s] + s;
      a.start += l, a.end += l;
    }
  return o;
}
function yJ(i, e) {
  const t = e.toLowerCase().indexOf(i.toLowerCase());
  return t !== -1 ? [{ start: t, end: t + i.length }] : null;
}
function FGe(i, e, t) {
  const n = i.labelHighlights || [], r = e.labelHighlights || [];
  return n.length && !r.length ? -1 : !n.length && r.length ? 1 : n.length === 0 && r.length === 0 ? 0 : LGe(i.saneSortLabel, e.saneSortLabel, t);
}
class BGe {
  getWidgetAriaLabel() {
    return C("quickInput", "Quick Input");
  }
  getAriaLabel(e) {
    var t;
    return !((t = e.separator) === null || t === void 0) && t.label ? `${e.saneAriaLabel}, ${e.separator.label}` : e.saneAriaLabel;
  }
  getWidgetRole() {
    return "listbox";
  }
  getRole(e) {
    return e.hasCheckbox ? "checkbox" : "option";
  }
  isChecked(e) {
    if (e.hasCheckbox)
      return {
        value: e.checked,
        onDidChange: e.onChecked
      };
  }
}
var wJ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const qB = {
  iconClass: ft.asClassName(We.quickInputBack),
  tooltip: C("quickInput.back", "Back"),
  handle: -1
  // TODO
};
class US extends we {
  constructor(e) {
    super(), this.ui = e, this._widgetUpdated = !1, this.visible = !1, this._enabled = !0, this._busy = !1, this._ignoreFocusOut = !1, this._buttons = [], this.buttonsUpdated = !1, this._toggles = [], this.togglesUpdated = !1, this.noValidationMessage = US.noPromptMessage, this._severity = Yi.Ignore, this.onDidTriggerButtonEmitter = this._register(new pe()), this.onDidHideEmitter = this._register(new pe()), this.onDisposeEmitter = this._register(new pe()), this.visibleDisposables = this._register(new Ne()), this.onDidHide = this.onDidHideEmitter.event;
  }
  get title() {
    return this._title;
  }
  set title(e) {
    this._title = e, this.update();
  }
  get description() {
    return this._description;
  }
  set description(e) {
    this._description = e, this.update();
  }
  get step() {
    return this._steps;
  }
  set step(e) {
    this._steps = e, this.update();
  }
  get totalSteps() {
    return this._totalSteps;
  }
  set totalSteps(e) {
    this._totalSteps = e, this.update();
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._enabled = e, this.update();
  }
  get contextKey() {
    return this._contextKey;
  }
  set contextKey(e) {
    this._contextKey = e, this.update();
  }
  get busy() {
    return this._busy;
  }
  set busy(e) {
    this._busy = e, this.update();
  }
  get ignoreFocusOut() {
    return this._ignoreFocusOut;
  }
  set ignoreFocusOut(e) {
    const t = this._ignoreFocusOut !== e && !od;
    this._ignoreFocusOut = e && !od, t && this.update();
  }
  get buttons() {
    return this._buttons;
  }
  set buttons(e) {
    this._buttons = e, this.buttonsUpdated = !0, this.update();
  }
  get toggles() {
    return this._toggles;
  }
  set toggles(e) {
    this._toggles = e ?? [], this.togglesUpdated = !0, this.update();
  }
  get validationMessage() {
    return this._validationMessage;
  }
  set validationMessage(e) {
    this._validationMessage = e, this.update();
  }
  get severity() {
    return this._severity;
  }
  set severity(e) {
    this._severity = e, this.update();
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.onDidTriggerButton((e) => {
      this.buttons.indexOf(e) !== -1 && this.onDidTriggerButtonEmitter.fire(e);
    })), this.ui.show(this), this.visible = !0, this._lastValidationMessage = void 0, this._lastSeverity = void 0, this.buttons.length && (this.buttonsUpdated = !0), this.toggles.length && (this.togglesUpdated = !0), this.update());
  }
  hide() {
    this.visible && this.ui.hide();
  }
  didHide(e = gw.Other) {
    this.visible = !1, this.visibleDisposables.clear(), this.onDidHideEmitter.fire({ reason: e });
  }
  update() {
    var e, t;
    if (!this.visible)
      return;
    const n = this.getTitle();
    n && this.ui.title.textContent !== n ? this.ui.title.textContent = n : !n && this.ui.title.innerHTML !== "&nbsp;" && (this.ui.title.innerText = " ");
    const r = this.getDescription();
    if (this.ui.description1.textContent !== r && (this.ui.description1.textContent = r), this.ui.description2.textContent !== r && (this.ui.description2.textContent = r), this._widgetUpdated && (this._widgetUpdated = !1, this._widget ? cs(this.ui.widget, this._widget) : cs(this.ui.widget)), this.busy && !this.busyDelay && (this.busyDelay = new uc(), this.busyDelay.setIfNotSet(() => {
      this.visible && this.ui.progressBar.infinite();
    }, 800)), !this.busy && this.busyDelay && (this.ui.progressBar.stop(), this.busyDelay.cancel(), this.busyDelay = void 0), this.buttonsUpdated) {
      this.buttonsUpdated = !1, this.ui.leftActionBar.clear();
      const o = this.buttons.filter((l) => l === qB);
      this.ui.leftActionBar.push(o.map((l, c) => {
        const d = new vo(`id-${c}`, "", l.iconClass || GB(l.iconPath), !0, () => wJ(this, void 0, void 0, function* () {
          this.onDidTriggerButtonEmitter.fire(l);
        }));
        return d.tooltip = l.tooltip || "", d;
      }), { icon: !0, label: !1 }), this.ui.rightActionBar.clear();
      const a = this.buttons.filter((l) => l !== qB);
      this.ui.rightActionBar.push(a.map((l, c) => {
        const d = new vo(`id-${c}`, "", l.iconClass || GB(l.iconPath), !0, () => wJ(this, void 0, void 0, function* () {
          this.onDidTriggerButtonEmitter.fire(l);
        }));
        return d.tooltip = l.tooltip || "", d;
      }), { icon: !0, label: !1 });
    }
    if (this.togglesUpdated) {
      this.togglesUpdated = !1;
      const o = (t = (e = this.toggles) === null || e === void 0 ? void 0 : e.filter((a) => a instanceof wb)) !== null && t !== void 0 ? t : [];
      this.ui.inputBox.toggles = o;
    }
    this.ui.ignoreFocusOut = this.ignoreFocusOut, this.ui.setEnabled(this.enabled), this.ui.setContextKey(this.contextKey);
    const s = this.validationMessage || this.noValidationMessage;
    this._lastValidationMessage !== s && (this._lastValidationMessage = s, cs(this.ui.message), PGe(s, this.ui.message, {
      callback: (o) => {
        this.ui.linkOpenerDelegate(o);
      },
      disposables: this.visibleDisposables
    })), this._lastSeverity !== this.severity && (this._lastSeverity = this.severity, this.showMessageDecoration(this.severity));
  }
  getTitle() {
    return this.title && this.step ? `${this.title} (${this.getSteps()})` : this.title ? this.title : this.step ? this.getSteps() : "";
  }
  getDescription() {
    return this.description || "";
  }
  getSteps() {
    return this.step && this.totalSteps ? C("quickInput.steps", "{0}/{1}", this.step, this.totalSteps) : this.step ? String(this.step) : "";
  }
  showMessageDecoration(e) {
    if (this.ui.inputBox.showDecoration(e), e !== Yi.Ignore) {
      const t = this.ui.inputBox.stylesForType(e);
      this.ui.message.style.color = t.foreground ? `${t.foreground}` : "", this.ui.message.style.backgroundColor = t.background ? `${t.background}` : "", this.ui.message.style.border = t.border ? `1px solid ${t.border}` : "", this.ui.message.style.marginBottom = "-2px";
    } else
      this.ui.message.style.color = "", this.ui.message.style.backgroundColor = "", this.ui.message.style.border = "", this.ui.message.style.marginBottom = "";
  }
  dispose() {
    this.hide(), this.onDisposeEmitter.fire(), super.dispose();
  }
}
US.noPromptMessage = C("inputModeEntry", "Press 'Enter' to confirm your input or 'Escape' to cancel");
class pw extends US {
  constructor() {
    super(...arguments), this._value = "", this.onDidChangeValueEmitter = this._register(new pe()), this.onWillAcceptEmitter = this._register(new pe()), this.onDidAcceptEmitter = this._register(new pe()), this.onDidCustomEmitter = this._register(new pe()), this._items = [], this.itemsUpdated = !1, this._canSelectMany = !1, this._canAcceptInBackground = !1, this._matchOnDescription = !1, this._matchOnDetail = !1, this._matchOnLabel = !0, this._matchOnLabelMode = "fuzzy", this._sortByLabel = !0, this._autoFocusOnList = !0, this._keepScrollPosition = !1, this._itemActivation = kc.FIRST, this._activeItems = [], this.activeItemsUpdated = !1, this.activeItemsToConfirm = [], this.onDidChangeActiveEmitter = this._register(new pe()), this._selectedItems = [], this.selectedItemsUpdated = !1, this.selectedItemsToConfirm = [], this.onDidChangeSelectionEmitter = this._register(new pe()), this.onDidTriggerItemButtonEmitter = this._register(new pe()), this.onDidTriggerSeparatorButtonEmitter = this._register(new pe()), this.valueSelectionUpdated = !0, this._ok = "default", this._customButton = !1, this.filterValue = (e) => e, this.onDidChangeValue = this.onDidChangeValueEmitter.event, this.onWillAccept = this.onWillAcceptEmitter.event, this.onDidAccept = this.onDidAcceptEmitter.event, this.onDidChangeActive = this.onDidChangeActiveEmitter.event, this.onDidChangeSelection = this.onDidChangeSelectionEmitter.event, this.onDidTriggerItemButton = this.onDidTriggerItemButtonEmitter.event, this.onDidTriggerSeparatorButton = this.onDidTriggerSeparatorButtonEmitter.event;
  }
  get quickNavigate() {
    return this._quickNavigate;
  }
  set quickNavigate(e) {
    this._quickNavigate = e, this.update();
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.doSetValue(e);
  }
  doSetValue(e, t) {
    this._value !== e && (this._value = e, t || this.update(), this.visible && this.ui.list.filter(this.filterValue(this._value)) && this.trySelectFirst(), this.onDidChangeValueEmitter.fire(this._value));
  }
  set ariaLabel(e) {
    this._ariaLabel = e, this.update();
  }
  get ariaLabel() {
    return this._ariaLabel;
  }
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(e) {
    this._placeholder = e, this.update();
  }
  get items() {
    return this._items;
  }
  get scrollTop() {
    return this.ui.list.scrollTop;
  }
  set scrollTop(e) {
    this.ui.list.scrollTop = e;
  }
  set items(e) {
    this._items = e, this.itemsUpdated = !0, this.update();
  }
  get canSelectMany() {
    return this._canSelectMany;
  }
  set canSelectMany(e) {
    this._canSelectMany = e, this.update();
  }
  get canAcceptInBackground() {
    return this._canAcceptInBackground;
  }
  set canAcceptInBackground(e) {
    this._canAcceptInBackground = e;
  }
  get matchOnDescription() {
    return this._matchOnDescription;
  }
  set matchOnDescription(e) {
    this._matchOnDescription = e, this.update();
  }
  get matchOnDetail() {
    return this._matchOnDetail;
  }
  set matchOnDetail(e) {
    this._matchOnDetail = e, this.update();
  }
  get matchOnLabel() {
    return this._matchOnLabel;
  }
  set matchOnLabel(e) {
    this._matchOnLabel = e, this.update();
  }
  get matchOnLabelMode() {
    return this._matchOnLabelMode;
  }
  set matchOnLabelMode(e) {
    this._matchOnLabelMode = e, this.update();
  }
  get sortByLabel() {
    return this._sortByLabel;
  }
  set sortByLabel(e) {
    this._sortByLabel = e, this.update();
  }
  get autoFocusOnList() {
    return this._autoFocusOnList;
  }
  set autoFocusOnList(e) {
    this._autoFocusOnList = e, this.update();
  }
  get keepScrollPosition() {
    return this._keepScrollPosition;
  }
  set keepScrollPosition(e) {
    this._keepScrollPosition = e;
  }
  get itemActivation() {
    return this._itemActivation;
  }
  set itemActivation(e) {
    this._itemActivation = e;
  }
  get activeItems() {
    return this._activeItems;
  }
  set activeItems(e) {
    this._activeItems = e, this.activeItemsUpdated = !0, this.update();
  }
  get selectedItems() {
    return this._selectedItems;
  }
  set selectedItems(e) {
    this._selectedItems = e, this.selectedItemsUpdated = !0, this.update();
  }
  get keyMods() {
    return this._quickNavigate ? _Ge : this.ui.keyMods;
  }
  set valueSelection(e) {
    this._valueSelection = e, this.valueSelectionUpdated = !0, this.update();
  }
  get customButton() {
    return this._customButton;
  }
  set customButton(e) {
    this._customButton = e, this.update();
  }
  get customLabel() {
    return this._customButtonLabel;
  }
  set customLabel(e) {
    this._customButtonLabel = e, this.update();
  }
  get customHover() {
    return this._customButtonHover;
  }
  set customHover(e) {
    this._customButtonHover = e, this.update();
  }
  get ok() {
    return this._ok;
  }
  set ok(e) {
    this._ok = e, this.update();
  }
  get hideInput() {
    return !!this._hideInput;
  }
  set hideInput(e) {
    this._hideInput = e, this.update();
  }
  trySelectFirst() {
    this.autoFocusOnList && (this.canSelectMany || this.ui.list.focus(Vr.First));
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.inputBox.onDidChange((e) => {
      this.doSetValue(
        e,
        !0
        /* skip update since this originates from the UI */
      );
    })), this.visibleDisposables.add(this.ui.inputBox.onMouseDown((e) => {
      this.autoFocusOnList || this.ui.list.clearFocus();
    })), this.visibleDisposables.add((this._hideInput ? this.ui.list : this.ui.inputBox).onKeyDown((e) => {
      switch (e.keyCode) {
        case 18:
          this.ui.list.focus(Vr.Next), this.canSelectMany && this.ui.list.domFocus(), Tt.stop(e, !0);
          break;
        case 16:
          this.ui.list.getFocusedElements().length ? this.ui.list.focus(Vr.Previous) : this.ui.list.focus(Vr.Last), this.canSelectMany && this.ui.list.domFocus(), Tt.stop(e, !0);
          break;
        case 12:
          this.ui.list.focus(Vr.NextPage), this.canSelectMany && this.ui.list.domFocus(), Tt.stop(e, !0);
          break;
        case 11:
          this.ui.list.focus(Vr.PreviousPage), this.canSelectMany && this.ui.list.domFocus(), Tt.stop(e, !0);
          break;
        case 17:
          if (!this._canAcceptInBackground || !this.ui.inputBox.isSelectionAtEnd())
            return;
          this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems), this.handleAccept(!0));
          break;
        case 14:
          (e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && (this.ui.list.focus(Vr.First), Tt.stop(e, !0));
          break;
        case 13:
          (e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && (this.ui.list.focus(Vr.Last), Tt.stop(e, !0));
          break;
      }
    })), this.visibleDisposables.add(this.ui.onDidAccept(() => {
      this.canSelectMany ? this.ui.list.getCheckedElements().length || (this._selectedItems = [], this.onDidChangeSelectionEmitter.fire(this.selectedItems)) : this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems)), this.handleAccept(!1);
    })), this.visibleDisposables.add(this.ui.onDidCustom(() => {
      this.onDidCustomEmitter.fire();
    })), this.visibleDisposables.add(this.ui.list.onDidChangeFocus((e) => {
      this.activeItemsUpdated || this.activeItemsToConfirm !== this._activeItems && Qi(e, this._activeItems, (t, n) => t === n) || (this._activeItems = e, this.onDidChangeActiveEmitter.fire(e));
    })), this.visibleDisposables.add(this.ui.list.onDidChangeSelection(({ items: e, event: t }) => {
      if (this.canSelectMany) {
        e.length && this.ui.list.setSelectedElements([]);
        return;
      }
      this.selectedItemsToConfirm !== this._selectedItems && Qi(e, this._selectedItems, (n, r) => n === r) || (this._selectedItems = e, this.onDidChangeSelectionEmitter.fire(e), e.length && this.handleAccept(
        t instanceof MouseEvent && t.button === 1
        /* mouse middle click */
      ));
    })), this.visibleDisposables.add(this.ui.list.onChangedCheckedElements((e) => {
      this.canSelectMany && (this.selectedItemsToConfirm !== this._selectedItems && Qi(e, this._selectedItems, (t, n) => t === n) || (this._selectedItems = e, this.onDidChangeSelectionEmitter.fire(e)));
    })), this.visibleDisposables.add(this.ui.list.onButtonTriggered((e) => this.onDidTriggerItemButtonEmitter.fire(e))), this.visibleDisposables.add(this.ui.list.onSeparatorButtonTriggered((e) => this.onDidTriggerSeparatorButtonEmitter.fire(e))), this.visibleDisposables.add(this.registerQuickNavigation()), this.valueSelectionUpdated = !0), super.show();
  }
  handleAccept(e) {
    let t = !1;
    this.onWillAcceptEmitter.fire({ veto: () => t = !0 }), t || this.onDidAcceptEmitter.fire({ inBackground: e });
  }
  registerQuickNavigation() {
    return Ie(this.ui.container, Ge.KEY_UP, (e) => {
      if (this.canSelectMany || !this._quickNavigate)
        return;
      const t = new Xn(e), n = t.keyCode;
      this._quickNavigate.keybindings.some((o) => {
        const a = o.getChords();
        return a.length > 1 ? !1 : a[0].shiftKey && n === 4 ? !(t.ctrlKey || t.altKey || t.metaKey) : !!(a[0].altKey && n === 6 || a[0].ctrlKey && n === 5 || a[0].metaKey && n === 57);
      }) && (this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems), this.handleAccept(!1)), this._quickNavigate = void 0);
    });
  }
  update() {
    if (!this.visible)
      return;
    const e = this.keepScrollPosition ? this.scrollTop : 0, t = !!this.description, n = {
      title: !!this.title || !!this.step || !!this.buttons.length,
      description: t,
      checkAll: this.canSelectMany && !this._hideCheckAll,
      checkBox: this.canSelectMany,
      inputBox: !this._hideInput,
      progressBar: !this._hideInput || t,
      visibleCount: !0,
      count: this.canSelectMany && !this._hideCountBadge,
      ok: this.ok === "default" ? this.canSelectMany : this.ok,
      list: !0,
      message: !!this.validationMessage,
      customButton: this.customButton
    };
    this.ui.setVisibilities(n), super.update(), this.ui.inputBox.value !== this.value && (this.ui.inputBox.value = this.value), this.valueSelectionUpdated && (this.valueSelectionUpdated = !1, this.ui.inputBox.select(this._valueSelection && { start: this._valueSelection[0], end: this._valueSelection[1] })), this.ui.inputBox.placeholder !== (this.placeholder || "") && (this.ui.inputBox.placeholder = this.placeholder || "");
    let r = this.ariaLabel;
    if (!r && n.inputBox && (r = this.placeholder || pw.DEFAULT_ARIA_LABEL, this.title && (r += ` - ${this.title}`)), this.ui.list.ariaLabel !== r && (this.ui.list.ariaLabel = r ?? null), this.ui.list.matchOnDescription = this.matchOnDescription, this.ui.list.matchOnDetail = this.matchOnDetail, this.ui.list.matchOnLabel = this.matchOnLabel, this.ui.list.matchOnLabelMode = this.matchOnLabelMode, this.ui.list.sortByLabel = this.sortByLabel, this.itemsUpdated)
      switch (this.itemsUpdated = !1, this.ui.list.setElements(this.items), this.ui.list.filter(this.filterValue(this.ui.inputBox.value)), this.ui.checkAll.checked = this.ui.list.getAllVisibleChecked(), this.ui.visibleCount.setCount(this.ui.list.getVisibleCount()), this.ui.count.setCount(this.ui.list.getCheckedCount()), this._itemActivation) {
        case kc.NONE:
          this._itemActivation = kc.FIRST;
          break;
        case kc.SECOND:
          this.ui.list.focus(Vr.Second), this._itemActivation = kc.FIRST;
          break;
        case kc.LAST:
          this.ui.list.focus(Vr.Last), this._itemActivation = kc.FIRST;
          break;
        default:
          this.trySelectFirst();
          break;
      }
    this.ui.container.classList.contains("show-checkboxes") !== !!this.canSelectMany && (this.canSelectMany ? this.ui.list.clearFocus() : this.trySelectFirst()), this.activeItemsUpdated && (this.activeItemsUpdated = !1, this.activeItemsToConfirm = this._activeItems, this.ui.list.setFocusedElements(this.activeItems), this.activeItemsToConfirm === this._activeItems && (this.activeItemsToConfirm = null)), this.selectedItemsUpdated && (this.selectedItemsUpdated = !1, this.selectedItemsToConfirm = this._selectedItems, this.canSelectMany ? this.ui.list.setCheckedElements(this.selectedItems) : this.ui.list.setSelectedElements(this.selectedItems), this.selectedItemsToConfirm === this._selectedItems && (this.selectedItemsToConfirm = null)), this.ui.customButton.label = this.customLabel || "", this.ui.customButton.element.title = this.customHover || "", n.inputBox || (this.ui.list.domFocus(), this.canSelectMany && this.ui.list.focus(Vr.First)), this.keepScrollPosition && (this.scrollTop = e);
  }
}
pw.DEFAULT_ARIA_LABEL = C("quickInputBox.ariaLabel", "Type to narrow down results.");
class VGe extends US {
  constructor() {
    super(...arguments), this._value = "", this.valueSelectionUpdated = !0, this._password = !1, this.onDidValueChangeEmitter = this._register(new pe()), this.onDidAcceptEmitter = this._register(new pe()), this.onDidChangeValue = this.onDidValueChangeEmitter.event, this.onDidAccept = this.onDidAcceptEmitter.event;
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this._value = e || "", this.update();
  }
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(e) {
    this._placeholder = e, this.update();
  }
  get password() {
    return this._password;
  }
  set password(e) {
    this._password = e, this.update();
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.inputBox.onDidChange((e) => {
      e !== this.value && (this._value = e, this.onDidValueChangeEmitter.fire(e));
    })), this.visibleDisposables.add(this.ui.onDidAccept(() => this.onDidAcceptEmitter.fire())), this.valueSelectionUpdated = !0), super.show();
  }
  update() {
    if (!this.visible)
      return;
    this.ui.container.classList.remove("hidden-input");
    const e = {
      title: !!this.title || !!this.step || !!this.buttons.length,
      description: !!this.description || !!this.step,
      inputBox: !0,
      message: !0,
      progressBar: !0
    };
    this.ui.setVisibilities(e), super.update(), this.ui.inputBox.value !== this.value && (this.ui.inputBox.value = this.value), this.valueSelectionUpdated && (this.valueSelectionUpdated = !1, this.ui.inputBox.select(this._valueSelection && { start: this._valueSelection[0], end: this._valueSelection[1] })), this.ui.inputBox.placeholder !== (this.placeholder || "") && (this.ui.inputBox.placeholder = this.placeholder || ""), this.ui.inputBox.password !== this.password && (this.ui.inputBox.password = this.password);
  }
}
const zo = Re;
class K4 extends we {
  constructor(e, t) {
    super(), this.options = e, this.themeService = t, this.enabled = !0, this.onDidAcceptEmitter = this._register(new pe()), this.onDidCustomEmitter = this._register(new pe()), this.onDidTriggerButtonEmitter = this._register(new pe()), this.keyMods = { ctrlCmd: !1, alt: !1 }, this.controller = null, this.onShowEmitter = this._register(new pe()), this.onShow = this.onShowEmitter.event, this.onHideEmitter = this._register(new pe()), this.onHide = this.onHideEmitter.event, this.idPrefix = e.idPrefix, this.parentElement = e.container, this.styles = e.styles, this.registerKeyModsListeners();
  }
  registerKeyModsListeners() {
    const e = (t) => {
      this.keyMods.ctrlCmd = t.ctrlKey || t.metaKey, this.keyMods.alt = t.altKey;
    };
    this._register(Ie(window, Ge.KEY_DOWN, e, !0)), this._register(Ie(window, Ge.KEY_UP, e, !0)), this._register(Ie(window, Ge.MOUSE_DOWN, e, !0));
  }
  getUI() {
    if (this.ui)
      return this.ui;
    const e = Te(this.parentElement, zo(".quick-input-widget.show-file-icons"));
    e.tabIndex = -1, e.style.display = "none";
    const t = yl(e), n = Te(e, zo(".quick-input-titlebar")), r = this.options.hoverDelegate ? { hoverDelegate: this.options.hoverDelegate } : void 0, s = this._register(new Dl(n, r));
    s.domNode.classList.add("quick-input-left-action-bar");
    const o = Te(n, zo(".quick-input-title")), a = this._register(new Dl(n, r));
    a.domNode.classList.add("quick-input-right-action-bar");
    const l = Te(e, zo(".quick-input-header")), c = Te(l, zo("input.quick-input-check-all"));
    c.type = "checkbox", c.setAttribute("aria-label", C("quickInput.checkAll", "Toggle all checkboxes")), this._register(ar(c, Ge.CHANGE, (A) => {
      const P = c.checked;
      N.setAllVisibleChecked(P);
    })), this._register(Ie(c, Ge.CLICK, (A) => {
      (A.x || A.y) && f.setFocus();
    }));
    const d = Te(l, zo(".quick-input-description")), u = Te(l, zo(".quick-input-and-message")), h = Te(u, zo(".quick-input-filter")), f = this._register(new yGe(h, this.styles.inputBox, this.styles.toggle));
    f.setAttribute("aria-describedby", `${this.idPrefix}message`);
    const g = Te(h, zo(".quick-input-visible-count"));
    g.setAttribute("aria-live", "polite"), g.setAttribute("aria-atomic", "true");
    const p = new UB(g, { countFormat: C({ key: "quickInput.visibleCount", comment: ["This tells the user how many items are shown in a list of items to select from. The items can be anything. Currently not visible, but read by screen readers."] }, "{0} Results") }, this.styles.countBadge), m = Te(h, zo(".quick-input-count"));
    m.setAttribute("aria-live", "polite");
    const _ = new UB(m, { countFormat: C({ key: "quickInput.countSelected", comment: ["This tells the user how many items are selected in a list of items to select from. The items can be anything."] }, "{0} Selected") }, this.styles.countBadge), b = Te(l, zo(".quick-input-action")), w = this._register(new zB(b, this.styles.button));
    w.label = C("ok", "OK"), this._register(w.onDidClick((A) => {
      this.onDidAcceptEmitter.fire();
    }));
    const y = Te(l, zo(".quick-input-action")), S = this._register(new zB(y, this.styles.button));
    S.label = C("custom", "Custom"), this._register(S.onDidClick((A) => {
      this.onDidCustomEmitter.fire();
    }));
    const x = Te(u, zo(`#${this.idPrefix}message.quick-input-message`)), D = this._register(new q4(e, this.styles.progressBar));
    D.getContainer().classList.add("quick-input-progress");
    const E = Te(e, zo(".quick-input-html-widget"));
    E.tabIndex = -1;
    const L = Te(e, zo(".quick-input-description")), k = this.idPrefix + "list", N = this._register(new IU(e, k, this.options, this.themeService));
    f.setAttribute("aria-controls", k), this._register(N.onDidChangeFocus(() => {
      var A;
      f.setAttribute("aria-activedescendant", (A = N.getActiveDescendant()) !== null && A !== void 0 ? A : "");
    })), this._register(N.onChangedAllVisibleChecked((A) => {
      c.checked = A;
    })), this._register(N.onChangedVisibleCount((A) => {
      p.setCount(A);
    })), this._register(N.onChangedCheckedCount((A) => {
      _.setCount(A);
    })), this._register(N.onLeave(() => {
      setTimeout(() => {
        f.setFocus(), this.controller instanceof pw && this.controller.canSelectMany && N.clearFocus();
      }, 0);
    }));
    const I = yu(e);
    return this._register(I), this._register(Ie(e, Ge.FOCUS, (A) => {
      xs(A.relatedTarget, e) || (this.previousFocusElement = A.relatedTarget instanceof HTMLElement ? A.relatedTarget : void 0);
    }, !0)), this._register(I.onDidBlur(() => {
      !this.getUI().ignoreFocusOut && !this.options.ignoreFocusOut() && this.hide(gw.Blur), this.previousFocusElement = void 0;
    })), this._register(Ie(e, Ge.FOCUS, (A) => {
      f.setFocus();
    })), this._register(ar(e, Ge.KEY_DOWN, (A) => {
      if (!xs(A.target, E))
        switch (A.keyCode) {
          case 3:
            Tt.stop(A, !0), this.enabled && this.onDidAcceptEmitter.fire();
            break;
          case 9:
            Tt.stop(A, !0), this.hide(gw.Gesture);
            break;
          case 2:
            if (!A.altKey && !A.ctrlKey && !A.metaKey) {
              const P = [
                ".quick-input-list .monaco-action-bar .always-visible",
                ".quick-input-list-entry:hover .monaco-action-bar",
                ".monaco-list-row.focused .monaco-action-bar"
              ];
              if (e.classList.contains("show-checkboxes") ? P.push("input") : P.push("input[type=text]"), this.getUI().list.isDisplayed() && P.push(".monaco-list"), this.getUI().message && P.push(".quick-input-message a"), this.getUI().widget) {
                if (xs(A.target, this.getUI().widget))
                  break;
                P.push(".quick-input-html-widget");
              }
              const O = e.querySelectorAll(P.join(", "));
              A.shiftKey && A.target === O[0] ? (Tt.stop(A, !0), N.clearFocus()) : !A.shiftKey && xs(A.target, O[O.length - 1]) && (Tt.stop(A, !0), O[0].focus());
            }
            break;
          case 10:
            A.ctrlKey && (Tt.stop(A, !0), this.getUI().list.toggleHover());
            break;
        }
    })), this.ui = {
      container: e,
      styleSheet: t,
      leftActionBar: s,
      titleBar: n,
      title: o,
      description1: L,
      description2: d,
      widget: E,
      rightActionBar: a,
      checkAll: c,
      inputContainer: u,
      filterContainer: h,
      inputBox: f,
      visibleCountContainer: g,
      visibleCount: p,
      countContainer: m,
      count: _,
      okContainer: b,
      ok: w,
      message: x,
      customButtonContainer: y,
      customButton: S,
      list: N,
      progressBar: D,
      onDidAccept: this.onDidAcceptEmitter.event,
      onDidCustom: this.onDidCustomEmitter.event,
      onDidTriggerButton: this.onDidTriggerButtonEmitter.event,
      ignoreFocusOut: !1,
      keyMods: this.keyMods,
      show: (A) => this.show(A),
      hide: () => this.hide(),
      setVisibilities: (A) => this.setVisibilities(A),
      setEnabled: (A) => this.setEnabled(A),
      setContextKey: (A) => this.options.setContextKey(A),
      linkOpenerDelegate: (A) => this.options.linkOpenerDelegate(A)
    }, this.updateStyles(), this.ui;
  }
  pick(e, t = {}, n = jt.None) {
    return new Promise((r, s) => {
      let o = (d) => {
        var u;
        o = r, (u = t.onKeyMods) === null || u === void 0 || u.call(t, a.keyMods), r(d);
      };
      if (n.isCancellationRequested) {
        o(void 0);
        return;
      }
      const a = this.createQuickPick();
      let l;
      const c = [
        a,
        a.onDidAccept(() => {
          if (a.canSelectMany)
            o(a.selectedItems.slice()), a.hide();
          else {
            const d = a.activeItems[0];
            d && (o(d), a.hide());
          }
        }),
        a.onDidChangeActive((d) => {
          const u = d[0];
          u && t.onDidFocus && t.onDidFocus(u);
        }),
        a.onDidChangeSelection((d) => {
          if (!a.canSelectMany) {
            const u = d[0];
            u && (o(u), a.hide());
          }
        }),
        a.onDidTriggerItemButton((d) => t.onDidTriggerItemButton && t.onDidTriggerItemButton(Object.assign(Object.assign({}, d), { removeItem: () => {
          const u = a.items.indexOf(d.item);
          if (u !== -1) {
            const h = a.items.slice(), f = h.splice(u, 1), g = a.activeItems.filter((m) => m !== f[0]), p = a.keepScrollPosition;
            a.keepScrollPosition = !0, a.items = h, g && (a.activeItems = g), a.keepScrollPosition = p;
          }
        } }))),
        a.onDidTriggerSeparatorButton((d) => {
          var u;
          return (u = t.onDidTriggerSeparatorButton) === null || u === void 0 ? void 0 : u.call(t, d);
        }),
        a.onDidChangeValue((d) => {
          l && !d && (a.activeItems.length !== 1 || a.activeItems[0] !== l) && (a.activeItems = [l]);
        }),
        n.onCancellationRequested(() => {
          a.hide();
        }),
        a.onDidHide(() => {
          An(c), o(void 0);
        })
      ];
      a.title = t.title, a.canSelectMany = !!t.canPickMany, a.placeholder = t.placeHolder, a.ignoreFocusOut = !!t.ignoreFocusLost, a.matchOnDescription = !!t.matchOnDescription, a.matchOnDetail = !!t.matchOnDetail, a.matchOnLabel = t.matchOnLabel === void 0 || t.matchOnLabel, a.autoFocusOnList = t.autoFocusOnList === void 0 || t.autoFocusOnList, a.quickNavigate = t.quickNavigate, a.hideInput = !!t.hideInput, a.contextKey = t.contextKey, a.busy = !0, Promise.all([e, t.activeItem]).then(([d, u]) => {
        l = u, a.busy = !1, a.items = d, a.canSelectMany && (a.selectedItems = d.filter((h) => h.type !== "separator" && h.picked)), l && (a.activeItems = [l]);
      }), a.show(), Promise.resolve(e).then(void 0, (d) => {
        s(d), a.hide();
      });
    });
  }
  createQuickPick() {
    const e = this.getUI();
    return new pw(e);
  }
  createInputBox() {
    const e = this.getUI();
    return new VGe(e);
  }
  show(e) {
    const t = this.getUI();
    this.onShowEmitter.fire();
    const n = this.controller;
    this.controller = e, n?.didHide(), this.setEnabled(!0), t.leftActionBar.clear(), t.title.textContent = "", t.description1.textContent = "", t.description2.textContent = "", cs(t.widget), t.rightActionBar.clear(), t.checkAll.checked = !1, t.inputBox.placeholder = "", t.inputBox.password = !1, t.inputBox.showDecoration(Yi.Ignore), t.visibleCount.setCount(0), t.count.setCount(0), cs(t.message), t.progressBar.stop(), t.list.setElements([]), t.list.matchOnDescription = !1, t.list.matchOnDetail = !1, t.list.matchOnLabel = !0, t.list.sortByLabel = !0, t.ignoreFocusOut = !1, t.inputBox.toggles = void 0;
    const r = this.options.backKeybindingLabel();
    qB.tooltip = r ? C("quickInput.backWithKeybinding", "Back ({0})", r) : C("quickInput.back", "Back"), t.container.style.display = "", this.updateLayout(), t.inputBox.setFocus();
  }
  setVisibilities(e) {
    const t = this.getUI();
    t.title.style.display = e.title ? "" : "none", t.description1.style.display = e.description && (e.inputBox || e.checkAll) ? "" : "none", t.description2.style.display = e.description && !(e.inputBox || e.checkAll) ? "" : "none", t.checkAll.style.display = e.checkAll ? "" : "none", t.inputContainer.style.display = e.inputBox ? "" : "none", t.filterContainer.style.display = e.inputBox ? "" : "none", t.visibleCountContainer.style.display = e.visibleCount ? "" : "none", t.countContainer.style.display = e.count ? "" : "none", t.okContainer.style.display = e.ok ? "" : "none", t.customButtonContainer.style.display = e.customButton ? "" : "none", t.message.style.display = e.message ? "" : "none", t.progressBar.getContainer().style.display = e.progressBar ? "" : "none", t.list.display(!!e.list), t.container.classList.toggle("show-checkboxes", !!e.checkBox), t.container.classList.toggle("hidden-input", !e.inputBox && !e.description), this.updateLayout();
  }
  setEnabled(e) {
    if (e !== this.enabled) {
      this.enabled = e;
      for (const t of this.getUI().leftActionBar.viewItems)
        t.action.enabled = e;
      for (const t of this.getUI().rightActionBar.viewItems)
        t.action.enabled = e;
      this.getUI().checkAll.disabled = !e, this.getUI().inputBox.enabled = e, this.getUI().ok.enabled = e, this.getUI().list.enabled = e;
    }
  }
  hide(e) {
    var t, n, r;
    const s = this.controller;
    if (!s)
      return;
    const o = !xs(document.activeElement, (n = (t = this.ui) === null || t === void 0 ? void 0 : t.container) !== null && n !== void 0 ? n : null);
    if (this.controller = null, this.onHideEmitter.fire(), this.getUI().container.style.display = "none", !o) {
      let a = this.previousFocusElement;
      for (; a && !a.offsetParent; )
        a = (r = a.parentElement) !== null && r !== void 0 ? r : void 0;
      a?.offsetParent ? (a.focus(), this.previousFocusElement = void 0) : this.options.returnFocus();
    }
    s.didHide(e);
  }
  layout(e, t) {
    this.dimension = e, this.titleBarOffset = t, this.updateLayout();
  }
  updateLayout() {
    if (this.ui && this.isDisplayed()) {
      this.ui.container.style.top = `${this.titleBarOffset}px`;
      const e = this.ui.container.style, t = Math.min(this.dimension.width * 0.62, K4.MAX_WIDTH);
      e.width = t + "px", e.marginLeft = "-" + t / 2 + "px", this.ui.inputBox.layout(), this.ui.list.layout(this.dimension && this.dimension.height * 0.4);
    }
  }
  applyStyles(e) {
    this.styles = e, this.updateStyles();
  }
  updateStyles() {
    if (this.ui) {
      const { quickInputTitleBackground: e, quickInputBackground: t, quickInputForeground: n, widgetBorder: r, widgetShadow: s } = this.styles.widget;
      this.ui.titleBar.style.backgroundColor = e ?? "", this.ui.container.style.backgroundColor = t ?? "", this.ui.container.style.color = n ?? "", this.ui.container.style.border = r ? `1px solid ${r}` : "", this.ui.container.style.boxShadow = s ? `0 0 8px 2px ${s}` : "", this.ui.list.style(this.styles.list);
      const o = [];
      this.styles.pickerGroup.pickerGroupBorder && o.push(`.quick-input-list .quick-input-list-entry { border-top-color:  ${this.styles.pickerGroup.pickerGroupBorder}; }`), this.styles.pickerGroup.pickerGroupForeground && o.push(`.quick-input-list .quick-input-list-separator { color:  ${this.styles.pickerGroup.pickerGroupForeground}; }`), this.styles.pickerGroup.pickerGroupForeground && o.push(".quick-input-list .quick-input-list-separator-as-item { color: var(--vscode-descriptionForeground); }"), (this.styles.keybindingLabel.keybindingLabelBackground || this.styles.keybindingLabel.keybindingLabelBorder || this.styles.keybindingLabel.keybindingLabelBottomBorder || this.styles.keybindingLabel.keybindingLabelShadow || this.styles.keybindingLabel.keybindingLabelForeground) && (o.push(".quick-input-list .monaco-keybinding > .monaco-keybinding-key {"), this.styles.keybindingLabel.keybindingLabelBackground && o.push(`background-color: ${this.styles.keybindingLabel.keybindingLabelBackground};`), this.styles.keybindingLabel.keybindingLabelBorder && o.push(`border-color: ${this.styles.keybindingLabel.keybindingLabelBorder};`), this.styles.keybindingLabel.keybindingLabelBottomBorder && o.push(`border-bottom-color: ${this.styles.keybindingLabel.keybindingLabelBottomBorder};`), this.styles.keybindingLabel.keybindingLabelShadow && o.push(`box-shadow: inset 0 -1px 0 ${this.styles.keybindingLabel.keybindingLabelShadow};`), this.styles.keybindingLabel.keybindingLabelForeground && o.push(`color: ${this.styles.keybindingLabel.keybindingLabelForeground};`), o.push("}"));
      const a = o.join(`
`);
      a !== this.ui.styleSheet.textContent && (this.ui.styleSheet.textContent = a);
    }
  }
  isDisplayed() {
    return this.ui && this.ui.container.style.display !== "none";
  }
}
K4.MAX_WIDTH = 600;
var HGe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, CD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let KB = class extends CRe {
  get controller() {
    return this._controller || (this._controller = this._register(this.createController())), this._controller;
  }
  get hasController() {
    return !!this._controller;
  }
  get quickAccess() {
    return this._quickAccess || (this._quickAccess = this._register(this.instantiationService.createInstance(jB))), this._quickAccess;
  }
  constructor(e, t, n, r) {
    super(n), this.instantiationService = e, this.contextKeyService = t, this.layoutService = r, this._onShow = this._register(new pe()), this._onHide = this._register(new pe()), this.contexts = /* @__PURE__ */ new Map();
  }
  createController(e = this.layoutService, t) {
    const n = {
      idPrefix: "quickInput_",
      container: e.container,
      ignoreFocusOut: () => !1,
      backKeybindingLabel: () => {
      },
      setContextKey: (s) => this.setContextKey(s),
      linkOpenerDelegate: (s) => {
        this.instantiationService.invokeFunction((o) => {
          o.get(da).open(s, { allowCommands: !0, fromUserGesture: !0 });
        });
      },
      returnFocus: () => e.focus(),
      createList: (s, o, a, l, c) => this.instantiationService.createInstance(VB, s, o, a, l, c),
      styles: this.computeStyles()
    }, r = this._register(new K4(Object.assign(Object.assign({}, n), t), this.themeService));
    return r.layout(e.dimension, e.offset.quickPickTop), this._register(e.onDidLayout((s) => r.layout(s, e.offset.quickPickTop))), this._register(r.onShow(() => {
      this.resetContextKeys(), this._onShow.fire();
    })), this._register(r.onHide(() => {
      this.resetContextKeys(), this._onHide.fire();
    })), r;
  }
  setContextKey(e) {
    let t;
    e && (t = this.contexts.get(e), t || (t = new Ke(e, !1).bindTo(this.contextKeyService), this.contexts.set(e, t))), !(t && t.get()) && (this.resetContextKeys(), t?.set(!0));
  }
  resetContextKeys() {
    this.contexts.forEach((e) => {
      e.get() && e.reset();
    });
  }
  pick(e, t = {}, n = jt.None) {
    return this.controller.pick(e, t, n);
  }
  createQuickPick() {
    return this.controller.createQuickPick();
  }
  createInputBox() {
    return this.controller.createInputBox();
  }
  updateStyles() {
    this.hasController && this.controller.applyStyles(this.computeStyles());
  }
  computeStyles() {
    return {
      widget: {
        quickInputBackground: Ye(hZ),
        quickInputForeground: Ye(EMe),
        quickInputTitleBackground: Ye(LMe),
        widgetBorder: Ye(hz),
        widgetShadow: Ye(Qd)
      },
      inputBox: WL,
      toggle: HL,
      countBadge: ype,
      button: Yze,
      progressBar: Xze,
      keybindingLabel: Kze,
      list: Cb({
        listBackground: hZ,
        listFocusBackground: hm,
        listFocusForeground: um,
        // Look like focused when inactive.
        listInactiveFocusForeground: um,
        listInactiveSelectionIconForeground: $1,
        listInactiveFocusBackground: hm,
        listFocusOutline: ii,
        listInactiveFocusOutline: ii
      }),
      pickerGroup: {
        pickerGroupBorder: Ye(IMe),
        pickerGroupForeground: Ye(kfe)
      }
    };
  }
};
KB = HGe([
  CD(0, bt),
  CD(1, yt),
  CD(2, Pr),
  CD(3, bb)
], KB);
var Qpe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, hv = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let YB = class extends KB {
  constructor(e, t, n, r, s) {
    super(t, n, r, new eB(e.getContainerDomNode(), s)), this.host = void 0;
    const o = P_.get(e);
    if (o) {
      const a = o.widget;
      this.host = {
        _serviceBrand: void 0,
        get hasContainer() {
          return !0;
        },
        get container() {
          return a.getDomNode();
        },
        get dimension() {
          return e.getLayoutInfo();
        },
        get onDidLayout() {
          return e.onDidLayoutChange;
        },
        focus: () => e.focus(),
        offset: { top: 0, quickPickTop: 0 }
      };
    } else
      this.host = void 0;
  }
  createController() {
    return super.createController(this.host);
  }
};
YB = Qpe([
  hv(1, bt),
  hv(2, yt),
  hv(3, Pr),
  hv(4, Sn)
], YB);
let XB = class {
  get activeService() {
    const e = this.codeEditorService.getFocusedCodeEditor();
    if (!e)
      throw new Error("Quick input service needs a focused editor to work.");
    let t = this.mapEditorToService.get(e);
    if (!t) {
      const n = t = this.instantiationService.createInstance(YB, e);
      this.mapEditorToService.set(e, t), Ng(e.onDidDispose)(() => {
        n.dispose(), this.mapEditorToService.delete(e);
      });
    }
    return t;
  }
  get quickAccess() {
    return this.activeService.quickAccess;
  }
  constructor(e, t) {
    this.instantiationService = e, this.codeEditorService = t, this.mapEditorToService = /* @__PURE__ */ new Map();
  }
  pick(e, t = {}, n = jt.None) {
    return this.activeService.pick(e, t, n);
  }
  createQuickPick() {
    return this.activeService.createQuickPick();
  }
  createInputBox() {
    return this.activeService.createInputBox();
  }
};
XB = Qpe([
  hv(0, bt),
  hv(1, Sn)
], XB);
class P_ {
  static get(e) {
    return e.getContribution(P_.ID);
  }
  constructor(e) {
    this.editor = e, this.widget = new Y4(this.editor);
  }
  dispose() {
    this.widget.dispose();
  }
}
P_.ID = "editor.controller.quickInput";
class Y4 {
  constructor(e) {
    this.codeEditor = e, this.domNode = document.createElement("div"), this.codeEditor.addOverlayWidget(this);
  }
  getId() {
    return Y4.ID;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return {
      preference: 2
      /* OverlayWidgetPositionPreference.TOP_CENTER */
    };
  }
  dispose() {
    this.codeEditor.removeOverlayWidget(this);
  }
}
Y4.ID = "editor.contrib.quickInputWidget";
pn(
  P_.ID,
  P_,
  4
  /* EditorContributionInstantiation.Lazy */
);
class WGe {
  constructor(e, t, n, r, s) {
    this._parsedThemeRuleBrand = void 0, this.token = e, this.index = t, this.fontStyle = n, this.foreground = r, this.background = s;
  }
}
function jGe(i) {
  if (!i || !Array.isArray(i))
    return [];
  const e = [];
  let t = 0;
  for (let n = 0, r = i.length; n < r; n++) {
    const s = i[n];
    let o = -1;
    if (typeof s.fontStyle == "string") {
      o = 0;
      const c = s.fontStyle.split(" ");
      for (let d = 0, u = c.length; d < u; d++)
        switch (c[d]) {
          case "italic":
            o = o | 1;
            break;
          case "bold":
            o = o | 2;
            break;
          case "underline":
            o = o | 4;
            break;
          case "strikethrough":
            o = o | 8;
            break;
        }
    }
    let a = null;
    typeof s.foreground == "string" && (a = s.foreground);
    let l = null;
    typeof s.background == "string" && (l = s.background), e[t++] = new WGe(s.token || "", n, o, a, l);
  }
  return e;
}
function zGe(i, e) {
  i.sort((d, u) => {
    const h = YGe(d.token, u.token);
    return h !== 0 ? h : d.index - u.index;
  });
  let t = 0, n = "000000", r = "ffffff";
  for (; i.length >= 1 && i[0].token === ""; ) {
    const d = i.shift();
    d.fontStyle !== -1 && (t = d.fontStyle), d.foreground !== null && (n = d.foreground), d.background !== null && (r = d.background);
  }
  const s = new GGe();
  for (const d of e)
    s.getId(d);
  const o = s.getId(n), a = s.getId(r), l = new AU(t, o, a), c = new kU(l);
  for (let d = 0, u = i.length; d < u; d++) {
    const h = i[d];
    c.insert(h.token, h.fontStyle, s.getId(h.foreground), s.getId(h.background));
  }
  return new Jpe(s, c);
}
const UGe = /^#?([0-9A-Fa-f]{6})([0-9A-Fa-f]{2})?$/;
class GGe {
  constructor() {
    this._lastColorId = 0, this._id2color = [], this._color2id = /* @__PURE__ */ new Map();
  }
  getId(e) {
    if (e === null)
      return 0;
    const t = e.match(UGe);
    if (!t)
      throw new Error("Illegal value for token color: " + e);
    e = t[1].toUpperCase();
    let n = this._color2id.get(e);
    return n || (n = ++this._lastColorId, this._color2id.set(e, n), this._id2color[n] = ye.fromHex("#" + e), n);
  }
  getColorMap() {
    return this._id2color.slice(0);
  }
}
class Jpe {
  static createFromRawTokenTheme(e, t) {
    return this.createFromParsedTokenTheme(jGe(e), t);
  }
  static createFromParsedTokenTheme(e, t) {
    return zGe(e, t);
  }
  constructor(e, t) {
    this._colorMap = e, this._root = t, this._cache = /* @__PURE__ */ new Map();
  }
  getColorMap() {
    return this._colorMap.getColorMap();
  }
  _match(e) {
    return this._root.match(e);
  }
  match(e, t) {
    let n = this._cache.get(t);
    if (typeof n > "u") {
      const r = this._match(t), s = KGe(t);
      n = (r.metadata | s << 8) >>> 0, this._cache.set(t, n);
    }
    return (n | e << 0) >>> 0;
  }
}
const qGe = /\b(comment|string|regex|regexp)\b/;
function KGe(i) {
  const e = i.match(qGe);
  if (!e)
    return 0;
  switch (e[1]) {
    case "comment":
      return 1;
    case "string":
      return 2;
    case "regex":
      return 3;
    case "regexp":
      return 3;
  }
  throw new Error("Unexpected match for standard token type!");
}
function YGe(i, e) {
  return i < e ? -1 : i > e ? 1 : 0;
}
class AU {
  constructor(e, t, n) {
    this._themeTrieElementRuleBrand = void 0, this._fontStyle = e, this._foreground = t, this._background = n, this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
  }
  clone() {
    return new AU(this._fontStyle, this._foreground, this._background);
  }
  acceptOverwrite(e, t, n) {
    e !== -1 && (this._fontStyle = e), t !== 0 && (this._foreground = t), n !== 0 && (this._background = n), this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
  }
}
class kU {
  constructor(e) {
    this._themeTrieElementBrand = void 0, this._mainRule = e, this._children = /* @__PURE__ */ new Map();
  }
  match(e) {
    if (e === "")
      return this._mainRule;
    const t = e.indexOf(".");
    let n, r;
    t === -1 ? (n = e, r = "") : (n = e.substring(0, t), r = e.substring(t + 1));
    const s = this._children.get(n);
    return typeof s < "u" ? s.match(r) : this._mainRule;
  }
  insert(e, t, n, r) {
    if (e === "") {
      this._mainRule.acceptOverwrite(t, n, r);
      return;
    }
    const s = e.indexOf(".");
    let o, a;
    s === -1 ? (o = e, a = "") : (o = e.substring(0, s), a = e.substring(s + 1));
    let l = this._children.get(o);
    typeof l > "u" && (l = new kU(this._mainRule.clone()), this._children.set(o, l)), l.insert(a, t, n, r);
  }
}
function XGe(i) {
  const e = [];
  for (let t = 1, n = i.length; t < n; t++) {
    const r = i[t];
    e[t] = `.mtk${t} { color: ${r}; }`;
  }
  return e.push(".mtki { font-style: italic; }"), e.push(".mtkb { font-weight: bold; }"), e.push(".mtku { text-decoration: underline; text-underline-position: under; }"), e.push(".mtks { text-decoration: line-through; }"), e.push(".mtks.mtku { text-decoration: underline line-through; text-underline-position: under; }"), e.join(`
`);
}
const ZGe = {
  base: "vs",
  inherit: !1,
  rules: [
    { token: "", foreground: "000000", background: "fffffe" },
    { token: "invalid", foreground: "cd3131" },
    { token: "emphasis", fontStyle: "italic" },
    { token: "strong", fontStyle: "bold" },
    { token: "variable", foreground: "001188" },
    { token: "variable.predefined", foreground: "4864AA" },
    { token: "constant", foreground: "dd0000" },
    { token: "comment", foreground: "008000" },
    { token: "number", foreground: "098658" },
    { token: "number.hex", foreground: "3030c0" },
    { token: "regexp", foreground: "800000" },
    { token: "annotation", foreground: "808080" },
    { token: "type", foreground: "008080" },
    { token: "delimiter", foreground: "000000" },
    { token: "delimiter.html", foreground: "383838" },
    { token: "delimiter.xml", foreground: "0000FF" },
    { token: "tag", foreground: "800000" },
    { token: "tag.id.pug", foreground: "4F76AC" },
    { token: "tag.class.pug", foreground: "4F76AC" },
    { token: "meta.scss", foreground: "800000" },
    { token: "metatag", foreground: "e00000" },
    { token: "metatag.content.html", foreground: "FF0000" },
    { token: "metatag.html", foreground: "808080" },
    { token: "metatag.xml", foreground: "808080" },
    { token: "metatag.php", fontStyle: "bold" },
    { token: "key", foreground: "863B00" },
    { token: "string.key.json", foreground: "A31515" },
    { token: "string.value.json", foreground: "0451A5" },
    { token: "attribute.name", foreground: "FF0000" },
    { token: "attribute.value", foreground: "0451A5" },
    { token: "attribute.value.number", foreground: "098658" },
    { token: "attribute.value.unit", foreground: "098658" },
    { token: "attribute.value.html", foreground: "0000FF" },
    { token: "attribute.value.xml", foreground: "0000FF" },
    { token: "string", foreground: "A31515" },
    { token: "string.html", foreground: "0000FF" },
    { token: "string.sql", foreground: "FF0000" },
    { token: "string.yaml", foreground: "0451A5" },
    { token: "keyword", foreground: "0000FF" },
    { token: "keyword.json", foreground: "0451A5" },
    { token: "keyword.flow", foreground: "AF00DB" },
    { token: "keyword.flow.scss", foreground: "0000FF" },
    { token: "operator.scss", foreground: "666666" },
    { token: "operator.sql", foreground: "778899" },
    { token: "operator.swift", foreground: "666666" },
    { token: "predefined.sql", foreground: "C700C7" }
  ],
  colors: {
    [Nr]: "#FFFFFE",
    [Ul]: "#000000",
    [Tfe]: "#E5EBF1",
    [NS]: "#D3D3D3",
    [PS]: "#939393",
    [pz]: "#ADD6FF4D"
  }
}, QGe = {
  base: "vs-dark",
  inherit: !1,
  rules: [
    { token: "", foreground: "D4D4D4", background: "1E1E1E" },
    { token: "invalid", foreground: "f44747" },
    { token: "emphasis", fontStyle: "italic" },
    { token: "strong", fontStyle: "bold" },
    { token: "variable", foreground: "74B0DF" },
    { token: "variable.predefined", foreground: "4864AA" },
    { token: "variable.parameter", foreground: "9CDCFE" },
    { token: "constant", foreground: "569CD6" },
    { token: "comment", foreground: "608B4E" },
    { token: "number", foreground: "B5CEA8" },
    { token: "number.hex", foreground: "5BB498" },
    { token: "regexp", foreground: "B46695" },
    { token: "annotation", foreground: "cc6666" },
    { token: "type", foreground: "3DC9B0" },
    { token: "delimiter", foreground: "DCDCDC" },
    { token: "delimiter.html", foreground: "808080" },
    { token: "delimiter.xml", foreground: "808080" },
    { token: "tag", foreground: "569CD6" },
    { token: "tag.id.pug", foreground: "4F76AC" },
    { token: "tag.class.pug", foreground: "4F76AC" },
    { token: "meta.scss", foreground: "A79873" },
    { token: "meta.tag", foreground: "CE9178" },
    { token: "metatag", foreground: "DD6A6F" },
    { token: "metatag.content.html", foreground: "9CDCFE" },
    { token: "metatag.html", foreground: "569CD6" },
    { token: "metatag.xml", foreground: "569CD6" },
    { token: "metatag.php", fontStyle: "bold" },
    { token: "key", foreground: "9CDCFE" },
    { token: "string.key.json", foreground: "9CDCFE" },
    { token: "string.value.json", foreground: "CE9178" },
    { token: "attribute.name", foreground: "9CDCFE" },
    { token: "attribute.value", foreground: "CE9178" },
    { token: "attribute.value.number.css", foreground: "B5CEA8" },
    { token: "attribute.value.unit.css", foreground: "B5CEA8" },
    { token: "attribute.value.hex.css", foreground: "D4D4D4" },
    { token: "string", foreground: "CE9178" },
    { token: "string.sql", foreground: "FF0000" },
    { token: "keyword", foreground: "569CD6" },
    { token: "keyword.flow", foreground: "C586C0" },
    { token: "keyword.json", foreground: "CE9178" },
    { token: "keyword.flow.scss", foreground: "569CD6" },
    { token: "operator.scss", foreground: "909090" },
    { token: "operator.sql", foreground: "778899" },
    { token: "operator.swift", foreground: "909090" },
    { token: "predefined.sql", foreground: "FF00FF" }
  ],
  colors: {
    [Nr]: "#1E1E1E",
    [Ul]: "#D4D4D4",
    [Tfe]: "#3A3D41",
    [NS]: "#404040",
    [PS]: "#707070",
    [pz]: "#ADD6FF26"
  }
}, JGe = {
  base: "hc-black",
  inherit: !1,
  rules: [
    { token: "", foreground: "FFFFFF", background: "000000" },
    { token: "invalid", foreground: "f44747" },
    { token: "emphasis", fontStyle: "italic" },
    { token: "strong", fontStyle: "bold" },
    { token: "variable", foreground: "1AEBFF" },
    { token: "variable.parameter", foreground: "9CDCFE" },
    { token: "constant", foreground: "569CD6" },
    { token: "comment", foreground: "608B4E" },
    { token: "number", foreground: "FFFFFF" },
    { token: "regexp", foreground: "C0C0C0" },
    { token: "annotation", foreground: "569CD6" },
    { token: "type", foreground: "3DC9B0" },
    { token: "delimiter", foreground: "FFFF00" },
    { token: "delimiter.html", foreground: "FFFF00" },
    { token: "tag", foreground: "569CD6" },
    { token: "tag.id.pug", foreground: "4F76AC" },
    { token: "tag.class.pug", foreground: "4F76AC" },
    { token: "meta", foreground: "D4D4D4" },
    { token: "meta.tag", foreground: "CE9178" },
    { token: "metatag", foreground: "569CD6" },
    { token: "metatag.content.html", foreground: "1AEBFF" },
    { token: "metatag.html", foreground: "569CD6" },
    { token: "metatag.xml", foreground: "569CD6" },
    { token: "metatag.php", fontStyle: "bold" },
    { token: "key", foreground: "9CDCFE" },
    { token: "string.key", foreground: "9CDCFE" },
    { token: "string.value", foreground: "CE9178" },
    { token: "attribute.name", foreground: "569CD6" },
    { token: "attribute.value", foreground: "3FF23F" },
    { token: "string", foreground: "CE9178" },
    { token: "string.sql", foreground: "FF0000" },
    { token: "keyword", foreground: "569CD6" },
    { token: "keyword.flow", foreground: "C586C0" },
    { token: "operator.sql", foreground: "778899" },
    { token: "operator.swift", foreground: "909090" },
    { token: "predefined.sql", foreground: "FF00FF" }
  ],
  colors: {
    [Nr]: "#000000",
    [Ul]: "#FFFFFF",
    [NS]: "#FFFFFF",
    [PS]: "#FFFFFF"
  }
}, $Ge = {
  base: "hc-light",
  inherit: !1,
  rules: [
    { token: "", foreground: "292929", background: "FFFFFF" },
    { token: "invalid", foreground: "B5200D" },
    { token: "emphasis", fontStyle: "italic" },
    { token: "strong", fontStyle: "bold" },
    { token: "variable", foreground: "264F70" },
    { token: "variable.predefined", foreground: "4864AA" },
    { token: "constant", foreground: "dd0000" },
    { token: "comment", foreground: "008000" },
    { token: "number", foreground: "098658" },
    { token: "number.hex", foreground: "3030c0" },
    { token: "regexp", foreground: "800000" },
    { token: "annotation", foreground: "808080" },
    { token: "type", foreground: "008080" },
    { token: "delimiter", foreground: "000000" },
    { token: "delimiter.html", foreground: "383838" },
    { token: "tag", foreground: "800000" },
    { token: "tag.id.pug", foreground: "4F76AC" },
    { token: "tag.class.pug", foreground: "4F76AC" },
    { token: "meta.scss", foreground: "800000" },
    { token: "metatag", foreground: "e00000" },
    { token: "metatag.content.html", foreground: "B5200D" },
    { token: "metatag.html", foreground: "808080" },
    { token: "metatag.xml", foreground: "808080" },
    { token: "metatag.php", fontStyle: "bold" },
    { token: "key", foreground: "863B00" },
    { token: "string.key.json", foreground: "A31515" },
    { token: "string.value.json", foreground: "0451A5" },
    { token: "attribute.name", foreground: "264F78" },
    { token: "attribute.value", foreground: "0451A5" },
    { token: "string", foreground: "A31515" },
    { token: "string.sql", foreground: "B5200D" },
    { token: "keyword", foreground: "0000FF" },
    { token: "keyword.flow", foreground: "AF00DB" },
    { token: "operator.sql", foreground: "778899" },
    { token: "operator.swift", foreground: "666666" },
    { token: "predefined.sql", foreground: "C700C7" }
  ],
  colors: {
    [Nr]: "#FFFFFF",
    [Ul]: "#292929",
    [NS]: "#292929",
    [PS]: "#292929"
  }
}, eqe = {
  IconContribution: "base.contributions.icons"
};
var SJ;
(function(i) {
  function e(t, n) {
    let r = t.defaults;
    for (; ft.isThemeIcon(r); ) {
      const s = W0.getIcon(r.id);
      if (!s)
        return;
      r = s.defaults;
    }
    return r;
  }
  i.getDefinition = e;
})(SJ || (SJ = {}));
var xJ;
(function(i) {
  function e(n) {
    return {
      weight: n.weight,
      style: n.style,
      src: n.src.map((r) => ({ format: r.format, location: r.location.toString() }))
    };
  }
  i.toJSONObject = e;
  function t(n) {
    const r = (s) => mo(s) ? s : void 0;
    if (n && Array.isArray(n.src) && n.src.every((s) => mo(s.format) && mo(s.location)))
      return {
        weight: r(n.weight),
        style: r(n.style),
        src: n.src.map((s) => ({ format: s.format, location: pt.parse(s.location) }))
      };
  }
  i.fromJSONObject = t;
})(xJ || (xJ = {}));
class tqe {
  constructor() {
    this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event, this.iconSchema = {
      definitions: {
        icons: {
          type: "object",
          properties: {
            fontId: { type: "string", description: C("iconDefinition.fontId", "The id of the font to use. If not set, the font that is defined first is used.") },
            fontCharacter: { type: "string", description: C("iconDefinition.fontCharacter", "The font character associated with the icon definition.") }
          },
          additionalProperties: !1,
          defaultSnippets: [{ body: { fontCharacter: "\\\\e030" } }]
        }
      },
      type: "object",
      properties: {}
    }, this.iconReferenceSchema = { type: "string", pattern: `^${ft.iconNameExpression}$`, enum: [], enumDescriptions: [] }, this.iconsById = {}, this.iconFontsById = {};
  }
  registerIcon(e, t, n, r) {
    const s = this.iconsById[e];
    if (s) {
      if (n && !s.description) {
        s.description = n, this.iconSchema.properties[e].markdownDescription = `${n} $(${e})`;
        const l = this.iconReferenceSchema.enum.indexOf(e);
        l !== -1 && (this.iconReferenceSchema.enumDescriptions[l] = n), this._onDidChange.fire();
      }
      return s;
    }
    const o = { id: e, description: n, defaults: t, deprecationMessage: r };
    this.iconsById[e] = o;
    const a = { $ref: "#/definitions/icons" };
    return r && (a.deprecationMessage = r), n && (a.markdownDescription = `${n}: $(${e})`), this.iconSchema.properties[e] = a, this.iconReferenceSchema.enum.push(e), this.iconReferenceSchema.enumDescriptions.push(n || ""), this._onDidChange.fire(), { id: e };
  }
  getIcons() {
    return Object.keys(this.iconsById).map((e) => this.iconsById[e]);
  }
  getIcon(e) {
    return this.iconsById[e];
  }
  getIconSchema() {
    return this.iconSchema;
  }
  toString() {
    const e = (s, o) => s.id.localeCompare(o.id), t = (s) => {
      for (; ft.isThemeIcon(s.defaults); )
        s = this.iconsById[s.defaults.id];
      return `codicon codicon-${s ? s.id : ""}`;
    }, n = [];
    n.push("| preview     | identifier                        | default codicon ID                | description"), n.push("| ----------- | --------------------------------- | --------------------------------- | --------------------------------- |");
    const r = Object.keys(this.iconsById).map((s) => this.iconsById[s]);
    for (const s of r.filter((o) => !!o.description).sort(e))
      n.push(`|<i class="${t(s)}"></i>|${s.id}|${ft.isThemeIcon(s.defaults) ? s.defaults.id : s.id}|${s.description || ""}|`);
    n.push("| preview     | identifier                        "), n.push("| ----------- | --------------------------------- |");
    for (const s of r.filter((o) => !ft.isThemeIcon(o.defaults)).sort(e))
      n.push(`|<i class="${t(s)}"></i>|${s.id}|`);
    return n.join(`
`);
  }
}
const W0 = new tqe();
Di.add(eqe.IconContribution, W0);
function $i(i, e, t, n) {
  return W0.registerIcon(i, e, t, n);
}
function $pe() {
  return W0;
}
function nqe() {
  const i = ahe();
  for (const e in i) {
    const t = "\\" + i[e].toString(16);
    W0.registerIcon(e, { fontCharacter: t });
  }
}
nqe();
const eme = "vscode://schemas/icons", tme = Di.as(d4.JSONContribution);
tme.registerSchema(eme, W0.getIconSchema());
const DJ = new Rn(() => tme.notifySchemaChanged(eme), 200);
W0.onDidChange(() => {
  DJ.isScheduled() || DJ.schedule();
});
const nme = $i("widget-close", We.close, C("widgetClose", "Icon for the close action in widgets."));
$i("goto-previous-location", We.arrowUp, C("previousChangeIcon", "Icon for goto previous editor location."));
$i("goto-next-location", We.arrowDown, C("nextChangeIcon", "Icon for goto next editor location."));
ft.modify(We.sync, "spin");
ft.modify(We.loading, "spin");
function iqe(i) {
  const e = new Ne(), t = e.add(new pe()), n = $pe();
  return e.add(n.onDidChange(() => t.fire())), i && e.add(i.onDidProductIconThemeChange(() => t.fire())), {
    dispose: () => e.dispose(),
    onDidChange: t.event,
    getCSS() {
      const r = i ? i.getProductIconTheme() : new ime(), s = {}, o = (l) => {
        const c = r.getIcon(l);
        if (!c)
          return;
        const d = c.font;
        return d ? (s[d.id] = d.definition, `.codicon-${l.id}:before { content: '${c.fontCharacter}'; font-family: ${_X(d.id)}; }`) : `.codicon-${l.id}:before { content: '${c.fontCharacter}'; }`;
      }, a = [];
      for (const l of n.getIcons()) {
        const c = o(l);
        c && a.push(c);
      }
      for (const l in s) {
        const c = s[l], d = c.weight ? `font-weight: ${c.weight};` : "", u = c.style ? `font-style: ${c.style};` : "", h = c.src.map((f) => `${Og(f.location)} format('${f.format}')`).join(", ");
        a.push(`@font-face { src: ${h}; font-family: ${_X(l)};${d}${u} font-display: block; }`);
      }
      return a.join(`
`);
    }
  };
}
class ime {
  getIcon(e) {
    const t = $pe();
    let n = e.defaults;
    for (; ft.isThemeIcon(n); ) {
      const r = t.getIcon(n.id);
      if (!r)
        return;
      n = r.defaults;
    }
    return n;
  }
}
const Ch = "vs", qv = "vs-dark", km = "hc-black", Tm = "hc-light", rme = Di.as(Efe.ColorContribution), rqe = Di.as(zfe.ThemingContribution);
class sme {
  constructor(e, t) {
    this.semanticHighlighting = !1, this.themeData = t;
    const n = t.base;
    e.length > 0 ? (nE(e) ? this.id = e : this.id = n + " " + e, this.themeName = e) : (this.id = n, this.themeName = n), this.colors = null, this.defaultColors = /* @__PURE__ */ Object.create(null), this._tokenTheme = null;
  }
  get base() {
    return this.themeData.base;
  }
  notifyBaseUpdated() {
    this.themeData.inherit && (this.colors = null, this._tokenTheme = null);
  }
  getColors() {
    if (!this.colors) {
      const e = /* @__PURE__ */ new Map();
      for (const t in this.themeData.colors)
        e.set(t, ye.fromHex(this.themeData.colors[t]));
      if (this.themeData.inherit) {
        const t = ZB(this.themeData.base);
        for (const n in t.colors)
          e.has(n) || e.set(n, ye.fromHex(t.colors[n]));
      }
      this.colors = e;
    }
    return this.colors;
  }
  getColor(e, t) {
    const n = this.getColors().get(e);
    if (n)
      return n;
    if (t !== !1)
      return this.getDefault(e);
  }
  getDefault(e) {
    let t = this.defaultColors[e];
    return t || (t = rme.resolveDefaultColor(e, this), this.defaultColors[e] = t, t);
  }
  defines(e) {
    return this.getColors().has(e);
  }
  get type() {
    switch (this.base) {
      case Ch:
        return dl.LIGHT;
      case km:
        return dl.HIGH_CONTRAST_DARK;
      case Tm:
        return dl.HIGH_CONTRAST_LIGHT;
      default:
        return dl.DARK;
    }
  }
  get tokenTheme() {
    if (!this._tokenTheme) {
      let e = [], t = [];
      if (this.themeData.inherit) {
        const s = ZB(this.themeData.base);
        e = s.rules, s.encodedTokensColors && (t = s.encodedTokensColors);
      }
      const n = this.themeData.colors["editor.foreground"], r = this.themeData.colors["editor.background"];
      if (n || r) {
        const s = { token: "" };
        n && (s.foreground = n), r && (s.background = r), e.push(s);
      }
      e = e.concat(this.themeData.rules), this.themeData.encodedTokensColors && (t = this.themeData.encodedTokensColors), this._tokenTheme = Jpe.createFromRawTokenTheme(e, t);
    }
    return this._tokenTheme;
  }
  getTokenStyleMetadata(e, t, n) {
    const s = this.tokenTheme._match([e].concat(t).join(".")).metadata, o = Cs.getForeground(s), a = Cs.getFontStyle(s);
    return {
      foreground: o,
      italic: !!(a & 1),
      bold: !!(a & 2),
      underline: !!(a & 4),
      strikethrough: !!(a & 8)
    };
  }
}
function nE(i) {
  return i === Ch || i === qv || i === km || i === Tm;
}
function ZB(i) {
  switch (i) {
    case Ch:
      return ZGe;
    case qv:
      return QGe;
    case km:
      return JGe;
    case Tm:
      return $Ge;
  }
}
function yD(i) {
  const e = ZB(i);
  return new sme(i, e);
}
class sqe extends we {
  constructor() {
    super(), this._onColorThemeChange = this._register(new pe()), this.onDidColorThemeChange = this._onColorThemeChange.event, this._onProductIconThemeChange = this._register(new pe()), this.onDidProductIconThemeChange = this._onProductIconThemeChange.event, this._environment = /* @__PURE__ */ Object.create(null), this._builtInProductIconTheme = new ime(), this._autoDetectHighContrast = !0, this._knownThemes = /* @__PURE__ */ new Map(), this._knownThemes.set(Ch, yD(Ch)), this._knownThemes.set(qv, yD(qv)), this._knownThemes.set(km, yD(km)), this._knownThemes.set(Tm, yD(Tm));
    const e = this._register(iqe(this));
    this._codiconCSS = e.getCSS(), this._themeCSS = "", this._allCSS = `${this._codiconCSS}
${this._themeCSS}`, this._globalStyleElement = null, this._styleElements = [], this._colorMapOverride = null, this.setTheme(Ch), this._onOSSchemeChanged(), this._register(e.onDidChange(() => {
      this._codiconCSS = e.getCSS(), this._updateCSS();
    })), _he("(forced-colors: active)", () => {
      this._onOSSchemeChanged();
    });
  }
  registerEditorContainer(e) {
    return JE(e) ? this._registerShadowDomContainer(e) : this._registerRegularEditorContainer();
  }
  _registerRegularEditorContainer() {
    return this._globalStyleElement || (this._globalStyleElement = yl(void 0, (e) => {
      e.className = "monaco-colors", e.textContent = this._allCSS;
    }), this._styleElements.push(this._globalStyleElement)), we.None;
  }
  _registerShadowDomContainer(e) {
    const t = yl(e, (n) => {
      n.className = "monaco-colors", n.textContent = this._allCSS;
    });
    return this._styleElements.push(t), {
      dispose: () => {
        for (let n = 0; n < this._styleElements.length; n++)
          if (this._styleElements[n] === t) {
            this._styleElements.splice(n, 1);
            return;
          }
      }
    };
  }
  defineTheme(e, t) {
    if (!/^[a-z0-9\-]+$/i.test(e))
      throw new Error("Illegal theme name!");
    if (!nE(t.base) && !nE(e))
      throw new Error("Illegal theme base!");
    this._knownThemes.set(e, new sme(e, t)), nE(e) && this._knownThemes.forEach((n) => {
      n.base === e && n.notifyBaseUpdated();
    }), this._theme.themeName === e && this.setTheme(e);
  }
  getColorTheme() {
    return this._theme;
  }
  setColorMapOverride(e) {
    this._colorMapOverride = e, this._updateThemeOrColorMap();
  }
  setTheme(e) {
    let t;
    this._knownThemes.has(e) ? t = this._knownThemes.get(e) : t = this._knownThemes.get(Ch), this._updateActualTheme(t);
  }
  _updateActualTheme(e) {
    !e || this._theme === e || (this._theme = e, this._updateThemeOrColorMap());
  }
  _onOSSchemeChanged() {
    if (this._autoDetectHighContrast) {
      const e = window.matchMedia("(forced-colors: active)").matches;
      if (e !== ed(this._theme.type)) {
        let t;
        w_(this._theme.type) ? t = e ? km : qv : t = e ? Tm : Ch, this._updateActualTheme(this._knownThemes.get(t));
      }
    }
  }
  setAutoDetectHighContrast(e) {
    this._autoDetectHighContrast = e, this._onOSSchemeChanged();
  }
  _updateThemeOrColorMap() {
    const e = [], t = {}, n = {
      addRule: (o) => {
        t[o] || (e.push(o), t[o] = !0);
      }
    };
    rqe.getThemingParticipants().forEach((o) => o(this._theme, n, this._environment));
    const r = [];
    for (const o of rme.getColors()) {
      const a = this._theme.getColor(o.id, !0);
      a && r.push(`${uz(o.id)}: ${a.toString()};`);
    }
    n.addRule(`.monaco-editor, .monaco-diff-editor { ${r.join(`
`)} }`);
    const s = this._colorMapOverride || this._theme.tokenTheme.getColorMap();
    n.addRule(XGe(s)), this._themeCSS = e.join(`
`), this._updateCSS(), Pi.setColorMap(s), this._onColorThemeChange.fire(this._theme);
  }
  _updateCSS() {
    this._allCSS = `${this._codiconCSS}
${this._themeCSS}`, this._styleElements.forEach((e) => e.textContent = this._allCSS);
  }
  getFileIconTheme() {
    return {
      hasFileIcons: !1,
      hasFolderIcons: !1,
      hidesExplorerArrows: !1
    };
  }
  getProductIconTheme() {
    return this._builtInProductIconTheme;
  }
}
const Ya = Gt("themeService");
var oqe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, vT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let QB = class extends we {
  constructor(e, t, n) {
    super(), this._contextKeyService = e, this._layoutService = t, this._configurationService = n, this._accessibilitySupport = 0, this._onDidChangeScreenReaderOptimized = new pe(), this._onDidChangeReducedMotion = new pe(), this._accessibilityModeEnabledContext = LS.bindTo(this._contextKeyService);
    const r = () => this._accessibilityModeEnabledContext.set(this.isScreenReaderOptimized());
    this._register(this._configurationService.onDidChangeConfiguration((o) => {
      o.affectsConfiguration("editor.accessibilitySupport") && (r(), this._onDidChangeScreenReaderOptimized.fire()), o.affectsConfiguration("workbench.reduceMotion") && (this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion"), this._onDidChangeReducedMotion.fire());
    })), r(), this._register(this.onDidChangeScreenReaderOptimized(() => r()));
    const s = window.matchMedia("(prefers-reduced-motion: reduce)");
    this._systemMotionReduced = s.matches, this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion"), this.initReducedMotionListeners(s);
  }
  initReducedMotionListeners(e) {
    if (!this._layoutService.hasContainer)
      return;
    this._register(Ie(e, "change", () => {
      this._systemMotionReduced = e.matches, this._configMotionReduced === "auto" && this._onDidChangeReducedMotion.fire();
    }));
    const t = () => {
      const n = this.isMotionReduced();
      this._layoutService.container.classList.toggle("reduce-motion", n), this._layoutService.container.classList.toggle("enable-motion", !n);
    };
    t(), this._register(this.onDidChangeReducedMotion(() => t()));
  }
  get onDidChangeScreenReaderOptimized() {
    return this._onDidChangeScreenReaderOptimized.event;
  }
  isScreenReaderOptimized() {
    const e = this._configurationService.getValue("editor.accessibilitySupport");
    return e === "on" || e === "auto" && this._accessibilitySupport === 2;
  }
  get onDidChangeReducedMotion() {
    return this._onDidChangeReducedMotion.event;
  }
  isMotionReduced() {
    const e = this._configMotionReduced;
    return e === "on" || e === "auto" && this._systemMotionReduced;
  }
  getAccessibilitySupport() {
    return this._accessibilitySupport;
  }
};
QB = oqe([
  vT(0, yt),
  vT(1, bb),
  vT(2, en)
], QB);
var X4 = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, n0 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, F1, Nf;
let JB = class {
  constructor(e, t) {
    this._commandService = e, this._hiddenStates = new eI(t);
  }
  createMenu(e, t, n) {
    return new eV(e, this._hiddenStates, Object.assign({ emitEventsForSubmenuChanges: !1, eventDebounceDelay: 50 }, n), this._commandService, t);
  }
  resetHiddenStates(e) {
    this._hiddenStates.reset(e);
  }
};
JB = X4([
  n0(0, Ui),
  n0(1, mc)
], JB);
let eI = F1 = class {
  constructor(e) {
    this._storageService = e, this._disposables = new Ne(), this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event, this._ignoreChangeEvent = !1, this._hiddenByDefaultCache = /* @__PURE__ */ new Map();
    try {
      const t = e.get(F1._key, 0, "{}");
      this._data = JSON.parse(t);
    } catch {
      this._data = /* @__PURE__ */ Object.create(null);
    }
    this._disposables.add(e.onDidChangeValue(0, F1._key, this._disposables)(() => {
      if (!this._ignoreChangeEvent)
        try {
          const t = e.get(F1._key, 0, "{}");
          this._data = JSON.parse(t);
        } catch (t) {
          console.log("FAILED to read storage after UPDATE", t);
        }
      this._onDidChange.fire();
    }));
  }
  dispose() {
    this._onDidChange.dispose(), this._disposables.dispose();
  }
  _isHiddenByDefault(e, t) {
    var n;
    return (n = this._hiddenByDefaultCache.get(`${e.id}/${t}`)) !== null && n !== void 0 ? n : !1;
  }
  setDefaultState(e, t, n) {
    this._hiddenByDefaultCache.set(`${e.id}/${t}`, n);
  }
  isHidden(e, t) {
    var n, r;
    const s = this._isHiddenByDefault(e, t), o = (r = (n = this._data[e.id]) === null || n === void 0 ? void 0 : n.includes(t)) !== null && r !== void 0 ? r : !1;
    return s ? !o : o;
  }
  updateHidden(e, t, n) {
    this._isHiddenByDefault(e, t) && (n = !n);
    const s = this._data[e.id];
    if (n)
      s ? s.indexOf(t) < 0 && s.push(t) : this._data[e.id] = [t];
    else if (s) {
      const o = s.indexOf(t);
      o >= 0 && f6e(s, o), s.length === 0 && delete this._data[e.id];
    }
    this._persist();
  }
  reset(e) {
    if (e === void 0)
      this._data = /* @__PURE__ */ Object.create(null), this._persist();
    else {
      for (const { id: t } of e)
        this._data[t] && delete this._data[t];
      this._persist();
    }
  }
  _persist() {
    try {
      this._ignoreChangeEvent = !0;
      const e = JSON.stringify(this._data);
      this._storageService.store(
        F1._key,
        e,
        0,
        0
        /* StorageTarget.USER */
      );
    } finally {
      this._ignoreChangeEvent = !1;
    }
  }
};
eI._key = "menu.hiddenCommands";
eI = F1 = X4([
  n0(0, mc)
], eI);
let $B = Nf = class {
  constructor(e, t, n, r, s) {
    this._id = e, this._hiddenStates = t, this._collectContextKeysForSubmenus = n, this._commandService = r, this._contextKeyService = s, this._menuGroups = [], this._structureContextKeys = /* @__PURE__ */ new Set(), this._preconditionContextKeys = /* @__PURE__ */ new Set(), this._toggledContextKeys = /* @__PURE__ */ new Set(), this.refresh();
  }
  get structureContextKeys() {
    return this._structureContextKeys;
  }
  get preconditionContextKeys() {
    return this._preconditionContextKeys;
  }
  get toggledContextKeys() {
    return this._toggledContextKeys;
  }
  refresh() {
    this._menuGroups.length = 0, this._structureContextKeys.clear(), this._preconditionContextKeys.clear(), this._toggledContextKeys.clear();
    const e = os.getMenuItems(this._id);
    let t;
    e.sort(Nf._compareMenuItems);
    for (const n of e) {
      const r = n.group || "";
      (!t || t[0] !== r) && (t = [r, []], this._menuGroups.push(t)), t[1].push(n), this._collectContextKeys(n);
    }
  }
  _collectContextKeys(e) {
    if (Nf._fillInKbExprKeys(e.when, this._structureContextKeys), Y1(e)) {
      if (e.command.precondition && Nf._fillInKbExprKeys(e.command.precondition, this._preconditionContextKeys), e.command.toggled) {
        const t = e.command.toggled.condition || e.command.toggled;
        Nf._fillInKbExprKeys(t, this._toggledContextKeys);
      }
    } else this._collectContextKeysForSubmenus && os.getMenuItems(e.submenu).forEach(this._collectContextKeys, this);
  }
  createActionGroups(e) {
    const t = [];
    for (const n of this._menuGroups) {
      const [r, s] = n, o = [];
      for (const a of s)
        if (this._contextKeyService.contextMatchesRules(a.when)) {
          const l = Y1(a);
          l && this._hiddenStates.setDefaultState(this._id, a.command.id, !!a.isHiddenByDefault);
          const c = aqe(this._id, l ? a.command : a, this._hiddenStates);
          if (l)
            o.push(new sc(a.command, a.alt, e, c, this._contextKeyService, this._commandService));
          else {
            const d = new Nf(a.submenu, this._hiddenStates, this._collectContextKeysForSubmenus, this._commandService, this._contextKeyService).createActionGroups(e), u = Gr.join(...d.map((h) => h[1]));
            u.length > 0 && o.push(new Ay(a, c, u));
          }
        }
      o.length > 0 && t.push([r, o]);
    }
    return t;
  }
  static _fillInKbExprKeys(e, t) {
    if (e)
      for (const n of e.keys())
        t.add(n);
  }
  static _compareMenuItems(e, t) {
    const n = e.group, r = t.group;
    if (n !== r) {
      if (n) {
        if (!r)
          return -1;
      } else return 1;
      if (n === "navigation")
        return -1;
      if (r === "navigation")
        return 1;
      const a = n.localeCompare(r);
      if (a !== 0)
        return a;
    }
    const s = e.order || 0, o = t.order || 0;
    return s < o ? -1 : s > o ? 1 : Nf._compareTitles(Y1(e) ? e.command.title : e.title, Y1(t) ? t.command.title : t.title);
  }
  static _compareTitles(e, t) {
    const n = typeof e == "string" ? e : e.original, r = typeof t == "string" ? t : t.original;
    return n.localeCompare(r);
  }
};
$B = Nf = X4([
  n0(3, Ui),
  n0(4, yt)
], $B);
let eV = class {
  constructor(e, t, n, r, s) {
    this._disposables = new Ne(), this._menuInfo = new $B(e, t, n.emitEventsForSubmenuChanges, r, s);
    const o = new Rn(() => {
      this._menuInfo.refresh(), this._onDidChange.fire({ menu: this, isStructuralChange: !0, isEnablementChange: !0, isToggleChange: !0 });
    }, n.eventDebounceDelay);
    this._disposables.add(o), this._disposables.add(os.onDidChangeMenu((d) => {
      d.has(e) && o.schedule();
    }));
    const a = this._disposables.add(new Ne()), l = (d) => {
      let u = !1, h = !1, f = !1;
      for (const g of d)
        if (u = u || g.isStructuralChange, h = h || g.isEnablementChange, f = f || g.isToggleChange, u && h && f)
          break;
      return { menu: this, isStructuralChange: u, isEnablementChange: h, isToggleChange: f };
    }, c = () => {
      a.add(s.onDidChangeContext((d) => {
        const u = d.affectsSome(this._menuInfo.structureContextKeys), h = d.affectsSome(this._menuInfo.preconditionContextKeys), f = d.affectsSome(this._menuInfo.toggledContextKeys);
        (u || h || f) && this._onDidChange.fire({ menu: this, isStructuralChange: u, isEnablementChange: h, isToggleChange: f });
      })), a.add(t.onDidChange((d) => {
        this._onDidChange.fire({ menu: this, isStructuralChange: !0, isEnablementChange: !1, isToggleChange: !1 });
      }));
    };
    this._onDidChange = new Zue({
      // start/stop context key listener
      onWillAddFirstListener: c,
      onDidRemoveLastListener: a.clear.bind(a),
      delay: n.eventDebounceDelay,
      merge: l
    }), this.onDidChange = this._onDidChange.event;
  }
  getActions(e) {
    return this._menuInfo.createActionGroups(e);
  }
  dispose() {
    this._disposables.dispose(), this._onDidChange.dispose();
  }
};
eV = X4([
  n0(3, Ui),
  n0(4, yt)
], eV);
function aqe(i, e, t) {
  const n = r9e(e) ? e.submenu.id : e.id, r = typeof e.title == "string" ? e.title : e.title.value, s = Iv({
    id: `hide/${i.id}/${n}`,
    label: C("hide.label", "Hide '{0}'", r),
    run() {
      t.updateHidden(i, n, !0);
    }
  }), o = Iv({
    id: `toggle/${i.id}/${n}`,
    label: r,
    get checked() {
      return !t.isHidden(i, n);
    },
    run() {
      t.updateHidden(i, n, !!this.checked);
    }
  });
  return {
    hide: s,
    toggle: o,
    get isHidden() {
      return !o.checked;
    }
  };
}
var lqe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, EJ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Lp = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let tV = class extends we {
  constructor(e, t) {
    super(), this.layoutService = e, this.logService = t, this.mapTextToType = /* @__PURE__ */ new Map(), this.findText = "", this.resources = [], (Zh || bhe) && this.installWebKitWriteTextWorkaround();
  }
  // In Safari, it has the following note:
  //
  // "The request to write to the clipboard must be triggered during a user gesture.
  // A call to clipboard.write or clipboard.writeText outside the scope of a user
  // gesture(such as "click" or "touch" event handlers) will result in the immediate
  // rejection of the promise returned by the API call."
  // From: https://webkit.org/blog/10855/async-clipboard-api/
  //
  // Since extensions run in a web worker, and handle gestures in an asynchronous way,
  // they are not classified by Safari as "in response to a user gesture" and will reject.
  //
  // This function sets up some handlers to work around that behavior.
  installWebKitWriteTextWorkaround() {
    const e = () => {
      const t = new r4();
      this.webKitPendingClipboardWritePromise && !this.webKitPendingClipboardWritePromise.isSettled && this.webKitPendingClipboardWritePromise.cancel(), this.webKitPendingClipboardWritePromise = t, navigator.clipboard.write([new ClipboardItem({
        "text/plain": t.p
      })]).catch((n) => Lp(this, void 0, void 0, function* () {
        (!(n instanceof Error) || n.name !== "NotAllowedError" || !t.isRejected) && this.logService.error(n);
      }));
    };
    this.layoutService.hasContainer && (this._register(Ie(this.layoutService.container, "click", e)), this._register(Ie(this.layoutService.container, "keydown", e)));
  }
  writeText(e, t) {
    return Lp(this, void 0, void 0, function* () {
      if (t) {
        this.mapTextToType.set(t, e);
        return;
      }
      if (this.webKitPendingClipboardWritePromise)
        return this.webKitPendingClipboardWritePromise.complete(e);
      try {
        return yield navigator.clipboard.writeText(e);
      } catch (s) {
        console.error(s);
      }
      const n = document.activeElement, r = document.body.appendChild(Re("textarea", { "aria-hidden": !0 }));
      r.style.height = "1px", r.style.width = "1px", r.style.position = "absolute", r.value = e, r.focus(), r.select(), document.execCommand("copy"), n instanceof HTMLElement && n.focus(), document.body.removeChild(r);
    });
  }
  readText(e) {
    return Lp(this, void 0, void 0, function* () {
      if (e)
        return this.mapTextToType.get(e) || "";
      try {
        return yield navigator.clipboard.readText();
      } catch (t) {
        return console.error(t), "";
      }
    });
  }
  readFindText() {
    return Lp(this, void 0, void 0, function* () {
      return this.findText;
    });
  }
  writeFindText(e) {
    return Lp(this, void 0, void 0, function* () {
      this.findText = e;
    });
  }
  writeResources(e) {
    return Lp(this, void 0, void 0, function* () {
      this.resources = e;
    });
  }
  readResources() {
    return Lp(this, void 0, void 0, function* () {
      return this.resources;
    });
  }
};
tV = lqe([
  EJ(0, bb),
  EJ(1, Ka)
], tV);
const hf = Gt("clipboardService");
var cqe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, dqe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const HC = "data-keybinding-context";
let TU = class {
  constructor(e, t) {
    this._id = e, this._parent = t, this._value = /* @__PURE__ */ Object.create(null), this._value._contextId = e;
  }
  get value() {
    return Object.assign({}, this._value);
  }
  setValue(e, t) {
    return this._value[e] !== t ? (this._value[e] = t, !0) : !1;
  }
  removeValue(e) {
    return e in this._value ? (delete this._value[e], !0) : !1;
  }
  getValue(e) {
    const t = this._value[e];
    return typeof t > "u" && this._parent ? this._parent.getValue(e) : t;
  }
};
class O_ extends TU {
  constructor() {
    super(-1, null);
  }
  setValue(e, t) {
    return !1;
  }
  removeValue(e) {
    return !1;
  }
  getValue(e) {
  }
}
O_.INSTANCE = new O_();
class mw extends TU {
  constructor(e, t, n) {
    super(e, null), this._configurationService = t, this._values = Uv.forConfigKeys(), this._listener = this._configurationService.onDidChangeConfiguration((r) => {
      if (r.source === 7) {
        const s = Array.from(this._values, ([o]) => o);
        this._values.clear(), n.fire(new IJ(s));
      } else {
        const s = [];
        for (const o of r.affectedKeys) {
          const a = `config.${o}`, l = this._values.findSuperstr(a);
          l !== void 0 && (s.push(...Wt.map(l, ([c]) => c)), this._values.deleteSuperstr(a)), this._values.has(a) && (s.push(a), this._values.delete(a));
        }
        n.fire(new IJ(s));
      }
    });
  }
  dispose() {
    this._listener.dispose();
  }
  getValue(e) {
    if (e.indexOf(mw._keyPrefix) !== 0)
      return super.getValue(e);
    if (this._values.has(e))
      return this._values.get(e);
    const t = e.substr(mw._keyPrefix.length), n = this._configurationService.getValue(t);
    let r;
    switch (typeof n) {
      case "number":
      case "boolean":
      case "string":
        r = n;
        break;
      default:
        Array.isArray(n) ? r = JSON.stringify(n) : r = n;
    }
    return this._values.set(e, r), r;
  }
  setValue(e, t) {
    return super.setValue(e, t);
  }
  removeValue(e) {
    return super.removeValue(e);
  }
}
mw._keyPrefix = "config.";
class uqe {
  constructor(e, t, n) {
    this._service = e, this._key = t, this._defaultValue = n, this.reset();
  }
  set(e) {
    this._service.setContext(this._key, e);
  }
  reset() {
    typeof this._defaultValue > "u" ? this._service.removeContext(this._key) : this._service.setContext(this._key, this._defaultValue);
  }
  get() {
    return this._service.getContextKeyValue(this._key);
  }
}
class LJ {
  constructor(e) {
    this.key = e;
  }
  affectsSome(e) {
    return e.has(this.key);
  }
  allKeysContainedIn(e) {
    return this.affectsSome(e);
  }
}
class IJ {
  constructor(e) {
    this.keys = e;
  }
  affectsSome(e) {
    for (const t of this.keys)
      if (e.has(t))
        return !0;
    return !1;
  }
  allKeysContainedIn(e) {
    return this.keys.every((t) => e.has(t));
  }
}
class hqe {
  constructor(e) {
    this.events = e;
  }
  affectsSome(e) {
    for (const t of this.events)
      if (t.affectsSome(e))
        return !0;
    return !1;
  }
  allKeysContainedIn(e) {
    return this.events.every((t) => t.allKeysContainedIn(e));
  }
}
function fqe(i, e) {
  return i.allKeysContainedIn(new Set(Object.keys(e)));
}
class ome extends we {
  constructor(e) {
    super(), this._onDidChangeContext = this._register(new jm({ merge: (t) => new hqe(t) })), this.onDidChangeContext = this._onDidChangeContext.event, this._isDisposed = !1, this._myContextId = e;
  }
  createKey(e, t) {
    if (this._isDisposed)
      throw new Error("AbstractContextKeyService has been disposed");
    return new uqe(this, e, t);
  }
  bufferChangeEvents(e) {
    this._onDidChangeContext.pause();
    try {
      e();
    } finally {
      this._onDidChangeContext.resume();
    }
  }
  createScoped(e) {
    if (this._isDisposed)
      throw new Error("AbstractContextKeyService has been disposed");
    return new gqe(this, e);
  }
  contextMatchesRules(e) {
    if (this._isDisposed)
      throw new Error("AbstractContextKeyService has been disposed");
    const t = this.getContextValuesContainer(this._myContextId);
    return e ? e.evaluate(t) : !0;
  }
  getContextKeyValue(e) {
    if (!this._isDisposed)
      return this.getContextValuesContainer(this._myContextId).getValue(e);
  }
  setContext(e, t) {
    if (this._isDisposed)
      return;
    const n = this.getContextValuesContainer(this._myContextId);
    n && n.setValue(e, t) && this._onDidChangeContext.fire(new LJ(e));
  }
  removeContext(e) {
    this._isDisposed || this.getContextValuesContainer(this._myContextId).removeValue(e) && this._onDidChangeContext.fire(new LJ(e));
  }
  getContext(e) {
    return this._isDisposed ? O_.INSTANCE : this.getContextValuesContainer(pqe(e));
  }
  dispose() {
    super.dispose(), this._isDisposed = !0;
  }
}
let nV = class extends ome {
  constructor(e) {
    super(0), this._contexts = /* @__PURE__ */ new Map(), this._lastContextId = 0;
    const t = this._register(new mw(this._myContextId, e, this._onDidChangeContext));
    this._contexts.set(this._myContextId, t);
  }
  getContextValuesContainer(e) {
    return this._isDisposed ? O_.INSTANCE : this._contexts.get(e) || O_.INSTANCE;
  }
  createChildContext(e = this._myContextId) {
    if (this._isDisposed)
      throw new Error("ContextKeyService has been disposed");
    const t = ++this._lastContextId;
    return this._contexts.set(t, new TU(t, this.getContextValuesContainer(e))), t;
  }
  disposeContext(e) {
    this._isDisposed || this._contexts.delete(e);
  }
};
nV = cqe([
  dqe(0, en)
], nV);
class gqe extends ome {
  constructor(e, t) {
    if (super(e.createChildContext()), this._parentChangeListener = this._register(new ds()), this._parent = e, this._updateParentChangeListener(), this._domNode = t, this._domNode.hasAttribute(HC)) {
      let n = "";
      this._domNode.classList && (n = Array.from(this._domNode.classList.values()).join(", ")), console.error(`Element already has context attribute${n ? ": " + n : ""}`);
    }
    this._domNode.setAttribute(HC, String(this._myContextId));
  }
  _updateParentChangeListener() {
    this._parentChangeListener.value = this._parent.onDidChangeContext((e) => {
      const n = this._parent.getContextValuesContainer(this._myContextId).value;
      fqe(e, n) || this._onDidChangeContext.fire(e);
    });
  }
  dispose() {
    this._isDisposed || (this._parent.disposeContext(this._myContextId), this._domNode.removeAttribute(HC), super.dispose());
  }
  getContextValuesContainer(e) {
    return this._isDisposed ? O_.INSTANCE : this._parent.getContextValuesContainer(e);
  }
  createChildContext(e = this._myContextId) {
    if (this._isDisposed)
      throw new Error("ScopedContextKeyService has been disposed");
    return this._parent.createChildContext(e);
  }
  disposeContext(e) {
    this._isDisposed || this._parent.disposeContext(e);
  }
}
function pqe(i) {
  for (; i; ) {
    if (i.hasAttribute(HC)) {
      const e = i.getAttribute(HC);
      return e ? parseInt(e, 10) : NaN;
    }
    i = i.parentElement;
  }
  return 0;
}
function mqe(i, e, t) {
  i.get(yt).createKey(String(e), vqe(t));
}
function vqe(i) {
  return Fue(i, (e) => {
    if (typeof e == "object" && e.$mid === 1)
      return pt.revive(e).toString();
    if (e instanceof pt)
      return e.toString();
  });
}
on.registerCommand("_setContext", mqe);
on.registerCommand({
  id: "getContextKeyInfo",
  handler() {
    return [...Ke.all()].sort((i, e) => i.key.localeCompare(e.key));
  },
  description: {
    description: C("getContextKeyInfo", "A command that returns information about context keys"),
    args: []
  }
});
on.registerCommand("_generateContextKeyInfo", function() {
  const i = [], e = /* @__PURE__ */ new Set();
  for (const t of Ke.all())
    e.has(t.key) || (e.add(t.key), i.push(t));
  i.sort((t, n) => t.key.localeCompare(n.key)), console.log(JSON.stringify(i, void 0, 2));
});
let _qe = class {
  constructor(e, t) {
    this.key = e, this.data = t, this.incoming = /* @__PURE__ */ new Map(), this.outgoing = /* @__PURE__ */ new Map();
  }
};
class AJ {
  constructor(e) {
    this._hashFn = e, this._nodes = /* @__PURE__ */ new Map();
  }
  roots() {
    const e = [];
    for (const t of this._nodes.values())
      t.outgoing.size === 0 && e.push(t);
    return e;
  }
  insertEdge(e, t) {
    const n = this.lookupOrInsertNode(e), r = this.lookupOrInsertNode(t);
    n.outgoing.set(r.key, r), r.incoming.set(n.key, n);
  }
  removeNode(e) {
    const t = this._hashFn(e);
    this._nodes.delete(t);
    for (const n of this._nodes.values())
      n.outgoing.delete(t), n.incoming.delete(t);
  }
  lookupOrInsertNode(e) {
    const t = this._hashFn(e);
    let n = this._nodes.get(t);
    return n || (n = new _qe(t, e), this._nodes.set(t, n)), n;
  }
  isEmpty() {
    return this._nodes.size === 0;
  }
  toString() {
    const e = [];
    for (const [t, n] of this._nodes)
      e.push(`${t}
	(-> incoming)[${[...n.incoming.keys()].join(", ")}]
	(outgoing ->)[${[...n.outgoing.keys()].join(",")}]
`);
    return e.join(`
`);
  }
  /**
   * This is brute force and slow and **only** be used
   * to trouble shoot.
   */
  findCycleSlow() {
    for (const [e, t] of this._nodes) {
      const n = /* @__PURE__ */ new Set([e]), r = this._findCycle(t, n);
      if (r)
        return r;
    }
  }
  _findCycle(e, t) {
    for (const [n, r] of e.outgoing) {
      if (t.has(n))
        return [...t, n].join(" -> ");
      t.add(n);
      const s = this._findCycle(r, t);
      if (s)
        return s;
      t.delete(n);
    }
  }
}
const bqe = !1;
class kJ extends Error {
  constructor(e) {
    var t;
    super("cyclic dependency between services"), this.message = (t = e.findCycleSlow()) !== null && t !== void 0 ? t : `UNABLE to detect cycle, dumping graph: 
${e.toString()}`;
  }
}
class tI {
  constructor(e = new L4(), t = !1, n, r = bqe) {
    var s;
    this._services = e, this._strict = t, this._parent = n, this._enableTracing = r, this._activeInstantiations = /* @__PURE__ */ new Set(), this._services.set(bt, this), this._globalGraph = r ? (s = n?._globalGraph) !== null && s !== void 0 ? s : new AJ((o) => o) : void 0;
  }
  createChild(e) {
    return new tI(e, this._strict, this, this._enableTracing);
  }
  invokeFunction(e, ...t) {
    const n = Ao.traceInvocation(this._enableTracing, e);
    let r = !1;
    try {
      return e({
        get: (o) => {
          if (r)
            throw Aj("service accessor is only valid during the invocation of its target method");
          const a = this._getOrCreateServiceInstance(o, n);
          if (!a)
            throw new Error(`[invokeFunction] unknown service '${o}'`);
          return a;
        }
      }, ...t);
    } finally {
      r = !0, n.stop();
    }
  }
  createInstance(e, ...t) {
    let n, r;
    return e instanceof Md ? (n = Ao.traceCreation(this._enableTracing, e.ctor), r = this._createInstance(e.ctor, e.staticArguments.concat(t), n)) : (n = Ao.traceCreation(this._enableTracing, e), r = this._createInstance(e, t, n)), n.stop(), r;
  }
  _createInstance(e, t = [], n) {
    const r = Uc.getServiceDependencies(e).sort((a, l) => a.index - l.index), s = [];
    for (const a of r) {
      const l = this._getOrCreateServiceInstance(a.id, n);
      l || this._throwIfStrict(`[createInstance] ${e.name} depends on UNKNOWN service ${a.id}.`, !1), s.push(l);
    }
    const o = r.length > 0 ? r[0].index : t.length;
    if (t.length !== o) {
      console.trace(`[createInstance] First service dependency of ${e.name} at position ${o + 1} conflicts with ${t.length} static arguments`);
      const a = o - t.length;
      a > 0 ? t = t.concat(new Array(a)) : t = t.slice(0, o);
    }
    return Reflect.construct(e, t.concat(s));
  }
  _setServiceInstance(e, t) {
    if (this._services.get(e) instanceof Md)
      this._services.set(e, t);
    else if (this._parent)
      this._parent._setServiceInstance(e, t);
    else
      throw new Error("illegalState - setting UNKNOWN service instance");
  }
  _getServiceInstanceOrDescriptor(e) {
    const t = this._services.get(e);
    return !t && this._parent ? this._parent._getServiceInstanceOrDescriptor(e) : t;
  }
  _getOrCreateServiceInstance(e, t) {
    this._globalGraph && this._globalGraphImplicitDependency && this._globalGraph.insertEdge(this._globalGraphImplicitDependency, String(e));
    const n = this._getServiceInstanceOrDescriptor(e);
    return n instanceof Md ? this._safeCreateAndCacheServiceInstance(e, n, t.branch(e, !0)) : (t.branch(e, !1), n);
  }
  _safeCreateAndCacheServiceInstance(e, t, n) {
    if (this._activeInstantiations.has(e))
      throw new Error(`illegal state - RECURSIVELY instantiating service '${e}'`);
    this._activeInstantiations.add(e);
    try {
      return this._createAndCacheServiceInstance(e, t, n);
    } finally {
      this._activeInstantiations.delete(e);
    }
  }
  _createAndCacheServiceInstance(e, t, n) {
    var r;
    const s = new AJ((l) => l.id.toString());
    let o = 0;
    const a = [{ id: e, desc: t, _trace: n }];
    for (; a.length; ) {
      const l = a.pop();
      if (s.lookupOrInsertNode(l), o++ > 1e3)
        throw new kJ(s);
      for (const c of Uc.getServiceDependencies(l.desc.ctor)) {
        const d = this._getServiceInstanceOrDescriptor(c.id);
        if (d || this._throwIfStrict(`[createInstance] ${e} depends on ${c.id} which is NOT registered.`, !0), (r = this._globalGraph) === null || r === void 0 || r.insertEdge(String(l.id), String(c.id)), d instanceof Md) {
          const u = { id: c.id, desc: d, _trace: l._trace.branch(c.id, !0) };
          s.insertEdge(l, u), a.push(u);
        }
      }
    }
    for (; ; ) {
      const l = s.roots();
      if (l.length === 0) {
        if (!s.isEmpty())
          throw new kJ(s);
        break;
      }
      for (const { data: c } of l) {
        if (this._getServiceInstanceOrDescriptor(c.id) instanceof Md) {
          const u = this._createServiceInstanceWithOwner(c.id, c.desc.ctor, c.desc.staticArguments, c.desc.supportsDelayedInstantiation, c._trace);
          this._setServiceInstance(c.id, u);
        }
        s.removeNode(c);
      }
    }
    return this._getServiceInstanceOrDescriptor(e);
  }
  _createServiceInstanceWithOwner(e, t, n = [], r, s) {
    if (this._services.get(e) instanceof Md)
      return this._createServiceInstance(e, t, n, r, s);
    if (this._parent)
      return this._parent._createServiceInstanceWithOwner(e, t, n, r, s);
    throw new Error(`illegalState - creating UNKNOWN service instance ${t.name}`);
  }
  _createServiceInstance(e, t, n = [], r, s) {
    if (r) {
      const o = new tI(void 0, this._strict, this, this._enableTracing);
      o._globalGraphImplicitDependency = String(e);
      const a = /* @__PURE__ */ new Map(), l = new O3(() => {
        const c = o._createInstance(t, n, s);
        for (const [d, u] of a) {
          const h = c[d];
          if (typeof h == "function")
            for (const f of u)
              h.apply(c, f);
        }
        return a.clear(), c;
      });
      return new Proxy(/* @__PURE__ */ Object.create(null), {
        get(c, d) {
          if (!l.isInitialized && typeof d == "string" && (d.startsWith("onDid") || d.startsWith("onWill"))) {
            let f = a.get(d);
            return f || (f = new fo(), a.set(d, f)), (p, m, _) => {
              const b = f.push([p, m, _]);
              return Ct(b);
            };
          }
          if (d in c)
            return c[d];
          const u = l.value;
          let h = u[d];
          return typeof h != "function" || (h = h.bind(u), c[d] = h), h;
        },
        set(c, d, u) {
          return l.value[d] = u, !0;
        },
        getPrototypeOf(c) {
          return t.prototype;
        }
      });
    } else
      return this._createInstance(t, n, s);
  }
  _throwIfStrict(e, t) {
    if (t && console.warn(e), this._strict)
      throw new Error(e);
  }
}
class Ao {
  static traceInvocation(e, t) {
    return e ? new Ao(2, t.name || new Error().stack.split(`
`).slice(3, 4).join(`
`)) : Ao._None;
  }
  static traceCreation(e, t) {
    return e ? new Ao(1, t.name) : Ao._None;
  }
  constructor(e, t) {
    this.type = e, this.name = t, this._start = Date.now(), this._dep = [];
  }
  branch(e, t) {
    const n = new Ao(3, e.toString());
    return this._dep.push([e, t, n]), n;
  }
  stop() {
    const e = Date.now() - this._start;
    Ao._totals += e;
    let t = !1;
    function n(s, o) {
      const a = [], l = new Array(s + 1).join("	");
      for (const [c, d, u] of o._dep)
        if (d && u) {
          t = !0, a.push(`${l}CREATES -> ${c}`);
          const h = n(s + 1, u);
          h && a.push(h);
        } else
          a.push(`${l}uses -> ${c}`);
      return a.join(`
`);
    }
    const r = [
      `${this.type === 1 ? "CREATE" : "CALL"} ${this.name}`,
      `${n(1, this)}`,
      `DONE, took ${e.toFixed(2)}ms (grand total ${Ao._totals.toFixed(2)}ms)`
    ];
    (e > 2 || t) && Ao.all.add(r.join(`
`));
  }
}
Ao.all = /* @__PURE__ */ new Set();
Ao._None = new class extends Ao {
  constructor() {
    super(0, null);
  }
  stop() {
  }
  branch() {
    return this;
  }
}();
Ao._totals = 0;
const Cqe = /* @__PURE__ */ new Set([Mt.inMemory, Mt.vscodeSourceControl, Mt.walkThrough, Mt.walkThroughSnippet]);
class yqe {
  constructor() {
    this._byResource = new Ms(), this._byOwner = /* @__PURE__ */ new Map();
  }
  set(e, t, n) {
    let r = this._byResource.get(e);
    r || (r = /* @__PURE__ */ new Map(), this._byResource.set(e, r)), r.set(t, n);
    let s = this._byOwner.get(t);
    s || (s = new Ms(), this._byOwner.set(t, s)), s.set(e, n);
  }
  get(e, t) {
    const n = this._byResource.get(e);
    return n?.get(t);
  }
  delete(e, t) {
    let n = !1, r = !1;
    const s = this._byResource.get(e);
    s && (n = s.delete(t));
    const o = this._byOwner.get(t);
    if (o && (r = o.delete(e)), n !== r)
      throw new Error("illegal state");
    return n && r;
  }
  values(e) {
    var t, n, r, s;
    return typeof e == "string" ? (n = (t = this._byOwner.get(e)) === null || t === void 0 ? void 0 : t.values()) !== null && n !== void 0 ? n : Wt.empty() : pt.isUri(e) ? (s = (r = this._byResource.get(e)) === null || r === void 0 ? void 0 : r.values()) !== null && s !== void 0 ? s : Wt.empty() : Wt.map(Wt.concat(...this._byOwner.values()), (o) => o[1]);
  }
}
class wqe {
  constructor(e) {
    this.errors = 0, this.infos = 0, this.warnings = 0, this.unknowns = 0, this._data = new Ms(), this._service = e, this._subscription = e.onMarkerChanged(this._update, this);
  }
  dispose() {
    this._subscription.dispose();
  }
  _update(e) {
    for (const t of e) {
      const n = this._data.get(t);
      n && this._substract(n);
      const r = this._resourceStats(t);
      this._add(r), this._data.set(t, r);
    }
  }
  _resourceStats(e) {
    const t = { errors: 0, warnings: 0, infos: 0, unknowns: 0 };
    if (Cqe.has(e.scheme))
      return t;
    for (const { severity: n } of this._service.read({ resource: e }))
      n === Fi.Error ? t.errors += 1 : n === Fi.Warning ? t.warnings += 1 : n === Fi.Info ? t.infos += 1 : t.unknowns += 1;
    return t;
  }
  _substract(e) {
    this.errors -= e.errors, this.warnings -= e.warnings, this.infos -= e.infos, this.unknowns -= e.unknowns;
  }
  _add(e) {
    this.errors += e.errors, this.warnings += e.warnings, this.infos += e.infos, this.unknowns += e.unknowns;
  }
}
class Mf {
  constructor() {
    this._onMarkerChanged = new Zue({
      delay: 0,
      merge: Mf._merge
    }), this.onMarkerChanged = this._onMarkerChanged.event, this._data = new yqe(), this._stats = new wqe(this);
  }
  dispose() {
    this._stats.dispose(), this._onMarkerChanged.dispose();
  }
  remove(e, t) {
    for (const n of t || [])
      this.changeOne(e, n, []);
  }
  changeOne(e, t, n) {
    if (Tue(n))
      this._data.delete(t, e) && this._onMarkerChanged.fire([t]);
    else {
      const r = [];
      for (const s of n) {
        const o = Mf._toMarker(e, t, s);
        o && r.push(o);
      }
      this._data.set(t, e, r), this._onMarkerChanged.fire([t]);
    }
  }
  static _toMarker(e, t, n) {
    let { code: r, severity: s, message: o, source: a, startLineNumber: l, startColumn: c, endLineNumber: d, endColumn: u, relatedInformation: h, tags: f } = n;
    if (o)
      return l = l > 0 ? l : 1, c = c > 0 ? c : 1, d = d >= l ? d : l, u = u > 0 ? u : c, {
        resource: t,
        owner: e,
        code: r,
        severity: s,
        message: o,
        source: a,
        startLineNumber: l,
        startColumn: c,
        endLineNumber: d,
        endColumn: u,
        relatedInformation: h,
        tags: f
      };
  }
  changeAll(e, t) {
    const n = [], r = this._data.values(e);
    if (r)
      for (const s of r) {
        const o = Wt.first(s);
        o && (n.push(o.resource), this._data.delete(o.resource, e));
      }
    if (Bs(t)) {
      const s = new Ms();
      for (const { resource: o, marker: a } of t) {
        const l = Mf._toMarker(e, o, a);
        if (!l)
          continue;
        const c = s.get(o);
        c ? c.push(l) : (s.set(o, [l]), n.push(o));
      }
      for (const [o, a] of s)
        this._data.set(o, e, a);
    }
    n.length > 0 && this._onMarkerChanged.fire(n);
  }
  read(e = /* @__PURE__ */ Object.create(null)) {
    let { owner: t, resource: n, severities: r, take: s } = e;
    if ((!s || s < 0) && (s = -1), t && n) {
      const o = this._data.get(n, t);
      if (o) {
        const a = [];
        for (const l of o)
          if (Mf._accept(l, r)) {
            const c = a.push(l);
            if (s > 0 && c === s)
              break;
          }
        return a;
      } else
        return [];
    } else if (!t && !n) {
      const o = [];
      for (const a of this._data.values())
        for (const l of a)
          if (Mf._accept(l, r)) {
            const c = o.push(l);
            if (s > 0 && c === s)
              return o;
          }
      return o;
    } else {
      const o = this._data.values(n ?? t), a = [];
      for (const l of o)
        for (const c of l)
          if (Mf._accept(c, r)) {
            const d = a.push(c);
            if (s > 0 && d === s)
              return a;
          }
      return a;
    }
  }
  static _accept(e, t) {
    return t === void 0 || (t & e.severity) === e.severity;
  }
  // --- event debounce logic
  static _merge(e) {
    const t = new Ms();
    for (const n of e)
      for (const r of n)
        t.set(r, !0);
    return Array.from(t.keys());
  }
}
class Sqe extends we {
  constructor() {
    super(...arguments), this._configurationModel = new Ns();
  }
  get configurationModel() {
    return this._configurationModel;
  }
  reload() {
    return this.resetConfigurationModel(), this.configurationModel;
  }
  getConfigurationDefaultOverrides() {
    return {};
  }
  resetConfigurationModel() {
    this._configurationModel = new Ns();
    const e = Di.as(_d.Configuration).getConfigurationProperties();
    this.updateConfigurationModel(Object.keys(e), e);
  }
  updateConfigurationModel(e, t) {
    const n = this.getConfigurationDefaultOverrides();
    for (const r of e) {
      const s = n[r], o = t[r];
      s !== void 0 ? this._configurationModel.addValue(r, s) : o ? this._configurationModel.addValue(r, o.default) : this._configurationModel.removeValue(r);
    }
  }
}
const GS = Gt("audioCue");
class Rt {
  static register(e) {
    return new Rt(e.fileName);
  }
  constructor(e) {
    this.fileName = e;
  }
}
Rt.error = Rt.register({ fileName: "error.mp3" });
Rt.warning = Rt.register({ fileName: "warning.mp3" });
Rt.foldedArea = Rt.register({ fileName: "foldedAreas.mp3" });
Rt.break = Rt.register({ fileName: "break.mp3" });
Rt.quickFixes = Rt.register({ fileName: "quickFixes.mp3" });
Rt.taskCompleted = Rt.register({ fileName: "taskCompleted.mp3" });
Rt.taskFailed = Rt.register({ fileName: "taskFailed.mp3" });
Rt.terminalBell = Rt.register({ fileName: "terminalBell.mp3" });
Rt.diffLineInserted = Rt.register({ fileName: "diffLineInserted.mp3" });
Rt.diffLineDeleted = Rt.register({ fileName: "diffLineDeleted.mp3" });
Rt.diffLineModified = Rt.register({ fileName: "diffLineModified.mp3" });
Rt.chatRequestSent = Rt.register({ fileName: "chatRequestSent.mp3" });
Rt.chatResponsePending = Rt.register({ fileName: "chatResponsePending.mp3" });
Rt.chatResponseReceived1 = Rt.register({ fileName: "chatResponseReceived1.mp3" });
Rt.chatResponseReceived2 = Rt.register({ fileName: "chatResponseReceived2.mp3" });
Rt.chatResponseReceived3 = Rt.register({ fileName: "chatResponseReceived3.mp3" });
Rt.chatResponseReceived4 = Rt.register({ fileName: "chatResponseReceived4.mp3" });
class xqe {
  constructor(e) {
    this.randomOneOf = e;
  }
}
class un {
  static register(e) {
    const t = new xqe("randomOneOf" in e.sound ? e.sound.randomOneOf : [e.sound]), n = new un(t, e.name, e.settingsKey);
    return un._audioCues.add(n), n;
  }
  constructor(e, t, n) {
    this.sound = e, this.name = t, this.settingsKey = n;
  }
}
un._audioCues = /* @__PURE__ */ new Set();
un.error = un.register({
  name: C("audioCues.lineHasError.name", "Error on Line"),
  sound: Rt.error,
  settingsKey: "audioCues.lineHasError"
});
un.warning = un.register({
  name: C("audioCues.lineHasWarning.name", "Warning on Line"),
  sound: Rt.warning,
  settingsKey: "audioCues.lineHasWarning"
});
un.foldedArea = un.register({
  name: C("audioCues.lineHasFoldedArea.name", "Folded Area on Line"),
  sound: Rt.foldedArea,
  settingsKey: "audioCues.lineHasFoldedArea"
});
un.break = un.register({
  name: C("audioCues.lineHasBreakpoint.name", "Breakpoint on Line"),
  sound: Rt.break,
  settingsKey: "audioCues.lineHasBreakpoint"
});
un.inlineSuggestion = un.register({
  name: C("audioCues.lineHasInlineSuggestion.name", "Inline Suggestion on Line"),
  sound: Rt.quickFixes,
  settingsKey: "audioCues.lineHasInlineSuggestion"
});
un.terminalQuickFix = un.register({
  name: C("audioCues.terminalQuickFix.name", "Terminal Quick Fix"),
  sound: Rt.quickFixes,
  settingsKey: "audioCues.terminalQuickFix"
});
un.onDebugBreak = un.register({
  name: C("audioCues.onDebugBreak.name", "Debugger Stopped on Breakpoint"),
  sound: Rt.break,
  settingsKey: "audioCues.onDebugBreak"
});
un.noInlayHints = un.register({
  name: C("audioCues.noInlayHints", "No Inlay Hints on Line"),
  sound: Rt.error,
  settingsKey: "audioCues.noInlayHints"
});
un.taskCompleted = un.register({
  name: C("audioCues.taskCompleted", "Task Completed"),
  sound: Rt.taskCompleted,
  settingsKey: "audioCues.taskCompleted"
});
un.taskFailed = un.register({
  name: C("audioCues.taskFailed", "Task Failed"),
  sound: Rt.taskFailed,
  settingsKey: "audioCues.taskFailed"
});
un.terminalCommandFailed = un.register({
  name: C("audioCues.terminalCommandFailed", "Terminal Command Failed"),
  sound: Rt.error,
  settingsKey: "audioCues.terminalCommandFailed"
});
un.terminalBell = un.register({
  name: C("audioCues.terminalBell", "Terminal Bell"),
  sound: Rt.terminalBell,
  settingsKey: "audioCues.terminalBell"
});
un.notebookCellCompleted = un.register({
  name: C("audioCues.notebookCellCompleted", "Notebook Cell Completed"),
  sound: Rt.taskCompleted,
  settingsKey: "audioCues.notebookCellCompleted"
});
un.notebookCellFailed = un.register({
  name: C("audioCues.notebookCellFailed", "Notebook Cell Failed"),
  sound: Rt.taskFailed,
  settingsKey: "audioCues.notebookCellFailed"
});
un.diffLineInserted = un.register({
  name: C("audioCues.diffLineInserted", "Diff Line Inserted"),
  sound: Rt.diffLineInserted,
  settingsKey: "audioCues.diffLineInserted"
});
un.diffLineDeleted = un.register({
  name: C("audioCues.diffLineDeleted", "Diff Line Deleted"),
  sound: Rt.diffLineDeleted,
  settingsKey: "audioCues.diffLineDeleted"
});
un.diffLineModified = un.register({
  name: C("audioCues.diffLineModified", "Diff Line Modified"),
  sound: Rt.diffLineModified,
  settingsKey: "audioCues.diffLineModified"
});
un.chatRequestSent = un.register({
  name: C("audioCues.chatRequestSent", "Chat Request Sent"),
  sound: Rt.chatRequestSent,
  settingsKey: "audioCues.chatRequestSent"
});
un.chatResponseReceived = un.register({
  name: C("audioCues.chatResponseReceived", "Chat Response Received"),
  settingsKey: "audioCues.chatResponseReceived",
  sound: {
    randomOneOf: [
      Rt.chatResponseReceived1,
      Rt.chatResponseReceived2,
      Rt.chatResponseReceived3,
      Rt.chatResponseReceived4
    ]
  }
});
un.chatResponsePending = un.register({
  name: C("audioCues.chatResponsePending", "Chat Response Pending"),
  sound: Rt.chatResponsePending,
  settingsKey: "audioCues.chatResponsePending"
});
class Dqe extends we {
  constructor(e, t = []) {
    super(), this.logger = new o9e([e, ...t]), this._register(e.onDidChangeLogLevel((n) => this.setLevel(n)));
  }
  get onDidChangeLogLevel() {
    return this.logger.onDidChangeLogLevel;
  }
  setLevel(e) {
    this.logger.setLevel(e);
  }
  getLevel() {
    return this.logger.getLevel();
  }
  trace(e, ...t) {
    this.logger.trace(e, ...t);
  }
  debug(e, ...t) {
    this.logger.debug(e, ...t);
  }
  info(e, ...t) {
    this.logger.info(e, ...t);
  }
  warn(e, ...t) {
    this.logger.warn(e, ...t);
  }
  error(e, ...t) {
    this.logger.error(e, ...t);
  }
}
const ame = [];
function Z4(i) {
  ame.push(i);
}
function Eqe() {
  return ame.slice(0);
}
var fp = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, ss = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Kv = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class Lqe {
  constructor(e) {
    this.disposed = !1, this.model = e, this._onWillDispose = new pe();
  }
  get textEditorModel() {
    return this.model;
  }
  dispose() {
    this.disposed = !0, this._onWillDispose.fire();
  }
}
let iV = class {
  constructor(e) {
    this.modelService = e;
  }
  createModelReference(e) {
    const t = this.modelService.getModel(e);
    return t ? Promise.resolve(new TTe(new Lqe(t))) : Promise.reject(new Error("Model not found"));
  }
};
iV = fp([
  ss(0, fi)
], iV);
class Q4 {
  show() {
    return Q4.NULL_PROGRESS_RUNNER;
  }
  showWhile(e, t) {
    return Kv(this, void 0, void 0, function* () {
      yield e;
    });
  }
}
Q4.NULL_PROGRESS_RUNNER = {
  done: () => {
  },
  total: () => {
  },
  worked: () => {
  }
};
class Iqe {
  withProgress(e, t, n) {
    return t({
      report: () => {
      }
    });
  }
}
class Aqe {
  constructor() {
    this.isExtensionDevelopment = !1, this.isBuilt = !1;
  }
}
class kqe {
  confirm(e) {
    return Kv(this, void 0, void 0, function* () {
      return {
        confirmed: this.doConfirm(e.message, e.detail),
        checkboxChecked: !1
        // unsupported
      };
    });
  }
  doConfirm(e, t) {
    let n = e;
    return t && (n = n + `

` + t), window.confirm(n);
  }
  prompt(e) {
    var t, n;
    return Kv(this, void 0, void 0, function* () {
      let r;
      if (this.doConfirm(e.message, e.detail)) {
        const o = [...(t = e.buttons) !== null && t !== void 0 ? t : []];
        e.cancelButton && typeof e.cancelButton != "string" && typeof e.cancelButton != "boolean" && o.push(e.cancelButton), r = yield (n = o[0]) === null || n === void 0 ? void 0 : n.run({ checkboxChecked: !1 });
      }
      return { result: r };
    });
  }
  error(e, t) {
    return Kv(this, void 0, void 0, function* () {
      yield this.prompt({ type: Yi.Error, message: e, detail: t });
    });
  }
}
class vw {
  info(e) {
    return this.notify({ severity: Yi.Info, message: e });
  }
  warn(e) {
    return this.notify({ severity: Yi.Warning, message: e });
  }
  error(e) {
    return this.notify({ severity: Yi.Error, message: e });
  }
  notify(e) {
    switch (e.severity) {
      case Yi.Error:
        console.error(e.message);
        break;
      case Yi.Warning:
        console.warn(e.message);
        break;
      default:
        console.log(e.message);
        break;
    }
    return vw.NO_OP;
  }
  prompt(e, t, n, r) {
    return vw.NO_OP;
  }
  status(e, t) {
    return we.None;
  }
}
vw.NO_OP = new MHe();
let rV = class {
  constructor(e) {
    this._onWillExecuteCommand = new pe(), this._onDidExecuteCommand = new pe(), this.onDidExecuteCommand = this._onDidExecuteCommand.event, this._instantiationService = e;
  }
  executeCommand(e, ...t) {
    const n = on.getCommand(e);
    if (!n)
      return Promise.reject(new Error(`command '${e}' not found`));
    try {
      this._onWillExecuteCommand.fire({ commandId: e, args: t });
      const r = this._instantiationService.invokeFunction.apply(this._instantiationService, [n.handler, ...t]);
      return this._onDidExecuteCommand.fire({ commandId: e, args: t }), Promise.resolve(r);
    } catch (r) {
      return Promise.reject(r);
    }
  }
};
rV = fp([
  ss(0, bt)
], rV);
let M_ = class extends zWe {
  constructor(e, t, n, r, s, o) {
    super(e, t, n, r, s), this._cachedResolver = null, this._dynamicKeybindings = [], this._domNodeListeners = [];
    const a = (f) => {
      const g = new Ne();
      g.add(Ie(f, Ge.KEY_DOWN, (p) => {
        const m = new Xn(p);
        this._dispatch(m, m.target) && (m.preventDefault(), m.stopPropagation());
      })), g.add(Ie(f, Ge.KEY_UP, (p) => {
        const m = new Xn(p);
        this._singleModifierDispatch(m, m.target) && m.preventDefault();
      })), this._domNodeListeners.push(new Tqe(f, g));
    }, l = (f) => {
      for (let g = 0; g < this._domNodeListeners.length; g++) {
        const p = this._domNodeListeners[g];
        p.domNode === f && (this._domNodeListeners.splice(g, 1), p.dispose());
      }
    }, c = (f) => {
      f.getOption(
        61
        /* EditorOption.inDiffEditor */
      ) || a(f.getContainerDomNode());
    }, d = (f) => {
      f.getOption(
        61
        /* EditorOption.inDiffEditor */
      ) || l(f.getContainerDomNode());
    };
    this._register(o.onCodeEditorAdd(c)), this._register(o.onCodeEditorRemove(d)), o.listCodeEditors().forEach(c);
    const u = (f) => {
      a(f.getContainerDomNode());
    }, h = (f) => {
      l(f.getContainerDomNode());
    };
    this._register(o.onDiffEditorAdd(u)), this._register(o.onDiffEditorRemove(h)), o.listDiffEditors().forEach(u);
  }
  addDynamicKeybinding(e, t, n, r) {
    return Ql(on.registerCommand(e, n), this.addDynamicKeybindings([{
      keybinding: t,
      command: e,
      when: r
    }]));
  }
  addDynamicKeybindings(e) {
    const t = e.map((n) => {
      var r;
      return {
        keybinding: oF(n.keybinding, ka),
        command: (r = n.command) !== null && r !== void 0 ? r : null,
        commandArgs: n.commandArgs,
        when: n.when,
        weight1: 1e3,
        weight2: 0,
        extensionId: null,
        isBuiltinExtension: !1
      };
    });
    return this._dynamicKeybindings = this._dynamicKeybindings.concat(t), this.updateResolver(), Ct(() => {
      for (let n = 0; n < this._dynamicKeybindings.length; n++)
        if (this._dynamicKeybindings[n] === t[0]) {
          this._dynamicKeybindings.splice(n, t.length), this.updateResolver();
          return;
        }
    });
  }
  updateResolver() {
    this._cachedResolver = null, this._onDidUpdateKeybindings.fire();
  }
  _getResolver() {
    if (!this._cachedResolver) {
      const e = this._toNormalizedKeybindingItems(Bo.getDefaultKeybindings(), !0), t = this._toNormalizedKeybindingItems(this._dynamicKeybindings, !1);
      this._cachedResolver = new VC(e, t, (n) => this._log(n));
    }
    return this._cachedResolver;
  }
  _documentHasFocus() {
    return document.hasFocus();
  }
  _toNormalizedKeybindingItems(e, t) {
    const n = [];
    let r = 0;
    for (const s of e) {
      const o = s.when || void 0, a = s.keybinding;
      if (!a)
        n[r++] = new WQ(void 0, s.command, s.commandArgs, o, t, null, !1);
      else {
        const l = iw.resolveKeybinding(a, ka);
        for (const c of l)
          n[r++] = new WQ(c, s.command, s.commandArgs, o, t, null, !1);
      }
    }
    return n;
  }
  resolveKeyboardEvent(e) {
    const t = new Qh(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, e.keyCode);
    return new iw([t], ka);
  }
};
M_ = fp([
  ss(0, yt),
  ss(1, Ui),
  ss(2, qa),
  ss(3, dr),
  ss(4, Ka),
  ss(5, Sn)
], M_);
class Tqe extends we {
  constructor(e, t) {
    super(), this.domNode = e, this._register(t);
  }
}
function TJ(i) {
  return i && typeof i == "object" && (!i.overrideIdentifier || typeof i.overrideIdentifier == "string") && (!i.resource || i.resource instanceof pt);
}
class lme {
  constructor() {
    this._onDidChangeConfiguration = new pe(), this.onDidChangeConfiguration = this._onDidChangeConfiguration.event;
    const e = new Sqe();
    this._configuration = new T4(e.reload(), new Ns(), new Ns(), new Ns()), e.dispose();
  }
  getValue(e, t) {
    const n = typeof e == "string" ? e : void 0, r = TJ(e) ? e : TJ(t) ? t : {};
    return this._configuration.getValue(n, r, void 0);
  }
  updateValues(e) {
    const t = { data: this._configuration.toData() }, n = [];
    for (const r of e) {
      const [s, o] = r;
      this.getValue(s) !== o && (this._configuration.updateValue(s, o), n.push(s));
    }
    if (n.length > 0) {
      const r = new VWe({ keys: n, overrides: [] }, t, this._configuration);
      r.source = 8, r.sourceConfig = null, this._onDidChangeConfiguration.fire(r);
    }
    return Promise.resolve();
  }
  updateValue(e, t, n, r) {
    return this.updateValues([[e, t]]);
  }
  inspect(e, t = {}) {
    return this._configuration.inspect(e, t, void 0);
  }
}
let sV = class {
  constructor(e, t, n) {
    this.configurationService = e, this.modelService = t, this.languageService = n, this._onDidChangeConfiguration = new pe(), this.configurationService.onDidChangeConfiguration((r) => {
      this._onDidChangeConfiguration.fire({ affectedKeys: r.affectedKeys, affectsConfiguration: (s, o) => r.affectsConfiguration(o) });
    });
  }
  getValue(e, t, n) {
    const r = ve.isIPosition(t) ? t : null, s = r ? typeof n == "string" ? n : void 0 : typeof t == "string" ? t : void 0, o = e ? this.getLanguage(e, r) : void 0;
    return typeof s > "u" ? this.configurationService.getValue({
      resource: e,
      overrideIdentifier: o
    }) : this.configurationService.getValue(s, {
      resource: e,
      overrideIdentifier: o
    });
  }
  getLanguage(e, t) {
    const n = this.modelService.getModel(e);
    return n ? t ? n.getLanguageIdAtPosition(t.lineNumber, t.column) : n.getLanguageId() : this.languageService.guessLanguageIdByFilepathOrFirstLine(e);
  }
};
sV = fp([
  ss(0, en),
  ss(1, fi),
  ss(2, ci)
], sV);
let oV = class {
  constructor(e) {
    this.configurationService = e;
  }
  getEOL(e, t) {
    const n = this.configurationService.getValue("files.eol", { overrideIdentifier: t, resource: e });
    return n && typeof n == "string" && n !== "auto" ? n : $s || sn ? `
` : `\r
`;
  }
};
oV = fp([
  ss(0, en)
], oV);
class Nqe {
  publicLog2() {
  }
}
class _w {
  constructor() {
    const e = pt.from({ scheme: _w.SCHEME, authority: "model", path: "/" });
    this.workspace = { id: Qge, folders: [new ije({ uri: e, name: "", index: 0 })] };
  }
  getWorkspace() {
    return this.workspace;
  }
  getWorkspaceFolder(e) {
    return e && e.scheme === _w.SCHEME ? this.workspace.folders[0] : null;
  }
}
_w.SCHEME = "inmemory";
function nI(i, e, t) {
  if (!e || !(i instanceof lme))
    return;
  const n = [];
  Object.keys(e).forEach((r) => {
    OWe(r) && n.push([`editor.${r}`, e[r]]), t && MWe(r) && n.push([`diffEditor.${r}`, e[r]]);
  }), n.length > 0 && i.updateValues(n);
}
let aV = class {
  constructor(e) {
    this._modelService = e;
  }
  hasPreviewHandler() {
    return !1;
  }
  apply(e, t) {
    return Kv(this, void 0, void 0, function* () {
      const n = Array.isArray(e) ? e : Xz.convert(e), r = /* @__PURE__ */ new Map();
      for (const a of n) {
        if (!(a instanceof Vh))
          throw new Error("bad edit - only text edits are supported");
        const l = this._modelService.getModel(a.resource);
        if (!l)
          throw new Error("bad edit - model not found");
        if (typeof a.versionId == "number" && l.getVersionId() !== a.versionId)
          throw new Error("bad state - model changed in the meantime");
        let c = r.get(l);
        c || (c = [], r.set(l, c)), c.push(Si.replaceMove(V.lift(a.textEdit.range), a.textEdit.text));
      }
      let s = 0, o = 0;
      for (const [a, l] of r)
        a.pushStackElement(), a.pushEditOperations([], l, () => []), a.pushStackElement(), o += 1, s += l.length;
      return {
        ariaSummary: zm(uB.bulkEditServiceSummary, s, o),
        isApplied: s > 0
      };
    });
  }
};
aV = fp([
  ss(0, fi)
], aV);
class Pqe {
  getUriLabel(e, t) {
    return e.scheme === "file" ? e.fsPath : e.path;
  }
  getUriBasenameLabel(e) {
    return xl(e);
  }
}
let lV = class extends hB {
  constructor(e, t) {
    super(e), this._codeEditorService = t;
  }
  showContextView(e, t, n) {
    if (!t) {
      const r = this._codeEditorService.getFocusedCodeEditor() || this._codeEditorService.getActiveCodeEditor();
      r && (t = r.getContainerDomNode());
    }
    return super.showContextView(e, t, n);
  }
};
lV = fp([
  ss(0, bb),
  ss(1, Sn)
], lV);
class Oqe {
  constructor() {
    this._neverEmitter = new pe(), this.onDidChangeTrust = this._neverEmitter.event;
  }
  isWorkspaceTrusted() {
    return !0;
  }
}
class Mqe extends ow {
  constructor() {
    super();
  }
}
class Rqe extends Dqe {
  constructor() {
    super(new s9e());
  }
}
let cV = class extends kB {
  constructor(e, t, n, r, s, o) {
    super(e, t, n, r, s, o), this.configure({ blockMouse: !1 });
  }
};
cV = fp([
  ss(0, qa),
  ss(1, dr),
  ss(2, cf),
  ss(3, Bn),
  ss(4, Ou),
  ss(5, yt)
], cV);
class Fqe {
  playAudioCue(e, t) {
    return Kv(this, void 0, void 0, function* () {
    });
  }
}
an(
  en,
  lme,
  0
  /* InstantiationType.Eager */
);
an(
  rz,
  sV,
  0
  /* InstantiationType.Eager */
);
an(
  _fe,
  oV,
  0
  /* InstantiationType.Eager */
);
an(
  Qm,
  _w,
  0
  /* InstantiationType.Eager */
);
an(
  I_,
  Pqe,
  0
  /* InstantiationType.Eager */
);
an(
  qa,
  Nqe,
  0
  /* InstantiationType.Eager */
);
an(
  RS,
  kqe,
  0
  /* InstantiationType.Eager */
);
an(
  qz,
  Aqe,
  0
  /* InstantiationType.Eager */
);
an(
  dr,
  vw,
  0
  /* InstantiationType.Eager */
);
an(
  Fu,
  Mf,
  0
  /* InstantiationType.Eager */
);
an(
  ci,
  Mqe,
  0
  /* InstantiationType.Eager */
);
an(
  Ya,
  sqe,
  0
  /* InstantiationType.Eager */
);
an(
  Ka,
  Rqe,
  0
  /* InstantiationType.Eager */
);
an(
  fi,
  qL,
  0
  /* InstantiationType.Eager */
);
an(
  dz,
  MB,
  0
  /* InstantiationType.Eager */
);
an(
  yt,
  nV,
  0
  /* InstantiationType.Eager */
);
an(
  Zge,
  Iqe,
  0
  /* InstantiationType.Eager */
);
an(
  hp,
  Q4,
  0
  /* InstantiationType.Eager */
);
an(
  mc,
  Gze,
  0
  /* InstantiationType.Eager */
);
an(
  vc,
  yF,
  0
  /* InstantiationType.Eager */
);
an(
  FS,
  aV,
  0
  /* InstantiationType.Eager */
);
an(
  Jge,
  Oqe,
  0
  /* InstantiationType.Eager */
);
an(
  Wo,
  iV,
  0
  /* InstantiationType.Eager */
);
an(
  lf,
  QB,
  0
  /* InstantiationType.Eager */
);
an(
  Nl,
  aGe,
  0
  /* InstantiationType.Eager */
);
an(
  Ui,
  rV,
  0
  /* InstantiationType.Eager */
);
an(
  Bn,
  M_,
  0
  /* InstantiationType.Eager */
);
an(
  bd,
  XB,
  0
  /* InstantiationType.Eager */
);
an(
  cf,
  lV,
  0
  /* InstantiationType.Eager */
);
an(
  da,
  OB,
  0
  /* InstantiationType.Eager */
);
an(
  hf,
  tV,
  0
  /* InstantiationType.Eager */
);
an(
  gc,
  cV,
  0
  /* InstantiationType.Eager */
);
an(
  Ou,
  JB,
  0
  /* InstantiationType.Eager */
);
an(
  GS,
  Fqe,
  0
  /* InstantiationType.Eager */
);
var _t;
(function(i) {
  const e = new L4();
  for (const [l, c] of LX())
    e.set(l, c);
  const t = new tI(e, !0);
  e.set(bt, t);
  function n(l) {
    r || o({});
    const c = e.get(l);
    if (!c)
      throw new Error("Missing service " + l);
    return c instanceof Md ? t.invokeFunction((d) => d.get(l)) : c;
  }
  i.get = n;
  let r = !1;
  const s = new pe();
  function o(l) {
    if (r)
      return t;
    r = !0;
    for (const [d, u] of LX())
      e.get(d) || e.set(d, u);
    for (const d in l)
      if (l.hasOwnProperty(d)) {
        const u = Gt(d);
        e.get(u) instanceof Md && e.set(u, l[d]);
      }
    const c = Eqe();
    for (const d of c)
      try {
        t.createInstance(d);
      } catch (u) {
        It(u);
      }
    return s.fire(), t;
  }
  i.initialize = o;
  function a(l) {
    if (r)
      return l();
    const c = new Ne(), d = c.add(s.event(() => {
      d.dispose(), c.add(l());
    }));
    return c;
  }
  i.withServices = a;
})(_t || (_t = {}));
let Bqe;
function Wh() {
  return Bqe;
}
let cme;
function Vqe(i) {
  cme = i;
}
class dme {
  get TChange() {
    return null;
  }
  reportChanges() {
    this.get();
  }
  /** @sealed */
  read(e) {
    return e ? e.readObservable(this) : this.get();
  }
  map(e, t) {
    const n = t === void 0 ? void 0 : e, r = t === void 0 ? e : t;
    return cme({
      owner: n,
      debugName: () => {
        const s = j0(r);
        if (s !== void 0)
          return s;
        const a = /^\s*\(?\s*([a-zA-Z_$][a-zA-Z_$0-9]*)\s*\)?\s*=>\s*\1\.([a-zA-Z_$][a-zA-Z_$0-9]*)\s*$/.exec(r.toString());
        if (a)
          return `${this.debugName}.${a[2]}`;
        if (!n)
          return `${this.debugName} (mapped)`;
      }
    }, (s) => r(this.read(s), s));
  }
}
class qS extends dme {
  constructor() {
    super(...arguments), this.observers = /* @__PURE__ */ new Set();
  }
  addObserver(e) {
    const t = this.observers.size;
    this.observers.add(e), t === 0 && this.onFirstObserverAdded();
  }
  removeObserver(e) {
    this.observers.delete(e) && this.observers.size === 0 && this.onLastObserverRemoved();
  }
  onFirstObserverAdded() {
  }
  onLastObserverRemoved() {
  }
}
function di(i, e) {
  const t = new ume(i, e);
  try {
    i(t);
  } finally {
    t.finish();
  }
}
function dV(i, e, t) {
  i ? e(i) : di(e, t);
}
class ume {
  constructor(e, t) {
    var n;
    this._fn = e, this._getDebugName = t, this.updatingObservers = [], (n = Wh()) === null || n === void 0 || n.handleBeginTransaction(this);
  }
  getDebugName() {
    return this._getDebugName ? this._getDebugName() : j0(this._fn);
  }
  updateObserver(e, t) {
    this.updatingObservers.push({ observer: e, observable: t }), e.beginUpdate(t);
  }
  finish() {
    var e;
    const t = this.updatingObservers;
    this.updatingObservers = null;
    for (const { observer: n, observable: r } of t)
      n.endUpdate(r);
    (e = Wh()) === null || e === void 0 || e.handleEndTransaction();
  }
}
function NU(i, e, t, n) {
  let r;
  if (i !== void 0)
    if (typeof i == "function") {
      if (r = i(), r !== void 0)
        return r;
    } else
      return i;
  if (e !== void 0 && (r = j0(e), r !== void 0))
    return r;
  if (t !== void 0) {
    for (const s in t)
      if (t[s] === n)
        return s;
  }
}
function j0(i) {
  const e = i.toString(), n = /\/\*\*\s*@description\s*([^*]*)\*\//.exec(e), r = n ? n[1] : void 0;
  return r?.trim();
}
function Yn(i, e) {
  return typeof i == "string" ? new uV(void 0, i, e) : new uV(i, void 0, e);
}
class uV extends qS {
  get debugName() {
    var e;
    return (e = NU(this._debugName, void 0, this._owner, this)) !== null && e !== void 0 ? e : "ObservableValue";
  }
  constructor(e, t, n) {
    super(), this._owner = e, this._debugName = t, this._value = n;
  }
  get() {
    return this._value;
  }
  set(e, t, n) {
    var r;
    if (this._value === e)
      return;
    let s;
    t || (t = s = new ume(() => {
    }, () => `Setting ${this.debugName}`));
    try {
      const o = this._value;
      this._setValue(e), (r = Wh()) === null || r === void 0 || r.handleObservableChanged(this, { oldValue: o, newValue: e, change: n, didChange: !0, hadValue: !0 });
      for (const a of this.observers)
        t.updateObserver(a, this), a.handleChange(this, n);
    } finally {
      s && s.finish();
    }
  }
  toString() {
    return `${this.debugName}: ${this._value}`;
  }
  _setValue(e) {
    this._value = e;
  }
}
function iI(i, e) {
  return typeof i == "string" ? new NJ(void 0, i, e) : new NJ(i, void 0, e);
}
class NJ extends uV {
  _setValue(e) {
    this._value !== e && (this._value && this._value.dispose(), this._value = e);
  }
  dispose() {
    var e;
    (e = this._value) === null || e === void 0 || e.dispose();
  }
}
const bw = (i, e) => i === e;
function nn(i, e) {
  return e !== void 0 ? new yw(i, void 0, e, void 0, void 0, void 0, bw) : new yw(void 0, void 0, i, void 0, void 0, void 0, bw);
}
function PJ(i, e) {
  var t;
  return new yw(i.owner, i.debugName, e, void 0, void 0, void 0, (t = i.equalityComparer) !== null && t !== void 0 ? t : bw);
}
function Hqe(i, e) {
  var t;
  return new yw(i.owner, i.debugName, e, i.createEmptyChangeSummary, i.handleChange, void 0, (t = i.equalityComparer) !== null && t !== void 0 ? t : bw);
}
function Cw(i, e) {
  let t, n;
  e === void 0 ? (t = i, n = void 0) : (n = i, t = e);
  const r = new Ne();
  return new yw(n, () => {
    var s;
    return (s = j0(t)) !== null && s !== void 0 ? s : "(anonymous)";
  }, (s) => (r.clear(), t(s, r)), void 0, void 0, () => r.dispose(), bw);
}
Vqe(nn);
class yw extends qS {
  get debugName() {
    var e;
    return (e = NU(this._debugName, this._computeFn, this._owner, this)) !== null && e !== void 0 ? e : "(anonymous)";
  }
  constructor(e, t, n, r, s, o = void 0, a) {
    var l, c;
    super(), this._owner = e, this._debugName = t, this._computeFn = n, this.createChangeSummary = r, this._handleChange = s, this._handleLastObserverRemoved = o, this._equalityComparator = a, this.state = 0, this.value = void 0, this.updateCount = 0, this.dependencies = /* @__PURE__ */ new Set(), this.dependenciesToBeRemoved = /* @__PURE__ */ new Set(), this.changeSummary = void 0, this.changeSummary = (l = this.createChangeSummary) === null || l === void 0 ? void 0 : l.call(this), (c = Wh()) === null || c === void 0 || c.handleDerivedCreated(this);
  }
  onLastObserverRemoved() {
    var e;
    this.state = 0, this.value = void 0;
    for (const t of this.dependencies)
      t.removeObserver(this);
    this.dependencies.clear(), (e = this._handleLastObserverRemoved) === null || e === void 0 || e.call(this);
  }
  get() {
    var e;
    if (this.observers.size === 0) {
      const t = this._computeFn(this, (e = this.createChangeSummary) === null || e === void 0 ? void 0 : e.call(this));
      return this.onLastObserverRemoved(), t;
    } else {
      do {
        if (this.state === 1) {
          for (const t of this.dependencies)
            if (t.reportChanges(), this.state === 2)
              break;
        }
        this.state === 1 && (this.state = 3), this._recomputeIfNeeded();
      } while (this.state !== 3);
      return this.value;
    }
  }
  _recomputeIfNeeded() {
    var e, t;
    if (this.state === 3)
      return;
    const n = this.dependenciesToBeRemoved;
    this.dependenciesToBeRemoved = this.dependencies, this.dependencies = n;
    const r = this.state !== 0, s = this.value;
    this.state = 3;
    const o = this.changeSummary;
    this.changeSummary = (e = this.createChangeSummary) === null || e === void 0 ? void 0 : e.call(this);
    try {
      this.value = this._computeFn(this, o);
    } finally {
      for (const l of this.dependenciesToBeRemoved)
        l.removeObserver(this);
      this.dependenciesToBeRemoved.clear();
    }
    const a = r && !this._equalityComparator(s, this.value);
    if ((t = Wh()) === null || t === void 0 || t.handleDerivedRecomputed(this, {
      oldValue: s,
      newValue: this.value,
      change: void 0,
      didChange: a,
      hadValue: r
    }), a)
      for (const l of this.observers)
        l.handleChange(this, void 0);
  }
  toString() {
    return `LazyDerived<${this.debugName}>`;
  }
  // IObserver Implementation
  beginUpdate(e) {
    this.updateCount++;
    const t = this.updateCount === 1;
    if (this.state === 3 && (this.state = 1, !t))
      for (const n of this.observers)
        n.handlePossibleChange(this);
    if (t)
      for (const n of this.observers)
        n.beginUpdate(this);
  }
  endUpdate(e) {
    if (this.updateCount--, this.updateCount === 0) {
      const t = [...this.observers];
      for (const n of t)
        n.endUpdate(this);
    }
    if (this.updateCount < 0)
      throw new gr();
  }
  handlePossibleChange(e) {
    if (this.state === 3 && this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e)) {
      this.state = 1;
      for (const t of this.observers)
        t.handlePossibleChange(this);
    }
  }
  handleChange(e, t) {
    if (this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e)) {
      const n = this._handleChange ? this._handleChange({
        changedObservable: e,
        change: t,
        didChange: (s) => s === e
      }, this.changeSummary) : !0, r = this.state === 3;
      if (n && (this.state === 1 || r) && (this.state = 2, r))
        for (const s of this.observers)
          s.handlePossibleChange(this);
    }
  }
  // IReader Implementation
  readObservable(e) {
    e.addObserver(this);
    const t = e.get();
    return this.dependencies.add(e), this.dependenciesToBeRemoved.delete(e), t;
  }
  addObserver(e) {
    const t = !this.observers.has(e) && this.updateCount > 0;
    super.addObserver(e), t && e.beginUpdate(this);
  }
  removeObserver(e) {
    const t = this.observers.has(e) && this.updateCount > 0;
    super.removeObserver(e), t && e.endUpdate(this);
  }
}
function PU(i, e) {
  return new $4(i.debugName, e, void 0, void 0);
}
function zn(i) {
  return new $4(void 0, i, void 0, void 0);
}
function J4(i, e) {
  return new $4(i.debugName, e, i.createEmptyChangeSummary, i.handleChange);
}
function Yo(i) {
  const e = new Ne(), t = PU({
    debugName: () => j0(i) || "(anonymous)"
  }, (n) => {
    e.clear(), i(n, e);
  });
  return Ct(() => {
    t.dispose(), e.dispose();
  });
}
class $4 {
  get debugName() {
    if (typeof this._debugName == "string")
      return this._debugName;
    if (typeof this._debugName == "function") {
      const t = this._debugName();
      if (t !== void 0)
        return t;
    }
    const e = j0(this._runFn);
    return e !== void 0 ? e : "(anonymous)";
  }
  constructor(e, t, n, r) {
    var s, o;
    this._debugName = e, this._runFn = t, this.createChangeSummary = n, this._handleChange = r, this.state = 2, this.updateCount = 0, this.disposed = !1, this.dependencies = /* @__PURE__ */ new Set(), this.dependenciesToBeRemoved = /* @__PURE__ */ new Set(), this.changeSummary = (s = this.createChangeSummary) === null || s === void 0 ? void 0 : s.call(this), (o = Wh()) === null || o === void 0 || o.handleAutorunCreated(this), this._runIfNeeded();
  }
  dispose() {
    this.disposed = !0;
    for (const e of this.dependencies)
      e.removeObserver(this);
    this.dependencies.clear();
  }
  _runIfNeeded() {
    var e, t, n;
    if (this.state === 3)
      return;
    const r = this.dependenciesToBeRemoved;
    this.dependenciesToBeRemoved = this.dependencies, this.dependencies = r, this.state = 3;
    try {
      if (!this.disposed) {
        (e = Wh()) === null || e === void 0 || e.handleAutorunTriggered(this);
        const s = this.changeSummary;
        this.changeSummary = (t = this.createChangeSummary) === null || t === void 0 ? void 0 : t.call(this), this._runFn(this, s);
      }
    } finally {
      (n = Wh()) === null || n === void 0 || n.handleAutorunFinished(this);
      for (const s of this.dependenciesToBeRemoved)
        s.removeObserver(this);
      this.dependenciesToBeRemoved.clear();
    }
  }
  toString() {
    return `Autorun<${this.debugName}>`;
  }
  // IObserver implementation
  beginUpdate() {
    this.state === 3 && (this.state = 1), this.updateCount++;
  }
  endUpdate() {
    if (this.updateCount === 1)
      do {
        if (this.state === 1) {
          this.state = 3;
          for (const e of this.dependencies)
            if (e.reportChanges(), this.state === 2)
              break;
        }
        this._runIfNeeded();
      } while (this.state !== 3);
    this.updateCount--, Iy(() => this.updateCount >= 0);
  }
  handlePossibleChange(e) {
    this.state === 3 && this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e) && (this.state = 1);
  }
  handleChange(e, t) {
    this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e) && (!this._handleChange || this._handleChange({
      changedObservable: e,
      change: t,
      didChange: (r) => r === e
    }, this.changeSummary)) && (this.state = 2);
  }
  // IReader implementation
  readObservable(e) {
    if (this.disposed)
      return e.get();
    e.addObserver(this);
    const t = e.get();
    return this.dependencies.add(e), this.dependenciesToBeRemoved.delete(e), t;
  }
}
(function(i) {
  i.Observer = $4;
})(zn || (zn = {}));
function rI(i) {
  return new Wqe(i);
}
class Wqe extends dme {
  constructor(e) {
    super(), this.value = e;
  }
  get debugName() {
    return this.toString();
  }
  get() {
    return this.value;
  }
  addObserver(e) {
  }
  removeObserver(e) {
  }
  toString() {
    return `Const: ${this.value}`;
  }
}
function jqe(i, e) {
  return new Promise((t) => {
    let n = !1, r = !1;
    const s = zn((o) => {
      const a = i.read(o);
      e(a) && (n ? s.dispose() : r = !0, t(a));
    });
    n = !0, r && s.dispose();
  });
}
function as(i, e) {
  return new hme(i, e);
}
class hme extends qS {
  constructor(e, t) {
    super(), this.event = e, this._getValue = t, this.hasValue = !1, this.handleEvent = (n) => {
      var r;
      const s = this._getValue(n), o = !this.hasValue || this.value !== s;
      (r = Wh()) === null || r === void 0 || r.handleFromEventObservableTriggered(this, { oldValue: this.value, newValue: s, change: void 0, didChange: o, hadValue: this.hasValue }), o && (this.value = s, this.hasValue && di((a) => {
        for (const l of this.observers)
          a.updateObserver(l, this), l.handleChange(this, void 0);
      }, () => {
        const a = this.getDebugName();
        return "Event fired" + (a ? `: ${a}` : "");
      }), this.hasValue = !0);
    };
  }
  getDebugName() {
    return j0(this._getValue);
  }
  get debugName() {
    const e = this.getDebugName();
    return "From Event" + (e ? `: ${e}` : "");
  }
  onFirstObserverAdded() {
    this.subscription = this.event(this.handleEvent);
  }
  onLastObserverRemoved() {
    this.subscription.dispose(), this.subscription = void 0, this.hasValue = !1, this.value = void 0;
  }
  get() {
    return this.subscription ? (this.hasValue || this.handleEvent(void 0), this.value) : this._getValue(void 0);
  }
}
(function(i) {
  i.Observer = hme;
})(as || (as = {}));
function La(i, e) {
  return new zqe(i, e);
}
class zqe extends qS {
  constructor(e, t) {
    super(), this.debugName = e, this.event = t, this.handleEvent = () => {
      di((n) => {
        for (const r of this.observers)
          n.updateObserver(r, this), r.handleChange(this, void 0);
      }, () => this.debugName);
    };
  }
  onFirstObserverAdded() {
    this.subscription = this.event(this.handleEvent);
  }
  onLastObserverRemoved() {
    this.subscription.dispose(), this.subscription = void 0;
  }
  get() {
  }
}
function fme(i) {
  return typeof i == "string" ? new OJ(i) : new OJ(void 0, i);
}
class OJ extends qS {
  get debugName() {
    var e;
    return (e = NU(this._debugName, void 0, this._owner, this)) !== null && e !== void 0 ? e : "Observable Signal";
  }
  constructor(e, t) {
    super(), this._debugName = e, this._owner = t;
  }
  trigger(e, t) {
    if (!e) {
      di((n) => {
        this.trigger(n, t);
      }, () => `Trigger signal ${this.debugName}`);
      return;
    }
    for (const n of this.observers)
      e.updateObserver(n, this), n.handleChange(this, t);
  }
  get() {
  }
}
function ww(i) {
  const e = new Uqe(!0);
  return i.addObserver(e), i.reportChanges(), Ct(() => {
    i.removeObserver(e);
  });
}
class Uqe {
  constructor(e) {
    this.forceRecompute = e, this.counter = 0;
  }
  beginUpdate(e) {
    this.counter++;
  }
  endUpdate(e) {
    this.counter--, this.counter === 0 && this.forceRecompute && e.reportChanges();
  }
  handlePossibleChange(e) {
  }
  handleChange(e, t) {
  }
}
function gme() {
  return !!$ue.VSCODE_DEV;
}
function Gqe(i) {
  if (gme()) {
    const e = qqe();
    return e.add(i), {
      dispose() {
        e.delete(i);
      }
    };
  } else
    return { dispose() {
    } };
}
function qqe() {
  wD || (wD = /* @__PURE__ */ new Set());
  const i = globalThis;
  return i.$hotReload_applyNewExports || (i.$hotReload_applyNewExports = (e) => {
    for (const t of wD) {
      const n = t(e);
      if (n)
        return n;
    }
  }), wD;
}
let wD;
function Kqe(i, e, t, n) {
  if (i.length === 0)
    return e;
  if (e.length === 0)
    return i;
  const r = [];
  let s = 0, o = 0;
  for (; s < i.length && o < e.length; ) {
    const a = i[s], l = e[o], c = t(a), d = t(l);
    c < d ? (r.push(a), s++) : c > d ? (r.push(l), o++) : (r.push(n(a, l)), s++, o++);
  }
  for (; s < i.length; )
    r.push(i[s]), s++;
  for (; o < e.length; )
    r.push(e[o]), o++;
  return r;
}
function sI(i, e) {
  const t = new Ne(), n = i.createDecorationsCollection();
  return t.add(PU({ debugName: () => `Apply decorations from ${e.debugName}` }, (r) => {
    const s = e.read(r);
    n.set(s);
  })), t.add({
    dispose: () => {
      n.clear();
    }
  }), t;
}
function SD(i, e) {
  return i.appendChild(e), Ct(() => {
    i.removeChild(e);
  });
}
class Yqe extends we {
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
  constructor(e, t) {
    super(), this.elementSizeObserver = this._register(new Dfe(e, t)), this._width = Yn(this, this.elementSizeObserver.getWidth()), this._height = Yn(this, this.elementSizeObserver.getHeight()), this._register(this.elementSizeObserver.onDidChange((n) => di((r) => {
      this._width.set(this.elementSizeObserver.getWidth(), r), this._height.set(this.elementSizeObserver.getHeight(), r);
    })));
  }
  observe(e) {
    this.elementSizeObserver.observe(e);
  }
  setAutomaticLayout(e) {
    e ? this.elementSizeObserver.startObserving() : this.elementSizeObserver.stopObserving();
  }
}
function MJ(i, e) {
  let t = i.get(), n = t, r = t;
  const s = Yn("animatedValue", t);
  let o = -1;
  const a = 300;
  let l;
  e.add(J4({
    createEmptyChangeSummary: () => ({ animate: !1 }),
    handleChange: (d, u) => (d.didChange(i) && (u.animate = u.animate || d.change), !0)
  }, (d, u) => {
    l !== void 0 && (cancelAnimationFrame(l), l = void 0), n = r, t = i.read(d), o = Date.now() - (u.animate ? 0 : a), c();
  }));
  function c() {
    const d = Date.now() - o;
    r = Math.floor(Xqe(d, n, t - n, a)), d < a ? l = requestAnimationFrame(c) : r = t, s.set(r, void 0);
  }
  return s;
}
function Xqe(i, e, t, n) {
  return i === n ? e + t : t * (-Math.pow(2, -10 * i / n) + 1) + e;
}
class pme extends we {
  constructor(e, t, n) {
    super(), this._register(new e5(e, n)), this._register(wg(n, {
      height: t.actualHeight,
      top: t.actualTop
    }));
  }
}
class oI {
  get afterLineNumber() {
    return this._afterLineNumber.get();
  }
  constructor(e, t) {
    this._afterLineNumber = e, this.heightInPx = t, this.domNode = document.createElement("div"), this._actualTop = Yn(this, void 0), this._actualHeight = Yn(this, void 0), this.actualTop = this._actualTop, this.actualHeight = this._actualHeight, this.showInHiddenAreas = !0, this.onChange = this._afterLineNumber, this.onDomNodeTop = (n) => {
      this._actualTop.set(n, void 0);
    }, this.onComputedHeight = (n) => {
      this._actualHeight.set(n, void 0);
    };
  }
}
class e5 {
  constructor(e, t) {
    this._editor = e, this._domElement = t, this._overlayWidgetId = `managedOverlayWidget-${e5._counter++}`, this._overlayWidget = {
      getId: () => this._overlayWidgetId,
      getDomNode: () => this._domElement,
      getPosition: () => null
    }, this._editor.addOverlayWidget(this._overlayWidget);
  }
  dispose() {
    this._editor.removeOverlayWidget(this._overlayWidget);
  }
}
e5._counter = 0;
function wg(i, e) {
  return zn((t) => {
    for (let [n, r] of Object.entries(e))
      r && typeof r == "object" && "read" in r && (r = r.read(t)), typeof r == "number" && (r = `${r}px`), n = n.replace(/[A-Z]/g, (s) => "-" + s.toLowerCase()), i.style[n] = r;
  });
}
function Rf(i, e) {
  return Zqe([i], e), i;
}
function Zqe(i, e) {
  gme() && La("reload", (n) => Gqe((r) => {
    if ([...Object.values(r)].some((s) => i.includes(s)))
      return (s) => (n(void 0), !0);
  })).read(e);
}
function aI(i, e, t) {
  const n = new Ne(), r = [];
  return n.add(zn((s) => {
    const o = e.read(s), a = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
    t && t(!0), i.changeViewZones((c) => {
      for (const d of r)
        c.removeZone(d);
      r.length = 0;
      for (const d of o) {
        const u = c.addZone(d);
        r.push(u), a.set(d, u);
      }
    }), t && t(!1), n.add(J4({
      createEmptyChangeSummary() {
        return [];
      },
      handleChange(c, d) {
        const u = l.get(c.changedObservable);
        return u !== void 0 && d.push(u), !0;
      }
    }, (c, d) => {
      for (const u of o)
        u.onChange && (l.set(u.onChange, a.get(u)), u.onChange.read(c));
      t && t(!0), i.changeViewZones((u) => {
        for (const h of d)
          u.layoutZone(h);
      }), t && t(!1);
    }));
  })), n.add({
    dispose() {
      t && t(!0), i.changeViewZones((s) => {
        for (const o of r)
          s.removeZone(o);
      }), t && t(!1);
    }
  }), n;
}
class Qqe extends lr {
  dispose() {
    super.dispose(!0);
  }
}
var OU = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, MU = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Jqe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const $qe = $i("diff-review-insert", We.add, C("accessibleDiffViewerInsertIcon", "Icon for 'Insert' in accessible diff viewer.")), eKe = $i("diff-review-remove", We.remove, C("accessibleDiffViewerRemoveIcon", "Icon for 'Remove' in accessible diff viewer.")), tKe = $i("diff-review-close", We.close, C("accessibleDiffViewerCloseIcon", "Icon for 'Close' in accessible diff viewer."));
let rg = class extends we {
  constructor(e, t, n, r, s, o, a, l, c) {
    super(), this._parentNode = e, this._visible = t, this._setVisible = n, this._canClose = r, this._width = s, this._height = o, this._diffs = a, this._editors = l, this._instantiationService = c, this.model = Cw(this, (d, u) => {
      const h = this._visible.read(d);
      if (this._parentNode.style.visibility = h ? "visible" : "hidden", !h)
        return null;
      const f = u.add(this._instantiationService.createInstance(hV, this._diffs, this._editors, this._setVisible, this._canClose)), g = u.add(this._instantiationService.createInstance(fV, this._parentNode, f, this._width, this._height, this._editors));
      return {
        model: f,
        view: g
      };
    }), this._register(ww(this.model));
  }
  next() {
    di((e) => {
      const t = this._visible.get();
      this._setVisible(!0, e), t && this.model.get().model.nextGroup(e);
    });
  }
  prev() {
    di((e) => {
      this._setVisible(!0, e), this.model.get().model.previousGroup(e);
    });
  }
  close() {
    di((e) => {
      this._setVisible(!1, e);
    });
  }
};
rg._ttPolicy = af("diffReview", { createHTML: (i) => i });
rg = OU([
  MU(8, bt)
], rg);
let hV = class extends we {
  constructor(e, t, n, r, s) {
    super(), this._diffs = e, this._editors = t, this._setVisible = n, this.canClose = r, this._audioCueService = s, this._groups = Yn(this, []), this._currentGroupIdx = Yn(this, 0), this._currentElementIdx = Yn(this, 0), this.groups = this._groups, this.currentGroup = this._currentGroupIdx.map((o, a) => this._groups.read(a)[o]), this.currentGroupIndex = this._currentGroupIdx, this.currentElement = this._currentElementIdx.map((o, a) => {
      var l;
      return (l = this.currentGroup.read(a)) === null || l === void 0 ? void 0 : l.lines[o];
    }), this._register(zn((o) => {
      const a = this._diffs.read(o);
      if (!a) {
        this._groups.set([], void 0);
        return;
      }
      const l = nKe(a, this._editors.original.getModel().getLineCount(), this._editors.modified.getModel().getLineCount());
      di((c) => {
        const d = this._editors.modified.getPosition();
        if (d) {
          const u = l.findIndex((h) => d?.lineNumber < h.range.modified.endLineNumberExclusive);
          u !== -1 && this._currentGroupIdx.set(u, c);
        }
        this._groups.set(l, c);
      });
    })), this._register(zn((o) => {
      const a = this.currentElement.read(o);
      a?.type === lo.Deleted ? this._audioCueService.playAudioCue(un.diffLineDeleted, { source: "accessibleDiffViewer.currentElementChanged" }) : a?.type === lo.Added && this._audioCueService.playAudioCue(un.diffLineInserted, { source: "accessibleDiffViewer.currentElementChanged" });
    })), this._register(zn((o) => {
      var a;
      const l = this.currentElement.read(o);
      if (l && l.type !== lo.Header) {
        const c = (a = l.modifiedLineNumber) !== null && a !== void 0 ? a : l.diff.modified.startLineNumber;
        this._editors.modified.setSelection(V.fromPositions(new ve(c, 1)));
      }
    }));
  }
  _goToGroupDelta(e, t) {
    const n = this.groups.get();
    !n || n.length <= 1 || dV(t, (r) => {
      this._currentGroupIdx.set(zt.ofLength(n.length).clipCyclic(this._currentGroupIdx.get() + e), r), this._currentElementIdx.set(0, r);
    });
  }
  nextGroup(e) {
    this._goToGroupDelta(1, e);
  }
  previousGroup(e) {
    this._goToGroupDelta(-1, e);
  }
  _goToLineDelta(e) {
    const t = this.currentGroup.get();
    !t || t.lines.length <= 1 || di((n) => {
      this._currentElementIdx.set(zt.ofLength(t.lines.length).clip(this._currentElementIdx.get() + e), n);
    });
  }
  goToNextLine() {
    this._goToLineDelta(1);
  }
  goToPreviousLine() {
    this._goToLineDelta(-1);
  }
  goToLine(e) {
    const t = this.currentGroup.get();
    if (!t)
      return;
    const n = t.lines.indexOf(e);
    n !== -1 && di((r) => {
      this._currentElementIdx.set(n, r);
    });
  }
  revealCurrentElementInEditor() {
    this._setVisible(!1, void 0);
    const e = this.currentElement.get();
    e && (e.type === lo.Deleted ? (this._editors.original.setSelection(V.fromPositions(new ve(e.originalLineNumber, 1))), this._editors.original.revealLine(e.originalLineNumber), this._editors.original.focus()) : (e.type !== lo.Header && (this._editors.modified.setSelection(V.fromPositions(new ve(e.modifiedLineNumber, 1))), this._editors.modified.revealLine(e.modifiedLineNumber)), this._editors.modified.focus()));
  }
  close() {
    this._setVisible(!1, void 0), this._editors.modified.focus();
  }
};
hV = OU([
  MU(4, GS)
], hV);
const h2 = 3;
function nKe(i, e, t) {
  const n = [];
  for (const r of Aue(i, (s, o) => o.modified.startLineNumber - s.modified.endLineNumberExclusive < 2 * h2)) {
    const s = [];
    s.push(new rKe());
    const o = new Qt(Math.max(1, r[0].original.startLineNumber - h2), Math.min(r[r.length - 1].original.endLineNumberExclusive + h2, e + 1)), a = new Qt(Math.max(1, r[0].modified.startLineNumber - h2), Math.min(r[r.length - 1].modified.endLineNumberExclusive + h2, t + 1));
    kue(r, (d, u) => {
      const h = new Qt(d ? d.original.endLineNumberExclusive : o.startLineNumber, u ? u.original.startLineNumber : o.endLineNumberExclusive), f = new Qt(d ? d.modified.endLineNumberExclusive : a.startLineNumber, u ? u.modified.startLineNumber : a.endLineNumberExclusive);
      h.forEach((g) => {
        s.push(new aKe(g, f.startLineNumber + (g - h.startLineNumber)));
      }), u && (u.original.forEach((g) => {
        s.push(new sKe(u, g));
      }), u.modified.forEach((g) => {
        s.push(new oKe(u, g));
      }));
    });
    const l = r[0].modified.join(r[r.length - 1].modified), c = r[0].original.join(r[r.length - 1].original);
    n.push(new iKe(new wu(l, c), s));
  }
  return n;
}
var lo;
(function(i) {
  i[i.Header = 0] = "Header", i[i.Unchanged = 1] = "Unchanged", i[i.Deleted = 2] = "Deleted", i[i.Added = 3] = "Added";
})(lo || (lo = {}));
class iKe {
  constructor(e, t) {
    this.range = e, this.lines = t;
  }
}
class rKe {
  constructor() {
    this.type = lo.Header;
  }
}
class sKe {
  constructor(e, t) {
    this.diff = e, this.originalLineNumber = t, this.type = lo.Deleted, this.modifiedLineNumber = void 0;
  }
}
class oKe {
  constructor(e, t) {
    this.diff = e, this.modifiedLineNumber = t, this.type = lo.Added, this.originalLineNumber = void 0;
  }
}
class aKe {
  constructor(e, t) {
    this.originalLineNumber = e, this.modifiedLineNumber = t, this.type = lo.Unchanged;
  }
}
let fV = class extends we {
  constructor(e, t, n, r, s, o) {
    super(), this._element = e, this._model = t, this._width = n, this._height = r, this._editors = s, this._languageService = o, this.domNode = this._element, this.domNode.className = "diff-review monaco-editor-background";
    const a = document.createElement("div");
    a.className = "diff-review-actions", this._actionBar = this._register(new Dl(a)), this._register(zn((l) => {
      this._actionBar.clear(), this._model.canClose.read(l) && this._actionBar.push(new vo("diffreview.close", C("label.close", "Close"), "close-diff-review " + ft.asClassName(tKe), !0, () => Jqe(this, void 0, void 0, function* () {
        return t.close();
      })), { label: !1, icon: !0 });
    })), this._content = document.createElement("div"), this._content.className = "diff-review-content", this._content.setAttribute("role", "code"), this._scrollbar = this._register(new TS(this._content, {})), cs(this.domNode, this._scrollbar.getDomNode(), a), this._register(Ct(() => {
      cs(this.domNode);
    })), this._register(wg(this.domNode, { width: this._width, height: this._height })), this._register(wg(this._content, { width: this._width, height: this._height })), this._register(Yo((l, c) => {
      this._model.currentGroup.read(l), this._render(c);
    })), this._register(ar(this.domNode, "keydown", (l) => {
      (l.equals(
        18
        /* KeyCode.DownArrow */
      ) || l.equals(
        2066
        /* KeyCode.DownArrow */
      ) || l.equals(
        530
        /* KeyCode.DownArrow */
      )) && (l.preventDefault(), this._model.goToNextLine()), (l.equals(
        16
        /* KeyCode.UpArrow */
      ) || l.equals(
        2064
        /* KeyCode.UpArrow */
      ) || l.equals(
        528
        /* KeyCode.UpArrow */
      )) && (l.preventDefault(), this._model.goToPreviousLine()), (l.equals(
        9
        /* KeyCode.Escape */
      ) || l.equals(
        2057
        /* KeyCode.Escape */
      ) || l.equals(
        521
        /* KeyCode.Escape */
      ) || l.equals(
        1033
        /* KeyCode.Escape */
      )) && (l.preventDefault(), this._model.close()), (l.equals(
        10
        /* KeyCode.Space */
      ) || l.equals(
        3
        /* KeyCode.Enter */
      )) && (l.preventDefault(), this._model.revealCurrentElementInEditor());
    }));
  }
  _render(e) {
    const t = this._editors.original.getOptions(), n = this._editors.modified.getOptions(), r = document.createElement("div");
    r.className = "diff-review-table", r.setAttribute("role", "list"), r.setAttribute("aria-label", C("ariaLabel", "Accessible Diff Viewer. Use arrow up and down to navigate.")), Ds(r, n.get(
      50
      /* EditorOption.fontInfo */
    )), cs(this._content, r);
    const s = this._editors.original.getModel(), o = this._editors.modified.getModel();
    if (!s || !o)
      return;
    const a = s.getOptions(), l = o.getOptions(), c = n.get(
      66
      /* EditorOption.lineHeight */
    ), d = this._model.currentGroup.get();
    for (const u of d?.lines || []) {
      if (!d)
        break;
      let h;
      if (u.type === lo.Header) {
        const g = document.createElement("div");
        g.className = "diff-review-row", g.setAttribute("role", "listitem");
        const p = d.range, m = this._model.currentGroupIndex.get(), _ = this._model.groups.get().length, b = (x) => x === 0 ? C("no_lines_changed", "no lines changed") : x === 1 ? C("one_line_changed", "1 line changed") : C("more_lines_changed", "{0} lines changed", x), w = b(p.original.length), y = b(p.modified.length);
        g.setAttribute("aria-label", C({
          key: "header",
          comment: [
            "This is the ARIA label for a git diff header.",
            "A git diff header looks like this: @@ -154,12 +159,39 @@.",
            "That encodes that at original line 154 (which is now line 159), 12 lines were removed/changed with 39 lines.",
            "Variables 0 and 1 refer to the diff index out of total number of diffs.",
            "Variables 2 and 4 will be numbers (a line number).",
            'Variables 3 and 5 will be "no lines changed", "1 line changed" or "X lines changed", localized separately.'
          ]
        }, "Difference {0} of {1}: original line {2}, {3}, modified line {4}, {5}", m + 1, _, p.original.startLineNumber, w, p.modified.startLineNumber, y));
        const S = document.createElement("div");
        S.className = "diff-review-cell diff-review-summary", S.appendChild(document.createTextNode(`${m + 1}/${_}: @@ -${p.original.startLineNumber},${p.original.length} +${p.modified.startLineNumber},${p.modified.length} @@`)), g.appendChild(S), h = g;
      } else
        h = this._createRow(u, c, this._width.get(), t, s, a, n, o, l);
      r.appendChild(h);
      const f = nn((g) => (
        /** @description isSelected */
        this._model.currentElement.read(g) === u
      ));
      e.add(zn((g) => {
        const p = f.read(g);
        h.tabIndex = p ? 0 : -1, p && h.focus();
      })), e.add(Ie(h, "focus", () => {
        this._model.goToLine(u);
      }));
    }
    this._scrollbar.scanDomNode();
  }
  _createRow(e, t, n, r, s, o, a, l, c) {
    const d = r.get(
      143
      /* EditorOption.layoutInfo */
    ), u = d.glyphMarginWidth + d.lineNumbersWidth, h = a.get(
      143
      /* EditorOption.layoutInfo */
    ), f = 10 + h.glyphMarginWidth + h.lineNumbersWidth;
    let g = "diff-review-row", p = "";
    const m = "diff-review-spacer";
    let _ = null;
    switch (e.type) {
      case lo.Added:
        g = "diff-review-row line-insert", p = " char-insert", _ = $qe;
        break;
      case lo.Deleted:
        g = "diff-review-row line-delete", p = " char-delete", _ = eKe;
        break;
    }
    const b = document.createElement("div");
    b.style.minWidth = n + "px", b.className = g, b.setAttribute("role", "listitem"), b.ariaLevel = "";
    const w = document.createElement("div");
    w.className = "diff-review-cell", w.style.height = `${t}px`, b.appendChild(w);
    const y = document.createElement("span");
    y.style.width = u + "px", y.style.minWidth = u + "px", y.className = "diff-review-line-number" + p, e.originalLineNumber !== void 0 ? y.appendChild(document.createTextNode(String(e.originalLineNumber))) : y.innerText = " ", w.appendChild(y);
    const S = document.createElement("span");
    S.style.width = f + "px", S.style.minWidth = f + "px", S.style.paddingRight = "10px", S.className = "diff-review-line-number" + p, e.modifiedLineNumber !== void 0 ? S.appendChild(document.createTextNode(String(e.modifiedLineNumber))) : S.innerText = " ", w.appendChild(S);
    const x = document.createElement("span");
    if (x.className = m, _) {
      const L = document.createElement("span");
      L.className = ft.asClassName(_), L.innerText = "  ", x.appendChild(L);
    } else
      x.innerText = "  ";
    w.appendChild(x);
    let D;
    if (e.modifiedLineNumber !== void 0) {
      let L = this._getLineHtml(l, a, c.tabSize, e.modifiedLineNumber, this._languageService.languageIdCodec);
      rg._ttPolicy && (L = rg._ttPolicy.createHTML(L)), w.insertAdjacentHTML("beforeend", L), D = l.getLineContent(e.modifiedLineNumber);
    } else {
      let L = this._getLineHtml(s, r, o.tabSize, e.originalLineNumber, this._languageService.languageIdCodec);
      rg._ttPolicy && (L = rg._ttPolicy.createHTML(L)), w.insertAdjacentHTML("beforeend", L), D = s.getLineContent(e.originalLineNumber);
    }
    D.length === 0 && (D = C("blankLine", "blank"));
    let E = "";
    switch (e.type) {
      case lo.Unchanged:
        e.originalLineNumber === e.modifiedLineNumber ? E = C({ key: "unchangedLine", comment: ["The placeholders are contents of the line and should not be translated."] }, "{0} unchanged line {1}", D, e.originalLineNumber) : E = C("equalLine", "{0} original line {1} modified line {2}", D, e.originalLineNumber, e.modifiedLineNumber);
        break;
      case lo.Added:
        E = C("insertLine", "+ {0} modified line {1}", D, e.modifiedLineNumber);
        break;
      case lo.Deleted:
        E = C("deleteLine", "- {0} original line {1}", D, e.originalLineNumber);
        break;
    }
    return b.setAttribute("aria-label", E), b;
  }
  _getLineHtml(e, t, n, r, s) {
    const o = e.getLineContent(r), a = t.get(
      50
      /* EditorOption.fontInfo */
    ), l = Tr.createEmpty(o, s), c = Wa.isBasicASCII(o, e.mightContainNonBasicASCII()), d = Wa.containsRTL(o, c, e.mightContainRTL());
    return g4(new dp(a.isMonospace && !t.get(
      33
      /* EditorOption.disableMonospaceOptimizations */
    ), a.canUseHalfwidthRightwardsArrow, o, !1, c, d, 0, l, [], n, 0, a.spaceWidth, a.middotWidth, a.wsmiddotWidth, t.get(
      116
      /* EditorOption.stopRenderingLineAfter */
    ), t.get(
      98
      /* EditorOption.renderWhitespace */
    ), t.get(
      93
      /* EditorOption.renderControlCharacters */
    ), t.get(
      51
      /* EditorOption.fontLigatures */
    ) !== Da.OFF, null)).html;
  }
};
fV = OU([
  MU(5, ci)
], fV);
const lKe = $i("diff-insert", We.add, C("diffInsertIcon", "Line decoration for inserts in the diff editor.")), mme = $i("diff-remove", We.remove, C("diffRemoveIcon", "Line decoration for removals in the diff editor.")), RJ = Lt.register({
  className: "line-insert",
  description: "line-insert",
  isWholeLine: !0,
  linesDecorationsClassName: "insert-sign " + ft.asClassName(lKe),
  marginClassName: "gutter-insert"
}), FJ = Lt.register({
  className: "line-delete",
  description: "line-delete",
  isWholeLine: !0,
  linesDecorationsClassName: "delete-sign " + ft.asClassName(mme),
  marginClassName: "gutter-delete"
}), BJ = Lt.register({
  className: "line-insert",
  description: "line-insert",
  isWholeLine: !0,
  marginClassName: "gutter-insert"
}), VJ = Lt.register({
  className: "line-delete",
  description: "line-delete",
  isWholeLine: !0,
  marginClassName: "gutter-delete"
}), HJ = Lt.register({
  className: "char-insert",
  description: "char-insert",
  shouldFillLineOnLineBreak: !0
}), cKe = Lt.register({
  className: "char-insert",
  description: "char-insert",
  isWholeLine: !0
}), dKe = Lt.register({
  className: "char-insert diff-range-empty",
  description: "char-insert diff-range-empty"
}), gV = Lt.register({
  className: "char-delete",
  description: "char-delete",
  shouldFillLineOnLineBreak: !0
}), uKe = Lt.register({
  className: "char-delete",
  description: "char-delete",
  isWholeLine: !0
}), hKe = Lt.register({
  className: "char-delete diff-range-empty",
  description: "char-delete diff-range-empty"
}), fKe = Lt.register({
  description: "diff-editor-arrow-revert-change",
  glyphMarginHoverMessage: new ys(void 0, { isTrusted: !0, supportThemeIcons: !0 }).appendMarkdown(C("revertChangeHoverMessage", "Click to revert change")),
  glyphMarginClassName: "arrow-revert-change " + ft.asClassName(We.arrowRight),
  zIndex: 10001
});
class Sg extends we {
  constructor(e, t, n, r, s) {
    super(), this._rootElement = e, this._diffModel = t, this._originalEditorLayoutInfo = n, this._modifiedEditorLayoutInfo = r, this._editors = s, this._originalScrollTop = as(this._editors.original.onDidScrollChange, () => this._editors.original.getScrollTop()), this._modifiedScrollTop = as(this._editors.modified.onDidScrollChange, () => this._editors.modified.getScrollTop()), this._viewZonesChanged = La("onDidChangeViewZones", this._editors.modified.onDidChangeViewZones), this.width = Yn(this, 0), this._modifiedViewZonesChangedSignal = La("modified.onDidChangeViewZones", this._editors.modified.onDidChangeViewZones), this._originalViewZonesChangedSignal = La("original.onDidChangeViewZones", this._editors.original.onDidChangeViewZones), this._state = Cw((h, f) => {
      var g;
      this._element.replaceChildren();
      const p = this._diffModel.read(h), m = (g = p?.diff.read(h)) === null || g === void 0 ? void 0 : g.movedTexts;
      if (!m || m.length === 0) {
        this.width.set(0, void 0);
        return;
      }
      this._viewZonesChanged.read(h);
      const _ = this._originalEditorLayoutInfo.read(h), b = this._modifiedEditorLayoutInfo.read(h);
      if (!_ || !b) {
        this.width.set(0, void 0);
        return;
      }
      this._modifiedViewZonesChangedSignal.read(h), this._originalViewZonesChangedSignal.read(h);
      const w = m.map((k) => {
        function N(R, T) {
          const z = T.getTopForLineNumber(R.startLineNumber, !0), X = T.getTopForLineNumber(R.endLineNumberExclusive, !0);
          return (z + X) / 2;
        }
        const I = N(k.lineRangeMapping.original, this._editors.original), A = this._originalScrollTop.read(h), P = N(k.lineRangeMapping.modified, this._editors.modified), O = this._modifiedScrollTop.read(h), K = I - A, W = P - O, F = Math.min(I, P), q = Math.max(I, P);
        return { range: new zt(F, q), from: K, to: W, fromWithoutScroll: I, toWithoutScroll: P, move: k };
      });
      w.sort(v6e(hl((k) => k.fromWithoutScroll > k.toWithoutScroll, _6e), hl((k) => k.fromWithoutScroll > k.toWithoutScroll ? k.fromWithoutScroll : -k.toWithoutScroll, Rh)));
      const y = RU.compute(w.map((k) => k.range)), S = 10, x = _.verticalScrollbarWidth, D = (y.getTrackCount() - 1) * 10 + S * 2, E = x + D + (b.contentLeft - Sg.movedCodeBlockPadding);
      let L = 0;
      for (const k of w) {
        const N = y.getTrack(L), I = x + S + N * 10, A = 15, P = 15, O = E, K = b.glyphMarginWidth + b.lineNumbersWidth, W = 18, F = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        F.classList.add("arrow-rectangle"), F.setAttribute("x", `${O - K}`), F.setAttribute("y", `${k.to - W / 2}`), F.setAttribute("width", `${K}`), F.setAttribute("height", `${W}`), this._element.appendChild(F);
        const q = document.createElementNS("http://www.w3.org/2000/svg", "g"), R = document.createElementNS("http://www.w3.org/2000/svg", "path");
        R.setAttribute("d", `M 0 ${k.from} L ${I} ${k.from} L ${I} ${k.to} L ${O - P} ${k.to}`), R.setAttribute("fill", "none"), q.appendChild(R);
        const T = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
        T.classList.add("arrow"), f.add(zn((z) => {
          R.classList.toggle("currentMove", k.move === p.activeMovedText.read(z)), T.classList.toggle("currentMove", k.move === p.activeMovedText.read(z));
        })), T.setAttribute("points", `${O - P},${k.to - A / 2} ${O},${k.to} ${O - P},${k.to + A / 2}`), q.appendChild(T), this._element.appendChild(q), L++;
      }
      this.width.set(D, void 0);
    }), this._element = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this._element.setAttribute("class", "moved-blocks-lines"), this._rootElement.appendChild(this._element), this._register(Ct(() => this._element.remove())), this._register(zn((h) => {
      const f = this._originalEditorLayoutInfo.read(h), g = this._modifiedEditorLayoutInfo.read(h);
      !f || !g || (this._element.style.left = `${f.width - f.verticalScrollbarWidth}px`, this._element.style.height = `${f.height}px`, this._element.style.width = `${f.verticalScrollbarWidth + f.contentLeft - Sg.movedCodeBlockPadding + this.width.read(h)}px`);
    })), this._register(ww(this._state));
    const o = nn((h) => {
      const f = this._diffModel.read(h), g = f?.diff.read(h);
      return g ? g.movedTexts.map((p) => ({
        move: p,
        original: new oI(rI(p.lineRangeMapping.original.startLineNumber - 1), 18),
        modified: new oI(rI(p.lineRangeMapping.modified.startLineNumber - 1), 18)
      })) : [];
    });
    this._register(aI(this._editors.original, o.map((h) => h.map((f) => f.original)))), this._register(aI(this._editors.modified, o.map((h) => h.map((f) => f.modified)))), this._register(Yo((h, f) => {
      const g = o.read(h);
      for (const p of g)
        f.add(new WJ(this._editors.original, p.original, p.move, "original", this._diffModel.get())), f.add(new WJ(this._editors.modified, p.modified, p.move, "modified", this._diffModel.get()));
    }));
    const a = as(this._editors.original.onDidChangeCursorPosition, () => this._editors.original.getPosition()), l = as(this._editors.modified.onDidChangeCursorPosition, () => this._editors.modified.getPosition()), c = La("original.onDidFocusEditorWidget", (h) => this._editors.original.onDidFocusEditorWidget(() => setTimeout(() => h(void 0), 0))), d = La("modified.onDidFocusEditorWidget", (h) => this._editors.modified.onDidFocusEditorWidget(() => setTimeout(() => h(void 0), 0)));
    let u = "modified";
    this._register(J4({
      createEmptyChangeSummary: () => {
      },
      handleChange: (h, f) => (h.didChange(c) && (u = "original"), h.didChange(d) && (u = "modified"), !0)
    }, (h) => {
      c.read(h), d.read(h);
      const f = this._diffModel.read(h);
      if (!f)
        return;
      const g = f.diff.read(h);
      let p;
      if (g && u === "original") {
        const m = a.read(h);
        m && (p = g.movedTexts.find((_) => _.lineRangeMapping.original.contains(m.lineNumber)));
      }
      if (g && u === "modified") {
        const m = l.read(h);
        m && (p = g.movedTexts.find((_) => _.lineRangeMapping.modified.contains(m.lineNumber)));
      }
      p !== f.movedTextToCompare.get() && f.movedTextToCompare.set(void 0, void 0), f.setActiveMovedText(p);
    }));
  }
}
Sg.movedCodeBlockPadding = 4;
class RU {
  static compute(e) {
    const t = [], n = [];
    for (const r of e) {
      let s = t.findIndex((o) => !o.intersectsStrict(r));
      s === -1 && (t.length >= 6 ? s = NPe(t, hl((a) => a.intersectWithRangeLength(r), Rh)) : (s = t.length, t.push(new tz()))), t[s].addRange(r), n.push(s);
    }
    return new RU(t.length, n);
  }
  constructor(e, t) {
    this._trackCount = e, this.trackPerLineIdx = t;
  }
  getTrack(e) {
    return this.trackPerLineIdx[e];
  }
  getTrackCount() {
    return this._trackCount;
  }
}
class WJ extends pme {
  constructor(e, t, n, r, s) {
    const o = ts("div.diff-hidden-lines-widget");
    super(e, t, o.root), this._editor = e, this._move = n, this._kind = r, this._diffModel = s, this._nodes = ts("div.diff-moved-code-block", { style: { marginRight: "4px" } }, [
      ts("div.text-content@textContent"),
      ts("div.action-bar@actionBar")
    ]), o.root.appendChild(this._nodes.root);
    const a = as(this._editor.onDidLayoutChange, () => this._editor.getLayoutInfo());
    this._register(wg(this._nodes.root, {
      paddingRight: a.map((h) => h.verticalScrollbarWidth)
    }));
    let l;
    n.changes.length > 0 ? l = this._kind === "original" ? C("codeMovedToWithChanges", "Code moved with changes to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : C("codeMovedFromWithChanges", "Code moved with changes from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1) : l = this._kind === "original" ? C("codeMovedTo", "Code moved to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : C("codeMovedFrom", "Code moved from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1);
    const c = this._register(new Dl(this._nodes.actionBar, {
      highlightToggledItems: !0
    })), d = new vo("", l, "", !1);
    c.push(d, { icon: !1, label: !0 });
    const u = new vo("", "Compare", ft.asClassName(We.compareChanges), !0, () => {
      this._editor.focus(), this._diffModel.movedTextToCompare.set(this._diffModel.movedTextToCompare.get() === n ? void 0 : this._move, void 0);
    });
    this._register(zn((h) => {
      const f = this._diffModel.movedTextToCompare.read(h) === n;
      u.checked = f;
    })), c.push(u, { icon: !1, label: !0 });
  }
}
class gKe extends we {
  constructor(e, t, n) {
    super(), this._editors = e, this._diffModel = t, this._options = n, this._decorations = nn(this, (r) => {
      var s;
      const o = (s = this._diffModel.read(r)) === null || s === void 0 ? void 0 : s.diff.read(r);
      if (!o)
        return null;
      const a = this._diffModel.read(r).movedTextToCompare.read(r), l = this._options.renderIndicators.read(r), c = this._options.showEmptyDecorations.read(r), d = [], u = [];
      if (!a)
        for (const f of o.mappings) {
          if (f.lineRangeMapping.original.isEmpty || d.push({ range: f.lineRangeMapping.original.toInclusiveRange(), options: l ? FJ : VJ }), f.lineRangeMapping.modified.isEmpty || u.push({ range: f.lineRangeMapping.modified.toInclusiveRange(), options: l ? RJ : BJ }), f.lineRangeMapping.modified.isEmpty || f.lineRangeMapping.original.isEmpty)
            f.lineRangeMapping.original.isEmpty || d.push({ range: f.lineRangeMapping.original.toInclusiveRange(), options: uKe }), f.lineRangeMapping.modified.isEmpty || u.push({ range: f.lineRangeMapping.modified.toInclusiveRange(), options: cKe });
          else
            for (const g of f.lineRangeMapping.innerChanges || [])
              f.lineRangeMapping.original.contains(g.originalRange.startLineNumber) && d.push({ range: g.originalRange, options: g.originalRange.isEmpty() && c ? hKe : gV }), f.lineRangeMapping.modified.contains(g.modifiedRange.startLineNumber) && u.push({ range: g.modifiedRange, options: g.modifiedRange.isEmpty() && c ? dKe : HJ });
          !f.lineRangeMapping.modified.isEmpty && this._options.shouldRenderRevertArrows.read(r) && !a && u.push({ range: V.fromPositions(new ve(f.lineRangeMapping.modified.startLineNumber, 1)), options: fKe });
        }
      if (a)
        for (const f of a.changes) {
          const g = f.original.toInclusiveRange();
          g && d.push({ range: g, options: l ? FJ : VJ });
          const p = f.modified.toInclusiveRange();
          p && u.push({ range: p, options: l ? RJ : BJ });
          for (const m of f.innerChanges || [])
            d.push({ range: m.originalRange, options: gV }), u.push({ range: m.modifiedRange, options: HJ });
        }
      const h = this._diffModel.read(r).activeMovedText.read(r);
      for (const f of o.movedTexts)
        d.push({
          range: f.lineRangeMapping.original.toInclusiveRange(),
          options: {
            description: "moved",
            blockClassName: "movedOriginal" + (f === h ? " currentMove" : ""),
            blockPadding: [Sg.movedCodeBlockPadding, 0, Sg.movedCodeBlockPadding, Sg.movedCodeBlockPadding]
          }
        }), u.push({
          range: f.lineRangeMapping.modified.toInclusiveRange(),
          options: {
            description: "moved",
            blockClassName: "movedModified" + (f === h ? " currentMove" : ""),
            blockPadding: [4, 0, 4, 4]
          }
        });
      return { originalDecorations: d, modifiedDecorations: u };
    }), this._register(sI(this._editors.original, this._decorations.map((r) => r?.originalDecorations || []))), this._register(sI(this._editors.modified, this._decorations.map((r) => r?.modifiedDecorations || [])));
  }
}
class pKe extends we {
  constructor(e, t, n) {
    super(), this._options = e, this._domNode = t, this._dimensions = n, this._sashRatio = Yn(this, void 0), this.sashLeft = nn(this, (r) => {
      var s;
      const o = (s = this._sashRatio.read(r)) !== null && s !== void 0 ? s : this._options.splitViewDefaultRatio.read(r);
      return this._computeSashLeft(o, r);
    }), this._sash = this._register(new Ts(this._domNode, {
      getVerticalSashTop: (r) => 0,
      getVerticalSashLeft: (r) => this.sashLeft.get(),
      getVerticalSashHeight: (r) => this._dimensions.height.get()
    }, {
      orientation: 0
      /* Orientation.VERTICAL */
    })), this._startSashPosition = void 0, this._register(this._sash.onDidStart(() => {
      this._startSashPosition = this.sashLeft.get();
    })), this._register(this._sash.onDidChange((r) => {
      const s = this._dimensions.width.get(), o = this._computeSashLeft((this._startSashPosition + (r.currentX - r.startX)) / s, void 0);
      this._sashRatio.set(o / s, void 0);
    })), this._register(this._sash.onDidEnd(() => this._sash.layout())), this._register(this._sash.onDidReset(() => this._sashRatio.set(void 0, void 0))), this._register(zn((r) => {
      const s = this._options.enableSplitViewResizing.read(r);
      this._sash.state = s ? 3 : 0, this.sashLeft.read(r), this._dimensions.height.read(r), this._sash.layout();
    }));
  }
  setBoundarySashes(e) {
    this._sash.orthogonalEndSash = e.bottom;
  }
  /** @pure */
  _computeSashLeft(e, t) {
    const n = this._dimensions.width.read(t), r = Math.floor(this._options.splitViewDefaultRatio.read(t) * n), s = this._options.enableSplitViewResizing.read(t) ? Math.floor(e * n) : r, o = 100;
    return n <= o * 2 ? r : s < o ? o : s > n - o ? n - o : s;
  }
}
let fv = class {
  remove() {
    var e;
    (e = this.parent) === null || e === void 0 || e.children.delete(this.id);
  }
  static findId(e, t) {
    let n;
    typeof e == "string" ? n = `${t.id}/${e}` : (n = `${t.id}/${e.name}`, t.children.get(n) !== void 0 && (n = `${t.id}/${e.name}_${e.range.startLineNumber}_${e.range.startColumn}`));
    let r = n;
    for (let s = 0; t.children.get(r) !== void 0; s++)
      r = `${n}_${s}`;
    return r;
  }
  static empty(e) {
    return e.children.size === 0;
  }
}, jJ = class extends fv {
  constructor(e, t, n) {
    super(), this.id = e, this.parent = t, this.symbol = n, this.children = /* @__PURE__ */ new Map();
  }
}, mKe = class extends fv {
  constructor(e, t, n, r) {
    super(), this.id = e, this.parent = t, this.label = n, this.order = r, this.children = /* @__PURE__ */ new Map();
  }
}, vKe = class jp extends fv {
  static create(e, t, n) {
    const r = new lr(n), s = new jp(t.uri), o = e.ordered(t), a = o.map((c, d) => {
      var u;
      const h = fv.findId(`provider_${d}`, s), f = new mKe(h, s, (u = c.displayName) !== null && u !== void 0 ? u : "Unknown Outline Provider", d);
      return Promise.resolve(c.provideDocumentSymbols(t, r.token)).then((g) => {
        for (const p of g || [])
          jp._makeOutlineElement(p, f);
        return f;
      }, (g) => (vr(g), f)).then((g) => {
        fv.empty(g) ? g.remove() : s._groups.set(h, g);
      });
    }), l = e.onDidChange(() => {
      const c = e.ordered(t);
      Qi(c, o) || r.cancel();
    });
    return Promise.all(a).then(() => r.token.isCancellationRequested && !n.isCancellationRequested ? jp.create(e, t, n) : s._compact()).finally(() => {
      r.dispose(), l.dispose();
    });
  }
  static _makeOutlineElement(e, t) {
    const n = fv.findId(e, t), r = new jJ(n, t, e);
    if (e.children)
      for (const s of e.children)
        jp._makeOutlineElement(s, r);
    t.children.set(r.id, r);
  }
  constructor(e) {
    super(), this.uri = e, this.id = "root", this.parent = void 0, this._groups = /* @__PURE__ */ new Map(), this.children = /* @__PURE__ */ new Map(), this.id = "root", this.parent = void 0;
  }
  _compact() {
    let e = 0;
    for (const [t, n] of this._groups)
      n.children.size === 0 ? this._groups.delete(t) : e += 1;
    if (e !== 1)
      this.children = this._groups;
    else {
      const t = Wt.first(this._groups.values());
      for (const [, n] of t.children)
        n.parent = this, this.children.set(n.id, n);
    }
    return this;
  }
  getTopLevelSymbols() {
    const e = [];
    for (const t of this.children.values())
      t instanceof jJ ? e.push(t.symbol) : e.push(...Wt.map(t.children.values(), (n) => n.symbol));
    return e.sort((t, n) => V.compareRangesUsingStarts(t.range, n.range));
  }
  asListOfDocumentSymbols() {
    const e = this.getTopLevelSymbols(), t = [];
    return jp._flattenDocumentSymbols(t, e, ""), t.sort((n, r) => ve.compare(V.getStartPosition(n.range), V.getStartPosition(r.range)) || ve.compare(V.getEndPosition(r.range), V.getEndPosition(n.range)));
  }
  static _flattenDocumentSymbols(e, t, n) {
    for (const r of t)
      e.push({
        kind: r.kind,
        tags: r.tags,
        name: r.name,
        detail: r.detail,
        containerName: r.containerName || n,
        range: r.range,
        selectionRange: r.selectionRange,
        children: void 0
        // we flatten it...
      }), r.children && jp._flattenDocumentSymbols(e, r.children, r.name);
  }
};
var vme = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, _me = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, _Ke = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let pV = class extends we {
  get isUpdatingViewZones() {
    return this._isUpdatingViewZones;
  }
  constructor(e, t, n, r) {
    super(), this._editors = e, this._diffModel = t, this._options = n, this._languageFeaturesService = r, this._isUpdatingViewZones = !1, this._modifiedOutlineSource = Cw(this, (c, d) => {
      const u = this._editors.modifiedModel.read(c);
      if (u)
        return d.add(new mV(this._languageFeaturesService, u));
    }), this._register(this._editors.original.onDidChangeCursorPosition((c) => {
      if (c.reason === 3) {
        const d = this._diffModel.get();
        di((u) => {
          for (const h of this._editors.original.getSelections() || [])
            d?.ensureOriginalLineIsVisible(h.getStartPosition().lineNumber, u), d?.ensureOriginalLineIsVisible(h.getEndPosition().lineNumber, u);
        });
      }
    })), this._register(this._editors.modified.onDidChangeCursorPosition((c) => {
      if (c.reason === 3) {
        const d = this._diffModel.get();
        di((u) => {
          for (const h of this._editors.modified.getSelections() || [])
            d?.ensureModifiedLineIsVisible(h.getStartPosition().lineNumber, u), d?.ensureModifiedLineIsVisible(h.getEndPosition().lineNumber, u);
        });
      }
    }));
    const s = this._diffModel.map((c, d) => {
      var u, h;
      return ((u = c?.diff.read(d)) === null || u === void 0 ? void 0 : u.mappings.length) === 0 ? [] : (h = c?.unchangedRegions.read(d)) !== null && h !== void 0 ? h : [];
    }), o = Cw(this, (c, d) => {
      const u = this._modifiedOutlineSource.read(c);
      if (!u)
        return { origViewZones: [], modViewZones: [] };
      const h = [], f = [], g = this._options.renderSideBySide.read(c), p = s.read(c);
      for (const m of p)
        if (!m.shouldHideControls(c)) {
          {
            const _ = nn((w) => (
              /** @description hiddenOriginalRangeStart */
              m.getHiddenOriginalRange(w).startLineNumber - 1
            )), b = new oI(_, 24);
            h.push(b), d.add(new zJ(this._editors.original, b, m, m.originalUnchangedRange, !g, u, (w) => this._diffModel.get().ensureModifiedLineIsVisible(w, void 0), this._options));
          }
          {
            const _ = nn((w) => (
              /** @description hiddenModifiedRangeStart */
              m.getHiddenModifiedRange(w).startLineNumber - 1
            )), b = new oI(_, 24);
            f.push(b), d.add(new zJ(this._editors.modified, b, m, m.modifiedUnchangedRange, !1, u, (w) => this._diffModel.get().ensureModifiedLineIsVisible(w, void 0), this._options));
          }
        }
      return { origViewZones: h, modViewZones: f };
    }), a = {
      description: "unchanged lines",
      className: "diff-unchanged-lines",
      isWholeLine: !0
    }, l = {
      description: "Fold Unchanged",
      glyphMarginHoverMessage: new ys(void 0, { isTrusted: !0, supportThemeIcons: !0 }).appendMarkdown(C("foldUnchanged", "Fold Unchanged Region")),
      glyphMarginClassName: "fold-unchanged " + ft.asClassName(We.fold),
      zIndex: 10001
    };
    this._register(sI(this._editors.original, nn((c) => {
      const d = s.read(c), u = d.map((h) => ({
        range: h.originalUnchangedRange.toInclusiveRange(),
        options: a
      }));
      for (const h of d)
        h.shouldHideControls(c) && u.push({
          range: V.fromPositions(new ve(h.originalLineNumber, 1)),
          options: l
        });
      return u;
    }))), this._register(sI(this._editors.modified, nn((c) => {
      const d = s.read(c), u = d.map((h) => ({
        range: h.modifiedUnchangedRange.toInclusiveRange(),
        options: a
      }));
      for (const h of d)
        h.shouldHideControls(c) && u.push({
          range: Qt.ofLength(h.modifiedLineNumber, 1).toInclusiveRange(),
          options: l
        });
      return u;
    }))), this._register(aI(this._editors.original, o.map((c) => c.origViewZones), (c) => this._isUpdatingViewZones = c)), this._register(aI(this._editors.modified, o.map((c) => c.modViewZones), (c) => this._isUpdatingViewZones = c)), this._register(zn((c) => {
      const d = s.read(c);
      this._editors.original.setHiddenAreas(d.map((u) => u.getHiddenOriginalRange(c).toInclusiveRange()).filter(by)), this._editors.modified.setHiddenAreas(d.map((u) => u.getHiddenModifiedRange(c).toInclusiveRange()).filter(by));
    })), this._register(this._editors.modified.onMouseUp((c) => {
      var d;
      if (!c.event.rightButton && c.target.position && (!((d = c.target.element) === null || d === void 0) && d.className.includes("fold-unchanged"))) {
        const u = c.target.position.lineNumber, h = this._diffModel.get();
        if (!h)
          return;
        const f = h.unchangedRegions.get().find((g) => g.modifiedUnchangedRange.includes(u));
        if (!f)
          return;
        f.collapseAll(void 0), c.event.stopPropagation(), c.event.preventDefault();
      }
    })), this._register(this._editors.original.onMouseUp((c) => {
      var d;
      if (!c.event.rightButton && c.target.position && (!((d = c.target.element) === null || d === void 0) && d.className.includes("fold-unchanged"))) {
        const u = c.target.position.lineNumber, h = this._diffModel.get();
        if (!h)
          return;
        const f = h.unchangedRegions.get().find((g) => g.originalUnchangedRange.includes(u));
        if (!f)
          return;
        f.collapseAll(void 0), c.event.stopPropagation(), c.event.preventDefault();
      }
    }));
  }
};
pV = vme([
  _me(3, tt)
], pV);
let mV = class extends we {
  constructor(e, t) {
    super(), this._languageFeaturesService = e, this._textModel = t, this._currentModel = Yn(this, void 0);
    const n = La("documentSymbolProvider.onDidChange", this._languageFeaturesService.documentSymbolProvider.onDidChange), r = La("_textModel.onDidChangeContent", qe.debounce((s) => this._textModel.onDidChangeContent(s), () => {
    }, 100));
    this._register(Yo((s, o) => _Ke(this, void 0, void 0, function* () {
      n.read(s), r.read(s);
      const a = o.add(new Qqe()), l = yield vKe.create(this._languageFeaturesService.documentSymbolProvider, this._textModel, a.token);
      o.isDisposed || this._currentModel.set(l, void 0);
    })));
  }
  getBreadcrumbItems(e, t) {
    const n = this._currentModel.read(t);
    if (!n)
      return [];
    const r = n.asListOfDocumentSymbols().filter((s) => e.contains(s.range.startLineNumber) && !e.contains(s.range.endLineNumber));
    return r.sort(Oue(hl((s) => s.range.endLineNumber - s.range.startLineNumber, Rh))), r.map((s) => ({ name: s.name, kind: s.kind, startLineNumber: s.range.startLineNumber }));
  }
};
mV = vme([
  _me(0, tt)
], mV);
class zJ extends pme {
  constructor(e, t, n, r, s, o, a, l) {
    const c = ts("div.diff-hidden-lines-widget");
    super(e, t, c.root), this._editor = e, this._unchangedRegion = n, this._unchangedRegionRange = r, this.hide = s, this._modifiedOutlineSource = o, this._revealModifiedHiddenLine = a, this._options = l, this._nodes = ts("div.diff-hidden-lines", [
      ts("div.top@top", { title: C("diff.hiddenLines.top", "Click or drag to show more above") }),
      ts("div.center@content", { style: { display: "flex" } }, [
        ts("div@first", { style: { display: "flex", justifyContent: "center", alignItems: "center", flexShrink: "0" } }, [Re("a", { title: C("showAll", "Show all"), role: "button", onclick: () => {
          this._unchangedRegion.showAll(void 0);
        } }, ...bg("$(unfold)"))]),
        ts("div@others", { style: { display: "flex", justifyContent: "center", alignItems: "center" } })
      ]),
      ts("div.bottom@bottom", { title: C("diff.bottom", "Click or drag to show more below"), role: "button" })
    ]), c.root.appendChild(this._nodes.root);
    const d = as(this._editor.onDidLayoutChange, () => this._editor.getLayoutInfo());
    this.hide ? cs(this._nodes.first) : this._register(wg(this._nodes.first, { width: d.map((h) => h.contentLeft) }));
    const u = this._editor;
    this._register(Ie(this._nodes.top, "mousedown", (h) => {
      if (h.button !== 0)
        return;
      this._nodes.top.classList.toggle("dragging", !0), this._nodes.root.classList.toggle("dragging", !0), h.preventDefault();
      const f = h.clientY;
      let g = !1;
      const p = this._unchangedRegion.visibleLineCountTop.get();
      this._unchangedRegion.isDragged.set(!0, void 0);
      const m = Ie(window, "mousemove", (b) => {
        const y = b.clientY - f;
        g = g || Math.abs(y) > 2;
        const S = Math.round(y / u.getOption(
          66
          /* EditorOption.lineHeight */
        )), x = Math.max(0, Math.min(p + S, this._unchangedRegion.getMaxVisibleLineCountTop()));
        this._unchangedRegion.visibleLineCountTop.set(x, void 0);
      }), _ = Ie(window, "mouseup", (b) => {
        g || this._unchangedRegion.showMoreAbove(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0), this._nodes.top.classList.toggle("dragging", !1), this._nodes.root.classList.toggle("dragging", !1), this._unchangedRegion.isDragged.set(!1, void 0), m.dispose(), _.dispose();
      });
    })), this._register(Ie(this._nodes.bottom, "mousedown", (h) => {
      if (h.button !== 0)
        return;
      this._nodes.bottom.classList.toggle("dragging", !0), this._nodes.root.classList.toggle("dragging", !0), h.preventDefault();
      const f = h.clientY;
      let g = !1;
      const p = this._unchangedRegion.visibleLineCountBottom.get();
      this._unchangedRegion.isDragged.set(!0, void 0);
      const m = Ie(window, "mousemove", (b) => {
        const y = b.clientY - f;
        g = g || Math.abs(y) > 2;
        const S = Math.round(y / u.getOption(
          66
          /* EditorOption.lineHeight */
        )), x = Math.max(0, Math.min(p - S, this._unchangedRegion.getMaxVisibleLineCountBottom())), D = u.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
        this._unchangedRegion.visibleLineCountBottom.set(x, void 0);
        const E = u.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
        u.setScrollTop(u.getScrollTop() + (E - D));
      }), _ = Ie(window, "mouseup", (b) => {
        if (this._unchangedRegion.isDragged.set(!1, void 0), !g) {
          const w = u.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
          this._unchangedRegion.showMoreBelow(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0);
          const y = u.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
          u.setScrollTop(u.getScrollTop() + (y - w));
        }
        this._nodes.bottom.classList.toggle("dragging", !1), this._nodes.root.classList.toggle("dragging", !1), m.dispose(), _.dispose();
      });
    })), this._register(zn((h) => {
      const f = [];
      if (!this.hide) {
        const g = n.getHiddenModifiedRange(h).length, p = C("hiddenLines", "{0} hidden lines", g), m = Re("span", { title: C("diff.hiddenLines.expandAll", "Double click to unfold") }, p);
        m.addEventListener("dblclick", (w) => {
          w.button === 0 && (w.preventDefault(), this._unchangedRegion.showAll(void 0));
        }), f.push(m);
        const _ = this._unchangedRegion.getHiddenModifiedRange(h), b = this._modifiedOutlineSource.getBreadcrumbItems(_, h);
        if (b.length > 0) {
          f.push(Re("span", void 0, "  |  "));
          for (let w = 0; w < b.length; w++) {
            const y = b[w], S = GE.toIcon(y.kind), x = ts("div.breadcrumb-item", {
              style: { display: "flex", alignItems: "center" }
            }, [
              bB(S),
              " ",
              y.name,
              ...w === b.length - 1 ? [] : [bB(We.chevronRight)]
            ]).root;
            f.push(x), x.onclick = () => {
              this._revealModifiedHiddenLine(y.startLineNumber);
            };
          }
        }
      }
      cs(this._nodes.others, ...f);
    }));
  }
}
class ud {
  static capture(e) {
    if (e.getScrollTop() === 0 || e.hasPendingScrollAnimation())
      return new ud(e.getScrollTop(), e.getContentHeight(), null, 0, null);
    let t = null, n = 0;
    const r = e.getVisibleRanges();
    if (r.length > 0) {
      t = r[0].getStartPosition();
      const s = e.getTopForPosition(t.lineNumber, t.column);
      n = e.getScrollTop() - s;
    }
    return new ud(e.getScrollTop(), e.getContentHeight(), t, n, e.getPosition());
  }
  constructor(e, t, n, r, s) {
    this._initialScrollTop = e, this._initialContentHeight = t, this._visiblePosition = n, this._visiblePositionScrollDelta = r, this._cursorPosition = s;
  }
  restore(e) {
    if (!(this._initialContentHeight === e.getContentHeight() && this._initialScrollTop === e.getScrollTop()) && this._visiblePosition) {
      const t = e.getTopForPosition(this._visiblePosition.lineNumber, this._visiblePosition.column);
      e.setScrollTop(t + this._visiblePositionScrollDelta);
    }
  }
  restoreRelativeVerticalPositionOfCursor(e) {
    if (this._initialContentHeight === e.getContentHeight() && this._initialScrollTop === e.getScrollTop())
      return;
    const t = e.getPosition();
    if (!this._cursorPosition || !t)
      return;
    const n = e.getTopForLineNumber(t.lineNumber) - e.getTopForLineNumber(this._cursorPosition.lineNumber);
    e.setScrollTop(e.getScrollTop() + n);
  }
}
var bKe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, UJ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, CKe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, zp;
let lI = zp = class {
  constructor(e, t, n) {
    this.editorWorkerService = t, this.telemetryService = n, this.onDidChangeEventEmitter = new pe(), this.onDidChange = this.onDidChangeEventEmitter.event, this.diffAlgorithm = "advanced", this.diffAlgorithmOnDidChangeSubscription = void 0, this.setOptions(e);
  }
  dispose() {
    var e;
    (e = this.diffAlgorithmOnDidChangeSubscription) === null || e === void 0 || e.dispose();
  }
  computeDiff(e, t, n, r) {
    var s, o;
    return CKe(this, void 0, void 0, function* () {
      if (typeof this.diffAlgorithm != "string")
        return this.diffAlgorithm.computeDiff(e, t, n, r);
      if (e.getLineCount() === 1 && e.getLineMaxColumn(1) === 1)
        return t.getLineCount() === 1 && t.getLineMaxColumn(1) === 1 ? {
          changes: [],
          identical: !0,
          quitEarly: !1,
          moves: []
        } : {
          changes: [
            new Sl(new Qt(1, 2), new Qt(1, t.getLineCount() + 1), [
              new Bg(e.getFullModelRange(), t.getFullModelRange())
            ])
          ],
          identical: !1,
          quitEarly: !1,
          moves: []
        };
      const a = JSON.stringify([e.uri.toString(), t.uri.toString()]), l = JSON.stringify([e.id, t.id, e.getAlternativeVersionId(), t.getAlternativeVersionId(), JSON.stringify(n)]), c = zp.diffCache.get(a);
      if (c && c.context === l)
        return c.result;
      const d = Vs.create(), u = yield this.editorWorkerService.computeDiff(e.uri, t.uri, n, this.diffAlgorithm), h = d.elapsed();
      if (this.telemetryService.publicLog2("diffEditor.computeDiff", {
        timeMs: h,
        timedOut: (s = u?.quitEarly) !== null && s !== void 0 ? s : !0,
        detectedMoves: n.computeMoves ? (o = u?.moves.length) !== null && o !== void 0 ? o : 0 : -1
      }), r.isCancellationRequested)
        return {
          changes: [],
          identical: !1,
          quitEarly: !0,
          moves: []
        };
      if (!u)
        throw new Error("no diff result available");
      return zp.diffCache.size > 10 && zp.diffCache.delete(zp.diffCache.keys().next().value), zp.diffCache.set(a, { result: u, context: l }), u;
    });
  }
  setOptions(e) {
    var t;
    let n = !1;
    e.diffAlgorithm && this.diffAlgorithm !== e.diffAlgorithm && ((t = this.diffAlgorithmOnDidChangeSubscription) === null || t === void 0 || t.dispose(), this.diffAlgorithmOnDidChangeSubscription = void 0, this.diffAlgorithm = e.diffAlgorithm, typeof e.diffAlgorithm != "string" && (this.diffAlgorithmOnDidChangeSubscription = e.diffAlgorithm.onDidChange(() => this.onDidChangeEventEmitter.fire())), n = !0), n && this.onDidChangeEventEmitter.fire();
  }
};
lI.diffCache = /* @__PURE__ */ new Map();
lI = zp = bKe([
  UJ(1, vc),
  UJ(2, qa)
], lI);
var yKe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, wKe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const bme = Gt("diffProviderFactoryService");
let vV = class {
  constructor(e) {
    this.instantiationService = e;
  }
  createDiffProvider(e, t) {
    return this.instantiationService.createInstance(lI, t);
  }
};
vV = yKe([
  wKe(0, bt)
], vV);
an(
  bme,
  vV,
  1
  /* InstantiationType.Delayed */
);
var SKe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, xKe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, GJ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let _V = class extends we {
  setActiveMovedText(e) {
    this._activeMovedText.set(e, void 0);
  }
  constructor(e, t, n, r) {
    super(), this.model = e, this._options = t, this._editor = n, this._diffProviderFactoryService = r, this._isDiffUpToDate = Yn(this, !1), this.isDiffUpToDate = this._isDiffUpToDate, this._diff = Yn(this, void 0), this.diff = this._diff, this._unchangedRegions = Yn(this, { regions: [], originalDecorationIds: [], modifiedDecorationIds: [] }), this.unchangedRegions = nn(this, (l) => this._options.hideUnchangedRegions.read(l) ? this._unchangedRegions.read(l).regions : (di((c) => {
      for (const d of this._unchangedRegions.get().regions)
        d.collapseAll(c);
    }), [])), this.movedTextToCompare = Yn(this, void 0), this._activeMovedText = Yn(this, void 0), this._hoveredMovedText = Yn(this, void 0), this.activeMovedText = nn(this, (l) => {
      var c, d;
      return (d = (c = this.movedTextToCompare.read(l)) !== null && c !== void 0 ? c : this._hoveredMovedText.read(l)) !== null && d !== void 0 ? d : this._activeMovedText.read(l);
    }), this._cancellationTokenSource = new lr(), this._diffProvider = nn(this, (l) => {
      const c = this._diffProviderFactoryService.createDiffProvider(this._editor, {
        diffAlgorithm: this._options.diffAlgorithm.read(l)
      }), d = La("onDidChange", c.onDidChange);
      return {
        diffProvider: c,
        onChangeSignal: d
      };
    }), this._register(Ct(() => this._cancellationTokenSource.cancel()));
    const s = fme("contentChangedSignal"), o = this._register(new Rn(() => s.trigger(void 0), 200)), a = (l, c, d) => {
      const u = cI.fromDiffs(l.changes, e.original.getLineCount(), e.modified.getLineCount(), this._options.hideUnchangedRegionsMinimumLineCount.read(d), this._options.hideUnchangedRegionsContextLineCount.read(d)), h = this._unchangedRegions.get(), f = h.originalDecorationIds.map((_) => e.original.getDecorationRange(_)).filter((_) => !!_).map((_) => Qt.fromRange(_)), g = h.modifiedDecorationIds.map((_) => e.modified.getDecorationRange(_)).filter((_) => !!_).map((_) => Qt.fromRange(_)), p = e.original.deltaDecorations(h.originalDecorationIds, u.map((_) => ({ range: _.originalUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } }))), m = e.modified.deltaDecorations(h.modifiedDecorationIds, u.map((_) => ({ range: _.modifiedUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } })));
      for (const _ of u)
        for (let b = 0; b < h.regions.length; b++)
          if (_.originalUnchangedRange.intersectsStrict(f[b]) && _.modifiedUnchangedRange.intersectsStrict(g[b])) {
            _.setHiddenModifiedRange(h.regions[b].getHiddenModifiedRange(void 0), c);
            break;
          }
      this._unchangedRegions.set({
        regions: u,
        originalDecorationIds: p,
        modifiedDecorationIds: m
      }, c);
    };
    this._register(e.modified.onDidChangeContent((l) => {
      if (this._diff.get()) {
        const d = Th.fromModelContentChanges(l.changes);
        this._lastDiff, e.original, e.modified;
      }
      o.schedule();
    })), this._register(e.original.onDidChangeContent((l) => {
      if (this._diff.get()) {
        const d = Th.fromModelContentChanges(l.changes);
        this._lastDiff, e.original, e.modified;
      }
      o.schedule();
    })), this._register(Yo((l, c) => GJ(this, void 0, void 0, function* () {
      var d, u;
      this._options.hideUnchangedRegionsMinimumLineCount.read(l), this._options.hideUnchangedRegionsContextLineCount.read(l), o.cancel(), s.read(l);
      const h = this._diffProvider.read(l);
      h.onChangeSignal.read(l), Rf(mfe, l), Rf(CF, l), this._isDiffUpToDate.set(!1, void 0);
      let f = [];
      c.add(e.original.onDidChangeContent((m) => {
        const _ = Th.fromModelContentChanges(m.changes);
        f = yL(f, _);
      }));
      let g = [];
      c.add(e.modified.onDidChangeContent((m) => {
        const _ = Th.fromModelContentChanges(m.changes);
        g = yL(g, _);
      }));
      let p = yield h.diffProvider.computeDiff(e.original, e.modified, {
        ignoreTrimWhitespace: this._options.ignoreTrimWhitespace.read(l),
        maxComputationTimeMs: this._options.maxComputationTimeMs.read(l),
        computeMoves: this._options.showMoves.read(l)
      }, this._cancellationTokenSource.token);
      this._cancellationTokenSource.token.isCancellationRequested || (p = DKe(p, e.original, e.modified), p = (d = (e.original, e.modified, void 0)) !== null && d !== void 0 ? d : p, p = (u = (e.original, e.modified, void 0)) !== null && u !== void 0 ? u : p, di((m) => {
        a(p, m), this._lastDiff = p;
        const _ = FU.fromDiffResult(p);
        this._diff.set(_, m), this._isDiffUpToDate.set(!0, m);
        const b = this.movedTextToCompare.get();
        this.movedTextToCompare.set(b ? this._lastDiff.moves.find((w) => w.lineRangeMapping.modified.intersect(b.lineRangeMapping.modified)) : void 0, m);
      }));
    })));
  }
  ensureModifiedLineIsVisible(e, t) {
    var n;
    if (((n = this.diff.get()) === null || n === void 0 ? void 0 : n.mappings.length) === 0)
      return;
    const r = this._unchangedRegions.get().regions;
    for (const s of r)
      if (s.getHiddenModifiedRange(void 0).contains(e)) {
        s.showModifiedLine(e, t);
        return;
      }
  }
  ensureOriginalLineIsVisible(e, t) {
    var n;
    if (((n = this.diff.get()) === null || n === void 0 ? void 0 : n.mappings.length) === 0)
      return;
    const r = this._unchangedRegions.get().regions;
    for (const s of r)
      if (s.getHiddenOriginalRange(void 0).contains(e)) {
        s.showOriginalLine(e, t);
        return;
      }
  }
  waitForDiff() {
    return GJ(this, void 0, void 0, function* () {
      yield jqe(this.isDiffUpToDate, (e) => e);
    });
  }
  serializeState() {
    return {
      collapsedRegions: this._unchangedRegions.get().regions.map((t) => ({ range: t.getHiddenModifiedRange(void 0).serialize() }))
    };
  }
  restoreSerializedState(e) {
    const t = e.collapsedRegions.map((r) => Qt.deserialize(r.range)), n = this._unchangedRegions.get();
    di((r) => {
      for (const s of n.regions)
        for (const o of t)
          if (s.modifiedUnchangedRange.intersect(o)) {
            s.setHiddenModifiedRange(o, r);
            break;
          }
    });
  }
};
_V = SKe([
  xKe(3, bme)
], _V);
function DKe(i, e, t) {
  return {
    changes: i.changes.map((n) => new Sl(n.original, n.modified, n.innerChanges ? n.innerChanges.map((r) => EKe(r, e, t)) : void 0)),
    moves: i.moves,
    identical: i.identical,
    quitEarly: i.quitEarly
  };
}
function EKe(i, e, t) {
  let n = i.originalRange, r = i.modifiedRange;
  return (n.endColumn !== 1 || r.endColumn !== 1) && n.endColumn === e.getLineMaxColumn(n.endLineNumber) && r.endColumn === t.getLineMaxColumn(r.endLineNumber) && n.endLineNumber < e.getLineCount() && r.endLineNumber < t.getLineCount() && (n = n.setEndPosition(n.endLineNumber + 1, 1), r = r.setEndPosition(r.endLineNumber + 1, 1)), new Bg(n, r);
}
class FU {
  static fromDiffResult(e) {
    return new FU(e.changes.map((t) => new Cme(t)), e.moves || [], e.identical, e.quitEarly);
  }
  constructor(e, t, n, r) {
    this.mappings = e, this.movedTexts = t, this.identical = n, this.quitEarly = r;
  }
}
class Cme {
  constructor(e) {
    this.lineRangeMapping = e;
  }
}
class cI {
  static fromDiffs(e, t, n, r, s) {
    const o = Sl.inverse(e, t, n), a = [];
    for (const l of o) {
      let c = l.original.startLineNumber, d = l.modified.startLineNumber, u = l.original.length;
      const h = c === 1 && d === 1, f = c + u === t + 1 && d + u === n + 1;
      (h || f) && u >= s + r ? (h && !f && (u -= s), f && !h && (c += s, d += s, u -= s), a.push(new cI(c, d, u, 0, 0))) : u >= s * 2 + r && (c += s, d += s, u -= s * 2, a.push(new cI(c, d, u, 0, 0)));
    }
    return a;
  }
  get originalUnchangedRange() {
    return Qt.ofLength(this.originalLineNumber, this.lineCount);
  }
  get modifiedUnchangedRange() {
    return Qt.ofLength(this.modifiedLineNumber, this.lineCount);
  }
  constructor(e, t, n, r, s) {
    this.originalLineNumber = e, this.modifiedLineNumber = t, this.lineCount = n, this._visibleLineCountTop = Yn(this, 0), this.visibleLineCountTop = this._visibleLineCountTop, this._visibleLineCountBottom = Yn(this, 0), this.visibleLineCountBottom = this._visibleLineCountBottom, this._shouldHideControls = nn(this, (o) => (
      /** @description isVisible */
      this.visibleLineCountTop.read(o) + this.visibleLineCountBottom.read(o) === this.lineCount && !this.isDragged.read(o)
    )), this.isDragged = Yn(this, !1), this._visibleLineCountTop.set(r, void 0), this._visibleLineCountBottom.set(s, void 0);
  }
  shouldHideControls(e) {
    return this._shouldHideControls.read(e);
  }
  getHiddenOriginalRange(e) {
    return Qt.ofLength(this.originalLineNumber + this._visibleLineCountTop.read(e), this.lineCount - this._visibleLineCountTop.read(e) - this._visibleLineCountBottom.read(e));
  }
  getHiddenModifiedRange(e) {
    return Qt.ofLength(this.modifiedLineNumber + this._visibleLineCountTop.read(e), this.lineCount - this._visibleLineCountTop.read(e) - this._visibleLineCountBottom.read(e));
  }
  setHiddenModifiedRange(e, t) {
    const n = e.startLineNumber - this.modifiedLineNumber, r = this.modifiedLineNumber + this.lineCount - e.endLineNumberExclusive;
    this.setState(n, r, t);
  }
  getMaxVisibleLineCountTop() {
    return this.lineCount - this._visibleLineCountBottom.get();
  }
  getMaxVisibleLineCountBottom() {
    return this.lineCount - this._visibleLineCountTop.get();
  }
  showMoreAbove(e = 10, t) {
    const n = this.getMaxVisibleLineCountTop();
    this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + e, n), t);
  }
  showMoreBelow(e = 10, t) {
    const n = this.lineCount - this._visibleLineCountTop.get();
    this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + e, n), t);
  }
  showAll(e) {
    this._visibleLineCountBottom.set(this.lineCount - this._visibleLineCountTop.get(), e);
  }
  showModifiedLine(e, t) {
    const n = e + 1 - (this.modifiedLineNumber + this._visibleLineCountTop.get()), r = this.modifiedLineNumber - this._visibleLineCountBottom.get() + this.lineCount - e;
    n < r ? this._visibleLineCountTop.set(this._visibleLineCountTop.get() + n, t) : this._visibleLineCountBottom.set(this._visibleLineCountBottom.get() + r, t);
  }
  showOriginalLine(e, t) {
    const n = e - this.originalLineNumber, r = this.originalLineNumber + this.lineCount - e;
    n < r ? this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + r - n, this.getMaxVisibleLineCountTop()), t) : this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + n - r, this.getMaxVisibleLineCountBottom()), t);
  }
  collapseAll(e) {
    this._visibleLineCountTop.set(0, e), this._visibleLineCountBottom.set(0, e);
  }
  setState(e, t, n) {
    e = Math.max(Math.min(e, this.lineCount), 0), t = Math.max(Math.min(t, this.lineCount - e), 0), this._visibleLineCountTop.set(e, n), this._visibleLineCountBottom.set(t, n);
  }
}
var _T = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class LKe extends we {
  get visibility() {
    return this._visibility;
  }
  set visibility(e) {
    this._visibility !== e && (this._visibility = e, this._diffActions.style.visibility = e ? "visible" : "hidden");
  }
  constructor(e, t, n, r, s, o, a, l, c) {
    super(), this._getViewZoneId = e, this._marginDomNode = t, this._modifiedEditor = n, this._diff = r, this._editor = s, this._viewLineCounts = o, this._originalTextModel = a, this._contextMenuService = l, this._clipboardService = c, this._visibility = !1, this._marginDomNode.style.zIndex = "10", this._diffActions = document.createElement("div"), this._diffActions.className = ft.asClassName(We.lightBulb) + " lightbulb-glyph", this._diffActions.style.position = "absolute";
    const d = this._modifiedEditor.getOption(
      66
      /* EditorOption.lineHeight */
    );
    this._diffActions.style.right = "0px", this._diffActions.style.visibility = "hidden", this._diffActions.style.height = `${d}px`, this._diffActions.style.lineHeight = `${d}px`, this._marginDomNode.appendChild(this._diffActions);
    let u = 0;
    const h = n.getOption(
      126
      /* EditorOption.useShadowDOM */
    ) && !od, f = (g, p) => {
      var m;
      this._contextMenuService.showContextMenu({
        domForShadowRoot: h && (m = n.getDomNode()) !== null && m !== void 0 ? m : void 0,
        getAnchor: () => ({ x: g, y: p }),
        getActions: () => {
          const _ = [], b = r.modified.isEmpty;
          return _.push(new vo("diff.clipboard.copyDeletedContent", b ? r.original.length > 1 ? C("diff.clipboard.copyDeletedLinesContent.label", "Copy deleted lines") : C("diff.clipboard.copyDeletedLinesContent.single.label", "Copy deleted line") : r.original.length > 1 ? C("diff.clipboard.copyChangedLinesContent.label", "Copy changed lines") : C("diff.clipboard.copyChangedLinesContent.single.label", "Copy changed line"), void 0, !0, () => _T(this, void 0, void 0, function* () {
            const y = this._originalTextModel.getValueInRange(r.original.toExclusiveRange());
            yield this._clipboardService.writeText(y);
          }))), r.original.length > 1 && _.push(new vo("diff.clipboard.copyDeletedLineContent", b ? C("diff.clipboard.copyDeletedLineContent.label", "Copy deleted line ({0})", r.original.startLineNumber + u) : C("diff.clipboard.copyChangedLineContent.label", "Copy changed line ({0})", r.original.startLineNumber + u), void 0, !0, () => _T(this, void 0, void 0, function* () {
            let y = this._originalTextModel.getLineContent(r.original.startLineNumber + u);
            y === "" && (y = this._originalTextModel.getEndOfLineSequence() === 0 ? `
` : `\r
`), yield this._clipboardService.writeText(y);
          }))), n.getOption(
            90
            /* EditorOption.readOnly */
          ) || _.push(new vo("diff.inline.revertChange", C("diff.inline.revertChange.label", "Revert this change"), void 0, !0, () => _T(this, void 0, void 0, function* () {
            this._editor.revert(this._diff);
          }))), _;
        },
        autoSelectFirstItem: !0
      });
    };
    this._register(ar(this._diffActions, "mousedown", (g) => {
      const { top: p, height: m } = wr(this._diffActions), _ = Math.floor(d / 3);
      g.preventDefault(), f(g.posx, p + m + _);
    })), this._register(n.onMouseMove((g) => {
      (g.target.type === 8 || g.target.type === 5) && g.target.detail.viewZoneId === this._getViewZoneId() ? (u = this._updateLightBulbPosition(this._marginDomNode, g.event.browserEvent.y, d), this.visibility = !0) : this.visibility = !1;
    })), this._register(n.onMouseDown((g) => {
      g.event.rightButton && (g.target.type === 8 || g.target.type === 5) && g.target.detail.viewZoneId === this._getViewZoneId() && (g.event.preventDefault(), u = this._updateLightBulbPosition(this._marginDomNode, g.event.browserEvent.y, d), f(g.event.posx, g.event.posy + d));
    }));
  }
  _updateLightBulbPosition(e, t, n) {
    const { top: r } = wr(e), s = t - r, o = Math.floor(s / n), a = o * n;
    if (this._diffActions.style.top = `${a}px`, this._viewLineCounts) {
      let l = 0;
      for (let c = 0; c < this._viewLineCounts.length; c++)
        if (l += this._viewLineCounts[c], o < l)
          return c;
    }
    return o;
  }
}
const qJ = af("diffEditorWidget", { createHTML: (i) => i });
function IKe(i, e, t, n) {
  Ds(n, e.fontInfo);
  const r = t.length > 0, s = new pb(1e4);
  let o = 0, a = 0;
  const l = [];
  for (let h = 0; h < i.lineTokens.length; h++) {
    const f = h + 1, g = i.lineTokens[h], p = i.lineBreakData[h], m = ea.filter(t, f, 1, Number.MAX_SAFE_INTEGER);
    if (p) {
      let _ = 0;
      for (const b of p.breakOffsets) {
        const w = g.sliceAndInflate(_, b, 0);
        o = Math.max(o, KJ(a, w, ea.extractWrapped(m, _, b), r, i.mightContainNonBasicASCII, i.mightContainRTL, e, s)), a++, _ = b;
      }
      l.push(p.breakOffsets.length);
    } else
      l.push(1), o = Math.max(o, KJ(a, g, m, r, i.mightContainNonBasicASCII, i.mightContainRTL, e, s)), a++;
  }
  o += e.scrollBeyondLastColumn;
  const c = s.build(), d = qJ ? qJ.createHTML(c) : c;
  n.innerHTML = d;
  const u = o * e.typicalHalfwidthCharacterWidth;
  return {
    heightInLines: a,
    minWidthInPx: u,
    viewLineCounts: l
  };
}
class AKe {
  constructor(e, t, n, r) {
    this.lineTokens = e, this.lineBreakData = t, this.mightContainNonBasicASCII = n, this.mightContainRTL = r;
  }
}
class BU {
  static fromEditor(e) {
    var t;
    const n = e.getOptions(), r = n.get(
      50
      /* EditorOption.fontInfo */
    ), s = n.get(
      143
      /* EditorOption.layoutInfo */
    );
    return new BU(((t = e.getModel()) === null || t === void 0 ? void 0 : t.getOptions().tabSize) || 0, r, n.get(
      33
      /* EditorOption.disableMonospaceOptimizations */
    ), r.typicalHalfwidthCharacterWidth, n.get(
      103
      /* EditorOption.scrollBeyondLastColumn */
    ), n.get(
      66
      /* EditorOption.lineHeight */
    ), s.decorationsWidth, n.get(
      116
      /* EditorOption.stopRenderingLineAfter */
    ), n.get(
      98
      /* EditorOption.renderWhitespace */
    ), n.get(
      93
      /* EditorOption.renderControlCharacters */
    ), n.get(
      51
      /* EditorOption.fontLigatures */
    ));
  }
  constructor(e, t, n, r, s, o, a, l, c, d, u) {
    this.tabSize = e, this.fontInfo = t, this.disableMonospaceOptimizations = n, this.typicalHalfwidthCharacterWidth = r, this.scrollBeyondLastColumn = s, this.lineHeight = o, this.lineDecorationsWidth = a, this.stopRenderingLineAfter = l, this.renderWhitespace = c, this.renderControlCharacters = d, this.fontLigatures = u;
  }
}
function KJ(i, e, t, n, r, s, o, a) {
  a.appendString('<div class="view-line'), n || a.appendString(" char-delete"), a.appendString('" style="top:'), a.appendString(String(i * o.lineHeight)), a.appendString('px;width:1000000px;">');
  const l = e.getLineContent(), c = Wa.isBasicASCII(l, r), d = Wa.containsRTL(l, c, s), u = ES(new dp(
    o.fontInfo.isMonospace && !o.disableMonospaceOptimizations,
    o.fontInfo.canUseHalfwidthRightwardsArrow,
    l,
    !1,
    c,
    d,
    0,
    e,
    t,
    o.tabSize,
    0,
    o.fontInfo.spaceWidth,
    o.fontInfo.middotWidth,
    o.fontInfo.wsmiddotWidth,
    o.stopRenderingLineAfter,
    o.renderWhitespace,
    o.renderControlCharacters,
    o.fontLigatures !== Da.OFF,
    null
    // Send no selections, original line cannot be selected
  ), a);
  return a.appendString("</div>"), u.characterMapping.getHorizontalOffset(u.characterMapping.length);
}
var kKe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, YJ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let bV = class extends we {
  constructor(e, t, n, r, s, o, a) {
    super(), this._editors = e, this._diffModel = t, this._options = n, this._diffEditorWidget = r, this._canIgnoreViewZoneUpdateEvent = s, this._clipboardService = o, this._contextMenuService = a, this._originalTopPadding = Yn(this, 0), this._originalScrollOffset = Yn(this, 0), this._originalScrollOffsetAnimated = MJ(this._originalScrollOffset, this._store), this._modifiedTopPadding = Yn(this, 0), this._modifiedScrollOffset = Yn(this, 0), this._modifiedScrollOffsetAnimated = MJ(this._modifiedScrollOffset, this._store);
    let l = !1;
    const c = Yn("state", 0), d = this._register(new Rn(() => {
      c.set(c.get() + 1, void 0);
    }, 0));
    this._register(this._editors.original.onDidChangeViewZones((y) => {
      !l && !this._canIgnoreViewZoneUpdateEvent() && d.schedule();
    })), this._register(this._editors.modified.onDidChangeViewZones((y) => {
      !l && !this._canIgnoreViewZoneUpdateEvent() && d.schedule();
    })), this._register(this._editors.original.onDidChangeConfiguration((y) => {
      (y.hasChanged(
        144
        /* EditorOption.wrappingInfo */
      ) || y.hasChanged(
        66
        /* EditorOption.lineHeight */
      )) && d.schedule();
    })), this._register(this._editors.modified.onDidChangeConfiguration((y) => {
      (y.hasChanged(
        144
        /* EditorOption.wrappingInfo */
      ) || y.hasChanged(
        66
        /* EditorOption.lineHeight */
      )) && d.schedule();
    }));
    const u = this._diffModel.map((y) => y ? as(
      y.model.original.onDidChangeTokens,
      () => y.model.original.tokenization.backgroundTokenizationState === 2
      /* BackgroundTokenizationState.Completed */
    ) : void 0).map((y, S) => y?.read(S)), h = /* @__PURE__ */ new Set(), f = /* @__PURE__ */ new Set(), g = nn((y) => {
      const S = this._diffModel.read(y), x = S?.diff.read(y);
      if (!S || !x)
        return null;
      c.read(y);
      const E = this._options.renderSideBySide.read(y);
      return XJ(this._editors.original, this._editors.modified, x.mappings, h, f, E);
    }), p = nn((y) => {
      var S;
      const x = (S = this._diffModel.read(y)) === null || S === void 0 ? void 0 : S.movedTextToCompare.read(y);
      if (!x)
        return null;
      c.read(y);
      const D = x.changes.map((E) => new Cme(E));
      return XJ(this._editors.original, this._editors.modified, D, h, f, !0);
    });
    function m() {
      const y = document.createElement("div");
      return y.className = "diagonal-fill", y;
    }
    const _ = this._register(new Ne()), b = nn((y) => {
      var S, x, D, E, L, k, N, I;
      _.clear();
      const A = g.read(y) || [], P = [], O = [], K = this._modifiedTopPadding.read(y);
      K > 0 && O.push({
        afterLineNumber: 0,
        domNode: document.createElement("div"),
        heightInPx: K,
        showInHiddenAreas: !0,
        suppressMouseDown: !0
      });
      const W = this._originalTopPadding.read(y);
      W > 0 && P.push({
        afterLineNumber: 0,
        domNode: document.createElement("div"),
        heightInPx: W,
        showInHiddenAreas: !0,
        suppressMouseDown: !0
      });
      const F = this._options.renderSideBySide.read(y), q = F || (S = this._editors.modified._getViewModel()) === null || S === void 0 ? void 0 : S.createLineBreaksComputer();
      if (q) {
        for (const le of A)
          if (le.diff)
            for (let oe = le.originalRange.startLineNumber; oe < le.originalRange.endLineNumberExclusive; oe++)
              q?.addRequest(this._editors.original.getModel().getLineContent(oe), null, null);
      }
      const R = (x = q?.finalize()) !== null && x !== void 0 ? x : [];
      let T = 0;
      const z = this._editors.modified.getOption(
        66
        /* EditorOption.lineHeight */
      ), X = (D = this._diffModel.read(y)) === null || D === void 0 ? void 0 : D.movedTextToCompare.read(y), ae = (L = (E = this._editors.original.getModel()) === null || E === void 0 ? void 0 : E.mightContainNonBasicASCII()) !== null && L !== void 0 ? L : !1, ue = (N = (k = this._editors.original.getModel()) === null || k === void 0 ? void 0 : k.mightContainRTL()) !== null && N !== void 0 ? N : !1, se = BU.fromEditor(this._editors.modified);
      for (const le of A)
        if (le.diff && !F) {
          if (!le.originalRange.isEmpty) {
            u.read(y);
            const re = document.createElement("div");
            re.classList.add("view-lines", "line-delete", "monaco-mouse-cursor-text");
            const B = new AKe(le.originalRange.mapToLineArray((ge) => this._editors.original.getModel().tokenization.getLineTokens(ge)), le.originalRange.mapToLineArray((ge) => R[T++]), ae, ue), ee = [];
            for (const ge of le.diff.innerChanges || [])
              ee.push(new SC(
                ge.originalRange.delta(-(le.diff.original.startLineNumber - 1)),
                gV.className,
                0
                /* InlineDecorationType.Regular */
              ));
            const j = IKe(B, se, ee, re), he = document.createElement("div");
            if (he.className = "inline-deleted-margin-view-zone", Ds(he, se.fontInfo), this._options.renderIndicators.read(y))
              for (let ge = 0; ge < j.heightInLines; ge++) {
                const te = document.createElement("div");
                te.className = `delete-sign ${ft.asClassName(mme)}`, te.setAttribute("style", `position:absolute;top:${ge * z}px;width:${se.lineDecorationsWidth}px;height:${z}px;right:0;`), he.appendChild(te);
              }
            let Se;
            _.add(new LKe(() => am(Se), he, this._editors.modified, le.diff, this._diffEditorWidget, j.viewLineCounts, this._editors.original.getModel(), this._contextMenuService, this._clipboardService));
            for (let ge = 0; ge < j.viewLineCounts.length; ge++) {
              const te = j.viewLineCounts[ge];
              te > 1 && P.push({
                afterLineNumber: le.originalRange.startLineNumber + ge,
                domNode: m(),
                heightInPx: (te - 1) * z,
                showInHiddenAreas: !0,
                suppressMouseDown: !0
              });
            }
            O.push({
              afterLineNumber: le.modifiedRange.startLineNumber - 1,
              domNode: re,
              heightInPx: j.heightInLines * z,
              minWidthInPx: j.minWidthInPx,
              marginDomNode: he,
              setZoneId(ge) {
                Se = ge;
              },
              showInHiddenAreas: !0,
              suppressMouseDown: !0
            });
          }
          const oe = document.createElement("div");
          oe.className = "gutter-delete", P.push({
            afterLineNumber: le.originalRange.endLineNumberExclusive - 1,
            domNode: m(),
            heightInPx: le.modifiedHeightInPx,
            marginDomNode: oe,
            showInHiddenAreas: !0,
            suppressMouseDown: !0
          });
        } else {
          const oe = le.modifiedHeightInPx - le.originalHeightInPx;
          if (oe > 0) {
            if (X?.lineRangeMapping.original.delta(-1).deltaLength(2).contains(le.originalRange.endLineNumberExclusive - 1))
              continue;
            P.push({
              afterLineNumber: le.originalRange.endLineNumberExclusive - 1,
              domNode: m(),
              heightInPx: oe,
              showInHiddenAreas: !0,
              suppressMouseDown: !0
            });
          } else {
            let re = function() {
              const ee = document.createElement("div");
              return ee.className = "arrow-revert-change " + ft.asClassName(We.arrowRight), Re("div", {}, ee);
            };
            if (X?.lineRangeMapping.modified.delta(-1).deltaLength(2).contains(le.modifiedRange.endLineNumberExclusive - 1))
              continue;
            let B;
            le.diff && le.diff.modified.isEmpty && this._options.shouldRenderRevertArrows.read(y) && (B = re()), O.push({
              afterLineNumber: le.modifiedRange.endLineNumberExclusive - 1,
              domNode: m(),
              heightInPx: -oe,
              marginDomNode: B,
              showInHiddenAreas: !0,
              suppressMouseDown: !0
            });
          }
        }
      for (const le of (I = p.read(y)) !== null && I !== void 0 ? I : []) {
        if (!X?.lineRangeMapping.original.intersect(le.originalRange) || !X?.lineRangeMapping.modified.intersect(le.modifiedRange))
          continue;
        const oe = le.modifiedHeightInPx - le.originalHeightInPx;
        oe > 0 ? P.push({
          afterLineNumber: le.originalRange.endLineNumberExclusive - 1,
          domNode: m(),
          heightInPx: oe,
          showInHiddenAreas: !0,
          suppressMouseDown: !0
        }) : O.push({
          afterLineNumber: le.modifiedRange.endLineNumberExclusive - 1,
          domNode: m(),
          heightInPx: -oe,
          showInHiddenAreas: !0,
          suppressMouseDown: !0
        });
      }
      return { orig: P, mod: O };
    });
    this._register(Yo((y) => {
      const S = ud.capture(this._editors.modified), x = b.read(y);
      l = !0, this._editors.original.changeViewZones((D) => {
        for (const E of h)
          D.removeZone(E);
        h.clear();
        for (const E of x.orig) {
          const L = D.addZone(E);
          E.setZoneId && E.setZoneId(L), h.add(L);
        }
      }), this._editors.modified.changeViewZones((D) => {
        for (const E of f)
          D.removeZone(E);
        f.clear();
        for (const E of x.mod) {
          const L = D.addZone(E);
          E.setZoneId && E.setZoneId(L), f.add(L);
        }
      }), l = !1, S.restore(this._editors.modified);
    })), this._register(Ct(() => {
      this._editors.original.changeViewZones((y) => {
        for (const S of h)
          y.removeZone(S);
        h.clear();
      }), this._editors.modified.changeViewZones((y) => {
        for (const S of f)
          y.removeZone(S);
        f.clear();
      });
    }));
    let w = !1;
    this._register(this._editors.original.onDidScrollChange((y) => {
      y.scrollLeftChanged && !w && (w = !0, this._editors.modified.setScrollLeft(y.scrollLeft), w = !1);
    })), this._register(this._editors.modified.onDidScrollChange((y) => {
      y.scrollLeftChanged && !w && (w = !0, this._editors.original.setScrollLeft(y.scrollLeft), w = !1);
    })), this._originalScrollTop = as(this._editors.original.onDidScrollChange, () => this._editors.original.getScrollTop()), this._modifiedScrollTop = as(this._editors.modified.onDidScrollChange, () => this._editors.modified.getScrollTop()), this._register(zn((y) => {
      const S = this._originalScrollTop.read(y) - (this._originalScrollOffsetAnimated.get() - this._modifiedScrollOffsetAnimated.read(y)) - (this._originalTopPadding.get() - this._modifiedTopPadding.read(y));
      S !== this._editors.modified.getScrollTop() && this._editors.modified.setScrollTop(
        S,
        1
        /* ScrollType.Immediate */
      );
    })), this._register(zn((y) => {
      const S = this._modifiedScrollTop.read(y) - (this._modifiedScrollOffsetAnimated.get() - this._originalScrollOffsetAnimated.read(y)) - (this._modifiedTopPadding.get() - this._originalTopPadding.read(y));
      S !== this._editors.original.getScrollTop() && this._editors.original.setScrollTop(
        S,
        1
        /* ScrollType.Immediate */
      );
    })), this._register(zn((y) => {
      var S;
      const x = (S = this._diffModel.read(y)) === null || S === void 0 ? void 0 : S.movedTextToCompare.read(y);
      let D = 0;
      if (x) {
        const E = this._editors.original.getTopForLineNumber(x.lineRangeMapping.original.startLineNumber, !0) - this._originalTopPadding.get();
        D = this._editors.modified.getTopForLineNumber(x.lineRangeMapping.modified.startLineNumber, !0) - this._modifiedTopPadding.get() - E;
      }
      D > 0 ? (this._modifiedTopPadding.set(0, void 0), this._originalTopPadding.set(D, void 0)) : D < 0 ? (this._modifiedTopPadding.set(-D, void 0), this._originalTopPadding.set(0, void 0)) : setTimeout(() => {
        this._modifiedTopPadding.set(0, void 0), this._originalTopPadding.set(0, void 0);
      }, 400), this._editors.modified.hasTextFocus() ? this._originalScrollOffset.set(this._modifiedScrollOffset.get() - D, void 0, !0) : this._modifiedScrollOffset.set(this._originalScrollOffset.get() + D, void 0, !0);
    }));
  }
};
bV = kKe([
  YJ(5, hf),
  YJ(6, gc)
], bV);
function XJ(i, e, t, n, r, s) {
  const o = new Xh(ZJ(i, n)), a = new Xh(ZJ(e, r)), l = i.getOption(
    66
    /* EditorOption.lineHeight */
  ), c = e.getOption(
    66
    /* EditorOption.lineHeight */
  ), d = [];
  let u = 0, h = 0;
  function f(g, p) {
    for (; ; ) {
      let m = o.peek(), _ = a.peek();
      if (m && m.lineNumber >= g && (m = void 0), _ && _.lineNumber >= p && (_ = void 0), !m && !_)
        break;
      const b = m ? m.lineNumber - u : Number.MAX_VALUE, w = _ ? _.lineNumber - h : Number.MAX_VALUE;
      b < w ? (o.dequeue(), _ = {
        lineNumber: m.lineNumber - u + h,
        heightInPx: 0
      }) : b > w ? (a.dequeue(), m = {
        lineNumber: _.lineNumber - h + u,
        heightInPx: 0
      }) : (o.dequeue(), a.dequeue()), d.push({
        originalRange: Qt.ofLength(m.lineNumber, 1),
        modifiedRange: Qt.ofLength(_.lineNumber, 1),
        originalHeightInPx: l + m.heightInPx,
        modifiedHeightInPx: c + _.heightInPx,
        diff: void 0
      });
    }
  }
  for (const g of t) {
    let w = function(y, S) {
      var x, D, E, L;
      if (y < b || S < _)
        return;
      if (m)
        m = !1;
      else if (y === b || S === _)
        return;
      const k = new Qt(b, y), N = new Qt(_, S);
      if (k.isEmpty && N.isEmpty)
        return;
      const I = (D = (x = o.takeWhile((P) => P.lineNumber < y)) === null || x === void 0 ? void 0 : x.reduce((P, O) => P + O.heightInPx, 0)) !== null && D !== void 0 ? D : 0, A = (L = (E = a.takeWhile((P) => P.lineNumber < S)) === null || E === void 0 ? void 0 : E.reduce((P, O) => P + O.heightInPx, 0)) !== null && L !== void 0 ? L : 0;
      d.push({
        originalRange: k,
        modifiedRange: N,
        originalHeightInPx: k.length * l + I,
        modifiedHeightInPx: N.length * c + A,
        diff: g.lineRangeMapping
      }), b = y, _ = S;
    };
    const p = g.lineRangeMapping;
    f(p.original.startLineNumber, p.modified.startLineNumber);
    let m = !0, _ = p.modified.startLineNumber, b = p.original.startLineNumber;
    if (s)
      for (const y of p.innerChanges || [])
        y.originalRange.startColumn > 1 && y.modifiedRange.startColumn > 1 && w(y.originalRange.startLineNumber, y.modifiedRange.startLineNumber), y.originalRange.endColumn < i.getModel().getLineMaxColumn(y.originalRange.endLineNumber) && w(y.originalRange.endLineNumber, y.modifiedRange.endLineNumber);
    w(p.original.endLineNumberExclusive, p.modified.endLineNumberExclusive), u = p.original.endLineNumberExclusive, h = p.modified.endLineNumberExclusive;
  }
  return f(Number.MAX_VALUE, Number.MAX_VALUE), d;
}
function ZJ(i, e) {
  const t = [], n = [], r = i.getOption(
    144
    /* EditorOption.wrappingInfo */
  ).wrappingColumn !== -1, s = i._getViewModel().coordinatesConverter, o = i.getOption(
    66
    /* EditorOption.lineHeight */
  );
  if (r)
    for (let l = 1; l <= i.getModel().getLineCount(); l++) {
      const c = s.getModelLineViewLineCount(l);
      c > 1 && n.push({ lineNumber: l, heightInPx: o * (c - 1) });
    }
  for (const l of i.getWhitespaces()) {
    if (e.has(l.id))
      continue;
    const c = l.afterLineNumber === 0 ? 0 : s.convertViewPositionToModelPosition(new ve(l.afterLineNumber, 1)).lineNumber;
    t.push({ lineNumber: c, heightInPx: l.height });
  }
  return Kqe(t, n, (l) => l.lineNumber, (l, c) => ({ lineNumber: l.lineNumber, heightInPx: l.heightInPx + c.heightInPx }));
}
var TKe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, NKe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Lc;
let jh = Lc = class extends we {
  constructor(e, t, n, r, s, o, a, l) {
    super(), this._editors = e, this._rootElement = t, this._diffModel = n, this._rootWidth = r, this._rootHeight = s, this._modifiedEditorLayoutInfo = o, this._options = a, this._themeService = l;
    const c = as(this._themeService.onDidColorThemeChange, () => this._themeService.getColorTheme()), d = nn((f) => {
      const g = c.read(f), p = g.getColor(qMe) || (g.getColor(UMe) || IF).transparent(2), m = g.getColor(KMe) || (g.getColor(GMe) || AF).transparent(2);
      return { insertColor: p, removeColor: m };
    }), u = as(this._editors.modified.onDidScrollChange, () => this._editors.modified.getScrollTop()), h = as(this._editors.modified.onDidScrollChange, () => this._editors.modified.getScrollHeight());
    this._register(Yo((f, g) => {
      if (!this._options.renderOverviewRuler.read(f))
        return;
      const p = Dn(document.createElement("div"));
      p.setClassName("diffViewport"), p.setPosition("absolute");
      const m = ts("div.diffOverview", {
        style: { position: "absolute", top: "0px", width: Lc.ENTIRE_DIFF_OVERVIEW_WIDTH + "px" }
      }).root;
      g.add(SD(m, p.domNode)), g.add(ar(m, Ge.POINTER_DOWN, (_) => {
        this._editors.modified.delegateVerticalScrollbarPointerDown(_);
      })), g.add(Ie(m, Ge.MOUSE_WHEEL, (_) => {
        this._editors.modified.delegateScrollFromMouseWheelEvent(_);
      }, { passive: !1 })), g.add(SD(this._rootElement, m)), g.add(Yo((_, b) => {
        const w = this._diffModel.read(_), y = this._editors.original.createOverviewRuler("original diffOverviewRuler");
        y && (b.add(y), b.add(SD(m, y.getDomNode())));
        const S = this._editors.modified.createOverviewRuler("modified diffOverviewRuler");
        if (S && (b.add(S), b.add(SD(m, S.getDomNode()))), !y || !S)
          return;
        const x = La("viewZoneChanged", this._editors.original.onDidChangeViewZones), D = La("viewZoneChanged", this._editors.modified.onDidChangeViewZones), E = La("hiddenRangesChanged", this._editors.original.onDidChangeHiddenAreas), L = La("hiddenRangesChanged", this._editors.modified.onDidChangeHiddenAreas);
        b.add(zn((k) => {
          var N;
          x.read(k), D.read(k), E.read(k), L.read(k);
          const I = d.read(k), A = (N = w?.diff.read(k)) === null || N === void 0 ? void 0 : N.mappings;
          function P(W, F, q) {
            const R = q._getViewModel();
            return R ? W.filter((T) => T.length > 0).map((T) => {
              const z = R.coordinatesConverter.convertModelPositionToViewPosition(new ve(T.startLineNumber, 1)), X = R.coordinatesConverter.convertModelPositionToViewPosition(new ve(T.endLineNumberExclusive, 1)), ae = X.lineNumber - z.lineNumber;
              return new dge(z.lineNumber, X.lineNumber, ae, F.toString());
            }) : [];
          }
          const O = P((A || []).map((W) => W.lineRangeMapping.original), I.removeColor, this._editors.original), K = P((A || []).map((W) => W.lineRangeMapping.modified), I.insertColor, this._editors.modified);
          y?.setZones(O), S?.setZones(K);
        })), b.add(zn((k) => {
          const N = this._rootHeight.read(k), I = this._rootWidth.read(k), A = this._modifiedEditorLayoutInfo.read(k);
          if (A) {
            const P = Lc.ENTIRE_DIFF_OVERVIEW_WIDTH - 2 * Lc.ONE_OVERVIEW_WIDTH;
            y.setLayout({
              top: 0,
              height: N,
              right: P + Lc.ONE_OVERVIEW_WIDTH,
              width: Lc.ONE_OVERVIEW_WIDTH
            }), S.setLayout({
              top: 0,
              height: N,
              right: 0,
              width: Lc.ONE_OVERVIEW_WIDTH
            });
            const O = u.read(k), K = h.read(k), W = this._editors.modified.getOption(
              102
              /* EditorOption.scrollbar */
            ), F = new D_(W.verticalHasArrows ? W.arrowSize : 0, W.verticalScrollbarSize, 0, A.height, K, O);
            p.setTop(F.getSliderPosition()), p.setHeight(F.getSliderSize());
          } else
            p.setTop(0), p.setHeight(0);
          m.style.height = N + "px", m.style.left = I - Lc.ENTIRE_DIFF_OVERVIEW_WIDTH + "px", p.setWidth(Lc.ENTIRE_DIFF_OVERVIEW_WIDTH);
        }));
      }));
    }));
  }
};
jh.ONE_OVERVIEW_WIDTH = 15;
jh.ENTIRE_DIFF_OVERVIEW_WIDTH = Lc.ONE_OVERVIEW_WIDTH * 2;
jh = Lc = TKe([
  NKe(7, Pr)
], jh);
ne("diffEditor.move.border", { dark: "#8b8b8b9c", light: "#8b8b8b9c", hcDark: "#8b8b8b9c", hcLight: "#8b8b8b9c" }, C("diffEditor.move.border", "The border color for text that got moved in the diff editor."));
ne("diffEditor.moveActive.border", { dark: "#FFA500", light: "#FFA500", hcDark: "#FFA500", hcLight: "#FFA500" }, C("diffEditor.moveActive.border", "The active border color for text that got moved in the diff editor."));
class t5 extends we {
  constructor() {
    super(...arguments), this._id = ++t5.idCounter, this._onDidDispose = this._register(new pe()), this.onDidDispose = this._onDidDispose.event;
  }
  getId() {
    return this.getEditorType() + ":v2:" + this._id;
  }
  // #region editorBrowser.IDiffEditor: Delegating to modified Editor
  getVisibleColumnFromPosition(e) {
    return this._targetEditor.getVisibleColumnFromPosition(e);
  }
  getPosition() {
    return this._targetEditor.getPosition();
  }
  setPosition(e, t = "api") {
    this._targetEditor.setPosition(e, t);
  }
  revealLine(e, t = 0) {
    this._targetEditor.revealLine(e, t);
  }
  revealLineInCenter(e, t = 0) {
    this._targetEditor.revealLineInCenter(e, t);
  }
  revealLineInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealLineInCenterIfOutsideViewport(e, t);
  }
  revealLineNearTop(e, t = 0) {
    this._targetEditor.revealLineNearTop(e, t);
  }
  revealPosition(e, t = 0) {
    this._targetEditor.revealPosition(e, t);
  }
  revealPositionInCenter(e, t = 0) {
    this._targetEditor.revealPositionInCenter(e, t);
  }
  revealPositionInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealPositionInCenterIfOutsideViewport(e, t);
  }
  revealPositionNearTop(e, t = 0) {
    this._targetEditor.revealPositionNearTop(e, t);
  }
  getSelection() {
    return this._targetEditor.getSelection();
  }
  getSelections() {
    return this._targetEditor.getSelections();
  }
  setSelection(e, t = "api") {
    this._targetEditor.setSelection(e, t);
  }
  setSelections(e, t = "api") {
    this._targetEditor.setSelections(e, t);
  }
  revealLines(e, t, n = 0) {
    this._targetEditor.revealLines(e, t, n);
  }
  revealLinesInCenter(e, t, n = 0) {
    this._targetEditor.revealLinesInCenter(e, t, n);
  }
  revealLinesInCenterIfOutsideViewport(e, t, n = 0) {
    this._targetEditor.revealLinesInCenterIfOutsideViewport(e, t, n);
  }
  revealLinesNearTop(e, t, n = 0) {
    this._targetEditor.revealLinesNearTop(e, t, n);
  }
  revealRange(e, t = 0, n = !1, r = !0) {
    this._targetEditor.revealRange(e, t, n, r);
  }
  revealRangeInCenter(e, t = 0) {
    this._targetEditor.revealRangeInCenter(e, t);
  }
  revealRangeInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealRangeInCenterIfOutsideViewport(e, t);
  }
  revealRangeNearTop(e, t = 0) {
    this._targetEditor.revealRangeNearTop(e, t);
  }
  revealRangeNearTopIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealRangeNearTopIfOutsideViewport(e, t);
  }
  revealRangeAtTop(e, t = 0) {
    this._targetEditor.revealRangeAtTop(e, t);
  }
  getSupportedActions() {
    return this._targetEditor.getSupportedActions();
  }
  focus() {
    this._targetEditor.focus();
  }
  trigger(e, t, n) {
    this._targetEditor.trigger(e, t, n);
  }
  createDecorationsCollection(e) {
    return this._targetEditor.createDecorationsCollection(e);
  }
  changeDecorations(e) {
    return this._targetEditor.changeDecorations(e);
  }
}
t5.idCounter = 0;
var PKe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, QJ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let CV = class extends we {
  constructor(e, t, n, r, s, o, a) {
    super(), this.originalEditorElement = e, this.modifiedEditorElement = t, this._options = n, this._createInnerEditor = s, this._instantiationService = o, this._keybindingService = a, this._onDidContentSizeChange = this._register(new pe()), this.original = this._register(this._createLeftHandSideEditor(n.editorOptions.get(), r.originalEditor || {})), this.modified = this._register(this._createRightHandSideEditor(n.editorOptions.get(), r.modifiedEditor || {})), this.modifiedModel = as(this.modified.onDidChangeModel, () => this.modified.getModel()), this._register(J4({
      createEmptyChangeSummary: () => ({}),
      handleChange: (l, c) => (l.didChange(n.editorOptions) && Object.assign(c, l.change.changedOptions), !0)
    }, (l, c) => {
      n.editorOptions.read(l), this._options.renderSideBySide.read(l), this.modified.updateOptions(this._adjustOptionsForRightHandSide(l, c)), this.original.updateOptions(this._adjustOptionsForLeftHandSide(l, c));
    }));
  }
  _createLeftHandSideEditor(e, t) {
    const n = this._adjustOptionsForLeftHandSide(void 0, e), r = this._constructInnerEditor(this._instantiationService, this.originalEditorElement, n, t);
    return r.setContextValue("isInDiffLeftEditor", !0), r;
  }
  _createRightHandSideEditor(e, t) {
    const n = this._adjustOptionsForRightHandSide(void 0, e), r = this._constructInnerEditor(this._instantiationService, this.modifiedEditorElement, n, t);
    return r.setContextValue("isInDiffRightEditor", !0), r;
  }
  _constructInnerEditor(e, t, n, r) {
    const s = this._createInnerEditor(e, t, n, r);
    return this._register(s.onDidContentSizeChange((o) => {
      const a = this.original.getContentWidth() + this.modified.getContentWidth() + jh.ENTIRE_DIFF_OVERVIEW_WIDTH, l = Math.max(this.modified.getContentHeight(), this.original.getContentHeight());
      this._onDidContentSizeChange.fire({
        contentHeight: l,
        contentWidth: a,
        contentHeightChanged: o.contentHeightChanged,
        contentWidthChanged: o.contentWidthChanged
      });
    })), s;
  }
  _adjustOptionsForLeftHandSide(e, t) {
    const n = this._adjustOptionsForSubEditor(t);
    return this._options.renderSideBySide.get() ? (n.unicodeHighlight = this._options.editorOptions.get().unicodeHighlight || {}, n.wordWrapOverride1 = this._options.diffWordWrap.get()) : (n.wordWrapOverride1 = "off", n.wordWrapOverride2 = "off", n.stickyScroll = { enabled: !1 }, n.unicodeHighlight = { nonBasicASCII: !1, ambiguousCharacters: !1, invisibleCharacters: !1 }), t.originalAriaLabel && (n.ariaLabel = t.originalAriaLabel), n.ariaLabel = this._updateAriaLabel(n.ariaLabel), n.readOnly = !this._options.originalEditable.get(), n.dropIntoEditor = { enabled: !n.readOnly }, n.extraEditorClassName = "original-in-monaco-diff-editor", n;
  }
  _adjustOptionsForRightHandSide(e, t) {
    const n = this._adjustOptionsForSubEditor(t);
    return t.modifiedAriaLabel && (n.ariaLabel = t.modifiedAriaLabel), n.ariaLabel = this._updateAriaLabel(n.ariaLabel), n.wordWrapOverride1 = this._options.diffWordWrap.get(), n.revealHorizontalRightPadding = pd.revealHorizontalRightPadding.defaultValue + jh.ENTIRE_DIFF_OVERVIEW_WIDTH, n.scrollbar.verticalHasArrows = !1, n.extraEditorClassName = "modified-in-monaco-diff-editor", n;
  }
  _adjustOptionsForSubEditor(e) {
    const t = Object.assign(Object.assign({}, e), { dimension: {
      height: 0,
      width: 0
    } });
    return t.inDiffEditor = !0, t.automaticLayout = !1, t.scrollbar = Object.assign({}, t.scrollbar || {}), t.scrollbar.vertical = "visible", t.folding = !1, t.codeLens = this._options.diffCodeLens.get(), t.fixedOverflowWidgets = !0, t.minimap = Object.assign({}, t.minimap || {}), t.minimap.enabled = !1, this._options.hideUnchangedRegions.get() ? t.stickyScroll = { enabled: !1 } : t.stickyScroll = this._options.editorOptions.get().stickyScroll, t;
  }
  _updateAriaLabel(e) {
    var t;
    e || (e = "");
    const n = C("diff-aria-navigation-tip", " use {0} to open the accessibility help.", (t = this._keybindingService.lookupKeybinding("editor.action.accessibilityHelp")) === null || t === void 0 ? void 0 : t.getAriaLabel());
    return this._options.accessibilityVerbose.get() ? e + n : e ? e.replaceAll(n, "") : "";
  }
};
CV = PKe([
  QJ(5, bt),
  QJ(6, Bn)
], CV);
class OKe {
  get editorOptions() {
    return this._options;
  }
  constructor(e, t) {
    this.diffEditorWidth = t, this.couldShowInlineViewBecauseOfSize = nn(this, (r) => this._options.read(r).renderSideBySide && this.diffEditorWidth.read(r) <= this._options.read(r).renderSideBySideInlineBreakpoint), this.renderOverviewRuler = nn(this, (r) => this._options.read(r).renderOverviewRuler), this.renderSideBySide = nn(this, (r) => this._options.read(r).renderSideBySide && !(this._options.read(r).useInlineViewWhenSpaceIsLimited && this.couldShowInlineViewBecauseOfSize.read(r))), this.readOnly = nn(this, (r) => this._options.read(r).readOnly), this.shouldRenderRevertArrows = nn(this, (r) => !(!this._options.read(r).renderMarginRevertIcon || !this.renderSideBySide.read(r) || this.readOnly.read(r))), this.renderIndicators = nn(this, (r) => this._options.read(r).renderIndicators), this.enableSplitViewResizing = nn(this, (r) => this._options.read(r).enableSplitViewResizing), this.splitViewDefaultRatio = nn(this, (r) => this._options.read(r).splitViewDefaultRatio), this.ignoreTrimWhitespace = nn(this, (r) => this._options.read(r).ignoreTrimWhitespace), this.maxComputationTimeMs = nn(this, (r) => this._options.read(r).maxComputationTime), this.showMoves = nn(this, (r) => this._options.read(r).experimental.showMoves && this.renderSideBySide.read(r)), this.isInEmbeddedEditor = nn(this, (r) => this._options.read(r).isInEmbeddedEditor), this.diffWordWrap = nn(this, (r) => this._options.read(r).diffWordWrap), this.originalEditable = nn(this, (r) => this._options.read(r).originalEditable), this.diffCodeLens = nn(this, (r) => this._options.read(r).diffCodeLens), this.accessibilityVerbose = nn(this, (r) => this._options.read(r).accessibilityVerbose), this.diffAlgorithm = nn(this, (r) => this._options.read(r).diffAlgorithm), this.showEmptyDecorations = nn(this, (r) => this._options.read(r).experimental.showEmptyDecorations), this.onlyShowAccessibleDiffViewer = nn(this, (r) => this._options.read(r).onlyShowAccessibleDiffViewer), this.hideUnchangedRegions = nn(this, (r) => this._options.read(r).hideUnchangedRegions.enabled), this.hideUnchangedRegionsRevealLineCount = nn(this, (r) => this._options.read(r).hideUnchangedRegions.revealLineCount), this.hideUnchangedRegionsContextLineCount = nn(this, (r) => this._options.read(r).hideUnchangedRegions.contextLineCount), this.hideUnchangedRegionsMinimumLineCount = nn(this, (r) => this._options.read(r).hideUnchangedRegions.minimumLineCount);
    const n = Object.assign(Object.assign({}, e), JJ(e, Gs));
    this._options = Yn(this, n);
  }
  updateOptions(e) {
    const t = JJ(e, this._options.get()), n = Object.assign(Object.assign(Object.assign({}, this._options.get()), e), t);
    this._options.set(n, void 0, { changedOptions: e });
  }
}
function JJ(i, e) {
  var t, n, r, s, o, a, l, c;
  return {
    enableSplitViewResizing: ut(i.enableSplitViewResizing, e.enableSplitViewResizing),
    splitViewDefaultRatio: V6e(i.splitViewDefaultRatio, 0.5, 0.1, 0.9),
    renderSideBySide: ut(i.renderSideBySide, e.renderSideBySide),
    renderMarginRevertIcon: ut(i.renderMarginRevertIcon, e.renderMarginRevertIcon),
    maxComputationTime: Fp(
      i.maxComputationTime,
      e.maxComputationTime,
      0,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ),
    maxFileSize: Fp(
      i.maxFileSize,
      e.maxFileSize,
      0,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ),
    ignoreTrimWhitespace: ut(i.ignoreTrimWhitespace, e.ignoreTrimWhitespace),
    renderIndicators: ut(i.renderIndicators, e.renderIndicators),
    originalEditable: ut(i.originalEditable, e.originalEditable),
    diffCodeLens: ut(i.diffCodeLens, e.diffCodeLens),
    renderOverviewRuler: ut(i.renderOverviewRuler, e.renderOverviewRuler),
    diffWordWrap: or(i.diffWordWrap, e.diffWordWrap, ["off", "on", "inherit"]),
    diffAlgorithm: or(i.diffAlgorithm, e.diffAlgorithm, ["legacy", "advanced"], { smart: "legacy", experimental: "advanced" }),
    accessibilityVerbose: ut(i.accessibilityVerbose, e.accessibilityVerbose),
    experimental: {
      showMoves: ut((t = i.experimental) === null || t === void 0 ? void 0 : t.showMoves, e.experimental.showMoves),
      showEmptyDecorations: ut((n = i.experimental) === null || n === void 0 ? void 0 : n.showEmptyDecorations, e.experimental.showEmptyDecorations)
    },
    hideUnchangedRegions: {
      enabled: ut((s = (r = i.hideUnchangedRegions) === null || r === void 0 ? void 0 : r.enabled) !== null && s !== void 0 ? s : (o = i.experimental) === null || o === void 0 ? void 0 : o.collapseUnchangedRegions, e.hideUnchangedRegions.enabled),
      contextLineCount: Fp(
        (a = i.hideUnchangedRegions) === null || a === void 0 ? void 0 : a.contextLineCount,
        e.hideUnchangedRegions.contextLineCount,
        0,
        1073741824
        /* Constants.MAX_SAFE_SMALL_INTEGER */
      ),
      minimumLineCount: Fp(
        (l = i.hideUnchangedRegions) === null || l === void 0 ? void 0 : l.minimumLineCount,
        e.hideUnchangedRegions.minimumLineCount,
        0,
        1073741824
        /* Constants.MAX_SAFE_SMALL_INTEGER */
      ),
      revealLineCount: Fp(
        (c = i.hideUnchangedRegions) === null || c === void 0 ? void 0 : c.revealLineCount,
        e.hideUnchangedRegions.revealLineCount,
        0,
        1073741824
        /* Constants.MAX_SAFE_SMALL_INTEGER */
      )
    },
    isInEmbeddedEditor: ut(i.isInEmbeddedEditor, e.isInEmbeddedEditor),
    onlyShowAccessibleDiffViewer: ut(i.onlyShowAccessibleDiffViewer, e.onlyShowAccessibleDiffViewer),
    renderSideBySideInlineBreakpoint: Fp(
      i.renderSideBySideInlineBreakpoint,
      e.renderSideBySideInlineBreakpoint,
      0,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ),
    useInlineViewWhenSpaceIsLimited: ut(i.useInlineViewWhenSpaceIsLimited, e.useInlineViewWhenSpaceIsLimited)
  };
}
var MKe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, f2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let i0 = class extends t5 {
  constructor(e, t, n, r, s, o, a, l) {
    var c;
    super(), this._domElement = e, this._parentContextKeyService = r, this._parentInstantiationService = s, this._audioCueService = a, this._editorProgressService = l, this.elements = ts("div.monaco-diff-editor.side-by-side", { style: { position: "relative", height: "100%" } }, [
      ts("div.noModificationsOverlay@overlay", { style: { position: "absolute", height: "100%", visibility: "hidden" } }, [Re("span", {}, "No Changes")]),
      ts("div.editor.original@original", { style: { position: "absolute", height: "100%" } }),
      ts("div.editor.modified@modified", { style: { position: "absolute", height: "100%" } }),
      ts("div.accessibleDiffViewer@accessibleDiffViewer", { style: { position: "absolute", height: "100%" } })
    ]), this._diffModel = this._register(iI("diffModel", void 0)), this.onDidChangeModel = qe.fromObservableLight(this._diffModel), this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._domElement)), this._instantiationService = this._parentInstantiationService.createChild(new L4([yt, this._contextKeyService])), this._boundarySashes = Yn(this, void 0), this._accessibleDiffViewerShouldBeVisible = Yn(this, !1), this._accessibleDiffViewerVisible = nn(this, (p) => this._options.onlyShowAccessibleDiffViewer.read(p) ? !0 : this._accessibleDiffViewerShouldBeVisible.read(p)), this.movedBlocksLinesPart = Yn(this, void 0), this._layoutInfo = nn(this, (p) => {
      var m, _, b;
      const w = this._rootSizeObserver.width.read(p), y = this._rootSizeObserver.height.read(p), S = (m = this._sash.read(p)) === null || m === void 0 ? void 0 : m.sashLeft.read(p), x = S ?? Math.max(5, this._editors.original.getLayoutInfo().decorationsLeft), D = w - x - (this._options.renderOverviewRuler.read(p) ? jh.ENTIRE_DIFF_OVERVIEW_WIDTH : 0), E = (b = (_ = this.movedBlocksLinesPart.read(p)) === null || _ === void 0 ? void 0 : _.width.read(p)) !== null && b !== void 0 ? b : 0, L = x - E;
      return this.elements.original.style.width = L + "px", this.elements.original.style.left = "0px", this.elements.modified.style.width = D + "px", this.elements.modified.style.left = x + "px", this._editors.original.layout({ width: L, height: y }), this._editors.modified.layout({ width: D, height: y }), {
        modifiedEditor: this._editors.modified.getLayoutInfo(),
        originalEditor: this._editors.original.getLayoutInfo()
      };
    }), this._diffValue = this._diffModel.map((p, m) => p?.diff.read(m)), this.onDidUpdateDiff = qe.fromObservableLight(this._diffValue), o.willCreateDiffEditor(), this._contextKeyService.createKey("isInDiffEditor", !0), this._domElement.appendChild(this.elements.root), this._register(Ct(() => this._domElement.removeChild(this.elements.root))), this._rootSizeObserver = this._register(new Yqe(this.elements.root, t.dimension)), this._rootSizeObserver.setAutomaticLayout((c = t.automaticLayout) !== null && c !== void 0 ? c : !1), this._options = new OKe(t, this._rootSizeObserver.width), this._contextKeyService.createKey($.isEmbeddedDiffEditor.key, !1);
    const d = $.isEmbeddedDiffEditor.bindTo(this._contextKeyService);
    this._register(zn((p) => {
      d.set(this._options.isInEmbeddedEditor.read(p));
    }));
    const u = $.comparingMovedCode.bindTo(this._contextKeyService);
    this._register(zn((p) => {
      var m;
      u.set(!!(!((m = this._diffModel.read(p)) === null || m === void 0) && m.movedTextToCompare.read(p)));
    }));
    const h = $.diffEditorRenderSideBySideInlineBreakpointReached.bindTo(this._contextKeyService);
    this._register(zn((p) => {
      h.set(this._options.couldShowInlineViewBecauseOfSize.read(p));
    })), this._editors = this._register(this._instantiationService.createInstance(CV, this.elements.original, this.elements.modified, this._options, n, (p, m, _, b) => this._createInnerEditor(p, m, _, b))), this._sash = Cw(this, (p, m) => {
      const _ = this._options.renderSideBySide.read(p);
      if (this.elements.root.classList.toggle("side-by-side", _), !_)
        return;
      const b = m.add(new pKe(this._options, this.elements.root, {
        height: this._rootSizeObserver.height,
        width: this._rootSizeObserver.width.map((w, y) => w - (this._options.renderOverviewRuler.read(y) ? jh.ENTIRE_DIFF_OVERVIEW_WIDTH : 0))
      }));
      return m.add(zn((w) => {
        const y = this._boundarySashes.read(w);
        y && b.setBoundarySashes(y);
      })), b;
    }), this._register(ww(this._sash)), this._register(Yo((p, m) => {
      this.unchangedRangesFeature = m.add(this._instantiationService.createInstance(Rf(pV, p), this._editors, this._diffModel, this._options));
    })), this._register(Yo((p, m) => {
      m.add(new (Rf(gKe, p))(this._editors, this._diffModel, this._options));
    })), this._register(Yo((p, m) => {
      m.add(this._instantiationService.createInstance(Rf(bV, p), this._editors, this._diffModel, this._options, this, () => this.unchangedRangesFeature.isUpdatingViewZones));
    })), this._register(Yo((p, m) => {
      m.add(this._instantiationService.createInstance(Rf(jh, p), this._editors, this.elements.root, this._diffModel, this._rootSizeObserver.width, this._rootSizeObserver.height, this._layoutInfo.map((_) => _.modifiedEditor), this._options));
    })), this._register(Yo((p, m) => {
      this._accessibleDiffViewer = m.add(this._register(this._instantiationService.createInstance(Rf(rg, p), this.elements.accessibleDiffViewer, this._accessibleDiffViewerVisible, (_, b) => this._accessibleDiffViewerShouldBeVisible.set(_, b), this._options.onlyShowAccessibleDiffViewer.map((_) => !_), this._rootSizeObserver.width, this._rootSizeObserver.height, this._diffModel.map((_, b) => {
        var w;
        return (w = _?.diff.read(b)) === null || w === void 0 ? void 0 : w.mappings.map((y) => y.lineRangeMapping);
      }), this._editors)));
    }));
    const f = this._accessibleDiffViewerVisible.map((p) => p ? "hidden" : "visible");
    this._register(wg(this.elements.modified, { visibility: f })), this._register(wg(this.elements.original, { visibility: f })), this._createDiffEditorContributions(), o.addDiffEditor(this), this._register(ww(this._layoutInfo)), this._register(Yo((p, m) => {
      this.movedBlocksLinesPart.set(m.add(new (Rf(Sg, p))(this.elements.root, this._diffModel, this._layoutInfo.map((_) => _.originalEditor), this._layoutInfo.map((_) => _.modifiedEditor), this._editors)), void 0);
    })), this._register(wg(this.elements.overlay, {
      width: this._layoutInfo.map((p, m) => p.originalEditor.width + (this._options.renderSideBySide.read(m) ? 0 : p.modifiedEditor.width)),
      visibility: nn((p) => {
        var m, _;
        return this._options.hideUnchangedRegions.read(p) && ((_ = (m = this._diffModel.read(p)) === null || m === void 0 ? void 0 : m.diff.read(p)) === null || _ === void 0 ? void 0 : _.mappings.length) === 0 ? "visible" : "hidden";
      })
    })), this._register(this._editors.modified.onMouseDown((p) => {
      var m, _;
      if (!p.event.rightButton && p.target.position && (!((m = p.target.element) === null || m === void 0) && m.className.includes("arrow-revert-change"))) {
        const b = p.target.position.lineNumber, w = p.target, y = this._diffModel.get();
        if (!y)
          return;
        const S = (_ = y.diff.get()) === null || _ === void 0 ? void 0 : _.mappings;
        if (!S)
          return;
        const x = S.find((D) => w?.detail.afterLineNumber === D.lineRangeMapping.modified.startLineNumber - 1 || D.lineRangeMapping.modified.startLineNumber === b);
        if (!x)
          return;
        this.revert(x.lineRangeMapping), p.event.stopPropagation();
      }
    })), this._register(qe.runAndSubscribe(this._editors.modified.onDidChangeCursorPosition, (p) => {
      var m, _;
      if (p?.reason === 3) {
        const b = (_ = (m = this._diffModel.get()) === null || m === void 0 ? void 0 : m.diff.get()) === null || _ === void 0 ? void 0 : _.mappings.find((w) => w.lineRangeMapping.modified.contains(p.position.lineNumber));
        b?.lineRangeMapping.modified.isEmpty ? this._audioCueService.playAudioCue(un.diffLineDeleted, { source: "diffEditor.cursorPositionChanged" }) : b?.lineRangeMapping.original.isEmpty ? this._audioCueService.playAudioCue(un.diffLineInserted, { source: "diffEditor.cursorPositionChanged" }) : b && this._audioCueService.playAudioCue(un.diffLineModified, { source: "diffEditor.cursorPositionChanged" });
      }
    }));
    const g = this._diffModel.map((p, m) => p?.isDiffUpToDate.read(m));
    this._register(Yo((p, m) => {
      if (g.read(p) === !1) {
        const _ = this._editorProgressService.show(!0, 1e3);
        m.add(Ct(() => _.done()));
      }
    }));
  }
  _createInnerEditor(e, t, n, r) {
    return e.createInstance(L_, t, n, r);
  }
  _createDiffEditorContributions() {
    const e = Av.getDiffEditorContributions();
    for (const t of e)
      try {
        this._register(this._instantiationService.createInstance(t.ctor, this));
      } catch (n) {
        It(n);
      }
  }
  get _targetEditor() {
    return this._editors.modified;
  }
  getEditorType() {
    return DS.IDiffEditor;
  }
  layout(e) {
    this._rootSizeObserver.observe(e);
  }
  hasTextFocus() {
    return this._editors.original.hasTextFocus() || this._editors.modified.hasTextFocus();
  }
  saveViewState() {
    var e;
    const t = this._editors.original.saveViewState(), n = this._editors.modified.saveViewState();
    return {
      original: t,
      modified: n,
      modelState: (e = this._diffModel.get()) === null || e === void 0 ? void 0 : e.serializeState()
    };
  }
  restoreViewState(e) {
    var t;
    if (e && e.original && e.modified) {
      const n = e;
      this._editors.original.restoreViewState(n.original), this._editors.modified.restoreViewState(n.modified), n.modelState && ((t = this._diffModel.get()) === null || t === void 0 || t.restoreSerializedState(n.modelState));
    }
  }
  createViewModel(e) {
    return this._instantiationService.createInstance(_V, e, this._options, this);
  }
  getModel() {
    var e, t;
    return (t = (e = this._diffModel.get()) === null || e === void 0 ? void 0 : e.model) !== null && t !== void 0 ? t : null;
  }
  setModel(e) {
    !e && this._diffModel.get() && this._accessibleDiffViewer.close();
    const t = e ? "model" in e ? e : this.createViewModel(e) : void 0;
    this._editors.original.setModel(t ? t.model.original : null), this._editors.modified.setModel(t ? t.model.modified : null), di((n) => {
      this._diffModel.set(t, n);
    });
  }
  /**
   * @param changedOptions Only has values for top-level options that have actually changed.
   */
  updateOptions(e) {
    this._options.updateOptions(e);
  }
  getContainerDomNode() {
    return this._domElement;
  }
  getOriginalEditor() {
    return this._editors.original;
  }
  getModifiedEditor() {
    return this._editors.modified;
  }
  /**
   * @deprecated Use `this.getDiffComputationResult().changes2` instead.
   */
  getLineChanges() {
    var e;
    const t = (e = this._diffModel.get()) === null || e === void 0 ? void 0 : e.diff.get();
    return t ? BKe(t) : null;
  }
  revert(e) {
    var t;
    const n = (t = this._diffModel.get()) === null || t === void 0 ? void 0 : t.model;
    if (!n)
      return;
    const r = e.innerChanges ? e.innerChanges.map((s) => ({
      range: s.modifiedRange,
      text: n.original.getValueInRange(s.originalRange)
    })) : [
      {
        range: e.modified.toExclusiveRange(),
        text: n.original.getValueInRange(e.original.toExclusiveRange())
      }
    ];
    this._editors.modified.executeEdits("diffEditor", r);
  }
  accessibleDiffViewerNext() {
    this._accessibleDiffViewer.next();
  }
  accessibleDiffViewerPrev() {
    this._accessibleDiffViewer.prev();
  }
  mapToOtherSide() {
    var e, t;
    const n = this._editors.modified.hasWidgetFocus(), r = n ? this._editors.modified : this._editors.original, s = n ? this._editors.original : this._editors.modified;
    let o;
    const a = r.getSelection();
    if (a) {
      const l = (t = (e = this._diffModel.get()) === null || e === void 0 ? void 0 : e.diff.get()) === null || t === void 0 ? void 0 : t.mappings.map((c) => n ? c.lineRangeMapping.flip() : c.lineRangeMapping);
      if (l) {
        const c = $J(a.getStartPosition(), l), d = $J(a.getEndPosition(), l);
        o = V.plusRange(c, d);
      }
    }
    return { destination: s, destinationSelection: o };
  }
  switchSide() {
    const { destination: e, destinationSelection: t } = this.mapToOtherSide();
    e.focus(), t && e.setSelection(t);
  }
  exitCompareMove() {
    const e = this._diffModel.get();
    e && e.movedTextToCompare.set(void 0, void 0);
  }
  collapseAllUnchangedRegions() {
    var e;
    const t = (e = this._diffModel.get()) === null || e === void 0 ? void 0 : e.unchangedRegions.get();
    t && di((n) => {
      for (const r of t)
        r.collapseAll(n);
    });
  }
  showAllUnchangedRegions() {
    var e;
    const t = (e = this._diffModel.get()) === null || e === void 0 ? void 0 : e.unchangedRegions.get();
    t && di((n) => {
      for (const r of t)
        r.showAll(n);
    });
  }
};
i0 = MKe([
  f2(3, yt),
  f2(4, bt),
  f2(5, Sn),
  f2(6, GS),
  f2(7, hp)
], i0);
function $J(i, e) {
  const t = sL(e, (r) => r.original.startLineNumber <= i.lineNumber);
  if (!t)
    return V.fromPositions(i);
  if (t.original.endLineNumberExclusive <= i.lineNumber) {
    const r = i.lineNumber - t.original.endLineNumberExclusive + t.modified.endLineNumberExclusive;
    return V.fromPositions(new ve(r, i.column));
  }
  if (!t.innerChanges)
    return V.fromPositions(new ve(t.modified.startLineNumber, 1));
  const n = sL(t.innerChanges, (r) => r.originalRange.getStartPosition().isBeforeOrEqual(i));
  if (!n) {
    const r = i.lineNumber - t.original.startLineNumber + t.modified.startLineNumber;
    return V.fromPositions(new ve(r, i.column));
  }
  if (n.originalRange.containsPosition(i))
    return n.modifiedRange;
  {
    const r = RKe(n.originalRange.getEndPosition(), i);
    return V.fromPositions(FKe(n.modifiedRange.getEndPosition(), r));
  }
}
function RKe(i, e) {
  return i.lineNumber === e.lineNumber ? new Qy(0, e.column - i.column) : new Qy(e.lineNumber - i.lineNumber, e.column - 1);
}
function FKe(i, e) {
  return e.lineCount === 0 ? new ve(i.lineNumber, i.column + e.columnCount) : new ve(i.lineNumber + e.lineCount, e.columnCount + 1);
}
function BKe(i) {
  return i.mappings.map((e) => {
    const t = e.lineRangeMapping;
    let n, r, s, o, a = t.innerChanges;
    return t.original.isEmpty ? (n = t.original.startLineNumber - 1, r = 0, a = void 0) : (n = t.original.startLineNumber, r = t.original.endLineNumberExclusive - 1), t.modified.isEmpty ? (s = t.modified.startLineNumber - 1, o = 0, a = void 0) : (s = t.modified.startLineNumber, o = t.modified.endLineNumberExclusive - 1), {
      originalStartLineNumber: n,
      originalEndLineNumber: r,
      modifiedStartLineNumber: s,
      modifiedEndLineNumber: o,
      charChanges: a?.map((l) => ({
        originalStartLineNumber: l.originalRange.startLineNumber,
        originalStartColumn: l.originalRange.startColumn,
        originalEndLineNumber: l.originalRange.endLineNumber,
        originalEndColumn: l.originalRange.endColumn,
        modifiedStartLineNumber: l.modifiedRange.startLineNumber,
        modifiedStartColumn: l.modifiedRange.startColumn,
        modifiedEndLineNumber: l.modifiedRange.endLineNumber,
        modifiedEndColumn: l.modifiedRange.endColumn
      }))
    };
  });
}
var VU = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, ai = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let VKe = 0, e$ = !1;
function HKe(i) {
  if (!i) {
    if (e$)
      return;
    e$ = !0;
  }
  jOe(i || document.body);
}
let dI = class extends L_ {
  constructor(e, t, n, r, s, o, a, l, c, d, u, h) {
    const f = Object.assign({}, t);
    f.ariaLabel = f.ariaLabel || ML.editorViewAccessibleLabel, f.ariaLabel = f.ariaLabel + ";" + ML.accessibilityHelpMessage, super(e, f, {}, n, r, s, o, l, c, d, u, h), a instanceof M_ ? this._standaloneKeybindingService = a : this._standaloneKeybindingService = null, HKe(f.ariaContainerElement);
  }
  addCommand(e, t, n) {
    if (!this._standaloneKeybindingService)
      return console.warn("Cannot add command because the editor is configured with an unrecognized KeybindingService"), null;
    const r = "DYNAMIC_" + ++VKe, s = ke.deserialize(n);
    return this._standaloneKeybindingService.addDynamicKeybinding(r, e, t, s), r;
  }
  createContextKey(e, t) {
    return this._contextKeyService.createKey(e, t);
  }
  addAction(e) {
    if (typeof e.id != "string" || typeof e.label != "string" || typeof e.run != "function")
      throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
    if (!this._standaloneKeybindingService)
      return console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService"), we.None;
    const t = e.id, n = e.label, r = ke.and(ke.equals("editorId", this.getId()), ke.deserialize(e.precondition)), s = e.keybindings, o = ke.and(r, ke.deserialize(e.keybindingContext)), a = e.contextMenuGroupId || null, l = e.contextMenuOrder || 0, c = (f, ...g) => Promise.resolve(e.run(this, ...g)), d = new Ne(), u = this.getId() + ":" + t;
    if (d.add(on.registerCommand(u, c)), a) {
      const f = {
        command: {
          id: u,
          title: n
        },
        when: r,
        group: a,
        order: l
      };
      d.add(os.appendMenuItem(J.EditorContext, f));
    }
    if (Array.isArray(s))
      for (const f of s)
        d.add(this._standaloneKeybindingService.addDynamicKeybinding(u, f, c, o));
    const h = new uge(u, n, n, r, (...f) => Promise.resolve(e.run(this, ...f)), this._contextKeyService);
    return this._actions.set(t, h), d.add(Ct(() => {
      this._actions.delete(t);
    })), d;
  }
  _triggerCommand(e, t) {
    if (this._codeEditorService instanceof LL)
      try {
        this._codeEditorService.setActiveCodeEditor(this), super._triggerCommand(e, t);
      } finally {
        this._codeEditorService.setActiveCodeEditor(null);
      }
    else
      super._triggerCommand(e, t);
  }
};
dI = VU([
  ai(2, bt),
  ai(3, Sn),
  ai(4, Ui),
  ai(5, yt),
  ai(6, Bn),
  ai(7, Pr),
  ai(8, dr),
  ai(9, lf),
  ai(10, Un),
  ai(11, tt)
], dI);
let yV = class extends dI {
  constructor(e, t, n, r, s, o, a, l, c, d, u, h, f, g, p) {
    const m = Object.assign({}, t);
    nI(d, m, !1);
    const _ = l.registerEditorContainer(e);
    typeof m.theme == "string" && l.setTheme(m.theme), typeof m.autoDetectHighContrast < "u" && l.setAutoDetectHighContrast(!!m.autoDetectHighContrast);
    const b = m.model;
    delete m.model, super(e, m, n, r, s, o, a, l, c, u, g, p), this._configurationService = d, this._standaloneThemeService = l, this._register(_);
    let w;
    if (typeof b > "u") {
      const y = f.getLanguageIdByMimeType(m.language) || m.language || Fa;
      w = yme(h, f, m.value || "", y, void 0), this._ownsModel = !0;
    } else
      w = b, this._ownsModel = !1;
    if (this._attachModel(w), w) {
      const y = {
        oldModelUrl: null,
        newModelUrl: w.uri
      };
      this._onDidChangeModel.fire(y);
    }
  }
  dispose() {
    super.dispose();
  }
  updateOptions(e) {
    nI(this._configurationService, e, !1), typeof e.theme == "string" && this._standaloneThemeService.setTheme(e.theme), typeof e.autoDetectHighContrast < "u" && this._standaloneThemeService.setAutoDetectHighContrast(!!e.autoDetectHighContrast), super.updateOptions(e);
  }
  _postDetachModelCleanup(e) {
    super._postDetachModelCleanup(e), e && this._ownsModel && (e.dispose(), this._ownsModel = !1);
  }
};
yV = VU([
  ai(2, bt),
  ai(3, Sn),
  ai(4, Ui),
  ai(5, yt),
  ai(6, Bn),
  ai(7, Ya),
  ai(8, dr),
  ai(9, en),
  ai(10, lf),
  ai(11, fi),
  ai(12, ci),
  ai(13, Un),
  ai(14, tt)
], yV);
let wV = class extends i0 {
  constructor(e, t, n, r, s, o, a, l, c, d, u, h) {
    const f = Object.assign({}, t);
    nI(l, f, !0);
    const g = o.registerEditorContainer(e);
    typeof f.theme == "string" && o.setTheme(f.theme), typeof f.autoDetectHighContrast < "u" && o.setAutoDetectHighContrast(!!f.autoDetectHighContrast), super(e, f, {}, r, n, s, h, d), this._configurationService = l, this._standaloneThemeService = o, this._register(g);
  }
  dispose() {
    super.dispose();
  }
  updateOptions(e) {
    nI(this._configurationService, e, !0), typeof e.theme == "string" && this._standaloneThemeService.setTheme(e.theme), typeof e.autoDetectHighContrast < "u" && this._standaloneThemeService.setAutoDetectHighContrast(!!e.autoDetectHighContrast), super.updateOptions(e);
  }
  _createInnerEditor(e, t, n) {
    return e.createInstance(dI, t, n);
  }
  getOriginalEditor() {
    return super.getOriginalEditor();
  }
  getModifiedEditor() {
    return super.getModifiedEditor();
  }
  addCommand(e, t, n) {
    return this.getModifiedEditor().addCommand(e, t, n);
  }
  createContextKey(e, t) {
    return this.getModifiedEditor().createContextKey(e, t);
  }
  addAction(e) {
    return this.getModifiedEditor().addAction(e);
  }
};
wV = VU([
  ai(2, bt),
  ai(3, yt),
  ai(4, Sn),
  ai(5, Ya),
  ai(6, dr),
  ai(7, en),
  ai(8, gc),
  ai(9, hp),
  ai(10, hf),
  ai(11, GS)
], wV);
function yme(i, e, t, n, r) {
  if (t = t || "", !n) {
    const s = t.indexOf(`
`);
    let o = t;
    return s !== -1 && (o = t.substring(0, s)), t$(i, t, e.createByFilepathOrFirstLine(r || null, o), r);
  }
  return t$(i, t, e.createById(n), r);
}
function t$(i, e, t, n) {
  return i.createModel(e, t, n);
}
var wme = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function WKe(i, e, t) {
  return _t.initialize(t || {}).createInstance(yV, i, e);
}
function jKe(i) {
  return _t.get(Sn).onCodeEditorAdd((t) => {
    i(t);
  });
}
function zKe(i) {
  return _t.get(Sn).onDiffEditorAdd((t) => {
    i(t);
  });
}
function UKe() {
  return _t.get(Sn).listCodeEditors();
}
function GKe() {
  return _t.get(Sn).listDiffEditors();
}
function qKe(i, e, t) {
  return _t.initialize(t || {}).createInstance(wV, i, e);
}
function KKe(i) {
  if (typeof i.id != "string" || typeof i.run != "function")
    throw new Error("Invalid command descriptor, `id` and `run` are required properties!");
  return on.registerCommand(i.id, i.run);
}
function YKe(i) {
  if (typeof i.id != "string" || typeof i.label != "string" || typeof i.run != "function")
    throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
  const e = ke.deserialize(i.precondition), t = (r, ...s) => Kr.runEditorCommand(r, s, e, (o, a, l) => Promise.resolve(i.run(a, ...l))), n = new Ne();
  if (n.add(on.registerCommand(i.id, t)), i.contextMenuGroupId) {
    const r = {
      command: {
        id: i.id,
        title: i.label
      },
      when: e,
      group: i.contextMenuGroupId,
      order: i.contextMenuOrder || 0
    };
    n.add(os.appendMenuItem(J.EditorContext, r));
  }
  if (Array.isArray(i.keybindings)) {
    const r = _t.get(Bn);
    if (!(r instanceof M_))
      console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
    else {
      const s = ke.and(e, ke.deserialize(i.keybindingContext));
      n.add(r.addDynamicKeybindings(i.keybindings.map((o) => ({
        keybinding: o,
        command: i.id,
        when: s
      }))));
    }
  }
  return n;
}
function XKe(i) {
  return Sme([i]);
}
function Sme(i) {
  const e = _t.get(Bn);
  return e instanceof M_ ? e.addDynamicKeybindings(i.map((t) => ({
    keybinding: t.keybinding,
    command: t.command,
    commandArgs: t.commandArgs,
    when: ke.deserialize(t.when)
  }))) : (console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService"), we.None);
}
function ZKe(i, e, t) {
  const n = _t.get(ci), r = n.getLanguageIdByMimeType(e) || e;
  return yme(_t.get(fi), n, i, r, t);
}
function QKe(i, e) {
  const t = _t.get(ci), n = t.getLanguageIdByMimeType(e) || e || Fa;
  i.setLanguage(t.createById(n));
}
function JKe(i, e, t) {
  i && _t.get(Fu).changeOne(e, i.uri, t);
}
function $Ke(i) {
  _t.get(Fu).changeAll(i, []);
}
function eYe(i) {
  return _t.get(Fu).read(i);
}
function tYe(i) {
  return _t.get(Fu).onMarkerChanged(i);
}
function nYe(i) {
  return _t.get(fi).getModel(i);
}
function iYe() {
  return _t.get(fi).getModels();
}
function rYe(i) {
  return _t.get(fi).onModelAdded(i);
}
function sYe(i) {
  return _t.get(fi).onModelRemoved(i);
}
function oYe(i) {
  return _t.get(fi).onModelLanguageChanged((t) => {
    i({
      model: t.model,
      oldLanguage: t.oldLanguageId
    });
  });
}
function aYe(i) {
  return pOe(_t.get(fi), _t.get(Un), i);
}
function lYe(i, e) {
  const t = _t.get(ci), n = _t.get(Ya);
  return cz.colorizeElement(n, t, i, e).then(() => {
    n.registerEditorContainer(i);
  });
}
function cYe(i, e, t) {
  const n = _t.get(ci);
  return _t.get(Ya).registerEditorContainer(document.body), cz.colorize(n, i, e, t);
}
function dYe(i, e, t = 4) {
  return _t.get(Ya).registerEditorContainer(document.body), cz.colorizeModelLine(i, e, t);
}
function uYe(i) {
  const e = Pi.get(i);
  return e || {
    getInitialState: () => __,
    tokenize: (t, n, r) => oz(i, r)
  };
}
function hYe(i, e) {
  Pi.getOrCreate(e);
  const t = uYe(e), n = Cu(i), r = [];
  let s = t.getInitialState();
  for (let o = 0, a = n.length; o < a; o++) {
    const l = n[o], c = t.tokenize(l, !0, s);
    r[o] = c.tokens, s = c.endState;
  }
  return r;
}
function fYe(i, e) {
  _t.get(Ya).defineTheme(i, e);
}
function gYe(i) {
  _t.get(Ya).setTheme(i);
}
function pYe() {
  nF.clearAllFontInfos();
}
function mYe(i, e) {
  return on.registerCommand({ id: i, handler: e });
}
function vYe(i) {
  return _t.get(da).registerOpener({
    open(t) {
      return wme(this, void 0, void 0, function* () {
        return typeof t == "string" && (t = pt.parse(t)), i.open(t);
      });
    }
  });
}
function _Ye(i) {
  return _t.get(Sn).registerCodeEditorOpenHandler((t, n, r) => wme(this, void 0, void 0, function* () {
    var s;
    if (!n)
      return null;
    const o = (s = t.options) === null || s === void 0 ? void 0 : s.selection;
    let a;
    return o && typeof o.endLineNumber == "number" && typeof o.endColumn == "number" ? a = o : o && (a = { lineNumber: o.startLineNumber, column: o.startColumn }), (yield i.openCodeEditor(n, t.resource, a)) ? n : null;
  }));
}
function bYe() {
  return {
    // methods
    create: WKe,
    getEditors: UKe,
    getDiffEditors: GKe,
    onDidCreateEditor: jKe,
    onDidCreateDiffEditor: zKe,
    createDiffEditor: qKe,
    addCommand: KKe,
    addEditorAction: YKe,
    addKeybindingRule: XKe,
    addKeybindingRules: Sme,
    createModel: ZKe,
    setModelLanguage: QKe,
    setModelMarkers: JKe,
    getModelMarkers: eYe,
    removeAllMarkers: $Ke,
    onDidChangeMarkers: tYe,
    getModels: iYe,
    getModel: nYe,
    onDidCreateModel: rYe,
    onWillDisposeModel: sYe,
    onDidChangeModelLanguage: oYe,
    createWebWorker: aYe,
    colorizeElement: lYe,
    colorize: cYe,
    colorizeModelLine: dYe,
    tokenize: hYe,
    defineTheme: fYe,
    setTheme: gYe,
    remeasureFonts: pYe,
    registerCommand: mYe,
    registerLinkOpener: vYe,
    registerEditorOpener: _Ye,
    // enums
    AccessibilitySupport: gR,
    ContentWidgetPositionPreference: CR,
    CursorChangeReason: yR,
    DefaultEndOfLine: wR,
    EditorAutoIndentStrategy: xR,
    EditorOption: DR,
    EndOfLinePreference: ER,
    EndOfLineSequence: LR,
    MinimapPosition: RR,
    MouseTargetType: FR,
    OverlayWidgetPositionPreference: BR,
    OverviewRulerLane: VR,
    GlyphMarginLane: IR,
    RenderLineNumbersType: WR,
    RenderMinimap: jR,
    ScrollbarVisibility: UR,
    ScrollType: zR,
    TextEditorCursorBlinkingStyle: XR,
    TextEditorCursorStyle: ZR,
    TrackedRangeStickiness: QR,
    WrappingIndent: JR,
    InjectedTextCursorStops: kR,
    PositionAffinity: HR,
    // classes
    ConfigurationChangedEvent: que,
    BareFontInfo: xm,
    FontInfo: tF,
    TextModelResolvedOptions: R3,
    FindMatch: Ny,
    ApplyUpdateResult: CC,
    EditorZoom: rl,
    // vars
    EditorType: DS,
    EditorOptions: pd
  };
}
function CYe(i, e) {
  if (!e || !Array.isArray(e))
    return !1;
  for (const t of e)
    if (!i(t))
      return !1;
  return !0;
}
function xD(i, e) {
  return typeof i == "boolean" ? i : e;
}
function n$(i, e) {
  return typeof i == "string" ? i : e;
}
function yYe(i) {
  const e = {};
  for (const t of i)
    e[t] = !0;
  return e;
}
function i$(i, e = !1) {
  e && (i = i.map(function(n) {
    return n.toLowerCase();
  }));
  const t = yYe(i);
  return e ? function(n) {
    return t[n.toLowerCase()] !== void 0 && t.hasOwnProperty(n.toLowerCase());
  } : function(n) {
    return t[n] !== void 0 && t.hasOwnProperty(n);
  };
}
function SV(i, e) {
  e = e.replace(/@@/g, "");
  let t = 0, n;
  do
    n = !1, e = e.replace(/@(\w+)/g, function(s, o) {
      n = !0;
      let a = "";
      if (typeof i[o] == "string")
        a = i[o];
      else if (i[o] && i[o] instanceof RegExp)
        a = i[o].source;
      else
        throw i[o] === void 0 ? ni(i, "language definition does not contain attribute '" + o + "', used at: " + e) : ni(i, "attribute reference '" + o + "' must be a string, used at: " + e);
      return M1(a) ? "" : "(?:" + a + ")";
    }), t++;
  while (n && t < 5);
  e = e.replace(/\x01/g, "@");
  const r = (i.ignoreCase ? "i" : "") + (i.unicode ? "u" : "");
  return new RegExp(e, r);
}
function wYe(i, e, t, n) {
  if (n < 0)
    return i;
  if (n < e.length)
    return e[n];
  if (n >= 100) {
    n = n - 100;
    const r = t.split(".");
    if (r.unshift(t), n < r.length)
      return r[n];
  }
  return null;
}
function SYe(i, e, t, n) {
  let r = -1, s = t, o = t.match(/^\$(([sS]?)(\d\d?)|#)(.*)$/);
  o && (o[3] && (r = parseInt(o[3]), o[2] && (r = r + 100)), s = o[4]);
  let a = "~", l = s;
  !s || s.length === 0 ? (a = "!=", l = "") : /^\w*$/.test(l) ? a = "==" : (o = s.match(/^(@|!@|~|!~|==|!=)(.*)$/), o && (a = o[1], l = o[2]));
  let c;
  if ((a === "~" || a === "!~") && /^(\w|\|)*$/.test(l)) {
    const d = i$(l.split("|"), i.ignoreCase);
    c = function(u) {
      return a === "~" ? d(u) : !d(u);
    };
  } else if (a === "@" || a === "!@") {
    const d = i[l];
    if (!d)
      throw ni(i, "the @ match target '" + l + "' is not defined, in rule: " + e);
    if (!CYe(function(h) {
      return typeof h == "string";
    }, d))
      throw ni(i, "the @ match target '" + l + "' must be an array of strings, in rule: " + e);
    const u = i$(d, i.ignoreCase);
    c = function(h) {
      return a === "@" ? u(h) : !u(h);
    };
  } else if (a === "~" || a === "!~")
    if (l.indexOf("$") < 0) {
      const d = SV(i, "^" + l + "$");
      c = function(u) {
        return a === "~" ? d.test(u) : !d.test(u);
      };
    } else
      c = function(d, u, h, f) {
        return SV(i, "^" + Bf(i, l, u, h, f) + "$").test(d);
      };
  else if (l.indexOf("$") < 0) {
    const d = mg(i, l);
    c = function(u) {
      return a === "==" ? u === d : u !== d;
    };
  } else {
    const d = mg(i, l);
    c = function(u, h, f, g, p) {
      const m = Bf(i, d, h, f, g);
      return a === "==" ? u === m : u !== m;
    };
  }
  return r === -1 ? {
    name: t,
    value: n,
    test: function(d, u, h, f) {
      return c(d, d, u, h, f);
    }
  } : {
    name: t,
    value: n,
    test: function(d, u, h, f) {
      const g = wYe(d, u, h, r);
      return c(g || "", d, u, h, f);
    }
  };
}
function xV(i, e, t) {
  if (t) {
    if (typeof t == "string")
      return t;
    if (t.token || t.token === "") {
      if (typeof t.token != "string")
        throw ni(i, "a 'token' attribute must be of type string, in rule: " + e);
      {
        const n = { token: t.token };
        if (t.token.indexOf("$") >= 0 && (n.tokenSubst = !0), typeof t.bracket == "string")
          if (t.bracket === "@open")
            n.bracket = 1;
          else if (t.bracket === "@close")
            n.bracket = -1;
          else
            throw ni(i, "a 'bracket' attribute must be either '@open' or '@close', in rule: " + e);
        if (t.next) {
          if (typeof t.next != "string")
            throw ni(i, "the next state must be a string value in rule: " + e);
          {
            let r = t.next;
            if (!/^(@pop|@push|@popall)$/.test(r) && (r[0] === "@" && (r = r.substr(1)), r.indexOf("$") < 0 && !OOe(i, Bf(i, r, "", [], ""))))
              throw ni(i, "the next state '" + t.next + "' is not defined in rule: " + e);
            n.next = r;
          }
        }
        return typeof t.goBack == "number" && (n.goBack = t.goBack), typeof t.switchTo == "string" && (n.switchTo = t.switchTo), typeof t.log == "string" && (n.log = t.log), typeof t.nextEmbedded == "string" && (n.nextEmbedded = t.nextEmbedded, i.usesEmbedded = !0), n;
      }
    } else if (Array.isArray(t)) {
      const n = [];
      for (let r = 0, s = t.length; r < s; r++)
        n[r] = xV(i, e, t[r]);
      return { group: n };
    } else if (t.cases) {
      const n = [];
      for (const s in t.cases)
        if (t.cases.hasOwnProperty(s)) {
          const o = xV(i, e, t.cases[s]);
          s === "@default" || s === "@" || s === "" ? n.push({ test: void 0, value: o, name: s }) : s === "@eos" ? n.push({ test: function(a, l, c, d) {
            return d;
          }, value: o, name: s }) : n.push(SYe(i, e, s, o));
        }
      const r = i.defaultToken;
      return {
        test: function(s, o, a, l) {
          for (const c of n)
            if (!c.test || c.test(s, o, a, l))
              return c.value;
          return r;
        }
      };
    } else
      throw ni(i, "an action must be a string, an object with a 'token' or 'cases' attribute, or an array of actions; in rule: " + e);
  } else return { token: "" };
}
class xYe {
  constructor(e) {
    this.regex = new RegExp(""), this.action = { token: "" }, this.matchOnlyAtLineStart = !1, this.name = "", this.name = e;
  }
  setRegex(e, t) {
    let n;
    if (typeof t == "string")
      n = t;
    else if (t instanceof RegExp)
      n = t.source;
    else
      throw ni(e, "rules must start with a match string or regular expression: " + this.name);
    this.matchOnlyAtLineStart = n.length > 0 && n[0] === "^", this.name = this.name + ": " + n, this.regex = SV(e, "^(?:" + (this.matchOnlyAtLineStart ? n.substr(1) : n) + ")");
  }
  setAction(e, t) {
    this.action = xV(e, this.name, t);
  }
}
function xme(i, e) {
  if (!e || typeof e != "object")
    throw new Error("Monarch: expecting a language definition object");
  const t = {};
  t.languageId = i, t.includeLF = xD(e.includeLF, !1), t.noThrow = !1, t.maxStack = 100, t.start = typeof e.start == "string" ? e.start : null, t.ignoreCase = xD(e.ignoreCase, !1), t.unicode = xD(e.unicode, !1), t.tokenPostfix = n$(e.tokenPostfix, "." + t.languageId), t.defaultToken = n$(e.defaultToken, "source"), t.usesEmbedded = !1;
  const n = e;
  n.languageId = i, n.includeLF = t.includeLF, n.ignoreCase = t.ignoreCase, n.unicode = t.unicode, n.noThrow = t.noThrow, n.usesEmbedded = t.usesEmbedded, n.stateNames = e.tokenizer, n.defaultToken = t.defaultToken;
  function r(o, a, l) {
    for (const c of l) {
      let d = c.include;
      if (d) {
        if (typeof d != "string")
          throw ni(t, "an 'include' attribute must be a string at: " + o);
        if (d[0] === "@" && (d = d.substr(1)), !e.tokenizer[d])
          throw ni(t, "include target '" + d + "' is not defined at: " + o);
        r(o + "." + d, a, e.tokenizer[d]);
      } else {
        const u = new xYe(o);
        if (Array.isArray(c) && c.length >= 1 && c.length <= 3)
          if (u.setRegex(n, c[0]), c.length >= 3)
            if (typeof c[1] == "string")
              u.setAction(n, { token: c[1], next: c[2] });
            else if (typeof c[1] == "object") {
              const h = c[1];
              h.next = c[2], u.setAction(n, h);
            } else
              throw ni(t, "a next state as the last element of a rule can only be given if the action is either an object or a string, at: " + o);
          else
            u.setAction(n, c[1]);
        else {
          if (!c.regex)
            throw ni(t, "a rule must either be an array, or an object with a 'regex' or 'include' field at: " + o);
          c.name && typeof c.name == "string" && (u.name = c.name), c.matchOnlyAtStart && (u.matchOnlyAtLineStart = xD(c.matchOnlyAtLineStart, !1)), u.setRegex(n, c.regex), u.setAction(n, c.action);
        }
        a.push(u);
      }
    }
  }
  if (!e.tokenizer || typeof e.tokenizer != "object")
    throw ni(t, "a language definition must define the 'tokenizer' attribute as an object");
  t.tokenizer = [];
  for (const o in e.tokenizer)
    if (e.tokenizer.hasOwnProperty(o)) {
      t.start || (t.start = o);
      const a = e.tokenizer[o];
      t.tokenizer[o] = new Array(), r("tokenizer." + o, t.tokenizer[o], a);
    }
  if (t.usesEmbedded = n.usesEmbedded, e.brackets) {
    if (!Array.isArray(e.brackets))
      throw ni(t, "the 'brackets' attribute must be defined as an array");
  } else
    e.brackets = [
      { open: "{", close: "}", token: "delimiter.curly" },
      { open: "[", close: "]", token: "delimiter.square" },
      { open: "(", close: ")", token: "delimiter.parenthesis" },
      { open: "<", close: ">", token: "delimiter.angle" }
    ];
  const s = [];
  for (const o of e.brackets) {
    let a = o;
    if (a && Array.isArray(a) && a.length === 3 && (a = { token: a[2], open: a[0], close: a[1] }), a.open === a.close)
      throw ni(t, "open and close brackets in a 'brackets' attribute must be different: " + a.open + `
 hint: use the 'bracket' attribute if matching on equal brackets is required.`);
    if (typeof a.open == "string" && typeof a.token == "string" && typeof a.close == "string")
      s.push({
        token: a.token + t.tokenPostfix,
        open: mg(t, a.open),
        close: mg(t, a.close)
      });
    else
      throw ni(t, "every element in the 'brackets' array must be a '{open,close,token}' object or array");
  }
  return t.brackets = s, t.noThrow = !0, t;
}
var DYe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function EYe(i) {
  m_.registerLanguage(i);
}
function LYe() {
  let i = [];
  return i = i.concat(m_.getLanguages()), i;
}
function IYe(i) {
  return _t.get(ci).languageIdCodec.encodeLanguageId(i);
}
function AYe(i, e) {
  return _t.withServices(() => {
    const n = _t.get(ci).onDidRequestRichLanguageFeatures((r) => {
      r === i && (n.dispose(), e());
    });
    return n;
  });
}
function kYe(i, e) {
  return _t.withServices(() => {
    const n = _t.get(ci).onDidRequestBasicLanguageFeatures((r) => {
      r === i && (n.dispose(), e());
    });
    return n;
  });
}
function TYe(i, e) {
  if (!_t.get(ci).isRegisteredLanguageId(i))
    throw new Error(`Cannot set configuration for unknown language ${i}`);
  return _t.get(Un).register(i, e, 100);
}
class NYe {
  constructor(e, t) {
    this._languageId = e, this._actual = t;
  }
  dispose() {
  }
  getInitialState() {
    return this._actual.getInitialState();
  }
  tokenize(e, t, n) {
    if (typeof this._actual.tokenize == "function")
      return Sw.adaptTokenize(this._languageId, this._actual, e, n);
    throw new Error("Not supported!");
  }
  tokenizeEncoded(e, t, n) {
    const r = this._actual.tokenizeEncoded(e, n);
    return new zA(r.tokens, r.endState);
  }
}
class Sw {
  constructor(e, t, n, r) {
    this._languageId = e, this._actual = t, this._languageService = n, this._standaloneThemeService = r;
  }
  dispose() {
  }
  getInitialState() {
    return this._actual.getInitialState();
  }
  static _toClassicTokens(e, t) {
    const n = [];
    let r = 0;
    for (let s = 0, o = e.length; s < o; s++) {
      const a = e[s];
      let l = a.startIndex;
      s === 0 ? l = 0 : l < r && (l = r), n[s] = new wy(l, a.scopes, t), r = l;
    }
    return n;
  }
  static adaptTokenize(e, t, n, r) {
    const s = t.tokenize(n, r), o = Sw._toClassicTokens(s.tokens, e);
    let a;
    return s.endState.equals(r) ? a = r : a = s.endState, new Rj(o, a);
  }
  tokenize(e, t, n) {
    return Sw.adaptTokenize(this._languageId, this._actual, e, n);
  }
  _toBinaryTokens(e, t) {
    const n = e.encodeLanguageId(this._languageId), r = this._standaloneThemeService.getColorTheme().tokenTheme, s = [];
    let o = 0, a = 0;
    for (let c = 0, d = t.length; c < d; c++) {
      const u = t[c], h = r.match(n, u.scopes) | 1024;
      if (o > 0 && s[o - 1] === h)
        continue;
      let f = u.startIndex;
      c === 0 ? f = 0 : f < a && (f = a), s[o++] = f, s[o++] = h, a = f;
    }
    const l = new Uint32Array(o);
    for (let c = 0; c < o; c++)
      l[c] = s[c];
    return l;
  }
  tokenizeEncoded(e, t, n) {
    const r = this._actual.tokenize(e, n), s = this._toBinaryTokens(this._languageService.languageIdCodec, r.tokens);
    let o;
    return r.endState.equals(n) ? o = n : o = r.endState, new zA(s, o);
  }
}
function PYe(i) {
  return typeof i.getInitialState == "function";
}
function OYe(i) {
  return "tokenizeEncoded" in i;
}
function Dme(i) {
  return i && typeof i.then == "function";
}
function MYe(i) {
  const e = _t.get(Ya);
  if (i) {
    const t = [null];
    for (let n = 1, r = i.length; n < r; n++)
      t[n] = ye.fromHex(i[n]);
    e.setColorMapOverride(t);
  } else
    e.setColorMapOverride(null);
}
function Eme(i, e) {
  return OYe(e) ? new NYe(i, e) : new Sw(i, e, _t.get(ci), _t.get(Ya));
}
function HU(i, e) {
  const t = new uNe(() => DYe(this, void 0, void 0, function* () {
    const n = yield Promise.resolve(e.create());
    return n ? PYe(n) ? Eme(i, n) : new Vy(_t.get(ci), _t.get(Ya), i, xme(i, n), _t.get(en)) : null;
  }));
  return Pi.registerFactory(i, t);
}
function RYe(i, e) {
  if (!_t.get(ci).isRegisteredLanguageId(i))
    throw new Error(`Cannot set tokens provider for unknown language ${i}`);
  return Dme(e) ? HU(i, { create: () => e }) : Pi.register(i, Eme(i, e));
}
function FYe(i, e) {
  const t = (n) => new Vy(_t.get(ci), _t.get(Ya), i, xme(i, n), _t.get(en));
  return Dme(e) ? HU(i, { create: () => e }) : Pi.register(i, t(e));
}
function BYe(i, e) {
  return _t.get(tt).referenceProvider.register(i, e);
}
function VYe(i, e) {
  return _t.get(tt).renameProvider.register(i, e);
}
function HYe(i, e) {
  return _t.get(tt).signatureHelpProvider.register(i, e);
}
function WYe(i, e) {
  return _t.get(tt).hoverProvider.register(i, {
    provideHover: (n, r, s) => {
      const o = n.getWordAtPosition(r);
      return Promise.resolve(e.provideHover(n, r, s)).then((a) => {
        if (a)
          return !a.range && o && (a.range = new V(r.lineNumber, o.startColumn, r.lineNumber, o.endColumn)), a.range || (a.range = new V(r.lineNumber, r.column, r.lineNumber, r.column)), a;
      });
    }
  });
}
function jYe(i, e) {
  return _t.get(tt).documentSymbolProvider.register(i, e);
}
function zYe(i, e) {
  return _t.get(tt).documentHighlightProvider.register(i, e);
}
function UYe(i, e) {
  return _t.get(tt).linkedEditingRangeProvider.register(i, e);
}
function GYe(i, e) {
  return _t.get(tt).definitionProvider.register(i, e);
}
function qYe(i, e) {
  return _t.get(tt).implementationProvider.register(i, e);
}
function KYe(i, e) {
  return _t.get(tt).typeDefinitionProvider.register(i, e);
}
function YYe(i, e) {
  return _t.get(tt).codeLensProvider.register(i, e);
}
function XYe(i, e, t) {
  return _t.get(tt).codeActionProvider.register(i, {
    providedCodeActionKinds: t?.providedCodeActionKinds,
    documentation: t?.documentation,
    provideCodeActions: (r, s, o, a) => {
      const c = _t.get(Fu).read({ resource: r.uri }).filter((d) => V.areIntersectingOrTouching(d, s));
      return e.provideCodeActions(r, s, { markers: c, only: o.only, trigger: o.trigger }, a);
    },
    resolveCodeAction: e.resolveCodeAction
  });
}
function ZYe(i, e) {
  return _t.get(tt).documentFormattingEditProvider.register(i, e);
}
function QYe(i, e) {
  return _t.get(tt).documentRangeFormattingEditProvider.register(i, e);
}
function JYe(i, e) {
  return _t.get(tt).onTypeFormattingEditProvider.register(i, e);
}
function $Ye(i, e) {
  return _t.get(tt).linkProvider.register(i, e);
}
function eXe(i, e) {
  return _t.get(tt).completionProvider.register(i, e);
}
function tXe(i, e) {
  return _t.get(tt).colorProvider.register(i, e);
}
function nXe(i, e) {
  return _t.get(tt).foldingRangeProvider.register(i, e);
}
function iXe(i, e) {
  return _t.get(tt).declarationProvider.register(i, e);
}
function rXe(i, e) {
  return _t.get(tt).selectionRangeProvider.register(i, e);
}
function sXe(i, e) {
  return _t.get(tt).documentSemanticTokensProvider.register(i, e);
}
function oXe(i, e) {
  return _t.get(tt).documentRangeSemanticTokensProvider.register(i, e);
}
function aXe(i, e) {
  return _t.get(tt).inlineCompletionsProvider.register(i, e);
}
function lXe(i, e) {
  return _t.get(tt).inlayHintsProvider.register(i, e);
}
function cXe() {
  return {
    register: EYe,
    getLanguages: LYe,
    onLanguage: AYe,
    onLanguageEncountered: kYe,
    getEncodedLanguageId: IYe,
    // provider methods
    setLanguageConfiguration: TYe,
    setColorMap: MYe,
    registerTokensProviderFactory: HU,
    setTokensProvider: RYe,
    setMonarchTokensProvider: FYe,
    registerReferenceProvider: BYe,
    registerRenameProvider: VYe,
    registerCompletionItemProvider: eXe,
    registerSignatureHelpProvider: HYe,
    registerHoverProvider: WYe,
    registerDocumentSymbolProvider: jYe,
    registerDocumentHighlightProvider: zYe,
    registerLinkedEditingRangeProvider: UYe,
    registerDefinitionProvider: GYe,
    registerImplementationProvider: qYe,
    registerTypeDefinitionProvider: KYe,
    registerCodeLensProvider: YYe,
    registerCodeActionProvider: XYe,
    registerDocumentFormattingEditProvider: ZYe,
    registerDocumentRangeFormattingEditProvider: QYe,
    registerOnTypeFormattingEditProvider: JYe,
    registerLinkProvider: $Ye,
    registerColorProvider: tXe,
    registerFoldingRangeProvider: nXe,
    registerDeclarationProvider: iXe,
    registerSelectionRangeProvider: rXe,
    registerDocumentSemanticTokensProvider: sXe,
    registerDocumentRangeSemanticTokensProvider: oXe,
    registerInlineCompletionsProvider: aXe,
    registerInlayHintsProvider: lXe,
    // enums
    DocumentHighlightKind: SR,
    CompletionItemKind: vR,
    CompletionItemTag: _R,
    CompletionItemInsertTextRule: mR,
    SymbolKind: KR,
    SymbolTag: YR,
    IndentAction: AR,
    CompletionTriggerKind: bR,
    SignatureHelpTriggerKind: qR,
    InlayHintKind: TR,
    InlineCompletionTriggerKind: NR,
    CodeActionTriggerType: pR,
    // classes
    FoldingRangeKind: go,
    SelectedSuggestionInfo: lhe
  };
}
const WU = Gt("IEditorCancelService"), Lme = new Ke("cancellableOperation", !1, C("cancellableOperation", "Whether the editor runs a cancellable operation, e.g. like 'Peek References'"));
an(
  WU,
  class {
    constructor() {
      this._tokens = /* @__PURE__ */ new WeakMap();
    }
    add(i, e) {
      let t = this._tokens.get(i);
      t || (t = i.invokeWithinContext((r) => {
        const s = Lme.bindTo(r.get(yt)), o = new fo();
        return { key: s, tokens: o };
      }), this._tokens.set(i, t));
      let n;
      return t.key.set(!0), n = t.tokens.push(e), () => {
        n && (n(), t.key.set(!t.tokens.isEmpty()), n = void 0);
      };
    }
    cancel(i) {
      const e = this._tokens.get(i);
      if (!e)
        return;
      const t = e.tokens.pop();
      t && (t.cancel(), e.key.set(!e.tokens.isEmpty()));
    }
  },
  1
  /* InstantiationType.Delayed */
);
class dXe extends lr {
  constructor(e, t) {
    super(t), this.editor = e, this._unregister = e.invokeWithinContext((n) => n.get(WU).add(e, this));
  }
  dispose() {
    this._unregister(), super.dispose();
  }
}
ze(new class extends Kr {
  constructor() {
    super({
      id: "editor.cancelOperation",
      kbOpts: {
        weight: 100,
        primary: 9
        /* KeyCode.Escape */
      },
      precondition: Lme
    });
  }
  runEditorCommand(i, e) {
    i.get(WU).cancel(e);
  }
}());
let Ime = class DV {
  constructor(e, t) {
    if (this.flags = t, this.flags & 1) {
      const n = e.getModel();
      this.modelVersionId = n ? zm("{0}#{1}", n.uri.toString(), n.getVersionId()) : null;
    } else
      this.modelVersionId = null;
    this.flags & 4 ? this.position = e.getPosition() : this.position = null, this.flags & 2 ? this.selection = e.getSelection() : this.selection = null, this.flags & 8 ? (this.scrollLeft = e.getScrollLeft(), this.scrollTop = e.getScrollTop()) : (this.scrollLeft = -1, this.scrollTop = -1);
  }
  _equals(e) {
    if (!(e instanceof DV))
      return !1;
    const t = e;
    return !(this.modelVersionId !== t.modelVersionId || this.scrollLeft !== t.scrollLeft || this.scrollTop !== t.scrollTop || !this.position && t.position || this.position && !t.position || this.position && t.position && !this.position.equals(t.position) || !this.selection && t.selection || this.selection && !t.selection || this.selection && t.selection && !this.selection.equalsRange(t.selection));
  }
  validate(e) {
    return this._equals(new DV(e, this.flags));
  }
};
class Gg extends dXe {
  constructor(e, t, n, r) {
    super(e, r), this._listener = new Ne(), t & 4 && this._listener.add(e.onDidChangeCursorPosition((s) => {
      (!n || !V.containsPosition(n, s.position)) && this.cancel();
    })), t & 2 && this._listener.add(e.onDidChangeCursorSelection((s) => {
      (!n || !V.containsRange(n, s.selection)) && this.cancel();
    })), t & 8 && this._listener.add(e.onDidScrollChange((s) => this.cancel())), t & 1 && (this._listener.add(e.onDidChangeModel((s) => this.cancel())), this._listener.add(e.onDidChangeModelContent((s) => this.cancel())));
  }
  dispose() {
    this._listener.dispose(), super.dispose();
  }
}
class jU extends lr {
  constructor(e, t) {
    super(t), this._listener = e.onDidChangeContent(() => this.cancel());
  }
  dispose() {
    this._listener.dispose(), super.dispose();
  }
}
function Au(i) {
  return i && typeof i.getEditorType == "function" ? i.getEditorType() === DS.ICodeEditor : !1;
}
function Ame(i) {
  return i && typeof i.getEditorType == "function" ? i.getEditorType() === DS.IDiffEditor : !1;
}
function uXe(i) {
  return !!i && typeof i == "object" && typeof i.onDidChangeActiveEditor == "function";
}
function kme(i) {
  return Au(i) ? i : Ame(i) ? i.getModifiedEditor() : uXe(i) && Au(i.activeCodeEditor) ? i.activeCodeEditor : null;
}
class R_ {
  static _handleEolEdits(e, t) {
    let n;
    const r = [];
    for (const s of t)
      typeof s.eol == "number" && (n = s.eol), s.range && typeof s.text == "string" && r.push(s);
    return typeof n == "number" && e.hasModel() && e.getModel().pushEOL(n), r;
  }
  static _isFullModelReplaceEdit(e, t) {
    if (!e.hasModel())
      return !1;
    const n = e.getModel(), r = n.validateRange(t.range);
    return n.getFullModelRange().equalsRange(r);
  }
  static execute(e, t, n) {
    n && e.pushUndoStop();
    const r = ud.capture(e), s = R_._handleEolEdits(e, t);
    s.length === 1 && R_._isFullModelReplaceEdit(e, s[0]) ? e.executeEdits("formatEditsCommand", s.map((o) => Si.replace(V.lift(o.range), o.text))) : e.executeEdits("formatEditsCommand", s.map((o) => Si.replaceMove(V.lift(o.range), o.text))), n && e.pushUndoStop(), r.restoreRelativeVerticalPositionOfCursor(e);
  }
}
class r$ {
  constructor(e) {
    this.value = e, this._lower = e.toLowerCase();
  }
  /**
   * Gives the value by which to index (for equality).
   */
  static toKey(e) {
    return typeof e == "string" ? e.toLowerCase() : e._lower;
  }
}
class hXe {
  constructor(e) {
    if (this._set = /* @__PURE__ */ new Set(), e)
      for (const t of e)
        this.add(t);
  }
  add(e) {
    this._set.add(r$.toKey(e));
  }
  has(e) {
    return this._set.has(r$.toKey(e));
  }
}
var hd = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function zU(i) {
  if (i = i.filter((r) => r.range), !i.length)
    return;
  let { range: e } = i[0];
  for (let r = 1; r < i.length; r++)
    e = V.plusRange(e, i[r].range);
  const { startLineNumber: t, endLineNumber: n } = e;
  t === n ? i.length === 1 ? Fs(C("hint11", "Made 1 formatting edit on line {0}", t)) : Fs(C("hintn1", "Made {0} formatting edits on line {1}", i.length, t)) : i.length === 1 ? Fs(C("hint1n", "Made 1 formatting edit between lines {0} and {1}", t, n)) : Fs(C("hintnn", "Made {0} formatting edits between lines {1} and {2}", i.length, t, n));
}
function Tme(i, e, t) {
  const n = [], r = new hXe(), s = i.ordered(t);
  for (const a of s)
    n.push(a), a.extensionId && r.add(a.extensionId);
  const o = e.ordered(t);
  for (const a of o) {
    if (a.extensionId) {
      if (r.has(a.extensionId))
        continue;
      r.add(a.extensionId);
    }
    n.push({
      displayName: a.displayName,
      extensionId: a.extensionId,
      provideDocumentFormattingEdits(l, c, d) {
        return a.provideDocumentRangeFormattingEdits(l, l.getFullModelRange(), c, d);
      }
    });
  }
  return n;
}
class r0 {
  static setFormatterSelector(e) {
    return { dispose: r0._selectors.unshift(e) };
  }
  static select(e, t, n) {
    return hd(this, void 0, void 0, function* () {
      if (e.length === 0)
        return;
      const r = Wt.first(r0._selectors);
      if (r)
        return yield r(e, t, n);
    });
  }
}
r0._selectors = new fo();
function Nme(i, e, t, n, r, s) {
  return hd(this, void 0, void 0, function* () {
    const o = i.get(bt), { documentRangeFormattingEditProvider: a } = i.get(tt), l = Au(e) ? e.getModel() : e, c = a.ordered(l), d = yield r0.select(c, l, n);
    d && (r.report(d), yield o.invokeFunction(fXe, d, e, t, s));
  });
}
function fXe(i, e, t, n, r) {
  var s, o;
  return hd(this, void 0, void 0, function* () {
    const a = i.get(vc), l = i.get(Ka);
    let c, d;
    Au(t) ? (c = t.getModel(), d = new Gg(t, 5, void 0, r)) : (c = t, d = new jU(t, r));
    const u = [];
    let h = 0;
    for (const _ of xj(n).sort(V.compareRangesUsingStarts))
      h > 0 && V.areIntersectingOrTouching(u[h - 1], _) ? u[h - 1] = V.fromPositions(u[h - 1].getStartPosition(), _.getEndPosition()) : h = u.push(_);
    const f = (_) => hd(this, void 0, void 0, function* () {
      var b, w;
      l.trace("[format][provideDocumentRangeFormattingEdits] (request)", (b = e.extensionId) === null || b === void 0 ? void 0 : b.value, _);
      const y = (yield e.provideDocumentRangeFormattingEdits(c, _, c.getFormattingOptions(), d.token)) || [];
      return l.trace("[format][provideDocumentRangeFormattingEdits] (response)", (w = e.extensionId) === null || w === void 0 ? void 0 : w.value, y), y;
    }), g = (_, b) => {
      if (!_.length || !b.length)
        return !1;
      const w = _.reduce((y, S) => V.plusRange(y, S.range), _[0].range);
      if (!b.some((y) => V.intersectRanges(w, y.range)))
        return !1;
      for (const y of _)
        for (const S of b)
          if (V.intersectRanges(y.range, S.range))
            return !0;
      return !1;
    }, p = [], m = [];
    try {
      if (typeof e.provideDocumentRangesFormattingEdits == "function") {
        l.trace("[format][provideDocumentRangeFormattingEdits] (request)", (s = e.extensionId) === null || s === void 0 ? void 0 : s.value, u);
        const _ = (yield e.provideDocumentRangesFormattingEdits(c, u, c.getFormattingOptions(), d.token)) || [];
        l.trace("[format][provideDocumentRangeFormattingEdits] (response)", (o = e.extensionId) === null || o === void 0 ? void 0 : o.value, _), m.push(_);
      } else {
        for (const _ of u) {
          if (d.token.isCancellationRequested)
            return !0;
          m.push(yield f(_));
        }
        for (let _ = 0; _ < u.length; ++_)
          for (let b = _ + 1; b < u.length; ++b) {
            if (d.token.isCancellationRequested)
              return !0;
            if (g(m[_], m[b])) {
              const w = V.plusRange(u[_], u[b]), y = yield f(w);
              u.splice(b, 1), u.splice(_, 1), u.push(w), m.splice(b, 1), m.splice(_, 1), m.push(y), _ = 0, b = 0;
            }
          }
      }
      for (const _ of m) {
        if (d.token.isCancellationRequested)
          return !0;
        const b = yield a.computeMoreMinimalEdits(c.uri, _);
        b && p.push(...b);
      }
    } finally {
      d.dispose();
    }
    if (p.length === 0)
      return !1;
    if (Au(t))
      R_.execute(t, p, !0), zU(p), t.revealPositionInCenterIfOutsideViewport(
        t.getPosition(),
        1
        /* ScrollType.Immediate */
      );
    else {
      const [{ range: _ }] = p, b = new ot(_.startLineNumber, _.startColumn, _.endLineNumber, _.endColumn);
      c.pushEditOperations([b], p.map((w) => ({
        text: w.text,
        range: V.lift(w.range),
        forceMoveMarkers: !0
      })), (w) => {
        for (const { range: y } of w)
          if (V.areIntersectingOrTouching(y, b))
            return [new ot(y.startLineNumber, y.startColumn, y.endLineNumber, y.endColumn)];
        return null;
      });
    }
    return !0;
  });
}
function gXe(i, e, t, n, r) {
  return hd(this, void 0, void 0, function* () {
    const s = i.get(bt), o = i.get(tt), a = Au(e) ? e.getModel() : e, l = Tme(o.documentFormattingEditProvider, o.documentRangeFormattingEditProvider, a), c = yield r0.select(l, a, t);
    c && (n.report(c), yield s.invokeFunction(pXe, c, e, t, r));
  });
}
function pXe(i, e, t, n, r) {
  return hd(this, void 0, void 0, function* () {
    const s = i.get(vc);
    let o, a;
    Au(t) ? (o = t.getModel(), a = new Gg(t, 5, void 0, r)) : (o = t, a = new jU(t, r));
    let l;
    try {
      const c = yield e.provideDocumentFormattingEdits(o, o.getFormattingOptions(), a.token);
      if (l = yield s.computeMoreMinimalEdits(o.uri, c), a.token.isCancellationRequested)
        return !0;
    } finally {
      a.dispose();
    }
    if (!l || l.length === 0)
      return !1;
    if (Au(t))
      R_.execute(
        t,
        l,
        n !== 2
        /* FormattingMode.Silent */
      ), n !== 2 && (zU(l), t.revealPositionInCenterIfOutsideViewport(
        t.getPosition(),
        1
        /* ScrollType.Immediate */
      ));
    else {
      const [{ range: c }] = l, d = new ot(c.startLineNumber, c.startColumn, c.endLineNumber, c.endColumn);
      o.pushEditOperations([d], l.map((u) => ({
        text: u.text,
        range: V.lift(u.range),
        forceMoveMarkers: !0
      })), (u) => {
        for (const { range: h } of u)
          if (V.areIntersectingOrTouching(h, d))
            return [new ot(h.startLineNumber, h.startColumn, h.endLineNumber, h.endColumn)];
        return null;
      });
    }
    return !0;
  });
}
function mXe(i, e, t, n, r, s) {
  return hd(this, void 0, void 0, function* () {
    const o = e.documentRangeFormattingEditProvider.ordered(t);
    for (const a of o) {
      const l = yield Promise.resolve(a.provideDocumentRangeFormattingEdits(t, n, r, s)).catch(vr);
      if (Bs(l))
        return yield i.computeMoreMinimalEdits(t.uri, l);
    }
  });
}
function vXe(i, e, t, n, r) {
  return hd(this, void 0, void 0, function* () {
    const s = Tme(e.documentFormattingEditProvider, e.documentRangeFormattingEditProvider, t);
    for (const o of s) {
      const a = yield Promise.resolve(o.provideDocumentFormattingEdits(t, n, r)).catch(vr);
      if (Bs(a))
        return yield i.computeMoreMinimalEdits(t.uri, a);
    }
  });
}
function Pme(i, e, t, n, r, s, o) {
  const a = e.onTypeFormattingEditProvider.ordered(t);
  return a.length === 0 || a[0].autoFormatTriggerCharacters.indexOf(r) < 0 ? Promise.resolve(void 0) : Promise.resolve(a[0].provideOnTypeFormattingEdits(t, n, r, s, o)).catch(vr).then((l) => i.computeMoreMinimalEdits(t.uri, l));
}
on.registerCommand("_executeFormatRangeProvider", function(i, ...e) {
  return hd(this, void 0, void 0, function* () {
    const [t, n, r] = e;
    On(pt.isUri(t)), On(V.isIRange(n));
    const s = i.get(Wo), o = i.get(vc), a = i.get(tt), l = yield s.createModelReference(t);
    try {
      return mXe(o, a, l.object.textEditorModel, V.lift(n), r, jt.None);
    } finally {
      l.dispose();
    }
  });
});
on.registerCommand("_executeFormatDocumentProvider", function(i, ...e) {
  return hd(this, void 0, void 0, function* () {
    const [t, n] = e;
    On(pt.isUri(t));
    const r = i.get(Wo), s = i.get(vc), o = i.get(tt), a = yield r.createModelReference(t);
    try {
      return vXe(s, o, a.object.textEditorModel, n, jt.None);
    } finally {
      a.dispose();
    }
  });
});
on.registerCommand("_executeFormatOnTypeProvider", function(i, ...e) {
  return hd(this, void 0, void 0, function* () {
    const [t, n, r, s] = e;
    On(pt.isUri(t)), On(ve.isIPosition(n)), On(typeof r == "string");
    const o = i.get(Wo), a = i.get(vc), l = i.get(tt), c = yield o.createModelReference(t);
    try {
      return Pme(a, l, c.object.textEditorModel, ve.lift(n), r, s, jt.None);
    } finally {
      c.dispose();
    }
  });
});
pd.wrappingIndent.defaultValue = 0;
pd.glyphMargin.defaultValue = !1;
pd.autoIndent.defaultValue = 3;
pd.overviewRulerLanes.defaultValue = 2;
r0.setFormatterSelector((i, e, t) => Promise.resolve(i[0]));
const yo = che();
yo.editor = bYe();
yo.languages = cXe();
const _Xe = yo.CancellationTokenSource, bXe = yo.Emitter, Ome = yo.KeyCode, Mme = yo.KeyMod, CXe = yo.Position, yXe = yo.Range, wXe = yo.Selection, SXe = yo.SelectionDirection, xXe = yo.MarkerSeverity, DXe = yo.MarkerTag, EXe = yo.Uri, LXe = yo.Token, Wr = yo.editor, IXe = yo.languages, bT = globalThis.MonacoEnvironment;
(bT?.globalAPI || typeof define == "function" && define.amd) && (globalThis.monaco = yo);
typeof globalThis.require < "u" && typeof globalThis.require.config == "function" && globalThis.require.config({
  ignoreDuplicateModules: [
    "vscode-languageserver-types",
    "vscode-languageserver-types/main",
    "vscode-languageserver-textdocument",
    "vscode-languageserver-textdocument/main",
    "vscode-nls",
    "vscode-nls/vscode-nls",
    "jsonc-parser",
    "jsonc-parser/main",
    "vscode-uri",
    "vscode-uri/index",
    "vs/basic-languages/typescript/typescript"
  ]
});
const Qo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CancellationTokenSource: _Xe,
  Emitter: bXe,
  KeyCode: Ome,
  KeyMod: Mme,
  MarkerSeverity: xXe,
  MarkerTag: DXe,
  Position: CXe,
  Range: yXe,
  Selection: wXe,
  SelectionDirection: SXe,
  Token: LXe,
  Uri: EXe,
  editor: Wr,
  languages: IXe
}, Symbol.toStringTag, { value: "Module" }));
function uI(i) {
  return /^\d+$/.test(i) ? "".concat(i, "px") : i;
}
function sg() {
}
var nm = function() {
  return nm = Object.assign || function(i) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (i[r] = e[r]);
    }
    return i;
  }, nm.apply(this, arguments);
};
function UU(i) {
  var e = i.width, t = i.height, n = i.value, r = i.defaultValue, s = i.language, o = i.theme, a = i.options, l = i.overrideServices, c = i.editorWillMount, d = i.editorDidMount, u = i.editorWillUnmount, h = i.onChange, f = i.className, g = i.original, p = i.originalUri, m = i.modifiedUri, _ = Nt(null), b = Nt(null), w = Nt(null), y = Nt(null), S = uI(e), x = uI(t), D = Mn(function() {
    return {
      width: S,
      height: x
    };
  }, [S, x]), E = function() {
    var I = c(Qo);
    return I || {};
  }, L = function() {
    d(b.current, Qo);
    var I = b.current.getModel().modified;
    w.current = I.onDidChangeContent(function(A) {
      y.current || h(I.getValue(), A);
    });
  }, k = function() {
    u(b.current, Qo);
  }, N = function() {
    var I = n ?? r, A = p?.(Qo), P = m?.(Qo), O = A && Wr.getModel(A), K = P && Wr.getModel(P);
    O ? (O.setValue(g), Wr.setModelLanguage(O, s)) : O = Wr.createModel(I, s, A), K ? (O.setValue(I), Wr.setModelLanguage(K, s)) : K = Wr.createModel(I, s, P), b.current.setModel({
      original: O,
      modified: K
    });
  };
  return $e(
    function() {
      _.current && (E(), b.current = Wr.createDiffEditor(_.current, nm(nm(nm({}, f ? { extraEditorClassName: f } : {}), a), o ? { theme: o } : {}), l), N(), L());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), $e(function() {
    b.current && b.current.updateOptions(nm(nm({}, f ? { extraEditorClassName: f } : {}), a));
  }, [f, a]), $e(function() {
    b.current && b.current.layout();
  }, [e, t]), $e(function() {
    if (b.current) {
      var I = b.current.getModel(), A = I.original, P = I.modified;
      Wr.setModelLanguage(A, s), Wr.setModelLanguage(P, s);
    }
  }, [s]), $e(function() {
    if (b.current) {
      var I = b.current.getModel().modified;
      y.current = !0, b.current.getModifiedEditor().pushUndoStop(), I.pushEditOperations([], [
        {
          range: I.getFullModelRange(),
          text: n
        }
      ]), b.current.getModifiedEditor().pushUndoStop(), y.current = !1;
    }
  }, [n]), $e(function() {
    Wr.setTheme(o);
  }, [o]), $e(function() {
    if (b.current) {
      var I = b.current.getModel().original;
      g !== I.getValue() && I.setValue(g);
    }
  }, [g]), $e(
    function() {
      return function() {
        if (b.current) {
          k(), b.current.dispose();
          var I = b.current.getModel(), A = I.original, P = I.modified;
          A && A.dispose(), P && P.dispose();
        }
        w.current && w.current.dispose();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), G.createElement("div", { ref: _, style: D, className: "react-monaco-editor-container" });
}
UU.defaultProps = {
  width: "100%",
  height: "100%",
  original: null,
  value: null,
  defaultValue: "",
  language: "javascript",
  theme: null,
  options: {},
  overrideServices: {},
  editorWillMount: sg,
  editorDidMount: sg,
  editorWillUnmount: sg,
  onChange: sg,
  className: null
};
UU.displayName = "MonacoDiffEditor";
var sh = function() {
  return sh = Object.assign || function(i) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (i[r] = e[r]);
    }
    return i;
  }, sh.apply(this, arguments);
}, AXe = function(i, e) {
  var t = {};
  for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && e.indexOf(n) < 0 && (t[n] = i[n]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(i); r < n.length; r++)
      e.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(i, n[r]) && (t[n[r]] = i[n[r]]);
  return t;
};
function GU(i) {
  var e = i.width, t = i.height, n = i.value, r = i.defaultValue, s = i.language, o = i.theme, a = i.options, l = i.overrideServices, c = i.editorWillMount, d = i.editorDidMount, u = i.editorWillUnmount, h = i.onChange, f = i.className, g = i.uri, p = Nt(null), m = Nt(null), _ = Nt(null), b = Nt(null), w = uI(e), y = uI(t), S = Mn(function() {
    return {
      width: w,
      height: y
    };
  }, [w, y]), x = function() {
    var k = c(Qo);
    return k || {};
  }, D = function() {
    d(m.current, Qo), _.current = m.current.onDidChangeModelContent(function(k) {
      b.current || h(m.current.getValue(), k);
    });
  }, E = function() {
    u(m.current, Qo);
  }, L = function() {
    var k = n !== null ? n : r;
    if (p.current) {
      var N = sh(sh({}, a), x()), I = g?.(Qo), A = I && Wr.getModel(I);
      A ? (A.setValue(k), Wr.setModelLanguage(A, s)) : A = Wr.createModel(k, s, I), m.current = Wr.create(p.current, sh(sh(sh({ model: A }, f ? { extraEditorClassName: f } : {}), N), o ? { theme: o } : {}), l), D();
    }
  };
  return $e(L, []), $e(function() {
    if (m.current) {
      if (n === m.current.getValue())
        return;
      var k = m.current.getModel();
      b.current = !0, m.current.pushUndoStop(), k.pushEditOperations([], [
        {
          range: k.getFullModelRange(),
          text: n
        }
      ], void 0), m.current.pushUndoStop(), b.current = !1;
    }
  }, [n]), $e(function() {
    if (m.current) {
      var k = m.current.getModel();
      Wr.setModelLanguage(k, s);
    }
  }, [s]), $e(function() {
    if (m.current) {
      a.model;
      var k = AXe(a, ["model"]);
      m.current.updateOptions(sh(sh({}, f ? { extraEditorClassName: f } : {}), k));
    }
  }, [f, a]), $e(function() {
    m.current && m.current.layout();
  }, [e, t]), $e(function() {
    Wr.setTheme(o);
  }, [o]), $e(
    function() {
      return function() {
        if (m.current) {
          E(), m.current.dispose();
          var k = m.current.getModel();
          k && k.dispose();
        }
        _.current && _.current.dispose();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), G.createElement("div", { ref: p, style: S, className: "react-monaco-editor-container" });
}
GU.defaultProps = {
  width: "100%",
  height: "100%",
  value: null,
  defaultValue: "",
  language: "javascript",
  theme: null,
  options: {},
  overrideServices: {},
  editorWillMount: sg,
  editorDidMount: sg,
  editorWillUnmount: sg,
  onChange: sg,
  className: null
};
GU.displayName = "MonacoEditor";
function s$(i, e, t) {
  const n = /* @__PURE__ */ new Map(), r = (u) => {
    const h = u.getLanguageId();
    return Array.isArray(e) ? e.includes(h) : e === h;
  }, s = async (u) => {
    const h = u.getVersionId(), f = await t.provideMarkerData(u);
    h === u.getVersionId() && !u.isDisposed() && r(u) && i.editor.setModelMarkers(u, t.owner, f ?? []);
  }, o = (u) => {
    if (!r(u))
      return;
    let h;
    const f = u.onDidChangeContent(() => {
      clearTimeout(h), h = setTimeout(() => {
        s(u);
      }, 500);
    });
    n.set(u, {
      dispose() {
        clearTimeout(h), f.dispose();
      }
    }), s(u);
  }, a = (u) => {
    i.editor.setModelMarkers(u, t.owner, []);
    const h = n.get(u);
    h && (h.dispose(), n.delete(u));
  }, l = i.editor.onDidCreateModel(o), c = i.editor.onWillDisposeModel((u) => {
    a(u), t.doReset?.(u);
  }), d = i.editor.onDidChangeModelLanguage(({ model: u }) => {
    a(u), o(u), t.doReset?.(u);
  });
  for (const u of i.editor.getModels())
    o(u);
  return {
    dispose() {
      for (const u of n.keys())
        a(u);
      l.dispose(), c.dispose(), d.dispose();
    },
    async revalidate() {
      await Promise.all(i.editor.getModels().map(s));
    }
  };
}
function kXe(i, e) {
  let { createData: t, interval: n = 3e4, label: r, moduleId: s, stopWhenIdleFor: o = 12e4 } = e, a, l = 0, c = !1;
  const d = () => {
    a && (a.dispose(), a = void 0);
  }, u = setInterval(() => {
    if (!a)
      return;
    Date.now() - l > o && d();
  }, n);
  return {
    dispose() {
      c = !0, clearInterval(u), d();
    },
    getWorker(...h) {
      if (c)
        throw new Error("Worker manager has been disposed");
      return l = Date.now(), a || (a = i.editor.createWebWorker({
        createData: t,
        label: r,
        moduleId: s
      })), a.withSyncedResources(h);
    },
    updateCreateData(h) {
      t = h, d();
    }
  };
}
var Rme;
(() => {
  var i = { 470: (r) => {
    function s(l) {
      if (typeof l != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(l));
    }
    function o(l, c) {
      for (var d, u = "", h = 0, f = -1, g = 0, p = 0; p <= l.length; ++p) {
        if (p < l.length) d = l.charCodeAt(p);
        else {
          if (d === 47) break;
          d = 47;
        }
        if (d === 47) {
          if (!(f === p - 1 || g === 1)) if (f !== p - 1 && g === 2) {
            if (u.length < 2 || h !== 2 || u.charCodeAt(u.length - 1) !== 46 || u.charCodeAt(u.length - 2) !== 46) {
              if (u.length > 2) {
                var m = u.lastIndexOf("/");
                if (m !== u.length - 1) {
                  m === -1 ? (u = "", h = 0) : h = (u = u.slice(0, m)).length - 1 - u.lastIndexOf("/"), f = p, g = 0;
                  continue;
                }
              } else if (u.length === 2 || u.length === 1) {
                u = "", h = 0, f = p, g = 0;
                continue;
              }
            }
            c && (u.length > 0 ? u += "/.." : u = "..", h = 2);
          } else u.length > 0 ? u += "/" + l.slice(f + 1, p) : u = l.slice(f + 1, p), h = p - f - 1;
          f = p, g = 0;
        } else d === 46 && g !== -1 ? ++g : g = -1;
      }
      return u;
    }
    var a = { resolve: function() {
      for (var l, c = "", d = !1, u = arguments.length - 1; u >= -1 && !d; u--) {
        var h;
        u >= 0 ? h = arguments[u] : (l === void 0 && (l = process.cwd()), h = l), s(h), h.length !== 0 && (c = h + "/" + c, d = h.charCodeAt(0) === 47);
      }
      return c = o(c, !d), d ? c.length > 0 ? "/" + c : "/" : c.length > 0 ? c : ".";
    }, normalize: function(l) {
      if (s(l), l.length === 0) return ".";
      var c = l.charCodeAt(0) === 47, d = l.charCodeAt(l.length - 1) === 47;
      return (l = o(l, !c)).length !== 0 || c || (l = "."), l.length > 0 && d && (l += "/"), c ? "/" + l : l;
    }, isAbsolute: function(l) {
      return s(l), l.length > 0 && l.charCodeAt(0) === 47;
    }, join: function() {
      if (arguments.length === 0) return ".";
      for (var l, c = 0; c < arguments.length; ++c) {
        var d = arguments[c];
        s(d), d.length > 0 && (l === void 0 ? l = d : l += "/" + d);
      }
      return l === void 0 ? "." : a.normalize(l);
    }, relative: function(l, c) {
      if (s(l), s(c), l === c || (l = a.resolve(l)) === (c = a.resolve(c))) return "";
      for (var d = 1; d < l.length && l.charCodeAt(d) === 47; ++d) ;
      for (var u = l.length, h = u - d, f = 1; f < c.length && c.charCodeAt(f) === 47; ++f) ;
      for (var g = c.length - f, p = h < g ? h : g, m = -1, _ = 0; _ <= p; ++_) {
        if (_ === p) {
          if (g > p) {
            if (c.charCodeAt(f + _) === 47) return c.slice(f + _ + 1);
            if (_ === 0) return c.slice(f + _);
          } else h > p && (l.charCodeAt(d + _) === 47 ? m = _ : _ === 0 && (m = 0));
          break;
        }
        var b = l.charCodeAt(d + _);
        if (b !== c.charCodeAt(f + _)) break;
        b === 47 && (m = _);
      }
      var w = "";
      for (_ = d + m + 1; _ <= u; ++_) _ !== u && l.charCodeAt(_) !== 47 || (w.length === 0 ? w += ".." : w += "/..");
      return w.length > 0 ? w + c.slice(f + m) : (f += m, c.charCodeAt(f) === 47 && ++f, c.slice(f));
    }, _makeLong: function(l) {
      return l;
    }, dirname: function(l) {
      if (s(l), l.length === 0) return ".";
      for (var c = l.charCodeAt(0), d = c === 47, u = -1, h = !0, f = l.length - 1; f >= 1; --f) if ((c = l.charCodeAt(f)) === 47) {
        if (!h) {
          u = f;
          break;
        }
      } else h = !1;
      return u === -1 ? d ? "/" : "." : d && u === 1 ? "//" : l.slice(0, u);
    }, basename: function(l, c) {
      if (c !== void 0 && typeof c != "string") throw new TypeError('"ext" argument must be a string');
      s(l);
      var d, u = 0, h = -1, f = !0;
      if (c !== void 0 && c.length > 0 && c.length <= l.length) {
        if (c.length === l.length && c === l) return "";
        var g = c.length - 1, p = -1;
        for (d = l.length - 1; d >= 0; --d) {
          var m = l.charCodeAt(d);
          if (m === 47) {
            if (!f) {
              u = d + 1;
              break;
            }
          } else p === -1 && (f = !1, p = d + 1), g >= 0 && (m === c.charCodeAt(g) ? --g == -1 && (h = d) : (g = -1, h = p));
        }
        return u === h ? h = p : h === -1 && (h = l.length), l.slice(u, h);
      }
      for (d = l.length - 1; d >= 0; --d) if (l.charCodeAt(d) === 47) {
        if (!f) {
          u = d + 1;
          break;
        }
      } else h === -1 && (f = !1, h = d + 1);
      return h === -1 ? "" : l.slice(u, h);
    }, extname: function(l) {
      s(l);
      for (var c = -1, d = 0, u = -1, h = !0, f = 0, g = l.length - 1; g >= 0; --g) {
        var p = l.charCodeAt(g);
        if (p !== 47) u === -1 && (h = !1, u = g + 1), p === 46 ? c === -1 ? c = g : f !== 1 && (f = 1) : c !== -1 && (f = -1);
        else if (!h) {
          d = g + 1;
          break;
        }
      }
      return c === -1 || u === -1 || f === 0 || f === 1 && c === u - 1 && c === d + 1 ? "" : l.slice(c, u);
    }, format: function(l) {
      if (l === null || typeof l != "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof l);
      return function(c, d) {
        var u = d.dir || d.root, h = d.base || (d.name || "") + (d.ext || "");
        return u ? u === d.root ? u + h : u + "/" + h : h;
      }(0, l);
    }, parse: function(l) {
      s(l);
      var c = { root: "", dir: "", base: "", ext: "", name: "" };
      if (l.length === 0) return c;
      var d, u = l.charCodeAt(0), h = u === 47;
      h ? (c.root = "/", d = 1) : d = 0;
      for (var f = -1, g = 0, p = -1, m = !0, _ = l.length - 1, b = 0; _ >= d; --_) if ((u = l.charCodeAt(_)) !== 47) p === -1 && (m = !1, p = _ + 1), u === 46 ? f === -1 ? f = _ : b !== 1 && (b = 1) : f !== -1 && (b = -1);
      else if (!m) {
        g = _ + 1;
        break;
      }
      return f === -1 || p === -1 || b === 0 || b === 1 && f === p - 1 && f === g + 1 ? p !== -1 && (c.base = c.name = g === 0 && h ? l.slice(1, p) : l.slice(g, p)) : (g === 0 && h ? (c.name = l.slice(1, f), c.base = l.slice(1, p)) : (c.name = l.slice(g, f), c.base = l.slice(g, p)), c.ext = l.slice(f, p)), g > 0 ? c.dir = l.slice(0, g - 1) : h && (c.dir = "/"), c;
    }, sep: "/", delimiter: ":", win32: null, posix: null };
    a.posix = a, r.exports = a;
  } }, e = {};
  function t(r) {
    var s = e[r];
    if (s !== void 0) return s.exports;
    var o = e[r] = { exports: {} };
    return i[r](o, o.exports, t), o.exports;
  }
  t.d = (r, s) => {
    for (var o in s) t.o(s, o) && !t.o(r, o) && Object.defineProperty(r, o, { enumerable: !0, get: s[o] });
  }, t.o = (r, s) => Object.prototype.hasOwnProperty.call(r, s), t.r = (r) => {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(r, "__esModule", { value: !0 });
  };
  var n = {};
  (() => {
    let r;
    t.r(n), t.d(n, { URI: () => h, Utils: () => k }), typeof process == "object" ? r = process.platform === "win32" : typeof navigator == "object" && (r = navigator.userAgent.indexOf("Windows") >= 0);
    const s = /^\w[\w\d+.-]*$/, o = /^\//, a = /^\/\//;
    function l(N, I) {
      if (!N.scheme && I) throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${N.authority}", path: "${N.path}", query: "${N.query}", fragment: "${N.fragment}"}`);
      if (N.scheme && !s.test(N.scheme)) throw new Error("[UriError]: Scheme contains illegal characters.");
      if (N.path) {
        if (N.authority) {
          if (!o.test(N.path)) throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
        } else if (a.test(N.path)) throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
      }
    }
    const c = "", d = "/", u = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
    class h {
      constructor(I, A, P, O, K, W = !1) {
        gn(this, "scheme");
        gn(this, "authority");
        gn(this, "path");
        gn(this, "query");
        gn(this, "fragment");
        typeof I == "object" ? (this.scheme = I.scheme || c, this.authority = I.authority || c, this.path = I.path || c, this.query = I.query || c, this.fragment = I.fragment || c) : (this.scheme = /* @__PURE__ */ function(F, q) {
          return F || q ? F : "file";
        }(I, W), this.authority = A || c, this.path = function(F, q) {
          switch (F) {
            case "https":
            case "http":
            case "file":
              q ? q[0] !== d && (q = d + q) : q = d;
          }
          return q;
        }(this.scheme, P || c), this.query = O || c, this.fragment = K || c, l(this, W));
      }
      static isUri(I) {
        return I instanceof h || !!I && typeof I.authority == "string" && typeof I.fragment == "string" && typeof I.path == "string" && typeof I.query == "string" && typeof I.scheme == "string" && typeof I.fsPath == "string" && typeof I.with == "function" && typeof I.toString == "function";
      }
      get fsPath() {
        return b(this);
      }
      with(I) {
        if (!I) return this;
        let { scheme: A, authority: P, path: O, query: K, fragment: W } = I;
        return A === void 0 ? A = this.scheme : A === null && (A = c), P === void 0 ? P = this.authority : P === null && (P = c), O === void 0 ? O = this.path : O === null && (O = c), K === void 0 ? K = this.query : K === null && (K = c), W === void 0 ? W = this.fragment : W === null && (W = c), A === this.scheme && P === this.authority && O === this.path && K === this.query && W === this.fragment ? this : new g(A, P, O, K, W);
      }
      static parse(I, A = !1) {
        const P = u.exec(I);
        return P ? new g(P[2] || c, x(P[4] || c), x(P[5] || c), x(P[7] || c), x(P[9] || c), A) : new g(c, c, c, c, c);
      }
      static file(I) {
        let A = c;
        if (r && (I = I.replace(/\\/g, d)), I[0] === d && I[1] === d) {
          const P = I.indexOf(d, 2);
          P === -1 ? (A = I.substring(2), I = d) : (A = I.substring(2, P), I = I.substring(P) || d);
        }
        return new g("file", A, I, c, c);
      }
      static from(I) {
        const A = new g(I.scheme, I.authority, I.path, I.query, I.fragment);
        return l(A, !0), A;
      }
      toString(I = !1) {
        return w(this, I);
      }
      toJSON() {
        return this;
      }
      static revive(I) {
        if (I) {
          if (I instanceof h) return I;
          {
            const A = new g(I);
            return A._formatted = I.external, A._fsPath = I._sep === f ? I.fsPath : null, A;
          }
        }
        return I;
      }
    }
    const f = r ? 1 : void 0;
    class g extends h {
      constructor() {
        super(...arguments);
        gn(this, "_formatted", null);
        gn(this, "_fsPath", null);
      }
      get fsPath() {
        return this._fsPath || (this._fsPath = b(this)), this._fsPath;
      }
      toString(A = !1) {
        return A ? w(this, !0) : (this._formatted || (this._formatted = w(this, !1)), this._formatted);
      }
      toJSON() {
        const A = { $mid: 1 };
        return this._fsPath && (A.fsPath = this._fsPath, A._sep = f), this._formatted && (A.external = this._formatted), this.path && (A.path = this.path), this.scheme && (A.scheme = this.scheme), this.authority && (A.authority = this.authority), this.query && (A.query = this.query), this.fragment && (A.fragment = this.fragment), A;
      }
    }
    const p = { 58: "%3A", 47: "%2F", 63: "%3F", 35: "%23", 91: "%5B", 93: "%5D", 64: "%40", 33: "%21", 36: "%24", 38: "%26", 39: "%27", 40: "%28", 41: "%29", 42: "%2A", 43: "%2B", 44: "%2C", 59: "%3B", 61: "%3D", 32: "%20" };
    function m(N, I, A) {
      let P, O = -1;
      for (let K = 0; K < N.length; K++) {
        const W = N.charCodeAt(K);
        if (W >= 97 && W <= 122 || W >= 65 && W <= 90 || W >= 48 && W <= 57 || W === 45 || W === 46 || W === 95 || W === 126 || I && W === 47 || A && W === 91 || A && W === 93 || A && W === 58) O !== -1 && (P += encodeURIComponent(N.substring(O, K)), O = -1), P !== void 0 && (P += N.charAt(K));
        else {
          P === void 0 && (P = N.substr(0, K));
          const F = p[W];
          F !== void 0 ? (O !== -1 && (P += encodeURIComponent(N.substring(O, K)), O = -1), P += F) : O === -1 && (O = K);
        }
      }
      return O !== -1 && (P += encodeURIComponent(N.substring(O))), P !== void 0 ? P : N;
    }
    function _(N) {
      let I;
      for (let A = 0; A < N.length; A++) {
        const P = N.charCodeAt(A);
        P === 35 || P === 63 ? (I === void 0 && (I = N.substr(0, A)), I += p[P]) : I !== void 0 && (I += N[A]);
      }
      return I !== void 0 ? I : N;
    }
    function b(N, I) {
      let A;
      return A = N.authority && N.path.length > 1 && N.scheme === "file" ? `//${N.authority}${N.path}` : N.path.charCodeAt(0) === 47 && (N.path.charCodeAt(1) >= 65 && N.path.charCodeAt(1) <= 90 || N.path.charCodeAt(1) >= 97 && N.path.charCodeAt(1) <= 122) && N.path.charCodeAt(2) === 58 ? N.path[1].toLowerCase() + N.path.substr(2) : N.path, r && (A = A.replace(/\//g, "\\")), A;
    }
    function w(N, I) {
      const A = I ? _ : m;
      let P = "", { scheme: O, authority: K, path: W, query: F, fragment: q } = N;
      if (O && (P += O, P += ":"), (K || O === "file") && (P += d, P += d), K) {
        let R = K.indexOf("@");
        if (R !== -1) {
          const T = K.substr(0, R);
          K = K.substr(R + 1), R = T.lastIndexOf(":"), R === -1 ? P += A(T, !1, !1) : (P += A(T.substr(0, R), !1, !1), P += ":", P += A(T.substr(R + 1), !1, !0)), P += "@";
        }
        K = K.toLowerCase(), R = K.lastIndexOf(":"), R === -1 ? P += A(K, !1, !0) : (P += A(K.substr(0, R), !1, !0), P += K.substr(R));
      }
      if (W) {
        if (W.length >= 3 && W.charCodeAt(0) === 47 && W.charCodeAt(2) === 58) {
          const R = W.charCodeAt(1);
          R >= 65 && R <= 90 && (W = `/${String.fromCharCode(R + 32)}:${W.substr(3)}`);
        } else if (W.length >= 2 && W.charCodeAt(1) === 58) {
          const R = W.charCodeAt(0);
          R >= 65 && R <= 90 && (W = `${String.fromCharCode(R + 32)}:${W.substr(2)}`);
        }
        P += A(W, !0, !1);
      }
      return F && (P += "?", P += A(F, !1, !1)), q && (P += "#", P += I ? q : m(q, !1, !1)), P;
    }
    function y(N) {
      try {
        return decodeURIComponent(N);
      } catch {
        return N.length > 3 ? N.substr(0, 3) + y(N.substr(3)) : N;
      }
    }
    const S = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
    function x(N) {
      return N.match(S) ? N.replace(S, (I) => y(I)) : N;
    }
    var D = t(470);
    const E = D.posix || D, L = "/";
    var k;
    (function(N) {
      N.joinPath = function(I, ...A) {
        return I.with({ path: E.join(I.path, ...A) });
      }, N.resolvePath = function(I, ...A) {
        let P = I.path, O = !1;
        P[0] !== L && (P = L + P, O = !0);
        let K = E.resolve(P, ...A);
        return O && K[0] === L && !I.authority && (K = K.substring(1)), I.with({ path: K });
      }, N.dirname = function(I) {
        if (I.path.length === 0 || I.path === L) return I;
        let A = E.dirname(I.path);
        return A.length === 1 && A.charCodeAt(0) === 46 && (A = ""), I.with({ path: A });
      }, N.basename = function(I) {
        return E.basename(I.path);
      }, N.extname = function(I) {
        return E.extname(I.path);
      };
    })(k || (k = {}));
  })(), Rme = n;
})();
const { URI: Nh, Utils: VCt } = Rme;
function TXe(i) {
  return i === 8 ? 1 : i === 4 ? 2 : i === 2 ? 3 : 4;
}
function NXe(i) {
  return i === 1 ? 8 : i === 2 ? 4 : i === 3 ? 2 : 1;
}
function PXe(i) {
  return i;
}
function OXe(i) {
  return i;
}
function qU(i) {
  return {
    start: { line: i.startLineNumber - 1, character: i.startColumn - 1 },
    end: { line: i.endLineNumber - 1, character: i.endColumn - 1 }
  };
}
function ta(i) {
  return {
    startLineNumber: i.start.line + 1,
    startColumn: i.start.character + 1,
    endLineNumber: i.end.line + 1,
    endColumn: i.end.character + 1
  };
}
function MXe(i) {
  return {
    location: {
      range: qU(i),
      uri: String(i.resource)
    },
    message: i.message
  };
}
function RXe(i) {
  return {
    ...ta(i.location.range),
    message: i.message,
    resource: Nh.parse(i.location.uri)
  };
}
function FXe(i) {
  const e = {
    message: i.message,
    range: qU(i),
    severity: TXe(i.severity)
  };
  return typeof i.code == "string" ? e.code = i.code : i.code != null && (e.code = i.code.value, e.codeDescription = { href: String(i.code.target) }), i.relatedInformation && (e.relatedInformation = i.relatedInformation.map(MXe)), i.tags && (e.tags = i.tags.map(PXe)), i.source != null && (e.source = i.source), e;
}
function Fme(i, e) {
  var t;
  const n = {
    ...ta(i.range),
    message: i.message,
    severity: i.severity ? NXe(i.severity) : (t = void 0) !== null && t !== void 0 ? t : 8
  };
  return i.code != null && (n.code = i.codeDescription == null ? String(i.code) : { value: String(i.code), target: Nh.parse(i.codeDescription.href) }), i.relatedInformation && (n.relatedInformation = i.relatedInformation.map(RXe)), i.tags && (n.tags = i.tags.map(OXe)), i.source != null && (n.source = i.source), n;
}
function Bme(i) {
  return {
    range: ta(i.range),
    text: i.newText
  };
}
function BXe(i) {
  const e = {};
  return i.ignoreIfExists != null && (e.ignoreIfExists = i.ignoreIfExists), i.ignoreIfNotExists != null && (e.ignoreIfNotExists = i.ignoreIfNotExists), i.overwrite != null && (e.overwrite = i.overwrite), i.recursive != null && (e.recursive = i.recursive), e;
}
function VXe(i) {
  const e = i.kind === "create" ? { newResource: Nh.parse(i.uri) } : i.kind === "delete" ? { oldResource: Nh.parse(i.uri) } : {
    oldResource: Nh.parse(i.oldUri),
    newResource: Nh.parse(i.newUri)
  };
  return i.options && (e.options = BXe(i.options)), e;
}
function o$(i, e, t) {
  return {
    resource: Nh.parse(e),
    versionId: t,
    textEdit: Bme(i)
  };
}
function HXe(i) {
  var e;
  const t = [];
  if (i.changes)
    for (const [n, r] of Object.entries(i.changes))
      for (const s of r)
        t.push(o$(s, n));
  if (i.documentChanges)
    for (const n of i.documentChanges)
      if ("textDocument" in n)
        for (const r of n.edits)
          t.push(o$(r, n.textDocument.uri, (e = n.textDocument.version) !== null && e !== void 0 ? e : void 0));
      else
        t.push(VXe(n));
  return {
    edits: t
  };
}
function WXe(i, e) {
  const t = {
    title: i.title,
    isPreferred: i.isPreferred
  };
  return i.diagnostics && (t.diagnostics = i.diagnostics.map((n) => Fme(n))), i.disabled && (t.disabled = i.disabled.reason), i.edit && (t.edit = HXe(i.edit)), i.isPreferred != null && (t.isPreferred = i.isPreferred), i.kind && (t.kind = i.kind), t;
}
function jXe(i) {
  const e = {
    diagnostics: i.markers.map(FXe),
    triggerKind: i.trigger
  };
  return i.only != null && (e.only = [i.only]), e;
}
function zXe(i) {
  const e = {
    title: i.title,
    id: i.command
  };
  return i.arguments && (e.arguments = i.arguments), e;
}
function UXe(i) {
  return i === 1 ? 18 : i === 2 ? 0 : i === 3 ? 1 : i === 4 ? 2 : i === 5 ? 3 : i === 6 ? 4 : i === 7 ? 5 : i === 8 ? 7 : i === 9 ? 8 : i === 10 ? 9 : i === 11 ? 12 : i === 12 ? 13 : i === 13 ? 15 : i === 14 ? 17 : i === 15 ? 27 : i === 16 ? 19 : i === 17 ? 20 : i === 18 ? 21 : i === 19 ? 23 : i === 20 ? 16 : i === 21 ? 14 : i === 22 ? 6 : i === 23 ? 10 : i === 24 ? 11 : 24;
}
function GXe(i) {
  return i;
}
function Vme(i) {
  return {
    value: i.value
  };
}
function qXe(i) {
  return {
    range: ta(i.range),
    text: i.newText
  };
}
function KXe(i) {
  return "range" in i ? ta(i.range) : "insert" in i && "replace" in i ? {
    insert: ta(i.insert),
    replace: ta(i.replace)
  } : ta(i);
}
function YXe(i, e) {
  var t, n, r, s, o;
  const a = (t = e.itemDefaults) !== null && t !== void 0 ? t : {}, l = (n = i.textEdit) !== null && n !== void 0 ? n : a.editRange, c = (r = i.commitCharacters) !== null && r !== void 0 ? r : a.commitCharacters, d = (s = i.insertTextFormat) !== null && s !== void 0 ? s : a.insertTextFormat, u = (o = i.insertTextMode) !== null && o !== void 0 ? o : a.insertTextMode;
  let h = i.insertText, f;
  l ? (f = KXe(l), "newText" in l && (h = l.newText)) : f = { ...e.range };
  const g = {
    insertText: h ?? i.label,
    kind: i.kind == null ? 18 : UXe(i.kind),
    label: i.label,
    range: f
  };
  return i.additionalTextEdits && (g.additionalTextEdits = i.additionalTextEdits.map(qXe)), i.command && (g.command = zXe(i.command)), c && (g.commitCharacters = c), i.detail != null && (g.detail = i.detail), typeof i.documentation == "string" ? g.documentation = i.documentation : i.documentation && (g.documentation = Vme(i.documentation)), i.filterText != null && (g.filterText = i.filterText), d === 2 ? g.insertTextRules = 4 : u === 2 && (g.insertTextRules = 1), i.preselect != null && (g.preselect = i.preselect), i.sortText != null && (g.sortText = i.sortText), i.tags && (g.tags = i.tags.map(GXe)), g;
}
function XXe(i, e) {
  return {
    incomplete: !!i.isIncomplete,
    suggestions: i.items.map((t) => YXe(t, { range: e.range, itemDefaults: i.itemDefaults }))
  };
}
function ZXe(i) {
  return i === 1 ? 0 : i === 2 ? 1 : i === 3 ? 2 : i === 4 ? 3 : i === 5 ? 4 : i === 6 ? 5 : i === 7 ? 6 : i === 8 ? 7 : i === 9 ? 8 : i === 10 ? 9 : i === 11 ? 10 : i === 12 ? 11 : i === 13 ? 12 : i === 14 ? 13 : i === 15 ? 14 : i === 16 ? 15 : i === 17 ? 16 : i === 18 ? 17 : i === 19 ? 18 : i === 20 ? 19 : i === 21 ? 20 : i === 22 ? 21 : i === 23 ? 22 : i === 24 ? 23 : i === 25 ? 24 : 25;
}
function QXe(i) {
  return i;
}
function Hme(i) {
  var e, t, n;
  const r = {
    detail: (e = i.detail) !== null && e !== void 0 ? e : "",
    kind: ZXe(i.kind),
    name: i.name,
    range: ta(i.range),
    selectionRange: ta(i.selectionRange),
    tags: (n = (t = i.tags) === null || t === void 0 ? void 0 : t.map(QXe)) !== null && n !== void 0 ? n : []
  };
  return i.children && (r.children = i.children.map(Hme)), r;
}
function JXe(i) {
  const e = {
    start: i.startLine + 1,
    end: i.endLine + 1
  };
  return i.kind != null && (e.kind = { value: i.kind }), e;
}
function a$(i) {
  return typeof i == "string" ? { value: i } : { value: `\`\`\`${i.language}
${i.value}
\`\`\`` };
}
function $Xe(i) {
  return typeof i == "string" || "language" in i ? [a$(i)] : Array.isArray(i) ? i.map(a$) : [Vme(i)];
}
function eZe(i) {
  const e = {
    contents: $Xe(i.contents)
  };
  return i.range && (e.range = ta(i.range)), e;
}
function KU(i) {
  return { character: i.column - 1, line: i.lineNumber - 1 };
}
function tZe(i) {
  const e = {
    range: ta(i.range)
  };
  return i.tooltip != null && (e.tooltip = i.tooltip), i.target != null && (e.url = Nh.parse(i.target)), e;
}
function nZe(i) {
  const e = {
    range: ta(i.targetRange),
    targetSelectionRange: ta(i.targetSelectionRange),
    uri: Nh.parse(i.targetUri)
  };
  return i.originSelectionRange && (e.originSelectionRange = ta(i.originSelectionRange)), e;
}
function l$(i) {
  return {
    owner: "yaml",
    async provideMarkerData(e) {
      const n = await (await i(e.uri)).doValidation(String(e.uri));
      return n?.map((r) => Fme(r));
    },
    async doReset(e) {
      await (await i(e.uri)).resetSchema(String(e.uri));
    }
  };
}
function iZe(i) {
  return {
    triggerCharacters: [" ", ":"],
    async provideCompletionItems(e, t) {
      const n = e.uri, r = e.getWordUntilPosition(t), o = await (await i(n)).doComplete(String(n), KU(t));
      if (o)
        return XXe(o, {
          range: {
            startLineNumber: t.lineNumber,
            startColumn: r.startColumn,
            endLineNumber: t.lineNumber,
            endColumn: r.endColumn
          }
        });
    }
  };
}
function rZe(i) {
  return {
    async provideDefinition(e, t) {
      const n = e.uri, s = await (await i(n)).doDefinition(String(n), KU(t));
      return s?.map(nZe);
    }
  };
}
function sZe(i) {
  return {
    async provideHover(e, t) {
      const n = e.uri, s = await (await i(n)).doHover(String(n), KU(t));
      if (s)
        return eZe(s);
    }
  };
}
function oZe(i) {
  return {
    displayName: "yaml",
    async provideDocumentSymbols(e) {
      const t = e.uri, r = await (await i(t)).findDocumentSymbols(String(t));
      return r?.map(Hme);
    }
  };
}
function aZe(i) {
  return {
    displayName: "yaml",
    async provideDocumentFormattingEdits(e) {
      const t = e.uri, r = await (await i(t)).format(String(t));
      return r?.map(Bme);
    }
  };
}
function lZe(i) {
  return {
    async provideLinks(e) {
      const t = e.uri, r = await (await i(t)).findLinks(String(t));
      if (r)
        return {
          links: r.map(tZe)
        };
    }
  };
}
function cZe(i) {
  return {
    async provideCodeActions(e, t, n) {
      const r = e.uri, o = await (await i(r)).getCodeAction(
        String(r),
        qU(t),
        jXe(n)
      );
      if (o)
        return {
          actions: o.map((a) => WXe(a)),
          dispose() {
          }
        };
    }
  };
}
function dZe(i) {
  return {
    async provideFoldingRanges(e) {
      const t = e.uri, r = await (await i(t)).getFoldingRanges(String(t));
      return r?.map(JXe);
    }
  };
}
function uZe(i, e) {
  const t = {
    completion: !0,
    customTags: [],
    enableSchemaRequest: !1,
    format: !0,
    isKubernetes: !1,
    hover: !0,
    schemas: [],
    validate: !0,
    yamlVersion: "1.2",
    ...e
  };
  i.languages.register({
    id: "yaml",
    extensions: [".yaml", ".yml"],
    aliases: ["YAML", "yaml", "YML", "yml"],
    mimetypes: ["application/x-yaml"]
  });
  const n = kXe(i, {
    label: "yaml",
    moduleId: "monaco-yaml/yaml.worker",
    createData: t
  });
  let r = s$(
    i,
    "yaml",
    l$(n.getWorker)
  );
  const s = [
    n,
    i.languages.registerCompletionItemProvider(
      "yaml",
      iZe(n.getWorker)
    ),
    i.languages.registerHoverProvider("yaml", sZe(n.getWorker)),
    i.languages.registerDefinitionProvider("yaml", rZe(n.getWorker)),
    i.languages.registerDocumentSymbolProvider(
      "yaml",
      oZe(n.getWorker)
    ),
    i.languages.registerDocumentFormattingEditProvider(
      "yaml",
      aZe(n.getWorker)
    ),
    i.languages.registerLinkProvider("yaml", lZe(n.getWorker)),
    i.languages.registerCodeActionProvider("yaml", cZe(n.getWorker)),
    i.languages.registerFoldingRangeProvider(
      "yaml",
      dZe(n.getWorker)
    ),
    i.languages.setLanguageConfiguration("yaml", {
      comments: {
        lineComment: "#"
      },
      brackets: [
        ["{", "}"],
        ["[", "]"],
        ["(", ")"]
      ],
      autoClosingPairs: [
        { open: "{", close: "}" },
        { open: "[", close: "]" },
        { open: "(", close: ")" },
        { open: '"', close: '"' },
        { open: "'", close: "'" }
      ],
      surroundingPairs: [
        { open: "{", close: "}" },
        { open: "[", close: "]" },
        { open: "(", close: ")" },
        { open: '"', close: '"' },
        { open: "'", close: "'" }
      ],
      onEnterRules: [
        {
          beforeText: /:\s*$/,
          action: { indentAction: i.languages.IndentAction.Indent }
        }
      ]
    })
  ];
  return {
    dispose() {
      for (const o of s)
        o.dispose();
      r.dispose();
    },
    update(o) {
      n.updateCreateData(Object.assign(t, o)), r.dispose(), r = s$(
        i,
        "yaml",
        l$(n.getWorker)
      );
    }
  };
}
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
var hZe = Object.defineProperty, fZe = Object.getOwnPropertyDescriptor, gZe = Object.getOwnPropertyNames, pZe = Object.prototype.hasOwnProperty, mZe = (i, e, t, n) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let r of gZe(e))
      !pZe.call(i, r) && r !== t && hZe(i, r, { get: () => e[r], enumerable: !(n = fZe(e, r)) || n.enumerable });
  return i;
}, vZe = (i, e, t) => (mZe(i, e, "default"), t), iC = {};
vZe(iC, Qo);
var Wme = {}, CT = {}, jme = class {
  constructor(i) {
    gn(this, "_languageId");
    gn(this, "_loadingTriggered");
    gn(this, "_lazyLoadPromise");
    gn(this, "_lazyLoadPromiseResolve");
    gn(this, "_lazyLoadPromiseReject");
    this._languageId = i, this._loadingTriggered = !1, this._lazyLoadPromise = new Promise((e, t) => {
      this._lazyLoadPromiseResolve = e, this._lazyLoadPromiseReject = t;
    });
  }
  static getOrCreate(i) {
    return CT[i] || (CT[i] = new jme(i)), CT[i];
  }
  load() {
    return this._loadingTriggered || (this._loadingTriggered = !0, Wme[this._languageId].loader().then((i) => this._lazyLoadPromiseResolve(i), (i) => this._lazyLoadPromiseReject(i))), this._lazyLoadPromise;
  }
};
function ht(i) {
  const e = i.id;
  Wme[e] = i, iC.languages.register(i);
  const t = jme.getOrCreate(e);
  iC.languages.registerTokensProviderFactory(e, {
    create: async () => (await t.load()).language
  }), iC.languages.onLanguageEncountered(e, async () => {
    const n = await t.load();
    iC.languages.setLanguageConfiguration(e, n.conf);
  });
}
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "abap",
  extensions: [".abap"],
  aliases: ["abap", "ABAP"],
  loader: () => import("./abap-DttVK1gE.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "apex",
  extensions: [".cls"],
  aliases: ["Apex", "apex"],
  mimetypes: ["text/x-apex-source", "text/x-apex"],
  loader: () => import("./apex-BjfHvyb2.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "azcli",
  extensions: [".azcli"],
  aliases: ["Azure CLI", "azcli"],
  loader: () => import("./azcli-Ws-Trf8e.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "bat",
  extensions: [".bat", ".cmd"],
  aliases: ["Batch", "bat"],
  loader: () => import("./bat-CeCHpU9_.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "bicep",
  extensions: [".bicep"],
  aliases: ["Bicep"],
  loader: () => import("./bicep-C7a7aEmi.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "cameligo",
  extensions: [".mligo"],
  aliases: ["Cameligo"],
  loader: () => import("./cameligo-CJeEIvX4.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "clojure",
  extensions: [".clj", ".cljs", ".cljc", ".edn"],
  aliases: ["clojure", "Clojure"],
  loader: () => import("./clojure-CEKXhLdU.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "coffeescript",
  extensions: [".coffee"],
  aliases: ["CoffeeScript", "coffeescript", "coffee"],
  mimetypes: ["text/x-coffeescript", "text/coffeescript"],
  loader: () => import("./coffee-CKu3e6V1.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "c",
  extensions: [".c", ".h"],
  aliases: ["C", "c"],
  loader: () => import("./cpp-CvUiT5Ec.js")
});
ht({
  id: "cpp",
  extensions: [".cpp", ".cc", ".cxx", ".hpp", ".hh", ".hxx"],
  aliases: ["C++", "Cpp", "cpp"],
  loader: () => import("./cpp-CvUiT5Ec.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "csharp",
  extensions: [".cs", ".csx", ".cake"],
  aliases: ["C#", "csharp"],
  loader: () => import("./csharp-PmU9HJkB.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "csp",
  extensions: [],
  aliases: ["CSP", "csp"],
  loader: () => import("./csp-DULvRLPF.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "css",
  extensions: [".css"],
  aliases: ["CSS", "css"],
  mimetypes: ["text/css"],
  loader: () => import("./css-CNWXQPpt.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "cypher",
  extensions: [".cypher", ".cyp"],
  aliases: ["Cypher", "OpenCypher"],
  loader: () => import("./cypher-CYHOQS2R.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "dart",
  extensions: [".dart"],
  aliases: ["Dart", "dart"],
  mimetypes: ["text/x-dart-source", "text/x-dart"],
  loader: () => import("./dart-BjGx-9Jk.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "dockerfile",
  extensions: [".dockerfile"],
  filenames: ["Dockerfile"],
  aliases: ["Dockerfile"],
  loader: () => import("./dockerfile-D0WaVIZ2.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "ecl",
  extensions: [".ecl"],
  aliases: ["ECL", "Ecl", "ecl"],
  loader: () => import("./ecl-CijaJu-p.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "elixir",
  extensions: [".ex", ".exs"],
  aliases: ["Elixir", "elixir", "ex"],
  loader: () => import("./elixir-BI5Tc37S.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "flow9",
  extensions: [".flow"],
  aliases: ["Flow9", "Flow", "flow9", "flow"],
  loader: () => import("./flow9-BApGtQOO.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "fsharp",
  extensions: [".fs", ".fsi", ".ml", ".mli", ".fsx", ".fsscript"],
  aliases: ["F#", "FSharp", "fsharp"],
  loader: () => import("./fsharp-VeKgt2eG.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "freemarker2",
  extensions: [".ftl", ".ftlh", ".ftlx"],
  aliases: ["FreeMarker2", "Apache FreeMarker2"],
  loader: () => import("./freemarker2-DqW5LPDz.js").then((i) => i.TagAutoInterpolationDollar)
});
ht({
  id: "freemarker2.tag-angle.interpolation-dollar",
  aliases: ["FreeMarker2 (Angle/Dollar)", "Apache FreeMarker2 (Angle/Dollar)"],
  loader: () => import("./freemarker2-DqW5LPDz.js").then((i) => i.TagAngleInterpolationDollar)
});
ht({
  id: "freemarker2.tag-bracket.interpolation-dollar",
  aliases: ["FreeMarker2 (Bracket/Dollar)", "Apache FreeMarker2 (Bracket/Dollar)"],
  loader: () => import("./freemarker2-DqW5LPDz.js").then((i) => i.TagBracketInterpolationDollar)
});
ht({
  id: "freemarker2.tag-angle.interpolation-bracket",
  aliases: ["FreeMarker2 (Angle/Bracket)", "Apache FreeMarker2 (Angle/Bracket)"],
  loader: () => import("./freemarker2-DqW5LPDz.js").then((i) => i.TagAngleInterpolationBracket)
});
ht({
  id: "freemarker2.tag-bracket.interpolation-bracket",
  aliases: ["FreeMarker2 (Bracket/Bracket)", "Apache FreeMarker2 (Bracket/Bracket)"],
  loader: () => import("./freemarker2-DqW5LPDz.js").then((i) => i.TagBracketInterpolationBracket)
});
ht({
  id: "freemarker2.tag-auto.interpolation-dollar",
  aliases: ["FreeMarker2 (Auto/Dollar)", "Apache FreeMarker2 (Auto/Dollar)"],
  loader: () => import("./freemarker2-DqW5LPDz.js").then((i) => i.TagAutoInterpolationDollar)
});
ht({
  id: "freemarker2.tag-auto.interpolation-bracket",
  aliases: ["FreeMarker2 (Auto/Bracket)", "Apache FreeMarker2 (Auto/Bracket)"],
  loader: () => import("./freemarker2-DqW5LPDz.js").then((i) => i.TagAutoInterpolationBracket)
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "go",
  extensions: [".go"],
  aliases: ["Go"],
  loader: () => import("./go-Cl8cKDlN.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "graphql",
  extensions: [".graphql", ".gql"],
  aliases: ["GraphQL", "graphql", "gql"],
  mimetypes: ["application/graphql"],
  loader: () => import("./graphql-PfgPBmj4.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "handlebars",
  extensions: [".handlebars", ".hbs"],
  aliases: ["Handlebars", "handlebars", "hbs"],
  mimetypes: ["text/x-handlebars-template"],
  loader: () => import("./handlebars-BEh6ryPs.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "hcl",
  extensions: [".tf", ".tfvars", ".hcl"],
  aliases: ["Terraform", "tf", "HCL", "hcl"],
  loader: () => import("./hcl-CG4VZSkm.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "html",
  extensions: [".html", ".htm", ".shtml", ".xhtml", ".mdoc", ".jsp", ".asp", ".aspx", ".jshtm"],
  aliases: ["HTML", "htm", "html", "xhtml"],
  mimetypes: ["text/html", "text/x-jshtm", "text/template", "text/ng-template"],
  loader: () => import("./html-Ch9g9zNA.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "ini",
  extensions: [".ini", ".properties", ".gitconfig"],
  filenames: ["config", ".gitattributes", ".gitconfig", ".editorconfig"],
  aliases: ["Ini", "ini"],
  loader: () => import("./ini-EhiBNPZF.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "java",
  extensions: [".java", ".jav"],
  aliases: ["Java", "java"],
  mimetypes: ["text/x-java-source", "text/x-java"],
  loader: () => import("./java-DPbnXhoY.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "javascript",
  extensions: [".js", ".es6", ".jsx", ".mjs", ".cjs"],
  firstLine: "^#!.*\\bnode",
  filenames: ["jakefile"],
  aliases: ["JavaScript", "javascript", "js"],
  mimetypes: ["text/javascript"],
  loader: () => import("./javascript-DUBIL4Ps.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "julia",
  extensions: [".jl"],
  aliases: ["julia", "Julia"],
  loader: () => import("./julia-Bw7EYexg.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "kotlin",
  extensions: [".kt", ".kts"],
  aliases: ["Kotlin", "kotlin"],
  mimetypes: ["text/x-kotlin-source", "text/x-kotlin"],
  loader: () => import("./kotlin-BNXLDoV0.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "less",
  extensions: [".less"],
  aliases: ["Less", "less"],
  mimetypes: ["text/x-less", "text/less"],
  loader: () => import("./less-DtuF_id_.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "lexon",
  extensions: [".lex"],
  aliases: ["Lexon"],
  loader: () => import("./lexon-DpB0-37O.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "lua",
  extensions: [".lua"],
  aliases: ["Lua", "lua"],
  loader: () => import("./lua-CzRNOk9S.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "liquid",
  extensions: [".liquid", ".html.liquid"],
  aliases: ["Liquid", "liquid"],
  mimetypes: ["application/liquid"],
  loader: () => import("./liquid-BpUGJ0tE.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "m3",
  extensions: [".m3", ".i3", ".mg", ".ig"],
  aliases: ["Modula-3", "Modula3", "modula3", "m3"],
  loader: () => import("./m3-pXPmDwal.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "markdown",
  extensions: [".md", ".markdown", ".mdown", ".mkdn", ".mkd", ".mdwn", ".mdtxt", ".mdtext"],
  aliases: ["Markdown", "markdown"],
  loader: () => import("./markdown-CeQ3rxjn.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "mdx",
  extensions: [".mdx"],
  aliases: ["MDX", "mdx"],
  loader: () => import("./mdx-B0rtKVHb.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "mips",
  extensions: [".s"],
  aliases: ["MIPS", "MIPS-V"],
  mimetypes: ["text/x-mips", "text/mips", "text/plaintext"],
  loader: () => import("./mips-DyE0VSNz.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "msdax",
  extensions: [".dax", ".msdax"],
  aliases: ["DAX", "MSDAX"],
  loader: () => import("./msdax-CbdkoqRa.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "mysql",
  extensions: [],
  aliases: ["MySQL", "mysql"],
  loader: () => import("./mysql-B86-uHNu.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "objective-c",
  extensions: [".m"],
  aliases: ["Objective-C"],
  loader: () => import("./objective-c-1xvkKPId.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "pascal",
  extensions: [".pas", ".p", ".pp"],
  aliases: ["Pascal", "pas"],
  mimetypes: ["text/x-pascal-source", "text/x-pascal"],
  loader: () => import("./pascal-DcyFhj80.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "pascaligo",
  extensions: [".ligo"],
  aliases: ["Pascaligo", "ligo"],
  loader: () => import("./pascaligo-QnM0hvMG.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "perl",
  extensions: [".pl", ".pm"],
  aliases: ["Perl", "pl"],
  loader: () => import("./perl-Bqp3FbU4.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "pgsql",
  extensions: [],
  aliases: ["PostgreSQL", "postgres", "pg", "postgre"],
  loader: () => import("./pgsql-HdG7BG_Z.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "php",
  extensions: [".php", ".php4", ".php5", ".phtml", ".ctp"],
  aliases: ["PHP", "php"],
  mimetypes: ["application/x-php"],
  loader: () => import("./php-zf7L2p7t.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "pla",
  extensions: [".pla"],
  loader: () => import("./pla-3Ykqsyzl.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "postiats",
  extensions: [".dats", ".sats", ".hats"],
  aliases: ["ATS", "ATS/Postiats"],
  loader: () => import("./postiats-D1v08O4B.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "powerquery",
  extensions: [".pq", ".pqm"],
  aliases: ["PQ", "M", "Power Query", "Power Query M"],
  loader: () => import("./powerquery-CiQ9b1-b.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "powershell",
  extensions: [".ps1", ".psm1", ".psd1"],
  aliases: ["PowerShell", "powershell", "ps", "ps1"],
  loader: () => import("./powershell-DFNK6VaX.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "proto",
  extensions: [".proto"],
  aliases: ["protobuf", "Protocol Buffers"],
  loader: () => import("./protobuf-D5P2Z6tc.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "pug",
  extensions: [".jade", ".pug"],
  aliases: ["Pug", "Jade", "jade"],
  loader: () => import("./pug-BeyMX5am.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "python",
  extensions: [".py", ".rpy", ".pyw", ".cpy", ".gyp", ".gypi"],
  aliases: ["Python", "py"],
  firstLine: "^#!/.*\\bpython[0-9.-]*\\b",
  loader: () => import("./python-BNnKRFXR.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "qsharp",
  extensions: [".qs"],
  aliases: ["Q#", "qsharp"],
  loader: () => import("./qsharp-DcFOTjuP.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "r",
  extensions: [".r", ".rhistory", ".rmd", ".rprofile", ".rt"],
  aliases: ["R", "r"],
  loader: () => import("./r-B3aJPcWp.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "razor",
  extensions: [".cshtml"],
  aliases: ["Razor", "razor"],
  mimetypes: ["text/x-cshtml"],
  loader: () => import("./razor-D-KV7amz.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "redis",
  extensions: [".redis"],
  aliases: ["redis"],
  loader: () => import("./redis-CyC__Tub.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "redshift",
  extensions: [],
  aliases: ["Redshift", "redshift"],
  loader: () => import("./redshift-NqbcQPcY.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "restructuredtext",
  extensions: [".rst"],
  aliases: ["reStructuredText", "restructuredtext"],
  loader: () => import("./restructuredtext-CZMxBkap.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "ruby",
  extensions: [".rb", ".rbx", ".rjs", ".gemspec", ".pp"],
  filenames: ["rakefile", "Gemfile"],
  aliases: ["Ruby", "rb"],
  loader: () => import("./ruby-C_jEtDv5.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "rust",
  extensions: [".rs", ".rlib"],
  aliases: ["Rust", "rust"],
  loader: () => import("./rust-WAeitMCC.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "sb",
  extensions: [".sb"],
  aliases: ["Small Basic", "sb"],
  loader: () => import("./sb-CSBm2pED.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "scala",
  extensions: [".scala", ".sc", ".sbt"],
  aliases: ["Scala", "scala", "SBT", "Sbt", "sbt", "Dotty", "dotty"],
  mimetypes: ["text/x-scala-source", "text/x-scala", "text/x-sbt", "text/x-dotty"],
  loader: () => import("./scala-D76PhKmh.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "scheme",
  extensions: [".scm", ".ss", ".sch", ".rkt"],
  aliases: ["scheme", "Scheme"],
  loader: () => import("./scheme-CBSAjRuO.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "scss",
  extensions: [".scss"],
  aliases: ["Sass", "sass", "scss"],
  mimetypes: ["text/x-scss", "text/scss"],
  loader: () => import("./scss-BHY8wFFg.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "shell",
  extensions: [".sh", ".bash"],
  aliases: ["Shell", "sh"],
  loader: () => import("./shell-Cwju9_l8.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "sol",
  extensions: [".sol"],
  aliases: ["sol", "solidity", "Solidity"],
  loader: () => import("./solidity-BV1-nze3.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "aes",
  extensions: [".aes"],
  aliases: ["aes", "sophia", "Sophia"],
  loader: () => import("./sophia-DfoUlGAs.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "sparql",
  extensions: [".rq"],
  aliases: ["sparql", "SPARQL"],
  loader: () => import("./sparql-4kfArTtK.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "sql",
  extensions: [".sql"],
  aliases: ["SQL"],
  loader: () => import("./sql-DIpn0HSX.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "st",
  extensions: [".st", ".iecst", ".iecplc", ".lc3lib", ".TcPOU", ".TcDUT", ".TcGVL", ".TcIO"],
  aliases: ["StructuredText", "scl", "stl"],
  loader: () => import("./st-BgJ_KDZh.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "swift",
  aliases: ["Swift", "swift"],
  extensions: [".swift"],
  mimetypes: ["text/swift"],
  loader: () => import("./swift-D-ucEgIi.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "systemverilog",
  extensions: [".sv", ".svh"],
  aliases: ["SV", "sv", "SystemVerilog", "systemverilog"],
  loader: () => import("./systemverilog-DjkH5zuo.js")
});
ht({
  id: "verilog",
  extensions: [".v", ".vh"],
  aliases: ["V", "v", "Verilog", "verilog"],
  loader: () => import("./systemverilog-DjkH5zuo.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "tcl",
  extensions: [".tcl"],
  aliases: ["tcl", "Tcl", "tcltk", "TclTk", "tcl/tk", "Tcl/Tk"],
  loader: () => import("./tcl-gd8XLKJA.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "twig",
  extensions: [".twig"],
  aliases: ["Twig", "twig"],
  mimetypes: ["text/x-twig"],
  loader: () => import("./twig-D5XtTFGM.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "typescript",
  extensions: [".ts", ".tsx", ".cts", ".mts"],
  aliases: ["TypeScript", "ts", "typescript"],
  mimetypes: ["text/typescript"],
  loader: () => import("./typescript-0ivYg7i9.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "vb",
  extensions: [".vb"],
  aliases: ["Visual Basic", "vb"],
  loader: () => import("./vb-DYqqYAf3.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "wgsl",
  extensions: [".wgsl"],
  aliases: ["WebGPU Shading Language", "WGSL", "wgsl"],
  loader: () => import("./wgsl-CkZE0qf3.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "xml",
  extensions: [
    ".xml",
    ".xsd",
    ".dtd",
    ".ascx",
    ".csproj",
    ".config",
    ".props",
    ".targets",
    ".wxi",
    ".wxl",
    ".wxs",
    ".xaml",
    ".svg",
    ".svgz",
    ".opf",
    ".xslt",
    ".xsl"
  ],
  firstLine: "(\\<\\?xml.*)|(\\<svg)|(\\<\\!doctype\\s+svg)",
  aliases: ["XML", "xml"],
  mimetypes: ["text/xml", "application/xml", "application/xaml+xml", "application/xml-dtd"],
  loader: () => import("./xml-DF976KJS.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
ht({
  id: "yaml",
  extensions: [".yaml", ".yml"],
  aliases: ["YAML", "yaml", "YML", "yml"],
  mimetypes: ["application/x-yaml", "text/x-yaml"],
  loader: () => import("./yaml-CkLQT9tm.js")
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
var _Ze = Object.defineProperty, bZe = Object.getOwnPropertyDescriptor, CZe = Object.getOwnPropertyNames, yZe = Object.prototype.hasOwnProperty, wZe = (i, e, t, n) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let r of CZe(e))
      !yZe.call(i, r) && r !== t && _Ze(i, r, { get: () => e[r], enumerable: !(n = bZe(e, r)) || n.enumerable });
  return i;
}, SZe = (i, e, t) => (wZe(i, e, "default"), t), Sb = {};
SZe(Sb, Qo);
var YU = class {
  constructor(e, t, n) {
    gn(this, "_onDidChange", new Sb.Emitter());
    gn(this, "_options");
    gn(this, "_modeConfiguration");
    gn(this, "_languageId");
    this._languageId = e, this.setOptions(t), this.setModeConfiguration(n);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get diagnosticsOptions() {
    return this.options;
  }
  get options() {
    return this._options;
  }
  setOptions(e) {
    this._options = e || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setDiagnosticsOptions(e) {
    this.setOptions(e);
  }
  setModeConfiguration(e) {
    this._modeConfiguration = e || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}, XU = {
  validate: !0,
  lint: {
    compatibleVendorPrefixes: "ignore",
    vendorPrefix: "warning",
    duplicateProperties: "warning",
    emptyRules: "warning",
    importStatement: "ignore",
    boxModel: "ignore",
    universalSelector: "ignore",
    zeroUnits: "ignore",
    fontFaceProperties: "warning",
    hexColorLength: "error",
    argumentsInColorFunction: "error",
    unknownProperties: "warning",
    ieHack: "ignore",
    unknownVendorSpecificProperties: "ignore",
    propertyIgnoredDueToDisplay: "warning",
    important: "ignore",
    float: "ignore",
    idSelector: "ignore"
  },
  data: { useDefaultDataProvider: !0 },
  format: {
    newlineBetweenSelectors: !0,
    newlineBetweenRules: !0,
    spaceAroundSelectorSeparator: !1,
    braceStyle: "collapse",
    maxPreserveNewLines: void 0,
    preserveNewLines: !0
  }
}, ZU = {
  completionItems: !0,
  hovers: !0,
  documentSymbols: !0,
  definitions: !0,
  references: !0,
  documentHighlights: !0,
  rename: !0,
  colors: !0,
  foldingRanges: !0,
  diagnostics: !0,
  selectionRanges: !0,
  documentFormattingEdits: !0,
  documentRangeFormattingEdits: !0
}, zme = new YU("css", XU, ZU), Ume = new YU("scss", XU, ZU), Gme = new YU("less", XU, ZU);
Sb.languages.css = { cssDefaults: zme, lessDefaults: Gme, scssDefaults: Ume };
function QU() {
  return import("./cssMode-DM77FzJL.js");
}
Sb.languages.onLanguage("less", () => {
  QU().then((i) => i.setupMode(Gme));
});
Sb.languages.onLanguage("scss", () => {
  QU().then((i) => i.setupMode(Ume));
});
Sb.languages.onLanguage("css", () => {
  QU().then((i) => i.setupMode(zme));
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
var xZe = Object.defineProperty, DZe = Object.getOwnPropertyDescriptor, EZe = Object.getOwnPropertyNames, LZe = Object.prototype.hasOwnProperty, IZe = (i, e, t, n) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let r of EZe(e))
      !LZe.call(i, r) && r !== t && xZe(i, r, { get: () => e[r], enumerable: !(n = DZe(e, r)) || n.enumerable });
  return i;
}, AZe = (i, e, t) => (IZe(i, e, "default"), t), n5 = {};
AZe(n5, Qo);
var kZe = class {
  constructor(e, t, n) {
    gn(this, "_onDidChange", new n5.Emitter());
    gn(this, "_options");
    gn(this, "_modeConfiguration");
    gn(this, "_languageId");
    this._languageId = e, this.setOptions(t), this.setModeConfiguration(n);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get options() {
    return this._options;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  setOptions(e) {
    this._options = e || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setModeConfiguration(e) {
    this._modeConfiguration = e || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}, TZe = {
  tabSize: 4,
  insertSpaces: !1,
  wrapLineLength: 120,
  unformatted: 'default": "a, abbr, acronym, b, bdo, big, br, button, cite, code, dfn, em, i, img, input, kbd, label, map, object, q, samp, select, small, span, strong, sub, sup, textarea, tt, var',
  contentUnformatted: "pre",
  indentInnerHtml: !1,
  preserveNewLines: !0,
  maxPreserveNewLines: void 0,
  indentHandlebars: !1,
  endWithNewline: !1,
  extraLiners: "head, body, /html",
  wrapAttributes: "auto"
}, i5 = {
  format: TZe,
  suggest: {},
  data: { useDefaultDataProvider: !0 }
};
function r5(i) {
  return {
    completionItems: !0,
    hovers: !0,
    documentSymbols: !0,
    links: !0,
    documentHighlights: !0,
    rename: !0,
    colors: !0,
    foldingRanges: !0,
    selectionRanges: !0,
    diagnostics: i === WC,
    documentFormattingEdits: i === WC,
    documentRangeFormattingEdits: i === WC
  };
}
var WC = "html", c$ = "handlebars", d$ = "razor", qme = s5(WC, i5, r5(WC)), NZe = qme.defaults, Kme = s5(c$, i5, r5(c$)), PZe = Kme.defaults, Yme = s5(d$, i5, r5(d$)), OZe = Yme.defaults;
n5.languages.html = {
  htmlDefaults: NZe,
  razorDefaults: OZe,
  handlebarDefaults: PZe,
  htmlLanguageService: qme,
  handlebarLanguageService: Kme,
  razorLanguageService: Yme,
  registerHTMLLanguageService: s5
};
function MZe() {
  return import("./htmlMode-D0-2mRJZ.js");
}
function s5(i, e = i5, t = r5(i)) {
  const n = new kZe(i, e, t);
  let r;
  const s = n5.languages.onLanguage(i, async () => {
    r = (await MZe()).setupMode(n);
  });
  return {
    defaults: n,
    dispose() {
      s.dispose(), r?.dispose(), r = void 0;
    }
  };
}
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
var RZe = Object.defineProperty, FZe = Object.getOwnPropertyDescriptor, BZe = Object.getOwnPropertyNames, VZe = Object.prototype.hasOwnProperty, HZe = (i, e, t, n) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let r of BZe(e))
      !VZe.call(i, r) && r !== t && RZe(i, r, { get: () => e[r], enumerable: !(n = FZe(e, r)) || n.enumerable });
  return i;
}, WZe = (i, e, t) => (HZe(i, e, "default"), t), KS = {};
WZe(KS, Qo);
var jZe = class {
  constructor(e, t, n) {
    gn(this, "_onDidChange", new KS.Emitter());
    gn(this, "_diagnosticsOptions");
    gn(this, "_modeConfiguration");
    gn(this, "_languageId");
    this._languageId = e, this.setDiagnosticsOptions(t), this.setModeConfiguration(n);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get diagnosticsOptions() {
    return this._diagnosticsOptions;
  }
  setDiagnosticsOptions(e) {
    this._diagnosticsOptions = e || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setModeConfiguration(e) {
    this._modeConfiguration = e || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}, zZe = {
  validate: !0,
  allowComments: !0,
  schemas: [],
  enableSchemaRequest: !1,
  schemaRequest: "warning",
  schemaValidation: "warning",
  comments: "error",
  trailingCommas: "error"
}, UZe = {
  documentFormattingEdits: !0,
  documentRangeFormattingEdits: !0,
  completionItems: !0,
  hovers: !0,
  documentSymbols: !0,
  tokens: !0,
  colors: !0,
  foldingRanges: !0,
  diagnostics: !0,
  selectionRanges: !0
}, Xme = new jZe("json", zZe, UZe);
KS.languages.json = { jsonDefaults: Xme };
function GZe() {
  return import("./jsonMode-BKMo8U8_.js");
}
KS.languages.register({
  id: "json",
  extensions: [".json", ".bowerrc", ".jshintrc", ".jscsrc", ".eslintrc", ".babelrc", ".har"],
  aliases: ["JSON", "json"],
  mimetypes: ["application/json"]
});
KS.languages.onLanguage("json", () => {
  GZe().then((i) => i.setupMode(Xme));
});
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.44.0(3e047efd345ff102c8c61b5398fb30845aaac166)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
var qZe = Object.defineProperty, KZe = Object.getOwnPropertyDescriptor, YZe = Object.getOwnPropertyNames, XZe = Object.prototype.hasOwnProperty, ZZe = (i, e, t, n) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let r of YZe(e))
      !XZe.call(i, r) && r !== t && qZe(i, r, { get: () => e[r], enumerable: !(n = KZe(e, r)) || n.enumerable });
  return i;
}, QZe = (i, e, t) => (ZZe(i, e, "default"), t), JZe = "5.0.2", F_ = {};
QZe(F_, Qo);
var Zme = /* @__PURE__ */ ((i) => (i[i.None = 0] = "None", i[i.CommonJS = 1] = "CommonJS", i[i.AMD = 2] = "AMD", i[i.UMD = 3] = "UMD", i[i.System = 4] = "System", i[i.ES2015 = 5] = "ES2015", i[i.ESNext = 99] = "ESNext", i))(Zme || {}), Qme = /* @__PURE__ */ ((i) => (i[i.None = 0] = "None", i[i.Preserve = 1] = "Preserve", i[i.React = 2] = "React", i[i.ReactNative = 3] = "ReactNative", i[i.ReactJSX = 4] = "ReactJSX", i[i.ReactJSXDev = 5] = "ReactJSXDev", i))(Qme || {}), Jme = /* @__PURE__ */ ((i) => (i[i.CarriageReturnLineFeed = 0] = "CarriageReturnLineFeed", i[i.LineFeed = 1] = "LineFeed", i))(Jme || {}), $me = /* @__PURE__ */ ((i) => (i[i.ES3 = 0] = "ES3", i[i.ES5 = 1] = "ES5", i[i.ES2015 = 2] = "ES2015", i[i.ES2016 = 3] = "ES2016", i[i.ES2017 = 4] = "ES2017", i[i.ES2018 = 5] = "ES2018", i[i.ES2019 = 6] = "ES2019", i[i.ES2020 = 7] = "ES2020", i[i.ESNext = 99] = "ESNext", i[i.JSON = 100] = "JSON", i[
  i.Latest = 99
  /* ESNext */
] = "Latest", i))($me || {}), e0e = /* @__PURE__ */ ((i) => (i[i.Classic = 1] = "Classic", i[i.NodeJs = 2] = "NodeJs", i))(e0e || {}), t0e = class {
  constructor(i, e, t, n, r) {
    gn(this, "_onDidChange", new F_.Emitter());
    gn(this, "_onDidExtraLibsChange", new F_.Emitter());
    gn(this, "_extraLibs");
    gn(this, "_removedExtraLibs");
    gn(this, "_eagerModelSync");
    gn(this, "_compilerOptions");
    gn(this, "_diagnosticsOptions");
    gn(this, "_workerOptions");
    gn(this, "_onDidExtraLibsChangeTimeout");
    gn(this, "_inlayHintsOptions");
    gn(this, "_modeConfiguration");
    this._extraLibs = /* @__PURE__ */ Object.create(null), this._removedExtraLibs = /* @__PURE__ */ Object.create(null), this._eagerModelSync = !1, this.setCompilerOptions(i), this.setDiagnosticsOptions(e), this.setWorkerOptions(t), this.setInlayHintsOptions(n), this.setModeConfiguration(r), this._onDidExtraLibsChangeTimeout = -1;
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get onDidExtraLibsChange() {
    return this._onDidExtraLibsChange.event;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get workerOptions() {
    return this._workerOptions;
  }
  get inlayHintsOptions() {
    return this._inlayHintsOptions;
  }
  getExtraLibs() {
    return this._extraLibs;
  }
  addExtraLib(i, e) {
    let t;
    if (typeof e > "u" ? t = `ts:extralib-${Math.random().toString(36).substring(2, 15)}` : t = e, this._extraLibs[t] && this._extraLibs[t].content === i)
      return {
        dispose: () => {
        }
      };
    let n = 1;
    return this._removedExtraLibs[t] && (n = this._removedExtraLibs[t] + 1), this._extraLibs[t] && (n = this._extraLibs[t].version + 1), this._extraLibs[t] = {
      content: i,
      version: n
    }, this._fireOnDidExtraLibsChangeSoon(), {
      dispose: () => {
        let r = this._extraLibs[t];
        r && r.version === n && (delete this._extraLibs[t], this._removedExtraLibs[t] = n, this._fireOnDidExtraLibsChangeSoon());
      }
    };
  }
  setExtraLibs(i) {
    for (const e in this._extraLibs)
      this._removedExtraLibs[e] = this._extraLibs[e].version;
    if (this._extraLibs = /* @__PURE__ */ Object.create(null), i && i.length > 0)
      for (const e of i) {
        const t = e.filePath || `ts:extralib-${Math.random().toString(36).substring(2, 15)}`, n = e.content;
        let r = 1;
        this._removedExtraLibs[t] && (r = this._removedExtraLibs[t] + 1), this._extraLibs[t] = {
          content: n,
          version: r
        };
      }
    this._fireOnDidExtraLibsChangeSoon();
  }
  _fireOnDidExtraLibsChangeSoon() {
    this._onDidExtraLibsChangeTimeout === -1 && (this._onDidExtraLibsChangeTimeout = window.setTimeout(() => {
      this._onDidExtraLibsChangeTimeout = -1, this._onDidExtraLibsChange.fire(void 0);
    }, 0));
  }
  getCompilerOptions() {
    return this._compilerOptions;
  }
  setCompilerOptions(i) {
    this._compilerOptions = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  getDiagnosticsOptions() {
    return this._diagnosticsOptions;
  }
  setDiagnosticsOptions(i) {
    this._diagnosticsOptions = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  setWorkerOptions(i) {
    this._workerOptions = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  setInlayHintsOptions(i) {
    this._inlayHintsOptions = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  setMaximumWorkerIdleTime(i) {
  }
  setEagerModelSync(i) {
    this._eagerModelSync = i;
  }
  getEagerModelSync() {
    return this._eagerModelSync;
  }
  setModeConfiguration(i) {
    this._modeConfiguration = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
}, $Ze = JZe, n0e = {
  completionItems: !0,
  hovers: !0,
  documentSymbols: !0,
  definitions: !0,
  references: !0,
  documentHighlights: !0,
  rename: !0,
  diagnostics: !0,
  documentRangeFormattingEdits: !0,
  signatureHelp: !0,
  onTypeFormattingEdits: !0,
  codeActions: !0,
  inlayHints: !0
}, i0e = new t0e({
  allowNonTsExtensions: !0,
  target: 99
  /* Latest */
}, { noSemanticValidation: !1, noSyntaxValidation: !1, onlyVisible: !1 }, {}, {}, n0e), r0e = new t0e({
  allowNonTsExtensions: !0,
  allowJs: !0,
  target: 99
  /* Latest */
}, { noSemanticValidation: !0, noSyntaxValidation: !1, onlyVisible: !1 }, {}, {}, n0e), eQe = () => o5().then((i) => i.getTypeScriptWorker()), tQe = () => o5().then((i) => i.getJavaScriptWorker());
F_.languages.typescript = {
  ModuleKind: Zme,
  JsxEmit: Qme,
  NewLineKind: Jme,
  ScriptTarget: $me,
  ModuleResolutionKind: e0e,
  typescriptVersion: $Ze,
  typescriptDefaults: i0e,
  javascriptDefaults: r0e,
  getTypeScriptWorker: eQe,
  getJavaScriptWorker: tQe
};
function o5() {
  return import("./tsMode-r9zEV8aL.js");
}
F_.languages.onLanguage("typescript", () => o5().then((i) => i.setupTypeScript(i0e)));
F_.languages.onLanguage("javascript", () => o5().then((i) => i.setupJavaScript(r0e)));
class nQe extends Ga {
  constructor() {
    super({
      id: "diffEditor.toggleCollapseUnchangedRegions",
      title: { value: C("toggleCollapseUnchangedRegions", "Toggle Collapse Unchanged Regions"), original: "Toggle Collapse Unchanged Regions" },
      icon: We.map,
      toggled: ke.has("config.diffEditor.hideUnchangedRegions.enabled"),
      precondition: ke.has("isInDiffEditor"),
      menu: {
        when: ke.has("isInDiffEditor"),
        id: J.EditorTitle,
        order: 22,
        group: "navigation"
      }
    });
  }
  run(e, ...t) {
    const n = e.get(en), r = !n.getValue("diffEditor.hideUnchangedRegions.enabled");
    n.updateValue("diffEditor.hideUnchangedRegions.enabled", r);
  }
}
oi(nQe);
class s0e extends Ga {
  constructor() {
    super({
      id: "diffEditor.toggleShowMovedCodeBlocks",
      title: { value: C("toggleShowMovedCodeBlocks", "Toggle Show Moved Code Blocks"), original: "Toggle Show Moved Code Blocks" },
      precondition: ke.has("isInDiffEditor")
    });
  }
  run(e, ...t) {
    const n = e.get(en), r = !n.getValue("diffEditor.experimental.showMoves");
    n.updateValue("diffEditor.experimental.showMoves", r);
  }
}
oi(s0e);
class o0e extends Ga {
  constructor() {
    super({
      id: "diffEditor.toggleUseInlineViewWhenSpaceIsLimited",
      title: { value: C("toggleUseInlineViewWhenSpaceIsLimited", "Toggle Use Inline View When Space Is Limited"), original: "Toggle Use Inline View When Space Is Limited" },
      precondition: ke.has("isInDiffEditor")
    });
  }
  run(e, ...t) {
    const n = e.get(en), r = !n.getValue("diffEditor.useInlineViewWhenSpaceIsLimited");
    n.updateValue("diffEditor.useInlineViewWhenSpaceIsLimited", r);
  }
}
oi(o0e);
os.appendMenuItem(J.EditorTitle, {
  command: {
    id: new o0e().desc.id,
    title: C("useInlineViewWhenSpaceIsLimited", "Use Inline View When Space Is Limited"),
    toggled: ke.has("config.diffEditor.useInlineViewWhenSpaceIsLimited"),
    precondition: ke.has("isInDiffEditor")
  },
  order: 11,
  group: "1_diff",
  when: ke.and($.diffEditorRenderSideBySideInlineBreakpointReached, ke.has("isInDiffEditor"))
});
os.appendMenuItem(J.EditorTitle, {
  command: {
    id: new s0e().desc.id,
    title: C("showMoves", "Show Moved Code Blocks"),
    icon: We.move,
    toggled: hb.create("config.diffEditor.experimental.showMoves", !0),
    precondition: ke.has("isInDiffEditor")
  },
  order: 10,
  group: "1_diff",
  when: ke.has("isInDiffEditor")
});
const a5 = {
  value: C("diffEditor", "Diff Editor"),
  original: "Diff Editor"
};
class iQe extends vd {
  constructor() {
    super({
      id: "diffEditor.switchSide",
      title: { value: C("switchSide", "Switch Side"), original: "Switch Side" },
      icon: We.arrowSwap,
      precondition: ke.has("isInDiffEditor"),
      f1: !0,
      category: a5
    });
  }
  runEditorCommand(e, t, n) {
    const r = Db(e);
    if (r instanceof i0) {
      if (n && n.dryRun)
        return { destinationSelection: r.mapToOtherSide().destinationSelection };
      r.switchSide();
    }
  }
}
oi(iQe);
class rQe extends vd {
  constructor() {
    super({
      id: "diffEditor.exitCompareMove",
      title: { value: C("exitCompareMove", "Exit Compare Move"), original: "Exit Compare Move" },
      icon: We.close,
      precondition: $.comparingMovedCode,
      f1: !1,
      category: a5,
      keybinding: {
        weight: 1e4,
        primary: 9
      }
    });
  }
  runEditorCommand(e, t, ...n) {
    const r = Db(e);
    r instanceof i0 && r.exitCompareMove();
  }
}
oi(rQe);
class sQe extends vd {
  constructor() {
    super({
      id: "diffEditor.collapseAllUnchangedRegions",
      title: { value: C("collapseAllUnchangedRegions", "Collapse All Unchanged Regions"), original: "Collapse All Unchanged Regions" },
      icon: We.fold,
      precondition: ke.has("isInDiffEditor"),
      f1: !0,
      category: a5
    });
  }
  runEditorCommand(e, t, ...n) {
    const r = Db(e);
    r instanceof i0 && r.collapseAllUnchangedRegions();
  }
}
oi(sQe);
class oQe extends vd {
  constructor() {
    super({
      id: "diffEditor.showAllUnchangedRegions",
      title: { value: C("showAllUnchangedRegions", "Show All Unchanged Regions"), original: "Show All Unchanged Regions" },
      icon: We.unfold,
      precondition: ke.has("isInDiffEditor"),
      f1: !0,
      category: a5
    });
  }
  runEditorCommand(e, t, ...n) {
    const r = Db(e);
    r instanceof i0 && r.showAllUnchangedRegions();
  }
}
oi(oQe);
const a0e = {
  value: C("accessibleDiffViewer", "Accessible Diff Viewer"),
  original: "Accessible Diff Viewer"
};
class xb extends Ga {
  constructor() {
    super({
      id: xb.id,
      title: { value: C("editor.action.accessibleDiffViewer.next", "Go to Next Difference"), original: "Go to Next Difference" },
      category: a0e,
      precondition: ke.has("isInDiffEditor"),
      keybinding: {
        primary: 65,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      f1: !0
    });
  }
  run(e) {
    const t = Db(e);
    t?.accessibleDiffViewerNext();
  }
}
xb.id = "editor.action.accessibleDiffViewer.next";
os.appendMenuItem(J.EditorTitle, {
  command: {
    id: xb.id,
    title: C("Open Accessible Diff Viewer", "Open Accessible Diff Viewer"),
    precondition: ke.has("isInDiffEditor")
  },
  order: 10,
  group: "2_diff",
  when: ke.and($.accessibleDiffViewerVisible.negate(), ke.has("isInDiffEditor"))
});
class YS extends Ga {
  constructor() {
    super({
      id: YS.id,
      title: { value: C("editor.action.accessibleDiffViewer.prev", "Go to Previous Difference"), original: "Go to Previous Difference" },
      category: a0e,
      precondition: ke.has("isInDiffEditor"),
      keybinding: {
        primary: 1089,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      f1: !0
    });
  }
  run(e) {
    const t = Db(e);
    t?.accessibleDiffViewerPrev();
  }
}
YS.id = "editor.action.accessibleDiffViewer.prev";
function Db(i) {
  var e;
  const t = i.get(Sn), n = t.listDiffEditors(), r = (e = t.getFocusedCodeEditor()) !== null && e !== void 0 ? e : t.getActiveCodeEditor();
  if (!r)
    return null;
  for (let o = 0, a = n.length; o < a; o++) {
    const l = n[o];
    if (l.getModifiedEditor().getId() === r.getId() || l.getOriginalEditor().getId() === r.getId())
      return l;
  }
  const s = Jl();
  if (s)
    for (const o of n) {
      const a = o.getContainerDomNode();
      if (aQe(a, s))
        return o;
    }
  return null;
}
function aQe(i, e) {
  let t = e;
  for (; t; ) {
    if (t === i)
      return !0;
    t = t.parentElement;
  }
  return !1;
}
on.registerCommandAlias("editor.action.diffReview.next", xb.id);
oi(xb);
on.registerCommandAlias("editor.action.diffReview.prev", YS.id);
oi(YS);
var lQe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, cQe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, l5 = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, EV;
const c5 = new Ke("selectionAnchorSet", !1);
let Jh = EV = class {
  static get(e) {
    return e.getContribution(EV.ID);
  }
  constructor(e, t) {
    this.editor = e, this.selectionAnchorSetContextKey = c5.bindTo(t), this.modelChangeListener = e.onDidChangeModel(() => this.selectionAnchorSetContextKey.reset());
  }
  setSelectionAnchor() {
    if (this.editor.hasModel()) {
      const e = this.editor.getPosition();
      this.editor.changeDecorations((t) => {
        this.decorationId && t.removeDecoration(this.decorationId), this.decorationId = t.addDecoration(ot.fromPositions(e, e), {
          description: "selection-anchor",
          stickiness: 1,
          hoverMessage: new ys().appendText(C("selectionAnchor", "Selection Anchor")),
          className: "selection-anchor"
        });
      }), this.selectionAnchorSetContextKey.set(!!this.decorationId), Fs(C("anchorSet", "Anchor set at {0}:{1}", e.lineNumber, e.column));
    }
  }
  goToSelectionAnchor() {
    if (this.editor.hasModel() && this.decorationId) {
      const e = this.editor.getModel().getDecorationRange(this.decorationId);
      e && this.editor.setPosition(e.getStartPosition());
    }
  }
  selectFromAnchorToCursor() {
    if (this.editor.hasModel() && this.decorationId) {
      const e = this.editor.getModel().getDecorationRange(this.decorationId);
      if (e) {
        const t = this.editor.getPosition();
        this.editor.setSelection(ot.fromPositions(e.getStartPosition(), t)), this.cancelSelectionAnchor();
      }
    }
  }
  cancelSelectionAnchor() {
    if (this.decorationId) {
      const e = this.decorationId;
      this.editor.changeDecorations((t) => {
        t.removeDecoration(e), this.decorationId = void 0;
      }), this.selectionAnchorSetContextKey.set(!1);
    }
  }
  dispose() {
    this.cancelSelectionAnchor(), this.modelChangeListener.dispose();
  }
};
Jh.ID = "editor.contrib.selectionAnchorController";
Jh = EV = lQe([
  cQe(1, yt)
], Jh);
class dQe extends Je {
  constructor() {
    super({
      id: "editor.action.setSelectionAnchor",
      label: C("setSelectionAnchor", "Set Selection Anchor"),
      alias: "Set Selection Anchor",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2080
          /* KeyCode.KeyB */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    var n;
    return l5(this, void 0, void 0, function* () {
      (n = Jh.get(t)) === null || n === void 0 || n.setSelectionAnchor();
    });
  }
}
class uQe extends Je {
  constructor() {
    super({
      id: "editor.action.goToSelectionAnchor",
      label: C("goToSelectionAnchor", "Go to Selection Anchor"),
      alias: "Go to Selection Anchor",
      precondition: c5
    });
  }
  run(e, t) {
    var n;
    return l5(this, void 0, void 0, function* () {
      (n = Jh.get(t)) === null || n === void 0 || n.goToSelectionAnchor();
    });
  }
}
class hQe extends Je {
  constructor() {
    super({
      id: "editor.action.selectFromAnchorToCursor",
      label: C("selectFromAnchorToCursor", "Select from Anchor to Cursor"),
      alias: "Select from Anchor to Cursor",
      precondition: c5,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2089
          /* KeyCode.KeyK */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    var n;
    return l5(this, void 0, void 0, function* () {
      (n = Jh.get(t)) === null || n === void 0 || n.selectFromAnchorToCursor();
    });
  }
}
class fQe extends Je {
  constructor() {
    super({
      id: "editor.action.cancelSelectionAnchor",
      label: C("cancelSelectionAnchor", "Cancel Selection Anchor"),
      alias: "Cancel Selection Anchor",
      precondition: c5,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 9,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    var n;
    return l5(this, void 0, void 0, function* () {
      (n = Jh.get(t)) === null || n === void 0 || n.cancelSelectionAnchor();
    });
  }
}
pn(
  Jh.ID,
  Jh,
  4
  /* EditorContributionInstantiation.Lazy */
);
Be(dQe);
Be(uQe);
Be(hQe);
Be(fQe);
const gQe = ne("editorOverviewRuler.bracketMatchForeground", { dark: "#A0A0A0", light: "#A0A0A0", hcDark: "#A0A0A0", hcLight: "#A0A0A0" }, C("overviewRulerBracketMatchForeground", "Overview ruler marker color for matching brackets."));
class pQe extends Je {
  constructor() {
    super({
      id: "editor.action.jumpToBracket",
      label: C("smartSelect.jumpBracket", "Go to Bracket"),
      alias: "Go to Bracket",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 3165,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    var n;
    (n = $l.get(t)) === null || n === void 0 || n.jumpToBracket();
  }
}
class mQe extends Je {
  constructor() {
    super({
      id: "editor.action.selectToBracket",
      label: C("smartSelect.selectToBracket", "Select to Bracket"),
      alias: "Select to Bracket",
      precondition: void 0,
      description: {
        description: "Select to Bracket",
        args: [{
          name: "args",
          schema: {
            type: "object",
            properties: {
              selectBrackets: {
                type: "boolean",
                default: !0
              }
            }
          }
        }]
      }
    });
  }
  run(e, t, n) {
    var r;
    let s = !0;
    n && n.selectBrackets === !1 && (s = !1), (r = $l.get(t)) === null || r === void 0 || r.selectToBracket(s);
  }
}
class vQe extends Je {
  constructor() {
    super({
      id: "editor.action.removeBrackets",
      label: C("smartSelect.removeBrackets", "Remove Brackets"),
      alias: "Remove Brackets",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 2561,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    var n;
    (n = $l.get(t)) === null || n === void 0 || n.removeBrackets(this.id);
  }
}
class _Qe {
  constructor(e, t, n) {
    this.position = e, this.brackets = t, this.options = n;
  }
}
class $l extends we {
  static get(e) {
    return e.getContribution($l.ID);
  }
  constructor(e) {
    super(), this._editor = e, this._lastBracketsData = [], this._lastVersionId = 0, this._decorations = this._editor.createDecorationsCollection(), this._updateBracketsSoon = this._register(new Rn(() => this._updateBrackets(), 50)), this._matchBrackets = this._editor.getOption(
      71
      /* EditorOption.matchBrackets */
    ), this._updateBracketsSoon.schedule(), this._register(e.onDidChangeCursorPosition((t) => {
      this._matchBrackets !== "never" && this._updateBracketsSoon.schedule();
    })), this._register(e.onDidChangeModelContent((t) => {
      this._updateBracketsSoon.schedule();
    })), this._register(e.onDidChangeModel((t) => {
      this._lastBracketsData = [], this._updateBracketsSoon.schedule();
    })), this._register(e.onDidChangeModelLanguageConfiguration((t) => {
      this._lastBracketsData = [], this._updateBracketsSoon.schedule();
    })), this._register(e.onDidChangeConfiguration((t) => {
      t.hasChanged(
        71
        /* EditorOption.matchBrackets */
      ) && (this._matchBrackets = this._editor.getOption(
        71
        /* EditorOption.matchBrackets */
      ), this._decorations.clear(), this._lastBracketsData = [], this._lastVersionId = 0, this._updateBracketsSoon.schedule());
    })), this._register(e.onDidBlurEditorWidget(() => {
      this._updateBracketsSoon.schedule();
    })), this._register(e.onDidFocusEditorWidget(() => {
      this._updateBracketsSoon.schedule();
    }));
  }
  jumpToBracket() {
    if (!this._editor.hasModel())
      return;
    const e = this._editor.getModel(), t = this._editor.getSelections().map((n) => {
      const r = n.getStartPosition(), s = e.bracketPairs.matchBracket(r);
      let o = null;
      if (s)
        s[0].containsPosition(r) && !s[1].containsPosition(r) ? o = s[1].getStartPosition() : s[1].containsPosition(r) && (o = s[0].getStartPosition());
      else {
        const a = e.bracketPairs.findEnclosingBrackets(r);
        if (a)
          o = a[1].getStartPosition();
        else {
          const l = e.bracketPairs.findNextBracket(r);
          l && l.range && (o = l.range.getStartPosition());
        }
      }
      return o ? new ot(o.lineNumber, o.column, o.lineNumber, o.column) : new ot(r.lineNumber, r.column, r.lineNumber, r.column);
    });
    this._editor.setSelections(t), this._editor.revealRange(t[0]);
  }
  selectToBracket(e) {
    if (!this._editor.hasModel())
      return;
    const t = this._editor.getModel(), n = [];
    this._editor.getSelections().forEach((r) => {
      const s = r.getStartPosition();
      let o = t.bracketPairs.matchBracket(s);
      if (!o && (o = t.bracketPairs.findEnclosingBrackets(s), !o)) {
        const c = t.bracketPairs.findNextBracket(s);
        c && c.range && (o = t.bracketPairs.matchBracket(c.range.getStartPosition()));
      }
      let a = null, l = null;
      if (o) {
        o.sort(V.compareRangesUsingStarts);
        const [c, d] = o;
        if (a = e ? c.getStartPosition() : c.getEndPosition(), l = e ? d.getEndPosition() : d.getStartPosition(), d.containsPosition(s)) {
          const u = a;
          a = l, l = u;
        }
      }
      a && l && n.push(new ot(a.lineNumber, a.column, l.lineNumber, l.column));
    }), n.length > 0 && (this._editor.setSelections(n), this._editor.revealRange(n[0]));
  }
  removeBrackets(e) {
    if (!this._editor.hasModel())
      return;
    const t = this._editor.getModel();
    this._editor.getSelections().forEach((n) => {
      const r = n.getPosition();
      let s = t.bracketPairs.matchBracket(r);
      s || (s = t.bracketPairs.findEnclosingBrackets(r)), s && (this._editor.pushUndoStop(), this._editor.executeEdits(e, [
        { range: s[0], text: "" },
        { range: s[1], text: "" }
      ]), this._editor.pushUndoStop());
    });
  }
  _updateBrackets() {
    if (this._matchBrackets === "never")
      return;
    this._recomputeBrackets();
    const e = [];
    let t = 0;
    for (const n of this._lastBracketsData) {
      const r = n.brackets;
      r && (e[t++] = { range: r[0], options: n.options }, e[t++] = { range: r[1], options: n.options });
    }
    this._decorations.set(e);
  }
  _recomputeBrackets() {
    if (!this._editor.hasModel() || !this._editor.hasWidgetFocus()) {
      this._lastBracketsData = [], this._lastVersionId = 0;
      return;
    }
    const e = this._editor.getSelections();
    if (e.length > 100) {
      this._lastBracketsData = [], this._lastVersionId = 0;
      return;
    }
    const t = this._editor.getModel(), n = t.getVersionId();
    let r = [];
    this._lastVersionId === n && (r = this._lastBracketsData);
    const s = [];
    let o = 0;
    for (let u = 0, h = e.length; u < h; u++) {
      const f = e[u];
      f.isEmpty() && (s[o++] = f.getStartPosition());
    }
    s.length > 1 && s.sort(ve.compare);
    const a = [];
    let l = 0, c = 0;
    const d = r.length;
    for (let u = 0, h = s.length; u < h; u++) {
      const f = s[u];
      for (; c < d && r[c].position.isBefore(f); )
        c++;
      if (c < d && r[c].position.equals(f))
        a[l++] = r[c];
      else {
        let g = t.bracketPairs.matchBracket(
          f,
          20
          /* give at most 20ms to compute */
        ), p = $l._DECORATION_OPTIONS_WITH_OVERVIEW_RULER;
        !g && this._matchBrackets === "always" && (g = t.bracketPairs.findEnclosingBrackets(
          f,
          20
          /* give at most 20ms to compute */
        ), p = $l._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER), a[l++] = new _Qe(f, g, p);
      }
    }
    this._lastBracketsData = a, this._lastVersionId = n;
  }
}
$l.ID = "editor.contrib.bracketMatchingController";
$l._DECORATION_OPTIONS_WITH_OVERVIEW_RULER = Lt.register({
  description: "bracket-match-overview",
  stickiness: 1,
  className: "bracket-match",
  overviewRuler: {
    color: Oi(gQe),
    position: Ha.Center
  }
});
$l._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER = Lt.register({
  description: "bracket-match-no-overview",
  stickiness: 1,
  className: "bracket-match"
});
pn(
  $l.ID,
  $l,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
Be(mQe);
Be(pQe);
Be(vQe);
os.appendMenuItem(J.MenubarGoMenu, {
  group: "5_infile_nav",
  command: {
    id: "editor.action.jumpToBracket",
    title: C({ key: "miGoToBracket", comment: ["&& denotes a mnemonic"] }, "Go to &&Bracket")
  },
  order: 2
});
class bQe {
  constructor(e, t) {
    this._selection = e, this._isMovingLeft = t;
  }
  getEditOperations(e, t) {
    if (this._selection.startLineNumber !== this._selection.endLineNumber || this._selection.isEmpty())
      return;
    const n = this._selection.startLineNumber, r = this._selection.startColumn, s = this._selection.endColumn;
    if (!(this._isMovingLeft && r === 1) && !(!this._isMovingLeft && s === e.getLineMaxColumn(n)))
      if (this._isMovingLeft) {
        const o = new V(n, r - 1, n, r), a = e.getValueInRange(o);
        t.addEditOperation(o, null), t.addEditOperation(new V(n, s, n, s), a);
      } else {
        const o = new V(n, s, n, s + 1), a = e.getValueInRange(o);
        t.addEditOperation(o, null), t.addEditOperation(new V(n, r, n, r), a);
      }
  }
  computeCursorState(e, t) {
    return this._isMovingLeft ? new ot(this._selection.startLineNumber, this._selection.startColumn - 1, this._selection.endLineNumber, this._selection.endColumn - 1) : new ot(this._selection.startLineNumber, this._selection.startColumn + 1, this._selection.endLineNumber, this._selection.endColumn + 1);
  }
}
class l0e extends Je {
  constructor(e, t) {
    super(t), this.left = e;
  }
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = [], r = t.getSelections();
    for (const s of r)
      n.push(new bQe(s, this.left));
    t.pushUndoStop(), t.executeCommands(this.id, n), t.pushUndoStop();
  }
}
class CQe extends l0e {
  constructor() {
    super(!0, {
      id: "editor.action.moveCarretLeftAction",
      label: C("caret.moveLeft", "Move Selected Text Left"),
      alias: "Move Selected Text Left",
      precondition: $.writable
    });
  }
}
class yQe extends l0e {
  constructor() {
    super(!1, {
      id: "editor.action.moveCarretRightAction",
      label: C("caret.moveRight", "Move Selected Text Right"),
      alias: "Move Selected Text Right",
      precondition: $.writable
    });
  }
}
Be(CQe);
Be(yQe);
class wQe extends Je {
  constructor() {
    super({
      id: "editor.action.transposeLetters",
      label: C("transposeLetters.label", "Transpose Letters"),
      alias: "Transpose Letters",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        mac: {
          primary: 306
          /* KeyCode.KeyT */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = t.getModel(), r = [], s = t.getSelections();
    for (const o of s) {
      if (!o.isEmpty())
        continue;
      const a = o.startLineNumber, l = o.startColumn, c = n.getLineMaxColumn(a);
      if (a === 1 && (l === 1 || l === 2 && c === 2))
        continue;
      const d = l === c ? o.getPosition() : Ln.rightPosition(n, o.getPosition().lineNumber, o.getPosition().column), u = Ln.leftPosition(n, d), h = Ln.leftPosition(n, u), f = n.getValueInRange(V.fromPositions(h, u)), g = n.getValueInRange(V.fromPositions(u, d)), p = V.fromPositions(h, d);
      r.push(new vs(p, g + f));
    }
    r.length > 0 && (t.pushUndoStop(), t.executeCommands(this.id, r), t.pushUndoStop());
  }
}
Be(wQe);
var SQe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const s0 = "9_cutcopypaste", xQe = Zc || document.queryCommandSupported("cut"), c0e = Zc || document.queryCommandSupported("copy"), DQe = typeof navigator.clipboard > "u" || bl ? document.queryCommandSupported("paste") : !0;
function JU(i) {
  return i.register(), i;
}
const EQe = xQe ? JU(new gb({
  id: "editor.action.clipboardCutAction",
  precondition: void 0,
  kbOpts: (
    // Do not bind cut keybindings in the browser,
    // since browsers do that for us and it avoids security prompts
    Zc ? {
      primary: 2102,
      win: { primary: 2102, secondary: [
        1044
        /* KeyCode.Delete */
      ] },
      weight: 100
      /* KeybindingWeight.EditorContrib */
    } : void 0
  ),
  menuOpts: [{
    menuId: J.MenubarEditMenu,
    group: "2_ccp",
    title: C({ key: "miCut", comment: ["&& denotes a mnemonic"] }, "Cu&&t"),
    order: 1
  }, {
    menuId: J.EditorContext,
    group: s0,
    title: C("actions.clipboard.cutLabel", "Cut"),
    when: $.writable,
    order: 1
  }, {
    menuId: J.CommandPalette,
    group: "",
    title: C("actions.clipboard.cutLabel", "Cut"),
    order: 1
  }, {
    menuId: J.SimpleEditorContext,
    group: s0,
    title: C("actions.clipboard.cutLabel", "Cut"),
    when: $.writable,
    order: 1
  }]
})) : void 0, LQe = c0e ? JU(new gb({
  id: "editor.action.clipboardCopyAction",
  precondition: void 0,
  kbOpts: (
    // Do not bind copy keybindings in the browser,
    // since browsers do that for us and it avoids security prompts
    Zc ? {
      primary: 2081,
      win: { primary: 2081, secondary: [
        2067
        /* KeyCode.Insert */
      ] },
      weight: 100
      /* KeybindingWeight.EditorContrib */
    } : void 0
  ),
  menuOpts: [{
    menuId: J.MenubarEditMenu,
    group: "2_ccp",
    title: C({ key: "miCopy", comment: ["&& denotes a mnemonic"] }, "&&Copy"),
    order: 2
  }, {
    menuId: J.EditorContext,
    group: s0,
    title: C("actions.clipboard.copyLabel", "Copy"),
    order: 2
  }, {
    menuId: J.CommandPalette,
    group: "",
    title: C("actions.clipboard.copyLabel", "Copy"),
    order: 1
  }, {
    menuId: J.SimpleEditorContext,
    group: s0,
    title: C("actions.clipboard.copyLabel", "Copy"),
    order: 2
  }]
})) : void 0;
os.appendMenuItem(J.MenubarEditMenu, { submenu: J.MenubarCopy, title: { value: C("copy as", "Copy As"), original: "Copy As" }, group: "2_ccp", order: 3 });
os.appendMenuItem(J.EditorContext, { submenu: J.EditorContextCopy, title: { value: C("copy as", "Copy As"), original: "Copy As" }, group: s0, order: 3 });
os.appendMenuItem(J.EditorContext, { submenu: J.EditorContextShare, title: { value: C("share", "Share"), original: "Share" }, group: "11_share", order: -1, when: ke.and(ke.notEquals("resourceScheme", "output"), $.editorTextFocus) });
os.appendMenuItem(J.EditorTitleContext, { submenu: J.EditorTitleContextShare, title: { value: C("share", "Share"), original: "Share" }, group: "11_share", order: -1 });
os.appendMenuItem(J.ExplorerContext, { submenu: J.ExplorerContextShare, title: { value: C("share", "Share"), original: "Share" }, group: "11_share", order: -1 });
const yT = DQe ? JU(new gb({
  id: "editor.action.clipboardPasteAction",
  precondition: void 0,
  kbOpts: (
    // Do not bind paste keybindings in the browser,
    // since browsers do that for us and it avoids security prompts
    Zc ? {
      primary: 2100,
      win: { primary: 2100, secondary: [
        1043
        /* KeyCode.Insert */
      ] },
      linux: { primary: 2100, secondary: [
        1043
        /* KeyCode.Insert */
      ] },
      weight: 100
      /* KeybindingWeight.EditorContrib */
    } : void 0
  ),
  menuOpts: [{
    menuId: J.MenubarEditMenu,
    group: "2_ccp",
    title: C({ key: "miPaste", comment: ["&& denotes a mnemonic"] }, "&&Paste"),
    order: 4
  }, {
    menuId: J.EditorContext,
    group: s0,
    title: C("actions.clipboard.pasteLabel", "Paste"),
    when: $.writable,
    order: 4
  }, {
    menuId: J.CommandPalette,
    group: "",
    title: C("actions.clipboard.pasteLabel", "Paste"),
    order: 1
  }, {
    menuId: J.SimpleEditorContext,
    group: s0,
    title: C("actions.clipboard.pasteLabel", "Paste"),
    when: $.writable,
    order: 4
  }]
})) : void 0;
class IQe extends Je {
  constructor() {
    super({
      id: "editor.action.clipboardCopyWithSyntaxHighlightingAction",
      label: C("actions.clipboard.copyWithSyntaxHighlightingLabel", "Copy With Syntax Highlighting"),
      alias: "Copy With Syntax Highlighting",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    !t.hasModel() || !t.getOption(
      37
      /* EditorOption.emptySelectionClipboard */
    ) && t.getSelection().isEmpty() || (TF.forceCopyWithSyntaxHighlighting = !0, t.focus(), t.getContainerDomNode().ownerDocument.execCommand("copy"), TF.forceCopyWithSyntaxHighlighting = !1);
  }
}
function d0e(i, e) {
  i && (i.addImplementation(1e4, "code-editor", (t, n) => {
    const r = t.get(Sn).getFocusedCodeEditor();
    if (r && r.hasTextFocus()) {
      const s = r.getOption(
        37
        /* EditorOption.emptySelectionClipboard */
      ), o = r.getSelection();
      return o && o.isEmpty() && !s || r.getContainerDomNode().ownerDocument.execCommand(e), !0;
    }
    return !1;
  }), i.addImplementation(0, "generic-dom", (t, n) => (t4().execCommand(e), !0)));
}
d0e(EQe, "cut");
d0e(LQe, "copy");
yT && (yT.addImplementation(1e4, "code-editor", (i, e) => {
  const t = i.get(Sn), n = i.get(hf), r = t.getFocusedCodeEditor();
  return r && r.hasTextFocus() ? !r.getContainerDomNode().ownerDocument.execCommand("paste") && sp ? SQe(void 0, void 0, void 0, function* () {
    const o = yield n.readText();
    if (o !== "") {
      const a = qy.INSTANCE.get(o);
      let l = !1, c = null, d = null;
      a && (l = r.getOption(
        37
        /* EditorOption.emptySelectionClipboard */
      ) && !!a.isFromEmptySelection, c = typeof a.multicursorText < "u" ? a.multicursorText : null, d = a.mode), r.trigger("keyboard", "paste", {
        text: o,
        pasteOnNewLine: l,
        multicursorText: c,
        mode: d
      });
    }
  }) : !0 : !1;
}), yT.addImplementation(0, "generic-dom", (i, e) => (t4().execCommand("paste"), !0)));
c0e && Be(IQe);
var AQe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class vt {
  constructor(e) {
    this.value = e;
  }
  equals(e) {
    return this.value === e.value;
  }
  contains(e) {
    return this.equals(e) || this.value === "" || e.value.startsWith(this.value + vt.sep);
  }
  intersects(e) {
    return this.contains(e) || e.contains(this);
  }
  append(e) {
    return new vt(this.value + vt.sep + e);
  }
}
vt.sep = ".";
vt.None = new vt("@@none@@");
vt.Empty = new vt("");
vt.QuickFix = new vt("quickfix");
vt.Refactor = new vt("refactor");
vt.RefactorExtract = vt.Refactor.append("extract");
vt.RefactorInline = vt.Refactor.append("inline");
vt.RefactorMove = vt.Refactor.append("move");
vt.RefactorRewrite = vt.Refactor.append("rewrite");
vt.Notebook = new vt("notebook");
vt.Source = new vt("source");
vt.SourceOrganizeImports = vt.Source.append("organizeImports");
vt.SourceFixAll = vt.Source.append("fixAll");
vt.SurroundWith = vt.Refactor.append("surround");
var la;
(function(i) {
  i.Refactor = "refactor", i.RefactorPreview = "refactor preview", i.Lightbulb = "lightbulb", i.Default = "other (default)", i.SourceAction = "source action", i.QuickFix = "quick fix action", i.FixAll = "fix all", i.OrganizeImports = "organize imports", i.AutoFix = "auto fix", i.QuickFixHover = "quick fix hover window", i.OnSave = "save participants", i.ProblemsView = "problems view";
})(la || (la = {}));
function kQe(i, e) {
  return !(i.include && !i.include.intersects(e) || i.excludes && i.excludes.some((t) => u0e(e, t, i.include)) || !i.includeSourceActions && vt.Source.contains(e));
}
function TQe(i, e) {
  const t = e.kind ? new vt(e.kind) : void 0;
  return !(i.include && (!t || !i.include.contains(t)) || i.excludes && t && i.excludes.some((n) => u0e(t, n, i.include)) || !i.includeSourceActions && t && vt.Source.contains(t) || i.onlyIncludePreferredActions && !e.isPreferred);
}
function u0e(i, e, t) {
  return !(!e.contains(i) || t && e.contains(t));
}
class Yd {
  static fromUser(e, t) {
    return !e || typeof e != "object" ? new Yd(t.kind, t.apply, !1) : new Yd(Yd.getKindFromUser(e, t.kind), Yd.getApplyFromUser(e, t.apply), Yd.getPreferredUser(e));
  }
  static getApplyFromUser(e, t) {
    switch (typeof e.apply == "string" ? e.apply.toLowerCase() : "") {
      case "first":
        return "first";
      case "never":
        return "never";
      case "ifsingle":
        return "ifSingle";
      default:
        return t;
    }
  }
  static getKindFromUser(e, t) {
    return typeof e.kind == "string" ? new vt(e.kind) : t;
  }
  static getPreferredUser(e) {
    return typeof e.preferred == "boolean" ? e.preferred : !1;
  }
  constructor(e, t, n) {
    this.kind = e, this.apply = t, this.preferred = n;
  }
}
class NQe {
  constructor(e, t, n) {
    this.action = e, this.provider = t, this.highlightRange = n;
  }
  resolve(e) {
    var t;
    return AQe(this, void 0, void 0, function* () {
      if (!((t = this.provider) === null || t === void 0) && t.resolveCodeAction && !this.action.edit) {
        let n;
        try {
          n = yield this.provider.resolveCodeAction(this.action, e);
        } catch (r) {
          vr(r);
        }
        n && (this.action.edit = n.edit);
      }
      return this;
    });
  }
}
var hI = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const h0e = "editor.action.codeAction", $U = "editor.action.quickFix", f0e = "editor.action.autoFix", g0e = "editor.action.refactor", p0e = "editor.action.sourceAction", eG = "editor.action.organizeImports", tG = "editor.action.fixAll";
class jC extends we {
  static codeActionsPreferredComparator(e, t) {
    return e.isPreferred && !t.isPreferred ? -1 : !e.isPreferred && t.isPreferred ? 1 : 0;
  }
  static codeActionsComparator({ action: e }, { action: t }) {
    return Bs(e.diagnostics) ? Bs(t.diagnostics) ? jC.codeActionsPreferredComparator(e, t) : -1 : Bs(t.diagnostics) ? 1 : jC.codeActionsPreferredComparator(e, t);
  }
  constructor(e, t, n) {
    super(), this.documentation = t, this._register(n), this.allActions = [...e].sort(jC.codeActionsComparator), this.validActions = this.allActions.filter(({ action: r }) => !r.disabled);
  }
  get hasAutoFix() {
    return this.validActions.some(({ action: e }) => !!e.kind && vt.QuickFix.contains(new vt(e.kind)) && !!e.isPreferred);
  }
}
const u$ = { actions: [], documentation: void 0 };
function zC(i, e, t, n, r, s) {
  var o;
  return hI(this, void 0, void 0, function* () {
    const a = n.filter || {}, l = Object.assign(Object.assign({}, a), { excludes: [...a.excludes || [], vt.Notebook] }), c = {
      only: (o = a.include) === null || o === void 0 ? void 0 : o.value,
      trigger: n.type
    }, d = new jU(e, s), u = n.type === 2, h = PQe(i, e, u ? l : a), f = new Ne(), g = h.map((m) => hI(this, void 0, void 0, function* () {
      try {
        r.report(m);
        const _ = yield m.provideCodeActions(e, t, c, d.token);
        if (_ && f.add(_), d.token.isCancellationRequested)
          return u$;
        const b = (_?.actions || []).filter((y) => y && TQe(a, y)), w = MQe(m, b, a.include);
        return {
          actions: b.map((y) => new NQe(y, m)),
          documentation: w
        };
      } catch (_) {
        if (md(_))
          throw _;
        return vr(_), u$;
      }
    })), p = i.onDidChange(() => {
      const m = i.all(e);
      Qi(m, h) || d.cancel();
    });
    try {
      const m = yield Promise.all(g), _ = m.map((w) => w.actions).flat(), b = [
        ..._u(m.map((w) => w.documentation)),
        ...OQe(i, e, n, _)
      ];
      return new jC(_, b, f);
    } finally {
      p.dispose(), d.dispose();
    }
  });
}
function PQe(i, e, t) {
  return i.all(e).filter((n) => n.providedCodeActionKinds ? n.providedCodeActionKinds.some((r) => kQe(t, new vt(r))) : !0);
}
function* OQe(i, e, t, n) {
  var r, s, o;
  if (e && n.length)
    for (const a of i.all(e))
      a._getAdditionalMenuItems && (yield* (r = a._getAdditionalMenuItems) === null || r === void 0 ? void 0 : r.call(a, { trigger: t.type, only: (o = (s = t.filter) === null || s === void 0 ? void 0 : s.include) === null || o === void 0 ? void 0 : o.value }, n.map((l) => l.action)));
}
function MQe(i, e, t) {
  if (!i.documentation)
    return;
  const n = i.documentation.map((r) => ({ kind: new vt(r.kind), command: r.command }));
  if (t) {
    let r;
    for (const s of n)
      s.kind.contains(t) && (r ? r.kind.contains(s.kind) && (r = s) : r = s);
    if (r)
      return r?.command;
  }
  for (const r of e)
    if (r.kind) {
      for (const s of n)
        if (s.kind.contains(new vt(r.kind)))
          return s.command;
    }
}
var fI;
(function(i) {
  i.OnSave = "onSave", i.FromProblemsView = "fromProblemsView", i.FromCodeActions = "fromCodeActions";
})(fI || (fI = {}));
function RQe(i, e, t, n, r = jt.None) {
  var s;
  return hI(this, void 0, void 0, function* () {
    const o = i.get(FS), a = i.get(Ui), l = i.get(qa), c = i.get(dr);
    if (l.publicLog2("codeAction.applyCodeAction", {
      codeActionTitle: e.action.title,
      codeActionKind: e.action.kind,
      codeActionIsPreferred: !!e.action.isPreferred,
      reason: t
    }), yield e.resolve(r), !r.isCancellationRequested && !(!((s = e.action.edit) === null || s === void 0) && s.edits.length && !(yield o.apply(e.action.edit, {
      editor: n?.editor,
      label: e.action.title,
      quotableLabel: e.action.title,
      code: "undoredo.codeAction",
      respectAutoSaveConfig: t !== fI.OnSave,
      showPreview: n?.preview
    })).isApplied) && e.action.command)
      try {
        yield a.executeCommand(e.action.command.id, ...e.action.command.arguments || []);
      } catch (d) {
        const u = FQe(d);
        c.error(typeof u == "string" ? u : C("applyCodeActionFailed", "An unknown error occurred while applying the code action"));
      }
  });
}
function FQe(i) {
  return typeof i == "string" ? i : i instanceof Error && typeof i.message == "string" ? i.message : void 0;
}
on.registerCommand("_executeCodeActionProvider", function(i, e, t, n, r) {
  return hI(this, void 0, void 0, function* () {
    if (!(e instanceof pt))
      throw fl();
    const { codeActionProvider: s } = i.get(tt), o = i.get(fi).getModel(e);
    if (!o)
      throw fl();
    const a = ot.isISelection(t) ? ot.liftSelection(t) : V.isIRange(t) ? o.validateRange(t) : void 0;
    if (!a)
      throw fl();
    const l = typeof n == "string" ? new vt(n) : void 0, c = yield zC(s, o, a, { type: 1, triggerAction: la.Default, filter: { includeSourceActions: !0, include: l } }, Hh.None, jt.None), d = [], u = Math.min(c.validActions.length, typeof r == "number" ? r : 0);
    for (let h = 0; h < u; h++)
      d.push(c.validActions[h].resolve(jt.None));
    try {
      return yield Promise.all(d), c.validActions.map((h) => h.action);
    } finally {
      setTimeout(() => c.dispose(), 100);
    }
  });
});
var BQe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, VQe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, LV;
let gI = LV = class {
  constructor(e) {
    this.keybindingService = e;
  }
  getResolver() {
    const e = new lp(() => this.keybindingService.getKeybindings().filter((t) => LV.codeActionCommands.indexOf(t.command) >= 0).filter((t) => t.resolvedKeybinding).map((t) => {
      let n = t.commandArgs;
      return t.command === eG ? n = { kind: vt.SourceOrganizeImports.value } : t.command === tG && (n = { kind: vt.SourceFixAll.value }), Object.assign({ resolvedKeybinding: t.resolvedKeybinding }, Yd.fromUser(n, {
        kind: vt.None,
        apply: "never"
        /* CodeActionAutoApply.Never */
      }));
    }));
    return (t) => {
      if (t.kind) {
        const n = this.bestKeybindingForCodeAction(t, e.value);
        return n?.resolvedKeybinding;
      }
    };
  }
  bestKeybindingForCodeAction(e, t) {
    if (!e.kind)
      return;
    const n = new vt(e.kind);
    return t.filter((r) => r.kind.contains(n)).filter((r) => r.preferred ? e.isPreferred : !0).reduceRight((r, s) => r ? r.kind.contains(s.kind) ? s : r : s, void 0);
  }
};
gI.codeActionCommands = [
  g0e,
  h0e,
  p0e,
  eG,
  tG
];
gI = LV = BQe([
  VQe(0, Bn)
], gI);
ne("symbolIcon.arrayForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.arrayForeground", "The foreground color for array symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.booleanForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.booleanForeground", "The foreground color for boolean symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.classForeground", {
  dark: "#EE9D28",
  light: "#D67E00",
  hcDark: "#EE9D28",
  hcLight: "#D67E00"
}, C("symbolIcon.classForeground", "The foreground color for class symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.colorForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.colorForeground", "The foreground color for color symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.constantForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.constantForeground", "The foreground color for constant symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.constructorForeground", {
  dark: "#B180D7",
  light: "#652D90",
  hcDark: "#B180D7",
  hcLight: "#652D90"
}, C("symbolIcon.constructorForeground", "The foreground color for constructor symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.enumeratorForeground", {
  dark: "#EE9D28",
  light: "#D67E00",
  hcDark: "#EE9D28",
  hcLight: "#D67E00"
}, C("symbolIcon.enumeratorForeground", "The foreground color for enumerator symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.enumeratorMemberForeground", {
  dark: "#75BEFF",
  light: "#007ACC",
  hcDark: "#75BEFF",
  hcLight: "#007ACC"
}, C("symbolIcon.enumeratorMemberForeground", "The foreground color for enumerator member symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.eventForeground", {
  dark: "#EE9D28",
  light: "#D67E00",
  hcDark: "#EE9D28",
  hcLight: "#D67E00"
}, C("symbolIcon.eventForeground", "The foreground color for event symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.fieldForeground", {
  dark: "#75BEFF",
  light: "#007ACC",
  hcDark: "#75BEFF",
  hcLight: "#007ACC"
}, C("symbolIcon.fieldForeground", "The foreground color for field symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.fileForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.fileForeground", "The foreground color for file symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.folderForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.folderForeground", "The foreground color for folder symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.functionForeground", {
  dark: "#B180D7",
  light: "#652D90",
  hcDark: "#B180D7",
  hcLight: "#652D90"
}, C("symbolIcon.functionForeground", "The foreground color for function symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.interfaceForeground", {
  dark: "#75BEFF",
  light: "#007ACC",
  hcDark: "#75BEFF",
  hcLight: "#007ACC"
}, C("symbolIcon.interfaceForeground", "The foreground color for interface symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.keyForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.keyForeground", "The foreground color for key symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.keywordForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.keywordForeground", "The foreground color for keyword symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.methodForeground", {
  dark: "#B180D7",
  light: "#652D90",
  hcDark: "#B180D7",
  hcLight: "#652D90"
}, C("symbolIcon.methodForeground", "The foreground color for method symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.moduleForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.moduleForeground", "The foreground color for module symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.namespaceForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.namespaceForeground", "The foreground color for namespace symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.nullForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.nullForeground", "The foreground color for null symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.numberForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.numberForeground", "The foreground color for number symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.objectForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.objectForeground", "The foreground color for object symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.operatorForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.operatorForeground", "The foreground color for operator symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.packageForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.packageForeground", "The foreground color for package symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.propertyForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.propertyForeground", "The foreground color for property symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.referenceForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.referenceForeground", "The foreground color for reference symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.snippetForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.snippetForeground", "The foreground color for snippet symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.stringForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.stringForeground", "The foreground color for string symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.structForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.structForeground", "The foreground color for struct symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.textForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.textForeground", "The foreground color for text symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.typeParameterForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.typeParameterForeground", "The foreground color for type parameter symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.unitForeground", {
  dark: Ve,
  light: Ve,
  hcDark: Ve,
  hcLight: Ve
}, C("symbolIcon.unitForeground", "The foreground color for unit symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
ne("symbolIcon.variableForeground", {
  dark: "#75BEFF",
  light: "#007ACC",
  hcDark: "#75BEFF",
  hcLight: "#007ACC"
}, C("symbolIcon.variableForeground", "The foreground color for variable symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const m0e = Object.freeze({ kind: vt.Empty, title: C("codeAction.widget.id.more", "More Actions...") }), HQe = Object.freeze([
  { kind: vt.QuickFix, title: C("codeAction.widget.id.quickfix", "Quick Fix") },
  { kind: vt.RefactorExtract, title: C("codeAction.widget.id.extract", "Extract"), icon: We.wrench },
  { kind: vt.RefactorInline, title: C("codeAction.widget.id.inline", "Inline"), icon: We.wrench },
  { kind: vt.RefactorRewrite, title: C("codeAction.widget.id.convert", "Rewrite"), icon: We.wrench },
  { kind: vt.RefactorMove, title: C("codeAction.widget.id.move", "Move"), icon: We.wrench },
  { kind: vt.SurroundWith, title: C("codeAction.widget.id.surround", "Surround With"), icon: We.symbolSnippet },
  { kind: vt.Source, title: C("codeAction.widget.id.source", "Source Action"), icon: We.symbolFile },
  m0e
]);
function WQe(i, e, t) {
  if (!e)
    return i.map((s) => {
      var o;
      return {
        kind: "action",
        item: s,
        group: m0e,
        disabled: !!s.action.disabled,
        label: s.action.disabled || s.action.title,
        canPreview: !!(!((o = s.action.edit) === null || o === void 0) && o.edits.length)
      };
    });
  const n = HQe.map((s) => ({ group: s, actions: [] }));
  for (const s of i) {
    const o = s.action.kind ? new vt(s.action.kind) : vt.None;
    for (const a of n)
      if (a.group.kind.contains(o)) {
        a.actions.push(s);
        break;
      }
  }
  const r = [];
  for (const s of n)
    if (s.actions.length) {
      r.push({ kind: "header", group: s.group });
      for (const o of s.actions)
        r.push({
          kind: "action",
          item: o,
          group: s.group,
          label: o.action.title,
          disabled: !!o.action.disabled,
          keybinding: t(o.action)
        });
    }
  return r;
}
var jQe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, zQe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, IV, gv;
(function(i) {
  i.Hidden = {
    type: 0
    /* Type.Hidden */
  };
  class e {
    constructor(n, r, s, o) {
      this.actions = n, this.trigger = r, this.editorPosition = s, this.widgetPosition = o, this.type = 1;
    }
  }
  i.Showing = e;
})(gv || (gv = {}));
let o0 = IV = class extends we {
  constructor(e, t) {
    super(), this._editor = e, this._onClick = this._register(new pe()), this.onClick = this._onClick.event, this._state = gv.Hidden, this._domNode = Re("div.lightBulbWidget"), this._register(Vn.ignoreTarget(this._domNode)), this._editor.addContentWidget(this), this._register(this._editor.onDidChangeModelContent((n) => {
      const r = this._editor.getModel();
      (this.state.type !== 1 || !r || this.state.editorPosition.lineNumber >= r.getLineCount()) && this.hide();
    })), this._register(H9e(this._domNode, (n) => {
      if (this.state.type !== 1)
        return;
      this._editor.focus(), n.preventDefault();
      const { top: r, height: s } = wr(this._domNode), o = this._editor.getOption(
        66
        /* EditorOption.lineHeight */
      );
      let a = Math.floor(o / 3);
      this.state.widgetPosition.position !== null && this.state.widgetPosition.position.lineNumber < this.state.editorPosition.lineNumber && (a += o), this._onClick.fire({
        x: n.posx,
        y: r + s + a,
        actions: this.state.actions,
        trigger: this.state.trigger
      });
    })), this._register(Ie(this._domNode, "mouseenter", (n) => {
      (n.buttons & 1) === 1 && this.hide();
    })), this._register(this._editor.onDidChangeConfiguration((n) => {
      n.hasChanged(
        64
        /* EditorOption.lightbulb */
      ) && !this._editor.getOption(
        64
        /* EditorOption.lightbulb */
      ).enabled && this.hide();
    })), this._register(qe.runAndSubscribe(t.onDidUpdateKeybindings, () => {
      var n, r, s, o;
      this._preferredKbLabel = (r = (n = t.lookupKeybinding(f0e)) === null || n === void 0 ? void 0 : n.getLabel()) !== null && r !== void 0 ? r : void 0, this._quickFixKbLabel = (o = (s = t.lookupKeybinding($U)) === null || s === void 0 ? void 0 : s.getLabel()) !== null && o !== void 0 ? o : void 0, this._updateLightBulbTitleAndIcon();
    }));
  }
  dispose() {
    super.dispose(), this._editor.removeContentWidget(this);
  }
  getId() {
    return "LightBulbWidget";
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._state.type === 1 ? this._state.widgetPosition : null;
  }
  update(e, t, n) {
    if (e.validActions.length <= 0)
      return this.hide();
    const r = this._editor.getOptions();
    if (!r.get(
      64
      /* EditorOption.lightbulb */
    ).enabled)
      return this.hide();
    const s = this._editor.getModel();
    if (!s)
      return this.hide();
    const { lineNumber: o, column: a } = s.validatePosition(n), l = s.getOptions().tabSize, c = r.get(
      50
      /* EditorOption.fontInfo */
    ), d = s.getLineContent(o), u = S4(d, l), h = c.spaceWidth * u > 22, f = (p) => p > 2 && this._editor.getTopForLineNumber(p) === this._editor.getTopForLineNumber(p - 1);
    let g = o;
    if (!h) {
      if (o > 1 && !f(o - 1))
        g -= 1;
      else if (!f(o + 1))
        g += 1;
      else if (a * c.spaceWidth < 22)
        return this.hide();
    }
    this.state = new gv.Showing(e, t, n, {
      position: { lineNumber: g, column: 1 },
      preference: IV._posPref
    }), this._editor.layoutContentWidget(this);
  }
  hide() {
    this.state !== gv.Hidden && (this.state = gv.Hidden, this._editor.layoutContentWidget(this));
  }
  get state() {
    return this._state;
  }
  set state(e) {
    this._state = e, this._updateLightBulbTitleAndIcon();
  }
  _updateLightBulbTitleAndIcon() {
    if (this.state.type === 1 && this.state.actions.hasAutoFix && (this._domNode.classList.remove(...ft.asClassNameArray(We.lightBulb)), this._domNode.classList.add(...ft.asClassNameArray(We.lightbulbAutofix)), this._preferredKbLabel)) {
      this.title = C("preferredcodeActionWithKb", "Show Code Actions. Preferred Quick Fix Available ({0})", this._preferredKbLabel);
      return;
    }
    this._domNode.classList.remove(...ft.asClassNameArray(We.lightbulbAutofix)), this._domNode.classList.add(...ft.asClassNameArray(We.lightBulb)), this._quickFixKbLabel ? this.title = C("codeActionWithKb", "Show Code Actions ({0})", this._quickFixKbLabel) : this.title = C("codeAction", "Show Code Actions");
  }
  set title(e) {
    this._domNode.title = e;
  }
};
o0.ID = "editor.contrib.lightbulbWidget";
o0._posPref = [
  0
  /* ContentWidgetPositionPreference.EXACT */
];
o0 = IV = jQe([
  zQe(1, Bn)
], o0);
var UQe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, h$ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, v0e = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, AV;
let $h = AV = class {
  constructor(e, t, n) {
    this._options = e, this._languageService = t, this._openerService = n, this._onDidRenderAsync = new pe(), this.onDidRenderAsync = this._onDidRenderAsync.event;
  }
  dispose() {
    this._onDidRenderAsync.dispose();
  }
  render(e, t, n) {
    if (!e)
      return { element: document.createElement("span"), dispose: () => {
      } };
    const r = new Ne(), s = r.add(M4(e, Object.assign(Object.assign({}, this._getRenderOptions(e, r)), t), n));
    return s.element.classList.add("rendered-markdown"), {
      element: s.element,
      dispose: () => r.dispose()
    };
  }
  _getRenderOptions(e, t) {
    return {
      codeBlockRenderer: (n, r) => v0e(this, void 0, void 0, function* () {
        var s, o, a;
        let l;
        n ? l = this._languageService.getLanguageIdByLanguageName(n) : this._options.editor && (l = (s = this._options.editor.getModel()) === null || s === void 0 ? void 0 : s.getLanguageId()), l || (l = Fa);
        const c = yield mHe(this._languageService, r, l), d = document.createElement("span");
        if (d.innerHTML = (a = (o = AV._ttpTokenizer) === null || o === void 0 ? void 0 : o.createHTML(c)) !== null && a !== void 0 ? a : c, this._options.editor) {
          const u = this._options.editor.getOption(
            50
            /* EditorOption.fontInfo */
          );
          Ds(d, u);
        } else this._options.codeBlockFontFamily && (d.style.fontFamily = this._options.codeBlockFontFamily);
        return this._options.codeBlockFontSize !== void 0 && (d.style.fontSize = this._options.codeBlockFontSize), d;
      }),
      asyncRenderCallback: () => this._onDidRenderAsync.fire(),
      actionHandler: {
        callback: (n) => _0e(this._openerService, n, e.isTrusted),
        disposables: t
      }
    };
  }
};
$h._ttpTokenizer = af("tokenizeToString", {
  createHTML(i) {
    return i;
  }
});
$h = AV = UQe([
  h$(1, ci),
  h$(2, da)
], $h);
function _0e(i, e, t) {
  return v0e(this, void 0, void 0, function* () {
    try {
      return yield i.open(e, {
        fromUserGesture: !0,
        allowContributedOpeners: !0,
        allowCommands: GQe(t)
      });
    } catch (n) {
      return It(n), !1;
    }
  });
}
function GQe(i) {
  return i === !0 ? !0 : i && Array.isArray(i.enabledCommands) ? i.enabledCommands : !1;
}
var qQe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, f$ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, iE;
let ra = iE = class {
  static get(e) {
    return e.getContribution(iE.ID);
  }
  constructor(e, t, n) {
    this._openerService = n, this._messageWidget = new ds(), this._messageListeners = new Ne(), this._mouseOverMessage = !1, this._editor = e, this._visible = iE.MESSAGE_VISIBLE.bindTo(t);
  }
  dispose() {
    var e;
    (e = this._message) === null || e === void 0 || e.dispose(), this._messageListeners.dispose(), this._messageWidget.dispose(), this._visible.reset();
  }
  showMessage(e, t) {
    Fs(_g(e) ? e.value : e), this._visible.set(!0), this._messageWidget.clear(), this._messageListeners.clear(), this._message = _g(e) ? M4(e, {
      actionHandler: {
        callback: (r) => _0e(this._openerService, r, _g(e) ? e.isTrusted : void 0),
        disposables: this._messageListeners
      }
    }) : void 0, this._messageWidget.value = new g$(this._editor, t, typeof e == "string" ? e : this._message.element), this._messageListeners.add(qe.debounce(this._editor.onDidBlurEditorText, (r, s) => s, 0)(() => {
      this._mouseOverMessage || this._messageWidget.value && xs(Jl(), this._messageWidget.value.getDomNode()) || this.closeMessage();
    })), this._messageListeners.add(this._editor.onDidChangeCursorPosition(() => this.closeMessage())), this._messageListeners.add(this._editor.onDidDispose(() => this.closeMessage())), this._messageListeners.add(this._editor.onDidChangeModel(() => this.closeMessage())), this._messageListeners.add(Ie(this._messageWidget.value.getDomNode(), Ge.MOUSE_ENTER, () => this._mouseOverMessage = !0, !0)), this._messageListeners.add(Ie(this._messageWidget.value.getDomNode(), Ge.MOUSE_LEAVE, () => this._mouseOverMessage = !1, !0));
    let n;
    this._messageListeners.add(this._editor.onMouseMove((r) => {
      r.target.position && (n ? n.containsPosition(r.target.position) || this.closeMessage() : n = new V(t.lineNumber - 3, 1, r.target.position.lineNumber + 3, 1));
    }));
  }
  closeMessage() {
    this._visible.reset(), this._messageListeners.clear(), this._messageWidget.value && this._messageListeners.add(g$.fadeOut(this._messageWidget.value));
  }
};
ra.ID = "editor.contrib.messageController";
ra.MESSAGE_VISIBLE = new Ke("messageVisible", !1, C("messageVisible", "Whether the editor is currently showing an inline message"));
ra = iE = qQe([
  f$(1, yt),
  f$(2, da)
], ra);
const KQe = Kr.bindToContribution(ra.get);
ze(new KQe({
  id: "leaveEditorMessage",
  precondition: ra.MESSAGE_VISIBLE,
  handler: (i) => i.closeMessage(),
  kbOpts: {
    weight: 130,
    primary: 9
    /* KeyCode.Escape */
  }
}));
let g$ = class {
  static fadeOut(e) {
    const t = () => {
      e.dispose(), clearTimeout(n), e.getDomNode().removeEventListener("animationend", t);
    }, n = setTimeout(t, 110);
    return e.getDomNode().addEventListener("animationend", t), e.getDomNode().classList.add("fadeOut"), { dispose: t };
  }
  constructor(e, { lineNumber: t, column: n }, r) {
    this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this._editor = e, this._editor.revealLinesInCenterIfOutsideViewport(
      t,
      t,
      0
      /* ScrollType.Smooth */
    ), this._position = { lineNumber: t, column: n }, this._domNode = document.createElement("div"), this._domNode.classList.add("monaco-editor-overlaymessage"), this._domNode.style.marginLeft = "-6px";
    const s = document.createElement("div");
    s.classList.add("anchor", "top"), this._domNode.appendChild(s);
    const o = document.createElement("div");
    typeof r == "string" ? (o.classList.add("message"), o.textContent = r) : (r.classList.add("message"), o.appendChild(r)), this._domNode.appendChild(o);
    const a = document.createElement("div");
    a.classList.add("anchor", "below"), this._domNode.appendChild(a), this._editor.addContentWidget(this), this._domNode.classList.add("fadeIn");
  }
  dispose() {
    this._editor.removeContentWidget(this);
  }
  getId() {
    return "messageoverlay";
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return {
      position: this._position,
      preference: [
        1,
        2
      ],
      positionAffinity: 1
    };
  }
  afterRender(e) {
    this._domNode.classList.toggle(
      "below",
      e === 2
      /* ContentWidgetPositionPreference.BELOW */
    );
  }
};
pn(
  ra.ID,
  ra,
  4
  /* EditorContributionInstantiation.Lazy */
);
var b0e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, kV = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, YQe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const C0e = "acceptSelectedCodeAction", y0e = "previewSelectedCodeAction";
class XQe {
  get templateId() {
    return "header";
  }
  renderTemplate(e) {
    e.classList.add("group-header");
    const t = document.createElement("span");
    return e.append(t), { container: e, text: t };
  }
  renderElement(e, t, n) {
    var r, s;
    n.text.textContent = (s = (r = e.group) === null || r === void 0 ? void 0 : r.title) !== null && s !== void 0 ? s : "";
  }
  disposeTemplate(e) {
  }
}
let TV = class {
  get templateId() {
    return "action";
  }
  constructor(e, t) {
    this._supportsPreview = e, this._keybindingService = t;
  }
  renderTemplate(e) {
    e.classList.add(this.templateId);
    const t = document.createElement("div");
    t.className = "icon", e.append(t);
    const n = document.createElement("span");
    n.className = "title", e.append(n);
    const r = new jS(e, ka);
    return { container: e, icon: t, text: n, keybinding: r };
  }
  renderElement(e, t, n) {
    var r, s, o;
    if (!((r = e.group) === null || r === void 0) && r.icon ? (n.icon.className = ft.asClassName(e.group.icon), e.group.icon.color && (n.icon.style.color = Ye(e.group.icon.color.id))) : (n.icon.className = ft.asClassName(We.lightBulb), n.icon.style.color = "var(--vscode-editorLightBulb-foreground)"), !e.item || !e.label)
      return;
    n.text.textContent = w0e(e.label), n.keybinding.set(e.keybinding), Q9e(!!e.keybinding, n.keybinding.element);
    const a = (s = this._keybindingService.lookupKeybinding(C0e)) === null || s === void 0 ? void 0 : s.getLabel(), l = (o = this._keybindingService.lookupKeybinding(y0e)) === null || o === void 0 ? void 0 : o.getLabel();
    n.container.classList.toggle("option-disabled", e.disabled), e.disabled ? n.container.title = e.label : a && l ? this._supportsPreview && e.canPreview ? n.container.title = C({ key: "label-preview", comment: ['placeholders are keybindings, e.g "F2 to apply, Shift+F2 to preview"'] }, "{0} to apply, {1} to preview", a, l) : n.container.title = C({ key: "label", comment: ['placeholder is a keybinding, e.g "F2 to apply"'] }, "{0} to apply", a) : n.container.title = "";
  }
  disposeTemplate(e) {
  }
};
TV = b0e([
  kV(1, Bn)
], TV);
class ZQe extends UIEvent {
  constructor() {
    super("acceptSelectedAction");
  }
}
class p$ extends UIEvent {
  constructor() {
    super("previewSelectedAction");
  }
}
function QQe(i) {
  if (i.kind === "action")
    return i.label;
}
let NV = class extends we {
  constructor(e, t, n, r, s, o) {
    super(), this._delegate = r, this._contextViewService = s, this._keybindingService = o, this._actionLineHeight = 24, this._headerLineHeight = 26, this.cts = this._register(new lr()), this.domNode = document.createElement("div"), this.domNode.classList.add("actionList");
    const a = {
      getHeight: (l) => l.kind === "header" ? this._headerLineHeight : this._actionLineHeight,
      getTemplateId: (l) => l.kind
    };
    this._list = this._register(new pc(e, this.domNode, a, [
      new TV(t, this._keybindingService),
      new XQe()
    ], {
      keyboardSupport: !1,
      typeNavigationEnabled: !0,
      keyboardNavigationLabelProvider: { getKeyboardNavigationLabel: QQe },
      accessibilityProvider: {
        getAriaLabel: (l) => {
          if (l.kind === "action") {
            let c = l.label ? w0e(l?.label) : "";
            return l.disabled && (c = C({ key: "customQuickFixWidget.labels", comment: ["Action widget labels for accessibility."] }, "{0}, Disabled Reason: {1}", c, l.disabled)), c;
          }
          return null;
        },
        getWidgetAriaLabel: () => C({ key: "customQuickFixWidget", comment: ["An action widget option"] }, "Action Widget"),
        getRole: (l) => l.kind === "action" ? "option" : "separator",
        getWidgetRole: () => "listbox"
      }
    })), this._list.style(B0), this._register(this._list.onMouseClick((l) => this.onListClick(l))), this._register(this._list.onMouseOver((l) => this.onListHover(l))), this._register(this._list.onDidChangeFocus(() => this.onFocus())), this._register(this._list.onDidChangeSelection((l) => this.onListSelection(l))), this._allMenuItems = n, this._list.splice(0, this._list.length, this._allMenuItems), this._list.length && this.focusNext();
  }
  focusCondition(e) {
    return !e.disabled && e.kind === "action";
  }
  hide(e) {
    this._delegate.onHide(e), this.cts.cancel(), this._contextViewService.hideContextView();
  }
  layout(e) {
    const t = this._allMenuItems.filter((c) => c.kind === "header").length, r = this._allMenuItems.length * this._actionLineHeight + t * this._headerLineHeight - t * this._actionLineHeight;
    this._list.layout(r);
    const s = this._allMenuItems.map((c, d) => {
      const u = document.getElementById(this._list.getElementID(d));
      if (u) {
        u.style.width = "auto";
        const h = u.getBoundingClientRect().width;
        return u.style.width = "", h;
      }
      return 0;
    }), o = Math.max(...s, e), l = Math.min(r, document.body.clientHeight * 0.7);
    return this._list.layout(l, o), this.domNode.style.height = `${l}px`, this._list.domFocus(), o;
  }
  focusPrevious() {
    this._list.focusPrevious(1, !0, void 0, this.focusCondition);
  }
  focusNext() {
    this._list.focusNext(1, !0, void 0, this.focusCondition);
  }
  acceptSelected(e) {
    const t = this._list.getFocus();
    if (t.length === 0)
      return;
    const n = t[0], r = this._list.element(n);
    if (!this.focusCondition(r))
      return;
    const s = e ? new p$() : new ZQe();
    this._list.setSelection([n], s);
  }
  onListSelection(e) {
    if (!e.elements.length)
      return;
    const t = e.elements[0];
    t.item && this.focusCondition(t) ? this._delegate.onSelect(t.item, e.browserEvent instanceof p$) : this._list.setSelection([]);
  }
  onFocus() {
    var e, t;
    this._list.domFocus();
    const n = this._list.getFocus();
    if (n.length === 0)
      return;
    const r = n[0], s = this._list.element(r);
    (t = (e = this._delegate).onFocus) === null || t === void 0 || t.call(e, s.item);
  }
  onListHover(e) {
    return YQe(this, void 0, void 0, function* () {
      const t = e.element;
      if (t && t.item && this.focusCondition(t)) {
        if (this._delegate.onHover && !t.disabled && t.kind === "action") {
          const n = yield this._delegate.onHover(t.item, this.cts.token);
          t.canPreview = n ? n.canPreview : void 0;
        }
        e.index && this._list.splice(e.index, 1, [t]);
      }
      this._list.setFocus(typeof e.index == "number" ? [e.index] : []);
    });
  }
  onListClick(e) {
    e.element && this.focusCondition(e.element) && this._list.setFocus([]);
  }
};
NV = b0e([
  kV(4, cf),
  kV(5, Bn)
], NV);
function w0e(i) {
  return i.replace(/\r\n|\r|\n/g, " ");
}
var JQe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, wT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
ne("actionBar.toggledBackground", { dark: dm, light: dm, hcDark: dm, hcLight: dm }, C("actionBar.toggledBackground", "Background color for toggled action items in action bar."));
const a0 = {
  Visible: new Ke("codeActionMenuVisible", !1, C("codeActionMenuVisible", "Whether the action widget list is visible"))
}, z0 = Gt("actionWidgetService");
let l0 = class extends we {
  get isVisible() {
    return a0.Visible.getValue(this._contextKeyService) || !1;
  }
  constructor(e, t, n) {
    super(), this._contextViewService = e, this._contextKeyService = t, this._instantiationService = n, this._list = this._register(new ds());
  }
  show(e, t, n, r, s, o, a) {
    const l = a0.Visible.bindTo(this._contextKeyService), c = this._instantiationService.createInstance(NV, e, t, n, r);
    this._contextViewService.showContextView({
      getAnchor: () => s,
      render: (d) => (l.set(!0), this._renderWidget(d, c, a ?? [])),
      onHide: (d) => {
        l.reset(), this._onWidgetClosed(d);
      }
    }, o, !1);
  }
  acceptSelected(e) {
    var t;
    (t = this._list.value) === null || t === void 0 || t.acceptSelected(e);
  }
  focusPrevious() {
    var e, t;
    (t = (e = this._list) === null || e === void 0 ? void 0 : e.value) === null || t === void 0 || t.focusPrevious();
  }
  focusNext() {
    var e, t;
    (t = (e = this._list) === null || e === void 0 ? void 0 : e.value) === null || t === void 0 || t.focusNext();
  }
  hide() {
    var e;
    (e = this._list.value) === null || e === void 0 || e.hide(), this._list.clear();
  }
  _renderWidget(e, t, n) {
    var r;
    const s = document.createElement("div");
    if (s.classList.add("action-widget"), e.appendChild(s), this._list.value = t, this._list.value)
      s.appendChild(this._list.value.domNode);
    else
      throw new Error("List has no value");
    const o = new Ne(), a = document.createElement("div"), l = e.appendChild(a);
    l.classList.add("context-view-block"), o.add(Ie(l, Ge.MOUSE_DOWN, (g) => g.stopPropagation()));
    const c = document.createElement("div"), d = e.appendChild(c);
    d.classList.add("context-view-pointerBlock"), o.add(Ie(d, Ge.POINTER_MOVE, () => d.remove())), o.add(Ie(d, Ge.MOUSE_DOWN, () => d.remove()));
    let u = 0;
    if (n.length) {
      const g = this._createActionBar(".action-widget-action-bar", n);
      g && (s.appendChild(g.getContainer().parentElement), o.add(g), u = g.getContainer().offsetWidth);
    }
    const h = (r = this._list.value) === null || r === void 0 ? void 0 : r.layout(u);
    s.style.width = `${h}px`;
    const f = o.add(yu(e));
    return o.add(f.onDidBlur(() => this.hide())), o;
  }
  _createActionBar(e, t) {
    if (!t.length)
      return;
    const n = Re(e), r = new Dl(n);
    return r.push(t, { icon: !1, label: !0 }), r;
  }
  _onWidgetClosed(e) {
    var t;
    (t = this._list.value) === null || t === void 0 || t.hide(e);
  }
};
l0 = JQe([
  wT(0, cf),
  wT(1, yt),
  wT(2, bt)
], l0);
an(
  z0,
  l0,
  1
  /* InstantiationType.Delayed */
);
const XS = 1100;
oi(class extends Ga {
  constructor() {
    super({
      id: "hideCodeActionWidget",
      title: {
        value: C("hideCodeActionWidget.title", "Hide action widget"),
        original: "Hide action widget"
      },
      precondition: a0.Visible,
      keybinding: {
        weight: XS,
        primary: 9,
        secondary: [
          1033
          /* KeyCode.Escape */
        ]
      }
    });
  }
  run(i) {
    i.get(z0).hide();
  }
});
oi(class extends Ga {
  constructor() {
    super({
      id: "selectPrevCodeAction",
      title: {
        value: C("selectPrevCodeAction.title", "Select previous action"),
        original: "Select previous action"
      },
      precondition: a0.Visible,
      keybinding: {
        weight: XS,
        primary: 16,
        secondary: [
          2064
          /* KeyCode.UpArrow */
        ],
        mac: { primary: 16, secondary: [
          2064,
          302
          /* KeyCode.KeyP */
        ] }
      }
    });
  }
  run(i) {
    const e = i.get(z0);
    e instanceof l0 && e.focusPrevious();
  }
});
oi(class extends Ga {
  constructor() {
    super({
      id: "selectNextCodeAction",
      title: {
        value: C("selectNextCodeAction.title", "Select next action"),
        original: "Select next action"
      },
      precondition: a0.Visible,
      keybinding: {
        weight: XS,
        primary: 18,
        secondary: [
          2066
          /* KeyCode.DownArrow */
        ],
        mac: { primary: 18, secondary: [
          2066,
          300
          /* KeyCode.KeyN */
        ] }
      }
    });
  }
  run(i) {
    const e = i.get(z0);
    e instanceof l0 && e.focusNext();
  }
});
oi(class extends Ga {
  constructor() {
    super({
      id: C0e,
      title: {
        value: C("acceptSelected.title", "Accept selected action"),
        original: "Accept selected action"
      },
      precondition: a0.Visible,
      keybinding: {
        weight: XS,
        primary: 3,
        secondary: [
          2137
          /* KeyCode.Period */
        ]
      }
    });
  }
  run(i) {
    const e = i.get(z0);
    e instanceof l0 && e.acceptSelected();
  }
});
oi(class extends Ga {
  constructor() {
    super({
      id: y0e,
      title: {
        value: C("previewSelected.title", "Preview selected action"),
        original: "Preview selected action"
      },
      precondition: a0.Visible,
      keybinding: {
        weight: XS,
        primary: 2051
      }
    });
  }
  run(i) {
    const e = i.get(z0);
    e instanceof l0 && e.acceptSelected(!0);
  }
});
var $Qe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const S0e = new Ke("supportedCodeAction", "");
class eJe extends we {
  constructor(e, t, n, r = 250) {
    super(), this._editor = e, this._markerService = t, this._signalChange = n, this._delay = r, this._autoTriggerTimer = this._register(new uc()), this._register(this._markerService.onMarkerChanged((s) => this._onMarkerChanges(s))), this._register(this._editor.onDidChangeCursorPosition(() => this._tryAutoTrigger()));
  }
  trigger(e) {
    const t = this._getRangeOfSelectionUnlessWhitespaceEnclosed(e);
    this._signalChange(t ? { trigger: e, selection: t } : void 0);
  }
  _onMarkerChanges(e) {
    const t = this._editor.getModel();
    t && e.some((n) => Tz(n, t.uri)) && this._tryAutoTrigger();
  }
  _tryAutoTrigger() {
    this._autoTriggerTimer.cancelAndSet(() => {
      this.trigger({ type: 2, triggerAction: la.Default });
    }, this._delay);
  }
  _getRangeOfSelectionUnlessWhitespaceEnclosed(e) {
    if (!this._editor.hasModel())
      return;
    const t = this._editor.getModel(), n = this._editor.getSelection();
    if (n.isEmpty() && e.type === 2) {
      const { lineNumber: r, column: s } = n.getPosition(), o = t.getLineContent(r);
      if (o.length === 0)
        return;
      if (s === 1) {
        if (/\s/.test(o[0]))
          return;
      } else if (s === t.getLineMaxColumn(r)) {
        if (/\s/.test(o[o.length - 1]))
          return;
      } else if (/\s/.test(o[s - 2]) && /\s/.test(o[s - 1]))
        return;
    }
    return n;
  }
}
var im;
(function(i) {
  i.Empty = {
    type: 0
    /* Type.Empty */
  };
  class e {
    constructor(n, r, s) {
      this.trigger = n, this.position = r, this._cancellablePromise = s, this.type = 1, this.actions = s.catch((o) => {
        if (md(o))
          return x0e;
        throw o;
      });
    }
    cancel() {
      this._cancellablePromise.cancel();
    }
  }
  i.Triggered = e;
})(im || (im = {}));
const x0e = Object.freeze({
  allActions: [],
  validActions: [],
  dispose: () => {
  },
  documentation: [],
  hasAutoFix: !1
});
class tJe extends we {
  constructor(e, t, n, r, s, o) {
    super(), this._editor = e, this._registry = t, this._markerService = n, this._progressService = s, this._configurationService = o, this._codeActionOracle = this._register(new ds()), this._state = im.Empty, this._onDidChangeState = this._register(new pe()), this.onDidChangeState = this._onDidChangeState.event, this._disposed = !1, this._supportedCodeActions = S0e.bindTo(r), this._register(this._editor.onDidChangeModel(() => this._update())), this._register(this._editor.onDidChangeModelLanguage(() => this._update())), this._register(this._registry.onDidChange(() => this._update())), this._update();
  }
  dispose() {
    this._disposed || (this._disposed = !0, super.dispose(), this.setState(im.Empty, !0));
  }
  _settingEnabledNearbyQuickfixes() {
    var e;
    const t = (e = this._editor) === null || e === void 0 ? void 0 : e.getModel();
    return this._configurationService ? this._configurationService.getValue("editor.codeActionWidget.includeNearbyQuickfixes", { resource: t?.uri }) : !1;
  }
  _update() {
    if (this._disposed)
      return;
    this._codeActionOracle.value = void 0, this.setState(im.Empty);
    const e = this._editor.getModel();
    if (e && this._registry.has(e) && !this._editor.getOption(
      90
      /* EditorOption.readOnly */
    )) {
      const t = this._registry.all(e).flatMap((n) => {
        var r;
        return (r = n.providedCodeActionKinds) !== null && r !== void 0 ? r : [];
      });
      this._supportedCodeActions.set(t.join(" ")), this._codeActionOracle.value = new eJe(this._editor, this._markerService, (n) => {
        var r;
        if (!n) {
          this.setState(im.Empty);
          return;
        }
        const s = n.selection.getStartPosition(), o = Ir((a) => $Qe(this, void 0, void 0, function* () {
          var l, c, d, u, h, f;
          if (this._settingEnabledNearbyQuickfixes() && n.trigger.type === 1 && (n.trigger.triggerAction === la.QuickFix || !((c = (l = n.trigger.filter) === null || l === void 0 ? void 0 : l.include) === null || c === void 0) && c.contains(vt.QuickFix))) {
            const g = yield zC(this._registry, e, n.selection, n.trigger, Hh.None, a);
            if (a.isCancellationRequested)
              return x0e;
            if (!((d = g.validActions) === null || d === void 0 ? void 0 : d.some((m) => m.action.kind ? vt.QuickFix.contains(new vt(m.action.kind)) : !1))) {
              const m = this._markerService.read({ resource: e.uri });
              if (m.length > 0) {
                const _ = n.selection.getPosition();
                let b = _, w = Number.MAX_VALUE, y = !1;
                for (const S of m) {
                  const x = S.endColumn, D = S.endLineNumber, E = S.startLineNumber;
                  (D === _.lineNumber || E === _.lineNumber) && Math.abs(_.column - x) < w && (w = Math.abs(_.column - x), y = !0, b = new ve(D, x));
                }
                if (y) {
                  const S = {
                    type: n.trigger.type,
                    triggerAction: n.trigger.triggerAction,
                    filter: { include: !((u = n.trigger.filter) === null || u === void 0) && u.include ? (h = n.trigger.filter) === null || h === void 0 ? void 0 : h.include : vt.QuickFix },
                    autoApply: n.trigger.autoApply,
                    context: { notAvailableMessage: ((f = n.trigger.context) === null || f === void 0 ? void 0 : f.notAvailableMessage) || "", position: b }
                  }, x = new ot(b.lineNumber, b.column, b.lineNumber, b.column), D = yield zC(this._registry, e, x, S, Hh.None, a), E = [...g.validActions];
                  return D.validActions.length !== 0 && (D.validActions.forEach((L) => {
                    L.highlightRange = L.action.isPreferred;
                  }), E.push(...D.validActions)), { validActions: E, allActions: g.allActions, documentation: g.documentation, hasAutoFix: g.hasAutoFix, dispose: () => {
                    g.dispose();
                  } };
                }
              }
            }
          }
          return zC(this._registry, e, n.selection, n.trigger, Hh.None, a);
        }));
        n.trigger.type === 1 && ((r = this._progressService) === null || r === void 0 || r.showWhile(o, 250)), this.setState(new im.Triggered(n.trigger, s, o));
      }, void 0), this._codeActionOracle.value.trigger({ type: 2, triggerAction: la.Default });
    } else
      this._supportedCodeActions.reset();
  }
  trigger(e) {
    var t;
    (t = this._codeActionOracle.value) === null || t === void 0 || t.trigger(e);
  }
  setState(e, t) {
    e !== this._state && (this._state.type === 1 && this._state.cancel(), this._state = e, !t && !this._disposed && this._onDidChangeState.fire(e));
  }
}
var nJe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Gu = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, g2 = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, rE;
const iJe = "quickfix-edit-highlight";
let qg = rE = class extends we {
  static get(e) {
    return e.getContribution(rE.ID);
  }
  constructor(e, t, n, r, s, o, a, l, c, d) {
    super(), this._commandService = a, this._configurationService = l, this._actionWidgetService = c, this._instantiationService = d, this._activeCodeActions = this._register(new ds()), this._showDisabled = !1, this._disposed = !1, this._editor = e, this._model = this._register(new tJe(this._editor, s.codeActionProvider, t, n, o, l)), this._register(this._model.onDidChangeState((u) => this.update(u))), this._lightBulbWidget = new lp(() => {
      const u = this._editor.getContribution(o0.ID);
      return u && this._register(u.onClick((h) => this.showCodeActionList(h.actions, h, { includeDisabledActions: !1, fromLightbulb: !0 }))), u;
    }), this._resolver = r.createInstance(gI), this._register(this._editor.onDidLayoutChange(() => this._actionWidgetService.hide()));
  }
  dispose() {
    this._disposed = !0, super.dispose();
  }
  showCodeActions(e, t, n) {
    return this.showCodeActionList(t, n, { includeDisabledActions: !1, fromLightbulb: !1 });
  }
  manualTriggerAtCurrentPosition(e, t, n, r) {
    var s;
    if (!this._editor.hasModel())
      return;
    (s = ra.get(this._editor)) === null || s === void 0 || s.closeMessage();
    const o = this._editor.getPosition();
    this._trigger({ type: 1, triggerAction: t, filter: n, autoApply: r, context: { notAvailableMessage: e, position: o } });
  }
  _trigger(e) {
    return this._model.trigger(e);
  }
  _applyCodeAction(e, t, n) {
    return g2(this, void 0, void 0, function* () {
      try {
        yield this._instantiationService.invokeFunction(RQe, e, fI.FromCodeActions, { preview: n, editor: this._editor });
      } finally {
        t && this._trigger({ type: 2, triggerAction: la.QuickFix, filter: {} });
      }
    });
  }
  update(e) {
    var t, n, r, s, o, a, l;
    return g2(this, void 0, void 0, function* () {
      if (e.type !== 1) {
        (t = this._lightBulbWidget.rawValue) === null || t === void 0 || t.hide();
        return;
      }
      let c;
      try {
        c = yield e.actions;
      } catch (d) {
        It(d);
        return;
      }
      if (!this._disposed)
        if ((n = this._lightBulbWidget.value) === null || n === void 0 || n.update(c, e.trigger, e.position), e.trigger.type === 1) {
          if (!((r = e.trigger.filter) === null || r === void 0) && r.include) {
            const u = this.tryGetValidActionToApply(e.trigger, c);
            if (u) {
              try {
                (s = this._lightBulbWidget.value) === null || s === void 0 || s.hide(), yield this._applyCodeAction(u, !1, !1);
              } finally {
                c.dispose();
              }
              return;
            }
            if (e.trigger.context) {
              const h = this.getInvalidActionThatWouldHaveBeenApplied(e.trigger, c);
              if (h && h.action.disabled) {
                (o = ra.get(this._editor)) === null || o === void 0 || o.showMessage(h.action.disabled, e.trigger.context.position), c.dispose();
                return;
              }
            }
          }
          const d = !!(!((a = e.trigger.filter) === null || a === void 0) && a.include);
          if (e.trigger.context && (!c.allActions.length || !d && !c.validActions.length)) {
            (l = ra.get(this._editor)) === null || l === void 0 || l.showMessage(e.trigger.context.notAvailableMessage, e.trigger.context.position), this._activeCodeActions.value = c, c.dispose();
            return;
          }
          this._activeCodeActions.value = c, this.showCodeActionList(c, this.toCoords(e.position), { includeDisabledActions: d, fromLightbulb: !1 });
        } else
          this._actionWidgetService.isVisible ? c.dispose() : this._activeCodeActions.value = c;
    });
  }
  getInvalidActionThatWouldHaveBeenApplied(e, t) {
    if (t.allActions.length && (e.autoApply === "first" && t.validActions.length === 0 || e.autoApply === "ifSingle" && t.allActions.length === 1))
      return t.allActions.find(({ action: n }) => n.disabled);
  }
  tryGetValidActionToApply(e, t) {
    if (t.validActions.length && (e.autoApply === "first" && t.validActions.length > 0 || e.autoApply === "ifSingle" && t.validActions.length === 1))
      return t.validActions[0];
  }
  showCodeActionList(e, t, n) {
    return g2(this, void 0, void 0, function* () {
      const r = this._editor.createDecorationsCollection(), s = this._editor.getDomNode();
      if (!s)
        return;
      const o = n.includeDisabledActions && (this._showDisabled || e.validActions.length === 0) ? e.allActions : e.validActions;
      if (!o.length)
        return;
      const a = ve.isIPosition(t) ? this.toCoords(t) : t, l = {
        onSelect: (c, d) => g2(this, void 0, void 0, function* () {
          this._applyCodeAction(
            c,
            /* retrigger */
            !0,
            !!d
          ), this._actionWidgetService.hide(), r.clear();
        }),
        onHide: () => {
          var c;
          (c = this._editor) === null || c === void 0 || c.focus(), r.clear();
        },
        onHover: (c, d) => g2(this, void 0, void 0, function* () {
          var u;
          if (yield c.resolve(d), !d.isCancellationRequested)
            return { canPreview: !!(!((u = c.action.edit) === null || u === void 0) && u.edits.length) };
        }),
        onFocus: (c) => {
          var d, u;
          if (c && c.highlightRange && c.action.diagnostics) {
            const h = [{ range: c.action.diagnostics[0], options: rE.DECORATION }];
            r.set(h);
            const f = c.action.diagnostics[0], g = (u = (d = this._editor.getModel()) === null || d === void 0 ? void 0 : d.getWordAtPosition({ lineNumber: f.startLineNumber, column: f.startColumn })) === null || u === void 0 ? void 0 : u.word;
            Vg(C("editingNewSelection", "Context: {0} at line {1} and column {2}.", g, f.startLineNumber, f.startColumn));
          } else
            r.clear();
        }
      };
      this._actionWidgetService.show("codeActionWidget", !0, WQe(o, this._shouldShowHeaders(), this._resolver.getResolver()), l, a, s, this._getActionBarActions(e, t, n));
    });
  }
  toCoords(e) {
    if (!this._editor.hasModel())
      return { x: 0, y: 0 };
    this._editor.revealPosition(
      e,
      1
      /* ScrollType.Immediate */
    ), this._editor.render();
    const t = this._editor.getScrolledVisiblePosition(e), n = wr(this._editor.getDomNode()), r = n.left + t.left, s = n.top + t.top + t.height;
    return { x: r, y: s };
  }
  _shouldShowHeaders() {
    var e;
    const t = (e = this._editor) === null || e === void 0 ? void 0 : e.getModel();
    return this._configurationService.getValue("editor.codeActionWidget.showHeaders", { resource: t?.uri });
  }
  _getActionBarActions(e, t, n) {
    if (n.fromLightbulb)
      return [];
    const r = e.documentation.map((s) => {
      var o;
      return {
        id: s.id,
        label: s.title,
        tooltip: (o = s.tooltip) !== null && o !== void 0 ? o : "",
        class: void 0,
        enabled: !0,
        run: () => {
          var a;
          return this._commandService.executeCommand(s.id, ...(a = s.arguments) !== null && a !== void 0 ? a : []);
        }
      };
    });
    return n.includeDisabledActions && e.validActions.length > 0 && e.allActions.length !== e.validActions.length && r.push(this._showDisabled ? {
      id: "hideMoreActions",
      label: C("hideMoreActions", "Hide Disabled"),
      enabled: !0,
      tooltip: "",
      class: void 0,
      run: () => (this._showDisabled = !1, this.showCodeActionList(e, t, n))
    } : {
      id: "showMoreActions",
      label: C("showMoreActions", "Show Disabled"),
      enabled: !0,
      tooltip: "",
      class: void 0,
      run: () => (this._showDisabled = !0, this.showCodeActionList(e, t, n))
    }), r;
  }
};
qg.ID = "editor.contrib.codeActionController";
qg.DECORATION = Lt.register({
  description: "quickfix-highlight",
  className: iJe
});
qg = rE = nJe([
  Gu(1, Fu),
  Gu(2, yt),
  Gu(3, bt),
  Gu(4, tt),
  Gu(5, hp),
  Gu(6, Ui),
  Gu(7, en),
  Gu(8, z0),
  Gu(9, bt)
], qg);
fc((i, e) => {
  ((r, s) => {
    s && e.addRule(`.monaco-editor ${r} { background-color: ${s}; }`);
  })(".quickfix-edit-highlight", i.getColor(nu));
  const n = i.getColor($f);
  n && e.addRule(`.monaco-editor .quickfix-edit-highlight { border: 1px ${ed(i.type) ? "dotted" : "solid"} ${n}; box-sizing: border-box; }`);
});
function ZS(i) {
  return ke.regex(S0e.keys()[0], new RegExp("(\\s|^)" + Va(i.value) + "\\b"));
}
const nG = {
  type: "object",
  defaultSnippets: [{ body: { kind: "" } }],
  properties: {
    kind: {
      type: "string",
      description: C("args.schema.kind", "Kind of the code action to run.")
    },
    apply: {
      type: "string",
      description: C("args.schema.apply", "Controls when the returned actions are applied."),
      default: "ifSingle",
      enum: [
        "first",
        "ifSingle",
        "never"
        /* CodeActionAutoApply.Never */
      ],
      enumDescriptions: [
        C("args.schema.apply.first", "Always apply the first returned code action."),
        C("args.schema.apply.ifSingle", "Apply the first returned code action if it is the only one."),
        C("args.schema.apply.never", "Do not apply the returned code actions.")
      ]
    },
    preferred: {
      type: "boolean",
      default: !1,
      description: C("args.schema.preferred", "Controls if only preferred code actions should be returned.")
    }
  }
};
function U0(i, e, t, n, r = la.Default) {
  if (i.hasModel()) {
    const s = qg.get(i);
    s?.manualTriggerAtCurrentPosition(e, r, t, n);
  }
}
class rJe extends Je {
  constructor() {
    super({
      id: $U,
      label: C("quickfix.trigger.label", "Quick Fix..."),
      alias: "Quick Fix...",
      precondition: ke.and($.writable, $.hasCodeActionsProvider),
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 2137,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    return U0(t, C("editor.action.quickFix.noneMessage", "No code actions available"), void 0, void 0, la.QuickFix);
  }
}
class sJe extends Kr {
  constructor() {
    super({
      id: h0e,
      precondition: ke.and($.writable, $.hasCodeActionsProvider),
      description: {
        description: "Trigger a code action",
        args: [{ name: "args", schema: nG }]
      }
    });
  }
  runEditorCommand(e, t, n) {
    const r = Yd.fromUser(n, {
      kind: vt.Empty,
      apply: "ifSingle"
    });
    return U0(t, typeof n?.kind == "string" ? r.preferred ? C("editor.action.codeAction.noneMessage.preferred.kind", "No preferred code actions for '{0}' available", n.kind) : C("editor.action.codeAction.noneMessage.kind", "No code actions for '{0}' available", n.kind) : r.preferred ? C("editor.action.codeAction.noneMessage.preferred", "No preferred code actions available") : C("editor.action.codeAction.noneMessage", "No code actions available"), {
      include: r.kind,
      includeSourceActions: !0,
      onlyIncludePreferredActions: r.preferred
    }, r.apply);
  }
}
class oJe extends Je {
  constructor() {
    super({
      id: g0e,
      label: C("refactor.label", "Refactor..."),
      alias: "Refactor...",
      precondition: ke.and($.writable, $.hasCodeActionsProvider),
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 3120,
        mac: {
          primary: 1328
          /* KeyCode.KeyR */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      contextMenuOpts: {
        group: "1_modification",
        order: 2,
        when: ke.and($.writable, ZS(vt.Refactor))
      },
      description: {
        description: "Refactor...",
        args: [{ name: "args", schema: nG }]
      }
    });
  }
  run(e, t, n) {
    const r = Yd.fromUser(n, {
      kind: vt.Refactor,
      apply: "never"
      /* CodeActionAutoApply.Never */
    });
    return U0(t, typeof n?.kind == "string" ? r.preferred ? C("editor.action.refactor.noneMessage.preferred.kind", "No preferred refactorings for '{0}' available", n.kind) : C("editor.action.refactor.noneMessage.kind", "No refactorings for '{0}' available", n.kind) : r.preferred ? C("editor.action.refactor.noneMessage.preferred", "No preferred refactorings available") : C("editor.action.refactor.noneMessage", "No refactorings available"), {
      include: vt.Refactor.contains(r.kind) ? r.kind : vt.None,
      onlyIncludePreferredActions: r.preferred
    }, r.apply, la.Refactor);
  }
}
class aJe extends Je {
  constructor() {
    super({
      id: p0e,
      label: C("source.label", "Source Action..."),
      alias: "Source Action...",
      precondition: ke.and($.writable, $.hasCodeActionsProvider),
      contextMenuOpts: {
        group: "1_modification",
        order: 2.1,
        when: ke.and($.writable, ZS(vt.Source))
      },
      description: {
        description: "Source Action...",
        args: [{ name: "args", schema: nG }]
      }
    });
  }
  run(e, t, n) {
    const r = Yd.fromUser(n, {
      kind: vt.Source,
      apply: "never"
      /* CodeActionAutoApply.Never */
    });
    return U0(t, typeof n?.kind == "string" ? r.preferred ? C("editor.action.source.noneMessage.preferred.kind", "No preferred source actions for '{0}' available", n.kind) : C("editor.action.source.noneMessage.kind", "No source actions for '{0}' available", n.kind) : r.preferred ? C("editor.action.source.noneMessage.preferred", "No preferred source actions available") : C("editor.action.source.noneMessage", "No source actions available"), {
      include: vt.Source.contains(r.kind) ? r.kind : vt.None,
      includeSourceActions: !0,
      onlyIncludePreferredActions: r.preferred
    }, r.apply, la.SourceAction);
  }
}
class lJe extends Je {
  constructor() {
    super({
      id: eG,
      label: C("organizeImports.label", "Organize Imports"),
      alias: "Organize Imports",
      precondition: ke.and($.writable, ZS(vt.SourceOrganizeImports)),
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 1581,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    return U0(t, C("editor.action.organize.noneMessage", "No organize imports action available"), { include: vt.SourceOrganizeImports, includeSourceActions: !0 }, "ifSingle", la.OrganizeImports);
  }
}
class cJe extends Je {
  constructor() {
    super({
      id: tG,
      label: C("fixAll.label", "Fix All"),
      alias: "Fix All",
      precondition: ke.and($.writable, ZS(vt.SourceFixAll))
    });
  }
  run(e, t) {
    return U0(t, C("fixAll.noneMessage", "No fix all action available"), { include: vt.SourceFixAll, includeSourceActions: !0 }, "ifSingle", la.FixAll);
  }
}
class dJe extends Je {
  constructor() {
    super({
      id: f0e,
      label: C("autoFix.label", "Auto Fix..."),
      alias: "Auto Fix...",
      precondition: ke.and($.writable, ZS(vt.QuickFix)),
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 1625,
        mac: {
          primary: 2649
          /* KeyCode.Period */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    return U0(t, C("editor.action.autoFix.noneMessage", "No auto fixes available"), {
      include: vt.QuickFix,
      onlyIncludePreferredActions: !0
    }, "ifSingle", la.AutoFix);
  }
}
pn(
  qg.ID,
  qg,
  3
  /* EditorContributionInstantiation.Eventually */
);
pn(
  o0.ID,
  o0,
  4
  /* EditorContributionInstantiation.Lazy */
);
Be(rJe);
Be(oJe);
Be(aJe);
Be(lJe);
Be(dJe);
Be(cJe);
ze(new sJe());
Di.as(_d.Configuration).registerConfiguration(Object.assign(Object.assign({}, k4), { properties: {
  "editor.codeActionWidget.showHeaders": {
    type: "boolean",
    scope: 5,
    description: C("showCodeActionHeaders", "Enable/disable showing group headers in the Code Action menu."),
    default: !0
  }
} }));
Di.as(_d.Configuration).registerConfiguration(Object.assign(Object.assign({}, k4), { properties: {
  "editor.codeActionWidget.includeNearbyQuickfixes": {
    type: "boolean",
    scope: 5,
    description: C("includeNearbyQuickfixes", "Enable/disable showing nearest quickfix within a line when not currently on a diagnostic."),
    default: !1
  }
} }));
var m$ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class PV {
  constructor() {
    this.lenses = [], this._disposables = new Ne();
  }
  dispose() {
    this._disposables.dispose();
  }
  get isDisposed() {
    return this._disposables.isDisposed;
  }
  add(e, t) {
    this._disposables.add(e);
    for (const n of e.lenses)
      this.lenses.push({ symbol: n, provider: t });
  }
}
function D0e(i, e, t) {
  return m$(this, void 0, void 0, function* () {
    const n = i.ordered(e), r = /* @__PURE__ */ new Map(), s = new PV(), o = n.map((a, l) => m$(this, void 0, void 0, function* () {
      r.set(a, l);
      try {
        const c = yield Promise.resolve(a.provideCodeLenses(e, t));
        c && s.add(c, a);
      } catch (c) {
        vr(c);
      }
    }));
    return yield Promise.all(o), s.lenses = s.lenses.sort((a, l) => a.symbol.range.startLineNumber < l.symbol.range.startLineNumber ? -1 : a.symbol.range.startLineNumber > l.symbol.range.startLineNumber ? 1 : r.get(a.provider) < r.get(l.provider) ? -1 : r.get(a.provider) > r.get(l.provider) ? 1 : a.symbol.range.startColumn < l.symbol.range.startColumn ? -1 : a.symbol.range.startColumn > l.symbol.range.startColumn ? 1 : 0), s;
  });
}
on.registerCommand("_executeCodeLensProvider", function(i, ...e) {
  let [t, n] = e;
  On(pt.isUri(t)), On(typeof n == "number" || !n);
  const { codeLensProvider: r } = i.get(tt), s = i.get(fi).getModel(t);
  if (!s)
    throw fl();
  const o = [], a = new Ne();
  return D0e(r, s, jt.None).then((l) => {
    a.add(l);
    const c = [];
    for (const d of l.lenses)
      n == null || d.symbol.command ? o.push(d.symbol) : n-- > 0 && d.provider.resolveCodeLens && c.push(Promise.resolve(d.provider.resolveCodeLens(s, d.symbol, jt.None)).then((u) => o.push(u || d.symbol)));
    return Promise.all(c);
  }).then(() => o).finally(() => {
    setTimeout(() => a.dispose(), 100);
  });
});
var uJe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, hJe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const E0e = Gt("ICodeLensCache");
class v$ {
  constructor(e, t) {
    this.lineCount = e, this.data = t;
  }
}
let OV = class {
  constructor(e) {
    this._fakeProvider = new class {
      provideCodeLenses() {
        throw new Error("not supported");
      }
    }(), this._cache = new cp(20, 0.75);
    const t = "codelens/cache";
    xh(() => e.remove(
      t,
      1
      /* StorageScope.WORKSPACE */
    ));
    const n = "codelens/cache2", r = e.get(n, 1, "{}");
    this._deserialize(r), qe.once(e.onWillSaveState)((s) => {
      s.reason === VL.SHUTDOWN && e.store(
        n,
        this._serialize(),
        1,
        1
        /* StorageTarget.MACHINE */
      );
    });
  }
  put(e, t) {
    const n = t.lenses.map((o) => {
      var a;
      return {
        range: o.symbol.range,
        command: o.symbol.command && { id: "", title: (a = o.symbol.command) === null || a === void 0 ? void 0 : a.title }
      };
    }), r = new PV();
    r.add({ lenses: n, dispose: () => {
    } }, this._fakeProvider);
    const s = new v$(e.getLineCount(), r);
    this._cache.set(e.uri.toString(), s);
  }
  get(e) {
    const t = this._cache.get(e.uri.toString());
    return t && t.lineCount === e.getLineCount() ? t.data : void 0;
  }
  delete(e) {
    this._cache.delete(e.uri.toString());
  }
  // --- persistence
  _serialize() {
    const e = /* @__PURE__ */ Object.create(null);
    for (const [t, n] of this._cache) {
      const r = /* @__PURE__ */ new Set();
      for (const s of n.data.lenses)
        r.add(s.symbol.range.startLineNumber);
      e[t] = {
        lineCount: n.lineCount,
        lines: [...r.values()]
      };
    }
    return JSON.stringify(e);
  }
  _deserialize(e) {
    try {
      const t = JSON.parse(e);
      for (const n in t) {
        const r = t[n], s = [];
        for (const a of r.lines)
          s.push({ range: new V(a, 1, a, 11) });
        const o = new PV();
        o.add({ lenses: s, dispose() {
        } }, this._fakeProvider), this._cache.set(n, new v$(r.lineCount, o));
      }
    } catch {
    }
  }
};
OV = uJe([
  hJe(0, mc)
], OV);
an(
  E0e,
  OV,
  1
  /* InstantiationType.Delayed */
);
class fJe {
  constructor(e, t, n) {
    this.afterColumn = 1073741824, this.afterLineNumber = e, this.heightInPx = t, this._onHeight = n, this.suppressMouseDown = !0, this.domNode = document.createElement("div");
  }
  onComputedHeight(e) {
    this._lastHeight === void 0 ? this._lastHeight = e : this._lastHeight !== e && (this._lastHeight = e, this._onHeight());
  }
  isVisible() {
    return this._lastHeight !== 0 && this.domNode.hasAttribute("monaco-visible-view-zone");
  }
}
class d5 {
  constructor(e, t) {
    this.allowEditorOverflow = !1, this.suppressMouseDown = !0, this._commands = /* @__PURE__ */ new Map(), this._isEmpty = !0, this._editor = e, this._id = `codelens.widget-${d5._idPool++}`, this.updatePosition(t), this._domNode = document.createElement("span"), this._domNode.className = "codelens-decoration";
  }
  withCommands(e, t) {
    this._commands.clear();
    const n = [];
    let r = !1;
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      if (o && (r = !0, o.command)) {
        const a = bg(o.command.title.trim());
        o.command.id ? (n.push(Re("a", { id: String(s), title: o.command.tooltip, role: "button" }, ...a)), this._commands.set(String(s), o.command)) : n.push(Re("span", { title: o.command.tooltip }, ...a)), s + 1 < e.length && n.push(Re("span", void 0, " | "));
      }
    }
    r ? (cs(this._domNode, ...n), this._isEmpty && t && this._domNode.classList.add("fadein"), this._isEmpty = !1) : cs(this._domNode, Re("span", void 0, "no commands"));
  }
  getCommand(e) {
    return e.parentElement === this._domNode ? this._commands.get(e.id) : void 0;
  }
  getId() {
    return this._id;
  }
  getDomNode() {
    return this._domNode;
  }
  updatePosition(e) {
    const t = this._editor.getModel().getLineFirstNonWhitespaceColumn(e);
    this._widgetPosition = {
      position: { lineNumber: e, column: t },
      preference: [
        1
        /* ContentWidgetPositionPreference.ABOVE */
      ]
    };
  }
  getPosition() {
    return this._widgetPosition || null;
  }
}
d5._idPool = 0;
class ST {
  constructor() {
    this._removeDecorations = [], this._addDecorations = [], this._addDecorationsCallbacks = [];
  }
  addDecoration(e, t) {
    this._addDecorations.push(e), this._addDecorationsCallbacks.push(t);
  }
  removeDecoration(e) {
    this._removeDecorations.push(e);
  }
  commit(e) {
    const t = e.deltaDecorations(this._removeDecorations, this._addDecorations);
    for (let n = 0, r = t.length; n < r; n++)
      this._addDecorationsCallbacks[n](t[n]);
  }
}
const _$ = Lt.register({
  collapseOnReplaceEdit: !0,
  description: "codelens"
});
class b$ {
  constructor(e, t, n, r, s, o) {
    this._isDisposed = !1, this._editor = t, this._data = e, this._decorationIds = [];
    let a;
    const l = [];
    this._data.forEach((c, d) => {
      c.symbol.command && l.push(c.symbol), n.addDecoration({
        range: c.symbol.range,
        options: _$
      }, (u) => this._decorationIds[d] = u), a ? a = V.plusRange(a, c.symbol.range) : a = V.lift(c.symbol.range);
    }), this._viewZone = new fJe(a.startLineNumber - 1, s, o), this._viewZoneId = r.addZone(this._viewZone), l.length > 0 && (this._createContentWidgetIfNecessary(), this._contentWidget.withCommands(l, !1));
  }
  _createContentWidgetIfNecessary() {
    this._contentWidget ? this._editor.layoutContentWidget(this._contentWidget) : (this._contentWidget = new d5(this._editor, this._viewZone.afterLineNumber + 1), this._editor.addContentWidget(this._contentWidget));
  }
  dispose(e, t) {
    this._decorationIds.forEach(e.removeDecoration, e), this._decorationIds = [], t?.removeZone(this._viewZoneId), this._contentWidget && (this._editor.removeContentWidget(this._contentWidget), this._contentWidget = void 0), this._isDisposed = !0;
  }
  isDisposed() {
    return this._isDisposed;
  }
  isValid() {
    return this._decorationIds.some((e, t) => {
      const n = this._editor.getModel().getDecorationRange(e), r = this._data[t].symbol;
      return !!(n && V.isEmpty(r.range) === n.isEmpty());
    });
  }
  updateCodeLensSymbols(e, t) {
    this._decorationIds.forEach(t.removeDecoration, t), this._decorationIds = [], this._data = e, this._data.forEach((n, r) => {
      t.addDecoration({
        range: n.symbol.range,
        options: _$
      }, (s) => this._decorationIds[r] = s);
    });
  }
  updateHeight(e, t) {
    this._viewZone.heightInPx = e, t.layoutZone(this._viewZoneId), this._contentWidget && this._editor.layoutContentWidget(this._contentWidget);
  }
  computeIfNecessary(e) {
    if (!this._viewZone.isVisible())
      return null;
    for (let t = 0; t < this._decorationIds.length; t++) {
      const n = e.getDecorationRange(this._decorationIds[t]);
      n && (this._data[t].symbol.range = n);
    }
    return this._data;
  }
  updateCommands(e) {
    this._createContentWidgetIfNecessary(), this._contentWidget.withCommands(e, !0);
    for (let t = 0; t < this._data.length; t++) {
      const n = e[t];
      if (n) {
        const { symbol: r } = this._data[t];
        r.command = n.command || r.command;
      }
    }
  }
  getCommand(e) {
    var t;
    return (t = this._contentWidget) === null || t === void 0 ? void 0 : t.getCommand(e);
  }
  getLineNumber() {
    const e = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
    return e ? e.startLineNumber : -1;
  }
  update(e) {
    if (this.isValid()) {
      const t = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
      t && (this._viewZone.afterLineNumber = t.startLineNumber - 1, e.layoutZone(this._viewZoneId), this._contentWidget && (this._contentWidget.updatePosition(t.startLineNumber), this._editor.layoutContentWidget(this._contentWidget)));
    }
  }
}
var gJe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, p2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, L0e = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let B_ = class {
  constructor(e, t, n, r, s, o) {
    this._editor = e, this._languageFeaturesService = t, this._commandService = r, this._notificationService = s, this._codeLensCache = o, this._disposables = new Ne(), this._localToDispose = new Ne(), this._lenses = [], this._oldCodeLensModels = new Ne(), this._provideCodeLensDebounce = n.for(t.codeLensProvider, "CodeLensProvide", { min: 250 }), this._resolveCodeLensesDebounce = n.for(t.codeLensProvider, "CodeLensResolve", { min: 250, salt: "resolve" }), this._resolveCodeLensesScheduler = new Rn(() => this._resolveCodeLensesInViewport(), this._resolveCodeLensesDebounce.default()), this._disposables.add(this._editor.onDidChangeModel(() => this._onModelChange())), this._disposables.add(this._editor.onDidChangeModelLanguage(() => this._onModelChange())), this._disposables.add(this._editor.onDidChangeConfiguration((a) => {
      (a.hasChanged(
        50
        /* EditorOption.fontInfo */
      ) || a.hasChanged(
        19
        /* EditorOption.codeLensFontSize */
      ) || a.hasChanged(
        18
        /* EditorOption.codeLensFontFamily */
      )) && this._updateLensStyle(), a.hasChanged(
        17
        /* EditorOption.codeLens */
      ) && this._onModelChange();
    })), this._disposables.add(t.codeLensProvider.onDidChange(this._onModelChange, this)), this._onModelChange(), this._updateLensStyle();
  }
  dispose() {
    var e;
    this._localDispose(), this._disposables.dispose(), this._oldCodeLensModels.dispose(), (e = this._currentCodeLensModel) === null || e === void 0 || e.dispose();
  }
  _getLayoutInfo() {
    const e = Math.max(1.3, this._editor.getOption(
      66
      /* EditorOption.lineHeight */
    ) / this._editor.getOption(
      52
      /* EditorOption.fontSize */
    ));
    let t = this._editor.getOption(
      19
      /* EditorOption.codeLensFontSize */
    );
    return (!t || t < 5) && (t = this._editor.getOption(
      52
      /* EditorOption.fontSize */
    ) * 0.9 | 0), {
      fontSize: t,
      codeLensHeight: t * e | 0
    };
  }
  _updateLensStyle() {
    const { codeLensHeight: e, fontSize: t } = this._getLayoutInfo(), n = this._editor.getOption(
      18
      /* EditorOption.codeLensFontFamily */
    ), r = this._editor.getOption(
      50
      /* EditorOption.fontInfo */
    ), { style: s } = this._editor.getContainerDomNode();
    s.setProperty("--vscode-editorCodeLens-lineHeight", `${e}px`), s.setProperty("--vscode-editorCodeLens-fontSize", `${t}px`), s.setProperty("--vscode-editorCodeLens-fontFeatureSettings", r.fontFeatureSettings), n && (s.setProperty("--vscode-editorCodeLens-fontFamily", n), s.setProperty("--vscode-editorCodeLens-fontFamilyDefault", na.fontFamily)), this._editor.changeViewZones((o) => {
      for (const a of this._lenses)
        a.updateHeight(e, o);
    });
  }
  _localDispose() {
    var e, t, n;
    (e = this._getCodeLensModelPromise) === null || e === void 0 || e.cancel(), this._getCodeLensModelPromise = void 0, (t = this._resolveCodeLensesPromise) === null || t === void 0 || t.cancel(), this._resolveCodeLensesPromise = void 0, this._localToDispose.clear(), this._oldCodeLensModels.clear(), (n = this._currentCodeLensModel) === null || n === void 0 || n.dispose();
  }
  _onModelChange() {
    this._localDispose();
    const e = this._editor.getModel();
    if (!e || !this._editor.getOption(
      17
      /* EditorOption.codeLens */
    ) || e.isTooLargeForTokenization())
      return;
    const t = this._codeLensCache.get(e);
    if (t && this._renderCodeLensSymbols(t), !this._languageFeaturesService.codeLensProvider.has(e)) {
      t && this._localToDispose.add(Rg(() => {
        const r = this._codeLensCache.get(e);
        t === r && (this._codeLensCache.delete(e), this._onModelChange());
      }, 30 * 1e3));
      return;
    }
    for (const r of this._languageFeaturesService.codeLensProvider.all(e))
      if (typeof r.onDidChange == "function") {
        const s = r.onDidChange(() => n.schedule());
        this._localToDispose.add(s);
      }
    const n = new Rn(() => {
      var r;
      const s = Date.now();
      (r = this._getCodeLensModelPromise) === null || r === void 0 || r.cancel(), this._getCodeLensModelPromise = Ir((o) => D0e(this._languageFeaturesService.codeLensProvider, e, o)), this._getCodeLensModelPromise.then((o) => {
        this._currentCodeLensModel && this._oldCodeLensModels.add(this._currentCodeLensModel), this._currentCodeLensModel = o, this._codeLensCache.put(e, o);
        const a = this._provideCodeLensDebounce.update(e, Date.now() - s);
        n.delay = a, this._renderCodeLensSymbols(o), this._resolveCodeLensesInViewportSoon();
      }, It);
    }, this._provideCodeLensDebounce.get(e));
    this._localToDispose.add(n), this._localToDispose.add(Ct(() => this._resolveCodeLensesScheduler.cancel())), this._localToDispose.add(this._editor.onDidChangeModelContent(() => {
      var r;
      this._editor.changeDecorations((s) => {
        this._editor.changeViewZones((o) => {
          const a = [];
          let l = -1;
          this._lenses.forEach((d) => {
            !d.isValid() || l === d.getLineNumber() ? a.push(d) : (d.update(o), l = d.getLineNumber());
          });
          const c = new ST();
          a.forEach((d) => {
            d.dispose(c, o), this._lenses.splice(this._lenses.indexOf(d), 1);
          }), c.commit(s);
        });
      }), n.schedule(), this._resolveCodeLensesScheduler.cancel(), (r = this._resolveCodeLensesPromise) === null || r === void 0 || r.cancel(), this._resolveCodeLensesPromise = void 0;
    })), this._localToDispose.add(this._editor.onDidFocusEditorWidget(() => {
      n.schedule();
    })), this._localToDispose.add(this._editor.onDidBlurEditorText(() => {
      n.cancel();
    })), this._localToDispose.add(this._editor.onDidScrollChange((r) => {
      r.scrollTopChanged && this._lenses.length > 0 && this._resolveCodeLensesInViewportSoon();
    })), this._localToDispose.add(this._editor.onDidLayoutChange(() => {
      this._resolveCodeLensesInViewportSoon();
    })), this._localToDispose.add(Ct(() => {
      if (this._editor.getModel()) {
        const r = ud.capture(this._editor);
        this._editor.changeDecorations((s) => {
          this._editor.changeViewZones((o) => {
            this._disposeAllLenses(s, o);
          });
        }), r.restore(this._editor);
      } else
        this._disposeAllLenses(void 0, void 0);
    })), this._localToDispose.add(this._editor.onMouseDown((r) => {
      if (r.target.type !== 9)
        return;
      let s = r.target.element;
      if (s?.tagName === "SPAN" && (s = s.parentElement), s?.tagName === "A")
        for (const o of this._lenses) {
          const a = o.getCommand(s);
          if (a) {
            this._commandService.executeCommand(a.id, ...a.arguments || []).catch((l) => this._notificationService.error(l));
            break;
          }
        }
    })), n.schedule();
  }
  _disposeAllLenses(e, t) {
    const n = new ST();
    for (const r of this._lenses)
      r.dispose(n, t);
    e && n.commit(e), this._lenses.length = 0;
  }
  _renderCodeLensSymbols(e) {
    if (!this._editor.hasModel())
      return;
    const t = this._editor.getModel().getLineCount(), n = [];
    let r;
    for (const a of e.lenses) {
      const l = a.symbol.range.startLineNumber;
      l < 1 || l > t || (r && r[r.length - 1].symbol.range.startLineNumber === l ? r.push(a) : (r = [a], n.push(r)));
    }
    if (!n.length && !this._lenses.length)
      return;
    const s = ud.capture(this._editor), o = this._getLayoutInfo();
    this._editor.changeDecorations((a) => {
      this._editor.changeViewZones((l) => {
        const c = new ST();
        let d = 0, u = 0;
        for (; u < n.length && d < this._lenses.length; ) {
          const h = n[u][0].symbol.range.startLineNumber, f = this._lenses[d].getLineNumber();
          f < h ? (this._lenses[d].dispose(c, l), this._lenses.splice(d, 1)) : f === h ? (this._lenses[d].updateCodeLensSymbols(n[u], c), u++, d++) : (this._lenses.splice(d, 0, new b$(n[u], this._editor, c, l, o.codeLensHeight, () => this._resolveCodeLensesInViewportSoon())), d++, u++);
        }
        for (; d < this._lenses.length; )
          this._lenses[d].dispose(c, l), this._lenses.splice(d, 1);
        for (; u < n.length; )
          this._lenses.push(new b$(n[u], this._editor, c, l, o.codeLensHeight, () => this._resolveCodeLensesInViewportSoon())), u++;
        c.commit(a);
      });
    }), s.restore(this._editor);
  }
  _resolveCodeLensesInViewportSoon() {
    this._editor.getModel() && this._resolveCodeLensesScheduler.schedule();
  }
  _resolveCodeLensesInViewport() {
    var e;
    (e = this._resolveCodeLensesPromise) === null || e === void 0 || e.cancel(), this._resolveCodeLensesPromise = void 0;
    const t = this._editor.getModel();
    if (!t)
      return;
    const n = [], r = [];
    if (this._lenses.forEach((a) => {
      const l = a.computeIfNecessary(t);
      l && (n.push(l), r.push(a));
    }), n.length === 0)
      return;
    const s = Date.now(), o = Ir((a) => {
      const l = n.map((c, d) => {
        const u = new Array(c.length), h = c.map((f, g) => !f.symbol.command && typeof f.provider.resolveCodeLens == "function" ? Promise.resolve(f.provider.resolveCodeLens(t, f.symbol, a)).then((p) => {
          u[g] = p;
        }, vr) : (u[g] = f.symbol, Promise.resolve(void 0)));
        return Promise.all(h).then(() => {
          !a.isCancellationRequested && !r[d].isDisposed() && r[d].updateCommands(u);
        });
      });
      return Promise.all(l);
    });
    this._resolveCodeLensesPromise = o, this._resolveCodeLensesPromise.then(() => {
      const a = this._resolveCodeLensesDebounce.update(t, Date.now() - s);
      this._resolveCodeLensesScheduler.delay = a, this._currentCodeLensModel && this._codeLensCache.put(t, this._currentCodeLensModel), this._oldCodeLensModels.clear(), o === this._resolveCodeLensesPromise && (this._resolveCodeLensesPromise = void 0);
    }, (a) => {
      It(a), o === this._resolveCodeLensesPromise && (this._resolveCodeLensesPromise = void 0);
    });
  }
  getModel() {
    var e;
    return L0e(this, void 0, void 0, function* () {
      return yield this._getCodeLensModelPromise, yield this._resolveCodeLensesPromise, !((e = this._currentCodeLensModel) === null || e === void 0) && e.isDisposed ? void 0 : this._currentCodeLensModel;
    });
  }
};
B_.ID = "css.editor.codeLens";
B_ = gJe([
  p2(1, tt),
  p2(2, kl),
  p2(3, Ui),
  p2(4, dr),
  p2(5, E0e)
], B_);
pn(
  B_.ID,
  B_,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
Be(class extends Je {
  constructor() {
    super({
      id: "codelens.showLensesInCurrentLine",
      precondition: $.hasCodeLensProvider,
      label: C("showLensOnLine", "Show CodeLens Commands For Current Line"),
      alias: "Show CodeLens Commands For Current Line"
    });
  }
  run(e, t) {
    return L0e(this, void 0, void 0, function* () {
      if (!t.hasModel())
        return;
      const n = e.get(bd), r = e.get(Ui), s = e.get(dr), o = t.getSelection().positionLineNumber, a = t.getContribution(B_.ID);
      if (!a)
        return;
      const l = yield a.getModel();
      if (!l)
        return;
      const c = [];
      for (const h of l.lenses)
        h.symbol.command && h.symbol.range.startLineNumber === o && c.push({
          label: h.symbol.command.title,
          command: h.symbol.command
        });
      if (c.length === 0)
        return;
      const d = yield n.pick(c, {
        canPickMany: !1,
        placeHolder: C("placeHolder", "Select a command")
      });
      if (!d)
        return;
      let u = d.command;
      if (l.isDisposed) {
        const h = yield a.getModel(), f = h?.lenses.find((g) => {
          var p;
          return g.symbol.range.startLineNumber === o && ((p = g.symbol.command) === null || p === void 0 ? void 0 : p.title) === u.title;
        });
        if (!f || !f.symbol.command)
          return;
        u = f.symbol.command;
      }
      try {
        yield r.executeCommand(u.id, ...u.arguments || []);
      } catch (h) {
        s.error(h);
      }
    });
  }
});
var pJe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, xT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, mJe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class iG {
  constructor(e, t) {
    this._editorWorkerClient = new sz(e, !1, "editorWorkerService", t);
  }
  provideDocumentColors(e, t) {
    return mJe(this, void 0, void 0, function* () {
      return this._editorWorkerClient.computeDefaultDocumentColors(e.uri);
    });
  }
  provideColorPresentations(e, t, n) {
    const r = t.range, s = t.color, o = s.alpha, a = new ye(new rn(Math.round(255 * s.red), Math.round(255 * s.green), Math.round(255 * s.blue), o)), l = o ? ye.Format.CSS.formatRGB(a) : ye.Format.CSS.formatRGBA(a), c = o ? ye.Format.CSS.formatHSL(a) : ye.Format.CSS.formatHSLA(a), d = o ? ye.Format.CSS.formatHex(a) : ye.Format.CSS.formatHexA(a), u = [];
    return u.push({ label: l, textEdit: { range: r, text: l } }), u.push({ label: c, textEdit: { range: r, text: c } }), u.push({ label: d, textEdit: { range: r, text: d } }), u;
  }
}
let MV = class extends we {
  constructor(e, t, n) {
    super(), this._register(n.colorProvider.register("*", new iG(e, t)));
  }
};
MV = pJe([
  xT(0, fi),
  xT(1, Un),
  xT(2, tt)
], MV);
Z4(MV);
var QS = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function I0e(i, e, t, n = !0) {
  return QS(this, void 0, void 0, function* () {
    return rG(new vJe(), i, e, t, n);
  });
}
function A0e(i, e, t, n) {
  return Promise.resolve(t.provideColorPresentations(i, e, n));
}
class vJe {
  constructor() {
  }
  compute(e, t, n, r) {
    return QS(this, void 0, void 0, function* () {
      const s = yield e.provideDocumentColors(t, n);
      if (Array.isArray(s))
        for (const o of s)
          r.push({ colorInfo: o, provider: e });
      return Array.isArray(s);
    });
  }
}
class _Je {
  constructor() {
  }
  compute(e, t, n, r) {
    return QS(this, void 0, void 0, function* () {
      const s = yield e.provideDocumentColors(t, n);
      if (Array.isArray(s))
        for (const o of s)
          r.push({ range: o.range, color: [o.color.red, o.color.green, o.color.blue, o.color.alpha] });
      return Array.isArray(s);
    });
  }
}
class bJe {
  constructor(e) {
    this.colorInfo = e;
  }
  compute(e, t, n, r) {
    return QS(this, void 0, void 0, function* () {
      const s = yield e.provideColorPresentations(t, this.colorInfo, jt.None);
      return Array.isArray(s) && r.push(...s), Array.isArray(s);
    });
  }
}
function rG(i, e, t, n, r) {
  return QS(this, void 0, void 0, function* () {
    let s = !1, o;
    const a = [], l = e.ordered(t);
    for (let c = l.length - 1; c >= 0; c--) {
      const d = l[c];
      if (d instanceof iG)
        o = d;
      else
        try {
          (yield i.compute(d, t, n, a)) && (s = !0);
        } catch (u) {
          vr(u);
        }
    }
    return s ? a : o && r ? (yield i.compute(o, t, n, a), a) : [];
  });
}
function k0e(i, e) {
  const { colorProvider: t } = i.get(tt), n = i.get(fi).getModel(e);
  if (!n)
    throw fl();
  const r = i.get(en).getValue("editor.defaultColorDecorators", { resource: e });
  return { model: n, colorProviderRegistry: t, isDefaultColorDecoratorsEnabled: r };
}
on.registerCommand("_executeDocumentColorProvider", function(i, ...e) {
  const [t] = e;
  if (!(t instanceof pt))
    throw fl();
  const { model: n, colorProviderRegistry: r, isDefaultColorDecoratorsEnabled: s } = k0e(i, t);
  return rG(new _Je(), r, n, jt.None, s);
});
on.registerCommand("_executeColorPresentationProvider", function(i, ...e) {
  const [t, n] = e, { uri: r, range: s } = n;
  if (!(r instanceof pt) || !Array.isArray(t) || t.length !== 4 || !V.isIRange(s))
    throw fl();
  const { model: o, colorProviderRegistry: a, isDefaultColorDecoratorsEnabled: l } = k0e(i, r), [c, d, u, h] = t;
  return rG(new bJe({ range: s, color: { red: c, green: d, blue: u, alpha: h } }), a, o, jt.None, l);
});
var CJe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, DT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, C$ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, RV;
const T0e = /* @__PURE__ */ Object.create({});
let Kg = RV = class extends we {
  constructor(e, t, n, r) {
    super(), this._editor = e, this._configurationService = t, this._languageFeaturesService = n, this._localToDispose = this._register(new Ne()), this._decorationsIds = [], this._colorDatas = /* @__PURE__ */ new Map(), this._colorDecoratorIds = this._editor.createDecorationsCollection(), this._ruleFactory = new IS(this._editor), this._decoratorLimitReporter = new yJe(), this._colorDecorationClassRefs = this._register(new Ne()), this._debounceInformation = r.for(n.colorProvider, "Document Colors", { min: RV.RECOMPUTE_TIME }), this._register(e.onDidChangeModel(() => {
      this._isColorDecoratorsEnabled = this.isEnabled(), this.updateColors();
    })), this._register(e.onDidChangeModelLanguage(() => this.updateColors())), this._register(n.colorProvider.onDidChange(() => this.updateColors())), this._register(e.onDidChangeConfiguration((s) => {
      const o = this._isColorDecoratorsEnabled;
      this._isColorDecoratorsEnabled = this.isEnabled(), this._isDefaultColorDecoratorsEnabled = this._editor.getOption(
        145
        /* EditorOption.defaultColorDecorators */
      );
      const a = o !== this._isColorDecoratorsEnabled || s.hasChanged(
        21
        /* EditorOption.colorDecoratorsLimit */
      ), l = s.hasChanged(
        145
        /* EditorOption.defaultColorDecorators */
      );
      (a || l) && (this._isColorDecoratorsEnabled ? this.updateColors() : this.removeAllDecorations());
    })), this._timeoutTimer = null, this._computePromise = null, this._isColorDecoratorsEnabled = this.isEnabled(), this._isDefaultColorDecoratorsEnabled = this._editor.getOption(
      145
      /* EditorOption.defaultColorDecorators */
    ), this.updateColors();
  }
  isEnabled() {
    const e = this._editor.getModel();
    if (!e)
      return !1;
    const t = e.getLanguageId(), n = this._configurationService.getValue(t);
    if (n && typeof n == "object") {
      const r = n.colorDecorators;
      if (r && r.enable !== void 0 && !r.enable)
        return r.enable;
    }
    return this._editor.getOption(
      20
      /* EditorOption.colorDecorators */
    );
  }
  static get(e) {
    return e.getContribution(this.ID);
  }
  dispose() {
    this.stop(), this.removeAllDecorations(), super.dispose();
  }
  updateColors() {
    if (this.stop(), !this._isColorDecoratorsEnabled)
      return;
    const e = this._editor.getModel();
    !e || !this._languageFeaturesService.colorProvider.has(e) || (this._localToDispose.add(this._editor.onDidChangeModelContent(() => {
      this._timeoutTimer || (this._timeoutTimer = new uc(), this._timeoutTimer.cancelAndSet(() => {
        this._timeoutTimer = null, this.beginCompute();
      }, this._debounceInformation.get(e)));
    })), this.beginCompute());
  }
  beginCompute() {
    return C$(this, void 0, void 0, function* () {
      this._computePromise = Ir((e) => C$(this, void 0, void 0, function* () {
        const t = this._editor.getModel();
        if (!t)
          return [];
        const n = new Vs(!1), r = yield I0e(this._languageFeaturesService.colorProvider, t, e, this._isDefaultColorDecoratorsEnabled);
        return this._debounceInformation.update(t, n.elapsed()), r;
      }));
      try {
        const e = yield this._computePromise;
        this.updateDecorations(e), this.updateColorDecorators(e), this._computePromise = null;
      } catch (e) {
        It(e);
      }
    });
  }
  stop() {
    this._timeoutTimer && (this._timeoutTimer.cancel(), this._timeoutTimer = null), this._computePromise && (this._computePromise.cancel(), this._computePromise = null), this._localToDispose.clear();
  }
  updateDecorations(e) {
    const t = e.map((n) => ({
      range: {
        startLineNumber: n.colorInfo.range.startLineNumber,
        startColumn: n.colorInfo.range.startColumn,
        endLineNumber: n.colorInfo.range.endLineNumber,
        endColumn: n.colorInfo.range.endColumn
      },
      options: Lt.EMPTY
    }));
    this._editor.changeDecorations((n) => {
      this._decorationsIds = n.deltaDecorations(this._decorationsIds, t), this._colorDatas = /* @__PURE__ */ new Map(), this._decorationsIds.forEach((r, s) => this._colorDatas.set(r, e[s]));
    });
  }
  updateColorDecorators(e) {
    this._colorDecorationClassRefs.clear();
    const t = [], n = this._editor.getOption(
      21
      /* EditorOption.colorDecoratorsLimit */
    );
    for (let s = 0; s < e.length && t.length < n; s++) {
      const { red: o, green: a, blue: l, alpha: c } = e[s].colorInfo.color, d = new rn(Math.round(o * 255), Math.round(a * 255), Math.round(l * 255), c), u = `rgba(${d.r}, ${d.g}, ${d.b}, ${d.a})`, h = this._colorDecorationClassRefs.add(this._ruleFactory.createClassNameRef({
        backgroundColor: u
      }));
      t.push({
        range: {
          startLineNumber: e[s].colorInfo.range.startLineNumber,
          startColumn: e[s].colorInfo.range.startColumn,
          endLineNumber: e[s].colorInfo.range.endLineNumber,
          endColumn: e[s].colorInfo.range.endColumn
        },
        options: {
          description: "colorDetector",
          before: {
            content: vhe,
            inlineClassName: `${h.className} colorpicker-color-decoration`,
            inlineClassNameAffectsLetterSpacing: !0,
            attachedData: T0e
          }
        }
      });
    }
    const r = n < e.length ? n : !1;
    this._decoratorLimitReporter.update(e.length, r), this._colorDecoratorIds.set(t);
  }
  removeAllDecorations() {
    this._editor.removeDecorations(this._decorationsIds), this._decorationsIds = [], this._colorDecoratorIds.clear(), this._colorDecorationClassRefs.clear();
  }
  getColorData(e) {
    const t = this._editor.getModel();
    if (!t)
      return null;
    const n = t.getDecorationsInRange(V.fromPositions(e, e)).filter((r) => this._colorDatas.has(r.id));
    return n.length === 0 ? null : this._colorDatas.get(n[0].id);
  }
  isColorDecoration(e) {
    return this._colorDecoratorIds.has(e);
  }
};
Kg.ID = "editor.contrib.colorDetector";
Kg.RECOMPUTE_TIME = 1e3;
Kg = RV = CJe([
  DT(1, en),
  DT(2, tt),
  DT(3, kl)
], Kg);
class yJe {
  constructor() {
    this._onDidChange = new pe(), this._computed = 0, this._limited = !1;
  }
  update(e, t) {
    (e !== this._computed || t !== this._limited) && (this._computed = e, this._limited = t, this._onDidChange.fire());
  }
}
pn(
  Kg.ID,
  Kg,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
class wJe {
  get color() {
    return this._color;
  }
  set color(e) {
    this._color.equals(e) || (this._color = e, this._onDidChangeColor.fire(e));
  }
  get presentation() {
    return this.colorPresentations[this.presentationIndex];
  }
  get colorPresentations() {
    return this._colorPresentations;
  }
  set colorPresentations(e) {
    this._colorPresentations = e, this.presentationIndex > e.length - 1 && (this.presentationIndex = 0), this._onDidChangePresentation.fire(this.presentation);
  }
  constructor(e, t, n) {
    this.presentationIndex = n, this._onColorFlushed = new pe(), this.onColorFlushed = this._onColorFlushed.event, this._onDidChangeColor = new pe(), this.onDidChangeColor = this._onDidChangeColor.event, this._onDidChangePresentation = new pe(), this.onDidChangePresentation = this._onDidChangePresentation.event, this.originalColor = e, this._color = e, this._colorPresentations = t;
  }
  selectNextColorPresentation() {
    this.presentationIndex = (this.presentationIndex + 1) % this.colorPresentations.length, this.flushColor(), this._onDidChangePresentation.fire(this.presentation);
  }
  guessColorPresentation(e, t) {
    let n = -1;
    for (let r = 0; r < this.colorPresentations.length; r++)
      if (t.toLowerCase() === this.colorPresentations[r].label) {
        n = r;
        break;
      }
    if (n === -1) {
      const r = t.split("(")[0].toLowerCase();
      for (let s = 0; s < this.colorPresentations.length; s++)
        if (this.colorPresentations[s].label.toLowerCase().startsWith(r)) {
          n = s;
          break;
        }
    }
    n !== -1 && n !== this.presentationIndex && (this.presentationIndex = n, this._onDidChangePresentation.fire(this.presentation));
  }
  flushColor() {
    this._onColorFlushed.fire(this._color);
  }
}
const Ia = Re;
class SJe extends we {
  constructor(e, t, n, r = !1) {
    super(), this.model = t, this.showingStandaloneColorPicker = r, this._closeButton = null, this._domNode = Ia(".colorpicker-header"), Te(e, this._domNode), this._pickedColorNode = Te(this._domNode, Ia(".picked-color")), Te(this._pickedColorNode, Ia("span.codicon.codicon-color-mode")), this._pickedColorPresentation = Te(this._pickedColorNode, document.createElement("span")), this._pickedColorPresentation.classList.add("picked-color-presentation");
    const s = C("clickToToggleColorOptions", "Click to toggle color options (rgb/hsl/hex)");
    this._pickedColorNode.setAttribute("title", s), this._originalColorNode = Te(this._domNode, Ia(".original-color")), this._originalColorNode.style.backgroundColor = ye.Format.CSS.format(this.model.originalColor) || "", this.backgroundColor = n.getColorTheme().getColor(uL) || ye.white, this._register(n.onDidColorThemeChange((o) => {
      this.backgroundColor = o.getColor(uL) || ye.white;
    })), this._register(Ie(this._pickedColorNode, Ge.CLICK, () => this.model.selectNextColorPresentation())), this._register(Ie(this._originalColorNode, Ge.CLICK, () => {
      this.model.color = this.model.originalColor, this.model.flushColor();
    })), this._register(t.onDidChangeColor(this.onDidChangeColor, this)), this._register(t.onDidChangePresentation(this.onDidChangePresentation, this)), this._pickedColorNode.style.backgroundColor = ye.Format.CSS.format(t.color) || "", this._pickedColorNode.classList.toggle("light", t.color.rgba.a < 0.5 ? this.backgroundColor.isLighter() : t.color.isLighter()), this.onDidChangeColor(this.model.color), this.showingStandaloneColorPicker && (this._domNode.classList.add("standalone-colorpicker"), this._closeButton = this._register(new xJe(this._domNode)));
  }
  get closeButton() {
    return this._closeButton;
  }
  get pickedColorNode() {
    return this._pickedColorNode;
  }
  get originalColorNode() {
    return this._originalColorNode;
  }
  onDidChangeColor(e) {
    this._pickedColorNode.style.backgroundColor = ye.Format.CSS.format(e) || "", this._pickedColorNode.classList.toggle("light", e.rgba.a < 0.5 ? this.backgroundColor.isLighter() : e.isLighter()), this.onDidChangePresentation();
  }
  onDidChangePresentation() {
    this._pickedColorPresentation.textContent = this.model.presentation ? this.model.presentation.label : "";
  }
}
let xJe = class extends we {
  constructor(e) {
    super(), this._onClicked = this._register(new pe()), this.onClicked = this._onClicked.event, this._button = document.createElement("div"), this._button.classList.add("close-button"), Te(e, this._button);
    const t = document.createElement("div");
    t.classList.add("close-button-inner-div"), Te(this._button, t), Te(t, Ia(".button" + ft.asCSSSelector($i("color-picker-close", We.close, C("closeIcon", "Icon to close the color picker"))))).classList.add("close-icon"), this._button.onclick = () => {
      this._onClicked.fire();
    };
  }
};
class DJe extends we {
  constructor(e, t, n, r = !1) {
    super(), this.model = t, this.pixelRatio = n, this._insertButton = null, this._domNode = Ia(".colorpicker-body"), Te(e, this._domNode), this._saturationBox = new EJe(this._domNode, this.model, this.pixelRatio), this._register(this._saturationBox), this._register(this._saturationBox.onDidChange(this.onDidSaturationValueChange, this)), this._register(this._saturationBox.onColorFlushed(this.flushColor, this)), this._opacityStrip = new LJe(this._domNode, this.model, r), this._register(this._opacityStrip), this._register(this._opacityStrip.onDidChange(this.onDidOpacityChange, this)), this._register(this._opacityStrip.onColorFlushed(this.flushColor, this)), this._hueStrip = new IJe(this._domNode, this.model, r), this._register(this._hueStrip), this._register(this._hueStrip.onDidChange(this.onDidHueChange, this)), this._register(this._hueStrip.onColorFlushed(this.flushColor, this)), r && (this._insertButton = this._register(new AJe(this._domNode)), this._domNode.classList.add("standalone-colorpicker"));
  }
  flushColor() {
    this.model.flushColor();
  }
  onDidSaturationValueChange({ s: e, v: t }) {
    const n = this.model.color.hsva;
    this.model.color = new ye(new Zd(n.h, e, t, n.a));
  }
  onDidOpacityChange(e) {
    const t = this.model.color.hsva;
    this.model.color = new ye(new Zd(t.h, t.s, t.v, e));
  }
  onDidHueChange(e) {
    const t = this.model.color.hsva, n = (1 - e) * 360;
    this.model.color = new ye(new Zd(n === 360 ? 0 : n, t.s, t.v, t.a));
  }
  get domNode() {
    return this._domNode;
  }
  get saturationBox() {
    return this._saturationBox;
  }
  get enterButton() {
    return this._insertButton;
  }
  layout() {
    this._saturationBox.layout(), this._opacityStrip.layout(), this._hueStrip.layout();
  }
}
class EJe extends we {
  constructor(e, t, n) {
    super(), this.model = t, this.pixelRatio = n, this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event, this._onColorFlushed = new pe(), this.onColorFlushed = this._onColorFlushed.event, this._domNode = Ia(".saturation-wrap"), Te(e, this._domNode), this._canvas = document.createElement("canvas"), this._canvas.className = "saturation-box", Te(this._domNode, this._canvas), this.selection = Ia(".saturation-selection"), Te(this._domNode, this.selection), this.layout(), this._register(Ie(this._domNode, Ge.POINTER_DOWN, (r) => this.onPointerDown(r))), this._register(this.model.onDidChangeColor(this.onDidChangeColor, this)), this.monitor = null;
  }
  get domNode() {
    return this._domNode;
  }
  onPointerDown(e) {
    if (!e.target || !(e.target instanceof Element))
      return;
    this.monitor = this._register(new vb());
    const t = wr(this._domNode);
    e.target !== this.selection && this.onDidChangePosition(e.offsetX, e.offsetY), this.monitor.startMonitoring(e.target, e.pointerId, e.buttons, (r) => this.onDidChangePosition(r.pageX - t.left, r.pageY - t.top), () => null);
    const n = Ie(e.target.ownerDocument, Ge.POINTER_UP, () => {
      this._onColorFlushed.fire(), n.dispose(), this.monitor && (this.monitor.stopMonitoring(!0), this.monitor = null);
    }, !0);
  }
  onDidChangePosition(e, t) {
    const n = Math.max(0, Math.min(1, e / this.width)), r = Math.max(0, Math.min(1, 1 - t / this.height));
    this.paintSelection(n, r), this._onDidChange.fire({ s: n, v: r });
  }
  layout() {
    this.width = this._domNode.offsetWidth, this.height = this._domNode.offsetHeight, this._canvas.width = this.width * this.pixelRatio, this._canvas.height = this.height * this.pixelRatio, this.paint();
    const e = this.model.color.hsva;
    this.paintSelection(e.s, e.v);
  }
  paint() {
    const e = this.model.color.hsva, t = new ye(new Zd(e.h, 1, 1, 1)), n = this._canvas.getContext("2d"), r = n.createLinearGradient(0, 0, this._canvas.width, 0);
    r.addColorStop(0, "rgba(255, 255, 255, 1)"), r.addColorStop(0.5, "rgba(255, 255, 255, 0.5)"), r.addColorStop(1, "rgba(255, 255, 255, 0)");
    const s = n.createLinearGradient(0, 0, 0, this._canvas.height);
    s.addColorStop(0, "rgba(0, 0, 0, 0)"), s.addColorStop(1, "rgba(0, 0, 0, 1)"), n.rect(0, 0, this._canvas.width, this._canvas.height), n.fillStyle = ye.Format.CSS.format(t), n.fill(), n.fillStyle = r, n.fill(), n.fillStyle = s, n.fill();
  }
  paintSelection(e, t) {
    this.selection.style.left = `${e * this.width}px`, this.selection.style.top = `${this.height - t * this.height}px`;
  }
  onDidChangeColor(e) {
    if (this.monitor && this.monitor.isMonitoring())
      return;
    this.paint();
    const t = e.hsva;
    this.paintSelection(t.s, t.v);
  }
}
class N0e extends we {
  constructor(e, t, n = !1) {
    super(), this.model = t, this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event, this._onColorFlushed = new pe(), this.onColorFlushed = this._onColorFlushed.event, n ? (this.domNode = Te(e, Ia(".standalone-strip")), this.overlay = Te(this.domNode, Ia(".standalone-overlay"))) : (this.domNode = Te(e, Ia(".strip")), this.overlay = Te(this.domNode, Ia(".overlay"))), this.slider = Te(this.domNode, Ia(".slider")), this.slider.style.top = "0px", this._register(Ie(this.domNode, Ge.POINTER_DOWN, (r) => this.onPointerDown(r))), this._register(t.onDidChangeColor(this.onDidChangeColor, this)), this.layout();
  }
  layout() {
    this.height = this.domNode.offsetHeight - this.slider.offsetHeight;
    const e = this.getValue(this.model.color);
    this.updateSliderPosition(e);
  }
  onDidChangeColor(e) {
    const t = this.getValue(e);
    this.updateSliderPosition(t);
  }
  onPointerDown(e) {
    if (!e.target || !(e.target instanceof Element))
      return;
    const t = this._register(new vb()), n = wr(this.domNode);
    this.domNode.classList.add("grabbing"), e.target !== this.slider && this.onDidChangeTop(e.offsetY), t.startMonitoring(e.target, e.pointerId, e.buttons, (s) => this.onDidChangeTop(s.pageY - n.top), () => null);
    const r = Ie(e.target.ownerDocument, Ge.POINTER_UP, () => {
      this._onColorFlushed.fire(), r.dispose(), t.stopMonitoring(!0), this.domNode.classList.remove("grabbing");
    }, !0);
  }
  onDidChangeTop(e) {
    const t = Math.max(0, Math.min(1, 1 - e / this.height));
    this.updateSliderPosition(t), this._onDidChange.fire(t);
  }
  updateSliderPosition(e) {
    this.slider.style.top = `${(1 - e) * this.height}px`;
  }
}
class LJe extends N0e {
  constructor(e, t, n = !1) {
    super(e, t, n), this.domNode.classList.add("opacity-strip"), this.onDidChangeColor(this.model.color);
  }
  onDidChangeColor(e) {
    super.onDidChangeColor(e);
    const { r: t, g: n, b: r } = e.rgba, s = new ye(new rn(t, n, r, 1)), o = new ye(new rn(t, n, r, 0));
    this.overlay.style.background = `linear-gradient(to bottom, ${s} 0%, ${o} 100%)`;
  }
  getValue(e) {
    return e.hsva.a;
  }
}
class IJe extends N0e {
  constructor(e, t, n = !1) {
    super(e, t, n), this.domNode.classList.add("hue-strip");
  }
  getValue(e) {
    return 1 - e.hsva.h / 360;
  }
}
class AJe extends we {
  constructor(e) {
    super(), this._onClicked = this._register(new pe()), this.onClicked = this._onClicked.event, this._button = Te(e, document.createElement("button")), this._button.classList.add("insert-button"), this._button.textContent = "Insert", this._button.onclick = (t) => {
      this._onClicked.fire();
    };
  }
  get button() {
    return this._button;
  }
}
class kJe extends hc {
  constructor(e, t, n, r, s = !1) {
    super(), this.model = t, this.pixelRatio = n, this._register(Ey.onDidChange(() => this.layout()));
    const o = Ia(".colorpicker-widget");
    e.appendChild(o), this.header = this._register(new SJe(o, this.model, r, s)), this.body = this._register(new DJe(o, this.model, this.pixelRatio, s));
  }
  layout() {
    this.body.layout();
  }
}
var P0e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, O0e = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, V_ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class TJe {
  constructor(e, t, n, r) {
    this.owner = e, this.range = t, this.model = n, this.provider = r, this.forceShowAtRange = !0;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let pI = class {
  constructor(e, t) {
    this._editor = e, this._themeService = t, this.hoverOrdinal = 2;
  }
  computeSync(e, t) {
    return [];
  }
  computeAsync(e, t, n) {
    return hr.fromPromise(this._computeAsync(e, t, n));
  }
  _computeAsync(e, t, n) {
    return V_(this, void 0, void 0, function* () {
      if (!this._editor.hasModel())
        return [];
      const r = Kg.get(this._editor);
      if (!r)
        return [];
      for (const s of t) {
        if (!r.isColorDecoration(s))
          continue;
        const o = r.getColorData(s.range.getStartPosition());
        if (o)
          return [yield M0e(this, this._editor.getModel(), o.colorInfo, o.provider)];
      }
      return [];
    });
  }
  renderHoverParts(e, t) {
    return R0e(this, this._editor, this._themeService, t, e);
  }
};
pI = P0e([
  O0e(1, Pr)
], pI);
class NJe {
  constructor(e, t, n, r) {
    this.owner = e, this.range = t, this.model = n, this.provider = r;
  }
}
let xw = class {
  constructor(e, t) {
    this._editor = e, this._themeService = t, this._color = null;
  }
  createColorHover(e, t, n) {
    return V_(this, void 0, void 0, function* () {
      if (!this._editor.hasModel() || !Kg.get(this._editor))
        return null;
      const s = yield I0e(n, this._editor.getModel(), jt.None);
      let o = null, a = null;
      for (const u of s) {
        const h = u.colorInfo;
        V.containsRange(h.range, e.range) && (o = h, a = u.provider);
      }
      const l = o ?? e, c = a ?? t, d = !!o;
      return { colorHover: yield M0e(this, this._editor.getModel(), l, c), foundInEditor: d };
    });
  }
  updateEditorModel(e) {
    return V_(this, void 0, void 0, function* () {
      if (!this._editor.hasModel())
        return;
      const t = e.model;
      let n = new V(e.range.startLineNumber, e.range.startColumn, e.range.endLineNumber, e.range.endColumn);
      this._color && (yield sE(this._editor.getModel(), t, this._color, n, e), n = F0e(this._editor, n, t));
    });
  }
  renderHoverParts(e, t) {
    return R0e(this, this._editor, this._themeService, t, e);
  }
  set color(e) {
    this._color = e;
  }
  get color() {
    return this._color;
  }
};
xw = P0e([
  O0e(1, Pr)
], xw);
function M0e(i, e, t, n) {
  return V_(this, void 0, void 0, function* () {
    const r = e.getValueInRange(t.range), { red: s, green: o, blue: a, alpha: l } = t.color, c = new rn(Math.round(s * 255), Math.round(o * 255), Math.round(a * 255), l), d = new ye(c), u = yield A0e(e, t, n, jt.None), h = new wJe(d, [], 0);
    return h.colorPresentations = u || [], h.guessColorPresentation(d, r), i instanceof pI ? new TJe(i, V.lift(t.range), h, n) : new NJe(i, V.lift(t.range), h, n);
  });
}
function R0e(i, e, t, n, r) {
  if (n.length === 0 || !e.hasModel())
    return we.None;
  if (r.setMinimumDimensions) {
    const h = e.getOption(
      66
      /* EditorOption.lineHeight */
    ) + 8;
    r.setMinimumDimensions(new _n(302, h));
  }
  const s = new Ne(), o = n[0], a = e.getModel(), l = o.model, c = s.add(new kJe(r.fragment, l, e.getOption(
    141
    /* EditorOption.pixelRatio */
  ), t, i instanceof xw));
  r.setColorPicker(c);
  let d = !1, u = new V(o.range.startLineNumber, o.range.startColumn, o.range.endLineNumber, o.range.endColumn);
  if (i instanceof xw) {
    const h = n[0].model.color;
    i.color = h, sE(a, l, h, u, o), s.add(l.onColorFlushed((f) => {
      i.color = f;
    }));
  } else
    s.add(l.onColorFlushed((h) => V_(this, void 0, void 0, function* () {
      yield sE(a, l, h, u, o), d = !0, u = F0e(e, u, l, r);
    })));
  return s.add(l.onDidChangeColor((h) => {
    sE(a, l, h, u, o);
  })), s.add(e.onDidChangeModelContent((h) => {
    d ? d = !1 : (r.hide(), e.focus());
  })), s;
}
function F0e(i, e, t, n) {
  let r, s;
  if (t.presentation.textEdit) {
    r = [t.presentation.textEdit], s = new V(t.presentation.textEdit.range.startLineNumber, t.presentation.textEdit.range.startColumn, t.presentation.textEdit.range.endLineNumber, t.presentation.textEdit.range.endColumn);
    const o = i.getModel()._setTrackedRange(
      null,
      s,
      3
      /* TrackedRangeStickiness.GrowsOnlyWhenTypingAfter */
    );
    i.pushUndoStop(), i.executeEdits("colorpicker", r), s = i.getModel()._getTrackedRange(o) || s;
  } else
    r = [{ range: e, text: t.presentation.label, forceMoveMarkers: !1 }], s = e.setEndPosition(e.endLineNumber, e.startColumn + t.presentation.label.length), i.pushUndoStop(), i.executeEdits("colorpicker", r);
  return t.presentation.additionalTextEdits && (r = [...t.presentation.additionalTextEdits], i.executeEdits("colorpicker", r), n && n.hide()), i.pushUndoStop(), s;
}
function sE(i, e, t, n, r) {
  return V_(this, void 0, void 0, function* () {
    const s = yield A0e(i, {
      range: n,
      color: {
        red: t.rgba.r / 255,
        green: t.rgba.g / 255,
        blue: t.rgba.b / 255,
        alpha: t.rgba.a
      }
    }, r.provider, jt.None);
    e.colorPresentations = s || [];
  });
}
function FV(i, e) {
  return !!i[e];
}
class ET {
  constructor(e, t) {
    this.target = e.target, this.isLeftClick = e.event.leftButton, this.isMiddleClick = e.event.middleButton, this.isRightClick = e.event.rightButton, this.hasTriggerModifier = FV(e.event, t.triggerModifier), this.hasSideBySideModifier = FV(e.event, t.triggerSideBySideModifier), this.isNoneOrSingleMouseDown = e.event.detail <= 1;
  }
}
class y$ {
  constructor(e, t) {
    this.keyCodeIsTriggerKey = e.keyCode === t.triggerKey, this.keyCodeIsSideBySideKey = e.keyCode === t.triggerSideBySideKey, this.hasTriggerModifier = FV(e, t.triggerModifier);
  }
}
class DD {
  constructor(e, t, n, r) {
    this.triggerKey = e, this.triggerModifier = t, this.triggerSideBySideKey = n, this.triggerSideBySideModifier = r;
  }
  equals(e) {
    return this.triggerKey === e.triggerKey && this.triggerModifier === e.triggerModifier && this.triggerSideBySideKey === e.triggerSideBySideKey && this.triggerSideBySideModifier === e.triggerSideBySideModifier;
  }
}
function w$(i) {
  return i === "altKey" ? sn ? new DD(57, "metaKey", 6, "altKey") : new DD(5, "ctrlKey", 6, "altKey") : sn ? new DD(6, "altKey", 57, "metaKey") : new DD(6, "altKey", 5, "ctrlKey");
}
class u5 extends we {
  constructor(e, t) {
    var n;
    super(), this._onMouseMoveOrRelevantKeyDown = this._register(new pe()), this.onMouseMoveOrRelevantKeyDown = this._onMouseMoveOrRelevantKeyDown.event, this._onExecute = this._register(new pe()), this.onExecute = this._onExecute.event, this._onCancel = this._register(new pe()), this.onCancel = this._onCancel.event, this._editor = e, this._extractLineNumberFromMouseEvent = (n = t?.extractLineNumberFromMouseEvent) !== null && n !== void 0 ? n : (r) => r.target.position ? r.target.position.lineNumber : 0, this._opts = w$(this._editor.getOption(
      77
      /* EditorOption.multiCursorModifier */
    )), this._lastMouseMoveEvent = null, this._hasTriggerKeyOnMouseDown = !1, this._lineNumberOnMouseDown = 0, this._register(this._editor.onDidChangeConfiguration((r) => {
      if (r.hasChanged(
        77
        /* EditorOption.multiCursorModifier */
      )) {
        const s = w$(this._editor.getOption(
          77
          /* EditorOption.multiCursorModifier */
        ));
        if (this._opts.equals(s))
          return;
        this._opts = s, this._lastMouseMoveEvent = null, this._hasTriggerKeyOnMouseDown = !1, this._lineNumberOnMouseDown = 0, this._onCancel.fire();
      }
    })), this._register(this._editor.onMouseMove((r) => this._onEditorMouseMove(new ET(r, this._opts)))), this._register(this._editor.onMouseDown((r) => this._onEditorMouseDown(new ET(r, this._opts)))), this._register(this._editor.onMouseUp((r) => this._onEditorMouseUp(new ET(r, this._opts)))), this._register(this._editor.onKeyDown((r) => this._onEditorKeyDown(new y$(r, this._opts)))), this._register(this._editor.onKeyUp((r) => this._onEditorKeyUp(new y$(r, this._opts)))), this._register(this._editor.onMouseDrag(() => this._resetHandler())), this._register(this._editor.onDidChangeCursorSelection((r) => this._onDidChangeCursorSelection(r))), this._register(this._editor.onDidChangeModel((r) => this._resetHandler())), this._register(this._editor.onDidChangeModelContent(() => this._resetHandler())), this._register(this._editor.onDidScrollChange((r) => {
      (r.scrollTopChanged || r.scrollLeftChanged) && this._resetHandler();
    }));
  }
  _onDidChangeCursorSelection(e) {
    e.selection && e.selection.startColumn !== e.selection.endColumn && this._resetHandler();
  }
  _onEditorMouseMove(e) {
    this._lastMouseMoveEvent = e, this._onMouseMoveOrRelevantKeyDown.fire([e, null]);
  }
  _onEditorMouseDown(e) {
    this._hasTriggerKeyOnMouseDown = e.hasTriggerModifier, this._lineNumberOnMouseDown = this._extractLineNumberFromMouseEvent(e);
  }
  _onEditorMouseUp(e) {
    const t = this._extractLineNumberFromMouseEvent(e);
    this._hasTriggerKeyOnMouseDown && this._lineNumberOnMouseDown && this._lineNumberOnMouseDown === t && this._onExecute.fire(e);
  }
  _onEditorKeyDown(e) {
    this._lastMouseMoveEvent && (e.keyCodeIsTriggerKey || e.keyCodeIsSideBySideKey && e.hasTriggerModifier) ? this._onMouseMoveOrRelevantKeyDown.fire([this._lastMouseMoveEvent, e]) : e.hasTriggerModifier && this._onCancel.fire();
  }
  _onEditorKeyUp(e) {
    e.keyCodeIsTriggerKey && this._onCancel.fire();
  }
  _resetHandler() {
    this._lastMouseMoveEvent = null, this._hasTriggerKeyOnMouseDown = !1, this._onCancel.fire();
  }
}
var PJe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, qu = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Yg = class extends L_ {
  constructor(e, t, n, r, s, o, a, l, c, d, u, h, f) {
    super(e, Object.assign(Object.assign({}, r.getRawOptions()), { overflowWidgetsDomNode: r.getOverflowWidgetsDomNode() }), n, s, o, a, l, c, d, u, h, f), this._parentEditor = r, this._overwriteOptions = t, super.updateOptions(this._overwriteOptions), this._register(r.onDidChangeConfiguration((g) => this._onParentConfigurationChanged(g)));
  }
  getParentEditor() {
    return this._parentEditor;
  }
  _onParentConfigurationChanged(e) {
    super.updateOptions(this._parentEditor.getRawOptions()), super.updateOptions(this._overwriteOptions);
  }
  updateOptions(e) {
    WA(this._overwriteOptions, e, !0), super.updateOptions(this._overwriteOptions);
  }
};
Yg = PJe([
  qu(4, bt),
  qu(5, Sn),
  qu(6, Ui),
  qu(7, yt),
  qu(8, Pr),
  qu(9, dr),
  qu(10, lf),
  qu(11, Un),
  qu(12, tt)
], Yg);
const S$ = new ye(new rn(0, 122, 204)), OJe = {
  showArrow: !0,
  showFrame: !0,
  className: "",
  frameColor: S$,
  arrowColor: S$,
  keepEditorSelection: !1
}, MJe = "vs.editor.contrib.zoneWidget";
class RJe {
  constructor(e, t, n, r, s, o, a, l) {
    this.id = "", this.domNode = e, this.afterLineNumber = t, this.afterColumn = n, this.heightInLines = r, this.showInHiddenAreas = a, this.ordinal = l, this._onDomNodeTop = s, this._onComputedHeight = o;
  }
  onDomNodeTop(e) {
    this._onDomNodeTop(e);
  }
  onComputedHeight(e) {
    this._onComputedHeight(e);
  }
}
class FJe {
  constructor(e, t) {
    this._id = e, this._domNode = t;
  }
  getId() {
    return this._id;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return null;
  }
}
class h5 {
  constructor(e) {
    this._editor = e, this._ruleName = h5._IdGenerator.nextId(), this._decorations = this._editor.createDecorationsCollection(), this._color = null, this._height = -1;
  }
  dispose() {
    this.hide(), mX(this._ruleName);
  }
  set color(e) {
    this._color !== e && (this._color = e, this._updateStyle());
  }
  set height(e) {
    this._height !== e && (this._height = e, this._updateStyle());
  }
  _updateStyle() {
    mX(this._ruleName), cF(`.monaco-editor ${this._ruleName}`, `border-style: solid; border-color: transparent; border-bottom-color: ${this._color}; border-width: ${this._height}px; bottom: -${this._height}px; margin-left: -${this._height}px; `);
  }
  show(e) {
    e.column === 1 && (e = { lineNumber: e.lineNumber, column: 2 }), this._decorations.set([{
      range: V.fromPositions(e),
      options: {
        description: "zone-widget-arrow",
        className: this._ruleName,
        stickiness: 1
        /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
      }
    }]);
  }
  hide() {
    this._decorations.clear();
  }
}
h5._IdGenerator = new oU(".arrow-decoration-");
class BJe {
  constructor(e, t = {}) {
    this._arrow = null, this._overlayWidget = null, this._resizeSash = null, this._viewZone = null, this._disposables = new Ne(), this.container = null, this._isShowing = !1, this.editor = e, this._positionMarkerId = this.editor.createDecorationsCollection(), this.options = lh(t), WA(this.options, OJe, !1), this.domNode = document.createElement("div"), this.options.isAccessible || (this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setAttribute("role", "presentation")), this._disposables.add(this.editor.onDidLayoutChange((n) => {
      const r = this._getWidth(n);
      this.domNode.style.width = r + "px", this.domNode.style.left = this._getLeft(n) + "px", this._onWidth(r);
    }));
  }
  dispose() {
    this._overlayWidget && (this.editor.removeOverlayWidget(this._overlayWidget), this._overlayWidget = null), this._viewZone && this.editor.changeViewZones((e) => {
      this._viewZone && e.removeZone(this._viewZone.id), this._viewZone = null;
    }), this._positionMarkerId.clear(), this._disposables.dispose();
  }
  create() {
    this.domNode.classList.add("zone-widget"), this.options.className && this.domNode.classList.add(this.options.className), this.container = document.createElement("div"), this.container.classList.add("zone-widget-container"), this.domNode.appendChild(this.container), this.options.showArrow && (this._arrow = new h5(this.editor), this._disposables.add(this._arrow)), this._fillContainer(this.container), this._initSash(), this._applyStyles();
  }
  style(e) {
    e.frameColor && (this.options.frameColor = e.frameColor), e.arrowColor && (this.options.arrowColor = e.arrowColor), this._applyStyles();
  }
  _applyStyles() {
    if (this.container && this.options.frameColor) {
      const e = this.options.frameColor.toString();
      this.container.style.borderTopColor = e, this.container.style.borderBottomColor = e;
    }
    if (this._arrow && this.options.arrowColor) {
      const e = this.options.arrowColor.toString();
      this._arrow.color = e;
    }
  }
  _getWidth(e) {
    return e.width - e.minimap.minimapWidth - e.verticalScrollbarWidth;
  }
  _getLeft(e) {
    return e.minimap.minimapWidth > 0 && e.minimap.minimapLeft === 0 ? e.minimap.minimapWidth : 0;
  }
  _onViewZoneTop(e) {
    this.domNode.style.top = e + "px";
  }
  _onViewZoneHeight(e) {
    var t;
    if (this.domNode.style.height = `${e}px`, this.container) {
      const n = e - this._decoratingElementsHeight();
      this.container.style.height = `${n}px`;
      const r = this.editor.getLayoutInfo();
      this._doLayout(n, this._getWidth(r));
    }
    (t = this._resizeSash) === null || t === void 0 || t.layout();
  }
  get position() {
    const e = this._positionMarkerId.getRange(0);
    if (e)
      return e.getStartPosition();
  }
  show(e, t) {
    const n = V.isIRange(e) ? V.lift(e) : V.fromPositions(e);
    this._isShowing = !0, this._showImpl(n, t), this._isShowing = !1, this._positionMarkerId.set([{ range: n, options: Lt.EMPTY }]);
  }
  hide() {
    var e;
    this._viewZone && (this.editor.changeViewZones((t) => {
      this._viewZone && t.removeZone(this._viewZone.id);
    }), this._viewZone = null), this._overlayWidget && (this.editor.removeOverlayWidget(this._overlayWidget), this._overlayWidget = null), (e = this._arrow) === null || e === void 0 || e.hide(), this._positionMarkerId.clear();
  }
  _decoratingElementsHeight() {
    const e = this.editor.getOption(
      66
      /* EditorOption.lineHeight */
    );
    let t = 0;
    if (this.options.showArrow) {
      const n = Math.round(e / 3);
      t += 2 * n;
    }
    if (this.options.showFrame) {
      const n = Math.round(e / 9);
      t += 2 * n;
    }
    return t;
  }
  _showImpl(e, t) {
    const n = e.getStartPosition(), r = this.editor.getLayoutInfo(), s = this._getWidth(r);
    this.domNode.style.width = `${s}px`, this.domNode.style.left = this._getLeft(r) + "px";
    const o = document.createElement("div");
    o.style.overflow = "hidden";
    const a = this.editor.getOption(
      66
      /* EditorOption.lineHeight */
    );
    if (!this.options.allowUnlimitedHeight) {
      const h = Math.max(12, this.editor.getLayoutInfo().height / a * 0.8);
      t = Math.min(t, h);
    }
    let l = 0, c = 0;
    if (this._arrow && this.options.showArrow && (l = Math.round(a / 3), this._arrow.height = l, this._arrow.show(n)), this.options.showFrame && (c = Math.round(a / 9)), this.editor.changeViewZones((h) => {
      this._viewZone && h.removeZone(this._viewZone.id), this._overlayWidget && (this.editor.removeOverlayWidget(this._overlayWidget), this._overlayWidget = null), this.domNode.style.top = "-1000px", this._viewZone = new RJe(o, n.lineNumber, n.column, t, (f) => this._onViewZoneTop(f), (f) => this._onViewZoneHeight(f), this.options.showInHiddenAreas, this.options.ordinal), this._viewZone.id = h.addZone(this._viewZone), this._overlayWidget = new FJe(MJe + this._viewZone.id, this.domNode), this.editor.addOverlayWidget(this._overlayWidget);
    }), this.container && this.options.showFrame) {
      const h = this.options.frameWidth ? this.options.frameWidth : c;
      this.container.style.borderTopWidth = h + "px", this.container.style.borderBottomWidth = h + "px";
    }
    const d = t * a - this._decoratingElementsHeight();
    this.container && (this.container.style.top = l + "px", this.container.style.height = d + "px", this.container.style.overflow = "hidden"), this._doLayout(d, s), this.options.keepEditorSelection || this.editor.setSelection(e);
    const u = this.editor.getModel();
    if (u) {
      const h = u.validateRange(new V(e.startLineNumber, 1, e.endLineNumber + 1, 1));
      this.revealRange(h, h.startLineNumber === u.getLineCount());
    }
  }
  revealRange(e, t) {
    t ? this.editor.revealLineNearTop(
      e.endLineNumber,
      0
      /* ScrollType.Smooth */
    ) : this.editor.revealRange(
      e,
      0
      /* ScrollType.Smooth */
    );
  }
  setCssClass(e, t) {
    this.container && (t && this.container.classList.remove(t), this.container.classList.add(e));
  }
  _onWidth(e) {
  }
  _doLayout(e, t) {
  }
  _relayout(e) {
    this._viewZone && this._viewZone.heightInLines !== e && this.editor.changeViewZones((t) => {
      this._viewZone && (this._viewZone.heightInLines = e, t.layoutZone(this._viewZone.id));
    });
  }
  // --- sash
  _initSash() {
    if (this._resizeSash)
      return;
    this._resizeSash = this._disposables.add(new Ts(this.domNode, this, {
      orientation: 1
      /* Orientation.HORIZONTAL */
    })), this.options.isResizeable || (this._resizeSash.state = 0);
    let e;
    this._disposables.add(this._resizeSash.onDidStart((t) => {
      this._viewZone && (e = {
        startY: t.startY,
        heightInLines: this._viewZone.heightInLines
      });
    })), this._disposables.add(this._resizeSash.onDidEnd(() => {
      e = void 0;
    })), this._disposables.add(this._resizeSash.onDidChange((t) => {
      if (e) {
        const n = (t.currentY - e.startY) / this.editor.getOption(
          66
          /* EditorOption.lineHeight */
        ), r = n < 0 ? Math.ceil(n) : Math.floor(n), s = e.heightInLines + r;
        s > 5 && s < 35 && this._relayout(s);
      }
    }));
  }
  getHorizontalSashLeft() {
    return 0;
  }
  getHorizontalSashTop() {
    return (this.domNode.style.height === null ? 0 : parseInt(this.domNode.style.height)) - this._decoratingElementsHeight() / 2;
  }
  getHorizontalSashWidth() {
    const e = this.editor.getLayoutInfo();
    return e.width - e.minimap.minimapWidth;
  }
}
var B0e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, V0e = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const H0e = Gt("IPeekViewService");
an(
  H0e,
  class {
    constructor() {
      this._widgets = /* @__PURE__ */ new Map();
    }
    addExclusiveWidget(i, e) {
      const t = this._widgets.get(i);
      t && (t.listener.dispose(), t.widget.dispose());
      const n = () => {
        const r = this._widgets.get(i);
        r && r.widget === e && (r.listener.dispose(), this._widgets.delete(i));
      };
      this._widgets.set(i, { widget: e, listener: e.onDidClose(n) });
    }
  },
  1
  /* InstantiationType.Delayed */
);
var Vo;
(function(i) {
  i.inPeekEditor = new Ke("inReferenceSearchEditor", !0, C("inReferenceSearchEditor", "Whether the current code editor is embedded inside peek")), i.notInPeekEditor = i.inPeekEditor.toNegated();
})(Vo || (Vo = {}));
let Dw = class {
  constructor(e, t) {
    e instanceof Yg && Vo.inPeekEditor.bindTo(t);
  }
  dispose() {
  }
};
Dw.ID = "editor.contrib.referenceController";
Dw = B0e([
  V0e(1, yt)
], Dw);
pn(
  Dw.ID,
  Dw,
  0
  /* EditorContributionInstantiation.Eager */
);
function VJe(i) {
  const e = i.get(Sn).getFocusedCodeEditor();
  return e instanceof Yg ? e.getParentEditor() : e;
}
const HJe = {
  headerBackgroundColor: ye.white,
  primaryHeadingColor: ye.fromHex("#333333"),
  secondaryHeadingColor: ye.fromHex("#6c6c6cb3")
};
let mI = class extends BJe {
  constructor(e, t, n) {
    super(e, t), this.instantiationService = n, this._onDidClose = new pe(), this.onDidClose = this._onDidClose.event, WA(this.options, HJe, !1);
  }
  dispose() {
    this.disposed || (this.disposed = !0, super.dispose(), this._onDidClose.fire(this));
  }
  style(e) {
    const t = this.options;
    e.headerBackgroundColor && (t.headerBackgroundColor = e.headerBackgroundColor), e.primaryHeadingColor && (t.primaryHeadingColor = e.primaryHeadingColor), e.secondaryHeadingColor && (t.secondaryHeadingColor = e.secondaryHeadingColor), super.style(e);
  }
  _applyStyles() {
    super._applyStyles();
    const e = this.options;
    this._headElement && e.headerBackgroundColor && (this._headElement.style.backgroundColor = e.headerBackgroundColor.toString()), this._primaryHeading && e.primaryHeadingColor && (this._primaryHeading.style.color = e.primaryHeadingColor.toString()), this._secondaryHeading && e.secondaryHeadingColor && (this._secondaryHeading.style.color = e.secondaryHeadingColor.toString()), this._bodyElement && e.frameColor && (this._bodyElement.style.borderColor = e.frameColor.toString());
  }
  _fillContainer(e) {
    this.setCssClass("peekview-widget"), this._headElement = Re(".head"), this._bodyElement = Re(".body"), this._fillHead(this._headElement), this._fillBody(this._bodyElement), e.appendChild(this._headElement), e.appendChild(this._bodyElement);
  }
  _fillHead(e, t) {
    this._titleElement = Re(".peekview-title"), this.options.supportOnTitleClick && (this._titleElement.classList.add("clickable"), ar(this._titleElement, "click", (s) => this._onTitleClick(s))), Te(this._headElement, this._titleElement), this._fillTitleIcon(this._titleElement), this._primaryHeading = Re("span.filename"), this._secondaryHeading = Re("span.dirname"), this._metaHeading = Re("span.meta"), Te(this._titleElement, this._primaryHeading, this._secondaryHeading, this._metaHeading);
    const n = Re(".peekview-actions");
    Te(this._headElement, n);
    const r = this._getActionBarOptions();
    this._actionbarWidget = new Dl(n, r), this._disposables.add(this._actionbarWidget), t || this._actionbarWidget.push(new vo("peekview.close", C("label.close", "Close"), ft.asClassName(We.close), !0, () => (this.dispose(), Promise.resolve())), { label: !1, icon: !0 });
  }
  _fillTitleIcon(e) {
  }
  _getActionBarOptions() {
    return {
      actionViewItemProvider: eUe.bind(void 0, this.instantiationService),
      orientation: 0
      /* ActionsOrientation.HORIZONTAL */
    };
  }
  _onTitleClick(e) {
  }
  setTitle(e, t) {
    this._primaryHeading && this._secondaryHeading && (this._primaryHeading.innerText = e, this._primaryHeading.setAttribute("title", e), t ? this._secondaryHeading.innerText = t : ls(this._secondaryHeading));
  }
  setMetaTitle(e) {
    this._metaHeading && (e ? (this._metaHeading.innerText = e, Zo(this._metaHeading)) : ao(this._metaHeading));
  }
  _doLayout(e, t) {
    if (!this._isShowing && e < 0) {
      this.dispose();
      return;
    }
    const n = Math.ceil(this.editor.getOption(
      66
      /* EditorOption.lineHeight */
    ) * 1.2), r = Math.round(e - (n + 2));
    this._doLayoutHead(n, t), this._doLayoutBody(r, t);
  }
  _doLayoutHead(e, t) {
    this._headElement && (this._headElement.style.height = `${e}px`, this._headElement.style.lineHeight = this._headElement.style.height);
  }
  _doLayoutBody(e, t) {
    this._bodyElement && (this._bodyElement.style.height = `${e}px`);
  }
};
mI = B0e([
  V0e(2, bt)
], mI);
const WJe = ne("peekViewTitle.background", { dark: "#252526", light: "#F3F3F3", hcDark: ye.black, hcLight: ye.white }, C("peekViewTitleBackground", "Background color of the peek view title area.")), W0e = ne("peekViewTitleLabel.foreground", { dark: ye.white, light: ye.black, hcDark: ye.white, hcLight: Ul }, C("peekViewTitleForeground", "Color of the peek view title.")), j0e = ne("peekViewTitleDescription.foreground", { dark: "#ccccccb3", light: "#616161", hcDark: "#FFFFFF99", hcLight: "#292929" }, C("peekViewTitleInfoForeground", "Color of the peek view title info.")), jJe = ne("peekView.border", { dark: Oo, light: Oo, hcDark: $t, hcLight: $t }, C("peekViewBorder", "Color of the peek view borders and arrow.")), zJe = ne("peekViewResult.background", { dark: "#252526", light: "#F3F3F3", hcDark: ye.black, hcLight: ye.white }, C("peekViewResultsBackground", "Background color of the peek view result list."));
ne("peekViewResult.lineForeground", { dark: "#bbbbbb", light: "#646465", hcDark: ye.white, hcLight: Ul }, C("peekViewResultsMatchForeground", "Foreground color for line nodes in the peek view result list."));
ne("peekViewResult.fileForeground", { dark: ye.white, light: "#1E1E1E", hcDark: ye.white, hcLight: Ul }, C("peekViewResultsFileForeground", "Foreground color for file nodes in the peek view result list."));
ne("peekViewResult.selectionBackground", { dark: "#3399ff33", light: "#3399ff33", hcDark: null, hcLight: null }, C("peekViewResultsSelectionBackground", "Background color of the selected entry in the peek view result list."));
ne("peekViewResult.selectionForeground", { dark: ye.white, light: "#6C6C6C", hcDark: ye.white, hcLight: Ul }, C("peekViewResultsSelectionForeground", "Foreground color of the selected entry in the peek view result list."));
const og = ne("peekViewEditor.background", { dark: "#001F33", light: "#F2F8FC", hcDark: ye.black, hcLight: ye.white }, C("peekViewEditorBackground", "Background color of the peek view editor."));
ne("peekViewEditorGutter.background", { dark: og, light: og, hcDark: og, hcLight: og }, C("peekViewEditorGutterBackground", "Background color of the gutter in the peek view editor."));
ne("peekViewEditorStickyScroll.background", { dark: og, light: og, hcDark: og, hcLight: og }, C("peekViewEditorStickScrollBackground", "Background color of sticky scroll in the peek view editor."));
ne("peekViewResult.matchHighlightBackground", { dark: "#ea5c004d", light: "#ea5c004d", hcDark: null, hcLight: null }, C("peekViewResultsMatchHighlight", "Match highlight color in the peek view result list."));
ne("peekViewEditor.matchHighlightBackground", { dark: "#ff8f0099", light: "#f5d802de", hcDark: null, hcLight: null }, C("peekViewEditorMatchHighlight", "Match highlight color in the peek view editor."));
ne("peekViewEditor.matchHighlightBorder", { dark: null, light: null, hcDark: ii, hcLight: ii }, C("peekViewEditorMatchHighlightBorder", "Match highlight border in the peek view editor."));
var UJe = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class Xg {
  constructor(e, t, n, r) {
    this.isProviderFirst = e, this.parent = t, this.link = n, this._rangeCallback = r, this.id = CB.nextId();
  }
  get uri() {
    return this.link.uri;
  }
  get range() {
    var e, t;
    return (t = (e = this._range) !== null && e !== void 0 ? e : this.link.targetSelectionRange) !== null && t !== void 0 ? t : this.link.range;
  }
  set range(e) {
    this._range = e, this._rangeCallback(this);
  }
  get ariaMessage() {
    var e;
    const t = (e = this.parent.getPreview(this)) === null || e === void 0 ? void 0 : e.preview(this.range);
    return t ? C({ key: "aria.oneReference.preview", comment: ["Placeholders are: 0: filename, 1:line number, 2: column number, 3: preview snippet of source code"] }, "{0} in {1} on line {2} at column {3}", t.value, xl(this.uri), this.range.startLineNumber, this.range.startColumn) : C("aria.oneReference", "in {0} on line {1} at column {2}", xl(this.uri), this.range.startLineNumber, this.range.startColumn);
  }
}
class GJe {
  constructor(e) {
    this._modelReference = e;
  }
  dispose() {
    this._modelReference.dispose();
  }
  preview(e, t = 8) {
    const n = this._modelReference.object.textEditorModel;
    if (!n)
      return;
    const { startLineNumber: r, startColumn: s, endLineNumber: o, endColumn: a } = e, l = n.getWordUntilPosition({ lineNumber: r, column: s - t }), c = new V(r, l.startColumn, r, s), d = new V(
      o,
      a,
      o,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ), u = n.getValueInRange(c).replace(/^\s+/, ""), h = n.getValueInRange(e), f = n.getValueInRange(d).replace(/\s+$/, "");
    return {
      value: u + h + f,
      highlight: { start: u.length, end: u.length + h.length }
    };
  }
}
class Ew {
  constructor(e, t) {
    this.parent = e, this.uri = t, this.children = [], this._previews = new Ms();
  }
  dispose() {
    An(this._previews.values()), this._previews.clear();
  }
  getPreview(e) {
    return this._previews.get(e.uri);
  }
  get ariaMessage() {
    const e = this.children.length;
    return e === 1 ? C("aria.fileReferences.1", "1 symbol in {0}, full path {1}", xl(this.uri), this.uri.fsPath) : C("aria.fileReferences.N", "{0} symbols in {1}, full path {2}", e, xl(this.uri), this.uri.fsPath);
  }
  resolve(e) {
    return UJe(this, void 0, void 0, function* () {
      if (this._previews.size !== 0)
        return this;
      for (const t of this.children)
        if (!this._previews.has(t.uri))
          try {
            const n = yield e.createModelReference(t.uri);
            this._previews.set(t.uri, new GJe(n));
          } catch (n) {
            It(n);
          }
      return this;
    });
  }
}
class sa {
  constructor(e, t) {
    this.groups = [], this.references = [], this._onDidChangeReferenceRange = new pe(), this.onDidChangeReferenceRange = this._onDidChangeReferenceRange.event, this._links = e, this._title = t;
    const [n] = e;
    e.sort(sa._compareReferences);
    let r;
    for (const s of e)
      if ((!r || !ri.isEqual(r.uri, s.uri, !0)) && (r = new Ew(this, s.uri), this.groups.push(r)), r.children.length === 0 || sa._compareReferences(s, r.children[r.children.length - 1]) !== 0) {
        const o = new Xg(n === s, r, s, (a) => this._onDidChangeReferenceRange.fire(a));
        this.references.push(o), r.children.push(o);
      }
  }
  dispose() {
    An(this.groups), this._onDidChangeReferenceRange.dispose(), this.groups.length = 0;
  }
  clone() {
    return new sa(this._links, this._title);
  }
  get title() {
    return this._title;
  }
  get isEmpty() {
    return this.groups.length === 0;
  }
  get ariaMessage() {
    return this.isEmpty ? C("aria.result.0", "No results found") : this.references.length === 1 ? C("aria.result.1", "Found 1 symbol in {0}", this.references[0].uri.fsPath) : this.groups.length === 1 ? C("aria.result.n1", "Found {0} symbols in {1}", this.references.length, this.groups[0].uri.fsPath) : C("aria.result.nm", "Found {0} symbols in {1} files", this.references.length, this.groups.length);
  }
  nextOrPreviousReference(e, t) {
    const { parent: n } = e;
    let r = n.children.indexOf(e);
    const s = n.children.length, o = n.parent.groups.length;
    return o === 1 || t && r + 1 < s || !t && r > 0 ? (t ? r = (r + 1) % s : r = (r + s - 1) % s, n.children[r]) : (r = n.parent.groups.indexOf(n), t ? (r = (r + 1) % o, n.parent.groups[r].children[0]) : (r = (r + o - 1) % o, n.parent.groups[r].children[n.parent.groups[r].children.length - 1]));
  }
  nearestReference(e, t) {
    const n = this.references.map((r, s) => ({
      idx: s,
      prefixLen: Um(r.uri.toString(), e.toString()),
      offsetDist: Math.abs(r.range.startLineNumber - t.lineNumber) * 100 + Math.abs(r.range.startColumn - t.column)
    })).sort((r, s) => r.prefixLen > s.prefixLen ? -1 : r.prefixLen < s.prefixLen ? 1 : r.offsetDist < s.offsetDist ? -1 : r.offsetDist > s.offsetDist ? 1 : 0)[0];
    if (n)
      return this.references[n.idx];
  }
  referenceAt(e, t) {
    for (const n of this.references)
      if (n.uri.toString() === e.toString() && V.containsPosition(n.range, t))
        return n;
  }
  firstReference() {
    for (const e of this.references)
      if (e.isProviderFirst)
        return e;
    return this.references[0];
  }
  static _compareReferences(e, t) {
    return ri.compare(e.uri, t.uri) || V.compareRangesUsingStarts(e.range, t.range);
  }
}
var f5 = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, g5 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, BV;
let VV = class {
  constructor(e) {
    this._resolverService = e;
  }
  hasChildren(e) {
    return e instanceof sa || e instanceof Ew;
  }
  getChildren(e) {
    if (e instanceof sa)
      return e.groups;
    if (e instanceof Ew)
      return e.resolve(this._resolverService).then((t) => t.children);
    throw new Error("bad tree");
  }
};
VV = f5([
  g5(0, Wo)
], VV);
class qJe {
  getHeight() {
    return 23;
  }
  getTemplateId(e) {
    return e instanceof Ew ? Lw.id : JS.id;
  }
}
let HV = class {
  constructor(e) {
    this._keybindingService = e;
  }
  getKeyboardNavigationLabel(e) {
    var t;
    if (e instanceof Xg) {
      const n = (t = e.parent.getPreview(e)) === null || t === void 0 ? void 0 : t.preview(e.range);
      if (n)
        return n.value;
    }
    return xl(e.uri);
  }
};
HV = f5([
  g5(0, Bn)
], HV);
class KJe {
  getId(e) {
    return e instanceof Xg ? e.id : e.uri;
  }
}
let WV = class extends we {
  constructor(e, t) {
    super(), this._labelService = t;
    const n = document.createElement("div");
    n.classList.add("reference-file"), this.file = this._register(new $L(n, { supportHighlights: !0 })), this.badge = new UB(Te(n, Re(".count")), {}, ype), e.appendChild(n);
  }
  set(e, t) {
    const n = D4(e.uri);
    this.file.setLabel(this._labelService.getUriBasenameLabel(e.uri), this._labelService.getUriLabel(n, { relative: !0 }), { title: this._labelService.getUriLabel(e.uri), matches: t });
    const r = e.children.length;
    this.badge.setCount(r), r > 1 ? this.badge.setTitleFormat(C("referencesCount", "{0} references", r)) : this.badge.setTitleFormat(C("referenceCount", "{0} reference", r));
  }
};
WV = f5([
  g5(1, I_)
], WV);
let Lw = BV = class {
  constructor(e) {
    this._instantiationService = e, this.templateId = BV.id;
  }
  renderTemplate(e) {
    return this._instantiationService.createInstance(WV, e);
  }
  renderElement(e, t, n) {
    n.set(e.element, BS(e.filterData));
  }
  disposeTemplate(e) {
    e.dispose();
  }
};
Lw.id = "FileReferencesRenderer";
Lw = BV = f5([
  g5(0, bt)
], Lw);
class YJe {
  constructor(e) {
    this.label = new yg(e);
  }
  set(e, t) {
    var n;
    const r = (n = e.parent.getPreview(e)) === null || n === void 0 ? void 0 : n.preview(e.range);
    if (!r || !r.value)
      this.label.set(`${xl(e.uri)}:${e.range.startLineNumber + 1}:${e.range.startColumn + 1}`);
    else {
      const { value: s, highlight: o } = r;
      t && !td.isDefault(t) ? (this.label.element.classList.toggle("referenceMatch", !1), this.label.set(s, BS(t))) : (this.label.element.classList.toggle("referenceMatch", !0), this.label.set(s, [o]));
    }
  }
}
class JS {
  constructor() {
    this.templateId = JS.id;
  }
  renderTemplate(e) {
    return new YJe(e);
  }
  renderElement(e, t, n) {
    n.set(e.element, e.filterData);
  }
  disposeTemplate() {
  }
}
JS.id = "OneReferenceRenderer";
class XJe {
  getWidgetAriaLabel() {
    return C("treeAriaLabel", "References");
  }
  getAriaLabel(e) {
    return e.ariaMessage;
  }
}
var ZJe = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Ku = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, x$ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class p5 {
  constructor(e, t) {
    this._editor = e, this._model = t, this._decorations = /* @__PURE__ */ new Map(), this._decorationIgnoreSet = /* @__PURE__ */ new Set(), this._callOnDispose = new Ne(), this._callOnModelChange = new Ne(), this._callOnDispose.add(this._editor.onDidChangeModel(() => this._onModelChanged())), this._onModelChanged();
  }
  dispose() {
    this._callOnModelChange.dispose(), this._callOnDispose.dispose(), this.removeDecorations();
  }
  _onModelChanged() {
    this._callOnModelChange.clear();
    const e = this._editor.getModel();
    if (e) {
      for (const t of this._model.references)
        if (t.uri.toString() === e.uri.toString()) {
          this._addDecorations(t.parent);
          return;
        }
    }
  }
  _addDecorations(e) {
    if (!this._editor.hasModel())
      return;
    this._callOnModelChange.add(this._editor.getModel().onDidChangeDecorations(() => this._onDecorationChanged()));
    const t = [], n = [];
    for (let r = 0, s = e.children.length; r < s; r++) {
      const o = e.children[r];
      this._decorationIgnoreSet.has(o.id) || o.uri.toString() === this._editor.getModel().uri.toString() && (t.push({
        range: o.range,
        options: p5.DecorationOptions
      }), n.push(r));
    }
    this._editor.changeDecorations((r) => {
      const s = r.deltaDecorations([], t);
      for (let o = 0; o < s.length; o++)
        this._decorations.set(s[o], e.children[n[o]]);
    });
  }
  _onDecorationChanged() {
    const e = [], t = this._editor.getModel();
    if (t) {
      for (const [n, r] of this._decorations) {
        const s = t.getDecorationRange(n);
        if (!s)
          continue;
        let o = !1;
        if (!V.equalsRange(s, r.range)) {
          if (V.spansMultipleLines(s))
            o = !0;
          else {
            const a = r.range.endColumn - r.range.startColumn, l = s.endColumn - s.startColumn;
            a !== l && (o = !0);
          }
          o ? (this._decorationIgnoreSet.add(r.id), e.push(n)) : r.range = s;
        }
      }
      for (let n = 0, r = e.length; n < r; n++)
        this._decorations.delete(e[n]);
      this._editor.removeDecorations(e);
    }
  }
  removeDecorations() {
    this._editor.removeDecorations([...this._decorations.keys()]), this._decorations.clear();
  }
}
p5.DecorationOptions = Lt.register({
  description: "reference-decoration",
  stickiness: 1,
  className: "reference-decoration"
});
class QJe {
  constructor() {
    this.ratio = 0.7, this.heightInLines = 18;
  }
  static fromJSON(e) {
    let t, n;
    try {
      const r = JSON.parse(e);
      t = r.ratio, n = r.heightInLines;
    } catch {
    }
    return {
      ratio: t || 0.7,
      heightInLines: n || 18
    };
  }
}
class JJe extends HB {
}
let jV = class extends mI {
  constructor(e, t, n, r, s, o, a, l, c, d, u, h) {
    super(e, { showFrame: !1, showArrow: !0, isResizeable: !0, isAccessible: !0, supportOnTitleClick: !0 }, o), this._defaultTreeKeyboardSupport = t, this.layoutData = n, this._textModelResolverService = s, this._instantiationService = o, this._peekViewService = a, this._uriLabel = l, this._undoRedoService = c, this._keybindingService = d, this._languageService = u, this._languageConfigurationService = h, this._disposeOnNewModel = new Ne(), this._callOnDispose = new Ne(), this._onDidSelectReference = new pe(), this.onDidSelectReference = this._onDidSelectReference.event, this._dim = new _n(0, 0), this._applyTheme(r.getColorTheme()), this._callOnDispose.add(r.onDidColorThemeChange(this._applyTheme.bind(this))), this._peekViewService.addExclusiveWidget(e, this), this.create();
  }
  dispose() {
    this.setModel(void 0), this._callOnDispose.dispose(), this._disposeOnNewModel.dispose(), An(this._preview), An(this._previewNotAvailableMessage), An(this._tree), An(this._previewModelReference), this._splitView.dispose(), super.dispose();
  }
  _applyTheme(e) {
    const t = e.getColor(jJe) || ye.transparent;
    this.style({
      arrowColor: t,
      frameColor: t,
      headerBackgroundColor: e.getColor(WJe) || ye.transparent,
      primaryHeadingColor: e.getColor(W0e),
      secondaryHeadingColor: e.getColor(j0e)
    });
  }
  show(e) {
    super.show(e, this.layoutData.heightInLines || 18);
  }
  focusOnReferenceTree() {
    this._tree.domFocus();
  }
  focusOnPreviewEditor() {
    this._preview.focus();
  }
  isPreviewEditorFocused() {
    return this._preview.hasTextFocus();
  }
  _onTitleClick(e) {
    this._preview && this._preview.getModel() && this._onDidSelectReference.fire({
      element: this._getFocusedReference(),
      kind: e.ctrlKey || e.metaKey || e.altKey ? "side" : "open",
      source: "title"
    });
  }
  _fillBody(e) {
    this.setCssClass("reference-zone-widget"), this._messageContainer = Te(e, Re("div.messages")), ao(this._messageContainer), this._splitView = new Ipe(e, {
      orientation: 1
      /* Orientation.HORIZONTAL */
    }), this._previewContainer = Te(e, Re("div.preview.inline"));
    const t = {
      scrollBeyondLastLine: !1,
      scrollbar: {
        verticalScrollbarSize: 14,
        horizontal: "auto",
        useShadows: !0,
        verticalHasArrows: !1,
        horizontalHasArrows: !1,
        alwaysConsumeMouseWheel: !0
      },
      overviewRulerLanes: 2,
      fixedOverflowWidgets: !0,
      minimap: {
        enabled: !1
      }
    };
    this._preview = this._instantiationService.createInstance(Yg, this._previewContainer, t, {}, this.editor), ao(this._previewContainer), this._previewNotAvailableMessage = new Du(C("missingPreviewMessage", "no preview available"), Fa, Du.DEFAULT_CREATION_OPTIONS, null, this._undoRedoService, this._languageService, this._languageConfigurationService), this._treeContainer = Te(e, Re("div.ref-tree.inline"));
    const n = {
      keyboardSupport: this._defaultTreeKeyboardSupport,
      accessibilityProvider: new XJe(),
      keyboardNavigationLabelProvider: this._instantiationService.createInstance(HV),
      identityProvider: new KJe(),
      openOnSingleClick: !0,
      selectionNavigation: !0,
      overrideStyles: {
        listBackground: zJe
      }
    };
    this._defaultTreeKeyboardSupport && this._callOnDispose.add(ar(this._treeContainer, "keydown", (s) => {
      s.equals(
        9
        /* KeyCode.Escape */
      ) && (this._keybindingService.dispatchEvent(s, s.target), s.stopPropagation());
    }, !0)), this._tree = this._instantiationService.createInstance(JJe, "ReferencesWidget", this._treeContainer, new qJe(), [
      this._instantiationService.createInstance(Lw),
      this._instantiationService.createInstance(JS)
    ], this._instantiationService.createInstance(VV), n), this._splitView.addView({
      onDidChange: qe.None,
      element: this._previewContainer,
      minimumSize: 200,
      maximumSize: Number.MAX_VALUE,
      layout: (s) => {
        this._preview.layout({ height: this._dim.height, width: s });
      }
    }, XL.Distribute), this._splitView.addView({
      onDidChange: qe.None,
      element: this._treeContainer,
      minimumSize: 100,
      maximumSize: Number.MAX_VALUE,
      layout: (s) => {
        this._treeContainer.style.height = `${this._dim.height}px`, this._treeContainer.style.width = `${s}px`, this._tree.layout(this._dim.height, s);
      }
    }, XL.Distribute), this._disposables.add(this._splitView.onDidSashChange(() => {
      this._dim.width && (this.layoutData.ratio = this._splitView.getViewSize(0) / this._dim.width);
    }, void 0));
    const r = (s, o) => {
      s instanceof Xg && (o === "show" && this._revealReference(s, !1), this._onDidSelectReference.fire({ element: s, kind: o, source: "tree" }));
    };
    this._tree.onDidOpen((s) => {
      s.sideBySide ? r(s.element, "side") : s.editorOptions.pinned ? r(s.element, "goto") : r(s.element, "show");
    }), ao(this._treeContainer);
  }
  _onWidth(e) {
    this._dim && this._doLayoutBody(this._dim.height, e);
  }
  _doLayoutBody(e, t) {
    super._doLayoutBody(e, t), this._dim = new _n(t, e), this.layoutData.heightInLines = this._viewZone ? this._viewZone.heightInLines : this.layoutData.heightInLines, this._splitView.layout(t), this._splitView.resizeView(0, t * this.layoutData.ratio);
  }
  setSelection(e) {
    return this._revealReference(e, !0).then(() => {
      this._model && (this._tree.setSelection([e]), this._tree.setFocus([e]));
    });
  }
  setModel(e) {
    return this._disposeOnNewModel.clear(), this._model = e, this._model ? this._onNewModel() : Promise.resolve();
  }
  _onNewModel() {
    return this._model ? this._model.isEmpty ? (this.setTitle(""), this._messageContainer.innerText = C("noResults", "No results"), Zo(this._messageContainer), Promise.resolve(void 0)) : (ao(this._messageContainer), this._decorationsManager = new p5(this._preview, this._model), this._disposeOnNewModel.add(this._decorationsManager), this._disposeOnNewModel.add(this._model.onDidChangeReferenceRange((e) => this._tree.rerender(e))), this._disposeOnNewModel.add(this._preview.onMouseDown((e) => {
      const { event: t, target: n } = e;
      if (t.detail !== 2)
        return;
      const r = this._getFocusedReference();
      r && this._onDidSelectReference.fire({
        element: { uri: r.uri, range: n.range },
        kind: t.ctrlKey || t.metaKey || t.altKey ? "side" : "open",
        source: "editor"
      });
    })), this.container.classList.add("results-loaded"), Zo(this._treeContainer), Zo(this._previewContainer), this._splitView.layout(this._dim.width), this.focusOnReferenceTree(), this._tree.setInput(this._model.groups.length === 1 ? this._model.groups[0] : this._model)) : Promise.resolve(void 0);
  }
  _getFocusedReference() {
    const [e] = this._tree.getFocus();
    if (e instanceof Xg)
      return e;
    if (e instanceof Ew && e.children.length > 0)
      return e.children[0];
  }
  revealReference(e) {
    return x$(this, void 0, void 0, function* () {
      yield this._revealReference(e, !1), this._onDidSelectReference.fire({ element: e, kind: "goto", source: "tree" });
    });
  }
  _revealReference(e, t) {
    return x$(this, void 0, void 0, function* () {
      if (this._revealedReference === e)
        return;
      this._revealedReference = e, e.uri.scheme !== Mt.inMemory ? this.setTitle(zBe(e.uri), this._uriLabel.getUriLabel(D4(e.uri))) : this.setTitle(C("peekView.alternateTitle", "References"));
      const n = this._textModelResolverService.createModelReference(e.uri);
      this._tree.getInput() === e.parent ? this._tree.reveal(e) : (t && this._tree.reveal(e.parent), yield this._tree.expand(e.parent), this._tree.reveal(e));
      const r = yield n;
      if (!this._model) {
        r.dispose();
        return;
      }
      An(this._previewModelReference);
      const s = r.object;
      if (s) {
        const o = this._preview.getModel() === s.textEditorModel ? 0 : 1, a = V.lift(e.range).collapseToStart();
        this._previewModelReference = r, this._preview.setModel(s.textEditorModel), this._preview.setSelection(a), this._preview.revealRangeInCenter(a, o);
      } else
        this._preview.setModel(this._previewNotAvailableMessage), r.dispose();
    });
  }
};
jV = ZJe([
  Ku(3, Pr),
  Ku(4, Wo),
  Ku(5, bt),
  Ku(6, H0e),
  Ku(7, I_),
  Ku(8, E4),
  Ku(9, Bn),
  Ku(10, ci),
  Ku(11, Un)
], jV);
var $Je = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, b1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, D$ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, oE;
const G0 = new Ke("referenceSearchVisible", !1, C("referenceSearchVisible", "Whether reference peek is visible, like 'Peek References' or 'Peek Definition'"));
let Zg = oE = class {
  static get(e) {
    return e.getContribution(oE.ID);
  }
  constructor(e, t, n, r, s, o, a, l) {
    this._defaultTreeKeyboardSupport = e, this._editor = t, this._editorService = r, this._notificationService = s, this._instantiationService = o, this._storageService = a, this._configurationService = l, this._disposables = new Ne(), this._requestIdPool = 0, this._ignoreModelChangeEvent = !1, this._referenceSearchVisible = G0.bindTo(n);
  }
  dispose() {
    var e, t;
    this._referenceSearchVisible.reset(), this._disposables.dispose(), (e = this._widget) === null || e === void 0 || e.dispose(), (t = this._model) === null || t === void 0 || t.dispose(), this._widget = void 0, this._model = void 0;
  }
  toggleWidget(e, t, n) {
    let r;
    if (this._widget && (r = this._widget.position), this.closeWidget(), r && e.containsPosition(r))
      return;
    this._peekMode = n, this._referenceSearchVisible.set(!0), this._disposables.add(this._editor.onDidChangeModelLanguage(() => {
      this.closeWidget();
    })), this._disposables.add(this._editor.onDidChangeModel(() => {
      this._ignoreModelChangeEvent || this.closeWidget();
    }));
    const s = "peekViewLayout", o = QJe.fromJSON(this._storageService.get(s, 0, "{}"));
    this._widget = this._instantiationService.createInstance(jV, this._editor, this._defaultTreeKeyboardSupport, o), this._widget.setTitle(C("labelLoading", "Loading...")), this._widget.show(e), this._disposables.add(this._widget.onDidClose(() => {
      t.cancel(), this._widget && (this._storageService.store(
        s,
        JSON.stringify(this._widget.layoutData),
        0,
        1
        /* StorageTarget.MACHINE */
      ), this._widget = void 0), this.closeWidget();
    })), this._disposables.add(this._widget.onDidSelectReference((l) => {
      const { element: c, kind: d } = l;
      if (c)
        switch (d) {
          case "open":
            (l.source !== "editor" || !this._configurationService.getValue("editor.stablePeek")) && this.openReference(c, !1, !1);
            break;
          case "side":
            this.openReference(c, !0, !1);
            break;
          case "goto":
            n ? this._gotoReference(c, !0) : this.openReference(c, !1, !0);
            break;
        }
    }));
    const a = ++this._requestIdPool;
    t.then((l) => {
      var c;
      if (a !== this._requestIdPool || !this._widget) {
        l.dispose();
        return;
      }
      return (c = this._model) === null || c === void 0 || c.dispose(), this._model = l, this._widget.setModel(this._model).then(() => {
        if (this._widget && this._model && this._editor.hasModel()) {
          this._model.isEmpty ? this._widget.setMetaTitle("") : this._widget.setMetaTitle(C("metaTitle.N", "{0} ({1})", this._model.title, this._model.references.length));
          const d = this._editor.getModel().uri, u = new ve(e.startLineNumber, e.startColumn), h = this._model.nearestReference(d, u);
          if (h)
            return this._widget.setSelection(h).then(() => {
              this._widget && this._editor.getOption(
                86
                /* EditorOption.peekWidgetDefaultFocus */
              ) === "editor" && this._widget.focusOnPreviewEditor();
            });
        }
      });
    }, (l) => {
      this._notificationService.error(l);
    });
  }
  changeFocusBetweenPreviewAndReferences() {
    this._widget && (this._widget.isPreviewEditorFocused() ? this._widget.focusOnReferenceTree() : this._widget.focusOnPreviewEditor());
  }
  goToNextOrPreviousReference(e) {
    return D$(this, void 0, void 0, function* () {
      if (!this._editor.hasModel() || !this._model || !this._widget)
        return;
      const t = this._widget.position;
      if (!t)
        return;
      const n = this._model.nearestReference(this._editor.getModel().uri, t);
      if (!n)
        return;
      const r = this._model.nextOrPreviousReference(n, e), s = this._editor.hasTextFocus(), o = this._widget.isPreviewEditorFocused();
      yield this._widget.setSelection(r), yield this._gotoReference(r, !1), s ? this._editor.focus() : this._widget && o && this._widget.focusOnPreviewEditor();
    });
  }
  revealReference(e) {
    return D$(this, void 0, void 0, function* () {
      !this._editor.hasModel() || !this._model || !this._widget || (yield this._widget.revealReference(e));
    });
  }
  closeWidget(e = !0) {
    var t, n;
    (t = this._widget) === null || t === void 0 || t.dispose(), (n = this._model) === null || n === void 0 || n.dispose(), this._referenceSearchVisible.reset(), this._disposables.clear(), this._widget = void 0, this._model = void 0, e && this._editor.focus(), this._requestIdPool += 1;
  }
  _gotoReference(e, t) {
    var n;
    (n = this._widget) === null || n === void 0 || n.hide(), this._ignoreModelChangeEvent = !0;
    const r = V.lift(e.range).collapseToStart();
    return this._editorService.openCodeEditor({
      resource: e.uri,
      options: { selection: r, selectionSource: "code.jump", pinned: t }
    }, this._editor).then((s) => {
      var o;
      if (this._ignoreModelChangeEvent = !1, !s || !this._widget) {
        this.closeWidget();
        return;
      }
      if (this._editor === s)
        this._widget.show(r), this._widget.focusOnReferenceTree();
      else {
        const a = oE.get(s), l = this._model.clone();
        this.closeWidget(), s.focus(), a?.toggleWidget(r, Ir((c) => Promise.resolve(l)), (o = this._peekMode) !== null && o !== void 0 ? o : !1);
      }
    }, (s) => {
      this._ignoreModelChangeEvent = !1, It(s);
    });
  }
  openReference(e, t, n) {
    t || this.closeWidget();
    const { uri: r, range: s } = e;
    this._editorService.openCodeEditor({
      resource: r,
      options: { selection: s, selectionSource: "code.jump", pinned: n }
    }, this._editor, t);
  }
};
Zg.ID = "editor.contrib.referencesController";
Zg = oE = $Je([
  b1(2, yt),
  b1(3, Sn),
  b1(4, dr),
  b1(5, bt),
  b1(6, mc),
  b1(7, en)
], Zg);
function q0(i, e) {
  const t = VJe(i);
  if (!t)
    return;
  const n = Zg.get(t);
  n && e(n);
}
Bo.registerCommandAndKeybindingRule({
  id: "togglePeekWidgetFocus",
  weight: 100,
  primary: xr(
    2089,
    60
    /* KeyCode.F2 */
  ),
  when: ke.or(G0, Vo.inPeekEditor),
  handler(i) {
    q0(i, (e) => {
      e.changeFocusBetweenPreviewAndReferences();
    });
  }
});
Bo.registerCommandAndKeybindingRule({
  id: "goToNextReference",
  weight: 90,
  primary: 62,
  secondary: [
    70
    /* KeyCode.F12 */
  ],
  when: ke.or(G0, Vo.inPeekEditor),
  handler(i) {
    q0(i, (e) => {
      e.goToNextOrPreviousReference(!0);
    });
  }
});
Bo.registerCommandAndKeybindingRule({
  id: "goToPreviousReference",
  weight: 90,
  primary: 1086,
  secondary: [
    1094
    /* KeyCode.F12 */
  ],
  when: ke.or(G0, Vo.inPeekEditor),
  handler(i) {
    q0(i, (e) => {
      e.goToNextOrPreviousReference(!1);
    });
  }
});
on.registerCommandAlias("goToNextReferenceFromEmbeddedEditor", "goToNextReference");
on.registerCommandAlias("goToPreviousReferenceFromEmbeddedEditor", "goToPreviousReference");
on.registerCommandAlias("closeReferenceSearchEditor", "closeReferenceSearch");
on.registerCommand("closeReferenceSearch", (i) => q0(i, (e) => e.closeWidget()));
Bo.registerKeybindingRule({
  id: "closeReferenceSearch",
  weight: -1,
  primary: 9,
  secondary: [
    1033
    /* KeyCode.Escape */
  ],
  when: ke.and(Vo.inPeekEditor, ke.not("config.editor.stablePeek"))
});
Bo.registerKeybindingRule({
  id: "closeReferenceSearch",
  weight: 250,
  primary: 9,
  secondary: [
    1033
    /* KeyCode.Escape */
  ],
  when: ke.and(G0, ke.not("config.editor.stablePeek"))
});
Bo.registerCommandAndKeybindingRule({
  id: "revealReference",
  weight: 200,
  primary: 3,
  mac: {
    primary: 3,
    secondary: [
      2066
      /* KeyCode.DownArrow */
    ]
  },
  when: ke.and(G0, zpe, wU.negate(), SU.negate()),
  handler(i) {
    var e;
    const n = (e = i.get(Nl).lastFocusedList) === null || e === void 0 ? void 0 : e.getFocus();
    Array.isArray(n) && n[0] instanceof Xg && q0(i, (r) => r.revealReference(n[0]));
  }
});
Bo.registerCommandAndKeybindingRule({
  id: "openReferenceToSide",
  weight: 100,
  primary: 2051,
  mac: {
    primary: 259
    /* KeyCode.Enter */
  },
  when: ke.and(G0, zpe, wU.negate(), SU.negate()),
  handler(i) {
    var e;
    const n = (e = i.get(Nl).lastFocusedList) === null || e === void 0 ? void 0 : e.getFocus();
    Array.isArray(n) && n[0] instanceof Xg && q0(i, (r) => r.openReference(n[0], !0, !0));
  }
});
on.registerCommand("openReference", (i) => {
  var e;
  const n = (e = i.get(Nl).lastFocusedList) === null || e === void 0 ? void 0 : e.getFocus();
  Array.isArray(n) && n[0] instanceof Xg && q0(i, (r) => r.openReference(n[0], !1, !0));
});
var z0e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, rC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const sG = new Ke("hasSymbols", !1, C("hasSymbols", "Whether there are symbol locations that can be navigated via keyboard-only.")), m5 = Gt("ISymbolNavigationService");
let zV = class {
  constructor(e, t, n, r) {
    this._editorService = t, this._notificationService = n, this._keybindingService = r, this._currentModel = void 0, this._currentIdx = -1, this._ignoreEditorChange = !1, this._ctxHasSymbols = sG.bindTo(e);
  }
  reset() {
    var e, t;
    this._ctxHasSymbols.reset(), (e = this._currentState) === null || e === void 0 || e.dispose(), (t = this._currentMessage) === null || t === void 0 || t.dispose(), this._currentModel = void 0, this._currentIdx = -1;
  }
  put(e) {
    const t = e.parent.parent;
    if (t.references.length <= 1) {
      this.reset();
      return;
    }
    this._currentModel = t, this._currentIdx = t.references.indexOf(e), this._ctxHasSymbols.set(!0), this._showMessage();
    const n = new UV(this._editorService), r = n.onDidChange((s) => {
      if (this._ignoreEditorChange)
        return;
      const o = this._editorService.getActiveCodeEditor();
      if (!o)
        return;
      const a = o.getModel(), l = o.getPosition();
      if (!a || !l)
        return;
      let c = !1, d = !1;
      for (const u of t.references)
        if (Tz(u.uri, a.uri))
          c = !0, d = d || V.containsPosition(u.range, l);
        else if (c)
          break;
      (!c || !d) && this.reset();
    });
    this._currentState = Ql(n, r);
  }
  revealNext(e) {
    if (!this._currentModel)
      return Promise.resolve();
    this._currentIdx += 1, this._currentIdx %= this._currentModel.references.length;
    const t = this._currentModel.references[this._currentIdx];
    return this._showMessage(), this._ignoreEditorChange = !0, this._editorService.openCodeEditor({
      resource: t.uri,
      options: {
        selection: V.collapseToStart(t.range),
        selectionRevealType: 3
        /* TextEditorSelectionRevealType.NearTopIfOutsideViewport */
      }
    }, e).finally(() => {
      this._ignoreEditorChange = !1;
    });
  }
  _showMessage() {
    var e;
    (e = this._currentMessage) === null || e === void 0 || e.dispose();
    const t = this._keybindingService.lookupKeybinding("editor.gotoNextSymbolFromResult"), n = t ? C("location.kb", "Symbol {0} of {1}, {2} for next", this._currentIdx + 1, this._currentModel.references.length, t.getLabel()) : C("location", "Symbol {0} of {1}", this._currentIdx + 1, this._currentModel.references.length);
    this._currentMessage = this._notificationService.status(n);
  }
};
zV = z0e([
  rC(0, yt),
  rC(1, Sn),
  rC(2, dr),
  rC(3, Bn)
], zV);
an(
  m5,
  zV,
  1
  /* InstantiationType.Delayed */
);
ze(new class extends Kr {
  constructor() {
    super({
      id: "editor.gotoNextSymbolFromResult",
      precondition: sG,
      kbOpts: {
        weight: 100,
        primary: 70
        /* KeyCode.F12 */
      }
    });
  }
  runEditorCommand(i, e) {
    return i.get(m5).revealNext(e);
  }
}());
Bo.registerCommandAndKeybindingRule({
  id: "editor.gotoNextSymbolFromResult.cancel",
  weight: 100,
  when: sG,
  primary: 9,
  handler(i) {
    i.get(m5).reset();
  }
});
let UV = class {
  constructor(e) {
    this._listener = /* @__PURE__ */ new Map(), this._disposables = new Ne(), this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event, this._disposables.add(e.onCodeEditorRemove(this._onDidRemoveEditor, this)), this._disposables.add(e.onCodeEditorAdd(this._onDidAddEditor, this)), e.listCodeEditors().forEach(this._onDidAddEditor, this);
  }
  dispose() {
    this._disposables.dispose(), this._onDidChange.dispose(), An(this._listener.values());
  }
  _onDidAddEditor(e) {
    this._listener.set(e, Ql(e.onDidChangeCursorPosition((t) => this._onDidChange.fire({ editor: e })), e.onDidChangeModelContent((t) => this._onDidChange.fire({ editor: e }))));
  }
  _onDidRemoveEditor(e) {
    var t;
    (t = this._listener.get(e)) === null || t === void 0 || t.dispose(), this._listener.delete(e);
  }
};
UV = z0e([
  rC(0, Sn)
], UV);
var oG = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function $S(i, e, t, n) {
  return oG(this, void 0, void 0, function* () {
    const s = t.ordered(i).map((a) => Promise.resolve(n(a, i, e)).then(void 0, (l) => {
      vr(l);
    })), o = yield Promise.all(s);
    return _u(o.flat());
  });
}
function v5(i, e, t, n) {
  return $S(e, t, i, (r, s, o) => r.provideDefinition(s, o, n));
}
function U0e(i, e, t, n) {
  return $S(e, t, i, (r, s, o) => r.provideDeclaration(s, o, n));
}
function G0e(i, e, t, n) {
  return $S(e, t, i, (r, s, o) => r.provideImplementation(s, o, n));
}
function q0e(i, e, t, n) {
  return $S(e, t, i, (r, s, o) => r.provideTypeDefinition(s, o, n));
}
function _5(i, e, t, n, r) {
  return $S(e, t, i, (s, o, a) => oG(this, void 0, void 0, function* () {
    const l = yield s.provideReferences(o, a, { includeDeclaration: !0 }, r);
    if (!n || !l || l.length !== 2)
      return l;
    const c = yield s.provideReferences(o, a, { includeDeclaration: !1 }, r);
    return c && c.length === 1 ? c : l;
  }));
}
function ex(i) {
  return oG(this, void 0, void 0, function* () {
    const e = yield i(), t = new sa(e, ""), n = t.references.map((r) => r.link);
    return t.dispose(), n;
  });
}
Ru("_executeDefinitionProvider", (i, e, t) => {
  const n = i.get(tt), r = v5(n.definitionProvider, e, t, jt.None);
  return ex(() => r);
});
Ru("_executeTypeDefinitionProvider", (i, e, t) => {
  const n = i.get(tt), r = q0e(n.typeDefinitionProvider, e, t, jt.None);
  return ex(() => r);
});
Ru("_executeDeclarationProvider", (i, e, t) => {
  const n = i.get(tt), r = U0e(n.declarationProvider, e, t, jt.None);
  return ex(() => r);
});
Ru("_executeReferenceProvider", (i, e, t) => {
  const n = i.get(tt), r = _5(n.referenceProvider, e, t, !1, jt.None);
  return ex(() => r);
});
Ru("_executeImplementationProvider", (i, e, t) => {
  const n = i.get(tt), r = G0e(n.implementationProvider, e, t, jt.None);
  return ex(() => r);
});
var ec = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, m2, v2, _2, ED, LD, ID, AD, kD;
os.appendMenuItem(J.EditorContext, {
  submenu: J.EditorContextPeek,
  title: C("peek.submenu", "Peek"),
  group: "navigation",
  order: 100
});
class H_ {
  static is(e) {
    return !e || typeof e != "object" ? !1 : !!(e instanceof H_ || ve.isIPosition(e.position) && e.model);
  }
  constructor(e, t) {
    this.model = e, this.position = t;
  }
}
class Xs extends vd {
  static all() {
    return Xs._allSymbolNavigationCommands.values();
  }
  static _patchConfig(e) {
    const t = Object.assign(Object.assign({}, e), { f1: !0 });
    if (t.menu)
      for (const n of Wt.wrap(t.menu))
        (n.id === J.EditorContext || n.id === J.EditorContextPeek) && (n.when = ke.and(e.precondition, n.when));
    return t;
  }
  constructor(e, t) {
    super(Xs._patchConfig(t)), this.configuration = e, Xs._allSymbolNavigationCommands.set(t.id, this);
  }
  runEditorCommand(e, t, n, r) {
    if (!t.hasModel())
      return Promise.resolve(void 0);
    const s = e.get(dr), o = e.get(Sn), a = e.get(hp), l = e.get(m5), c = e.get(tt), d = e.get(bt), u = t.getModel(), h = t.getPosition(), f = H_.is(n) ? n : new H_(u, h), g = new Gg(
      t,
      5
      /* CodeEditorStateFlag.Position */
    ), p = i4(this._getLocationModel(c, f.model, f.position, g.token), g.token).then((m) => ec(this, void 0, void 0, function* () {
      var _;
      if (!m || g.token.isCancellationRequested)
        return;
      Fs(m.ariaMessage);
      let b;
      if (m.referenceAt(u.uri, h)) {
        const y = this._getAlternativeCommand(t);
        !Xs._activeAlternativeCommands.has(y) && Xs._allSymbolNavigationCommands.has(y) && (b = Xs._allSymbolNavigationCommands.get(y));
      }
      const w = m.references.length;
      if (w === 0) {
        if (!this.configuration.muteMessage) {
          const y = u.getWordAtPosition(h);
          (_ = ra.get(t)) === null || _ === void 0 || _.showMessage(this._getNoResultFoundMessage(y), h);
        }
      } else if (w === 1 && b)
        Xs._activeAlternativeCommands.add(this.desc.id), d.invokeFunction((y) => b.runEditorCommand(y, t, n, r).finally(() => {
          Xs._activeAlternativeCommands.delete(this.desc.id);
        }));
      else
        return this._onResult(o, l, t, m, r);
    }), (m) => {
      s.error(m);
    }).finally(() => {
      g.dispose();
    });
    return a.showWhile(p, 250), p;
  }
  _onResult(e, t, n, r, s) {
    return ec(this, void 0, void 0, function* () {
      const o = this._getGoToPreference(n);
      if (!(n instanceof Yg) && (this.configuration.openInPeek || o === "peek" && r.references.length > 1))
        this._openInPeek(n, r, s);
      else {
        const a = r.firstReference(), l = r.references.length > 1 && o === "gotoAndPeek", c = yield this._openReference(n, e, a, this.configuration.openToSide, !l);
        l && c ? this._openInPeek(c, r, s) : r.dispose(), o === "goto" && t.put(a);
      }
    });
  }
  _openReference(e, t, n, r, s) {
    return ec(this, void 0, void 0, function* () {
      let o;
      if (lNe(n) && (o = n.targetSelectionRange), o || (o = n.range), !o)
        return;
      const a = yield t.openCodeEditor({
        resource: n.uri,
        options: {
          selection: V.collapseToStart(o),
          selectionRevealType: 3,
          selectionSource: "code.jump"
          /* TextEditorSelectionSource.JUMP */
        }
      }, e, r);
      if (a) {
        if (s) {
          const l = a.getModel(), c = a.createDecorationsCollection([{ range: o, options: { description: "symbol-navigate-action-highlight", className: "symbolHighlight" } }]);
          setTimeout(() => {
            a.getModel() === l && c.clear();
          }, 350);
        }
        return a;
      }
    });
  }
  _openInPeek(e, t, n) {
    const r = Zg.get(e);
    r && e.hasModel() ? r.toggleWidget(n ?? e.getSelection(), Ir((s) => Promise.resolve(t)), this.configuration.openInPeek) : t.dispose();
  }
}
Xs._allSymbolNavigationCommands = /* @__PURE__ */ new Map();
Xs._activeAlternativeCommands = /* @__PURE__ */ new Set();
class tx extends Xs {
  _getLocationModel(e, t, n, r) {
    return ec(this, void 0, void 0, function* () {
      return new sa(yield v5(e.definitionProvider, t, n, r), C("def.title", "Definitions"));
    });
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? C("noResultWord", "No definition found for '{0}'", e.word) : C("generic.noResults", "No definition found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).alternativeDefinitionCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).multipleDefinitions;
  }
}
oi((m2 = class extends tx {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !1,
      muteMessage: !1
    }, {
      id: m2.id,
      title: {
        value: C("actions.goToDecl.label", "Go to Definition"),
        original: "Go to Definition",
        mnemonicTitle: C({ key: "miGotoDefinition", comment: ["&& denotes a mnemonic"] }, "Go to &&Definition")
      },
      precondition: ke.and($.hasDefinitionProvider, $.isInWalkThroughSnippet.toNegated()),
      keybinding: [{
        when: $.editorTextFocus,
        primary: 70,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }, {
        when: ke.and($.editorTextFocus, Hpe),
        primary: 2118,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }],
      menu: [{
        id: J.EditorContext,
        group: "navigation",
        order: 1.1
      }, {
        id: J.MenubarGoMenu,
        precondition: null,
        group: "4_symbol_nav",
        order: 2
      }]
    }), on.registerCommandAlias("editor.action.goToDeclaration", m2.id);
  }
}, m2.id = "editor.action.revealDefinition", m2));
oi((v2 = class extends tx {
  constructor() {
    super({
      openToSide: !0,
      openInPeek: !1,
      muteMessage: !1
    }, {
      id: v2.id,
      title: {
        value: C("actions.goToDeclToSide.label", "Open Definition to the Side"),
        original: "Open Definition to the Side"
      },
      precondition: ke.and($.hasDefinitionProvider, $.isInWalkThroughSnippet.toNegated()),
      keybinding: [{
        when: $.editorTextFocus,
        primary: xr(
          2089,
          70
          /* KeyCode.F12 */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }, {
        when: ke.and($.editorTextFocus, Hpe),
        primary: xr(
          2089,
          2118
          /* KeyCode.F12 */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }]
    }), on.registerCommandAlias("editor.action.openDeclarationToTheSide", v2.id);
  }
}, v2.id = "editor.action.revealDefinitionAside", v2));
oi((_2 = class extends tx {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !0,
      muteMessage: !1
    }, {
      id: _2.id,
      title: {
        value: C("actions.previewDecl.label", "Peek Definition"),
        original: "Peek Definition"
      },
      precondition: ke.and($.hasDefinitionProvider, Vo.notInPeekEditor, $.isInWalkThroughSnippet.toNegated()),
      keybinding: {
        when: $.editorTextFocus,
        primary: 582,
        linux: {
          primary: 3140
          /* KeyCode.F10 */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menu: {
        id: J.EditorContextPeek,
        group: "peek",
        order: 2
      }
    }), on.registerCommandAlias("editor.action.previewDeclaration", _2.id);
  }
}, _2.id = "editor.action.peekDefinition", _2));
class K0e extends Xs {
  _getLocationModel(e, t, n, r) {
    return ec(this, void 0, void 0, function* () {
      return new sa(yield U0e(e.declarationProvider, t, n, r), C("decl.title", "Declarations"));
    });
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? C("decl.noResultWord", "No declaration found for '{0}'", e.word) : C("decl.generic.noResults", "No declaration found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).alternativeDeclarationCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).multipleDeclarations;
  }
}
oi((ED = class extends K0e {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !1,
      muteMessage: !1
    }, {
      id: ED.id,
      title: {
        value: C("actions.goToDeclaration.label", "Go to Declaration"),
        original: "Go to Declaration",
        mnemonicTitle: C({ key: "miGotoDeclaration", comment: ["&& denotes a mnemonic"] }, "Go to &&Declaration")
      },
      precondition: ke.and($.hasDeclarationProvider, $.isInWalkThroughSnippet.toNegated()),
      menu: [{
        id: J.EditorContext,
        group: "navigation",
        order: 1.3
      }, {
        id: J.MenubarGoMenu,
        precondition: null,
        group: "4_symbol_nav",
        order: 3
      }]
    });
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? C("decl.noResultWord", "No declaration found for '{0}'", e.word) : C("decl.generic.noResults", "No declaration found");
  }
}, ED.id = "editor.action.revealDeclaration", ED));
oi(class extends K0e {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !0,
      muteMessage: !1
    }, {
      id: "editor.action.peekDeclaration",
      title: {
        value: C("actions.peekDecl.label", "Peek Declaration"),
        original: "Peek Declaration"
      },
      precondition: ke.and($.hasDeclarationProvider, Vo.notInPeekEditor, $.isInWalkThroughSnippet.toNegated()),
      menu: {
        id: J.EditorContextPeek,
        group: "peek",
        order: 3
      }
    });
  }
});
class Y0e extends Xs {
  _getLocationModel(e, t, n, r) {
    return ec(this, void 0, void 0, function* () {
      return new sa(yield q0e(e.typeDefinitionProvider, t, n, r), C("typedef.title", "Type Definitions"));
    });
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? C("goToTypeDefinition.noResultWord", "No type definition found for '{0}'", e.word) : C("goToTypeDefinition.generic.noResults", "No type definition found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).alternativeTypeDefinitionCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).multipleTypeDefinitions;
  }
}
oi((LD = class extends Y0e {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !1,
      muteMessage: !1
    }, {
      id: LD.ID,
      title: {
        value: C("actions.goToTypeDefinition.label", "Go to Type Definition"),
        original: "Go to Type Definition",
        mnemonicTitle: C({ key: "miGotoTypeDefinition", comment: ["&& denotes a mnemonic"] }, "Go to &&Type Definition")
      },
      precondition: ke.and($.hasTypeDefinitionProvider, $.isInWalkThroughSnippet.toNegated()),
      keybinding: {
        when: $.editorTextFocus,
        primary: 0,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menu: [{
        id: J.EditorContext,
        group: "navigation",
        order: 1.4
      }, {
        id: J.MenubarGoMenu,
        precondition: null,
        group: "4_symbol_nav",
        order: 3
      }]
    });
  }
}, LD.ID = "editor.action.goToTypeDefinition", LD));
oi((ID = class extends Y0e {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !0,
      muteMessage: !1
    }, {
      id: ID.ID,
      title: {
        value: C("actions.peekTypeDefinition.label", "Peek Type Definition"),
        original: "Peek Type Definition"
      },
      precondition: ke.and($.hasTypeDefinitionProvider, Vo.notInPeekEditor, $.isInWalkThroughSnippet.toNegated()),
      menu: {
        id: J.EditorContextPeek,
        group: "peek",
        order: 4
      }
    });
  }
}, ID.ID = "editor.action.peekTypeDefinition", ID));
class X0e extends Xs {
  _getLocationModel(e, t, n, r) {
    return ec(this, void 0, void 0, function* () {
      return new sa(yield G0e(e.implementationProvider, t, n, r), C("impl.title", "Implementations"));
    });
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? C("goToImplementation.noResultWord", "No implementation found for '{0}'", e.word) : C("goToImplementation.generic.noResults", "No implementation found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).alternativeImplementationCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).multipleImplementations;
  }
}
oi((AD = class extends X0e {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !1,
      muteMessage: !1
    }, {
      id: AD.ID,
      title: {
        value: C("actions.goToImplementation.label", "Go to Implementations"),
        original: "Go to Implementations",
        mnemonicTitle: C({ key: "miGotoImplementation", comment: ["&& denotes a mnemonic"] }, "Go to &&Implementations")
      },
      precondition: ke.and($.hasImplementationProvider, $.isInWalkThroughSnippet.toNegated()),
      keybinding: {
        when: $.editorTextFocus,
        primary: 2118,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menu: [{
        id: J.EditorContext,
        group: "navigation",
        order: 1.45
      }, {
        id: J.MenubarGoMenu,
        precondition: null,
        group: "4_symbol_nav",
        order: 4
      }]
    });
  }
}, AD.ID = "editor.action.goToImplementation", AD));
oi((kD = class extends X0e {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !0,
      muteMessage: !1
    }, {
      id: kD.ID,
      title: {
        value: C("actions.peekImplementation.label", "Peek Implementations"),
        original: "Peek Implementations"
      },
      precondition: ke.and($.hasImplementationProvider, Vo.notInPeekEditor, $.isInWalkThroughSnippet.toNegated()),
      keybinding: {
        when: $.editorTextFocus,
        primary: 3142,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menu: {
        id: J.EditorContextPeek,
        group: "peek",
        order: 5
      }
    });
  }
}, kD.ID = "editor.action.peekImplementation", kD));
class Z0e extends Xs {
  _getNoResultFoundMessage(e) {
    return e ? C("references.no", "No references found for '{0}'", e.word) : C("references.noGeneric", "No references found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).alternativeReferenceCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).multipleReferences;
  }
}
oi(class extends Z0e {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !1,
      muteMessage: !1
    }, {
      id: "editor.action.goToReferences",
      title: {
        value: C("goToReferences.label", "Go to References"),
        original: "Go to References",
        mnemonicTitle: C({ key: "miGotoReference", comment: ["&& denotes a mnemonic"] }, "Go to &&References")
      },
      precondition: ke.and($.hasReferenceProvider, Vo.notInPeekEditor, $.isInWalkThroughSnippet.toNegated()),
      keybinding: {
        when: $.editorTextFocus,
        primary: 1094,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menu: [{
        id: J.EditorContext,
        group: "navigation",
        order: 1.45
      }, {
        id: J.MenubarGoMenu,
        precondition: null,
        group: "4_symbol_nav",
        order: 5
      }]
    });
  }
  _getLocationModel(e, t, n, r) {
    return ec(this, void 0, void 0, function* () {
      return new sa(yield _5(e.referenceProvider, t, n, !0, r), C("ref.title", "References"));
    });
  }
});
oi(class extends Z0e {
  constructor() {
    super({
      openToSide: !1,
      openInPeek: !0,
      muteMessage: !1
    }, {
      id: "editor.action.referenceSearch.trigger",
      title: {
        value: C("references.action.label", "Peek References"),
        original: "Peek References"
      },
      precondition: ke.and($.hasReferenceProvider, Vo.notInPeekEditor, $.isInWalkThroughSnippet.toNegated()),
      menu: {
        id: J.EditorContextPeek,
        group: "peek",
        order: 6
      }
    });
  }
  _getLocationModel(e, t, n, r) {
    return ec(this, void 0, void 0, function* () {
      return new sa(yield _5(e.referenceProvider, t, n, !1, r), C("ref.title", "References"));
    });
  }
});
class e$e extends Xs {
  constructor(e, t, n) {
    super(e, {
      id: "editor.action.goToLocation",
      title: {
        value: C("label.generic", "Go to Any Symbol"),
        original: "Go to Any Symbol"
      },
      precondition: ke.and(Vo.notInPeekEditor, $.isInWalkThroughSnippet.toNegated())
    }), this._references = t, this._gotoMultipleBehaviour = n;
  }
  _getLocationModel(e, t, n, r) {
    return ec(this, void 0, void 0, function* () {
      return new sa(this._references, C("generic.title", "Locations"));
    });
  }
  _getNoResultFoundMessage(e) {
    return e && C("generic.noResult", "No results for '{0}'", e.word) || "";
  }
  _getGoToPreference(e) {
    var t;
    return (t = this._gotoMultipleBehaviour) !== null && t !== void 0 ? t : e.getOption(
      58
      /* EditorOption.gotoLocation */
    ).multipleReferences;
  }
  _getAlternativeCommand() {
    return "";
  }
}
on.registerCommand({
  id: "editor.action.goToLocations",
  description: {
    description: "Go to locations from a position in a file",
    args: [
      { name: "uri", description: "The text document in which to start", constraint: pt },
      { name: "position", description: "The position at which to start", constraint: ve.isIPosition },
      { name: "locations", description: "An array of locations.", constraint: Array },
      { name: "multiple", description: "Define what to do when having multiple results, either `peek`, `gotoAndPeek`, or `goto" },
      { name: "noResultsMessage", description: "Human readable message that shows when locations is empty." }
    ]
  },
  handler: (i, e, t, n, r, s, o) => ec(void 0, void 0, void 0, function* () {
    On(pt.isUri(e)), On(ve.isIPosition(t)), On(Array.isArray(n)), On(typeof r > "u" || typeof r == "string"), On(typeof o > "u" || typeof o == "boolean");
    const a = i.get(Sn), l = yield a.openCodeEditor({ resource: e }, a.getFocusedCodeEditor());
    if (Au(l))
      return l.setPosition(t), l.revealPositionInCenterIfOutsideViewport(
        t,
        0
        /* ScrollType.Smooth */
      ), l.invokeWithinContext((c) => {
        const d = new class extends e$e {
          _getNoResultFoundMessage(u) {
            return s || super._getNoResultFoundMessage(u);
          }
        }({
          muteMessage: !s,
          openInPeek: !!o,
          openToSide: !1
        }, n, r);
        c.get(bt).invokeFunction(d.run.bind(d), l);
      });
  })
});
on.registerCommand({
  id: "editor.action.peekLocations",
  description: {
    description: "Peek locations from a position in a file",
    args: [
      { name: "uri", description: "The text document in which to start", constraint: pt },
      { name: "position", description: "The position at which to start", constraint: ve.isIPosition },
      { name: "locations", description: "An array of locations.", constraint: Array },
      { name: "multiple", description: "Define what to do when having multiple results, either `peek`, `gotoAndPeek`, or `goto" }
    ]
  },
  handler: (i, e, t, n, r) => ec(void 0, void 0, void 0, function* () {
    i.get(Ui).executeCommand("editor.action.goToLocations", e, t, n, r, void 0, !0);
  })
});
on.registerCommand({
  id: "editor.action.findReferences",
  handler: (i, e, t) => {
    On(pt.isUri(e)), On(ve.isIPosition(t));
    const n = i.get(tt), r = i.get(Sn);
    return r.openCodeEditor({ resource: e }, r.getFocusedCodeEditor()).then((s) => {
      if (!Au(s) || !s.hasModel())
        return;
      const o = Zg.get(s);
      if (!o)
        return;
      const a = Ir((c) => _5(n.referenceProvider, s.getModel(), ve.lift(t), !1, c).then((d) => new sa(d, C("ref.title", "References")))), l = new V(t.lineNumber, t.column, t.lineNumber, t.column);
      return Promise.resolve(o.toggleWidget(l, a, !1));
    });
  }
});
on.registerCommandAlias("editor.action.showReferences", "editor.action.peekLocations");
var t$e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, LT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, E$ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, sC;
let c0 = sC = class {
  constructor(e, t, n, r) {
    this.textModelResolverService = t, this.languageService = n, this.languageFeaturesService = r, this.toUnhook = new Ne(), this.toUnhookForKeyboard = new Ne(), this.currentWordAtPosition = null, this.previousPromise = null, this.editor = e, this.linkDecorations = this.editor.createDecorationsCollection();
    const s = new u5(e);
    this.toUnhook.add(s), this.toUnhook.add(s.onMouseMoveOrRelevantKeyDown(([o, a]) => {
      this.startFindDefinitionFromMouse(o, a ?? void 0);
    })), this.toUnhook.add(s.onExecute((o) => {
      this.isEnabled(o) && this.gotoDefinition(o.target.position, o.hasSideBySideModifier).catch((a) => {
        It(a);
      }).finally(() => {
        this.removeLinkDecorations();
      });
    })), this.toUnhook.add(s.onCancel(() => {
      this.removeLinkDecorations(), this.currentWordAtPosition = null;
    }));
  }
  static get(e) {
    return e.getContribution(sC.ID);
  }
  startFindDefinitionFromCursor(e) {
    return E$(this, void 0, void 0, function* () {
      yield this.startFindDefinition(e), this.toUnhookForKeyboard.add(this.editor.onDidChangeCursorPosition(() => {
        this.currentWordAtPosition = null, this.removeLinkDecorations(), this.toUnhookForKeyboard.clear();
      })), this.toUnhookForKeyboard.add(this.editor.onKeyDown((t) => {
        t && (this.currentWordAtPosition = null, this.removeLinkDecorations(), this.toUnhookForKeyboard.clear());
      }));
    });
  }
  startFindDefinitionFromMouse(e, t) {
    if (e.target.type === 9 && this.linkDecorations.length > 0)
      return;
    if (!this.editor.hasModel() || !this.isEnabled(e, t)) {
      this.currentWordAtPosition = null, this.removeLinkDecorations();
      return;
    }
    const n = e.target.position;
    this.startFindDefinition(n);
  }
  startFindDefinition(e) {
    var t;
    return E$(this, void 0, void 0, function* () {
      this.toUnhookForKeyboard.clear();
      const n = e ? (t = this.editor.getModel()) === null || t === void 0 ? void 0 : t.getWordAtPosition(e) : null;
      if (!n) {
        this.currentWordAtPosition = null, this.removeLinkDecorations();
        return;
      }
      if (this.currentWordAtPosition && this.currentWordAtPosition.startColumn === n.startColumn && this.currentWordAtPosition.endColumn === n.endColumn && this.currentWordAtPosition.word === n.word)
        return;
      this.currentWordAtPosition = n;
      const r = new Ime(
        this.editor,
        15
        /* CodeEditorStateFlag.Scroll */
      );
      this.previousPromise && (this.previousPromise.cancel(), this.previousPromise = null), this.previousPromise = Ir((a) => this.findDefinition(e, a));
      let s;
      try {
        s = yield this.previousPromise;
      } catch (a) {
        It(a);
        return;
      }
      if (!s || !s.length || !r.validate(this.editor)) {
        this.removeLinkDecorations();
        return;
      }
      const o = s[0].originSelectionRange ? V.lift(s[0].originSelectionRange) : new V(e.lineNumber, n.startColumn, e.lineNumber, n.endColumn);
      if (s.length > 1) {
        let a = o;
        for (const { originSelectionRange: l } of s)
          l && (a = V.plusRange(a, l));
        this.addDecoration(a, new ys().appendText(C("multipleResults", "Click to show {0} definitions.", s.length)));
      } else {
        const a = s[0];
        if (!a.uri)
          return;
        this.textModelResolverService.createModelReference(a.uri).then((l) => {
          if (!l.object || !l.object.textEditorModel) {
            l.dispose();
            return;
          }
          const { object: { textEditorModel: c } } = l, { startLineNumber: d } = a.range;
          if (d < 1 || d > c.getLineCount()) {
            l.dispose();
            return;
          }
          const u = this.getPreviewValue(c, d, a), h = this.languageService.guessLanguageIdByFilepathOrFirstLine(c.uri);
          this.addDecoration(o, u ? new ys().appendCodeblock(h || "", u) : void 0), l.dispose();
        });
      }
    });
  }
  getPreviewValue(e, t, n) {
    let r = n.range;
    return r.endLineNumber - r.startLineNumber >= sC.MAX_SOURCE_PREVIEW_LINES && (r = this.getPreviewRangeBasedOnIndentation(e, t)), this.stripIndentationFromPreviewRange(e, t, r);
  }
  stripIndentationFromPreviewRange(e, t, n) {
    let s = e.getLineFirstNonWhitespaceColumn(t);
    for (let a = t + 1; a < n.endLineNumber; a++) {
      const l = e.getLineFirstNonWhitespaceColumn(a);
      s = Math.min(s, l);
    }
    return e.getValueInRange(n).replace(new RegExp(`^\\s{${s - 1}}`, "gm"), "").trim();
  }
  getPreviewRangeBasedOnIndentation(e, t) {
    const n = e.getLineFirstNonWhitespaceColumn(t), r = Math.min(e.getLineCount(), t + sC.MAX_SOURCE_PREVIEW_LINES);
    let s = t + 1;
    for (; s < r; s++) {
      const o = e.getLineFirstNonWhitespaceColumn(s);
      if (n === o)
        break;
    }
    return new V(t, 1, s + 1, 1);
  }
  addDecoration(e, t) {
    const n = {
      range: e,
      options: {
        description: "goto-definition-link",
        inlineClassName: "goto-definition-link",
        hoverMessage: t
      }
    };
    this.linkDecorations.set([n]);
  }
  removeLinkDecorations() {
    this.linkDecorations.clear();
  }
  isEnabled(e, t) {
    var n;
    return this.editor.hasModel() && e.isLeftClick && e.isNoneOrSingleMouseDown && e.target.type === 6 && !(((n = e.target.detail.injectedText) === null || n === void 0 ? void 0 : n.options) instanceof Ug) && (e.hasTriggerModifier || (t ? t.keyCodeIsTriggerKey : !1)) && this.languageFeaturesService.definitionProvider.has(this.editor.getModel());
  }
  findDefinition(e, t) {
    const n = this.editor.getModel();
    return n ? v5(this.languageFeaturesService.definitionProvider, n, e, t) : Promise.resolve(null);
  }
  gotoDefinition(e, t) {
    return this.editor.setPosition(e), this.editor.invokeWithinContext((n) => {
      const r = !t && this.editor.getOption(
        87
        /* EditorOption.definitionLinkOpensInPeek */
      ) && !this.isInPeekEditor(n);
      return new tx({ openToSide: t, openInPeek: r, muteMessage: !0 }, { title: { value: "", original: "" }, id: "", precondition: void 0 }).run(n);
    });
  }
  isInPeekEditor(e) {
    const t = e.get(yt);
    return Vo.inPeekEditor.getValue(t);
  }
  dispose() {
    this.toUnhook.dispose(), this.toUnhookForKeyboard.dispose();
  }
};
c0.ID = "editor.contrib.gotodefinitionatposition";
c0.MAX_SOURCE_PREVIEW_LINES = 8;
c0 = sC = t$e([
  LT(1, Wo),
  LT(2, ci),
  LT(3, tt)
], c0);
pn(
  c0.ID,
  c0,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
const TD = Re;
class Q0e extends we {
  constructor() {
    super(), this.containerDomNode = document.createElement("div"), this.containerDomNode.className = "monaco-hover", this.containerDomNode.tabIndex = 0, this.containerDomNode.setAttribute("role", "tooltip"), this.contentsDomNode = document.createElement("div"), this.contentsDomNode.className = "monaco-hover-content", this.scrollbar = this._register(new TS(this.contentsDomNode, {
      consumeMouseWheelIfScrollbarIsNeeded: !0
    })), this.containerDomNode.appendChild(this.scrollbar.getDomNode());
  }
  onContentsChanged() {
    this.scrollbar.scanDomNode();
  }
}
class aG extends we {
  static render(e, t, n) {
    return new aG(e, t, n);
  }
  constructor(e, t, n) {
    super(), this.actionContainer = Te(e, TD("div.action-container")), this.actionContainer.setAttribute("tabindex", "0"), this.action = Te(this.actionContainer, TD("a.action")), this.action.setAttribute("role", "button"), t.iconClass && Te(this.action, TD(`span.icon.${t.iconClass}`));
    const r = Te(this.action, TD("span"));
    r.textContent = n ? `${t.label} (${n})` : t.label, this._register(Ie(this.actionContainer, Ge.CLICK, (s) => {
      s.stopPropagation(), s.preventDefault(), t.run(this.actionContainer);
    })), this._register(Ie(this.actionContainer, Ge.KEY_DOWN, (s) => {
      const o = new Xn(s);
      (o.equals(
        3
        /* KeyCode.Enter */
      ) || o.equals(
        10
        /* KeyCode.Space */
      )) && (s.stopPropagation(), s.preventDefault(), t.run(this.actionContainer));
    })), this.setEnabled(!0);
  }
  setEnabled(e) {
    e ? (this.actionContainer.classList.remove("disabled"), this.actionContainer.removeAttribute("aria-disabled")) : (this.actionContainer.classList.add("disabled"), this.actionContainer.setAttribute("aria-disabled", "true"));
  }
}
function n$e(i, e) {
  return i && e ? C("acessibleViewHint", "Inspect this in the accessible view with {0}.", e) : i ? C("acessibleViewHintNoKbOpen", "Inspect this in the accessible view via the command Open Accessible View which is currently not triggerable via keybinding.") : "";
}
var i$e = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, r$e = function(i) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = i[Symbol.asyncIterator], t;
  return e ? e.call(i) : (i = typeof __values == "function" ? __values(i) : i[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function n(s) {
    t[s] = i[s] && function(o) {
      return new Promise(function(a, l) {
        o = i[s](o), r(a, l, o.done, o.value);
      });
    };
  }
  function r(s, o, a, l) {
    Promise.resolve(l).then(function(c) {
      s({ value: c, done: a });
    }, o);
  }
};
let s$e = class {
  constructor(e, t, n) {
    this.value = e, this.isComplete = t, this.hasLoadingMessage = n;
  }
};
class J0e extends we {
  constructor(e, t) {
    super(), this._editor = e, this._computer = t, this._onResult = this._register(new pe()), this.onResult = this._onResult.event, this._firstWaitScheduler = this._register(new Rn(() => this._triggerAsyncComputation(), 0)), this._secondWaitScheduler = this._register(new Rn(() => this._triggerSyncComputation(), 0)), this._loadingMessageScheduler = this._register(new Rn(() => this._triggerLoadingMessage(), 0)), this._state = 0, this._asyncIterable = null, this._asyncIterableDone = !1, this._result = [];
  }
  dispose() {
    this._asyncIterable && (this._asyncIterable.cancel(), this._asyncIterable = null), super.dispose();
  }
  get _hoverTime() {
    return this._editor.getOption(
      60
      /* EditorOption.hover */
    ).delay;
  }
  get _firstWaitTime() {
    return this._hoverTime / 2;
  }
  get _secondWaitTime() {
    return this._hoverTime - this._firstWaitTime;
  }
  get _loadingMessageTime() {
    return 3 * this._hoverTime;
  }
  _setState(e, t = !0) {
    this._state = e, t && this._fireResult();
  }
  _triggerAsyncComputation() {
    this._setState(
      2
      /* HoverOperationState.SecondWait */
    ), this._secondWaitScheduler.schedule(this._secondWaitTime), this._computer.computeAsync ? (this._asyncIterableDone = !1, this._asyncIterable = d7e((e) => this._computer.computeAsync(e)), i$e(this, void 0, void 0, function* () {
      var e, t, n, r;
      try {
        try {
          for (var s = !0, o = r$e(this._asyncIterable), a; a = yield o.next(), e = a.done, !e; s = !0) {
            r = a.value, s = !1;
            const l = r;
            l && (this._result.push(l), this._fireResult());
          }
        } catch (l) {
          t = { error: l };
        } finally {
          try {
            !s && !e && (n = o.return) && (yield n.call(o));
          } finally {
            if (t) throw t.error;
          }
        }
        this._asyncIterableDone = !0, (this._state === 3 || this._state === 4) && this._setState(
          0
          /* HoverOperationState.Idle */
        );
      } catch (l) {
        It(l);
      }
    })) : this._asyncIterableDone = !0;
  }
  _triggerSyncComputation() {
    this._computer.computeSync && (this._result = this._result.concat(this._computer.computeSync())), this._setState(
      this._asyncIterableDone ? 0 : 3
      /* HoverOperationState.WaitingForAsync */
    );
  }
  _triggerLoadingMessage() {
    this._state === 3 && this._setState(
      4
      /* HoverOperationState.WaitingForAsyncShowingLoading */
    );
  }
  _fireResult() {
    if (this._state === 1 || this._state === 2)
      return;
    const e = this._state === 0, t = this._state === 4;
    this._onResult.fire(new s$e(this._result.slice(0), e, t));
  }
  start(e) {
    if (e === 0)
      this._state === 0 && (this._setState(
        1
        /* HoverOperationState.FirstWait */
      ), this._firstWaitScheduler.schedule(this._firstWaitTime), this._loadingMessageScheduler.schedule(this._loadingMessageTime));
    else
      switch (this._state) {
        case 0:
          this._triggerAsyncComputation(), this._secondWaitScheduler.cancel(), this._triggerSyncComputation();
          break;
        case 2:
          this._secondWaitScheduler.cancel(), this._triggerSyncComputation();
          break;
      }
  }
  cancel() {
    this._firstWaitScheduler.cancel(), this._secondWaitScheduler.cancel(), this._loadingMessageScheduler.cancel(), this._asyncIterable && (this._asyncIterable.cancel(), this._asyncIterable = null), this._result = [], this._setState(0, !1);
  }
}
class IT {
  constructor(e, t, n, r) {
    this.priority = e, this.range = t, this.initialMousePosX = n, this.initialMousePosY = r, this.type = 1;
  }
  equals(e) {
    return e.type === 1 && this.range.equalsRange(e.range);
  }
  canAdoptVisibleHover(e, t) {
    return e.type === 1 && t.lineNumber === this.range.startLineNumber;
  }
}
class aE {
  constructor(e, t, n, r, s, o) {
    this.priority = e, this.owner = t, this.range = n, this.initialMousePosX = r, this.initialMousePosY = s, this.supportsMarkerHover = o, this.type = 2;
  }
  equals(e) {
    return e.type === 2 && this.owner === e.owner;
  }
  canAdoptVisibleHover(e, t) {
    return e.type === 2 && this.owner === e.owner;
  }
}
const K0 = new class {
  constructor() {
    this._participants = [];
  }
  register(e) {
    this._participants.push(e);
  }
  getAll() {
    return this._participants;
  }
}();
class lG {
  constructor() {
    this._onDidWillResize = new pe(), this.onDidWillResize = this._onDidWillResize.event, this._onDidResize = new pe(), this.onDidResize = this._onDidResize.event, this._sashListener = new Ne(), this._size = new _n(0, 0), this._minSize = new _n(0, 0), this._maxSize = new _n(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER), this.domNode = document.createElement("div"), this._eastSash = new Ts(this.domNode, { getVerticalSashLeft: () => this._size.width }, {
      orientation: 0
      /* Orientation.VERTICAL */
    }), this._westSash = new Ts(this.domNode, { getVerticalSashLeft: () => 0 }, {
      orientation: 0
      /* Orientation.VERTICAL */
    }), this._northSash = new Ts(this.domNode, { getHorizontalSashTop: () => 0 }, { orientation: 1, orthogonalEdge: KL.North }), this._southSash = new Ts(this.domNode, { getHorizontalSashTop: () => this._size.height }, { orientation: 1, orthogonalEdge: KL.South }), this._northSash.orthogonalStartSash = this._westSash, this._northSash.orthogonalEndSash = this._eastSash, this._southSash.orthogonalStartSash = this._westSash, this._southSash.orthogonalEndSash = this._eastSash;
    let e, t = 0, n = 0;
    this._sashListener.add(qe.any(this._northSash.onDidStart, this._eastSash.onDidStart, this._southSash.onDidStart, this._westSash.onDidStart)(() => {
      e === void 0 && (this._onDidWillResize.fire(), e = this._size, t = 0, n = 0);
    })), this._sashListener.add(qe.any(this._northSash.onDidEnd, this._eastSash.onDidEnd, this._southSash.onDidEnd, this._westSash.onDidEnd)(() => {
      e !== void 0 && (e = void 0, t = 0, n = 0, this._onDidResize.fire({ dimension: this._size, done: !0 }));
    })), this._sashListener.add(this._eastSash.onDidChange((r) => {
      e && (n = r.currentX - r.startX, this.layout(e.height + t, e.width + n), this._onDidResize.fire({ dimension: this._size, done: !1, east: !0 }));
    })), this._sashListener.add(this._westSash.onDidChange((r) => {
      e && (n = -(r.currentX - r.startX), this.layout(e.height + t, e.width + n), this._onDidResize.fire({ dimension: this._size, done: !1, west: !0 }));
    })), this._sashListener.add(this._northSash.onDidChange((r) => {
      e && (t = -(r.currentY - r.startY), this.layout(e.height + t, e.width + n), this._onDidResize.fire({ dimension: this._size, done: !1, north: !0 }));
    })), this._sashListener.add(this._southSash.onDidChange((r) => {
      e && (t = r.currentY - r.startY, this.layout(e.height + t, e.width + n), this._onDidResize.fire({ dimension: this._size, done: !1, south: !0 }));
    })), this._sashListener.add(qe.any(this._eastSash.onDidReset, this._westSash.onDidReset)((r) => {
      this._preferredSize && (this.layout(this._size.height, this._preferredSize.width), this._onDidResize.fire({ dimension: this._size, done: !0 }));
    })), this._sashListener.add(qe.any(this._northSash.onDidReset, this._southSash.onDidReset)((r) => {
      this._preferredSize && (this.layout(this._preferredSize.height, this._size.width), this._onDidResize.fire({ dimension: this._size, done: !0 }));
    }));
  }
  dispose() {
    this._northSash.dispose(), this._southSash.dispose(), this._eastSash.dispose(), this._westSash.dispose(), this._sashListener.dispose(), this._onDidResize.dispose(), this._onDidWillResize.dispose(), this.domNode.remove();
  }
  enableSashes(e, t, n, r) {
    this._northSash.state = e ? 3 : 0, this._eastSash.state = t ? 3 : 0, this._southSash.state = n ? 3 : 0, this._westSash.state = r ? 3 : 0;
  }
  layout(e = this.size.height, t = this.size.width) {
    const { height: n, width: r } = this._minSize, { height: s, width: o } = this._maxSize;
    e = Math.max(n, Math.min(s, e)), t = Math.max(r, Math.min(o, t));
    const a = new _n(t, e);
    _n.equals(a, this._size) || (this.domNode.style.height = e + "px", this.domNode.style.width = t + "px", this._size = a, this._northSash.layout(), this._eastSash.layout(), this._southSash.layout(), this._westSash.layout());
  }
  clearSashHoverState() {
    this._eastSash.clearSashHoverState(), this._westSash.clearSashHoverState(), this._northSash.clearSashHoverState(), this._southSash.clearSashHoverState();
  }
  get size() {
    return this._size;
  }
  set maxSize(e) {
    this._maxSize = e;
  }
  get maxSize() {
    return this._maxSize;
  }
  set minSize(e) {
    this._minSize = e;
  }
  get minSize() {
    return this._minSize;
  }
  set preferredSize(e) {
    this._preferredSize = e;
  }
  get preferredSize() {
    return this._preferredSize;
  }
}
const o$e = 30, a$e = 24;
class l$e extends we {
  constructor(e, t = new _n(10, 10)) {
    super(), this._editor = e, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this._resizableNode = this._register(new lG()), this._contentPosition = null, this._isResizing = !1, this._resizableNode.domNode.style.position = "absolute", this._resizableNode.minSize = _n.lift(t), this._resizableNode.layout(t.height, t.width), this._resizableNode.enableSashes(!0, !0, !0, !0), this._register(this._resizableNode.onDidResize((n) => {
      this._resize(new _n(n.dimension.width, n.dimension.height)), n.done && (this._isResizing = !1);
    })), this._register(this._resizableNode.onDidWillResize(() => {
      this._isResizing = !0;
    }));
  }
  get isResizing() {
    return this._isResizing;
  }
  getDomNode() {
    return this._resizableNode.domNode;
  }
  getPosition() {
    return this._contentPosition;
  }
  get position() {
    var e;
    return !((e = this._contentPosition) === null || e === void 0) && e.position ? ve.lift(this._contentPosition.position) : void 0;
  }
  _availableVerticalSpaceAbove(e) {
    const t = this._editor.getDomNode(), n = this._editor.getScrolledVisiblePosition(e);
    return !t || !n ? void 0 : wr(t).top + n.top - o$e;
  }
  _availableVerticalSpaceBelow(e) {
    const t = this._editor.getDomNode(), n = this._editor.getScrolledVisiblePosition(e);
    if (!t || !n)
      return;
    const r = wr(t), s = fb(t.ownerDocument.body), o = r.top + n.top + n.height;
    return s.height - o - a$e;
  }
  _findPositionPreference(e, t) {
    var n, r;
    const s = Math.min((n = this._availableVerticalSpaceBelow(t)) !== null && n !== void 0 ? n : 1 / 0, e), o = Math.min((r = this._availableVerticalSpaceAbove(t)) !== null && r !== void 0 ? r : 1 / 0, e), a = Math.min(Math.max(o, s), e), l = Math.min(e, a);
    let c;
    return this._editor.getOption(
      60
      /* EditorOption.hover */
    ).above ? c = l <= o ? 1 : 2 : c = l <= s ? 2 : 1, c === 1 ? this._resizableNode.enableSashes(!0, !0, !1, !1) : this._resizableNode.enableSashes(!1, !0, !0, !1), c;
  }
  _resize(e) {
    this._resizableNode.layout(e.height, e.width);
  }
}
var cG = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, vm = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, lE, Id;
const L$ = Re;
let vI = lE = class extends we {
  constructor(e, t, n) {
    super(), this._editor = e, this._instantiationService = t, this._keybindingService = n, this._currentResult = null, this._widget = this._register(this._instantiationService.createInstance(xg, this._editor)), this._participants = [];
    for (const r of K0.getAll())
      this._participants.push(this._instantiationService.createInstance(r, this._editor));
    this._participants.sort((r, s) => r.hoverOrdinal - s.hoverOrdinal), this._computer = new bI(this._editor, this._participants), this._hoverOperation = this._register(new J0e(this._editor, this._computer)), this._register(this._hoverOperation.onResult((r) => {
      if (!this._computer.anchor)
        return;
      const s = r.hasLoadingMessage ? this._addLoadingMessage(r.value) : r.value;
      this._withResult(new $0e(this._computer.anchor, s, r.isComplete));
    })), this._register(ar(this._widget.getDomNode(), "keydown", (r) => {
      r.equals(
        9
        /* KeyCode.Escape */
      ) && this.hide();
    })), this._register(Pi.onDidChange(() => {
      this._widget.position && this._currentResult && this._setCurrentResult(this._currentResult);
    }));
  }
  get widget() {
    return this._widget;
  }
  /**
   * Returns true if the hover shows now or will show.
   */
  maybeShowAt(e) {
    if (this._widget.isResizing)
      return !0;
    const t = [];
    for (const r of this._participants)
      if (r.suggestHoverAnchor) {
        const s = r.suggestHoverAnchor(e);
        s && t.push(s);
      }
    const n = e.target;
    if (n.type === 6 && t.push(new IT(0, n.range, e.event.posx, e.event.posy)), n.type === 7) {
      const r = this._editor.getOption(
        50
        /* EditorOption.fontInfo */
      ).typicalHalfwidthCharacterWidth / 2;
      !n.detail.isAfterLines && typeof n.detail.horizontalDistanceToText == "number" && n.detail.horizontalDistanceToText < r && t.push(new IT(0, n.range, e.event.posx, e.event.posy));
    }
    return t.length === 0 ? this._startShowingOrUpdateHover(null, 0, 0, !1, e) : (t.sort((r, s) => s.priority - r.priority), this._startShowingOrUpdateHover(t[0], 0, 0, !1, e));
  }
  startShowingAtRange(e, t, n, r) {
    this._startShowingOrUpdateHover(new IT(0, e, void 0, void 0), t, n, r, null);
  }
  /**
   * Returns true if the hover shows now or will show.
   */
  _startShowingOrUpdateHover(e, t, n, r, s) {
    return !this._widget.position || !this._currentResult ? e ? (this._startHoverOperationIfNecessary(e, t, n, r, !1), !0) : !1 : this._editor.getOption(
      60
      /* EditorOption.hover */
    ).sticky && s && this._widget.isMouseGettingCloser(s.event.posx, s.event.posy) ? (e && this._startHoverOperationIfNecessary(e, t, n, r, !0), !0) : e ? e && this._currentResult.anchor.equals(e) ? !0 : e.canAdoptVisibleHover(this._currentResult.anchor, this._widget.position) ? (this._setCurrentResult(this._currentResult.filter(e)), this._startHoverOperationIfNecessary(e, t, n, r, !1), !0) : (this._setCurrentResult(null), this._startHoverOperationIfNecessary(e, t, n, r, !1), !0) : (this._setCurrentResult(null), !1);
  }
  _startHoverOperationIfNecessary(e, t, n, r, s) {
    this._computer.anchor && this._computer.anchor.equals(e) || (this._hoverOperation.cancel(), this._computer.anchor = e, this._computer.shouldFocus = r, this._computer.source = n, this._computer.insistOnKeepingHoverVisible = s, this._hoverOperation.start(t));
  }
  _setCurrentResult(e) {
    this._currentResult !== e && (e && e.messages.length === 0 && (e = null), this._currentResult = e, this._currentResult ? this._renderMessages(this._currentResult.anchor, this._currentResult.messages) : this._widget.hide());
  }
  hide() {
    this._computer.anchor = null, this._hoverOperation.cancel(), this._setCurrentResult(null);
  }
  get isColorPickerVisible() {
    return this._widget.isColorPickerVisible;
  }
  get isVisibleFromKeyboard() {
    return this._widget.isVisibleFromKeyboard;
  }
  get isVisible() {
    return this._widget.isVisible;
  }
  get isFocused() {
    return this._widget.isFocused;
  }
  get isResizing() {
    return this._widget.isResizing;
  }
  containsNode(e) {
    return e ? this._widget.getDomNode().contains(e) : !1;
  }
  _addLoadingMessage(e) {
    if (this._computer.anchor) {
      for (const t of this._participants)
        if (t.createLoadingMessage) {
          const n = t.createLoadingMessage(this._computer.anchor);
          if (n)
            return e.slice(0).concat([n]);
        }
    }
    return e;
  }
  _withResult(e) {
    this._widget.position && this._currentResult && this._currentResult.isComplete && (!e.isComplete || this._computer.insistOnKeepingHoverVisible && e.messages.length === 0) || this._setCurrentResult(e);
  }
  _renderMessages(e, t) {
    const { showAtPosition: n, showAtSecondaryPosition: r, highlightRange: s } = lE.computeHoverRanges(this._editor, e.range, t), o = new Ne(), a = o.add(new _I(this._keybindingService)), l = document.createDocumentFragment();
    let c = null;
    const d = {
      fragment: l,
      statusBar: a,
      setColorPicker: (h) => c = h,
      onContentsChanged: () => this._widget.onContentsChanged(),
      setMinimumDimensions: (h) => this._widget.setMinimumDimensions(h),
      hide: () => this.hide()
    };
    for (const h of this._participants) {
      const f = t.filter((g) => g.owner === h);
      f.length > 0 && o.add(h.renderHoverParts(d, f));
    }
    const u = t.some((h) => h.isBeforeContent);
    if (a.hasContent && l.appendChild(a.hoverElement), l.hasChildNodes()) {
      if (s) {
        const h = this._editor.createDecorationsCollection();
        h.set([{
          range: s,
          options: lE._DECORATION_OPTIONS
        }]), o.add(Ct(() => {
          h.clear();
        }));
      }
      this._widget.showAt(l, new d$e(c, n, r, this._editor.getOption(
        60
        /* EditorOption.hover */
      ).above, this._computer.shouldFocus, this._computer.source, u, e.initialMousePosX, e.initialMousePosY, o));
    } else
      o.dispose();
  }
  static computeHoverRanges(e, t, n) {
    let r = 1;
    if (e.hasModel()) {
      const c = e._getViewModel(), d = c.coordinatesConverter, u = d.convertModelRangeToViewRange(t), h = new ve(u.startLineNumber, c.getLineMinColumn(u.startLineNumber));
      r = d.convertViewPositionToModelPosition(h).column;
    }
    const s = t.startLineNumber;
    let o = t.startColumn, a = n[0].range, l = null;
    for (const c of n)
      a = V.plusRange(a, c.range), c.range.startLineNumber === s && c.range.endLineNumber === s && (o = Math.max(Math.min(o, c.range.startColumn), r)), c.forceShowAtRange && (l = c.range);
    return {
      showAtPosition: l ? l.getStartPosition() : new ve(s, t.startColumn),
      showAtSecondaryPosition: l ? l.getStartPosition() : new ve(s, o),
      highlightRange: a
    };
  }
  focus() {
    this._widget.focus();
  }
  scrollUp() {
    this._widget.scrollUp();
  }
  scrollDown() {
    this._widget.scrollDown();
  }
  scrollLeft() {
    this._widget.scrollLeft();
  }
  scrollRight() {
    this._widget.scrollRight();
  }
  pageUp() {
    this._widget.pageUp();
  }
  pageDown() {
    this._widget.pageDown();
  }
  goToTop() {
    this._widget.goToTop();
  }
  goToBottom() {
    this._widget.goToBottom();
  }
};
vI._DECORATION_OPTIONS = Lt.register({
  description: "content-hover-highlight",
  className: "hoverHighlight"
});
vI = lE = cG([
  vm(1, bt),
  vm(2, Bn)
], vI);
class $0e {
  constructor(e, t, n) {
    this.anchor = e, this.messages = t, this.isComplete = n;
  }
  filter(e) {
    const t = this.messages.filter((n) => n.isValidForHoverAnchor(e));
    return t.length === this.messages.length ? this : new c$e(this, this.anchor, t, this.isComplete);
  }
}
class c$e extends $0e {
  constructor(e, t, n, r) {
    super(t, n, r), this.original = e;
  }
  filter(e) {
    return this.original.filter(e);
  }
}
class d$e {
  constructor(e, t, n, r, s, o, a, l, c, d) {
    this.colorPicker = e, this.showAtPosition = t, this.showAtSecondaryPosition = n, this.preferAbove = r, this.stoleFocus = s, this.source = o, this.isBeforeContent = a, this.initialMousePosX = l, this.initialMousePosY = c, this.disposables = d, this.closestMouseDistance = void 0;
  }
}
const I$ = 30, AT = 10, u$e = 6;
let xg = Id = class extends l$e {
  get isColorPickerVisible() {
    var e;
    return !!(!((e = this._visibleData) === null || e === void 0) && e.colorPicker);
  }
  get isVisibleFromKeyboard() {
    var e;
    return ((e = this._visibleData) === null || e === void 0 ? void 0 : e.source) === 1;
  }
  get isVisible() {
    var e;
    return (e = this._hoverVisibleKey.get()) !== null && e !== void 0 ? e : !1;
  }
  get isFocused() {
    var e;
    return (e = this._hoverFocusedKey.get()) !== null && e !== void 0 ? e : !1;
  }
  constructor(e, t, n, r, s) {
    const o = e.getOption(
      66
      /* EditorOption.lineHeight */
    ) + 8, a = 150, l = new _n(a, o);
    super(e, l), this._configurationService = n, this._accessibilityService = r, this._keybindingService = s, this._hover = this._register(new Q0e()), this._minimumSize = l, this._hoverVisibleKey = $.hoverVisible.bindTo(t), this._hoverFocusedKey = $.hoverFocused.bindTo(t), Te(this._resizableNode.domNode, this._hover.containerDomNode), this._resizableNode.domNode.style.zIndex = "50", this._register(this._editor.onDidLayoutChange(() => this._layout())), this._register(this._editor.onDidChangeConfiguration((d) => {
      d.hasChanged(
        50
        /* EditorOption.fontInfo */
      ) && this._updateFont();
    }));
    const c = this._register(yu(this._resizableNode.domNode));
    this._register(c.onDidFocus(() => {
      this._hoverFocusedKey.set(!0);
    })), this._register(c.onDidBlur(() => {
      this._hoverFocusedKey.set(!1);
    })), this._setHoverData(void 0), this._layout(), this._editor.addContentWidget(this);
  }
  dispose() {
    var e;
    super.dispose(), (e = this._visibleData) === null || e === void 0 || e.disposables.dispose(), this._editor.removeContentWidget(this);
  }
  getId() {
    return Id.ID;
  }
  static _applyDimensions(e, t, n) {
    const r = typeof t == "number" ? `${t}px` : t, s = typeof n == "number" ? `${n}px` : n;
    e.style.width = r, e.style.height = s;
  }
  _setContentsDomNodeDimensions(e, t) {
    const n = this._hover.contentsDomNode;
    return Id._applyDimensions(n, e, t);
  }
  _setContainerDomNodeDimensions(e, t) {
    const n = this._hover.containerDomNode;
    return Id._applyDimensions(n, e, t);
  }
  _setHoverWidgetDimensions(e, t) {
    this._setContentsDomNodeDimensions(e, t), this._setContainerDomNodeDimensions(e, t), this._layoutContentWidget();
  }
  static _applyMaxDimensions(e, t, n) {
    const r = typeof t == "number" ? `${t}px` : t, s = typeof n == "number" ? `${n}px` : n;
    e.style.maxWidth = r, e.style.maxHeight = s;
  }
  _setHoverWidgetMaxDimensions(e, t) {
    Id._applyMaxDimensions(this._hover.contentsDomNode, e, t), Id._applyMaxDimensions(this._hover.containerDomNode, e, t), this._hover.containerDomNode.style.setProperty("--vscode-hover-maxWidth", typeof e == "number" ? `${e}px` : e), this._layoutContentWidget();
  }
  _hasHorizontalScrollbar() {
    const e = this._hover.scrollbar.getScrollDimensions();
    return e.scrollWidth > e.width;
  }
  _adjustContentsBottomPadding() {
    const e = this._hover.contentsDomNode, t = `${this._hover.scrollbar.options.horizontalScrollbarSize}px`;
    e.style.paddingBottom !== t && (e.style.paddingBottom = t);
  }
  _setAdjustedHoverWidgetDimensions(e) {
    this._setHoverWidgetMaxDimensions("none", "none");
    const t = e.width, n = e.height;
    this._setHoverWidgetDimensions(t, n), this._hasHorizontalScrollbar() && (this._adjustContentsBottomPadding(), this._setContentsDomNodeDimensions(t, n - AT));
  }
  _updateResizableNodeMaxDimensions() {
    var e, t;
    const n = (e = this._findMaximumRenderingWidth()) !== null && e !== void 0 ? e : 1 / 0, r = (t = this._findMaximumRenderingHeight()) !== null && t !== void 0 ? t : 1 / 0;
    this._resizableNode.maxSize = new _n(n, r), this._setHoverWidgetMaxDimensions(n, r);
  }
  _resize(e) {
    var t, n;
    Id._lastDimensions = new _n(e.width, e.height), this._setAdjustedHoverWidgetDimensions(e), this._resizableNode.layout(e.height, e.width), this._updateResizableNodeMaxDimensions(), this._hover.scrollbar.scanDomNode(), this._editor.layoutContentWidget(this), (n = (t = this._visibleData) === null || t === void 0 ? void 0 : t.colorPicker) === null || n === void 0 || n.layout();
  }
  _findAvailableSpaceVertically() {
    var e;
    const t = (e = this._visibleData) === null || e === void 0 ? void 0 : e.showAtPosition;
    if (t)
      return this._positionPreference === 1 ? this._availableVerticalSpaceAbove(t) : this._availableVerticalSpaceBelow(t);
  }
  _findMaximumRenderingHeight() {
    const e = this._findAvailableSpaceVertically();
    if (!e)
      return;
    let t = u$e;
    return Array.from(this._hover.contentsDomNode.children).forEach((n) => {
      t += n.clientHeight;
    }), this._hasHorizontalScrollbar() && (t += AT), Math.min(e, t);
  }
  _isHoverTextOverflowing() {
    this._hover.containerDomNode.style.setProperty("--vscode-hover-whiteSpace", "nowrap"), this._hover.containerDomNode.style.setProperty("--vscode-hover-sourceWhiteSpace", "nowrap");
    const e = Array.from(this._hover.contentsDomNode.children).some((t) => t.scrollWidth > t.clientWidth);
    return this._hover.containerDomNode.style.removeProperty("--vscode-hover-whiteSpace"), this._hover.containerDomNode.style.removeProperty("--vscode-hover-sourceWhiteSpace"), e;
  }
  _findMaximumRenderingWidth() {
    if (!this._editor || !this._editor.hasModel())
      return;
    const e = this._isHoverTextOverflowing(), t = typeof this._contentWidth > "u" ? 0 : this._contentWidth - 2;
    return e || this._hover.containerDomNode.clientWidth < t ? fb(this._hover.containerDomNode.ownerDocument.body).width - 14 : this._hover.containerDomNode.clientWidth + 2;
  }
  isMouseGettingCloser(e, t) {
    if (!this._visibleData)
      return !1;
    if (typeof this._visibleData.initialMousePosX > "u" || typeof this._visibleData.initialMousePosY > "u")
      return this._visibleData.initialMousePosX = e, this._visibleData.initialMousePosY = t, !1;
    const n = wr(this.getDomNode());
    typeof this._visibleData.closestMouseDistance > "u" && (this._visibleData.closestMouseDistance = A$(this._visibleData.initialMousePosX, this._visibleData.initialMousePosY, n.left, n.top, n.width, n.height));
    const r = A$(e, t, n.left, n.top, n.width, n.height);
    return r > this._visibleData.closestMouseDistance + 4 ? !1 : (this._visibleData.closestMouseDistance = Math.min(this._visibleData.closestMouseDistance, r), !0);
  }
  _setHoverData(e) {
    var t;
    (t = this._visibleData) === null || t === void 0 || t.disposables.dispose(), this._visibleData = e, this._hoverVisibleKey.set(!!e), this._hover.containerDomNode.classList.toggle("hidden", !e);
  }
  _layout() {
    const { fontSize: e, lineHeight: t } = this._editor.getOption(
      50
      /* EditorOption.fontInfo */
    ), n = this._hover.contentsDomNode;
    n.style.fontSize = `${e}px`, n.style.lineHeight = `${t / e}`, this._updateMaxDimensions();
  }
  _updateFont() {
    Array.prototype.slice.call(this._hover.contentsDomNode.getElementsByClassName("code")).forEach((t) => this._editor.applyFontInfo(t));
  }
  _updateContent(e) {
    const t = this._hover.contentsDomNode;
    t.style.paddingBottom = "", t.textContent = "", t.appendChild(e);
  }
  _layoutContentWidget() {
    this._editor.layoutContentWidget(this), this._hover.onContentsChanged();
  }
  _updateMaxDimensions() {
    const e = Math.max(this._editor.getLayoutInfo().height / 4, 250, Id._lastDimensions.height), t = Math.max(this._editor.getLayoutInfo().width * 0.66, 500, Id._lastDimensions.width);
    this._setHoverWidgetMaxDimensions(t, e);
  }
  _render(e, t) {
    this._setHoverData(t), this._updateFont(), this._updateContent(e), this._updateMaxDimensions(), this.onContentsChanged(), this._editor.render();
  }
  getPosition() {
    var e;
    return this._visibleData ? {
      position: this._visibleData.showAtPosition,
      secondaryPosition: this._visibleData.showAtSecondaryPosition,
      positionAffinity: this._visibleData.isBeforeContent ? 3 : void 0,
      preference: [
        (e = this._positionPreference) !== null && e !== void 0 ? e : 1
        /* ContentWidgetPositionPreference.ABOVE */
      ]
    } : null;
  }
  showAt(e, t) {
    var n, r, s, o;
    if (!this._editor || !this._editor.hasModel())
      return;
    this._render(e, t);
    const a = cm(this._hover.containerDomNode), l = t.showAtPosition;
    this._positionPreference = (n = this._findPositionPreference(a, l)) !== null && n !== void 0 ? n : 1, this.onContentsChanged(), t.stoleFocus && this._hover.containerDomNode.focus(), (r = t.colorPicker) === null || r === void 0 || r.layout();
    const c = n$e(this._configurationService.getValue("accessibility.verbosity.hover") === !0 && this._accessibilityService.isScreenReaderOptimized(), (o = (s = this._keybindingService.lookupKeybinding("editor.action.accessibleView")) === null || s === void 0 ? void 0 : s.getAriaLabel()) !== null && o !== void 0 ? o : "");
    c && (this._hover.contentsDomNode.ariaLabel = this._hover.contentsDomNode.textContent + ", " + c);
  }
  hide() {
    if (!this._visibleData)
      return;
    const e = this._visibleData.stoleFocus || this._hoverFocusedKey.get();
    this._setHoverData(void 0), this._resizableNode.maxSize = new _n(1 / 0, 1 / 0), this._resizableNode.clearSashHoverState(), this._hoverFocusedKey.set(!1), this._editor.layoutContentWidget(this), e && this._editor.focus();
  }
  _removeConstraintsRenderNormally() {
    const e = this._editor.getLayoutInfo();
    this._resizableNode.layout(e.height, e.width), this._setHoverWidgetDimensions("auto", "auto");
  }
  _adjustHoverHeightForScrollbar(e) {
    var t;
    const n = this._hover.containerDomNode, r = this._hover.contentsDomNode, s = (t = this._findMaximumRenderingHeight()) !== null && t !== void 0 ? t : 1 / 0;
    this._setContainerDomNodeDimensions(Lo(n), Math.min(s, e)), this._setContentsDomNodeDimensions(Lo(r), Math.min(s, e - AT));
  }
  setMinimumDimensions(e) {
    this._minimumSize = new _n(Math.max(this._minimumSize.width, e.width), Math.max(this._minimumSize.height, e.height)), this._updateMinimumWidth();
  }
  _updateMinimumWidth() {
    const e = typeof this._contentWidth > "u" ? this._minimumSize.width : Math.min(this._contentWidth, this._minimumSize.width);
    this._resizableNode.minSize = new _n(e, this._minimumSize.height);
  }
  onContentsChanged() {
    var e;
    this._removeConstraintsRenderNormally();
    const t = this._hover.containerDomNode;
    let n = cm(t), r = Lo(t);
    if (this._resizableNode.layout(n, r), this._setHoverWidgetDimensions(r, n), n = cm(t), r = Lo(t), this._contentWidth = r, this._updateMinimumWidth(), this._resizableNode.layout(n, r), this._hasHorizontalScrollbar() && (this._adjustContentsBottomPadding(), this._adjustHoverHeightForScrollbar(n)), !((e = this._visibleData) === null || e === void 0) && e.showAtPosition) {
      const s = cm(this._hover.containerDomNode);
      this._positionPreference = this._findPositionPreference(s, this._visibleData.showAtPosition);
    }
    this._layoutContentWidget();
  }
  focus() {
    this._hover.containerDomNode.focus();
  }
  scrollUp() {
    const e = this._hover.scrollbar.getScrollPosition().scrollTop, t = this._editor.getOption(
      50
      /* EditorOption.fontInfo */
    );
    this._hover.scrollbar.setScrollPosition({ scrollTop: e - t.lineHeight });
  }
  scrollDown() {
    const e = this._hover.scrollbar.getScrollPosition().scrollTop, t = this._editor.getOption(
      50
      /* EditorOption.fontInfo */
    );
    this._hover.scrollbar.setScrollPosition({ scrollTop: e + t.lineHeight });
  }
  scrollLeft() {
    const e = this._hover.scrollbar.getScrollPosition().scrollLeft;
    this._hover.scrollbar.setScrollPosition({ scrollLeft: e - I$ });
  }
  scrollRight() {
    const e = this._hover.scrollbar.getScrollPosition().scrollLeft;
    this._hover.scrollbar.setScrollPosition({ scrollLeft: e + I$ });
  }
  pageUp() {
    const e = this._hover.scrollbar.getScrollPosition().scrollTop, t = this._hover.scrollbar.getScrollDimensions().height;
    this._hover.scrollbar.setScrollPosition({ scrollTop: e - t });
  }
  pageDown() {
    const e = this._hover.scrollbar.getScrollPosition().scrollTop, t = this._hover.scrollbar.getScrollDimensions().height;
    this._hover.scrollbar.setScrollPosition({ scrollTop: e + t });
  }
  goToTop() {
    this._hover.scrollbar.setScrollPosition({ scrollTop: 0 });
  }
  goToBottom() {
    this._hover.scrollbar.setScrollPosition({ scrollTop: this._hover.scrollbar.getScrollDimensions().scrollHeight });
  }
};
xg.ID = "editor.contrib.resizableContentHoverWidget";
xg._lastDimensions = new _n(0, 0);
xg = Id = cG([
  vm(1, yt),
  vm(2, en),
  vm(3, lf),
  vm(4, Bn)
], xg);
let _I = class extends we {
  get hasContent() {
    return this._hasContent;
  }
  constructor(e) {
    super(), this._keybindingService = e, this._hasContent = !1, this.hoverElement = L$("div.hover-row.status-bar"), this.actionsElement = Te(this.hoverElement, L$("div.actions"));
  }
  addAction(e) {
    const t = this._keybindingService.lookupKeybinding(e.commandId), n = t ? t.getLabel() : null;
    return this._hasContent = !0, this._register(aG.render(this.actionsElement, e, n));
  }
  append(e) {
    const t = Te(this.actionsElement, e);
    return this._hasContent = !0, t;
  }
};
_I = cG([
  vm(0, Bn)
], _I);
class bI {
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    this._anchor = e;
  }
  get shouldFocus() {
    return this._shouldFocus;
  }
  set shouldFocus(e) {
    this._shouldFocus = e;
  }
  get source() {
    return this._source;
  }
  set source(e) {
    this._source = e;
  }
  get insistOnKeepingHoverVisible() {
    return this._insistOnKeepingHoverVisible;
  }
  set insistOnKeepingHoverVisible(e) {
    this._insistOnKeepingHoverVisible = e;
  }
  constructor(e, t) {
    this._editor = e, this._participants = t, this._anchor = null, this._shouldFocus = !1, this._source = 0, this._insistOnKeepingHoverVisible = !1;
  }
  static _getLineDecorations(e, t) {
    if (t.type !== 1 && !t.supportsMarkerHover)
      return [];
    const n = e.getModel(), r = t.range.startLineNumber;
    if (r > n.getLineCount())
      return [];
    const s = n.getLineMaxColumn(r);
    return e.getLineDecorations(r).filter((o) => {
      if (o.options.isWholeLine)
        return !0;
      const a = o.range.startLineNumber === r ? o.range.startColumn : 1, l = o.range.endLineNumber === r ? o.range.endColumn : s;
      if (o.options.showIfCollapsed) {
        if (a > t.range.startColumn + 1 || t.range.endColumn - 1 > l)
          return !1;
      } else if (a > t.range.startColumn || t.range.endColumn > l)
        return !1;
      return !0;
    });
  }
  computeAsync(e) {
    const t = this._anchor;
    if (!this._editor.hasModel() || !t)
      return hr.EMPTY;
    const n = bI._getLineDecorations(this._editor, t);
    return hr.merge(this._participants.map((r) => r.computeAsync ? r.computeAsync(t, n, e) : hr.EMPTY));
  }
  computeSync() {
    if (!this._editor.hasModel() || !this._anchor)
      return [];
    const e = bI._getLineDecorations(this._editor, this._anchor);
    let t = [];
    for (const n of this._participants)
      t = t.concat(n.computeSync(this._anchor, e));
    return _u(t);
  }
}
function A$(i, e, t, n, r, s) {
  const o = t + r / 2, a = n + s / 2, l = Math.max(Math.abs(i - o) - r / 2, 0), c = Math.max(Math.abs(e - a) - s / 2, 0);
  return Math.sqrt(l * l + c * c);
}
const k$ = Re;
class Yv extends we {
  constructor(e, t, n) {
    super(), this._renderDisposeables = this._register(new Ne()), this._editor = e, this._isVisible = !1, this._messages = [], this._hover = this._register(new Q0e()), this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible), this._markdownRenderer = this._register(new $h({ editor: this._editor }, t, n)), this._computer = new h$e(this._editor), this._hoverOperation = this._register(new J0e(this._editor, this._computer)), this._register(this._hoverOperation.onResult((r) => {
      this._withResult(r.value);
    })), this._register(this._editor.onDidChangeModelDecorations(() => this._onModelDecorationsChanged())), this._register(this._editor.onDidChangeConfiguration((r) => {
      r.hasChanged(
        50
        /* EditorOption.fontInfo */
      ) && this._updateFont();
    })), this._editor.addOverlayWidget(this);
  }
  dispose() {
    this._editor.removeOverlayWidget(this), super.dispose();
  }
  getId() {
    return Yv.ID;
  }
  getDomNode() {
    return this._hover.containerDomNode;
  }
  getPosition() {
    return null;
  }
  _updateFont() {
    Array.prototype.slice.call(this._hover.contentsDomNode.getElementsByClassName("code")).forEach((t) => this._editor.applyFontInfo(t));
  }
  _onModelDecorationsChanged() {
    this._isVisible && (this._hoverOperation.cancel(), this._hoverOperation.start(
      0
      /* HoverStartMode.Delayed */
    ));
  }
  startShowingAt(e) {
    this._computer.lineNumber !== e && (this._hoverOperation.cancel(), this.hide(), this._computer.lineNumber = e, this._hoverOperation.start(
      0
      /* HoverStartMode.Delayed */
    ));
  }
  hide() {
    this._computer.lineNumber = -1, this._hoverOperation.cancel(), this._isVisible && (this._isVisible = !1, this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible));
  }
  _withResult(e) {
    this._messages = e, this._messages.length > 0 ? this._renderMessages(this._computer.lineNumber, this._messages) : this.hide();
  }
  _renderMessages(e, t) {
    this._renderDisposeables.clear();
    const n = document.createDocumentFragment();
    for (const r of t) {
      const s = k$("div.hover-row.markdown-hover"), o = Te(s, k$("div.hover-contents")), a = this._renderDisposeables.add(this._markdownRenderer.render(r.value));
      o.appendChild(a.element), n.appendChild(s);
    }
    this._updateContents(n), this._showAt(e);
  }
  _updateContents(e) {
    this._hover.contentsDomNode.textContent = "", this._hover.contentsDomNode.appendChild(e), this._updateFont();
  }
  _showAt(e) {
    this._isVisible || (this._isVisible = !0, this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible));
    const t = this._editor.getLayoutInfo(), n = this._editor.getTopForLineNumber(e), r = this._editor.getScrollTop(), s = this._editor.getOption(
      66
      /* EditorOption.lineHeight */
    ), o = this._hover.containerDomNode.clientHeight, a = n - r - (o - s) / 2;
    this._hover.containerDomNode.style.left = `${t.glyphMarginLeft + t.glyphMarginWidth}px`, this._hover.containerDomNode.style.top = `${Math.max(Math.round(a), 0)}px`;
  }
}
Yv.ID = "editor.contrib.modesGlyphHoverWidget";
class h$e {
  get lineNumber() {
    return this._lineNumber;
  }
  set lineNumber(e) {
    this._lineNumber = e;
  }
  constructor(e) {
    this._editor = e, this._lineNumber = -1;
  }
  computeSync() {
    const e = (r) => ({
      value: r
    }), t = this._editor.getLineDecorations(this._lineNumber), n = [];
    if (!t)
      return n;
    for (const r of t) {
      if (!r.options.glyphMarginClassName)
        continue;
      const s = r.options.glyphMarginHoverMessage;
      !s || T_(s) || n.push(...xj(s).map(e));
    }
    return n;
  }
}
var f$e = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class g$e {
  constructor(e, t, n) {
    this.provider = e, this.hover = t, this.ordinal = n;
  }
}
function p$e(i, e, t, n, r) {
  return f$e(this, void 0, void 0, function* () {
    try {
      const s = yield Promise.resolve(i.provideHover(t, n, r));
      if (s && v$e(s))
        return new g$e(i, s, e);
    } catch (s) {
      vr(s);
    }
  });
}
function dG(i, e, t, n) {
  const s = i.ordered(e).map((o, a) => p$e(o, a, e, t, n));
  return hr.fromPromises(s).coalesce();
}
function m$e(i, e, t, n) {
  return dG(i, e, t, n).map((r) => r.hover).toPromise();
}
Ru("_executeHoverProvider", (i, e, t) => {
  const n = i.get(tt);
  return m$e(n.hoverProvider, e, t, jt.None);
});
function v$e(i) {
  const e = typeof i.range < "u", t = typeof i.contents < "u" && i.contents && i.contents.length > 0;
  return e && t;
}
var _$e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, ND = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const T$ = Re;
class Wc {
  constructor(e, t, n, r, s) {
    this.owner = e, this.range = t, this.contents = n, this.isBeforeContent = r, this.ordinal = s;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let CI = class {
  constructor(e, t, n, r, s) {
    this._editor = e, this._languageService = t, this._openerService = n, this._configurationService = r, this._languageFeaturesService = s, this.hoverOrdinal = 3;
  }
  createLoadingMessage(e) {
    return new Wc(this, e.range, [new ys().appendText(C("modesContentHover.loading", "Loading..."))], !1, 2e3);
  }
  computeSync(e, t) {
    if (!this._editor.hasModel() || e.type !== 1)
      return [];
    const n = this._editor.getModel(), r = e.range.startLineNumber, s = n.getLineMaxColumn(r), o = [];
    let a = 1e3;
    const l = n.getLineLength(r), c = n.getLanguageIdAtPosition(e.range.startLineNumber, e.range.startColumn), d = this._editor.getOption(
      116
      /* EditorOption.stopRenderingLineAfter */
    ), u = this._configurationService.getValue("editor.maxTokenizationLineLength", {
      overrideIdentifier: c
    });
    let h = !1;
    d >= 0 && l > d && e.range.startColumn >= d && (h = !0, o.push(new Wc(this, e.range, [{
      value: C("stopped rendering", "Rendering paused for long line for performance reasons. This can be configured via `editor.stopRenderingLineAfter`.")
    }], !1, a++))), !h && typeof u == "number" && l >= u && o.push(new Wc(this, e.range, [{
      value: C("too many characters", "Tokenization is skipped for long lines for performance reasons. This can be configured via `editor.maxTokenizationLineLength`.")
    }], !1, a++));
    let f = !1;
    for (const g of t) {
      const p = g.range.startLineNumber === r ? g.range.startColumn : 1, m = g.range.endLineNumber === r ? g.range.endColumn : s, _ = g.options.hoverMessage;
      if (!_ || T_(_))
        continue;
      g.options.beforeContentClassName && (f = !0);
      const b = new V(e.range.startLineNumber, p, e.range.startLineNumber, m);
      o.push(new Wc(this, b, xj(_), f, a++));
    }
    return o;
  }
  computeAsync(e, t, n) {
    if (!this._editor.hasModel() || e.type !== 1)
      return hr.EMPTY;
    const r = this._editor.getModel();
    if (!this._languageFeaturesService.hoverProvider.has(r))
      return hr.EMPTY;
    const s = new ve(e.range.startLineNumber, e.range.startColumn);
    return dG(this._languageFeaturesService.hoverProvider, r, s, n).filter((o) => !T_(o.hover.contents)).map((o) => {
      const a = o.hover.range ? V.lift(o.hover.range) : e.range;
      return new Wc(this, a, o.hover.contents, !1, o.ordinal);
    });
  }
  renderHoverParts(e, t) {
    return e1e(e, t, this._editor, this._languageService, this._openerService);
  }
};
CI = _$e([
  ND(1, ci),
  ND(2, da),
  ND(3, en),
  ND(4, tt)
], CI);
function e1e(i, e, t, n, r) {
  e.sort((o, a) => o.ordinal - a.ordinal);
  const s = new Ne();
  for (const o of e)
    for (const a of o.contents) {
      if (T_(a))
        continue;
      const l = T$("div.hover-row.markdown-hover"), c = Te(l, T$("div.hover-contents")), d = s.add(new $h({ editor: t }, n, r));
      s.add(d.onDidRenderAsync(() => {
        c.className = "hover-contents code-hover-contents", i.onContentsChanged();
      }));
      const u = s.add(d.render(a));
      c.appendChild(u.element), i.fragment.appendChild(l);
    }
  return s;
}
var t1e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, yI = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class N$ {
  constructor(e, t, n) {
    this.marker = e, this.index = t, this.total = n;
  }
}
let GV = class {
  constructor(e, t, n) {
    this._markerService = t, this._configService = n, this._onDidChange = new pe(), this.onDidChange = this._onDidChange.event, this._dispoables = new Ne(), this._markers = [], this._nextIdx = -1, pt.isUri(e) ? this._resourceFilter = (a) => a.toString() === e.toString() : e && (this._resourceFilter = e);
    const r = this._configService.getValue("problems.sortOrder"), s = (a, l) => {
      let c = Dy(a.resource.toString(), l.resource.toString());
      return c === 0 && (r === "position" ? c = V.compareRangesUsingStarts(a, l) || Fi.compare(a.severity, l.severity) : c = Fi.compare(a.severity, l.severity) || V.compareRangesUsingStarts(a, l)), c;
    }, o = () => {
      this._markers = this._markerService.read({
        resource: pt.isUri(e) ? e : void 0,
        severities: Fi.Error | Fi.Warning | Fi.Info
      }), typeof e == "function" && (this._markers = this._markers.filter((a) => this._resourceFilter(a.resource))), this._markers.sort(s);
    };
    o(), this._dispoables.add(t.onMarkerChanged((a) => {
      (!this._resourceFilter || a.some((l) => this._resourceFilter(l))) && (o(), this._nextIdx = -1, this._onDidChange.fire());
    }));
  }
  dispose() {
    this._dispoables.dispose(), this._onDidChange.dispose();
  }
  matches(e) {
    return !this._resourceFilter && !e ? !0 : !this._resourceFilter || !e ? !1 : this._resourceFilter(e);
  }
  get selected() {
    const e = this._markers[this._nextIdx];
    return e && new N$(e, this._nextIdx + 1, this._markers.length);
  }
  _initIdx(e, t, n) {
    let r = !1, s = this._markers.findIndex((o) => o.resource.toString() === e.uri.toString());
    s < 0 && (s = vy(this._markers, { resource: e.uri }, (o, a) => Dy(o.resource.toString(), a.resource.toString())), s < 0 && (s = ~s));
    for (let o = s; o < this._markers.length; o++) {
      let a = V.lift(this._markers[o]);
      if (a.isEmpty()) {
        const l = e.getWordAtPosition(a.getStartPosition());
        l && (a = new V(a.startLineNumber, l.startColumn, a.startLineNumber, l.endColumn));
      }
      if (t && (a.containsPosition(t) || t.isBeforeOrEqual(a.getStartPosition()))) {
        this._nextIdx = o, r = !0;
        break;
      }
      if (this._markers[o].resource.toString() !== e.uri.toString())
        break;
    }
    r || (this._nextIdx = n ? 0 : this._markers.length - 1), this._nextIdx < 0 && (this._nextIdx = this._markers.length - 1);
  }
  resetIndex() {
    this._nextIdx = -1;
  }
  move(e, t, n) {
    if (this._markers.length === 0)
      return !1;
    const r = this._nextIdx;
    return this._nextIdx === -1 ? this._initIdx(t, n, e) : e ? this._nextIdx = (this._nextIdx + 1) % this._markers.length : e || (this._nextIdx = (this._nextIdx - 1 + this._markers.length) % this._markers.length), r !== this._nextIdx;
  }
  find(e, t) {
    let n = this._markers.findIndex((r) => r.resource.toString() === e.toString());
    if (!(n < 0)) {
      for (; n < this._markers.length; n++)
        if (V.containsPosition(this._markers[n], t))
          return new N$(this._markers[n], n + 1, this._markers.length);
    }
  }
};
GV = t1e([
  yI(1, Fu),
  yI(2, en)
], GV);
const n1e = Gt("IMarkerNavigationService");
let qV = class {
  constructor(e, t) {
    this._markerService = e, this._configService = t, this._provider = new fo();
  }
  getMarkerList(e) {
    for (const t of this._provider) {
      const n = t.getMarkerList(e);
      if (n)
        return n;
    }
    return new GV(e, this._markerService, this._configService);
  }
};
qV = t1e([
  yI(0, Fu),
  yI(1, en)
], qV);
an(
  n1e,
  qV,
  1
  /* InstantiationType.Delayed */
);
var KV;
(function(i) {
  function e(t) {
    switch (t) {
      case Yi.Ignore:
        return "severity-ignore " + ft.asClassName(We.info);
      case Yi.Info:
        return ft.asClassName(We.info);
      case Yi.Warning:
        return ft.asClassName(We.warning);
      case Yi.Error:
        return ft.asClassName(We.error);
      default:
        return "";
    }
  }
  i.className = e;
})(KV || (KV = {}));
var b$e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, C1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, YV;
class C$e {
  constructor(e, t, n, r, s) {
    this._openerService = r, this._labelService = s, this._lines = 0, this._longestLineLength = 0, this._relatedDiagnostics = /* @__PURE__ */ new WeakMap(), this._disposables = new Ne(), this._editor = t;
    const o = document.createElement("div");
    o.className = "descriptioncontainer", this._messageBlock = document.createElement("div"), this._messageBlock.classList.add("message"), this._messageBlock.setAttribute("aria-live", "assertive"), this._messageBlock.setAttribute("role", "alert"), o.appendChild(this._messageBlock), this._relatedBlock = document.createElement("div"), o.appendChild(this._relatedBlock), this._disposables.add(ar(this._relatedBlock, "click", (a) => {
      a.preventDefault();
      const l = this._relatedDiagnostics.get(a.target);
      l && n(l);
    })), this._scrollable = new jfe(o, {
      horizontal: 1,
      vertical: 1,
      useShadows: !1,
      horizontalScrollbarSize: 6,
      verticalScrollbarSize: 6
    }), e.appendChild(this._scrollable.getDomNode()), this._disposables.add(this._scrollable.onScroll((a) => {
      o.style.left = `-${a.scrollLeft}px`, o.style.top = `-${a.scrollTop}px`;
    })), this._disposables.add(this._scrollable);
  }
  dispose() {
    An(this._disposables);
  }
  update(e) {
    const { source: t, message: n, relatedInformation: r, code: s } = e;
    let o = (t?.length || 0) + 2;
    s && (typeof s == "string" ? o += s.length : o += s.value.length);
    const a = Cu(n);
    this._lines = a.length, this._longestLineLength = 0;
    for (const h of a)
      this._longestLineLength = Math.max(h.length + o, this._longestLineLength);
    ls(this._messageBlock), this._messageBlock.setAttribute("aria-label", this.getAriaLabel(e)), this._editor.applyFontInfo(this._messageBlock);
    let l = this._messageBlock;
    for (const h of a)
      l = document.createElement("div"), l.innerText = h, h === "" && (l.style.height = this._messageBlock.style.lineHeight), this._messageBlock.appendChild(l);
    if (t || s) {
      const h = document.createElement("span");
      if (h.classList.add("details"), l.appendChild(h), t) {
        const f = document.createElement("span");
        f.innerText = t, f.classList.add("source"), h.appendChild(f);
      }
      if (s)
        if (typeof s == "string") {
          const f = document.createElement("span");
          f.innerText = `(${s})`, f.classList.add("code"), h.appendChild(f);
        } else {
          this._codeLink = Re("a.code-link"), this._codeLink.setAttribute("href", `${s.target.toString()}`), this._codeLink.onclick = (g) => {
            this._openerService.open(s.target, { allowCommands: !0 }), g.preventDefault(), g.stopPropagation();
          };
          const f = Te(this._codeLink, Re("span"));
          f.innerText = s.value, h.appendChild(this._codeLink);
        }
    }
    if (ls(this._relatedBlock), this._editor.applyFontInfo(this._relatedBlock), Bs(r)) {
      const h = this._relatedBlock.appendChild(document.createElement("div"));
      h.style.paddingTop = `${Math.floor(this._editor.getOption(
        66
        /* EditorOption.lineHeight */
      ) * 0.66)}px`, this._lines += 1;
      for (const f of r) {
        const g = document.createElement("div"), p = document.createElement("a");
        p.classList.add("filename"), p.innerText = `${this._labelService.getUriBasenameLabel(f.resource)}(${f.startLineNumber}, ${f.startColumn}): `, p.title = this._labelService.getUriLabel(f.resource), this._relatedDiagnostics.set(p, f);
        const m = document.createElement("span");
        m.innerText = f.message, g.appendChild(p), g.appendChild(m), this._lines += 1, h.appendChild(g);
      }
    }
    const c = this._editor.getOption(
      50
      /* EditorOption.fontInfo */
    ), d = Math.ceil(c.typicalFullwidthCharacterWidth * this._longestLineLength * 0.75), u = c.lineHeight * this._lines;
    this._scrollable.setScrollDimensions({ scrollWidth: d, scrollHeight: u });
  }
  layout(e, t) {
    this._scrollable.getDomNode().style.height = `${e}px`, this._scrollable.getDomNode().style.width = `${t}px`, this._scrollable.setScrollDimensions({ width: t, height: e });
  }
  getHeightInLines() {
    return Math.min(17, this._lines);
  }
  getAriaLabel(e) {
    let t = "";
    switch (e.severity) {
      case Fi.Error:
        t = C("Error", "Error");
        break;
      case Fi.Warning:
        t = C("Warning", "Warning");
        break;
      case Fi.Info:
        t = C("Info", "Info");
        break;
      case Fi.Hint:
        t = C("Hint", "Hint");
        break;
    }
    let n = C("marker aria", "{0} at {1}. ", t, e.startLineNumber + ":" + e.startColumn);
    const r = this._editor.getModel();
    return r && e.startLineNumber <= r.getLineCount() && e.startLineNumber >= 1 && (n = `${r.getLineContent(e.startLineNumber)}, ${n}`), n;
  }
}
let W_ = YV = class extends mI {
  constructor(e, t, n, r, s, o, a) {
    super(e, { showArrow: !0, showFrame: !0, isAccessible: !0, frameWidth: 1 }, s), this._themeService = t, this._openerService = n, this._menuService = r, this._contextKeyService = o, this._labelService = a, this._callOnDispose = new Ne(), this._onDidSelectRelatedInformation = new pe(), this.onDidSelectRelatedInformation = this._onDidSelectRelatedInformation.event, this._severity = Fi.Warning, this._backgroundColor = ye.white, this._applyTheme(t.getColorTheme()), this._callOnDispose.add(t.onDidColorThemeChange(this._applyTheme.bind(this))), this.create();
  }
  _applyTheme(e) {
    this._backgroundColor = e.getColor(x$e);
    let t = XV, n = y$e;
    this._severity === Fi.Warning ? (t = cE, n = w$e) : this._severity === Fi.Info && (t = ZV, n = S$e);
    const r = e.getColor(t), s = e.getColor(n);
    this.style({
      arrowColor: r,
      frameColor: r,
      headerBackgroundColor: s,
      primaryHeadingColor: e.getColor(W0e),
      secondaryHeadingColor: e.getColor(j0e)
    });
  }
  _applyStyles() {
    this._parentContainer && (this._parentContainer.style.backgroundColor = this._backgroundColor ? this._backgroundColor.toString() : ""), super._applyStyles();
  }
  dispose() {
    this._callOnDispose.dispose(), super.dispose();
  }
  _fillHead(e) {
    super._fillHead(e), this._disposables.add(this._actionbarWidget.actionRunner.onWillRun((r) => this.editor.focus()));
    const t = [], n = this._menuService.createMenu(YV.TitleMenu, this._contextKeyService);
    Spe(n, void 0, t), this._actionbarWidget.push(t, { label: !1, icon: !0, index: 0 }), n.dispose();
  }
  _fillTitleIcon(e) {
    this._icon = Te(e, Re(""));
  }
  _fillBody(e) {
    this._parentContainer = e, e.classList.add("marker-widget"), this._parentContainer.tabIndex = 0, this._parentContainer.setAttribute("role", "tooltip"), this._container = document.createElement("div"), e.appendChild(this._container), this._message = new C$e(this._container, this.editor, (t) => this._onDidSelectRelatedInformation.fire(t), this._openerService, this._labelService), this._disposables.add(this._message);
  }
  show() {
    throw new Error("call showAtMarker");
  }
  showAtMarker(e, t, n) {
    this._container.classList.remove("stale"), this._message.update(e), this._severity = e.severity, this._applyTheme(this._themeService.getColorTheme());
    const r = V.lift(e), s = this.editor.getPosition(), o = s && r.containsPosition(s) ? s : r.getStartPosition();
    super.show(o, this.computeRequiredHeight());
    const a = this.editor.getModel();
    if (a) {
      const l = n > 1 ? C("problems", "{0} of {1} problems", t, n) : C("change", "{0} of {1} problem", t, n);
      this.setTitle(xl(a.uri), l);
    }
    this._icon.className = `codicon ${KV.className(Fi.toSeverity(this._severity))}`, this.editor.revealPositionNearTop(
      o,
      0
      /* ScrollType.Smooth */
    ), this.editor.focus();
  }
  updateMarker(e) {
    this._container.classList.remove("stale"), this._message.update(e);
  }
  showStale() {
    this._container.classList.add("stale"), this._relayout();
  }
  _doLayoutBody(e, t) {
    super._doLayoutBody(e, t), this._heightInPixel = e, this._message.layout(e, t), this._container.style.height = `${e}px`;
  }
  _onWidth(e) {
    this._message.layout(this._heightInPixel, e);
  }
  _relayout() {
    super._relayout(this.computeRequiredHeight());
  }
  computeRequiredHeight() {
    return 3 + this._message.getHeightInLines();
  }
};
W_.TitleMenu = new J("gotoErrorTitleMenu");
W_ = YV = b$e([
  C1(1, Pr),
  C1(2, da),
  C1(3, Ou),
  C1(4, bt),
  C1(5, yt),
  C1(6, I_)
], W_);
const P$ = zy($d, SMe), O$ = zy(Na, Wy), M$ = zy(Oo, jy), XV = ne("editorMarkerNavigationError.background", { dark: P$, light: P$, hcDark: $t, hcLight: $t }, C("editorMarkerNavigationError", "Editor marker navigation widget error color.")), y$e = ne("editorMarkerNavigationError.headerBackground", { dark: dt(XV, 0.1), light: dt(XV, 0.1), hcDark: null, hcLight: null }, C("editorMarkerNavigationErrorHeaderBackground", "Editor marker navigation widget error heading background.")), cE = ne("editorMarkerNavigationWarning.background", { dark: O$, light: O$, hcDark: $t, hcLight: $t }, C("editorMarkerNavigationWarning", "Editor marker navigation widget warning color.")), w$e = ne("editorMarkerNavigationWarning.headerBackground", { dark: dt(cE, 0.1), light: dt(cE, 0.1), hcDark: "#0C141F", hcLight: dt(cE, 0.2) }, C("editorMarkerNavigationWarningBackground", "Editor marker navigation widget warning heading background.")), ZV = ne("editorMarkerNavigationInfo.background", { dark: M$, light: M$, hcDark: $t, hcLight: $t }, C("editorMarkerNavigationInfo", "Editor marker navigation widget info color.")), S$e = ne("editorMarkerNavigationInfo.headerBackground", { dark: dt(ZV, 0.1), light: dt(ZV, 0.1), hcDark: null, hcLight: null }, C("editorMarkerNavigationInfoHeaderBackground", "Editor marker navigation widget info heading background.")), x$e = ne("editorMarkerNavigation.background", { dark: Nr, light: Nr, hcDark: Nr, hcLight: Nr }, C("editorMarkerNavigationBackground", "Editor marker navigation widget background."));
var D$e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, PD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, i1e = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, oC;
let Qg = oC = class {
  static get(e) {
    return e.getContribution(oC.ID);
  }
  constructor(e, t, n, r, s) {
    this._markerNavigationService = t, this._contextKeyService = n, this._editorService = r, this._instantiationService = s, this._sessionDispoables = new Ne(), this._editor = e, this._widgetVisible = r1e.bindTo(this._contextKeyService);
  }
  dispose() {
    this._cleanUp(), this._sessionDispoables.dispose();
  }
  _cleanUp() {
    this._widgetVisible.reset(), this._sessionDispoables.clear(), this._widget = void 0, this._model = void 0;
  }
  _getOrCreateModel(e) {
    if (this._model && this._model.matches(e))
      return this._model;
    let t = !1;
    return this._model && (t = !0, this._cleanUp()), this._model = this._markerNavigationService.getMarkerList(e), t && this._model.move(!0, this._editor.getModel(), this._editor.getPosition()), this._widget = this._instantiationService.createInstance(W_, this._editor), this._widget.onDidClose(() => this.close(), this, this._sessionDispoables), this._widgetVisible.set(!0), this._sessionDispoables.add(this._model), this._sessionDispoables.add(this._widget), this._sessionDispoables.add(this._editor.onDidChangeCursorPosition((n) => {
      var r, s, o;
      (!(!((r = this._model) === null || r === void 0) && r.selected) || !V.containsPosition((s = this._model) === null || s === void 0 ? void 0 : s.selected.marker, n.position)) && ((o = this._model) === null || o === void 0 || o.resetIndex());
    })), this._sessionDispoables.add(this._model.onDidChange(() => {
      if (!this._widget || !this._widget.position || !this._model)
        return;
      const n = this._model.find(this._editor.getModel().uri, this._widget.position);
      n ? this._widget.updateMarker(n.marker) : this._widget.showStale();
    })), this._sessionDispoables.add(this._widget.onDidSelectRelatedInformation((n) => {
      this._editorService.openCodeEditor({
        resource: n.resource,
        options: { pinned: !0, revealIfOpened: !0, selection: V.lift(n).collapseToStart() }
      }, this._editor), this.close(!1);
    })), this._sessionDispoables.add(this._editor.onDidChangeModel(() => this._cleanUp())), this._model;
  }
  close(e = !0) {
    this._cleanUp(), e && this._editor.focus();
  }
  showAtMarker(e) {
    if (this._editor.hasModel()) {
      const t = this._getOrCreateModel(this._editor.getModel().uri);
      t.resetIndex(), t.move(!0, this._editor.getModel(), new ve(e.startLineNumber, e.startColumn)), t.selected && this._widget.showAtMarker(t.selected.marker, t.selected.index, t.selected.total);
    }
  }
  nagivate(e, t) {
    var n, r;
    return i1e(this, void 0, void 0, function* () {
      if (this._editor.hasModel()) {
        const s = this._getOrCreateModel(t ? void 0 : this._editor.getModel().uri);
        if (s.move(e, this._editor.getModel(), this._editor.getPosition()), !s.selected)
          return;
        if (s.selected.marker.resource.toString() !== this._editor.getModel().uri.toString()) {
          this._cleanUp();
          const o = yield this._editorService.openCodeEditor({
            resource: s.selected.marker.resource,
            options: { pinned: !1, revealIfOpened: !0, selectionRevealType: 2, selection: s.selected.marker }
          }, this._editor);
          o && ((n = oC.get(o)) === null || n === void 0 || n.close(), (r = oC.get(o)) === null || r === void 0 || r.nagivate(e, t));
        } else
          this._widget.showAtMarker(s.selected.marker, s.selected.index, s.selected.total);
      }
    });
  }
};
Qg.ID = "editor.contrib.markerController";
Qg = oC = D$e([
  PD(1, n1e),
  PD(2, yt),
  PD(3, Sn),
  PD(4, bt)
], Qg);
class b5 extends Je {
  constructor(e, t, n) {
    super(n), this._next = e, this._multiFile = t;
  }
  run(e, t) {
    var n;
    return i1e(this, void 0, void 0, function* () {
      t.hasModel() && ((n = Qg.get(t)) === null || n === void 0 || n.nagivate(this._next, this._multiFile));
    });
  }
}
class Dg extends b5 {
  constructor() {
    super(!0, !1, {
      id: Dg.ID,
      label: Dg.LABEL,
      alias: "Go to Next Problem (Error, Warning, Info)",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 578,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: W_.TitleMenu,
        title: Dg.LABEL,
        icon: $i("marker-navigation-next", We.arrowDown, C("nextMarkerIcon", "Icon for goto next marker.")),
        group: "navigation",
        order: 1
      }
    });
  }
}
Dg.ID = "editor.action.marker.next";
Dg.LABEL = C("markerAction.next.label", "Go to Next Problem (Error, Warning, Info)");
class Nm extends b5 {
  constructor() {
    super(!1, !1, {
      id: Nm.ID,
      label: Nm.LABEL,
      alias: "Go to Previous Problem (Error, Warning, Info)",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 1602,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: W_.TitleMenu,
        title: Nm.LABEL,
        icon: $i("marker-navigation-previous", We.arrowUp, C("previousMarkerIcon", "Icon for goto previous marker.")),
        group: "navigation",
        order: 2
      }
    });
  }
}
Nm.ID = "editor.action.marker.prev";
Nm.LABEL = C("markerAction.previous.label", "Go to Previous Problem (Error, Warning, Info)");
class E$e extends b5 {
  constructor() {
    super(!0, !0, {
      id: "editor.action.marker.nextInFiles",
      label: C("markerAction.nextInFiles.label", "Go to Next Problem in Files (Error, Warning, Info)"),
      alias: "Go to Next Problem in Files (Error, Warning, Info)",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 66,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarGoMenu,
        title: C({ key: "miGotoNextProblem", comment: ["&& denotes a mnemonic"] }, "Next &&Problem"),
        group: "6_problem_nav",
        order: 1
      }
    });
  }
}
class L$e extends b5 {
  constructor() {
    super(!1, !0, {
      id: "editor.action.marker.prevInFiles",
      label: C("markerAction.previousInFiles.label", "Go to Previous Problem in Files (Error, Warning, Info)"),
      alias: "Go to Previous Problem in Files (Error, Warning, Info)",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 1090,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarGoMenu,
        title: C({ key: "miGotoPreviousProblem", comment: ["&& denotes a mnemonic"] }, "Previous &&Problem"),
        group: "6_problem_nav",
        order: 2
      }
    });
  }
}
pn(
  Qg.ID,
  Qg,
  4
  /* EditorContributionInstantiation.Lazy */
);
Be(Dg);
Be(Nm);
Be(E$e);
Be(L$e);
const r1e = new Ke("markersNavigationVisible", !1), I$e = Kr.bindToContribution(Qg.get);
ze(new I$e({
  id: "closeMarkersNavigation",
  precondition: r1e,
  handler: (i) => i.close(),
  kbOpts: {
    weight: 150,
    kbExpr: $.focus,
    primary: 9,
    secondary: [
      1033
      /* KeyCode.Escape */
    ]
  }
}));
var A$e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, kT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Ol = Re;
class k$e {
  constructor(e, t, n) {
    this.owner = e, this.range = t, this.marker = n;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
const R$ = {
  type: 1,
  filter: { include: vt.QuickFix },
  triggerAction: la.QuickFixHover
};
let QV = class {
  constructor(e, t, n, r) {
    this._editor = e, this._markerDecorationsService = t, this._openerService = n, this._languageFeaturesService = r, this.hoverOrdinal = 1, this.recentMarkerCodeActionsInfo = void 0;
  }
  computeSync(e, t) {
    if (!this._editor.hasModel() || e.type !== 1 && !e.supportsMarkerHover)
      return [];
    const n = this._editor.getModel(), r = e.range.startLineNumber, s = n.getLineMaxColumn(r), o = [];
    for (const a of t) {
      const l = a.range.startLineNumber === r ? a.range.startColumn : 1, c = a.range.endLineNumber === r ? a.range.endColumn : s, d = this._markerDecorationsService.getMarker(n.uri, a);
      if (!d)
        continue;
      const u = new V(e.range.startLineNumber, l, e.range.startLineNumber, c);
      o.push(new k$e(this, u, d));
    }
    return o;
  }
  renderHoverParts(e, t) {
    if (!t.length)
      return we.None;
    const n = new Ne();
    t.forEach((s) => e.fragment.appendChild(this.renderMarkerHover(s, n)));
    const r = t.length === 1 ? t[0] : t.sort((s, o) => Fi.compare(s.marker.severity, o.marker.severity))[0];
    return this.renderMarkerStatusbar(e, r, n), n;
  }
  renderMarkerHover(e, t) {
    const n = Ol("div.hover-row"), r = Te(n, Ol("div.marker.hover-contents")), { source: s, message: o, code: a, relatedInformation: l } = e.marker;
    this._editor.applyFontInfo(r);
    const c = Te(r, Ol("span"));
    if (c.style.whiteSpace = "pre-wrap", c.innerText = o, s || a)
      if (a && typeof a != "string") {
        const d = Ol("span");
        if (s) {
          const g = Te(d, Ol("span"));
          g.innerText = s;
        }
        const u = Te(d, Ol("a.code-link"));
        u.setAttribute("href", a.target.toString()), t.add(Ie(u, "click", (g) => {
          this._openerService.open(a.target, { allowCommands: !0 }), g.preventDefault(), g.stopPropagation();
        }));
        const h = Te(u, Ol("span"));
        h.innerText = a.value;
        const f = Te(r, d);
        f.style.opacity = "0.6", f.style.paddingLeft = "6px";
      } else {
        const d = Te(r, Ol("span"));
        d.style.opacity = "0.6", d.style.paddingLeft = "6px", d.innerText = s && a ? `${s}(${a})` : s || `(${a})`;
      }
    if (Bs(l))
      for (const { message: d, resource: u, startLineNumber: h, startColumn: f } of l) {
        const g = Te(r, Ol("div"));
        g.style.marginTop = "8px";
        const p = Te(g, Ol("a"));
        p.innerText = `${xl(u)}(${h}, ${f}): `, p.style.cursor = "pointer", t.add(Ie(p, "click", (_) => {
          _.stopPropagation(), _.preventDefault(), this._openerService && this._openerService.open(u, {
            fromUserGesture: !0,
            editorOptions: { selection: { startLineNumber: h, startColumn: f } }
          }).catch(It);
        }));
        const m = Te(g, Ol("span"));
        m.innerText = d, this._editor.applyFontInfo(m);
      }
    return n;
  }
  renderMarkerStatusbar(e, t, n) {
    if ((t.marker.severity === Fi.Error || t.marker.severity === Fi.Warning || t.marker.severity === Fi.Info) && e.statusBar.addAction({
      label: C("view problem", "View Problem"),
      commandId: Dg.ID,
      run: () => {
        var r;
        e.hide(), (r = Qg.get(this._editor)) === null || r === void 0 || r.showAtMarker(t.marker), this._editor.focus();
      }
    }), !this._editor.getOption(
      90
      /* EditorOption.readOnly */
    )) {
      const r = e.statusBar.append(Ol("div"));
      this.recentMarkerCodeActionsInfo && (GL.makeKey(this.recentMarkerCodeActionsInfo.marker) === GL.makeKey(t.marker) ? this.recentMarkerCodeActionsInfo.hasCodeActions || (r.textContent = C("noQuickFixes", "No quick fixes available")) : this.recentMarkerCodeActionsInfo = void 0);
      const s = this.recentMarkerCodeActionsInfo && !this.recentMarkerCodeActionsInfo.hasCodeActions ? we.None : n.add(Rg(() => r.textContent = C("checkingForQuickFixes", "Checking for quick fixes..."), 200));
      r.textContent || (r.textContent = " ");
      const o = this.getCodeActions(t.marker);
      n.add(Ct(() => o.cancel())), o.then((a) => {
        if (s.dispose(), this.recentMarkerCodeActionsInfo = { marker: t.marker, hasCodeActions: a.validActions.length > 0 }, !this.recentMarkerCodeActionsInfo.hasCodeActions) {
          a.dispose(), r.textContent = C("noQuickFixes", "No quick fixes available");
          return;
        }
        r.style.display = "none";
        let l = !1;
        n.add(Ct(() => {
          l || a.dispose();
        })), e.statusBar.addAction({
          label: C("quick fixes", "Quick Fix..."),
          commandId: $U,
          run: (c) => {
            l = !0;
            const d = qg.get(this._editor), u = wr(c);
            e.hide(), d?.showCodeActions(R$, a, {
              x: u.left,
              y: u.top,
              width: u.width,
              height: u.height
            });
          }
        });
      }, It);
    }
  }
  getCodeActions(e) {
    return Ir((t) => zC(this._languageFeaturesService.codeActionProvider, this._editor.getModel(), new V(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn), R$, Hh.None, t));
  }
};
QV = A$e([
  kT(1, dz),
  kT(2, da),
  kT(3, tt)
], QV);
const s1e = "editor.action.inlineSuggest.commit", o1e = "editor.action.inlineSuggest.showPrevious", a1e = "editor.action.inlineSuggest.showNext";
var T$e = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class N$e extends we {
  constructor(e, t, n = {
    orientation: 0
    /* ActionsOrientation.HORIZONTAL */
  }) {
    super(), this.submenuActionViewItems = [], this.hasSecondaryActions = !1, this._onDidChangeDropdownVisibility = this._register(new BTe()), this.onDidChangeDropdownVisibility = this._onDidChangeDropdownVisibility.event, this.disposables = this._register(new Ne()), this.options = n, this.lookupKeybindings = typeof this.options.getKeyBinding == "function", this.toggleMenuAction = this._register(new Iw(() => {
      var r;
      return (r = this.toggleMenuActionViewItem) === null || r === void 0 ? void 0 : r.show();
    }, n.toggleMenuTitle)), this.element = document.createElement("div"), this.element.className = "monaco-toolbar", e.appendChild(this.element), this.actionBar = this._register(new Dl(this.element, {
      orientation: n.orientation,
      ariaLabel: n.ariaLabel,
      actionRunner: n.actionRunner,
      allowContextMenu: n.allowContextMenu,
      highlightToggledItems: n.highlightToggledItems,
      actionViewItemProvider: (r, s) => {
        var o;
        if (r.id === Iw.ID)
          return this.toggleMenuActionViewItem = new BL(r, r.menuActions, t, {
            actionViewItemProvider: this.options.actionViewItemProvider,
            actionRunner: this.actionRunner,
            keybindingProvider: this.options.getKeyBinding,
            classNames: ft.asClassNameArray((o = n.moreIcon) !== null && o !== void 0 ? o : We.toolBarMore),
            anchorAlignmentProvider: this.options.anchorAlignmentProvider,
            menuAsChild: !!this.options.renderDropdownAsChildElement,
            skipTelemetry: this.options.skipTelemetry
          }), this.toggleMenuActionViewItem.setActionContext(this.actionBar.context), this.disposables.add(this._onDidChangeDropdownVisibility.add(this.toggleMenuActionViewItem.onDidChangeVisibility)), this.toggleMenuActionViewItem;
        if (n.actionViewItemProvider) {
          const a = n.actionViewItemProvider(r, s);
          if (a)
            return a;
        }
        if (r instanceof g_) {
          const a = new BL(r, r.actions, t, {
            actionViewItemProvider: this.options.actionViewItemProvider,
            actionRunner: this.actionRunner,
            keybindingProvider: this.options.getKeyBinding,
            classNames: r.class,
            anchorAlignmentProvider: this.options.anchorAlignmentProvider,
            menuAsChild: !!this.options.renderDropdownAsChildElement,
            skipTelemetry: this.options.skipTelemetry
          });
          return a.setActionContext(this.actionBar.context), this.submenuActionViewItems.push(a), this.disposables.add(this._onDidChangeDropdownVisibility.add(a.onDidChangeVisibility)), a;
        }
      }
    }));
  }
  set actionRunner(e) {
    this.actionBar.actionRunner = e;
  }
  get actionRunner() {
    return this.actionBar.actionRunner;
  }
  getElement() {
    return this.element;
  }
  getItemAction(e) {
    return this.actionBar.getAction(e);
  }
  setActions(e, t) {
    this.clear();
    const n = e ? e.slice(0) : [];
    this.hasSecondaryActions = !!(t && t.length > 0), this.hasSecondaryActions && t && (this.toggleMenuAction.menuActions = t.slice(0), n.push(this.toggleMenuAction)), n.forEach((r) => {
      this.actionBar.push(r, { icon: !0, label: !1, keybinding: this.getKeybindingLabel(r) });
    });
  }
  getKeybindingLabel(e) {
    var t, n, r;
    const s = this.lookupKeybindings ? (n = (t = this.options).getKeyBinding) === null || n === void 0 ? void 0 : n.call(t, e) : void 0;
    return (r = s?.getLabel()) !== null && r !== void 0 ? r : void 0;
  }
  clear() {
    this.submenuActionViewItems = [], this.disposables.clear(), this.actionBar.clear();
  }
  dispose() {
    this.clear(), this.disposables.dispose(), super.dispose();
  }
}
class Iw extends vo {
  constructor(e, t) {
    t = t || C("moreActions", "More Actions..."), super(Iw.ID, t, void 0, !0), this._menuActions = [], this.toggleDropdownMenu = e;
  }
  run() {
    return T$e(this, void 0, void 0, function* () {
      this.toggleDropdownMenu();
    });
  }
  get menuActions() {
    return this._menuActions;
  }
  set menuActions(e) {
    this._menuActions = e;
  }
}
Iw.ID = "toolbar.toggle.more";
var P$e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, b2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let JV = class extends N$e {
  constructor(e, t, n, r, s, o, a) {
    super(e, s, Object.assign(Object.assign({
      // defaults
      getKeyBinding: (c) => {
        var d;
        return (d = o.lookupKeybinding(c.id)) !== null && d !== void 0 ? d : void 0;
      }
    }, t), {
      // mandatory (overide options)
      allowContextMenu: !0,
      skipTelemetry: typeof t?.telemetrySource == "string"
    })), this._options = t, this._menuService = n, this._contextKeyService = r, this._contextMenuService = s, this._sessionDisposables = this._store.add(new Ne());
    const l = t?.telemetrySource;
    l && this._store.add(this.actionBar.onDidRun((c) => a.publicLog2("workbenchActionExecuted", { id: c.action.id, from: l })));
  }
  setActions(e, t = [], n) {
    var r, s, o;
    this._sessionDisposables.clear();
    const a = e.slice(), l = t.slice(), c = [];
    let d = 0;
    const u = [];
    let h = !1;
    if (((r = this._options) === null || r === void 0 ? void 0 : r.hiddenItemStrategy) !== -1)
      for (let f = 0; f < a.length; f++) {
        const g = a[f];
        !(g instanceof sc) && !(g instanceof Ay) || g.hideActions && (c.push(g.hideActions.toggle), g.hideActions.toggle.checked && d++, g.hideActions.isHidden && (h = !0, a[f] = void 0, ((s = this._options) === null || s === void 0 ? void 0 : s.hiddenItemStrategy) !== 0 && (u[f] = g)));
      }
    if (((o = this._options) === null || o === void 0 ? void 0 : o.overflowBehavior) !== void 0) {
      const f = aUe(new Set(this._options.overflowBehavior.exempted), Wt.map(a, (m) => m?.id)), g = this._options.overflowBehavior.maxItems - f.size;
      let p = 0;
      for (let m = 0; m < a.length; m++) {
        const _ = a[m];
        _ && (p++, !f.has(_.id) && p >= g && (a[m] = void 0, u[m] = _));
      }
    }
    jY(a), jY(u), super.setActions(a, Gr.join(u, l)), c.length > 0 && this._sessionDisposables.add(Ie(this.getElement(), "contextmenu", (f) => {
      var g, p, m, _, b;
      const w = new cl(f), y = this.getItemAction(w.target);
      if (!y)
        return;
      w.preventDefault(), w.stopPropagation();
      let S = !1;
      if (d === 1 && ((g = this._options) === null || g === void 0 ? void 0 : g.hiddenItemStrategy) === 0) {
        S = !0;
        for (let E = 0; E < c.length; E++)
          if (c[E].checked) {
            c[E] = Iv({
              id: y.id,
              label: y.label,
              checked: !0,
              enabled: !1,
              run() {
              }
            });
            break;
          }
      }
      let x;
      if (!S && (y instanceof sc || y instanceof Ay)) {
        if (!y.hideActions)
          return;
        x = y.hideActions.hide;
      } else
        x = Iv({
          id: "label",
          label: C("hide", "Hide"),
          enabled: !1,
          run() {
          }
        });
      const D = Gr.join([x], c);
      !((p = this._options) === null || p === void 0) && p.resetMenu && !n && (n = [this._options.resetMenu]), h && n && (D.push(new Gr()), D.push(Iv({
        id: "resetThisMenu",
        label: C("resetThisMenu", "Reset Menu"),
        run: () => this._menuService.resetHiddenStates(n)
      }))), this._contextMenuService.showContextMenu({
        getAnchor: () => w,
        getActions: () => D,
        // add context menu actions (iff appicable)
        menuId: (m = this._options) === null || m === void 0 ? void 0 : m.contextMenu,
        menuActionOptions: Object.assign({ renderShortTitle: !0 }, (_ = this._options) === null || _ === void 0 ? void 0 : _.menuOptions),
        skipTelemetry: typeof ((b = this._options) === null || b === void 0 ? void 0 : b.telemetrySource) == "string",
        contextKeyService: this._contextKeyService
      });
    }));
  }
};
JV = P$e([
  b2(2, Ou),
  b2(3, yt),
  b2(4, gc),
  b2(5, Bn),
  b2(6, qa)
], JV);
var uG = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, jc = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, dE;
let $V = class extends we {
  constructor(e, t, n) {
    super(), this.editor = e, this.model = t, this.instantiationService = n, this.alwaysShowToolbar = as(this.editor.onDidChangeConfiguration, () => this.editor.getOption(
      62
      /* EditorOption.inlineSuggest */
    ).showToolbar === "always"), this.sessionPosition = void 0, this.position = nn(this, (r) => {
      var s, o, a;
      const l = (s = this.model.read(r)) === null || s === void 0 ? void 0 : s.ghostText.read(r);
      if (!this.alwaysShowToolbar.read(r) || !l || l.parts.length === 0)
        return this.sessionPosition = void 0, null;
      const c = l.parts[0].column;
      this.sessionPosition && this.sessionPosition.lineNumber !== l.lineNumber && (this.sessionPosition = void 0);
      const d = new ve(l.lineNumber, Math.min(c, (a = (o = this.sessionPosition) === null || o === void 0 ? void 0 : o.column) !== null && a !== void 0 ? a : Number.MAX_SAFE_INTEGER));
      return this.sessionPosition = d, d;
    }), this._register(Yo((r, s) => {
      const o = this.model.read(r);
      if (!o || !this.alwaysShowToolbar.read(r))
        return;
      const a = s.add(this.instantiationService.createInstance(Jg, this.editor, !0, this.position, o.selectedInlineCompletionIndex, o.inlineCompletionsCount, o.selectedInlineCompletion.map((l) => {
        var c;
        return (c = l?.inlineCompletion.source.inlineCompletions.commands) !== null && c !== void 0 ? c : [];
      })));
      e.addContentWidget(a), s.add(Ct(() => e.removeContentWidget(a))), s.add(zn((l) => {
        this.position.read(l) && o.lastTriggerKind.read(l) !== Fh.Explicit && o.triggerExplicitly();
      }));
    }));
  }
};
$V = uG([
  jc(2, bt)
], $V);
const O$e = $i("inline-suggestion-hints-next", We.chevronRight, C("parameterHintsNextIcon", "Icon for show next parameter hint.")), M$e = $i("inline-suggestion-hints-previous", We.chevronLeft, C("parameterHintsPreviousIcon", "Icon for show previous parameter hint."));
let Jg = dE = class extends we {
  static get dropDownVisible() {
    return this._dropDownVisible;
  }
  createCommandAction(e, t, n) {
    const r = new vo(e, t, n, !0, () => this._commandService.executeCommand(e)), s = this.keybindingService.lookupKeybinding(e, this._contextKeyService);
    let o = t;
    return s && (o = C({ key: "content", comment: ["A label", "A keybinding"] }, "{0} ({1})", t, s.getLabel())), r.tooltip = o, r;
  }
  constructor(e, t, n, r, s, o, a, l, c, d, u) {
    super(), this.editor = e, this.withBorder = t, this._position = n, this._currentSuggestionIdx = r, this._suggestionCount = s, this._extraCommands = o, this._commandService = a, this.keybindingService = c, this._contextKeyService = d, this._menuService = u, this.id = `InlineSuggestionHintsContentWidget${dE.id++}`, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this.nodes = ts("div.inlineSuggestionsHints", { className: this.withBorder ? ".withBorder" : "" }, [
      ts("div@toolBar")
    ]), this.previousAction = this.createCommandAction(o1e, C("previous", "Previous"), ft.asClassName(M$e)), this.availableSuggestionCountAction = new vo("inlineSuggestionHints.availableSuggestionCount", "", void 0, !1), this.nextAction = this.createCommandAction(a1e, C("next", "Next"), ft.asClassName(O$e)), this.inlineCompletionsActionsMenus = this._register(this._menuService.createMenu(J.InlineCompletionsActions, this._contextKeyService)), this.clearAvailableSuggestionCountLabelDebounced = this._register(new Rn(() => {
      this.availableSuggestionCountAction.label = "";
    }, 100)), this.disableButtonsDebounced = this._register(new Rn(() => {
      this.previousAction.enabled = this.nextAction.enabled = !1;
    }, 100)), this.lastCommands = [], this.toolBar = this._register(l.createInstance(eH, this.nodes.toolBar, J.InlineSuggestionToolbar, {
      menuOptions: { renderShortTitle: !0 },
      toolbarOptions: { primaryGroup: (h) => h.startsWith("primary") },
      actionViewItemProvider: (h, f) => {
        if (h instanceof sc)
          return l.createInstance(F$e, h, void 0);
        if (h === this.availableSuggestionCountAction) {
          const g = new R$e(void 0, h, { label: !0, icon: !1 });
          return g.setClass("availableSuggestionCount"), g;
        }
      },
      telemetrySource: "InlineSuggestionToolbar"
    })), this.toolBar.setPrependedPrimaryActions([
      this.previousAction,
      this.availableSuggestionCountAction,
      this.nextAction
    ]), this._register(this.toolBar.onDidChangeDropdownVisibility((h) => {
      dE._dropDownVisible = h;
    })), this._register(zn((h) => {
      this._position.read(h), this.editor.layoutContentWidget(this);
    })), this._register(zn((h) => {
      const f = this._suggestionCount.read(h), g = this._currentSuggestionIdx.read(h);
      f !== void 0 ? (this.clearAvailableSuggestionCountLabelDebounced.cancel(), this.availableSuggestionCountAction.label = `${g + 1}/${f}`) : this.clearAvailableSuggestionCountLabelDebounced.schedule(), f !== void 0 && f > 1 ? (this.disableButtonsDebounced.cancel(), this.previousAction.enabled = this.nextAction.enabled = !0) : this.disableButtonsDebounced.schedule();
    })), this._register(zn((h) => {
      const f = this._extraCommands.read(h);
      if (Qi(this.lastCommands, f))
        return;
      this.lastCommands = f;
      const g = f.map((p) => ({
        class: void 0,
        id: p.id,
        enabled: !0,
        tooltip: p.tooltip || "",
        label: p.title,
        run: (m) => this._commandService.executeCommand(p.id)
      }));
      for (const [p, m] of this.inlineCompletionsActionsMenus.getActions())
        for (const _ of m)
          _ instanceof sc && g.push(_);
      g.length > 0 && g.unshift(new Gr()), this.toolBar.setAdditionalSecondaryActions(g);
    }));
  }
  getId() {
    return this.id;
  }
  getDomNode() {
    return this.nodes.root;
  }
  getPosition() {
    return {
      position: this._position.get(),
      preference: [
        1,
        2
        /* ContentWidgetPositionPreference.BELOW */
      ],
      positionAffinity: 3
    };
  }
};
Jg._dropDownVisible = !1;
Jg.id = 0;
Jg = dE = uG([
  jc(6, Ui),
  jc(7, bt),
  jc(8, Bn),
  jc(9, yt),
  jc(10, Ou)
], Jg);
class R$e extends N_ {
  constructor() {
    super(...arguments), this._className = void 0;
  }
  setClass(e) {
    this._className = e;
  }
  render(e) {
    super.render(e), this._className && e.classList.add(this._className);
  }
}
let F$e = class extends $m {
  updateLabel() {
    const e = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
    if (!e)
      return super.updateLabel();
    if (this.label) {
      const t = ts("div.keybinding").root;
      new jS(t, ka, Object.assign({ disableTitle: !0 }, DGe)).set(e), this.label.textContent = this._action.label, this.label.appendChild(t), this.label.classList.add("inlineSuggestionStatusBarItemLabel");
    }
  }
}, eH = class extends JV {
  constructor(e, t, n, r, s, o, a, l) {
    super(e, Object.assign({ resetMenu: t }, n), r, s, o, a, l), this.menuId = t, this.options2 = n, this.menuService = r, this.contextKeyService = s, this.menu = this._store.add(this.menuService.createMenu(this.menuId, this.contextKeyService, { emitEventsForSubmenuChanges: !0 })), this.additionalActions = [], this.prependedPrimaryActions = [], this._store.add(this.menu.onDidChange(() => this.updateToolbar())), this.updateToolbar();
  }
  updateToolbar() {
    var e, t, n, r, s, o, a;
    const l = [], c = [];
    Spe(this.menu, (e = this.options2) === null || e === void 0 ? void 0 : e.menuOptions, { primary: l, secondary: c }, (n = (t = this.options2) === null || t === void 0 ? void 0 : t.toolbarOptions) === null || n === void 0 ? void 0 : n.primaryGroup, (s = (r = this.options2) === null || r === void 0 ? void 0 : r.toolbarOptions) === null || s === void 0 ? void 0 : s.shouldInlineSubmenu, (a = (o = this.options2) === null || o === void 0 ? void 0 : o.toolbarOptions) === null || a === void 0 ? void 0 : a.useSeparatorsInPrimaryActions), c.push(...this.additionalActions), l.unshift(...this.prependedPrimaryActions), this.setActions(l, c);
  }
  setPrependedPrimaryActions(e) {
    Qi(this.prependedPrimaryActions, e, (t, n) => t === n) || (this.prependedPrimaryActions = e, this.updateToolbar());
  }
  setAdditionalSecondaryActions(e) {
    Qi(this.additionalActions, e, (t, n) => t === n) || (this.additionalActions = e, this.updateToolbar());
  }
};
eH = uG([
  jc(3, Ou),
  jc(4, yt),
  jc(5, gc),
  jc(6, Bn),
  jc(7, qa)
], eH);
var B$e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, OD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, tH;
const V$e = !1;
let Ho = tH = class extends we {
  static get(e) {
    return e.getContribution(tH.ID);
  }
  constructor(e, t, n, r, s) {
    super(), this._editor = e, this._instantiationService = t, this._openerService = n, this._languageService = r, this._keybindingService = s, this._toUnhook = new Ne(), this._hoverActivatedByColorDecoratorClick = !1, this._isMouseDown = !1, this._hoverClicked = !1, this._contentWidget = null, this._glyphWidget = null, this._reactToEditorMouseMoveRunner = this._register(new Rn(() => this._reactToEditorMouseMove(this._mouseMoveEvent), 0)), this._hookEvents(), this._register(this._editor.onDidChangeConfiguration((o) => {
      o.hasChanged(
        60
        /* EditorOption.hover */
      ) && (this._unhookEvents(), this._hookEvents());
    })), this._register(this._editor.onMouseLeave(() => {
      this._mouseMoveEvent = void 0, this._reactToEditorMouseMoveRunner.cancel();
    }));
  }
  _hookEvents() {
    const e = () => this._hideWidgets(), t = this._editor.getOption(
      60
      /* EditorOption.hover */
    );
    this._isHoverEnabled = t.enabled, this._isHoverSticky = t.sticky, this._hidingDelay = t.hidingDelay, this._isHoverEnabled ? (this._toUnhook.add(this._editor.onMouseDown((n) => this._onEditorMouseDown(n))), this._toUnhook.add(this._editor.onMouseUp((n) => this._onEditorMouseUp(n))), this._toUnhook.add(this._editor.onMouseMove((n) => this._onEditorMouseMove(n))), this._toUnhook.add(this._editor.onKeyDown((n) => this._onKeyDown(n)))) : (this._toUnhook.add(this._editor.onMouseMove((n) => this._onEditorMouseMove(n))), this._toUnhook.add(this._editor.onKeyDown((n) => this._onKeyDown(n)))), this._toUnhook.add(this._editor.onMouseLeave((n) => this._onEditorMouseLeave(n))), this._toUnhook.add(this._editor.onDidChangeModel(e)), this._toUnhook.add(this._editor.onDidScrollChange((n) => this._onEditorScrollChanged(n)));
  }
  _unhookEvents() {
    this._toUnhook.clear();
  }
  _onEditorScrollChanged(e) {
    (e.scrollTopChanged || e.scrollLeftChanged) && this._hideWidgets();
  }
  _onEditorMouseDown(e) {
    var t;
    this._isMouseDown = !0;
    const n = e.target;
    if (n.type === 9 && n.detail === xg.ID) {
      this._hoverClicked = !0;
      return;
    }
    n.type === 12 && n.detail === Yv.ID || (n.type !== 12 && (this._hoverClicked = !1), !((t = this._contentWidget) === null || t === void 0) && t.widget.isResizing || this._hideWidgets());
  }
  _onEditorMouseUp(e) {
    this._isMouseDown = !1;
  }
  _onEditorMouseLeave(e) {
    var t, n;
    const r = e.event.browserEvent.relatedTarget;
    !((t = this._contentWidget) === null || t === void 0) && t.widget.isResizing || !((n = this._contentWidget) === null || n === void 0) && n.containsNode(r) || this._hideWidgets();
  }
  _isMouseOverWidget(e) {
    var t, n, r, s, o;
    const a = e.target;
    return !!(this._isHoverSticky && a.type === 9 && a.detail === xg.ID || this._isHoverSticky && (!((t = this._contentWidget) === null || t === void 0) && t.containsNode((n = e.event.browserEvent.view) === null || n === void 0 ? void 0 : n.document.activeElement)) && !(!((s = (r = e.event.browserEvent.view) === null || r === void 0 ? void 0 : r.getSelection()) === null || s === void 0) && s.isCollapsed) || !this._isHoverSticky && a.type === 9 && a.detail === xg.ID && (!((o = this._contentWidget) === null || o === void 0) && o.isColorPickerVisible) || this._isHoverSticky && a.type === 12 && a.detail === Yv.ID);
  }
  _onEditorMouseMove(e) {
    var t, n, r, s;
    if (this._mouseMoveEvent = e, !((t = this._contentWidget) === null || t === void 0) && t.isFocused || !((n = this._contentWidget) === null || n === void 0) && n.isResizing || this._isMouseDown && this._hoverClicked || this._isHoverSticky && (!((r = this._contentWidget) === null || r === void 0) && r.isVisibleFromKeyboard))
      return;
    if (this._isMouseOverWidget(e)) {
      this._reactToEditorMouseMoveRunner.cancel();
      return;
    }
    if (!((s = this._contentWidget) === null || s === void 0) && s.isVisible && this._isHoverSticky && this._hidingDelay > 0) {
      this._reactToEditorMouseMoveRunner.isScheduled() || this._reactToEditorMouseMoveRunner.schedule(this._hidingDelay);
      return;
    }
    this._reactToEditorMouseMove(e);
  }
  _reactToEditorMouseMove(e) {
    var t, n, r;
    if (!e)
      return;
    const s = e.target, o = (t = s.element) === null || t === void 0 ? void 0 : t.classList.contains("colorpicker-color-decoration"), a = this._editor.getOption(
      146
      /* EditorOption.colorDecoratorsActivatedOn */
    );
    if (o && (a === "click" && !this._hoverActivatedByColorDecoratorClick || a === "hover" && !this._isHoverEnabled && !V$e || a === "clickAndHover" && !this._isHoverEnabled && !this._hoverActivatedByColorDecoratorClick) || !o && !this._isHoverEnabled && !this._hoverActivatedByColorDecoratorClick) {
      this._hideWidgets();
      return;
    }
    if (this._getOrCreateContentWidget().maybeShowAt(e)) {
      (n = this._glyphWidget) === null || n === void 0 || n.hide();
      return;
    }
    if (s.type === 2 && s.position) {
      (r = this._contentWidget) === null || r === void 0 || r.hide(), this._glyphWidget || (this._glyphWidget = new Yv(this._editor, this._languageService, this._openerService)), this._glyphWidget.startShowingAt(s.position.lineNumber);
      return;
    }
    this._hideWidgets();
  }
  _onKeyDown(e) {
    var t;
    if (!this._editor.hasModel())
      return;
    const n = this._keybindingService.softDispatch(e, this._editor.getDomNode()), r = n.kind === 1 || n.kind === 2 && n.commandId === "editor.action.showHover" && ((t = this._contentWidget) === null || t === void 0 ? void 0 : t.isVisible);
    e.keyCode !== 5 && e.keyCode !== 6 && e.keyCode !== 57 && e.keyCode !== 4 && !r && this._hideWidgets();
  }
  _hideWidgets() {
    var e, t, n;
    this._isMouseDown && this._hoverClicked && (!((e = this._contentWidget) === null || e === void 0) && e.isColorPickerVisible) || Jg.dropDownVisible || (this._hoverActivatedByColorDecoratorClick = !1, this._hoverClicked = !1, (t = this._glyphWidget) === null || t === void 0 || t.hide(), (n = this._contentWidget) === null || n === void 0 || n.hide());
  }
  _getOrCreateContentWidget() {
    return this._contentWidget || (this._contentWidget = this._instantiationService.createInstance(vI, this._editor)), this._contentWidget;
  }
  showContentHover(e, t, n, r, s = !1) {
    this._hoverActivatedByColorDecoratorClick = s, this._getOrCreateContentWidget().startShowingAtRange(e, t, n, r);
  }
  focus() {
    var e;
    (e = this._contentWidget) === null || e === void 0 || e.focus();
  }
  scrollUp() {
    var e;
    (e = this._contentWidget) === null || e === void 0 || e.scrollUp();
  }
  scrollDown() {
    var e;
    (e = this._contentWidget) === null || e === void 0 || e.scrollDown();
  }
  scrollLeft() {
    var e;
    (e = this._contentWidget) === null || e === void 0 || e.scrollLeft();
  }
  scrollRight() {
    var e;
    (e = this._contentWidget) === null || e === void 0 || e.scrollRight();
  }
  pageUp() {
    var e;
    (e = this._contentWidget) === null || e === void 0 || e.pageUp();
  }
  pageDown() {
    var e;
    (e = this._contentWidget) === null || e === void 0 || e.pageDown();
  }
  goToTop() {
    var e;
    (e = this._contentWidget) === null || e === void 0 || e.goToTop();
  }
  goToBottom() {
    var e;
    (e = this._contentWidget) === null || e === void 0 || e.goToBottom();
  }
  get isColorPickerVisible() {
    var e;
    return (e = this._contentWidget) === null || e === void 0 ? void 0 : e.isColorPickerVisible;
  }
  get isHoverVisible() {
    var e;
    return (e = this._contentWidget) === null || e === void 0 ? void 0 : e.isVisible;
  }
  dispose() {
    var e, t;
    super.dispose(), this._unhookEvents(), this._toUnhook.dispose(), (e = this._glyphWidget) === null || e === void 0 || e.dispose(), (t = this._contentWidget) === null || t === void 0 || t.dispose();
  }
};
Ho.ID = "editor.contrib.hover";
Ho = tH = B$e([
  OD(1, bt),
  OD(2, da),
  OD(3, ci),
  OD(4, Bn)
], Ho);
class H$e extends Je {
  constructor() {
    super({
      id: "editor.action.showHover",
      label: C({
        key: "showOrFocusHover",
        comment: [
          "Label for action that will trigger the showing/focusing of a hover in the editor.",
          "If the hover is not visible, it will show the hover.",
          "This allows for users to show the hover without using the mouse.",
          "If the hover is already visible, it will take focus."
        ]
      }, "Show or Focus Hover"),
      description: {
        description: "Show or Focus Hover",
        args: [{
          name: "args",
          schema: {
            type: "object",
            properties: {
              focus: {
                description: "Controls if when triggered with the keyboard, the hover should take focus immediately.",
                type: "boolean",
                default: !1
              }
            }
          }
        }]
      },
      alias: "Show or Focus Hover",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2087
          /* KeyCode.KeyI */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t, n) {
    if (!t.hasModel())
      return;
    const r = Ho.get(t);
    if (!r)
      return;
    const s = t.getPosition(), o = new V(s.lineNumber, s.column, s.lineNumber, s.column), a = t.getOption(
      2
      /* EditorOption.accessibilitySupport */
    ) === 2 || !!n?.focus;
    r.isHoverVisible ? r.focus() : r.showContentHover(o, 1, 1, a);
  }
}
class W$e extends Je {
  constructor() {
    super({
      id: "editor.action.showDefinitionPreviewHover",
      label: C({
        key: "showDefinitionPreviewHover",
        comment: [
          "Label for action that will trigger the showing of definition preview hover in the editor.",
          "This allows for users to show the definition preview hover without using the mouse."
        ]
      }, "Show Definition Preview Hover"),
      alias: "Show Definition Preview Hover",
      precondition: void 0
    });
  }
  run(e, t) {
    const n = Ho.get(t);
    if (!n)
      return;
    const r = t.getPosition();
    if (!r)
      return;
    const s = new V(r.lineNumber, r.column, r.lineNumber, r.column), o = c0.get(t);
    if (!o)
      return;
    o.startFindDefinitionFromCursor(r).then(() => {
      n.showContentHover(s, 1, 1, !0);
    });
  }
}
class j$e extends Je {
  constructor() {
    super({
      id: "editor.action.scrollUpHover",
      label: C({
        key: "scrollUpHover",
        comment: [
          "Action that allows to scroll up in the hover widget with the up arrow when the hover widget is focused."
        ]
      }, "Scroll Up Hover"),
      alias: "Scroll Up Hover",
      precondition: $.hoverFocused,
      kbOpts: {
        kbExpr: $.hoverFocused,
        primary: 16,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = Ho.get(t);
    n && n.scrollUp();
  }
}
class z$e extends Je {
  constructor() {
    super({
      id: "editor.action.scrollDownHover",
      label: C({
        key: "scrollDownHover",
        comment: [
          "Action that allows to scroll down in the hover widget with the up arrow when the hover widget is focused."
        ]
      }, "Scroll Down Hover"),
      alias: "Scroll Down Hover",
      precondition: $.hoverFocused,
      kbOpts: {
        kbExpr: $.hoverFocused,
        primary: 18,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = Ho.get(t);
    n && n.scrollDown();
  }
}
class U$e extends Je {
  constructor() {
    super({
      id: "editor.action.scrollLeftHover",
      label: C({
        key: "scrollLeftHover",
        comment: [
          "Action that allows to scroll left in the hover widget with the left arrow when the hover widget is focused."
        ]
      }, "Scroll Left Hover"),
      alias: "Scroll Left Hover",
      precondition: $.hoverFocused,
      kbOpts: {
        kbExpr: $.hoverFocused,
        primary: 15,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = Ho.get(t);
    n && n.scrollLeft();
  }
}
class G$e extends Je {
  constructor() {
    super({
      id: "editor.action.scrollRightHover",
      label: C({
        key: "scrollRightHover",
        comment: [
          "Action that allows to scroll right in the hover widget with the right arrow when the hover widget is focused."
        ]
      }, "Scroll Right Hover"),
      alias: "Scroll Right Hover",
      precondition: $.hoverFocused,
      kbOpts: {
        kbExpr: $.hoverFocused,
        primary: 17,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = Ho.get(t);
    n && n.scrollRight();
  }
}
class q$e extends Je {
  constructor() {
    super({
      id: "editor.action.pageUpHover",
      label: C({
        key: "pageUpHover",
        comment: [
          "Action that allows to page up in the hover widget with the page up command when the hover widget is focused."
        ]
      }, "Page Up Hover"),
      alias: "Page Up Hover",
      precondition: $.hoverFocused,
      kbOpts: {
        kbExpr: $.hoverFocused,
        primary: 11,
        secondary: [
          528
          /* KeyCode.UpArrow */
        ],
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = Ho.get(t);
    n && n.pageUp();
  }
}
class K$e extends Je {
  constructor() {
    super({
      id: "editor.action.pageDownHover",
      label: C({
        key: "pageDownHover",
        comment: [
          "Action that allows to page down in the hover widget with the page down command when the hover widget is focused."
        ]
      }, "Page Down Hover"),
      alias: "Page Down Hover",
      precondition: $.hoverFocused,
      kbOpts: {
        kbExpr: $.hoverFocused,
        primary: 12,
        secondary: [
          530
          /* KeyCode.DownArrow */
        ],
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = Ho.get(t);
    n && n.pageDown();
  }
}
class Y$e extends Je {
  constructor() {
    super({
      id: "editor.action.goToTopHover",
      label: C({
        key: "goToTopHover",
        comment: [
          "Action that allows to go to the top of the hover widget with the home command when the hover widget is focused."
        ]
      }, "Go To Top Hover"),
      alias: "Go To Bottom Hover",
      precondition: $.hoverFocused,
      kbOpts: {
        kbExpr: $.hoverFocused,
        primary: 14,
        secondary: [
          2064
          /* KeyCode.UpArrow */
        ],
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = Ho.get(t);
    n && n.goToTop();
  }
}
class X$e extends Je {
  constructor() {
    super({
      id: "editor.action.goToBottomHover",
      label: C({
        key: "goToBottomHover",
        comment: [
          "Action that allows to go to the bottom in the hover widget with the end command when the hover widget is focused."
        ]
      }, "Go To Bottom Hover"),
      alias: "Go To Bottom Hover",
      precondition: $.hoverFocused,
      kbOpts: {
        kbExpr: $.hoverFocused,
        primary: 13,
        secondary: [
          2066
          /* KeyCode.DownArrow */
        ],
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = Ho.get(t);
    n && n.goToBottom();
  }
}
pn(
  Ho.ID,
  Ho,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
Be(H$e);
Be(W$e);
Be(j$e);
Be(z$e);
Be(U$e);
Be(G$e);
Be(q$e);
Be(K$e);
Be(Y$e);
Be(X$e);
K0.register(CI);
K0.register(QV);
fc((i, e) => {
  const t = i.getColor(BMe);
  t && (e.addRule(`.monaco-editor .monaco-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid ${t.transparent(0.5)}; }`), e.addRule(`.monaco-editor .monaco-hover hr { border-top: 1px solid ${t.transparent(0.5)}; }`), e.addRule(`.monaco-editor .monaco-hover hr { border-bottom: 0px solid ${t.transparent(0.5)}; }`));
});
class nH extends we {
  constructor(e) {
    super(), this._editor = e, this._register(e.onMouseDown((t) => this.onMouseDown(t)));
  }
  dispose() {
    super.dispose();
  }
  onMouseDown(e) {
    const t = this._editor.getOption(
      146
      /* EditorOption.colorDecoratorsActivatedOn */
    );
    if (t !== "click" && t !== "clickAndHover")
      return;
    const n = e.target;
    if (n.type !== 6 || !n.detail.injectedText || n.detail.injectedText.options.attachedData !== T0e || !n.range)
      return;
    const r = this._editor.getContribution(Ho.ID);
    if (r && !r.isColorPickerVisible) {
      const s = new V(n.range.startLineNumber, n.range.startColumn + 1, n.range.endLineNumber, n.range.endColumn + 1);
      r.showContentHover(s, 1, 0, !1, !0);
    }
  }
}
nH.ID = "editor.contrib.colorContribution";
pn(
  nH.ID,
  nH,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
K0.register(pI);
var l1e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Rc = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, F$ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, iH, rH;
let $g = iH = class extends we {
  constructor(e, t, n, r, s, o, a) {
    super(), this._editor = e, this._modelService = n, this._keybindingService = r, this._instantiationService = s, this._languageFeatureService = o, this._languageConfigurationService = a, this._standaloneColorPickerWidget = null, this._standaloneColorPickerVisible = $.standaloneColorPickerVisible.bindTo(t), this._standaloneColorPickerFocused = $.standaloneColorPickerFocused.bindTo(t);
  }
  showOrFocus() {
    var e;
    this._editor.hasModel() && (this._standaloneColorPickerVisible.get() ? this._standaloneColorPickerFocused.get() || (e = this._standaloneColorPickerWidget) === null || e === void 0 || e.focus() : this._standaloneColorPickerWidget = new wI(this._editor, this._standaloneColorPickerVisible, this._standaloneColorPickerFocused, this._instantiationService, this._modelService, this._keybindingService, this._languageFeatureService, this._languageConfigurationService));
  }
  hide() {
    var e;
    this._standaloneColorPickerFocused.set(!1), this._standaloneColorPickerVisible.set(!1), (e = this._standaloneColorPickerWidget) === null || e === void 0 || e.hide(), this._editor.focus();
  }
  insertColor() {
    var e;
    (e = this._standaloneColorPickerWidget) === null || e === void 0 || e.updateEditor(), this.hide();
  }
  static get(e) {
    return e.getContribution(iH.ID);
  }
};
$g.ID = "editor.contrib.standaloneColorPickerController";
$g = iH = l1e([
  Rc(1, yt),
  Rc(2, fi),
  Rc(3, Bn),
  Rc(4, bt),
  Rc(5, tt),
  Rc(6, Un)
], $g);
pn(
  $g.ID,
  $g,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
const B$ = 8, Z$e = 22;
let wI = rH = class extends we {
  constructor(e, t, n, r, s, o, a, l) {
    var c;
    super(), this._editor = e, this._standaloneColorPickerVisible = t, this._standaloneColorPickerFocused = n, this._modelService = s, this._keybindingService = o, this._languageFeaturesService = a, this._languageConfigurationService = l, this.allowEditorOverflow = !0, this._position = void 0, this._body = document.createElement("div"), this._colorHover = null, this._selectionSetInEditor = !1, this._onResult = this._register(new pe()), this.onResult = this._onResult.event, this._standaloneColorPickerVisible.set(!0), this._standaloneColorPickerParticipant = r.createInstance(xw, this._editor), this._position = (c = this._editor._getViewModel()) === null || c === void 0 ? void 0 : c.getPrimaryCursorState().modelState.position;
    const d = this._editor.getSelection(), u = d ? {
      startLineNumber: d.startLineNumber,
      startColumn: d.startColumn,
      endLineNumber: d.endLineNumber,
      endColumn: d.endColumn
    } : { startLineNumber: 0, endLineNumber: 0, endColumn: 0, startColumn: 0 }, h = this._register(yu(this._body));
    this._register(h.onDidBlur((f) => {
      this.hide();
    })), this._register(h.onDidFocus((f) => {
      this.focus();
    })), this._register(this._editor.onDidChangeCursorPosition(() => {
      this._selectionSetInEditor ? this._selectionSetInEditor = !1 : this.hide();
    })), this._register(this._editor.onMouseMove((f) => {
      var g;
      const p = (g = f.target.element) === null || g === void 0 ? void 0 : g.classList;
      p && p.contains("colorpicker-color-decoration") && this.hide();
    })), this._register(this.onResult((f) => {
      this._render(f.value, f.foundInEditor);
    })), this._start(u), this._body.style.zIndex = "50", this._editor.addContentWidget(this);
  }
  updateEditor() {
    this._colorHover && this._standaloneColorPickerParticipant.updateEditorModel(this._colorHover);
  }
  getId() {
    return rH.ID;
  }
  getDomNode() {
    return this._body;
  }
  getPosition() {
    if (!this._position)
      return null;
    const e = this._editor.getOption(
      60
      /* EditorOption.hover */
    ).above;
    return {
      position: this._position,
      secondaryPosition: this._position,
      preference: e ? [
        1,
        2
        /* ContentWidgetPositionPreference.BELOW */
      ] : [
        2,
        1
        /* ContentWidgetPositionPreference.ABOVE */
      ],
      positionAffinity: 2
      /* PositionAffinity.None */
    };
  }
  hide() {
    this.dispose(), this._standaloneColorPickerVisible.set(!1), this._standaloneColorPickerFocused.set(!1), this._editor.removeContentWidget(this), this._editor.focus();
  }
  focus() {
    this._standaloneColorPickerFocused.set(!0), this._body.focus();
  }
  _start(e) {
    return F$(this, void 0, void 0, function* () {
      const t = yield this._computeAsync(e);
      t && this._onResult.fire(new Q$e(t.result, t.foundInEditor));
    });
  }
  _computeAsync(e) {
    return F$(this, void 0, void 0, function* () {
      if (!this._editor.hasModel())
        return null;
      const t = {
        range: e,
        color: { red: 0, green: 0, blue: 0, alpha: 1 }
      }, n = yield this._standaloneColorPickerParticipant.createColorHover(t, new iG(this._modelService, this._languageConfigurationService), this._languageFeaturesService.colorProvider);
      return n ? { result: n.colorHover, foundInEditor: n.foundInEditor } : null;
    });
  }
  _render(e, t) {
    const n = document.createDocumentFragment(), r = this._register(new _I(this._keybindingService));
    let s;
    const o = {
      fragment: n,
      statusBar: r,
      setColorPicker: (p) => s = p,
      onContentsChanged: () => {
      },
      hide: () => this.hide()
    };
    if (this._colorHover = e, this._register(this._standaloneColorPickerParticipant.renderHoverParts(o, [e])), s === void 0)
      return;
    this._body.classList.add("standalone-colorpicker-body"), this._body.style.maxHeight = Math.max(this._editor.getLayoutInfo().height / 4, 250) + "px", this._body.style.maxWidth = Math.max(this._editor.getLayoutInfo().width * 0.66, 500) + "px", this._body.tabIndex = 0, this._body.appendChild(n), s.layout();
    const a = s.body, l = a.saturationBox.domNode.clientWidth, c = a.domNode.clientWidth - l - Z$e - B$, d = s.body.enterButton;
    d?.onClicked(() => {
      this.updateEditor(), this.hide();
    });
    const u = s.header, h = u.pickedColorNode;
    h.style.width = l + B$ + "px";
    const f = u.originalColorNode;
    f.style.width = c + "px";
    const g = s.header.closeButton;
    g?.onClicked(() => {
      this.hide();
    }), t && (d && (d.button.textContent = "Replace"), this._selectionSetInEditor = !0, this._editor.setSelection(e.range)), this._editor.layoutContentWidget(this);
  }
};
wI.ID = "editor.contrib.standaloneColorPickerWidget";
wI = rH = l1e([
  Rc(3, bt),
  Rc(4, fi),
  Rc(5, Bn),
  Rc(6, tt),
  Rc(7, Un)
], wI);
class Q$e {
  // The color picker result consists of: an array of color results and a boolean indicating if the color was found in the editor
  constructor(e, t) {
    this.value = e, this.foundInEditor = t;
  }
}
class J$e extends vd {
  constructor() {
    super({
      id: "editor.action.showOrFocusStandaloneColorPicker",
      title: {
        value: C("showOrFocusStandaloneColorPicker", "Show or Focus Standalone Color Picker"),
        mnemonicTitle: C({ key: "mishowOrFocusStandaloneColorPicker", comment: ["&& denotes a mnemonic"] }, "&&Show or Focus Standalone Color Picker"),
        original: "Show or Focus Standalone Color Picker"
      },
      precondition: void 0,
      menu: [
        { id: J.CommandPalette }
      ]
    });
  }
  runEditorCommand(e, t) {
    var n;
    (n = $g.get(t)) === null || n === void 0 || n.showOrFocus();
  }
}
class $$e extends Je {
  constructor() {
    super({
      id: "editor.action.hideColorPicker",
      label: C({
        key: "hideColorPicker",
        comment: [
          "Action that hides the color picker"
        ]
      }, "Hide the Color Picker"),
      alias: "Hide the Color Picker",
      precondition: $.standaloneColorPickerVisible.isEqualTo(!0),
      kbOpts: {
        primary: 9,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    var n;
    (n = $g.get(t)) === null || n === void 0 || n.hide();
  }
}
class eet extends Je {
  constructor() {
    super({
      id: "editor.action.insertColorWithStandaloneColorPicker",
      label: C({
        key: "insertColorWithStandaloneColorPicker",
        comment: [
          "Action that inserts color with standalone color picker"
        ]
      }, "Insert Color with Standalone Color Picker"),
      alias: "Insert Color with Standalone Color Picker",
      precondition: $.standaloneColorPickerFocused.isEqualTo(!0),
      kbOpts: {
        primary: 3,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    var n;
    (n = $g.get(t)) === null || n === void 0 || n.insertColor();
  }
}
Be($$e);
Be(eet);
oi(J$e);
class ag {
  constructor(e, t, n) {
    this.languageConfigurationService = n, this._selection = e, this._insertSpace = t, this._usedEndToken = null;
  }
  static _haystackHasNeedleAtOffset(e, t, n) {
    if (n < 0)
      return !1;
    const r = t.length, s = e.length;
    if (n + r > s)
      return !1;
    for (let o = 0; o < r; o++) {
      const a = e.charCodeAt(n + o), l = t.charCodeAt(o);
      if (a !== l && !(a >= 65 && a <= 90 && a + 32 === l) && !(l >= 65 && l <= 90 && l + 32 === a))
        return !1;
    }
    return !0;
  }
  _createOperationsForBlockComment(e, t, n, r, s, o) {
    const a = e.startLineNumber, l = e.startColumn, c = e.endLineNumber, d = e.endColumn, u = s.getLineContent(a), h = s.getLineContent(c);
    let f = u.lastIndexOf(t, l - 1 + t.length), g = h.indexOf(n, d - 1 - n.length);
    if (f !== -1 && g !== -1)
      if (a === c)
        u.substring(f + t.length, g).indexOf(n) >= 0 && (f = -1, g = -1);
      else {
        const m = u.substring(f + t.length), _ = h.substring(0, g);
        (m.indexOf(n) >= 0 || _.indexOf(n) >= 0) && (f = -1, g = -1);
      }
    let p;
    f !== -1 && g !== -1 ? (r && f + t.length < u.length && u.charCodeAt(f + t.length) === 32 && (t = t + " "), r && g > 0 && h.charCodeAt(g - 1) === 32 && (n = " " + n, g -= 1), p = ag._createRemoveBlockCommentOperations(new V(a, f + t.length + 1, c, g + 1), t, n)) : (p = ag._createAddBlockCommentOperations(e, t, n, this._insertSpace), this._usedEndToken = p.length === 1 ? n : null);
    for (const m of p)
      o.addTrackedEditOperation(m.range, m.text);
  }
  static _createRemoveBlockCommentOperations(e, t, n) {
    const r = [];
    return V.isEmpty(e) ? r.push(Si.delete(new V(e.startLineNumber, e.startColumn - t.length, e.endLineNumber, e.endColumn + n.length))) : (r.push(Si.delete(new V(e.startLineNumber, e.startColumn - t.length, e.startLineNumber, e.startColumn))), r.push(Si.delete(new V(e.endLineNumber, e.endColumn, e.endLineNumber, e.endColumn + n.length)))), r;
  }
  static _createAddBlockCommentOperations(e, t, n, r) {
    const s = [];
    return V.isEmpty(e) ? s.push(Si.replace(new V(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn), t + "  " + n)) : (s.push(Si.insert(new ve(e.startLineNumber, e.startColumn), t + (r ? " " : ""))), s.push(Si.insert(new ve(e.endLineNumber, e.endColumn), (r ? " " : "") + n))), s;
  }
  getEditOperations(e, t) {
    const n = this._selection.startLineNumber, r = this._selection.startColumn;
    e.tokenization.tokenizeIfCheap(n);
    const s = e.getLanguageIdAtPosition(n, r), o = this.languageConfigurationService.getLanguageConfiguration(s).comments;
    !o || !o.blockCommentStartToken || !o.blockCommentEndToken || this._createOperationsForBlockComment(this._selection, o.blockCommentStartToken, o.blockCommentEndToken, this._insertSpace, e, t);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations();
    if (n.length === 2) {
      const r = n[0], s = n[1];
      return new ot(r.range.endLineNumber, r.range.endColumn, s.range.startLineNumber, s.range.startColumn);
    } else {
      const r = n[0].range, s = this._usedEndToken ? -this._usedEndToken.length - 1 : 0;
      return new ot(r.endLineNumber, r.endColumn + s, r.endLineNumber, r.endColumn + s);
    }
  }
}
class oh {
  constructor(e, t, n, r, s, o, a) {
    this.languageConfigurationService = e, this._selection = t, this._tabSize = n, this._type = r, this._insertSpace = s, this._selectionId = null, this._deltaColumn = 0, this._moveEndPositionDown = !1, this._ignoreEmptyLines = o, this._ignoreFirstLine = a || !1;
  }
  /**
   * Do an initial pass over the lines and gather info about the line comment string.
   * Returns null if any of the lines doesn't support a line comment string.
   */
  static _gatherPreflightCommentStrings(e, t, n, r) {
    e.tokenization.tokenizeIfCheap(t);
    const s = e.getLanguageIdAtPosition(t, 1), o = r.getLanguageConfiguration(s).comments, a = o ? o.lineCommentToken : null;
    if (!a)
      return null;
    const l = [];
    for (let c = 0, d = n - t + 1; c < d; c++)
      l[c] = {
        ignore: !1,
        commentStr: a,
        commentStrOffset: 0,
        commentStrLength: a.length
      };
    return l;
  }
  /**
   * Analyze lines and decide which lines are relevant and what the toggle should do.
   * Also, build up several offsets and lengths useful in the generation of editor operations.
   */
  static _analyzeLines(e, t, n, r, s, o, a, l) {
    let c = !0, d;
    e === 0 ? d = !0 : e === 1 ? d = !1 : d = !0;
    for (let u = 0, h = r.length; u < h; u++) {
      const f = r[u], g = s + u;
      if (g === s && a) {
        f.ignore = !0;
        continue;
      }
      const p = n.getLineContent(g), m = Js(p);
      if (m === -1) {
        f.ignore = o, f.commentStrOffset = p.length;
        continue;
      }
      if (c = !1, f.ignore = !1, f.commentStrOffset = m, d && !ag._haystackHasNeedleAtOffset(p, f.commentStr, m) && (e === 0 ? d = !1 : e === 1 || (f.ignore = !0)), d && t) {
        const _ = m + f.commentStrLength;
        _ < p.length && p.charCodeAt(_) === 32 && (f.commentStrLength += 1);
      }
    }
    if (e === 0 && c) {
      d = !1;
      for (let u = 0, h = r.length; u < h; u++)
        r[u].ignore = !1;
    }
    return {
      supported: !0,
      shouldRemoveComments: d,
      lines: r
    };
  }
  /**
   * Analyze all lines and decide exactly what to do => not supported | insert line comments | remove line comments
   */
  static _gatherPreflightData(e, t, n, r, s, o, a, l) {
    const c = oh._gatherPreflightCommentStrings(n, r, s, l);
    return c === null ? {
      supported: !1
    } : oh._analyzeLines(e, t, n, c, r, o, a, l);
  }
  /**
   * Given a successful analysis, execute either insert line comments, either remove line comments
   */
  _executeLineComments(e, t, n, r) {
    let s;
    n.shouldRemoveComments ? s = oh._createRemoveLineCommentsOperations(n.lines, r.startLineNumber) : (oh._normalizeInsertionPoint(e, n.lines, r.startLineNumber, this._tabSize), s = this._createAddLineCommentsOperations(n.lines, r.startLineNumber));
    const o = new ve(r.positionLineNumber, r.positionColumn);
    for (let a = 0, l = s.length; a < l; a++)
      t.addEditOperation(s[a].range, s[a].text), V.isEmpty(s[a].range) && V.getStartPosition(s[a].range).equals(o) && e.getLineContent(o.lineNumber).length + 1 === o.column && (this._deltaColumn = (s[a].text || "").length);
    this._selectionId = t.trackSelection(r);
  }
  _attemptRemoveBlockComment(e, t, n, r) {
    let s = t.startLineNumber, o = t.endLineNumber;
    const a = r.length + Math.max(e.getLineFirstNonWhitespaceColumn(t.startLineNumber), t.startColumn);
    let l = e.getLineContent(s).lastIndexOf(n, a - 1), c = e.getLineContent(o).indexOf(r, t.endColumn - 1 - n.length);
    return l !== -1 && c === -1 && (c = e.getLineContent(s).indexOf(r, l + n.length), o = s), l === -1 && c !== -1 && (l = e.getLineContent(o).lastIndexOf(n, c), s = o), t.isEmpty() && (l === -1 || c === -1) && (l = e.getLineContent(s).indexOf(n), l !== -1 && (c = e.getLineContent(s).indexOf(r, l + n.length))), l !== -1 && e.getLineContent(s).charCodeAt(l + n.length) === 32 && (n += " "), c !== -1 && e.getLineContent(o).charCodeAt(c - 1) === 32 && (r = " " + r, c -= 1), l !== -1 && c !== -1 ? ag._createRemoveBlockCommentOperations(new V(s, l + n.length + 1, o, c + 1), n, r) : null;
  }
  /**
   * Given an unsuccessful analysis, delegate to the block comment command
   */
  _executeBlockComment(e, t, n) {
    e.tokenization.tokenizeIfCheap(n.startLineNumber);
    const r = e.getLanguageIdAtPosition(n.startLineNumber, 1), s = this.languageConfigurationService.getLanguageConfiguration(r).comments;
    if (!s || !s.blockCommentStartToken || !s.blockCommentEndToken)
      return;
    const o = s.blockCommentStartToken, a = s.blockCommentEndToken;
    let l = this._attemptRemoveBlockComment(e, n, o, a);
    if (!l) {
      if (n.isEmpty()) {
        const c = e.getLineContent(n.startLineNumber);
        let d = Js(c);
        d === -1 && (d = c.length), l = ag._createAddBlockCommentOperations(new V(n.startLineNumber, d + 1, n.startLineNumber, c.length + 1), o, a, this._insertSpace);
      } else
        l = ag._createAddBlockCommentOperations(new V(n.startLineNumber, e.getLineFirstNonWhitespaceColumn(n.startLineNumber), n.endLineNumber, e.getLineMaxColumn(n.endLineNumber)), o, a, this._insertSpace);
      l.length === 1 && (this._deltaColumn = o.length + 1);
    }
    this._selectionId = t.trackSelection(n);
    for (const c of l)
      t.addEditOperation(c.range, c.text);
  }
  getEditOperations(e, t) {
    let n = this._selection;
    if (this._moveEndPositionDown = !1, n.startLineNumber === n.endLineNumber && this._ignoreFirstLine) {
      t.addEditOperation(new V(n.startLineNumber, e.getLineMaxColumn(n.startLineNumber), n.startLineNumber + 1, 1), n.startLineNumber === e.getLineCount() ? "" : `
`), this._selectionId = t.trackSelection(n);
      return;
    }
    n.startLineNumber < n.endLineNumber && n.endColumn === 1 && (this._moveEndPositionDown = !0, n = n.setEndPosition(n.endLineNumber - 1, e.getLineMaxColumn(n.endLineNumber - 1)));
    const r = oh._gatherPreflightData(this._type, this._insertSpace, e, n.startLineNumber, n.endLineNumber, this._ignoreEmptyLines, this._ignoreFirstLine, this.languageConfigurationService);
    return r.supported ? this._executeLineComments(e, t, r, n) : this._executeBlockComment(e, t, n);
  }
  computeCursorState(e, t) {
    let n = t.getTrackedSelection(this._selectionId);
    return this._moveEndPositionDown && (n = n.setEndPosition(n.endLineNumber + 1, 1)), new ot(n.selectionStartLineNumber, n.selectionStartColumn + this._deltaColumn, n.positionLineNumber, n.positionColumn + this._deltaColumn);
  }
  /**
   * Generate edit operations in the remove line comment case
   */
  static _createRemoveLineCommentsOperations(e, t) {
    const n = [];
    for (let r = 0, s = e.length; r < s; r++) {
      const o = e[r];
      o.ignore || n.push(Si.delete(new V(t + r, o.commentStrOffset + 1, t + r, o.commentStrOffset + o.commentStrLength + 1)));
    }
    return n;
  }
  /**
   * Generate edit operations in the add line comment case
   */
  _createAddLineCommentsOperations(e, t) {
    const n = [], r = this._insertSpace ? " " : "";
    for (let s = 0, o = e.length; s < o; s++) {
      const a = e[s];
      a.ignore || n.push(Si.insert(new ve(t + s, a.commentStrOffset + 1), a.commentStr + r));
    }
    return n;
  }
  static nextVisibleColumn(e, t, n, r) {
    return n ? e + (t - e % t) : e + r;
  }
  /**
   * Adjust insertion points to have them vertically aligned in the add line comment case
   */
  static _normalizeInsertionPoint(e, t, n, r) {
    let s = 1073741824, o, a;
    for (let l = 0, c = t.length; l < c; l++) {
      if (t[l].ignore)
        continue;
      const d = e.getLineContent(n + l);
      let u = 0;
      for (let h = 0, f = t[l].commentStrOffset; u < s && h < f; h++)
        u = oh.nextVisibleColumn(u, r, d.charCodeAt(h) === 9, 1);
      u < s && (s = u);
    }
    s = Math.floor(s / r) * r;
    for (let l = 0, c = t.length; l < c; l++) {
      if (t[l].ignore)
        continue;
      const d = e.getLineContent(n + l);
      let u = 0;
      for (o = 0, a = t[l].commentStrOffset; u < s && o < a; o++)
        u = oh.nextVisibleColumn(u, r, d.charCodeAt(o) === 9, 1);
      u > s ? t[l].commentStrOffset = o - 1 : t[l].commentStrOffset = o;
    }
  }
}
class hG extends Je {
  constructor(e, t) {
    super(t), this._type = e;
  }
  run(e, t) {
    const n = e.get(Un);
    if (!t.hasModel())
      return;
    const r = t.getModel(), s = [], o = r.getOptions(), a = t.getOption(
      23
      /* EditorOption.comments */
    ), l = t.getSelections().map((d, u) => ({ selection: d, index: u, ignoreFirstLine: !1 }));
    l.sort((d, u) => V.compareRangesUsingStarts(d.selection, u.selection));
    let c = l[0];
    for (let d = 1; d < l.length; d++) {
      const u = l[d];
      c.selection.endLineNumber === u.selection.startLineNumber && (c.index < u.index ? u.ignoreFirstLine = !0 : (c.ignoreFirstLine = !0, c = u));
    }
    for (const d of l)
      s.push(new oh(n, d.selection, o.tabSize, this._type, a.insertSpace, a.ignoreEmptyLines, d.ignoreFirstLine));
    t.pushUndoStop(), t.executeCommands(this.id, s), t.pushUndoStop();
  }
}
class tet extends hG {
  constructor() {
    super(0, {
      id: "editor.action.commentLine",
      label: C("comment.line", "Toggle Line Comment"),
      alias: "Toggle Line Comment",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 2138,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarEditMenu,
        group: "5_insert",
        title: C({ key: "miToggleLineComment", comment: ["&& denotes a mnemonic"] }, "&&Toggle Line Comment"),
        order: 1
      }
    });
  }
}
class net extends hG {
  constructor() {
    super(1, {
      id: "editor.action.addCommentLine",
      label: C("comment.line.add", "Add Line Comment"),
      alias: "Add Line Comment",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2081
          /* KeyCode.KeyC */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class iet extends hG {
  constructor() {
    super(2, {
      id: "editor.action.removeCommentLine",
      label: C("comment.line.remove", "Remove Line Comment"),
      alias: "Remove Line Comment",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2099
          /* KeyCode.KeyU */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class ret extends Je {
  constructor() {
    super({
      id: "editor.action.blockComment",
      label: C("comment.block", "Toggle Block Comment"),
      alias: "Toggle Block Comment",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 1567,
        linux: {
          primary: 3103
          /* KeyCode.KeyA */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarEditMenu,
        group: "5_insert",
        title: C({ key: "miToggleBlockComment", comment: ["&& denotes a mnemonic"] }, "Toggle &&Block Comment"),
        order: 2
      }
    });
  }
  run(e, t) {
    const n = e.get(Un);
    if (!t.hasModel())
      return;
    const r = t.getOption(
      23
      /* EditorOption.comments */
    ), s = [], o = t.getSelections();
    for (const a of o)
      s.push(new ag(a, r.insertSpace, n));
    t.pushUndoStop(), t.executeCommands(this.id, s), t.pushUndoStop();
  }
}
Be(tet);
Be(net);
Be(iet);
Be(ret);
var set = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Ip = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, sH;
let j_ = sH = class {
  static get(e) {
    return e.getContribution(sH.ID);
  }
  constructor(e, t, n, r, s, o, a, l) {
    this._contextMenuService = t, this._contextViewService = n, this._contextKeyService = r, this._keybindingService = s, this._menuService = o, this._configurationService = a, this._workspaceContextService = l, this._toDispose = new Ne(), this._contextMenuIsBeingShownCount = 0, this._editor = e, this._toDispose.add(this._editor.onContextMenu((c) => this._onContextMenu(c))), this._toDispose.add(this._editor.onMouseWheel((c) => {
      if (this._contextMenuIsBeingShownCount > 0) {
        const d = this._contextViewService.getContextViewElement(), u = c.srcElement;
        u.shadowRoot && Ym(d) === u.shadowRoot || this._contextViewService.hideContextView();
      }
    })), this._toDispose.add(this._editor.onKeyDown((c) => {
      this._editor.getOption(
        24
        /* EditorOption.contextmenu */
      ) && c.keyCode === 58 && (c.preventDefault(), c.stopPropagation(), this.showContextMenu());
    }));
  }
  _onContextMenu(e) {
    if (!this._editor.hasModel())
      return;
    if (!this._editor.getOption(
      24
      /* EditorOption.contextmenu */
    )) {
      this._editor.focus(), e.target.position && !this._editor.getSelection().containsPosition(e.target.position) && this._editor.setPosition(e.target.position);
      return;
    }
    if (e.target.type === 12 || e.target.type === 6 && e.target.detail.injectedText)
      return;
    if (e.event.preventDefault(), e.event.stopPropagation(), e.target.type === 11)
      return this._showScrollbarContextMenu(e.event);
    if (e.target.type !== 6 && e.target.type !== 7 && e.target.type !== 1)
      return;
    if (this._editor.focus(), e.target.position) {
      let n = !1;
      for (const r of this._editor.getSelections())
        if (r.containsPosition(e.target.position)) {
          n = !0;
          break;
        }
      n || this._editor.setPosition(e.target.position);
    }
    let t = null;
    e.target.type !== 1 && (t = e.event), this.showContextMenu(t);
  }
  showContextMenu(e) {
    if (!this._editor.getOption(
      24
      /* EditorOption.contextmenu */
    ) || !this._editor.hasModel())
      return;
    const t = this._getMenuActions(this._editor.getModel(), this._editor.isSimpleWidget ? J.SimpleEditorContext : J.EditorContext);
    t.length > 0 && this._doShowContextMenu(t, e);
  }
  _getMenuActions(e, t) {
    const n = [], r = this._menuService.createMenu(t, this._contextKeyService), s = r.getActions({ arg: e.uri });
    r.dispose();
    for (const o of s) {
      const [, a] = o;
      let l = 0;
      for (const c of a)
        if (c instanceof Ay) {
          const d = this._getMenuActions(e, c.item.submenu);
          d.length > 0 && (n.push(new g_(c.id, c.label, d)), l++);
        } else
          n.push(c), l++;
      l && n.push(new Gr());
    }
    return n.length && n.pop(), n;
  }
  _doShowContextMenu(e, t = null) {
    if (!this._editor.hasModel())
      return;
    const n = this._editor.getOption(
      60
      /* EditorOption.hover */
    );
    this._editor.updateOptions({
      hover: {
        enabled: !1
      }
    });
    let r = t;
    if (!r) {
      this._editor.revealPosition(
        this._editor.getPosition(),
        1
        /* ScrollType.Immediate */
      ), this._editor.render();
      const o = this._editor.getScrolledVisiblePosition(this._editor.getPosition()), a = wr(this._editor.getDomNode()), l = a.left + o.left, c = a.top + o.top + o.height;
      r = { x: l, y: c };
    }
    const s = this._editor.getOption(
      126
      /* EditorOption.useShadowDOM */
    ) && !od;
    this._contextMenuIsBeingShownCount++, this._contextMenuService.showContextMenu({
      domForShadowRoot: s ? this._editor.getDomNode() : void 0,
      getAnchor: () => r,
      getActions: () => e,
      getActionViewItem: (o) => {
        const a = this._keybindingFor(o);
        if (a)
          return new N_(o, o, { label: !0, keybinding: a.getLabel(), isMenu: !0 });
        const l = o;
        return typeof l.getActionViewItem == "function" ? l.getActionViewItem() : new N_(o, o, { icon: !0, label: !0, isMenu: !0 });
      },
      getKeyBinding: (o) => this._keybindingFor(o),
      onHide: (o) => {
        this._contextMenuIsBeingShownCount--, this._editor.updateOptions({
          hover: n
        });
      }
    });
  }
  _showScrollbarContextMenu(e) {
    if (!this._editor.hasModel() || rje(this._workspaceContextService.getWorkspace()))
      return;
    const t = this._editor.getOption(
      72
      /* EditorOption.minimap */
    );
    let n = 0;
    const r = (c) => ({
      id: `menu-action-${++n}`,
      label: c.label,
      tooltip: "",
      class: void 0,
      enabled: typeof c.enabled > "u" ? !0 : c.enabled,
      checked: c.checked,
      run: c.run
    }), s = (c, d) => new g_(`menu-action-${++n}`, c, d, void 0), o = (c, d, u, h, f) => {
      if (!d)
        return r({ label: c, enabled: d, run: () => {
        } });
      const g = (m) => () => {
        this._configurationService.updateValue(u, m);
      }, p = [];
      for (const m of f)
        p.push(r({
          label: m.label,
          checked: h === m.value,
          run: g(m.value)
        }));
      return s(c, p);
    }, a = [];
    a.push(r({
      label: C("context.minimap.minimap", "Minimap"),
      checked: t.enabled,
      run: () => {
        this._configurationService.updateValue("editor.minimap.enabled", !t.enabled);
      }
    })), a.push(new Gr()), a.push(r({
      label: C("context.minimap.renderCharacters", "Render Characters"),
      enabled: t.enabled,
      checked: t.renderCharacters,
      run: () => {
        this._configurationService.updateValue("editor.minimap.renderCharacters", !t.renderCharacters);
      }
    })), a.push(o(C("context.minimap.size", "Vertical size"), t.enabled, "editor.minimap.size", t.size, [{
      label: C("context.minimap.size.proportional", "Proportional"),
      value: "proportional"
    }, {
      label: C("context.minimap.size.fill", "Fill"),
      value: "fill"
    }, {
      label: C("context.minimap.size.fit", "Fit"),
      value: "fit"
    }])), a.push(o(C("context.minimap.slider", "Slider"), t.enabled, "editor.minimap.showSlider", t.showSlider, [{
      label: C("context.minimap.slider.mouseover", "Mouse Over"),
      value: "mouseover"
    }, {
      label: C("context.minimap.slider.always", "Always"),
      value: "always"
    }]));
    const l = this._editor.getOption(
      126
      /* EditorOption.useShadowDOM */
    ) && !od;
    this._contextMenuIsBeingShownCount++, this._contextMenuService.showContextMenu({
      domForShadowRoot: l ? this._editor.getDomNode() : void 0,
      getAnchor: () => e,
      getActions: () => a,
      onHide: (c) => {
        this._contextMenuIsBeingShownCount--, this._editor.focus();
      }
    });
  }
  _keybindingFor(e) {
    return this._keybindingService.lookupKeybinding(e.id);
  }
  dispose() {
    this._contextMenuIsBeingShownCount > 0 && this._contextViewService.hideContextView(), this._toDispose.dispose();
  }
};
j_.ID = "editor.contrib.contextmenu";
j_ = sH = set([
  Ip(1, gc),
  Ip(2, cf),
  Ip(3, yt),
  Ip(4, Bn),
  Ip(5, Ou),
  Ip(6, en),
  Ip(7, Qm)
], j_);
class oet extends Je {
  constructor() {
    super({
      id: "editor.action.showContextMenu",
      label: C("action.showContextMenu.label", "Show Editor Context Menu"),
      alias: "Show Editor Context Menu",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 1092,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    var n;
    (n = j_.get(t)) === null || n === void 0 || n.showContextMenu();
  }
}
pn(
  j_.ID,
  j_,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
Be(oet);
class TT {
  constructor(e) {
    this.selections = e;
  }
  equals(e) {
    const t = this.selections.length, n = e.selections.length;
    if (t !== n)
      return !1;
    for (let r = 0; r < t; r++)
      if (!this.selections[r].equalsSelection(e.selections[r]))
        return !1;
    return !0;
  }
}
class NT {
  constructor(e, t, n) {
    this.cursorState = e, this.scrollTop = t, this.scrollLeft = n;
  }
}
class d0 extends we {
  static get(e) {
    return e.getContribution(d0.ID);
  }
  constructor(e) {
    super(), this._editor = e, this._isCursorUndoRedo = !1, this._undoStack = [], this._redoStack = [], this._register(e.onDidChangeModel((t) => {
      this._undoStack = [], this._redoStack = [];
    })), this._register(e.onDidChangeModelContent((t) => {
      this._undoStack = [], this._redoStack = [];
    })), this._register(e.onDidChangeCursorSelection((t) => {
      if (this._isCursorUndoRedo || !t.oldSelections || t.oldModelVersionId !== t.modelVersionId)
        return;
      const n = new TT(t.oldSelections);
      this._undoStack.length > 0 && this._undoStack[this._undoStack.length - 1].cursorState.equals(n) || (this._undoStack.push(new NT(n, e.getScrollTop(), e.getScrollLeft())), this._redoStack = [], this._undoStack.length > 50 && this._undoStack.shift());
    }));
  }
  cursorUndo() {
    !this._editor.hasModel() || this._undoStack.length === 0 || (this._redoStack.push(new NT(new TT(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft())), this._applyState(this._undoStack.pop()));
  }
  cursorRedo() {
    !this._editor.hasModel() || this._redoStack.length === 0 || (this._undoStack.push(new NT(new TT(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft())), this._applyState(this._redoStack.pop()));
  }
  _applyState(e) {
    this._isCursorUndoRedo = !0, this._editor.setSelections(e.cursorState.selections), this._editor.setScrollPosition({
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), this._isCursorUndoRedo = !1;
  }
}
d0.ID = "editor.contrib.cursorUndoRedoController";
class aet extends Je {
  constructor() {
    super({
      id: "cursorUndo",
      label: C("cursor.undo", "Cursor Undo"),
      alias: "Cursor Undo",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 2099,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t, n) {
    var r;
    (r = d0.get(t)) === null || r === void 0 || r.cursorUndo();
  }
}
class cet extends Je {
  constructor() {
    super({
      id: "cursorRedo",
      label: C("cursor.redo", "Cursor Redo"),
      alias: "Cursor Redo",
      precondition: void 0
    });
  }
  run(e, t, n) {
    var r;
    (r = d0.get(t)) === null || r === void 0 || r.cursorRedo();
  }
}
pn(
  d0.ID,
  d0,
  0
  /* EditorContributionInstantiation.Eager */
);
Be(aet);
Be(cet);
class det {
  constructor(e, t, n) {
    this.selection = e, this.targetPosition = t, this.copy = n, this.targetSelection = null;
  }
  getEditOperations(e, t) {
    const n = e.getValueInRange(this.selection);
    if (this.copy || t.addEditOperation(this.selection, null), t.addEditOperation(new V(this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column), n), this.selection.containsPosition(this.targetPosition) && !(this.copy && (this.selection.getEndPosition().equals(this.targetPosition) || this.selection.getStartPosition().equals(this.targetPosition)))) {
      this.targetSelection = this.selection;
      return;
    }
    if (this.copy) {
      this.targetSelection = new ot(this.targetPosition.lineNumber, this.targetPosition.column, this.selection.endLineNumber - this.selection.startLineNumber + this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn);
      return;
    }
    if (this.targetPosition.lineNumber > this.selection.endLineNumber) {
      this.targetSelection = new ot(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn);
      return;
    }
    if (this.targetPosition.lineNumber < this.selection.endLineNumber) {
      this.targetSelection = new ot(this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber + this.selection.endLineNumber - this.selection.startLineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn);
      return;
    }
    this.selection.endColumn <= this.targetPosition.column ? this.targetSelection = new ot(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column - this.selection.endColumn + this.selection.startColumn : this.targetPosition.column - this.selection.endColumn + this.selection.startColumn, this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column : this.selection.endColumn) : this.targetSelection = new ot(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column + this.selection.endColumn - this.selection.startColumn);
  }
  computeCursorState(e, t) {
    return this.targetSelection;
  }
}
function y1(i) {
  return sn ? i.altKey : i.ctrlKey;
}
class zh extends we {
  constructor(e) {
    super(), this._editor = e, this._dndDecorationIds = this._editor.createDecorationsCollection(), this._register(this._editor.onMouseDown((t) => this._onEditorMouseDown(t))), this._register(this._editor.onMouseUp((t) => this._onEditorMouseUp(t))), this._register(this._editor.onMouseDrag((t) => this._onEditorMouseDrag(t))), this._register(this._editor.onMouseDrop((t) => this._onEditorMouseDrop(t))), this._register(this._editor.onMouseDropCanceled(() => this._onEditorMouseDropCanceled())), this._register(this._editor.onKeyDown((t) => this.onEditorKeyDown(t))), this._register(this._editor.onKeyUp((t) => this.onEditorKeyUp(t))), this._register(this._editor.onDidBlurEditorWidget(() => this.onEditorBlur())), this._register(this._editor.onDidBlurEditorText(() => this.onEditorBlur())), this._mouseDown = !1, this._modifierPressed = !1, this._dragSelection = null;
  }
  onEditorBlur() {
    this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1, this._modifierPressed = !1;
  }
  onEditorKeyDown(e) {
    !this._editor.getOption(
      35
      /* EditorOption.dragAndDrop */
    ) || this._editor.getOption(
      22
      /* EditorOption.columnSelection */
    ) || (y1(e) && (this._modifierPressed = !0), this._mouseDown && y1(e) && this._editor.updateOptions({
      mouseStyle: "copy"
    }));
  }
  onEditorKeyUp(e) {
    !this._editor.getOption(
      35
      /* EditorOption.dragAndDrop */
    ) || this._editor.getOption(
      22
      /* EditorOption.columnSelection */
    ) || (y1(e) && (this._modifierPressed = !1), this._mouseDown && e.keyCode === zh.TRIGGER_KEY_VALUE && this._editor.updateOptions({
      mouseStyle: "default"
    }));
  }
  _onEditorMouseDown(e) {
    this._mouseDown = !0;
  }
  _onEditorMouseUp(e) {
    this._mouseDown = !1, this._editor.updateOptions({
      mouseStyle: "text"
    });
  }
  _onEditorMouseDrag(e) {
    const t = e.target;
    if (this._dragSelection === null) {
      const r = (this._editor.getSelections() || []).filter((s) => t.position && s.containsPosition(t.position));
      if (r.length === 1)
        this._dragSelection = r[0];
      else
        return;
    }
    y1(e.event) ? this._editor.updateOptions({
      mouseStyle: "copy"
    }) : this._editor.updateOptions({
      mouseStyle: "default"
    }), t.position && (this._dragSelection.containsPosition(t.position) ? this._removeDecoration() : this.showAt(t.position));
  }
  _onEditorMouseDropCanceled() {
    this._editor.updateOptions({
      mouseStyle: "text"
    }), this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1;
  }
  _onEditorMouseDrop(e) {
    if (e.target && (this._hitContent(e.target) || this._hitMargin(e.target)) && e.target.position) {
      const t = new ve(e.target.position.lineNumber, e.target.position.column);
      if (this._dragSelection === null) {
        let n = null;
        if (e.event.shiftKey) {
          const r = this._editor.getSelection();
          if (r) {
            const { selectionStartLineNumber: s, selectionStartColumn: o } = r;
            n = [new ot(s, o, t.lineNumber, t.column)];
          }
        } else
          n = (this._editor.getSelections() || []).map((r) => r.containsPosition(t) ? new ot(t.lineNumber, t.column, t.lineNumber, t.column) : r);
        this._editor.setSelections(
          n || [],
          "mouse",
          3
          /* CursorChangeReason.Explicit */
        );
      } else (!this._dragSelection.containsPosition(t) || (y1(e.event) || this._modifierPressed) && (this._dragSelection.getEndPosition().equals(t) || this._dragSelection.getStartPosition().equals(t))) && (this._editor.pushUndoStop(), this._editor.executeCommand(zh.ID, new det(this._dragSelection, t, y1(e.event) || this._modifierPressed)), this._editor.pushUndoStop());
    }
    this._editor.updateOptions({
      mouseStyle: "text"
    }), this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1;
  }
  showAt(e) {
    this._dndDecorationIds.set([{
      range: new V(e.lineNumber, e.column, e.lineNumber, e.column),
      options: zh._DECORATION_OPTIONS
    }]), this._editor.revealPosition(
      e,
      1
      /* ScrollType.Immediate */
    );
  }
  _removeDecoration() {
    this._dndDecorationIds.clear();
  }
  _hitContent(e) {
    return e.type === 6 || e.type === 7;
  }
  _hitMargin(e) {
    return e.type === 2 || e.type === 3 || e.type === 4;
  }
  dispose() {
    this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1, this._modifierPressed = !1, super.dispose();
  }
}
zh.ID = "editor.contrib.dragAndDrop";
zh.TRIGGER_KEY_VALUE = sn ? 6 : 5;
zh._DECORATION_OPTIONS = Lt.register({
  description: "dnd-target",
  className: "dnd-target"
});
pn(
  zh.ID,
  zh,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
const C5 = function() {
  if (typeof crypto == "object" && typeof crypto.randomUUID == "function")
    return crypto.randomUUID.bind(crypto);
  let i;
  typeof crypto == "object" && typeof crypto.getRandomValues == "function" ? i = crypto.getRandomValues.bind(crypto) : i = function(n) {
    for (let r = 0; r < n.length; r++)
      n[r] = Math.floor(Math.random() * 256);
    return n;
  };
  const e = new Uint8Array(16), t = [];
  for (let n = 0; n < 256; n++)
    t.push(n.toString(16).padStart(2, "0"));
  return function() {
    i(e), e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
    let r = 0, s = "";
    return s += t[e[r++]], s += t[e[r++]], s += t[e[r++]], s += t[e[r++]], s += "-", s += t[e[r++]], s += t[e[r++]], s += "-", s += t[e[r++]], s += t[e[r++]], s += "-", s += t[e[r++]], s += t[e[r++]], s += "-", s += t[e[r++]], s += t[e[r++]], s += t[e[r++]], s += t[e[r++]], s += t[e[r++]], s += t[e[r++]], s;
  };
}();
var c1e = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function fG(i) {
  return {
    asString: () => c1e(this, void 0, void 0, function* () {
      return i;
    }),
    asFile: () => {
    },
    value: typeof i == "string" ? i : void 0
  };
}
function uet(i, e, t) {
  const n = { id: C5(), name: i, uri: e, data: t };
  return {
    asString: () => c1e(this, void 0, void 0, function* () {
      return "";
    }),
    asFile: () => n,
    value: void 0
  };
}
class d1e {
  constructor() {
    this._entries = /* @__PURE__ */ new Map();
  }
  get size() {
    let e = 0;
    for (const t of this._entries)
      e++;
    return e;
  }
  has(e) {
    return this._entries.has(this.toKey(e));
  }
  matches(e) {
    const t = [...this._entries.keys()];
    return Wt.some(this, ([n, r]) => r.asFile()) && t.push("files"), h1e(SI(e), t);
  }
  get(e) {
    var t;
    return (t = this._entries.get(this.toKey(e))) === null || t === void 0 ? void 0 : t[0];
  }
  /**
   * Add a new entry to this data transfer.
   *
   * This does not replace existing entries for `mimeType`.
   */
  append(e, t) {
    const n = this._entries.get(e);
    n ? n.push(t) : this._entries.set(this.toKey(e), [t]);
  }
  /**
   * Set the entry for a given mime type.
   *
   * This replaces all existing entries for `mimeType`.
   */
  replace(e, t) {
    this._entries.set(this.toKey(e), [t]);
  }
  /**
   * Remove all entries for `mimeType`.
   */
  delete(e) {
    this._entries.delete(this.toKey(e));
  }
  /**
   * Iterate over all `[mime, item]` pairs in this data transfer.
   *
   * There may be multiple entries for each mime type.
   */
  *[Symbol.iterator]() {
    for (const [e, t] of this._entries)
      for (const n of t)
        yield [e, n];
  }
  toKey(e) {
    return SI(e);
  }
}
function SI(i) {
  return i.toLowerCase();
}
function u1e(i, e) {
  return h1e(SI(i), e.map(SI));
}
function h1e(i, e) {
  if (i === "*/*")
    return e.length > 0;
  if (e.includes(i))
    return !0;
  const t = i.match(/^([a-z]+)\/([a-z]+|\*)$/i);
  if (!t)
    return !1;
  const [n, r, s] = t;
  return s === "*" ? e.some((o) => o.startsWith(r + "/")) : !1;
}
const y5 = Object.freeze({
  // http://amundsen.com/hypermedia/urilist/
  create: (i) => kg(i.map((e) => e.toString())).join(`\r
`),
  split: (i) => i.split(`\r
`),
  parse: (i) => y5.split(i).filter((e) => !e.startsWith("#"))
}), V$ = {
  EDITORS: "CodeEditors",
  FILES: "CodeFiles"
};
class het {
}
const fet = {
  DragAndDropContribution: "workbench.contributions.dragAndDrop"
};
Di.add(fet.DragAndDropContribution, new het());
class Aw {
  constructor() {
  }
  static getInstance() {
    return Aw.INSTANCE;
  }
  hasData(e) {
    return e && e === this.proto;
  }
  getData(e) {
    if (this.hasData(e))
      return this.data;
  }
}
Aw.INSTANCE = new Aw();
var get = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function f1e(i) {
  const e = new d1e();
  for (const t of i.items) {
    const n = t.type;
    if (t.kind === "string") {
      const r = new Promise((s) => t.getAsString(s));
      e.append(n, fG(r));
    } else if (t.kind === "file") {
      const r = t.getAsFile();
      r && e.append(n, pet(r));
    }
  }
  return e;
}
function pet(i) {
  const e = i.path ? pt.parse(i.path) : void 0;
  return uet(i.name, e, () => get(this, void 0, void 0, function* () {
    return new Uint8Array(yield i.arrayBuffer());
  }));
}
const met = Object.freeze([
  V$.EDITORS,
  V$.FILES,
  aw.RESOURCES,
  aw.INTERNAL_URI_LIST
]);
function g1e(i, e = !1) {
  const t = f1e(i), n = t.get(aw.INTERNAL_URI_LIST);
  if (n)
    t.replace(Zi.uriList, n);
  else if (e || !t.has(Zi.uriList)) {
    const r = [];
    for (const s of i.items) {
      const o = s.getAsFile();
      if (o) {
        const a = o.path;
        try {
          a ? r.push(pt.file(a).toString()) : r.push(pt.parse(o.name, !0).toString());
        } catch {
        }
      }
    }
    r.length && t.replace(Zi.uriList, fG(y5.create(r)));
  }
  for (const r of met)
    t.delete(r);
  return t;
}
function vet(i, e, t) {
  var n, r;
  return {
    edits: [
      ...e.map((s) => new Vh(i, typeof t.insertText == "string" ? { range: s, text: t.insertText, insertAsSnippet: !1 } : { range: s, text: t.insertText.snippet, insertAsSnippet: !0 })),
      ...(r = (n = t.additionalEdit) === null || n === void 0 ? void 0 : n.edits) !== null && r !== void 0 ? r : []
    ]
  };
}
function p1e(i) {
  var e;
  function t(a, l) {
    return "providerId" in a && a.providerId === l.providerId || "mimeType" in a && a.mimeType === l.handledMimeType;
  }
  const n = /* @__PURE__ */ new Map();
  for (const a of i)
    for (const l of (e = a.yieldTo) !== null && e !== void 0 ? e : [])
      for (const c of i)
        if (c !== a && t(l, c)) {
          let d = n.get(a);
          d || (d = [], n.set(a, d)), d.push(c);
        }
  if (!n.size)
    return Array.from(i);
  const r = /* @__PURE__ */ new Set(), s = [];
  function o(a) {
    if (!a.length)
      return [];
    const l = a[0];
    if (s.includes(l))
      return console.warn(`Yield to cycle detected for ${l.providerId}`), a;
    if (r.has(l))
      return o(a.slice(1));
    let c = [];
    const d = n.get(l);
    return d && (s.push(l), c = o(d), s.pop()), r.add(l), [...c, l, ...o(a.slice(1))];
  }
  return o(Array.from(i));
}
var _et = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, bet = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Cet = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const yet = Lt.register({
  description: "inline-progress-widget",
  stickiness: 1,
  showIfCollapsed: !0,
  after: {
    content: vhe,
    inlineClassName: "inline-editor-progress-decoration",
    inlineClassNameAffectsLetterSpacing: !0
  }
});
class w5 extends we {
  constructor(e, t, n, r, s) {
    super(), this.typeId = e, this.editor = t, this.range = n, this.delegate = s, this.allowEditorOverflow = !1, this.suppressMouseDown = !0, this.create(r), this.editor.addContentWidget(this), this.editor.layoutContentWidget(this);
  }
  create(e) {
    this.domNode = Re(".inline-progress-widget"), this.domNode.role = "button", this.domNode.title = e;
    const t = Re("span.icon");
    this.domNode.append(t), t.classList.add(...ft.asClassNameArray(We.loading), "codicon-modifier-spin");
    const n = () => {
      const r = this.editor.getOption(
        66
        /* EditorOption.lineHeight */
      );
      this.domNode.style.height = `${r}px`, this.domNode.style.width = `${Math.ceil(0.8 * r)}px`;
    };
    n(), this._register(this.editor.onDidChangeConfiguration((r) => {
      (r.hasChanged(
        52
        /* EditorOption.fontSize */
      ) || r.hasChanged(
        66
        /* EditorOption.lineHeight */
      )) && n();
    })), this._register(Ie(this.domNode, Ge.CLICK, (r) => {
      this.delegate.cancel();
    }));
  }
  getId() {
    return w5.baseId + "." + this.typeId;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return {
      position: { lineNumber: this.range.startLineNumber, column: this.range.startColumn },
      preference: [
        0
        /* ContentWidgetPositionPreference.EXACT */
      ]
    };
  }
  dispose() {
    super.dispose(), this.editor.removeContentWidget(this);
  }
}
w5.baseId = "editor.widget.inlineProgressWidget";
let xI = class extends we {
  constructor(e, t, n) {
    super(), this.id = e, this._editor = t, this._instantiationService = n, this._showDelay = 500, this._showPromise = this._register(new ds()), this._currentWidget = new ds(), this._operationIdPool = 0, this._currentDecorations = t.createDecorationsCollection();
  }
  showWhile(e, t, n) {
    return Cet(this, void 0, void 0, function* () {
      const r = this._operationIdPool++;
      this._currentOperation = r, this.clear(), this._showPromise.value = Rg(() => {
        const s = V.fromPositions(e);
        this._currentDecorations.set([{
          range: s,
          options: yet
        }]).length > 0 && (this._currentWidget.value = this._instantiationService.createInstance(w5, this.id, this._editor, s, t, n));
      }, this._showDelay);
      try {
        return yield n;
      } finally {
        this._currentOperation === r && (this.clear(), this._currentOperation = void 0);
      }
    });
  }
  clear() {
    this._showPromise.clear(), this._currentDecorations.clear(), this._currentWidget.clear();
  }
};
xI = _et([
  bet(2, bt)
], xI);
var m1e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, UC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, H$ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, oH;
let DI = oH = class extends we {
  constructor(e, t, n, r, s, o, a, l, c, d) {
    super(), this.typeId = e, this.editor = t, this.showCommand = r, this.range = s, this.edits = o, this.onSelectNewEdit = a, this._contextMenuService = l, this._keybindingService = d, this.allowEditorOverflow = !0, this.suppressMouseDown = !0, this.create(), this.visibleContext = n.bindTo(c), this.visibleContext.set(!0), this._register(Ct(() => this.visibleContext.reset())), this.editor.addContentWidget(this), this.editor.layoutContentWidget(this), this._register(Ct(() => this.editor.removeContentWidget(this))), this._register(this.editor.onDidChangeCursorPosition((u) => {
      s.containsPosition(u.position) || this.dispose();
    })), this._register(qe.runAndSubscribe(d.onDidUpdateKeybindings, () => {
      this._updateButtonTitle();
    }));
  }
  _updateButtonTitle() {
    var e;
    const t = (e = this._keybindingService.lookupKeybinding(this.showCommand.id)) === null || e === void 0 ? void 0 : e.getLabel();
    this.button.element.title = this.showCommand.label + (t ? ` (${t})` : "");
  }
  create() {
    this.domNode = Re(".post-edit-widget"), this.button = this._register(new zB(this.domNode, {
      supportIcons: !0
    })), this.button.label = "$(insert)", this._register(Ie(this.domNode, Ge.CLICK, () => this.showSelector()));
  }
  getId() {
    return oH.baseId + "." + this.typeId;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return {
      position: this.range.getEndPosition(),
      preference: [
        2
        /* ContentWidgetPositionPreference.BELOW */
      ]
    };
  }
  showSelector() {
    this._contextMenuService.showContextMenu({
      getAnchor: () => {
        const e = wr(this.button.element);
        return { x: e.left + e.width, y: e.top + e.height };
      },
      getActions: () => this.edits.allEdits.map((e, t) => Iv({
        id: "",
        label: e.label,
        checked: t === this.edits.activeEditIndex,
        run: () => {
          if (t !== this.edits.activeEditIndex)
            return this.onSelectNewEdit(t);
        }
      }))
    });
  }
};
DI.baseId = "editor.widget.postEditWidget";
DI = oH = m1e([
  UC(7, gc),
  UC(8, yt),
  UC(9, Bn)
], DI);
let EI = class extends we {
  constructor(e, t, n, r, s, o) {
    super(), this._id = e, this._editor = t, this._visibleContext = n, this._showCommand = r, this._instantiationService = s, this._bulkEditService = o, this._currentWidget = this._register(new ds()), this._register(qe.any(t.onDidChangeModel, t.onDidChangeModelContent)(() => this.clear()));
  }
  applyEditAndShowIfNeeded(e, t, n, r) {
    var s, o;
    return H$(this, void 0, void 0, function* () {
      const a = this._editor.getModel();
      if (!a || !e.length)
        return;
      const l = t.allEdits[t.activeEditIndex];
      if (!l)
        return;
      let c = [];
      (typeof l.insertText == "string" ? l.insertText === "" : l.insertText.snippet === "") ? c = [] : c = e.map((m) => new Vh(a.uri, typeof l.insertText == "string" ? { range: m, text: l.insertText, insertAsSnippet: !1 } : { range: m, text: l.insertText.snippet, insertAsSnippet: !0 }));
      const u = {
        edits: [
          ...c,
          ...(o = (s = l.additionalEdit) === null || s === void 0 ? void 0 : s.edits) !== null && o !== void 0 ? o : []
        ]
      }, h = e[0], f = a.deltaDecorations([], [{
        range: h,
        options: {
          description: "paste-line-suffix",
          stickiness: 0
          /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */
        }
      }]);
      let g, p;
      try {
        g = yield this._bulkEditService.apply(u, { editor: this._editor, token: r }), p = a.getDecorationRange(f[0]);
      } finally {
        a.deltaDecorations(f, []);
      }
      n && g.isApplied && t.allEdits.length > 1 && this.show(p ?? h, t, (m) => H$(this, void 0, void 0, function* () {
        const _ = this._editor.getModel();
        _ && (yield _.undo(), this.applyEditAndShowIfNeeded(e, { activeEditIndex: m, allEdits: t.allEdits }, n, r));
      }));
    });
  }
  show(e, t, n) {
    this.clear(), this._editor.hasModel() && (this._currentWidget.value = this._instantiationService.createInstance(DI, this._id, this._editor, this._visibleContext, this._showCommand, e, t, n));
  }
  clear() {
    this._currentWidget.clear();
  }
  tryShowSelector() {
    var e;
    (e = this._currentWidget.value) === null || e === void 0 || e.showSelector();
  }
};
EI = m1e([
  UC(4, bt),
  UC(5, FS)
], EI);
var wet = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, w1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Yu = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, aH;
const v1e = "editor.changePasteType", _1e = new Ke("pasteWidgetVisible", !1, C("pasteWidgetVisible", "Whether the paste widget is showing")), PT = "application/vnd.code.copyMetadata";
let u0 = aH = class extends we {
  static get(e) {
    return e.getContribution(aH.ID);
  }
  constructor(e, t, n, r, s, o, a) {
    super(), this._bulkEditService = n, this._clipboardService = r, this._languageFeaturesService = s, this._quickInputService = o, this._progressService = a, this._editor = e;
    const l = e.getContainerDomNode();
    this._register(Ie(l, "copy", (c) => this.handleCopy(c))), this._register(Ie(l, "cut", (c) => this.handleCopy(c))), this._register(Ie(l, "paste", (c) => this.handlePaste(c), !0)), this._pasteProgressManager = this._register(new xI("pasteIntoEditor", e, t)), this._postPasteWidgetManager = this._register(t.createInstance(EI, "pasteIntoEditor", e, _1e, { id: v1e, label: C("postPasteWidgetTitle", "Show paste options...") }));
  }
  changePasteType() {
    this._postPasteWidgetManager.tryShowSelector();
  }
  pasteAs(e) {
    this._editor.focus();
    try {
      this._pasteAsActionContext = { preferredId: e }, t4().execCommand("paste");
    } finally {
      this._pasteAsActionContext = void 0;
    }
  }
  isPasteAsEnabled() {
    return this._editor.getOption(
      84
      /* EditorOption.pasteAs */
    ).enabled && !this._editor.getOption(
      90
      /* EditorOption.readOnly */
    );
  }
  handleCopy(e) {
    var t, n;
    if (!this._editor.hasTextFocus() || (sp && this._clipboardService.writeResources([]), !e.clipboardData || !this.isPasteAsEnabled()))
      return;
    const r = this._editor.getModel(), s = this._editor.getSelections();
    if (!r || !s?.length)
      return;
    const o = this._editor.getOption(
      37
      /* EditorOption.emptySelectionClipboard */
    );
    let a = s;
    const l = s.length === 1 && s[0].isEmpty();
    if (l) {
      if (!o)
        return;
      a = [new V(a[0].startLineNumber, 1, a[0].startLineNumber, 1 + r.getLineLength(a[0].startLineNumber))];
    }
    const c = (t = this._editor._getViewModel()) === null || t === void 0 ? void 0 : t.getPlainTextToCopy(s, o, Ls), u = {
      multicursorText: Array.isArray(c) ? c : null,
      pasteOnNewLine: l,
      mode: null
    }, h = this._languageFeaturesService.documentPasteEditProvider.ordered(r).filter((_) => !!_.prepareDocumentPaste);
    if (!h.length) {
      this.setCopyMetadata(e.clipboardData, { defaultPastePayload: u });
      return;
    }
    const f = f1e(e.clipboardData), g = h.flatMap((_) => {
      var b;
      return (b = _.copyMimeTypes) !== null && b !== void 0 ? b : [];
    }), p = C5();
    this.setCopyMetadata(e.clipboardData, {
      id: p,
      providerCopyMimeTypes: g,
      defaultPastePayload: u
    });
    const m = Ir((_) => Yu(this, void 0, void 0, function* () {
      const b = _u(yield Promise.all(h.map((w) => Yu(this, void 0, void 0, function* () {
        try {
          return yield w.prepareDocumentPaste(r, a, f, _);
        } catch (y) {
          console.error(y);
          return;
        }
      }))));
      b.reverse();
      for (const w of b)
        for (const [y, S] of w)
          f.replace(y, S);
      return f;
    }));
    (n = this._currentCopyOperation) === null || n === void 0 || n.dataTransferPromise.cancel(), this._currentCopyOperation = { handle: p, dataTransferPromise: m };
  }
  handlePaste(e) {
    var t, n;
    return Yu(this, void 0, void 0, function* () {
      if (!e.clipboardData || !this._editor.hasTextFocus())
        return;
      (t = this._currentPasteOperation) === null || t === void 0 || t.cancel(), this._currentPasteOperation = void 0;
      const r = this._editor.getModel(), s = this._editor.getSelections();
      if (!s?.length || !r || !this.isPasteAsEnabled())
        return;
      const o = this.fetchCopyMetadata(e), a = g1e(e.clipboardData);
      a.delete(PT);
      const l = [
        ...e.clipboardData.types,
        ...(n = o?.providerCopyMimeTypes) !== null && n !== void 0 ? n : [],
        // TODO: always adds `uri-list` because this get set if there are resources in the system clipboard.
        // However we can only check the system clipboard async. For this early check, just add it in.
        // We filter providers again once we have the final dataTransfer we will use.
        Zi.uriList
      ], c = this._languageFeaturesService.documentPasteEditProvider.ordered(r).filter((d) => {
        var u;
        return (u = d.pasteMimeTypes) === null || u === void 0 ? void 0 : u.some((h) => u1e(h, l));
      });
      c.length && (e.preventDefault(), e.stopImmediatePropagation(), this._pasteAsActionContext ? this.showPasteAsPick(this._pasteAsActionContext.preferredId, c, s, a, o) : this.doPasteInline(c, s, a, o));
    });
  }
  doPasteInline(e, t, n, r) {
    const s = Ir((o) => Yu(this, void 0, void 0, function* () {
      const a = this._editor;
      if (!a.hasModel())
        return;
      const l = a.getModel(), c = new Gg(a, 3, void 0, o);
      try {
        if (yield this.mergeInDataFromCopy(n, r, c.token), c.token.isCancellationRequested)
          return;
        const d = e.filter((h) => W$(h, n));
        if (!d.length || d.length === 1 && d[0].id === "text") {
          yield this.applyDefaultPasteHandler(n, r, c.token);
          return;
        }
        const u = yield this.getPasteEdits(d, n, l, t, c.token);
        if (c.token.isCancellationRequested)
          return;
        if (u.length === 1 && u[0].providerId === "text") {
          yield this.applyDefaultPasteHandler(n, r, c.token);
          return;
        }
        if (u.length) {
          const h = a.getOption(
            84
            /* EditorOption.pasteAs */
          ).showPasteSelector === "afterPaste";
          return this._postPasteWidgetManager.applyEditAndShowIfNeeded(t, { activeEditIndex: 0, allEdits: u }, h, c.token);
        }
        yield this.applyDefaultPasteHandler(n, r, c.token);
      } finally {
        c.dispose(), this._currentPasteOperation === s && (this._currentPasteOperation = void 0);
      }
    }));
    this._pasteProgressManager.showWhile(t[0].getEndPosition(), C("pasteIntoEditorProgress", "Running paste handlers. Click to cancel"), s), this._currentPasteOperation = s;
  }
  showPasteAsPick(e, t, n, r, s) {
    const o = Ir((a) => Yu(this, void 0, void 0, function* () {
      const l = this._editor;
      if (!l.hasModel())
        return;
      const c = l.getModel(), d = new Gg(l, 3, void 0, a);
      try {
        if (yield this.mergeInDataFromCopy(r, s, d.token), d.token.isCancellationRequested)
          return;
        let u = t.filter((p) => W$(p, r));
        e && (u = u.filter((p) => p.id === e));
        const h = yield this.getPasteEdits(u, r, c, n, d.token);
        if (d.token.isCancellationRequested || !h.length)
          return;
        let f;
        if (e)
          f = h.at(0);
        else {
          const p = yield this._quickInputService.pick(h.map((m) => ({
            label: m.label,
            description: m.providerId,
            detail: m.detail,
            edit: m
          })), {
            placeHolder: C("pasteAsPickerPlaceholder", "Select Paste Action")
          });
          f = p?.edit;
        }
        if (!f)
          return;
        const g = vet(c.uri, n, f);
        yield this._bulkEditService.apply(g, { editor: this._editor });
      } finally {
        d.dispose(), this._currentPasteOperation === o && (this._currentPasteOperation = void 0);
      }
    }));
    this._progressService.withProgress({
      location: 10,
      title: C("pasteAsProgress", "Running paste handlers")
    }, () => o);
  }
  setCopyMetadata(e, t) {
    e.setData(PT, JSON.stringify(t));
  }
  fetchCopyMetadata(e) {
    var t;
    if (!e.clipboardData)
      return;
    const n = e.clipboardData.getData(PT);
    if (n)
      try {
        return JSON.parse(n);
      } catch {
        return;
      }
    const [r, s] = NF.getTextData(e.clipboardData);
    if (s)
      return {
        defaultPastePayload: {
          mode: s.mode,
          multicursorText: (t = s.multicursorText) !== null && t !== void 0 ? t : null,
          pasteOnNewLine: !!s.isFromEmptySelection
        }
      };
  }
  mergeInDataFromCopy(e, t, n) {
    var r;
    return Yu(this, void 0, void 0, function* () {
      if (t?.id && ((r = this._currentCopyOperation) === null || r === void 0 ? void 0 : r.handle) === t.id) {
        const s = yield this._currentCopyOperation.dataTransferPromise;
        if (n.isCancellationRequested)
          return;
        for (const [o, a] of s)
          e.replace(o, a);
      }
      if (!e.has(Zi.uriList)) {
        const s = yield this._clipboardService.readResources();
        if (n.isCancellationRequested)
          return;
        s.length && e.append(Zi.uriList, fG(y5.create(s)));
      }
    });
  }
  getPasteEdits(e, t, n, r, s) {
    return Yu(this, void 0, void 0, function* () {
      const o = yield i4(Promise.all(e.map((l) => Yu(this, void 0, void 0, function* () {
        var c;
        try {
          const d = yield (c = l.provideDocumentPasteEdits) === null || c === void 0 ? void 0 : c.call(l, n, r, t, s);
          if (d)
            return Object.assign(Object.assign({}, d), { providerId: l.id });
        } catch (d) {
          console.error(d);
        }
      }))), s), a = _u(o ?? []);
      return p1e(a);
    });
  }
  applyDefaultPasteHandler(e, t, n) {
    var r, s, o;
    return Yu(this, void 0, void 0, function* () {
      const a = (r = e.get(Zi.text)) !== null && r !== void 0 ? r : e.get("text");
      if (!a)
        return;
      const l = yield a.asString();
      if (n.isCancellationRequested)
        return;
      const c = {
        text: l,
        pasteOnNewLine: (s = t?.defaultPastePayload.pasteOnNewLine) !== null && s !== void 0 ? s : !1,
        multicursorText: (o = t?.defaultPastePayload.multicursorText) !== null && o !== void 0 ? o : null,
        mode: null
      };
      this._editor.trigger("keyboard", "paste", c);
    });
  }
};
u0.ID = "editor.contrib.copyPasteActionController";
u0 = aH = wet([
  w1(1, bt),
  w1(2, FS),
  w1(3, hf),
  w1(4, tt),
  w1(5, bd),
  w1(6, Zge)
], u0);
function W$(i, e) {
  var t;
  return !!(!((t = i.pasteMimeTypes) === null || t === void 0) && t.some((n) => e.matches(n)));
}
var gG = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, kw = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, z_ = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const pG = C("builtIn", "Built-in");
class mG {
  provideDocumentPasteEdits(e, t, n, r) {
    return z_(this, void 0, void 0, function* () {
      const s = yield this.getEdit(n, r);
      return s ? { insertText: s.insertText, label: s.label, detail: s.detail, handledMimeType: s.handledMimeType, yieldTo: s.yieldTo } : void 0;
    });
  }
  provideDocumentOnDropEdits(e, t, n, r) {
    return z_(this, void 0, void 0, function* () {
      const s = yield this.getEdit(n, r);
      return s ? { insertText: s.insertText, label: s.label, handledMimeType: s.handledMimeType, yieldTo: s.yieldTo } : void 0;
    });
  }
}
class b1e extends mG {
  constructor() {
    super(...arguments), this.id = "text", this.dropMimeTypes = [Zi.text], this.pasteMimeTypes = [Zi.text];
  }
  getEdit(e, t) {
    return z_(this, void 0, void 0, function* () {
      const n = e.get(Zi.text);
      if (!n || e.has(Zi.uriList))
        return;
      const r = yield n.asString();
      return {
        handledMimeType: Zi.text,
        label: C("text.label", "Insert Plain Text"),
        detail: pG,
        insertText: r
      };
    });
  }
}
class C1e extends mG {
  constructor() {
    super(...arguments), this.id = "uri", this.dropMimeTypes = [Zi.uriList], this.pasteMimeTypes = [Zi.uriList];
  }
  getEdit(e, t) {
    return z_(this, void 0, void 0, function* () {
      const n = yield y1e(e);
      if (!n.length || t.isCancellationRequested)
        return;
      let r = 0;
      const s = n.map(({ uri: a, originalText: l }) => a.scheme === Mt.file ? a.fsPath : (r++, l)).join(" ");
      let o;
      return r > 0 ? o = n.length > 1 ? C("defaultDropProvider.uriList.uris", "Insert Uris") : C("defaultDropProvider.uriList.uri", "Insert Uri") : o = n.length > 1 ? C("defaultDropProvider.uriList.paths", "Insert Paths") : C("defaultDropProvider.uriList.path", "Insert Path"), {
        handledMimeType: Zi.uriList,
        insertText: s,
        label: o,
        detail: pG
      };
    });
  }
}
let LI = class extends mG {
  constructor(e) {
    super(), this._workspaceContextService = e, this.id = "relativePath", this.dropMimeTypes = [Zi.uriList], this.pasteMimeTypes = [Zi.uriList];
  }
  getEdit(e, t) {
    return z_(this, void 0, void 0, function* () {
      const n = yield y1e(e);
      if (!n.length || t.isCancellationRequested)
        return;
      const r = _u(n.map(({ uri: s }) => {
        const o = this._workspaceContextService.getWorkspaceFolder(s);
        return o ? KBe(o.uri, s) : void 0;
      }));
      if (r.length)
        return {
          handledMimeType: Zi.uriList,
          insertText: r.join(" "),
          label: n.length > 1 ? C("defaultDropProvider.uriList.relativePaths", "Insert Relative Paths") : C("defaultDropProvider.uriList.relativePath", "Insert Relative Path"),
          detail: pG
        };
    });
  }
};
LI = gG([
  kw(0, Qm)
], LI);
function y1e(i) {
  return z_(this, void 0, void 0, function* () {
    const e = i.get(Zi.uriList);
    if (!e)
      return [];
    const t = yield e.asString(), n = [];
    for (const r of y5.parse(t))
      try {
        n.push({ uri: pt.parse(r), originalText: r });
      } catch {
      }
    return n;
  });
}
let lH = class extends we {
  constructor(e, t) {
    super(), this._register(e.documentOnDropEditProvider.register("*", new b1e())), this._register(e.documentOnDropEditProvider.register("*", new C1e())), this._register(e.documentOnDropEditProvider.register("*", new LI(t)));
  }
};
lH = gG([
  kw(0, tt),
  kw(1, Qm)
], lH);
let cH = class extends we {
  constructor(e, t) {
    super(), this._register(e.documentPasteEditProvider.register("*", new b1e())), this._register(e.documentPasteEditProvider.register("*", new C1e())), this._register(e.documentPasteEditProvider.register("*", new LI(t)));
  }
};
cH = gG([
  kw(0, tt),
  kw(1, Qm)
], cH);
pn(
  u0.ID,
  u0,
  0
  /* EditorContributionInstantiation.Eager */
);
Z4(cH);
ze(new class extends Kr {
  constructor() {
    super({
      id: v1e,
      precondition: _1e,
      kbOpts: {
        weight: 100,
        primary: 2137
      }
    });
  }
  runEditorCommand(i, e, t) {
    var n;
    return (n = u0.get(e)) === null || n === void 0 ? void 0 : n.changePasteType();
  }
}());
Be(class extends Je {
  constructor() {
    super({
      id: "editor.action.pasteAs",
      label: C("pasteAs", "Paste As..."),
      alias: "Paste As...",
      precondition: void 0,
      description: {
        description: "Paste as",
        args: [{
          name: "args",
          schema: {
            type: "object",
            properties: {
              id: {
                type: "string",
                description: C("pasteAs.id", "The id of the paste edit to try applying. If not provided, the editor will show a picker.")
              }
            }
          }
        }]
      }
    });
  }
  run(i, e, t) {
    var n;
    const r = typeof t?.id == "string" ? t.id : void 0;
    return (n = u0.get(e)) === null || n === void 0 ? void 0 : n.pasteAs(r);
  }
});
class xet {
  constructor() {
    this._dragOperations = /* @__PURE__ */ new Map();
  }
  removeDragOperationTransfer(e) {
    if (e && this._dragOperations.has(e)) {
      const t = this._dragOperations.get(e);
      return this._dragOperations.delete(e), t;
    }
  }
}
class j$ {
  constructor(e) {
    this.identifier = e;
  }
}
const w1e = Gt("treeViewsDndService");
an(
  w1e,
  xet,
  1
  /* InstantiationType.Delayed */
);
var Det = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, MD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, C2 = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, dH;
const S1e = "editor.experimental.dropIntoEditor.defaultProvider", x1e = "editor.changeDropType", D1e = new Ke("dropWidgetVisible", !1, C("dropWidgetVisible", "Whether the drop widget is showing"));
let U_ = dH = class extends we {
  static get(e) {
    return e.getContribution(dH.ID);
  }
  constructor(e, t, n, r, s) {
    super(), this._configService = n, this._languageFeaturesService = r, this._treeViewsDragAndDropService = s, this.treeItemsTransfer = Aw.getInstance(), this._dropProgressManager = this._register(t.createInstance(xI, "dropIntoEditor", e)), this._postDropWidgetManager = this._register(t.createInstance(EI, "dropIntoEditor", e, D1e, { id: x1e, label: C("postDropWidgetTitle", "Show drop options...") })), this._register(e.onDropIntoEditor((o) => this.onDropIntoEditor(e, o.position, o.event)));
  }
  changeDropType() {
    this._postDropWidgetManager.tryShowSelector();
  }
  onDropIntoEditor(e, t, n) {
    var r;
    return C2(this, void 0, void 0, function* () {
      if (!n.dataTransfer || !e.hasModel())
        return;
      (r = this._currentOperation) === null || r === void 0 || r.cancel(), e.focus(), e.setPosition(t);
      const s = Ir((o) => C2(this, void 0, void 0, function* () {
        const a = new Gg(e, 1, void 0, o);
        try {
          const l = yield this.extractDataTransferData(n);
          if (l.size === 0 || a.token.isCancellationRequested)
            return;
          const c = e.getModel();
          if (!c)
            return;
          const d = this._languageFeaturesService.documentOnDropEditProvider.ordered(c).filter((h) => h.dropMimeTypes ? h.dropMimeTypes.some((f) => l.matches(f)) : !0), u = yield this.getDropEdits(d, c, t, l, a);
          if (a.token.isCancellationRequested)
            return;
          if (u.length) {
            const h = this.getInitialActiveEditIndex(c, u), f = e.getOption(
              36
              /* EditorOption.dropIntoEditor */
            ).showDropSelector === "afterDrop";
            yield this._postDropWidgetManager.applyEditAndShowIfNeeded([V.fromPositions(t)], { activeEditIndex: h, allEdits: u }, f, o);
          }
        } finally {
          a.dispose(), this._currentOperation === s && (this._currentOperation = void 0);
        }
      }));
      this._dropProgressManager.showWhile(t, C("dropIntoEditorProgress", "Running drop handlers. Click to cancel"), s), this._currentOperation = s;
    });
  }
  getDropEdits(e, t, n, r, s) {
    return C2(this, void 0, void 0, function* () {
      const o = yield i4(Promise.all(e.map((l) => C2(this, void 0, void 0, function* () {
        try {
          const c = yield l.provideDocumentOnDropEdits(t, n, r, s.token);
          if (c)
            return Object.assign(Object.assign({}, c), { providerId: l.id });
        } catch (c) {
          console.error(c);
        }
      }))), s.token), a = _u(o ?? []);
      return p1e(a);
    });
  }
  getInitialActiveEditIndex(e, t) {
    const n = this._configService.getValue(S1e, { resource: e.uri });
    for (const [r, s] of Object.entries(n)) {
      const o = t.findIndex((a) => s === a.providerId && a.handledMimeType && u1e(r, [a.handledMimeType]));
      if (o >= 0)
        return o;
    }
    return 0;
  }
  extractDataTransferData(e) {
    return C2(this, void 0, void 0, function* () {
      if (!e.dataTransfer)
        return new d1e();
      const t = g1e(e.dataTransfer);
      if (this.treeItemsTransfer.hasData(j$.prototype)) {
        const n = this.treeItemsTransfer.getData(j$.prototype);
        if (Array.isArray(n))
          for (const r of n) {
            const s = yield this._treeViewsDragAndDropService.removeDragOperationTransfer(r.identifier);
            if (s)
              for (const [o, a] of s)
                t.replace(o, a);
          }
      }
      return t;
    });
  }
};
U_.ID = "editor.contrib.dropIntoEditorController";
U_ = dH = Det([
  MD(1, bt),
  MD(2, en),
  MD(3, tt),
  MD(4, w1e)
], U_);
pn(
  U_.ID,
  U_,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
ze(new class extends Kr {
  constructor() {
    super({
      id: x1e,
      precondition: D1e,
      kbOpts: {
        weight: 100,
        primary: 2137
      }
    });
  }
  runEditorCommand(i, e, t) {
    var n;
    (n = U_.get(e)) === null || n === void 0 || n.changeDropType();
  }
}());
Z4(lH);
Di.as(_d.Configuration).registerConfiguration(Object.assign(Object.assign({}, k4), { properties: {
  [S1e]: {
    type: "object",
    scope: 5,
    description: C("defaultProviderDescription", "Configures the default drop provider to use for content of a given mime type."),
    default: {},
    additionalProperties: {
      type: "string"
    }
  }
} }));
class Ks {
  constructor(e) {
    this._editor = e, this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null, this._startPosition = this._editor.getPosition();
  }
  dispose() {
    this._editor.removeDecorations(this._allDecorations()), this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null;
  }
  reset() {
    this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null;
  }
  getCount() {
    return this._decorations.length;
  }
  /** @deprecated use getFindScopes to support multiple selections */
  getFindScope() {
    return this._findScopeDecorationIds[0] ? this._editor.getModel().getDecorationRange(this._findScopeDecorationIds[0]) : null;
  }
  getFindScopes() {
    if (this._findScopeDecorationIds.length) {
      const e = this._findScopeDecorationIds.map((t) => this._editor.getModel().getDecorationRange(t)).filter((t) => !!t);
      if (e.length)
        return e;
    }
    return null;
  }
  getStartPosition() {
    return this._startPosition;
  }
  setStartPosition(e) {
    this._startPosition = e, this.setCurrentFindMatch(null);
  }
  _getDecorationIndex(e) {
    const t = this._decorations.indexOf(e);
    return t >= 0 ? t + 1 : 1;
  }
  getDecorationRangeAt(e) {
    const t = e < this._decorations.length ? this._decorations[e] : null;
    return t ? this._editor.getModel().getDecorationRange(t) : null;
  }
  getCurrentMatchesPosition(e) {
    const t = this._editor.getModel().getDecorationsInRange(e);
    for (const n of t) {
      const r = n.options;
      if (r === Ks._FIND_MATCH_DECORATION || r === Ks._CURRENT_FIND_MATCH_DECORATION)
        return this._getDecorationIndex(n.id);
    }
    return 0;
  }
  setCurrentFindMatch(e) {
    let t = null, n = 0;
    if (e)
      for (let r = 0, s = this._decorations.length; r < s; r++) {
        const o = this._editor.getModel().getDecorationRange(this._decorations[r]);
        if (e.equalsRange(o)) {
          t = this._decorations[r], n = r + 1;
          break;
        }
      }
    return (this._highlightedDecorationId !== null || t !== null) && this._editor.changeDecorations((r) => {
      if (this._highlightedDecorationId !== null && (r.changeDecorationOptions(this._highlightedDecorationId, Ks._FIND_MATCH_DECORATION), this._highlightedDecorationId = null), t !== null && (this._highlightedDecorationId = t, r.changeDecorationOptions(this._highlightedDecorationId, Ks._CURRENT_FIND_MATCH_DECORATION)), this._rangeHighlightDecorationId !== null && (r.removeDecoration(this._rangeHighlightDecorationId), this._rangeHighlightDecorationId = null), t !== null) {
        let s = this._editor.getModel().getDecorationRange(t);
        if (s.startLineNumber !== s.endLineNumber && s.endColumn === 1) {
          const o = s.endLineNumber - 1, a = this._editor.getModel().getLineMaxColumn(o);
          s = new V(s.startLineNumber, s.startColumn, o, a);
        }
        this._rangeHighlightDecorationId = r.addDecoration(s, Ks._RANGE_HIGHLIGHT_DECORATION);
      }
    }), n;
  }
  set(e, t) {
    this._editor.changeDecorations((n) => {
      let r = Ks._FIND_MATCH_DECORATION;
      const s = [];
      if (e.length > 1e3) {
        r = Ks._FIND_MATCH_NO_OVERVIEW_DECORATION;
        const a = this._editor.getModel().getLineCount(), c = this._editor.getLayoutInfo().height / a, d = Math.max(2, Math.ceil(3 / c));
        let u = e[0].range.startLineNumber, h = e[0].range.endLineNumber;
        for (let f = 1, g = e.length; f < g; f++) {
          const p = e[f].range;
          h + d >= p.startLineNumber ? p.endLineNumber > h && (h = p.endLineNumber) : (s.push({
            range: new V(u, 1, h, 1),
            options: Ks._FIND_MATCH_ONLY_OVERVIEW_DECORATION
          }), u = p.startLineNumber, h = p.endLineNumber);
        }
        s.push({
          range: new V(u, 1, h, 1),
          options: Ks._FIND_MATCH_ONLY_OVERVIEW_DECORATION
        });
      }
      const o = new Array(e.length);
      for (let a = 0, l = e.length; a < l; a++)
        o[a] = {
          range: e[a].range,
          options: r
        };
      this._decorations = n.deltaDecorations(this._decorations, o), this._overviewRulerApproximateDecorations = n.deltaDecorations(this._overviewRulerApproximateDecorations, s), this._rangeHighlightDecorationId && (n.removeDecoration(this._rangeHighlightDecorationId), this._rangeHighlightDecorationId = null), this._findScopeDecorationIds.length && (this._findScopeDecorationIds.forEach((a) => n.removeDecoration(a)), this._findScopeDecorationIds = []), t?.length && (this._findScopeDecorationIds = t.map((a) => n.addDecoration(a, Ks._FIND_SCOPE_DECORATION)));
    });
  }
  matchBeforePosition(e) {
    if (this._decorations.length === 0)
      return null;
    for (let t = this._decorations.length - 1; t >= 0; t--) {
      const n = this._decorations[t], r = this._editor.getModel().getDecorationRange(n);
      if (!(!r || r.endLineNumber > e.lineNumber)) {
        if (r.endLineNumber < e.lineNumber)
          return r;
        if (!(r.endColumn > e.column))
          return r;
      }
    }
    return this._editor.getModel().getDecorationRange(this._decorations[this._decorations.length - 1]);
  }
  matchAfterPosition(e) {
    if (this._decorations.length === 0)
      return null;
    for (let t = 0, n = this._decorations.length; t < n; t++) {
      const r = this._decorations[t], s = this._editor.getModel().getDecorationRange(r);
      if (!(!s || s.startLineNumber < e.lineNumber)) {
        if (s.startLineNumber > e.lineNumber)
          return s;
        if (!(s.startColumn < e.column))
          return s;
      }
    }
    return this._editor.getModel().getDecorationRange(this._decorations[0]);
  }
  _allDecorations() {
    let e = [];
    return e = e.concat(this._decorations), e = e.concat(this._overviewRulerApproximateDecorations), this._findScopeDecorationIds.length && e.push(...this._findScopeDecorationIds), this._rangeHighlightDecorationId && e.push(this._rangeHighlightDecorationId), e;
  }
}
Ks._CURRENT_FIND_MATCH_DECORATION = Lt.register({
  description: "current-find-match",
  stickiness: 1,
  zIndex: 13,
  className: "currentFindMatch",
  showIfCollapsed: !0,
  overviewRuler: {
    color: Oi(mz),
    position: Ha.Center
  },
  minimap: {
    color: Oi(iv),
    position: ia.Inline
  }
});
Ks._FIND_MATCH_DECORATION = Lt.register({
  description: "find-match",
  stickiness: 1,
  zIndex: 10,
  className: "findMatch",
  showIfCollapsed: !0,
  overviewRuler: {
    color: Oi(mz),
    position: Ha.Center
  },
  minimap: {
    color: Oi(iv),
    position: ia.Inline
  }
});
Ks._FIND_MATCH_NO_OVERVIEW_DECORATION = Lt.register({
  description: "find-match-no-overview",
  stickiness: 1,
  className: "findMatch",
  showIfCollapsed: !0
});
Ks._FIND_MATCH_ONLY_OVERVIEW_DECORATION = Lt.register({
  description: "find-match-only-overview",
  stickiness: 1,
  overviewRuler: {
    color: Oi(mz),
    position: Ha.Center
  }
});
Ks._RANGE_HIGHLIGHT_DECORATION = Lt.register({
  description: "find-range-highlight",
  stickiness: 1,
  className: "rangeHighlight",
  isWholeLine: !0
});
Ks._FIND_SCOPE_DECORATION = Lt.register({
  description: "find-scope",
  className: "findScope",
  isWholeLine: !0
});
class Eet {
  constructor(e, t, n) {
    this._editorSelection = e, this._ranges = t, this._replaceStrings = n, this._trackedEditorSelectionId = null;
  }
  getEditOperations(e, t) {
    if (this._ranges.length > 0) {
      const n = [];
      for (let o = 0; o < this._ranges.length; o++)
        n.push({
          range: this._ranges[o],
          text: this._replaceStrings[o]
        });
      n.sort((o, a) => V.compareRangesUsingStarts(o.range, a.range));
      const r = [];
      let s = n[0];
      for (let o = 1; o < n.length; o++)
        s.range.endLineNumber === n[o].range.startLineNumber && s.range.endColumn === n[o].range.startColumn ? (s.range = s.range.plusRange(n[o].range), s.text = s.text + n[o].text) : (r.push(s), s = n[o]);
      r.push(s);
      for (const o of r)
        t.addEditOperation(o.range, o.text);
    }
    this._trackedEditorSelectionId = t.trackSelection(this._editorSelection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._trackedEditorSelectionId);
  }
}
function E1e(i, e) {
  if (i && i[0] !== "") {
    const t = z$(i, e, "-"), n = z$(i, e, "_");
    return t && !n ? U$(i, e, "-") : !t && n ? U$(i, e, "_") : i[0].toUpperCase() === i[0] ? e.toUpperCase() : i[0].toLowerCase() === i[0] ? e.toLowerCase() : SNe(i[0][0]) && e.length > 0 ? e[0].toUpperCase() + e.substr(1) : i[0][0].toUpperCase() !== i[0][0] && e.length > 0 ? e[0].toLowerCase() + e.substr(1) : e;
  } else
    return e;
}
function z$(i, e, t) {
  return i[0].indexOf(t) !== -1 && e.indexOf(t) !== -1 && i[0].split(t).length === e.split(t).length;
}
function U$(i, e, t) {
  const n = e.split(t), r = i[0].split(t);
  let s = "";
  return n.forEach((o, a) => {
    s += E1e([r[a]], o) + t;
  }), s.slice(0, -1);
}
class G$ {
  constructor(e) {
    this.staticValue = e, this.kind = 0;
  }
}
class Let {
  constructor(e) {
    this.pieces = e, this.kind = 1;
  }
}
class G_ {
  static fromStaticValue(e) {
    return new G_([Pm.staticValue(e)]);
  }
  get hasReplacementPatterns() {
    return this._state.kind === 1;
  }
  constructor(e) {
    !e || e.length === 0 ? this._state = new G$("") : e.length === 1 && e[0].staticValue !== null ? this._state = new G$(e[0].staticValue) : this._state = new Let(e);
  }
  buildReplaceString(e, t) {
    if (this._state.kind === 0)
      return t ? E1e(e, this._state.staticValue) : this._state.staticValue;
    let n = "";
    for (let r = 0, s = this._state.pieces.length; r < s; r++) {
      const o = this._state.pieces[r];
      if (o.staticValue !== null) {
        n += o.staticValue;
        continue;
      }
      let a = G_._substitute(o.matchIndex, e);
      if (o.caseOps !== null && o.caseOps.length > 0) {
        const l = [], c = o.caseOps.length;
        let d = 0;
        for (let u = 0, h = a.length; u < h; u++) {
          if (d >= c) {
            l.push(a.slice(u));
            break;
          }
          switch (o.caseOps[d]) {
            case "U":
              l.push(a[u].toUpperCase());
              break;
            case "u":
              l.push(a[u].toUpperCase()), d++;
              break;
            case "L":
              l.push(a[u].toLowerCase());
              break;
            case "l":
              l.push(a[u].toLowerCase()), d++;
              break;
            default:
              l.push(a[u]);
          }
        }
        a = l.join("");
      }
      n += a;
    }
    return n;
  }
  static _substitute(e, t) {
    if (t === null)
      return "";
    if (e === 0)
      return t[0];
    let n = "";
    for (; e > 0; ) {
      if (e < t.length)
        return (t[e] || "") + n;
      n = String(e % 10) + n, e = Math.floor(e / 10);
    }
    return "$" + n;
  }
}
class Pm {
  static staticValue(e) {
    return new Pm(e, -1, null);
  }
  static caseOps(e, t) {
    return new Pm(null, e, t);
  }
  constructor(e, t, n) {
    this.staticValue = e, this.matchIndex = t, !n || n.length === 0 ? this.caseOps = null : this.caseOps = n.slice(0);
  }
}
class Iet {
  constructor(e) {
    this._source = e, this._lastCharIndex = 0, this._result = [], this._resultLen = 0, this._currentStaticPiece = "";
  }
  emitUnchanged(e) {
    this._emitStatic(this._source.substring(this._lastCharIndex, e)), this._lastCharIndex = e;
  }
  emitStatic(e, t) {
    this._emitStatic(e), this._lastCharIndex = t;
  }
  _emitStatic(e) {
    e.length !== 0 && (this._currentStaticPiece += e);
  }
  emitMatchIndex(e, t, n) {
    this._currentStaticPiece.length !== 0 && (this._result[this._resultLen++] = Pm.staticValue(this._currentStaticPiece), this._currentStaticPiece = ""), this._result[this._resultLen++] = Pm.caseOps(e, n), this._lastCharIndex = t;
  }
  finalize() {
    return this.emitUnchanged(this._source.length), this._currentStaticPiece.length !== 0 && (this._result[this._resultLen++] = Pm.staticValue(this._currentStaticPiece), this._currentStaticPiece = ""), new G_(this._result);
  }
}
function Aet(i) {
  if (!i || i.length === 0)
    return new G_(null);
  const e = [], t = new Iet(i);
  for (let n = 0, r = i.length; n < r; n++) {
    const s = i.charCodeAt(n);
    if (s === 92) {
      if (n++, n >= r)
        break;
      const o = i.charCodeAt(n);
      switch (o) {
        case 92:
          t.emitUnchanged(n - 1), t.emitStatic("\\", n + 1);
          break;
        case 110:
          t.emitUnchanged(n - 1), t.emitStatic(`
`, n + 1);
          break;
        case 116:
          t.emitUnchanged(n - 1), t.emitStatic("	", n + 1);
          break;
        case 117:
        case 85:
        case 108:
        case 76:
          t.emitUnchanged(n - 1), t.emitStatic("", n + 1), e.push(String.fromCharCode(o));
          break;
      }
      continue;
    }
    if (s === 36) {
      if (n++, n >= r)
        break;
      const o = i.charCodeAt(n);
      if (o === 36) {
        t.emitUnchanged(n - 1), t.emitStatic("$", n + 1);
        continue;
      }
      if (o === 48 || o === 38) {
        t.emitUnchanged(n - 1), t.emitMatchIndex(0, n + 1, e), e.length = 0;
        continue;
      }
      if (49 <= o && o <= 57) {
        let a = o - 48;
        if (n + 1 < r) {
          const l = i.charCodeAt(n + 1);
          if (48 <= l && l <= 57) {
            n++, a = a * 10 + (l - 48), t.emitUnchanged(n - 2), t.emitMatchIndex(a, n + 1, e), e.length = 0;
            continue;
          }
        }
        t.emitUnchanged(n - 1), t.emitMatchIndex(a, n + 1, e), e.length = 0;
        continue;
      }
    }
  }
  return t.finalize();
}
const ff = new Ke("findWidgetVisible", !1);
ff.toNegated();
const S5 = new Ke("findInputFocussed", !1), vG = new Ke("replaceInputFocussed", !1), RD = {
  primary: 545,
  mac: {
    primary: 2593
    /* KeyCode.KeyC */
  }
}, FD = {
  primary: 565,
  mac: {
    primary: 2613
    /* KeyCode.KeyW */
  }
}, BD = {
  primary: 560,
  mac: {
    primary: 2608
    /* KeyCode.KeyR */
  }
}, VD = {
  primary: 554,
  mac: {
    primary: 2602
    /* KeyCode.KeyL */
  }
}, HD = {
  primary: 558,
  mac: {
    primary: 2606
    /* KeyCode.KeyP */
  }
}, Gn = {
  StartFindAction: "actions.find",
  StartFindWithSelection: "actions.findWithSelection",
  StartFindWithArgs: "editor.actions.findWithArgs",
  NextMatchFindAction: "editor.action.nextMatchFindAction",
  PreviousMatchFindAction: "editor.action.previousMatchFindAction",
  GoToMatchFindAction: "editor.action.goToMatchFindAction",
  NextSelectionMatchFindAction: "editor.action.nextSelectionMatchFindAction",
  PreviousSelectionMatchFindAction: "editor.action.previousSelectionMatchFindAction",
  StartFindReplaceAction: "editor.action.startFindReplaceAction",
  CloseFindWidgetCommand: "closeFindWidget",
  ToggleCaseSensitiveCommand: "toggleFindCaseSensitive",
  ToggleWholeWordCommand: "toggleFindWholeWord",
  ToggleRegexCommand: "toggleFindRegex",
  ToggleSearchScopeCommand: "toggleFindInSelection",
  TogglePreserveCaseCommand: "togglePreserveCase",
  ReplaceOneAction: "editor.action.replaceOne",
  ReplaceAllAction: "editor.action.replaceAll",
  SelectAllMatchesAction: "editor.action.selectAllMatches"
}, lg = 19999, ket = 240;
class GC {
  constructor(e, t) {
    this._toDispose = new Ne(), this._editor = e, this._state = t, this._isDisposed = !1, this._startSearchingTimer = new uc(), this._decorations = new Ks(e), this._toDispose.add(this._decorations), this._updateDecorationsScheduler = new Rn(() => this.research(!1), 100), this._toDispose.add(this._updateDecorationsScheduler), this._toDispose.add(this._editor.onDidChangeCursorPosition((n) => {
      (n.reason === 3 || n.reason === 5 || n.reason === 6) && this._decorations.setStartPosition(this._editor.getPosition());
    })), this._ignoreModelContentChanged = !1, this._toDispose.add(this._editor.onDidChangeModelContent((n) => {
      this._ignoreModelContentChanged || (n.isFlush && this._decorations.reset(), this._decorations.setStartPosition(this._editor.getPosition()), this._updateDecorationsScheduler.schedule());
    })), this._toDispose.add(this._state.onFindReplaceStateChange((n) => this._onStateChanged(n))), this.research(!1, this._state.searchScope);
  }
  dispose() {
    this._isDisposed = !0, An(this._startSearchingTimer), this._toDispose.dispose();
  }
  _onStateChanged(e) {
    this._isDisposed || this._editor.hasModel() && (e.searchString || e.isReplaceRevealed || e.isRegex || e.wholeWord || e.matchCase || e.searchScope) && (this._editor.getModel().isTooLargeForSyncing() ? (this._startSearchingTimer.cancel(), this._startSearchingTimer.setIfNotSet(() => {
      e.searchScope ? this.research(e.moveCursor, this._state.searchScope) : this.research(e.moveCursor);
    }, ket)) : e.searchScope ? this.research(e.moveCursor, this._state.searchScope) : this.research(e.moveCursor));
  }
  static _getSearchRange(e, t) {
    return t || e.getFullModelRange();
  }
  research(e, t) {
    let n = null;
    typeof t < "u" ? t !== null && (Array.isArray(t) ? n = t : n = [t]) : n = this._decorations.getFindScopes(), n !== null && (n = n.map((a) => {
      if (a.startLineNumber !== a.endLineNumber) {
        let l = a.endLineNumber;
        return a.endColumn === 1 && (l = l - 1), new V(a.startLineNumber, 1, l, this._editor.getModel().getLineMaxColumn(l));
      }
      return a;
    }));
    const r = this._findMatches(n, !1, lg);
    this._decorations.set(r, n);
    const s = this._editor.getSelection();
    let o = this._decorations.getCurrentMatchesPosition(s);
    if (o === 0 && r.length > 0) {
      const a = My(r.map((l) => l.range), (l) => V.compareRangesUsingStarts(l, s) >= 0);
      o = a > 0 ? a - 1 + 1 : o;
    }
    this._state.changeMatchInfo(o, this._decorations.getCount(), void 0), e && this._editor.getOption(
      41
      /* EditorOption.find */
    ).cursorMoveOnType && this._moveToNextMatch(this._decorations.getStartPosition());
  }
  _hasMatches() {
    return this._state.matchesCount > 0;
  }
  _cannotFind() {
    if (!this._hasMatches()) {
      const e = this._decorations.getFindScope();
      return e && this._editor.revealRangeInCenterIfOutsideViewport(
        e,
        0
        /* ScrollType.Smooth */
      ), !0;
    }
    return !1;
  }
  _setCurrentFindMatch(e) {
    const t = this._decorations.setCurrentFindMatch(e);
    this._state.changeMatchInfo(t, this._decorations.getCount(), e), this._editor.setSelection(e), this._editor.revealRangeInCenterIfOutsideViewport(
      e,
      0
      /* ScrollType.Smooth */
    );
  }
  _prevSearchPosition(e) {
    const t = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
    let { lineNumber: n, column: r } = e;
    const s = this._editor.getModel();
    return t || r === 1 ? (n === 1 ? n = s.getLineCount() : n--, r = s.getLineMaxColumn(n)) : r--, new ve(n, r);
  }
  _moveToPrevMatch(e, t = !1) {
    if (!this._state.canNavigateBack()) {
      const d = this._decorations.matchAfterPosition(e);
      d && this._setCurrentFindMatch(d);
      return;
    }
    if (this._decorations.getCount() < lg) {
      let d = this._decorations.matchBeforePosition(e);
      d && d.isEmpty() && d.getStartPosition().equals(e) && (e = this._prevSearchPosition(e), d = this._decorations.matchBeforePosition(e)), d && this._setCurrentFindMatch(d);
      return;
    }
    if (this._cannotFind())
      return;
    const n = this._decorations.getFindScope(), r = GC._getSearchRange(this._editor.getModel(), n);
    r.getEndPosition().isBefore(e) && (e = r.getEndPosition()), e.isBefore(r.getStartPosition()) && (e = r.getEndPosition());
    const { lineNumber: s, column: o } = e, a = this._editor.getModel();
    let l = new ve(s, o), c = a.findPreviousMatch(this._state.searchString, l, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      129
      /* EditorOption.wordSeparators */
    ) : null, !1);
    if (c && c.range.isEmpty() && c.range.getStartPosition().equals(l) && (l = this._prevSearchPosition(l), c = a.findPreviousMatch(this._state.searchString, l, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      129
      /* EditorOption.wordSeparators */
    ) : null, !1)), !!c) {
      if (!t && !r.containsRange(c.range))
        return this._moveToPrevMatch(c.range.getStartPosition(), !0);
      this._setCurrentFindMatch(c.range);
    }
  }
  moveToPrevMatch() {
    this._moveToPrevMatch(this._editor.getSelection().getStartPosition());
  }
  _nextSearchPosition(e) {
    const t = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
    let { lineNumber: n, column: r } = e;
    const s = this._editor.getModel();
    return t || r === s.getLineMaxColumn(n) ? (n === s.getLineCount() ? n = 1 : n++, r = 1) : r++, new ve(n, r);
  }
  _moveToNextMatch(e) {
    if (!this._state.canNavigateForward()) {
      const n = this._decorations.matchBeforePosition(e);
      n && this._setCurrentFindMatch(n);
      return;
    }
    if (this._decorations.getCount() < lg) {
      let n = this._decorations.matchAfterPosition(e);
      n && n.isEmpty() && n.getStartPosition().equals(e) && (e = this._nextSearchPosition(e), n = this._decorations.matchAfterPosition(e)), n && this._setCurrentFindMatch(n);
      return;
    }
    const t = this._getNextMatch(e, !1, !0);
    t && this._setCurrentFindMatch(t.range);
  }
  _getNextMatch(e, t, n, r = !1) {
    if (this._cannotFind())
      return null;
    const s = this._decorations.getFindScope(), o = GC._getSearchRange(this._editor.getModel(), s);
    o.getEndPosition().isBefore(e) && (e = o.getStartPosition()), e.isBefore(o.getStartPosition()) && (e = o.getStartPosition());
    const { lineNumber: a, column: l } = e, c = this._editor.getModel();
    let d = new ve(a, l), u = c.findNextMatch(this._state.searchString, d, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      129
      /* EditorOption.wordSeparators */
    ) : null, t);
    return n && u && u.range.isEmpty() && u.range.getStartPosition().equals(d) && (d = this._nextSearchPosition(d), u = c.findNextMatch(this._state.searchString, d, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      129
      /* EditorOption.wordSeparators */
    ) : null, t)), u ? !r && !o.containsRange(u.range) ? this._getNextMatch(u.range.getEndPosition(), t, n, !0) : u : null;
  }
  moveToNextMatch() {
    this._moveToNextMatch(this._editor.getSelection().getEndPosition());
  }
  _moveToMatch(e) {
    const t = this._decorations.getDecorationRangeAt(e);
    t && this._setCurrentFindMatch(t);
  }
  moveToMatch(e) {
    this._moveToMatch(e);
  }
  _getReplacePattern() {
    return this._state.isRegex ? Aet(this._state.replaceString) : G_.fromStaticValue(this._state.replaceString);
  }
  replace() {
    if (!this._hasMatches())
      return;
    const e = this._getReplacePattern(), t = this._editor.getSelection(), n = this._getNextMatch(t.getStartPosition(), !0, !1);
    if (n)
      if (t.equalsRange(n.range)) {
        const r = e.buildReplaceString(n.matches, this._state.preserveCase), s = new vs(t, r);
        this._executeEditorCommand("replace", s), this._decorations.setStartPosition(new ve(t.startLineNumber, t.startColumn + r.length)), this.research(!0);
      } else
        this._decorations.setStartPosition(this._editor.getPosition()), this._setCurrentFindMatch(n.range);
  }
  _findMatches(e, t, n) {
    const r = (e || [null]).map((s) => GC._getSearchRange(this._editor.getModel(), s));
    return this._editor.getModel().findMatches(this._state.searchString, r, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      129
      /* EditorOption.wordSeparators */
    ) : null, t, n);
  }
  replaceAll() {
    if (!this._hasMatches())
      return;
    const e = this._decorations.getFindScopes();
    e === null && this._state.matchesCount >= lg ? this._largeReplaceAll() : this._regularReplaceAll(e), this.research(!1);
  }
  _largeReplaceAll() {
    const t = new Vp(this._state.searchString, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      129
      /* EditorOption.wordSeparators */
    ) : null).parseSearchRequest();
    if (!t)
      return;
    let n = t.regex;
    if (!n.multiline) {
      let u = "mu";
      n.ignoreCase && (u += "i"), n.global && (u += "g"), n = new RegExp(n.source, u);
    }
    const r = this._editor.getModel(), s = r.getValue(
      1
      /* EndOfLinePreference.LF */
    ), o = r.getFullModelRange(), a = this._getReplacePattern();
    let l;
    const c = this._state.preserveCase;
    a.hasReplacementPatterns || c ? l = s.replace(n, function() {
      return a.buildReplaceString(arguments, c);
    }) : l = s.replace(n, a.buildReplaceString(null, c));
    const d = new Dz(o, l, this._editor.getSelection());
    this._executeEditorCommand("replaceAll", d);
  }
  _regularReplaceAll(e) {
    const t = this._getReplacePattern(), n = this._findMatches(
      e,
      t.hasReplacementPatterns || this._state.preserveCase,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ), r = [];
    for (let o = 0, a = n.length; o < a; o++)
      r[o] = t.buildReplaceString(n[o].matches, this._state.preserveCase);
    const s = new Eet(this._editor.getSelection(), n.map((o) => o.range), r);
    this._executeEditorCommand("replaceAll", s);
  }
  selectAllMatches() {
    if (!this._hasMatches())
      return;
    const e = this._decorations.getFindScopes();
    let n = this._findMatches(
      e,
      !1,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ).map((s) => new ot(s.range.startLineNumber, s.range.startColumn, s.range.endLineNumber, s.range.endColumn));
    const r = this._editor.getSelection();
    for (let s = 0, o = n.length; s < o; s++)
      if (n[s].equalsRange(r)) {
        n = [r].concat(n.slice(0, s)).concat(n.slice(s + 1));
        break;
      }
    this._editor.setSelections(n);
  }
  _executeEditorCommand(e, t) {
    try {
      this._ignoreModelContentChanged = !0, this._editor.pushUndoStop(), this._editor.executeCommand(e, t), this._editor.pushUndoStop();
    } finally {
      this._ignoreModelContentChanged = !1;
    }
  }
}
class x5 extends hc {
  constructor(e, t, n) {
    super(), this._hideSoon = this._register(new Rn(() => this._hide(), 2e3)), this._isVisible = !1, this._editor = e, this._state = t, this._keybindingService = n, this._domNode = document.createElement("div"), this._domNode.className = "findOptionsWidget", this._domNode.style.display = "none", this._domNode.style.top = "10px", this._domNode.style.zIndex = "12", this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true");
    const r = {
      inputActiveOptionBorder: Ye(fz),
      inputActiveOptionForeground: Ye(gz),
      inputActiveOptionBackground: Ye(dm)
    };
    this.caseSensitive = this._register(new Ape(Object.assign({ appendTitle: this._keybindingLabelFor(Gn.ToggleCaseSensitiveCommand), isChecked: this._state.matchCase }, r))), this._domNode.appendChild(this.caseSensitive.domNode), this._register(this.caseSensitive.onChange(() => {
      this._state.change({
        matchCase: this.caseSensitive.checked
      }, !1);
    })), this.wholeWords = this._register(new kpe(Object.assign({ appendTitle: this._keybindingLabelFor(Gn.ToggleWholeWordCommand), isChecked: this._state.wholeWord }, r))), this._domNode.appendChild(this.wholeWords.domNode), this._register(this.wholeWords.onChange(() => {
      this._state.change({
        wholeWord: this.wholeWords.checked
      }, !1);
    })), this.regex = this._register(new Tpe(Object.assign({ appendTitle: this._keybindingLabelFor(Gn.ToggleRegexCommand), isChecked: this._state.isRegex }, r))), this._domNode.appendChild(this.regex.domNode), this._register(this.regex.onChange(() => {
      this._state.change({
        isRegex: this.regex.checked
      }, !1);
    })), this._editor.addOverlayWidget(this), this._register(this._state.onFindReplaceStateChange((s) => {
      let o = !1;
      s.isRegex && (this.regex.checked = this._state.isRegex, o = !0), s.wholeWord && (this.wholeWords.checked = this._state.wholeWord, o = !0), s.matchCase && (this.caseSensitive.checked = this._state.matchCase, o = !0), !this._state.isRevealed && o && this._revealTemporarily();
    })), this._register(Ie(this._domNode, Ge.MOUSE_LEAVE, (s) => this._onMouseLeave())), this._register(Ie(this._domNode, "mouseover", (s) => this._onMouseOver()));
  }
  _keybindingLabelFor(e) {
    const t = this._keybindingService.lookupKeybinding(e);
    return t ? ` (${t.getLabel()})` : "";
  }
  dispose() {
    this._editor.removeOverlayWidget(this), super.dispose();
  }
  // ----- IOverlayWidget API
  getId() {
    return x5.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return {
      preference: 0
      /* OverlayWidgetPositionPreference.TOP_RIGHT_CORNER */
    };
  }
  highlightFindOptions() {
    this._revealTemporarily();
  }
  _revealTemporarily() {
    this._show(), this._hideSoon.schedule();
  }
  _onMouseLeave() {
    this._hideSoon.schedule();
  }
  _onMouseOver() {
    this._hideSoon.cancel();
  }
  _show() {
    this._isVisible || (this._isVisible = !0, this._domNode.style.display = "block");
  }
  _hide() {
    this._isVisible && (this._isVisible = !1, this._domNode.style.display = "none");
  }
}
x5.ID = "editor.contrib.findOptionsWidget";
function WD(i, e) {
  return i === 1 ? !0 : i === 2 ? !1 : e;
}
class Tet extends we {
  get searchString() {
    return this._searchString;
  }
  get replaceString() {
    return this._replaceString;
  }
  get isRevealed() {
    return this._isRevealed;
  }
  get isReplaceRevealed() {
    return this._isReplaceRevealed;
  }
  get isRegex() {
    return WD(this._isRegexOverride, this._isRegex);
  }
  get wholeWord() {
    return WD(this._wholeWordOverride, this._wholeWord);
  }
  get matchCase() {
    return WD(this._matchCaseOverride, this._matchCase);
  }
  get preserveCase() {
    return WD(this._preserveCaseOverride, this._preserveCase);
  }
  get actualIsRegex() {
    return this._isRegex;
  }
  get actualWholeWord() {
    return this._wholeWord;
  }
  get actualMatchCase() {
    return this._matchCase;
  }
  get actualPreserveCase() {
    return this._preserveCase;
  }
  get searchScope() {
    return this._searchScope;
  }
  get matchesPosition() {
    return this._matchesPosition;
  }
  get matchesCount() {
    return this._matchesCount;
  }
  get currentMatch() {
    return this._currentMatch;
  }
  constructor() {
    super(), this._onFindReplaceStateChange = this._register(new pe()), this.onFindReplaceStateChange = this._onFindReplaceStateChange.event, this._searchString = "", this._replaceString = "", this._isRevealed = !1, this._isReplaceRevealed = !1, this._isRegex = !1, this._isRegexOverride = 0, this._wholeWord = !1, this._wholeWordOverride = 0, this._matchCase = !1, this._matchCaseOverride = 0, this._preserveCase = !1, this._preserveCaseOverride = 0, this._searchScope = null, this._matchesPosition = 0, this._matchesCount = 0, this._currentMatch = null, this._loop = !0, this._isSearching = !1, this._filters = null;
  }
  changeMatchInfo(e, t, n) {
    const r = {
      moveCursor: !1,
      updateHistory: !1,
      searchString: !1,
      replaceString: !1,
      isRevealed: !1,
      isReplaceRevealed: !1,
      isRegex: !1,
      wholeWord: !1,
      matchCase: !1,
      preserveCase: !1,
      searchScope: !1,
      matchesPosition: !1,
      matchesCount: !1,
      currentMatch: !1,
      loop: !1,
      isSearching: !1,
      filters: !1
    };
    let s = !1;
    t === 0 && (e = 0), e > t && (e = t), this._matchesPosition !== e && (this._matchesPosition = e, r.matchesPosition = !0, s = !0), this._matchesCount !== t && (this._matchesCount = t, r.matchesCount = !0, s = !0), typeof n < "u" && (V.equalsRange(this._currentMatch, n) || (this._currentMatch = n, r.currentMatch = !0, s = !0)), s && this._onFindReplaceStateChange.fire(r);
  }
  change(e, t, n = !0) {
    var r;
    const s = {
      moveCursor: t,
      updateHistory: n,
      searchString: !1,
      replaceString: !1,
      isRevealed: !1,
      isReplaceRevealed: !1,
      isRegex: !1,
      wholeWord: !1,
      matchCase: !1,
      preserveCase: !1,
      searchScope: !1,
      matchesPosition: !1,
      matchesCount: !1,
      currentMatch: !1,
      loop: !1,
      isSearching: !1,
      filters: !1
    };
    let o = !1;
    const a = this.isRegex, l = this.wholeWord, c = this.matchCase, d = this.preserveCase;
    typeof e.searchString < "u" && this._searchString !== e.searchString && (this._searchString = e.searchString, s.searchString = !0, o = !0), typeof e.replaceString < "u" && this._replaceString !== e.replaceString && (this._replaceString = e.replaceString, s.replaceString = !0, o = !0), typeof e.isRevealed < "u" && this._isRevealed !== e.isRevealed && (this._isRevealed = e.isRevealed, s.isRevealed = !0, o = !0), typeof e.isReplaceRevealed < "u" && this._isReplaceRevealed !== e.isReplaceRevealed && (this._isReplaceRevealed = e.isReplaceRevealed, s.isReplaceRevealed = !0, o = !0), typeof e.isRegex < "u" && (this._isRegex = e.isRegex), typeof e.wholeWord < "u" && (this._wholeWord = e.wholeWord), typeof e.matchCase < "u" && (this._matchCase = e.matchCase), typeof e.preserveCase < "u" && (this._preserveCase = e.preserveCase), typeof e.searchScope < "u" && (!((r = e.searchScope) === null || r === void 0) && r.every((u) => {
      var h;
      return (h = this._searchScope) === null || h === void 0 ? void 0 : h.some((f) => !V.equalsRange(f, u));
    }) || (this._searchScope = e.searchScope, s.searchScope = !0, o = !0)), typeof e.loop < "u" && this._loop !== e.loop && (this._loop = e.loop, s.loop = !0, o = !0), typeof e.isSearching < "u" && this._isSearching !== e.isSearching && (this._isSearching = e.isSearching, s.isSearching = !0, o = !0), typeof e.filters < "u" && (this._filters ? this._filters.update(e.filters) : this._filters = e.filters, s.filters = !0, o = !0), this._isRegexOverride = typeof e.isRegexOverride < "u" ? e.isRegexOverride : 0, this._wholeWordOverride = typeof e.wholeWordOverride < "u" ? e.wholeWordOverride : 0, this._matchCaseOverride = typeof e.matchCaseOverride < "u" ? e.matchCaseOverride : 0, this._preserveCaseOverride = typeof e.preserveCaseOverride < "u" ? e.preserveCaseOverride : 0, a !== this.isRegex && (o = !0, s.isRegex = !0), l !== this.wholeWord && (o = !0, s.wholeWord = !0), c !== this.matchCase && (o = !0, s.matchCase = !0), d !== this.preserveCase && (o = !0, s.preserveCase = !0), o && this._onFindReplaceStateChange.fire(s);
  }
  canNavigateBack() {
    return this.canNavigateInLoop() || this.matchesPosition !== 1;
  }
  canNavigateForward() {
    return this.canNavigateInLoop() || this.matchesPosition < this.matchesCount;
  }
  canNavigateInLoop() {
    return this._loop || this.matchesCount >= lg;
  }
}
const Net = C("defaultLabel", "input"), Pet = C("label.preserveCaseToggle", "Preserve Case");
class Oet extends wb {
  constructor(e) {
    super({
      // TODO: does this need its own icon?
      icon: We.preserveCase,
      title: Pet + e.appendTitle,
      isChecked: e.isChecked,
      inputActiveOptionBorder: e.inputActiveOptionBorder,
      inputActiveOptionForeground: e.inputActiveOptionForeground,
      inputActiveOptionBackground: e.inputActiveOptionBackground
    });
  }
}
class Met extends hc {
  constructor(e, t, n, r) {
    super(), this._showOptionButtons = n, this.fixFocusOnOptionClickEnabled = !0, this.cachedOptionsWidth = 0, this._onDidOptionChange = this._register(new pe()), this.onDidOptionChange = this._onDidOptionChange.event, this._onKeyDown = this._register(new pe()), this.onKeyDown = this._onKeyDown.event, this._onMouseDown = this._register(new pe()), this._onInput = this._register(new pe()), this._onKeyUp = this._register(new pe()), this._onPreserveCaseKeyDown = this._register(new pe()), this.onPreserveCaseKeyDown = this._onPreserveCaseKeyDown.event, this.contextViewProvider = t, this.placeholder = r.placeholder || "", this.validation = r.validation, this.label = r.label || Net;
    const s = r.appendPreserveCaseLabel || "", o = r.history || [], a = !!r.flexibleHeight, l = !!r.flexibleWidth, c = r.flexibleMaxHeight;
    this.domNode = document.createElement("div"), this.domNode.classList.add("monaco-findInput"), this.inputBox = this._register(new Npe(this.domNode, this.contextViewProvider, {
      ariaLabel: this.label || "",
      placeholder: this.placeholder || "",
      validationOptions: {
        validation: this.validation
      },
      history: o,
      showHistoryHint: r.showHistoryHint,
      flexibleHeight: a,
      flexibleWidth: l,
      flexibleMaxHeight: c,
      inputBoxStyles: r.inputBoxStyles
    })), this.preserveCase = this._register(new Oet(Object.assign({ appendTitle: s, isChecked: !1 }, r.toggleStyles))), this._register(this.preserveCase.onChange((h) => {
      this._onDidOptionChange.fire(h), !h && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
    })), this._register(this.preserveCase.onKeyDown((h) => {
      this._onPreserveCaseKeyDown.fire(h);
    })), this._showOptionButtons ? this.cachedOptionsWidth = this.preserveCase.width() : this.cachedOptionsWidth = 0;
    const d = [this.preserveCase.domNode];
    this.onkeydown(this.domNode, (h) => {
      if (h.equals(
        15
        /* KeyCode.LeftArrow */
      ) || h.equals(
        17
        /* KeyCode.RightArrow */
      ) || h.equals(
        9
        /* KeyCode.Escape */
      )) {
        const f = d.indexOf(document.activeElement);
        if (f >= 0) {
          let g = -1;
          h.equals(
            17
            /* KeyCode.RightArrow */
          ) ? g = (f + 1) % d.length : h.equals(
            15
            /* KeyCode.LeftArrow */
          ) && (f === 0 ? g = d.length - 1 : g = f - 1), h.equals(
            9
            /* KeyCode.Escape */
          ) ? (d[f].blur(), this.inputBox.focus()) : g >= 0 && d[g].focus(), Tt.stop(h, !0);
        }
      }
    });
    const u = document.createElement("div");
    u.className = "controls", u.style.display = this._showOptionButtons ? "block" : "none", u.appendChild(this.preserveCase.domNode), this.domNode.appendChild(u), e?.appendChild(this.domNode), this.onkeydown(this.inputBox.inputElement, (h) => this._onKeyDown.fire(h)), this.onkeyup(this.inputBox.inputElement, (h) => this._onKeyUp.fire(h)), this.oninput(this.inputBox.inputElement, (h) => this._onInput.fire()), this.onmousedown(this.inputBox.inputElement, (h) => this._onMouseDown.fire(h));
  }
  enable() {
    this.domNode.classList.remove("disabled"), this.inputBox.enable(), this.preserveCase.enable();
  }
  disable() {
    this.domNode.classList.add("disabled"), this.inputBox.disable(), this.preserveCase.disable();
  }
  setEnabled(e) {
    e ? this.enable() : this.disable();
  }
  select() {
    this.inputBox.select();
  }
  focus() {
    this.inputBox.focus();
  }
  getPreserveCase() {
    return this.preserveCase.checked;
  }
  setPreserveCase(e) {
    this.preserveCase.checked = e;
  }
  focusOnPreserve() {
    this.preserveCase.focus();
  }
  validate() {
    var e;
    (e = this.inputBox) === null || e === void 0 || e.validate();
  }
  set width(e) {
    this.inputBox.paddingRight = this.cachedOptionsWidth, this.domNode.style.width = e + "px";
  }
  dispose() {
    super.dispose();
  }
}
var L1e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, I1e = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const _G = new Ke("suggestWidgetVisible", !1, C("suggestWidgetVisible", "Whether suggestion are visible")), bG = "historyNavigationWidgetFocus", A1e = "historyNavigationForwardsEnabled", k1e = "historyNavigationBackwardsEnabled";
let Uh;
const jD = [];
function T1e(i, e) {
  if (jD.includes(e))
    throw new Error("Cannot register the same widget multiple times");
  jD.push(e);
  const t = new Ne(), n = new Ke(bG, !1).bindTo(i), r = new Ke(A1e, !0).bindTo(i), s = new Ke(k1e, !0).bindTo(i), o = () => {
    n.set(!0), Uh = e;
  }, a = () => {
    n.set(!1), Uh === e && (Uh = void 0);
  };
  return e.element === document.activeElement && o(), t.add(e.onDidFocus(() => o())), t.add(e.onDidBlur(() => a())), t.add(Ct(() => {
    jD.splice(jD.indexOf(e), 1), a();
  })), {
    historyNavigationForwardsEnablement: r,
    historyNavigationBackwardsEnablement: s,
    dispose() {
      t.dispose();
    }
  };
}
let uH = class extends Ppe {
  constructor(e, t, n, r) {
    super(e, t, n);
    const s = this._register(r.createScoped(this.inputBox.element));
    this._register(T1e(s, this.inputBox));
  }
};
uH = L1e([
  I1e(3, yt)
], uH);
let hH = class extends Met {
  constructor(e, t, n, r, s = !1) {
    super(e, t, s, n);
    const o = this._register(r.createScoped(this.inputBox.element));
    this._register(T1e(o, this.inputBox));
  }
};
hH = L1e([
  I1e(3, yt)
], hH);
Bo.registerCommandAndKeybindingRule({
  id: "history.showPrevious",
  weight: 200,
  when: ke.and(ke.has(bG), ke.equals(k1e, !0), ke.not("isComposing"), _G.isEqualTo(!1)),
  primary: 16,
  secondary: [
    528
    /* KeyCode.UpArrow */
  ],
  handler: (i) => {
    Uh?.showPreviousValue();
  }
});
Bo.registerCommandAndKeybindingRule({
  id: "history.showNext",
  weight: 200,
  when: ke.and(ke.has(bG), ke.equals(A1e, !0), ke.not("isComposing"), _G.isEqualTo(!1)),
  primary: 18,
  secondary: [
    530
    /* KeyCode.DownArrow */
  ],
  handler: (i) => {
    Uh?.showNextValue();
  }
});
function q$(i) {
  var e, t;
  return ((e = i.lookupKeybinding("history.showPrevious")) === null || e === void 0 ? void 0 : e.getElectronAccelerator()) === "Up" && ((t = i.lookupKeybinding("history.showNext")) === null || t === void 0 ? void 0 : t.getElectronAccelerator()) === "Down";
}
var Ret = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const Fet = $i("find-selection", We.selection, C("findSelectionIcon", "Icon for 'Find in Selection' in the editor find widget.")), K$ = $i("find-collapsed", We.chevronRight, C("findCollapsedIcon", "Icon to indicate that the editor find widget is collapsed.")), Y$ = $i("find-expanded", We.chevronDown, C("findExpandedIcon", "Icon to indicate that the editor find widget is expanded.")), Bet = $i("find-replace", We.replace, C("findReplaceIcon", "Icon for 'Replace' in the editor find widget.")), Vet = $i("find-replace-all", We.replaceAll, C("findReplaceAllIcon", "Icon for 'Replace All' in the editor find widget.")), Het = $i("find-previous-match", We.arrowUp, C("findPreviousMatchIcon", "Icon for 'Find Previous' in the editor find widget.")), Wet = $i("find-next-match", We.arrowDown, C("findNextMatchIcon", "Icon for 'Find Next' in the editor find widget.")), jet = C("label.findDialog", "Find / Replace"), zet = C("label.find", "Find"), Uet = C("placeholder.find", "Find"), Get = C("label.previousMatchButton", "Previous Match"), qet = C("label.nextMatchButton", "Next Match"), Ket = C("label.toggleSelectionFind", "Find in Selection"), Yet = C("label.closeButton", "Close"), Xet = C("label.replace", "Replace"), Zet = C("placeholder.replace", "Replace"), Qet = C("label.replaceButton", "Replace"), Jet = C("label.replaceAllButton", "Replace All"), $et = C("label.toggleReplaceButton", "Toggle Replace"), ett = C("title.matchesCountLimit", "Only the first {0} results are highlighted, but all find operations work on the entire text.", lg), ttt = C("label.matchesLocation", "{0} of {1}"), X$ = C("label.noResults", "No results"), xd = 419, ntt = 275, itt = ntt - 54;
let y2 = 69;
const rtt = 33, Z$ = "ctrlEnterReplaceAll.windows.donotask", Q$ = sn ? 256 : 2048;
class OT {
  constructor(e) {
    this.afterLineNumber = e, this.heightInPx = rtt, this.suppressMouseDown = !1, this.domNode = document.createElement("div"), this.domNode.className = "dock-find-viewzone";
  }
}
function J$(i, e, t) {
  const n = !!e.match(/\n/);
  if (t && n && t.selectionStart > 0) {
    i.stopPropagation();
    return;
  }
}
function $$(i, e, t) {
  const n = !!e.match(/\n/);
  if (t && n && t.selectionEnd < t.value.length) {
    i.stopPropagation();
    return;
  }
}
class D5 extends hc {
  constructor(e, t, n, r, s, o, a, l, c) {
    super(), this._cachedHeight = null, this._revealTimeouts = [], this._codeEditor = e, this._controller = t, this._state = n, this._contextViewProvider = r, this._keybindingService = s, this._contextKeyService = o, this._storageService = l, this._notificationService = c, this._ctrlEnterReplaceAllWarningPrompted = !!l.getBoolean(
      Z$,
      0
      /* StorageScope.PROFILE */
    ), this._isVisible = !1, this._isReplaceVisible = !1, this._ignoreChangeEvent = !1, this._updateHistoryDelayer = new ac(500), this._register(Ct(() => this._updateHistoryDelayer.cancel())), this._register(this._state.onFindReplaceStateChange((d) => this._onStateChanged(d))), this._buildDomNode(), this._updateButtons(), this._tryUpdateWidgetWidth(), this._findInput.inputBox.layout(), this._register(this._codeEditor.onDidChangeConfiguration((d) => {
      if (d.hasChanged(
        90
        /* EditorOption.readOnly */
      ) && (this._codeEditor.getOption(
        90
        /* EditorOption.readOnly */
      ) && this._state.change({ isReplaceRevealed: !1 }, !1), this._updateButtons()), d.hasChanged(
        143
        /* EditorOption.layoutInfo */
      ) && this._tryUpdateWidgetWidth(), d.hasChanged(
        2
        /* EditorOption.accessibilitySupport */
      ) && this.updateAccessibilitySupport(), d.hasChanged(
        41
        /* EditorOption.find */
      )) {
        const u = this._codeEditor.getOption(
          41
          /* EditorOption.find */
        ).loop;
        this._state.change({ loop: u }, !1);
        const h = this._codeEditor.getOption(
          41
          /* EditorOption.find */
        ).addExtraSpaceOnTop;
        h && !this._viewZone && (this._viewZone = new OT(0), this._showViewZone()), !h && this._viewZone && this._removeViewZone();
      }
    })), this.updateAccessibilitySupport(), this._register(this._codeEditor.onDidChangeCursorSelection(() => {
      this._isVisible && this._updateToggleSelectionFindButton();
    })), this._register(this._codeEditor.onDidFocusEditorWidget(() => Ret(this, void 0, void 0, function* () {
      if (this._isVisible) {
        const d = yield this._controller.getGlobalBufferTerm();
        d && d !== this._state.searchString && (this._state.change({ searchString: d }, !1), this._findInput.select());
      }
    }))), this._findInputFocused = S5.bindTo(o), this._findFocusTracker = this._register(yu(this._findInput.inputBox.inputElement)), this._register(this._findFocusTracker.onDidFocus(() => {
      this._findInputFocused.set(!0), this._updateSearchScope();
    })), this._register(this._findFocusTracker.onDidBlur(() => {
      this._findInputFocused.set(!1);
    })), this._replaceInputFocused = vG.bindTo(o), this._replaceFocusTracker = this._register(yu(this._replaceInput.inputBox.inputElement)), this._register(this._replaceFocusTracker.onDidFocus(() => {
      this._replaceInputFocused.set(!0), this._updateSearchScope();
    })), this._register(this._replaceFocusTracker.onDidBlur(() => {
      this._replaceInputFocused.set(!1);
    })), this._codeEditor.addOverlayWidget(this), this._codeEditor.getOption(
      41
      /* EditorOption.find */
    ).addExtraSpaceOnTop && (this._viewZone = new OT(0)), this._register(this._codeEditor.onDidChangeModel(() => {
      this._isVisible && (this._viewZoneId = void 0);
    })), this._register(this._codeEditor.onDidScrollChange((d) => {
      if (d.scrollTopChanged) {
        this._layoutViewZone();
        return;
      }
      setTimeout(() => {
        this._layoutViewZone();
      }, 0);
    }));
  }
  // ----- IOverlayWidget API
  getId() {
    return D5.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._isVisible ? {
      preference: 0
      /* OverlayWidgetPositionPreference.TOP_RIGHT_CORNER */
    } : null;
  }
  // ----- React to state changes
  _onStateChanged(e) {
    if (e.searchString) {
      try {
        this._ignoreChangeEvent = !0, this._findInput.setValue(this._state.searchString);
      } finally {
        this._ignoreChangeEvent = !1;
      }
      this._updateButtons();
    }
    if (e.replaceString && (this._replaceInput.inputBox.value = this._state.replaceString), e.isRevealed && (this._state.isRevealed ? this._reveal() : this._hide(!0)), e.isReplaceRevealed && (this._state.isReplaceRevealed ? !this._codeEditor.getOption(
      90
      /* EditorOption.readOnly */
    ) && !this._isReplaceVisible && (this._isReplaceVisible = !0, this._replaceInput.width = Lo(this._findInput.domNode), this._updateButtons(), this._replaceInput.inputBox.layout()) : this._isReplaceVisible && (this._isReplaceVisible = !1, this._updateButtons())), (e.isRevealed || e.isReplaceRevealed) && (this._state.isRevealed || this._state.isReplaceRevealed) && this._tryUpdateHeight() && this._showViewZone(), e.isRegex && this._findInput.setRegex(this._state.isRegex), e.wholeWord && this._findInput.setWholeWords(this._state.wholeWord), e.matchCase && this._findInput.setCaseSensitive(this._state.matchCase), e.preserveCase && this._replaceInput.setPreserveCase(this._state.preserveCase), e.searchScope && (this._state.searchScope ? this._toggleSelectionFind.checked = !0 : this._toggleSelectionFind.checked = !1, this._updateToggleSelectionFindButton()), e.searchString || e.matchesCount || e.matchesPosition) {
      const t = this._state.searchString.length > 0 && this._state.matchesCount === 0;
      this._domNode.classList.toggle("no-results", t), this._updateMatchesCount(), this._updateButtons();
    }
    (e.searchString || e.currentMatch) && this._layoutViewZone(), e.updateHistory && this._delayedUpdateHistory(), e.loop && this._updateButtons();
  }
  _delayedUpdateHistory() {
    this._updateHistoryDelayer.trigger(this._updateHistory.bind(this)).then(void 0, It);
  }
  _updateHistory() {
    this._state.searchString && this._findInput.inputBox.addToHistory(), this._state.replaceString && this._replaceInput.inputBox.addToHistory();
  }
  _updateMatchesCount() {
    this._matchesCount.style.minWidth = y2 + "px", this._state.matchesCount >= lg ? this._matchesCount.title = ett : this._matchesCount.title = "", this._matchesCount.firstChild && this._matchesCount.removeChild(this._matchesCount.firstChild);
    let e;
    if (this._state.matchesCount > 0) {
      let t = String(this._state.matchesCount);
      this._state.matchesCount >= lg && (t += "+");
      let n = String(this._state.matchesPosition);
      n === "0" && (n = "?"), e = zm(ttt, n, t);
    } else
      e = X$;
    this._matchesCount.appendChild(document.createTextNode(e)), Fs(this._getAriaLabel(e, this._state.currentMatch, this._state.searchString)), y2 = Math.max(y2, this._matchesCount.clientWidth);
  }
  // ----- actions
  _getAriaLabel(e, t, n) {
    if (e === X$)
      return n === "" ? C("ariaSearchNoResultEmpty", "{0} found", e) : C("ariaSearchNoResult", "{0} found for '{1}'", e, n);
    if (t) {
      const r = C("ariaSearchNoResultWithLineNum", "{0} found for '{1}', at {2}", e, n, t.startLineNumber + ":" + t.startColumn), s = this._codeEditor.getModel();
      return s && t.startLineNumber <= s.getLineCount() && t.startLineNumber >= 1 ? `${s.getLineContent(t.startLineNumber)}, ${r}` : r;
    }
    return C("ariaSearchNoResultWithLineNumNoCurrentMatch", "{0} found for '{1}'", e, n);
  }
  /**
   * If 'selection find' is ON we should not disable the button (its function is to cancel 'selection find').
   * If 'selection find' is OFF we enable the button only if there is a selection.
   */
  _updateToggleSelectionFindButton() {
    const e = this._codeEditor.getSelection(), t = e ? e.startLineNumber !== e.endLineNumber || e.startColumn !== e.endColumn : !1, n = this._toggleSelectionFind.checked;
    this._isVisible && (n || t) ? this._toggleSelectionFind.enable() : this._toggleSelectionFind.disable();
  }
  _updateButtons() {
    this._findInput.setEnabled(this._isVisible), this._replaceInput.setEnabled(this._isVisible && this._isReplaceVisible), this._updateToggleSelectionFindButton(), this._closeBtn.setEnabled(this._isVisible);
    const e = this._state.searchString.length > 0, t = !!this._state.matchesCount;
    this._prevBtn.setEnabled(this._isVisible && e && t && this._state.canNavigateBack()), this._nextBtn.setEnabled(this._isVisible && e && t && this._state.canNavigateForward()), this._replaceBtn.setEnabled(this._isVisible && this._isReplaceVisible && e), this._replaceAllBtn.setEnabled(this._isVisible && this._isReplaceVisible && e), this._domNode.classList.toggle("replaceToggled", this._isReplaceVisible), this._toggleReplaceBtn.setExpanded(this._isReplaceVisible);
    const n = !this._codeEditor.getOption(
      90
      /* EditorOption.readOnly */
    );
    this._toggleReplaceBtn.setEnabled(this._isVisible && n);
  }
  _reveal() {
    if (this._revealTimeouts.forEach((e) => {
      clearTimeout(e);
    }), this._revealTimeouts = [], !this._isVisible) {
      this._isVisible = !0;
      const e = this._codeEditor.getSelection();
      switch (this._codeEditor.getOption(
        41
        /* EditorOption.find */
      ).autoFindInSelection) {
        case "always":
          this._toggleSelectionFind.checked = !0;
          break;
        case "never":
          this._toggleSelectionFind.checked = !1;
          break;
        case "multiline": {
          const n = !!e && e.startLineNumber !== e.endLineNumber;
          this._toggleSelectionFind.checked = n;
          break;
        }
      }
      this._tryUpdateWidgetWidth(), this._updateButtons(), this._revealTimeouts.push(setTimeout(() => {
        this._domNode.classList.add("visible"), this._domNode.setAttribute("aria-hidden", "false");
      }, 0)), this._revealTimeouts.push(setTimeout(() => {
        this._findInput.validate();
      }, 200)), this._codeEditor.layoutOverlayWidget(this);
      let t = !0;
      if (this._codeEditor.getOption(
        41
        /* EditorOption.find */
      ).seedSearchStringFromSelection && e) {
        const n = this._codeEditor.getDomNode();
        if (n) {
          const r = wr(n), s = this._codeEditor.getScrolledVisiblePosition(e.getStartPosition()), o = r.left + (s ? s.left : 0), a = s ? s.top : 0;
          if (this._viewZone && a < this._viewZone.heightInPx) {
            e.endLineNumber > e.startLineNumber && (t = !1);
            const l = Fhe(this._domNode).left;
            o > l && (t = !1);
            const c = this._codeEditor.getScrolledVisiblePosition(e.getEndPosition());
            r.left + (c ? c.left : 0) > l && (t = !1);
          }
        }
      }
      this._showViewZone(t);
    }
  }
  _hide(e) {
    this._revealTimeouts.forEach((t) => {
      clearTimeout(t);
    }), this._revealTimeouts = [], this._isVisible && (this._isVisible = !1, this._updateButtons(), this._domNode.classList.remove("visible"), this._domNode.setAttribute("aria-hidden", "true"), this._findInput.clearMessage(), e && this._codeEditor.focus(), this._codeEditor.layoutOverlayWidget(this), this._removeViewZone());
  }
  _layoutViewZone(e) {
    if (!this._codeEditor.getOption(
      41
      /* EditorOption.find */
    ).addExtraSpaceOnTop) {
      this._removeViewZone();
      return;
    }
    if (!this._isVisible)
      return;
    const n = this._viewZone;
    this._viewZoneId !== void 0 || !n || this._codeEditor.changeViewZones((r) => {
      n.heightInPx = this._getHeight(), this._viewZoneId = r.addZone(n), this._codeEditor.setScrollTop(e || this._codeEditor.getScrollTop() + n.heightInPx);
    });
  }
  _showViewZone(e = !0) {
    if (!this._isVisible || !this._codeEditor.getOption(
      41
      /* EditorOption.find */
    ).addExtraSpaceOnTop)
      return;
    this._viewZone === void 0 && (this._viewZone = new OT(0));
    const n = this._viewZone;
    this._codeEditor.changeViewZones((r) => {
      if (this._viewZoneId !== void 0) {
        const s = this._getHeight();
        if (s === n.heightInPx)
          return;
        const o = s - n.heightInPx;
        n.heightInPx = s, r.layoutZone(this._viewZoneId), e && this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + o);
        return;
      } else {
        let s = this._getHeight();
        if (s -= this._codeEditor.getOption(
          83
          /* EditorOption.padding */
        ).top, s <= 0)
          return;
        n.heightInPx = s, this._viewZoneId = r.addZone(n), e && this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + s);
      }
    });
  }
  _removeViewZone() {
    this._codeEditor.changeViewZones((e) => {
      this._viewZoneId !== void 0 && (e.removeZone(this._viewZoneId), this._viewZoneId = void 0, this._viewZone && (this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() - this._viewZone.heightInPx), this._viewZone = void 0));
    });
  }
  _tryUpdateWidgetWidth() {
    if (!this._isVisible || !Xj(this._domNode))
      return;
    const e = this._codeEditor.getLayoutInfo();
    if (e.contentWidth <= 0) {
      this._domNode.classList.add("hiddenEditor");
      return;
    } else this._domNode.classList.contains("hiddenEditor") && this._domNode.classList.remove("hiddenEditor");
    const n = e.width, r = e.minimap.minimapWidth;
    let s = !1, o = !1, a = !1;
    if (this._resized && Lo(this._domNode) > xd) {
      this._domNode.style.maxWidth = `${n - 28 - r - 15}px`, this._replaceInput.width = Lo(this._findInput.domNode);
      return;
    }
    if (xd + 28 + r >= n && (o = !0), xd + 28 + r - y2 >= n && (a = !0), xd + 28 + r - y2 >= n + 50 && (s = !0), this._domNode.classList.toggle("collapsed-find-widget", s), this._domNode.classList.toggle("narrow-find-widget", a), this._domNode.classList.toggle("reduced-find-widget", o), !a && !s && (this._domNode.style.maxWidth = `${n - 28 - r - 15}px`), this._findInput.layout({ collapsedFindWidget: s, narrowFindWidget: a, reducedFindWidget: o }), this._resized) {
      const l = this._findInput.inputBox.element.clientWidth;
      l > 0 && (this._replaceInput.width = l);
    } else this._isReplaceVisible && (this._replaceInput.width = Lo(this._findInput.domNode));
  }
  _getHeight() {
    let e = 0;
    return e += 4, e += this._findInput.inputBox.height + 2, this._isReplaceVisible && (e += 4, e += this._replaceInput.inputBox.height + 2), e += 4, e;
  }
  _tryUpdateHeight() {
    const e = this._getHeight();
    return this._cachedHeight !== null && this._cachedHeight === e ? !1 : (this._cachedHeight = e, this._domNode.style.height = `${e}px`, !0);
  }
  // ----- Public
  focusFindInput() {
    this._findInput.select(), this._findInput.focus();
  }
  focusReplaceInput() {
    this._replaceInput.select(), this._replaceInput.focus();
  }
  highlightFindOptions() {
    this._findInput.highlightFindOptions();
  }
  _updateSearchScope() {
    if (this._codeEditor.hasModel() && this._toggleSelectionFind.checked) {
      const e = this._codeEditor.getSelections();
      e.map((t) => {
        t.endColumn === 1 && t.endLineNumber > t.startLineNumber && (t = t.setEndPosition(t.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(t.endLineNumber - 1)));
        const n = this._state.currentMatch;
        return t.startLineNumber !== t.endLineNumber && !V.equalsRange(t, n) ? t : null;
      }).filter((t) => !!t), e.length && this._state.change({ searchScope: e }, !0);
    }
  }
  _onFindInputMouseDown(e) {
    e.middleButton && e.stopPropagation();
  }
  _onFindInputKeyDown(e) {
    if (e.equals(
      Q$ | 3
      /* KeyCode.Enter */
    ))
      if (this._keybindingService.dispatchEvent(e, e.target)) {
        e.preventDefault();
        return;
      } else {
        this._findInput.inputBox.insertAtCursor(`
`), e.preventDefault();
        return;
      }
    if (e.equals(
      2
      /* KeyCode.Tab */
    )) {
      this._isReplaceVisible ? this._replaceInput.focus() : this._findInput.focusOnCaseSensitive(), e.preventDefault();
      return;
    }
    if (e.equals(
      2066
      /* KeyCode.DownArrow */
    )) {
      this._codeEditor.focus(), e.preventDefault();
      return;
    }
    if (e.equals(
      16
      /* KeyCode.UpArrow */
    ))
      return J$(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea"));
    if (e.equals(
      18
      /* KeyCode.DownArrow */
    ))
      return $$(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea"));
  }
  _onReplaceInputKeyDown(e) {
    if (e.equals(
      Q$ | 3
      /* KeyCode.Enter */
    ))
      if (this._keybindingService.dispatchEvent(e, e.target)) {
        e.preventDefault();
        return;
      } else {
        Ls && Zc && !this._ctrlEnterReplaceAllWarningPrompted && (this._notificationService.info(C("ctrlEnter.keybindingChanged", "Ctrl+Enter now inserts line break instead of replacing all. You can modify the keybinding for editor.action.replaceAll to override this behavior.")), this._ctrlEnterReplaceAllWarningPrompted = !0, this._storageService.store(
          Z$,
          !0,
          0,
          0
          /* StorageTarget.USER */
        )), this._replaceInput.inputBox.insertAtCursor(`
`), e.preventDefault();
        return;
      }
    if (e.equals(
      2
      /* KeyCode.Tab */
    )) {
      this._findInput.focusOnCaseSensitive(), e.preventDefault();
      return;
    }
    if (e.equals(
      1026
      /* KeyCode.Tab */
    )) {
      this._findInput.focus(), e.preventDefault();
      return;
    }
    if (e.equals(
      2066
      /* KeyCode.DownArrow */
    )) {
      this._codeEditor.focus(), e.preventDefault();
      return;
    }
    if (e.equals(
      16
      /* KeyCode.UpArrow */
    ))
      return J$(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea"));
    if (e.equals(
      18
      /* KeyCode.DownArrow */
    ))
      return $$(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea"));
  }
  // ----- sash
  getVerticalSashLeft(e) {
    return 0;
  }
  // ----- initialization
  _keybindingLabelFor(e) {
    const t = this._keybindingService.lookupKeybinding(e);
    return t ? ` (${t.getLabel()})` : "";
  }
  _buildDomNode() {
    this._findInput = this._register(new uH(null, this._contextViewProvider, {
      width: itt,
      label: zet,
      placeholder: Uet,
      appendCaseSensitiveLabel: this._keybindingLabelFor(Gn.ToggleCaseSensitiveCommand),
      appendWholeWordsLabel: this._keybindingLabelFor(Gn.ToggleWholeWordCommand),
      appendRegexLabel: this._keybindingLabelFor(Gn.ToggleRegexCommand),
      validation: (l) => {
        if (l.length === 0 || !this._findInput.getRegex())
          return null;
        try {
          return new RegExp(l, "gu"), null;
        } catch (c) {
          return { content: c.message };
        }
      },
      flexibleHeight: !0,
      flexibleWidth: !0,
      flexibleMaxHeight: 118,
      showCommonFindToggles: !0,
      showHistoryHint: () => q$(this._keybindingService),
      inputBoxStyles: WL,
      toggleStyles: HL
    }, this._contextKeyService)), this._findInput.setRegex(!!this._state.isRegex), this._findInput.setCaseSensitive(!!this._state.matchCase), this._findInput.setWholeWords(!!this._state.wholeWord), this._register(this._findInput.onKeyDown((l) => this._onFindInputKeyDown(l))), this._register(this._findInput.inputBox.onDidChange(() => {
      this._ignoreChangeEvent || this._state.change({ searchString: this._findInput.getValue() }, !0);
    })), this._register(this._findInput.onDidOptionChange(() => {
      this._state.change({
        isRegex: this._findInput.getRegex(),
        wholeWord: this._findInput.getWholeWords(),
        matchCase: this._findInput.getCaseSensitive()
      }, !0);
    })), this._register(this._findInput.onCaseSensitiveKeyDown((l) => {
      l.equals(
        1026
        /* KeyCode.Tab */
      ) && this._isReplaceVisible && (this._replaceInput.focus(), l.preventDefault());
    })), this._register(this._findInput.onRegexKeyDown((l) => {
      l.equals(
        2
        /* KeyCode.Tab */
      ) && this._isReplaceVisible && (this._replaceInput.focusOnPreserve(), l.preventDefault());
    })), this._register(this._findInput.inputBox.onDidHeightChange((l) => {
      this._tryUpdateHeight() && this._showViewZone();
    })), $s && this._register(this._findInput.onMouseDown((l) => this._onFindInputMouseDown(l))), this._matchesCount = document.createElement("div"), this._matchesCount.className = "matchesCount", this._updateMatchesCount(), this._prevBtn = this._register(new S1({
      label: Get + this._keybindingLabelFor(Gn.PreviousMatchFindAction),
      icon: Het,
      onTrigger: () => {
        am(this._codeEditor.getAction(Gn.PreviousMatchFindAction)).run().then(void 0, It);
      }
    })), this._nextBtn = this._register(new S1({
      label: qet + this._keybindingLabelFor(Gn.NextMatchFindAction),
      icon: Wet,
      onTrigger: () => {
        am(this._codeEditor.getAction(Gn.NextMatchFindAction)).run().then(void 0, It);
      }
    }));
    const n = document.createElement("div");
    n.className = "find-part", n.appendChild(this._findInput.domNode);
    const r = document.createElement("div");
    r.className = "find-actions", n.appendChild(r), r.appendChild(this._matchesCount), r.appendChild(this._prevBtn.domNode), r.appendChild(this._nextBtn.domNode), this._toggleSelectionFind = this._register(new wb({
      icon: Fet,
      title: Ket + this._keybindingLabelFor(Gn.ToggleSearchScopeCommand),
      isChecked: !1,
      inputActiveOptionBackground: Ye(dm),
      inputActiveOptionBorder: Ye(fz),
      inputActiveOptionForeground: Ye(gz)
    })), this._register(this._toggleSelectionFind.onChange(() => {
      if (this._toggleSelectionFind.checked) {
        if (this._codeEditor.hasModel()) {
          const l = this._codeEditor.getSelections();
          l.map((c) => (c.endColumn === 1 && c.endLineNumber > c.startLineNumber && (c = c.setEndPosition(c.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(c.endLineNumber - 1))), c.isEmpty() ? null : c)).filter((c) => !!c), l.length && this._state.change({ searchScope: l }, !0);
        }
      } else
        this._state.change({ searchScope: null }, !0);
    })), r.appendChild(this._toggleSelectionFind.domNode), this._closeBtn = this._register(new S1({
      label: Yet + this._keybindingLabelFor(Gn.CloseFindWidgetCommand),
      icon: nme,
      onTrigger: () => {
        this._state.change({ isRevealed: !1, searchScope: null }, !1);
      },
      onKeyDown: (l) => {
        l.equals(
          2
          /* KeyCode.Tab */
        ) && this._isReplaceVisible && (this._replaceBtn.isEnabled() ? this._replaceBtn.focus() : this._codeEditor.focus(), l.preventDefault());
      }
    })), this._replaceInput = this._register(new hH(null, void 0, {
      label: Xet,
      placeholder: Zet,
      appendPreserveCaseLabel: this._keybindingLabelFor(Gn.TogglePreserveCaseCommand),
      history: [],
      flexibleHeight: !0,
      flexibleWidth: !0,
      flexibleMaxHeight: 118,
      showHistoryHint: () => q$(this._keybindingService),
      inputBoxStyles: WL,
      toggleStyles: HL
    }, this._contextKeyService, !0)), this._replaceInput.setPreserveCase(!!this._state.preserveCase), this._register(this._replaceInput.onKeyDown((l) => this._onReplaceInputKeyDown(l))), this._register(this._replaceInput.inputBox.onDidChange(() => {
      this._state.change({ replaceString: this._replaceInput.inputBox.value }, !1);
    })), this._register(this._replaceInput.inputBox.onDidHeightChange((l) => {
      this._isReplaceVisible && this._tryUpdateHeight() && this._showViewZone();
    })), this._register(this._replaceInput.onDidOptionChange(() => {
      this._state.change({
        preserveCase: this._replaceInput.getPreserveCase()
      }, !0);
    })), this._register(this._replaceInput.onPreserveCaseKeyDown((l) => {
      l.equals(
        2
        /* KeyCode.Tab */
      ) && (this._prevBtn.isEnabled() ? this._prevBtn.focus() : this._nextBtn.isEnabled() ? this._nextBtn.focus() : this._toggleSelectionFind.enabled ? this._toggleSelectionFind.focus() : this._closeBtn.isEnabled() && this._closeBtn.focus(), l.preventDefault());
    })), this._replaceBtn = this._register(new S1({
      label: Qet + this._keybindingLabelFor(Gn.ReplaceOneAction),
      icon: Bet,
      onTrigger: () => {
        this._controller.replace();
      },
      onKeyDown: (l) => {
        l.equals(
          1026
          /* KeyCode.Tab */
        ) && (this._closeBtn.focus(), l.preventDefault());
      }
    })), this._replaceAllBtn = this._register(new S1({
      label: Jet + this._keybindingLabelFor(Gn.ReplaceAllAction),
      icon: Vet,
      onTrigger: () => {
        this._controller.replaceAll();
      }
    }));
    const s = document.createElement("div");
    s.className = "replace-part", s.appendChild(this._replaceInput.domNode);
    const o = document.createElement("div");
    o.className = "replace-actions", s.appendChild(o), o.appendChild(this._replaceBtn.domNode), o.appendChild(this._replaceAllBtn.domNode), this._toggleReplaceBtn = this._register(new S1({
      label: $et,
      className: "codicon toggle left",
      onTrigger: () => {
        this._state.change({ isReplaceRevealed: !this._isReplaceVisible }, !1), this._isReplaceVisible && (this._replaceInput.width = Lo(this._findInput.domNode), this._replaceInput.inputBox.layout()), this._showViewZone();
      }
    })), this._toggleReplaceBtn.setExpanded(this._isReplaceVisible), this._domNode = document.createElement("div"), this._domNode.className = "editor-widget find-widget", this._domNode.setAttribute("aria-hidden", "true"), this._domNode.ariaLabel = jet, this._domNode.role = "dialog", this._domNode.style.width = `${xd}px`, this._domNode.appendChild(this._toggleReplaceBtn.domNode), this._domNode.appendChild(n), this._domNode.appendChild(this._closeBtn.domNode), this._domNode.appendChild(s), this._resizeSash = new Ts(this._domNode, this, { orientation: 0, size: 2 }), this._resized = !1;
    let a = xd;
    this._register(this._resizeSash.onDidStart(() => {
      a = Lo(this._domNode);
    })), this._register(this._resizeSash.onDidChange((l) => {
      this._resized = !0;
      const c = a + l.startX - l.currentX;
      if (c < xd)
        return;
      const d = parseFloat(e4(this._domNode).maxWidth) || 0;
      c > d || (this._domNode.style.width = `${c}px`, this._isReplaceVisible && (this._replaceInput.width = Lo(this._findInput.domNode)), this._findInput.inputBox.layout(), this._tryUpdateHeight());
    })), this._register(this._resizeSash.onDidReset(() => {
      const l = Lo(this._domNode);
      if (l < xd)
        return;
      let c = xd;
      if (!this._resized || l === xd) {
        const d = this._codeEditor.getLayoutInfo();
        c = d.width - 28 - d.minimap.minimapWidth - 15, this._resized = !0;
      }
      this._domNode.style.width = `${c}px`, this._isReplaceVisible && (this._replaceInput.width = Lo(this._findInput.domNode)), this._findInput.inputBox.layout();
    }));
  }
  updateAccessibilitySupport() {
    const e = this._codeEditor.getOption(
      2
      /* EditorOption.accessibilitySupport */
    );
    this._findInput.setFocusInputOnOptionClick(
      e !== 2
      /* AccessibilitySupport.Enabled */
    );
  }
}
D5.ID = "editor.contrib.findWidget";
class S1 extends hc {
  constructor(e) {
    super(), this._opts = e;
    let t = "button";
    this._opts.className && (t = t + " " + this._opts.className), this._opts.icon && (t = t + " " + ft.asClassName(this._opts.icon)), this._domNode = document.createElement("div"), this._domNode.title = this._opts.label, this._domNode.tabIndex = 0, this._domNode.className = t, this._domNode.setAttribute("role", "button"), this._domNode.setAttribute("aria-label", this._opts.label), this.onclick(this._domNode, (n) => {
      this._opts.onTrigger(), n.preventDefault();
    }), this.onkeydown(this._domNode, (n) => {
      var r, s;
      if (n.equals(
        10
        /* KeyCode.Space */
      ) || n.equals(
        3
        /* KeyCode.Enter */
      )) {
        this._opts.onTrigger(), n.preventDefault();
        return;
      }
      (s = (r = this._opts).onKeyDown) === null || s === void 0 || s.call(r, n);
    });
  }
  get domNode() {
    return this._domNode;
  }
  isEnabled() {
    return this._domNode.tabIndex >= 0;
  }
  focus() {
    this._domNode.focus();
  }
  setEnabled(e) {
    this._domNode.classList.toggle("disabled", !e), this._domNode.setAttribute("aria-disabled", String(!e)), this._domNode.tabIndex = e ? 0 : -1;
  }
  setExpanded(e) {
    this._domNode.setAttribute("aria-expanded", String(!!e)), e ? (this._domNode.classList.remove(...ft.asClassNameArray(K$)), this._domNode.classList.add(...ft.asClassNameArray(Y$))) : (this._domNode.classList.remove(...ft.asClassNameArray(Y$)), this._domNode.classList.add(...ft.asClassNameArray(K$)));
  }
}
fc((i, e) => {
  const t = (p, m) => {
    m && e.addRule(`.monaco-editor ${p} { background-color: ${m}; }`);
  };
  t(".findMatch", i.getColor(nu)), t(".currentFindMatch", i.getColor(OMe)), t(".findScope", i.getColor(MMe));
  const n = i.getColor(ji);
  t(".find-widget", n);
  const r = i.getColor(Qd);
  r && e.addRule(`.monaco-editor .find-widget { box-shadow: 0 0 8px 2px ${r}; }`);
  const s = i.getColor(hz);
  s && e.addRule(`.monaco-editor .find-widget { border-left: 1px solid ${s}; border-right: 1px solid ${s}; border-bottom: 1px solid ${s}; }`);
  const o = i.getColor($f);
  o && e.addRule(`.monaco-editor .findMatch { border: 1px ${ed(i.type) ? "dotted" : "solid"} ${o}; box-sizing: border-box; }`);
  const a = i.getColor(RMe);
  a && e.addRule(`.monaco-editor .currentFindMatch { border: 2px solid ${a}; padding: 1px; box-sizing: border-box; }`);
  const l = i.getColor(FMe);
  l && e.addRule(`.monaco-editor .findScope { border: 1px ${ed(i.type) ? "dashed" : "solid"} ${l}; }`);
  const c = i.getColor($t);
  c && e.addRule(`.monaco-editor .find-widget { border: 1px solid ${c}; }`);
  const d = i.getColor(eu);
  d && e.addRule(`.monaco-editor .find-widget { color: ${d}; }`);
  const u = i.getColor(iMe);
  u && e.addRule(`.monaco-editor .find-widget.no-results .matchesCount { color: ${u}; }`);
  const h = i.getColor(DMe);
  if (h)
    e.addRule(`.monaco-editor .find-widget .monaco-sash { background-color: ${h}; }`);
  else {
    const p = i.getColor(tu);
    p && e.addRule(`.monaco-editor .find-widget .monaco-sash { background-color: ${p}; }`);
  }
  const f = i.getColor(kF);
  f && e.addRule(`
		.monaco-editor .find-widget .button:not(.disabled):hover,
		.monaco-editor .find-widget .codicon-find-selection:hover {
			background-color: ${f} !important;
		}
	`);
  const g = i.getColor(Ta);
  g && e.addRule(`.monaco-editor .find-widget .monaco-inputbox.synthetic-focus { outline-color: ${g}; }`);
});
var N1e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Tc = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, h0 = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, fH;
const stt = 524288;
function gH(i, e = "single", t = !1) {
  if (!i.hasModel())
    return null;
  const n = i.getSelection();
  if (e === "single" && n.startLineNumber === n.endLineNumber || e === "multiple") {
    if (n.isEmpty()) {
      const r = i.getConfiguredWordAtPosition(n.getStartPosition());
      if (r && t === !1)
        return r.word;
    } else if (i.getModel().getValueLengthInRange(n) < stt)
      return i.getModel().getValueInRange(n);
  }
  return null;
}
let bo = fH = class extends we {
  get editor() {
    return this._editor;
  }
  static get(e) {
    return e.getContribution(fH.ID);
  }
  constructor(e, t, n, r, s) {
    super(), this._editor = e, this._findWidgetVisible = ff.bindTo(t), this._contextKeyService = t, this._storageService = n, this._clipboardService = r, this._notificationService = s, this._updateHistoryDelayer = new ac(500), this._state = this._register(new Tet()), this.loadQueryState(), this._register(this._state.onFindReplaceStateChange((o) => this._onStateChanged(o))), this._model = null, this._register(this._editor.onDidChangeModel(() => {
      const o = this._editor.getModel() && this._state.isRevealed;
      this.disposeModel(), this._state.change({
        searchScope: null,
        matchCase: this._storageService.getBoolean("editor.matchCase", 1, !1),
        wholeWord: this._storageService.getBoolean("editor.wholeWord", 1, !1),
        isRegex: this._storageService.getBoolean("editor.isRegex", 1, !1),
        preserveCase: this._storageService.getBoolean("editor.preserveCase", 1, !1)
      }, !1), o && this._start({
        forceRevealReplace: !1,
        seedSearchStringFromSelection: "none",
        seedSearchStringFromNonEmptySelection: !1,
        seedSearchStringFromGlobalClipboard: !1,
        shouldFocus: 0,
        shouldAnimate: !1,
        updateSearchScope: !1,
        loop: this._editor.getOption(
          41
          /* EditorOption.find */
        ).loop
      });
    }));
  }
  dispose() {
    this.disposeModel(), super.dispose();
  }
  disposeModel() {
    this._model && (this._model.dispose(), this._model = null);
  }
  _onStateChanged(e) {
    this.saveQueryState(e), e.isRevealed && (this._state.isRevealed ? this._findWidgetVisible.set(!0) : (this._findWidgetVisible.reset(), this.disposeModel())), e.searchString && this.setGlobalBufferTerm(this._state.searchString);
  }
  saveQueryState(e) {
    e.isRegex && this._storageService.store(
      "editor.isRegex",
      this._state.actualIsRegex,
      1,
      1
      /* StorageTarget.MACHINE */
    ), e.wholeWord && this._storageService.store(
      "editor.wholeWord",
      this._state.actualWholeWord,
      1,
      1
      /* StorageTarget.MACHINE */
    ), e.matchCase && this._storageService.store(
      "editor.matchCase",
      this._state.actualMatchCase,
      1,
      1
      /* StorageTarget.MACHINE */
    ), e.preserveCase && this._storageService.store(
      "editor.preserveCase",
      this._state.actualPreserveCase,
      1,
      1
      /* StorageTarget.MACHINE */
    );
  }
  loadQueryState() {
    this._state.change({
      matchCase: this._storageService.getBoolean("editor.matchCase", 1, this._state.matchCase),
      wholeWord: this._storageService.getBoolean("editor.wholeWord", 1, this._state.wholeWord),
      isRegex: this._storageService.getBoolean("editor.isRegex", 1, this._state.isRegex),
      preserveCase: this._storageService.getBoolean("editor.preserveCase", 1, this._state.preserveCase)
    }, !1);
  }
  isFindInputFocused() {
    return !!S5.getValue(this._contextKeyService);
  }
  getState() {
    return this._state;
  }
  closeFindWidget() {
    this._state.change({
      isRevealed: !1,
      searchScope: null
    }, !1), this._editor.focus();
  }
  toggleCaseSensitive() {
    this._state.change({ matchCase: !this._state.matchCase }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleWholeWords() {
    this._state.change({ wholeWord: !this._state.wholeWord }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleRegex() {
    this._state.change({ isRegex: !this._state.isRegex }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  togglePreserveCase() {
    this._state.change({ preserveCase: !this._state.preserveCase }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleSearchScope() {
    if (this._state.searchScope)
      this._state.change({ searchScope: null }, !0);
    else if (this._editor.hasModel()) {
      const e = this._editor.getSelections();
      e.map((t) => (t.endColumn === 1 && t.endLineNumber > t.startLineNumber && (t = t.setEndPosition(t.endLineNumber - 1, this._editor.getModel().getLineMaxColumn(t.endLineNumber - 1))), t.isEmpty() ? null : t)).filter((t) => !!t), e.length && this._state.change({ searchScope: e }, !0);
    }
  }
  setSearchString(e) {
    this._state.isRegex && (e = Va(e)), this._state.change({ searchString: e }, !1);
  }
  highlightFindOptions(e = !1) {
  }
  _start(e, t) {
    return h0(this, void 0, void 0, function* () {
      if (this.disposeModel(), !this._editor.hasModel())
        return;
      const n = Object.assign(Object.assign({}, t), { isRevealed: !0 });
      if (e.seedSearchStringFromSelection === "single") {
        const r = gH(this._editor, e.seedSearchStringFromSelection, e.seedSearchStringFromNonEmptySelection);
        r && (this._state.isRegex ? n.searchString = Va(r) : n.searchString = r);
      } else if (e.seedSearchStringFromSelection === "multiple" && !e.updateSearchScope) {
        const r = gH(this._editor, e.seedSearchStringFromSelection);
        r && (n.searchString = r);
      }
      if (!n.searchString && e.seedSearchStringFromGlobalClipboard) {
        const r = yield this.getGlobalBufferTerm();
        if (!this._editor.hasModel())
          return;
        r && (n.searchString = r);
      }
      if (e.forceRevealReplace || n.isReplaceRevealed ? n.isReplaceRevealed = !0 : this._findWidgetVisible.get() || (n.isReplaceRevealed = !1), e.updateSearchScope) {
        const r = this._editor.getSelections();
        r.some((s) => !s.isEmpty()) && (n.searchScope = r);
      }
      n.loop = e.loop, this._state.change(n, !1), this._model || (this._model = new GC(this._editor, this._state));
    });
  }
  start(e, t) {
    return this._start(e, t);
  }
  moveToNextMatch() {
    return this._model ? (this._model.moveToNextMatch(), !0) : !1;
  }
  moveToPrevMatch() {
    return this._model ? (this._model.moveToPrevMatch(), !0) : !1;
  }
  goToMatch(e) {
    return this._model ? (this._model.moveToMatch(e), !0) : !1;
  }
  replace() {
    return this._model ? (this._model.replace(), !0) : !1;
  }
  replaceAll() {
    var e;
    return this._model ? !((e = this._editor.getModel()) === null || e === void 0) && e.isTooLargeForHeapOperation() ? (this._notificationService.warn(C("too.large.for.replaceall", "The file is too large to perform a replace all operation.")), !1) : (this._model.replaceAll(), !0) : !1;
  }
  selectAllMatches() {
    return this._model ? (this._model.selectAllMatches(), this._editor.focus(), !0) : !1;
  }
  getGlobalBufferTerm() {
    return h0(this, void 0, void 0, function* () {
      return this._editor.getOption(
        41
        /* EditorOption.find */
      ).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing() ? this._clipboardService.readFindText() : "";
    });
  }
  setGlobalBufferTerm(e) {
    this._editor.getOption(
      41
      /* EditorOption.find */
    ).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing() && this._clipboardService.writeFindText(e);
  }
};
bo.ID = "editor.contrib.findController";
bo = fH = N1e([
  Tc(1, yt),
  Tc(2, mc),
  Tc(3, hf),
  Tc(4, dr)
], bo);
let pH = class extends bo {
  constructor(e, t, n, r, s, o, a, l) {
    super(e, n, a, l, o), this._contextViewService = t, this._keybindingService = r, this._themeService = s, this._widget = null, this._findOptionsWidget = null;
  }
  _start(e, t) {
    const n = Object.create(null, {
      _start: { get: () => super._start }
    });
    return h0(this, void 0, void 0, function* () {
      this._widget || this._createFindWidget();
      const r = this._editor.getSelection();
      let s = !1;
      switch (this._editor.getOption(
        41
        /* EditorOption.find */
      ).autoFindInSelection) {
        case "always":
          s = !0;
          break;
        case "never":
          s = !1;
          break;
        case "multiline": {
          s = !!r && r.startLineNumber !== r.endLineNumber;
          break;
        }
      }
      e.updateSearchScope = e.updateSearchScope || s, yield n._start.call(this, e, t), this._widget && (e.shouldFocus === 2 ? this._widget.focusReplaceInput() : e.shouldFocus === 1 && this._widget.focusFindInput());
    });
  }
  highlightFindOptions(e = !1) {
    this._widget || this._createFindWidget(), this._state.isRevealed && !e ? this._widget.highlightFindOptions() : this._findOptionsWidget.highlightFindOptions();
  }
  _createFindWidget() {
    this._widget = this._register(new D5(this._editor, this, this._state, this._contextViewService, this._keybindingService, this._contextKeyService, this._themeService, this._storageService, this._notificationService)), this._findOptionsWidget = this._register(new x5(this._editor, this._state, this._keybindingService));
  }
};
pH = N1e([
  Tc(1, cf),
  Tc(2, yt),
  Tc(3, Bn),
  Tc(4, Pr),
  Tc(5, dr),
  Tc(6, mc),
  Tc(7, hf)
], pH);
const ott = Ghe(new Uhe({
  id: Gn.StartFindAction,
  label: C("startFindAction", "Find"),
  alias: "Find",
  precondition: ke.or($.focus, ke.has("editorIsOpen")),
  kbOpts: {
    kbExpr: null,
    primary: 2084,
    weight: 100
    /* KeybindingWeight.EditorContrib */
  },
  menuOpts: {
    menuId: J.MenubarEditMenu,
    group: "3_find",
    title: C({ key: "miFind", comment: ["&& denotes a mnemonic"] }, "&&Find"),
    order: 1
  }
}));
ott.addImplementation(0, (i, e, t) => {
  const n = bo.get(e);
  return n ? n.start({
    forceRevealReplace: !1,
    seedSearchStringFromSelection: e.getOption(
      41
      /* EditorOption.find */
    ).seedSearchStringFromSelection !== "never" ? "single" : "none",
    seedSearchStringFromNonEmptySelection: e.getOption(
      41
      /* EditorOption.find */
    ).seedSearchStringFromSelection === "selection",
    seedSearchStringFromGlobalClipboard: e.getOption(
      41
      /* EditorOption.find */
    ).globalFindClipboard,
    shouldFocus: 1,
    shouldAnimate: !0,
    updateSearchScope: !1,
    loop: e.getOption(
      41
      /* EditorOption.find */
    ).loop
  }) : !1;
});
const att = {
  description: "Open a new In-Editor Find Widget.",
  args: [{
    name: "Open a new In-Editor Find Widget args",
    schema: {
      properties: {
        searchString: { type: "string" },
        replaceString: { type: "string" },
        regex: { type: "boolean" },
        regexOverride: {
          type: "number",
          description: C("actions.find.isRegexOverride", `Overrides "Use Regular Expression" flag.
The flag will not be saved for the future.
0: Do Nothing
1: True
2: False`)
        },
        wholeWord: { type: "boolean" },
        wholeWordOverride: {
          type: "number",
          description: C("actions.find.wholeWordOverride", `Overrides "Match Whole Word" flag.
The flag will not be saved for the future.
0: Do Nothing
1: True
2: False`)
        },
        matchCase: { type: "boolean" },
        matchCaseOverride: {
          type: "number",
          description: C("actions.find.matchCaseOverride", `Overrides "Math Case" flag.
The flag will not be saved for the future.
0: Do Nothing
1: True
2: False`)
        },
        preserveCase: { type: "boolean" },
        preserveCaseOverride: {
          type: "number",
          description: C("actions.find.preserveCaseOverride", `Overrides "Preserve Case" flag.
The flag will not be saved for the future.
0: Do Nothing
1: True
2: False`)
        },
        findInSelection: { type: "boolean" }
      }
    }
  }]
};
class ltt extends Je {
  constructor() {
    super({
      id: Gn.StartFindWithArgs,
      label: C("startFindWithArgsAction", "Find With Arguments"),
      alias: "Find With Arguments",
      precondition: void 0,
      kbOpts: {
        kbExpr: null,
        primary: 0,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      description: att
    });
  }
  run(e, t, n) {
    return h0(this, void 0, void 0, function* () {
      const r = bo.get(t);
      if (r) {
        const s = n ? {
          searchString: n.searchString,
          replaceString: n.replaceString,
          isReplaceRevealed: n.replaceString !== void 0,
          isRegex: n.isRegex,
          // isRegexOverride: args.regexOverride,
          wholeWord: n.matchWholeWord,
          // wholeWordOverride: args.wholeWordOverride,
          matchCase: n.isCaseSensitive,
          // matchCaseOverride: args.matchCaseOverride,
          preserveCase: n.preserveCase
          // preserveCaseOverride: args.preserveCaseOverride,
        } : {};
        yield r.start({
          forceRevealReplace: !1,
          seedSearchStringFromSelection: r.getState().searchString.length === 0 && t.getOption(
            41
            /* EditorOption.find */
          ).seedSearchStringFromSelection !== "never" ? "single" : "none",
          seedSearchStringFromNonEmptySelection: t.getOption(
            41
            /* EditorOption.find */
          ).seedSearchStringFromSelection === "selection",
          seedSearchStringFromGlobalClipboard: !0,
          shouldFocus: 1,
          shouldAnimate: !0,
          updateSearchScope: n?.findInSelection || !1,
          loop: t.getOption(
            41
            /* EditorOption.find */
          ).loop
        }, s), r.setGlobalBufferTerm(r.getState().searchString);
      }
    });
  }
}
class ctt extends Je {
  constructor() {
    super({
      id: Gn.StartFindWithSelection,
      label: C("startFindWithSelectionAction", "Find With Selection"),
      alias: "Find With Selection",
      precondition: void 0,
      kbOpts: {
        kbExpr: null,
        primary: 0,
        mac: {
          primary: 2083
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    return h0(this, void 0, void 0, function* () {
      const n = bo.get(t);
      n && (yield n.start({
        forceRevealReplace: !1,
        seedSearchStringFromSelection: "multiple",
        seedSearchStringFromNonEmptySelection: !1,
        seedSearchStringFromGlobalClipboard: !1,
        shouldFocus: 0,
        shouldAnimate: !0,
        updateSearchScope: !1,
        loop: t.getOption(
          41
          /* EditorOption.find */
        ).loop
      }), n.setGlobalBufferTerm(n.getState().searchString));
    });
  }
}
class P1e extends Je {
  run(e, t) {
    return h0(this, void 0, void 0, function* () {
      const n = bo.get(t);
      n && !this._run(n) && (yield n.start({
        forceRevealReplace: !1,
        seedSearchStringFromSelection: n.getState().searchString.length === 0 && t.getOption(
          41
          /* EditorOption.find */
        ).seedSearchStringFromSelection !== "never" ? "single" : "none",
        seedSearchStringFromNonEmptySelection: t.getOption(
          41
          /* EditorOption.find */
        ).seedSearchStringFromSelection === "selection",
        seedSearchStringFromGlobalClipboard: !0,
        shouldFocus: 0,
        shouldAnimate: !0,
        updateSearchScope: !1,
        loop: t.getOption(
          41
          /* EditorOption.find */
        ).loop
      }), this._run(n));
    });
  }
}
class dtt extends P1e {
  constructor() {
    super({
      id: Gn.NextMatchFindAction,
      label: C("findNextMatchAction", "Find Next"),
      alias: "Find Next",
      precondition: void 0,
      kbOpts: [{
        kbExpr: $.focus,
        primary: 61,
        mac: { primary: 2085, secondary: [
          61
          /* KeyCode.F3 */
        ] },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }, {
        kbExpr: ke.and($.focus, S5),
        primary: 3,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }]
    });
  }
  _run(e) {
    return e.moveToNextMatch() ? (e.editor.pushUndoStop(), !0) : !1;
  }
}
class utt extends P1e {
  constructor() {
    super({
      id: Gn.PreviousMatchFindAction,
      label: C("findPreviousMatchAction", "Find Previous"),
      alias: "Find Previous",
      precondition: void 0,
      kbOpts: [
        {
          kbExpr: $.focus,
          primary: 1085,
          mac: { primary: 3109, secondary: [
            1085
            /* KeyCode.F3 */
          ] },
          weight: 100
          /* KeybindingWeight.EditorContrib */
        },
        {
          kbExpr: ke.and($.focus, S5),
          primary: 1027,
          weight: 100
          /* KeybindingWeight.EditorContrib */
        }
      ]
    });
  }
  _run(e) {
    return e.moveToPrevMatch();
  }
}
class htt extends Je {
  constructor() {
    super({
      id: Gn.GoToMatchFindAction,
      label: C("findMatchAction.goToMatch", "Go to Match..."),
      alias: "Go to Match...",
      precondition: ff
    }), this._highlightDecorations = [];
  }
  run(e, t, n) {
    const r = bo.get(t);
    if (!r)
      return;
    const s = r.getState().matchesCount;
    if (s < 1) {
      e.get(dr).notify({
        severity: I4.Warning,
        message: C("findMatchAction.noResults", "No matches. Try searching for something else.")
      });
      return;
    }
    const a = e.get(bd).createInputBox();
    a.placeholder = C("findMatchAction.inputPlaceHolder", "Type a number to go to a specific match (between 1 and {0})", s);
    const l = (d) => {
      const u = parseInt(d);
      if (isNaN(u))
        return;
      const h = r.getState().matchesCount;
      if (u > 0 && u <= h)
        return u - 1;
      if (u < 0 && u >= -h)
        return h + u;
    }, c = (d) => {
      const u = l(d);
      if (typeof u == "number") {
        a.validationMessage = void 0, r.goToMatch(u);
        const h = r.getState().currentMatch;
        h && this.addDecorations(t, h);
      } else
        a.validationMessage = C("findMatchAction.inputValidationMessage", "Please type a number between 1 and {0}", r.getState().matchesCount), this.clearDecorations(t);
    };
    a.onDidChangeValue((d) => {
      c(d);
    }), a.onDidAccept(() => {
      const d = l(a.value);
      typeof d == "number" ? (r.goToMatch(d), a.hide()) : a.validationMessage = C("findMatchAction.inputValidationMessage", "Please type a number between 1 and {0}", r.getState().matchesCount);
    }), a.onDidHide(() => {
      this.clearDecorations(t), a.dispose();
    }), a.show();
  }
  clearDecorations(e) {
    e.changeDecorations((t) => {
      this._highlightDecorations = t.deltaDecorations(this._highlightDecorations, []);
    });
  }
  addDecorations(e, t) {
    e.changeDecorations((n) => {
      this._highlightDecorations = n.deltaDecorations(this._highlightDecorations, [
        {
          range: t,
          options: {
            description: "find-match-quick-access-range-highlight",
            className: "rangeHighlight",
            isWholeLine: !0
          }
        },
        {
          range: t,
          options: {
            description: "find-match-quick-access-range-highlight-overview",
            overviewRuler: {
              color: Oi(Kfe),
              position: Ha.Full
            }
          }
        }
      ]);
    });
  }
}
class O1e extends Je {
  run(e, t) {
    return h0(this, void 0, void 0, function* () {
      const n = bo.get(t);
      if (!n)
        return;
      const r = gH(t, "single", !1);
      r && n.setSearchString(r), this._run(n) || (yield n.start({
        forceRevealReplace: !1,
        seedSearchStringFromSelection: "none",
        seedSearchStringFromNonEmptySelection: !1,
        seedSearchStringFromGlobalClipboard: !1,
        shouldFocus: 0,
        shouldAnimate: !0,
        updateSearchScope: !1,
        loop: t.getOption(
          41
          /* EditorOption.find */
        ).loop
      }), this._run(n));
    });
  }
}
class ftt extends O1e {
  constructor() {
    super({
      id: Gn.NextSelectionMatchFindAction,
      label: C("nextSelectionMatchFindAction", "Find Next Selection"),
      alias: "Find Next Selection",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 2109,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  _run(e) {
    return e.moveToNextMatch();
  }
}
class gtt extends O1e {
  constructor() {
    super({
      id: Gn.PreviousSelectionMatchFindAction,
      label: C("previousSelectionMatchFindAction", "Find Previous Selection"),
      alias: "Find Previous Selection",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 3133,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  _run(e) {
    return e.moveToPrevMatch();
  }
}
const ptt = Ghe(new Uhe({
  id: Gn.StartFindReplaceAction,
  label: C("startReplace", "Replace"),
  alias: "Replace",
  precondition: ke.or($.focus, ke.has("editorIsOpen")),
  kbOpts: {
    kbExpr: null,
    primary: 2086,
    mac: {
      primary: 2596
      /* KeyCode.KeyF */
    },
    weight: 100
    /* KeybindingWeight.EditorContrib */
  },
  menuOpts: {
    menuId: J.MenubarEditMenu,
    group: "3_find",
    title: C({ key: "miReplace", comment: ["&& denotes a mnemonic"] }, "&&Replace"),
    order: 2
  }
}));
ptt.addImplementation(0, (i, e, t) => {
  if (!e.hasModel() || e.getOption(
    90
    /* EditorOption.readOnly */
  ))
    return !1;
  const n = bo.get(e);
  if (!n)
    return !1;
  const r = e.getSelection(), s = n.isFindInputFocused(), o = !r.isEmpty() && r.startLineNumber === r.endLineNumber && e.getOption(
    41
    /* EditorOption.find */
  ).seedSearchStringFromSelection !== "never" && !s, a = s || o ? 2 : 1;
  return n.start({
    forceRevealReplace: !0,
    seedSearchStringFromSelection: o ? "single" : "none",
    seedSearchStringFromNonEmptySelection: e.getOption(
      41
      /* EditorOption.find */
    ).seedSearchStringFromSelection === "selection",
    seedSearchStringFromGlobalClipboard: e.getOption(
      41
      /* EditorOption.find */
    ).seedSearchStringFromSelection !== "never",
    shouldFocus: a,
    shouldAnimate: !0,
    updateSearchScope: !1,
    loop: e.getOption(
      41
      /* EditorOption.find */
    ).loop
  });
});
pn(
  bo.ID,
  pH,
  0
  /* EditorContributionInstantiation.Eager */
);
Be(ltt);
Be(ctt);
Be(dtt);
Be(utt);
Be(htt);
Be(ftt);
Be(gtt);
const Cd = Kr.bindToContribution(bo.get);
ze(new Cd({
  id: Gn.CloseFindWidgetCommand,
  precondition: ff,
  handler: (i) => i.closeFindWidget(),
  kbOpts: {
    weight: 105,
    kbExpr: ke.and($.focus, ke.not("isComposing")),
    primary: 9,
    secondary: [
      1033
      /* KeyCode.Escape */
    ]
  }
}));
ze(new Cd({
  id: Gn.ToggleCaseSensitiveCommand,
  precondition: void 0,
  handler: (i) => i.toggleCaseSensitive(),
  kbOpts: {
    weight: 105,
    kbExpr: $.focus,
    primary: RD.primary,
    mac: RD.mac,
    win: RD.win,
    linux: RD.linux
  }
}));
ze(new Cd({
  id: Gn.ToggleWholeWordCommand,
  precondition: void 0,
  handler: (i) => i.toggleWholeWords(),
  kbOpts: {
    weight: 105,
    kbExpr: $.focus,
    primary: FD.primary,
    mac: FD.mac,
    win: FD.win,
    linux: FD.linux
  }
}));
ze(new Cd({
  id: Gn.ToggleRegexCommand,
  precondition: void 0,
  handler: (i) => i.toggleRegex(),
  kbOpts: {
    weight: 105,
    kbExpr: $.focus,
    primary: BD.primary,
    mac: BD.mac,
    win: BD.win,
    linux: BD.linux
  }
}));
ze(new Cd({
  id: Gn.ToggleSearchScopeCommand,
  precondition: void 0,
  handler: (i) => i.toggleSearchScope(),
  kbOpts: {
    weight: 105,
    kbExpr: $.focus,
    primary: VD.primary,
    mac: VD.mac,
    win: VD.win,
    linux: VD.linux
  }
}));
ze(new Cd({
  id: Gn.TogglePreserveCaseCommand,
  precondition: void 0,
  handler: (i) => i.togglePreserveCase(),
  kbOpts: {
    weight: 105,
    kbExpr: $.focus,
    primary: HD.primary,
    mac: HD.mac,
    win: HD.win,
    linux: HD.linux
  }
}));
ze(new Cd({
  id: Gn.ReplaceOneAction,
  precondition: ff,
  handler: (i) => i.replace(),
  kbOpts: {
    weight: 105,
    kbExpr: $.focus,
    primary: 3094
    /* KeyCode.Digit1 */
  }
}));
ze(new Cd({
  id: Gn.ReplaceOneAction,
  precondition: ff,
  handler: (i) => i.replace(),
  kbOpts: {
    weight: 105,
    kbExpr: ke.and($.focus, vG),
    primary: 3
    /* KeyCode.Enter */
  }
}));
ze(new Cd({
  id: Gn.ReplaceAllAction,
  precondition: ff,
  handler: (i) => i.replaceAll(),
  kbOpts: {
    weight: 105,
    kbExpr: $.focus,
    primary: 2563
    /* KeyCode.Enter */
  }
}));
ze(new Cd({
  id: Gn.ReplaceAllAction,
  precondition: ff,
  handler: (i) => i.replaceAll(),
  kbOpts: {
    weight: 105,
    kbExpr: ke.and($.focus, vG),
    primary: void 0,
    mac: {
      primary: 2051
    }
  }
}));
ze(new Cd({
  id: Gn.SelectAllMatchesAction,
  precondition: ff,
  handler: (i) => i.selectAllMatches(),
  kbOpts: {
    weight: 105,
    kbExpr: $.focus,
    primary: 515
    /* KeyCode.Enter */
  }
}));
const mtt = {
  0: " ",
  1: "u",
  2: "r"
}, eee = 65535, Nc = 16777215, tee = 4278190080;
class MT {
  constructor(e) {
    const t = Math.ceil(e / 32);
    this._states = new Uint32Array(t);
  }
  get(e) {
    const t = e / 32 | 0, n = e % 32;
    return (this._states[t] & 1 << n) !== 0;
  }
  set(e, t) {
    const n = e / 32 | 0, r = e % 32, s = this._states[n];
    t ? this._states[n] = s | 1 << r : this._states[n] = s & ~(1 << r);
  }
}
class Sa {
  constructor(e, t, n) {
    if (e.length !== t.length || e.length > eee)
      throw new Error("invalid startIndexes or endIndexes size");
    this._startIndexes = e, this._endIndexes = t, this._collapseStates = new MT(e.length), this._userDefinedStates = new MT(e.length), this._recoveredStates = new MT(e.length), this._types = n, this._parentsComputed = !1;
  }
  ensureParentIndices() {
    if (!this._parentsComputed) {
      this._parentsComputed = !0;
      const e = [], t = (n, r) => {
        const s = e[e.length - 1];
        return this.getStartLineNumber(s) <= n && this.getEndLineNumber(s) >= r;
      };
      for (let n = 0, r = this._startIndexes.length; n < r; n++) {
        const s = this._startIndexes[n], o = this._endIndexes[n];
        if (s > Nc || o > Nc)
          throw new Error("startLineNumber or endLineNumber must not exceed " + Nc);
        for (; e.length > 0 && !t(s, o); )
          e.pop();
        const a = e.length > 0 ? e[e.length - 1] : -1;
        e.push(n), this._startIndexes[n] = s + ((a & 255) << 24), this._endIndexes[n] = o + ((a & 65280) << 16);
      }
    }
  }
  get length() {
    return this._startIndexes.length;
  }
  getStartLineNumber(e) {
    return this._startIndexes[e] & Nc;
  }
  getEndLineNumber(e) {
    return this._endIndexes[e] & Nc;
  }
  getType(e) {
    return this._types ? this._types[e] : void 0;
  }
  hasTypes() {
    return !!this._types;
  }
  isCollapsed(e) {
    return this._collapseStates.get(e);
  }
  setCollapsed(e, t) {
    this._collapseStates.set(e, t);
  }
  isUserDefined(e) {
    return this._userDefinedStates.get(e);
  }
  setUserDefined(e, t) {
    return this._userDefinedStates.set(e, t);
  }
  isRecovered(e) {
    return this._recoveredStates.get(e);
  }
  setRecovered(e, t) {
    return this._recoveredStates.set(e, t);
  }
  getSource(e) {
    return this.isUserDefined(e) ? 1 : this.isRecovered(e) ? 2 : 0;
  }
  setSource(e, t) {
    t === 1 ? (this.setUserDefined(e, !0), this.setRecovered(e, !1)) : t === 2 ? (this.setUserDefined(e, !1), this.setRecovered(e, !0)) : (this.setUserDefined(e, !1), this.setRecovered(e, !1));
  }
  setCollapsedAllOfType(e, t) {
    let n = !1;
    if (this._types)
      for (let r = 0; r < this._types.length; r++)
        this._types[r] === e && (this.setCollapsed(r, t), n = !0);
    return n;
  }
  toRegion(e) {
    return new vtt(this, e);
  }
  getParentIndex(e) {
    this.ensureParentIndices();
    const t = ((this._startIndexes[e] & tee) >>> 24) + ((this._endIndexes[e] & tee) >>> 16);
    return t === eee ? -1 : t;
  }
  contains(e, t) {
    return this.getStartLineNumber(e) <= t && this.getEndLineNumber(e) >= t;
  }
  findIndex(e) {
    let t = 0, n = this._startIndexes.length;
    if (n === 0)
      return -1;
    for (; t < n; ) {
      const r = Math.floor((t + n) / 2);
      e < this.getStartLineNumber(r) ? n = r : t = r + 1;
    }
    return t - 1;
  }
  findRange(e) {
    let t = this.findIndex(e);
    if (t >= 0) {
      if (this.getEndLineNumber(t) >= e)
        return t;
      for (t = this.getParentIndex(t); t !== -1; ) {
        if (this.contains(t, e))
          return t;
        t = this.getParentIndex(t);
      }
    }
    return -1;
  }
  toString() {
    const e = [];
    for (let t = 0; t < this.length; t++)
      e[t] = `[${mtt[this.getSource(t)]}${this.isCollapsed(t) ? "+" : "-"}] ${this.getStartLineNumber(t)}/${this.getEndLineNumber(t)}`;
    return e.join(", ");
  }
  toFoldRange(e) {
    return {
      startLineNumber: this._startIndexes[e] & Nc,
      endLineNumber: this._endIndexes[e] & Nc,
      type: this._types ? this._types[e] : void 0,
      isCollapsed: this.isCollapsed(e),
      source: this.getSource(e)
    };
  }
  static fromFoldRanges(e) {
    const t = e.length, n = new Uint32Array(t), r = new Uint32Array(t);
    let s = [], o = !1;
    for (let l = 0; l < t; l++) {
      const c = e[l];
      n[l] = c.startLineNumber, r[l] = c.endLineNumber, s.push(c.type), c.type && (o = !0);
    }
    o || (s = void 0);
    const a = new Sa(n, r, s);
    for (let l = 0; l < t; l++)
      e[l].isCollapsed && a.setCollapsed(l, !0), a.setSource(l, e[l].source);
    return a;
  }
  /**
   * Two inputs, each a FoldingRegions or a FoldRange[], are merged.
   * Each input must be pre-sorted on startLineNumber.
   * The first list is assumed to always include all regions currently defined by range providers.
   * The second list only contains the previously collapsed and all manual ranges.
   * If the line position matches, the range of the new range is taken, and the range is no longer manual
   * When an entry in one list overlaps an entry in the other, the second list's entry "wins" and
   * overlapping entries in the first list are discarded.
   * Invalid entries are discarded. An entry is invalid if:
   * 		the start and end line numbers aren't a valid range of line numbers,
   * 		it is out of sequence or has the same start line as a preceding entry,
   * 		it overlaps a preceding entry and is not fully contained by that entry.
   */
  static sanitizeAndMerge(e, t, n) {
    n = n ?? Number.MAX_VALUE;
    const r = (p, m) => Array.isArray(p) ? (_) => _ < m ? p[_] : void 0 : (_) => _ < m ? p.toFoldRange(_) : void 0, s = r(e, e.length), o = r(t, t.length);
    let a = 0, l = 0, c = s(0), d = o(0);
    const u = [];
    let h, f = 0;
    const g = [];
    for (; c || d; ) {
      let p;
      if (d && (!c || c.startLineNumber >= d.startLineNumber))
        c && c.startLineNumber === d.startLineNumber ? (d.source === 1 ? p = d : (p = c, p.isCollapsed = d.isCollapsed && c.endLineNumber === d.endLineNumber, p.source = 0), c = s(++a)) : (p = d, d.isCollapsed && d.source === 0 && (p.source = 2)), d = o(++l);
      else {
        let m = l, _ = d;
        for (; ; ) {
          if (!_ || _.startLineNumber > c.endLineNumber) {
            p = c;
            break;
          }
          if (_.source === 1 && _.endLineNumber > c.endLineNumber)
            break;
          _ = o(++m);
        }
        c = s(++a);
      }
      if (p) {
        for (; h && h.endLineNumber < p.startLineNumber; )
          h = u.pop();
        p.endLineNumber > p.startLineNumber && p.startLineNumber > f && p.endLineNumber <= n && (!h || h.endLineNumber >= p.endLineNumber) && (g.push(p), f = p.startLineNumber, h && u.push(h), h = p);
      }
    }
    return g;
  }
}
class vtt {
  constructor(e, t) {
    this.ranges = e, this.index = t;
  }
  get startLineNumber() {
    return this.ranges.getStartLineNumber(this.index);
  }
  get endLineNumber() {
    return this.ranges.getEndLineNumber(this.index);
  }
  get regionIndex() {
    return this.index;
  }
  get parentIndex() {
    return this.ranges.getParentIndex(this.index);
  }
  get isCollapsed() {
    return this.ranges.isCollapsed(this.index);
  }
  containedBy(e) {
    return e.startLineNumber <= this.startLineNumber && e.endLineNumber >= this.endLineNumber;
  }
  containsLine(e) {
    return this.startLineNumber <= e && e <= this.endLineNumber;
  }
}
class _tt {
  get regions() {
    return this._regions;
  }
  get textModel() {
    return this._textModel;
  }
  constructor(e, t) {
    this._updateEventEmitter = new pe(), this.onDidChange = this._updateEventEmitter.event, this._textModel = e, this._decorationProvider = t, this._regions = new Sa(new Uint32Array(0), new Uint32Array(0)), this._editorDecorationIds = [];
  }
  toggleCollapseState(e) {
    if (!e.length)
      return;
    e = e.sort((n, r) => n.regionIndex - r.regionIndex);
    const t = {};
    this._decorationProvider.changeDecorations((n) => {
      let r = 0, s = -1, o = -1;
      const a = (l) => {
        for (; r < l; ) {
          const c = this._regions.getEndLineNumber(r), d = this._regions.isCollapsed(r);
          if (c <= s) {
            const u = this.regions.getSource(r) !== 0;
            n.changeDecorationOptions(this._editorDecorationIds[r], this._decorationProvider.getDecorationOption(d, c <= o, u));
          }
          d && c > o && (o = c), r++;
        }
      };
      for (const l of e) {
        const c = l.regionIndex, d = this._editorDecorationIds[c];
        if (d && !t[d]) {
          t[d] = !0, a(c);
          const u = !this._regions.isCollapsed(c);
          this._regions.setCollapsed(c, u), s = Math.max(s, this._regions.getEndLineNumber(c));
        }
      }
      a(this._regions.length);
    }), this._updateEventEmitter.fire({ model: this, collapseStateChanged: e });
  }
  removeManualRanges(e) {
    const t = new Array(), n = (r) => {
      for (const s of e)
        if (!(s.startLineNumber > r.endLineNumber || r.startLineNumber > s.endLineNumber))
          return !0;
      return !1;
    };
    for (let r = 0; r < this._regions.length; r++) {
      const s = this._regions.toFoldRange(r);
      (s.source === 0 || !n(s)) && t.push(s);
    }
    this.updatePost(Sa.fromFoldRanges(t));
  }
  update(e, t = []) {
    const n = this._currentFoldedOrManualRanges(t), r = Sa.sanitizeAndMerge(e, n, this._textModel.getLineCount());
    this.updatePost(Sa.fromFoldRanges(r));
  }
  updatePost(e) {
    const t = [];
    let n = -1;
    for (let r = 0, s = e.length; r < s; r++) {
      const o = e.getStartLineNumber(r), a = e.getEndLineNumber(r), l = e.isCollapsed(r), c = e.getSource(r) !== 0, d = {
        startLineNumber: o,
        startColumn: this._textModel.getLineMaxColumn(o),
        endLineNumber: a,
        endColumn: this._textModel.getLineMaxColumn(a) + 1
      };
      t.push({ range: d, options: this._decorationProvider.getDecorationOption(l, a <= n, c) }), l && a > n && (n = a);
    }
    this._decorationProvider.changeDecorations((r) => this._editorDecorationIds = r.deltaDecorations(this._editorDecorationIds, t)), this._regions = e, this._updateEventEmitter.fire({ model: this });
  }
  _currentFoldedOrManualRanges(e = []) {
    const t = (r, s) => {
      for (const o of e)
        if (r < o && o <= s)
          return !0;
      return !1;
    }, n = [];
    for (let r = 0, s = this._regions.length; r < s; r++) {
      let o = this.regions.isCollapsed(r);
      const a = this.regions.getSource(r);
      if (o || a !== 0) {
        const l = this._regions.toFoldRange(r), c = this._textModel.getDecorationRange(this._editorDecorationIds[r]);
        c && (o && t(c.startLineNumber, c.endLineNumber) && (o = !1), n.push({
          startLineNumber: c.startLineNumber,
          endLineNumber: c.endLineNumber,
          type: l.type,
          isCollapsed: o,
          source: a
        }));
      }
    }
    return n;
  }
  /**
   * Collapse state memento, for persistence only
   */
  getMemento() {
    const e = this._currentFoldedOrManualRanges(), t = [], n = this._textModel.getLineCount();
    for (let r = 0, s = e.length; r < s; r++) {
      const o = e[r];
      if (o.startLineNumber >= o.endLineNumber || o.startLineNumber < 1 || o.endLineNumber > n)
        continue;
      const a = this._getLinesChecksum(o.startLineNumber + 1, o.endLineNumber);
      t.push({
        startLineNumber: o.startLineNumber,
        endLineNumber: o.endLineNumber,
        isCollapsed: o.isCollapsed,
        source: o.source,
        checksum: a
      });
    }
    return t.length > 0 ? t : void 0;
  }
  /**
   * Apply persisted state, for persistence only
   */
  applyMemento(e) {
    var t, n;
    if (!Array.isArray(e))
      return;
    const r = [], s = this._textModel.getLineCount();
    for (const a of e) {
      if (a.startLineNumber >= a.endLineNumber || a.startLineNumber < 1 || a.endLineNumber > s)
        continue;
      const l = this._getLinesChecksum(a.startLineNumber + 1, a.endLineNumber);
      (!a.checksum || l === a.checksum) && r.push({
        startLineNumber: a.startLineNumber,
        endLineNumber: a.endLineNumber,
        type: void 0,
        isCollapsed: (t = a.isCollapsed) !== null && t !== void 0 ? t : !0,
        source: (n = a.source) !== null && n !== void 0 ? n : 0
        /* FoldSource.provider */
      });
    }
    const o = Sa.sanitizeAndMerge(this._regions, r, s);
    this.updatePost(Sa.fromFoldRanges(o));
  }
  _getLinesChecksum(e, t) {
    return dfe(this._textModel.getLineContent(e) + this._textModel.getLineContent(t)) % 1e6;
  }
  dispose() {
    this._decorationProvider.removeDecorations(this._editorDecorationIds);
  }
  getAllRegionsAtLine(e, t) {
    const n = [];
    if (this._regions) {
      let r = this._regions.findRange(e), s = 1;
      for (; r >= 0; ) {
        const o = this._regions.toRegion(r);
        (!t || t(o, s)) && n.push(o), s++, r = o.parentIndex;
      }
    }
    return n;
  }
  getRegionAtLine(e) {
    if (this._regions) {
      const t = this._regions.findRange(e);
      if (t >= 0)
        return this._regions.toRegion(t);
    }
    return null;
  }
  getRegionsInside(e, t) {
    const n = [], r = e ? e.regionIndex + 1 : 0, s = e ? e.endLineNumber : Number.MAX_VALUE;
    if (t && t.length === 2) {
      const o = [];
      for (let a = r, l = this._regions.length; a < l; a++) {
        const c = this._regions.toRegion(a);
        if (this._regions.getStartLineNumber(a) < s) {
          for (; o.length > 0 && !c.containedBy(o[o.length - 1]); )
            o.pop();
          o.push(c), t(c, o.length) && n.push(c);
        } else
          break;
      }
    } else
      for (let o = r, a = this._regions.length; o < a; o++) {
        const l = this._regions.toRegion(o);
        if (this._regions.getStartLineNumber(o) < s)
          (!t || t(l)) && n.push(l);
        else
          break;
      }
    return n;
  }
}
function M1e(i, e, t) {
  const n = [];
  for (const r of t) {
    const s = i.getRegionAtLine(r);
    if (s) {
      const o = !s.isCollapsed;
      if (n.push(s), e > 1) {
        const a = i.getRegionsInside(s, (l, c) => l.isCollapsed !== o && c < e);
        n.push(...a);
      }
    }
  }
  i.toggleCollapseState(n);
}
function Eb(i, e, t = Number.MAX_VALUE, n) {
  const r = [];
  if (n && n.length > 0)
    for (const s of n) {
      const o = i.getRegionAtLine(s);
      if (o && (o.isCollapsed !== e && r.push(o), t > 1)) {
        const a = i.getRegionsInside(o, (l, c) => l.isCollapsed !== e && c < t);
        r.push(...a);
      }
    }
  else {
    const s = i.getRegionsInside(null, (o, a) => o.isCollapsed !== e && a < t);
    r.push(...s);
  }
  i.toggleCollapseState(r);
}
function R1e(i, e, t, n) {
  const r = [];
  for (const s of n) {
    const o = i.getAllRegionsAtLine(s, (a, l) => a.isCollapsed !== e && l <= t);
    r.push(...o);
  }
  i.toggleCollapseState(r);
}
function btt(i, e, t) {
  const n = [];
  for (const r of t) {
    const s = i.getAllRegionsAtLine(r, (o) => o.isCollapsed !== e);
    s.length > 0 && n.push(s[0]);
  }
  i.toggleCollapseState(n);
}
function Ctt(i, e, t, n) {
  const r = (o, a) => a === e && o.isCollapsed !== t && !n.some((l) => o.containsLine(l)), s = i.getRegionsInside(null, r);
  i.toggleCollapseState(s);
}
function F1e(i, e, t) {
  const n = [];
  for (const o of t) {
    const a = i.getAllRegionsAtLine(o, void 0);
    a.length > 0 && n.push(a[0]);
  }
  const r = (o) => n.every((a) => !a.containedBy(o) && !o.containedBy(a)) && o.isCollapsed !== e, s = i.getRegionsInside(null, r);
  i.toggleCollapseState(s);
}
function CG(i, e, t) {
  const n = i.textModel, r = i.regions, s = [];
  for (let o = r.length - 1; o >= 0; o--)
    if (t !== r.isCollapsed(o)) {
      const a = r.getStartLineNumber(o);
      e.test(n.getLineContent(a)) && s.push(r.toRegion(o));
    }
  i.toggleCollapseState(s);
}
function yG(i, e, t) {
  const n = i.regions, r = [];
  for (let s = n.length - 1; s >= 0; s--)
    t !== n.isCollapsed(s) && e === n.getType(s) && r.push(n.toRegion(s));
  i.toggleCollapseState(r);
}
function ytt(i, e) {
  let t = null;
  const n = e.getRegionAtLine(i);
  if (n !== null && (t = n.startLineNumber, i === t)) {
    const r = n.parentIndex;
    r !== -1 ? t = e.regions.getStartLineNumber(r) : t = null;
  }
  return t;
}
function wtt(i, e) {
  let t = e.getRegionAtLine(i);
  if (t !== null && t.startLineNumber === i) {
    if (i !== t.startLineNumber)
      return t.startLineNumber;
    {
      const n = t.parentIndex;
      let r = 0;
      for (n !== -1 && (r = e.regions.getStartLineNumber(t.parentIndex)); t !== null; )
        if (t.regionIndex > 0) {
          if (t = e.regions.toRegion(t.regionIndex - 1), t.startLineNumber <= r)
            return null;
          if (t.parentIndex === n)
            return t.startLineNumber;
        } else
          return null;
    }
  } else if (e.regions.length > 0)
    for (t = e.regions.toRegion(e.regions.length - 1); t !== null; ) {
      if (t.startLineNumber < i)
        return t.startLineNumber;
      t.regionIndex > 0 ? t = e.regions.toRegion(t.regionIndex - 1) : t = null;
    }
  return null;
}
function Stt(i, e) {
  let t = e.getRegionAtLine(i);
  if (t !== null && t.startLineNumber === i) {
    const n = t.parentIndex;
    let r = 0;
    if (n !== -1)
      r = e.regions.getEndLineNumber(t.parentIndex);
    else {
      if (e.regions.length === 0)
        return null;
      r = e.regions.getEndLineNumber(e.regions.length - 1);
    }
    for (; t !== null; )
      if (t.regionIndex < e.regions.length) {
        if (t = e.regions.toRegion(t.regionIndex + 1), t.startLineNumber >= r)
          return null;
        if (t.parentIndex === n)
          return t.startLineNumber;
      } else
        return null;
  } else if (e.regions.length > 0)
    for (t = e.regions.toRegion(0); t !== null; ) {
      if (t.startLineNumber > i)
        return t.startLineNumber;
      t.regionIndex < e.regions.length ? t = e.regions.toRegion(t.regionIndex + 1) : t = null;
    }
  return null;
}
class xtt {
  get onDidChange() {
    return this._updateEventEmitter.event;
  }
  get hiddenRanges() {
    return this._hiddenRanges;
  }
  constructor(e) {
    this._updateEventEmitter = new pe(), this._hasLineChanges = !1, this._foldingModel = e, this._foldingModelListener = e.onDidChange((t) => this.updateHiddenRanges()), this._hiddenRanges = [], e.regions.length && this.updateHiddenRanges();
  }
  notifyChangeModelContent(e) {
    this._hiddenRanges.length && !this._hasLineChanges && (this._hasLineChanges = e.changes.some((t) => t.range.endLineNumber !== t.range.startLineNumber || Wg(t.text)[0] !== 0));
  }
  updateHiddenRanges() {
    let e = !1;
    const t = [];
    let n = 0, r = 0, s = Number.MAX_VALUE, o = -1;
    const a = this._foldingModel.regions;
    for (; n < a.length; n++) {
      if (!a.isCollapsed(n))
        continue;
      const l = a.getStartLineNumber(n) + 1, c = a.getEndLineNumber(n);
      s <= l && c <= o || (!e && r < this._hiddenRanges.length && this._hiddenRanges[r].startLineNumber === l && this._hiddenRanges[r].endLineNumber === c ? (t.push(this._hiddenRanges[r]), r++) : (e = !0, t.push(new V(l, 1, c, 1))), s = l, o = c);
    }
    (this._hasLineChanges || e || r < this._hiddenRanges.length) && this.applyHiddenRanges(t);
  }
  applyHiddenRanges(e) {
    this._hiddenRanges = e, this._hasLineChanges = !1, this._updateEventEmitter.fire(e);
  }
  hasRanges() {
    return this._hiddenRanges.length > 0;
  }
  isHidden(e) {
    return nee(this._hiddenRanges, e) !== null;
  }
  adjustSelections(e) {
    let t = !1;
    const n = this._foldingModel.textModel;
    let r = null;
    const s = (o) => ((!r || !Dtt(o, r)) && (r = nee(this._hiddenRanges, o)), r ? r.startLineNumber - 1 : null);
    for (let o = 0, a = e.length; o < a; o++) {
      let l = e[o];
      const c = s(l.startLineNumber);
      c && (l = l.setStartPosition(c, n.getLineMaxColumn(c)), t = !0);
      const d = s(l.endLineNumber);
      d && (l = l.setEndPosition(d, n.getLineMaxColumn(d)), t = !0), e[o] = l;
    }
    return t;
  }
  dispose() {
    this.hiddenRanges.length > 0 && (this._hiddenRanges = [], this._updateEventEmitter.fire(this._hiddenRanges)), this._foldingModelListener && (this._foldingModelListener.dispose(), this._foldingModelListener = null);
  }
}
function Dtt(i, e) {
  return i >= e.startLineNumber && i <= e.endLineNumber;
}
function nee(i, e) {
  const t = My(i, (n) => e < n.startLineNumber) - 1;
  return t >= 0 && i[t].endLineNumber >= e ? i[t] : null;
}
const Ett = 5e3, Ltt = "indent";
class wG {
  constructor(e, t, n) {
    this.editorModel = e, this.languageConfigurationService = t, this.foldingRangesLimit = n, this.id = Ltt;
  }
  dispose() {
  }
  compute(e) {
    const t = this.languageConfigurationService.getLanguageConfiguration(this.editorModel.getLanguageId()).foldingRules, n = t && !!t.offSide, r = t && t.markers;
    return Promise.resolve(ktt(this.editorModel, n, r, this.foldingRangesLimit));
  }
}
let Itt = class {
  constructor(e) {
    this._startIndexes = [], this._endIndexes = [], this._indentOccurrences = [], this._length = 0, this._foldingRangesLimit = e;
  }
  insertFirst(e, t, n) {
    if (e > Nc || t > Nc)
      return;
    const r = this._length;
    this._startIndexes[r] = e, this._endIndexes[r] = t, this._length++, n < 1e3 && (this._indentOccurrences[n] = (this._indentOccurrences[n] || 0) + 1);
  }
  toIndentRanges(e) {
    const t = this._foldingRangesLimit.limit;
    if (this._length <= t) {
      this._foldingRangesLimit.update(this._length, !1);
      const n = new Uint32Array(this._length), r = new Uint32Array(this._length);
      for (let s = this._length - 1, o = 0; s >= 0; s--, o++)
        n[o] = this._startIndexes[s], r[o] = this._endIndexes[s];
      return new Sa(n, r);
    } else {
      this._foldingRangesLimit.update(this._length, t);
      let n = 0, r = this._indentOccurrences.length;
      for (let l = 0; l < this._indentOccurrences.length; l++) {
        const c = this._indentOccurrences[l];
        if (c) {
          if (c + n > t) {
            r = l;
            break;
          }
          n += c;
        }
      }
      const s = e.getOptions().tabSize, o = new Uint32Array(t), a = new Uint32Array(t);
      for (let l = this._length - 1, c = 0; l >= 0; l--) {
        const d = this._startIndexes[l], u = e.getLineContent(d), h = S4(u, s);
        (h < r || h === r && n++ < t) && (o[c] = d, a[c] = this._endIndexes[l], c++);
      }
      return new Sa(o, a);
    }
  }
};
const Att = {
  limit: Ett,
  update: () => {
  }
};
function ktt(i, e, t, n = Att) {
  const r = i.getOptions().tabSize, s = new Itt(n);
  let o;
  t && (o = new RegExp(`(${t.start.source})|(?:${t.end.source})`));
  const a = [], l = i.getLineCount() + 1;
  a.push({ indent: -1, endAbove: l, line: l });
  for (let c = i.getLineCount(); c > 0; c--) {
    const d = i.getLineContent(c), u = S4(d, r);
    let h = a[a.length - 1];
    if (u === -1) {
      e && (h.endAbove = c);
      continue;
    }
    let f;
    if (o && (f = d.match(o)))
      if (f[1]) {
        let g = a.length - 1;
        for (; g > 0 && a[g].indent !== -2; )
          g--;
        if (g > 0) {
          a.length = g + 1, h = a[g], s.insertFirst(c, h.line, u), h.line = c, h.indent = u, h.endAbove = c;
          continue;
        }
      } else {
        a.push({ indent: -2, endAbove: c, line: c });
        continue;
      }
    if (h.indent > u) {
      do
        a.pop(), h = a[a.length - 1];
      while (h.indent > u);
      const g = h.endAbove - 1;
      g - c >= 1 && s.insertFirst(c, g, u);
    }
    h.indent === u ? h.endAbove = c : a.push({ indent: u, endAbove: c, line: c });
  }
  return s.toIndentRanges(i);
}
const Ttt = ne("editor.foldBackground", { light: dt(Jf, 0.3), dark: dt(Jf, 0.3), hcDark: null, hcLight: null }, C("foldBackgroundBackground", "Background color behind folded ranges. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("editorGutter.foldingControlForeground", { dark: Qf, light: Qf, hcDark: Qf, hcLight: Qf }, C("editorGutter.foldingControlForeground", "Color of the folding control in the editor gutter."));
const E5 = $i("folding-expanded", We.chevronDown, C("foldingExpandedIcon", "Icon for expanded ranges in the editor glyph margin.")), L5 = $i("folding-collapsed", We.chevronRight, C("foldingCollapsedIcon", "Icon for collapsed ranges in the editor glyph margin.")), B1e = $i("folding-manual-collapsed", L5, C("foldingManualCollapedIcon", "Icon for manually collapsed ranges in the editor glyph margin.")), V1e = $i("folding-manual-expanded", E5, C("foldingManualExpandedIcon", "Icon for manually expanded ranges in the editor glyph margin.")), SG = { color: Oi(Ttt), position: ia.Inline };
class ur {
  constructor(e) {
    this.editor = e, this.showFoldingControls = "mouseover", this.showFoldingHighlights = !0;
  }
  getDecorationOption(e, t, n) {
    return t ? ur.HIDDEN_RANGE_DECORATION : this.showFoldingControls === "never" ? e ? this.showFoldingHighlights ? ur.NO_CONTROLS_COLLAPSED_HIGHLIGHTED_RANGE_DECORATION : ur.NO_CONTROLS_COLLAPSED_RANGE_DECORATION : ur.NO_CONTROLS_EXPANDED_RANGE_DECORATION : e ? n ? this.showFoldingHighlights ? ur.MANUALLY_COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION : ur.MANUALLY_COLLAPSED_VISUAL_DECORATION : this.showFoldingHighlights ? ur.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION : ur.COLLAPSED_VISUAL_DECORATION : this.showFoldingControls === "mouseover" ? n ? ur.MANUALLY_EXPANDED_AUTO_HIDE_VISUAL_DECORATION : ur.EXPANDED_AUTO_HIDE_VISUAL_DECORATION : n ? ur.MANUALLY_EXPANDED_VISUAL_DECORATION : ur.EXPANDED_VISUAL_DECORATION;
  }
  changeDecorations(e) {
    return this.editor.changeDecorations(e);
  }
  removeDecorations(e) {
    this.editor.removeDecorations(e);
  }
}
ur.COLLAPSED_VISUAL_DECORATION = Lt.register({
  description: "folding-collapsed-visual-decoration",
  stickiness: 0,
  afterContentClassName: "inline-folded",
  isWholeLine: !0,
  firstLineDecorationClassName: ft.asClassName(L5)
});
ur.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION = Lt.register({
  description: "folding-collapsed-highlighted-visual-decoration",
  stickiness: 0,
  afterContentClassName: "inline-folded",
  className: "folded-background",
  minimap: SG,
  isWholeLine: !0,
  firstLineDecorationClassName: ft.asClassName(L5)
});
ur.MANUALLY_COLLAPSED_VISUAL_DECORATION = Lt.register({
  description: "folding-manually-collapsed-visual-decoration",
  stickiness: 0,
  afterContentClassName: "inline-folded",
  isWholeLine: !0,
  firstLineDecorationClassName: ft.asClassName(B1e)
});
ur.MANUALLY_COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION = Lt.register({
  description: "folding-manually-collapsed-highlighted-visual-decoration",
  stickiness: 0,
  afterContentClassName: "inline-folded",
  className: "folded-background",
  minimap: SG,
  isWholeLine: !0,
  firstLineDecorationClassName: ft.asClassName(B1e)
});
ur.NO_CONTROLS_COLLAPSED_RANGE_DECORATION = Lt.register({
  description: "folding-no-controls-range-decoration",
  stickiness: 0,
  afterContentClassName: "inline-folded",
  isWholeLine: !0
});
ur.NO_CONTROLS_COLLAPSED_HIGHLIGHTED_RANGE_DECORATION = Lt.register({
  description: "folding-no-controls-range-decoration",
  stickiness: 0,
  afterContentClassName: "inline-folded",
  className: "folded-background",
  minimap: SG,
  isWholeLine: !0
});
ur.EXPANDED_VISUAL_DECORATION = Lt.register({
  description: "folding-expanded-visual-decoration",
  stickiness: 1,
  isWholeLine: !0,
  firstLineDecorationClassName: "alwaysShowFoldIcons " + ft.asClassName(E5)
});
ur.EXPANDED_AUTO_HIDE_VISUAL_DECORATION = Lt.register({
  description: "folding-expanded-auto-hide-visual-decoration",
  stickiness: 1,
  isWholeLine: !0,
  firstLineDecorationClassName: ft.asClassName(E5)
});
ur.MANUALLY_EXPANDED_VISUAL_DECORATION = Lt.register({
  description: "folding-manually-expanded-visual-decoration",
  stickiness: 0,
  isWholeLine: !0,
  firstLineDecorationClassName: "alwaysShowFoldIcons " + ft.asClassName(V1e)
});
ur.MANUALLY_EXPANDED_AUTO_HIDE_VISUAL_DECORATION = Lt.register({
  description: "folding-manually-expanded-auto-hide-visual-decoration",
  stickiness: 0,
  isWholeLine: !0,
  firstLineDecorationClassName: ft.asClassName(V1e)
});
ur.NO_CONTROLS_EXPANDED_RANGE_DECORATION = Lt.register({
  description: "folding-no-controls-range-decoration",
  stickiness: 0,
  isWholeLine: !0
});
ur.HIDDEN_RANGE_DECORATION = Lt.register({
  description: "folding-hidden-range-decoration",
  stickiness: 1
  /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
});
const Ntt = {}, Ptt = "syntax";
class xG {
  constructor(e, t, n, r, s) {
    this.editorModel = e, this.providers = t, this.handleFoldingRangesChange = n, this.foldingRangesLimit = r, this.fallbackRangeProvider = s, this.id = Ptt, this.disposables = new Ne(), s && this.disposables.add(s);
    for (const o of t)
      typeof o.onDidChange == "function" && this.disposables.add(o.onDidChange(n));
  }
  compute(e) {
    return Ott(this.providers, this.editorModel, e).then((t) => {
      var n, r;
      return t ? Rtt(t, this.foldingRangesLimit) : (r = (n = this.fallbackRangeProvider) === null || n === void 0 ? void 0 : n.compute(e)) !== null && r !== void 0 ? r : null;
    });
  }
  dispose() {
    this.disposables.dispose();
  }
}
function Ott(i, e, t) {
  let n = null;
  const r = i.map((s, o) => Promise.resolve(s.provideFoldingRanges(e, Ntt, t)).then((a) => {
    if (!t.isCancellationRequested && Array.isArray(a)) {
      Array.isArray(n) || (n = []);
      const l = e.getLineCount();
      for (const c of a)
        c.start > 0 && c.end > c.start && c.end <= l && n.push({ start: c.start, end: c.end, rank: o, kind: c.kind });
    }
  }, vr));
  return Promise.all(r).then((s) => n);
}
class Mtt {
  constructor(e) {
    this._startIndexes = [], this._endIndexes = [], this._nestingLevels = [], this._nestingLevelCounts = [], this._types = [], this._length = 0, this._foldingRangesLimit = e;
  }
  add(e, t, n, r) {
    if (e > Nc || t > Nc)
      return;
    const s = this._length;
    this._startIndexes[s] = e, this._endIndexes[s] = t, this._nestingLevels[s] = r, this._types[s] = n, this._length++, r < 30 && (this._nestingLevelCounts[r] = (this._nestingLevelCounts[r] || 0) + 1);
  }
  toIndentRanges() {
    const e = this._foldingRangesLimit.limit;
    if (this._length <= e) {
      this._foldingRangesLimit.update(this._length, !1);
      const t = new Uint32Array(this._length), n = new Uint32Array(this._length);
      for (let r = 0; r < this._length; r++)
        t[r] = this._startIndexes[r], n[r] = this._endIndexes[r];
      return new Sa(t, n, this._types);
    } else {
      this._foldingRangesLimit.update(this._length, e);
      let t = 0, n = this._nestingLevelCounts.length;
      for (let a = 0; a < this._nestingLevelCounts.length; a++) {
        const l = this._nestingLevelCounts[a];
        if (l) {
          if (l + t > e) {
            n = a;
            break;
          }
          t += l;
        }
      }
      const r = new Uint32Array(e), s = new Uint32Array(e), o = [];
      for (let a = 0, l = 0; a < this._length; a++) {
        const c = this._nestingLevels[a];
        (c < n || c === n && t++ < e) && (r[l] = this._startIndexes[a], s[l] = this._endIndexes[a], o[l] = this._types[a], l++);
      }
      return new Sa(r, s, o);
    }
  }
}
function Rtt(i, e) {
  const t = i.sort((o, a) => {
    let l = o.start - a.start;
    return l === 0 && (l = o.rank - a.rank), l;
  }), n = new Mtt(e);
  let r;
  const s = [];
  for (const o of t)
    if (!r)
      r = o, n.add(o.start, o.end, o.kind && o.kind.value, s.length);
    else if (o.start > r.start)
      if (o.end <= r.end)
        s.push(r), r = o, n.add(o.start, o.end, o.kind && o.kind.value, s.length);
      else {
        if (o.start > r.end) {
          do
            r = s.pop();
          while (r && o.start > r.end);
          r && s.push(r), r = o;
        }
        n.add(o.start, o.end, o.kind && o.kind.value, s.length);
      }
  return n.toIndentRanges();
}
var Ftt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, w2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Btt = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, B1;
const Ws = new Ke("foldingEnabled", !1);
let ku = B1 = class extends we {
  static get(e) {
    return e.getContribution(B1.ID);
  }
  static getFoldingRangeProviders(e, t) {
    var n, r;
    const s = e.foldingRangeProvider.ordered(t);
    return (r = (n = B1._foldingRangeSelector) === null || n === void 0 ? void 0 : n.call(B1, s, t)) !== null && r !== void 0 ? r : s;
  }
  constructor(e, t, n, r, s, o) {
    super(), this.contextKeyService = t, this.languageConfigurationService = n, this.languageFeaturesService = o, this.localToDispose = this._register(new Ne()), this.editor = e, this._foldingLimitReporter = new H1e(e);
    const a = this.editor.getOptions();
    this._isEnabled = a.get(
      43
      /* EditorOption.folding */
    ), this._useFoldingProviders = a.get(
      44
      /* EditorOption.foldingStrategy */
    ) !== "indentation", this._unfoldOnClickAfterEndOfLine = a.get(
      48
      /* EditorOption.unfoldOnClickAfterEndOfLine */
    ), this._restoringViewState = !1, this._currentModelHasFoldedImports = !1, this._foldingImportsByDefault = a.get(
      46
      /* EditorOption.foldingImportsByDefault */
    ), this.updateDebounceInfo = s.for(o.foldingRangeProvider, "Folding", { min: 200 }), this.foldingModel = null, this.hiddenRangeModel = null, this.rangeProvider = null, this.foldingRegionPromise = null, this.foldingModelPromise = null, this.updateScheduler = null, this.cursorChangedScheduler = null, this.mouseDownInfo = null, this.foldingDecorationProvider = new ur(e), this.foldingDecorationProvider.showFoldingControls = a.get(
      109
      /* EditorOption.showFoldingControls */
    ), this.foldingDecorationProvider.showFoldingHighlights = a.get(
      45
      /* EditorOption.foldingHighlight */
    ), this.foldingEnabled = Ws.bindTo(this.contextKeyService), this.foldingEnabled.set(this._isEnabled), this._register(this.editor.onDidChangeModel(() => this.onModelChanged())), this._register(this.editor.onDidChangeConfiguration((l) => {
      if (l.hasChanged(
        43
        /* EditorOption.folding */
      ) && (this._isEnabled = this.editor.getOptions().get(
        43
        /* EditorOption.folding */
      ), this.foldingEnabled.set(this._isEnabled), this.onModelChanged()), l.hasChanged(
        47
        /* EditorOption.foldingMaximumRegions */
      ) && this.onModelChanged(), l.hasChanged(
        109
        /* EditorOption.showFoldingControls */
      ) || l.hasChanged(
        45
        /* EditorOption.foldingHighlight */
      )) {
        const c = this.editor.getOptions();
        this.foldingDecorationProvider.showFoldingControls = c.get(
          109
          /* EditorOption.showFoldingControls */
        ), this.foldingDecorationProvider.showFoldingHighlights = c.get(
          45
          /* EditorOption.foldingHighlight */
        ), this.triggerFoldingModelChanged();
      }
      l.hasChanged(
        44
        /* EditorOption.foldingStrategy */
      ) && (this._useFoldingProviders = this.editor.getOptions().get(
        44
        /* EditorOption.foldingStrategy */
      ) !== "indentation", this.onFoldingStrategyChanged()), l.hasChanged(
        48
        /* EditorOption.unfoldOnClickAfterEndOfLine */
      ) && (this._unfoldOnClickAfterEndOfLine = this.editor.getOptions().get(
        48
        /* EditorOption.unfoldOnClickAfterEndOfLine */
      )), l.hasChanged(
        46
        /* EditorOption.foldingImportsByDefault */
      ) && (this._foldingImportsByDefault = this.editor.getOptions().get(
        46
        /* EditorOption.foldingImportsByDefault */
      ));
    })), this.onModelChanged();
  }
  /**
   * Store view state.
   */
  saveViewState() {
    const e = this.editor.getModel();
    if (!e || !this._isEnabled || e.isTooLargeForTokenization())
      return {};
    if (this.foldingModel) {
      const t = this.foldingModel.getMemento(), n = this.rangeProvider ? this.rangeProvider.id : void 0;
      return { collapsedRegions: t, lineCount: e.getLineCount(), provider: n, foldedImports: this._currentModelHasFoldedImports };
    }
  }
  /**
   * Restore view state.
   */
  restoreViewState(e) {
    const t = this.editor.getModel();
    if (!(!t || !this._isEnabled || t.isTooLargeForTokenization() || !this.hiddenRangeModel) && e && (this._currentModelHasFoldedImports = !!e.foldedImports, e.collapsedRegions && e.collapsedRegions.length > 0 && this.foldingModel)) {
      this._restoringViewState = !0;
      try {
        this.foldingModel.applyMemento(e.collapsedRegions);
      } finally {
        this._restoringViewState = !1;
      }
    }
  }
  onModelChanged() {
    this.localToDispose.clear();
    const e = this.editor.getModel();
    !this._isEnabled || !e || e.isTooLargeForTokenization() || (this._currentModelHasFoldedImports = !1, this.foldingModel = new _tt(e, this.foldingDecorationProvider), this.localToDispose.add(this.foldingModel), this.hiddenRangeModel = new xtt(this.foldingModel), this.localToDispose.add(this.hiddenRangeModel), this.localToDispose.add(this.hiddenRangeModel.onDidChange((t) => this.onHiddenRangesChanges(t))), this.updateScheduler = new ac(this.updateDebounceInfo.get(e)), this.cursorChangedScheduler = new Rn(() => this.revealCursor(), 200), this.localToDispose.add(this.cursorChangedScheduler), this.localToDispose.add(this.languageFeaturesService.foldingRangeProvider.onDidChange(() => this.onFoldingStrategyChanged())), this.localToDispose.add(this.editor.onDidChangeModelLanguageConfiguration(() => this.onFoldingStrategyChanged())), this.localToDispose.add(this.editor.onDidChangeModelContent((t) => this.onDidChangeModelContent(t))), this.localToDispose.add(this.editor.onDidChangeCursorPosition(() => this.onCursorPositionChanged())), this.localToDispose.add(this.editor.onMouseDown((t) => this.onEditorMouseDown(t))), this.localToDispose.add(this.editor.onMouseUp((t) => this.onEditorMouseUp(t))), this.localToDispose.add({
      dispose: () => {
        var t, n;
        this.foldingRegionPromise && (this.foldingRegionPromise.cancel(), this.foldingRegionPromise = null), (t = this.updateScheduler) === null || t === void 0 || t.cancel(), this.updateScheduler = null, this.foldingModel = null, this.foldingModelPromise = null, this.hiddenRangeModel = null, this.cursorChangedScheduler = null, (n = this.rangeProvider) === null || n === void 0 || n.dispose(), this.rangeProvider = null;
      }
    }), this.triggerFoldingModelChanged());
  }
  onFoldingStrategyChanged() {
    var e;
    (e = this.rangeProvider) === null || e === void 0 || e.dispose(), this.rangeProvider = null, this.triggerFoldingModelChanged();
  }
  getRangeProvider(e) {
    if (this.rangeProvider)
      return this.rangeProvider;
    const t = new wG(e, this.languageConfigurationService, this._foldingLimitReporter);
    if (this.rangeProvider = t, this._useFoldingProviders && this.foldingModel) {
      const n = B1.getFoldingRangeProviders(this.languageFeaturesService, e);
      n.length > 0 && (this.rangeProvider = new xG(e, n, () => this.triggerFoldingModelChanged(), this._foldingLimitReporter, t));
    }
    return this.rangeProvider;
  }
  getFoldingModel() {
    return this.foldingModelPromise;
  }
  onDidChangeModelContent(e) {
    var t;
    (t = this.hiddenRangeModel) === null || t === void 0 || t.notifyChangeModelContent(e), this.triggerFoldingModelChanged();
  }
  triggerFoldingModelChanged() {
    this.updateScheduler && (this.foldingRegionPromise && (this.foldingRegionPromise.cancel(), this.foldingRegionPromise = null), this.foldingModelPromise = this.updateScheduler.trigger(() => {
      const e = this.foldingModel;
      if (!e)
        return null;
      const t = new Vs(), n = this.getRangeProvider(e.textModel), r = this.foldingRegionPromise = Ir((s) => n.compute(s));
      return r.then((s) => {
        if (s && r === this.foldingRegionPromise) {
          let o;
          if (this._foldingImportsByDefault && !this._currentModelHasFoldedImports) {
            const d = s.setCollapsedAllOfType(go.Imports.value, !0);
            d && (o = ud.capture(this.editor), this._currentModelHasFoldedImports = d);
          }
          const a = this.editor.getSelections(), l = a ? a.map((d) => d.startLineNumber) : [];
          e.update(s, l), o?.restore(this.editor);
          const c = this.updateDebounceInfo.update(e.textModel, t.elapsed());
          this.updateScheduler && (this.updateScheduler.defaultDelay = c);
        }
        return e;
      });
    }).then(void 0, (e) => (It(e), null)));
  }
  onHiddenRangesChanges(e) {
    if (this.hiddenRangeModel && e.length && !this._restoringViewState) {
      const t = this.editor.getSelections();
      t && this.hiddenRangeModel.adjustSelections(t) && this.editor.setSelections(t);
    }
    this.editor.setHiddenAreas(e, this);
  }
  onCursorPositionChanged() {
    this.hiddenRangeModel && this.hiddenRangeModel.hasRanges() && this.cursorChangedScheduler.schedule();
  }
  revealCursor() {
    const e = this.getFoldingModel();
    e && e.then((t) => {
      if (t) {
        const n = this.editor.getSelections();
        if (n && n.length > 0) {
          const r = [];
          for (const s of n) {
            const o = s.selectionStartLineNumber;
            this.hiddenRangeModel && this.hiddenRangeModel.isHidden(o) && r.push(...t.getAllRegionsAtLine(o, (a) => a.isCollapsed && o > a.startLineNumber));
          }
          r.length && (t.toggleCollapseState(r), this.reveal(n[0].getPosition()));
        }
      }
    }).then(void 0, It);
  }
  onEditorMouseDown(e) {
    if (this.mouseDownInfo = null, !this.hiddenRangeModel || !e.target || !e.target.range || !e.event.leftButton && !e.event.middleButton)
      return;
    const t = e.target.range;
    let n = !1;
    switch (e.target.type) {
      case 4: {
        const r = e.target.detail, s = e.target.element.offsetLeft;
        if (r.offsetX - s < 4)
          return;
        n = !0;
        break;
      }
      case 7: {
        if (this._unfoldOnClickAfterEndOfLine && this.hiddenRangeModel.hasRanges() && !e.target.detail.isAfterLines)
          break;
        return;
      }
      case 6: {
        if (this.hiddenRangeModel.hasRanges()) {
          const r = this.editor.getModel();
          if (r && t.startColumn === r.getLineMaxColumn(t.startLineNumber))
            break;
        }
        return;
      }
      default:
        return;
    }
    this.mouseDownInfo = { lineNumber: t.startLineNumber, iconClicked: n };
  }
  onEditorMouseUp(e) {
    const t = this.foldingModel;
    if (!t || !this.mouseDownInfo || !e.target)
      return;
    const n = this.mouseDownInfo.lineNumber, r = this.mouseDownInfo.iconClicked, s = e.target.range;
    if (!s || s.startLineNumber !== n)
      return;
    if (r) {
      if (e.target.type !== 4)
        return;
    } else {
      const a = this.editor.getModel();
      if (!a || s.startColumn !== a.getLineMaxColumn(n))
        return;
    }
    const o = t.getRegionAtLine(n);
    if (o && o.startLineNumber === n) {
      const a = o.isCollapsed;
      if (r || a) {
        const l = e.event.altKey;
        let c = [];
        if (l) {
          const d = (h) => !h.containedBy(o) && !o.containedBy(h), u = t.getRegionsInside(null, d);
          for (const h of u)
            h.isCollapsed && c.push(h);
          c.length === 0 && (c = u);
        } else {
          const d = e.event.middleButton || e.event.shiftKey;
          if (d)
            for (const u of t.getRegionsInside(o))
              u.isCollapsed === a && c.push(u);
          (a || !d || c.length === 0) && c.push(o);
        }
        t.toggleCollapseState(c), this.reveal({ lineNumber: n, column: 1 });
      }
    }
  }
  reveal(e) {
    this.editor.revealPositionInCenterIfOutsideViewport(
      e,
      0
      /* ScrollType.Smooth */
    );
  }
};
ku.ID = "editor.contrib.folding";
ku = B1 = Ftt([
  w2(1, yt),
  w2(2, Un),
  w2(3, dr),
  w2(4, kl),
  w2(5, tt)
], ku);
class H1e {
  constructor(e) {
    this.editor = e, this._onDidChange = new pe(), this._computed = 0, this._limited = !1;
  }
  get limit() {
    return this.editor.getOptions().get(
      47
      /* EditorOption.foldingMaximumRegions */
    );
  }
  update(e, t) {
    (e !== this._computed || t !== this._limited) && (this._computed = e, this._limited = t, this._onDidChange.fire());
  }
}
class to extends Je {
  runEditorCommand(e, t, n) {
    const r = e.get(Un), s = ku.get(t);
    if (!s)
      return;
    const o = s.getFoldingModel();
    if (o)
      return this.reportTelemetry(e, t), o.then((a) => {
        if (a) {
          this.invoke(s, a, t, n, r);
          const l = t.getSelection();
          l && s.reveal(l.getStartPosition());
        }
      });
  }
  getSelectedLines(e) {
    const t = e.getSelections();
    return t ? t.map((n) => n.startLineNumber) : [];
  }
  getLineNumbers(e, t) {
    return e && e.selectionLines ? e.selectionLines.map((n) => n + 1) : this.getSelectedLines(t);
  }
  run(e, t) {
  }
}
function W1e(i) {
  if (!Jo(i)) {
    if (!ho(i))
      return !1;
    const e = i;
    if (!Jo(e.levels) && !Tg(e.levels) || !Jo(e.direction) && !mo(e.direction) || !Jo(e.selectionLines) && (!Array.isArray(e.selectionLines) || !e.selectionLines.every(Tg)))
      return !1;
  }
  return !0;
}
class Vtt extends to {
  constructor() {
    super({
      id: "editor.unfold",
      label: C("unfoldAction.label", "Unfold"),
      alias: "Unfold",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 3166,
        mac: {
          primary: 2654
          /* KeyCode.BracketRight */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      description: {
        description: "Unfold the content in the editor",
        args: [
          {
            name: "Unfold editor argument",
            description: `Property-value pairs that can be passed through this argument:
						* 'levels': Number of levels to unfold. If not set, defaults to 1.
						* 'direction': If 'up', unfold given number of levels up otherwise unfolds down.
						* 'selectionLines': Array of the start lines (0-based) of the editor selections to apply the unfold action to. If not set, the active selection(s) will be used.
						`,
            constraint: W1e,
            schema: {
              type: "object",
              properties: {
                levels: {
                  type: "number",
                  default: 1
                },
                direction: {
                  type: "string",
                  enum: ["up", "down"],
                  default: "down"
                },
                selectionLines: {
                  type: "array",
                  items: {
                    type: "number"
                  }
                }
              }
            }
          }
        ]
      }
    });
  }
  invoke(e, t, n, r) {
    const s = r && r.levels || 1, o = this.getLineNumbers(r, n);
    r && r.direction === "up" ? R1e(t, !1, s, o) : Eb(t, !1, s, o);
  }
}
class Htt extends to {
  constructor() {
    super({
      id: "editor.unfoldRecursively",
      label: C("unFoldRecursivelyAction.label", "Unfold Recursively"),
      alias: "Unfold Recursively",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2142
          /* KeyCode.BracketRight */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n, r) {
    Eb(t, !1, Number.MAX_VALUE, this.getSelectedLines(n));
  }
}
class Wtt extends to {
  constructor() {
    super({
      id: "editor.fold",
      label: C("foldAction.label", "Fold"),
      alias: "Fold",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 3164,
        mac: {
          primary: 2652
          /* KeyCode.BracketLeft */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      description: {
        description: "Fold the content in the editor",
        args: [
          {
            name: "Fold editor argument",
            description: `Property-value pairs that can be passed through this argument:
							* 'levels': Number of levels to fold.
							* 'direction': If 'up', folds given number of levels up otherwise folds down.
							* 'selectionLines': Array of the start lines (0-based) of the editor selections to apply the fold action to. If not set, the active selection(s) will be used.
							If no levels or direction is set, folds the region at the locations or if already collapsed, the first uncollapsed parent instead.
						`,
            constraint: W1e,
            schema: {
              type: "object",
              properties: {
                levels: {
                  type: "number"
                },
                direction: {
                  type: "string",
                  enum: ["up", "down"]
                },
                selectionLines: {
                  type: "array",
                  items: {
                    type: "number"
                  }
                }
              }
            }
          }
        ]
      }
    });
  }
  invoke(e, t, n, r) {
    const s = this.getLineNumbers(r, n), o = r && r.levels, a = r && r.direction;
    typeof o != "number" && typeof a != "string" ? btt(t, !0, s) : a === "up" ? R1e(t, !0, o || 1, s) : Eb(t, !0, o || 1, s);
  }
}
class jtt extends to {
  constructor() {
    super({
      id: "editor.toggleFold",
      label: C("toggleFoldAction.label", "Toggle Fold"),
      alias: "Toggle Fold",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2090
          /* KeyCode.KeyL */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    const r = this.getSelectedLines(n);
    M1e(t, 1, r);
  }
}
class ztt extends to {
  constructor() {
    super({
      id: "editor.foldRecursively",
      label: C("foldRecursivelyAction.label", "Fold Recursively"),
      alias: "Fold Recursively",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2140
          /* KeyCode.BracketLeft */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    const r = this.getSelectedLines(n);
    Eb(t, !0, Number.MAX_VALUE, r);
  }
}
class Utt extends to {
  constructor() {
    super({
      id: "editor.foldAllBlockComments",
      label: C("foldAllBlockComments.label", "Fold All Block Comments"),
      alias: "Fold All Block Comments",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2138
          /* KeyCode.Slash */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n, r, s) {
    if (t.regions.hasTypes())
      yG(t, go.Comment.value, !0);
    else {
      const o = n.getModel();
      if (!o)
        return;
      const a = s.getLanguageConfiguration(o.getLanguageId()).comments;
      if (a && a.blockCommentStartToken) {
        const l = new RegExp("^\\s*" + Va(a.blockCommentStartToken));
        CG(t, l, !0);
      }
    }
  }
}
class Gtt extends to {
  constructor() {
    super({
      id: "editor.foldAllMarkerRegions",
      label: C("foldAllMarkerRegions.label", "Fold All Regions"),
      alias: "Fold All Regions",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2077
          /* KeyCode.Digit8 */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n, r, s) {
    if (t.regions.hasTypes())
      yG(t, go.Region.value, !0);
    else {
      const o = n.getModel();
      if (!o)
        return;
      const a = s.getLanguageConfiguration(o.getLanguageId()).foldingRules;
      if (a && a.markers && a.markers.start) {
        const l = new RegExp(a.markers.start);
        CG(t, l, !0);
      }
    }
  }
}
class qtt extends to {
  constructor() {
    super({
      id: "editor.unfoldAllMarkerRegions",
      label: C("unfoldAllMarkerRegions.label", "Unfold All Regions"),
      alias: "Unfold All Regions",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2078
          /* KeyCode.Digit9 */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n, r, s) {
    if (t.regions.hasTypes())
      yG(t, go.Region.value, !1);
    else {
      const o = n.getModel();
      if (!o)
        return;
      const a = s.getLanguageConfiguration(o.getLanguageId()).foldingRules;
      if (a && a.markers && a.markers.start) {
        const l = new RegExp(a.markers.start);
        CG(t, l, !1);
      }
    }
  }
}
class Ktt extends to {
  constructor() {
    super({
      id: "editor.foldAllExcept",
      label: C("foldAllExcept.label", "Fold All Except Selected"),
      alias: "Fold All Except Selected",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2136
          /* KeyCode.Minus */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    const r = this.getSelectedLines(n);
    F1e(t, !0, r);
  }
}
class Ytt extends to {
  constructor() {
    super({
      id: "editor.unfoldAllExcept",
      label: C("unfoldAllExcept.label", "Unfold All Except Selected"),
      alias: "Unfold All Except Selected",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2134
          /* KeyCode.Equal */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    const r = this.getSelectedLines(n);
    F1e(t, !1, r);
  }
}
class Xtt extends to {
  constructor() {
    super({
      id: "editor.foldAll",
      label: C("foldAllAction.label", "Fold All"),
      alias: "Fold All",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2069
          /* KeyCode.Digit0 */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    Eb(t, !0);
  }
}
class Ztt extends to {
  constructor() {
    super({
      id: "editor.unfoldAll",
      label: C("unfoldAllAction.label", "Unfold All"),
      alias: "Unfold All",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2088
          /* KeyCode.KeyJ */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    Eb(t, !1);
  }
}
class f0 extends to {
  getFoldingLevel() {
    return parseInt(this.id.substr(f0.ID_PREFIX.length));
  }
  invoke(e, t, n) {
    Ctt(t, this.getFoldingLevel(), !0, this.getSelectedLines(n));
  }
}
f0.ID_PREFIX = "editor.foldLevel";
f0.ID = (i) => f0.ID_PREFIX + i;
class Qtt extends to {
  constructor() {
    super({
      id: "editor.gotoParentFold",
      label: C("gotoParentFold.label", "Go to Parent Fold"),
      alias: "Go to Parent Fold",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    const r = this.getSelectedLines(n);
    if (r.length > 0) {
      const s = ytt(r[0], t);
      s !== null && n.setSelection({
        startLineNumber: s,
        startColumn: 1,
        endLineNumber: s,
        endColumn: 1
      });
    }
  }
}
class Jtt extends to {
  constructor() {
    super({
      id: "editor.gotoPreviousFold",
      label: C("gotoPreviousFold.label", "Go to Previous Folding Range"),
      alias: "Go to Previous Folding Range",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    const r = this.getSelectedLines(n);
    if (r.length > 0) {
      const s = wtt(r[0], t);
      s !== null && n.setSelection({
        startLineNumber: s,
        startColumn: 1,
        endLineNumber: s,
        endColumn: 1
      });
    }
  }
}
class $tt extends to {
  constructor() {
    super({
      id: "editor.gotoNextFold",
      label: C("gotoNextFold.label", "Go to Next Folding Range"),
      alias: "Go to Next Folding Range",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    const r = this.getSelectedLines(n);
    if (r.length > 0) {
      const s = Stt(r[0], t);
      s !== null && n.setSelection({
        startLineNumber: s,
        startColumn: 1,
        endLineNumber: s,
        endColumn: 1
      });
    }
  }
}
class ent extends to {
  constructor() {
    super({
      id: "editor.createFoldingRangeFromSelection",
      label: C("createManualFoldRange.label", "Create Folding Range from Selection"),
      alias: "Create Folding Range from Selection",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2135
          /* KeyCode.Comma */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    var r;
    const s = [], o = n.getSelections();
    if (o) {
      for (const a of o) {
        let l = a.endLineNumber;
        a.endColumn === 1 && --l, l > a.startLineNumber && (s.push({
          startLineNumber: a.startLineNumber,
          endLineNumber: l,
          type: void 0,
          isCollapsed: !0,
          source: 1
          /* FoldSource.userDefined */
        }), n.setSelection({
          startLineNumber: a.startLineNumber,
          startColumn: 1,
          endLineNumber: a.startLineNumber,
          endColumn: 1
        }));
      }
      if (s.length > 0) {
        s.sort((l, c) => l.startLineNumber - c.startLineNumber);
        const a = Sa.sanitizeAndMerge(t.regions, s, (r = n.getModel()) === null || r === void 0 ? void 0 : r.getLineCount());
        t.updatePost(Sa.fromFoldRanges(a));
      }
    }
  }
}
class tnt extends to {
  constructor() {
    super({
      id: "editor.removeManualFoldingRanges",
      label: C("removeManualFoldingRanges.label", "Remove Manual Folding Ranges"),
      alias: "Remove Manual Folding Ranges",
      precondition: Ws,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2137
          /* KeyCode.Period */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  invoke(e, t, n) {
    const r = n.getSelections();
    if (r) {
      const s = [];
      for (const o of r) {
        const { startLineNumber: a, endLineNumber: l } = o;
        s.push(l >= a ? { startLineNumber: a, endLineNumber: l } : { endLineNumber: l, startLineNumber: a });
      }
      t.removeManualRanges(s), e.triggerFoldingModelChanged();
    }
  }
}
pn(
  ku.ID,
  ku,
  0
  /* EditorContributionInstantiation.Eager */
);
Be(Vtt);
Be(Htt);
Be(Wtt);
Be(ztt);
Be(Xtt);
Be(Ztt);
Be(Utt);
Be(Gtt);
Be(qtt);
Be(Ktt);
Be(Ytt);
Be(jtt);
Be(Qtt);
Be(Jtt);
Be($tt);
Be(ent);
Be(tnt);
for (let i = 1; i <= 7; i++)
  i7e(new f0({
    id: f0.ID(i),
    label: C("foldLevelAction.label", "Fold Level {0}", i),
    alias: `Fold Level ${i}`,
    precondition: Ws,
    kbOpts: {
      kbExpr: $.editorTextFocus,
      primary: xr(2089, 2048 | 21 + i),
      weight: 100
      /* KeybindingWeight.EditorContrib */
    }
  }));
on.registerCommand("_executeFoldingRangeProvider", function(i, ...e) {
  return Btt(this, void 0, void 0, function* () {
    const [t] = e;
    if (!(t instanceof pt))
      throw fl();
    const n = i.get(tt), r = i.get(fi).getModel(t);
    if (!r)
      throw fl();
    const s = i.get(en);
    if (!s.getValue("editor.folding", { resource: t }))
      return [];
    const o = i.get(Un), a = s.getValue("editor.foldingStrategy", { resource: t }), l = {
      get limit() {
        return s.getValue("editor.foldingMaximumRegions", { resource: t });
      },
      update: (f, g) => {
      }
    }, c = new wG(r, o, l);
    let d = c;
    if (a !== "indentation") {
      const f = ku.getFoldingRangeProviders(n, r);
      f.length && (d = new xG(r, f, () => {
      }, l, c));
    }
    const u = yield d.compute(jt.None), h = [];
    try {
      if (u)
        for (let f = 0; f < u.length; f++) {
          const g = u.getType(f);
          h.push({ start: u.getStartLineNumber(f), end: u.getEndLineNumber(f), kind: g ? go.fromValue(g) : void 0 });
        }
      return h;
    } finally {
      d.dispose();
    }
  });
});
class nnt extends Je {
  constructor() {
    super({
      id: "editor.action.fontZoomIn",
      label: C("EditorFontZoomIn.label", "Editor Font Zoom In"),
      alias: "Editor Font Zoom In",
      precondition: void 0
    });
  }
  run(e, t) {
    rl.setZoomLevel(rl.getZoomLevel() + 1);
  }
}
class int extends Je {
  constructor() {
    super({
      id: "editor.action.fontZoomOut",
      label: C("EditorFontZoomOut.label", "Editor Font Zoom Out"),
      alias: "Editor Font Zoom Out",
      precondition: void 0
    });
  }
  run(e, t) {
    rl.setZoomLevel(rl.getZoomLevel() - 1);
  }
}
class rnt extends Je {
  constructor() {
    super({
      id: "editor.action.fontZoomReset",
      label: C("EditorFontZoomReset.label", "Editor Font Zoom Reset"),
      alias: "Editor Font Zoom Reset",
      precondition: void 0
    });
  }
  run(e, t) {
    rl.setZoomLevel(0);
  }
}
Be(nnt);
Be(int);
Be(rnt);
var j1e = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, II = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, DG = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let Tw = class {
  constructor(e, t, n) {
    this._editor = e, this._languageFeaturesService = t, this._workerService = n, this._disposables = new Ne(), this._sessionDisposables = new Ne(), this._disposables.add(t.onTypeFormattingEditProvider.onDidChange(this._update, this)), this._disposables.add(e.onDidChangeModel(() => this._update())), this._disposables.add(e.onDidChangeModelLanguage(() => this._update())), this._disposables.add(e.onDidChangeConfiguration((r) => {
      r.hasChanged(
        56
        /* EditorOption.formatOnType */
      ) && this._update();
    })), this._update();
  }
  dispose() {
    this._disposables.dispose(), this._sessionDisposables.dispose();
  }
  _update() {
    if (this._sessionDisposables.clear(), !this._editor.getOption(
      56
      /* EditorOption.formatOnType */
    ) || !this._editor.hasModel())
      return;
    const e = this._editor.getModel(), [t] = this._languageFeaturesService.onTypeFormattingEditProvider.ordered(e);
    if (!t || !t.autoFormatTriggerCharacters)
      return;
    const n = new iL();
    for (const r of t.autoFormatTriggerCharacters)
      n.add(r.charCodeAt(0));
    this._sessionDisposables.add(this._editor.onDidType((r) => {
      const s = r.charCodeAt(r.length - 1);
      n.has(s) && this._trigger(String.fromCharCode(s));
    }));
  }
  _trigger(e) {
    if (!this._editor.hasModel() || this._editor.getSelections().length > 1 || !this._editor.getSelection().isEmpty())
      return;
    const t = this._editor.getModel(), n = this._editor.getPosition(), r = new lr(), s = this._editor.onDidChangeModelContent((o) => {
      if (o.isFlush) {
        r.cancel(), s.dispose();
        return;
      }
      for (let a = 0, l = o.changes.length; a < l; a++)
        if (o.changes[a].range.endLineNumber <= n.lineNumber) {
          r.cancel(), s.dispose();
          return;
        }
    });
    Pme(this._workerService, this._languageFeaturesService, t, n, e, t.getFormattingOptions(), r.token).then((o) => {
      r.token.isCancellationRequested || Bs(o) && (R_.execute(this._editor, o, !0), zU(o));
    }).finally(() => {
      s.dispose();
    });
  }
};
Tw.ID = "editor.contrib.autoFormat";
Tw = j1e([
  II(1, tt),
  II(2, vc)
], Tw);
let Nw = class {
  constructor(e, t, n) {
    this.editor = e, this._languageFeaturesService = t, this._instantiationService = n, this._callOnDispose = new Ne(), this._callOnModel = new Ne(), this._callOnDispose.add(e.onDidChangeConfiguration(() => this._update())), this._callOnDispose.add(e.onDidChangeModel(() => this._update())), this._callOnDispose.add(e.onDidChangeModelLanguage(() => this._update())), this._callOnDispose.add(t.documentRangeFormattingEditProvider.onDidChange(this._update, this));
  }
  dispose() {
    this._callOnDispose.dispose(), this._callOnModel.dispose();
  }
  _update() {
    this._callOnModel.clear(), this.editor.getOption(
      55
      /* EditorOption.formatOnPaste */
    ) && this.editor.hasModel() && this._languageFeaturesService.documentRangeFormattingEditProvider.has(this.editor.getModel()) && this._callOnModel.add(this.editor.onDidPaste(({ range: e }) => this._trigger(e)));
  }
  _trigger(e) {
    this.editor.hasModel() && (this.editor.getSelections().length > 1 || this._instantiationService.invokeFunction(Nme, this.editor, e, 2, Hh.None, jt.None).catch(It));
  }
};
Nw.ID = "editor.contrib.formatOnPaste";
Nw = j1e([
  II(1, tt),
  II(2, bt)
], Nw);
class snt extends Je {
  constructor() {
    super({
      id: "editor.action.formatDocument",
      label: C("formatDocument.label", "Format Document"),
      alias: "Format Document",
      precondition: ke.and($.notInCompositeEditor, $.writable, $.hasDocumentFormattingProvider),
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 1572,
        linux: {
          primary: 3111
          /* KeyCode.KeyI */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      contextMenuOpts: {
        group: "1_modification",
        order: 1.3
      }
    });
  }
  run(e, t) {
    return DG(this, void 0, void 0, function* () {
      if (t.hasModel()) {
        const n = e.get(bt);
        yield e.get(hp).showWhile(n.invokeFunction(gXe, t, 1, Hh.None, jt.None), 250);
      }
    });
  }
}
class ont extends Je {
  constructor() {
    super({
      id: "editor.action.formatSelection",
      label: C("formatSelection.label", "Format Selection"),
      alias: "Format Selection",
      precondition: ke.and($.writable, $.hasDocumentSelectionFormattingProvider),
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2084
          /* KeyCode.KeyF */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      contextMenuOpts: {
        when: $.hasNonEmptySelection,
        group: "1_modification",
        order: 1.31
      }
    });
  }
  run(e, t) {
    return DG(this, void 0, void 0, function* () {
      if (!t.hasModel())
        return;
      const n = e.get(bt), r = t.getModel(), s = t.getSelections().map((a) => a.isEmpty() ? new V(a.startLineNumber, 1, a.startLineNumber, r.getLineMaxColumn(a.startLineNumber)) : a);
      yield e.get(hp).showWhile(n.invokeFunction(Nme, t, s, 1, Hh.None, jt.None), 250);
    });
  }
}
pn(
  Tw.ID,
  Tw,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
pn(
  Nw.ID,
  Nw,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
Be(snt);
Be(ont);
on.registerCommand("editor.action.format", (i) => DG(void 0, void 0, void 0, function* () {
  const e = i.get(Sn).getFocusedCodeEditor();
  if (!e || !e.hasModel())
    return;
  const t = i.get(Ui);
  e.getSelection().isEmpty() ? yield t.executeCommand("editor.action.formatDocument") : yield t.executeCommand("editor.action.formatSelection");
}));
var ant = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, RT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, lnt = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class pv {
  remove() {
    var e;
    (e = this.parent) === null || e === void 0 || e.children.delete(this.id);
  }
  static findId(e, t) {
    let n;
    typeof e == "string" ? n = `${t.id}/${e}` : (n = `${t.id}/${e.name}`, t.children.get(n) !== void 0 && (n = `${t.id}/${e.name}_${e.range.startLineNumber}_${e.range.startColumn}`));
    let r = n;
    for (let s = 0; t.children.get(r) !== void 0; s++)
      r = `${n}_${s}`;
    return r;
  }
  static empty(e) {
    return e.children.size === 0;
  }
}
class mH extends pv {
  constructor(e, t, n) {
    super(), this.id = e, this.parent = t, this.symbol = n, this.children = /* @__PURE__ */ new Map();
  }
}
class z1e extends pv {
  constructor(e, t, n, r) {
    super(), this.id = e, this.parent = t, this.label = n, this.order = r, this.children = /* @__PURE__ */ new Map();
  }
}
class hh extends pv {
  static create(e, t, n) {
    const r = new lr(n), s = new hh(t.uri), o = e.ordered(t), a = o.map((c, d) => {
      var u;
      const h = pv.findId(`provider_${d}`, s), f = new z1e(h, s, (u = c.displayName) !== null && u !== void 0 ? u : "Unknown Outline Provider", d);
      return Promise.resolve(c.provideDocumentSymbols(t, r.token)).then((g) => {
        for (const p of g || [])
          hh._makeOutlineElement(p, f);
        return f;
      }, (g) => (vr(g), f)).then((g) => {
        pv.empty(g) ? g.remove() : s._groups.set(h, g);
      });
    }), l = e.onDidChange(() => {
      const c = e.ordered(t);
      Qi(c, o) || r.cancel();
    });
    return Promise.all(a).then(() => r.token.isCancellationRequested && !n.isCancellationRequested ? hh.create(e, t, n) : s._compact()).finally(() => {
      r.dispose(), l.dispose(), r.dispose();
    });
  }
  static _makeOutlineElement(e, t) {
    const n = pv.findId(e, t), r = new mH(n, t, e);
    if (e.children)
      for (const s of e.children)
        hh._makeOutlineElement(s, r);
    t.children.set(r.id, r);
  }
  constructor(e) {
    super(), this.uri = e, this.id = "root", this.parent = void 0, this._groups = /* @__PURE__ */ new Map(), this.children = /* @__PURE__ */ new Map(), this.id = "root", this.parent = void 0;
  }
  _compact() {
    let e = 0;
    for (const [t, n] of this._groups)
      n.children.size === 0 ? this._groups.delete(t) : e += 1;
    if (e !== 1)
      this.children = this._groups;
    else {
      const t = Wt.first(this._groups.values());
      for (const [, n] of t.children)
        n.parent = this, this.children.set(n.id, n);
    }
    return this;
  }
  getTopLevelSymbols() {
    const e = [];
    for (const t of this.children.values())
      t instanceof mH ? e.push(t.symbol) : e.push(...Wt.map(t.children.values(), (n) => n.symbol));
    return e.sort((t, n) => V.compareRangesUsingStarts(t.range, n.range));
  }
  asListOfDocumentSymbols() {
    const e = this.getTopLevelSymbols(), t = [];
    return hh._flattenDocumentSymbols(t, e, ""), t.sort((n, r) => ve.compare(V.getStartPosition(n.range), V.getStartPosition(r.range)) || ve.compare(V.getEndPosition(r.range), V.getEndPosition(n.range)));
  }
  static _flattenDocumentSymbols(e, t, n) {
    for (const r of t)
      e.push({
        kind: r.kind,
        tags: r.tags,
        name: r.name,
        detail: r.detail,
        containerName: r.containerName || n,
        range: r.range,
        selectionRange: r.selectionRange,
        children: void 0
        // we flatten it...
      }), r.children && hh._flattenDocumentSymbols(e, r.children, r.name);
  }
}
const I5 = Gt("IOutlineModelService");
let vH = class {
  constructor(e, t, n) {
    this._languageFeaturesService = e, this._disposables = new Ne(), this._cache = new cp(10, 0.7), this._debounceInformation = t.for(e.documentSymbolProvider, "DocumentSymbols", { min: 350 }), this._disposables.add(n.onModelRemoved((r) => {
      this._cache.delete(r.id);
    }));
  }
  dispose() {
    this._disposables.dispose();
  }
  getOrCreate(e, t) {
    return lnt(this, void 0, void 0, function* () {
      const n = this._languageFeaturesService.documentSymbolProvider, r = n.ordered(e);
      let s = this._cache.get(e.id);
      if (!s || s.versionId !== e.getVersionId() || !Qi(s.provider, r)) {
        const a = new lr();
        s = {
          versionId: e.getVersionId(),
          provider: r,
          promiseCnt: 0,
          source: a,
          promise: hh.create(n, e, a.token),
          model: void 0
        }, this._cache.set(e.id, s);
        const l = Date.now();
        s.promise.then((c) => {
          s.model = c, this._debounceInformation.update(e, Date.now() - l);
        }).catch((c) => {
          this._cache.delete(e.id);
        });
      }
      if (s.model)
        return s.model;
      s.promiseCnt += 1;
      const o = t.onCancellationRequested(() => {
        --s.promiseCnt === 0 && (s.source.cancel(), this._cache.delete(e.id));
      });
      try {
        return yield s.promise;
      } finally {
        o.dispose();
      }
    });
  }
};
vH = ant([
  RT(0, tt),
  RT(1, kl),
  RT(2, fi)
], vH);
an(
  I5,
  vH,
  1
  /* InstantiationType.Delayed */
);
var cnt = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
on.registerCommand("_executeDocumentSymbolProvider", function(i, ...e) {
  return cnt(this, void 0, void 0, function* () {
    const [t] = e;
    On(pt.isUri(t));
    const n = i.get(I5), s = yield i.get(Wo).createModelReference(t);
    try {
      return (yield n.getOrCreate(s.object.textEditorModel, jt.None)).getTopLevelSymbols();
    } finally {
      s.dispose();
    }
  });
});
class Ur extends we {
  constructor(e, t) {
    super(), this.contextKeyService = e, this.model = t, this.inlineCompletionVisible = Ur.inlineSuggestionVisible.bindTo(this.contextKeyService), this.inlineCompletionSuggestsIndentation = Ur.inlineSuggestionHasIndentation.bindTo(this.contextKeyService), this.inlineCompletionSuggestsIndentationLessThanTabSize = Ur.inlineSuggestionHasIndentationLessThanTabSize.bindTo(this.contextKeyService), this.suppressSuggestions = Ur.suppressSuggestions.bindTo(this.contextKeyService), this._register(zn((n) => {
      const r = this.model.read(n), s = r?.state.read(n), o = !!s?.inlineCompletion && s?.ghostText !== void 0 && !s?.ghostText.isEmpty();
      this.inlineCompletionVisible.set(o), s?.ghostText && s?.inlineCompletion && this.suppressSuggestions.set(s.inlineCompletion.inlineCompletion.source.inlineCompletions.suppressSuggestions);
    })), this._register(zn((n) => {
      const r = this.model.read(n);
      let s = !1, o = !0;
      const a = r?.ghostText.read(n);
      if (r?.selectedSuggestItem && a && a.parts.length > 0) {
        const { column: l, lines: c } = a.parts[0], d = c[0], u = r.textModel.getLineIndentColumn(a.lineNumber);
        if (l <= u) {
          let f = Js(d);
          f === -1 && (f = d.length - 1), s = f > 0;
          const g = r.textModel.getOptions().tabSize;
          o = Lr.visibleColumnFromColumn(d, f + 1, g) < g;
        }
      }
      this.inlineCompletionSuggestsIndentation.set(s), this.inlineCompletionSuggestsIndentationLessThanTabSize.set(o);
    }));
  }
}
Ur.inlineSuggestionVisible = new Ke("inlineSuggestionVisible", !1, C("inlineSuggestionVisible", "Whether an inline suggestion is visible"));
Ur.inlineSuggestionHasIndentation = new Ke("inlineSuggestionHasIndentation", !1, C("inlineSuggestionHasIndentation", "Whether the inline suggestion starts with whitespace"));
Ur.inlineSuggestionHasIndentationLessThanTabSize = new Ke("inlineSuggestionHasIndentationLessThanTabSize", !0, C("inlineSuggestionHasIndentationLessThanTabSize", "Whether the inline suggestion starts with whitespace that is less than what would be inserted by tab"));
Ur.suppressSuggestions = new Ke("inlineSuggestionSuppressSuggestions", void 0, C("suppressSuggestions", "Whether suggestions should be suppressed for the current suggestion"));
function dnt(i, e) {
  const t = new unt(i), n = e.map((r) => {
    const s = V.lift(r.range);
    return {
      startOffset: t.getOffset(s.getStartPosition()),
      endOffset: t.getOffset(s.getEndPosition()),
      text: r.text
    };
  });
  n.sort((r, s) => s.startOffset - r.startOffset);
  for (const r of n)
    i = i.substring(0, r.startOffset) + r.text + i.substring(r.endOffset);
  return i;
}
class unt {
  constructor(e) {
    this.lineStartOffsetByLineIdx = [], this.lineStartOffsetByLineIdx.push(0);
    for (let t = 0; t < e.length; t++)
      e.charAt(t) === `
` && this.lineStartOffsetByLineIdx.push(t + 1);
  }
  getOffset(e) {
    return this.lineStartOffsetByLineIdx[e.lineNumber - 1] + e.column - 1;
  }
}
const hnt = [];
function fnt() {
  return hnt;
}
class gnt {
  constructor(e, t) {
    if (this.startColumn = e, this.endColumnExclusive = t, e > t)
      throw new gr(`startColumn ${e} cannot be after endColumnExclusive ${t}`);
  }
  toRange(e) {
    return new V(e, this.startColumn, e, this.endColumnExclusive);
  }
  equals(e) {
    return this.startColumn === e.startColumn && this.endColumnExclusive === e.endColumnExclusive;
  }
}
function pnt(i, e) {
  const t = new Ne(), n = i.createDecorationsCollection();
  return t.add(PU({ debugName: () => `Apply decorations from ${e.debugName}` }, (r) => {
    const s = e.read(r);
    n.set(s);
  })), t.add({
    dispose: () => {
      n.clear();
    }
  }), t;
}
function _H(i, e) {
  return new ve(i.lineNumber + e.lineNumber - 1, e.lineNumber === 1 ? i.column + e.column - 1 : e.column);
}
function bH(i) {
  let e = 1, t = 1;
  for (const n of i)
    n === `
` ? (e++, t = 1) : t++;
  return new ve(e, t);
}
class AI {
  constructor(e, t) {
    this.lineNumber = e, this.parts = t;
  }
  equals(e) {
    return this.lineNumber === e.lineNumber && this.parts.length === e.parts.length && this.parts.every((t, n) => t.equals(e.parts[n]));
  }
  renderForScreenReader(e) {
    if (this.parts.length === 0)
      return "";
    const t = this.parts[this.parts.length - 1], n = e.substr(0, t.column - 1);
    return dnt(n, this.parts.map((s) => ({
      range: { startLineNumber: 1, endLineNumber: 1, startColumn: s.column, endColumn: s.column },
      text: s.lines.join(`
`)
    }))).substring(this.parts[0].column - 1);
  }
  isEmpty() {
    return this.parts.every((e) => e.lines.length === 0);
  }
  get lineCount() {
    return 1 + this.parts.reduce((e, t) => e + t.lines.length - 1, 0);
  }
}
class CH {
  constructor(e, t, n) {
    this.column = e, this.lines = t, this.preview = n;
  }
  equals(e) {
    return this.column === e.column && this.lines.length === e.lines.length && this.lines.every((t, n) => t === e.lines[n]);
  }
}
class yH {
  constructor(e, t, n, r = 0) {
    this.lineNumber = e, this.columnRange = t, this.newLines = n, this.additionalReservedLineCount = r, this.parts = [
      new CH(this.columnRange.endColumnExclusive, this.newLines, !1)
    ];
  }
  renderForScreenReader(e) {
    return this.newLines.join(`
`);
  }
  get lineCount() {
    return this.newLines.length;
  }
  isEmpty() {
    return this.parts.every((e) => e.lines.length === 0);
  }
  equals(e) {
    return this.lineNumber === e.lineNumber && this.columnRange.equals(e.columnRange) && this.newLines.length === e.newLines.length && this.newLines.every((t, n) => t === e.newLines[n]) && this.additionalReservedLineCount === e.additionalReservedLineCount;
  }
}
function iee(i, e) {
  return i === e ? !0 : !i || !e ? !1 : i instanceof AI && e instanceof AI || i instanceof yH && e instanceof yH ? i.equals(e) : !1;
}
var mnt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, vnt = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const ree = "ghost-text";
let wH = class extends we {
  constructor(e, t, n) {
    super(), this.editor = e, this.model = t, this.languageService = n, this.isDisposed = Yn(this, !1), this.currentTextModel = as(this.editor.onDidChangeModel, () => this.editor.getModel()), this.uiState = nn(this, (r) => {
      if (this.isDisposed.read(r))
        return;
      const s = this.currentTextModel.read(r);
      if (s !== this.model.targetTextModel.read(r))
        return;
      const o = this.model.ghostText.read(r);
      if (!o)
        return;
      const a = o instanceof yH ? o.columnRange : void 0, l = [], c = [];
      function d(p, m) {
        if (c.length > 0) {
          const _ = c[c.length - 1];
          m && _.decorations.push(new ea(
            _.content.length + 1,
            _.content.length + 1 + p[0].length,
            m,
            0
            /* InlineDecorationType.Regular */
          )), _.content += p[0], p = p.slice(1);
        }
        for (const _ of p)
          c.push({
            content: _,
            decorations: m ? [new ea(
              1,
              _.length + 1,
              m,
              0
              /* InlineDecorationType.Regular */
            )] : []
          });
      }
      const u = s.getLineContent(o.lineNumber);
      let h, f = 0;
      for (const p of o.parts) {
        let m = p.lines;
        h === void 0 ? (l.push({
          column: p.column,
          text: m[0],
          preview: p.preview
        }), m = m.slice(1)) : d([u.substring(f, p.column - 1)], void 0), m.length > 0 && (d(m, ree), h === void 0 && p.column <= u.length && (h = p.column)), f = p.column - 1;
      }
      h !== void 0 && d([u.substring(f)], void 0);
      const g = h !== void 0 ? new gnt(h, u.length + 1) : void 0;
      return {
        replacedRange: a,
        inlineTexts: l,
        additionalLines: c,
        hiddenRange: g,
        lineNumber: o.lineNumber,
        additionalReservedLineCount: this.model.minReservedLineCount.read(r),
        targetTextModel: s
      };
    }), this.decorations = nn(this, (r) => {
      const s = this.uiState.read(r);
      if (!s)
        return [];
      const o = [];
      s.replacedRange && o.push({
        range: s.replacedRange.toRange(s.lineNumber),
        options: { inlineClassName: "inline-completion-text-to-replace", description: "GhostTextReplacement" }
      }), s.hiddenRange && o.push({
        range: s.hiddenRange.toRange(s.lineNumber),
        options: { inlineClassName: "ghost-text-hidden", description: "ghost-text-hidden" }
      });
      for (const a of s.inlineTexts)
        o.push({
          range: V.fromPositions(new ve(s.lineNumber, a.column)),
          options: {
            description: ree,
            after: { content: a.text, inlineClassName: a.preview ? "ghost-text-decoration-preview" : "ghost-text-decoration", cursorStops: Gc.Left },
            showIfCollapsed: !0
          }
        });
      return o;
    }), this.additionalLinesWidget = this._register(new _nt(this.editor, this.languageService.languageIdCodec, nn((r) => {
      const s = this.uiState.read(r);
      return s ? {
        lineNumber: s.lineNumber,
        additionalLines: s.additionalLines,
        minReservedLineCount: s.additionalReservedLineCount,
        targetTextModel: s.targetTextModel
      } : void 0;
    }))), this._register(Ct(() => {
      this.isDisposed.set(!0, void 0);
    })), this._register(pnt(this.editor, this.decorations));
  }
  ownsViewZone(e) {
    return this.additionalLinesWidget.viewZoneId === e;
  }
};
wH = mnt([
  vnt(2, ci)
], wH);
class _nt extends we {
  get viewZoneId() {
    return this._viewZoneId;
  }
  constructor(e, t, n) {
    super(), this.editor = e, this.languageIdCodec = t, this.lines = n, this._viewZoneId = void 0, this.editorOptionsChanged = La("editorOptionChanged", qe.filter(this.editor.onDidChangeConfiguration, (r) => r.hasChanged(
      33
      /* EditorOption.disableMonospaceOptimizations */
    ) || r.hasChanged(
      116
      /* EditorOption.stopRenderingLineAfter */
    ) || r.hasChanged(
      98
      /* EditorOption.renderWhitespace */
    ) || r.hasChanged(
      93
      /* EditorOption.renderControlCharacters */
    ) || r.hasChanged(
      51
      /* EditorOption.fontLigatures */
    ) || r.hasChanged(
      50
      /* EditorOption.fontInfo */
    ) || r.hasChanged(
      66
      /* EditorOption.lineHeight */
    ))), this._register(zn((r) => {
      const s = this.lines.read(r);
      this.editorOptionsChanged.read(r), s ? this.updateLines(s.lineNumber, s.additionalLines, s.minReservedLineCount) : this.clear();
    }));
  }
  dispose() {
    super.dispose(), this.clear();
  }
  clear() {
    this.editor.changeViewZones((e) => {
      this._viewZoneId && (e.removeZone(this._viewZoneId), this._viewZoneId = void 0);
    });
  }
  updateLines(e, t, n) {
    const r = this.editor.getModel();
    if (!r)
      return;
    const { tabSize: s } = r.getOptions();
    this.editor.changeViewZones((o) => {
      this._viewZoneId && (o.removeZone(this._viewZoneId), this._viewZoneId = void 0);
      const a = Math.max(t.length, n);
      if (a > 0) {
        const l = document.createElement("div");
        bnt(l, s, t, this.editor.getOptions(), this.languageIdCodec), this._viewZoneId = o.addZone({
          afterLineNumber: e,
          heightInLines: a,
          domNode: l,
          afterColumnAffinity: 1
          /* PositionAffinity.Right */
        });
      }
    });
  }
}
function bnt(i, e, t, n, r) {
  const s = n.get(
    33
    /* EditorOption.disableMonospaceOptimizations */
  ), o = n.get(
    116
    /* EditorOption.stopRenderingLineAfter */
  ), a = "none", l = n.get(
    93
    /* EditorOption.renderControlCharacters */
  ), c = n.get(
    51
    /* EditorOption.fontLigatures */
  ), d = n.get(
    50
    /* EditorOption.fontInfo */
  ), u = n.get(
    66
    /* EditorOption.lineHeight */
  ), h = new pb(1e4);
  h.appendString('<div class="suggest-preview-text">');
  for (let p = 0, m = t.length; p < m; p++) {
    const _ = t[p], b = _.content;
    h.appendString('<div class="view-line'), h.appendString('" style="top:'), h.appendString(String(p * u)), h.appendString('px;width:1000000px;">');
    const w = yS(b), y = u_(b), S = Tr.createEmpty(b, r);
    ES(new dp(d.isMonospace && !s, d.canUseHalfwidthRightwardsArrow, b, !1, w, y, 0, S, _.decorations, e, 0, d.spaceWidth, d.middotWidth, d.wsmiddotWidth, o, a, l, c !== Da.OFF, null), h), h.appendString("</div>");
  }
  h.appendString("</div>"), Ds(i, d);
  const f = h.build(), g = see ? see.createHTML(f) : f;
  i.innerHTML = g;
}
const see = af("editorGhostText", { createHTML: (i) => i });
function Cnt(i, e) {
  const t = new fge(), n = new pge(t, (c) => e.getLanguageConfiguration(c)), r = new gge(new ynt([i]), n), s = BF(r, [], void 0, !0);
  let o = "";
  const a = i.getLineContent();
  function l(c, d) {
    if (c.kind === 2)
      if (l(c.openingBracket, d), d = Ri(d, c.openingBracket.length), c.child && (l(c.child, d), d = Ri(d, c.child.length)), c.closingBracket)
        l(c.closingBracket, d), d = Ri(d, c.closingBracket.length);
      else {
        const h = n.getSingleLanguageBracketTokens(c.openingBracket.languageId).findClosingTokenText(c.openingBracket.bracketIds);
        o += h;
      }
    else if (c.kind !== 3) {
      if (c.kind === 0 || c.kind === 1)
        o += a.substring(d, Ri(d, c.length));
      else if (c.kind === 4)
        for (const u of c.children)
          l(u, d), d = Ri(d, u.length);
    }
  }
  return l(s, po), o;
}
class ynt {
  constructor(e) {
    this.lines = e, this.tokenization = {
      getLineTokens: (t) => this.lines[t - 1]
    };
  }
  getLineCount() {
    return this.lines.length;
  }
  getLineLength(e) {
    return this.lines[e - 1].getLineContent().length;
  }
}
class Bl {
  constructor() {
    this.value = "", this.pos = 0;
  }
  static isDigitCharacter(e) {
    return e >= 48 && e <= 57;
  }
  static isVariableCharacter(e) {
    return e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90;
  }
  text(e) {
    this.value = e, this.pos = 0;
  }
  tokenText(e) {
    return this.value.substr(e.pos, e.len);
  }
  next() {
    if (this.pos >= this.value.length)
      return { type: 14, pos: this.pos, len: 0 };
    const e = this.pos;
    let t = 0, n = this.value.charCodeAt(e), r;
    if (r = Bl._table[n], typeof r == "number")
      return this.pos += 1, { type: r, pos: e, len: 1 };
    if (Bl.isDigitCharacter(n)) {
      r = 8;
      do
        t += 1, n = this.value.charCodeAt(e + t);
      while (Bl.isDigitCharacter(n));
      return this.pos += t, { type: r, pos: e, len: t };
    }
    if (Bl.isVariableCharacter(n)) {
      r = 9;
      do
        n = this.value.charCodeAt(e + ++t);
      while (Bl.isVariableCharacter(n) || Bl.isDigitCharacter(n));
      return this.pos += t, { type: r, pos: e, len: t };
    }
    r = 10;
    do
      t += 1, n = this.value.charCodeAt(e + t);
    while (!isNaN(n) && typeof Bl._table[n] > "u" && !Bl.isDigitCharacter(n) && !Bl.isVariableCharacter(n));
    return this.pos += t, { type: r, pos: e, len: t };
  }
}
Bl._table = {
  36: 0,
  58: 1,
  44: 2,
  123: 3,
  125: 4,
  92: 5,
  47: 6,
  124: 7,
  43: 11,
  45: 12,
  63: 13
};
class Lb {
  constructor() {
    this._children = [];
  }
  appendChild(e) {
    return e instanceof co && this._children[this._children.length - 1] instanceof co ? this._children[this._children.length - 1].value += e.value : (e.parent = this, this._children.push(e)), this;
  }
  replace(e, t) {
    const { parent: n } = e, r = n.children.indexOf(e), s = n.children.slice(0);
    s.splice(r, 1, ...t), n._children = s, function o(a, l) {
      for (const c of a)
        c.parent = l, o(c.children, c);
    }(t, n);
  }
  get children() {
    return this._children;
  }
  get rightMostDescendant() {
    return this._children.length > 0 ? this._children[this._children.length - 1].rightMostDescendant : this;
  }
  get snippet() {
    let e = this;
    for (; ; ) {
      if (!e)
        return;
      if (e instanceof nx)
        return e;
      e = e.parent;
    }
  }
  toString() {
    return this.children.reduce((e, t) => e + t.toString(), "");
  }
  len() {
    return 0;
  }
}
class co extends Lb {
  constructor(e) {
    super(), this.value = e;
  }
  toString() {
    return this.value;
  }
  len() {
    return this.value.length;
  }
  clone() {
    return new co(this.value);
  }
}
class U1e extends Lb {
}
let Fc = class G1e extends U1e {
  static compareByIndex(e, t) {
    return e.index === t.index ? 0 : e.isFinalTabstop ? 1 : t.isFinalTabstop || e.index < t.index ? -1 : e.index > t.index ? 1 : 0;
  }
  constructor(e) {
    super(), this.index = e;
  }
  get isFinalTabstop() {
    return this.index === 0;
  }
  get choice() {
    return this._children.length === 1 && this._children[0] instanceof Ib ? this._children[0] : void 0;
  }
  clone() {
    const e = new G1e(this.index);
    return this.transform && (e.transform = this.transform.clone()), e._children = this.children.map((t) => t.clone()), e;
  }
};
class Ib extends Lb {
  constructor() {
    super(...arguments), this.options = [];
  }
  appendChild(e) {
    return e instanceof co && (e.parent = this, this.options.push(e)), this;
  }
  toString() {
    return this.options[0].value;
  }
  len() {
    return this.options[0].len();
  }
  clone() {
    const e = new Ib();
    return this.options.forEach(e.appendChild, e), e;
  }
}
class EG extends Lb {
  constructor() {
    super(...arguments), this.regexp = new RegExp("");
  }
  resolve(e) {
    const t = this;
    let n = !1, r = e.replace(this.regexp, function() {
      return n = !0, t._replace(Array.prototype.slice.call(arguments, 0, -2));
    });
    return !n && this._children.some((s) => s instanceof Pc && !!s.elseValue) && (r = this._replace([])), r;
  }
  _replace(e) {
    let t = "";
    for (const n of this._children)
      if (n instanceof Pc) {
        let r = e[n.index] || "";
        r = n.resolve(r), t += r;
      } else
        t += n.toString();
    return t;
  }
  toString() {
    return "";
  }
  clone() {
    const e = new EG();
    return e.regexp = new RegExp(this.regexp.source, (this.regexp.ignoreCase ? "i" : "") + (this.regexp.global ? "g" : "")), e._children = this.children.map((t) => t.clone()), e;
  }
}
class Pc extends Lb {
  constructor(e, t, n, r) {
    super(), this.index = e, this.shorthandName = t, this.ifValue = n, this.elseValue = r;
  }
  resolve(e) {
    return this.shorthandName === "upcase" ? e ? e.toLocaleUpperCase() : "" : this.shorthandName === "downcase" ? e ? e.toLocaleLowerCase() : "" : this.shorthandName === "capitalize" ? e ? e[0].toLocaleUpperCase() + e.substr(1) : "" : this.shorthandName === "pascalcase" ? e ? this._toPascalCase(e) : "" : this.shorthandName === "camelcase" ? e ? this._toCamelCase(e) : "" : e && typeof this.ifValue == "string" ? this.ifValue : !e && typeof this.elseValue == "string" ? this.elseValue : e || "";
  }
  _toPascalCase(e) {
    const t = e.match(/[a-z0-9]+/gi);
    return t ? t.map((n) => n.charAt(0).toUpperCase() + n.substr(1)).join("") : e;
  }
  _toCamelCase(e) {
    const t = e.match(/[a-z0-9]+/gi);
    return t ? t.map((n, r) => r === 0 ? n.charAt(0).toLowerCase() + n.substr(1) : n.charAt(0).toUpperCase() + n.substr(1)).join("") : e;
  }
  clone() {
    return new Pc(this.index, this.shorthandName, this.ifValue, this.elseValue);
  }
}
class Pw extends U1e {
  constructor(e) {
    super(), this.name = e;
  }
  resolve(e) {
    let t = e.resolve(this);
    return this.transform && (t = this.transform.resolve(t || "")), t !== void 0 ? (this._children = [new co(t)], !0) : !1;
  }
  clone() {
    const e = new Pw(this.name);
    return this.transform && (e.transform = this.transform.clone()), e._children = this.children.map((t) => t.clone()), e;
  }
}
function oee(i, e) {
  const t = [...i];
  for (; t.length > 0; ) {
    const n = t.shift();
    if (!e(n))
      break;
    t.unshift(...n.children);
  }
}
class nx extends Lb {
  get placeholderInfo() {
    if (!this._placeholders) {
      const e = [];
      let t;
      this.walk(function(n) {
        return n instanceof Fc && (e.push(n), t = !t || t.index < n.index ? n : t), !0;
      }), this._placeholders = { all: e, last: t };
    }
    return this._placeholders;
  }
  get placeholders() {
    const { all: e } = this.placeholderInfo;
    return e;
  }
  offset(e) {
    let t = 0, n = !1;
    return this.walk((r) => r === e ? (n = !0, !1) : (t += r.len(), !0)), n ? t : -1;
  }
  fullLen(e) {
    let t = 0;
    return oee([e], (n) => (t += n.len(), !0)), t;
  }
  enclosingPlaceholders(e) {
    const t = [];
    let { parent: n } = e;
    for (; n; )
      n instanceof Fc && t.push(n), n = n.parent;
    return t;
  }
  resolveVariables(e) {
    return this.walk((t) => (t instanceof Pw && t.resolve(e) && (this._placeholders = void 0), !0)), this;
  }
  appendChild(e) {
    return this._placeholders = void 0, super.appendChild(e);
  }
  replace(e, t) {
    return this._placeholders = void 0, super.replace(e, t);
  }
  clone() {
    const e = new nx();
    return this._children = this.children.map((t) => t.clone()), e;
  }
  walk(e) {
    oee(this.children, e);
  }
}
class q_ {
  constructor() {
    this._scanner = new Bl(), this._token = { type: 14, pos: 0, len: 0 };
  }
  static escape(e) {
    return e.replace(/\$|}|\\/g, "\\$&");
  }
  static guessNeedsClipboard(e) {
    return /\${?CLIPBOARD/.test(e);
  }
  parse(e, t, n) {
    const r = new nx();
    return this.parseFragment(e, r), this.ensureFinalTabstop(r, n ?? !1, t ?? !1), r;
  }
  parseFragment(e, t) {
    const n = t.children.length;
    for (this._scanner.text(e), this._token = this._scanner.next(); this._parse(t); )
      ;
    const r = /* @__PURE__ */ new Map(), s = [];
    t.walk((l) => (l instanceof Fc && (l.isFinalTabstop ? r.set(0, void 0) : !r.has(l.index) && l.children.length > 0 ? r.set(l.index, l.children) : s.push(l)), !0));
    const o = (l, c) => {
      const d = r.get(l.index);
      if (!d)
        return;
      const u = new Fc(l.index);
      u.transform = l.transform;
      for (const h of d) {
        const f = h.clone();
        u.appendChild(f), f instanceof Fc && r.has(f.index) && !c.has(f.index) && (c.add(f.index), o(f, c), c.delete(f.index));
      }
      t.replace(l, [u]);
    }, a = /* @__PURE__ */ new Set();
    for (const l of s)
      o(l, a);
    return t.children.slice(n);
  }
  ensureFinalTabstop(e, t, n) {
    (t || n && e.placeholders.length > 0) && (e.placeholders.find((s) => s.index === 0) || e.appendChild(new Fc(0)));
  }
  _accept(e, t) {
    if (e === void 0 || this._token.type === e) {
      const n = t ? this._scanner.tokenText(this._token) : !0;
      return this._token = this._scanner.next(), n;
    }
    return !1;
  }
  _backTo(e) {
    return this._scanner.pos = e.pos + e.len, this._token = e, !1;
  }
  _until(e) {
    const t = this._token;
    for (; this._token.type !== e; ) {
      if (this._token.type === 14)
        return !1;
      if (this._token.type === 5) {
        const r = this._scanner.next();
        if (r.type !== 0 && r.type !== 4 && r.type !== 5)
          return !1;
      }
      this._token = this._scanner.next();
    }
    const n = this._scanner.value.substring(t.pos, this._token.pos).replace(/\\(\$|}|\\)/g, "$1");
    return this._token = this._scanner.next(), n;
  }
  _parse(e) {
    return this._parseEscaped(e) || this._parseTabstopOrVariableName(e) || this._parseComplexPlaceholder(e) || this._parseComplexVariable(e) || this._parseAnything(e);
  }
  // \$, \\, \} -> just text
  _parseEscaped(e) {
    let t;
    return (t = this._accept(5, !0)) ? (t = this._accept(0, !0) || this._accept(4, !0) || this._accept(5, !0) || t, e.appendChild(new co(t)), !0) : !1;
  }
  // $foo -> variable, $1 -> tabstop
  _parseTabstopOrVariableName(e) {
    let t;
    const n = this._token;
    return this._accept(
      0
      /* TokenType.Dollar */
    ) && (t = this._accept(9, !0) || this._accept(8, !0)) ? (e.appendChild(/^\d+$/.test(t) ? new Fc(Number(t)) : new Pw(t)), !0) : this._backTo(n);
  }
  // ${1:<children>}, ${1} -> placeholder
  _parseComplexPlaceholder(e) {
    let t;
    const n = this._token;
    if (!(this._accept(
      0
      /* TokenType.Dollar */
    ) && this._accept(
      3
      /* TokenType.CurlyOpen */
    ) && (t = this._accept(8, !0))))
      return this._backTo(n);
    const s = new Fc(Number(t));
    if (this._accept(
      1
      /* TokenType.Colon */
    ))
      for (; ; ) {
        if (this._accept(
          4
          /* TokenType.CurlyClose */
        ))
          return e.appendChild(s), !0;
        if (!this._parse(s))
          return e.appendChild(new co("${" + t + ":")), s.children.forEach(e.appendChild, e), !0;
      }
    else if (s.index > 0 && this._accept(
      7
      /* TokenType.Pipe */
    )) {
      const o = new Ib();
      for (; ; ) {
        if (this._parseChoiceElement(o)) {
          if (this._accept(
            2
            /* TokenType.Comma */
          ))
            continue;
          if (this._accept(
            7
            /* TokenType.Pipe */
          ) && (s.appendChild(o), this._accept(
            4
            /* TokenType.CurlyClose */
          )))
            return e.appendChild(s), !0;
        }
        return this._backTo(n), !1;
      }
    } else return this._accept(
      6
      /* TokenType.Forwardslash */
    ) ? this._parseTransform(s) ? (e.appendChild(s), !0) : (this._backTo(n), !1) : this._accept(
      4
      /* TokenType.CurlyClose */
    ) ? (e.appendChild(s), !0) : this._backTo(n);
  }
  _parseChoiceElement(e) {
    const t = this._token, n = [];
    for (; !(this._token.type === 2 || this._token.type === 7); ) {
      let r;
      if ((r = this._accept(5, !0)) ? r = this._accept(2, !0) || this._accept(7, !0) || this._accept(5, !0) || r : r = this._accept(void 0, !0), !r)
        return this._backTo(t), !1;
      n.push(r);
    }
    return n.length === 0 ? (this._backTo(t), !1) : (e.appendChild(new co(n.join(""))), !0);
  }
  // ${foo:<children>}, ${foo} -> variable
  _parseComplexVariable(e) {
    let t;
    const n = this._token;
    if (!(this._accept(
      0
      /* TokenType.Dollar */
    ) && this._accept(
      3
      /* TokenType.CurlyOpen */
    ) && (t = this._accept(9, !0))))
      return this._backTo(n);
    const s = new Pw(t);
    if (this._accept(
      1
      /* TokenType.Colon */
    ))
      for (; ; ) {
        if (this._accept(
          4
          /* TokenType.CurlyClose */
        ))
          return e.appendChild(s), !0;
        if (!this._parse(s))
          return e.appendChild(new co("${" + t + ":")), s.children.forEach(e.appendChild, e), !0;
      }
    else return this._accept(
      6
      /* TokenType.Forwardslash */
    ) ? this._parseTransform(s) ? (e.appendChild(s), !0) : (this._backTo(n), !1) : this._accept(
      4
      /* TokenType.CurlyClose */
    ) ? (e.appendChild(s), !0) : this._backTo(n);
  }
  _parseTransform(e) {
    const t = new EG();
    let n = "", r = "";
    for (; !this._accept(
      6
      /* TokenType.Forwardslash */
    ); ) {
      let s;
      if (s = this._accept(5, !0)) {
        s = this._accept(6, !0) || s, n += s;
        continue;
      }
      if (this._token.type !== 14) {
        n += this._accept(void 0, !0);
        continue;
      }
      return !1;
    }
    for (; !this._accept(
      6
      /* TokenType.Forwardslash */
    ); ) {
      let s;
      if (s = this._accept(5, !0)) {
        s = this._accept(5, !0) || this._accept(6, !0) || s, t.appendChild(new co(s));
        continue;
      }
      if (!(this._parseFormatString(t) || this._parseAnything(t)))
        return !1;
    }
    for (; !this._accept(
      4
      /* TokenType.CurlyClose */
    ); ) {
      if (this._token.type !== 14) {
        r += this._accept(void 0, !0);
        continue;
      }
      return !1;
    }
    try {
      t.regexp = new RegExp(n, r);
    } catch {
      return !1;
    }
    return e.transform = t, !0;
  }
  _parseFormatString(e) {
    const t = this._token;
    if (!this._accept(
      0
      /* TokenType.Dollar */
    ))
      return !1;
    let n = !1;
    this._accept(
      3
      /* TokenType.CurlyOpen */
    ) && (n = !0);
    const r = this._accept(8, !0);
    if (r)
      if (n) {
        if (this._accept(
          4
          /* TokenType.CurlyClose */
        ))
          return e.appendChild(new Pc(Number(r))), !0;
        if (!this._accept(
          1
          /* TokenType.Colon */
        ))
          return this._backTo(t), !1;
      } else return e.appendChild(new Pc(Number(r))), !0;
    else return this._backTo(t), !1;
    if (this._accept(
      6
      /* TokenType.Forwardslash */
    )) {
      const s = this._accept(9, !0);
      return !s || !this._accept(
        4
        /* TokenType.CurlyClose */
      ) ? (this._backTo(t), !1) : (e.appendChild(new Pc(Number(r), s)), !0);
    } else if (this._accept(
      11
      /* TokenType.Plus */
    )) {
      const s = this._until(
        4
        /* TokenType.CurlyClose */
      );
      if (s)
        return e.appendChild(new Pc(Number(r), void 0, s, void 0)), !0;
    } else if (this._accept(
      12
      /* TokenType.Dash */
    )) {
      const s = this._until(
        4
        /* TokenType.CurlyClose */
      );
      if (s)
        return e.appendChild(new Pc(Number(r), void 0, void 0, s)), !0;
    } else if (this._accept(
      13
      /* TokenType.QuestionMark */
    )) {
      const s = this._until(
        1
        /* TokenType.Colon */
      );
      if (s) {
        const o = this._until(
          4
          /* TokenType.CurlyClose */
        );
        if (o)
          return e.appendChild(new Pc(Number(r), void 0, s, o)), !0;
      }
    } else {
      const s = this._until(
        4
        /* TokenType.CurlyClose */
      );
      if (s)
        return e.appendChild(new Pc(Number(r), void 0, void 0, s)), !0;
    }
    return this._backTo(t), !1;
  }
  _parseAnything(e) {
    return this._token.type !== 14 ? (e.appendChild(new co(this._scanner.tokenText(this._token))), this._accept(void 0), !0) : !1;
  }
}
var FT = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function wnt(i, e, t, n, r = jt.None, s) {
  return FT(this, void 0, void 0, function* () {
    const o = Dnt(e, t), a = i.all(t), l = new nz();
    for (const _ of a)
      _.groupId && l.add(_.groupId, _);
    function c(_) {
      if (!_.yieldsToGroupIds)
        return [];
      const b = [];
      for (const w of _.yieldsToGroupIds || []) {
        const y = l.get(w);
        for (const S of y)
          b.push(S);
      }
      return b;
    }
    const d = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Set();
    function h(_, b) {
      if (b = [...b, _], u.has(_))
        return b;
      u.add(_);
      try {
        const w = c(_);
        for (const y of w) {
          const S = h(y, b);
          if (S)
            return S;
        }
      } finally {
        u.delete(_);
      }
    }
    function f(_) {
      const b = d.get(_);
      if (b)
        return b;
      const w = h(_, []);
      w && vr(new Error(`Inline completions: cyclic yield-to dependency detected. Path: ${w.map((S) => S.toString ? S.toString() : "" + S).join(" -> ")}`));
      const y = new r4();
      return d.set(_, y.p), FT(this, void 0, void 0, function* () {
        if (!w) {
          const S = c(_);
          for (const x of S) {
            const D = yield f(x);
            if (D && D.items.length > 0)
              return;
          }
        }
        try {
          return yield _.provideInlineCompletions(t, e, n, r);
        } catch (S) {
          vr(S);
          return;
        }
      }).then((S) => y.complete(S), (S) => y.error(S)), y.p;
    }
    const g = yield Promise.all(a.map((_) => FT(this, void 0, void 0, function* () {
      return { provider: _, completions: yield f(_) };
    }))), p = /* @__PURE__ */ new Map(), m = [];
    for (const _ of g) {
      const b = _.completions;
      if (!b)
        continue;
      const w = new xnt(b, _.provider);
      m.push(w);
      for (const y of b.items) {
        const S = kI.from(y, w, o, t, s);
        p.set(S.hash(), S);
      }
    }
    return new Snt(Array.from(p.values()), new Set(p.keys()), m);
  });
}
class Snt {
  constructor(e, t, n) {
    this.completions = e, this.hashs = t, this.providerResults = n;
  }
  has(e) {
    return this.hashs.has(e.hash());
  }
  dispose() {
    for (const e of this.providerResults)
      e.removeRef();
  }
}
class xnt {
  constructor(e, t) {
    this.inlineCompletions = e, this.provider = t, this.refCount = 1;
  }
  addRef() {
    this.refCount++;
  }
  removeRef() {
    this.refCount--, this.refCount === 0 && this.provider.freeInlineCompletions(this.inlineCompletions);
  }
}
class kI {
  static from(e, t, n, r, s) {
    let o, a, l = e.range ? V.lift(e.range) : n;
    if (typeof e.insertText == "string") {
      if (o = e.insertText, s && e.completeBracketPairs) {
        o = aee(o, l.getStartPosition(), r, s);
        const c = o.length - e.insertText.length;
        c !== 0 && (l = new V(l.startLineNumber, l.startColumn, l.endLineNumber, l.endColumn + c));
      }
      a = void 0;
    } else if ("snippet" in e.insertText) {
      const c = e.insertText.snippet.length;
      if (s && e.completeBracketPairs) {
        e.insertText.snippet = aee(e.insertText.snippet, l.getStartPosition(), r, s);
        const u = e.insertText.snippet.length - c;
        u !== 0 && (l = new V(l.startLineNumber, l.startColumn, l.endLineNumber, l.endColumn + u));
      }
      const d = new q_().parse(e.insertText.snippet);
      d.children.length === 1 && d.children[0] instanceof co ? (o = d.children[0].value, a = void 0) : (o = d.toString(), a = {
        snippet: e.insertText.snippet,
        range: l
      });
    } else
      $A(e.insertText);
    return new kI(o, e.command, l, o, a, e.additionalTextEdits || fnt(), e, t);
  }
  constructor(e, t, n, r, s, o, a, l) {
    this.filterText = e, this.command = t, this.range = n, this.insertText = r, this.snippetInfo = s, this.additionalTextEdits = o, this.sourceInlineCompletion = a, this.source = l, e = e.replace(/\r\n|\r/g, `
`), r = e.replace(/\r\n|\r/g, `
`);
  }
  withRange(e) {
    return new kI(this.filterText, this.command, e, this.insertText, this.snippetInfo, this.additionalTextEdits, this.sourceInlineCompletion, this.source);
  }
  hash() {
    return JSON.stringify({ insertText: this.insertText, range: this.range.toString() });
  }
}
function Dnt(i, e) {
  const t = e.getWordAtPosition(i), n = e.getLineMaxColumn(i.lineNumber);
  return t ? new V(i.lineNumber, t.startColumn, i.lineNumber, n) : V.fromPositions(i, i.with(void 0, n));
}
function aee(i, e, t, n) {
  const s = t.getLineContent(e.lineNumber).substring(0, e.column - 1) + i, o = t.tokenization.tokenizeLineWithEdit(e, s.length - (e.column - 1), i), a = o?.sliceAndInflate(e.column - 1, s.length, 0);
  return a ? Cnt(a, n) : i;
}
class K_ {
  constructor(e, t) {
    this.range = e, this.text = t;
  }
  removeCommonPrefix(e, t) {
    const n = t ? this.range.intersectRanges(t) : this.range;
    if (!n)
      return this;
    const r = e.getValueInRange(
      n,
      1
      /* EndOfLinePreference.LF */
    ), s = Um(r, this.text), o = _H(this.range.getStartPosition(), bH(r.substring(0, s))), a = this.text.substring(s), l = V.fromPositions(o, this.range.getEndPosition());
    return new K_(l, a);
  }
  augments(e) {
    return this.text.startsWith(e.text) && Ent(this.range, e.range);
  }
  /**
   * @param previewSuffixLength Sets where to split `inlineCompletion.text`.
   * 	If the text is `hello` and the suffix length is 2, the non-preview part is `hel` and the preview-part is `lo`.
  */
  computeGhostText(e, t, n, r = 0) {
    let s = this.removeCommonPrefix(e);
    if (s.range.endLineNumber !== s.range.startLineNumber)
      return;
    const o = e.getLineContent(s.range.startLineNumber), a = Hn(o).length;
    if (s.range.startColumn - 1 <= a) {
      const g = Hn(s.text).length, p = o.substring(s.range.startColumn - 1, a), [m, _] = [s.range.getStartPosition(), s.range.getEndPosition()], b = m.column + p.length <= _.column ? m.delta(0, p.length) : _, w = V.fromPositions(b, _), y = s.text.startsWith(p) ? s.text.substring(p.length) : s.text.substring(g);
      s = new K_(w, y);
    }
    const c = e.getValueInRange(s.range), d = Lnt(c, s.text);
    if (!d)
      return;
    const u = s.range.startLineNumber, h = new Array();
    if (t === "prefix") {
      const g = d.filter((p) => p.originalLength === 0);
      if (g.length > 1 || g.length === 1 && g[0].originalStart !== c.length)
        return;
    }
    const f = s.text.length - r;
    for (const g of d) {
      const p = s.range.startColumn + g.originalStart + g.originalLength;
      if (t === "subwordSmart" && n && n.lineNumber === s.range.startLineNumber && p < n.column || g.originalLength > 0)
        return;
      if (g.modifiedLength === 0)
        continue;
      const m = g.modifiedStart + g.modifiedLength, _ = Math.max(g.modifiedStart, Math.min(m, f)), b = s.text.substring(g.modifiedStart, _), w = s.text.substring(_, Math.max(g.modifiedStart, m));
      if (b.length > 0) {
        const y = Cu(b);
        h.push(new CH(p, y, !1));
      }
      if (w.length > 0) {
        const y = Cu(w);
        h.push(new CH(p, y, !0));
      }
    }
    return new AI(u, h);
  }
}
function Ent(i, e) {
  return e.getStartPosition().equals(i.getStartPosition()) && e.getEndPosition().isBeforeOrEqual(i.getEndPosition());
}
let Dd;
function Lnt(i, e) {
  if (Dd?.originalValue === i && Dd?.newValue === e)
    return Dd?.changes;
  {
    let t = cee(i, e, !0);
    if (t) {
      const n = lee(t);
      if (n > 0) {
        const r = cee(i, e, !1);
        r && lee(r) < n && (t = r);
      }
    }
    return Dd = {
      originalValue: i,
      newValue: e,
      changes: t
    }, t;
  }
}
function lee(i) {
  let e = 0;
  for (const t of i)
    e += t.originalLength;
  return e;
}
function cee(i, e, t) {
  if (i.length > 5e3 || e.length > 5e3)
    return;
  function n(c) {
    let d = 0;
    for (let u = 0, h = c.length; u < h; u++) {
      const f = c.charCodeAt(u);
      f > d && (d = f);
    }
    return d;
  }
  const r = Math.max(n(i), n(e));
  function s(c) {
    if (c < 0)
      throw new Error("unexpected");
    return r + c + 1;
  }
  function o(c) {
    let d = 0, u = 0;
    const h = new Int32Array(c.length);
    for (let f = 0, g = c.length; f < g; f++)
      if (t && c[f] === "(") {
        const p = u * 100 + d;
        h[f] = s(2 * p), d++;
      } else if (t && c[f] === ")") {
        d = Math.max(d - 1, 0);
        const p = u * 100 + d;
        h[f] = s(2 * p + 1), d === 0 && u++;
      } else
        h[f] = c.charCodeAt(f);
    return h;
  }
  const a = o(i), l = o(e);
  return new Wd({ getElements: () => a }, { getElements: () => l }).ComputeDiff(!1).changes;
}
var Int = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, dee = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Ant = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let SH = class extends we {
  constructor(e, t, n, r, s) {
    super(), this.textModel = e, this.versionId = t, this._debounceValue = n, this.languageFeaturesService = r, this.languageConfigurationService = s, this._updateOperation = this._register(new ds()), this.inlineCompletions = iI("inlineCompletions", void 0), this.suggestWidgetInlineCompletions = iI("suggestWidgetInlineCompletions", void 0), this._register(this.textModel.onDidChangeContent(() => {
      this._updateOperation.clear();
    }));
  }
  fetch(e, t, n) {
    var r, s;
    const o = new Tnt(e, t, this.textModel.getVersionId()), a = t.selectedSuggestionInfo ? this.suggestWidgetInlineCompletions : this.inlineCompletions;
    if (!((r = this._updateOperation.value) === null || r === void 0) && r.request.satisfies(o))
      return this._updateOperation.value.promise;
    if (!((s = a.get()) === null || s === void 0) && s.request.satisfies(o))
      return Promise.resolve(!0);
    const l = !!this._updateOperation.value;
    this._updateOperation.clear();
    const c = new lr(), d = Ant(this, void 0, void 0, function* () {
      if ((l || t.triggerKind === Fh.Automatic) && (yield knt(this._debounceValue.get(this.textModel))), c.token.isCancellationRequested || this.textModel.getVersionId() !== o.versionId)
        return !1;
      const f = /* @__PURE__ */ new Date(), g = yield wnt(this.languageFeaturesService.inlineCompletionsProvider, e, this.textModel, t, c.token, this.languageConfigurationService);
      if (c.token.isCancellationRequested || this.textModel.getVersionId() !== o.versionId)
        return !1;
      const p = /* @__PURE__ */ new Date();
      this._debounceValue.update(this.textModel, p.getTime() - f.getTime());
      const m = new Ont(g, o, this.textModel, this.versionId);
      if (n) {
        const _ = n.toInlineCompletion(void 0);
        n.canBeReused(this.textModel, e) && !g.has(_) && m.prepend(n.inlineCompletion, _.range, !0);
      }
      return this._updateOperation.clear(), di((_) => {
        a.set(m, _);
      }), !0;
    }), u = new Pnt(o, c, d);
    return this._updateOperation.value = u, d;
  }
  clear(e) {
    this._updateOperation.clear(), this.inlineCompletions.set(void 0, e), this.suggestWidgetInlineCompletions.set(void 0, e);
  }
  clearSuggestWidgetInlineCompletions(e) {
    var t;
    !((t = this._updateOperation.value) === null || t === void 0) && t.request.context.selectedSuggestionInfo && this._updateOperation.clear(), this.suggestWidgetInlineCompletions.set(void 0, e);
  }
  cancelUpdate() {
    this._updateOperation.clear();
  }
};
SH = Int([
  dee(3, tt),
  dee(4, Un)
], SH);
function knt(i, e) {
  return new Promise((t) => {
    setTimeout(() => {
      t();
    }, i);
  });
}
class Tnt {
  constructor(e, t, n) {
    this.position = e, this.context = t, this.versionId = n;
  }
  satisfies(e) {
    return this.position.equals(e.position) && Nnt(this.context.selectedSuggestionInfo, e.context.selectedSuggestionInfo, (t, n) => t.equals(n)) && (e.context.triggerKind === Fh.Automatic || this.context.triggerKind === Fh.Explicit) && this.versionId === e.versionId;
  }
}
function Nnt(i, e, t) {
  return !i || !e ? i === e : t(i, e);
}
class Pnt {
  constructor(e, t, n) {
    this.request = e, this.cancellationTokenSource = t, this.promise = n;
  }
  dispose() {
    this.cancellationTokenSource.cancel();
  }
}
class Ont {
  get inlineCompletions() {
    return this._inlineCompletions;
  }
  constructor(e, t, n, r) {
    this.inlineCompletionProviderResult = e, this.request = t, this.textModel = n, this.versionId = r, this._refCount = 1, this._prependedInlineCompletionItems = [], this._rangeVersionIdValue = 0, this._rangeVersionId = nn(this, (o) => {
      this.versionId.read(o);
      let a = !1;
      for (const l of this._inlineCompletions)
        a = a || l._updateRange(this.textModel);
      return a && this._rangeVersionIdValue++, this._rangeVersionIdValue;
    });
    const s = n.deltaDecorations([], e.completions.map((o) => ({
      range: o.range,
      options: {
        description: "inline-completion-tracking-range"
      }
    })));
    this._inlineCompletions = e.completions.map((o, a) => new uee(o, s[a], this._rangeVersionId));
  }
  clone() {
    return this._refCount++, this;
  }
  dispose() {
    if (this._refCount--, this._refCount === 0) {
      setTimeout(() => {
        this.textModel.isDisposed() || this.textModel.deltaDecorations(this._inlineCompletions.map((e) => e.decorationId), []);
      }, 0), this.inlineCompletionProviderResult.dispose();
      for (const e of this._prependedInlineCompletionItems)
        e.source.removeRef();
    }
  }
  prepend(e, t, n) {
    n && e.source.addRef();
    const r = this.textModel.deltaDecorations([], [{
      range: t,
      options: {
        description: "inline-completion-tracking-range"
      }
    }])[0];
    this._inlineCompletions.unshift(new uee(e, r, this._rangeVersionId, t)), this._prependedInlineCompletionItems.push(e);
  }
}
class uee {
  get forwardStable() {
    var e;
    return (e = this.inlineCompletion.source.inlineCompletions.enableForwardStability) !== null && e !== void 0 ? e : !1;
  }
  constructor(e, t, n, r) {
    this.inlineCompletion = e, this.decorationId = t, this.rangeVersion = n, this.semanticId = JSON.stringify([
      this.inlineCompletion.filterText,
      this.inlineCompletion.insertText,
      this.inlineCompletion.range.getStartPosition().toString()
    ]), this._isValid = !0, this._updatedRange = r ?? e.range;
  }
  toInlineCompletion(e) {
    return this.inlineCompletion.withRange(this._getUpdatedRange(e));
  }
  toSingleTextEdit(e) {
    return new K_(this._getUpdatedRange(e), this.inlineCompletion.insertText);
  }
  isVisible(e, t, n) {
    const r = this._toFilterTextReplacement(n).removeCommonPrefix(e);
    if (!this._isValid || !this.inlineCompletion.range.getStartPosition().equals(this._getUpdatedRange(n).getStartPosition()) || t.lineNumber !== r.range.startLineNumber)
      return !1;
    const s = e.getValueInRange(
      r.range,
      1
      /* EndOfLinePreference.LF */
    ).toLowerCase(), o = r.text.toLowerCase(), a = Math.max(0, t.column - r.range.startColumn);
    let l = o.substring(0, a), c = o.substring(a), d = s.substring(0, a), u = s.substring(a);
    const h = e.getLineIndentColumn(r.range.startLineNumber);
    return r.range.startColumn <= h && (d = d.trimStart(), d.length === 0 && (u = u.trimStart()), l = l.trimStart(), l.length === 0 && (c = c.trimStart())), l.startsWith(d) && !!npe(u, c);
  }
  canBeReused(e, t) {
    return this._isValid && this._getUpdatedRange(void 0).containsPosition(t) && this.isVisible(e, t, void 0) && !this._isSmallerThanOriginal(void 0);
  }
  _toFilterTextReplacement(e) {
    return new K_(this._getUpdatedRange(e), this.inlineCompletion.filterText);
  }
  _isSmallerThanOriginal(e) {
    return hee(this._getUpdatedRange(e)).isBefore(hee(this.inlineCompletion.range));
  }
  _getUpdatedRange(e) {
    return this.rangeVersion.read(e), this._updatedRange;
  }
  _updateRange(e) {
    const t = e.getDecorationRange(this.decorationId);
    return t ? this._updatedRange.equalsRange(t) ? !1 : (this._updatedRange = t, !0) : (this._isValid = !1, !0);
  }
}
function hee(i) {
  return i.startLineNumber === i.endLineNumber ? new ve(1, 1 + i.endColumn - i.startColumn) : new ve(1 + i.endLineNumber - i.startLineNumber, i.endColumn);
}
var qC = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const kt = {
  Visible: _G,
  HasFocusedSuggestion: new Ke("suggestWidgetHasFocusedSuggestion", !1, C("suggestWidgetHasSelection", "Whether any suggestion is focused")),
  DetailsVisible: new Ke("suggestWidgetDetailsVisible", !1, C("suggestWidgetDetailsVisible", "Whether suggestion details are visible")),
  MultipleSuggestions: new Ke("suggestWidgetMultipleSuggestions", !1, C("suggestWidgetMultipleSuggestions", "Whether there are multiple suggestions to pick from")),
  MakesTextEdit: new Ke("suggestionMakesTextEdit", !0, C("suggestionMakesTextEdit", "Whether inserting the current suggestion yields in a change or has everything already been typed")),
  AcceptSuggestionsOnEnter: new Ke("acceptSuggestionOnEnter", !0, C("acceptSuggestionOnEnter", "Whether suggestions are inserted when pressing Enter")),
  HasInsertAndReplaceRange: new Ke("suggestionHasInsertAndReplaceRange", !1, C("suggestionHasInsertAndReplaceRange", "Whether the current suggestion has insert and replace behaviour")),
  InsertMode: new Ke("suggestionInsertMode", void 0, { type: "string", description: C("suggestionInsertMode", "Whether the default behaviour is to insert or replace") }),
  CanResolve: new Ke("suggestionCanResolve", !1, C("suggestionCanResolve", "Whether the current suggestion supports to resolve further details"))
}, Eg = new J("suggestWidgetStatusBar");
class Mnt {
  constructor(e, t, n, r) {
    var s;
    this.position = e, this.completion = t, this.container = n, this.provider = r, this.isInvalid = !1, this.score = td.Default, this.distance = 0, this.textLabel = typeof t.label == "string" ? t.label : (s = t.label) === null || s === void 0 ? void 0 : s.label, this.labelLow = this.textLabel.toLowerCase(), this.isInvalid = !this.textLabel, this.sortTextLow = t.sortText && t.sortText.toLowerCase(), this.filterTextLow = t.filterText && t.filterText.toLowerCase(), this.extensionId = t.extensionId, V.isIRange(t.range) ? (this.editStart = new ve(t.range.startLineNumber, t.range.startColumn), this.editInsertEnd = new ve(t.range.endLineNumber, t.range.endColumn), this.editReplaceEnd = new ve(t.range.endLineNumber, t.range.endColumn), this.isInvalid = this.isInvalid || V.spansMultipleLines(t.range) || t.range.startLineNumber !== e.lineNumber) : (this.editStart = new ve(t.range.insert.startLineNumber, t.range.insert.startColumn), this.editInsertEnd = new ve(t.range.insert.endLineNumber, t.range.insert.endColumn), this.editReplaceEnd = new ve(t.range.replace.endLineNumber, t.range.replace.endColumn), this.isInvalid = this.isInvalid || V.spansMultipleLines(t.range.insert) || V.spansMultipleLines(t.range.replace) || t.range.insert.startLineNumber !== e.lineNumber || t.range.replace.startLineNumber !== e.lineNumber || t.range.insert.startColumn !== t.range.replace.startColumn), typeof r.resolveCompletionItem != "function" && (this._resolveCache = Promise.resolve(), this._resolveDuration = 0);
  }
  // ---- resolving
  get isResolved() {
    return this._resolveDuration !== void 0;
  }
  get resolveDuration() {
    return this._resolveDuration !== void 0 ? this._resolveDuration : -1;
  }
  resolve(e) {
    return qC(this, void 0, void 0, function* () {
      if (!this._resolveCache) {
        const t = e.onCancellationRequested(() => {
          this._resolveCache = void 0, this._resolveDuration = void 0;
        }), n = new Vs(!0);
        this._resolveCache = Promise.resolve(this.provider.resolveCompletionItem(this.completion, e)).then((r) => {
          Object.assign(this.completion, r), this._resolveDuration = n.elapsed();
        }, (r) => {
          md(r) && (this._resolveCache = void 0, this._resolveDuration = void 0);
        }).finally(() => {
          t.dispose();
        });
      }
      return this._resolveCache;
    });
  }
}
class Ow {
  constructor(e = 2, t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Map(), s = !0) {
    this.snippetSortOrder = e, this.kindFilter = t, this.providerFilter = n, this.providerItemsToReuse = r, this.showDeprecated = s;
  }
}
Ow.default = new Ow();
let Rnt;
function Fnt() {
  return Rnt;
}
class Bnt {
  constructor(e, t, n, r) {
    this.items = e, this.needsClipboard = t, this.durations = n, this.disposable = r;
  }
}
function LG(i, e, t, n = Ow.default, r = {
  triggerKind: 0
  /* languages.CompletionTriggerKind.Invoke */
}, s = jt.None) {
  return qC(this, void 0, void 0, function* () {
    const o = new Vs();
    t = t.clone();
    const a = e.getWordAtPosition(t), l = a ? new V(t.lineNumber, a.startColumn, t.lineNumber, a.endColumn) : V.fromPositions(t), c = { replace: l, insert: l.setEndPosition(t.lineNumber, t.column) }, d = [], u = new Ne(), h = [];
    let f = !1;
    const g = (m, _, b) => {
      var w, y, S;
      let x = !1;
      if (!_)
        return x;
      for (const D of _.suggestions)
        if (!n.kindFilter.has(D.kind)) {
          if (!n.showDeprecated && (!((w = D?.tags) === null || w === void 0) && w.includes(
            1
            /* languages.CompletionItemTag.Deprecated */
          )))
            continue;
          D.range || (D.range = c), D.sortText || (D.sortText = typeof D.label == "string" ? D.label : D.label.label), !f && D.insertTextRules && D.insertTextRules & 4 && (f = q_.guessNeedsClipboard(D.insertText)), d.push(new Mnt(t, D, _, m)), x = !0;
        }
      return kj(_) && u.add(_), h.push({
        providerName: (y = m._debugDisplayName) !== null && y !== void 0 ? y : "unknown_provider",
        elapsedProvider: (S = _.duration) !== null && S !== void 0 ? S : -1,
        elapsedOverall: b.elapsed()
      }), x;
    }, p = qC(this, void 0, void 0, function* () {
    });
    for (const m of i.orderedGroups(e)) {
      let _ = !1;
      if (yield Promise.all(m.map((b) => qC(this, void 0, void 0, function* () {
        if (n.providerItemsToReuse.has(b)) {
          const w = n.providerItemsToReuse.get(b);
          w.forEach((y) => d.push(y)), _ = _ || w.length > 0;
          return;
        }
        if (!(n.providerFilter.size > 0 && !n.providerFilter.has(b)))
          try {
            const w = new Vs(), y = yield b.provideCompletionItems(e, t, r, s);
            _ = g(b, y, w) || _;
          } catch (w) {
            vr(w);
          }
      }))), _ || s.isCancellationRequested)
        break;
    }
    return yield p, s.isCancellationRequested ? (u.dispose(), Promise.reject(new op())) : new Bnt(d.sort(Wnt(n.snippetSortOrder)), f, { entries: h, elapsed: o.elapsed() }, u);
  });
}
function IG(i, e) {
  if (i.sortTextLow && e.sortTextLow) {
    if (i.sortTextLow < e.sortTextLow)
      return -1;
    if (i.sortTextLow > e.sortTextLow)
      return 1;
  }
  return i.textLabel < e.textLabel ? -1 : i.textLabel > e.textLabel ? 1 : i.completion.kind - e.completion.kind;
}
function Vnt(i, e) {
  if (i.completion.kind !== e.completion.kind) {
    if (i.completion.kind === 27)
      return -1;
    if (e.completion.kind === 27)
      return 1;
  }
  return IG(i, e);
}
function Hnt(i, e) {
  if (i.completion.kind !== e.completion.kind) {
    if (i.completion.kind === 27)
      return 1;
    if (e.completion.kind === 27)
      return -1;
  }
  return IG(i, e);
}
const A5 = /* @__PURE__ */ new Map();
A5.set(0, Vnt);
A5.set(2, Hnt);
A5.set(1, IG);
function Wnt(i) {
  return A5.get(i);
}
on.registerCommand("_executeCompletionItemProvider", (i, ...e) => qC(void 0, void 0, void 0, function* () {
  const [t, n, r, s] = e;
  On(pt.isUri(t)), On(ve.isIPosition(n)), On(typeof r == "string" || !r), On(typeof s == "number" || !s);
  const { completionProvider: o } = i.get(tt), a = yield i.get(Wo).createModelReference(t);
  try {
    const l = {
      incomplete: !1,
      suggestions: []
    }, c = [], d = a.object.textEditorModel.validatePosition(n), u = yield LG(o, a.object.textEditorModel, d, void 0, {
      triggerCharacter: r ?? void 0,
      triggerKind: r ? 1 : 0
      /* languages.CompletionTriggerKind.Invoke */
    });
    for (const h of u.items)
      c.length < (s ?? 0) && c.push(h.resolve(jt.None)), l.incomplete = l.incomplete || h.container.incomplete, l.suggestions.push(h.completion);
    try {
      return yield Promise.all(c), l;
    } finally {
      setTimeout(() => u.disposable.dispose(), 100);
    }
  } finally {
    a.dispose();
  }
}));
function jnt(i, e) {
  var t;
  (t = i.getContribution("editor.contrib.suggestController")) === null || t === void 0 || t.triggerSuggest((/* @__PURE__ */ new Set()).add(e), void 0, !0);
}
class mv {
  static isAllOff(e) {
    return e.other === "off" && e.comments === "off" && e.strings === "off";
  }
  static isAllOn(e) {
    return e.other === "on" && e.comments === "on" && e.strings === "on";
  }
  static valueFor(e, t) {
    switch (t) {
      case 1:
        return e.comments;
      case 2:
        return e.strings;
      default:
        return e.other;
    }
  }
}
function fee(i, e = Ls) {
  return WBe(i, e) ? i.charAt(0).toUpperCase() + i.slice(1) : i;
}
var znt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Unt = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class gee {
  constructor(e) {
    this._delegates = e;
  }
  resolve(e) {
    for (const t of this._delegates) {
      const n = t.resolve(e);
      if (n !== void 0)
        return n;
    }
  }
}
class pee {
  constructor(e, t, n, r) {
    this._model = e, this._selection = t, this._selectionIdx = n, this._overtypingCapturer = r;
  }
  resolve(e) {
    const { name: t } = e;
    if (t === "SELECTION" || t === "TM_SELECTED_TEXT") {
      let n = this._model.getValueInRange(this._selection) || void 0, r = this._selection.startLineNumber !== this._selection.endLineNumber;
      if (!n && this._overtypingCapturer) {
        const s = this._overtypingCapturer.getLastOvertypedInfo(this._selectionIdx);
        s && (n = s.value, r = s.multiline);
      }
      if (n && r && e.snippet) {
        const s = this._model.getLineContent(this._selection.startLineNumber), o = Hn(s, 0, this._selection.startColumn - 1);
        let a = o;
        e.snippet.walk((c) => c === e ? !1 : (c instanceof co && (a = Hn(Cu(c.value).pop())), !0));
        const l = Um(a, o);
        n = n.replace(/(\r\n|\r|\n)(.*)/g, (c, d, u) => `${d}${a.substr(l)}${u}`);
      }
      return n;
    } else {
      if (t === "TM_CURRENT_LINE")
        return this._model.getLineContent(this._selection.positionLineNumber);
      if (t === "TM_CURRENT_WORD") {
        const n = this._model.getWordAtPosition({
          lineNumber: this._selection.positionLineNumber,
          column: this._selection.positionColumn
        });
        return n && n.word || void 0;
      } else {
        if (t === "TM_LINE_INDEX")
          return String(this._selection.positionLineNumber - 1);
        if (t === "TM_LINE_NUMBER")
          return String(this._selection.positionLineNumber);
        if (t === "CURSOR_INDEX")
          return String(this._selectionIdx);
        if (t === "CURSOR_NUMBER")
          return String(this._selectionIdx + 1);
      }
    }
  }
}
class mee {
  constructor(e, t) {
    this._labelService = e, this._model = t;
  }
  resolve(e) {
    const { name: t } = e;
    if (t === "TM_FILENAME")
      return fg(this._model.uri.fsPath);
    if (t === "TM_FILENAME_BASE") {
      const n = fg(this._model.uri.fsPath), r = n.lastIndexOf(".");
      return r <= 0 ? n : n.slice(0, r);
    } else {
      if (t === "TM_DIRECTORY")
        return ihe(this._model.uri.fsPath) === "." ? "" : this._labelService.getUriLabel(D4(this._model.uri));
      if (t === "TM_FILEPATH")
        return this._labelService.getUriLabel(this._model.uri);
      if (t === "RELATIVE_FILEPATH")
        return this._labelService.getUriLabel(this._model.uri, { relative: !0, noPrefix: !0 });
    }
  }
}
class vee {
  constructor(e, t, n, r) {
    this._readClipboardText = e, this._selectionIdx = t, this._selectionCount = n, this._spread = r;
  }
  resolve(e) {
    if (e.name !== "CLIPBOARD")
      return;
    const t = this._readClipboardText();
    if (t) {
      if (this._spread) {
        const n = t.split(/\r\n|\n|\r/).filter((r) => !dhe(r));
        if (n.length === this._selectionCount)
          return n[this._selectionIdx];
      }
      return t;
    }
  }
}
let TI = class {
  constructor(e, t, n) {
    this._model = e, this._selection = t, this._languageConfigurationService = n;
  }
  resolve(e) {
    const { name: t } = e, n = this._model.getLanguageIdAtPosition(this._selection.selectionStartLineNumber, this._selection.selectionStartColumn), r = this._languageConfigurationService.getLanguageConfiguration(n).comments;
    if (r) {
      if (t === "LINE_COMMENT")
        return r.lineCommentToken || void 0;
      if (t === "BLOCK_COMMENT_START")
        return r.blockCommentStartToken || void 0;
      if (t === "BLOCK_COMMENT_END")
        return r.blockCommentEndToken || void 0;
    }
  }
};
TI = znt([
  Unt(2, Un)
], TI);
class qc {
  constructor() {
    this._date = /* @__PURE__ */ new Date();
  }
  resolve(e) {
    const { name: t } = e;
    if (t === "CURRENT_YEAR")
      return String(this._date.getFullYear());
    if (t === "CURRENT_YEAR_SHORT")
      return String(this._date.getFullYear()).slice(-2);
    if (t === "CURRENT_MONTH")
      return String(this._date.getMonth().valueOf() + 1).padStart(2, "0");
    if (t === "CURRENT_DATE")
      return String(this._date.getDate().valueOf()).padStart(2, "0");
    if (t === "CURRENT_HOUR")
      return String(this._date.getHours().valueOf()).padStart(2, "0");
    if (t === "CURRENT_MINUTE")
      return String(this._date.getMinutes().valueOf()).padStart(2, "0");
    if (t === "CURRENT_SECOND")
      return String(this._date.getSeconds().valueOf()).padStart(2, "0");
    if (t === "CURRENT_DAY_NAME")
      return qc.dayNames[this._date.getDay()];
    if (t === "CURRENT_DAY_NAME_SHORT")
      return qc.dayNamesShort[this._date.getDay()];
    if (t === "CURRENT_MONTH_NAME")
      return qc.monthNames[this._date.getMonth()];
    if (t === "CURRENT_MONTH_NAME_SHORT")
      return qc.monthNamesShort[this._date.getMonth()];
    if (t === "CURRENT_SECONDS_UNIX")
      return String(Math.floor(this._date.getTime() / 1e3));
    if (t === "CURRENT_TIMEZONE_OFFSET") {
      const n = this._date.getTimezoneOffset(), r = n > 0 ? "-" : "+", s = Math.trunc(Math.abs(n / 60)), o = s < 10 ? "0" + s : s, a = Math.abs(n) - s * 60, l = a < 10 ? "0" + a : a;
      return r + o + ":" + l;
    }
  }
}
qc.dayNames = [C("Sunday", "Sunday"), C("Monday", "Monday"), C("Tuesday", "Tuesday"), C("Wednesday", "Wednesday"), C("Thursday", "Thursday"), C("Friday", "Friday"), C("Saturday", "Saturday")];
qc.dayNamesShort = [C("SundayShort", "Sun"), C("MondayShort", "Mon"), C("TuesdayShort", "Tue"), C("WednesdayShort", "Wed"), C("ThursdayShort", "Thu"), C("FridayShort", "Fri"), C("SaturdayShort", "Sat")];
qc.monthNames = [C("January", "January"), C("February", "February"), C("March", "March"), C("April", "April"), C("May", "May"), C("June", "June"), C("July", "July"), C("August", "August"), C("September", "September"), C("October", "October"), C("November", "November"), C("December", "December")];
qc.monthNamesShort = [C("JanuaryShort", "Jan"), C("FebruaryShort", "Feb"), C("MarchShort", "Mar"), C("AprilShort", "Apr"), C("MayShort", "May"), C("JuneShort", "Jun"), C("JulyShort", "Jul"), C("AugustShort", "Aug"), C("SeptemberShort", "Sep"), C("OctoberShort", "Oct"), C("NovemberShort", "Nov"), C("DecemberShort", "Dec")];
class _ee {
  constructor(e) {
    this._workspaceService = e;
  }
  resolve(e) {
    if (!this._workspaceService)
      return;
    const t = tje(this._workspaceService.getWorkspace());
    if (!$We(t)) {
      if (e.name === "WORKSPACE_NAME")
        return this._resolveWorkspaceName(t);
      if (e.name === "WORKSPACE_FOLDER")
        return this._resoveWorkspacePath(t);
    }
  }
  _resolveWorkspaceName(e) {
    if (oB(e))
      return fg(e.uri.path);
    let t = fg(e.configPath.path);
    return t.endsWith(aB) && (t = t.substr(0, t.length - aB.length - 1)), t;
  }
  _resoveWorkspacePath(e) {
    if (oB(e))
      return fee(e.uri.fsPath);
    const t = fg(e.configPath.path);
    let n = e.configPath.fsPath;
    return n.endsWith(t) && (n = n.substr(0, n.length - t.length - 1)), n ? fee(n) : "/";
  }
}
class bee {
  resolve(e) {
    const { name: t } = e;
    if (t === "RANDOM")
      return Math.random().toString().slice(-6);
    if (t === "RANDOM_HEX")
      return Math.random().toString(16).slice(-6);
    if (t === "UUID")
      return C5();
  }
}
var Gnt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, qnt = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Ec;
class tl {
  constructor(e, t, n) {
    this._editor = e, this._snippet = t, this._snippetLineLeadingWhitespace = n, this._offset = -1, this._nestingLevel = 1, this._placeholderGroups = WY(t.placeholders, Fc.compareByIndex), this._placeholderGroupsIdx = -1;
  }
  initialize(e) {
    this._offset = e.newPosition;
  }
  dispose() {
    this._placeholderDecorations && this._editor.removeDecorations([...this._placeholderDecorations.values()]), this._placeholderGroups.length = 0;
  }
  _initDecorations() {
    if (this._offset === -1)
      throw new Error("Snippet not initialized!");
    if (this._placeholderDecorations)
      return;
    this._placeholderDecorations = /* @__PURE__ */ new Map();
    const e = this._editor.getModel();
    this._editor.changeDecorations((t) => {
      for (const n of this._snippet.placeholders) {
        const r = this._snippet.offset(n), s = this._snippet.fullLen(n), o = V.fromPositions(e.getPositionAt(this._offset + r), e.getPositionAt(this._offset + r + s)), a = n.isFinalTabstop ? tl._decor.inactiveFinal : tl._decor.inactive, l = t.addDecoration(o, a);
        this._placeholderDecorations.set(n, l);
      }
    });
  }
  move(e) {
    if (!this._editor.hasModel())
      return [];
    if (this._initDecorations(), this._placeholderGroupsIdx >= 0) {
      const r = [];
      for (const s of this._placeholderGroups[this._placeholderGroupsIdx])
        if (s.transform) {
          const o = this._placeholderDecorations.get(s), a = this._editor.getModel().getDecorationRange(o), l = this._editor.getModel().getValueInRange(a), c = s.transform.resolve(l).split(/\r\n|\r|\n/);
          for (let d = 1; d < c.length; d++)
            c[d] = this._editor.getModel().normalizeIndentation(this._snippetLineLeadingWhitespace + c[d]);
          r.push(Si.replace(a, c.join(this._editor.getModel().getEOL())));
        }
      r.length > 0 && this._editor.executeEdits("snippet.placeholderTransform", r);
    }
    let t = !1;
    e === !0 && this._placeholderGroupsIdx < this._placeholderGroups.length - 1 ? (this._placeholderGroupsIdx += 1, t = !0) : e === !1 && this._placeholderGroupsIdx > 0 && (this._placeholderGroupsIdx -= 1, t = !0);
    const n = this._editor.getModel().changeDecorations((r) => {
      const s = /* @__PURE__ */ new Set(), o = [];
      for (const a of this._placeholderGroups[this._placeholderGroupsIdx]) {
        const l = this._placeholderDecorations.get(a), c = this._editor.getModel().getDecorationRange(l);
        o.push(new ot(c.startLineNumber, c.startColumn, c.endLineNumber, c.endColumn)), t = t && this._hasPlaceholderBeenCollapsed(a), r.changeDecorationOptions(l, a.isFinalTabstop ? tl._decor.activeFinal : tl._decor.active), s.add(a);
        for (const d of this._snippet.enclosingPlaceholders(a)) {
          const u = this._placeholderDecorations.get(d);
          r.changeDecorationOptions(u, d.isFinalTabstop ? tl._decor.activeFinal : tl._decor.active), s.add(d);
        }
      }
      for (const [a, l] of this._placeholderDecorations)
        s.has(a) || r.changeDecorationOptions(l, a.isFinalTabstop ? tl._decor.inactiveFinal : tl._decor.inactive);
      return o;
    });
    return t ? this.move(e) : n ?? [];
  }
  _hasPlaceholderBeenCollapsed(e) {
    let t = e;
    for (; t; ) {
      if (t instanceof Fc) {
        const n = this._placeholderDecorations.get(t);
        if (this._editor.getModel().getDecorationRange(n).isEmpty() && t.toString().length > 0)
          return !0;
      }
      t = t.parent;
    }
    return !1;
  }
  get isAtFirstPlaceholder() {
    return this._placeholderGroupsIdx <= 0 || this._placeholderGroups.length === 0;
  }
  get isAtLastPlaceholder() {
    return this._placeholderGroupsIdx === this._placeholderGroups.length - 1;
  }
  get hasPlaceholder() {
    return this._snippet.placeholders.length > 0;
  }
  /**
   * A snippet is trivial when it has no placeholder or only a final placeholder at
   * its very end
   */
  get isTrivialSnippet() {
    if (this._snippet.placeholders.length === 0)
      return !0;
    if (this._snippet.placeholders.length === 1) {
      const [e] = this._snippet.placeholders;
      if (e.isFinalTabstop && this._snippet.rightMostDescendant === e)
        return !0;
    }
    return !1;
  }
  computePossibleSelections() {
    const e = /* @__PURE__ */ new Map();
    for (const t of this._placeholderGroups) {
      let n;
      for (const r of t) {
        if (r.isFinalTabstop)
          break;
        n || (n = [], e.set(r.index, n));
        const s = this._placeholderDecorations.get(r), o = this._editor.getModel().getDecorationRange(s);
        if (!o) {
          e.delete(r.index);
          break;
        }
        n.push(o);
      }
    }
    return e;
  }
  get activeChoice() {
    if (!this._placeholderDecorations)
      return;
    const e = this._placeholderGroups[this._placeholderGroupsIdx][0];
    if (!e?.choice)
      return;
    const t = this._placeholderDecorations.get(e);
    if (!t)
      return;
    const n = this._editor.getModel().getDecorationRange(t);
    if (n)
      return { range: n, choice: e.choice };
  }
  get hasChoice() {
    let e = !1;
    return this._snippet.walk((t) => (e = t instanceof Ib, !e)), e;
  }
  merge(e) {
    const t = this._editor.getModel();
    this._nestingLevel *= 10, this._editor.changeDecorations((n) => {
      for (const r of this._placeholderGroups[this._placeholderGroupsIdx]) {
        const s = e.shift();
        console.assert(s._offset !== -1), console.assert(!s._placeholderDecorations);
        const o = s._snippet.placeholderInfo.last.index;
        for (const l of s._snippet.placeholderInfo.all)
          l.isFinalTabstop ? l.index = r.index + (o + 1) / this._nestingLevel : l.index = r.index + l.index / this._nestingLevel;
        this._snippet.replace(r, s._snippet.children);
        const a = this._placeholderDecorations.get(r);
        n.removeDecoration(a), this._placeholderDecorations.delete(r);
        for (const l of s._snippet.placeholders) {
          const c = s._snippet.offset(l), d = s._snippet.fullLen(l), u = V.fromPositions(t.getPositionAt(s._offset + c), t.getPositionAt(s._offset + c + d)), h = n.addDecoration(u, tl._decor.inactive);
          this._placeholderDecorations.set(l, h);
        }
      }
      this._placeholderGroups = WY(this._snippet.placeholders, Fc.compareByIndex);
    });
  }
}
tl._decor = {
  active: Lt.register({ description: "snippet-placeholder-1", stickiness: 0, className: "snippet-placeholder" }),
  inactive: Lt.register({ description: "snippet-placeholder-2", stickiness: 1, className: "snippet-placeholder" }),
  activeFinal: Lt.register({ description: "snippet-placeholder-3", stickiness: 1, className: "finish-snippet-placeholder" }),
  inactiveFinal: Lt.register({ description: "snippet-placeholder-4", stickiness: 1, className: "finish-snippet-placeholder" })
};
const Cee = {
  overwriteBefore: 0,
  overwriteAfter: 0,
  adjustWhitespace: !0,
  clipboardText: void 0,
  overtypingCapturer: void 0
};
let NI = Ec = class {
  static adjustWhitespace(e, t, n, r, s) {
    const o = e.getLineContent(t.lineNumber), a = Hn(o, 0, t.column - 1);
    let l;
    return r.walk((c) => {
      if (!(c instanceof co) || c.parent instanceof Ib || s && !s.has(c))
        return !0;
      const d = c.value.split(/\r\n|\r|\n/);
      if (n) {
        const h = r.offset(c);
        if (h === 0)
          d[0] = e.normalizeIndentation(d[0]);
        else {
          l = l ?? r.toString();
          const f = l.charCodeAt(h - 1);
          (f === 10 || f === 13) && (d[0] = e.normalizeIndentation(a + d[0]));
        }
        for (let f = 1; f < d.length; f++)
          d[f] = e.normalizeIndentation(a + d[f]);
      }
      const u = d.join(e.getEOL());
      return u !== c.value && (c.parent.replace(c, [new co(u)]), l = void 0), !0;
    }), a;
  }
  static adjustSelection(e, t, n, r) {
    if (n !== 0 || r !== 0) {
      const { positionLineNumber: s, positionColumn: o } = t, a = o - n, l = o + r, c = e.validateRange({
        startLineNumber: s,
        startColumn: a,
        endLineNumber: s,
        endColumn: l
      });
      t = ot.createWithDirection(c.startLineNumber, c.startColumn, c.endLineNumber, c.endColumn, t.getDirection());
    }
    return t;
  }
  static createEditsAndSnippetsFromSelections(e, t, n, r, s, o, a, l, c) {
    const d = [], u = [];
    if (!e.hasModel())
      return { edits: d, snippets: u };
    const h = e.getModel(), f = e.invokeWithinContext((y) => y.get(Qm)), g = e.invokeWithinContext((y) => new mee(y.get(I_), h)), p = () => a, m = h.getValueInRange(Ec.adjustSelection(h, e.getSelection(), n, 0)), _ = h.getValueInRange(Ec.adjustSelection(h, e.getSelection(), 0, r)), b = h.getLineFirstNonWhitespaceColumn(e.getSelection().positionLineNumber), w = e.getSelections().map((y, S) => ({ selection: y, idx: S })).sort((y, S) => V.compareRangesUsingStarts(y.selection, S.selection));
    for (const { selection: y, idx: S } of w) {
      let x = Ec.adjustSelection(h, y, n, 0), D = Ec.adjustSelection(h, y, 0, r);
      m !== h.getValueInRange(x) && (x = y), _ !== h.getValueInRange(D) && (D = y);
      const E = y.setStartPosition(x.startLineNumber, x.startColumn).setEndPosition(D.endLineNumber, D.endColumn), L = new q_().parse(t, !0, s), k = E.getStartPosition(), N = Ec.adjustWhitespace(h, k, o || S > 0 && b !== h.getLineFirstNonWhitespaceColumn(y.positionLineNumber), L);
      L.resolveVariables(new gee([
        g,
        new vee(p, S, w.length, e.getOption(
          78
          /* EditorOption.multiCursorPaste */
        ) === "spread"),
        new pee(h, y, S, l),
        new TI(h, y, c),
        new qc(),
        new _ee(f),
        new bee()
      ])), d[S] = Si.replace(E, L.toString()), d[S].identifier = { major: S, minor: 0 }, d[S]._isTracked = !0, u[S] = new tl(e, L, N);
    }
    return { edits: d, snippets: u };
  }
  static createEditsAndSnippetsFromEdits(e, t, n, r, s, o, a) {
    if (!e.hasModel() || t.length === 0)
      return { edits: [], snippets: [] };
    const l = [], c = e.getModel(), d = new q_(), u = new nx(), h = new gee([
      e.invokeWithinContext((g) => new mee(g.get(I_), c)),
      new vee(() => s, 0, e.getSelections().length, e.getOption(
        78
        /* EditorOption.multiCursorPaste */
      ) === "spread"),
      new pee(c, e.getSelection(), 0, o),
      new TI(c, e.getSelection(), a),
      new qc(),
      new _ee(e.invokeWithinContext((g) => g.get(Qm))),
      new bee()
    ]);
    t = t.sort((g, p) => V.compareRangesUsingStarts(g.range, p.range));
    let f = 0;
    for (let g = 0; g < t.length; g++) {
      const { range: p, template: m } = t[g];
      if (g > 0) {
        const S = t[g - 1].range, x = V.fromPositions(S.getEndPosition(), p.getStartPosition()), D = new co(c.getValueInRange(x));
        u.appendChild(D), f += D.value.length;
      }
      const _ = d.parseFragment(m, u);
      Ec.adjustWhitespace(c, p.getStartPosition(), !0, u, new Set(_)), u.resolveVariables(h);
      const b = u.toString(), w = b.slice(f);
      f = b.length;
      const y = Si.replace(p, w);
      y.identifier = { major: g, minor: 0 }, y._isTracked = !0, l.push(y);
    }
    return d.ensureFinalTabstop(u, n, !0), {
      edits: l,
      snippets: [new tl(e, u, "")]
    };
  }
  constructor(e, t, n = Cee, r) {
    this._editor = e, this._template = t, this._options = n, this._languageConfigurationService = r, this._templateMerges = [], this._snippets = [];
  }
  dispose() {
    An(this._snippets);
  }
  _logInfo() {
    return `template="${this._template}", merged_templates="${this._templateMerges.join(" -> ")}"`;
  }
  insert() {
    if (!this._editor.hasModel())
      return;
    const { edits: e, snippets: t } = typeof this._template == "string" ? Ec.createEditsAndSnippetsFromSelections(this._editor, this._template, this._options.overwriteBefore, this._options.overwriteAfter, !1, this._options.adjustWhitespace, this._options.clipboardText, this._options.overtypingCapturer, this._languageConfigurationService) : Ec.createEditsAndSnippetsFromEdits(this._editor, this._template, !1, this._options.adjustWhitespace, this._options.clipboardText, this._options.overtypingCapturer, this._languageConfigurationService);
    this._snippets = t, this._editor.executeEdits("snippet", e, (n) => {
      const r = n.filter((s) => !!s.identifier);
      for (let s = 0; s < t.length; s++)
        t[s].initialize(r[s].textChange);
      return this._snippets[0].hasPlaceholder ? this._move(!0) : r.map((s) => ot.fromPositions(s.range.getEndPosition()));
    }), this._editor.revealRange(this._editor.getSelections()[0]);
  }
  merge(e, t = Cee) {
    if (!this._editor.hasModel())
      return;
    this._templateMerges.push([this._snippets[0]._nestingLevel, this._snippets[0]._placeholderGroupsIdx, e]);
    const { edits: n, snippets: r } = Ec.createEditsAndSnippetsFromSelections(this._editor, e, t.overwriteBefore, t.overwriteAfter, !0, t.adjustWhitespace, t.clipboardText, t.overtypingCapturer, this._languageConfigurationService);
    this._editor.executeEdits("snippet", n, (s) => {
      const o = s.filter((l) => !!l.identifier);
      for (let l = 0; l < r.length; l++)
        r[l].initialize(o[l].textChange);
      const a = r[0].isTrivialSnippet;
      if (!a) {
        for (const l of this._snippets)
          l.merge(r);
        console.assert(r.length === 0);
      }
      return this._snippets[0].hasPlaceholder && !a ? this._move(void 0) : o.map((l) => ot.fromPositions(l.range.getEndPosition()));
    });
  }
  next() {
    const e = this._move(!0);
    this._editor.setSelections(e), this._editor.revealPositionInCenterIfOutsideViewport(e[0].getPosition());
  }
  prev() {
    const e = this._move(!1);
    this._editor.setSelections(e), this._editor.revealPositionInCenterIfOutsideViewport(e[0].getPosition());
  }
  _move(e) {
    const t = [];
    for (const n of this._snippets) {
      const r = n.move(e);
      t.push(...r);
    }
    return t;
  }
  get isAtFirstPlaceholder() {
    return this._snippets[0].isAtFirstPlaceholder;
  }
  get isAtLastPlaceholder() {
    return this._snippets[0].isAtLastPlaceholder;
  }
  get hasPlaceholder() {
    return this._snippets[0].hasPlaceholder;
  }
  get hasChoice() {
    return this._snippets[0].hasChoice;
  }
  get activeChoice() {
    return this._snippets[0].activeChoice;
  }
  isSelectionWithinPlaceholders() {
    if (!this.hasPlaceholder)
      return !1;
    const e = this._editor.getSelections();
    if (e.length < this._snippets.length)
      return !1;
    const t = /* @__PURE__ */ new Map();
    for (const n of this._snippets) {
      const r = n.computePossibleSelections();
      if (t.size === 0)
        for (const [s, o] of r) {
          o.sort(V.compareRangesUsingStarts);
          for (const a of e)
            if (o[0].containsRange(a)) {
              t.set(s, []);
              break;
            }
        }
      if (t.size === 0)
        return !1;
      t.forEach((s, o) => {
        s.push(...r.get(o));
      });
    }
    e.sort(V.compareRangesUsingStarts);
    for (const [n, r] of t) {
      if (r.length !== e.length) {
        t.delete(n);
        continue;
      }
      r.sort(V.compareRangesUsingStarts);
      for (let s = 0; s < r.length; s++)
        if (!r[s].containsRange(e[s])) {
          t.delete(n);
          continue;
        }
    }
    return t.size > 0;
  }
};
NI = Ec = Gnt([
  qnt(3, Un)
], NI);
var Knt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, zD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, V1;
const yee = {
  overwriteBefore: 0,
  overwriteAfter: 0,
  undoStopBefore: !0,
  undoStopAfter: !0,
  adjustWhitespace: !0,
  clipboardText: void 0,
  overtypingCapturer: void 0
};
let us = V1 = class {
  static get(e) {
    return e.getContribution(V1.ID);
  }
  constructor(e, t, n, r, s) {
    this._editor = e, this._logService = t, this._languageFeaturesService = n, this._languageConfigurationService = s, this._snippetListener = new Ne(), this._modelVersionId = -1, this._inSnippet = V1.InSnippetMode.bindTo(r), this._hasNextTabstop = V1.HasNextTabstop.bindTo(r), this._hasPrevTabstop = V1.HasPrevTabstop.bindTo(r);
  }
  dispose() {
    var e;
    this._inSnippet.reset(), this._hasPrevTabstop.reset(), this._hasNextTabstop.reset(), (e = this._session) === null || e === void 0 || e.dispose(), this._snippetListener.dispose();
  }
  insert(e, t) {
    try {
      this._doInsert(e, typeof t > "u" ? yee : Object.assign(Object.assign({}, yee), t));
    } catch (n) {
      this.cancel(), this._logService.error(n), this._logService.error("snippet_error"), this._logService.error("insert_template=", e), this._logService.error("existing_template=", this._session ? this._session._logInfo() : "<no_session>");
    }
  }
  _doInsert(e, t) {
    var n;
    if (this._editor.hasModel()) {
      if (this._snippetListener.clear(), t.undoStopBefore && this._editor.getModel().pushStackElement(), this._session && typeof e != "string" && this.cancel(), this._session ? (On(typeof e == "string"), this._session.merge(e, t)) : (this._modelVersionId = this._editor.getModel().getAlternativeVersionId(), this._session = new NI(this._editor, e, t, this._languageConfigurationService), this._session.insert()), t.undoStopAfter && this._editor.getModel().pushStackElement(), !((n = this._session) === null || n === void 0) && n.hasChoice) {
        const r = {
          _debugDisplayName: "snippetChoiceCompletions",
          provideCompletionItems: (d, u) => {
            if (!this._session || d !== this._editor.getModel() || !ve.equals(this._editor.getPosition(), u))
              return;
            const { activeChoice: h } = this._session;
            if (!h || h.choice.options.length === 0)
              return;
            const f = d.getValueInRange(h.range), g = !!h.choice.options.find((m) => m.value === f), p = [];
            for (let m = 0; m < h.choice.options.length; m++) {
              const _ = h.choice.options[m];
              p.push({
                kind: 13,
                label: _.value,
                insertText: _.value,
                sortText: "a".repeat(m + 1),
                range: h.range,
                filterText: g ? `${f}_${_.value}` : void 0,
                command: { id: "jumpToNextSnippetPlaceholder", title: C("next", "Go to next placeholder...") }
              });
            }
            return { suggestions: p };
          }
        }, s = this._editor.getModel();
        let o, a = !1;
        const l = () => {
          o?.dispose(), a = !1;
        }, c = () => {
          a || (o = this._languageFeaturesService.completionProvider.register({
            language: s.getLanguageId(),
            pattern: s.uri.fsPath,
            scheme: s.uri.scheme,
            exclusive: !0
          }, r), this._snippetListener.add(o), a = !0);
        };
        this._choiceCompletions = { provider: r, enable: c, disable: l };
      }
      this._updateState(), this._snippetListener.add(this._editor.onDidChangeModelContent((r) => r.isFlush && this.cancel())), this._snippetListener.add(this._editor.onDidChangeModel(() => this.cancel())), this._snippetListener.add(this._editor.onDidChangeCursorSelection(() => this._updateState()));
    }
  }
  _updateState() {
    if (!(!this._session || !this._editor.hasModel())) {
      if (this._modelVersionId === this._editor.getModel().getAlternativeVersionId())
        return this.cancel();
      if (!this._session.hasPlaceholder)
        return this.cancel();
      if (this._session.isAtLastPlaceholder || !this._session.isSelectionWithinPlaceholders())
        return this._editor.getModel().pushStackElement(), this.cancel();
      this._inSnippet.set(!0), this._hasPrevTabstop.set(!this._session.isAtFirstPlaceholder), this._hasNextTabstop.set(!this._session.isAtLastPlaceholder), this._handleChoice();
    }
  }
  _handleChoice() {
    var e;
    if (!this._session || !this._editor.hasModel()) {
      this._currentChoice = void 0;
      return;
    }
    const { activeChoice: t } = this._session;
    if (!t || !this._choiceCompletions) {
      (e = this._choiceCompletions) === null || e === void 0 || e.disable(), this._currentChoice = void 0;
      return;
    }
    this._currentChoice !== t.choice && (this._currentChoice = t.choice, this._choiceCompletions.enable(), queueMicrotask(() => {
      jnt(this._editor, this._choiceCompletions.provider);
    }));
  }
  finish() {
    for (; this._inSnippet.get(); )
      this.next();
  }
  cancel(e = !1) {
    var t;
    this._inSnippet.reset(), this._hasPrevTabstop.reset(), this._hasNextTabstop.reset(), this._snippetListener.clear(), this._currentChoice = void 0, (t = this._session) === null || t === void 0 || t.dispose(), this._session = void 0, this._modelVersionId = -1, e && this._editor.setSelections([this._editor.getSelection()]);
  }
  prev() {
    var e;
    (e = this._session) === null || e === void 0 || e.prev(), this._updateState();
  }
  next() {
    var e;
    (e = this._session) === null || e === void 0 || e.next(), this._updateState();
  }
  isInSnippet() {
    return !!this._inSnippet.get();
  }
};
us.ID = "snippetController2";
us.InSnippetMode = new Ke("inSnippetMode", !1, C("inSnippetMode", "Whether the editor in current in snippet mode"));
us.HasNextTabstop = new Ke("hasNextTabstop", !1, C("hasNextTabstop", "Whether there is a next tab stop when in snippet mode"));
us.HasPrevTabstop = new Ke("hasPrevTabstop", !1, C("hasPrevTabstop", "Whether there is a previous tab stop when in snippet mode"));
us = V1 = Knt([
  zD(1, Ka),
  zD(2, tt),
  zD(3, yt),
  zD(4, Un)
], us);
pn(
  us.ID,
  us,
  4
  /* EditorContributionInstantiation.Lazy */
);
const k5 = Kr.bindToContribution(us.get);
ze(new k5({
  id: "jumpToNextSnippetPlaceholder",
  precondition: ke.and(us.InSnippetMode, us.HasNextTabstop),
  handler: (i) => i.next(),
  kbOpts: {
    weight: 130,
    kbExpr: $.editorTextFocus,
    primary: 2
    /* KeyCode.Tab */
  }
}));
ze(new k5({
  id: "jumpToPrevSnippetPlaceholder",
  precondition: ke.and(us.InSnippetMode, us.HasPrevTabstop),
  handler: (i) => i.prev(),
  kbOpts: {
    weight: 130,
    kbExpr: $.editorTextFocus,
    primary: 1026
    /* KeyCode.Tab */
  }
}));
ze(new k5({
  id: "leaveSnippet",
  precondition: us.InSnippetMode,
  handler: (i) => i.cancel(!0),
  kbOpts: {
    weight: 130,
    kbExpr: $.editorTextFocus,
    primary: 9,
    secondary: [
      1033
      /* KeyCode.Escape */
    ]
  }
}));
ze(new k5({
  id: "acceptSnippet",
  precondition: us.InSnippetMode,
  handler: (i) => i.finish()
  // kbOpts: {
  // 	weight: KeybindingWeight.EditorContrib + 30,
  // 	kbExpr: EditorContextKeys.textFocus,
  // 	primary: KeyCode.Enter,
  // }
}));
var Ynt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, BT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Xu = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, ya;
(function(i) {
  i[i.Undo = 0] = "Undo", i[i.Redo = 1] = "Redo", i[i.AcceptWord = 2] = "AcceptWord", i[i.Other = 3] = "Other";
})(ya || (ya = {}));
let xH = class extends we {
  get isAcceptingPartially() {
    return this._isAcceptingPartially;
  }
  constructor(e, t, n, r, s, o, a, l, c, d, u, h) {
    super(), this.textModel = e, this.selectedSuggestItem = t, this.cursorPosition = n, this.textModelVersionId = r, this._debounceValue = s, this._suggestPreviewEnabled = o, this._suggestPreviewMode = a, this._inlineSuggestMode = l, this._enabled = c, this._instantiationService = d, this._commandService = u, this._languageConfigurationService = h, this._source = this._register(this._instantiationService.createInstance(SH, this.textModel, this.textModelVersionId, this._debounceValue)), this._isActive = Yn(this, !1), this._forceUpdate = fme("forceUpdate"), this._selectedInlineCompletionId = Yn(this, void 0), this._isAcceptingPartially = !1, this._preserveCurrentCompletionReasons = /* @__PURE__ */ new Set([
      ya.Redo,
      ya.Undo,
      ya.AcceptWord
    ]), this._fetchInlineCompletions = Hqe({
      owner: this,
      createEmptyChangeSummary: () => ({
        preserveCurrentCompletion: !1,
        inlineCompletionTriggerKind: Fh.Automatic
      }),
      handleChange: (g, p) => (g.didChange(this.textModelVersionId) && this._preserveCurrentCompletionReasons.has(g.change) ? p.preserveCurrentCompletion = !0 : g.didChange(this._forceUpdate) && (p.inlineCompletionTriggerKind = g.change), !0)
    }, (g, p) => {
      if (this._forceUpdate.read(g), !(this._enabled.read(g) && this.selectedSuggestItem.read(g) || this._isActive.read(g))) {
        this._source.cancelUpdate();
        return;
      }
      this.textModelVersionId.read(g);
      const _ = this.selectedInlineCompletion.get(), b = p.preserveCurrentCompletion || _?.forwardStable ? _ : void 0, w = this._source.suggestWidgetInlineCompletions.get(), y = this.selectedSuggestItem.read(g);
      if (w && !y) {
        const D = this._source.inlineCompletions.get();
        di((E) => {
          D && w.request.versionId > D.request.versionId && this._source.inlineCompletions.set(w.clone(), E), this._source.clearSuggestWidgetInlineCompletions(E);
        });
      }
      const S = this.cursorPosition.read(g), x = {
        triggerKind: p.inlineCompletionTriggerKind,
        selectedSuggestionInfo: y?.toSelectedSuggestionInfo()
      };
      return this._source.fetch(S, x, b);
    }), this._filteredInlineCompletionItems = nn(this, (g) => {
      const p = this._source.inlineCompletions.read(g);
      if (!p)
        return [];
      const m = this.cursorPosition.read(g);
      return p.inlineCompletions.filter((b) => b.isVisible(this.textModel, m, g));
    }), this.selectedInlineCompletionIndex = nn(this, (g) => {
      const p = this._selectedInlineCompletionId.read(g), m = this._filteredInlineCompletionItems.read(g), _ = this._selectedInlineCompletionId === void 0 ? -1 : m.findIndex((b) => b.semanticId === p);
      return _ === -1 ? (this._selectedInlineCompletionId.set(void 0, void 0), 0) : _;
    }), this.selectedInlineCompletion = nn(this, (g) => {
      const p = this._filteredInlineCompletionItems.read(g), m = this.selectedInlineCompletionIndex.read(g);
      return p[m];
    }), this.lastTriggerKind = this._source.inlineCompletions.map((g) => g?.request.context.triggerKind), this.inlineCompletionsCount = nn(this, (g) => {
      if (this.lastTriggerKind.read(g) === Fh.Explicit)
        return this._filteredInlineCompletionItems.read(g).length;
    }), this.state = PJ({
      owner: this,
      equalityComparer: (g, p) => !g || !p ? g === p : iee(g.ghostText, p.ghostText) && g.inlineCompletion === p.inlineCompletion && g.suggestItem === p.suggestItem
    }, (g) => {
      var p;
      const m = this.textModel, _ = this.selectedSuggestItem.read(g);
      if (_) {
        const b = _.toSingleTextEdit().removeCommonPrefix(m), w = this._computeAugmentedCompletion(b, g);
        if (!this._suggestPreviewEnabled.read(g) && !w)
          return;
        const S = (p = w?.edit) !== null && p !== void 0 ? p : b, x = w ? w.edit.text.length - b.text.length : 0, D = this._suggestPreviewMode.read(g), E = this.cursorPosition.read(g), L = S.computeGhostText(m, D, E, x);
        return { ghostText: L ?? new AI(S.range.endLineNumber, []), inlineCompletion: w?.completion, suggestItem: _ };
      } else {
        if (!this._isActive.read(g))
          return;
        const b = this.selectedInlineCompletion.read(g);
        if (!b)
          return;
        const w = b.toSingleTextEdit(g), y = this._inlineSuggestMode.read(g), S = this.cursorPosition.read(g), x = w.computeGhostText(m, y, S);
        return x ? { ghostText: x, inlineCompletion: b, suggestItem: void 0 } : void 0;
      }
    }), this.ghostText = PJ({
      owner: this,
      equalityComparer: iee
    }, (g) => {
      const p = this.state.read(g);
      if (p)
        return p.ghostText;
    }), this._register(ww(this._fetchInlineCompletions));
    let f;
    this._register(zn((g) => {
      var p, m;
      const _ = this.state.read(g), b = _?.inlineCompletion;
      if (b?.semanticId !== f?.semanticId && (f = b, b)) {
        const w = b.inlineCompletion, y = w.source;
        (m = (p = y.provider).handleItemDidShow) === null || m === void 0 || m.call(p, y.inlineCompletions, w.sourceInlineCompletion, w.insertText);
      }
    }));
  }
  trigger(e) {
    return Xu(this, void 0, void 0, function* () {
      this._isActive.set(!0, e), yield this._fetchInlineCompletions.get();
    });
  }
  triggerExplicitly(e) {
    return Xu(this, void 0, void 0, function* () {
      dV(e, (t) => {
        this._isActive.set(!0, t), this._forceUpdate.trigger(t, Fh.Explicit);
      }), yield this._fetchInlineCompletions.get();
    });
  }
  stop(e) {
    dV(e, (t) => {
      this._isActive.set(!1, t), this._source.clear(t);
    });
  }
  _computeAugmentedCompletion(e, t) {
    const n = this.textModel, r = this._source.suggestWidgetInlineCompletions.read(t), s = r ? r.inlineCompletions : [this.selectedInlineCompletion.read(t)].filter(by);
    return PPe(s, (a) => {
      let l = a.toSingleTextEdit(t);
      return l = l.removeCommonPrefix(n, V.fromPositions(l.range.getStartPosition(), e.range.getEndPosition())), l.augments(e) ? { edit: l, completion: a } : void 0;
    });
  }
  _deltaSelectedInlineCompletionIndex(e) {
    return Xu(this, void 0, void 0, function* () {
      yield this.triggerExplicitly();
      const t = this._filteredInlineCompletionItems.get() || [];
      if (t.length > 0) {
        const n = (this.selectedInlineCompletionIndex.get() + e + t.length) % t.length;
        this._selectedInlineCompletionId.set(t[n].semanticId, void 0);
      } else
        this._selectedInlineCompletionId.set(void 0, void 0);
    });
  }
  next() {
    return Xu(this, void 0, void 0, function* () {
      yield this._deltaSelectedInlineCompletionIndex(1);
    });
  }
  previous() {
    return Xu(this, void 0, void 0, function* () {
      yield this._deltaSelectedInlineCompletionIndex(-1);
    });
  }
  accept(e) {
    var t;
    return Xu(this, void 0, void 0, function* () {
      if (e.getModel() !== this.textModel)
        throw new gr();
      const n = this.state.get();
      if (!n || n.ghostText.isEmpty() || !n.inlineCompletion)
        return;
      const r = n.inlineCompletion.toInlineCompletion(void 0);
      e.pushUndoStop(), r.snippetInfo ? (e.executeEdits("inlineSuggestion.accept", [
        Si.replaceMove(r.range, ""),
        ...r.additionalTextEdits
      ]), e.setPosition(r.snippetInfo.range.getStartPosition()), (t = us.get(e)) === null || t === void 0 || t.insert(r.snippetInfo.snippet, { undoStopBefore: !1 })) : e.executeEdits("inlineSuggestion.accept", [
        Si.replaceMove(r.range, r.insertText),
        ...r.additionalTextEdits
      ]), r.command && r.source.addRef(), di((s) => {
        this._source.clear(s), this._isActive.set(!1, s);
      }), r.command && (yield this._commandService.executeCommand(r.command.id, ...r.command.arguments || []).then(void 0, vr), r.source.removeRef());
    });
  }
  acceptNextWord(e) {
    return Xu(this, void 0, void 0, function* () {
      yield this._acceptNext(e, (t, n) => {
        const r = this.textModel.getLanguageIdAtPosition(t.lineNumber, t.column), s = this._languageConfigurationService.getLanguageConfiguration(r), o = new RegExp(s.wordDefinition.source, s.wordDefinition.flags.replace("g", "")), a = n.match(o);
        let l = 0;
        a && a.index !== void 0 ? a.index === 0 ? l = a[0].length : l = a.index : l = n.length;
        const d = /\s+/g.exec(n);
        return d && d.index !== void 0 && d.index + d[0].length < l && (l = d.index + d[0].length), l;
      });
    });
  }
  acceptNextLine(e) {
    return Xu(this, void 0, void 0, function* () {
      yield this._acceptNext(e, (t, n) => {
        const r = n.match(/\n/);
        return r && r.index !== void 0 ? r.index + 1 : n.length;
      });
    });
  }
  _acceptNext(e, t) {
    return Xu(this, void 0, void 0, function* () {
      if (e.getModel() !== this.textModel)
        throw new gr();
      const n = this.state.get();
      if (!n || n.ghostText.isEmpty() || !n.inlineCompletion)
        return;
      const r = n.ghostText, s = n.inlineCompletion.toInlineCompletion(void 0);
      if (s.snippetInfo || s.filterText !== s.insertText) {
        yield this.accept(e);
        return;
      }
      const o = r.parts[0], a = new ve(r.lineNumber, o.column), l = o.lines.join(`
`), c = t(a, l);
      if (c === l.length && r.parts.length === 1) {
        this.accept(e);
        return;
      }
      const d = l.substring(0, c);
      this._isAcceptingPartially = !0;
      try {
        e.pushUndoStop(), e.executeEdits("inlineSuggestion.accept", [
          Si.replace(V.fromPositions(a), d)
        ]);
        const u = bH(d);
        e.setPosition(_H(a, u));
      } finally {
        this._isAcceptingPartially = !1;
      }
      if (s.source.provider.handlePartialAccept) {
        const u = V.fromPositions(s.range.getStartPosition(), _H(a, bH(d))), h = e.getModel().getValueInRange(
          u,
          1
          /* EndOfLinePreference.LF */
        );
        s.source.provider.handlePartialAccept(s.source.inlineCompletions, s.sourceInlineCompletion, h.length);
      }
    });
  }
  handleSuggestAccepted(e) {
    var t, n;
    const r = e.toSingleTextEdit().removeCommonPrefix(this.textModel), s = this._computeAugmentedCompletion(r, void 0);
    if (!s)
      return;
    const o = s.completion.inlineCompletion;
    (n = (t = o.source.provider).handlePartialAccept) === null || n === void 0 || n.call(t, o.source.inlineCompletions, o.sourceInlineCompletion, r.text.length);
  }
};
xH = Ynt([
  BT(9, bt),
  BT(10, Ui),
  BT(11, Un)
], xH);
var Xnt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, wee = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, aC;
class AG {
  constructor(e) {
    this.name = e;
  }
  select(e, t, n) {
    if (n.length === 0)
      return 0;
    const r = n[0].score[0];
    for (let s = 0; s < n.length; s++) {
      const { score: o, completion: a } = n[s];
      if (o[0] !== r)
        break;
      if (a.preselect)
        return s;
    }
    return 0;
  }
}
class q1e extends AG {
  constructor() {
    super("first");
  }
  memorize(e, t, n) {
  }
  toJSON() {
  }
  fromJSON() {
  }
}
class Znt extends AG {
  constructor() {
    super("recentlyUsed"), this._cache = new cp(300, 0.66), this._seq = 0;
  }
  memorize(e, t, n) {
    const r = `${e.getLanguageId()}/${n.textLabel}`;
    this._cache.set(r, {
      touch: this._seq++,
      type: n.completion.kind,
      insertText: n.completion.insertText
    });
  }
  select(e, t, n) {
    if (n.length === 0)
      return 0;
    const r = e.getLineContent(t.lineNumber).substr(t.column - 10, t.column - 1);
    if (/\s$/.test(r))
      return super.select(e, t, n);
    const s = n[0].score[0];
    let o = -1, a = -1, l = -1;
    for (let c = 0; c < n.length && n[c].score[0] === s; c++) {
      const d = `${e.getLanguageId()}/${n[c].textLabel}`, u = this._cache.peek(d);
      if (u && u.touch > l && u.type === n[c].completion.kind && u.insertText === n[c].completion.insertText && (l = u.touch, a = c), n[c].completion.preselect && o === -1)
        return o = c;
    }
    return a !== -1 ? a : o !== -1 ? o : 0;
  }
  toJSON() {
    return this._cache.toJSON();
  }
  fromJSON(e) {
    this._cache.clear();
    const t = 0;
    for (const [n, r] of e)
      r.touch = t, r.type = typeof r.type == "number" ? r.type : Sy.fromString(r.type), this._cache.set(n, r);
    this._seq = this._cache.size;
  }
}
class Qnt extends AG {
  constructor() {
    super("recentlyUsedByPrefix"), this._trie = Uv.forStrings(), this._seq = 0;
  }
  memorize(e, t, n) {
    const { word: r } = e.getWordUntilPosition(t), s = `${e.getLanguageId()}/${r}`;
    this._trie.set(s, {
      type: n.completion.kind,
      insertText: n.completion.insertText,
      touch: this._seq++
    });
  }
  select(e, t, n) {
    const { word: r } = e.getWordUntilPosition(t);
    if (!r)
      return super.select(e, t, n);
    const s = `${e.getLanguageId()}/${r}`;
    let o = this._trie.get(s);
    if (o || (o = this._trie.findSubstr(s)), o)
      for (let a = 0; a < n.length; a++) {
        const { kind: l, insertText: c } = n[a].completion;
        if (l === o.type && c === o.insertText)
          return a;
      }
    return super.select(e, t, n);
  }
  toJSON() {
    const e = [];
    return this._trie.forEach((t, n) => e.push([n, t])), e.sort((t, n) => -(t[1].touch - n[1].touch)).forEach((t, n) => t[1].touch = n), e.slice(0, 200);
  }
  fromJSON(e) {
    if (this._trie.clear(), e.length > 0) {
      this._seq = e[0][1].touch + 1;
      for (const [t, n] of e)
        n.type = typeof n.type == "number" ? n.type : Sy.fromString(n.type), this._trie.set(t, n);
    }
  }
}
let Mw = aC = class {
  constructor(e, t) {
    this._storageService = e, this._configService = t, this._disposables = new Ne(), this._persistSoon = new Rn(() => this._saveState(), 500), this._disposables.add(e.onWillSaveState((n) => {
      n.reason === VL.SHUTDOWN && this._saveState();
    }));
  }
  dispose() {
    this._disposables.dispose(), this._persistSoon.dispose();
  }
  memorize(e, t, n) {
    this._withStrategy(e, t).memorize(e, t, n), this._persistSoon.schedule();
  }
  select(e, t, n) {
    return this._withStrategy(e, t).select(e, t, n);
  }
  _withStrategy(e, t) {
    var n;
    const r = this._configService.getValue("editor.suggestSelection", {
      overrideIdentifier: e.getLanguageIdAtPosition(t.lineNumber, t.column),
      resource: e.uri
    });
    if (((n = this._strategy) === null || n === void 0 ? void 0 : n.name) !== r) {
      this._saveState();
      const s = aC._strategyCtors.get(r) || q1e;
      this._strategy = new s();
      try {
        const a = this._configService.getValue("editor.suggest.shareSuggestSelections") ? 0 : 1, l = this._storageService.get(`${aC._storagePrefix}/${r}`, a);
        l && this._strategy.fromJSON(JSON.parse(l));
      } catch {
      }
    }
    return this._strategy;
  }
  _saveState() {
    if (this._strategy) {
      const t = this._configService.getValue("editor.suggest.shareSuggestSelections") ? 0 : 1, n = JSON.stringify(this._strategy);
      this._storageService.store(
        `${aC._storagePrefix}/${this._strategy.name}`,
        n,
        t,
        1
        /* StorageTarget.MACHINE */
      );
    }
  }
};
Mw._strategyCtors = /* @__PURE__ */ new Map([
  ["recentlyUsedByPrefix", Qnt],
  ["recentlyUsed", Znt],
  ["first", q1e]
]);
Mw._storagePrefix = "suggest/memories";
Mw = aC = Xnt([
  wee(0, mc),
  wee(1, en)
], Mw);
const T5 = Gt("ISuggestMemories");
an(
  T5,
  Mw,
  1
  /* InstantiationType.Delayed */
);
var Jnt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, $nt = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, DH;
let Rw = DH = class {
  constructor(e, t) {
    this._editor = e, this._enabled = !1, this._ckAtEnd = DH.AtEnd.bindTo(t), this._configListener = this._editor.onDidChangeConfiguration((n) => n.hasChanged(
      122
      /* EditorOption.tabCompletion */
    ) && this._update()), this._update();
  }
  dispose() {
    var e;
    this._configListener.dispose(), (e = this._selectionListener) === null || e === void 0 || e.dispose(), this._ckAtEnd.reset();
  }
  _update() {
    const e = this._editor.getOption(
      122
      /* EditorOption.tabCompletion */
    ) === "on";
    if (this._enabled !== e)
      if (this._enabled = e, this._enabled) {
        const t = () => {
          if (!this._editor.hasModel()) {
            this._ckAtEnd.set(!1);
            return;
          }
          const n = this._editor.getModel(), r = this._editor.getSelection(), s = n.getWordAtPosition(r.getStartPosition());
          if (!s) {
            this._ckAtEnd.set(!1);
            return;
          }
          this._ckAtEnd.set(s.endColumn === r.getStartPosition().column);
        };
        this._selectionListener = this._editor.onDidChangeCursorSelection(t), t();
      } else this._selectionListener && (this._ckAtEnd.reset(), this._selectionListener.dispose(), this._selectionListener = void 0);
  }
};
Rw.AtEnd = new Ke("atEndOfWord", !1);
Rw = DH = Jnt([
  $nt(1, yt)
], Rw);
var eit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, tit = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, lC;
let g0 = lC = class {
  constructor(e, t) {
    this._editor = e, this._index = 0, this._ckOtherSuggestions = lC.OtherSuggestions.bindTo(t);
  }
  dispose() {
    this.reset();
  }
  reset() {
    var e;
    this._ckOtherSuggestions.reset(), (e = this._listener) === null || e === void 0 || e.dispose(), this._model = void 0, this._acceptNext = void 0, this._ignore = !1;
  }
  set({ model: e, index: t }, n) {
    if (e.items.length === 0) {
      this.reset();
      return;
    }
    if (lC._moveIndex(!0, e, t) === t) {
      this.reset();
      return;
    }
    this._acceptNext = n, this._model = e, this._index = t, this._listener = this._editor.onDidChangeCursorPosition(() => {
      this._ignore || this.reset();
    }), this._ckOtherSuggestions.set(!0);
  }
  static _moveIndex(e, t, n) {
    let r = n;
    for (let s = t.items.length; s > 0 && (r = (r + t.items.length + (e ? 1 : -1)) % t.items.length, !(r === n || !t.items[r].completion.additionalTextEdits)); s--)
      ;
    return r;
  }
  next() {
    this._move(!0);
  }
  prev() {
    this._move(!1);
  }
  _move(e) {
    if (this._model)
      try {
        this._ignore = !0, this._index = lC._moveIndex(e, this._model, this._index), this._acceptNext({ index: this._index, item: this._model.items[this._index], model: this._model });
      } finally {
        this._ignore = !1;
      }
  }
};
g0.OtherSuggestions = new Ke("hasOtherSuggestions", !1);
g0 = lC = eit([
  tit(1, yt)
], g0);
class nit {
  constructor(e, t, n, r) {
    this._disposables = new Ne(), this._disposables.add(n.onDidSuggest((s) => {
      s.completionModel.items.length === 0 && this.reset();
    })), this._disposables.add(n.onDidCancel((s) => {
      this.reset();
    })), this._disposables.add(t.onDidShow(() => this._onItem(t.getFocusedItem()))), this._disposables.add(t.onDidFocus(this._onItem, this)), this._disposables.add(t.onDidHide(this.reset, this)), this._disposables.add(e.onWillType((s) => {
      if (this._active && !t.isFrozen() && n.state !== 0) {
        const o = s.charCodeAt(s.length - 1);
        this._active.acceptCharacters.has(o) && e.getOption(
          0
          /* EditorOption.acceptSuggestionOnCommitCharacter */
        ) && r(this._active.item);
      }
    }));
  }
  _onItem(e) {
    if (!e || !Bs(e.item.completion.commitCharacters)) {
      this.reset();
      return;
    }
    if (this._active && this._active.item.item === e.item)
      return;
    const t = new iL();
    for (const n of e.item.completion.commitCharacters)
      n.length > 0 && t.add(n.charCodeAt(0));
    this._active = { acceptCharacters: t, item: e };
  }
  reset() {
    this._active = void 0;
  }
  dispose() {
    this._disposables.dispose();
  }
}
var iit = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class wa {
  provideSelectionRanges(e, t) {
    return iit(this, void 0, void 0, function* () {
      const n = [];
      for (const r of t) {
        const s = [];
        n.push(s);
        const o = /* @__PURE__ */ new Map();
        yield new Promise((a) => wa._bracketsRightYield(a, 0, e, r, o)), yield new Promise((a) => wa._bracketsLeftYield(a, 0, e, r, o, s));
      }
      return n;
    });
  }
  static _bracketsRightYield(e, t, n, r, s) {
    const o = /* @__PURE__ */ new Map(), a = Date.now();
    for (; ; ) {
      if (t >= wa._maxRounds) {
        e();
        break;
      }
      if (!r) {
        e();
        break;
      }
      const l = n.bracketPairs.findNextBracket(r);
      if (!l) {
        e();
        break;
      }
      if (Date.now() - a > wa._maxDuration) {
        setTimeout(() => wa._bracketsRightYield(e, t + 1, n, r, s));
        break;
      }
      if (l.bracketInfo.isOpeningBracket) {
        const d = l.bracketInfo.bracketText, u = o.has(d) ? o.get(d) : 0;
        o.set(d, u + 1);
      } else {
        const d = l.bracketInfo.getOpeningBrackets()[0].bracketText;
        let u = o.has(d) ? o.get(d) : 0;
        if (u -= 1, o.set(d, Math.max(0, u)), u < 0) {
          let h = s.get(d);
          h || (h = new fo(), s.set(d, h)), h.push(l.range);
        }
      }
      r = l.range.getEndPosition();
    }
  }
  static _bracketsLeftYield(e, t, n, r, s, o) {
    const a = /* @__PURE__ */ new Map(), l = Date.now();
    for (; ; ) {
      if (t >= wa._maxRounds && s.size === 0) {
        e();
        break;
      }
      if (!r) {
        e();
        break;
      }
      const c = n.bracketPairs.findPrevBracket(r);
      if (!c) {
        e();
        break;
      }
      if (Date.now() - l > wa._maxDuration) {
        setTimeout(() => wa._bracketsLeftYield(e, t + 1, n, r, s, o));
        break;
      }
      if (c.bracketInfo.isOpeningBracket) {
        const u = c.bracketInfo.bracketText;
        let h = a.has(u) ? a.get(u) : 0;
        if (h -= 1, a.set(u, Math.max(0, h)), h < 0) {
          const f = s.get(u);
          if (f) {
            const g = f.shift();
            f.size === 0 && s.delete(u);
            const p = V.fromPositions(c.range.getEndPosition(), g.getStartPosition()), m = V.fromPositions(c.range.getStartPosition(), g.getEndPosition());
            o.push({ range: p }), o.push({ range: m }), wa._addBracketLeading(n, m, o);
          }
        }
      } else {
        const u = c.bracketInfo.getOpeningBrackets()[0].bracketText, h = a.has(u) ? a.get(u) : 0;
        a.set(u, h + 1);
      }
      r = c.range.getStartPosition();
    }
  }
  static _addBracketLeading(e, t, n) {
    if (t.startLineNumber === t.endLineNumber)
      return;
    const r = t.startLineNumber, s = e.getLineFirstNonWhitespaceColumn(r);
    s !== 0 && s !== t.startColumn && (n.push({ range: V.fromPositions(new ve(r, s), t.getEndPosition()) }), n.push({ range: V.fromPositions(new ve(r, 1), t.getEndPosition()) }));
    const o = r - 1;
    if (o > 0) {
      const a = e.getLineFirstNonWhitespaceColumn(o);
      a === t.startColumn && a !== e.getLineLastNonWhitespaceColumn(o) && (n.push({ range: V.fromPositions(new ve(o, a), t.getEndPosition()) }), n.push({ range: V.fromPositions(new ve(o, 1), t.getEndPosition()) }));
    }
  }
}
wa._maxDuration = 30;
wa._maxRounds = 2;
var rit = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class Bc {
  static create(e, t) {
    return rit(this, void 0, void 0, function* () {
      if (!t.getOption(
        117
        /* EditorOption.suggest */
      ).localityBonus || !t.hasModel())
        return Bc.None;
      const n = t.getModel(), r = t.getPosition();
      if (!e.canComputeWordRanges(n.uri))
        return Bc.None;
      const [s] = yield new wa().provideSelectionRanges(n, [r]);
      if (s.length === 0)
        return Bc.None;
      const o = yield e.computeWordRanges(n.uri, s[0].range);
      if (!o)
        return Bc.None;
      const a = n.getWordUntilPosition(r);
      return delete o[a.word], new class extends Bc {
        distance(l, c) {
          if (!r.equals(t.getPosition()))
            return 0;
          if (c.kind === 17)
            return 2 << 20;
          const d = typeof c.label == "string" ? c.label : c.label.label, u = o[d];
          if (Tue(u))
            return 2 << 20;
          const h = vy(u, V.fromPositions(l), V.compareRangesUsingStarts), f = h >= 0 ? u[h] : u[Math.max(0, ~h - 1)];
          let g = s.length;
          for (const p of s) {
            if (!V.containsRange(p.range, f))
              break;
            g -= 1;
          }
          return g;
        }
      }();
    });
  }
}
Bc.None = new class extends Bc {
  distance() {
    return 0;
  }
}();
let See = class {
  constructor(e, t) {
    this.leadingLineContent = e, this.characterCountDelta = t;
  }
};
class jf {
  constructor(e, t, n, r, s, o, a = O4.default, l = void 0) {
    this.clipboardText = l, this._snippetCompareFn = jf._compareCompletionItems, this._items = e, this._column = t, this._wordDistance = r, this._options = s, this._refilterKind = 1, this._lineContext = n, this._fuzzyScoreOptions = a, o === "top" ? this._snippetCompareFn = jf._compareCompletionItemsSnippetsUp : o === "bottom" && (this._snippetCompareFn = jf._compareCompletionItemsSnippetsDown);
  }
  get lineContext() {
    return this._lineContext;
  }
  set lineContext(e) {
    (this._lineContext.leadingLineContent !== e.leadingLineContent || this._lineContext.characterCountDelta !== e.characterCountDelta) && (this._refilterKind = this._lineContext.characterCountDelta < e.characterCountDelta && this._filteredItems ? 2 : 1, this._lineContext = e);
  }
  get items() {
    return this._ensureCachedState(), this._filteredItems;
  }
  getItemsByProvider() {
    return this._ensureCachedState(), this._itemsByProvider;
  }
  getIncompleteProvider() {
    this._ensureCachedState();
    const e = /* @__PURE__ */ new Set();
    for (const [t, n] of this.getItemsByProvider())
      n.length > 0 && n[0].container.incomplete && e.add(t);
    return e;
  }
  get stats() {
    return this._ensureCachedState(), this._stats;
  }
  _ensureCachedState() {
    this._refilterKind !== 0 && this._createCachedState();
  }
  _createCachedState() {
    this._itemsByProvider = /* @__PURE__ */ new Map();
    const e = [], { leadingLineContent: t, characterCountDelta: n } = this._lineContext;
    let r = "", s = "";
    const o = this._refilterKind === 1 ? this._items : this._filteredItems, a = [], l = !this._options.filterGraceful || o.length > 2e3 ? Jm : Aje;
    for (let c = 0; c < o.length; c++) {
      const d = o[c];
      if (d.isInvalid)
        continue;
      const u = this._itemsByProvider.get(d.provider);
      u ? u.push(d) : this._itemsByProvider.set(d.provider, [d]);
      const h = d.position.column - d.editStart.column, f = h + n - (d.position.column - this._column);
      if (r.length !== f && (r = f === 0 ? "" : t.slice(-f), s = r.toLowerCase()), d.word = r, f === 0)
        d.score = td.Default;
      else {
        let g = 0;
        for (; g < h; ) {
          const p = r.charCodeAt(g);
          if (p === 32 || p === 9)
            g += 1;
          else
            break;
        }
        if (g >= f)
          d.score = td.Default;
        else if (typeof d.completion.filterText == "string") {
          const p = l(r, s, g, d.completion.filterText, d.filterTextLow, 0, this._fuzzyScoreOptions);
          if (!p)
            continue;
          $R(d.completion.filterText, d.textLabel) === 0 ? d.score = p : (d.score = Dje(r, s, g, d.textLabel, d.labelLow, 0), d.score[0] = p[0]);
        } else {
          const p = l(r, s, g, d.textLabel, d.labelLow, 0, this._fuzzyScoreOptions);
          if (!p)
            continue;
          d.score = p;
        }
      }
      d.idx = c, d.distance = this._wordDistance.distance(d.position, d.completion), a.push(d), e.push(d.textLabel.length);
    }
    this._filteredItems = a.sort(this._snippetCompareFn), this._refilterKind = 0, this._stats = {
      pLabelLen: e.length ? iR(e.length - 0.85, e, (c, d) => c - d) : 0
    };
  }
  static _compareCompletionItems(e, t) {
    return e.score[0] > t.score[0] ? -1 : e.score[0] < t.score[0] ? 1 : e.distance < t.distance ? -1 : e.distance > t.distance ? 1 : e.idx < t.idx ? -1 : e.idx > t.idx ? 1 : 0;
  }
  static _compareCompletionItemsSnippetsDown(e, t) {
    if (e.completion.kind !== t.completion.kind) {
      if (e.completion.kind === 27)
        return 1;
      if (t.completion.kind === 27)
        return -1;
    }
    return jf._compareCompletionItems(e, t);
  }
  static _compareCompletionItemsSnippetsUp(e, t) {
    if (e.completion.kind !== t.completion.kind) {
      if (e.completion.kind === 27)
        return -1;
      if (t.completion.kind === 27)
        return 1;
    }
    return jf._compareCompletionItems(e, t);
  }
}
var sit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, wf = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, oit = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, EH;
class Ap {
  static shouldAutoTrigger(e) {
    if (!e.hasModel())
      return !1;
    const t = e.getModel(), n = e.getPosition();
    t.tokenization.tokenizeIfCheap(n.lineNumber);
    const r = t.getWordAtPosition(n);
    return !(!r || r.endColumn !== n.column && r.startColumn + 1 !== n.column || !isNaN(Number(r.word)));
  }
  constructor(e, t, n) {
    this.leadingLineContent = e.getLineContent(t.lineNumber).substr(0, t.column - 1), this.leadingWord = e.getWordUntilPosition(t), this.lineNumber = t.lineNumber, this.column = t.column, this.triggerOptions = n;
  }
}
function ait(i, e, t) {
  if (!e.getContextKeyValue(Ur.inlineSuggestionVisible.key))
    return !0;
  const n = e.getContextKeyValue(Ur.suppressSuggestions.key);
  return n !== void 0 ? !n : !i.getOption(
    62
    /* EditorOption.inlineSuggest */
  ).suppressSuggestions;
}
function lit(i, e, t) {
  if (!e.getContextKeyValue("inlineSuggestionVisible"))
    return !0;
  const n = e.getContextKeyValue(Ur.suppressSuggestions.key);
  return n !== void 0 ? !n : !i.getOption(
    62
    /* EditorOption.inlineSuggest */
  ).suppressSuggestions;
}
let LH = EH = class {
  constructor(e, t, n, r, s, o, a, l, c) {
    this._editor = e, this._editorWorkerService = t, this._clipboardService = n, this._telemetryService = r, this._logService = s, this._contextKeyService = o, this._configurationService = a, this._languageFeaturesService = l, this._envService = c, this._toDispose = new Ne(), this._triggerCharacterListener = new Ne(), this._triggerQuickSuggest = new uc(), this._triggerState = void 0, this._completionDisposables = new Ne(), this._onDidCancel = new pe(), this._onDidTrigger = new pe(), this._onDidSuggest = new pe(), this.onDidCancel = this._onDidCancel.event, this.onDidTrigger = this._onDidTrigger.event, this.onDidSuggest = this._onDidSuggest.event, this._telemetryGate = 0, this._currentSelection = this._editor.getSelection() || new ot(1, 1, 1, 1), this._toDispose.add(this._editor.onDidChangeModel(() => {
      this._updateTriggerCharacters(), this.cancel();
    })), this._toDispose.add(this._editor.onDidChangeModelLanguage(() => {
      this._updateTriggerCharacters(), this.cancel();
    })), this._toDispose.add(this._editor.onDidChangeConfiguration(() => {
      this._updateTriggerCharacters();
    })), this._toDispose.add(this._languageFeaturesService.completionProvider.onDidChange(() => {
      this._updateTriggerCharacters(), this._updateActiveSuggestSession();
    }));
    let d = !1;
    this._toDispose.add(this._editor.onDidCompositionStart(() => {
      d = !0;
    })), this._toDispose.add(this._editor.onDidCompositionEnd(() => {
      d = !1, this._onCompositionEnd();
    })), this._toDispose.add(this._editor.onDidChangeCursorSelection((u) => {
      d || this._onCursorChange(u);
    })), this._toDispose.add(this._editor.onDidChangeModelContent(() => {
      !d && this._triggerState !== void 0 && this._refilterCompletionItems();
    })), this._updateTriggerCharacters();
  }
  dispose() {
    An(this._triggerCharacterListener), An([this._onDidCancel, this._onDidSuggest, this._onDidTrigger, this._triggerQuickSuggest]), this._toDispose.dispose(), this._completionDisposables.dispose(), this.cancel();
  }
  _updateTriggerCharacters() {
    if (this._triggerCharacterListener.clear(), this._editor.getOption(
      90
      /* EditorOption.readOnly */
    ) || !this._editor.hasModel() || !this._editor.getOption(
      120
      /* EditorOption.suggestOnTriggerCharacters */
    ))
      return;
    const e = /* @__PURE__ */ new Map();
    for (const n of this._languageFeaturesService.completionProvider.all(this._editor.getModel()))
      for (const r of n.triggerCharacters || []) {
        let s = e.get(r);
        s || (s = /* @__PURE__ */ new Set(), s.add(Fnt()), e.set(r, s)), s.add(n);
      }
    const t = (n) => {
      var r;
      if (!lit(this._editor, this._contextKeyService, this._configurationService) || Ap.shouldAutoTrigger(this._editor))
        return;
      if (!n) {
        const a = this._editor.getPosition();
        n = this._editor.getModel().getLineContent(a.lineNumber).substr(0, a.column - 1);
      }
      let s = "";
      Gm(n.charCodeAt(n.length - 1)) ? kr(n.charCodeAt(n.length - 2)) && (s = n.substr(n.length - 2)) : s = n.charAt(n.length - 1);
      const o = e.get(s);
      if (o) {
        const a = /* @__PURE__ */ new Map();
        if (this._completionModel)
          for (const [l, c] of this._completionModel.getItemsByProvider())
            o.has(l) || a.set(l, c);
        this.trigger({
          auto: !0,
          triggerKind: 1,
          triggerCharacter: s,
          retrigger: !!this._completionModel,
          clipboardText: (r = this._completionModel) === null || r === void 0 ? void 0 : r.clipboardText,
          completionOptions: { providerFilter: o, providerItemsToReuse: a }
        });
      }
    };
    this._triggerCharacterListener.add(this._editor.onDidType(t)), this._triggerCharacterListener.add(this._editor.onDidCompositionEnd(() => t()));
  }
  // --- trigger/retrigger/cancel suggest
  get state() {
    return this._triggerState ? this._triggerState.auto ? 2 : 1 : 0;
  }
  cancel(e = !1) {
    var t;
    this._triggerState !== void 0 && (this._triggerQuickSuggest.cancel(), (t = this._requestToken) === null || t === void 0 || t.cancel(), this._requestToken = void 0, this._triggerState = void 0, this._completionModel = void 0, this._context = void 0, this._onDidCancel.fire({ retrigger: e }));
  }
  clear() {
    this._completionDisposables.clear();
  }
  _updateActiveSuggestSession() {
    this._triggerState !== void 0 && (!this._editor.hasModel() || !this._languageFeaturesService.completionProvider.has(this._editor.getModel()) ? this.cancel() : this.trigger({ auto: this._triggerState.auto, retrigger: !0 }));
  }
  _onCursorChange(e) {
    if (!this._editor.hasModel())
      return;
    const t = this._currentSelection;
    if (this._currentSelection = this._editor.getSelection(), !e.selection.isEmpty() || e.reason !== 0 && e.reason !== 3 || e.source !== "keyboard" && e.source !== "deleteLeft") {
      this.cancel();
      return;
    }
    this._triggerState === void 0 && e.reason === 0 ? (t.containsRange(this._currentSelection) || t.getEndPosition().isBeforeOrEqual(this._currentSelection.getPosition())) && this._doTriggerQuickSuggest() : this._triggerState !== void 0 && e.reason === 3 && this._refilterCompletionItems();
  }
  _onCompositionEnd() {
    this._triggerState === void 0 ? this._doTriggerQuickSuggest() : this._refilterCompletionItems();
  }
  _doTriggerQuickSuggest() {
    var e;
    mv.isAllOff(this._editor.getOption(
      88
      /* EditorOption.quickSuggestions */
    )) || this._editor.getOption(
      117
      /* EditorOption.suggest */
    ).snippetsPreventQuickSuggestions && (!((e = us.get(this._editor)) === null || e === void 0) && e.isInSnippet()) || (this.cancel(), this._triggerQuickSuggest.cancelAndSet(() => {
      if (this._triggerState !== void 0 || !Ap.shouldAutoTrigger(this._editor) || !this._editor.hasModel() || !this._editor.hasWidgetFocus())
        return;
      const t = this._editor.getModel(), n = this._editor.getPosition(), r = this._editor.getOption(
        88
        /* EditorOption.quickSuggestions */
      );
      if (!mv.isAllOff(r)) {
        if (!mv.isAllOn(r)) {
          t.tokenization.tokenizeIfCheap(n.lineNumber);
          const s = t.tokenization.getLineTokens(n.lineNumber), o = s.getStandardTokenType(s.findTokenIndexAtOffset(Math.max(n.column - 1 - 1, 0)));
          if (mv.valueFor(r, o) !== "on")
            return;
        }
        ait(this._editor, this._contextKeyService, this._configurationService) && this._languageFeaturesService.completionProvider.has(t) && this.trigger({ auto: !0 });
      }
    }, this._editor.getOption(
      89
      /* EditorOption.quickSuggestionsDelay */
    )));
  }
  _refilterCompletionItems() {
    On(this._editor.hasModel()), On(this._triggerState !== void 0);
    const e = this._editor.getModel(), t = this._editor.getPosition(), n = new Ap(e, t, Object.assign(Object.assign({}, this._triggerState), { refilter: !0 }));
    this._onNewContext(n);
  }
  trigger(e) {
    var t, n, r, s, o, a;
    if (!this._editor.hasModel())
      return;
    const l = this._editor.getModel(), c = new Ap(l, this._editor.getPosition(), e);
    this.cancel(e.retrigger), this._triggerState = e, this._onDidTrigger.fire({ auto: e.auto, shy: (t = e.shy) !== null && t !== void 0 ? t : !1, position: this._editor.getPosition() }), this._context = c;
    let d = {
      triggerKind: (n = e.triggerKind) !== null && n !== void 0 ? n : 0
      /* CompletionTriggerKind.Invoke */
    };
    e.triggerCharacter && (d = {
      triggerKind: 1,
      triggerCharacter: e.triggerCharacter
    }), this._requestToken = new lr();
    const u = this._editor.getOption(
      111
      /* EditorOption.snippetSuggestions */
    );
    let h = 1;
    switch (u) {
      case "top":
        h = 0;
        break;
      case "bottom":
        h = 2;
        break;
    }
    const { itemKind: f, showDeprecated: g } = EH._createSuggestFilter(this._editor), p = new Ow(h, (s = (r = e.completionOptions) === null || r === void 0 ? void 0 : r.kindFilter) !== null && s !== void 0 ? s : f, (o = e.completionOptions) === null || o === void 0 ? void 0 : o.providerFilter, (a = e.completionOptions) === null || a === void 0 ? void 0 : a.providerItemsToReuse, g), m = Bc.create(this._editorWorkerService, this._editor), _ = LG(this._languageFeaturesService.completionProvider, l, this._editor.getPosition(), p, d, this._requestToken.token);
    Promise.all([_, m]).then(([b, w]) => oit(this, void 0, void 0, function* () {
      var y;
      if ((y = this._requestToken) === null || y === void 0 || y.dispose(), !this._editor.hasModel())
        return;
      let S = e?.clipboardText;
      if (!S && b.needsClipboard && (S = yield this._clipboardService.readText()), this._triggerState === void 0)
        return;
      const x = this._editor.getModel(), D = new Ap(x, this._editor.getPosition(), e), E = Object.assign(Object.assign({}, O4.default), { firstMatchCanBeWeak: !this._editor.getOption(
        117
        /* EditorOption.suggest */
      ).matchOnWordStartOnly });
      if (this._completionModel = new jf(b.items, this._context.column, {
        leadingLineContent: D.leadingLineContent,
        characterCountDelta: D.column - this._context.column
      }, w, this._editor.getOption(
        117
        /* EditorOption.suggest */
      ), this._editor.getOption(
        111
        /* EditorOption.snippetSuggestions */
      ), E, S), this._completionDisposables.add(b.disposable), this._onNewContext(D), this._reportDurationsTelemetry(b.durations), !this._envService.isBuilt || this._envService.isExtensionDevelopment)
        for (const L of b.items)
          L.isInvalid && this._logService.warn(`[suggest] did IGNORE invalid completion item from ${L.provider._debugDisplayName}`, L.completion);
    })).catch(It);
  }
  _reportDurationsTelemetry(e) {
    this._telemetryGate++ % 230 === 0 && setTimeout(() => {
      this._telemetryService.publicLog2("suggest.durations.json", { data: JSON.stringify(e) }), this._logService.debug("suggest.durations.json", e);
    });
  }
  static _createSuggestFilter(e) {
    const t = /* @__PURE__ */ new Set();
    e.getOption(
      111
      /* EditorOption.snippetSuggestions */
    ) === "none" && t.add(
      27
      /* CompletionItemKind.Snippet */
    );
    const r = e.getOption(
      117
      /* EditorOption.suggest */
    );
    return r.showMethods || t.add(
      0
      /* CompletionItemKind.Method */
    ), r.showFunctions || t.add(
      1
      /* CompletionItemKind.Function */
    ), r.showConstructors || t.add(
      2
      /* CompletionItemKind.Constructor */
    ), r.showFields || t.add(
      3
      /* CompletionItemKind.Field */
    ), r.showVariables || t.add(
      4
      /* CompletionItemKind.Variable */
    ), r.showClasses || t.add(
      5
      /* CompletionItemKind.Class */
    ), r.showStructs || t.add(
      6
      /* CompletionItemKind.Struct */
    ), r.showInterfaces || t.add(
      7
      /* CompletionItemKind.Interface */
    ), r.showModules || t.add(
      8
      /* CompletionItemKind.Module */
    ), r.showProperties || t.add(
      9
      /* CompletionItemKind.Property */
    ), r.showEvents || t.add(
      10
      /* CompletionItemKind.Event */
    ), r.showOperators || t.add(
      11
      /* CompletionItemKind.Operator */
    ), r.showUnits || t.add(
      12
      /* CompletionItemKind.Unit */
    ), r.showValues || t.add(
      13
      /* CompletionItemKind.Value */
    ), r.showConstants || t.add(
      14
      /* CompletionItemKind.Constant */
    ), r.showEnums || t.add(
      15
      /* CompletionItemKind.Enum */
    ), r.showEnumMembers || t.add(
      16
      /* CompletionItemKind.EnumMember */
    ), r.showKeywords || t.add(
      17
      /* CompletionItemKind.Keyword */
    ), r.showWords || t.add(
      18
      /* CompletionItemKind.Text */
    ), r.showColors || t.add(
      19
      /* CompletionItemKind.Color */
    ), r.showFiles || t.add(
      20
      /* CompletionItemKind.File */
    ), r.showReferences || t.add(
      21
      /* CompletionItemKind.Reference */
    ), r.showColors || t.add(
      22
      /* CompletionItemKind.Customcolor */
    ), r.showFolders || t.add(
      23
      /* CompletionItemKind.Folder */
    ), r.showTypeParameters || t.add(
      24
      /* CompletionItemKind.TypeParameter */
    ), r.showSnippets || t.add(
      27
      /* CompletionItemKind.Snippet */
    ), r.showUsers || t.add(
      25
      /* CompletionItemKind.User */
    ), r.showIssues || t.add(
      26
      /* CompletionItemKind.Issue */
    ), { itemKind: t, showDeprecated: r.showDeprecated };
  }
  _onNewContext(e) {
    if (this._context) {
      if (e.lineNumber !== this._context.lineNumber) {
        this.cancel();
        return;
      }
      if (Hn(e.leadingLineContent) !== Hn(this._context.leadingLineContent)) {
        this.cancel();
        return;
      }
      if (e.column < this._context.column) {
        e.leadingWord.word ? this.trigger({ auto: this._context.triggerOptions.auto, retrigger: !0 }) : this.cancel();
        return;
      }
      if (this._completionModel) {
        if (e.leadingWord.word.length !== 0 && e.leadingWord.startColumn > this._context.leadingWord.startColumn) {
          if (Ap.shouldAutoTrigger(this._editor) && this._context) {
            const n = this._completionModel.getItemsByProvider();
            this.trigger({
              auto: this._context.triggerOptions.auto,
              retrigger: !0,
              clipboardText: this._completionModel.clipboardText,
              completionOptions: { providerItemsToReuse: n }
            });
          }
          return;
        }
        if (e.column > this._context.column && this._completionModel.getIncompleteProvider().size > 0 && e.leadingWord.word.length !== 0) {
          const t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set();
          for (const [r, s] of this._completionModel.getItemsByProvider())
            s.length > 0 && s[0].container.incomplete ? n.add(r) : t.set(r, s);
          this.trigger({
            auto: this._context.triggerOptions.auto,
            triggerKind: 2,
            retrigger: !0,
            clipboardText: this._completionModel.clipboardText,
            completionOptions: { providerFilter: n, providerItemsToReuse: t }
          });
        } else {
          const t = this._completionModel.lineContext;
          let n = !1;
          if (this._completionModel.lineContext = {
            leadingLineContent: e.leadingLineContent,
            characterCountDelta: e.column - this._context.column
          }, this._completionModel.items.length === 0) {
            const r = Ap.shouldAutoTrigger(this._editor);
            if (!this._context) {
              this.cancel();
              return;
            }
            if (r && this._context.leadingWord.endColumn < e.leadingWord.startColumn) {
              this.trigger({ auto: this._context.triggerOptions.auto, retrigger: !0 });
              return;
            }
            if (this._context.triggerOptions.auto) {
              this.cancel();
              return;
            } else if (this._completionModel.lineContext = t, n = this._completionModel.items.length > 0, n && e.leadingWord.word.length === 0) {
              this.cancel();
              return;
            }
          }
          this._onDidSuggest.fire({
            completionModel: this._completionModel,
            triggerOptions: e.triggerOptions,
            isFrozen: n
          });
        }
      }
    }
  }
};
LH = EH = sit([
  wf(1, vc),
  wf(2, hf),
  wf(3, qa),
  wf(4, Ka),
  wf(5, yt),
  wf(6, en),
  wf(7, tt),
  wf(8, qz)
], LH);
class N5 {
  constructor(e, t) {
    this._disposables = new Ne(), this._lastOvertyped = [], this._locked = !1, this._disposables.add(e.onWillType(() => {
      if (this._locked || !e.hasModel())
        return;
      const n = e.getSelections(), r = n.length;
      let s = !1;
      for (let a = 0; a < r; a++)
        if (!n[a].isEmpty()) {
          s = !0;
          break;
        }
      if (!s) {
        this._lastOvertyped.length !== 0 && (this._lastOvertyped.length = 0);
        return;
      }
      this._lastOvertyped = [];
      const o = e.getModel();
      for (let a = 0; a < r; a++) {
        const l = n[a];
        if (o.getValueLengthInRange(l) > N5._maxSelectionLength)
          return;
        this._lastOvertyped[a] = { value: o.getValueInRange(l), multiline: l.startLineNumber !== l.endLineNumber };
      }
    })), this._disposables.add(t.onDidTrigger((n) => {
      this._locked = !0;
    })), this._disposables.add(t.onDidCancel((n) => {
      this._locked = !1;
    }));
  }
  getLastOvertypedInfo(e) {
    if (e >= 0 && e < this._lastOvertyped.length)
      return this._lastOvertyped[e];
  }
  dispose() {
    this._disposables.dispose();
  }
}
N5._maxSelectionLength = 51200;
var cit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, VT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class kG extends $m {
  updateLabel() {
    const e = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
    if (!e)
      return super.updateLabel();
    this.label && (this.label.textContent = C({ key: "content", comment: ["A label", "A keybinding"] }, "{0} ({1})", this._action.label, kG.symbolPrintEnter(e)));
  }
  static symbolPrintEnter(e) {
    var t;
    return (t = e.getLabel()) === null || t === void 0 ? void 0 : t.replace(/\benter\b/gi, "⏎");
  }
}
let IH = class {
  constructor(e, t, n, r, s) {
    this._menuId = t, this._menuService = r, this._contextKeyService = s, this._menuDisposables = new Ne(), this.element = Te(e, Re(".suggest-status-bar"));
    const o = (a) => a instanceof sc ? n.createInstance(kG, a, void 0) : void 0;
    this._leftActions = new Dl(this.element, { actionViewItemProvider: o }), this._rightActions = new Dl(this.element, { actionViewItemProvider: o }), this._leftActions.domNode.classList.add("left"), this._rightActions.domNode.classList.add("right");
  }
  dispose() {
    this._menuDisposables.dispose(), this._leftActions.dispose(), this._rightActions.dispose(), this.element.remove();
  }
  show() {
    const e = this._menuService.createMenu(this._menuId, this._contextKeyService), t = () => {
      const n = [], r = [];
      for (const [s, o] of e.getActions())
        s === "left" ? n.push(...o) : r.push(...o);
      this._leftActions.clear(), this._leftActions.push(n), this._rightActions.clear(), this._rightActions.push(r);
    };
    this._menuDisposables.add(e.onDidChange(() => t())), this._menuDisposables.add(e);
  }
  hide() {
    this._menuDisposables.clear();
  }
};
IH = cit([
  VT(2, bt),
  VT(3, Ou),
  VT(4, yt)
], IH);
var dit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, uit = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function TG(i) {
  return !!i && !!(i.completion.documentation || i.completion.detail && i.completion.detail !== i.completion.label);
}
let AH = class {
  constructor(e, t) {
    this._editor = e, this._onDidClose = new pe(), this.onDidClose = this._onDidClose.event, this._onDidChangeContents = new pe(), this.onDidChangeContents = this._onDidChangeContents.event, this._disposables = new Ne(), this._renderDisposeable = new Ne(), this._borderWidth = 1, this._size = new _n(330, 0), this.domNode = Re(".suggest-details"), this.domNode.classList.add("no-docs"), this._markdownRenderer = t.createInstance($h, { editor: e }), this._body = Re(".body"), this._scrollbar = new TS(this._body, {
      alwaysConsumeMouseWheel: !0
    }), Te(this.domNode, this._scrollbar.getDomNode()), this._disposables.add(this._scrollbar), this._header = Te(this._body, Re(".header")), this._close = Te(this._header, Re("span" + ft.asCSSSelector(We.close))), this._close.title = C("details.close", "Close"), this._type = Te(this._header, Re("p.type")), this._docs = Te(this._body, Re("p.docs")), this._configureFont(), this._disposables.add(this._editor.onDidChangeConfiguration((n) => {
      n.hasChanged(
        50
        /* EditorOption.fontInfo */
      ) && this._configureFont();
    }));
  }
  dispose() {
    this._disposables.dispose(), this._renderDisposeable.dispose();
  }
  _configureFont() {
    const e = this._editor.getOptions(), t = e.get(
      50
      /* EditorOption.fontInfo */
    ), n = t.getMassagedFontFamily(), r = e.get(
      118
      /* EditorOption.suggestFontSize */
    ) || t.fontSize, s = e.get(
      119
      /* EditorOption.suggestLineHeight */
    ) || t.lineHeight, o = t.fontWeight, a = `${r}px`, l = `${s}px`;
    this.domNode.style.fontSize = a, this.domNode.style.lineHeight = `${s / r}`, this.domNode.style.fontWeight = o, this.domNode.style.fontFeatureSettings = t.fontFeatureSettings, this._type.style.fontFamily = n, this._close.style.height = l, this._close.style.width = l;
  }
  getLayoutInfo() {
    const e = this._editor.getOption(
      119
      /* EditorOption.suggestLineHeight */
    ) || this._editor.getOption(
      50
      /* EditorOption.fontInfo */
    ).lineHeight, t = this._borderWidth, n = t * 2;
    return {
      lineHeight: e,
      borderWidth: t,
      borderHeight: n,
      verticalPadding: 22,
      horizontalPadding: 14
    };
  }
  renderLoading() {
    this._type.textContent = C("loading", "Loading..."), this._docs.textContent = "", this.domNode.classList.remove("no-docs", "no-type"), this.layout(this.size.width, this.getLayoutInfo().lineHeight * 2), this._onDidChangeContents.fire(this);
  }
  renderItem(e, t) {
    var n, r;
    this._renderDisposeable.clear();
    let { detail: s, documentation: o } = e.completion;
    if (t) {
      let a = "";
      a += `score: ${e.score[0]}
`, a += `prefix: ${(n = e.word) !== null && n !== void 0 ? n : "(no prefix)"}
`, a += `word: ${e.completion.filterText ? e.completion.filterText + " (filterText)" : e.textLabel}
`, a += `distance: ${e.distance} (localityBonus-setting)
`, a += `index: ${e.idx}, based on ${e.completion.sortText && `sortText: "${e.completion.sortText}"` || "label"}
`, a += `commit_chars: ${(r = e.completion.commitCharacters) === null || r === void 0 ? void 0 : r.join("")}
`, o = new ys().appendCodeblock("empty", a), s = `Provider: ${e.provider._debugDisplayName}`;
    }
    if (!t && !TG(e)) {
      this.clearContents();
      return;
    }
    if (this.domNode.classList.remove("no-docs", "no-type"), s) {
      const a = s.length > 1e5 ? `${s.substr(0, 1e5)}…` : s;
      this._type.textContent = a, this._type.title = a, Zo(this._type), this._type.classList.toggle("auto-wrap", !/\r?\n^\s+/gmi.test(a));
    } else
      ls(this._type), this._type.title = "", ao(this._type), this.domNode.classList.add("no-type");
    if (ls(this._docs), typeof o == "string")
      this._docs.classList.remove("markdown-docs"), this._docs.textContent = o;
    else if (o) {
      this._docs.classList.add("markdown-docs"), ls(this._docs);
      const a = this._markdownRenderer.render(o);
      this._docs.appendChild(a.element), this._renderDisposeable.add(a), this._renderDisposeable.add(this._markdownRenderer.onDidRenderAsync(() => {
        this.layout(this._size.width, this._type.clientHeight + this._docs.clientHeight), this._onDidChangeContents.fire(this);
      }));
    }
    this.domNode.style.userSelect = "text", this.domNode.tabIndex = -1, this._close.onmousedown = (a) => {
      a.preventDefault(), a.stopPropagation();
    }, this._close.onclick = (a) => {
      a.preventDefault(), a.stopPropagation(), this._onDidClose.fire();
    }, this._body.scrollTop = 0, this.layout(this._size.width, this._type.clientHeight + this._docs.clientHeight), this._onDidChangeContents.fire(this);
  }
  clearContents() {
    this.domNode.classList.add("no-docs"), this._type.textContent = "", this._docs.textContent = "";
  }
  get size() {
    return this._size;
  }
  layout(e, t) {
    const n = new _n(e, t);
    _n.equals(n, this._size) || (this._size = n, j9e(this.domNode, e, t)), this._scrollbar.scanDomNode();
  }
  scrollDown(e = 8) {
    this._body.scrollTop += e;
  }
  scrollUp(e = 8) {
    this._body.scrollTop -= e;
  }
  scrollTop() {
    this._body.scrollTop = 0;
  }
  scrollBottom() {
    this._body.scrollTop = this._body.scrollHeight;
  }
  pageDown() {
    this.scrollDown(80);
  }
  pageUp() {
    this.scrollUp(80);
  }
  set borderWidth(e) {
    this._borderWidth = e;
  }
  get borderWidth() {
    return this._borderWidth;
  }
};
AH = dit([
  uit(1, bt)
], AH);
class hit {
  constructor(e, t) {
    this.widget = e, this._editor = t, this._disposables = new Ne(), this._added = !1, this._preferAlignAtTop = !0, this._resizable = new lG(), this._resizable.domNode.classList.add("suggest-details-container"), this._resizable.domNode.appendChild(e.domNode), this._resizable.enableSashes(!1, !0, !0, !1);
    let n, r, s = 0, o = 0;
    this._disposables.add(this._resizable.onDidWillResize(() => {
      n = this._topLeft, r = this._resizable.size;
    })), this._disposables.add(this._resizable.onDidResize((a) => {
      if (n && r) {
        this.widget.layout(a.dimension.width, a.dimension.height);
        let l = !1;
        a.west && (o = r.width - a.dimension.width, l = !0), a.north && (s = r.height - a.dimension.height, l = !0), l && this._applyTopLeft({
          top: n.top + s,
          left: n.left + o
        });
      }
      a.done && (n = void 0, r = void 0, s = 0, o = 0, this._userSize = a.dimension);
    })), this._disposables.add(this.widget.onDidChangeContents(() => {
      var a;
      this._anchorBox && this._placeAtAnchor(this._anchorBox, (a = this._userSize) !== null && a !== void 0 ? a : this.widget.size, this._preferAlignAtTop);
    }));
  }
  dispose() {
    this._resizable.dispose(), this._disposables.dispose(), this.hide();
  }
  getId() {
    return "suggest.details";
  }
  getDomNode() {
    return this._resizable.domNode;
  }
  getPosition() {
    return null;
  }
  show() {
    this._added || (this._editor.addOverlayWidget(this), this.getDomNode().style.position = "fixed", this._added = !0);
  }
  hide(e = !1) {
    this._resizable.clearSashHoverState(), this._added && (this._editor.removeOverlayWidget(this), this._added = !1, this._anchorBox = void 0, this._topLeft = void 0), e && (this._userSize = void 0, this.widget.clearContents());
  }
  placeAtAnchor(e, t) {
    var n;
    const r = e.getBoundingClientRect();
    this._anchorBox = r, this._preferAlignAtTop = t, this._placeAtAnchor(this._anchorBox, (n = this._userSize) !== null && n !== void 0 ? n : this.widget.size, t);
  }
  _placeAtAnchor(e, t, n) {
    var r;
    const s = fb(this.getDomNode().ownerDocument.body), o = this.widget.getLayoutInfo(), a = new _n(220, 2 * o.lineHeight), l = e.top, c = function() {
      const w = s.width - (e.left + e.width + o.borderWidth + o.horizontalPadding), y = -o.borderWidth + e.left + e.width, S = new _n(w, s.height - e.top - o.borderHeight - o.verticalPadding), x = S.with(void 0, e.top + e.height - o.borderHeight - o.verticalPadding);
      return { top: l, left: y, fit: w - t.width, maxSizeTop: S, maxSizeBottom: x, minSize: a.with(Math.min(w, a.width)) };
    }(), d = function() {
      const w = e.left - o.borderWidth - o.horizontalPadding, y = Math.max(o.horizontalPadding, e.left - t.width - o.borderWidth), S = new _n(w, s.height - e.top - o.borderHeight - o.verticalPadding), x = S.with(void 0, e.top + e.height - o.borderHeight - o.verticalPadding);
      return { top: l, left: y, fit: w - t.width, maxSizeTop: S, maxSizeBottom: x, minSize: a.with(Math.min(w, a.width)) };
    }(), u = function() {
      const w = e.left, y = -o.borderWidth + e.top + e.height, S = new _n(e.width - o.borderHeight, s.height - e.top - e.height - o.verticalPadding);
      return { top: y, left: w, fit: S.height - t.height, maxSizeBottom: S, maxSizeTop: S, minSize: a.with(S.width) };
    }(), h = [c, d, u], f = (r = h.find((w) => w.fit >= 0)) !== null && r !== void 0 ? r : h.sort((w, y) => y.fit - w.fit)[0], g = e.top + e.height - o.borderHeight;
    let p, m = t.height;
    const _ = Math.max(f.maxSizeTop.height, f.maxSizeBottom.height);
    m > _ && (m = _);
    let b;
    n ? m <= f.maxSizeTop.height ? (p = !0, b = f.maxSizeTop) : (p = !1, b = f.maxSizeBottom) : m <= f.maxSizeBottom.height ? (p = !1, b = f.maxSizeBottom) : (p = !0, b = f.maxSizeTop), this._applyTopLeft({ left: f.left, top: p ? f.top : g - m }), this.getDomNode().style.position = "fixed", this._resizable.enableSashes(!p, f === c, p, f !== c), this._resizable.minSize = f.minSize, this._resizable.maxSize = b, this._resizable.layout(m, Math.min(b.width, t.width)), this.widget.layout(this._resizable.size.width, this._resizable.size.height);
  }
  _applyTopLeft(e) {
    this._topLeft = e, this.getDomNode().style.left = `${this._topLeft.left}px`, this.getDomNode().style.top = `${this._topLeft.top}px`;
  }
}
var Ph;
(function(i) {
  i[i.FILE = 0] = "FILE", i[i.FOLDER = 1] = "FOLDER", i[i.ROOT_FOLDER = 2] = "ROOT_FOLDER";
})(Ph || (Ph = {}));
const fit = /(?:\/|^)(?:([^\/]+)\/)?([^\/]+)$/;
function UD(i, e, t, n) {
  const r = n === Ph.ROOT_FOLDER ? ["rootfolder-icon"] : n === Ph.FOLDER ? ["folder-icon"] : ["file-icon"];
  if (t) {
    let s;
    if (t.scheme === Mt.data)
      s = jg.parseMetaData(t).get(jg.META_DATA_LABEL);
    else {
      const o = t.path.match(fit);
      o ? (s = GD(o[2].toLowerCase()), o[1] && r.push(`${GD(o[1].toLowerCase())}-name-dir-icon`)) : s = GD(t.authority.toLowerCase());
    }
    if (n === Ph.FOLDER)
      r.push(`${s}-name-folder-icon`);
    else {
      if (s) {
        if (r.push(`${s}-name-file-icon`), r.push("name-file-icon"), s.length <= 255) {
          const a = s.split(".");
          for (let l = 1; l < a.length; l++)
            r.push(`${a.slice(l).join(".")}-ext-file-icon`);
        }
        r.push("ext-file-icon");
      }
      const o = git(i, e, t);
      o && r.push(`${GD(o)}-lang-file-icon`);
    }
  }
  return r;
}
function git(i, e, t) {
  if (!t)
    return null;
  let n = null;
  if (t.scheme === Mt.data) {
    const s = jg.parseMetaData(t).get(jg.META_DATA_MIME);
    s && (n = e.getLanguageIdByMimeType(s));
  } else {
    const r = i.getModel(t);
    r && (n = r.getLanguageId());
  }
  return n && n !== Fa ? n : e.guessLanguageIdByFilepathOrFirstLine(t);
}
function GD(i) {
  return i.replace(/[\11\12\14\15\40]/g, "/");
}
var pit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, HT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Sf;
function K1e(i) {
  return `suggest-aria-id:${i}`;
}
const mit = $i("suggest-more-info", We.chevronRight, C("suggestMoreInfoIcon", "Icon for more information in the suggest widget.")), vit = new (Sf = class {
  extract(e, t) {
    if (e.textLabel.match(Sf._regexStrict))
      return t[0] = e.textLabel, !0;
    if (e.completion.detail && e.completion.detail.match(Sf._regexStrict))
      return t[0] = e.completion.detail, !0;
    if (typeof e.completion.documentation == "string") {
      const n = Sf._regexRelaxed.exec(e.completion.documentation);
      if (n && (n.index === 0 || n.index + n[0].length === e.completion.documentation.length))
        return t[0] = n[0], !0;
    }
    return !1;
  }
}, Sf._regexRelaxed = /(#([\da-fA-F]{3}){1,2}|(rgb|hsl)a\(\s*(\d{1,3}%?\s*,\s*){3}(1|0?\.\d+)\)|(rgb|hsl)\(\s*\d{1,3}%?(\s*,\s*\d{1,3}%?){2}\s*\))/, Sf._regexStrict = new RegExp(`^${Sf._regexRelaxed.source}$`, "i"), Sf)();
let kH = class {
  constructor(e, t, n, r) {
    this._editor = e, this._modelService = t, this._languageService = n, this._themeService = r, this._onDidToggleDetails = new pe(), this.onDidToggleDetails = this._onDidToggleDetails.event, this.templateId = "suggestion";
  }
  dispose() {
    this._onDidToggleDetails.dispose();
  }
  renderTemplate(e) {
    const t = new Ne(), n = e;
    n.classList.add("show-file-icons");
    const r = Te(e, Re(".icon")), s = Te(r, Re("span.colorspan")), o = Te(e, Re(".contents")), a = Te(o, Re(".main")), l = Te(a, Re(".icon-label.codicon")), c = Te(a, Re("span.left")), d = Te(a, Re("span.right")), u = new $L(c, { supportHighlights: !0, supportIcons: !0 });
    t.add(u);
    const h = Te(c, Re("span.signature-label")), f = Te(c, Re("span.qualifier-label")), g = Te(d, Re("span.details-label")), p = Te(d, Re("span.readMore" + ft.asCSSSelector(mit)));
    p.title = C("readMore", "Read More");
    const m = () => {
      const _ = this._editor.getOptions(), b = _.get(
        50
        /* EditorOption.fontInfo */
      ), w = b.getMassagedFontFamily(), y = b.fontFeatureSettings, S = _.get(
        118
        /* EditorOption.suggestFontSize */
      ) || b.fontSize, x = _.get(
        119
        /* EditorOption.suggestLineHeight */
      ) || b.lineHeight, D = b.fontWeight, E = b.letterSpacing, L = `${S}px`, k = `${x}px`, N = `${E}px`;
      n.style.fontSize = L, n.style.fontWeight = D, n.style.letterSpacing = N, a.style.fontFamily = w, a.style.fontFeatureSettings = y, a.style.lineHeight = k, r.style.height = k, r.style.width = k, p.style.height = k, p.style.width = k;
    };
    return m(), t.add(this._editor.onDidChangeConfiguration((_) => {
      (_.hasChanged(
        50
        /* EditorOption.fontInfo */
      ) || _.hasChanged(
        118
        /* EditorOption.suggestFontSize */
      ) || _.hasChanged(
        119
        /* EditorOption.suggestLineHeight */
      )) && m();
    })), { root: n, left: c, right: d, icon: r, colorspan: s, iconLabel: u, iconContainer: l, parametersLabel: h, qualifierLabel: f, detailsLabel: g, readMore: p, disposables: t };
  }
  renderElement(e, t, n) {
    const { completion: r } = e;
    n.root.id = K1e(t), n.colorspan.style.backgroundColor = "";
    const s = {
      labelEscapeNewLines: !0,
      matches: BS(e.score)
    }, o = [];
    if (r.kind === 19 && vit.extract(e, o))
      n.icon.className = "icon customcolor", n.iconContainer.className = "icon hide", n.colorspan.style.backgroundColor = o[0];
    else if (r.kind === 20 && this._themeService.getFileIconTheme().hasFileIcons) {
      n.icon.className = "icon hide", n.iconContainer.className = "icon hide";
      const a = UD(this._modelService, this._languageService, pt.from({ scheme: "fake", path: e.textLabel }), Ph.FILE), l = UD(this._modelService, this._languageService, pt.from({ scheme: "fake", path: r.detail }), Ph.FILE);
      s.extraClasses = a.length > l.length ? a : l;
    } else r.kind === 23 && this._themeService.getFileIconTheme().hasFolderIcons ? (n.icon.className = "icon hide", n.iconContainer.className = "icon hide", s.extraClasses = [
      UD(this._modelService, this._languageService, pt.from({ scheme: "fake", path: e.textLabel }), Ph.FOLDER),
      UD(this._modelService, this._languageService, pt.from({ scheme: "fake", path: r.detail }), Ph.FOLDER)
    ].flat()) : (n.icon.className = "icon hide", n.iconContainer.className = "", n.iconContainer.classList.add("suggest-icon", ...ft.asClassNameArray(Sy.toIcon(r.kind))));
    r.tags && r.tags.indexOf(
      1
      /* CompletionItemTag.Deprecated */
    ) >= 0 && (s.extraClasses = (s.extraClasses || []).concat(["deprecated"]), s.matches = []), n.iconLabel.setLabel(e.textLabel, void 0, s), typeof r.label == "string" ? (n.parametersLabel.textContent = "", n.detailsLabel.textContent = WT(r.detail || ""), n.root.classList.add("string-label")) : (n.parametersLabel.textContent = WT(r.label.detail || ""), n.detailsLabel.textContent = WT(r.label.description || ""), n.root.classList.remove("string-label")), this._editor.getOption(
      117
      /* EditorOption.suggest */
    ).showInlineDetails ? Zo(n.detailsLabel) : ao(n.detailsLabel), TG(e) ? (n.right.classList.add("can-expand-details"), Zo(n.readMore), n.readMore.onmousedown = (a) => {
      a.stopPropagation(), a.preventDefault();
    }, n.readMore.onclick = (a) => {
      a.stopPropagation(), a.preventDefault(), this._onDidToggleDetails.fire();
    }) : (n.right.classList.remove("can-expand-details"), ao(n.readMore), n.readMore.onmousedown = null, n.readMore.onclick = null);
  }
  disposeTemplate(e) {
    e.disposables.dispose();
  }
};
kH = pit([
  HT(1, fi),
  HT(2, ci),
  HT(3, Pr)
], kH);
function WT(i) {
  return i.replace(/\r\n|\r|\n/g, "");
}
var _it = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, qD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, bit = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, H1;
ne("editorSuggestWidget.background", { dark: ji, light: ji, hcDark: ji, hcLight: ji }, C("editorSuggestWidgetBackground", "Background color of the suggest widget."));
ne("editorSuggestWidget.border", { dark: tu, light: tu, hcDark: tu, hcLight: tu }, C("editorSuggestWidgetBorder", "Border color of the suggest widget."));
const KD = ne("editorSuggestWidget.foreground", { dark: Ul, light: Ul, hcDark: Ul, hcLight: Ul }, C("editorSuggestWidgetForeground", "Foreground color of the suggest widget."));
ne("editorSuggestWidget.selectedForeground", { dark: um, light: um, hcDark: um, hcLight: um }, C("editorSuggestWidgetSelectedForeground", "Foreground color of the selected entry in the suggest widget."));
ne("editorSuggestWidget.selectedIconForeground", { dark: $1, light: $1, hcDark: $1, hcLight: $1 }, C("editorSuggestWidgetSelectedIconForeground", "Icon foreground color of the selected entry in the suggest widget."));
const Cit = ne("editorSuggestWidget.selectedBackground", { dark: hm, light: hm, hcDark: hm, hcLight: hm }, C("editorSuggestWidgetSelectedBackground", "Background color of the selected entry in the suggest widget."));
ne("editorSuggestWidget.highlightForeground", { dark: Gl, light: Gl, hcDark: Gl, hcLight: Gl }, C("editorSuggestWidgetHighlightForeground", "Color of the match highlights in the suggest widget."));
ne("editorSuggestWidget.focusHighlightForeground", { dark: Ux, light: Ux, hcDark: Ux, hcLight: Ux }, C("editorSuggestWidgetFocusHighlightForeground", "Color of the match highlights in the suggest widget when an item is focused."));
ne("editorSuggestWidgetStatus.foreground", { dark: dt(KD, 0.5), light: dt(KD, 0.5), hcDark: dt(KD, 0.5), hcLight: dt(KD, 0.5) }, C("editorSuggestWidgetStatusForeground", "Foreground color of the suggest widget status."));
class yit {
  constructor(e, t) {
    this._service = e, this._key = `suggestWidget.size/${t.getEditorType()}/${t instanceof Yg}`;
  }
  restore() {
    var e;
    const t = (e = this._service.get(
      this._key,
      0
      /* StorageScope.PROFILE */
    )) !== null && e !== void 0 ? e : "";
    try {
      const n = JSON.parse(t);
      if (_n.is(n))
        return _n.lift(n);
    } catch {
    }
  }
  store(e) {
    this._service.store(
      this._key,
      JSON.stringify(e),
      0,
      1
      /* StorageTarget.MACHINE */
    );
  }
  reset() {
    this._service.remove(
      this._key,
      0
      /* StorageScope.PROFILE */
    );
  }
}
let Fw = H1 = class {
  constructor(e, t, n, r, s) {
    this.editor = e, this._storageService = t, this._state = 0, this._isAuto = !1, this._pendingLayout = new ds(), this._pendingShowDetails = new ds(), this._ignoreFocusEvents = !1, this._forceRenderingAbove = !1, this._explainMode = !1, this._showTimeout = new uc(), this._disposables = new Ne(), this._onDidSelect = new jm(), this._onDidFocus = new jm(), this._onDidHide = new pe(), this._onDidShow = new pe(), this.onDidSelect = this._onDidSelect.event, this.onDidFocus = this._onDidFocus.event, this.onDidHide = this._onDidHide.event, this.onDidShow = this._onDidShow.event, this._onDetailsKeydown = new pe(), this.onDetailsKeyDown = this._onDetailsKeydown.event, this.element = new lG(), this.element.domNode.classList.add("editor-widget", "suggest-widget"), this._contentWidget = new wit(this, e), this._persistedSize = new yit(t, e);
    class o {
      constructor(f, g, p = !1, m = !1) {
        this.persistedSize = f, this.currentSize = g, this.persistHeight = p, this.persistWidth = m;
      }
    }
    let a;
    this._disposables.add(this.element.onDidWillResize(() => {
      this._contentWidget.lockPreference(), a = new o(this._persistedSize.restore(), this.element.size);
    })), this._disposables.add(this.element.onDidResize((h) => {
      var f, g, p, m;
      if (this._resize(h.dimension.width, h.dimension.height), a && (a.persistHeight = a.persistHeight || !!h.north || !!h.south, a.persistWidth = a.persistWidth || !!h.east || !!h.west), !!h.done) {
        if (a) {
          const { itemHeight: _, defaultSize: b } = this.getLayoutInfo(), w = Math.round(_ / 2);
          let { width: y, height: S } = this.element.size;
          (!a.persistHeight || Math.abs(a.currentSize.height - S) <= w) && (S = (g = (f = a.persistedSize) === null || f === void 0 ? void 0 : f.height) !== null && g !== void 0 ? g : b.height), (!a.persistWidth || Math.abs(a.currentSize.width - y) <= w) && (y = (m = (p = a.persistedSize) === null || p === void 0 ? void 0 : p.width) !== null && m !== void 0 ? m : b.width), this._persistedSize.store(new _n(y, S));
        }
        this._contentWidget.unlockPreference(), a = void 0;
      }
    })), this._messageElement = Te(this.element.domNode, Re(".message")), this._listElement = Te(this.element.domNode, Re(".tree"));
    const l = this._disposables.add(s.createInstance(AH, this.editor));
    l.onDidClose(this.toggleDetails, this, this._disposables), this._details = new hit(l, this.editor);
    const c = () => this.element.domNode.classList.toggle("no-icons", !this.editor.getOption(
      117
      /* EditorOption.suggest */
    ).showIcons);
    c();
    const d = s.createInstance(kH, this.editor);
    this._disposables.add(d), this._disposables.add(d.onDidToggleDetails(() => this.toggleDetails())), this._list = new pc("SuggestWidget", this._listElement, {
      getHeight: (h) => this.getLayoutInfo().itemHeight,
      getTemplateId: (h) => "suggestion"
    }, [d], {
      alwaysConsumeMouseWheel: !0,
      useShadows: !1,
      mouseSupport: !1,
      multipleSelectionSupport: !1,
      accessibilityProvider: {
        getRole: () => "option",
        getWidgetAriaLabel: () => C("suggest", "Suggest"),
        getWidgetRole: () => "listbox",
        getAriaLabel: (h) => {
          let f = h.textLabel;
          if (typeof h.completion.label != "string") {
            const { detail: _, description: b } = h.completion.label;
            _ && b ? f = C("label.full", "{0} {1}, {2}", f, _, b) : _ ? f = C("label.detail", "{0} {1}", f, _) : b && (f = C("label.desc", "{0}, {1}", f, b));
          }
          if (!h.isResolved || !this._isDetailsVisible())
            return f;
          const { documentation: g, detail: p } = h.completion, m = zm("{0}{1}", p || "", g ? typeof g == "string" ? g : g.value : "");
          return C("ariaCurrenttSuggestionReadDetails", "{0}, docs: {1}", f, m);
        }
      }
    }), this._list.style(Cb({
      listInactiveFocusBackground: Cit,
      listInactiveFocusOutline: ii
    })), this._status = s.createInstance(IH, this.element.domNode, Eg);
    const u = () => this.element.domNode.classList.toggle("with-status-bar", this.editor.getOption(
      117
      /* EditorOption.suggest */
    ).showStatusBar);
    u(), this._disposables.add(r.onDidColorThemeChange((h) => this._onThemeChange(h))), this._onThemeChange(r.getColorTheme()), this._disposables.add(this._list.onMouseDown((h) => this._onListMouseDownOrTap(h))), this._disposables.add(this._list.onTap((h) => this._onListMouseDownOrTap(h))), this._disposables.add(this._list.onDidChangeSelection((h) => this._onListSelection(h))), this._disposables.add(this._list.onDidChangeFocus((h) => this._onListFocus(h))), this._disposables.add(this.editor.onDidChangeCursorSelection(() => this._onCursorSelectionChanged())), this._disposables.add(this.editor.onDidChangeConfiguration((h) => {
      h.hasChanged(
        117
        /* EditorOption.suggest */
      ) && (u(), c());
    })), this._ctxSuggestWidgetVisible = kt.Visible.bindTo(n), this._ctxSuggestWidgetDetailsVisible = kt.DetailsVisible.bindTo(n), this._ctxSuggestWidgetMultipleSuggestions = kt.MultipleSuggestions.bindTo(n), this._ctxSuggestWidgetHasFocusedSuggestion = kt.HasFocusedSuggestion.bindTo(n), this._disposables.add(ar(this._details.widget.domNode, "keydown", (h) => {
      this._onDetailsKeydown.fire(h);
    })), this._disposables.add(this.editor.onMouseDown((h) => this._onEditorMouseDown(h)));
  }
  dispose() {
    var e;
    this._details.widget.dispose(), this._details.dispose(), this._list.dispose(), this._status.dispose(), this._disposables.dispose(), (e = this._loadingTimeout) === null || e === void 0 || e.dispose(), this._pendingLayout.dispose(), this._pendingShowDetails.dispose(), this._showTimeout.dispose(), this._contentWidget.dispose(), this.element.dispose();
  }
  _onEditorMouseDown(e) {
    this._details.widget.domNode.contains(e.target.element) ? this._details.widget.domNode.focus() : this.element.domNode.contains(e.target.element) && this.editor.focus();
  }
  _onCursorSelectionChanged() {
    this._state !== 0 && this._contentWidget.layout();
  }
  _onListMouseDownOrTap(e) {
    typeof e.element > "u" || typeof e.index > "u" || (e.browserEvent.preventDefault(), e.browserEvent.stopPropagation(), this._select(e.element, e.index));
  }
  _onListSelection(e) {
    e.elements.length && this._select(e.elements[0], e.indexes[0]);
  }
  _select(e, t) {
    const n = this._completionModel;
    n && (this._onDidSelect.fire({ item: e, index: t, model: n }), this.editor.focus());
  }
  _onThemeChange(e) {
    this._details.widget.borderWidth = ed(e.type) ? 2 : 1;
  }
  _onListFocus(e) {
    var t;
    if (this._ignoreFocusEvents)
      return;
    if (!e.elements.length) {
      this._currentSuggestionDetails && (this._currentSuggestionDetails.cancel(), this._currentSuggestionDetails = void 0, this._focusedItem = void 0), this.editor.setAriaOptions({ activeDescendant: void 0 }), this._ctxSuggestWidgetHasFocusedSuggestion.set(!1);
      return;
    }
    if (!this._completionModel)
      return;
    this._ctxSuggestWidgetHasFocusedSuggestion.set(!0);
    const n = e.elements[0], r = e.indexes[0];
    n !== this._focusedItem && ((t = this._currentSuggestionDetails) === null || t === void 0 || t.cancel(), this._currentSuggestionDetails = void 0, this._focusedItem = n, this._list.reveal(r), this._currentSuggestionDetails = Ir((s) => bit(this, void 0, void 0, function* () {
      const o = Rg(() => {
        this._isDetailsVisible() && this.showDetails(!0);
      }, 250), a = s.onCancellationRequested(() => o.dispose());
      try {
        return yield n.resolve(s);
      } finally {
        o.dispose(), a.dispose();
      }
    })), this._currentSuggestionDetails.then(() => {
      r >= this._list.length || n !== this._list.element(r) || (this._ignoreFocusEvents = !0, this._list.splice(r, 1, [n]), this._list.setFocus([r]), this._ignoreFocusEvents = !1, this._isDetailsVisible() ? this.showDetails(!1) : this.element.domNode.classList.remove("docs-side"), this.editor.setAriaOptions({ activeDescendant: K1e(r) }));
    }).catch(It)), this._onDidFocus.fire({ item: n, index: r, model: this._completionModel });
  }
  _setState(e) {
    if (this._state !== e)
      switch (this._state = e, this.element.domNode.classList.toggle(
        "frozen",
        e === 4
        /* State.Frozen */
      ), this.element.domNode.classList.remove("message"), e) {
        case 0:
          ao(this._messageElement, this._listElement, this._status.element), this._details.hide(!0), this._status.hide(), this._contentWidget.hide(), this._ctxSuggestWidgetVisible.reset(), this._ctxSuggestWidgetMultipleSuggestions.reset(), this._ctxSuggestWidgetHasFocusedSuggestion.reset(), this._showTimeout.cancel(), this.element.domNode.classList.remove("visible"), this._list.splice(0, this._list.length), this._focusedItem = void 0, this._cappedHeight = void 0, this._explainMode = !1;
          break;
        case 1:
          this.element.domNode.classList.add("message"), this._messageElement.textContent = H1.LOADING_MESSAGE, ao(this._listElement, this._status.element), Zo(this._messageElement), this._details.hide(), this._show(), this._focusedItem = void 0, Vg(H1.LOADING_MESSAGE);
          break;
        case 2:
          this.element.domNode.classList.add("message"), this._messageElement.textContent = H1.NO_SUGGESTIONS_MESSAGE, ao(this._listElement, this._status.element), Zo(this._messageElement), this._details.hide(), this._show(), this._focusedItem = void 0, Vg(H1.NO_SUGGESTIONS_MESSAGE);
          break;
        case 3:
          ao(this._messageElement), Zo(this._listElement, this._status.element), this._show();
          break;
        case 4:
          ao(this._messageElement), Zo(this._listElement, this._status.element), this._show();
          break;
        case 5:
          ao(this._messageElement), Zo(this._listElement, this._status.element), this._details.show(), this._show();
          break;
      }
  }
  _show() {
    this._status.show(), this._contentWidget.show(), this._layout(this._persistedSize.restore()), this._ctxSuggestWidgetVisible.set(!0), this._showTimeout.cancelAndSet(() => {
      this.element.domNode.classList.add("visible"), this._onDidShow.fire(this);
    }, 100);
  }
  showTriggered(e, t) {
    this._state === 0 && (this._contentWidget.setPosition(this.editor.getPosition()), this._isAuto = !!e, this._isAuto || (this._loadingTimeout = Rg(() => this._setState(
      1
      /* State.Loading */
    ), t)));
  }
  showSuggestions(e, t, n, r, s) {
    var o, a;
    if (this._contentWidget.setPosition(this.editor.getPosition()), (o = this._loadingTimeout) === null || o === void 0 || o.dispose(), (a = this._currentSuggestionDetails) === null || a === void 0 || a.cancel(), this._currentSuggestionDetails = void 0, this._completionModel !== e && (this._completionModel = e), n && this._state !== 2 && this._state !== 0) {
      this._setState(
        4
        /* State.Frozen */
      );
      return;
    }
    const l = this._completionModel.items.length, c = l === 0;
    if (this._ctxSuggestWidgetMultipleSuggestions.set(l > 1), c) {
      this._setState(
        r ? 0 : 2
        /* State.Empty */
      ), this._completionModel = void 0;
      return;
    }
    this._focusedItem = void 0, this._onDidFocus.pause(), this._onDidSelect.pause();
    try {
      this._list.splice(0, this._list.length, this._completionModel.items), this._setState(
        n ? 4 : 3
        /* State.Open */
      ), this._list.reveal(t, 0), this._list.setFocus(s ? [] : [t]);
    } finally {
      this._onDidFocus.resume(), this._onDidSelect.resume();
    }
    this._pendingLayout.value = QE(() => {
      this._pendingLayout.clear(), this._layout(this.element.size), this._details.widget.domNode.classList.remove("focused");
    });
  }
  focusSelected() {
    this._list.length > 0 && this._list.setFocus([0]);
  }
  selectNextPage() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.pageDown(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusNextPage(), !0;
    }
  }
  selectNext() {
    switch (this._state) {
      case 0:
        return !1;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusNext(1, !0), !0;
    }
  }
  selectLast() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.scrollBottom(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusLast(), !0;
    }
  }
  selectPreviousPage() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.pageUp(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusPreviousPage(), !0;
    }
  }
  selectPrevious() {
    switch (this._state) {
      case 0:
        return !1;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusPrevious(1, !0), !1;
    }
  }
  selectFirst() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.scrollTop(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusFirst(), !0;
    }
  }
  getFocusedItem() {
    if (this._state !== 0 && this._state !== 2 && this._state !== 1 && this._completionModel && this._list.getFocus().length > 0)
      return {
        item: this._list.getFocusedElements()[0],
        index: this._list.getFocus()[0],
        model: this._completionModel
      };
  }
  toggleDetailsFocus() {
    this._state === 5 ? (this._setState(
      3
      /* State.Open */
    ), this._details.widget.domNode.classList.remove("focused")) : this._state === 3 && this._isDetailsVisible() && (this._setState(
      5
      /* State.Details */
    ), this._details.widget.domNode.classList.add("focused"));
  }
  toggleDetails() {
    this._isDetailsVisible() ? (this._pendingShowDetails.clear(), this._ctxSuggestWidgetDetailsVisible.set(!1), this._setDetailsVisible(!1), this._details.hide(), this.element.domNode.classList.remove("shows-details")) : (TG(this._list.getFocusedElements()[0]) || this._explainMode) && (this._state === 3 || this._state === 5 || this._state === 4) && (this._ctxSuggestWidgetDetailsVisible.set(!0), this._setDetailsVisible(!0), this.showDetails(!1));
  }
  showDetails(e) {
    this._pendingShowDetails.value = QE(() => {
      this._pendingShowDetails.clear(), this._details.show(), e ? this._details.widget.renderLoading() : this._details.widget.renderItem(this._list.getFocusedElements()[0], this._explainMode), this._positionDetails(), this.editor.focus(), this.element.domNode.classList.add("shows-details");
    });
  }
  toggleExplainMode() {
    this._list.getFocusedElements()[0] && (this._explainMode = !this._explainMode, this._isDetailsVisible() ? this.showDetails(!1) : this.toggleDetails());
  }
  resetPersistedSize() {
    this._persistedSize.reset();
  }
  hideWidget() {
    var e;
    this._pendingLayout.clear(), this._pendingShowDetails.clear(), (e = this._loadingTimeout) === null || e === void 0 || e.dispose(), this._setState(
      0
      /* State.Hidden */
    ), this._onDidHide.fire(this), this.element.clearSashHoverState();
    const t = this._persistedSize.restore(), n = Math.ceil(this.getLayoutInfo().itemHeight * 4.3);
    t && t.height < n && this._persistedSize.store(t.with(void 0, n));
  }
  isFrozen() {
    return this._state === 4;
  }
  _afterRender(e) {
    if (e === null) {
      this._isDetailsVisible() && this._details.hide();
      return;
    }
    this._state === 2 || this._state === 1 || (this._isDetailsVisible() && this._details.show(), this._positionDetails());
  }
  _layout(e) {
    var t, n, r;
    if (!this.editor.hasModel() || !this.editor.getDomNode())
      return;
    const s = fb(this.element.domNode.ownerDocument.body), o = this.getLayoutInfo();
    e || (e = o.defaultSize);
    let a = e.height, l = e.width;
    if (this._status.element.style.height = `${o.itemHeight}px`, this._state === 2 || this._state === 1)
      a = o.itemHeight + o.borderHeight, l = o.defaultSize.width / 2, this.element.enableSashes(!1, !1, !1, !1), this.element.minSize = this.element.maxSize = new _n(l, a), this._contentWidget.setPreference(
        2
        /* ContentWidgetPositionPreference.BELOW */
      );
    else {
      const c = s.width - o.borderHeight - 2 * o.horizontalPadding;
      l > c && (l = c);
      const d = this._completionModel ? this._completionModel.stats.pLabelLen * o.typicalHalfwidthCharacterWidth : l, u = o.statusBarHeight + this._list.contentHeight + o.borderHeight, h = o.itemHeight + o.statusBarHeight, f = wr(this.editor.getDomNode()), g = this.editor.getScrolledVisiblePosition(this.editor.getPosition()), p = f.top + g.top + g.height, m = Math.min(s.height - p - o.verticalPadding, u), _ = f.top + g.top - o.verticalPadding, b = Math.min(_, u);
      let w = Math.min(Math.max(b, m) + o.borderHeight, u);
      a === ((t = this._cappedHeight) === null || t === void 0 ? void 0 : t.capped) && (a = this._cappedHeight.wanted), a < h && (a = h), a > w && (a = w), a > m || this._forceRenderingAbove && _ > 150 ? (this._contentWidget.setPreference(
        1
        /* ContentWidgetPositionPreference.ABOVE */
      ), this.element.enableSashes(!0, !0, !1, !1), w = b) : (this._contentWidget.setPreference(
        2
        /* ContentWidgetPositionPreference.BELOW */
      ), this.element.enableSashes(!1, !0, !0, !1), w = m), this.element.preferredSize = new _n(d, o.defaultSize.height), this.element.maxSize = new _n(c, w), this.element.minSize = new _n(220, h), this._cappedHeight = a === u ? { wanted: (r = (n = this._cappedHeight) === null || n === void 0 ? void 0 : n.wanted) !== null && r !== void 0 ? r : e.height, capped: a } : void 0;
    }
    this._resize(l, a);
  }
  _resize(e, t) {
    const { width: n, height: r } = this.element.maxSize;
    e = Math.min(n, e), t = Math.min(r, t);
    const { statusBarHeight: s } = this.getLayoutInfo();
    this._list.layout(t - s, e), this._listElement.style.height = `${t - s}px`, this.element.layout(t, e), this._contentWidget.layout(), this._positionDetails();
  }
  _positionDetails() {
    var e;
    this._isDetailsVisible() && this._details.placeAtAnchor(
      this.element.domNode,
      ((e = this._contentWidget.getPosition()) === null || e === void 0 ? void 0 : e.preference[0]) === 2
      /* ContentWidgetPositionPreference.BELOW */
    );
  }
  getLayoutInfo() {
    const e = this.editor.getOption(
      50
      /* EditorOption.fontInfo */
    ), t = qo(this.editor.getOption(
      119
      /* EditorOption.suggestLineHeight */
    ) || e.lineHeight, 8, 1e3), n = !this.editor.getOption(
      117
      /* EditorOption.suggest */
    ).showStatusBar || this._state === 2 || this._state === 1 ? 0 : t, r = this._details.widget.borderWidth, s = 2 * r;
    return {
      itemHeight: t,
      statusBarHeight: n,
      borderWidth: r,
      borderHeight: s,
      typicalHalfwidthCharacterWidth: e.typicalHalfwidthCharacterWidth,
      verticalPadding: 22,
      horizontalPadding: 14,
      defaultSize: new _n(430, n + 12 * t + s)
    };
  }
  _isDetailsVisible() {
    return this._storageService.getBoolean("expandSuggestionDocs", 0, !1);
  }
  _setDetailsVisible(e) {
    this._storageService.store(
      "expandSuggestionDocs",
      e,
      0,
      0
      /* StorageTarget.USER */
    );
  }
  forceRenderingAbove() {
    this._forceRenderingAbove || (this._forceRenderingAbove = !0, this._layout(this._persistedSize.restore()));
  }
  stopForceRenderingAbove() {
    this._forceRenderingAbove = !1;
  }
};
Fw.LOADING_MESSAGE = C("suggestWidget.loading", "Loading...");
Fw.NO_SUGGESTIONS_MESSAGE = C("suggestWidget.noSuggestions", "No suggestions.");
Fw = H1 = _it([
  qD(1, mc),
  qD(2, yt),
  qD(3, Pr),
  qD(4, bt)
], Fw);
class wit {
  constructor(e, t) {
    this._widget = e, this._editor = t, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this._preferenceLocked = !1, this._added = !1, this._hidden = !1;
  }
  dispose() {
    this._added && (this._added = !1, this._editor.removeContentWidget(this));
  }
  getId() {
    return "editor.widget.suggestWidget";
  }
  getDomNode() {
    return this._widget.element.domNode;
  }
  show() {
    this._hidden = !1, this._added || (this._added = !0, this._editor.addContentWidget(this));
  }
  hide() {
    this._hidden || (this._hidden = !0, this.layout());
  }
  layout() {
    this._editor.layoutContentWidget(this);
  }
  getPosition() {
    return this._hidden || !this._position || !this._preference ? null : {
      position: this._position,
      preference: [this._preference]
    };
  }
  beforeRender() {
    const { height: e, width: t } = this._widget.element.size, { borderWidth: n, horizontalPadding: r } = this._widget.getLayoutInfo();
    return new _n(t + 2 * n + r, e + 2 * n);
  }
  afterRender(e) {
    this._widget._afterRender(e);
  }
  setPreference(e) {
    this._preferenceLocked || (this._preference = e);
  }
  lockPreference() {
    this._preferenceLocked = !0;
  }
  unlockPreference() {
    this._preferenceLocked = !1;
  }
  setPosition(e) {
    this._position = e;
  }
}
var Sit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, x1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, TH;
class xit {
  constructor(e, t) {
    if (this._model = e, this._position = t, e.getLineMaxColumn(t.lineNumber) !== t.column) {
      const r = e.getOffsetAt(t), s = e.getPositionAt(r + 1);
      this._marker = e.deltaDecorations([], [{
        range: V.fromPositions(t, s),
        options: {
          description: "suggest-line-suffix",
          stickiness: 1
          /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
        }
      }]);
    }
  }
  dispose() {
    this._marker && !this._model.isDisposed() && this._model.deltaDecorations(this._marker, []);
  }
  delta(e) {
    if (this._model.isDisposed() || this._position.lineNumber !== e.lineNumber)
      return 0;
    if (this._marker) {
      const t = this._model.getDecorationRange(this._marker[0]);
      return this._model.getOffsetAt(t.getStartPosition()) - this._model.getOffsetAt(e);
    } else
      return this._model.getLineMaxColumn(e.lineNumber) - e.column;
  }
}
let Kl = TH = class {
  static get(e) {
    return e.getContribution(TH.ID);
  }
  constructor(e, t, n, r, s, o, a) {
    this._memoryService = t, this._commandService = n, this._contextKeyService = r, this._instantiationService = s, this._logService = o, this._telemetryService = a, this._lineSuffix = new ds(), this._toDispose = new Ne(), this._selectors = new Dit((u) => u.priority), this._onWillInsertSuggestItem = new pe(), this.onWillInsertSuggestItem = this._onWillInsertSuggestItem.event, this.editor = e, this.model = s.createInstance(LH, this.editor), this._selectors.register({
      priority: 0,
      select: (u, h, f) => this._memoryService.select(u, h, f)
    });
    const l = kt.InsertMode.bindTo(r);
    l.set(e.getOption(
      117
      /* EditorOption.suggest */
    ).insertMode), this._toDispose.add(this.model.onDidTrigger(() => l.set(e.getOption(
      117
      /* EditorOption.suggest */
    ).insertMode))), this.widget = this._toDispose.add(new O3(() => {
      const u = this._instantiationService.createInstance(Fw, this.editor);
      this._toDispose.add(u), this._toDispose.add(u.onDidSelect((m) => this._insertSuggestion(
        m,
        0
        /* InsertFlags.None */
      ), this));
      const h = new nit(this.editor, u, this.model, (m) => this._insertSuggestion(
        m,
        2
        /* InsertFlags.NoAfterUndoStop */
      ));
      this._toDispose.add(h);
      const f = kt.MakesTextEdit.bindTo(this._contextKeyService), g = kt.HasInsertAndReplaceRange.bindTo(this._contextKeyService), p = kt.CanResolve.bindTo(this._contextKeyService);
      return this._toDispose.add(Ct(() => {
        f.reset(), g.reset(), p.reset();
      })), this._toDispose.add(u.onDidFocus(({ item: m }) => {
        const _ = this.editor.getPosition(), b = m.editStart.column, w = _.column;
        let y = !0;
        this.editor.getOption(
          1
          /* EditorOption.acceptSuggestionOnEnter */
        ) === "smart" && this.model.state === 2 && !m.completion.additionalTextEdits && !(m.completion.insertTextRules & 4) && w - b === m.completion.insertText.length && (y = this.editor.getModel().getValueInRange({
          startLineNumber: _.lineNumber,
          startColumn: b,
          endLineNumber: _.lineNumber,
          endColumn: w
        }) !== m.completion.insertText), f.set(y), g.set(!ve.equals(m.editInsertEnd, m.editReplaceEnd)), p.set(!!m.provider.resolveCompletionItem || !!m.completion.documentation || m.completion.detail !== m.completion.label);
      })), this._toDispose.add(u.onDetailsKeyDown((m) => {
        if (m.toKeyCodeChord().equals(new Qh(
          !0,
          !1,
          !1,
          !1,
          33
          /* KeyCode.KeyC */
        )) || sn && m.toKeyCodeChord().equals(new Qh(
          !1,
          !1,
          !1,
          !0,
          33
          /* KeyCode.KeyC */
        ))) {
          m.stopPropagation();
          return;
        }
        m.toKeyCodeChord().isModifierKey() || this.editor.focus();
      })), u;
    })), this._overtypingCapturer = this._toDispose.add(new O3(() => this._toDispose.add(new N5(this.editor, this.model)))), this._alternatives = this._toDispose.add(new O3(() => this._toDispose.add(new g0(this.editor, this._contextKeyService)))), this._toDispose.add(s.createInstance(Rw, e)), this._toDispose.add(this.model.onDidTrigger((u) => {
      this.widget.value.showTriggered(u.auto, u.shy ? 250 : 50), this._lineSuffix.value = new xit(this.editor.getModel(), u.position);
    })), this._toDispose.add(this.model.onDidSuggest((u) => {
      if (u.triggerOptions.shy)
        return;
      let h = -1;
      for (const g of this._selectors.itemsOrderedByPriorityDesc)
        if (h = g.select(this.editor.getModel(), this.editor.getPosition(), u.completionModel.items), h !== -1)
          break;
      h === -1 && (h = 0);
      let f = !1;
      if (u.triggerOptions.auto) {
        const g = this.editor.getOption(
          117
          /* EditorOption.suggest */
        );
        g.selectionMode === "never" || g.selectionMode === "always" ? f = g.selectionMode === "never" : g.selectionMode === "whenTriggerCharacter" ? f = u.triggerOptions.triggerKind !== 1 : g.selectionMode === "whenQuickSuggestion" && (f = u.triggerOptions.triggerKind === 1 && !u.triggerOptions.refilter);
      }
      this.widget.value.showSuggestions(u.completionModel, h, u.isFrozen, u.triggerOptions.auto, f);
    })), this._toDispose.add(this.model.onDidCancel((u) => {
      u.retrigger || this.widget.value.hideWidget();
    })), this._toDispose.add(this.editor.onDidBlurEditorWidget(() => {
      this.model.cancel(), this.model.clear();
    }));
    const c = kt.AcceptSuggestionsOnEnter.bindTo(r), d = () => {
      const u = this.editor.getOption(
        1
        /* EditorOption.acceptSuggestionOnEnter */
      );
      c.set(u === "on" || u === "smart");
    };
    this._toDispose.add(this.editor.onDidChangeConfiguration(() => d())), d();
  }
  dispose() {
    this._alternatives.dispose(), this._toDispose.dispose(), this.widget.dispose(), this.model.dispose(), this._lineSuffix.dispose(), this._onWillInsertSuggestItem.dispose();
  }
  _insertSuggestion(e, t) {
    if (!e || !e.item) {
      this._alternatives.value.reset(), this.model.cancel(), this.model.clear();
      return;
    }
    if (!this.editor.hasModel())
      return;
    const n = us.get(this.editor);
    if (!n)
      return;
    this._onWillInsertSuggestItem.fire({ item: e.item });
    const r = this.editor.getModel(), s = r.getAlternativeVersionId(), { item: o } = e, a = [], l = new lr();
    t & 1 || this.editor.pushUndoStop();
    const c = this.getOverwriteInfo(o, !!(t & 8));
    this._memoryService.memorize(r, this.editor.getPosition(), o);
    const d = o.isResolved;
    let u = -1, h = -1;
    if (Array.isArray(o.completion.additionalTextEdits)) {
      this.model.cancel();
      const g = ud.capture(this.editor);
      this.editor.executeEdits("suggestController.additionalTextEdits.sync", o.completion.additionalTextEdits.map((p) => Si.replaceMove(V.lift(p.range), p.text))), g.restoreRelativeVerticalPositionOfCursor(this.editor);
    } else if (!d) {
      const g = new Vs();
      let p;
      const m = r.onDidChangeContent((y) => {
        if (y.isFlush) {
          l.cancel(), m.dispose();
          return;
        }
        for (const S of y.changes) {
          const x = V.getEndPosition(S.range);
          (!p || ve.isBefore(x, p)) && (p = x);
        }
      }), _ = t;
      t |= 2;
      let b = !1;
      const w = this.editor.onWillType(() => {
        w.dispose(), b = !0, _ & 2 || this.editor.pushUndoStop();
      });
      a.push(o.resolve(l.token).then(() => {
        if (!o.completion.additionalTextEdits || l.token.isCancellationRequested)
          return;
        if (p && o.completion.additionalTextEdits.some((S) => ve.isBefore(p, V.getStartPosition(S.range))))
          return !1;
        b && this.editor.pushUndoStop();
        const y = ud.capture(this.editor);
        return this.editor.executeEdits("suggestController.additionalTextEdits.async", o.completion.additionalTextEdits.map((S) => Si.replaceMove(V.lift(S.range), S.text))), y.restoreRelativeVerticalPositionOfCursor(this.editor), (b || !(_ & 2)) && this.editor.pushUndoStop(), !0;
      }).then((y) => {
        this._logService.trace("[suggest] async resolving of edits DONE (ms, applied?)", g.elapsed(), y), h = y === !0 ? 1 : y === !1 ? 0 : -2;
      }).finally(() => {
        m.dispose(), w.dispose();
      }));
    }
    let { insertText: f } = o.completion;
    if (o.completion.insertTextRules & 4 || (f = q_.escape(f)), this.model.cancel(), n.insert(f, {
      overwriteBefore: c.overwriteBefore,
      overwriteAfter: c.overwriteAfter,
      undoStopBefore: !1,
      undoStopAfter: !1,
      adjustWhitespace: !(o.completion.insertTextRules & 1),
      clipboardText: e.model.clipboardText,
      overtypingCapturer: this._overtypingCapturer.value
    }), t & 2 || this.editor.pushUndoStop(), o.completion.command)
      if (o.completion.command.id === ix.id)
        this.model.trigger({ auto: !0, retrigger: !0 });
      else {
        const g = new Vs();
        a.push(this._commandService.executeCommand(o.completion.command.id, ...o.completion.command.arguments ? [...o.completion.command.arguments] : []).catch((p) => {
          o.completion.extensionId ? vr(p) : It(p);
        }).finally(() => {
          u = g.elapsed();
        }));
      }
    t & 4 && this._alternatives.value.set(e, (g) => {
      for (l.cancel(); r.canUndo(); ) {
        s !== r.getAlternativeVersionId() && r.undo(), this._insertSuggestion(g, 3 | (t & 8 ? 8 : 0));
        break;
      }
    }), this._alertCompletionItem(o), Promise.all(a).finally(() => {
      this._reportSuggestionAcceptedTelemetry(o, r, d, u, h), this.model.clear(), l.dispose();
    });
  }
  _reportSuggestionAcceptedTelemetry(e, t, n, r, s) {
    var o, a, l;
    Math.floor(Math.random() * 100) !== 0 && this._telemetryService.publicLog2("suggest.acceptedSuggestion", {
      extensionId: (a = (o = e.extensionId) === null || o === void 0 ? void 0 : o.value) !== null && a !== void 0 ? a : "unknown",
      providerId: (l = e.provider._debugDisplayName) !== null && l !== void 0 ? l : "unknown",
      kind: e.completion.kind,
      basenameHash: dfe(xl(t.uri)).toString(16),
      languageId: t.getLanguageId(),
      fileExtension: UBe(t.uri),
      resolveInfo: e.provider.resolveCompletionItem ? n ? 1 : 0 : -1,
      resolveDuration: e.resolveDuration,
      commandDuration: r,
      additionalEditsAsync: s
    });
  }
  getOverwriteInfo(e, t) {
    On(this.editor.hasModel());
    let n = this.editor.getOption(
      117
      /* EditorOption.suggest */
    ).insertMode === "replace";
    t && (n = !n);
    const r = e.position.column - e.editStart.column, s = (n ? e.editReplaceEnd.column : e.editInsertEnd.column) - e.position.column, o = this.editor.getPosition().column - e.position.column, a = this._lineSuffix.value ? this._lineSuffix.value.delta(this.editor.getPosition()) : 0;
    return {
      overwriteBefore: r + o,
      overwriteAfter: s + a
    };
  }
  _alertCompletionItem(e) {
    if (Bs(e.completion.additionalTextEdits)) {
      const t = C("aria.alert.snippet", "Accepting '{0}' made {1} additional edits", e.textLabel, e.completion.additionalTextEdits.length);
      Fs(t);
    }
  }
  triggerSuggest(e, t, n) {
    this.editor.hasModel() && (this.model.trigger({
      auto: t ?? !1,
      completionOptions: { providerFilter: e, kindFilter: n ? /* @__PURE__ */ new Set() : void 0 }
    }), this.editor.revealPosition(
      this.editor.getPosition(),
      0
      /* ScrollType.Smooth */
    ), this.editor.focus());
  }
  triggerSuggestAndAcceptBest(e) {
    if (!this.editor.hasModel())
      return;
    const t = this.editor.getPosition(), n = () => {
      t.equals(this.editor.getPosition()) && this._commandService.executeCommand(e.fallback);
    }, r = (s) => {
      if (s.completion.insertTextRules & 4 || s.completion.additionalTextEdits)
        return !0;
      const o = this.editor.getPosition(), a = s.editStart.column, l = o.column;
      return l - a !== s.completion.insertText.length ? !0 : this.editor.getModel().getValueInRange({
        startLineNumber: o.lineNumber,
        startColumn: a,
        endLineNumber: o.lineNumber,
        endColumn: l
      }) !== s.completion.insertText;
    };
    qe.once(this.model.onDidTrigger)((s) => {
      const o = [];
      qe.any(this.model.onDidTrigger, this.model.onDidCancel)(() => {
        An(o), n();
      }, void 0, o), this.model.onDidSuggest(({ completionModel: a }) => {
        if (An(o), a.items.length === 0) {
          n();
          return;
        }
        const l = this._memoryService.select(this.editor.getModel(), this.editor.getPosition(), a.items), c = a.items[l];
        if (!r(c)) {
          n();
          return;
        }
        this.editor.pushUndoStop(), this._insertSuggestion(
          { index: l, item: c, model: a },
          7
          /* InsertFlags.NoAfterUndoStop */
        );
      }, void 0, o);
    }), this.model.trigger({ auto: !1, shy: !0 }), this.editor.revealPosition(
      t,
      0
      /* ScrollType.Smooth */
    ), this.editor.focus();
  }
  acceptSelectedSuggestion(e, t) {
    const n = this.widget.value.getFocusedItem();
    let r = 0;
    e && (r |= 4), t && (r |= 8), this._insertSuggestion(n, r);
  }
  acceptNextSuggestion() {
    this._alternatives.value.next();
  }
  acceptPrevSuggestion() {
    this._alternatives.value.prev();
  }
  cancelSuggestWidget() {
    this.model.cancel(), this.model.clear(), this.widget.value.hideWidget();
  }
  focusSuggestion() {
    this.widget.value.focusSelected();
  }
  selectNextSuggestion() {
    this.widget.value.selectNext();
  }
  selectNextPageSuggestion() {
    this.widget.value.selectNextPage();
  }
  selectLastSuggestion() {
    this.widget.value.selectLast();
  }
  selectPrevSuggestion() {
    this.widget.value.selectPrevious();
  }
  selectPrevPageSuggestion() {
    this.widget.value.selectPreviousPage();
  }
  selectFirstSuggestion() {
    this.widget.value.selectFirst();
  }
  toggleSuggestionDetails() {
    this.widget.value.toggleDetails();
  }
  toggleExplainMode() {
    this.widget.value.toggleExplainMode();
  }
  toggleSuggestionFocus() {
    this.widget.value.toggleDetailsFocus();
  }
  resetWidgetSize() {
    this.widget.value.resetPersistedSize();
  }
  forceRenderingAbove() {
    this.widget.value.forceRenderingAbove();
  }
  stopForceRenderingAbove() {
    this.widget.isInitialized && this.widget.value.stopForceRenderingAbove();
  }
  registerSelector(e) {
    return this._selectors.register(e);
  }
};
Kl.ID = "editor.contrib.suggestController";
Kl = TH = Sit([
  x1(1, T5),
  x1(2, Ui),
  x1(3, yt),
  x1(4, bt),
  x1(5, Ka),
  x1(6, qa)
], Kl);
class Dit {
  constructor(e) {
    this.prioritySelector = e, this._items = new Array();
  }
  register(e) {
    if (this._items.indexOf(e) !== -1)
      throw new Error("Value is already registered");
    return this._items.push(e), this._items.sort((t, n) => this.prioritySelector(n) - this.prioritySelector(t)), {
      dispose: () => {
        const t = this._items.indexOf(e);
        t >= 0 && this._items.splice(t, 1);
      }
    };
  }
  get itemsOrderedByPriorityDesc() {
    return this._items;
  }
}
class ix extends Je {
  constructor() {
    super({
      id: ix.id,
      label: C("suggest.trigger.label", "Trigger Suggest"),
      alias: "Trigger Suggest",
      precondition: ke.and($.writable, $.hasCompletionItemProvider, kt.Visible.toNegated()),
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 2058,
        secondary: [
          2087
          /* KeyCode.KeyI */
        ],
        mac: { primary: 266, secondary: [
          521,
          2087
          /* KeyCode.KeyI */
        ] },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t, n) {
    const r = Kl.get(t);
    if (!r)
      return;
    let s;
    n && typeof n == "object" && n.auto === !0 && (s = !0), r.triggerSuggest(void 0, s, void 0);
  }
}
ix.id = "editor.action.triggerSuggest";
pn(
  Kl.ID,
  Kl,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
Be(ix);
const ja = 190, wo = Kr.bindToContribution(Kl.get);
ze(new wo({
  id: "acceptSelectedSuggestion",
  precondition: ke.and(kt.Visible, kt.HasFocusedSuggestion),
  handler(i) {
    i.acceptSelectedSuggestion(!0, !1);
  },
  kbOpts: [{
    // normal tab
    primary: 2,
    kbExpr: ke.and(kt.Visible, $.textInputFocus),
    weight: ja
  }, {
    // accept on enter has special rules
    primary: 3,
    kbExpr: ke.and(kt.Visible, $.textInputFocus, kt.AcceptSuggestionsOnEnter, kt.MakesTextEdit),
    weight: ja
  }],
  menuOpts: [{
    menuId: Eg,
    title: C("accept.insert", "Insert"),
    group: "left",
    order: 1,
    when: kt.HasInsertAndReplaceRange.toNegated()
  }, {
    menuId: Eg,
    title: C("accept.insert", "Insert"),
    group: "left",
    order: 1,
    when: ke.and(kt.HasInsertAndReplaceRange, kt.InsertMode.isEqualTo("insert"))
  }, {
    menuId: Eg,
    title: C("accept.replace", "Replace"),
    group: "left",
    order: 1,
    when: ke.and(kt.HasInsertAndReplaceRange, kt.InsertMode.isEqualTo("replace"))
  }]
}));
ze(new wo({
  id: "acceptAlternativeSelectedSuggestion",
  precondition: ke.and(kt.Visible, $.textInputFocus, kt.HasFocusedSuggestion),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 1027,
    secondary: [
      1026
      /* KeyCode.Tab */
    ]
  },
  handler(i) {
    i.acceptSelectedSuggestion(!1, !0);
  },
  menuOpts: [{
    menuId: Eg,
    group: "left",
    order: 2,
    when: ke.and(kt.HasInsertAndReplaceRange, kt.InsertMode.isEqualTo("insert")),
    title: C("accept.replace", "Replace")
  }, {
    menuId: Eg,
    group: "left",
    order: 2,
    when: ke.and(kt.HasInsertAndReplaceRange, kt.InsertMode.isEqualTo("replace")),
    title: C("accept.insert", "Insert")
  }]
}));
on.registerCommandAlias("acceptSelectedSuggestionOnEnter", "acceptSelectedSuggestion");
ze(new wo({
  id: "hideSuggestWidget",
  precondition: kt.Visible,
  handler: (i) => i.cancelSuggestWidget(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 9,
    secondary: [
      1033
      /* KeyCode.Escape */
    ]
  }
}));
ze(new wo({
  id: "selectNextSuggestion",
  precondition: ke.and(kt.Visible, ke.or(kt.MultipleSuggestions, kt.HasFocusedSuggestion.negate())),
  handler: (i) => i.selectNextSuggestion(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 18,
    secondary: [
      2066
      /* KeyCode.DownArrow */
    ],
    mac: { primary: 18, secondary: [
      2066,
      300
      /* KeyCode.KeyN */
    ] }
  }
}));
ze(new wo({
  id: "selectNextPageSuggestion",
  precondition: ke.and(kt.Visible, ke.or(kt.MultipleSuggestions, kt.HasFocusedSuggestion.negate())),
  handler: (i) => i.selectNextPageSuggestion(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 12,
    secondary: [
      2060
      /* KeyCode.PageDown */
    ]
  }
}));
ze(new wo({
  id: "selectLastSuggestion",
  precondition: ke.and(kt.Visible, ke.or(kt.MultipleSuggestions, kt.HasFocusedSuggestion.negate())),
  handler: (i) => i.selectLastSuggestion()
}));
ze(new wo({
  id: "selectPrevSuggestion",
  precondition: ke.and(kt.Visible, ke.or(kt.MultipleSuggestions, kt.HasFocusedSuggestion.negate())),
  handler: (i) => i.selectPrevSuggestion(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 16,
    secondary: [
      2064
      /* KeyCode.UpArrow */
    ],
    mac: { primary: 16, secondary: [
      2064,
      302
      /* KeyCode.KeyP */
    ] }
  }
}));
ze(new wo({
  id: "selectPrevPageSuggestion",
  precondition: ke.and(kt.Visible, ke.or(kt.MultipleSuggestions, kt.HasFocusedSuggestion.negate())),
  handler: (i) => i.selectPrevPageSuggestion(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 11,
    secondary: [
      2059
      /* KeyCode.PageUp */
    ]
  }
}));
ze(new wo({
  id: "selectFirstSuggestion",
  precondition: ke.and(kt.Visible, ke.or(kt.MultipleSuggestions, kt.HasFocusedSuggestion.negate())),
  handler: (i) => i.selectFirstSuggestion()
}));
ze(new wo({
  id: "focusSuggestion",
  precondition: ke.and(kt.Visible, kt.HasFocusedSuggestion.negate()),
  handler: (i) => i.focusSuggestion(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 2058,
    secondary: [
      2087
      /* KeyCode.KeyI */
    ],
    mac: { primary: 266, secondary: [
      2087
      /* KeyCode.KeyI */
    ] }
  }
}));
ze(new wo({
  id: "focusAndAcceptSuggestion",
  precondition: ke.and(kt.Visible, kt.HasFocusedSuggestion.negate()),
  handler: (i) => {
    i.focusSuggestion(), i.acceptSelectedSuggestion(!0, !1);
  }
}));
ze(new wo({
  id: "toggleSuggestionDetails",
  precondition: ke.and(kt.Visible, kt.HasFocusedSuggestion),
  handler: (i) => i.toggleSuggestionDetails(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 2058,
    secondary: [
      2087
      /* KeyCode.KeyI */
    ],
    mac: { primary: 266, secondary: [
      2087
      /* KeyCode.KeyI */
    ] }
  },
  menuOpts: [{
    menuId: Eg,
    group: "right",
    order: 1,
    when: ke.and(kt.DetailsVisible, kt.CanResolve),
    title: C("detail.more", "show less")
  }, {
    menuId: Eg,
    group: "right",
    order: 1,
    when: ke.and(kt.DetailsVisible.toNegated(), kt.CanResolve),
    title: C("detail.less", "show more")
  }]
}));
ze(new wo({
  id: "toggleExplainMode",
  precondition: kt.Visible,
  handler: (i) => i.toggleExplainMode(),
  kbOpts: {
    weight: 100,
    primary: 2138
  }
}));
ze(new wo({
  id: "toggleSuggestionFocus",
  precondition: kt.Visible,
  handler: (i) => i.toggleSuggestionFocus(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 2570,
    mac: {
      primary: 778
      /* KeyCode.Space */
    }
  }
}));
ze(new wo({
  id: "insertBestCompletion",
  precondition: ke.and($.textInputFocus, ke.equals("config.editor.tabCompletion", "on"), Rw.AtEnd, kt.Visible.toNegated(), g0.OtherSuggestions.toNegated(), us.InSnippetMode.toNegated()),
  handler: (i, e) => {
    i.triggerSuggestAndAcceptBest(ho(e) ? Object.assign({ fallback: "tab" }, e) : { fallback: "tab" });
  },
  kbOpts: {
    weight: ja,
    primary: 2
    /* KeyCode.Tab */
  }
}));
ze(new wo({
  id: "insertNextSuggestion",
  precondition: ke.and($.textInputFocus, ke.equals("config.editor.tabCompletion", "on"), g0.OtherSuggestions, kt.Visible.toNegated(), us.InSnippetMode.toNegated()),
  handler: (i) => i.acceptNextSuggestion(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 2
    /* KeyCode.Tab */
  }
}));
ze(new wo({
  id: "insertPrevSuggestion",
  precondition: ke.and($.textInputFocus, ke.equals("config.editor.tabCompletion", "on"), g0.OtherSuggestions, kt.Visible.toNegated(), us.InSnippetMode.toNegated()),
  handler: (i) => i.acceptPrevSuggestion(),
  kbOpts: {
    weight: ja,
    kbExpr: $.textInputFocus,
    primary: 1026
    /* KeyCode.Tab */
  }
}));
Be(class extends Je {
  constructor() {
    super({
      id: "editor.action.resetSuggestSize",
      label: C("suggest.reset.label", "Reset Suggest Widget Size"),
      alias: "Reset Suggest Widget Size",
      precondition: void 0
    });
  }
  run(i, e) {
    var t;
    (t = Kl.get(e)) === null || t === void 0 || t.resetWidgetSize();
  }
});
class Eit extends we {
  get selectedItem() {
    return this._selectedItem;
  }
  constructor(e, t, n, r) {
    super(), this.editor = e, this.suggestControllerPreselector = t, this.checkModelVersion = n, this.onWillAccept = r, this.isSuggestWidgetVisible = !1, this.isShiftKeyPressed = !1, this._isActive = !1, this._currentSuggestItemInfo = void 0, this._selectedItem = Yn(this, void 0), this._register(e.onKeyDown((o) => {
      o.shiftKey && !this.isShiftKeyPressed && (this.isShiftKeyPressed = !0, this.update(this._isActive));
    })), this._register(e.onKeyUp((o) => {
      o.shiftKey && this.isShiftKeyPressed && (this.isShiftKeyPressed = !1, this.update(this._isActive));
    }));
    const s = Kl.get(this.editor);
    if (s) {
      this._register(s.registerSelector({
        priority: 100,
        select: (l, c, d) => {
          var u;
          di((_) => this.checkModelVersion(_));
          const h = this.editor.getModel();
          if (!h)
            return -1;
          const f = (u = this.suggestControllerPreselector()) === null || u === void 0 ? void 0 : u.removeCommonPrefix(h);
          if (!f)
            return -1;
          const g = ve.lift(c), p = d.map((_, b) => {
            const y = KC.fromSuggestion(s, h, g, _, this.isShiftKeyPressed).toSingleTextEdit().removeCommonPrefix(h), S = f.augments(y);
            return { index: b, valid: S, prefixLength: y.text.length, suggestItem: _ };
          }).filter((_) => _ && _.valid && _.prefixLength > 0), m = ffe(p, hl((_) => _.prefixLength, Rh));
          return m ? m.index : -1;
        }
      }));
      let o = !1;
      const a = () => {
        o || (o = !0, this._register(s.widget.value.onDidShow(() => {
          this.isSuggestWidgetVisible = !0, this.update(!0);
        })), this._register(s.widget.value.onDidHide(() => {
          this.isSuggestWidgetVisible = !1, this.update(!1);
        })), this._register(s.widget.value.onDidFocus(() => {
          this.isSuggestWidgetVisible = !0, this.update(!0);
        })));
      };
      this._register(qe.once(s.model.onDidTrigger)((l) => {
        a();
      })), this._register(s.onWillInsertSuggestItem((l) => {
        const c = this.editor.getPosition(), d = this.editor.getModel();
        if (!c || !d)
          return;
        const u = KC.fromSuggestion(s, d, c, l.item, this.isShiftKeyPressed);
        this.onWillAccept(u);
      }));
    }
    this.update(this._isActive);
  }
  update(e) {
    const t = this.getSuggestItemInfo();
    (this._isActive !== e || !Lit(this._currentSuggestItemInfo, t)) && (this._isActive = e, this._currentSuggestItemInfo = t, di((n) => {
      this.checkModelVersion(n), this._selectedItem.set(this._isActive ? this._currentSuggestItemInfo : void 0, n);
    }));
  }
  getSuggestItemInfo() {
    const e = Kl.get(this.editor);
    if (!e || !this.isSuggestWidgetVisible)
      return;
    const t = e.widget.value.getFocusedItem(), n = this.editor.getPosition(), r = this.editor.getModel();
    if (!(!t || !n || !r))
      return KC.fromSuggestion(e, r, n, t.item, this.isShiftKeyPressed);
  }
  stopForceRenderingAbove() {
    const e = Kl.get(this.editor);
    e?.stopForceRenderingAbove();
  }
  forceRenderingAbove() {
    const e = Kl.get(this.editor);
    e?.forceRenderingAbove();
  }
}
class KC {
  static fromSuggestion(e, t, n, r, s) {
    let { insertText: o } = r.completion, a = !1;
    if (r.completion.insertTextRules & 4) {
      const c = new q_().parse(o);
      c.children.length < 100 && NI.adjustWhitespace(t, n, !0, c), o = c.toString(), a = !0;
    }
    const l = e.getOverwriteInfo(r, s);
    return new KC(V.fromPositions(n.delta(0, -l.overwriteBefore), n.delta(0, Math.max(l.overwriteAfter, 0))), o, r.completion.kind, a);
  }
  constructor(e, t, n, r) {
    this.range = e, this.insertText = t, this.completionItemKind = n, this.isSnippetText = r;
  }
  equals(e) {
    return this.range.equalsRange(e.range) && this.insertText === e.insertText && this.completionItemKind === e.completionItemKind && this.isSnippetText === e.isSnippetText;
  }
  toSelectedSuggestionInfo() {
    return new lhe(this.range, this.insertText, this.completionItemKind, this.isSnippetText);
  }
  toSingleTextEdit() {
    return new K_(this.range, this.insertText);
  }
}
function Lit(i, e) {
  return i === e ? !0 : !i || !e ? !1 : i.equals(e);
}
var Iit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, xf = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, NH;
let za = NH = class extends we {
  static get(e) {
    return e.getContribution(NH.ID);
  }
  constructor(e, t, n, r, s, o, a, l, c) {
    super(), this.editor = e, this.instantiationService = t, this.contextKeyService = n, this.configurationService = r, this.commandService = s, this.debounceService = o, this.languageFeaturesService = a, this.audioCueService = l, this._keybindingService = c, this.model = iI("inlineCompletionModel", void 0), this.textModelVersionId = Yn(this, -1), this.cursorPosition = Yn(this, new ve(1, 1)), this.suggestWidgetAdaptor = this._register(new Eit(this.editor, () => {
      var h, f;
      return (f = (h = this.model.get()) === null || h === void 0 ? void 0 : h.selectedInlineCompletion.get()) === null || f === void 0 ? void 0 : f.toSingleTextEdit(void 0);
    }, (h) => this.updateObservables(h, ya.Other), (h) => {
      di((f) => {
        var g;
        this.updateObservables(f, ya.Other), (g = this.model.get()) === null || g === void 0 || g.handleSuggestAccepted(h);
      });
    })), this._enabled = as(this.editor.onDidChangeConfiguration, () => this.editor.getOption(
      62
      /* EditorOption.inlineSuggest */
    ).enabled), this.ghostTextWidget = this._register(this.instantiationService.createInstance(wH, this.editor, {
      ghostText: this.model.map((h, f) => h?.ghostText.read(f)),
      minReservedLineCount: rI(0),
      targetTextModel: this.model.map((h) => h?.textModel)
    })), this._debounceValue = this.debounceService.for(this.languageFeaturesService.inlineCompletionsProvider, "InlineCompletionsDebounce", { min: 50, max: 50 }), this._register(new Ur(this.contextKeyService, this.model)), this._register(qe.runAndSubscribe(e.onDidChangeModel, () => di((h) => {
      this.model.set(void 0, h), this.updateObservables(h, ya.Other);
      const f = e.getModel();
      if (f) {
        const g = t.createInstance(xH, f, this.suggestWidgetAdaptor.selectedItem, this.cursorPosition, this.textModelVersionId, this._debounceValue, as(e.onDidChangeConfiguration, () => e.getOption(
          117
          /* EditorOption.suggest */
        ).preview), as(e.onDidChangeConfiguration, () => e.getOption(
          117
          /* EditorOption.suggest */
        ).previewMode), as(e.onDidChangeConfiguration, () => e.getOption(
          62
          /* EditorOption.inlineSuggest */
        ).mode), this._enabled);
        this.model.set(g, h);
      }
    })));
    const d = (h) => {
      var f;
      return h.isUndoing ? ya.Undo : h.isRedoing ? ya.Redo : !((f = this.model.get()) === null || f === void 0) && f.isAcceptingPartially ? ya.AcceptWord : ya.Other;
    };
    this._register(e.onDidChangeModelContent((h) => di((f) => (
      /** @description onDidChangeModelContent */
      this.updateObservables(f, d(h))
    )))), this._register(e.onDidChangeCursorPosition((h) => di((f) => {
      var g;
      this.updateObservables(f, ya.Other), (h.reason === 3 || h.source === "api") && ((g = this.model.get()) === null || g === void 0 || g.stop(f));
    }))), this._register(e.onDidType(() => di((h) => {
      var f;
      this.updateObservables(h, ya.Other), this._enabled.get() && ((f = this.model.get()) === null || f === void 0 || f.trigger(h));
    }))), this._register(this.commandService.onDidExecuteCommand((h) => {
      (/* @__PURE__ */ new Set([
        Bv.Tab.id,
        Bv.DeleteLeft.id,
        Bv.DeleteRight.id,
        s1e,
        "acceptSelectedSuggestion"
      ])).has(h.commandId) && e.hasTextFocus() && this._enabled.get() && di((g) => {
        var p;
        (p = this.model.get()) === null || p === void 0 || p.trigger(g);
      });
    })), this._register(this.editor.onDidBlurEditorWidget(() => {
      this.contextKeyService.getContextKeyValue("accessibleViewIsShown") || this.configurationService.getValue("editor.inlineSuggest.keepOnBlur") || e.getOption(
        62
        /* EditorOption.inlineSuggest */
      ).keepOnBlur || Jg.dropDownVisible || di((h) => {
        var f;
        (f = this.model.get()) === null || f === void 0 || f.stop(h);
      });
    })), this._register(zn((h) => {
      var f;
      const g = (f = this.model.read(h)) === null || f === void 0 ? void 0 : f.state.read(h);
      g?.suggestItem ? g.ghostText.lineCount >= 2 && this.suggestWidgetAdaptor.forceRenderingAbove() : this.suggestWidgetAdaptor.stopForceRenderingAbove();
    })), this._register(Ct(() => {
      this.suggestWidgetAdaptor.stopForceRenderingAbove();
    }));
    let u;
    this._register(zn((h) => {
      const f = this.model.read(h), g = f?.state.read(h);
      if (!f || !g || !g.inlineCompletion) {
        u = void 0;
        return;
      }
      if (g.inlineCompletion.semanticId !== u) {
        u = g.inlineCompletion.semanticId;
        const p = f.textModel.getLineContent(g.ghostText.lineNumber);
        this.audioCueService.playAudioCue(un.inlineSuggestion).then(() => {
          this.editor.getOption(
            8
            /* EditorOption.screenReaderAnnounceInlineSuggestion */
          ) && this.provideScreenReaderUpdate(g.ghostText.renderForScreenReader(p));
        });
      }
    })), this._register(new $V(this.editor, this.model, this.instantiationService)), this._register(this.configurationService.onDidChangeConfiguration((h) => {
      h.affectsConfiguration("accessibility.verbosity.inlineCompletions") && this.editor.updateOptions({ inlineCompletionsAccessibilityVerbose: this.configurationService.getValue("accessibility.verbosity.inlineCompletions") });
    })), this.editor.updateOptions({ inlineCompletionsAccessibilityVerbose: this.configurationService.getValue("accessibility.verbosity.inlineCompletions") });
  }
  provideScreenReaderUpdate(e) {
    const t = this.contextKeyService.getContextKeyValue("accessibleViewIsShown"), n = this._keybindingService.lookupKeybinding("editor.action.accessibleView");
    let r;
    !t && n && this.editor.getOption(
      147
      /* EditorOption.inlineCompletionsAccessibilityVerbose */
    ) && (r = C("showAccessibleViewHint", "Inspect this in the accessible view ({0})", n.getAriaLabel())), Fs(r ? e + ", " + r : e);
  }
  /**
   * Copies over the relevant state from the text model to observables.
   * This solves all kind of eventing issues, as we make sure we always operate on the latest state,
   * regardless of who calls into us.
   */
  updateObservables(e, t) {
    var n, r;
    const s = this.editor.getModel();
    this.textModelVersionId.set((n = s?.getVersionId()) !== null && n !== void 0 ? n : -1, e, t), this.cursorPosition.set((r = this.editor.getPosition()) !== null && r !== void 0 ? r : new ve(1, 1), e);
  }
  shouldShowHoverAt(e) {
    var t;
    const n = (t = this.model.get()) === null || t === void 0 ? void 0 : t.ghostText.get();
    return n ? n.parts.some((r) => e.containsPosition(new ve(n.lineNumber, r.column))) : !1;
  }
  shouldShowHoverAtViewZone(e) {
    return this.ghostTextWidget.ownsViewZone(e);
  }
};
za.ID = "editor.contrib.inlineCompletionsController";
za = NH = Iit([
  xf(1, bt),
  xf(2, yt),
  xf(3, en),
  xf(4, Ui),
  xf(5, kl),
  xf(6, tt),
  xf(7, GS),
  xf(8, Bn)
], za);
var gp = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class P5 extends Je {
  constructor() {
    super({
      id: P5.ID,
      label: C("action.inlineSuggest.showNext", "Show Next Inline Suggestion"),
      alias: "Show Next Inline Suggestion",
      precondition: ke.and($.writable, Ur.inlineSuggestionVisible),
      kbOpts: {
        weight: 100,
        primary: 606
      }
    });
  }
  run(e, t) {
    var n;
    return gp(this, void 0, void 0, function* () {
      const r = za.get(t);
      (n = r?.model.get()) === null || n === void 0 || n.next();
    });
  }
}
P5.ID = a1e;
class O5 extends Je {
  constructor() {
    super({
      id: O5.ID,
      label: C("action.inlineSuggest.showPrevious", "Show Previous Inline Suggestion"),
      alias: "Show Previous Inline Suggestion",
      precondition: ke.and($.writable, Ur.inlineSuggestionVisible),
      kbOpts: {
        weight: 100,
        primary: 604
      }
    });
  }
  run(e, t) {
    var n;
    return gp(this, void 0, void 0, function* () {
      const r = za.get(t);
      (n = r?.model.get()) === null || n === void 0 || n.previous();
    });
  }
}
O5.ID = o1e;
class Ait extends Je {
  constructor() {
    super({
      id: "editor.action.inlineSuggest.trigger",
      label: C("action.inlineSuggest.trigger", "Trigger Inline Suggestion"),
      alias: "Trigger Inline Suggestion",
      precondition: $.writable
    });
  }
  run(e, t) {
    var n;
    return gp(this, void 0, void 0, function* () {
      const r = za.get(t);
      (n = r?.model.get()) === null || n === void 0 || n.triggerExplicitly();
    });
  }
}
class kit extends Je {
  constructor() {
    super({
      id: "editor.action.inlineSuggest.acceptNextWord",
      label: C("action.inlineSuggest.acceptNextWord", "Accept Next Word Of Inline Suggestion"),
      alias: "Accept Next Word Of Inline Suggestion",
      precondition: ke.and($.writable, Ur.inlineSuggestionVisible),
      kbOpts: {
        weight: 101,
        primary: 2065,
        kbExpr: ke.and($.writable, Ur.inlineSuggestionVisible)
      },
      menuOpts: [{
        menuId: J.InlineSuggestionToolbar,
        title: C("acceptWord", "Accept Word"),
        group: "primary",
        order: 2
      }]
    });
  }
  run(e, t) {
    var n;
    return gp(this, void 0, void 0, function* () {
      const r = za.get(t);
      yield (n = r?.model.get()) === null || n === void 0 ? void 0 : n.acceptNextWord(r.editor);
    });
  }
}
class Tit extends Je {
  constructor() {
    super({
      id: "editor.action.inlineSuggest.acceptNextLine",
      label: C("action.inlineSuggest.acceptNextLine", "Accept Next Line Of Inline Suggestion"),
      alias: "Accept Next Line Of Inline Suggestion",
      precondition: ke.and($.writable, Ur.inlineSuggestionVisible),
      kbOpts: {
        weight: 101
      },
      menuOpts: [{
        menuId: J.InlineSuggestionToolbar,
        title: C("acceptLine", "Accept Line"),
        group: "secondary",
        order: 2
      }]
    });
  }
  run(e, t) {
    var n;
    return gp(this, void 0, void 0, function* () {
      const r = za.get(t);
      yield (n = r?.model.get()) === null || n === void 0 ? void 0 : n.acceptNextLine(r.editor);
    });
  }
}
class Nit extends Je {
  constructor() {
    super({
      id: s1e,
      label: C("action.inlineSuggest.accept", "Accept Inline Suggestion"),
      alias: "Accept Inline Suggestion",
      precondition: Ur.inlineSuggestionVisible,
      menuOpts: [{
        menuId: J.InlineSuggestionToolbar,
        title: C("accept", "Accept"),
        group: "primary",
        order: 1
      }],
      kbOpts: {
        primary: 2,
        weight: 200,
        kbExpr: ke.and(Ur.inlineSuggestionVisible, $.tabMovesFocus.toNegated(), Ur.inlineSuggestionHasIndentationLessThanTabSize, kt.Visible.toNegated(), $.hoverFocused.toNegated())
      }
    });
  }
  run(e, t) {
    var n;
    return gp(this, void 0, void 0, function* () {
      const r = za.get(t);
      r && ((n = r.model.get()) === null || n === void 0 || n.accept(r.editor), r.editor.focus());
    });
  }
}
class M5 extends Je {
  constructor() {
    super({
      id: M5.ID,
      label: C("action.inlineSuggest.hide", "Hide Inline Suggestion"),
      alias: "Hide Inline Suggestion",
      precondition: Ur.inlineSuggestionVisible,
      kbOpts: {
        weight: 100,
        primary: 9
      }
    });
  }
  run(e, t) {
    return gp(this, void 0, void 0, function* () {
      const n = za.get(t);
      di((r) => {
        var s;
        (s = n?.model.get()) === null || s === void 0 || s.stop(r);
      });
    });
  }
}
M5.ID = "editor.action.inlineSuggest.hide";
class R5 extends Ga {
  constructor() {
    super({
      id: R5.ID,
      title: C("action.inlineSuggest.alwaysShowToolbar", "Always Show Toolbar"),
      f1: !1,
      precondition: void 0,
      menu: [{
        id: J.InlineSuggestionToolbar,
        group: "secondary",
        order: 10
      }],
      toggled: ke.equals("config.editor.inlineSuggest.showToolbar", "always")
    });
  }
  run(e, t) {
    return gp(this, void 0, void 0, function* () {
      const n = e.get(en), s = n.getValue("editor.inlineSuggest.showToolbar") === "always" ? "onHover" : "always";
      n.updateValue("editor.inlineSuggest.showToolbar", s);
    });
  }
}
R5.ID = "editor.action.inlineSuggest.toggleAlwaysShowToolbar";
var Pit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, S2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class Oit {
  constructor(e, t, n) {
    this.owner = e, this.range = t, this.controller = n;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let PH = class {
  constructor(e, t, n, r, s, o) {
    this._editor = e, this._languageService = t, this._openerService = n, this.accessibilityService = r, this._instantiationService = s, this._telemetryService = o, this.hoverOrdinal = 4;
  }
  suggestHoverAnchor(e) {
    const t = za.get(this._editor);
    if (!t)
      return null;
    const n = e.target;
    if (n.type === 8) {
      const r = n.detail;
      if (t.shouldShowHoverAtViewZone(r.viewZoneId))
        return new aE(1e3, this, V.fromPositions(this._editor.getModel().validatePosition(r.positionBefore || r.position)), e.event.posx, e.event.posy, !1);
    }
    return n.type === 7 && t.shouldShowHoverAt(n.range) ? new aE(1e3, this, n.range, e.event.posx, e.event.posy, !1) : n.type === 6 && n.detail.mightBeForeignElement && t.shouldShowHoverAt(n.range) ? new aE(1e3, this, n.range, e.event.posx, e.event.posy, !1) : null;
  }
  computeSync(e, t) {
    if (this._editor.getOption(
      62
      /* EditorOption.inlineSuggest */
    ).showToolbar === "always")
      return [];
    const n = za.get(this._editor);
    return n && n.shouldShowHoverAt(e.range) ? [new Oit(this, e.range, n)] : [];
  }
  renderHoverParts(e, t) {
    const n = new Ne(), r = t[0];
    this._telemetryService.publicLog2("inlineCompletionHover.shown"), this.accessibilityService.isScreenReaderOptimized() && !this._editor.getOption(
      8
      /* EditorOption.screenReaderAnnounceInlineSuggestion */
    ) && this.renderScreenReaderText(e, r, n);
    const s = r.controller.model.get(), o = this._instantiationService.createInstance(Jg, this._editor, !1, rI(null), s.selectedInlineCompletionIndex, s.inlineCompletionsCount, s.selectedInlineCompletion.map((a) => {
      var l;
      return (l = a?.inlineCompletion.source.inlineCompletions.commands) !== null && l !== void 0 ? l : [];
    }));
    return e.fragment.appendChild(o.getDomNode()), s.triggerExplicitly(), n.add(o), n;
  }
  renderScreenReaderText(e, t, n) {
    const r = Re, s = r("div.hover-row.markdown-hover"), o = Te(s, r("div.hover-contents", { "aria-live": "assertive" })), a = n.add(new $h({ editor: this._editor }, this._languageService, this._openerService)), l = (c) => {
      n.add(a.onDidRenderAsync(() => {
        o.className = "hover-contents code-hover-contents", e.onContentsChanged();
      }));
      const d = C("inlineSuggestionFollows", "Suggestion:"), u = n.add(a.render(new ys().appendText(d).appendCodeblock("text", c)));
      o.replaceChildren(u.element);
    };
    n.add(zn((c) => {
      var d;
      const u = (d = t.controller.model.read(c)) === null || d === void 0 ? void 0 : d.ghostText.read(c);
      if (u) {
        const h = this._editor.getModel().getLineContent(u.lineNumber);
        l(u.renderForScreenReader(h));
      } else
        cs(o);
    })), e.fragment.appendChild(s);
  }
};
PH = Pit([
  S2(1, ci),
  S2(2, da),
  S2(3, lf),
  S2(4, bt),
  S2(5, qa)
], PH);
pn(
  za.ID,
  za,
  3
  /* EditorContributionInstantiation.Eventually */
);
Be(Ait);
Be(P5);
Be(O5);
Be(kit);
Be(Tit);
Be(Nit);
Be(M5);
oi(R5);
K0.register(PH);
function Go(i, e) {
  let t = 0;
  for (let n = 0; n < i.length; n++)
    i.charAt(n) === "	" ? t += e : t++;
  return t;
}
function YC(i, e, t) {
  i = i < 0 ? 0 : i;
  let n = "";
  if (!t) {
    const r = Math.floor(i / e);
    i = i % e;
    for (let s = 0; s < r; s++)
      n += "	";
  }
  for (let r = 0; r < i; r++)
    n += " ";
  return n;
}
var Mit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Rit = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function Y1e(i, e, t, n, r) {
  if (i.getLineCount() === 1 && i.getLineMaxColumn(1) === 1)
    return [];
  const s = e.getLanguageConfiguration(i.getLanguageId()).indentationRules;
  if (!s)
    return [];
  for (n = Math.min(n, i.getLineCount()); t <= n && s.unIndentedLinePattern; ) {
    const m = i.getLineContent(t);
    if (!s.unIndentedLinePattern.test(m))
      break;
    t++;
  }
  if (t > n - 1)
    return [];
  const { tabSize: o, indentSize: a, insertSpaces: l } = i.getOptions(), c = (m, _) => (_ = _ || 1, ol.shiftIndent(m, m.length + _, o, a, l)), d = (m, _) => (_ = _ || 1, ol.unshiftIndent(m, m.length + _, o, a, l)), u = [];
  let h;
  const f = i.getLineContent(t);
  let g = f;
  h = Hn(f);
  let p = h;
  s.increaseIndentPattern && s.increaseIndentPattern.test(g) ? (p = c(p), h = c(h)) : s.indentNextLinePattern && s.indentNextLinePattern.test(g) && (p = c(p)), t++;
  for (let m = t; m <= n; m++) {
    const _ = i.getLineContent(m), b = Hn(_), w = p + _.substring(b.length);
    s.decreaseIndentPattern && s.decreaseIndentPattern.test(w) && (p = d(p), h = d(h)), b !== p && u.push(Si.replaceMove(new ot(m, 1, m, b.length + 1), xz(p, a, l))), !(s.unIndentedLinePattern && s.unIndentedLinePattern.test(_)) && (s.increaseIndentPattern && s.increaseIndentPattern.test(w) ? (h = c(h), p = h) : s.indentNextLinePattern && s.indentNextLinePattern.test(w) ? p = c(p) : p = h);
  }
  return u;
}
class F5 extends Je {
  constructor() {
    super({
      id: F5.ID,
      label: C("indentationToSpaces", "Convert Indentation to Spaces"),
      alias: "Convert Indentation to Spaces",
      precondition: $.writable
    });
  }
  run(e, t) {
    const n = t.getModel();
    if (!n)
      return;
    const r = n.getOptions(), s = t.getSelection();
    if (!s)
      return;
    const o = new Hit(s, r.tabSize);
    t.pushUndoStop(), t.executeCommands(this.id, [o]), t.pushUndoStop(), n.updateOptions({
      insertSpaces: !0
    });
  }
}
F5.ID = "editor.action.indentationToSpaces";
class B5 extends Je {
  constructor() {
    super({
      id: B5.ID,
      label: C("indentationToTabs", "Convert Indentation to Tabs"),
      alias: "Convert Indentation to Tabs",
      precondition: $.writable
    });
  }
  run(e, t) {
    const n = t.getModel();
    if (!n)
      return;
    const r = n.getOptions(), s = t.getSelection();
    if (!s)
      return;
    const o = new Wit(s, r.tabSize);
    t.pushUndoStop(), t.executeCommands(this.id, [o]), t.pushUndoStop(), n.updateOptions({
      insertSpaces: !1
    });
  }
}
B5.ID = "editor.action.indentationToTabs";
class NG extends Je {
  constructor(e, t, n) {
    super(n), this.insertSpaces = e, this.displaySizeOnly = t;
  }
  run(e, t) {
    const n = e.get(bd), r = e.get(fi), s = t.getModel();
    if (!s)
      return;
    const o = r.getCreationOptions(s.getLanguageId(), s.uri, s.isForSimpleWidget), a = s.getOptions(), l = [1, 2, 3, 4, 5, 6, 7, 8].map((d) => ({
      id: d.toString(),
      label: d.toString(),
      // add description for tabSize value set in the configuration
      description: d === o.tabSize && d === a.tabSize ? C("configuredTabSize", "Configured Tab Size") : d === o.tabSize ? C("defaultTabSize", "Default Tab Size") : d === a.tabSize ? C("currentTabSize", "Current Tab Size") : void 0
    })), c = Math.min(s.getOptions().tabSize - 1, 7);
    setTimeout(
      () => {
        n.pick(l, { placeHolder: C({ key: "selectTabWidth", comment: ["Tab corresponds to the tab key"] }, "Select Tab Size for Current File"), activeItem: l[c] }).then((d) => {
          if (d && s && !s.isDisposed()) {
            const u = parseInt(d.label, 10);
            this.displaySizeOnly ? s.updateOptions({
              tabSize: u
            }) : s.updateOptions({
              tabSize: u,
              indentSize: u,
              insertSpaces: this.insertSpaces
            });
          }
        });
      },
      50
      /* quick input is sensitive to being opened so soon after another */
    );
  }
}
class V5 extends NG {
  constructor() {
    super(!1, !1, {
      id: V5.ID,
      label: C("indentUsingTabs", "Indent Using Tabs"),
      alias: "Indent Using Tabs",
      precondition: void 0
    });
  }
}
V5.ID = "editor.action.indentUsingTabs";
class H5 extends NG {
  constructor() {
    super(!0, !1, {
      id: H5.ID,
      label: C("indentUsingSpaces", "Indent Using Spaces"),
      alias: "Indent Using Spaces",
      precondition: void 0
    });
  }
}
H5.ID = "editor.action.indentUsingSpaces";
class W5 extends NG {
  constructor() {
    super(!0, !0, {
      id: W5.ID,
      label: C("changeTabDisplaySize", "Change Tab Display Size"),
      alias: "Change Tab Display Size",
      precondition: void 0
    });
  }
}
W5.ID = "editor.action.changeTabDisplaySize";
class j5 extends Je {
  constructor() {
    super({
      id: j5.ID,
      label: C("detectIndentation", "Detect Indentation from Content"),
      alias: "Detect Indentation from Content",
      precondition: void 0
    });
  }
  run(e, t) {
    const n = e.get(fi), r = t.getModel();
    if (!r)
      return;
    const s = n.getCreationOptions(r.getLanguageId(), r.uri, r.isForSimpleWidget);
    r.detectIndentation(s.insertSpaces, s.tabSize);
  }
}
j5.ID = "editor.action.detectIndentation";
class Fit extends Je {
  constructor() {
    super({
      id: "editor.action.reindentlines",
      label: C("editor.reindentlines", "Reindent Lines"),
      alias: "Reindent Lines",
      precondition: $.writable
    });
  }
  run(e, t) {
    const n = e.get(Un), r = t.getModel();
    if (!r)
      return;
    const s = Y1e(r, n, 1, r.getLineCount());
    s.length > 0 && (t.pushUndoStop(), t.executeEdits(this.id, s), t.pushUndoStop());
  }
}
class Bit extends Je {
  constructor() {
    super({
      id: "editor.action.reindentselectedlines",
      label: C("editor.reindentselectedlines", "Reindent Selected Lines"),
      alias: "Reindent Selected Lines",
      precondition: $.writable
    });
  }
  run(e, t) {
    const n = e.get(Un), r = t.getModel();
    if (!r)
      return;
    const s = t.getSelections();
    if (s === null)
      return;
    const o = [];
    for (const a of s) {
      let l = a.startLineNumber, c = a.endLineNumber;
      if (l !== c && a.endColumn === 1 && c--, l === 1) {
        if (l === c)
          continue;
      } else
        l--;
      const d = Y1e(r, n, l, c);
      o.push(...d);
    }
    o.length > 0 && (t.pushUndoStop(), t.executeEdits(this.id, o), t.pushUndoStop());
  }
}
class Vit {
  constructor(e, t) {
    this._initialSelection = t, this._edits = [], this._selectionId = null;
    for (const n of e)
      n.range && typeof n.text == "string" && this._edits.push(n);
  }
  getEditOperations(e, t) {
    for (const r of this._edits)
      t.addEditOperation(V.lift(r.range), r.text);
    let n = !1;
    Array.isArray(this._edits) && this._edits.length === 1 && this._initialSelection.isEmpty() && (this._edits[0].range.startColumn === this._initialSelection.endColumn && this._edits[0].range.startLineNumber === this._initialSelection.endLineNumber ? (n = !0, this._selectionId = t.trackSelection(this._initialSelection, !0)) : this._edits[0].range.endColumn === this._initialSelection.startColumn && this._edits[0].range.endLineNumber === this._initialSelection.startLineNumber && (n = !0, this._selectionId = t.trackSelection(this._initialSelection, !1))), n || (this._selectionId = t.trackSelection(this._initialSelection));
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
let Bw = class {
  constructor(e, t) {
    this.editor = e, this._languageConfigurationService = t, this.callOnDispose = new Ne(), this.callOnModel = new Ne(), this.callOnDispose.add(e.onDidChangeConfiguration(() => this.update())), this.callOnDispose.add(e.onDidChangeModel(() => this.update())), this.callOnDispose.add(e.onDidChangeModelLanguage(() => this.update()));
  }
  update() {
    this.callOnModel.clear(), !(this.editor.getOption(
      12
      /* EditorOption.autoIndent */
    ) < 4 || this.editor.getOption(
      55
      /* EditorOption.formatOnPaste */
    )) && this.editor.hasModel() && this.callOnModel.add(this.editor.onDidPaste(({ range: e }) => {
      this.trigger(e);
    }));
  }
  trigger(e) {
    const t = this.editor.getSelections();
    if (t === null || t.length > 1)
      return;
    const n = this.editor.getModel();
    if (!n || !n.tokenization.isCheapToTokenize(e.getStartPosition().lineNumber))
      return;
    const r = this.editor.getOption(
      12
      /* EditorOption.autoIndent */
    ), { tabSize: s, indentSize: o, insertSpaces: a } = n.getOptions(), l = [], c = {
      shiftIndent: (f) => ol.shiftIndent(f, f.length + 1, s, o, a),
      unshiftIndent: (f) => ol.unshiftIndent(f, f.length + 1, s, o, a)
    };
    let d = e.startLineNumber;
    for (; d <= e.endLineNumber; ) {
      if (this.shouldIgnoreLine(n, d)) {
        d++;
        continue;
      }
      break;
    }
    if (d > e.endLineNumber)
      return;
    let u = n.getLineContent(d);
    if (!/\S/.test(u.substring(0, e.startColumn - 1))) {
      const f = EC(r, n, n.getLanguageId(), d, c, this._languageConfigurationService);
      if (f !== null) {
        const g = Hn(u), p = Go(f, s), m = Go(g, s);
        if (p !== m) {
          const _ = YC(p, s, a);
          l.push({
            range: new V(d, 1, d, g.length + 1),
            text: _
          }), u = _ + u.substr(g.length);
        } else {
          const _ = tge(n, d, this._languageConfigurationService);
          if (_ === 0 || _ === 8)
            return;
        }
      }
    }
    const h = d;
    for (; d < e.endLineNumber; ) {
      if (!/\S/.test(n.getLineContent(d + 1))) {
        d++;
        continue;
      }
      break;
    }
    if (d !== e.endLineNumber) {
      const g = EC(r, {
        tokenization: {
          getLineTokens: (p) => n.tokenization.getLineTokens(p),
          getLanguageId: () => n.getLanguageId(),
          getLanguageIdAtPosition: (p, m) => n.getLanguageIdAtPosition(p, m)
        },
        getLineContent: (p) => p === h ? u : n.getLineContent(p)
      }, n.getLanguageId(), d + 1, c, this._languageConfigurationService);
      if (g !== null) {
        const p = Go(g, s), m = Go(Hn(n.getLineContent(d + 1)), s);
        if (p !== m) {
          const _ = p - m;
          for (let b = d + 1; b <= e.endLineNumber; b++) {
            const w = n.getLineContent(b), y = Hn(w), x = Go(y, s) + _, D = YC(x, s, a);
            D !== y && l.push({
              range: new V(b, 1, b, y.length + 1),
              text: D
            });
          }
        }
      }
    }
    if (l.length > 0) {
      this.editor.pushUndoStop();
      const f = new Vit(l, this.editor.getSelection());
      this.editor.executeCommand("autoIndentOnPaste", f), this.editor.pushUndoStop();
    }
  }
  shouldIgnoreLine(e, t) {
    e.tokenization.forceTokenization(t);
    const n = e.getLineFirstNonWhitespaceColumn(t);
    if (n === 0)
      return !0;
    const r = e.tokenization.getLineTokens(t);
    if (r.getCount() > 0) {
      const s = r.findTokenIndexAtOffset(n);
      if (s >= 0 && r.getStandardTokenType(s) === 1)
        return !0;
    }
    return !1;
  }
  dispose() {
    this.callOnDispose.dispose(), this.callOnModel.dispose();
  }
};
Bw.ID = "editor.contrib.autoIndentOnPaste";
Bw = Mit([
  Rit(1, Un)
], Bw);
function X1e(i, e, t, n) {
  if (i.getLineCount() === 1 && i.getLineMaxColumn(1) === 1)
    return;
  let r = "";
  for (let o = 0; o < t; o++)
    r += " ";
  const s = new RegExp(r, "gi");
  for (let o = 1, a = i.getLineCount(); o <= a; o++) {
    let l = i.getLineFirstNonWhitespaceColumn(o);
    if (l === 0 && (l = i.getLineMaxColumn(o)), l === 1)
      continue;
    const c = new V(o, 1, o, l), d = i.getValueInRange(c), u = n ? d.replace(/\t/ig, r) : d.replace(s, "	");
    e.addEditOperation(c, u);
  }
}
class Hit {
  constructor(e, t) {
    this.selection = e, this.tabSize = t, this.selectionId = null;
  }
  getEditOperations(e, t) {
    this.selectionId = t.trackSelection(this.selection), X1e(e, t, this.tabSize, !0);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this.selectionId);
  }
}
class Wit {
  constructor(e, t) {
    this.selection = e, this.tabSize = t, this.selectionId = null;
  }
  getEditOperations(e, t) {
    this.selectionId = t.trackSelection(this.selection), X1e(e, t, this.tabSize, !1);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this.selectionId);
  }
}
pn(
  Bw.ID,
  Bw,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
Be(F5);
Be(B5);
Be(V5);
Be(H5);
Be(W5);
Be(j5);
Be(Fit);
Be(Bit);
var PI = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class Z1e {
  constructor(e, t) {
    this.range = e, this.direction = t;
  }
}
class PG {
  constructor(e, t, n) {
    this.hint = e, this.anchor = t, this.provider = n, this._isResolved = !1;
  }
  with(e) {
    const t = new PG(this.hint, e.anchor, this.provider);
    return t._isResolved = this._isResolved, t._currentResolve = this._currentResolve, t;
  }
  resolve(e) {
    return PI(this, void 0, void 0, function* () {
      if (typeof this.provider.resolveInlayHint == "function") {
        if (this._currentResolve)
          return yield this._currentResolve, e.isCancellationRequested ? void 0 : this.resolve(e);
        this._isResolved || (this._currentResolve = this._doResolve(e).finally(() => this._currentResolve = void 0)), yield this._currentResolve;
      }
    });
  }
  _doResolve(e) {
    var t, n;
    return PI(this, void 0, void 0, function* () {
      try {
        const r = yield Promise.resolve(this.provider.resolveInlayHint(this.hint, e));
        this.hint.tooltip = (t = r?.tooltip) !== null && t !== void 0 ? t : this.hint.tooltip, this.hint.label = (n = r?.label) !== null && n !== void 0 ? n : this.hint.label, this._isResolved = !0;
      } catch (r) {
        vr(r), this._isResolved = !1;
      }
    });
  }
}
class Vw {
  static create(e, t, n, r) {
    return PI(this, void 0, void 0, function* () {
      const s = [], o = e.ordered(t).reverse().map((a) => n.map((l) => PI(this, void 0, void 0, function* () {
        try {
          const c = yield a.provideInlayHints(t, l, r);
          c?.hints.length && s.push([c, a]);
        } catch (c) {
          vr(c);
        }
      })));
      if (yield Promise.all(o.flat()), r.isCancellationRequested || t.isDisposed())
        throw new op();
      return new Vw(n, s, t);
    });
  }
  constructor(e, t, n) {
    this._disposables = new Ne(), this.ranges = e, this.provider = /* @__PURE__ */ new Set();
    const r = [];
    for (const [s, o] of t) {
      this._disposables.add(s), this.provider.add(o);
      for (const a of s.hints) {
        const l = n.validatePosition(a.position);
        let c = "before";
        const d = Vw._getRangeAtPosition(n, l);
        let u;
        d.getStartPosition().isBefore(l) ? (u = V.fromPositions(d.getStartPosition(), l), c = "after") : (u = V.fromPositions(l, d.getEndPosition()), c = "before"), r.push(new PG(a, new Z1e(u, c), o));
      }
    }
    this.items = r.sort((s, o) => ve.compare(s.hint.position, o.hint.position));
  }
  dispose() {
    this._disposables.dispose();
  }
  static _getRangeAtPosition(e, t) {
    const n = t.lineNumber, r = e.getWordAtPosition(t);
    if (r)
      return new V(n, r.startColumn, n, r.endColumn);
    e.tokenization.tokenizeIfCheap(n);
    const s = e.tokenization.getLineTokens(n), o = t.column - 1, a = s.findTokenIndexAtOffset(o);
    let l = s.getStartOffset(a), c = s.getEndOffset(a);
    return c - l === 1 && (l === o && a > 1 ? (l = s.getStartOffset(a - 1), c = s.getEndOffset(a - 1)) : c === o && a < s.getCount() - 1 && (l = s.getStartOffset(a + 1), c = s.getEndOffset(a + 1))), new V(n, l + 1, n, c + 1);
  }
}
function jit(i) {
  return pt.from({
    scheme: Mt.command,
    path: i.id,
    query: i.arguments && encodeURIComponent(JSON.stringify(i.arguments))
  }).toString();
}
var XC = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function zit(i, e, t, n) {
  var r;
  return XC(this, void 0, void 0, function* () {
    const s = i.get(Wo), o = i.get(gc), a = i.get(Ui), l = i.get(bt), c = i.get(dr);
    if (yield n.item.resolve(jt.None), !n.part.location)
      return;
    const d = n.part.location, u = [], h = new Set(os.getMenuItems(J.EditorContext).map((g) => Y1(g) ? g.command.id : C5()));
    for (const g of Xs.all())
      h.has(g.desc.id) && u.push(new vo(g.desc.id, sc.label(g.desc, { renderShortTitle: !0 }), void 0, !0, () => XC(this, void 0, void 0, function* () {
        const p = yield s.createModelReference(d.uri);
        try {
          const m = new H_(p.object.textEditorModel, V.getStartPosition(d.range)), _ = n.item.anchor.range;
          yield l.invokeFunction(g.runEditorCommand.bind(g), e, m, _);
        } finally {
          p.dispose();
        }
      })));
    if (n.part.command) {
      const { command: g } = n.part;
      u.push(new Gr()), u.push(new vo(g.id, g.title, void 0, !0, () => XC(this, void 0, void 0, function* () {
        var p;
        try {
          yield a.executeCommand(g.id, ...(p = g.arguments) !== null && p !== void 0 ? p : []);
        } catch (m) {
          c.notify({
            severity: I4.Error,
            source: n.item.provider.displayName,
            message: m
          });
        }
      })));
    }
    const f = e.getOption(
      126
      /* EditorOption.useShadowDOM */
    );
    o.showContextMenu({
      domForShadowRoot: f && (r = e.getDomNode()) !== null && r !== void 0 ? r : void 0,
      getAnchor: () => {
        const g = wr(t);
        return { x: g.left, y: g.top + g.height + 8 };
      },
      getActions: () => u,
      onHide: () => {
        e.focus();
      },
      autoSelectFirstItem: !0
    });
  });
}
function Q1e(i, e, t, n) {
  return XC(this, void 0, void 0, function* () {
    const s = yield i.get(Wo).createModelReference(n.uri);
    yield t.invokeWithinContext((o) => XC(this, void 0, void 0, function* () {
      const a = e.hasSideBySideModifier, l = o.get(yt), c = Vo.inPeekEditor.getValue(l), d = !a && t.getOption(
        87
        /* EditorOption.definitionLinkOpensInPeek */
      ) && !c;
      return new tx({ openToSide: a, openInPeek: d, muteMessage: !0 }, { title: { value: "", original: "" }, id: "", precondition: void 0 }).run(o, new H_(s.object.textEditorModel, V.getStartPosition(n.range)), V.lift(n.range));
    })), s.dispose();
  });
}
var Uit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, D1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, W1 = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, uE;
class OI {
  constructor() {
    this._entries = new cp(50);
  }
  get(e) {
    const t = OI._key(e);
    return this._entries.get(t);
  }
  set(e, t) {
    const n = OI._key(e);
    this._entries.set(n, t);
  }
  static _key(e) {
    return `${e.uri.toString()}/${e.getVersionId()}`;
  }
}
const J1e = Gt("IInlayHintsCache");
an(
  J1e,
  OI,
  1
  /* InstantiationType.Delayed */
);
class OH {
  constructor(e, t) {
    this.item = e, this.index = t;
  }
  get part() {
    const e = this.item.hint.label;
    return typeof e == "string" ? { label: e } : e[this.index];
  }
}
class Git {
  constructor(e, t) {
    this.part = e, this.hasTriggerModifier = t;
  }
}
let p0 = uE = class {
  static get(e) {
    var t;
    return (t = e.getContribution(uE.ID)) !== null && t !== void 0 ? t : void 0;
  }
  constructor(e, t, n, r, s, o, a) {
    this._editor = e, this._languageFeaturesService = t, this._inlayHintsCache = r, this._commandService = s, this._notificationService = o, this._instaService = a, this._disposables = new Ne(), this._sessionDisposables = new Ne(), this._decorationsMetadata = /* @__PURE__ */ new Map(), this._ruleFactory = new IS(this._editor), this._activeRenderMode = 0, this._debounceInfo = n.for(t.inlayHintsProvider, "InlayHint", { min: 25 }), this._disposables.add(t.inlayHintsProvider.onDidChange(() => this._update())), this._disposables.add(e.onDidChangeModel(() => this._update())), this._disposables.add(e.onDidChangeModelLanguage(() => this._update())), this._disposables.add(e.onDidChangeConfiguration((l) => {
      l.hasChanged(
        139
        /* EditorOption.inlayHints */
      ) && this._update();
    })), this._update();
  }
  dispose() {
    this._sessionDisposables.dispose(), this._removeAllDecorations(), this._disposables.dispose();
  }
  _update() {
    this._sessionDisposables.clear(), this._removeAllDecorations();
    const e = this._editor.getOption(
      139
      /* EditorOption.inlayHints */
    );
    if (e.enabled === "off")
      return;
    const t = this._editor.getModel();
    if (!t || !this._languageFeaturesService.inlayHintsProvider.has(t))
      return;
    const n = this._inlayHintsCache.get(t);
    n && this._updateHintsDecorators([t.getFullModelRange()], n), this._sessionDisposables.add(Ct(() => {
      t.isDisposed() || this._cacheHintsForFastRestore(t);
    }));
    let r;
    const s = /* @__PURE__ */ new Set(), o = new Rn(() => W1(this, void 0, void 0, function* () {
      const a = Date.now();
      r?.dispose(!0), r = new lr();
      const l = t.onWillDispose(() => r?.cancel());
      try {
        const c = r.token, d = yield Vw.create(this._languageFeaturesService.inlayHintsProvider, t, this._getHintsRanges(), c);
        if (o.delay = this._debounceInfo.update(t, Date.now() - a), c.isCancellationRequested) {
          d.dispose();
          return;
        }
        for (const u of d.provider)
          typeof u.onDidChangeInlayHints == "function" && !s.has(u) && (s.add(u), this._sessionDisposables.add(u.onDidChangeInlayHints(() => {
            o.isScheduled() || o.schedule();
          })));
        this._sessionDisposables.add(d), this._updateHintsDecorators(d.ranges, d.items), this._cacheHintsForFastRestore(t);
      } catch (c) {
        It(c);
      } finally {
        r.dispose(), l.dispose();
      }
    }), this._debounceInfo.get(t));
    if (this._sessionDisposables.add(o), this._sessionDisposables.add(Ct(() => r?.dispose(!0))), o.schedule(0), this._sessionDisposables.add(this._editor.onDidScrollChange((a) => {
      (a.scrollTopChanged || !o.isScheduled()) && o.schedule();
    })), this._sessionDisposables.add(this._editor.onDidChangeModelContent((a) => {
      const l = Math.max(o.delay, 1250);
      o.schedule(l);
    })), e.enabled === "on")
      this._activeRenderMode = 0;
    else {
      let a, l;
      e.enabled === "onUnlessPressed" ? (a = 0, l = 1) : (a = 1, l = 0), this._activeRenderMode = a, this._sessionDisposables.add(Sh.getInstance().event((c) => {
        if (!this._editor.hasModel())
          return;
        const d = c.altKey && c.ctrlKey && !(c.shiftKey || c.metaKey) ? l : a;
        if (d !== this._activeRenderMode) {
          this._activeRenderMode = d;
          const u = this._editor.getModel(), h = this._copyInlayHintsWithCurrentAnchor(u);
          this._updateHintsDecorators([u.getFullModelRange()], h), o.schedule(0);
        }
      }));
    }
    this._sessionDisposables.add(this._installDblClickGesture(() => o.schedule(0))), this._sessionDisposables.add(this._installLinkGesture()), this._sessionDisposables.add(this._installContextMenu());
  }
  _installLinkGesture() {
    const e = new Ne(), t = e.add(new u5(this._editor)), n = new Ne();
    return e.add(n), e.add(t.onMouseMoveOrRelevantKeyDown((r) => {
      const [s] = r, o = this._getInlayHintLabelPart(s), a = this._editor.getModel();
      if (!o || !a) {
        n.clear();
        return;
      }
      const l = new lr();
      n.add(Ct(() => l.dispose(!0))), o.item.resolve(l.token), this._activeInlayHintPart = o.part.command || o.part.location ? new Git(o, s.hasTriggerModifier) : void 0;
      const c = a.validatePosition(o.item.hint.position).lineNumber, d = new V(c, 1, c, a.getLineMaxColumn(c)), u = this._getInlineHintsForRange(d);
      this._updateHintsDecorators([d], u), n.add(Ct(() => {
        this._activeInlayHintPart = void 0, this._updateHintsDecorators([d], u);
      }));
    })), e.add(t.onCancel(() => n.clear())), e.add(t.onExecute((r) => W1(this, void 0, void 0, function* () {
      const s = this._getInlayHintLabelPart(r);
      if (s) {
        const o = s.part;
        o.location ? this._instaService.invokeFunction(Q1e, r, this._editor, o.location) : fR.is(o.command) && (yield this._invokeCommand(o.command, s.item));
      }
    }))), e;
  }
  _getInlineHintsForRange(e) {
    const t = /* @__PURE__ */ new Set();
    for (const n of this._decorationsMetadata.values())
      e.containsRange(n.item.anchor.range) && t.add(n.item);
    return Array.from(t);
  }
  _installDblClickGesture(e) {
    return this._editor.onMouseUp((t) => W1(this, void 0, void 0, function* () {
      if (t.event.detail !== 2)
        return;
      const n = this._getInlayHintLabelPart(t);
      if (n && (t.event.preventDefault(), yield n.item.resolve(jt.None), Bs(n.item.hint.textEdits))) {
        const r = n.item.hint.textEdits.map((s) => Si.replace(V.lift(s.range), s.text));
        this._editor.executeEdits("inlayHint.default", r), e();
      }
    }));
  }
  _installContextMenu() {
    return this._editor.onContextMenu((e) => W1(this, void 0, void 0, function* () {
      if (!(e.event.target instanceof HTMLElement))
        return;
      const t = this._getInlayHintLabelPart(e);
      t && (yield this._instaService.invokeFunction(zit, this._editor, e.event.target, t));
    }));
  }
  _getInlayHintLabelPart(e) {
    var t;
    if (e.target.type !== 6)
      return;
    const n = (t = e.target.detail.injectedText) === null || t === void 0 ? void 0 : t.options;
    if (n instanceof Ug && n?.attachedData instanceof OH)
      return n.attachedData;
  }
  _invokeCommand(e, t) {
    var n;
    return W1(this, void 0, void 0, function* () {
      try {
        yield this._commandService.executeCommand(e.id, ...(n = e.arguments) !== null && n !== void 0 ? n : []);
      } catch (r) {
        this._notificationService.notify({
          severity: I4.Error,
          source: t.provider.displayName,
          message: r
        });
      }
    });
  }
  _cacheHintsForFastRestore(e) {
    const t = this._copyInlayHintsWithCurrentAnchor(e);
    this._inlayHintsCache.set(e, t);
  }
  // return inlay hints but with an anchor that reflects "updates"
  // that happened after receiving them, e.g adding new lines before a hint
  _copyInlayHintsWithCurrentAnchor(e) {
    const t = /* @__PURE__ */ new Map();
    for (const [n, r] of this._decorationsMetadata) {
      if (t.has(r.item))
        continue;
      const s = e.getDecorationRange(n);
      if (s) {
        const o = new Z1e(s, r.item.anchor.direction), a = r.item.with({ anchor: o });
        t.set(r.item, a);
      }
    }
    return Array.from(t.values());
  }
  _getHintsRanges() {
    const t = this._editor.getModel(), n = this._editor.getVisibleRangesPlusViewportAboveBelow(), r = [];
    for (const s of n.sort(V.compareRangesUsingStarts)) {
      const o = t.validateRange(new V(s.startLineNumber - 30, s.startColumn, s.endLineNumber + 30, s.endColumn));
      r.length === 0 || !V.areIntersectingOrTouching(r[r.length - 1], o) ? r.push(o) : r[r.length - 1] = V.plusRange(r[r.length - 1], o);
    }
    return r;
  }
  _updateHintsDecorators(e, t) {
    var n, r;
    const s = [], o = (p, m, _, b, w) => {
      const y = {
        content: _,
        inlineClassNameAffectsLetterSpacing: !0,
        inlineClassName: m.className,
        cursorStops: b,
        attachedData: w
      };
      s.push({
        item: p,
        classNameRef: m,
        decoration: {
          range: p.anchor.range,
          options: {
            // className: "rangeHighlight", // DEBUG highlight to see to what range a hint is attached
            description: "InlayHint",
            showIfCollapsed: p.anchor.range.isEmpty(),
            // "original" range is empty
            collapseOnReplaceEdit: !p.anchor.range.isEmpty(),
            stickiness: 0,
            [p.anchor.direction]: this._activeRenderMode === 0 ? y : void 0
          }
        }
      });
    }, a = (p, m) => {
      const _ = this._ruleFactory.createClassNameRef({
        width: `${l / 3 | 0}px`,
        display: "inline-block"
      });
      o(p, _, " ", m ? Gc.Right : Gc.None);
    }, { fontSize: l, fontFamily: c, padding: d, isUniform: u } = this._getLayoutInfo(), h = "--code-editorInlayHintsFontFamily";
    this._editor.getContainerDomNode().style.setProperty(h, c);
    for (const p of t) {
      p.hint.paddingLeft && a(p, !1);
      const m = typeof p.hint.label == "string" ? [{ label: p.hint.label }] : p.hint.label;
      for (let _ = 0; _ < m.length; _++) {
        const b = m[_], w = _ === 0, y = _ === m.length - 1, S = {
          fontSize: `${l}px`,
          fontFamily: `var(${h}), ${na.fontFamily}`,
          verticalAlign: u ? "baseline" : "middle",
          unicodeBidi: "isolate"
        };
        Bs(p.hint.textEdits) && (S.cursor = "default"), this._fillInColors(S, p.hint), (b.command || b.location) && ((n = this._activeInlayHintPart) === null || n === void 0 ? void 0 : n.part.item) === p && this._activeInlayHintPart.part.index === _ && (S.textDecoration = "underline", this._activeInlayHintPart.hasTriggerModifier && (S.color = Oi(VMe), S.cursor = "pointer")), d && (w && y ? (S.padding = `1px ${Math.max(1, l / 4) | 0}px`, S.borderRadius = `${l / 4 | 0}px`) : w ? (S.padding = `1px 0 1px ${Math.max(1, l / 4) | 0}px`, S.borderRadius = `${l / 4 | 0}px 0 0 ${l / 4 | 0}px`) : y ? (S.padding = `1px ${Math.max(1, l / 4) | 0}px 1px 0`, S.borderRadius = `0 ${l / 4 | 0}px ${l / 4 | 0}px 0`) : S.padding = "1px 0 1px 0"), o(p, this._ruleFactory.createClassNameRef(S), qit(b.label), y && !p.hint.paddingRight ? Gc.Right : Gc.None, new OH(p, _));
      }
      if (p.hint.paddingRight && a(p, !0), s.length > uE._MAX_DECORATORS)
        break;
    }
    const f = [];
    for (const p of e)
      for (const { id: m } of (r = this._editor.getDecorationsInRange(p)) !== null && r !== void 0 ? r : []) {
        const _ = this._decorationsMetadata.get(m);
        _ && (f.push(m), _.classNameRef.dispose(), this._decorationsMetadata.delete(m));
      }
    const g = ud.capture(this._editor);
    this._editor.changeDecorations((p) => {
      const m = p.deltaDecorations(f, s.map((_) => _.decoration));
      for (let _ = 0; _ < m.length; _++) {
        const b = s[_];
        this._decorationsMetadata.set(m[_], b);
      }
    }), g.restore(this._editor);
  }
  _fillInColors(e, t) {
    t.kind === qE.Parameter ? (e.backgroundColor = Oi(zMe), e.color = Oi(jMe)) : t.kind === qE.Type ? (e.backgroundColor = Oi(WMe), e.color = Oi(HMe)) : (e.backgroundColor = Oi(Ih), e.color = Oi(Lh));
  }
  _getLayoutInfo() {
    const e = this._editor.getOption(
      139
      /* EditorOption.inlayHints */
    ), t = e.padding, n = this._editor.getOption(
      52
      /* EditorOption.fontSize */
    ), r = this._editor.getOption(
      49
      /* EditorOption.fontFamily */
    );
    let s = e.fontSize;
    (!s || s < 5 || s > n) && (s = n);
    const o = e.fontFamily || r;
    return { fontSize: s, fontFamily: o, padding: t, isUniform: !t && o === r && s === n };
  }
  _removeAllDecorations() {
    this._editor.removeDecorations(Array.from(this._decorationsMetadata.keys()));
    for (const e of this._decorationsMetadata.values())
      e.classNameRef.dispose();
    this._decorationsMetadata.clear();
  }
};
p0.ID = "editor.contrib.InlayHints";
p0._MAX_DECORATORS = 1500;
p0 = uE = Uit([
  D1(1, tt),
  D1(2, kl),
  D1(3, J1e),
  D1(4, Ui),
  D1(5, dr),
  D1(6, bt)
], p0);
function qit(i) {
  return i.replace(/[ \t]/g, " ");
}
on.registerCommand("_executeInlayHintProvider", (i, ...e) => W1(void 0, void 0, void 0, function* () {
  const [t, n] = e;
  On(pt.isUri(t)), On(V.isIRange(n));
  const { inlayHintsProvider: r } = i.get(tt), s = yield i.get(Wo).createModelReference(t);
  try {
    const o = yield Vw.create(r, s.object.textEditorModel, [V.lift(n)], jt.None), a = o.items.map((l) => l.hint);
    return setTimeout(() => o.dispose(), 0), a;
  } finally {
    s.dispose();
  }
}));
var Kit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, x2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, xee = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, Yit = function(i) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = i[Symbol.asyncIterator], t;
  return e ? e.call(i) : (i = typeof __values == "function" ? __values(i) : i[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function n(s) {
    t[s] = i[s] && function(o) {
      return new Promise(function(a, l) {
        o = i[s](o), r(a, l, o.done, o.value);
      });
    };
  }
  function r(s, o, a, l) {
    Promise.resolve(l).then(function(c) {
      s({ value: c, done: a });
    }, o);
  }
};
class Dee extends aE {
  constructor(e, t, n, r) {
    super(10, t, e.item.anchor.range, n, r, !0), this.part = e;
  }
}
let MH = class extends CI {
  constructor(e, t, n, r, s, o) {
    super(e, t, n, r, o), this._resolverService = s, this.hoverOrdinal = 6;
  }
  suggestHoverAnchor(e) {
    var t;
    if (!p0.get(this._editor) || e.target.type !== 6)
      return null;
    const r = (t = e.target.detail.injectedText) === null || t === void 0 ? void 0 : t.options;
    return r instanceof Ug && r.attachedData instanceof OH ? new Dee(r.attachedData, this, e.event.posx, e.event.posy) : null;
  }
  computeSync() {
    return [];
  }
  computeAsync(e, t, n) {
    return e instanceof Dee ? new hr((r) => xee(this, void 0, void 0, function* () {
      var s, o, a, l;
      const { part: c } = e;
      if (yield c.item.resolve(n), n.isCancellationRequested)
        return;
      let d;
      typeof c.item.hint.tooltip == "string" ? d = new ys().appendText(c.item.hint.tooltip) : c.item.hint.tooltip && (d = c.item.hint.tooltip), d && r.emitOne(new Wc(this, e.range, [d], !1, 0)), Bs(c.item.hint.textEdits) && r.emitOne(new Wc(this, e.range, [new ys().appendText(C("hint.dbl", "Double-click to insert"))], !1, 10001));
      let u;
      if (typeof c.part.tooltip == "string" ? u = new ys().appendText(c.part.tooltip) : c.part.tooltip && (u = c.part.tooltip), u && r.emitOne(new Wc(this, e.range, [u], !1, 1)), c.part.location || c.part.command) {
        let m;
        const b = this._editor.getOption(
          77
          /* EditorOption.multiCursorModifier */
        ) === "altKey" ? sn ? C("links.navigate.kb.meta.mac", "cmd + click") : C("links.navigate.kb.meta", "ctrl + click") : sn ? C("links.navigate.kb.alt.mac", "option + click") : C("links.navigate.kb.alt", "alt + click");
        c.part.location && c.part.command ? m = new ys().appendText(C("hint.defAndCommand", "Go to Definition ({0}), right click for more", b)) : c.part.location ? m = new ys().appendText(C("hint.def", "Go to Definition ({0})", b)) : c.part.command && (m = new ys(`[${C("hint.cmd", "Execute Command")}](${jit(c.part.command)} "${c.part.command.title}") (${b})`, { isTrusted: !0 })), m && r.emitOne(new Wc(this, e.range, [m], !1, 1e4));
      }
      const h = yield this._resolveInlayHintLabelPartHover(c, n);
      try {
        for (var f = !0, g = Yit(h), p; p = yield g.next(), s = p.done, !s; f = !0) {
          l = p.value, f = !1;
          const m = l;
          r.emitOne(m);
        }
      } catch (m) {
        o = { error: m };
      } finally {
        try {
          !f && !s && (a = g.return) && (yield a.call(g));
        } finally {
          if (o) throw o.error;
        }
      }
    })) : hr.EMPTY;
  }
  _resolveInlayHintLabelPartHover(e, t) {
    return xee(this, void 0, void 0, function* () {
      if (!e.part.location)
        return hr.EMPTY;
      const { uri: n, range: r } = e.part.location, s = yield this._resolverService.createModelReference(n);
      try {
        const o = s.object.textEditorModel;
        return this._languageFeaturesService.hoverProvider.has(o) ? dG(this._languageFeaturesService.hoverProvider, o, new ve(r.startLineNumber, r.startColumn), t).filter((a) => !T_(a.hover.contents)).map((a) => new Wc(this, e.item.anchor.range, a.hover.contents, !1, 2 + a.ordinal)) : hr.EMPTY;
      } finally {
        s.dispose();
      }
    });
  }
};
MH = Kit([
  x2(1, ci),
  x2(2, da),
  x2(3, en),
  x2(4, Wo),
  x2(5, tt)
], MH);
pn(
  p0.ID,
  p0,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
K0.register(MH);
class Xit {
  constructor(e, t, n) {
    this._editRange = e, this._originalSelection = t, this._text = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._editRange, this._text);
  }
  computeCursorState(e, t) {
    const r = t.getInverseEditOperations()[0].range;
    return this._originalSelection.isEmpty() ? new ot(r.endLineNumber, Math.min(this._originalSelection.positionColumn, r.endColumn), r.endLineNumber, Math.min(this._originalSelection.positionColumn, r.endColumn)) : new ot(r.endLineNumber, r.endColumn - this._text.length, r.endLineNumber, r.endColumn);
  }
}
var Zit = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Qit = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, hE;
let ep = hE = class {
  static get(e) {
    return e.getContribution(hE.ID);
  }
  constructor(e, t) {
    this.editor = e, this.editorWorkerService = t, this.decorations = this.editor.createDecorationsCollection();
  }
  dispose() {
  }
  run(e, t) {
    var n;
    (n = this.currentRequest) === null || n === void 0 || n.cancel();
    const r = this.editor.getSelection(), s = this.editor.getModel();
    if (!s || !r)
      return;
    let o = r;
    if (o.startLineNumber !== o.endLineNumber)
      return;
    const a = new Ime(
      this.editor,
      5
      /* CodeEditorStateFlag.Position */
    ), l = s.uri;
    return this.editorWorkerService.canNavigateValueSet(l) ? (this.currentRequest = Ir((c) => this.editorWorkerService.navigateValueSet(l, o, t)), this.currentRequest.then((c) => {
      var d;
      if (!c || !c.range || !c.value || !a.validate(this.editor))
        return;
      const u = V.lift(c.range);
      let h = c.range;
      const f = c.value.length - (o.endColumn - o.startColumn);
      h = {
        startLineNumber: h.startLineNumber,
        startColumn: h.startColumn,
        endLineNumber: h.endLineNumber,
        endColumn: h.startColumn + c.value.length
      }, f > 1 && (o = new ot(o.startLineNumber, o.startColumn, o.endLineNumber, o.endColumn + f - 1));
      const g = new Xit(u, o, c.value);
      this.editor.pushUndoStop(), this.editor.executeCommand(e, g), this.editor.pushUndoStop(), this.decorations.set([{
        range: h,
        options: hE.DECORATION
      }]), (d = this.decorationRemover) === null || d === void 0 || d.cancel(), this.decorationRemover = Mg(350), this.decorationRemover.then(() => this.decorations.clear()).catch(It);
    }).catch(It)) : Promise.resolve(void 0);
  }
};
ep.ID = "editor.contrib.inPlaceReplaceController";
ep.DECORATION = Lt.register({
  description: "in-place-replace",
  className: "valueSetReplacement"
});
ep = hE = Zit([
  Qit(1, vc)
], ep);
class Jit extends Je {
  constructor() {
    super({
      id: "editor.action.inPlaceReplace.up",
      label: C("InPlaceReplaceAction.previous.label", "Replace with Previous Value"),
      alias: "Replace with Previous Value",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 3159,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = ep.get(t);
    return n ? n.run(this.id, !1) : Promise.resolve(void 0);
  }
}
class $it extends Je {
  constructor() {
    super({
      id: "editor.action.inPlaceReplace.down",
      label: C("InPlaceReplaceAction.next.label", "Replace with Next Value"),
      alias: "Replace with Next Value",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 3161,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = ep.get(t);
    return n ? n.run(this.id, !0) : Promise.resolve(void 0);
  }
}
pn(
  ep.ID,
  ep,
  4
  /* EditorContributionInstantiation.Lazy */
);
Be(Jit);
Be($it);
class ert extends Je {
  constructor() {
    super({
      id: "expandLineSelection",
      label: C("expandLineSelection", "Expand Line Selection"),
      alias: "Expand Line Selection",
      precondition: void 0,
      kbOpts: {
        weight: 0,
        kbExpr: $.textInputFocus,
        primary: 2090
        /* KeyCode.KeyL */
      }
    });
  }
  run(e, t, n) {
    if (n = n || {}, !t.hasModel())
      return;
    const r = t._getViewModel();
    r.model.pushStackElement(), r.setCursorStates(n.source, 3, Qr.expandLineSelection(r, r.getCursorStates())), r.revealPrimaryCursor(n.source, !0);
  }
}
Be(ert);
class trt {
  constructor(e, t) {
    this._selection = e, this._cursors = t, this._selectionId = null;
  }
  getEditOperations(e, t) {
    const n = nrt(e, this._cursors);
    for (let r = 0, s = n.length; r < s; r++) {
      const o = n[r];
      t.addEditOperation(o.range, o.text);
    }
    this._selectionId = t.trackSelection(this._selection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
function nrt(i, e) {
  e.sort((o, a) => o.lineNumber === a.lineNumber ? o.column - a.column : o.lineNumber - a.lineNumber);
  for (let o = e.length - 2; o >= 0; o--)
    e[o].lineNumber === e[o + 1].lineNumber && e.splice(o, 1);
  const t = [];
  let n = 0, r = 0;
  const s = e.length;
  for (let o = 1, a = i.getLineCount(); o <= a; o++) {
    const l = i.getLineContent(o), c = l.length + 1;
    let d = 0;
    if (r < s && e[r].lineNumber === o && (d = e[r].column, r++, d === c) || l.length === 0)
      continue;
    const u = Jc(l);
    let h = 0;
    if (u === -1)
      h = 1;
    else if (u !== l.length - 1)
      h = u + 2;
    else
      continue;
    h = Math.max(d, h), t[n++] = Si.delete(new V(o, h, o, c));
  }
  return t;
}
class $1e {
  constructor(e, t, n) {
    this._selection = e, this._isCopyingDown = t, this._noop = n || !1, this._selectionDirection = 0, this._selectionId = null, this._startLineNumberDelta = 0, this._endLineNumberDelta = 0;
  }
  getEditOperations(e, t) {
    let n = this._selection;
    this._startLineNumberDelta = 0, this._endLineNumberDelta = 0, n.startLineNumber < n.endLineNumber && n.endColumn === 1 && (this._endLineNumberDelta = 1, n = n.setEndPosition(n.endLineNumber - 1, e.getLineMaxColumn(n.endLineNumber - 1)));
    const r = [];
    for (let o = n.startLineNumber; o <= n.endLineNumber; o++)
      r.push(e.getLineContent(o));
    const s = r.join(`
`);
    s === "" && this._isCopyingDown && (this._startLineNumberDelta++, this._endLineNumberDelta++), this._noop ? t.addEditOperation(new V(n.endLineNumber, e.getLineMaxColumn(n.endLineNumber), n.endLineNumber + 1, 1), n.endLineNumber === e.getLineCount() ? "" : `
`) : this._isCopyingDown ? t.addEditOperation(new V(n.startLineNumber, 1, n.startLineNumber, 1), s + `
`) : t.addEditOperation(new V(n.endLineNumber, e.getLineMaxColumn(n.endLineNumber), n.endLineNumber, e.getLineMaxColumn(n.endLineNumber)), `
` + s), this._selectionId = t.trackSelection(n), this._selectionDirection = this._selection.getDirection();
  }
  computeCursorState(e, t) {
    let n = t.getTrackedSelection(this._selectionId);
    if (this._startLineNumberDelta !== 0 || this._endLineNumberDelta !== 0) {
      let r = n.startLineNumber, s = n.startColumn, o = n.endLineNumber, a = n.endColumn;
      this._startLineNumberDelta !== 0 && (r = r + this._startLineNumberDelta, s = 1), this._endLineNumberDelta !== 0 && (o = o + this._endLineNumberDelta, a = 1), n = ot.createWithDirection(r, s, o, a, this._selectionDirection);
    }
    return n;
  }
}
var irt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, rrt = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let RH = class {
  constructor(e, t, n, r) {
    this._languageConfigurationService = r, this._selection = e, this._isMovingDown = t, this._autoIndent = n, this._selectionId = null, this._moveEndLineSelectionShrink = !1;
  }
  getEditOperations(e, t) {
    const n = e.getLineCount();
    if (this._isMovingDown && this._selection.endLineNumber === n) {
      this._selectionId = t.trackSelection(this._selection);
      return;
    }
    if (!this._isMovingDown && this._selection.startLineNumber === 1) {
      this._selectionId = t.trackSelection(this._selection);
      return;
    }
    this._moveEndPositionDown = !1;
    let r = this._selection;
    r.startLineNumber < r.endLineNumber && r.endColumn === 1 && (this._moveEndPositionDown = !0, r = r.setEndPosition(r.endLineNumber - 1, e.getLineMaxColumn(r.endLineNumber - 1)));
    const { tabSize: s, indentSize: o, insertSpaces: a } = e.getOptions(), l = this.buildIndentConverter(s, o, a), c = {
      tokenization: {
        getLineTokens: (d) => e.tokenization.getLineTokens(d),
        getLanguageId: () => e.getLanguageId(),
        getLanguageIdAtPosition: (d, u) => e.getLanguageIdAtPosition(d, u)
      },
      getLineContent: null
    };
    if (r.startLineNumber === r.endLineNumber && e.getLineMaxColumn(r.startLineNumber) === 1) {
      const d = r.startLineNumber, u = this._isMovingDown ? d + 1 : d - 1;
      e.getLineMaxColumn(u) === 1 ? t.addEditOperation(new V(1, 1, 1, 1), null) : (t.addEditOperation(new V(d, 1, d, 1), e.getLineContent(u)), t.addEditOperation(new V(u, 1, u, e.getLineMaxColumn(u)), null)), r = new ot(u, 1, u, 1);
    } else {
      let d, u;
      if (this._isMovingDown) {
        d = r.endLineNumber + 1, u = e.getLineContent(d), t.addEditOperation(new V(d - 1, e.getLineMaxColumn(d - 1), d, e.getLineMaxColumn(d)), null);
        let h = u;
        if (this.shouldAutoIndent(e, r)) {
          const f = this.matchEnterRule(e, l, s, d, r.startLineNumber - 1);
          if (f !== null) {
            const p = Hn(e.getLineContent(d)), m = f + Go(p, s);
            h = YC(m, s, a) + this.trimStart(u);
          } else {
            c.getLineContent = (m) => m === r.startLineNumber ? e.getLineContent(d) : e.getLineContent(m);
            const p = EC(this._autoIndent, c, e.getLanguageIdAtPosition(d, 1), r.startLineNumber, l, this._languageConfigurationService);
            if (p !== null) {
              const m = Hn(e.getLineContent(d)), _ = Go(p, s), b = Go(m, s);
              _ !== b && (h = YC(_, s, a) + this.trimStart(u));
            }
          }
          t.addEditOperation(new V(r.startLineNumber, 1, r.startLineNumber, 1), h + `
`);
          const g = this.matchEnterRuleMovingDown(e, l, s, r.startLineNumber, d, h);
          if (g !== null)
            g !== 0 && this.getIndentEditsOfMovingBlock(e, t, r, s, a, g);
          else {
            c.getLineContent = (m) => m === r.startLineNumber ? h : m >= r.startLineNumber + 1 && m <= r.endLineNumber + 1 ? e.getLineContent(m - 1) : e.getLineContent(m);
            const p = EC(this._autoIndent, c, e.getLanguageIdAtPosition(d, 1), r.startLineNumber + 1, l, this._languageConfigurationService);
            if (p !== null) {
              const m = Hn(e.getLineContent(r.startLineNumber)), _ = Go(p, s), b = Go(m, s);
              if (_ !== b) {
                const w = _ - b;
                this.getIndentEditsOfMovingBlock(e, t, r, s, a, w);
              }
            }
          }
        } else
          t.addEditOperation(new V(r.startLineNumber, 1, r.startLineNumber, 1), h + `
`);
      } else if (d = r.startLineNumber - 1, u = e.getLineContent(d), t.addEditOperation(new V(d, 1, d + 1, 1), null), t.addEditOperation(new V(r.endLineNumber, e.getLineMaxColumn(r.endLineNumber), r.endLineNumber, e.getLineMaxColumn(r.endLineNumber)), `
` + u), this.shouldAutoIndent(e, r)) {
        c.getLineContent = (f) => f === d ? e.getLineContent(r.startLineNumber) : e.getLineContent(f);
        const h = this.matchEnterRule(e, l, s, r.startLineNumber, r.startLineNumber - 2);
        if (h !== null)
          h !== 0 && this.getIndentEditsOfMovingBlock(e, t, r, s, a, h);
        else {
          const f = EC(this._autoIndent, c, e.getLanguageIdAtPosition(r.startLineNumber, 1), d, l, this._languageConfigurationService);
          if (f !== null) {
            const g = Hn(e.getLineContent(r.startLineNumber)), p = Go(f, s), m = Go(g, s);
            if (p !== m) {
              const _ = p - m;
              this.getIndentEditsOfMovingBlock(e, t, r, s, a, _);
            }
          }
        }
      }
    }
    this._selectionId = t.trackSelection(r);
  }
  buildIndentConverter(e, t, n) {
    return {
      shiftIndent: (r) => ol.shiftIndent(r, r.length + 1, e, t, n),
      unshiftIndent: (r) => ol.unshiftIndent(r, r.length + 1, e, t, n)
    };
  }
  parseEnterResult(e, t, n, r, s) {
    if (s) {
      let o = s.indentation;
      s.indentAction === mr.None || s.indentAction === mr.Indent ? o = s.indentation + s.appendText : s.indentAction === mr.IndentOutdent ? o = s.indentation : s.indentAction === mr.Outdent && (o = t.unshiftIndent(s.indentation) + s.appendText);
      const a = e.getLineContent(r);
      if (this.trimStart(a).indexOf(this.trimStart(o)) >= 0) {
        const l = Hn(e.getLineContent(r));
        let c = Hn(o);
        const d = tge(e, r, this._languageConfigurationService);
        d !== null && d & 2 && (c = t.unshiftIndent(c));
        const u = Go(c, n), h = Go(l, n);
        return u - h;
      }
    }
    return null;
  }
  /**
   *
   * @param model
   * @param indentConverter
   * @param tabSize
   * @param line the line moving down
   * @param futureAboveLineNumber the line which will be at the `line` position
   * @param futureAboveLineText
   */
  matchEnterRuleMovingDown(e, t, n, r, s, o) {
    if (Jc(o) >= 0) {
      const a = e.getLineMaxColumn(s), l = Fv(this._autoIndent, e, new V(s, a, s, a), this._languageConfigurationService);
      return this.parseEnterResult(e, t, n, r, l);
    } else {
      let a = r - 1;
      for (; a >= 1; ) {
        const d = e.getLineContent(a);
        if (Jc(d) >= 0)
          break;
        a--;
      }
      if (a < 1 || r > e.getLineCount())
        return null;
      const l = e.getLineMaxColumn(a), c = Fv(this._autoIndent, e, new V(a, l, a, l), this._languageConfigurationService);
      return this.parseEnterResult(e, t, n, r, c);
    }
  }
  matchEnterRule(e, t, n, r, s, o) {
    let a = s;
    for (; a >= 1; ) {
      let d;
      if (a === s && o !== void 0 ? d = o : d = e.getLineContent(a), Jc(d) >= 0)
        break;
      a--;
    }
    if (a < 1 || r > e.getLineCount())
      return null;
    const l = e.getLineMaxColumn(a), c = Fv(this._autoIndent, e, new V(a, l, a, l), this._languageConfigurationService);
    return this.parseEnterResult(e, t, n, r, c);
  }
  trimStart(e) {
    return e.replace(/^\s+/, "");
  }
  shouldAutoIndent(e, t) {
    if (this._autoIndent < 4 || !e.tokenization.isCheapToTokenize(t.startLineNumber))
      return !1;
    const n = e.getLanguageIdAtPosition(t.startLineNumber, 1), r = e.getLanguageIdAtPosition(t.endLineNumber, 1);
    return !(n !== r || this._languageConfigurationService.getLanguageConfiguration(n).indentRulesSupport === null);
  }
  getIndentEditsOfMovingBlock(e, t, n, r, s, o) {
    for (let a = n.startLineNumber; a <= n.endLineNumber; a++) {
      const l = e.getLineContent(a), c = Hn(l), u = Go(c, r) + o, h = YC(u, r, s);
      h !== c && (t.addEditOperation(new V(a, 1, a, c.length + 1), h), a === n.endLineNumber && n.endColumn <= c.length + 1 && h === "" && (this._moveEndLineSelectionShrink = !0));
    }
  }
  computeCursorState(e, t) {
    let n = t.getTrackedSelection(this._selectionId);
    return this._moveEndPositionDown && (n = n.setEndPosition(n.endLineNumber + 1, 1)), this._moveEndLineSelectionShrink && n.startLineNumber < n.endLineNumber && (n = n.setEndPosition(n.endLineNumber, 2)), n;
  }
};
RH = irt([
  rrt(3, Un)
], RH);
class Lg {
  static getCollator() {
    return Lg._COLLATOR || (Lg._COLLATOR = new Intl.Collator()), Lg._COLLATOR;
  }
  constructor(e, t) {
    this.selection = e, this.descending = t, this.selectionId = null;
  }
  getEditOperations(e, t) {
    const n = srt(e, this.selection, this.descending);
    n && t.addEditOperation(n.range, n.text), this.selectionId = t.trackSelection(this.selection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this.selectionId);
  }
  static canRun(e, t, n) {
    if (e === null)
      return !1;
    const r = eve(e, t, n);
    if (!r)
      return !1;
    for (let s = 0, o = r.before.length; s < o; s++)
      if (r.before[s] !== r.after[s])
        return !0;
    return !1;
  }
}
Lg._COLLATOR = null;
function eve(i, e, t) {
  const n = e.startLineNumber;
  let r = e.endLineNumber;
  if (e.endColumn === 1 && r--, n >= r)
    return null;
  const s = [];
  for (let a = n; a <= r; a++)
    s.push(i.getLineContent(a));
  let o = s.slice(0);
  return o.sort(Lg.getCollator().compare), t === !0 && (o = o.reverse()), {
    startLineNumber: n,
    endLineNumber: r,
    before: s,
    after: o
  };
}
function srt(i, e, t) {
  const n = eve(i, e, t);
  return n ? Si.replace(new V(n.startLineNumber, 1, n.endLineNumber, i.getLineMaxColumn(n.endLineNumber)), n.after.join(`
`)) : null;
}
class tve extends Je {
  constructor(e, t) {
    super(t), this.down = e;
  }
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = t.getSelections().map((o, a) => ({ selection: o, index: a, ignore: !1 }));
    n.sort((o, a) => V.compareRangesUsingStarts(o.selection, a.selection));
    let r = n[0];
    for (let o = 1; o < n.length; o++) {
      const a = n[o];
      r.selection.endLineNumber === a.selection.startLineNumber && (r.index < a.index ? a.ignore = !0 : (r.ignore = !0, r = a));
    }
    const s = [];
    for (const o of n)
      s.push(new $1e(o.selection, this.down, o.ignore));
    t.pushUndoStop(), t.executeCommands(this.id, s), t.pushUndoStop();
  }
}
class ort extends tve {
  constructor() {
    super(!1, {
      id: "editor.action.copyLinesUpAction",
      label: C("lines.copyUp", "Copy Line Up"),
      alias: "Copy Line Up",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 1552,
        linux: {
          primary: 3600
          /* KeyCode.UpArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "2_line",
        title: C({ key: "miCopyLinesUp", comment: ["&& denotes a mnemonic"] }, "&&Copy Line Up"),
        order: 1
      }
    });
  }
}
class art extends tve {
  constructor() {
    super(!0, {
      id: "editor.action.copyLinesDownAction",
      label: C("lines.copyDown", "Copy Line Down"),
      alias: "Copy Line Down",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 1554,
        linux: {
          primary: 3602
          /* KeyCode.DownArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "2_line",
        title: C({ key: "miCopyLinesDown", comment: ["&& denotes a mnemonic"] }, "Co&&py Line Down"),
        order: 2
      }
    });
  }
}
class lrt extends Je {
  constructor() {
    super({
      id: "editor.action.duplicateSelection",
      label: C("duplicateSelection", "Duplicate Selection"),
      alias: "Duplicate Selection",
      precondition: $.writable,
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "2_line",
        title: C({ key: "miDuplicateSelection", comment: ["&& denotes a mnemonic"] }, "&&Duplicate Selection"),
        order: 5
      }
    });
  }
  run(e, t, n) {
    if (!t.hasModel())
      return;
    const r = [], s = t.getSelections(), o = t.getModel();
    for (const a of s)
      if (a.isEmpty())
        r.push(new $1e(a, !0));
      else {
        const l = new ot(a.endLineNumber, a.endColumn, a.endLineNumber, a.endColumn);
        r.push(new dFe(l, o.getValueInRange(a)));
      }
    t.pushUndoStop(), t.executeCommands(this.id, r), t.pushUndoStop();
  }
}
class nve extends Je {
  constructor(e, t) {
    super(t), this.down = e;
  }
  run(e, t) {
    const n = e.get(Un), r = [], s = t.getSelections() || [], o = t.getOption(
      12
      /* EditorOption.autoIndent */
    );
    for (const a of s)
      r.push(new RH(a, this.down, o, n));
    t.pushUndoStop(), t.executeCommands(this.id, r), t.pushUndoStop();
  }
}
class crt extends nve {
  constructor() {
    super(!1, {
      id: "editor.action.moveLinesUpAction",
      label: C("lines.moveUp", "Move Line Up"),
      alias: "Move Line Up",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 528,
        linux: {
          primary: 528
          /* KeyCode.UpArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "2_line",
        title: C({ key: "miMoveLinesUp", comment: ["&& denotes a mnemonic"] }, "Mo&&ve Line Up"),
        order: 3
      }
    });
  }
}
class drt extends nve {
  constructor() {
    super(!0, {
      id: "editor.action.moveLinesDownAction",
      label: C("lines.moveDown", "Move Line Down"),
      alias: "Move Line Down",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 530,
        linux: {
          primary: 530
          /* KeyCode.DownArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "2_line",
        title: C({ key: "miMoveLinesDown", comment: ["&& denotes a mnemonic"] }, "Move &&Line Down"),
        order: 4
      }
    });
  }
}
class ive extends Je {
  constructor(e, t) {
    super(t), this.descending = e;
  }
  run(e, t) {
    const n = t.getSelections() || [];
    for (const s of n)
      if (!Lg.canRun(t.getModel(), s, this.descending))
        return;
    const r = [];
    for (let s = 0, o = n.length; s < o; s++)
      r[s] = new Lg(n[s], this.descending);
    t.pushUndoStop(), t.executeCommands(this.id, r), t.pushUndoStop();
  }
}
class urt extends ive {
  constructor() {
    super(!1, {
      id: "editor.action.sortLinesAscending",
      label: C("lines.sortAscending", "Sort Lines Ascending"),
      alias: "Sort Lines Ascending",
      precondition: $.writable
    });
  }
}
class hrt extends ive {
  constructor() {
    super(!0, {
      id: "editor.action.sortLinesDescending",
      label: C("lines.sortDescending", "Sort Lines Descending"),
      alias: "Sort Lines Descending",
      precondition: $.writable
    });
  }
}
class frt extends Je {
  constructor() {
    super({
      id: "editor.action.removeDuplicateLines",
      label: C("lines.deleteDuplicates", "Delete Duplicate Lines"),
      alias: "Delete Duplicate Lines",
      precondition: $.writable
    });
  }
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = t.getModel();
    if (n.getLineCount() === 1 && n.getLineMaxColumn(1) === 1)
      return;
    const r = [], s = [];
    let o = 0;
    for (const a of t.getSelections()) {
      const l = /* @__PURE__ */ new Set(), c = [];
      for (let f = a.startLineNumber; f <= a.endLineNumber; f++) {
        const g = n.getLineContent(f);
        l.has(g) || (c.push(g), l.add(g));
      }
      const d = new ot(a.startLineNumber, 1, a.endLineNumber, n.getLineMaxColumn(a.endLineNumber)), u = a.startLineNumber - o, h = new ot(u, 1, u + c.length - 1, c[c.length - 1].length);
      r.push(Si.replace(d, c.join(`
`))), s.push(h), o += a.endLineNumber - a.startLineNumber + 1 - c.length;
    }
    t.pushUndoStop(), t.executeEdits(this.id, r, s), t.pushUndoStop();
  }
}
class z5 extends Je {
  constructor() {
    super({
      id: z5.ID,
      label: C("lines.trimTrailingWhitespace", "Trim Trailing Whitespace"),
      alias: "Trim Trailing Whitespace",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: xr(
          2089,
          2102
          /* KeyCode.KeyX */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t, n) {
    let r = [];
    n.reason === "auto-save" && (r = (t.getSelections() || []).map((a) => new ve(a.positionLineNumber, a.positionColumn)));
    const s = t.getSelection();
    if (s === null)
      return;
    const o = new trt(s, r);
    t.pushUndoStop(), t.executeCommands(this.id, [o]), t.pushUndoStop();
  }
}
z5.ID = "editor.action.trimTrailingWhitespace";
class grt extends Je {
  constructor() {
    super({
      id: "editor.action.deleteLines",
      label: C("lines.delete", "Delete Line"),
      alias: "Delete Line",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 3113,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = this._getLinesToRemove(t), r = t.getModel();
    if (r.getLineCount() === 1 && r.getLineMaxColumn(1) === 1)
      return;
    let s = 0;
    const o = [], a = [];
    for (let l = 0, c = n.length; l < c; l++) {
      const d = n[l];
      let u = d.startLineNumber, h = d.endLineNumber, f = 1, g = r.getLineMaxColumn(h);
      h < r.getLineCount() ? (h += 1, g = 1) : u > 1 && (u -= 1, f = r.getLineMaxColumn(u)), o.push(Si.replace(new ot(u, f, h, g), "")), a.push(new ot(u - s, d.positionColumn, u - s, d.positionColumn)), s += d.endLineNumber - d.startLineNumber + 1;
    }
    t.pushUndoStop(), t.executeEdits(this.id, o, a), t.pushUndoStop();
  }
  _getLinesToRemove(e) {
    const t = e.getSelections().map((s) => {
      let o = s.endLineNumber;
      return s.startLineNumber < s.endLineNumber && s.endColumn === 1 && (o -= 1), {
        startLineNumber: s.startLineNumber,
        selectionStartColumn: s.selectionStartColumn,
        endLineNumber: o,
        positionColumn: s.positionColumn
      };
    });
    t.sort((s, o) => s.startLineNumber === o.startLineNumber ? s.endLineNumber - o.endLineNumber : s.startLineNumber - o.startLineNumber);
    const n = [];
    let r = t[0];
    for (let s = 1; s < t.length; s++)
      r.endLineNumber + 1 >= t[s].startLineNumber ? r.endLineNumber = t[s].endLineNumber : (n.push(r), r = t[s]);
    return n.push(r), n;
  }
}
class prt extends Je {
  constructor() {
    super({
      id: "editor.action.indentLines",
      label: C("lines.indent", "Indent Line"),
      alias: "Indent Line",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 2142,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = t._getViewModel();
    n && (t.pushUndoStop(), t.executeCommands(this.id, wi.indent(n.cursorConfig, t.getModel(), t.getSelections())), t.pushUndoStop());
  }
}
class mrt extends Je {
  constructor() {
    super({
      id: "editor.action.outdentLines",
      label: C("lines.outdent", "Outdent Line"),
      alias: "Outdent Line",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 2140,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    Bv.Outdent.runEditorCommand(e, t, null);
  }
}
class vrt extends Je {
  constructor() {
    super({
      id: "editor.action.insertLineBefore",
      label: C("lines.insertBefore", "Insert Line Above"),
      alias: "Insert Line Above",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 3075,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = t._getViewModel();
    n && (t.pushUndoStop(), t.executeCommands(this.id, wi.lineInsertBefore(n.cursorConfig, t.getModel(), t.getSelections())));
  }
}
class _rt extends Je {
  constructor() {
    super({
      id: "editor.action.insertLineAfter",
      label: C("lines.insertAfter", "Insert Line Below"),
      alias: "Insert Line Below",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 2051,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = t._getViewModel();
    n && (t.pushUndoStop(), t.executeCommands(this.id, wi.lineInsertAfter(n.cursorConfig, t.getModel(), t.getSelections())));
  }
}
class rve extends Je {
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = t.getSelection(), r = this._getRangesToDelete(t), s = [];
    for (let l = 0, c = r.length - 1; l < c; l++) {
      const d = r[l], u = r[l + 1];
      V.intersectRanges(d, u) === null ? s.push(d) : r[l + 1] = V.plusRange(d, u);
    }
    s.push(r[r.length - 1]);
    const o = this._getEndCursorState(n, s), a = s.map((l) => Si.replace(l, ""));
    t.pushUndoStop(), t.executeEdits(this.id, a, o), t.pushUndoStop();
  }
}
class brt extends rve {
  constructor() {
    super({
      id: "deleteAllLeft",
      label: C("lines.deleteAllLeft", "Delete All Left"),
      alias: "Delete All Left",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        mac: {
          primary: 2049
          /* KeyCode.Backspace */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  _getEndCursorState(e, t) {
    let n = null;
    const r = [];
    let s = 0;
    return t.forEach((o) => {
      let a;
      if (o.endColumn === 1 && s > 0) {
        const l = o.startLineNumber - s;
        a = new ot(l, o.startColumn, l, o.startColumn);
      } else
        a = new ot(o.startLineNumber, o.startColumn, o.startLineNumber, o.startColumn);
      s += o.endLineNumber - o.startLineNumber, o.intersectRanges(e) ? n = a : r.push(a);
    }), n && r.unshift(n), r;
  }
  _getRangesToDelete(e) {
    const t = e.getSelections();
    if (t === null)
      return [];
    let n = t;
    const r = e.getModel();
    return r === null ? [] : (n.sort(V.compareRangesUsingStarts), n = n.map((s) => {
      if (s.isEmpty())
        if (s.startColumn === 1) {
          const o = Math.max(1, s.startLineNumber - 1), a = s.startLineNumber === 1 ? 1 : r.getLineLength(o) + 1;
          return new V(o, a, s.startLineNumber, 1);
        } else
          return new V(s.startLineNumber, 1, s.startLineNumber, s.startColumn);
      else
        return new V(s.startLineNumber, 1, s.endLineNumber, s.endColumn);
    }), n);
  }
}
class Crt extends rve {
  constructor() {
    super({
      id: "deleteAllRight",
      label: C("lines.deleteAllRight", "Delete All Right"),
      alias: "Delete All Right",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        mac: { primary: 297, secondary: [
          2068
          /* KeyCode.Delete */
        ] },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  _getEndCursorState(e, t) {
    let n = null;
    const r = [];
    for (let s = 0, o = t.length, a = 0; s < o; s++) {
      const l = t[s], c = new ot(l.startLineNumber - a, l.startColumn, l.startLineNumber - a, l.startColumn);
      l.intersectRanges(e) ? n = c : r.push(c);
    }
    return n && r.unshift(n), r;
  }
  _getRangesToDelete(e) {
    const t = e.getModel();
    if (t === null)
      return [];
    const n = e.getSelections();
    if (n === null)
      return [];
    const r = n.map((s) => {
      if (s.isEmpty()) {
        const o = t.getLineMaxColumn(s.startLineNumber);
        return s.startColumn === o ? new V(s.startLineNumber, s.startColumn, s.startLineNumber + 1, 1) : new V(s.startLineNumber, s.startColumn, s.startLineNumber, o);
      }
      return s;
    });
    return r.sort(V.compareRangesUsingStarts), r;
  }
}
class yrt extends Je {
  constructor() {
    super({
      id: "editor.action.joinLines",
      label: C("lines.joinLines", "Join Lines"),
      alias: "Join Lines",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 0,
        mac: {
          primary: 296
          /* KeyCode.KeyJ */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = t.getSelections();
    if (n === null)
      return;
    let r = t.getSelection();
    if (r === null)
      return;
    n.sort(V.compareRangesUsingStarts);
    const s = [], o = n.reduce((h, f) => h.isEmpty() ? h.endLineNumber === f.startLineNumber ? (r.equalsSelection(h) && (r = f), f) : f.startLineNumber > h.endLineNumber + 1 ? (s.push(h), f) : new ot(h.startLineNumber, h.startColumn, f.endLineNumber, f.endColumn) : f.startLineNumber > h.endLineNumber ? (s.push(h), f) : new ot(h.startLineNumber, h.startColumn, f.endLineNumber, f.endColumn));
    s.push(o);
    const a = t.getModel();
    if (a === null)
      return;
    const l = [], c = [];
    let d = r, u = 0;
    for (let h = 0, f = s.length; h < f; h++) {
      const g = s[h], p = g.startLineNumber, m = 1;
      let _ = 0, b, w;
      const y = a.getLineLength(g.endLineNumber) - g.endColumn;
      if (g.isEmpty() || g.startLineNumber === g.endLineNumber) {
        const D = g.getStartPosition();
        D.lineNumber < a.getLineCount() ? (b = p + 1, w = a.getLineMaxColumn(b)) : (b = D.lineNumber, w = a.getLineMaxColumn(D.lineNumber));
      } else
        b = g.endLineNumber, w = a.getLineMaxColumn(b);
      let S = a.getLineContent(p);
      for (let D = p + 1; D <= b; D++) {
        const E = a.getLineContent(D), L = a.getLineFirstNonWhitespaceColumn(D);
        if (L >= 1) {
          let k = !0;
          S === "" && (k = !1), k && (S.charAt(S.length - 1) === " " || S.charAt(S.length - 1) === "	") && (k = !1, S = S.replace(/[\s\uFEFF\xA0]+$/g, " "));
          const N = E.substr(L - 1);
          S += (k ? " " : "") + N, k ? _ = N.length + 1 : _ = N.length;
        } else
          _ = 0;
      }
      const x = new V(p, m, b, w);
      if (!x.isEmpty()) {
        let D;
        g.isEmpty() ? (l.push(Si.replace(x, S)), D = new ot(x.startLineNumber - u, S.length - _ + 1, p - u, S.length - _ + 1)) : g.startLineNumber === g.endLineNumber ? (l.push(Si.replace(x, S)), D = new ot(g.startLineNumber - u, g.startColumn, g.endLineNumber - u, g.endColumn)) : (l.push(Si.replace(x, S)), D = new ot(g.startLineNumber - u, g.startColumn, g.startLineNumber - u, S.length - y)), V.intersectRanges(x, r) !== null ? d = D : c.push(D);
      }
      u += x.endLineNumber - x.startLineNumber;
    }
    c.unshift(d), t.pushUndoStop(), t.executeEdits(this.id, l, c), t.pushUndoStop();
  }
}
class wrt extends Je {
  constructor() {
    super({
      id: "editor.action.transpose",
      label: C("editor.transpose", "Transpose Characters around the Cursor"),
      alias: "Transpose Characters around the Cursor",
      precondition: $.writable
    });
  }
  run(e, t) {
    const n = t.getSelections();
    if (n === null)
      return;
    const r = t.getModel();
    if (r === null)
      return;
    const s = [];
    for (let o = 0, a = n.length; o < a; o++) {
      const l = n[o];
      if (!l.isEmpty())
        continue;
      const c = l.getStartPosition(), d = r.getLineMaxColumn(c.lineNumber);
      if (c.column >= d) {
        if (c.lineNumber === r.getLineCount())
          continue;
        const u = new V(c.lineNumber, Math.max(1, c.column - 1), c.lineNumber + 1, 1), h = r.getValueInRange(u).split("").reverse().join("");
        s.push(new vs(new ot(c.lineNumber, Math.max(1, c.column - 1), c.lineNumber + 1, 1), h));
      } else {
        const u = new V(c.lineNumber, Math.max(1, c.column - 1), c.lineNumber, c.column + 1), h = r.getValueInRange(u).split("").reverse().join("");
        s.push(new Dz(u, h, new ot(c.lineNumber, c.column + 1, c.lineNumber, c.column + 1)));
      }
    }
    t.pushUndoStop(), t.executeCommands(this.id, s), t.pushUndoStop();
  }
}
class Ab extends Je {
  run(e, t) {
    const n = t.getSelections();
    if (n === null)
      return;
    const r = t.getModel();
    if (r === null)
      return;
    const s = t.getOption(
      129
      /* EditorOption.wordSeparators */
    ), o = [];
    for (const a of n)
      if (a.isEmpty()) {
        const l = a.getStartPosition(), c = t.getConfiguredWordAtPosition(l);
        if (!c)
          continue;
        const d = new V(l.lineNumber, c.startColumn, l.lineNumber, c.endColumn), u = r.getValueInRange(d);
        o.push(Si.replace(d, this._modifyText(u, s)));
      } else {
        const l = r.getValueInRange(a);
        o.push(Si.replace(a, this._modifyText(l, s)));
      }
    t.pushUndoStop(), t.executeEdits(this.id, o), t.pushUndoStop();
  }
}
class Srt extends Ab {
  constructor() {
    super({
      id: "editor.action.transformToUppercase",
      label: C("editor.transformToUppercase", "Transform to Uppercase"),
      alias: "Transform to Uppercase",
      precondition: $.writable
    });
  }
  _modifyText(e, t) {
    return e.toLocaleUpperCase();
  }
}
class xrt extends Ab {
  constructor() {
    super({
      id: "editor.action.transformToLowercase",
      label: C("editor.transformToLowercase", "Transform to Lowercase"),
      alias: "Transform to Lowercase",
      precondition: $.writable
    });
  }
  _modifyText(e, t) {
    return e.toLocaleLowerCase();
  }
}
class Y0 {
  constructor(e, t) {
    this._pattern = e, this._flags = t, this._actual = null, this._evaluated = !1;
  }
  get() {
    if (!this._evaluated) {
      this._evaluated = !0;
      try {
        this._actual = new RegExp(this._pattern, this._flags);
      } catch {
      }
    }
    return this._actual;
  }
  isSupported() {
    return this.get() !== null;
  }
}
class Hw extends Ab {
  constructor() {
    super({
      id: "editor.action.transformToTitlecase",
      label: C("editor.transformToTitlecase", "Transform to Title Case"),
      alias: "Transform to Title Case",
      precondition: $.writable
    });
  }
  _modifyText(e, t) {
    const n = Hw.titleBoundary.get();
    return n ? e.toLocaleLowerCase().replace(n, (r) => r.toLocaleUpperCase()) : e;
  }
}
Hw.titleBoundary = new Y0("(^|[^\\p{L}\\p{N}']|((^|\\P{L})'))\\p{L}", "gmu");
class Ig extends Ab {
  constructor() {
    super({
      id: "editor.action.transformToSnakecase",
      label: C("editor.transformToSnakecase", "Transform to Snake Case"),
      alias: "Transform to Snake Case",
      precondition: $.writable
    });
  }
  _modifyText(e, t) {
    const n = Ig.caseBoundary.get(), r = Ig.singleLetters.get();
    return !n || !r ? e : e.replace(n, "$1_$2").replace(r, "$1_$2$3").toLocaleLowerCase();
  }
}
Ig.caseBoundary = new Y0("(\\p{Ll})(\\p{Lu})", "gmu");
Ig.singleLetters = new Y0("(\\p{Lu}|\\p{N})(\\p{Lu})(\\p{Ll})", "gmu");
class Ww extends Ab {
  constructor() {
    super({
      id: "editor.action.transformToCamelcase",
      label: C("editor.transformToCamelcase", "Transform to Camel Case"),
      alias: "Transform to Camel Case",
      precondition: $.writable
    });
  }
  _modifyText(e, t) {
    const n = Ww.wordBoundary.get();
    if (!n)
      return e;
    const r = e.split(n);
    return r.shift() + r.map((o) => o.substring(0, 1).toLocaleUpperCase() + o.substring(1)).join("");
  }
}
Ww.wordBoundary = new Y0("[_\\s-]", "gm");
class Gh extends Ab {
  static isSupported() {
    return [
      this.caseBoundary,
      this.singleLetters,
      this.underscoreBoundary
    ].every((t) => t.isSupported());
  }
  constructor() {
    super({
      id: "editor.action.transformToKebabcase",
      label: C("editor.transformToKebabcase", "Transform to Kebab Case"),
      alias: "Transform to Kebab Case",
      precondition: $.writable
    });
  }
  _modifyText(e, t) {
    const n = Gh.caseBoundary.get(), r = Gh.singleLetters.get(), s = Gh.underscoreBoundary.get();
    return !n || !r || !s ? e : e.replace(s, "$1-$3").replace(n, "$1-$2").replace(r, "$1-$2").toLocaleLowerCase();
  }
}
Gh.caseBoundary = new Y0("(\\p{Ll})(\\p{Lu})", "gmu");
Gh.singleLetters = new Y0("(\\p{Lu}|\\p{N})(\\p{Lu}\\p{Ll})", "gmu");
Gh.underscoreBoundary = new Y0("(\\S)(_)(\\S)", "gm");
Be(ort);
Be(art);
Be(lrt);
Be(crt);
Be(drt);
Be(urt);
Be(hrt);
Be(frt);
Be(z5);
Be(grt);
Be(prt);
Be(mrt);
Be(vrt);
Be(_rt);
Be(brt);
Be(Crt);
Be(yrt);
Be(wrt);
Be(Srt);
Be(xrt);
Ig.caseBoundary.isSupported() && Ig.singleLetters.isSupported() && Be(Ig);
Ww.wordBoundary.isSupported() && Be(Ww);
Hw.titleBoundary.isSupported() && Be(Hw);
Gh.isSupported() && Be(Gh);
var Drt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, YD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, FH = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, fE;
const sve = new Ke("LinkedEditingInputVisible", !1), Ert = "linked-editing-decoration";
let tp = fE = class extends we {
  static get(e) {
    return e.getContribution(fE.ID);
  }
  constructor(e, t, n, r, s) {
    super(), this.languageConfigurationService = r, this._syncRangesToken = 0, this._localToDispose = this._register(new Ne()), this._editor = e, this._providers = n.linkedEditingRangeProvider, this._enabled = !1, this._visibleContextKey = sve.bindTo(t), this._debounceInformation = s.for(this._providers, "Linked Editing", { max: 200 }), this._currentDecorations = this._editor.createDecorationsCollection(), this._languageWordPattern = null, this._currentWordPattern = null, this._ignoreChangeEvent = !1, this._localToDispose = this._register(new Ne()), this._rangeUpdateTriggerPromise = null, this._rangeSyncTriggerPromise = null, this._currentRequest = null, this._currentRequestPosition = null, this._currentRequestModelVersion = null, this._register(this._editor.onDidChangeModel(() => this.reinitialize(!0))), this._register(this._editor.onDidChangeConfiguration((o) => {
      (o.hasChanged(
        69
        /* EditorOption.linkedEditing */
      ) || o.hasChanged(
        92
        /* EditorOption.renameOnType */
      )) && this.reinitialize(!1);
    })), this._register(this._providers.onDidChange(() => this.reinitialize(!1))), this._register(this._editor.onDidChangeModelLanguage(() => this.reinitialize(!0))), this.reinitialize(!0);
  }
  reinitialize(e) {
    const t = this._editor.getModel(), n = t !== null && (this._editor.getOption(
      69
      /* EditorOption.linkedEditing */
    ) || this._editor.getOption(
      92
      /* EditorOption.renameOnType */
    )) && this._providers.has(t);
    if (n === this._enabled && !e || (this._enabled = n, this.clearRanges(), this._localToDispose.clear(), !n || t === null))
      return;
    this._localToDispose.add(qe.runAndSubscribe(t.onDidChangeLanguageConfiguration, () => {
      this._languageWordPattern = this.languageConfigurationService.getLanguageConfiguration(t.getLanguageId()).getWordDefinition();
    }));
    const r = new ac(this._debounceInformation.get(t)), s = () => {
      var l;
      this._rangeUpdateTriggerPromise = r.trigger(() => this.updateRanges(), (l = this._debounceDuration) !== null && l !== void 0 ? l : this._debounceInformation.get(t));
    }, o = new ac(0), a = (l) => {
      this._rangeSyncTriggerPromise = o.trigger(() => this._syncRanges(l));
    };
    this._localToDispose.add(this._editor.onDidChangeCursorPosition(() => {
      s();
    })), this._localToDispose.add(this._editor.onDidChangeModelContent((l) => {
      if (!this._ignoreChangeEvent && this._currentDecorations.length > 0) {
        const c = this._currentDecorations.getRange(0);
        if (c && l.changes.every((d) => c.intersectRanges(d.range))) {
          a(this._syncRangesToken);
          return;
        }
      }
      s();
    })), this._localToDispose.add({
      dispose: () => {
        r.dispose(), o.dispose();
      }
    }), this.updateRanges();
  }
  _syncRanges(e) {
    if (!this._editor.hasModel() || e !== this._syncRangesToken || this._currentDecorations.length === 0)
      return;
    const t = this._editor.getModel(), n = this._currentDecorations.getRange(0);
    if (!n || n.startLineNumber !== n.endLineNumber)
      return this.clearRanges();
    const r = t.getValueInRange(n);
    if (this._currentWordPattern) {
      const o = r.match(this._currentWordPattern);
      if ((o ? o[0].length : 0) !== r.length)
        return this.clearRanges();
    }
    const s = [];
    for (let o = 1, a = this._currentDecorations.length; o < a; o++) {
      const l = this._currentDecorations.getRange(o);
      if (l)
        if (l.startLineNumber !== l.endLineNumber)
          s.push({
            range: l,
            text: r
          });
        else {
          let c = t.getValueInRange(l), d = r, u = l.startColumn, h = l.endColumn;
          const f = Um(c, d);
          u += f, c = c.substr(f), d = d.substr(f);
          const g = YE(c, d);
          h -= g, c = c.substr(0, c.length - g), d = d.substr(0, d.length - g), (u !== h || d.length !== 0) && s.push({
            range: new V(l.startLineNumber, u, l.endLineNumber, h),
            text: d
          });
        }
    }
    if (s.length !== 0)
      try {
        this._editor.popUndoStop(), this._ignoreChangeEvent = !0;
        const o = this._editor._getViewModel().getPrevEditOperationType();
        this._editor.executeEdits("linkedEditing", s), this._editor._getViewModel().setPrevEditOperationType(o);
      } finally {
        this._ignoreChangeEvent = !1;
      }
  }
  dispose() {
    this.clearRanges(), super.dispose();
  }
  clearRanges() {
    this._visibleContextKey.set(!1), this._currentDecorations.clear(), this._currentRequest && (this._currentRequest.cancel(), this._currentRequest = null, this._currentRequestPosition = null);
  }
  updateRanges(e = !1) {
    return FH(this, void 0, void 0, function* () {
      if (!this._editor.hasModel()) {
        this.clearRanges();
        return;
      }
      const t = this._editor.getPosition();
      if (!this._enabled && !e || this._editor.getSelections().length > 1) {
        this.clearRanges();
        return;
      }
      const n = this._editor.getModel(), r = n.getVersionId();
      if (this._currentRequestPosition && this._currentRequestModelVersion === r) {
        if (t.equals(this._currentRequestPosition))
          return;
        if (this._currentDecorations.length > 0) {
          const o = this._currentDecorations.getRange(0);
          if (o && o.containsPosition(t))
            return;
        }
      }
      this.clearRanges(), this._currentRequestPosition = t, this._currentRequestModelVersion = r;
      const s = Ir((o) => FH(this, void 0, void 0, function* () {
        try {
          const a = new Vs(!1), l = yield ove(this._providers, n, t, o);
          if (this._debounceInformation.update(n, a.elapsed()), s !== this._currentRequest || (this._currentRequest = null, r !== n.getVersionId()))
            return;
          let c = [];
          l?.ranges && (c = l.ranges), this._currentWordPattern = l?.wordPattern || this._languageWordPattern;
          let d = !1;
          for (let h = 0, f = c.length; h < f; h++)
            if (V.containsPosition(c[h], t)) {
              if (d = !0, h !== 0) {
                const g = c[h];
                c.splice(h, 1), c.unshift(g);
              }
              break;
            }
          if (!d) {
            this.clearRanges();
            return;
          }
          const u = c.map((h) => ({ range: h, options: fE.DECORATION }));
          this._visibleContextKey.set(!0), this._currentDecorations.set(u), this._syncRangesToken++;
        } catch (a) {
          md(a) || It(a), (this._currentRequest === s || !this._currentRequest) && this.clearRanges();
        }
      }));
      return this._currentRequest = s, s;
    });
  }
};
tp.ID = "editor.contrib.linkedEditing";
tp.DECORATION = Lt.register({
  description: "linked-editing",
  stickiness: 0,
  className: Ert
});
tp = fE = Drt([
  YD(1, yt),
  YD(2, tt),
  YD(3, Un),
  YD(4, kl)
], tp);
class Lrt extends Je {
  constructor() {
    super({
      id: "editor.action.linkedEditing",
      label: C("linkedEditing.label", "Start Linked Editing"),
      alias: "Start Linked Editing",
      precondition: ke.and($.writable, $.hasRenameProvider),
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 3132,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  runCommand(e, t) {
    const n = e.get(Sn), [r, s] = Array.isArray(t) && t || [void 0, void 0];
    return pt.isUri(r) && ve.isIPosition(s) ? n.openCodeEditor({ resource: r }, n.getActiveCodeEditor()).then((o) => {
      o && (o.setPosition(s), o.invokeWithinContext((a) => (this.reportTelemetry(a, o), this.run(a, o))));
    }, It) : super.runCommand(e, t);
  }
  run(e, t) {
    const n = tp.get(t);
    return n ? Promise.resolve(n.updateRanges(!0)) : Promise.resolve();
  }
}
const Irt = Kr.bindToContribution(tp.get);
ze(new Irt({
  id: "cancelLinkedEditingInput",
  precondition: sve,
  handler: (i) => i.clearRanges(),
  kbOpts: {
    kbExpr: $.editorTextFocus,
    weight: 199,
    primary: 9,
    secondary: [
      1033
      /* KeyCode.Escape */
    ]
  }
}));
function ove(i, e, t, n) {
  const r = i.ordered(e);
  return Zhe(r.map((s) => () => FH(this, void 0, void 0, function* () {
    try {
      return yield s.provideLinkedEditingRanges(e, t, n);
    } catch (o) {
      vr(o);
      return;
    }
  })), (s) => !!s && Bs(s?.ranges));
}
ne("editor.linkedEditingBackground", { dark: ye.fromHex("#f00").transparent(0.3), light: ye.fromHex("#f00").transparent(0.3), hcDark: ye.fromHex("#f00").transparent(0.3), hcLight: ye.white }, C("editorLinkedEditingBackground", "Background color when the editor auto renames on type."));
Ru("_executeLinkedEditingProvider", (i, e, t) => {
  const { linkedEditingRangeProvider: n } = i.get(tt);
  return ove(n, e, t, jt.None);
});
pn(
  tp.ID,
  tp,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
Be(Lrt);
var ave = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let Art = class {
  constructor(e, t) {
    this._link = e, this._provider = t;
  }
  toJSON() {
    return {
      range: this.range,
      url: this.url,
      tooltip: this.tooltip
    };
  }
  get range() {
    return this._link.range;
  }
  get url() {
    return this._link.url;
  }
  get tooltip() {
    return this._link.tooltip;
  }
  resolve(e) {
    return ave(this, void 0, void 0, function* () {
      return this._link.url ? this._link.url : typeof this._provider.resolveLink == "function" ? Promise.resolve(this._provider.resolveLink(this._link, e)).then((t) => (this._link = t || this._link, this._link.url ? this.resolve(e) : Promise.reject(new Error("missing")))) : Promise.reject(new Error("missing"));
    });
  }
};
class MI {
  constructor(e) {
    this._disposables = new Ne();
    let t = [];
    for (const [n, r] of e) {
      const s = n.links.map((o) => new Art(o, r));
      t = MI._union(t, s), kj(n) && this._disposables.add(n);
    }
    this.links = t;
  }
  dispose() {
    this._disposables.dispose(), this.links.length = 0;
  }
  static _union(e, t) {
    const n = [];
    let r, s, o, a;
    for (r = 0, o = 0, s = e.length, a = t.length; r < s && o < a; ) {
      const l = e[r], c = t[o];
      if (V.areIntersectingOrTouching(l.range, c.range)) {
        r++;
        continue;
      }
      V.compareRangesUsingStarts(l.range, c.range) < 0 ? (n.push(l), r++) : (n.push(c), o++);
    }
    for (; r < s; r++)
      n.push(e[r]);
    for (; o < a; o++)
      n.push(t[o]);
    return n;
  }
}
function lve(i, e, t) {
  const n = [], r = i.ordered(e).reverse().map((s, o) => Promise.resolve(s.provideLinks(e, t)).then((a) => {
    a && (n[o] = [a, s]);
  }, vr));
  return Promise.all(r).then(() => {
    const s = new MI(_u(n));
    return t.isCancellationRequested ? (s.dispose(), new MI([])) : s;
  });
}
on.registerCommand("_executeLinkProvider", (i, ...e) => ave(void 0, void 0, void 0, function* () {
  let [t, n] = e;
  On(t instanceof pt), typeof n != "number" && (n = 0);
  const { linkProvider: r } = i.get(tt), s = i.get(fi).getModel(t);
  if (!s)
    return [];
  const o = yield lve(r, s, jt.None);
  if (!o)
    return [];
  for (let l = 0; l < Math.min(n, o.links.length); l++)
    yield o.links[l].resolve(jt.None);
  const a = o.links.slice(0);
  return o.dispose(), a;
}));
var krt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, XD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Trt = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, BH;
let Y_ = BH = class extends we {
  static get(e) {
    return e.getContribution(BH.ID);
  }
  constructor(e, t, n, r, s) {
    super(), this.editor = e, this.openerService = t, this.notificationService = n, this.languageFeaturesService = r, this.providers = this.languageFeaturesService.linkProvider, this.debounceInformation = s.for(this.providers, "Links", { min: 1e3, max: 4e3 }), this.computeLinks = this._register(new Rn(() => this.computeLinksNow(), 1e3)), this.computePromise = null, this.activeLinksList = null, this.currentOccurrences = {}, this.activeLinkDecorationId = null;
    const o = this._register(new u5(e));
    this._register(o.onMouseMoveOrRelevantKeyDown(([a, l]) => {
      this._onEditorMouseMove(a, l);
    })), this._register(o.onExecute((a) => {
      this.onEditorMouseUp(a);
    })), this._register(o.onCancel((a) => {
      this.cleanUpActiveLinkDecoration();
    })), this._register(e.onDidChangeConfiguration((a) => {
      a.hasChanged(
        70
        /* EditorOption.links */
      ) && (this.updateDecorations([]), this.stop(), this.computeLinks.schedule(0));
    })), this._register(e.onDidChangeModelContent((a) => {
      this.editor.hasModel() && this.computeLinks.schedule(this.debounceInformation.get(this.editor.getModel()));
    })), this._register(e.onDidChangeModel((a) => {
      this.currentOccurrences = {}, this.activeLinkDecorationId = null, this.stop(), this.computeLinks.schedule(0);
    })), this._register(e.onDidChangeModelLanguage((a) => {
      this.stop(), this.computeLinks.schedule(0);
    })), this._register(this.providers.onDidChange((a) => {
      this.stop(), this.computeLinks.schedule(0);
    })), this.computeLinks.schedule(0);
  }
  computeLinksNow() {
    return Trt(this, void 0, void 0, function* () {
      if (!this.editor.hasModel() || !this.editor.getOption(
        70
        /* EditorOption.links */
      ))
        return;
      const e = this.editor.getModel();
      if (!e.isTooLargeForSyncing() && this.providers.has(e)) {
        this.activeLinksList && (this.activeLinksList.dispose(), this.activeLinksList = null), this.computePromise = Ir((t) => lve(this.providers, e, t));
        try {
          const t = new Vs(!1);
          if (this.activeLinksList = yield this.computePromise, this.debounceInformation.update(e, t.elapsed()), e.isDisposed())
            return;
          this.updateDecorations(this.activeLinksList.links);
        } catch (t) {
          It(t);
        } finally {
          this.computePromise = null;
        }
      }
    });
  }
  updateDecorations(e) {
    const t = this.editor.getOption(
      77
      /* EditorOption.multiCursorModifier */
    ) === "altKey", n = [], r = Object.keys(this.currentOccurrences);
    for (const o of r) {
      const a = this.currentOccurrences[o];
      n.push(a.decorationId);
    }
    const s = [];
    if (e)
      for (const o of e)
        s.push(Xv.decoration(o, t));
    this.editor.changeDecorations((o) => {
      const a = o.deltaDecorations(n, s);
      this.currentOccurrences = {}, this.activeLinkDecorationId = null;
      for (let l = 0, c = a.length; l < c; l++) {
        const d = new Xv(e[l], a[l]);
        this.currentOccurrences[d.decorationId] = d;
      }
    });
  }
  _onEditorMouseMove(e, t) {
    const n = this.editor.getOption(
      77
      /* EditorOption.multiCursorModifier */
    ) === "altKey";
    if (this.isEnabled(e, t)) {
      this.cleanUpActiveLinkDecoration();
      const r = this.getLinkOccurrence(e.target.position);
      r && this.editor.changeDecorations((s) => {
        r.activate(s, n), this.activeLinkDecorationId = r.decorationId;
      });
    } else
      this.cleanUpActiveLinkDecoration();
  }
  cleanUpActiveLinkDecoration() {
    const e = this.editor.getOption(
      77
      /* EditorOption.multiCursorModifier */
    ) === "altKey";
    if (this.activeLinkDecorationId) {
      const t = this.currentOccurrences[this.activeLinkDecorationId];
      t && this.editor.changeDecorations((n) => {
        t.deactivate(n, e);
      }), this.activeLinkDecorationId = null;
    }
  }
  onEditorMouseUp(e) {
    if (!this.isEnabled(e))
      return;
    const t = this.getLinkOccurrence(e.target.position);
    t && this.openLinkOccurrence(
      t,
      e.hasSideBySideModifier,
      !0
      /* from user gesture */
    );
  }
  openLinkOccurrence(e, t, n = !1) {
    if (!this.openerService)
      return;
    const { link: r } = e;
    r.resolve(jt.None).then((s) => {
      if (typeof s == "string" && this.editor.hasModel()) {
        const o = this.editor.getModel().uri;
        if (o.scheme === Mt.file && s.startsWith(`${Mt.file}:`)) {
          const a = pt.parse(s);
          if (a.scheme === Mt.file) {
            const l = Ld(a);
            let c = null;
            l.startsWith("/./") ? c = `.${l.substr(1)}` : l.startsWith("//./") && (c = `.${l.substr(2)}`), c && (s = GBe(o, c));
          }
        }
      }
      return this.openerService.open(s, { openToSide: t, fromUserGesture: n, allowContributedOpeners: !0, allowCommands: !0, fromWorkspace: !0 });
    }, (s) => {
      const o = s instanceof Error ? s.message : s;
      o === "invalid" ? this.notificationService.warn(C("invalid.url", "Failed to open this link because it is not well-formed: {0}", r.url.toString())) : o === "missing" ? this.notificationService.warn(C("missing.url", "Failed to open this link because its target is missing.")) : It(s);
    });
  }
  getLinkOccurrence(e) {
    if (!this.editor.hasModel() || !e)
      return null;
    const t = this.editor.getModel().getDecorationsInRange({
      startLineNumber: e.lineNumber,
      startColumn: e.column,
      endLineNumber: e.lineNumber,
      endColumn: e.column
    }, 0, !0);
    for (const n of t) {
      const r = this.currentOccurrences[n.id];
      if (r)
        return r;
    }
    return null;
  }
  isEnabled(e, t) {
    return !!(e.target.type === 6 && (e.hasTriggerModifier || t && t.keyCodeIsTriggerKey));
  }
  stop() {
    var e;
    this.computeLinks.cancel(), this.activeLinksList && ((e = this.activeLinksList) === null || e === void 0 || e.dispose(), this.activeLinksList = null), this.computePromise && (this.computePromise.cancel(), this.computePromise = null);
  }
  dispose() {
    super.dispose(), this.stop();
  }
};
Y_.ID = "editor.linkDetector";
Y_ = BH = krt([
  XD(1, da),
  XD(2, dr),
  XD(3, tt),
  XD(4, kl)
], Y_);
const Eee = {
  general: Lt.register({
    description: "detected-link",
    stickiness: 1,
    collapseOnReplaceEdit: !0,
    inlineClassName: "detected-link"
  }),
  active: Lt.register({
    description: "detected-link-active",
    stickiness: 1,
    collapseOnReplaceEdit: !0,
    inlineClassName: "detected-link-active"
  })
};
class Xv {
  static decoration(e, t) {
    return {
      range: e.range,
      options: Xv._getOptions(e, t, !1)
    };
  }
  static _getOptions(e, t, n) {
    const r = Object.assign({}, n ? Eee.active : Eee.general);
    return r.hoverMessage = Nrt(e, t), r;
  }
  constructor(e, t) {
    this.link = e, this.decorationId = t;
  }
  activate(e, t) {
    e.changeDecorationOptions(this.decorationId, Xv._getOptions(this.link, t, !0));
  }
  deactivate(e, t) {
    e.changeDecorationOptions(this.decorationId, Xv._getOptions(this.link, t, !1));
  }
}
function Nrt(i, e) {
  const t = i.url && /^command:/i.test(i.url.toString()), n = i.tooltip ? i.tooltip : t ? C("links.navigate.executeCmd", "Execute command") : C("links.navigate.follow", "Follow link"), r = e ? sn ? C("links.navigate.kb.meta.mac", "cmd + click") : C("links.navigate.kb.meta", "ctrl + click") : sn ? C("links.navigate.kb.alt.mac", "option + click") : C("links.navigate.kb.alt", "alt + click");
  if (i.url) {
    let s = "";
    if (/^command:/i.test(i.url.toString())) {
      const a = i.url.toString().match(/^command:([^?#]+)/);
      if (a) {
        const l = a[1];
        s = C("tooltip.explanation", "Execute command {0}", l);
      }
    }
    return new ys("", !0).appendLink(i.url.toString(!0).replace(/ /g, "%20"), n, s).appendMarkdown(` (${r})`);
  } else
    return new ys().appendText(`${n} (${r})`);
}
class Prt extends Je {
  constructor() {
    super({
      id: "editor.action.openLink",
      label: C("label", "Open Link"),
      alias: "Open Link",
      precondition: void 0
    });
  }
  run(e, t) {
    const n = Y_.get(t);
    if (!n || !t.hasModel())
      return;
    const r = t.getSelections();
    for (const s of r) {
      const o = n.getLinkOccurrence(s.getEndPosition());
      o && n.openLinkOccurrence(o, !1);
    }
  }
}
pn(
  Y_.ID,
  Y_,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
Be(Prt);
class VH extends we {
  constructor(e) {
    super(), this._editor = e, this._register(this._editor.onMouseDown((t) => {
      const n = this._editor.getOption(
        116
        /* EditorOption.stopRenderingLineAfter */
      );
      n >= 0 && t.target.type === 6 && t.target.position.column >= n && this._editor.updateOptions({
        stopRenderingLineAfter: -1
      });
    }));
  }
}
VH.ID = "editor.contrib.longLinesHelper";
pn(
  VH.ID,
  VH,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
const ZD = ne("editor.wordHighlightBackground", { dark: "#575757B8", light: "#57575740", hcDark: null, hcLight: null }, C("wordHighlight", "Background color of a symbol during read-access, like reading a variable. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("editor.wordHighlightStrongBackground", { dark: "#004972B8", light: "#0e639c40", hcDark: null, hcLight: null }, C("wordHighlightStrong", "Background color of a symbol during write-access, like writing to a variable. The color must not be opaque so as not to hide underlying decorations."), !0);
ne("editor.wordHighlightTextBackground", { light: ZD, dark: ZD, hcDark: ZD, hcLight: ZD }, C("wordHighlightText", "Background color of a textual occurrence for a symbol. The color must not be opaque so as not to hide underlying decorations."), !0);
const QD = ne("editor.wordHighlightBorder", { light: null, dark: null, hcDark: ii, hcLight: ii }, C("wordHighlightBorder", "Border color of a symbol during read-access, like reading a variable."));
ne("editor.wordHighlightStrongBorder", { light: null, dark: null, hcDark: ii, hcLight: ii }, C("wordHighlightStrongBorder", "Border color of a symbol during write-access, like writing to a variable."));
ne("editor.wordHighlightTextBorder", { light: QD, dark: QD, hcDark: QD, hcLight: QD }, C("wordHighlightTextBorder", "Border color of a textual occurrence for a symbol."));
const Ort = ne("editorOverviewRuler.wordHighlightForeground", { dark: "#A0A0A0CC", light: "#A0A0A0CC", hcDark: "#A0A0A0CC", hcLight: "#A0A0A0CC" }, C("overviewRulerWordHighlightForeground", "Overview ruler marker color for symbol highlights. The color must not be opaque so as not to hide underlying decorations."), !0), Mrt = ne("editorOverviewRuler.wordHighlightStrongForeground", { dark: "#C0A0C0CC", light: "#C0A0C0CC", hcDark: "#C0A0C0CC", hcLight: "#C0A0C0CC" }, C("overviewRulerWordHighlightStrongForeground", "Overview ruler marker color for write-access symbol highlights. The color must not be opaque so as not to hide underlying decorations."), !0), Rrt = ne("editorOverviewRuler.wordHighlightTextForeground", { dark: Z2, light: Z2, hcDark: Z2, hcLight: Z2 }, C("overviewRulerWordHighlightTextForeground", "Overview ruler marker color of a textual occurrence for a symbol. The color must not be opaque so as not to hide underlying decorations."), !0), Frt = Lt.register({
  description: "word-highlight-strong",
  stickiness: 1,
  className: "wordHighlightStrong",
  overviewRuler: {
    color: Oi(Mrt),
    position: Ha.Center
  },
  minimap: {
    color: Oi(m4),
    position: ia.Inline
  }
}), Brt = Lt.register({
  description: "word-highlight-text",
  stickiness: 1,
  className: "wordHighlightText",
  overviewRuler: {
    color: Oi(Rrt),
    position: Ha.Center
  },
  minimap: {
    color: Oi(m4),
    position: ia.Inline
  }
}), Vrt = Lt.register({
  description: "selection-highlight-overview",
  stickiness: 1,
  className: "selectionHighlight",
  overviewRuler: {
    color: Oi(Z2),
    position: Ha.Center
  },
  minimap: {
    color: Oi(m4),
    position: ia.Inline
  }
}), Hrt = Lt.register({
  description: "selection-highlight",
  stickiness: 1,
  className: "selectionHighlight"
}), Wrt = Lt.register({
  description: "word-highlight",
  stickiness: 1,
  className: "wordHighlight",
  overviewRuler: {
    color: Oi(Ort),
    position: Ha.Center
  },
  minimap: {
    color: Oi(m4),
    position: ia.Inline
  }
});
function jrt(i) {
  return i === xy.Write ? Frt : i === xy.Text ? Brt : Wrt;
}
function zrt(i) {
  return i ? Hrt : Vrt;
}
fc((i, e) => {
  const t = i.getColor(pz);
  t && e.addRule(`.monaco-editor .selectionHighlight { background-color: ${t.transparent(0.5)}; }`);
});
var Urt = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Grt = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, HH;
function pp(i, e) {
  const t = e.filter((n) => !i.find((r) => r.equals(n)));
  if (t.length >= 1) {
    const n = t.map((s) => `line ${s.viewState.position.lineNumber} column ${s.viewState.position.column}`).join(", "), r = t.length === 1 ? C("cursorAdded", "Cursor added: {0}", n) : C("cursorsAdded", "Cursors added: {0}", n);
    Vg(r);
  }
}
class qrt extends Je {
  constructor() {
    super({
      id: "editor.action.insertCursorAbove",
      label: C("mutlicursor.insertAbove", "Add Cursor Above"),
      alias: "Add Cursor Above",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 2576,
        linux: {
          primary: 1552,
          secondary: [
            3088
            /* KeyCode.UpArrow */
          ]
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "3_multi",
        title: C({ key: "miInsertCursorAbove", comment: ["&& denotes a mnemonic"] }, "&&Add Cursor Above"),
        order: 2
      }
    });
  }
  run(e, t, n) {
    if (!t.hasModel())
      return;
    let r = !0;
    n && n.logicalLine === !1 && (r = !1);
    const s = t._getViewModel();
    if (s.cursorConfig.readOnly)
      return;
    s.model.pushStackElement();
    const o = s.getCursorStates();
    s.setCursorStates(n.source, 3, Qr.addCursorUp(s, o, r)), s.revealTopMostCursor(n.source), pp(o, s.getCursorStates());
  }
}
class Krt extends Je {
  constructor() {
    super({
      id: "editor.action.insertCursorBelow",
      label: C("mutlicursor.insertBelow", "Add Cursor Below"),
      alias: "Add Cursor Below",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 2578,
        linux: {
          primary: 1554,
          secondary: [
            3090
            /* KeyCode.DownArrow */
          ]
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "3_multi",
        title: C({ key: "miInsertCursorBelow", comment: ["&& denotes a mnemonic"] }, "A&&dd Cursor Below"),
        order: 3
      }
    });
  }
  run(e, t, n) {
    if (!t.hasModel())
      return;
    let r = !0;
    n && n.logicalLine === !1 && (r = !1);
    const s = t._getViewModel();
    if (s.cursorConfig.readOnly)
      return;
    s.model.pushStackElement();
    const o = s.getCursorStates();
    s.setCursorStates(n.source, 3, Qr.addCursorDown(s, o, r)), s.revealBottomMostCursor(n.source), pp(o, s.getCursorStates());
  }
}
class Yrt extends Je {
  constructor() {
    super({
      id: "editor.action.insertCursorAtEndOfEachLineSelected",
      label: C("mutlicursor.insertAtEndOfEachLineSelected", "Add Cursors to Line Ends"),
      alias: "Add Cursors to Line Ends",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 1575,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "3_multi",
        title: C({ key: "miInsertCursorAtEndOfEachLineSelected", comment: ["&& denotes a mnemonic"] }, "Add C&&ursors to Line Ends"),
        order: 4
      }
    });
  }
  getCursorsForSelection(e, t, n) {
    if (!e.isEmpty()) {
      for (let r = e.startLineNumber; r < e.endLineNumber; r++) {
        const s = t.getLineMaxColumn(r);
        n.push(new ot(r, s, r, s));
      }
      e.endColumn > 1 && n.push(new ot(e.endLineNumber, e.endColumn, e.endLineNumber, e.endColumn));
    }
  }
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = t.getModel(), r = t.getSelections(), s = t._getViewModel(), o = s.getCursorStates(), a = [];
    r.forEach((l) => this.getCursorsForSelection(l, n, a)), a.length > 0 && t.setSelections(a), pp(o, s.getCursorStates());
  }
}
class Xrt extends Je {
  constructor() {
    super({
      id: "editor.action.addCursorsToBottom",
      label: C("mutlicursor.addCursorsToBottom", "Add Cursors To Bottom"),
      alias: "Add Cursors To Bottom",
      precondition: void 0
    });
  }
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = t.getSelections(), r = t.getModel().getLineCount(), s = [];
    for (let l = n[0].startLineNumber; l <= r; l++)
      s.push(new ot(l, n[0].startColumn, l, n[0].endColumn));
    const o = t._getViewModel(), a = o.getCursorStates();
    s.length > 0 && t.setSelections(s), pp(a, o.getCursorStates());
  }
}
class Zrt extends Je {
  constructor() {
    super({
      id: "editor.action.addCursorsToTop",
      label: C("mutlicursor.addCursorsToTop", "Add Cursors To Top"),
      alias: "Add Cursors To Top",
      precondition: void 0
    });
  }
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = t.getSelections(), r = [];
    for (let a = n[0].startLineNumber; a >= 1; a--)
      r.push(new ot(a, n[0].startColumn, a, n[0].endColumn));
    const s = t._getViewModel(), o = s.getCursorStates();
    r.length > 0 && t.setSelections(r), pp(o, s.getCursorStates());
  }
}
class JD {
  constructor(e, t, n) {
    this.selections = e, this.revealRange = t, this.revealScrollType = n;
  }
}
class jw {
  static create(e, t) {
    if (!e.hasModel())
      return null;
    const n = t.getState();
    if (!e.hasTextFocus() && n.isRevealed && n.searchString.length > 0)
      return new jw(e, t, !1, n.searchString, n.wholeWord, n.matchCase, null);
    let r = !1, s, o;
    const a = e.getSelections();
    a.length === 1 && a[0].isEmpty() ? (r = !0, s = !0, o = !0) : (s = n.wholeWord, o = n.matchCase);
    const l = e.getSelection();
    let c, d = null;
    if (l.isEmpty()) {
      const u = e.getConfiguredWordAtPosition(l.getStartPosition());
      if (!u)
        return null;
      c = u.word, d = new ot(l.startLineNumber, u.startColumn, l.startLineNumber, u.endColumn);
    } else
      c = e.getModel().getValueInRange(l).replace(/\r\n/g, `
`);
    return new jw(e, t, r, c, s, o, d);
  }
  constructor(e, t, n, r, s, o, a) {
    this._editor = e, this.findController = t, this.isDisconnectedFromFindController = n, this.searchText = r, this.wholeWord = s, this.matchCase = o, this.currentMatch = a;
  }
  addSelectionToNextFindMatch() {
    if (!this._editor.hasModel())
      return null;
    const e = this._getNextMatch();
    if (!e)
      return null;
    const t = this._editor.getSelections();
    return new JD(
      t.concat(e),
      e,
      0
      /* ScrollType.Smooth */
    );
  }
  moveSelectionToNextFindMatch() {
    if (!this._editor.hasModel())
      return null;
    const e = this._getNextMatch();
    if (!e)
      return null;
    const t = this._editor.getSelections();
    return new JD(
      t.slice(0, t.length - 1).concat(e),
      e,
      0
      /* ScrollType.Smooth */
    );
  }
  _getNextMatch() {
    if (!this._editor.hasModel())
      return null;
    if (this.currentMatch) {
      const r = this.currentMatch;
      return this.currentMatch = null, r;
    }
    this.findController.highlightFindOptions();
    const e = this._editor.getSelections(), t = e[e.length - 1], n = this._editor.getModel().findNextMatch(this.searchText, t.getEndPosition(), !1, this.matchCase, this.wholeWord ? this._editor.getOption(
      129
      /* EditorOption.wordSeparators */
    ) : null, !1);
    return n ? new ot(n.range.startLineNumber, n.range.startColumn, n.range.endLineNumber, n.range.endColumn) : null;
  }
  addSelectionToPreviousFindMatch() {
    if (!this._editor.hasModel())
      return null;
    const e = this._getPreviousMatch();
    if (!e)
      return null;
    const t = this._editor.getSelections();
    return new JD(
      t.concat(e),
      e,
      0
      /* ScrollType.Smooth */
    );
  }
  moveSelectionToPreviousFindMatch() {
    if (!this._editor.hasModel())
      return null;
    const e = this._getPreviousMatch();
    if (!e)
      return null;
    const t = this._editor.getSelections();
    return new JD(
      t.slice(0, t.length - 1).concat(e),
      e,
      0
      /* ScrollType.Smooth */
    );
  }
  _getPreviousMatch() {
    if (!this._editor.hasModel())
      return null;
    if (this.currentMatch) {
      const r = this.currentMatch;
      return this.currentMatch = null, r;
    }
    this.findController.highlightFindOptions();
    const e = this._editor.getSelections(), t = e[e.length - 1], n = this._editor.getModel().findPreviousMatch(this.searchText, t.getStartPosition(), !1, this.matchCase, this.wholeWord ? this._editor.getOption(
      129
      /* EditorOption.wordSeparators */
    ) : null, !1);
    return n ? new ot(n.range.startLineNumber, n.range.startColumn, n.range.endLineNumber, n.range.endColumn) : null;
  }
  selectAll(e) {
    if (!this._editor.hasModel())
      return [];
    this.findController.highlightFindOptions();
    const t = this._editor.getModel();
    return e ? t.findMatches(
      this.searchText,
      e,
      !1,
      this.matchCase,
      this.wholeWord ? this._editor.getOption(
        129
        /* EditorOption.wordSeparators */
      ) : null,
      !1,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ) : t.findMatches(
      this.searchText,
      !0,
      !1,
      this.matchCase,
      this.wholeWord ? this._editor.getOption(
        129
        /* EditorOption.wordSeparators */
      ) : null,
      !1,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    );
  }
}
class m0 extends we {
  static get(e) {
    return e.getContribution(m0.ID);
  }
  constructor(e) {
    super(), this._sessionDispose = this._register(new Ne()), this._editor = e, this._ignoreSelectionChange = !1, this._session = null;
  }
  dispose() {
    this._endSession(), super.dispose();
  }
  _beginSessionIfNeeded(e) {
    if (!this._session) {
      const t = jw.create(this._editor, e);
      if (!t)
        return;
      this._session = t;
      const n = { searchString: this._session.searchText };
      this._session.isDisconnectedFromFindController && (n.wholeWordOverride = 1, n.matchCaseOverride = 1, n.isRegexOverride = 2), e.getState().change(n, !1), this._sessionDispose.add(this._editor.onDidChangeCursorSelection((r) => {
        this._ignoreSelectionChange || this._endSession();
      })), this._sessionDispose.add(this._editor.onDidBlurEditorText(() => {
        this._endSession();
      })), this._sessionDispose.add(e.getState().onFindReplaceStateChange((r) => {
        (r.matchCase || r.wholeWord) && this._endSession();
      }));
    }
  }
  _endSession() {
    if (this._sessionDispose.clear(), this._session && this._session.isDisconnectedFromFindController) {
      const e = {
        wholeWordOverride: 0,
        matchCaseOverride: 0,
        isRegexOverride: 0
      };
      this._session.findController.getState().change(e, !1);
    }
    this._session = null;
  }
  _setSelections(e) {
    this._ignoreSelectionChange = !0, this._editor.setSelections(e), this._ignoreSelectionChange = !1;
  }
  _expandEmptyToWord(e, t) {
    if (!t.isEmpty())
      return t;
    const n = this._editor.getConfiguredWordAtPosition(t.getStartPosition());
    return n ? new ot(t.startLineNumber, n.startColumn, t.startLineNumber, n.endColumn) : t;
  }
  _applySessionResult(e) {
    e && (this._setSelections(e.selections), e.revealRange && this._editor.revealRangeInCenterIfOutsideViewport(e.revealRange, e.revealScrollType));
  }
  getSession(e) {
    return this._session;
  }
  addSelectionToNextFindMatch(e) {
    if (this._editor.hasModel()) {
      if (!this._session) {
        const t = this._editor.getSelections();
        if (t.length > 1) {
          const r = e.getState().matchCase;
          if (!cve(this._editor.getModel(), t, r)) {
            const o = this._editor.getModel(), a = [];
            for (let l = 0, c = t.length; l < c; l++)
              a[l] = this._expandEmptyToWord(o, t[l]);
            this._editor.setSelections(a);
            return;
          }
        }
      }
      this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.addSelectionToNextFindMatch());
    }
  }
  addSelectionToPreviousFindMatch(e) {
    this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.addSelectionToPreviousFindMatch());
  }
  moveSelectionToNextFindMatch(e) {
    this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.moveSelectionToNextFindMatch());
  }
  moveSelectionToPreviousFindMatch(e) {
    this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.moveSelectionToPreviousFindMatch());
  }
  selectAll(e) {
    if (!this._editor.hasModel())
      return;
    let t = null;
    const n = e.getState();
    if (n.isRevealed && n.searchString.length > 0 && n.isRegex) {
      const r = this._editor.getModel();
      n.searchScope ? t = r.findMatches(
        n.searchString,
        n.searchScope,
        n.isRegex,
        n.matchCase,
        n.wholeWord ? this._editor.getOption(
          129
          /* EditorOption.wordSeparators */
        ) : null,
        !1,
        1073741824
        /* Constants.MAX_SAFE_SMALL_INTEGER */
      ) : t = r.findMatches(
        n.searchString,
        !0,
        n.isRegex,
        n.matchCase,
        n.wholeWord ? this._editor.getOption(
          129
          /* EditorOption.wordSeparators */
        ) : null,
        !1,
        1073741824
        /* Constants.MAX_SAFE_SMALL_INTEGER */
      );
    } else {
      if (this._beginSessionIfNeeded(e), !this._session)
        return;
      t = this._session.selectAll(n.searchScope);
    }
    if (t.length > 0) {
      const r = this._editor.getSelection();
      for (let s = 0, o = t.length; s < o; s++) {
        const a = t[s];
        if (a.range.intersectRanges(r)) {
          t[s] = t[0], t[0] = a;
          break;
        }
      }
      this._setSelections(t.map((s) => new ot(s.range.startLineNumber, s.range.startColumn, s.range.endLineNumber, s.range.endColumn)));
    }
  }
}
m0.ID = "editor.contrib.multiCursorController";
class kb extends Je {
  run(e, t) {
    const n = m0.get(t);
    if (!n)
      return;
    const r = t._getViewModel();
    if (r) {
      const s = r.getCursorStates(), o = bo.get(t);
      if (o)
        this._run(n, o);
      else {
        const a = e.get(bt).createInstance(bo, t);
        this._run(n, a), a.dispose();
      }
      pp(s, r.getCursorStates());
    }
  }
}
class Qrt extends kb {
  constructor() {
    super({
      id: "editor.action.addSelectionToNextFindMatch",
      label: C("addSelectionToNextFindMatch", "Add Selection To Next Find Match"),
      alias: "Add Selection To Next Find Match",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 2082,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "3_multi",
        title: C({ key: "miAddSelectionToNextFindMatch", comment: ["&& denotes a mnemonic"] }, "Add &&Next Occurrence"),
        order: 5
      }
    });
  }
  _run(e, t) {
    e.addSelectionToNextFindMatch(t);
  }
}
class Jrt extends kb {
  constructor() {
    super({
      id: "editor.action.addSelectionToPreviousFindMatch",
      label: C("addSelectionToPreviousFindMatch", "Add Selection To Previous Find Match"),
      alias: "Add Selection To Previous Find Match",
      precondition: void 0,
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "3_multi",
        title: C({ key: "miAddSelectionToPreviousFindMatch", comment: ["&& denotes a mnemonic"] }, "Add P&&revious Occurrence"),
        order: 6
      }
    });
  }
  _run(e, t) {
    e.addSelectionToPreviousFindMatch(t);
  }
}
class $rt extends kb {
  constructor() {
    super({
      id: "editor.action.moveSelectionToNextFindMatch",
      label: C("moveSelectionToNextFindMatch", "Move Last Selection To Next Find Match"),
      alias: "Move Last Selection To Next Find Match",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: xr(
          2089,
          2082
          /* KeyCode.KeyD */
        ),
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  _run(e, t) {
    e.moveSelectionToNextFindMatch(t);
  }
}
class est extends kb {
  constructor() {
    super({
      id: "editor.action.moveSelectionToPreviousFindMatch",
      label: C("moveSelectionToPreviousFindMatch", "Move Last Selection To Previous Find Match"),
      alias: "Move Last Selection To Previous Find Match",
      precondition: void 0
    });
  }
  _run(e, t) {
    e.moveSelectionToPreviousFindMatch(t);
  }
}
class tst extends kb {
  constructor() {
    super({
      id: "editor.action.selectHighlights",
      label: C("selectAllOccurrencesOfFindMatch", "Select All Occurrences of Find Match"),
      alias: "Select All Occurrences of Find Match",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 3114,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "3_multi",
        title: C({ key: "miSelectHighlights", comment: ["&& denotes a mnemonic"] }, "Select All &&Occurrences"),
        order: 7
      }
    });
  }
  _run(e, t) {
    e.selectAll(t);
  }
}
class nst extends kb {
  constructor() {
    super({
      id: "editor.action.changeAll",
      label: C("changeAll.label", "Change All Occurrences"),
      alias: "Change All Occurrences",
      precondition: ke.and($.writable, $.editorTextFocus),
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 2108,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      contextMenuOpts: {
        group: "1_modification",
        order: 1.2
      }
    });
  }
  _run(e, t) {
    e.selectAll(t);
  }
}
class ist {
  constructor(e, t, n, r, s) {
    this._model = e, this._searchText = t, this._matchCase = n, this._wordSeparators = r, this._modelVersionId = this._model.getVersionId(), this._cachedFindMatches = null, s && this._model === s._model && this._searchText === s._searchText && this._matchCase === s._matchCase && this._wordSeparators === s._wordSeparators && this._modelVersionId === s._modelVersionId && (this._cachedFindMatches = s._cachedFindMatches);
  }
  findMatches() {
    return this._cachedFindMatches === null && (this._cachedFindMatches = this._model.findMatches(this._searchText, !0, !1, this._matchCase, this._wordSeparators, !1).map((e) => e.range), this._cachedFindMatches.sort(V.compareRangesUsingStarts)), this._cachedFindMatches;
  }
}
let zw = HH = class extends we {
  constructor(e, t) {
    super(), this._languageFeaturesService = t, this.editor = e, this._isEnabled = e.getOption(
      107
      /* EditorOption.selectionHighlight */
    ), this._decorations = e.createDecorationsCollection(), this.updateSoon = this._register(new Rn(() => this._update(), 300)), this.state = null, this._register(e.onDidChangeConfiguration((r) => {
      this._isEnabled = e.getOption(
        107
        /* EditorOption.selectionHighlight */
      );
    })), this._register(e.onDidChangeCursorSelection((r) => {
      this._isEnabled && (r.selection.isEmpty() ? r.reason === 3 ? (this.state && this._setState(null), this.updateSoon.schedule()) : this._setState(null) : this._update());
    })), this._register(e.onDidChangeModel((r) => {
      this._setState(null);
    })), this._register(e.onDidChangeModelContent((r) => {
      this._isEnabled && this.updateSoon.schedule();
    }));
    const n = bo.get(e);
    n && this._register(n.getState().onFindReplaceStateChange((r) => {
      this._update();
    })), this.updateSoon.schedule();
  }
  _update() {
    this._setState(HH._createState(this.state, this._isEnabled, this.editor));
  }
  static _createState(e, t, n) {
    if (!t || !n.hasModel())
      return null;
    const r = n.getSelection();
    if (r.startLineNumber !== r.endLineNumber)
      return null;
    const s = m0.get(n);
    if (!s)
      return null;
    const o = bo.get(n);
    if (!o)
      return null;
    let a = s.getSession(o);
    if (!a) {
      const d = n.getSelections();
      if (d.length > 1) {
        const h = o.getState().matchCase;
        if (!cve(n.getModel(), d, h))
          return null;
      }
      a = jw.create(n, o);
    }
    if (!a || a.currentMatch || /^[ \t]+$/.test(a.searchText) || a.searchText.length > 200)
      return null;
    const l = o.getState(), c = l.matchCase;
    if (l.isRevealed) {
      let d = l.searchString;
      c || (d = d.toLowerCase());
      let u = a.searchText;
      if (c || (u = u.toLowerCase()), d === u && a.matchCase === l.matchCase && a.wholeWord === l.wholeWord && !l.isRegex)
        return null;
    }
    return new ist(n.getModel(), a.searchText, a.matchCase, a.wholeWord ? n.getOption(
      129
      /* EditorOption.wordSeparators */
    ) : null, e);
  }
  _setState(e) {
    if (this.state = e, !this.state) {
      this._decorations.clear();
      return;
    }
    if (!this.editor.hasModel())
      return;
    const t = this.editor.getModel();
    if (t.isTooLargeForTokenization())
      return;
    const n = this.state.findMatches(), r = this.editor.getSelections();
    r.sort(V.compareRangesUsingStarts);
    const s = [];
    for (let l = 0, c = 0, d = n.length, u = r.length; l < d; ) {
      const h = n[l];
      if (c >= u)
        s.push(h), l++;
      else {
        const f = V.compareRangesUsingStarts(h, r[c]);
        f < 0 ? ((r[c].isEmpty() || !V.areIntersecting(h, r[c])) && s.push(h), l++) : (f > 0 || l++, c++);
      }
    }
    const o = this._languageFeaturesService.documentHighlightProvider.has(t) && this.editor.getOption(
      80
      /* EditorOption.occurrencesHighlight */
    ), a = s.map((l) => ({
      range: l,
      options: zrt(o)
    }));
    this._decorations.set(a);
  }
  dispose() {
    this._setState(null), super.dispose();
  }
};
zw.ID = "editor.contrib.selectionHighlighter";
zw = HH = Urt([
  Grt(1, tt)
], zw);
function cve(i, e, t) {
  const n = Lee(i, e[0], !t);
  for (let r = 1, s = e.length; r < s; r++) {
    const o = e[r];
    if (o.isEmpty())
      return !1;
    const a = Lee(i, o, !t);
    if (n !== a)
      return !1;
  }
  return !0;
}
function Lee(i, e, t) {
  const n = i.getValueInRange(e);
  return t ? n.toLowerCase() : n;
}
class rst extends Je {
  constructor() {
    super({
      id: "editor.action.focusNextCursor",
      label: C("mutlicursor.focusNextCursor", "Focus Next Cursor"),
      description: {
        description: C("mutlicursor.focusNextCursor.description", "Focuses the next cursor"),
        args: []
      },
      alias: "Focus Next Cursor",
      precondition: void 0
    });
  }
  run(e, t, n) {
    if (!t.hasModel())
      return;
    const r = t._getViewModel();
    if (r.cursorConfig.readOnly)
      return;
    r.model.pushStackElement();
    const s = Array.from(r.getCursorStates()), o = s.shift();
    o && (s.push(o), r.setCursorStates(n.source, 3, s), r.revealPrimaryCursor(n.source, !0), pp(s, r.getCursorStates()));
  }
}
class sst extends Je {
  constructor() {
    super({
      id: "editor.action.focusPreviousCursor",
      label: C("mutlicursor.focusPreviousCursor", "Focus Previous Cursor"),
      description: {
        description: C("mutlicursor.focusPreviousCursor.description", "Focuses the previous cursor"),
        args: []
      },
      alias: "Focus Previous Cursor",
      precondition: void 0
    });
  }
  run(e, t, n) {
    if (!t.hasModel())
      return;
    const r = t._getViewModel();
    if (r.cursorConfig.readOnly)
      return;
    r.model.pushStackElement();
    const s = Array.from(r.getCursorStates()), o = s.pop();
    o && (s.unshift(o), r.setCursorStates(n.source, 3, s), r.revealPrimaryCursor(n.source, !0), pp(s, r.getCursorStates()));
  }
}
pn(
  m0.ID,
  m0,
  4
  /* EditorContributionInstantiation.Lazy */
);
pn(
  zw.ID,
  zw,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
Be(qrt);
Be(Krt);
Be(Yrt);
Be(Qrt);
Be(Jrt);
Be($rt);
Be(est);
Be(tst);
Be(nst);
Be(Xrt);
Be(Zrt);
Be(rst);
Be(sst);
var dve = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const v0 = {
  Visible: new Ke("parameterHintsVisible", !1),
  MultipleSignatures: new Ke("parameterHintsMultipleSignatures", !1)
};
function uve(i, e, t, n, r) {
  return dve(this, void 0, void 0, function* () {
    const s = i.ordered(e);
    for (const o of s)
      try {
        const a = yield o.provideSignatureHelp(e, t, r, n);
        if (a)
          return a;
      } catch (a) {
        vr(a);
      }
  });
}
on.registerCommand("_executeSignatureHelpProvider", (i, ...e) => dve(void 0, void 0, void 0, function* () {
  const [t, n, r] = e;
  On(pt.isUri(t)), On(ve.isIPosition(n)), On(typeof r == "string" || !r);
  const s = i.get(tt), o = yield i.get(Wo).createModelReference(t);
  try {
    const a = yield uve(s.signatureHelpProvider, o.object.textEditorModel, ve.lift(n), {
      triggerKind: lu.Invoke,
      isRetrigger: !1,
      triggerCharacter: r
    }, jt.None);
    return a ? (setTimeout(() => a.dispose(), 0), a.value) : void 0;
  } finally {
    o.dispose();
  }
}));
var ost = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, Ff;
(function(i) {
  i.Default = {
    type: 0
    /* Type.Default */
  };
  class e {
    constructor(r, s) {
      this.request = r, this.previouslyActiveHints = s, this.type = 2;
    }
  }
  i.Pending = e;
  class t {
    constructor(r) {
      this.hints = r, this.type = 1;
    }
  }
  i.Active = t;
})(Ff || (Ff = {}));
class U5 extends we {
  constructor(e, t, n = U5.DEFAULT_DELAY) {
    super(), this._onChangedHints = this._register(new pe()), this.onChangedHints = this._onChangedHints.event, this.triggerOnType = !1, this._state = Ff.Default, this._pendingTriggers = [], this._lastSignatureHelpResult = this._register(new ds()), this.triggerChars = new iL(), this.retriggerChars = new iL(), this.triggerId = 0, this.editor = e, this.providers = t, this.throttledDelayer = new ac(n), this._register(this.editor.onDidBlurEditorWidget(() => this.cancel())), this._register(this.editor.onDidChangeConfiguration(() => this.onEditorConfigurationChange())), this._register(this.editor.onDidChangeModel((r) => this.onModelChanged())), this._register(this.editor.onDidChangeModelLanguage((r) => this.onModelChanged())), this._register(this.editor.onDidChangeCursorSelection((r) => this.onCursorChange(r))), this._register(this.editor.onDidChangeModelContent((r) => this.onModelContentChange())), this._register(this.providers.onDidChange(this.onModelChanged, this)), this._register(this.editor.onDidType((r) => this.onDidType(r))), this.onEditorConfigurationChange(), this.onModelChanged();
  }
  get state() {
    return this._state;
  }
  set state(e) {
    this._state.type === 2 && this._state.request.cancel(), this._state = e;
  }
  cancel(e = !1) {
    this.state = Ff.Default, this.throttledDelayer.cancel(), e || this._onChangedHints.fire(void 0);
  }
  trigger(e, t) {
    const n = this.editor.getModel();
    if (!n || !this.providers.has(n))
      return;
    const r = ++this.triggerId;
    this._pendingTriggers.push(e), this.throttledDelayer.trigger(() => this.doTrigger(r), t).catch(It);
  }
  next() {
    if (this.state.type !== 1)
      return;
    const e = this.state.hints.signatures.length, t = this.state.hints.activeSignature, n = t % e === e - 1, r = this.editor.getOption(
      85
      /* EditorOption.parameterHints */
    ).cycle;
    if ((e < 2 || n) && !r) {
      this.cancel();
      return;
    }
    this.updateActiveSignature(n && r ? 0 : t + 1);
  }
  previous() {
    if (this.state.type !== 1)
      return;
    const e = this.state.hints.signatures.length, t = this.state.hints.activeSignature, n = t === 0, r = this.editor.getOption(
      85
      /* EditorOption.parameterHints */
    ).cycle;
    if ((e < 2 || n) && !r) {
      this.cancel();
      return;
    }
    this.updateActiveSignature(n && r ? e - 1 : t - 1);
  }
  updateActiveSignature(e) {
    this.state.type === 1 && (this.state = new Ff.Active(Object.assign(Object.assign({}, this.state.hints), { activeSignature: e })), this._onChangedHints.fire(this.state.hints));
  }
  doTrigger(e) {
    return ost(this, void 0, void 0, function* () {
      const t = this.state.type === 1 || this.state.type === 2, n = this.getLastActiveHints();
      if (this.cancel(!0), this._pendingTriggers.length === 0)
        return !1;
      const r = this._pendingTriggers.reduce(ast);
      this._pendingTriggers = [];
      const s = {
        triggerKind: r.triggerKind,
        triggerCharacter: r.triggerCharacter,
        isRetrigger: t,
        activeSignatureHelp: n
      };
      if (!this.editor.hasModel())
        return !1;
      const o = this.editor.getModel(), a = this.editor.getPosition();
      this.state = new Ff.Pending(Ir((l) => uve(this.providers, o, a, s, l)), n);
      try {
        const l = yield this.state.request;
        return e !== this.triggerId ? (l?.dispose(), !1) : !l || !l.value.signatures || l.value.signatures.length === 0 ? (l?.dispose(), this._lastSignatureHelpResult.clear(), this.cancel(), !1) : (this.state = new Ff.Active(l.value), this._lastSignatureHelpResult.value = l, this._onChangedHints.fire(this.state.hints), !0);
      } catch (l) {
        return e === this.triggerId && (this.state = Ff.Default), It(l), !1;
      }
    });
  }
  getLastActiveHints() {
    switch (this.state.type) {
      case 1:
        return this.state.hints;
      case 2:
        return this.state.previouslyActiveHints;
      default:
        return;
    }
  }
  get isTriggered() {
    return this.state.type === 1 || this.state.type === 2 || this.throttledDelayer.isTriggered();
  }
  onModelChanged() {
    this.cancel(), this.triggerChars.clear(), this.retriggerChars.clear();
    const e = this.editor.getModel();
    if (e)
      for (const t of this.providers.ordered(e)) {
        for (const n of t.signatureHelpTriggerCharacters || [])
          if (n.length) {
            const r = n.charCodeAt(0);
            this.triggerChars.add(r), this.retriggerChars.add(r);
          }
        for (const n of t.signatureHelpRetriggerCharacters || [])
          n.length && this.retriggerChars.add(n.charCodeAt(0));
      }
  }
  onDidType(e) {
    if (!this.triggerOnType)
      return;
    const t = e.length - 1, n = e.charCodeAt(t);
    (this.triggerChars.has(n) || this.isTriggered && this.retriggerChars.has(n)) && this.trigger({
      triggerKind: lu.TriggerCharacter,
      triggerCharacter: e.charAt(t)
    });
  }
  onCursorChange(e) {
    e.source === "mouse" ? this.cancel() : this.isTriggered && this.trigger({ triggerKind: lu.ContentChange });
  }
  onModelContentChange() {
    this.isTriggered && this.trigger({ triggerKind: lu.ContentChange });
  }
  onEditorConfigurationChange() {
    this.triggerOnType = this.editor.getOption(
      85
      /* EditorOption.parameterHints */
    ).enabled, this.triggerOnType || this.cancel();
  }
  dispose() {
    this.cancel(!0), super.dispose();
  }
}
U5.DEFAULT_DELAY = 120;
function ast(i, e) {
  switch (e.triggerKind) {
    case lu.Invoke:
      return e;
    case lu.ContentChange:
      return i;
    case lu.TriggerCharacter:
    default:
      return e;
  }
}
var lst = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, jT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, WH;
const ma = Re, cst = $i("parameter-hints-next", We.chevronDown, C("parameterHintsNextIcon", "Icon for show next parameter hint.")), dst = $i("parameter-hints-previous", We.chevronUp, C("parameterHintsPreviousIcon", "Icon for show previous parameter hint."));
let RI = WH = class extends we {
  constructor(e, t, n, r, s) {
    super(), this.editor = e, this.model = t, this.renderDisposeables = this._register(new Ne()), this.visible = !1, this.announcedLabel = null, this.allowEditorOverflow = !0, this.markdownRenderer = this._register(new $h({ editor: e }, s, r)), this.keyVisible = v0.Visible.bindTo(n), this.keyMultipleSignatures = v0.MultipleSignatures.bindTo(n);
  }
  createParameterHintDOMNodes() {
    const e = ma(".editor-widget.parameter-hints-widget"), t = Te(e, ma(".phwrapper"));
    t.tabIndex = -1;
    const n = Te(t, ma(".controls")), r = Te(n, ma(".button" + ft.asCSSSelector(dst))), s = Te(n, ma(".overloads")), o = Te(n, ma(".button" + ft.asCSSSelector(cst)));
    this._register(Ie(r, "click", (h) => {
      Tt.stop(h), this.previous();
    })), this._register(Ie(o, "click", (h) => {
      Tt.stop(h), this.next();
    }));
    const a = ma(".body"), l = new TS(a, {
      alwaysConsumeMouseWheel: !0
    });
    this._register(l), t.appendChild(l.getDomNode());
    const c = Te(a, ma(".signature")), d = Te(a, ma(".docs"));
    e.style.userSelect = "text", this.domNodes = {
      element: e,
      signature: c,
      overloads: s,
      docs: d,
      scrollbar: l
    }, this.editor.addContentWidget(this), this.hide(), this._register(this.editor.onDidChangeCursorSelection((h) => {
      this.visible && this.editor.layoutContentWidget(this);
    }));
    const u = () => {
      if (!this.domNodes)
        return;
      const h = this.editor.getOption(
        50
        /* EditorOption.fontInfo */
      );
      this.domNodes.element.style.fontSize = `${h.fontSize}px`, this.domNodes.element.style.lineHeight = `${h.lineHeight / h.fontSize}`;
    };
    u(), this._register(qe.chain(this.editor.onDidChangeConfiguration.bind(this.editor), (h) => h.filter((f) => f.hasChanged(
      50
      /* EditorOption.fontInfo */
    )))(u)), this._register(this.editor.onDidLayoutChange((h) => this.updateMaxHeight())), this.updateMaxHeight();
  }
  show() {
    this.visible || (this.domNodes || this.createParameterHintDOMNodes(), this.keyVisible.set(!0), this.visible = !0, setTimeout(() => {
      var e;
      (e = this.domNodes) === null || e === void 0 || e.element.classList.add("visible");
    }, 100), this.editor.layoutContentWidget(this));
  }
  hide() {
    var e;
    this.renderDisposeables.clear(), this.visible && (this.keyVisible.reset(), this.visible = !1, this.announcedLabel = null, (e = this.domNodes) === null || e === void 0 || e.element.classList.remove("visible"), this.editor.layoutContentWidget(this));
  }
  getPosition() {
    return this.visible ? {
      position: this.editor.getPosition(),
      preference: [
        1,
        2
        /* ContentWidgetPositionPreference.BELOW */
      ]
    } : null;
  }
  render(e) {
    var t;
    if (this.renderDisposeables.clear(), !this.domNodes)
      return;
    const n = e.signatures.length > 1;
    this.domNodes.element.classList.toggle("multiple", n), this.keyMultipleSignatures.set(n), this.domNodes.signature.innerText = "", this.domNodes.docs.innerText = "";
    const r = e.signatures[e.activeSignature];
    if (!r)
      return;
    const s = Te(this.domNodes.signature, ma(".code")), o = this.editor.getOption(
      50
      /* EditorOption.fontInfo */
    );
    s.style.fontSize = `${o.fontSize}px`, s.style.fontFamily = o.fontFamily;
    const a = r.parameters.length > 0, l = (t = r.activeParameter) !== null && t !== void 0 ? t : e.activeParameter;
    if (a)
      this.renderParameters(s, r, l);
    else {
      const u = Te(s, ma("span"));
      u.textContent = r.label;
    }
    const c = r.parameters[l];
    if (c?.documentation) {
      const u = ma("span.documentation");
      if (typeof c.documentation == "string")
        u.textContent = c.documentation;
      else {
        const h = this.renderMarkdownDocs(c.documentation);
        u.appendChild(h.element);
      }
      Te(this.domNodes.docs, ma("p", {}, u));
    }
    if (r.documentation !== void 0) if (typeof r.documentation == "string")
      Te(this.domNodes.docs, ma("p", {}, r.documentation));
    else {
      const u = this.renderMarkdownDocs(r.documentation);
      Te(this.domNodes.docs, u.element);
    }
    const d = this.hasDocs(r, c);
    if (this.domNodes.signature.classList.toggle("has-docs", d), this.domNodes.docs.classList.toggle("empty", !d), this.domNodes.overloads.textContent = String(e.activeSignature + 1).padStart(e.signatures.length.toString().length, "0") + "/" + e.signatures.length, c) {
      let u = "";
      const h = r.parameters[l];
      Array.isArray(h.label) ? u = r.label.substring(h.label[0], h.label[1]) : u = h.label, h.documentation && (u += typeof h.documentation == "string" ? `, ${h.documentation}` : `, ${h.documentation.value}`), r.documentation && (u += typeof r.documentation == "string" ? `, ${r.documentation}` : `, ${r.documentation.value}`), this.announcedLabel !== u && (Fs(C("hint", "{0}, hint", u)), this.announcedLabel = u);
    }
    this.editor.layoutContentWidget(this), this.domNodes.scrollbar.scanDomNode();
  }
  renderMarkdownDocs(e) {
    const t = this.renderDisposeables.add(this.markdownRenderer.render(e, {
      asyncRenderCallback: () => {
        var n;
        (n = this.domNodes) === null || n === void 0 || n.scrollbar.scanDomNode();
      }
    }));
    return t.element.classList.add("markdown-docs"), t;
  }
  hasDocs(e, t) {
    return !!(t && typeof t.documentation == "string" && am(t.documentation).length > 0 || t && typeof t.documentation == "object" && am(t.documentation).value.length > 0 || e.documentation && typeof e.documentation == "string" && am(e.documentation).length > 0 || e.documentation && typeof e.documentation == "object" && am(e.documentation.value).length > 0);
  }
  renderParameters(e, t, n) {
    const [r, s] = this.getParameterLabelOffsets(t, n), o = document.createElement("span");
    o.textContent = t.label.substring(0, r);
    const a = document.createElement("span");
    a.textContent = t.label.substring(r, s), a.className = "parameter active";
    const l = document.createElement("span");
    l.textContent = t.label.substring(s), Te(e, o, a, l);
  }
  getParameterLabelOffsets(e, t) {
    const n = e.parameters[t];
    if (n) {
      if (Array.isArray(n.label))
        return n.label;
      if (n.label.length) {
        const r = new RegExp(`(\\W|^)${Va(n.label)}(?=\\W|$)`, "g");
        r.test(e.label);
        const s = r.lastIndex - n.label.length;
        return s >= 0 ? [s, r.lastIndex] : [0, 0];
      } else
        return [0, 0];
    } else return [0, 0];
  }
  next() {
    this.editor.focus(), this.model.next();
  }
  previous() {
    this.editor.focus(), this.model.previous();
  }
  getDomNode() {
    return this.domNodes || this.createParameterHintDOMNodes(), this.domNodes.element;
  }
  getId() {
    return WH.ID;
  }
  updateMaxHeight() {
    if (!this.domNodes)
      return;
    const t = `${Math.max(this.editor.getLayoutInfo().height / 4, 250)}px`;
    this.domNodes.element.style.maxHeight = t;
    const n = this.domNodes.element.getElementsByClassName("phwrapper");
    n.length && (n[0].style.maxHeight = t);
  }
};
RI.ID = "editor.widget.parameterHintsWidget";
RI = WH = lst([
  jT(2, yt),
  jT(3, da),
  jT(4, ci)
], RI);
ne("editorHoverWidget.highlightForeground", { dark: Gl, light: Gl, hcDark: Gl, hcLight: Gl }, C("editorHoverWidgetHighlightForeground", "Foreground color of the active item in the parameter hint."));
var ust = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Iee = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, jH;
let _0 = jH = class extends we {
  static get(e) {
    return e.getContribution(jH.ID);
  }
  constructor(e, t, n) {
    super(), this.editor = e, this.model = this._register(new U5(e, n.signatureHelpProvider)), this._register(this.model.onChangedHints((r) => {
      var s;
      r ? (this.widget.value.show(), this.widget.value.render(r)) : (s = this.widget.rawValue) === null || s === void 0 || s.hide();
    })), this.widget = new lp(() => this._register(t.createInstance(RI, this.editor, this.model)));
  }
  cancel() {
    this.model.cancel();
  }
  previous() {
    var e;
    (e = this.widget.rawValue) === null || e === void 0 || e.previous();
  }
  next() {
    var e;
    (e = this.widget.rawValue) === null || e === void 0 || e.next();
  }
  trigger(e) {
    this.model.trigger(e, 0);
  }
};
_0.ID = "editor.controller.parameterHints";
_0 = jH = ust([
  Iee(1, bt),
  Iee(2, tt)
], _0);
class hst extends Je {
  constructor() {
    super({
      id: "editor.action.triggerParameterHints",
      label: C("parameterHints.trigger.label", "Trigger Parameter Hints"),
      alias: "Trigger Parameter Hints",
      precondition: $.hasSignatureHelpProvider,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 3082,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t) {
    const n = _0.get(t);
    n?.trigger({
      triggerKind: lu.Invoke
    });
  }
}
pn(
  _0.ID,
  _0,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
Be(hst);
const OG = 175, MG = Kr.bindToContribution(_0.get);
ze(new MG({
  id: "closeParameterHints",
  precondition: v0.Visible,
  handler: (i) => i.cancel(),
  kbOpts: {
    weight: OG,
    kbExpr: $.focus,
    primary: 9,
    secondary: [
      1033
      /* KeyCode.Escape */
    ]
  }
}));
ze(new MG({
  id: "showPrevParameterHint",
  precondition: ke.and(v0.Visible, v0.MultipleSignatures),
  handler: (i) => i.previous(),
  kbOpts: {
    weight: OG,
    kbExpr: $.focus,
    primary: 16,
    secondary: [
      528
      /* KeyCode.UpArrow */
    ],
    mac: { primary: 16, secondary: [
      528,
      302
      /* KeyCode.KeyP */
    ] }
  }
}));
ze(new MG({
  id: "showNextParameterHint",
  precondition: ke.and(v0.Visible, v0.MultipleSignatures),
  handler: (i) => i.next(),
  kbOpts: {
    weight: OG,
    kbExpr: $.focus,
    primary: 18,
    secondary: [
      530
      /* KeyCode.DownArrow */
    ],
    mac: { primary: 18, secondary: [
      530,
      300
      /* KeyCode.KeyN */
    ] }
  }
}));
var fst = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, zT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const G5 = new Ke("renameInputVisible", !1, C("renameInputVisible", "Whether the rename input widget is visible"));
let zH = class {
  constructor(e, t, n, r, s) {
    this._editor = e, this._acceptKeybindings = t, this._themeService = n, this._keybindingService = r, this._disposables = new Ne(), this.allowEditorOverflow = !0, this._visibleContextKey = G5.bindTo(s), this._editor.addContentWidget(this), this._disposables.add(this._editor.onDidChangeConfiguration((o) => {
      o.hasChanged(
        50
        /* EditorOption.fontInfo */
      ) && this._updateFont();
    })), this._disposables.add(n.onDidColorThemeChange(this._updateStyles, this));
  }
  dispose() {
    this._disposables.dispose(), this._editor.removeContentWidget(this);
  }
  getId() {
    return "__renameInputWidget";
  }
  getDomNode() {
    return this._domNode || (this._domNode = document.createElement("div"), this._domNode.className = "monaco-editor rename-box", this._input = document.createElement("input"), this._input.className = "rename-input", this._input.type = "text", this._input.setAttribute("aria-label", C("renameAriaLabel", "Rename input. Type new name and press Enter to commit.")), this._domNode.appendChild(this._input), this._label = document.createElement("div"), this._label.className = "rename-label", this._domNode.appendChild(this._label), this._updateFont(), this._updateStyles(this._themeService.getColorTheme())), this._domNode;
  }
  _updateStyles(e) {
    var t, n, r, s;
    if (!this._input || !this._domNode)
      return;
    const o = e.getColor(Qd), a = e.getColor(hz);
    this._domNode.style.backgroundColor = String((t = e.getColor(ji)) !== null && t !== void 0 ? t : ""), this._domNode.style.boxShadow = o ? ` 0 0 8px 2px ${o}` : "", this._domNode.style.border = a ? `1px solid ${a}` : "", this._domNode.style.color = String((n = e.getColor(Ife)) !== null && n !== void 0 ? n : ""), this._input.style.backgroundColor = String((r = e.getColor(Lfe)) !== null && r !== void 0 ? r : "");
    const l = e.getColor(Afe);
    this._input.style.borderWidth = l ? "1px" : "0px", this._input.style.borderStyle = l ? "solid" : "none", this._input.style.borderColor = (s = l?.toString()) !== null && s !== void 0 ? s : "none";
  }
  _updateFont() {
    if (!this._input || !this._label)
      return;
    const e = this._editor.getOption(
      50
      /* EditorOption.fontInfo */
    );
    this._input.style.fontFamily = e.fontFamily, this._input.style.fontWeight = e.fontWeight, this._input.style.fontSize = `${e.fontSize}px`, this._label.style.fontSize = `${e.fontSize * 0.8}px`;
  }
  getPosition() {
    return this._visible ? {
      position: this._position,
      preference: [
        2,
        1
        /* ContentWidgetPositionPreference.ABOVE */
      ]
    } : null;
  }
  beforeRender() {
    var e, t;
    const [n, r] = this._acceptKeybindings;
    return this._label.innerText = C({ key: "label", comment: ['placeholders are keybindings, e.g "F2 to Rename, Shift+F2 to Preview"'] }, "{0} to Rename, {1} to Preview", (e = this._keybindingService.lookupKeybinding(n)) === null || e === void 0 ? void 0 : e.getLabel(), (t = this._keybindingService.lookupKeybinding(r)) === null || t === void 0 ? void 0 : t.getLabel()), null;
  }
  afterRender(e) {
    e || this.cancelInput(!0);
  }
  acceptInput(e) {
    var t;
    (t = this._currentAcceptInput) === null || t === void 0 || t.call(this, e);
  }
  cancelInput(e) {
    var t;
    (t = this._currentCancelInput) === null || t === void 0 || t.call(this, e);
  }
  getInput(e, t, n, r, s, o) {
    this._domNode.classList.toggle("preview", s), this._position = new ve(e.startLineNumber, e.startColumn), this._input.value = t, this._input.setAttribute("selectionStart", n.toString()), this._input.setAttribute("selectionEnd", r.toString()), this._input.size = Math.max((e.endColumn - e.startColumn) * 1.1, 20);
    const a = new Ne();
    return new Promise((l) => {
      this._currentCancelInput = (c) => (this._currentAcceptInput = void 0, this._currentCancelInput = void 0, l(c), !0), this._currentAcceptInput = (c) => {
        if (this._input.value.trim().length === 0 || this._input.value === t) {
          this.cancelInput(!0);
          return;
        }
        this._currentAcceptInput = void 0, this._currentCancelInput = void 0, l({
          newName: this._input.value,
          wantsPreview: s && c
        });
      }, a.add(o.onCancellationRequested(() => this.cancelInput(!0))), a.add(this._editor.onDidBlurEditorWidget(() => {
        var c;
        return this.cancelInput(!(!((c = this._domNode) === null || c === void 0) && c.ownerDocument.hasFocus()));
      })), this._show();
    }).finally(() => {
      a.dispose(), this._hide();
    });
  }
  _show() {
    this._editor.revealLineInCenterIfOutsideViewport(
      this._position.lineNumber,
      0
      /* ScrollType.Smooth */
    ), this._visible = !0, this._visibleContextKey.set(!0), this._editor.layoutContentWidget(this), setTimeout(() => {
      this._input.focus(), this._input.setSelectionRange(parseInt(this._input.getAttribute("selectionStart")), parseInt(this._input.getAttribute("selectionEnd")));
    }, 100);
  }
  _hide() {
    this._visible = !1, this._visibleContextKey.reset(), this._editor.layoutContentWidget(this);
  }
};
zH = fst([
  zT(2, Pr),
  zT(3, Bn),
  zT(4, yt)
], zH);
var gst = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, kp = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Om = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, UH;
class RG {
  constructor(e, t, n) {
    this.model = e, this.position = t, this._providerRenameIdx = 0, this._providers = n.ordered(e);
  }
  hasProvider() {
    return this._providers.length > 0;
  }
  resolveRenameLocation(e) {
    return Om(this, void 0, void 0, function* () {
      const t = [];
      for (this._providerRenameIdx = 0; this._providerRenameIdx < this._providers.length; this._providerRenameIdx++) {
        const r = this._providers[this._providerRenameIdx];
        if (!r.resolveRenameLocation)
          break;
        const s = yield r.resolveRenameLocation(this.model, this.position, e);
        if (s) {
          if (s.rejectReason) {
            t.push(s.rejectReason);
            continue;
          }
          return s;
        }
      }
      const n = this.model.getWordAtPosition(this.position);
      return n ? {
        range: new V(this.position.lineNumber, n.startColumn, this.position.lineNumber, n.endColumn),
        text: n.word,
        rejectReason: t.length > 0 ? t.join(`
`) : void 0
      } : {
        range: V.fromPositions(this.position),
        text: "",
        rejectReason: t.length > 0 ? t.join(`
`) : void 0
      };
    });
  }
  provideRenameEdits(e, t) {
    return Om(this, void 0, void 0, function* () {
      return this._provideRenameEdits(e, this._providerRenameIdx, [], t);
    });
  }
  _provideRenameEdits(e, t, n, r) {
    return Om(this, void 0, void 0, function* () {
      const s = this._providers[t];
      if (!s)
        return {
          edits: [],
          rejectReason: n.join(`
`)
        };
      const o = yield s.provideRenameEdits(this.model, this.position, e, r);
      if (o) {
        if (o.rejectReason)
          return this._provideRenameEdits(e, t + 1, n.concat(o.rejectReason), r);
      } else return this._provideRenameEdits(e, t + 1, n.concat(C("no result", "No result.")), r);
      return o;
    });
  }
}
function pst(i, e, t, n) {
  return Om(this, void 0, void 0, function* () {
    const r = new RG(e, t, i), s = yield r.resolveRenameLocation(jt.None);
    return s?.rejectReason ? { edits: [], rejectReason: s.rejectReason } : r.provideRenameEdits(n, jt.None);
  });
}
let b0 = UH = class {
  static get(e) {
    return e.getContribution(UH.ID);
  }
  constructor(e, t, n, r, s, o, a, l) {
    this.editor = e, this._instaService = t, this._notificationService = n, this._bulkEditService = r, this._progressService = s, this._logService = o, this._configService = a, this._languageFeaturesService = l, this._disposableStore = new Ne(), this._cts = new lr(), this._renameInputField = this._disposableStore.add(this._instaService.createInstance(zH, this.editor, ["acceptRenameInput", "acceptRenameInputWithPreview"]));
  }
  dispose() {
    this._disposableStore.dispose(), this._cts.dispose(!0);
  }
  run() {
    var e, t;
    return Om(this, void 0, void 0, function* () {
      if (this._cts.dispose(!0), this._cts = new lr(), !this.editor.hasModel())
        return;
      const n = this.editor.getPosition(), r = new RG(this.editor.getModel(), n, this._languageFeaturesService.renameProvider);
      if (!r.hasProvider())
        return;
      const s = new Gg(this.editor, 5, void 0, this._cts.token);
      let o;
      try {
        const g = r.resolveRenameLocation(s.token);
        this._progressService.showWhile(g, 250), o = yield g;
      } catch (g) {
        (e = ra.get(this.editor)) === null || e === void 0 || e.showMessage(g || C("resolveRenameLocationFailed", "An unknown error occurred while resolving rename location"), n);
        return;
      } finally {
        s.dispose();
      }
      if (!o)
        return;
      if (o.rejectReason) {
        (t = ra.get(this.editor)) === null || t === void 0 || t.showMessage(o.rejectReason, n);
        return;
      }
      if (s.token.isCancellationRequested)
        return;
      const a = new Gg(this.editor, 5, o.range, this._cts.token), l = this.editor.getSelection();
      let c = 0, d = o.text.length;
      !V.isEmpty(l) && !V.spansMultipleLines(l) && V.containsRange(o.range, l) && (c = Math.max(0, l.startColumn - o.range.startColumn), d = Math.min(o.range.endColumn, l.endColumn) - o.range.startColumn);
      const u = this._bulkEditService.hasPreviewHandler() && this._configService.getValue(this.editor.getModel().uri, "editor.rename.enablePreview"), h = yield this._renameInputField.getInput(o.range, o.text, c, d, u, a.token);
      if (typeof h == "boolean") {
        h && this.editor.focus(), a.dispose();
        return;
      }
      this.editor.focus();
      const f = i4(r.provideRenameEdits(h.newName, a.token), a.token).then((g) => Om(this, void 0, void 0, function* () {
        if (!(!g || !this.editor.hasModel())) {
          if (g.rejectReason) {
            this._notificationService.info(g.rejectReason);
            return;
          }
          this.editor.setSelection(V.fromPositions(this.editor.getSelection().getPosition())), this._bulkEditService.apply(g, {
            editor: this.editor,
            showPreview: h.wantsPreview,
            label: C("label", "Renaming '{0}' to '{1}'", o?.text, h.newName),
            code: "undoredo.rename",
            quotableLabel: C("quotableLabel", "Renaming {0} to {1}", o?.text, h.newName),
            respectAutoSaveConfig: !0
          }).then((p) => {
            p.ariaSummary && Fs(C("aria", "Successfully renamed '{0}' to '{1}'. Summary: {2}", o.text, h.newName, p.ariaSummary));
          }).catch((p) => {
            this._notificationService.error(C("rename.failedApply", "Rename failed to apply edits")), this._logService.error(p);
          });
        }
      }), (g) => {
        this._notificationService.error(C("rename.failed", "Rename failed to compute edits")), this._logService.error(g);
      }).finally(() => {
        a.dispose();
      });
      return this._progressService.showWhile(f, 250), f;
    });
  }
  acceptRenameInput(e) {
    this._renameInputField.acceptInput(e);
  }
  cancelRenameInput() {
    this._renameInputField.cancelInput(!0);
  }
};
b0.ID = "editor.contrib.renameController";
b0 = UH = gst([
  kp(1, bt),
  kp(2, dr),
  kp(3, FS),
  kp(4, hp),
  kp(5, Ka),
  kp(6, rz),
  kp(7, tt)
], b0);
class mst extends Je {
  constructor() {
    super({
      id: "editor.action.rename",
      label: C("rename.label", "Rename Symbol"),
      alias: "Rename Symbol",
      precondition: ke.and($.writable, $.hasRenameProvider),
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 60,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      contextMenuOpts: {
        group: "1_modification",
        order: 1.1
      }
    });
  }
  runCommand(e, t) {
    const n = e.get(Sn), [r, s] = Array.isArray(t) && t || [void 0, void 0];
    return pt.isUri(r) && ve.isIPosition(s) ? n.openCodeEditor({ resource: r }, n.getActiveCodeEditor()).then((o) => {
      o && (o.setPosition(s), o.invokeWithinContext((a) => (this.reportTelemetry(a, o), this.run(a, o))));
    }, It) : super.runCommand(e, t);
  }
  run(e, t) {
    const n = b0.get(t);
    return n ? n.run() : Promise.resolve();
  }
}
pn(
  b0.ID,
  b0,
  4
  /* EditorContributionInstantiation.Lazy */
);
Be(mst);
const FG = Kr.bindToContribution(b0.get);
ze(new FG({
  id: "acceptRenameInput",
  precondition: G5,
  handler: (i) => i.acceptRenameInput(!1),
  kbOpts: {
    weight: 199,
    kbExpr: ke.and($.focus, ke.not("isComposing")),
    primary: 3
    /* KeyCode.Enter */
  }
}));
ze(new FG({
  id: "acceptRenameInputWithPreview",
  precondition: ke.and(G5, ke.has("config.editor.rename.enablePreview")),
  handler: (i) => i.acceptRenameInput(!0),
  kbOpts: {
    weight: 199,
    kbExpr: ke.and($.focus, ke.not("isComposing")),
    primary: 1027
    /* KeyCode.Enter */
  }
}));
ze(new FG({
  id: "cancelRenameInput",
  precondition: G5,
  handler: (i) => i.cancelRenameInput(),
  kbOpts: {
    weight: 199,
    kbExpr: $.focus,
    primary: 9,
    secondary: [
      1033
      /* KeyCode.Escape */
    ]
  }
}));
Ru("_executeDocumentRenameProvider", function(i, e, t, ...n) {
  const [r] = n;
  On(typeof r == "string");
  const { renameProvider: s } = i.get(tt);
  return pst(s, e, t, r);
});
Ru("_executePrepareRename", function(i, e, t) {
  return Om(this, void 0, void 0, function* () {
    const { renameProvider: n } = i.get(tt), s = yield new RG(e, t, n).resolveRenameLocation(jt.None);
    if (s?.rejectReason)
      throw new Error(s.rejectReason);
    return s;
  });
});
Di.as(_d.Configuration).registerConfiguration({
  id: "editor",
  properties: {
    "editor.rename.enablePreview": {
      scope: 5,
      description: C("enablePreview", "Enable/disable the ability to preview changes before renaming"),
      default: !0,
      type: "boolean"
    }
  }
});
function vst(i) {
  for (let e = 0, t = i.length; e < t; e += 4) {
    const n = i[e + 0], r = i[e + 1], s = i[e + 2], o = i[e + 3];
    i[e + 0] = o, i[e + 1] = s, i[e + 2] = r, i[e + 3] = n;
  }
}
function _st(i) {
  const e = new Uint8Array(i.buffer, i.byteOffset, i.length * 4);
  return Wue() || vst(e), a4.wrap(e);
}
function hve(i) {
  const e = new Uint32Array(bst(i));
  let t = 0;
  if (e[t++] = i.id, i.type === "full")
    e[t++] = 1, e[t++] = i.data.length, e.set(i.data, t), t += i.data.length;
  else {
    e[t++] = 2, e[t++] = i.deltas.length;
    for (const n of i.deltas)
      e[t++] = n.start, e[t++] = n.deleteCount, n.data ? (e[t++] = n.data.length, e.set(n.data, t), t += n.data.length) : e[t++] = 0;
  }
  return _st(e);
}
function bst(i) {
  let e = 0;
  if (e += 2, i.type === "full")
    e += 1 + i.data.length;
  else {
    e += 1, e += 3 * i.deltas.length;
    for (const t of i.deltas)
      t.data && (e += t.data.length);
  }
  return e;
}
var np = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
function q5(i) {
  return i && !!i.data;
}
function fve(i) {
  return i && Array.isArray(i.edits);
}
class Cst {
  constructor(e, t, n) {
    this.provider = e, this.tokens = t, this.error = n;
  }
}
function gve(i, e) {
  return i.has(e);
}
function yst(i, e) {
  const t = i.orderedGroups(e);
  return t.length > 0 ? t[0] : [];
}
function pve(i, e, t, n, r) {
  return np(this, void 0, void 0, function* () {
    const s = yst(i, e), o = yield Promise.all(s.map((a) => np(this, void 0, void 0, function* () {
      let l, c = null;
      try {
        l = yield a.provideDocumentSemanticTokens(e, a === t ? n : null, r);
      } catch (d) {
        c = d, l = null;
      }
      return (!l || !q5(l) && !fve(l)) && (l = null), new Cst(a, l, c);
    })));
    for (const a of o) {
      if (a.error)
        throw a.error;
      if (a.tokens)
        return a;
    }
    return o.length > 0 ? o[0] : null;
  });
}
function wst(i, e) {
  const t = i.orderedGroups(e);
  return t.length > 0 ? t[0] : null;
}
class Sst {
  constructor(e, t) {
    this.provider = e, this.tokens = t;
  }
}
function xst(i, e) {
  return i.has(e);
}
function mve(i, e) {
  const t = i.orderedGroups(e);
  return t.length > 0 ? t[0] : [];
}
function BG(i, e, t, n) {
  return np(this, void 0, void 0, function* () {
    const r = mve(i, e), s = yield Promise.all(r.map((o) => np(this, void 0, void 0, function* () {
      let a;
      try {
        a = yield o.provideDocumentRangeSemanticTokens(e, t, n);
      } catch (l) {
        vr(l), a = null;
      }
      return (!a || !q5(a)) && (a = null), new Sst(o, a);
    })));
    for (const o of s)
      if (o.tokens)
        return o;
    return s.length > 0 ? s[0] : null;
  });
}
on.registerCommand("_provideDocumentSemanticTokensLegend", (i, ...e) => np(void 0, void 0, void 0, function* () {
  const [t] = e;
  On(t instanceof pt);
  const n = i.get(fi).getModel(t);
  if (!n)
    return;
  const { documentSemanticTokensProvider: r } = i.get(tt), s = wst(r, n);
  return s ? s[0].getLegend() : i.get(Ui).executeCommand("_provideDocumentRangeSemanticTokensLegend", t);
}));
on.registerCommand("_provideDocumentSemanticTokens", (i, ...e) => np(void 0, void 0, void 0, function* () {
  const [t] = e;
  On(t instanceof pt);
  const n = i.get(fi).getModel(t);
  if (!n)
    return;
  const { documentSemanticTokensProvider: r } = i.get(tt);
  if (!gve(r, n))
    return i.get(Ui).executeCommand("_provideDocumentRangeSemanticTokens", t, n.getFullModelRange());
  const s = yield pve(r, n, null, null, jt.None);
  if (!s)
    return;
  const { provider: o, tokens: a } = s;
  if (!a || !q5(a))
    return;
  const l = hve({
    id: 0,
    type: "full",
    data: a.data
  });
  return a.resultId && o.releaseDocumentSemanticTokens(a.resultId), l;
}));
on.registerCommand("_provideDocumentRangeSemanticTokensLegend", (i, ...e) => np(void 0, void 0, void 0, function* () {
  const [t, n] = e;
  On(t instanceof pt);
  const r = i.get(fi).getModel(t);
  if (!r)
    return;
  const { documentRangeSemanticTokensProvider: s } = i.get(tt), o = mve(s, r);
  if (o.length === 0)
    return;
  if (o.length === 1)
    return o[0].getLegend();
  if (!n || !V.isIRange(n))
    return console.warn("provideDocumentRangeSemanticTokensLegend might be out-of-sync with provideDocumentRangeSemanticTokens unless a range argument is passed in"), o[0].getLegend();
  const a = yield BG(s, r, V.lift(n), jt.None);
  if (a)
    return a.provider.getLegend();
}));
on.registerCommand("_provideDocumentRangeSemanticTokens", (i, ...e) => np(void 0, void 0, void 0, function* () {
  const [t, n] = e;
  On(t instanceof pt), On(V.isIRange(n));
  const r = i.get(fi).getModel(t);
  if (!r)
    return;
  const { documentRangeSemanticTokensProvider: s } = i.get(tt), o = yield BG(s, r, V.lift(n), jt.None);
  if (!(!o || !o.tokens))
    return hve({
      id: 0,
      type: "full",
      data: o.tokens.data
    });
}));
const VG = "editor.semanticHighlighting";
function GH(i, e, t) {
  var n;
  const r = (n = t.getValue(VG, { overrideIdentifier: i.getLanguageId(), resource: i.uri })) === null || n === void 0 ? void 0 : n.enabled;
  return typeof r == "boolean" ? r : e.getColorTheme().semanticHighlighting;
}
var vve = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Fd = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Pf;
let qH = class extends we {
  constructor(e, t, n, r, s, o) {
    super(), this._watchers = /* @__PURE__ */ Object.create(null);
    const a = (d) => {
      this._watchers[d.uri.toString()] = new Uw(d, e, n, s, o);
    }, l = (d, u) => {
      u.dispose(), delete this._watchers[d.uri.toString()];
    }, c = () => {
      for (const d of t.getModels()) {
        const u = this._watchers[d.uri.toString()];
        GH(d, n, r) ? u || a(d) : u && l(d, u);
      }
    };
    this._register(t.onModelAdded((d) => {
      GH(d, n, r) && a(d);
    })), this._register(t.onModelRemoved((d) => {
      const u = this._watchers[d.uri.toString()];
      u && l(d, u);
    })), this._register(r.onDidChangeConfiguration((d) => {
      d.affectsConfiguration(VG) && c();
    })), this._register(n.onDidColorThemeChange(c));
  }
  dispose() {
    for (const e of Object.values(this._watchers))
      e.dispose();
    super.dispose();
  }
};
qH = vve([
  Fd(0, A4),
  Fd(1, fi),
  Fd(2, Pr),
  Fd(3, en),
  Fd(4, kl),
  Fd(5, tt)
], qH);
let Uw = Pf = class extends we {
  constructor(e, t, n, r, s) {
    super(), this._semanticTokensStylingService = t, this._isDisposed = !1, this._model = e, this._provider = s.documentSemanticTokensProvider, this._debounceInformation = r.for(this._provider, "DocumentSemanticTokens", { min: Pf.REQUEST_MIN_DELAY, max: Pf.REQUEST_MAX_DELAY }), this._fetchDocumentSemanticTokens = this._register(new Rn(() => this._fetchDocumentSemanticTokensNow(), Pf.REQUEST_MIN_DELAY)), this._currentDocumentResponse = null, this._currentDocumentRequestCancellationTokenSource = null, this._documentProvidersChangeListeners = [], this._providersChangedDuringRequest = !1, this._register(this._model.onDidChangeContent(() => {
      this._fetchDocumentSemanticTokens.isScheduled() || this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    })), this._register(this._model.onDidChangeAttached(() => {
      this._fetchDocumentSemanticTokens.isScheduled() || this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    })), this._register(this._model.onDidChangeLanguage(() => {
      this._currentDocumentResponse && (this._currentDocumentResponse.dispose(), this._currentDocumentResponse = null), this._currentDocumentRequestCancellationTokenSource && (this._currentDocumentRequestCancellationTokenSource.cancel(), this._currentDocumentRequestCancellationTokenSource = null), this._setDocumentSemanticTokens(null, null, null, []), this._fetchDocumentSemanticTokens.schedule(0);
    }));
    const o = () => {
      An(this._documentProvidersChangeListeners), this._documentProvidersChangeListeners = [];
      for (const a of this._provider.all(e))
        typeof a.onDidChange == "function" && this._documentProvidersChangeListeners.push(a.onDidChange(() => {
          if (this._currentDocumentRequestCancellationTokenSource) {
            this._providersChangedDuringRequest = !0;
            return;
          }
          this._fetchDocumentSemanticTokens.schedule(0);
        }));
    };
    o(), this._register(this._provider.onDidChange(() => {
      o(), this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    })), this._register(n.onDidColorThemeChange((a) => {
      this._setDocumentSemanticTokens(null, null, null, []), this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    })), this._fetchDocumentSemanticTokens.schedule(0);
  }
  dispose() {
    this._currentDocumentResponse && (this._currentDocumentResponse.dispose(), this._currentDocumentResponse = null), this._currentDocumentRequestCancellationTokenSource && (this._currentDocumentRequestCancellationTokenSource.cancel(), this._currentDocumentRequestCancellationTokenSource = null), An(this._documentProvidersChangeListeners), this._documentProvidersChangeListeners = [], this._setDocumentSemanticTokens(null, null, null, []), this._isDisposed = !0, super.dispose();
  }
  _fetchDocumentSemanticTokensNow() {
    if (this._currentDocumentRequestCancellationTokenSource)
      return;
    if (!gve(this._provider, this._model)) {
      this._currentDocumentResponse && this._model.tokenization.setSemanticTokens(null, !1);
      return;
    }
    if (!this._model.isAttachedToEditor())
      return;
    const e = new lr(), t = this._currentDocumentResponse ? this._currentDocumentResponse.provider : null, n = this._currentDocumentResponse && this._currentDocumentResponse.resultId || null, r = pve(this._provider, this._model, t, n, e.token);
    this._currentDocumentRequestCancellationTokenSource = e, this._providersChangedDuringRequest = !1;
    const s = [], o = this._model.onDidChangeContent((l) => {
      s.push(l);
    }), a = new Vs(!1);
    r.then((l) => {
      if (this._debounceInformation.update(this._model, a.elapsed()), this._currentDocumentRequestCancellationTokenSource = null, o.dispose(), !l)
        this._setDocumentSemanticTokens(null, null, null, s);
      else {
        const { provider: c, tokens: d } = l, u = this._semanticTokensStylingService.getStyling(c);
        this._setDocumentSemanticTokens(c, d || null, u, s);
      }
    }, (l) => {
      l && (md(l) || typeof l.message == "string" && l.message.indexOf("busy") !== -1) || It(l), this._currentDocumentRequestCancellationTokenSource = null, o.dispose(), (s.length > 0 || this._providersChangedDuringRequest) && (this._fetchDocumentSemanticTokens.isScheduled() || this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model)));
    });
  }
  static _copy(e, t, n, r, s) {
    s = Math.min(s, n.length - r, e.length - t);
    for (let o = 0; o < s; o++)
      n[r + o] = e[t + o];
  }
  _setDocumentSemanticTokens(e, t, n, r) {
    const s = this._currentDocumentResponse, o = () => {
      (r.length > 0 || this._providersChangedDuringRequest) && !this._fetchDocumentSemanticTokens.isScheduled() && this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    };
    if (this._currentDocumentResponse && (this._currentDocumentResponse.dispose(), this._currentDocumentResponse = null), this._isDisposed) {
      e && t && e.releaseDocumentSemanticTokens(t.resultId);
      return;
    }
    if (!e || !n) {
      this._model.tokenization.setSemanticTokens(null, !1);
      return;
    }
    if (!t) {
      this._model.tokenization.setSemanticTokens(null, !0), o();
      return;
    }
    if (fve(t)) {
      if (!s) {
        this._model.tokenization.setSemanticTokens(null, !0);
        return;
      }
      if (t.edits.length === 0)
        t = {
          resultId: t.resultId,
          data: s.data
        };
      else {
        let a = 0;
        for (const h of t.edits)
          a += (h.data ? h.data.length : 0) - h.deleteCount;
        const l = s.data, c = new Uint32Array(l.length + a);
        let d = l.length, u = c.length;
        for (let h = t.edits.length - 1; h >= 0; h--) {
          const f = t.edits[h];
          if (f.start > l.length) {
            n.warnInvalidEditStart(s.resultId, t.resultId, h, f.start, l.length), this._model.tokenization.setSemanticTokens(null, !0);
            return;
          }
          const g = d - (f.start + f.deleteCount);
          g > 0 && (Pf._copy(l, d - g, c, u - g, g), u -= g), f.data && (Pf._copy(f.data, 0, c, u - f.data.length, f.data.length), u -= f.data.length), d = f.start;
        }
        d > 0 && Pf._copy(l, 0, c, 0, d), t = {
          resultId: t.resultId,
          data: c
        };
      }
    }
    if (q5(t)) {
      this._currentDocumentResponse = new Dst(e, t.resultId, t.data);
      const a = zge(t, n, this._model.getLanguageId());
      if (r.length > 0)
        for (const l of r)
          for (const c of a)
            for (const d of l.changes)
              c.applyEdit(d.range, d.text);
      this._model.tokenization.setSemanticTokens(a, !0);
    } else
      this._model.tokenization.setSemanticTokens(null, !0);
    o();
  }
};
Uw.REQUEST_MIN_DELAY = 300;
Uw.REQUEST_MAX_DELAY = 2e3;
Uw = Pf = vve([
  Fd(1, A4),
  Fd(2, Pr),
  Fd(3, kl),
  Fd(4, tt)
], Uw);
class Dst {
  constructor(e, t, n) {
    this.provider = e, this.resultId = t, this.data = n;
  }
  dispose() {
    this.provider.releaseDocumentSemanticTokens(this.resultId);
  }
}
Z4(qH);
var Est = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, D2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Gw = class extends we {
  constructor(e, t, n, r, s, o) {
    super(), this._semanticTokensStylingService = t, this._themeService = n, this._configurationService = r, this._editor = e, this._provider = o.documentRangeSemanticTokensProvider, this._debounceInformation = s.for(this._provider, "DocumentRangeSemanticTokens", { min: 100, max: 500 }), this._tokenizeViewport = this._register(new Rn(() => this._tokenizeViewportNow(), 100)), this._outstandingRequests = [];
    const a = () => {
      this._editor.hasModel() && this._tokenizeViewport.schedule(this._debounceInformation.get(this._editor.getModel()));
    };
    this._register(this._editor.onDidScrollChange(() => {
      a();
    })), this._register(this._editor.onDidChangeModel(() => {
      this._cancelAll(), a();
    })), this._register(this._editor.onDidChangeModelContent((l) => {
      this._cancelAll(), a();
    })), this._register(this._provider.onDidChange(() => {
      this._cancelAll(), a();
    })), this._register(this._configurationService.onDidChangeConfiguration((l) => {
      l.affectsConfiguration(VG) && (this._cancelAll(), a());
    })), this._register(this._themeService.onDidColorThemeChange(() => {
      this._cancelAll(), a();
    })), a();
  }
  _cancelAll() {
    for (const e of this._outstandingRequests)
      e.cancel();
    this._outstandingRequests = [];
  }
  _removeOutstandingRequest(e) {
    for (let t = 0, n = this._outstandingRequests.length; t < n; t++)
      if (this._outstandingRequests[t] === e) {
        this._outstandingRequests.splice(t, 1);
        return;
      }
  }
  _tokenizeViewportNow() {
    if (!this._editor.hasModel())
      return;
    const e = this._editor.getModel();
    if (e.tokenization.hasCompleteSemanticTokens())
      return;
    if (!GH(e, this._themeService, this._configurationService)) {
      e.tokenization.hasSomeSemanticTokens() && e.tokenization.setSemanticTokens(null, !1);
      return;
    }
    if (!xst(this._provider, e)) {
      e.tokenization.hasSomeSemanticTokens() && e.tokenization.setSemanticTokens(null, !1);
      return;
    }
    const t = this._editor.getVisibleRangesPlusViewportAboveBelow();
    this._outstandingRequests = this._outstandingRequests.concat(t.map((n) => this._requestRange(e, n)));
  }
  _requestRange(e, t) {
    const n = e.getVersionId(), r = Ir((o) => Promise.resolve(BG(this._provider, e, t, o))), s = new Vs(!1);
    return r.then((o) => {
      if (this._debounceInformation.update(e, s.elapsed()), !o || !o.tokens || e.isDisposed() || e.getVersionId() !== n)
        return;
      const { provider: a, tokens: l } = o, c = this._semanticTokensStylingService.getStyling(a);
      e.tokenization.setPartialSemanticTokens(t, zge(l, c, e.getLanguageId()));
    }).then(() => this._removeOutstandingRequest(r), () => this._removeOutstandingRequest(r)), r;
  }
};
Gw.ID = "editor.contrib.viewportSemanticTokens";
Gw = Est([
  D2(1, A4),
  D2(2, Pr),
  D2(3, en),
  D2(4, kl),
  D2(5, tt)
], Gw);
pn(
  Gw.ID,
  Gw,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
class Lst {
  constructor(e = !0) {
    this.selectSubwords = e;
  }
  provideSelectionRanges(e, t) {
    const n = [];
    for (const r of t) {
      const s = [];
      n.push(s), this.selectSubwords && this._addInWordRanges(s, e, r), this._addWordRanges(s, e, r), this._addWhitespaceLine(s, e, r), s.push({ range: e.getFullModelRange() });
    }
    return n;
  }
  _addInWordRanges(e, t, n) {
    const r = t.getWordAtPosition(n);
    if (!r)
      return;
    const { word: s, startColumn: o } = r, a = n.column - o;
    let l = a, c = a, d = 0;
    for (; l >= 0; l--) {
      const u = s.charCodeAt(l);
      if (l !== a && (u === 95 || u === 45))
        break;
      if (Xf(u) && Od(d))
        break;
      d = u;
    }
    for (l += 1; c < s.length; c++) {
      const u = s.charCodeAt(c);
      if (Od(u) && Xf(d))
        break;
      if (u === 95 || u === 45)
        break;
      d = u;
    }
    l < c && e.push({ range: new V(n.lineNumber, o + l, n.lineNumber, o + c) });
  }
  _addWordRanges(e, t, n) {
    const r = t.getWordAtPosition(n);
    r && e.push({ range: new V(n.lineNumber, r.startColumn, n.lineNumber, r.endColumn) });
  }
  _addWhitespaceLine(e, t, n) {
    t.getLineLength(n.lineNumber) > 0 && t.getLineFirstNonWhitespaceColumn(n.lineNumber) === 0 && t.getLineLastNonWhitespaceColumn(n.lineNumber) === 0 && e.push({ range: new V(n.lineNumber, 1, n.lineNumber, t.getLineMaxColumn(n.lineNumber)) });
  }
}
var Ist = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Ast = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, K5 = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, KH;
class HG {
  constructor(e, t) {
    this.index = e, this.ranges = t;
  }
  mov(e) {
    const t = this.index + (e ? 1 : -1);
    if (t < 0 || t >= this.ranges.length)
      return this;
    const n = new HG(t, this.ranges);
    return n.ranges[t].equalsRange(this.ranges[this.index]) ? n.mov(e) : n;
  }
}
let X_ = KH = class {
  static get(e) {
    return e.getContribution(KH.ID);
  }
  constructor(e, t) {
    this._editor = e, this._languageFeaturesService = t, this._ignoreSelection = !1;
  }
  dispose() {
    var e;
    (e = this._selectionListener) === null || e === void 0 || e.dispose();
  }
  run(e) {
    return K5(this, void 0, void 0, function* () {
      if (!this._editor.hasModel())
        return;
      const t = this._editor.getSelections(), n = this._editor.getModel();
      if (this._state || (yield bve(this._languageFeaturesService.selectionRangeProvider, n, t.map((s) => s.getPosition()), this._editor.getOption(
        112
        /* EditorOption.smartSelect */
      ), jt.None).then((s) => {
        var o;
        if (!(!Bs(s) || s.length !== t.length) && !(!this._editor.hasModel() || !Qi(this._editor.getSelections(), t, (a, l) => a.equalsSelection(l)))) {
          for (let a = 0; a < s.length; a++)
            s[a] = s[a].filter((l) => l.containsPosition(t[a].getStartPosition()) && l.containsPosition(t[a].getEndPosition())), s[a].unshift(t[a]);
          this._state = s.map((a) => new HG(0, a)), (o = this._selectionListener) === null || o === void 0 || o.dispose(), this._selectionListener = this._editor.onDidChangeCursorPosition(() => {
            var a;
            this._ignoreSelection || ((a = this._selectionListener) === null || a === void 0 || a.dispose(), this._state = void 0);
          });
        }
      })), !this._state)
        return;
      this._state = this._state.map((s) => s.mov(e));
      const r = this._state.map((s) => ot.fromPositions(s.ranges[s.index].getStartPosition(), s.ranges[s.index].getEndPosition()));
      this._ignoreSelection = !0;
      try {
        this._editor.setSelections(r);
      } finally {
        this._ignoreSelection = !1;
      }
    });
  }
};
X_.ID = "editor.contrib.smartSelectController";
X_ = KH = Ist([
  Ast(1, tt)
], X_);
class _ve extends Je {
  constructor(e, t) {
    super(t), this._forward = e;
  }
  run(e, t) {
    return K5(this, void 0, void 0, function* () {
      const n = X_.get(t);
      n && (yield n.run(this._forward));
    });
  }
}
class kst extends _ve {
  constructor() {
    super(!0, {
      id: "editor.action.smartSelect.expand",
      label: C("smartSelect.expand", "Expand Selection"),
      alias: "Expand Selection",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 1553,
        mac: {
          primary: 3345,
          secondary: [
            1297
            /* KeyCode.RightArrow */
          ]
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "1_basic",
        title: C({ key: "miSmartSelectGrow", comment: ["&& denotes a mnemonic"] }, "&&Expand Selection"),
        order: 2
      }
    });
  }
}
on.registerCommandAlias("editor.action.smartSelect.grow", "editor.action.smartSelect.expand");
class Tst extends _ve {
  constructor() {
    super(!1, {
      id: "editor.action.smartSelect.shrink",
      label: C("smartSelect.shrink", "Shrink Selection"),
      alias: "Shrink Selection",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 1551,
        mac: {
          primary: 3343,
          secondary: [
            1295
            /* KeyCode.LeftArrow */
          ]
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      menuOpts: {
        menuId: J.MenubarSelectionMenu,
        group: "1_basic",
        title: C({ key: "miSmartSelectShrink", comment: ["&& denotes a mnemonic"] }, "&&Shrink Selection"),
        order: 3
      }
    });
  }
}
pn(
  X_.ID,
  X_,
  4
  /* EditorContributionInstantiation.Lazy */
);
Be(kst);
Be(Tst);
function bve(i, e, t, n, r) {
  return K5(this, void 0, void 0, function* () {
    const s = i.all(e).concat(new Lst(n.selectSubwords));
    s.length === 1 && s.unshift(new wa());
    const o = [], a = [];
    for (const l of s)
      o.push(Promise.resolve(l.provideSelectionRanges(e, t, r)).then((c) => {
        if (Bs(c) && c.length === t.length)
          for (let d = 0; d < t.length; d++) {
            a[d] || (a[d] = []);
            for (const u of c[d])
              V.isIRange(u.range) && V.containsPosition(u.range, t[d]) && a[d].push(V.lift(u.range));
          }
      }, vr));
    return yield Promise.all(o), a.map((l) => {
      if (l.length === 0)
        return [];
      l.sort((h, f) => ve.isBefore(h.getStartPosition(), f.getStartPosition()) ? 1 : ve.isBefore(f.getStartPosition(), h.getStartPosition()) || ve.isBefore(h.getEndPosition(), f.getEndPosition()) ? -1 : ve.isBefore(f.getEndPosition(), h.getEndPosition()) ? 1 : 0);
      const c = [];
      let d;
      for (const h of l)
        (!d || V.containsRange(h, d) && !V.equalsRange(h, d)) && (c.push(h), d = h);
      if (!n.selectLeadingAndTrailingWhitespace)
        return c;
      const u = [c[0]];
      for (let h = 1; h < c.length; h++) {
        const f = c[h - 1], g = c[h];
        if (g.startLineNumber !== f.startLineNumber || g.endLineNumber !== f.endLineNumber) {
          const p = new V(f.startLineNumber, e.getLineFirstNonWhitespaceColumn(f.startLineNumber), f.endLineNumber, e.getLineLastNonWhitespaceColumn(f.endLineNumber));
          p.containsRange(f) && !p.equalsRange(f) && g.containsRange(p) && !g.equalsRange(p) && u.push(p);
          const m = new V(f.startLineNumber, 1, f.endLineNumber, e.getLineMaxColumn(f.endLineNumber));
          m.containsRange(f) && !m.equalsRange(p) && g.containsRange(m) && !g.equalsRange(m) && u.push(m);
        }
        u.push(g);
      }
      return u;
    });
  });
}
on.registerCommand("_executeSelectionRangeProvider", function(i, ...e) {
  return K5(this, void 0, void 0, function* () {
    const [t, n] = e;
    On(pt.isUri(t));
    const r = i.get(tt).selectionRangeProvider, s = yield i.get(Wo).createModelReference(t);
    try {
      return bve(r, s.object.textEditorModel, n, { selectLeadingAndTrailingWhitespace: !0, selectSubwords: !0 }, jt.None);
    } finally {
      s.dispose();
    }
  });
});
const Nst = Object.freeze({
  View: { value: C("view", "View"), original: "View" },
  Help: { value: C("help", "Help"), original: "Help" },
  Test: { value: C("test", "Test"), original: "Test" },
  File: { value: C("file", "File"), original: "File" },
  Preferences: { value: C("preferences", "Preferences"), original: "Preferences" },
  Developer: { value: C({ key: "developer", comment: ["A developer on Code itself or someone diagnosing issues in Code"] }, "Developer"), original: "Developer" }
});
var Pst = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class Aee {
  constructor(e, t, n, r = null) {
    this.startLineNumbers = e, this.endLineNumbers = t, this.lastLineRelativePosition = n, this.showEndForLine = r;
  }
  equals(e) {
    return !!e && this.lastLineRelativePosition === e.lastLineRelativePosition && this.showEndForLine === e.showEndForLine && Qi(this.startLineNumbers, e.startLineNumbers) && Qi(this.endLineNumbers, e.endLineNumbers);
  }
}
const kee = af("stickyScrollViewLayer", { createHTML: (i) => i }), UT = "data-sticky-line-index", Tee = "data-sticky-is-line", Ost = "data-sticky-is-line-number", Nee = "data-sticky-is-folding-icon";
class Mst extends we {
  constructor(e) {
    super(), this._editor = e, this._foldingIconStore = new Ne(), this._rootDomNode = document.createElement("div"), this._lineNumbersDomNode = document.createElement("div"), this._linesDomNodeScrollable = document.createElement("div"), this._linesDomNode = document.createElement("div"), this._lineHeight = this._editor.getOption(
      66
      /* EditorOption.lineHeight */
    ), this._stickyLines = [], this._lineNumbers = [], this._lastLineRelativePosition = 0, this._minContentWidthInPx = 0, this._isOnGlyphMargin = !1, this._lineNumbersDomNode.className = "sticky-widget-line-numbers", this._lineNumbersDomNode.setAttribute("role", "none"), this._linesDomNode.className = "sticky-widget-lines", this._linesDomNode.setAttribute("role", "list"), this._linesDomNodeScrollable.className = "sticky-widget-lines-scrollable", this._linesDomNodeScrollable.appendChild(this._linesDomNode), this._rootDomNode.className = "sticky-widget", this._rootDomNode.classList.toggle("peek", e instanceof Yg), this._rootDomNode.appendChild(this._lineNumbersDomNode), this._rootDomNode.appendChild(this._linesDomNodeScrollable);
    const t = () => {
      this._linesDomNode.style.left = this._editor.getOption(
        114
        /* EditorOption.stickyScroll */
      ).scrollWithEditor ? `-${this._editor.getScrollLeft()}px` : "0px";
    };
    this._register(this._editor.onDidChangeConfiguration((n) => {
      n.hasChanged(
        114
        /* EditorOption.stickyScroll */
      ) && t(), n.hasChanged(
        66
        /* EditorOption.lineHeight */
      ) && (this._lineHeight = this._editor.getOption(
        66
        /* EditorOption.lineHeight */
      ));
    })), this._register(this._editor.onDidScrollChange((n) => {
      n.scrollLeftChanged && t(), n.scrollWidthChanged && this._updateWidgetWidth();
    })), this._register(this._editor.onDidChangeModel(() => {
      t(), this._updateWidgetWidth();
    })), this._register(this._foldingIconStore), t(), this._register(this._editor.onDidLayoutChange((n) => {
      this._updateWidgetWidth();
    })), this._updateWidgetWidth();
  }
  get lineNumbers() {
    return this._lineNumbers;
  }
  get lineNumberCount() {
    return this._lineNumbers.length;
  }
  getStickyLineForLine(e) {
    return this._stickyLines.find((t) => t.lineNumber === e);
  }
  getCurrentLines() {
    return this._lineNumbers;
  }
  setState(e, t, n = 1 / 0) {
    if ((!this._previousState && !e || this._previousState && this._previousState.equals(e)) && n === 1 / 0)
      return;
    this._previousState = e;
    const r = this._stickyLines;
    if (this._clearStickyWidget(), !e || !this._editor._getViewModel())
      return;
    if (e.startLineNumbers.length * this._lineHeight + e.lastLineRelativePosition > 0) {
      this._lastLineRelativePosition = e.lastLineRelativePosition;
      const o = [...e.startLineNumbers];
      e.showEndForLine !== null && (o[e.showEndForLine] = e.endLineNumbers[e.showEndForLine]), this._lineNumbers = o;
    } else
      this._lastLineRelativePosition = 0, this._lineNumbers = [];
    this._renderRootNode(r, t, n);
  }
  _updateWidgetWidth() {
    const e = this._editor.getLayoutInfo(), t = e.contentLeft;
    this._lineNumbersDomNode.style.width = `${t}px`, this._linesDomNodeScrollable.style.setProperty("--vscode-editorStickyScroll-scrollableWidth", `${this._editor.getScrollWidth() - e.verticalScrollbarWidth}px`), this._rootDomNode.style.width = `${e.width - e.verticalScrollbarWidth}px`;
  }
  _clearStickyWidget() {
    this._stickyLines = [], this._foldingIconStore.clear(), ls(this._lineNumbersDomNode), ls(this._linesDomNode), this._rootDomNode.style.display = "none";
  }
  _useFoldingOpacityTransition(e) {
    this._lineNumbersDomNode.style.setProperty("--vscode-editorStickyScroll-foldingOpacityTransition", `opacity ${e ? 0.5 : 0}s`);
  }
  _setFoldingIconsVisibility(e) {
    for (const t of this._stickyLines) {
      const n = t.foldingIcon;
      n && n.setVisible(e ? !0 : n.isCollapsed);
    }
  }
  _renderRootNode(e, t, n = 1 / 0) {
    return Pst(this, void 0, void 0, function* () {
      const r = this._editor.getLayoutInfo();
      for (const [o, a] of this._lineNumbers.entries()) {
        const l = e[o], c = a >= n || l?.lineNumber !== a ? this._renderChildNode(o, a, t, r) : this._updateTopAndZIndexOfStickyLine(l);
        c && (this._linesDomNode.appendChild(c.lineDomNode), this._lineNumbersDomNode.appendChild(c.lineNumberDomNode), this._stickyLines.push(c));
      }
      t && (this._setFoldingHoverListeners(), this._useFoldingOpacityTransition(!this._isOnGlyphMargin));
      const s = this._lineNumbers.length * this._lineHeight + this._lastLineRelativePosition;
      if (s === 0) {
        this._clearStickyWidget();
        return;
      }
      this._rootDomNode.style.display = "block", this._lineNumbersDomNode.style.height = `${s}px`, this._linesDomNodeScrollable.style.height = `${s}px`, this._rootDomNode.style.height = `${s}px`, this._rootDomNode.style.marginLeft = "0px", this._updateMinContentWidth(), this._editor.layoutOverlayWidget(this);
    });
  }
  _setFoldingHoverListeners() {
    this._editor.getOption(
      109
      /* EditorOption.showFoldingControls */
    ) === "mouseover" && (this._foldingIconStore.add(Ie(this._lineNumbersDomNode, Ge.MOUSE_ENTER, (t) => {
      this._isOnGlyphMargin = !0, this._setFoldingIconsVisibility(!0);
    })), this._foldingIconStore.add(Ie(this._lineNumbersDomNode, Ge.MOUSE_LEAVE, () => {
      this._isOnGlyphMargin = !1, this._useFoldingOpacityTransition(!0), this._setFoldingIconsVisibility(!1);
    })));
  }
  _renderChildNode(e, t, n, r) {
    const s = this._editor._getViewModel();
    if (!s)
      return;
    const o = s.coordinatesConverter.convertModelPositionToViewPosition(new ve(t, 1)).lineNumber, a = s.getViewLineRenderingData(o), l = this._editor.getOption(
      67
      /* EditorOption.lineNumbers */
    );
    let c;
    try {
      c = ea.filter(a.inlineDecorations, o, a.minColumn, a.maxColumn);
    } catch {
      c = [];
    }
    const d = new dp(!0, !0, a.content, a.continuesWithWrappedLine, a.isBasicASCII, a.containsRTL, 0, a.tokens, c, a.tabSize, a.startVisibleColumn, 1, 1, 1, 500, "none", !0, !0, null), u = new pb(2e3), h = ES(d, u);
    let f;
    kee ? f = kee.createHTML(u.build()) : f = u.build();
    const g = document.createElement("span");
    g.setAttribute(UT, String(e)), g.setAttribute(Tee, ""), g.setAttribute("role", "listitem"), g.tabIndex = 0, g.className = "sticky-line-content", g.classList.add(`stickyLine${t}`), g.style.lineHeight = `${this._lineHeight}px`, g.innerHTML = f;
    const p = document.createElement("span");
    p.setAttribute(UT, String(e)), p.setAttribute(Ost, ""), p.className = "sticky-line-number", p.style.lineHeight = `${this._lineHeight}px`;
    const m = r.contentLeft;
    p.style.width = `${m}px`;
    const _ = document.createElement("span");
    l.renderType === 1 || l.renderType === 3 && t % 10 === 0 ? _.innerText = t.toString() : l.renderType === 2 && (_.innerText = Math.abs(t - this._editor.getPosition().lineNumber).toString()), _.className = "sticky-line-number-inner", _.style.lineHeight = `${this._lineHeight}px`, _.style.width = `${r.lineNumbersWidth}px`, _.style.paddingLeft = `${r.lineNumbersLeft}px`, p.appendChild(_);
    const b = this._renderFoldingIconForLine(n, t);
    b && p.appendChild(b.domNode), this._editor.applyFontInfo(g), this._editor.applyFontInfo(_), p.style.lineHeight = `${this._lineHeight}px`, g.style.lineHeight = `${this._lineHeight}px`, p.style.height = `${this._lineHeight}px`, g.style.height = `${this._lineHeight}px`;
    const w = new Rst(e, t, g, p, b, h.characterMapping);
    return this._updateTopAndZIndexOfStickyLine(w);
  }
  _updateTopAndZIndexOfStickyLine(e) {
    var t;
    const n = e.index, r = e.lineDomNode, s = e.lineNumberDomNode, o = n === this._lineNumbers.length - 1, a = "0", l = "1";
    r.style.zIndex = o ? a : l, s.style.zIndex = o ? a : l;
    const c = `${n * this._lineHeight + this._lastLineRelativePosition + (!((t = e.foldingIcon) === null || t === void 0) && t.isCollapsed ? 1 : 0)}px`, d = `${n * this._lineHeight}px`;
    return r.style.top = o ? c : d, s.style.top = o ? c : d, e;
  }
  _renderFoldingIconForLine(e, t) {
    const n = this._editor.getOption(
      109
      /* EditorOption.showFoldingControls */
    );
    if (!e || n === "never")
      return;
    const r = e.regions, s = r.findRange(t), o = r.getStartLineNumber(s);
    if (!(t === o))
      return;
    const l = r.isCollapsed(s), c = new Fst(l, o, r.getEndLineNumber(s), this._lineHeight);
    return c.setVisible(this._isOnGlyphMargin ? !0 : l || n === "always"), c.domNode.setAttribute(Nee, ""), c;
  }
  _updateMinContentWidth() {
    this._minContentWidthInPx = 0;
    for (const e of this._stickyLines)
      e.lineDomNode.scrollWidth > this._minContentWidthInPx && (this._minContentWidthInPx = e.lineDomNode.scrollWidth);
    this._minContentWidthInPx += this._editor.getLayoutInfo().verticalScrollbarWidth;
  }
  getId() {
    return "editor.contrib.stickyScrollWidget";
  }
  getDomNode() {
    return this._rootDomNode;
  }
  getPosition() {
    return {
      preference: null
    };
  }
  getMinContentWidthInPx() {
    return this._minContentWidthInPx;
  }
  focusLineWithIndex(e) {
    0 <= e && e < this._stickyLines.length && this._stickyLines[e].lineDomNode.focus();
  }
  /**
   * Given a leaf dom node, tries to find the editor position.
   */
  getEditorPositionFromNode(e) {
    if (!e || e.children.length > 0)
      return null;
    const t = this._getRenderedStickyLineFromChildDomNode(e);
    if (!t)
      return null;
    const n = bz(t.characterMapping, e, 0);
    return new ve(t.lineNumber, n);
  }
  getLineNumberFromChildDomNode(e) {
    var t, n;
    return (n = (t = this._getRenderedStickyLineFromChildDomNode(e)) === null || t === void 0 ? void 0 : t.lineNumber) !== null && n !== void 0 ? n : null;
  }
  _getRenderedStickyLineFromChildDomNode(e) {
    const t = this.getLineIndexFromChildDomNode(e);
    return t === null || t < 0 || t >= this._stickyLines.length ? null : this._stickyLines[t];
  }
  /**
   * Given a child dom node, tries to find the line number attribute that was stored in the node.
   * @returns the attribute value or null if none is found.
   */
  getLineIndexFromChildDomNode(e) {
    const t = this._getAttributeValue(e, UT);
    return t ? parseInt(t, 10) : null;
  }
  /**
   * Given a child dom node, tries to find if it is (contained in) a sticky line.
   * @returns a boolean.
   */
  isInStickyLine(e) {
    return this._getAttributeValue(e, Tee) !== void 0;
  }
  /**
   * Given a child dom node, tries to find if this dom node is (contained in) a sticky folding icon.
   * @returns a boolean.
   */
  isInFoldingIconDomNode(e) {
    return this._getAttributeValue(e, Nee) !== void 0;
  }
  /**
   * Given the dom node, finds if it or its parent sequence contains the given attribute.
   * @returns the attribute value or undefined.
   */
  _getAttributeValue(e, t) {
    for (; e && e !== this._rootDomNode; ) {
      const n = e.getAttribute(t);
      if (n !== null)
        return n;
      e = e.parentElement;
    }
  }
}
class Rst {
  constructor(e, t, n, r, s, o) {
    this.index = e, this.lineNumber = t, this.lineDomNode = n, this.lineNumberDomNode = r, this.foldingIcon = s, this.characterMapping = o;
  }
}
class Fst {
  constructor(e, t, n, r) {
    this.isCollapsed = e, this.foldingStartLine = t, this.foldingEndLine = n, this.dimension = r, this.domNode = document.createElement("div"), this.domNode.style.width = `${r}px`, this.domNode.style.height = `${r}px`, this.domNode.className = ft.asClassName(e ? L5 : E5);
  }
  setVisible(e) {
    this.domNode.style.cursor = e ? "pointer" : "default", this.domNode.style.opacity = e ? "1" : "0";
  }
}
class ZC {
  constructor(e, t) {
    this.startLineNumber = e, this.endLineNumber = t;
  }
}
class FI {
  constructor(e, t, n) {
    this.range = e, this.children = t, this.parent = n;
  }
}
class Cve {
  constructor(e, t, n, r) {
    this.uri = e, this.version = t, this.element = n, this.outlineProviderId = r;
  }
}
var Y5 = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, qw = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Pee = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, QC;
(function(i) {
  i.OUTLINE_MODEL = "outlineModel", i.FOLDING_PROVIDER_MODEL = "foldingProviderModel", i.INDENTATION_MODEL = "indentationModel";
})(QC || (QC = {}));
var cg;
(function(i) {
  i[i.VALID = 0] = "VALID", i[i.INVALID = 1] = "INVALID", i[i.CANCELED = 2] = "CANCELED";
})(cg || (cg = {}));
let YH = class extends we {
  constructor(e, t, n, r) {
    super(), this._editor = e, this._languageConfigurationService = t, this._languageFeaturesService = n, this._modelProviders = [], this._modelPromise = null, this._updateScheduler = this._register(new ac(300)), this._updateOperation = this._register(new Ne());
    const s = new XH(n), o = new QH(this._editor, n), a = new ZH(this._editor, t);
    switch (r) {
      case QC.OUTLINE_MODEL:
        this._modelProviders.push(s), this._modelProviders.push(o), this._modelProviders.push(a);
        break;
      case QC.FOLDING_PROVIDER_MODEL:
        this._modelProviders.push(o), this._modelProviders.push(a);
        break;
      case QC.INDENTATION_MODEL:
        this._modelProviders.push(a);
        break;
    }
  }
  _cancelModelPromise() {
    this._modelPromise && (this._modelPromise.cancel(), this._modelPromise = null);
  }
  update(e, t, n) {
    return Pee(this, void 0, void 0, function* () {
      return this._updateOperation.clear(), this._updateOperation.add({
        dispose: () => {
          this._cancelModelPromise(), this._updateScheduler.cancel();
        }
      }), this._cancelModelPromise(), yield this._updateScheduler.trigger(() => Pee(this, void 0, void 0, function* () {
        for (const r of this._modelProviders) {
          const { statusPromise: s, modelPromise: o } = r.computeStickyModel(e, t, n);
          this._modelPromise = o;
          const a = yield s;
          if (this._modelPromise !== o)
            return null;
          switch (a) {
            case cg.CANCELED:
              return this._updateOperation.clear(), null;
            case cg.VALID:
              return r.stickyModel;
          }
        }
        return null;
      })).catch((r) => (It(r), null));
    });
  }
};
YH = Y5([
  qw(1, Un),
  qw(2, tt)
], YH);
class yve {
  constructor() {
    this._stickyModel = null;
  }
  get stickyModel() {
    return this._stickyModel;
  }
  _invalid() {
    return this._stickyModel = null, cg.INVALID;
  }
  computeStickyModel(e, t, n) {
    if (n.isCancellationRequested || !this.isProviderValid(e))
      return { statusPromise: this._invalid(), modelPromise: null };
    const r = Ir((s) => this.createModelFromProvider(e, t, s));
    return {
      statusPromise: r.then((s) => this.isModelValid(s) ? n.isCancellationRequested ? cg.CANCELED : (this._stickyModel = this.createStickyModel(e, t, n, s), cg.VALID) : this._invalid()).then(void 0, (s) => (It(s), cg.CANCELED)),
      modelPromise: r
    };
  }
  /**
   * Method which checks whether the model returned by the provider is valid and can be used to compute a sticky model.
   * This method by default returns true.
   * @param model model returned by the provider
   * @returns boolean indicating whether the model is valid
   */
  isModelValid(e) {
    return !0;
  }
  /**
   * Method which checks whether the provider is valid before applying it to find the provider model.
   * This method by default returns true.
   * @param textModel text-model of the editor
   * @returns boolean indicating whether the provider is valid
   */
  isProviderValid(e) {
    return !0;
  }
}
let XH = class extends yve {
  constructor(e) {
    super(), this._languageFeaturesService = e;
  }
  createModelFromProvider(e, t, n) {
    return hh.create(this._languageFeaturesService.documentSymbolProvider, e, n);
  }
  createStickyModel(e, t, n, r) {
    var s;
    const { stickyOutlineElement: o, providerID: a } = this._stickyModelFromOutlineModel(r, (s = this._stickyModel) === null || s === void 0 ? void 0 : s.outlineProviderId);
    return new Cve(e.uri, t, o, a);
  }
  isModelValid(e) {
    return e && e.children.size > 0;
  }
  _stickyModelFromOutlineModel(e, t) {
    let n;
    if (Wt.first(e.children.values()) instanceof z1e) {
      const a = Wt.find(e.children.values(), (l) => l.id === t);
      if (a)
        n = a.children;
      else {
        let l = "", c = -1, d;
        for (const [u, h] of e.children.entries()) {
          const f = this._findSumOfRangesOfGroup(h);
          f > c && (d = h, c = f, l = h.id);
        }
        t = l, n = d.children;
      }
    } else
      n = e.children;
    const r = [], s = Array.from(n.values()).sort((a, l) => {
      const c = new ZC(a.symbol.range.startLineNumber, a.symbol.range.endLineNumber), d = new ZC(l.symbol.range.startLineNumber, l.symbol.range.endLineNumber);
      return this._comparator(c, d);
    });
    for (const a of s)
      r.push(this._stickyModelFromOutlineElement(a, a.symbol.selectionRange.startLineNumber));
    return {
      stickyOutlineElement: new FI(void 0, r, void 0),
      providerID: t
    };
  }
  _stickyModelFromOutlineElement(e, t) {
    const n = [];
    for (const s of e.children.values())
      if (s.symbol.selectionRange.startLineNumber !== s.symbol.range.endLineNumber)
        if (s.symbol.selectionRange.startLineNumber !== t)
          n.push(this._stickyModelFromOutlineElement(s, s.symbol.selectionRange.startLineNumber));
        else
          for (const o of s.children.values())
            n.push(this._stickyModelFromOutlineElement(o, s.symbol.selectionRange.startLineNumber));
    n.sort((s, o) => this._comparator(s.range, o.range));
    const r = new ZC(e.symbol.selectionRange.startLineNumber, e.symbol.range.endLineNumber);
    return new FI(r, n, void 0);
  }
  _comparator(e, t) {
    return e.startLineNumber !== t.startLineNumber ? e.startLineNumber - t.startLineNumber : t.endLineNumber - e.endLineNumber;
  }
  _findSumOfRangesOfGroup(e) {
    let t = 0;
    for (const n of e.children.values())
      t += this._findSumOfRangesOfGroup(n);
    return e instanceof mH ? t + e.symbol.range.endLineNumber - e.symbol.selectionRange.startLineNumber : t;
  }
};
XH = Y5([
  qw(0, tt)
], XH);
class wve extends yve {
  constructor(e) {
    super(), this._foldingLimitReporter = new H1e(e);
  }
  createStickyModel(e, t, n, r) {
    const s = this._fromFoldingRegions(r);
    return new Cve(e.uri, t, s, void 0);
  }
  isModelValid(e) {
    return e !== null;
  }
  _fromFoldingRegions(e) {
    const t = e.length, n = [], r = new FI(void 0, [], void 0);
    for (let s = 0; s < t; s++) {
      const o = e.getParentIndex(s);
      let a;
      o !== -1 ? a = n[o] : a = r;
      const l = new FI(new ZC(e.getStartLineNumber(s), e.getEndLineNumber(s) + 1), [], a);
      a.children.push(l), n.push(l);
    }
    return r;
  }
}
let ZH = class extends wve {
  constructor(e, t) {
    super(e), this._languageConfigurationService = t;
  }
  createModelFromProvider(e, t, n) {
    return new wG(e, this._languageConfigurationService, this._foldingLimitReporter).compute(n);
  }
};
ZH = Y5([
  qw(1, Un)
], ZH);
let QH = class extends wve {
  constructor(e, t) {
    super(e), this._languageFeaturesService = t;
  }
  isProviderValid(e) {
    return ku.getFoldingRangeProviders(this._languageFeaturesService, e).length > 0;
  }
  createModelFromProvider(e, t, n) {
    const r = ku.getFoldingRangeProviders(this._languageFeaturesService, e);
    return new xG(e, r, () => this.createModelFromProvider(e, t, n), this._foldingLimitReporter, void 0).compute(n);
  }
};
QH = Y5([
  qw(1, tt)
], QH);
var Bst = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Oee = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Mee = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class Vst {
  constructor(e, t, n) {
    this.startLineNumber = e, this.endLineNumber = t, this.nestingDepth = n;
  }
}
let JH = class extends we {
  constructor(e, t, n) {
    super(), this._languageFeaturesService = t, this._languageConfigurationService = n, this._onDidChangeStickyScroll = this._register(new pe()), this.onDidChangeStickyScroll = this._onDidChangeStickyScroll.event, this._options = null, this._model = null, this._cts = null, this._stickyModelProvider = null, this._editor = e, this._sessionStore = this._register(new Ne()), this._updateSoon = this._register(new Rn(() => this.update(), 50)), this._register(this._editor.onDidChangeConfiguration((r) => {
      r.hasChanged(
        114
        /* EditorOption.stickyScroll */
      ) && this.readConfiguration();
    })), this.readConfiguration();
  }
  readConfiguration() {
    this._stickyModelProvider = null, this._sessionStore.clear(), this._options = this._editor.getOption(
      114
      /* EditorOption.stickyScroll */
    ), this._options.enabled && (this._stickyModelProvider = this._sessionStore.add(new YH(this._editor, this._languageConfigurationService, this._languageFeaturesService, this._options.defaultModel)), this._sessionStore.add(this._editor.onDidChangeModel(() => {
      this._model = null, this._onDidChangeStickyScroll.fire(), this.update();
    })), this._sessionStore.add(this._editor.onDidChangeHiddenAreas(() => this.update())), this._sessionStore.add(this._editor.onDidChangeModelContent(() => this._updateSoon.schedule())), this._sessionStore.add(this._languageFeaturesService.documentSymbolProvider.onDidChange(() => this.update())), this.update());
  }
  getVersionId() {
    var e;
    return (e = this._model) === null || e === void 0 ? void 0 : e.version;
  }
  update() {
    var e;
    return Mee(this, void 0, void 0, function* () {
      (e = this._cts) === null || e === void 0 || e.dispose(!0), this._cts = new lr(), yield this.updateStickyModel(this._cts.token), this._onDidChangeStickyScroll.fire();
    });
  }
  updateStickyModel(e) {
    return Mee(this, void 0, void 0, function* () {
      if (!this._editor.hasModel() || !this._stickyModelProvider || this._editor.getModel().isTooLargeForTokenization()) {
        this._model = null;
        return;
      }
      const t = this._editor.getModel(), n = t.getVersionId(), r = yield this._stickyModelProvider.update(t, n, e);
      e.isCancellationRequested || (this._model = r);
    });
  }
  updateIndex(e) {
    return e === -1 ? e = 0 : e < 0 && (e = -e - 2), e;
  }
  getCandidateStickyLinesIntersectingFromStickyModel(e, t, n, r, s) {
    if (t.children.length === 0)
      return;
    let o = s;
    const a = [];
    for (let d = 0; d < t.children.length; d++) {
      const u = t.children[d];
      u.range && a.push(u.range.startLineNumber);
    }
    const l = this.updateIndex(vy(a, e.startLineNumber, (d, u) => d - u)), c = this.updateIndex(vy(a, e.startLineNumber + r, (d, u) => d - u));
    for (let d = l; d <= c; d++) {
      const u = t.children[d];
      if (!u)
        return;
      if (u.range) {
        const h = u.range.startLineNumber, f = u.range.endLineNumber;
        e.startLineNumber <= f + 1 && h - 1 <= e.endLineNumber && h !== o && (o = h, n.push(new Vst(h, f - 1, r + 1)), this.getCandidateStickyLinesIntersectingFromStickyModel(e, u, n, r + 1, h));
      } else
        this.getCandidateStickyLinesIntersectingFromStickyModel(e, u, n, r, s);
    }
  }
  getCandidateStickyLinesIntersecting(e) {
    var t, n;
    if (!(!((t = this._model) === null || t === void 0) && t.element))
      return [];
    let r = [];
    this.getCandidateStickyLinesIntersectingFromStickyModel(e, this._model.element, r, 0, -1);
    const s = (n = this._editor._getViewModel()) === null || n === void 0 ? void 0 : n.getHiddenAreas();
    if (s)
      for (const o of s)
        r = r.filter((a) => !(a.startLineNumber >= o.startLineNumber && a.endLineNumber <= o.endLineNumber + 1));
    return r;
  }
};
JH = Bst([
  Oee(1, tt),
  Oee(2, Un)
], JH);
var Hst = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, E1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, GT = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, $H;
let Tu = $H = class extends we {
  constructor(e, t, n, r, s, o, a) {
    super(), this._editor = e, this._contextMenuService = t, this._languageFeaturesService = n, this._instaService = r, this._contextKeyService = a, this._sessionStore = new Ne(), this._foldingModel = null, this._maxStickyLines = Number.MAX_SAFE_INTEGER, this._candidateDefinitionsLength = -1, this._focusedStickyElementIndex = -1, this._enabled = !1, this._focused = !1, this._positionRevealed = !1, this._onMouseDown = !1, this._endLineNumbers = [], this._showEndForLine = null, this._stickyScrollWidget = new Mst(this._editor), this._stickyLineCandidateProvider = new JH(this._editor, n, s), this._register(this._stickyScrollWidget), this._register(this._stickyLineCandidateProvider), this._widgetState = new Aee([], [], 0), this._readConfiguration();
    const l = this._stickyScrollWidget.getDomNode();
    this._register(this._editor.onDidChangeConfiguration((d) => {
      (d.hasChanged(
        114
        /* EditorOption.stickyScroll */
      ) || d.hasChanged(
        72
        /* EditorOption.minimap */
      ) || d.hasChanged(
        66
        /* EditorOption.lineHeight */
      ) || d.hasChanged(
        109
        /* EditorOption.showFoldingControls */
      )) && this._readConfiguration();
    })), this._register(Ie(l, Ge.CONTEXT_MENU, (d) => GT(this, void 0, void 0, function* () {
      this._onContextMenu(d);
    }))), this._stickyScrollFocusedContextKey = $.stickyScrollFocused.bindTo(this._contextKeyService), this._stickyScrollVisibleContextKey = $.stickyScrollVisible.bindTo(this._contextKeyService);
    const c = this._register(yu(l));
    this._register(c.onDidBlur((d) => {
      this._positionRevealed === !1 && l.clientHeight === 0 ? (this._focusedStickyElementIndex = -1, this.focus()) : this._disposeFocusStickyScrollStore();
    })), this._register(c.onDidFocus((d) => {
      this.focus();
    })), this._registerMouseListeners(), this._register(Ie(l, Ge.MOUSE_DOWN, (d) => {
      this._onMouseDown = !0;
    }));
  }
  static get(e) {
    return e.getContribution($H.ID);
  }
  _disposeFocusStickyScrollStore() {
    var e;
    this._stickyScrollFocusedContextKey.set(!1), (e = this._focusDisposableStore) === null || e === void 0 || e.dispose(), this._focused = !1, this._positionRevealed = !1, this._onMouseDown = !1;
  }
  focus() {
    if (this._onMouseDown) {
      this._onMouseDown = !1, this._editor.focus();
      return;
    }
    this._stickyScrollFocusedContextKey.get() !== !0 && (this._focused = !0, this._focusDisposableStore = new Ne(), this._stickyScrollFocusedContextKey.set(!0), this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumbers.length - 1, this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex));
  }
  focusNext() {
    this._focusedStickyElementIndex < this._stickyScrollWidget.lineNumberCount - 1 && this._focusNav(!0);
  }
  focusPrevious() {
    this._focusedStickyElementIndex > 0 && this._focusNav(!1);
  }
  selectEditor() {
    this._editor.focus();
  }
  // True is next, false is previous
  _focusNav(e) {
    this._focusedStickyElementIndex = e ? this._focusedStickyElementIndex + 1 : this._focusedStickyElementIndex - 1, this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
  }
  goToFocused() {
    const e = this._stickyScrollWidget.lineNumbers;
    this._disposeFocusStickyScrollStore(), this._revealPosition({ lineNumber: e[this._focusedStickyElementIndex], column: 1 });
  }
  _revealPosition(e) {
    this._reveaInEditor(e, () => this._editor.revealPosition(e));
  }
  _revealLineInCenterIfOutsideViewport(e) {
    this._reveaInEditor(e, () => this._editor.revealLineInCenterIfOutsideViewport(
      e.lineNumber,
      0
      /* ScrollType.Smooth */
    ));
  }
  _reveaInEditor(e, t) {
    this._focused && this._disposeFocusStickyScrollStore(), this._positionRevealed = !0, t(), this._editor.setSelection(V.fromPositions(e)), this._editor.focus();
  }
  _registerMouseListeners() {
    const e = this._register(new Ne()), t = this._register(new u5(this._editor, {
      extractLineNumberFromMouseEvent: (s) => {
        const o = this._stickyScrollWidget.getEditorPositionFromNode(s.target.element);
        return o ? o.lineNumber : 0;
      }
    })), n = (s) => {
      if (!this._editor.hasModel() || s.target.type !== 12 || s.target.detail !== this._stickyScrollWidget.getId())
        return null;
      const o = s.target.element;
      if (!o || o.innerText !== o.innerHTML)
        return null;
      const a = this._stickyScrollWidget.getEditorPositionFromNode(o);
      return a ? {
        range: new V(a.lineNumber, a.column, a.lineNumber, a.column + o.innerText.length),
        textElement: o
      } : null;
    }, r = this._stickyScrollWidget.getDomNode();
    this._register(ar(r, Ge.CLICK, (s) => {
      if (s.ctrlKey || s.altKey || s.metaKey || !s.leftButton)
        return;
      if (s.shiftKey) {
        const c = this._stickyScrollWidget.getLineIndexFromChildDomNode(s.target);
        if (c === null)
          return;
        const d = new ve(this._endLineNumbers[c], 1);
        this._revealLineInCenterIfOutsideViewport(d);
        return;
      }
      if (this._stickyScrollWidget.isInFoldingIconDomNode(s.target)) {
        const c = this._stickyScrollWidget.getLineNumberFromChildDomNode(s.target);
        this._toggleFoldingRegionForLine(c);
        return;
      }
      if (!this._stickyScrollWidget.isInStickyLine(s.target))
        return;
      let l = this._stickyScrollWidget.getEditorPositionFromNode(s.target);
      if (!l) {
        const c = this._stickyScrollWidget.getLineNumberFromChildDomNode(s.target);
        if (c === null)
          return;
        l = new ve(c, 1);
      }
      this._revealPosition(l);
    })), this._register(ar(r, Ge.MOUSE_MOVE, (s) => {
      if (s.shiftKey) {
        const o = this._stickyScrollWidget.getLineIndexFromChildDomNode(s.target);
        if (o === null || this._showEndForLine !== null && this._showEndForLine === o)
          return;
        this._showEndForLine = o, this._renderStickyScroll();
        return;
      }
      this._showEndForLine !== null && (this._showEndForLine = null, this._renderStickyScroll());
    })), this._register(Ie(r, Ge.MOUSE_LEAVE, (s) => {
      this._showEndForLine !== null && (this._showEndForLine = null, this._renderStickyScroll());
    })), this._register(t.onMouseMoveOrRelevantKeyDown(([s, o]) => {
      const a = n(s);
      if (!a || !s.hasTriggerModifier || !this._editor.hasModel()) {
        e.clear();
        return;
      }
      const { range: l, textElement: c } = a;
      if (!l.equalsRange(this._stickyRangeProjectedOnEditor))
        this._stickyRangeProjectedOnEditor = l, e.clear();
      else if (c.style.textDecoration === "underline")
        return;
      const d = new lr();
      e.add(Ct(() => d.dispose(!0)));
      let u;
      v5(this._languageFeaturesService.definitionProvider, this._editor.getModel(), new ve(l.startLineNumber, l.startColumn + 1), d.token).then((h) => {
        if (!d.token.isCancellationRequested)
          if (h.length !== 0) {
            this._candidateDefinitionsLength = h.length;
            const f = c;
            u !== f ? (e.clear(), u = f, u.style.textDecoration = "underline", e.add(Ct(() => {
              u.style.textDecoration = "none";
            }))) : u || (u = f, u.style.textDecoration = "underline", e.add(Ct(() => {
              u.style.textDecoration = "none";
            })));
          } else
            e.clear();
      });
    })), this._register(t.onCancel(() => {
      e.clear();
    })), this._register(t.onExecute((s) => GT(this, void 0, void 0, function* () {
      if (s.target.type !== 12 || s.target.detail !== this._stickyScrollWidget.getId())
        return;
      const o = this._stickyScrollWidget.getEditorPositionFromNode(s.target.element);
      o && (this._candidateDefinitionsLength > 1 && (this._focused && this._disposeFocusStickyScrollStore(), this._revealPosition({ lineNumber: o.lineNumber, column: 1 })), this._instaService.invokeFunction(Q1e, s, this._editor, { uri: this._editor.getModel().uri, range: this._stickyRangeProjectedOnEditor }));
    })));
  }
  _onContextMenu(e) {
    const t = new cl(e);
    this._contextMenuService.showContextMenu({
      menuId: J.StickyScrollContext,
      getAnchor: () => t
    });
  }
  _toggleFoldingRegionForLine(e) {
    if (!this._foldingModel || e === null)
      return;
    const t = this._stickyScrollWidget.getStickyLineForLine(e), n = t?.foldingIcon;
    if (!n)
      return;
    M1e(this._foldingModel, Number.MAX_VALUE, [e]), n.isCollapsed = !n.isCollapsed;
    const r = (n.isCollapsed ? this._editor.getTopForLineNumber(n.foldingEndLine) : this._editor.getTopForLineNumber(n.foldingStartLine)) - this._editor.getOption(
      66
      /* EditorOption.lineHeight */
    ) * t.index + 1;
    this._editor.setScrollTop(r), this._renderStickyScroll(e);
  }
  _readConfiguration() {
    const e = this._editor.getOption(
      114
      /* EditorOption.stickyScroll */
    );
    if (e.enabled === !1) {
      this._editor.removeOverlayWidget(this._stickyScrollWidget), this._sessionStore.clear(), this._enabled = !1;
      return;
    } else e.enabled && !this._enabled && (this._editor.addOverlayWidget(this._stickyScrollWidget), this._sessionStore.add(this._editor.onDidScrollChange((n) => {
      n.scrollTopChanged && (this._showEndForLine = null, this._renderStickyScroll());
    })), this._sessionStore.add(this._editor.onDidLayoutChange(() => this._onDidResize())), this._sessionStore.add(this._editor.onDidChangeModelTokens((n) => this._onTokensChange(n))), this._sessionStore.add(this._stickyLineCandidateProvider.onDidChangeStickyScroll(() => {
      this._showEndForLine = null, this._renderStickyScroll();
    })), this._enabled = !0);
    this._editor.getOption(
      67
      /* EditorOption.lineNumbers */
    ).renderType === 2 && this._sessionStore.add(this._editor.onDidChangeCursorPosition(() => {
      this._showEndForLine = null, this._renderStickyScroll();
    }));
  }
  _needsUpdate(e) {
    const t = this._stickyScrollWidget.getCurrentLines();
    for (const n of t)
      for (const r of e.ranges)
        if (n >= r.fromLineNumber && n <= r.toLineNumber)
          return !0;
    return !1;
  }
  _onTokensChange(e) {
    this._needsUpdate(e) && this._renderStickyScroll(-1);
  }
  _onDidResize() {
    const t = this._editor.getLayoutInfo().height / this._editor.getOption(
      66
      /* EditorOption.lineHeight */
    );
    this._maxStickyLines = Math.round(t * 0.25);
  }
  _renderStickyScroll(e = 1 / 0) {
    var t, n;
    return GT(this, void 0, void 0, function* () {
      const r = this._editor.getModel();
      if (!r || r.isTooLargeForTokenization()) {
        this._foldingModel = null, this._stickyScrollWidget.setState(void 0, null, e);
        return;
      }
      const s = this._stickyLineCandidateProvider.getVersionId();
      if (s === void 0 || s === r.getVersionId())
        if (this._foldingModel = (n = yield (t = ku.get(this._editor)) === null || t === void 0 ? void 0 : t.getFoldingModel()) !== null && n !== void 0 ? n : null, this._widgetState = this.findScrollWidgetState(), this._stickyScrollVisibleContextKey.set(this._widgetState.startLineNumbers.length !== 0), !this._focused)
          this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, e);
        else if (this._focusedStickyElementIndex === -1)
          this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, e), this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumberCount - 1, this._focusedStickyElementIndex !== -1 && this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
        else {
          const o = this._stickyScrollWidget.lineNumbers[this._focusedStickyElementIndex];
          this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, e), this._stickyScrollWidget.lineNumberCount === 0 ? this._focusedStickyElementIndex = -1 : (this._stickyScrollWidget.lineNumbers.includes(o) || (this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumberCount - 1), this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex));
        }
    });
  }
  findScrollWidgetState() {
    const e = this._editor.getOption(
      66
      /* EditorOption.lineHeight */
    ), t = Math.min(this._maxStickyLines, this._editor.getOption(
      114
      /* EditorOption.stickyScroll */
    ).maxLineCount), n = this._editor.getScrollTop();
    let r = 0;
    const s = [], o = [], a = this._editor.getVisibleRanges();
    if (a.length !== 0) {
      const l = new ZC(a[0].startLineNumber, a[a.length - 1].endLineNumber), c = this._stickyLineCandidateProvider.getCandidateStickyLinesIntersecting(l);
      for (const d of c) {
        const u = d.startLineNumber, h = d.endLineNumber, f = d.nestingDepth;
        if (h - u > 0) {
          const g = (f - 1) * e, p = f * e, m = this._editor.getBottomForLineNumber(u) - n, _ = this._editor.getTopForLineNumber(h) - n, b = this._editor.getBottomForLineNumber(h) - n;
          if (g > _ && g <= b) {
            s.push(u), o.push(h + 1), r = b - p;
            break;
          } else p > m && p <= b && (s.push(u), o.push(h + 1));
          if (s.length === t)
            break;
        }
      }
    }
    return this._endLineNumbers = o, new Aee(s, o, r, this._showEndForLine);
  }
  dispose() {
    super.dispose(), this._sessionStore.dispose();
  }
};
Tu.ID = "store.contrib.stickyScrollController";
Tu = $H = Hst([
  E1(1, gc),
  E1(2, tt),
  E1(3, bt),
  E1(4, Un),
  E1(5, kl),
  E1(6, yt)
], Tu);
var Wst = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
class jst extends Ga {
  constructor() {
    super({
      id: "editor.action.toggleStickyScroll",
      title: {
        value: C("toggleStickyScroll", "Toggle Sticky Scroll"),
        mnemonicTitle: C({ key: "mitoggleStickyScroll", comment: ["&& denotes a mnemonic"] }, "&&Toggle Sticky Scroll"),
        original: "Toggle Sticky Scroll"
      },
      category: Nst.View,
      toggled: {
        condition: ke.equals("config.editor.stickyScroll.enabled", !0),
        title: C("stickyScroll", "Sticky Scroll"),
        mnemonicTitle: C({ key: "miStickyScroll", comment: ["&& denotes a mnemonic"] }, "&&Sticky Scroll")
      },
      menu: [
        { id: J.CommandPalette },
        { id: J.MenubarAppearanceMenu, group: "4_editor", order: 3 },
        { id: J.StickyScrollContext }
      ]
    });
  }
  run(e) {
    return Wst(this, void 0, void 0, function* () {
      const t = e.get(en), n = !t.getValue("editor.stickyScroll.enabled");
      return t.updateValue("editor.stickyScroll.enabled", n);
    });
  }
}
const X5 = 100;
class zst extends vd {
  constructor() {
    super({
      id: "editor.action.focusStickyScroll",
      title: {
        value: C("focusStickyScroll", "Focus Sticky Scroll"),
        mnemonicTitle: C({ key: "mifocusStickyScroll", comment: ["&& denotes a mnemonic"] }, "&&Focus Sticky Scroll"),
        original: "Focus Sticky Scroll"
      },
      precondition: ke.and(ke.has("config.editor.stickyScroll.enabled"), $.stickyScrollVisible),
      menu: [
        { id: J.CommandPalette }
      ]
    });
  }
  runEditorCommand(e, t) {
    var n;
    (n = Tu.get(t)) === null || n === void 0 || n.focus();
  }
}
class Ust extends vd {
  constructor() {
    super({
      id: "editor.action.selectNextStickyScrollLine",
      title: {
        value: C("selectNextStickyScrollLine.title", "Select next sticky scroll line"),
        original: "Select next sticky scroll line"
      },
      precondition: $.stickyScrollFocused.isEqualTo(!0),
      keybinding: {
        weight: X5,
        primary: 18
        /* KeyCode.DownArrow */
      }
    });
  }
  runEditorCommand(e, t) {
    var n;
    (n = Tu.get(t)) === null || n === void 0 || n.focusNext();
  }
}
class Gst extends vd {
  constructor() {
    super({
      id: "editor.action.selectPreviousStickyScrollLine",
      title: {
        value: C("selectPreviousStickyScrollLine.title", "Select previous sticky scroll line"),
        original: "Select previous sticky scroll line"
      },
      precondition: $.stickyScrollFocused.isEqualTo(!0),
      keybinding: {
        weight: X5,
        primary: 16
        /* KeyCode.UpArrow */
      }
    });
  }
  runEditorCommand(e, t) {
    var n;
    (n = Tu.get(t)) === null || n === void 0 || n.focusPrevious();
  }
}
class qst extends vd {
  constructor() {
    super({
      id: "editor.action.goToFocusedStickyScrollLine",
      title: {
        value: C("goToFocusedStickyScrollLine.title", "Go to focused sticky scroll line"),
        original: "Go to focused sticky scroll line"
      },
      precondition: $.stickyScrollFocused.isEqualTo(!0),
      keybinding: {
        weight: X5,
        primary: 3
        /* KeyCode.Enter */
      }
    });
  }
  runEditorCommand(e, t) {
    var n;
    (n = Tu.get(t)) === null || n === void 0 || n.goToFocused();
  }
}
class Kst extends vd {
  constructor() {
    super({
      id: "editor.action.selectEditor",
      title: {
        value: C("selectEditor.title", "Select Editor"),
        original: "Select Editor"
      },
      precondition: $.stickyScrollFocused.isEqualTo(!0),
      keybinding: {
        weight: X5,
        primary: 9
        /* KeyCode.Escape */
      }
    });
  }
  runEditorCommand(e, t) {
    var n;
    (n = Tu.get(t)) === null || n === void 0 || n.selectEditor();
  }
}
pn(
  Tu.ID,
  Tu,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
oi(jst);
oi(zst);
oi(Gst);
oi(Ust);
oi(qst);
oi(Kst);
var WG = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Mm = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Yst = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, Up;
class Xst {
  constructor(e, t, n, r, s, o) {
    this.range = e, this.insertText = t, this.filterText = n, this.additionalTextEdits = r, this.command = s, this.completion = o;
  }
}
let eW = class extends kTe {
  constructor(e, t, n, r, s, o) {
    super(s.disposable), this.model = e, this.line = t, this.word = n, this.completionModel = r, this._suggestMemoryService = o;
  }
  canBeReused(e, t, n) {
    return this.model === e && this.line === t && this.word.word.length > 0 && this.word.startColumn === n.startColumn && this.word.endColumn < n.endColumn && this.completionModel.getIncompleteProvider().size === 0;
  }
  get items() {
    var e;
    const t = [], { items: n } = this.completionModel, r = this._suggestMemoryService.select(this.model, { lineNumber: this.line, column: this.word.endColumn + this.completionModel.lineContext.characterCountDelta }, n), s = Wt.slice(n, r), o = Wt.slice(n, 0, r);
    let a = 5;
    for (const l of Wt.concat(s, o)) {
      if (l.score === td.Default)
        continue;
      const c = new V(
        l.editStart.lineNumber,
        l.editStart.column,
        l.editInsertEnd.lineNumber,
        l.editInsertEnd.column + this.completionModel.lineContext.characterCountDelta
        // end PLUS character delta
      ), d = l.completion.insertTextRules && l.completion.insertTextRules & 4 ? { snippet: l.completion.insertText } : l.completion.insertText;
      t.push(new Xst(c, d, (e = l.filterTextLow) !== null && e !== void 0 ? e : l.labelLow, l.completion.additionalTextEdits, l.completion.command, l)), a-- >= 0 && l.resolve(jt.None);
    }
    return t;
  }
};
eW = WG([
  Mm(5, T5)
], eW);
let tW = class {
  constructor(e, t, n, r) {
    this._getEditorOption = e, this._languageFeatureService = t, this._clipboardService = n, this._suggestMemoryService = r;
  }
  provideInlineCompletions(e, t, n, r) {
    var s;
    return Yst(this, void 0, void 0, function* () {
      if (n.selectedSuggestionInfo)
        return;
      const o = this._getEditorOption(88, e);
      if (mv.isAllOff(o))
        return;
      e.tokenization.tokenizeIfCheap(t.lineNumber);
      const a = e.tokenization.getLineTokens(t.lineNumber), l = a.getStandardTokenType(a.findTokenIndexAtOffset(Math.max(t.column - 1 - 1, 0)));
      if (mv.valueFor(o, l) !== "inline")
        return;
      let c = e.getWordAtPosition(t), d;
      if (c?.word || (d = this._getTriggerCharacterInfo(e, t)), !c?.word && !d || (c || (c = e.getWordUntilPosition(t)), c.endColumn !== t.column))
        return;
      let u;
      const h = e.getValueInRange(new V(t.lineNumber, 1, t.lineNumber, t.column));
      if (!d && (!((s = this._lastResult) === null || s === void 0) && s.canBeReused(e, t.lineNumber, c))) {
        const f = new See(h, t.column - this._lastResult.word.endColumn);
        this._lastResult.completionModel.lineContext = f, this._lastResult.acquire(), u = this._lastResult;
      } else {
        const f = yield LG(this._languageFeatureService.completionProvider, e, t, new Ow(void 0, void 0, d?.providers), d && { triggerKind: 1, triggerCharacter: d.ch }, r);
        let g;
        f.needsClipboard && (g = yield this._clipboardService.readText());
        const p = new jf(f.items, t.column, new See(h, 0), Bc.None, this._getEditorOption(117, e), this._getEditorOption(111, e), { boostFullMatch: !1, firstMatchCanBeWeak: !1 }, g);
        u = new eW(e, t.lineNumber, c, p, f, this._suggestMemoryService);
      }
      return this._lastResult = u, u;
    });
  }
  handleItemDidShow(e, t) {
    t.completion.resolve(jt.None);
  }
  freeInlineCompletions(e) {
    e.release();
  }
  _getTriggerCharacterInfo(e, t) {
    var n;
    const r = e.getValueInRange(V.fromPositions({ lineNumber: t.lineNumber, column: t.column - 1 }, t)), s = /* @__PURE__ */ new Set();
    for (const o of this._languageFeatureService.completionProvider.all(e))
      !((n = o.triggerCharacters) === null || n === void 0) && n.includes(r) && s.add(o);
    if (s.size !== 0)
      return { providers: s, ch: r };
  }
};
tW = WG([
  Mm(1, tt),
  Mm(2, hf),
  Mm(3, T5)
], tW);
let BI = Up = class {
  constructor(e, t, n, r) {
    if (++Up._counter === 1) {
      const s = r.createInstance(tW, (o, a) => {
        var l;
        return ((l = n.listCodeEditors().find((d) => d.getModel() === a)) !== null && l !== void 0 ? l : e).getOption(o);
      });
      Up._disposable = t.inlineCompletionsProvider.register("*", s);
    }
  }
  dispose() {
    var e;
    --Up._counter === 0 && ((e = Up._disposable) === null || e === void 0 || e.dispose(), Up._disposable = void 0);
  }
};
BI._counter = 0;
BI = Up = WG([
  Mm(1, tt),
  Mm(2, Sn),
  Mm(3, bt)
], BI);
pn(
  "suggest.inlineCompletionsProvider",
  BI,
  0
  /* EditorContributionInstantiation.Eager */
);
class Zst extends Je {
  constructor() {
    super({
      id: "editor.action.forceRetokenize",
      label: C("forceRetokenize", "Developer: Force Retokenize"),
      alias: "Developer: Force Retokenize",
      precondition: void 0
    });
  }
  run(e, t) {
    if (!t.hasModel())
      return;
    const n = t.getModel();
    n.tokenization.resetTokenization();
    const r = new Vs();
    n.tokenization.forceTokenization(n.getLineCount()), r.stop(), console.log(`tokenization took ${r.elapsed()}`);
  }
}
Be(Zst);
class Z5 extends Ga {
  constructor() {
    super({
      id: Z5.ID,
      title: { value: C({ key: "toggle.tabMovesFocus", comment: ["Turn on/off use of tab key for moving focus around VS Code"] }, "Toggle Tab Key Moves Focus"), original: "Toggle Tab Key Moves Focus" },
      precondition: void 0,
      keybinding: {
        primary: 2091,
        mac: {
          primary: 1323
          /* KeyCode.KeyM */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      f1: !0
    });
  }
  run() {
    const t = !b_.getTabFocusMode();
    b_.setTabFocusMode(t), Fs(t ? C("toggle.tabMovesFocus.on", "Pressing Tab will now move focus to the next focusable element") : C("toggle.tabMovesFocus.off", "Pressing Tab will now insert the tab character"));
  }
}
Z5.ID = "editor.action.toggleTabFocusMode";
oi(Z5);
var Qst = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Jst = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let nW = class extends we {
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    e ? (this.el.setAttribute("aria-disabled", "false"), this.el.tabIndex = 0, this.el.style.pointerEvents = "auto", this.el.style.opacity = "1", this.el.style.cursor = "pointer", this._enabled = !1) : (this.el.setAttribute("aria-disabled", "true"), this.el.tabIndex = -1, this.el.style.pointerEvents = "none", this.el.style.opacity = "0.4", this.el.style.cursor = "default", this._enabled = !0), this._enabled = e;
  }
  constructor(e, t, n = {}, r) {
    var s;
    super(), this._link = t, this._enabled = !0, this.el = Te(e, Re("a.monaco-link", {
      tabIndex: (s = t.tabIndex) !== null && s !== void 0 ? s : 0,
      href: t.href,
      title: t.title
    }, t.label)), this.el.setAttribute("role", "button");
    const o = this._register(new Yt(this.el, "click")), a = this._register(new Yt(this.el, "keypress")), l = qe.chain(a.event, (u) => u.map((h) => new Xn(h)).filter(
      (h) => h.keyCode === 3
      /* KeyCode.Enter */
    )), c = this._register(new Yt(this.el, Wn.Tap)).event;
    this._register(Vn.addTarget(this.el));
    const d = qe.any(o.event, l, c);
    this._register(d((u) => {
      this.enabled && (Tt.stop(u, !0), n?.opener ? n.opener(this._link.href) : r.open(this._link.href, { allowCommands: !0 }));
    })), this.enabled = !0;
  }
};
nW = Qst([
  Jst(3, da)
], nW);
var Sve = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, xve = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const $st = 26;
let iW = class extends we {
  constructor(e, t) {
    super(), this._editor = e, this.instantiationService = t, this.banner = this._register(this.instantiationService.createInstance(rW));
  }
  hide() {
    this._editor.setBanner(null, 0), this.banner.clear();
  }
  show(e) {
    this.banner.show(Object.assign(Object.assign({}, e), { onClose: () => {
      var t;
      this.hide(), (t = e.onClose) === null || t === void 0 || t.call(e);
    } })), this._editor.setBanner(this.banner.element, $st);
  }
};
iW = Sve([
  xve(1, bt)
], iW);
let rW = class extends we {
  constructor(e) {
    super(), this.instantiationService = e, this.markdownRenderer = this.instantiationService.createInstance($h, {}), this.element = Re("div.editor-banner"), this.element.tabIndex = 0;
  }
  getAriaLabel(e) {
    if (e.ariaLabel)
      return e.ariaLabel;
    if (typeof e.message == "string")
      return e.message;
  }
  getBannerMessage(e) {
    if (typeof e == "string") {
      const t = Re("span");
      return t.innerText = e, t;
    }
    return this.markdownRenderer.render(e).element;
  }
  clear() {
    ls(this.element);
  }
  show(e) {
    ls(this.element);
    const t = this.getAriaLabel(e);
    t && this.element.setAttribute("aria-label", t);
    const n = Te(this.element, Re("div.icon-container"));
    n.setAttribute("aria-hidden", "true"), e.icon && n.appendChild(Re(`div${ft.asCSSSelector(e.icon)}`));
    const r = Te(this.element, Re("div.message-container"));
    if (r.setAttribute("aria-hidden", "true"), r.appendChild(this.getBannerMessage(e.message)), this.messageActionsContainer = Te(this.element, Re("div.message-actions-container")), e.actions)
      for (const o of e.actions)
        this._register(this.instantiationService.createInstance(nW, this.messageActionsContainer, Object.assign(Object.assign({}, o), { tabIndex: -1 }), {}));
    const s = Te(this.element, Re("div.action-container"));
    this.actionBar = this._register(new Dl(s)), this.actionBar.push(this._register(new vo("banner.close", "Close Banner", ft.asClassName(nme), !0, () => {
      typeof e.onClose == "function" && e.onClose();
    })), { icon: !0, label: !1 }), this.actionBar.setFocusable(!1);
  }
};
rW = Sve([
  xve(0, bt)
], rW);
var jG = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Zv = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Ps = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const eot = $i("extensions-warning-message", We.warning, C("warningIcon", "Icon shown with a warning message in the extensions editor."));
let Z_ = class extends we {
  constructor(e, t, n, r) {
    super(), this._editor = e, this._editorWorkerService = t, this._workspaceTrustService = n, this._highlighter = null, this._bannerClosed = !1, this._updateState = (s) => {
      if (s && s.hasMore) {
        if (this._bannerClosed)
          return;
        const o = Math.max(s.ambiguousCharacterCount, s.nonBasicAsciiCharacterCount, s.invisibleCharacterCount);
        let a;
        if (s.nonBasicAsciiCharacterCount >= o)
          a = {
            message: C("unicodeHighlighting.thisDocumentHasManyNonBasicAsciiUnicodeCharacters", "This document contains many non-basic ASCII unicode characters"),
            command: new Nb()
          };
        else if (s.ambiguousCharacterCount >= o)
          a = {
            message: C("unicodeHighlighting.thisDocumentHasManyAmbiguousUnicodeCharacters", "This document contains many ambiguous unicode characters"),
            command: new mp()
          };
        else if (s.invisibleCharacterCount >= o)
          a = {
            message: C("unicodeHighlighting.thisDocumentHasManyInvisibleUnicodeCharacters", "This document contains many invisible unicode characters"),
            command: new Tb()
          };
        else
          throw new Error("Unreachable");
        this._bannerController.show({
          id: "unicodeHighlightBanner",
          message: a.message,
          icon: eot,
          actions: [
            {
              label: a.command.shortLabel,
              href: `command:${a.command.id}`
            }
          ],
          onClose: () => {
            this._bannerClosed = !0;
          }
        });
      } else
        this._bannerController.hide();
    }, this._bannerController = this._register(r.createInstance(iW, e)), this._register(this._editor.onDidChangeModel(() => {
      this._bannerClosed = !1, this._updateHighlighter();
    })), this._options = e.getOption(
      124
      /* EditorOption.unicodeHighlighting */
    ), this._register(n.onDidChangeTrust((s) => {
      this._updateHighlighter();
    })), this._register(e.onDidChangeConfiguration((s) => {
      s.hasChanged(
        124
        /* EditorOption.unicodeHighlighting */
      ) && (this._options = e.getOption(
        124
        /* EditorOption.unicodeHighlighting */
      ), this._updateHighlighter());
    })), this._updateHighlighter();
  }
  dispose() {
    this._highlighter && (this._highlighter.dispose(), this._highlighter = null), super.dispose();
  }
  _updateHighlighter() {
    if (this._updateState(null), this._highlighter && (this._highlighter.dispose(), this._highlighter = null), !this._editor.hasModel())
      return;
    const e = tot(this._workspaceTrustService.isWorkspaceTrusted(), this._options);
    if ([
      e.nonBasicASCII,
      e.ambiguousCharacters,
      e.invisibleCharacters
    ].every((n) => n === !1))
      return;
    const t = {
      nonBasicASCII: e.nonBasicASCII,
      ambiguousCharacters: e.ambiguousCharacters,
      invisibleCharacters: e.invisibleCharacters,
      includeComments: e.includeComments,
      includeStrings: e.includeStrings,
      allowedCodePoints: Object.keys(e.allowedCharacters).map((n) => n.codePointAt(0)),
      allowedLocales: Object.keys(e.allowedLocales).map((n) => n === "_os" ? new Intl.NumberFormat().resolvedOptions().locale : n === "_vscode" ? N6e : n)
    };
    this._editorWorkerService.canComputeUnicodeHighlights(this._editor.getModel().uri) ? this._highlighter = new sW(this._editor, t, this._updateState, this._editorWorkerService) : this._highlighter = new not(this._editor, t, this._updateState);
  }
  getDecorationInfo(e) {
    return this._highlighter ? this._highlighter.getDecorationInfo(e) : null;
  }
};
Z_.ID = "editor.contrib.unicodeHighlighter";
Z_ = jG([
  Zv(1, vc),
  Zv(2, Jge),
  Zv(3, bt)
], Z_);
function tot(i, e) {
  return {
    nonBasicASCII: e.nonBasicASCII === Ca ? !i : e.nonBasicASCII,
    ambiguousCharacters: e.ambiguousCharacters,
    invisibleCharacters: e.invisibleCharacters,
    includeComments: e.includeComments === Ca ? !i : e.includeComments,
    includeStrings: e.includeStrings === Ca ? !i : e.includeStrings,
    allowedCharacters: e.allowedCharacters,
    allowedLocales: e.allowedLocales
  };
}
let sW = class extends we {
  constructor(e, t, n, r) {
    super(), this._editor = e, this._options = t, this._updateState = n, this._editorWorkerService = r, this._model = this._editor.getModel(), this._decorations = this._editor.createDecorationsCollection(), this._updateSoon = this._register(new Rn(() => this._update(), 250)), this._register(this._editor.onDidChangeModelContent(() => {
      this._updateSoon.schedule();
    })), this._updateSoon.schedule();
  }
  dispose() {
    this._decorations.clear(), super.dispose();
  }
  _update() {
    if (this._model.isDisposed())
      return;
    if (!this._model.mightContainNonBasicASCII()) {
      this._decorations.clear();
      return;
    }
    const e = this._model.getVersionId();
    this._editorWorkerService.computedUnicodeHighlights(this._model.uri, this._options).then((t) => {
      if (this._model.isDisposed() || this._model.getVersionId() !== e)
        return;
      this._updateState(t);
      const n = [];
      if (!t.hasMore)
        for (const r of t.ranges)
          n.push({
            range: r,
            options: VI.instance.getDecorationFromOptions(this._options)
          });
      this._decorations.set(n);
    });
  }
  getDecorationInfo(e) {
    if (!this._decorations.has(e))
      return null;
    const t = this._editor.getModel();
    if (!Hz(t, e))
      return null;
    const n = t.getValueInRange(e.range);
    return {
      reason: Dve(n, this._options),
      inComment: Wz(t, e),
      inString: jz(t, e)
    };
  }
};
sW = jG([
  Zv(3, vc)
], sW);
class not extends we {
  constructor(e, t, n) {
    super(), this._editor = e, this._options = t, this._updateState = n, this._model = this._editor.getModel(), this._decorations = this._editor.createDecorationsCollection(), this._updateSoon = this._register(new Rn(() => this._update(), 250)), this._register(this._editor.onDidLayoutChange(() => {
      this._updateSoon.schedule();
    })), this._register(this._editor.onDidScrollChange(() => {
      this._updateSoon.schedule();
    })), this._register(this._editor.onDidChangeHiddenAreas(() => {
      this._updateSoon.schedule();
    })), this._register(this._editor.onDidChangeModelContent(() => {
      this._updateSoon.schedule();
    })), this._updateSoon.schedule();
  }
  dispose() {
    this._decorations.clear(), super.dispose();
  }
  _update() {
    if (this._model.isDisposed())
      return;
    if (!this._model.mightContainNonBasicASCII()) {
      this._decorations.clear();
      return;
    }
    const e = this._editor.getVisibleRanges(), t = [], n = {
      ranges: [],
      ambiguousCharacterCount: 0,
      invisibleCharacterCount: 0,
      nonBasicAsciiCharacterCount: 0,
      hasMore: !1
    };
    for (const r of e) {
      const s = ez.computeUnicodeHighlights(this._model, this._options, r);
      for (const o of s.ranges)
        n.ranges.push(o);
      n.ambiguousCharacterCount += n.ambiguousCharacterCount, n.invisibleCharacterCount += n.invisibleCharacterCount, n.nonBasicAsciiCharacterCount += n.nonBasicAsciiCharacterCount, n.hasMore = n.hasMore || s.hasMore;
    }
    if (!n.hasMore)
      for (const r of n.ranges)
        t.push({ range: r, options: VI.instance.getDecorationFromOptions(this._options) });
    this._updateState(n), this._decorations.set(t);
  }
  getDecorationInfo(e) {
    if (!this._decorations.has(e))
      return null;
    const t = this._editor.getModel(), n = t.getValueInRange(e.range);
    return Hz(t, e) ? {
      reason: Dve(n, this._options),
      inComment: Wz(t, e),
      inString: jz(t, e)
    } : null;
  }
}
let oW = class {
  constructor(e, t, n) {
    this._editor = e, this._languageService = t, this._openerService = n, this.hoverOrdinal = 5;
  }
  computeSync(e, t) {
    if (!this._editor.hasModel() || e.type !== 1)
      return [];
    const n = this._editor.getModel(), r = this._editor.getContribution(Z_.ID);
    if (!r)
      return [];
    const s = [], o = /* @__PURE__ */ new Set();
    let a = 300;
    for (const l of t) {
      const c = r.getDecorationInfo(l);
      if (!c)
        continue;
      const u = n.getValueInRange(l.range).codePointAt(0), h = qT(u);
      let f;
      switch (c.reason.kind) {
        case 0: {
          yS(c.reason.confusableWith) ? f = C("unicodeHighlight.characterIsAmbiguousASCII", "The character {0} could be confused with the ASCII character {1}, which is more common in source code.", h, qT(c.reason.confusableWith.codePointAt(0))) : f = C("unicodeHighlight.characterIsAmbiguous", "The character {0} could be confused with the character {1}, which is more common in source code.", h, qT(c.reason.confusableWith.codePointAt(0)));
          break;
        }
        case 1:
          f = C("unicodeHighlight.characterIsInvisible", "The character {0} is invisible.", h);
          break;
        case 2:
          f = C("unicodeHighlight.characterIsNonBasicAscii", "The character {0} is not a basic ASCII character.", h);
          break;
      }
      if (o.has(f))
        continue;
      o.add(f);
      const g = {
        codePoint: u,
        reason: c.reason,
        inComment: c.inComment,
        inString: c.inString
      }, p = C("unicodeHighlight.adjustSettings", "Adjust settings"), m = `command:${rx.ID}?${encodeURIComponent(JSON.stringify(g))}`, _ = new ys("", !0).appendMarkdown(f).appendText(" ").appendLink(m, p);
      s.push(new Wc(this, l.range, [_], !1, a++));
    }
    return s;
  }
  renderHoverParts(e, t) {
    return e1e(e, t, this._editor, this._languageService, this._openerService);
  }
};
oW = jG([
  Zv(1, ci),
  Zv(2, da)
], oW);
function aW(i) {
  return `U+${i.toString(16).padStart(4, "0")}`;
}
function qT(i) {
  let e = `\`${aW(i)}\``;
  return cu.isInvisibleCharacter(i) || (e += ` "${`${iot(i)}`}"`), e;
}
function iot(i) {
  return i === 96 ? "`` ` ``" : "`" + String.fromCodePoint(i) + "`";
}
function Dve(i, e) {
  return ez.computeUnicodeHighlightReason(i, e);
}
class VI {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  getDecorationFromOptions(e) {
    return this.getDecoration(!e.includeComments, !e.includeStrings);
  }
  getDecoration(e, t) {
    const n = `${e}${t}`;
    let r = this.map.get(n);
    return r || (r = Lt.createDynamic({
      description: "unicode-highlight",
      stickiness: 1,
      className: "unicode-highlight",
      showIfCollapsed: !0,
      overviewRuler: null,
      minimap: null,
      hideInCommentTokens: e,
      hideInStringTokens: t
    }), this.map.set(n, r)), r;
  }
}
VI.instance = new VI();
class rot extends Je {
  constructor() {
    super({
      id: mp.ID,
      label: C("action.unicodeHighlight.disableHighlightingInComments", "Disable highlighting of characters in comments"),
      alias: "Disable highlighting of characters in comments",
      precondition: void 0
    }), this.shortLabel = C("unicodeHighlight.disableHighlightingInComments.shortLabel", "Disable Highlight In Comments");
  }
  run(e, t, n) {
    return Ps(this, void 0, void 0, function* () {
      const r = e?.get(en);
      r && this.runAction(r);
    });
  }
  runAction(e) {
    return Ps(this, void 0, void 0, function* () {
      yield e.updateValue(
        To.includeComments,
        !1,
        2
        /* ConfigurationTarget.USER */
      );
    });
  }
}
class sot extends Je {
  constructor() {
    super({
      id: mp.ID,
      label: C("action.unicodeHighlight.disableHighlightingInStrings", "Disable highlighting of characters in strings"),
      alias: "Disable highlighting of characters in strings",
      precondition: void 0
    }), this.shortLabel = C("unicodeHighlight.disableHighlightingInStrings.shortLabel", "Disable Highlight In Strings");
  }
  run(e, t, n) {
    return Ps(this, void 0, void 0, function* () {
      const r = e?.get(en);
      r && this.runAction(r);
    });
  }
  runAction(e) {
    return Ps(this, void 0, void 0, function* () {
      yield e.updateValue(
        To.includeStrings,
        !1,
        2
        /* ConfigurationTarget.USER */
      );
    });
  }
}
class mp extends Je {
  constructor() {
    super({
      id: mp.ID,
      label: C("action.unicodeHighlight.disableHighlightingOfAmbiguousCharacters", "Disable highlighting of ambiguous characters"),
      alias: "Disable highlighting of ambiguous characters",
      precondition: void 0
    }), this.shortLabel = C("unicodeHighlight.disableHighlightingOfAmbiguousCharacters.shortLabel", "Disable Ambiguous Highlight");
  }
  run(e, t, n) {
    return Ps(this, void 0, void 0, function* () {
      const r = e?.get(en);
      r && this.runAction(r);
    });
  }
  runAction(e) {
    return Ps(this, void 0, void 0, function* () {
      yield e.updateValue(
        To.ambiguousCharacters,
        !1,
        2
        /* ConfigurationTarget.USER */
      );
    });
  }
}
mp.ID = "editor.action.unicodeHighlight.disableHighlightingOfAmbiguousCharacters";
class Tb extends Je {
  constructor() {
    super({
      id: Tb.ID,
      label: C("action.unicodeHighlight.disableHighlightingOfInvisibleCharacters", "Disable highlighting of invisible characters"),
      alias: "Disable highlighting of invisible characters",
      precondition: void 0
    }), this.shortLabel = C("unicodeHighlight.disableHighlightingOfInvisibleCharacters.shortLabel", "Disable Invisible Highlight");
  }
  run(e, t, n) {
    return Ps(this, void 0, void 0, function* () {
      const r = e?.get(en);
      r && this.runAction(r);
    });
  }
  runAction(e) {
    return Ps(this, void 0, void 0, function* () {
      yield e.updateValue(
        To.invisibleCharacters,
        !1,
        2
        /* ConfigurationTarget.USER */
      );
    });
  }
}
Tb.ID = "editor.action.unicodeHighlight.disableHighlightingOfInvisibleCharacters";
class Nb extends Je {
  constructor() {
    super({
      id: Nb.ID,
      label: C("action.unicodeHighlight.disableHighlightingOfNonBasicAsciiCharacters", "Disable highlighting of non basic ASCII characters"),
      alias: "Disable highlighting of non basic ASCII characters",
      precondition: void 0
    }), this.shortLabel = C("unicodeHighlight.disableHighlightingOfNonBasicAsciiCharacters.shortLabel", "Disable Non ASCII Highlight");
  }
  run(e, t, n) {
    return Ps(this, void 0, void 0, function* () {
      const r = e?.get(en);
      r && this.runAction(r);
    });
  }
  runAction(e) {
    return Ps(this, void 0, void 0, function* () {
      yield e.updateValue(
        To.nonBasicASCII,
        !1,
        2
        /* ConfigurationTarget.USER */
      );
    });
  }
}
Nb.ID = "editor.action.unicodeHighlight.disableHighlightingOfNonBasicAsciiCharacters";
class rx extends Je {
  constructor() {
    super({
      id: rx.ID,
      label: C("action.unicodeHighlight.showExcludeOptions", "Show Exclude Options"),
      alias: "Show Exclude Options",
      precondition: void 0
    });
  }
  run(e, t, n) {
    return Ps(this, void 0, void 0, function* () {
      const { codePoint: r, reason: s, inString: o, inComment: a } = n, l = String.fromCodePoint(r), c = e.get(bd), d = e.get(en);
      function u(g) {
        return cu.isInvisibleCharacter(g) ? C("unicodeHighlight.excludeInvisibleCharFromBeingHighlighted", "Exclude {0} (invisible character) from being highlighted", aW(g)) : C("unicodeHighlight.excludeCharFromBeingHighlighted", "Exclude {0} from being highlighted", `${aW(g)} "${l}"`);
      }
      const h = [];
      if (s.kind === 0)
        for (const g of s.notAmbiguousInLocales)
          h.push({
            label: C("unicodeHighlight.allowCommonCharactersInLanguage", 'Allow unicode characters that are more common in the language "{0}".', g),
            run: () => Ps(this, void 0, void 0, function* () {
              aot(d, [g]);
            })
          });
      if (h.push({
        label: u(r),
        run: () => oot(d, [r])
      }), a) {
        const g = new rot();
        h.push({ label: g.label, run: () => Ps(this, void 0, void 0, function* () {
          return g.runAction(d);
        }) });
      } else if (o) {
        const g = new sot();
        h.push({ label: g.label, run: () => Ps(this, void 0, void 0, function* () {
          return g.runAction(d);
        }) });
      }
      if (s.kind === 0) {
        const g = new mp();
        h.push({ label: g.label, run: () => Ps(this, void 0, void 0, function* () {
          return g.runAction(d);
        }) });
      } else if (s.kind === 1) {
        const g = new Tb();
        h.push({ label: g.label, run: () => Ps(this, void 0, void 0, function* () {
          return g.runAction(d);
        }) });
      } else if (s.kind === 2) {
        const g = new Nb();
        h.push({ label: g.label, run: () => Ps(this, void 0, void 0, function* () {
          return g.runAction(d);
        }) });
      } else
        lot(s);
      const f = yield c.pick(h, { title: C("unicodeHighlight.configureUnicodeHighlightOptions", "Configure Unicode Highlight Options") });
      f && (yield f.run());
    });
  }
}
rx.ID = "editor.action.unicodeHighlight.showExcludeOptions";
function oot(i, e) {
  return Ps(this, void 0, void 0, function* () {
    const t = i.getValue(To.allowedCharacters);
    let n;
    typeof t == "object" && t ? n = t : n = {};
    for (const r of e)
      n[String.fromCodePoint(r)] = !0;
    yield i.updateValue(
      To.allowedCharacters,
      n,
      2
      /* ConfigurationTarget.USER */
    );
  });
}
function aot(i, e) {
  var t;
  return Ps(this, void 0, void 0, function* () {
    const n = (t = i.inspect(To.allowedLocales).user) === null || t === void 0 ? void 0 : t.value;
    let r;
    typeof n == "object" && n ? r = Object.assign({}, n) : r = {};
    for (const s of e)
      r[s] = !0;
    yield i.updateValue(
      To.allowedLocales,
      r,
      2
      /* ConfigurationTarget.USER */
    );
  });
}
function lot(i) {
  throw new Error(`Unexpected value: ${i}`);
}
Be(mp);
Be(Tb);
Be(Nb);
Be(rx);
pn(
  Z_.ID,
  Z_,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
K0.register(oW);
var cot = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Ree = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, dot = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
const Eve = "ignoreUnusualLineTerminators";
function uot(i, e, t) {
  i.setModelProperty(e.uri, Eve, t);
}
function hot(i, e) {
  return i.getModelProperty(e.uri, Eve);
}
let Kw = class extends we {
  constructor(e, t, n) {
    super(), this._editor = e, this._dialogService = t, this._codeEditorService = n, this._isPresentingDialog = !1, this._config = this._editor.getOption(
      125
      /* EditorOption.unusualLineTerminators */
    ), this._register(this._editor.onDidChangeConfiguration((r) => {
      r.hasChanged(
        125
        /* EditorOption.unusualLineTerminators */
      ) && (this._config = this._editor.getOption(
        125
        /* EditorOption.unusualLineTerminators */
      ), this._checkForUnusualLineTerminators());
    })), this._register(this._editor.onDidChangeModel(() => {
      this._checkForUnusualLineTerminators();
    })), this._register(this._editor.onDidChangeModelContent((r) => {
      r.isUndoing || this._checkForUnusualLineTerminators();
    })), this._checkForUnusualLineTerminators();
  }
  _checkForUnusualLineTerminators() {
    return dot(this, void 0, void 0, function* () {
      if (this._config === "off" || !this._editor.hasModel())
        return;
      const e = this._editor.getModel();
      if (!e.mightContainUnusualLineTerminators() || hot(this._codeEditorService, e) === !0 || this._editor.getOption(
        90
        /* EditorOption.readOnly */
      ))
        return;
      if (this._config === "auto") {
        e.removeUnusualLineTerminators(this._editor.getSelections());
        return;
      }
      if (this._isPresentingDialog)
        return;
      let n;
      try {
        this._isPresentingDialog = !0, n = yield this._dialogService.confirm({
          title: C("unusualLineTerminators.title", "Unusual Line Terminators"),
          message: C("unusualLineTerminators.message", "Detected unusual line terminators"),
          detail: C("unusualLineTerminators.detail", "The file '{0}' contains one or more unusual line terminator characters, like Line Separator (LS) or Paragraph Separator (PS).\n\nIt is recommended to remove them from the file. This can be configured via `editor.unusualLineTerminators`.", xl(e.uri)),
          primaryButton: C({ key: "unusualLineTerminators.fix", comment: ["&& denotes a mnemonic"] }, "&&Remove Unusual Line Terminators"),
          cancelButton: C("unusualLineTerminators.ignore", "Ignore")
        });
      } finally {
        this._isPresentingDialog = !1;
      }
      if (!n.confirmed) {
        uot(this._codeEditorService, e, !0);
        return;
      }
      e.removeUnusualLineTerminators(this._editor.getSelections());
    });
  }
};
Kw.ID = "editor.contrib.unusualLineTerminatorsDetector";
Kw = cot([
  Ree(1, RS),
  Ree(2, Sn)
], Kw);
pn(
  Kw.ID,
  Kw,
  1
  /* EditorContributionInstantiation.AfterFirstRender */
);
var fot = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Fee = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, lW;
const Q5 = new Ke("hasWordHighlights", !1);
function Lve(i, e, t, n) {
  const r = i.ordered(e);
  return Zhe(r.map((s) => () => Promise.resolve(s.provideDocumentHighlights(e, t, n)).then(void 0, vr)), Bs);
}
class Ive {
  constructor(e, t, n) {
    this._model = e, this._selection = t, this._wordSeparators = n, this._wordRange = this._getCurrentWordRange(e, t), this._result = null;
  }
  get result() {
    return this._result || (this._result = Ir((e) => this._compute(this._model, this._selection, this._wordSeparators, e))), this._result;
  }
  _getCurrentWordRange(e, t) {
    const n = e.getWordAtPosition(t.getPosition());
    return n ? new V(t.startLineNumber, n.startColumn, t.startLineNumber, n.endColumn) : null;
  }
  isValid(e, t, n) {
    const r = t.startLineNumber, s = t.startColumn, o = t.endColumn, a = this._getCurrentWordRange(e, t);
    let l = !!(this._wordRange && this._wordRange.equalsRange(a));
    for (let c = 0, d = n.length; !l && c < d; c++) {
      const u = n.getRange(c);
      u && u.startLineNumber === r && u.startColumn <= s && u.endColumn >= o && (l = !0);
    }
    return l;
  }
  cancel() {
    this.result.cancel();
  }
}
class got extends Ive {
  constructor(e, t, n, r) {
    super(e, t, n), this._providers = r;
  }
  _compute(e, t, n, r) {
    return Lve(this._providers, e, t.getPosition(), r).then((s) => s || []);
  }
}
class pot extends Ive {
  constructor(e, t, n) {
    super(e, t, n), this._selectionIsEmpty = t.isEmpty();
  }
  _compute(e, t, n, r) {
    return Mg(250, r).then(() => {
      if (!t.isEmpty())
        return [];
      const s = e.getWordAtPosition(t.getPosition());
      return !s || s.word.length > 1e3 ? [] : e.findMatches(s.word, !0, !1, !0, n, !1).map((a) => ({
        range: a.range,
        kind: xy.Text
      }));
    });
  }
  isValid(e, t, n) {
    const r = t.isEmpty();
    return this._selectionIsEmpty !== r ? !1 : super.isValid(e, t, n);
  }
}
function mot(i, e, t, n) {
  return i.has(e) ? new got(e, t, n, i) : new pot(e, t, n);
}
Ru("_executeDocumentHighlights", (i, e, t) => {
  const n = i.get(tt);
  return Lve(n.documentHighlightProvider, e, t, jt.None);
});
class vot {
  constructor(e, t, n, r) {
    this.toUnhook = new Ne(), this.workerRequestTokenId = 0, this.workerRequestCompleted = !1, this.workerRequestValue = [], this.lastCursorPositionChangeTime = 0, this.renderDecorationsTimer = -1, this.editor = e, this.providers = t, this.linkedHighlighters = n, this._hasWordHighlights = Q5.bindTo(r), this._ignorePositionChangeEvent = !1, this.occurrencesHighlight = this.editor.getOption(
      80
      /* EditorOption.occurrencesHighlight */
    ), this.model = this.editor.getModel(), this.toUnhook.add(e.onDidChangeCursorPosition((s) => {
      this._ignorePositionChangeEvent || this.occurrencesHighlight && this._onPositionChanged(s);
    })), this.toUnhook.add(e.onDidChangeModelContent((s) => {
      this._stopAll();
    })), this.toUnhook.add(e.onDidChangeConfiguration((s) => {
      const o = this.editor.getOption(
        80
        /* EditorOption.occurrencesHighlight */
      );
      this.occurrencesHighlight !== o && (this.occurrencesHighlight = o, this._stopAll());
    })), this.decorations = this.editor.createDecorationsCollection(), this.workerRequestTokenId = 0, this.workerRequest = null, this.workerRequestCompleted = !1, this.lastCursorPositionChangeTime = 0, this.renderDecorationsTimer = -1;
  }
  hasDecorations() {
    return this.decorations.length > 0;
  }
  restore() {
    this.occurrencesHighlight && this._run();
  }
  _getSortedHighlights() {
    return this.decorations.getRanges().sort(V.compareRangesUsingStarts);
  }
  moveNext() {
    const e = this._getSortedHighlights(), n = (e.findIndex((s) => s.containsPosition(this.editor.getPosition())) + 1) % e.length, r = e[n];
    try {
      this._ignorePositionChangeEvent = !0, this.editor.setPosition(r.getStartPosition()), this.editor.revealRangeInCenterIfOutsideViewport(r);
      const s = this._getWord();
      if (s) {
        const o = this.editor.getModel().getLineContent(r.startLineNumber);
        Fs(`${o}, ${n + 1} of ${e.length} for '${s.word}'`);
      }
    } finally {
      this._ignorePositionChangeEvent = !1;
    }
  }
  moveBack() {
    const e = this._getSortedHighlights(), n = (e.findIndex((s) => s.containsPosition(this.editor.getPosition())) - 1 + e.length) % e.length, r = e[n];
    try {
      this._ignorePositionChangeEvent = !0, this.editor.setPosition(r.getStartPosition()), this.editor.revealRangeInCenterIfOutsideViewport(r);
      const s = this._getWord();
      if (s) {
        const o = this.editor.getModel().getLineContent(r.startLineNumber);
        Fs(`${o}, ${n + 1} of ${e.length} for '${s.word}'`);
      }
    } finally {
      this._ignorePositionChangeEvent = !1;
    }
  }
  _removeDecorations() {
    this.decorations.length > 0 && (this.decorations.clear(), this._hasWordHighlights.set(!1));
  }
  _stopAll() {
    this._removeDecorations(), this.renderDecorationsTimer !== -1 && (clearTimeout(this.renderDecorationsTimer), this.renderDecorationsTimer = -1), this.workerRequest !== null && (this.workerRequest.cancel(), this.workerRequest = null), this.workerRequestCompleted || (this.workerRequestTokenId++, this.workerRequestCompleted = !0);
  }
  _onPositionChanged(e) {
    if (!this.occurrencesHighlight) {
      this._stopAll();
      return;
    }
    if (e.reason !== 3) {
      this._stopAll();
      return;
    }
    this._run();
  }
  _getWord() {
    const e = this.editor.getSelection(), t = e.startLineNumber, n = e.startColumn;
    return this.model.getWordAtPosition({
      lineNumber: t,
      column: n
    });
  }
  _run() {
    const e = this.editor.getSelection();
    if (e.startLineNumber !== e.endLineNumber) {
      this._stopAll();
      return;
    }
    const t = e.startColumn, n = e.endColumn, r = this._getWord();
    if (!r || r.startColumn > t || r.endColumn < n) {
      this._stopAll();
      return;
    }
    const s = this.workerRequest && this.workerRequest.isValid(this.model, e, this.decorations);
    if (this.lastCursorPositionChangeTime = (/* @__PURE__ */ new Date()).getTime(), s)
      this.workerRequestCompleted && this.renderDecorationsTimer !== -1 && (clearTimeout(this.renderDecorationsTimer), this.renderDecorationsTimer = -1, this._beginRenderDecorations());
    else {
      this._stopAll();
      const o = ++this.workerRequestTokenId;
      this.workerRequestCompleted = !1, this.workerRequest = mot(this.providers, this.model, this.editor.getSelection(), this.editor.getOption(
        129
        /* EditorOption.wordSeparators */
      )), this.workerRequest.result.then((a) => {
        o === this.workerRequestTokenId && (this.workerRequestCompleted = !0, this.workerRequestValue = a || [], this._beginRenderDecorations());
      }, It);
    }
  }
  _beginRenderDecorations() {
    const e = (/* @__PURE__ */ new Date()).getTime(), t = this.lastCursorPositionChangeTime + 250;
    e >= t ? (this.renderDecorationsTimer = -1, this.renderDecorations()) : this.renderDecorationsTimer = setTimeout(() => {
      this.renderDecorations();
    }, t - e);
  }
  renderDecorations() {
    this.renderDecorationsTimer = -1;
    const e = [];
    for (const t of this.workerRequestValue)
      t.range && e.push({
        range: t.range,
        options: jrt(t.kind)
      });
    this.decorations.set(e), this._hasWordHighlights.set(this.hasDecorations());
    for (const t of this.linkedHighlighters())
      t?.editor.getModel() === this.editor.getModel() && (t._stopAll(), t.decorations.set(e), t._hasWordHighlights.set(t.hasDecorations()));
  }
  dispose() {
    this._stopAll(), this.toUnhook.dispose();
  }
}
let C0 = lW = class extends we {
  static get(e) {
    return e.getContribution(lW.ID);
  }
  constructor(e, t, n) {
    super(), this.wordHighlighter = null, this.linkedContributions = /* @__PURE__ */ new Set();
    const r = () => {
      e.hasModel() && !e.getModel().isTooLargeForTokenization() && (this.wordHighlighter = new vot(e, n.documentHighlightProvider, () => Wt.map(this.linkedContributions, (s) => s.wordHighlighter), t));
    };
    this._register(e.onDidChangeModel((s) => {
      this.wordHighlighter && (this.wordHighlighter.dispose(), this.wordHighlighter = null), r();
    })), r();
  }
  saveViewState() {
    return !!(this.wordHighlighter && this.wordHighlighter.hasDecorations());
  }
  moveNext() {
    var e;
    (e = this.wordHighlighter) === null || e === void 0 || e.moveNext();
  }
  moveBack() {
    var e;
    (e = this.wordHighlighter) === null || e === void 0 || e.moveBack();
  }
  restoreViewState(e) {
    this.wordHighlighter && e && this.wordHighlighter.restore();
  }
  dispose() {
    this.wordHighlighter && (this.wordHighlighter.dispose(), this.wordHighlighter = null), super.dispose();
  }
};
C0.ID = "editor.contrib.wordHighlighter";
C0 = lW = fot([
  Fee(1, yt),
  Fee(2, tt)
], C0);
class Ave extends Je {
  constructor(e, t) {
    super(t), this._isNext = e;
  }
  run(e, t) {
    const n = C0.get(t);
    n && (this._isNext ? n.moveNext() : n.moveBack());
  }
}
class _ot extends Ave {
  constructor() {
    super(!0, {
      id: "editor.action.wordHighlight.next",
      label: C("wordHighlight.next.label", "Go to Next Symbol Highlight"),
      alias: "Go to Next Symbol Highlight",
      precondition: Q5,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 65,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class bot extends Ave {
  constructor() {
    super(!1, {
      id: "editor.action.wordHighlight.prev",
      label: C("wordHighlight.previous.label", "Go to Previous Symbol Highlight"),
      alias: "Go to Previous Symbol Highlight",
      precondition: Q5,
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 1089,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class Cot extends Je {
  constructor() {
    super({
      id: "editor.action.wordHighlight.trigger",
      label: C("wordHighlight.trigger.label", "Trigger Symbol Highlight"),
      alias: "Trigger Symbol Highlight",
      precondition: Q5.toNegated(),
      kbOpts: {
        kbExpr: $.editorTextFocus,
        primary: 0,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e, t, n) {
    const r = C0.get(t);
    r && r.restoreViewState(!0);
  }
}
pn(
  C0.ID,
  C0,
  0
  /* EditorContributionInstantiation.Eager */
);
Be(_ot);
Be(bot);
Be(Cot);
class J5 extends Kr {
  constructor(e) {
    super(e), this._inSelectionMode = e.inSelectionMode, this._wordNavigationType = e.wordNavigationType;
  }
  runEditorCommand(e, t, n) {
    if (!t.hasModel())
      return;
    const r = wl(t.getOption(
      129
      /* EditorOption.wordSeparators */
    )), s = t.getModel(), a = t.getSelections().map((l) => {
      const c = new ve(l.positionLineNumber, l.positionColumn), d = this._move(r, s, c, this._wordNavigationType);
      return this._moveTo(l, d, this._inSelectionMode);
    });
    if (s.pushStackElement(), t._getViewModel().setCursorStates("moveWordCommand", 3, a.map((l) => dn.fromModelSelection(l))), a.length === 1) {
      const l = new ve(a[0].positionLineNumber, a[0].positionColumn);
      t.revealPosition(
        l,
        0
        /* ScrollType.Smooth */
      );
    }
  }
  _moveTo(e, t, n) {
    return n ? new ot(e.selectionStartLineNumber, e.selectionStartColumn, t.lineNumber, t.column) : new ot(t.lineNumber, t.column, t.lineNumber, t.column);
  }
}
class vp extends J5 {
  _move(e, t, n, r) {
    return yn.moveWordLeft(e, t, n, r);
  }
}
class _p extends J5 {
  _move(e, t, n, r) {
    return yn.moveWordRight(e, t, n, r);
  }
}
class yot extends vp {
  constructor() {
    super({
      inSelectionMode: !1,
      wordNavigationType: 0,
      id: "cursorWordStartLeft",
      precondition: void 0
    });
  }
}
class wot extends vp {
  constructor() {
    super({
      inSelectionMode: !1,
      wordNavigationType: 2,
      id: "cursorWordEndLeft",
      precondition: void 0
    });
  }
}
class Sot extends vp {
  constructor() {
    var e;
    super({
      inSelectionMode: !1,
      wordNavigationType: 1,
      id: "cursorWordLeft",
      precondition: void 0,
      kbOpts: {
        kbExpr: ke.and($.textInputFocus, (e = ke.and(LS, H4)) === null || e === void 0 ? void 0 : e.negate()),
        primary: 2063,
        mac: {
          primary: 527
          /* KeyCode.LeftArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class xot extends vp {
  constructor() {
    super({
      inSelectionMode: !0,
      wordNavigationType: 0,
      id: "cursorWordStartLeftSelect",
      precondition: void 0
    });
  }
}
class Dot extends vp {
  constructor() {
    super({
      inSelectionMode: !0,
      wordNavigationType: 2,
      id: "cursorWordEndLeftSelect",
      precondition: void 0
    });
  }
}
class Eot extends vp {
  constructor() {
    var e;
    super({
      inSelectionMode: !0,
      wordNavigationType: 1,
      id: "cursorWordLeftSelect",
      precondition: void 0,
      kbOpts: {
        kbExpr: ke.and($.textInputFocus, (e = ke.and(LS, H4)) === null || e === void 0 ? void 0 : e.negate()),
        primary: 3087,
        mac: {
          primary: 1551
          /* KeyCode.LeftArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class Lot extends vp {
  constructor() {
    super({
      inSelectionMode: !1,
      wordNavigationType: 3,
      id: "cursorWordAccessibilityLeft",
      precondition: void 0
    });
  }
  _move(e, t, n, r) {
    return super._move(wl(pd.wordSeparators.defaultValue), t, n, r);
  }
}
class Iot extends vp {
  constructor() {
    super({
      inSelectionMode: !0,
      wordNavigationType: 3,
      id: "cursorWordAccessibilityLeftSelect",
      precondition: void 0
    });
  }
  _move(e, t, n, r) {
    return super._move(wl(pd.wordSeparators.defaultValue), t, n, r);
  }
}
class Aot extends _p {
  constructor() {
    super({
      inSelectionMode: !1,
      wordNavigationType: 0,
      id: "cursorWordStartRight",
      precondition: void 0
    });
  }
}
class kot extends _p {
  constructor() {
    var e;
    super({
      inSelectionMode: !1,
      wordNavigationType: 2,
      id: "cursorWordEndRight",
      precondition: void 0,
      kbOpts: {
        kbExpr: ke.and($.textInputFocus, (e = ke.and(LS, H4)) === null || e === void 0 ? void 0 : e.negate()),
        primary: 2065,
        mac: {
          primary: 529
          /* KeyCode.RightArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class Tot extends _p {
  constructor() {
    super({
      inSelectionMode: !1,
      wordNavigationType: 2,
      id: "cursorWordRight",
      precondition: void 0
    });
  }
}
class Not extends _p {
  constructor() {
    super({
      inSelectionMode: !0,
      wordNavigationType: 0,
      id: "cursorWordStartRightSelect",
      precondition: void 0
    });
  }
}
class Pot extends _p {
  constructor() {
    var e;
    super({
      inSelectionMode: !0,
      wordNavigationType: 2,
      id: "cursorWordEndRightSelect",
      precondition: void 0,
      kbOpts: {
        kbExpr: ke.and($.textInputFocus, (e = ke.and(LS, H4)) === null || e === void 0 ? void 0 : e.negate()),
        primary: 3089,
        mac: {
          primary: 1553
          /* KeyCode.RightArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class Oot extends _p {
  constructor() {
    super({
      inSelectionMode: !0,
      wordNavigationType: 2,
      id: "cursorWordRightSelect",
      precondition: void 0
    });
  }
}
class Mot extends _p {
  constructor() {
    super({
      inSelectionMode: !1,
      wordNavigationType: 3,
      id: "cursorWordAccessibilityRight",
      precondition: void 0
    });
  }
  _move(e, t, n, r) {
    return super._move(wl(pd.wordSeparators.defaultValue), t, n, r);
  }
}
class Rot extends _p {
  constructor() {
    super({
      inSelectionMode: !0,
      wordNavigationType: 3,
      id: "cursorWordAccessibilityRightSelect",
      precondition: void 0
    });
  }
  _move(e, t, n, r) {
    return super._move(wl(pd.wordSeparators.defaultValue), t, n, r);
  }
}
class $5 extends Kr {
  constructor(e) {
    super(e), this._whitespaceHeuristics = e.whitespaceHeuristics, this._wordNavigationType = e.wordNavigationType;
  }
  runEditorCommand(e, t, n) {
    const r = e.get(Un);
    if (!t.hasModel())
      return;
    const s = wl(t.getOption(
      129
      /* EditorOption.wordSeparators */
    )), o = t.getModel(), a = t.getSelections(), l = t.getOption(
      6
      /* EditorOption.autoClosingBrackets */
    ), c = t.getOption(
      11
      /* EditorOption.autoClosingQuotes */
    ), d = r.getLanguageConfiguration(o.getLanguageId()).getAutoClosingPairs(), u = t._getViewModel(), h = a.map((f) => {
      const g = this._delete({
        wordSeparators: s,
        model: o,
        selection: f,
        whitespaceHeuristics: this._whitespaceHeuristics,
        autoClosingDelete: t.getOption(
          9
          /* EditorOption.autoClosingDelete */
        ),
        autoClosingBrackets: l,
        autoClosingQuotes: c,
        autoClosingPairs: d,
        autoClosedCharacters: u.getCursorAutoClosedCharacters()
      }, this._wordNavigationType);
      return new vs(g, "");
    });
    t.pushUndoStop(), t.executeCommands(this.id, h), t.pushUndoStop();
  }
}
class zG extends $5 {
  _delete(e, t) {
    const n = yn.deleteWordLeft(e, t);
    return n || new V(1, 1, 1, 1);
  }
}
class UG extends $5 {
  _delete(e, t) {
    const n = yn.deleteWordRight(e, t);
    if (n)
      return n;
    const r = e.model.getLineCount(), s = e.model.getLineMaxColumn(r);
    return new V(r, s, r, s);
  }
}
class Fot extends zG {
  constructor() {
    super({
      whitespaceHeuristics: !1,
      wordNavigationType: 0,
      id: "deleteWordStartLeft",
      precondition: $.writable
    });
  }
}
class Bot extends zG {
  constructor() {
    super({
      whitespaceHeuristics: !1,
      wordNavigationType: 2,
      id: "deleteWordEndLeft",
      precondition: $.writable
    });
  }
}
class Vot extends zG {
  constructor() {
    super({
      whitespaceHeuristics: !0,
      wordNavigationType: 0,
      id: "deleteWordLeft",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 2049,
        mac: {
          primary: 513
          /* KeyCode.Backspace */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class Hot extends UG {
  constructor() {
    super({
      whitespaceHeuristics: !1,
      wordNavigationType: 0,
      id: "deleteWordStartRight",
      precondition: $.writable
    });
  }
}
class Wot extends UG {
  constructor() {
    super({
      whitespaceHeuristics: !1,
      wordNavigationType: 2,
      id: "deleteWordEndRight",
      precondition: $.writable
    });
  }
}
class jot extends UG {
  constructor() {
    super({
      whitespaceHeuristics: !0,
      wordNavigationType: 2,
      id: "deleteWordRight",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 2068,
        mac: {
          primary: 532
          /* KeyCode.Delete */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class zot extends Je {
  constructor() {
    super({
      id: "deleteInsideWord",
      precondition: $.writable,
      label: C("deleteInsideWord", "Delete Word"),
      alias: "Delete Word"
    });
  }
  run(e, t, n) {
    if (!t.hasModel())
      return;
    const r = wl(t.getOption(
      129
      /* EditorOption.wordSeparators */
    )), s = t.getModel(), a = t.getSelections().map((l) => {
      const c = yn.deleteInsideWord(r, s, l);
      return new vs(c, "");
    });
    t.pushUndoStop(), t.executeCommands(this.id, a), t.pushUndoStop();
  }
}
ze(new yot());
ze(new wot());
ze(new Sot());
ze(new xot());
ze(new Dot());
ze(new Eot());
ze(new Aot());
ze(new kot());
ze(new Tot());
ze(new Not());
ze(new Pot());
ze(new Oot());
ze(new Lot());
ze(new Iot());
ze(new Mot());
ze(new Rot());
ze(new Fot());
ze(new Bot());
ze(new Vot());
ze(new Hot());
ze(new Wot());
ze(new jot());
Be(zot);
class Uot extends $5 {
  constructor() {
    super({
      whitespaceHeuristics: !0,
      wordNavigationType: 0,
      id: "deleteWordPartLeft",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        mac: {
          primary: 769
          /* KeyCode.Backspace */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  _delete(e, t) {
    const n = C4.deleteWordPartLeft(e);
    return n || new V(1, 1, 1, 1);
  }
}
class Got extends $5 {
  constructor() {
    super({
      whitespaceHeuristics: !0,
      wordNavigationType: 2,
      id: "deleteWordPartRight",
      precondition: $.writable,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        mac: {
          primary: 788
          /* KeyCode.Delete */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  _delete(e, t) {
    const n = C4.deleteWordPartRight(e);
    if (n)
      return n;
    const r = e.model.getLineCount(), s = e.model.getLineMaxColumn(r);
    return new V(r, s, r, s);
  }
}
class kve extends J5 {
  _move(e, t, n, r) {
    return C4.moveWordPartLeft(e, t, n);
  }
}
class qot extends kve {
  constructor() {
    super({
      inSelectionMode: !1,
      wordNavigationType: 0,
      id: "cursorWordPartLeft",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        mac: {
          primary: 783
          /* KeyCode.LeftArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
on.registerCommandAlias("cursorWordPartStartLeft", "cursorWordPartLeft");
class Kot extends kve {
  constructor() {
    super({
      inSelectionMode: !0,
      wordNavigationType: 0,
      id: "cursorWordPartLeftSelect",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        mac: {
          primary: 1807
          /* KeyCode.LeftArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
on.registerCommandAlias("cursorWordPartStartLeftSelect", "cursorWordPartLeftSelect");
class Tve extends J5 {
  _move(e, t, n, r) {
    return C4.moveWordPartRight(e, t, n);
  }
}
class Yot extends Tve {
  constructor() {
    super({
      inSelectionMode: !1,
      wordNavigationType: 2,
      id: "cursorWordPartRight",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        mac: {
          primary: 785
          /* KeyCode.RightArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
class Xot extends Tve {
  constructor() {
    super({
      inSelectionMode: !0,
      wordNavigationType: 2,
      id: "cursorWordPartRightSelect",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.textInputFocus,
        primary: 0,
        mac: {
          primary: 1809
          /* KeyCode.RightArrow */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
}
ze(new Uot());
ze(new Got());
ze(new qot());
ze(new Kot());
ze(new Yot());
ze(new Xot());
class cW extends we {
  constructor(e) {
    super(), this.editor = e, this._register(this.editor.onDidAttemptReadOnlyEdit(() => this._onDidAttemptReadOnlyEdit()));
  }
  _onDidAttemptReadOnlyEdit() {
    const e = ra.get(this.editor);
    if (e && this.editor.hasModel()) {
      let t = this.editor.getOptions().get(
        91
        /* EditorOption.readOnlyMessage */
      );
      t || (this.editor.isSimpleWidget ? t = new ys(C("editor.simple.readonly", "Cannot edit in read-only input")) : t = new ys(C("editor.readonly", "Cannot edit in read-only editor"))), e.showMessage(t, this.editor.getPosition());
    }
  }
}
cW.ID = "editor.contrib.readOnlyMessageController";
pn(
  cW.ID,
  cW,
  2
  /* EditorContributionInstantiation.BeforeFirstInteraction */
);
class dW extends we {
  constructor(e) {
    super(), this.editor = e, this.widget = null, od && (this._register(e.onDidChangeConfiguration(() => this.update())), this.update());
  }
  update() {
    const e = !this.editor.getOption(
      90
      /* EditorOption.readOnly */
    );
    !this.widget && e ? this.widget = new ek(this.editor) : this.widget && !e && (this.widget.dispose(), this.widget = null);
  }
  dispose() {
    super.dispose(), this.widget && (this.widget.dispose(), this.widget = null);
  }
}
dW.ID = "editor.contrib.iPadShowKeyboard";
class ek extends we {
  constructor(e) {
    super(), this.editor = e, this._domNode = document.createElement("textarea"), this._domNode.className = "iPadShowKeyboard", this._register(Ie(this._domNode, "touchstart", (t) => {
      this.editor.focus();
    })), this._register(Ie(this._domNode, "focus", (t) => {
      this.editor.focus();
    })), this.editor.addOverlayWidget(this);
  }
  dispose() {
    this.editor.removeOverlayWidget(this), super.dispose();
  }
  // ----- IOverlayWidget API
  getId() {
    return ek.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return {
      preference: 1
      /* OverlayWidgetPositionPreference.BOTTOM_RIGHT_CORNER */
    };
  }
}
ek.ID = "editor.contrib.ShowKeyboardWidget";
pn(
  dW.ID,
  dW,
  3
  /* EditorContributionInstantiation.Eventually */
);
var Zot = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Bee = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, uW;
let Q_ = uW = class extends we {
  static get(e) {
    return e.getContribution(uW.ID);
  }
  constructor(e, t, n) {
    super(), this._editor = e, this._languageService = n, this._widget = null, this._register(this._editor.onDidChangeModel((r) => this.stop())), this._register(this._editor.onDidChangeModelLanguage((r) => this.stop())), this._register(Pi.onDidChange((r) => this.stop())), this._register(this._editor.onKeyUp((r) => r.keyCode === 9 && this.stop()));
  }
  dispose() {
    this.stop(), super.dispose();
  }
  launch() {
    this._widget || this._editor.hasModel() && (this._widget = new tk(this._editor, this._languageService));
  }
  stop() {
    this._widget && (this._widget.dispose(), this._widget = null);
  }
};
Q_.ID = "editor.contrib.inspectTokens";
Q_ = uW = Zot([
  Bee(1, Ya),
  Bee(2, ci)
], Q_);
class Qot extends Je {
  constructor() {
    super({
      id: "editor.action.inspectTokens",
      label: lB.inspectTokensAction,
      alias: "Developer: Inspect Tokens",
      precondition: void 0
    });
  }
  run(e, t) {
    const n = Q_.get(t);
    n?.launch();
  }
}
function Jot(i) {
  let e = "";
  for (let t = 0, n = i.length; t < n; t++) {
    const r = i.charCodeAt(t);
    switch (r) {
      case 9:
        e += "→";
        break;
      case 32:
        e += "·";
        break;
      default:
        e += String.fromCharCode(r);
    }
  }
  return e;
}
function $ot(i, e) {
  const t = Pi.get(e);
  if (t)
    return t;
  const n = i.encodeLanguageId(e);
  return {
    getInitialState: () => __,
    tokenize: (r, s, o) => oz(e, o),
    tokenizeEncoded: (r, s, o) => f4(n, o)
  };
}
class tk extends we {
  constructor(e, t) {
    super(), this.allowEditorOverflow = !0, this._editor = e, this._languageService = t, this._model = this._editor.getModel(), this._domNode = document.createElement("div"), this._domNode.className = "tokens-inspect-widget", this._tokenizationSupport = $ot(this._languageService.languageIdCodec, this._model.getLanguageId()), this._compute(this._editor.getPosition()), this._register(this._editor.onDidChangeCursorPosition((n) => this._compute(this._editor.getPosition()))), this._editor.addContentWidget(this);
  }
  dispose() {
    this._editor.removeContentWidget(this), super.dispose();
  }
  getId() {
    return tk._ID;
  }
  _compute(e) {
    const t = this._getTokensAtLine(e.lineNumber);
    let n = 0;
    for (let l = t.tokens1.length - 1; l >= 0; l--) {
      const c = t.tokens1[l];
      if (e.column - 1 >= c.offset) {
        n = l;
        break;
      }
    }
    let r = 0;
    for (let l = t.tokens2.length >>> 1; l >= 0; l--)
      if (e.column - 1 >= t.tokens2[l << 1]) {
        r = l;
        break;
      }
    const s = this._model.getLineContent(e.lineNumber);
    let o = "";
    if (n < t.tokens1.length) {
      const l = t.tokens1[n].offset, c = n + 1 < t.tokens1.length ? t.tokens1[n + 1].offset : s.length;
      o = s.substring(l, c);
    }
    cs(this._domNode, Re("h2.tm-token", void 0, Jot(o), Re("span.tm-token-length", void 0, `${o.length} ${o.length === 1 ? "char" : "chars"}`))), Te(this._domNode, Re("hr.tokens-inspect-separator", { style: "clear:both" }));
    const a = (r << 1) + 1 < t.tokens2.length ? this._decodeMetadata(t.tokens2[(r << 1) + 1]) : null;
    Te(this._domNode, Re("table.tm-metadata-table", void 0, Re("tbody", void 0, Re("tr", void 0, Re("td.tm-metadata-key", void 0, "language"), Re("td.tm-metadata-value", void 0, `${a ? a.languageId : "-?-"}`)), Re("tr", void 0, Re("td.tm-metadata-key", void 0, "token type"), Re("td.tm-metadata-value", void 0, `${a ? this._tokenTypeToString(a.tokenType) : "-?-"}`)), Re("tr", void 0, Re("td.tm-metadata-key", void 0, "font style"), Re("td.tm-metadata-value", void 0, `${a ? this._fontStyleToString(a.fontStyle) : "-?-"}`)), Re("tr", void 0, Re("td.tm-metadata-key", void 0, "foreground"), Re("td.tm-metadata-value", void 0, `${a ? ye.Format.CSS.formatHex(a.foreground) : "-?-"}`)), Re("tr", void 0, Re("td.tm-metadata-key", void 0, "background"), Re("td.tm-metadata-value", void 0, `${a ? ye.Format.CSS.formatHex(a.background) : "-?-"}`))))), Te(this._domNode, Re("hr.tokens-inspect-separator")), n < t.tokens1.length && Te(this._domNode, Re("span.tm-token-type", void 0, t.tokens1[n].type)), this._editor.layoutContentWidget(this);
  }
  _decodeMetadata(e) {
    const t = Pi.getColorMap(), n = Cs.getLanguageId(e), r = Cs.getTokenType(e), s = Cs.getFontStyle(e), o = Cs.getForeground(e), a = Cs.getBackground(e);
    return {
      languageId: this._languageService.languageIdCodec.decodeLanguageId(n),
      tokenType: r,
      fontStyle: s,
      foreground: t[o],
      background: t[a]
    };
  }
  _tokenTypeToString(e) {
    switch (e) {
      case 0:
        return "Other";
      case 1:
        return "Comment";
      case 2:
        return "String";
      case 3:
        return "RegEx";
      default:
        return "??";
    }
  }
  _fontStyleToString(e) {
    let t = "";
    return e & 1 && (t += "italic "), e & 2 && (t += "bold "), e & 4 && (t += "underline "), e & 8 && (t += "strikethrough "), t.length === 0 && (t = "---"), t;
  }
  _getTokensAtLine(e) {
    const t = this._getStateBeforeLine(e), n = this._tokenizationSupport.tokenize(this._model.getLineContent(e), !0, t), r = this._tokenizationSupport.tokenizeEncoded(this._model.getLineContent(e), !0, t);
    return {
      startState: t,
      tokens1: n.tokens,
      tokens2: r.tokens,
      endState: n.endState
    };
  }
  _getStateBeforeLine(e) {
    let t = this._tokenizationSupport.getInitialState();
    for (let n = 1; n < e; n++)
      t = this._tokenizationSupport.tokenize(this._model.getLineContent(n), !0, t).endState;
    return t;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return {
      position: this._editor.getPosition(),
      preference: [
        2,
        1
        /* ContentWidgetPositionPreference.ABOVE */
      ]
    };
  }
}
tk._ID = "editor.contrib.inspectTokensWidget";
pn(
  Q_.ID,
  Q_,
  4
  /* EditorContributionInstantiation.Lazy */
);
Be(Qot);
var eat = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, Vee = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, cC;
let HI = cC = class {
  constructor(e, t) {
    this.quickInputService = e, this.keybindingService = t, this.registry = Di.as(H0.Quickaccess);
  }
  provide(e) {
    const t = new Ne();
    return t.add(e.onDidAccept(() => {
      const [n] = e.selectedItems;
      n && this.quickInputService.quickAccess.show(n.prefix, { preserveValue: !0 });
    })), t.add(e.onDidChangeValue((n) => {
      const r = this.registry.getQuickAccessProvider(n.substr(cC.PREFIX.length));
      r && r.prefix && r.prefix !== cC.PREFIX && this.quickInputService.quickAccess.show(r.prefix, { preserveValue: !0 });
    })), e.items = this.getQuickAccessProviders().filter((n) => n.prefix !== cC.PREFIX), t;
  }
  getQuickAccessProviders() {
    return this.registry.getQuickAccessProviders().sort((t, n) => t.prefix.localeCompare(n.prefix)).flatMap((t) => this.createPicks(t));
  }
  createPicks(e) {
    return e.helpEntries.map((t) => {
      const n = t.prefix || e.prefix, r = n || "…";
      return {
        prefix: n,
        label: r,
        keybinding: t.commandId ? this.keybindingService.lookupKeybinding(t.commandId) : void 0,
        ariaLabel: C("helpPickAriaLabel", "{0}, {1}", r, t.description),
        description: t.description
      };
    });
  }
};
HI.PREFIX = "?";
HI = cC = eat([
  Vee(0, bd),
  Vee(1, Bn)
], HI);
Di.as(H0.Quickaccess).registerQuickAccessProvider({
  ctor: HI,
  prefix: "",
  helpEntries: [{ description: cB.helpQuickAccessActionLabel }]
});
class Nve {
  constructor(e) {
    this.options = e, this.rangeHighlightDecorationId = void 0;
  }
  //#region Provider methods
  provide(e, t) {
    var n;
    const r = new Ne();
    e.canAcceptInBackground = !!(!((n = this.options) === null || n === void 0) && n.canAcceptInBackground), e.matchOnLabel = e.matchOnDescription = e.matchOnDetail = e.sortByLabel = !1;
    const s = r.add(new ds());
    return s.value = this.doProvide(e, t), r.add(this.onDidActiveTextEditorControlChange(() => {
      s.value = void 0, s.value = this.doProvide(e, t);
    })), r;
  }
  doProvide(e, t) {
    var n;
    const r = new Ne(), s = this.activeTextEditorControl;
    if (s && this.canProvideWithTextEditor(s)) {
      const o = { editor: s }, a = kme(s);
      if (a) {
        let l = (n = s.saveViewState()) !== null && n !== void 0 ? n : void 0;
        r.add(a.onDidChangeCursorPosition(() => {
          var c;
          l = (c = s.saveViewState()) !== null && c !== void 0 ? c : void 0;
        })), o.restoreViewState = () => {
          l && s === this.activeTextEditorControl && s.restoreViewState(l);
        }, r.add(Ng(t.onCancellationRequested)(() => {
          var c;
          return (c = o.restoreViewState) === null || c === void 0 ? void 0 : c.call(o);
        }));
      }
      r.add(Ct(() => this.clearDecorations(s))), r.add(this.provideWithTextEditor(o, e, t));
    } else
      r.add(this.provideWithoutTextEditor(e, t));
    return r;
  }
  /**
   * Subclasses to implement if they can operate on the text editor.
   */
  canProvideWithTextEditor(e) {
    return !0;
  }
  gotoLocation({ editor: e }, t) {
    e.setSelection(t.range), e.revealRangeInCenter(
      t.range,
      0
      /* ScrollType.Smooth */
    ), t.preserveFocus || e.focus();
    const n = e.getModel();
    n && "getLineContent" in n && Vg(`${n.getLineContent(t.range.startLineNumber)}`);
  }
  getModel(e) {
    var t;
    return Ame(e) ? (t = e.getModel()) === null || t === void 0 ? void 0 : t.modified : e.getModel();
  }
  addDecorations(e, t) {
    e.changeDecorations((n) => {
      const r = [];
      this.rangeHighlightDecorationId && (r.push(this.rangeHighlightDecorationId.overviewRulerDecorationId), r.push(this.rangeHighlightDecorationId.rangeHighlightId), this.rangeHighlightDecorationId = void 0);
      const s = [
        // highlight the entire line on the range
        {
          range: t,
          options: {
            description: "quick-access-range-highlight",
            className: "rangeHighlight",
            isWholeLine: !0
          }
        },
        // also add overview ruler highlight
        {
          range: t,
          options: {
            description: "quick-access-range-highlight-overview",
            overviewRuler: {
              color: Oi(Kfe),
              position: Ha.Full
            }
          }
        }
      ], [o, a] = n.deltaDecorations(r, s);
      this.rangeHighlightDecorationId = { rangeHighlightId: o, overviewRulerDecorationId: a };
    });
  }
  clearDecorations(e) {
    const t = this.rangeHighlightDecorationId;
    t && (e.changeDecorations((n) => {
      n.deltaDecorations([
        t.overviewRulerDecorationId,
        t.rangeHighlightId
      ], []);
    }), this.rangeHighlightDecorationId = void 0);
  }
}
class nk extends Nve {
  constructor() {
    super({ canAcceptInBackground: !0 });
  }
  provideWithoutTextEditor(e) {
    const t = C("cannotRunGotoLine", "Open a text editor first to go to a line.");
    return e.items = [{ label: t }], e.ariaLabel = t, we.None;
  }
  provideWithTextEditor(e, t, n) {
    const r = e.editor, s = new Ne();
    s.add(t.onDidAccept((l) => {
      const [c] = t.selectedItems;
      if (c) {
        if (!this.isValidLineNumber(r, c.lineNumber))
          return;
        this.gotoLocation(e, { range: this.toRange(c.lineNumber, c.column), keyMods: t.keyMods, preserveFocus: l.inBackground }), l.inBackground || t.hide();
      }
    }));
    const o = () => {
      const l = this.parsePosition(r, t.value.trim().substr(nk.PREFIX.length)), c = this.getPickLabel(r, l.lineNumber, l.column);
      if (t.items = [{
        lineNumber: l.lineNumber,
        column: l.column,
        label: c
      }], t.ariaLabel = c, !this.isValidLineNumber(r, l.lineNumber)) {
        this.clearDecorations(r);
        return;
      }
      const d = this.toRange(l.lineNumber, l.column);
      r.revealRangeInCenter(
        d,
        0
        /* ScrollType.Smooth */
      ), this.addDecorations(r, d);
    };
    o(), s.add(t.onDidChangeValue(() => o()));
    const a = kme(r);
    return a && a.getOptions().get(
      67
      /* EditorOption.lineNumbers */
    ).renderType === 2 && (a.updateOptions({ lineNumbers: "on" }), s.add(Ct(() => a.updateOptions({ lineNumbers: "relative" })))), s;
  }
  toRange(e = 1, t = 1) {
    return {
      startLineNumber: e,
      startColumn: t,
      endLineNumber: e,
      endColumn: t
    };
  }
  parsePosition(e, t) {
    const n = t.split(/,|:|#/).map((s) => parseInt(s, 10)).filter((s) => !isNaN(s)), r = this.lineCount(e) + 1;
    return {
      lineNumber: n[0] > 0 ? n[0] : r + n[0],
      column: n[1]
    };
  }
  getPickLabel(e, t, n) {
    if (this.isValidLineNumber(e, t))
      return this.isValidColumn(e, t, n) ? C("gotoLineColumnLabel", "Go to line {0} and character {1}.", t, n) : C("gotoLineLabel", "Go to line {0}.", t);
    const r = e.getPosition() || { lineNumber: 1, column: 1 }, s = this.lineCount(e);
    return s > 1 ? C("gotoLineLabelEmptyWithLimit", "Current Line: {0}, Character: {1}. Type a line number between 1 and {2} to navigate to.", r.lineNumber, r.column, s) : C("gotoLineLabelEmpty", "Current Line: {0}, Character: {1}. Type a line number to navigate to.", r.lineNumber, r.column);
  }
  isValidLineNumber(e, t) {
    return !t || typeof t != "number" ? !1 : t > 0 && t <= this.lineCount(e);
  }
  isValidColumn(e, t, n) {
    if (!n || typeof n != "number")
      return !1;
    const r = this.getModel(e);
    if (!r)
      return !1;
    const s = { lineNumber: t, column: n };
    return r.validatePosition(s).equals(s);
  }
  lineCount(e) {
    var t, n;
    return (n = (t = this.getModel(e)) === null || t === void 0 ? void 0 : t.getLineCount()) !== null && n !== void 0 ? n : 0;
  }
}
nk.PREFIX = ":";
var tat = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, nat = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Yw = class extends nk {
  constructor(e) {
    super(), this.editorService = e, this.onDidActiveTextEditorControlChange = qe.None;
  }
  get activeTextEditorControl() {
    var e;
    return (e = this.editorService.getFocusedCodeEditor()) !== null && e !== void 0 ? e : void 0;
  }
};
Yw = tat([
  nat(0, Sn)
], Yw);
let GG = class Pve extends Je {
  constructor() {
    super({
      id: Pve.ID,
      label: PL.gotoLineActionLabel,
      alias: "Go to Line/Column...",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 2085,
        mac: {
          primary: 293
          /* KeyCode.KeyG */
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  run(e) {
    e.get(bd).quickAccess.show(Yw.PREFIX);
  }
};
GG.ID = "editor.action.gotoLine";
Be(GG);
Di.as(H0.Quickaccess).registerQuickAccessProvider({
  ctor: Yw,
  prefix: Yw.PREFIX,
  helpEntries: [{ description: PL.gotoLineActionLabel, commandId: GG.ID }]
});
const Ove = [void 0, []];
function KT(i, e, t = 0, n = 0) {
  const r = e;
  return r.values && r.values.length > 1 ? iat(i, r.values, t, n) : Mve(i, e, t, n);
}
function iat(i, e, t, n) {
  let r = 0;
  const s = [];
  for (const o of e) {
    const [a, l] = Mve(i, o, t, n);
    if (typeof a != "number")
      return Ove;
    r += a, s.push(...l);
  }
  return [r, rat(s)];
}
function Mve(i, e, t, n) {
  const r = Jm(e.original, e.originalLowercase, t, i, i.toLowerCase(), n, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
  return r ? [r[0], BS(r)] : Ove;
}
function rat(i) {
  const e = i.sort((r, s) => r.start - s.start), t = [];
  let n;
  for (const r of e)
    !n || !sat(n, r) ? (n = r, t.push(r)) : (n.start = Math.min(n.start, r.start), n.end = Math.max(n.end, r.end));
  return t;
}
function sat(i, e) {
  return !(i.end < e.start || e.end < i.start);
}
function Hee(i) {
  return i.startsWith('"') && i.endsWith('"');
}
const Rve = " ";
function hW(i) {
  typeof i != "string" && (i = "");
  const e = i.toLowerCase(), { pathNormalized: t, normalized: n, normalizedLowercase: r } = Wee(i), s = t.indexOf(Qc) >= 0, o = Hee(i);
  let a;
  const l = i.split(Rve);
  if (l.length > 1)
    for (const c of l) {
      const d = Hee(c), { pathNormalized: u, normalized: h, normalizedLowercase: f } = Wee(c);
      h && (a || (a = []), a.push({
        original: c,
        originalLowercase: c.toLowerCase(),
        pathNormalized: u,
        normalized: h,
        normalizedLowercase: f,
        expectContiguousMatch: d
      }));
    }
  return { original: i, originalLowercase: e, pathNormalized: t, normalized: n, normalizedLowercase: r, values: a, containsPathSeparator: s, expectContiguousMatch: o };
}
function Wee(i) {
  let e;
  Ls ? e = i.replace(/\//g, Qc) : e = i.replace(/\\/g, Qc);
  const t = mNe(e).replace(/\s|"/g, "");
  return {
    pathNormalized: e,
    normalized: t,
    normalizedLowercase: t.toLowerCase()
  };
}
function jee(i) {
  return Array.isArray(i) ? hW(i.map((e) => e.original).join(Rve)) : hW(i.original);
}
var oat = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, zee = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, E2 = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, Qv;
let uu = Qv = class extends Nve {
  constructor(e, t, n = /* @__PURE__ */ Object.create(null)) {
    super(n), this._languageFeaturesService = e, this._outlineModelService = t, this.options = n, this.options.canAcceptInBackground = !0;
  }
  provideWithoutTextEditor(e) {
    return this.provideLabelPick(e, C("cannotRunGotoSymbolWithoutEditor", "To go to a symbol, first open a text editor with symbol information.")), we.None;
  }
  provideWithTextEditor(e, t, n) {
    const r = e.editor, s = this.getModel(r);
    return s ? this._languageFeaturesService.documentSymbolProvider.has(s) ? this.doProvideWithEditorSymbols(e, s, t, n) : this.doProvideWithoutEditorSymbols(e, s, t, n) : we.None;
  }
  doProvideWithoutEditorSymbols(e, t, n, r) {
    const s = new Ne();
    return this.provideLabelPick(n, C("cannotRunGotoSymbolWithoutSymbolProvider", "The active text editor does not provide symbol information.")), E2(this, void 0, void 0, function* () {
      !(yield this.waitForLanguageSymbolRegistry(t, s)) || r.isCancellationRequested || s.add(this.doProvideWithEditorSymbols(e, t, n, r));
    }), s;
  }
  provideLabelPick(e, t) {
    e.items = [{
      label: t,
      index: 0,
      kind: 14
      /* SymbolKind.String */
    }], e.ariaLabel = t;
  }
  waitForLanguageSymbolRegistry(e, t) {
    return E2(this, void 0, void 0, function* () {
      if (this._languageFeaturesService.documentSymbolProvider.has(e))
        return !0;
      const n = new r4(), r = t.add(this._languageFeaturesService.documentSymbolProvider.onDidChange(() => {
        this._languageFeaturesService.documentSymbolProvider.has(e) && (r.dispose(), n.complete(!0));
      }));
      return t.add(Ct(() => n.complete(!1))), n.p;
    });
  }
  doProvideWithEditorSymbols(e, t, n, r) {
    var s;
    const o = e.editor, a = new Ne();
    a.add(n.onDidAccept((u) => {
      const [h] = n.selectedItems;
      h && h.range && (this.gotoLocation(e, { range: h.range.selection, keyMods: n.keyMods, preserveFocus: u.inBackground }), u.inBackground || n.hide());
    })), a.add(n.onDidTriggerItemButton(({ item: u }) => {
      u && u.range && (this.gotoLocation(e, { range: u.range.selection, keyMods: n.keyMods, forceSideBySide: !0 }), n.hide());
    }));
    const l = this.getDocumentSymbols(t, r);
    let c;
    const d = (u) => E2(this, void 0, void 0, function* () {
      c?.dispose(!0), n.busy = !1, c = new lr(r), n.busy = !0;
      try {
        const h = hW(n.value.substr(Qv.PREFIX.length).trim()), f = yield this.doGetSymbolPicks(l, h, void 0, c.token);
        if (r.isCancellationRequested)
          return;
        if (f.length > 0) {
          if (n.items = f, u && h.original.length === 0) {
            const g = sL(f, (p) => !!(p.type !== "separator" && p.range && V.containsPosition(p.range.decoration, u)));
            g && (n.activeItems = [g]);
          }
        } else
          h.original.length > 0 ? this.provideLabelPick(n, C("noMatchingSymbolResults", "No matching editor symbols")) : this.provideLabelPick(n, C("noSymbolResults", "No editor symbols"));
      } finally {
        r.isCancellationRequested || (n.busy = !1);
      }
    });
    return a.add(n.onDidChangeValue(() => d(void 0))), d((s = o.getSelection()) === null || s === void 0 ? void 0 : s.getPosition()), a.add(n.onDidChangeActive(() => {
      const [u] = n.activeItems;
      u && u.range && (o.revealRangeInCenter(
        u.range.selection,
        0
        /* ScrollType.Smooth */
      ), this.addDecorations(o, u.range.decoration));
    })), a;
  }
  doGetSymbolPicks(e, t, n, r) {
    var s, o;
    return E2(this, void 0, void 0, function* () {
      const a = yield e;
      if (r.isCancellationRequested)
        return [];
      const l = t.original.indexOf(Qv.SCOPE_PREFIX) === 0, c = l ? 1 : 0;
      let d, u;
      t.values && t.values.length > 1 ? (d = jee(t.values[0]), u = jee(t.values.slice(1))) : d = t;
      let h;
      const f = (o = (s = this.options) === null || s === void 0 ? void 0 : s.openSideBySideDirection) === null || o === void 0 ? void 0 : o.call(s);
      f && (h = [{
        iconClass: f === "right" ? ft.asClassName(We.splitHorizontal) : ft.asClassName(We.splitVertical),
        tooltip: f === "right" ? C("openToSide", "Open to the Side") : C("openToBottom", "Open to the Bottom")
      }]);
      const g = [];
      for (let _ = 0; _ < a.length; _++) {
        const b = a[_], w = gNe(b.name), y = `$(${GE.toIcon(b.kind).id}) ${w}`, S = y.length - w.length;
        let x = b.containerName;
        n?.extraContainerLabel && (x ? x = `${n.extraContainerLabel} • ${x}` : x = n.extraContainerLabel);
        let D, E, L, k;
        if (t.original.length > c) {
          let I = !1;
          if (d !== t && ([D, E] = KT(y, Object.assign(Object.assign({}, t), {
            values: void 0
            /* disable multi-query support */
          }), c, S), typeof D == "number" && (I = !0)), typeof D != "number" && ([D, E] = KT(y, d, c, S), typeof D != "number"))
            continue;
          if (!I && u) {
            if (x && u.original.length > 0 && ([L, k] = KT(x, u)), typeof L != "number")
              continue;
            typeof D == "number" && (D += L);
          }
        }
        const N = b.tags && b.tags.indexOf(
          1
          /* SymbolTag.Deprecated */
        ) >= 0;
        g.push({
          index: _,
          kind: b.kind,
          score: D,
          label: y,
          ariaLabel: dNe(b.name, b.kind),
          description: x,
          highlights: N ? void 0 : {
            label: E,
            description: k
          },
          range: {
            selection: V.collapseToStart(b.selectionRange),
            decoration: b.range
          },
          strikethrough: N,
          buttons: h
        });
      }
      const p = g.sort((_, b) => l ? this.compareByKindAndScore(_, b) : this.compareByScore(_, b));
      let m = [];
      if (l) {
        let y = function() {
          b && typeof _ == "number" && w > 0 && (b.label = zm(XT[_] || YT, w));
        }, _, b, w = 0;
        for (const S of p)
          _ !== S.kind ? (y(), _ = S.kind, w = 1, b = { type: "separator" }, m.push(b)) : w++, m.push(S);
        y();
      } else p.length > 0 && (m = [
        { label: C("symbols", "symbols ({0})", g.length), type: "separator" },
        ...p
      ]);
      return m;
    });
  }
  compareByScore(e, t) {
    if (typeof e.score != "number" && typeof t.score == "number")
      return 1;
    if (typeof e.score == "number" && typeof t.score != "number")
      return -1;
    if (typeof e.score == "number" && typeof t.score == "number") {
      if (e.score > t.score)
        return -1;
      if (e.score < t.score)
        return 1;
    }
    return e.index < t.index ? -1 : e.index > t.index ? 1 : 0;
  }
  compareByKindAndScore(e, t) {
    const n = XT[e.kind] || YT, r = XT[t.kind] || YT, s = n.localeCompare(r);
    return s === 0 ? this.compareByScore(e, t) : s;
  }
  getDocumentSymbols(e, t) {
    return E2(this, void 0, void 0, function* () {
      const n = yield this._outlineModelService.getOrCreate(e, t);
      return t.isCancellationRequested ? [] : n.asListOfDocumentSymbols();
    });
  }
};
uu.PREFIX = "@";
uu.SCOPE_PREFIX = ":";
uu.PREFIX_BY_CATEGORY = `${Qv.PREFIX}${Qv.SCOPE_PREFIX}`;
uu = Qv = oat([
  zee(0, tt),
  zee(1, I5)
], uu);
const YT = C("property", "properties ({0})"), XT = {
  5: C("method", "methods ({0})"),
  11: C("function", "functions ({0})"),
  8: C("_constructor", "constructors ({0})"),
  12: C("variable", "variables ({0})"),
  4: C("class", "classes ({0})"),
  22: C("struct", "structs ({0})"),
  23: C("event", "events ({0})"),
  24: C("operator", "operators ({0})"),
  10: C("interface", "interfaces ({0})"),
  2: C("namespace", "namespaces ({0})"),
  3: C("package", "packages ({0})"),
  25: C("typeParameter", "type parameters ({0})"),
  1: C("modules", "modules ({0})"),
  6: C("property", "properties ({0})"),
  9: C("enum", "enumerations ({0})"),
  21: C("enumMember", "enumeration members ({0})"),
  14: C("string", "strings ({0})"),
  0: C("file", "files ({0})"),
  17: C("array", "arrays ({0})"),
  15: C("number", "numbers ({0})"),
  16: C("boolean", "booleans ({0})"),
  18: C("object", "objects ({0})"),
  19: C("key", "keys ({0})"),
  7: C("field", "fields ({0})"),
  13: C("constant", "constants ({0})")
};
var aat = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, ZT = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let fW = class extends uu {
  constructor(e, t, n) {
    super(t, n), this.editorService = e, this.onDidActiveTextEditorControlChange = qe.None;
  }
  get activeTextEditorControl() {
    var e;
    return (e = this.editorService.getFocusedCodeEditor()) !== null && e !== void 0 ? e : void 0;
  }
};
fW = aat([
  ZT(0, Sn),
  ZT(1, tt),
  ZT(2, I5)
], fW);
class sx extends Je {
  constructor() {
    super({
      id: sx.ID,
      label: rw.quickOutlineActionLabel,
      alias: "Go to Symbol...",
      precondition: $.hasDocumentSymbolProvider,
      kbOpts: {
        kbExpr: $.focus,
        primary: 3117,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      contextMenuOpts: {
        group: "navigation",
        order: 3
      }
    });
  }
  run(e) {
    e.get(bd).quickAccess.show(uu.PREFIX, { itemActivation: kc.NONE });
  }
}
sx.ID = "editor.action.quickOutline";
Be(sx);
Di.as(H0.Quickaccess).registerQuickAccessProvider({
  ctor: fW,
  prefix: uu.PREFIX,
  helpEntries: [
    { description: rw.quickOutlineActionLabel, prefix: uu.PREFIX, commandId: sx.ID },
    { description: rw.quickOutlineByCategoryActionLabel, prefix: uu.PREFIX_BY_CATEGORY }
  ]
});
function QT(i, e) {
  return e && (i.stack || i.stacktrace) ? C("stackTrace.format", "{0}: {1}", Gee(i), Uee(i.stack) || Uee(i.stacktrace)) : Gee(i);
}
function Uee(i) {
  return Array.isArray(i) ? i.join(`
`) : i;
}
function Gee(i) {
  return i.code === "ERR_UNC_HOST_NOT_ALLOWED" ? `${i.message}. Please update the 'security.allowedUNCHosts' setting if you want to allow this host.` : typeof i.code == "string" && typeof i.errno == "number" && typeof i.syscall == "string" ? C("nodeExceptionMessage", "A system error occurred ({0})", i.message) : i.message || C("error.defaultMessage", "An unknown error occurred. Please consult the log for more details.");
}
function Fve(i = null, e = !1) {
  if (!i)
    return C("error.defaultMessage", "An unknown error occurred. Please consult the log for more details.");
  if (Array.isArray(i)) {
    const t = _u(i), n = Fve(t[0], e);
    return t.length > 1 ? C("error.moreErrors", "{0} ({1} errors in total)", n, t.length) : n;
  }
  if (mo(i))
    return i;
  if (i.detail) {
    const t = i.detail;
    if (t.error)
      return QT(t.error, e);
    if (t.exception)
      return QT(t.exception, e);
  }
  return i.stack ? QT(i, e) : i.message ? i.message : C("error.defaultMessage", "An unknown error occurred. Please consult the log for more details.");
}
function lat(i) {
  var e;
  const t = /* @__PURE__ */ new Map();
  for (const n of i)
    t.set(n, ((e = t.get(n)) !== null && e !== void 0 ? e : 0) + 1);
  return t;
}
class JC {
  constructor() {
    this.chunkCount = 0, this.chunkOccurrences = /* @__PURE__ */ new Map(), this.documents = /* @__PURE__ */ new Map();
  }
  calculateScores(e, t) {
    const n = this.computeEmbedding(e), r = /* @__PURE__ */ new Map(), s = [];
    for (const [o, a] of this.documents) {
      if (t.isCancellationRequested)
        return [];
      for (const l of a.chunks) {
        const c = this.computeSimilarityScore(l, n, r);
        c > 0 && s.push({ key: o, score: c });
      }
    }
    return s;
  }
  /**
   * Count how many times each term (word) appears in a string.
   */
  static termFrequencies(e) {
    return lat(JC.splitTerms(e));
  }
  /**
   * Break a string into terms (words).
   */
  static *splitTerms(e) {
    const t = (n) => n.toLowerCase();
    for (const [n] of e.matchAll(/\b\p{Letter}[\p{Letter}\d]{2,}\b/gu)) {
      yield t(n);
      const r = n.split(/(?<=[a-z])(?=[A-Z])/g);
      if (r.length > 1)
        for (const s of r)
          s.length > 2 && /\p{Letter}{3,}/gu.test(s) && (yield t(s));
    }
  }
  updateDocuments(e) {
    var t;
    for (const { key: n } of e)
      this.deleteDocument(n);
    for (const n of e) {
      const r = [];
      for (const s of n.textChunks) {
        const o = JC.termFrequencies(s);
        for (const a of o.keys())
          this.chunkOccurrences.set(a, ((t = this.chunkOccurrences.get(a)) !== null && t !== void 0 ? t : 0) + 1);
        r.push({ text: s, tf: o });
      }
      this.chunkCount += r.length, this.documents.set(n.key, { chunks: r });
    }
    return this;
  }
  deleteDocument(e) {
    const t = this.documents.get(e);
    if (t) {
      this.documents.delete(e), this.chunkCount -= t.chunks.length;
      for (const n of t.chunks)
        for (const r of n.tf.keys()) {
          const s = this.chunkOccurrences.get(r);
          if (typeof s == "number") {
            const o = s - 1;
            o <= 0 ? this.chunkOccurrences.delete(r) : this.chunkOccurrences.set(r, o);
          }
        }
    }
  }
  computeSimilarityScore(e, t, n) {
    let r = 0;
    for (const [s, o] of Object.entries(t)) {
      const a = e.tf.get(s);
      if (!a)
        continue;
      let l = n.get(s);
      typeof l != "number" && (l = this.computeIdf(s), n.set(s, l));
      const c = a * l;
      r += c * o;
    }
    return r;
  }
  computeEmbedding(e) {
    const t = JC.termFrequencies(e);
    return this.computeTfidf(t);
  }
  computeIdf(e) {
    var t;
    const n = (t = this.chunkOccurrences.get(e)) !== null && t !== void 0 ? t : 0;
    return n > 0 ? Math.log((this.chunkCount + 1) / n) : 0;
  }
  computeTfidf(e) {
    const t = /* @__PURE__ */ Object.create(null);
    for (const [n, r] of e) {
      const s = this.computeIdf(n);
      s > 0 && (t[n] = r * s);
    }
    return t;
  }
}
function cat(i) {
  var e, t;
  const n = i.slice(0);
  n.sort((s, o) => o.score - s.score);
  const r = (t = (e = n[0]) === null || e === void 0 ? void 0 : e.score) !== null && t !== void 0 ? t : 0;
  if (r > 0)
    for (const s of n)
      s.score /= r;
  return n;
}
var L2 = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, vv;
(function(i) {
  i[i.NO_ACTION = 0] = "NO_ACTION", i[i.CLOSE_PICKER = 1] = "CLOSE_PICKER", i[i.REFRESH_PICKER = 2] = "REFRESH_PICKER", i[i.REMOVE_ITEM = 3] = "REMOVE_ITEM";
})(vv || (vv = {}));
function JT(i) {
  const e = i;
  return Array.isArray(e.items);
}
function qee(i) {
  const e = i;
  return !!e.picks && e.additionalPicks instanceof Promise;
}
class dat extends we {
  constructor(e, t) {
    super(), this.prefix = e, this.options = t;
  }
  provide(e, t, n) {
    var r;
    const s = new Ne();
    e.canAcceptInBackground = !!(!((r = this.options) === null || r === void 0) && r.canAcceptInBackground), e.matchOnLabel = e.matchOnDescription = e.matchOnDetail = e.sortByLabel = !1;
    let o;
    const a = s.add(new ds()), l = () => L2(this, void 0, void 0, function* () {
      const c = a.value = new Ne();
      o?.dispose(!0), e.busy = !1, o = new lr(t);
      const d = o.token, u = e.value.substr(this.prefix.length).trim(), h = this._getPicks(u, c, d, n), f = (p, m) => {
        var _;
        let b, w;
        if (JT(p) ? (b = p.items, w = p.active) : b = p, b.length === 0) {
          if (m)
            return !1;
          (u.length > 0 || e.hideInput) && (!((_ = this.options) === null || _ === void 0) && _.noResultsPick) && (Cy(this.options.noResultsPick) ? b = [this.options.noResultsPick(u)] : b = [this.options.noResultsPick]);
        }
        return e.items = b, w && (e.activeItems = [w]), !0;
      }, g = (p) => L2(this, void 0, void 0, function* () {
        let m = !1, _ = !1;
        yield Promise.all([
          // Fast Picks: if `mergeDelay` is configured, in order to reduce
          // amount of flicker, we race against the slow picks over some delay
          // and then set the fast picks.
          // If the slow picks are faster, we reduce the flicker by only
          // setting the items once.
          L2(this, void 0, void 0, function* () {
            typeof p.mergeDelay == "number" && (yield Mg(p.mergeDelay), d.isCancellationRequested) || _ || (m = f(
              p.picks,
              !0
              /* skip over empty to reduce flicker */
            ));
          }),
          // Slow Picks: we await the slow picks and then set them at
          // once together with the fast picks, but only if we actually
          // have additional results.
          L2(this, void 0, void 0, function* () {
            e.busy = !0;
            try {
              const b = yield p.additionalPicks;
              if (d.isCancellationRequested)
                return;
              let w, y;
              JT(p.picks) ? (w = p.picks.items, y = p.picks.active) : w = p.picks;
              let S, x;
              if (JT(b) ? (S = b.items, x = b.active) : S = b, S.length > 0 || !m) {
                let D;
                if (!y && !x) {
                  const E = e.activeItems[0];
                  E && w.indexOf(E) !== -1 && (D = E);
                }
                f({
                  items: [...w, ...S],
                  active: y || x || D
                });
              }
            } finally {
              d.isCancellationRequested || (e.busy = !1), _ = !0;
            }
          })
        ]);
      });
      if (h !== null) if (qee(h))
        yield g(h);
      else if (!(h instanceof Promise))
        f(h);
      else {
        e.busy = !0;
        try {
          const p = yield h;
          if (d.isCancellationRequested)
            return;
          qee(p) ? yield g(p) : f(p);
        } finally {
          d.isCancellationRequested || (e.busy = !1);
        }
      }
    });
    return s.add(e.onDidChangeValue(() => l())), l(), s.add(e.onDidAccept((c) => {
      const [d] = e.selectedItems;
      typeof d?.accept == "function" && (c.inBackground || e.hide(), d.accept(e.keyMods, c));
    })), s.add(e.onDidTriggerItemButton(({ button: c, item: d }) => L2(this, void 0, void 0, function* () {
      var u, h;
      if (typeof d.trigger == "function") {
        const f = (h = (u = d.buttons) === null || u === void 0 ? void 0 : u.indexOf(c)) !== null && h !== void 0 ? h : -1;
        if (f >= 0) {
          const g = d.trigger(f, e.keyMods), p = typeof g == "number" ? g : yield g;
          if (t.isCancellationRequested)
            return;
          switch (p) {
            case vv.NO_ACTION:
              break;
            case vv.CLOSE_PICKER:
              e.hide();
              break;
            case vv.REFRESH_PICKER:
              l();
              break;
            case vv.REMOVE_ITEM: {
              const m = e.items.indexOf(d);
              if (m !== -1) {
                const _ = e.items.slice(), b = _.splice(m, 1), w = e.activeItems.filter((S) => S !== b[0]), y = e.keepScrollPosition;
                e.keepScrollPosition = !0, e.items = _, w && (e.activeItems = w), e.keepScrollPosition = y;
              }
              break;
            }
          }
        }
      }
    }))), s;
  }
}
var Bve = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, rm = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, $T = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
}, Gp, Ar;
let y0 = Gp = class extends dat {
  constructor(e, t, n, r, s, o) {
    super(Gp.PREFIX, e), this.instantiationService = t, this.keybindingService = n, this.commandService = r, this.telemetryService = s, this.dialogService = o, this.commandsHistory = this._register(this.instantiationService.createInstance(w0)), this.options = e;
  }
  _getPicks(e, t, n, r) {
    var s, o, a, l;
    return $T(this, void 0, void 0, function* () {
      const c = yield this.getCommandPicks(n);
      if (n.isCancellationRequested)
        return [];
      const d = Ng(() => {
        const _ = new JC();
        _.updateDocuments(c.map((w) => ({
          key: w.commandId,
          textChunks: [w.label + (w.commandAlias ? ` ${w.commandAlias}` : "")]
        })));
        const b = _.calculateScores(e, n);
        return cat(b).filter((w) => w.score > Gp.TFIDF_THRESHOLD).slice(0, Gp.TFIDF_MAX_RESULTS);
      }), u = [];
      for (const _ of c) {
        const b = (s = Gp.WORD_FILTER(e, _.label)) !== null && s !== void 0 ? s : void 0, w = _.commandAlias && (o = Gp.WORD_FILTER(e, _.commandAlias)) !== null && o !== void 0 ? o : void 0;
        if (b || w)
          _.highlights = {
            label: b,
            detail: this.options.showAlias ? w : void 0
          }, u.push(_);
        else if (e === _.commandId)
          u.push(_);
        else if (e.length >= 3) {
          const y = d();
          if (n.isCancellationRequested)
            return [];
          const S = y.find((x) => x.key === _.commandId);
          S && (_.tfIdfScore = S.score, u.push(_));
        }
      }
      const h = /* @__PURE__ */ new Map();
      for (const _ of u) {
        const b = h.get(_.label);
        b ? (_.description = _.commandId, b.description = b.commandId) : h.set(_.label, _);
      }
      u.sort((_, b) => {
        if (_.tfIdfScore && b.tfIdfScore)
          return _.tfIdfScore === b.tfIdfScore ? _.label.localeCompare(b.label) : b.tfIdfScore - _.tfIdfScore;
        if (_.tfIdfScore)
          return 1;
        if (b.tfIdfScore)
          return -1;
        const w = this.commandsHistory.peek(_.commandId), y = this.commandsHistory.peek(b.commandId);
        if (w && y)
          return w > y ? -1 : 1;
        if (w)
          return -1;
        if (y)
          return 1;
        if (this.options.suggestedCommandIds) {
          const S = this.options.suggestedCommandIds.has(_.commandId), x = this.options.suggestedCommandIds.has(b.commandId);
          if (S && x)
            return 0;
          if (S)
            return -1;
          if (x)
            return 1;
        }
        return _.label.localeCompare(b.label);
      });
      const f = [];
      let g = !1, p = !0, m = !!this.options.suggestedCommandIds;
      for (let _ = 0; _ < u.length; _++) {
        const b = u[_];
        _ === 0 && this.commandsHistory.peek(b.commandId) && (f.push({ type: "separator", label: C("recentlyUsed", "recently used") }), g = !0), p && b.tfIdfScore !== void 0 && (f.push({ type: "separator", label: C("suggested", "similar commands") }), p = !1), m && b.tfIdfScore === void 0 && !this.commandsHistory.peek(b.commandId) && (!((a = this.options.suggestedCommandIds) === null || a === void 0) && a.has(b.commandId)) && (f.push({ type: "separator", label: C("commonlyUsed", "commonly used") }), g = !0, m = !1), g && b.tfIdfScore === void 0 && !this.commandsHistory.peek(b.commandId) && !(!((l = this.options.suggestedCommandIds) === null || l === void 0) && l.has(b.commandId)) && (f.push({ type: "separator", label: C("morecCommands", "other commands") }), g = !1), f.push(this.toCommandPick(b, r));
      }
      return this.hasAdditionalCommandPicks(e, n) ? {
        picks: f,
        additionalPicks: $T(this, void 0, void 0, function* () {
          var _;
          const b = yield this.getAdditionalCommandPicks(c, u, e, n);
          if (n.isCancellationRequested)
            return [];
          const w = b.map((y) => this.toCommandPick(y, r));
          return p && ((_ = w[0]) === null || _ === void 0 ? void 0 : _.type) !== "separator" && w.unshift({ type: "separator", label: C("suggested", "similar commands") }), w;
        })
      } : f;
    });
  }
  toCommandPick(e, t) {
    if (e.type === "separator")
      return e;
    const n = this.keybindingService.lookupKeybinding(e.commandId), r = n ? C("commandPickAriaLabelWithKeybinding", "{0}, {1}", e.label, n.getAriaLabel()) : e.label;
    return Object.assign(Object.assign({}, e), { ariaLabel: r, detail: this.options.showAlias && e.commandAlias !== e.label ? e.commandAlias : void 0, keybinding: n, accept: () => $T(this, void 0, void 0, function* () {
      var s, o;
      this.commandsHistory.push(e.commandId), this.telemetryService.publicLog2("workbenchActionExecuted", {
        id: e.commandId,
        from: (s = t?.from) !== null && s !== void 0 ? s : "quick open"
      });
      try {
        !((o = e.args) === null || o === void 0) && o.length ? yield this.commandService.executeCommand(e.commandId, ...e.args) : yield this.commandService.executeCommand(e.commandId);
      } catch (a) {
        md(a) || this.dialogService.error(C("canNotRun", "Command '{0}' resulted in an error", e.label), Fve(a));
      }
    }) });
  }
};
y0.PREFIX = ">";
y0.TFIDF_THRESHOLD = 0.5;
y0.TFIDF_MAX_RESULTS = 5;
y0.WORD_FILTER = Jz(lw, yje, tpe);
y0 = Gp = Bve([
  rm(1, bt),
  rm(2, Bn),
  rm(3, Ui),
  rm(4, qa),
  rm(5, RS)
], y0);
let w0 = Ar = class extends we {
  constructor(e, t) {
    super(), this.storageService = e, this.configurationService = t, this.configuredCommandsHistoryLength = 0, this.updateConfiguration(), this.load(), this.registerListeners();
  }
  registerListeners() {
    this._register(this.configurationService.onDidChangeConfiguration((e) => this.updateConfiguration(e)));
  }
  updateConfiguration(e) {
    e && !e.affectsConfiguration("workbench.commandPalette.history") || (this.configuredCommandsHistoryLength = Ar.getConfiguredCommandHistoryLength(this.configurationService), Ar.cache && Ar.cache.limit !== this.configuredCommandsHistoryLength && (Ar.cache.limit = this.configuredCommandsHistoryLength, Ar.saveState(this.storageService)));
  }
  load() {
    const e = this.storageService.get(
      Ar.PREF_KEY_CACHE,
      0
      /* StorageScope.PROFILE */
    );
    let t;
    if (e)
      try {
        t = JSON.parse(e);
      } catch {
      }
    const n = Ar.cache = new cp(this.configuredCommandsHistoryLength, 1);
    if (t) {
      let r;
      t.usesLRU ? r = t.entries : r = t.entries.sort((s, o) => s.value - o.value), r.forEach((s) => n.set(s.key, s.value));
    }
    Ar.counter = this.storageService.getNumber(Ar.PREF_KEY_COUNTER, 0, Ar.counter);
  }
  push(e) {
    Ar.cache && (Ar.cache.set(e, Ar.counter++), Ar.saveState(this.storageService));
  }
  peek(e) {
    var t;
    return (t = Ar.cache) === null || t === void 0 ? void 0 : t.peek(e);
  }
  static saveState(e) {
    if (!Ar.cache)
      return;
    const t = { usesLRU: !0, entries: [] };
    Ar.cache.forEach((n, r) => t.entries.push({ key: r, value: n })), e.store(
      Ar.PREF_KEY_CACHE,
      JSON.stringify(t),
      0,
      0
      /* StorageTarget.USER */
    ), e.store(
      Ar.PREF_KEY_COUNTER,
      Ar.counter,
      0,
      0
      /* StorageTarget.USER */
    );
  }
  static getConfiguredCommandHistoryLength(e) {
    var t, n;
    const s = (n = (t = e.getValue().workbench) === null || t === void 0 ? void 0 : t.commandPalette) === null || n === void 0 ? void 0 : n.history;
    return typeof s == "number" ? s : Ar.DEFAULT_COMMANDS_HISTORY_LENGTH;
  }
};
w0.DEFAULT_COMMANDS_HISTORY_LENGTH = 50;
w0.PREF_KEY_CACHE = "commandPalette.mru.cache";
w0.PREF_KEY_COUNTER = "commandPalette.mru.counter";
w0.counter = 1;
w0 = Ar = Bve([
  rm(0, mc),
  rm(1, en)
], w0);
class uat extends y0 {
  constructor(e, t, n, r, s, o) {
    super(e, t, n, r, s, o);
  }
  getCodeEditorCommandPicks() {
    const e = this.activeTextEditorControl;
    if (!e)
      return [];
    const t = [];
    for (const n of e.getSupportedActions())
      t.push({
        commandId: n.id,
        commandAlias: n.alias,
        label: rU(n.label) || n.id
      });
    return t;
  }
}
var hat = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, L1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
}, Kee = function(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(n.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? s(d.value) : r(d.value).then(a, l);
    }
    c((n = n.apply(i, e || [])).next());
  });
};
let Xw = class extends uat {
  get activeTextEditorControl() {
    var e;
    return (e = this.codeEditorService.getFocusedCodeEditor()) !== null && e !== void 0 ? e : void 0;
  }
  constructor(e, t, n, r, s, o) {
    super({ showAlias: !1 }, e, n, r, s, o), this.codeEditorService = t;
  }
  getCommandPicks() {
    return Kee(this, void 0, void 0, function* () {
      return this.getCodeEditorCommandPicks();
    });
  }
  hasAdditionalCommandPicks() {
    return !1;
  }
  getAdditionalCommandPicks() {
    return Kee(this, void 0, void 0, function* () {
      return [];
    });
  }
};
Xw = hat([
  L1(0, bt),
  L1(1, Sn),
  L1(2, Bn),
  L1(3, Ui),
  L1(4, qa),
  L1(5, RS)
], Xw);
class ox extends Je {
  constructor() {
    super({
      id: ox.ID,
      label: OL.quickCommandActionLabel,
      alias: "Command Palette",
      precondition: void 0,
      kbOpts: {
        kbExpr: $.focus,
        primary: 59,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      contextMenuOpts: {
        group: "z_commands",
        order: 1
      }
    });
  }
  run(e) {
    e.get(bd).quickAccess.show(Xw.PREFIX);
  }
}
ox.ID = "editor.action.quickCommand";
Be(ox);
Di.as(H0.Quickaccess).registerQuickAccessProvider({
  ctor: Xw,
  prefix: Xw.PREFIX,
  helpEntries: [{ description: OL.quickCommandHelp, commandId: ox.ID }]
});
var fat = function(i, e, t, n) {
  var r = arguments.length, s = r < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(e, t, s) : o(e, t)) || s);
  return r > 3 && s && Object.defineProperty(e, t, s), s;
}, I1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let gW = class extends Zg {
  constructor(e, t, n, r, s, o, a) {
    super(!0, e, t, n, r, s, o, a);
  }
};
gW = fat([
  I1(1, yt),
  I1(2, Sn),
  I1(3, dr),
  I1(4, bt),
  I1(5, mc),
  I1(6, en)
], gW);
pn(
  Zg.ID,
  gW,
  4
  /* EditorContributionInstantiation.Lazy */
);
class gat extends Je {
  constructor() {
    super({
      id: "editor.action.toggleHighContrast",
      label: dB.toggleHighContrast,
      alias: "Toggle High Contrast Theme",
      precondition: void 0
    }), this._originalThemeName = null;
  }
  run(e, t) {
    const n = e.get(Ya), r = n.getColorTheme();
    ed(r.type) ? (n.setTheme(this._originalThemeName || (w_(r.type) ? qv : Ch)), this._originalThemeName = null) : (n.setTheme(w_(r.type) ? km : Tm), this._originalThemeName = r.themeName);
  }
}
Be(gat);
const Vve = () => {
  const [i, e] = Oe(!1);
  return $e(() => {
    J5e().then((t) => {
      e(t.result.superAdmin ?? !1);
    }).catch((t) => {
      Is(t);
    });
  }, []), { isSuperAdmin: i };
}, pat = (i, e) => {
  $e(() => {
    const t = (n) => {
      i?.current && !i.current.contains(n.target) && e();
    };
    return document.addEventListener("click", t), () => {
      document.removeEventListener("click", t);
    };
  }, [i, e]);
};
let eN;
const Yee = () => ({
  width: window.innerWidth,
  height: window.innerHeight
}), Hve = () => {
  const [i, e] = Oe(Yee);
  function t(n) {
    eN && window.cancelAnimationFrame(eN), eN = window.requestAnimationFrame(() => {
      e(Yee());
    });
  }
  return $e(() => (window.addEventListener("resize", t, !1), () => window.removeEventListener("resize", t, !1)), []), i;
}, Jv = 1, mat = {
  PAGE_SIZE: "pageSize",
  PAGE_NUMBER: "pageNumber",
  SEARCH_KEY: "searchKey",
  SORT_BY: "sortBy",
  SORT_ORDER: "sortOrder"
}, { PAGE_SIZE: Xee, PAGE_NUMBER: tN, SEARCH_KEY: Zee, SORT_BY: Qee, SORT_ORDER: Jee } = mat, vat = ({
  initialSortKey: i,
  parseSearchParams: e
} = {}) => {
  const t = E0(), n = ip(), r = new URLSearchParams(t.search), { pageSize: s, pageNumber: o, searchKey: a, sortBy: l, sortOrder: c, parsedParams: d } = Mn(() => {
    const y = r.get(Xee), S = r.get(tN), x = r.get(Zee), D = r.get(Jee), L = r.get(Qee) || i || "", k = Object.values(Xi).includes(D) ? D : Xi.ASC, N = e ? e(r) : {};
    return {
      pageSize: Number(y) || s8,
      pageNumber: Number(S) || Jv,
      searchKey: x || "",
      sortBy: L,
      // sort order should only be applied if the key is available
      sortOrder: L ? k : "",
      parsedParams: N
    };
  }, [r]), u = s * (o - 1), h = (y, S) => {
    r.set(y, String(S)), n.replace({ search: r.toString() });
  }, f = () => {
    if (o !== Jv) {
      h(tN, Jv);
      return;
    }
    n.replace({ search: r.toString() });
  };
  return {
    pageSize: s,
    changePage: (y) => {
      h(tN, y);
    },
    changePageSize: (y) => {
      h(Xee, y), f();
    },
    searchKey: a,
    handleSearch: (y) => {
      h(Zee, y), f();
    },
    offset: u,
    sortBy: l,
    sortOrder: c,
    handleSorting: (y) => {
      let S;
      y === l && c === Xi.ASC ? S = Xi.DESC : S = Xi.ASC, h(Qee, y), h(Jee, S), f();
    },
    clearFilters: () => {
      n.replace({ search: "" });
    },
    ...d,
    updateSearchParams: (y) => {
      Object.keys(y).forEach((S) => {
        Ple.includes(y[S]) ? r.delete(S) : Array.isArray(y[S]) ? (r.delete(S), y[S].forEach((x) => {
          r.append(S, x);
        })) : r.set(S, y[S]);
      }), f();
    }
  };
}, _at = vat, Wve = nf(null), bat = () => x0(Wve), ySt = bat, Cat = ({ children: i }) => {
  const [e, t] = Oe(!0), n = Mn(
    () => ({
      registerShortcut: e,
      setRegisterShortcut: (r) => t(r)
    }),
    [e]
  );
  return /* @__PURE__ */ v.jsx(Wve.Provider, { value: n, children: i });
}, wSt = Cat, jve = ({
  initialSortKey: i
} = {}) => {
  const [e, t] = Oe({
    sortOrder: Xi.ASC,
    sortBy: i
  }), [n, r] = Oe(""), { sortBy: s, sortOrder: o } = e, [a, l] = Oe({
    pageSize: s8,
    pageNumber: Jv
  }), c = a.pageSize * (a.pageNumber - 1), d = () => {
    l((m) => ({
      ...m,
      pageNumber: Jv
    }));
  };
  return {
    ...e,
    handleSorting: (m) => {
      let _;
      m === s && o === Xi.ASC ? _ = Xi.DESC : _ = Xi.ASC, t(() => ({
        ...e,
        sortBy: m,
        sortOrder: _
      })), d();
    },
    searchKey: n,
    handleSearch: (m) => {
      r(m?.trim() ?? ""), d();
    },
    clearFilters: () => {
      r(""), t({
        sortOrder: Xi.ASC,
        sortBy: i
      }), l({
        pageSize: s8,
        pageNumber: Jv
      });
    },
    ...a,
    changePage: (m) => {
      l({
        ...a,
        pageNumber: m
      });
    },
    changePageSize: (m) => {
      l({
        ...a,
        pageSize: m
      }), d();
    },
    offset: c
  };
}, zve = ({
  style: i = {},
  children: e,
  modal: t = !1,
  rootClassName: n = "",
  onClick: r = null,
  callbackRef: s = null,
  preventWheelDisable: o = !1,
  noBackDrop: a
}) => {
  const l = it.useRef(null);
  function c(u) {
    u.stopPropagation(), typeof r == "function" && (l && l.current?.contains(u.target) ? r(u, "in") : r(u, "out"));
  }
  function d(u) {
    o || (l?.current.contains(u.target) ? l.current.clientHeight === l.current.scrollHeight && u.preventDefault() : u.preventDefault());
  }
  return $e(() => {
    document.addEventListener("click", c);
    const u = document.getElementById("visible-modal");
    return u && u.classList.add("show"), a && u.classList.add("no-back-drop"), o || document.body.addEventListener("wheel", d, { passive: !1 }), () => {
      o || document.body.removeEventListener("wheel", d), document.removeEventListener("click", c), u && u.classList.remove("show"), a && u.classList.remove("no-back-drop");
    };
  }, []), Fm.createPortal(
    /* @__PURE__ */ v.jsx(
      "div",
      {
        tabIndex: 0,
        onClick: c,
        "data-testid": "common-modal",
        ref: (u) => {
          typeof s == "function" && s(u), l.current = u;
        },
        id: "popup",
        className: `${n} ${jde} ${t ? "modal" : ""}`,
        style: { ...i },
        children: e
      }
    ),
    document.getElementById("visible-modal")
  );
}, Uve = it.createContext(null);
function Gve() {
  const i = it.useContext(Uve);
  if (!i)
    throw new Error("Select compound components cannot be rendered outside popupmenup");
  return i;
}
const qG = ({
  children: i = null,
  onToggleCallback: e = null,
  autoClose: t = !1,
  autoPosition: n = !1,
  shouldPreventDefault: r = !1
}) => {
  const [s, o] = it.useState(null), [a, l] = it.useState(0), c = it.useRef(null), d = it.useRef(null), u = it.useRef(null);
  it.useEffect(() => (c.current = window.IntersectionObserver ? new IntersectionObserver(f, h) : null, () => {
    c && c.current && c.current.disconnect && c.current.disconnect();
  }), []), $e(() => {
    typeof e == "function" && e(!!s);
  }, [s]), $e(() => {
    if (d?.current && n && s) {
      const { height: b, x: w, y } = d.current.getBoundingClientRect();
      o({ left: w, top: y + b });
    }
  }, [d?.current?.clientHeight]);
  let h = {
    root: null,
    rootMargin: "0px",
    threshold: 1
  };
  if (!i) return i;
  function f(b, w) {
    b.forEach((y) => {
      if (y.isIntersecting && y.intersectionRatio >= 1)
        l(1);
      else {
        const { boundingClientRect: S, rootBounds: x } = y, { x: D, y: E, height: L, width: k } = S, {
          x: N,
          y: I,
          height: A,
          width: P,
          left: O,
          right: K,
          top: W,
          bottom: F
        } = d.current.getBoundingClientRect();
        E + L > x.height && (o({ left: N, bottom: document.documentElement.clientHeight - I }), l(1)), D + k > x.width && (o((q) => ({ ...q, right: "20px", left: "unset" })), l(1));
      }
    });
  }
  const g = (b) => {
    b.stopPropagation(), r && b.preventDefault(), l(0);
    const { height: w, x: y, y: S } = b.currentTarget.getBoundingClientRect();
    o({ left: y, top: S + w });
  }, p = (b, w) => {
    t || w === "out" ? (c && c.current && c.current.disconnect && c.current.disconnect(), l(0), o(null)) : b.stopPropagation();
  };
  function m(b) {
    b && c?.current?.observe ? c.current.observe(b) : c.current.disconnect();
  }
  function _(b) {
    if (!b) return;
    d.current = b;
    const { bottom: w, height: y, left: S, right: x, top: D, width: E, x: L, y: k } = b.getBoundingClientRect();
    u.current = E;
  }
  return /* @__PURE__ */ v.jsx(
    Uve.Provider,
    {
      value: {
        handleOpen: g,
        popupPosition: s,
        handleClose: p,
        opacity: a,
        setPopupPosition: o,
        callbackRef: m,
        buttonRef: d,
        initialiseButtonWidth: _,
        buttonWidth: u
      },
      children: i
    }
  );
}, yat = ({
  children: i = null,
  disabled: e = !1,
  rootClassName: t = "",
  tabIndex: n = 0,
  onHover: r = !1,
  isKebab: s = !1,
  dataTestId: o = ""
}) => {
  const { handleOpen: a, popupPosition: l, buttonRef: c, initialiseButtonWidth: d } = Gve();
  return /* @__PURE__ */ v.jsx(
    "button",
    {
      ref: d,
      type: "button",
      tabIndex: n,
      disabled: e,
      className: `${t} ${l ? "focused" : ""}  ${s ? "popup-button-kebab" : "popup-button"}`,
      onMouseEnter: r ? e ? null : a : () => {
      },
      onClick: e ? null : a,
      "data-testid": o,
      children: i
    }
  );
}, wat = ({
  children: i = null,
  rootClassName: e = "",
  style: t = {},
  autoWidth: n = !1,
  preventWheelDisable: r = !1,
  noBackDrop: s
}) => {
  const { handleClose: o, popupPosition: a, opacity: l, callbackRef: c, buttonWidth: d } = Gve();
  return a ? /* @__PURE__ */ v.jsx(
    zve,
    {
      callbackRef: c,
      onClick: o,
      rootClassName: `${e} popup-body ${i ? "" : "popup-body--empty"} ${Object.keys(
        a
      ).join(" ")}`,
      style: {
        ...a,
        ...t,
        ...n ? { width: d.current } : {},
        opacity: l
      },
      preventWheelDisable: r,
      noBackDrop: s,
      children: i
    }
  ) : null;
};
qG.Button = yat;
qG.Body = wat;
const tc = qG, qve = it.createContext(null);
function ax() {
  const i = it.useContext(qve);
  if (!i)
    throw new Error("Select compound components cannot be rendered outside the Toggle component");
  return i;
}
const X0 = ({
  children: i = null,
  onChange: e,
  value: t = null,
  valueComparator: n,
  rootClassName: r = "",
  disabled: s = !1,
  tabIndex: o = 0,
  name: a = "select",
  autoWidth: l = !0,
  isKebab: c = !1,
  dataTestId: d = ""
}) => {
  const [u, h] = it.useState(t), [f, g] = it.useState(!1), [p, m] = it.useState(""), [_, b] = it.useState(!1);
  useEffectAfterMount(() => {
    u !== t && g(!1);
  }, [u]), useEffectAfterMount(() => {
    h(t);
  }, [t]);
  function w(E, L) {
    h(L), E.target.name = a, E.target.value = L, e(E);
  }
  if (!i) return null;
  const { button: y, body: S, optionLength: x, AsyncComponent: D } = it.Children.toArray(i).reduce(
    (E, L) => (L.type === Xve ? E.button = L : L.type === Zve ? E.AsyncComponent = L : ((L.type === Kve || L.type === Yve) && (E.optionLength += 1), E.body.push(L)), E),
    { button: null, body: [], optionLength: 0, AsyncComponent: null }
  );
  return /* @__PURE__ */ v.jsx(
    qve.Provider,
    {
      value: {
        selected: u,
        select: h,
        popupOpen: f,
        valueComparator: n,
        searchString: p,
        search: m,
        handleClick: w,
        disabled: s,
        loading: _,
        setLoading: b
      },
      children: /* @__PURE__ */ v.jsxs(tc, { onToggleCallback: (E) => g(E), autoClose: f, children: [
        /* @__PURE__ */ v.jsx(
          tc.Button,
          {
            isKebab: c,
            disabled: s,
            tabIndex: o,
            rootClassName: r,
            dataTestId: d,
            children: y
          }
        ),
        f && D,
        /* @__PURE__ */ v.jsx(tc.Body, { rootClassName: `select-popup ${r || ""}`, autoWidth: l, children: _ ? null : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          x === 0 && /* @__PURE__ */ v.jsx("div", { className: `${r} no-option-found flex`, children: "No results found" }),
          S
        ] }) })
      ] })
    }
  );
}, Kve = ({
  dataTestIdMenuList: i,
  children: e,
  value: t,
  disabled: n = !1,
  style: r = {},
  active: s = !1,
  name: o = "",
  rootClassName: a = ""
}) => {
  const { selected: l, searchString: c, valueComparator: d, handleClick: u } = ax();
  return s = s || l === t, typeof t == "object" && (s = s || d(t)), o.includes(c) ? /* @__PURE__ */ v.jsx(
    "div",
    {
      "data-testid": `list-${i}`,
      className: `select__option ${a} ${s ? "selected" : ""}`,
      style: { ...r },
      onClick: (h) => {
        n || (h.persist(), u(h, t));
      },
      children: e
    }
  ) : null;
}, Yve = ({ children: i, label: e, rootClassName: t = "" }) => /* @__PURE__ */ v.jsxs("div", { className: `select__option-group ${t}`, children: [
  /* @__PURE__ */ v.jsx("span", { className: "option-group__label", children: e }),
  i
] }), Xve = ({
  dataTestIdDropdown: i,
  children: e,
  style: t = {},
  rootClassName: n = "",
  arrowAsset: r = "",
  hideArrow: s = !1
}) => {
  const { popupOpen: o, loading: a } = ax();
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      "data-testid": i,
      className: `select-button flex ${n} ${o ? "focused" : ""}`,
      style: { ...t },
      children: [
        e,
        !s && (a ? /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(Progressing, {}) }) : /* @__PURE__ */ v.jsx(
          "img",
          {
            src: r || JLe,
            className: "rotate select-button-sort-image",
            style: { "--rotateBy": o ? "180deg" : "0deg" }
          }
        ))
      ]
    }
  );
}, Sat = ({ placeholder: i = "search", style: e = {}, inputStyle: t = {}, rootClassName: n = "" }) => {
  const { searchString: r, search: s } = ax();
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `${n} search search--select-menu`,
      onClickCapture: (o) => o.stopPropagation(),
      style: { ...e },
      children: [
        /* @__PURE__ */ v.jsx("span", { className: "search__icon", children: /* @__PURE__ */ v.jsx("i", { className: "fa fa-search" }) }),
        /* @__PURE__ */ v.jsx(
          "input",
          {
            autoFocus: !0,
            className: "search__input",
            style: { ...t },
            type: "text",
            placeholder: i,
            value: r,
            onChange: (o) => s(o.target.value)
          }
        )
      ]
    }
  );
}, Zve = ({ api: i }) => {
  const { loading: e, setLoading: t } = ax();
  return $e(() => {
    async function n() {
      t(!0);
      try {
        await i();
      } catch (r) {
        Is(r);
      } finally {
        t(!1);
      }
    }
    n();
  }, []), null;
}, xat = ({ rootClassName: i = "", style: e = {} }) => {
  const { handleClick: t } = ax();
  return /* @__PURE__ */ v.jsx(
    "div",
    {
      className: `select__all ${i}`,
      style: { ...e },
      onClick: (n) => {
        n.persist(), t(n, "all");
      },
      children: "Select All"
    }
  );
};
X0.Button = Xve;
X0.OptGroup = Yve;
X0.Option = Kve;
X0.Search = Sat;
X0.All = xat;
X0.Async = Zve;
const $D = X0, Qve = it.createContext(null);
function Dat() {
  const i = it.useContext(Qve);
  if (!i)
    throw new Error("Radio compound components cannot be rendered outside the Toggle component");
  return i;
}
const Jve = it.memo(
  ({ name: i, onChange: e, children: t, className: n = "", initialTab: r, disabled: s = !1 }) => {
    const [o, a] = Oe(null);
    $e(() => {
      r !== o && a(r);
    }, [r]);
    const l = Mn(
      () => ({ name: i, selected: o, select: a, disabled: s, onChange: e }),
      [i, o, a, s, e]
    );
    return /* @__PURE__ */ v.jsx(Qve.Provider, { value: l, children: /* @__PURE__ */ v.jsx("div", { className: `${n} radio-group`, children: t }) });
  }
), Eat = (i, e, t, n) => /* @__PURE__ */ v.jsx(wn, { className: `default-tt w-250 ${n}`, arrow: !1, placement: t, content: e, children: i }), Lat = ({
  value: i,
  children: e,
  className: t = "",
  showTippy: n = !1,
  tippyContent: r = "",
  tippyPlacement: s = "bottom",
  canSelect: o = !0,
  isDisabled: a = !1,
  tippyClass: l = "",
  dataTestId: c
}) => {
  const { name: d, selected: u, select: h, disabled: f, onChange: g } = Dat();
  return /* @__PURE__ */ v.jsx(
    lc,
    {
      condition: n,
      wrap: (p) => Eat(p, r, s, l),
      children: /* @__PURE__ */ v.jsxs("label", { className: `${t} radio ${a || f ? "disabled" : ""}`, children: [
        /* @__PURE__ */ v.jsx(
          "input",
          {
            type: "checkbox",
            value: i,
            name: d,
            checked: i === u,
            onChange: (p) => {
              p.persist(), o && h(p.target.value), g(p);
            },
            disabled: a || f
          }
        ),
        /* @__PURE__ */ v.jsx("span", { className: "radio__item-label", "data-testid": c, children: e })
      ] })
    }
  );
};
Jve.Radio = Lat;
const $C = Jve, Iat = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#767D84", fillRule: "evenodd", d: "M15.833 6.917a2.5 2.5 0 0 1 2.5 2.5v6.416a2.5 2.5 0 0 1-2.5 2.5H9.417a2.5 2.5 0 0 1-2.5-2.5V9.417a2.5 2.5 0 0 1 2.5-2.5zm0 1.666H9.417a.833.833 0 0 0-.834.834v6.416c0 .46.373.834.834.834h6.416c.46 0 .834-.373.834-.834V9.417a.833.833 0 0 0-.834-.834zM10.75 1.667c1.24 0 2.256.968 2.33 2.19l.003.143v.75a.833.833 0 0 1-1.66.097l-.006-.097V4c0-.34-.255-.62-.583-.661l-.084-.006H4c-.34 0-.62.255-.661.583L3.333 4v6.75c0 .34.255.62.583.661l.084.006h.75a.833.833 0 0 1 .097 1.66l-.097.006H4a2.333 2.333 0 0 1-2.33-2.19l-.003-.143V4c0-1.24.968-2.256 2.19-2.33L4 1.668h6.75z" }));
function J_({
  content: i,
  copiedTippyText: e = "Copied!",
  duration: t = 1e3,
  trigger: n,
  setTrigger: r = El,
  rootClassName: s = "",
  iconSize: o = 16
}) {
  const [a, l] = Oe(!1), [c, d] = Oe(!1), u = () => {
    l(!0);
  }, h = typeof n > "u", f = () => d(!0), g = () => d(!1), p = Wi(
    (_) => {
      _ && Cr(_), b1t(i, u);
    },
    [i]
  ), m = `icon-dim-${o} dc__no-shrink`;
  return $e(() => {
    if (!a) return;
    const _ = setTimeout(() => {
      l(!1), r(!1);
    }, t);
    return () => clearTimeout(_);
  }, [a, t, r]), $e(() => {
    !h && n && (l(!0), p());
  }, [n, p]), /* @__PURE__ */ v.jsx(
    wn,
    {
      className: "default-tt",
      content: a ? e : "Copy",
      placement: "bottom",
      visible: a || c,
      arrow: !1,
      children: /* @__PURE__ */ v.jsx(
        "button",
        {
          type: "button",
          className: `dc__outline-none-imp p-0 flex dc__transparent--unstyled dc__no-border ${s}`,
          onMouseEnter: f,
          onMouseLeave: g,
          onClick: h && p,
          children: a ? /* @__PURE__ */ v.jsx(BA, { className: m }) : /* @__PURE__ */ v.jsx(Iat, { className: m })
        }
      )
    }
  );
}
const Yr = ({ pageLoader: i, size: e, theme: t, styles: n, fillColor: r }) => {
  const s = e ? `${e}px` : i ? "48px" : "20px";
  return /* @__PURE__ */ v.jsx("div", { className: `loader ${t || "default"}-background`, style: n, "data-testid": "progressing", children: /* @__PURE__ */ v.jsx("div", { style: { width: s, height: s }, children: /* @__PURE__ */ v.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: "loader__svg", children: /* @__PURE__ */ v.jsxs("g", { fill: "none", fillRule: "evenodd", strokeLinecap: "round", children: [
    /* @__PURE__ */ v.jsx(
      "animateTransform",
      {
        attributeName: "transform",
        attributeType: "XML",
        dur: "0.5s",
        from: "0 12 12",
        repeatCount: "indefinite",
        to: "360 12 12",
        type: "rotate"
      }
    ),
    /* @__PURE__ */ v.jsx(
      "path",
      {
        fill: r || "#06C",
        fillRule: "nonzero",
        d: "M12 2.5A9.5 9.5 0 1 1 2.5 12a1.5 1.5 0 0 1 3 0A6.5 6.5 0 1 0 12 5.5a1.5 1.5 0 0 1 0-3z"
      }
    )
  ] }) }) }) });
}, SSt = ({
  loadingText: i,
  size: e = 24,
  fullHeight: t = !1,
  styles: n,
  fillColor: r,
  children: s
}) => /* @__PURE__ */ v.jsxs(
  "div",
  {
    className: `details-loader bcn-0 flex column fs-14 fw-6 ${t ? "h-100" : "details-loader-height"}`,
    style: n,
    "data-testid": "details-progressing",
    children: [
      /* @__PURE__ */ v.jsx("span", { style: { width: `${e}px`, height: `${e}px` }, children: /* @__PURE__ */ v.jsx(Yr, { size: e, fillColor: r }) }),
      i && /* @__PURE__ */ v.jsx("span", { className: "mt-10", children: i }),
      s
    ]
  }
);
var _v = /* @__PURE__ */ ((i) => (i.vsDarkDT = "vs-dark--dt", i.deleteDraft = "delete-draft", i.unpublished = "unpublished", i.vs = "vs", i.networkStatusInterface = "network-status-interface", i))(_v || {}), Aat = /* @__PURE__ */ ((i) => (i.reInit = "reInit", i.submitLoading = "submitLoading", i.overrideLoading = "overrideLoading", i.success = "success", i))(Aat || {});
const kat = (i, e) => {
  switch (e.type) {
    case "changeLanguage":
      return { ...i, mode: e.value };
    case "setDiff":
      return { ...i, diffMode: e.value };
    case "setTheme":
      return { ...i, theme: e.value };
    case "setCode":
      return { ...i, code: e.value };
    case "setHeight":
      return { ...i, height: e.value.toString() };
    default:
      return i;
  }
}, Tat = ({
  mode: i,
  theme: e,
  value: t,
  diffView: n,
  noParsing: r
}) => ({
  mode: i,
  theme: e || _v.vs,
  code: t,
  diffMode: n,
  noParsing: [Bm.JSON, Bm.YAML].includes(i) ? r : !0
}), $ve = it.createContext(null);
function Z0() {
  const i = it.useContext($ve);
  if (!i)
    throw new Error("cannot be rendered outside the component");
  return i;
}
const $ee = {
  onChange: null
}, Nat = 100, gf = it.memo(
  ({
    value: i,
    mode: e = Bm.JSON,
    noParsing: t = !1,
    defaultValue: n = "",
    children: r,
    tabSize: s = 2,
    lineDecorationsWidth: o = 0,
    height: a = 450,
    inline: l = !1,
    shebang: c = "",
    onChange: d,
    readOnly: u,
    diffView: h,
    theme: f = "",
    loading: g,
    customLoader: p,
    focus: m,
    validatorSchema: _,
    chartVersion: b,
    isKubernetes: w = !0,
    cleanData: y = !1,
    onBlur: S,
    onFocus: x,
    adjustEditorHeightToContent: D = !1,
    disableSearch: E = !1
  }) => {
    y && (i = mle(i), n = mle(n));
    const L = Nt(null), k = Nt(null), { width: N, height: I } = Hve(), A = it.useCallback(kat, []), [P, O] = Ale(A, Tat({ mode: e, theme: f, value: i, diffView: h, noParsing: t })), [, K, W, F] = ple(P.code, s, P.mode, !P.noParsing), [, q, R] = ple(n, s, P.mode, !P.noParsing), [T, z] = Oe(
      D ? Nat : a
    );
    Wr.defineTheme(_v.vsDarkDT, {
      base: "vs-dark",
      inherit: !0,
      rules: [
        // @ts-ignore
        { background: "#0B0F22" }
      ],
      colors: {
        "editor.background": "#0B0F22"
      }
    }), Wr.defineTheme(_v.networkStatusInterface, {
      base: "vs-dark",
      inherit: !0,
      rules: [
        // @ts-ignore
        { background: "#1A1A1A" }
      ],
      colors: {
        "editor.background": "#1A1A1A"
      }
    }), Wr.defineTheme(_v.deleteDraft, {
      base: "vs",
      inherit: !0,
      rules: [],
      colors: {
        "diffEditor.insertedTextBackground": "#ffd4d1",
        "diffEditor.removedTextBackground": "#ffffff33"
      }
    }), Wr.defineTheme(_v.unpublished, {
      base: "vs",
      inherit: !0,
      rules: [],
      colors: {
        "diffEditor.insertedTextBackground": "#eaf1dd",
        "diffEditor.removedTextBackground": "#ffffff33"
      }
    }), $e(() => {
      const B = E ? Wr.addKeybindingRule({
        command: null,
        keybinding: Ome.KeyF | Mme.CtrlCmd
      }) : null;
      return () => {
        B?.dispose();
      };
    }, [E]);
    const X = (B, ee) => {
      if (e === Bm.YAML && B && typeof B.getModel == "function" && typeof B.getModel().updateOptions == "function" && B.getModel().updateOptions({ tabSize: 2 }), B && (typeof B.onDidFocusEditorWidget == "function" && typeof x == "function" && B.onDidFocusEditorWidget(x), typeof B.onDidBlurEditorWidget == "function" && typeof S == "function" && B.onDidBlurEditorWidget(S)), D && B) {
        if (!("getModifiedEditor" in B)) {
          B.onDidContentSizeChange(() => {
            z(B.getContentHeight());
          }), z(B.getContentHeight());
          return;
        }
        const j = B.getModifiedEditor(), he = B.getOriginalEditor();
        he.onDidContentSizeChange(() => {
          z(
            Math.max(
              typeof T == "number" ? T : Number.MIN_SAFE_INTEGER,
              he.getContentHeight()
            )
          );
        }), j.onDidContentSizeChange(() => {
          z(
            Math.max(
              typeof T == "number" ? T : Number.MIN_SAFE_INTEGER,
              j.getContentHeight()
            )
          );
        }), z(Math.max(j.getContentHeight(), j.getContentHeight()));
      }
      L.current = B, k.current = ee;
    }, ae = Mn(() => D ? T : a, [a, T, D]);
    $e(() => {
      if (!_)
        return;
      const B = uZe(Qo, {
        enableSchemaRequest: !0,
        isKubernetes: w,
        schemas: [
          {
            uri: `https://github.com/devtron-labs/devtron/tree/main/scripts/devtron-reference-helm-charts/reference-chart_${b}/schema.json`,
            // id of the first schema
            fileMatch: ["*"],
            // associate with our model
            schema: _
          }
        ]
      });
      return () => {
        B.dispose();
      };
    }, [_, b]), $e(() => {
      L.current && L.current.updateOptions({ readOnly: u });
    }, [u]), $e(() => {
      L.current && L.current.layout();
    }, [N, I]), $ee.onChange = d;
    const ue = (B) => {
      O({ type: "setCode", value: B }), $ee.onChange?.(B);
    };
    $e(() => {
      if (t) {
        ue(i);
        return;
      }
      let B;
      if (i === P.code)
        return;
      try {
        B = JSON.parse(i);
      } catch {
        try {
          B = hC.parse(i);
        } catch {
        }
      }
      let ee = i;
      B && (ee = P.mode === "json" ? JSON.stringify(B, null, s) : iA(B)), ue(ee);
    }, [i, t]), $e(() => {
      O({ type: "setDiff", value: h });
    }, [h]), $e(() => {
      m && L.current.focus();
    }, [m]);
    function se(B, ee) {
      ue(B);
    }
    function le(B) {
      O({ type: "changeLanguage", value: B }), ue(B === "json" ? K : W);
    }
    const oe = {
      selectOnLineNumbers: !0,
      roundedSelection: !1,
      readOnly: u,
      lineDecorationsWidth: o,
      automaticLayout: !0,
      scrollBeyondLastLine: !1,
      ...D ? {
        overviewRulerLanes: D ? 0 : 1
      } : {},
      minimap: {
        enabled: !1
      },
      scrollbar: {
        alwaysConsumeMouseWheel: !1,
        vertical: l ? "hidden" : "auto",
        ...D ? {
          vertical: "hidden",
          verticalScrollbarSize: 0,
          verticalSliderSize: 0
        } : {}
      },
      lineNumbers(B) {
        return `<span style="padding-right:6px">${B}</span>`;
      }
    }, re = {
      ...oe,
      useInlineViewWhenSpaceIsLimited: !1
    };
    return /* @__PURE__ */ v.jsxs(
      $ve.Provider,
      {
        value: { dispatch: O, state: P, handleLanguageChange: le, error: F, defaultValue: n, height: ae },
        children: [
          r,
          g ? /* @__PURE__ */ v.jsx(jat, { customLoader: p }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            c && /* @__PURE__ */ v.jsx("div", { className: "shebang", children: c }),
            P.diffMode ? /* @__PURE__ */ v.jsx(
              UU,
              {
                original: t ? n : P.mode === "json" ? q : R,
                value: P.code,
                language: P.mode,
                onChange: se,
                options: re,
                theme: P.theme.toLowerCase().split(" ").join("-"),
                editorDidMount: X,
                height: ae,
                width: "100%"
              }
            ) : /* @__PURE__ */ v.jsx(
              GU,
              {
                language: P.mode,
                value: P.code,
                theme: P.theme.toLowerCase().split(" ").join("-"),
                options: oe,
                onChange: se,
                editorDidMount: X,
                height: ae,
                width: "100%"
              }
            )
          ] })
        ]
      }
    );
  }
), Pat = ({
  children: i,
  className: e,
  hideDefaultSplitHeader: t
}) => {
  const { defaultValue: n } = Z0();
  return /* @__PURE__ */ v.jsxs("div", { className: e || "code-editor__header flex right", children: [
    i,
    !t && n && /* @__PURE__ */ v.jsx(Wat, {})
  ] });
}, Oat = ({}) => {
  const { readOnly: i, state: e, dispatch: t } = Z0();
  function n(s) {
    t({ type: "setTheme", value: s.target.value });
  }
  const r = ["vs", "vs-dark"];
  return /* @__PURE__ */ v.jsxs($D, { onChange: n, rootClassName: "select-theme", value: e.theme, disabled: i, children: [
    /* @__PURE__ */ v.jsx($D.Button, { children: /* @__PURE__ */ v.jsx("span", { className: "dc__ellipsis-right", children: e.theme }) }),
    /* @__PURE__ */ v.jsx($D.Search, { placeholder: "select theme" }),
    r.map((s) => /* @__PURE__ */ v.jsx($D.Option, { name: s, value: s, children: /* @__PURE__ */ v.jsx("span", { className: "dc__ellipsis-right", children: s }) }, s))
  ] });
}, Mat = ({}) => {
  const { readOnly: i, handleLanguageChange: e, state: t } = Z0();
  return t.noParsing ? null : /* @__PURE__ */ v.jsx("div", { className: "code-editor__toggle flex left", children: /* @__PURE__ */ v.jsxs(
    $C,
    {
      name: "selectedTab",
      disabled: i,
      initialTab: t.mode,
      className: "flex left",
      onChange: (n) => {
        cA.event({
          category: "JSON-YAML Switch",
          action: `${n.target.value} view`
        }), e(n.target.value);
      },
      children: [
        /* @__PURE__ */ v.jsx($C.Radio, { value: "json", children: "JSON" }),
        /* @__PURE__ */ v.jsx($C.Radio, { value: "yaml", children: "YAML" })
      ]
    }
  ) });
}, Rat = () => {
  const { error: i } = Z0();
  return i ? /* @__PURE__ */ v.jsx("div", { className: "form__error", children: i }) : null;
}, Fat = (i) => /* @__PURE__ */ v.jsxs("div", { className: `code-editor__warning ${i.className || ""}`, children: [
  /* @__PURE__ */ v.jsx(rc, { className: "code-editor__information-info-icon" }),
  i.text,
  i.children
] }), Bat = (i) => /* @__PURE__ */ v.jsxs("div", { className: `code-editor__error ${i.className || ""}`, children: [
  /* @__PURE__ */ v.jsx(A0, { className: "code-editor__information-info-icon" }),
  i.text,
  i.children
] }), Vat = (i) => /* @__PURE__ */ v.jsxs("div", { className: `code-editor__information ${i.className || ""}`, children: [
  /* @__PURE__ */ v.jsx(mS, { className: "code-editor__information-info-icon" }),
  i.text,
  i.children
] }), Hat = () => {
  const { state: i } = Z0();
  return /* @__PURE__ */ v.jsx(J_, { content: i.code, rootClassName: "bcn-1", iconSize: 20 });
}, Wat = ({}) => {
  const { state: i, dispatch: e, readOnly: t } = Z0();
  function n(r) {
    t || e({ type: "setDiff", value: !i.diffMode });
  }
  return /* @__PURE__ */ v.jsxs("div", { className: "code-editor__split-pane flex pointer", onClick: n, children: [
    /* @__PURE__ */ v.jsx("div", { className: "diff-icon" }),
    i.diffMode ? "Hide comparison" : "Compare with default"
  ] });
}, jat = ({ className: i = "", style: e = {}, customLoader: t }) => {
  const { height: n } = Z0();
  return t || /* @__PURE__ */ v.jsx("div", { className: `code-editor code-editor--placeholder disabled ${i}`, style: { ...e }, children: /* @__PURE__ */ v.jsx("div", { className: "flex", style: { height: n || "100%" }, children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(Yr, { pageLoader: !0 }) }) }) });
};
gf.LanguageChanger = Mat;
gf.ThemeChanger = Oat;
gf.ValidationError = Rat;
gf.Clipboard = Hat;
gf.Header = Pat;
gf.Warning = Fat;
gf.ErrorBar = Bat;
gf.Information = Vat;
const e_e = gf, zat = (i) => /* @__PURE__ */ G.createElement("svg", { width: 18, height: 14, viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("g", { id: "Group 1513" }, /* @__PURE__ */ G.createElement("path", { id: "Vector", d: "M5.66663 1.72336C5.22218 1.61225 4.26663 1.59002 3.99996 2.39002C3.66663 3.39002 3.33329 5.66699 2.99996 6.33366C2.66663 7.00033 2.33329 6.94397 1.66663 7.00033C2.33329 7.05668 2.66663 7.00033 2.99996 7.66699C3.33329 8.33366 3.66663 10.6106 3.99996 11.6106C4.26663 12.4106 5.22218 12.3884 5.66663 12.2773", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { id: "Vector_2", d: "M12.3333 1.72336C12.7777 1.61225 13.7333 1.59002 13.9999 2.39002C14.3333 3.39002 14.6666 5.66699 14.9999 6.33366C15.3333 7.00033 15.6666 6.94397 16.3333 7.00033C15.6666 7.05668 15.3333 7.00033 14.9999 7.66699C14.6666 8.33366 14.3333 10.6106 13.9999 11.6106C13.7333 12.4106 12.7777 12.3884 12.3333 12.2773", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { id: "Vector_3", d: "M8.99996 5C6.61901 5 5.66663 7.00022 5.66663 7.00022C5.66663 7.00022 6.61901 9 8.99996 9C11.3809 9 12.3333 7.00022 12.3333 7.00022C12.3333 7.00022 11.3809 5 8.99996 5Z", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { id: "Vector_4", d: "M8.99992 7.66732C9.36811 7.66732 9.66659 7.36884 9.66659 7.00065C9.66659 6.63246 9.36811 6.33398 8.99992 6.33398C8.63173 6.33398 8.33325 6.63246 8.33325 7.00065C8.33325 7.36884 8.63173 7.66732 8.99992 7.66732Z", fill: "white" }))), Uat = ({
  currentConfiguration: i,
  baseTemplateConfiguration: e,
  previousConfigAvailable: t,
  isUnpublished: n,
  isDeleteDraft: r,
  rootClassName: s,
  comparisonBodyClassName: o,
  sortOrder: a = null
}) => {
  const { historyComponent: l, historyComponentName: c } = eo(), [d, u] = Oe(!1), h = () => r ? "delete-draft" : n ? "unpublished" : null, f = Object.keys(e?.codeEditorValue?.variableSnapshot || {}).length !== 0 || Object.keys(i?.codeEditorValue?.variableSnapshot || {}).length !== 0, g = Mn(() => {
    if (!e?.codeEditorValue?.value || r)
      return "";
    const y = d ? e?.codeEditorValue?.resolvedValue : e?.codeEditorValue?.value;
    return iA(JSON.parse(y), {
      sortMapEntries: (S, x) => Y8(S, x, a)
    });
  }, [d, e, a, r]), p = Mn(() => {
    if (!i?.codeEditorValue?.value || n)
      return "";
    const y = d ? i?.codeEditorValue?.resolvedValue : i?.codeEditorValue?.value;
    return iA(JSON.parse(y), {
      sortMapEntries: (S, x) => Y8(S, x, a)
    });
  }, [d, i, a, n]), m = () => /* @__PURE__ */ v.jsx(
    e_e,
    {
      value: g,
      defaultValue: p,
      adjustEditorHeightToContent: !0,
      disableSearch: !0,
      diffView: t && !0,
      readOnly: !0,
      noParsing: !0,
      mode: Bm.YAML,
      theme: h()
    }
  ), _ = () => {
    u(!d);
  }, b = d ? "Hide variables values" : "Show variables values", w = (y, S, x) => /* @__PURE__ */ v.jsxs("div", { className: y, children: [
    /* @__PURE__ */ v.jsx("div", { className: "cn-6 pt-8 pl-16 pr-16 lh-16", "data-testid": x, children: S.displayName }),
    /* @__PURE__ */ v.jsx("div", { className: "cn-9 fs-13 pb-8 pl-16 pr-16 lh-20 mh-28", children: S.value })
  ] });
  return /* @__PURE__ */ v.jsxs("div", { className: "deployment-history-diff-view", children: [
    !t && /* @__PURE__ */ v.jsxs("div", { className: "bcb-1 eb-2 pt-8 pb-8 br-4 flexbox pl-4 cn-9 fs-13 mt-16 mb-16 mr-20 ml-20", children: [
      /* @__PURE__ */ v.jsx(mS, { className: "mr-8 ml-14 icon-dim-20" }),
      /* @__PURE__ */ v.jsxs("span", { className: "lh-20", children: [
        Xo[l.replace("-", "_").toUpperCase()]?.DISPLAY_NAME,
        c ? ` “${c}”` : "",
        " was added in this deployment. There is no previous instance to compare with."
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: `en-2 bw-1 br-4 bcn-0 mt-16 mb-16 mr-20 ml-20 pt-2 pb-2 ${t ? "deployment-diff__upper" : ""} ${s ?? ""}`,
        "data-testid": `configuration-link-${t ? "previous-deployment" : "no-previous-deployment"}`,
        children: e && Object.keys({ ...i?.values, ...e.values }).map(
          (y, S) => {
            const x = i?.values?.[y], D = e.values[y], E = t && x?.value !== D?.value;
            return (
              // eslint-disable-next-line react/no-array-index-key
              /* @__PURE__ */ v.jsxs(qh, { children: [
                !n && x?.value ? w(
                  !r && E ? "code-editor-red-diff" : "",
                  x,
                  `configuration-deployment-template-heading-${S}`
                ) : /* @__PURE__ */ v.jsx("div", {}),
                !r && D?.value ? w(
                  E ? "code-editor-green-diff" : "",
                  D,
                  `configuration-deployment-template-heading-${S}`
                ) : /* @__PURE__ */ v.jsx("div", { className: r ? "code-editor-red-diff" : "" })
              ] }, `deployment-history-diff-view-${S}`)
            );
          }
        )
      }
    ),
    (i?.codeEditorValue?.value || e?.codeEditorValue?.value) && /* @__PURE__ */ v.jsxs("div", { className: `en-2 bw-1 br-4 mr-20 ml-20 mb-20 ${o || ""}`, children: [
      /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: "code-editor-header-value pl-16 pr-16 pt-12 pb-12 fs-13 fw-6 cn-9 bcn-0 dc__top-radius-4 dc__border-bottom",
          "data-testid": "configuration-link-comparison-body-heading",
          children: [
            /* @__PURE__ */ v.jsx("span", { children: e?.codeEditorValue?.displayName }),
            f && /* @__PURE__ */ v.jsx(wn, { content: b, placement: "bottom-start", animation: "shift-away", arrow: !1, children: /* @__PURE__ */ v.jsx("li", { className: "flex left dc_width-max-content cursor", children: /* @__PURE__ */ v.jsx("div", { className: "w-40 h-20", children: /* @__PURE__ */ v.jsx(
              bCe,
              {
                selected: d,
                color: "var(--B500)",
                onSelect: _,
                Icon: zat
              }
            ) }) }) })
          ]
        }
      ),
      m()
    ] })
  ] });
}, t_e = Uat, Gat = ({
  deploymentHistoryList: i,
  setDeploymentHistoryList: e
}) => {
  const t = fd(), { appId: n, pipelineId: r, triggerId: s } = eo();
  $e(() => {
    i || Due(n, r, s).then((a) => {
      e(a.result);
    });
  }, [i]);
  const o = (a, l, c, d) => {
    const u = Xo[l], h = d ? `/${d}` : "", f = `${t.url.split(sr.DEPLOYMENT_HISTORY_CONFIGURATIONS)[0]}${sr.DEPLOYMENT_HISTORY_CONFIGURATIONS}/${u.VALUE}/${a}${h}`;
    return /* @__PURE__ */ v.jsx("div", { className: "cursor", children: /* @__PURE__ */ v.jsx(
      uo,
      {
        to: f,
        activeClassName: "active",
        className: "historical-name dc__inline-block dc__no-decor pt-12 pb-12 pl-16 pr-12 fs-13 cn-9 configuration-link w-280",
        children: u.DISPLAY_NAME + h
      }
    ) }, c);
  };
  return /* @__PURE__ */ v.jsx("div", { className: "pt-8 pb-8 bcn-0 dc__border-right h-100", children: i?.map(
    (a, l) => a.childList?.length > 0 ? a.childList.map(
      (c, d) => o(
        a.id,
        a.name,
        `config-${l}-${d}`,
        c
      )
    ) : o(a.id, a.name, `config-${l}`)
  ) });
}, qat = ({
  setFullScreenView: i,
  deploymentHistoryList: e,
  setDeploymentHistoryList: t,
  renderRunSource: n,
  resourceId: r
}) => {
  const { appId: s, pipelineId: o, historyComponent: a, baseConfigurationId: l, historyComponentName: c } = eo(), [d, u] = Oe(), [h, f] = Oe(), [g, p] = Oe(), [m, _] = Oe(!0), [b, w] = Oe(!0);
  return $e(() => {
    if (d)
      if (w(!0), d.value === "NA")
        w(!1);
      else
        try {
          BY(
            s,
            o,
            d.value,
            a,
            c
          ).then((y) => {
            f(my(y.result, a)), w(!1);
          });
        } catch (y) {
          Is(y), w(!1);
        }
  }, [d]), $e(() => {
    try {
      w(!0), u(null), f(null), BY(
        s,
        o,
        l,
        a,
        c
      ).then((y) => {
        p(my(y.result, a));
      });
    } catch (y) {
      Is(y), w(!1);
    }
  }, [l, a, c]), $e(() => (i(!0), () => {
    i(!1);
  }), []), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      u6e,
      {
        selectedDeploymentTemplate: d,
        setSelectedDeploymentTemplate: u,
        setFullScreenView: i,
        setLoader: w,
        setPreviousConfigAvailable: _,
        renderRunSource: n,
        resourceId: r
      }
    ),
    /* @__PURE__ */ v.jsxs("div", { className: "historical-diff__container bcn-1", children: [
      /* @__PURE__ */ v.jsx(
        Gat,
        {
          deploymentHistoryList: e,
          setDeploymentHistoryList: t
        }
      ),
      b ? /* @__PURE__ */ v.jsx(Yr, { pageLoader: !0 }) : /* @__PURE__ */ v.jsx("div", { className: "dc__overflow-scroll", children: /* @__PURE__ */ v.jsx(
        t_e,
        {
          currentConfiguration: h,
          baseTemplateConfiguration: g,
          previousConfigAvailable: m
        }
      ) })
    ] })
  ] });
}, Kat = qat, Yat = ({
  setFullScreenView: i,
  deploymentHistoryList: e,
  setDeploymentHistoryList: t
}) => {
  const n = fd(), { appId: r, pipelineId: s, triggerId: o } = eo(), [a, l] = Oe(!1);
  $e(() => {
    l(!0), Due(r, s, o).then((d) => {
      t(d.result), l(!1);
    });
  }, [o]);
  const c = (d, u, h, f, g) => {
    const p = Xo[h], m = `${n.url}/${p.VALUE}/${u}${g ? `/${g}` : ""}`;
    return /* @__PURE__ */ v.jsxs(
      uo,
      {
        to: m,
        activeClassName: "active",
        onClick: () => {
          i(!1);
        },
        "data-testid": `configuration-link-option-${d}`,
        className: "bcb-1 dc__no-decor bcn-0 cn-9 pl-16 pr-16 pt-12 pb-12 br-4 en-2 bw-1 flex dc__content-space cursor lh-20",
        children: [
          g || p.DISPLAY_NAME,
          /* @__PURE__ */ v.jsx(vu, { className: "icon-dim-20 fcn-6 dc__flip-270" })
        ]
      },
      f
    );
  };
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ v.jsx(v.Fragment, { children: !e && !a ? /* @__PURE__ */ v.jsx(
      oa,
      {
        title: jr.DATA_NOT_AVAILABLE,
        subTitle: jr.DEPLOYMENT_HISTORY_CONFIG_LIST.SUBTITLE
      }
    ) : a ? /* @__PURE__ */ v.jsx(Yr, { pageLoader: !0 }) : e && e.map((d, u) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ v.jsx("div", { className: "px-20 pt-20 fs-13 cn-9 flexbox-col dc__gap-12", children: d.childList?.length > 0 ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx("div", { className: "fs-14 fw-6", children: Xo[d.name].DISPLAY_NAME }),
        d.childList.map(
          (h, f) => c(
            u,
            d.id,
            d.name,
            `config-${u}-${f}`,
            h
          )
        )
      ] }) : c(u, d.id, d.name, `config-${u}`) }, `history-list__${u}`)
    )) })
  );
}, Xat = Yat, ete = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("g", { id: "Radio" }, /* @__PURE__ */ G.createElement("g", { id: "outer border" }, /* @__PURE__ */ G.createElement("rect", { x: 1.66663, y: 1.66699, width: 16.6667, height: 16.6667, rx: 8.33333, fill: "white" }), /* @__PURE__ */ G.createElement("rect", { x: 1.66663, y: 1.66699, width: 16.6667, height: 16.6667, rx: 8.33333, stroke: "#ABCFF3" })), /* @__PURE__ */ G.createElement("rect", { id: "inner border", x: 2.41663, y: 2.41699, width: 15.1667, height: 15.1667, rx: 7.58333, fill: "white", stroke: "#959BA1", strokeWidth: 1.5 }))), nN = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ G.createElement("path", { stroke: "#06C", className: "stroke-color", strokeLinecap: "round", strokeWidth: 2, d: "M3.6 12h5.397M15 12h5.4" }), /* @__PURE__ */ G.createElement("circle", { cx: 12, cy: 12, r: 3, stroke: "#06C", className: "stroke-color", strokeWidth: 2 }))), tte = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { d: "M0 0H16V16H0z" }), /* @__PURE__ */ G.createElement("path", { fill: "#596168", d: "M8 .667c4.05 0 7.333 3.283 7.333 7.333 0 4.05-3.283 7.333-7.333 7.333C3.95 15.333.667 12.05.667 8 .667 3.95 3.95.667 8 .667zm0 10c-1.539 0-2.945.75-3.808 1.968C5.228 13.49 6.554 14 8 14c1.446 0 2.772-.512 3.808-1.363-.862-1.219-2.269-1.97-3.808-1.97zM8 2C4.686 2 2 4.686 2 8c0 1.38.466 2.652 1.25 3.666C4.37 10.218 6.107 9.333 8 9.333c1.894 0 3.632.886 4.75 2.333C13.534 10.652 14 9.381 14 8c0-3.314-2.686-6-6-6zm0 1.333c1.473 0 2.667 1.194 2.667 2.667 0 1.473-1.194 2.667-2.667 2.667-1.473 0-2.667-1.194-2.667-2.667 0-1.473 1.194-2.667 2.667-2.667zm0 1.334c-.736 0-1.333.597-1.333 1.333S7.264 7.333 8 7.333 9.333 6.736 9.333 6 8.736 4.667 8 4.667z" }))), pW = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#596168", fillRule: "evenodd", d: "M10.667.667c.342 0 .623.257.662.589l.004.077V2h1.334c1.054 0 1.918.816 1.994 1.85l.006.15v9.333c0 1.105-.896 2-2 2H3.333c-1.104 0-2-.895-2-2V4c0-1.105.896-2 2-2h1.333v-.667c0-.368.3-.666.667-.666.342 0 .624.257.663.589L6 1.333V2h4v-.667c0-.368.298-.666.667-.666zm2.666 6.666H2.666v6c0 .335.247.612.569.66l.098.007h9.334c.368 0 .666-.298.666-.667v-6zm-8.667-4H3.333c-.368 0-.666.299-.666.667v2h10.666V4c0-.335-.246-.612-.568-.66l-.098-.007h-1.335l.001.667c0 .368-.298.667-.666.667-.342 0-.624-.258-.663-.59L10 4v-.667H6V4c0 .368-.298.667-.667.667-.342 0-.623-.258-.662-.59L4.667 4v-.667z" })), Zat = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#596168", fillRule: "evenodd", d: "M12.444 1.778c.982 0 1.778.796 1.778 1.778v6.11c0 .983-.796 1.778-1.778 1.778H7.72l-2.582 2.583c-.402.402-1.076.147-1.134-.396L4 13.556v-2.112h-.444c-.945 0-1.717-.735-1.775-1.665l-.003-.112V3.556c0-.982.796-1.778 1.778-1.778zm0 1.333H3.556c-.246 0-.445.2-.445.445v6.11c0 .246.2.445.445.445h1.11c.369 0 .667.299.667.667v1.167l1.64-1.639c.104-.104.24-.17.384-.19l.087-.005h5c.246 0 .445-.199.445-.444V3.556c0-.246-.2-.445-.445-.445zM8 7.056c.368 0 .667.298.667.666 0 .342-.258.624-.59.662L8 8.39H5.222c-.368 0-.666-.299-.666-.667 0-.342.257-.623.588-.662l.078-.004H8zm2.778-2.223c.368 0 .666.299.666.667 0 .342-.257.624-.588.662l-.078.005H5.222c-.368 0-.666-.299-.666-.667 0-.342.257-.624.588-.662l.078-.005h5.556z" })), Qat = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 36, viewBox: "0 0 18 36", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("g", { fillRule: "nonzero" }, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("g", null, /* @__PURE__ */ G.createElement("path", { fill: "#979797", d: "M4 0C1.79 0 0 1.79 0 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 2c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z", transform: "translate(-379.000000, -356.000000) translate(364.000000, 276.000000) translate(15.000000, 74.000000) translate(0.000000, 6.000000)" }), /* @__PURE__ */ G.createElement("path", { fill: "#06C", d: "M14 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 2c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z", transform: "translate(-379.000000, -356.000000) translate(364.000000, 276.000000) translate(15.000000, 74.000000) translate(0.000000, 6.000000)" }), /* @__PURE__ */ G.createElement("path", { fill: "#979797", d: "M5 7v9c0 2.142 1.684 3.891 3.8 3.995L9 20c3.238 0 5.878 2.566 5.996 5.775L15 26v3h-2v-3c0-2.142-1.684-3.891-3.8-3.995L9 22c-3.238 0-5.878-2.566-5.996-5.775L3 16V7h2z", transform: "translate(-379.000000, -356.000000) translate(364.000000, 276.000000) translate(15.000000, 74.000000) translate(0.000000, 6.000000)" }), /* @__PURE__ */ G.createElement("path", { fill: "#06C", d: "M15 7L15 29 13 29 13 7z", transform: "translate(-379.000000, -356.000000) translate(364.000000, 276.000000) translate(15.000000, 74.000000) translate(0.000000, 6.000000)" }), /* @__PURE__ */ G.createElement("path", { fill: "#06C", d: "M14 28c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 2c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z", transform: "translate(-379.000000, -356.000000) translate(364.000000, 276.000000) translate(15.000000, 74.000000) translate(0.000000, 6.000000)" }))))))), iN = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...i }, /* @__PURE__ */ G.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ G.createElement("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ G.createElement("g", { transform: "translate(2 2)" }, /* @__PURE__ */ G.createElement("rect", { width: 20, height: 20, fill: "#06c", rx: 10 }), /* @__PURE__ */ G.createElement("path", { stroke: "#FFF", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M5.757 10.414l2.829 2.829 5.657-5.657" }))));
function Jat(i) {
  for (const e of ["github", "gitlab", "bitbucket"])
    if (i.includes(e))
      return `${e}`;
  return "git";
}
const $at = ({
  index: i,
  repoUrl: e = "",
  materialType: t = "",
  materialValue: n = "",
  style: r = {},
  ...s
}) => {
  e = e.replace(".git", "");
  const o = e.split("/"), { length: a, [a - 1]: l } = o;
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      ...s,
      className: "git-commit-info-generic__header px-16 py-12 dc__box-shadow fs-12 fw-6 dc__gap-4",
      style: r,
      children: [
        /* @__PURE__ */ v.jsx("div", { className: Jat(e) }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex left left dc__gap-4 fs-13", children: [
          /* @__PURE__ */ v.jsx(
            "div",
            {
              className: "repo cn-9 fw-6 dc__mxw-250 dc__ellipsis-right",
              "data-testid": `deployment-history-source-code-repo${i}`,
              children: l
            }
          ),
          /* @__PURE__ */ v.jsxs("div", { className: "branch flex left cn-7 dc__gap-4", children: [
            /* @__PURE__ */ v.jsx("span", { children: "/" }),
            /* @__PURE__ */ v.jsx(_ue, { sourceType: t, sourceValue: n, showTooltip: !0 })
          ] })
        ] })
      ]
    }
  );
}, e3 = {
  MERGED: "merged",
  NON_MERGED: "non-merged"
}, elt = ({
  materialSourceType: i,
  materialSourceValue: e,
  commitInfo: t,
  selectedCommitInfo: n,
  materialUrl: r,
  showMaterialInfoHeader: s,
  canTriggerBuild: o = !1,
  index: a,
  isExcluded: l = !1
}) => {
  const [c, d] = Oe(!0);
  function u(x) {
    const D = {};
    return x && Object.keys(x).forEach((E) => {
      const L = E.toLowerCase(), k = x[E];
      k && typeof k == "object" ? D[L] = u(k) : D[L] = k;
    }), D;
  }
  const h = u(t), f = i === Ag.WEBHOOK || h && h.webhookdata && h.webhookdata.id !== 0, g = f ? h.webhookdata : {}, p = f ? null : h.commiturl ? h.commiturl : wm(r, h.commit);
  function m() {
    let x;
    if (g.data.date) {
      const D = st(g.data.date, "YYYY-MM-DDTHH:mm:ssZ");
      x = D.isValid() ? D.format(id.TWELVE_HOURS_FORMAT) : g.data.date;
    }
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      g.data.author ? /* @__PURE__ */ v.jsxs("div", { className: "material-history__text lh-20 flex left dc__gap-8", children: [
        /* @__PURE__ */ v.jsx(tte, { className: "icon-dim-16" }),
        " ",
        g.data.author
      ] }) : null,
      x ? /* @__PURE__ */ v.jsxs("div", { className: "material-history__text lh-20 flex left dc__gap-8", children: [
        /* @__PURE__ */ v.jsx(pW, { className: "icon-dim-16" }),
        /* @__PURE__ */ v.jsx("time", { className: "cn-7 fs-12", children: x })
      ] }) : null,
      g.data.message ? /* @__PURE__ */ v.jsxs("div", { className: "material-history__text lh-20 flex left dc__gap-8 top material-history-text--padded", children: [
        /* @__PURE__ */ v.jsx(Zat, { className: "icon-dim-16 mw-16 mr-8 mt-2" }),
        g.data.message
      ] }) : null
    ] });
  }
  function _(x) {
    return c ? null : /* @__PURE__ */ v.jsx("div", { className: "material-history__all-changes", children: /* @__PURE__ */ v.jsx("div", { className: "material-history__body mt-4", children: Object.keys(x).map((D, E) => {
      let L;
      return E % 2 == 0 && (L = "bcn-1"), /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: `material-history__text material-history__grid left pt-4 pb-4 ${L}`,
          children: [
            /* @__PURE__ */ v.jsx("div", { children: D }),
            /* @__PURE__ */ v.jsx("div", { children: x[D] })
          ]
        },
        D
      );
    }) }) });
  }
  function b() {
    return /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        className: "fs-12 fw-6 pt-12 mt-12 pl-12 pr-12 w-100 bcn-0 flex left br-4 dc__box-shadow-top cb-5 dc__no-border",
        onClick: (x) => {
          x.stopPropagation(), d(!c);
        },
        children: c ? "See More" : "See Less"
      }
    );
  }
  function w() {
    const x = {};
    g.eventactiontype === e3.MERGED ? Object.keys(g.data).forEach((E) => {
      E != "author" && E != "date" && E != "git url" && E != "source branch name" && E != "source checkout" && E != "target branch name" && E != "target checkout" && E != "title" && (x[E] = g.data[E]);
    }) : g.eventactiontype === e3.NON_MERGED && Object.keys(g.data).forEach((E) => {
      E !== "author" && E !== "date" && E !== "target checkout" && (x[E] = g.data[E]);
    });
    const D = Object.keys(x).length > 0;
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      D && _(x),
      D && b()
    ] });
  }
  const y = () => l ? /* @__PURE__ */ v.jsx(
    wn,
    {
      className: "default-tt w-200 dc__align-left fw-4 fs-12 dc__no-text-transform",
      arrow: !1,
      placement: "bottom",
      content: LIe,
      interactive: !0,
      children: /* @__PURE__ */ v.jsxs(
        "span",
        {
          "data-testid": "excluded-git-commit",
          className: "dc_max-width__max-content flex left cr-5 cursor-not-allowed dc__uppercase",
          children: [
            /* @__PURE__ */ v.jsx(Kde, { className: "mr-4 fcr-5" }),
            "Excluded"
          ]
        }
      )
    }
  ) : /* @__PURE__ */ v.jsx(ete, { "data-testid": "valid-git-commit" }), S = () => h.isselected ? /* @__PURE__ */ v.jsx(iN, { "data-testid": "selected-git-commit", className: "dc__align-right icon-dim-20" }) : y();
  return /* @__PURE__ */ v.jsxs("div", { className: "git-commit-info-generic__wrapper cn-9 fs-12", children: [
    s && (f || h.commit) && /* @__PURE__ */ v.jsx(
      $at,
      {
        index: a,
        repoUrl: r,
        materialType: i,
        materialValue: e
      }
    ),
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col left dc__gap-8 p-16", children: [
      !f && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h.commit && /* @__PURE__ */ v.jsxs("div", { className: "flex dc__content-space", children: [
          p ? /* @__PURE__ */ v.jsxs("div", { className: "flex dc__gap-8", children: [
            /* @__PURE__ */ v.jsx(
              "a",
              {
                href: p,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "commit-hash",
                onClick: Cr,
                "data-testid": `deployment-history-source-code-material-history${a}`,
                children: /* @__PURE__ */ v.jsxs(
                  "div",
                  {
                    className: "material-history__header flex dc__gap-4",
                    "data-testid": `git-commit-credential${a}`,
                    children: [
                      /* @__PURE__ */ v.jsx(nN, { className: "commit-hash__icon mr-0" }),
                      h.commit.slice(0, 7)
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ v.jsx(
              "span",
              {
                className: "git-commit-info-generic__copy dc__visibility-hidden p-2",
                "data-testid": "git-commit-copy",
                children: /* @__PURE__ */ v.jsx(J_, { content: h.commit })
              }
            )
          ] }) : null,
          n ? S() : null
        ] }),
        h.message ? /* @__PURE__ */ v.jsx(
          "div",
          {
            "data-testid": `${h.message.trim()}-${l ? "excluded" : "included"}`,
            className: "material-history__text lh-20 flex left dc__gap-8 top material-history-text--padded dc__word-break-all",
            children: /* @__PURE__ */ v.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9  dc__truncate--clamp-3", children: h.message })
          }
        ) : null,
        /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
          h.author ? /* @__PURE__ */ v.jsxs("div", { className: "material-history__text lh-20 flex left dc__gap-8", children: [
            /* @__PURE__ */ v.jsx(tte, { className: "icon-dim-16" }),
            /* @__PURE__ */ v.jsxs("span", { className: "lh-20", children: [
              " ",
              h.author
            ] })
          ] }) : null,
          h.date ? /* @__PURE__ */ v.jsxs("div", { className: "material-history__text lh-20 flex left dc__gap-8", children: [
            /* @__PURE__ */ v.jsx(pW, { className: "icon-dim-16" }),
            /* @__PURE__ */ v.jsx("span", { className: "lh-20", children: st(h.date).format(
              id.TWELVE_HOURS_FORMAT
            ) })
          ] }) : null
        ] })
      ] }),
      f && g.eventactiontype === e3.MERGED && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsxs("div", { className: "flex dc__content-space pr-16 ", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "ml-16 ", children: [
            g.data.title ? /* @__PURE__ */ v.jsx("div", { className: "flex left cn-9  fs-13", children: g.data.title }) : null,
            g.data["git url"] ? /* @__PURE__ */ v.jsx(
              "a",
              {
                href: `${g.data["git url"]}`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "dc__no-decor cb-5",
                children: "View git url"
              }
            ) : null
          ] }),
          n ? /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__align-items-center dc__content-end fs-12", children: h.isselected ? /* @__PURE__ */ v.jsx(iN, { className: "dc__align-right" }) : /* @__PURE__ */ v.jsx(ete, { "data-testid": "valid-git-commit" }) }) : null
        ] }),
        /* @__PURE__ */ v.jsx("div", { className: "material-history__header ml-6 mt-12 mb-12", children: /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
          /* @__PURE__ */ v.jsx(Qat, { className: "icon-dim-32" }),
          /* @__PURE__ */ v.jsxs("div", { children: [
            /* @__PURE__ */ v.jsxs("div", { className: "flex left mb-8", children: [
              g.data["source branch name"] ? /* @__PURE__ */ v.jsxs("div", { className: " mono cn-7 fs-12 lh-1-5 br-4 bcn-1 pl-6 pr-6", children: [
                /* @__PURE__ */ v.jsx(DY, { className: "icon-dim-12 dc__vertical-align-middle" }),
                " ",
                g.data["source branch name"]
              ] }) : null,
              g.data["source checkout"] ? /* @__PURE__ */ v.jsx("div", { className: "flex left cb-5 br-4 pl-8 pr-8", children: /* @__PURE__ */ v.jsxs(
                "a",
                {
                  href: wm(
                    r,
                    g.data["source checkout"]
                  ),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: "commit-hash",
                  onClick: Cr,
                  children: [
                    /* @__PURE__ */ v.jsx(nN, { className: "commit-hash__icon" }),
                    g.data["source checkout"]
                  ]
                }
              ) }) : null
            ] }),
            /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
              /* @__PURE__ */ v.jsx("div", { className: "mono cn-7 fs-12 lh-1-5 br-4 bcn-1 pl-6 pr-6", children: g.data["target branch name"] ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                /* @__PURE__ */ v.jsx(DY, { className: "icon-dim-12 dc__vertical-align-middle" }),
                " ",
                g.data["target branch name"],
                " "
              ] }) : null }),
              /* @__PURE__ */ v.jsxs("div", { className: "flex left cb-5 br-4 pl-8 pr-8", children: [
                o && /* @__PURE__ */ v.jsxs("div", { className: "flex left bcn-1 br-4 cn-5 pl-8 pr-8", children: [
                  /* @__PURE__ */ v.jsx(xue, { className: "commit-hash__icon " }),
                  "HEAD"
                ] }),
                !o && /* @__PURE__ */ v.jsxs(
                  "a",
                  {
                    href: wm(
                      r,
                      g.data["target checkout"]
                    ),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "commit-hash",
                    onClick: Cr,
                    children: [
                      /* @__PURE__ */ v.jsx(nN, { className: "commit-hash__icon" }),
                      g.data["target checkout"]
                    ]
                  }
                )
              ] })
            ] })
          ] })
        ] }) }),
        m(),
        w()
      ] }),
      f && g.eventactiontype === e3.NON_MERGED && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsxs("div", { className: "flex left pr-16 pb-8 dc__content-space", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flex left cn-9 fs-13 ml-16", children: [
            " ",
            g.data["target checkout"]
          ] }),
          n ? /* @__PURE__ */ v.jsx("div", { className: "material-history__select-text", children: h.isselected ? /* @__PURE__ */ v.jsx(iN, { className: "dc__align-right" }) : "Select" }) : null
        ] }),
        m(),
        w()
      ] })
    ] })
  ] });
}, n_e = elt, tlt = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M10 3H13M13 3V6M13 3L9.5 6.5M6 13H3M3 13V10M3 13L6.5 9.5", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), nlt = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M9.5 3.5V6.5M9.5 6.5H12.5M9.5 6.5L13 3M3.5 9.5H6.5M6.5 9.5V12.5M6.5 9.5L3 13", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), xSt = ({ fullScreenView: i, setFullScreenView: e }) => {
  const { pathname: t } = E0(), n = x1t(), r = () => {
    e(!i);
  };
  return $e(() => {
    if (t.includes("/logs"))
      switch (n.join("")) {
        case "f":
          r();
          break;
        case "Escape":
          e(!1);
          break;
      }
  }, [n]), t.includes("/logs") && /* @__PURE__ */ v.jsx(
    wn,
    {
      placement: "top",
      arrow: !1,
      className: "default-tt",
      content: i ? "Exit fullscreen (f)" : "Enter fullscreen (f)",
      children: /* @__PURE__ */ v.jsx("div", { children: i ? /* @__PURE__ */ v.jsx(nlt, { className: "zoom zoom--out pointer dc__zi-4", onClick: r }) : /* @__PURE__ */ v.jsx(tlt, { className: "zoom zoom--in pointer dc__zi-4", onClick: r }) })
    }
  );
}, ilt = ({ scrollToTop: i, scrollToBottom: e, style: t }) => /* @__PURE__ */ v.jsxs("div", { style: t, className: "dc__element-scroller flex column top br-4", children: [
  /* @__PURE__ */ v.jsx(wn, { className: "default-tt", arrow: !1, content: "Scroll to Top", children: /* @__PURE__ */ v.jsx(
    "button",
    {
      className: "flex",
      disabled: !i,
      type: "button",
      onClick: i,
      "aria-label": "scroll-to-top",
      children: /* @__PURE__ */ v.jsx(vu, { className: "rotate", style: { "--rotateBy": "180deg" } })
    }
  ) }),
  /* @__PURE__ */ v.jsx(wn, { className: "default-tt", arrow: !1, content: "Scroll to Bottom", children: /* @__PURE__ */ v.jsx(
    "button",
    {
      className: "flex",
      disabled: !e,
      type: "button",
      onClick: e,
      "aria-label": "scroll-to-button",
      children: /* @__PURE__ */ v.jsx(vu, { className: "rotate" })
    }
  ) })
] }), rlt = ({
  gitTriggers: i,
  ciMaterials: e,
  artifact: t,
  userApprovalMetadata: n,
  triggeredByEmail: r,
  ciPipelineId: s,
  artifactId: o,
  imageComment: a,
  imageReleaseTags: l,
  appReleaseTagNames: c,
  tagsEditable: d,
  hideImageTaggingHardDelete: u,
  appliedFilters: h,
  appliedFiltersTimestamp: f,
  promotionApprovalMetadata: g,
  selectedEnvironmentName: p,
  renderCIListHeader: m
}) => {
  const { isSuperAdmin: _ } = Vve();
  if (!e?.length || !Object.keys(i ?? {}).length)
    return /* @__PURE__ */ v.jsx(
      oa,
      {
        title: jr.DATA_NOT_AVAILABLE,
        subTitle: jr.DEVTRON_APP_DEPLOYMENT_HISTORY_SOURCE_CODE.SUBTITLE
      }
    );
  const b = FE(t);
  return /* @__PURE__ */ v.jsxs("div", { className: "history-component__wrapper flex column left w-100 p-16 dc__gap-12", children: [
    e?.map((w, y) => {
      const S = i[w.id];
      return S && (S.Commit || S.WebhookData?.data) ? /* @__PURE__ */ v.jsx(
        "div",
        {
          className: "bcn-0 br-4 en-2 bw-1",
          "data-testid": "source-code-git-hash",
          style: { width: "min( 100%, 800px )" },
          children: /* @__PURE__ */ v.jsx(
            n_e,
            {
              index: y,
              materialUrl: S?.GitRepoUrl ? S.GitRepoUrl : w?.url,
              showMaterialInfoHeader: !0,
              commitInfo: S,
              materialSourceType: S?.CiConfigureSourceType ? S.CiConfigureSourceType : w?.type,
              selectedCommitInfo: "",
              materialSourceValue: S?.CiConfigureSourceValue ? S.CiConfigureSourceValue : w?.value
            }
          )
        },
        `mat-${S?.Commit}-${y}`
      ) : null;
    }),
    t && /* @__PURE__ */ v.jsx("div", { className: "history-component__artifact flex left column", children: /* @__PURE__ */ v.jsx(
      tR,
      {
        type: "deployed-artifact",
        userApprovalMetadata: n,
        triggeredBy: r,
        artifactId: o,
        ciPipelineId: s,
        imageComment: a,
        imageReleaseTags: l,
        appReleaseTagNames: c,
        tagsEditable: d,
        hideImageTaggingHardDelete: u,
        appliedFilters: h,
        appliedFiltersTimestamp: f,
        isSuperAdmin: _,
        promotionApprovalMetadata: g,
        selectedEnvironmentName: p,
        renderCIListHeader: m,
        children: /* @__PURE__ */ v.jsxs("div", { className: "flex column left hover-trigger", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "cn-9 fs-14 flex left", children: [
            b,
            /* @__PURE__ */ v.jsx("div", { className: "pl-4", children: /* @__PURE__ */ v.jsx(J_, { content: b }) })
          ] }),
          /* @__PURE__ */ v.jsxs("div", { className: "cn-7 fs-12 flex left", children: [
            t,
            /* @__PURE__ */ v.jsx("div", { className: "pl-4", children: /* @__PURE__ */ v.jsx(J_, { content: t }) })
          ] })
        ] })
      }
    ) })
  ] });
}, slt = it.memo(
  ({ status: i, finishedOn: e, artifact: t, type: n }) => /* @__PURE__ */ v.jsxs("div", { className: "flexbox pt-12 dc__gap-8 left dc__min-width-fit-content dc__align-items-center", children: [
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: `${i} fs-13 fw-6 ${A5e[i.toLowerCase()] || "cn-5"}`,
        "data-testid": "deployment-status-text",
        children: i && i.toLowerCase() === "cancelled" ? "Aborted" : i
      }
    ),
    e && e !== iS && /* @__PURE__ */ v.jsx("time", { className: "dc__vertical-align-middle fs-13", children: st(e, "YYYY-MM-DDTHH:mm:ssZ").format(id.TWELVE_HOURS_FORMAT) }),
    n === ir.CI && t && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx("div", { className: "dc__bullet" }),
      /* @__PURE__ */ v.jsx(Sue, { imagePath: t, placement: "top" })
    ] })
  ] })
), olt = it.memo(
  ({ message: i, podStatus: e, stage: t, workerPodName: n, finishedOn: r }) => {
    if (!i && !e)
      return null;
    const s = st(r).isBefore(st().subtract(x5e, "hours")), o = n && (r === iS || !s), a = () => o ? /* @__PURE__ */ v.jsx(uo, { to: `${D5e}/${n}/logs`, target: "_blank", className: "anchor", children: /* @__PURE__ */ v.jsx("span", { className: "mr-10 fs-13", children: "View worker pod" }) }) : null;
    return /* @__PURE__ */ v.jsxs("div", { className: "display-grid trigger-details__grid py-4", children: [
      /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__content-center", children: /* @__PURE__ */ v.jsx(Eke, { className: "icon-dim-20 dc__no-shrink scn-7" }) }),
      /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-8", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flexbox cn-9 fs-13 fw-4 lh-20", children: [
            /* @__PURE__ */ v.jsx("span", { children: "Worker" }),
            " ",
            e && /* @__PURE__ */ v.jsxs("span", { children: [
              e.toLowerCase(),
              " "
            ] })
          ] }),
          t !== "DEPLOY" && a()
        ] }),
        i && /* @__PURE__ */ v.jsx(wue, { text: i, textClass: "cn-7" }, i)
      ] })
    ] });
  }
), alt = it.memo(({ status: i, stage: e, type: t }) => {
  const [n, r] = Oe(!1), [s, o] = Oe(!1), [a, l] = Oe({
    status: !1,
    message: ""
  }), { buildId: c, triggerId: d, pipelineId: u } = eo();
  let h = null;
  t === ir.CI ? h = (m) => Tke({ pipelineId: u, workflowId: c }, m) : e !== "DEPLOY" && (h = () => Nke(u, d));
  async function f() {
    r(!0);
    try {
      await h(a.status), In.success("Build Aborted"), o(!1), l({
        status: !1,
        message: ""
      });
    } catch (m) {
      if (r(!1), o(!1), m.code === 400) {
        const { errors: _ } = m;
        l({
          status: !0,
          message: _[0].userMessage
        });
      }
    }
  }
  const g = () => {
    o(oCe);
  }, p = () => {
    l({
      status: !1,
      message: ""
    });
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex dc__gap-8 left pt-12", children: [
      /* @__PURE__ */ v.jsx("div", { className: "dc__min-width-fit-content", children: /* @__PURE__ */ v.jsx("div", { className: `${i} fs-14 fw-6 flex left inprogress-status-color`, children: "In progress" }) }),
      h && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx("span", { className: "cn-5 fs-13 fw-4 lh-20", children: "/" }),
        /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            className: "flex dc__transparent cr-5 fs-13 fw-6 lh-20",
            onClick: g,
            children: "Abort"
          }
        )
      ] })
    ] }),
    s && /* @__PURE__ */ v.jsxs(ko, { children: [
      /* @__PURE__ */ v.jsx(ko.Icon, { src: nY }),
      /* @__PURE__ */ v.jsx(
        ko.Body,
        {
          title: t === ir.CD ? `Abort ${e.toLowerCase()}-deployment?` : "Abort build?"
        }
      ),
      /* @__PURE__ */ v.jsx("p", { className: "fs-13 cn-7 lh-1-54", children: t === ir.CD ? "Are you sure you want to abort this stage?" : "Are you sure you want to abort this build?" }),
      /* @__PURE__ */ v.jsxs(ko.ButtonGroup, { children: [
        /* @__PURE__ */ v.jsx("button", { type: "button", className: "cta cancel", onClick: g, children: "Cancel" }),
        /* @__PURE__ */ v.jsx("button", { type: "button", className: "cta delete", onClick: f, children: n ? /* @__PURE__ */ v.jsx(Yr, {}) : "Yes, Abort" })
      ] })
    ] }),
    a.status && /* @__PURE__ */ v.jsxs(ko, { children: [
      /* @__PURE__ */ v.jsx(ko.Icon, { src: nY }),
      /* @__PURE__ */ v.jsx(ko.Body, { title: "Could not abort build!" }),
      /* @__PURE__ */ v.jsx("div", { className: "w-100 bc-n50 h-36 flexbox dc__align-items-center", children: /* @__PURE__ */ v.jsxs("span", { className: "pl-12", children: [
        "Error: ",
        a.message
      ] }) }),
      /* @__PURE__ */ v.jsx("div", { className: "fs-13 fw-6 pt-12 cn-7 lh-1-54", children: /* @__PURE__ */ v.jsx("span", { children: "Please try to force abort" }) }),
      /* @__PURE__ */ v.jsx("div", { className: "pt-4 fw-4 cn-7 lh-1-54", children: /* @__PURE__ */ v.jsx("span", { children: "Some resource might get orphaned which will be cleaned up with Job-lifecycle" }) }),
      /* @__PURE__ */ v.jsxs(ko.ButtonGroup, { children: [
        /* @__PURE__ */ v.jsx("button", { type: "button", className: "cta cancel", onClick: p, children: "Cancel" }),
        /* @__PURE__ */ v.jsx("button", { type: "button", className: "cta delete", onClick: f, children: n ? /* @__PURE__ */ v.jsx(Yr, {}) : "Force Abort" })
      ] })
    ] })
  ] });
}), llt = it.memo(({ status: i, finishedOn: e, artifact: t, stage: n, type: r }) => k5e[i.toLowerCase()] ? /* @__PURE__ */ v.jsx(alt, { status: i, stage: n, type: r }) : /* @__PURE__ */ v.jsx(slt, { status: i, finishedOn: e, artifact: t, type: r })), clt = ({
  startedOn: i,
  triggeredBy: e,
  triggeredByEmail: t,
  ciMaterials: n,
  gitTriggers: r,
  artifact: s,
  type: o,
  environmentName: a,
  isJobView: l,
  triggerMetadata: c,
  renderDeploymentHistoryTriggerMetaText: d,
  renderTargetConfigInfo: u,
  stage: h
}) => {
  const { url: f } = fd(), { pathname: g } = E0();
  return /* @__PURE__ */ v.jsxs("div", { className: "w-100 pr-20 flex column left dc__border-bottom-n1", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center pb-12", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex left dc__gap-4 cn-9 fs-13 fw-6 lh-20", children: [
        /* @__PURE__ */ v.jsxs("div", { className: "flex left dc__no-shrink dc__gap-4", "data-testid": "deployment-history-start-heading", children: [
          /* @__PURE__ */ v.jsx("div", { children: "Start" }),
          h && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx("div", { className: "dc__bullet" }),
            /* @__PURE__ */ v.jsx("div", { className: "dc__first-letter-capitalize", children: wAe(h) })
          ] })
        ] }),
        a && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          /* @__PURE__ */ v.jsx(Ike, { className: "icon-dim-14 scn-9 dc__no-shrink" }),
          /* @__PURE__ */ v.jsx("span", { className: "dc__truncate", children: a })
        ] }),
        u?.()
      ] }),
      /* @__PURE__ */ v.jsx("time", { className: "cn-7 fs-13", children: st(i, "YYYY-MM-DDTHH:mm:ssZ").format(id.TWELVE_HOURS_FORMAT) }),
      /* @__PURE__ */ v.jsx("div", { className: "dc__bullet" }),
      /* @__PURE__ */ v.jsx("div", { className: "trigger-details__trigger-by cn-7 fs-13", children: e === 1 ? "auto trigger" : t }),
      /* @__PURE__ */ v.jsx("div", {}),
      o === ir.CD ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        /* @__PURE__ */ v.jsx(v.Fragment, { children: s && /* @__PURE__ */ v.jsx(Sue, { imagePath: s, placement: "top" }) })
      ) : Object.keys(r ?? {}).length > 0 && n?.map((p) => {
        const m = r[p.id];
        return m ? /* @__PURE__ */ v.jsxs(it.Fragment, { children: [
          p.type !== "WEBHOOK" && m.Commit && /* @__PURE__ */ v.jsx(
            RY,
            {
              commits: [m.Commit],
              handleClick: OAe(
                wm(p.url, m.Commit)
              )
            }
          ),
          p.type === "WEBHOOK" && m.WebhookData && m.WebhookData.Data && m.WebhookData.Data["target checkout"] && /* @__PURE__ */ v.jsx(
            RY,
            {
              commits: m.WebhookData.EventActionType === "merged" ? m.WebhookData.Data["target checkout"].substr(0, 7) : m.WebhookData.Data["target checkout"]
            }
          )
        ] }, p.id) : null;
      }),
      !g.includes("source-code") && /* @__PURE__ */ v.jsx(D0, { to: `${f}/source-code`, className: "anchor fs-13", "data-testid": "commit-details-link", children: "Commit details" })
    ] }),
    c && d && d(c),
    l && /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 pb-8", children: [
      /* @__PURE__ */ v.jsx("span", { className: "cn-9 fs-13 fw-6 lh-20", children: "Env" }),
      /* @__PURE__ */ v.jsx("span", { className: "fs-12 lh-20", children: a !== "" ? a : E5e }),
      a === "" && /* @__PURE__ */ v.jsx("i", { className: "fw-4 fs-12 lh-20", children: "(Default)" })
    ] })
  ] });
}, dlt = it.memo(
  ({ status: i }) => /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col", children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
      /* @__PURE__ */ v.jsx("circle", { cx: "10", cy: "10", r: "5", stroke: "var(--N700)" }),
      /* @__PURE__ */ v.jsx("path", { d: "M10 15L10 20", stroke: "var(--N700)" })
    ] }) }),
    /* @__PURE__ */ v.jsx("div", { className: "flex flex-grow-1", children: /* @__PURE__ */ v.jsx("div", { className: "dc__border-left--n7 h-100" }) }),
    DIe[i] ? /* @__PURE__ */ v.jsx(Lke, {}) : /* @__PURE__ */ v.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
      /* @__PURE__ */ v.jsx(
        "circle",
        {
          cx: "10",
          cy: "10",
          r: "5",
          fill: q8[i],
          stroke: q8[i],
          strokeOpacity: "0.3",
          strokeWidth: "10"
        }
      ),
      /* @__PURE__ */ v.jsx("path", { d: "M10 0L10 5", stroke: "var(--N700)" })
    ] })
  ] })
), ult = it.memo(
  ({
    status: i,
    startedOn: e,
    finishedOn: t,
    triggeredBy: n,
    triggeredByEmail: r,
    ciMaterials: s,
    gitTriggers: o,
    message: a,
    podStatus: l,
    type: c,
    stage: d,
    artifact: u,
    environmentName: h,
    isJobView: f,
    workerPodName: g,
    triggerMetadata: p,
    renderDeploymentHistoryTriggerMetaText: m,
    renderTargetConfigInfo: _
  }) => /* @__PURE__ */ v.jsxs("div", { className: "trigger-details flexbox-col pb-12", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "display-grid trigger-details__grid py-12", children: [
      /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__content-center", children: /* @__PURE__ */ v.jsx(dlt, { status: i?.toLowerCase() }) }),
      /* @__PURE__ */ v.jsxs("div", { className: "trigger-details__summary flexbox-col flex-grow-1 lh-20", children: [
        /* @__PURE__ */ v.jsx(
          clt,
          {
            startedOn: e,
            triggeredBy: n,
            triggeredByEmail: r,
            ciMaterials: s,
            gitTriggers: o,
            artifact: u,
            type: c,
            environmentName: h,
            isJobView: f,
            triggerMetadata: p,
            renderDeploymentHistoryTriggerMetaText: m,
            renderTargetConfigInfo: _,
            stage: d
          }
        ),
        /* @__PURE__ */ v.jsx(
          llt,
          {
            status: i,
            finishedOn: t,
            artifact: u,
            stage: d,
            type: c
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      olt,
      {
        message: a,
        podStatus: l,
        stage: d,
        finishedOn: t,
        workerPodName: g
      }
    )
  ] })
), hlt = ({
  triggerDetails: i,
  loading: e,
  setFullScreenView: t,
  deploymentHistoryList: n,
  setDeploymentHistoryList: r,
  deploymentAppType: s,
  isBlobStorageConfigured: o,
  userApprovalMetadata: a,
  triggeredByEmail: l,
  artifactId: c,
  ciPipelineId: d,
  appReleaseTags: u,
  tagsEditable: h,
  hideImageTaggingHardDelete: f,
  selectedEnvironmentName: g,
  resourceId: p,
  renderRunSource: m,
  processVirtualEnvironmentDeploymentData: _,
  renderDeploymentApprovalInfo: b,
  renderCIListHeader: w,
  renderVirtualHistoryArtifacts: y,
  scrollToTop: S,
  scrollToBottom: x,
  fullScreenView: D
}) => {
  const { path: E } = fd(), { appId: L, pipelineId: k, triggerId: N, envId: I } = eo(), A = {
    appId: L,
    envId: I,
    appName: `${i.helmPackageName}.tgz`,
    workflowId: i.id
  }, P = `app/cd-pipeline/workflow/download/${L}/${I}/${k}/${N}`;
  return /* @__PURE__ */ v.jsx("div", { className: "trigger-outputs-container flexbox-col flex-grow-1", children: e ? /* @__PURE__ */ v.jsx(Yr, { pageLoader: !0 }) : /* @__PURE__ */ v.jsxs(OCe, { children: [
    i.stage !== "DEPLOY" ? !i.IsVirtualEnvironment && /* @__PURE__ */ v.jsxs(n1, { path: `${E}/logs`, children: [
      /* @__PURE__ */ v.jsx(
        Gke,
        {
          triggerDetails: i,
          isBlobStorageConfigured: o,
          parentType: ir.CD,
          fullScreenView: D
        }
      ),
      (S || x) && /* @__PURE__ */ v.jsx(
        ilt,
        {
          style: { position: "fixed", bottom: "52px", right: "12px", zIndex: "4" },
          scrollToTop: S,
          scrollToBottom: x
        }
      )
    ] }) : /* @__PURE__ */ v.jsx(n1, { path: `${E}/deployment-steps`, children: /* @__PURE__ */ v.jsx(
      l6e,
      {
        deploymentStatus: i.status,
        deploymentAppType: s,
        userApprovalMetadata: a,
        isGitops: s === bv.GITOPS || s === bv.MANIFEST_DOWNLOAD || s === bv.MANIFEST_PUSH,
        isHelmApps: !1,
        isVirtualEnvironment: i.IsVirtualEnvironment,
        processVirtualEnvironmentDeploymentData: _,
        renderDeploymentApprovalInfo: b
      }
    ) }),
    /* @__PURE__ */ v.jsx(n1, { path: `${E}/source-code`, children: /* @__PURE__ */ v.jsx(
      rlt,
      {
        gitTriggers: i.gitTriggers,
        ciMaterials: i.ciMaterials,
        artifact: i.artifact,
        userApprovalMetadata: a,
        triggeredByEmail: l,
        artifactId: c,
        ciPipelineId: d,
        imageComment: i?.imageComment,
        imageReleaseTags: i?.imageReleaseTags,
        appReleaseTagNames: u,
        tagsEditable: h,
        hideImageTaggingHardDelete: f,
        appliedFilters: i.appliedFilters ?? [],
        appliedFiltersTimestamp: i.appliedFiltersTimestamp,
        selectedEnvironmentName: g,
        promotionApprovalMetadata: i?.promotionApprovalMetadata,
        renderCIListHeader: w
      }
    ) }),
    i.stage === "DEPLOY" && /* @__PURE__ */ v.jsx(n1, { path: `${E}/configuration`, exact: !0, children: /* @__PURE__ */ v.jsx(
      Xat,
      {
        setDeploymentHistoryList: r,
        deploymentHistoryList: n,
        setFullScreenView: t
      }
    ) }),
    i.stage === "DEPLOY" && /* @__PURE__ */ v.jsx(
      n1,
      {
        path: `${E}${sr.DEPLOYMENT_HISTORY_CONFIGURATIONS}/:historyComponent/:baseConfigurationId(\\d+)/:historyComponentName?`,
        children: /* @__PURE__ */ v.jsx(
          Kat,
          {
            setDeploymentHistoryList: r,
            deploymentHistoryList: n,
            setFullScreenView: t,
            renderRunSource: m,
            resourceId: p
          }
        )
      }
    ),
    (i.stage !== "DEPLOY" || i.IsVirtualEnvironment) && /* @__PURE__ */ v.jsx(n1, { path: `${E}/artifacts`, children: i.IsVirtualEnvironment && y ? y({
      status: i.status,
      title: i.helmPackageName,
      params: { ...A, appId: Number(L), envId: Number(I) }
    }) : /* @__PURE__ */ v.jsx(
      yue,
      {
        status: i.status,
        artifact: i.artifact,
        blobStorageEnabled: i.blobStorageEnabled,
        ciPipelineId: i.ciPipelineId,
        artifactId: i.artifactId,
        imageComment: i?.imageComment,
        imageReleaseTags: i?.imageReleaseTags,
        tagsEditable: h,
        appReleaseTagNames: u,
        hideImageTaggingHardDelete: f,
        downloadArtifactUrl: P,
        type: ir.CD,
        renderCIListHeader: w,
        rootClassName: "p-16 flex-grow-1"
      }
    ) }),
    /* @__PURE__ */ v.jsx(
      MCe,
      {
        to: `${E}/${// eslint-disable-next-line no-nested-ternary
        i.stage === "DEPLOY" ? "deployment-steps" : i.status.toLowerCase() === "succeeded" || i.IsVirtualEnvironment ? "artifacts" : "logs"}`
      }
    )
  ] }) });
}, flt = ({
  fullScreenView: i,
  triggerHistory: e,
  setTriggerHistory: t,
  setFullScreenView: n,
  setDeploymentHistoryList: r,
  deploymentHistoryList: s,
  deploymentAppType: o,
  isBlobStorageConfigured: a,
  appReleaseTags: l,
  tagsEditable: c,
  hideImageTaggingHardDelete: d,
  fetchIdData: u,
  setFetchTriggerIdData: h,
  selectedEnvironmentName: f,
  deploymentHistoryResult: g,
  renderRunSource: p,
  renderCIListHeader: m,
  renderDeploymentApprovalInfo: _,
  processVirtualEnvironmentDeploymentData: b,
  renderVirtualHistoryArtifacts: w,
  renderDeploymentHistoryTriggerMetaText: y,
  resourceId: S,
  scrollToTop: x,
  scrollToBottom: D,
  renderTargetConfigInfo: E
}) => {
  const { appId: L, triggerId: k, envId: N, pipelineId: I } = eo(), A = e.get(+k), [P, O, K, W] = tf(
    () => Ake({ appId: L, envId: N, pipelineId: I, triggerId: k, fetchIdData: u }),
    // TODO: Ask if fetchIdData is required here as dependency
    [k, L, N],
    !!k && !!I
  ), F = (ae, ue, se) => {
    if (se) {
      g?.result?.cdWorkflows?.length && t(hCe(g.result.cdWorkflows, "id")), h(Yf.SUSPEND);
      return;
    }
    if (ae === ue?.id) {
      const le = e.get(ae)?.appliedFilters ?? [], oe = e.get(ae)?.appliedFiltersTimestamp, re = e.get(ae)?.promotionApprovalMetadata, B = e.get(ae)?.runSource, ee = e.get(ae)?.targetConfig, j = {
        ...le.length ? { appliedFilters: le } : {},
        ...oe ? { appliedFiltersTimestamp: oe } : {},
        ...re ? { promotionApprovalMetadata: re } : {},
        ...B ? { runSource: B } : {},
        ...ee ? { targetConfig: ee } : {}
      };
      t((he) => (he.set(ae, { ...ue, ...j }), new Map(he))), u === Yf.FETCHING && h(Yf.SUCCESS);
    }
  };
  let q = !!u && u !== Yf.SUSPEND;
  (O?.result?.artifactId === 0 || A?.artifactId === 0) && (q = !1);
  const [R, T, z] = tf(
    () => kke({
      pipelineId: I,
      artifactId: O?.result?.artifactId || A?.artifactId
    }),
    [I, k],
    q && !!I && (!!O?.result?.artifactId || !!A?.artifactId)
  );
  $e(() => {
    if (P)
      return;
    let ae = {
      ...O?.result,
      imageComment: A?.imageComment,
      imageReleaseTags: A?.imageReleaseTags
    };
    q && (ae = null), F(+k, ae, K);
  }, [P, O, K]), $e(() => {
    if (R || !O || !q)
      return;
    const ae = {
      ...O?.result,
      imageReleaseTags: T?.result?.imageReleaseTags,
      imageComment: T?.result?.imageComment
    };
    F(+k, ae, z);
  }, [R, T, z]);
  const X = Mn(() => !A || T5e.has(A.podStatus?.toLowerCase() || A.status?.toLowerCase()) ? null : N5e.has(A.status?.toLowerCase() || A.podStatus?.toLowerCase()) ? 1e4 : 3e4, [A]);
  return dCe(W, X), !q && P && !A || !k || q && (R || P) && !A ? /* @__PURE__ */ v.jsx(Yr, { pageLoader: !0 }) : K?.code === 404 ? /* @__PURE__ */ v.jsx(
    oa,
    {
      title: jr.TRIGGER_NOT_FOUND.TITLE,
      subTitle: jr.TRIGGER_NOT_FOUND.SUBTITLE
    }
  ) : !q && !P && !A ? /* @__PURE__ */ v.jsx(sA, {}) : q && !(R || P) && !A ? /* @__PURE__ */ v.jsx(sA, {}) : A?.id !== +k ? null : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    !i && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(
        ult,
        {
          type: ir.CD,
          status: A.status,
          startedOn: A.startedOn,
          finishedOn: A.finishedOn,
          triggeredBy: A.triggeredBy,
          triggeredByEmail: A.triggeredByEmail,
          ciMaterials: A.ciMaterials,
          gitTriggers: A.gitTriggers,
          message: A.message,
          podStatus: A.podStatus,
          stage: A.stage,
          artifact: A.artifact,
          triggerMetadata: A.triggerMetadata,
          renderDeploymentHistoryTriggerMetaText: y,
          environmentName: f,
          renderTargetConfigInfo: E
        }
      ),
      /* @__PURE__ */ v.jsxs("ul", { className: "pl-50 pr-20 pt-8 tab-list tab-list--nodes dc__border-bottom dc__position-sticky dc__top-0 bcn-0 dc__zi-3", children: [
        A.stage === "DEPLOY" && o !== bv.HELM && /* @__PURE__ */ v.jsx("li", { className: "tab-list__tab", "data-testid": "deployment-history-steps-link", children: /* @__PURE__ */ v.jsx(
          uo,
          {
            replace: !0,
            className: "tab-list__tab-link fs-13-imp pb-8 pt-0-imp",
            activeClassName: "active",
            to: "deployment-steps",
            children: "Steps"
          }
        ) }),
        !(A.stage === "DEPLOY" || A.IsVirtualEnvironment) && /* @__PURE__ */ v.jsx("li", { className: "tab-list__tab", "data-testid": "deployment-history-logs-link", children: /* @__PURE__ */ v.jsx(
          uo,
          {
            replace: !0,
            className: "tab-list__tab-link fs-13-imp pb-8 pt-0-imp",
            activeClassName: "active",
            to: "logs",
            children: "Logs"
          }
        ) }),
        /* @__PURE__ */ v.jsx("li", { className: "tab-list__tab", "data-testid": "deployment-history-source-code-link", children: /* @__PURE__ */ v.jsx(
          uo,
          {
            replace: !0,
            className: "tab-list__tab-link fs-13-imp pb-8 pt-0-imp",
            activeClassName: "active",
            to: "source-code",
            children: "Source"
          }
        ) }),
        A.stage === "DEPLOY" && /* @__PURE__ */ v.jsx("li", { className: "tab-list__tab", "data-testid": "deployment-history-configuration-link", children: /* @__PURE__ */ v.jsx(
          uo,
          {
            replace: !0,
            className: "tab-list__tab-link fs-13-imp pb-8 pt-0-imp",
            activeClassName: "active",
            to: "configuration",
            children: "Configuration"
          }
        ) }),
        (A.stage !== "DEPLOY" || A.IsVirtualEnvironment) && /* @__PURE__ */ v.jsx("li", { className: "tab-list__tab", "data-testid": "deployment-history-artifacts-link", children: /* @__PURE__ */ v.jsx(
          uo,
          {
            replace: !0,
            className: "tab-list__tab-link fs-13-imp pb-8 pt-0-imp",
            activeClassName: "active",
            to: "artifacts",
            children: "Artifacts"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      hlt,
      {
        triggerDetails: A,
        loading: P && !O || !A || q && !T,
        userApprovalMetadata: O?.result?.userApprovalMetadata,
        triggeredByEmail: O?.result?.triggeredByEmail,
        setFullScreenView: n,
        setDeploymentHistoryList: r,
        deploymentHistoryList: s,
        deploymentAppType: o,
        isBlobStorageConfigured: a,
        artifactId: O?.result?.artifactId,
        ciPipelineId: O?.result?.ciPipelineId,
        appReleaseTags: l,
        tagsEditable: c,
        hideImageTaggingHardDelete: d,
        selectedEnvironmentName: f,
        resourceId: S,
        renderRunSource: p,
        processVirtualEnvironmentDeploymentData: b,
        renderDeploymentApprovalInfo: _,
        renderCIListHeader: m,
        renderVirtualHistoryArtifacts: w,
        scrollToTop: x,
        scrollToBottom: D,
        fullScreenView: i
      },
      A.id
    )
  ] });
}, DSt = flt;
var i_e = {}, r_e = { exports: {} };
(function(i) {
  function e(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  i.exports = e, i.exports.__esModule = !0, i.exports.default = i.exports;
})(r_e);
var xt = r_e.exports, rN = {}, t3 = { exports: {} }, sN, nte;
function s_e() {
  if (nte) return sN;
  nte = 1;
  var i = Object.prototype.toString;
  return sN = function(t) {
    var n = i.call(t), r = n === "[object Arguments]";
    return r || (r = n !== "[object Array]" && t !== null && typeof t == "object" && typeof t.length == "number" && t.length >= 0 && i.call(t.callee) === "[object Function]"), r;
  }, sN;
}
var oN, ite;
function glt() {
  if (ite) return oN;
  ite = 1;
  var i;
  if (!Object.keys) {
    var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = s_e(), r = Object.prototype.propertyIsEnumerable, s = !r.call({ toString: null }, "toString"), o = r.call(function() {
    }, "prototype"), a = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], l = function(h) {
      var f = h.constructor;
      return f && f.prototype === h;
    }, c = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, d = function() {
      if (typeof window > "u")
        return !1;
      for (var h in window)
        try {
          if (!c["$" + h] && e.call(window, h) && window[h] !== null && typeof window[h] == "object")
            try {
              l(window[h]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), u = function(h) {
      if (typeof window > "u" || !d)
        return l(h);
      try {
        return l(h);
      } catch {
        return !1;
      }
    };
    i = function(f) {
      var g = f !== null && typeof f == "object", p = t.call(f) === "[object Function]", m = n(f), _ = g && t.call(f) === "[object String]", b = [];
      if (!g && !p && !m)
        throw new TypeError("Object.keys called on a non-object");
      var w = o && p;
      if (_ && f.length > 0 && !e.call(f, 0))
        for (var y = 0; y < f.length; ++y)
          b.push(String(y));
      if (m && f.length > 0)
        for (var S = 0; S < f.length; ++S)
          b.push(String(S));
      else
        for (var x in f)
          !(w && x === "prototype") && e.call(f, x) && b.push(String(x));
      if (s)
        for (var D = u(f), E = 0; E < a.length; ++E)
          !(D && a[E] === "constructor") && e.call(f, a[E]) && b.push(a[E]);
      return b;
    };
  }
  return oN = i, oN;
}
var aN, rte;
function KG() {
  if (rte) return aN;
  rte = 1;
  var i = Array.prototype.slice, e = s_e(), t = Object.keys, n = t ? function(o) {
    return t(o);
  } : glt(), r = Object.keys;
  return n.shim = function() {
    if (Object.keys) {
      var o = function() {
        var a = Object.keys(arguments);
        return a && a.length === arguments.length;
      }(1, 2);
      o || (Object.keys = function(l) {
        return e(l) ? r(i.call(l)) : r(l);
      });
    } else
      Object.keys = n;
    return Object.keys || n;
  }, aN = n, aN;
}
var lN, ste;
function plt() {
  return ste || (ste = 1, lN = Error), lN;
}
var cN, ote;
function mlt() {
  return ote || (ote = 1, cN = EvalError), cN;
}
var dN, ate;
function o_e() {
  return ate || (ate = 1, dN = RangeError), dN;
}
var uN, lte;
function vlt() {
  return lte || (lte = 1, uN = ReferenceError), uN;
}
var hN, cte;
function ik() {
  return cte || (cte = 1, hN = SyntaxError), hN;
}
var fN, dte;
function Jn() {
  return dte || (dte = 1, fN = TypeError), fN;
}
var gN, ute;
function _lt() {
  return ute || (ute = 1, gN = URIError), gN;
}
var pN, hte;
function YG() {
  return hte || (hte = 1, pN = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, t = Symbol("test"), n = Object(t);
    if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var r = 42;
    e[t] = r;
    for (t in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var s = Object.getOwnPropertySymbols(e);
    if (s.length !== 1 || s[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var o = Object.getOwnPropertyDescriptor(e, t);
      if (o.value !== r || o.enumerable !== !0)
        return !1;
    }
    return !0;
  }), pN;
}
var mN, fte;
function a_e() {
  if (fte) return mN;
  fte = 1;
  var i = typeof Symbol < "u" && Symbol, e = YG();
  return mN = function() {
    return typeof i != "function" || typeof Symbol != "function" || typeof i("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, mN;
}
var vN, gte;
function l_e() {
  if (gte) return vN;
  gte = 1;
  var i = {
    __proto__: null,
    foo: {}
  }, e = Object;
  return vN = function() {
    return { __proto__: i }.foo === i.foo && !(i instanceof e);
  }, vN;
}
var _N, pte;
function blt() {
  if (pte) return _N;
  pte = 1;
  var i = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, t = Math.max, n = "[object Function]", r = function(l, c) {
    for (var d = [], u = 0; u < l.length; u += 1)
      d[u] = l[u];
    for (var h = 0; h < c.length; h += 1)
      d[h + l.length] = c[h];
    return d;
  }, s = function(l, c) {
    for (var d = [], u = c, h = 0; u < l.length; u += 1, h += 1)
      d[h] = l[u];
    return d;
  }, o = function(a, l) {
    for (var c = "", d = 0; d < a.length; d += 1)
      c += a[d], d + 1 < a.length && (c += l);
    return c;
  };
  return _N = function(l) {
    var c = this;
    if (typeof c != "function" || e.apply(c) !== n)
      throw new TypeError(i + c);
    for (var d = s(arguments, 1), u, h = function() {
      if (this instanceof u) {
        var _ = c.apply(
          this,
          r(d, arguments)
        );
        return Object(_) === _ ? _ : this;
      }
      return c.apply(
        l,
        r(d, arguments)
      );
    }, f = t(0, c.length - d.length), g = [], p = 0; p < f; p++)
      g[p] = "$" + p;
    if (u = Function("binder", "return function (" + o(g, ",") + "){ return binder.apply(this,arguments); }")(h), c.prototype) {
      var m = function() {
      };
      m.prototype = c.prototype, u.prototype = new m(), m.prototype = null;
    }
    return u;
  }, _N;
}
var bN, mte;
function XG() {
  if (mte) return bN;
  mte = 1;
  var i = blt();
  return bN = Function.prototype.bind || i, bN;
}
var CN, vte;
function Bu() {
  if (vte) return CN;
  vte = 1;
  var i = Function.prototype.call, e = Object.prototype.hasOwnProperty, t = XG();
  return CN = t.call(i, e), CN;
}
var yN, _te;
function As() {
  if (_te) return yN;
  _te = 1;
  var i, e = plt(), t = mlt(), n = o_e(), r = vlt(), s = ik(), o = Jn(), a = _lt(), l = Function, c = function(W) {
    try {
      return l('"use strict"; return (' + W + ").constructor;")();
    } catch {
    }
  }, d = Object.getOwnPropertyDescriptor;
  if (d)
    try {
      d({}, "");
    } catch {
      d = null;
    }
  var u = function() {
    throw new o();
  }, h = d ? function() {
    try {
      return arguments.callee, u;
    } catch {
      try {
        return d(arguments, "callee").get;
      } catch {
        return u;
      }
    }
  }() : u, f = a_e()(), g = l_e()(), p = Object.getPrototypeOf || (g ? function(W) {
    return W.__proto__;
  } : null), m = {}, _ = typeof Uint8Array > "u" || !p ? i : p(Uint8Array), b = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? i : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? i : ArrayBuffer,
    "%ArrayIteratorPrototype%": f && p ? p([][Symbol.iterator]()) : i,
    "%AsyncFromSyncIteratorPrototype%": i,
    "%AsyncFunction%": m,
    "%AsyncGenerator%": m,
    "%AsyncGeneratorFunction%": m,
    "%AsyncIteratorPrototype%": m,
    "%Atomics%": typeof Atomics > "u" ? i : Atomics,
    "%BigInt%": typeof BigInt > "u" ? i : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? i : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? i : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? i : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": e,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": t,
    "%Float32Array%": typeof Float32Array > "u" ? i : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? i : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? i : FinalizationRegistry,
    "%Function%": l,
    "%GeneratorFunction%": m,
    "%Int8Array%": typeof Int8Array > "u" ? i : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? i : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? i : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": f && p ? p(p([][Symbol.iterator]())) : i,
    "%JSON%": typeof JSON == "object" ? JSON : i,
    "%Map%": typeof Map > "u" ? i : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !f || !p ? i : p((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? i : Promise,
    "%Proxy%": typeof Proxy > "u" ? i : Proxy,
    "%RangeError%": n,
    "%ReferenceError%": r,
    "%Reflect%": typeof Reflect > "u" ? i : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? i : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !f || !p ? i : p((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? i : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": f && p ? p(""[Symbol.iterator]()) : i,
    "%Symbol%": f ? Symbol : i,
    "%SyntaxError%": s,
    "%ThrowTypeError%": h,
    "%TypedArray%": _,
    "%TypeError%": o,
    "%Uint8Array%": typeof Uint8Array > "u" ? i : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? i : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? i : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? i : Uint32Array,
    "%URIError%": a,
    "%WeakMap%": typeof WeakMap > "u" ? i : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? i : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? i : WeakSet
  };
  if (p)
    try {
      null.error;
    } catch (W) {
      var w = p(p(W));
      b["%Error.prototype%"] = w;
    }
  var y = function W(F) {
    var q;
    if (F === "%AsyncFunction%")
      q = c("async function () {}");
    else if (F === "%GeneratorFunction%")
      q = c("function* () {}");
    else if (F === "%AsyncGeneratorFunction%")
      q = c("async function* () {}");
    else if (F === "%AsyncGenerator%") {
      var R = W("%AsyncGeneratorFunction%");
      R && (q = R.prototype);
    } else if (F === "%AsyncIteratorPrototype%") {
      var T = W("%AsyncGenerator%");
      T && p && (q = p(T.prototype));
    }
    return b[F] = q, q;
  }, S = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, x = XG(), D = Bu(), E = x.call(Function.call, Array.prototype.concat), L = x.call(Function.apply, Array.prototype.splice), k = x.call(Function.call, String.prototype.replace), N = x.call(Function.call, String.prototype.slice), I = x.call(Function.call, RegExp.prototype.exec), A = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, P = /\\(\\)?/g, O = function(F) {
    var q = N(F, 0, 1), R = N(F, -1);
    if (q === "%" && R !== "%")
      throw new s("invalid intrinsic syntax, expected closing `%`");
    if (R === "%" && q !== "%")
      throw new s("invalid intrinsic syntax, expected opening `%`");
    var T = [];
    return k(F, A, function(z, X, ae, ue) {
      T[T.length] = ae ? k(ue, P, "$1") : X || z;
    }), T;
  }, K = function(F, q) {
    var R = F, T;
    if (D(S, R) && (T = S[R], R = "%" + T[0] + "%"), D(b, R)) {
      var z = b[R];
      if (z === m && (z = y(R)), typeof z > "u" && !q)
        throw new o("intrinsic " + F + " exists, but is not available. Please file an issue!");
      return {
        alias: T,
        name: R,
        value: z
      };
    }
    throw new s("intrinsic " + F + " does not exist!");
  };
  return yN = function(F, q) {
    if (typeof F != "string" || F.length === 0)
      throw new o("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof q != "boolean")
      throw new o('"allowMissing" argument must be a boolean');
    if (I(/^%?[^%]*%?$/, F) === null)
      throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var R = O(F), T = R.length > 0 ? R[0] : "", z = K("%" + T + "%", q), X = z.name, ae = z.value, ue = !1, se = z.alias;
    se && (T = se[0], L(R, E([0, 1], se)));
    for (var le = 1, oe = !0; le < R.length; le += 1) {
      var re = R[le], B = N(re, 0, 1), ee = N(re, -1);
      if ((B === '"' || B === "'" || B === "`" || ee === '"' || ee === "'" || ee === "`") && B !== ee)
        throw new s("property names with quotes must have matching quotes");
      if ((re === "constructor" || !oe) && (ue = !0), T += "." + re, X = "%" + T + "%", D(b, X))
        ae = b[X];
      else if (ae != null) {
        if (!(re in ae)) {
          if (!q)
            throw new o("base intrinsic for " + F + " exists, but the property is not available.");
          return;
        }
        if (d && le + 1 >= R.length) {
          var j = d(ae, re);
          oe = !!j, oe && "get" in j && !("originalValue" in j.get) ? ae = j.get : ae = ae[re];
        } else
          oe = D(ae, re), ae = ae[re];
        oe && !ue && (b[X] = ae);
      }
    }
    return ae;
  }, yN;
}
var wN, bte;
function rk() {
  if (bte) return wN;
  bte = 1;
  var i = As(), e = i("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return wN = e, wN;
}
var SN, Cte;
function sk() {
  if (Cte) return SN;
  Cte = 1;
  var i = As(), e = i("%Object.getOwnPropertyDescriptor%", !0);
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return SN = e, SN;
}
var xN, yte;
function c_e() {
  if (yte) return xN;
  yte = 1;
  var i = rk(), e = ik(), t = Jn(), n = sk();
  return xN = function(s, o, a) {
    if (!s || typeof s != "object" && typeof s != "function")
      throw new t("`obj` must be an object or a function`");
    if (typeof o != "string" && typeof o != "symbol")
      throw new t("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new t("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new t("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new t("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new t("`loose`, if provided, must be a boolean");
    var l = arguments.length > 3 ? arguments[3] : null, c = arguments.length > 4 ? arguments[4] : null, d = arguments.length > 5 ? arguments[5] : null, u = arguments.length > 6 ? arguments[6] : !1, h = !!n && n(s, o);
    if (i)
      i(s, o, {
        configurable: d === null && h ? h.configurable : !d,
        enumerable: l === null && h ? h.enumerable : !l,
        value: a,
        writable: c === null && h ? h.writable : !c
      });
    else if (u || !l && !c && !d)
      s[o] = a;
    else
      throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, xN;
}
var DN, wte;
function ZG() {
  if (wte) return DN;
  wte = 1;
  var i = rk(), e = function() {
    return !!i;
  };
  return e.hasArrayLengthDefineBug = function() {
    if (!i)
      return null;
    try {
      return i([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, DN = e, DN;
}
var EN, Ste;
function Xr() {
  if (Ste) return EN;
  Ste = 1;
  var i = KG(), e = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", t = Object.prototype.toString, n = Array.prototype.concat, r = c_e(), s = function(c) {
    return typeof c == "function" && t.call(c) === "[object Function]";
  }, o = ZG()(), a = function(c, d, u, h) {
    if (d in c) {
      if (h === !0) {
        if (c[d] === u)
          return;
      } else if (!s(h) || !h())
        return;
    }
    o ? r(c, d, u, !0) : r(c, d, u);
  }, l = function(c, d) {
    var u = arguments.length > 2 ? arguments[2] : {}, h = i(d);
    e && (h = n.call(h, Object.getOwnPropertySymbols(d)));
    for (var f = 0; f < h.length; f += 1)
      a(c, h[f], d[h[f]], u[h[f]]);
  };
  return l.supportsDescriptors = !!o, EN = l, EN;
}
var LN = { exports: {} }, IN, xte;
function Clt() {
  if (xte) return IN;
  xte = 1;
  var i = As(), e = c_e(), t = ZG()(), n = sk(), r = Jn(), s = i("%Math.floor%");
  return IN = function(a, l) {
    if (typeof a != "function")
      throw new r("`fn` is not a function");
    if (typeof l != "number" || l < 0 || l > 4294967295 || s(l) !== l)
      throw new r("`length` must be a positive 32-bit integer");
    var c = arguments.length > 2 && !!arguments[2], d = !0, u = !0;
    if ("length" in a && n) {
      var h = n(a, "length");
      h && !h.configurable && (d = !1), h && !h.writable && (u = !1);
    }
    return (d || u || !c) && (t ? e(
      /** @type {Parameters<define>[0]} */
      a,
      "length",
      l,
      !0,
      !0
    ) : e(
      /** @type {Parameters<define>[0]} */
      a,
      "length",
      l
    )), a;
  }, IN;
}
var Dte;
function Vu() {
  return Dte || (Dte = 1, function(i) {
    var e = XG(), t = As(), n = Clt(), r = Jn(), s = t("%Function.prototype.apply%"), o = t("%Function.prototype.call%"), a = t("%Reflect.apply%", !0) || e.call(o, s), l = rk(), c = t("%Math.max%");
    i.exports = function(h) {
      if (typeof h != "function")
        throw new r("a function is required");
      var f = a(e, o, arguments);
      return n(
        f,
        1 + c(0, h.length - (arguments.length - 1)),
        !0
      );
    };
    var d = function() {
      return a(e, s, arguments);
    };
    l ? l(i.exports, "apply", { value: d }) : i.exports.apply = d;
  }(LN)), LN.exports;
}
var AN, Ete;
function d_e() {
  if (Ete) return AN;
  Ete = 1;
  var i = function(e) {
    return e !== e;
  };
  return AN = function(t, n) {
    return t === 0 && n === 0 ? 1 / t === 1 / n : !!(t === n || i(t) && i(n));
  }, AN;
}
var kN, Lte;
function u_e() {
  if (Lte) return kN;
  Lte = 1;
  var i = d_e();
  return kN = function() {
    return typeof Object.is == "function" ? Object.is : i;
  }, kN;
}
var TN, Ite;
function ylt() {
  if (Ite) return TN;
  Ite = 1;
  var i = u_e(), e = Xr();
  return TN = function() {
    var n = i();
    return e(Object, { is: n }, {
      is: function() {
        return Object.is !== n;
      }
    }), n;
  }, TN;
}
var NN, Ate;
function QG() {
  if (Ate) return NN;
  Ate = 1;
  var i = Xr(), e = Vu(), t = d_e(), n = u_e(), r = ylt(), s = e(n(), Object);
  return i(s, {
    getPolyfill: n,
    implementation: t,
    shim: r
  }), NN = s, NN;
}
var kte;
function ua() {
  return kte || (kte = 1, function(i, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = o;
    var t = r(QG()), n = r(Bu());
    function r(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function s(a) {
      "@babel/helpers - typeof";
      return s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
        return typeof l;
      } : function(l) {
        return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
      }, s(a);
    }
    function o(a, l) {
      if ((0, t.default)(a, l))
        return !0;
      if (!a || !l || s(a) !== "object" || s(l) !== "object")
        return !1;
      var c = Object.keys(a), d = Object.keys(l);
      if (c.length !== d.length)
        return !1;
      c.sort(), d.sort();
      for (var u = 0; u < c.length; u += 1)
        if (!(0, n.default)(l, c[u]) || !(0, t.default)(a[c[u]], l[c[u]]))
          return !1;
      return !0;
    }
    i.exports = e.default;
  }(t3, t3.exports)), t3.exports;
}
var PN = { exports: {} }, Tte;
function ha() {
  return Tte || (Tte = 1, function(i) {
    function e() {
      return i.exports = e = Object.assign ? Object.assign.bind() : function(t) {
        for (var n = 1; n < arguments.length; n++) {
          var r = arguments[n];
          for (var s in r) ({}).hasOwnProperty.call(r, s) && (t[s] = r[s]);
        }
        return t;
      }, i.exports.__esModule = !0, i.exports.default = i.exports, e.apply(null, arguments);
    }
    i.exports = e, i.exports.__esModule = !0, i.exports.default = i.exports;
  }(PN)), PN.exports;
}
var ON = { exports: {} }, Nte;
function Pl() {
  return Nte || (Nte = 1, function(i) {
    function e(t) {
      if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    i.exports = e, i.exports.__esModule = !0, i.exports.default = i.exports;
  }(ON)), ON.exports;
}
var MN = { exports: {} }, RN = { exports: {} }, Pte;
function wlt() {
  return Pte || (Pte = 1, function(i) {
    function e(t, n) {
      return i.exports = e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, s) {
        return r.__proto__ = s, r;
      }, i.exports.__esModule = !0, i.exports.default = i.exports, e(t, n);
    }
    i.exports = e, i.exports.__esModule = !0, i.exports.default = i.exports;
  }(RN)), RN.exports;
}
var Ote;
function fa() {
  return Ote || (Ote = 1, function(i) {
    var e = wlt();
    function t(n, r) {
      n.prototype = Object.create(r.prototype), n.prototype.constructor = n, e(n, r);
    }
    i.exports = t, i.exports.__esModule = !0, i.exports.default = i.exports;
  }(MN)), MN.exports;
}
var FN = { exports: {} }, BN = { exports: {} }, VN = { exports: {} }, Mte;
function JG() {
  return Mte || (Mte = 1, function(i) {
    function e(t) {
      "@babel/helpers - typeof";
      return i.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, i.exports.__esModule = !0, i.exports.default = i.exports, e(t);
    }
    i.exports = e, i.exports.__esModule = !0, i.exports.default = i.exports;
  }(VN)), VN.exports;
}
var HN = { exports: {} }, Rte;
function Slt() {
  return Rte || (Rte = 1, function(i) {
    var e = JG().default;
    function t(n, r) {
      if (e(n) != "object" || !n) return n;
      var s = n[Symbol.toPrimitive];
      if (s !== void 0) {
        var o = s.call(n, r || "default");
        if (e(o) != "object") return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (r === "string" ? String : Number)(n);
    }
    i.exports = t, i.exports.__esModule = !0, i.exports.default = i.exports;
  }(HN)), HN.exports;
}
var Fte;
function xlt() {
  return Fte || (Fte = 1, function(i) {
    var e = JG().default, t = Slt();
    function n(r) {
      var s = t(r, "string");
      return e(s) == "symbol" ? s : s + "";
    }
    i.exports = n, i.exports.__esModule = !0, i.exports.default = i.exports;
  }(BN)), BN.exports;
}
var Bte;
function hs() {
  return Bte || (Bte = 1, function(i) {
    var e = xlt();
    function t(n, r, s) {
      return (r = e(r)) in n ? Object.defineProperty(n, r, {
        value: s,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[r] = s, n;
    }
    i.exports = t, i.exports.__esModule = !0, i.exports.default = i.exports;
  }(FN)), FN.exports;
}
var n3 = { exports: {} }, i3 = { exports: {} }, Li = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vte;
function Dlt() {
  if (Vte) return Li;
  Vte = 1;
  var i = typeof Symbol == "function" && Symbol.for, e = i ? Symbol.for("react.element") : 60103, t = i ? Symbol.for("react.portal") : 60106, n = i ? Symbol.for("react.fragment") : 60107, r = i ? Symbol.for("react.strict_mode") : 60108, s = i ? Symbol.for("react.profiler") : 60114, o = i ? Symbol.for("react.provider") : 60109, a = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, c = i ? Symbol.for("react.concurrent_mode") : 60111, d = i ? Symbol.for("react.forward_ref") : 60112, u = i ? Symbol.for("react.suspense") : 60113, h = i ? Symbol.for("react.suspense_list") : 60120, f = i ? Symbol.for("react.memo") : 60115, g = i ? Symbol.for("react.lazy") : 60116, p = i ? Symbol.for("react.block") : 60121, m = i ? Symbol.for("react.fundamental") : 60117, _ = i ? Symbol.for("react.responder") : 60118, b = i ? Symbol.for("react.scope") : 60119;
  function w(S) {
    if (typeof S == "object" && S !== null) {
      var x = S.$$typeof;
      switch (x) {
        case e:
          switch (S = S.type, S) {
            case l:
            case c:
            case n:
            case s:
            case r:
            case u:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case a:
                case d:
                case g:
                case f:
                case o:
                  return S;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  function y(S) {
    return w(S) === c;
  }
  return Li.AsyncMode = l, Li.ConcurrentMode = c, Li.ContextConsumer = a, Li.ContextProvider = o, Li.Element = e, Li.ForwardRef = d, Li.Fragment = n, Li.Lazy = g, Li.Memo = f, Li.Portal = t, Li.Profiler = s, Li.StrictMode = r, Li.Suspense = u, Li.isAsyncMode = function(S) {
    return y(S) || w(S) === l;
  }, Li.isConcurrentMode = y, Li.isContextConsumer = function(S) {
    return w(S) === a;
  }, Li.isContextProvider = function(S) {
    return w(S) === o;
  }, Li.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === e;
  }, Li.isForwardRef = function(S) {
    return w(S) === d;
  }, Li.isFragment = function(S) {
    return w(S) === n;
  }, Li.isLazy = function(S) {
    return w(S) === g;
  }, Li.isMemo = function(S) {
    return w(S) === f;
  }, Li.isPortal = function(S) {
    return w(S) === t;
  }, Li.isProfiler = function(S) {
    return w(S) === s;
  }, Li.isStrictMode = function(S) {
    return w(S) === r;
  }, Li.isSuspense = function(S) {
    return w(S) === u;
  }, Li.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === c || S === s || S === r || S === u || S === h || typeof S == "object" && S !== null && (S.$$typeof === g || S.$$typeof === f || S.$$typeof === o || S.$$typeof === a || S.$$typeof === d || S.$$typeof === m || S.$$typeof === _ || S.$$typeof === b || S.$$typeof === p);
  }, Li.typeOf = w, Li;
}
var Ii = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hte;
function Elt() {
  return Hte || (Hte = 1, process.env.NODE_ENV !== "production" && function() {
    var i = typeof Symbol == "function" && Symbol.for, e = i ? Symbol.for("react.element") : 60103, t = i ? Symbol.for("react.portal") : 60106, n = i ? Symbol.for("react.fragment") : 60107, r = i ? Symbol.for("react.strict_mode") : 60108, s = i ? Symbol.for("react.profiler") : 60114, o = i ? Symbol.for("react.provider") : 60109, a = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, c = i ? Symbol.for("react.concurrent_mode") : 60111, d = i ? Symbol.for("react.forward_ref") : 60112, u = i ? Symbol.for("react.suspense") : 60113, h = i ? Symbol.for("react.suspense_list") : 60120, f = i ? Symbol.for("react.memo") : 60115, g = i ? Symbol.for("react.lazy") : 60116, p = i ? Symbol.for("react.block") : 60121, m = i ? Symbol.for("react.fundamental") : 60117, _ = i ? Symbol.for("react.responder") : 60118, b = i ? Symbol.for("react.scope") : 60119;
    function w(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === n || j === c || j === s || j === r || j === u || j === h || typeof j == "object" && j !== null && (j.$$typeof === g || j.$$typeof === f || j.$$typeof === o || j.$$typeof === a || j.$$typeof === d || j.$$typeof === m || j.$$typeof === _ || j.$$typeof === b || j.$$typeof === p);
    }
    function y(j) {
      if (typeof j == "object" && j !== null) {
        var he = j.$$typeof;
        switch (he) {
          case e:
            var Se = j.type;
            switch (Se) {
              case l:
              case c:
              case n:
              case s:
              case r:
              case u:
                return Se;
              default:
                var ge = Se && Se.$$typeof;
                switch (ge) {
                  case a:
                  case d:
                  case g:
                  case f:
                  case o:
                    return ge;
                  default:
                    return he;
                }
            }
          case t:
            return he;
        }
      }
    }
    var S = l, x = c, D = a, E = o, L = e, k = d, N = n, I = g, A = f, P = t, O = s, K = r, W = u, F = !1;
    function q(j) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(j) || y(j) === l;
    }
    function R(j) {
      return y(j) === c;
    }
    function T(j) {
      return y(j) === a;
    }
    function z(j) {
      return y(j) === o;
    }
    function X(j) {
      return typeof j == "object" && j !== null && j.$$typeof === e;
    }
    function ae(j) {
      return y(j) === d;
    }
    function ue(j) {
      return y(j) === n;
    }
    function se(j) {
      return y(j) === g;
    }
    function le(j) {
      return y(j) === f;
    }
    function oe(j) {
      return y(j) === t;
    }
    function re(j) {
      return y(j) === s;
    }
    function B(j) {
      return y(j) === r;
    }
    function ee(j) {
      return y(j) === u;
    }
    Ii.AsyncMode = S, Ii.ConcurrentMode = x, Ii.ContextConsumer = D, Ii.ContextProvider = E, Ii.Element = L, Ii.ForwardRef = k, Ii.Fragment = N, Ii.Lazy = I, Ii.Memo = A, Ii.Portal = P, Ii.Profiler = O, Ii.StrictMode = K, Ii.Suspense = W, Ii.isAsyncMode = q, Ii.isConcurrentMode = R, Ii.isContextConsumer = T, Ii.isContextProvider = z, Ii.isElement = X, Ii.isForwardRef = ae, Ii.isFragment = ue, Ii.isLazy = se, Ii.isMemo = le, Ii.isPortal = oe, Ii.isProfiler = re, Ii.isStrictMode = B, Ii.isSuspense = ee, Ii.isValidElementType = w, Ii.typeOf = y;
  }()), Ii;
}
var Wte;
function h_e() {
  return Wte || (Wte = 1, process.env.NODE_ENV === "production" ? i3.exports = Dlt() : i3.exports = Elt()), i3.exports;
}
var WN, jte;
function $G() {
  if (jte) return WN;
  jte = 1;
  var i = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return WN = i, WN;
}
var jN, zte;
function f_e() {
  return zte || (zte = 1, jN = Function.call.bind(Object.prototype.hasOwnProperty)), jN;
}
var zN, Ute;
function Llt() {
  if (Ute) return zN;
  Ute = 1;
  var i = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = $G(), t = {}, n = f_e();
    i = function(s) {
      var o = "Warning: " + s;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function r(s, o, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in s)
        if (n(s, d)) {
          var u;
          try {
            if (typeof s[d] != "function") {
              var h = Error(
                (l || "React class") + ": " + a + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            u = s[d](o, d, l, a, null, e);
          } catch (g) {
            u = g;
          }
          if (u && !(u instanceof Error) && i(
            (l || "React class") + ": type specification of " + a + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in t)) {
            t[u.message] = !0;
            var f = c ? c() : "";
            i(
              "Failed " + a + " type: " + u.message + (f ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, zN = r, zN;
}
var UN, Gte;
function Ilt() {
  if (Gte) return UN;
  Gte = 1;
  var i = h_e(), e = NW(), t = $G(), n = f_e(), r = Llt(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return UN = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function u(R) {
      var T = R && (c && R[c] || R[d]);
      if (typeof T == "function")
        return T;
    }
    var h = "<<anonymous>>", f = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: b(),
      arrayOf: w,
      element: y(),
      elementType: S(),
      instanceOf: x,
      node: k(),
      objectOf: E,
      oneOf: D,
      oneOfType: L,
      shape: I,
      exact: A
    };
    function g(R, T) {
      return R === T ? R !== 0 || 1 / R === 1 / T : R !== R && T !== T;
    }
    function p(R, T) {
      this.message = R, this.data = T && typeof T == "object" ? T : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function m(R) {
      if (process.env.NODE_ENV !== "production")
        var T = {}, z = 0;
      function X(ue, se, le, oe, re, B, ee) {
        if (oe = oe || h, B = B || le, ee !== t) {
          if (l) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var he = oe + ":" + le;
            !T[he] && // Avoid spamming the console because they are often not actionable except for lib authors
            z < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + B + "` prop on `" + oe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), T[he] = !0, z++);
          }
        }
        return se[le] == null ? ue ? se[le] === null ? new p("The " + re + " `" + B + "` is marked as required " + ("in `" + oe + "`, but its value is `null`.")) : new p("The " + re + " `" + B + "` is marked as required in " + ("`" + oe + "`, but its value is `undefined`.")) : null : R(se, le, oe, re, B);
      }
      var ae = X.bind(null, !1);
      return ae.isRequired = X.bind(null, !0), ae;
    }
    function _(R) {
      function T(z, X, ae, ue, se, le) {
        var oe = z[X], re = K(oe);
        if (re !== R) {
          var B = W(oe);
          return new p(
            "Invalid " + ue + " `" + se + "` of type " + ("`" + B + "` supplied to `" + ae + "`, expected ") + ("`" + R + "`."),
            { expectedType: R }
          );
        }
        return null;
      }
      return m(T);
    }
    function b() {
      return m(o);
    }
    function w(R) {
      function T(z, X, ae, ue, se) {
        if (typeof R != "function")
          return new p("Property `" + se + "` of component `" + ae + "` has invalid PropType notation inside arrayOf.");
        var le = z[X];
        if (!Array.isArray(le)) {
          var oe = K(le);
          return new p("Invalid " + ue + " `" + se + "` of type " + ("`" + oe + "` supplied to `" + ae + "`, expected an array."));
        }
        for (var re = 0; re < le.length; re++) {
          var B = R(le, re, ae, ue, se + "[" + re + "]", t);
          if (B instanceof Error)
            return B;
        }
        return null;
      }
      return m(T);
    }
    function y() {
      function R(T, z, X, ae, ue) {
        var se = T[z];
        if (!a(se)) {
          var le = K(se);
          return new p("Invalid " + ae + " `" + ue + "` of type " + ("`" + le + "` supplied to `" + X + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(R);
    }
    function S() {
      function R(T, z, X, ae, ue) {
        var se = T[z];
        if (!i.isValidElementType(se)) {
          var le = K(se);
          return new p("Invalid " + ae + " `" + ue + "` of type " + ("`" + le + "` supplied to `" + X + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(R);
    }
    function x(R) {
      function T(z, X, ae, ue, se) {
        if (!(z[X] instanceof R)) {
          var le = R.name || h, oe = q(z[X]);
          return new p("Invalid " + ue + " `" + se + "` of type " + ("`" + oe + "` supplied to `" + ae + "`, expected ") + ("instance of `" + le + "`."));
        }
        return null;
      }
      return m(T);
    }
    function D(R) {
      if (!Array.isArray(R))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), o;
      function T(z, X, ae, ue, se) {
        for (var le = z[X], oe = 0; oe < R.length; oe++)
          if (g(le, R[oe]))
            return null;
        var re = JSON.stringify(R, function(ee, j) {
          var he = W(j);
          return he === "symbol" ? String(j) : j;
        });
        return new p("Invalid " + ue + " `" + se + "` of value `" + String(le) + "` " + ("supplied to `" + ae + "`, expected one of " + re + "."));
      }
      return m(T);
    }
    function E(R) {
      function T(z, X, ae, ue, se) {
        if (typeof R != "function")
          return new p("Property `" + se + "` of component `" + ae + "` has invalid PropType notation inside objectOf.");
        var le = z[X], oe = K(le);
        if (oe !== "object")
          return new p("Invalid " + ue + " `" + se + "` of type " + ("`" + oe + "` supplied to `" + ae + "`, expected an object."));
        for (var re in le)
          if (n(le, re)) {
            var B = R(le, re, ae, ue, se + "." + re, t);
            if (B instanceof Error)
              return B;
          }
        return null;
      }
      return m(T);
    }
    function L(R) {
      if (!Array.isArray(R))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var T = 0; T < R.length; T++) {
        var z = R[T];
        if (typeof z != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(z) + " at index " + T + "."
          ), o;
      }
      function X(ae, ue, se, le, oe) {
        for (var re = [], B = 0; B < R.length; B++) {
          var ee = R[B], j = ee(ae, ue, se, le, oe, t);
          if (j == null)
            return null;
          j.data && n(j.data, "expectedType") && re.push(j.data.expectedType);
        }
        var he = re.length > 0 ? ", expected one of type [" + re.join(", ") + "]" : "";
        return new p("Invalid " + le + " `" + oe + "` supplied to " + ("`" + se + "`" + he + "."));
      }
      return m(X);
    }
    function k() {
      function R(T, z, X, ae, ue) {
        return P(T[z]) ? null : new p("Invalid " + ae + " `" + ue + "` supplied to " + ("`" + X + "`, expected a ReactNode."));
      }
      return m(R);
    }
    function N(R, T, z, X, ae) {
      return new p(
        (R || "React class") + ": " + T + " type `" + z + "." + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ae + "`."
      );
    }
    function I(R) {
      function T(z, X, ae, ue, se) {
        var le = z[X], oe = K(le);
        if (oe !== "object")
          return new p("Invalid " + ue + " `" + se + "` of type `" + oe + "` " + ("supplied to `" + ae + "`, expected `object`."));
        for (var re in R) {
          var B = R[re];
          if (typeof B != "function")
            return N(ae, ue, se, re, W(B));
          var ee = B(le, re, ae, ue, se + "." + re, t);
          if (ee)
            return ee;
        }
        return null;
      }
      return m(T);
    }
    function A(R) {
      function T(z, X, ae, ue, se) {
        var le = z[X], oe = K(le);
        if (oe !== "object")
          return new p("Invalid " + ue + " `" + se + "` of type `" + oe + "` " + ("supplied to `" + ae + "`, expected `object`."));
        var re = e({}, z[X], R);
        for (var B in re) {
          var ee = R[B];
          if (n(R, B) && typeof ee != "function")
            return N(ae, ue, se, B, W(ee));
          if (!ee)
            return new p(
              "Invalid " + ue + " `" + se + "` key `" + B + "` supplied to `" + ae + "`.\nBad object: " + JSON.stringify(z[X], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(R), null, "  ")
            );
          var j = ee(le, B, ae, ue, se + "." + B, t);
          if (j)
            return j;
        }
        return null;
      }
      return m(T);
    }
    function P(R) {
      switch (typeof R) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !R;
        case "object":
          if (Array.isArray(R))
            return R.every(P);
          if (R === null || a(R))
            return !0;
          var T = u(R);
          if (T) {
            var z = T.call(R), X;
            if (T !== R.entries) {
              for (; !(X = z.next()).done; )
                if (!P(X.value))
                  return !1;
            } else
              for (; !(X = z.next()).done; ) {
                var ae = X.value;
                if (ae && !P(ae[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function O(R, T) {
      return R === "symbol" ? !0 : T ? T["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && T instanceof Symbol : !1;
    }
    function K(R) {
      var T = typeof R;
      return Array.isArray(R) ? "array" : R instanceof RegExp ? "object" : O(T, R) ? "symbol" : T;
    }
    function W(R) {
      if (typeof R > "u" || R === null)
        return "" + R;
      var T = K(R);
      if (T === "object") {
        if (R instanceof Date)
          return "date";
        if (R instanceof RegExp)
          return "regexp";
      }
      return T;
    }
    function F(R) {
      var T = W(R);
      switch (T) {
        case "array":
        case "object":
          return "an " + T;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + T;
        default:
          return T;
      }
    }
    function q(R) {
      return !R.constructor || !R.constructor.name ? h : R.constructor.name;
    }
    return f.checkPropTypes = r, f.resetWarningCache = r.resetWarningCache, f.PropTypes = f, f;
  }, UN;
}
var GN, qte;
function Alt() {
  if (qte) return GN;
  qte = 1;
  var i = $G();
  function e() {
  }
  function t() {
  }
  return t.resetWarningCache = e, GN = function() {
    function n(o, a, l, c, d, u) {
      if (u !== i) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    n.isRequired = n;
    function r() {
      return n;
    }
    var s = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: r,
      element: n,
      elementType: n,
      instanceOf: r,
      node: n,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: t,
      resetWarningCache: e
    };
    return s.PropTypes = s, s;
  }, GN;
}
var Kte;
function mn() {
  if (Kte) return n3.exports;
  if (Kte = 1, process.env.NODE_ENV !== "production") {
    var i = h_e(), e = !0;
    n3.exports = Ilt()(i.isElement, e);
  } else
    n3.exports = Alt()();
  return n3.exports;
}
const gi = /* @__PURE__ */ L0($3e);
var qN, Yte;
function klt() {
  if (Yte) return qN;
  Yte = 1;
  var i = gi;
  function e(t) {
    return typeof i.isMoment == "function" && !i.isMoment(t) ? !1 : typeof t.isValid == "function" ? t.isValid() : !isNaN(t);
  }
  return qN = {
    isValidMoment: e
  }, qN;
}
var KN, Xte;
function Tlt() {
  if (Xte) return KN;
  Xte = 1;
  var i = {
    invalidPredicate: "`predicate` must be a function",
    invalidPropValidator: "`propValidator` must be a function",
    requiredCore: "is marked as required",
    invalidTypeCore: "Invalid input type",
    predicateFailureCore: "Failed to succeed with predicate",
    anonymousMessage: "<<anonymous>>",
    baseInvalidMessage: "Invalid "
  };
  function e(o) {
    if (typeof o != "function")
      throw new Error(i.invalidPropValidator);
    var a = o.bind(null, !1, null);
    return a.isRequired = o.bind(null, !0, null), a.withPredicate = function(c) {
      if (typeof c != "function")
        throw new Error(i.invalidPredicate);
      var d = o.bind(null, !1, c);
      return d.isRequired = o.bind(null, !0, c), d;
    }, a;
  }
  function t(o, a, l) {
    return new Error(
      "The prop `" + o + "` " + i.requiredCore + " in `" + a + "`, but its value is `" + l + "`."
    );
  }
  var n = -1;
  function r(o, a, l, c) {
    var d = typeof c > "u", u = c === null;
    if (o) {
      if (d)
        return t(l, a, "undefined");
      if (u)
        return t(l, a, "null");
    }
    return d || u ? null : n;
  }
  function s(o, a, l, c) {
    function d(u, h, f, g, p, m, _) {
      var b = f[g], w = typeof b;
      p = p || i.anonymousMessage, _ = _ || g;
      var y = r(
        u,
        p,
        _,
        b
      );
      if (y !== n)
        return y;
      if (a && !a(b))
        return new Error(
          i.invalidTypeCore + ": `" + g + "` of type `" + w + "` supplied to `" + p + "`, expected `" + o + "`."
        );
      if (!l(b))
        return new Error(
          i.baseInvalidMessage + m + " `" + g + "` of type `" + w + "` supplied to `" + p + "`, expected `" + c + "`."
        );
      if (h && !h(b)) {
        var S = h.name || i.anonymousMessage;
        return new Error(
          i.baseInvalidMessage + m + " `" + g + "` of type `" + w + "` supplied to `" + p + "`. " + i.predicateFailureCore + " `" + S + "`."
        );
      }
      return null;
    }
    return e(d);
  }
  return KN = {
    constructPropValidatorVariations: e,
    createMomentChecker: s,
    messages: i
  }, KN;
}
var YN, Zte;
function yd() {
  if (Zte) return YN;
  Zte = 1;
  var i = gi, e = klt(), t = Tlt();
  return YN = {
    momentObj: t.createMomentChecker(
      "object",
      function(n) {
        return typeof n == "object";
      },
      function(r) {
        return e.isValidMoment(r);
      },
      "Moment"
    ),
    momentString: t.createMomentChecker(
      "string",
      function(n) {
        return typeof n == "string";
      },
      function(r) {
        return e.isValidMoment(i(r));
      },
      "Moment"
    ),
    momentDurationObj: t.createMomentChecker(
      "object",
      function(n) {
        return typeof n == "object";
      },
      function(r) {
        return i.isDuration(r);
      },
      "Duration"
    )
  }, YN;
}
var XN, Qte;
function Nlt() {
  if (Qte) return XN;
  Qte = 1;
  function i() {
    return null;
  }
  i.isRequired = i;
  function e() {
    return i;
  }
  return XN = {
    and: e,
    between: e,
    booleanSome: e,
    childrenHavePropXorChildren: e,
    childrenOf: e,
    childrenOfType: e,
    childrenSequenceOf: e,
    componentWithName: e,
    disallowedIf: e,
    elementType: e,
    empty: e,
    explicitNull: e,
    forbidExtraProps: Object,
    integer: e,
    keysOf: e,
    mutuallyExclusiveProps: e,
    mutuallyExclusiveTrueProps: e,
    nChildren: e,
    nonNegativeInteger: i,
    nonNegativeNumber: e,
    numericString: e,
    object: e,
    or: e,
    predicate: e,
    range: e,
    ref: e,
    requiredBy: e,
    restrictedProp: e,
    sequenceOf: e,
    shape: e,
    stringEndsWith: e,
    stringStartsWith: e,
    uniqueArray: e,
    uniqueArrayOf: e,
    valuesOf: e,
    withShape: e
  }, XN;
}
var ZN, Jte;
function Xa() {
  if (Jte) return ZN;
  Jte = 1;
  var i = As(), e = Vu(), t = e(i("String.prototype.indexOf"));
  return ZN = function(r, s) {
    var o = i(r, !!s);
    return typeof o == "function" && t(r, ".prototype.") > -1 ? e(o) : o;
  }, ZN;
}
var QN, $te;
function g_e() {
  if ($te) return QN;
  $te = 1;
  var i = KG(), e = YG()(), t = Xa(), n = Object, r = t("Array.prototype.push"), s = t("Object.prototype.propertyIsEnumerable"), o = e ? Object.getOwnPropertySymbols : null;
  return QN = function(l, c) {
    if (l == null)
      throw new TypeError("target must be an object");
    var d = n(l);
    if (arguments.length === 1)
      return d;
    for (var u = 1; u < arguments.length; ++u) {
      var h = n(arguments[u]), f = i(h), g = e && (Object.getOwnPropertySymbols || o);
      if (g)
        for (var p = g(h), m = 0; m < p.length; ++m) {
          var _ = p[m];
          s(h, _) && r(f, _);
        }
      for (var b = 0; b < f.length; ++b) {
        var w = f[b];
        if (s(h, w)) {
          var y = h[w];
          d[w] = y;
        }
      }
    }
    return d;
  }, QN;
}
var JN, ene;
function p_e() {
  if (ene) return JN;
  ene = 1;
  var i = g_e(), e = function() {
    if (!Object.assign)
      return !1;
    for (var n = "abcdefghijklmnopqrst", r = n.split(""), s = {}, o = 0; o < r.length; ++o)
      s[r[o]] = r[o];
    var a = Object.assign({}, s), l = "";
    for (var c in a)
      l += c;
    return n !== l;
  }, t = function() {
    if (!Object.assign || !Object.preventExtensions)
      return !1;
    var n = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(n, "xy");
    } catch {
      return n[1] === "y";
    }
    return !1;
  };
  return JN = function() {
    return !Object.assign || e() || t() ? i : Object.assign;
  }, JN;
}
var $N, tne;
function Plt() {
  if (tne) return $N;
  tne = 1;
  var i = Xr(), e = p_e();
  return $N = function() {
    var n = e();
    return i(
      Object,
      { assign: n },
      { assign: function() {
        return Object.assign !== n;
      } }
    ), n;
  }, $N;
}
var e9, nne;
function m_e() {
  if (nne) return e9;
  nne = 1;
  var i = Xr(), e = Vu(), t = g_e(), n = p_e(), r = Plt(), s = e.apply(n()), o = function(l, c) {
    return s(Object, arguments);
  };
  return i(o, {
    getPolyfill: n,
    implementation: t,
    shim: r
  }), e9 = o, e9;
}
var t9, ine;
function Olt() {
  if (ine) return t9;
  ine = 1;
  var i = As(), e = Vu(), t = Xa(), n = i("%Reflect.ownKeys%", !0), r = e.apply(i("%Array.prototype.push%")), s = t("Symbol.prototype.valueOf", !0), o = i("%Object.getOwnPropertyNames%", !0), a = s ? i("%Object.getOwnPropertySymbols%") : null, l = KG();
  return t9 = n || function(d) {
    var u = (o || l)(d);
    return a && r(u, a(d)), u;
  }, t9;
}
var n9, rne;
function v_e() {
  if (rne) return n9;
  rne = 1;
  var i = Olt();
  return n9 = function(t) {
    return i(t);
  }, n9;
}
var i9, sne;
function __e() {
  if (sne) return i9;
  sne = 1;
  var i = v_e();
  return i9 = function() {
    return typeof Reflect == "object" && typeof Reflect.ownKeys == "function" ? Reflect.ownKeys : i;
  }, i9;
}
var r9, one;
function b_e() {
  if (one) return r9;
  one = 1;
  var i = As(), e = i("%Array%"), t = !e.isArray && Xa()("Object.prototype.toString");
  return r9 = e.isArray || function(r) {
    return t(r) === "[object Array]";
  }, r9;
}
var s9, ane;
function eq() {
  if (ane) return s9;
  ane = 1;
  var i = ZG(), e = rk(), t = i.hasArrayLengthDefineBug(), n = t && b_e(), r = Xa(), s = r("Object.prototype.propertyIsEnumerable");
  return s9 = function(a, l, c, d, u, h) {
    if (!e) {
      if (!a(h) || !h["[[Configurable]]"] || !h["[[Writable]]"] || u in d && s(d, u) !== !!h["[[Enumerable]]"])
        return !1;
      var f = h["[[Value]]"];
      return d[u] = f, l(d[u], f);
    }
    return t && u === "length" && "[[Value]]" in h && n(d) && d.length !== h["[[Value]]"] ? (d.length = h["[[Value]]"], d.length === h["[[Value]]"]) : (e(d, u, c(h)), !0);
  }, s9;
}
var o9, lne;
function bp() {
  if (lne) return o9;
  lne = 1;
  var i = Jn(), e = Bu(), t = {
    __proto__: null,
    "[[Configurable]]": !0,
    "[[Enumerable]]": !0,
    "[[Get]]": !0,
    "[[Set]]": !0,
    "[[Value]]": !0,
    "[[Writable]]": !0
  };
  return o9 = function(r) {
    if (!r || typeof r != "object")
      return !1;
    for (var s in r)
      if (e(r, s) && !t[s])
        return !1;
    var o = e(r, "[[Value]]") || e(r, "[[Writable]]"), a = e(r, "[[Get]]") || e(r, "[[Set]]");
    if (o && a)
      throw new i("Property Descriptors may not be both accessor and data descriptors");
    return !0;
  }, o9;
}
var a9, cne;
function Mlt() {
  return cne || (cne = 1, a9 = function(e) {
    if (typeof e > "u")
      return e;
    var t = {};
    return "[[Value]]" in e && (t.value = e["[[Value]]"]), "[[Writable]]" in e && (t.writable = !!e["[[Writable]]"]), "[[Get]]" in e && (t.get = e["[[Get]]"]), "[[Set]]" in e && (t.set = e["[[Set]]"]), "[[Enumerable]]" in e && (t.enumerable = !!e["[[Enumerable]]"]), "[[Configurable]]" in e && (t.configurable = !!e["[[Configurable]]"]), t;
  }), a9;
}
var l9, dne;
function tq() {
  if (dne) return l9;
  dne = 1;
  var i = Jn(), e = bp(), t = Mlt();
  return l9 = function(r) {
    if (typeof r < "u" && !e(r))
      throw new i("Assertion failed: `Desc` must be a Property Descriptor");
    return t(r);
  }, l9;
}
var c9, une;
function ok() {
  if (une) return c9;
  une = 1;
  var i = Jn(), e = Bu(), t = bp();
  return c9 = function(r) {
    if (typeof r > "u")
      return !1;
    if (!t(r))
      throw new i("Assertion failed: `Desc` must be a Property Descriptor");
    return !(!e(r, "[[Value]]") && !e(r, "[[Writable]]"));
  }, c9;
}
var d9, hne;
function pf() {
  return hne || (hne = 1, d9 = function(e) {
    return typeof e == "string" || typeof e == "symbol";
  }), d9;
}
var u9, fne;
function lx() {
  return fne || (fne = 1, u9 = Number.isNaN || function(e) {
    return e !== e;
  }), u9;
}
var h9, gne;
function ak() {
  if (gne) return h9;
  gne = 1;
  var i = lx();
  return h9 = function(t, n) {
    return t === n ? t === 0 ? 1 / t === 1 / n : !0 : i(t) && i(n);
  }, h9;
}
var f9, pne;
function Rlt() {
  return pne || (pne = 1, f9 = function(e) {
    if (e === null)
      return "Null";
    if (typeof e > "u")
      return "Undefined";
    if (typeof e == "function" || typeof e == "object")
      return "Object";
    if (typeof e == "number")
      return "Number";
    if (typeof e == "boolean")
      return "Boolean";
    if (typeof e == "string")
      return "String";
  }), f9;
}
var g9, mne;
function _c() {
  if (mne) return g9;
  mne = 1;
  var i = Rlt();
  return g9 = function(t) {
    return typeof t == "symbol" ? "Symbol" : typeof t == "bigint" ? "BigInt" : i(t);
  }, g9;
}
var p9, vne;
function Flt() {
  if (vne) return p9;
  vne = 1;
  var i = Jn(), e = eq(), t = tq(), n = ok(), r = pf(), s = ak(), o = _c();
  return p9 = function(l, c, d) {
    if (o(l) !== "Object")
      throw new i("Assertion failed: Type(O) is not Object");
    if (!r(c))
      throw new i("Assertion failed: IsPropertyKey(P) is not true");
    var u = {
      "[[Configurable]]": !0,
      "[[Enumerable]]": !1,
      "[[Value]]": d,
      "[[Writable]]": !0
    };
    return e(
      n,
      s,
      t,
      l,
      c,
      u
    );
  }, p9;
}
var m9, _ne;
function nq() {
  if (_ne) return m9;
  _ne = 1;
  var i = YG();
  return m9 = function() {
    return i() && !!Symbol.toStringTag;
  }, m9;
}
var v9, bne;
function Blt() {
  if (bne) return v9;
  bne = 1;
  var i = As(), e = i("%Object.defineProperty%", !0), t = nq()(), n = Bu(), r = t ? Symbol.toStringTag : null;
  return v9 = function(o, a) {
    var l = arguments.length > 2 && arguments[2] && arguments[2].force;
    r && (l || !n(o, r)) && (e ? e(o, r, {
      configurable: !0,
      enumerable: !1,
      value: a,
      writable: !1
    }) : o[r] = a);
  }, v9;
}
var I2 = { exports: {} }, Cne;
function C_e() {
  return Cne || (Cne = 1, typeof self < "u" ? I2.exports = self : typeof window < "u" ? I2.exports = window : I2.exports = Function("return this")()), I2.exports;
}
var _9, yne;
function y_e() {
  if (yne) return _9;
  yne = 1;
  var i = C_e();
  return _9 = function() {
    return typeof Zs != "object" || !Zs || Zs.Math !== Math || Zs.Array !== Array ? i : Zs;
  }, _9;
}
var b9, wne;
function Vlt() {
  if (wne) return b9;
  wne = 1;
  var i = Xr(), e = sk(), t = y_e();
  return b9 = function() {
    var r = t();
    if (i.supportsDescriptors) {
      var s = e(r, "globalThis");
      (!s || s.configurable && (s.enumerable || !s.writable || globalThis !== r)) && Object.defineProperty(r, "globalThis", {
        configurable: !0,
        enumerable: !1,
        value: r,
        writable: !0
      });
    } else (typeof globalThis != "object" || globalThis !== r) && (r.globalThis = r);
    return r;
  }, b9;
}
var C9, Sne;
function Hlt() {
  if (Sne) return C9;
  Sne = 1;
  var i = Xr(), e = C_e(), t = y_e(), n = Vlt(), r = t(), s = function() {
    return r;
  };
  return i(s, {
    getPolyfill: t,
    implementation: e,
    shim: n
  }), C9 = s, C9;
}
var y9, xne;
function Wlt() {
  if (xne) return y9;
  xne = 1;
  var i = Flt(), e = Blt(), t = Hlt()(), n = __e();
  return y9 = function() {
    if (typeof Reflect > "u") {
      var s = {};
      e(s, "Reflect"), i(t, "Reflect", s);
    }
    var o = n();
    return o !== Reflect.ownKeys && i(Reflect, "ownKeys", o), o;
  }, y9;
}
var w9, Dne;
function jlt() {
  if (Dne) return w9;
  Dne = 1;
  var i = Xr(), e = Vu(), t = v_e(), n = __e(), r = Wlt(), s = e(n(), null);
  return i(s, {
    getPolyfill: n,
    implementation: t,
    shim: r
  }), w9 = s, w9;
}
var S9, Ene;
function zlt() {
  if (Ene) return S9;
  Ene = 1;
  var i = {}.toString;
  return S9 = Array.isArray || function(e) {
    return i.call(e) == "[object Array]";
  }, S9;
}
var x9, Lne;
function w_e() {
  if (Lne) return x9;
  Lne = 1;
  var i = zlt();
  return x9 = function(t) {
    return t && typeof t == "object" && !i(t);
  }, x9;
}
var D9, Ine;
function Ult() {
  if (Ine) return D9;
  Ine = 1;
  var i = m_e(), e = Bu(), t = jlt(), n = Jn(), r = w_e(), s = "​", o = "prop-types-exact: " + s, a = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for(o) : (
    /* istanbul ignore next */
    o
  );
  function l(d) {
    return d[o] = a, d;
  }
  function c(d) {
    return d && d[o] === a;
  }
  return D9 = function(u) {
    if (!r(u))
      throw new n("given propTypes must be an object");
    if (e(u, o) && !c(u[o]))
      throw new n("Against all odds, you created a propType for a prop that uses both the zero-width space and our custom string - which, sadly, conflicts with `prop-types-exact`");
    var h = {};
    return h[o] = l(function(g, p, m) {
      var _ = t(g).filter(function(b) {
        return !e(u, b);
      });
      return _.length > 0 ? new n(m + ": unknown props found: " + _.join(", ")) : null;
    }), i({}, u, h);
  }, D9;
}
var E9 = {}, L9 = {}, Ane;
function pi() {
  return Ane || (Ane = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = n;
    var e = t(m_e());
    function t(r) {
      return r && r.__esModule ? r : { default: r };
    }
    function n(r, s) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      return (0, e.default)(r.bind(), {
        typeName: s,
        typeChecker: o,
        isRequired: (0, e.default)(r.isRequired.bind(), {
          typeName: s,
          typeChecker: o,
          typeRequired: !0
        })
      });
    }
  }(L9)), L9;
}
var kne;
function Q0() {
  return kne || (kne = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = n;
    var e = t(pi());
    function t(r) {
      return r && r.__esModule ? r : { default: r };
    }
    function n(r) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "and";
      if (!Array.isArray(r))
        throw new TypeError("and: 2 or more validators are required");
      if (r.length <= 1)
        throw new RangeError("and: 2 or more validators are required");
      var o = function() {
        for (var l = arguments.length, c = new Array(l), d = 0; d < l; d++)
          c[d] = arguments[d];
        var u = null;
        return r.some(function(h) {
          return u = h.apply(void 0, c), u != null;
        }), u ?? null;
      };
      return o.isRequired = function() {
        for (var l = arguments.length, c = new Array(l), d = 0; d < l; d++)
          c[d] = arguments[d];
        var u = null;
        return r.some(function(h) {
          return u = h.isRequired.apply(h, c), u != null;
        }), u ?? null;
      }, (0, e.default)(o, s, r);
    }
  }(E9)), E9;
}
var I9 = {}, A9, Tne;
function Pb() {
  if (Tne) return A9;
  Tne = 1;
  var i = Jn();
  return A9 = function(t) {
    if (t == null)
      throw new i(arguments.length > 0 && arguments[1] || "Cannot call method on " + t);
    return t;
  }, A9;
}
var k9, Nne;
function S_e() {
  if (Nne) return k9;
  Nne = 1;
  var i = Pb(), e = Xa(), t = e("Object.prototype.propertyIsEnumerable"), n = e("Array.prototype.push");
  return k9 = function(s) {
    var o = i(s), a = [];
    for (var l in o)
      t(o, l) && n(a, [l, o[l]]);
    return a;
  }, k9;
}
var T9, Pne;
function x_e() {
  if (Pne) return T9;
  Pne = 1;
  var i = S_e();
  return T9 = function() {
    return typeof Object.entries == "function" ? Object.entries : i;
  }, T9;
}
var N9, One;
function Glt() {
  if (One) return N9;
  One = 1;
  var i = x_e(), e = Xr();
  return N9 = function() {
    var n = i();
    return e(Object, { entries: n }, {
      entries: function() {
        return Object.entries !== n;
      }
    }), n;
  }, N9;
}
var P9, Mne;
function qlt() {
  if (Mne) return P9;
  Mne = 1;
  var i = Xr(), e = Vu(), t = S_e(), n = x_e(), r = Glt(), s = e(n(), Object);
  return i(s, {
    getPolyfill: n,
    implementation: t,
    shim: r
  }), P9 = s, P9;
}
var O9 = {}, M9 = {}, Rne;
function iq() {
  return Rne || (Rne = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = t(w_e());
    function t(r) {
      return r && r.__esModule ? r : { default: r };
    }
    var n = e.default;
    i.default = n;
  }(M9)), M9;
}
var Fne;
function rq() {
  return Fne || (Fne = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = n(iq()), t = n(pi());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r(s) {
      if (!(0, e.default)(s))
        throw new TypeError("shape must be a normal object");
      function o(a, l, c, d) {
        var u = a[l];
        if (u == null)
          return null;
        for (var h = arguments.length, f = new Array(h > 4 ? h - 4 : 0), g = 4; g < h; g++)
          f[g - 4] = arguments[g];
        for (var p in s) {
          var m = s[p];
          if (m) {
            var _ = m.apply(void 0, [u, p, c, d].concat(f));
            if (_)
              return _;
          }
        }
        return null;
      }
      return o.isRequired = function(l, c, d) {
        var u = l[c];
        if (u == null)
          return new TypeError("".concat(d, ": ").concat(c, " is required."));
        for (var h = arguments.length, f = new Array(h > 3 ? h - 3 : 0), g = 3; g < h; g++)
          f[g - 3] = arguments[g];
        return o.apply(void 0, [l, c, d].concat(f));
      }, (0, t.default)(o, "shape", s);
    }
  }(O9)), O9;
}
var R9 = {}, F9 = {}, Bne;
function D_e() {
  return Bne || (Bne = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = t;
    function e(n) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(s) {
        return typeof s;
      } : e = function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, e(n);
    }
    function t(n) {
      return !n || e(n) !== "object" && typeof n != "function";
    }
  }(F9)), F9;
}
var Vne;
function E_e() {
  return Vne || (Vne = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = n(D_e()), t = n(pi());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r(s) {
      if (typeof s != "function")
        throw new TypeError("objectOf: propType must be a function");
      var o = function(l, c, d, u, h) {
        for (var f = arguments.length, g = new Array(f > 5 ? f - 5 : 0), p = 5; p < f; p++)
          g[p - 5] = arguments[p];
        var m = l[c];
        if (m == null || (0, e.default)(m))
          return null;
        var _;
        return Object.keys(m).some(function(b) {
          return _ = s.apply(void 0, [m, b, d, u, "".concat(h, ".").concat(b)].concat(g)), _;
        }), _ || null;
      };
      return o.isRequired = function(l, c, d) {
        var u = l[c];
        if (u == null)
          return new TypeError("".concat(d, ": ").concat(c, " is required."));
        for (var h = arguments.length, f = new Array(h > 3 ? h - 3 : 0), g = 3; g < h; g++)
          f[g - 3] = arguments[g];
        return o.apply(void 0, [l, c, d].concat(f));
      }, (0, t.default)(o, "valuesOf", s);
    }
  }(R9)), R9;
}
var Hne;
function sq() {
  return Hne || (Hne = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = I;
    var e = s(qlt()), t = s(rq()), n = s(E_e()), r = s(pi());
    function s(A) {
      return A && A.__esModule ? A : { default: A };
    }
    function o(A) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o = function(O) {
        return typeof O;
      } : o = function(O) {
        return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
      }, o(A);
    }
    function a(A, P) {
      var O = Object.keys(A);
      if (Object.getOwnPropertySymbols) {
        var K = Object.getOwnPropertySymbols(A);
        P && (K = K.filter(function(W) {
          return Object.getOwnPropertyDescriptor(A, W).enumerable;
        })), O.push.apply(O, K);
      }
      return O;
    }
    function l(A) {
      for (var P = 1; P < arguments.length; P++) {
        var O = arguments[P] != null ? arguments[P] : {};
        P % 2 ? a(Object(O), !0).forEach(function(K) {
          c(A, K, O[K]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(O)) : a(Object(O)).forEach(function(K) {
          Object.defineProperty(A, K, Object.getOwnPropertyDescriptor(O, K));
        });
      }
      return A;
    }
    function c(A, P, O) {
      return P in A ? Object.defineProperty(A, P, { value: O, enumerable: !0, configurable: !0, writable: !0 }) : A[P] = O, A;
    }
    function d(A, P) {
      return p(A) || g(A, P) || h(A, P) || u();
    }
    function u() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function h(A, P) {
      if (A) {
        if (typeof A == "string") return f(A, P);
        var O = Object.prototype.toString.call(A).slice(8, -1);
        if (O === "Object" && A.constructor && (O = A.constructor.name), O === "Map" || O === "Set") return Array.from(A);
        if (O === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(O)) return f(A, P);
      }
    }
    function f(A, P) {
      (P == null || P > A.length) && (P = A.length);
      for (var O = 0, K = new Array(P); O < P; O++)
        K[O] = A[O];
      return K;
    }
    function g(A, P) {
      if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(A)))) {
        var O = [], K = !0, W = !1, F = void 0;
        try {
          for (var q = A[Symbol.iterator](), R; !(K = (R = q.next()).done) && (O.push(R.value), !(P && O.length === P)); K = !0)
            ;
        } catch (T) {
          W = !0, F = T;
        } finally {
          try {
            !K && q.return != null && q.return();
          } finally {
            if (W) throw F;
          }
        }
        return O;
      }
    }
    function p(A) {
      if (Array.isArray(A)) return A;
    }
    function m(A, P, O) {
      var K = A[P];
      return typeof K == "number" && !isNaN(K) ? null : new TypeError("".concat(O, ": ").concat(P, " must be a non-NaN number."));
    }
    function _(A, P) {
      var O = A[P];
      return typeof O == "function" || typeof O == "number" && !isNaN(O) ? null : new TypeError("".concat(P, ": a function, or a non-NaN number is required"));
    }
    function b(A, P) {
      var O = P.gt, K = P.gte;
      return typeof O == "number" ? A > O : typeof K == "number" ? A >= K : !0;
    }
    function w(A, P) {
      var O = P.lt, K = P.lte;
      return typeof O == "number" ? A < O : typeof K == "number" ? A <= K : !0;
    }
    function y(A) {
      var P = A.gt, O = A.gte;
      return typeof P == "number" ? "greater than ".concat(P) : typeof O == "number" ? "greater than or equal to ".concat(O) : "";
    }
    function S(A) {
      var P = A.lt, O = A.lte;
      return typeof P == "number" ? "less than ".concat(P) : typeof O == "number" ? "less than or equal to ".concat(O) : "";
    }
    function x(A, P, O) {
      var K = [y(O), S(O)].filter(Boolean).join(" and ");
      return "".concat(A, ": ").concat(P, " must be ").concat(K);
    }
    function D(A) {
      return (0, e.default)(A).reduce(function(P, O) {
        var K = d(O, 2), W = K[0], F = K[1], q = typeof F == "number" ? function() {
          return F;
        } : F;
        return l(l({}, P), {}, c({}, W, q));
      }, {});
    }
    function E(A, P) {
      return (0, e.default)(A).reduce(function(O, K) {
        var W = d(K, 2), F = W[0], q = W[1], R = q(P);
        return l(l({}, O), {}, c({}, F, R));
      }, {});
    }
    var L = [(0, t.default)({
      lt: _,
      gt: _
    }).isRequired, (0, t.default)({
      lte: _,
      gt: _
    }).isRequired, (0, t.default)({
      lt: _,
      gte: _
    }).isRequired, (0, t.default)({
      lte: _,
      gte: _
    }).isRequired, (0, t.default)({
      lt: _
    }).isRequired, (0, t.default)({
      lte: _
    }).isRequired, (0, t.default)({
      gt: _
    }).isRequired, (0, t.default)({
      gte: _
    }).isRequired];
    function k(A, P) {
      return L.every(function(O) {
        return !!O(A, P);
      });
    }
    var N = (0, n.default)(m).isRequired;
    function I(A) {
      var P = k({
        options: A
      }, "options");
      if (P)
        throw new TypeError("between: only one of the pairs of `lt`/`lte`, and `gt`/`gte`, may be supplied, and at least one pair must be provided.");
      var O = D(A), K = function(F, q, R) {
        var T = F[q];
        if (T == null)
          return null;
        if (typeof T != "number")
          return new RangeError("".concat(R, ": ").concat(q, ' must be a number, got "').concat(o(T), '"'));
        for (var z = E(O, F), X = arguments.length, ae = new Array(X > 3 ? X - 3 : 0), ue = 3; ue < X; ue++)
          ae[ue - 3] = arguments[ue];
        var se = N.apply(void 0, [c({}, q, z), q, R].concat(ae));
        return se || (!b(T, z) || !w(T, z) ? new RangeError(x(R, q, z)) : null);
      };
      return K.isRequired = function(F, q, R) {
        var T = F[q];
        if (typeof T != "number")
          return new RangeError("".concat(R, ": ").concat(q, ' must be a number, got "').concat(o(T), '"'));
        for (var z = E(O, F), X = arguments.length, ae = new Array(X > 3 ? X - 3 : 0), ue = 3; ue < X; ue++)
          ae[ue - 3] = arguments[ue];
        var se = N.apply(void 0, [c({}, q, z), q, R].concat(ae));
        return se || (!b(T, z) || !w(T, z) ? new RangeError(x(R, q, z)) : null);
      }, (0, r.default)(K, "between", A);
    }
  }(I9)), I9;
}
var B9 = {}, Wne;
function Klt() {
  return Wne || (Wne = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = mn(), t = n(pi());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r() {
      for (var s = arguments.length, o = new Array(s), a = 0; a < s; a++)
        o[a] = arguments[a];
      if (o.length < 1)
        throw new TypeError("at least one prop (one of which must be `true`) is required");
      if (!o.every(function(d) {
        return typeof d == "string";
      }))
        throw new TypeError("all booleanSome props must be strings");
      var l = o.join(", or "), c = function(u, h, f) {
        var g = function(y, S) {
          return y + (u[S] === !1 ? 1 : 0);
        }, p = o.reduce(g, 0);
        if (p === o.length)
          return new Error("A ".concat(f, " must have at least one of these boolean props be `true`: ").concat(l));
        for (var m = arguments.length, _ = new Array(m > 3 ? m - 3 : 0), b = 3; b < m; b++)
          _[b - 3] = arguments[b];
        return e.bool.apply(void 0, [u, h, f].concat(_));
      };
      return c.isRequired = function(u, h, f) {
        var g = function(y, S) {
          return y + (u[S] === !1 ? 1 : 0);
        }, p = o.reduce(g, 0);
        if (p === o.length)
          return new Error("A ".concat(f, " must have at least one of these boolean props be `true`: ").concat(l));
        for (var m = arguments.length, _ = new Array(m > 3 ? m - 3 : 0), b = 3; b < m; b++)
          _[b - 3] = arguments[b];
        return e.bool.isRequired.apply(e.bool, [u, h, f].concat(_));
      }, (0, t.default)(c, "booleanSome: ".concat(l), o);
    }
  }(B9)), B9;
}
var V9 = {}, jne;
function Ylt() {
  return jne || (jne = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = s;
    var e = n(it), t = n(pi());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function r(o) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(l) {
        return typeof l;
      } : r = function(l) {
        return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
      }, r(o);
    }
    function s(o) {
      if (typeof o != "string" && r(o) !== "symbol")
        throw new TypeError("invalid prop: must be string or symbol");
      var a = function(c, d, u) {
        var h = c.children, f = 0, g = 0, p = 0;
        return e.default.Children.forEach(h, function(m) {
          m && (f += 1, m.props[o] && (g += 1), e.default.Children.count(m.props.children) && (p += 1));
        }), g === f && p === 0 || g === 0 && p === f || g === 0 && p === 0 ? null : new TypeError("`".concat(u, "` requires children to all have prop “").concat(o, "”, all have children, or all have neither."));
      };
      return a.isRequired = a, (0, t.default)(a, "childrenHavePropXorChildrenWithProp:".concat(o), o);
    }
  }(V9)), V9;
}
var H9 = {}, W9 = {}, zne;
function oq() {
  return zne || (zne = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = n;
    var e = t(it);
    function t(r) {
      return r && r.__esModule ? r : { default: r };
    }
    function n(r) {
      return e.default.Children.toArray(r).filter(function(s) {
        return s === 0 || s;
      });
    }
  }(W9)), W9;
}
var Une;
function Xlt() {
  return Une || (Une = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = l;
    var e = n(oq()), t = n(pi());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    function r(c, d) {
      var u = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(c);
        d && (h = h.filter(function(f) {
          return Object.getOwnPropertyDescriptor(c, f).enumerable;
        })), u.push.apply(u, h);
      }
      return u;
    }
    function s(c) {
      for (var d = 1; d < arguments.length; d++) {
        var u = arguments[d] != null ? arguments[d] : {};
        d % 2 ? r(Object(u), !0).forEach(function(h) {
          o(c, h, u[h]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(u)) : r(Object(u)).forEach(function(h) {
          Object.defineProperty(c, h, Object.getOwnPropertyDescriptor(u, h));
        });
      }
      return c;
    }
    function o(c, d, u) {
      return d in c ? Object.defineProperty(c, d, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : c[d] = u, c;
    }
    function a(c, d, u) {
      for (var h = arguments.length, f = new Array(h > 3 ? h - 3 : 0), g = 3; g < h; g++)
        f[g - 3] = arguments[g];
      var p;
      return d.some(function(m) {
        return p = c.apply(void 0, [s(s({}, u), {}, {
          children: m
        }), "children"].concat(f)), p;
      }), p || null;
    }
    function l(c) {
      function d(u, h, f) {
        if (h !== "children")
          return new TypeError("".concat(f, ' is using the childrenOf validator on non-children prop "').concat(h, '"'));
        var g = u[h];
        if (g == null)
          return null;
        var p = (0, e.default)(g);
        if (p.length === 0)
          return null;
        for (var m = arguments.length, _ = new Array(m > 3 ? m - 3 : 0), b = 3; b < m; b++)
          _[b - 3] = arguments[b];
        return a.apply(void 0, [c, p, u, f].concat(_));
      }
      return d.isRequired = function(u, h, f) {
        if (h !== "children")
          return new TypeError("".concat(f, ' is using the childrenOf validator on non-children prop "').concat(h, '"'));
        var g = (0, e.default)(u[h]);
        if (g.length === 0)
          return new TypeError("`".concat(f, "` requires at least one node of type ").concat(c.typeName || c.name));
        for (var p = arguments.length, m = new Array(p > 3 ? p - 3 : 0), _ = 3; _ < p; _++)
          m[_ - 3] = arguments[_];
        return a.apply(void 0, [c, g, u, f].concat(m));
      }, (0, t.default)(d, "childrenOf", c);
    }
  }(H9)), H9;
}
var j9 = {}, z9, Gne;
function Zlt() {
  return Gne || (Gne = 1, z9 = Object), z9;
}
var U9, qne;
function L_e() {
  if (qne) return U9;
  qne = 1;
  var i = Zlt(), e = Pb();
  return U9 = function(n) {
    return e(n), i(n);
  }, U9;
}
var G9, Kne;
function aq() {
  return Kne || (Kne = 1, G9 = Number.MAX_SAFE_INTEGER || 9007199254740991), G9;
}
var q9, Yne;
function lq() {
  return Yne || (Yne = 1, q9 = function(e) {
    return e === null || typeof e != "function" && typeof e != "object";
  }), q9;
}
var K9, Xne;
function Qlt() {
  return Xne || (Xne = 1, K9 = function(e) {
    return e === null || typeof e != "function" && typeof e != "object";
  }), K9;
}
var Y9, Zne;
function cq() {
  if (Zne) return Y9;
  Zne = 1;
  var i = Function.prototype.toString, e = typeof Reflect == "object" && Reflect !== null && Reflect.apply, t, n;
  if (typeof e == "function" && typeof Object.defineProperty == "function")
    try {
      t = Object.defineProperty({}, "length", {
        get: function() {
          throw n;
        }
      }), n = {}, e(function() {
        throw 42;
      }, null, t);
    } catch (b) {
      b !== n && (e = null);
    }
  else
    e = null;
  var r = /^\s*class\b/, s = function(w) {
    try {
      var y = i.call(w);
      return r.test(y);
    } catch {
      return !1;
    }
  }, o = function(w) {
    try {
      return s(w) ? !1 : (i.call(w), !0);
    } catch {
      return !1;
    }
  }, a = Object.prototype.toString, l = "[object Object]", c = "[object Function]", d = "[object GeneratorFunction]", u = "[object HTMLAllCollection]", h = "[object HTML document.all class]", f = "[object HTMLCollection]", g = typeof Symbol == "function" && !!Symbol.toStringTag, p = !(0 in [,]), m = function() {
    return !1;
  };
  if (typeof document == "object") {
    var _ = document.all;
    a.call(_) === a.call(document.all) && (m = function(w) {
      if ((p || !w) && (typeof w > "u" || typeof w == "object"))
        try {
          var y = a.call(w);
          return (y === u || y === h || y === f || y === l) && w("") == null;
        } catch {
        }
      return !1;
    });
  }
  return Y9 = e ? function(w) {
    if (m(w))
      return !0;
    if (!w || typeof w != "function" && typeof w != "object")
      return !1;
    try {
      e(w, null, t);
    } catch (y) {
      if (y !== n)
        return !1;
    }
    return !s(w) && o(w);
  } : function(w) {
    if (m(w))
      return !0;
    if (!w || typeof w != "function" && typeof w != "object")
      return !1;
    if (g)
      return o(w);
    if (s(w))
      return !1;
    var y = a.call(w);
    return y !== c && y !== d && !/^\[object HTML/.test(y) ? !1 : o(w);
  }, Y9;
}
var X9, Qne;
function Jlt() {
  if (Qne) return X9;
  Qne = 1;
  var i = Date.prototype.getDay, e = function(o) {
    try {
      return i.call(o), !0;
    } catch {
      return !1;
    }
  }, t = Object.prototype.toString, n = "[object Date]", r = nq()();
  return X9 = function(o) {
    return typeof o != "object" || o === null ? !1 : r ? e(o) : t.call(o) === n;
  }, X9;
}
var r3 = { exports: {} }, Jne;
function I_e() {
  if (Jne) return r3.exports;
  Jne = 1;
  var i = Object.prototype.toString, e = a_e()();
  if (e) {
    var t = Symbol.prototype.toString, n = /^Symbol\(.*\)$/, r = function(o) {
      return typeof o.valueOf() != "symbol" ? !1 : n.test(t.call(o));
    };
    r3.exports = function(o) {
      if (typeof o == "symbol")
        return !0;
      if (i.call(o) !== "[object Symbol]")
        return !1;
      try {
        return r(o);
      } catch {
        return !1;
      }
    };
  } else
    r3.exports = function(o) {
      return !1;
    };
  return r3.exports;
}
var Z9, $ne;
function A_e() {
  if ($ne) return Z9;
  $ne = 1;
  var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol", e = Qlt(), t = cq(), n = Jlt(), r = I_e(), s = function(l, c) {
    if (typeof l > "u" || l === null)
      throw new TypeError("Cannot call method on " + l);
    if (typeof c != "string" || c !== "number" && c !== "string")
      throw new TypeError('hint must be "string" or "number"');
    var d = c === "string" ? ["toString", "valueOf"] : ["valueOf", "toString"], u, h, f;
    for (f = 0; f < d.length; ++f)
      if (u = l[d[f]], t(u) && (h = u.call(l), e(h)))
        return h;
    throw new TypeError("No default value");
  }, o = function(l, c) {
    var d = l[c];
    if (d !== null && typeof d < "u") {
      if (!t(d))
        throw new TypeError(d + " returned for property " + c + " of object " + l + " is not a function");
      return d;
    }
  };
  return Z9 = function(l) {
    if (e(l))
      return l;
    var c = "default";
    arguments.length > 1 && (arguments[1] === String ? c = "string" : arguments[1] === Number && (c = "number"));
    var d;
    if (i && (Symbol.toPrimitive ? d = o(l, Symbol.toPrimitive) : r(l) && (d = Symbol.prototype.valueOf)), typeof d < "u") {
      var u = d.call(l, c);
      if (e(u))
        return u;
      throw new TypeError("unable to convert exotic object to primitive");
    }
    return c === "default" && (n(l) || r(l)) && (c = "string"), s(l, c === "default" ? "number" : c);
  }, Z9;
}
var Q9, eie;
function $lt() {
  if (eie) return Q9;
  eie = 1;
  var i = A_e();
  return Q9 = function(t) {
    return arguments.length > 1 ? i(t, arguments[1]) : i(t);
  }, Q9;
}
var J9, tie;
function k_e() {
  if (tie) return J9;
  tie = 1;
  var i = Xa(), e = nq()(), t, n, r, s;
  if (e) {
    t = i("Object.prototype.hasOwnProperty"), n = i("RegExp.prototype.exec"), r = {};
    var o = function() {
      throw r;
    };
    s = {
      toString: o,
      valueOf: o
    }, typeof Symbol.toPrimitive == "symbol" && (s[Symbol.toPrimitive] = o);
  }
  var a = i("Object.prototype.toString"), l = Object.getOwnPropertyDescriptor, c = "[object RegExp]";
  return J9 = e ? function(u) {
    if (!u || typeof u != "object")
      return !1;
    var h = l(u, "lastIndex"), f = h && t(h, "value");
    if (!f)
      return !1;
    try {
      n(u, s);
    } catch (g) {
      return g === r;
    }
  } : function(u) {
    return !u || typeof u != "object" && typeof u != "function" ? !1 : a(u) === c;
  }, J9;
}
var $9, nie;
function T_e() {
  if (nie) return $9;
  nie = 1;
  var i = Xa(), e = k_e(), t = i("RegExp.prototype.exec"), n = Jn();
  return $9 = function(s) {
    if (!e(s))
      throw new n("`regex` must be a RegExp");
    return function(a) {
      return t(s, a) !== null;
    };
  }, $9;
}
var e7, iie;
function ect() {
  if (iie) return e7;
  iie = 1;
  var i = As(), e = i("%String%"), t = Jn();
  return e7 = function(r) {
    if (typeof r == "symbol")
      throw new t("Cannot convert a Symbol value to a string");
    return e(r);
  }, e7;
}
var t7, rie;
function N_e() {
  if (rie) return t7;
  rie = 1;
  var i = Pb(), e = ect(), t = Xa(), n = t("String.prototype.replace"), r = /^\s$/.test("᠎"), s = r ? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/ : /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/, o = r ? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/ : /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
  return t7 = function() {
    var l = e(i(this));
    return n(n(l, s, ""), o, "");
  }, t7;
}
var n7, sie;
function P_e() {
  if (sie) return n7;
  sie = 1;
  var i = N_e(), e = "​", t = "᠎";
  return n7 = function() {
    return String.prototype.trim && e.trim() === e && t.trim() === t && ("_" + t).trim() === "_" + t && (t + "_").trim() === t + "_" ? String.prototype.trim : i;
  }, n7;
}
var i7, oie;
function tct() {
  if (oie) return i7;
  oie = 1;
  var i = Xr(), e = P_e();
  return i7 = function() {
    var n = e();
    return i(String.prototype, { trim: n }, {
      trim: function() {
        return String.prototype.trim !== n;
      }
    }), n;
  }, i7;
}
var r7, aie;
function O_e() {
  if (aie) return r7;
  aie = 1;
  var i = Vu(), e = Xr(), t = Pb(), n = N_e(), r = P_e(), s = tct(), o = i(r()), a = function(c) {
    return t(c), o(c);
  };
  return e(a, {
    getPolyfill: r,
    implementation: n,
    shim: s
  }), r7 = a, r7;
}
var s7, lie;
function nct() {
  if (lie) return s7;
  lie = 1;
  var i = As(), e = i("%Number%"), t = i("%RegExp%"), n = Jn(), r = i("%parseInt%"), s = Xa(), o = T_e(), a = s("String.prototype.slice"), l = o(/^0b[01]+$/i), c = o(/^0o[0-7]+$/i), d = o(/^[-+]0x[0-9a-f]+$/i), u = ["", "​", "￾"].join(""), h = new t("[" + u + "]", "g"), f = o(h), g = O_e();
  return s7 = function p(m) {
    if (typeof m != "string")
      throw new n("Assertion failed: `argument` is not a String");
    if (l(m))
      return e(r(a(m, 2), 2));
    if (c(m))
      return e(r(a(m, 2), 8));
    if (f(m) || d(m))
      return NaN;
    var _ = g(m);
    return _ !== m ? p(_) : e(m);
  }, s7;
}
var o7, cie;
function ict() {
  if (cie) return o7;
  cie = 1;
  var i = As(), e = Jn(), t = i("%Number%"), n = lq(), r = $lt(), s = nct();
  return o7 = function(a) {
    var l = n(a) ? a : r(a, t);
    if (typeof l == "symbol")
      throw new e("Cannot convert a Symbol value to a number");
    if (typeof l == "bigint")
      throw new e("Conversion from 'BigInt' to 'number' is not allowed.");
    return typeof l == "string" ? s(l) : t(l);
  }, o7;
}
var a7, die;
function rct() {
  if (die) return a7;
  die = 1;
  var i = Math.floor;
  return a7 = function(t) {
    return typeof t == "bigint" ? t : i(t);
  }, a7;
}
var l7, uie;
function sct() {
  if (uie) return l7;
  uie = 1;
  var i = rct(), e = Jn();
  return l7 = function(n) {
    if (typeof n != "number" && typeof n != "bigint")
      throw new e("argument must be a Number or a BigInt");
    var r = n < 0 ? -i(-n) : i(n);
    return r === 0 ? 0 : r;
  }, l7;
}
var c7, hie;
function dq() {
  if (hie) return c7;
  hie = 1;
  var i = lx();
  return c7 = function(e) {
    return (typeof e == "number" || typeof e == "bigint") && !i(e) && e !== 1 / 0 && e !== -1 / 0;
  }, c7;
}
var d7, fie;
function oct() {
  if (fie) return d7;
  fie = 1;
  var i = ict(), e = sct(), t = lx(), n = dq();
  return d7 = function(s) {
    var o = i(s);
    return t(o) || o === 0 ? 0 : n(o) ? e(o) : o;
  }, d7;
}
var u7, gie;
function act() {
  if (gie) return u7;
  gie = 1;
  var i = aq(), e = oct();
  return u7 = function(n) {
    var r = e(n);
    return r <= 0 ? 0 : r > i ? i : r;
  }, u7;
}
var h7, pie;
function lct() {
  return pie || (pie = 1, h7 = cq()), h7;
}
var f7, mie;
function M_e() {
  if (mie) return f7;
  mie = 1;
  var i = L_e(), e = act(), t = lct();
  return f7 = function(r) {
    var s = i(this), o = e(s.length);
    if (!t(r))
      throw new TypeError("Array#find: predicate must be a function");
    if (o !== 0) {
      var a;
      arguments.length > 0 && (a = arguments[1]);
      for (var l = 0, c; l < o; l++)
        if (c = s[l], r.apply(a, [c, l, s]))
          return c;
    }
  }, f7;
}
var g7, vie;
function R_e() {
  return vie || (vie = 1, g7 = function() {
    var e = Array.prototype.find && [, 1].find(function() {
      return !0;
    }) !== 1;
    return e ? Array.prototype.find : M_e();
  }), g7;
}
var p7, _ie;
function F_e() {
  if (_ie) return p7;
  _ie = 1;
  var i = Bu(), e = typeof Symbol == "function" && typeof Symbol.unscopables == "symbol", t = e && Array.prototype[Symbol.unscopables], n = TypeError;
  return p7 = function(s) {
    if (typeof s != "string" || !s)
      throw new n("method must be a non-empty string");
    if (!i(Array.prototype, s))
      throw new n("method must be on Array.prototype");
    e && (t[s] = !0);
  }, p7;
}
var m7, bie;
function cct() {
  if (bie) return m7;
  bie = 1;
  var i = Xr(), e = F_e(), t = R_e();
  return m7 = function() {
    var r = t();
    return i(
      Array.prototype,
      { find: r },
      {
        find: function() {
          return Array.prototype.find !== r;
        }
      }
    ), e("find"), r;
  }, m7;
}
var v7, Cie;
function B_e() {
  if (Cie) return v7;
  Cie = 1;
  var i = Xr(), e = Xa(), t = Pb(), n = M_e(), r = R_e(), s = cct(), o = e("Array.prototype.slice"), a = r(), l = function(d, u) {
    t(d);
    var h = o(arguments, 1);
    return a.apply(d, h);
  };
  return i(l, {
    getPolyfill: r,
    implementation: n,
    shim: s
  }), v7 = l, v7;
}
var _7 = {}, b7, yie;
function V_e() {
  return yie || (yie = 1, b7 = cq()), b7;
}
var C7, wie;
function dct() {
  if (wie) return C7;
  wie = 1;
  var i = Jn(), e = Bu(), t = pf(), n = _c();
  return C7 = function(s, o) {
    if (n(s) !== "Object")
      throw new i("Assertion failed: `O` must be an Object");
    if (!t(o))
      throw new i("Assertion failed: `P` must be a Property Key");
    return e(s, o);
  }, C7;
}
var y7, Sie;
function H_e() {
  if (Sie) return y7;
  Sie = 1;
  var i = function() {
    return typeof function() {
    }.name == "string";
  }, e = Object.getOwnPropertyDescriptor;
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  i.functionsHaveConfigurableNames = function() {
    if (!i() || !e)
      return !1;
    var r = e(function() {
    }, "name");
    return !!r && !!r.configurable;
  };
  var t = Function.prototype.bind;
  return i.boundFunctionsHaveNames = function() {
    return i() && typeof t == "function" && function() {
    }.bind().name !== "";
  }, y7 = i, y7;
}
var w7, xie;
function W_e() {
  if (xie) return w7;
  xie = 1;
  var i = V_e(), e = dct(), t = H_e()(), n = Xa(), r = n("Function.prototype.toString"), s = n("String.prototype.match"), o = n("Object.prototype.toString"), a = /^class /, l = function(_) {
    if (i(_) || typeof _ != "function")
      return !1;
    try {
      var b = s(r(_), a);
      return !!b;
    } catch {
    }
    return !1;
  }, c = /\s*function\s+([^(\s]*)\s*/, d = !(0 in [,]), u = "[object Object]", h = "[object HTMLAllCollection]", f = Function.prototype, g = function() {
    return !1;
  };
  if (typeof document == "object") {
    var p = document.all;
    o(p) === o(document.all) && (g = function(_) {
      if ((d || !_) && (typeof _ > "u" || typeof _ == "object"))
        try {
          var b = o(_);
          return (b === h || b === u) && _("") == null;
        } catch {
        }
      return !1;
    });
  }
  return w7 = function() {
    if (g(this) || !l(this) && !i(this))
      throw new TypeError("Function.prototype.name sham getter called on non-function");
    if (t && e(this, "name"))
      return this.name;
    if (this === f)
      return "";
    var _ = r(this), b = s(_, c), w = b && b[1];
    return w;
  }, w7;
}
var S7, Die;
function j_e() {
  if (Die) return S7;
  Die = 1;
  var i = W_e();
  return S7 = function() {
    return i;
  }, S7;
}
var x7, Eie;
function uct() {
  if (Eie) return x7;
  Eie = 1;
  var i = Xr().supportsDescriptors, e = H_e()(), t = j_e(), n = Object.defineProperty, r = TypeError;
  return x7 = function() {
    var o = t();
    if (e)
      return o;
    if (!i)
      throw new r("Shimming Function.prototype.name support requires ES5 property descriptor support.");
    var a = Function.prototype;
    return n(a, "name", {
      configurable: !0,
      enumerable: !1,
      get: function() {
        var l = o.call(this);
        return this !== a && n(this, "name", {
          configurable: !0,
          enumerable: !1,
          value: l,
          writable: !1
        }), l;
      }
    }), o;
  }, x7;
}
var D7, Lie;
function hct() {
  if (Lie) return D7;
  Lie = 1;
  var i = Xr(), e = Vu(), t = W_e(), n = j_e(), r = uct(), s = e(t);
  return i(s, {
    getPolyfill: n,
    implementation: t,
    shim: r
  }), D7 = s, D7;
}
var s3 = { exports: {} }, Ai = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Iie;
function fct() {
  if (Iie) return Ai;
  Iie = 1;
  var i = typeof Symbol == "function" && Symbol.for, e = i ? Symbol.for("react.element") : 60103, t = i ? Symbol.for("react.portal") : 60106, n = i ? Symbol.for("react.fragment") : 60107, r = i ? Symbol.for("react.strict_mode") : 60108, s = i ? Symbol.for("react.profiler") : 60114, o = i ? Symbol.for("react.provider") : 60109, a = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, c = i ? Symbol.for("react.concurrent_mode") : 60111, d = i ? Symbol.for("react.forward_ref") : 60112, u = i ? Symbol.for("react.suspense") : 60113, h = i ? Symbol.for("react.suspense_list") : 60120, f = i ? Symbol.for("react.memo") : 60115, g = i ? Symbol.for("react.lazy") : 60116, p = i ? Symbol.for("react.block") : 60121, m = i ? Symbol.for("react.fundamental") : 60117, _ = i ? Symbol.for("react.responder") : 60118, b = i ? Symbol.for("react.scope") : 60119;
  function w(S) {
    if (typeof S == "object" && S !== null) {
      var x = S.$$typeof;
      switch (x) {
        case e:
          switch (S = S.type, S) {
            case l:
            case c:
            case n:
            case s:
            case r:
            case u:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case a:
                case d:
                case g:
                case f:
                case o:
                  return S;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  function y(S) {
    return w(S) === c;
  }
  return Ai.AsyncMode = l, Ai.ConcurrentMode = c, Ai.ContextConsumer = a, Ai.ContextProvider = o, Ai.Element = e, Ai.ForwardRef = d, Ai.Fragment = n, Ai.Lazy = g, Ai.Memo = f, Ai.Portal = t, Ai.Profiler = s, Ai.StrictMode = r, Ai.Suspense = u, Ai.isAsyncMode = function(S) {
    return y(S) || w(S) === l;
  }, Ai.isConcurrentMode = y, Ai.isContextConsumer = function(S) {
    return w(S) === a;
  }, Ai.isContextProvider = function(S) {
    return w(S) === o;
  }, Ai.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === e;
  }, Ai.isForwardRef = function(S) {
    return w(S) === d;
  }, Ai.isFragment = function(S) {
    return w(S) === n;
  }, Ai.isLazy = function(S) {
    return w(S) === g;
  }, Ai.isMemo = function(S) {
    return w(S) === f;
  }, Ai.isPortal = function(S) {
    return w(S) === t;
  }, Ai.isProfiler = function(S) {
    return w(S) === s;
  }, Ai.isStrictMode = function(S) {
    return w(S) === r;
  }, Ai.isSuspense = function(S) {
    return w(S) === u;
  }, Ai.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === c || S === s || S === r || S === u || S === h || typeof S == "object" && S !== null && (S.$$typeof === g || S.$$typeof === f || S.$$typeof === o || S.$$typeof === a || S.$$typeof === d || S.$$typeof === m || S.$$typeof === _ || S.$$typeof === b || S.$$typeof === p);
  }, Ai.typeOf = w, Ai;
}
var ki = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Aie;
function gct() {
  return Aie || (Aie = 1, process.env.NODE_ENV !== "production" && function() {
    var i = typeof Symbol == "function" && Symbol.for, e = i ? Symbol.for("react.element") : 60103, t = i ? Symbol.for("react.portal") : 60106, n = i ? Symbol.for("react.fragment") : 60107, r = i ? Symbol.for("react.strict_mode") : 60108, s = i ? Symbol.for("react.profiler") : 60114, o = i ? Symbol.for("react.provider") : 60109, a = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, c = i ? Symbol.for("react.concurrent_mode") : 60111, d = i ? Symbol.for("react.forward_ref") : 60112, u = i ? Symbol.for("react.suspense") : 60113, h = i ? Symbol.for("react.suspense_list") : 60120, f = i ? Symbol.for("react.memo") : 60115, g = i ? Symbol.for("react.lazy") : 60116, p = i ? Symbol.for("react.block") : 60121, m = i ? Symbol.for("react.fundamental") : 60117, _ = i ? Symbol.for("react.responder") : 60118, b = i ? Symbol.for("react.scope") : 60119;
    function w(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === n || j === c || j === s || j === r || j === u || j === h || typeof j == "object" && j !== null && (j.$$typeof === g || j.$$typeof === f || j.$$typeof === o || j.$$typeof === a || j.$$typeof === d || j.$$typeof === m || j.$$typeof === _ || j.$$typeof === b || j.$$typeof === p);
    }
    function y(j) {
      if (typeof j == "object" && j !== null) {
        var he = j.$$typeof;
        switch (he) {
          case e:
            var Se = j.type;
            switch (Se) {
              case l:
              case c:
              case n:
              case s:
              case r:
              case u:
                return Se;
              default:
                var ge = Se && Se.$$typeof;
                switch (ge) {
                  case a:
                  case d:
                  case g:
                  case f:
                  case o:
                    return ge;
                  default:
                    return he;
                }
            }
          case t:
            return he;
        }
      }
    }
    var S = l, x = c, D = a, E = o, L = e, k = d, N = n, I = g, A = f, P = t, O = s, K = r, W = u, F = !1;
    function q(j) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(j) || y(j) === l;
    }
    function R(j) {
      return y(j) === c;
    }
    function T(j) {
      return y(j) === a;
    }
    function z(j) {
      return y(j) === o;
    }
    function X(j) {
      return typeof j == "object" && j !== null && j.$$typeof === e;
    }
    function ae(j) {
      return y(j) === d;
    }
    function ue(j) {
      return y(j) === n;
    }
    function se(j) {
      return y(j) === g;
    }
    function le(j) {
      return y(j) === f;
    }
    function oe(j) {
      return y(j) === t;
    }
    function re(j) {
      return y(j) === s;
    }
    function B(j) {
      return y(j) === r;
    }
    function ee(j) {
      return y(j) === u;
    }
    ki.AsyncMode = S, ki.ConcurrentMode = x, ki.ContextConsumer = D, ki.ContextProvider = E, ki.Element = L, ki.ForwardRef = k, ki.Fragment = N, ki.Lazy = I, ki.Memo = A, ki.Portal = P, ki.Profiler = O, ki.StrictMode = K, ki.Suspense = W, ki.isAsyncMode = q, ki.isConcurrentMode = R, ki.isContextConsumer = T, ki.isContextProvider = z, ki.isElement = X, ki.isForwardRef = ae, ki.isFragment = ue, ki.isLazy = se, ki.isMemo = le, ki.isPortal = oe, ki.isProfiler = re, ki.isStrictMode = B, ki.isSuspense = ee, ki.isValidElementType = w, ki.typeOf = y;
  }()), ki;
}
var kie;
function z_e() {
  return kie || (kie = 1, process.env.NODE_ENV === "production" ? s3.exports = fct() : s3.exports = gct()), s3.exports;
}
var Tie;
function cx() {
  return Tie || (Tie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = n(hct()), t = z_e();
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r(s) {
      return typeof s == "string" ? s : typeof s == "function" ? s.displayName || (0, e.default)(s) : (0, t.isForwardRef)({
        type: s,
        $$typeof: t.Element
      }) ? s.displayName : (0, t.isMemo)(s) ? r(s.type) : null;
    }
  }(_7)), _7;
}
var Nie;
function pct() {
  return Nie || (Nie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = s(B_e()), t = s(cx()), n = s(oq()), r = s(pi());
    function s(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function o(d, u, h) {
      if (!u.every(function(g) {
        return g && (0, e.default)(d, function(p) {
          return p === "*" || g.type === p;
        });
      })) {
        var f = d.map(t.default).join(", or ");
        return new TypeError("`".concat(h, "` only accepts children of type ").concat(f));
      }
      return null;
    }
    function a(d, u, h) {
      if (u.length === 0) {
        var f = d.map(t.default).join(", or ");
        return new TypeError("`".concat(h, "` requires at least one node of type ").concat(f));
      }
      return null;
    }
    function l() {
      for (var d = arguments.length, u = new Array(d), h = 0; h < d; h++)
        u[h] = arguments[h];
      if (u.length < 1)
        throw new TypeError("childrenOfType: at least 1 type is required");
      function f(g, p, m) {
        return o(u, (0, n.default)(g[p]), m);
      }
      return f.isRequired = function(g, p, m) {
        var _ = (0, n.default)(g[p]);
        return a(u, _, m) || o(u, _, m);
      }, (0, r.default)(f, "childrenOfType", u);
    }
    var c = l;
    i.default = c;
  }(j9)), j9;
}
var E7 = {}, L7 = {}, I7 = {}, A7 = {}, k7 = {}, Pie;
function U_e() {
  return Pie || (Pie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = Math.floor, t = isFinite, n = Number.isInteger || /* istanbul ignore next */
    function(r) {
      return typeof r == "number" && t(r) && e(r) === r;
    };
    i.default = n;
  }(k7)), k7;
}
var Oie;
function uq() {
  return Oie || (Oie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = n(U_e()), t = n(pi());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function r(a, l, c) {
      var d = a[l];
      return d == null || !(0, e.default)(d) ? new RangeError("".concat(l, " in ").concat(c, " must be an integer")) : null;
    }
    var s = function(l, c) {
      var d = l[c];
      if (d == null)
        return null;
      for (var u = arguments.length, h = new Array(u > 2 ? u - 2 : 0), f = 2; f < u; f++)
        h[f - 2] = arguments[f];
      return r.apply(void 0, [l, c].concat(h));
    };
    s.isRequired = r;
    var o = function() {
      return (0, t.default)(s, "integer");
    };
    i.default = o;
  }(A7)), A7;
}
var T7 = {}, Mie;
function G_e() {
  return Mie || (Mie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = n(QG()), t = n(pi());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function r(l) {
      return typeof l == "number" && isFinite(l) && l >= 0 && !(0, e.default)(l, -0);
    }
    function s(l, c, d) {
      var u = l[c];
      return u == null || r(u) ? null : new RangeError("".concat(c, " in ").concat(d, " must be a non-negative number"));
    }
    function o(l, c, d) {
      var u = l[c];
      return r(u) ? null : new RangeError("".concat(c, " in ").concat(d, " must be a non-negative number"));
    }
    s.isRequired = o;
    var a = function() {
      return (0, t.default)(s, "nonNegativeNumber");
    };
    i.default = a;
  }(T7)), T7;
}
var Rie;
function q_e() {
  return Rie || (Rie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = r(Q0()), t = r(uq()), n = r(G_e());
    function r(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var s = (0, e.default)([(0, t.default)(), (0, n.default)()], "nonNegativeInteger");
    i.default = s;
  }(I7)), I7;
}
var N7 = {}, P7 = {}, Fie;
function K_e() {
  return Fie || (Fie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = t(it);
    function t(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function n(s) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(a) {
        return typeof a;
      } : n = function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, n(s);
    }
    function r(s) {
      return s === null ? "null" : Array.isArray(s) ? "array" : n(s) !== "object" ? n(s) : /* @__PURE__ */ e.default.isValidElement(s) ? s.type : s;
    }
  }(P7)), P7;
}
var Bie;
function Y_e() {
  return Bie || (Bie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = r(iq()), t = r(K_e()), n = r(pi());
    function r(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var s = {
      prop: "prop",
      context: "context",
      childContext: "child context"
    };
    function o(l, c, d, u, h) {
      var f = l[c];
      if (f == null || (0, e.default)(f))
        return null;
      var g = s[u] || u;
      return new TypeError("Invalid ".concat(g, " `").concat(h, "` of type `").concat((0, t.default)(f), "` supplied to `").concat(d, "`, expected `object`."));
    }
    o.isRequired = function(c, d, u, h, f) {
      var g = c[d];
      if (g == null) {
        var p = s[h] || h;
        return new TypeError("The ".concat(p, " `").concat(f, "` is marked as required in `").concat(u, "`, but its value is `").concat(g, "`."));
      }
      for (var m = arguments.length, _ = new Array(m > 5 ? m - 5 : 0), b = 5; b < m; b++)
        _[b - 5] = arguments[b];
      return o.apply(void 0, [c, d, u, h, f].concat(_));
    };
    var a = function() {
      return (0, n.default)(o, "object");
    };
    i.default = a;
  }(N7)), N7;
}
var O7 = {}, Vie;
function hq() {
  return Vie || (Vie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = n(Q0()), t = n(rq());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r(s, o) {
      if (typeof s != "function")
        throw new TypeError("type must be a valid PropType");
      var a = (0, t.default)(o);
      return (0, e.default)([s, a], "withShape");
    }
  }(O7)), O7;
}
var Hie;
function X_e() {
  return Hie || (Hie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = S;
    var e = mn(), t = c(Q0()), n = c(sq()), r = c(q_e()), s = c(Y_e()), o = c(hq()), a = c(K_e()), l = c(pi());
    function c(x) {
      return x && x.__esModule ? x : { default: x };
    }
    function d(x, D) {
      var E = Object.keys(x);
      if (Object.getOwnPropertySymbols) {
        var L = Object.getOwnPropertySymbols(x);
        D && (L = L.filter(function(k) {
          return Object.getOwnPropertyDescriptor(x, k).enumerable;
        })), E.push.apply(E, L);
      }
      return E;
    }
    function u(x) {
      for (var D = 1; D < arguments.length; D++) {
        var E = arguments[D] != null ? arguments[D] : {};
        D % 2 ? d(Object(E), !0).forEach(function(L) {
          h(x, L, E[L]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(E)) : d(Object(E)).forEach(function(L) {
          Object.defineProperty(x, L, Object.getOwnPropertyDescriptor(E, L));
        });
      }
      return x;
    }
    function h(x, D, E) {
      return D in x ? Object.defineProperty(x, D, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : x[D] = E, x;
    }
    var f = r.default, g = (0, t.default)([r.default, (0, n.default)({
      gte: 1
    })]);
    function p(x, D) {
      return typeof D != "number" || typeof x != "number" || x <= D ? null : new RangeError("min must be less than or equal to max");
    }
    var m = {
      validator: function(D, E) {
        var L = D[E];
        return typeof L != "function" ? new TypeError('"validator" must be a propType validator function') : null;
      },
      min: function(D, E) {
        return f(D, E) || p(D.min, D.max);
      },
      max: function(D, E) {
        return g(D, E) || p(D.min, D.max);
      }
    };
    function _(x) {
      var D = x.min, E = x.max, L, k;
      return typeof D != "number" && typeof E != "number" ? (L = 1, k = 1) : (L = typeof D == "number" ? D : 1, k = typeof E == "number" ? E : 1 / 0), {
        minimum: L,
        maximum: k
      };
    }
    function b(x) {
      var D = [], E;
      return x.reduce(function(L, k) {
        var N = (0, a.default)(k);
        return !E || N === E ? D.push(k) : (L.push(D), D = [k]), E = N, L;
      }, []).concat(D.length > 0 ? [D] : []);
    }
    function w(x, D, E, L) {
      for (var k = D[E], N = b(k), I = arguments.length, A = new Array(I > 4 ? I - 4 : 0), P = 4; P < I; P++)
        A[P - 4] = arguments[P];
      for (var O = 0; O < x.length; O += 1) {
        var K = x[O], W = K.validator, F = K.min, q = K.max, R = _({
          min: F,
          max: q
        }), T = R.minimum, z = R.maximum;
        if (!(N.length === 0 && T === 0)) {
          var X = (0, e.arrayOf)(W).isRequired, ae = N.shift(), ue = X.apply(void 0, [u(u({}, D), {}, h({}, E, ae)), E, L].concat(A));
          if (ue) {
            if (T === 0) {
              N.unshift(ae);
              continue;
            }
            return ue;
          }
          if (ae.length < T)
            return new RangeError("".concat(L, ": specifier index ").concat(O, " requires a minimum of ").concat(F, " items, but only has ").concat(ae.length, "."));
          if (ae.length > z)
            return new RangeError("".concat(L, ": specifier index ").concat(O, " requires a maximum of ").concat(q, " items, but has ").concat(ae.length, "."));
        }
      }
      return N.length > 0 ? new TypeError("".concat(L, ": after all ").concat(x.length, " specifiers matched, ").concat(N.length, " types of items were remaining.")) : null;
    }
    var y = (0, o.default)((0, s.default)(), m).isRequired;
    function S() {
      for (var x = arguments.length, D = new Array(x), E = 0; E < x; E++)
        D[E] = arguments[E];
      if (D.length === 0)
        throw new RangeError("sequenceOf: at least one specifier is required");
      var L = D.map(function(N, I) {
        return y({
          specifier: N
        }, "specifier", "sequenceOf specifier", "suequenceOf specifier, index ".concat(I), "specifier, index ".concat(I));
      });
      if (L.some(Boolean))
        throw new TypeError(`
      sequenceOf: all specifiers must match the appropriate shape.

      Errors:
        `.concat(L.map(function(N, I) {
          return " - Argument index ".concat(I, ": ").concat(N.message);
        }).join(`,
        `), `
    `));
      var k = function(I, A) {
        var P = I[A];
        if (P == null)
          return null;
        for (var O = arguments.length, K = new Array(O > 2 ? O - 2 : 0), W = 2; W < O; W++)
          K[W - 2] = arguments[W];
        var F = e.array.apply(void 0, [I, A].concat(K));
        return F || w.apply(void 0, [D, I, A].concat(K));
      };
      return k.isRequired = function(I, A, P) {
        for (var O = arguments.length, K = new Array(O > 3 ? O - 3 : 0), W = 3; W < O; W++)
          K[W - 3] = arguments[W];
        var F = e.array.isRequired.apply(e.array, [I, A, P].concat(K));
        return F || w.apply(void 0, [D, I, A, P].concat(K));
      }, (0, l.default)(k, "sequenceOf", D);
    }
  }(L7)), L7;
}
var Wie;
function mct() {
  return Wie || (Wie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = l;
    var e = r(X_e()), t = r(oq()), n = r(pi());
    function r(c) {
      return c && c.__esModule ? c : { default: c };
    }
    function s(c, d) {
      var u = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(c);
        d && (h = h.filter(function(f) {
          return Object.getOwnPropertyDescriptor(c, f).enumerable;
        })), u.push.apply(u, h);
      }
      return u;
    }
    function o(c) {
      for (var d = 1; d < arguments.length; d++) {
        var u = arguments[d] != null ? arguments[d] : {};
        d % 2 ? s(Object(u), !0).forEach(function(h) {
          a(c, h, u[h]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(u)) : s(Object(u)).forEach(function(h) {
          Object.defineProperty(c, h, Object.getOwnPropertyDescriptor(u, h));
        });
      }
      return c;
    }
    function a(c, d, u) {
      return d in c ? Object.defineProperty(c, d, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : c[d] = u, c;
    }
    function l() {
      for (var c = arguments.length, d = new Array(c), u = 0; u < c; u++)
        d[u] = arguments[u];
      var h = e.default.apply(void 0, d), f = function(p, m, _) {
        if (m !== "children")
          return new TypeError("".concat(_, ' is using the childrenSequenceOf validator on non-children prop "').concat(m, '"'));
        var b = p[m], w = (0, t.default)(b);
        if (w.length === 0)
          return null;
        for (var y = arguments.length, S = new Array(y > 3 ? y - 3 : 0), x = 3; x < y; x++)
          S[x - 3] = arguments[x];
        return h.apply(void 0, [o(o({}, p), {}, {
          children: w
        }), m, _].concat(S));
      };
      return f.isRequired = function(p, m, _) {
        if (m !== "children")
          return new TypeError("".concat(_, ' is using the childrenSequenceOf validator on non-children prop "').concat(m, '"'));
        var b = p[m], w = (0, t.default)(b);
        if (w.length === 0)
          return new TypeError("".concat(_, ": renderable children are required."));
        for (var y = arguments.length, S = new Array(y > 3 ? y - 3 : 0), x = 3; x < y; x++)
          S[x - 3] = arguments[x];
        return h.isRequired.apply(h, [o(o({}, p), {}, {
          children: w
        }), m, _].concat(S));
      }, (0, n.default)(f, "childrenSequenceOf", d);
    }
  }(E7)), E7;
}
var M7 = {}, jie;
function vct() {
  return jie || (jie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = c;
    var e = o(it), t = o(k_e()), n = o(B_e()), r = o(cx()), s = o(pi());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d, u) {
      for (var h = d; /\([^()]*\)/g.test(h); ) {
        var f = h, g = void 0;
        do
          g = f, f = g.replace(/\([^()]*\)/g, "");
        while (g !== f);
        if (u.indexOf(f) === -1)
          return h;
        h = h.replace(RegExp("^".concat(f, "\\(|\\)$"), "g"), "");
      }
      return h;
    }
    function l(d, u, h, f, g) {
      for (var p = arguments.length, m = new Array(p > 5 ? p - 5 : 0), _ = 5; _ < p; _++)
        m[_ - 5] = arguments[_];
      if (Array.isArray(h))
        return (0, n.default)(h.map(function(S) {
          return l.apply(void 0, [d, u, S, f, g].concat(m));
        }), Boolean) || null;
      if (!/* @__PURE__ */ e.default.isValidElement(h))
        return new TypeError("".concat(g, ".").concat(f, " is not a valid React element"));
      var b = h.type, w = (0, r.default)(b), y = u.length > 0 ? a(w, u) : w;
      return (0, t.default)(d) && !d.test(y) ? new TypeError("`".concat(g, ".").concat(f, "` only accepts components matching the regular expression ").concat(d)) : !(0, t.default)(d) && y !== d ? new TypeError("`".concat(g, ".").concat(f, "` only accepts components named ").concat(d, ", got ").concat(y)) : null;
    }
    function c(d) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (typeof d != "string" && !(0, t.default)(d))
        throw new TypeError("name must be a string or a regex");
      var h = Object.keys(u);
      if (h.length > 1 || h.length === 1 && h[0] !== "stripHOCs")
        throw new TypeError("The only options supported are: “stripHOCs”, got: “".concat(h.join("”, “"), "”"));
      var f = u.stripHOCs, g = f === void 0 ? [] : f, p = g.every(function(_) {
        return typeof _ != "string" || /[()]/g.test(_) ? !1 : /^(?:[a-z][a-zA-Z0-9]+|[A-Z][a-z][a-zA-Z0-9]+)$/.test(_);
      });
      if (!p)
        throw new TypeError("every provided HOC name must be a string with no parens, and in camelCase");
      function m(_, b, w) {
        var y = _[b];
        if (_[b] == null)
          return null;
        for (var S = arguments.length, x = new Array(S > 3 ? S - 3 : 0), D = 3; D < S; D++)
          x[D - 3] = arguments[D];
        return l.apply(void 0, [d, g, y, b, w].concat(x));
      }
      return m.isRequired = function(b, w, y) {
        var S = b[w];
        if (S == null)
          return new TypeError("`".concat(y, ".").concat(w, "` requires at least one component named ").concat(d));
        for (var x = arguments.length, D = new Array(x > 3 ? x - 3 : 0), E = 3; E < x; E++)
          D[E - 3] = arguments[E];
        return l.apply(void 0, [d, g, S, w, y].concat(D));
      }, (0, s.default)(m, "componentWithName:".concat(d), d);
    }
  }(M7)), M7;
}
var R7 = {}, zie;
function _ct() {
  return zie || (zie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = n;
    var e = t(pi());
    function t(r) {
      return r && r.__esModule ? r : { default: r };
    }
    function n(r, s, o) {
      if (typeof r != "function" || typeof r.isRequired != "function")
        throw new TypeError("a propType validator is required; propType validators must also provide `.isRequired`");
      if (typeof s != "string")
        throw new TypeError("other prop name must be a string");
      if (typeof o != "function")
        throw new TypeError("other prop type validator is required");
      function a(c, d, u) {
        for (var h = arguments.length, f = new Array(h > 3 ? h - 3 : 0), g = 3; g < h; g++)
          f[g - 3] = arguments[g];
        var p = r.isRequired.apply(r, [c, d, u].concat(f));
        if (p)
          return p;
        if (c[s] == null)
          return null;
        var m = o.apply(void 0, [c, s, u].concat(f));
        return m ? null : new Error("prop “".concat(d, "” is disallowed when “").concat(s, "” matches the provided validator"));
      }
      var l = function(d, u) {
        if (d[u] == null)
          return null;
        for (var h = arguments.length, f = new Array(h > 2 ? h - 2 : 0), g = 2; g < h; g++)
          f[g - 2] = arguments[g];
        return a.apply(void 0, [d, u].concat(f));
      };
      return l.isRequired = a, (0, e.default)(l, "disallowedIf", {
        propType: r,
        otherPropName: s,
        otherPropType: o
      });
    }
  }(R7)), R7;
}
var F7 = {}, Uie;
function bct() {
  return Uie || (Uie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = d;
    var e = mn(), t = z_e(), n = o(Q0()), r = o(cx()), s = o(pi());
    function o(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function a(u) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(f) {
        return typeof f;
      } : a = function(f) {
        return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
      }, a(u);
    }
    function l(u) {
      if (typeof u == "string")
        return u;
      var h = (0, r.default)(u);
      return h || "Anonymous Component";
    }
    function c(u, h, f, g) {
      var p = h[f].type;
      return p === u ? null : new TypeError("".concat(g, ".").concat(f, " must be a React element of type ").concat(l(u)));
    }
    function d(u) {
      if (u === "*")
        return (0, s.default)(e.element, "elementType(*)", u);
      if (!(0, t.isValidElementType)(u))
        throw new TypeError('Type must be a React Component, an HTML element tag name, or "*". Got an '.concat(a(u)));
      function h(p, m, _) {
        if (p[m] == null)
          return null;
        for (var b = arguments.length, w = new Array(b > 3 ? b - 3 : 0), y = 3; y < b; y++)
          w[y - 3] = arguments[y];
        return c.apply(void 0, [u, p, m, _].concat(w));
      }
      h.isRequired = h;
      var f = l(u), g = "elementType(".concat(f, ")");
      return (0, s.default)((0, n.default)([e.element, h], g), g, u);
    }
  }(F7)), F7;
}
var B7 = {}, V7 = {}, Gie;
function Z_e() {
  return Gie || (Gie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = u;
    var e = mn(), t = n(pi());
    function n(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function r(h) {
      return l(h) || a(h) || o(h) || s();
    }
    function s() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function o(h, f) {
      if (h) {
        if (typeof h == "string") return c(h, f);
        var g = Object.prototype.toString.call(h).slice(8, -1);
        if (g === "Object" && h.constructor && (g = h.constructor.name), g === "Map" || g === "Set") return Array.from(h);
        if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return c(h, f);
      }
    }
    function a(h) {
      if (typeof Symbol < "u" && Symbol.iterator in Object(h)) return Array.from(h);
    }
    function l(h) {
      if (Array.isArray(h)) return c(h);
    }
    function c(h, f) {
      (f == null || f > h.length) && (f = h.length);
      for (var g = 0, p = new Array(f); g < f; g++)
        p[g] = h[g];
      return p;
    }
    function d(h) {
      var f = function(p, m, _) {
        for (var b = arguments.length, w = new Array(b > 3 ? b - 3 : 0), y = 3; y < b; y++)
          w[y - 3] = arguments[y];
        var S = p[m];
        if (typeof S > "u")
          return null;
        var x = h.map(function(D) {
          return D.apply(void 0, [p, m, _].concat(w));
        }).filter(Boolean);
        return x.length < h.length ? null : new TypeError("".concat(_, ": invalid value supplied to ").concat(m, "."));
      };
      return f.isRequired = function(p, m, _) {
        for (var b = arguments.length, w = new Array(b > 3 ? b - 3 : 0), y = 3; y < b; y++)
          w[y - 3] = arguments[y];
        var S = p[m];
        if (typeof S > "u")
          return new TypeError("".concat(_, ": missing value for required ").concat(m, "."));
        var x = h.map(function(D) {
          return D.apply(void 0, [p, m, _].concat(w));
        }).filter(Boolean);
        return x.length === h.length ? new TypeError("".concat(_, ": invalid value ").concat(x, " supplied to required ").concat(m, ".")) : null;
      }, (0, t.default)(f, "oneOfType", h);
    }
    function u(h) {
      var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "or";
      if (!Array.isArray(h))
        throw new TypeError("or: 2 or more validators are required");
      if (h.length <= 1)
        throw new RangeError("or: 2 or more validators are required");
      var g = d([(0, e.arrayOf)(d(h))].concat(r(h)));
      return (0, t.default)(g, f, h);
    }
  }(V7)), V7;
}
var H7 = {}, qie;
function Q_e() {
  return qie || (qie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = t(pi());
    function t(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function n(o) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(l) {
        return typeof l;
      } : n = function(l) {
        return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
      }, n(o);
    }
    function r(o, a, l) {
      return o[a] == null ? null : new TypeError("".concat(l, ": prop “").concat(a, "” must be null or undefined; received ").concat(n(o[a])));
    }
    r.isRequired = function(a, l, c) {
      return a[l] === null ? null : new TypeError("".concat(c, ": prop “").concat(l, "” must be null; received ").concat(n(a[l])));
    };
    var s = function() {
      return (0, e.default)(r, "explicitNull");
    };
    i.default = s;
  }(H7)), H7;
}
var Kie;
function Cct() {
  return Kie || (Kie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = mn(), t = o(Z_e()), n = o(Q_e()), r = o(hq()), s = o(pi());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var a, l = (0, t.default)([
      n.default,
      // null/undefined
      (0, e.oneOf)([!1, "", NaN]),
      (0, r.default)(e.array, {
        length: (0, e.oneOf)([0]).isRequired
      }).isRequired,
      function() {
        return a.apply(void 0, arguments);
      }
    ]);
    a = (0, e.arrayOf)(l).isRequired;
    var c = function() {
      return (0, s.default)(l, "empty");
    };
    i.default = c;
  }(B7)), B7;
}
var W7 = {}, Yie;
function yct() {
  return Yie || (Yie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = s;
    var e = n(D_e()), t = n(pi());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function r(o, a, l) {
      return a in o ? Object.defineProperty(o, a, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : o[a] = l, o;
    }
    function s(o) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "keysOf";
      if (typeof o != "function")
        throw new TypeError("argument to keysOf must be a valid PropType function");
      var l = function(d, u, h, f, g) {
        for (var p = arguments.length, m = new Array(p > 5 ? p - 5 : 0), _ = 5; _ < p; _++)
          m[_ - 5] = arguments[_];
        var b = d[u];
        if (b == null || (0, e.default)(b))
          return null;
        var w = null;
        return Object.keys(b).some(function(y) {
          return w = o.apply(void 0, [r({}, y, y), y, h, f, "(".concat(g, ").").concat(y)].concat(m)), w != null;
        }), w || null;
      };
      return l.isRequired = function(d, u, h) {
        var f = d[u];
        if (f == null)
          return new TypeError("".concat(h, ": ").concat(u, " is required, but value is ").concat(f));
        for (var g = arguments.length, p = new Array(g > 3 ? g - 3 : 0), m = 3; m < g; m++)
          p[m - 3] = arguments[m];
        return l.apply(void 0, [d, u, h].concat(p));
      }, (0, t.default)(l, a, o);
    }
  }(W7)), W7;
}
var j7 = {}, Xie;
function wct() {
  return Xie || (Xie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = o;
    var e = t(pi());
    function t(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function n(a, l) {
      var c = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var d = Object.getOwnPropertySymbols(a);
        l && (d = d.filter(function(u) {
          return Object.getOwnPropertyDescriptor(a, u).enumerable;
        })), c.push.apply(c, d);
      }
      return c;
    }
    function r(a) {
      for (var l = 1; l < arguments.length; l++) {
        var c = arguments[l] != null ? arguments[l] : {};
        l % 2 ? n(Object(c), !0).forEach(function(d) {
          s(a, d, c[d]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(c)) : n(Object(c)).forEach(function(d) {
          Object.defineProperty(a, d, Object.getOwnPropertyDescriptor(c, d));
        });
      }
      return a;
    }
    function s(a, l, c) {
      return l in a ? Object.defineProperty(a, l, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[l] = c, a;
    }
    function o(a) {
      if (typeof a != "function")
        throw new TypeError("a propType is required");
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), d = 1; d < l; d++)
        c[d - 1] = arguments[d];
      if (c.length < 1)
        throw new TypeError("at least one prop that is mutually exclusive with this propType is required");
      var u = c.join(", or "), h = c.reduce(function(p, m) {
        return r(r({}, p), {}, s({}, m, !0));
      }, {}), f = function(m, _) {
        return m + (h[_] ? 1 : 0);
      }, g = function(m, _, b) {
        var w = Object.keys(m).filter(function(D) {
          return m[D] != null;
        }).reduce(f, 0);
        if (w > 1)
          return new Error("A ".concat(b, " cannot have more than one of these props: ").concat(u));
        for (var y = arguments.length, S = new Array(y > 3 ? y - 3 : 0), x = 3; x < y; x++)
          S[x - 3] = arguments[x];
        return a.apply(void 0, [m, _, b].concat(S));
      };
      return g.isRequired = function(m, _, b) {
        var w = Object.keys(m).filter(function(D) {
          return D === _ || m[D] != null;
        }).reduce(f, 0);
        if (w > 1)
          return new Error("A ".concat(b, " cannot have more than one of these props: ").concat(u));
        for (var y = arguments.length, S = new Array(y > 3 ? y - 3 : 0), x = 3; x < y; x++)
          S[x - 3] = arguments[x];
        return a.apply(void 0, [m, _, b].concat(S));
      }, (0, e.default)(g, "mutuallyExclusiveProps:".concat(u), c);
    }
  }(j7)), j7;
}
var z7 = {}, Zie;
function Sct() {
  return Zie || (Zie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = mn(), t = n(pi());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r() {
      for (var s = arguments.length, o = new Array(s), a = 0; a < s; a++)
        o[a] = arguments[a];
      if (o.length < 1)
        throw new TypeError("at least one prop that is mutually exclusive is required");
      if (!o.every(function(d) {
        return typeof d == "string";
      }))
        throw new TypeError("all exclusive true props must be strings");
      var l = o.join(", or "), c = function(u, h, f) {
        var g = function(y, S) {
          return y + (u[S] ? 1 : 0);
        }, p = o.reduce(g, 0);
        if (p > 1)
          return new Error("A ".concat(f, " cannot have more than one of these boolean props be true: ").concat(l));
        for (var m = arguments.length, _ = new Array(m > 3 ? m - 3 : 0), b = 3; b < m; b++)
          _[b - 3] = arguments[b];
        return e.bool.apply(void 0, [u, h, f].concat(_));
      };
      return c.isRequired = function(u, h, f) {
        var g = function(y, S) {
          return y + (u[S] ? 1 : 0);
        }, p = o.reduce(g, 0);
        if (p > 1)
          return new Error("A ".concat(f, " cannot have more than one of these boolean props be true: ").concat(l));
        for (var m = arguments.length, _ = new Array(m > 3 ? m - 3 : 0), b = 3; b < m; b++)
          _[b - 3] = arguments[b];
        return e.bool.isRequired.apply(e.bool, [u, h, f].concat(_));
      }, (0, t.default)(c, "mutuallyExclusiveTrueProps: ".concat(l), o);
    }
  }(z7)), z7;
}
var U7 = {}, Qie;
function xct() {
  return Qie || (Qie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = s;
    var e = r(it), t = mn(), n = r(pi());
    function r(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function s(o) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t.node;
      if (typeof o != "number" || isNaN(o) || o < 0)
        throw new TypeError("a non-negative number is required");
      var l = function(d, u, h) {
        if (u !== "children")
          return new TypeError("".concat(h, " is using the nChildren validator on a non-children prop"));
        var f = d.children, g = e.default.Children.count(f);
        if (g !== o)
          return new RangeError("".concat(h, " expects to receive ").concat(o, " children, but received ").concat(g, " children."));
        for (var p = arguments.length, m = new Array(p > 3 ? p - 3 : 0), _ = 3; _ < p; _++)
          m[_ - 3] = arguments[_];
        return a.apply(void 0, [d, u, h].concat(m));
      };
      return l.isRequired = l, (0, n.default)(l, "nChildren:".concat(o), o);
    }
  }(U7)), U7;
}
var G7 = {}, Jie;
function Dct() {
  return Jie || (Jie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = mn(), t = n(pi());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var r = /^[-+]?(?:[1-9][0-9]*(?:\.[0-9]+)?|0|0\.[0-9]+)$/, s = function(l, c, d) {
      if (l[c] == null)
        return null;
      for (var u = arguments.length, h = new Array(u > 3 ? u - 3 : 0), f = 3; f < u; f++)
        h[f - 3] = arguments[f];
      var g = e.string.apply(void 0, [l, c, d].concat(h));
      if (g)
        return g;
      var p = l[c], m = r.test(p);
      return m ? null : new TypeError("".concat(d, ': prop "').concat(c, '" (value "').concat(p, `") must be a numeric string:
    - starting with an optional + or -
    - that does not have a leading zero
    - with an optional decimal part (that contains only one decimal point, if present)
    - that otherwise only contains digits (0-9)
    - not +-NaN, or +-Infinity
  `));
    };
    s.isRequired = function(l, c, d) {
      if (l[c] == null)
        return new TypeError("".concat(d, ": ").concat(c, " is required"));
      for (var u = arguments.length, h = new Array(u > 3 ? u - 3 : 0), f = 3; f < u; f++)
        h[f - 3] = arguments[f];
      return s.apply(void 0, [l, c, d].concat(h));
    };
    var o = function() {
      return (0, t.default)(s, "numericString");
    };
    i.default = o;
  }(G7)), G7;
}
var q7 = {}, $ie;
function Ect() {
  return $ie || ($ie = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = n;
    var e = t(pi());
    function t(r) {
      return r && r.__esModule ? r : { default: r };
    }
    function n(r) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      if (typeof r != "function")
        throw new TypeError("`fn` must be a function");
      if (typeof s != "string")
        throw new TypeError("`message`, if provided, must be a string");
      function o(l, c, d) {
        var u = r(l[c]);
        return u ? null : new TypeError("`".concat(d, "` requires that `").concat(c, "` pass a predicate function").concat(s ? ": ".concat(s) : "", "."));
      }
      function a(l, c) {
        if (l[c] == null)
          return null;
        for (var d = arguments.length, u = new Array(d > 2 ? d - 2 : 0), h = 2; h < d; h++)
          u[h - 2] = arguments[h];
        return o.apply(void 0, [l, c].concat(u));
      }
      return a.isRequired = o, (0, e.default)(a, "predicate", r);
    }
  }(q7)), q7;
}
var K7 = {}, ere;
function Lct() {
  return ere || (ere = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = c;
    var e = o(Q0()), t = o(sq()), n = o(uq()), r = o(U_e()), s = o(pi());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var a = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
    Math.pow(2, 53) - 1;
    function l(d) {
      return (0, r.default)(d) && Math.abs(d) < a;
    }
    function c(d, u) {
      if (!l(d) || !l(u))
        throw new RangeError('"range" requires two integers: '.concat(d, " and ").concat(u, " given"));
      if (d === u)
        throw new RangeError("min and max must not be the same");
      return (0, s.default)((0, e.default)([(0, n.default)(), (0, t.default)({
        gte: d,
        lt: u
      })], "range"), "range", {
        min: d,
        max: u
      });
    }
  }(K7)), K7;
}
var Y7 = {}, tre;
function J_e() {
  return tre || (tre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = it, t = r(iq()), n = r(pi());
    function r(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var s = Object.prototype.isPrototypeOf;
    function o(u) {
      if (!(0, t.default)(u))
        return !1;
      var h = Object.keys(u);
      return h.length === 1 && h[0] === "current";
    }
    function a(u) {
      return typeof u == "function" && !s.call(e.Component, u) && (!e.PureComponent || !s.call(e.PureComponent, u));
    }
    function l(u, h, f) {
      var g = u[h];
      return a(g) || o(g) ? null : new TypeError("".concat(h, " in ").concat(f, " must be a ref"));
    }
    function c(u, h, f) {
      var g = u[h];
      if (g == null)
        return null;
      for (var p = arguments.length, m = new Array(p > 3 ? p - 3 : 0), _ = 3; _ < p; _++)
        m[_ - 3] = arguments[_];
      return l.apply(void 0, [u, h, f].concat(m));
    }
    c.isRequired = l;
    var d = function() {
      return (0, n.default)(c, "ref");
    };
    i.default = d;
  }(Y7)), Y7;
}
var X7 = {}, nre;
function Ict() {
  return nre || (nre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = n(QG()), t = n(pi());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r(s, o) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      function l(c, d, u) {
        if (c[s]) {
          var h = c[d];
          if ((0, e.default)(h, a) || typeof h > "u")
            return new TypeError("".concat(u, ": when ").concat(s, " is true, prop “").concat(d, "” must be present."));
        }
        for (var f = arguments.length, g = new Array(f > 3 ? f - 3 : 0), p = 3; p < f; p++)
          g[p - 3] = arguments[p];
        return o.apply(void 0, [c, d, u].concat(g));
      }
      return l.isRequired = function(d, u, h) {
        var f = d[u];
        if ((0, e.default)(f, a))
          return new TypeError("".concat(h, ": prop “").concat(u, "” must be present."));
        for (var g = arguments.length, p = new Array(g > 3 ? g - 3 : 0), m = 3; m < g; m++)
          p[m - 3] = arguments[m];
        return o.isRequired.apply(o, [d, u, h].concat(p));
      }, (0, t.default)(l, "requiredBy “".concat(s, "”"), [s, a]);
    }
  }(X7)), X7;
}
var Z7 = {}, ire;
function Act() {
  return ire || (ire = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = t(pi());
    function t(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function n(s) {
      function o(a, l, c, d) {
        if (a[l] == null)
          return null;
        if (s && typeof s == "function") {
          for (var u = arguments.length, h = new Array(u > 4 ? u - 4 : 0), f = 4; f < u; f++)
            h[f - 4] = arguments[f];
          return new TypeError(s.apply(void 0, [a, l, c, d].concat(h)));
        }
        return new TypeError("The ".concat(l, " ").concat(d, " on ").concat(c, " is not allowed."));
      }
      return o.isRequired = o, o;
    }
    var r = function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      return (0, e.default)(n(o), "restrictedProp");
    };
    i.default = r;
  }(Z7)), Z7;
}
var Q7 = {}, rre;
function kct() {
  return rre || (rre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = mn(), t = n(pi());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r(s) {
      if (typeof s != "string" || s.length === 0)
        throw new TypeError("a non-empty string is required");
      var o = function(l, c, d) {
        var u = l[c];
        if (u == null)
          return null;
        for (var h = arguments.length, f = new Array(h > 3 ? h - 3 : 0), g = 3; g < h; g++)
          f[g - 3] = arguments[g];
        var p = e.string.apply(void 0, [l, c, d].concat(f));
        return p || (!u.endsWith(s) || u.length <= s.length ? new TypeError("".concat(d, ": ").concat(c, ' does not end with "').concat(s, '"')) : null);
      };
      return o.isRequired = function() {
        var l = e.string.isRequired.apply(e.string, arguments);
        return l || o.apply(void 0, arguments);
      }, (0, t.default)(o, "stringEndsWith: ".concat(s));
    }
  }(Q7)), Q7;
}
var J7 = {}, sre;
function Tct() {
  return sre || (sre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var e = mn(), t = n(pi());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r(s) {
      if (typeof s != "string" || s.length === 0)
        throw new TypeError("a non-empty string is required");
      var o = function(l, c, d) {
        var u = l[c];
        if (u == null)
          return null;
        for (var h = arguments.length, f = new Array(h > 3 ? h - 3 : 0), g = 3; g < h; g++)
          f[g - 3] = arguments[g];
        var p = e.string.apply(void 0, [l, c, d].concat(f));
        return p || (!u.startsWith(s) || u.length <= s.length ? new TypeError("".concat(d, ": ").concat(c, ' does not start with "').concat(s, '"')) : null);
      };
      return o.isRequired = function() {
        var l = e.string.isRequired.apply(e.string, arguments);
        return l || o.apply(void 0, arguments);
      }, (0, t.default)(o, "stringStartsWith: ".concat(s));
    }
  }(J7)), J7;
}
var $7 = {}, ore;
function $_e() {
  return ore || (ore = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = mn(), t = n(pi());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function r(d) {
      return new Set(d).size;
    }
    function s(d) {
      var u = [];
      return d.forEach(function(h) {
        u.indexOf(h) === -1 && u.push(h);
      }), u.length;
    }
    var o = typeof Set == "function" ? r : (
      /* istanbul ignore next */
      s
    );
    function a(d, u, h) {
      for (var f = arguments.length, g = new Array(f > 3 ? f - 3 : 0), p = 3; p < f; p++)
        g[p - 3] = arguments[p];
      var m = e.array.isRequired.apply(e.array, [d, u, h].concat(g));
      if (m != null)
        return m;
      var _ = d[u], b = o(_);
      return b !== _.length ? new RangeError("".concat(h, ": values must be unique. ").concat(_.length - b, " duplicate values found.")) : null;
    }
    function l(d, u) {
      var h = d[u];
      if (h == null)
        return null;
      for (var f = arguments.length, g = new Array(f > 2 ? f - 2 : 0), p = 2; p < f; p++)
        g[p - 2] = arguments[p];
      return a.apply(void 0, [d, u].concat(g));
    }
    l.isRequired = a;
    var c = function() {
      return (0, t.default)(l, "uniqueArray");
    };
    i.default = c;
  }($7)), $7;
}
var eP = {}, are;
function Nct() {
  return are || (are = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = c;
    var e = mn(), t = r(Q0()), n = r($_e());
    function r(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function s(d, u) {
      var h = Object.keys(d);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(d);
        u && (f = f.filter(function(g) {
          return Object.getOwnPropertyDescriptor(d, g).enumerable;
        })), h.push.apply(h, f);
      }
      return h;
    }
    function o(d) {
      for (var u = 1; u < arguments.length; u++) {
        var h = arguments[u] != null ? arguments[u] : {};
        u % 2 ? s(Object(h), !0).forEach(function(f) {
          a(d, f, h[f]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(h)) : s(Object(h)).forEach(function(f) {
          Object.defineProperty(d, f, Object.getOwnPropertyDescriptor(h, f));
        });
      }
      return d;
    }
    function a(d, u, h) {
      return u in d ? Object.defineProperty(d, u, { value: h, enumerable: !0, configurable: !0, writable: !0 }) : d[u] = h, d;
    }
    var l = (0, n.default)();
    function c(d) {
      if (typeof d != "function")
        throw new TypeError("type must be a validator function");
      for (var u = null, h = "uniqueArrayOfType", f = arguments.length, g = new Array(f > 1 ? f - 1 : 0), p = 1; p < f; p++)
        g[p - 1] = arguments[p];
      if (g.length === 1)
        if (typeof g[0] == "function")
          u = g[0];
        else if (typeof g[0] == "string")
          h = g[0];
        else
          throw new TypeError("single input must either be string or function");
      else if (g.length === 2)
        if (typeof g[0] == "function" && typeof g[1] == "string")
          u = g[0], h = g[1];
        else
          throw new TypeError("multiple inputs must be in [function, string] order");
      else if (g.length > 2)
        throw new TypeError("only [], [name], [mapper], and [mapper, name] are valid inputs");
      function m(y, S) {
        var x = y[S];
        if (x == null)
          return null;
        for (var D = x.map(u), E = arguments.length, L = new Array(E > 2 ? E - 2 : 0), k = 2; k < E; k++)
          L[k - 2] = arguments[k];
        return l.apply(void 0, [o(o({}, y), {}, a({}, S, D)), S].concat(L));
      }
      m.isRequired = function(S, x) {
        for (var D = S[x], E = arguments.length, L = new Array(E > 2 ? E - 2 : 0), k = 2; k < E; k++)
          L[k - 2] = arguments[k];
        return D == null ? e.array.isRequired.apply(e.array, [S, x].concat(L)) : m.apply(void 0, [S, x].concat(L));
      };
      var _ = (0, e.arrayOf)(d), b = u ? m : l, w = (0, t.default)([_, b], h);
      return w.isRequired = (0, t.default)([b.isRequired, _.isRequired], "".concat(h, ".isRequired")), w;
    }
  }(eP)), eP;
}
var tP, lre;
function Pct() {
  if (lre) return tP;
  lre = 1;
  var i = R(Ult()), e = R(Q0()), t = R(sq()), n = R(Klt()), r = R(Ylt()), s = R(Xlt()), o = R(pct()), a = R(mct()), l = R(vct()), c = R(_ct()), d = R(bct()), u = R(Cct()), h = R(Q_e()), f = R(uq()), g = R(yct()), p = R(wct()), m = R(Sct()), _ = R(xct()), b = R(q_e()), w = R(G_e()), y = R(Dct()), S = R(Y_e()), x = R(Z_e()), D = R(Ect()), E = R(Lct()), L = R(J_e()), k = R(Ict()), N = R(Act()), I = R(X_e()), A = R(rq()), P = R(kct()), O = R(Tct()), K = R($_e()), W = R(Nct()), F = R(E_e()), q = R(hq());
  function R(T) {
    return T && T.__esModule ? T : { default: T };
  }
  return tP = {
    and: e.default,
    between: t.default,
    booleanSome: n.default,
    childrenHavePropXorChildren: r.default,
    childrenOf: s.default,
    childrenOfType: o.default,
    childrenSequenceOf: a.default,
    componentWithName: l.default,
    disallowedIf: c.default,
    elementType: d.default,
    empty: u.default,
    explicitNull: h.default,
    forbidExtraProps: i.default,
    integer: f.default,
    keysOf: g.default,
    mutuallyExclusiveProps: p.default,
    mutuallyExclusiveTrueProps: m.default,
    nChildren: _.default,
    nonNegativeInteger: b.default,
    nonNegativeNumber: w.default,
    numericString: y.default,
    object: S.default,
    or: x.default,
    predicate: D.default,
    range: E.default,
    ref: L.default,
    requiredBy: k.default,
    restrictedProp: N.default,
    sequenceOf: I.default,
    shape: A.default,
    stringEndsWith: P.default,
    stringStartsWith: O.default,
    uniqueArray: K.default,
    uniqueArrayOf: W.default,
    valuesOf: F.default,
    withShape: q.default
  }, tP;
}
var nP, cre;
function Or() {
  return cre || (cre = 1, nP = process.env.NODE_ENV === "production" ? Nlt() : Pct()), nP;
}
var iP = {}, rP = { exports: {} }, dre;
function ebe() {
  return dre || (dre = 1, function(i) {
    var e = JG().default;
    function t(r) {
      if (typeof WeakMap != "function") return null;
      var s = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
      return (t = function(l) {
        return l ? o : s;
      })(r);
    }
    function n(r, s) {
      if (!s && r && r.__esModule) return r;
      if (r === null || e(r) != "object" && typeof r != "function") return {
        default: r
      };
      var o = t(s);
      if (o && o.has(r)) return o.get(r);
      var a = {
        __proto__: null
      }, l = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var c in r) if (c !== "default" && {}.hasOwnProperty.call(r, c)) {
        var d = l ? Object.getOwnPropertyDescriptor(r, c) : null;
        d && (d.get || d.set) ? Object.defineProperty(a, c, d) : a[c] = r[c];
      }
      return a.default = r, o && o.set(r, a), a;
    }
    i.exports = n, i.exports.__esModule = !0, i.exports.default = i.exports;
  }(rP)), rP.exports;
}
function Oct(i, e) {
  if (i == null) return {};
  var t = {};
  for (var n in i) if ({}.hasOwnProperty.call(i, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = i[n];
  }
  return t;
}
function wd(i, e) {
  if (i == null) return {};
  var t, n, r = Oct(i, e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(i);
    for (n = 0; n < s.length; n++) t = s[n], e.indexOf(t) >= 0 || {}.propertyIsEnumerable.call(i, t) && (r[t] = i[t]);
  }
  return r;
}
const Mct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wd
}, Symbol.toStringTag, { value: "Module" })), Rct = /* @__PURE__ */ L0(Mct);
var o3 = { exports: {} }, Ti = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ure;
function Fct() {
  if (ure) return Ti;
  ure = 1;
  var i = typeof Symbol == "function" && Symbol.for, e = i ? Symbol.for("react.element") : 60103, t = i ? Symbol.for("react.portal") : 60106, n = i ? Symbol.for("react.fragment") : 60107, r = i ? Symbol.for("react.strict_mode") : 60108, s = i ? Symbol.for("react.profiler") : 60114, o = i ? Symbol.for("react.provider") : 60109, a = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, c = i ? Symbol.for("react.concurrent_mode") : 60111, d = i ? Symbol.for("react.forward_ref") : 60112, u = i ? Symbol.for("react.suspense") : 60113, h = i ? Symbol.for("react.suspense_list") : 60120, f = i ? Symbol.for("react.memo") : 60115, g = i ? Symbol.for("react.lazy") : 60116, p = i ? Symbol.for("react.block") : 60121, m = i ? Symbol.for("react.fundamental") : 60117, _ = i ? Symbol.for("react.responder") : 60118, b = i ? Symbol.for("react.scope") : 60119;
  function w(S) {
    if (typeof S == "object" && S !== null) {
      var x = S.$$typeof;
      switch (x) {
        case e:
          switch (S = S.type, S) {
            case l:
            case c:
            case n:
            case s:
            case r:
            case u:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case a:
                case d:
                case g:
                case f:
                case o:
                  return S;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  function y(S) {
    return w(S) === c;
  }
  return Ti.AsyncMode = l, Ti.ConcurrentMode = c, Ti.ContextConsumer = a, Ti.ContextProvider = o, Ti.Element = e, Ti.ForwardRef = d, Ti.Fragment = n, Ti.Lazy = g, Ti.Memo = f, Ti.Portal = t, Ti.Profiler = s, Ti.StrictMode = r, Ti.Suspense = u, Ti.isAsyncMode = function(S) {
    return y(S) || w(S) === l;
  }, Ti.isConcurrentMode = y, Ti.isContextConsumer = function(S) {
    return w(S) === a;
  }, Ti.isContextProvider = function(S) {
    return w(S) === o;
  }, Ti.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === e;
  }, Ti.isForwardRef = function(S) {
    return w(S) === d;
  }, Ti.isFragment = function(S) {
    return w(S) === n;
  }, Ti.isLazy = function(S) {
    return w(S) === g;
  }, Ti.isMemo = function(S) {
    return w(S) === f;
  }, Ti.isPortal = function(S) {
    return w(S) === t;
  }, Ti.isProfiler = function(S) {
    return w(S) === s;
  }, Ti.isStrictMode = function(S) {
    return w(S) === r;
  }, Ti.isSuspense = function(S) {
    return w(S) === u;
  }, Ti.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === c || S === s || S === r || S === u || S === h || typeof S == "object" && S !== null && (S.$$typeof === g || S.$$typeof === f || S.$$typeof === o || S.$$typeof === a || S.$$typeof === d || S.$$typeof === m || S.$$typeof === _ || S.$$typeof === b || S.$$typeof === p);
  }, Ti.typeOf = w, Ti;
}
var Ni = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hre;
function Bct() {
  return hre || (hre = 1, process.env.NODE_ENV !== "production" && function() {
    var i = typeof Symbol == "function" && Symbol.for, e = i ? Symbol.for("react.element") : 60103, t = i ? Symbol.for("react.portal") : 60106, n = i ? Symbol.for("react.fragment") : 60107, r = i ? Symbol.for("react.strict_mode") : 60108, s = i ? Symbol.for("react.profiler") : 60114, o = i ? Symbol.for("react.provider") : 60109, a = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, c = i ? Symbol.for("react.concurrent_mode") : 60111, d = i ? Symbol.for("react.forward_ref") : 60112, u = i ? Symbol.for("react.suspense") : 60113, h = i ? Symbol.for("react.suspense_list") : 60120, f = i ? Symbol.for("react.memo") : 60115, g = i ? Symbol.for("react.lazy") : 60116, p = i ? Symbol.for("react.block") : 60121, m = i ? Symbol.for("react.fundamental") : 60117, _ = i ? Symbol.for("react.responder") : 60118, b = i ? Symbol.for("react.scope") : 60119;
    function w(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === n || j === c || j === s || j === r || j === u || j === h || typeof j == "object" && j !== null && (j.$$typeof === g || j.$$typeof === f || j.$$typeof === o || j.$$typeof === a || j.$$typeof === d || j.$$typeof === m || j.$$typeof === _ || j.$$typeof === b || j.$$typeof === p);
    }
    function y(j) {
      if (typeof j == "object" && j !== null) {
        var he = j.$$typeof;
        switch (he) {
          case e:
            var Se = j.type;
            switch (Se) {
              case l:
              case c:
              case n:
              case s:
              case r:
              case u:
                return Se;
              default:
                var ge = Se && Se.$$typeof;
                switch (ge) {
                  case a:
                  case d:
                  case g:
                  case f:
                  case o:
                    return ge;
                  default:
                    return he;
                }
            }
          case t:
            return he;
        }
      }
    }
    var S = l, x = c, D = a, E = o, L = e, k = d, N = n, I = g, A = f, P = t, O = s, K = r, W = u, F = !1;
    function q(j) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(j) || y(j) === l;
    }
    function R(j) {
      return y(j) === c;
    }
    function T(j) {
      return y(j) === a;
    }
    function z(j) {
      return y(j) === o;
    }
    function X(j) {
      return typeof j == "object" && j !== null && j.$$typeof === e;
    }
    function ae(j) {
      return y(j) === d;
    }
    function ue(j) {
      return y(j) === n;
    }
    function se(j) {
      return y(j) === g;
    }
    function le(j) {
      return y(j) === f;
    }
    function oe(j) {
      return y(j) === t;
    }
    function re(j) {
      return y(j) === s;
    }
    function B(j) {
      return y(j) === r;
    }
    function ee(j) {
      return y(j) === u;
    }
    Ni.AsyncMode = S, Ni.ConcurrentMode = x, Ni.ContextConsumer = D, Ni.ContextProvider = E, Ni.Element = L, Ni.ForwardRef = k, Ni.Fragment = N, Ni.Lazy = I, Ni.Memo = A, Ni.Portal = P, Ni.Profiler = O, Ni.StrictMode = K, Ni.Suspense = W, Ni.isAsyncMode = q, Ni.isConcurrentMode = R, Ni.isContextConsumer = T, Ni.isContextProvider = z, Ni.isElement = X, Ni.isForwardRef = ae, Ni.isFragment = ue, Ni.isLazy = se, Ni.isMemo = le, Ni.isPortal = oe, Ni.isProfiler = re, Ni.isStrictMode = B, Ni.isSuspense = ee, Ni.isValidElementType = w, Ni.typeOf = y;
  }()), Ni;
}
var fre;
function Vct() {
  return fre || (fre = 1, process.env.NODE_ENV === "production" ? o3.exports = Fct() : o3.exports = Bct()), o3.exports;
}
var sP, gre;
function fq() {
  if (gre) return sP;
  gre = 1;
  var i = Vct(), e = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, t = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, n = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, r = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, s = {};
  s[i.ForwardRef] = n, s[i.Memo] = r;
  function o(g) {
    return i.isMemo(g) ? r : s[g.$$typeof] || e;
  }
  var a = Object.defineProperty, l = Object.getOwnPropertyNames, c = Object.getOwnPropertySymbols, d = Object.getOwnPropertyDescriptor, u = Object.getPrototypeOf, h = Object.prototype;
  function f(g, p, m) {
    if (typeof p != "string") {
      if (h) {
        var _ = u(p);
        _ && _ !== h && f(g, _, m);
      }
      var b = l(p);
      c && (b = b.concat(c(p)));
      for (var w = o(g), y = o(p), S = 0; S < b.length; ++S) {
        var x = b[S];
        if (!t[x] && !(m && m[x]) && !(y && y[x]) && !(w && w[x])) {
          var D = d(p, x);
          try {
            a(g, x, D);
          } catch {
          }
        }
      }
    }
    return g;
  }
  return sP = f, sP;
}
var oP = {}, pre;
function Hct() {
  return pre || (pre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = {}, t = function() {
      return e;
    }, n = t;
    i.default = n;
  }(oP)), oP;
}
var aP = {}, mre;
function Wct() {
  return mre || (mre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.perfStart = e, i.perfEnd = t, i.default = n;
    function e(r) {
      typeof performance < "u" && performance.mark !== void 0 && typeof performance.clearMarks == "function" && r && (performance.clearMarks(r), performance.mark(r));
    }
    function t(r, s, o) {
      typeof performance < "u" && performance.mark !== void 0 && typeof performance.clearMarks == "function" && (performance.clearMarks(s), performance.mark(s), performance.measure(o, r, s), performance.clearMarks(o));
    }
    function n(r) {
      var s = "react-with-styles.".concat(r, ".start"), o = "react-with-styles.".concat(r, ".end"), a = "👩‍🎨 [".concat(r, "]");
      return function(l) {
        return function() {
          process.env.NODE_ENV !== "production" && e(s);
          var c = l.apply(void 0, arguments);
          return process.env.NODE_ENV !== "production" && t(s, o, a), c;
        };
      };
    }
  }(aP)), aP;
}
var lP = {}, cP = {}, dP, vre;
function jct() {
  if (vre) return dP;
  vre = 1;
  var i = function(f) {
    return e(f) && !t(f);
  };
  function e(h) {
    return !!h && typeof h == "object";
  }
  function t(h) {
    var f = Object.prototype.toString.call(h);
    return f === "[object RegExp]" || f === "[object Date]" || s(h);
  }
  var n = typeof Symbol == "function" && Symbol.for, r = n ? Symbol.for("react.element") : 60103;
  function s(h) {
    return h.$$typeof === r;
  }
  function o(h) {
    return Array.isArray(h) ? [] : {};
  }
  function a(h, f) {
    var g = f && f.clone === !0;
    return g && i(h) ? d(o(h), h, f) : h;
  }
  function l(h, f, g) {
    var p = h.slice();
    return f.forEach(function(m, _) {
      typeof p[_] > "u" ? p[_] = a(m, g) : i(m) ? p[_] = d(h[_], m, g) : h.indexOf(m) === -1 && p.push(a(m, g));
    }), p;
  }
  function c(h, f, g) {
    var p = {};
    return i(h) && Object.keys(h).forEach(function(m) {
      p[m] = a(h[m], g);
    }), Object.keys(f).forEach(function(m) {
      !i(f[m]) || !h[m] ? p[m] = a(f[m], g) : p[m] = d(h[m], f[m], g);
    }), p;
  }
  function d(h, f, g) {
    var p = Array.isArray(f), m = Array.isArray(h), _ = g || { arrayMerge: l }, b = p === m;
    if (b)
      if (p) {
        var w = _.arrayMerge || l;
        return w(h, f, g);
      } else
        return c(h, f, g);
    else return a(f, g);
  }
  d.all = function(f, g) {
    if (!Array.isArray(f) || f.length < 2)
      throw new Error("first argument should be an array with at least two elements");
    return f.reduce(function(p, m) {
      return d(p, m, g);
    });
  };
  var u = d;
  return dP = u, dP;
}
var A2 = {}, _re;
function tbe() {
  return _re || (_re = 1, Object.defineProperty(A2, "__esModule", {
    value: !0
  }), A2.CHANNEL = "__direction__", A2.DIRECTIONS = {
    LTR: "ltr",
    RTL: "rtl"
  }), A2;
}
var uP = {}, bre;
function zct() {
  return bre || (bre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    });
    var e = mn(), t = n(e);
    function n(r) {
      return r && r.__esModule ? r : { default: r };
    }
    i.default = t.default.shape({
      getState: t.default.func,
      setState: t.default.func,
      subscribe: t.default.func
    });
  }(uP)), uP;
}
var hP = {}, fP, Cre;
function nbe() {
  if (Cre) return fP;
  Cre = 1;
  var i = Pb(), e = Xa(), t = e("Object.prototype.propertyIsEnumerable"), n = e("Array.prototype.push");
  return fP = function(s) {
    var o = i(s), a = [];
    for (var l in o)
      t(o, l) && n(a, o[l]);
    return a;
  }, fP;
}
var gP, yre;
function ibe() {
  if (yre) return gP;
  yre = 1;
  var i = nbe();
  return gP = function() {
    return typeof Object.values == "function" ? Object.values : i;
  }, gP;
}
var pP, wre;
function Uct() {
  if (wre) return pP;
  wre = 1;
  var i = ibe(), e = Xr();
  return pP = function() {
    var n = i();
    return e(Object, { values: n }, {
      values: function() {
        return Object.values !== n;
      }
    }), n;
  }, pP;
}
var mP, Sre;
function lk() {
  if (Sre) return mP;
  Sre = 1;
  var i = Xr(), e = Vu(), t = nbe(), n = ibe(), r = Uct(), s = e(n(), Object);
  return i(s, {
    getPolyfill: n,
    implementation: t,
    shim: r
  }), mP = s, mP;
}
var xre;
function Gct() {
  return xre || (xre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    });
    var e = lk(), t = o(e), n = mn(), r = o(n), s = tbe();
    function o(a) {
      return a && a.__esModule ? a : { default: a };
    }
    i.default = r.default.oneOf((0, t.default)(s.DIRECTIONS));
  }(hP)), hP;
}
var Dre;
function qct() {
  return Dre || (Dre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.withDirectionPropTypes = i.DIRECTIONS = void 0;
    var e = Object.assign || function(E) {
      for (var L = 1; L < arguments.length; L++) {
        var k = arguments[L];
        for (var N in k)
          Object.prototype.hasOwnProperty.call(k, N) && (E[N] = k[N]);
      }
      return E;
    }, t = /* @__PURE__ */ function() {
      function E(L, k) {
        for (var N = 0; N < k.length; N++) {
          var I = k[N];
          I.enumerable = I.enumerable || !1, I.configurable = !0, "value" in I && (I.writable = !0), Object.defineProperty(L, I.key, I);
        }
      }
      return function(L, k, N) {
        return k && E(L.prototype, k), N && E(L, N), L;
      };
    }();
    i.default = D;
    var n = it, r = m(n), s = fq(), o = m(s), a = jct(), l = m(a), c = cx(), d = m(c), u = tbe(), h = zct(), f = m(h), g = Gct(), p = m(g);
    function m(E) {
      return E && E.__esModule ? E : { default: E };
    }
    function _(E, L) {
      if (!(E instanceof L))
        throw new TypeError("Cannot call a class as a function");
    }
    function b(E, L) {
      if (!E)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return L && (typeof L == "object" || typeof L == "function") ? L : E;
    }
    function w(E, L) {
      if (typeof L != "function" && L !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof L);
      E.prototype = Object.create(L && L.prototype, { constructor: { value: E, enumerable: !1, writable: !0, configurable: !0 } }), L && (Object.setPrototypeOf ? Object.setPrototypeOf(E, L) : E.__proto__ = L);
    }
    function y(E, L, k) {
      return L in E ? Object.defineProperty(E, L, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : E[L] = k, E;
    }
    var S = y({}, u.CHANNEL, f.default);
    i.DIRECTIONS = u.DIRECTIONS;
    var x = u.DIRECTIONS.LTR;
    i.withDirectionPropTypes = {
      direction: p.default.isRequired
    };
    function D(E) {
      var L = function(N) {
        w(I, N);
        function I(A, P) {
          _(this, I);
          var O = b(this, (I.__proto__ || Object.getPrototypeOf(I)).call(this, A, P));
          return O.state = {
            direction: P[u.CHANNEL] ? P[u.CHANNEL].getState() : x
          }, O;
        }
        return t(I, [{
          key: "componentDidMount",
          value: /* @__PURE__ */ function() {
            function A() {
              var P = this;
              this.context[u.CHANNEL] && (this.channelUnsubscribe = this.context[u.CHANNEL].subscribe(function(O) {
                P.setState({ direction: O });
              }));
            }
            return A;
          }()
        }, {
          key: "componentWillUnmount",
          value: /* @__PURE__ */ function() {
            function A() {
              this.channelUnsubscribe && this.channelUnsubscribe();
            }
            return A;
          }()
        }, {
          key: "render",
          value: /* @__PURE__ */ function() {
            function A() {
              var P = this.state.direction;
              return r.default.createElement(E, e({}, this.props, {
                direction: P
              }));
            }
            return A;
          }()
        }]), I;
      }(r.default.Component), k = (0, d.default)(E) || "Component";
      return L.WrappedComponent = E, L.contextTypes = S, L.displayName = "withDirection(" + String(k) + ")", E.propTypes && (L.propTypes = (0, l.default)({}, E.propTypes), delete L.propTypes.direction), E.defaultProps && (L.defaultProps = (0, l.default)({}, E.defaultProps)), (0, o.default)(L, E);
    }
  }(cP)), cP;
}
var Ere;
function Kct() {
  return Ere || (Ere = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), Object.defineProperty(i, "DIRECTIONS", {
      enumerable: !0,
      get: function() {
        return r.DIRECTIONS;
      }
    }), i.default = void 0;
    var t = it, n = e(mn()), r = qct();
    function s(l) {
      return t.createContext ? /* @__PURE__ */ (0, t.createContext)(l) : {
        Provider: function() {
          throw new ReferenceError("WithStylesContext requires React 16.3 or later");
        },
        Consumer: function() {
          throw new ReferenceError("WithStylesContext requires React 16.3 or later");
        }
      };
    }
    var o = s({
      stylesInterface: null,
      stylesTheme: null,
      direction: null
    });
    o.Provider.propTypes = {
      stylesInterface: n.default.object,
      // eslint-disable-line react/forbid-prop-types
      stylesTheme: n.default.object,
      // eslint-disable-line react/forbid-prop-types
      direction: n.default.oneOf([r.DIRECTIONS.LTR, r.DIRECTIONS.RTL])
    };
    var a = o;
    i.default = a;
  }(lP)), lP;
}
var vP = {}, Lre;
function rbe() {
  return Lre || (Lre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i._getInterface = m, i._getTheme = u, i.default = void 0;
    var e, t, n = "react-with-styles.resolve.start", r = "react-with-styles.resolve.end", s = "👩‍🎨 [resolve]";
    function o(b) {
      t = b;
    }
    function a(b) {
      e = b;
    }
    function l(b, w) {
      var y = w(b(t));
      return function() {
        return y;
      };
    }
    function c(b) {
      return l(b, e.createLTR || e.create);
    }
    function d(b) {
      return l(b, e.createRTL || e.create);
    }
    function u() {
      return t;
    }
    function h() {
      process.env.NODE_ENV !== "production" && typeof performance < "u" && performance.mark !== void 0 && typeof performance.clearMarks == "function" && (performance.clearMarks(n), performance.mark(n));
      for (var b = arguments.length, w = new Array(b), y = 0; y < b; y++)
        w[y] = arguments[y];
      var S = e.resolve(w);
      return process.env.NODE_ENV !== "production" && typeof performance < "u" && performance.mark !== void 0 && typeof performance.clearMarks == "function" && (performance.clearMarks(r), performance.mark(r), performance.measure(s, n, r), performance.clearMarks(s)), S;
    }
    function f() {
      for (var b = arguments.length, w = new Array(b), y = 0; y < b; y++)
        w[y] = arguments[y];
      return e.resolveLTR ? e.resolveLTR(w) : h(w);
    }
    function g() {
      for (var b = arguments.length, w = new Array(b), y = 0; y < b; y++)
        w[y] = arguments[y];
      return e.resolveRTL ? e.resolveRTL(w) : h(w);
    }
    function p() {
      e.flush && e.flush();
    }
    function m() {
      return e;
    }
    var _ = {
      registerTheme: o,
      registerInterface: a,
      create: c,
      createLTR: c,
      createRTL: d,
      get: u,
      resolve: f,
      resolveLTR: f,
      resolveRTL: g,
      flush: p
    };
    i.default = _;
  }(vP)), vP;
}
var _P = {}, Ire;
function Yct() {
  return Ire || (Ire = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = i.withStylesPropTypes = void 0;
    var t = e(mn()), n = {
      styles: t.default.object.isRequired,
      theme: t.default.object.isRequired,
      css: t.default.func.isRequired
    };
    i.withStylesPropTypes = n;
    var r = n;
    i.default = r;
  }(_P)), _P;
}
var Are;
function Za() {
  return Are || (Are = 1, function(i) {
    var e = ebe(), t = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.withStyles = b, Object.defineProperty(i, "withStylesPropTypes", {
      enumerable: !0,
      get: function() {
        return p.withStylesPropTypes;
      }
    }), i.css = i.default = void 0;
    var n = t(ha()), r = t(hs()), s = t(Rct), o = t(fa()), a = t(it), l = t(fq()), c = t(cx()), d = t(J_e()), u = t(Hct()), h = t(Wct()), f = e(Kct()), g = e(rbe()), p = Yct();
    function m(S, x) {
      var D = Object.keys(S);
      if (Object.getOwnPropertySymbols) {
        var E = Object.getOwnPropertySymbols(S);
        x && (E = E.filter(function(L) {
          return Object.getOwnPropertyDescriptor(S, L).enumerable;
        })), D.push.apply(D, E);
      }
      return D;
    }
    function _(S) {
      for (var x = 1; x < arguments.length; x++) {
        var D = arguments[x] != null ? arguments[x] : {};
        x % 2 ? m(Object(D), !0).forEach(function(E) {
          (0, r.default)(S, E, D[E]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(S, Object.getOwnPropertyDescriptors(D)) : m(Object(D)).forEach(function(E) {
          Object.defineProperty(S, E, Object.getOwnPropertyDescriptor(D, E));
        });
      }
      return S;
    }
    function b() {
      var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : u.default, x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, D = x.stylesPropName, E = D === void 0 ? "styles" : D, L = x.themePropName, k = L === void 0 ? "theme" : L, N = x.cssPropName, I = N === void 0 ? "css" : N, A = x.flushBefore, P = A === void 0 ? !1 : A, O = x.pureComponent, K = O === void 0 ? !1 : O;
      S = S || u.default;
      var W = K ? a.default.PureComponent : a.default.Component, F = typeof WeakMap > "u" ? /* @__PURE__ */ new Map() : /* @__PURE__ */ new WeakMap();
      function q(ue) {
        var se = F.get(ue), le = se || S(ue) || {};
        return F.set(ue, le), le;
      }
      var R = typeof WeakMap > "u" ? /* @__PURE__ */ new Map() : /* @__PURE__ */ new WeakMap();
      function T(ue, se, le) {
        var oe = R.get(ue);
        if (!oe)
          return null;
        var re = oe.get(se);
        return re ? re[le] : null;
      }
      function z(ue, se, le, oe) {
        var re = R.get(ue);
        re || (re = typeof WeakMap > "u" ? /* @__PURE__ */ new Map() : /* @__PURE__ */ new WeakMap(), R.set(ue, re));
        var B = re.get(se);
        B || (B = {
          ltr: {},
          rtl: {}
        }, re.set(se, B)), B[le] = oe;
      }
      function X(ue, se) {
        var le = ue === f.DIRECTIONS.RTL ? "RTL" : "LTR", oe = se["create".concat(le)] || se.create, re = oe;
        return process.env.NODE_ENV !== "production" && (oe = (0, h.default)("create")(oe)), {
          create: oe,
          original: re
        };
      }
      function ae(ue, se) {
        var le = ue === f.DIRECTIONS.RTL ? "RTL" : "LTR", oe = se["resolve".concat(le)] || se.resolve, re = oe;
        return process.env.NODE_ENV !== "production" && (oe = (0, h.default)("resolve")(oe)), {
          resolve: oe,
          original: re
        };
      }
      return function(se) {
        var le = (0, c.default)(se), oe = /* @__PURE__ */ function(B) {
          (0, o.default)(ee, B);
          function ee() {
            return B.apply(this, arguments) || this;
          }
          var j = ee.prototype;
          return j.getCurrentInterface = function() {
            return this.context && this.context.stylesInterface || (0, g._getInterface)();
          }, j.getCurrentTheme = function() {
            return this.context && this.context.stylesTheme || (0, g._getTheme)();
          }, j.getCurrentDirection = function() {
            return this.context && this.context.direction || f.DIRECTIONS.LTR;
          }, j.getProps = function() {
            var Se = this.getCurrentInterface(), ge = this.getCurrentTheme(), te = this.getCurrentDirection(), be = T(ge, ee, te), Ae = !be || !be.stylesInterface || Se && be.stylesInterface !== Se, He = !be || be.theme !== ge;
            if (!Ae && !He)
              return be.props;
            var de = Ae && X(te, Se) || be.create, ce = Ae && ae(te, Se) || be.resolve, ie = de.create, H = ce.resolve, Y = !be || !be.create || de.original !== be.create.original, Z = !be || !be.resolve || ce.original !== be.resolve.original, Q = Z && function() {
              for (var Ue = arguments.length, je = new Array(Ue), Ze = 0; Ze < Ue; Ze++)
                je[Ze] = arguments[Ze];
              return H(je);
            } || be.props.css, me = q(ge), Le = (Y || me !== be.stylesFnResult) && ie(me) || be.props.styles, xe = {
              css: Q,
              styles: Le,
              theme: ge
            };
            return z(ge, ee, te, {
              stylesInterface: Se,
              theme: ge,
              create: de,
              resolve: ce,
              stylesFnResult: me,
              props: xe
            }), xe;
          }, j.flush = function() {
            var Se = this.getCurrentInterface();
            Se && Se.flush && Se.flush();
          }, j.render = function() {
            var Se, ge = this.getProps(), te = ge.theme, be = ge.styles, Ae = ge.css;
            P && this.flush();
            var He = this.props, de = He.forwardedRef, ce = (0, s.default)(He, ["forwardedRef"]);
            return /* @__PURE__ */ a.default.createElement(
              se,
              (0, n.default)({
                ref: typeof a.default.forwardRef > "u" ? void 0 : de
              }, typeof a.default.forwardRef > "u" ? this.props : ce, (Se = {}, (0, r.default)(Se, k, te), (0, r.default)(Se, E, be), (0, r.default)(Se, I, Ae), Se))
            );
          }, ee;
        }(W);
        typeof a.default.forwardRef < "u" && (oe.propTypes = {
          forwardedRef: (0, d.default)()
        });
        var re = typeof a.default.forwardRef > "u" ? oe : /* @__PURE__ */ a.default.forwardRef(function(B, ee) {
          return /* @__PURE__ */ a.default.createElement(oe, (0, n.default)({}, B, {
            forwardedRef: ee
          }));
        });
        return se.propTypes && (re.propTypes = _({}, se.propTypes), delete re.propTypes[E], delete re.propTypes[k], delete re.propTypes[I]), se.defaultProps && (re.defaultProps = _({}, se.defaultProps)), oe.contextType = f.default, re.WrappedComponent = se, re.displayName = "withStyles(".concat(le, ")"), (0, l.default)(re, se);
      };
    }
    var w = b;
    i.default = w;
    var y = g.default.resolveLTR;
    i.css = y;
  }(iP)), iP;
}
var k2 = { exports: {} }, A1 = { exports: {} }, kre;
function Xct() {
  return kre || (kre = 1, function() {
    var i, e, t, n, r, s;
    typeof performance < "u" && performance !== null && performance.now ? A1.exports = function() {
      return performance.now();
    } : typeof process < "u" && process !== null && process.hrtime ? (A1.exports = function() {
      return (i() - r) / 1e6;
    }, e = process.hrtime, i = function() {
      var o;
      return o = e(), o[0] * 1e9 + o[1];
    }, n = i(), s = process.uptime() * 1e9, r = n - s) : Date.now ? (A1.exports = function() {
      return Date.now() - t;
    }, t = Date.now()) : (A1.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - t;
    }, t = (/* @__PURE__ */ new Date()).getTime());
  }.call(Zs)), A1.exports;
}
var Tre;
function gq() {
  if (Tre) return k2.exports;
  Tre = 1;
  for (var i = Xct(), e = typeof window > "u" ? Zs : window, t = ["moz", "webkit"], n = "AnimationFrame", r = e["request" + n], s = e["cancel" + n] || e["cancelRequest" + n], o = 0; !r && o < t.length; o++)
    r = e[t[o] + "Request" + n], s = e[t[o] + "Cancel" + n] || e[t[o] + "CancelRequest" + n];
  if (!r || !s) {
    var a = 0, l = 0, c = [], d = 1e3 / 60;
    r = function(u) {
      if (c.length === 0) {
        var h = i(), f = Math.max(0, d - (h - a));
        a = f + h, setTimeout(function() {
          var g = c.slice(0);
          c.length = 0;
          for (var p = 0; p < g.length; p++)
            if (!g[p].cancelled)
              try {
                g[p].callback(a);
              } catch (m) {
                setTimeout(function() {
                  throw m;
                }, 0);
              }
        }, Math.round(f));
      }
      return c.push({
        handle: ++l,
        callback: u,
        cancelled: !1
      }), l;
    }, s = function(u) {
      for (var h = 0; h < c.length; h++)
        c[h].handle === u && (c[h].cancelled = !0);
    };
  }
  return k2.exports = function(u) {
    return r.call(e, u);
  }, k2.exports.cancel = function() {
    s.apply(e, arguments);
  }, k2.exports.polyfill = function(u) {
    u || (u = e), u.requestAnimationFrame = r, u.cancelAnimationFrame = s;
  }, k2.exports;
}
var bP = {}, Nre;
function So() {
  return Nre || (Nre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.CalendarDayPhrases = i.DayPickerNavigationPhrases = i.DayPickerKeyboardShortcutsPhrases = i.DayPickerPhrases = i.SingleDatePickerInputPhrases = i.SingleDatePickerPhrases = i.DateRangePickerInputPhrases = i.DateRangePickerPhrases = i.default = void 0;
    var e = "Calendar", t = "datepicker", n = "Close", r = "Interact with the calendar and add the check-in date for your trip.", s = "Clear Date", o = "Clear Dates", a = "Move backward to switch to the previous month.", l = "Move forward to switch to the next month.", c = "Keyboard Shortcuts", d = "Open the keyboard shortcuts panel.", u = "Close the shortcuts panel.", h = "Open this panel.", f = "Enter key", g = "Right and left arrow keys", p = "up and down arrow keys", m = "page up and page down keys", _ = "Home and end keys", b = "Escape key", w = "Question mark", y = "Select the date in focus.", S = "Move backward (left) and forward (right) by one day.", x = "Move backward (up) and forward (down) by one week.", D = "Switch months.", E = "Go to the first or last day of a week.", L = "Return to the date input field.", k = "Navigate forward to interact with the calendar and select a date. Press the question mark key to get the keyboard shortcuts for changing dates.", N = "Navigate backward to interact with the calendar and select a date. Press the question mark key to get the keyboard shortcuts for changing dates.", I = function(re) {
      var B = re.date;
      return "Choose ".concat(B, " as your check-in date. It’s available.");
    }, A = function(re) {
      var B = re.date;
      return "Choose ".concat(B, " as your check-out date. It’s available.");
    }, P = function(re) {
      var B = re.date;
      return B;
    }, O = function(re) {
      var B = re.date;
      return "Not available. ".concat(B);
    }, K = function(re) {
      var B = re.date;
      return "Selected. ".concat(B);
    }, W = function(re) {
      var B = re.date;
      return "Selected as start date. ".concat(B);
    }, F = function(re) {
      var B = re.date;
      return "Selected as end date. ".concat(B);
    }, q = {
      calendarLabel: e,
      roleDescription: t,
      closeDatePicker: n,
      focusStartDate: r,
      clearDate: s,
      clearDates: o,
      jumpToPrevMonth: a,
      jumpToNextMonth: l,
      keyboardShortcuts: c,
      showKeyboardShortcutsPanel: d,
      hideKeyboardShortcutsPanel: u,
      openThisPanel: h,
      enterKey: f,
      leftArrowRightArrow: g,
      upArrowDownArrow: p,
      pageUpPageDown: m,
      homeEnd: _,
      escape: b,
      questionMark: w,
      selectFocusedDate: y,
      moveFocusByOneDay: S,
      moveFocusByOneWeek: x,
      moveFocusByOneMonth: D,
      moveFocustoStartAndEndOfWeek: E,
      returnFocusToInput: L,
      keyboardForwardNavigationInstructions: k,
      keyboardBackwardNavigationInstructions: N,
      chooseAvailableStartDate: I,
      chooseAvailableEndDate: A,
      dateIsUnavailable: O,
      dateIsSelected: K,
      dateIsSelectedAsStartDate: W,
      dateIsSelectedAsEndDate: F
    };
    i.default = q;
    var R = {
      calendarLabel: e,
      roleDescription: t,
      closeDatePicker: n,
      clearDates: o,
      focusStartDate: r,
      jumpToPrevMonth: a,
      jumpToNextMonth: l,
      keyboardShortcuts: c,
      showKeyboardShortcutsPanel: d,
      hideKeyboardShortcutsPanel: u,
      openThisPanel: h,
      enterKey: f,
      leftArrowRightArrow: g,
      upArrowDownArrow: p,
      pageUpPageDown: m,
      homeEnd: _,
      escape: b,
      questionMark: w,
      selectFocusedDate: y,
      moveFocusByOneDay: S,
      moveFocusByOneWeek: x,
      moveFocusByOneMonth: D,
      moveFocustoStartAndEndOfWeek: E,
      returnFocusToInput: L,
      keyboardForwardNavigationInstructions: k,
      keyboardBackwardNavigationInstructions: N,
      chooseAvailableStartDate: I,
      chooseAvailableEndDate: A,
      dateIsUnavailable: O,
      dateIsSelected: K,
      dateIsSelectedAsStartDate: W,
      dateIsSelectedAsEndDate: F
    };
    i.DateRangePickerPhrases = R;
    var T = {
      focusStartDate: r,
      clearDates: o,
      keyboardForwardNavigationInstructions: k,
      keyboardBackwardNavigationInstructions: N
    };
    i.DateRangePickerInputPhrases = T;
    var z = {
      calendarLabel: e,
      roleDescription: t,
      closeDatePicker: n,
      clearDate: s,
      jumpToPrevMonth: a,
      jumpToNextMonth: l,
      keyboardShortcuts: c,
      showKeyboardShortcutsPanel: d,
      hideKeyboardShortcutsPanel: u,
      openThisPanel: h,
      enterKey: f,
      leftArrowRightArrow: g,
      upArrowDownArrow: p,
      pageUpPageDown: m,
      homeEnd: _,
      escape: b,
      questionMark: w,
      selectFocusedDate: y,
      moveFocusByOneDay: S,
      moveFocusByOneWeek: x,
      moveFocusByOneMonth: D,
      moveFocustoStartAndEndOfWeek: E,
      returnFocusToInput: L,
      keyboardForwardNavigationInstructions: k,
      keyboardBackwardNavigationInstructions: N,
      chooseAvailableDate: P,
      dateIsUnavailable: O,
      dateIsSelected: K
    };
    i.SingleDatePickerPhrases = z;
    var X = {
      clearDate: s,
      keyboardForwardNavigationInstructions: k,
      keyboardBackwardNavigationInstructions: N
    };
    i.SingleDatePickerInputPhrases = X;
    var ae = {
      calendarLabel: e,
      roleDescription: t,
      jumpToPrevMonth: a,
      jumpToNextMonth: l,
      keyboardShortcuts: c,
      showKeyboardShortcutsPanel: d,
      hideKeyboardShortcutsPanel: u,
      openThisPanel: h,
      enterKey: f,
      leftArrowRightArrow: g,
      upArrowDownArrow: p,
      pageUpPageDown: m,
      homeEnd: _,
      escape: b,
      questionMark: w,
      selectFocusedDate: y,
      moveFocusByOneDay: S,
      moveFocusByOneWeek: x,
      moveFocusByOneMonth: D,
      moveFocustoStartAndEndOfWeek: E,
      returnFocusToInput: L,
      chooseAvailableStartDate: I,
      chooseAvailableEndDate: A,
      chooseAvailableDate: P,
      dateIsUnavailable: O,
      dateIsSelected: K,
      dateIsSelectedAsStartDate: W,
      dateIsSelectedAsEndDate: F
    };
    i.DayPickerPhrases = ae;
    var ue = {
      keyboardShortcuts: c,
      showKeyboardShortcutsPanel: d,
      hideKeyboardShortcutsPanel: u,
      openThisPanel: h,
      enterKey: f,
      leftArrowRightArrow: g,
      upArrowDownArrow: p,
      pageUpPageDown: m,
      homeEnd: _,
      escape: b,
      questionMark: w,
      selectFocusedDate: y,
      moveFocusByOneDay: S,
      moveFocusByOneWeek: x,
      moveFocusByOneMonth: D,
      moveFocustoStartAndEndOfWeek: E,
      returnFocusToInput: L
    };
    i.DayPickerKeyboardShortcutsPhrases = ue;
    var se = {
      jumpToPrevMonth: a,
      jumpToNextMonth: l
    };
    i.DayPickerNavigationPhrases = se;
    var le = {
      chooseAvailableDate: P,
      dateIsUnavailable: O,
      dateIsSelected: K,
      dateIsSelectedAsStartDate: W,
      dateIsSelectedAsEndDate: F
    };
    i.CalendarDayPhrases = le;
  }(bP)), bP;
}
var CP = {}, Pre;
function ga() {
  return Pre || (Pre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = o;
    var t = e(hs()), n = e(mn());
    function r(a, l) {
      var c = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var d = Object.getOwnPropertySymbols(a);
        l && (d = d.filter(function(u) {
          return Object.getOwnPropertyDescriptor(a, u).enumerable;
        })), c.push.apply(c, d);
      }
      return c;
    }
    function s(a) {
      for (var l = 1; l < arguments.length; l++) {
        var c = arguments[l] != null ? arguments[l] : {};
        l % 2 ? r(Object(c), !0).forEach(function(d) {
          (0, t.default)(a, d, c[d]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(c)) : r(Object(c)).forEach(function(d) {
          Object.defineProperty(a, d, Object.getOwnPropertyDescriptor(c, d));
        });
      }
      return a;
    }
    function o(a) {
      return Object.keys(a).reduce(function(l, c) {
        return s({}, l, (0, t.default)({}, c, n.default.oneOfType([n.default.string, n.default.func, n.default.node])));
      }, {});
    }
  }(CP)), CP;
}
var yP = {}, wP = {}, Ore;
function Zct() {
  return Ore || (Ore = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = e;
    function e(t, n) {
      return typeof t == "string" ? t : typeof t == "function" ? t(n) : "";
    }
  }(wP)), wP;
}
var Ft = {}, Mre;
function mi() {
  if (Mre) return Ft;
  Mre = 1, Object.defineProperty(Ft, "__esModule", {
    value: !0
  }), Ft.MODIFIER_KEY_NAMES = Ft.DEFAULT_VERTICAL_SPACING = Ft.FANG_HEIGHT_PX = Ft.FANG_WIDTH_PX = Ft.WEEKDAYS = Ft.BLOCKED_MODIFIER = Ft.DAY_SIZE = Ft.OPEN_UP = Ft.OPEN_DOWN = Ft.ANCHOR_RIGHT = Ft.ANCHOR_LEFT = Ft.INFO_POSITION_AFTER = Ft.INFO_POSITION_BEFORE = Ft.INFO_POSITION_BOTTOM = Ft.INFO_POSITION_TOP = Ft.ICON_AFTER_POSITION = Ft.ICON_BEFORE_POSITION = Ft.NAV_POSITION_TOP = Ft.NAV_POSITION_BOTTOM = Ft.VERTICAL_SCROLLABLE = Ft.VERTICAL_ORIENTATION = Ft.HORIZONTAL_ORIENTATION = Ft.END_DATE = Ft.START_DATE = Ft.ISO_MONTH_FORMAT = Ft.ISO_FORMAT = Ft.DISPLAY_FORMAT = void 0;
  var i = "L";
  Ft.DISPLAY_FORMAT = i;
  var e = "YYYY-MM-DD";
  Ft.ISO_FORMAT = e;
  var t = "YYYY-MM";
  Ft.ISO_MONTH_FORMAT = t;
  var n = "startDate";
  Ft.START_DATE = n;
  var r = "endDate";
  Ft.END_DATE = r;
  var s = "horizontal";
  Ft.HORIZONTAL_ORIENTATION = s;
  var o = "vertical";
  Ft.VERTICAL_ORIENTATION = o;
  var a = "verticalScrollable";
  Ft.VERTICAL_SCROLLABLE = a;
  var l = "navPositionBottom";
  Ft.NAV_POSITION_BOTTOM = l;
  var c = "navPositionTop";
  Ft.NAV_POSITION_TOP = c;
  var d = "before";
  Ft.ICON_BEFORE_POSITION = d;
  var u = "after";
  Ft.ICON_AFTER_POSITION = u;
  var h = "top";
  Ft.INFO_POSITION_TOP = h;
  var f = "bottom";
  Ft.INFO_POSITION_BOTTOM = f;
  var g = "before";
  Ft.INFO_POSITION_BEFORE = g;
  var p = "after";
  Ft.INFO_POSITION_AFTER = p;
  var m = "left";
  Ft.ANCHOR_LEFT = m;
  var _ = "right";
  Ft.ANCHOR_RIGHT = _;
  var b = "down";
  Ft.OPEN_DOWN = b;
  var w = "up";
  Ft.OPEN_UP = w;
  var y = 39;
  Ft.DAY_SIZE = y;
  var S = "blocked";
  Ft.BLOCKED_MODIFIER = S;
  var x = [0, 1, 2, 3, 4, 5, 6];
  Ft.WEEKDAYS = x;
  var D = 20;
  Ft.FANG_WIDTH_PX = D;
  var E = 10;
  Ft.FANG_HEIGHT_PX = E;
  var L = 22;
  Ft.DEFAULT_VERTICAL_SPACING = L;
  var k = /* @__PURE__ */ new Set(["Shift", "Control", "Alt", "Meta"]);
  return Ft.MODIFIER_KEY_NAMES = k, Ft;
}
var Rre;
function sbe() {
  return Rre || (Rre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = l;
    var t = e(Zct()), n = mi();
    function r(c) {
      return c.has("selected") || c.has("selected-span") || c.has("selected-start") || c.has("selected-end");
    }
    function s(c) {
      return c.has("blocked-minimum-nights") || c.has("blocked-calendar") || c.has("blocked-out-of-range");
    }
    function o(c) {
      return r(c) ? !1 : c.has("hovered-span") || c.has("after-hovered-start") || c.has("before-hovered-end");
    }
    function a(c, d, u, h) {
      var f = c.chooseAvailableDate, g = c.dateIsUnavailable, p = c.dateIsSelected, m = c.dateIsSelectedAsStartDate, _ = c.dateIsSelectedAsEndDate, b = {
        date: u.format(h)
      };
      return d.has("selected-start") && m ? (0, t.default)(m, b) : d.has("selected-end") && _ ? (0, t.default)(_, b) : r(d) && p ? (0, t.default)(p, b) : d.has(n.BLOCKED_MODIFIER) ? (0, t.default)(g, b) : (0, t.default)(f, b);
    }
    function l(c, d, u, h, f) {
      return {
        ariaLabel: a(f, h, c, d),
        hoveredSpan: o(h),
        isOutsideRange: h.has("blocked-out-of-range"),
        selected: r(h),
        useDefaultCursor: s(h),
        daySizeStyles: {
          width: u,
          height: u - 1
        }
      };
    }
  }(yP)), yP;
}
var SP = {};
function mW(i, e) {
  (e == null || e > i.length) && (e = i.length);
  for (var t = 0, n = Array(e); t < e; t++) n[t] = i[t];
  return n;
}
function Qct(i) {
  if (Array.isArray(i)) return mW(i);
}
function Jct(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
}
function obe(i, e) {
  if (i) {
    if (typeof i == "string") return mW(i, e);
    var t = {}.toString.call(i).slice(8, -1);
    return t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set" ? Array.from(i) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? mW(i, e) : void 0;
  }
}
function $ct() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rm(i) {
  return Qct(i) || Jct(i) || obe(i) || $ct();
}
const edt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rm
}, Symbol.toStringTag, { value: "Module" })), pq = /* @__PURE__ */ L0(edt);
var Fre;
function ck() {
  return Fre || (Fre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(hs()), n = e(pq), r = e(mn()), s = Or(), o = (0, s.and)([r.default.instanceOf(Set), function(l, c) {
      for (var d = arguments.length, u = new Array(d > 2 ? d - 2 : 0), h = 2; h < d; h++)
        u[h - 2] = arguments[h];
      var f = l[c], g;
      return (0, n.default)(f).some(function(p, m) {
        var _, b = "".concat(c, ": index ").concat(m);
        return g = (_ = r.default.string).isRequired.apply(_, [(0, t.default)({}, b, p), b].concat(u)), g != null;
      }), g ?? null;
    }], "Modifiers (Set of Strings)");
    i.default = o;
  }(SP)), SP;
}
var Bre;
function abe() {
  return Bre || (Bre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = i.PureCalendarDay = void 0;
    var t = e(ua()), n = e(ha()), r = e(Pl()), s = e(fa()), o = e(hs()), a = e(it), l = e(mn()), c = e(yd()), d = Or(), u = Za(), h = e(gi), f = e(gq()), g = So(), p = e(ga()), m = e(sbe()), _ = e(ck()), b = mi();
    function w(L, k) {
      var N = Object.keys(L);
      if (Object.getOwnPropertySymbols) {
        var I = Object.getOwnPropertySymbols(L);
        k && (I = I.filter(function(A) {
          return Object.getOwnPropertyDescriptor(L, A).enumerable;
        })), N.push.apply(N, I);
      }
      return N;
    }
    function y(L) {
      for (var k = 1; k < arguments.length; k++) {
        var N = arguments[k] != null ? arguments[k] : {};
        k % 2 ? w(Object(N), !0).forEach(function(I) {
          (0, o.default)(L, I, N[I]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(L, Object.getOwnPropertyDescriptors(N)) : w(Object(N)).forEach(function(I) {
          Object.defineProperty(L, I, Object.getOwnPropertyDescriptor(N, I));
        });
      }
      return L;
    }
    var S = process.env.NODE_ENV !== "production" ? (0, d.forbidExtraProps)(y({}, u.withStylesPropTypes, {
      day: c.default.momentObj,
      daySize: d.nonNegativeInteger,
      isOutsideDay: l.default.bool,
      modifiers: _.default,
      isFocused: l.default.bool,
      tabIndex: l.default.oneOf([0, -1]),
      onDayClick: l.default.func,
      onDayMouseEnter: l.default.func,
      onDayMouseLeave: l.default.func,
      renderDayContents: l.default.func,
      ariaLabelFormat: l.default.string,
      // internationalization
      phrases: l.default.shape((0, p.default)(g.CalendarDayPhrases))
    })) : {}, x = {
      day: (0, h.default)(),
      daySize: b.DAY_SIZE,
      isOutsideDay: !1,
      modifiers: /* @__PURE__ */ new Set(),
      isFocused: !1,
      tabIndex: -1,
      onDayClick: function() {
      },
      onDayMouseEnter: function() {
      },
      onDayMouseLeave: function() {
      },
      renderDayContents: null,
      ariaLabelFormat: "dddd, LL",
      // internationalization
      phrases: g.CalendarDayPhrases
    }, D = /* @__PURE__ */ function(L) {
      (0, s.default)(N, L);
      var k = N.prototype;
      k[!a.default.PureComponent && "shouldComponentUpdate"] = function(I, A) {
        return !(0, t.default)(this.props, I) || !(0, t.default)(this.state, A);
      };
      function N() {
        for (var I, A = arguments.length, P = new Array(A), O = 0; O < A; O++)
          P[O] = arguments[O];
        return I = L.call.apply(L, [this].concat(P)) || this, I.setButtonRef = I.setButtonRef.bind((0, r.default)(I)), I;
      }
      return k.componentDidUpdate = function(A) {
        var P = this, O = this.props, K = O.isFocused, W = O.tabIndex;
        W === 0 && (K || W !== A.tabIndex) && (0, f.default)(function() {
          P.buttonRef && P.buttonRef.focus();
        });
      }, k.onDayClick = function(A, P) {
        var O = this.props.onDayClick;
        O(A, P);
      }, k.onDayMouseEnter = function(A, P) {
        var O = this.props.onDayMouseEnter;
        O(A, P);
      }, k.onDayMouseLeave = function(A, P) {
        var O = this.props.onDayMouseLeave;
        O(A, P);
      }, k.onKeyDown = function(A, P) {
        var O = this.props.onDayClick, K = P.key;
        (K === "Enter" || K === " ") && O(A, P);
      }, k.setButtonRef = function(A) {
        this.buttonRef = A;
      }, k.render = function() {
        var A = this, P = this.props, O = P.day, K = P.ariaLabelFormat, W = P.daySize, F = P.isOutsideDay, q = P.modifiers, R = P.renderDayContents, T = P.tabIndex, z = P.styles, X = P.phrases;
        if (!O) return a.default.createElement("td", null);
        var ae = (0, m.default)(O, K, W, q, X), ue = ae.daySizeStyles, se = ae.useDefaultCursor, le = ae.selected, oe = ae.hoveredSpan, re = ae.isOutsideRange, B = ae.ariaLabel;
        return a.default.createElement("td", (0, n.default)({}, (0, u.css)(z.CalendarDay, se && z.CalendarDay__defaultCursor, z.CalendarDay__default, F && z.CalendarDay__outside, q.has("today") && z.CalendarDay__today, q.has("first-day-of-week") && z.CalendarDay__firstDayOfWeek, q.has("last-day-of-week") && z.CalendarDay__lastDayOfWeek, q.has("hovered-offset") && z.CalendarDay__hovered_offset, q.has("hovered-start-first-possible-end") && z.CalendarDay__hovered_start_first_possible_end, q.has("hovered-start-blocked-minimum-nights") && z.CalendarDay__hovered_start_blocked_min_nights, q.has("highlighted-calendar") && z.CalendarDay__highlighted_calendar, q.has("blocked-minimum-nights") && z.CalendarDay__blocked_minimum_nights, q.has("blocked-calendar") && z.CalendarDay__blocked_calendar, oe && z.CalendarDay__hovered_span, q.has("after-hovered-start") && z.CalendarDay__after_hovered_start, q.has("selected-span") && z.CalendarDay__selected_span, q.has("selected-start") && z.CalendarDay__selected_start, q.has("selected-end") && z.CalendarDay__selected_end, le && !q.has("selected-span") && z.CalendarDay__selected, q.has("before-hovered-end") && z.CalendarDay__before_hovered_end, q.has("no-selected-start-before-selected-end") && z.CalendarDay__no_selected_start_before_selected_end, q.has("selected-start-in-hovered-span") && z.CalendarDay__selected_start_in_hovered_span, q.has("selected-end-in-hovered-span") && z.CalendarDay__selected_end_in_hovered_span, q.has("selected-start-no-selected-end") && z.CalendarDay__selected_start_no_selected_end, q.has("selected-end-no-selected-start") && z.CalendarDay__selected_end_no_selected_start, re && z.CalendarDay__blocked_out_of_range, ue), {
          role: "button",
          ref: this.setButtonRef,
          "aria-disabled": q.has("blocked"),
          "aria-label": B,
          onMouseEnter: function(j) {
            A.onDayMouseEnter(O, j);
          },
          onMouseLeave: function(j) {
            A.onDayMouseLeave(O, j);
          },
          onMouseUp: function(j) {
            j.currentTarget.blur();
          },
          onClick: function(j) {
            A.onDayClick(O, j);
          },
          onKeyDown: function(j) {
            A.onKeyDown(O, j);
          },
          tabIndex: T
        }), R ? R(O, q) : O.format("D"));
      }, N;
    }(a.default.PureComponent || a.default.Component);
    i.PureCalendarDay = D, D.propTypes = process.env.NODE_ENV !== "production" ? S : {}, D.defaultProps = x;
    var E = (0, u.withStyles)(function(L) {
      var k = L.reactDates, N = k.color, I = k.font;
      return {
        CalendarDay: {
          boxSizing: "border-box",
          cursor: "pointer",
          fontSize: I.size,
          textAlign: "center",
          ":active": {
            outline: 0
          }
        },
        CalendarDay__defaultCursor: {
          cursor: "default"
        },
        CalendarDay__default: {
          border: "1px solid ".concat(N.core.borderLight),
          color: N.text,
          background: N.background,
          ":hover": {
            background: N.core.borderLight,
            border: "1px solid ".concat(N.core.borderLight),
            color: "inherit"
          }
        },
        CalendarDay__hovered_offset: {
          background: N.core.borderBright,
          border: "1px double ".concat(N.core.borderLight),
          color: "inherit"
        },
        CalendarDay__outside: {
          border: 0,
          background: N.outside.backgroundColor,
          color: N.outside.color,
          ":hover": {
            border: 0
          }
        },
        CalendarDay__blocked_minimum_nights: {
          background: N.minimumNights.backgroundColor,
          border: "1px solid ".concat(N.minimumNights.borderColor),
          color: N.minimumNights.color,
          ":hover": {
            background: N.minimumNights.backgroundColor_hover,
            color: N.minimumNights.color_active
          },
          ":active": {
            background: N.minimumNights.backgroundColor_active,
            color: N.minimumNights.color_active
          }
        },
        CalendarDay__highlighted_calendar: {
          background: N.highlighted.backgroundColor,
          color: N.highlighted.color,
          ":hover": {
            background: N.highlighted.backgroundColor_hover,
            color: N.highlighted.color_active
          },
          ":active": {
            background: N.highlighted.backgroundColor_active,
            color: N.highlighted.color_active
          }
        },
        CalendarDay__selected_span: {
          background: N.selectedSpan.backgroundColor,
          border: "1px double ".concat(N.selectedSpan.borderColor),
          color: N.selectedSpan.color,
          ":hover": {
            background: N.selectedSpan.backgroundColor_hover,
            border: "1px double ".concat(N.selectedSpan.borderColor),
            color: N.selectedSpan.color_active
          },
          ":active": {
            background: N.selectedSpan.backgroundColor_active,
            border: "1px double ".concat(N.selectedSpan.borderColor),
            color: N.selectedSpan.color_active
          }
        },
        CalendarDay__selected: {
          background: N.selected.backgroundColor,
          border: "1px double ".concat(N.selected.borderColor),
          color: N.selected.color,
          ":hover": {
            background: N.selected.backgroundColor_hover,
            border: "1px double ".concat(N.selected.borderColor),
            color: N.selected.color_active
          },
          ":active": {
            background: N.selected.backgroundColor_active,
            border: "1px double ".concat(N.selected.borderColor),
            color: N.selected.color_active
          }
        },
        CalendarDay__hovered_span: {
          background: N.hoveredSpan.backgroundColor,
          border: "1px double ".concat(N.hoveredSpan.borderColor),
          color: N.hoveredSpan.color,
          ":hover": {
            background: N.hoveredSpan.backgroundColor_hover,
            border: "1px double ".concat(N.hoveredSpan.borderColor),
            color: N.hoveredSpan.color_active
          },
          ":active": {
            background: N.hoveredSpan.backgroundColor_active,
            border: "1px double ".concat(N.hoveredSpan.borderColor),
            color: N.hoveredSpan.color_active
          }
        },
        CalendarDay__blocked_calendar: {
          background: N.blocked_calendar.backgroundColor,
          border: "1px solid ".concat(N.blocked_calendar.borderColor),
          color: N.blocked_calendar.color,
          ":hover": {
            background: N.blocked_calendar.backgroundColor_hover,
            border: "1px solid ".concat(N.blocked_calendar.borderColor),
            color: N.blocked_calendar.color_active
          },
          ":active": {
            background: N.blocked_calendar.backgroundColor_active,
            border: "1px solid ".concat(N.blocked_calendar.borderColor),
            color: N.blocked_calendar.color_active
          }
        },
        CalendarDay__blocked_out_of_range: {
          background: N.blocked_out_of_range.backgroundColor,
          border: "1px solid ".concat(N.blocked_out_of_range.borderColor),
          color: N.blocked_out_of_range.color,
          ":hover": {
            background: N.blocked_out_of_range.backgroundColor_hover,
            border: "1px solid ".concat(N.blocked_out_of_range.borderColor),
            color: N.blocked_out_of_range.color_active
          },
          ":active": {
            background: N.blocked_out_of_range.backgroundColor_active,
            border: "1px solid ".concat(N.blocked_out_of_range.borderColor),
            color: N.blocked_out_of_range.color_active
          }
        },
        CalendarDay__hovered_start_first_possible_end: {
          background: N.core.borderLighter,
          border: "1px double ".concat(N.core.borderLighter)
        },
        CalendarDay__hovered_start_blocked_min_nights: {
          background: N.core.borderLighter,
          border: "1px double ".concat(N.core.borderLight)
        },
        CalendarDay__selected_start: {},
        CalendarDay__selected_end: {},
        CalendarDay__today: {},
        CalendarDay__firstDayOfWeek: {},
        CalendarDay__lastDayOfWeek: {},
        CalendarDay__after_hovered_start: {},
        CalendarDay__before_hovered_end: {},
        CalendarDay__no_selected_start_before_selected_end: {},
        CalendarDay__selected_start_in_hovered_span: {},
        CalendarDay__selected_end_in_hovered_span: {},
        CalendarDay__selected_start_no_selected_end: {},
        CalendarDay__selected_end_no_selected_start: {}
      };
    }, {
      pureComponent: typeof a.default.PureComponent < "u"
    })(D);
    i.default = E;
  }(rN)), rN;
}
var xP = {}, DP = {}, Vre;
function tdt() {
  return Vre || (Vre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = o;
    var t = e(it), n = e(mn()), r = Or(), s = process.env.NODE_ENV !== "production" ? (0, r.forbidExtraProps)({
      children: n.default.node.isRequired
    }) : {};
    function o(a) {
      var l = a.children;
      return t.default.createElement("tr", null, l);
    }
    o.propTypes = process.env.NODE_ENV !== "production" ? s : {};
  }(DP)), DP;
}
var EP = {}, Hre;
function lbe() {
  return Hre || (Hre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = e;
    function e(t, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      if (!t)
        return 0;
      var o = n === "width" ? "Left" : "Top", a = n === "width" ? "Right" : "Bottom", l = !r || s ? window.getComputedStyle(t) : null, c = t.offsetWidth, d = t.offsetHeight, u = n === "width" ? c : d;
      return r || (u -= parseFloat(l["padding".concat(o)]) + parseFloat(l["padding".concat(a)]) + parseFloat(l["border".concat(o, "Width")]) + parseFloat(l["border".concat(a, "Width")])), s && (u += parseFloat(l["margin".concat(o)]) + parseFloat(l["margin".concat(a)])), u;
    }
  }(EP)), EP;
}
var LP = {}, Wre;
function ndt() {
  return Wre || (Wre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = mi();
    function r(s, o) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.default.localeData().firstDayOfWeek();
      if (!t.default.isMoment(s) || !s.isValid())
        throw new TypeError("`month` must be a valid moment object");
      if (n.WEEKDAYS.indexOf(a) === -1)
        throw new TypeError("`firstDayOfWeek` must be an integer between 0 and 6");
      for (var l = s.clone().startOf("month").hour(12), c = s.clone().endOf("month").hour(12), d = (l.day() + 7 - a) % 7, u = (a + 6 - c.day()) % 7, h = l.clone().subtract(d, "day"), f = c.clone().add(u, "day"), g = f.diff(h, "days") + 1, p = h.clone(), m = [], _ = 0; _ < g; _ += 1) {
        _ % 7 === 0 && m.push([]);
        var b = null;
        (_ >= d && _ < g - u || o) && (b = p.clone()), m[m.length - 1].push(b), p.add(1, "day");
      }
      return m;
    }
  }(LP)), LP;
}
var IP = {}, jre;
function J0() {
  return jre || (jre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = n;
    var t = e(gi);
    function n(r, s) {
      return !t.default.isMoment(r) || !t.default.isMoment(s) ? !1 : r.date() === s.date() && r.month() === s.month() && r.year() === s.year();
    }
  }(IP)), IP;
}
var AP = {}, kP = {}, zre;
function Ob() {
  return zre || (zre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = mi();
    function r(s, o) {
      var a = o ? [o, n.DISPLAY_FORMAT, n.ISO_FORMAT] : [n.DISPLAY_FORMAT, n.ISO_FORMAT], l = (0, t.default)(s, a, !0);
      return l.isValid() ? l.hour(12) : null;
    }
  }(kP)), kP;
}
var Ure;
function dx() {
  return Ure || (Ure = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = e(Ob());
    function r(s, o) {
      var a = t.default.isMoment(s) ? s : (0, n.default)(s, o);
      return a ? a.year() + "-" + String(a.month() + 1).padStart(2, "0") + "-" + String(a.date()).padStart(2, "0") : null;
    }
  }(AP)), AP;
}
var TP = {}, Gre;
function Mb() {
  return Gre || (Gre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOf([n.HORIZONTAL_ORIENTATION, n.VERTICAL_ORIENTATION, n.VERTICAL_SCROLLABLE]);
    i.default = r;
  }(TP)), TP;
}
var NP = {}, qre;
function $0() {
  return qre || (qre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOf(n.WEEKDAYS);
    i.default = r;
  }(NP)), NP;
}
var Kre;
function cbe() {
  return Kre || (Kre = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ua()), n = e(ha()), r = e(Pl()), s = e(fa()), o = e(hs()), a = e(it), l = e(mn()), c = e(yd()), d = Or(), u = Za(), h = e(gi), f = So(), g = e(ga()), p = e(tdt()), m = e(abe()), _ = e(lbe()), b = e(ndt()), w = e(J0()), y = e(dx()), S = e(ck()), x = e(Mb()), D = e($0()), E = mi();
    function L(O, K) {
      var W = Object.keys(O);
      if (Object.getOwnPropertySymbols) {
        var F = Object.getOwnPropertySymbols(O);
        K && (F = F.filter(function(q) {
          return Object.getOwnPropertyDescriptor(O, q).enumerable;
        })), W.push.apply(W, F);
      }
      return W;
    }
    function k(O) {
      for (var K = 1; K < arguments.length; K++) {
        var W = arguments[K] != null ? arguments[K] : {};
        K % 2 ? L(Object(W), !0).forEach(function(F) {
          (0, o.default)(O, F, W[F]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(O, Object.getOwnPropertyDescriptors(W)) : L(Object(W)).forEach(function(F) {
          Object.defineProperty(O, F, Object.getOwnPropertyDescriptor(W, F));
        });
      }
      return O;
    }
    var N = process.env.NODE_ENV !== "production" ? (0, d.forbidExtraProps)(k({}, u.withStylesPropTypes, {
      month: c.default.momentObj,
      horizontalMonthPadding: d.nonNegativeInteger,
      isVisible: l.default.bool,
      enableOutsideDays: l.default.bool,
      modifiers: l.default.objectOf(S.default),
      orientation: x.default,
      daySize: d.nonNegativeInteger,
      onDayClick: l.default.func,
      onDayMouseEnter: l.default.func,
      onDayMouseLeave: l.default.func,
      onMonthSelect: l.default.func,
      onYearSelect: l.default.func,
      renderMonthText: (0, d.mutuallyExclusiveProps)(l.default.func, "renderMonthText", "renderMonthElement"),
      renderCalendarDay: l.default.func,
      renderDayContents: l.default.func,
      renderMonthElement: (0, d.mutuallyExclusiveProps)(l.default.func, "renderMonthText", "renderMonthElement"),
      firstDayOfWeek: D.default,
      setMonthTitleHeight: l.default.func,
      verticalBorderSpacing: d.nonNegativeInteger,
      focusedDate: c.default.momentObj,
      // indicates focusable day
      isFocused: l.default.bool,
      // indicates whether or not to move focus to focusable day
      // i18n
      monthFormat: l.default.string,
      phrases: l.default.shape((0, g.default)(f.CalendarDayPhrases)),
      dayAriaLabelFormat: l.default.string
    })) : {}, I = {
      month: (0, h.default)(),
      horizontalMonthPadding: 13,
      isVisible: !0,
      enableOutsideDays: !1,
      modifiers: {},
      orientation: E.HORIZONTAL_ORIENTATION,
      daySize: E.DAY_SIZE,
      onDayClick: function() {
      },
      onDayMouseEnter: function() {
      },
      onDayMouseLeave: function() {
      },
      onMonthSelect: function() {
      },
      onYearSelect: function() {
      },
      renderMonthText: null,
      renderCalendarDay: function(K) {
        return a.default.createElement(m.default, K);
      },
      renderDayContents: null,
      renderMonthElement: null,
      firstDayOfWeek: null,
      setMonthTitleHeight: null,
      focusedDate: null,
      isFocused: !1,
      // i18n
      monthFormat: "MMMM YYYY",
      // english locale
      phrases: f.CalendarDayPhrases,
      dayAriaLabelFormat: void 0,
      verticalBorderSpacing: void 0
    }, A = /* @__PURE__ */ function(O) {
      (0, s.default)(W, O);
      var K = W.prototype;
      K[!a.default.PureComponent && "shouldComponentUpdate"] = function(F, q) {
        return !(0, t.default)(this.props, F) || !(0, t.default)(this.state, q);
      };
      function W(F) {
        var q;
        return q = O.call(this, F) || this, q.state = {
          weeks: (0, b.default)(F.month, F.enableOutsideDays, F.firstDayOfWeek == null ? h.default.localeData().firstDayOfWeek() : F.firstDayOfWeek)
        }, q.setCaptionRef = q.setCaptionRef.bind((0, r.default)(q)), q.setMonthTitleHeight = q.setMonthTitleHeight.bind((0, r.default)(q)), q;
      }
      return K.componentDidMount = function() {
        this.setMonthTitleHeightTimeout = setTimeout(this.setMonthTitleHeight, 0);
      }, K.componentWillReceiveProps = function(q) {
        var R = q.month, T = q.enableOutsideDays, z = q.firstDayOfWeek, X = this.props, ae = X.month, ue = X.enableOutsideDays, se = X.firstDayOfWeek;
        (!R.isSame(ae) || T !== ue || z !== se) && this.setState({
          weeks: (0, b.default)(R, T, z ?? h.default.localeData().firstDayOfWeek())
        });
      }, K.componentWillUnmount = function() {
        this.setMonthTitleHeightTimeout && clearTimeout(this.setMonthTitleHeightTimeout);
      }, K.setMonthTitleHeight = function() {
        var q = this.props.setMonthTitleHeight;
        if (q) {
          var R = (0, _.default)(this.captionRef, "height", !0, !0);
          q(R);
        }
      }, K.setCaptionRef = function(q) {
        this.captionRef = q;
      }, K.render = function() {
        var q = this.props, R = q.dayAriaLabelFormat, T = q.daySize, z = q.focusedDate, X = q.horizontalMonthPadding, ae = q.isFocused, ue = q.isVisible, se = q.modifiers, le = q.month, oe = q.monthFormat, re = q.onDayClick, B = q.onDayMouseEnter, ee = q.onDayMouseLeave, j = q.onMonthSelect, he = q.onYearSelect, Se = q.orientation, ge = q.phrases, te = q.renderCalendarDay, be = q.renderDayContents, Ae = q.renderMonthElement, He = q.renderMonthText, de = q.styles, ce = q.verticalBorderSpacing, ie = this.state.weeks, H = He ? He(le) : le.format(oe), Y = Se === E.VERTICAL_SCROLLABLE;
        return a.default.createElement("div", (0, n.default)({}, (0, u.css)(de.CalendarMonth, {
          padding: "0 ".concat(X, "px")
        }), {
          "data-visible": ue
        }), a.default.createElement("div", (0, n.default)({
          ref: this.setCaptionRef
        }, (0, u.css)(de.CalendarMonth_caption, Y && de.CalendarMonth_caption__verticalScrollable)), Ae ? Ae({
          month: le,
          onMonthSelect: j,
          onYearSelect: he,
          isVisible: ue
        }) : a.default.createElement("strong", null, H)), a.default.createElement("table", (0, n.default)({}, (0, u.css)(!ce && de.CalendarMonth_table, ce && de.CalendarMonth_verticalSpacing, ce && {
          borderSpacing: "0px ".concat(ce, "px")
        }), {
          role: "presentation"
        }), a.default.createElement("tbody", null, ie.map(function(Z, Q) {
          return a.default.createElement(p.default, {
            key: Q
          }, Z.map(function(me, Le) {
            return te({
              key: Le,
              day: me,
              daySize: T,
              isOutsideDay: !me || me.month() !== le.month(),
              tabIndex: ue && (0, w.default)(me, z) ? 0 : -1,
              isFocused: ae,
              onDayMouseEnter: B,
              onDayMouseLeave: ee,
              onDayClick: re,
              renderDayContents: be,
              phrases: ge,
              modifiers: se[(0, y.default)(me)],
              ariaLabelFormat: R
            });
          }));
        }))));
      }, W;
    }(a.default.PureComponent || a.default.Component);
    A.propTypes = process.env.NODE_ENV !== "production" ? N : {}, A.defaultProps = I;
    var P = (0, u.withStyles)(function(O) {
      var K = O.reactDates, W = K.color, F = K.font, q = K.spacing;
      return {
        CalendarMonth: {
          background: W.background,
          textAlign: "center",
          verticalAlign: "top",
          userSelect: "none"
        },
        CalendarMonth_table: {
          borderCollapse: "collapse",
          borderSpacing: 0
        },
        CalendarMonth_verticalSpacing: {
          borderCollapse: "separate"
        },
        CalendarMonth_caption: {
          color: W.text,
          fontSize: F.captionSize,
          textAlign: "center",
          paddingTop: q.captionPaddingTop,
          paddingBottom: q.captionPaddingBottom,
          captionSide: "initial"
        },
        CalendarMonth_caption__verticalScrollable: {
          paddingTop: 12,
          paddingBottom: 7
        }
      };
    }, {
      pureComponent: typeof a.default.PureComponent < "u"
    })(A);
    i.default = P;
  }(xP)), xP;
}
var PP = {}, idt = !!(typeof window < "u" && window.document && window.document.createElement);
function rdt() {
  if (!idt || !window.addEventListener || !window.removeEventListener || !Object.defineProperty)
    return !1;
  var i = !1;
  try {
    var e = Object.defineProperty({}, "passive", {
      // eslint-disable-next-line getter-return
      get: /* @__PURE__ */ function() {
        function n() {
          i = !0;
        }
        return n;
      }()
    }), t = function() {
    };
    window.addEventListener("testPassiveEventSupport", t, e), window.removeEventListener("testPassiveEventSupport", t, e);
  } catch {
  }
  return i;
}
var OP = void 0;
function sdt() {
  return OP === void 0 && (OP = rdt()), OP;
}
function odt(i) {
  if (i)
    return sdt() ? i : !!i.capture;
}
function adt(i) {
  if (!i)
    return 0;
  if (i === !0)
    return 100;
  var e = i.capture << 0, t = i.passive << 1, n = i.once << 2;
  return e + t + n;
}
function Yre(i) {
  i.handlers === i.nextHandlers && (i.nextHandlers = i.handlers.slice());
}
function dk(i) {
  this.target = i, this.events = {};
}
dk.prototype.getEventHandlers = /* @__PURE__ */ function() {
  function i(e, t) {
    var n = String(e) + " " + String(adt(t));
    return this.events[n] || (this.events[n] = {
      handlers: [],
      handleEvent: void 0
    }, this.events[n].nextHandlers = this.events[n].handlers), this.events[n];
  }
  return i;
}();
dk.prototype.handleEvent = /* @__PURE__ */ function() {
  function i(e, t, n) {
    var r = this.getEventHandlers(e, t);
    r.handlers = r.nextHandlers, r.handlers.forEach(function(s) {
      s && s(n);
    });
  }
  return i;
}();
dk.prototype.add = /* @__PURE__ */ function() {
  function i(e, t, n) {
    var r = this, s = this.getEventHandlers(e, n);
    Yre(s), s.nextHandlers.length === 0 && (s.handleEvent = this.handleEvent.bind(this, e, n), this.target.addEventListener(e, s.handleEvent, n)), s.nextHandlers.push(t);
    var o = !0, a = /* @__PURE__ */ function() {
      function l() {
        if (o) {
          o = !1, Yre(s);
          var c = s.nextHandlers.indexOf(t);
          s.nextHandlers.splice(c, 1), s.nextHandlers.length === 0 && (r.target && r.target.removeEventListener(e, s.handleEvent, n), s.handleEvent = void 0);
        }
      }
      return l;
    }();
    return a;
  }
  return i;
}();
var MP = "__consolidated_events_handlers__";
function ldt(i, e, t, n) {
  i[MP] || (i[MP] = new dk(i));
  var r = odt(n);
  return i[MP].add(e, t, r);
}
const cdt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addEventListener: ldt
}, Symbol.toStringTag, { value: "Module" })), uk = /* @__PURE__ */ L0(cdt);
var RP = {}, Xre;
function Cp() {
  return Xre || (Xre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = t;
    var e = "/* @noflip */";
    function t(n) {
      if (typeof n == "number") return "".concat(n, "px ").concat(e);
      if (typeof n == "string") return "".concat(n, " ").concat(e);
      throw new TypeError("noflip expects a string or a number");
    }
  }(RP)), RP;
}
var FP = {}, Zre;
function ddt() {
  return Zre || (Zre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = e;
    function e() {
      return typeof window < "u" && "TransitionEvent" in window;
    }
  }(FP)), FP;
}
var BP = {}, Qre;
function udt() {
  return Qre || (Qre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = e;
    function e(t) {
      return {
        transform: t,
        msTransform: t,
        MozTransform: t,
        WebkitTransform: t
      };
    }
  }(BP)), BP;
}
var VP = {}, Jre;
function dbe() {
  return Jre || (Jre = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = e;
    function e(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return 7 * t + 2 * n + 1;
    }
  }(VP)), VP;
}
var HP = {}, $re;
function hk() {
  return $re || ($re = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = e(Ob());
    function r(s, o) {
      var a = t.default.isMoment(s) ? s : (0, n.default)(s, o);
      return a ? a.year() + "-" + String(a.month() + 1).padStart(2, "0") : null;
    }
  }(HP)), HP;
}
var WP = {}, jP = {}, ese;
function mq() {
  return ese || (ese = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = n;
    var t = e(gi);
    function n(r, s) {
      return !t.default.isMoment(r) || !t.default.isMoment(s) ? !1 : r.month() === s.month() && r.year() === s.year();
    }
  }(jP)), jP;
}
var tse;
function hdt() {
  return tse || (tse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = e(mq());
    function r(s, o) {
      return !t.default.isMoment(s) || !t.default.isMoment(o) ? !1 : (0, n.default)(s.clone().subtract(1, "month"), o);
    }
  }(WP)), WP;
}
var zP = {}, nse;
function fdt() {
  return nse || (nse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = e(mq());
    function r(s, o) {
      return !t.default.isMoment(s) || !t.default.isMoment(o) ? !1 : (0, n.default)(s.clone().add(1, "month"), o);
    }
  }(zP)), zP;
}
var ise;
function ube() {
  return ise || (ise = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ua()), n = e(ha()), r = e(Pl()), s = e(fa()), o = e(hs()), a = e(it), l = e(mn()), c = e(yd()), d = Or(), u = Za(), h = e(gi), f = uk, g = So(), p = e(ga()), m = e(Cp()), _ = e(cbe()), b = e(ddt()), w = e(udt()), y = e(dbe()), S = e(hk()), x = e(hdt()), D = e(fdt()), E = e(ck()), L = e(Mb()), k = e($0()), N = mi();
    function I(q, R) {
      var T = Object.keys(q);
      if (Object.getOwnPropertySymbols) {
        var z = Object.getOwnPropertySymbols(q);
        R && (z = z.filter(function(X) {
          return Object.getOwnPropertyDescriptor(q, X).enumerable;
        })), T.push.apply(T, z);
      }
      return T;
    }
    function A(q) {
      for (var R = 1; R < arguments.length; R++) {
        var T = arguments[R] != null ? arguments[R] : {};
        R % 2 ? I(Object(T), !0).forEach(function(z) {
          (0, o.default)(q, z, T[z]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(T)) : I(Object(T)).forEach(function(z) {
          Object.defineProperty(q, z, Object.getOwnPropertyDescriptor(T, z));
        });
      }
      return q;
    }
    var P = process.env.NODE_ENV !== "production" ? (0, d.forbidExtraProps)(A({}, u.withStylesPropTypes, {
      enableOutsideDays: l.default.bool,
      firstVisibleMonthIndex: l.default.number,
      horizontalMonthPadding: d.nonNegativeInteger,
      initialMonth: c.default.momentObj,
      isAnimating: l.default.bool,
      numberOfMonths: l.default.number,
      modifiers: l.default.objectOf(l.default.objectOf(E.default)),
      orientation: L.default,
      onDayClick: l.default.func,
      onDayMouseEnter: l.default.func,
      onDayMouseLeave: l.default.func,
      onMonthTransitionEnd: l.default.func,
      onMonthChange: l.default.func,
      onYearChange: l.default.func,
      renderMonthText: (0, d.mutuallyExclusiveProps)(l.default.func, "renderMonthText", "renderMonthElement"),
      renderCalendarDay: l.default.func,
      renderDayContents: l.default.func,
      translationValue: l.default.number,
      renderMonthElement: (0, d.mutuallyExclusiveProps)(l.default.func, "renderMonthText", "renderMonthElement"),
      daySize: d.nonNegativeInteger,
      focusedDate: c.default.momentObj,
      // indicates focusable day
      isFocused: l.default.bool,
      // indicates whether or not to move focus to focusable day
      firstDayOfWeek: k.default,
      setMonthTitleHeight: l.default.func,
      isRTL: l.default.bool,
      transitionDuration: d.nonNegativeInteger,
      verticalBorderSpacing: d.nonNegativeInteger,
      // i18n
      monthFormat: l.default.string,
      phrases: l.default.shape((0, p.default)(g.CalendarDayPhrases)),
      dayAriaLabelFormat: l.default.string
    })) : {}, O = {
      enableOutsideDays: !1,
      firstVisibleMonthIndex: 0,
      horizontalMonthPadding: 13,
      initialMonth: (0, h.default)(),
      isAnimating: !1,
      numberOfMonths: 1,
      modifiers: {},
      orientation: N.HORIZONTAL_ORIENTATION,
      onDayClick: function() {
      },
      onDayMouseEnter: function() {
      },
      onDayMouseLeave: function() {
      },
      onMonthChange: function() {
      },
      onYearChange: function() {
      },
      onMonthTransitionEnd: function() {
      },
      renderMonthText: null,
      renderCalendarDay: void 0,
      renderDayContents: null,
      translationValue: null,
      renderMonthElement: null,
      daySize: N.DAY_SIZE,
      focusedDate: null,
      isFocused: !1,
      firstDayOfWeek: null,
      setMonthTitleHeight: null,
      isRTL: !1,
      transitionDuration: 200,
      verticalBorderSpacing: void 0,
      // i18n
      monthFormat: "MMMM YYYY",
      // english locale
      phrases: g.CalendarDayPhrases,
      dayAriaLabelFormat: void 0
    };
    function K(q, R, T) {
      var z = q.clone();
      T || (z = z.subtract(1, "month"));
      for (var X = [], ae = 0; ae < (T ? R : R + 2); ae += 1)
        X.push(z), z = z.clone().add(1, "month");
      return X;
    }
    var W = /* @__PURE__ */ function(q) {
      (0, s.default)(T, q);
      var R = T.prototype;
      R[!a.default.PureComponent && "shouldComponentUpdate"] = function(z, X) {
        return !(0, t.default)(this.props, z) || !(0, t.default)(this.state, X);
      };
      function T(z) {
        var X;
        X = q.call(this, z) || this;
        var ae = z.orientation === N.VERTICAL_SCROLLABLE;
        return X.state = {
          months: K(z.initialMonth, z.numberOfMonths, ae)
        }, X.isTransitionEndSupported = (0, b.default)(), X.onTransitionEnd = X.onTransitionEnd.bind((0, r.default)(X)), X.setContainerRef = X.setContainerRef.bind((0, r.default)(X)), X.locale = h.default.locale(), X.onMonthSelect = X.onMonthSelect.bind((0, r.default)(X)), X.onYearSelect = X.onYearSelect.bind((0, r.default)(X)), X;
      }
      return R.componentDidMount = function() {
        this.removeEventListener = (0, f.addEventListener)(this.container, "transitionend", this.onTransitionEnd);
      }, R.componentWillReceiveProps = function(X) {
        var ae = this, ue = X.initialMonth, se = X.numberOfMonths, le = X.orientation, oe = this.state.months, re = this.props, B = re.initialMonth, ee = re.numberOfMonths, j = !B.isSame(ue, "month"), he = ee !== se, Se = oe;
        if (j && !he)
          if ((0, D.default)(B, ue))
            Se = oe.slice(1), Se.push(oe[oe.length - 1].clone().add(1, "month"));
          else if ((0, x.default)(B, ue))
            Se = oe.slice(0, oe.length - 1), Se.unshift(oe[0].clone().subtract(1, "month"));
          else {
            var ge = le === N.VERTICAL_SCROLLABLE;
            Se = K(ue, se, ge);
          }
        if (he) {
          var te = le === N.VERTICAL_SCROLLABLE;
          Se = K(ue, se, te);
        }
        var be = h.default.locale();
        this.locale !== be && (this.locale = be, Se = Se.map(function(Ae) {
          return Ae.locale(ae.locale);
        })), this.setState({
          months: Se
        });
      }, R.componentDidUpdate = function() {
        var X = this.props, ae = X.isAnimating, ue = X.transitionDuration, se = X.onMonthTransitionEnd;
        (!this.isTransitionEndSupported || !ue) && ae && se();
      }, R.componentWillUnmount = function() {
        this.removeEventListener && this.removeEventListener();
      }, R.onTransitionEnd = function() {
        var X = this.props.onMonthTransitionEnd;
        X();
      }, R.onMonthSelect = function(X, ae) {
        var ue = X.clone(), se = this.props, le = se.onMonthChange, oe = se.orientation, re = this.state.months, B = oe === N.VERTICAL_SCROLLABLE, ee = re.indexOf(X);
        B || (ee -= 1), ue.set("month", ae).subtract(ee, "months"), le(ue);
      }, R.onYearSelect = function(X, ae) {
        var ue = X.clone(), se = this.props, le = se.onYearChange, oe = se.orientation, re = this.state.months, B = oe === N.VERTICAL_SCROLLABLE, ee = re.indexOf(X);
        B || (ee -= 1), ue.set("year", ae).subtract(ee, "months"), le(ue);
      }, R.setContainerRef = function(X) {
        this.container = X;
      }, R.render = function() {
        var X = this, ae = this.props, ue = ae.enableOutsideDays, se = ae.firstVisibleMonthIndex, le = ae.horizontalMonthPadding, oe = ae.isAnimating, re = ae.modifiers, B = ae.numberOfMonths, ee = ae.monthFormat, j = ae.orientation, he = ae.translationValue, Se = ae.daySize, ge = ae.onDayMouseEnter, te = ae.onDayMouseLeave, be = ae.onDayClick, Ae = ae.renderMonthText, He = ae.renderCalendarDay, de = ae.renderDayContents, ce = ae.renderMonthElement, ie = ae.onMonthTransitionEnd, H = ae.firstDayOfWeek, Y = ae.focusedDate, Z = ae.isFocused, Q = ae.isRTL, me = ae.styles, Le = ae.phrases, xe = ae.dayAriaLabelFormat, Ue = ae.transitionDuration, je = ae.verticalBorderSpacing, Ze = ae.setMonthTitleHeight, _e = this.state.months, U = j === N.VERTICAL_ORIENTATION, fe = j === N.VERTICAL_SCROLLABLE, Ee = j === N.HORIZONTAL_ORIENTATION, Me = (0, y.default)(Se, le), Pe = U || fe ? Me : (B + 2) * Me, et = U || fe ? "translateY" : "translateX", gt = "".concat(et, "(").concat(he, "px)");
        return a.default.createElement("div", (0, n.default)({}, (0, u.css)(me.CalendarMonthGrid, Ee && me.CalendarMonthGrid__horizontal, U && me.CalendarMonthGrid__vertical, fe && me.CalendarMonthGrid__vertical_scrollable, oe && me.CalendarMonthGrid__animating, oe && Ue && {
          transition: "transform ".concat(Ue, "ms ease-in-out")
        }, A({}, (0, w.default)(gt), {
          width: Pe
        })), {
          ref: this.setContainerRef,
          onTransitionEnd: ie
        }), _e.map(function(Vt, Zt) {
          var St = Zt >= se && Zt < se + B, Ht = Zt === 0 && !St, fn = Zt === 0 && oe && St, xn = (0, S.default)(Vt);
          return a.default.createElement("div", (0, n.default)({
            key: xn
          }, (0, u.css)(Ee && me.CalendarMonthGrid_month__horizontal, Ht && me.CalendarMonthGrid_month__hideForAnimation, fn && !U && !Q && {
            position: "absolute",
            left: -Me
          }, fn && !U && Q && {
            position: "absolute",
            right: 0
          }, fn && U && {
            position: "absolute",
            top: -he
          }, !St && !oe && me.CalendarMonthGrid_month__hidden)), a.default.createElement(_.default, {
            month: Vt,
            isVisible: St,
            enableOutsideDays: ue,
            modifiers: re[xn],
            monthFormat: ee,
            orientation: j,
            onDayMouseEnter: ge,
            onDayMouseLeave: te,
            onDayClick: be,
            onMonthSelect: X.onMonthSelect,
            onYearSelect: X.onYearSelect,
            renderMonthText: Ae,
            renderCalendarDay: He,
            renderDayContents: de,
            renderMonthElement: ce,
            firstDayOfWeek: H,
            daySize: Se,
            focusedDate: St ? Y : null,
            isFocused: Z,
            phrases: Le,
            setMonthTitleHeight: Ze,
            dayAriaLabelFormat: xe,
            verticalBorderSpacing: je,
            horizontalMonthPadding: le
          }));
        }));
      }, T;
    }(a.default.PureComponent || a.default.Component);
    W.propTypes = process.env.NODE_ENV !== "production" ? P : {}, W.defaultProps = O;
    var F = (0, u.withStyles)(function(q) {
      var R = q.reactDates, T = R.color, z = R.spacing, X = R.zIndex;
      return {
        CalendarMonthGrid: {
          background: T.background,
          textAlign: (0, m.default)("left"),
          zIndex: X
        },
        CalendarMonthGrid__animating: {
          zIndex: X + 1
        },
        CalendarMonthGrid__horizontal: {
          position: "absolute",
          left: (0, m.default)(z.dayPickerHorizontalPadding)
        },
        CalendarMonthGrid__vertical: {
          margin: "0 auto"
        },
        CalendarMonthGrid__vertical_scrollable: {
          margin: "0 auto"
        },
        CalendarMonthGrid_month__horizontal: {
          display: "inline-block",
          verticalAlign: "top",
          minHeight: "100%"
        },
        CalendarMonthGrid_month__hideForAnimation: {
          position: "absolute",
          zIndex: X - 1,
          opacity: 0,
          pointerEvents: "none"
        },
        CalendarMonthGrid_month__hidden: {
          visibility: "hidden"
        }
      };
    }, {
      pureComponent: typeof a.default.PureComponent < "u"
    })(W);
    i.default = F;
  }(PP)), PP;
}
var UP = {}, gdt = mn();
const qn = /* @__PURE__ */ eb(gdt);
var pdt = !!(typeof window < "u" && window.document && window.document.createElement), mdt = /* @__PURE__ */ function() {
  function i(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  return function(e, t, n) {
    return t && i(e.prototype, t), n && i(e, n), e;
  };
}();
function vdt(i, e) {
  if (!(i instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _dt(i, e) {
  if (!i)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : i;
}
function bdt(i, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  i.prototype = Object.create(e && e.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(i, e) : i.__proto__ = e);
}
var hbe = function(i) {
  bdt(e, i);
  function e() {
    return vdt(this, e), _dt(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }
  return mdt(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function() {
      return pdt ? (!this.props.node && !this.defaultNode && (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode)), Fm.createPortal(this.props.children, this.props.node || this.defaultNode)) : null;
    }
  }]), e;
}(it.Component);
hbe.propTypes = {
  children: qn.node.isRequired,
  node: qn.any
};
var Cdt = /* @__PURE__ */ function() {
  function i(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  return function(e, t, n) {
    return t && i(e.prototype, t), n && i(e, n), e;
  };
}();
function ydt(i, e) {
  if (!(i instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function wdt(i, e) {
  if (!i)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : i;
}
function Sdt(i, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  i.prototype = Object.create(e && e.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(i, e) : i.__proto__ = e);
}
var fbe = function(i) {
  Sdt(e, i);
  function e() {
    return ydt(this, e), wdt(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }
  return Cdt(e, [{
    key: "componentDidMount",
    value: function() {
      this.renderPortal();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      this.renderPortal();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      Fm.unmountComponentAtNode(this.defaultNode || this.props.node), this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null, this.portal = null;
    }
  }, {
    key: "renderPortal",
    value: function(n) {
      !this.props.node && !this.defaultNode && (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode));
      var r = this.props.children;
      typeof this.props.children.type == "function" && (r = it.cloneElement(this.props.children)), this.portal = Fm.unstable_renderSubtreeIntoContainer(this, r, this.props.node || this.defaultNode);
    }
  }, {
    key: "render",
    value: function() {
      return null;
    }
  }]), e;
}(it.Component);
fbe.propTypes = {
  children: qn.node.isRequired,
  node: qn.any
};
var vW = void 0;
Fm.createPortal ? vW = hbe : vW = fbe;
const gbe = vW;
var xdt = /* @__PURE__ */ function() {
  function i(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  return function(e, t, n) {
    return t && i(e.prototype, t), n && i(e, n), e;
  };
}();
function Ddt(i, e) {
  if (!(i instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Edt(i, e) {
  if (!i)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : i;
}
function Ldt(i, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  i.prototype = Object.create(e && e.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(i, e) : i.__proto__ = e);
}
var Idt = {
  ESCAPE: 27
}, vq = function(i) {
  Ldt(e, i);
  function e(t) {
    Ddt(this, e);
    var n = Edt(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
    return n.portalNode = null, n.state = { active: !!t.defaultOpen }, n.openPortal = n.openPortal.bind(n), n.closePortal = n.closePortal.bind(n), n.wrapWithPortal = n.wrapWithPortal.bind(n), n.handleOutsideMouseClick = n.handleOutsideMouseClick.bind(n), n.handleKeydown = n.handleKeydown.bind(n), n;
  }
  return xdt(e, [{
    key: "componentDidMount",
    value: function() {
      this.props.closeOnEsc && document.addEventListener("keydown", this.handleKeydown), this.props.closeOnOutsideClick && document.addEventListener("click", this.handleOutsideMouseClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.props.closeOnEsc && document.removeEventListener("keydown", this.handleKeydown), this.props.closeOnOutsideClick && document.removeEventListener("click", this.handleOutsideMouseClick);
    }
  }, {
    key: "openPortal",
    value: function(n) {
      this.state.active || (n && n.nativeEvent && n.nativeEvent.stopImmediatePropagation(), this.setState({ active: !0 }, this.props.onOpen));
    }
  }, {
    key: "closePortal",
    value: function() {
      this.state.active && this.setState({ active: !1 }, this.props.onClose);
    }
  }, {
    key: "wrapWithPortal",
    value: function(n) {
      var r = this;
      return this.state.active ? it.createElement(
        gbe,
        {
          node: this.props.node,
          key: "react-portal",
          ref: function(o) {
            return r.portalNode = o;
          }
        },
        n
      ) : null;
    }
  }, {
    key: "handleOutsideMouseClick",
    value: function(n) {
      if (this.state.active) {
        var r = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
        !r || r.contains(n.target) || n.button && n.button !== 0 || this.closePortal();
      }
    }
  }, {
    key: "handleKeydown",
    value: function(n) {
      n.keyCode === Idt.ESCAPE && this.state.active && this.closePortal();
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]), e;
}(it.Component);
vq.propTypes = {
  children: qn.func.isRequired,
  defaultOpen: qn.bool,
  node: qn.any,
  closeOnEsc: qn.bool,
  closeOnOutsideClick: qn.bool,
  onOpen: qn.func,
  onClose: qn.func
};
vq.defaultProps = {
  onOpen: function() {
  },
  onClose: function() {
  }
};
const Adt = vq, kdt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Portal: gbe,
  PortalWithState: Adt
}, Symbol.toStringTag, { value: "Module" })), pbe = /* @__PURE__ */ L0(kdt);
var a3 = { exports: {} }, rse;
function Rb() {
  return rse || (rse = 1, function(i, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = t;
    function t() {
      return !!(typeof window < "u" && ("ontouchstart" in window || window.DocumentTouch && typeof document < "u" && document instanceof window.DocumentTouch)) || !!(typeof navigator < "u" && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
    }
    i.exports = e.default;
  }(a3, a3.exports)), a3.exports;
}
var GP = {}, qP, sse;
function mbe() {
  return sse || (sse = 1, qP = function(e) {
    if (arguments.length < 1)
      throw new TypeError("1 argument is required");
    if (typeof e != "object")
      throw new TypeError("Argument 1 (”other“) to Node.contains must be an instance of Node");
    var t = e;
    do {
      if (this === t)
        return !0;
      t && (t = t.parentNode);
    } while (t);
    return !1;
  }), qP;
}
var KP, ose;
function vbe() {
  if (ose) return KP;
  ose = 1;
  var i = mbe();
  return KP = function() {
    if (typeof document < "u") {
      if (document.contains)
        return document.contains;
      if (document.body && document.body.contains)
        try {
          if (typeof document.body.contains.call(document, "") == "boolean")
            return document.body.contains;
        } catch {
        }
    }
    return i;
  }, KP;
}
var YP, ase;
function Tdt() {
  if (ase) return YP;
  ase = 1;
  var i = Xr(), e = vbe();
  return YP = function() {
    var n = e();
    return typeof document < "u" && (i(
      document,
      { contains: n },
      { contains: function() {
        return document.contains !== n;
      } }
    ), typeof Element < "u" && i(
      Element.prototype,
      { contains: n },
      { contains: function() {
        return Element.prototype.contains !== n;
      } }
    )), n;
  }, YP;
}
var XP, lse;
function Ndt() {
  if (lse) return XP;
  lse = 1;
  var i = Xr(), e = mbe(), t = vbe(), n = t(), r = Tdt(), s = function(a, l) {
    return n.apply(a, [l]);
  };
  return i(s, {
    getPolyfill: t,
    implementation: e,
    shim: r
  }), XP = s, XP;
}
var cse;
function Pdt() {
  return cse || (cse = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    });
    var e = /* @__PURE__ */ function() {
      function y(S, x) {
        for (var D = 0; D < x.length; D++) {
          var E = x[D];
          E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(S, E.key, E);
        }
      }
      return function(S, x, D) {
        return x && y(S.prototype, x), D && y(S, D), S;
      };
    }(), t = it, n = h(t), r = mn(), s = h(r), o = Or(), a = uk, l = lk(), c = h(l), d = Ndt(), u = h(d);
    function h(y) {
      return y && y.__esModule ? y : { default: y };
    }
    function f(y, S) {
      if (!(y instanceof S))
        throw new TypeError("Cannot call a class as a function");
    }
    function g(y, S) {
      if (!y)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return S && (typeof S == "object" || typeof S == "function") ? S : y;
    }
    function p(y, S) {
      if (typeof S != "function" && S !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof S);
      y.prototype = Object.create(S && S.prototype, { constructor: { value: y, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(y, S) : y.__proto__ = S);
    }
    var m = {
      BLOCK: "block",
      FLEX: "flex",
      INLINE: "inline",
      INLINE_BLOCK: "inline-block",
      CONTENTS: "contents"
    }, _ = (0, o.forbidExtraProps)({
      children: s.default.node.isRequired,
      onOutsideClick: s.default.func.isRequired,
      disabled: s.default.bool,
      useCapture: s.default.bool,
      display: s.default.oneOf((0, c.default)(m))
    }), b = {
      disabled: !1,
      // `useCapture` is set to true by default so that a `stopPropagation` in the
      // children will not prevent all outside click handlers from firing - maja
      useCapture: !0,
      display: m.BLOCK
    }, w = function(y) {
      p(S, y);
      function S() {
        var x;
        f(this, S);
        for (var D = arguments.length, E = Array(D), L = 0; L < D; L++)
          E[L] = arguments[L];
        var k = g(this, (x = S.__proto__ || Object.getPrototypeOf(S)).call.apply(x, [this].concat(E)));
        return k.onMouseDown = k.onMouseDown.bind(k), k.onMouseUp = k.onMouseUp.bind(k), k.setChildNodeRef = k.setChildNodeRef.bind(k), k;
      }
      return e(S, [{
        key: "componentDidMount",
        value: /* @__PURE__ */ function() {
          function x() {
            var D = this.props, E = D.disabled, L = D.useCapture;
            E || this.addMouseDownEventListener(L);
          }
          return x;
        }()
      }, {
        key: "componentDidUpdate",
        value: /* @__PURE__ */ function() {
          function x(D) {
            var E = D.disabled, L = this.props, k = L.disabled, N = L.useCapture;
            E !== k && (k ? this.removeEventListeners() : this.addMouseDownEventListener(N));
          }
          return x;
        }()
      }, {
        key: "componentWillUnmount",
        value: /* @__PURE__ */ function() {
          function x() {
            this.removeEventListeners();
          }
          return x;
        }()
        // Use mousedown/mouseup to enforce that clicks remain outside the root's
        // descendant tree, even when dragged. This should also get triggered on
        // touch devices.
      }, {
        key: "onMouseDown",
        value: /* @__PURE__ */ function() {
          function x(D) {
            var E = this.props.useCapture, L = this.childNode && (0, u.default)(this.childNode, D.target);
            L || (this.removeMouseUp && (this.removeMouseUp(), this.removeMouseUp = null), this.removeMouseUp = (0, a.addEventListener)(document, "mouseup", this.onMouseUp, { capture: E }));
          }
          return x;
        }()
        // Use mousedown/mouseup to enforce that clicks remain outside the root's
        // descendant tree, even when dragged. This should also get triggered on
        // touch devices.
      }, {
        key: "onMouseUp",
        value: /* @__PURE__ */ function() {
          function x(D) {
            var E = this.props.onOutsideClick, L = this.childNode && (0, u.default)(this.childNode, D.target);
            this.removeMouseUp && (this.removeMouseUp(), this.removeMouseUp = null), L || E(D);
          }
          return x;
        }()
      }, {
        key: "setChildNodeRef",
        value: /* @__PURE__ */ function() {
          function x(D) {
            this.childNode = D;
          }
          return x;
        }()
      }, {
        key: "addMouseDownEventListener",
        value: /* @__PURE__ */ function() {
          function x(D) {
            this.removeMouseDown = (0, a.addEventListener)(document, "mousedown", this.onMouseDown, { capture: D });
          }
          return x;
        }()
      }, {
        key: "removeEventListeners",
        value: /* @__PURE__ */ function() {
          function x() {
            this.removeMouseDown && this.removeMouseDown(), this.removeMouseUp && this.removeMouseUp();
          }
          return x;
        }()
      }, {
        key: "render",
        value: /* @__PURE__ */ function() {
          function x() {
            var D = this.props, E = D.children, L = D.display;
            return n.default.createElement(
              "div",
              {
                ref: this.setChildNodeRef,
                style: L !== m.BLOCK && (0, c.default)(m).includes(L) ? { display: L } : void 0
              },
              E
            );
          }
          return x;
        }()
      }]), S;
    }(n.default.Component);
    i.default = w, w.propTypes = _, w.defaultProps = b;
  }(GP)), GP;
}
var ZP, dse;
function _q() {
  return dse || (dse = 1, ZP = Pdt()), ZP;
}
var QP = {}, JP = {}, use;
function _be() {
  return use || (use = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOf([n.START_DATE, n.END_DATE]);
    i.default = r;
  }(JP)), JP;
}
var $P = {}, hse;
function Fb() {
  return hse || (hse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOf([n.ICON_BEFORE_POSITION, n.ICON_AFTER_POSITION]);
    i.default = r;
  }($P)), $P;
}
var eO = {}, fse;
function bbe() {
  return fse || (fse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOf([n.HORIZONTAL_ORIENTATION, n.VERTICAL_ORIENTATION]);
    i.default = r;
  }(eO)), eO;
}
var tO = {}, gse;
function ux() {
  return gse || (gse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOfType([t.default.bool, t.default.oneOf([n.START_DATE, n.END_DATE])]);
    i.default = r;
  }(tO)), tO;
}
var nO = {}, pse;
function Cbe() {
  return pse || (pse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOf([n.ANCHOR_LEFT, n.ANCHOR_RIGHT]);
    i.default = r;
  }(nO)), nO;
}
var iO = {}, mse;
function e1() {
  return mse || (mse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOf([n.OPEN_DOWN, n.OPEN_UP]);
    i.default = r;
  }(iO)), iO;
}
var rO = {}, vse;
function hx() {
  return vse || (vse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOf([n.INFO_POSITION_TOP, n.INFO_POSITION_BOTTOM, n.INFO_POSITION_BEFORE, n.INFO_POSITION_AFTER]);
    i.default = r;
  }(rO)), rO;
}
var sO = {}, _se;
function Bb() {
  return _se || (_se = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = mi(), r = t.default.oneOf([n.NAV_POSITION_BOTTOM, n.NAV_POSITION_TOP]);
    i.default = r;
  }(sO)), sO;
}
var bse;
function ybe() {
  return bse || (bse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = e(yd()), r = Or(), s = So(), o = e(ga()), a = e(_be()), l = e(Fb()), c = e(bbe()), d = e(ux()), u = e(Cbe()), h = e(e1()), f = e($0()), g = e(hx()), p = e(Bb()), m = {
      // required props for a functional interactive DateRangePicker
      startDate: n.default.momentObj,
      endDate: n.default.momentObj,
      onDatesChange: t.default.func.isRequired,
      focusedInput: a.default,
      onFocusChange: t.default.func.isRequired,
      onClose: t.default.func,
      // input related props
      startDateId: t.default.string.isRequired,
      startDatePlaceholderText: t.default.string,
      startDateOffset: t.default.func,
      endDateOffset: t.default.func,
      endDateId: t.default.string.isRequired,
      endDatePlaceholderText: t.default.string,
      startDateAriaLabel: t.default.string,
      endDateAriaLabel: t.default.string,
      disabled: d.default,
      required: t.default.bool,
      readOnly: t.default.bool,
      screenReaderInputMessage: t.default.string,
      showClearDates: t.default.bool,
      showDefaultInputIcon: t.default.bool,
      inputIconPosition: l.default,
      customInputIcon: t.default.node,
      customArrowIcon: t.default.node,
      customCloseIcon: t.default.node,
      noBorder: t.default.bool,
      block: t.default.bool,
      small: t.default.bool,
      regular: t.default.bool,
      keepFocusOnInput: t.default.bool,
      // calendar presentation and interaction related props
      renderMonthText: (0, r.mutuallyExclusiveProps)(t.default.func, "renderMonthText", "renderMonthElement"),
      renderMonthElement: (0, r.mutuallyExclusiveProps)(t.default.func, "renderMonthText", "renderMonthElement"),
      renderWeekHeaderElement: t.default.func,
      orientation: c.default,
      anchorDirection: u.default,
      openDirection: h.default,
      horizontalMargin: t.default.number,
      withPortal: t.default.bool,
      withFullScreenPortal: t.default.bool,
      appendToBody: t.default.bool,
      disableScroll: t.default.bool,
      daySize: r.nonNegativeInteger,
      isRTL: t.default.bool,
      firstDayOfWeek: f.default,
      initialVisibleMonth: t.default.func,
      numberOfMonths: t.default.number,
      keepOpenOnDateSelect: t.default.bool,
      reopenPickerOnClearDates: t.default.bool,
      renderCalendarInfo: t.default.func,
      calendarInfoPosition: g.default,
      hideKeyboardShortcutsPanel: t.default.bool,
      verticalHeight: r.nonNegativeInteger,
      transitionDuration: r.nonNegativeInteger,
      verticalSpacing: r.nonNegativeInteger,
      horizontalMonthPadding: r.nonNegativeInteger,
      // navigation related props
      dayPickerNavigationInlineStyles: t.default.object,
      navPosition: p.default,
      navPrev: t.default.node,
      navNext: t.default.node,
      renderNavPrevButton: t.default.func,
      renderNavNextButton: t.default.func,
      onPrevMonthClick: t.default.func,
      onNextMonthClick: t.default.func,
      // day presentation and interaction related props
      renderCalendarDay: t.default.func,
      renderDayContents: t.default.func,
      minimumNights: t.default.number,
      minDate: n.default.momentObj,
      maxDate: n.default.momentObj,
      enableOutsideDays: t.default.bool,
      isDayBlocked: t.default.func,
      isOutsideRange: t.default.func,
      isDayHighlighted: t.default.func,
      // internationalization props
      displayFormat: t.default.oneOfType([t.default.string, t.default.func]),
      monthFormat: t.default.string,
      weekDayFormat: t.default.string,
      phrases: t.default.shape((0, o.default)(s.DateRangePickerPhrases)),
      dayAriaLabelFormat: t.default.string
    };
    i.default = m;
  }(QP)), QP;
}
var oO = {}, Cse;
function wbe() {
  return Cse || (Cse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(hs()), n = mi();
    function r(s, o, a, l) {
      var c = typeof window < "u" ? window.innerWidth : 0, d = s === n.ANCHOR_LEFT ? c - a : a, u = l || 0;
      return (0, t.default)({}, s, Math.min(o + d - u, 0));
    }
  }(oO)), oO;
}
var aO = {}, yse;
function Sbe() {
  return yse || (yse = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = t;
    var e = mi();
    function t(n, r, s) {
      var o = s.getBoundingClientRect(), a = o.left, l = o.top;
      return n === e.OPEN_UP && (l = -(window.innerHeight - o.bottom)), r === e.ANCHOR_RIGHT && (a = -(window.innerWidth - o.right)), {
        transform: "translate3d(".concat(Math.round(a), "px, ").concat(Math.round(l), "px, 0)")
      };
    }
  }(aO)), aO;
}
var lO = {}, wse;
function bq() {
  return wse || (wse = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = t;
    function e(n, r, s) {
      var o = typeof r == "number", a = typeof s == "number", l = typeof n == "number";
      return o && a ? r + s : o && l ? r + n : o ? r : a && l ? s + n : a ? s : l ? 2 * n : 0;
    }
    function t(n, r) {
      var s = n.font.input, o = s.lineHeight, a = s.lineHeight_small, l = n.spacing, c = l.inputPadding, d = l.displayTextPaddingVertical, u = l.displayTextPaddingTop, h = l.displayTextPaddingBottom, f = l.displayTextPaddingVertical_small, g = l.displayTextPaddingTop_small, p = l.displayTextPaddingBottom_small, m = r ? a : o, _ = r ? e(f, g, p) : e(d, u, h);
      return parseInt(m, 10) + 2 * c + _;
    }
  }(lO)), lO;
}
var cO = {}, dO = {}, Sse;
function fx() {
  return Sse || (Sse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = n;
    var t = e(gi);
    function n(r, s) {
      if (!t.default.isMoment(r) || !t.default.isMoment(s)) return !1;
      var o = r.year(), a = r.month(), l = s.year(), c = s.month(), d = o === l, u = a === c;
      return d && u ? r.date() < s.date() : d ? a < c : o < l;
    }
  }(dO)), dO;
}
var xse;
function Vb() {
  return xse || (xse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = e(fx());
    function r(s, o) {
      return !t.default.isMoment(s) || !t.default.isMoment(o) ? !1 : !(0, n.default)(s, o);
    }
  }(cO)), cO;
}
var uO = {}, Dse;
function xbe() {
  return Dse || (Dse = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.getScrollParent = t, i.getScrollAncestorsOverflowY = n, i.default = r;
    var e = function() {
      return document.scrollingElement || document.documentElement;
    };
    function t(s) {
      var o = s.parentElement;
      if (o == null) return e();
      var a = window.getComputedStyle(o), l = a.overflowY, c = l !== "visible" && l !== "hidden";
      return c && o.scrollHeight > o.clientHeight ? o : t(o);
    }
    function n(s) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Map(), a = e(), l = t(s);
      return o.set(l, l.style.overflowY), l === a ? o : n(l, o);
    }
    function r(s) {
      var o = n(s), a = function(c) {
        return o.forEach(function(d, u) {
          u.style.setProperty("overflow-y", c ? "hidden" : d);
        });
      };
      return a(!0), function() {
        return a(!1);
      };
    }
  }(uO)), uO;
}
var hO = {}, fO = {}, gO = {}, pO, Ese;
function Cq() {
  if (Ese) return pO;
  Ese = 1;
  function i(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  return pO = i, pO;
}
var mO, Lse;
function Odt() {
  if (Lse) return mO;
  Lse = 1;
  var i = typeof Zs == "object" && Zs && Zs.Object === Object && Zs;
  return mO = i, mO;
}
var vO, Ise;
function Dbe() {
  if (Ise) return vO;
  Ise = 1;
  var i = Odt(), e = typeof self == "object" && self && self.Object === Object && self, t = i || e || Function("return this")();
  return vO = t, vO;
}
var _O, Ase;
function Mdt() {
  if (Ase) return _O;
  Ase = 1;
  var i = Dbe(), e = function() {
    return i.Date.now();
  };
  return _O = e, _O;
}
var bO, kse;
function Rdt() {
  if (kse) return bO;
  kse = 1;
  var i = /\s/;
  function e(t) {
    for (var n = t.length; n-- && i.test(t.charAt(n)); )
      ;
    return n;
  }
  return bO = e, bO;
}
var CO, Tse;
function Fdt() {
  if (Tse) return CO;
  Tse = 1;
  var i = Rdt(), e = /^\s+/;
  function t(n) {
    return n && n.slice(0, i(n) + 1).replace(e, "");
  }
  return CO = t, CO;
}
var yO, Nse;
function Ebe() {
  if (Nse) return yO;
  Nse = 1;
  var i = Dbe(), e = i.Symbol;
  return yO = e, yO;
}
var wO, Pse;
function Bdt() {
  if (Pse) return wO;
  Pse = 1;
  var i = Ebe(), e = Object.prototype, t = e.hasOwnProperty, n = e.toString, r = i ? i.toStringTag : void 0;
  function s(o) {
    var a = t.call(o, r), l = o[r];
    try {
      o[r] = void 0;
      var c = !0;
    } catch {
    }
    var d = n.call(o);
    return c && (a ? o[r] = l : delete o[r]), d;
  }
  return wO = s, wO;
}
var SO, Ose;
function Vdt() {
  if (Ose) return SO;
  Ose = 1;
  var i = Object.prototype, e = i.toString;
  function t(n) {
    return e.call(n);
  }
  return SO = t, SO;
}
var xO, Mse;
function Hdt() {
  if (Mse) return xO;
  Mse = 1;
  var i = Ebe(), e = Bdt(), t = Vdt(), n = "[object Null]", r = "[object Undefined]", s = i ? i.toStringTag : void 0;
  function o(a) {
    return a == null ? a === void 0 ? r : n : s && s in Object(a) ? e(a) : t(a);
  }
  return xO = o, xO;
}
var DO, Rse;
function Wdt() {
  if (Rse) return DO;
  Rse = 1;
  function i(e) {
    return e != null && typeof e == "object";
  }
  return DO = i, DO;
}
var EO, Fse;
function jdt() {
  if (Fse) return EO;
  Fse = 1;
  var i = Hdt(), e = Wdt(), t = "[object Symbol]";
  function n(r) {
    return typeof r == "symbol" || e(r) && i(r) == t;
  }
  return EO = n, EO;
}
var LO, Bse;
function zdt() {
  if (Bse) return LO;
  Bse = 1;
  var i = Fdt(), e = Cq(), t = jdt(), n = NaN, r = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, o = /^0o[0-7]+$/i, a = parseInt;
  function l(c) {
    if (typeof c == "number")
      return c;
    if (t(c))
      return n;
    if (e(c)) {
      var d = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = e(d) ? d + "" : d;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = i(c);
    var u = s.test(c);
    return u || o.test(c) ? a(c.slice(2), u ? 2 : 8) : r.test(c) ? n : +c;
  }
  return LO = l, LO;
}
var IO, Vse;
function Udt() {
  if (Vse) return IO;
  Vse = 1;
  var i = Cq(), e = Mdt(), t = zdt(), n = "Expected a function", r = Math.max, s = Math.min;
  function o(a, l, c) {
    var d, u, h, f, g, p, m = 0, _ = !1, b = !1, w = !0;
    if (typeof a != "function")
      throw new TypeError(n);
    l = t(l) || 0, i(c) && (_ = !!c.leading, b = "maxWait" in c, h = b ? r(t(c.maxWait) || 0, l) : h, w = "trailing" in c ? !!c.trailing : w);
    function y(A) {
      var P = d, O = u;
      return d = u = void 0, m = A, f = a.apply(O, P), f;
    }
    function S(A) {
      return m = A, g = setTimeout(E, l), _ ? y(A) : f;
    }
    function x(A) {
      var P = A - p, O = A - m, K = l - P;
      return b ? s(K, h - O) : K;
    }
    function D(A) {
      var P = A - p, O = A - m;
      return p === void 0 || P >= l || P < 0 || b && O >= h;
    }
    function E() {
      var A = e();
      if (D(A))
        return L(A);
      g = setTimeout(E, x(A));
    }
    function L(A) {
      return g = void 0, w && d ? y(A) : (d = u = void 0, f);
    }
    function k() {
      g !== void 0 && clearTimeout(g), m = 0, d = p = u = g = void 0;
    }
    function N() {
      return g === void 0 ? f : L(e());
    }
    function I() {
      var A = e(), P = D(A);
      if (d = arguments, u = this, p = A, P) {
        if (g === void 0)
          return S(p);
        if (b)
          return clearTimeout(g), g = setTimeout(E, l), y(p);
      }
      return g === void 0 && (g = setTimeout(E, l)), f;
    }
    return I.cancel = k, I.flush = N, I;
  }
  return IO = o, IO;
}
var AO, Hse;
function Lbe() {
  if (Hse) return AO;
  Hse = 1;
  var i = Udt(), e = Cq(), t = "Expected a function";
  function n(r, s, o) {
    var a = !0, l = !0;
    if (typeof r != "function")
      throw new TypeError(t);
    return e(o) && (a = "leading" in o ? !!o.leading : a, l = "trailing" in o ? !!o.trailing : l), i(r, s, {
      leading: a,
      maxWait: s,
      trailing: l
    });
  }
  return AO = n, AO;
}
var Wse;
function Ibe() {
  return Wse || (Wse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ua()), n = e(ha()), r = e(Pl()), s = e(fa()), o = e(hs()), a = e(it), l = e(mn()), c = Or(), d = Za(), u = e(Lbe()), h = e(Rb()), f = e(Cp()), g = e(bq()), p = e(e1()), m = mi();
    function _(N, I) {
      var A = Object.keys(N);
      if (Object.getOwnPropertySymbols) {
        var P = Object.getOwnPropertySymbols(N);
        I && (P = P.filter(function(O) {
          return Object.getOwnPropertyDescriptor(N, O).enumerable;
        })), A.push.apply(A, P);
      }
      return A;
    }
    function b(N) {
      for (var I = 1; I < arguments.length; I++) {
        var A = arguments[I] != null ? arguments[I] : {};
        I % 2 ? _(Object(A), !0).forEach(function(P) {
          (0, o.default)(N, P, A[P]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(A)) : _(Object(A)).forEach(function(P) {
          Object.defineProperty(N, P, Object.getOwnPropertyDescriptor(A, P));
        });
      }
      return N;
    }
    var w = "M0,".concat(m.FANG_HEIGHT_PX, " ").concat(m.FANG_WIDTH_PX, ",").concat(m.FANG_HEIGHT_PX, " ").concat(m.FANG_WIDTH_PX / 2, ",0z"), y = "M0,".concat(m.FANG_HEIGHT_PX, " ").concat(m.FANG_WIDTH_PX / 2, ",0 ").concat(m.FANG_WIDTH_PX, ",").concat(m.FANG_HEIGHT_PX), S = "M0,0 ".concat(m.FANG_WIDTH_PX, ",0 ").concat(m.FANG_WIDTH_PX / 2, ",").concat(m.FANG_HEIGHT_PX, "z"), x = "M0,0 ".concat(m.FANG_WIDTH_PX / 2, ",").concat(m.FANG_HEIGHT_PX, " ").concat(m.FANG_WIDTH_PX, ",0"), D = process.env.NODE_ENV !== "production" ? (0, c.forbidExtraProps)(b({}, d.withStylesPropTypes, {
      id: l.default.string.isRequired,
      placeholder: l.default.string,
      displayValue: l.default.string,
      ariaLabel: l.default.string,
      screenReaderMessage: l.default.string,
      focused: l.default.bool,
      disabled: l.default.bool,
      required: l.default.bool,
      readOnly: l.default.bool,
      openDirection: p.default,
      showCaret: l.default.bool,
      verticalSpacing: c.nonNegativeInteger,
      small: l.default.bool,
      block: l.default.bool,
      regular: l.default.bool,
      onChange: l.default.func,
      onFocus: l.default.func,
      onKeyDownShiftTab: l.default.func,
      onKeyDownTab: l.default.func,
      onKeyDownArrowDown: l.default.func,
      onKeyDownQuestionMark: l.default.func,
      // accessibility
      isFocused: l.default.bool
      // describes actual DOM focus
    })) : {}, E = {
      placeholder: "Select Date",
      displayValue: "",
      ariaLabel: void 0,
      screenReaderMessage: "",
      focused: !1,
      disabled: !1,
      required: !1,
      readOnly: null,
      openDirection: m.OPEN_DOWN,
      showCaret: !1,
      verticalSpacing: m.DEFAULT_VERTICAL_SPACING,
      small: !1,
      block: !1,
      regular: !1,
      onChange: function() {
      },
      onFocus: function() {
      },
      onKeyDownShiftTab: function() {
      },
      onKeyDownTab: function() {
      },
      onKeyDownArrowDown: function() {
      },
      onKeyDownQuestionMark: function() {
      },
      // accessibility
      isFocused: !1
    }, L = /* @__PURE__ */ function(N) {
      (0, s.default)(A, N);
      var I = A.prototype;
      I[!a.default.PureComponent && "shouldComponentUpdate"] = function(P, O) {
        return !(0, t.default)(this.props, P) || !(0, t.default)(this.state, O);
      };
      function A(P) {
        var O;
        return O = N.call(this, P) || this, O.state = {
          dateString: "",
          isTouchDevice: !1
        }, O.onChange = O.onChange.bind((0, r.default)(O)), O.onKeyDown = O.onKeyDown.bind((0, r.default)(O)), O.setInputRef = O.setInputRef.bind((0, r.default)(O)), O.throttledKeyDown = (0, u.default)(O.onFinalKeyDown, 300, {
          trailing: !1
        }), O;
      }
      return I.componentDidMount = function() {
        this.setState({
          isTouchDevice: (0, h.default)()
        });
      }, I.componentWillReceiveProps = function(O) {
        var K = this.state.dateString;
        K && O.displayValue && this.setState({
          dateString: ""
        });
      }, I.componentDidUpdate = function(O) {
        var K = this.props, W = K.focused, F = K.isFocused;
        O.focused === W && O.isFocused === F || W && F && this.inputRef.focus();
      }, I.onChange = function(O) {
        var K = this.props, W = K.onChange, F = K.onKeyDownQuestionMark, q = O.target.value;
        q[q.length - 1] === "?" ? F(O) : this.setState({
          dateString: q
        }, function() {
          return W(q);
        });
      }, I.onKeyDown = function(O) {
        O.stopPropagation(), m.MODIFIER_KEY_NAMES.has(O.key) || this.throttledKeyDown(O);
      }, I.onFinalKeyDown = function(O) {
        var K = this.props, W = K.onKeyDownShiftTab, F = K.onKeyDownTab, q = K.onKeyDownArrowDown, R = K.onKeyDownQuestionMark, T = O.key;
        T === "Tab" ? O.shiftKey ? W(O) : F(O) : T === "ArrowDown" ? q(O) : T === "?" && (O.preventDefault(), R(O));
      }, I.setInputRef = function(O) {
        this.inputRef = O;
      }, I.render = function() {
        var O = this.state, K = O.dateString, W = O.isTouchDevice, F = this.props, q = F.id, R = F.placeholder, T = F.ariaLabel, z = F.displayValue, X = F.screenReaderMessage, ae = F.focused, ue = F.showCaret, se = F.onFocus, le = F.disabled, oe = F.required, re = F.readOnly, B = F.openDirection, ee = F.verticalSpacing, j = F.small, he = F.regular, Se = F.block, ge = F.styles, te = F.theme.reactDates, be = K || z || "", Ae = "DateInput__screen-reader-message-".concat(q), He = ue && ae, de = (0, g.default)(te, j);
        return a.default.createElement("div", (0, d.css)(ge.DateInput, j && ge.DateInput__small, Se && ge.DateInput__block, He && ge.DateInput__withFang, le && ge.DateInput__disabled, He && B === m.OPEN_DOWN && ge.DateInput__openDown, He && B === m.OPEN_UP && ge.DateInput__openUp), a.default.createElement("input", (0, n.default)({}, (0, d.css)(ge.DateInput_input, j && ge.DateInput_input__small, he && ge.DateInput_input__regular, re && ge.DateInput_input__readOnly, ae && ge.DateInput_input__focused, le && ge.DateInput_input__disabled), {
          "aria-label": T === void 0 ? R : T,
          type: "text",
          id: q,
          name: q,
          ref: this.setInputRef,
          value: be,
          onChange: this.onChange,
          onKeyDown: this.onKeyDown,
          onFocus: se,
          placeholder: R,
          autoComplete: "off",
          disabled: le,
          readOnly: typeof re == "boolean" ? re : W,
          required: oe,
          "aria-describedby": X && Ae
        })), He && a.default.createElement("svg", (0, n.default)({
          role: "presentation",
          focusable: "false"
        }, (0, d.css)(ge.DateInput_fang, B === m.OPEN_DOWN && {
          top: de + ee - m.FANG_HEIGHT_PX - 1
        }, B === m.OPEN_UP && {
          bottom: de + ee - m.FANG_HEIGHT_PX - 1
        })), a.default.createElement("path", (0, n.default)({}, (0, d.css)(ge.DateInput_fangShape), {
          d: B === m.OPEN_DOWN ? w : S
        })), a.default.createElement("path", (0, n.default)({}, (0, d.css)(ge.DateInput_fangStroke), {
          d: B === m.OPEN_DOWN ? y : x
        }))), X && a.default.createElement("p", (0, n.default)({}, (0, d.css)(ge.DateInput_screenReaderMessage), {
          id: Ae
        }), X));
      }, A;
    }(a.default.PureComponent || a.default.Component);
    L.propTypes = process.env.NODE_ENV !== "production" ? D : {}, L.defaultProps = E;
    var k = (0, d.withStyles)(function(N) {
      var I = N.reactDates, A = I.border, P = I.color, O = I.sizing, K = I.spacing, W = I.font, F = I.zIndex;
      return {
        DateInput: {
          margin: 0,
          padding: K.inputPadding,
          background: P.background,
          position: "relative",
          display: "inline-block",
          width: O.inputWidth,
          verticalAlign: "middle"
        },
        DateInput__small: {
          width: O.inputWidth_small
        },
        DateInput__block: {
          width: "100%"
        },
        DateInput__disabled: {
          background: P.disabled,
          color: P.textDisabled
        },
        DateInput_input: {
          fontWeight: W.input.weight,
          fontSize: W.input.size,
          lineHeight: W.input.lineHeight,
          color: P.text,
          backgroundColor: P.background,
          width: "100%",
          padding: "".concat(K.displayTextPaddingVertical, "px ").concat(K.displayTextPaddingHorizontal, "px"),
          paddingTop: K.displayTextPaddingTop,
          paddingBottom: K.displayTextPaddingBottom,
          paddingLeft: (0, f.default)(K.displayTextPaddingLeft),
          paddingRight: (0, f.default)(K.displayTextPaddingRight),
          border: A.input.border,
          borderTop: A.input.borderTop,
          borderRight: (0, f.default)(A.input.borderRight),
          borderBottom: A.input.borderBottom,
          borderLeft: (0, f.default)(A.input.borderLeft),
          borderRadius: A.input.borderRadius
        },
        DateInput_input__small: {
          fontSize: W.input.size_small,
          lineHeight: W.input.lineHeight_small,
          letterSpacing: W.input.letterSpacing_small,
          padding: "".concat(K.displayTextPaddingVertical_small, "px ").concat(K.displayTextPaddingHorizontal_small, "px"),
          paddingTop: K.displayTextPaddingTop_small,
          paddingBottom: K.displayTextPaddingBottom_small,
          paddingLeft: (0, f.default)(K.displayTextPaddingLeft_small),
          paddingRight: (0, f.default)(K.displayTextPaddingRight_small)
        },
        DateInput_input__regular: {
          fontWeight: "auto"
        },
        DateInput_input__readOnly: {
          userSelect: "none"
        },
        DateInput_input__focused: {
          outline: A.input.outlineFocused,
          background: P.backgroundFocused,
          border: A.input.borderFocused,
          borderTop: A.input.borderTopFocused,
          borderRight: (0, f.default)(A.input.borderRightFocused),
          borderBottom: A.input.borderBottomFocused,
          borderLeft: (0, f.default)(A.input.borderLeftFocused)
        },
        DateInput_input__disabled: {
          background: P.disabled,
          fontStyle: W.input.styleDisabled
        },
        DateInput_screenReaderMessage: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          height: 1,
          margin: -1,
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: 1
        },
        DateInput_fang: {
          position: "absolute",
          width: m.FANG_WIDTH_PX,
          height: m.FANG_HEIGHT_PX,
          left: 22,
          // TODO: should be noflip wrapped and handled by an isRTL prop
          zIndex: F + 2
        },
        DateInput_fangShape: {
          fill: P.background
        },
        DateInput_fangStroke: {
          stroke: P.core.border,
          fill: "transparent"
        }
      };
    }, {
      pureComponent: typeof a.default.PureComponent < "u"
    })(L);
    i.default = k;
  }(gO)), gO;
}
var kO = {}, jse;
function Abe() {
  return jse || (jse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(it), n = function(o) {
      return t.default.createElement("svg", o, t.default.createElement("path", {
        d: "M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z"
      }));
    };
    n.defaultProps = {
      focusable: "false",
      viewBox: "0 0 1000 1000"
    };
    var r = n;
    i.default = r;
  }(kO)), kO;
}
var TO = {}, zse;
function kbe() {
  return zse || (zse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(it), n = function(o) {
      return t.default.createElement("svg", o, t.default.createElement("path", {
        d: "M336 275L126 485h806c13 0 23 10 23 23s-10 23-23 23H126l210 210c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7L55 524c-11-11-11-21 0-32l249-249c21-22 53 10 32 32z"
      }));
    };
    n.defaultProps = {
      focusable: "false",
      viewBox: "0 0 1000 1000"
    };
    var r = n;
    i.default = r;
  }(TO)), TO;
}
var NO = {}, Use;
function gx() {
  return Use || (Use = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(it), n = function(o) {
      return t.default.createElement("svg", o, t.default.createElement("path", {
        fillRule: "evenodd",
        d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z"
      }));
    };
    n.defaultProps = {
      focusable: "false",
      viewBox: "0 0 12 12"
    };
    var r = n;
    i.default = r;
  }(NO)), NO;
}
var PO = {}, Gse;
function Tbe() {
  return Gse || (Gse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(it), n = function(o) {
      return t.default.createElement("svg", o, t.default.createElement("path", {
        d: "m107 1393h241v-241h-241zm295 0h268v-241h-268zm-295-295h241v-268h-241zm295 0h268v-268h-268zm-295-321h241v-241h-241zm616 616h268v-241h-268zm-321-616h268v-241h-268zm643 616h241v-241h-241zm-322-295h268v-268h-268zm-294-723v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm616 723h241v-268h-241zm-322-321h268v-241h-268zm322 0h241v-241h-241zm27-402v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm321-54v1072c0 29-11 54-32 75s-46 32-75 32h-1179c-29 0-54-11-75-32s-32-46-32-75v-1072c0-29 11-54 32-75s46-32 75-32h107v-80c0-37 13-68 40-95s57-39 94-39h54c37 0 68 13 95 39 26 26 39 58 39 95v80h321v-80c0-37 13-69 40-95 26-26 57-39 94-39h54c37 0 68 13 94 39s40 58 40 95v80h107c29 0 54 11 75 32s32 46 32 75z"
      }));
    };
    n.defaultProps = {
      focusable: "false",
      viewBox: "0 0 1393.1 1500"
    };
    var r = n;
    i.default = r;
  }(PO)), PO;
}
var qse;
function Nbe() {
  return qse || (qse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ha()), n = e(hs()), r = e(it), s = e(mn()), o = Or(), a = Za(), l = So(), c = e(ga()), d = e(Cp()), u = e(e1()), h = e(Ibe()), f = e(Fb()), g = e(ux()), p = e(Abe()), m = e(kbe()), _ = e(gx()), b = e(Tbe()), w = mi();
    function y(k, N) {
      var I = Object.keys(k);
      if (Object.getOwnPropertySymbols) {
        var A = Object.getOwnPropertySymbols(k);
        N && (A = A.filter(function(P) {
          return Object.getOwnPropertyDescriptor(k, P).enumerable;
        })), I.push.apply(I, A);
      }
      return I;
    }
    function S(k) {
      for (var N = 1; N < arguments.length; N++) {
        var I = arguments[N] != null ? arguments[N] : {};
        N % 2 ? y(Object(I), !0).forEach(function(A) {
          (0, n.default)(k, A, I[A]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(k, Object.getOwnPropertyDescriptors(I)) : y(Object(I)).forEach(function(A) {
          Object.defineProperty(k, A, Object.getOwnPropertyDescriptor(I, A));
        });
      }
      return k;
    }
    var x = process.env.NODE_ENV !== "production" ? (0, o.forbidExtraProps)(S({}, a.withStylesPropTypes, {
      children: s.default.node,
      startDateId: s.default.string,
      startDatePlaceholderText: s.default.string,
      startDateAriaLabel: s.default.string,
      screenReaderMessage: s.default.string,
      endDateId: s.default.string,
      endDatePlaceholderText: s.default.string,
      endDateAriaLabel: s.default.string,
      onStartDateFocus: s.default.func,
      onEndDateFocus: s.default.func,
      onStartDateChange: s.default.func,
      onEndDateChange: s.default.func,
      onStartDateShiftTab: s.default.func,
      onEndDateTab: s.default.func,
      onClearDates: s.default.func,
      onKeyDownArrowDown: s.default.func,
      onKeyDownQuestionMark: s.default.func,
      startDate: s.default.string,
      endDate: s.default.string,
      isStartDateFocused: s.default.bool,
      isEndDateFocused: s.default.bool,
      showClearDates: s.default.bool,
      disabled: g.default,
      required: s.default.bool,
      readOnly: s.default.bool,
      openDirection: u.default,
      showCaret: s.default.bool,
      showDefaultInputIcon: s.default.bool,
      inputIconPosition: f.default,
      customInputIcon: s.default.node,
      customArrowIcon: s.default.node,
      customCloseIcon: s.default.node,
      noBorder: s.default.bool,
      block: s.default.bool,
      small: s.default.bool,
      regular: s.default.bool,
      verticalSpacing: o.nonNegativeInteger,
      // accessibility
      isFocused: s.default.bool,
      // describes actual DOM focus
      // i18n
      phrases: s.default.shape((0, c.default)(l.DateRangePickerInputPhrases)),
      isRTL: s.default.bool
    })) : {}, D = {
      children: null,
      startDateId: w.START_DATE,
      endDateId: w.END_DATE,
      startDatePlaceholderText: "Start Date",
      endDatePlaceholderText: "End Date",
      startDateAriaLabel: void 0,
      endDateAriaLabel: void 0,
      screenReaderMessage: "",
      onStartDateFocus: function() {
      },
      onEndDateFocus: function() {
      },
      onStartDateChange: function() {
      },
      onEndDateChange: function() {
      },
      onStartDateShiftTab: function() {
      },
      onEndDateTab: function() {
      },
      onClearDates: function() {
      },
      onKeyDownArrowDown: function() {
      },
      onKeyDownQuestionMark: function() {
      },
      startDate: "",
      endDate: "",
      isStartDateFocused: !1,
      isEndDateFocused: !1,
      showClearDates: !1,
      disabled: !1,
      required: !1,
      readOnly: !1,
      openDirection: w.OPEN_DOWN,
      showCaret: !1,
      showDefaultInputIcon: !1,
      inputIconPosition: w.ICON_BEFORE_POSITION,
      customInputIcon: null,
      customArrowIcon: null,
      customCloseIcon: null,
      noBorder: !1,
      block: !1,
      small: !1,
      regular: !1,
      verticalSpacing: void 0,
      // accessibility
      isFocused: !1,
      // i18n
      phrases: l.DateRangePickerInputPhrases,
      isRTL: !1
    };
    function E(k) {
      var N = k.children, I = k.startDate, A = k.startDateId, P = k.startDatePlaceholderText, O = k.screenReaderMessage, K = k.isStartDateFocused, W = k.onStartDateChange, F = k.onStartDateFocus, q = k.onStartDateShiftTab, R = k.startDateAriaLabel, T = k.endDate, z = k.endDateId, X = k.endDatePlaceholderText, ae = k.isEndDateFocused, ue = k.onEndDateChange, se = k.onEndDateFocus, le = k.onEndDateTab, oe = k.endDateAriaLabel, re = k.onKeyDownArrowDown, B = k.onKeyDownQuestionMark, ee = k.onClearDates, j = k.showClearDates, he = k.disabled, Se = k.required, ge = k.readOnly, te = k.showCaret, be = k.openDirection, Ae = k.showDefaultInputIcon, He = k.inputIconPosition, de = k.customInputIcon, ce = k.customArrowIcon, ie = k.customCloseIcon, H = k.isFocused, Y = k.phrases, Z = k.isRTL, Q = k.noBorder, me = k.block, Le = k.verticalSpacing, xe = k.small, Ue = k.regular, je = k.styles, Ze = de || r.default.createElement(b.default, (0, a.css)(je.DateRangePickerInput_calendarIcon_svg)), _e = ce || r.default.createElement(p.default, (0, a.css)(je.DateRangePickerInput_arrow_svg));
      Z && (_e = r.default.createElement(m.default, (0, a.css)(je.DateRangePickerInput_arrow_svg))), xe && (_e = "-");
      var U = ie || r.default.createElement(_.default, (0, a.css)(je.DateRangePickerInput_clearDates_svg, xe && je.DateRangePickerInput_clearDates_svg__small)), fe = O || Y.keyboardForwardNavigationInstructions, Ee = O || Y.keyboardBackwardNavigationInstructions, Me = (Ae || de !== null) && r.default.createElement("button", (0, t.default)({}, (0, a.css)(je.DateRangePickerInput_calendarIcon), {
        type: "button",
        disabled: he,
        "aria-label": Y.focusStartDate,
        onClick: re
      }), Ze), Pe = he === w.START_DATE || he === !0, et = he === w.END_DATE || he === !0;
      return r.default.createElement("div", (0, a.css)(je.DateRangePickerInput, he && je.DateRangePickerInput__disabled, Z && je.DateRangePickerInput__rtl, !Q && je.DateRangePickerInput__withBorder, me && je.DateRangePickerInput__block, j && je.DateRangePickerInput__showClearDates), He === w.ICON_BEFORE_POSITION && Me, r.default.createElement(h.default, {
        id: A,
        placeholder: P,
        ariaLabel: R,
        displayValue: I,
        screenReaderMessage: fe,
        focused: K,
        isFocused: H,
        disabled: Pe,
        required: Se,
        readOnly: ge,
        showCaret: te,
        openDirection: be,
        onChange: W,
        onFocus: F,
        onKeyDownShiftTab: q,
        onKeyDownArrowDown: re,
        onKeyDownQuestionMark: B,
        verticalSpacing: Le,
        small: xe,
        regular: Ue
      }), N, r.default.createElement("div", (0, t.default)({}, (0, a.css)(je.DateRangePickerInput_arrow), {
        "aria-hidden": "true",
        role: "presentation"
      }), _e), r.default.createElement(h.default, {
        id: z,
        placeholder: X,
        ariaLabel: oe,
        displayValue: T,
        screenReaderMessage: Ee,
        focused: ae,
        isFocused: H,
        disabled: et,
        required: Se,
        readOnly: ge,
        showCaret: te,
        openDirection: be,
        onChange: ue,
        onFocus: se,
        onKeyDownArrowDown: re,
        onKeyDownQuestionMark: B,
        onKeyDownTab: le,
        verticalSpacing: Le,
        small: xe,
        regular: Ue
      }), j && r.default.createElement("button", (0, t.default)({
        type: "button",
        "aria-label": Y.clearDates
      }, (0, a.css)(je.DateRangePickerInput_clearDates, xe && je.DateRangePickerInput_clearDates__small, !ie && je.DateRangePickerInput_clearDates_default, !(I || T) && je.DateRangePickerInput_clearDates__hide), {
        onClick: ee,
        disabled: he
      }), U), He === w.ICON_AFTER_POSITION && Me);
    }
    E.propTypes = process.env.NODE_ENV !== "production" ? x : {}, E.defaultProps = D;
    var L = (0, a.withStyles)(function(k) {
      var N = k.reactDates, I = N.border, A = N.color, P = N.sizing;
      return {
        DateRangePickerInput: {
          backgroundColor: A.background,
          display: "inline-block"
        },
        DateRangePickerInput__disabled: {
          background: A.disabled
        },
        DateRangePickerInput__withBorder: {
          borderColor: A.border,
          borderWidth: I.pickerInput.borderWidth,
          borderStyle: I.pickerInput.borderStyle,
          borderRadius: I.pickerInput.borderRadius
        },
        DateRangePickerInput__rtl: {
          direction: (0, d.default)("rtl")
        },
        DateRangePickerInput__block: {
          display: "block"
        },
        DateRangePickerInput__showClearDates: {
          paddingRight: 30
          // TODO: should be noflip wrapped and handled by an isRTL prop
        },
        DateRangePickerInput_arrow: {
          display: "inline-block",
          verticalAlign: "middle",
          color: A.text
        },
        DateRangePickerInput_arrow_svg: {
          verticalAlign: "middle",
          fill: A.text,
          height: P.arrowWidth,
          width: P.arrowWidth
        },
        DateRangePickerInput_clearDates: {
          background: "none",
          border: 0,
          color: "inherit",
          font: "inherit",
          lineHeight: "normal",
          overflow: "visible",
          cursor: "pointer",
          padding: 10,
          margin: "0 10px 0 5px",
          // TODO: should be noflip wrapped and handled by an isRTL prop
          position: "absolute",
          right: 0,
          // TODO: should be noflip wrapped and handled by an isRTL prop
          top: "50%",
          transform: "translateY(-50%)"
        },
        DateRangePickerInput_clearDates__small: {
          padding: 6
        },
        DateRangePickerInput_clearDates_default: {
          ":focus": {
            background: A.core.border,
            borderRadius: "50%"
          },
          ":hover": {
            background: A.core.border,
            borderRadius: "50%"
          }
        },
        DateRangePickerInput_clearDates__hide: {
          visibility: "hidden"
        },
        DateRangePickerInput_clearDates_svg: {
          fill: A.core.grayLight,
          height: 12,
          width: 15,
          verticalAlign: "middle"
        },
        DateRangePickerInput_clearDates_svg__small: {
          height: 9
        },
        DateRangePickerInput_calendarIcon: {
          background: "none",
          border: 0,
          color: "inherit",
          font: "inherit",
          lineHeight: "normal",
          overflow: "visible",
          cursor: "pointer",
          display: "inline-block",
          verticalAlign: "middle",
          padding: 10,
          margin: "0 5px 0 10px"
          // TODO: should be noflip wrapped and handled by an isRTL prop
        },
        DateRangePickerInput_calendarIcon_svg: {
          fill: A.core.grayLight,
          height: 15,
          width: 14,
          verticalAlign: "middle"
        }
      };
    }, {
      pureComponent: typeof r.default.PureComponent < "u"
    })(E);
    i.default = L;
  }(fO)), fO;
}
var OO = {}, Kse;
function yq() {
  return Kse || (Kse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = s;
    var t = e(gi), n = e(Ob()), r = mi();
    function s(o, a) {
      var l = t.default.isMoment(o) ? o : (0, n.default)(o, a);
      return l ? l.format(r.DISPLAY_FORMAT) : null;
    }
  }(OO)), OO;
}
var Yse;
function Pbe() {
  return Yse || (Yse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ua()), n = e(Pl()), r = e(fa()), s = e(it), o = e(mn()), a = e(gi), l = e(yd()), c = Or(), d = e(e1()), u = So(), h = e(ga()), f = e(Nbe()), g = e(Fb()), p = e(ux()), m = e(Ob()), _ = e(yq()), b = e(Vb()), w = e(fx()), y = mi(), S = process.env.NODE_ENV !== "production" ? (0, c.forbidExtraProps)({
      children: o.default.node,
      startDate: l.default.momentObj,
      startDateId: o.default.string,
      startDatePlaceholderText: o.default.string,
      isStartDateFocused: o.default.bool,
      startDateAriaLabel: o.default.string,
      endDate: l.default.momentObj,
      endDateId: o.default.string,
      endDatePlaceholderText: o.default.string,
      isEndDateFocused: o.default.bool,
      endDateAriaLabel: o.default.string,
      screenReaderMessage: o.default.string,
      showClearDates: o.default.bool,
      showCaret: o.default.bool,
      showDefaultInputIcon: o.default.bool,
      inputIconPosition: g.default,
      disabled: p.default,
      required: o.default.bool,
      readOnly: o.default.bool,
      openDirection: d.default,
      noBorder: o.default.bool,
      block: o.default.bool,
      small: o.default.bool,
      regular: o.default.bool,
      verticalSpacing: c.nonNegativeInteger,
      keepOpenOnDateSelect: o.default.bool,
      reopenPickerOnClearDates: o.default.bool,
      withFullScreenPortal: o.default.bool,
      minimumNights: c.nonNegativeInteger,
      isOutsideRange: o.default.func,
      displayFormat: o.default.oneOfType([o.default.string, o.default.func]),
      onFocusChange: o.default.func,
      onClose: o.default.func,
      onDatesChange: o.default.func,
      onKeyDownArrowDown: o.default.func,
      onKeyDownQuestionMark: o.default.func,
      customInputIcon: o.default.node,
      customArrowIcon: o.default.node,
      customCloseIcon: o.default.node,
      // accessibility
      isFocused: o.default.bool,
      // i18n
      phrases: o.default.shape((0, h.default)(u.DateRangePickerInputPhrases)),
      isRTL: o.default.bool
    }) : {}, x = {
      children: null,
      startDate: null,
      startDateId: y.START_DATE,
      startDatePlaceholderText: "Start Date",
      isStartDateFocused: !1,
      startDateAriaLabel: void 0,
      endDate: null,
      endDateId: y.END_DATE,
      endDatePlaceholderText: "End Date",
      isEndDateFocused: !1,
      endDateAriaLabel: void 0,
      screenReaderMessage: "",
      showClearDates: !1,
      showCaret: !1,
      showDefaultInputIcon: !1,
      inputIconPosition: y.ICON_BEFORE_POSITION,
      disabled: !1,
      required: !1,
      readOnly: !1,
      openDirection: y.OPEN_DOWN,
      noBorder: !1,
      block: !1,
      small: !1,
      regular: !1,
      verticalSpacing: void 0,
      keepOpenOnDateSelect: !1,
      reopenPickerOnClearDates: !1,
      withFullScreenPortal: !1,
      minimumNights: 1,
      isOutsideRange: function(L) {
        return !(0, b.default)(L, (0, a.default)());
      },
      displayFormat: function() {
        return a.default.localeData().longDateFormat("L");
      },
      onFocusChange: function() {
      },
      onClose: function() {
      },
      onDatesChange: function() {
      },
      onKeyDownArrowDown: function() {
      },
      onKeyDownQuestionMark: function() {
      },
      customInputIcon: null,
      customArrowIcon: null,
      customCloseIcon: null,
      // accessibility
      isFocused: !1,
      // i18n
      phrases: u.DateRangePickerInputPhrases,
      isRTL: !1
    }, D = /* @__PURE__ */ function(E) {
      (0, r.default)(k, E);
      var L = k.prototype;
      L[!s.default.PureComponent && "shouldComponentUpdate"] = function(N, I) {
        return !(0, t.default)(this.props, N) || !(0, t.default)(this.state, I);
      };
      function k(N) {
        var I;
        return I = E.call(this, N) || this, I.onClearFocus = I.onClearFocus.bind((0, n.default)(I)), I.onStartDateChange = I.onStartDateChange.bind((0, n.default)(I)), I.onStartDateFocus = I.onStartDateFocus.bind((0, n.default)(I)), I.onEndDateChange = I.onEndDateChange.bind((0, n.default)(I)), I.onEndDateFocus = I.onEndDateFocus.bind((0, n.default)(I)), I.clearDates = I.clearDates.bind((0, n.default)(I)), I;
      }
      return L.onClearFocus = function() {
        var I = this.props, A = I.onFocusChange, P = I.onClose, O = I.startDate, K = I.endDate;
        A(null), P({
          startDate: O,
          endDate: K
        });
      }, L.onEndDateChange = function(I) {
        var A = this.props, P = A.startDate, O = A.isOutsideRange, K = A.minimumNights, W = A.keepOpenOnDateSelect, F = A.onDatesChange, q = (0, m.default)(I, this.getDisplayFormat()), R = q && !O(q) && !(P && (0, w.default)(q, P.clone().add(K, "days")));
        R ? (F({
          startDate: P,
          endDate: q
        }), W || this.onClearFocus()) : F({
          startDate: P,
          endDate: null
        });
      }, L.onEndDateFocus = function() {
        var I = this.props, A = I.startDate, P = I.onFocusChange, O = I.withFullScreenPortal, K = I.disabled;
        !A && O && (!K || K === y.END_DATE) ? P(y.START_DATE) : (!K || K === y.START_DATE) && P(y.END_DATE);
      }, L.onStartDateChange = function(I) {
        var A = this.props.endDate, P = this.props, O = P.isOutsideRange, K = P.minimumNights, W = P.onDatesChange, F = P.onFocusChange, q = P.disabled, R = (0, m.default)(I, this.getDisplayFormat()), T = R && (0, w.default)(A, R.clone().add(K, "days")), z = R && !O(R) && !(q === y.END_DATE && T);
        z ? (T && (A = null), W({
          startDate: R,
          endDate: A
        }), F(y.END_DATE)) : W({
          startDate: null,
          endDate: A
        });
      }, L.onStartDateFocus = function() {
        var I = this.props, A = I.disabled, P = I.onFocusChange;
        (!A || A === y.END_DATE) && P(y.START_DATE);
      }, L.getDisplayFormat = function() {
        var I = this.props.displayFormat;
        return typeof I == "string" ? I : I();
      }, L.getDateString = function(I) {
        var A = this.getDisplayFormat();
        return I && A ? I && I.format(A) : (0, _.default)(I);
      }, L.clearDates = function() {
        var I = this.props, A = I.onDatesChange, P = I.reopenPickerOnClearDates, O = I.onFocusChange;
        A({
          startDate: null,
          endDate: null
        }), P && O(y.START_DATE);
      }, L.render = function() {
        var I = this.props, A = I.children, P = I.startDate, O = I.startDateId, K = I.startDatePlaceholderText, W = I.isStartDateFocused, F = I.startDateAriaLabel, q = I.endDate, R = I.endDateId, T = I.endDatePlaceholderText, z = I.endDateAriaLabel, X = I.isEndDateFocused, ae = I.screenReaderMessage, ue = I.showClearDates, se = I.showCaret, le = I.showDefaultInputIcon, oe = I.inputIconPosition, re = I.customInputIcon, B = I.customArrowIcon, ee = I.customCloseIcon, j = I.disabled, he = I.required, Se = I.readOnly, ge = I.openDirection, te = I.isFocused, be = I.phrases, Ae = I.onKeyDownArrowDown, He = I.onKeyDownQuestionMark, de = I.isRTL, ce = I.noBorder, ie = I.block, H = I.small, Y = I.regular, Z = I.verticalSpacing, Q = this.getDateString(P), me = this.getDateString(q);
        return s.default.createElement(f.default, {
          startDate: Q,
          startDateId: O,
          startDatePlaceholderText: K,
          isStartDateFocused: W,
          startDateAriaLabel: F,
          endDate: me,
          endDateId: R,
          endDatePlaceholderText: T,
          isEndDateFocused: X,
          endDateAriaLabel: z,
          isFocused: te,
          disabled: j,
          required: he,
          readOnly: Se,
          openDirection: ge,
          showCaret: se,
          showDefaultInputIcon: le,
          inputIconPosition: oe,
          customInputIcon: re,
          customArrowIcon: B,
          customCloseIcon: ee,
          phrases: be,
          onStartDateChange: this.onStartDateChange,
          onStartDateFocus: this.onStartDateFocus,
          onStartDateShiftTab: this.onClearFocus,
          onEndDateChange: this.onEndDateChange,
          onEndDateFocus: this.onEndDateFocus,
          showClearDates: ue,
          onClearDates: this.clearDates,
          screenReaderMessage: ae,
          onKeyDownArrowDown: Ae,
          onKeyDownQuestionMark: He,
          isRTL: de,
          noBorder: ce,
          block: ie,
          small: H,
          regular: Y,
          verticalSpacing: Z
        }, A);
      }, k;
    }(s.default.PureComponent || s.default.Component);
    i.default = D, D.propTypes = process.env.NODE_ENV !== "production" ? S : {}, D.defaultProps = x;
  }(hO)), hO;
}
var MO = {};
function Gdt(i) {
  if (Array.isArray(i)) return i;
}
function qdt(i, e) {
  var t = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (t != null) {
    var n, r, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(i)).next, e === 0) {
        if (Object(t) !== t) return;
        l = !1;
      } else for (; !(l = (n = s.call(t)).done) && (a.push(n.value), a.length !== e); l = !0) ;
    } catch (d) {
      c = !0, r = d;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw r;
      }
    }
    return a;
  }
}
function Kdt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hu(i, e) {
  return Gdt(i) || qdt(i, e) || obe(i, e) || Kdt();
}
const Ydt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hu
}, Symbol.toStringTag, { value: "Module" })), Obe = /* @__PURE__ */ L0(Ydt);
var RO = {}, Xse;
function Mbe() {
  return Xse || (Xse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = e(J0());
    function r(s, o) {
      if (!t.default.isMoment(s) || !t.default.isMoment(o)) return !1;
      var a = (0, t.default)(s).add(1, "day");
      return (0, n.default)(a, o);
    }
  }(RO)), RO;
}
var FO = {}, Zse;
function fk() {
  return Zse || (Zse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = s;
    var t = e(gi), n = e(fx()), r = e(J0());
    function s(o, a) {
      return !t.default.isMoment(o) || !t.default.isMoment(a) ? !1 : !(0, n.default)(o, a) && !(0, r.default)(o, a);
    }
  }(FO)), FO;
}
var BO = {}, Qse;
function Xdt() {
  return Qse || (Qse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = e(J0());
    function r(s, o) {
      if (!t.default.isMoment(s) || !t.default.isMoment(o)) return !1;
      var a = (0, t.default)(s).subtract(1, "day");
      return (0, n.default)(a, o);
    }
  }(BO)), BO;
}
var VO = {}, Jse;
function Rbe() {
  return Jse || (Jse = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = e(hk());
    function r(s, o, a, l) {
      if (!t.default.isMoment(s)) return {};
      for (var c = {}, d = l ? s.clone() : s.clone().subtract(1, "month"), u = 0; u < (l ? o : o + 2); u += 1) {
        var h = [], f = d.clone(), g = f.clone().startOf("month").hour(12), p = f.clone().endOf("month").hour(12), m = g.clone();
        if (a)
          for (var _ = 0; _ < m.weekday(); _ += 1) {
            var b = m.clone().subtract(_ + 1, "day");
            h.unshift(b);
          }
        for (; m < p; )
          h.push(m.clone()), m.add(1, "day");
        if (a && m.weekday() !== 0)
          for (var w = m.weekday(), y = 0; w < 7; w += 1, y += 1) {
            var S = m.clone().add(y, "day");
            h.push(S);
          }
        c[(0, n.default)(d)] = h, d = d.clone().add(1, "month");
      }
      return c;
    }
  }(VO)), VO;
}
var HO = {}, $se;
function wq() {
  return $se || ($se = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = d;
    var t = e(gi), n = e(fx()), r = e(fk()), s = e(hk()), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map();
    function d(u, h, f, g) {
      if (!t.default.isMoment(u)) return !1;
      var p = (0, s.default)(h), m = p + "+" + f;
      return g ? (o.has(p) || o.set(p, h.clone().startOf("month").startOf("week")), (0, n.default)(u, o.get(p)) ? !1 : (a.has(m) || a.set(m, h.clone().endOf("week").add(f - 1, "months").endOf("month").endOf("week")), !(0, r.default)(u, a.get(m)))) : (l.has(p) || l.set(p, h.clone().startOf("month")), (0, n.default)(u, l.get(p)) ? !1 : (c.has(m) || c.set(m, h.clone().add(f - 1, "months").endOf("month")), !(0, r.default)(u, c.get(m))));
    }
  }(HO)), HO;
}
var WO = {}, eoe;
function Zdt() {
  return eoe || (eoe = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = t;
    var e = function(r) {
      return r;
    };
    function t(n, r) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e;
      return n ? s(n(r.clone())) : r;
    }
  }(WO)), WO;
}
var T2 = {}, jO = {}, toe;
function Qdt() {
  return toe || (toe = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = n;
    var e, t;
    function n(r) {
      return r !== e && (e = r, t = r.clone().subtract(1, "month")), t;
    }
  }(jO)), jO;
}
var noe;
function Fbe() {
  if (noe) return T2;
  noe = 1;
  var i = xt;
  Object.defineProperty(T2, "__esModule", {
    value: !0
  }), T2.addModifier = c, T2.deleteModifier = d;
  var e = i(hs()), t = i(wq()), n = i(dx()), r = i(hk()), s = i(Qdt()), o = mi();
  function a(u, h) {
    var f = Object.keys(u);
    if (Object.getOwnPropertySymbols) {
      var g = Object.getOwnPropertySymbols(u);
      h && (g = g.filter(function(p) {
        return Object.getOwnPropertyDescriptor(u, p).enumerable;
      })), f.push.apply(f, g);
    }
    return f;
  }
  function l(u) {
    for (var h = 1; h < arguments.length; h++) {
      var f = arguments[h] != null ? arguments[h] : {};
      h % 2 ? a(Object(f), !0).forEach(function(g) {
        (0, e.default)(u, g, f[g]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(u, Object.getOwnPropertyDescriptors(f)) : a(Object(f)).forEach(function(g) {
        Object.defineProperty(u, g, Object.getOwnPropertyDescriptor(f, g));
      });
    }
    return u;
  }
  function c(u, h, f, g, p) {
    var m = g.numberOfMonths, _ = g.enableOutsideDays, b = g.orientation, w = p.currentMonth, y = p.visibleDays, S = w, x = m;
    if (b === o.VERTICAL_SCROLLABLE ? x = Object.keys(y).length : (S = (0, s.default)(S), x += 2), !h || !(0, t.default)(h, S, x, _))
      return u;
    var D = (0, n.default)(h), E = l({}, u);
    if (_) {
      var L = Object.keys(y).filter(function(A) {
        return Object.keys(y[A]).indexOf(D) > -1;
      });
      E = L.reduce(function(A, P) {
        var O = u[P] || y[P];
        if (!O[D] || !O[D].has(f)) {
          var K = new Set(O[D]);
          K.add(f), A[P] = l({}, O, (0, e.default)({}, D, K));
        }
        return A;
      }, E);
    } else {
      var k = (0, r.default)(h), N = u[k] || y[k] || {};
      if (!N[D] || !N[D].has(f)) {
        var I = new Set(N[D]);
        I.add(f), E[k] = l({}, N, (0, e.default)({}, D, I));
      }
    }
    return E;
  }
  function d(u, h, f, g, p) {
    var m = g.numberOfMonths, _ = g.enableOutsideDays, b = g.orientation, w = p.currentMonth, y = p.visibleDays, S = w, x = m;
    if (b === o.VERTICAL_SCROLLABLE ? x = Object.keys(y).length : (S = (0, s.default)(S), x += 2), !h || !(0, t.default)(h, S, x, _))
      return u;
    var D = (0, n.default)(h), E = l({}, u);
    if (_) {
      var L = Object.keys(y).filter(function(A) {
        return Object.keys(y[A]).indexOf(D) > -1;
      });
      E = L.reduce(function(A, P) {
        var O = u[P] || y[P];
        if (O[D] && O[D].has(f)) {
          var K = new Set(O[D]);
          K.delete(f), A[P] = l({}, O, (0, e.default)({}, D, K));
        }
        return A;
      }, E);
    } else {
      var k = (0, r.default)(h), N = u[k] || y[k] || {};
      if (N[D] && N[D].has(f)) {
        var I = new Set(N[D]);
        I.delete(f), E[k] = l({}, N, (0, e.default)({}, D, I));
      }
    }
    return E;
  }
  return T2;
}
var zO = {}, UO = {}, GO = {}, ioe;
function Jdt() {
  return ioe || (ioe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(it), n = function(o) {
      return t.default.createElement("svg", o, t.default.createElement("path", {
        d: "M32 713l453-453c11-11 21-11 32 0l453 453c5 5 7 10 7 16 0 13-10 23-22 23-7 0-12-2-16-7L501 309 64 745c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32z"
      }));
    };
    n.defaultProps = {
      focusable: "false",
      viewBox: "0 0 1000 1000"
    };
    var r = n;
    i.default = r;
  }(GO)), GO;
}
var qO = {}, roe;
function $dt() {
  return roe || (roe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(it), n = function(o) {
      return t.default.createElement("svg", o, t.default.createElement("path", {
        d: "M968 289L514 741c-11 11-21 11-32 0L29 289c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437 436 438-436c4-5 9-7 16-7 6 0 11 2 16 7 9 10 9 21 0 32z"
      }));
    };
    n.defaultProps = {
      focusable: "false",
      viewBox: "0 0 1000 1000"
    };
    var r = n;
    i.default = r;
  }(qO)), qO;
}
var soe;
function eut() {
  return soe || (soe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ua()), n = e(ha()), r = e(pq), s = e(fa()), o = e(hs()), a = e(it), l = e(mn()), c = Or(), d = Za(), u = So(), h = e(ga()), f = e(Cp()), g = e(kbe()), p = e(Abe()), m = e(Jdt()), _ = e($dt()), b = e(Bb()), w = e(Mb()), y = mi();
    function S(N, I) {
      var A = Object.keys(N);
      if (Object.getOwnPropertySymbols) {
        var P = Object.getOwnPropertySymbols(N);
        I && (P = P.filter(function(O) {
          return Object.getOwnPropertyDescriptor(N, O).enumerable;
        })), A.push.apply(A, P);
      }
      return A;
    }
    function x(N) {
      for (var I = 1; I < arguments.length; I++) {
        var A = arguments[I] != null ? arguments[I] : {};
        I % 2 ? S(Object(A), !0).forEach(function(P) {
          (0, o.default)(N, P, A[P]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(A)) : S(Object(A)).forEach(function(P) {
          Object.defineProperty(N, P, Object.getOwnPropertyDescriptor(A, P));
        });
      }
      return N;
    }
    var D = process.env.NODE_ENV !== "production" ? (0, c.forbidExtraProps)(x({}, d.withStylesPropTypes, {
      disablePrev: l.default.bool,
      disableNext: l.default.bool,
      inlineStyles: l.default.object,
      isRTL: l.default.bool,
      navPosition: b.default,
      navPrev: l.default.node,
      navNext: l.default.node,
      orientation: w.default,
      onPrevMonthClick: l.default.func,
      onNextMonthClick: l.default.func,
      // internationalization
      phrases: l.default.shape((0, h.default)(u.DayPickerNavigationPhrases)),
      renderNavPrevButton: l.default.func,
      renderNavNextButton: l.default.func,
      showNavPrevButton: l.default.bool,
      showNavNextButton: l.default.bool
    })) : {}, E = {
      disablePrev: !1,
      disableNext: !1,
      inlineStyles: null,
      isRTL: !1,
      navPosition: y.NAV_POSITION_TOP,
      navPrev: null,
      navNext: null,
      orientation: y.HORIZONTAL_ORIENTATION,
      onPrevMonthClick: function() {
      },
      onNextMonthClick: function() {
      },
      // internationalization
      phrases: u.DayPickerNavigationPhrases,
      renderNavPrevButton: null,
      renderNavNextButton: null,
      showNavPrevButton: !0,
      showNavNextButton: !0
    }, L = /* @__PURE__ */ function(N) {
      (0, s.default)(I, N);
      function I() {
        return N.apply(this, arguments) || this;
      }
      var A = I.prototype;
      return A[!a.default.PureComponent && "shouldComponentUpdate"] = function(P, O) {
        return !(0, t.default)(this.props, P) || !(0, t.default)(this.state, O);
      }, A.render = function() {
        var O = this.props, K = O.inlineStyles, W = O.isRTL, F = O.disablePrev, q = O.disableNext, R = O.navPosition, T = O.navPrev, z = O.navNext, X = O.onPrevMonthClick, ae = O.onNextMonthClick, ue = O.orientation, se = O.phrases, le = O.renderNavPrevButton, oe = O.renderNavNextButton, re = O.showNavPrevButton, B = O.showNavNextButton, ee = O.styles;
        if (!B && !re)
          return null;
        var j = ue === y.HORIZONTAL_ORIENTATION, he = ue !== y.HORIZONTAL_ORIENTATION, Se = ue === y.VERTICAL_SCROLLABLE, ge = R === y.NAV_POSITION_BOTTOM, te = !!K, be = T, Ae = z, He = !1, de = !1, ce = {}, ie = {};
        if (!be && !le && re) {
          ce = {
            tabIndex: "0"
          }, He = !0;
          var H = he ? m.default : g.default;
          W && !he && (H = p.default), be = a.default.createElement(H, (0, d.css)(j && ee.DayPickerNavigation_svg__horizontal, he && ee.DayPickerNavigation_svg__vertical, F && ee.DayPickerNavigation_svg__disabled));
        }
        if (!Ae && !oe && B) {
          ie = {
            tabIndex: "0"
          }, de = !0;
          var Y = he ? _.default : p.default;
          W && !he && (Y = g.default), Ae = a.default.createElement(Y, (0, d.css)(j && ee.DayPickerNavigation_svg__horizontal, he && ee.DayPickerNavigation_svg__vertical, q && ee.DayPickerNavigation_svg__disabled));
        }
        var Z = de || He;
        return a.default.createElement("div", d.css.apply(void 0, [ee.DayPickerNavigation, j && ee.DayPickerNavigation__horizontal].concat((0, r.default)(he ? [ee.DayPickerNavigation__vertical, Z && ee.DayPickerNavigation__verticalDefault] : []), (0, r.default)(Se ? [ee.DayPickerNavigation__verticalScrollable, Z && ee.DayPickerNavigation__verticalScrollableDefault, re && ee.DayPickerNavigation__verticalScrollable_prevNav] : []), (0, r.default)(ge ? [ee.DayPickerNavigation__bottom, Z && ee.DayPickerNavigation__bottomDefault] : []), [te && K])), re && (le ? le({
          ariaLabel: se.jumpToPrevMonth,
          disabled: F,
          onClick: F ? void 0 : X,
          onKeyUp: F ? void 0 : function(Q) {
            var me = Q.key;
            (me === "Enter" || me === " ") && X(Q);
          },
          onMouseUp: F ? void 0 : function(Q) {
            Q.currentTarget.blur();
          }
        }) : a.default.createElement("div", (0, n.default)({
          // eslint-disable-line jsx-a11y/interactive-supports-focus
          role: "button"
        }, ce, d.css.apply(void 0, [ee.DayPickerNavigation_button, He && ee.DayPickerNavigation_button__default, F && ee.DayPickerNavigation_button__disabled].concat((0, r.default)(j ? [ee.DayPickerNavigation_button__horizontal].concat((0, r.default)(He ? [ee.DayPickerNavigation_button__horizontalDefault, ge && ee.DayPickerNavigation_bottomButton__horizontalDefault, !W && ee.DayPickerNavigation_leftButton__horizontalDefault, W && ee.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), (0, r.default)(he ? [ee.DayPickerNavigation_button__vertical].concat((0, r.default)(He ? [ee.DayPickerNavigation_button__verticalDefault, ee.DayPickerNavigation_prevButton__verticalDefault, Se && ee.DayPickerNavigation_prevButton__verticalScrollableDefault] : [])) : []))), {
          "aria-disabled": F ? !0 : void 0,
          "aria-label": se.jumpToPrevMonth,
          onClick: F ? void 0 : X,
          onKeyUp: F ? void 0 : function(Q) {
            var me = Q.key;
            (me === "Enter" || me === " ") && X(Q);
          },
          onMouseUp: F ? void 0 : function(Q) {
            Q.currentTarget.blur();
          }
        }), be)), B && (oe ? oe({
          ariaLabel: se.jumpToNextMonth,
          disabled: q,
          onClick: q ? void 0 : ae,
          onKeyUp: q ? void 0 : function(Q) {
            var me = Q.key;
            (me === "Enter" || me === " ") && ae(Q);
          },
          onMouseUp: q ? void 0 : function(Q) {
            Q.currentTarget.blur();
          }
        }) : a.default.createElement("div", (0, n.default)({
          // eslint-disable-line jsx-a11y/interactive-supports-focus
          role: "button"
        }, ie, d.css.apply(void 0, [ee.DayPickerNavigation_button, de && ee.DayPickerNavigation_button__default, q && ee.DayPickerNavigation_button__disabled].concat((0, r.default)(j ? [ee.DayPickerNavigation_button__horizontal].concat((0, r.default)(de ? [ee.DayPickerNavigation_button__horizontalDefault, ge && ee.DayPickerNavigation_bottomButton__horizontalDefault, W && ee.DayPickerNavigation_leftButton__horizontalDefault, !W && ee.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), (0, r.default)(he ? [ee.DayPickerNavigation_button__vertical].concat((0, r.default)(de ? [ee.DayPickerNavigation_button__verticalDefault, ee.DayPickerNavigation_nextButton__verticalDefault, Se && ee.DayPickerNavigation_nextButton__verticalScrollableDefault] : [])) : []))), {
          "aria-disabled": q ? !0 : void 0,
          "aria-label": se.jumpToNextMonth,
          onClick: q ? void 0 : ae,
          onKeyUp: q ? void 0 : function(Q) {
            var me = Q.key;
            (me === "Enter" || me === " ") && ae(Q);
          },
          onMouseUp: q ? void 0 : function(Q) {
            Q.currentTarget.blur();
          }
        }), Ae)));
      }, I;
    }(a.default.PureComponent || a.default.Component);
    L.propTypes = process.env.NODE_ENV !== "production" ? D : {}, L.defaultProps = E;
    var k = (0, d.withStyles)(function(N) {
      var I = N.reactDates, A = I.color, P = I.zIndex;
      return {
        DayPickerNavigation: {
          position: "relative",
          zIndex: P + 2
        },
        DayPickerNavigation__horizontal: {
          height: 0
        },
        DayPickerNavigation__vertical: {},
        DayPickerNavigation__verticalScrollable: {},
        DayPickerNavigation__verticalScrollable_prevNav: {
          zIndex: P + 1
          // zIndex + 2 causes the button to show on top of the day of week headers
        },
        DayPickerNavigation__verticalDefault: {
          position: "absolute",
          width: "100%",
          height: 52,
          bottom: 0,
          left: (0, f.default)(0)
        },
        DayPickerNavigation__verticalScrollableDefault: {
          position: "relative"
        },
        DayPickerNavigation__bottom: {
          height: "auto"
        },
        DayPickerNavigation__bottomDefault: {
          display: "flex",
          justifyContent: "space-between"
        },
        DayPickerNavigation_button: {
          cursor: "pointer",
          userSelect: "none",
          border: 0,
          padding: 0,
          margin: 0
        },
        DayPickerNavigation_button__default: {
          border: "1px solid ".concat(A.core.borderLight),
          backgroundColor: A.background,
          color: A.placeholderText,
          ":focus": {
            border: "1px solid ".concat(A.core.borderMedium)
          },
          ":hover": {
            border: "1px solid ".concat(A.core.borderMedium)
          },
          ":active": {
            background: A.backgroundDark
          }
        },
        DayPickerNavigation_button__disabled: {
          cursor: "default",
          border: "1px solid ".concat(A.disabled),
          ":focus": {
            border: "1px solid ".concat(A.disabled)
          },
          ":hover": {
            border: "1px solid ".concat(A.disabled)
          },
          ":active": {
            background: "none"
          }
        },
        DayPickerNavigation_button__horizontal: {},
        DayPickerNavigation_button__horizontalDefault: {
          position: "absolute",
          top: 18,
          lineHeight: 0.78,
          borderRadius: 3,
          padding: "6px 9px"
        },
        DayPickerNavigation_bottomButton__horizontalDefault: {
          position: "static",
          marginLeft: 22,
          marginRight: 22,
          marginBottom: 30,
          marginTop: -10
        },
        DayPickerNavigation_leftButton__horizontalDefault: {
          left: (0, f.default)(22)
        },
        DayPickerNavigation_rightButton__horizontalDefault: {
          right: (0, f.default)(22)
        },
        DayPickerNavigation_button__vertical: {},
        DayPickerNavigation_button__verticalDefault: {
          padding: 5,
          background: A.background,
          boxShadow: (0, f.default)("0 0 5px 2px rgba(0, 0, 0, 0.1)"),
          position: "relative",
          display: "inline-block",
          textAlign: "center",
          height: "100%",
          width: "50%"
        },
        DayPickerNavigation_prevButton__verticalDefault: {},
        DayPickerNavigation_nextButton__verticalDefault: {
          borderLeft: (0, f.default)(0)
        },
        DayPickerNavigation_nextButton__verticalScrollableDefault: {
          width: "100%"
        },
        DayPickerNavigation_prevButton__verticalScrollableDefault: {
          width: "100%"
        },
        DayPickerNavigation_svg__horizontal: {
          height: 19,
          width: 19,
          fill: A.core.grayLight,
          display: "block"
        },
        DayPickerNavigation_svg__vertical: {
          height: 42,
          width: 42,
          fill: A.text
        },
        DayPickerNavigation_svg__disabled: {
          fill: A.disabled
        }
      };
    }, {
      pureComponent: typeof a.default.PureComponent < "u"
    })(L);
    i.default = k;
  }(UO)), UO;
}
var KO = {}, YO = {}, ooe;
function tut() {
  return ooe || (ooe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ha()), n = e(hs()), r = e(it), s = e(mn()), o = Or(), a = Za();
    function l(g, p) {
      var m = Object.keys(g);
      if (Object.getOwnPropertySymbols) {
        var _ = Object.getOwnPropertySymbols(g);
        p && (_ = _.filter(function(b) {
          return Object.getOwnPropertyDescriptor(g, b).enumerable;
        })), m.push.apply(m, _);
      }
      return m;
    }
    function c(g) {
      for (var p = 1; p < arguments.length; p++) {
        var m = arguments[p] != null ? arguments[p] : {};
        p % 2 ? l(Object(m), !0).forEach(function(_) {
          (0, n.default)(g, _, m[_]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(g, Object.getOwnPropertyDescriptors(m)) : l(Object(m)).forEach(function(_) {
          Object.defineProperty(g, _, Object.getOwnPropertyDescriptor(m, _));
        });
      }
      return g;
    }
    var d = process.env.NODE_ENV !== "production" ? (0, o.forbidExtraProps)(c({}, a.withStylesPropTypes, {
      unicode: s.default.string.isRequired,
      label: s.default.string.isRequired,
      action: s.default.string.isRequired,
      block: s.default.bool
    })) : {}, u = {
      block: !1
    };
    function h(g) {
      var p = g.unicode, m = g.label, _ = g.action, b = g.block, w = g.styles;
      return r.default.createElement("li", (0, a.css)(w.KeyboardShortcutRow, b && w.KeyboardShortcutRow__block), r.default.createElement("div", (0, a.css)(w.KeyboardShortcutRow_keyContainer, b && w.KeyboardShortcutRow_keyContainer__block), r.default.createElement("span", (0, t.default)({}, (0, a.css)(w.KeyboardShortcutRow_key), {
        role: "img",
        "aria-label": "".concat(m, ",")
        // add comma so screen readers will pause before reading action
      }), p)), r.default.createElement("div", (0, a.css)(w.KeyboardShortcutRow_action), _));
    }
    h.propTypes = process.env.NODE_ENV !== "production" ? d : {}, h.defaultProps = u;
    var f = (0, a.withStyles)(function(g) {
      var p = g.reactDates.color;
      return {
        KeyboardShortcutRow: {
          listStyle: "none",
          margin: "6px 0"
        },
        KeyboardShortcutRow__block: {
          marginBottom: 16
        },
        KeyboardShortcutRow_keyContainer: {
          display: "inline-block",
          whiteSpace: "nowrap",
          textAlign: "right",
          // is not handled by isRTL
          marginRight: 6
          // is not handled by isRTL
        },
        KeyboardShortcutRow_keyContainer__block: {
          textAlign: "left",
          // is not handled by isRTL
          display: "inline"
        },
        KeyboardShortcutRow_key: {
          fontFamily: "monospace",
          fontSize: 12,
          textTransform: "uppercase",
          background: p.core.grayLightest,
          padding: "2px 6px"
        },
        KeyboardShortcutRow_action: {
          display: "inline",
          wordBreak: "break-word",
          marginLeft: 8
          // is not handled by isRTL
        }
      };
    }, {
      pureComponent: typeof r.default.PureComponent < "u"
    })(h);
    i.default = f;
  }(YO)), YO;
}
var aoe;
function nut() {
  return aoe || (aoe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = i.BOTTOM_RIGHT = i.TOP_RIGHT = i.TOP_LEFT = void 0;
    var t = e(ua()), n = e(ha()), r = e(Pl()), s = e(fa()), o = e(hs()), a = e(it), l = e(mn()), c = Or(), d = Za(), u = So(), h = e(ga()), f = e(tut()), g = e(gx());
    function p(L, k) {
      var N = Object.keys(L);
      if (Object.getOwnPropertySymbols) {
        var I = Object.getOwnPropertySymbols(L);
        k && (I = I.filter(function(A) {
          return Object.getOwnPropertyDescriptor(L, A).enumerable;
        })), N.push.apply(N, I);
      }
      return N;
    }
    function m(L) {
      for (var k = 1; k < arguments.length; k++) {
        var N = arguments[k] != null ? arguments[k] : {};
        k % 2 ? p(Object(N), !0).forEach(function(I) {
          (0, o.default)(L, I, N[I]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(L, Object.getOwnPropertyDescriptors(N)) : p(Object(N)).forEach(function(I) {
          Object.defineProperty(L, I, Object.getOwnPropertyDescriptor(N, I));
        });
      }
      return L;
    }
    var _ = "top-left";
    i.TOP_LEFT = _;
    var b = "top-right";
    i.TOP_RIGHT = b;
    var w = "bottom-right";
    i.BOTTOM_RIGHT = w;
    var y = process.env.NODE_ENV !== "production" ? (0, c.forbidExtraProps)(m({}, d.withStylesPropTypes, {
      block: l.default.bool,
      // TODO: rename button location to be direction-agnostic
      buttonLocation: l.default.oneOf([_, b, w]),
      showKeyboardShortcutsPanel: l.default.bool,
      openKeyboardShortcutsPanel: l.default.func,
      closeKeyboardShortcutsPanel: l.default.func,
      phrases: l.default.shape((0, h.default)(u.DayPickerKeyboardShortcutsPhrases)),
      renderKeyboardShortcutsButton: l.default.func,
      renderKeyboardShortcutsPanel: l.default.func
    })) : {}, S = {
      block: !1,
      buttonLocation: w,
      showKeyboardShortcutsPanel: !1,
      openKeyboardShortcutsPanel: function() {
      },
      closeKeyboardShortcutsPanel: function() {
      },
      phrases: u.DayPickerKeyboardShortcutsPhrases,
      renderKeyboardShortcutsButton: void 0,
      renderKeyboardShortcutsPanel: void 0
    };
    function x(L) {
      return [{
        unicode: "↵",
        label: L.enterKey,
        action: L.selectFocusedDate
      }, {
        unicode: "←/→",
        label: L.leftArrowRightArrow,
        action: L.moveFocusByOneDay
      }, {
        unicode: "↑/↓",
        label: L.upArrowDownArrow,
        action: L.moveFocusByOneWeek
      }, {
        unicode: "PgUp/PgDn",
        label: L.pageUpPageDown,
        action: L.moveFocusByOneMonth
      }, {
        unicode: "Home/End",
        label: L.homeEnd,
        action: L.moveFocustoStartAndEndOfWeek
      }, {
        unicode: "Esc",
        label: L.escape,
        action: L.returnFocusToInput
      }, {
        unicode: "?",
        label: L.questionMark,
        action: L.openThisPanel
      }];
    }
    var D = /* @__PURE__ */ function(L) {
      (0, s.default)(N, L);
      var k = N.prototype;
      k[!a.default.PureComponent && "shouldComponentUpdate"] = function(I, A) {
        return !(0, t.default)(this.props, I) || !(0, t.default)(this.state, A);
      };
      function N() {
        for (var I, A = arguments.length, P = new Array(A), O = 0; O < A; O++)
          P[O] = arguments[O];
        I = L.call.apply(L, [this].concat(P)) || this;
        var K = I.props.phrases;
        return I.keyboardShortcuts = x(K), I.onShowKeyboardShortcutsButtonClick = I.onShowKeyboardShortcutsButtonClick.bind((0, r.default)(I)), I.setShowKeyboardShortcutsButtonRef = I.setShowKeyboardShortcutsButtonRef.bind((0, r.default)(I)), I.setHideKeyboardShortcutsButtonRef = I.setHideKeyboardShortcutsButtonRef.bind((0, r.default)(I)), I.handleFocus = I.handleFocus.bind((0, r.default)(I)), I.onKeyDown = I.onKeyDown.bind((0, r.default)(I)), I;
      }
      return k.componentWillReceiveProps = function(A) {
        var P = this.props.phrases;
        A.phrases !== P && (this.keyboardShortcuts = x(A.phrases));
      }, k.componentDidUpdate = function() {
        this.handleFocus();
      }, k.onKeyDown = function(A) {
        A.stopPropagation();
        var P = this.props.closeKeyboardShortcutsPanel;
        switch (A.key) {
          case "Escape":
            P();
            break;
          case "ArrowUp":
          case "ArrowDown":
            break;
          case "Tab":
          case "Home":
          case "End":
          case "PageUp":
          case "PageDown":
          case "ArrowLeft":
          case "ArrowRight":
            A.preventDefault();
            break;
        }
      }, k.onShowKeyboardShortcutsButtonClick = function() {
        var A = this, P = this.props.openKeyboardShortcutsPanel;
        P(function() {
          A.showKeyboardShortcutsButton.focus();
        });
      }, k.setShowKeyboardShortcutsButtonRef = function(A) {
        this.showKeyboardShortcutsButton = A;
      }, k.setHideKeyboardShortcutsButtonRef = function(A) {
        this.hideKeyboardShortcutsButton = A;
      }, k.handleFocus = function() {
        this.hideKeyboardShortcutsButton && this.hideKeyboardShortcutsButton.focus();
      }, k.render = function() {
        var A = this.props, P = A.block, O = A.buttonLocation, K = A.showKeyboardShortcutsPanel, W = A.closeKeyboardShortcutsPanel, F = A.styles, q = A.phrases, R = A.renderKeyboardShortcutsButton, T = A.renderKeyboardShortcutsPanel, z = K ? q.hideKeyboardShortcutsPanel : q.showKeyboardShortcutsPanel, X = O === w, ae = O === b, ue = O === _;
        return a.default.createElement("div", null, R && R({
          // passing in context-specific props
          ref: this.setShowKeyboardShortcutsButtonRef,
          onClick: this.onShowKeyboardShortcutsButtonClick,
          ariaLabel: z
        }), !R && a.default.createElement("button", (0, n.default)({
          ref: this.setShowKeyboardShortcutsButtonRef
        }, (0, d.css)(F.DayPickerKeyboardShortcuts_buttonReset, F.DayPickerKeyboardShortcuts_show, X && F.DayPickerKeyboardShortcuts_show__bottomRight, ae && F.DayPickerKeyboardShortcuts_show__topRight, ue && F.DayPickerKeyboardShortcuts_show__topLeft), {
          type: "button",
          "aria-label": z,
          onClick: this.onShowKeyboardShortcutsButtonClick,
          onMouseUp: function(le) {
            le.currentTarget.blur();
          }
        }), a.default.createElement("span", (0, d.css)(F.DayPickerKeyboardShortcuts_showSpan, X && F.DayPickerKeyboardShortcuts_showSpan__bottomRight, ae && F.DayPickerKeyboardShortcuts_showSpan__topRight, ue && F.DayPickerKeyboardShortcuts_showSpan__topLeft), "?")), K && (T ? T({
          closeButtonAriaLabel: q.hideKeyboardShortcutsPanel,
          keyboardShortcuts: this.keyboardShortcuts,
          onCloseButtonClick: W,
          onKeyDown: this.onKeyDown,
          title: q.keyboardShortcuts
        }) : a.default.createElement("div", (0, n.default)({}, (0, d.css)(F.DayPickerKeyboardShortcuts_panel), {
          role: "dialog",
          "aria-labelledby": "DayPickerKeyboardShortcuts_title",
          "aria-describedby": "DayPickerKeyboardShortcuts_description"
        }), a.default.createElement("div", (0, n.default)({}, (0, d.css)(F.DayPickerKeyboardShortcuts_title), {
          id: "DayPickerKeyboardShortcuts_title"
        }), q.keyboardShortcuts), a.default.createElement("button", (0, n.default)({
          ref: this.setHideKeyboardShortcutsButtonRef
        }, (0, d.css)(F.DayPickerKeyboardShortcuts_buttonReset, F.DayPickerKeyboardShortcuts_close), {
          type: "button",
          tabIndex: "0",
          "aria-label": q.hideKeyboardShortcutsPanel,
          onClick: W,
          onKeyDown: this.onKeyDown
        }), a.default.createElement(g.default, (0, d.css)(F.DayPickerKeyboardShortcuts_closeSvg))), a.default.createElement("ul", (0, n.default)({}, (0, d.css)(F.DayPickerKeyboardShortcuts_list), {
          id: "DayPickerKeyboardShortcuts_description"
        }), this.keyboardShortcuts.map(function(se) {
          var le = se.unicode, oe = se.label, re = se.action;
          return a.default.createElement(f.default, {
            key: oe,
            unicode: le,
            label: oe,
            action: re,
            block: P
          });
        })))));
      }, N;
    }(a.default.PureComponent || a.default.Component);
    D.propTypes = process.env.NODE_ENV !== "production" ? y : {}, D.defaultProps = S;
    var E = (0, d.withStyles)(function(L) {
      var k = L.reactDates, N = k.color, I = k.font, A = k.zIndex;
      return {
        DayPickerKeyboardShortcuts_buttonReset: {
          background: "none",
          border: 0,
          borderRadius: 0,
          color: "inherit",
          font: "inherit",
          lineHeight: "normal",
          overflow: "visible",
          padding: 0,
          cursor: "pointer",
          fontSize: I.size,
          ":active": {
            outline: "none"
          }
        },
        DayPickerKeyboardShortcuts_show: {
          width: 33,
          height: 26,
          position: "absolute",
          zIndex: A + 2,
          "::before": {
            content: '""',
            display: "block",
            position: "absolute"
          }
        },
        DayPickerKeyboardShortcuts_show__bottomRight: {
          bottom: 0,
          right: 0,
          "::before": {
            borderTop: "26px solid transparent",
            borderRight: "33px solid ".concat(N.core.primary),
            bottom: 0,
            right: 0
          },
          ":hover::before": {
            borderRight: "33px solid ".concat(N.core.primary_dark)
          }
        },
        DayPickerKeyboardShortcuts_show__topRight: {
          top: 0,
          right: 0,
          "::before": {
            borderBottom: "26px solid transparent",
            borderRight: "33px solid ".concat(N.core.primary),
            top: 0,
            right: 0
          },
          ":hover::before": {
            borderRight: "33px solid ".concat(N.core.primary_dark)
          }
        },
        DayPickerKeyboardShortcuts_show__topLeft: {
          top: 0,
          left: 0,
          "::before": {
            borderBottom: "26px solid transparent",
            borderLeft: "33px solid ".concat(N.core.primary),
            top: 0,
            left: 0
          },
          ":hover::before": {
            borderLeft: "33px solid ".concat(N.core.primary_dark)
          }
        },
        DayPickerKeyboardShortcuts_showSpan: {
          color: N.core.white,
          position: "absolute"
        },
        DayPickerKeyboardShortcuts_showSpan__bottomRight: {
          bottom: 0,
          right: 5
        },
        DayPickerKeyboardShortcuts_showSpan__topRight: {
          top: 1,
          right: 5
        },
        DayPickerKeyboardShortcuts_showSpan__topLeft: {
          top: 1,
          left: 5
        },
        DayPickerKeyboardShortcuts_panel: {
          overflow: "auto",
          background: N.background,
          border: "1px solid ".concat(N.core.border),
          borderRadius: 2,
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          zIndex: A + 2,
          padding: 22,
          margin: 33,
          textAlign: "left"
          // TODO: investigate use of text-align throughout the library
        },
        DayPickerKeyboardShortcuts_title: {
          fontSize: 16,
          fontWeight: "bold",
          margin: 0
        },
        DayPickerKeyboardShortcuts_list: {
          listStyle: "none",
          padding: 0,
          fontSize: I.size
        },
        DayPickerKeyboardShortcuts_close: {
          position: "absolute",
          right: 22,
          top: 22,
          zIndex: A + 2,
          ":active": {
            outline: "none"
          }
        },
        DayPickerKeyboardShortcuts_closeSvg: {
          height: 15,
          width: 15,
          fill: N.core.grayLighter,
          ":hover": {
            fill: N.core.grayLight
          },
          ":focus": {
            fill: N.core.grayLight
          }
        }
      };
    }, {
      pureComponent: typeof a.default.PureComponent < "u"
    })(D);
    i.default = E;
  }(KO)), KO;
}
var XO = {}, loe;
function iut() {
  return loe || (loe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi);
    function n(s, o) {
      var a = s.day() - o;
      return (a + 7) % 7;
    }
    function r(s) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t.default.localeData().firstDayOfWeek(), a = s.clone().startOf("month"), l = n(a, o);
      return Math.ceil((l + s.daysInMonth()) / 7);
    }
  }(XO)), XO;
}
var ZO = {}, coe;
function rut() {
  return coe || (coe = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = e;
    function e() {
      return typeof document < "u" && document.activeElement;
    }
  }(ZO)), ZO;
}
var doe;
function Sq() {
  return doe || (doe = 1, function(i) {
    var e = ebe(), t = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = i.PureDayPicker = i.defaultProps = void 0;
    var n = t(ua()), r = t(ha()), s = t(pq), o = t(Pl()), a = t(fa()), l = t(hs()), c = t(it), d = t(mn()), u = Or(), h = Za(), f = t(gi), g = t(Lbe()), p = t(Rb()), m = t(_q()), _ = So(), b = t(ga()), w = t(Cp()), y = t(ube()), S = t(eut()), x = e(nut()), D = t(iut()), E = t(dbe()), L = t(lbe()), k = t(rut()), N = t(wq()), I = t(mq()), A = t(ck()), P = t(Bb()), O = t(Mb()), K = t($0()), W = t(hx()), F = mi();
    function q(j, he) {
      var Se = Object.keys(j);
      if (Object.getOwnPropertySymbols) {
        var ge = Object.getOwnPropertySymbols(j);
        he && (ge = ge.filter(function(te) {
          return Object.getOwnPropertyDescriptor(j, te).enumerable;
        })), Se.push.apply(Se, ge);
      }
      return Se;
    }
    function R(j) {
      for (var he = 1; he < arguments.length; he++) {
        var Se = arguments[he] != null ? arguments[he] : {};
        he % 2 ? q(Object(Se), !0).forEach(function(ge) {
          (0, l.default)(j, ge, Se[ge]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(j, Object.getOwnPropertyDescriptors(Se)) : q(Object(Se)).forEach(function(ge) {
          Object.defineProperty(j, ge, Object.getOwnPropertyDescriptor(Se, ge));
        });
      }
      return j;
    }
    var T = 23, z = "prev", X = "next", ae = "month_selection", ue = "year_selection", se = "prev_nav", le = "next_nav", oe = process.env.NODE_ENV !== "production" ? (0, u.forbidExtraProps)(R({}, h.withStylesPropTypes, {
      // calendar presentation props
      enableOutsideDays: d.default.bool,
      numberOfMonths: d.default.number,
      orientation: O.default,
      withPortal: d.default.bool,
      onOutsideClick: d.default.func,
      hidden: d.default.bool,
      initialVisibleMonth: d.default.func,
      firstDayOfWeek: K.default,
      renderCalendarInfo: d.default.func,
      calendarInfoPosition: W.default,
      hideKeyboardShortcutsPanel: d.default.bool,
      daySize: u.nonNegativeInteger,
      isRTL: d.default.bool,
      verticalHeight: u.nonNegativeInteger,
      noBorder: d.default.bool,
      transitionDuration: u.nonNegativeInteger,
      verticalBorderSpacing: u.nonNegativeInteger,
      horizontalMonthPadding: u.nonNegativeInteger,
      renderKeyboardShortcutsButton: d.default.func,
      renderKeyboardShortcutsPanel: d.default.func,
      // navigation props
      dayPickerNavigationInlineStyles: d.default.object,
      disablePrev: d.default.bool,
      disableNext: d.default.bool,
      navPosition: P.default,
      navPrev: d.default.node,
      navNext: d.default.node,
      renderNavPrevButton: d.default.func,
      renderNavNextButton: d.default.func,
      noNavButtons: d.default.bool,
      noNavNextButton: d.default.bool,
      noNavPrevButton: d.default.bool,
      onPrevMonthClick: d.default.func,
      onNextMonthClick: d.default.func,
      onMonthChange: d.default.func,
      onYearChange: d.default.func,
      onGetNextScrollableMonths: d.default.func,
      // VERTICAL_SCROLLABLE daypickers only
      onGetPrevScrollableMonths: d.default.func,
      // VERTICAL_SCROLLABLE daypickers only
      // month props
      renderMonthText: (0, u.mutuallyExclusiveProps)(d.default.func, "renderMonthText", "renderMonthElement"),
      renderMonthElement: (0, u.mutuallyExclusiveProps)(d.default.func, "renderMonthText", "renderMonthElement"),
      renderWeekHeaderElement: d.default.func,
      // day props
      modifiers: d.default.objectOf(d.default.objectOf(A.default)),
      renderCalendarDay: d.default.func,
      renderDayContents: d.default.func,
      onDayClick: d.default.func,
      onDayMouseEnter: d.default.func,
      onDayMouseLeave: d.default.func,
      // accessibility props
      isFocused: d.default.bool,
      getFirstFocusableDay: d.default.func,
      onBlur: d.default.func,
      showKeyboardShortcuts: d.default.bool,
      onTab: d.default.func,
      onShiftTab: d.default.func,
      // internationalization
      monthFormat: d.default.string,
      weekDayFormat: d.default.string,
      phrases: d.default.shape((0, b.default)(_.DayPickerPhrases)),
      dayAriaLabelFormat: d.default.string
    })) : {}, re = {
      // calendar presentation props
      enableOutsideDays: !1,
      numberOfMonths: 2,
      orientation: F.HORIZONTAL_ORIENTATION,
      withPortal: !1,
      onOutsideClick: function() {
      },
      hidden: !1,
      initialVisibleMonth: function() {
        return (0, f.default)();
      },
      firstDayOfWeek: null,
      renderCalendarInfo: null,
      calendarInfoPosition: F.INFO_POSITION_BOTTOM,
      hideKeyboardShortcutsPanel: !1,
      daySize: F.DAY_SIZE,
      isRTL: !1,
      verticalHeight: null,
      noBorder: !1,
      transitionDuration: void 0,
      verticalBorderSpacing: void 0,
      horizontalMonthPadding: 13,
      renderKeyboardShortcutsButton: void 0,
      renderKeyboardShortcutsPanel: void 0,
      // navigation props
      dayPickerNavigationInlineStyles: null,
      disablePrev: !1,
      disableNext: !1,
      navPosition: F.NAV_POSITION_TOP,
      navPrev: null,
      navNext: null,
      renderNavPrevButton: null,
      renderNavNextButton: null,
      noNavButtons: !1,
      noNavNextButton: !1,
      noNavPrevButton: !1,
      onPrevMonthClick: function() {
      },
      onNextMonthClick: function() {
      },
      onMonthChange: function() {
      },
      onYearChange: function() {
      },
      onGetNextScrollableMonths: function() {
      },
      onGetPrevScrollableMonths: function() {
      },
      // month props
      renderMonthText: null,
      renderMonthElement: null,
      renderWeekHeaderElement: null,
      // day props
      modifiers: {},
      renderCalendarDay: void 0,
      renderDayContents: null,
      onDayClick: function() {
      },
      onDayMouseEnter: function() {
      },
      onDayMouseLeave: function() {
      },
      // accessibility props
      isFocused: !1,
      getFirstFocusableDay: null,
      onBlur: function() {
      },
      showKeyboardShortcuts: !1,
      onTab: function() {
      },
      onShiftTab: function() {
      },
      // internationalization
      monthFormat: "MMMM YYYY",
      weekDayFormat: "dd",
      phrases: _.DayPickerPhrases,
      dayAriaLabelFormat: void 0
    };
    i.defaultProps = re;
    var B = /* @__PURE__ */ function(j) {
      (0, a.default)(Se, j);
      var he = Se.prototype;
      he[!c.default.PureComponent && "shouldComponentUpdate"] = function(ge, te) {
        return !(0, n.default)(this.props, ge) || !(0, n.default)(this.state, te);
      };
      function Se(ge) {
        var te;
        te = j.call(this, ge) || this;
        var be = ge.hidden ? (0, f.default)() : ge.initialVisibleMonth(), Ae = be.clone().startOf("month");
        ge.getFirstFocusableDay && (Ae = ge.getFirstFocusableDay(be));
        var He = ge.horizontalMonthPadding, de = ge.isRTL && te.isHorizontal() ? -(0, E.default)(ge.daySize, He) : 0;
        return te.hasSetInitialVisibleMonth = !ge.hidden, te.state = {
          currentMonthScrollTop: null,
          currentMonth: be,
          monthTransition: null,
          translationValue: de,
          scrollableMonthMultiple: 1,
          calendarMonthWidth: (0, E.default)(ge.daySize, He),
          focusedDate: !ge.hidden || ge.isFocused ? Ae : null,
          nextFocusedDate: null,
          showKeyboardShortcuts: ge.showKeyboardShortcuts,
          onKeyboardShortcutsPanelClose: function() {
          },
          isTouchDevice: (0, p.default)(),
          withMouseInteractions: !0,
          calendarInfoWidth: 0,
          monthTitleHeight: null,
          hasSetHeight: !1
        }, te.setCalendarMonthWeeks(be), te.calendarMonthGridHeight = 0, te.setCalendarInfoWidthTimeout = null, te.setCalendarMonthGridHeightTimeout = null, te.onKeyDown = te.onKeyDown.bind((0, o.default)(te)), te.throttledKeyDown = (0, g.default)(te.onFinalKeyDown, 200, {
          trailing: !1
        }), te.onPrevMonthClick = te.onPrevMonthClick.bind((0, o.default)(te)), te.onPrevMonthTransition = te.onPrevMonthTransition.bind((0, o.default)(te)), te.onNextMonthClick = te.onNextMonthClick.bind((0, o.default)(te)), te.onNextMonthTransition = te.onNextMonthTransition.bind((0, o.default)(te)), te.onMonthChange = te.onMonthChange.bind((0, o.default)(te)), te.onYearChange = te.onYearChange.bind((0, o.default)(te)), te.getNextScrollableMonths = te.getNextScrollableMonths.bind((0, o.default)(te)), te.getPrevScrollableMonths = te.getPrevScrollableMonths.bind((0, o.default)(te)), te.updateStateAfterMonthTransition = te.updateStateAfterMonthTransition.bind((0, o.default)(te)), te.openKeyboardShortcutsPanel = te.openKeyboardShortcutsPanel.bind((0, o.default)(te)), te.closeKeyboardShortcutsPanel = te.closeKeyboardShortcutsPanel.bind((0, o.default)(te)), te.setCalendarInfoRef = te.setCalendarInfoRef.bind((0, o.default)(te)), te.setContainerRef = te.setContainerRef.bind((0, o.default)(te)), te.setTransitionContainerRef = te.setTransitionContainerRef.bind((0, o.default)(te)), te.setMonthTitleHeight = te.setMonthTitleHeight.bind((0, o.default)(te)), te;
      }
      return he.componentDidMount = function() {
        var te = this.props.orientation, be = this.state.currentMonth, Ae = this.calendarInfo ? (0, L.default)(this.calendarInfo, "width", !0, !0) : 0, He = this.transitionContainer && te === F.VERTICAL_SCROLLABLE ? this.transitionContainer.scrollHeight - this.transitionContainer.scrollTop : null;
        this.setState({
          isTouchDevice: (0, p.default)(),
          calendarInfoWidth: Ae,
          currentMonthScrollTop: He
        }), this.setCalendarMonthWeeks(be);
      }, he.componentWillReceiveProps = function(te, be) {
        var Ae = te.hidden, He = te.isFocused, de = te.showKeyboardShortcuts, ce = te.onBlur, ie = te.orientation, H = te.renderMonthText, Y = te.horizontalMonthPadding, Z = this.state.currentMonth, Q = be.currentMonth;
        Ae || this.hasSetInitialVisibleMonth || (this.hasSetInitialVisibleMonth = !0, this.setState({
          currentMonth: te.initialVisibleMonth()
        }));
        var me = this.props, Le = me.daySize, xe = me.isFocused, Ue = me.renderMonthText;
        if (te.daySize !== Le && this.setState({
          calendarMonthWidth: (0, E.default)(te.daySize, Y)
        }), He !== xe)
          if (He) {
            var je = this.getFocusedDay(Z), Ze = this.state.onKeyboardShortcutsPanelClose;
            te.showKeyboardShortcuts && (Ze = ce), this.setState({
              showKeyboardShortcuts: de,
              onKeyboardShortcutsPanelClose: Ze,
              focusedDate: je,
              withMouseInteractions: !1
            });
          } else
            this.setState({
              focusedDate: null
            });
        H !== Ue && this.setState({
          monthTitleHeight: null
        }), ie === F.VERTICAL_SCROLLABLE && this.transitionContainer && !(0, I.default)(Z, Q) && this.setState({
          currentMonthScrollTop: this.transitionContainer.scrollHeight - this.transitionContainer.scrollTop
        });
      }, he.componentWillUpdate = function() {
        var te = this, be = this.props.transitionDuration;
        this.calendarInfo && (this.setCalendarInfoWidthTimeout = setTimeout(function() {
          var Ae = te.state.calendarInfoWidth, He = (0, L.default)(te.calendarInfo, "width", !0, !0);
          Ae !== He && te.setState({
            calendarInfoWidth: He
          });
        }, be));
      }, he.componentDidUpdate = function(te, be) {
        var Ae = this.props, He = Ae.orientation, de = Ae.daySize, ce = Ae.isFocused, ie = Ae.numberOfMonths, H = this.state, Y = H.currentMonth, Z = H.currentMonthScrollTop, Q = H.focusedDate, me = H.monthTitleHeight;
        if (this.isHorizontal() && (He !== te.orientation || de !== te.daySize)) {
          var Le = this.calendarMonthWeeks.slice(1, ie + 1), xe = Math.max.apply(Math, [0].concat((0, s.default)(Le))) * (de - 1), Ue = me + xe + 1;
          this.adjustDayPickerHeight(Ue);
        }
        !te.isFocused && ce && !Q && this.container.focus(), He === F.VERTICAL_SCROLLABLE && !(0, I.default)(be.currentMonth, Y) && Z && this.transitionContainer && (this.transitionContainer.scrollTop = this.transitionContainer.scrollHeight - Z);
      }, he.componentWillUnmount = function() {
        clearTimeout(this.setCalendarInfoWidthTimeout), clearTimeout(this.setCalendarMonthGridHeightTimeout);
      }, he.onKeyDown = function(te) {
        te.stopPropagation(), F.MODIFIER_KEY_NAMES.has(te.key) || this.throttledKeyDown(te);
      }, he.onFinalKeyDown = function(te) {
        this.setState({
          withMouseInteractions: !1
        });
        var be = this.props, Ae = be.onBlur, He = be.onTab, de = be.onShiftTab, ce = be.isRTL, ie = this.state, H = ie.focusedDate, Y = ie.showKeyboardShortcuts;
        if (H) {
          var Z = H.clone(), Q = !1, me = (0, k.default)(), Le = function() {
            me && me.focus();
          };
          switch (te.key) {
            case "ArrowUp":
              te.preventDefault(), Z.subtract(1, "week"), Q = this.maybeTransitionPrevMonth(Z);
              break;
            case "ArrowLeft":
              te.preventDefault(), ce ? Z.add(1, "day") : Z.subtract(1, "day"), Q = this.maybeTransitionPrevMonth(Z);
              break;
            case "Home":
              te.preventDefault(), Z.startOf("week"), Q = this.maybeTransitionPrevMonth(Z);
              break;
            case "PageUp":
              te.preventDefault(), Z.subtract(1, "month"), Q = this.maybeTransitionPrevMonth(Z);
              break;
            case "ArrowDown":
              te.preventDefault(), Z.add(1, "week"), Q = this.maybeTransitionNextMonth(Z);
              break;
            case "ArrowRight":
              te.preventDefault(), ce ? Z.subtract(1, "day") : Z.add(1, "day"), Q = this.maybeTransitionNextMonth(Z);
              break;
            case "End":
              te.preventDefault(), Z.endOf("week"), Q = this.maybeTransitionNextMonth(Z);
              break;
            case "PageDown":
              te.preventDefault(), Z.add(1, "month"), Q = this.maybeTransitionNextMonth(Z);
              break;
            case "?":
              this.openKeyboardShortcutsPanel(Le);
              break;
            case "Escape":
              Y ? this.closeKeyboardShortcutsPanel() : Ae(te);
              break;
            case "Tab":
              te.shiftKey ? de() : He(te);
              break;
          }
          Q || this.setState({
            focusedDate: Z
          });
        }
      }, he.onPrevMonthClick = function(te) {
        te && te.preventDefault(), this.onPrevMonthTransition();
      }, he.onPrevMonthTransition = function(te) {
        var be = this.props, Ae = be.daySize, He = be.isRTL, de = be.numberOfMonths, ce = this.state, ie = ce.calendarMonthWidth, H = ce.monthTitleHeight, Y;
        if (this.isVertical()) {
          var Z = this.calendarMonthWeeks[0] * (Ae - 1);
          Y = H + Z + 1;
        } else if (this.isHorizontal()) {
          Y = ie, He && (Y = -2 * ie);
          var Q = this.calendarMonthWeeks.slice(0, de), me = Math.max.apply(Math, [0].concat((0, s.default)(Q))) * (Ae - 1), Le = H + me + 1;
          this.adjustDayPickerHeight(Le);
        }
        this.setState({
          monthTransition: z,
          translationValue: Y,
          focusedDate: null,
          nextFocusedDate: te
        });
      }, he.onMonthChange = function(te) {
        this.setCalendarMonthWeeks(te), this.calculateAndSetDayPickerHeight(), this.setState({
          monthTransition: ae,
          translationValue: 1e-5,
          focusedDate: null,
          nextFocusedDate: te,
          currentMonth: te
        });
      }, he.onYearChange = function(te) {
        this.setCalendarMonthWeeks(te), this.calculateAndSetDayPickerHeight(), this.setState({
          monthTransition: ue,
          translationValue: 1e-4,
          focusedDate: null,
          nextFocusedDate: te,
          currentMonth: te
        });
      }, he.onNextMonthClick = function(te) {
        te && te.preventDefault(), this.onNextMonthTransition();
      }, he.onNextMonthTransition = function(te) {
        var be = this.props, Ae = be.isRTL, He = be.numberOfMonths, de = be.daySize, ce = this.state, ie = ce.calendarMonthWidth, H = ce.monthTitleHeight, Y;
        if (this.isVertical()) {
          var Z = this.calendarMonthWeeks[1], Q = Z * (de - 1);
          Y = -(H + Q + 1);
        }
        if (this.isHorizontal()) {
          Y = -ie, Ae && (Y = 0);
          var me = this.calendarMonthWeeks.slice(2, He + 2), Le = Math.max.apply(Math, [0].concat((0, s.default)(me))) * (de - 1), xe = H + Le + 1;
          this.adjustDayPickerHeight(xe);
        }
        this.setState({
          monthTransition: X,
          translationValue: Y,
          focusedDate: null,
          nextFocusedDate: te
        });
      }, he.getFirstDayOfWeek = function() {
        var te = this.props.firstDayOfWeek;
        return te ?? f.default.localeData().firstDayOfWeek();
      }, he.getWeekHeaders = function() {
        for (var te = this.props.weekDayFormat, be = this.state.currentMonth, Ae = this.getFirstDayOfWeek(), He = [], de = 0; de < 7; de += 1)
          He.push(be.clone().day((de + Ae) % 7).format(te));
        return He;
      }, he.getFirstVisibleIndex = function() {
        var te = this.props.orientation, be = this.state.monthTransition;
        if (te === F.VERTICAL_SCROLLABLE) return 0;
        var Ae = 1;
        return be === z ? Ae -= 1 : be === X && (Ae += 1), Ae;
      }, he.getFocusedDay = function(te) {
        var be = this.props, Ae = be.getFirstFocusableDay, He = be.numberOfMonths, de;
        return Ae && (de = Ae(te)), te && (!de || !(0, N.default)(de, te, He)) && (de = te.clone().startOf("month")), de;
      }, he.setMonthTitleHeight = function(te) {
        var be = this;
        this.setState({
          monthTitleHeight: te
        }, function() {
          be.calculateAndSetDayPickerHeight();
        });
      }, he.setCalendarMonthWeeks = function(te) {
        var be = this.props.numberOfMonths;
        this.calendarMonthWeeks = [];
        for (var Ae = te.clone().subtract(1, "months"), He = this.getFirstDayOfWeek(), de = 0; de < be + 2; de += 1) {
          var ce = (0, D.default)(Ae, He);
          this.calendarMonthWeeks.push(ce), Ae = Ae.add(1, "months");
        }
      }, he.setContainerRef = function(te) {
        this.container = te;
      }, he.setCalendarInfoRef = function(te) {
        this.calendarInfo = te;
      }, he.setTransitionContainerRef = function(te) {
        this.transitionContainer = te;
      }, he.getNextScrollableMonths = function(te) {
        var be = this.props.onGetNextScrollableMonths;
        te && te.preventDefault(), be && be(te), this.setState(function(Ae) {
          var He = Ae.scrollableMonthMultiple;
          return {
            scrollableMonthMultiple: He + 1
          };
        });
      }, he.getPrevScrollableMonths = function(te) {
        var be = this.props, Ae = be.numberOfMonths, He = be.onGetPrevScrollableMonths;
        te && te.preventDefault(), He && He(te), this.setState(function(de) {
          var ce = de.currentMonth, ie = de.scrollableMonthMultiple;
          return {
            currentMonth: ce.clone().subtract(Ae, "month"),
            scrollableMonthMultiple: ie + 1
          };
        });
      }, he.maybeTransitionNextMonth = function(te) {
        var be = this.props.numberOfMonths, Ae = this.state, He = Ae.currentMonth, de = Ae.focusedDate, ce = te.month(), ie = de.month(), H = (0, N.default)(te, He, be);
        return ce !== ie && !H ? (this.onNextMonthTransition(te), !0) : !1;
      }, he.maybeTransitionPrevMonth = function(te) {
        var be = this.props.numberOfMonths, Ae = this.state, He = Ae.currentMonth, de = Ae.focusedDate, ce = te.month(), ie = de.month(), H = (0, N.default)(te, He, be);
        return ce !== ie && !H ? (this.onPrevMonthTransition(te), !0) : !1;
      }, he.isHorizontal = function() {
        var te = this.props.orientation;
        return te === F.HORIZONTAL_ORIENTATION;
      }, he.isVertical = function() {
        var te = this.props.orientation;
        return te === F.VERTICAL_ORIENTATION || te === F.VERTICAL_SCROLLABLE;
      }, he.updateStateAfterMonthTransition = function() {
        var te = this, be = this.props, Ae = be.onPrevMonthClick, He = be.onNextMonthClick, de = be.numberOfMonths, ce = be.onMonthChange, ie = be.onYearChange, H = be.isRTL, Y = this.state, Z = Y.currentMonth, Q = Y.monthTransition, me = Y.focusedDate, Le = Y.nextFocusedDate, xe = Y.withMouseInteractions, Ue = Y.calendarMonthWidth;
        if (Q) {
          var je = Z.clone(), Ze = this.getFirstDayOfWeek();
          if (Q === z) {
            je.subtract(1, "month"), Ae && Ae(je);
            var _e = je.clone().subtract(1, "month"), U = (0, D.default)(_e, Ze);
            this.calendarMonthWeeks = [U].concat((0, s.default)(this.calendarMonthWeeks.slice(0, -1)));
          } else if (Q === X) {
            je.add(1, "month"), He && He(je);
            var fe = je.clone().add(de, "month"), Ee = (0, D.default)(fe, Ze);
            this.calendarMonthWeeks = [].concat((0, s.default)(this.calendarMonthWeeks.slice(1)), [Ee]);
          } else Q === ae ? ce && ce(je) : Q === ue && ie && ie(je);
          var Me = null;
          Le ? Me = Le : !me && !xe && (Me = this.getFocusedDay(je)), this.setState({
            currentMonth: je,
            monthTransition: null,
            translationValue: H && this.isHorizontal() ? -Ue : 0,
            nextFocusedDate: null,
            focusedDate: Me
          }, function() {
            if (xe) {
              var Pe = (0, k.default)();
              Pe && Pe !== document.body && te.container.contains(Pe) && Pe.blur && Pe.blur();
            }
          });
        }
      }, he.adjustDayPickerHeight = function(te) {
        var be = this, Ae = te + T;
        Ae !== this.calendarMonthGridHeight && (this.transitionContainer.style.height = "".concat(Ae, "px"), this.calendarMonthGridHeight || (this.setCalendarMonthGridHeightTimeout = setTimeout(function() {
          be.setState({
            hasSetHeight: !0
          });
        }, 0)), this.calendarMonthGridHeight = Ae);
      }, he.calculateAndSetDayPickerHeight = function() {
        var te = this.props, be = te.daySize, Ae = te.numberOfMonths, He = this.state.monthTitleHeight, de = this.calendarMonthWeeks.slice(1, Ae + 1), ce = Math.max.apply(Math, [0].concat((0, s.default)(de))) * (be - 1), ie = He + ce + 1;
        this.isHorizontal() && this.adjustDayPickerHeight(ie);
      }, he.openKeyboardShortcutsPanel = function(te) {
        this.setState({
          showKeyboardShortcuts: !0,
          onKeyboardShortcutsPanelClose: te
        });
      }, he.closeKeyboardShortcutsPanel = function() {
        var te = this.state.onKeyboardShortcutsPanelClose;
        te && te(), this.setState({
          onKeyboardShortcutsPanelClose: null,
          showKeyboardShortcuts: !1
        });
      }, he.renderNavigation = function(te) {
        var be = this.props, Ae = be.dayPickerNavigationInlineStyles, He = be.disablePrev, de = be.disableNext, ce = be.navPosition, ie = be.navPrev, H = be.navNext, Y = be.noNavButtons, Z = be.noNavNextButton, Q = be.noNavPrevButton, me = be.orientation, Le = be.phrases, xe = be.renderNavPrevButton, Ue = be.renderNavNextButton, je = be.isRTL;
        if (Y)
          return null;
        var Ze = me === F.VERTICAL_SCROLLABLE ? this.getPrevScrollableMonths : this.onPrevMonthClick, _e = me === F.VERTICAL_SCROLLABLE ? this.getNextScrollableMonths : this.onNextMonthClick;
        return c.default.createElement(S.default, {
          disablePrev: He,
          disableNext: de,
          inlineStyles: Ae,
          onPrevMonthClick: Ze,
          onNextMonthClick: _e,
          navPosition: ce,
          navPrev: ie,
          navNext: H,
          renderNavPrevButton: xe,
          renderNavNextButton: Ue,
          orientation: me,
          phrases: Le,
          isRTL: je,
          showNavNextButton: !(Z || me === F.VERTICAL_SCROLLABLE && te === se),
          showNavPrevButton: !(Q || me === F.VERTICAL_SCROLLABLE && te === le)
        });
      }, he.renderWeekHeader = function(te) {
        var be = this.props, Ae = be.daySize, He = be.horizontalMonthPadding, de = be.orientation, ce = be.renderWeekHeaderElement, ie = be.styles, H = this.state.calendarMonthWidth, Y = de === F.VERTICAL_SCROLLABLE, Z = {
          left: te * H
        }, Q = {
          marginLeft: -H / 2
        }, me = {};
        this.isHorizontal() ? me = Z : this.isVertical() && !Y && (me = Q);
        var Le = this.getWeekHeaders(), xe = Le.map(function(Ue) {
          return c.default.createElement("li", (0, r.default)({
            key: Ue
          }, (0, h.css)(ie.DayPicker_weekHeader_li, {
            width: Ae
          })), ce ? ce(Ue) : c.default.createElement("small", null, Ue));
        });
        return c.default.createElement("div", (0, r.default)({}, (0, h.css)(ie.DayPicker_weekHeader, this.isVertical() && ie.DayPicker_weekHeader__vertical, Y && ie.DayPicker_weekHeader__verticalScrollable, me, {
          padding: "0 ".concat(He, "px")
        }), {
          key: "week-".concat(te)
        }), c.default.createElement("ul", (0, h.css)(ie.DayPicker_weekHeader_ul), xe));
      }, he.render = function() {
        for (var te = this, be = this.state, Ae = be.calendarMonthWidth, He = be.currentMonth, de = be.monthTransition, ce = be.translationValue, ie = be.scrollableMonthMultiple, H = be.focusedDate, Y = be.showKeyboardShortcuts, Z = be.isTouchDevice, Q = be.hasSetHeight, me = be.calendarInfoWidth, Le = be.monthTitleHeight, xe = this.props, Ue = xe.enableOutsideDays, je = xe.numberOfMonths, Ze = xe.orientation, _e = xe.modifiers, U = xe.withPortal, fe = xe.onDayClick, Ee = xe.onDayMouseEnter, Me = xe.onDayMouseLeave, Pe = xe.firstDayOfWeek, et = xe.renderMonthText, gt = xe.renderCalendarDay, Vt = xe.renderDayContents, Zt = xe.renderCalendarInfo, St = xe.renderMonthElement, Ht = xe.renderKeyboardShortcutsButton, fn = xe.renderKeyboardShortcutsPanel, xn = xe.calendarInfoPosition, rt = xe.hideKeyboardShortcutsPanel, Ei = xe.onOutsideClick, Nn = xe.monthFormat, Gi = xe.daySize, Ce = xe.isFocused, Xe = xe.isRTL, nt = xe.styles, At = xe.theme, tn = xe.phrases, qt = xe.verticalHeight, Kt = xe.dayAriaLabelFormat, Pt = xe.noBorder, _i = xe.transitionDuration, vn = xe.verticalBorderSpacing, $n = xe.horizontalMonthPadding, mt = xe.navPosition, De = At.reactDates.spacing.dayPickerHorizontalPadding, Qe = this.isHorizontal(), ct = this.isVertical() ? 1 : je, bi = [], Mr = 0; Mr < ct; Mr += 1)
          bi.push(this.renderWeekHeader(Mr));
        var fs = Ze === F.VERTICAL_SCROLLABLE, er;
        Qe ? er = this.calendarMonthGridHeight : this.isVertical() && !fs && !U && (er = qt || 1.75 * Ae);
        var Qa = de !== null, Wb = !Qa && Ce, jb = x.BOTTOM_RIGHT;
        this.isVertical() && (jb = U ? x.TOP_LEFT : x.TOP_RIGHT);
        var Qq = Qe && Q, SCe = xn === F.INFO_POSITION_TOP, xCe = xn === F.INFO_POSITION_BOTTOM, Jq = xn === F.INFO_POSITION_BEFORE, $q = xn === F.INFO_POSITION_AFTER, Sk = Jq || $q, eK = Zt && c.default.createElement("div", (0, r.default)({
          ref: this.setCalendarInfoRef
        }, (0, h.css)(Sk && nt.DayPicker_calendarInfo__horizontal)), Zt()), DCe = Zt && Sk ? me : 0, ECe = this.getFirstVisibleIndex(), xk = Ae * je + 2 * De, tK = xk + DCe + 1, LCe = {
          width: Qe && xk,
          height: er
        }, ICe = {
          width: Qe && xk
        }, ACe = {
          width: Qe && tK,
          // These values are to center the datepicker (approximately) on the page
          marginLeft: Qe && U ? -tK / 2 : null,
          marginTop: Qe && U ? -Ae / 2 : null
        };
        return c.default.createElement("div", (0, h.css)(nt.DayPicker, Qe && nt.DayPicker__horizontal, fs && nt.DayPicker__verticalScrollable, Qe && U && nt.DayPicker_portal__horizontal, this.isVertical() && U && nt.DayPicker_portal__vertical, ACe, !Le && nt.DayPicker__hidden, !Pt && nt.DayPicker__withBorder), c.default.createElement(m.default, {
          onOutsideClick: Ei
        }, (SCe || Jq) && eK, c.default.createElement("div", (0, h.css)(ICe, Sk && Qe && nt.DayPicker_wrapper__horizontal), c.default.createElement("div", (0, r.default)({}, (0, h.css)(nt.DayPicker_weekHeaders, Qe && nt.DayPicker_weekHeaders__horizontal), {
          "aria-hidden": "true",
          role: "presentation"
        }), bi), c.default.createElement("div", (0, r.default)({}, (0, h.css)(nt.DayPicker_focusRegion), {
          ref: this.setContainerRef,
          onClick: function(TCe) {
            TCe.stopPropagation();
          },
          onKeyDown: this.onKeyDown,
          onMouseUp: function() {
            te.setState({
              withMouseInteractions: !0
            });
          },
          tabIndex: -1,
          role: "application",
          "aria-roledescription": tn.roleDescription,
          "aria-label": tn.calendarLabel
        }), !fs && mt === F.NAV_POSITION_TOP && this.renderNavigation(), c.default.createElement("div", (0, r.default)({}, (0, h.css)(nt.DayPicker_transitionContainer, Qq && nt.DayPicker_transitionContainer__horizontal, this.isVertical() && nt.DayPicker_transitionContainer__vertical, fs && nt.DayPicker_transitionContainer__verticalScrollable, LCe), {
          ref: this.setTransitionContainerRef
        }), fs && this.renderNavigation(se), c.default.createElement(y.default, {
          setMonthTitleHeight: Le ? void 0 : this.setMonthTitleHeight,
          translationValue: ce,
          enableOutsideDays: Ue,
          firstVisibleMonthIndex: ECe,
          initialMonth: He,
          isAnimating: Qa,
          modifiers: _e,
          orientation: Ze,
          numberOfMonths: je * ie,
          onDayClick: fe,
          onDayMouseEnter: Ee,
          onDayMouseLeave: Me,
          onMonthChange: this.onMonthChange,
          onYearChange: this.onYearChange,
          renderMonthText: et,
          renderCalendarDay: gt,
          renderDayContents: Vt,
          renderMonthElement: St,
          onMonthTransitionEnd: this.updateStateAfterMonthTransition,
          monthFormat: Nn,
          daySize: Gi,
          firstDayOfWeek: Pe,
          isFocused: Wb,
          focusedDate: H,
          phrases: tn,
          isRTL: Xe,
          dayAriaLabelFormat: Kt,
          transitionDuration: _i,
          verticalBorderSpacing: vn,
          horizontalMonthPadding: $n
        }), fs && this.renderNavigation(le)), !fs && mt === F.NAV_POSITION_BOTTOM && this.renderNavigation(), !Z && !rt && c.default.createElement(x.default, {
          block: this.isVertical() && !U,
          buttonLocation: jb,
          showKeyboardShortcutsPanel: Y,
          openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
          closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
          phrases: tn,
          renderKeyboardShortcutsButton: Ht,
          renderKeyboardShortcutsPanel: fn
        }))), (xCe || $q) && eK));
      }, Se;
    }(c.default.PureComponent || c.default.Component);
    i.PureDayPicker = B, B.propTypes = process.env.NODE_ENV !== "production" ? oe : {}, B.defaultProps = re;
    var ee = (0, h.withStyles)(function(j) {
      var he = j.reactDates, Se = he.color, ge = he.font, te = he.noScrollBarOnVerticalScrollable, be = he.spacing, Ae = he.zIndex;
      return {
        DayPicker: {
          background: Se.background,
          position: "relative",
          textAlign: (0, w.default)("left")
        },
        DayPicker__horizontal: {
          background: Se.background
        },
        DayPicker__verticalScrollable: {
          height: "100%"
        },
        DayPicker__hidden: {
          visibility: "hidden"
        },
        DayPicker__withBorder: {
          boxShadow: (0, w.default)("0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)"),
          borderRadius: 3
        },
        DayPicker_portal__horizontal: {
          boxShadow: "none",
          position: "absolute",
          left: (0, w.default)("50%"),
          top: "50%"
        },
        DayPicker_portal__vertical: {
          position: "initial"
        },
        DayPicker_focusRegion: {
          outline: "none"
        },
        DayPicker_calendarInfo__horizontal: {
          display: "inline-block",
          verticalAlign: "top"
        },
        DayPicker_wrapper__horizontal: {
          display: "inline-block",
          verticalAlign: "top"
        },
        DayPicker_weekHeaders: {
          position: "relative"
        },
        DayPicker_weekHeaders__horizontal: {
          marginLeft: (0, w.default)(be.dayPickerHorizontalPadding)
        },
        DayPicker_weekHeader: {
          color: Se.placeholderText,
          position: "absolute",
          top: 62,
          zIndex: Ae + 2,
          textAlign: (0, w.default)("left")
        },
        DayPicker_weekHeader__vertical: {
          left: (0, w.default)("50%")
        },
        DayPicker_weekHeader__verticalScrollable: {
          top: 0,
          display: "table-row",
          borderBottom: "1px solid ".concat(Se.core.border),
          background: Se.background,
          marginLeft: (0, w.default)(0),
          left: (0, w.default)(0),
          width: "100%",
          textAlign: "center"
        },
        DayPicker_weekHeader_ul: {
          listStyle: "none",
          margin: "1px 0",
          paddingLeft: (0, w.default)(0),
          paddingRight: (0, w.default)(0),
          fontSize: ge.size
        },
        DayPicker_weekHeader_li: {
          display: "inline-block",
          textAlign: "center"
        },
        DayPicker_transitionContainer: {
          position: "relative",
          overflow: "hidden",
          borderRadius: 3
        },
        DayPicker_transitionContainer__horizontal: {
          transition: "height 0.2s ease-in-out"
        },
        DayPicker_transitionContainer__vertical: {
          width: "100%"
        },
        DayPicker_transitionContainer__verticalScrollable: R({
          paddingTop: 20,
          height: "100%",
          position: "absolute",
          top: 0,
          bottom: 0,
          right: (0, w.default)(0),
          left: (0, w.default)(0),
          overflowY: "scroll"
        }, te && {
          "-webkitOverflowScrolling": "touch",
          "::-webkit-scrollbar": {
            "-webkit-appearance": "none",
            display: "none"
          }
        })
      };
    }, {
      pureComponent: typeof c.default.PureComponent < "u"
    })(B);
    i.default = ee;
  }(zO)), zO;
}
var QO = {}, uoe;
function Bbe() {
  return uoe || (uoe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = /* @__PURE__ */ new Map();
    function r(s) {
      return n.has(s) || n.set(s, (0, t.default)(s)), n.get(s);
    }
  }(QO)), QO;
}
var hoe;
function Vbe() {
  return hoe || (hoe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ua()), n = e(Obe), r = e(hs()), s = e(Pl()), o = e(fa()), a = e(it), l = e(mn()), c = e(yd()), d = Or(), u = e(gi), h = e(lk()), f = e(Rb()), g = So(), p = e(ga()), m = e(Vb()), _ = e(Mbe()), b = e(J0()), w = e(fk()), y = e(fx()), S = e(Xdt()), x = e(Rbe()), D = e(wq()), E = e(Zdt()), L = e(dx()), k = Fbe(), N = e(ux()), I = e(_be()), A = e(Mb()), P = e($0()), O = e(hx()), K = e(Bb()), W = mi(), F = e(Sq()), q = e(Bbe());
    function R(se, le) {
      var oe = Object.keys(se);
      if (Object.getOwnPropertySymbols) {
        var re = Object.getOwnPropertySymbols(se);
        le && (re = re.filter(function(B) {
          return Object.getOwnPropertyDescriptor(se, B).enumerable;
        })), oe.push.apply(oe, re);
      }
      return oe;
    }
    function T(se) {
      for (var le = 1; le < arguments.length; le++) {
        var oe = arguments[le] != null ? arguments[le] : {};
        le % 2 ? R(Object(oe), !0).forEach(function(re) {
          (0, r.default)(se, re, oe[re]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(se, Object.getOwnPropertyDescriptors(oe)) : R(Object(oe)).forEach(function(re) {
          Object.defineProperty(se, re, Object.getOwnPropertyDescriptor(oe, re));
        });
      }
      return se;
    }
    var z = process.env.NODE_ENV !== "production" ? (0, d.forbidExtraProps)({
      startDate: c.default.momentObj,
      endDate: c.default.momentObj,
      onDatesChange: l.default.func,
      startDateOffset: l.default.func,
      endDateOffset: l.default.func,
      minDate: c.default.momentObj,
      maxDate: c.default.momentObj,
      focusedInput: I.default,
      onFocusChange: l.default.func,
      onClose: l.default.func,
      keepOpenOnDateSelect: l.default.bool,
      minimumNights: l.default.number,
      disabled: N.default,
      isOutsideRange: l.default.func,
      isDayBlocked: l.default.func,
      isDayHighlighted: l.default.func,
      getMinNightsForHoverDate: l.default.func,
      daysViolatingMinNightsCanBeClicked: l.default.bool,
      // DayPicker props
      renderMonthText: (0, d.mutuallyExclusiveProps)(l.default.func, "renderMonthText", "renderMonthElement"),
      renderMonthElement: (0, d.mutuallyExclusiveProps)(l.default.func, "renderMonthText", "renderMonthElement"),
      renderWeekHeaderElement: l.default.func,
      enableOutsideDays: l.default.bool,
      numberOfMonths: l.default.number,
      orientation: A.default,
      withPortal: l.default.bool,
      initialVisibleMonth: l.default.func,
      hideKeyboardShortcutsPanel: l.default.bool,
      daySize: d.nonNegativeInteger,
      noBorder: l.default.bool,
      verticalBorderSpacing: d.nonNegativeInteger,
      horizontalMonthPadding: d.nonNegativeInteger,
      dayPickerNavigationInlineStyles: l.default.object,
      navPosition: K.default,
      navPrev: l.default.node,
      navNext: l.default.node,
      renderNavPrevButton: l.default.func,
      renderNavNextButton: l.default.func,
      noNavButtons: l.default.bool,
      noNavNextButton: l.default.bool,
      noNavPrevButton: l.default.bool,
      onPrevMonthClick: l.default.func,
      onNextMonthClick: l.default.func,
      onOutsideClick: l.default.func,
      renderCalendarDay: l.default.func,
      renderDayContents: l.default.func,
      renderCalendarInfo: l.default.func,
      renderKeyboardShortcutsButton: l.default.func,
      renderKeyboardShortcutsPanel: l.default.func,
      calendarInfoPosition: O.default,
      firstDayOfWeek: P.default,
      verticalHeight: d.nonNegativeInteger,
      transitionDuration: d.nonNegativeInteger,
      // accessibility
      onBlur: l.default.func,
      isFocused: l.default.bool,
      showKeyboardShortcuts: l.default.bool,
      onTab: l.default.func,
      onShiftTab: l.default.func,
      // i18n
      monthFormat: l.default.string,
      weekDayFormat: l.default.string,
      phrases: l.default.shape((0, p.default)(g.DayPickerPhrases)),
      dayAriaLabelFormat: l.default.string,
      isRTL: l.default.bool
    }) : {}, X = {
      startDate: void 0,
      // TODO: use null
      endDate: void 0,
      // TODO: use null
      minDate: null,
      maxDate: null,
      onDatesChange: function() {
      },
      startDateOffset: void 0,
      endDateOffset: void 0,
      focusedInput: null,
      onFocusChange: function() {
      },
      onClose: function() {
      },
      keepOpenOnDateSelect: !1,
      minimumNights: 1,
      disabled: !1,
      isOutsideRange: function() {
      },
      isDayBlocked: function() {
      },
      isDayHighlighted: function() {
      },
      getMinNightsForHoverDate: function() {
      },
      daysViolatingMinNightsCanBeClicked: !1,
      // DayPicker props
      renderMonthText: null,
      renderWeekHeaderElement: null,
      enableOutsideDays: !1,
      numberOfMonths: 1,
      orientation: W.HORIZONTAL_ORIENTATION,
      withPortal: !1,
      hideKeyboardShortcutsPanel: !1,
      initialVisibleMonth: null,
      daySize: W.DAY_SIZE,
      dayPickerNavigationInlineStyles: null,
      navPosition: W.NAV_POSITION_TOP,
      navPrev: null,
      navNext: null,
      renderNavPrevButton: null,
      renderNavNextButton: null,
      noNavButtons: !1,
      noNavNextButton: !1,
      noNavPrevButton: !1,
      onPrevMonthClick: function() {
      },
      onNextMonthClick: function() {
      },
      onOutsideClick: function() {
      },
      renderCalendarDay: void 0,
      renderDayContents: null,
      renderCalendarInfo: null,
      renderMonthElement: null,
      renderKeyboardShortcutsButton: void 0,
      renderKeyboardShortcutsPanel: void 0,
      calendarInfoPosition: W.INFO_POSITION_BOTTOM,
      firstDayOfWeek: null,
      verticalHeight: null,
      noBorder: !1,
      transitionDuration: void 0,
      verticalBorderSpacing: void 0,
      horizontalMonthPadding: 13,
      // accessibility
      onBlur: function() {
      },
      isFocused: !1,
      showKeyboardShortcuts: !1,
      onTab: function() {
      },
      onShiftTab: function() {
      },
      // i18n
      monthFormat: "MMMM YYYY",
      weekDayFormat: "dd",
      phrases: g.DayPickerPhrases,
      dayAriaLabelFormat: void 0,
      isRTL: !1
    }, ae = function(le, oe) {
      return oe === W.START_DATE ? le.chooseAvailableStartDate : oe === W.END_DATE ? le.chooseAvailableEndDate : le.chooseAvailableDate;
    }, ue = /* @__PURE__ */ function(se) {
      (0, o.default)(oe, se);
      var le = oe.prototype;
      le[!a.default.PureComponent && "shouldComponentUpdate"] = function(re, B) {
        return !(0, t.default)(this.props, re) || !(0, t.default)(this.state, B);
      };
      function oe(re) {
        var B;
        B = se.call(this, re) || this, B.isTouchDevice = (0, f.default)(), B.today = (0, u.default)(), B.modifiers = {
          today: function(te) {
            return B.isToday(te);
          },
          blocked: function(te) {
            return B.isBlocked(te);
          },
          "blocked-calendar": function(te) {
            return re.isDayBlocked(te);
          },
          "blocked-out-of-range": function(te) {
            return re.isOutsideRange(te);
          },
          "highlighted-calendar": function(te) {
            return re.isDayHighlighted(te);
          },
          valid: function(te) {
            return !B.isBlocked(te);
          },
          "selected-start": function(te) {
            return B.isStartDate(te);
          },
          "selected-end": function(te) {
            return B.isEndDate(te);
          },
          "blocked-minimum-nights": function(te) {
            return B.doesNotMeetMinimumNights(te);
          },
          "selected-span": function(te) {
            return B.isInSelectedSpan(te);
          },
          "last-in-range": function(te) {
            return B.isLastInRange(te);
          },
          hovered: function(te) {
            return B.isHovered(te);
          },
          "hovered-span": function(te) {
            return B.isInHoveredSpan(te);
          },
          "hovered-offset": function(te) {
            return B.isInHoveredSpan(te);
          },
          "after-hovered-start": function(te) {
            return B.isDayAfterHoveredStartDate(te);
          },
          "first-day-of-week": function(te) {
            return B.isFirstDayOfWeek(te);
          },
          "last-day-of-week": function(te) {
            return B.isLastDayOfWeek(te);
          },
          "hovered-start-first-possible-end": function(te, be) {
            return B.isFirstPossibleEndDateForHoveredStartDate(te, be);
          },
          "hovered-start-blocked-minimum-nights": function(te, be) {
            return B.doesNotMeetMinNightsForHoveredStartDate(te, be);
          },
          "before-hovered-end": function(te) {
            return B.isDayBeforeHoveredEndDate(te);
          },
          "no-selected-start-before-selected-end": function(te) {
            return B.beforeSelectedEnd(te) && !re.startDate;
          },
          "selected-start-in-hovered-span": function(te, be) {
            return B.isStartDate(te) && (0, w.default)(be, te);
          },
          "selected-start-no-selected-end": function(te) {
            return B.isStartDate(te) && !re.endDate;
          },
          "selected-end-no-selected-start": function(te) {
            return B.isEndDate(te) && !re.startDate;
          }
        };
        var ee = B.getStateForNewMonth(re), j = ee.currentMonth, he = ee.visibleDays, Se = ae(re.phrases, re.focusedInput);
        return B.state = {
          hoverDate: null,
          currentMonth: j,
          phrases: T({}, re.phrases, {
            chooseAvailableDate: Se
          }),
          visibleDays: he,
          disablePrev: B.shouldDisableMonthNavigation(re.minDate, j),
          disableNext: B.shouldDisableMonthNavigation(re.maxDate, j)
        }, B.onDayClick = B.onDayClick.bind((0, s.default)(B)), B.onDayMouseEnter = B.onDayMouseEnter.bind((0, s.default)(B)), B.onDayMouseLeave = B.onDayMouseLeave.bind((0, s.default)(B)), B.onPrevMonthClick = B.onPrevMonthClick.bind((0, s.default)(B)), B.onNextMonthClick = B.onNextMonthClick.bind((0, s.default)(B)), B.onMonthChange = B.onMonthChange.bind((0, s.default)(B)), B.onYearChange = B.onYearChange.bind((0, s.default)(B)), B.onGetNextScrollableMonths = B.onGetNextScrollableMonths.bind((0, s.default)(B)), B.onGetPrevScrollableMonths = B.onGetPrevScrollableMonths.bind((0, s.default)(B)), B.getFirstFocusableDay = B.getFirstFocusableDay.bind((0, s.default)(B)), B;
      }
      return le.componentWillReceiveProps = function(B) {
        var ee = this, j = B.startDate, he = B.endDate, Se = B.focusedInput, ge = B.getMinNightsForHoverDate, te = B.minimumNights, be = B.isOutsideRange, Ae = B.isDayBlocked, He = B.isDayHighlighted, de = B.phrases, ce = B.initialVisibleMonth, ie = B.numberOfMonths, H = B.enableOutsideDays, Y = this.props, Z = Y.startDate, Q = Y.endDate, me = Y.focusedInput, Le = Y.minimumNights, xe = Y.isOutsideRange, Ue = Y.isDayBlocked, je = Y.isDayHighlighted, Ze = Y.phrases, _e = Y.initialVisibleMonth, U = Y.numberOfMonths, fe = Y.enableOutsideDays, Ee = this.state.hoverDate, Me = this.state.visibleDays, Pe = !1, et = !1, gt = !1;
        be !== xe && (this.modifiers["blocked-out-of-range"] = function(Pt) {
          return be(Pt);
        }, Pe = !0), Ae !== Ue && (this.modifiers["blocked-calendar"] = function(Pt) {
          return Ae(Pt);
        }, et = !0), He !== je && (this.modifiers["highlighted-calendar"] = function(Pt) {
          return He(Pt);
        }, gt = !0);
        var Vt = Pe || et || gt, Zt = j !== Z, St = he !== Q, Ht = Se !== me;
        if (ie !== U || H !== fe || ce !== _e && !me && Ht) {
          var fn = this.getStateForNewMonth(B), xn = fn.currentMonth;
          Me = fn.visibleDays, this.setState({
            currentMonth: xn,
            visibleDays: Me
          });
        }
        var rt = {};
        if (Zt) {
          if (rt = this.deleteModifier(rt, Z, "selected-start"), rt = this.addModifier(rt, j, "selected-start"), Z) {
            var Ei = Z.clone().add(1, "day"), Nn = Z.clone().add(Le + 1, "days");
            rt = this.deleteModifierFromRange(rt, Ei, Nn, "after-hovered-start"), (!he || !Q) && (rt = this.deleteModifier(rt, Z, "selected-start-no-selected-end"));
          }
          !Z && he && j && (rt = this.deleteModifier(rt, he, "selected-end-no-selected-start"), rt = this.deleteModifier(rt, he, "selected-end-in-hovered-span"), (0, h.default)(Me).forEach(function(Pt) {
            Object.keys(Pt).forEach(function(_i) {
              var vn = (0, u.default)(_i);
              rt = ee.deleteModifier(rt, vn, "no-selected-start-before-selected-end");
            });
          }));
        }
        if (St && (rt = this.deleteModifier(rt, Q, "selected-end"), rt = this.addModifier(rt, he, "selected-end"), Q && (!j || !Z) && (rt = this.deleteModifier(rt, Q, "selected-end-no-selected-start"))), (Zt || St) && (Z && Q && (rt = this.deleteModifierFromRange(rt, Z, Q.clone().add(1, "day"), "selected-span")), j && he && (rt = this.deleteModifierFromRange(rt, j, he.clone().add(1, "day"), "hovered-span"), rt = this.addModifierToRange(rt, j.clone().add(1, "day"), he, "selected-span")), j && !he && (rt = this.addModifier(rt, j, "selected-start-no-selected-end")), he && !j && (rt = this.addModifier(rt, he, "selected-end-no-selected-start")), !j && he && (0, h.default)(Me).forEach(function(Pt) {
          Object.keys(Pt).forEach(function(_i) {
            var vn = (0, u.default)(_i);
            (0, y.default)(vn, he) && (rt = ee.addModifier(rt, vn, "no-selected-start-before-selected-end"));
          });
        })), !this.isTouchDevice && Zt && j && !he) {
          var Gi = j.clone().add(1, "day"), Ce = j.clone().add(te + 1, "days");
          rt = this.addModifierToRange(rt, Gi, Ce, "after-hovered-start");
        }
        if (!this.isTouchDevice && St && !j && he) {
          var Xe = he.clone().subtract(te, "days"), nt = he.clone();
          rt = this.addModifierToRange(rt, Xe, nt, "before-hovered-end");
        }
        if (Le > 0 && (Ht || Zt || te !== Le)) {
          var At = Z || this.today;
          rt = this.deleteModifierFromRange(rt, At, At.clone().add(Le, "days"), "blocked-minimum-nights"), rt = this.deleteModifierFromRange(rt, At, At.clone().add(Le, "days"), "blocked");
        }
        if ((Ht || Vt) && (0, h.default)(Me).forEach(function(Pt) {
          Object.keys(Pt).forEach(function(_i) {
            var vn = (0, q.default)(_i), $n = !1;
            (Ht || Pe) && (be(vn) ? (rt = ee.addModifier(rt, vn, "blocked-out-of-range"), $n = !0) : rt = ee.deleteModifier(rt, vn, "blocked-out-of-range")), (Ht || et) && (Ae(vn) ? (rt = ee.addModifier(rt, vn, "blocked-calendar"), $n = !0) : rt = ee.deleteModifier(rt, vn, "blocked-calendar")), $n ? rt = ee.addModifier(rt, vn, "blocked") : rt = ee.deleteModifier(rt, vn, "blocked"), (Ht || gt) && (He(vn) ? rt = ee.addModifier(rt, vn, "highlighted-calendar") : rt = ee.deleteModifier(rt, vn, "highlighted-calendar"));
          });
        }), !this.isTouchDevice && Ht && Ee && !this.isBlocked(Ee)) {
          var tn = ge(Ee);
          tn > 0 && Se === W.END_DATE && (rt = this.deleteModifierFromRange(rt, Ee.clone().add(1, "days"), Ee.clone().add(tn, "days"), "hovered-start-blocked-minimum-nights"), rt = this.deleteModifier(rt, Ee.clone().add(tn, "days"), "hovered-start-first-possible-end")), tn > 0 && Se === W.START_DATE && (rt = this.addModifierToRange(rt, Ee.clone().add(1, "days"), Ee.clone().add(tn, "days"), "hovered-start-blocked-minimum-nights"), rt = this.addModifier(rt, Ee.clone().add(tn, "days"), "hovered-start-first-possible-end"));
        }
        te > 0 && j && Se === W.END_DATE && (rt = this.addModifierToRange(rt, j, j.clone().add(te, "days"), "blocked-minimum-nights"), rt = this.addModifierToRange(rt, j, j.clone().add(te, "days"), "blocked"));
        var qt = (0, u.default)();
        if ((0, b.default)(this.today, qt) || (rt = this.deleteModifier(rt, this.today, "today"), rt = this.addModifier(rt, qt, "today"), this.today = qt), Object.keys(rt).length > 0 && this.setState({
          visibleDays: T({}, Me, {}, rt)
        }), Ht || de !== Ze) {
          var Kt = ae(de, Se);
          this.setState({
            phrases: T({}, de, {
              chooseAvailableDate: Kt
            })
          });
        }
      }, le.onDayClick = function(B, ee) {
        var j = this.props, he = j.keepOpenOnDateSelect, Se = j.minimumNights, ge = j.onBlur, te = j.focusedInput, be = j.onFocusChange, Ae = j.onClose, He = j.onDatesChange, de = j.startDateOffset, ce = j.endDateOffset, ie = j.disabled, H = j.daysViolatingMinNightsCanBeClicked;
        if (ee && ee.preventDefault(), !this.isBlocked(B, !H)) {
          var Y = this.props, Z = Y.startDate, Q = Y.endDate;
          if (de || ce) {
            if (Z = (0, E.default)(de, B), Q = (0, E.default)(ce, B), this.isBlocked(Z) || this.isBlocked(Q))
              return;
            He({
              startDate: Z,
              endDate: Q
            }), he || (be(null), Ae({
              startDate: Z,
              endDate: Q
            }));
          } else if (te === W.START_DATE) {
            var me = Q && Q.clone().subtract(Se, "days"), Le = (0, y.default)(me, B) || (0, w.default)(Z, Q), xe = ie === W.END_DATE;
            (!xe || !Le) && (Z = B, Le && (Q = null)), He({
              startDate: Z,
              endDate: Q
            }), xe && !Le ? (be(null), Ae({
              startDate: Z,
              endDate: Q
            })) : xe || be(W.END_DATE);
          } else if (te === W.END_DATE) {
            var Ue = Z && Z.clone().add(Se, "days");
            Z ? (0, m.default)(B, Ue) ? (Q = B, He({
              startDate: Z,
              endDate: Q
            }), he || (be(null), Ae({
              startDate: Z,
              endDate: Q
            }))) : H && this.doesNotMeetMinimumNights(B) ? (Q = B, He({
              startDate: Z,
              endDate: Q
            })) : ie !== W.START_DATE ? (Z = B, Q = null, He({
              startDate: Z,
              endDate: Q
            })) : He({
              startDate: Z,
              endDate: Q
            }) : (Q = B, He({
              startDate: Z,
              endDate: Q
            }), be(W.START_DATE));
          } else
            He({
              startDate: Z,
              endDate: Q
            });
          ge();
        }
      }, le.onDayMouseEnter = function(B) {
        if (!this.isTouchDevice) {
          var ee = this.props, j = ee.startDate, he = ee.endDate, Se = ee.focusedInput, ge = ee.getMinNightsForHoverDate, te = ee.minimumNights, be = ee.startDateOffset, Ae = ee.endDateOffset, He = this.state, de = He.hoverDate, ce = He.visibleDays, ie = He.dateOffset, H = null;
          if (Se) {
            var Y = be || Ae, Z = {};
            if (Y) {
              var Q = (0, E.default)(be, B), me = (0, E.default)(Ae, B, function(Pe) {
                return Pe.add(1, "day");
              });
              H = {
                start: Q,
                end: me
              }, ie && ie.start && ie.end && (Z = this.deleteModifierFromRange(Z, ie.start, ie.end, "hovered-offset")), Z = this.addModifierToRange(Z, Q, me, "hovered-offset");
            }
            if (!Y) {
              if (Z = this.deleteModifier(Z, de, "hovered"), Z = this.addModifier(Z, B, "hovered"), j && !he && Se === W.END_DATE) {
                if ((0, w.default)(de, j)) {
                  var Le = de.clone().add(1, "day");
                  Z = this.deleteModifierFromRange(Z, j, Le, "hovered-span");
                }
                if (((0, y.default)(B, j) || (0, b.default)(B, j)) && (Z = this.deleteModifier(Z, j, "selected-start-in-hovered-span")), !this.isBlocked(B) && (0, w.default)(B, j)) {
                  var xe = B.clone().add(1, "day");
                  Z = this.addModifierToRange(Z, j, xe, "hovered-span"), Z = this.addModifier(Z, j, "selected-start-in-hovered-span");
                }
              }
              if (!j && he && Se === W.START_DATE && ((0, y.default)(de, he) && (Z = this.deleteModifierFromRange(Z, de, he, "hovered-span")), ((0, w.default)(B, he) || (0, b.default)(B, he)) && (Z = this.deleteModifier(Z, he, "selected-end-in-hovered-span")), !this.isBlocked(B) && (0, y.default)(B, he) && (Z = this.addModifierToRange(Z, B, he, "hovered-span"), Z = this.addModifier(Z, he, "selected-end-in-hovered-span"))), j) {
                var Ue = j.clone().add(1, "day"), je = j.clone().add(te + 1, "days");
                if (Z = this.deleteModifierFromRange(Z, Ue, je, "after-hovered-start"), (0, b.default)(B, j)) {
                  var Ze = j.clone().add(1, "day"), _e = j.clone().add(te + 1, "days");
                  Z = this.addModifierToRange(Z, Ze, _e, "after-hovered-start");
                }
              }
              if (he) {
                var U = he.clone().subtract(te, "days");
                if (Z = this.deleteModifierFromRange(Z, U, he, "before-hovered-end"), (0, b.default)(B, he)) {
                  var fe = he.clone().subtract(te, "days");
                  Z = this.addModifierToRange(Z, fe, he, "before-hovered-end");
                }
              }
              if (de && !this.isBlocked(de)) {
                var Ee = ge(de);
                Ee > 0 && Se === W.START_DATE && (Z = this.deleteModifierFromRange(Z, de.clone().add(1, "days"), de.clone().add(Ee, "days"), "hovered-start-blocked-minimum-nights"), Z = this.deleteModifier(Z, de.clone().add(Ee, "days"), "hovered-start-first-possible-end"));
              }
              if (!this.isBlocked(B)) {
                var Me = ge(B);
                Me > 0 && Se === W.START_DATE && (Z = this.addModifierToRange(Z, B.clone().add(1, "days"), B.clone().add(Me, "days"), "hovered-start-blocked-minimum-nights"), Z = this.addModifier(Z, B.clone().add(Me, "days"), "hovered-start-first-possible-end"));
              }
            }
            this.setState({
              hoverDate: B,
              dateOffset: H,
              visibleDays: T({}, ce, {}, Z)
            });
          }
        }
      }, le.onDayMouseLeave = function(B) {
        var ee = this.props, j = ee.startDate, he = ee.endDate, Se = ee.focusedInput, ge = ee.getMinNightsForHoverDate, te = ee.minimumNights, be = this.state, Ae = be.hoverDate, He = be.visibleDays, de = be.dateOffset;
        if (!(this.isTouchDevice || !Ae)) {
          var ce = {};
          if (ce = this.deleteModifier(ce, Ae, "hovered"), de && (ce = this.deleteModifierFromRange(ce, de.start, de.end, "hovered-offset")), j && !he) {
            if ((0, w.default)(Ae, j)) {
              var ie = Ae.clone().add(1, "day");
              ce = this.deleteModifierFromRange(ce, j, ie, "hovered-span");
            }
            (0, w.default)(B, j) && (ce = this.deleteModifier(ce, j, "selected-start-in-hovered-span"));
          }
          if (!j && he && ((0, w.default)(he, Ae) && (ce = this.deleteModifierFromRange(ce, Ae, he, "hovered-span")), (0, y.default)(B, he) && (ce = this.deleteModifier(ce, he, "selected-end-in-hovered-span"))), j && (0, b.default)(B, j)) {
            var H = j.clone().add(1, "day"), Y = j.clone().add(te + 1, "days");
            ce = this.deleteModifierFromRange(ce, H, Y, "after-hovered-start");
          }
          if (he && (0, b.default)(B, he)) {
            var Z = he.clone().subtract(te, "days");
            ce = this.deleteModifierFromRange(ce, Z, he, "before-hovered-end");
          }
          if (!this.isBlocked(Ae)) {
            var Q = ge(Ae);
            Q > 0 && Se === W.START_DATE && (ce = this.deleteModifierFromRange(ce, Ae.clone().add(1, "days"), Ae.clone().add(Q, "days"), "hovered-start-blocked-minimum-nights"), ce = this.deleteModifier(ce, Ae.clone().add(Q, "days"), "hovered-start-first-possible-end"));
          }
          this.setState({
            hoverDate: null,
            visibleDays: T({}, He, {}, ce)
          });
        }
      }, le.onPrevMonthClick = function() {
        var B = this.props, ee = B.enableOutsideDays, j = B.maxDate, he = B.minDate, Se = B.numberOfMonths, ge = B.onPrevMonthClick, te = this.state, be = te.currentMonth, Ae = te.visibleDays, He = {};
        Object.keys(Ae).sort().slice(0, Se + 1).forEach(function(H) {
          He[H] = Ae[H];
        });
        var de = be.clone().subtract(2, "months"), ce = (0, x.default)(de, 1, ee, !0), ie = be.clone().subtract(1, "month");
        this.setState({
          currentMonth: ie,
          disablePrev: this.shouldDisableMonthNavigation(he, ie),
          disableNext: this.shouldDisableMonthNavigation(j, ie),
          visibleDays: T({}, He, {}, this.getModifiers(ce))
        }, function() {
          ge(ie.clone());
        });
      }, le.onNextMonthClick = function() {
        var B = this.props, ee = B.enableOutsideDays, j = B.maxDate, he = B.minDate, Se = B.numberOfMonths, ge = B.onNextMonthClick, te = this.state, be = te.currentMonth, Ae = te.visibleDays, He = {};
        Object.keys(Ae).sort().slice(1).forEach(function(H) {
          He[H] = Ae[H];
        });
        var de = be.clone().add(Se + 1, "month"), ce = (0, x.default)(de, 1, ee, !0), ie = be.clone().add(1, "month");
        this.setState({
          currentMonth: ie,
          disablePrev: this.shouldDisableMonthNavigation(he, ie),
          disableNext: this.shouldDisableMonthNavigation(j, ie),
          visibleDays: T({}, He, {}, this.getModifiers(ce))
        }, function() {
          ge(ie.clone());
        });
      }, le.onMonthChange = function(B) {
        var ee = this.props, j = ee.numberOfMonths, he = ee.enableOutsideDays, Se = ee.orientation, ge = Se === W.VERTICAL_SCROLLABLE, te = (0, x.default)(B, j, he, ge);
        this.setState({
          currentMonth: B.clone(),
          visibleDays: this.getModifiers(te)
        });
      }, le.onYearChange = function(B) {
        var ee = this.props, j = ee.numberOfMonths, he = ee.enableOutsideDays, Se = ee.orientation, ge = Se === W.VERTICAL_SCROLLABLE, te = (0, x.default)(B, j, he, ge);
        this.setState({
          currentMonth: B.clone(),
          visibleDays: this.getModifiers(te)
        });
      }, le.onGetNextScrollableMonths = function() {
        var B = this.props, ee = B.numberOfMonths, j = B.enableOutsideDays, he = this.state, Se = he.currentMonth, ge = he.visibleDays, te = Object.keys(ge).length, be = Se.clone().add(te, "month"), Ae = (0, x.default)(be, ee, j, !0);
        this.setState({
          visibleDays: T({}, ge, {}, this.getModifiers(Ae))
        });
      }, le.onGetPrevScrollableMonths = function() {
        var B = this.props, ee = B.numberOfMonths, j = B.enableOutsideDays, he = this.state, Se = he.currentMonth, ge = he.visibleDays, te = Se.clone().subtract(ee, "month"), be = (0, x.default)(te, ee, j, !0);
        this.setState({
          currentMonth: te.clone(),
          visibleDays: T({}, ge, {}, this.getModifiers(be))
        });
      }, le.getFirstFocusableDay = function(B) {
        var ee = this, j = this.props, he = j.startDate, Se = j.endDate, ge = j.focusedInput, te = j.minimumNights, be = j.numberOfMonths, Ae = B.clone().startOf("month");
        if (ge === W.START_DATE && he ? Ae = he.clone() : ge === W.END_DATE && !Se && he ? Ae = he.clone().add(te, "days") : ge === W.END_DATE && Se && (Ae = Se.clone()), this.isBlocked(Ae)) {
          for (var He = [], de = B.clone().add(be - 1, "months").endOf("month"), ce = Ae.clone(); !(0, w.default)(ce, de); )
            ce = ce.clone().add(1, "day"), He.push(ce);
          var ie = He.filter(function(Y) {
            return !ee.isBlocked(Y);
          });
          if (ie.length > 0) {
            var H = (0, n.default)(ie, 1);
            Ae = H[0];
          }
        }
        return Ae;
      }, le.getModifiers = function(B) {
        var ee = this, j = {};
        return Object.keys(B).forEach(function(he) {
          j[he] = {}, B[he].forEach(function(Se) {
            j[he][(0, L.default)(Se)] = ee.getModifiersForDay(Se);
          });
        }), j;
      }, le.getModifiersForDay = function(B) {
        var ee = this;
        return new Set(Object.keys(this.modifiers).filter(function(j) {
          return ee.modifiers[j](B);
        }));
      }, le.getStateForNewMonth = function(B) {
        var ee = this, j = B.initialVisibleMonth, he = B.numberOfMonths, Se = B.enableOutsideDays, ge = B.orientation, te = B.startDate, be = j || (te ? function() {
          return te;
        } : function() {
          return ee.today;
        }), Ae = be(), He = ge === W.VERTICAL_SCROLLABLE, de = this.getModifiers((0, x.default)(Ae, he, Se, He));
        return {
          currentMonth: Ae,
          visibleDays: de
        };
      }, le.shouldDisableMonthNavigation = function(B, ee) {
        if (!B) return !1;
        var j = this.props, he = j.numberOfMonths, Se = j.enableOutsideDays;
        return (0, D.default)(B, ee, he, Se);
      }, le.addModifier = function(B, ee, j) {
        return (0, k.addModifier)(B, ee, j, this.props, this.state);
      }, le.addModifierToRange = function(B, ee, j, he) {
        for (var Se = B, ge = ee.clone(); (0, y.default)(ge, j); )
          Se = this.addModifier(Se, ge, he), ge = ge.clone().add(1, "day");
        return Se;
      }, le.deleteModifier = function(B, ee, j) {
        return (0, k.deleteModifier)(B, ee, j, this.props, this.state);
      }, le.deleteModifierFromRange = function(B, ee, j, he) {
        for (var Se = B, ge = ee.clone(); (0, y.default)(ge, j); )
          Se = this.deleteModifier(Se, ge, he), ge = ge.clone().add(1, "day");
        return Se;
      }, le.doesNotMeetMinimumNights = function(B) {
        var ee = this.props, j = ee.startDate, he = ee.isOutsideRange, Se = ee.focusedInput, ge = ee.minimumNights;
        if (Se !== W.END_DATE) return !1;
        if (j) {
          var te = B.diff(j.clone().startOf("day").hour(12), "days");
          return te < ge && te >= 0;
        }
        return he((0, u.default)(B).subtract(ge, "days"));
      }, le.doesNotMeetMinNightsForHoveredStartDate = function(B, ee) {
        var j = this.props, he = j.focusedInput, Se = j.getMinNightsForHoverDate;
        if (he !== W.END_DATE) return !1;
        if (ee && !this.isBlocked(ee)) {
          var ge = Se(ee), te = B.diff(ee.clone().startOf("day").hour(12), "days");
          return te < ge && te >= 0;
        }
        return !1;
      }, le.isDayAfterHoveredStartDate = function(B) {
        var ee = this.props, j = ee.startDate, he = ee.endDate, Se = ee.minimumNights, ge = this.state || {}, te = ge.hoverDate;
        return !!j && !he && !this.isBlocked(B) && (0, _.default)(te, B) && Se > 0 && (0, b.default)(te, j);
      }, le.isEndDate = function(B) {
        var ee = this.props.endDate;
        return (0, b.default)(B, ee);
      }, le.isHovered = function(B) {
        var ee = this.state || {}, j = ee.hoverDate, he = this.props.focusedInput;
        return !!he && (0, b.default)(B, j);
      }, le.isInHoveredSpan = function(B) {
        var ee = this.props, j = ee.startDate, he = ee.endDate, Se = this.state || {}, ge = Se.hoverDate, te = !!j && !he && (B.isBetween(j, ge) || (0, b.default)(ge, B)), be = !!he && !j && (B.isBetween(ge, he) || (0, b.default)(ge, B)), Ae = ge && !this.isBlocked(ge);
        return (te || be) && Ae;
      }, le.isInSelectedSpan = function(B) {
        var ee = this.props, j = ee.startDate, he = ee.endDate;
        return B.isBetween(j, he, "days");
      }, le.isLastInRange = function(B) {
        var ee = this.props.endDate;
        return this.isInSelectedSpan(B) && (0, _.default)(B, ee);
      }, le.isStartDate = function(B) {
        var ee = this.props.startDate;
        return (0, b.default)(B, ee);
      }, le.isBlocked = function(B) {
        var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, j = this.props, he = j.isDayBlocked, Se = j.isOutsideRange;
        return he(B) || Se(B) || ee && this.doesNotMeetMinimumNights(B);
      }, le.isToday = function(B) {
        return (0, b.default)(B, this.today);
      }, le.isFirstDayOfWeek = function(B) {
        var ee = this.props.firstDayOfWeek;
        return B.day() === (ee || u.default.localeData().firstDayOfWeek());
      }, le.isLastDayOfWeek = function(B) {
        var ee = this.props.firstDayOfWeek;
        return B.day() === ((ee || u.default.localeData().firstDayOfWeek()) + 6) % 7;
      }, le.isFirstPossibleEndDateForHoveredStartDate = function(B, ee) {
        var j = this.props, he = j.focusedInput, Se = j.getMinNightsForHoverDate;
        if (he !== W.END_DATE || !ee || this.isBlocked(ee)) return !1;
        var ge = Se(ee), te = ee.clone().add(ge, "days");
        return (0, b.default)(B, te);
      }, le.beforeSelectedEnd = function(B) {
        var ee = this.props.endDate;
        return (0, y.default)(B, ee);
      }, le.isDayBeforeHoveredEndDate = function(B) {
        var ee = this.props, j = ee.startDate, he = ee.endDate, Se = ee.minimumNights, ge = this.state || {}, te = ge.hoverDate;
        return !!he && !j && !this.isBlocked(B) && (0, S.default)(te, B) && Se > 0 && (0, b.default)(te, he);
      }, le.render = function() {
        var B = this.props, ee = B.numberOfMonths, j = B.orientation, he = B.monthFormat, Se = B.renderMonthText, ge = B.renderWeekHeaderElement, te = B.dayPickerNavigationInlineStyles, be = B.navPosition, Ae = B.navPrev, He = B.navNext, de = B.renderNavPrevButton, ce = B.renderNavNextButton, ie = B.noNavButtons, H = B.noNavNextButton, Y = B.noNavPrevButton, Z = B.onOutsideClick, Q = B.withPortal, me = B.enableOutsideDays, Le = B.firstDayOfWeek, xe = B.renderKeyboardShortcutsButton, Ue = B.renderKeyboardShortcutsPanel, je = B.hideKeyboardShortcutsPanel, Ze = B.daySize, _e = B.focusedInput, U = B.renderCalendarDay, fe = B.renderDayContents, Ee = B.renderCalendarInfo, Me = B.renderMonthElement, Pe = B.calendarInfoPosition, et = B.onBlur, gt = B.onShiftTab, Vt = B.onTab, Zt = B.isFocused, St = B.showKeyboardShortcuts, Ht = B.isRTL, fn = B.weekDayFormat, xn = B.dayAriaLabelFormat, rt = B.verticalHeight, Ei = B.noBorder, Nn = B.transitionDuration, Gi = B.verticalBorderSpacing, Ce = B.horizontalMonthPadding, Xe = this.state, nt = Xe.currentMonth, At = Xe.phrases, tn = Xe.visibleDays, qt = Xe.disablePrev, Kt = Xe.disableNext;
        return a.default.createElement(F.default, {
          orientation: j,
          enableOutsideDays: me,
          modifiers: tn,
          numberOfMonths: ee,
          onDayClick: this.onDayClick,
          onDayMouseEnter: this.onDayMouseEnter,
          onDayMouseLeave: this.onDayMouseLeave,
          onPrevMonthClick: this.onPrevMonthClick,
          onNextMonthClick: this.onNextMonthClick,
          onMonthChange: this.onMonthChange,
          onTab: Vt,
          onShiftTab: gt,
          onYearChange: this.onYearChange,
          onGetNextScrollableMonths: this.onGetNextScrollableMonths,
          onGetPrevScrollableMonths: this.onGetPrevScrollableMonths,
          monthFormat: he,
          renderMonthText: Se,
          renderWeekHeaderElement: ge,
          withPortal: Q,
          hidden: !_e,
          initialVisibleMonth: function() {
            return nt;
          },
          daySize: Ze,
          onOutsideClick: Z,
          disablePrev: qt,
          disableNext: Kt,
          dayPickerNavigationInlineStyles: te,
          navPosition: be,
          navPrev: Ae,
          navNext: He,
          renderNavPrevButton: de,
          renderNavNextButton: ce,
          noNavButtons: ie,
          noNavPrevButton: Y,
          noNavNextButton: H,
          renderCalendarDay: U,
          renderDayContents: fe,
          renderCalendarInfo: Ee,
          renderMonthElement: Me,
          renderKeyboardShortcutsButton: xe,
          renderKeyboardShortcutsPanel: Ue,
          calendarInfoPosition: Pe,
          firstDayOfWeek: Le,
          hideKeyboardShortcutsPanel: je,
          isFocused: Zt,
          getFirstFocusableDay: this.getFirstFocusableDay,
          onBlur: et,
          showKeyboardShortcuts: St,
          phrases: At,
          isRTL: Ht,
          weekDayFormat: fn,
          dayAriaLabelFormat: xn,
          verticalHeight: rt,
          verticalBorderSpacing: Gi,
          noBorder: Ei,
          transitionDuration: Nn,
          horizontalMonthPadding: Ce
        });
      }, oe;
    }(a.default.PureComponent || a.default.Component);
    i.default = ue, ue.propTypes = process.env.NODE_ENV !== "production" ? z : {}, ue.defaultProps = X;
  }(MO)), MO;
}
var foe;
function sut() {
  return foe || (foe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = i.PureDateRangePicker = void 0;
    var t = e(ua()), n = e(ha()), r = e(Pl()), s = e(fa()), o = e(hs()), a = e(it), l = e(gi), c = Za(), d = pbe, u = Or(), h = uk, f = e(Rb()), g = e(_q()), p = e(ybe()), m = So(), _ = e(wbe()), b = e(Sbe()), w = e(bq()), y = e(Vb()), S = e(xbe()), x = e(Cp()), D = e(Pbe()), E = e(Vbe()), L = e(gx()), k = mi();
    function N(W, F) {
      var q = Object.keys(W);
      if (Object.getOwnPropertySymbols) {
        var R = Object.getOwnPropertySymbols(W);
        F && (R = R.filter(function(T) {
          return Object.getOwnPropertyDescriptor(W, T).enumerable;
        })), q.push.apply(q, R);
      }
      return q;
    }
    function I(W) {
      for (var F = 1; F < arguments.length; F++) {
        var q = arguments[F] != null ? arguments[F] : {};
        F % 2 ? N(Object(q), !0).forEach(function(R) {
          (0, o.default)(W, R, q[R]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(W, Object.getOwnPropertyDescriptors(q)) : N(Object(q)).forEach(function(R) {
          Object.defineProperty(W, R, Object.getOwnPropertyDescriptor(q, R));
        });
      }
      return W;
    }
    var A = process.env.NODE_ENV !== "production" ? (0, u.forbidExtraProps)(I({}, c.withStylesPropTypes, {}, p.default)) : {}, P = {
      // required props for a functional interactive DateRangePicker
      startDate: null,
      endDate: null,
      focusedInput: null,
      // input related props
      startDatePlaceholderText: "Start Date",
      endDatePlaceholderText: "End Date",
      startDateAriaLabel: void 0,
      endDateAriaLabel: void 0,
      startDateOffset: void 0,
      endDateOffset: void 0,
      disabled: !1,
      required: !1,
      readOnly: !1,
      screenReaderInputMessage: "",
      showClearDates: !1,
      showDefaultInputIcon: !1,
      inputIconPosition: k.ICON_BEFORE_POSITION,
      customInputIcon: null,
      customArrowIcon: null,
      customCloseIcon: null,
      noBorder: !1,
      block: !1,
      small: !1,
      regular: !1,
      keepFocusOnInput: !1,
      // calendar presentation and interaction related props
      renderMonthText: null,
      renderWeekHeaderElement: null,
      orientation: k.HORIZONTAL_ORIENTATION,
      anchorDirection: k.ANCHOR_LEFT,
      openDirection: k.OPEN_DOWN,
      horizontalMargin: 0,
      withPortal: !1,
      withFullScreenPortal: !1,
      appendToBody: !1,
      disableScroll: !1,
      initialVisibleMonth: null,
      numberOfMonths: 2,
      keepOpenOnDateSelect: !1,
      reopenPickerOnClearDates: !1,
      renderCalendarInfo: null,
      calendarInfoPosition: k.INFO_POSITION_BOTTOM,
      hideKeyboardShortcutsPanel: !1,
      daySize: k.DAY_SIZE,
      isRTL: !1,
      firstDayOfWeek: null,
      verticalHeight: null,
      transitionDuration: void 0,
      verticalSpacing: k.DEFAULT_VERTICAL_SPACING,
      horizontalMonthPadding: void 0,
      // navigation related props
      dayPickerNavigationInlineStyles: null,
      navPosition: k.NAV_POSITION_TOP,
      navPrev: null,
      navNext: null,
      renderNavPrevButton: null,
      renderNavNextButton: null,
      onPrevMonthClick: function() {
      },
      onNextMonthClick: function() {
      },
      onClose: function() {
      },
      // day presentation and interaction related props
      renderCalendarDay: void 0,
      renderDayContents: null,
      renderMonthElement: null,
      minimumNights: 1,
      enableOutsideDays: !1,
      isDayBlocked: function() {
        return !1;
      },
      isOutsideRange: function(F) {
        return !(0, y.default)(F, (0, l.default)());
      },
      isDayHighlighted: function() {
        return !1;
      },
      minDate: void 0,
      maxDate: void 0,
      // internationalization
      displayFormat: function() {
        return l.default.localeData().longDateFormat("L");
      },
      monthFormat: "MMMM YYYY",
      weekDayFormat: "dd",
      phrases: m.DateRangePickerPhrases,
      dayAriaLabelFormat: void 0
    }, O = /* @__PURE__ */ function(W) {
      (0, s.default)(q, W);
      var F = q.prototype;
      F[!a.default.PureComponent && "shouldComponentUpdate"] = function(R, T) {
        return !(0, t.default)(this.props, R) || !(0, t.default)(this.state, T);
      };
      function q(R) {
        var T;
        return T = W.call(this, R) || this, T.state = {
          dayPickerContainerStyles: {},
          isDateRangePickerInputFocused: !1,
          isDayPickerFocused: !1,
          showKeyboardShortcuts: !1
        }, T.isTouchDevice = !1, T.onOutsideClick = T.onOutsideClick.bind((0, r.default)(T)), T.onDateRangePickerInputFocus = T.onDateRangePickerInputFocus.bind((0, r.default)(T)), T.onDayPickerFocus = T.onDayPickerFocus.bind((0, r.default)(T)), T.onDayPickerFocusOut = T.onDayPickerFocusOut.bind((0, r.default)(T)), T.onDayPickerBlur = T.onDayPickerBlur.bind((0, r.default)(T)), T.showKeyboardShortcutsPanel = T.showKeyboardShortcutsPanel.bind((0, r.default)(T)), T.responsivizePickerPosition = T.responsivizePickerPosition.bind((0, r.default)(T)), T.disableScroll = T.disableScroll.bind((0, r.default)(T)), T.setDayPickerContainerRef = T.setDayPickerContainerRef.bind((0, r.default)(T)), T.setContainerRef = T.setContainerRef.bind((0, r.default)(T)), T;
      }
      return F.componentDidMount = function() {
        this.removeEventListener = (0, h.addEventListener)(window, "resize", this.responsivizePickerPosition, {
          passive: !0
        }), this.responsivizePickerPosition(), this.disableScroll();
        var T = this.props.focusedInput;
        T && this.setState({
          isDateRangePickerInputFocused: !0
        }), this.isTouchDevice = (0, f.default)();
      }, F.componentDidUpdate = function(T) {
        var z = this.props.focusedInput;
        !T.focusedInput && z && this.isOpened() ? (this.responsivizePickerPosition(), this.disableScroll()) : T.focusedInput && !z && !this.isOpened() && this.enableScroll && this.enableScroll();
      }, F.componentWillUnmount = function() {
        this.removeDayPickerEventListeners(), this.removeEventListener && this.removeEventListener(), this.enableScroll && this.enableScroll();
      }, F.onOutsideClick = function(T) {
        var z = this.props, X = z.onFocusChange, ae = z.onClose, ue = z.startDate, se = z.endDate, le = z.appendToBody;
        this.isOpened() && (le && this.dayPickerContainer.contains(T.target) || (this.setState({
          isDateRangePickerInputFocused: !1,
          isDayPickerFocused: !1,
          showKeyboardShortcuts: !1
        }), X(null), ae({
          startDate: ue,
          endDate: se
        })));
      }, F.onDateRangePickerInputFocus = function(T) {
        var z = this.props, X = z.onFocusChange, ae = z.readOnly, ue = z.withPortal, se = z.withFullScreenPortal, le = z.keepFocusOnInput;
        if (T) {
          var oe = ue || se, re = oe || ae && !le || this.isTouchDevice && !le;
          re ? this.onDayPickerFocus() : this.onDayPickerBlur();
        }
        X(T);
      }, F.onDayPickerFocus = function() {
        var T = this.props, z = T.focusedInput, X = T.onFocusChange;
        z || X(k.START_DATE), this.setState({
          isDateRangePickerInputFocused: !1,
          isDayPickerFocused: !0,
          showKeyboardShortcuts: !1
        });
      }, F.onDayPickerFocusOut = function(T) {
        var z = T.relatedTarget === document.body ? T.target : T.relatedTarget || T.target;
        this.dayPickerContainer.contains(z) || this.onOutsideClick(T);
      }, F.onDayPickerBlur = function() {
        this.setState({
          isDateRangePickerInputFocused: !0,
          isDayPickerFocused: !1,
          showKeyboardShortcuts: !1
        });
      }, F.setDayPickerContainerRef = function(T) {
        T !== this.dayPickerContainer && (this.dayPickerContainer && this.removeDayPickerEventListeners(), this.dayPickerContainer = T, T && this.addDayPickerEventListeners());
      }, F.setContainerRef = function(T) {
        this.container = T;
      }, F.addDayPickerEventListeners = function() {
        this.removeDayPickerFocusOut = (0, h.addEventListener)(this.dayPickerContainer, "focusout", this.onDayPickerFocusOut);
      }, F.removeDayPickerEventListeners = function() {
        this.removeDayPickerFocusOut && this.removeDayPickerFocusOut();
      }, F.isOpened = function() {
        var T = this.props.focusedInput;
        return T === k.START_DATE || T === k.END_DATE;
      }, F.disableScroll = function() {
        var T = this.props, z = T.appendToBody, X = T.disableScroll;
        !z && !X || this.isOpened() && (this.enableScroll = (0, S.default)(this.container));
      }, F.responsivizePickerPosition = function() {
        var T = this.state.dayPickerContainerStyles;
        if (Object.keys(T).length > 0 && this.setState({
          dayPickerContainerStyles: {}
        }), !!this.isOpened()) {
          var z = this.props, X = z.openDirection, ae = z.anchorDirection, ue = z.horizontalMargin, se = z.withPortal, le = z.withFullScreenPortal, oe = z.appendToBody, re = ae === k.ANCHOR_LEFT;
          if (!se && !le) {
            var B = this.dayPickerContainer.getBoundingClientRect(), ee = T[ae] || 0, j = re ? B[k.ANCHOR_RIGHT] : B[k.ANCHOR_LEFT];
            this.setState({
              dayPickerContainerStyles: I({}, (0, _.default)(ae, ee, j, ue), {}, oe && (0, b.default)(X, ae, this.container))
            });
          }
        }
      }, F.showKeyboardShortcutsPanel = function() {
        this.setState({
          isDateRangePickerInputFocused: !1,
          isDayPickerFocused: !0,
          showKeyboardShortcuts: !0
        });
      }, F.maybeRenderDayPickerWithPortal = function() {
        var T = this.props, z = T.withPortal, X = T.withFullScreenPortal, ae = T.appendToBody;
        return this.isOpened() ? z || X || ae ? a.default.createElement(d.Portal, null, this.renderDayPicker()) : this.renderDayPicker() : null;
      }, F.renderDayPicker = function() {
        var T = this.props, z = T.anchorDirection, X = T.openDirection, ae = T.isDayBlocked, ue = T.isDayHighlighted, se = T.isOutsideRange, le = T.numberOfMonths, oe = T.orientation, re = T.monthFormat, B = T.renderMonthText, ee = T.renderWeekHeaderElement, j = T.dayPickerNavigationInlineStyles, he = T.navPosition, Se = T.navPrev, ge = T.navNext, te = T.renderNavPrevButton, be = T.renderNavNextButton, Ae = T.onPrevMonthClick, He = T.onNextMonthClick, de = T.onDatesChange, ce = T.onFocusChange, ie = T.withPortal, H = T.withFullScreenPortal, Y = T.daySize, Z = T.enableOutsideDays, Q = T.focusedInput, me = T.startDate, Le = T.startDateOffset, xe = T.endDate, Ue = T.endDateOffset, je = T.minDate, Ze = T.maxDate, _e = T.minimumNights, U = T.keepOpenOnDateSelect, fe = T.renderCalendarDay, Ee = T.renderDayContents, Me = T.renderCalendarInfo, Pe = T.renderMonthElement, et = T.calendarInfoPosition, gt = T.firstDayOfWeek, Vt = T.initialVisibleMonth, Zt = T.hideKeyboardShortcutsPanel, St = T.customCloseIcon, Ht = T.onClose, fn = T.phrases, xn = T.dayAriaLabelFormat, rt = T.isRTL, Ei = T.weekDayFormat, Nn = T.styles, Gi = T.verticalHeight, Ce = T.transitionDuration, Xe = T.verticalSpacing, nt = T.horizontalMonthPadding, At = T.small, tn = T.disabled, qt = T.theme.reactDates, Kt = this.state, Pt = Kt.dayPickerContainerStyles, _i = Kt.isDayPickerFocused, vn = Kt.showKeyboardShortcuts, $n = !H && ie ? this.onOutsideClick : void 0, mt = Vt || function() {
          return me || xe || (0, l.default)();
        }, De = St || a.default.createElement(L.default, (0, c.css)(Nn.DateRangePicker_closeButton_svg)), Qe = (0, w.default)(qt, At), ct = ie || H;
        return a.default.createElement("div", (0, n.default)({
          ref: this.setDayPickerContainerRef
        }, (0, c.css)(Nn.DateRangePicker_picker, z === k.ANCHOR_LEFT && Nn.DateRangePicker_picker__directionLeft, z === k.ANCHOR_RIGHT && Nn.DateRangePicker_picker__directionRight, oe === k.HORIZONTAL_ORIENTATION && Nn.DateRangePicker_picker__horizontal, oe === k.VERTICAL_ORIENTATION && Nn.DateRangePicker_picker__vertical, !ct && X === k.OPEN_DOWN && {
          top: Qe + Xe
        }, !ct && X === k.OPEN_UP && {
          bottom: Qe + Xe
        }, ct && Nn.DateRangePicker_picker__portal, H && Nn.DateRangePicker_picker__fullScreenPortal, rt && Nn.DateRangePicker_picker__rtl, Pt), {
          onClick: $n
        }), a.default.createElement(E.default, {
          orientation: oe,
          enableOutsideDays: Z,
          numberOfMonths: le,
          onPrevMonthClick: Ae,
          onNextMonthClick: He,
          onDatesChange: de,
          onFocusChange: ce,
          onClose: Ht,
          focusedInput: Q,
          startDate: me,
          startDateOffset: Le,
          endDate: xe,
          endDateOffset: Ue,
          minDate: je,
          maxDate: Ze,
          monthFormat: re,
          renderMonthText: B,
          renderWeekHeaderElement: ee,
          withPortal: ct,
          daySize: Y,
          initialVisibleMonth: mt,
          hideKeyboardShortcutsPanel: Zt,
          dayPickerNavigationInlineStyles: j,
          navPosition: he,
          navPrev: Se,
          navNext: ge,
          renderNavPrevButton: te,
          renderNavNextButton: be,
          minimumNights: _e,
          isOutsideRange: se,
          isDayHighlighted: ue,
          isDayBlocked: ae,
          keepOpenOnDateSelect: U,
          renderCalendarDay: fe,
          renderDayContents: Ee,
          renderCalendarInfo: Me,
          renderMonthElement: Pe,
          calendarInfoPosition: et,
          isFocused: _i,
          showKeyboardShortcuts: vn,
          onBlur: this.onDayPickerBlur,
          phrases: fn,
          dayAriaLabelFormat: xn,
          isRTL: rt,
          firstDayOfWeek: gt,
          weekDayFormat: Ei,
          verticalHeight: Gi,
          transitionDuration: Ce,
          disabled: tn,
          horizontalMonthPadding: nt
        }), H && a.default.createElement("button", (0, n.default)({}, (0, c.css)(Nn.DateRangePicker_closeButton), {
          type: "button",
          onClick: this.onOutsideClick,
          "aria-label": fn.closeDatePicker
        }), De));
      }, F.render = function() {
        var T = this.props, z = T.startDate, X = T.startDateId, ae = T.startDatePlaceholderText, ue = T.startDateAriaLabel, se = T.endDate, le = T.endDateId, oe = T.endDatePlaceholderText, re = T.endDateAriaLabel, B = T.focusedInput, ee = T.screenReaderInputMessage, j = T.showClearDates, he = T.showDefaultInputIcon, Se = T.inputIconPosition, ge = T.customInputIcon, te = T.customArrowIcon, be = T.customCloseIcon, Ae = T.disabled, He = T.required, de = T.readOnly, ce = T.openDirection, ie = T.phrases, H = T.isOutsideRange, Y = T.minimumNights, Z = T.withPortal, Q = T.withFullScreenPortal, me = T.displayFormat, Le = T.reopenPickerOnClearDates, xe = T.keepOpenOnDateSelect, Ue = T.onDatesChange, je = T.onClose, Ze = T.isRTL, _e = T.noBorder, U = T.block, fe = T.verticalSpacing, Ee = T.small, Me = T.regular, Pe = T.styles, et = this.state.isDateRangePickerInputFocused, gt = !Z && !Q, Vt = fe < k.FANG_HEIGHT_PX, Zt = a.default.createElement(D.default, {
          startDate: z,
          startDateId: X,
          startDatePlaceholderText: ae,
          isStartDateFocused: B === k.START_DATE,
          startDateAriaLabel: ue,
          endDate: se,
          endDateId: le,
          endDatePlaceholderText: oe,
          isEndDateFocused: B === k.END_DATE,
          endDateAriaLabel: re,
          displayFormat: me,
          showClearDates: j,
          showCaret: !Z && !Q && !Vt,
          showDefaultInputIcon: he,
          inputIconPosition: Se,
          customInputIcon: ge,
          customArrowIcon: te,
          customCloseIcon: be,
          disabled: Ae,
          required: He,
          readOnly: de,
          openDirection: ce,
          reopenPickerOnClearDates: Le,
          keepOpenOnDateSelect: xe,
          isOutsideRange: H,
          minimumNights: Y,
          withFullScreenPortal: Q,
          onDatesChange: Ue,
          onFocusChange: this.onDateRangePickerInputFocus,
          onKeyDownArrowDown: this.onDayPickerFocus,
          onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
          onClose: je,
          phrases: ie,
          screenReaderMessage: ee,
          isFocused: et,
          isRTL: Ze,
          noBorder: _e,
          block: U,
          small: Ee,
          regular: Me,
          verticalSpacing: fe
        }, this.maybeRenderDayPickerWithPortal());
        return a.default.createElement("div", (0, n.default)({
          ref: this.setContainerRef
        }, (0, c.css)(Pe.DateRangePicker, U && Pe.DateRangePicker__block)), gt && a.default.createElement(g.default, {
          onOutsideClick: this.onOutsideClick
        }, Zt), gt || Zt);
      }, q;
    }(a.default.PureComponent || a.default.Component);
    i.PureDateRangePicker = O, O.propTypes = process.env.NODE_ENV !== "production" ? A : {}, O.defaultProps = P;
    var K = (0, c.withStyles)(function(W) {
      var F = W.reactDates, q = F.color, R = F.zIndex;
      return {
        DateRangePicker: {
          position: "relative",
          display: "inline-block"
        },
        DateRangePicker__block: {
          display: "block"
        },
        DateRangePicker_picker: {
          zIndex: R + 1,
          backgroundColor: q.background,
          position: "absolute"
        },
        DateRangePicker_picker__rtl: {
          direction: (0, x.default)("rtl")
        },
        DateRangePicker_picker__directionLeft: {
          left: (0, x.default)(0)
        },
        DateRangePicker_picker__directionRight: {
          right: (0, x.default)(0)
        },
        DateRangePicker_picker__portal: {
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          position: "fixed",
          top: 0,
          left: (0, x.default)(0),
          height: "100%",
          width: "100%"
        },
        DateRangePicker_picker__fullScreenPortal: {
          backgroundColor: q.background
        },
        DateRangePicker_closeButton: {
          background: "none",
          border: 0,
          color: "inherit",
          font: "inherit",
          lineHeight: "normal",
          overflow: "visible",
          cursor: "pointer",
          position: "absolute",
          top: 0,
          right: (0, x.default)(0),
          padding: 15,
          zIndex: R + 2,
          ":hover": {
            color: "darken(".concat(q.core.grayLighter, ", 10%)"),
            textDecoration: "none"
          },
          ":focus": {
            color: "darken(".concat(q.core.grayLighter, ", 10%)"),
            textDecoration: "none"
          }
        },
        DateRangePicker_closeButton_svg: {
          height: 15,
          width: 15,
          fill: q.core.grayLighter
        }
      };
    }, {
      pureComponent: typeof a.default.PureComponent < "u"
    })(O);
    i.default = K;
  }(UP)), UP;
}
var JO = {}, goe;
function Hbe() {
  return goe || (goe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ua()), n = e(Obe), r = e(hs()), s = e(Pl()), o = e(fa()), a = e(it), l = e(mn()), c = e(yd()), d = Or(), u = e(gi), h = e(lk()), f = e(Rb()), g = So(), p = e(ga()), m = e(J0()), _ = e(fk()), b = e(Rbe()), w = e(dx()), y = Fbe(), S = e(Mb()), x = e($0()), D = e(hx()), E = e(Bb()), L = mi(), k = e(Sq()), N = e(Bbe());
    function I(W, F) {
      var q = Object.keys(W);
      if (Object.getOwnPropertySymbols) {
        var R = Object.getOwnPropertySymbols(W);
        F && (R = R.filter(function(T) {
          return Object.getOwnPropertyDescriptor(W, T).enumerable;
        })), q.push.apply(q, R);
      }
      return q;
    }
    function A(W) {
      for (var F = 1; F < arguments.length; F++) {
        var q = arguments[F] != null ? arguments[F] : {};
        F % 2 ? I(Object(q), !0).forEach(function(R) {
          (0, r.default)(W, R, q[R]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(W, Object.getOwnPropertyDescriptors(q)) : I(Object(q)).forEach(function(R) {
          Object.defineProperty(W, R, Object.getOwnPropertyDescriptor(q, R));
        });
      }
      return W;
    }
    var P = process.env.NODE_ENV !== "production" ? (0, d.forbidExtraProps)({
      date: c.default.momentObj,
      onDateChange: l.default.func,
      focused: l.default.bool,
      onFocusChange: l.default.func,
      onClose: l.default.func,
      keepOpenOnDateSelect: l.default.bool,
      isOutsideRange: l.default.func,
      isDayBlocked: l.default.func,
      isDayHighlighted: l.default.func,
      // DayPicker props
      renderMonthText: (0, d.mutuallyExclusiveProps)(l.default.func, "renderMonthText", "renderMonthElement"),
      renderMonthElement: (0, d.mutuallyExclusiveProps)(l.default.func, "renderMonthText", "renderMonthElement"),
      renderWeekHeaderElement: l.default.func,
      enableOutsideDays: l.default.bool,
      numberOfMonths: l.default.number,
      orientation: S.default,
      withPortal: l.default.bool,
      initialVisibleMonth: l.default.func,
      firstDayOfWeek: x.default,
      hideKeyboardShortcutsPanel: l.default.bool,
      daySize: d.nonNegativeInteger,
      verticalHeight: d.nonNegativeInteger,
      noBorder: l.default.bool,
      verticalBorderSpacing: d.nonNegativeInteger,
      transitionDuration: d.nonNegativeInteger,
      horizontalMonthPadding: d.nonNegativeInteger,
      dayPickerNavigationInlineStyles: l.default.object,
      navPosition: E.default,
      navPrev: l.default.node,
      navNext: l.default.node,
      renderNavPrevButton: l.default.func,
      renderNavNextButton: l.default.func,
      noNavButtons: l.default.bool,
      noNavNextButton: l.default.bool,
      noNavPrevButton: l.default.bool,
      onPrevMonthClick: l.default.func,
      onNextMonthClick: l.default.func,
      onOutsideClick: l.default.func,
      renderCalendarDay: l.default.func,
      renderDayContents: l.default.func,
      renderCalendarInfo: l.default.func,
      calendarInfoPosition: D.default,
      // accessibility
      onBlur: l.default.func,
      isFocused: l.default.bool,
      showKeyboardShortcuts: l.default.bool,
      onTab: l.default.func,
      onShiftTab: l.default.func,
      // i18n
      monthFormat: l.default.string,
      weekDayFormat: l.default.string,
      phrases: l.default.shape((0, p.default)(g.DayPickerPhrases)),
      dayAriaLabelFormat: l.default.string,
      isRTL: l.default.bool
    }) : {}, O = {
      date: void 0,
      // TODO: use null
      onDateChange: function() {
      },
      focused: !1,
      onFocusChange: function() {
      },
      onClose: function() {
      },
      keepOpenOnDateSelect: !1,
      isOutsideRange: function() {
      },
      isDayBlocked: function() {
      },
      isDayHighlighted: function() {
      },
      // DayPicker props
      renderMonthText: null,
      renderWeekHeaderElement: null,
      enableOutsideDays: !1,
      numberOfMonths: 1,
      orientation: L.HORIZONTAL_ORIENTATION,
      withPortal: !1,
      hideKeyboardShortcutsPanel: !1,
      initialVisibleMonth: null,
      firstDayOfWeek: null,
      daySize: L.DAY_SIZE,
      verticalHeight: null,
      noBorder: !1,
      verticalBorderSpacing: void 0,
      transitionDuration: void 0,
      horizontalMonthPadding: 13,
      dayPickerNavigationInlineStyles: null,
      navPosition: L.NAV_POSITION_TOP,
      navPrev: null,
      navNext: null,
      renderNavPrevButton: null,
      renderNavNextButton: null,
      noNavButtons: !1,
      noNavNextButton: !1,
      noNavPrevButton: !1,
      onPrevMonthClick: function() {
      },
      onNextMonthClick: function() {
      },
      onOutsideClick: function() {
      },
      renderCalendarDay: void 0,
      renderDayContents: null,
      renderCalendarInfo: null,
      renderMonthElement: null,
      calendarInfoPosition: L.INFO_POSITION_BOTTOM,
      // accessibility
      onBlur: function() {
      },
      isFocused: !1,
      showKeyboardShortcuts: !1,
      onTab: function() {
      },
      onShiftTab: function() {
      },
      // i18n
      monthFormat: "MMMM YYYY",
      weekDayFormat: "dd",
      phrases: g.DayPickerPhrases,
      dayAriaLabelFormat: void 0,
      isRTL: !1
    }, K = /* @__PURE__ */ function(W) {
      (0, o.default)(q, W);
      var F = q.prototype;
      F[!a.default.PureComponent && "shouldComponentUpdate"] = function(R, T) {
        return !(0, t.default)(this.props, R) || !(0, t.default)(this.state, T);
      };
      function q(R) {
        var T;
        T = W.call(this, R) || this, T.isTouchDevice = !1, T.today = (0, u.default)(), T.modifiers = {
          today: function(se) {
            return T.isToday(se);
          },
          blocked: function(se) {
            return T.isBlocked(se);
          },
          "blocked-calendar": function(se) {
            return R.isDayBlocked(se);
          },
          "blocked-out-of-range": function(se) {
            return R.isOutsideRange(se);
          },
          "highlighted-calendar": function(se) {
            return R.isDayHighlighted(se);
          },
          valid: function(se) {
            return !T.isBlocked(se);
          },
          hovered: function(se) {
            return T.isHovered(se);
          },
          selected: function(se) {
            return T.isSelected(se);
          },
          "first-day-of-week": function(se) {
            return T.isFirstDayOfWeek(se);
          },
          "last-day-of-week": function(se) {
            return T.isLastDayOfWeek(se);
          }
        };
        var z = T.getStateForNewMonth(R), X = z.currentMonth, ae = z.visibleDays;
        return T.state = {
          hoverDate: null,
          currentMonth: X,
          visibleDays: ae
        }, T.onDayMouseEnter = T.onDayMouseEnter.bind((0, s.default)(T)), T.onDayMouseLeave = T.onDayMouseLeave.bind((0, s.default)(T)), T.onDayClick = T.onDayClick.bind((0, s.default)(T)), T.onPrevMonthClick = T.onPrevMonthClick.bind((0, s.default)(T)), T.onNextMonthClick = T.onNextMonthClick.bind((0, s.default)(T)), T.onMonthChange = T.onMonthChange.bind((0, s.default)(T)), T.onYearChange = T.onYearChange.bind((0, s.default)(T)), T.onGetNextScrollableMonths = T.onGetNextScrollableMonths.bind((0, s.default)(T)), T.onGetPrevScrollableMonths = T.onGetPrevScrollableMonths.bind((0, s.default)(T)), T.getFirstFocusableDay = T.getFirstFocusableDay.bind((0, s.default)(T)), T;
      }
      return F.componentDidMount = function() {
        this.isTouchDevice = (0, f.default)();
      }, F.componentWillReceiveProps = function(T) {
        var z = this, X = T.date, ae = T.focused, ue = T.isOutsideRange, se = T.isDayBlocked, le = T.isDayHighlighted, oe = T.initialVisibleMonth, re = T.numberOfMonths, B = T.enableOutsideDays, ee = this.props, j = ee.isOutsideRange, he = ee.isDayBlocked, Se = ee.isDayHighlighted, ge = ee.numberOfMonths, te = ee.enableOutsideDays, be = ee.initialVisibleMonth, Ae = ee.focused, He = ee.date, de = this.state.visibleDays, ce = !1, ie = !1, H = !1;
        ue !== j && (this.modifiers["blocked-out-of-range"] = function(je) {
          return ue(je);
        }, ce = !0), se !== he && (this.modifiers["blocked-calendar"] = function(je) {
          return se(je);
        }, ie = !0), le !== Se && (this.modifiers["highlighted-calendar"] = function(je) {
          return le(je);
        }, H = !0);
        var Y = ce || ie || H;
        if (re !== ge || B !== te || oe !== be && !Ae && ae) {
          var Z = this.getStateForNewMonth(T), Q = Z.currentMonth;
          de = Z.visibleDays, this.setState({
            currentMonth: Q,
            visibleDays: de
          });
        }
        var me = X !== He, Le = ae !== Ae, xe = {};
        me && (xe = this.deleteModifier(xe, He, "selected"), xe = this.addModifier(xe, X, "selected")), (Le || Y) && (0, h.default)(de).forEach(function(je) {
          Object.keys(je).forEach(function(Ze) {
            var _e = (0, N.default)(Ze);
            z.isBlocked(_e) ? xe = z.addModifier(xe, _e, "blocked") : xe = z.deleteModifier(xe, _e, "blocked"), (Le || ce) && (ue(_e) ? xe = z.addModifier(xe, _e, "blocked-out-of-range") : xe = z.deleteModifier(xe, _e, "blocked-out-of-range")), (Le || ie) && (se(_e) ? xe = z.addModifier(xe, _e, "blocked-calendar") : xe = z.deleteModifier(xe, _e, "blocked-calendar")), (Le || H) && (le(_e) ? xe = z.addModifier(xe, _e, "highlighted-calendar") : xe = z.deleteModifier(xe, _e, "highlighted-calendar"));
          });
        });
        var Ue = (0, u.default)();
        (0, m.default)(this.today, Ue) || (xe = this.deleteModifier(xe, this.today, "today"), xe = this.addModifier(xe, Ue, "today"), this.today = Ue), Object.keys(xe).length > 0 && this.setState({
          visibleDays: A({}, de, {}, xe)
        });
      }, F.componentWillUpdate = function() {
        this.today = (0, u.default)();
      }, F.onDayClick = function(T, z) {
        if (z && z.preventDefault(), !this.isBlocked(T)) {
          var X = this.props, ae = X.onDateChange, ue = X.keepOpenOnDateSelect, se = X.onFocusChange, le = X.onClose;
          ae(T), ue || (se({
            focused: !1
          }), le({
            date: T
          }));
        }
      }, F.onDayMouseEnter = function(T) {
        if (!this.isTouchDevice) {
          var z = this.state, X = z.hoverDate, ae = z.visibleDays, ue = this.deleteModifier({}, X, "hovered");
          ue = this.addModifier(ue, T, "hovered"), this.setState({
            hoverDate: T,
            visibleDays: A({}, ae, {}, ue)
          });
        }
      }, F.onDayMouseLeave = function() {
        var T = this.state, z = T.hoverDate, X = T.visibleDays;
        if (!(this.isTouchDevice || !z)) {
          var ae = this.deleteModifier({}, z, "hovered");
          this.setState({
            hoverDate: null,
            visibleDays: A({}, X, {}, ae)
          });
        }
      }, F.onPrevMonthClick = function() {
        var T = this.props, z = T.onPrevMonthClick, X = T.numberOfMonths, ae = T.enableOutsideDays, ue = this.state, se = ue.currentMonth, le = ue.visibleDays, oe = {};
        Object.keys(le).sort().slice(0, X + 1).forEach(function(ee) {
          oe[ee] = le[ee];
        });
        var re = se.clone().subtract(1, "month"), B = (0, b.default)(re, 1, ae);
        this.setState({
          currentMonth: re,
          visibleDays: A({}, oe, {}, this.getModifiers(B))
        }, function() {
          z(re.clone());
        });
      }, F.onNextMonthClick = function() {
        var T = this.props, z = T.onNextMonthClick, X = T.numberOfMonths, ae = T.enableOutsideDays, ue = this.state, se = ue.currentMonth, le = ue.visibleDays, oe = {};
        Object.keys(le).sort().slice(1).forEach(function(j) {
          oe[j] = le[j];
        });
        var re = se.clone().add(X, "month"), B = (0, b.default)(re, 1, ae), ee = se.clone().add(1, "month");
        this.setState({
          currentMonth: ee,
          visibleDays: A({}, oe, {}, this.getModifiers(B))
        }, function() {
          z(ee.clone());
        });
      }, F.onMonthChange = function(T) {
        var z = this.props, X = z.numberOfMonths, ae = z.enableOutsideDays, ue = z.orientation, se = ue === L.VERTICAL_SCROLLABLE, le = (0, b.default)(T, X, ae, se);
        this.setState({
          currentMonth: T.clone(),
          visibleDays: this.getModifiers(le)
        });
      }, F.onYearChange = function(T) {
        var z = this.props, X = z.numberOfMonths, ae = z.enableOutsideDays, ue = z.orientation, se = ue === L.VERTICAL_SCROLLABLE, le = (0, b.default)(T, X, ae, se);
        this.setState({
          currentMonth: T.clone(),
          visibleDays: this.getModifiers(le)
        });
      }, F.onGetNextScrollableMonths = function() {
        var T = this.props, z = T.numberOfMonths, X = T.enableOutsideDays, ae = this.state, ue = ae.currentMonth, se = ae.visibleDays, le = Object.keys(se).length, oe = ue.clone().add(le, "month"), re = (0, b.default)(oe, z, X, !0);
        this.setState({
          visibleDays: A({}, se, {}, this.getModifiers(re))
        });
      }, F.onGetPrevScrollableMonths = function() {
        var T = this.props, z = T.numberOfMonths, X = T.enableOutsideDays, ae = this.state, ue = ae.currentMonth, se = ae.visibleDays, le = ue.clone().subtract(z, "month"), oe = (0, b.default)(le, z, X, !0);
        this.setState({
          currentMonth: le.clone(),
          visibleDays: A({}, se, {}, this.getModifiers(oe))
        });
      }, F.getFirstFocusableDay = function(T) {
        var z = this, X = this.props, ae = X.date, ue = X.numberOfMonths, se = T.clone().startOf("month");
        if (ae && (se = ae.clone()), this.isBlocked(se)) {
          for (var le = [], oe = T.clone().add(ue - 1, "months").endOf("month"), re = se.clone(); !(0, _.default)(re, oe); )
            re = re.clone().add(1, "day"), le.push(re);
          var B = le.filter(function(j) {
            return !z.isBlocked(j) && (0, _.default)(j, se);
          });
          if (B.length > 0) {
            var ee = (0, n.default)(B, 1);
            se = ee[0];
          }
        }
        return se;
      }, F.getModifiers = function(T) {
        var z = this, X = {};
        return Object.keys(T).forEach(function(ae) {
          X[ae] = {}, T[ae].forEach(function(ue) {
            X[ae][(0, w.default)(ue)] = z.getModifiersForDay(ue);
          });
        }), X;
      }, F.getModifiersForDay = function(T) {
        var z = this;
        return new Set(Object.keys(this.modifiers).filter(function(X) {
          return z.modifiers[X](T);
        }));
      }, F.getStateForNewMonth = function(T) {
        var z = this, X = T.initialVisibleMonth, ae = T.date, ue = T.numberOfMonths, se = T.orientation, le = T.enableOutsideDays, oe = X || (ae ? function() {
          return ae;
        } : function() {
          return z.today;
        }), re = oe(), B = se === L.VERTICAL_SCROLLABLE, ee = this.getModifiers((0, b.default)(re, ue, le, B));
        return {
          currentMonth: re,
          visibleDays: ee
        };
      }, F.addModifier = function(T, z, X) {
        return (0, y.addModifier)(T, z, X, this.props, this.state);
      }, F.deleteModifier = function(T, z, X) {
        return (0, y.deleteModifier)(T, z, X, this.props, this.state);
      }, F.isBlocked = function(T) {
        var z = this.props, X = z.isDayBlocked, ae = z.isOutsideRange;
        return X(T) || ae(T);
      }, F.isHovered = function(T) {
        var z = this.state || {}, X = z.hoverDate;
        return (0, m.default)(T, X);
      }, F.isSelected = function(T) {
        var z = this.props.date;
        return (0, m.default)(T, z);
      }, F.isToday = function(T) {
        return (0, m.default)(T, this.today);
      }, F.isFirstDayOfWeek = function(T) {
        var z = this.props.firstDayOfWeek;
        return T.day() === (z || u.default.localeData().firstDayOfWeek());
      }, F.isLastDayOfWeek = function(T) {
        var z = this.props.firstDayOfWeek;
        return T.day() === ((z || u.default.localeData().firstDayOfWeek()) + 6) % 7;
      }, F.render = function() {
        var T = this.props, z = T.numberOfMonths, X = T.orientation, ae = T.monthFormat, ue = T.renderMonthText, se = T.renderWeekHeaderElement, le = T.dayPickerNavigationInlineStyles, oe = T.navPosition, re = T.navPrev, B = T.navNext, ee = T.renderNavPrevButton, j = T.renderNavNextButton, he = T.noNavButtons, Se = T.noNavPrevButton, ge = T.noNavNextButton, te = T.onOutsideClick, be = T.onShiftTab, Ae = T.onTab, He = T.withPortal, de = T.focused, ce = T.enableOutsideDays, ie = T.hideKeyboardShortcutsPanel, H = T.daySize, Y = T.firstDayOfWeek, Z = T.renderCalendarDay, Q = T.renderDayContents, me = T.renderCalendarInfo, Le = T.renderMonthElement, xe = T.calendarInfoPosition, Ue = T.isFocused, je = T.isRTL, Ze = T.phrases, _e = T.dayAriaLabelFormat, U = T.onBlur, fe = T.showKeyboardShortcuts, Ee = T.weekDayFormat, Me = T.verticalHeight, Pe = T.noBorder, et = T.transitionDuration, gt = T.verticalBorderSpacing, Vt = T.horizontalMonthPadding, Zt = this.state, St = Zt.currentMonth, Ht = Zt.visibleDays;
        return a.default.createElement(k.default, {
          orientation: X,
          enableOutsideDays: ce,
          modifiers: Ht,
          numberOfMonths: z,
          onDayClick: this.onDayClick,
          onDayMouseEnter: this.onDayMouseEnter,
          onDayMouseLeave: this.onDayMouseLeave,
          onPrevMonthClick: this.onPrevMonthClick,
          onNextMonthClick: this.onNextMonthClick,
          onMonthChange: this.onMonthChange,
          onYearChange: this.onYearChange,
          onGetNextScrollableMonths: this.onGetNextScrollableMonths,
          onGetPrevScrollableMonths: this.onGetPrevScrollableMonths,
          monthFormat: ae,
          withPortal: He,
          hidden: !de,
          hideKeyboardShortcutsPanel: ie,
          initialVisibleMonth: function() {
            return St;
          },
          firstDayOfWeek: Y,
          onOutsideClick: te,
          dayPickerNavigationInlineStyles: le,
          navPosition: oe,
          navPrev: re,
          navNext: B,
          renderNavPrevButton: ee,
          renderNavNextButton: j,
          noNavButtons: he,
          noNavNextButton: ge,
          noNavPrevButton: Se,
          renderMonthText: ue,
          renderWeekHeaderElement: se,
          renderCalendarDay: Z,
          renderDayContents: Q,
          renderCalendarInfo: me,
          renderMonthElement: Le,
          calendarInfoPosition: xe,
          isFocused: Ue,
          getFirstFocusableDay: this.getFirstFocusableDay,
          onBlur: U,
          onTab: Ae,
          onShiftTab: be,
          phrases: Ze,
          daySize: H,
          isRTL: je,
          showKeyboardShortcuts: fe,
          weekDayFormat: Ee,
          dayAriaLabelFormat: _e,
          verticalHeight: Me,
          noBorder: Pe,
          transitionDuration: et,
          verticalBorderSpacing: gt,
          horizontalMonthPadding: Vt
        });
      }, q;
    }(a.default.PureComponent || a.default.Component);
    i.default = K, K.propTypes = process.env.NODE_ENV !== "production" ? P : {}, K.defaultProps = O;
  }(JO)), JO;
}
var $O = {}, eM = {}, poe;
function Wbe() {
  return poe || (poe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(mn()), n = e(yd()), r = Or(), s = So(), o = e(ga()), a = e(Fb()), l = e(bbe()), c = e(Cbe()), d = e(e1()), u = e($0()), h = e(hx()), f = e(Bb()), g = {
      // required props for a functional interactive SingleDatePicker
      date: n.default.momentObj,
      onDateChange: t.default.func.isRequired,
      focused: t.default.bool,
      onFocusChange: t.default.func.isRequired,
      // input related props
      id: t.default.string.isRequired,
      placeholder: t.default.string,
      ariaLabel: t.default.string,
      disabled: t.default.bool,
      required: t.default.bool,
      readOnly: t.default.bool,
      screenReaderInputMessage: t.default.string,
      showClearDate: t.default.bool,
      customCloseIcon: t.default.node,
      showDefaultInputIcon: t.default.bool,
      inputIconPosition: a.default,
      customInputIcon: t.default.node,
      noBorder: t.default.bool,
      block: t.default.bool,
      small: t.default.bool,
      regular: t.default.bool,
      verticalSpacing: r.nonNegativeInteger,
      keepFocusOnInput: t.default.bool,
      // calendar presentation and interaction related props
      renderMonthText: (0, r.mutuallyExclusiveProps)(t.default.func, "renderMonthText", "renderMonthElement"),
      renderMonthElement: (0, r.mutuallyExclusiveProps)(t.default.func, "renderMonthText", "renderMonthElement"),
      renderWeekHeaderElement: t.default.func,
      orientation: l.default,
      anchorDirection: c.default,
      openDirection: d.default,
      horizontalMargin: t.default.number,
      withPortal: t.default.bool,
      withFullScreenPortal: t.default.bool,
      appendToBody: t.default.bool,
      disableScroll: t.default.bool,
      initialVisibleMonth: t.default.func,
      firstDayOfWeek: u.default,
      numberOfMonths: t.default.number,
      keepOpenOnDateSelect: t.default.bool,
      reopenPickerOnClearDate: t.default.bool,
      renderCalendarInfo: t.default.func,
      calendarInfoPosition: h.default,
      hideKeyboardShortcutsPanel: t.default.bool,
      daySize: r.nonNegativeInteger,
      isRTL: t.default.bool,
      verticalHeight: r.nonNegativeInteger,
      transitionDuration: r.nonNegativeInteger,
      horizontalMonthPadding: r.nonNegativeInteger,
      // navigation related props
      dayPickerNavigationInlineStyles: t.default.object,
      navPosition: f.default,
      navPrev: t.default.node,
      navNext: t.default.node,
      renderNavPrevButton: t.default.func,
      renderNavNextButton: t.default.func,
      onPrevMonthClick: t.default.func,
      onNextMonthClick: t.default.func,
      onClose: t.default.func,
      // day presentation and interaction related props
      renderCalendarDay: t.default.func,
      renderDayContents: t.default.func,
      enableOutsideDays: t.default.bool,
      isDayBlocked: t.default.func,
      isOutsideRange: t.default.func,
      isDayHighlighted: t.default.func,
      // internationalization props
      displayFormat: t.default.oneOfType([t.default.string, t.default.func]),
      monthFormat: t.default.string,
      weekDayFormat: t.default.string,
      phrases: t.default.shape((0, o.default)(s.SingleDatePickerPhrases)),
      dayAriaLabelFormat: t.default.string
    };
    i.default = g;
  }(eM)), eM;
}
var tM = {}, nM = {}, moe;
function jbe() {
  return moe || (moe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ha()), n = e(hs()), r = e(it), s = e(mn()), o = Or(), a = Za(), l = So(), c = e(ga()), d = e(Cp()), u = e(Ibe()), h = e(Fb()), f = e(gx()), g = e(Tbe()), p = e(e1()), m = mi();
    function _(D, E) {
      var L = Object.keys(D);
      if (Object.getOwnPropertySymbols) {
        var k = Object.getOwnPropertySymbols(D);
        E && (k = k.filter(function(N) {
          return Object.getOwnPropertyDescriptor(D, N).enumerable;
        })), L.push.apply(L, k);
      }
      return L;
    }
    function b(D) {
      for (var E = 1; E < arguments.length; E++) {
        var L = arguments[E] != null ? arguments[E] : {};
        E % 2 ? _(Object(L), !0).forEach(function(k) {
          (0, n.default)(D, k, L[k]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(L)) : _(Object(L)).forEach(function(k) {
          Object.defineProperty(D, k, Object.getOwnPropertyDescriptor(L, k));
        });
      }
      return D;
    }
    var w = process.env.NODE_ENV !== "production" ? (0, o.forbidExtraProps)(b({}, a.withStylesPropTypes, {
      id: s.default.string.isRequired,
      children: s.default.node,
      placeholder: s.default.string,
      ariaLabel: s.default.string,
      displayValue: s.default.string,
      screenReaderMessage: s.default.string,
      focused: s.default.bool,
      isFocused: s.default.bool,
      // describes actual DOM focus
      disabled: s.default.bool,
      required: s.default.bool,
      readOnly: s.default.bool,
      openDirection: p.default,
      showCaret: s.default.bool,
      showClearDate: s.default.bool,
      customCloseIcon: s.default.node,
      showDefaultInputIcon: s.default.bool,
      inputIconPosition: h.default,
      customInputIcon: s.default.node,
      isRTL: s.default.bool,
      noBorder: s.default.bool,
      block: s.default.bool,
      small: s.default.bool,
      regular: s.default.bool,
      verticalSpacing: o.nonNegativeInteger,
      onChange: s.default.func,
      onClearDate: s.default.func,
      onFocus: s.default.func,
      onKeyDownShiftTab: s.default.func,
      onKeyDownTab: s.default.func,
      onKeyDownArrowDown: s.default.func,
      onKeyDownQuestionMark: s.default.func,
      // i18n
      phrases: s.default.shape((0, c.default)(l.SingleDatePickerInputPhrases))
    })) : {}, y = {
      children: null,
      placeholder: "Select Date",
      ariaLabel: void 0,
      displayValue: "",
      screenReaderMessage: "",
      focused: !1,
      isFocused: !1,
      disabled: !1,
      required: !1,
      readOnly: !1,
      openDirection: m.OPEN_DOWN,
      showCaret: !1,
      showClearDate: !1,
      showDefaultInputIcon: !1,
      inputIconPosition: m.ICON_BEFORE_POSITION,
      customCloseIcon: null,
      customInputIcon: null,
      isRTL: !1,
      noBorder: !1,
      block: !1,
      small: !1,
      regular: !1,
      verticalSpacing: void 0,
      onChange: function() {
      },
      onClearDate: function() {
      },
      onFocus: function() {
      },
      onKeyDownShiftTab: function() {
      },
      onKeyDownTab: function() {
      },
      onKeyDownArrowDown: function() {
      },
      onKeyDownQuestionMark: function() {
      },
      // i18n
      phrases: l.SingleDatePickerInputPhrases
    };
    function S(D) {
      var E = D.id, L = D.children, k = D.placeholder, N = D.ariaLabel, I = D.displayValue, A = D.focused, P = D.isFocused, O = D.disabled, K = D.required, W = D.readOnly, F = D.showCaret, q = D.showClearDate, R = D.showDefaultInputIcon, T = D.inputIconPosition, z = D.phrases, X = D.onClearDate, ae = D.onChange, ue = D.onFocus, se = D.onKeyDownShiftTab, le = D.onKeyDownTab, oe = D.onKeyDownArrowDown, re = D.onKeyDownQuestionMark, B = D.screenReaderMessage, ee = D.customCloseIcon, j = D.customInputIcon, he = D.openDirection, Se = D.isRTL, ge = D.noBorder, te = D.block, be = D.small, Ae = D.regular, He = D.verticalSpacing, de = D.styles, ce = j || r.default.createElement(g.default, (0, a.css)(de.SingleDatePickerInput_calendarIcon_svg)), ie = ee || r.default.createElement(f.default, (0, a.css)(de.SingleDatePickerInput_clearDate_svg, be && de.SingleDatePickerInput_clearDate_svg__small)), H = B || z.keyboardForwardNavigationInstructions, Y = (R || j !== null) && r.default.createElement("button", (0, t.default)({}, (0, a.css)(de.SingleDatePickerInput_calendarIcon), {
        type: "button",
        disabled: O,
        "aria-label": z.focusStartDate,
        onClick: ue
      }), ce);
      return r.default.createElement("div", (0, a.css)(de.SingleDatePickerInput, O && de.SingleDatePickerInput__disabled, Se && de.SingleDatePickerInput__rtl, !ge && de.SingleDatePickerInput__withBorder, te && de.SingleDatePickerInput__block, q && de.SingleDatePickerInput__showClearDate), T === m.ICON_BEFORE_POSITION && Y, r.default.createElement(u.default, {
        id: E,
        placeholder: k,
        ariaLabel: N,
        displayValue: I,
        screenReaderMessage: H,
        focused: A,
        isFocused: P,
        disabled: O,
        required: K,
        readOnly: W,
        showCaret: F,
        onChange: ae,
        onFocus: ue,
        onKeyDownShiftTab: se,
        onKeyDownTab: le,
        onKeyDownArrowDown: oe,
        onKeyDownQuestionMark: re,
        openDirection: he,
        verticalSpacing: He,
        small: be,
        regular: Ae,
        block: te
      }), L, q && r.default.createElement("button", (0, t.default)({}, (0, a.css)(de.SingleDatePickerInput_clearDate, be && de.SingleDatePickerInput_clearDate__small, !ee && de.SingleDatePickerInput_clearDate__default, !I && de.SingleDatePickerInput_clearDate__hide), {
        type: "button",
        "aria-label": z.clearDate,
        disabled: O,
        onClick: X
      }), ie), T === m.ICON_AFTER_POSITION && Y);
    }
    S.propTypes = process.env.NODE_ENV !== "production" ? w : {}, S.defaultProps = y;
    var x = (0, a.withStyles)(function(D) {
      var E = D.reactDates, L = E.border, k = E.color;
      return {
        SingleDatePickerInput: {
          display: "inline-block",
          backgroundColor: k.background
        },
        SingleDatePickerInput__withBorder: {
          borderColor: k.border,
          borderWidth: L.pickerInput.borderWidth,
          borderStyle: L.pickerInput.borderStyle,
          borderRadius: L.pickerInput.borderRadius
        },
        SingleDatePickerInput__rtl: {
          direction: (0, d.default)("rtl")
        },
        SingleDatePickerInput__disabled: {
          backgroundColor: k.disabled
        },
        SingleDatePickerInput__block: {
          display: "block"
        },
        SingleDatePickerInput__showClearDate: {
          paddingRight: 30
          // TODO: should be noflip wrapped and handled by an isRTL prop
        },
        SingleDatePickerInput_clearDate: {
          background: "none",
          border: 0,
          color: "inherit",
          font: "inherit",
          lineHeight: "normal",
          overflow: "visible",
          cursor: "pointer",
          padding: 10,
          margin: "0 10px 0 5px",
          // TODO: should be noflip wrapped and handled by an isRTL prop
          position: "absolute",
          right: 0,
          // TODO: should be noflip wrapped and handled by an isRTL prop
          top: "50%",
          transform: "translateY(-50%)"
        },
        SingleDatePickerInput_clearDate__default: {
          ":focus": {
            background: k.core.border,
            borderRadius: "50%"
          },
          ":hover": {
            background: k.core.border,
            borderRadius: "50%"
          }
        },
        SingleDatePickerInput_clearDate__small: {
          padding: 6
        },
        SingleDatePickerInput_clearDate__hide: {
          visibility: "hidden"
        },
        SingleDatePickerInput_clearDate_svg: {
          fill: k.core.grayLight,
          height: 12,
          width: 15,
          verticalAlign: "middle"
        },
        SingleDatePickerInput_clearDate_svg__small: {
          height: 9
        },
        SingleDatePickerInput_calendarIcon: {
          background: "none",
          border: 0,
          color: "inherit",
          font: "inherit",
          lineHeight: "normal",
          overflow: "visible",
          cursor: "pointer",
          display: "inline-block",
          verticalAlign: "middle",
          padding: 10,
          margin: "0 5px 0 10px"
          // TODO: should be noflip wrapped and handled by an isRTL prop
        },
        SingleDatePickerInput_calendarIcon_svg: {
          fill: k.core.grayLight,
          height: 15,
          width: 14,
          verticalAlign: "middle"
        }
      };
    }, {
      pureComponent: typeof r.default.PureComponent < "u"
    })(S);
    i.default = x;
  }(nM)), nM;
}
var voe;
function out() {
  return voe || (voe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(ua()), n = e(Pl()), r = e(fa()), s = e(it), o = e(mn()), a = e(gi), l = e(yd()), c = Or(), d = e(e1()), u = So(), h = e(ga()), f = e(jbe()), g = e(Fb()), p = e(ux()), m = e(Ob()), _ = e(yq()), b = e(Vb()), w = mi(), y = process.env.NODE_ENV !== "production" ? (0, c.forbidExtraProps)({
      children: o.default.node,
      date: l.default.momentObj,
      onDateChange: o.default.func.isRequired,
      focused: o.default.bool,
      onFocusChange: o.default.func.isRequired,
      id: o.default.string.isRequired,
      placeholder: o.default.string,
      ariaLabel: o.default.string,
      screenReaderMessage: o.default.string,
      showClearDate: o.default.bool,
      showCaret: o.default.bool,
      showDefaultInputIcon: o.default.bool,
      inputIconPosition: g.default,
      disabled: p.default,
      required: o.default.bool,
      readOnly: o.default.bool,
      openDirection: d.default,
      noBorder: o.default.bool,
      block: o.default.bool,
      small: o.default.bool,
      regular: o.default.bool,
      verticalSpacing: c.nonNegativeInteger,
      keepOpenOnDateSelect: o.default.bool,
      reopenPickerOnClearDate: o.default.bool,
      isOutsideRange: o.default.func,
      displayFormat: o.default.oneOfType([o.default.string, o.default.func]),
      onClose: o.default.func,
      onKeyDownArrowDown: o.default.func,
      onKeyDownQuestionMark: o.default.func,
      customInputIcon: o.default.node,
      customCloseIcon: o.default.node,
      // accessibility
      isFocused: o.default.bool,
      // i18n
      phrases: o.default.shape((0, h.default)(u.SingleDatePickerInputPhrases)),
      isRTL: o.default.bool
    }) : {}, S = {
      children: null,
      date: null,
      focused: !1,
      placeholder: "",
      ariaLabel: void 0,
      screenReaderMessage: "Date",
      showClearDate: !1,
      showCaret: !1,
      showDefaultInputIcon: !1,
      inputIconPosition: w.ICON_BEFORE_POSITION,
      disabled: !1,
      required: !1,
      readOnly: !1,
      openDirection: w.OPEN_DOWN,
      noBorder: !1,
      block: !1,
      small: !1,
      regular: !1,
      verticalSpacing: void 0,
      keepOpenOnDateSelect: !1,
      reopenPickerOnClearDate: !1,
      isOutsideRange: function(E) {
        return !(0, b.default)(E, (0, a.default)());
      },
      displayFormat: function() {
        return a.default.localeData().longDateFormat("L");
      },
      onClose: function() {
      },
      onKeyDownArrowDown: function() {
      },
      onKeyDownQuestionMark: function() {
      },
      customInputIcon: null,
      customCloseIcon: null,
      // accessibility
      isFocused: !1,
      // i18n
      phrases: u.SingleDatePickerInputPhrases,
      isRTL: !1
    }, x = /* @__PURE__ */ function(D) {
      (0, r.default)(L, D);
      var E = L.prototype;
      E[!s.default.PureComponent && "shouldComponentUpdate"] = function(k, N) {
        return !(0, t.default)(this.props, k) || !(0, t.default)(this.state, N);
      };
      function L(k) {
        var N;
        return N = D.call(this, k) || this, N.onChange = N.onChange.bind((0, n.default)(N)), N.onFocus = N.onFocus.bind((0, n.default)(N)), N.onClearFocus = N.onClearFocus.bind((0, n.default)(N)), N.clearDate = N.clearDate.bind((0, n.default)(N)), N;
      }
      return E.onChange = function(N) {
        var I = this.props, A = I.isOutsideRange, P = I.keepOpenOnDateSelect, O = I.onDateChange, K = I.onFocusChange, W = I.onClose, F = (0, m.default)(N, this.getDisplayFormat()), q = F && !A(F);
        q ? (O(F), P || (K({
          focused: !1
        }), W({
          date: F
        }))) : O(null);
      }, E.onFocus = function() {
        var N = this.props, I = N.onFocusChange, A = N.disabled;
        A || I({
          focused: !0
        });
      }, E.onClearFocus = function() {
        var N = this.props, I = N.focused, A = N.onFocusChange, P = N.onClose, O = N.date;
        I && (A({
          focused: !1
        }), P({
          date: O
        }));
      }, E.getDisplayFormat = function() {
        var N = this.props.displayFormat;
        return typeof N == "string" ? N : N();
      }, E.getDateString = function(N) {
        var I = this.getDisplayFormat();
        return N && I ? N && N.format(I) : (0, _.default)(N);
      }, E.clearDate = function() {
        var N = this.props, I = N.onDateChange, A = N.reopenPickerOnClearDate, P = N.onFocusChange;
        I(null), A && P({
          focused: !0
        });
      }, E.render = function() {
        var N = this.props, I = N.children, A = N.id, P = N.placeholder, O = N.ariaLabel, K = N.disabled, W = N.focused, F = N.isFocused, q = N.required, R = N.readOnly, T = N.openDirection, z = N.showClearDate, X = N.showCaret, ae = N.showDefaultInputIcon, ue = N.inputIconPosition, se = N.customCloseIcon, le = N.customInputIcon, oe = N.date, re = N.phrases, B = N.onKeyDownArrowDown, ee = N.onKeyDownQuestionMark, j = N.screenReaderMessage, he = N.isRTL, Se = N.noBorder, ge = N.block, te = N.small, be = N.regular, Ae = N.verticalSpacing, He = this.getDateString(oe);
        return s.default.createElement(f.default, {
          id: A,
          placeholder: P,
          ariaLabel: O,
          focused: W,
          isFocused: F,
          disabled: K,
          required: q,
          readOnly: R,
          openDirection: T,
          showCaret: X,
          onClearDate: this.clearDate,
          showClearDate: z,
          showDefaultInputIcon: ae,
          inputIconPosition: ue,
          customCloseIcon: se,
          customInputIcon: le,
          displayValue: He,
          onChange: this.onChange,
          onFocus: this.onFocus,
          onKeyDownShiftTab: this.onClearFocus,
          onKeyDownArrowDown: B,
          onKeyDownQuestionMark: ee,
          screenReaderMessage: j,
          phrases: re,
          isRTL: he,
          noBorder: Se,
          block: ge,
          small: te,
          regular: be,
          verticalSpacing: Ae
        }, I);
      }, L;
    }(s.default.PureComponent || s.default.Component);
    i.default = x, x.propTypes = process.env.NODE_ENV !== "production" ? y : {}, x.defaultProps = S;
  }(tM)), tM;
}
var _oe;
function aut() {
  return _oe || (_oe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = i.PureSingleDatePicker = void 0;
    var t = e(ua()), n = e(ha()), r = e(Pl()), s = e(fa()), o = e(hs()), a = e(it), l = e(gi), c = Za(), d = pbe, u = Or(), h = uk, f = e(Rb()), g = e(_q()), p = e(Wbe()), m = So(), _ = e(wbe()), b = e(Sbe()), w = e(bq()), y = e(Vb()), S = e(xbe()), x = e(Cp()), D = e(out()), E = e(Hbe()), L = e(gx()), k = mi();
    function N(W, F) {
      var q = Object.keys(W);
      if (Object.getOwnPropertySymbols) {
        var R = Object.getOwnPropertySymbols(W);
        F && (R = R.filter(function(T) {
          return Object.getOwnPropertyDescriptor(W, T).enumerable;
        })), q.push.apply(q, R);
      }
      return q;
    }
    function I(W) {
      for (var F = 1; F < arguments.length; F++) {
        var q = arguments[F] != null ? arguments[F] : {};
        F % 2 ? N(Object(q), !0).forEach(function(R) {
          (0, o.default)(W, R, q[R]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(W, Object.getOwnPropertyDescriptors(q)) : N(Object(q)).forEach(function(R) {
          Object.defineProperty(W, R, Object.getOwnPropertyDescriptor(q, R));
        });
      }
      return W;
    }
    var A = process.env.NODE_ENV !== "production" ? (0, u.forbidExtraProps)(I({}, c.withStylesPropTypes, {}, p.default)) : {}, P = {
      // required props for a functional interactive SingleDatePicker
      date: null,
      focused: !1,
      // input related props
      id: "date",
      placeholder: "Date",
      ariaLabel: void 0,
      disabled: !1,
      required: !1,
      readOnly: !1,
      screenReaderInputMessage: "",
      showClearDate: !1,
      showDefaultInputIcon: !1,
      inputIconPosition: k.ICON_BEFORE_POSITION,
      customInputIcon: null,
      customCloseIcon: null,
      noBorder: !1,
      block: !1,
      small: !1,
      regular: !1,
      verticalSpacing: k.DEFAULT_VERTICAL_SPACING,
      keepFocusOnInput: !1,
      // calendar presentation and interaction related props
      orientation: k.HORIZONTAL_ORIENTATION,
      anchorDirection: k.ANCHOR_LEFT,
      openDirection: k.OPEN_DOWN,
      horizontalMargin: 0,
      withPortal: !1,
      withFullScreenPortal: !1,
      appendToBody: !1,
      disableScroll: !1,
      initialVisibleMonth: null,
      firstDayOfWeek: null,
      numberOfMonths: 2,
      keepOpenOnDateSelect: !1,
      reopenPickerOnClearDate: !1,
      renderCalendarInfo: null,
      calendarInfoPosition: k.INFO_POSITION_BOTTOM,
      hideKeyboardShortcutsPanel: !1,
      daySize: k.DAY_SIZE,
      isRTL: !1,
      verticalHeight: null,
      transitionDuration: void 0,
      horizontalMonthPadding: 13,
      // navigation related props
      dayPickerNavigationInlineStyles: null,
      navPosition: k.NAV_POSITION_TOP,
      navPrev: null,
      navNext: null,
      renderNavPrevButton: null,
      renderNavNextButton: null,
      onPrevMonthClick: function() {
      },
      onNextMonthClick: function() {
      },
      onClose: function() {
      },
      // month presentation and interaction related props
      renderMonthText: null,
      renderWeekHeaderElement: null,
      // day presentation and interaction related props
      renderCalendarDay: void 0,
      renderDayContents: null,
      renderMonthElement: null,
      enableOutsideDays: !1,
      isDayBlocked: function() {
        return !1;
      },
      isOutsideRange: function(F) {
        return !(0, y.default)(F, (0, l.default)());
      },
      isDayHighlighted: function() {
      },
      // internationalization props
      displayFormat: function() {
        return l.default.localeData().longDateFormat("L");
      },
      monthFormat: "MMMM YYYY",
      weekDayFormat: "dd",
      phrases: m.SingleDatePickerPhrases,
      dayAriaLabelFormat: void 0
    }, O = /* @__PURE__ */ function(W) {
      (0, s.default)(q, W);
      var F = q.prototype;
      F[!a.default.PureComponent && "shouldComponentUpdate"] = function(R, T) {
        return !(0, t.default)(this.props, R) || !(0, t.default)(this.state, T);
      };
      function q(R) {
        var T;
        return T = W.call(this, R) || this, T.isTouchDevice = !1, T.state = {
          dayPickerContainerStyles: {},
          isDayPickerFocused: !1,
          isInputFocused: !1,
          showKeyboardShortcuts: !1
        }, T.onFocusOut = T.onFocusOut.bind((0, r.default)(T)), T.onOutsideClick = T.onOutsideClick.bind((0, r.default)(T)), T.onInputFocus = T.onInputFocus.bind((0, r.default)(T)), T.onDayPickerFocus = T.onDayPickerFocus.bind((0, r.default)(T)), T.onDayPickerBlur = T.onDayPickerBlur.bind((0, r.default)(T)), T.showKeyboardShortcutsPanel = T.showKeyboardShortcutsPanel.bind((0, r.default)(T)), T.responsivizePickerPosition = T.responsivizePickerPosition.bind((0, r.default)(T)), T.disableScroll = T.disableScroll.bind((0, r.default)(T)), T.setDayPickerContainerRef = T.setDayPickerContainerRef.bind((0, r.default)(T)), T.setContainerRef = T.setContainerRef.bind((0, r.default)(T)), T;
      }
      return F.componentDidMount = function() {
        this.removeResizeEventListener = (0, h.addEventListener)(window, "resize", this.responsivizePickerPosition, {
          passive: !0
        }), this.responsivizePickerPosition(), this.disableScroll();
        var T = this.props.focused;
        T && this.setState({
          isInputFocused: !0
        }), this.isTouchDevice = (0, f.default)();
      }, F.componentDidUpdate = function(T) {
        var z = this.props.focused;
        !T.focused && z ? (this.responsivizePickerPosition(), this.disableScroll()) : T.focused && !z && this.enableScroll && this.enableScroll();
      }, F.componentWillUnmount = function() {
        this.removeResizeEventListener && this.removeResizeEventListener(), this.removeFocusOutEventListener && this.removeFocusOutEventListener(), this.enableScroll && this.enableScroll();
      }, F.onOutsideClick = function(T) {
        var z = this.props, X = z.focused, ae = z.onFocusChange, ue = z.onClose, se = z.date, le = z.appendToBody;
        X && (le && this.dayPickerContainer.contains(T.target) || (this.setState({
          isInputFocused: !1,
          isDayPickerFocused: !1,
          showKeyboardShortcuts: !1
        }), ae({
          focused: !1
        }), ue({
          date: se
        })));
      }, F.onInputFocus = function(T) {
        var z = T.focused, X = this.props, ae = X.onFocusChange, ue = X.readOnly, se = X.withPortal, le = X.withFullScreenPortal, oe = X.keepFocusOnInput;
        if (z) {
          var re = se || le, B = re || ue && !oe || this.isTouchDevice && !oe;
          B ? this.onDayPickerFocus() : this.onDayPickerBlur();
        }
        ae({
          focused: z
        });
      }, F.onDayPickerFocus = function() {
        this.setState({
          isInputFocused: !1,
          isDayPickerFocused: !0,
          showKeyboardShortcuts: !1
        });
      }, F.onDayPickerBlur = function() {
        this.setState({
          isInputFocused: !0,
          isDayPickerFocused: !1,
          showKeyboardShortcuts: !1
        });
      }, F.onFocusOut = function(T) {
        var z = this.props.onFocusChange, X = T.relatedTarget === document.body ? T.target : T.relatedTarget || T.target;
        this.dayPickerContainer.contains(X) || z({
          focused: !1
        });
      }, F.setDayPickerContainerRef = function(T) {
        T !== this.dayPickerContainer && (this.removeEventListeners(), this.dayPickerContainer = T, T && this.addEventListeners());
      }, F.setContainerRef = function(T) {
        this.container = T;
      }, F.addEventListeners = function() {
        this.removeFocusOutEventListener = (0, h.addEventListener)(this.dayPickerContainer, "focusout", this.onFocusOut);
      }, F.removeEventListeners = function() {
        this.removeFocusOutEventListener && this.removeFocusOutEventListener();
      }, F.disableScroll = function() {
        var T = this.props, z = T.appendToBody, X = T.disableScroll, ae = T.focused;
        !z && !X || ae && (this.enableScroll = (0, S.default)(this.container));
      }, F.responsivizePickerPosition = function() {
        this.setState({
          dayPickerContainerStyles: {}
        });
        var T = this.props, z = T.openDirection, X = T.anchorDirection, ae = T.horizontalMargin, ue = T.withPortal, se = T.withFullScreenPortal, le = T.appendToBody, oe = T.focused, re = this.state.dayPickerContainerStyles;
        if (oe) {
          var B = X === k.ANCHOR_LEFT;
          if (!ue && !se) {
            var ee = this.dayPickerContainer.getBoundingClientRect(), j = re[X] || 0, he = B ? ee[k.ANCHOR_RIGHT] : ee[k.ANCHOR_LEFT];
            this.setState({
              dayPickerContainerStyles: I({}, (0, _.default)(X, j, he, ae), {}, le && (0, b.default)(z, X, this.container))
            });
          }
        }
      }, F.showKeyboardShortcutsPanel = function() {
        this.setState({
          isInputFocused: !1,
          isDayPickerFocused: !0,
          showKeyboardShortcuts: !0
        });
      }, F.maybeRenderDayPickerWithPortal = function() {
        var T = this.props, z = T.focused, X = T.withPortal, ae = T.withFullScreenPortal, ue = T.appendToBody;
        return z ? X || ae || ue ? a.default.createElement(d.Portal, null, this.renderDayPicker()) : this.renderDayPicker() : null;
      }, F.renderDayPicker = function() {
        var T = this.props, z = T.anchorDirection, X = T.openDirection, ae = T.onDateChange, ue = T.date, se = T.onFocusChange, le = T.focused, oe = T.enableOutsideDays, re = T.numberOfMonths, B = T.orientation, ee = T.monthFormat, j = T.dayPickerNavigationInlineStyles, he = T.navPosition, Se = T.navPrev, ge = T.navNext, te = T.renderNavPrevButton, be = T.renderNavNextButton, Ae = T.onPrevMonthClick, He = T.onNextMonthClick, de = T.onClose, ce = T.withPortal, ie = T.withFullScreenPortal, H = T.keepOpenOnDateSelect, Y = T.initialVisibleMonth, Z = T.renderMonthText, Q = T.renderWeekHeaderElement, me = T.renderCalendarDay, Le = T.renderDayContents, xe = T.renderCalendarInfo, Ue = T.renderMonthElement, je = T.calendarInfoPosition, Ze = T.hideKeyboardShortcutsPanel, _e = T.firstDayOfWeek, U = T.customCloseIcon, fe = T.phrases, Ee = T.dayAriaLabelFormat, Me = T.daySize, Pe = T.isRTL, et = T.isOutsideRange, gt = T.isDayBlocked, Vt = T.isDayHighlighted, Zt = T.weekDayFormat, St = T.styles, Ht = T.verticalHeight, fn = T.transitionDuration, xn = T.verticalSpacing, rt = T.horizontalMonthPadding, Ei = T.small, Nn = T.theme.reactDates, Gi = this.state, Ce = Gi.dayPickerContainerStyles, Xe = Gi.isDayPickerFocused, nt = Gi.showKeyboardShortcuts, At = !ie && ce ? this.onOutsideClick : void 0, tn = U || a.default.createElement(L.default, null), qt = (0, w.default)(Nn, Ei), Kt = ce || ie;
        return a.default.createElement("div", (0, n.default)({
          ref: this.setDayPickerContainerRef
        }, (0, c.css)(St.SingleDatePicker_picker, z === k.ANCHOR_LEFT && St.SingleDatePicker_picker__directionLeft, z === k.ANCHOR_RIGHT && St.SingleDatePicker_picker__directionRight, X === k.OPEN_DOWN && St.SingleDatePicker_picker__openDown, X === k.OPEN_UP && St.SingleDatePicker_picker__openUp, !Kt && X === k.OPEN_DOWN && {
          top: qt + xn
        }, !Kt && X === k.OPEN_UP && {
          bottom: qt + xn
        }, B === k.HORIZONTAL_ORIENTATION && St.SingleDatePicker_picker__horizontal, B === k.VERTICAL_ORIENTATION && St.SingleDatePicker_picker__vertical, Kt && St.SingleDatePicker_picker__portal, ie && St.SingleDatePicker_picker__fullScreenPortal, Pe && St.SingleDatePicker_picker__rtl, Ce), {
          onClick: At
        }), a.default.createElement(E.default, {
          date: ue,
          onDateChange: ae,
          onFocusChange: se,
          orientation: B,
          enableOutsideDays: oe,
          numberOfMonths: re,
          monthFormat: ee,
          withPortal: Kt,
          focused: le,
          keepOpenOnDateSelect: H,
          hideKeyboardShortcutsPanel: Ze,
          initialVisibleMonth: Y,
          dayPickerNavigationInlineStyles: j,
          navPosition: he,
          navPrev: Se,
          navNext: ge,
          renderNavPrevButton: te,
          renderNavNextButton: be,
          onPrevMonthClick: Ae,
          onNextMonthClick: He,
          onClose: de,
          renderMonthText: Z,
          renderWeekHeaderElement: Q,
          renderCalendarDay: me,
          renderDayContents: Le,
          renderCalendarInfo: xe,
          renderMonthElement: Ue,
          calendarInfoPosition: je,
          isFocused: Xe,
          showKeyboardShortcuts: nt,
          onBlur: this.onDayPickerBlur,
          phrases: fe,
          dayAriaLabelFormat: Ee,
          daySize: Me,
          isRTL: Pe,
          isOutsideRange: et,
          isDayBlocked: gt,
          isDayHighlighted: Vt,
          firstDayOfWeek: _e,
          weekDayFormat: Zt,
          verticalHeight: Ht,
          transitionDuration: fn,
          horizontalMonthPadding: rt
        }), ie && a.default.createElement("button", (0, n.default)({}, (0, c.css)(St.SingleDatePicker_closeButton), {
          "aria-label": fe.closeDatePicker,
          type: "button",
          onClick: this.onOutsideClick
        }), a.default.createElement("div", (0, c.css)(St.SingleDatePicker_closeButton_svg), tn)));
      }, F.render = function() {
        var T = this.props, z = T.id, X = T.placeholder, ae = T.ariaLabel, ue = T.disabled, se = T.focused, le = T.required, oe = T.readOnly, re = T.openDirection, B = T.showClearDate, ee = T.showDefaultInputIcon, j = T.inputIconPosition, he = T.customCloseIcon, Se = T.customInputIcon, ge = T.date, te = T.onDateChange, be = T.displayFormat, Ae = T.phrases, He = T.withPortal, de = T.withFullScreenPortal, ce = T.screenReaderInputMessage, ie = T.isRTL, H = T.noBorder, Y = T.block, Z = T.small, Q = T.regular, me = T.verticalSpacing, Le = T.reopenPickerOnClearDate, xe = T.keepOpenOnDateSelect, Ue = T.styles, je = T.isOutsideRange, Ze = this.state.isInputFocused, _e = !He && !de, U = me < k.FANG_HEIGHT_PX, fe = a.default.createElement(D.default, {
          id: z,
          placeholder: X,
          ariaLabel: ae,
          focused: se,
          isFocused: Ze,
          disabled: ue,
          required: le,
          readOnly: oe,
          openDirection: re,
          showCaret: !He && !de && !U,
          showClearDate: B,
          showDefaultInputIcon: ee,
          inputIconPosition: j,
          isOutsideRange: je,
          customCloseIcon: he,
          customInputIcon: Se,
          date: ge,
          onDateChange: te,
          displayFormat: be,
          onFocusChange: this.onInputFocus,
          onKeyDownArrowDown: this.onDayPickerFocus,
          onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
          screenReaderMessage: ce,
          phrases: Ae,
          isRTL: ie,
          noBorder: H,
          block: Y,
          small: Z,
          regular: Q,
          verticalSpacing: me,
          reopenPickerOnClearDate: Le,
          keepOpenOnDateSelect: xe
        }, this.maybeRenderDayPickerWithPortal());
        return a.default.createElement("div", (0, n.default)({
          ref: this.setContainerRef
        }, (0, c.css)(Ue.SingleDatePicker, Y && Ue.SingleDatePicker__block)), _e && a.default.createElement(g.default, {
          onOutsideClick: this.onOutsideClick
        }, fe), _e || fe);
      }, q;
    }(a.default.PureComponent || a.default.Component);
    i.PureSingleDatePicker = O, O.propTypes = process.env.NODE_ENV !== "production" ? A : {}, O.defaultProps = P;
    var K = (0, c.withStyles)(function(W) {
      var F = W.reactDates, q = F.color, R = F.zIndex;
      return {
        SingleDatePicker: {
          position: "relative",
          display: "inline-block"
        },
        SingleDatePicker__block: {
          display: "block"
        },
        SingleDatePicker_picker: {
          zIndex: R + 1,
          backgroundColor: q.background,
          position: "absolute"
        },
        SingleDatePicker_picker__rtl: {
          direction: (0, x.default)("rtl")
        },
        SingleDatePicker_picker__directionLeft: {
          left: (0, x.default)(0)
        },
        SingleDatePicker_picker__directionRight: {
          right: (0, x.default)(0)
        },
        SingleDatePicker_picker__portal: {
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          position: "fixed",
          top: 0,
          left: (0, x.default)(0),
          height: "100%",
          width: "100%"
        },
        SingleDatePicker_picker__fullScreenPortal: {
          backgroundColor: q.background
        },
        SingleDatePicker_closeButton: {
          background: "none",
          border: 0,
          color: "inherit",
          font: "inherit",
          lineHeight: "normal",
          overflow: "visible",
          cursor: "pointer",
          position: "absolute",
          top: 0,
          right: (0, x.default)(0),
          padding: 15,
          zIndex: R + 2,
          ":hover": {
            color: "darken(".concat(q.core.grayLighter, ", 10%)"),
            textDecoration: "none"
          },
          ":focus": {
            color: "darken(".concat(q.core.grayLighter, ", 10%)"),
            textDecoration: "none"
          }
        },
        SingleDatePicker_closeButton_svg: {
          height: 15,
          width: 15,
          fill: q.core.grayLighter
        }
      };
    }, {
      pureComponent: typeof a.default.PureComponent < "u"
    })(O);
    i.default = K;
  }($O)), $O;
}
var iM = {}, boe;
function lut() {
  return boe || (boe = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(gi), n = e(fk());
    function r(s, o) {
      return !t.default.isMoment(s) || !t.default.isMoment(o) ? !1 : !(0, n.default)(s, o);
    }
  }(iM)), iM;
}
(function(i) {
  var e = xt;
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "CalendarDay", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(i, "CalendarMonth", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(i, "CalendarMonthGrid", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(i, "DateRangePicker", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  }), Object.defineProperty(i, "DateRangePickerInput", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(i, "DateRangePickerInputController", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(i, "DateRangePickerShape", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), Object.defineProperty(i, "DayPicker", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), Object.defineProperty(i, "DayPickerRangeController", {
    enumerable: !0,
    get: function() {
      return d.default;
    }
  }), Object.defineProperty(i, "DayPickerSingleDateController", {
    enumerable: !0,
    get: function() {
      return u.default;
    }
  }), Object.defineProperty(i, "SingleDatePicker", {
    enumerable: !0,
    get: function() {
      return h.default;
    }
  }), Object.defineProperty(i, "SingleDatePickerInput", {
    enumerable: !0,
    get: function() {
      return f.default;
    }
  }), Object.defineProperty(i, "SingleDatePickerShape", {
    enumerable: !0,
    get: function() {
      return g.default;
    }
  }), Object.defineProperty(i, "isInclusivelyAfterDay", {
    enumerable: !0,
    get: function() {
      return p.default;
    }
  }), Object.defineProperty(i, "isInclusivelyBeforeDay", {
    enumerable: !0,
    get: function() {
      return m.default;
    }
  }), Object.defineProperty(i, "isNextDay", {
    enumerable: !0,
    get: function() {
      return _.default;
    }
  }), Object.defineProperty(i, "isSameDay", {
    enumerable: !0,
    get: function() {
      return b.default;
    }
  }), Object.defineProperty(i, "toISODateString", {
    enumerable: !0,
    get: function() {
      return w.default;
    }
  }), Object.defineProperty(i, "toLocalizedDateString", {
    enumerable: !0,
    get: function() {
      return y.default;
    }
  }), Object.defineProperty(i, "toMomentObject", {
    enumerable: !0,
    get: function() {
      return S.default;
    }
  });
  var t = e(abe()), n = e(cbe()), r = e(ube()), s = e(sut()), o = e(Nbe()), a = e(Pbe()), l = e(ybe()), c = e(Sq()), d = e(Vbe()), u = e(Hbe()), h = e(aut()), f = e(jbe()), g = e(Wbe()), p = e(Vb()), m = e(lut()), _ = e(Mbe()), b = e(J0()), w = e(dx()), y = e(yq()), S = e(Ob());
})(i_e);
var zbe = i_e, Ube = {}, rM = {}, Coe;
function Gbe() {
  return Coe || (Coe = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var e = {
      white: "#fff",
      gray: "#484848",
      grayLight: "#82888a",
      grayLighter: "#cacccd",
      grayLightest: "#f2f2f2",
      borderMedium: "#c4c4c4",
      border: "#dbdbdb",
      borderLight: "#e4e7e7",
      borderLighter: "#eceeee",
      borderBright: "#f4f5f5",
      primary: "#00a699",
      primaryShade_1: "#33dacd",
      primaryShade_2: "#66e2da",
      primaryShade_3: "#80e8e0",
      primaryShade_4: "#b2f1ec",
      primary_dark: "#008489",
      secondary: "#007a87",
      yellow: "#ffe8bc",
      yellow_dark: "#ffce71"
    }, t = {
      reactDates: {
        zIndex: 0,
        border: {
          input: {
            border: 0,
            borderTop: 0,
            borderRight: 0,
            borderBottom: "2px solid transparent",
            borderLeft: 0,
            outlineFocused: 0,
            borderFocused: 0,
            borderTopFocused: 0,
            borderLeftFocused: 0,
            borderBottomFocused: "2px solid ".concat(e.primary_dark),
            borderRightFocused: 0,
            borderRadius: 0
          },
          pickerInput: {
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: 2
          }
        },
        color: {
          core: e,
          disabled: e.grayLightest,
          background: e.white,
          backgroundDark: "#f2f2f2",
          backgroundFocused: e.white,
          border: "rgb(219, 219, 219)",
          text: e.gray,
          textDisabled: e.border,
          textFocused: "#007a87",
          placeholderText: "#757575",
          outside: {
            backgroundColor: e.white,
            backgroundColor_active: e.white,
            backgroundColor_hover: e.white,
            color: e.gray,
            color_active: e.gray,
            color_hover: e.gray
          },
          highlighted: {
            backgroundColor: e.yellow,
            backgroundColor_active: e.yellow_dark,
            backgroundColor_hover: e.yellow_dark,
            color: e.gray,
            color_active: e.gray,
            color_hover: e.gray
          },
          minimumNights: {
            backgroundColor: e.white,
            backgroundColor_active: e.white,
            backgroundColor_hover: e.white,
            borderColor: e.borderLighter,
            color: e.grayLighter,
            color_active: e.grayLighter,
            color_hover: e.grayLighter
          },
          hoveredSpan: {
            backgroundColor: e.primaryShade_4,
            backgroundColor_active: e.primaryShade_3,
            backgroundColor_hover: e.primaryShade_4,
            borderColor: e.primaryShade_3,
            borderColor_active: e.primaryShade_3,
            borderColor_hover: e.primaryShade_3,
            color: e.secondary,
            color_active: e.secondary,
            color_hover: e.secondary
          },
          selectedSpan: {
            backgroundColor: e.primaryShade_2,
            backgroundColor_active: e.primaryShade_1,
            backgroundColor_hover: e.primaryShade_1,
            borderColor: e.primaryShade_1,
            borderColor_active: e.primary,
            borderColor_hover: e.primary,
            color: e.white,
            color_active: e.white,
            color_hover: e.white
          },
          selected: {
            backgroundColor: e.primary,
            backgroundColor_active: e.primary,
            backgroundColor_hover: e.primary,
            borderColor: e.primary,
            borderColor_active: e.primary,
            borderColor_hover: e.primary,
            color: e.white,
            color_active: e.white,
            color_hover: e.white
          },
          blocked_calendar: {
            backgroundColor: e.grayLighter,
            backgroundColor_active: e.grayLighter,
            backgroundColor_hover: e.grayLighter,
            borderColor: e.grayLighter,
            borderColor_active: e.grayLighter,
            borderColor_hover: e.grayLighter,
            color: e.grayLight,
            color_active: e.grayLight,
            color_hover: e.grayLight
          },
          blocked_out_of_range: {
            backgroundColor: e.white,
            backgroundColor_active: e.white,
            backgroundColor_hover: e.white,
            borderColor: e.borderLight,
            borderColor_active: e.borderLight,
            borderColor_hover: e.borderLight,
            color: e.grayLighter,
            color_active: e.grayLighter,
            color_hover: e.grayLighter
          }
        },
        spacing: {
          dayPickerHorizontalPadding: 9,
          captionPaddingTop: 22,
          captionPaddingBottom: 37,
          inputPadding: 0,
          displayTextPaddingVertical: void 0,
          displayTextPaddingTop: 11,
          displayTextPaddingBottom: 9,
          displayTextPaddingHorizontal: void 0,
          displayTextPaddingLeft: 11,
          displayTextPaddingRight: 11,
          displayTextPaddingVertical_small: void 0,
          displayTextPaddingTop_small: 7,
          displayTextPaddingBottom_small: 5,
          displayTextPaddingHorizontal_small: void 0,
          displayTextPaddingLeft_small: 7,
          displayTextPaddingRight_small: 7
        },
        sizing: {
          inputWidth: 130,
          inputWidth_small: 97,
          arrowWidth: 24
        },
        noScrollBarOnVerticalScrollable: !1,
        font: {
          size: 14,
          captionSize: 18,
          input: {
            size: 19,
            weight: 200,
            lineHeight: "24px",
            size_small: 15,
            lineHeight_small: "18px",
            letterSpacing_small: "0.2px",
            styleDisabled: "italic"
          }
        }
      }
    };
    i.default = t;
  }(rM)), rM;
}
(function(i) {
  var e = xt;
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), i.default = i.PureCustomizableCalendarDay = i.selectedStyles = i.lastInRangeStyles = i.selectedSpanStyles = i.hoveredSpanStyles = i.blockedOutOfRangeStyles = i.blockedCalendarStyles = i.blockedMinNightsStyles = i.highlightedCalendarStyles = i.outsideStyles = i.defaultStyles = void 0;
  var t = e(ua()), n = e(ha()), r = e(Pl()), s = e(fa()), o = e(hs()), a = e(it), l = e(mn()), c = e(yd()), d = Or(), u = Za(), h = e(gi), f = e(gq()), g = So(), p = e(ga()), m = e(sbe()), _ = mi(), b = e(Gbe());
  function w(z, X) {
    var ae = Object.keys(z);
    if (Object.getOwnPropertySymbols) {
      var ue = Object.getOwnPropertySymbols(z);
      X && (ue = ue.filter(function(se) {
        return Object.getOwnPropertyDescriptor(z, se).enumerable;
      })), ae.push.apply(ae, ue);
    }
    return ae;
  }
  function y(z) {
    for (var X = 1; X < arguments.length; X++) {
      var ae = arguments[X] != null ? arguments[X] : {};
      X % 2 ? w(Object(ae), !0).forEach(function(ue) {
        (0, o.default)(z, ue, ae[ue]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(z, Object.getOwnPropertyDescriptors(ae)) : w(Object(ae)).forEach(function(ue) {
        Object.defineProperty(z, ue, Object.getOwnPropertyDescriptor(ae, ue));
      });
    }
    return z;
  }
  var S = b.default.reactDates.color;
  function x(z, X) {
    if (!z) return null;
    var ae = z.hover;
    return X && ae ? ae : z;
  }
  var D = process.env.NODE_ENV !== "production" ? l.default.shape({
    background: l.default.string,
    border: (0, d.or)([l.default.string, l.default.number]),
    color: l.default.string,
    hover: l.default.shape({
      background: l.default.string,
      border: (0, d.or)([l.default.string, l.default.number]),
      color: l.default.string
    })
  }) : {}, E = process.env.NODE_ENV !== "production" ? (0, d.forbidExtraProps)(y({}, u.withStylesPropTypes, {
    day: c.default.momentObj,
    daySize: d.nonNegativeInteger,
    isOutsideDay: l.default.bool,
    modifiers: l.default.instanceOf(Set),
    isFocused: l.default.bool,
    tabIndex: l.default.oneOf([0, -1]),
    onDayClick: l.default.func,
    onDayMouseEnter: l.default.func,
    onDayMouseLeave: l.default.func,
    renderDayContents: l.default.func,
    ariaLabelFormat: l.default.string,
    // style overrides
    defaultStyles: D,
    outsideStyles: D,
    todayStyles: D,
    firstDayOfWeekStyles: D,
    lastDayOfWeekStyles: D,
    highlightedCalendarStyles: D,
    blockedMinNightsStyles: D,
    blockedCalendarStyles: D,
    blockedOutOfRangeStyles: D,
    hoveredSpanStyles: D,
    selectedSpanStyles: D,
    lastInRangeStyles: D,
    selectedStyles: D,
    selectedStartStyles: D,
    selectedEndStyles: D,
    afterHoveredStartStyles: D,
    hoveredStartFirstPossibleEndStyles: D,
    hoveredStartBlockedMinNightsStyles: D,
    // internationalization
    phrases: l.default.shape((0, p.default)(g.CalendarDayPhrases))
  })) : {}, L = {
    border: "1px solid ".concat(S.core.borderLight),
    color: S.text,
    background: S.background,
    hover: {
      background: S.core.borderLight,
      border: "1px solid ".concat(S.core.borderLight),
      color: "inherit"
    }
  };
  i.defaultStyles = L;
  var k = {
    background: S.outside.backgroundColor,
    border: 0,
    color: S.outside.color
  };
  i.outsideStyles = k;
  var N = {
    background: S.highlighted.backgroundColor,
    color: S.highlighted.color,
    hover: {
      background: S.highlighted.backgroundColor_hover,
      color: S.highlighted.color_active
    }
  };
  i.highlightedCalendarStyles = N;
  var I = {
    background: S.minimumNights.backgroundColor,
    border: "1px solid ".concat(S.minimumNights.borderColor),
    color: S.minimumNights.color,
    hover: {
      background: S.minimumNights.backgroundColor_hover,
      color: S.minimumNights.color_active
    }
  };
  i.blockedMinNightsStyles = I;
  var A = {
    background: S.blocked_calendar.backgroundColor,
    border: "1px solid ".concat(S.blocked_calendar.borderColor),
    color: S.blocked_calendar.color,
    hover: {
      background: S.blocked_calendar.backgroundColor_hover,
      border: "1px solid ".concat(S.blocked_calendar.borderColor),
      color: S.blocked_calendar.color_active
    }
  };
  i.blockedCalendarStyles = A;
  var P = {
    background: S.blocked_out_of_range.backgroundColor,
    border: "1px solid ".concat(S.blocked_out_of_range.borderColor),
    color: S.blocked_out_of_range.color,
    hover: {
      background: S.blocked_out_of_range.backgroundColor_hover,
      border: "1px solid ".concat(S.blocked_out_of_range.borderColor),
      color: S.blocked_out_of_range.color_active
    }
  };
  i.blockedOutOfRangeStyles = P;
  var O = {
    background: S.hoveredSpan.backgroundColor,
    border: "1px double ".concat(S.hoveredSpan.borderColor),
    color: S.hoveredSpan.color,
    hover: {
      background: S.hoveredSpan.backgroundColor_hover,
      border: "1px double ".concat(S.hoveredSpan.borderColor),
      color: S.hoveredSpan.color_active
    }
  };
  i.hoveredSpanStyles = O;
  var K = {
    background: S.selectedSpan.backgroundColor,
    border: "1px double ".concat(S.selectedSpan.borderColor),
    color: S.selectedSpan.color,
    hover: {
      background: S.selectedSpan.backgroundColor_hover,
      border: "1px double ".concat(S.selectedSpan.borderColor),
      color: S.selectedSpan.color_active
    }
  };
  i.selectedSpanStyles = K;
  var W = {};
  i.lastInRangeStyles = W;
  var F = {
    background: S.selected.backgroundColor,
    border: "1px double ".concat(S.selected.borderColor),
    color: S.selected.color,
    hover: {
      background: S.selected.backgroundColor_hover,
      border: "1px double ".concat(S.selected.borderColor),
      color: S.selected.color_active
    }
  };
  i.selectedStyles = F;
  var q = {
    day: (0, h.default)(),
    daySize: _.DAY_SIZE,
    isOutsideDay: !1,
    modifiers: /* @__PURE__ */ new Set(),
    isFocused: !1,
    tabIndex: -1,
    onDayClick: function() {
    },
    onDayMouseEnter: function() {
    },
    onDayMouseLeave: function() {
    },
    renderDayContents: null,
    ariaLabelFormat: "dddd, LL",
    // style defaults
    defaultStyles: L,
    outsideStyles: k,
    todayStyles: {},
    highlightedCalendarStyles: N,
    blockedMinNightsStyles: I,
    blockedCalendarStyles: A,
    blockedOutOfRangeStyles: P,
    hoveredSpanStyles: O,
    selectedSpanStyles: K,
    lastInRangeStyles: W,
    selectedStyles: F,
    selectedStartStyles: {},
    selectedEndStyles: {},
    afterHoveredStartStyles: {},
    firstDayOfWeekStyles: {},
    lastDayOfWeekStyles: {},
    hoveredStartFirstPossibleEndStyles: {},
    hoveredStartBlockedMinNightsStyles: {},
    // internationalization
    phrases: g.CalendarDayPhrases
  }, R = /* @__PURE__ */ function(z) {
    (0, s.default)(ae, z);
    var X = ae.prototype;
    X[!a.default.PureComponent && "shouldComponentUpdate"] = function(ue, se) {
      return !(0, t.default)(this.props, ue) || !(0, t.default)(this.state, se);
    };
    function ae() {
      for (var ue, se = arguments.length, le = new Array(se), oe = 0; oe < se; oe++)
        le[oe] = arguments[oe];
      return ue = z.call.apply(z, [this].concat(le)) || this, ue.state = {
        isHovered: !1
      }, ue.setButtonRef = ue.setButtonRef.bind((0, r.default)(ue)), ue;
    }
    return X.componentDidUpdate = function(se) {
      var le = this, oe = this.props, re = oe.isFocused, B = oe.tabIndex;
      B === 0 && (re || B !== se.tabIndex) && (0, f.default)(function() {
        le.buttonRef && le.buttonRef.focus();
      });
    }, X.onDayClick = function(se, le) {
      var oe = this.props.onDayClick;
      oe(se, le);
    }, X.onDayMouseEnter = function(se, le) {
      var oe = this.props.onDayMouseEnter;
      this.setState({
        isHovered: !0
      }), oe(se, le);
    }, X.onDayMouseLeave = function(se, le) {
      var oe = this.props.onDayMouseLeave;
      this.setState({
        isHovered: !1
      }), oe(se, le);
    }, X.onKeyDown = function(se, le) {
      var oe = this.props.onDayClick, re = le.key;
      (re === "Enter" || re === " ") && oe(se, le);
    }, X.setButtonRef = function(se) {
      this.buttonRef = se;
    }, X.render = function() {
      var se = this, le = this.props, oe = le.day, re = le.ariaLabelFormat, B = le.daySize, ee = le.isOutsideDay, j = le.modifiers, he = le.tabIndex, Se = le.renderDayContents, ge = le.styles, te = le.phrases, be = le.defaultStyles, Ae = le.outsideStyles, He = le.todayStyles, de = le.firstDayOfWeekStyles, ce = le.lastDayOfWeekStyles, ie = le.highlightedCalendarStyles, H = le.blockedMinNightsStyles, Y = le.blockedCalendarStyles, Z = le.blockedOutOfRangeStyles, Q = le.hoveredSpanStyles, me = le.selectedSpanStyles, Le = le.lastInRangeStyles, xe = le.selectedStyles, Ue = le.selectedStartStyles, je = le.selectedEndStyles, Ze = le.afterHoveredStartStyles, _e = le.hoveredStartFirstPossibleEndStyles, U = le.hoveredStartBlockedMinNightsStyles, fe = this.state.isHovered;
      if (!oe) return a.default.createElement("td", null);
      var Ee = (0, m.default)(oe, re, B, j, te), Me = Ee.daySizeStyles, Pe = Ee.useDefaultCursor, et = Ee.selected, gt = Ee.hoveredSpan, Vt = Ee.isOutsideRange, Zt = Ee.ariaLabel;
      return a.default.createElement("td", (0, n.default)({}, (0, u.css)(ge.CalendarDay, Pe && ge.CalendarDay__defaultCursor, Me, x(be, fe), ee && x(Ae, fe), j.has("today") && x(He, fe), j.has("first-day-of-week") && x(de, fe), j.has("last-day-of-week") && x(ce, fe), j.has("hovered-start-first-possible-end") && x(_e, fe), j.has("hovered-start-blocked-minimum-nights") && x(U, fe), j.has("highlighted-calendar") && x(ie, fe), j.has("blocked-minimum-nights") && x(H, fe), j.has("blocked-calendar") && x(Y, fe), gt && x(Q, fe), j.has("after-hovered-start") && x(Ze, fe), j.has("selected-span") && x(me, fe), j.has("last-in-range") && x(Le, fe), et && x(xe, fe), j.has("selected-start") && x(Ue, fe), j.has("selected-end") && x(je, fe), Vt && x(Z, fe)), {
        role: "button",
        ref: this.setButtonRef,
        "aria-disabled": j.has("blocked"),
        "aria-label": Zt,
        onMouseEnter: function(Ht) {
          se.onDayMouseEnter(oe, Ht);
        },
        onMouseLeave: function(Ht) {
          se.onDayMouseLeave(oe, Ht);
        },
        onMouseUp: function(Ht) {
          Ht.currentTarget.blur();
        },
        onClick: function(Ht) {
          se.onDayClick(oe, Ht);
        },
        onKeyDown: function(Ht) {
          se.onKeyDown(oe, Ht);
        },
        tabIndex: he
      }), Se ? Se(oe, j) : oe.format("D"));
    }, ae;
  }(a.default.PureComponent || a.default.Component);
  i.PureCustomizableCalendarDay = R, R.propTypes = process.env.NODE_ENV !== "production" ? E : {}, R.defaultProps = q;
  var T = (0, u.withStyles)(function(z) {
    var X = z.reactDates.font;
    return {
      CalendarDay: {
        boxSizing: "border-box",
        cursor: "pointer",
        fontSize: X.size,
        textAlign: "center",
        ":active": {
          outline: 0
        }
      },
      CalendarDay__defaultCursor: {
        cursor: "default"
      }
    };
  }, {
    pureComponent: typeof a.default.PureComponent < "u"
  })(R);
  i.default = T;
})(Ube);
const cut = /* @__PURE__ */ eb(Ube), sM = {
  background: "var(--B100)",
  color: "var(--B500)",
  hover: {
    background: "var(--B500)",
    color: "#fff"
  }
}, dut = {
  background: "var(--B100)",
  color: "var(--B500)",
  hover: {
    background: "var(--B500)",
    color: "#fff"
  }
}, uut = {
  background: "var(--B100)",
  color: "var(--B500)"
}, qbe = {
  selectedStartStyles: sM,
  selectedEndStyles: sM,
  hoveredSpanStyles: uut,
  selectedSpanStyles: dut,
  selectedStyles: sM,
  border: "none"
}, hut = {
  "Day 1": "1",
  "Day 2": "2",
  "Day 3": "3",
  "Day 4": "4",
  "Day 5": "5",
  "Day 6": "6",
  "Day 7": "7",
  "Day 8": "8",
  "Day 9": "9",
  "Day 10": "10",
  "Day 11": "11",
  "Day 12": "12",
  "Day 13": "13",
  "Day 14": "14",
  "Day 15": "15",
  "Day 16": "16",
  "Day 17": "17",
  "Day 18": "18",
  "Day 19": "19",
  "Day 20": "20",
  "Day 21": "21",
  "Day 22": "22",
  "Day 23": "23",
  "Day 24": "24",
  "Day 25": "25",
  "Day 26": "26",
  "Day 27": "27",
  "Day 28": "28",
  "Third Last Day": "-3",
  "Second Last Day": "-2",
  "Last Day": "-1"
}, fut = {
  "12:00 AM": "00:00:00",
  "12:30 AM": "00:30:00",
  "01:00 AM": "01:00:00",
  "01:30 AM": "01:30:00",
  "02:00 AM": "02:00:00",
  "02:30 AM": "02:30:00",
  "03:00 AM": "03:00:00",
  "03:30 AM": "03:30:00",
  "04:00 AM": "04:00:00",
  "04:30 AM": "04:30:00",
  "05:00 AM": "05:00:00",
  "05:30 AM": "05:30:00",
  "06:00 AM": "06:00:00",
  "06:30 AM": "06:30:00",
  "07:00 AM": "07:00:00",
  "07:30 AM": "07:30:00",
  "08:00 AM": "08:00:00",
  "08:30 AM": "08:30:00",
  "09:00 AM": "09:00:00",
  "09:30 AM": "09:30:00",
  "10:00 AM": "10:00:00",
  "10:30 AM": "10:30:00",
  "11:00 AM": "11:00:00",
  "11:30 AM": "11:30:00",
  "12:00 PM": "12:00:00",
  "12:30 PM": "12:30:00",
  "01:00 PM": "13:00:00",
  "01:30 PM": "13:30:00",
  "02:00 PM": "14:00:00",
  "02:30 PM": "14:30:00",
  "03:00 PM": "15:00:00",
  "03:30 PM": "15:30:00",
  "04:00 PM": "16:00:00",
  "04:30 PM": "16:30:00",
  "05:00 PM": "17:00:00",
  "05:30 PM": "17:30:00",
  "06:00 PM": "18:00:00",
  "06:30 PM": "18:30:00",
  "07:00 PM": "19:00:00",
  "07:30 PM": "19:30:00",
  "08:00 PM": "20:00:00",
  "08:30 PM": "20:30:00",
  "09:00 PM": "21:00:00",
  "09:30 PM": "21:30:00",
  "10:00 PM": "22:00:00",
  "10:30 PM": "22:30:00",
  "11:00 PM": "23:00:00",
  "11:30 PM": "23:30:00"
}, gut = {
  DATE: "Select date",
  TIME: "Select time",
  MONTH: "Select month",
  DEFAULT_TIME: "12:00 AM",
  DEFAULT_MONTHLY_DATE: "Day 1"
}, WI = {
  DATE: "date_picker",
  MONTH: "month_picker",
  TIME: "time_picker"
}, ESt = {
  container: (i) => ({
    ...i,
    height: "36px"
  }),
  control: (i, e) => ({
    ...i,
    boxShadow: "none",
    minHeight: "36px",
    cursor: "pointer",
    borderColor: "var(--N200)",
    backgroundColor: "var(--N50)",
    ...e.isDisabled ? {
      borderColor: "var(--N200)",
      backgroundColor: "var(--N100)",
      cursor: "not-allowed"
    } : {},
    "&:hover": {
      borderColor: "var(--N400)"
    },
    "&:focus, &:focus-within": {
      borderColor: "var(--B500)",
      outline: "none"
    }
  }),
  valueContainer: (i) => ({
    ...i,
    padding: 0,
    width: "180px"
  }),
  input: (i) => ({
    ...i,
    padding: 0,
    margin: 0
  }),
  dropdownIndicator: (i, e) => ({
    ...i,
    transition: "all .2s ease",
    transform: e.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
    padding: 0
  }),
  option: (i) => ({
    ...i,
    fontSize: "13px",
    cursor: "pointer"
  }),
  menuList: (i) => ({
    ...i,
    position: "relative",
    paddingBottom: "0px",
    maxHeight: "250px",
    width: "200px"
  })
};
var oM = {}, aM = {}, lM, yoe;
function Kbe() {
  if (yoe) return lM;
  yoe = 1;
  var i = As(), e = i("%Math.abs%"), t = i("%Math.floor%"), n = lx(), r = dq();
  return lM = function(o) {
    if (typeof o != "number" || n(o) || !r(o))
      return !1;
    var a = e(o);
    return t(a) === a;
  }, lM;
}
var cM, woe;
function put() {
  if (woe) return cM;
  woe = 1;
  var i = As(), e = i("%Array.prototype%"), t = o_e(), n = ik(), r = Jn(), s = Kbe(), o = Math.pow(2, 32) - 1, a = l_e()(), l = i("%Object.setPrototypeOf%", !0) || (a ? function(c, d) {
    return c.__proto__ = d, c;
  } : null);
  return cM = function(d) {
    if (!s(d) || d < 0)
      throw new r("Assertion failed: `length` must be an integer Number >= 0");
    if (d > o)
      throw new t("length is greater than (2**32 - 1)");
    var u = arguments.length > 1 ? arguments[1] : e, h = [];
    if (u !== e) {
      if (!l)
        throw new n("ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]");
      l(h, u);
    }
    return d !== 0 && (h.length = d), h;
  }, cM;
}
const mut = {}, vut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mut
}, Symbol.toStringTag, { value: "Module" })), _ut = /* @__PURE__ */ L0(vut);
var dM, Soe;
function but() {
  if (Soe) return dM;
  Soe = 1;
  var i = typeof Map == "function" && Map.prototype, e = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, t = i && e && typeof e.get == "function" ? e.get : null, n = i && Map.prototype.forEach, r = typeof Set == "function" && Set.prototype, s = Object.getOwnPropertyDescriptor && r ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, o = r && s && typeof s.get == "function" ? s.get : null, a = r && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, c = l ? WeakMap.prototype.has : null, d = typeof WeakSet == "function" && WeakSet.prototype, u = d ? WeakSet.prototype.has : null, h = typeof WeakRef == "function" && WeakRef.prototype, f = h ? WeakRef.prototype.deref : null, g = Boolean.prototype.valueOf, p = Object.prototype.toString, m = Function.prototype.toString, _ = String.prototype.match, b = String.prototype.slice, w = String.prototype.replace, y = String.prototype.toUpperCase, S = String.prototype.toLowerCase, x = RegExp.prototype.test, D = Array.prototype.concat, E = Array.prototype.join, L = Array.prototype.slice, k = Math.floor, N = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, I = Object.getOwnPropertySymbols, A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, P = typeof Symbol == "function" && typeof Symbol.iterator == "object", O = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === P || !0) ? Symbol.toStringTag : null, K = Object.prototype.propertyIsEnumerable, W = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(_e) {
    return _e.__proto__;
  } : null);
  function F(_e, U) {
    if (_e === 1 / 0 || _e === -1 / 0 || _e !== _e || _e && _e > -1e3 && _e < 1e3 || x.call(/e/, U))
      return U;
    var fe = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof _e == "number") {
      var Ee = _e < 0 ? -k(-_e) : k(_e);
      if (Ee !== _e) {
        var Me = String(Ee), Pe = b.call(U, Me.length + 1);
        return w.call(Me, fe, "$&_") + "." + w.call(w.call(Pe, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return w.call(U, fe, "$&_");
  }
  var q = _ut, R = q.custom, T = ee(R) ? R : null;
  dM = function _e(U, fe, Ee, Me) {
    var Pe = fe || {};
    if (Se(Pe, "quoteStyle") && Pe.quoteStyle !== "single" && Pe.quoteStyle !== "double")
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Se(Pe, "maxStringLength") && (typeof Pe.maxStringLength == "number" ? Pe.maxStringLength < 0 && Pe.maxStringLength !== 1 / 0 : Pe.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var et = Se(Pe, "customInspect") ? Pe.customInspect : !0;
    if (typeof et != "boolean" && et !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Se(Pe, "indent") && Pe.indent !== null && Pe.indent !== "	" && !(parseInt(Pe.indent, 10) === Pe.indent && Pe.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Se(Pe, "numericSeparator") && typeof Pe.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var gt = Pe.numericSeparator;
    if (typeof U > "u")
      return "undefined";
    if (U === null)
      return "null";
    if (typeof U == "boolean")
      return U ? "true" : "false";
    if (typeof U == "string")
      return Y(U, Pe);
    if (typeof U == "number") {
      if (U === 0)
        return 1 / 0 / U > 0 ? "0" : "-0";
      var Vt = String(U);
      return gt ? F(U, Vt) : Vt;
    }
    if (typeof U == "bigint") {
      var Zt = String(U) + "n";
      return gt ? F(U, Zt) : Zt;
    }
    var St = typeof Pe.depth > "u" ? 5 : Pe.depth;
    if (typeof Ee > "u" && (Ee = 0), Ee >= St && St > 0 && typeof U == "object")
      return ae(U) ? "[Array]" : "[Object]";
    var Ht = Ue(Pe, Ee);
    if (typeof Me > "u")
      Me = [];
    else if (be(Me, U) >= 0)
      return "[Circular]";
    function fn(mt, De, Qe) {
      if (De && (Me = L.call(Me), Me.push(De)), Qe) {
        var ct = {
          depth: Pe.depth
        };
        return Se(Pe, "quoteStyle") && (ct.quoteStyle = Pe.quoteStyle), _e(mt, ct, Ee + 1, Me);
      }
      return _e(mt, Pe, Ee + 1, Me);
    }
    if (typeof U == "function" && !se(U)) {
      var xn = te(U), rt = Ze(U, fn);
      return "[Function" + (xn ? ": " + xn : " (anonymous)") + "]" + (rt.length > 0 ? " { " + E.call(rt, ", ") + " }" : "");
    }
    if (ee(U)) {
      var Ei = P ? w.call(String(U), /^(Symbol\(.*\))_[^)]*$/, "$1") : A.call(U);
      return typeof U == "object" && !P ? Q(Ei) : Ei;
    }
    if (H(U)) {
      for (var Nn = "<" + S.call(String(U.nodeName)), Gi = U.attributes || [], Ce = 0; Ce < Gi.length; Ce++)
        Nn += " " + Gi[Ce].name + "=" + z(X(Gi[Ce].value), "double", Pe);
      return Nn += ">", U.childNodes && U.childNodes.length && (Nn += "..."), Nn += "</" + S.call(String(U.nodeName)) + ">", Nn;
    }
    if (ae(U)) {
      if (U.length === 0)
        return "[]";
      var Xe = Ze(U, fn);
      return Ht && !xe(Xe) ? "[" + je(Xe, Ht) + "]" : "[ " + E.call(Xe, ", ") + " ]";
    }
    if (le(U)) {
      var nt = Ze(U, fn);
      return !("cause" in Error.prototype) && "cause" in U && !K.call(U, "cause") ? "{ [" + String(U) + "] " + E.call(D.call("[cause]: " + fn(U.cause), nt), ", ") + " }" : nt.length === 0 ? "[" + String(U) + "]" : "{ [" + String(U) + "] " + E.call(nt, ", ") + " }";
    }
    if (typeof U == "object" && et) {
      if (T && typeof U[T] == "function" && q)
        return q(U, { depth: St - Ee });
      if (et !== "symbol" && typeof U.inspect == "function")
        return U.inspect();
    }
    if (Ae(U)) {
      var At = [];
      return n && n.call(U, function(mt, De) {
        At.push(fn(De, U, !0) + " => " + fn(mt, U));
      }), Le("Map", t.call(U), At, Ht);
    }
    if (ce(U)) {
      var tn = [];
      return a && a.call(U, function(mt) {
        tn.push(fn(mt, U));
      }), Le("Set", o.call(U), tn, Ht);
    }
    if (He(U))
      return me("WeakMap");
    if (ie(U))
      return me("WeakSet");
    if (de(U))
      return me("WeakRef");
    if (re(U))
      return Q(fn(Number(U)));
    if (j(U))
      return Q(fn(N.call(U)));
    if (B(U))
      return Q(g.call(U));
    if (oe(U))
      return Q(fn(String(U)));
    if (typeof window < "u" && U === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && U === globalThis || typeof Zs < "u" && U === Zs)
      return "{ [object globalThis] }";
    if (!ue(U) && !se(U)) {
      var qt = Ze(U, fn), Kt = W ? W(U) === Object.prototype : U instanceof Object || U.constructor === Object, Pt = U instanceof Object ? "" : "null prototype", _i = !Kt && O && Object(U) === U && O in U ? b.call(ge(U), 8, -1) : Pt ? "Object" : "", vn = Kt || typeof U.constructor != "function" ? "" : U.constructor.name ? U.constructor.name + " " : "", $n = vn + (_i || Pt ? "[" + E.call(D.call([], _i || [], Pt || []), ": ") + "] " : "");
      return qt.length === 0 ? $n + "{}" : Ht ? $n + "{" + je(qt, Ht) + "}" : $n + "{ " + E.call(qt, ", ") + " }";
    }
    return String(U);
  };
  function z(_e, U, fe) {
    var Ee = (fe.quoteStyle || U) === "double" ? '"' : "'";
    return Ee + _e + Ee;
  }
  function X(_e) {
    return w.call(String(_e), /"/g, "&quot;");
  }
  function ae(_e) {
    return ge(_e) === "[object Array]" && (!O || !(typeof _e == "object" && O in _e));
  }
  function ue(_e) {
    return ge(_e) === "[object Date]" && (!O || !(typeof _e == "object" && O in _e));
  }
  function se(_e) {
    return ge(_e) === "[object RegExp]" && (!O || !(typeof _e == "object" && O in _e));
  }
  function le(_e) {
    return ge(_e) === "[object Error]" && (!O || !(typeof _e == "object" && O in _e));
  }
  function oe(_e) {
    return ge(_e) === "[object String]" && (!O || !(typeof _e == "object" && O in _e));
  }
  function re(_e) {
    return ge(_e) === "[object Number]" && (!O || !(typeof _e == "object" && O in _e));
  }
  function B(_e) {
    return ge(_e) === "[object Boolean]" && (!O || !(typeof _e == "object" && O in _e));
  }
  function ee(_e) {
    if (P)
      return _e && typeof _e == "object" && _e instanceof Symbol;
    if (typeof _e == "symbol")
      return !0;
    if (!_e || typeof _e != "object" || !A)
      return !1;
    try {
      return A.call(_e), !0;
    } catch {
    }
    return !1;
  }
  function j(_e) {
    if (!_e || typeof _e != "object" || !N)
      return !1;
    try {
      return N.call(_e), !0;
    } catch {
    }
    return !1;
  }
  var he = Object.prototype.hasOwnProperty || function(_e) {
    return _e in this;
  };
  function Se(_e, U) {
    return he.call(_e, U);
  }
  function ge(_e) {
    return p.call(_e);
  }
  function te(_e) {
    if (_e.name)
      return _e.name;
    var U = _.call(m.call(_e), /^function\s*([\w$]+)/);
    return U ? U[1] : null;
  }
  function be(_e, U) {
    if (_e.indexOf)
      return _e.indexOf(U);
    for (var fe = 0, Ee = _e.length; fe < Ee; fe++)
      if (_e[fe] === U)
        return fe;
    return -1;
  }
  function Ae(_e) {
    if (!t || !_e || typeof _e != "object")
      return !1;
    try {
      t.call(_e);
      try {
        o.call(_e);
      } catch {
        return !0;
      }
      return _e instanceof Map;
    } catch {
    }
    return !1;
  }
  function He(_e) {
    if (!c || !_e || typeof _e != "object")
      return !1;
    try {
      c.call(_e, c);
      try {
        u.call(_e, u);
      } catch {
        return !0;
      }
      return _e instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function de(_e) {
    if (!f || !_e || typeof _e != "object")
      return !1;
    try {
      return f.call(_e), !0;
    } catch {
    }
    return !1;
  }
  function ce(_e) {
    if (!o || !_e || typeof _e != "object")
      return !1;
    try {
      o.call(_e);
      try {
        t.call(_e);
      } catch {
        return !0;
      }
      return _e instanceof Set;
    } catch {
    }
    return !1;
  }
  function ie(_e) {
    if (!u || !_e || typeof _e != "object")
      return !1;
    try {
      u.call(_e, u);
      try {
        c.call(_e, c);
      } catch {
        return !0;
      }
      return _e instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function H(_e) {
    return !_e || typeof _e != "object" ? !1 : typeof HTMLElement < "u" && _e instanceof HTMLElement ? !0 : typeof _e.nodeName == "string" && typeof _e.getAttribute == "function";
  }
  function Y(_e, U) {
    if (_e.length > U.maxStringLength) {
      var fe = _e.length - U.maxStringLength, Ee = "... " + fe + " more character" + (fe > 1 ? "s" : "");
      return Y(b.call(_e, 0, U.maxStringLength), U) + Ee;
    }
    var Me = w.call(w.call(_e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Z);
    return z(Me, "single", U);
  }
  function Z(_e) {
    var U = _e.charCodeAt(0), fe = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[U];
    return fe ? "\\" + fe : "\\x" + (U < 16 ? "0" : "") + y.call(U.toString(16));
  }
  function Q(_e) {
    return "Object(" + _e + ")";
  }
  function me(_e) {
    return _e + " { ? }";
  }
  function Le(_e, U, fe, Ee) {
    var Me = Ee ? je(fe, Ee) : E.call(fe, ", ");
    return _e + " (" + U + ") {" + Me + "}";
  }
  function xe(_e) {
    for (var U = 0; U < _e.length; U++)
      if (be(_e[U], `
`) >= 0)
        return !1;
    return !0;
  }
  function Ue(_e, U) {
    var fe;
    if (_e.indent === "	")
      fe = "	";
    else if (typeof _e.indent == "number" && _e.indent > 0)
      fe = E.call(Array(_e.indent + 1), " ");
    else
      return null;
    return {
      base: fe,
      prev: E.call(Array(U + 1), fe)
    };
  }
  function je(_e, U) {
    if (_e.length === 0)
      return "";
    var fe = `
` + U.prev + U.base;
    return fe + E.call(_e, "," + fe) + `
` + U.prev;
  }
  function Ze(_e, U) {
    var fe = ae(_e), Ee = [];
    if (fe) {
      Ee.length = _e.length;
      for (var Me = 0; Me < _e.length; Me++)
        Ee[Me] = Se(_e, Me) ? U(_e[Me], _e) : "";
    }
    var Pe = typeof I == "function" ? I(_e) : [], et;
    if (P) {
      et = {};
      for (var gt = 0; gt < Pe.length; gt++)
        et["$" + Pe[gt]] = Pe[gt];
    }
    for (var Vt in _e)
      Se(_e, Vt) && (fe && String(Number(Vt)) === Vt && Vt < _e.length || P && et["$" + Vt] instanceof Symbol || (x.call(/[^\w$]/, Vt) ? Ee.push(U(Vt, _e) + ": " + U(_e[Vt], _e)) : Ee.push(Vt + ": " + U(_e[Vt], _e))));
    if (typeof I == "function")
      for (var Zt = 0; Zt < Pe.length; Zt++)
        K.call(_e, Pe[Zt]) && Ee.push("[" + U(Pe[Zt]) + "]: " + U(_e[Pe[Zt]], _e));
    return Ee;
  }
  return dM;
}
var uM, xoe;
function gk() {
  if (xoe) return uM;
  xoe = 1;
  var i = Jn(), e = but(), t = pf(), n = _c();
  return uM = function(s, o) {
    if (n(s) !== "Object")
      throw new i("Assertion failed: Type(O) is not Object");
    if (!t(o))
      throw new i("Assertion failed: IsPropertyKey(P) is not true, got " + e(o));
    return s[o];
  }, uM;
}
var hM, Doe;
function xq() {
  return Doe || (Doe = 1, hM = b_e()), hM;
}
var l3 = { exports: {} }, fM, Eoe;
function Cut() {
  return Eoe || (Eoe = 1, fM = As()), fM;
}
var gM, Loe;
function yut() {
  return Loe || (Loe = 1, gM = function(e) {
    return !!e;
  }), gM;
}
var pM, Ioe;
function Ybe() {
  if (Ioe) return pM;
  Ioe = 1;
  var i = Bu(), e = Jn(), t = _c(), n = yut(), r = V_e();
  return pM = function(o) {
    if (t(o) !== "Object")
      throw new e("ToPropertyDescriptor requires an object");
    var a = {};
    if (i(o, "enumerable") && (a["[[Enumerable]]"] = n(o.enumerable)), i(o, "configurable") && (a["[[Configurable]]"] = n(o.configurable)), i(o, "value") && (a["[[Value]]"] = o.value), i(o, "writable") && (a["[[Writable]]"] = n(o.writable)), i(o, "get")) {
      var l = o.get;
      if (typeof l < "u" && !r(l))
        throw new e("getter must be a function");
      a["[[Get]]"] = l;
    }
    if (i(o, "set")) {
      var c = o.set;
      if (typeof c < "u" && !r(c))
        throw new e("setter must be a function");
      a["[[Set]]"] = c;
    }
    if ((i(a, "[[Get]]") || i(a, "[[Set]]")) && (i(a, "[[Value]]") || i(a, "[[Writable]]")))
      throw new e("Invalid property descriptor. Cannot both specify accessors and a value or writable attribute");
    return a;
  }, pM;
}
var mM, Aoe;
function wut() {
  if (Aoe) return mM;
  Aoe = 1;
  var i = Jn(), e = bp(), t = eq(), n = tq(), r = ok(), s = pf(), o = ak(), a = Ybe(), l = _c();
  return mM = function(d, u, h) {
    if (l(d) !== "Object")
      throw new i("Assertion failed: Type(O) is not Object");
    if (!s(u))
      throw new i("Assertion failed: IsPropertyKey(P) is not true");
    var f = e(h) ? h : a(h);
    if (!e(f))
      throw new i("Assertion failed: Desc is not a valid Property Descriptor");
    return t(
      r,
      o,
      n,
      d,
      u,
      f
    );
  }, mM;
}
var koe;
function Sut() {
  if (koe) return l3.exports;
  koe = 1;
  var i = Cut(), e = i("%Reflect.construct%", !0), t = wut();
  try {
    t({}, "", { "[[Get]]": function() {
    } });
  } catch {
    t = null;
  }
  if (t && e) {
    var n = {}, r = {};
    t(r, "length", {
      "[[Get]]": function() {
        throw n;
      },
      "[[Enumerable]]": !0
    }), l3.exports = function(o) {
      try {
        e(o, r);
      } catch (a) {
        return a === n;
      }
    };
  } else
    l3.exports = function(o) {
      return typeof o == "function" && !!o.prototype;
    };
  return l3.exports;
}
var vM, Toe;
function xut() {
  if (Toe) return vM;
  Toe = 1;
  var i = As(), e = i("%Symbol.species%", !0), t = Jn(), n = put(), r = gk(), s = xq(), o = Sut(), a = _c(), l = Kbe();
  return vM = function(d, u) {
    if (!l(u) || u < 0)
      throw new t("Assertion failed: length must be an integer >= 0");
    var h = s(d);
    if (!h)
      return n(u);
    var f = r(d, "constructor");
    if (e && a(f) === "Object" && (f = r(f, e), f === null && (f = void 0)), typeof f > "u")
      return n(u);
    if (!o(f))
      throw new t("C must be a constructor");
    return new f(u);
  }, vM;
}
var _M, Noe;
function Dut() {
  if (Noe) return _M;
  Noe = 1;
  var i = As(), e = Xa(), t = Jn(), n = xq(), r = i("%Reflect.apply%", !0) || e("Function.prototype.apply");
  return _M = function(o, a) {
    var l = arguments.length > 2 ? arguments[2] : [];
    if (!n(l))
      throw new t("Assertion failed: optional `argumentsList`, if provided, must be a List");
    return r(o, a, l);
  }, _M;
}
var bM, Poe;
function Dq() {
  if (Poe) return bM;
  Poe = 1;
  var i = Jn(), e = Bu(), t = bp();
  return bM = function(r) {
    if (typeof r > "u")
      return !1;
    if (!t(r))
      throw new i("Assertion failed: `Desc` must be a Property Descriptor");
    return !(!e(r, "[[Get]]") && !e(r, "[[Set]]"));
  }, bM;
}
var CM, Ooe;
function Eut() {
  if (Ooe) return CM;
  Ooe = 1;
  var i = As(), e = i("%Object.preventExtensions%", !0), t = i("%Object.isExtensible%", !0), n = lq();
  return CM = e ? function(s) {
    return !n(s) && t(s);
  } : function(s) {
    return !n(s);
  }, CM;
}
var yM, Moe;
function Lut() {
  if (Moe) return yM;
  Moe = 1;
  var i = bp();
  return yM = function(t, n) {
    return i(n) && typeof n == "object" && "[[Enumerable]]" in n && "[[Configurable]]" in n && (t.IsAccessorDescriptor(n) || t.IsDataDescriptor(n));
  }, yM;
}
var wM, Roe;
function Iut() {
  if (Roe) return wM;
  Roe = 1;
  var i = Jn(), e = Dq(), t = ok(), n = bp();
  return wM = function(s) {
    if (typeof s > "u")
      return !1;
    if (!n(s))
      throw new i("Assertion failed: `Desc` must be a Property Descriptor");
    return !e(s) && !t(s);
  }, wM;
}
var SM, Foe;
function Aut() {
  if (Foe) return SM;
  Foe = 1;
  var i = Jn(), e = eq(), t = Lut(), n = bp(), r = tq(), s = Dq(), o = ok(), a = Iut(), l = pf(), c = ak(), d = _c();
  return SM = function(h, f, g, p, m) {
    var _ = d(h);
    if (_ !== "Undefined" && _ !== "Object")
      throw new i("Assertion failed: O must be undefined or an Object");
    if (!l(f))
      throw new i("Assertion failed: P must be a Property Key");
    if (typeof g != "boolean")
      throw new i("Assertion failed: extensible must be a Boolean");
    if (!n(p))
      throw new i("Assertion failed: Desc must be a Property Descriptor");
    if (typeof m < "u" && !n(m))
      throw new i("Assertion failed: current must be a Property Descriptor, or undefined");
    if (typeof m > "u")
      return g ? _ === "Undefined" ? !0 : s(p) ? e(
        o,
        c,
        r,
        h,
        f,
        p
      ) : e(
        o,
        c,
        r,
        h,
        f,
        {
          "[[Configurable]]": !!p["[[Configurable]]"],
          "[[Enumerable]]": !!p["[[Enumerable]]"],
          "[[Value]]": p["[[Value]]"],
          "[[Writable]]": !!p["[[Writable]]"]
        }
      ) : !1;
    if (!t(
      {
        IsAccessorDescriptor: s,
        IsDataDescriptor: o
      },
      m
    ))
      throw new i("`current`, when present, must be a fully populated and valid Property Descriptor");
    if (!m["[[Configurable]]"]) {
      if ("[[Configurable]]" in p && p["[[Configurable]]"] || "[[Enumerable]]" in p && !c(p["[[Enumerable]]"], m["[[Enumerable]]"]) || !a(p) && !c(s(p), s(m)))
        return !1;
      if (s(m)) {
        if ("[[Get]]" in p && !c(p["[[Get]]"], m["[[Get]]"]) || "[[Set]]" in p && !c(p["[[Set]]"], m["[[Set]]"]))
          return !1;
      } else if (!m["[[Writable]]"] && ("[[Writable]]" in p && p["[[Writable]]"] || "[[Value]]" in p && !c(p["[[Value]]"], m["[[Value]]"])))
        return !1;
    }
    if (_ !== "Undefined") {
      var b, w;
      return o(m) && s(p) ? (b = ("[[Configurable]]" in p ? p : m)["[[Configurable]]"], w = ("[[Enumerable]]" in p ? p : m)["[[Enumerable]]"], e(
        o,
        c,
        r,
        h,
        f,
        {
          "[[Configurable]]": !!b,
          "[[Enumerable]]": !!w,
          "[[Get]]": ("[[Get]]" in p ? p : m)["[[Get]]"],
          "[[Set]]": ("[[Set]]" in p ? p : m)["[[Set]]"]
        }
      )) : s(m) && o(p) ? (b = ("[[Configurable]]" in p ? p : m)["[[Configurable]]"], w = ("[[Enumerable]]" in p ? p : m)["[[Enumerable]]"], e(
        o,
        c,
        r,
        h,
        f,
        {
          "[[Configurable]]": !!b,
          "[[Enumerable]]": !!w,
          "[[Value]]": ("[[Value]]" in p ? p : m)["[[Value]]"],
          "[[Writable]]": !!("[[Writable]]" in p ? p : m)["[[Writable]]"]
        }
      )) : e(
        o,
        c,
        r,
        h,
        f,
        p
      );
    }
    return !0;
  }, SM;
}
var xM, Boe;
function kut() {
  if (Boe) return xM;
  Boe = 1;
  var i = sk(), e = ik(), t = Jn(), n = bp(), r = Dq(), s = Eut(), o = pf(), a = Ybe(), l = ak(), c = _c(), d = Aut();
  return xM = function(h, f, g) {
    if (c(h) !== "Object")
      throw new t("Assertion failed: O must be an Object");
    if (!o(f))
      throw new t("Assertion failed: P must be a Property Key");
    if (!n(g))
      throw new t("Assertion failed: Desc must be a Property Descriptor");
    if (!i) {
      if (r(g))
        throw new e("This environment does not support accessor property descriptors.");
      var p = !(f in h) && g["[[Writable]]"] && g["[[Enumerable]]"] && g["[[Configurable]]"] && "[[Value]]" in g, m = f in h && (!("[[Configurable]]" in g) || g["[[Configurable]]"]) && (!("[[Enumerable]]" in g) || g["[[Enumerable]]"]) && (!("[[Writable]]" in g) || g["[[Writable]]"]) && "[[Value]]" in g;
      if (p || m)
        return h[f] = g["[[Value]]"], l(h[f], g["[[Value]]"]);
      throw new e("This environment does not support defining non-writable, non-enumerable, or non-configurable properties");
    }
    var _ = i(h, f), b = _ && a(_), w = s(h);
    return d(h, f, w, g, b);
  }, xM;
}
var DM, Voe;
function Tut() {
  if (Voe) return DM;
  Voe = 1;
  var i = Jn(), e = pf(), t = kut(), n = _c();
  return DM = function(s, o, a) {
    if (n(s) !== "Object")
      throw new i("Assertion failed: Type(O) is not Object");
    if (!e(o))
      throw new i("Assertion failed: IsPropertyKey(P) is not true");
    var l = {
      "[[Configurable]]": !0,
      "[[Enumerable]]": !0,
      "[[Value]]": a,
      "[[Writable]]": !0
    };
    return t(s, o, l);
  }, DM;
}
var EM, Hoe;
function Nut() {
  if (Hoe) return EM;
  Hoe = 1;
  var i = Jn(), e = Tut(), t = pf(), n = _c();
  return EM = function(s, o, a) {
    if (n(s) !== "Object")
      throw new i("Assertion failed: Type(O) is not Object");
    if (!t(o))
      throw new i("Assertion failed: IsPropertyKey(P) is not true");
    var l = e(s, o, a);
    if (!l)
      throw new i("unable to create data property");
  }, EM;
}
var LM, Woe;
function Put() {
  if (Woe) return LM;
  Woe = 1;
  var i = Jn(), e = pf(), t = _c();
  return LM = function(r, s) {
    if (t(r) !== "Object")
      throw new i("Assertion failed: `O` must be an Object");
    if (!e(s))
      throw new i("Assertion failed: `P` must be a Property Key");
    return s in r;
  }, LM;
}
var IM, joe;
function Out() {
  if (joe) return IM;
  joe = 1;
  var i = A_e();
  return IM = function(t) {
    return arguments.length > 1 ? i(t, arguments[1]) : i(t);
  }, IM;
}
var AM, zoe;
function Mut() {
  if (zoe) return AM;
  zoe = 1;
  var i = As(), e = i("%Number%"), t = i("%RegExp%"), n = Jn(), r = i("%parseInt%"), s = Xa(), o = T_e(), a = s("String.prototype.slice"), l = o(/^0b[01]+$/i), c = o(/^0o[0-7]+$/i), d = o(/^[-+]0x[0-9a-f]+$/i), u = ["", "​", "￾"].join(""), h = new t("[" + u + "]", "g"), f = o(h), g = O_e();
  return AM = function p(m) {
    if (typeof m != "string")
      throw new n("Assertion failed: `argument` is not a String");
    if (l(m))
      return e(r(a(m, 2), 2));
    if (c(m))
      return e(r(a(m, 2), 8));
    if (f(m) || d(m))
      return NaN;
    var _ = g(m);
    return _ !== m ? p(_) : e(m);
  }, AM;
}
var kM, Uoe;
function Rut() {
  if (Uoe) return kM;
  Uoe = 1;
  var i = As(), e = Jn(), t = i("%Number%"), n = lq(), r = Out(), s = Mut();
  return kM = function(a) {
    var l = n(a) ? a : r(a, t);
    if (typeof l == "symbol")
      throw new e("Cannot convert a Symbol value to a number");
    if (typeof l == "bigint")
      throw new e("Conversion from 'BigInt' to 'number' is not allowed.");
    return typeof l == "string" ? s(l) : t(l);
  }, kM;
}
var TM, Goe;
function Fut() {
  if (Goe) return TM;
  Goe = 1;
  var i = Math.floor;
  return TM = function(t) {
    return typeof t == "bigint" ? t : i(t);
  }, TM;
}
var NM, qoe;
function But() {
  if (qoe) return NM;
  qoe = 1;
  var i = Fut(), e = Jn();
  return NM = function(n) {
    if (typeof n != "number" && typeof n != "bigint")
      throw new e("argument must be a Number or a BigInt");
    var r = n < 0 ? -i(-n) : i(n);
    return r === 0 ? 0 : r;
  }, NM;
}
var PM, Koe;
function Xbe() {
  if (Koe) return PM;
  Koe = 1;
  var i = Rut(), e = But(), t = lx(), n = dq();
  return PM = function(s) {
    var o = i(s);
    return t(o) || o === 0 ? 0 : n(o) ? e(o) : o;
  }, PM;
}
var OM, Yoe;
function Zbe() {
  if (Yoe) return OM;
  Yoe = 1;
  var i = aq(), e = Xbe();
  return OM = function(n) {
    var r = e(n);
    return r <= 0 ? 0 : r > i ? i : r;
  }, OM;
}
var MM, Xoe;
function Vut() {
  if (Xoe) return MM;
  Xoe = 1;
  var i = Jn(), e = gk(), t = Zbe(), n = _c();
  return MM = function(s) {
    if (n(s) !== "Object")
      throw new i("Assertion failed: `obj` must be an Object");
    return t(e(s, "length"));
  }, MM;
}
var RM, Zoe;
function Hut() {
  if (Zoe) return RM;
  Zoe = 1;
  var i = As(), e = i("%String%"), t = Jn();
  return RM = function(r) {
    if (typeof r == "symbol")
      throw new t("Cannot convert a Symbol value to a string");
    return e(r);
  }, RM;
}
var FM, Qoe;
function Wut() {
  if (Qoe) return FM;
  Qoe = 1;
  var i = Jn(), e = aq(), t = Dut(), n = Nut(), r = gk(), s = Put(), o = xq(), a = Vut(), l = Hut();
  return FM = function c(d, u, h, f, g) {
    var p;
    arguments.length > 5 && (p = arguments[5]);
    for (var m = f, _ = 0; _ < h; ) {
      var b = l(_), w = s(u, b);
      if (w === !0) {
        var y = r(u, b);
        if (typeof p < "u") {
          if (arguments.length <= 6)
            throw new i("Assertion failed: thisArg is required when mapperFunction is provided");
          y = t(p, arguments[6], [y, _, u]);
        }
        var S = !1;
        if (g > 0 && (S = o(y)), S) {
          var x = a(y);
          m = c(d, y, x, m, g - 1);
        } else {
          if (m >= e)
            throw new i("index too large");
          n(d, l(m), y), m += 1;
        }
      }
      _ += 1;
    }
    return m;
  }, FM;
}
var BM, Joe;
function jut() {
  return Joe || (Joe = 1, BM = L_e()), BM;
}
var VM, $oe;
function Qbe() {
  if ($oe) return VM;
  $oe = 1;
  var i = xut(), e = Wut(), t = gk(), n = Xbe(), r = Zbe(), s = jut();
  return VM = function() {
    var a = s(this), l = r(t(a, "length")), c = 1;
    arguments.length > 0 && typeof arguments[0] < "u" && (c = n(arguments[0]));
    var d = i(a, 0);
    return e(d, a, l, 0, c), d;
  }, VM;
}
var HM, eae;
function Jbe() {
  if (eae) return HM;
  eae = 1;
  var i = Qbe();
  return HM = function() {
    return Array.prototype.flat || i;
  }, HM;
}
var WM, tae;
function zut() {
  if (tae) return WM;
  tae = 1;
  var i = Xr(), e = F_e(), t = Jbe();
  return WM = function() {
    var r = t();
    return i(
      Array.prototype,
      { flat: r },
      { flat: function() {
        return Array.prototype.flat !== r;
      } }
    ), e("flat"), r;
  }, WM;
}
var jM, nae;
function Uut() {
  if (nae) return jM;
  nae = 1;
  var i = Xr(), e = Vu(), t = Qbe(), n = Jbe(), r = n(), s = zut(), o = e(r);
  return i(o, {
    getPolyfill: n,
    implementation: t,
    shim: s
  }), jM = o, jM;
}
var zM, iae;
function Gut() {
  if (iae) return zM;
  iae = 1;
  var i = Xr(), e = I_e(), t = "__ global cache key __";
  typeof Symbol == "function" && e(Symbol("foo")) && typeof Symbol.for == "function" && (t = Symbol.for(t));
  var n = function() {
    return !0;
  }, r = function() {
    if (!Zs[t]) {
      var u = {};
      u[t] = {};
      var h = {};
      h[t] = n, i(Zs, u, h);
    }
    return Zs[t];
  }, s = r(), o = function(u) {
    return u === null || typeof u != "object" && typeof u != "function";
  }, a = function(u) {
    return e(u) ? Symbol.prototype.valueOf.call(u) : typeof u + " | " + String(u);
  }, l = function(u) {
    if (!o(u))
      throw new TypeError("key must not be an object");
  }, c = {
    clear: function() {
      delete Zs[t], s = r();
    },
    delete: function(u) {
      return l(u), delete s[a(u)], !c.has(u);
    },
    get: function(u) {
      return l(u), s[a(u)];
    },
    has: function(u) {
      return l(u), a(u) in s;
    },
    set: function(u, h) {
      l(u);
      var f = a(u), g = {};
      g[f] = h;
      var p = {};
      return p[f] = n, i(s, g, p), c.has(u);
    },
    setIfMissingThenGet: function(u, h) {
      if (c.has(u))
        return c.get(u);
      var f = h();
      return c.set(u, f), f;
    }
  };
  return zM = c, zM;
}
var Tp = {}, rae;
function qut() {
  if (rae) return Tp;
  rae = 1, Object.defineProperty(Tp, "__esModule", {
    value: !0
  }), Tp.MAX_SPECIFICITY = Tp.GLOBAL_CACHE_KEY = void 0;
  var i = "reactWithStylesInterfaceCSS";
  Tp.GLOBAL_CACHE_KEY = i;
  var e = 20;
  return Tp.MAX_SPECIFICITY = e, Tp;
}
var UM = {}, sae;
function Kut() {
  return sae || (sae = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = e;
    function e(t, n) {
      var r = t.length > 0 ? "".concat(t, "__") : "";
      return "".concat(r).concat(n);
    }
  }(UM)), UM;
}
var GM = {}, oae;
function Yut() {
  return oae || (oae = 1, function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    function e(n) {
      for (var r = [], s = !1, o = {}, a = 0; a < n.length; a++) {
        var l = n[a];
        l && (typeof l == "string" ? r.push(l) : (Object.assign(o, l), s = !0));
      }
      return {
        classNames: r,
        hasInlineStyles: s,
        inlineStyles: o
      };
    }
    var t = e;
    i.default = t;
  }(GM)), GM;
}
var aae;
function Xut() {
  return aae || (aae = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var t = e(Uut()), n = e(Gut()), r = qut(), s = e(Kut()), o = e(Yut());
    function a(d) {
      var u = {}, h = Object.keys(d), f = n.default.get(r.GLOBAL_CACHE_KEY) || {}, g = f.namespace, p = g === void 0 ? "" : g;
      return h.forEach(function(m) {
        var _ = (0, s.default)(p, m);
        u[m] = _;
      }), u;
    }
    function l(d) {
      var u = (0, t.default)(d, 1 / 0), h = (0, o.default)(u), f = h.classNames, g = h.hasInlineStyles, p = h.inlineStyles, m = f.map(function(w, y) {
        return "".concat(w, " ").concat(w, "_").concat(y + 1);
      }), _ = m.join(" "), b = {
        className: _
      };
      return g && (b.style = p), b;
    }
    var c = {
      create: a,
      resolve: l
    };
    i.default = c;
  }(aM)), aM;
}
var qM, lae;
function Zut() {
  return lae || (lae = 1, qM = Xut().default), qM;
}
var KM = {}, cae;
function Qut() {
  return cae || (cae = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(rbe()), n = e(Gbe());
    function r(s) {
      t.default.registerInterface(s), t.default.registerTheme(n.default);
    }
  }(KM)), KM;
}
var dae;
function Jut() {
  return dae || (dae = 1, function(i) {
    var e = xt;
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = r;
    var t = e(Zut()), n = e(Qut());
    function r() {
      (0, n.default)(t.default);
    }
  }(oM)), oM;
}
var $ut = xt, eht = $ut(Jut());
(0, eht.default)();
const tht = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.75%201.875V4.375M6.25%201.875V4.375M3.125%207.70833H16.875M4.16667%2017.5H15.8333C16.7538%2017.5%2017.5%2016.7538%2017.5%2015.8333V5C17.5%204.07953%2016.7538%203.33333%2015.8333%203.33333H4.16667C3.24619%203.33333%202.5%204.07953%202.5%205V15.8333C2.5%2016.7538%203.24619%2017.5%204.16667%2017.5Z'%20stroke='%23596168'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", nht = (i) => i.isSame(st(), "day"), iht = ({
  date: i,
  handleDatesChange: e,
  readOnly: t,
  isTodayBlocked: n,
  displayFormat: r,
  dataTestId: s
}) => {
  const [o, a] = Oe(!1), l = (d) => {
    a(d.focused);
  }, c = (d) => /* @__PURE__ */ v.jsx(cut, { ...d, ...qbe });
  return /* @__PURE__ */ v.jsx(
    zbe.SingleDatePicker,
    {
      id: "single_date_picker",
      placeholder: "Select date",
      date: i,
      onDateChange: e,
      focused: o,
      onFocusChange: l,
      numberOfMonths: 1,
      openDirection: "down",
      renderCalendarDay: (d) => c(d),
      hideKeyboardShortcutsPanel: !0,
      withFullScreenPortal: !1,
      orientation: "horizontal",
      readOnly: t || !1,
      isDayBlocked: n ? nht : void 0,
      customInputIcon: /* @__PURE__ */ v.jsx(tht, {}),
      inputIconPosition: "after",
      displayFormat: r,
      "data-testid": s
    }
  );
}, LSt = iht, rht = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M8.75 4.5C8.75 4.08579 8.41421 3.75 8 3.75C7.58579 3.75 7.25 4.08579 7.25 4.5H8.75ZM8 8H7.25C7.25 8.41421 7.58579 8.75 8 8.75V8ZM11.5 8.75C11.9142 8.75 12.25 8.41421 12.25 8C12.25 7.58579 11.9142 7.25 11.5 7.25V8.75ZM13.25 8C13.25 10.8995 10.8995 13.25 8 13.25V14.75C11.7279 14.75 14.75 11.7279 14.75 8H13.25ZM8 13.25C5.10051 13.25 2.75 10.8995 2.75 8H1.25C1.25 11.7279 4.27208 14.75 8 14.75V13.25ZM2.75 8C2.75 5.10051 5.10051 2.75 8 2.75V1.25C4.27208 1.25 1.25 4.27208 1.25 8H2.75ZM8 2.75C10.8995 2.75 13.25 5.10051 13.25 8H14.75C14.75 4.27208 11.7279 1.25 8 1.25V2.75ZM7.25 4.5V8H8.75V4.5H7.25ZM8 8.75H11.5V7.25H8V8.75Z", fill: "#596168" })), Eq = () => ({
  container: (i) => ({
    ...i,
    height: "36px"
  }),
  control: (i, e) => ({
    ...i,
    boxShadow: "none",
    minHeight: "36px",
    cursor: "pointer",
    borderColor: "var(--N200)",
    backgroundColor: "var(--N50)",
    ...e.isDisabled ? {
      borderColor: "var(--N200)",
      backgroundColor: "var(--N100)",
      cursor: "not-allowed"
    } : {},
    "&:hover": {
      borderColor: "var(--N400)"
    },
    "&:focus, &:focus-within": {
      borderColor: "var(--B500)",
      outline: "none"
    }
  }),
  menu: (i) => ({
    ...i,
    overflow: "hidden",
    marginBottom: "4px"
  }),
  singleValue: (i) => ({
    ...i,
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "20px",
    color: "var(--N900)"
  }),
  placeholder: (i) => ({
    ...i,
    fontSize: "13px",
    color: "var(--N900)"
  }),
  option: (i, e) => ({
    ...i,
    color: e.isSelected ? "var(--B500)" : "var(--N900)",
    // eslint-disable-next-line no-nested-ternary
    backgroundColor: e.isSelected ? "var(--B100)" : e.isFocused ? "var(--N50)" : "var(--N0)",
    cursor: "pointer"
  }),
  valueContainer: (i) => ({
    ...i,
    padding: "2px 0px 2px 8px",
    display: "flex"
  }),
  dropdownIndicator: (i) => ({
    ...i,
    padding: "0px 8px"
  })
}), sht = Object.entries(hut).map(([i, e]) => ({
  label: i,
  value: e
})), gE = Object.entries(fut).map(([i, e]) => ({
  label: i,
  value: e
})), oht = (i) => i < 10 ? `0${i}` : i, aht = (i) => {
  const [e, t, n] = [
    i.getHours(),
    i.getMinutes(),
    i.getSeconds()
  ].map(oht);
  return `${e}:${t}:${n}`;
}, lht = (i, e) => {
  const [t, n, r] = e.split(":").map((o) => parseInt(o, 10)), s = new Date(i);
  return s.setHours(t, n, r), s;
}, cht = (i, e) => {
  if (!e)
    return i;
  const t = e.getDate(), n = e.getMonth(), r = e.getFullYear(), s = new Date(i);
  return s.setFullYear(r, n, t), s;
}, ISt = (i, e) => {
  const t = i ? new Date(i) : /* @__PURE__ */ new Date();
  let n = t.getHours(), r = t.getMinutes();
  if (r === 0 || r === 30 || (r < 30 ? r = 30 : (r = 0, n += 1)), e) {
    const o = new Date(t);
    return o.setHours(n, r, 0), o.setDate(t.getDate() + 1), o;
  }
  const s = new Date(t);
  return s.setHours(n, r, 0), s;
}, $be = (i) => /* @__PURE__ */ v.jsx(zi.DropdownIndicator, { ...i, children: /* @__PURE__ */ v.jsx(rht, { className: "icon-dim-20 fcn-6" }) }), dht = Eq(), ASt = ({
  selectedMonthlyDate: i,
  onChange: e,
  dataTestId: t = WI.MONTH
}) => /* @__PURE__ */ v.jsx("div", { className: "dc__no-shrink", children: /* @__PURE__ */ v.jsx(
  Ba,
  {
    placeholder: "Day 1",
    options: sht,
    menuPlacement: "auto",
    components: {
      IndicatorSeparator: null,
      ClearIndicator: null,
      DropdownIndicator: uCe
    },
    isSearchable: !1,
    styles: dht,
    value: i,
    onChange: e,
    "data-testid": t,
    menuPosition: "fixed"
  }
) }), kSt = ({
  disabled: i = !1,
  onChange: e,
  timePickerProps: t,
  error: n,
  selectedTimeOption: r
}) => {
  const s = Eq();
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("div", { className: "dc__no-shrink", children: /* @__PURE__ */ v.jsx(
      Ba,
      {
        placeholder: "12:00 AM",
        options: gE,
        menuPlacement: "auto",
        menuPosition: "fixed",
        components: {
          IndicatorSeparator: null,
          ClearIndicator: null,
          DropdownIndicator: $be
        },
        isSearchable: !1,
        styles: s,
        isDisabled: i,
        ...t,
        value: r,
        onChange: e,
        "data-testid": WI.TIME
      }
    ) }),
    n && /* @__PURE__ */ v.jsxs("div", { className: "form__error", children: [
      /* @__PURE__ */ v.jsx(rc, { className: "form__icon form__icon--error" }),
      n
    ] })
  ] });
};
function cn() {
  return cn = Object.assign ? Object.assign.bind() : function(i) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (i[n] = t[n]);
    }
    return i;
  }, cn.apply(null, arguments);
}
function e2e(i) {
  if (i === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return i;
}
function jI(i, e) {
  return jI = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, jI(i, e);
}
function uht(i, e) {
  i.prototype = Object.create(e.prototype), i.prototype.constructor = i, jI(i, e);
}
function S0(i) {
  "@babel/helpers - typeof";
  return S0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, S0(i);
}
function hht(i, e) {
  if (S0(i) != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(i, e || "default");
    if (S0(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(i);
}
function t2e(i) {
  var e = hht(i, "string");
  return S0(e) == "symbol" ? e : e + "";
}
function dg(i, e, t) {
  return (e = t2e(e)) in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
var fht = ua();
const uae = /* @__PURE__ */ eb(fht);
var ght = yd();
const pht = /* @__PURE__ */ eb(ght);
var zI = Or(), Lq = Za(), mht = gq();
const vht = /* @__PURE__ */ eb(mht);
var _ht = function(e) {
  var t = e.date;
  return t;
}, bht = function(e) {
  var t = e.date;
  return "Not available. ".concat(t);
}, Cht = function(e) {
  var t = e.date;
  return "Selected. ".concat(t);
}, yht = function(e) {
  var t = e.date;
  return "Selected as start date. ".concat(t);
}, wht = function(e) {
  var t = e.date;
  return "Selected as end date. ".concat(t);
}, n2e = {
  chooseAvailableDate: _ht,
  dateIsUnavailable: bht,
  dateIsSelected: Cht,
  dateIsSelectedAsStartDate: yht,
  dateIsSelectedAsEndDate: wht
};
function hae(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(i);
    e && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(i, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Sht(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hae(Object(t), !0).forEach(function(n) {
      dg(i, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : hae(Object(t)).forEach(function(n) {
      Object.defineProperty(i, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return i;
}
function xht(i) {
  return Object.keys(i).reduce(function(e, t) {
    return Sht({}, e, dg({}, t, qn.oneOfType([qn.string, qn.func, qn.node])));
  }, {});
}
function N2(i, e) {
  return typeof i == "string" ? i : typeof i == "function" ? i(e) : "";
}
var Dht = 39, Eht = "blocked";
function Iq(i) {
  return i.has("selected") || i.has("selected-span") || i.has("selected-start") || i.has("selected-end");
}
function Lht(i) {
  return i.has("blocked-minimum-nights") || i.has("blocked-calendar") || i.has("blocked-out-of-range");
}
function Iht(i) {
  return Iq(i) ? !1 : i.has("hovered-span") || i.has("after-hovered-start") || i.has("before-hovered-end");
}
function Aht(i, e, t, n) {
  var r = i.chooseAvailableDate, s = i.dateIsUnavailable, o = i.dateIsSelected, a = i.dateIsSelectedAsStartDate, l = i.dateIsSelectedAsEndDate, c = {
    date: t.format(n)
  };
  return e.has("selected-start") && a ? N2(a, c) : e.has("selected-end") && l ? N2(l, c) : Iq(e) && o ? N2(o, c) : e.has(Eht) ? N2(s, c) : N2(r, c);
}
function kht(i, e, t, n, r) {
  return {
    ariaLabel: Aht(r, n, i, e),
    hoveredSpan: Iht(n),
    isOutsideRange: n.has("blocked-out-of-range"),
    selected: Iq(n),
    useDefaultCursor: Lht(n),
    daySizeStyles: {
      width: t,
      height: t - 1
    }
  };
}
var wt = {
  white: "#fff",
  gray: "#484848",
  grayLight: "#82888a",
  grayLighter: "#cacccd",
  grayLightest: "#f2f2f2",
  borderMedium: "#c4c4c4",
  border: "#dbdbdb",
  borderLight: "#e4e7e7",
  borderLighter: "#eceeee",
  borderBright: "#f4f5f5",
  primary: "#00a699",
  primaryShade_1: "#33dacd",
  primaryShade_2: "#66e2da",
  primaryShade_3: "#80e8e0",
  primaryShade_4: "#b2f1ec",
  primary_dark: "#008489",
  secondary: "#007a87",
  yellow: "#ffe8bc",
  yellow_dark: "#ffce71"
};
const Tht = {
  reactDates: {
    zIndex: 0,
    border: {
      input: {
        border: 0,
        borderTop: 0,
        borderRight: 0,
        borderBottom: "2px solid transparent",
        borderLeft: 0,
        outlineFocused: 0,
        borderFocused: 0,
        borderTopFocused: 0,
        borderLeftFocused: 0,
        borderBottomFocused: "2px solid ".concat(wt.primary_dark),
        borderRightFocused: 0,
        borderRadius: 0
      },
      pickerInput: {
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 2
      }
    },
    color: {
      core: wt,
      disabled: wt.grayLightest,
      background: wt.white,
      backgroundDark: "#f2f2f2",
      backgroundFocused: wt.white,
      border: "rgb(219, 219, 219)",
      text: wt.gray,
      textDisabled: wt.border,
      textFocused: "#007a87",
      placeholderText: "#757575",
      outside: {
        backgroundColor: wt.white,
        backgroundColor_active: wt.white,
        backgroundColor_hover: wt.white,
        color: wt.gray,
        color_active: wt.gray,
        color_hover: wt.gray
      },
      highlighted: {
        backgroundColor: wt.yellow,
        backgroundColor_active: wt.yellow_dark,
        backgroundColor_hover: wt.yellow_dark,
        color: wt.gray,
        color_active: wt.gray,
        color_hover: wt.gray
      },
      minimumNights: {
        backgroundColor: wt.white,
        backgroundColor_active: wt.white,
        backgroundColor_hover: wt.white,
        borderColor: wt.borderLighter,
        color: wt.grayLighter,
        color_active: wt.grayLighter,
        color_hover: wt.grayLighter
      },
      hoveredSpan: {
        backgroundColor: wt.primaryShade_4,
        backgroundColor_active: wt.primaryShade_3,
        backgroundColor_hover: wt.primaryShade_4,
        borderColor: wt.primaryShade_3,
        borderColor_active: wt.primaryShade_3,
        borderColor_hover: wt.primaryShade_3,
        color: wt.secondary,
        color_active: wt.secondary,
        color_hover: wt.secondary
      },
      selectedSpan: {
        backgroundColor: wt.primaryShade_2,
        backgroundColor_active: wt.primaryShade_1,
        backgroundColor_hover: wt.primaryShade_1,
        borderColor: wt.primaryShade_1,
        borderColor_active: wt.primary,
        borderColor_hover: wt.primary,
        color: wt.white,
        color_active: wt.white,
        color_hover: wt.white
      },
      selected: {
        backgroundColor: wt.primary,
        backgroundColor_active: wt.primary,
        backgroundColor_hover: wt.primary,
        borderColor: wt.primary,
        borderColor_active: wt.primary,
        borderColor_hover: wt.primary,
        color: wt.white,
        color_active: wt.white,
        color_hover: wt.white
      },
      blocked_calendar: {
        backgroundColor: wt.grayLighter,
        backgroundColor_active: wt.grayLighter,
        backgroundColor_hover: wt.grayLighter,
        borderColor: wt.grayLighter,
        borderColor_active: wt.grayLighter,
        borderColor_hover: wt.grayLighter,
        color: wt.grayLight,
        color_active: wt.grayLight,
        color_hover: wt.grayLight
      },
      blocked_out_of_range: {
        backgroundColor: wt.white,
        backgroundColor_active: wt.white,
        backgroundColor_hover: wt.white,
        borderColor: wt.borderLight,
        borderColor_active: wt.borderLight,
        borderColor_hover: wt.borderLight,
        color: wt.grayLighter,
        color_active: wt.grayLighter,
        color_hover: wt.grayLighter
      }
    },
    spacing: {
      dayPickerHorizontalPadding: 9,
      captionPaddingTop: 22,
      captionPaddingBottom: 37,
      inputPadding: 0,
      displayTextPaddingVertical: void 0,
      displayTextPaddingTop: 11,
      displayTextPaddingBottom: 9,
      displayTextPaddingHorizontal: void 0,
      displayTextPaddingLeft: 11,
      displayTextPaddingRight: 11,
      displayTextPaddingVertical_small: void 0,
      displayTextPaddingTop_small: 7,
      displayTextPaddingBottom_small: 5,
      displayTextPaddingHorizontal_small: void 0,
      displayTextPaddingLeft_small: 7,
      displayTextPaddingRight_small: 7
    },
    sizing: {
      inputWidth: 130,
      inputWidth_small: 97,
      arrowWidth: 24
    },
    noScrollBarOnVerticalScrollable: !1,
    font: {
      size: 14,
      captionSize: 18,
      input: {
        size: 19,
        weight: 200,
        lineHeight: "24px",
        size_small: 15,
        lineHeight_small: "18px",
        letterSpacing_small: "0.2px",
        styleDisabled: "italic"
      }
    }
  }
};
function fae(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(i);
    e && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(i, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Nht(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? fae(Object(t), !0).forEach(function(n) {
      dg(i, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : fae(Object(t)).forEach(function(n) {
      Object.defineProperty(i, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return i;
}
var Cn = Tht.reactDates.color;
function zs(i, e) {
  if (!i) return null;
  var t = i.hover;
  return e && t ? t : i;
}
var Us = process.env.NODE_ENV !== "production" ? qn.shape({
  background: qn.string,
  border: zI.or([qn.string, qn.number]),
  color: qn.string,
  hover: qn.shape({
    background: qn.string,
    border: zI.or([qn.string, qn.number]),
    color: qn.string
  })
}) : {}, Pht = process.env.NODE_ENV !== "production" ? zI.forbidExtraProps(Nht({}, Lq.withStylesPropTypes, {
  day: pht.momentObj,
  daySize: zI.nonNegativeInteger,
  isOutsideDay: qn.bool,
  modifiers: qn.instanceOf(Set),
  isFocused: qn.bool,
  tabIndex: qn.oneOf([0, -1]),
  onDayClick: qn.func,
  onDayMouseEnter: qn.func,
  onDayMouseLeave: qn.func,
  renderDayContents: qn.func,
  ariaLabelFormat: qn.string,
  // style overrides
  defaultStyles: Us,
  outsideStyles: Us,
  todayStyles: Us,
  firstDayOfWeekStyles: Us,
  lastDayOfWeekStyles: Us,
  highlightedCalendarStyles: Us,
  blockedMinNightsStyles: Us,
  blockedCalendarStyles: Us,
  blockedOutOfRangeStyles: Us,
  hoveredSpanStyles: Us,
  selectedSpanStyles: Us,
  lastInRangeStyles: Us,
  selectedStyles: Us,
  selectedStartStyles: Us,
  selectedEndStyles: Us,
  afterHoveredStartStyles: Us,
  hoveredStartFirstPossibleEndStyles: Us,
  hoveredStartBlockedMinNightsStyles: Us,
  // internationalization
  phrases: qn.shape(xht(n2e))
})) : {}, Oht = {
  border: "1px solid ".concat(Cn.core.borderLight),
  color: Cn.text,
  background: Cn.background,
  hover: {
    background: Cn.core.borderLight,
    border: "1px solid ".concat(Cn.core.borderLight),
    color: "inherit"
  }
}, Mht = {
  background: Cn.outside.backgroundColor,
  border: 0,
  color: Cn.outside.color
}, Rht = {
  background: Cn.highlighted.backgroundColor,
  color: Cn.highlighted.color,
  hover: {
    background: Cn.highlighted.backgroundColor_hover,
    color: Cn.highlighted.color_active
  }
}, Fht = {
  background: Cn.minimumNights.backgroundColor,
  border: "1px solid ".concat(Cn.minimumNights.borderColor),
  color: Cn.minimumNights.color,
  hover: {
    background: Cn.minimumNights.backgroundColor_hover,
    color: Cn.minimumNights.color_active
  }
}, Bht = {
  background: Cn.blocked_calendar.backgroundColor,
  border: "1px solid ".concat(Cn.blocked_calendar.borderColor),
  color: Cn.blocked_calendar.color,
  hover: {
    background: Cn.blocked_calendar.backgroundColor_hover,
    border: "1px solid ".concat(Cn.blocked_calendar.borderColor),
    color: Cn.blocked_calendar.color_active
  }
}, Vht = {
  background: Cn.blocked_out_of_range.backgroundColor,
  border: "1px solid ".concat(Cn.blocked_out_of_range.borderColor),
  color: Cn.blocked_out_of_range.color,
  hover: {
    background: Cn.blocked_out_of_range.backgroundColor_hover,
    border: "1px solid ".concat(Cn.blocked_out_of_range.borderColor),
    color: Cn.blocked_out_of_range.color_active
  }
}, Hht = {
  background: Cn.hoveredSpan.backgroundColor,
  border: "1px double ".concat(Cn.hoveredSpan.borderColor),
  color: Cn.hoveredSpan.color,
  hover: {
    background: Cn.hoveredSpan.backgroundColor_hover,
    border: "1px double ".concat(Cn.hoveredSpan.borderColor),
    color: Cn.hoveredSpan.color_active
  }
}, Wht = {
  background: Cn.selectedSpan.backgroundColor,
  border: "1px double ".concat(Cn.selectedSpan.borderColor),
  color: Cn.selectedSpan.color,
  hover: {
    background: Cn.selectedSpan.backgroundColor_hover,
    border: "1px double ".concat(Cn.selectedSpan.borderColor),
    color: Cn.selectedSpan.color_active
  }
}, jht = {}, zht = {
  background: Cn.selected.backgroundColor,
  border: "1px double ".concat(Cn.selected.borderColor),
  color: Cn.selected.color,
  hover: {
    background: Cn.selected.backgroundColor_hover,
    border: "1px double ".concat(Cn.selected.borderColor),
    color: Cn.selected.color_active
  }
}, Uht = {
  day: st(),
  daySize: Dht,
  isOutsideDay: !1,
  modifiers: /* @__PURE__ */ new Set(),
  isFocused: !1,
  tabIndex: -1,
  onDayClick: function() {
  },
  onDayMouseEnter: function() {
  },
  onDayMouseLeave: function() {
  },
  renderDayContents: null,
  ariaLabelFormat: "dddd, LL",
  // style defaults
  defaultStyles: Oht,
  outsideStyles: Mht,
  todayStyles: {},
  highlightedCalendarStyles: Rht,
  blockedMinNightsStyles: Fht,
  blockedCalendarStyles: Bht,
  blockedOutOfRangeStyles: Vht,
  hoveredSpanStyles: Hht,
  selectedSpanStyles: Wht,
  lastInRangeStyles: jht,
  selectedStyles: zht,
  selectedStartStyles: {},
  selectedEndStyles: {},
  afterHoveredStartStyles: {},
  firstDayOfWeekStyles: {},
  lastDayOfWeekStyles: {},
  hoveredStartFirstPossibleEndStyles: {},
  hoveredStartBlockedMinNightsStyles: {},
  // internationalization
  phrases: n2e
}, Aq = /* @__PURE__ */ function(i) {
  uht(t, i);
  var e = t.prototype;
  e[!it.PureComponent && "shouldComponentUpdate"] = function(n, r) {
    return !uae(this.props, n) || !uae(this.state, r);
  };
  function t() {
    for (var n, r = arguments.length, s = new Array(r), o = 0; o < r; o++)
      s[o] = arguments[o];
    return n = i.call.apply(i, [this].concat(s)) || this, n.state = {
      isHovered: !1
    }, n.setButtonRef = n.setButtonRef.bind(e2e(n)), n;
  }
  return e.componentDidUpdate = function(r) {
    var s = this, o = this.props, a = o.isFocused, l = o.tabIndex;
    l === 0 && (a || l !== r.tabIndex) && vht(function() {
      s.buttonRef && s.buttonRef.focus();
    });
  }, e.onDayClick = function(r, s) {
    var o = this.props.onDayClick;
    o(r, s);
  }, e.onDayMouseEnter = function(r, s) {
    var o = this.props.onDayMouseEnter;
    this.setState({
      isHovered: !0
    }), o(r, s);
  }, e.onDayMouseLeave = function(r, s) {
    var o = this.props.onDayMouseLeave;
    this.setState({
      isHovered: !1
    }), o(r, s);
  }, e.onKeyDown = function(r, s) {
    var o = this.props.onDayClick, a = s.key;
    (a === "Enter" || a === " ") && o(r, s);
  }, e.setButtonRef = function(r) {
    this.buttonRef = r;
  }, e.render = function() {
    var r = this, s = this.props, o = s.day, a = s.ariaLabelFormat, l = s.daySize, c = s.isOutsideDay, d = s.modifiers, u = s.tabIndex, h = s.renderDayContents, f = s.styles, g = s.phrases, p = s.defaultStyles, m = s.outsideStyles, _ = s.todayStyles, b = s.firstDayOfWeekStyles, w = s.lastDayOfWeekStyles, y = s.highlightedCalendarStyles, S = s.blockedMinNightsStyles, x = s.blockedCalendarStyles, D = s.blockedOutOfRangeStyles, E = s.hoveredSpanStyles, L = s.selectedSpanStyles, k = s.lastInRangeStyles, N = s.selectedStyles, I = s.selectedStartStyles, A = s.selectedEndStyles, P = s.afterHoveredStartStyles, O = s.hoveredStartFirstPossibleEndStyles, K = s.hoveredStartBlockedMinNightsStyles, W = this.state.isHovered;
    if (!o) return it.createElement("td", null);
    var F = kht(o, a, l, d, g), q = F.daySizeStyles, R = F.useDefaultCursor, T = F.selected, z = F.hoveredSpan, X = F.isOutsideRange, ae = F.ariaLabel;
    return it.createElement("td", cn({}, Lq.css(f.CalendarDay, R && f.CalendarDay__defaultCursor, q, zs(p, W), c && zs(m, W), d.has("today") && zs(_, W), d.has("first-day-of-week") && zs(b, W), d.has("last-day-of-week") && zs(w, W), d.has("hovered-start-first-possible-end") && zs(O, W), d.has("hovered-start-blocked-minimum-nights") && zs(K, W), d.has("highlighted-calendar") && zs(y, W), d.has("blocked-minimum-nights") && zs(S, W), d.has("blocked-calendar") && zs(x, W), z && zs(E, W), d.has("after-hovered-start") && zs(P, W), d.has("selected-span") && zs(L, W), d.has("last-in-range") && zs(k, W), T && zs(N, W), d.has("selected-start") && zs(I, W), d.has("selected-end") && zs(A, W), X && zs(D, W)), {
      role: "button",
      ref: this.setButtonRef,
      "aria-disabled": d.has("blocked"),
      "aria-label": ae,
      onMouseEnter: function(se) {
        r.onDayMouseEnter(o, se);
      },
      onMouseLeave: function(se) {
        r.onDayMouseLeave(o, se);
      },
      onMouseUp: function(se) {
        se.currentTarget.blur();
      },
      onClick: function(se) {
        r.onDayClick(o, se);
      },
      onKeyDown: function(se) {
        r.onKeyDown(o, se);
      },
      tabIndex: u
    }), h ? h(o, d) : o.format("D"));
  }, t;
}(it.PureComponent || it.Component);
Aq.propTypes = process.env.NODE_ENV !== "production" ? Pht : {};
Aq.defaultProps = Uht;
const Ght = Lq.withStyles(function(i) {
  var e = i.reactDates.font;
  return {
    CalendarDay: {
      boxSizing: "border-box",
      cursor: "pointer",
      fontSize: e.size,
      textAlign: "center",
      ":active": {
        outline: 0
      }
    },
    CalendarDay__defaultCursor: {
      cursor: "default"
    }
  };
}, {
  pureComponent: typeof it.PureComponent < "u"
})(Aq), qht = Eq(), Kht = ({
  date: i = /* @__PURE__ */ new Date(),
  onChange: e,
  timePickerProps: t = {},
  disabled: n,
  id: r,
  label: s,
  required: o,
  hideTimeSelect: a = !1,
  readOnly: l = !1,
  isTodayBlocked: c = !1,
  dataTestIdForTime: d = WI.TIME,
  dataTestidForDate: u = WI.DATE,
  openDirection: h = "down",
  error: f = ""
}) => {
  const g = aht(i), p = gE.find((D) => D.value === g) ?? gE[0], [m, _] = Oe(!1), b = ({ focused: D }) => {
    _(D);
  }, w = (D) => {
    e(cht(i, D?.toDate()));
  }, y = (D) => {
    e(lht(i, D.value));
  }, S = st(), x = (D) => c && !D.isAfter(S);
  return /* @__PURE__ */ v.jsxs("div", { className: "date-time-picker", children: [
    /* @__PURE__ */ v.jsx("label", { className: `form__label ${o ? "dc__required-field" : ""}`, htmlFor: r, children: s }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex left dc__gap-8", children: [
      /* @__PURE__ */ v.jsx(
        zbe.SingleDatePicker,
        {
          id: r,
          placeholder: "Select date",
          date: st(i),
          onDateChange: w,
          focused: m,
          onFocusChange: b,
          numberOfMonths: 1,
          openDirection: h,
          renderCalendarDay: (D) => /* @__PURE__ */ v.jsx(Ght, { ...D, ...qbe }),
          hideKeyboardShortcutsPanel: !0,
          withFullScreenPortal: !1,
          orientation: "horizontal",
          readOnly: l || !1,
          customInputIcon: /* @__PURE__ */ v.jsx(pW, { className: "icon-dim-20" }),
          inputIconPosition: "after",
          displayFormat: id.DD_MMM_YYYY,
          "data-testid": u,
          isDayBlocked: x,
          disabled: n,
          appendToBody: !0
        }
      ),
      !a && /* @__PURE__ */ v.jsx("div", { className: "dc__no-shrink", children: /* @__PURE__ */ v.jsx(
        Ba,
        {
          placeholder: gut.DEFAULT_TIME,
          options: gE,
          menuPlacement: "auto",
          menuPosition: "fixed",
          components: {
            IndicatorSeparator: null,
            ClearIndicator: null,
            DropdownIndicator: $be
          },
          isSearchable: !1,
          styles: qht,
          isDisabled: n,
          ...t,
          value: p,
          onChange: y,
          "data-testid": d
        }
      ) })
    ] }),
    f && /* @__PURE__ */ v.jsxs("div", { className: "form__error", children: [
      /* @__PURE__ */ v.jsx(rc, { className: "form__icon form__icon--error" }),
      f
    ] })
  ] });
}, TSt = Kht, i2e = (i) => {
  const e = (i?.ciMaterials ?? []).map((t, n) => ({
    id: t.id,
    gitMaterialName: t.gitMaterialName || "",
    gitMaterialId: t.gitMaterialId || 0,
    gitURL: t.url || "",
    type: t.type || "",
    value: t.value || "",
    active: t.active || !1,
    history: t.history.map((r, s) => ({
      commitURL: t.url ? wm(t.url, r.Commit) : "",
      commit: r.Commit || "",
      author: r.Author || "",
      date: nA(r.Date, !1),
      message: r.Message || "",
      changes: r.Changes || [],
      showChanges: s === 0,
      webhookData: r.WebhookData,
      isSelected: !1
    })),
    lastFetchTime: t.lastFetchTime || "",
    isSelected: n === 0
  }));
  return {
    ciPipelineId: i?.ciPipelineId,
    materials: e,
    triggeredByEmail: i?.triggeredByEmail || "",
    lastDeployedTime: nA(i.lastDeployedTime, !1),
    environmentName: i?.environmentName || "",
    environmentId: i?.environmentId || 0,
    appId: i?.appId,
    appName: i?.appName || "",
    appReleaseTags: i?.imageTaggingData?.appReleaseTags,
    imageComment: i?.imageTaggingData?.imageComment,
    imageReleaseTags: i?.imageTaggingData?.imageReleaseTags,
    image: i?.image,
    tagsEditable: i?.imageTaggingData?.tagsEditable
  };
}, Yht = async (i) => {
  try {
    const { result: e } = await Qn(
      `${hn.APP}/material-info/${i.envId}/${i.ciArtifactId}`
    );
    return i2e(e);
  } catch (e) {
    throw Is(e), e;
  }
}, Xht = async (i) => {
  try {
    const { result: e } = await Qn(
      `${hn.APP}/material-info/${i.ciArtifactId}`
    );
    return i2e(e);
  } catch (e) {
    throw Is(e), e;
  }
}, NSt = (i, e) => Qn(vl(hn.CONFIG_DATA, i), { signal: e }), Zht = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M10 3.125V16.875M10 16.875L15.625 11.25M10 16.875L4.375 11.25", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Qht = ({
  material: i,
  pipelineName: e,
  ciPipelineId: t,
  selectCommit: n,
  isCommitInfoModal: r
}) => {
  const s = (c, d, u) => {
    c.stopPropagation(), n && !u && n(i.id.toString(), d, t);
  }, a = (() => {
    const c = {};
    return i.history?.forEach((d) => {
      const u = d.date.substring(0, 16);
      c[u] || (c[u] = []), c[u].push(d);
    }), c;
  })(), l = Object.keys(a);
  return (
    // added for consistent typing
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ v.jsx(v.Fragment, { children: l.map((c) => {
      const d = a[c];
      return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        !r && i.type !== Ag.WEBHOOK && /* @__PURE__ */ v.jsxs("div", { className: "flex left dc__gap-8", children: [
          /* @__PURE__ */ v.jsx("span", { className: "fs-12 lh-18 cn-7 fw-6 w-130", children: c }),
          /* @__PURE__ */ v.jsx("div", { className: "h-1 bcn-2 w-100" })
        ] }),
        d?.map((u, h) => {
          const f = i.type === Ag.WEBHOOK && u.webhookData ? u.webhookData.id.toString() : u.commit;
          return /* @__PURE__ */ v.jsx(
            "div",
            {
              "data-testid": `material-history-${h}`,
              className: `material-history w-auto ${!u.excluded && !r ? "cursor material-history__box-shadow" : ""} ${u.isSelected ? "material-history-selected" : ""}`,
              onClick: (g) => s(g, f, u.excluded),
              children: /* @__PURE__ */ v.jsx(
                n_e,
                {
                  index: h,
                  materialUrl: i.gitURL,
                  showMaterialInfoHeader: e === "",
                  commitInfo: u,
                  materialSourceType: i.type,
                  selectedCommitInfo: n,
                  materialSourceValue: i.value,
                  canTriggerBuild: !u.excluded,
                  isExcluded: u.excluded
                }
              )
            },
            f
          );
        })
      ] });
    }) })
  );
}, Jht = Qht, $ht = ({
  envId: i,
  ciArtifactId: e,
  handleClose: t,
  renderCIListHeader: n,
  fetchOnlyArtifactInfo: r = !1
}) => {
  const [s, o, a, l] = tf(
    () => r ? Xht({
      ciArtifactId: e
    }) : Yht({
      ciArtifactId: e,
      envId: i
    }),
    [e, i, r]
  ), c = !!o?.materials?.length, d = c && !r;
  return /* @__PURE__ */ v.jsx(T1t, { position: "right", width: "800px", onEscape: t, children: /* @__PURE__ */ v.jsxs("div", { "data-testid": "visible-modal-commit-info", className: "flexbox-col h-100", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex dc__content-space py-10 px-20 cn-9 bcn-0 dc__border-bottom", children: [
      /* @__PURE__ */ v.jsx("div", { className: "flexbox-col dc__content-center", children: !a && (s ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx("div", { className: "shimmer h-24 mb-2 w-200" }),
        /* @__PURE__ */ v.jsx("div", { className: "shimmer h-18 w-250" })
      ] }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx("h1", { className: "fs-16 fw-6 lh-24 m-0 dc__truncate", children: d ? o?.appName : `Source & image details of ${o?.appName}` }),
        d && /* @__PURE__ */ v.jsxs("p", { className: "fs-13 cn-7 lh-1-5 m-0 dc__truncate", children: [
          "Deployed on ",
          o.environmentName,
          " at",
          " ",
          o.lastDeployedTime,
          " by ",
          o.triggeredByEmail
        ] })
      ] })) }),
      /* @__PURE__ */ v.jsx(
        "button",
        {
          "data-testid": "visible-modal-close",
          type: "button",
          className: "dc__transparent flex",
          onClick: t,
          "aria-label": "Close modal",
          children: /* @__PURE__ */ v.jsx(Il, { className: "icon-dim-24 icon-use-fill-n6" })
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-scroll dc__window-bg h-100", children: /* @__PURE__ */ v.jsx(
      rde,
      {
        isLoading: s,
        progressingProps: {
          pageLoader: !0
        },
        error: a,
        errorScreenManagerProps: {
          code: a?.code,
          reload: l
        },
        children: c ? /* @__PURE__ */ v.jsxs("div", { className: "select-material p-16 flexbox-col dc__gap-12", children: [
          o.materials.map((u) => /* @__PURE__ */ v.jsx(
            Jht,
            {
              material: u,
              pipelineName: "",
              isCommitInfoModal: !0
            },
            u.id
          )),
          /* @__PURE__ */ v.jsxs("div", { className: "dc__dashed_icon_grid-container", children: [
            /* @__PURE__ */ v.jsx("hr", { className: "dc__dotted-line" }),
            /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(Zht, { className: "scn-6" }) }),
            /* @__PURE__ */ v.jsx("hr", { className: "dc__dotted-line" })
          ] }),
          /* @__PURE__ */ v.jsx(
            yue,
            {
              status: "",
              artifact: o.image,
              blobStorageEnabled: !0,
              isArtifactUploaded: !1,
              isJobView: !1,
              type: ir.CI,
              imageReleaseTags: o.imageReleaseTags,
              imageComment: o.imageComment,
              ciPipelineId: o.ciPipelineId,
              artifactId: e,
              appReleaseTagNames: o.appReleaseTags,
              tagsEditable: o.tagsEditable,
              hideImageTaggingHardDelete: !1,
              renderCIListHeader: n
            }
          )
        ] }) : /* @__PURE__ */ v.jsx(
          oa,
          {
            title: "Data not available",
            subTitle: "The data you are looking for is not available",
            classname: "h-100 bcn-0 flex-grow-1"
          }
        )
      }
    ) })
  ] }) });
}, PSt = $ht, eft = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#767D84", fillRule: "evenodd", d: "M3.75 9.75c.385 0 .702.29.745.663l.005.087v1.938l2.432-2.43c.293-.294.768-.294 1.06 0 .271.27.292.695.063.99l-.062.07L5.56 13.5H7.5c.385 0 .702.29.745.663l.005.087c0 .385-.29.702-.663.745L7.5 15H3.75l-.078-.005-.049-.006-.051-.01-.054-.016c-.015-.004-.03-.01-.044-.015l-.05-.023c-.015-.006-.029-.014-.043-.022-.018-.01-.036-.021-.053-.033l-.033-.023c-.024-.02-.048-.04-.07-.061l-.005-.006c-.051-.051-.09-.103-.123-.16l-.005-.01-.018-.035c-.01-.019-.018-.039-.026-.06l-.014-.04-.016-.06-.008-.041-.005-.037-.002-.023L3 14.271V10.5c0-.414.336-.75.75-.75zM14.25 3l.076.004.05.007.052.01.054.016c.015.004.03.01.044.015l.05.023c.015.006.029.014.043.022.018.01.036.021.053.033.01.006.018.013.027.02l.034.026.031.028.016.016c.051.051.09.103.123.16l.005.01.018.035c.01.019.018.039.026.06l.014.04.016.06.008.041.003.018.005.046.001.03.001.03V7.5c0 .414-.336.75-.75.75-.385 0-.702-.29-.745-.663L13.5 7.5V5.56l-2.47 2.47c-.293.293-.767.293-1.06 0-.27-.27-.291-.695-.063-.99l.063-.07 2.469-2.471L10.5 4.5c-.385 0-.702-.29-.745-.663L9.75 3.75c0-.385.29-.702.663-.745L10.5 3h3.75z" })), tft = ({ URL: i, width: e, height: t, title: n, maxHeight: r, maxWidth: s }) => {
  const [o, a] = Oe(!1), [l, c] = Oe(!1), d = () => {
    a(!0);
  }, u = () => {
    a(!1);
  }, h = () => {
    c(!0);
  };
  return l ? /* @__PURE__ */ v.jsx(ob, { description: "Please try again later" }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__content-space dc__gap-4", children: [
        /* @__PURE__ */ v.jsx("h3", { className: "m-0 fs-12 cn-7 fw-6 dc__truncate", children: n }),
        /* @__PURE__ */ v.jsx(wn, { content: "Enter Full Screen", className: "default-tt", arrow: !1, children: /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus icon-dim-18 dc__tab-focus",
            onClick: d,
            "aria-label": "Enter Full Screen",
            children: /* @__PURE__ */ v.jsx(eft, { className: "dc__no-shrink icon-dim-18" })
          }
        ) })
      ] }),
      /* @__PURE__ */ v.jsx(
        "iframe",
        {
          src: i,
          width: Math.min(s, e),
          height: Math.min(r, t),
          className: "dc__no-border",
          onError: h,
          sandbox: "allow-same-origin allow-scripts",
          referrerPolicy: "no-referrer"
        }
      )
    ] }),
    o && /* @__PURE__ */ v.jsx(yk, { className: "", close: u, children: /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: "dc__overflow-scroll br-8 dc__position-rel bcn-0 custom-panel--iframe-element flexbox-col dc__content-space",
        onClick: Cr,
        children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space dc__border-bottom py-20 px-16", children: [
            /* @__PURE__ */ v.jsx("h3", { className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate", children: n }),
            /* @__PURE__ */ v.jsx(
              "button",
              {
                type: "button",
                className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus icon-dim-18 dc__tab-focus",
                onClick: u,
                "aria-label": "Close",
                children: /* @__PURE__ */ v.jsx(Il, { className: "dc__no-shrink icon-dim-18 fcn-6" })
              }
            )
          ] }),
          /* @__PURE__ */ v.jsx("div", { className: "flex px-16 py-8 h-100", children: /* @__PURE__ */ v.jsx(
            "iframe",
            {
              src: i,
              width: "100%",
              height: "100%",
              className: "dc__no-border",
              sandbox: "allow-same-origin allow-scripts",
              referrerPolicy: "no-referrer"
            }
          ) })
        ]
      }
    ) })
  ] });
}, nft = ({ iframeList: i, maxHeight: e = 300, maxWidth: t = 300 }) => {
  const n = i.sort((r, s) => (r?.order || 0) - (s?.order || 0));
  return /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__gap-16 flex-wrap w-100", children: n.map((r, s) => /* @__PURE__ */ v.jsx(
    tft,
    {
      URL: r.URL,
      width: r.width,
      height: r.height,
      title: r.title,
      maxHeight: e,
      maxWidth: t
    },
    s
  )) });
}, OSt = nft;
var r2e = /* @__PURE__ */ ((i) => (i.SHARED = "SHARED", i.PRESET = "PRESET", i))(r2e || {});
const MSt = {
  parentPluginStore: {},
  pluginVersionStore: {}
}, ift = {
  searchKey: "",
  selectedTags: []
}, rft = "Devtron", sft = (i) => i?.length ? i.map(({ id: e, description: t, name: n, pluginVersion: r, isLatest: s }) => ({
  id: e,
  description: t || "",
  name: n || "",
  pluginVersion: r || "",
  isLatest: s || !1
})) : [], s2e = (i) => {
  if (!i?.length)
    return {
      parentPluginStore: {},
      pluginVersionStore: {}
    };
  const e = {}, t = {};
  return i.forEach((n) => {
    const r = sft(n.pluginVersions.minimalPluginVersionData), s = r.findIndex((o) => o.isLatest);
    if (s === -1)
      throw new Error("Latest plugin version not found");
    e[n.id] = {
      id: n.id,
      name: n.name || "",
      description: n.description || "",
      type: n.type,
      icon: n.icon || "",
      pluginIdentifier: n.pluginIdentifier || "",
      // Assuming latest version is always present
      latestVersionId: r[s].id,
      pluginVersions: r
    }, n.pluginVersions.detailedPluginVersionData.forEach((o) => {
      const a = o.tags || [], l = Array.from(new Set(a)).sort(Qs);
      t[o.id] = {
        id: o.id,
        name: o.name || "",
        description: o.description || "",
        pluginVersion: o.pluginVersion || "",
        docLink: o.docLink || "",
        updatedBy: n.type === r2e.SHARED ? o.updatedBy : rft,
        outputVariables: o.outputVariables || [],
        inputVariables: o.inputVariables || [],
        isLatest: o.isLatest || !1,
        tags: l,
        parentPluginId: n.id,
        icon: n.icon || "",
        type: n.type,
        pluginIdentifier: n.pluginIdentifier || ""
      };
    });
  }), {
    parentPluginStore: e,
    pluginVersionStore: t
  };
}, oft = {
  ...Fde,
  option: (i, e) => ({
    ...i,
    height: "36px",
    padding: "8px 0px",
    backgroundColor: e.isFocused ? "var(--N100)" : "white",
    color: "var(--N900)",
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    ":active": {
      backgroundColor: "var(--N100)"
    }
  })
}, aft = (i) => /* @__PURE__ */ v.jsx(hue, { ...i, showTippy: !0, placement: "left" }), lft = (i, e, t) => {
  const n = structuredClone(i);
  return Object.keys(e).forEach((r) => {
    n.parentPluginStore[r] = e[r];
  }), Object.keys(t).forEach((r) => {
    n.pluginVersionStore[r] = t[r];
  }), n;
}, RSt = async ({
  appId: i,
  parentPluginIds: e,
  pluginIds: t,
  signal: n,
  shouldShowError: r = !0
}) => {
  try {
    const s = {
      appId: i,
      parentPluginId: e,
      pluginId: t
    }, { result: o } = await Qn(
      vl(hn.PLUGIN_GLOBAL_LIST_DETAIL_V2, s),
      { signal: n }
    );
    return {
      pluginStore: s2e(o?.parentPlugins)
    };
  } catch (s) {
    throw r && !SE(s) && Is(s), s;
  }
}, o2e = async ({
  searchKey: i,
  selectedTags: e,
  appId: t,
  offset: n = 0,
  signal: r
}) => {
  try {
    const s = {
      searchKey: i,
      offset: n,
      appId: t,
      size: 20,
      tag: e
    }, { result: o } = await Qn(vl(hn.PLUGIN_GLOBAL_LIST_V2, s), {
      signal: r
    }), a = s2e(o?.parentPlugins);
    return {
      totalCount: o?.totalCount || 0,
      pluginStore: a,
      parentPluginIdList: o?.parentPlugins?.map((l) => l.id) || []
    };
  } catch (s) {
    throw SE(s) || Is(s), s;
  }
}, cft = async (i) => {
  try {
    const e = {
      appId: i
    }, { result: t } = await Qn(vl(hn.PLUGIN_GLOBAL_LIST_TAGS, e));
    if (!t?.tagNames)
      return [];
    const n = new Set(t.tagNames);
    return Array.from(n).sort(Qs);
  } catch (e) {
    throw Is(e), e;
  }
}, FSt = async (i) => {
  const e = { appId: i };
  return Qn(vl(hn.PLUGIN_LIST_MIN, e));
}, dft = ({
  availableTags: i,
  handleUpdateSelectedTags: e,
  selectedTags: t,
  isLoading: n,
  hasError: r,
  reloadTags: s
}) => {
  const o = () => t?.map((b) => ({ label: b, value: b })) ?? [], [a, l] = Oe(!1), [c, d] = Oe(o());
  $e(() => {
    d(o());
  }, [t]);
  const u = Mn(
    () => i?.map((b) => ({ label: b, value: b })) || [],
    [i]
  ), h = (b) => {
    d(b);
  }, f = () => {
    l(!0);
  }, g = () => {
    l(!1), d(o());
  }, p = () => r ? /* @__PURE__ */ v.jsx(ob, { reload: s }) : /* @__PURE__ */ v.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-20 py-6 px-8", children: "No tags found" }), m = Wi(
    (b) => {
      const w = b.getValue() || [], y = () => {
        g(), e(w.map((S) => S.value));
      };
      return /* @__PURE__ */ v.jsx(GLe, { ...b, handleApplyFilter: y });
    },
    [e]
  ), _ = Wi(
    (b) => /* @__PURE__ */ v.jsx(qLe, { ...b, title: "Tags" }),
    []
  );
  return /* @__PURE__ */ v.jsx(
    Ba,
    {
      styles: oft,
      options: u,
      isMulti: !0,
      value: c,
      components: {
        IndicatorSeparator: null,
        ClearIndicator: null,
        LoadingIndicator: Rde,
        NoOptionsMessage: p,
        MenuList: m,
        Option: aft,
        ValueContainer: _
      },
      menuIsOpen: a,
      onMenuOpen: f,
      onMenuClose: g,
      isLoading: n,
      onChange: h,
      backspaceRemovesValue: !1,
      closeMenuOnSelect: !1,
      controlShouldRenderValue: !1,
      hideSelectedOptions: !1,
      blurInputOnSelect: !1,
      maxMenuHeight: 200,
      placeholder: "Search tags",
      inputId: "plugin-tag-select",
      className: "w-150"
    }
  );
}, uft = (i) => /* @__PURE__ */ G.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("g", { clipPath: "url(#clip0_5769_4636)" }, /* @__PURE__ */ G.createElement("path", { d: "M0.00016284 10.6669V22.9938C0.00016284 23.4007 0.246767 23.7671 0.623788 23.9202L16.0002 30.1669V16.6669L0.00016284 10.6669Z", fill: "#2589C7" }), /* @__PURE__ */ G.createElement("path", { d: "M32.0002 10.6669V22.9938C32.0002 23.4007 31.7536 23.7671 31.3765 23.9202L16.0002 30.1669V16.6669L32.0002 10.6669Z", fill: "#0E71AF" }), /* @__PURE__ */ G.createElement("path", { d: "M16.0002 16.6669L0.00016284 10.6669L16.0002 4.66687L32.0002 10.6669L16.0002 16.6669Z", fill: "#53ABDB" }), /* @__PURE__ */ G.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.0002 7.33221H21.0002V10.8319C21.0002 10.832 21.0002 10.8321 21.0002 10.8322C21.0007 11.4764 22.5675 11.9986 24.5002 11.9986C26.4328 11.9986 27.9996 11.4764 28.0002 10.8322C28.0002 10.8321 28.0002 10.832 28.0002 10.8319V7.33221Z", fill: "#1E85C5" }), /* @__PURE__ */ G.createElement("ellipse", { cx: 24.5002, cy: 7.33354, rx: 3.5, ry: 1.16667, fill: "#6DC4F3" }), /* @__PURE__ */ G.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0002 7.33221H4.00016V10.8319C4.00016 10.832 4.00016 10.8321 4.00016 10.8322C4.00069 11.4764 5.56749 11.9986 7.50016 11.9986C9.43283 11.9986 10.9996 11.4764 11.0002 10.8322C11.0002 10.8321 11.0002 10.832 11.0002 10.8319V7.33221Z", fill: "#1E85C5" }), /* @__PURE__ */ G.createElement("ellipse", { cx: 7.50016, cy: 7.33354, rx: 3.5, ry: 1.16667, fill: "#6DC4F3" }), /* @__PURE__ */ G.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5002 3.83221H12.5002V7.33189C12.5002 7.332 12.5002 7.33211 12.5002 7.33221C12.5007 7.9764 14.0675 8.49856 16.0002 8.49856C17.9328 8.49856 19.4996 7.9764 19.5002 7.33221C19.5002 7.33211 19.5002 7.332 19.5002 7.33189V3.83221Z", fill: "#1E85C5" }), /* @__PURE__ */ G.createElement("ellipse", { cx: 16.0002, cy: 3.83354, rx: 3.5, ry: 1.16667, fill: "#6DC4F3" }), /* @__PURE__ */ G.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5002 10.3322H12.5002V13.8319C12.5002 13.832 12.5002 13.8321 12.5002 13.8322C12.5007 14.4764 14.0675 14.9986 16.0002 14.9986C17.9328 14.9986 19.4996 14.4764 19.5002 13.8322C19.5002 13.8321 19.5002 13.832 19.5002 13.8319V10.3322Z", fill: "#1E85C5" }), /* @__PURE__ */ G.createElement("ellipse", { cx: 16.0002, cy: 10.3335, rx: 3.5, ry: 1.16667, fill: "#6DC4F3" })), /* @__PURE__ */ G.createElement("defs", null, /* @__PURE__ */ G.createElement("clipPath", { id: "clip0_5769_4636" }, /* @__PURE__ */ G.createElement("rect", { width: 32, height: 32, fill: "white" })))), hft = ({ imageProps: i, fallbackImageClassName: e }) => /* @__PURE__ */ v.jsx(
  tue,
  {
    fallbackImage: /* @__PURE__ */ v.jsx(uft, { className: `dc__no-shrink ${e}` }),
    imageProps: i
  }
), fft = hft, gft = ({ tags: i, rootClassName: e }) => i?.length ? /* @__PURE__ */ v.jsx("div", { className: `flexbox dc__gap-6 flex-wrap ${e}`, children: i.map((t) => /* @__PURE__ */ v.jsx("div", { className: "flexbox px-6 br-4 bcn-1 dc__align-items-center dc__mxw-160", children: /* @__PURE__ */ v.jsx("span", { className: "dc__mxw-160 dc__truncate cn-8 fs-11 fw-4 lh-20", children: t }) }, t)) }) : null, pft = gft, mft = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M6 4.125C6 3.72718 6.15804 3.34564 6.43934 3.06434C6.72064 2.78304 7.10218 2.625 7.5 2.625H10.5C10.5995 2.625 10.6948 2.66451 10.7652 2.73484C10.8355 2.80516 10.875 2.90054 10.875 3V9C10.875 9.09946 10.8355 9.19484 10.7652 9.26517C10.6948 9.33549 10.5995 9.375 10.5 9.375H7.5C7.10218 9.375 6.72064 9.53304 6.43934 9.81434C6.15804 10.0956 6 10.4772 6 10.875M6 4.125V10.875M6 4.125C6 3.72718 5.84196 3.34564 5.56066 3.06434C5.27936 2.78304 4.89782 2.625 4.5 2.625H1.5C1.40054 2.625 1.30516 2.66451 1.23483 2.73484C1.16451 2.80516 1.125 2.90054 1.125 3V9C1.125 9.09946 1.16451 9.19484 1.23483 9.26517C1.30516 9.33549 1.40054 9.375 1.5 9.375H4.5C4.89782 9.375 5.27936 9.53304 5.56066 9.81434C5.84196 10.0956 6 10.4772 6 10.875", stroke: "#0066CC", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), vft = ({
  isSelectable: i,
  pluginDataStore: e,
  handlePluginSelection: t,
  parentPluginId: n,
  isSelected: r,
  showCardBorder: s
}) => {
  const o = e.parentPluginStore[n].latestVersionId, { icon: a, name: l, description: c, tags: d, pluginVersion: u, updatedBy: h, docLink: f } = e.pluginVersionStore[o], g = (p) => {
    "key" in p && p.key !== "Enter" && p.key !== " " || t(n);
  };
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `p-12 flexbox dc__gap-16 dc__tab-focus plugin-card dc__visible-hover dc__visible-hover--parent br-4 ${s ? "dc__border dc__hover-n50" : "dc__border-transparent dc__hover-border-n1"}`,
      role: "button",
      tabIndex: 0,
      onClick: g,
      onKeyDown: g,
      children: [
        i && /* @__PURE__ */ v.jsx("div", { className: `dc__no-shrink icon-dim-40 p-8 ${r ? "" : "dc__visible-hover--child"}`, children: /* @__PURE__ */ v.jsx(
          cb,
          {
            isChecked: r,
            onChange: g,
            rootClassName: "icon-dim-40 p-8 w-100 mb-0 dc__no-shrink",
            value: Aa.CHECKED
          }
        ) }),
        !r && /* @__PURE__ */ v.jsx(
          fft,
          {
            fallbackImageClassName: `icon-dim-40 ${i ? "dc__visible-hover--hide-child" : ""}`,
            imageProps: {
              src: a,
              alt: `${l} logo`,
              width: 40,
              height: 40,
              className: `p-4 dc__no-shrink ${i ? "dc__visible-hover--hide-child" : ""}`
            }
          }
        ),
        /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-12 w-100", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
            /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
              /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-6 w-100 dc__align-start dc__content-space", children: [
                /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-4", children: [
                  /* @__PURE__ */ v.jsx("h4", { className: "m-0 dc__truncate cn-9 fs-13 fw-6 lh-20 plugin-card__title", children: l }),
                  !i && /* @__PURE__ */ v.jsxs("span", { className: "dc__truncate cn-7 fs-12 fw-4 lh-20", children: [
                    "(",
                    u,
                    ")"
                  ] })
                ] }),
                f && /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-4 dc__visible-hover--child dc__align-items-center dc__no-shrink", children: [
                  /* @__PURE__ */ v.jsx(
                    "a",
                    {
                      href: f,
                      className: "anchor fs-12 fw-6 lh-20",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      onClick: Cr,
                      children: "Learn more"
                    }
                  ),
                  /* @__PURE__ */ v.jsx(mft, { className: "icon-dim-12 dc__no-shrink scb-5" })
                ] })
              ] }),
              /* @__PURE__ */ v.jsxs("span", { className: "dc__truncate cn-7 fs-12 fw-4 lh-16", children: [
                "By ",
                h
              ] })
            ] }),
            c && /* @__PURE__ */ v.jsx("p", { className: "m-0 cn-7 fs-12 fw-4 lh-16 dc__truncate--clamp-3", children: c })
          ] }),
          /* @__PURE__ */ v.jsx(pft, { tags: d })
        ] })
      ]
    }
  );
}, _ft = () => /* @__PURE__ */ v.jsxs("div", { className: "p-12 flexbox dc__gap-16 w-100", children: [
  /* @__PURE__ */ v.jsx("div", { className: "p-4 dc__no-shrink icon-dim-40 shimmer-loading" }),
  /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-12 w-100", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-8 w-100", children: [
      /* @__PURE__ */ v.jsx("div", { className: "h-20 w-150 shimmer-loading" }),
      /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
        /* @__PURE__ */ v.jsx("div", { className: "h-12 w-100 shimmer-loading" }),
        /* @__PURE__ */ v.jsx("div", { className: "h-12 w-120 shimmer-loading" })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: "h-20 w-60 shimmer-loading" })
  ] })
] }), a2e = ({ count: i = 2 }) => /* @__PURE__ */ v.jsx(v.Fragment, { children: Array(i).fill(0).map((e, t) => (
  // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ v.jsx(_ft, {}, t)
)) }), bft = ({
  pluginDataStore: i,
  pluginList: e,
  totalCount: t,
  handleDataUpdateForPluginResponse: n,
  filters: { selectedTags: r, searchKey: s },
  handlePluginSelection: o,
  selectedPluginsMap: a,
  isSelectable: l,
  handleClearFilters: c,
  showCardBorder: d,
  getPluginStoreRef: u
}) => {
  const { appId: h } = eo(), [f, g] = Oe(!1), [p, m] = Oe(!1), _ = async () => {
    g(!0), m(!1);
    try {
      const b = await Ble(
        () => o2e({
          searchKey: s,
          offset: e.length,
          selectedTags: r,
          appId: h ? +h : null,
          signal: u.current.signal
        }),
        u
      );
      n(b, !0);
    } catch {
      m(!0);
    } finally {
      g(!1);
    }
  };
  return e.length ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    e.map((b) => /* @__PURE__ */ v.jsx(
      vft,
      {
        parentPluginId: b.parentPluginId,
        isSelectable: l,
        pluginDataStore: i,
        handlePluginSelection: o,
        isSelected: !!a[b.parentPluginId],
        showCardBorder: d
      },
      b.parentPluginId
    )),
    f && /* @__PURE__ */ v.jsx(a2e, {}),
    t > e.length && !f && /* @__PURE__ */ v.jsx(gue, { callback: _, hasError: p })
  ] }) : s || r.length ? /* @__PURE__ */ v.jsx(X1t, { handleClearFilters: c, imageType: Vl.Large }) : /* @__PURE__ */ v.jsx(oa, { title: "No plugins found", subTitle: "We are unable to locate any plugin in our system" });
}, Cft = ({
  availableTags: i,
  handleUpdateAvailableTags: e,
  pluginDataStore: t,
  handlePluginDataStoreUpdate: n,
  handlePluginSelection: r,
  // Selected plugins Section
  isSelectable: s,
  selectedPluginsMap: o = {},
  // Plugin list Section
  persistFilters: a,
  parentPluginList: l,
  handleParentPluginListUpdate: c,
  parentTotalCount: d,
  handleParentTotalCount: u,
  parentFilters: h,
  handleUpdateParentFilters: f,
  rootClassName: g = "",
  showCardBorder: p = !1
}) => {
  const { appId: m } = eo(), [_, b] = Oe(l || []), [w, y] = Oe(d || 0), [S, x] = Oe(
    h || structuredClone(ift)
  ), D = Nt(new AbortController()), E = (re) => {
    b(re), c?.(re);
  }, L = (re) => {
    y(re), u?.(re);
  }, k = (re) => {
    x(re), f?.(re);
  }, { searchKey: N, selectedTags: I } = S || {}, A = () => Ble(
    () => o2e({
      searchKey: N,
      selectedTags: I,
      offset: 0,
      appId: m ? +m : null,
      signal: D.current.signal
    }),
    D
  ), [P, O, K, W] = tf(
    A,
    // In case of persistFilters with change of searchKey or selectedTags we anyways clear the pluginList so no need to add dependency
    [N, m, I],
    a ? !_.length : !0
  ), [F, q, R, T] = tf(
    () => cft(m ? +m : null),
    [],
    !i?.length
  );
  $e(() => {
    !F && !R && q && e(q);
  }, [F, q, R]);
  const z = (re, B = !1) => {
    const {
      pluginStore: { parentPluginStore: ee, pluginVersionStore: j },
      totalCount: he,
      parentPluginIdList: Se
    } = re;
    n(lft(t, ee, j)), L(he);
    const ge = B ? structuredClone(_) : [], te = ge.reduce(
      (be, Ae) => (be[Ae.parentPluginId] = !0, be),
      {}
    );
    Se.forEach((be) => {
      te[be] || (ge.push({
        parentPluginId: be
      }), te[be] = !0);
    }), E(ge);
  };
  $e(() => {
    !(P || SE(K)) && !K && O && z(O);
  }, [P, O, K]);
  const X = () => {
    a && E([]);
  }, ae = () => {
    k({
      searchKey: "",
      selectedTags: []
    }), X();
  }, ue = (re) => {
    k({
      ...S,
      searchKey: re
    }), X();
  }, se = (re) => {
    k({
      ...S,
      selectedTags: re
    }), X();
  }, le = (re) => {
    k({
      ...S,
      selectedTags: re.selectedTags
    }), X();
  }, oe = (re) => {
    r(re);
  };
  return /* @__PURE__ */ v.jsxs("div", { className: `flexbox-col w-100 ${g}`, children: [
    /* @__PURE__ */ v.jsxs("div", { className: "w-100 flexbox dc__gap-12 py-12 dc__position-sticky dc__top-0 bcn-0 dc__zi-1 flex-wrap", children: [
      /* @__PURE__ */ v.jsx(
        _Ce,
        {
          initialSearchText: N,
          containerClassName: "flex-grow-1",
          handleEnter: ue,
          inputProps: {
            placeholder: "Search plugins",
            autoFocus: !0
          }
        }
      ),
      /* @__PURE__ */ v.jsx(
        dft,
        {
          availableTags: i,
          handleUpdateSelectedTags: se,
          selectedTags: I,
          isLoading: F,
          hasError: !!R,
          reloadTags: T
        }
      )
    ] }),
    !!I.length && /* @__PURE__ */ v.jsx(
      UAe,
      {
        filterConfig: {
          selectedTags: I
        },
        onRemoveFilter: le,
        clearFilters: ae,
        className: "w-100 pt-0-imp",
        clearButtonClassName: "dc__no-background-imp dc__no-border-imp dc__tab-focus",
        shouldHideLabel: !0
      }
    ),
    /* @__PURE__ */ v.jsx(
      rde,
      {
        isLoading: P || SE(K),
        customLoader: /* @__PURE__ */ v.jsx(a2e, {}),
        error: K,
        errorScreenManagerProps: {
          code: K?.code,
          reload: W
        },
        children: /* @__PURE__ */ v.jsx(
          bft,
          {
            pluginDataStore: t,
            pluginList: _,
            totalCount: w,
            handleDataUpdateForPluginResponse: z,
            filters: S,
            handlePluginSelection: oe,
            selectedPluginsMap: o,
            isSelectable: s,
            handleClearFilters: ae,
            showCardBorder: p,
            getPluginStoreRef: D
          }
        )
      }
    )
  ] });
}, BSt = Cft, kq = (i) => /* @__PURE__ */ G.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M3.5 7.50009L6.00004 10.0001M6.00004 10.0001L8.5 7.50054M6.00004 10.0001V2", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), yft = "Keys must be unique", wft = "Key cannot be empty", Sft = (i) => /* @__PURE__ */ v.jsx(
  wn,
  {
    className: "default-tt",
    arrow: !1,
    placement: "bottom",
    content: "Cannot edit in read-only mode",
    followCursor: "horizontal",
    plugins: [MLe],
    children: i
  }
), VSt = ({
  config: i,
  maskValue: e,
  isSortable: t,
  headerComponent: n,
  onChange: r,
  onDelete: s,
  placeholder: o,
  isAdditionNotAllowed: a,
  readOnly: l,
  showError: c,
  validationSchema: d,
  errorMessages: u = [],
  onError: h,
  validateDuplicateKeys: f = !1,
  validateEmptyKeys: g = !1
}) => {
  const { headers: p, rows: m } = i, _ = p[0].key, b = p[1].key, [w, y] = Oe(m), [S, x] = Oe(!1), D = l || a, E = !l && !a || !!w.length, L = !w[0]?.data[_].value && !w[0]?.data[b].value, k = w.length === 1 && L, { sortBy: N, sortOrder: I, handleSorting: A } = jve({
    initialSortKey: t ? _ : null
  }), P = Nt(), O = Nt();
  P.current || (P.current = w.reduce((oe, re) => ({ ...oe, [re.id]: t1() }), {})), O.current || (O.current = w.reduce((oe, re) => ({ ...oe, [re.id]: t1() }), {}));
  const K = Mn(
    () => w.reduce(
      (oe, re) => {
        const B = re.data[_].value;
        return B && (oe[B] = (oe[B] || 0) + 1), oe;
      },
      {}
    ),
    [w]
  ), W = (oe, re, B, ee = !0) => {
    if (ee) {
      const j = oe.trim();
      if (f && re === _ && K[j] > 1 || g && re === _ && !j && w.some(
        ({ id: Se, data: ge }) => Se === B && ge[b].value.trim()
      ))
        return !1;
    }
    return d ? d(oe, re, B) : !0;
  }, F = (oe) => {
    if (f) {
      const { isAnyKeyDuplicated: B } = oe.reduce(
        (ee, j) => {
          const { keysFrequency: he } = ee, Se = j.data[_].value.trim();
          return Se && (he[Se] = (he[Se] || 0) + 1), {
            isAnyKeyDuplicated: ee.isAnyKeyDuplicated || he[Se] > 1,
            keysFrequency: he
          };
        },
        { isAnyKeyDuplicated: !1, keysFrequency: {} }
      );
      if (B)
        return !1;
    }
    return g && oe.some(
      (ee) => !ee.data[_].value.trim() && ee.data[b].value.trim()
    ) ? !1 : oe.every(
      ({ data: B, id: ee }) => W(B[_].value, _, ee, !1) && W(B[b].value, b, ee, !1)
    );
  }, q = () => {
    const oe = (Date.now() * Math.random()).toString(16);
    return {
      data: {
        [_]: {
          value: ""
        },
        [b]: {
          value: ""
        }
      },
      id: oe
    };
  }, R = () => {
    const oe = q(), re = [oe, ...w], { id: B } = oe;
    h?.(!F(re)), x(!0), y(re), P.current = {
      ...P.current || {},
      [B]: t1()
    }, O.current = {
      ...O.current || {},
      [B]: t1()
    };
  };
  $e(() => {
    !D && !w.length && R();
  }, []), $e(() => {
    t && y((oe) => {
      const re = structuredClone(oe);
      return re.sort(
        (B, ee) => Qs(B.data[N].value, ee.data[N].value, I)
      ), re;
    });
  }, [I]), $e(() => {
    const oe = w[0];
    if (oe && S) {
      x(!1);
      const re = P.current[oe.id].current && O.current[oe.id].current;
      !oe.data[_].value && re && O.current[oe.id].current.focus(), !oe.data[b].value && re && P.current[oe.id].current.focus();
    }
  }, [S]);
  const T = () => A(N), z = (oe) => () => {
    const re = w.filter(({ id: B }) => B !== oe.id);
    if (re.length === 0 && !a) {
      const B = q(), { id: ee } = B;
      x(!0), h?.(!F([B])), y([B]), P.current = {
        [ee]: t1()
      }, O.current = {
        [ee]: t1()
      }, s?.(oe.id);
      return;
    }
    h?.(!F(re)), y(re), delete P.current[oe.id], delete O.current[oe.id], s?.(oe.id);
  }, X = (oe, re) => (B) => {
    const { value: ee } = B.target, j = {
      ...oe,
      data: {
        ...oe.data,
        [re]: {
          ...oe.data[re],
          value: ee
        }
      }
    }, he = w.map((Se) => Se.id === oe.id ? j : Se);
    h?.(!F(he)), y(he);
  }, ae = (oe, re) => (B) => {
    const { value: ee } = B.target;
    (ee || oe.data[re === _ ? b : _].value) && (r?.(oe.id, re, ee), h?.(!F(w)));
  }, ue = (oe, re, B) => /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `bcn-50 py-8 px-12 flexbox dc__content-space dc__align-items-center ${w.length || !D ? "dc__top-left-radius" : "dc__left-radius-4"} ${B || ""}`,
      children: [
        t ? /* @__PURE__ */ v.jsxs(
          "button",
          {
            type: "button",
            className: "cn-7 fs-12 lh-20-imp fw-6 flexbox dc__align-items-center dc__gap-2 dc__transparent",
            onClick: T,
            children: [
              re,
              /* @__PURE__ */ v.jsx(
                kq,
                {
                  className: "icon-dim-16 dc__no-shrink scn-7 rotate cursor",
                  style: {
                    "--rotateBy": I === Xi.ASC ? "0deg" : "180deg"
                  }
                }
              )
            ]
          }
        ) : /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: `cn-7 fs-12 lh-20 fw-6 flexbox dc__align-items-center dc__content-space dc__gap-2 ${E ? "dc__top-left-radius" : "dc__left-radius-4"}`,
            children: [
              re,
              !!n && n
            ]
          }
        ),
        /* @__PURE__ */ v.jsxs(
          "button",
          {
            type: "button",
            className: `dc__transparent p-0 flex dc__gap-4 ${D ? "dc__disabled" : ""}`,
            disabled: D,
            onClick: R,
            children: [
              /* @__PURE__ */ v.jsx(fS, { className: "icon-dim-12 fcb-5 dc__no-shrink" }),
              /* @__PURE__ */ v.jsx("span", { className: "cb-5 fs-12 fw-6 lh-20", children: "Add" })
            ]
          }
        )
      ]
    },
    `${oe}-header`
  ), se = (oe) => /* @__PURE__ */ v.jsxs("div", { className: "flexbox align-items-center dc__gap-4", children: [
    /* @__PURE__ */ v.jsx(Il, { className: "icon-dim-16 fcr-5 dc__align-self-start dc__no-shrink" }),
    /* @__PURE__ */ v.jsx("p", { className: "fs-12 lh-16 cn-7 m-0", children: oe })
  ] }, oe), le = (oe, re, B) => c && !W(oe, re, B) ? /* @__PURE__ */ v.jsxs("div", { className: "key-value-table__error bcn-0 dc__border br-4 py-7 px-8 flexbox-col dc__gap-4", children: [
    f && se(yft),
    g && se(wft),
    u.map((j) => se(j))
  ] }) : null;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("div", { className: `bcn-2 p-1 ${E ? "dc__top-radius-4" : "br-4"}`, children: /* @__PURE__ */ v.jsx("div", { className: "key-value-table two-columns w-100 bcn-1 br-4", children: /* @__PURE__ */ v.jsx("div", { className: "key-value-table__row", children: p.map(
      ({ key: oe, label: re, className: B }) => oe === _ ? ue(oe, re, B) : /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: `bcn-50 cn-9 fs-13 lh-20 py-8 px-12 fw-6 flexbox dc__align-items-center dc__content-space dc__gap-2 ${oe === _ ? `${E ? "dc__top-left-radius" : "dc__left-radius-4"}` : `${E ? "dc__top-right-radius" : "dc__right-radius-4"}`}  ${B || ""}`,
          children: [
            re,
            !!n && n
          ]
        },
        oe
      )
    ) }) }) }),
    E && /* @__PURE__ */ v.jsx("div", { className: "bcn-2 px-1 pb-1 dc__bottom-radius-4", children: !!w.length && /* @__PURE__ */ v.jsx(
      "div",
      {
        className: `key-value-table w-100 bcn-1 dc__bottom-radius-4 ${l ? "two-columns" : "three-columns"}`,
        children: w.map((oe) => /* @__PURE__ */ v.jsxs("div", { className: "key-value-table__row", children: [
          p.map(({ key: re }) => /* @__PURE__ */ v.jsx(qh, { children: /* @__PURE__ */ v.jsx(lc, { wrap: Sft, condition: l, children: /* @__PURE__ */ v.jsx(
            "div",
            {
              className: `key-value-table__cell bcn-0 flexbox dc__align-items-center dc__gap-4 dc__position-rel ${l || oe.data[re].disabled ? "cursor-not-allowed no-hover" : ""} ${c && !W(oe.data[re].value, re, oe.id) ? "key-value-table__cell--error no-hover" : ""}`,
              children: e?.[re] && oe.data[re].value ? /* @__PURE__ */ v.jsx("div", { className: "py-8 px-12 h-36 flex", children: yIe }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                /* @__PURE__ */ v.jsx(
                  mCe,
                  {
                    ...oe.data[re],
                    className: `key-value-table__cell-input placeholder-cn5 py-8 px-12 cn-9 fs-13 lh-20 dc__no-border-radius ${l || oe.data[re].disabled ? "cursor-not-allowed" : ""}`,
                    minHeight: 20,
                    maxHeight: 160,
                    value: oe.data[re].value,
                    placeholder: o[re],
                    onChange: X(oe, re),
                    onBlur: ae(oe, re),
                    refVar: re === _ ? P.current?.[oe.id] : O.current?.[oe.id],
                    dependentRef: re === _ ? O.current?.[oe.id] : P.current?.[oe.id],
                    disabled: l || oe.data[re].disabled,
                    disableOnBlurResizeToMinHeight: !0
                  }
                ),
                oe.data[re].required && /* @__PURE__ */ v.jsx("span", { className: "cr-5 fs-16 dc__align-self-start px-6 py-8", children: "*" }),
                le(oe.data[re].value, re, oe.id)
              ] })
            }
          ) }) }, re)),
          !l && /* @__PURE__ */ v.jsx(
            "button",
            {
              type: "button",
              className: `key-value-table__row-delete-btn dc__unset-button-styles dc__align-self-stretch dc__no-shrink flex py-10 px-8 bcn-0 dc__hover-n50 dc__tab-focus ${k ? "dc__disabled" : ""}`,
              onClick: z(oe),
              disabled: k,
              children: /* @__PURE__ */ v.jsx(
                ab,
                {
                  "aria-label": "delete-row",
                  className: "icon-dim-16 fcn-4 dc__align-self-start"
                }
              )
            }
          )
        ] }, oe.id))
      }
    ) })
  ] });
};
function gae(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(i);
    e && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(i, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Xt(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? gae(Object(t), !0).forEach(function(n) {
      dg(i, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : gae(Object(t)).forEach(function(n) {
      Object.defineProperty(i, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return i;
}
function xft(i, e) {
  if (!(i instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function pae(i, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(i, t2e(n.key), n);
  }
}
function Dft(i, e, t) {
  return e && pae(i.prototype, e), t && pae(i, t), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
function Eft(i, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  i.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: i,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(i, "prototype", {
    writable: !1
  }), e && jI(i, e);
}
function UI(i) {
  return UI = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, UI(i);
}
function l2e() {
  try {
    var i = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (l2e = function() {
    return !!i;
  })();
}
function Lft(i, e) {
  if (e && (S0(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return e2e(i);
}
function Ift(i) {
  var e = l2e();
  return function() {
    var t, n = UI(i);
    if (e) {
      var r = UI(this).constructor;
      t = Reflect.construct(n, arguments, r);
    } else t = n.apply(this, arguments);
    return Lft(this, t);
  };
}
function Aft(i) {
  if (i.sheet)
    return i.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === i)
      return document.styleSheets[e];
}
function kft(i) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", i.key), i.nonce !== void 0 && e.setAttribute("nonce", i.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var Tft = /* @__PURE__ */ function() {
  function i(t) {
    var n = this;
    this._insertTag = function(r) {
      var s;
      n.tags.length === 0 ? n.insertionPoint ? s = n.insertionPoint.nextSibling : n.prepend ? s = n.container.firstChild : s = n.before : s = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(r, s), n.tags.push(r);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var e = i.prototype;
  return e.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, e.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(kft(this));
    var r = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var s = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      s && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !s;
    }
    if (this.isSpeedy) {
      var o = Aft(r);
      try {
        o.insertRule(n, o.cssRules.length);
      } catch (a) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', a);
      }
    } else
      r.appendChild(document.createTextNode(n));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, i;
}(), xo = "-ms-", GI = "-moz-", Ci = "-webkit-", Tq = "comm", Nq = "rule", Pq = "decl", Nft = "@import", c2e = "@keyframes", Pft = "@layer", Oft = Math.abs, pk = String.fromCharCode, Mft = Object.assign;
function Rft(i, e) {
  return oo(i, 0) ^ 45 ? (((e << 2 ^ oo(i, 0)) << 2 ^ oo(i, 1)) << 2 ^ oo(i, 2)) << 2 ^ oo(i, 3) : 0;
}
function d2e(i) {
  return i.trim();
}
function Fft(i, e) {
  return (i = e.exec(i)) ? i[0] : i;
}
function yi(i, e, t) {
  return i.replace(e, t);
}
function _W(i, e) {
  return i.indexOf(e);
}
function oo(i, e) {
  return i.charCodeAt(e) | 0;
}
function Zw(i, e, t) {
  return i.slice(e, t);
}
function Bd(i) {
  return i.length;
}
function Oq(i) {
  return i.length;
}
function c3(i, e) {
  return e.push(i), i;
}
function Bft(i, e) {
  return i.map(e).join("");
}
var mk = 1, $_ = 1, u2e = 0, Ua = 0, ws = 0, Hb = "";
function vk(i, e, t, n, r, s, o) {
  return { value: i, root: e, parent: t, type: n, props: r, children: s, line: mk, column: $_, length: o, return: "" };
}
function P2(i, e) {
  return Mft(vk("", null, null, "", null, null, 0), i, { length: -i.length }, e);
}
function Vft() {
  return ws;
}
function Hft() {
  return ws = Ua > 0 ? oo(Hb, --Ua) : 0, $_--, ws === 10 && ($_ = 1, mk--), ws;
}
function ml() {
  return ws = Ua < u2e ? oo(Hb, Ua++) : 0, $_++, ws === 10 && ($_ = 1, mk++), ws;
}
function fu() {
  return oo(Hb, Ua);
}
function pE() {
  return Ua;
}
function px(i, e) {
  return Zw(Hb, i, e);
}
function Qw(i) {
  switch (i) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function h2e(i) {
  return mk = $_ = 1, u2e = Bd(Hb = i), Ua = 0, [];
}
function f2e(i) {
  return Hb = "", i;
}
function mE(i) {
  return d2e(px(Ua - 1, bW(i === 91 ? i + 2 : i === 40 ? i + 1 : i)));
}
function Wft(i) {
  for (; (ws = fu()) && ws < 33; )
    ml();
  return Qw(i) > 2 || Qw(ws) > 3 ? "" : " ";
}
function jft(i, e) {
  for (; --e && ml() && !(ws < 48 || ws > 102 || ws > 57 && ws < 65 || ws > 70 && ws < 97); )
    ;
  return px(i, pE() + (e < 6 && fu() == 32 && ml() == 32));
}
function bW(i) {
  for (; ml(); )
    switch (ws) {
      case i:
        return Ua;
      case 34:
      case 39:
        i !== 34 && i !== 39 && bW(ws);
        break;
      case 40:
        i === 41 && bW(i);
        break;
      case 92:
        ml();
        break;
    }
  return Ua;
}
function zft(i, e) {
  for (; ml() && i + ws !== 57; )
    if (i + ws === 84 && fu() === 47)
      break;
  return "/*" + px(e, Ua - 1) + "*" + pk(i === 47 ? i : ml());
}
function Uft(i) {
  for (; !Qw(fu()); )
    ml();
  return px(i, Ua);
}
function Gft(i) {
  return f2e(vE("", null, null, null, [""], i = h2e(i), 0, [0], i));
}
function vE(i, e, t, n, r, s, o, a, l) {
  for (var c = 0, d = 0, u = o, h = 0, f = 0, g = 0, p = 1, m = 1, _ = 1, b = 0, w = "", y = r, S = s, x = n, D = w; m; )
    switch (g = b, b = ml()) {
      case 40:
        if (g != 108 && oo(D, u - 1) == 58) {
          _W(D += yi(mE(b), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        D += mE(b);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        D += Wft(g);
        break;
      case 92:
        D += jft(pE() - 1, 7);
        continue;
      case 47:
        switch (fu()) {
          case 42:
          case 47:
            c3(qft(zft(ml(), pE()), e, t), l);
            break;
          default:
            D += "/";
        }
        break;
      case 123 * p:
        a[c++] = Bd(D) * _;
      case 125 * p:
      case 59:
      case 0:
        switch (b) {
          case 0:
          case 125:
            m = 0;
          case 59 + d:
            _ == -1 && (D = yi(D, /\f/g, "")), f > 0 && Bd(D) - u && c3(f > 32 ? vae(D + ";", n, t, u - 1) : vae(yi(D, " ", "") + ";", n, t, u - 2), l);
            break;
          case 59:
            D += ";";
          default:
            if (c3(x = mae(D, e, t, c, d, r, a, w, y = [], S = [], u), s), b === 123)
              if (d === 0)
                vE(D, e, x, x, y, s, u, a, S);
              else
                switch (h === 99 && oo(D, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    vE(i, x, x, n && c3(mae(i, x, x, 0, 0, r, a, w, r, y = [], u), S), r, S, u, a, n ? y : S);
                    break;
                  default:
                    vE(D, x, x, x, [""], S, 0, a, S);
                }
        }
        c = d = f = 0, p = _ = 1, w = D = "", u = o;
        break;
      case 58:
        u = 1 + Bd(D), f = g;
      default:
        if (p < 1) {
          if (b == 123)
            --p;
          else if (b == 125 && p++ == 0 && Hft() == 125)
            continue;
        }
        switch (D += pk(b), b * p) {
          case 38:
            _ = d > 0 ? 1 : (D += "\f", -1);
            break;
          case 44:
            a[c++] = (Bd(D) - 1) * _, _ = 1;
            break;
          case 64:
            fu() === 45 && (D += mE(ml())), h = fu(), d = u = Bd(w = D += Uft(pE())), b++;
            break;
          case 45:
            g === 45 && Bd(D) == 2 && (p = 0);
        }
    }
  return s;
}
function mae(i, e, t, n, r, s, o, a, l, c, d) {
  for (var u = r - 1, h = r === 0 ? s : [""], f = Oq(h), g = 0, p = 0, m = 0; g < n; ++g)
    for (var _ = 0, b = Zw(i, u + 1, u = Oft(p = o[g])), w = i; _ < f; ++_)
      (w = d2e(p > 0 ? h[_] + " " + b : yi(b, /&\f/g, h[_]))) && (l[m++] = w);
  return vk(i, e, t, r === 0 ? Nq : a, l, c, d);
}
function qft(i, e, t) {
  return vk(i, e, t, Tq, pk(Vft()), Zw(i, 2, -2), 0);
}
function vae(i, e, t, n) {
  return vk(i, e, t, Pq, Zw(i, 0, n), Zw(i, n + 1, -1), n);
}
function $v(i, e) {
  for (var t = "", n = Oq(i), r = 0; r < n; r++)
    t += e(i[r], r, i, e) || "";
  return t;
}
function Kft(i, e, t, n) {
  switch (i.type) {
    case Pft:
      if (i.children.length) break;
    case Nft:
    case Pq:
      return i.return = i.return || i.value;
    case Tq:
      return "";
    case c2e:
      return i.return = i.value + "{" + $v(i.children, n) + "}";
    case Nq:
      i.value = i.props.join(",");
  }
  return Bd(t = $v(i.children, n)) ? i.return = i.value + "{" + t + "}" : "";
}
function Yft(i) {
  var e = Oq(i);
  return function(t, n, r, s) {
    for (var o = "", a = 0; a < e; a++)
      o += i[a](t, n, r, s) || "";
    return o;
  };
}
function Xft(i) {
  return function(e) {
    e.root || (e = e.return) && i(e);
  };
}
function Zft(i) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return e[t] === void 0 && (e[t] = i(t)), e[t];
  };
}
var Qft = function(e, t, n) {
  for (var r = 0, s = 0; r = s, s = fu(), r === 38 && s === 12 && (t[n] = 1), !Qw(s); )
    ml();
  return px(e, Ua);
}, Jft = function(e, t) {
  var n = -1, r = 44;
  do
    switch (Qw(r)) {
      case 0:
        r === 38 && fu() === 12 && (t[n] = 1), e[n] += Qft(Ua - 1, t, n);
        break;
      case 2:
        e[n] += mE(r);
        break;
      case 4:
        if (r === 44) {
          e[++n] = fu() === 58 ? "&\f" : "", t[n] = e[n].length;
          break;
        }
      default:
        e[n] += pk(r);
    }
  while (r = ml());
  return e;
}, $ft = function(e, t) {
  return f2e(Jft(h2e(e), t));
}, _ae = /* @__PURE__ */ new WeakMap(), egt = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !_ae.get(n)) && !r) {
      _ae.set(e, !0);
      for (var s = [], o = $ft(t, s), a = n.props, l = 0, c = 0; l < o.length; l++)
        for (var d = 0; d < a.length; d++, c++)
          e.props[c] = s[l] ? o[l].replace(/&\f/g, a[d]) : a[d] + " " + o[l];
    }
  }
}, tgt = function(e) {
  if (e.type === "decl") {
    var t = e.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, ngt = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", igt = function(e) {
  return e.type === "comm" && e.children.indexOf(ngt) > -1;
}, rgt = function(e) {
  return function(t, n, r) {
    if (!(t.type !== "rule" || e.compat)) {
      var s = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (s) {
        for (var o = !!t.parent, a = o ? t.parent.children : (
          // global rule at the root level
          r
        ), l = a.length - 1; l >= 0; l--) {
          var c = a[l];
          if (c.line < t.line)
            break;
          if (c.column < t.column) {
            if (igt(c))
              return;
            break;
          }
        }
        s.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, g2e = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, sgt = function(e, t) {
  for (var n = e - 1; n >= 0; n--)
    if (!g2e(t[n]))
      return !0;
  return !1;
}, bae = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, ogt = function(e, t, n) {
  g2e(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), bae(e)) : sgt(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), bae(e)));
};
function p2e(i, e) {
  switch (Rft(i, e)) {
    case 5103:
      return Ci + "print-" + i + i;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Ci + i + i;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ci + i + GI + i + xo + i + i;
    case 6828:
    case 4268:
      return Ci + i + xo + i + i;
    case 6165:
      return Ci + i + xo + "flex-" + i + i;
    case 5187:
      return Ci + i + yi(i, /(\w+).+(:[^]+)/, Ci + "box-$1$2" + xo + "flex-$1$2") + i;
    case 5443:
      return Ci + i + xo + "flex-item-" + yi(i, /flex-|-self/, "") + i;
    case 4675:
      return Ci + i + xo + "flex-line-pack" + yi(i, /align-content|flex-|-self/, "") + i;
    case 5548:
      return Ci + i + xo + yi(i, "shrink", "negative") + i;
    case 5292:
      return Ci + i + xo + yi(i, "basis", "preferred-size") + i;
    case 6060:
      return Ci + "box-" + yi(i, "-grow", "") + Ci + i + xo + yi(i, "grow", "positive") + i;
    case 4554:
      return Ci + yi(i, /([^-])(transform)/g, "$1" + Ci + "$2") + i;
    case 6187:
      return yi(yi(yi(i, /(zoom-|grab)/, Ci + "$1"), /(image-set)/, Ci + "$1"), i, "") + i;
    case 5495:
    case 3959:
      return yi(i, /(image-set\([^]*)/, Ci + "$1$`$1");
    case 4968:
      return yi(yi(i, /(.+:)(flex-)?(.*)/, Ci + "box-pack:$3" + xo + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Ci + i + i;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return yi(i, /(.+)-inline(.+)/, Ci + "$1$2") + i;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Bd(i) - 1 - e > 6) switch (oo(i, e + 1)) {
        case 109:
          if (oo(i, e + 4) !== 45) break;
        case 102:
          return yi(i, /(.+:)(.+)-([^]+)/, "$1" + Ci + "$2-$3$1" + GI + (oo(i, e + 3) == 108 ? "$3" : "$2-$3")) + i;
        case 115:
          return ~_W(i, "stretch") ? p2e(yi(i, "stretch", "fill-available"), e) + i : i;
      }
      break;
    case 4949:
      if (oo(i, e + 1) !== 115) break;
    case 6444:
      switch (oo(i, Bd(i) - 3 - (~_W(i, "!important") && 10))) {
        case 107:
          return yi(i, ":", ":" + Ci) + i;
        case 101:
          return yi(i, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Ci + (oo(i, 14) === 45 ? "inline-" : "") + "box$3$1" + Ci + "$2$3$1" + xo + "$2box$3") + i;
      }
      break;
    case 5936:
      switch (oo(i, e + 11)) {
        case 114:
          return Ci + i + xo + yi(i, /[svh]\w+-[tblr]{2}/, "tb") + i;
        case 108:
          return Ci + i + xo + yi(i, /[svh]\w+-[tblr]{2}/, "tb-rl") + i;
        case 45:
          return Ci + i + xo + yi(i, /[svh]\w+-[tblr]{2}/, "lr") + i;
      }
      return Ci + i + xo + i + i;
  }
  return i;
}
var agt = function(e, t, n, r) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case Pq:
      e.return = p2e(e.value, e.length);
      break;
    case c2e:
      return $v([P2(e, {
        value: yi(e.value, "@", "@" + Ci)
      })], r);
    case Nq:
      if (e.length) return Bft(e.props, function(s) {
        switch (Fft(s, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return $v([P2(e, {
              props: [yi(s, /:(read-\w+)/, ":" + GI + "$1")]
            })], r);
          case "::placeholder":
            return $v([P2(e, {
              props: [yi(s, /:(plac\w+)/, ":" + Ci + "input-$1")]
            }), P2(e, {
              props: [yi(s, /:(plac\w+)/, ":" + GI + "$1")]
            }), P2(e, {
              props: [yi(s, /:(plac\w+)/, xo + "input-$1")]
            })], r);
        }
        return "";
      });
  }
}, lgt = [agt], cgt = function(e) {
  var t = e.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(p) {
      var m = p.getAttribute("data-emotion");
      m.indexOf(" ") !== -1 && (document.head.appendChild(p), p.setAttribute("data-s", ""));
    });
  }
  var r = e.stylisPlugins || lgt;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var s = {}, o, a = [];
  o = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(p) {
      for (var m = p.getAttribute("data-emotion").split(" "), _ = 1; _ < m.length; _++)
        s[m[_]] = !0;
      a.push(p);
    }
  );
  var l, c = [egt, tgt];
  process.env.NODE_ENV !== "production" && c.push(rgt({
    get compat() {
      return g.compat;
    }
  }), ogt);
  {
    var d, u = [Kft, process.env.NODE_ENV !== "production" ? function(p) {
      p.root || (p.return ? d.insert(p.return) : p.value && p.type !== Tq && d.insert(p.value + "{}"));
    } : Xft(function(p) {
      d.insert(p);
    })], h = Yft(c.concat(r, u)), f = function(m) {
      return $v(Gft(m), h);
    };
    l = function(m, _, b, w) {
      d = b, process.env.NODE_ENV !== "production" && _.map !== void 0 && (d = {
        insert: function(S) {
          b.insert(S + _.map);
        }
      }), f(m ? m + "{" + _.styles + "}" : _.styles), w && (g.inserted[_.name] = !0);
    };
  }
  var g = {
    key: t,
    sheet: new Tft({
      key: t,
      container: o,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: s,
    registered: {},
    insert: l
  };
  return g.sheet.hydrate(a), g;
};
fq();
var dgt = !0;
function m2e(i, e, t) {
  var n = "";
  return t.split(" ").forEach(function(r) {
    i[r] !== void 0 ? e.push(i[r] + ";") : n += r + " ";
  }), n;
}
var Mq = function(e, t, n) {
  var r = e.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  dgt === !1) && e.registered[r] === void 0 && (e.registered[r] = t.styles);
}, Rq = function(e, t, n) {
  Mq(e, t, n);
  var r = e.key + "-" + t.name;
  if (e.inserted[t.name] === void 0) {
    var s = t;
    do
      e.insert(t === s ? "." + r : "", s, e.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function ugt(i) {
  for (var e = 0, t, n = 0, r = i.length; r >= 4; ++n, r -= 4)
    t = i.charCodeAt(n) & 255 | (i.charCodeAt(++n) & 255) << 8 | (i.charCodeAt(++n) & 255) << 16 | (i.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, e = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      e ^= (i.charCodeAt(n + 2) & 255) << 16;
    case 2:
      e ^= (i.charCodeAt(n + 1) & 255) << 8;
    case 1:
      e ^= i.charCodeAt(n) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var hgt = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Cae = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, fgt = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", ggt = /[A-Z]|^ms/g, v2e = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Fq = function(e) {
  return e.charCodeAt(1) === 45;
}, yae = function(e) {
  return e != null && typeof e != "boolean";
}, YM = /* @__PURE__ */ Zft(function(i) {
  return Fq(i) ? i : i.replace(ggt, "-$&").toLowerCase();
}), qI = function(e, t) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(v2e, function(n, r, s) {
          return Vc = {
            name: r,
            styles: s,
            next: Vc
          }, r;
        });
  }
  return hgt[e] !== 1 && !Fq(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var pgt = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, mgt = ["normal", "none", "initial", "inherit", "unset"], vgt = qI, _gt = /^-ms-/, bgt = /-(.)/g, wae = {};
  qI = function(e, t) {
    if (e === "content" && (typeof t != "string" || mgt.indexOf(t) === -1 && !pgt.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = vgt(e, t);
    return n !== "" && !Fq(e) && e.indexOf("-") !== -1 && wae[e] === void 0 && (wae[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(_gt, "ms-").replace(bgt, function(r, s) {
      return s.toUpperCase();
    }) + "?")), n;
  };
}
var _2e = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Jw(i, e, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(_2e);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return Vc = {
          name: t.name,
          styles: t.styles,
          next: Vc
        }, t.name;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            Vc = {
              name: n.name,
              styles: n.styles,
              next: Vc
            }, n = n.next;
        var r = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (r += t.map), r;
      }
      return Cgt(i, e, t);
    }
    case "function": {
      if (i !== void 0) {
        var s = Vc, o = t(i);
        return Vc = s, Jw(i, e, o);
      } else process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var a = [], l = t.replace(v2e, function(d, u, h) {
          var f = "animation" + a.length;
          return a.push("const " + f + " = keyframes`" + h.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + f + "}";
        });
        a.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(a, ["`" + l + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + l + "`"));
      }
      break;
  }
  if (e == null)
    return t;
  var c = e[t];
  return c !== void 0 ? c : t;
}
function Cgt(i, e, t) {
  var n = "";
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      n += Jw(i, e, t[r]) + ";";
  else
    for (var s in t) {
      var o = t[s];
      if (typeof o != "object")
        e != null && e[o] !== void 0 ? n += s + "{" + e[o] + "}" : yae(o) && (n += YM(s) + ":" + qI(s, o) + ";");
      else {
        if (s === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(_2e);
        if (Array.isArray(o) && typeof o[0] == "string" && (e == null || e[o[0]] === void 0))
          for (var a = 0; a < o.length; a++)
            yae(o[a]) && (n += YM(s) + ":" + qI(s, o[a]) + ";");
        else {
          var l = Jw(i, e, o);
          switch (s) {
            case "animation":
            case "animationName": {
              n += YM(s) + ":" + l + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && s === "undefined" && console.error(fgt), n += s + "{" + l + "}";
          }
        }
      }
    }
  return n;
}
var Sae = /label:\s*([^\s;\n{]+)\s*(;|$)/g, b2e;
process.env.NODE_ENV !== "production" && (b2e = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Vc, $w = function(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, s = "";
  Vc = void 0;
  var o = e[0];
  o == null || o.raw === void 0 ? (r = !1, s += Jw(n, t, o)) : (process.env.NODE_ENV !== "production" && o[0] === void 0 && console.error(Cae), s += o[0]);
  for (var a = 1; a < e.length; a++)
    s += Jw(n, t, e[a]), r && (process.env.NODE_ENV !== "production" && o[a] === void 0 && console.error(Cae), s += o[a]);
  var l;
  process.env.NODE_ENV !== "production" && (s = s.replace(b2e, function(h) {
    return l = h, "";
  })), Sae.lastIndex = 0;
  for (var c = "", d; (d = Sae.exec(s)) !== null; )
    c += "-" + // $FlowFixMe we know it's not null
    d[1];
  var u = ugt(s) + c;
  return process.env.NODE_ENV !== "production" ? {
    name: u,
    styles: s,
    map: l,
    next: Vc,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: u,
    styles: s,
    next: Vc
  };
}, ygt = function(e) {
  return e();
}, C2e = G.useInsertionEffect ? G.useInsertionEffect : !1, y2e = C2e || ygt, xae = C2e || G.useLayoutEffect, Bq = {}.hasOwnProperty, Vq = /* @__PURE__ */ G.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ cgt({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Vq.displayName = "EmotionCacheContext");
Vq.Provider;
var Hq = function(e) {
  return /* @__PURE__ */ tS(function(t, n) {
    var r = x0(Vq);
    return e(t, r, n);
  });
}, _k = /* @__PURE__ */ G.createContext({});
process.env.NODE_ENV !== "production" && (_k.displayName = "EmotionThemeContext");
var Dae = function(e) {
  var t = e.split(".");
  return t[t.length - 1];
}, wgt = function(e) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(e);
  if (t || (t = /^([A-Za-z0-9$.]+)@/.exec(e), t)) return Dae(t[1]);
}, Sgt = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), xgt = function(e) {
  return e.replace(/\$/g, "-");
}, Dgt = function(e) {
  if (e)
    for (var t = e.split(`
`), n = 0; n < t.length; n++) {
      var r = wgt(t[n]);
      if (r) {
        if (Sgt.has(r)) break;
        if (/^[A-Z]/.test(r)) return xgt(r);
      }
    }
}, CW = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", yW = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Egt = function(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && // check if there is a css declaration
  t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var n = {};
  for (var r in t)
    Bq.call(t, r) && (n[r] = t[r]);
  if (n[CW] = e, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var s = Dgt(new Error().stack);
    s && (n[yW] = s);
  }
  return n;
}, Lgt = function(e) {
  var t = e.cache, n = e.serialized, r = e.isStringTag;
  return Mq(t, n, r), y2e(function() {
    return Rq(t, n, r);
  }), null;
}, w2e = /* @__PURE__ */ Hq(function(i, e, t) {
  var n = i.css;
  typeof n == "string" && e.registered[n] !== void 0 && (n = e.registered[n]);
  var r = i[CW], s = [n], o = "";
  typeof i.className == "string" ? o = m2e(e.registered, s, i.className) : i.className != null && (o = i.className + " ");
  var a = $w(s, void 0, G.useContext(_k));
  if (process.env.NODE_ENV !== "production" && a.name.indexOf("-") === -1) {
    var l = i[yW];
    l && (a = $w([a, "label:" + l + ";"]));
  }
  o += e.key + "-" + a.name;
  var c = {};
  for (var d in i)
    Bq.call(i, d) && d !== "css" && d !== CW && (process.env.NODE_ENV === "production" || d !== yW) && (c[d] = i[d]);
  return c.ref = t, c.className = o, /* @__PURE__ */ G.createElement(G.Fragment, null, /* @__PURE__ */ G.createElement(Lgt, {
    cache: e,
    serialized: a,
    isStringTag: typeof r == "string"
  }), /* @__PURE__ */ G.createElement(r, c));
});
process.env.NODE_ENV !== "production" && (w2e.displayName = "EmotionCssPropInternal");
var Igt = w2e;
ha();
var Agt = {
  name: "@emotion/react",
  version: "11.11.4",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.3",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.2",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, Jt = function(e, t) {
  var n = arguments;
  if (t == null || !Bq.call(t, "css"))
    return G.createElement.apply(void 0, n);
  var r = n.length, s = new Array(r);
  s[0] = Igt, s[1] = Egt(e, t);
  for (var o = 2; o < r; o++)
    s[o] = n[o];
  return G.createElement.apply(null, s);
}, Eae = !1, kgt = /* @__PURE__ */ Hq(function(i, e) {
  process.env.NODE_ENV !== "production" && !Eae && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (i.className || i.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), Eae = !0);
  var t = i.styles, n = $w([t], void 0, G.useContext(_k)), r = G.useRef();
  return xae(function() {
    var s = e.key + "-global", o = new e.sheet.constructor({
      key: s,
      nonce: e.sheet.nonce,
      container: e.sheet.container,
      speedy: e.sheet.isSpeedy
    }), a = !1, l = document.querySelector('style[data-emotion="' + s + " " + n.name + '"]');
    return e.sheet.tags.length && (o.before = e.sheet.tags[0]), l !== null && (a = !0, l.setAttribute("data-emotion", s), o.hydrate([l])), r.current = [o, a], function() {
      o.flush();
    };
  }, [e]), xae(function() {
    var s = r.current, o = s[0], a = s[1];
    if (a) {
      s[1] = !1;
      return;
    }
    if (n.next !== void 0 && Rq(e, n.next, !0), o.tags.length) {
      var l = o.tags[o.tags.length - 1].nextElementSibling;
      o.before = l, o.flush();
    }
    e.insert("", n, o, !1);
  }, [e, n.name]), null;
});
process.env.NODE_ENV !== "production" && (kgt.displayName = "EmotionGlobal");
function Wq() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++)
    e[t] = arguments[t];
  return $w(e);
}
var Tgt = function() {
  var e = Wq.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, Ngt = function i(e) {
  for (var t = e.length, n = 0, r = ""; n < t; n++) {
    var s = e[n];
    if (s != null) {
      var o = void 0;
      switch (typeof s) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(s))
            o = i(s);
          else {
            process.env.NODE_ENV !== "production" && s.styles !== void 0 && s.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), o = "";
            for (var a in s)
              s[a] && a && (o && (o += " "), o += a);
          }
          break;
        }
        default:
          o = s;
      }
      o && (r && (r += " "), r += o);
    }
  }
  return r;
};
function Pgt(i, e, t) {
  var n = [], r = m2e(i, n, t);
  return n.length < 2 ? t : r + e(n);
}
var Ogt = function(e) {
  var t = e.cache, n = e.serializedArr;
  return y2e(function() {
    for (var r = 0; r < n.length; r++)
      Rq(t, n[r], !1);
  }), null;
}, Mgt = /* @__PURE__ */ Hq(function(i, e) {
  var t = !1, n = [], r = function() {
    if (t && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var c = arguments.length, d = new Array(c), u = 0; u < c; u++)
      d[u] = arguments[u];
    var h = $w(d, e.registered);
    return n.push(h), Mq(e, h, !1), e.key + "-" + h.name;
  }, s = function() {
    if (t && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var c = arguments.length, d = new Array(c), u = 0; u < c; u++)
      d[u] = arguments[u];
    return Pgt(e.registered, r, Ngt(d));
  }, o = {
    css: r,
    cx: s,
    theme: G.useContext(_k)
  }, a = i.children(o);
  return t = !0, /* @__PURE__ */ G.createElement(G.Fragment, null, /* @__PURE__ */ G.createElement(Ogt, {
    cache: e,
    serializedArr: n
  }), a);
});
process.env.NODE_ENV !== "production" && (Mgt.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var Lae = !0, Rgt = typeof jest < "u" || typeof vi < "u";
  if (Lae && !Rgt) {
    var Iae = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : Lae ? window : global
    ), Aae = "__EMOTION_REACT_" + Agt.version.split(".")[0] + "__";
    Iae[Aae] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), Iae[Aae] = !0;
  }
}
function Fgt(i, e) {
  return e || (e = i.slice(0)), Object.freeze(Object.defineProperties(i, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
const Bgt = Math.min, Vgt = Math.max, KI = Math.round, d3 = Math.floor, YI = (i) => ({
  x: i,
  y: i
});
function Hgt(i) {
  const {
    x: e,
    y: t,
    width: n,
    height: r
  } = i;
  return {
    width: n,
    height: r,
    top: t,
    left: e,
    right: e + n,
    bottom: t + r,
    x: e,
    y: t
  };
}
function S2e(i) {
  return D2e(i) ? (i.nodeName || "").toLowerCase() : "#document";
}
function ef(i) {
  var e;
  return (i == null || (e = i.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function x2e(i) {
  var e;
  return (e = (D2e(i) ? i.ownerDocument : i.document) || window.document) == null ? void 0 : e.documentElement;
}
function D2e(i) {
  return i instanceof Node || i instanceof ef(i).Node;
}
function Wgt(i) {
  return i instanceof Element || i instanceof ef(i).Element;
}
function jq(i) {
  return i instanceof HTMLElement || i instanceof ef(i).HTMLElement;
}
function kae(i) {
  return typeof ShadowRoot > "u" ? !1 : i instanceof ShadowRoot || i instanceof ef(i).ShadowRoot;
}
function E2e(i) {
  const {
    overflow: e,
    overflowX: t,
    overflowY: n,
    display: r
  } = zq(i);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + t) && !["inline", "contents"].includes(r);
}
function jgt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function zgt(i) {
  return ["html", "body", "#document"].includes(S2e(i));
}
function zq(i) {
  return ef(i).getComputedStyle(i);
}
function Ugt(i) {
  if (S2e(i) === "html")
    return i;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    i.assignedSlot || // DOM Element detected.
    i.parentNode || // ShadowRoot detected.
    kae(i) && i.host || // Fallback.
    x2e(i)
  );
  return kae(e) ? e.host : e;
}
function L2e(i) {
  const e = Ugt(i);
  return zgt(e) ? i.ownerDocument ? i.ownerDocument.body : i.body : jq(e) && E2e(e) ? e : L2e(e);
}
function XI(i, e, t) {
  var n;
  e === void 0 && (e = []), t === void 0 && (t = !0);
  const r = L2e(i), s = r === ((n = i.ownerDocument) == null ? void 0 : n.body), o = ef(r);
  return s ? e.concat(o, o.visualViewport || [], E2e(r) ? r : [], o.frameElement && t ? XI(o.frameElement) : []) : e.concat(r, XI(r, [], t));
}
function Ggt(i) {
  const e = zq(i);
  let t = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const r = jq(i), s = r ? i.offsetWidth : t, o = r ? i.offsetHeight : n, a = KI(t) !== s || KI(n) !== o;
  return a && (t = s, n = o), {
    width: t,
    height: n,
    $: a
  };
}
function Uq(i) {
  return Wgt(i) ? i : i.contextElement;
}
function Tae(i) {
  const e = Uq(i);
  if (!jq(e))
    return YI(1);
  const t = e.getBoundingClientRect(), {
    width: n,
    height: r,
    $: s
  } = Ggt(e);
  let o = (s ? KI(t.width) : t.width) / n, a = (s ? KI(t.height) : t.height) / r;
  return (!o || !Number.isFinite(o)) && (o = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: o,
    y: a
  };
}
const qgt = /* @__PURE__ */ YI(0);
function Kgt(i) {
  const e = ef(i);
  return !jgt() || !e.visualViewport ? qgt : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Ygt(i, e, t) {
  return !1;
}
function Nae(i, e, t, n) {
  e === void 0 && (e = !1);
  const r = i.getBoundingClientRect(), s = Uq(i);
  let o = YI(1);
  e && (o = Tae(i));
  const a = Ygt() ? Kgt(s) : YI(0);
  let l = (r.left + a.x) / o.x, c = (r.top + a.y) / o.y, d = r.width / o.x, u = r.height / o.y;
  if (s) {
    const h = ef(s), f = n;
    let g = h, p = g.frameElement;
    for (; p && n && f !== g; ) {
      const m = Tae(p), _ = p.getBoundingClientRect(), b = zq(p), w = _.left + (p.clientLeft + parseFloat(b.paddingLeft)) * m.x, y = _.top + (p.clientTop + parseFloat(b.paddingTop)) * m.y;
      l *= m.x, c *= m.y, d *= m.x, u *= m.y, l += w, c += y, g = ef(p), p = g.frameElement;
    }
  }
  return Hgt({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function Xgt(i, e) {
  let t = null, n;
  const r = x2e(i);
  function s() {
    var a;
    clearTimeout(n), (a = t) == null || a.disconnect(), t = null;
  }
  function o(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), s();
    const {
      left: c,
      top: d,
      width: u,
      height: h
    } = i.getBoundingClientRect();
    if (a || e(), !u || !h)
      return;
    const f = d3(d), g = d3(r.clientWidth - (c + u)), p = d3(r.clientHeight - (d + h)), m = d3(c), b = {
      rootMargin: -f + "px " + -g + "px " + -p + "px " + -m + "px",
      threshold: Vgt(0, Bgt(1, l)) || 1
    };
    let w = !0;
    function y(S) {
      const x = S[0].intersectionRatio;
      if (x !== l) {
        if (!w)
          return o();
        x ? o(!1, x) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      w = !1;
    }
    try {
      t = new IntersectionObserver(y, {
        ...b,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(y, b);
    }
    t.observe(i);
  }
  return o(!0), s;
}
function Zgt(i, e, t, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, c = Uq(i), d = r || s ? [...c ? XI(c) : [], ...XI(e)] : [];
  d.forEach((_) => {
    r && _.addEventListener("scroll", t, {
      passive: !0
    }), s && _.addEventListener("resize", t);
  });
  const u = c && a ? Xgt(c, t) : null;
  let h = -1, f = null;
  o && (f = new ResizeObserver((_) => {
    let [b] = _;
    b && b.target === c && f && (f.unobserve(e), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = f) == null || w.observe(e);
    })), t();
  }), c && !l && f.observe(c), f.observe(e));
  let g, p = l ? Nae(i) : null;
  l && m();
  function m() {
    const _ = Nae(i);
    p && (_.x !== p.x || _.y !== p.y || _.width !== p.width || _.height !== p.height) && t(), p = _, g = requestAnimationFrame(m);
  }
  return t(), () => {
    var _;
    d.forEach((b) => {
      r && b.removeEventListener("scroll", t), s && b.removeEventListener("resize", t);
    }), u?.(), (_ = f) == null || _.disconnect(), f = null, l && cancelAnimationFrame(g);
  };
}
var wW = aA, Qgt = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], ZI = function() {
};
function Jgt(i, e) {
  return e ? e[0] === "-" ? i + e : i + "__" + e : i;
}
function $gt(i, e) {
  for (var t = arguments.length, n = new Array(t > 2 ? t - 2 : 0), r = 2; r < t; r++)
    n[r - 2] = arguments[r];
  var s = [].concat(n);
  if (e && i)
    for (var o in e)
      e.hasOwnProperty(o) && e[o] && s.push("".concat(Jgt(i, o)));
  return s.filter(function(a) {
    return a;
  }).map(function(a) {
    return String(a).trim();
  }).join(" ");
}
var QI = function(e) {
  return lpt(e) ? e.filter(Boolean) : S0(e) === "object" && e !== null ? [e] : [];
}, I2e = function(e) {
  e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme;
  var t = wd(e, Qgt);
  return Xt({}, t);
}, qr = function(e, t, n) {
  var r = e.cx, s = e.getStyles, o = e.getClassNames, a = e.className;
  return {
    css: s(t, e),
    className: r(n ?? {}, o(t, e), a)
  };
};
function bk(i) {
  return [document.documentElement, document.body, window].indexOf(i) > -1;
}
function ept(i) {
  return bk(i) ? window.innerHeight : i.clientHeight;
}
function A2e(i) {
  return bk(i) ? window.pageYOffset : i.scrollTop;
}
function JI(i, e) {
  if (bk(i)) {
    window.scrollTo(0, e);
    return;
  }
  i.scrollTop = e;
}
function tpt(i) {
  var e = getComputedStyle(i), t = e.position === "absolute", n = /(auto|scroll)/;
  if (e.position === "fixed") return document.documentElement;
  for (var r = i; r = r.parentElement; )
    if (e = getComputedStyle(r), !(t && e.position === "static") && n.test(e.overflow + e.overflowY + e.overflowX))
      return r;
  return document.documentElement;
}
function npt(i, e, t, n) {
  return t * ((i = i / n - 1) * i * i + 1) + e;
}
function u3(i, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ZI, r = A2e(i), s = e - r, o = 10, a = 0;
  function l() {
    a += o;
    var c = npt(a, r, s, t);
    JI(i, c), a < t ? window.requestAnimationFrame(l) : n(i);
  }
  l();
}
function Pae(i, e) {
  var t = i.getBoundingClientRect(), n = e.getBoundingClientRect(), r = e.offsetHeight / 3;
  n.bottom + r > t.bottom ? JI(i, Math.min(e.offsetTop + e.clientHeight - i.offsetHeight + r, i.scrollHeight)) : n.top - r < t.top && JI(i, Math.max(e.offsetTop - r, 0));
}
function ipt(i) {
  var e = i.getBoundingClientRect();
  return {
    bottom: e.bottom,
    height: e.height,
    left: e.left,
    right: e.right,
    top: e.top,
    width: e.width
  };
}
function Oae() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function rpt() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var k2e = !1, spt = {
  get passive() {
    return k2e = !0;
  }
}, h3 = typeof window < "u" ? window : {};
h3.addEventListener && h3.removeEventListener && (h3.addEventListener("p", ZI, spt), h3.removeEventListener("p", ZI, !1));
var opt = k2e;
function apt(i) {
  return i != null;
}
function lpt(i) {
  return Array.isArray(i);
}
function dC(i, e, t) {
  return i ? e : t;
}
var cpt = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var s = Object.entries(e).filter(function(o) {
    var a = hu(o, 1), l = a[0];
    return !n.includes(l);
  });
  return s.reduce(function(o, a) {
    var l = hu(a, 2), c = l[0], d = l[1];
    return o[c] = d, o;
  }, {});
}, dpt = ["children", "innerProps"], upt = ["children", "innerProps"];
function hpt(i) {
  var e = i.maxHeight, t = i.menuEl, n = i.minHeight, r = i.placement, s = i.shouldScroll, o = i.isFixedPosition, a = i.controlHeight, l = tpt(t), c = {
    placement: "bottom",
    maxHeight: e
  };
  if (!t || !t.offsetParent) return c;
  var d = l.getBoundingClientRect(), u = d.height, h = t.getBoundingClientRect(), f = h.bottom, g = h.height, p = h.top, m = t.offsetParent.getBoundingClientRect(), _ = m.top, b = o ? window.innerHeight : ept(l), w = A2e(l), y = parseInt(getComputedStyle(t).marginBottom, 10), S = parseInt(getComputedStyle(t).marginTop, 10), x = _ - S, D = b - p, E = x + w, L = u - w - p, k = f - b + w + y, N = w + p - S, I = 160;
  switch (r) {
    case "auto":
    case "bottom":
      if (D >= g)
        return {
          placement: "bottom",
          maxHeight: e
        };
      if (L >= g && !o)
        return s && u3(l, k, I), {
          placement: "bottom",
          maxHeight: e
        };
      if (!o && L >= n || o && D >= n) {
        s && u3(l, k, I);
        var A = o ? D - y : L - y;
        return {
          placement: "bottom",
          maxHeight: A
        };
      }
      if (r === "auto" || o) {
        var P = e, O = o ? x : E;
        return O >= n && (P = Math.min(O - y - a, e)), {
          placement: "top",
          maxHeight: P
        };
      }
      if (r === "bottom")
        return s && JI(l, k), {
          placement: "bottom",
          maxHeight: e
        };
      break;
    case "top":
      if (x >= g)
        return {
          placement: "top",
          maxHeight: e
        };
      if (E >= g && !o)
        return s && u3(l, N, I), {
          placement: "top",
          maxHeight: e
        };
      if (!o && E >= n || o && x >= n) {
        var K = e;
        return (!o && E >= n || o && x >= n) && (K = o ? x - S : E - S), s && u3(l, N, I), {
          placement: "top",
          maxHeight: K
        };
      }
      return {
        placement: "bottom",
        maxHeight: e
      };
    default:
      throw new Error('Invalid placement provided "'.concat(r, '".'));
  }
  return c;
}
function fpt(i) {
  var e = {
    bottom: "top",
    top: "bottom"
  };
  return i ? e[i] : "bottom";
}
var T2e = function(e) {
  return e === "auto" ? "bottom" : e;
}, gpt = function(e, t) {
  var n, r = e.placement, s = e.theme, o = s.borderRadius, a = s.spacing, l = s.colors;
  return Xt((n = {
    label: "menu"
  }, dg(n, fpt(r), "100%"), dg(n, "position", "absolute"), dg(n, "width", "100%"), dg(n, "zIndex", 1), n), t ? {} : {
    backgroundColor: l.neutral0,
    borderRadius: o,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: a.menuGutter,
    marginTop: a.menuGutter
  });
}, N2e = /* @__PURE__ */ nf(null), ppt = function(e) {
  var t = e.children, n = e.minMenuHeight, r = e.maxMenuHeight, s = e.menuPlacement, o = e.menuPosition, a = e.menuShouldScrollIntoView, l = e.theme, c = x0(N2e) || {}, d = c.setPortalPlacement, u = Nt(null), h = Oe(r), f = hu(h, 2), g = f[0], p = f[1], m = Oe(null), _ = hu(m, 2), b = _[0], w = _[1], y = l.spacing.controlHeight;
  return wW(function() {
    var S = u.current;
    if (S) {
      var x = o === "fixed", D = a && !x, E = hpt({
        maxHeight: r,
        menuEl: S,
        minHeight: n,
        placement: s,
        shouldScroll: D,
        isFixedPosition: x,
        controlHeight: y
      });
      p(E.maxHeight), w(E.placement), d?.(E.placement);
    }
  }, [r, s, o, a, n, d, y]), t({
    ref: u,
    placerProps: Xt(Xt({}, e), {}, {
      placement: b || T2e(s),
      maxHeight: g
    })
  });
}, mpt = function(e) {
  var t = e.children, n = e.innerRef, r = e.innerProps;
  return Jt("div", cn({}, qr(e, "menu", {
    menu: !0
  }), {
    ref: n
  }, r), t);
}, vpt = mpt, _pt = function(e, t) {
  var n = e.maxHeight, r = e.theme.spacing.baseUnit;
  return Xt({
    maxHeight: n,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, t ? {} : {
    paddingBottom: r,
    paddingTop: r
  });
}, bpt = function(e) {
  var t = e.children, n = e.innerProps, r = e.innerRef, s = e.isMulti;
  return Jt("div", cn({}, qr(e, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": s
  }), {
    ref: r
  }, n), t);
}, P2e = function(e, t) {
  var n = e.theme, r = n.spacing.baseUnit, s = n.colors;
  return Xt({
    textAlign: "center"
  }, t ? {} : {
    color: s.neutral40,
    padding: "".concat(r * 2, "px ").concat(r * 3, "px")
  });
}, Cpt = P2e, ypt = P2e, wpt = function(e) {
  var t = e.children, n = t === void 0 ? "No options" : t, r = e.innerProps, s = wd(e, dpt);
  return Jt("div", cn({}, qr(Xt(Xt({}, s), {}, {
    children: n,
    innerProps: r
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), r), n);
}, Spt = function(e) {
  var t = e.children, n = t === void 0 ? "Loading..." : t, r = e.innerProps, s = wd(e, upt);
  return Jt("div", cn({}, qr(Xt(Xt({}, s), {}, {
    children: n,
    innerProps: r
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), r), n);
}, xpt = function(e) {
  var t = e.rect, n = e.offset, r = e.position;
  return {
    left: t.left,
    position: r,
    top: n,
    width: t.width,
    zIndex: 1
  };
}, Dpt = function(e) {
  var t = e.appendTo, n = e.children, r = e.controlElement, s = e.innerProps, o = e.menuPlacement, a = e.menuPosition, l = Nt(null), c = Nt(null), d = Oe(T2e(o)), u = hu(d, 2), h = u[0], f = u[1], g = Mn(function() {
    return {
      setPortalPlacement: f
    };
  }, []), p = Oe(null), m = hu(p, 2), _ = m[0], b = m[1], w = Wi(function() {
    if (r) {
      var D = ipt(r), E = a === "fixed" ? 0 : window.pageYOffset, L = D[h] + E;
      (L !== _?.offset || D.left !== _?.rect.left || D.width !== _?.rect.width) && b({
        offset: L,
        rect: D
      });
    }
  }, [r, a, h, _?.offset, _?.rect.left, _?.rect.width]);
  wW(function() {
    w();
  }, [w]);
  var y = Wi(function() {
    typeof c.current == "function" && (c.current(), c.current = null), r && l.current && (c.current = Zgt(r, l.current, w, {
      elementResize: "ResizeObserver" in window
    }));
  }, [r, w]);
  wW(function() {
    y();
  }, [y]);
  var S = Wi(function(D) {
    l.current = D, y();
  }, [y]);
  if (!t && a !== "fixed" || !_) return null;
  var x = Jt("div", cn({
    ref: S
  }, qr(Xt(Xt({}, e), {}, {
    offset: _.offset,
    position: a,
    rect: _.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), s), n);
  return Jt(N2e.Provider, {
    value: g
  }, t ? /* @__PURE__ */ kW(x, t) : x);
}, Ept = function(e) {
  var t = e.isDisabled, n = e.isRtl;
  return {
    label: "container",
    direction: n ? "rtl" : void 0,
    pointerEvents: t ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, Lpt = function(e) {
  var t = e.children, n = e.innerProps, r = e.isDisabled, s = e.isRtl;
  return Jt("div", cn({}, qr(e, "container", {
    "--is-disabled": r,
    "--is-rtl": s
  }), n), t);
}, Ipt = function(e, t) {
  var n = e.theme.spacing, r = e.isMulti, s = e.hasValue, o = e.selectProps.controlShouldRenderValue;
  return Xt({
    alignItems: "center",
    display: r && s && o ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, t ? {} : {
    padding: "".concat(n.baseUnit / 2, "px ").concat(n.baseUnit * 2, "px")
  });
}, Apt = function(e) {
  var t = e.children, n = e.innerProps, r = e.isMulti, s = e.hasValue;
  return Jt("div", cn({}, qr(e, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": r,
    "value-container--has-value": s
  }), n), t);
}, kpt = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, Tpt = function(e) {
  var t = e.children, n = e.innerProps;
  return Jt("div", cn({}, qr(e, "indicatorsContainer", {
    indicators: !0
  }), n), t);
}, Mae, Npt = ["size"], Ppt = ["innerProps", "isRtl", "size"];
function Opt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Mpt = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Opt
}, O2e = function(e) {
  var t = e.size, n = wd(e, Npt);
  return Jt("svg", cn({
    height: t,
    width: t,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: Mpt
  }, n));
}, Gq = function(e) {
  return Jt(O2e, cn({
    size: 20
  }, e), Jt("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, M2e = function(e) {
  return Jt(O2e, cn({
    size: 20
  }, e), Jt("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, R2e = function(e, t) {
  var n = e.isFocused, r = e.theme, s = r.spacing.baseUnit, o = r.colors;
  return Xt({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, t ? {} : {
    color: n ? o.neutral60 : o.neutral20,
    padding: s * 2,
    ":hover": {
      color: n ? o.neutral80 : o.neutral40
    }
  });
}, Rpt = R2e, Fpt = function(e) {
  var t = e.children, n = e.innerProps;
  return Jt("div", cn({}, qr(e, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), n), t || Jt(M2e, null));
}, Bpt = R2e, Vpt = function(e) {
  var t = e.children, n = e.innerProps;
  return Jt("div", cn({}, qr(e, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), n), t || Jt(Gq, null));
}, Hpt = function(e, t) {
  var n = e.isDisabled, r = e.theme, s = r.spacing.baseUnit, o = r.colors;
  return Xt({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, t ? {} : {
    backgroundColor: n ? o.neutral10 : o.neutral20,
    marginBottom: s * 2,
    marginTop: s * 2
  });
}, Wpt = function(e) {
  var t = e.innerProps;
  return Jt("span", cn({}, t, qr(e, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, jpt = Tgt(Mae || (Mae = Fgt([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), zpt = function(e, t) {
  var n = e.isFocused, r = e.size, s = e.theme, o = s.colors, a = s.spacing.baseUnit;
  return Xt({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: r,
    lineHeight: 1,
    marginRight: r,
    textAlign: "center",
    verticalAlign: "middle"
  }, t ? {} : {
    color: n ? o.neutral60 : o.neutral20,
    padding: a * 2
  });
}, XM = function(e) {
  var t = e.delay, n = e.offset;
  return Jt("span", {
    css: /* @__PURE__ */ Wq({
      animation: "".concat(jpt, " 1s ease-in-out ").concat(t, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: n ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, Upt = function(e) {
  var t = e.innerProps, n = e.isRtl, r = e.size, s = r === void 0 ? 4 : r, o = wd(e, Ppt);
  return Jt("div", cn({}, qr(Xt(Xt({}, o), {}, {
    innerProps: t,
    isRtl: n,
    size: s
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), t), Jt(XM, {
    delay: 0,
    offset: n
  }), Jt(XM, {
    delay: 160,
    offset: !0
  }), Jt(XM, {
    delay: 320,
    offset: !n
  }));
}, Gpt = function(e, t) {
  var n = e.isDisabled, r = e.isFocused, s = e.theme, o = s.colors, a = s.borderRadius, l = s.spacing;
  return Xt({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: l.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, t ? {} : {
    backgroundColor: n ? o.neutral5 : o.neutral0,
    borderColor: n ? o.neutral10 : r ? o.primary : o.neutral20,
    borderRadius: a,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: r ? "0 0 0 1px ".concat(o.primary) : void 0,
    "&:hover": {
      borderColor: r ? o.primary : o.neutral30
    }
  });
}, qpt = function(e) {
  var t = e.children, n = e.isDisabled, r = e.isFocused, s = e.innerRef, o = e.innerProps, a = e.menuIsOpen;
  return Jt("div", cn({
    ref: s
  }, qr(e, "control", {
    control: !0,
    "control--is-disabled": n,
    "control--is-focused": r,
    "control--menu-is-open": a
  }), o, {
    "aria-disabled": n || void 0
  }), t);
}, Kpt = qpt, Ypt = ["data"], Xpt = function(e, t) {
  var n = e.theme.spacing;
  return t ? {} : {
    paddingBottom: n.baseUnit * 2,
    paddingTop: n.baseUnit * 2
  };
}, Zpt = function(e) {
  var t = e.children, n = e.cx, r = e.getStyles, s = e.getClassNames, o = e.Heading, a = e.headingProps, l = e.innerProps, c = e.label, d = e.theme, u = e.selectProps;
  return Jt("div", cn({}, qr(e, "group", {
    group: !0
  }), l), Jt(o, cn({}, a, {
    selectProps: u,
    theme: d,
    getStyles: r,
    getClassNames: s,
    cx: n
  }), c), Jt("div", null, t));
}, Qpt = function(e, t) {
  var n = e.theme, r = n.colors, s = n.spacing;
  return Xt({
    label: "group",
    cursor: "default",
    display: "block"
  }, t ? {} : {
    color: r.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: s.baseUnit * 3,
    paddingRight: s.baseUnit * 3,
    textTransform: "uppercase"
  });
}, Jpt = function(e) {
  var t = I2e(e);
  t.data;
  var n = wd(t, Ypt);
  return Jt("div", cn({}, qr(e, "groupHeading", {
    "group-heading": !0
  }), n));
}, $pt = Zpt, emt = ["innerRef", "isDisabled", "isHidden", "inputClassName"], tmt = function(e, t) {
  var n = e.isDisabled, r = e.value, s = e.theme, o = s.spacing, a = s.colors;
  return Xt(Xt({
    visibility: n ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: r ? "translateZ(0)" : ""
  }, nmt), t ? {} : {
    margin: o.baseUnit / 2,
    paddingBottom: o.baseUnit / 2,
    paddingTop: o.baseUnit / 2,
    color: a.neutral80
  });
}, F2e = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, nmt = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": Xt({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, F2e)
}, imt = function(e) {
  return Xt({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: e ? 0 : 1,
    width: "100%"
  }, F2e);
}, rmt = function(e) {
  var t = e.cx, n = e.value, r = I2e(e), s = r.innerRef, o = r.isDisabled, a = r.isHidden, l = r.inputClassName, c = wd(r, emt);
  return Jt("div", cn({}, qr(e, "input", {
    "input-container": !0
  }), {
    "data-value": n || ""
  }), Jt("input", cn({
    className: t({
      input: !0
    }, l),
    ref: s,
    style: imt(a),
    disabled: o
  }, c)));
}, smt = rmt, omt = function(e, t) {
  var n = e.theme, r = n.spacing, s = n.borderRadius, o = n.colors;
  return Xt({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, t ? {} : {
    backgroundColor: o.neutral10,
    borderRadius: s / 2,
    margin: r.baseUnit / 2
  });
}, amt = function(e, t) {
  var n = e.theme, r = n.borderRadius, s = n.colors, o = e.cropWithEllipsis;
  return Xt({
    overflow: "hidden",
    textOverflow: o || o === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, t ? {} : {
    borderRadius: r / 2,
    color: s.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, lmt = function(e, t) {
  var n = e.theme, r = n.spacing, s = n.borderRadius, o = n.colors, a = e.isFocused;
  return Xt({
    alignItems: "center",
    display: "flex"
  }, t ? {} : {
    borderRadius: s / 2,
    backgroundColor: a ? o.dangerLight : void 0,
    paddingLeft: r.baseUnit,
    paddingRight: r.baseUnit,
    ":hover": {
      backgroundColor: o.dangerLight,
      color: o.danger
    }
  });
}, B2e = function(e) {
  var t = e.children, n = e.innerProps;
  return Jt("div", n, t);
}, cmt = B2e, dmt = B2e;
function umt(i) {
  var e = i.children, t = i.innerProps;
  return Jt("div", cn({
    role: "button"
  }, t), e || Jt(Gq, {
    size: 14
  }));
}
var hmt = function(e) {
  var t = e.children, n = e.components, r = e.data, s = e.innerProps, o = e.isDisabled, a = e.removeProps, l = e.selectProps, c = n.Container, d = n.Label, u = n.Remove;
  return Jt(c, {
    data: r,
    innerProps: Xt(Xt({}, qr(e, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": o
    })), s),
    selectProps: l
  }, Jt(d, {
    data: r,
    innerProps: Xt({}, qr(e, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: l
  }, t), Jt(u, {
    data: r,
    innerProps: Xt(Xt({}, qr(e, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(t || "option")
    }, a),
    selectProps: l
  }));
}, fmt = hmt, gmt = function(e, t) {
  var n = e.isDisabled, r = e.isFocused, s = e.isSelected, o = e.theme, a = o.spacing, l = o.colors;
  return Xt({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, t ? {} : {
    backgroundColor: s ? l.primary : r ? l.primary25 : "transparent",
    color: n ? l.neutral20 : s ? l.neutral0 : "inherit",
    padding: "".concat(a.baseUnit * 2, "px ").concat(a.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: n ? void 0 : s ? l.primary : l.primary50
    }
  });
}, pmt = function(e) {
  var t = e.children, n = e.isDisabled, r = e.isFocused, s = e.isSelected, o = e.innerRef, a = e.innerProps;
  return Jt("div", cn({}, qr(e, "option", {
    option: !0,
    "option--is-disabled": n,
    "option--is-focused": r,
    "option--is-selected": s
  }), {
    ref: o,
    "aria-disabled": n
  }, a), t);
}, mmt = pmt, vmt = function(e, t) {
  var n = e.theme, r = n.spacing, s = n.colors;
  return Xt({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, t ? {} : {
    color: s.neutral50,
    marginLeft: r.baseUnit / 2,
    marginRight: r.baseUnit / 2
  });
}, _mt = function(e) {
  var t = e.children, n = e.innerProps;
  return Jt("div", cn({}, qr(e, "placeholder", {
    placeholder: !0
  }), n), t);
}, bmt = _mt, Cmt = function(e, t) {
  var n = e.isDisabled, r = e.theme, s = r.spacing, o = r.colors;
  return Xt({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, t ? {} : {
    color: n ? o.neutral40 : o.neutral80,
    marginLeft: s.baseUnit / 2,
    marginRight: s.baseUnit / 2
  });
}, ymt = function(e) {
  var t = e.children, n = e.isDisabled, r = e.innerProps;
  return Jt("div", cn({}, qr(e, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": n
  }), r), t);
}, wmt = ymt, Smt = {
  ClearIndicator: Vpt,
  Control: Kpt,
  DropdownIndicator: Fpt,
  DownChevron: M2e,
  CrossIcon: Gq,
  Group: $pt,
  GroupHeading: Jpt,
  IndicatorsContainer: Tpt,
  IndicatorSeparator: Wpt,
  Input: smt,
  LoadingIndicator: Upt,
  Menu: vpt,
  MenuList: bpt,
  MenuPortal: Dpt,
  LoadingMessage: Spt,
  NoOptionsMessage: wpt,
  MultiValue: fmt,
  MultiValueContainer: cmt,
  MultiValueLabel: dmt,
  MultiValueRemove: umt,
  Option: mmt,
  Placeholder: bmt,
  SelectContainer: Lpt,
  SingleValue: wmt,
  ValueContainer: Apt
}, xmt = function(e) {
  return Xt(Xt({}, Smt), e.components);
}, Rae = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function Dmt(i, e) {
  return !!(i === e || Rae(i) && Rae(e));
}
function Emt(i, e) {
  if (i.length !== e.length)
    return !1;
  for (var t = 0; t < i.length; t++)
    if (!Dmt(i[t], e[t]))
      return !1;
  return !0;
}
function Lmt(i, e) {
  e === void 0 && (e = Emt);
  var t = null;
  function n() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    if (t && t.lastThis === this && e(r, t.lastArgs))
      return t.lastResult;
    var o = i.apply(this, r);
    return t = {
      lastResult: o,
      lastArgs: r,
      lastThis: this
    }, o;
  }
  return n.clear = function() {
    t = null;
  }, n;
}
function Imt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Amt = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: Imt
}, kmt = function(e) {
  return Jt("span", cn({
    css: Amt
  }, e));
}, Fae = kmt, Tmt = {
  guidance: function(e) {
    var t = e.isSearchable, n = e.isMulti, r = e.tabSelectsValue, s = e.context, o = e.isInitialFocus;
    switch (s) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(r ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return o ? "".concat(e["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(e) {
    var t = e.action, n = e.label, r = n === void 0 ? "" : n, s = e.labels, o = e.isDisabled;
    switch (t) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(r, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(s.length > 1 ? "s" : "", " ").concat(s.join(","), ", selected.");
      case "select-option":
        return o ? "option ".concat(r, " is disabled. Select another option.") : "option ".concat(r, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(e) {
    var t = e.context, n = e.focused, r = e.options, s = e.label, o = s === void 0 ? "" : s, a = e.selectValue, l = e.isDisabled, c = e.isSelected, d = e.isAppleDevice, u = function(p, m) {
      return p && p.length ? "".concat(p.indexOf(m) + 1, " of ").concat(p.length) : "";
    };
    if (t === "value" && a)
      return "value ".concat(o, " focused, ").concat(u(a, n), ".");
    if (t === "menu" && d) {
      var h = l ? " disabled" : "", f = "".concat(c ? " selected" : "").concat(h);
      return "".concat(o).concat(f, ", ").concat(u(r, n), ".");
    }
    return "";
  },
  onFilter: function(e) {
    var t = e.inputValue, n = e.resultsMessage;
    return "".concat(n).concat(t ? " for search term " + t : "", ".");
  }
}, Nmt = function(e) {
  var t = e.ariaSelection, n = e.focusedOption, r = e.focusedValue, s = e.focusableOptions, o = e.isFocused, a = e.selectValue, l = e.selectProps, c = e.id, d = e.isAppleDevice, u = l.ariaLiveMessages, h = l.getOptionLabel, f = l.inputValue, g = l.isMulti, p = l.isOptionDisabled, m = l.isSearchable, _ = l.menuIsOpen, b = l.options, w = l.screenReaderStatus, y = l.tabSelectsValue, S = l.isLoading, x = l["aria-label"], D = l["aria-live"], E = Mn(function() {
    return Xt(Xt({}, Tmt), u || {});
  }, [u]), L = Mn(function() {
    var O = "";
    if (t && E.onChange) {
      var K = t.option, W = t.options, F = t.removedValue, q = t.removedValues, R = t.value, T = function(oe) {
        return Array.isArray(oe) ? null : oe;
      }, z = F || K || T(R), X = z ? h(z) : "", ae = W || q || void 0, ue = ae ? ae.map(h) : [], se = Xt({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: z && p(z, a),
        label: X,
        labels: ue
      }, t);
      O = E.onChange(se);
    }
    return O;
  }, [t, E, p, a, h]), k = Mn(function() {
    var O = "", K = n || r, W = !!(n && a && a.includes(n));
    if (K && E.onFocus) {
      var F = {
        focused: K,
        label: h(K),
        isDisabled: p(K, a),
        isSelected: W,
        options: s,
        context: K === n ? "menu" : "value",
        selectValue: a,
        isAppleDevice: d
      };
      O = E.onFocus(F);
    }
    return O;
  }, [n, r, h, p, E, s, a, d]), N = Mn(function() {
    var O = "";
    if (_ && b.length && !S && E.onFilter) {
      var K = w({
        count: s.length
      });
      O = E.onFilter({
        inputValue: f,
        resultsMessage: K
      });
    }
    return O;
  }, [s, f, _, E, b, w, S]), I = t?.action === "initial-input-focus", A = Mn(function() {
    var O = "";
    if (E.guidance) {
      var K = r ? "value" : _ ? "menu" : "input";
      O = E.guidance({
        "aria-label": x,
        context: K,
        isDisabled: n && p(n, a),
        isMulti: g,
        isSearchable: m,
        tabSelectsValue: y,
        isInitialFocus: I
      });
    }
    return O;
  }, [x, n, r, g, p, m, _, E, a, y, I]), P = Jt(qh, null, Jt("span", {
    id: "aria-selection"
  }, L), Jt("span", {
    id: "aria-focused"
  }, k), Jt("span", {
    id: "aria-results"
  }, N), Jt("span", {
    id: "aria-guidance"
  }, A));
  return Jt(qh, null, Jt(Fae, {
    id: c
  }, I && P), Jt(Fae, {
    "aria-live": D,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, o && !I && P));
}, Pmt = Nmt, SW = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], Omt = new RegExp("[" + SW.map(function(i) {
  return i.letters;
}).join("") + "]", "g"), V2e = {};
for (var ZM = 0; ZM < SW.length; ZM++)
  for (var QM = SW[ZM], JM = 0; JM < QM.letters.length; JM++)
    V2e[QM.letters[JM]] = QM.base;
var H2e = function(e) {
  return e.replace(Omt, function(t) {
    return V2e[t];
  });
}, Mmt = Lmt(H2e), Bae = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, Rmt = function(e) {
  return "".concat(e.label, " ").concat(e.value);
}, Fmt = function(e) {
  return function(t, n) {
    if (t.data.__isNew__) return !0;
    var r = Xt({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: Rmt,
      trim: !0,
      matchFrom: "any"
    }, e), s = r.ignoreCase, o = r.ignoreAccents, a = r.stringify, l = r.trim, c = r.matchFrom, d = l ? Bae(n) : n, u = l ? Bae(a(t)) : a(t);
    return s && (d = d.toLowerCase(), u = u.toLowerCase()), o && (d = Mmt(d), u = H2e(u)), c === "start" ? u.substr(0, d.length) === d : u.indexOf(d) > -1;
  };
}, Bmt = ["innerRef"];
function Vmt(i) {
  var e = i.innerRef, t = wd(i, Bmt), n = cpt(t, "onExited", "in", "enter", "exit", "appear");
  return Jt("input", cn({
    ref: e
  }, n, {
    css: /* @__PURE__ */ Wq({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var Hmt = function(e) {
  e.cancelable && e.preventDefault(), e.stopPropagation();
};
function Wmt(i) {
  var e = i.isEnabled, t = i.onBottomArrive, n = i.onBottomLeave, r = i.onTopArrive, s = i.onTopLeave, o = Nt(!1), a = Nt(!1), l = Nt(0), c = Nt(null), d = Wi(function(m, _) {
    if (c.current !== null) {
      var b = c.current, w = b.scrollTop, y = b.scrollHeight, S = b.clientHeight, x = c.current, D = _ > 0, E = y - S - w, L = !1;
      E > _ && o.current && (n && n(m), o.current = !1), D && a.current && (s && s(m), a.current = !1), D && _ > E ? (t && !o.current && t(m), x.scrollTop = y, L = !0, o.current = !0) : !D && -_ > w && (r && !a.current && r(m), x.scrollTop = 0, L = !0, a.current = !0), L && Hmt(m);
    }
  }, [t, n, r, s]), u = Wi(function(m) {
    d(m, m.deltaY);
  }, [d]), h = Wi(function(m) {
    l.current = m.changedTouches[0].clientY;
  }, []), f = Wi(function(m) {
    var _ = l.current - m.changedTouches[0].clientY;
    d(m, _);
  }, [d]), g = Wi(function(m) {
    if (m) {
      var _ = opt ? {
        passive: !1
      } : !1;
      m.addEventListener("wheel", u, _), m.addEventListener("touchstart", h, _), m.addEventListener("touchmove", f, _);
    }
  }, [f, h, u]), p = Wi(function(m) {
    m && (m.removeEventListener("wheel", u, !1), m.removeEventListener("touchstart", h, !1), m.removeEventListener("touchmove", f, !1));
  }, [f, h, u]);
  return $e(function() {
    if (e) {
      var m = c.current;
      return g(m), function() {
        p(m);
      };
    }
  }, [e, g, p]), function(m) {
    c.current = m;
  };
}
var Vae = ["boxSizing", "height", "overflow", "paddingRight", "position"], Hae = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function Wae(i) {
  i.preventDefault();
}
function jae(i) {
  i.stopPropagation();
}
function zae() {
  var i = this.scrollTop, e = this.scrollHeight, t = i + this.offsetHeight;
  i === 0 ? this.scrollTop = 1 : t === e && (this.scrollTop = i - 1);
}
function Uae() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var Gae = !!(typeof window < "u" && window.document && window.document.createElement), O2 = 0, k1 = {
  capture: !1,
  passive: !1
};
function jmt(i) {
  var e = i.isEnabled, t = i.accountForScrollbars, n = t === void 0 ? !0 : t, r = Nt({}), s = Nt(null), o = Wi(function(l) {
    if (Gae) {
      var c = document.body, d = c && c.style;
      if (n && Vae.forEach(function(g) {
        var p = d && d[g];
        r.current[g] = p;
      }), n && O2 < 1) {
        var u = parseInt(r.current.paddingRight, 10) || 0, h = document.body ? document.body.clientWidth : 0, f = window.innerWidth - h + u || 0;
        Object.keys(Hae).forEach(function(g) {
          var p = Hae[g];
          d && (d[g] = p);
        }), d && (d.paddingRight = "".concat(f, "px"));
      }
      c && Uae() && (c.addEventListener("touchmove", Wae, k1), l && (l.addEventListener("touchstart", zae, k1), l.addEventListener("touchmove", jae, k1))), O2 += 1;
    }
  }, [n]), a = Wi(function(l) {
    if (Gae) {
      var c = document.body, d = c && c.style;
      O2 = Math.max(O2 - 1, 0), n && O2 < 1 && Vae.forEach(function(u) {
        var h = r.current[u];
        d && (d[u] = h);
      }), c && Uae() && (c.removeEventListener("touchmove", Wae, k1), l && (l.removeEventListener("touchstart", zae, k1), l.removeEventListener("touchmove", jae, k1)));
    }
  }, [n]);
  return $e(function() {
    if (e) {
      var l = s.current;
      return o(l), function() {
        a(l);
      };
    }
  }, [e, o, a]), function(l) {
    s.current = l;
  };
}
function zmt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Umt = function(e) {
  var t = e.target;
  return t.ownerDocument.activeElement && t.ownerDocument.activeElement.blur();
}, Gmt = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: zmt
};
function qmt(i) {
  var e = i.children, t = i.lockEnabled, n = i.captureEnabled, r = n === void 0 ? !0 : n, s = i.onBottomArrive, o = i.onBottomLeave, a = i.onTopArrive, l = i.onTopLeave, c = Wmt({
    isEnabled: r,
    onBottomArrive: s,
    onBottomLeave: o,
    onTopArrive: a,
    onTopLeave: l
  }), d = jmt({
    isEnabled: t
  }), u = function(f) {
    c(f), d(f);
  };
  return Jt(qh, null, t && Jt("div", {
    onClick: Umt,
    css: Gmt
  }), e(u));
}
function Kmt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Ymt = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: Kmt
}, Xmt = function(e) {
  var t = e.name, n = e.onFocus;
  return Jt("input", {
    required: !0,
    name: t,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: n,
    css: Ymt,
    value: "",
    onChange: function() {
    }
  });
}, Zmt = Xmt;
function qq(i) {
  var e;
  return typeof window < "u" && window.navigator != null ? i.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function Qmt() {
  return qq(/^iPhone/i);
}
function W2e() {
  return qq(/^Mac/i);
}
function Jmt() {
  return qq(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  W2e() && navigator.maxTouchPoints > 1;
}
function $mt() {
  return Qmt() || Jmt();
}
function e0t() {
  return W2e() || $mt();
}
var t0t = function(e) {
  return e.label;
}, j2e = function(e) {
  return e.label;
}, z2e = function(e) {
  return e.value;
}, n0t = function(e) {
  return !!e.isDisabled;
}, i0t = {
  clearIndicator: Bpt,
  container: Ept,
  control: Gpt,
  dropdownIndicator: Rpt,
  group: Xpt,
  groupHeading: Qpt,
  indicatorsContainer: kpt,
  indicatorSeparator: Hpt,
  input: tmt,
  loadingIndicator: zpt,
  loadingMessage: ypt,
  menu: gpt,
  menuList: _pt,
  menuPortal: xpt,
  multiValue: omt,
  multiValueLabel: amt,
  multiValueRemove: lmt,
  noOptionsMessage: Cpt,
  option: gmt,
  placeholder: vmt,
  singleValue: Cmt,
  valueContainer: Ipt
}, r0t = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, s0t = 4, U2e = 4, o0t = 38, a0t = U2e * 2, l0t = {
  baseUnit: U2e,
  controlHeight: o0t,
  menuGutter: a0t
}, $M = {
  borderRadius: s0t,
  colors: r0t,
  spacing: l0t
}, c0t = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: Oae(),
  captureMenuScroll: !Oae(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: Fmt(),
  formatGroupLabel: t0t,
  getOptionLabel: j2e,
  getOptionValue: z2e,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: n0t,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !rpt(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(e) {
    var t = e.count;
    return "".concat(t, " result").concat(t !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function qae(i, e, t, n) {
  var r = K2e(i, e, t), s = Y2e(i, e, t), o = q2e(i, e), a = $I(i, e);
  return {
    type: "option",
    data: e,
    isDisabled: r,
    isSelected: s,
    label: o,
    value: a,
    index: n
  };
}
function _E(i, e) {
  return i.options.map(function(t, n) {
    if ("options" in t) {
      var r = t.options.map(function(o, a) {
        return qae(i, o, e, a);
      }).filter(function(o) {
        return Yae(i, o);
      });
      return r.length > 0 ? {
        type: "group",
        data: t,
        options: r,
        index: n
      } : void 0;
    }
    var s = qae(i, t, e, n);
    return Yae(i, s) ? s : void 0;
  }).filter(apt);
}
function G2e(i) {
  return i.reduce(function(e, t) {
    return t.type === "group" ? e.push.apply(e, Rm(t.options.map(function(n) {
      return n.data;
    }))) : e.push(t.data), e;
  }, []);
}
function Kae(i, e) {
  return i.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, Rm(n.options.map(function(r) {
      return {
        data: r.data,
        id: "".concat(e, "-").concat(n.index, "-").concat(r.index)
      };
    }))) : t.push({
      data: n.data,
      id: "".concat(e, "-").concat(n.index)
    }), t;
  }, []);
}
function d0t(i, e) {
  return G2e(_E(i, e));
}
function Yae(i, e) {
  var t = i.inputValue, n = t === void 0 ? "" : t, r = e.data, s = e.isSelected, o = e.label, a = e.value;
  return (!Z2e(i) || !s) && X2e(i, {
    label: o,
    value: a,
    data: r
  }, n);
}
function u0t(i, e) {
  var t = i.focusedValue, n = i.selectValue, r = n.indexOf(t);
  if (r > -1) {
    var s = e.indexOf(t);
    if (s > -1)
      return t;
    if (r < e.length)
      return e[r];
  }
  return null;
}
function h0t(i, e) {
  var t = i.focusedOption;
  return t && e.indexOf(t) > -1 ? t : e[0];
}
var e8 = function(e, t) {
  var n, r = (n = e.find(function(s) {
    return s.data === t;
  })) === null || n === void 0 ? void 0 : n.id;
  return r || null;
}, q2e = function(e, t) {
  return e.getOptionLabel(t);
}, $I = function(e, t) {
  return e.getOptionValue(t);
};
function K2e(i, e, t) {
  return typeof i.isOptionDisabled == "function" ? i.isOptionDisabled(e, t) : !1;
}
function Y2e(i, e, t) {
  if (t.indexOf(e) > -1) return !0;
  if (typeof i.isOptionSelected == "function")
    return i.isOptionSelected(e, t);
  var n = $I(i, e);
  return t.some(function(r) {
    return $I(i, r) === n;
  });
}
function X2e(i, e, t) {
  return i.filterOption ? i.filterOption(e, t) : !0;
}
var Z2e = function(e) {
  var t = e.hideSelectedOptions, n = e.isMulti;
  return t === void 0 ? n : t;
}, f0t = 1, Q2e = /* @__PURE__ */ function(i) {
  Eft(t, i);
  var e = Ift(t);
  function t(n) {
    var r;
    if (xft(this, t), r = e.call(this, n), r.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, r.blockOptionHover = !1, r.isComposing = !1, r.commonProps = void 0, r.initialTouchX = 0, r.initialTouchY = 0, r.openAfterFocus = !1, r.scrollToFocusedOptionOnUpdate = !1, r.userIsDragging = void 0, r.isAppleDevice = e0t(), r.controlRef = null, r.getControlRef = function(l) {
      r.controlRef = l;
    }, r.focusedOptionRef = null, r.getFocusedOptionRef = function(l) {
      r.focusedOptionRef = l;
    }, r.menuListRef = null, r.getMenuListRef = function(l) {
      r.menuListRef = l;
    }, r.inputRef = null, r.getInputRef = function(l) {
      r.inputRef = l;
    }, r.focus = r.focusInput, r.blur = r.blurInput, r.onChange = function(l, c) {
      var d = r.props, u = d.onChange, h = d.name;
      c.name = h, r.ariaOnChange(l, c), u(l, c);
    }, r.setValue = function(l, c, d) {
      var u = r.props, h = u.closeMenuOnSelect, f = u.isMulti, g = u.inputValue;
      r.onInputChange("", {
        action: "set-value",
        prevInputValue: g
      }), h && (r.setState({
        inputIsHiddenAfterUpdate: !f
      }), r.onMenuClose()), r.setState({
        clearFocusValueOnUpdate: !0
      }), r.onChange(l, {
        action: c,
        option: d
      });
    }, r.selectOption = function(l) {
      var c = r.props, d = c.blurInputOnSelect, u = c.isMulti, h = c.name, f = r.state.selectValue, g = u && r.isOptionSelected(l, f), p = r.isOptionDisabled(l, f);
      if (g) {
        var m = r.getOptionValue(l);
        r.setValue(f.filter(function(_) {
          return r.getOptionValue(_) !== m;
        }), "deselect-option", l);
      } else if (!p)
        u ? r.setValue([].concat(Rm(f), [l]), "select-option", l) : r.setValue(l, "select-option");
      else {
        r.ariaOnChange(l, {
          action: "select-option",
          option: l,
          name: h
        });
        return;
      }
      d && r.blurInput();
    }, r.removeValue = function(l) {
      var c = r.props.isMulti, d = r.state.selectValue, u = r.getOptionValue(l), h = d.filter(function(g) {
        return r.getOptionValue(g) !== u;
      }), f = dC(c, h, h[0] || null);
      r.onChange(f, {
        action: "remove-value",
        removedValue: l
      }), r.focusInput();
    }, r.clearValue = function() {
      var l = r.state.selectValue;
      r.onChange(dC(r.props.isMulti, [], null), {
        action: "clear",
        removedValues: l
      });
    }, r.popValue = function() {
      var l = r.props.isMulti, c = r.state.selectValue, d = c[c.length - 1], u = c.slice(0, c.length - 1), h = dC(l, u, u[0] || null);
      r.onChange(h, {
        action: "pop-value",
        removedValue: d
      });
    }, r.getFocusedOptionId = function(l) {
      return e8(r.state.focusableOptionsWithIds, l);
    }, r.getFocusableOptionsWithIds = function() {
      return Kae(_E(r.props, r.state.selectValue), r.getElementId("option"));
    }, r.getValue = function() {
      return r.state.selectValue;
    }, r.cx = function() {
      for (var l = arguments.length, c = new Array(l), d = 0; d < l; d++)
        c[d] = arguments[d];
      return $gt.apply(void 0, [r.props.classNamePrefix].concat(c));
    }, r.getOptionLabel = function(l) {
      return q2e(r.props, l);
    }, r.getOptionValue = function(l) {
      return $I(r.props, l);
    }, r.getStyles = function(l, c) {
      var d = r.props.unstyled, u = i0t[l](c, d);
      u.boxSizing = "border-box";
      var h = r.props.styles[l];
      return h ? h(u, c) : u;
    }, r.getClassNames = function(l, c) {
      var d, u;
      return (d = (u = r.props.classNames)[l]) === null || d === void 0 ? void 0 : d.call(u, c);
    }, r.getElementId = function(l) {
      return "".concat(r.state.instancePrefix, "-").concat(l);
    }, r.getComponents = function() {
      return xmt(r.props);
    }, r.buildCategorizedOptions = function() {
      return _E(r.props, r.state.selectValue);
    }, r.getCategorizedOptions = function() {
      return r.props.menuIsOpen ? r.buildCategorizedOptions() : [];
    }, r.buildFocusableOptions = function() {
      return G2e(r.buildCategorizedOptions());
    }, r.getFocusableOptions = function() {
      return r.props.menuIsOpen ? r.buildFocusableOptions() : [];
    }, r.ariaOnChange = function(l, c) {
      r.setState({
        ariaSelection: Xt({
          value: l
        }, c)
      });
    }, r.onMenuMouseDown = function(l) {
      l.button === 0 && (l.stopPropagation(), l.preventDefault(), r.focusInput());
    }, r.onMenuMouseMove = function(l) {
      r.blockOptionHover = !1;
    }, r.onControlMouseDown = function(l) {
      if (!l.defaultPrevented) {
        var c = r.props.openMenuOnClick;
        r.state.isFocused ? r.props.menuIsOpen ? l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && r.onMenuClose() : c && r.openMenu("first") : (c && (r.openAfterFocus = !0), r.focusInput()), l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && l.preventDefault();
      }
    }, r.onDropdownIndicatorMouseDown = function(l) {
      if (!(l && l.type === "mousedown" && l.button !== 0) && !r.props.isDisabled) {
        var c = r.props, d = c.isMulti, u = c.menuIsOpen;
        r.focusInput(), u ? (r.setState({
          inputIsHiddenAfterUpdate: !d
        }), r.onMenuClose()) : r.openMenu("first"), l.preventDefault();
      }
    }, r.onClearIndicatorMouseDown = function(l) {
      l && l.type === "mousedown" && l.button !== 0 || (r.clearValue(), l.preventDefault(), r.openAfterFocus = !1, l.type === "touchend" ? r.focusInput() : setTimeout(function() {
        return r.focusInput();
      }));
    }, r.onScroll = function(l) {
      typeof r.props.closeMenuOnScroll == "boolean" ? l.target instanceof HTMLElement && bk(l.target) && r.props.onMenuClose() : typeof r.props.closeMenuOnScroll == "function" && r.props.closeMenuOnScroll(l) && r.props.onMenuClose();
    }, r.onCompositionStart = function() {
      r.isComposing = !0;
    }, r.onCompositionEnd = function() {
      r.isComposing = !1;
    }, r.onTouchStart = function(l) {
      var c = l.touches, d = c && c.item(0);
      d && (r.initialTouchX = d.clientX, r.initialTouchY = d.clientY, r.userIsDragging = !1);
    }, r.onTouchMove = function(l) {
      var c = l.touches, d = c && c.item(0);
      if (d) {
        var u = Math.abs(d.clientX - r.initialTouchX), h = Math.abs(d.clientY - r.initialTouchY), f = 5;
        r.userIsDragging = u > f || h > f;
      }
    }, r.onTouchEnd = function(l) {
      r.userIsDragging || (r.controlRef && !r.controlRef.contains(l.target) && r.menuListRef && !r.menuListRef.contains(l.target) && r.blurInput(), r.initialTouchX = 0, r.initialTouchY = 0);
    }, r.onControlTouchEnd = function(l) {
      r.userIsDragging || r.onControlMouseDown(l);
    }, r.onClearIndicatorTouchEnd = function(l) {
      r.userIsDragging || r.onClearIndicatorMouseDown(l);
    }, r.onDropdownIndicatorTouchEnd = function(l) {
      r.userIsDragging || r.onDropdownIndicatorMouseDown(l);
    }, r.handleInputChange = function(l) {
      var c = r.props.inputValue, d = l.currentTarget.value;
      r.setState({
        inputIsHiddenAfterUpdate: !1
      }), r.onInputChange(d, {
        action: "input-change",
        prevInputValue: c
      }), r.props.menuIsOpen || r.onMenuOpen();
    }, r.onInputFocus = function(l) {
      r.props.onFocus && r.props.onFocus(l), r.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (r.openAfterFocus || r.props.openMenuOnFocus) && r.openMenu("first"), r.openAfterFocus = !1;
    }, r.onInputBlur = function(l) {
      var c = r.props.inputValue;
      if (r.menuListRef && r.menuListRef.contains(document.activeElement)) {
        r.inputRef.focus();
        return;
      }
      r.props.onBlur && r.props.onBlur(l), r.onInputChange("", {
        action: "input-blur",
        prevInputValue: c
      }), r.onMenuClose(), r.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, r.onOptionHover = function(l) {
      if (!(r.blockOptionHover || r.state.focusedOption === l)) {
        var c = r.getFocusableOptions(), d = c.indexOf(l);
        r.setState({
          focusedOption: l,
          focusedOptionId: d > -1 ? r.getFocusedOptionId(l) : null
        });
      }
    }, r.shouldHideSelectedOptions = function() {
      return Z2e(r.props);
    }, r.onValueInputFocus = function(l) {
      l.preventDefault(), l.stopPropagation(), r.focus();
    }, r.onKeyDown = function(l) {
      var c = r.props, d = c.isMulti, u = c.backspaceRemovesValue, h = c.escapeClearsValue, f = c.inputValue, g = c.isClearable, p = c.isDisabled, m = c.menuIsOpen, _ = c.onKeyDown, b = c.tabSelectsValue, w = c.openMenuOnFocus, y = r.state, S = y.focusedOption, x = y.focusedValue, D = y.selectValue;
      if (!p && !(typeof _ == "function" && (_(l), l.defaultPrevented))) {
        switch (r.blockOptionHover = !0, l.key) {
          case "ArrowLeft":
            if (!d || f) return;
            r.focusValue("previous");
            break;
          case "ArrowRight":
            if (!d || f) return;
            r.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (f) return;
            if (x)
              r.removeValue(x);
            else {
              if (!u) return;
              d ? r.popValue() : g && r.clearValue();
            }
            break;
          case "Tab":
            if (r.isComposing || l.shiftKey || !m || !b || !S || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            w && r.isOptionSelected(S, D))
              return;
            r.selectOption(S);
            break;
          case "Enter":
            if (l.keyCode === 229)
              break;
            if (m) {
              if (!S || r.isComposing) return;
              r.selectOption(S);
              break;
            }
            return;
          case "Escape":
            m ? (r.setState({
              inputIsHiddenAfterUpdate: !1
            }), r.onInputChange("", {
              action: "menu-close",
              prevInputValue: f
            }), r.onMenuClose()) : g && h && r.clearValue();
            break;
          case " ":
            if (f)
              return;
            if (!m) {
              r.openMenu("first");
              break;
            }
            if (!S) return;
            r.selectOption(S);
            break;
          case "ArrowUp":
            m ? r.focusOption("up") : r.openMenu("last");
            break;
          case "ArrowDown":
            m ? r.focusOption("down") : r.openMenu("first");
            break;
          case "PageUp":
            if (!m) return;
            r.focusOption("pageup");
            break;
          case "PageDown":
            if (!m) return;
            r.focusOption("pagedown");
            break;
          case "Home":
            if (!m) return;
            r.focusOption("first");
            break;
          case "End":
            if (!m) return;
            r.focusOption("last");
            break;
          default:
            return;
        }
        l.preventDefault();
      }
    }, r.state.instancePrefix = "react-select-" + (r.props.instanceId || ++f0t), r.state.selectValue = QI(n.value), n.menuIsOpen && r.state.selectValue.length) {
      var s = r.getFocusableOptionsWithIds(), o = r.buildFocusableOptions(), a = o.indexOf(r.state.selectValue[0]);
      r.state.focusableOptionsWithIds = s, r.state.focusedOption = o[a], r.state.focusedOptionId = e8(s, o[a]);
    }
    return r;
  }
  return Dft(t, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && Pae(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      var s = this.props, o = s.isDisabled, a = s.menuIsOpen, l = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (l && !o && r.isDisabled || // ensure focus is on the Input when the menu opens
      l && a && !r.menuIsOpen) && this.focusInput(), l && o && !r.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !l && !o && r.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (Pae(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(r, s) {
      this.props.onInputChange(r, s);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(r) {
      var s = this, o = this.state, a = o.selectValue, l = o.isFocused, c = this.buildFocusableOptions(), d = r === "first" ? 0 : c.length - 1;
      if (!this.props.isMulti) {
        var u = c.indexOf(a[0]);
        u > -1 && (d = u);
      }
      this.scrollToFocusedOptionOnUpdate = !(l && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: c[d],
        focusedOptionId: this.getFocusedOptionId(c[d])
      }, function() {
        return s.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(r) {
      var s = this.state, o = s.selectValue, a = s.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var l = o.indexOf(a);
        a || (l = -1);
        var c = o.length - 1, d = -1;
        if (o.length) {
          switch (r) {
            case "previous":
              l === 0 ? d = 0 : l === -1 ? d = c : d = l - 1;
              break;
            case "next":
              l > -1 && l < c && (d = l + 1);
              break;
          }
          this.setState({
            inputIsHidden: d !== -1,
            focusedValue: o[d]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", s = this.props.pageSize, o = this.state.focusedOption, a = this.getFocusableOptions();
      if (a.length) {
        var l = 0, c = a.indexOf(o);
        o || (c = -1), r === "up" ? l = c > 0 ? c - 1 : a.length - 1 : r === "down" ? l = (c + 1) % a.length : r === "pageup" ? (l = c - s, l < 0 && (l = 0)) : r === "pagedown" ? (l = c + s, l > a.length - 1 && (l = a.length - 1)) : r === "last" && (l = a.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: a[l],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(a[l])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme($M) : Xt(Xt({}, $M), this.props.theme) : $M;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var r = this.clearValue, s = this.cx, o = this.getStyles, a = this.getClassNames, l = this.getValue, c = this.selectOption, d = this.setValue, u = this.props, h = u.isMulti, f = u.isRtl, g = u.options, p = this.hasValue();
      return {
        clearValue: r,
        cx: s,
        getStyles: o,
        getClassNames: a,
        getValue: l,
        hasValue: p,
        isMulti: h,
        isRtl: f,
        options: g,
        selectOption: c,
        selectProps: u,
        setValue: d,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var r = this.state.selectValue;
      return r.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var r = this.props, s = r.isClearable, o = r.isMulti;
      return s === void 0 ? o : s;
    }
  }, {
    key: "isOptionDisabled",
    value: function(r, s) {
      return K2e(this.props, r, s);
    }
  }, {
    key: "isOptionSelected",
    value: function(r, s) {
      return Y2e(this.props, r, s);
    }
  }, {
    key: "filterOption",
    value: function(r, s) {
      return X2e(this.props, r, s);
    }
  }, {
    key: "formatOptionLabel",
    value: function(r, s) {
      if (typeof this.props.formatOptionLabel == "function") {
        var o = this.props.inputValue, a = this.state.selectValue;
        return this.props.formatOptionLabel(r, {
          context: s,
          inputValue: o,
          selectValue: a
        });
      } else
        return this.getOptionLabel(r);
    }
  }, {
    key: "formatGroupLabel",
    value: function(r) {
      return this.props.formatGroupLabel(r);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var r = this.props, s = r.isDisabled, o = r.isSearchable, a = r.inputId, l = r.inputValue, c = r.tabIndex, d = r.form, u = r.menuIsOpen, h = r.required, f = this.getComponents(), g = f.Input, p = this.state, m = p.inputIsHidden, _ = p.ariaSelection, b = this.commonProps, w = a || this.getElementId("input"), y = Xt(Xt(Xt({
          "aria-autocomplete": "list",
          "aria-expanded": u,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": h,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, u && {
          "aria-controls": this.getElementId("listbox")
        }), !o && {
          "aria-readonly": !0
        }), this.hasValue() ? _?.action === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return o ? /* @__PURE__ */ G.createElement(g, cn({}, b, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: w,
          innerRef: this.getInputRef,
          isDisabled: s,
          isHidden: m,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: c,
          form: d,
          type: "text",
          value: l
        }, y)) : /* @__PURE__ */ G.createElement(Vmt, cn({
          id: w,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: ZI,
          onFocus: this.onInputFocus,
          disabled: s,
          tabIndex: c,
          inputMode: "none",
          form: d,
          value: ""
        }, y));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var r = this, s = this.getComponents(), o = s.MultiValue, a = s.MultiValueContainer, l = s.MultiValueLabel, c = s.MultiValueRemove, d = s.SingleValue, u = s.Placeholder, h = this.commonProps, f = this.props, g = f.controlShouldRenderValue, p = f.isDisabled, m = f.isMulti, _ = f.inputValue, b = f.placeholder, w = this.state, y = w.selectValue, S = w.focusedValue, x = w.isFocused;
      if (!this.hasValue() || !g)
        return _ ? null : /* @__PURE__ */ G.createElement(u, cn({}, h, {
          key: "placeholder",
          isDisabled: p,
          isFocused: x,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), b);
      if (m)
        return y.map(function(E, L) {
          var k = E === S, N = "".concat(r.getOptionLabel(E), "-").concat(r.getOptionValue(E));
          return /* @__PURE__ */ G.createElement(o, cn({}, h, {
            components: {
              Container: a,
              Label: l,
              Remove: c
            },
            isFocused: k,
            isDisabled: p,
            key: N,
            index: L,
            removeProps: {
              onClick: function() {
                return r.removeValue(E);
              },
              onTouchEnd: function() {
                return r.removeValue(E);
              },
              onMouseDown: function(A) {
                A.preventDefault();
              }
            },
            data: E
          }), r.formatOptionLabel(E, "value"));
        });
      if (_)
        return null;
      var D = y[0];
      return /* @__PURE__ */ G.createElement(d, cn({}, h, {
        data: D,
        isDisabled: p
      }), this.formatOptionLabel(D, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var r = this.getComponents(), s = r.ClearIndicator, o = this.commonProps, a = this.props, l = a.isDisabled, c = a.isLoading, d = this.state.isFocused;
      if (!this.isClearable() || !s || l || !this.hasValue() || c)
        return null;
      var u = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ G.createElement(s, cn({}, o, {
        innerProps: u,
        isFocused: d
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var r = this.getComponents(), s = r.LoadingIndicator, o = this.commonProps, a = this.props, l = a.isDisabled, c = a.isLoading, d = this.state.isFocused;
      if (!s || !c) return null;
      var u = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ G.createElement(s, cn({}, o, {
        innerProps: u,
        isDisabled: l,
        isFocused: d
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var r = this.getComponents(), s = r.DropdownIndicator, o = r.IndicatorSeparator;
      if (!s || !o) return null;
      var a = this.commonProps, l = this.props.isDisabled, c = this.state.isFocused;
      return /* @__PURE__ */ G.createElement(o, cn({}, a, {
        isDisabled: l,
        isFocused: c
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var r = this.getComponents(), s = r.DropdownIndicator;
      if (!s) return null;
      var o = this.commonProps, a = this.props.isDisabled, l = this.state.isFocused, c = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ G.createElement(s, cn({}, o, {
        innerProps: c,
        isDisabled: a,
        isFocused: l
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var r = this, s = this.getComponents(), o = s.Group, a = s.GroupHeading, l = s.Menu, c = s.MenuList, d = s.MenuPortal, u = s.LoadingMessage, h = s.NoOptionsMessage, f = s.Option, g = this.commonProps, p = this.state.focusedOption, m = this.props, _ = m.captureMenuScroll, b = m.inputValue, w = m.isLoading, y = m.loadingMessage, S = m.minMenuHeight, x = m.maxMenuHeight, D = m.menuIsOpen, E = m.menuPlacement, L = m.menuPosition, k = m.menuPortalTarget, N = m.menuShouldBlockScroll, I = m.menuShouldScrollIntoView, A = m.noOptionsMessage, P = m.onMenuScrollToTop, O = m.onMenuScrollToBottom;
      if (!D) return null;
      var K = function(X, ae) {
        var ue = X.type, se = X.data, le = X.isDisabled, oe = X.isSelected, re = X.label, B = X.value, ee = p === se, j = le ? void 0 : function() {
          return r.onOptionHover(se);
        }, he = le ? void 0 : function() {
          return r.selectOption(se);
        }, Se = "".concat(r.getElementId("option"), "-").concat(ae), ge = {
          id: Se,
          onClick: he,
          onMouseMove: j,
          onMouseOver: j,
          tabIndex: -1,
          role: "option",
          "aria-selected": r.isAppleDevice ? void 0 : oe
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ G.createElement(f, cn({}, g, {
          innerProps: ge,
          data: se,
          isDisabled: le,
          isSelected: oe,
          key: Se,
          label: re,
          type: ue,
          value: B,
          isFocused: ee,
          innerRef: ee ? r.getFocusedOptionRef : void 0
        }), r.formatOptionLabel(X.data, "menu"));
      }, W;
      if (this.hasOptions())
        W = this.getCategorizedOptions().map(function(z) {
          if (z.type === "group") {
            var X = z.data, ae = z.options, ue = z.index, se = "".concat(r.getElementId("group"), "-").concat(ue), le = "".concat(se, "-heading");
            return /* @__PURE__ */ G.createElement(o, cn({}, g, {
              key: se,
              data: X,
              options: ae,
              Heading: a,
              headingProps: {
                id: le,
                data: z.data
              },
              label: r.formatGroupLabel(z.data)
            }), z.options.map(function(oe) {
              return K(oe, "".concat(ue, "-").concat(oe.index));
            }));
          } else if (z.type === "option")
            return K(z, "".concat(z.index));
        });
      else if (w) {
        var F = y({
          inputValue: b
        });
        if (F === null) return null;
        W = /* @__PURE__ */ G.createElement(u, g, F);
      } else {
        var q = A({
          inputValue: b
        });
        if (q === null) return null;
        W = /* @__PURE__ */ G.createElement(h, g, q);
      }
      var R = {
        minMenuHeight: S,
        maxMenuHeight: x,
        menuPlacement: E,
        menuPosition: L,
        menuShouldScrollIntoView: I
      }, T = /* @__PURE__ */ G.createElement(ppt, cn({}, g, R), function(z) {
        var X = z.ref, ae = z.placerProps, ue = ae.placement, se = ae.maxHeight;
        return /* @__PURE__ */ G.createElement(l, cn({}, g, R, {
          innerRef: X,
          innerProps: {
            onMouseDown: r.onMenuMouseDown,
            onMouseMove: r.onMenuMouseMove
          },
          isLoading: w,
          placement: ue
        }), /* @__PURE__ */ G.createElement(qmt, {
          captureEnabled: _,
          onTopArrive: P,
          onBottomArrive: O,
          lockEnabled: N
        }, function(le) {
          return /* @__PURE__ */ G.createElement(c, cn({}, g, {
            innerRef: function(re) {
              r.getMenuListRef(re), le(re);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": g.isMulti,
              id: r.getElementId("listbox")
            },
            isLoading: w,
            maxHeight: se,
            focusedOption: p
          }), W);
        }));
      });
      return k || L === "fixed" ? /* @__PURE__ */ G.createElement(d, cn({}, g, {
        appendTo: k,
        controlElement: this.controlRef,
        menuPlacement: E,
        menuPosition: L
      }), T) : T;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var r = this, s = this.props, o = s.delimiter, a = s.isDisabled, l = s.isMulti, c = s.name, d = s.required, u = this.state.selectValue;
      if (d && !this.hasValue() && !a)
        return /* @__PURE__ */ G.createElement(Zmt, {
          name: c,
          onFocus: this.onValueInputFocus
        });
      if (!(!c || a))
        if (l)
          if (o) {
            var h = u.map(function(p) {
              return r.getOptionValue(p);
            }).join(o);
            return /* @__PURE__ */ G.createElement("input", {
              name: c,
              type: "hidden",
              value: h
            });
          } else {
            var f = u.length > 0 ? u.map(function(p, m) {
              return /* @__PURE__ */ G.createElement("input", {
                key: "i-".concat(m),
                name: c,
                type: "hidden",
                value: r.getOptionValue(p)
              });
            }) : /* @__PURE__ */ G.createElement("input", {
              name: c,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ G.createElement("div", null, f);
          }
        else {
          var g = u[0] ? this.getOptionValue(u[0]) : "";
          return /* @__PURE__ */ G.createElement("input", {
            name: c,
            type: "hidden",
            value: g
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var r = this.commonProps, s = this.state, o = s.ariaSelection, a = s.focusedOption, l = s.focusedValue, c = s.isFocused, d = s.selectValue, u = this.getFocusableOptions();
      return /* @__PURE__ */ G.createElement(Pmt, cn({}, r, {
        id: this.getElementId("live-region"),
        ariaSelection: o,
        focusedOption: a,
        focusedValue: l,
        isFocused: c,
        selectValue: d,
        focusableOptions: u,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.getComponents(), s = r.Control, o = r.IndicatorsContainer, a = r.SelectContainer, l = r.ValueContainer, c = this.props, d = c.className, u = c.id, h = c.isDisabled, f = c.menuIsOpen, g = this.state.isFocused, p = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ G.createElement(a, cn({}, p, {
        className: d,
        innerProps: {
          id: u,
          onKeyDown: this.onKeyDown
        },
        isDisabled: h,
        isFocused: g
      }), this.renderLiveRegion(), /* @__PURE__ */ G.createElement(s, cn({}, p, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: h,
        isFocused: g,
        menuIsOpen: f
      }), /* @__PURE__ */ G.createElement(l, cn({}, p, {
        isDisabled: h
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ G.createElement(o, cn({}, p, {
        isDisabled: h
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, s) {
      var o = s.prevProps, a = s.clearFocusValueOnUpdate, l = s.inputIsHiddenAfterUpdate, c = s.ariaSelection, d = s.isFocused, u = s.prevWasFocused, h = s.instancePrefix, f = r.options, g = r.value, p = r.menuIsOpen, m = r.inputValue, _ = r.isMulti, b = QI(g), w = {};
      if (o && (g !== o.value || f !== o.options || p !== o.menuIsOpen || m !== o.inputValue)) {
        var y = p ? d0t(r, b) : [], S = p ? Kae(_E(r, b), "".concat(h, "-option")) : [], x = a ? u0t(s, b) : null, D = h0t(s, y), E = e8(S, D);
        w = {
          selectValue: b,
          focusedOption: D,
          focusedOptionId: E,
          focusableOptionsWithIds: S,
          focusedValue: x,
          clearFocusValueOnUpdate: !1
        };
      }
      var L = l != null && r !== o ? {
        inputIsHidden: l,
        inputIsHiddenAfterUpdate: void 0
      } : {}, k = c, N = d && u;
      return d && !N && (k = {
        value: dC(_, b, b[0] || null),
        options: b,
        action: "initial-input-focus"
      }, N = !u), c?.action === "initial-input-focus" && (k = null), Xt(Xt(Xt({}, w), L), {}, {
        prevProps: r,
        ariaSelection: k,
        prevWasFocused: N
      });
    }
  }]), t;
}(nS);
Q2e.defaultProps = c0t;
var g0t = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function p0t(i) {
  var e = i.defaultInputValue, t = e === void 0 ? "" : e, n = i.defaultMenuIsOpen, r = n === void 0 ? !1 : n, s = i.defaultValue, o = s === void 0 ? null : s, a = i.inputValue, l = i.menuIsOpen, c = i.onChange, d = i.onInputChange, u = i.onMenuClose, h = i.onMenuOpen, f = i.value, g = wd(i, g0t), p = Oe(a !== void 0 ? a : t), m = hu(p, 2), _ = m[0], b = m[1], w = Oe(l !== void 0 ? l : r), y = hu(w, 2), S = y[0], x = y[1], D = Oe(f !== void 0 ? f : o), E = hu(D, 2), L = E[0], k = E[1], N = Wi(function(F, q) {
    typeof c == "function" && c(F, q), k(F);
  }, [c]), I = Wi(function(F, q) {
    var R;
    typeof d == "function" && (R = d(F, q)), b(R !== void 0 ? R : F);
  }, [d]), A = Wi(function() {
    typeof h == "function" && h(), x(!0);
  }, [h]), P = Wi(function() {
    typeof u == "function" && u(), x(!1);
  }, [u]), O = a !== void 0 ? a : _, K = l !== void 0 ? l : S, W = f !== void 0 ? f : L;
  return Xt(Xt({}, g), {}, {
    inputValue: O,
    menuIsOpen: K,
    onChange: N,
    onInputChange: I,
    onMenuClose: P,
    onMenuOpen: A,
    value: W
  });
}
var m0t = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"], Xae = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 ? arguments[2] : void 0, r = String(e).toLowerCase(), s = String(n.getOptionValue(t)).toLowerCase(), o = String(n.getOptionLabel(t)).toLowerCase();
  return s === r || o === r;
}, t8 = {
  formatCreateLabel: function(e) {
    return 'Create "'.concat(e, '"');
  },
  isValidNewOption: function(e, t, n, r) {
    return !(!e || t.some(function(s) {
      return Xae(e, s, r);
    }) || n.some(function(s) {
      return Xae(e, s, r);
    }));
  },
  getNewOptionData: function(e, t) {
    return {
      label: t,
      value: e,
      __isNew__: !0
    };
  }
};
function v0t(i) {
  var e = i.allowCreateWhileLoading, t = e === void 0 ? !1 : e, n = i.createOptionPosition, r = n === void 0 ? "last" : n, s = i.formatCreateLabel, o = s === void 0 ? t8.formatCreateLabel : s, a = i.isValidNewOption, l = a === void 0 ? t8.isValidNewOption : a, c = i.getNewOptionData, d = c === void 0 ? t8.getNewOptionData : c, u = i.onCreateOption, h = i.options, f = h === void 0 ? [] : h, g = i.onChange, p = wd(i, m0t), m = p.getOptionValue, _ = m === void 0 ? z2e : m, b = p.getOptionLabel, w = b === void 0 ? j2e : b, y = p.inputValue, S = p.isLoading, x = p.isMulti, D = p.value, E = p.name, L = Mn(function() {
    return l(y, QI(D), f, {
      getOptionValue: _,
      getOptionLabel: w
    }) ? d(y, o(y)) : void 0;
  }, [o, d, w, _, y, l, f, D]), k = Mn(function() {
    return (t || !S) && L ? r === "first" ? [L].concat(Rm(f)) : [].concat(Rm(f), [L]) : f;
  }, [t, r, S, L, f]), N = Wi(function(I, A) {
    if (A.action !== "select-option")
      return g(I, A);
    var P = Array.isArray(I) ? I : [I];
    if (P[P.length - 1] === L) {
      if (u) u(y);
      else {
        var O = d(y, y), K = {
          action: "create-option",
          name: E,
          option: O
        };
        g(dC(x, [].concat(Rm(QI(D)), [O]), O), K);
      }
      return;
    }
    g(I, A);
  }, [d, y, x, E, L, u, g, D]);
  return Xt(Xt({}, p), {}, {
    options: k,
    onChange: N
  });
}
hs();
var _0t = /* @__PURE__ */ tS(function(i, e) {
  var t = p0t(i), n = v0t(t);
  return /* @__PURE__ */ G.createElement(Q2e, cn({
    ref: e
  }, n));
}), b0t = _0t;
const J2e = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...i }, /* @__PURE__ */ G.createElement("circle", { cx: 8.00016, cy: 8, r: 6.66667, fill: "#767D84" }), /* @__PURE__ */ G.createElement("path", { d: "M7.99496 5.38035C7.80688 5.38035 7.64568 5.31318 7.51133 5.17884C7.37699 5.0445 7.30982 4.87993 7.30982 4.68514C7.30982 4.49034 7.37699 4.32914 7.51133 4.20151C7.64568 4.06717 7.80688 4 7.99496 4C8.18976 4 8.35432 4.06717 8.48867 4.20151C8.62301 4.32914 8.69018 4.49034 8.69018 4.68514C8.69018 4.87993 8.62301 5.0445 8.48867 5.17884C8.35432 5.31318 8.18976 5.38035 7.99496 5.38035ZM8.57934 10.2267H10V11.2443H6V10.2267H7.42066V7.11335H6V6.09572H8.57934V10.2267Z", fill: "white" }));
var Kq = /* @__PURE__ */ ((i) => (i.DEFAULT = "default", i.BORDER_LESS = "border-less", i))(Kq || {});
const C0t = (i) => {
  switch (i) {
    case Mi.medium:
      return "125%";
    case Mi.large:
      return "150%";
    case Mi.small:
    default:
      return "100%";
  }
}, Zae = (i) => {
  switch (i) {
    case Kq.BORDER_LESS:
      return {
        control: () => ({
          backgroundColor: "transparent",
          border: "none",
          padding: 0,
          gap: "2px"
        }),
        singleValue: () => ({
          fontWeight: 600
        })
      };
    default:
      return null;
  }
}, y0t = (i) => i.isSelected && !i.selectProps.isMulti ? "var(--B100)" : i.isFocused ? "var(--N50)" : "var(--N0)", w0t = ({
  error: i,
  size: e,
  menuSize: t,
  variant: n,
  getIsOptionValid: r,
  isGroupHeadingSelectable: s,
  shouldMenuAlignRight: o
}) => ({
  container: (a, l) => ({
    ...a,
    ...l.isDisabled && {
      cursor: "not-allowed",
      pointerEvents: "auto"
    }
  }),
  menu: (a) => ({
    ...a,
    overflow: "hidden",
    marginBlock: "4px",
    backgroundColor: "var(--N0)",
    border: "1px solid var(--N200)",
    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
    width: C0t(t),
    minWidth: "200px",
    zIndex: "var(--select-picker-menu-index)",
    ...o && {
      right: 0
    }
  }),
  menuList: (a) => ({
    ...a,
    padding: 0
  }),
  control: (a, l) => ({
    ...a,
    minHeight: e === Mi.medium ? "auto" : "36px",
    minWidth: "100px",
    boxShadow: "none",
    backgroundColor: "var(--N50)",
    border: `1px solid ${i ? "var(--R500)" : "var(--N200)"}`,
    cursor: l.isDisabled ? "not-allowed" : "pointer",
    padding: "5px 8px",
    gap: "6px",
    opacity: l.isDisabled ? 0.5 : 1,
    flexWrap: "nowrap",
    maxHeight: "120px",
    overflow: "auto",
    alignItems: "safe center",
    ...Zae(n)?.control(a, l) || {},
    "&:hover": {
      borderColor: l.isDisabled ? "var(--N200)" : "var(--N300)"
    },
    "&:focus, &:focus-within": {
      borderColor: l.isDisabled ? "var(--N200)" : "var(--B500)",
      outline: "none"
    }
  }),
  option: (a, l) => ({
    ...a,
    color: "var(--N900)",
    backgroundColor: y0t(l),
    padding: "6px 8px",
    cursor: "pointer",
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 400,
    ":active": {
      backgroundColor: "var(--N100)"
    },
    ":hover": {
      backgroundColor: "var(--N50)"
    },
    ...l.isDisabled && {
      cursor: "not-allowed",
      opacity: 0.5
    }
  }),
  dropdownIndicator: (a, l) => ({
    ...a,
    color: "var(--N600)",
    padding: "0",
    transition: "all .2s ease",
    transform: l.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
  }),
  clearIndicator: (a) => ({
    ...a,
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent",
      color: "inherit",
      "svg use": {
        fill: "var(--R500)"
      }
    }
  }),
  valueContainer: (a, l) => ({
    ...a,
    padding: "0",
    fontWeight: "400",
    ...l.selectProps.isMulti && {
      gap: "6px"
    }
  }),
  multiValue: (a, l) => {
    const c = r(l.data);
    return {
      ...a,
      background: c ? "var(--N0)" : "var(--R100)",
      border: c ? "1px solid var(--N200)" : "1px solid var(--R200)",
      borderRadius: "4px",
      padding: "1px 5px",
      maxWidth: "250px",
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: "4px"
    };
  },
  multiValueLabel: (a) => ({
    ...a,
    borderRadius: 0,
    color: "var(--N900)",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "20px",
    padding: 0,
    paddingLeft: 0
  }),
  multiValueRemove: (a) => ({
    ...a,
    padding: 0,
    borderRadius: 0,
    "&:hover": {
      backgroundColor: "var(--R100)",
      color: "inherit",
      borderRadius: "2px",
      "svg use": {
        fill: "var(--R500)"
      }
    }
  }),
  loadingMessage: (a) => ({
    ...a,
    color: "var(--N600)"
  }),
  noOptionsMessage: (a) => ({
    ...a,
    color: "var(--N600)"
  }),
  group: (a) => ({
    ...a,
    paddingTop: "4px",
    paddingBottom: 0,
    "&:first-child": {
      paddingTop: 0
    }
  }),
  groupHeading: (a) => ({
    ...a,
    fontWeight: 600,
    fontSize: "12px",
    color: "var(--N900)",
    backgroundColor: "var(--N100)",
    marginBottom: 0,
    padding: "4px 8px",
    textTransform: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    zIndex: 1,
    ...s && {
      cursor: "pointer"
    }
  }),
  input: (a) => ({
    ...a,
    margin: 0,
    padding: 0,
    color: "var(--N900)",
    size: "13px",
    fontWeight: 400,
    lineHeight: "20px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "clip"
  }),
  placeholder: (a) => ({
    ...a,
    color: "var(--N500)",
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 400,
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  indicatorsContainer: (a) => ({
    ...a,
    gap: "4px",
    flexShrink: 0
  }),
  singleValue: (a, l) => ({
    ...a,
    margin: 0,
    color: "var(--N900)",
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "20px",
    ...Zae(n)?.singleValue(a, l) || {}
  })
}), S0t = (i, e, t) => {
  const n = e.reduce((a, l) => (a[t(l)] = !0, a), {}), r = i.map((a) => t(a));
  return r.every((a) => n[a]) ? Aa.CHECKED : r.some((a) => n[a]) ? Aa.INTERMEDIATE : null;
}, Qae = (i, e, t = { label: "", value: "" }) => Array.isArray(i) ? i.reduce(
  (r, s) => {
    if (!r.notFound) return r;
    if ("value" in s && s.value === e)
      return { data: s, notFound: !1 };
    if ("options" in s && s.options) {
      const o = s.options.find(({ value: a }) => a === e);
      if (o)
        return { data: o, notFound: !1 };
    }
    return r;
  },
  { notFound: !0, data: t }
).data : t, Jae = (i) => {
  const { isDisabled: e } = i;
  return /* @__PURE__ */ v.jsx(zi.DropdownIndicator, { ...i, children: /* @__PURE__ */ v.jsx(pS, { className: `icon-dim-16 ${e ? "scn-3" : "scn-6"} dc__no-shrink` }) });
}, $ae = (i) => /* @__PURE__ */ v.jsx(zi.ClearIndicator, { ...i, children: /* @__PURE__ */ v.jsx(Il, { className: "icon-dim-16 icon-use-fill-n6 dc__no-shrink" }) }), x0t = ({
  icon: i,
  showSelectedOptionIcon: e,
  ...t
}) => {
  const { children: n, getValue: r } = t, { startIcon: s, endIcon: o } = r()?.[0] ?? {};
  let a = i;
  return e && (s || o) && (a = s || o), /* @__PURE__ */ v.jsxs(zi.Control, { ...t, children: [
    a && /* @__PURE__ */ v.jsx("div", { className: "dc__no-shrink icon-dim-20 flex dc__fill-available-space", children: a }),
    n
  ] });
}, D0t = ({
  showSelectedOptionsCount: i,
  customSelectedOptionsCount: e,
  ...t
}) => {
  const { getValue: n } = t, r = LAe(e) ? (n() ?? []).length : e;
  return /* @__PURE__ */ v.jsxs("div", { className: "flex left dc__gap-8 flex-grow-1", children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex left", children: /* @__PURE__ */ v.jsx(zi.ValueContainer, { ...t }) }),
    i && r > 0 && /* @__PURE__ */ v.jsx("div", { className: "bcb-50 dc__border eb-2 dc__border-radius-4-imp pl-5 pr-5 cb-5 fs-12 fw-6 lh-18 dc__truncate dc__no-shrink", children: r })
  ] });
}, ele = () => /* @__PURE__ */ v.jsx(Yr, {}), E0t = ({
  disableDescriptionEllipsis: i,
  ...e
}) => {
  const {
    label: t,
    data: n,
    selectProps: { isMulti: r },
    selectOption: s,
    isDisabled: o,
    isSelected: a
  } = e, { description: l, startIcon: c, endIcon: d } = n ?? {}, u = !!l, h = "__isNew__" in n && n.__isNew__, f = (g) => {
    g.preventDefault(), g.stopPropagation(), s(n);
  };
  return /* @__PURE__ */ v.jsx(zi.Option, { ...e, children: /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
    r && !h && /* @__PURE__ */ v.jsx(
      cb,
      {
        onChange: El,
        onClick: f,
        isChecked: a || !1,
        value: Aa.CHECKED,
        rootClassName: "mb-0 w-20 p-2 dc__align-self-start dc__no-shrink",
        disabled: o
      }
    ),
    /* @__PURE__ */ v.jsxs("div", { className: `flex left ${u ? "top" : ""} dc__gap-8`, children: [
      c && /* @__PURE__ */ v.jsx("div", { className: "dc__no-shrink icon-dim-20 flex dc__fill-available-space", children: c }),
      /* @__PURE__ */ v.jsxs("div", { className: "flex-grow-1", children: [
        /* @__PURE__ */ v.jsx("h4", { className: `m-0 fs-13 ${h ? "cb-5" : "cn-9"} fw-4 lh-20 dc__truncate`, children: t }),
        u && /* @__PURE__ */ v.jsx(
          "p",
          {
            className: `m-0 fs-12 fw-4 lh-18 cn-7 ${i ? "" : "dc__ellipsis-right__2nd-line"}`,
            children: l
          }
        )
      ] }),
      d && /* @__PURE__ */ v.jsx("div", { className: "dc__no-shrink icon-dim-20 flex dc__fill-available-space", children: d })
    ] })
  ] }) });
}, tle = (i) => {
  const {
    children: e,
    selectProps: { inputValue: t, renderMenuListFooter: n, shouldRenderCustomOptions: r, renderCustomOptions: s }
  } = i;
  return (
    // added key here to explicitly re-render the list on input change so that the top option is rendered
    /* @__PURE__ */ pr(zi.MenuList, { ...i, key: t }, /* @__PURE__ */ v.jsx("div", { className: "py-4 cursor", children: r ? s() : e }), !r && n && /* @__PURE__ */ v.jsx("div", { className: "dc__position-sticky dc__bottom-0 dc__bottom-radius-4 bcn-0 dc__zi-2", children: n() }))
  );
}, L0t = ({
  getIsOptionValid: i,
  ...e
}) => {
  const { data: t, selectProps: n } = e, s = i(t) ? t.startIcon || t.endIcon : /* @__PURE__ */ v.jsx(A0, {});
  return /* @__PURE__ */ v.jsxs("div", { className: "flex dc__gap-4 mw-0 dc__truncate", children: [
    s && /* @__PURE__ */ v.jsx(
      "div",
      {
        className: `dc__no-shrink ${n.isMulti ? "icon-dim-16" : "icon-dim-20"} flex dc__fill-available-space`,
        children: s
      }
    ),
    /* @__PURE__ */ v.jsx(zi.MultiValueLabel, { ...e })
  ] });
}, I0t = (i) => /* @__PURE__ */ v.jsx(zi.MultiValueLabel, { ...i, children: /* @__PURE__ */ v.jsx("span", { className: "flex dc__no-shrink", children: /* @__PURE__ */ v.jsx(Il, { className: "icon-dim-12 icon-use-fill-n6" }) }) }), A0t = ({
  isGroupHeadingSelectable: i,
  ...e
}) => {
  const { data: t, selectProps: n } = e;
  if (!t.label)
    return null;
  if (!i || !n.isMulti)
    return /* @__PURE__ */ v.jsx(zi.GroupHeading, { ...e });
  const r = n.value ?? [], s = t.options ?? [], o = S0t(s, r, n.getOptionValue), a = () => {
    const c = s.reduce((u, h) => (u[n.getOptionValue(h)] = !0, u), {}), d = r.filter(
      (u) => !c[n.getOptionValue(u)]
    );
    if (o) {
      n?.onChange?.(d, {
        action: o8.deselectOption,
        option: null
      });
      return;
    }
    n?.onChange?.([...d, ...structuredClone(s)], {
      action: o8.selectOption,
      option: null
    });
  }, l = (c) => {
    c.preventDefault(), c.stopPropagation(), a();
  };
  return /* @__PURE__ */ v.jsx(zi.GroupHeading, { ...e, onClick: a, children: /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
    i && /* @__PURE__ */ v.jsx(
      cb,
      {
        onChange: El,
        onClick: l,
        isChecked: !!o,
        value: o,
        rootClassName: "mb-0 w-20 p-2 dc__align-self-start dc__no-shrink"
      }
    ),
    /* @__PURE__ */ v.jsx("div", { className: "dc__truncate", children: e.data.label })
  ] }) });
}, k0t = ({
  error: i,
  icon: e,
  helperText: t,
  placeholder: n = "Select a option",
  label: r,
  showSelectedOptionIcon: s = !0,
  size: o = Mi.medium,
  disabledTippyContent: a,
  showSelectedOptionsCount: l = !1,
  menuSize: c,
  optionListError: d,
  reloadOptionList: u,
  menuPosition: h = "fixed",
  variant: f = Kq.DEFAULT,
  disableDescriptionEllipsis: g = !1,
  multiSelectProps: p = {},
  isMulti: m,
  name: _,
  classNamePrefix: b,
  shouldRenderCustomOptions: w = !1,
  isSearchable: y,
  selectRef: S,
  shouldMenuAlignRight: x = !1,
  fullWidth: D = !1,
  customSelectedOptionsCount: E = null,
  renderMenuListFooter: L,
  ...k
}) => {
  const { inputId: N, required: I, isDisabled: A, controlShouldRenderValue: P = !0, value: O, options: K } = k, {
    isCreatable: W = !1,
    isGroupHeadingSelectable: F = !1,
    getIsOptionValid: q = () => !0,
    onCreateOption: R
  } = p, T = m && P ? Mi.large : o, z = !m && s, X = !w && y, ae = `${N}-label`, ue = `${N}-error-msg`, se = Mn(
    () => w0t({
      error: i,
      size: T,
      menuSize: c,
      variant: f,
      getIsOptionValid: q,
      isGroupHeadingSelectable: F,
      shouldMenuAlignRight: x
    }),
    [i, T, c, f, F, x]
  ), le = (be) => {
    const Ae = be?.trim();
    return W && !!Ae && !Qae(
      O,
      Ae,
      null
    ) && !Qae(K, Ae, null);
  }, oe = Wi(
    (be) => /* @__PURE__ */ v.jsx(x0t, { ...be, icon: e, showSelectedOptionIcon: z }),
    [e, z]
  ), re = Wi(
    (be) => /* @__PURE__ */ v.jsx(
      D0t,
      {
        ...be,
        showSelectedOptionsCount: l,
        customSelectedOptionsCount: E
      }
    ),
    [l, E]
  ), B = Wi(
    (be) => /* @__PURE__ */ v.jsx(E0t, { ...be, disableDescriptionEllipsis: g }),
    [g]
  ), ee = (be) => /* @__PURE__ */ v.jsx(L0t, { ...be, getIsOptionValid: q }), j = Wi(
    (be) => /* @__PURE__ */ v.jsx(A0t, { ...be, isGroupHeadingSelectable: F }),
    [F]
  ), he = () => d ? /* @__PURE__ */ v.jsx(ob, { reload: u }) : /* @__PURE__ */ v.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-20 py-6 px-8", children: "No options" }), Se = (be) => /* @__PURE__ */ v.jsx(wn, { content: a, placement: "top", className: "default-tt", arrow: !1, children: be }), ge = (be) => {
    const Ae = be?.trim();
    Ae && R(Ae);
  }, te = Mn(
    () => ({
      name: _ || N,
      classNamePrefix: b || N,
      isSearchable: X,
      placeholder: n,
      styles: se,
      menuPlacement: "auto",
      menuPosition: h,
      menuShouldScrollIntoView: !0,
      backspaceRemovesValue: m,
      "aria-errormessage": ue,
      "aria-invalid": !!i,
      "aria-labelledby": ae,
      hideSelectedOptions: !1,
      shouldRenderCustomOptions: w || !1
    }),
    [
      _,
      N,
      b,
      X,
      n,
      se,
      h,
      ue,
      i,
      ae,
      m,
      w
    ]
  );
  return /* @__PURE__ */ v.jsxs("div", { className: `flex column left top dc__gap-4 ${D ? "w-100" : ""}`, children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex column left top dc__gap-6 w-100", children: [
      r && /* @__PURE__ */ v.jsx(
        "label",
        {
          className: "fs-13 lh-20 cn-7 fw-4 dc__block mb-0",
          htmlFor: N,
          "data-testid": `label-${N}`,
          id: ae,
          children: typeof r == "string" ? /* @__PURE__ */ v.jsxs("span", { className: `flex left ${I ? "dc__required-field" : ""}`, children: [
            /* @__PURE__ */ v.jsx("span", { className: "dc__truncate", children: r }),
            I && /* @__PURE__ */ v.jsx("span", { children: " " })
          ] }) : r
        }
      ),
      /* @__PURE__ */ v.jsx(lc, { condition: A && !!a, wrap: Se, children: /* @__PURE__ */ v.jsx("div", { className: "w-100", children: m ? /* @__PURE__ */ v.jsx(
        b0t,
        {
          ...k,
          ...te,
          isMulti: !0,
          ref: S,
          components: {
            IndicatorSeparator: null,
            LoadingIndicator: ele,
            DropdownIndicator: Jae,
            Control: oe,
            Option: B,
            MenuList: tle,
            ClearIndicator: $ae,
            ValueContainer: re,
            MultiValueLabel: ee,
            MultiValueRemove: I0t,
            GroupHeading: j,
            NoOptionsMessage: he
          },
          closeMenuOnSelect: !1,
          allowCreateWhileLoading: !1,
          isValidNewOption: le,
          createOptionPosition: "first",
          onCreateOption: ge,
          renderMenuListFooter: !d && L
        }
      ) : /* @__PURE__ */ v.jsx(
        Ba,
        {
          ...k,
          ...te,
          ref: S,
          components: {
            IndicatorSeparator: null,
            LoadingIndicator: ele,
            DropdownIndicator: Jae,
            Control: oe,
            Option: B,
            MenuList: tle,
            ClearIndicator: $ae,
            ValueContainer: re,
            NoOptionsMessage: he
          },
          renderMenuListFooter: !d && L
        }
      ) }) })
    ] }),
    i && /* @__PURE__ */ v.jsxs("div", { className: "flex left dc__gap-4 cr-5 fs-11 lh-16 fw-4", id: ue, children: [
      /* @__PURE__ */ v.jsx(rc, { className: "icon-dim-16 p-1 form__icon--error dc__no-shrink dc__align-self-start" }),
      /* @__PURE__ */ v.jsx("span", { className: "dc__ellipsis-right__2nd-line", children: i })
    ] }),
    t && /* @__PURE__ */ v.jsxs("div", { className: "flex left dc__gap-4 fs-11 lh-16 cn-7", children: [
      /* @__PURE__ */ v.jsx(J2e, { className: "icon-dim-16 dc__no-shrink dc__align-self-start" }),
      /* @__PURE__ */ v.jsx("span", { className: "dc__ellipsis-right__2nd-line", children: t })
    ] })
  ] });
}, $2e = k0t, T0t = ({
  appliedFilterOptions: i,
  handleApplyFilter: e,
  options: t,
  ...n
}) => {
  const [r, s] = Oe(!1), [o, a] = Oe(
    structuredClone(i ?? [])
  ), l = i?.length ?? 0;
  $e(() => {
    a(i ?? []);
  }, [i]);
  const c = Mn(
    () => l ? /* @__PURE__ */ v.jsx(Pde, { className: "p-2" }) : /* @__PURE__ */ v.jsx(Nde, { className: "p-2" }),
    [l]
  ), d = () => {
    s(!0);
  }, u = () => {
    s(!1);
  }, h = (p) => {
    a(structuredClone(p));
  }, f = () => {
    u(), a(structuredClone(i ?? []));
  }, g = () => {
    const p = () => {
      e(o), u();
    };
    return /* @__PURE__ */ v.jsx("div", { className: "p-8 dc__border-top-n1", children: /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        className: "dc__unset-button-styles w-100 br-4 h-28 flex bcb-5 cn-0 fw-6 lh-28 fs-12 h-28 br-4 pt-5 pr-12 pb-5 pl-12",
        onClick: p,
        "aria-label": "Apply filters",
        children: "Apply"
      }
    ) });
  };
  return /* @__PURE__ */ v.jsx("div", { className: "dc__mxw-250", children: /* @__PURE__ */ v.jsx(
    $2e,
    {
      ...n,
      options: t,
      value: o,
      isMulti: !0,
      menuIsOpen: r,
      onMenuOpen: d,
      onMenuClose: f,
      onChange: h,
      renderMenuListFooter: g,
      controlShouldRenderValue: !1,
      showSelectedOptionsCount: !0,
      isSearchable: !0,
      isClearable: !1,
      customSelectedOptionsCount: l,
      icon: c
    }
  ) });
}, HSt = T0t, N0t = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M9.20711 14.5429L13.0429 10.7071C13.4334 10.3166 13.4334 9.68342 13.0429 9.29289L9.20711 5.45711C8.57714 4.82714 7.5 5.27331 7.5 6.16421L7.5 13.8358C7.5 14.7267 8.57714 15.1729 9.20711 14.5429Z", fill: "#3B444C" })), eCe = ({ expand: i, children: e }) => (
  // TODO: removed animation because of miscalculations (broken with auto editor height)
  /* @__PURE__ */ v.jsx("div", { children: i ? e : null })
), nle = (i) => (e) => /* @__PURE__ */ v.jsx(wn, { ...i, className: `default-tt ${i?.className || ""}`, children: /* @__PURE__ */ v.jsx("div", { className: "flex dc__align-self-start", children: e }) }), P0t = ({ config: i, onCollapseBtnClick: e }) => {
  const { pathname: t } = E0();
  return /* @__PURE__ */ v.jsx("div", { className: "mw-none bcn-0", children: i.map(({ id: n, header: r, headerIconConfig: s, items: o, noItemsText: a, isExpanded: l }) => /* @__PURE__ */ v.jsxs(qh, { children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4 py-6 px-8 br-4 dc__hover-n50", children: [
      /* @__PURE__ */ v.jsxs(
        "button",
        {
          type: "button",
          className: "dc__unset-button-styles mw-none flexbox dc__align-items-center flex-grow-1 p-0 cn-9 fs-13 lh-1-5 fw-6 dc__gap-4",
          onClick: (c) => e(n, c),
          children: [
            /* @__PURE__ */ v.jsx(
              N0t,
              {
                className: "icon-dim-20 fcn-6 dc__no-shrink cursor rotate",
                style: { "--rotateBy": l ? "90deg" : "0deg" }
              }
            ),
            /* @__PURE__ */ v.jsx("span", { className: "flex-grow-1 dc__align-left dc__truncate", children: r })
          ]
        }
      ),
      s && /* @__PURE__ */ v.jsx(
        lc,
        {
          condition: !!s.tooltipProps,
          wrap: nle(s.tooltipProps),
          children: /* @__PURE__ */ v.jsx(
            "button",
            {
              ...s.btnProps,
              type: "button",
              className: `dc__unset-button-styles dc__no-shrink cursor br-4 bcn-0 flex ${s.btnProps?.className || ""}`,
              children: /* @__PURE__ */ v.jsx(
                s.Icon,
                {
                  ...s.props,
                  className: `icon-dim-20 ${s.props?.className || ""}`
                }
              )
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(eCe, { expand: l, children: /* @__PURE__ */ v.jsx("div", { className: "collapsible ml-18 pl-4 dc__border-left", children: o.length ? o.map(({ title: c, href: d, iconConfig: u, subtitle: h, onClick: f }) => /* @__PURE__ */ v.jsxs(
      uo,
      {
        to: d,
        className: "collapsible__item flexbox dc__align-items-center dc__gap-8 dc__no-decor br-4 py-6 px-8 cursor",
        onClick: (g) => {
          d === t && g.preventDefault(), f?.(g);
        },
        children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col flex-grow-1 mw-none", children: [
            /* @__PURE__ */ v.jsx("span", { className: "collapsible__item__title dc__truncate fs-13 lh-20", children: c }),
            h && /* @__PURE__ */ v.jsx("span", { className: "dc__truncate fw-4 lh-1-5 cn-7", children: h })
          ] }),
          u && /* @__PURE__ */ v.jsx(
            lc,
            {
              condition: !!u.tooltipProps,
              wrap: nle(u.tooltipProps),
              children: /* @__PURE__ */ v.jsx(
                u.Icon,
                {
                  ...u.props,
                  className: `icon-dim-20 dc__no-shrink cursor ${u.props?.className || ""}`
                }
              )
            }
          )
        ]
      },
      c
    )) : /* @__PURE__ */ v.jsx("div", { className: "collapsible__item flexbox dc__gap-8 dc__no-decor no-hover br-4 py-6 px-8", children: /* @__PURE__ */ v.jsx("span", { className: "collapsible__item__title dc__truncate fs-13 lh-20 cn-5", children: a || "No items found." }) }) }) })
  ] }, n)) });
}, ile = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("g", { id: "Icon/ic-diff-file-updated" }, /* @__PURE__ */ G.createElement("rect", { id: "Rectangle 15", x: 2.4165, y: 2.41663, width: 15.1667, height: 15.1667, rx: 1.25, stroke: "#C58D36", strokeWidth: 1.5 }), /* @__PURE__ */ G.createElement("circle", { id: "Ellipse 3", cx: 9.99984, cy: 9.99996, r: 3.33333, fill: "#C58D36" }))), O0t = ({ width: i }) => /* @__PURE__ */ v.jsx("div", { className: `p-8 h-32 w-${i}`, children: /* @__PURE__ */ v.jsx("div", { className: "shimmer-loading w-100 h-100" }) }), M0t = ({
  isLoading: i,
  collapsibleNavList: e,
  navList: t,
  goBackURL: n,
  navHeading: r,
  navHelpText: s
}) => {
  const [o, a] = Oe({});
  $e(() => {
    a(e.reduce((f, g) => ({ ...f, [g.id]: !!g.items.length }), {}));
  }, [e]);
  const l = e.map(({ items: f, ...g }) => ({
    ...g,
    isExpanded: o[g.id],
    items: f.map(({ hasDiff: p, ...m }) => ({
      ...m,
      ...p ? {
        iconConfig: {
          Icon: ile,
          props: { className: "icon-dim-16 dc__no-shrink" },
          tooltipProps: { content: "File has difference", arrow: !1, placement: "right" }
        }
      } : {}
    }))
  })), c = (f) => {
    a((g) => ({ ...g, [f]: !g[f] }));
  }, d = () => /* @__PURE__ */ v.jsxs("div", { className: "p-12 flexbox dc__align-items-center dc__gap-8 dc__border-bottom-n1", children: [
    n && /* @__PURE__ */ v.jsx(D0, { to: n, children: /* @__PURE__ */ v.jsx("span", { className: "dc__border br-4 p-1 flex bcn-50", children: /* @__PURE__ */ v.jsx(Il, { className: "icon-dim-16 fcn-6" }) }) }),
    /* @__PURE__ */ v.jsx("span", { className: "fs-13 lh-20 fw-6 cn-9 dc__truncate", children: r })
  ] }), u = () => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    t.map(({ title: f, href: g, onClick: p, hasDiff: m }) => /* @__PURE__ */ v.jsxs(
      uo,
      {
        "data-testid": "env-deployment-template",
        className: "dc__nav-item cursor dc__gap-8 fs-13 lh-32 cn-7 w-100 br-4 px-8 flexbox dc__align-items-center dc__content-space dc__no-decor",
        to: g,
        onClick: p,
        children: [
          /* @__PURE__ */ v.jsx("span", { className: "dc__truncate", children: f }),
          m && /* @__PURE__ */ v.jsx(wn, { className: "default-tt", content: "File has difference", arrow: !1, placement: "right", children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(ile, { className: "icon-dim-20 dc__no-shrink" }) }) })
        ]
      },
      f
    )),
    /* @__PURE__ */ v.jsx(P0t, { config: l, onCollapseBtnClick: c }),
    s && /* @__PURE__ */ v.jsxs("div", { className: "mt-8 py-6 px-8 flexbox dc__align-items-center dc__gap-8", children: [
      /* @__PURE__ */ v.jsx("span", { className: "flex p-2 dc__align-self-start", children: /* @__PURE__ */ v.jsx(VA, { className: "icon-dim-16 fcn-6" }) }),
      /* @__PURE__ */ v.jsx("p", { className: "m-0 fs-12 lh-1-5 cn-9", children: s })
    ] })
  ] }), h = () => ["90", "70", "50"].map((f) => /* @__PURE__ */ v.jsx(O0t, { width: f }, f));
  return /* @__PURE__ */ v.jsxs("div", { className: "bcn-0 dc__border-right", children: [
    d(),
    /* @__PURE__ */ v.jsx("div", { className: "mw-none p-8", children: i ? h() : u() })
  ] });
}, tCe = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M4.125 8.5L6 10.75L7.875 8.5M4.125 3.5L6 1.25L7.875 3.5", stroke: "#3B444C", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), R0t = tS(
  ({ hasDiff: i, children: e, title: t, id: n, isExpanded: r, onClick: s, onTransitionEnd: o }, a) => /* @__PURE__ */ v.jsxs("div", { ref: a, id: n, className: "dc__border br-4 deployment-config-diff__accordion", children: [
    /* @__PURE__ */ v.jsxs(
      "button",
      {
        type: "button",
        className: "dc__unset-button-styles px-16 py-10 flexbox dc__align-items-center dc__gap-8 w-100 br-4 bcn-50 dc__position-sticky dc__top-0 dc__zi-10",
        "aria-label": "expand-collapse-btn",
        onClick: s,
        children: [
          /* @__PURE__ */ v.jsx(
            pS,
            {
              className: "icon-dim-16 fsn-6 rotate",
              style: { "--rotateBy": r ? "360deg" : "270deg" }
            }
          ),
          /* @__PURE__ */ v.jsx("p", { className: "m-0 cn-9 fs-13 lh-20", children: t }),
          /* @__PURE__ */ v.jsx(
            "p",
            {
              className: `m-0 fs-13 lh-20 fw-6 ${i ? "cy-7" : "cg-7"}`,
              children: `${i ? "Has" : "No"} difference`
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ v.jsx(eCe, { expand: r, onTransitionEnd: o, children: e })
  ] })
), F0t = ({
  isLoading: i,
  headerText: e = "Compare With",
  configList: t = [],
  selectorsConfig: n,
  sortingConfig: r,
  scrollIntoViewId: s
}) => {
  const [o, a] = Oe({}), l = (f) => () => {
    a({
      ...o,
      [f]: !o[f]
    });
  }, c = (f) => (g) => {
    g.target === g.currentTarget && s === f && document.querySelector(`#${s}`)?.scrollIntoView({ block: "start" });
  };
  $e(() => {
    i || a(
      t.reduce(
        (f, g) => ({ ...f, [g.id]: s === g.id || g.hasDiff }),
        {}
      )
    );
  }, [i]), $e(() => {
    s && a((f) => ({ ...f, [s]: !0 }));
  }, [s]);
  const d = (f) => f.map((g, p) => {
    if (g.type === "string")
      return /* @__PURE__ */ v.jsxs(qh, { children: [
        typeof g.text == "string" ? /* @__PURE__ */ v.jsx("p", { className: "m-0 cn-9 fs-13 lh-20 fw-6", children: g.text }) : g.text,
        p !== f.length - 1 && /* @__PURE__ */ v.jsx("span", { className: "cn-9 fs-13 lh-20", children: "/" })
      ] }, g.id);
    const { selectPickerProps: m } = g;
    return /* @__PURE__ */ v.jsxs(qh, { children: [
      /* @__PURE__ */ v.jsx("div", { className: "dc__mxw-300", children: /* @__PURE__ */ v.jsx(
        $2e,
        {
          ...m,
          isDisabled: i || m?.isDisabled
        }
      ) }),
      p !== f.length - 1 && /* @__PURE__ */ v.jsx("span", { className: "cn-9 fs-13 lh-20", children: "/" })
    ] }, g.id);
  }), u = () => {
    if (r) {
      const { handleSorting: f, sortBy: g, sortOrder: p } = r;
      return /* @__PURE__ */ v.jsx("div", { className: "dc__border-left p-12 h-100", children: /* @__PURE__ */ v.jsxs(
        "button",
        {
          type: "button",
          className: `dc__unset-button-styles flexbox dc__align-items-center dc__gap-6 ${i ? "dc__disabled" : ""}`,
          onClick: f,
          disabled: i,
          children: [
            g ? /* @__PURE__ */ v.jsx(
              kq,
              {
                className: "fcn-7 rotate",
                style: {
                  "--rotateBy": p === Xi.ASC ? "0deg" : "180deg"
                }
              }
            ) : /* @__PURE__ */ v.jsx(tCe, { className: "icon-dim-12 mw-12 scn-7" }),
            /* @__PURE__ */ v.jsx("span", { className: "cn-7 fs-13 lh-20 fw-6", children: "Sort keys" })
          ]
        }
      ) });
    }
    return null;
  }, h = () => t.map(({ id: f, isDeploymentTemplate: g, primaryConfig: p, secondaryConfig: m, title: _, hasDiff: b }) => {
    const { heading: w, list: y } = p, { heading: S, list: x } = m;
    return /* @__PURE__ */ v.jsx(
      R0t,
      {
        id: f,
        title: _,
        isExpanded: o[f],
        hasDiff: b,
        onClick: l(f),
        onTransitionEnd: c(f),
        children: g ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          /* @__PURE__ */ v.jsxs("div", { className: "bcn-1 deployment-diff__upper dc__border-top", children: [
            /* @__PURE__ */ v.jsx("div", { className: "px-12 py-6 dc__border-right", children: w }),
            /* @__PURE__ */ v.jsx("div", { className: "px-12 py-6", children: S })
          ] }),
          /* @__PURE__ */ v.jsx(
            e_e,
            {
              diffView: !0,
              defaultValue: y.codeEditorValue.value,
              value: x.codeEditorValue.value,
              mode: Bm.YAML,
              disableSearch: !0,
              adjustEditorHeightToContent: !0,
              noParsing: !0,
              readOnly: !0
            },
            r?.sortOrder
          )
        ] }) : /* @__PURE__ */ v.jsxs("div", { className: "p-16", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "bcn-1 deployment-diff__upper dc__top-radius-4 dc__border-right dc__border-left dc__border-top", children: [
            /* @__PURE__ */ v.jsx("div", { className: "px-12 py-6 dc__border-right", children: w }),
            /* @__PURE__ */ v.jsx("div", { className: "px-12 py-6", children: S })
          ] }),
          /* @__PURE__ */ v.jsx(
            t_e,
            {
              baseTemplateConfiguration: x,
              currentConfiguration: y,
              previousConfigAvailable: !0,
              rootClassName: "m-0 dc__no-top-radius dc__no-top-border",
              comparisonBodyClassName: "deployment-config-diff__main-content__comparison",
              sortOrder: r?.sortOrder
            }
          )
        ] })
      },
      `${f}-${_}`
    );
  });
  return /* @__PURE__ */ v.jsxs("div", { className: "bcn-0 deployment-config-diff__main-top", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "dc__border-bottom-n1 flexbox dc__align-items-center dc__position-sticky dc__top-0 bcn-0 w-100 dc__zi-11", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center p-12 dc__gap-8 deployment-config-diff__main-top__header", children: [
        /* @__PURE__ */ v.jsx("p", { className: "m-0 cn-9 fs-13 lh-20", children: e }),
        d(n.primaryConfig)
      ] }),
      /* @__PURE__ */ v.jsxs("div", { className: "dc__border-left flexbox dc__align-items-center deployment-config-diff__main-top__header", children: [
        /* @__PURE__ */ v.jsx("div", { className: "flex-grow-1 flexbox dc__align-items-center dc__gap-8 p-12", children: d(n.secondaryConfig) }),
        u()
      ] })
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: "deployment-config-diff__main-content", children: i ? /* @__PURE__ */ v.jsx(Yr, { fullHeight: !0, size: 48 }) : /* @__PURE__ */ v.jsx("div", { className: "flexbox-col dc__gap-12 p-12", children: h() }) })
  ] });
}, WSt = ({
  isLoading: i,
  configList: e = [],
  collapsibleNavList: t = [],
  navList: n = [],
  goBackURL: r,
  navHeading: s,
  navHelpText: o,
  ...a
}) => /* @__PURE__ */ v.jsxs("div", { className: "deployment-config-diff", children: [
  /* @__PURE__ */ v.jsx(
    M0t,
    {
      isLoading: i,
      collapsibleNavList: t,
      navList: n,
      goBackURL: r,
      navHeading: s,
      navHelpText: o
    }
  ),
  /* @__PURE__ */ v.jsx(F0t, { isLoading: i, configList: e, ...a })
] }), B0t = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M2.66675 14.6667H13.3334", stroke: "#664BEE", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("rect", { x: 2.66675, y: 8.66675, width: 10.6667, height: 3.33333, rx: 1, stroke: "#664BEE", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M5.88853 3.7765C5.6041 2.52497 6.55536 1.33325 7.8388 1.33325H8.16104C9.44448 1.33325 10.3957 2.52497 10.1113 3.77649L8.99992 8.66659H6.99992L5.88853 3.7765Z", stroke: "#664BEE", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
var V0t = /* @__PURE__ */ ((i) => (i.PUBLISHED_ONLY = "PublishedOnly", i.DRAFT_ONLY = "DraftOnly", i.PUBLISHED_WITH_DRAFT = "PublishedWithDraft", i.PREVIOUS_DEPLOYMENTS = "PreviousDeployments", i.DEFAULT_VERSION = "DefaultVersion", i))(V0t || {}), gu = /* @__PURE__ */ ((i) => (i.ConfigMap = "ConfigMap", i.Secret = "Secret", i.DeploymentTemplate = "Deployment Template", i))(gu || {}), xW = /* @__PURE__ */ ((i) => (i[i.DefaultVersions = 1] = "DefaultVersions", i[i.PublishedOnEnvironments = 2] = "PublishedOnEnvironments", i[i.DeployedOnSelfEnvironment = 3] = "DeployedOnSelfEnvironment", i[i.DeployedOnOtherEnvironment = 4] = "DeployedOnOtherEnvironment", i))(xW || {}), uC = /* @__PURE__ */ ((i) => (i[i.Init = 1] = "Init", i[i.Discarded = 2] = "Discarded", i[i.Published = 3] = "Published", i[i.AwaitApproval = 4] = "AwaitApproval", i))(uC || {}), fh = /* @__PURE__ */ ((i) => (i.ConfigMap = "configmap", i.Secret = "secrets", i.DeploymentTemplate = "deployment-template", i))(fh || {});
const rle = (i) => {
  if (i?.draftMetadata) {
    const e = JSON.parse(i.draftMetadata.data);
    return {
      ...i.draftMetadata.resourceName ? { name: i.draftMetadata.resourceName } : {},
      ...e.configData ? e.configData[0] : { data: e },
      draftMetadata: i.draftMetadata
    };
  }
  return i;
}, H0t = (i, e) => {
  const t = /* @__PURE__ */ new Map(), n = i.map(rle).sort((s, o) => Qs(s.name, o.name)), r = e.map(rle).sort((s, o) => Qs(s.name, o.name));
  return n.forEach((s) => t.set(s.name, [s, null])), r.forEach((s) => {
    const o = s.name;
    t.has(o) ? t.set(o, [t.get(o)[0], s]) : t.set(o, [null, s]);
  }), Array.from(t.values());
}, sle = (i, e) => {
  if (!i)
    return;
  const t = ["secretData", "esoSecretData", "defaultSecretData", "defaultESOSecretData"];
  if (e === gu.Secret) {
    const s = t.find((o) => Object.keys(i?.[o] ?? {}).length > 0);
    if (s)
      return i[s];
  }
  const r = ["data", "defaultData"].find((s) => Object.keys(i?.[s] ?? {}).length > 0);
  return i[r];
}, W0t = (i, e, t = !1, n = !1) => {
  const r = Object.keys(i).reduce((l, c) => (e[c] && i[c] === e[c] && (l[c] = !0), l), {}), s = (l, c, d = !1) => c ? l : Object.keys(l).reduce((u, h) => (d ? u[h] = r[h] ? "********" : "************" : u[h] = "********", u), {}), o = s(i, t, !0), a = s(e, n);
  return {
    compareToObfuscatedData: Object.keys(o).length ? o : void 0,
    compareWithObfuscatedData: Object.keys(a).length ? a : void 0
  };
}, j0t = (i, e, t, n, r) => {
  const s = sle(i, t), o = sle(e, t);
  let a, l;
  if (t === gu.Secret) {
    const { compareToObfuscatedData: c, compareWithObfuscatedData: d } = W0t(
      s ?? {},
      o ?? {},
      n,
      r
    );
    a = {
      displayName: "data",
      value: JSON.stringify(c) || ""
    }, l = {
      displayName: "data",
      value: JSON.stringify(d) || ""
    };
  } else
    a = {
      displayName: "data",
      value: JSON.stringify(s) || ""
    }, l = {
      displayName: "data",
      value: JSON.stringify(o) || ""
    };
  return { compareToCodeEditorData: a, compareWithCodeEditorData: l };
}, z0t = (i, e, t, n, r) => {
  const { compareToCodeEditorData: s, compareWithCodeEditorData: o } = j0t(
    i,
    e,
    t,
    n,
    r
  ), a = t === gu.Secret ? Xo.SECRET.VALUE : Xo.CONFIGMAP.VALUE, l = my(
    { ...i || {}, codeEditorValue: s },
    a,
    t === gu.Secret && !n
  ), c = my(
    { ...e || {}, codeEditorValue: o },
    a,
    t === gu.Secret && !r
  ), d = o.value !== s.value;
  return {
    compareToDiff: l,
    compareWithDiff: c,
    hasDiff: d
  };
}, ole = (i, e) => {
  const t = JSON.parse(i?.deploymentDraftData?.configData[0].draftMetadata.data || null), n = t?.envOverrideValues || t?.valuesOverride || t?.defaultAppOverride || i?.data || null, r = {
    displayName: "data",
    value: n ? iA(n, {
      sortMapEntries: (o, a) => Y8(o, a, e)
    }) ?? "" : ""
  };
  return my(
    { codeEditorValue: r },
    Xo.DEPLOYMENT_TEMPLATE.VALUE
  );
}, eA = (i, e) => {
  let t = !1, n = !1, r = !1;
  if (!i)
    t = !0;
  else if (e) {
    const s = i;
    s.deploymentDraftData?.configData[0].draftMetadata.draftState === uC.Init ? n = !0 : s.deploymentDraftData?.configData[0].draftMetadata.draftState === uC.AwaitApproval && (r = !0);
  } else {
    const s = i;
    s.draftMetadata?.draftState === uC.Init ? n = !0 : s.draftMetadata?.draftState === uC.AwaitApproval && (r = !0);
  }
  return t ? /* @__PURE__ */ v.jsx("span", { className: "fs-12 fw-6 cn-9", children: "Does not exist" }) : n ? /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 ", children: [
    /* @__PURE__ */ v.jsx(bj, { className: "icon-dim-16 scr-5" }),
    /* @__PURE__ */ v.jsx("span", { className: "fs-12 fw-6 cr-5", children: "Draft" })
  ] }) : r ? /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 ", children: [
    /* @__PURE__ */ v.jsx(B0t, { className: "icon-dim-16" }),
    /* @__PURE__ */ v.jsx("span", { className: "fs-12 fw-6 cv-5", children: "Approval pending" })
  ] }) : /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 ", children: [
    /* @__PURE__ */ v.jsx(BA, { className: "scn-9 icon-dim-16" }),
    /* @__PURE__ */ v.jsx("span", { className: "fs-12 fw-6 cn-9", children: "Published" })
  ] });
}, ale = (i, e, t, n, r) => H0t(
  i?.data.configData || [],
  e?.data.configData || []
).map(([a, l]) => {
  const { compareToDiff: c, compareWithDiff: d, hasDiff: u } = z0t(
    a,
    l,
    t,
    n,
    r
  );
  return {
    id: `${t === gu.ConfigMap ? fh.ConfigMap : fh.Secret}-${a?.name || l?.name}`,
    title: `${t === gu.ConfigMap ? "ConfigMap" : "Secret"} / ${a?.name || l?.name}`,
    name: a?.name || l?.name,
    primaryConfig: {
      heading: eA(l),
      list: d
    },
    secondaryConfig: {
      heading: eA(a),
      list: c
    },
    hasDiff: u
  };
}), jSt = (i, e, t, n) => {
  const r = ole(i.deploymentTemplate, n), s = ole(e.deploymentTemplate, n), o = {
    id: fh.DeploymentTemplate,
    title: "Deployment Template",
    primaryConfig: {
      heading: eA(e.deploymentTemplate, !0),
      list: s
    },
    secondaryConfig: {
      heading: eA(i.deploymentTemplate, !0),
      list: r
    },
    hasDiff: r.codeEditorValue.value !== s.codeEditorValue.value,
    isDeploymentTemplate: !0
  }, a = ale(
    i.configMapData,
    e.configMapData,
    gu.ConfigMap,
    i.isAppAdmin,
    e.isAppAdmin
  ), l = ale(
    i.secretsData,
    e.secretsData,
    gu.Secret,
    i.isAppAdmin,
    e.isAppAdmin
  ), c = [o, ...a, ...l], d = [
    {
      title: o.title,
      hasDiff: o.hasDiff,
      href: t(fh.DeploymentTemplate, null),
      onClick: () => {
        document.querySelector(`#${o.id}`)?.scrollIntoView({ block: "start" });
      }
    }
  ], u = [
    {
      header: "ConfigMaps",
      id: fh.ConfigMap,
      items: a.map(({ name: h, hasDiff: f, id: g }) => ({
        title: h,
        hasDiff: f,
        href: t(fh.ConfigMap, h),
        onClick: () => {
          document.querySelector(`#${g}`)?.scrollIntoView({ block: "start" });
        }
      })),
      noItemsText: "No configmaps"
    },
    {
      header: "Secrets",
      id: fh.Secret,
      items: l.map(({ name: h, hasDiff: f, id: g }) => ({
        title: h,
        hasDiff: f,
        href: t(fh.Secret, h),
        onClick: () => {
          document.querySelector(`#${g}`)?.scrollIntoView({ block: "start" });
        }
      })),
      noItemsText: "No secrets"
    }
  ];
  return {
    configList: c,
    collapsibleNavList: u,
    navList: d
  };
}, zSt = (i) => i.reduce(
  (e, t) => ({
    ...e,
    ...t.type === xW.DefaultVersions && t.chartType === "Deployment" ? {
      defaultVersions: [...e.defaultVersions, t]
    } : e.defaultVersions,
    ...t.type === xW.DeployedOnSelfEnvironment ? {
      previousDeployments: [...e.previousDeployments, t]
    } : e.previousDeployments
  }),
  {
    defaultVersions: [],
    previousDeployments: []
  }
), U0t = ({
  hideTopPadding: i,
  alignActiveBorderWithContainer: e
}) => ({
  [Mi.medium]: {
    tabClassName: `fs-12 ${i ? "" : "pt-6"} ${e ? "pb-5" : "pb-6"}`,
    iconClassName: "icon-dim-14",
    badgeClassName: "fs-11 lh-18 tab-group__tab__badge--medium"
  },
  [Mi.large]: {
    tabClassName: `fs-13 ${i ? "" : "pt-8"} ${e ? "pb-7" : "pb-8"}`,
    iconClassName: "icon-dim-16",
    badgeClassName: "fs-12 lh-20"
  }
}), G0t = ({ active: i }) => ({
  fill: `tab-group__tab__icon--fill ${i ? "fcb-5" : "fcn-7"}`,
  stroke: `tab-group__tab__icon--stroke ${i ? "scb-5" : "scn-7"}`
}), q0t = ({
  label: i,
  props: e,
  tabType: t,
  active: n,
  icon: r,
  iconType: s = "fill",
  size: o,
  badge: a = null,
  alignActiveBorderWithContainer: l,
  hideTopPadding: c,
  showIndicator: d,
  showError: u,
  showWarning: h,
  disabled: f
}) => {
  const { tabClassName: g, iconClassName: p, badgeClassName: m } = U0t({
    hideTopPadding: c,
    alignActiveBorderWithContainer: l
  })[o], _ = () => {
    const b = /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      u && /* @__PURE__ */ v.jsx(A0, { className: `${p}` }),
      !u && h && /* @__PURE__ */ v.jsx(rc, { className: `${p} warning-icon-y7` }),
      !u && !h && r && /* @__PURE__ */ v.jsx(r, { className: `${p} ${G0t({ active: n })[s] || ""}` }),
      i,
      a !== null && /* @__PURE__ */ v.jsx("div", { className: `tab-group__tab__badge bcn-1 cn-7 fw-6 flex px-4 ${m}`, children: a }),
      d && /* @__PURE__ */ v.jsx("span", { className: "tab-group__tab__indicator bcr-5 mt-4 dc__align-self-start" })
    ] });
    switch (t) {
      case "link":
        return /* @__PURE__ */ v.jsx(
          D0,
          {
            className: `${g} dc__no-decor flexbox dc__align-items-center dc__gap-6 ${f ? "cursor-not-allowed" : ""}`,
            "aria-disabled": f,
            ...e,
            children: b
          }
        );
      case "navLink":
        return /* @__PURE__ */ v.jsx(
          uo,
          {
            className: `${g} dc__no-decor tab-group__tab__nav-link flexbox dc__align-items-center dc__gap-6 ${f ? "cursor-not-allowed" : ""}`,
            "aria-disabled": f,
            ...e,
            children: b
          }
        );
      default:
        return /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            className: `dc__unset-button-styles ${g} flexbox dc__align-items-center dc__gap-6 ${f ? "cursor-not-allowed" : ""}`,
            disabled: f,
            ...e,
            children: b
          }
        );
    }
  };
  return /* @__PURE__ */ v.jsx(
    "li",
    {
      className: `tab-group__tab cursor lh-20 ${n ? "tab-group__tab--active cb-5 fw-6" : "cn-9 fw-4"} ${l ? "tab-group__tab--align-active-border" : ""}`,
      children: _()
    }
  );
}, USt = ({
  tabs: i = [],
  size: e = Mi.large,
  rightComponent: t,
  alignActiveBorderWithContainer: n,
  hideTopPadding: r
}) => /* @__PURE__ */ v.jsxs("div", { className: "flexbox  dc__align-items-center dc__content-space", children: [
  /* @__PURE__ */ v.jsx(
    "ul",
    {
      role: "tablist",
      className: `tab-group flexbox dc__align-items-center p-0 m-0 ${e === Mi.large ? "dc__gap-16" : "dc__gap-12"}`,
      children: i.map(({ id: s, ...o }) => /* @__PURE__ */ v.jsx(
        q0t,
        {
          id: s,
          size: e,
          alignActiveBorderWithContainer: n,
          hideTopPadding: r,
          ...o
        },
        s
      ))
    }
  ),
  t || null
] }), Ck = ({
  name: i,
  value: e,
  error: t,
  onChange: n,
  onFocus: r = (N) => {
  },
  label: s,
  type: o = "text",
  disabled: a = !1,
  labelClassName: l = "",
  placeholder: c = "",
  tabIndex: d = 0,
  dataTestid: u = "",
  isRequiredField: h = !1,
  autoFocus: f = !1,
  rootClassName: g = "",
  autoComplete: p = "off",
  helperText: m = "",
  handleOnBlur: _,
  readOnly: b = !1,
  noTrim: w = !1,
  onKeyPress: y,
  defaultValue: S,
  onKeyDown: x,
  required: D,
  additionalErrorInfo: E,
  inputWrapClassName: L = "",
  inputProps: k = {}
}) => {
  const N = Nt();
  $e(() => {
    setTimeout(() => {
      N.current && f && N.current.focus();
    }, 100);
  }, [f]);
  function I(F) {
    return Array.isArray(F) ? F : [F];
  }
  const A = (F) => {
    w || (F.stopPropagation(), F.target.value = F.target.value?.trim(), n(F)), typeof _ == "function" && _(F);
  }, P = (F) => /* @__PURE__ */ v.jsxs("div", { className: "flex left mt-4 mb-4 dc__gap-4 cr-5 fs-11 lh-16 fw-4", children: [
    /* @__PURE__ */ v.jsx(rc, { className: "icon-dim-16 p-1 form__icon--error dc__align-self-start dc__no-shrink" }),
    /* @__PURE__ */ v.jsx("span", { children: F }),
    F && typeof E == "function" && E()
  ] }, F), O = () => t?.length ? typeof t == "object" ? I(t).map((F) => P(F)) : P(t) : null, K = () => typeof s == "string" ? /* @__PURE__ */ v.jsx("span", { className: `${h ? "dc__required-field" : ""}`, children: s }) : s, W = () => s ? /* @__PURE__ */ v.jsx("label", { className: `form__label ${l}`, "data-testid": `label-${u}`, children: K() }) : null;
  return /* @__PURE__ */ v.jsxs("div", { className: `flex column left top ${L}`, children: [
    W(),
    /* @__PURE__ */ v.jsx(
      "input",
      {
        "data-testid": u,
        type: o,
        name: i,
        autoComplete: p,
        className: `form__input fs-13 lh-20 fw-4 ${g}`,
        onChange: (F) => {
          F.persist(), n(F);
        },
        onBlur: A,
        onFocus: r,
        placeholder: c,
        value: e,
        disabled: a,
        tabIndex: d,
        autoFocus: f,
        readOnly: b,
        onKeyPress: y,
        defaultValue: S,
        onKeyDown: x,
        required: D,
        ...k,
        ref: N
      }
    ),
    O(),
    m && /* @__PURE__ */ v.jsxs("div", { className: "flex left top dc__gap-4 fs-11 lh-16 cn-7 pt-4", children: [
      /* @__PURE__ */ v.jsx(J2e, { className: "icon-dim-16" }),
      /* @__PURE__ */ v.jsx("div", { children: m })
    ] })
  ] });
}, Mo = {
  PROVIDE_A_NUMBER: "Please provide a number",
  LOWERCASE_ALPHANUMERIC: "Only lowercase alphanumeric characters, -, _ or . allowed",
  CAN_NOT_START_END_WITH_SEPARATORS: "Cannot start/end with -, _ or .",
  getMinMaxCharMessage: (i, e) => `Minimum ${i} and maximum ${e} characters allowed`,
  getMaxCharMessage: (i) => `Maximum ${i} characters are allowed`,
  getMinCharMessage: (i) => `Minimum ${i} characters are required`,
  VALID_POSITIVE_NUMBER: "This field should be a valid positive number",
  VALID_POSITIVE_INTEGER: "This field should be a valid positive integer",
  MAX_SAFE_INTEGER: `Maximum allowed value is ${Number.MAX_SAFE_INTEGER}`,
  INVALID_SEMANTIC_VERSION: "Please follow semantic versioning"
}, lle = 350, cle = {
  MAX_LIMIT: 50,
  MIN_LIMIT: 3
}, GSt = (i) => i?.trim() ? { isValid: !0 } : { message: "This field is required", isValid: !1 }, K0t = (i) => /^.{3,50}$/.test(i) ? /^[a-z0-9-._]+$/.test(i) ? /^(?![-._]).*[^-._]$/.test(i) ? {
  isValid: !0
} : {
  isValid: !1,
  message: Mo.CAN_NOT_START_END_WITH_SEPARATORS
} : {
  isValid: !1,
  message: Mo.LOWERCASE_ALPHANUMERIC
} : {
  isValid: !1,
  message: Mo.getMinMaxCharMessage(3, 50)
}, Y0t = (i) => i?.length > lle ? {
  isValid: !1,
  message: Mo.getMaxCharMessage(lle)
} : {
  isValid: !0
}, X0t = (i, e, t) => i?.length < t ? {
  isValid: !1,
  message: Mo.getMinCharMessage(t)
} : i?.length > e ? {
  isValid: !1,
  message: Mo.getMaxCharMessage(e)
} : {
  isValid: !0
}, dle = (i) => {
  if (!i)
    return {
      isValid: !1,
      message: Mo.PROVIDE_A_NUMBER
    };
  if (!/^\d+(\.\d+)?$/.test(i.toString()))
    return {
      isValid: !1,
      message: Mo.VALID_POSITIVE_NUMBER
    };
  const e = Number(i);
  return e > Number.MAX_SAFE_INTEGER ? {
    isValid: !1,
    message: Mo.MAX_SAFE_INTEGER
  } : e <= 0 ? {
    isValid: !1,
    message: Mo.VALID_POSITIVE_NUMBER
  } : {
    isValid: !0
  };
}, Z0t = (i) => {
  if (!i)
    return {
      isValid: !1,
      message: Mo.PROVIDE_A_NUMBER
    };
  if (!/^\d+$/.test(i.toString()))
    return {
      isValid: !1,
      message: Mo.VALID_POSITIVE_INTEGER
    };
  const e = Number(i);
  return e > Number.MAX_SAFE_INTEGER ? {
    isValid: !1,
    message: Mo.MAX_SAFE_INTEGER
  } : e <= 0 ? {
    isValid: !1,
    message: Mo.VALID_POSITIVE_INTEGER
  } : {
    isValid: !0
  };
}, Q0t = (i) => /^data:.*;base64,/.test(i), J0t = (i, e = !0) => {
  try {
    if (!e && Q0t(i))
      throw new Error("Base64 URLs are not allowed");
    new URL(i);
  } catch (t) {
    return {
      isValid: !1,
      message: t.message || "Invalid URL"
    };
  }
  return {
    isValid: !0
  };
}, qSt = (i, e, t) => {
  if (t && !i)
    return {
      isValid: !1,
      message: "This field is required"
    };
  try {
    const { protocol: n } = new URL(i);
    if (n && e.includes(n))
      return {
        isValid: !0
      };
  } catch {
  }
  return {
    isValid: !1,
    message: `Invalid URL/protocol. Supported protocols are: ${e.join(", ")}`
  };
}, $0t = (i) => new Promise((e) => {
  const t = new Image();
  t.src = i, t.onload = () => (t.onload = null, t.onerror = null, e({
    isValid: !0
  })), t.onerror = () => (t.src = "", t.onload = null, t.onerror = null, e({
    isValid: !1,
    message: "Invalid URL"
  }));
}), KSt = (i) => {
  const e = i.reduce(
    (n, r) => n[r] ? (n[r] += 1, n) : (n[r] = 1, n),
    {}
  ), t = Object.keys(e).filter((n) => e[n] > 1);
  return t.length ? {
    isValid: !1,
    message: `Duplicate variable name: ${t.join(", ")}`
  } : {
    isValid: !0
  };
}, YSt = (i) => i ? i.length > 128 ? {
  isValid: !1,
  message: Mo.getMaxCharMessage(128)
} : /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/.test(
  i
) ? {
  isValid: !0
} : {
  isValid: !1,
  message: Mo.INVALID_SEMANTIC_VERSION
} : {
  isValid: !1,
  message: "Please provide a version"
}, XSt = (i) => X0t(i, cle.MAX_LIMIT, cle.MIN_LIMIT), ZSt = (i) => {
  try {
    return i && JSON.parse(i), {
      isValid: !0
    };
  } catch (e) {
    return {
      isValid: !1,
      message: e.message
    };
  }
}, ule = 2 * 1024 * 1024, tA = {
  width: 72,
  height: 72
}, hle = "Please provide image URL to preview", nCe = "edit-image-form-field__figure-container--base-image", e1t = ({ showEditIcon: i, defaultIcon: e }) => /* @__PURE__ */ v.jsx(
  "div",
  {
    className: `flex dc__align-self-start dc__no-shrink br-4 edit-image-form-field__fallback-image p-12 ${i ? nCe : ""}`,
    style: {
      height: tA.height,
      width: tA.width
    },
    children: e
  }
), t1t = ({
  defaultIcon: i,
  errorMessage: e,
  handleError: t,
  url: n,
  handleURLChange: r,
  ariaLabelPrefix: s,
  dataTestIdPrefix: o,
  altText: a
}) => {
  const [l, c] = Oe(n), [d, u] = Oe(!1), [h, f] = Oe(!1), [g, p] = Oe(""), m = () => {
    u(!0);
  }, _ = (L) => {
    c(L);
  }, b = (L) => {
    const k = L ?? l;
    _(k), r(k), t(""), u(!1), f(!1), p("");
  }, w = () => {
    b(n);
  }, y = () => {
    b();
  }, S = (L) => {
    const { value: k } = L.target;
    if (r(k), !k.trim()) {
      t("");
      return;
    }
    p(""), t(J0t(k, !1).message);
  }, x = async () => {
    if (!n) {
      p(hle), In.error(hle);
      return;
    }
    if (e) {
      In.error(e);
      return;
    }
    f(!0);
    try {
      const L = await fetch(n, { mode: "cors" });
      if (!L.ok)
        throw new Error("Invalid network response");
      const k = await L.blob();
      if (k.size > ule)
        throw new Error(`Please add an image smaller than ${ule / (1024 * 1024)} MB`);
      const N = URL.createObjectURL(k), I = await $0t(N);
      if (URL.revokeObjectURL(N), !I.isValid)
        throw new Error(I.message);
      w();
    } catch (L) {
      t(L.message || "Failed to load image"), Is(L);
    } finally {
      f(!1);
    }
  }, D = async (L) => {
    L.key === "Enter" && (L.preventDefault(), await x());
  }, E = (L, k) => /* @__PURE__ */ v.jsx(
    tue,
    {
      imageProps: {
        alt: a,
        src: l,
        height: tA.height,
        width: tA.width,
        className: `br-4 dc__no-shrink ${k || ""}`
      },
      fallbackImage: /* @__PURE__ */ v.jsx(e1t, { defaultIcon: i, showEditIcon: L })
    }
  );
  return d ? /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-20", children: [
    E(!1),
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox-col dc__gap-16 flex-grow-1", children: [
      /* @__PURE__ */ v.jsx("div", { className: "flexbox-col dc__gap-6 w-100 dc__align-start", children: /* @__PURE__ */ v.jsx(
        Ck,
        {
          name: `${s}-url-input`,
          label: "Image URL",
          labelClassName: "m-0 fs-13 fw-4 lh-20 cn-7",
          placeholder: "Enter image url",
          value: n,
          onChange: S,
          error: e || g,
          inputWrapClassName: "w-100",
          dataTestid: `${o}-input`,
          onKeyDown: D,
          autoFocus: !0
        }
      ) }),
      /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-8", children: [
        /* @__PURE__ */ v.jsx(
          RA,
          {
            isLoading: h,
            rootClassName: "cta h-28 flex",
            type: "button",
            disabled: h,
            "data-testid": `${o}-preview`,
            onClick: x,
            children: "Preview"
          }
        ),
        /* @__PURE__ */ v.jsx(
          "button",
          {
            className: "cta cancel h-28 flex",
            "data-testid": `${o}-cancel`,
            type: "button",
            disabled: h,
            onClick: y,
            children: "Cancel"
          }
        )
      ] })
    ] })
  ] }) : /* @__PURE__ */ v.jsxs(
    "button",
    {
      className: "dc__no-background dc__no-border dc__outline-none-imp display-grid edit-image-form-field__figure-container p-0 icon-dim-72 dc__no-shrink",
      type: "button",
      "data-testid": `${o}-button`,
      "aria-label": `${s} image`,
      onClick: m,
      children: [
        E(!0, nCe),
        /* @__PURE__ */ v.jsx("div", { className: "flex p-4 br-4 bcn-0 dc__border edit-image-form-field__figure-container--edit-image-icon dc__zi-1 bcn-0 dc__hover-n50 icon-dim-24", children: /* @__PURE__ */ v.jsx(MA, { className: "dc__no-shrink icon-dim-16" }) })
      ]
    }
  );
}, QSt = t1t, n1t = (i, e) => ({
  ...YK,
  menu: (t) => ({
    ...t,
    width: "200px",
    ...e && { right: 0 }
  }),
  control: (t, n) => ({
    ...YK.control(t, n),
    maxHeight: "36px",
    minHeight: "36px",
    fontSize: "12px",
    paddingLeft: "8px",
    width: i || "150px"
  }),
  container: (t) => ({
    ...t,
    height: "36px",
    width: i || "150px",
    maxHeight: "36px"
  }),
  option: (t, n) => ({
    ...t,
    height: "36px",
    padding: "8px 12px",
    backgroundColor: n.isFocused ? "var(--N100)" : "white",
    color: "var(--N900)",
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    ":active": {
      backgroundColor: "var(--N100)"
    }
  })
}), i1t = (i) => {
  const { selectProps: e, getValue: t, children: n } = i, r = t().length;
  return /* @__PURE__ */ v.jsxs(zi.ValueContainer, { ...i, children: [
    !e.inputValue && (e.menuIsOpen ? /* @__PURE__ */ v.jsx("span", { className: "dc__position-abs cn-5 ml-2", children: e.placeholder }) : /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
      /* @__PURE__ */ v.jsx("div", { className: "fs-13 fw-4 cn-9", children: e.placeholder }),
      r > 0 && /* @__PURE__ */ v.jsx("div", { className: "bcb-5 dc__border-radius-4-imp pl-5 pr-5 cn-0 fs-12 fw-6 lh-18", children: r })
    ] })),
    nd(n[1])
  ] });
}, r1t = (i) => {
  const {
    children: e,
    // @ts-ignore NOTE: handleApplyFilter is passed from FilterButton
    selectProps: { handleApplyFilter: t }
  } = i;
  return /* @__PURE__ */ v.jsxs(zi.MenuList, { ...i, children: [
    e,
    /* @__PURE__ */ v.jsx("div", { className: "p-8 dc__position-sticky dc__bottom-0 dc__border-top-n1 bcn-0", children: /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        className: "dc__unset-button-styles w-100 br-4 h-28 flex bcb-5 cn-0 fw-6 lh-28 fs-12 h-28 br-4 pt-5 pr-12 pb-5 pl-12",
        onClick: t,
        "aria-label": "Apply filters",
        children: "Apply"
      }
    ) })
  ] });
}, s1t = (i) => /* @__PURE__ */ v.jsx(zi.DropdownIndicator, { ...i, children: /* @__PURE__ */ v.jsx(pS, { className: "icon-dim-20 icon-n5" }) }), o1t = ({
  placeholder: i,
  appliedFilters: e,
  options: t,
  disabled: n,
  handleApplyChange: r,
  getFormattedFilterLabelValue: s,
  menuAlignFromRight: o,
  controlWidth: a
}) => {
  const [l, c] = Oe(!1), [d, u] = Oe(
    e.map((m) => ({ value: m, label: s?.(m) || m }))
  );
  $e(() => {
    u(
      e.map((m) => ({
        value: m,
        label: s?.(m) || m
      }))
    );
  }, [e]);
  const h = () => {
    c(!0);
  }, f = () => {
    c(!1);
  }, g = (m) => {
    u([...m]);
  }, p = () => {
    r(Object.values(d).map((m) => m.value)), f();
  };
  return /* @__PURE__ */ v.jsx(
    Ba,
    {
      placeholder: i,
      isMulti: !0,
      isDisabled: n,
      options: t,
      value: d,
      onChange: g,
      closeMenuOnSelect: !1,
      controlShouldRenderValue: !1,
      hideSelectedOptions: !1,
      maxMenuHeight: 300,
      components: {
        MenuList: r1t,
        IndicatorSeparator: null,
        ClearIndicator: null,
        DropdownIndicator: s1t,
        Option: hue,
        ValueContainer: i1t
      },
      styles: n1t(a, o),
      handleApplyFilter: p,
      menuIsOpen: l,
      onMenuOpen: h,
      onMenuClose: f
    }
  );
}, JSt = o1t, a1t = ({
  alwaysShowTippyOnHover: i,
  // NOTE: if alwaysShowTippyOnHover is being passed by user don't apply truncation logic at all
  showOnTruncate: e = i === void 0,
  wordBreak: t = !0,
  children: n,
  ...r
}) => {
  const [s, o] = Oe(!1), a = Wi((l) => {
    l && o(l.scrollWidth > l.clientWidth || l.scrollHeight > l.clientHeight);
  }, []);
  return (!s || !e) && !i ? nd(n, { ...n.props, ref: a }) : /* @__PURE__ */ v.jsx(
    wn,
    {
      arrow: !1,
      placement: "top",
      ...r,
      className: `default-tt ${t ? "dc__word-break-all" : ""} dc__mxw-200-imp ${r.className}`,
      children: nd(n, { ...n.props, ref: a })
    }
  );
}, mx = a1t;
var iCe = /* @__PURE__ */ ((i) => (i.primary = "primary", i.secondary = "secondary", i.borderLess = "border-less", i.text = "text", i))(iCe || {}), rCe = /* @__PURE__ */ ((i) => (i.default = "default", i.negative = "negative", i.positive = "positive", i.warning = "warning", i.neutral = "neutral", i))(rCe || {}), DW = /* @__PURE__ */ ((i) => (i.button = "button", i.link = "link", i))(DW || {});
const l1t = {
  [Mi.xs]: "px-9 py-1 fs-12 lh-20 fw-6 dc__gap-6",
  [Mi.small]: "px-9 py-3 fs-12 lh-20 fw-6 dc__gap-6",
  [Mi.medium]: "px-11 py-5 fs-13 lh-20 fw-6 dc__gap-8",
  [Mi.large]: "px-13 py-7 fs-13 lh-20 fw-6 dc__gap-10",
  [Mi.xl]: "px-15 py-9 fs-14 lh-20 fw-6 dc__gap-12"
}, c1t = {
  [Mi.xs]: "icon-dim-12",
  [Mi.small]: "icon-dim-12",
  [Mi.medium]: "icon-dim-16",
  [Mi.large]: "icon-dim-16",
  [Mi.xl]: "icon-dim-20"
}, d1t = {
  [Mi.xs]: 12,
  [Mi.small]: 12,
  [Mi.medium]: 16,
  [Mi.large]: 16,
  [Mi.xl]: 20
}, u1t = ({
  size: i,
  variant: e,
  style: t,
  isLoading: n
}) => `button button__${e}--${t} ${l1t[i]} ${n ? "button--loading" : ""}`, h1t = ({
  component: i = DW.button,
  linkProps: e,
  buttonProps: t,
  onClick: n,
  ...r
}) => i === DW.link ? /* @__PURE__ */ v.jsx(
  D0,
  {
    ...e,
    ...r,
    className: `${r.className} button__link ${r.disabled ? "dc__disable-click" : ""}`,
    onClick: n
  }
) : /* @__PURE__ */ v.jsx(
  "button",
  {
    ...t,
    ...r,
    type: t?.type || "button",
    onClick: n
  }
), f1t = ({
  dataTestId: i,
  text: e,
  variant: t = iCe.primary,
  size: n = Mi.large,
  style: r = rCe.default,
  startIcon: s = null,
  endIcon: o = null,
  disabled: a = !1,
  isLoading: l = !1,
  showTooltip: c = !1,
  tooltipProps: d = {},
  ...u
}) => {
  const h = a || l, f = `dc__no-shrink flex dc__fill-available-space ${c1t[n]}`;
  return /* @__PURE__ */ v.jsx(mx, { ...d, alwaysShowTippyOnHover: c && !!d?.content, children: /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsxs(
    h1t,
    {
      ...u,
      disabled: h,
      className: `br-4 flex cursor dc__mnw-100 dc__tab-focus dc__position-rel dc__capitalize ${u1t({ size: n, variant: t, style: r, isLoading: l })} ${h ? "dc__disabled" : ""}`,
      "data-testid": i,
      children: [
        s && /* @__PURE__ */ v.jsx("span", { className: f, children: s }),
        /* @__PURE__ */ v.jsx("span", { className: "dc__mxw-150 dc__align-left dc__truncate", children: e }),
        o && /* @__PURE__ */ v.jsx("span", { className: f, children: o }),
        l && /* @__PURE__ */ v.jsx(Yr, { size: d1t[n] })
      ]
    }
  ) }) });
}, $St = f1t, ext = ({ baseUrl: i, kind: e, version: t, suffix: n, queryParams: r }) => vl(`${i}/${e}/${t}${n ? `/${n}` : ""}`, r), txt = ({ kind: i, version: e, queryParams: t, suffix: n }) => vl(`global/policy/${i}/${e}${n ? `/${n}` : ""}`, t), sCe = (i, e, t, n, r) => {
  const s = i.lastIndex;
  Promise.resolve(e[s]()).then((o) => {
    i.results[s] = { status: y3.FULFILLED, value: o };
  }).catch((o) => {
    i.results[s] = { status: y3.REJECTED, reason: o };
  }).finally(() => {
    if (r && i.results[s].status === y3.REJECTED) {
      n(i.results[s].reason);
      return;
    }
    i.completedCalls++, i.lastIndex < e.length ? (sCe(i, e, t, n, r), i.lastIndex++) : i.completedCalls === e.length && t(i.results);
  });
}, g1t = (i, e, t = !1, n = window._env_.API_BATCH_SIZE) => ((!n || n <= 0) && (n = ["http/0.9", "http/1.0", "http/1.1"].indexOf(e) !== -1 ? 5 : 30), new Promise((r, s) => {
  i.length === 0 && r([]);
  const o = {
    lastIndex: 0,
    concurrentCount: n,
    results: i.map(() => null),
    completedCalls: 0
  };
  for (let a = 0; a < o.concurrentCount && a < i.length; a++, o.lastIndex++)
    sCe(o, i, r, s, t);
})), nxt = g1t;
In.configure({
  autoClose: 3e3,
  hideProgressBar: !0,
  pauseOnHover: !0,
  pauseOnFocusLoss: !0,
  closeOnClick: !1,
  newestOnTop: !0,
  toastClassName: "devtron-toast",
  bodyClassName: "devtron-toast__body"
});
function Is(i, e = !0, t = !1) {
  i instanceof Kc && Array.isArray(i.errors) ? i.errors.map(({ userMessage: n, internalMessage: r }) => {
    i.code === 403 && (n === Jr.UNAUTHORIZED || n === Jr.FORBIDDEN) ? t || Tye() : In.error(n || r);
  }) : (i.code !== 403 && i.code !== 408 && lce(i), e && (i.message ? In.error(i.message) : In.error("Some Error Occurred")));
}
const lc = ({ condition: i, wrap: e, children: t }) => i ? e(t) : /* @__PURE__ */ v.jsx(v.Fragment, { children: t });
function p1t(i, e, t, n) {
  let r = e[i], s = t[i];
  return n && (r = r.toLowerCase(), s = s.toLowerCase()), r < s ? -1 : r > s ? 1 : 0;
}
const Cr = (i) => {
  i.stopPropagation();
}, ixt = (i) => {
  i.preventDefault();
};
function Yq(i, e, t = []) {
  const n = Nt(Date.now());
  $e(() => {
    const r = setTimeout(
      () => {
        Date.now() - n.current >= e && (i(), n.current = Date.now());
      },
      e - (Date.now() - n.current)
    );
    return () => {
      clearTimeout(r);
    };
  }, [e, ...t]);
}
const fle = [
  "#FFB900",
  "#D83B01",
  "#B50E0E",
  "#E81123",
  "#B4009E",
  "#5C2D91",
  "#0078D7",
  "#00B4FF",
  "#008272",
  "#107C10"
];
function vx(i) {
  let e = 0;
  for (let t = 0; t < i.length; t++)
    e += i.charCodeAt(t);
  return fle[e % fle.length];
}
const rxt = (i, e = "") => i ? /* @__PURE__ */ v.jsx(
  "span",
  {
    className: `${e} alphabet-icon__initial fs-13 icon-dim-20 flex cn-0 mr-8`,
    style: { backgroundColor: vx(i) },
    children: i[0]
  }
) : null, sxt = (i) => Array.from({ length: i });
function El(...i) {
}
function oCe(i) {
  return !i;
}
const aCe = () => {
  window.location.reload();
}, m1t = () => {
  window.open(TW);
};
function gle(i, e) {
  const t = it.useRef(!0);
  it.useEffect(() => {
    if (!t.current)
      return i();
    t.current = !1;
  }, e);
}
function oxt(i) {
  return i && document.cookie.replace(
    new RegExp(`(?:(?:^|.*;)\\s*${i.replace(/[\-\.\+\*]/g, "\\$&")}\\s*\\=\\s*([^;]*).*$)|^.*$`),
    "$1"
  ) || null;
}
function axt(i, e = {}, t) {
  const [n, r] = Oe(i), [s, o] = Oe(!0), [a, l] = Oe(!1);
  $e(() => {
    o(!0);
  }, []), $e(() => {
    a && o(c(n));
  }, [n, a]);
  const c = Wi(
    (f) => Object.keys(e).some((p) => {
      const m = e[p].required, _ = f[p].value, b = f[p].error;
      return m && !_ || b;
    }),
    [n, e]
  );
  function d(f, g) {
    if (e[f].required && !g)
      return "This is a required field.";
    function p(b, w) {
      return !(w && !b.regex.test(w));
    }
    const m = e[f].validator;
    if (m && typeof m == "object" && !p(m, g))
      return m.error;
    const _ = e[f].validators;
    if (_ && typeof _ == "object" && Array.isArray(_)) {
      const b = [];
      if (_.forEach((w) => {
        p(w, g) || b.push(w.error);
      }), b.length > 0)
        return b;
    }
    return "";
  }
  const u = Wi(
    (f) => {
      l(!0);
      const { name: g, value: p } = f.target, m = d(g, p);
      r((_) => ({
        ..._,
        [g]: { value: p, error: m }
      }));
    },
    [e]
  );
  return { state: n, disable: s, handleOnChange: u, handleOnSubmit: (f) => {
    f.preventDefault();
    const g = Object.keys(e).reduce((p, m) => (p[m] = { ...n[m], error: d(m, n[m].value) }, p), n);
    c(g) ? r({ ...g }) : t(n);
  } };
}
function nA(i, e = !1) {
  let t = "";
  try {
    if (i && i.length && i !== iS) {
      const n = st(i);
      e ? t = n.fromNow() : t = n.format(Wde);
    }
  } catch {
    console.error("Error Parsing Date:", i);
  }
  return t;
}
function lxt() {
  const i = E0(), e = Mn(() => new URLSearchParams(i.search), [i]), t = Array.from(e.entries()).reduce((n, r, s) => (n[r[0]] = r[1], n), {});
  return { queryParams: e, searchParams: t };
}
const cxt = (i, e) => {
  (i.keyCode === 27 || i.key === "Escape") && e();
};
function ple(i, e = 4, t = "json", n = !1) {
  const [r, s] = Oe(""), [o, a] = Oe(""), [l, c] = Oe(null), [d, u] = Oe(""), h = {
    prettyErrors: !0
  };
  return $e(() => {
    if (!n) return;
    let f, g = null, p = null;
    if (t === "json")
      try {
        f = JSON.parse(i), g = null, p = null;
      } catch (m) {
        g = m;
        try {
          f = hC.parse(i, h), g = null, p = null;
        } catch (_) {
          p = _;
        }
      }
    else
      try {
        f = hC.parse(i, h), g = null, p = null;
      } catch (m) {
        p = m;
        try {
          f = JSON.parse(i), g = null, p = null;
        } catch (_) {
          g = _;
        }
      }
    (g || p) && u(t === "json" ? g.message : p.message), f && typeof f == "object" ? (s(JSON.stringify(f, null, e)), a(hC.stringify(f, { indent: 2, lineWidth: 0 })), c(f), u("")) : (c(null), u(g || p ? t === "json" ? g.message : p.message : "cannot parse to valid object"));
  }, [i, e, t, n]), [l, r, o, d];
}
const v1t = ["name", "namespace", "labels", "annotations"];
function mle(i) {
  if (!i)
    return i;
  try {
    const e = JSON.parse(i);
    delete e.status;
    const { metadata: t } = e;
    if (t)
      for (const n in t)
        v1t.includes(n) || delete t[n];
    return JSON.stringify(e);
  } catch {
    return i;
  }
}
const _1t = (i, e = El) => {
  const t = function(n) {
    n.preventDefault(), n.clipboardData.setData("text/plain", i);
  };
  document.addEventListener("copy", t), document.execCommand("copy"), document.removeEventListener("copy", t), e();
};
function b1t(i, e = El) {
  i && (window.isSecureContext && navigator.clipboard ? navigator.clipboard.writeText(i).then(() => {
    e();
  }).catch(() => {
    In.error("Failed to copy to clipboard");
  }) : _1t(i, e));
}
function tf(i, e = [], t = !0, n = { resetOnChange: !0 }) {
  const [r, s] = Oe({
    loading: !0,
    result: null,
    error: null,
    dependencies: e
  }), o = Nt(!0), a = Mn(() => [...e, t], [...e, t]), l = () => {
    async function d() {
      try {
        s((h) => ({
          ...h,
          loading: !0
        }));
        const u = await i();
        o.current && s((h) => ({
          ...h,
          result: u,
          error: null,
          loading: !1
        }));
      } catch (u) {
        o.current && s((h) => ({
          ...h,
          error: u,
          loading: !1
        }));
      }
    }
    return d();
  };
  $e(() => {
    if (!t) {
      s((d) => ({ ...d, loading: !1 }));
      return;
    }
    return s((d) => ({ ...d, dependencies: e })), l(), () => s((d) => ({
      ...d,
      loading: !1,
      error: null,
      ...n.resetOnChange ? { result: null } : {}
    }));
  }, a), $e(() => (o.current = !0, () => {
    o.current = !1;
  }), []);
  const c = (d) => {
    s(typeof d == "function" ? (u) => ({ ...u, result: d(u.result) }) : (u) => ({ ...u, result: d }));
  };
  return [r.loading, r.result, r.error, l, c, r.dependencies];
}
const dxt = (i, e) => i ? nA(i, !0) : e ? "" : "Not deployed", vl = (i, e = {}) => {
  const t = new URLSearchParams();
  Object.keys(e).forEach((r) => {
    Ple.includes(e[r]) || (Array.isArray(e[r]) ? e[r].forEach((s) => {
      t.append(r, s);
    }) : t.set(r, e[r]));
  });
  const n = t.toString();
  return i + (n ? `?${n}` : "");
}, uxt = lce.bind(window), vle = {
  control: (i, e) => ({
    ...i,
    minHeight: "32px",
    boxShadow: "none",
    border: "none",
    cursor: "pointer",
    background: "transparent"
  }),
  indicatorSeparator: (i, e) => ({
    ...i,
    width: 0
  }),
  valueContainer: (i, e) => ({
    ...i,
    padding: "0",
    fontSize: "13px",
    fontWeight: "600"
  }),
  dropdownIndicator: (i, e) => ({
    ...i,
    color: "var(--N400)",
    padding: "0 8px",
    transition: "all .2s ease",
    transform: e.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
  })
}, _le = (i, e) => (
  // Filter chart versions based on selected chart type
  i.filter((t) => t?.chartType === e.value).map((t) => ({
    value: t?.chartVersion,
    label: t?.chartVersion,
    chartRefId: t.chartRefId
  }))
), ble = (i) => typeof i != "object" || !i ? i : Array.isArray(i) ? i.filter((e) => (ble(e), !!e)) : (Object.keys(i).forEach((e) => {
  i[e] = ble(i[e]);
}), i), lCe = (i, e) => {
  typeof i != "object" || typeof e != "object" || !e || Object.keys(e).forEach((t) => {
    if (!i[t]) {
      i[t] = structuredClone(e[t]);
      return;
    }
    lCe(i[t], e[t]);
  });
}, hxt = (i) => {
  const e = {};
  return i.forEach((t) => {
    lCe(e, t);
  }), e;
}, EW = (i, e, t) => {
  if (i === e.length)
    return t;
  const n = e[i], r = Number(n);
  return !Number.isNaN(r) ? [...Array(r).fill(null), EW(i + 1, e, t)] : { [n]: EW(i + 1, e, t) };
}, fxt = (i, e) => {
  const t = i.split("/");
  return t.splice(0, 1), EW(0, t, e);
}, cCe = (i, e) => {
  const t = i.search(e);
  if (t < 0)
    return [];
  const n = i.slice(t + 1);
  return [t, ...cCe(n, e).map((r) => r + t + 1)];
}, gxt = (i, e) => i.flatMap((t) => {
  const n = [t];
  return cCe(t, e).forEach((s) => {
    n.push(t.slice(0, s));
  }), n;
}), pxt = (i) => i.replace(/\//g, ".").replace(/\./, "$."), mxt = (i, e, t = "path") => i.flatMap((n) => li({ path: n, json: e, resultType: t })), vxt = (i, e) => {
  const t = tce(i, e);
  return _A(i, t).newDocument;
}, C1t = (i, e = 500) => {
  let t;
  return function(...n) {
    const r = this;
    t && clearTimeout(t), t = setTimeout(() => {
      t = null, i.apply(r, n);
    }, e);
  };
}, _xt = (i) => i.charAt(0).toUpperCase() + i.slice(1).toLowerCase(), bxt = (i, e, t) => {
  const n = new Date(i).getTime(), r = new Date(e).getTime();
  return isNaN(n) && isNaN(r) ? 0 : isNaN(n) ? t === Xi.ASC ? 1 : -1 : isNaN(r) ? t === Xi.ASC ? -1 : 1 : t === Xi.ASC ? r - n : n - r;
}, iA = (i, e) => hC.stringify(i, { indent: 2, lineWidth: 0, ...e }), y1t = (i, e) => {
  if (i === e)
    return !0;
  const t = Array.isArray(i), n = Array.isArray(e);
  return t && !n || !t && n ? !1 : !t && !n ? Object.keys(i).length === Object.keys(e).length : i.length === e.length;
};
function rA(i, e) {
  try {
    if (i === e)
      return !0;
    if (i && !e || !i && e || !y1t(i, e))
      return !1;
    let t = !0;
    for (const n in i)
      if (t)
        typeof i[n] == "object" && typeof e[n] == "object" ? t = rA(i[n], e[n]) : i[n] !== e[n] && (t = !1);
      else break;
    return t;
  } catch (t) {
    return Is(t), !0;
  }
}
function w1t(i, e) {
  if (i === e)
    return !0;
  if (typeof i != "object" || i === null || typeof e != "object" || e === null)
    return !1;
  const t = Object.keys(i), n = Object.keys(e);
  if (t.length !== n.length)
    return !1;
  const r = Object.prototype.hasOwnProperty.bind(e);
  for (let s = 0; s < t.length; s++)
    if (!r(t[s]) || i[t[s]] !== e[t[s]])
      return !1;
  return !0;
}
function dCe(i, e) {
  const t = Nt(null);
  $e(() => {
    t.current = i;
  }, [i]), $e(() => {
    function n() {
      t.current();
    }
    if (e !== null) {
      const r = setInterval(n, e);
      return () => clearInterval(r);
    }
  }, [e]);
}
function Cxt(i) {
  const e = Nt(null), t = Nt(0), n = Nt(null), [r, s] = Oe(0), [o, a] = Oe(0), [l, c] = Oe(!1), d = Wi((_) => {
    if (_ !== null)
      return e.current = _, n.current = _.addEventListener("wheel", u), t.current = requestAnimationFrame(m), () => {
        _.removeEventListener("wheel", u), cancelAnimationFrame(t.current);
      };
  }, []);
  function u(_) {
    _.deltaY < 0 && c(!1);
  }
  const [h, f] = Mn(() => {
    if (!e.current)
      return [!1, !1];
    let _ = !0;
    const b = e.current.scrollHeight - e.current.scrollTop !== e.current.clientHeight;
    return o === 0 && (_ = !1), !b && i.autoBottomScroll && c(!0), [_, b];
  }, [r, o]);
  $e(() => {
    i.autoBottomScroll ? c(!0) : c(!1);
  }, [i.autoBottomScroll]), Yq(
    () => {
      !l || !e.current || e.current.scrollBy({
        top: r,
        left: 0
      });
    },
    500,
    [r, l]
  );
  function g(_) {
    e.current.scrollBy({
      top: -1 * o,
      left: 0,
      behavior: "smooth"
    }), i.autoBottomScroll && c(!1);
  }
  function p(_) {
    c(!0), e.current.scrollBy({
      top: r,
      left: 0,
      behavior: "smooth"
    });
  }
  function m() {
    e.current && (s(e.current.scrollHeight), a(e.current.scrollTop), t.current = requestAnimationFrame(m));
  }
  return [d, h ? g : null, f ? p : null];
}
function S1t(i, e, t = []) {
  const n = Nt(null);
  $e(() => (n.current = setTimeout(i, e), () => clearTimeout(n.current)), t);
}
function x1t() {
  const [i, e] = Oe([]);
  $e(() => (document.addEventListener("keydown", n), document.addEventListener("keyup", r), () => {
    document.removeEventListener("keydown", n), document.removeEventListener("keyup", r);
  }), [i]), S1t(t, 500, [i.join("+")]);
  function t() {
    i.length && e([]);
  }
  const n = ({ key: s }) => {
    e((o) => Array.from(new Set(o).add(s)));
  }, r = ({ key: s }) => {
    e((o) => o.filter((a) => a !== s));
  };
  return i;
}
const uCe = (i) => /* @__PURE__ */ v.jsx(zi.DropdownIndicator, { ...i, children: /* @__PURE__ */ v.jsx(vu, { className: "icon-dim-20 icon-n6" }) });
function hCe(i, e) {
  return Array.isArray(i) ? i.reduce((t, n) => t.set(n[e], n), /* @__PURE__ */ new Map()) : (console.error(i, "is not array"), /* @__PURE__ */ new Map());
}
function yxt(i) {
  return i.then((e) => [null, e]).catch((e) => [e]);
}
const wxt = (i = 0) => i > 0 && i < 10 ? `0${i}` : i;
function sA({ reload: i, className: e = "", heightToDeduct: t = 0 }) {
  return /* @__PURE__ */ v.jsx(
    "article",
    {
      className: `flex w-100 h-100 ${e}`,
      ...t > 0 && { style: { height: `calc(100vh - ${t}px)` } },
      children: /* @__PURE__ */ v.jsxs("div", { className: "flex column w-250 dc__align-center", "data-testid": "reload", children: [
        /* @__PURE__ */ v.jsx("img", { src: Nye, style: { height: "auto" }, className: "w-100 mb-12", alt: "load-error" }),
        /* @__PURE__ */ v.jsx("h3", { className: "title dc__bold", children: "Failed to load" }),
        /* @__PURE__ */ v.jsx("div", { className: "dc__empty__subtitle mb-20", children: "We could not load this page. Please give us another try." }),
        /* @__PURE__ */ v.jsx("button", { type: "button", className: "cta ghosted", onClick: typeof i == "function" ? i : aCe, children: "Retry" })
      ] })
    }
  );
}
const D1t = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20width='250'%20height='200'%20viewBox='0%200%20250%20200'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='10'%20y='80'%20width='200'%20height='13'%20fill='url(%23paint0_linear_1869_837)'/%3e%3crect%20x='18'%20y='93'%20width='184'%20height='4'%20fill='url(%23paint1_linear_1869_837)'/%3e%3cpath%20d='M36%2097H41L23%20197H18L36%2097Z'%20fill='url(%23paint2_linear_1869_837)'/%3e%3cpath%20d='M184%2097H179L197%20197H202L184%2097Z'%20fill='url(%23paint3_linear_1869_837)'/%3e%3crect%20x='101'%20y='62'%20width='18'%20height='15'%20fill='url(%23paint4_linear_1869_837)'/%3e%3crect%20x='88'%20y='77'%20width='44'%20height='3'%20fill='%23428DFC'/%3e%3crect%20width='129'%20height='57'%20transform='translate(45%205)'%20fill='url(%23paint5_linear_1869_837)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M109.112%2040.44C107.592%2040.44%20106.432%2039.86%20105.632%2038.7C104.845%2037.54%20104.452%2035.7133%20104.452%2033.22C104.452%2030.7267%20104.845%2028.9%20105.632%2027.74C106.432%2026.58%20107.592%2026%20109.112%2026C110.632%2026%20111.785%2026.58%20112.572%2027.74C113.372%2028.9%20113.772%2030.7267%20113.772%2033.22C113.772%2035.7133%20113.372%2037.54%20112.572%2038.7C111.785%2039.86%20110.632%2040.44%20109.112%2040.44ZM109.112%2039.78C110.405%2039.78%20111.372%2039.2933%20112.012%2038.32C112.652%2037.3333%20112.972%2035.8867%20112.972%2033.98V32.46C112.972%2030.5533%20112.652%2029.1133%20112.012%2028.14C111.372%2027.1533%20110.405%2026.66%20109.112%2026.66C107.819%2026.66%20106.852%2027.1533%20106.212%2028.14C105.572%2029.1133%20105.252%2030.5533%20105.252%2032.46V33.98C105.252%2035.8867%20105.572%2037.3333%20106.212%2038.32C106.852%2039.2933%20107.819%2039.78%20109.112%2039.78ZM109.112%2033.88C108.859%2033.88%20108.679%2033.8267%20108.572%2033.72C108.479%2033.6133%20108.432%2033.4867%20108.432%2033.34V33.1C108.432%2032.9533%20108.479%2032.8267%20108.572%2032.72C108.679%2032.6133%20108.859%2032.56%20109.112%2032.56C109.365%2032.56%20109.539%2032.6133%20109.632%2032.72C109.739%2032.8267%20109.792%2032.9533%20109.792%2033.1V33.34C109.792%2033.4867%20109.739%2033.6133%20109.632%2033.72C109.539%2033.8267%20109.365%2033.88%20109.112%2033.88ZM123.184%2040.2V37.1H115.984V36.44L122.904%2026.24H123.884V36.5H126.164V37.1H123.884V40.2H123.184ZM116.664%2036.5H123.184V26.98H123.124L116.664%2036.5ZM99.2%2037.1V40.2H99.9V37.1H102.18V36.5H99.9V26.24H98.92L92%2036.44V37.1H99.2ZM99.2%2036.5H92.68L99.14%2026.98H99.2V36.5Z'%20fill='white'/%3e%3cpath%20d='M212%20128H186C186%20130.209%20187.791%20132%20190%20132H208C210.209%20132%20212%20130.209%20212%20128Z'%20fill='%231E2360'/%3e%3crect%20width='6'%20height='13'%20transform='matrix(-1%200%200%201%20202%20132)'%20fill='%23181D55'/%3e%3cpath%20d='M204%20147C204%20144.791%20202.209%20143%20200%20143H198C195.791%20143%20194%20144.791%20194%20147V182H204V147Z'%20fill='url(%23paint6_linear_1869_837)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M229%20189C229%20185.134%20225.866%20182%20222%20182H176C172.134%20182%20169%20185.134%20169%20189H171C171%20186.239%20173.239%20184%20176%20184H222C224.761%20184%20227%20186.239%20227%20189H229Z'%20fill='%23171C53'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M215%20189C215%20185.134%20211.866%20182%20208%20182H190C186.134%20182%20183%20185.134%20183%20189H185C185%20186.239%20187.239%20184%20190%20184H208C210.761%20184%20213%20186.239%20213%20189H215Z'%20fill='%2323286B'/%3e%3ccircle%20cx='6'%20cy='6'%20r='6'%20transform='matrix(-1%200%200%201%20234%20188)'%20fill='url(%23paint7_linear_1869_837)'/%3e%3ccircle%20cx='6'%20cy='6'%20r='6'%20transform='matrix(-1%200%200%201%20220%20188)'%20fill='url(%23paint8_linear_1869_837)'/%3e%3ccircle%20cx='6'%20cy='6'%20r='6'%20transform='matrix(-1%200%200%201%20190%20188)'%20fill='url(%23paint9_linear_1869_837)'/%3e%3ccircle%20cx='6'%20cy='6'%20r='6'%20transform='matrix(-1%200%200%201%20176%20188)'%20fill='url(%23paint10_linear_1869_837)'/%3e%3crect%20width='26'%20height='15'%20transform='matrix(-1%200%200%201%20189%20113)'%20fill='%23C73837'/%3e%3cpath%20d='M188%20199.857C188%20199.713%20186.618%20195.769%20184.957%20191.036L181.914%20182H166.491L163.172%20184.868C160.405%20187.307%20147.83%20194.251%20146.228%20195.196C145.159%20195.825%20142.749%20197.426%20141%20200C171.667%20199.953%20188%20199.904%20188%20199.857Z'%20fill='url(%23paint11_linear_1869_837)'/%3e%3cpath%20d='M169%20199.857C169%20199.713%20167.618%20195.769%20165.957%20191.036L162.914%20182H147.491L144.172%20184.868C141.405%20187.307%20128.83%20194.251%20127.228%20195.196C126.159%20195.825%20123.749%20197.426%20122%20200C152.667%20199.953%20169%20199.904%20169%20199.857Z'%20fill='url(%23paint12_linear_1869_837)'/%3e%3cpath%20d='M176.5%20119C178.5%20115.4%20187%20113.167%20191%20112.5L185%2091.5L156.742%20104.661C151.868%20106.931%20149.099%20112.167%20149.965%20117.473L160.5%20182H190C190%20180%20189.7%20175.2%20188.5%20172C187%20168%20182.5%20163%20181.5%20159C180.5%20155%20182.5%20152%20181.5%20147C180.5%20142%20175%20135.5%20174.5%20131C174%20126.5%20174%20123.5%20176.5%20119Z'%20fill='url(%23paint13_linear_1869_837)'/%3e%3cpath%20d='M146.267%20102.694L186.5%2084C189.5%2088.5%20196.4%2099.1%20200%20105.5C198%20113%20183.5%20115%20178.5%20116C170.854%20117.529%20163%20118.5%20163.5%20128.5C163.7%20132.495%20168%20140%20168.5%20145.5C169%20151%20168%20154.5%20168%20159.5C168%20164.5%20172.5%20168%20174.5%20175.5C175.031%20177.492%20175%20181.5%20175%20182.5H146.5L138.276%20117.138C137.516%20111.098%20140.746%20105.259%20146.267%20102.694Z'%20fill='url(%23paint14_linear_1869_837)'/%3e%3cpath%20d='M207.5%2041.5L204.5%2035C201.333%2033.1667%20195.4%2030.7%20197%2035.5C198.6%2040.3%20199%2044.8333%20199%2046.5L207.5%2041.5Z'%20fill='url(%23paint15_linear_1869_837)'/%3e%3cellipse%20cx='2'%20cy='3'%20rx='2'%20ry='3'%20transform='matrix(-1%200%200%201%20190.2%2022)'%20stroke='white'%20stroke-width='0.3'/%3e%3cpath%20d='M212.2%2032.001C215.2%2029.501%20215.7%2025.501%20215.7%2023.501C215.7%2018.501%20212.7%2014.001%20203.7%2014.001C196.5%2014.001%20192.367%2020.001%20191.2%2023.001C190.034%2024.8343%20187.7%2028.801%20187.7%2030.001C187.7%2031.201%20189.367%2031.8343%20190.2%2032.001C191.2%2036.501%20195.7%2038.001%20199.2%2038.001C202.7%2038.001%20209.2%2034.501%20212.2%2032.001Z'%20fill='%23FFBEB6'/%3e%3cellipse%20cx='2.75'%20cy='3.75'%20rx='2.75'%20ry='3.75'%20transform='matrix(-1%200%200%201%20197.2%2021)'%20stroke='white'%20stroke-width='0.3'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M191.693%2021.9151C187.789%2020.8518%20184.2%2018.5249%20184.2%2013.726C184.2%209.97259%20187.633%209.99441%20188.604%2010.0006C188.639%2010.0008%20188.672%2010.001%20188.7%2010.001C191.465%2010.001%20194.521%2013.2016%20196.685%2015.4686C196.831%2015.6218%20196.974%2015.7708%20197.111%2015.9142C198.913%2014.7788%20201.108%2014.0011%20203.7%2014.0011C212.7%2014.0011%20215.7%2018.5011%20215.7%2023.5011C215.7%2025.5011%20215.2%2029.5011%20212.2%2032.0011C210.543%2033.3825%20207.816%2035.0691%20205.118%2036.302C204.664%2035.4677%20204.2%2034.316%20204.2%2033.2261C204.2%2032.2261%20204.95%2031.6011%20205.7%2030.9761C206.45%2030.3511%20207.2%2029.7261%20207.2%2028.7261C207.2%2026.7261%20205.2%2026.7261%20204.7%2026.7261C204.615%2026.7261%20204.472%2026.7551%20204.283%2026.7934C203.363%2026.9797%20201.36%2027.3855%20199.7%2025.7261C198.7%2024.7262%20198.2%2023.2262%20198.2%2022.7261C196.357%2022.7261%20193.971%2022.5359%20191.692%2021.9153C191.692%2021.9152%20191.693%2021.9152%20191.693%2021.9151Z'%20fill='%23428DFC'/%3e%3cpath%20d='M198.2%2022.5C191.7%2023%20182.2%2021.5%20183.7%2011'%20stroke='%23428DFC'%20stroke-width='0.25'/%3e%3cpath%20d='M191.7%2024.5C191.534%2024.3333%20190.72%2023.9999%20190.12%2024.4999'%20stroke='white'%20stroke-width='0.3'/%3e%3cpath%20d='M160%2048H148V56C148%2059.3137%20150.686%2062%20154%2062C157.314%2062%20160%2059.3137%20160%2056V48Z'%20fill='url(%23paint16_linear_1869_837)'/%3e%3cpath%20d='M157.5%2069.4999C158.3%2069.4999%20160.833%2071.8332%20162%2072.9999C163.833%2073.1666%20166.6%2072.0999%20163%2066.4999C158.5%2059.4999%20153.5%2053.4999%20152.5%2053.4999C151.5%2053.4999%20150.5%2052.9999%20148.5%2054.9999C146.5%2056.9999%20146%2060.4999%20146%2061.4999C146%2062.4999%20146%2063.9999%20147.5%2065.9999C149%2067.9999%20156.5%2069.4999%20157.5%2069.4999Z'%20fill='%23FBB4AD'/%3e%3cpath%20d='M156%2053C156%2052.4477%20155.552%2052%20155%2052H153C152.448%2052%20152%2052.4477%20152%2053V55.7825C152%2056.594%20152.004%2057.4083%20152.146%2058.2072C152.356%2059.3848%20152.853%2061%20154%2061C155.147%2061%20155.644%2059.3848%20155.854%2058.2072C155.996%2057.4083%20156%2056.594%20156%2055.7825V53Z'%20fill='url(%23paint17_linear_1869_837)'/%3e%3cpath%20d='M217%2072.9999C217%2057.7999%20210.667%2045.6666%20207.5%2041.4999C205.5%2040.8333%20199.132%2044%20196.5%2048.9999C190.71%2060%20192%2072.4999%20184%2072.4999C177.2%2072.4999%20165.833%2066.4999%20161%2063.4999L156%2082.9999C157.667%2084.9999%20160.5%2088%20164%2089.5C166.907%2090.7457%20168%2091%20171.5%2091C175%2091%20183%2099%20192%2099C208.008%2099%20217%2091.9999%20217%2072.9999Z'%20fill='url(%23paint18_linear_1869_837)'/%3e%3cpath%20d='M248.099%2060.59C249.09%2055.0713%20244.848%2050%20239.241%2050H208.365C203.524%2050%20199.378%2053.4681%20198.522%2058.2334L186%20128H236L248.099%2060.59Z'%20fill='url(%23paint19_linear_1869_837)'/%3e%3cpath%20d='M69.4212%20110.954C68.4263%20111.257%2067.4501%20111.623%2066.5038%20112.053C67.4089%20112.038%2068.3141%20112.042%2069.2155%20112.068C69.7166%20112.083%2070.2103%20112.106%2070.7115%20112.136C70.2739%20114.735%2069.7241%20117.301%2068.9836%20119.807C68.4412%20119.818%2067.8989%20119.84%2067.3603%20119.882C65.7333%20119.99%2064.1138%20120.222%2062.5205%20120.562C63.9829%20120.932%2065.4154%20121.419%2066.7955%20122.021C67.2257%20122.208%2067.6483%20122.406%2068.071%20122.612C67.6147%20123.887%2067.1022%20125.148%2066.5188%20126.389C65.9652%20127.571%2065.3444%20128.742%2064.6524%20129.875C63.9044%20131.11%2063.0741%20132.306%2062.1727%20133.455C60.1268%20133.275%2058.0697%20133.223%2056.0201%20133.309C57.5087%20133.963%2058.9449%20134.745%2060.2989%20135.639C56.8579%20139.327%2052.5417%20142.27%2047.485%20143.792C46.909%20141.694%2046.5051%20139.574%2046.2844%20137.449C46.9128%20137.034%2047.5411%20136.619%2048.1694%20136.196C47.5%20136.017%2046.823%20135.856%2046.1423%20135.732C46.0151%20133.548%2046.0787%20131.368%2046.3442%20129.213C47.5523%20129.389%2048.7529%20129.636%2049.9311%20129.954C48.9586%20128.854%2047.874%20127.856%2046.6996%20126.969V126.965C47.1783%20124.445%2047.9488%20121.976%2049.0185%20119.608C49.3065%20118.965%2049.6169%20118.333%2049.9498%20117.701C50.2752%20117.095%2050.6193%20116.493%2050.9896%20115.909C51.1728%20115.921%2051.3561%20115.936%2051.5431%20115.954C53.2449%20116.111%2054.9317%20116.508%2056.6036%20116.908C55.4553%20115.898%2054.251%20114.956%2052.9868%20114.092C52.8185%20113.976%2052.6464%20113.86%2052.4744%20113.748C54.3295%20111.26%2056.5886%20109.013%2059.1469%20107.124C59.6593%20107.374%2060.1567%20107.655%2060.6355%20107.965C61.0282%20108.216%2061.4097%20108.489%2061.78%20108.777C61.6191%20108.291%2061.4209%20107.819%2061.189%20107.359C60.9871%20106.952%2060.7477%20106.559%2060.4896%20106.181C63.9156%20103.911%2067.8166%20102.269%2072.0094%20101.517C71.7251%20104.547%2071.4109%20107.558%2070.9696%20110.524C70.446%20110.658%2069.9298%20110.797%2069.4212%20110.954Z'%20fill='url(%23paint20_linear_1869_837)'/%3e%3cpath%20d='M69.6021%20103.48C60.4724%20112.25%2054.0183%20123.47%2049.9411%20135.346C45.864%20147.218%2044.0896%20159.75%2043.5017%20172.254C43.4968%20172.357%2043.5769%20172.444%2043.6797%20172.449C43.7829%20172.454%2043.8705%20172.374%2043.8753%20172.271C44.4622%20159.791%2046.2331%20147.294%2050.295%20135.467C54.3564%20123.638%2060.7832%20112.47%2069.861%20103.75C69.9358%20103.679%2069.938%20103.56%2069.8666%20103.486C69.7948%20103.411%2069.6766%20103.409%2069.6021%20103.48Z'%20fill='%23093B31'/%3e%3cpath%20d='M47.2792%20113.624C47.1819%20115.756%2046.9239%20117.892%2046.5087%20119.986C44.9827%20119.893%2043.4492%20119.923%2041.9307%20120.069C43.4118%20120.274%2044.863%20120.701%2046.2207%20121.318C45.237%20125.604%2043.9392%20131.304%2041.5904%20134.827C39.2677%20132.901%2036.7319%20128.981%2034.7945%20126.419C36.0512%20125.982%2037.3153%20125.589%2038.5945%20125.245C36.9974%20125.054%2035.3891%20124.976%2033.7771%20125.013C31.907%20122.343%2030.2875%20119.429%2029.0009%20116.388C31.0917%20115.79%2033.2722%20115.472%2035.434%20115.158C33.0478%20114.387%2030.5493%20113.976%2028.0397%20113.931C27.531%20112.525%2027.0972%20111.107%2026.7381%20109.675C26.6783%20109.435%2026.6222%20109.196%2026.5661%20108.953C26.121%20107.034%2025.7956%20105.228%2025.5936%20103.458C26.0275%20103.417%2026.4613%20103.376%2026.8952%20103.335C29.1505%20103.122%2031.4133%20102.905%2033.6687%20102.692C31.2001%20101.592%2028.6194%20100.736%2025.9789%20100.141C25.7657%20100.092%2025.5487%20100.047%2025.3355%20100.003V99.9988C25.2345%2096.4045%2025.6198%2092.7541%2026.51%2088.4043C27.0149%2088.4379%2027.5198%2088.4978%2028.021%2088.5801C28.5259%2088.6549%2029.0346%2088.7558%2029.5283%2088.8755C29.0795%2088.4828%2028.6194%2088.1013%2028.1482%2087.7273C27.7293%2087.3944%2027.2991%2087.0653%2026.8615%2086.7511C27.3216%2084.6828%2027.8863%2082.4536%2028.5521%2080.0001C31.1403%2081.9001%2033.4966%2083.7103%2035.5986%2085.5468C35.3817%2086.0143%2035.1759%2086.4856%2034.9777%2086.9606C34.6187%2087.8058%2034.2895%2088.6623%2033.9941%2089.5301C34.5588%2089.0177%2035.1535%2088.5389%2035.7781%2088.0938C36.2756%2087.746%2036.7842%2087.4169%2037.3116%2087.1102C39.4809%2089.1748%2041.3248%2091.3254%2042.8171%2093.7265C42.2898%2094.1828%2041.7699%2094.6466%2041.2425%2095.1029C39.8923%2096.2848%2038.5421%2097.4592%2037.1919%2098.6449C38.5795%2097.8894%2039.997%2097.1974%2041.4445%2096.5653C42.2412%2096.2175%2043.049%2095.8884%2043.8644%2095.5779C44.9416%2097.6463%2045.7719%2099.9053%2046.3441%20102.452C46.662%20103.877%2046.9089%20105.344%2047.0697%20106.836C46.4563%20107.15%2045.8429%20107.464%2045.2258%20107.778C43.7559%20108.534%2042.2898%20109.289%2040.8199%20110.037C42.6376%20109.91%2044.4591%20109.776%2046.2768%20109.648C46.6134%20109.626%2046.9463%20109.6%2047.2792%20109.577C47.3428%20110.92%2047.3428%20112.27%2047.2792%20113.624Z'%20fill='url(%23paint21_linear_1869_837)'/%3e%3cpath%20d='M30.7922%2086.371C38.8575%20109.58%2042.9796%20134.101%2042.9796%20158.622C42.9796%20163.073%2042.8438%20167.524%2042.5712%20171.967C42.5648%20172.07%2042.6433%20172.159%2042.7466%20172.165C42.8494%20172.172%2042.9381%20172.093%2042.9444%20171.99C43.2178%20167.539%2043.3536%20163.081%2043.3536%20158.622C43.3536%20134.059%2039.2245%20109.497%2031.1453%2086.2484C31.1116%2086.1507%2031.005%2086.0991%2030.9074%2086.1332C30.8098%2086.1672%2030.7582%2086.2734%2030.7922%2086.371Z'%20fill='url(%23paint22_linear_1869_837)'/%3e%3cpath%20d='M70.5956%20138.093L68.3851%20138.399L70.3151%20138.605L71.669%20138.751C70.4011%20142.147%2066.717%20146.774%2066.717%20146.774L66.1597%20146.789L62.0605%20146.923L65.4827%20148.195L65.8194%20148.322C65.2733%20149.41%2064.5327%20150.645%2063.7847%20151.8C62.3447%20154.048%2060.901%20156.004%2060.901%20156.004L56.4128%20156.644L59.7902%20157.377C56.9738%20161.603%2048.0198%20165.056%2048.0198%20165.056C48.0198%20165.056%2043.4456%20153.158%2049.8637%20141.567L53.0018%20143.651L51.3561%20138.987C51.8273%20138.104%2052.609%20137.06%2053.5366%20136.021C55.3506%20133.982%2057.7181%20131.94%2059.3937%20131.072C59.4648%20131.304%2059.5583%20131.574%2059.6668%20131.854C60.0744%20132.916%2060.6542%20134.147%2060.7327%20134.18C60.8187%20134.222%2060.9571%20132.595%2061.1404%20131.151C61.2002%20130.68%2061.2638%20130.231%2061.3349%20129.864C65.0975%20127.575%2073.2361%20126.218%2078.6968%20128.447C78.6968%20128.447%2075.6336%20133.006%2072.2038%20137.876L70.5956%20138.093Z'%20fill='url(%23paint23_linear_1869_837)'/%3e%3cpath%20d='M45.2482%20183.091C45.2482%20183.091%2045.2594%20182.912%2045.2878%20182.571C45.5006%20180.012%2046.6683%20168.408%2051.0694%20156.565C53.2697%20150.643%2056.278%20144.663%2060.3723%20139.722C64.4671%20134.782%2069.6431%20130.882%2076.1915%20129.102C76.2909%20129.075%2076.35%20128.972%2076.3227%20128.873C76.2958%20128.773%2076.1929%20128.714%2076.0935%20128.742C69.0152%20130.665%2063.5223%20135.036%2059.2727%20140.494C46.5292%20156.873%2044.8798%20183.053%2044.8749%20183.068C44.8682%20183.171%2044.9464%20183.26%2045.0496%20183.266C45.1528%20183.273%2045.2415%20183.194%2045.2482%20183.091Z'%20fill='%23428DFC'/%3e%3cpath%20d='M41.5863%20161.392C41.841%20162.71%2041.9678%20164.05%2041.9678%20165.391C41.9678%20167.698%2041.593%20170.004%2040.8521%20172.191C40.8192%20172.289%2040.8716%20172.395%2040.9696%20172.428C41.0672%20172.462%2041.1734%20172.409%2041.2067%20172.311C41.9607%20170.085%2042.3418%20167.739%2042.3418%20165.391C42.3418%20164.027%2042.2128%20162.662%2041.9536%20161.321C41.9338%20161.22%2041.8358%20161.153%2041.7344%20161.173C41.6331%20161.192%2041.5669%20161.29%2041.5863%20161.392Z'%20fill='%23428DFC'/%3e%3cpath%20d='M42.2897%20165.602C42.2748%20165.729%2037.5434%20162.307%2032.6588%20157.033L33.4367%20154.512L33.6275%20153.876L33.2086%20154.198L31.3609%20155.593C30.0369%20154.086%2028.7129%20152.466%2027.4711%20150.757C26.2967%20149.141%2025.1971%20147.443%2024.2434%20145.697L25.2457%20144.791L26.4575%20143.699L28.3463%20141.994L25.99%20142.895L24.3443%20143.52L23.3233%20143.909C23.1662%20143.565%2023.0016%20143.224%2022.852%20142.88C21.4569%20139.675%2020.3162%20136.765%2019.4073%20134.214L19.9421%20133.855L20.8099%20133.275L22.1975%20132.352L20.4546%20132.55L19.5345%20132.655L18.8837%20132.729C16.7742%20126.614%2016.0449%20122.9%2016%20122.672V122.661C16%20122.661%2018.3488%20123.27%2021.6177%20124.767C26.2256%20126.876%2032.67%20130.747%2036.96%20137.15C43.5988%20147.095%2042.5665%20162.838%2042.2897%20165.602Z'%20fill='url(%23paint24_linear_1869_837)'/%3e%3cpath%20d='M56.873%20190.051C56.7608%20191.465%2056.5289%20192.74%2056.2334%20193.874C55.2946%20197.494%2052.007%20200%2048.2892%20200H41.8412C40.9061%20200%2040.001%20199.843%2039.1557%20199.547C36.6012%20198.657%2034.574%20196.533%2033.8709%20193.78C33.8035%20193.522%2033.7437%20193.253%2033.6838%20192.98C33.422%20191.775%2033.2388%20190.429%2033.1864%20188.955C33.134%20187.366%2033.235%20185.626%2033.5642%20183.741C33.6577%20183.191%2033.7736%20182.631%2033.912%20182.055C34.0915%20181.28%2034.3159%20180.48%2034.5852%20179.661L34.6638%20179.421C34.8283%20178.924%2034.9817%20178.442%2035.1275%20177.974C35.3819%20177.128%2035.6026%20176.332%2035.7896%20175.584C36.2608%20173.71%2036.5339%20172.143%2036.6872%20170.894C36.9752%20168.582%2036.8593%20167.378%2036.8593%20167.378H53.2712C53.2712%20167.378%2053.2038%20168.066%2053.2936%20169.402C53.3198%20169.828%2053.3684%20170.329%2053.4395%20170.894C53.5928%20172.143%2053.8659%20173.71%2054.3371%20175.584C54.5241%20176.332%2054.7411%20177.128%2054.9991%20177.974C55.145%20178.442%2055.2946%20178.924%2055.4629%20179.421C55.4891%20179.504%2055.5153%20179.582%2055.5415%20179.661C55.807%20180.48%2056.0277%20181.28%2056.2109%20182.055C56.3456%20182.627%2056.4615%20183.188%2056.5588%20183.741C56.7271%20184.695%2056.8318%20185.615%2056.8917%20186.498C56.9777%20187.766%2056.9627%20188.951%2056.873%20190.051Z'%20fill='url(%23paint25_linear_1869_837)'/%3e%3cpath%20d='M35.7896%20167.158C35.7896%20166.552%2036.2795%20166.062%2036.8854%20166.062H53.2412C53.8471%20166.062%2054.3371%20166.552%2054.3371%20167.158C54.3371%20167.763%2053.8471%20168.253%2053.2412%20168.253H36.8854C36.2795%20168.253%2035.7896%20167.763%2035.7896%20167.158Z'%20fill='url(%23paint26_linear_1869_837)'/%3e%3cpath%20d='M56.2334%20193.874C56.5289%20192.74%2056.7608%20191.465%2056.873%20190.051C56.9628%20188.951%2056.9777%20187.766%2056.8917%20186.498C56.8319%20185.615%2056.7271%20184.695%2056.5588%20183.741C56.4616%20183.188%2056.3456%20182.627%2056.211%20182.055C56.0277%20181.28%2055.807%20180.48%2055.5415%20179.661C55.5153%20179.582%2055.4891%20179.504%2055.4629%20179.421C55.2946%20178.924%2055.145%20178.442%2054.9992%20177.974C54.7411%20177.128%2054.5242%20176.332%2054.3372%20175.584C53.8659%20173.71%2053.5929%20172.143%2053.4395%20170.894C53.3685%20170.329%2053.3198%20169.828%2053.2936%20169.402H53.2974C53.3236%20169.828%2053.3722%20170.329%2053.4433%20170.894C53.5966%20172.143%2053.8696%20173.71%2054.3409%20175.584C54.5279%20176.332%2054.7448%20177.128%2055.0029%20177.974C55.1488%20178.442%2055.2984%20178.924%2055.4667%20179.421C55.4929%20179.504%2055.5191%20179.582%2055.5452%20179.661C55.8108%20180.48%2056.0315%20181.28%2056.2147%20182.055C56.3494%20182.627%2056.4653%20183.188%2056.5626%20183.741C56.7309%20184.695%2056.8356%20185.615%2056.8954%20186.498C56.9777%20187.766%2056.9628%20188.951%2056.873%20190.051C56.7608%20191.465%2056.5289%20192.74%2056.2334%20193.874Z'%20fill='%23E2E3C3'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1869_837'%20x1='10'%20y1='87'%20x2='210'%20y2='86.9999'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23EEEEEE'/%3e%3cstop%20offset='1'%20stop-color='%23D6D7D8'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_1869_837'%20x1='202'%20y1='95.4'%20x2='18'%20y2='95.4'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E9EBED'/%3e%3cstop%20offset='0.102145'%20stop-color='%23EEEEEE'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_1869_837'%20x1='33.333'%20y1='97'%20x2='33.333'%20y2='197'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E5E9EC'/%3e%3cstop%20offset='0.220246'%20stop-color='%23EEEEEE'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_1869_837'%20x1='186.667'%20y1='97'%20x2='186.667'%20y2='197'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E5E9EC'/%3e%3cstop%20offset='0.220246'%20stop-color='%23EEEEEE'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear_1869_837'%20x1='110'%20y1='62'%20x2='110'%20y2='77'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.15763'%20stop-color='%233986F3'/%3e%3cstop%20offset='0.657079'%20stop-color='%232175DD'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint5_linear_1869_837'%20x1='-1.04326e-06'%20y1='29.3636'%20x2='129.066'%20y2='27.0969'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2323286B'/%3e%3cstop%20offset='1'%20stop-color='%231D225F'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint6_linear_1869_837'%20x1='199'%20y1='143'%20x2='199'%20y2='182'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.70661'%20stop-color='%2323286B'/%3e%3cstop%20offset='1'%20stop-color='%231A1F5A'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint7_linear_1869_837'%20x1='12'%20y1='-4.6851e-07'%20x2='2.74666'%20y2='13.8368'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.133036'%20stop-color='%23EEEEEE'/%3e%3cstop%20offset='0.847068'%20stop-color='%23D0D0D0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint8_linear_1869_837'%20x1='12'%20y1='-4.6851e-07'%20x2='2.74666'%20y2='13.8368'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.133036'%20stop-color='%23EEEEEE'/%3e%3cstop%20offset='0.847068'%20stop-color='%23D0D0D0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint9_linear_1869_837'%20x1='12'%20y1='-4.6851e-07'%20x2='2.74666'%20y2='13.8368'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.133036'%20stop-color='%23EEEEEE'/%3e%3cstop%20offset='0.847068'%20stop-color='%23D0D0D0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint10_linear_1869_837'%20x1='12'%20y1='-4.6851e-07'%20x2='2.74666'%20y2='13.8368'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.133036'%20stop-color='%23EEEEEE'/%3e%3cstop%20offset='0.847068'%20stop-color='%23D0D0D0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint11_linear_1869_837'%20x1='184.533'%20y1='182.34'%20x2='172.175'%20y2='212.693'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.090505'%20stop-color='%232C7DE7'/%3e%3cstop%20offset='0.492038'%20stop-color='%231D72D9'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint12_linear_1869_837'%20x1='165.533'%20y1='182.34'%20x2='153.175'%20y2='212.693'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.0747083'%20stop-color='%23428DFC'/%3e%3cstop%20offset='1'%20stop-color='%23428DFC'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint13_linear_1869_837'%20x1='167.621'%20y1='91.5'%20x2='192.938'%20y2='176.217'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.332054'%20stop-color='%23181D55'/%3e%3cstop%20offset='1'%20stop-color='%231A1F58'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint14_linear_1869_837'%20x1='174'%20y1='84'%20x2='174.185'%20y2='182.5'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23191D52'/%3e%3cstop%20offset='0.815238'%20stop-color='%23272D78'/%3e%3cstop%20offset='1'%20stop-color='%2323286B'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint15_linear_1869_837'%20x1='201'%20y1='37.5'%20x2='203.5'%20y2='43.5'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FBA19B'/%3e%3cstop%20offset='0.349149'%20stop-color='%23F9ADA7'/%3e%3cstop%20offset='1'%20stop-color='%23F9AFA9'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint16_linear_1869_837'%20x1='160'%20y1='50.5'%20x2='148'%20y2='50.5'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E04341'/%3e%3cstop%20offset='1'%20stop-color='%23B62625'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint17_linear_1869_837'%20x1='154'%20y1='52'%20x2='154'%20y2='61'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23ED514F'/%3e%3cstop%20offset='1'%20stop-color='%23DC403E'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint18_linear_1869_837'%20x1='212.5'%20y1='42.5'%20x2='165'%20y2='93.5'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%237294D6'/%3e%3cstop%20offset='1'%20stop-color='%23A1C3FC'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint19_linear_1869_837'%20x1='193.5'%20y1='81.4787'%20x2='236.5'%20y2='128'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E74846'/%3e%3cstop%20offset='1'%20stop-color='%23D03231'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint20_linear_1869_837'%20x1='62.2989'%20y1='122.531'%20x2='46.1609'%20y2='121.383'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.29724'%20stop-color='%232D7EE8'/%3e%3cstop%20offset='0.828999'%20stop-color='%23428DFC'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint21_linear_1869_837'%20x1='39.0855'%20y1='107.253'%20x2='25.3496'%20y2='106.614'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.29724'%20stop-color='%232D7EE8'/%3e%3cstop%20offset='0.828999'%20stop-color='%23428DFC'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint22_linear_1869_837'%20x1='36.0679'%20y1='172.166'%20x2='35.3732'%20y2='86.128'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23191D52'/%3e%3cstop%20offset='0.815238'%20stop-color='%23272D78'/%3e%3cstop%20offset='1'%20stop-color='%2323286B'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint23_linear_1869_837'%20x1='48.8195'%20y1='164.342'%20x2='79.7126'%20y2='137.582'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%237294D6'/%3e%3cstop%20offset='1'%20stop-color='%23A1C3FC'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint24_linear_1869_837'%20x1='17.9561'%20y1='164.794'%20x2='49.8952'%20y2='144.804'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%237294D6'/%3e%3cstop%20offset='1'%20stop-color='%23A1C3FC'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint25_linear_1869_837'%20x1='56.9488'%20y1='200'%20x2='29.8303'%20y2='170.446'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.133036'%20stop-color='%23EEEEEE'/%3e%3cstop%20offset='0.847068'%20stop-color='%23D0D0D0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint26_linear_1869_837'%20x1='35.7896'%20y1='167.073'%20x2='54.3371'%20y2='167.073'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23EEEEEE'/%3e%3cstop%20offset='1'%20stop-color='%23D6D7D8'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", f3 = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20width='250'%20height='200'%20viewBox='0%200%20250%20200'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1869_550)'%3e%3crect%20x='92'%20y='127.163'%20width='77'%20height='77'%20transform='rotate(-42%2092%20127.163)'%20fill='%23EEEEEE'/%3e%3cpath%20d='M234.287%20102.782C253.504%20124.125%20251.781%20157.004%20230.438%20176.221C209.096%20195.437%20176.217%20193.714%20157%20172.372C166.569%20163.756%20211.469%20123.328%20234.287%20102.782Z'%20fill='%231F2463'/%3e%3cpath%20d='M169.5%208.5L101.5%2058L191.5%2092L169.5%208.5Z'%20fill='%23E94A47'/%3e%3cpath%20d='M54.0979%20121.532L59.3504%20117.611C61.5248%20117.419%2064.9923%20117.654%2062.917%20119.846C60.8417%20122.038%2059.0262%20123.348%2058.8965%20124.904L54.0979%20121.532Z'%20fill='url(%23paint0_linear_1869_550)'/%3e%3cpath%20d='M64.2151%20131.649C66.1938%20133.628%2069.4028%20135.28%2073.4232%20135.54C73.4232%20136.188%2073.8122%20145.526%2073.8122%20146.434C63.8258%20145.008%2054.099%20140.209%2051.505%20134.243C47.13%20124.181%2051.8941%20122.182%2052.5426%20121.922C53.191%20121.663%2055.6553%20121.014%2057.4709%20121.922C58.9007%20122.637%2059.4657%20124.909%2060.5837%20126.98C61.4279%20128.544%2062.7885%20130.222%2064.2151%20131.649Z'%20fill='url(%23paint1_linear_1869_550)'/%3e%3cpath%20d='M73.0344%20126.33C73.0344%20127.679%2072.7751%20132.944%2072.6454%20135.409V143.579C74.3314%20143.968%2077.7034%20143.45%2080.2973%20141.634C81.0755%20138.262%2080.6864%20133.723%2080.2973%20131.388C79.9082%20129.054%2079.0004%20125.941%2077.9628%20123.347C76.9253%20120.753%2074.8502%20116.344%2074.3314%20115.176C73.8127%20114.009%2073.4236%20112.193%2073.0344%20110.507C72.6453%20108.821%2070.4406%20107.914%2068.4952%20109.729C66.5498%20111.545%2069.014%20114.139%2069.5327%20114.658C70.0515%20115.176%2071.7375%20117.77%2072.386%20119.327C73.0344%20120.883%2073.0344%20124.644%2073.0344%20126.33Z'%20fill='url(%23paint2_linear_1869_550)'/%3e%3cpath%20d='M23.8806%20169.389L29.5871%20177.301C29.198%20179.419%2028.1605%20183.63%2027.1229%20183.526C25.826%20183.396%2021.0274%20183.785%2018.0444%20184.304C15.0615%20184.823%2011.1707%20185.99%208.18773%20185.99C5.80137%20185.99%203.73493%20185.298%203%20184.953L23.8806%20169.389Z'%20fill='%23428DFC'/%3e%3cpath%20d='M50.2062%20172.89L35.2915%20151.88L48.6499%20147.081C55.3075%20155.684%2069.0118%20173.357%2070.5681%20175.225C72.5135%20177.559%2073.1619%20180.542%2071.4759%20183.395C70.1271%20185.678%2065.121%20186.076%2062.7865%20185.989H24.6567L28.4178%20170.945C29.4121%20170.815%2031.8157%20170.634%2033.4758%20170.945C35.5509%20171.334%2038.6635%20173.279%2039.9605%20173.279C41.5168%20173.279%2043.8513%20171.853%2045.4076%20171.853C46.8342%20171.853%2049.0822%20172.544%2050.2062%20172.89Z'%20fill='url(%23paint3_linear_1869_550)'/%3e%3cpath%20d='M62.2707%20185.99L66.4209%20174.058H72.9055C73.6405%20174.966%2075.5772%20177.119%2077.4448%20178.468C79.7793%20180.154%2083.281%20181.321%2085.0967%20182.618C86.5493%20183.655%2087.95%20185.298%2088.4687%20185.99H62.2707Z'%20fill='%23428DFC'/%3e%3cpath%20d='M41.6488%20162.126C37.1874%20160.155%2035.0345%20154.129%2034.5157%20151.362C45.6693%20146.866%2068.1841%20137.796%2069.0141%20137.485C70.0516%20137.096%2075.1097%20135.28%2077.8332%20137.485C80.5568%20139.689%2080.1677%20146.304%2080.1677%20148.119C80.1677%20149.572%2079.2166%20166.968%2078.7411%20175.485H61.1028C60.9731%20174.188%2060.7397%20171.283%2060.8434%20170.038C60.9731%20168.481%2062.9185%20166.536%2063.1779%20164.85C63.4373%20163.164%2062.6591%20162.515%2062.6591%20160.181C62.6591%20158.313%2064.2154%20156.117%2064.9936%20155.253C62.6159%20156.679%2057.5751%20159.662%2056.4338%20160.181C55.0072%20160.829%2047.2256%20164.59%2041.6488%20162.126Z'%20fill='url(%23paint4_linear_1869_550)'/%3e%3cpath%20d='M87.0405%20125.033C87.689%20125.552%2088.9859%20129.054%2088.4672%20131.129C88.9427%20130.999%2090.0235%20129.599%2090.0235%20129.184C90.0235%20128.665%2090.0235%20127.498%2089.7641%20126.849C89.5047%20126.201%2088.8562%20125.293%2088.3375%20124.904C87.8973%20124.574%2087.1702%20124.644%2087.0405%20125.033Z'%20fill='url(%23paint5_linear_1869_550)'/%3e%3cpath%20d='M73.8109%20152.529L71.6061%20154.215C69.5312%20148.897%2069.142%20144.617%2068.8826%20140.856C71.6061%20140.727%2080.4253%20137.225%2081.7222%20136.447C83.0191%20135.669%2085.4833%20133.464%2086.0021%20132.945C86.5208%20132.426%2088.4662%20130.222%2088.5959%20129.443C88.7256%20128.665%2088.3365%20128.276%2089.2444%20126.59C90.1523%20124.904%2092.4867%20123.348%2092.7461%20123.088C93.0055%20122.829%2093.3946%20122.31%2093.9134%20121.532C94.3284%20120.91%2094.4321%20120.322%2094.4321%20120.105C94.9509%20120.365%2095.9884%20121.195%2095.9884%20122.44C95.9884%20123.996%2093.5243%20125.553%2093.1352%20126.979C92.7461%20128.406%2093.7837%20131.648%2093.2649%20132.556C92.7461%20133.464%2089.6335%20135.02%2088.985%20135.669C88.3365%20136.317%2086.2615%20139.17%2082.1113%20144.228C78.7911%20148.275%2075.1943%20151.448%2073.8109%20152.529Z'%20fill='url(%23paint6_linear_1869_550)'/%3e%3cpath%20d='M57.0806%20122.44C58.4678%20123.654%2059.4151%20129.443%2059.8042%20131.129C61.5102%20138.522%2059.5448%20149.935%2053.5789%20152.01C48.3912%20153.437%2042.9441%20153.955%2040.4799%20153.955C35.5516%20153.955%2029.8451%20151.88%2028.0294%20149.676C28.4184%20145.655%2029.0669%20141.245%2031.142%20138.522C33.2171%20135.798%2036.1341%20134.438%2038.0157%20132.556C39.9611%20130.611%2041.2581%20128.146%2044.8895%20125.553C48.6073%20122.897%2053.4558%20121.624%2054.0977%20121.532C55.0055%20121.402%2056.0431%20121.532%2057.0806%20122.44Z'%20fill='url(%23paint7_linear_1869_550)'/%3e%3cpath%20d='M63.1768%20138.911C64.9925%20140.338%2066.1597%20140.986%2068.8833%20140.856C69.198%20140.841%2069.594%20140.781%2070.0505%20140.686C71.8662%20146.044%2073.4426%20151.348%2075.1085%20156.679C74.2007%20157.414%2071.7884%20158.91%2069.402%20159.013C66.4191%20159.143%2061.4908%20154.604%2059.1563%20153.566C56.8674%20152.549%2055.6546%20153.437%2053.5795%20152.01C46.8359%20147.211%2044.761%20139.689%2045.4092%20130.74C45.7994%20125.353%2053.5795%20121.791%2057.0812%20123.996C58.641%20124.978%2059.4157%20129.443%2059.8047%20131.129C60.1938%20132.815%2061.361%20137.484%2063.1768%20138.911Z'%20fill='url(%23paint8_linear_1869_550)'/%3e%3cpath%20d='M56.4337%20113.881C55.6556%20113.924%2053.8918%20113.803%2053.0617%20112.973C52.2317%20112.143%2052.2836%20111.071%2052.4133%20110.639'%20stroke='%2323286B'%20stroke-width='0.3'/%3e%3cpath%20d='M64.473%20121.531C66.3406%20121.531%2068.1044%20119.975%2068.7529%20119.197C68.7529%20119.197%2070.1796%20119.456%2070.3093%20119.067C70.439%20118.678%2070.4567%20116.862%2070.3093%20115.565C70.1534%20114.194%2069.947%20113.348%2069.6607%20112.712C68.4936%20110.118%2066.8076%20108.86%2064.8621%20108.173C62.6574%20107.395%2059.4113%20108.108%2057.8588%20110.507C56.4322%20112.712%2058.118%20117.381%2059.1556%20118.678C60.1931%20119.975%2062.1385%20121.531%2064.473%20121.531Z'%20fill='%23FFBEB6'/%3e%3cpath%20d='M66.9374%20114.787C67.8453%20115.393%2070.1538%20116.162%2072.1252%20114.398C73.5518%20113.122%2073.8112%20110.81%2073.4221%20110.118'%20stroke='%2323286B'%20stroke-width='0.3'/%3e%3cpath%20d='M56.1763%20118.549C54.4125%20116.889%2055.6143%20114.745%2056.4357%20113.88C53.7122%20113.88%2053.0637%20111.805%2053.0637%20110.638C53.0637%20109.471%2054.7497%20107.266%2056.8248%20107.007C58.4848%20106.799%2059.7645%20107.439%2060.1968%20107.785C60.0239%20107.179%2060.0152%20105.917%2061.364%20105.71C62.7128%20105.502%2063.8282%20106.488%2064.2173%20107.007C64.2605%20106.099%2064.0876%20104.542%2064.9954%20104.153C65.9033%20103.764%2067.0042%20104.087%2068.3675%20105.45C69.405%20106.488%2069.3618%20108.52%2069.1456%20109.471C69.7941%20109.038%2071.2985%20108.355%2072.1286%20109.082C73.1661%20109.989%2073.0364%20111.935%2072.1286%20113.491C71.2207%20115.048%2068.7565%20115.566%2066.9408%20114.788C66.033%20116.474%2064.4767%20116.474%2063.8282%20115.566C62.4016%20118.679%2058.3811%20120.624%2056.1763%20118.549Z'%20fill='%2323286B'/%3e%3cpath%20d='M66.2894%20120.105C67.0676%20119.846%2068.1051%20119.923%2068.1051%20120.753'%20stroke='%2323286B'%20stroke-width='0.5'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1869_550'%20x1='60.6125'%20y1='119.846'%20x2='57.748'%20y2='122.459'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FBA19B'/%3e%3cstop%20offset='0.349149'%20stop-color='%23F9ADA7'/%3e%3cstop%20offset='1'%20stop-color='%23F9AFA9'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_1869_550'%20x1='65.3443'%20y1='146.534'%20x2='70.8524'%20y2='122.658'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23171B4D'/%3e%3cstop%20offset='0.683307'%20stop-color='%231D225F'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_1869_550'%20x1='78.0925'%20y1='143.709'%20x2='68.6249'%20y2='108.692'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.625896'%20stop-color='%23FFBEB6'/%3e%3cstop%20offset='0.768502'%20stop-color='%23F5A7A1'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_1869_550'%20x1='48.5509'%20y1='162.644'%20x2='48.5509'%20y2='186'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.509448'%20stop-color='%2387B2F4'/%3e%3cstop%20offset='1'%20stop-color='%239BBFFA'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear_1869_550'%20x1='57.3513'%20y1='136.412'%20x2='57.3513'%20y2='175.485'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.142369'%20stop-color='%237BABF0'/%3e%3cstop%20offset='0.668615'%20stop-color='%23A1C3FC'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint5_linear_1869_550'%20x1='87.0405'%20y1='131.153'%20x2='92.0484'%20y2='127.454'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FFBEB6'/%3e%3cstop%20offset='1'%20stop-color='%23F5A7A1'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint6_linear_1869_550'%20x1='68.8827'%20y1='154.344'%20x2='95.8931'%20y2='120.132'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.47747'%20stop-color='%23FFBEB6'/%3e%3cstop%20offset='0.890647'%20stop-color='%23F5A7A1'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint7_linear_1869_550'%20x1='49.0397'%20y1='154.085'%20x2='55.9995'%20y2='122.959'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23171B4D'/%3e%3cstop%20offset='0.683307'%20stop-color='%231D225F'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint8_linear_1869_550'%20x1='75.109'%20y1='159.013'%20x2='47.1296'%20y2='121.826'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%232A318C'/%3e%3cstop%20offset='0.811178'%20stop-color='%231D225F'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_1869_550'%3e%3crect%20width='250'%20height='200'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", LW = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='250'%20height='200'%20viewBox='0%200%20250%20200'%3e%3cdefs%3e%3clinearGradient%20id='ho9etwod5c'%20x1='55.01%25'%20x2='40.976%25'%20y1='0%25'%20y2='100%25'%3e%3cstop%20offset='0%25'%20stop-color='%232A318C'/%3e%3cstop%20offset='100%25'%20stop-color='%231D225F'/%3e%3c/linearGradient%3e%3clinearGradient%20id='mdhg2gjypd'%20x1='50%25'%20x2='50%25'%20y1='0%25'%20y2='100%25'%3e%3cstop%20offset='0%25'%20stop-color='%23EEE'/%3e%3cstop%20offset='100%25'%20stop-color='%23D6D7D8'/%3e%3c/linearGradient%3e%3clinearGradient%20id='xe2mx0bk0e'%20x1='0%25'%20x2='100%25'%20y1='18%25'%20y2='82%25'%3e%3cstop%20offset='0%25'%20stop-color='%23E8B73F'/%3e%3cstop%20offset='100%25'%20stop-color='%23CF9F36'/%3e%3c/linearGradient%3e%3cpath%20id='88gkjk6cca'%20d='M0%200H250V200H0z'/%3e%3c/defs%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cg%3e%3cg%20transform='translate(-590%20-308)%20translate(590%20308)'%3e%3cmask%20id='pitr2853ub'%20fill='%23fff'%3e%3cuse%20xlink:href='%2388gkjk6cca'/%3e%3c/mask%3e%3cg%20mask='url(%23pitr2853ub)'%3e%3cg%3e%3cpath%20fill='%23FFF'%20fill-rule='nonzero'%20d='M47.646%200c2.598%200%205.717%201.017%207.994%202.74%202.276%201.722%203.845%203.02%204.55%205.097.465%201.372.252%203.282-.641%205.728l.008-.072c-.013.145-.039.269-.071.387.574-1.048%201.638-1.624%202.576-1.283%201.07.39%201.5%201.803%201.013%203.14-.487%201.337-1.723%202.144-2.794%201.754-.536-.195-.91-.646-1.09-1.216.023.975.09%202.117.203%203.427l-2.317.161c-2.223%202.412-4.574%203.48-7.055%203.207-.6-.067-1.158-.18-1.675-.339-.588%201.007-1.177%202.688-1.766%205.043l-.064.031.005-.043c-.585%205.627-1.014%2011.07-1.287%2016.327l.001-.108c-.013.958-.003%201.853.028%202.684l.109-1.533c2.141%201.735%204.344%202.776%206.608%203.123%202.263.348%205.76-.128%2010.49-1.426%202.808-.962%205.555-2.299%208.243-4.011H63.94l16.84-20.83h2.756c0-1.439%201.165-2.604%202.604-2.604%201.378%200%202.506%201.07%202.597%202.425l.006.178h1.736c0-1.438%201.166-2.603%202.604-2.603%201.378%200%202.506%201.07%202.598%202.425l.006.178h5.284L89.832%2035.292c.097-.07.17-.106.212-.106.692%200%20.692%205.306-.057%207.152-.289.865-4.73%205.71-9.864%2010.844-2.78%202.78-6.605%206.366-11.477%2010.759l2.511%2011.858c-.568%201.157-2.01%201.928-4.324%202.314-5.208.579-10.415-1.736-16.78-1.736-1.852%200-3.142.343-4.269.744.841%208.545%202.264%2016.398%204.269%2023.558-1.157%201.157-1.946%201.682-2.808%202.052-1.015.394-2.305.789-3.009.86.776%202.429%201.318%204.584%201.627%206.464.38%202.322%202.518%2022.156%206.411%2059.5h-.044l2.037%201.697c2.308%201.962%2012.796%207.547%2014.132%208.307.891.506%202.067%201.794%203.526%203.864-16.575-.025-27.78-.05-33.613-.075l.053.075C12.788%20183.385%200%20183.346%200%20183.308c0-.116%201.154-3.288%202.538-7.095l2.44-6.658H1.761c-.4-1.385-.792-3.254-1.175-5.606-.75-4.788-.18-7.96%203.05-14.536%203.23-6.518%204.866-10.072%204.866-13.764.058-5.768%201.222-11.316%204.28-17.315%202.364-4.73%203.495-5.086%203.725-7.97l.367-5.421c-2.382-.231-5.928-.988-8.045-1.693l-4.21-1.385-.116-4.326C4.214%2085.6%205.08%2076.89%207.79%2065.757%2011.482%2050.47%2022.096%2034.84%2034.959%2025.668c3.055-2.203%204.272-3.049%205.093-2.807.79-.548%201.483-1.096%202.077-1.645-1.685-.52-3.275-1.222-4.77-2.105-2.311-1.366-4.444-3.194-6.398-5.483.397-.834.904-1.524%201.522-2.07.671-.592%201.935-1.108%203.169-1.822l-.065.021-1.204.401c-1.26.424-1.956.713-2.396%201.032-.829.601-1.259%201.275-1.312%202.032l-.005.191-.579.007c-.012-1.039.516-1.943%201.557-2.699.427-.31%201.013-.573%201.983-.916l1.755-.59.612-.213c.593-.213%201.063-.401%201.438-.584%201.296-1.399%202.17-3.971%204.089-5.678C43.642.855%2045.048%200%2047.646%200zM27.999%20144.476l-.189.512c-2.603%207.055-5.679%2015.219-9.228%2024.493l2.126%201.771c2.307%201.962%2012.795%207.547%2014.132%208.307l.035.021c.364-1.006.782-2.154%201.223-3.367l2.44-6.658h-4.242c-1.444-2.617-2.166-4.456-2.166-5.517%200-1.59.913-3.77.913-6.068%200-1.393-1.68-5.89-5.044-13.494zM78.827%2042.819l-1.242-.001c-2.375%202.17-3.972%203.706-4.791%204.61-.72.793-2.112%202.23-4.176%204.309%203.033-1.194%205.06-2.078%206.083-2.65%201.5-.865%202.077-1.673%203.807-5.307.082-.163.192-.506.319-.961zm7.313-22.857c-1.119%200-2.026.907-2.026%202.025h4.05c0-1.118-.906-2.025-2.024-2.025zm6.943%200c-1.119%200-2.025.907-2.025%202.025h4.05c0-1.118-.907-2.025-2.025-2.025zm-33.27-5.413c-.388%201.066-.065%202.132.666%202.398.73.266%201.664-.343%202.052-1.408.388-1.065.064-2.132-.667-2.398-.73-.266-1.664.343-2.052%201.408z'%20transform='translate(29%208)'/%3e%3cpath%20fill='%2380AEF2'%20fill-rule='nonzero'%20d='M36.56%20183.308c0-.116%201.153-3.288%202.538-7.095l2.538-6.922%206.46-.173%206.403-.173%202.768%202.307c2.308%201.962%2012.796%207.547%2014.132%208.307.891.506%202.067%201.794%203.526%203.864-25.577-.038-38.365-.077-38.365-.115z'%20transform='translate(29%208)'/%3e%3cpath%20fill='%2394BBF8'%20fill-rule='nonzero'%20d='M3%20183.308c0-.116%201.154-3.288%202.538-7.095l2.538-6.922%206.46-.173%206.403-.173%202.769%202.307c2.307%201.962%2012.795%207.547%2014.132%208.307.89.506%202.066%201.794%203.525%203.864C15.788%20183.385%203%20183.346%203%20183.308z'%20transform='translate(29%208)'/%3e%3cpath%20fill='%231D225F'%20fill-rule='nonzero'%20d='M46.655%20101.836c1.09%203.158%201.826%205.898%202.208%208.22.38%202.321%202.518%2022.155%206.411%2059.5H37.296c-1.444-2.618-2.166-4.457-2.166-5.518%200-1.59.913-3.77.913-6.068%200-1.532-2.034-6.823-6.104-15.871l3.931-39.349%2012.785-.914z'%20transform='translate(29%208)'/%3e%3cpath%20fill='url(%23ho9etwod5c)'%20d='M21.554%20169.555H4.76c-.4-1.385-.792-3.254-1.175-5.606-.75-4.788-.18-7.96%203.05-14.536%203.23-6.518%204.866-10.072%204.866-13.764.058-5.768%201.222-11.316%204.28-17.315%202.364-4.73%203.495-5.086%203.725-7.97l.42-6.202h21.078c.512%201.433.696%204.075.55%207.925-.145%203.85-6.812%2023.006-20.001%2057.468z'%20transform='translate(29%208)'/%3e%3cg%20fill-rule='nonzero'%3e%3cpath%20fill='%2398BDF9'%20d='M0%2024.302L16.84%203.472%2037.031%203.472%2019.592%2024.302z'%20transform='translate(29%208)%20translate(66.94%2018.516)'/%3e%3cpath%20fill='%232174DB'%20d='M22.2.868c1.378%200%202.506%201.07%202.597%202.425l.006.179h-.578c0-1.119-.907-2.025-2.025-2.025-1.119%200-2.025.906-2.025%202.025%200%201.062.818%201.934%201.859%202.018l.166.007v.578c-1.438%200-2.604-1.165-2.604-2.603%200-1.438%201.166-2.604%202.604-2.604zM29.143.868c1.378%200%202.506%201.07%202.598%202.425l.006.179h-.579c0-1.119-.906-2.025-2.025-2.025-1.118%200-2.025.906-2.025%202.025%200%201.062.818%201.934%201.859%202.018l.166.007v.578c-1.438%200-2.604-1.165-2.604-2.603%200-1.438%201.166-2.604%202.604-2.604z'%20transform='translate(29%208)%20translate(66.94%2018.516)'/%3e%3c/g%3e%3cpath%20fill='%23F3A29D'%20fill-rule='nonzero'%20d='M65.472%2046.829c2.807-.962%205.554-2.299%208.242-4.011h6.871c-2.375%202.17-3.972%203.706-4.791%204.61-.82.903-2.509%202.638-5.068%205.205-1.091%205.781-2.254%208.21-3.487%207.285-1.85-1.386-7.939-10.897-1.767-13.09z'%20transform='translate(29%208)'/%3e%3cpath%20fill='%23FAB6AF'%20fill-rule='nonzero'%20d='M69.254%2052.654c4.363-1.668%207.179-2.857%208.447-3.567%201.5-.865%202.077-1.673%203.807-5.307.23-.461.692-2.365%201.096-4.153.923-4.557%202.423-4.326%202.538.346.058%201.27.346%202.423.692%202.538.288.116%201.961-1.5%203.634-3.576%201.673-2.077%203.288-3.75%203.576-3.75.692%200%20.692%205.307-.057%207.153-.289.865-4.73%205.71-9.864%2010.844-3.422%203.423-8.431%208.068-15.026%2013.937l1.157-14.465z'%20transform='translate(29%208)'/%3e%3cpath%20fill='%23F3A29D'%20fill-rule='nonzero'%20d='M49.581%2027.774c.772-3.086%201.543-5.015%202.315-5.787-1.157-1.157-2.315-2.314-4.63-3.471-.77%201.543-2.314%203.086-4.628%204.629%200%202.314.771%203.857%202.314%204.629%201.543.771%203.086.771%204.63%200z'%20transform='translate(29%208)'/%3e%3cg%3e%3cpath%20fill='url(%23mdhg2gjypd)'%20fill-rule='nonzero'%20d='M12.858%2082.16c-2.365-.174-6.23-.981-8.48-1.731l-4.21-1.385-.115-4.326c-.289-11.94.577-20.65%203.288-31.782C7.032%2027.65%2017.646%2012.019%2030.509%202.847c4.96-3.576%205.076-3.576%206.518-1.153.634%201.153%201.96%202.307%202.884%202.653l2.161.594c-3.046%2029.324-1.87%2053.63%203.531%2072.917-1.157%201.158-1.946%201.682-2.808%202.052-1.039.403-2.365.807-3.057.865-.693.058-3%20.519-5.25%201.038-4.21.923-13.382%201.096-21.63.346z'%20transform='translate(29%208)%20translate(7.45%2022.82)'/%3e%3cpath%20fill='%23D6D7D8'%20d='M58.022%2024.008l1.767%2011.311-19.972%202.645%201.106-15.653c2.141%201.735%204.344%202.776%206.608%203.123%202.263.348%205.76-.128%2010.49-1.426z'%20transform='translate(29%208)%20translate(7.45%2022.82)'/%3e%3cpath%20fill='%23E9E9E9'%20fill-rule='nonzero'%20d='M61.804%2029.833l4.903%2023.145c-.568%201.157-2.01%201.929-4.324%202.314-5.208.579-10.415-1.736-16.78-1.736-6.365%200-6.09%204.05-15.348.58-6.172-2.315-8.68-12.73-7.523-31.246l18.054-1.73c-.078%205.782.655%209.252%202.198%2010.409%201.512%201.134%207.569.601%2018.17-1.6l.65-.136z'%20transform='translate(29%208)%20translate(7.45%2022.82)'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23FAB6AF'%20fill-rule='nonzero'%20d='M29.082%207.444c1.07%201.52%201.488%203.536%201.253%206.049-.062.656-.376.883-.376%202.052%200%201.12.07%202.506.212%204.157l-2.317.161c-2.222%202.412-4.574%203.48-7.055%203.207-2.48-.275-4.251-1.343-5.31-3.207-2.18-4.023-1.621-7.444%201.675-10.262%203.296-2.818%207.269-3.537%2011.918-2.157z'%20transform='translate(29%208)%20translate(32.223)'/%3e%3cpath%20fill='%23E94A47'%20d='M18.423%200c2.598%200%205.717%201.017%207.994%202.74%202.277%201.722%203.845%203.02%204.55%205.097.47%201.384.248%203.314-.664%205.791.13-2.345-.048-3.647-.533-3.906-.67%201.653-1.595%201.987-2.703%202.787-.62.448-2.791.518-4.917.897-2.628%201.722-4.303%203.33-4.867%204.86-.448%201.218-.402%202.608.148%204.177l.126.339-.54.21c-.714-1.833-.81-3.478-.277-4.925.522-1.417%201.85-2.838%203.894-4.321-1.09.307-2.051.754-2.634%201.449-1.279%201.526-2.028%203.765-2.246%206.716-2.766-.5-5.305-1.433-7.617-2.8-2.312-1.366-4.445-3.194-6.398-5.483.396-.834.904-1.524%201.521-2.07.671-.592%201.935-1.108%203.169-1.822l-.065.021-1.204.401c-1.26.424-1.956.713-2.395%201.032-.83.601-1.26%201.275-1.313%202.032l-.005.191-.579.007c-.012-1.039.516-1.943%201.557-2.699.427-.31%201.013-.573%201.983-.916l1.756-.59.61-.213c.594-.213%201.064-.401%201.439-.584%201.296-1.399%202.17-3.971%204.09-5.678C14.418.855%2015.825%200%2018.422%200z'%20transform='translate(29%208)%20translate(32.223)'/%3e%3cg%20fill='%23222768'%20fill-rule='nonzero'%3e%3cpath%20d='M1.025%203.16C1.622%201.52%203.194.563%204.56%201.06c1.061.386%201.653%201.524%201.586%202.781.36-.092.688-.137.988-.137l.208.008c.254.02.466.056.636.114.511-1.271%201.708-2.023%202.749-1.644%201.07.39%201.5%201.802%201.013%203.14-.487%201.337-1.723%202.143-2.794%201.754-.953-.347-1.397-1.504-1.14-2.697-.103-.038-.274-.072-.508-.09-.334-.025-.737.029-1.209.165l-.03.01c-.036.159-.083.318-.14.477-.597%201.64-2.17%202.597-3.536%202.1C1.017%206.543.428%204.8%201.025%203.16zm9.504-.434c-.73-.266-1.664.343-2.052%201.408-.388%201.065-.064%202.132.667%202.398.73.266%201.664-.343%202.052-1.408.387-1.066.064-2.132-.667-2.398zM4.362%201.604c-1.036-.378-2.297.39-2.793%201.754-.496%201.363-.024%202.762%201.012%203.14%201.036.376%202.298-.392%202.794-1.755s.023-2.762-1.013-3.14z'%20transform='translate(29%208)%20translate(32.223)%20translate(22.112%2010.415)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20mask='url(%23pitr2853ub)'%3e%3cg%3e%3cpath%20fill='%23FFF'%20d='M30%200c12.15%200%2022%209.85%2022%2022v11h8v48H0V33h8V22C8%209.973%2017.654.198%2029.637.004zm0%207.934c-7.755%200-14.067%206.309-14.067%2014.067V33h28.133V22c0-7.652-6.14-13.896-13.752-14.063z'%20transform='translate(134%2061)'/%3e%3cpath%20fill='%23D6D7D8'%20d='M55%2034.3V22C55%209.85%2045.15%200%2033%200S11%209.85%2011%2022v12.3m7.933%200V22c0-7.757%206.312-14.066%2014.068-14.066%207.756%200%2014.065%206.31%2014.065%2014.067v12.298'%20transform='translate(134%2061)'/%3e%3cpath%20fill='url(%23xe2mx0bk0e)'%20d='M3%2033H63V81H3z'%20transform='translate(134%2061)'/%3e%3cpath%20fill='%233E3D4C'%20fill-rule='nonzero'%20d='M39%2056c0-3.314-2.686-6-6-6s-6%202.686-6%206c0%202.282%201.275%204.267%203.15%205.281l-.965%207.386h7.63l-.965-7.386C37.726%2060.267%2039%2058.282%2039%2056z'%20transform='translate(134%2061)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", E1t = ({
  title: i,
  image: e,
  subTitle: t,
  isButtonAvailable: n,
  classname: r,
  styles: s,
  heightToDeduct: o,
  imageType: a,
  renderButton: l,
  imageClassName: c,
  children: d,
  SvgImage: u,
  noImage: h,
  layout: f = "column",
  contentClassName: g = "",
  imageStyles: p = {}
}) => {
  const m = f === "row", _ = () => {
    switch (a) {
      case Vl.Large:
        return { width: "250px", height: "200px" };
      default:
        return { width: "200px", height: "160px" };
    }
  };
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `flex ${m ? "dc__gap-32" : "column dc__gap-20"} empty-state ${r || ""}`,
      style: s,
      "data-testid": "generic-empty-state",
      ...o >= 0 && { style: { ...s, height: `calc(100vh - ${o}px)` } },
      children: [
        u ? /* @__PURE__ */ v.jsx(
          u,
          {
            style: {
              ...p,
              width: `${_().width}`,
              height: `${_().height}`
            }
          }
        ) : !h && /* @__PURE__ */ v.jsx(
          "img",
          {
            className: c || "",
            src: e || Iue,
            style: {
              ...p,
              width: `${_().width}`,
              height: `${_().height}`
            },
            alt: "empty-state"
          }
        ),
        /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: `flex column dc__gap-20 dc__mxw-300 ${m ? "dc__align-start" : ""} ${g}`,
            children: [
              /* @__PURE__ */ v.jsxs("div", { className: "flex column dc__gap-8", children: [
                /* @__PURE__ */ v.jsx("h4", { className: "title fw-6 cn-9 mt-0 mb-0 lh-24 dc__align-center", children: i }),
                t && /* @__PURE__ */ v.jsx("p", { className: `subtitle ${m ? "subtitle--text-start" : ""}`, children: t })
              ] }),
              n && l(),
              d
            ]
          }
        )
      ]
    }
  );
}, oa = E1t, Np = ({ code: i, image: e, title: t, subTitle: n, imageType: r, heightToDeduct: s, redirectURL: o, reload: a }) => {
  const { push: l } = ip(), c = () => {
    l(o || `/${hn.APP_LIST}`);
  }, d = (p) => {
    switch (p) {
      case ms.NOT_FOUND:
        return {
          onClick: c,
          renderButtonText: Jr.TAKE_BACK_HOME,
          isButtonAvailable: !0
        };
      case ms.INTERNAL_SERVER_ERROR:
        return {
          onClick: m1t,
          renderButtonText: Jr.REPORT_ISSUE,
          isButtonAvailable: !0
        };
      case ms.BAD_REQUEST:
      case ms.BAD_GATEWAY:
      case ms.SERVICE_TEMPORARY_UNAVAILABLE:
        return {
          onClick: a ?? aCe,
          renderButtonText: Jr.TRY_AGAIN,
          isButtonAvailable: !0
        };
      default:
        return { onClick: El, renderButtonText: "", isButtonAvailable: !1 };
    }
  }, {
    onClick: u,
    renderButtonText: h,
    isButtonAvailable: f
  } = d(i), g = () => /* @__PURE__ */ v.jsx("button", { type: "button", className: "flex cta h-36", onClick: u, "data-testid": "empty-screen-take-me-home", children: h });
  return /* @__PURE__ */ v.jsx(
    oa,
    {
      image: e,
      title: t,
      subTitle: n,
      isButtonAvailable: f,
      renderButton: g,
      imageType: r,
      heightToDeduct: s
    }
  );
}, L1t = ({
  code: i,
  reload: e,
  subtitle: t,
  reloadClass: n,
  heightToDeduct: r,
  redirectURL: s
}) => (() => {
  switch (i) {
    case ms.BAD_REQUEST:
      return /* @__PURE__ */ v.jsx(
        Np,
        {
          code: ms.BAD_REQUEST,
          title: Jr.BAD_REQUEST,
          subTitle: t || Jr.BAD_REQUEST_MESSAGE,
          image: f3,
          imageType: Vl.Large,
          heightToDeduct: r,
          reload: e
        }
      );
    case ms.UNAUTHORIZED:
      return /* @__PURE__ */ v.jsx(
        Np,
        {
          code: ms.UNAUTHORIZED,
          title: Jr.UNAUTHORIZED,
          subTitle: t || Jr.UNAUTHORIZED_MESSAGE,
          image: LW,
          imageType: Vl.Large,
          heightToDeduct: r
        }
      );
    case ms.PERMISSION_DENIED:
      return /* @__PURE__ */ v.jsx(
        Np,
        {
          code: ms.PERMISSION_DENIED,
          title: Jr.FORBIDDEN,
          subTitle: t || Jr.FORBIDDEN_MESSAGE,
          image: LW,
          imageType: Vl.Large,
          heightToDeduct: r
        }
      );
    case ms.NOT_FOUND:
      return /* @__PURE__ */ v.jsx(
        Np,
        {
          code: ms.NOT_FOUND,
          title: Jr.PAGE_NOT_FOUND,
          subTitle: t || Jr.PAGE_NOT_EXIST,
          image: D1t,
          imageType: Vl.Large,
          heightToDeduct: r,
          redirectURL: s
        }
      );
    case ms.INTERNAL_SERVER_ERROR:
      return /* @__PURE__ */ v.jsx(
        Np,
        {
          code: ms.INTERNAL_SERVER_ERROR,
          title: Jr.INTERNAL_SERVER_ERROR,
          subTitle: t || Jr.INTERNAL_SERVER_ERROR_MESSAGE,
          image: f3,
          imageType: Vl.Large,
          heightToDeduct: r,
          reload: e
        }
      );
    case ms.BAD_GATEWAY:
      return /* @__PURE__ */ v.jsx(
        Np,
        {
          code: ms.BAD_GATEWAY,
          title: Jr.BAD_GATEWAY,
          subTitle: t || Jr.BAD_GATEWAY_MESSAGE,
          image: f3,
          imageType: Vl.Large,
          heightToDeduct: r,
          reload: e
        }
      );
    case ms.SERVICE_TEMPORARY_UNAVAILABLE:
      return /* @__PURE__ */ v.jsx(
        Np,
        {
          code: ms.SERVICE_TEMPORARY_UNAVAILABLE,
          title: Jr.SERVICE_TEMPORARY_UNAVAILABLE,
          subTitle: t || Jr.SERVICE_TEMPORARY_UNAVAILABLE_MESSAGE,
          image: f3,
          imageType: Vl.Large,
          heightToDeduct: r,
          reload: e
        }
      );
    default:
      return /* @__PURE__ */ v.jsx(sA, { heightToDeduct: r, reload: e, className: n });
  }
})(), I1t = L1t, A1t = ({ subtitle: i, title: e }) => /* @__PURE__ */ v.jsx(
  oa,
  {
    image: LW,
    title: e ?? Jr.NOT_AUTHORIZED,
    subTitle: i ?? Jr.ONLY_FOR_SUPERADMIN
  }
), k1t = A1t;
class yk extends it.Component {
  constructor(t) {
    super(t);
    gn(this, "modalRef", document.getElementById("visible-modal"));
    gn(this, "handleBodyClick", (t) => {
      document.getElementById(jde) || (t.stopPropagation(), this.props.close?.(t));
    });
    this.escFunction = this.escFunction.bind(this);
  }
  escFunction(t) {
    Cr(t), (t.keyCode === 27 || t.key === "Escape") && (this.props.onEscape ? this.props.onEscape(t) : this.props.close && this.props.close(t));
  }
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction), this.modalRef.classList.add(this.props.noBackground ? "show" : "show-with-bg"), a_(!0), this.props.parentClassName && this.modalRef.classList.add(this.props.parentClassName);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction), this.modalRef.classList.remove("show"), this.modalRef.classList.remove("show-with-bg"), a_(!1), this.props.parentClassName && this.modalRef.classList.remove(this.props.parentClassName);
  }
  render() {
    return Fm.createPortal(
      /* @__PURE__ */ v.jsx(
        "div",
        {
          className: `visible-modal__body ${this.props.className || ""}`,
          onClick: this.handleBodyClick,
          "data-testid": "visible-modal-close",
          children: this.props.children
        }
      ),
      document.getElementById("visible-modal")
    );
  }
}
const T1t = ({
  children: i,
  position: e,
  height: t,
  width: n,
  minWidth: r,
  maxWidth: s,
  parentClassName: o,
  onEscape: a
}) => {
  const l = Nt(null);
  $e(() => (setTimeout(() => l.current?.classList?.add("show"), 1), a_(!0), () => {
    l.current?.classList?.remove("show"), a_(!1);
  }), []);
  const c = {};
  return (e === "left" || e === "right") && (c["--width"] = n, c["--minWidth"] = r, c["--maxWidth"] = s), (e === "top" || e === "bottom") && (c["--height"] = t), /* @__PURE__ */ v.jsx(yk, { className: "drawer--container", parentClassName: o || "", onEscape: a, children: /* @__PURE__ */ v.jsx("aside", { style: c, ref: l, className: `drawer ${e}`, children: i }) });
};
class N1t extends it.Component {
  constructor(t) {
    super(t);
    gn(this, "modalRef", document.getElementById("visible-modal-2"));
    gn(this, "handleBodyClick", (t) => {
      t.stopPropagation(), this.props.close?.(t);
    });
    this.escFunction = this.escFunction.bind(this);
  }
  escFunction(t) {
    Cr(t), t.keyCode === 27 && this.props.close && this.props.close(t);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction), this.modalRef.classList.add("show-with-bg"), a_(!0);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction), this.modalRef.classList.remove("show-with-bg"), a_(!1);
  }
  render() {
    return Fm.createPortal(
      /* @__PURE__ */ v.jsx(
        "div",
        {
          className: `visible-modal__body ${this.props.className || ""}`,
          onClick: this.handleBodyClick,
          "data-testid": "visible-modal2-close",
          children: this.props.children
        }
      ),
      document.getElementById("visible-modal-2")
    );
  }
}
const P1t = {
  alias: {}
}, Sxt = ({ heading: i, isActive: e }) => /* @__PURE__ */ v.jsx("h2", { className: `m-0 fs-16 fw-6 lh-32 ${e ? "cn-9" : "cb-5"}`, children: i }), O1t = ({ children: i }) => {
  const [e, t] = Oe(P1t);
  return /* @__PURE__ */ v.jsx(fCe.Provider, { value: { state: e, setState: t }, children: i });
}, fCe = nf({
  state: { alias: {} },
  setState: null
});
function M1t() {
  const i = it.useContext(fCe);
  if (!i)
    throw new Error("breadcrumb components cannot be used outside Breadcrumb context");
  return i;
}
const xxt = O1t;
it.createContext(null);
function Dxt(i, e) {
  const t = i?.sep || "/";
  e = e || [];
  const { url: n, path: r } = fd(), s = eo(), { state: o, setState: a } = M1t();
  $e(() => {
    if (!(!i || !i.alias))
      return a((h) => ({ ...h, alias: { ...h.alias, ...i.alias } })), () => c(Object.keys(i.alias));
  }, e);
  function l(h) {
    a((f) => ({ ...f, alias: { ...f.alias, ...h } }));
  }
  function c(h) {
    const f = h.reduce((g, p, m) => (delete g[p], g), o.alias);
    a((g) => ({ ...g, alias: f }));
  }
  const d = Mn(() => {
    const h = r.split("/").filter(Boolean), f = n.split("/").filter(Boolean);
    return h.map((g, p) => {
      const m = { to: f[p], name: g };
      return g.startsWith(":") && s[g.replace(":", "")] && (m.className = "param"), m;
    });
  }, [r, n]), { res: u } = Mn(
    () => d.reduce(
      (h, f, g) => {
        const { res: p, prefix: m } = h, { to: _, name: b } = f;
        return p.push({
          to: !o.alias[b]?.component || o.alias[b]?.component && o.alias[b]?.linked ? `${m}${_}` : null,
          name: typeof o.alias[b] == "object" ? o.alias[b]?.component ? o.alias[b].component : null : o.alias[b] || b,
          className: f.className || ""
        }), { res: p, prefix: `${m}${f.to}${t}` };
      },
      { res: [], prefix: "/" }
    ),
    [d, o]
  );
  return { breadcrumbs: u, setCrumb: l, resetCrumb: c };
}
const gCe = ({
  breadcrumbs: i,
  sep: e = "/",
  className: t = "dc__devtron-breadcrumb__item"
}) => {
  const { url: n } = fd(), r = i.filter((s) => !!s.name);
  return /* @__PURE__ */ v.jsx(v.Fragment, { children: r.map((s, o) => /* @__PURE__ */ v.jsxs(it.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      lc,
      {
        condition: !!s.to,
        wrap: (a) => /* @__PURE__ */ v.jsx(
          D0,
          {
            className: `${n === s.to ? "active" : ""} ${t} ${s.className || ""}`,
            to: s.to,
            children: a
          }
        ),
        children: s.name
      }
    ),
    o + 1 !== r.length && s.name && /* @__PURE__ */ v.jsx("span", { className: `${t}__separator cn-5`, children: e })
  ] }, o)) });
}, pCe = nf({
  name: "",
  value: "",
  disabled: !1,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange: (i) => {
  }
}), R1t = ({ name: i, value: e, disabled: t, onChange: n, className: r, children: s }) => {
  const o = Mn(() => ({ name: i, value: e, disabled: t, onChange: n }), [i, e, t, n]);
  return /* @__PURE__ */ v.jsx("div", { className: `form__radio-group ${r || ""}`, children: /* @__PURE__ */ v.jsx(pCe.Provider, { value: o, children: s }) });
}, Ext = R1t, F1t = ({ value: i, disabled: e, children: t, dataTestId: n }) => /* @__PURE__ */ v.jsx(pCe.Consumer, { children: (r) => (
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  /* @__PURE__ */ v.jsxs("label", { className: e || r.disabled ? "form__radio-item disabled" : "form__radio-item", children: [
    /* @__PURE__ */ v.jsx(
      "input",
      {
        type: "radio",
        className: "form__checkbox",
        name: r.name,
        disabled: r.disabled || e,
        onChange: r.onChange,
        value: i,
        checked: r.value === i,
        "data-testid": n
      }
    ),
    /* @__PURE__ */ v.jsxs("span", { className: "form__radio-item-content", "data-testid": `${n}-span`, children: [
      /* @__PURE__ */ v.jsx("span", { className: "radio__button" }),
      /* @__PURE__ */ v.jsx("span", { className: "radio__title", children: t })
    ] })
  ] })
) }), Lxt = F1t, bE = (i) => /* @__PURE__ */ G.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M10 10H3.33333", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("circle", { cx: 9.99992, cy: 9.99967, r: 1.66667, fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M4.41455 6.40325L9.76177 3.39544C9.83454 3.35451 9.91661 3.33301 10.0001 3.33301C10.0836 3.33301 10.1657 3.35451 10.2384 3.39544L15.5856 6.40325C15.6608 6.44554 15.7234 6.50706 15.7669 6.58152C15.8105 6.65598 15.8334 6.74068 15.8334 6.82693V12.8208C15.8334 12.9071 15.8105 12.9918 15.7669 13.0662C15.7234 13.1407 15.6608 13.2022 15.5856 13.2445L10.2384 16.2523C10.1657 16.2933 10.0836 16.3148 10.0001 16.3148C9.91661 16.3148 9.83454 16.2933 9.76177 16.2523L4.41455 13.2445", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
function B1t({ isCreateApp: i }) {
  const e = () => /* @__PURE__ */ v.jsxs("div", { className: "p-12 fs-13", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "mb-20", children: [
      /* @__PURE__ */ v.jsxs("span", { className: "flex left", children: [
        "Add a tag and click on the",
        /* @__PURE__ */ v.jsx(bE, { className: "icon-dim-16 ml-4 mr-4" }),
        "icon to"
      ] }),
      "propagate tags as labels to Kubernetes resources"
    ] }),
    /* @__PURE__ */ v.jsx("div", { children: "Use these tags to filter/identify resources via CLI or in other Kubernetes tools." })
  ] });
  return /* @__PURE__ */ v.jsx(
    Yde,
    {
      theme: uA.white,
      className: "w-300",
      placement: "top",
      Icon: bE,
      heading: "Propagate tags to K8s resources",
      infoText: "",
      additionalContent: e(),
      showCloseButton: !0,
      trigger: "click",
      interactive: !0,
      documentationLink: i ? ey.APP_TAGS : ey.APP_OVERVIEW_TAGS,
      documentationLinkText: "View Documentation",
      children: /* @__PURE__ */ v.jsxs("div", { className: "flexbox cursor", children: [
        /* @__PURE__ */ v.jsx(bE, { className: "icon-dim-16 mt-2 mr-4" }),
        /* @__PURE__ */ v.jsx("span", { children: "Propagate tags" }),
        /* @__PURE__ */ v.jsx(lb, { className: "icon-dim-16 mt-2 ml-4" })
      ] })
    }
  );
}
const mCe = ({
  className: i,
  minHeight: e,
  maxHeight: t,
  value: n,
  onChange: r,
  onBlur: s,
  onFocus: o,
  placeholder: a,
  tabIndex: l,
  refVar: c,
  dependentRef: d,
  dataTestId: u,
  handleKeyDown: h,
  disabled: f,
  disableOnBlurResizeToMinHeight: g
}) => {
  const [p, m] = Oe("");
  $e(() => {
    m(n);
  }, [n]);
  const _ = (S) => {
    m(S.target.value), r?.(S);
  }, b = () => {
    if (document.activeElement !== c.current) return;
    c.current.style.height = `${e}px`, d && (d.current.style.height = `${e}px`);
    let S = c.current.scrollHeight;
    d && S < d.current.scrollHeight && (S = d.current.scrollHeight), e && S < e && (S = e), t && S > t && (S = t), c.current.style.height = `${S}px`, d && (d.current.style.height = `${S}px`);
  };
  Yq(b, 500, [p]);
  const w = (S) => {
    g || (c.current.style.height = `${e}px`, d && (d.current.style.height = `${e}px`)), s && s(S);
  }, y = (S) => {
    b(), o && o(S);
  };
  return /* @__PURE__ */ v.jsx(
    "textarea",
    {
      rows: 1,
      ref: c,
      value: p,
      placeholder: a,
      className: `${i || ""} lh-20`,
      style: { resize: "none" },
      onChange: _,
      onBlur: w,
      onFocus: y,
      tabIndex: l,
      "data-testid": u,
      onKeyDown: h,
      disabled: f
    }
  );
}, n8 = (i) => {
  const e = [];
  return i.length > 63 && e.push("Can be max 63 characters"), yE.START_END_ALPHANUMERIC.test(i) || e.push("Must start and end with an alphanumeric character"), yE.ALPHANUMERIC_WITH_SPECIAL_CHAR.test(i) || e.push("Can only contain alphanumeric chars and (-), (_), (.)"), e;
};
class vCe {
  constructor() {
    gn(this, "propagateTagKey", (e) => {
      const t = [];
      if (!e)
        t.push("Key is required");
      else if (!e.startsWith("devtron.ai/")) {
        const n = new RegExp("/", "g"), r = e.match(n)?.length;
        if (r > 1)
          t.push("Key: Max 1 ( / ) allowed");
        else if (r === 1) {
          const [s, o] = e.split("/");
          t.push(...n8(o).map((l) => `Name: ${l}`)), s.length > 253 && t.push("Prefix: Can be max 253 characters"), yE.KUBERNETES_KEY_PREFIX.test(s) || t.push("Prefix: Must be a DNS subdomain (a series of DNS labels separated by dots (.)");
        } else
          t.push(...n8(e).map((s) => `Name: ${s}`));
      }
      return { isValid: t.length === 0, messages: t };
    });
    gn(this, "propagateTagValue", (e, t) => {
      const n = [];
      return e ? t.startsWith("devtron.ai/") || n.push(...n8(e)) : n.push("Value is required"), { isValid: n.length === 0, messages: n };
    });
  }
}
const Cle = ({
  selectedTagIndex: i,
  tagData: e,
  setTagData: t,
  tagOptions: n,
  isRequired: r,
  tagInputType: s,
  placeholder: o,
  tabIndex: a = null,
  refVar: l,
  dependentRef: c,
  noBackDrop: d
}) => {
  const [u, h] = Oe(""), [f, g] = Oe(""), p = new vCe();
  $e(() => {
    h(e?.[s] || "");
  }, [i, e, s]);
  const m = (L) => {
    setTimeout(() => {
      g(`tag-${s}-${i}`);
    }, 300);
  }, _ = (L) => {
    if (!L.relatedTarget || !L.relatedTarget.classList.value || !L.relatedTarget.classList.value.includes(`tag-${i}-class`)) {
      g("");
      const k = { ...e };
      k[s] = u, s === ah.KEY ? k.isInvalidKey = u || k.propagate ? !p.propagateTagKey(u).isValid : k.value !== "" : u || r || k.propagate ? (k.isInvalidValue = !p.propagateTagValue(u, k.key).isValid, k.isInvalidKey = !k.key || k.isInvalidKey) : (k.isInvalidValue = !1, k.isInvalidKey = k.key ? k.isInvalidKey : !1), t(i, k);
    }
  }, b = (L) => {
    h(L.target.value);
  }, w = (L) => {
    Cr(L);
    const k = { ...e };
    k[s] = L.currentTarget.dataset.key, k.propagate = L.currentTarget.dataset.propagate === "true", t(i, k), g("");
  }, y = () => {
    let L = { isValid: !0, messages: [] };
    return s === ah.KEY ? (u || e.value) && (L = p.propagateTagKey(u)) : (r || u || e.propagate) && (L = p.propagateTagValue(u, e.key)), L.isValid ? null : /* @__PURE__ */ v.jsxs("div", { className: "p-4", onClick: Cr, "data-testid": "tag-label-cross-stop-propagation", children: [
      L.messages.map((k) => /* @__PURE__ */ v.jsxs("div", { className: "flexbox pr-4 pl-4", children: [
        /* @__PURE__ */ v.jsx("span", { children: /* @__PURE__ */ v.jsx(ab, { className: "icon-dim-14 scr-5 mt-3 mr-4" }) }),
        /* @__PURE__ */ v.jsx("span", { children: k })
      ] }, k)),
      s === ah.KEY && /* @__PURE__ */ v.jsxs("div", { className: "flexbox pr-4 pl-4", children: [
        /* @__PURE__ */ v.jsx("span", { children: /* @__PURE__ */ v.jsx(VA, { className: "icon-dim-14 mt-3 mr-4" }) }),
        /* @__PURE__ */ v.jsx("span", { className: "dc__italic-font-style", children: "Key format: prefix/name or name" })
      ] })
    ] });
  }, S = (L, k) => /* @__PURE__ */ v.jsx(
    "div",
    {
      "data-key": L.label,
      "data-propagate": L.propagate,
      className: "dc__hover-n50 dc__ellipsis-right lh-20 fs-13 fw-4 pt-6 pr-8 pb-6 pl-8 cursor",
      onClick: w,
      "data-testid": `tag-label-value-${k}`,
      children: L.label
    },
    `${L.value}-${k}`
  ), x = (L, k) => /* @__PURE__ */ v.jsx(
    wn,
    {
      className: "default-tt",
      arrow: !1,
      placement: "right",
      content: /* @__PURE__ */ v.jsxs("div", { children: [
        /* @__PURE__ */ v.jsx("div", { className: "mb-10 fs-12 fw-6 cn-0 dc__break-word", children: L.label }),
        /* @__PURE__ */ v.jsx("div", { className: "fs-12 fw-4 cn-0 dc__break-word", children: L.description })
      ] }),
      children: S(L, k)
    }
  ), D = () => {
    if (n?.length) {
      const L = n.filter((k) => k.label.indexOf(u) >= 0);
      if (L.length)
        return /* @__PURE__ */ v.jsx("div", { children: L.map(
          (k, N) => k.description ? x(k, N) : S(k, N)
        ) });
    }
    return y();
  }, E = f === `tag-${s}-${i}` ? D() : null;
  return /* @__PURE__ */ v.jsxs(tc, { autoClose: !0, autoPosition: !0, children: [
    /* @__PURE__ */ v.jsx(tc.Button, { rootClassName: "dc__bg-n50 flex top dc__no-border-imp", children: /* @__PURE__ */ v.jsx(
      mCe,
      {
        minHeight: 30,
        maxHeight: 80,
        className: `form__input tag-input pt-4-imp pb-4-imp fs-13 ${s === ah.KEY ? "dc__no-right-radius" : "dc__no-border-radius dc__no-right-border dc__no-left-border"} ${e[s === ah.KEY ? "isInvalidKey" : "isInvalidValue"] ? "form__input--error" : ""}`,
        value: u,
        onChange: b,
        onBlur: _,
        onFocus: m,
        placeholder: o,
        tabIndex: a,
        refVar: l,
        dependentRef: c,
        dataTestId: `tag-${s === ah.KEY ? "key" : "value"}-${i}`
      }
    ) }),
    E && /* @__PURE__ */ v.jsx(
      tc.Body,
      {
        rootClassName: `mxh-210 dc__overflow-auto tag-${i}-class`,
        autoWidth: !0,
        preventWheelDisable: !0,
        noBackDrop: d,
        children: E
      }
    )
  ] });
}, V1t = ({
  index: i,
  tagData: e,
  setTagData: t,
  removeTag: n,
  tabIndex: r = 1,
  suggestedTagsOptions: s,
  hidePropagateTag: o
}) => {
  const a = Nt(null), l = Nt(null), c = new vCe(), d = (h) => {
    Cr(h), n(i);
  }, u = () => {
    const h = { ...e };
    h.propagate = !h.propagate, h.propagate ? (h.isInvalidKey = h.isInvalidKey || !h.key, h.isInvalidValue = h.isInvalidValue || !h.value) : (h.isInvalidKey = h.key || h.value ? !c.propagateTagKey(h.key).isValid : !1, h.isInvalidValue = h.value ? !c.propagateTagValue(h.value, h.key).isValid : !1), t(i, h);
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "flexbox mb-8", children: [
    !o && /* @__PURE__ */ v.jsx(
      "div",
      {
        className: `dc__border h-30 pl-4 pr-4 br-4 mr-8 pointer ${e.propagate ? "bcn-7" : ""} ${e.key.startsWith("devtron.ai/") ? "cursor-not-allowed bcn-1" : ""}`,
        onClick: u,
        "data-testid": `propagate-tag-${i}`,
        children: /* @__PURE__ */ v.jsx(bE, { className: `icon-dim-20 mt-4 ${e.propagate ? "scn-0" : ""}` })
      }
    ),
    /* @__PURE__ */ v.jsx(
      Cle,
      {
        selectedTagIndex: i,
        tagData: e,
        setTagData: t,
        tagInputType: ah.KEY,
        placeholder: "Enter key",
        tabIndex: r - 1,
        refVar: a,
        dependentRef: l,
        tagOptions: s
      }
    ),
    /* @__PURE__ */ v.jsx(
      Cle,
      {
        selectedTagIndex: i,
        tagData: e,
        setTagData: t,
        tagInputType: ah.VALUE,
        placeholder: "Enter value",
        tabIndex: r,
        refVar: l,
        dependentRef: a
      }
    ),
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: "dc__border pl-4 pr-4 dc__right-radius-4 pointer flex top",
        onClick: d,
        "data-testid": `delete-tag-${i}`,
        children: /* @__PURE__ */ v.jsx(ab, { className: "icon-dim-20 mt-4" })
      }
    )
  ] });
}, Ixt = ({ isCreateApp: i, labelTags: e, setLabelTags: t, tabIndex: n = 0, hidePropagateTag: r }) => {
  const s = (l, c) => {
    const d = [...e], u = c;
    u.key.startsWith("devtron.ai/") && (u.propagate = !1), d[l] = u, t(d);
  }, o = () => {
    const l = [...e];
    l.splice(0, 0, XCe), t(l);
  }, a = (l) => {
    const c = [...e];
    c.splice(l, 1), t(c);
  };
  return /* @__PURE__ */ v.jsxs("div", { children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__content-space mb-8", children: [
      /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: "dc_width-max-content cb-5 fw-6 fs-13 flexbox mr-20 mb-8 cursor",
          onClick: o,
          "data-testid": "add-tag-button",
          children: [
            /* @__PURE__ */ v.jsx(fS, { className: "icon-dim-20 fcb-5" }),
            " Add"
          ]
        }
      ),
      !r && /* @__PURE__ */ v.jsx(B1t, { isCreateApp: i })
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: "mb-8", "data-testid": "tag-rows-container", children: e?.map((l, c) => /* @__PURE__ */ v.jsx(
      V1t,
      {
        index: c,
        tagData: l,
        setTagData: s,
        removeTag: a,
        tabIndex: n + (c + 2),
        hidePropagateTag: r
      },
      `tag-${c}`
    )) })
  ] });
}, wk = ({ className: i = "", children: e }) => /* @__PURE__ */ v.jsx(N1t, { className: "confirmation-dialog", children: /* @__PURE__ */ v.jsx("div", { className: `confirmation-dialog__body ${i}`, children: e }) }), H1t = ({ src: i, className: e = "" }) => /* @__PURE__ */ v.jsx("img", { src: i, className: `confirmation-dialog__icon ${e}`, alt: "" }), W1t = ({ title: i, subtitle: e = null, children: t = null }) => /* @__PURE__ */ v.jsxs("div", { className: "flex left column ", children: [
  /* @__PURE__ */ v.jsx("h3", { className: "confirmation-dialog__title lh-1-5 dc__break-word w-100", children: i }),
  e && /* @__PURE__ */ v.jsx("div", { className: "confirmation-dialog__subtitle", children: e }),
  t
] }), j1t = ({ children: i }) => /* @__PURE__ */ v.jsx("div", { className: "flex right confirmation-dialog__button-group", children: i });
wk.Icon = H1t;
wk.Body = W1t;
wk.ButtonGroup = j1t;
const ko = wk, z1t = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20-%20-%20Licensed%20under%20the%20Apache%20License,%20Version%202.0%20(the%20'License');%20-%20you%20may%20not%20use%20this%20file%20except%20in%20compliance%20with%20the%20License.%20-%20You%20may%20obtain%20a%20copy%20of%20the%20License%20at%20-%20-%20http://www.apache.org/licenses/LICENSE-2.0%20-%20-%20Unless%20required%20by%20applicable%20law%20or%20agreed%20to%20in%20writing,%20software%20-%20distributed%20under%20the%20License%20is%20distributed%20on%20an%20'AS%20IS'%20BASIS,%20-%20WITHOUT%20WARRANTIES%20OR%20CONDITIONS%20OF%20ANY%20KIND,%20either%20express%20or%20implied.%20-%20See%20the%20License%20for%20the%20specific%20language%20governing%20permissions%20and%20-%20limitations%20under%20the%20License.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='44'%20height='46'%20viewBox='0%200%2044%2046'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5%2024H29V41C29%2043.2091%2027.2091%2045%2025%2045H9C6.79086%2045%205%2043.2091%205%2041V24Z'%20fill='%23F33E3E'%20fill-opacity='0.12'%20stroke='%23F33E3E'%20stroke-width='2'%20stroke-linejoin='round'/%3e%3cpath%20d='M17%2029.5V39.5'%20stroke='%23F33E3E'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M22%2029.5V39.5'%20stroke='%23F33E3E'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M12%2029.5V39.5'%20stroke='%23F33E3E'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M40%2010C41.6569%2010%2043%2011.3431%2043%2013C43%2014.6569%2041.6569%2016%2040%2016H31'%20stroke='%23F33E3E'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M36%2023C36%2021.3431%2034.6569%2020%2033%2020H25'%20stroke='%23F33E3E'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M29.6903%207.03989L2.11567%2011.902C1.57177%2011.9979%201.2086%2012.5166%201.30451%2013.0605L1.82545%2016.0149C1.92136%2016.5588%202.44001%2016.922%202.98391%2016.8261L30.5585%2011.9639C31.1024%2011.868%2031.4656%2011.3494%2031.3697%2010.8055L30.8487%207.85105C30.7528%207.30715%2030.2342%206.94398%2029.6903%207.03989Z'%20fill='%23F33E3E'%20fill-opacity='0.12'%20stroke='%23F33E3E'%20stroke-width='2'%20stroke-linejoin='round'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M10.9227%204.25671L18.8012%202.86752C19.889%202.67572%2020.9263%203.40205%2021.1181%204.48984L21.8127%208.42907L9.99501%2010.5129L9.30042%206.57362C9.10861%205.48583%209.83495%204.44851%2010.9227%204.25671Z'%20stroke='%23F33E3E'%20stroke-width='2'%20stroke-linejoin='round'/%3e%3c/svg%3e", eS = ({
  showDeleteConfirmation: i,
  deleteConfirmationText: e = null,
  ...t
}) => {
  const [n, r] = Oe(""), s = i && !!e, o = t.apiCallInProgress || t.disabled || s && e !== n, a = (h) => {
    r(h.target.value);
  }, l = (h) => {
    t.shouldStopPropagation && h.stopPropagation(), t.delete();
  }, c = (h) => {
    h.key === "Enter" && !o && (h.preventDefault(), t.shouldStopPropagation && h.stopPropagation(), t.delete());
  }, d = (h) => {
    t.shouldStopPropagation && h.stopPropagation(), t.closeDelete();
  }, u = () => /* @__PURE__ */ v.jsxs("span", { children: [
    "Type",
    /* @__PURE__ */ v.jsxs("span", { className: "fw-6 dc__word-break", children: [
      " '",
      e,
      "' "
    ] }),
    "to confirm"
  ] });
  return /* @__PURE__ */ v.jsxs(ko, { className: "confirmation-dialog__body--w-400", children: [
    /* @__PURE__ */ v.jsx(ko.Icon, { src: z1t }),
    /* @__PURE__ */ v.jsx(ko.Body, { title: t.title, children: /* @__PURE__ */ v.jsxs("div", { className: "fs-13 cn-7 lh-1-54 w-100", children: [
      t.description ? t.description : null,
      t.children,
      s && /* @__PURE__ */ v.jsx(
        Ck,
        {
          name: "delete-confirmation",
          value: n,
          onChange: a,
          label: u(),
          inputWrapClassName: "mt-12 w-100",
          placeholder: `Type ${e} to confirm`,
          isRequiredField: !0,
          onKeyDown: c,
          autoFocus: !0
        }
      )
    ] }) }),
    /* @__PURE__ */ v.jsx(ko.ButtonGroup, { children: /* @__PURE__ */ v.jsxs("div", { className: "flex right", children: [
      /* @__PURE__ */ v.jsx(
        "button",
        {
          type: "button",
          className: "cta cancel cta-cd-delete-modal ml-16",
          onClick: d,
          disabled: t.apiCallInProgress,
          "data-testid": "dialog-cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "button",
        {
          type: "button",
          className: "cta delete cta-cd-delete-modal ml-16",
          onClick: l,
          disabled: o,
          "data-testid": "dialog-delete",
          children: t.apiCallInProgress ? /* @__PURE__ */ v.jsx(Yr, {}) : `${t.deletePrefix || ""}${t.buttonPrimaryText ? t.buttonPrimaryText : "Delete"}${t.deletePostfix || ""}`
        }
      )
    ] }) })
  ] });
}, U1t = ({ children: i }) => /* @__PURE__ */ v.jsx(v.Fragment, { children: i });
eS.Description = U1t;
const IW = nf({ title: "", isLoading: !1, close: (i) => {
}, onSave: (i) => {
} });
class Axt extends nS {
  constructor(e) {
    super(e), this.escFunction = this.escFunction.bind(this);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction);
  }
  escFunction(e) {
    e.keyCode === 27 && this.props.closeOnESC && this.props.close(e);
  }
  render() {
    return /* @__PURE__ */ v.jsx(
      IW.Provider,
      {
        value: {
          title: this.props.title,
          isLoading: this.props.isLoading,
          close: this.props.close,
          onSave: this.props.onSave
        },
        children: /* @__PURE__ */ v.jsx(yk, { className: "", children: /* @__PURE__ */ v.jsxs("div", { className: `modal__body ${this.props.className || ""}`, children: [
          /* @__PURE__ */ v.jsxs("div", { className: `modal__header ${this.props.headerClassName || ""}`, children: [
            /* @__PURE__ */ v.jsx("h1", { className: "modal__title", children: this.props.title }),
            /* @__PURE__ */ v.jsxs("button", { type: "button", className: "dc__transparent", onClick: this.props.close, children: [
              " ",
              /* @__PURE__ */ v.jsx("img", { src: YAe, alt: "close" })
            ] })
          ] }),
          /* @__PURE__ */ v.jsx(IW.Consumer, { children: (e) => /* @__PURE__ */ v.jsx(
            "form",
            {
              noValidate: !0,
              onSubmit: (t) => {
                t.preventDefault(), e.isLoading || e.onSave(t);
              },
              children: this.props.children
            }
          ) })
        ] }) })
      }
    );
  }
}
class kxt extends nS {
  render() {
    return /* @__PURE__ */ v.jsx(IW.Consumer, { children: (e) => /* @__PURE__ */ v.jsx("button", { type: "submit", className: "cta dc__align-right", tabIndex: this.props.tabIndex, children: e.isLoading ? /* @__PURE__ */ v.jsx(Yr, {}) : this.props.children }) });
  }
}
function Txt({
  onClickDelete: i,
  closeDeleteModal: e,
  forceDeleteDialogTitle: t,
  forceDeleteDialogMessage: n
}) {
  return /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(
    eS,
    {
      title: t,
      delete: i,
      closeDelete: e,
      deletePrefix: "Force ",
      children: /* @__PURE__ */ v.jsxs(eS.Description, { children: [
        /* @__PURE__ */ v.jsxs("p", { className: "mt-12 mb-12 p-8 dc__break-word dc__window-bg", children: [
          "Error: ",
          n
        ] }),
        /* @__PURE__ */ v.jsx("p", { children: "Do you want to force delete?" })
      ] })
    }
  ) });
}
const G1t = ({
  message: i,
  classname: e,
  Icon: t,
  iconClass: n,
  iconSize: r,
  renderActionButton: s,
  linkText: o,
  redirectLink: a,
  linkOnClick: l,
  linkClass: c,
  internalLink: d,
  styles: u,
  hideIcon: h = !1
}) => {
  const f = () => o ? a ? d ? /* @__PURE__ */ v.jsx(
    D0,
    {
      to: a,
      onClick: l,
      "data-testid": "info-bar-internal-link",
      className: "cursor dc__link dc__underline-onhover mr-5",
      children: o
    }
  ) : /* @__PURE__ */ v.jsx(
    "a",
    {
      href: a,
      target: "_blank",
      onClick: l,
      "data-testid": "info-bar-redirectLink",
      className: "cursor dc__link dc__underline-onhover mr-5",
      rel: "noreferrer",
      children: o
    }
  ) : l && /* @__PURE__ */ v.jsx(
    "div",
    {
      onClick: l,
      className: "cursor dc__link dc__underline-onhover",
      "data-testid": "info-bar-linkText",
      children: o
    }
  ) : null;
  return /* @__PURE__ */ v.jsx("div", { className: "info-bar-container", children: /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `${e} info_text flex dc__content-space pt-8 pb-8 pl-12 pr-12 br-4 top fs-13 fw-4`,
      style: u,
      children: [
        /* @__PURE__ */ v.jsxs("div", { className: `flex top ${typeof s == "function" ? "mr-5" : ""}`, children: [
          !h && /* @__PURE__ */ v.jsx("div", { className: `icon-dim-${r ?? "20"} mr-10`, children: /* @__PURE__ */ v.jsx(t, { className: `icon-dim-${r ?? "20"} ${n || ""} mr-8` }) }),
          /* @__PURE__ */ v.jsxs("div", { className: `info-bar-message-wrapper ${c || ""}`, children: [
            /* @__PURE__ */ v.jsx("span", { className: o && a ? "mr-5" : "", children: i }),
            f()
          ] })
        ] }),
        typeof s == "function" && s()
      ]
    }
  ) });
}, q1t = G1t, K1t = "data:image/png;base64,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", Y1t = ({
  handleClearFilters: i,
  isButtonAvailable: e,
  renderButton: t,
  ...n
}) => {
  const r = !!i, s = () => /* @__PURE__ */ v.jsx("button", { type: "button", onClick: i, className: "cta secondary flex h-32 lh-20-imp", children: "Clear Filters" });
  return /* @__PURE__ */ v.jsx(
    oa,
    {
      image: K1t,
      title: "No results",
      subTitle: "We couldn’t find any matching results",
      ...n,
      isButtonAvailable: r || e,
      renderButton: r ? s : t
    }
  );
}, X1t = Y1t, Z1t = (i) => {
  switch (i) {
    case Mi.large:
      return "h-36";
    default:
      return "h-32";
  }
}, Q1t = ({
  initialSearchText: i = "",
  handleSearchChange: e = () => {
  },
  handleEnter: t = () => {
  },
  inputProps: n = {},
  containerClassName: r,
  shouldDebounce: s = !1,
  debounceTimeout: o = 300,
  dataTestId: a = "search-bar",
  noBackgroundAndBorder: l = !1,
  size: c = Mi.medium
}) => {
  const [d, u] = Oe(!!i), h = Nt(), f = Wi(C1t(e, o), [
    e,
    o
  ]);
  $e(() => {
    h.current.value = i, u(!!i);
  }, [i]);
  const g = (w) => {
    e(w), t(w);
  }, p = () => {
    h.current.value = "", g(""), u(!1);
  }, m = (w) => {
    const { value: y } = w.target;
    u(!!y), s ? f(y) : e(y);
  }, _ = (w) => {
    const { key: y } = w;
    if (y === "Enter") {
      w.preventDefault();
      const x = w.target.value.trim();
      g(x);
    }
  }, b = (w = null) => {
    n.ref && (n.ref.current = w), h.current = w;
  };
  return /* @__PURE__ */ v.jsx("div", { className: `search-bar-container ${r || ""}`, children: /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `search-bar ${l ? "dc__no-border dc__no-background dc__hover-n50" : "bc-n50 en-2 dc__hover-border-n300"} focus-within-border-b5 dc__block w-100 min-w-200 dc__position-rel br-4 bw-1 ${Z1t(c)}`,
      children: [
        /* @__PURE__ */ v.jsx(j8, { className: "search-bar__icon dc__position-abs icon-color-n6 icon-dim-16" }),
        /* @__PURE__ */ v.jsx(
          "input",
          {
            placeholder: "Search",
            "data-testid": a,
            type: "text",
            ...n,
            defaultValue: i,
            className: `search-bar__input  dc__position-abs w-100 h-100 br-4 dc__no-border pt-6 pr-10 pb-6 pl-30 fs-13 lh-20 fw-4 cn-9 placeholder-cn5 dc__left-0 ${d ? "pr-30" : "pr-10"} ${l ? "dc__no-background" : "bc-n50"}`,
            onChange: m,
            onKeyDown: _,
            ref: b
          }
        ),
        d && /* @__PURE__ */ v.jsx(
          "button",
          {
            className: "flex search-bar__clear-button dc__position-abs dc__transparent mt-0 mb-0 mr-5 ml-5",
            type: "button",
            onClick: p,
            "aria-label": "Clear search",
            children: /* @__PURE__ */ v.jsx(FA, { className: "icon-dim-16 icon-n4 dc__vertical-align-middle" })
          }
        )
      ]
    }
  ) });
}, _Ce = Q1t, yle = ({
  isSorted: i,
  triggerSorting: e,
  sortOrder: t,
  title: n,
  disabled: r,
  isSortable: s = !0,
  showTippyOnTruncate: o = !1
}) => {
  const a = () => s ? i ? /* @__PURE__ */ v.jsx(
    kq,
    {
      className: `icon-dim-12 mw-12 scn-7 dc__no-shrink dc__transition--transform ${t === Xi.DESC ? "dc__flip-180" : ""}`
    }
  ) : /* @__PURE__ */ v.jsx(tCe, { className: "icon-dim-12 mw-12 scn-7 dc__no-shrink" }) : null;
  return /* @__PURE__ */ v.jsxs(
    "button",
    {
      type: "button",
      className: `dc__transparent p-0 bcn-0 cn-7 flex dc__content-start dc__gap-4 dc__select-text ${s ? "" : "cursor-default"}`,
      onClick: s ? e : El,
      disabled: r,
      children: [
        /* @__PURE__ */ v.jsx(mx, { showOnTruncate: o, content: n, children: /* @__PURE__ */ v.jsx("span", { className: "dc__uppercase dc__ellipsis-right", children: n }) }),
        a()
      ]
    }
  );
}, J1t = ({
  selected: i = !1,
  onSelect: e = null,
  color: t = "#36b37e",
  rootClassName: n = "",
  disabled: r = !1,
  dataTestId: s = "handle-toggle-button",
  Icon: o = null,
  iconClass: a = "",
  ...l
}) => {
  const [c, d] = it.useState(i);
  gle(() => {
    typeof e == "function" && c !== i && e(c);
  }, [c]), gle(() => {
    d(i);
  }, [i]);
  function u(h) {
    r || d((f) => !f);
  }
  return /* @__PURE__ */ v.jsxs(
    "label",
    {
      ...l,
      className: `${n} toggle__switch ${r ? "disabled" : ""}`,
      style: { "--color": t },
      children: [
        /* @__PURE__ */ v.jsx("input", { type: "checkbox", checked: !!c, onChange: u, className: "toggle__input" }),
        /* @__PURE__ */ v.jsx("span", { className: `toggle__slider ${o ? "with-icon br-4 dc__border" : "round"}`, "data-testid": s, children: o && /* @__PURE__ */ v.jsx(o, { className: `icon-dim-20 br-4 p-2 ${a}` }) })
      ]
    }
  );
}, bCe = J1t;
var qp = /* @__PURE__ */ ((i) => (i.SEVERITY = "severity", i.PACKAGE = "package", i))(qp || {});
function $1t({
  vulnerabilities: i,
  hidePolicy: e,
  shouldStick: t
}) {
  const { sortBy: n, sortOrder: r, handleSorting: s } = jve({
    initialSortKey: qp.SEVERITY
  }), o = Mn(
    () => i.sort((d, u) => n === qp.PACKAGE ? Qs(d.package, u.package, r) : qde(
      wE[d.severity],
      wE[u.severity],
      r
    )),
    [n, r, i]
  ), a = () => s(qp.SEVERITY), l = () => s(qp.PACKAGE), c = (d) => /* @__PURE__ */ v.jsxs(
    "tr",
    {
      className: "dc__security-tab__table-row cursor",
      onClick: (u) => {
        window.open(`https://cve.mitre.org/cgi-bin/cvename.cgi?name=${d.name}`, "_blank");
      },
      children: [
        /* @__PURE__ */ v.jsx("td", { className: "security-tab__cell-cve dc__cve-cell", children: /* @__PURE__ */ v.jsx(
          "a",
          {
            href: `https://cve.mitre.org/cgi-bin/cvename.cgi?name=${d.name}`,
            rel: "noopener noreferrer",
            target: "_blank",
            children: d.name
          }
        ) }),
        /* @__PURE__ */ v.jsx("td", { className: "security-tab__cell-severity", children: /* @__PURE__ */ v.jsx(
          "span",
          {
            className: `severity-chip severity-chip--${d.severity?.toLowerCase()} dc__capitalize dc__w-fit-content`,
            children: d.severity
          }
        ) }),
        /* @__PURE__ */ v.jsx("td", { className: "security-tab__cell-package", children: d.package }),
        /* @__PURE__ */ v.jsx("td", { className: "security-tab__cell-current-ver", children: /* @__PURE__ */ v.jsx(
          "p",
          {
            className: "m-0 cn-9 fs-13 fw-4",
            dangerouslySetInnerHTML: {
              __html: lA.sanitize(d.version)
            }
          }
        ) }),
        /* @__PURE__ */ v.jsx("td", { className: "security-tab__cell-fixed-ver", children: d.fixedVersion }),
        !e && /* @__PURE__ */ v.jsx(
          "td",
          {
            className: `security-tab__cell-policy security-tab__cell-policy--${d.policy?.toLowerCase()}`,
            children: d.policy?.toLowerCase()
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ v.jsx("table", { className: "security-tab__table", children: /* @__PURE__ */ v.jsxs("tbody", { children: [
    /* @__PURE__ */ v.jsxs(
      "tr",
      {
        className: `security-tab__table-header ${t ? "dc__position-sticky bcn-0 dc__zi-4 dc__top-0" : ""}`,
        children: [
          /* @__PURE__ */ v.jsx("th", { className: "security-cell-header security-tab__cell-cve", children: "CVE" }),
          /* @__PURE__ */ v.jsx("th", { className: "security-cell-header security-tab__cell-severity", children: /* @__PURE__ */ v.jsx(
            yle,
            {
              title: "Severity",
              isSorted: n === qp.SEVERITY,
              isSortable: !0,
              sortOrder: r,
              triggerSorting: a,
              disabled: !1
            }
          ) }),
          /* @__PURE__ */ v.jsx("th", { className: "security-cell-header security-tab__cell-package", children: /* @__PURE__ */ v.jsx(
            yle,
            {
              title: "Package",
              isSorted: n === qp.PACKAGE,
              isSortable: !0,
              sortOrder: r,
              triggerSorting: l,
              disabled: !1
            }
          ) }),
          /* @__PURE__ */ v.jsx("th", { className: "security-cell-header security-tab__cell-current-ver", children: "Current Version" }),
          /* @__PURE__ */ v.jsx("th", { className: "security-cell-header security-tab__cell-fixed-ver", children: "Fixed In Version" }),
          !e && /* @__PURE__ */ v.jsx("th", { className: "security-cell-header security-tab__cell-policy", children: "Policy" })
        ]
      }
    ),
    o.map((d) => c(d))
  ] }) });
}
var evt = /* @__PURE__ */ ((i) => (i.GLOBAL = "GLOBAL", i.FROM_PREVIOUS_STEP = "FROM_PREVIOUS_STEP", i.NEW = "NEW", i))(evt || {}), tvt = /* @__PURE__ */ ((i) => (i.INLINE = "INLINE", i.PLUGIN_REF = "REF_PLUGIN", i))(tvt || {}), nvt = /* @__PURE__ */ ((i) => (i.SHELL = "SHELL", i.DOCKERFILE = "DOCKERFILE", i.CONTAINERIMAGE = "CONTAINER_IMAGE", i))(nvt || {}), ivt = /* @__PURE__ */ ((i) => (i.TRUE = "Yes", i.FALSE = "No", i))(ivt || {}), rvt = /* @__PURE__ */ ((i) => (i.SKIP = "SKIP", i.TRIGGER = "TRIGGER", i.PASS = "PASS", i.FAIL = "FAIL", i))(rvt || {}), svt = /* @__PURE__ */ ((i) => (i.PRE_CI = "PRE_CI", i.POST_CI = "POST_CI", i))(svt || {}), ovt = /* @__PURE__ */ ((i) => (i.SELF_DOCKERFILE_BUILD_TYPE = "self-dockerfile-build", i.MANAGED_DOCKERFILE_BUILD_TYPE = "managed-dockerfile-build", i.BUILDPACK_BUILD_TYPE = "buildpack-build", i))(ovt || {}), avt = /* @__PURE__ */ ((i) => (i.PRE_CI = "PRE_CI", i.POST_CI = "POST_CI", i.PRE_OR_POST_CI = "PRE_OR_POST_CI", i))(avt || {}), lvt = /* @__PURE__ */ ((i) => (i.PRE_CI = "preBuildStage", i.POST_CI = "postBuildStage", i.PRE_OR_POST_CI = "PRE_OR_POST_CI", i))(lvt || {}), cvt = /* @__PURE__ */ ((i) => (i.BLOCK = "BLOCK", i.ALLOW_UNTIL_TIME = "ALLOW_UNTIL_TIME", i.ALLOW_FOREVER = "ALLOW_FOREVER", i))(cvt || {});
const dvt = ({
  setDeleting: i,
  toggleConfirmation: e,
  deleteComponent: t,
  title: n,
  component: r,
  payload: s,
  confirmationDialogDescription: o = "",
  redirectTo: a = !1,
  url: l = "",
  reload: c,
  configuration: d = "",
  closeCustomComponent: u
}) => {
  const [h, f] = Oe(!1), { push: g } = ip();
  async function p() {
    i(!0);
    try {
      await t(s), In.success("Successfully deleted"), e(!1), a ? g(l) : c(), typeof u == "function" && u();
    } catch (w) {
      w instanceof Kc && w.code === 500 && f(!0);
    } finally {
      i(!1);
    }
  }
  const m = () => {
    f(!1), e(!1), typeof u == "function" && u();
  }, _ = () => /* @__PURE__ */ v.jsxs(ko, { className: "confirmation-dialog__body--w-360", children: [
    /* @__PURE__ */ v.jsx(ko.Icon, { src: Wke }),
    /* @__PURE__ */ v.jsx(ko.Body, { title: `Cannot delete ${r} '${n}'` }),
    /* @__PURE__ */ v.jsx("p", { className: "fs-13 cn-7 ", children: o }),
    /* @__PURE__ */ v.jsx(ko.ButtonGroup, { children: /* @__PURE__ */ v.jsx("button", { type: "button", className: "cta", onClick: m, children: "Okay" }) })
  ] }), b = () => /* @__PURE__ */ v.jsx(
    eS,
    {
      title: `Delete ${r} '${n}'`,
      delete: p,
      closeDelete: () => e(!1),
      dataTestId: "delete-dialog",
      children: /* @__PURE__ */ v.jsx(eS.Description, { children: /* @__PURE__ */ v.jsxs("p", { children: [
        "Are you sure you want to delete this ",
        d || r,
        "? "
      ] }) })
    }
  );
  return /* @__PURE__ */ v.jsxs("div", { children: [
    !h && b(),
    h && _()
  ] });
}, Nxt = dvt, uvt = (i) => /* @__PURE__ */ G.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M3.74216 4.67419H1.49216V2.42419", fill: "#767D84" }), /* @__PURE__ */ G.createElement("path", { d: "M3.74216 4.67419H1.49216V2.42419", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M3.08318 8.91682C3.66007 9.49371 4.39507 9.88658 5.19525 10.0457C5.99542 10.2049 6.82482 10.1232 7.57856 9.811C8.33231 9.49879 8.97654 8.97008 9.42981 8.29173C9.88307 7.61338 10.125 6.81585 10.125 6C10.125 5.18415 9.88307 4.38663 9.42981 3.70827C8.97654 3.02992 8.33231 2.50121 7.57856 2.189C6.82482 1.87679 5.99542 1.7951 5.19525 1.95426C4.39507 2.11343 3.66007 2.50629 3.08318 3.08319L1.49219 4.67418", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), hvt = (i) => /* @__PURE__ */ G.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", ...i }, /* @__PURE__ */ G.createElement("path", { fill: "#959BA1", className: "fill-color", fillRule: "evenodd", d: "M10.5 7.583h-7c-.322 0-.583-.26-.583-.583 0-.322.26-.583.583-.583h7c.322 0 .583.26.583.583 0 .322-.26.583-.583.583z" })), fvt = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M12.6667 4C12.4899 4 12.3203 4.07024 12.1953 4.19526C12.0703 4.32029 12.0001 4.48986 12.0001 4.66667V7.33333C12.0001 7.51014 11.9298 7.67971 11.8048 7.80474C11.6798 7.92976 11.5102 8 11.3334 8H4.94005L5.80672 7.14C5.93226 7.01446 6.00278 6.8442 6.00278 6.66667C6.00278 6.48913 5.93226 6.31887 5.80672 6.19333C5.68118 6.0678 5.51092 5.99727 5.33339 5.99727C5.15585 5.99727 4.98559 6.0678 4.86005 6.19333L2.86005 8.19333C2.79936 8.25674 2.75178 8.3315 2.72005 8.41333C2.65337 8.57564 2.65337 8.75769 2.72005 8.92C2.75178 9.00183 2.79936 9.0766 2.86005 9.14L4.86005 11.14C4.92203 11.2025 4.99576 11.2521 5.077 11.2859C5.15824 11.3198 5.24538 11.3372 5.33339 11.3372C5.42139 11.3372 5.50853 11.3198 5.58977 11.2859C5.67101 11.2521 5.74474 11.2025 5.80672 11.14C5.86921 11.078 5.9188 11.0043 5.95265 10.9231C5.98649 10.8418 6.00392 10.7547 6.00392 10.6667C6.00392 10.5787 5.98649 10.4915 5.95265 10.4103C5.9188 10.329 5.86921 10.2553 5.80672 10.1933L4.94005 9.33333H11.3334C11.8638 9.33333 12.3725 9.12262 12.7476 8.74755C13.1227 8.37247 13.3334 7.86377 13.3334 7.33333V4.66667C13.3334 4.48986 13.2631 4.32029 13.1381 4.19526C13.0131 4.07024 12.8435 4 12.6667 4Z", fill: "#3B444C" })), CCe = ({
  // Setting it to zero in case of external pipeline
  ciPipelineId: i,
  artifactId: e,
  imageComment: t,
  imageReleaseTags: n,
  updateCurrentAppMaterial: r,
  appReleaseTagNames: s,
  setAppReleaseTagNames: o,
  tagsEditable: a,
  setTagsEditable: l,
  toggleCardMode: c,
  hideHardDelete: d,
  forceReInit: u,
  isSuperAdmin: h
}) => {
  const [f, g] = Oe(n || []), [p, m] = Oe(t ? t.comment : ""), [_, b] = Oe(s || []), [w, y] = Oe(t ? t.comment : ""), [S, x] = Oe(!1), [D, E] = Oe(!1), [L, k] = Oe(n || []), [N, I] = Oe(""), [A, P] = Oe([]), [O, K] = Oe([]), [W, F] = Oe([]), [q, R] = Oe(""), [T, z] = Oe(""), [X, ae] = Oe(!1);
  $e(() => {
    ue();
  }, [n, t, a]), $e(() => {
    b(s || []);
  }, [s]);
  const ue = () => {
    (u || !S) && (g(n || []), m(t ? t.comment : ""), y(t ? t.comment : ""), k(n || []), x(!1));
  }, se = () => {
    x(!S), typeof c == "function" && c(e);
  }, le = (ie) => {
    const H = ie.target.value;
    H?.length > 500 ? R("comment length cannot exceed 500 characters") : R(""), y(H);
  }, oe = () => {
    k(f), y(p), P([]), K([]), F([]), se(), E(!1), I("");
  }, re = (ie) => {
    if (ie.length == 0 || ie.length >= 128 || ie[0] == "." || ie[0] == "-")
      return I("Label name cannot be empty or exceed 128 characters or cannot start with . or -"), !1;
    I("");
    const H = _.includes(ie);
    let Y = !1;
    for (let Z = 0; Z < L?.length; Z++)
      L[Z].tagName.toLowerCase() === ie && (Y = !0);
    return H || Y || ie === "latest" ? (I("This label is already being used in this application"), !1) : !0;
  }, B = (ie) => {
    const H = ie.toLowerCase().trim();
    if (re(H)) {
      const Y = {
        id: 0,
        tagName: H,
        appId: 0,
        deleted: !1,
        artifactId: 0,
        duplicateTag: !1
      }, Z = [...A, Y];
      return P(Z), k([...L, Y]), E(!0), z(""), Z;
    }
    return A;
  }, ee = (ie) => {
    const H = [...L];
    H[ie] = {
      ...H[ie],
      deleted: !H[ie].deleted
    };
    const Y = H[ie], Z = [...O], Q = Z.findIndex((me) => me.tagName === Y.tagName);
    Q !== -1 ? Z.splice(Q, 1) : Z.push(Y), k(H), K(Z);
  }, j = (ie) => {
    const H = L[ie], Y = A.filter((me) => me.tagName !== H.tagName);
    P(Y);
    const Z = [...L];
    Z.splice(ie, 1), k(Z);
    const Q = _.filter((me) => me.toLowerCase() !== H.tagName.toLowerCase());
    if (b(Q), H.id !== 0) {
      const me = [...W, H];
      F(me);
    }
  }, he = (ie) => {
    ie.forEach(({ userMessage: H }) => {
      const Y = A.map((Q) => H?.appReleaseTags?.includes(Q.tagName) ? {
        ...Q,
        duplicateTag: !0
      } : Q);
      P(Y);
      const Z = L.map((Q) => {
        const me = Y.find((Le) => Le.tagName === Q.tagName);
        return me ? { ...Q, duplicateTag: me.duplicateTag } : Q;
      });
      k(Z);
    });
  }, Se = async (ie) => {
    if (N) return;
    const H = {
      createTags: ie,
      softDeleteTags: O,
      imageComment: {
        id: 0,
        comment: w.trim(),
        artifactId: 0
      },
      hardDeleteTags: W
    };
    ae(!0), $5e(H, i ?? 0, e).then((Y) => {
      const Z = Y.result?.imageReleaseTags?.map((Q) => ({
        id: Q.id,
        tagName: Q.tagName,
        deleted: Q.deleted,
        appId: 0,
        artifactId: 0
      }));
      o && o(Y.result?.appReleaseTags), l && l(Y.result?.tagsEditable), g(Z), m(Y.result?.imageComment?.comment), k(Z), y(Y.result?.imageComment?.comment), P([]), K([]), F([]), se(), E(!1), I(""), r && r(e, Z, Y.result?.imageComment);
    }).catch((Y) => {
      Y.errors?.[0]?.userMessage?.appReleaseTags?.length ? (In.error(Y.errors?.[0]?.internalMessage), he(Y.errors)) : Is(Y);
    }).finally(() => {
      ae(!1);
    });
  }, ge = () => /* @__PURE__ */ v.jsx(
    OA,
    {
      heading: "Image labels",
      additionalContent: te(),
      iconClassName: "fcn-5 ml-4 icon-dim-16"
    }
  ), te = () => /* @__PURE__ */ v.jsxs("div", { className: "h-250 fs-13 dc__overflow-scroll p-12", children: [
    /* @__PURE__ */ v.jsx("div", { children: "Image labels allow you to tag container images with readable and relatable labels eg. v1.0." }),
    /* @__PURE__ */ v.jsxs("ul", { className: "pl-20 mt-8", children: [
      /* @__PURE__ */ v.jsx("li", { children: "A label can only be added if a workflow has CD pipelines deploying to Production environments." }),
      /* @__PURE__ */ v.jsx("li", { children: "Multiple labels can be added to an image." }),
      /* @__PURE__ */ v.jsx("li", { children: "Multiple images in an application cannot have the same label." }),
      /* @__PURE__ */ v.jsx("li", { children: "Labels cannot be deleted once saved. Although, you can soft delete a label if an unwanted label has been added." })
    ] })
  ] }), be = Nt(null);
  if (w === "" && L.length === 0 && !S)
    return a ? /* @__PURE__ */ v.jsx("div", { className: "bcn-0 mt-8 add-image-button", children: /* @__PURE__ */ v.jsx(gvt, { handleEditClick: se }) }) : /* @__PURE__ */ v.jsx("div", {});
  const Ae = (ie) => {
    ie.key === "Enter" && ie.target.value.trim() && B(ie.target.value.trim());
  }, He = (ie) => {
    ie.target.value && re(ie.target.value), z(ie.target.value);
  }, de = (ie) => {
    Cr(ie), T.trim() && B(T.trim());
  }, ce = () => {
    let ie = A;
    T.trim() && (ie = B(T)), Se(ie);
  };
  return /* @__PURE__ */ v.jsx("div", { className: "mt-8", children: S && a ? /* @__PURE__ */ v.jsxs("div", { className: "bcn-0 dc__border-top-n1 ", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "cn-7 mt-12 flex left", children: [
      /* @__PURE__ */ v.jsx("div", { children: "Image labels (eg. v1.0)" }),
      ge()
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "mt-6 dc__position-rel-imp", "data-testid": "add-tag-text-area", children: [
      /* @__PURE__ */ v.jsx(
        "input",
        {
          className: "form__input fs-13",
          value: T,
          onChange: He,
          placeholder: "Type a tag and press enter",
          onKeyDown: Ae,
          onBlur: He,
          ref: be
        }
      ),
      T.length > 0 && /* @__PURE__ */ v.jsxs(
        "div",
        {
          onClick: de,
          className: "dc__position-abs bcn-0 flex cursor pt-2 pb-2 pr-4 pl-4 br-2 cn-7 dc__border dc__border-bottom-2",
          style: {
            top: "50%",
            fontFamily: "monospace",
            right: "8px",
            transform: "translateY(-50%)"
          },
          children: [
            /* @__PURE__ */ v.jsx(fvt, { className: "icon-dim-16 mr-4" }),
            "Enter"
          ]
        }
      )
    ] }),
    N && /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
      /* @__PURE__ */ v.jsx(rc, { className: "form__icon form__icon--error" }),
      /* @__PURE__ */ v.jsx("div", { className: "form__error", children: N })
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: "flex-wrap mt-8 flex left", children: L?.map((ie, H) => /* @__PURE__ */ v.jsx(
      AW,
      {
        text: ie?.tagName,
        isSoftDeleted: ie?.deleted,
        isEditing: S,
        onSoftDeleteClick: (Y) => {
          Cr(Y), ee(H);
        },
        onHardDeleteClick: (Y) => {
          Cr(Y), j(H);
        },
        tagId: ie.id,
        softDeleteTags: O,
        isSuperAdmin: h,
        duplicateTag: ie?.duplicateTag,
        hideHardDelete: d
      },
      ie.id
    )) }),
    D && /* @__PURE__ */ v.jsxs("div", { className: "cn-7 mb-8 flex left", children: [
      /* @__PURE__ */ v.jsx(mS, { className: "form__icon--info icon-dim-16 mr-2" }),
      "Tags cannot be edited/removed later"
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: "cn-7 mt-12", children: "Comment" }),
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: "flex left flex-wrap dc__gap-8 w-100 mt-6 mb-12",
        "data-testid": "add-image-comment-text-area",
        children: /* @__PURE__ */ v.jsx(
          "textarea",
          {
            value: w,
            onChange: le,
            className: "flex left flex-wrap dc__gap-8 dc__description-textarea fs-13",
            style: { height: "90px !important" }
          }
        )
      }
    ),
    q !== "" && /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
      /* @__PURE__ */ v.jsx(rc, { className: "form__icon form__icon--error" }),
      /* @__PURE__ */ v.jsx("div", { className: "form__error", children: q })
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "w-100 flex right mt-12", children: [
      /* @__PURE__ */ v.jsx(
        "button",
        {
          className: "cta flex cancel h-32 lh-32-imp",
          type: "button",
          onClick: (ie) => {
            Cr(ie), oe();
          },
          disabled: X,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "button",
        {
          className: "cta flex h-32 lh-32-imp ml-12",
          "data-testid": "save-tags-button",
          type: "button",
          onClick: (ie) => {
            Cr(ie), ce();
          },
          disabled: X,
          children: X ? /* @__PURE__ */ v.jsx(Yr, {}) : "Save"
        }
      )
    ] })
  ] }) : /* @__PURE__ */ v.jsxs("div", { className: "top br-4 bcn-0 image-tags-container flexbox", children: [
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: "flex left image-tag-left-border w-100 mt-8 mb-8 pr-10 pl-10",
        "data-testid": "image-tags-container-hover",
        children: /* @__PURE__ */ v.jsxs("div", { className: "w-100", children: [
          p && /* @__PURE__ */ v.jsx("div", { className: "mb-6 fs-13 lh-20 dc__word-break-all", children: p }),
          /* @__PURE__ */ v.jsx("div", { className: "flex-wrap flex left", children: f?.map((ie, H) => /* @__PURE__ */ v.jsx(
            AW,
            {
              text: ie?.tagName,
              isSoftDeleted: ie?.deleted,
              isEditing: S,
              onSoftDeleteClick: (Y) => {
                Cr(Y), ee(H);
              },
              onHardDeleteClick: (Y) => {
                Cr(Y), j(H);
              },
              tagId: ie.id,
              softDeleteTags: O,
              isSuperAdmin: h,
              duplicateTag: ie?.duplicateTag,
              hideHardDelete: d
            },
            ie?.id
          )) })
        ] })
      }
    ),
    /* @__PURE__ */ v.jsx("div", { className: "mt-8 mr-10 icon-dim-16", children: a && /* @__PURE__ */ v.jsx(
      MA,
      {
        className: "icon-dim-16 image-tags-container-edit__icon cursor",
        "data-testid": "edit-tags-icon",
        onClick: (ie) => {
          Cr(ie), se();
        }
      }
    ) })
  ] }) });
}, AW = ({
  text: i,
  isSoftDeleted: e,
  isEditing: t,
  onSoftDeleteClick: n,
  onHardDeleteClick: r,
  tagId: s,
  softDeleteTags: o,
  isSuperAdmin: a,
  duplicateTag: l,
  hideHardDelete: c
}) => {
  const d = e ? uvt : hvt, u = e && o.some((g) => g.tagName === i), h = s === 0 || a && !c, f = () => l ? "cr-5 bcr-1 er-2" : e ? "cy-7 bcy-1 dc__strike-through ey-2" : "cn-9";
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `br-4 en-2 bw-1 mr-8 bcn-0 pt-2 pr-8 pb-2 pl-8 tag-class dc__word-break-all flex ${t ? "icon-hover" : ""} ${f()}`,
      children: [
        l ? /* @__PURE__ */ v.jsx(A0, { className: "icon-dim-12 mr-4" }) : /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !0,
            placement: "top",
            content: u ? "Restore tag" : "Soft delete tag",
            children: /* @__PURE__ */ v.jsx(
              "div",
              {
                className: `action-icon mr-4 lh-16 pt-3 ${u || s !== 0 && !e ? "show-icon" : ""}`,
                children: /* @__PURE__ */ v.jsx(
                  d,
                  {
                    className: `icon-dim-12 cursor ${e ? "scn-6" : "fcn-6"} `,
                    "data-testid": `${i}-tag-soft-delete`,
                    onClick: n
                  }
                )
              }
            )
          }
        ),
        i,
        /* @__PURE__ */ v.jsx(wn, { className: "default-tt", arrow: !0, placement: "top", content: "Remove tag", children: /* @__PURE__ */ v.jsx("div", { className: `action-icon ml-4 lh-16 pt-3 ${h ? "show-icon" : ""}`, children: /* @__PURE__ */ v.jsx(
          ab,
          {
            className: "icon-dim-12 fcn-6 cursor",
            "data-testid": `${i}-tag-hard-delete`,
            onClick: r
          }
        ) }) })
      ]
    }
  );
}, gvt = ({ handleEditClick: i }) => {
  const e = (t) => {
    Cr(t), i();
  };
  return /* @__PURE__ */ v.jsx("div", { className: "add-tag-button flex pt-12 pr-12", "data-testid": "add-tags-button", onClick: e, children: /* @__PURE__ */ v.jsxs("div", { className: "lh-16 flex", children: [
    /* @__PURE__ */ v.jsx(fS, { className: "icon-dim-16 cn-6" }),
    /* @__PURE__ */ v.jsx("span", { className: "cn-7", children: "Add labels/comment" })
  ] }) });
}, Pxt = ({
  minHeight: i,
  maxHeight: e,
  value: t,
  onChange: n = null,
  onBlur: r = null,
  onFocus: s = null,
  className: o = "",
  placeholder: a = "Enter your text here..",
  disabled: l = !1,
  dataTestId: c,
  name: d,
  ...u
}) => {
  const [h, f] = Oe(""), g = Nt(null);
  $e(() => {
    f(t);
  }, [t]);
  function p(b) {
    b.persist(), f(b.target.value), typeof n == "function" && n(b);
  }
  function m(b) {
    typeof r == "function" && r(b);
  }
  function _(b) {
    typeof s == "function" && s(b);
  }
  return Yq(
    () => {
      g.current.style.height = "auto";
      let b = g.current.scrollHeight;
      i && b < i && (b = i), e && b > e && (b = e), g.current.style.height = `${b + 2}px`;
    },
    500,
    [h]
  ), /* @__PURE__ */ v.jsx(
    "textarea",
    {
      "data-testid": c,
      ref: (b) => g.current = b,
      value: h,
      placeholder: a,
      className: `dc__resizable-textarea pt-8 pb-8 pl-10 pb-10 lh-20 fs-13 fw-4 ${o}`,
      onChange: p,
      onBlur: m,
      onFocus: _,
      spellCheck: !1,
      disabled: l,
      name: d,
      id: d,
      ...u
    }
  );
};
function pvt(i, e, t = []) {
  const n = Nt(!0);
  $e(() => {
    if (n.current) {
      n.current = !1;
      return;
    }
    const r = setTimeout(() => {
      i();
    }, e);
    return () => {
      clearTimeout(r);
    };
  }, [e, ...t]);
}
function Oxt({
  onSearch: i,
  Icon: e,
  children: t,
  placeholder: n,
  containerClass: r = "",
  iconClass: s = "",
  inputClass: o = "",
  debounceTimeout: a = 500,
  clearSearch: l,
  showClearIcon: c = !0,
  autoFocus: d = !0
}) {
  const [u, h] = Oe("");
  $e(() => {
    h("");
  }, [l]);
  const f = (p) => {
    h(p.target.value);
  }, g = () => {
    h("");
  };
  return pvt(() => i(u), a, [u]), /* @__PURE__ */ v.jsxs("div", { className: r, children: [
    e && /* @__PURE__ */ v.jsx(e, { className: s }),
    /* @__PURE__ */ v.jsx(
      "input",
      {
        type: "text",
        className: o,
        placeholder: n ?? "Search",
        value: u,
        onChange: f,
        autoFocus: d,
        "data-testid": "debounced-search"
      }
    ),
    c && !!u && /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        className: "dc__outline-none-imp dc__no-border p-0 bc-n50 flex",
        onClick: g,
        "data-testid": "clear-search",
        children: /* @__PURE__ */ v.jsx(FA, { className: "icon-dim-20 icon-n6" })
      }
    ),
    t
  ] });
}
function Mxt({
  container: i,
  spacing: e = 0,
  item: t,
  xs: n,
  containerClass: r = "",
  itemClass: s = "",
  children: o,
  ...a
}) {
  const l = i ? { gap: `${e}px` } : {};
  if (t) {
    const d = {
      flex: `1 1 ${`calc(${n / 12 * 100}%)`}`
    };
    return /* @__PURE__ */ v.jsx("div", { className: `p-0 ${s}`, style: d, ...a, children: o });
  }
  return /* @__PURE__ */ v.jsx(
    "div",
    {
      className: `flex-wrap flexbox ${i ? r : ""}`,
      style: l,
      ...a,
      children: o
    }
  );
}
const Xq = {
  SELECT: "Please select an option",
  INPUT: "Please enter an input",
  OBJECT_KEY: "Please enter a value for the key"
}, mvt = "Key not available", Rxt = {
  "ui:submitButtonOptions": {
    norender: !0
  }
}, oA = ({
  showLabel: i,
  label: e,
  required: t,
  children: n,
  id: r,
  rawDescription: s,
  shouldAlignCenter: o = !0
}) => /* @__PURE__ */ v.jsxs(
  "div",
  {
    className: i ? `display-grid dc__gap-12 rjsf-form-template__field ${o ? "flex-align-center" : ""}` : "",
    children: [
      i && /* @__PURE__ */ v.jsxs("label", { className: "cn-7 fs-13 lh-20 fw-4 flexbox mb-0", htmlFor: r, children: [
        /* @__PURE__ */ v.jsx(mx, { alwaysShowTippyOnHover: !!s, content: s, children: /* @__PURE__ */ v.jsx("span", { className: `dc__ellipsis-right ${s ? "text-underline-dashed-300" : ""}`, children: e || mvt }) }),
        t && /* @__PURE__ */ v.jsx("span", { className: "cr-5", children: " *" })
      ] }),
      n
    ]
  }
), wle = ({ label: i, canAdd: e, onAddClick: t, disabled: n, readonly: r, uiSchema: s, registry: o }) => {
  const {
    ButtonTemplates: { AddButton: a }
  } = o.templates;
  return e && /* @__PURE__ */ v.jsx(
    a,
    {
      label: i,
      onClick: t,
      disabled: n || r,
      uiSchema: s,
      registry: o
    }
  );
}, vvt = ({
  canAdd: i,
  className: e,
  disabled: t,
  idSchema: n,
  uiSchema: r,
  items: s,
  onAddClick: o,
  readonly: a,
  registry: l,
  required: c,
  title: d
}) => {
  const u = kle(r), h = Tle("ArrayFieldItemTemplate", l, u), f = u.title || d;
  return /* @__PURE__ */ v.jsx("fieldset", { className: e, id: n.$id, children: s.length ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    s.map(({ key: g, ...p }, m) => {
      const _ = {
        ...p.children,
        props: {
          ...p.children.props
        }
      };
      return /* @__PURE__ */ v.jsx(h, { ...p, children: _ }, g);
    }),
    /* @__PURE__ */ v.jsx(
      wle,
      {
        label: f,
        canAdd: i,
        onAddClick: o,
        disabled: t,
        readonly: a,
        uiSchema: r,
        registry: l
      }
    )
  ] }) : /* @__PURE__ */ v.jsx(oA, { label: f, required: c, showLabel: !0, id: n.$id, children: /* @__PURE__ */ v.jsx(
    wle,
    {
      label: f,
      canAdd: i,
      onAddClick: o,
      disabled: t,
      readonly: a,
      uiSchema: r,
      registry: l
    }
  ) }) });
}, _vt = ({
  children: i,
  disabled: e,
  hasToolbar: t,
  hasRemove: n,
  index: r,
  onDropIndexClick: s,
  readonly: o,
  registry: a,
  uiSchema: l
}) => {
  const { RemoveButton: c } = a.templates.ButtonTemplates;
  return /* @__PURE__ */ v.jsxs("div", { className: "dc__position-rel display-grid rjsf-form-template__array-field-item flex-align-center", children: [
    i,
    /* @__PURE__ */ v.jsx("div", { className: "dc__position-abs remove-btn__container", style: { right: "-28px", top: "9px" }, children: t && n && /* @__PURE__ */ v.jsx(
      c,
      {
        disabled: e || o,
        onClick: s(r),
        uiSchema: l,
        registry: a
      }
    ) })
  ] });
}, {
  templates: { BaseInputTemplate: bvt }
} = VCe(), Cvt = ({ placeholder: i, ...e }) => /* @__PURE__ */ v.jsx(
  bvt,
  {
    placeholder: i || Xq.INPUT,
    ...e,
    className: "form__input cn-9 fs-13 lh-20 fw-4"
  }
), yCe = ({
  label: i,
  icon: e,
  iconType: t,
  registry: n,
  uiSchema: r,
  ...s
}) => {
  const o = `Add ${i}`;
  return /* @__PURE__ */ v.jsx("div", { className: "flexbox flex-justify-start", children: /* @__PURE__ */ v.jsxs(
    "button",
    {
      ...s,
      type: "button",
      className: "dc__outline-none-imp p-0 dc__transparent flex dc__gap-4 cursor dc__mxw-250",
      title: "Add",
      children: [
        /* @__PURE__ */ v.jsx(fS, { className: "icon-dim-16 fcb-5" }),
        /* @__PURE__ */ v.jsx(mx, { placement: "right", content: o, children: /* @__PURE__ */ v.jsx("span", { className: "cb-5 fs-13 lh-34 dc__truncate", children: o }) })
      ]
    }
  ) });
}, yvt = ({ icon: i, iconType: e, registry: t, uiSchema: n, ...r }) => /* @__PURE__ */ v.jsx("button", { ...r, type: "button", className: "dc__outline-none-imp p-0 dc__transparent flex cursor", title: "Remove", children: /* @__PURE__ */ v.jsx(ab, { className: "icon-dim-16 fcn-6" }) }), wvt = ({ uiSchema: i }) => {
  const { submitText: e, norender: t, props: n = {} } = WCe(i);
  return t ? null : /* @__PURE__ */ v.jsx("div", { className: "flexbox flex-justify-end", children: /* @__PURE__ */ v.jsx("button", { type: "submit", ...n, className: `cta ${n.className || ""}`, children: e }) });
}, Zq = ({
  id: i,
  title: e,
  required: t,
  description: n
}) => /* @__PURE__ */ v.jsxs("legend", { className: "fs-13 fw-6 cn-9 lh-20 dc__no-border py-9 mb-0", id: i, children: [
  /* @__PURE__ */ v.jsx(mx, { alwaysShowTippyOnHover: !!n, content: n, children: /* @__PURE__ */ v.jsx("span", { className: `${n ? "text-underline-dashed-300" : ""}`, children: e }) }),
  t && /* @__PURE__ */ v.jsx("span", { className: "cr-5", children: " *" })
] }), Svt = (i) => {
  const {
    id: e,
    label: t,
    children: n,
    errors: r,
    hidden: s,
    required: o,
    displayLabel: a,
    registry: l,
    uiSchema: c,
    classNames: d,
    schema: u,
    rawDescription: h
  } = i, f = kle(c), g = Tle(
    "WrapIfAdditionalTemplate",
    l,
    f
  ), p = Nle in u, m = (a || u.type === "boolean") && !p, _ = u.type === "array";
  return s ? /* @__PURE__ */ v.jsx("div", { className: "hidden", children: n }) : (
    // NOTE: need to override the margins of default rjsf css
    /* @__PURE__ */ v.jsxs("div", { className: `${d} mb-0`, children: [
      _ && /* @__PURE__ */ v.jsx(
        Zq,
        {
          id: e,
          title: t,
          required: o,
          registry: l,
          uiSchema: c,
          schema: u,
          description: h
        }
      ),
      /* @__PURE__ */ v.jsx(
        oA,
        {
          label: t,
          showLabel: m,
          id: e,
          required: o,
          rawDescription: h,
          children: /* @__PURE__ */ v.jsx(g, { ...i, children: n })
        }
      ),
      r
    ] })
  );
}, xvt = ({ errors: i = [], idSchema: e }) => {
  const t = jCe(e);
  return i.length > 0 && /* @__PURE__ */ v.jsx("span", { className: "display-grid rjsf-form-template__field--error dc__gap-12", id: t, children: i.filter((n) => !!n).map((n, r) => /* @__PURE__ */ v.jsxs(it.Fragment, { children: [
    /* @__PURE__ */ v.jsx("span", {}),
    /* @__PURE__ */ v.jsxs("span", { className: "form__error", children: [
      /* @__PURE__ */ v.jsx(rc, { className: "form__icon form__icon--error" }),
      n
    ] })
  ] }, r)) });
}, Dvt = ({
  disabled: i,
  formData: e,
  idSchema: t,
  onAddClick: n,
  properties: r,
  readonly: s,
  registry: o,
  required: a,
  schema: l,
  title: c,
  uiSchema: d
}) => {
  const u = !!l.additionalProperties, h = UCe(l, d, e) && /* @__PURE__ */ v.jsx(
    yCe,
    {
      label: c,
      className: "object-property-expand",
      onClick: n(l),
      disabled: i || s,
      uiSchema: d,
      registry: o
    }
  ), f = r.filter((g) => {
    const p = l.properties?.[g.name]?.hidden;
    if (!p)
      return !0;
    try {
      const m = li({ path: p.match, json: e })?.[0];
      return !(m === void 0 || p.condition === m);
    } catch {
      return !0;
    }
  }).sort((g) => l.properties?.[g.name]?.type === "boolean" ? -1 : 1).map((g) => g.content);
  return u ? r.length ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      oA,
      {
        label: c,
        required: a,
        showLabel: !0,
        id: t.$id,
        shouldAlignCenter: !1,
        children: /* @__PURE__ */ v.jsx("div", { children: f })
      }
    ),
    h
  ] }) : /* @__PURE__ */ v.jsx(oA, { label: c, required: a, showLabel: !0, id: t.$id, children: h }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    f,
    h
  ] });
}, Evt = (i) => {
  const { idSchema: e, registry: t, required: n, schema: r, title: s, uiSchema: o, description: a } = i, l = !!r.additionalProperties, c = s && !l;
  return /* @__PURE__ */ v.jsxs("fieldset", { id: e.$id, children: [
    c && /* @__PURE__ */ v.jsx(
      Zq,
      {
        id: zCe(e),
        title: s,
        required: n,
        schema: r,
        uiSchema: o,
        registry: t,
        description: a
      }
    ),
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: `${r.properties && !l && e.$id !== "root" ? "dc__border-left pl-12" : ""} flexbox-col dc__gap-8`,
        children: /* @__PURE__ */ v.jsx(Dvt, { ...i })
      }
    )
  ] });
}, Lvt = ({
  id: i,
  disabled: e,
  label: t,
  onKeyChange: n,
  onDropPropertyClick: r,
  readonly: s,
  schema: o,
  children: a,
  uiSchema: l,
  registry: c
}) => {
  const { templates: d } = c, { RemoveButton: u } = d.ButtonTemplates, h = Nle in o;
  return /* @__PURE__ */ v.jsx(v.Fragment, { children: h ? /* @__PURE__ */ v.jsxs("div", { className: "dc__position-rel rjsf-form-template__additional-fields display-grid dc__gap-8 flex-align-center", children: [
    /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(
      "input",
      {
        type: "text",
        className: "form__input cn-9 fs-13 lh-20 fw-4",
        id: `${i}-key`,
        onBlur: (f) => n(f.target.value),
        placeholder: Xq.OBJECT_KEY,
        defaultValue: t
      }
    ) }),
    /* @__PURE__ */ v.jsx("div", { children: a }),
    /* @__PURE__ */ v.jsx("div", { className: "dc__position-abs remove-btn__container", style: { right: "-28px", top: "9px" }, children: /* @__PURE__ */ v.jsx(
      u,
      {
        disabled: e || s,
        onClick: r(t),
        uiSchema: l,
        registry: c
      }
    ) })
  ] }) : a });
}, Ivt = ({
  id: i,
  onChange: e,
  value: t,
  required: n,
  disabled: r,
  readonly: s,
  autofocus: o,
  onBlur: a,
  onFocus: l
}) => {
  const c = (u, h) => {
    const { id: f, checked: g } = u.target;
    h === "blur" ? a(f, g) : h === "focus" && l(f, g);
  }, d = typeof t > "u" ? !1 : t;
  return /* @__PURE__ */ v.jsxs("div", { children: [
    /* @__PURE__ */ v.jsx(
      bCe,
      {
        selected: d,
        onSelect: e,
        id: i,
        name: i,
        required: n,
        disabled: r || s,
        autoFocus: o,
        rootClassName: "w-32 mb-0 dc__height-inherit",
        onBlur: (u) => c(u, "blur"),
        onFocus: (u) => c(u, "focus")
      }
    ),
    /* @__PURE__ */ v.jsx("span", { className: "dc__capitalize ml-8", children: d.toString() })
  ] });
}, Avt = (i, e) => {
  switch (i) {
    case qCe.NewStringDefault:
      return "";
    default:
      return GCe(i, e);
  }
}, kvt = (i = {}) => ({
  menuList: (e) => ({
    ...e,
    paddingTop: 0,
    paddingBottom: 0,
    cursor: "pointer"
  }),
  control: (e, t) => ({
    ...e,
    minHeight: "32px",
    boxShadow: "none",
    backgroundColor: "var(--N50)",
    border: t.isFocused ? "1px solid var(--B500)" : "1px solid var(--N200)",
    cursor: "pointer"
  }),
  option: (e, t) => ({
    ...e,
    color: "var(--N900)",
    backgroundColor: t.isFocused ? "var(--N100)" : "white",
    padding: "10px 12px",
    cursor: "pointer"
  }),
  dropdownIndicator: (e, t) => ({
    ...e,
    color: "var(--N400)",
    padding: "0 8px",
    transition: "all .2s ease",
    transform: t.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
  }),
  valueContainer: (e, t) => ({
    ...e,
    padding: "0 8px",
    fontWeight: "400",
    color: t.selectProps.menuIsOpen ? "var(--N500)" : e.color
  }),
  loadingMessage: (e) => ({
    ...e,
    color: "var(--N600)"
  }),
  noOptionsMessage: (e) => ({
    ...e,
    color: "var(--N600)"
  }),
  multiValue: (e) => ({
    ...e,
    border: "1px solid var(--N200)",
    borderRadius: "4px",
    background: "white",
    height: "28px",
    marginRight: "8px",
    padding: "2px",
    fontSize: "12px"
  }),
  ...i
}), Fxt = (i) => {
  try {
    const e = new URL(i).origin === window.location.origin;
    return {
      href: i,
      target: e ? "_self" : "_blank",
      rel: e ? void 0 : "external noreferrer",
      url: i
    };
  } catch {
    return {
      href: i,
      target: "_blank",
      url: `${i} (Invalid URL)`
    };
  }
}, Bxt = (i) => {
  const e = typeof i;
  switch (e) {
    case "boolean":
    case "string":
    case "number":
      return e;
    case "object":
      return Array.isArray(i) ? "array" : i === null ? "null" : e;
    default:
      return "null";
  }
}, Sle = kvt(), Tvt = ({ children: i, ...e }) => /* @__PURE__ */ v.jsx(zi.MenuList, { ...e, children: Array.isArray(i) ? i.slice(0, 20) : i }), Nvt = (i) => /* @__PURE__ */ v.jsx(zi.DropdownIndicator, { ...i, children: /* @__PURE__ */ v.jsx(vu, { className: "icon-dim-20 icon-n5", "data-testid": "overview-project-edit-dropdown" }) }), Pvt = (i) => {
  const {
    id: e,
    multiple: t = !1,
    options: n,
    value: r,
    disabled: s,
    readonly: o,
    autofocus: a = !1,
    onChange: l,
    onBlur: c,
    onFocus: d,
    placeholder: u
  } = i, { enumOptions: h = [] } = n, f = t ? [] : "", g = (m) => {
    l(t ? m.map((_) => _.value) : m.value);
  }, p = (m) => t ? h.filter((_) => m.some((b) => rA(b, _.value))) : h.find((_) => rA(m, _.value));
  return /* @__PURE__ */ v.jsx(
    Ba,
    {
      id: e,
      name: e,
      isMulti: t,
      value: typeof r > "u" ? f : p(r),
      autoFocus: a,
      onChange: g,
      options: h,
      onBlur: () => c(e, r),
      onFocus: () => d(e, r),
      placeholder: u || Xq.SELECT,
      isDisabled: s || o,
      styles: {
        ...Sle,
        control: (m) => ({
          ...m,
          ...Sle.control,
          backgroundColor: "var(--N50)"
        })
      },
      components: {
        IndicatorSeparator: null,
        DropdownIndicator: Nvt,
        MenuList: Tvt
      },
      menuPlacement: "auto"
    }
  );
}, Ovt = {
  CheckboxWidget: Ivt,
  SelectWidget: Pvt
}, Mvt = {
  ArrayFieldItemTemplate: _vt,
  ArrayFieldTemplate: vvt,
  BaseInputTemplate: Cvt,
  ButtonTemplates: { AddButton: yCe, RemoveButton: yvt, SubmitButton: wvt },
  FieldTemplate: Svt,
  FieldErrorTemplate: xvt,
  ObjectFieldTemplate: Evt,
  TitleFieldTemplate: Zq,
  WrapIfAdditionalTemplate: Lvt
}, Rvt = BCe, Fvt = HCe, Vxt = (i) => /* @__PURE__ */ v.jsx(
  Rvt,
  {
    noHtml5Validate: !0,
    showErrorList: !1,
    autoComplete: "off",
    ...i,
    className: `rjsf-form-template__container ${i.className || ""}`,
    validator: Fvt,
    templates: {
      ...Mvt,
      ...i.templates
    },
    widgets: { ...Ovt, ...i.widgets },
    translateString: Avt
  }
), Bvt = (i) => /* @__PURE__ */ G.createElement("svg", { width: 80, height: 80, viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("style", null, `
  .svg__loader_group-top {
    animation: top-shape 1.2s infinite;
    transform-origin: center center;
  }
  .svg__loader_group-bottom {
    animation: bottom-shape 1.2s infinite;
    transform-origin: center center;
  }

  .svg__loader_shapepath-top {
    animation: path-fill 1.2s infinite;
    }
  .svg__loader_shapepath-bottom {
    animation: path-fill 1.2s infinite;
    }

  .svg__loader_rotating-group {
    animation: rotate-group 1.2s infinite reverse;
    transform-origin: center center;
    }

  @keyframes path-fill {
    0% {
      fill: #3989D9;
    }
    30% {
      fill: #3989D9;
    }
    45% {
      fill: #ABCFF3;
    }
    100% {
      fill: #3989D9;
    }
  }

  @keyframes top-shape {
    0% {
      transform: translateX(0px) translateY(0px) rotate(0deg);
      transform-origin: center center;
    }
    30% {
      transform: translateX(0px) translateY(0px) rotate(10deg);
      transform-origin: center center;
    }
    45% {
      transform: translateX(-6px) translateY(-6px) rotate(15deg);
      transform-origin: center center;
    }
      
    100% {
      transform: translateX(0px) translateY(0px) rotate(0deg);
      transform-origin: center center;
    }
  }

  @keyframes bottom-shape {
    0% {
      transform: translateX(0px) translateY(0px) rotate(0deg);
      transform-origin: center center;
    }
    30% {
      transform: translateX(0px) translateY(0px) rotate(10deg);
      transform-origin: center center;
    }
    45% {
      transform: translateX(6px) translateY(6px) rotate(15deg);
      transform-origin: center center;
    }
      
    100% {
      transform: translateX(0px) translateY(0px) rotate(0deg);
      transform-origin: center center;
    }
  }
  
  @keyframes rotate-group {
    0% {
      transform: rotate(0deg);
    }
    44% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
      animation-timing-function: ease-in-out;
    }
  }
  `), /* @__PURE__ */ G.createElement("rect", { width: 100, height: 100, rx: 20, fill: "#E5F2FF" }), /* @__PURE__ */ G.createElement("g", { className: "svg__loader_rotating-group" }, /* @__PURE__ */ G.createElement("g", { className: "svg__loader_group-top" }, /* @__PURE__ */ G.createElement("path", { className: "svg__loader_shapepath-top", d: "M59.8584 21.95L38.6084 21.875C36.8042 21.8667 35.1292 22.8125 34.1792 24.3667L19.4625 48.5167C18.9899 49.293 18.7427 50.1855 18.7486 51.0943C18.7545 52.0031 19.0132 52.8924 19.4958 53.6625L30.9125 71.8792C31.2183 72.533 31.7308 73.0679 32.3709 73.4015C33.011 73.7351 33.7431 73.8488 34.4542 73.725C35.141 73.5973 35.7703 73.2572 36.2533 72.7525C36.7362 72.2478 37.0485 71.6042 37.1459 70.9125C37.2338 70.2725 37.143 69.6207 36.8834 69.0292L36.8334 68.9458C36.7375 68.7458 36.6167 68.5583 36.4875 68.3833L35.1958 66.3083L28.3458 55.3583C27.9912 54.8612 27.7883 54.2719 27.7617 53.6618C27.735 53.0517 27.8858 52.447 28.1958 51.9208C30.175 48.5958 34.5125 41.5042 35.4875 40.3458C35.854 40.0077 36.2862 39.7489 36.7572 39.5854C37.2282 39.4219 37.7279 39.3574 38.225 39.3958L43.6208 39.8125C43.8939 39.8472 44.1535 39.951 44.3752 40.1142C44.5969 40.2773 44.7733 40.4943 44.8876 40.7447C45.0019 40.9951 45.0504 41.2705 45.0286 41.5448C45.0067 41.8192 44.9151 42.0834 44.7625 42.3125L42.5125 45.7917C42.3947 45.9427 42.2915 46.1045 42.2042 46.275V46.2792C41.8913 46.8936 41.8029 47.5981 41.9542 48.2708C42.0838 48.8505 42.391 49.3753 42.833 49.7721C43.275 50.1689 43.8298 50.4179 44.4201 50.4844C45.0103 50.5509 45.6066 50.4316 46.1259 50.1431C46.6451 49.8546 47.0614 49.4113 47.3167 48.875L62.0625 26.225C63.2084 24.4667 62.0709 22.0625 60 21.9542C59.9528 21.9515 59.9056 21.9501 59.8584 21.95Z", fill: "#3989D9" })), /* @__PURE__ */ G.createElement("g", { className: "svg__loader_group-bottom" }, /* @__PURE__ */ G.createElement("path", { className: "svg__loader_shapepath-bottom", d: "M65.4458 26.2375C66.1567 26.1108 66.8896 26.2217 67.5313 26.553C68.1729 26.8844 68.6876 27.4178 68.9958 28.0709L80.4875 46.2334C81.4833 47.7959 81.5041 49.7959 80.55 51.3792L65.9375 75.5917C65.4801 76.3555 64.8332 76.9882 64.0594 77.4284C63.2855 77.8686 62.4111 78.1014 61.5208 78.1042L40.2708 78.125C40.2236 78.1263 40.1764 78.1263 40.1291 78.125C38.0583 78.025 36.9125 75.625 38.0458 73.8625L52.6916 51.1459C52.9442 50.6078 53.3584 50.162 53.8765 49.8707C54.3946 49.5794 54.9907 49.4571 55.5816 49.5209C56.1725 49.5847 56.7288 49.8313 57.1728 50.2265C57.6168 50.6216 57.9264 51.1455 58.0583 51.725C58.2135 52.3963 58.1295 53.1007 57.8208 53.7167C57.7327 53.8889 57.628 54.0564 57.5083 54.2084L55.2791 57.6959C55.1264 57.9255 55.035 58.1904 55.0135 58.4654C54.9921 58.7403 55.0413 59.0162 55.1566 59.2667C55.2718 59.5173 55.4493 59.7342 55.672 59.8968C55.8947 60.0595 56.1554 60.1624 56.4291 60.1959L61.8291 60.5875C62.3261 60.6226 62.8249 60.5548 63.2944 60.3885C63.764 60.2222 64.1942 59.9609 64.5583 59.6209C65.1 58.975 66.6666 56.4959 68.2916 53.8417L69.2666 52.2459C70.2333 50.6542 71.1458 49.1209 71.8041 48.0125C72.1109 47.4853 72.2584 46.8805 72.2288 46.2712C72.1992 45.6619 71.9938 45.0743 71.6375 44.5792L71.6583 44.5667L64.7375 33.6584L63.4416 31.5875C63.3053 31.4122 63.1866 31.2238 63.0875 31.025L63.0375 30.95C62.7742 30.3581 62.6805 29.7046 62.7666 29.0625C62.8608 28.3703 63.1702 27.7251 63.6509 27.2182C64.1317 26.7113 64.7595 26.3682 65.4458 26.2375Z", fill: "#3989D9" })))), Hxt = ({ classes: i, parentClasses: e }) => /* @__PURE__ */ v.jsx("div", { className: e || "", children: /* @__PURE__ */ v.jsx(Bvt, { className: i || "" }) }), Vvt = ({ setSelectedChartRefId: i }) => {
  const [e, t] = Oe([]), [n, r] = Oe(null), [s, o] = Oe([]), [a, l] = Oe([]), [c, d] = Oe(null);
  $e(() => {
    oke().then((g) => {
      const p = g?.result || [];
      t(p);
      const m = [...new Set(p.map((b) => b.chartType))].map((b) => ({
        value: b,
        label: b
      }));
      l(m);
      const _ = _le(p, m[0]);
      u(_);
    }).catch((g) => {
      Is(g);
    });
  }, []);
  const u = (g) => {
    o(g), d(g[0]), i(g[0]?.chartRefId);
  }, h = (g) => {
    r(g);
    const p = _le(e, g);
    u(p);
  }, f = (g) => {
    d(g), i(g.chartRefId);
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "flex", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "chart-type-options flex", "data-testid": "chart-type-options", children: [
      /* @__PURE__ */ v.jsx("span", { className: "cn-7 mr-4", children: "Chart Type" }),
      /* @__PURE__ */ v.jsx(
        Ba,
        {
          value: n ?? a[0],
          options: a,
          onChange: h,
          styles: vle
        }
      )
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "chart-version-options flex", "data-testid": "chart-version-options", children: [
      /* @__PURE__ */ v.jsx("span", { className: "cn-7 mr-4", children: "Chart Version" }),
      /* @__PURE__ */ v.jsx(
        Ba,
        {
          value: c ?? s[0],
          options: s,
          onChange: f,
          styles: vle
        }
      )
    ] })
  ] });
}, Wxt = Vvt, Hvt = ({ tooltipContent: i }) => i ? /* @__PURE__ */ v.jsxs("div", { className: "dc__white-space-pre-wrap", children: [
  /* @__PURE__ */ v.jsx("p", { className: "m-0 cn-0 fs-12 fw-6 lh-18", children: "Click to add" }),
  i
] }) : /* @__PURE__ */ v.jsx("div", { className: "dc__white-space-pre-wrap", children: "Click to add here" });
function jxt({
  position: i,
  addCDButtons: e,
  endNode: t,
  startNode: n,
  handleAddCD: r,
  tooltipContent: s
}) {
  const o = i === ty.RIGHT ? t : n, a = () => {
    r(i);
  };
  return e?.includes(i) ? /* @__PURE__ */ v.jsx(
    wn,
    {
      placement: "top",
      content: /* @__PURE__ */ v.jsx(Hvt, { tooltipContent: s }),
      className: "default-tt",
      arrow: !1,
      children: /* @__PURE__ */ v.jsxs(
        "svg",
        {
          x: o.x + (i === ty.RIGHT ? -25 : o.width + 5),
          y: o.y + o.height / 2 - 10,
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "data-testid": `add-cd-to-${i}`,
          onClick: a,
          className: "dc__outline-none-imp",
          children: [
            /* @__PURE__ */ v.jsx("rect", { width: "20", height: "20", rx: "10", fill: "#664BEE", className: "add-cd-edge-btn" }),
            /* @__PURE__ */ v.jsx(
              "path",
              {
                d: "M6.5 10H13.5M10 6.5V13.5",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              }
            )
          ]
        }
      )
    }
  ) : null;
}
const Wvt = ({ startNode: i }) => i.type === u8.WEBHOOK ? g3.WEBHOOK : i.type === u8.CI ? g3.CI_PIPELINE : g3.CD_PIPELINE, zxt = ({
  position: i,
  handleCDSelect: e,
  startNode: t,
  endNode: n,
  workflowId: r,
  ciPipelineId: s,
  isWebhookCD: o,
  isParallelEdge: a
}) => {
  if (!e)
    return;
  const l = Wvt({ startNode: t }), c = a && i === ty.RIGHT ? h8.PARALLEL : h8.SEQUENTIAL, d = !a && i === ty.RIGHT ? n.id : null;
  e(r, s, l, t.id, o, d, c);
};
var wCe = /* @__PURE__ */ ((i) => (i.PARENT_BOTTOM_CENTER = "PARENT_BOTTOM_CENTER", i.SCREEN_BOTTOM_CENTER = "SCREEN_BOTTOM_CENTER", i))(wCe || {});
function Uxt({
  children: i,
  zIndex: e = QCe,
  positionVariant: t,
  dragSelector: n,
  parentRef: r,
  boundaryGap: s = 16,
  childDivProps: o = {},
  layoutFixDelta: a = 0
}) {
  const l = Hve(), c = Nt(null), [d, u] = Oe({
    x: 0,
    y: 0
  }), h = (g) => {
    const p = r?.current?.getBoundingClientRect() ?? {
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      bottom: 0
    }, m = c.current?.getBoundingClientRect().height ?? 0, _ = c.current?.getBoundingClientRect().width ?? 0;
    switch (g) {
      case wCe.PARENT_BOTTOM_CENTER: {
        const b = (p.width - _) / 2, w = p.top > 0 ? p.top : a, S = (p.height > l.height ? l.height - w : p.height) - m - s;
        return { x: b, y: S };
      }
      default: {
        const b = l.width / 2 - p.left - _ / 2, w = l.height - p.top - m - s;
        return { x: b, y: w };
      }
    }
  };
  $e(() => {
    const g = h(t);
    u(g);
  }, [c, t, l]);
  function f(g, p) {
    const m = r?.current?.getBoundingClientRect().left ?? 0, _ = r?.current?.getBoundingClientRect().top ?? 0, b = c.current?.getBoundingClientRect().height ?? 0, w = c.current?.getBoundingClientRect().width ?? 0;
    m + p.x + w + s > l.width || _ + p.y + b + s > l.height || m + p.x < 0 || _ + p.y < 0 || u({
      x: p.x,
      y: p.y
    });
  }
  return (
    // Since we are using position fixed so we need to disable click on the div so that it does not interfere with the click of other elements
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: "dc__position-fixed dc__disable-click",
        style: {
          zIndex: e
        },
        children: /* @__PURE__ */ v.jsx(FCe, { handle: n, nodeRef: c, position: d, onDrag: f, children: /* @__PURE__ */ v.jsx(
          "div",
          {
            ref: c,
            ...o,
            style: {
              zIndex: e,
              pointerEvents: "auto"
            },
            children: i
          }
        ) })
      }
    )
  );
}
const jvt = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M10.3335 9.33325C10.8858 9.33325 11.3335 8.88554 11.3335 8.33325C11.3335 7.78097 10.8858 7.33325 10.3335 7.33325C9.78121 7.33325 9.3335 7.78097 9.3335 8.33325C9.3335 8.88554 9.78121 9.33325 10.3335 9.33325Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M5.66675 9.33325C6.21903 9.33325 6.66675 8.88554 6.66675 8.33325C6.66675 7.78097 6.21903 7.33325 5.66675 7.33325C5.11446 7.33325 4.66675 7.78097 4.66675 8.33325C4.66675 8.88554 5.11446 9.33325 5.66675 9.33325Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M10.3335 5.33325C10.8858 5.33325 11.3335 4.88554 11.3335 4.33325C11.3335 3.78097 10.8858 3.33325 10.3335 3.33325C9.78121 3.33325 9.3335 3.78097 9.3335 4.33325C9.3335 4.88554 9.78121 5.33325 10.3335 5.33325Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M5.66675 5.33325C6.21903 5.33325 6.66675 4.88554 6.66675 4.33325C6.66675 3.78097 6.21903 3.33325 5.66675 3.33325C5.11446 3.33325 4.66675 3.78097 4.66675 4.33325C4.66675 4.88554 5.11446 5.33325 5.66675 5.33325Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M10.3335 13.3333C10.8858 13.3333 11.3335 12.8855 11.3335 12.3333C11.3335 11.781 10.8858 11.3333 10.3335 11.3333C9.78121 11.3333 9.3335 11.781 9.3335 12.3333C9.3335 12.8855 9.78121 13.3333 10.3335 13.3333Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M5.66675 13.3333C6.21903 13.3333 6.66675 12.8855 6.66675 12.3333C6.66675 11.781 6.21903 11.3333 5.66675 11.3333C5.11446 11.3333 4.66675 11.781 4.66675 12.3333C4.66675 12.8855 5.11446 13.3333 5.66675 13.3333Z", fill: "#596168" }));
function Gxt({ dragClassName: i }) {
  return /* @__PURE__ */ v.jsx(
    "button",
    {
      type: "button",
      className: `${i} dc__outline-none-imp dc__no-border p-0 dc__transparent h-20`,
      children: /* @__PURE__ */ v.jsx(jvt, { className: "dc__grabbable icon-dim-20 fcn-6" })
    }
  );
}
const xle = 5, zvt = [
  { value: 20, selected: !0 },
  { value: 40, selected: !1 },
  { value: 50, selected: !1 }
], i8 = ({ size: i, pageSize: e, selectedPageNo: t }) => {
  const n = [], r = Math.ceil(i / e), s = t - 2 < 1 ? 1 : t - 2, o = t + 2 > r ? r : t + 2;
  for (let a = 1; a <= r; a++)
    n.push({
      value: a,
      selected: a === t,
      isVisible: o - xle < a && a < s + xle
    });
  return n;
}, Uvt = (i) => i?.length ? i : zvt, Gvt = ({
  optionValue: i,
  options: e,
  setOptions: t,
  handleCloseDropdown: n,
  changePageSize: r
}) => {
  const s = () => {
    const o = e.map((a) => ({
      value: a.value,
      selected: a.value === i
    }));
    t([...o]), n(), r(i);
  };
  return /* @__PURE__ */ v.jsx("div", { className: "select__item", onClick: s, children: i }, i);
}, qvt = ({ pageSizeOptions: i, pageSize: e, changePageSize: t }) => {
  const n = Uvt(i).map((f) => ({
    value: f.value,
    selected: f.value === e
  })), [r, s] = Oe(!1), [o, a] = Oe(n), l = () => {
    s(!1);
  }, c = () => {
    s(!r);
  }, d = Nt(null);
  pat(d, l);
  const u = o.find((f) => f.selected), h = r ? "fa fa-caret-up" : "fa fa-caret-down";
  return /* @__PURE__ */ v.jsxs("div", { ref: d, children: [
    r && /* @__PURE__ */ v.jsx("div", { className: "pagination__select-menu", children: o.map((f) => /* @__PURE__ */ v.jsx(
      Gvt,
      {
        optionValue: f.value,
        options: o,
        setOptions: a,
        handleCloseDropdown: l,
        changePageSize: t
      }
    )) }),
    /* @__PURE__ */ v.jsxs("button", { type: "button", className: "select__button", onClick: c, children: [
      /* @__PURE__ */ v.jsx("span", { children: u ? u.value : "" }),
      /* @__PURE__ */ v.jsx("span", { className: "select__icon", children: /* @__PURE__ */ v.jsx("i", { className: h }) })
    ] })
  ] });
}, Kvt = ({ value: i, isSelected: e, selectPage: t }) => {
  const n = e ? "page__button page__button--selected" : "page__button", r = () => {
    t(i);
  };
  return /* @__PURE__ */ v.jsx("li", { className: "page", children: /* @__PURE__ */ v.jsx("button", { className: n, onClick: r, type: "button", children: i }) });
}, Yvt = ({
  size: i,
  pageSize: e,
  offset: t,
  changePage: n,
  changePageSize: r,
  isPageSizeFix: s,
  pageSizeOptions: o,
  rootClassName: a
}) => {
  const [l, c] = Oe([]);
  $e(() => {
    const m = i8({ size: i, pageSize: e, selectedPageNo: 1 });
    c(m);
  }, [i, e]), $e(() => {
    const m = 1 + Math.floor(t / e), _ = i8({ size: i, pageSize: e, selectedPageNo: m });
    c(_);
  }, [t]);
  const d = (m) => {
    const _ = i8({ size: i, pageSize: e, selectedPageNo: m });
    c(_), n(m);
  }, u = () => {
    const _ = l.find((b) => b.selected).value - 1;
    d(_);
  }, h = () => {
    const _ = l.find((b) => b.selected).value + 1;
    d(_);
  }, f = t + e < i ? t + e : i, g = l.findIndex((m) => m.selected), p = l.filter((m) => m.isVisible);
  return /* @__PURE__ */ v.jsxs("div", { className: a || "", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "page-number", children: [
      t + 1,
      " - ",
      f,
      " of ",
      i
    ] }),
    /* @__PURE__ */ v.jsxs("ul", { className: "pagination", children: [
      /* @__PURE__ */ v.jsx("li", { className: "page", children: /* @__PURE__ */ v.jsx(
        "button",
        {
          className: "page__button page__button--icon",
          disabled: !g,
          onClick: u,
          type: "button",
          "aria-label": "Previous page",
          children: /* @__PURE__ */ v.jsx("span", { className: "left-icon", children: /* @__PURE__ */ v.jsx("i", { className: "fa fa-chevron-left" }) })
        }
      ) }),
      p.map((m) => /* @__PURE__ */ v.jsx(
        Kvt,
        {
          value: m.value,
          isSelected: m.selected,
          selectPage: d
        },
        m.value
      )),
      /* @__PURE__ */ v.jsx("li", { className: "page", children: /* @__PURE__ */ v.jsx(
        "button",
        {
          className: "page__button page__button--icon",
          disabled: g === l.length - 1,
          onClick: h,
          type: "button",
          "aria-label": "Next page",
          children: /* @__PURE__ */ v.jsx("span", { className: "left-icon", children: /* @__PURE__ */ v.jsx("i", { className: "fa fa-chevron-right" }) })
        }
      ) })
    ] }),
    !s && /* @__PURE__ */ v.jsxs("div", { className: "select", children: [
      /* @__PURE__ */ v.jsx("span", { className: "select__placeholder", children: "Rows per page" }),
      /* @__PURE__ */ v.jsx(
        qvt,
        {
          pageSizeOptions: o,
          pageSize: e,
          changePageSize: r
        }
      )
    ] })
  ] });
}, qxt = Yvt, Dle = '<input checked="" disabled="" type="checkbox">', Ele = '<input disabled="" type="checkbox">', M2 = new r8.Renderer(), Xvt = ({ setExpandableIcon: i, markdown: e, className: t, breaks: n, disableEscapedText: r, ...s }) => {
  const o = Nt(null), a = () => {
    const h = o.current?.clientHeight > 320;
    typeof i == "function" && i(h);
  };
  $e(() => {
    a();
  }, [e]);
  const l = (d) => !!(d.includes(Dle) || d.includes(Ele));
  M2.listitem = (d) => l(d) ? (d = d.replace(
    Dle,
    '<input type="checkbox" style="margin: 0 0.2em 0.25em -1.4em;" class="dc__vertical-align-middle" checked disabled>'
  ).replace(
    Ele,
    '<input type="checkbox" style="margin: 0 0.2em 0.25em -1.4em;" class="dc__vertical-align-middle" disabled>'
  ), `<li style="list-style: none">${d}</li>`) : `<li>${d}</li>`, M2.image = (d, u, h) => `<img src="${d}" alt="${h}" title="${u}" class="max-w-100">`, M2.table = (d, u) => `
        <div class="table-container">
            <table>
                ${d}
                ${u}
            </table>
        </div>
        `, M2.heading = (d, u) => {
    const h = r ? "" : d.toLowerCase().replace(/[^\w]+/g, "-");
    return `
          <a name="${h}" rel="noreferrer noopener" class="anchor" href="#${h}">
                <h${u} data-testid="deployment-template-readme-version">
              <span class="header-link"></span>
              ${d}
              </h${u}>
            </a>`;
  }, r8.setOptions({
    renderer: M2,
    gfm: !0,
    smartLists: !0,
    ...n && { breaks: !0 }
  });
  const c = () => ({ __html: lA.sanitize(r8(e), { USE_PROFILES: { html: !0 } }) });
  return /* @__PURE__ */ v.jsx(
    "article",
    {
      ...s,
      ref: o,
      className: `markdown ${t}`,
      dangerouslySetInnerHTML: c(),
      "data-testid": "markdown-rendered-content"
    }
  );
}, Lle = Xvt;
var j1 = /* @__PURE__ */ ((i) => (i.WRITE = "write", i.PREVIEW = "preview", i))(j1 || {});
const Zvt = `
<br>
Nothing to preview
`, Qvt = [
  [
    "header",
    "bold",
    "italic",
    "strikethrough",
    "link",
    "quote",
    "code",
    "image",
    "unordered-list",
    "ordered-list",
    "checked-list"
  ]
];
var Fl = /* @__PURE__ */ ((i) => (i.HEADER = "header", i.BOLD = "bold", i.ITALIC = "italic", i.STRIKETHROUGH = "strikethrough", i.LINK = "link", i.QUOTE = "quote", i.CODE = "code", i.IMAGE = "image", i.UNORDERED_LIST = "unordered-list", i.ORDERED_LIST = "ordered-list", i.CHECKED_LIST = "checked-list", i))(Fl || {});
const yc = {
  header: "Add heading text",
  bold: "Add bold text",
  italic: "Add italic text",
  strikethrough: "Add strikethrough text",
  link: "Add a link",
  quote: "Add a quote",
  code: "Add code",
  image: "Add image via link",
  "unordered-list": "Add a bulleted list",
  "ordered-list": "Add a numbered list",
  "checked-list": "Add a task list"
}, Jvt = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M4 8H12", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("line", { x1: 3.75, y1: 2.75, x2: 3.75, y2: 13.25, stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("line", { x1: 12.75, y1: 2.75, x2: 12.75, y2: 13.25, stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), $vt = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M4.00037 7.49982H9.50037C10.1634 7.49982 10.7993 7.76321 11.2681 8.23205C11.737 8.70089 12.0004 9.33678 12.0004 9.99982C12.0004 10.6629 11.737 11.2987 11.2681 11.7676C10.7993 12.2364 10.1634 12.4998 9.50037 12.4998L4 12.4995V2.99951L8.75037 2.99982C9.3471 2.99982 9.9194 3.23687 10.3414 3.65883C10.7633 4.08078 11.0004 4.65308 11.0004 5.24982C11.0004 5.84655 10.7633 6.41885 10.3414 6.84081C9.9194 7.26276 9.3471 7.49982 8.75037 7.49982", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), e_t = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M9.5 3.49951L6.5 12.4995M4 12.4995H9M7 3.49951H12", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), t_t = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M7.64668 4.4647L8.88412 3.22726C9.13943 2.9717 9.4426 2.76896 9.7763 2.6306C10.11 2.49224 10.4677 2.42098 10.8289 2.4209C11.1902 2.42081 11.5479 2.4919 11.8816 2.63011C12.2154 2.76831 12.5187 2.97092 12.7741 3.22635C13.0295 3.48179 13.2322 3.78505 13.3704 4.11881C13.5086 4.45258 13.5796 4.8103 13.5796 5.17154C13.5795 5.53278 13.5082 5.89047 13.3699 6.22416C13.2315 6.55786 13.0288 6.86103 12.7732 7.11635L11.0054 8.88412C10.7501 9.13948 10.4469 9.34204 10.1133 9.48024C9.77963 9.61844 9.42203 9.68957 9.06089 9.68957C8.69976 9.68957 8.34216 9.61844 8.00851 9.48024C7.67487 9.34204 7.37171 9.13948 7.11635 8.88412M8.35378 11.5358L7.11635 12.7732C6.86103 13.0288 6.55786 13.2315 6.22416 13.3699C5.89047 13.5082 5.53278 13.5795 5.17154 13.5796C4.8103 13.5796 4.45258 13.5086 4.11881 13.3704C3.78505 13.2322 3.48179 13.0295 3.22635 12.7741C2.97092 12.5187 2.76831 12.2154 2.63011 11.8816C2.4919 11.5479 2.42081 11.1902 2.4209 10.8289C2.42098 10.4677 2.49224 10.11 2.6306 9.7763C2.76896 9.4426 2.9717 9.13943 3.22726 8.88412L4.99503 7.11635C5.25039 6.86099 5.55355 6.65842 5.88719 6.52022C6.22084 6.38202 6.57844 6.31089 6.93957 6.31089C7.30071 6.31089 7.65831 6.38202 7.99195 6.52022C8.3256 6.65842 8.62875 6.86099 8.88411 7.11635", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), n_t = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M2.5 8H13.5M4.77087 6.00018C4.71891 5.83859 4.6931 5.66974 4.69444 5.5C4.69444 4.11929 6.067 3 8 3C9.48617 3 10.641 3.66163 11.0956 4.59501M4.5 10.5C4.5 11.8807 6.067 13 8 13C9.933 13 11.5 11.8807 11.5 10.5C11.5 9.0146 10.1486 8.43935 8.65017 7.99995", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), i_t = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M5.5 4L1 8L5.5 12M10.5 4L15 8L10.5 12", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), r_t = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M6.5 8H13.4999M2.5 4H9.49994M2.5 8V12M6.49994 12H13.4999", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), s_t = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M2 10.5L5.14644 7.35355C5.19287 7.30712 5.24799 7.27029 5.30865 7.24517C5.36931 7.22004 5.43433 7.20711 5.49999 7.20711C5.56565 7.20711 5.63067 7.22004 5.69133 7.24517C5.752 7.27029 5.80711 7.30712 5.85354 7.35355L8.64644 10.1464C8.69287 10.1929 8.74799 10.2297 8.80865 10.2548C8.86931 10.28 8.93433 10.2929 8.99999 10.2929C9.06565 10.2929 9.13067 10.28 9.19133 10.2548C9.252 10.2297 9.30711 10.1929 9.35354 10.1464L10.6464 8.85355C10.6929 8.80712 10.748 8.77029 10.8086 8.74517C10.8693 8.72004 10.9343 8.70711 11 8.70711C11.0657 8.70711 11.1307 8.72004 11.1913 8.74517C11.252 8.77029 11.3071 8.80712 11.3535 8.85355L14 11.5M2.5 3H13.5C13.7761 3 14 3.22386 14 3.5V12.5C14 12.7761 13.7761 13 13.5 13H2.5C2.22386 13 2 12.7761 2 12.5V3.5C2 3.22386 2.22386 3 2.5 3Z", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M10 7.5C10.5523 7.5 11 7.05228 11 6.5C11 5.94772 10.5523 5.5 10 5.5C9.44772 5.5 9 5.94772 9 6.5C9 7.05228 9.44772 7.5 10 7.5Z", fill: "#596168" })), o_t = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M6.5 8H13.4999M6.5 4H13.4999M6.49994 12H13.4999M2.5 3.75L3.5 3.25V6.74963M2.56876 9.53441C2.61627 9.422 2.68677 9.32076 2.77573 9.23721C2.86468 9.15366 2.97013 9.08964 3.0853 9.04926C3.20047 9.00888 3.32281 8.99303 3.44447 9.00274C3.56612 9.01244 3.6844 9.04749 3.79171 9.10562C3.89902 9.16375 3.99298 9.24368 4.06756 9.34028C4.14215 9.43688 4.1957 9.54801 4.22479 9.66654C4.25387 9.78507 4.25785 9.90836 4.23645 10.0285C4.21506 10.1487 4.16877 10.263 4.10056 10.3642L2.5 12.5H4.25", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Ile = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M5.5 4H13.5M5.50038 8H13.5M5.50038 12H13.5", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ G.createElement("path", { d: "M2.75 4.75C3.16421 4.75 3.5 4.41421 3.5 4C3.5 3.58579 3.16421 3.25 2.75 3.25C2.33579 3.25 2 3.58579 2 4C2 4.41421 2.33579 4.75 2.75 4.75Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M2.75 8.75C3.16421 8.75 3.5 8.41421 3.5 8C3.5 7.58579 3.16421 7.25 2.75 7.25C2.33579 7.25 2 7.58579 2 8C2 8.41421 2.33579 8.75 2.75 8.75Z", fill: "#596168" }), /* @__PURE__ */ G.createElement("path", { d: "M2.75 12.75C3.16421 12.75 3.5 12.4142 3.5 12C3.5 11.5858 3.16421 11.25 2.75 11.25C2.33579 11.25 2 11.5858 2 12C2 12.4142 2.33579 12.75 2.75 12.75Z", fill: "#596168" })), a_t = (i) => /* @__PURE__ */ G.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ G.createElement("path", { d: "M9.5 4H13.5M9.5 8H13.4996M9.5 12H13.4996M7 9.75049L4.33333 12.417L3 11.0838M3 3.5H6.5V7H3V3.5Z", stroke: "#596168", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), l_t = "Readme cannot be empty. Please add some information or cancel the changes.", c_t = "Are you sure you want to discard your changes?", d_t = ({
  text: i,
  updatedBy: e,
  updatedOn: t,
  isDescriptionPreview: n,
  tabIndex: r,
  updateDescription: s,
  title: o,
  minEditorHeight: a = 300
}) => {
  const [l, c] = Oe(!1), [d, u] = Oe(n), [h, f] = Oe(i), [g, p] = Oe(j1.WRITE), m = !rA(i, h), _ = Nt(null);
  $e(() => {
    f(i);
  }, [i]);
  const b = st(t), w = b.isValid() ? b.format(id.TWELVE_HOURS_FORMAT) : t, y = (E) => {
    let L = !0;
    return E.length === 0 && (In.error(l_t), L = !1), L;
  }, S = () => {
    let E = !0;
    m && !d && (E = window.confirm(c_t)), E && (f(i), u(!d), p(j1.WRITE));
  }, x = async () => {
    const E = h.trim();
    if (y(E))
      try {
        c(!0), await s(E), u(!0), f(E);
      } catch (k) {
        Is(k);
      } finally {
        c(!1);
      }
  }, D = (E) => {
    switch (E) {
      case Fl.HEADER:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(Jvt, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.BOLD:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx($vt, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.ITALIC:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(e_t, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.STRIKETHROUGH:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(n_t, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.LINK:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(t_t, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.QUOTE:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(r_t, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.CODE:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(i_t, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.IMAGE:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(s_t, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.UNORDERED_LIST:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(Ile, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.ORDERED_LIST:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(o_t, { className: "icon-dim-16 flex" }) })
          }
        );
      case Fl.CHECKED_LIST:
        return /* @__PURE__ */ v.jsx(
          wn,
          {
            className: "default-tt",
            arrow: !1,
            placement: "bottom",
            content: yc[E],
            children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(a_t, { className: "icon-dim-16 flex" }) })
          }
        );
    }
  };
  return /* @__PURE__ */ v.jsx("div", { className: "cluster__body-details", children: /* @__PURE__ */ v.jsx("div", { "data-testid": "generic-description-wrapper", className: "dc__overflow-hidden", children: d ? /* @__PURE__ */ v.jsxs("div", { className: "min-w-500 bcn-0 br-4 dc__border-top dc__border-left dc__border-right w-100 dc__border-bottom", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "pt-8 pb-8 pl-16 pr-16 dc__top-radius-4 flex bc-n50 dc__border-bottom h-36", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-6 dc__align-items-center", children: [
        /* @__PURE__ */ v.jsx(Ile, { className: "icon-dim-16" }),
        /* @__PURE__ */ v.jsx("div", { className: "fw-6 lh-20 cn-9 fs-13", children: o })
      ] }),
      e && w && /* @__PURE__ */ v.jsxs("div", { className: "flex left fw-4 cn-7 ml-8 fs-12 h-20", children: [
        "Last updated by  ",
        /* @__PURE__ */ v.jsx("span", { className: "dc__ellipsis-right dc__mxw-200", children: e }),
        " on ",
        w
      ] }),
      /* @__PURE__ */ v.jsxs(
        "div",
        {
          "data-testid": "description-edit-button",
          className: "dc__align-right pencil-icon cursor flex fw-6 cn-7",
          onClick: S,
          children: [
            /* @__PURE__ */ v.jsx(MA, { className: "icon-dim-16 mr-4 scn-7" }),
            " Edit"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(
      nK,
      {
        classes: {
          reactMde: "mark-down-editor-container dc__word-break pb-16 pt-8 mark-down-editor__no-border",
          toolbar: "mark-down-editor__hidden",
          preview: "mark-down-editor-preview dc__bottom-radius-4",
          textArea: "mark-down-editor__hidden"
        },
        value: i,
        selectedTab: "preview",
        minPreviewHeight: 150,
        generateMarkdownPreview: (E) => Promise.resolve(/* @__PURE__ */ v.jsx(Lle, { markdown: E, breaks: !0, disableEscapedText: !0 }))
      }
    )
  ] }) : /* @__PURE__ */ v.jsxs("div", { className: "min-w-500", children: [
    /* @__PURE__ */ v.jsx(
      nK,
      {
        ref: _,
        classes: {
          reactMde: `mark-down-editor-container dc__word-break ${// TODO (Eshank): The checks are broken here & the height as well
          n ? "" : "create-app-description"}`,
          toolbar: "mark-down-editor-toolbar tab-description",
          preview: "mark-down-editor-preview pt-8",
          textArea: `mark-down-editor-textarea-wrapper ${n ? "" : "h-200-imp"}`
        },
        getIcon: (E) => D(E),
        toolbarCommands: Qvt,
        value: h,
        onChange: f,
        minEditorHeight: a,
        minPreviewHeight: 150,
        selectedTab: g,
        onTabChange: p,
        generateMarkdownPreview: (E) => Promise.resolve(
          /* @__PURE__ */ v.jsx(Lle, { markdown: E || Zvt, breaks: !0 })
        ),
        childProps: {
          writeButton: {
            className: `tab-list__tab pointer fs-13 ${g === j1.WRITE && "cb-5 fw-6 active active-tab"}`
          },
          previewButton: {
            className: `tab-list__tab pointer fs-13 ${g === j1.PREVIEW && "cb-5 fw-6 active active-tab"}`
          },
          textArea: {
            tabIndex: r
          }
        }
      }
    ),
    g === j1.WRITE && /* @__PURE__ */ v.jsx("div", { className: "form cluster__description-footer pt-12 pb-12", children: /* @__PURE__ */ v.jsxs("div", { className: "form__buttons pl-16 pr-16", children: [
      /* @__PURE__ */ v.jsx(
        "button",
        {
          "data-testid": "description-edit-cancel-button",
          className: "cta cancel flex h-36 mr-12",
          type: "button",
          onClick: S,
          disabled: l,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ v.jsx(
        RA,
        {
          isLoading: l,
          disabled: l,
          "data-testid": "description-edit-save-button",
          rootClassName: "cta flex h-36",
          type: "submit",
          onClick: x,
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}, Kxt = d_t, u_t = {
  color: "#B1B7BC",
  label: "-",
  value: 0
}, h_t = ({
  entities: i = [u_t],
  rootClassName: e,
  countClassName: t,
  labelClassName: n
}) => {
  const r = i.reduce((a, l) => l.value + a, 0), s = i.filter((a) => a.value), o = (a) => `${a.value / r * 100}%`;
  return /* @__PURE__ */ v.jsxs("div", { className: `flexbox-col w-100 dc__gap-12 ${e}`, children: [
    /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__gap-16", children: i?.map((a) => /* @__PURE__ */ v.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: [
      /* @__PURE__ */ v.jsx("div", { className: "dot", style: { backgroundColor: a.color, width: "10px", height: "10px" } }),
      /* @__PURE__ */ v.jsx("span", { className: t, "data-testid": `segmented-bar-chart-${a.label}-value`, children: a.value }),
      /* @__PURE__ */ v.jsx("span", { className: n, "data-testid": `segmented-bar-chart-${a.label}-label`, children: a.label })
    ] })) }),
    /* @__PURE__ */ v.jsx("div", { className: "flexbox dc__gap-2", children: s?.map((a, l, c) => /* @__PURE__ */ v.jsx(
      "div",
      {
        className: `h-8 ${l === 0 ? "dc__left-radius-4" : ""} ${l === c.length - 1 ? "dc__right-radius-4" : ""}`,
        style: { backgroundColor: a.color, width: o(a) }
      },
      a.label
    )) })
  ] });
}, Yxt = h_t, Df = {
  NOT_DEPLOYED: {
    noSpaceLower: "notdeployed",
    normalCase: "Not deployed",
    lowerCase: "not-deployed"
  },
  NOT_READY: {
    noSpaceLower: "notready",
    normalCase: "Not Ready",
    lowerCase: "not-ready"
  },
  APP_STATUS: {
    noSpaceLower: "appStatus",
    normalText: "App status"
  },
  PROJECT: {
    pluralLower: "projects",
    lowerCase: "project"
  },
  CLUSTER: {
    pluralLower: "clusters",
    lowerCase: "cluster"
  },
  NAMESPACE: {
    pluralLower: "namespaces",
    lowerCase: "namespace"
  },
  ENVIRONMENT: {
    pluralLower: "environments",
    lowerCase: "environment"
  },
  NOT_AVILABLE: {
    normalCase: "Not available"
  }
}, f_t = "Yet to run", g_t = (i) => {
  const e = i?.toUpperCase();
  return e === Ot.ABORTED || e === Ot.DEGRADED ? "Failed" : e === Ot.HEALTHY ? "Succeeded" : e === Ot.INPROGRESS ? "Inprogress" : i;
};
function Xxt({
  appStatus: i,
  isDeploymentStatus: e = !1,
  isJobView: t = !1,
  isVirtualEnv: n,
  hideStatusMessage: r = !1
}) {
  let s = i;
  e && (s = g_t(i));
  const o = s?.toLowerCase(), a = o === Df.NOT_DEPLOYED.noSpaceLower, l = i === Df.NOT_READY.normalCase, c = s || (n ? Df.NOT_AVILABLE.normalCase : "-"), d = t ? f_t : Df.NOT_DEPLOYED.normalCase, u = a ? d : c, f = a ? Df.NOT_DEPLOYED.lowerCase : l ? Df.NOT_READY.lowerCase : o, g = () => f ? /* @__PURE__ */ v.jsx("span", { className: `dc__app-summary__icon icon-dim-16 ${f} ${f}--node` }) : n ? /* @__PURE__ */ v.jsx(
    "span",
    {
      className: `dc__app-summary__icon icon-dim-16 ${Df.NOT_DEPLOYED.lowerCase} ${Df.NOT_DEPLOYED.lowerCase}--node`
    }
  ) : /* @__PURE__ */ v.jsx(
    wn,
    {
      className: "default-tt w-200",
      arrow: !1,
      placement: "top",
      content: "To fetch app status for GitOps based deployments open the app detail page",
      children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: /* @__PURE__ */ v.jsx(VA, { className: "icon-dim-16 fcn-6" }) })
    }
  );
  return r ? f || n ? /* @__PURE__ */ v.jsx(wn, { className: "default-tt", arrow: !1, placement: "top", content: u, children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: g() }) }) : g() : /* @__PURE__ */ v.jsxs("div", { className: "flex left", children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex mr-6", children: g() }),
    /* @__PURE__ */ v.jsx("p", { "data-testid": `${s}-app-status`, className: "dc__truncate-text dc__first-letter-capitalize cn-6 m-0", children: u })
  ] });
}
export {
  tye as $,
  P_t as A,
  gCe as B,
  J_ as C,
  Nxt as D,
  I1t as E,
  YCe as F,
  oa as G,
  CE as H,
  q1t as I,
  O_t as J,
  ah as K,
  M_t as L,
  Bm as M,
  ZCe as N,
  QCe as O,
  tc as P,
  R_t as Q,
  sA as R,
  xxt as S,
  bCe as T,
  sr as U,
  Xi as V,
  s8 as W,
  JCe as X,
  $Ce as Y,
  eye as Z,
  F_t as _,
  k1t as a,
  nA as a$,
  nye as a0,
  B_t as a1,
  bx as a2,
  V_t as a3,
  o8 as a4,
  iS as a5,
  Ple as a6,
  rK as a7,
  a8,
  l8 as a9,
  fA as aA,
  uye as aB,
  j_t as aC,
  Qn as aD,
  Fle as aE,
  Ble as aF,
  SE as aG,
  Yle as aH,
  z_t as aI,
  U_t as aJ,
  Tye as aK,
  Is as aL,
  lc as aM,
  p1t as aN,
  Cr as aO,
  ixt as aP,
  Yq as aQ,
  vx as aR,
  rxt as aS,
  sxt as aT,
  El as aU,
  oCe as aV,
  aCe as aW,
  m1t as aX,
  gle as aY,
  oxt as aZ,
  axt as a_,
  Ole as aa,
  Mle as ab,
  H_t as ac,
  id as ad,
  W_t as ae,
  wE as af,
  iye as ag,
  Kc as ah,
  uA as ai,
  Aa as aj,
  Vl as ak,
  B2 as al,
  c8 as am,
  hA as an,
  fC as ao,
  rye as ap,
  sye as aq,
  d8 as ar,
  oye as as,
  Rle as at,
  bv as au,
  aye as av,
  g3 as aw,
  u8 as ax,
  ty as ay,
  h8 as az,
  Sxt as b,
  ike as b$,
  lxt as b0,
  cxt as b1,
  ple as b2,
  mle as b3,
  b1t as b4,
  tf as b5,
  dxt as b6,
  vl as b7,
  uxt as b8,
  vle as b9,
  zve as bA,
  yk as bB,
  N1t as bC,
  Yde as bD,
  B1t as bE,
  V1t as bF,
  Ixt as bG,
  Cle as bH,
  mCe as bI,
  ko as bJ,
  Txt as bK,
  eS as bL,
  Axt as bM,
  kxt as bN,
  hue as bO,
  Tbt as bP,
  Nbt as bQ,
  Pbt as bR,
  C5e as bS,
  Obt as bT,
  Mbt as bU,
  fue as bV,
  Rbt as bW,
  Z5e as bX,
  Ag as bY,
  J5e as bZ,
  $5e as b_,
  _le as ba,
  ble as bb,
  hxt as bc,
  fxt as bd,
  cCe as be,
  gxt as bf,
  pxt as bg,
  mxt as bh,
  vxt as bi,
  C1t as bj,
  _xt as bk,
  bxt as bl,
  iA as bm,
  y1t as bn,
  rA as bo,
  w1t as bp,
  dCe as bq,
  Cxt as br,
  x1t as bs,
  uCe as bt,
  hCe as bu,
  yxt as bv,
  wxt as bw,
  Yr as bx,
  SSt as by,
  T1t as bz,
  Ext as c,
  Ix as c$,
  rke as c0,
  Vbt as c1,
  FE as c2,
  wm as c3,
  oke as c4,
  Hbt as c5,
  Wbt as c6,
  jbt as c7,
  zbt as c8,
  Ubt as c9,
  Fxt as cA,
  Rxt as cB,
  Hxt as cC,
  jxt as cD,
  zxt as cE,
  Ck as cF,
  Uxt as cG,
  Gxt as cH,
  wCe as cI,
  qxt as cJ,
  Lle as cK,
  Kxt as cL,
  j1 as cM,
  Yxt as cN,
  e_e as cO,
  _v as cP,
  Aat as cQ,
  Xxt as cR,
  g_t as cS,
  mx as cT,
  ebt as cU,
  tbt as cV,
  ibt as cW,
  QIe as cX,
  JIe as cY,
  $Ie as cZ,
  eAe as c_,
  MY as ca,
  cb,
  _Ce as cc,
  yle as cd,
  evt as ce,
  tvt as cf,
  nvt as cg,
  ivt as ch,
  rvt as ci,
  svt as cj,
  ovt as ck,
  avt as cl,
  lvt as cm,
  cvt as cn,
  CCe as co,
  AW as cp,
  Pxt as cq,
  Vve as cr,
  pat as cs,
  Hve as ct,
  _at as cu,
  ySt as cv,
  wSt as cw,
  jve as cx,
  Vxt as cy,
  Bxt as cz,
  Lxt as d,
  vbt as d$,
  nbt as d0,
  nAe as d1,
  at as d2,
  Wm as d3,
  S3 as d4,
  Mp as d5,
  J_t as d6,
  Ude as d7,
  o_ as d8,
  Ss as d9,
  Rde as dA,
  ULe as dB,
  Fde as dC,
  GLe as dD,
  qLe as dE,
  YK as dF,
  K_t as dG,
  QLe as dH,
  q_t as dI,
  so as dJ,
  Bde as dK,
  YLe as dL,
  Vk as dM,
  Kb as dN,
  XLe as dO,
  ZLe as dP,
  XK as dQ,
  Q_t as dR,
  vIe as dS,
  pbt as dT,
  mbt as dU,
  JK as dV,
  HAe as dW,
  MAe as dX,
  RAe as dY,
  FAe as dZ,
  UAe as d_,
  $_t as da,
  eY as db,
  K8 as dc,
  UIe as dd,
  GIe as de,
  qIe as df,
  KIe as dg,
  tY as dh,
  iY as di,
  cAe as dj,
  dAe as dk,
  uAe as dl,
  rbt as dm,
  sbt as dn,
  mAe as dp,
  obt as dq,
  abt as dr,
  V2 as ds,
  CAe as dt,
  yAe as du,
  wAe as dv,
  rde as dw,
  Ode as dx,
  Mde as dy,
  G_t as dz,
  X1t as e,
  r6e as e$,
  ob as e0,
  _bt as e1,
  bC as e2,
  OA as e3,
  bbt as e4,
  y4e as e5,
  Dbt as e6,
  b4e as e7,
  RA as e8,
  Ebt as e9,
  Oke as eA,
  Due as eB,
  BY as eC,
  Mke as eD,
  Rke as eE,
  Fke as eF,
  my as eG,
  Bke as eH,
  qbt as eI,
  Kbt as eJ,
  xSt as eK,
  ilt as eL,
  rlt as eM,
  W5e as eN,
  j5e as eO,
  EY as eP,
  LY as eQ,
  z5e as eR,
  U5e as eS,
  ult as eT,
  Gke as eU,
  Kat as eV,
  Xat as eW,
  t_e as eX,
  _ue as eY,
  Jke as eZ,
  n_e as e_,
  Lbt as ea,
  Ibt as eb,
  tue as ec,
  Abt as ed,
  N4e as ee,
  Fbt as ef,
  yue as eg,
  DSt as eh,
  Kke as ei,
  o6e as ej,
  e6e as ek,
  l6e as el,
  ir as em,
  Yf as en,
  A5e as eo,
  k5e as ep,
  no as eq,
  xY as er,
  xv as es,
  T5e as et,
  N5e as eu,
  Ake as ev,
  kke as ew,
  Tke as ex,
  Nke as ey,
  Pke as ez,
  $1t as f,
  Y0t as f$,
  n6e as f0,
  LSt as f1,
  TSt as f2,
  ASt as f3,
  kSt as f4,
  Eq as f5,
  sht as f6,
  gE as f7,
  aht as f8,
  lht as f9,
  MSt as fA,
  ift as fB,
  rft as fC,
  VSt as fD,
  $2e as fE,
  HSt as fF,
  Qae as fG,
  Kq as fH,
  wue as fI,
  P0t as fJ,
  WSt as fK,
  rle as fL,
  H0t as fM,
  jSt as fN,
  zSt as fO,
  gue as fP,
  USt as fQ,
  QSt as fR,
  eCe as fS,
  JSt as fT,
  $St as fU,
  iCe as fV,
  rCe as fW,
  DW as fX,
  Mo as fY,
  GSt as fZ,
  K0t as f_,
  cht as fa,
  ISt as fb,
  $be as fc,
  qbe as fd,
  hut as fe,
  fut as ff,
  gut as fg,
  WI as fh,
  ESt as fi,
  RY as fj,
  Sue as fk,
  PSt as fl,
  Jht as fm,
  OSt as fn,
  BSt as fo,
  pft as fp,
  fft as fq,
  r2e as fr,
  RSt as fs,
  o2e as ft,
  cft as fu,
  FSt as fv,
  s2e as fw,
  oft as fx,
  aft as fy,
  lft as fz,
  $C as g,
  Ex as g$,
  X0t as g0,
  dle as g1,
  Z0t as g2,
  J0t as g3,
  qSt as g4,
  $0t as g5,
  KSt as g6,
  YSt as g7,
  XSt as g8,
  ZSt as g9,
  En as gA,
  z8 as gB,
  iIe as gC,
  fy as gD,
  rIe as gE,
  sIe as gF,
  oIe as gG,
  aIe as gH,
  Hde as gI,
  Io as gJ,
  vj as gK,
  lIe as gL,
  U8 as gM,
  wc as gN,
  cIe as gO,
  dIe as gP,
  y3 as gQ,
  uIe as gR,
  hIe as gS,
  Cj as gT,
  Cbt as gU,
  Qde as gV,
  ybt as gW,
  wbt as gX,
  $de as gY,
  Sbt as gZ,
  xbt as g_,
  SAe as ga,
  lbt as gb,
  a_ as gc,
  cbt as gd,
  dbt as ge,
  Qs as gf,
  qde as gg,
  DAe as gh,
  ubt as gi,
  Y8 as gj,
  EAe as gk,
  LAe as gl,
  hbt as gm,
  fbt as gn,
  gbt as go,
  rY as gp,
  IAe as gq,
  sY as gr,
  oY as gs,
  kAe as gt,
  TAe as gu,
  _j as gv,
  NAe as gw,
  PAe as gx,
  OAe as gy,
  nIe as gz,
  Oxt as h,
  _Ie as h0,
  bIe as h1,
  ZK as h2,
  CIe as h3,
  Y_t as h4,
  Wde as h5,
  gy as h6,
  yIe as h7,
  wIe as h8,
  w3 as h9,
  Xht as hA,
  NSt as hB,
  ext as hC,
  txt as hD,
  wj as hE,
  Yke as hF,
  Xke as hG,
  Zke as hH,
  Qke as hI,
  Sj as hJ,
  Bbt as hK,
  Gbt as hL,
  pke as hM,
  nxt as hN,
  SIe as ha,
  G8 as hb,
  Ot as hc,
  jr as hd,
  Xo as he,
  Lx as hf,
  ei as hg,
  xIe as hh,
  q8 as hi,
  DIe as hj,
  EIe as hk,
  LIe as hl,
  Hk as hm,
  IIe as hn,
  QK as ho,
  Mi as hp,
  jde as hq,
  AIe as hr,
  X_t as hs,
  Z_t as ht,
  V0t as hu,
  gu as hv,
  xW as hw,
  uC as hx,
  fh as hy,
  Yht as hz,
  Mxt as i,
  $D as j,
  Wxt as k,
  F2 as l,
  Qo as m,
  _x as n,
  TW as o,
  ey as p,
  yE as q,
  hn as r,
  XCe as s,
  i0e as t,
  Dxt as u,
  ms as v,
  iK as w,
  Jr as x,
  T_t as y,
  N_t as z
};
